import require$$2$3, { jsxs, jsx as jsx$1, Fragment as Fragment$1 } from 'react/jsx-runtime';
import * as React$d from 'react';
import React__default, { useContext, forwardRef, createElement, createContext as createContext$1, Fragment, useRef, useLayoutEffect, Children, isValidElement, cloneElement, useState, useEffect, useMemo as useMemo$1, useReducer, useCallback as useCallback$1, useImperativeHandle, memo, Component } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal, unstable_batchedUpdates } from 'react-dom';
import require$$0$6 from 'tty';
import require$$2$4 from 'path';
import require$$1$5 from 'url';
import require$$1$4 from 'fs';
import require$$1$6 from 'http';
import require$$2$5 from 'https';
import require$$3$1 from 'stream';
import require$$4$1 from 'assert';
import require$$8 from 'zlib';
import require$$1$7 from 'util';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$3 = function() {
    __assign$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends$P() {
  _extends$P = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$P.apply(this, arguments);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var reactIs$3 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2=60103,c$3=60106,d$3=60107,e$2=60108,f$3=60114,g$2=60109,h$2=60110,k$3=60112,l$2=60113,m$2=60120,n$2=60115,p$2=60116,q$3=60121,r$2=60122,u=60117,v$2=60129,w$3=60131;
if("function"===typeof Symbol&&Symbol.for){var x$2=Symbol.for;b$2=x$2("react.element");c$3=x$2("react.portal");d$3=x$2("react.fragment");e$2=x$2("react.strict_mode");f$3=x$2("react.profiler");g$2=x$2("react.provider");h$2=x$2("react.context");k$3=x$2("react.forward_ref");l$2=x$2("react.suspense");m$2=x$2("react.suspense_list");n$2=x$2("react.memo");p$2=x$2("react.lazy");q$3=x$2("react.block");r$2=x$2("react.server.block");u=x$2("react.fundamental");v$2=x$2("react.debug_trace_mode");w$3=x$2("react.legacy_hidden");}
function y$2(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$2:switch(a=a.type,a){case d$3:case f$3:case e$2:case l$2:case m$2:return a;default:switch(a=a&&a.$$typeof,a){case h$2:case k$3:case p$2:case n$2:case g$2:return a;default:return t}}case c$3:return t}}}var z$3=g$2,A$3=b$2,B$1=k$3,C$1=d$3,D$1=p$2,E$1=n$2,F$1=c$3,G$1=f$3,H$1=e$2,I$1=l$2;reactIs_production_min$2.ContextConsumer=h$2;reactIs_production_min$2.ContextProvider=z$3;reactIs_production_min$2.Element=A$3;reactIs_production_min$2.ForwardRef=B$1;reactIs_production_min$2.Fragment=C$1;reactIs_production_min$2.Lazy=D$1;reactIs_production_min$2.Memo=E$1;reactIs_production_min$2.Portal=F$1;reactIs_production_min$2.Profiler=G$1;reactIs_production_min$2.StrictMode=H$1;
reactIs_production_min$2.Suspense=I$1;reactIs_production_min$2.isAsyncMode=function(){return !1};reactIs_production_min$2.isConcurrentMode=function(){return !1};reactIs_production_min$2.isContextConsumer=function(a){return y$2(a)===h$2};reactIs_production_min$2.isContextProvider=function(a){return y$2(a)===g$2};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$2};reactIs_production_min$2.isForwardRef=function(a){return y$2(a)===k$3};reactIs_production_min$2.isFragment=function(a){return y$2(a)===d$3};reactIs_production_min$2.isLazy=function(a){return y$2(a)===p$2};reactIs_production_min$2.isMemo=function(a){return y$2(a)===n$2};
reactIs_production_min$2.isPortal=function(a){return y$2(a)===c$3};reactIs_production_min$2.isProfiler=function(a){return y$2(a)===f$3};reactIs_production_min$2.isStrictMode=function(a){return y$2(a)===e$2};reactIs_production_min$2.isSuspense=function(a){return y$2(a)===l$2};reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$3||a===f$3||a===v$2||a===e$2||a===l$2||a===m$2||a===w$3||"object"===typeof a&&null!==a&&(a.$$typeof===p$2||a.$$typeof===n$2||a.$$typeof===g$2||a.$$typeof===h$2||a.$$typeof===k$3||a.$$typeof===u||a.$$typeof===q$3||a[0]===r$2)?!0:!1};
reactIs_production_min$2.typeOf=y$2;

var reactIs_development$2 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$2.ContextConsumer = ContextConsumer;
reactIs_development$2.ContextProvider = ContextProvider;
reactIs_development$2.Element = Element;
reactIs_development$2.ForwardRef = ForwardRef;
reactIs_development$2.Fragment = Fragment;
reactIs_development$2.Lazy = Lazy;
reactIs_development$2.Memo = Memo;
reactIs_development$2.Portal = Portal;
reactIs_development$2.Profiler = Profiler;
reactIs_development$2.StrictMode = StrictMode;
reactIs_development$2.Suspense = Suspense;
reactIs_development$2.isAsyncMode = isAsyncMode;
reactIs_development$2.isConcurrentMode = isConcurrentMode;
reactIs_development$2.isContextConsumer = isContextConsumer;
reactIs_development$2.isContextProvider = isContextProvider;
reactIs_development$2.isElement = isElement;
reactIs_development$2.isForwardRef = isForwardRef;
reactIs_development$2.isFragment = isFragment;
reactIs_development$2.isLazy = isLazy;
reactIs_development$2.isMemo = isMemo;
reactIs_development$2.isPortal = isPortal;
reactIs_development$2.isProfiler = isProfiler;
reactIs_development$2.isStrictMode = isStrictMode;
reactIs_development$2.isSuspense = isSuspense;
reactIs_development$2.isValidElementType = isValidElementType;
reactIs_development$2.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$3.exports = reactIs_production_min$2;
} else {
  reactIs$3.exports = reactIs_development$2;
}

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$2=b$1?Symbol.for("react.element"):60103,d$2=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$2=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$2=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$2=b$1?
Symbol.for("react.suspense_list"):60120,r$1=b$1?Symbol.for("react.memo"):60115,t$1=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$2=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$1:case m$1:case e$1:case g$1:case f$2:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case n$1:case t$1:case r$1:case h$1:return a;default:return u}}case d$2:return u}}}function A$2(a){return z$2(a)===m$1}reactIs_production_min$1.AsyncMode=l$1;reactIs_production_min$1.ConcurrentMode=m$1;reactIs_production_min$1.ContextConsumer=k$2;reactIs_production_min$1.ContextProvider=h$1;reactIs_production_min$1.Element=c$2;reactIs_production_min$1.ForwardRef=n$1;reactIs_production_min$1.Fragment=e$1;reactIs_production_min$1.Lazy=t$1;reactIs_production_min$1.Memo=r$1;reactIs_production_min$1.Portal=d$2;
reactIs_production_min$1.Profiler=g$1;reactIs_production_min$1.StrictMode=f$2;reactIs_production_min$1.Suspense=p$1;reactIs_production_min$1.isAsyncMode=function(a){return A$2(a)||z$2(a)===l$1};reactIs_production_min$1.isConcurrentMode=A$2;reactIs_production_min$1.isContextConsumer=function(a){return z$2(a)===k$2};reactIs_production_min$1.isContextProvider=function(a){return z$2(a)===h$1};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};reactIs_production_min$1.isForwardRef=function(a){return z$2(a)===n$1};reactIs_production_min$1.isFragment=function(a){return z$2(a)===e$1};reactIs_production_min$1.isLazy=function(a){return z$2(a)===t$1};
reactIs_production_min$1.isMemo=function(a){return z$2(a)===r$1};reactIs_production_min$1.isPortal=function(a){return z$2(a)===d$2};reactIs_production_min$1.isProfiler=function(a){return z$2(a)===g$1};reactIs_production_min$1.isStrictMode=function(a){return z$2(a)===f$2};reactIs_production_min$1.isSuspense=function(a){return z$2(a)===p$1};
reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$2||a===p$1||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$1||a.$$typeof===h$1||a.$$typeof===k$2||a.$$typeof===n$1||a.$$typeof===w$2||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};reactIs_production_min$1.typeOf=z$2;

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.AsyncMode = AsyncMode;
reactIs_development$1.ConcurrentMode = ConcurrentMode;
reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$1;
} else {
  reactIs$2.exports = reactIs_development$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$3.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$4 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$3 = has$4;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$3(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$2.exports;
var assign$2 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has$2 = has$4;
var checkPropTypes = checkPropTypes_1;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$2(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$2({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$2(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction$3() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction$3;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction$3
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$2.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes$1 = propTypes.exports;

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }

  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}

function isPlainObject$6(item) {
  return item !== null && typeof item === 'object' && item.constructor === Object;
}
function deepmerge$2(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$P({}, target) : target;

  if (isPlainObject$6(target) && isPlainObject$6(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject$6(source[key]) && key in target && isPlainObject$6(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge$2(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  const element = props[propName];
  const safePropName = propFullName || propName;

  if (element == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }

  let warningHint;
  const elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent$1(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

const elementAcceptingRef = chainPropTypes(PropTypes$1.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes$1.element.isRequired, acceptingRef);
var elementAcceptingRef$1 = elementAcceptingRef;

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  const propValue = props[propName];
  const safePropName = propFullName || propName;

  if (propValue == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }

  let warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementTypeAcceptingRef$1 = chainPropTypes(PropTypes$1.elementType, elementTypeAcceptingRef);

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends$P({}, propTypes, {
    [specialProperty]: props => {
      const unsupportedProps = Object.keys(props).filter(prop => !propTypes.hasOwnProperty(prop));

      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map(prop => `\`${prop}\``).join(', ')}. Please remove them.`);
      }

      return null;
    }
  });
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;

  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}

function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  } // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`


  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIs$3.exports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs$3.exports.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  const propValue = props[propName];
  const safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
  }

  return null;
}

const refType = PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]);
var refType$1 = refType;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$3(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction$1(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }

    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce$5(func, wait = 166) {
  let timeout;

  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = () => {
    clearTimeout(timeout);
  };

  return debounced;
}

function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }

  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }

    return null;
  };
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/React$d.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError, Component) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  } // eslint-disable-next-line react/forbid-foreign-prop-types


  const prevPropTypes = Component ? _extends$P({}, Component.propTypes) : null;

  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];

    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);

      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }

    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }

    return null;
  };

  return requireProp;
}

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

const useEnhancedEffect$1 = typeof window !== 'undefined' ? React$d.useLayoutEffect : React$d.useEffect;
var useEnhancedEffect$2 = useEnhancedEffect$1;

let globalId = 0;

function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React$d.useState(idOverride);
  const id = idOverride || defaultId;
  React$d.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814


const maybeReactUseId = React$d['useId' + ''];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */

function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  } // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.


  return useGlobalId(idOverride);
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  const propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }

  return null;
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = React$d.useRef(controlled !== undefined);
  const [valueState, setValue] = React$d.useState(defaultProp);
  const value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== 'production') {
    React$d.useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error([`MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = React$d.useRef(defaultProp);
    React$d.useEffect(() => {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  const setValueIfUncontrolled = React$d.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */

function useEventCallback$1(fn) {
  const ref = React$d.useRef(fn);
  useEnhancedEffect$2(() => {
    ref.current = fn;
  });
  return React$d.useCallback((...args) => // @ts-expect-error hide `this`
  // tslint:disable-next-line:ban-comma-operator
  (0, ref.current)(...args), []);
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return React$d.useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }

    return refValue => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
let hadFocusVisibleRecentlyTimeout;
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */

function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  const {
    target
  } = event;

  try {
    return target.matches(':focus-visible');
  } catch (error) {// Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}

function useIsFocusVisible() {
  const ref = React$d.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React$d.useRef(false);
  /**
   * Should be called if a blur event is fired
   */

  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(() => {
        hadFocusVisibleRecently = false;
      }, 100);
      isFocusVisibleRef.current = false;
      return true;
    }

    return false;
  }
  /**
   * Should be called if a blur event is fired
   */


  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }

    return false;
  }

  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

// Source from https://github.com/alitaheri/normalize-scroll-left
let cachedType;
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */

function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }

  const dummy = document.createElement('div');
  const container = document.createElement('div');
  container.style.width = '10px';
  container.style.height = '1px';
  dummy.appendChild(container);
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';

  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;

    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }

  document.body.removeChild(dummy);
  return cachedType;
} // Based on https://stackoverflow.com/a/24394376

function getNormalizedScrollLeft(element, direction) {
  const scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior

  if (direction !== 'rtl') {
    return scrollLeft;
  }

  const type = detectScrollType();

  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;

    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;

    default:
      return scrollLeft;
  }
}

const usePreviousProps = value => {
  const ref = React$d.useRef({});
  React$d.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

var usePreviousProps$1 = usePreviousProps;

const visuallyHidden$1 = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};
var visuallyHidden$2 = visuallyHidden$1;

function getTypeByValue(value) {
  const valueType = typeof value;

  switch (valueType) {
    case 'number':
      if (Number.isNaN(value)) {
        return 'NaN';
      }

      if (!Number.isFinite(value)) {
        return 'Infinity';
      }

      if (value !== Math.floor(value)) {
        return 'float';
      }

      return 'number';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return value.constructor.name;

    default:
      return valueType;
  }
} // IE 11 support

function ponyfillIsInteger(x) {
  // eslint-disable-next-line no-restricted-globals
  return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}

const isInteger$1 = Number.isInteger || ponyfillIsInteger;

function requiredInteger(props, propName, componentName, location) {
  const propValue = props[propName];

  if (propValue == null || !isInteger$1(propValue)) {
    const propType = getTypeByValue(propValue);
    return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
  }

  return null;
}

function validator$2(props, propName, ...other) {
  const propValue = props[propName];

  if (propValue === undefined) {
    return null;
  }

  return requiredInteger(props, propName, ...other);
}

function validatorNoop() {
  return null;
}

validator$2.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
var integerPropType = process.env.NODE_ENV === 'production' ? validatorNoop : validator$2;

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = _extends$P({}, props);

  Object.keys(defaultProps).forEach(propName => {
    if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node, `ownerState` are not applied.
 * @param existingProps Props of the element.
 * @param ownerState
 */

function appendOwnerState(elementType, existingProps = {}, ownerState) {
  if (isHostComponent(elementType)) {
    return existingProps;
  }

  return _extends$P({}, existingProps, {
    ownerState: _extends$P({}, existingProps.ownerState, ownerState)
  });
}

function composeClasses(slots, getUtilityClass, classes) {
  const output = {};
  Object.keys(slots).forEach( // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }

        acc.push(getUtilityClass(key));
      }

      return acc;
    }, []).join(' ');
  });
  return output;
}

function useBadge(props) {
  const {
    badgeContent: badgeContentProp,
    invisible: invisibleProp = false,
    max: maxProp = 99,
    showZero = false
  } = props;
  const prevProps = usePreviousProps$1({
    badgeContent: badgeContentProp,
    max: maxProp
  });
  let invisible = invisibleProp;

  if (invisibleProp === false && badgeContentProp === 0 && !showZero) {
    invisible = true;
  }

  const {
    badgeContent,
    max = maxProp
  } = invisible ? prevProps : props;
  const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
  return {
    badgeContent,
    invisible,
    max,
    displayValue
  };
}

const defaultGenerator = componentName => componentName;

const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },

    generate(componentName) {
      return generate(componentName);
    },

    reset() {
      generate = defaultGenerator;
    }

  };
};

const ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator$1 = ClassNameGenerator;

const globalStateClassesMapping = {
  active: 'Mui-active',
  checked: 'Mui-checked',
  completed: 'Mui-completed',
  disabled: 'Mui-disabled',
  error: 'Mui-error',
  expanded: 'Mui-expanded',
  focused: 'Mui-focused',
  focusVisible: 'Mui-focusVisible',
  required: 'Mui-required',
  selected: 'Mui-selected'
};
function generateUtilityClass(componentName, slot) {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass || `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}

function generateUtilityClasses(componentName, slots) {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot);
  });
  return result;
}

function getBadgeUtilityClass$1(slot) {
  return generateUtilityClass('BaseBadge', slot);
}
generateUtilityClasses('BaseBadge', ['root', 'badge', 'invisible']);

const _excluded$1I = ["badgeContent", "component", "children", "className", "components", "componentsProps", "invisible", "max", "showZero"];

const useUtilityClasses$15 = ownerState => {
  const {
    invisible
  } = ownerState;
  const slots = {
    root: ['root'],
    badge: ['badge', invisible && 'invisible']
  };
  return composeClasses(slots, getBadgeUtilityClass$1, undefined);
};

const BadgeUnstyled = /*#__PURE__*/React$d.forwardRef(function BadgeUnstyled(props, ref) {
  const {
    component,
    children,
    className,
    components = {},
    componentsProps = {},
    max: maxProp = 99,
    showZero = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1I);

  const {
    badgeContent,
    max,
    displayValue,
    invisible
  } = useBadge(_extends$P({}, props, {
    max: maxProp
  }));

  const ownerState = _extends$P({}, props, {
    badgeContent,
    invisible,
    max,
    showZero
  });

  const classes = useUtilityClasses$15(ownerState);
  const Root = component || components.Root || 'span';
  const rootProps = appendOwnerState(Root, _extends$P({}, other, componentsProps.root), ownerState);
  const Badge = components.Badge || 'span';
  const badgeProps = appendOwnerState(Badge, componentsProps.badge, ownerState);
  return /*#__PURE__*/jsxs(Root, _extends$P({}, rootProps, {
    ref: ref
  }, other, {
    className: clsx(classes.root, rootProps.className, className),
    children: [children, /*#__PURE__*/jsx$1(Badge, _extends$P({}, badgeProps, {
      className: clsx(classes.badge, badgeProps.className),
      children: displayValue
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? BadgeUnstyled.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes$1.node,

  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes$1.node,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Badge: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    badge: PropTypes$1.object,
    root: PropTypes$1.object
  }),

  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: PropTypes$1.bool,

  /**
   * Max count to show.
   * @default 99
   */
  max: PropTypes$1.number,

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: PropTypes$1.bool
} : void 0;
var BadgeUnstyled$1 = BadgeUnstyled;

function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar$1(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click Away Listener](https://mui.com/base/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base/api/click-away-listener/)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = React$d.useRef(false);
  const nodeRef = React$d.useRef(null);
  const activatedRef = React$d.useRef(false);
  const syntheticEventRef = React$d.useRef(false);
  React$d.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = useForkRef( // @ts-expect-error TODO upstream fix
  children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  const handleClickAway = useEventCallback$1(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar$1(event, doc)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  React$d.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = ownerDocument(nodeRef.current);

      const handleTouchMove = () => {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  React$d.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/jsx$1(React$d.Fragment, {
    children: /*#__PURE__*/React$d.cloneElement(children, childrenProps)
  });
}

process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * The wrapped element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: PropTypes$1.bool,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: PropTypes$1.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes$1.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: PropTypes$1.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

var top$3 = 'top';
var bottom$3 = 'bottom';
var right$1 = 'right';
var left$1 = 'left';
var auto = 'auto';
var basePlacements = [top$3, bottom$3, right$1, left$1];
var start$2 = 'start';
var end$1 = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start$2, placement + "-" + end$1]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start$2, placement + "-" + end$1]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$a(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement$6(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$6(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$6(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement$1(placement) {
  return placement.split('-')[0];
}

var max$1 = Math.max;
var min$1 = Math.min;
var round$3 = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement$6(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round$3(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round$3(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$2(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement$1(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$a(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement$1(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$6(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$2(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement$6(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$2(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$6(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$2(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$1(min, min$1(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement$1(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left$1, right$1].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top$3 : left$1;
  var maxProp = axis === 'y' ? bottom$3 : right$1;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement$6(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$3(x * dpr) / dpr || 0,
    y: round$3(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left$1;
  var sideY = top$3;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement$1(popper);

      if (getComputedStyle$2(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top$3 || (placement === left$1 || placement === right$1) && variation === end$1) {
      sideY = bottom$3;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left$1 || (placement === top$3 || placement === bottom$3) && variation === end$1) {
      sideX = right$1;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$2(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement$1(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$2 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$2[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll$2(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement$1(element)).left + getWindowScroll$2(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement$1(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement$1(element);
  var winScroll = getWindowScroll$2(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$2(body || html).direction === 'rtl') {
    x += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$2(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$6(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement$a(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement$1(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$6(element) ? getOffsetParent(element) : element;

  if (!isElement$a(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$a(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement$1(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top$3:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom$3:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right$1:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left$1:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start$2:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end$1:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$a(element) ? element : element.contextElement || getDocumentElement$1(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right$1, bottom$3].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top$3, bottom$3].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement$1(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement$1(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement$1(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement$1(placement);

    var isStartVariation = getVariation(placement) === start$2;
    var isVertical = [top$3, bottom$3].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right$1 : left$1 : isStartVariation ? bottom$3 : top$3;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top$3, right$1, bottom$3, left$1].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement$1(placement);
  var invertDistance = [left$1, top$3].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left$1, right$1].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$2 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset$1
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement$1(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top$3 : left$1;
    var altSide = mainAxis === 'y' ? bottom$3 : right$1;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start$2 ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start$2 ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$1(min, tetherMin) : min, offset, tether ? max$1(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top$3 : left$1;

    var _altSide = mainAxis === 'x' ? bottom$3 : right$1;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top$3, left$1].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement$6(node)) {
    return getWindowScroll$2(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$3(rect.width) / element.offsetWidth || 1;
  var scaleY = round$3(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement$6(offsetParent);
  var offsetParentIsScaled = isHTMLElement$6(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement$1(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$6(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order$3(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order$3(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$4(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format$2(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format$2(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format$2(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$a(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement$1(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$2(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$4(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

function getContainer$1(container) {
  return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


const Portal = /*#__PURE__*/React$d.forwardRef(function Portal(props, ref) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = React$d.useState(null);
  const handleRef = useForkRef( /*#__PURE__*/React$d.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect$2(() => {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$2(() => {
    if (mountNode && !disablePortal) {
      setRef(ref, mountNode);
      return () => {
        setRef(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/React$d.isValidElement(children)) {
      return /*#__PURE__*/React$d.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode;
});
process.env.NODE_ENV !== "production" ? Portal.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes$1.node,

  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

var Portal$1 = Portal;

const _excluded$1H = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "ownerState", "placement", "popperOptions", "popperRef", "TransitionProps"],
      _excluded2$7 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"];

function flipPlacement(placement, direction) {
  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function resolveAnchorEl$1(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

const defaultPopperOptions = {};
/* eslint-disable react/prop-types */

const PopperTooltip = /*#__PURE__*/React$d.forwardRef(function PopperTooltip(props, ref) {
  const {
    anchorEl,
    children,
    direction,
    disablePortal,
    modifiers,
    open,
    placement: initialPlacement,
    popperOptions,
    popperRef: popperRefProp,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1H);

  const tooltipRef = React$d.useRef(null);
  const ownRef = useForkRef(tooltipRef, ref);
  const popperRef = React$d.useRef(null);
  const handlePopperRef = useForkRef(popperRef, popperRefProp);
  const handlePopperRefRef = React$d.useRef(handlePopperRef);
  useEnhancedEffect$2(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React$d.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  const [placement, setPlacement] = React$d.useState(rtlPlacement);
  React$d.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  useEnhancedEffect$2(() => {
    if (!anchorEl || !open) {
      return undefined;
    }

    const handlePopperUpdate = data => {
      setPlacement(data.placement);
    };

    const resolvedAnchorEl = resolveAnchorEl$1(anchorEl);

    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    let popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];

    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }

    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }

    const popper = createPopper(resolveAnchorEl$1(anchorEl), tooltipRef.current, _extends$P({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return () => {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [anchorEl, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement
  };

  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }

  return /*#__PURE__*/jsx$1("div", _extends$P({
    ref: ownRef,
    role: "tooltip"
  }, other, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});
/* eslint-enable react/prop-types */

/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */

const PopperUnstyled = /*#__PURE__*/React$d.forwardRef(function PopperUnstyled(props, ref) {
  const {
    anchorEl,
    children,
    container: containerProp,
    direction = 'ltr',
    disablePortal = false,
    keepMounted = false,
    modifiers,
    open,
    placement = 'bottom',
    popperOptions = defaultPopperOptions,
    popperRef,
    style,
    transition = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded2$7);

  const [exited, setExited] = React$d.useState(true);

  const handleEnter = () => {
    setExited(false);
  };

  const handleExited = () => {
    setExited(true);
  };

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  const container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl$1(anchorEl)).body : undefined);
  return /*#__PURE__*/jsx$1(Portal$1, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/jsx$1(PopperTooltip, _extends$P({
      anchorEl: anchorEl,
      direction: direction,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: ref,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef
    }, other, {
      style: _extends$P({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: 'fixed',
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: !open && keepMounted && (!transition || exited) ? 'none' : null
      }, style),
      TransitionProps: transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
      } : null,
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? PopperUnstyled.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.object, PropTypes$1.func]), props => {
    if (props.open) {
      const resolvedAnchorEl = resolveAnchorEl$1(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== 'function' || resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a virtualElement ', '(https://popper.js.org/docs/v2/virtual-elements/).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.node, PropTypes$1.func]),

  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes$1.oneOf(['ltr', 'rtl']),

  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes$1.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes$1.arrayOf(PropTypes$1.shape({
    data: PropTypes$1.object,
    effect: PropTypes$1.func,
    enabled: PropTypes$1.bool,
    fn: PropTypes$1.func,
    name: PropTypes$1.any,
    options: PropTypes$1.object,
    phase: PropTypes$1.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: PropTypes$1.arrayOf(PropTypes$1.string),
    requiresIfExists: PropTypes$1.arrayOf(PropTypes$1.string)
  })),

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes$1.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes$1.shape({
    modifiers: PropTypes$1.array,
    onFirstUpdate: PropTypes$1.func,
    placement: PropTypes$1.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: PropTypes$1.oneOf(['absolute', 'fixed'])
  }),

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes$1.bool
} : void 0;
var PopperUnstyled$1 = PopperUnstyled;

// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = ownerDocument(container);

  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(element) {
  return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
}

function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  const blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, element => {
    if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) {
      ariaHidden(element, show);
    }
  });
}

function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = getScrollbarSize(ownerDocument(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.

      const fixedElements = ownerDocument(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    const parent = container.parentElement;
    const containerWindow = ownerWindow(container);
    const scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}

/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }

  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);

    if (modalIndex !== -1) {
      return modalIndex;
    }

    modalIndex = this.modals.length;
    this.modals.push(modal); // If the modal we are adding is already in the DOM.

    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }

    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);

    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }

    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }

  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];

    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }

  remove(modal) {
    const modalIndex = this.modals.indexOf(modal);

    if (modalIndex === -1) {
      return modalIndex;
    }

    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }

      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, true);
      }

      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null

      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }

    return modalIndex;
  }

  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }

}

/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */
const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');

function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
}

function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }

  if (!node.name) {
    return false;
  }

  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);

  let roving = getRadio(`[name="${node.name}"]:checked`);

  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }

  return roving !== node;
}

function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }

  return true;
}

function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);

    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }

    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}

function defaultIsEnabled() {
  return true;
}
/**
 * Utility component that locks focus inside the component.
 */


function TrapFocus(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = React$d.useRef();
  const sentinelStart = React$d.useRef(null);
  const sentinelEnd = React$d.useRef(null);
  const nodeToRestore = React$d.useRef(null);
  const reactFocusEventTarget = React$d.useRef(null); // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.

  const activated = React$d.useRef(false);
  const rootRef = React$d.useRef(null);
  const handleRef = useForkRef(children.ref, rootRef);
  const lastKeydown = React$d.useRef(null);
  React$d.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  React$d.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = ownerDocument(rootRef.current);

    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(['MUI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      if (activated.current) {
        rootRef.current.focus();
      }
    }

    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open TrapFocus
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  React$d.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = ownerDocument(rootRef.current);

    const contain = nativeEvent => {
      const {
        current: rootElement
      } = rootRef; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (!rootElement.contains(doc.activeElement)) {
        // if the focus event is not coming from inside the children's react tree, reset the refs
        if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) {
          reactFocusEventTarget.current = null;
        } else if (reactFocusEventTarget.current !== null) {
          return;
        }

        if (!activated.current) {
          return;
        }

        let tabbable = [];

        if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
          tabbable = getTabbable(rootRef.current);
        }

        if (tabbable.length > 0) {
          var _lastKeydown$current, _lastKeydown$current2;

          const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
          const focusNext = tabbable[0];
          const focusPrevious = tabbable[tabbable.length - 1];

          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        } else {
          rootElement.focus();
        }
      }
    };

    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;

      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      } // Make sure the next tab starts from the right place.
      // doc.activeElement referes to the origin.


      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        sentinelEnd.current.focus();
      }
    };

    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    const interval = setInterval(() => {
      if (doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);

  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
  };

  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [/*#__PURE__*/jsx$1("div", {
      tabIndex: 0,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-test": "sentinelStart"
    }), /*#__PURE__*/React$d.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/jsx$1("div", {
      tabIndex: 0,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-test": "sentinelEnd"
    })]
  });
}

process.env.NODE_ENV !== "production" ? TrapFocus.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,

  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes$1.bool,

  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes$1.bool,

  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes$1.bool,

  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes$1.func,

  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple trap focus mounted at the same time.
   * @default function defaultIsEnabled() {
   *   return true;
   * }
   */
  isEnabled: PropTypes$1.func,

  /**
   * If `true`, focus is locked.
   */
  open: PropTypes$1.bool.isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  TrapFocus['propTypes' + ''] = exactProp(TrapFocus.propTypes);
}

function getModalUtilityClass(slot) {
  return generateUtilityClass('MuiModal', slot);
}
generateUtilityClasses('MuiModal', ['root', 'hidden']);

const _excluded$1G = ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "theme", "onTransitionEnter", "onTransitionExited"];

const useUtilityClasses$14 = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden']
  };
  return composeClasses(slots, getModalUtilityClass, classes);
};

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


const defaultManager = new ModalManager();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const ModalUnstyled = /*#__PURE__*/React$d.forwardRef(function ModalUnstyled(props, ref) {
  const {
    BackdropComponent,
    BackdropProps,
    children,
    classes: classesProp,
    className,
    closeAfterTransition = false,
    component = 'div',
    components = {},
    componentsProps = {},
    container,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    // private
    // eslint-disable-next-line react/prop-types
    manager = defaultManager,
    onBackdropClick,
    onClose,
    onKeyDown,
    open,

    /* eslint-disable react/prop-types */
    theme,
    onTransitionEnter,
    onTransitionExited
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1G);

  const [exited, setExited] = React$d.useState(true);
  const modal = React$d.useRef({});
  const mountNodeRef = React$d.useRef(null);
  const modalRef = React$d.useRef(null);
  const handleRef = useForkRef(modalRef, ref);
  const hasTransition = getHasTransition(props);

  const getDoc = () => ownerDocument(mountNodeRef.current);

  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  const handleOpen = useEventCallback$1(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = React$d.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = useEventCallback$1(node => {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  const handleClose = React$d.useCallback(() => {
    manager.remove(getModal());
  }, [manager]);
  React$d.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  React$d.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  const ownerState = _extends$P({}, props, {
    classes: classesProp,
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    exited,
    hideBackdrop,
    keepMounted
  });

  const classes = useUtilityClasses$14(ownerState);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  const handleEnter = () => {
    setExited(false);

    if (onTransitionEnter) {
      onTransitionEnter();
    }
  };

  const handleExited = () => {
    setExited(true);

    if (onTransitionExited) {
      onTransitionExited();
    }

    if (closeAfterTransition) {
      handleClose();
    }
  };

  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    } // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.


    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  const childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = createChainedFunction$1(handleEnter, children.props.onEnter);
    childProps.onExited = createChainedFunction$1(handleExited, children.props.onExited);
  }

  const Root = components.Root || component;
  const rootProps = componentsProps.root || {};
  return /*#__PURE__*/jsx$1(Portal$1, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/jsxs(Root, _extends$P({
      role: "presentation"
    }, rootProps, !isHostComponent(Root) && {
      as: component,
      ownerState: _extends$P({}, ownerState, rootProps.ownerState),
      theme
    }, other, {
      ref: handleRef,
      onKeyDown: handleKeyDown,
      className: clsx(classes.root, rootProps.className, className),
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/jsx$1(BackdropComponent, _extends$P({
        "aria-hidden": true,
        open: open,
        onClick: handleBackdropClick
      }, BackdropProps)) : null, /*#__PURE__*/jsx$1(TrapFocus, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/React$d.cloneElement(children, childProps)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? ModalUnstyled.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes$1.elementType,

  /**
   * Props applied to the backdrop element.
   */
  BackdropProps: PropTypes$1.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes$1.bool,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    root: PropTypes$1.object
  }),

  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes$1.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes$1.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes$1.bool,

  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes$1.bool,

  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes$1.bool,

  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes$1.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes$1.bool,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired
} : void 0;
var ModalUnstyled$1 = ModalUnstyled;

function getSliderUtilityClass(slot) {
  return generateUtilityClass('MuiSlider', slot);
}
const sliderUnstyledClasses = generateUtilityClasses('MuiSlider', ['root', 'active', 'focusVisible', 'disabled', 'dragging', 'marked', 'vertical', 'trackInverted', 'trackFalse', 'rail', 'track', 'mark', 'markActive', 'markLabel', 'markLabelActive', 'thumb', 'valueLabel', 'valueLabelOpen', 'valueLabelCircle', 'valueLabelLabel']);
var sliderUnstyledClasses$1 = sliderUnstyledClasses;

const useValueLabelClasses = props => {
  const {
    open
  } = props;
  const utilityClasses = {
    offset: clsx(open && sliderUnstyledClasses$1.valueLabelOpen),
    circle: sliderUnstyledClasses$1.valueLabelCircle,
    label: sliderUnstyledClasses$1.valueLabelLabel
  };
  return utilityClasses;
};
/**
 * @ignore - internal component.
 */


function SliderValueLabelUnstyled(props) {
  const {
    children,
    className,
    value,
    theme
  } = props;
  const classes = useValueLabelClasses(props);
  return /*#__PURE__*/React$d.cloneElement(children, {
    className: clsx(children.props.className)
  }, /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [children.props.children, /*#__PURE__*/jsx$1("span", {
      className: clsx(classes.offset, className),
      theme: theme,
      "aria-hidden": true,
      children: /*#__PURE__*/jsx$1("span", {
        className: classes.circle,
        children: /*#__PURE__*/jsx$1("span", {
          className: classes.label,
          children: value
        })
      })
    })]
  }));
}

process.env.NODE_ENV !== "production" ? SliderValueLabelUnstyled.propTypes = {
  children: PropTypes$1.element.isRequired,
  className: PropTypes$1.string,
  theme: PropTypes$1.any,
  value: PropTypes$1.node
} : void 0;

const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;

function asc(a, b) {
  return a - b;
}

function clamp$2(value, min, max) {
  if (value == null) {
    return min;
  }

  return Math.min(Math.max(min, value), max);
}

function findClosest(values, currentValue) {
  var _values$reduce;

  const {
    index: closestIndex
  } = (_values$reduce = values.reduce((acc, value, index) => {
    const distance = Math.abs(currentValue - value);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance,
        index
      };
    }

    return acc;
  }, null)) != null ? _values$reduce : {};
  return closestIndex;
}

function trackFinger(event, touchId) {
  // The event is TouchEvent
  if (touchId.current !== undefined && event.changedTouches) {
    const touchEvent = event;

    for (let i = 0; i < touchEvent.changedTouches.length; i += 1) {
      const touch = touchEvent.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  } // The event is MouseEvent


  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    const parts = num.toExponential().split('e-');
    const matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToStep(value, step, min) {
  const nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}

function setValueIndex({
  values,
  newValue,
  index
}) {
  const output = values.slice();
  output[index] = newValue;
  return output.sort(asc);
}

function focusThumb({
  sliderRef,
  activeIndex,
  setActive
}) {
  var _sliderRef$current, _doc$activeElement;

  const doc = ownerDocument(sliderRef.current);

  if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null ? void 0 : (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
    var _sliderRef$current2;

    (_sliderRef$current2 = sliderRef.current) == null ? void 0 : _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
  }

  if (setActive) {
    setActive(activeIndex);
  }
}

const axisProps = {
  horizontal: {
    offset: percent => ({
      left: `${percent}%`
    }),
    leap: percent => ({
      width: `${percent}%`
    })
  },
  'horizontal-reverse': {
    offset: percent => ({
      right: `${percent}%`
    }),
    leap: percent => ({
      width: `${percent}%`
    })
  },
  vertical: {
    offset: percent => ({
      bottom: `${percent}%`
    }),
    leap: percent => ({
      height: `${percent}%`
    })
  }
};
const Identity$1 = x => x; // TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported

let cachedSupportsTouchActionNone;

function doesSupportTouchActionNone() {
  if (cachedSupportsTouchActionNone === undefined) {
    if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
      cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
    } else {
      cachedSupportsTouchActionNone = true;
    }
  }

  return cachedSupportsTouchActionNone;
}

function useSlider(props) {
  const {
    ref,
    'aria-labelledby': ariaLabelledby,
    defaultValue,
    disableSwap = false,
    disabled = false,
    marks: marksProp = false,
    max = 100,
    min = 0,
    name,
    onChange,
    onChangeCommitted,
    orientation = 'horizontal',
    scale = Identity$1,
    step = 1,
    tabIndex,
    value: valueProp,
    isRtl = false
  } = props;
  const touchId = React$d.useRef(); // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transferred when inversing a range slider.

  const [active, setActive] = React$d.useState(-1);
  const [open, setOpen] = React$d.useState(-1);
  const [dragging, setDragging] = React$d.useState(false);
  const moveCount = React$d.useRef(0);
  const [valueDerived, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue != null ? defaultValue : min,
    name: 'Slider'
  });

  const handleChange = onChange && ((event, value, thumbIndex) => {
    // Redefine target to allow name and value to be read.
    // This allows seamless integration with the most popular form libraries.
    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
    // Clone the event to not override `target` of the original event.
    const nativeEvent = event.nativeEvent || event; // @ts-ignore The nativeEvent is function, not object

    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value,
        name
      }
    });
    onChange(clonedEvent, value, thumbIndex);
  });

  const range = Array.isArray(valueDerived);
  let values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(value => clamp$2(value, min, max));
  const marks = marksProp === true && step !== null ? [...Array(Math.floor((max - min) / step) + 1)].map((_, index) => ({
    value: min + step * index
  })) : marksProp || [];
  const marksValues = marks.map(mark => mark.value);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React$d.useState(-1);
  const sliderRef = React$d.useRef();
  const handleFocusRef = useForkRef(focusVisibleRef, sliderRef);
  const handleRef = useForkRef(ref, handleFocusRef);

  const createHandleHiddenInputFocus = otherHandlers => event => {
    var _otherHandlers$onFocu;

    const index = Number(event.currentTarget.getAttribute('data-index'));
    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(index);
    }

    setOpen(index);
    otherHandlers == null ? void 0 : (_otherHandlers$onFocu = otherHandlers.onFocus) == null ? void 0 : _otherHandlers$onFocu.call(otherHandlers, event);
  };

  const createHandleHiddenInputBlur = otherHandlers => event => {
    var _otherHandlers$onBlur;

    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(-1);
    }

    setOpen(-1);
    otherHandlers == null ? void 0 : (_otherHandlers$onBlur = otherHandlers.onBlur) == null ? void 0 : _otherHandlers$onBlur.call(otherHandlers, event);
  };

  useEnhancedEffect$2(() => {
    if (disabled && sliderRef.current.contains(document.activeElement)) {
      var _document$activeEleme;

      // This is necessary because Firefox and Safari will keep focus
      // on a disabled element:
      // https://codesandbox.io/s/mui-pr-22247-forked-h151h?file=/src/App.js
      // @ts-ignore
      (_document$activeEleme = document.activeElement) == null ? void 0 : _document$activeEleme.blur();
    }
  }, [disabled]);

  if (disabled && active !== -1) {
    setActive(-1);
  }

  if (disabled && focusVisible !== -1) {
    setFocusVisible(-1);
  }

  const createHandleHiddenInputChange = otherHandlers => event => {
    var _otherHandlers$onChan;

    (_otherHandlers$onChan = otherHandlers.onChange) == null ? void 0 : _otherHandlers$onChan.call(otherHandlers, event);
    const index = Number(event.currentTarget.getAttribute('data-index'));
    const value = values[index];
    const marksIndex = marksValues.indexOf(value); // @ts-ignore

    let newValue = event.target.valueAsNumber;

    if (marks && step == null) {
      newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
    }

    newValue = clamp$2(newValue, min, max);

    if (marks && step == null) {
      const currentMarkIndex = marksValues.indexOf(values[index]);
      newValue = newValue < values[index] ? marksValues[currentMarkIndex - 1] : marksValues[currentMarkIndex + 1];
    }

    if (range) {
      // Bound the new value to the thumb's neighbours.
      if (disableSwap) {
        newValue = clamp$2(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
      }

      const previousValue = newValue;
      newValue = setValueIndex({
        values,
        newValue,
        index
      });
      let activeIndex = index; // Potentially swap the index if needed.

      if (!disableSwap) {
        activeIndex = newValue.indexOf(previousValue);
      }

      focusThumb({
        sliderRef,
        activeIndex
      });
    }

    setValueState(newValue);
    setFocusVisible(index);

    if (handleChange) {
      handleChange(event, newValue, index);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  };

  const previousIndex = React$d.useRef();
  let axis = orientation;

  if (isRtl && orientation === 'horizontal') {
    axis += '-reverse';
  }

  const getFingerNewValue = ({
    finger,
    move = false,
    values: values2
  }) => {
    const {
      current: slider
    } = sliderRef;
    const {
      width,
      height,
      bottom,
      left
    } = slider.getBoundingClientRect();
    let percent;

    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }

    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }

    let newValue;
    newValue = percentToValue(percent, min, max);

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      const closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }

    newValue = clamp$2(newValue, min, max);
    let activeIndex = 0;

    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      } // Bound the new value to the thumb's neighbours.


      if (disableSwap) {
        newValue = clamp$2(newValue, values2[activeIndex - 1] || -Infinity, values2[activeIndex + 1] || Infinity);
      }

      const previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        newValue,
        index: activeIndex
      }); // Potentially swap the index if needed.

      if (!(disableSwap && move)) {
        activeIndex = newValue.indexOf(previousValue);
        previousIndex.current = activeIndex;
      }
    }

    return {
      newValue,
      activeIndex
    };
  };

  const handleTouchMove = useEventCallback$1(nativeEvent => {
    const finger = trackFinger(nativeEvent, touchId);

    if (!finger) {
      return;
    }

    moveCount.current += 1; // Cancel move in case some other element consumed a mouseup event and it was not fired.
    // @ts-ignore buttons doesn't not exists on touch event

    if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      handleTouchEnd(nativeEvent);
      return;
    }

    const {
      newValue,
      activeIndex
    } = getFingerNewValue({
      finger,
      move: true,
      values
    });
    focusThumb({
      sliderRef,
      activeIndex,
      setActive
    });
    setValueState(newValue);

    if (!dragging && moveCount.current > INTENTIONAL_DRAG_COUNT_THRESHOLD) {
      setDragging(true);
    }

    if (handleChange) {
      handleChange(nativeEvent, newValue, activeIndex);
    }
  });
  const handleTouchEnd = useEventCallback$1(nativeEvent => {
    const finger = trackFinger(nativeEvent, touchId);
    setDragging(false);

    if (!finger) {
      return;
    }

    const {
      newValue
    } = getFingerNewValue({
      finger,
      values
    });
    setActive(-1);

    if (nativeEvent.type === 'touchend') {
      setOpen(-1);
    }

    if (onChangeCommitted) {
      onChangeCommitted(nativeEvent, newValue);
    }

    touchId.current = undefined; // eslint-disable-next-line @typescript-eslint/no-use-before-define

    stopListening();
  });
  const handleTouchStart = useEventCallback$1(nativeEvent => {
    if (disabled) {
      return;
    } // If touch-action: none; is not supported we need to prevent the scroll manually.


    if (!doesSupportTouchActionNone()) {
      nativeEvent.preventDefault();
    }

    const touch = nativeEvent.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    const finger = trackFinger(nativeEvent, touchId);

    if (finger !== false) {
      const {
        newValue,
        activeIndex
      } = getFingerNewValue({
        finger,
        values
      });
      focusThumb({
        sliderRef,
        activeIndex,
        setActive
      });
      setValueState(newValue);

      if (handleChange) {
        handleChange(nativeEvent, newValue, activeIndex);
      }
    }

    moveCount.current = 0;
    const doc = ownerDocument(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove);
    doc.addEventListener('touchend', handleTouchEnd);
  });
  const stopListening = React$d.useCallback(() => {
    const doc = ownerDocument(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  }, [handleTouchEnd, handleTouchMove]);
  React$d.useEffect(() => {
    const {
      current: slider
    } = sliderRef;
    slider.addEventListener('touchstart', handleTouchStart, {
      passive: doesSupportTouchActionNone()
    });
    return () => {
      // @ts-ignore
      slider.removeEventListener('touchstart', handleTouchStart, {
        passive: doesSupportTouchActionNone()
      });
      stopListening();
    };
  }, [stopListening, handleTouchStart]);
  React$d.useEffect(() => {
    if (disabled) {
      stopListening();
    }
  }, [disabled, stopListening]);

  const createHandleMouseDown = otherHandlers => event => {
    var _otherHandlers$onMous;

    (_otherHandlers$onMous = otherHandlers.onMouseDown) == null ? void 0 : _otherHandlers$onMous.call(otherHandlers, event);

    if (disabled) {
      return;
    }

    if (event.defaultPrevented) {
      return;
    } // Only handle left clicks


    if (event.button !== 0) {
      return;
    } // Avoid text selection


    event.preventDefault();
    const finger = trackFinger(event, touchId);

    if (finger !== false) {
      const {
        newValue,
        activeIndex
      } = getFingerNewValue({
        finger,
        values
      });
      focusThumb({
        sliderRef,
        activeIndex,
        setActive
      });
      setValueState(newValue);

      if (handleChange) {
        handleChange(event, newValue, activeIndex);
      }
    }

    moveCount.current = 0;
    const doc = ownerDocument(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove);
    doc.addEventListener('mouseup', handleTouchEnd);
  };

  const trackOffset = valueToPercent(range ? values[0] : min, min, max);
  const trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;

  const getRootProps = otherHandlers => {
    const ownEventHandlers = {
      onMouseDown: createHandleMouseDown(otherHandlers || {})
    };

    const mergedEventHandlers = _extends$P({}, otherHandlers, ownEventHandlers);

    return _extends$P({
      ref: handleRef
    }, mergedEventHandlers);
  };

  const createHandleMouseOver = otherHandlers => event => {
    var _otherHandlers$onMous2;

    (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null ? void 0 : _otherHandlers$onMous2.call(otherHandlers, event);
    const index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  };

  const createHandleMouseLeave = otherHandlers => event => {
    var _otherHandlers$onMous3;

    (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null ? void 0 : _otherHandlers$onMous3.call(otherHandlers, event);
    setOpen(-1);
  };

  const getThumbProps = otherHandlers => {
    const ownEventHandlers = {
      onMouseOver: createHandleMouseOver(otherHandlers || {}),
      onMouseLeave: createHandleMouseLeave(otherHandlers || {})
    };

    const mergedEventHandlers = _extends$P({}, otherHandlers, ownEventHandlers);

    return _extends$P({}, mergedEventHandlers);
  };

  const getHiddenInputProps = otherHandlers => {
    const ownEventHandlers = {
      onChange: createHandleHiddenInputChange(otherHandlers || {}),
      onFocus: createHandleHiddenInputFocus(otherHandlers || {}),
      onBlur: createHandleHiddenInputBlur(otherHandlers || {})
    };

    const mergedEventHandlers = _extends$P({}, otherHandlers, ownEventHandlers);

    return _extends$P({
      tabIndex,
      'aria-labelledby': ariaLabelledby,
      'aria-orientation': orientation,
      'aria-valuemax': scale(max),
      'aria-valuemin': scale(min),
      name,
      type: 'range',
      min: props.min,
      max: props.max,
      step: props.step,
      disabled
    }, mergedEventHandlers, {
      style: _extends$P({}, visuallyHidden$2, {
        direction: isRtl ? 'rtl' : 'ltr',
        // So that VoiceOver's focus indicator matches the thumb's dimensions
        width: '100%',
        height: '100%'
      })
    });
  };

  return {
    axis,
    axisProps,
    getRootProps,
    getHiddenInputProps,
    getThumbProps,
    dragging,
    marks,
    values,
    active,
    focusVisible,
    open,
    range,
    trackOffset,
    trackLeap
  };
}

const _excluded$1F = ["aria-label", "aria-valuetext", "className", "component", "classes", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat", "isRtl", "components", "componentsProps"];

const Identity = x => x;

const useUtilityClasses$13 = ownerState => {
  const {
    disabled,
    dragging,
    marked,
    orientation,
    track,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', dragging && 'dragging', marked && 'marked', orientation === 'vertical' && 'vertical', track === 'inverted' && 'trackInverted', track === false && 'trackFalse'],
    rail: ['rail'],
    track: ['track'],
    mark: ['mark'],
    markActive: ['markActive'],
    markLabel: ['markLabel'],
    markLabelActive: ['markLabelActive'],
    valueLabel: ['valueLabel'],
    thumb: ['thumb', disabled && 'disabled'],
    active: ['active'],
    disabled: ['disabled'],
    focusVisible: ['focusVisible']
  };
  return composeClasses(slots, getSliderUtilityClass, classes);
};

const Forward = ({
  children
}) => children;

const SliderUnstyled = /*#__PURE__*/React$d.forwardRef(function SliderUnstyled(props, ref) {
  var _ref, _components$Rail, _components$Track, _components$Thumb, _components$ValueLabe, _components$Mark, _components$MarkLabel;

  const {
    'aria-label': ariaLabel,
    'aria-valuetext': ariaValuetext,
    className,
    component,
    classes: classesProp,
    disableSwap = false,
    disabled = false,
    getAriaLabel,
    getAriaValueText,
    marks: marksProp = false,
    max = 100,
    min = 0,
    onMouseDown,
    orientation = 'horizontal',
    scale = Identity,
    step = 1,
    track = 'normal',
    valueLabelDisplay = 'off',
    valueLabelFormat = Identity,
    isRtl = false,
    components = {},
    componentsProps = {}
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1F); // all props with defaults
  // consider extracting to hook an reusing the lint rule for the varints


  const ownerState = _extends$P({}, props, {
    mark: marksProp,
    classes: classesProp,
    disabled,
    isRtl,
    max,
    min,
    orientation,
    scale,
    step,
    track,
    valueLabelDisplay,
    valueLabelFormat
  });

  const {
    axisProps,
    getRootProps,
    getHiddenInputProps,
    getThumbProps,
    open,
    active,
    axis,
    range,
    focusVisible,
    dragging,
    marks,
    values,
    trackOffset,
    trackLeap
  } = useSlider(_extends$P({}, ownerState, {
    ref
  }));
  ownerState.marked = marks.length > 0 && marks.some(mark => mark.label);
  ownerState.dragging = dragging;
  const Root = (_ref = component != null ? component : components.Root) != null ? _ref : 'span';
  const rootProps = appendOwnerState(Root, _extends$P({}, other, componentsProps.root), ownerState);
  const Rail = (_components$Rail = components.Rail) != null ? _components$Rail : 'span';
  const railProps = appendOwnerState(Rail, componentsProps.rail, ownerState);
  const Track = (_components$Track = components.Track) != null ? _components$Track : 'span';
  const trackProps = appendOwnerState(Track, componentsProps.track, ownerState);

  const trackStyle = _extends$P({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));

  const Thumb = (_components$Thumb = components.Thumb) != null ? _components$Thumb : 'span';
  const thumbProps = appendOwnerState(Thumb, componentsProps.thumb, ownerState);
  const ValueLabel = (_components$ValueLabe = components.ValueLabel) != null ? _components$ValueLabe : SliderValueLabelUnstyled;
  const valueLabelProps = appendOwnerState(ValueLabel, componentsProps.valueLabel, ownerState);
  const Mark = (_components$Mark = components.Mark) != null ? _components$Mark : 'span';
  const markProps = appendOwnerState(Mark, componentsProps.mark, ownerState);
  const MarkLabel = (_components$MarkLabel = components.MarkLabel) != null ? _components$MarkLabel : 'span';
  const markLabelProps = appendOwnerState(MarkLabel, componentsProps.markLabel, ownerState);
  const Input = components.Input || 'input';
  const inputProps = appendOwnerState(Input, componentsProps.input, ownerState);
  const hiddenInputProps = getHiddenInputProps();
  const classes = useUtilityClasses$13(ownerState);
  return /*#__PURE__*/jsxs(Root, _extends$P({}, rootProps, getRootProps({
    onMouseDown
  }), {
    className: clsx(classes.root, rootProps.className, className),
    children: [/*#__PURE__*/jsx$1(Rail, _extends$P({}, railProps, {
      className: clsx(classes.rail, railProps.className)
    })), /*#__PURE__*/jsx$1(Track, _extends$P({}, trackProps, {
      className: clsx(classes.track, trackProps.className),
      style: _extends$P({}, trackStyle, trackProps.style)
    })), marks.map((mark, index) => {
      const percent = valueToPercent(mark.value, min, max);
      const style = axisProps[axis].offset(percent);
      let markActive;

      if (track === false) {
        markActive = values.indexOf(mark.value) !== -1;
      } else {
        markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
      }

      return /*#__PURE__*/jsxs(React$d.Fragment, {
        children: [/*#__PURE__*/jsx$1(Mark, _extends$P({
          "data-index": index
        }, markProps, !isHostComponent(Mark) && {
          markActive
        }, {
          style: _extends$P({}, style, markProps.style),
          className: clsx(classes.mark, markProps.className, markActive && classes.markActive)
        })), mark.label != null ? /*#__PURE__*/jsx$1(MarkLabel, _extends$P({
          "aria-hidden": true,
          "data-index": index
        }, markLabelProps, !isHostComponent(MarkLabel) && {
          markLabelActive: markActive
        }, {
          style: _extends$P({}, style, markLabelProps.style),
          className: clsx(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
          children: mark.label
        })) : null]
      }, mark.value);
    }), values.map((value, index) => {
      const percent = valueToPercent(value, min, max);
      const style = axisProps[axis].offset(percent);
      const ValueLabelComponent = valueLabelDisplay === 'off' ? Forward : ValueLabel;
      return /*#__PURE__*/jsx$1(React$d.Fragment, {
        children: /*#__PURE__*/jsx$1(ValueLabelComponent, _extends$P({}, !isHostComponent(ValueLabelComponent) && {
          valueLabelFormat,
          valueLabelDisplay,
          value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
          index,
          open: open === index || active === index || valueLabelDisplay === 'on',
          disabled
        }, valueLabelProps, {
          className: clsx(classes.valueLabel, valueLabelProps.className),
          children: /*#__PURE__*/jsx$1(Thumb, _extends$P({
            "data-index": index
          }, thumbProps, getThumbProps(), {
            className: clsx(classes.thumb, thumbProps.className, active === index && classes.active, focusVisible === index && classes.focusVisible)
          }, !isHostComponent(Thumb) && {
            ownerState: _extends$P({}, ownerState, thumbProps.ownerState)
          }, {
            style: _extends$P({}, style, {
              pointerEvents: disableSwap && active !== index ? 'none' : undefined
            }, thumbProps.style),
            children: /*#__PURE__*/jsx$1(Input, _extends$P({}, hiddenInputProps, {
              "data-index": index,
              "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
              "aria-valuenow": scale(value),
              "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
              value: values[index]
            }, !isHostComponent(Input) && {
              ownerState: _extends$P({}, ownerState, inputProps.ownerState)
            }, inputProps, {
              style: _extends$P({}, hiddenInputProps.style, inputProps.style)
            }))
          }))
        }))
      }, index);
    })]
  }));
});
process.env.NODE_ENV !== "production" ? SliderUnstyled.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes$1.string, props => {
    const range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes$1.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes$1.string, props => {
    const range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * @ignore
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Input: PropTypes$1.elementType,
    Mark: PropTypes$1.elementType,
    MarkLabel: PropTypes$1.elementType,
    Rail: PropTypes$1.elementType,
    Root: PropTypes$1.elementType,
    Thumb: PropTypes$1.elementType,
    Track: PropTypes$1.elementType,
    ValueLabel: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    input: PropTypes$1.object,
    mark: PropTypes$1.object,
    markLabel: PropTypes$1.object,
    rail: PropTypes$1.object,
    root: PropTypes$1.object,
    thumb: PropTypes$1.object,
    track: PropTypes$1.object,
    valueLabel: PropTypes$1.shape({
      className: PropTypes$1.string,
      components: PropTypes$1.shape({
        Root: PropTypes$1.elementType
      }),
      style: PropTypes$1.object,
      value: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number]),
      valueLabelDisplay: PropTypes$1.oneOf(['auto', 'off', 'on'])
    })
  }),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number]),

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: PropTypes$1.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes$1.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes$1.func,

  /**
   * Indicates whether the theme context has rtl direction. It is set automatically.
   * @default false
   */
  isRtl: PropTypes$1.bool,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.shape({
    label: PropTypes$1.node,
    value: PropTypes$1.number.isRequired
  })), PropTypes$1.bool]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: PropTypes$1.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: PropTypes$1.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: PropTypes$1.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes$1.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes$1.func,

  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical']),

  /**
   * A transformation function, to change the scale of the slider.
   * @default (x) => x
   */
  scale: PropTypes$1.func,

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: PropTypes$1.number,

  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: PropTypes$1.number,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: PropTypes$1.oneOf(['inverted', 'normal', false]),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number]),

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: PropTypes$1.oneOf(['auto', 'off', 'on']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @default (x) => x
   */
  valueLabelFormat: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.string])
} : void 0;
var SliderUnstyled$1 = SliderUnstyled;

const _excluded$1E = ["onChange", "maxRows", "minRows", "style", "value"];

function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

const styles$3 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
const TextareaAutosize = /*#__PURE__*/React$d.forwardRef(function TextareaAutosize(props, ref) {
  const {
    onChange,
    maxRows,
    minRows = 1,
    style,
    value
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1E);

  const {
    current: isControlled
  } = React$d.useRef(value != null);
  const inputRef = React$d.useRef(null);
  const handleRef = useForkRef(ref, inputRef);
  const shadowRef = React$d.useRef(null);
  const renders = React$d.useRef(0);
  const [state, setState] = React$d.useState({});
  const syncHeight = React$d.useCallback(() => {
    const input = inputRef.current;
    const containerWindow = ownerWindow(input);
    const computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.

    if (computedStyle.width === '0px') {
      return;
    }

    const inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    const boxSizing = computedStyle['box-sizing'];
    const padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    const border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    const innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    const singleRowHeight = inputShallow.scrollHeight; // The height of the outer content

    let outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    const overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(prevState => {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow,
          outerHeightStyle
        };
      }

      if (process.env.NODE_ENV !== 'production') {
        if (renders.current === 20) {
          console.error(['MUI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  React$d.useEffect(() => {
    const handleResize = debounce$5(() => {
      renders.current = 0;
      syncHeight();
    });
    const containerWindow = ownerWindow(inputRef.current);
    containerWindow.addEventListener('resize', handleResize);
    let resizeObserver;

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(inputRef.current);
    }

    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);

      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [syncHeight]);
  useEnhancedEffect$2(() => {
    syncHeight();
  });
  React$d.useEffect(() => {
    renders.current = 0;
  }, [value]);

  const handleChange = event => {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [/*#__PURE__*/jsx$1("textarea", _extends$P({
      value: value,
      onChange: handleChange,
      ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
      ,
      rows: minRows,
      style: _extends$P({
        height: state.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: state.overflow ? 'hidden' : null
      }, style)
    }, other)), /*#__PURE__*/jsx$1("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: shadowRef,
      tabIndex: -1,
      style: _extends$P({}, styles$3.shadow, style, {
        padding: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * @ignore
   */
  onChange: PropTypes$1.func,

  /**
   * @ignore
   */
  placeholder: PropTypes$1.string,

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * @ignore
   */
  value: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.string), PropTypes$1.number, PropTypes$1.string])
} : void 0;
var TextareaAutosize$1 = TextareaAutosize;

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$1 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match$3 (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$1 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr$3 (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen$2 (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append$1 (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine$1 (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position$2 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node$1 (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy$5 (root, props) {
	return assign$1(node$1('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position$2 > 0 ? charat(characters, --position$2) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position$2 < length ? charat(characters, position$2++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position$2)
}

/**
 * @return {number}
 */
function caret$2 () {
	return position$2
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr$3(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen$2(characters = value), position$2 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$1(slice(position$2 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace$1 (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret$2() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position$2
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position$2
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position$2 - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position$2)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$8('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$8 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace$1(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace$1(previous);
				break
			// \
			case 92:
				characters += escaping(caret$2() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append$1(comment$1(commenter(next(), caret$2()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen$2(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen$2(characters) - length))
							append$1(property > 32 ? declaration$1(characters + ';', rule, parent, length - 1) : declaration$1(replace$1(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append$1(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$8(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse$8(value, reference, reference, rule && append$1(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$8(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen$2(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen$2(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen$2(type = characters += identifier(caret$2())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen$2(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr$3(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace$1(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node$1(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment$1 (value, root, parent) {
	return node$1(value, root, parent, COMMENT, from(char()), substr$3(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration$1 (value, root, parent, length) {
	return node$1(value, root, parent, DECLARATION, substr$3(value, 0, length), substr$3(value, length + 1, -1), length)
}

/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix$3 (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace$1(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace$1(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace$1(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace$1(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace$1(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace$1(value, '-grow', '') + WEBKIT + value + MS + replace$1(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace$1(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace$1(replace$1(replace$1(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace$1(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace$1(replace$1(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace$1(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen$2(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace$1(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix$3(replace$1(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (charat(value, strlen$2(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace$1(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace$1(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify$6 (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen$2(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix$3(element.value, element.length);
					break
				case KEYFRAMES:
					return serialize([copy$5(element, {value: replace$1(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine$1(element.props, function (value) {
							switch (match$3(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy$5(element, {props: [replace$1(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy$5(element, {props: [replace$1(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy$5(element, {props: [replace$1(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy$5(element, {props: [replace$1(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position$2);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position$2 - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var isBrowser$6 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$6 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$6 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  if (isBrowser$6) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$6) {
    var currentSheet;
    var finalizingPlugins = [stringify$6, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify$6];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var emotionCache_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': createCache
});

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c$1=b?Symbol.for("react.element"):60103,d$1=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f$1=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k$1=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q$1=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w$1=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l:case m:case e:case g:case f$1:case p:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n:case t:case r:case h:return a;default:return u}}case d$1:return u}}}function A$1(a){return z$1(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c$1;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d$1;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f$1;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A$1(a)||z$1(a)===l};reactIs_production_min.isConcurrentMode=A$1;reactIs_production_min.isContextConsumer=function(a){return z$1(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z$1(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};reactIs_production_min.isForwardRef=function(a){return z$1(a)===n};reactIs_production_min.isFragment=function(a){return z$1(a)===e};reactIs_production_min.isLazy=function(a){return z$1(a)===t};
reactIs_production_min.isMemo=function(a){return z$1(a)===r};reactIs_production_min.isPortal=function(a){return z$1(a)===d$1};reactIs_production_min.isProfiler=function(a){return z$1(a)===g};reactIs_production_min.isStrictMode=function(a){return z$1(a)===f$1};reactIs_production_min.isSuspense=function(a){return z$1(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f$1||a===p||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k$1||a.$$typeof===n||a.$$typeof===w$1||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z$1;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics$2(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics$2(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics$2;

// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics = (function (targetComponent, sourceComponent) {
  return hoistNonReactStatics_cjs(targetComponent, sourceComponent);
});

var hoistNonReactStatics$1 = hoistNonReactStatics;

var isBrowser$5 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$5 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$5 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$5 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

var emotionUtils_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getRegisteredStyles: getRegisteredStyles,
    insertStyles: insertStyles,
    registerStyles: registerStyles
});

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var emotionSerialize_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    serializeStyles: serializeStyles
});

var isBrowser$4 = typeof document !== 'undefined';
var hasOwnProperty$2 = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext$1( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$4) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext$2 = /* #__PURE__ */createContext$1({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext$2.displayName = 'EmotionThemeContext';
}

var useTheme$4 = function useTheme() {
  return useContext(ThemeContext$2);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (process.env.NODE_ENV !== 'production' && (mergedTheme == null || typeof mergedTheme !== 'object' || Array.isArray(mergedTheme))) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (process.env.NODE_ENV !== 'production' && (theme == null || typeof theme !== 'object' || Array.isArray(theme))) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return _extends$P({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider$3 = function ThemeProvider(props) {
  var theme = useContext(ThemeContext$2);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(ThemeContext$2.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext$2);
    return /*#__PURE__*/createElement(Component, _extends$P({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics$1(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var isBrowser$1$2 = typeof document !== 'undefined';
var useInsertionEffect$2 = React$d['useInsertion' + 'Effect'] ? React$d['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe$1(create) {
  if (!isBrowser$1$2) {
    return create();
  }

  useInsertionEffect$2(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$2.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion$2 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe$1(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$4 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext$2));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$2.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion$2, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
	name: "@emotion/react",
	version: "11.9.0",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/babel-plugin": "^11.7.1",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.3",
		"@emotion/utils": "^1.1.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.9.0",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.8.1",
		"@types/react": "^16.9.11",
		dtslint: "^4.2.1",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty$2.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var useInsertionEffect$1 = React$d['useInsertion' + 'Effect'] ? React$d['useInsertion' + 'Effect'] : useLayoutEffect;
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext$2));

  if (!isBrowser$4) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffect$1(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffect$1(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge$4(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectMaybe$1(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser$4 && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser$4) {
      return rules;
    }
  });

  if (!isBrowser$4 && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge$4(cache.registered, css, classnames$1(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext$2)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion$1, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}

if (process.env.NODE_ENV !== 'production') {
  var isBrowser$3 = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';

  if (isBrowser$3 && !isJest) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser$3 ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

var emotionReact_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ClassNames: ClassNames,
    Global: Global,
    createElement: jsx,
    css: css,
    jsx: jsx,
    keyframes: keyframes,
    CacheProvider: CacheProvider,
    ThemeContext: ThemeContext$2,
    ThemeProvider: ThemeProvider$3,
    __unsafe_useEmotionCache: __unsafe_useEmotionCache,
    useTheme: useTheme$4,
    get withEmotionCache () { return withEmotionCache; },
    withTheme: withTheme
});

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var isBrowser$2 = typeof document !== 'undefined';
var useInsertionEffect = React$d['useInsertion' + 'Effect'] ? React$d['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {
  if (!isBrowser$2) {
    return create();
  }

  useInsertionEffect(create);
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$1$1 = typeof document !== 'undefined';

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$1$1 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var createStyled$1 = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = useContext(ThemeContext$2);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$P({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled$1.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

var emStyled = newStyled;

function isEmpty$3(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}

function GlobalStyles$3(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty$3(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/jsx$1(Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$3.propTypes = {
  defaultTheme: PropTypes$1.object,
  styles: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object, PropTypes$1.func])
} : void 0;

/** @license MUI v5.8.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(tag, options) {
  const stylesFactory = emStyled(tag, options);

  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';

      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }

      return stylesFactory(...styles);
    };
  }

  return stylesFactory;
}

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string, PropTypes$1.object, PropTypes$1.array]) : {};
var responsivePropType$1 = responsivePropType;

function merge$3(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge$2(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

// For instance with the first breakpoint xs: [xs, sm[.

const values$2 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen

};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values$2[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};

  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values$2).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }

      return acc;
    }, {});
  }

  const output = styleFromPropValue(propValue);
  return output;
}

function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;

  const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;

    if (isBreakpointUnused) {
      delete acc[key];
    }

    return acc;
  }, style);
}
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}

function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }

  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);

  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }

  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);

  if (keys.length === 0) {
    return breakpointValues;
  }

  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }

    return acc;
  }, {});
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  } // Check if CSS variables are used


  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);

    if (val != null) {
      return val;
    }
  }

  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }

    return null;
  }, obj);
}

function getValue$2(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;

  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }

  if (transform) {
    value = transform(value);
  }

  return value;
}

function style$2(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  const fn = props => {
    if (props[prop] == null) {
      return null;
    }

    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};

    const styleFromPropValue = propValueFinal => {
      let value = getValue$2(themeMapping, transform, propValueFinal);

      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getValue$2(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize$3(propValueFinal)}`, propValueFinal);
      }

      if (cssProperty === false) {
        return value;
      }

      return {
        [cssProperty]: value
      };
    };

    return handleBreakpoints(props, propValue, styleFromPropValue);
  };

  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType$1
  } : {};
  fn.filterProps = [prop];
  return fn;
}

function compose$1(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge$3(acc, handlers[prop](props));
      }

      return acc;
    }, {});
  };

  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;

  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;

  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }

  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue$1(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  const abs = Math.abs(propValue);
  const transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue$1(transformer, propValue);
    return acc;
  }, {});
}

function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }

  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}

function style$1(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge$3, {});
}
process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

function spacing(props) {
  return style$1(props, spacingKeys);
}

spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;

function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return `${value}px solid`;
}

const border = style$2({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
const borderTop = style$2({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
const borderRight = style$2({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
const borderBottom = style$2({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
const borderLeft = style$2({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
const borderColor = style$2({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = style$2({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = style$2({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = style$2({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = style$2({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');

    const styleFromPropValue = propValue => ({
      borderRadius: getValue$1(transformer, propValue)
    });

    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }

  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ['borderRadius'];
const borders = compose$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
var borders$1 = borders;

const displayPrint = style$2({
  prop: 'displayPrint',
  cssProperty: false,
  transform: value => ({
    '@media print': {
      display: value
    }
  })
});
const displayRaw = style$2({
  prop: 'display'
});
const overflow = style$2({
  prop: 'overflow'
});
const textOverflow = style$2({
  prop: 'textOverflow'
});
const visibility = style$2({
  prop: 'visibility'
});
const whiteSpace = style$2({
  prop: 'whiteSpace'
});
var display = compose$1(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

const flexBasis = style$2({
  prop: 'flexBasis'
});
const flexDirection = style$2({
  prop: 'flexDirection'
});
const flexWrap = style$2({
  prop: 'flexWrap'
});
const justifyContent = style$2({
  prop: 'justifyContent'
});
const alignItems = style$2({
  prop: 'alignItems'
});
const alignContent = style$2({
  prop: 'alignContent'
});
const order$2 = style$2({
  prop: 'order'
});
const flex = style$2({
  prop: 'flex'
});
const flexGrow = style$2({
  prop: 'flexGrow'
});
const flexShrink = style$2({
  prop: 'flexShrink'
});
const alignSelf = style$2({
  prop: 'alignSelf'
});
const justifyItems = style$2({
  prop: 'justifyItems'
});
const justifySelf = style$2({
  prop: 'justifySelf'
});
const flexbox = compose$1(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order$2, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
var flexbox$1 = flexbox;

const gap$2 = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');

    const styleFromPropValue = propValue => ({
      gap: getValue$1(transformer, propValue)
    });

    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }

  return null;
};
gap$2.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType$1
} : {};
gap$2.filterProps = ['gap'];
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');

    const styleFromPropValue = propValue => ({
      columnGap: getValue$1(transformer, propValue)
    });

    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }

  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ['columnGap'];
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');

    const styleFromPropValue = propValue => ({
      rowGap: getValue$1(transformer, propValue)
    });

    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }

  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$2({
  prop: 'gridColumn'
});
const gridRow = style$2({
  prop: 'gridRow'
});
const gridAutoFlow = style$2({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$2({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$2({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$2({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$2({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$2({
  prop: 'gridTemplateAreas'
});
const gridArea = style$2({
  prop: 'gridArea'
});
const grid = compose$1(gap$2, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var grid$1 = grid;

const color$3 = style$2({
  prop: 'color',
  themeKey: 'palette'
});
const bgcolor = style$2({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
const backgroundColor = style$2({
  prop: 'backgroundColor',
  themeKey: 'palette'
});
const palette$4 = compose$1(color$3, bgcolor, backgroundColor);
var palette$5 = palette$4;

const position$1 = style$2({
  prop: 'position'
});
const zIndex$2 = style$2({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
const top$2 = style$2({
  prop: 'top'
});
const right = style$2({
  prop: 'right'
});
const bottom$2 = style$2({
  prop: 'bottom'
});
const left = style$2({
  prop: 'left'
});
var positions$1 = compose$1(position$1, zIndex$2, top$2, right, bottom$2, left);

const boxShadow = style$2({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
var shadows$2 = boxShadow;

function transform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}

const width = style$2({
  prop: 'width',
  transform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;

      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || values$2[propValue];
      return {
        maxWidth: breakpoint || transform(propValue)
      };
    };

    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }

  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$2({
  prop: 'minWidth',
  transform
});
const height = style$2({
  prop: 'height',
  transform
});
const maxHeight = style$2({
  prop: 'maxHeight',
  transform
});
const minHeight = style$2({
  prop: 'minHeight',
  transform
});
style$2({
  prop: 'size',
  cssProperty: 'width',
  transform
});
style$2({
  prop: 'size',
  cssProperty: 'height',
  transform
});
const boxSizing = style$2({
  prop: 'boxSizing'
});
const sizing = compose$1(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
var sizing$1 = sizing;

const fontFamily = style$2({
  prop: 'fontFamily',
  themeKey: 'typography'
});
const fontSize = style$2({
  prop: 'fontSize',
  themeKey: 'typography'
});
const fontStyle = style$2({
  prop: 'fontStyle',
  themeKey: 'typography'
});
const fontWeight = style$2({
  prop: 'fontWeight',
  themeKey: 'typography'
});
const letterSpacing = style$2({
  prop: 'letterSpacing'
});
const textTransform = style$2({
  prop: 'textTransform'
});
const lineHeight = style$2({
  prop: 'lineHeight'
});
const textAlign = style$2({
  prop: 'textAlign'
});
const typographyVariant = style$2({
  prop: 'typography',
  cssProperty: false,
  themeKey: 'typography'
});
const typography$3 = compose$1(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform);
var typography$4 = typography$3;

const filterPropsMapping = {
  borders: borders$1.filterProps,
  display: display.filterProps,
  flexbox: flexbox$1.filterProps,
  grid: grid$1.filterProps,
  positions: positions$1.filterProps,
  palette: palette$5.filterProps,
  shadows: shadows$2.filterProps,
  sizing: sizing$1.filterProps,
  spacing: spacing.filterProps,
  typography: typography$4.filterProps
};
const styleFunctionMapping = {
  borders: borders$1,
  display,
  flexbox: flexbox$1,
  grid: grid$1,
  positions: positions$1,
  palette: palette$5,
  shadows: shadows$2,
  sizing: sizing$1,
  spacing,
  typography: typography$4
};
const propToStyleFunction = Object.keys(filterPropsMapping).reduce((acc, styleFnName) => {
  filterPropsMapping[styleFnName].forEach(propName => {
    acc[propName] = styleFunctionMapping[styleFnName];
  });
  return acc;
}, {});

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}

function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
} // eslint-disable-next-line @typescript-eslint/naming-convention


function unstable_createStyleFunctionSx(styleFunctionMapping$1 = styleFunctionMapping) {
  const propToStyleFunction = Object.keys(styleFunctionMapping$1).reduce((acc, styleFnName) => {
    styleFunctionMapping$1[styleFnName].filterProps.forEach(propName => {
      acc[propName] = styleFunctionMapping$1[styleFnName];
    });
    return acc;
  }, {});

  function getThemeValue(prop, value, theme) {
    const inputProps = {
      [prop]: value,
      theme
    };
    const styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
      [prop]: value
    };
  }

  function styleFunctionSx(props) {
    const {
      sx,
      theme = {}
    } = props || {};

    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */


    function traverse(sxInput) {
      let sxObject = sxInput;

      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }

      if (!sxObject) {
        return null;
      }

      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);

        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (propToStyleFunction[styleKey]) {
              css = merge$3(css, getThemeValue(styleKey, value, theme));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, x => ({
                [styleKey]: x
              }));

              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = merge$3(css, breakpointsValues);
              }
            }
          } else {
            css = merge$3(css, getThemeValue(styleKey, value, theme));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }

    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }

  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
var defaultStyleFunctionSx = styleFunctionSx;

const _excluded$1D = ["sx"];

const splitProps = props => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  Object.keys(props).forEach(prop => {
    if (propToStyleFunction[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};

function extendSxProp(props) {
  const {
    sx: inSx
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1D);

  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;

  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);

      if (!isPlainObject$6(result)) {
        return systemProps;
      }

      return _extends$P({}, systemProps, result);
    };
  } else {
    finalSx = _extends$P({}, systemProps, inSx);
  }

  return _extends$P({}, otherProps, {
    sx: finalSx
  });
}

const _excluded$1C = ["values", "unit", "step"];

const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || []; // Sort in ascending order

  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$P({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
}; // Keep in mind that @media is inclusive by the CSS specification.


function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screen

    },
    unit = 'px',
    step = 5
  } = breakpoints,
        other = _objectWithoutPropertiesLoose$3(breakpoints, _excluded$1C);

  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);

  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }

  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }

  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }

  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }

    return up(key);
  }

  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);

    if (keyIndex === 0) {
      return up(keys[1]);
    }

    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }

    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }

  return _extends$P({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

const shape = {
  borderRadius: 4
};
var shape$1 = shape;

/* tslint:enable:unified-signatures */
function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  const transform = createUnarySpacing({
    spacing: spacingInput
  });

  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }

    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };

  spacing.mui = true;
  return spacing;
}

const _excluded$1B = ["breakpoints", "palette", "spacing", "shape"];

function createTheme$1(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options,
        other = _objectWithoutPropertiesLoose$3(options, _excluded$1B);

  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge$2({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$P({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: _extends$P({}, shape$1, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$2(acc, argument), muiTheme);
  return muiTheme;
}

const ThemeContext = /*#__PURE__*/React$d.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

var ThemeContext$1 = ThemeContext;

function useTheme$3() {
  const theme = React$d.useContext(ThemeContext$1);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$d.useDebugValue(theme);
  }

  return theme;
}

const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);

    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['MUI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return _extends$P({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider$2(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme$3();

  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  const theme = React$d.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/jsx$1(ThemeContext$1.Provider, {
    value: theme,
    children: children
  });
}

process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes$1.node,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.func]).isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes) : void 0;
}

function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

function useTheme$2(defaultTheme = null) {
  const contextTheme = useTheme$3();
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

const systemDefaultTheme$1 = createTheme$1();

function useTheme$1(defaultTheme = systemDefaultTheme$1) {
  return useTheme$2(defaultTheme);
}

const _excluded$1A = ["className", "component"];
function createBox$1(options = {}) {
  const {
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName,
    styleFunctionSx = defaultStyleFunctionSx
  } = options;
  const BoxRoot = styled$2('div')(styleFunctionSx);
  const Box = /*#__PURE__*/React$d.forwardRef(function Box(inProps, ref) {
    const theme = useTheme$1(defaultTheme);

    const _extendSxProp = extendSxProp(inProps),
          {
      className,
      component = 'div'
    } = _extendSxProp,
          other = _objectWithoutPropertiesLoose$3(_extendSxProp, _excluded$1A);

    return /*#__PURE__*/jsx$1(BoxRoot, _extends$P({
      as: component,
      ref: ref,
      className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: theme
    }, other));
  });
  return Box;
}

const _excluded$1z = ["variant"];

function isEmpty$2(string) {
  return string.length === 0;
}
/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */


function propsToClassKey(props) {
  const {
    variant
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1z);

  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty$2(classKey) ? props[key] : capitalize$3(props[key]);
    } else {
      classKey += `${isEmpty$2(classKey) ? key : capitalize$3(key)}${capitalize$3(props[key].toString())}`;
    }
  });
  return classKey;
}

const _excluded$1y = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
      _excluded2$6 = ["theme"],
      _excluded3$1 = ["theme"];

function isEmpty$1(obj) {
  return Object.keys(obj).length === 0;
}

const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }

  return null;
};

const getVariantStyles = (name, theme) => {
  let variants = [];

  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }

  const variantsStyles = {};
  variants.forEach(definition => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};

const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;

  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;

  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });

      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }

  return variantsStyles;
}; // Update /system/styled/#api in case if this changes


function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = createTheme$1();

const lowercaseFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

function createStyled(input = {}) {
  const {
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp,
    styleFunctionSx = defaultStyleFunctionSx
  } = input;
  return (tag, inputOptions = {}) => {
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions,
          options = _objectWithoutPropertiesLoose$3(inputOptions, _excluded$1y); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.


    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;

    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || 'Root')}`;
      }
    }

    let shouldForwardPropOption = shouldForwardProp;

    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    }

    const defaultStyledResolver = styled$2(tag, _extends$P({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));

    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        // eslint-disable-next-line no-underscore-dangle
        return typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg ? _ref => {
          let {
            theme: themeInput
          } = _ref,
              other = _objectWithoutPropertiesLoose$3(_ref, _excluded2$6);

          return stylesArg(_extends$P({
            theme: isEmpty$1(themeInput) ? defaultTheme : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;

      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);

          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle(_extends$P({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }

          return null;
        });
      }

      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }

      if (!skipSx) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty$1(props.theme) ? defaultTheme : props.theme;
          return styleFunctionSx(_extends$P({}, props, {
            theme
          }));
        });
      }

      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;

      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill(''); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.

        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function' && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      // eslint-disable-next-line no-underscore-dangle
      styleArg.__emotion_real !== styleArg) {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = _ref2 => {
          let {
            theme: themeInput
          } = _ref2,
              other = _objectWithoutPropertiesLoose$3(_ref2, _excluded3$1);

          return styleArg(_extends$P({
            theme: isEmpty$1(themeInput) ? defaultTheme : themeInput
          }, other));
        };
      }

      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);

      if (process.env.NODE_ENV !== 'production') {
        let displayName;

        if (componentName) {
          displayName = `${componentName}${componentSlot || ''}`;
        }

        if (displayName === undefined) {
          displayName = `Styled(${getDisplayName(tag)})`;
        }

        Component.displayName = displayName;
      }

      return Component;
    };

    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }

    return muiStyledResolver;
  };
}

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;

  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }

  return resolveProps(theme.components[name].defaultProps, props);
}

function useThemeProps$1({
  props,
  name,
  defaultTheme
}) {
  const theme = useTheme$1(defaultTheme);
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp$1(value, min = 0, max = 1) {
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }

  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  const marker = color.indexOf('(');
  const type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, color));
  }

  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;

  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();

    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }

    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }

  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }

  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }

  return `${type}(${values})`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);

  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }

    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha$2(color, value) {
  color = decomposeColor(color);
  value = clamp$1(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }

  return recomposeColor(color);
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp$1(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp$1(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

function InnerThemeProvider(props) {
  const theme = useTheme$1();
  return /*#__PURE__*/jsx$1(ThemeContext$2.Provider, {
    value: typeof theme === 'object' ? theme : {},
    children: props.children
  });
}

process.env.NODE_ENV !== "production" ? InnerThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes$1.node
} : void 0;
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 */

function ThemeProvider$1(props) {
  const {
    children,
    theme: localTheme
  } = props;
  return /*#__PURE__*/jsx$1(ThemeProvider$2, {
    theme: localTheme,
    children: /*#__PURE__*/jsx$1(InnerThemeProvider, {
      children: children
    })
  });
}

process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Your component tree.
   */
  children: PropTypes$1.node,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]).isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes) : void 0;
}

function createMixins(breakpoints, spacing, mixins) {
  return _extends$P({
    toolbar: {
      minHeight: 56,
      [`${breakpoints.up('xs')} and (orientation: landscape)`]: {
        minHeight: 48
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}

const common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
var grey$1 = grey;

const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var purple$1 = purple;

const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var lightBlue$1 = lightBlue;

const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

const _excluded$1x = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }

  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}

function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }

  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}

function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }

  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}

function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }

  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}

function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }

  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}

function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }

  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}

function createPalette(palette) {
  const {
    mode = 'light',
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette,
        other = _objectWithoutPropertiesLoose$3(palette, _excluded$1x);

  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54

  function getContrastText(background) {
    const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      const contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = _extends$P({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.hasOwnProperty('main')) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage(11, name ? ` (${name})` : '', mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  const modes = {
    dark,
    light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!modes[mode]) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }

  const paletteOutput = deepmerge$2(_extends$P({
    // A collection of common colors.
    common: common$1,
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}

const _excluded$1w = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

function round$2(value) {
  return Math.round(value * 1e5) / 1e5;
}

const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
        {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref,
        other = _objectWithoutPropertiesLoose$3(_ref, _excluded$1w);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('MUI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('MUI: `htmlFontSize` is required to be a number.');
    }
  }

  const coef = fontSize / 14;

  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);

  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$P({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round$2(letterSpacing / size)}em`
  } : {}, casing, allVariants);

  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge$2(_extends$P({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;

function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

const _excluded$1v = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}

function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }

  const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}

function createTransitions(inputTransitions) {
  const mergedEasing = _extends$P({}, easing, inputTransitions.easing);

  const mergedDuration = _extends$P({}, duration, inputTransitions.duration);

  const create = (props = ['all'], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options,
          other = _objectWithoutPropertiesLoose$3(options, _excluded$1v);

    if (process.env.NODE_ENV !== 'production') {
      const isString = value => typeof value === 'string'; // IE11 support, replace with Number.isNaN
      // eslint-disable-next-line no-restricted-globals


      const isNumber = value => !isNaN(parseFloat(value));

      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }

      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
      }
    }

    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };

  return _extends$P({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

const _excluded$1u = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];

function createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options,
        other = _objectWithoutPropertiesLoose$3(options, _excluded$1u);

  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$1(options);
  let muiTheme = deepmerge$2(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, systemTheme.spacing, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$P({}, zIndex$1)
  });
  muiTheme = deepmerge$2(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$2(acc, argument), muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    const stateClasses = ['active', 'checked', 'completed', 'disabled', 'error', 'expanded', 'focused', 'focusVisible', 'required', 'selected'];

    const traverse = (node, component) => {
      let key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        const child = node[key];

        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            const stateClass = generateUtilityClass('', key);
            console.error([`MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`, 'You can not override it like this: ', JSON.stringify(node, null, 2), '', `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), '', 'https://mui.com/r/state-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    Object.keys(muiTheme.components).forEach(component => {
      const styleOverrides = muiTheme.components[component].styleOverrides;

      if (styleOverrides && component.indexOf('Mui') === 0) {
        traverse(styleOverrides, component);
      }
    });
  }

  return muiTheme;
}

const defaultTheme$1 = createTheme();
var defaultTheme$2 = defaultTheme$1;

const rootShouldForwardProp = prop => shouldForwardProp(prop) && prop !== 'classes';
const slotShouldForwardProp = shouldForwardProp;
const styled = createStyled({
  defaultTheme: defaultTheme$2,
  rootShouldForwardProp
});
var styled$1 = styled;

function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme: defaultTheme$2
  });
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose$h(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config$1 = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
  enter: PropTypes$1.number,
  exit: PropTypes$1.number,
  appear: PropTypes$1.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape({
  enter: PropTypes$1.string,
  exit: PropTypes$1.string,
  active: PropTypes$1.string
}), PropTypes$1.shape({
  enter: PropTypes$1.string,
  enterDone: PropTypes$1.string,
  enterActive: PropTypes$1.string,
  exit: PropTypes$1.string,
  exitDone: PropTypes$1.string,
  exitActive: PropTypes$1.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$h(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config$1.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config$1.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$3(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition$1.contextType = TransitionGroupContext;
Transition$1.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes$1.shape({
    current: typeof Element === 'undefined' ? PropTypes$1.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes$1.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes$1.oneOfType([PropTypes$1.func.isRequired, PropTypes$1.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes$1.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes$1.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes$1.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes$1.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes$1.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes$1.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes$1.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes$1.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes$1.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes$1.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes$1.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes$1.func
} : {}; // Name the function so it is clearer in the documentation

function noop$7() {}

Transition$1.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$7,
  onEntering: noop$7,
  onEntered: noop$7,
  onExit: noop$7,
  onExiting: noop$7,
  onExited: noop$7
};
Transition$1.UNMOUNTED = UNMOUNTED;
Transition$1.EXITED = EXITED;
Transition$1.ENTERING = ENTERING;
Transition$1.ENTERED = ENTERED;
Transition$1.EXITING = EXITING;
var Transition$2 = Transition$1;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$h(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose$3(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition$2, _extends$P({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$P({}, Transition$2.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes$1.func
}) : {};
var CSSTransition$1 = CSSTransition;

function _assertThisInitialized$6(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values$1 = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$4 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$h(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$6(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$P({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$3(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values$1(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes$1.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes$1.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes$1.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes$1.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes$1.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes$1.func
} : {};
TransitionGroup.defaultProps = defaultProps$4;
var TransitionGroup$1 = TransitionGroup;

const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;

  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

function useTheme() {
  const theme = useTheme$1(defaultTheme$2);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$d.useDebugValue(theme);
  }

  return theme;
}

function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('MuiSvgIcon', slot);
}
generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);

const _excluded$1t = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];

const useUtilityClasses$12 = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${capitalize$3(color)}`, `fontSize${capitalize$3(fontSize)}`]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};

const SvgIconRoot = styled$1('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${capitalize$3(ownerState.color)}`], styles[`fontSize${capitalize$3(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _theme$palette$ownerS, _theme$palette, _theme$palette$ownerS2, _theme$palette2, _theme$palette2$actio, _theme$palette3, _theme$palette3$actio;

  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_theme$palette$ownerS = (_theme$palette = theme.palette) == null ? void 0 : (_theme$palette$ownerS2 = _theme$palette[ownerState.color]) == null ? void 0 : _theme$palette$ownerS2.main) != null ? _theme$palette$ownerS : {
      action: (_theme$palette2 = theme.palette) == null ? void 0 : (_theme$palette2$actio = _theme$palette2.action) == null ? void 0 : _theme$palette2$actio.active,
      disabled: (_theme$palette3 = theme.palette) == null ? void 0 : (_theme$palette3$actio = _theme$palette3.action) == null ? void 0 : _theme$palette3$actio.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon = /*#__PURE__*/React$d.forwardRef(function SvgIcon(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSvgIcon'
  });

  const {
    children,
    className,
    color = 'inherit',
    component = 'svg',
    fontSize = 'medium',
    htmlColor,
    inheritViewBox = false,
    titleAccess,
    viewBox = '0 0 24 24'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1t);

  const ownerState = _extends$P({}, props, {
    color,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox
  });

  const more = {};

  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }

  const classes = useUtilityClasses$12(ownerState);
  return /*#__PURE__*/jsxs(SvgIconRoot, _extends$P({
    as: component,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, {
    children: [children, titleAccess ? /*#__PURE__*/jsx$1("title", {
      children: titleAccess
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['inherit', 'large', 'medium', 'small']), PropTypes$1.string]),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes$1.string,

  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes$1.bool,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes$1.string,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes$1.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes$1.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = SvgIcon;

function createSvgIcon$1(path, displayName) {
  const Component = (props, ref) => /*#__PURE__*/jsx$1(SvgIcon$1, _extends$P({
    "data-testid": `${displayName}Icon`,
    ref: ref
  }, props, {
    children: path
  }));

  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
  }

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React$d.memo( /*#__PURE__*/React$d.forwardRef(Component));
}

// eslint-disable-next-line @typescript-eslint/naming-convention

const unstable_ClassNameGenerator = {
  configure: generator => {
    console.warn(['MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.', '', "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", '', 'The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401', '', 'The updated documentation: https://mui.com/guides/classname-generator/'].join('\n'));
    ClassNameGenerator$1.configure(generator);
  }
};

var utils$l = /*#__PURE__*/Object.freeze({
    __proto__: null,
    unstable_ClassNameGenerator: unstable_ClassNameGenerator,
    capitalize: capitalize$3,
    createChainedFunction: createChainedFunction$1,
    createSvgIcon: createSvgIcon$1,
    debounce: debounce$5,
    deprecatedPropType: deprecatedPropType,
    isMuiElement: isMuiElement,
    ownerDocument: ownerDocument,
    ownerWindow: ownerWindow,
    requirePropFactory: requirePropFactory,
    setRef: setRef,
    unstable_useEnhancedEffect: useEnhancedEffect$2,
    unstable_useId: useId,
    unsupportedProp: unsupportedProp,
    useControlled: useControlled,
    useEventCallback: useEventCallback$1,
    useForkRef: useForkRef,
    useIsFocusVisible: useIsFocusVisible
});

function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);

const _excluded$1s = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];

const useUtilityClasses$11 = ownerState => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${orientation}`],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', `${orientation}`],
    wrapperInner: ['wrapperInner', `${orientation}`]
  };
  return composeClasses(slots, getCollapseUtilityClass, classes);
};

const CollapseRoot = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  height: 0,
  overflow: 'hidden',
  transition: theme.transitions.create('height')
}, ownerState.orientation === 'horizontal' && {
  height: 'auto',
  width: 0,
  transition: theme.transitions.create('width')
}, ownerState.state === 'entered' && _extends$P({
  height: 'auto',
  overflow: 'visible'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto'
}), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
  visibility: 'hidden'
}));
const CollapseWrapper = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => styles.wrapper
})(({
  ownerState
}) => _extends$P({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: 'flex',
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
const CollapseWrapperInner = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: (props, styles) => styles.wrapperInner
})(({
  ownerState
}) => _extends$P({
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Collapse = /*#__PURE__*/React$d.forwardRef(function Collapse(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiCollapse'
  });

  const {
    addEndListener,
    children,
    className,
    collapsedSize: collapsedSizeProp = '0px',
    component,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    orientation = 'vertical',
    style,
    timeout = duration.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$2
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1s);

  const ownerState = _extends$P({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });

  const classes = useUtilityClasses$11(ownerState);
  const theme = useTheme();
  const timer = React$d.useRef();
  const wrapperRef = React$d.useRef(null);
  const autoTransitionDuration = React$d.useRef();
  const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === 'horizontal';
  const size = isHorizontal ? 'width' : 'height';
  React$d.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  const nodeRef = React$d.useRef(null);
  const handleRef = useForkRef(ref, nodeRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;

  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }

    node.style[size] = collapsedSize;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperSize = getWrapperSize();

    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }

    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });

    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }

    node.style[size] = `${wrapperSize}px`;
    node.style.transitionTimingFunction = transitionTimingFunction;

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style[size] = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    node.style[size] = `${getWrapperSize()}px`;

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });

    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }

    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;

    if (onExiting) {
      onExiting(node);
    }
  });

  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }

    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  return /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => /*#__PURE__*/jsx$1(CollapseRoot, _extends$P({
      as: component,
      className: clsx(classes.root, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: _extends$P({
        [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
      }, style),
      ownerState: _extends$P({}, ownerState, {
        state
      }),
      ref: handleRef
    }, childProps, {
      children: /*#__PURE__*/jsx$1(CollapseWrapper, {
        ownerState: _extends$P({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /*#__PURE__*/jsx$1(CollapseWrapperInner, {
          ownerState: _extends$P({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children: children
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes$1.func,

  /**
   * The content node to be collapsed.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes$1.oneOfType([PropTypes$1.shape({
    enter: PropTypes$1.string,
    exit: PropTypes$1.string
  }), PropTypes$1.string]),

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes$1.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntered: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntering: PropTypes$1.func,

  /**
   * @ignore
   */
  onExit: PropTypes$1.func,

  /**
   * @ignore
   */
  onExited: PropTypes$1.func,

  /**
   * @ignore
   */
  onExiting: PropTypes$1.func,

  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = Collapse;

function getPaperUtilityClass(slot) {
  return generateUtilityClass('MuiPaper', slot);
}
generateUtilityClasses('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);

const _excluded$1r = ["className", "component", "elevation", "square", "variant"];

const getOverlayAlpha = elevation => {
  let alphaValue;

  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }

  return (alphaValue / 100).toFixed(2);
};

const useUtilityClasses$10 = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};

const PaperRoot = styled$1('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  transition: theme.transitions.create('box-shadow')
}, !ownerState.square && {
  borderRadius: theme.shape.borderRadius
}, ownerState.variant === 'outlined' && {
  border: `1px solid ${theme.palette.divider}`
}, ownerState.variant === 'elevation' && _extends$P({
  boxShadow: theme.shadows[ownerState.elevation]
}, theme.palette.mode === 'dark' && {
  backgroundImage: `linear-gradient(${alpha$2('#fff', getOverlayAlpha(ownerState.elevation))}, ${alpha$2('#fff', getOverlayAlpha(ownerState.elevation))})`
})));
const Paper$1 = /*#__PURE__*/React$d.forwardRef(function Paper(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPaper'
  });

  const {
    className,
    component = 'div',
    elevation = 1,
    square = false,
    variant = 'elevation'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1r);

  const ownerState = _extends$P({}, props, {
    component,
    elevation,
    square,
    variant
  });

  const classes = useUtilityClasses$10(ownerState);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme = useTheme();

    if (theme.shadows[elevation] === undefined) {
      console.error([`MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${elevation}]\` is defined.`].join('\n'));
    }
  }

  return /*#__PURE__*/jsx$1(PaperRoot, _extends$P({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, props => {
    const {
      elevation,
      variant
    } = props;

    if (elevation > 0 && variant === 'outlined') {
      return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['elevation', 'outlined']), PropTypes$1.string])
} : void 0;
var Paper$2 = Paper$1;

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

const AccordionContext = /*#__PURE__*/React$d.createContext({});

if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}

var AccordionContext$1 = AccordionContext;

function getAccordionUtilityClass(slot) {
  return generateUtilityClass('MuiAccordion', slot);
}
const accordionClasses = generateUtilityClasses('MuiAccordion', ['root', 'rounded', 'expanded', 'disabled', 'gutters', 'region']);
var accordionClasses$1 = accordionClasses;

const _excluded$1q = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"];

const useUtilityClasses$$ = ownerState => {
  const {
    classes,
    square,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ['root', !square && 'rounded', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
    region: ['region']
  };
  return composeClasses(slots, getAccordionUtilityClass, classes);
};

const AccordionRoot = styled$1(Paper$2, {
  name: 'MuiAccordion',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${accordionClasses$1.region}`]: styles.region
    }, styles.root, !ownerState.square && styles.rounded, !ownerState.disableGutters && styles.gutters];
  }
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    position: 'relative',
    transition: theme.transitions.create(['margin'], transition),
    overflowAnchor: 'none',
    // Keep the same scrolling position
    '&:before': {
      position: 'absolute',
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: theme.palette.divider,
      transition: theme.transitions.create(['opacity', 'background-color'], transition)
    },
    '&:first-of-type': {
      '&:before': {
        display: 'none'
      }
    },
    [`&.${accordionClasses$1.expanded}`]: {
      '&:before': {
        opacity: 0
      },
      '&:first-of-type': {
        marginTop: 0
      },
      '&:last-of-type': {
        marginBottom: 0
      },
      '& + &': {
        '&:before': {
          display: 'none'
        }
      }
    },
    [`&.${accordionClasses$1.disabled}`]: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
}, ({
  theme,
  ownerState
}) => _extends$P({}, !ownerState.square && {
  borderRadius: 0,
  '&:first-of-type': {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius
  },
  '&:last-of-type': {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    // Fix a rendering issue on Edge
    '@supports (-ms-ime-align: auto)': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }
}, !ownerState.disableGutters && {
  [`&.${accordionClasses$1.expanded}`]: {
    margin: '16px 0'
  }
}));
const Accordion$1 = /*#__PURE__*/React$d.forwardRef(function Accordion(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiAccordion'
  });

  const {
    children: childrenProp,
    className,
    defaultExpanded = false,
    disabled = false,
    disableGutters = false,
    expanded: expandedProp,
    onChange,
    square = false,
    TransitionComponent = Collapse$1,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1q);

  const [expanded, setExpandedState] = useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  });
  const handleChange = React$d.useCallback(event => {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  const [summary, ...children] = React$d.Children.toArray(childrenProp);
  const contextValue = React$d.useMemo(() => ({
    expanded,
    disabled,
    disableGutters,
    toggle: handleChange
  }), [expanded, disabled, disableGutters, handleChange]);

  const ownerState = _extends$P({}, props, {
    square,
    disabled,
    disableGutters,
    expanded
  });

  const classes = useUtilityClasses$$(ownerState);
  return /*#__PURE__*/jsxs(AccordionRoot, _extends$P({
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState,
    square: square
  }, other, {
    children: [/*#__PURE__*/jsx$1(AccordionContext$1.Provider, {
      value: contextValue,
      children: summary
    }), /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
      in: expanded,
      timeout: "auto"
    }, TransitionProps, {
      children: /*#__PURE__*/jsx$1("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props['aria-controls'],
        role: "region",
        className: classes.region,
        children: children
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? Accordion$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes$1.node.isRequired, props => {
    const summary = React$d.Children.toArray(props.children)[0];

    if (reactIs$3.exports.isFragment(summary)) {
      return new Error("MUI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React$d.isValidElement(summary)) {
      return new Error('MUI: Expected the first child of Accordion to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: PropTypes$1.bool,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: PropTypes$1.bool,

  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes$1.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes$1.func,

  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   */
  TransitionComponent: PropTypes$1.elementType,

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes$1.object
} : void 0;
var MuiAccordion = Accordion$1;

function getAccordionDetailsUtilityClass(slot) {
  return generateUtilityClass('MuiAccordionDetails', slot);
}
generateUtilityClasses('MuiAccordionDetails', ['root']);

const _excluded$1p = ["className"];

const useUtilityClasses$_ = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getAccordionDetailsUtilityClass, classes);
};

const AccordionDetailsRoot = styled$1('div', {
  name: 'MuiAccordionDetails',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  padding: theme.spacing(1, 2, 2)
}));
const AccordionDetails = /*#__PURE__*/React$d.forwardRef(function AccordionDetails(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiAccordionDetails'
  });

  const {
    className
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1p);

  const ownerState = props;
  const classes = useUtilityClasses$_(ownerState);
  return /*#__PURE__*/jsx$1(AccordionDetailsRoot, _extends$P({
    className: clsx(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var AccordionDetails$1 = AccordionDetails;

function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = React$d.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);

  if (!inProp && !leaving) {
    setLeaving(true);
  }

  React$d.useEffect(() => {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/jsx$1("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/jsx$1("span", {
      className: childClassName
    })
  });
}

process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes$1.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes$1.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes$1.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes$1.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes$1.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes$1.number,

  /**
   * exit delay
   */
  timeout: PropTypes$1.number.isRequired
} : void 0;

const touchRippleClasses = generateUtilityClasses('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
var touchRippleClasses$1 = touchRippleClasses;

const _excluded$1o = ["center", "classes", "className"];

let _$3 = t => t,
    _t$3,
    _t2$3,
    _t3$3,
    _t4$3;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes(_t$3 || (_t$3 = _$3`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = keyframes(_t2$3 || (_t2$3 = _$3`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = keyframes(_t3$3 || (_t3$3 = _$3`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = styled$1('span', {
  name: 'MuiTouchRipple',
  slot: 'Root'
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
}); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.

const TouchRippleRipple = styled$1(Ripple, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})(_t4$3 || (_t4$3 = _$3`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

const TouchRipple = /*#__PURE__*/React$d.forwardRef(function TouchRipple(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTouchRipple'
  });

  const {
    center: centerProp = false,
    classes = {},
    className
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1o);

  const [ripples, setRipples] = React$d.useState([]);
  const nextKey = React$d.useRef(0);
  const rippleCallback = React$d.useRef(null);
  React$d.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  const ignoringMouseDown = React$d.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  const startTimer = React$d.useRef(null); // This is the hook called once the previous timeout is ready.

  const startTimerCommit = React$d.useRef(null);
  const container = React$d.useRef(null);
  React$d.useEffect(() => {
    return () => {
      clearTimeout(startTimer.current);
    };
  }, []);
  const startCommit = React$d.useCallback(params => {
    const {
      pulsate,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples(oldRipples => [...oldRipples, /*#__PURE__*/jsx$1(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses$1.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate,
      rippleX: rippleX,
      rippleY: rippleY,
      rippleSize: rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = React$d.useCallback((event = {}, options = {}, cb) => {
    const {
      pulsate = false,
      center = centerProp || options.pulsate,
      fakeElement = false // For test purposes

    } = options;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    let rippleX;
    let rippleY;
    let rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = () => {
          startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(() => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit]);
  const pulsate = React$d.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = React$d.useCallback((event, cb) => {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(() => {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(oldRipples => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  React$d.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /*#__PURE__*/jsx$1(TouchRippleRoot, _extends$P({
    className: clsx(classes.root, touchRippleClasses$1.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/jsx$1(TransitionGroup$1, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string
} : void 0;
var TouchRipple$1 = TouchRipple;

function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass('MuiButtonBase', slot);
}
const buttonBaseClasses = generateUtilityClasses('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
var buttonBaseClasses$1 = buttonBaseClasses;

const _excluded$1n = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];

const useUtilityClasses$Z = ownerState => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  const composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);

  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }

  return composedClasses;
};

const ButtonBaseRoot = styled$1('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.

  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  },
  '@media print': {
    colorAdjust: 'exact'
  }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

const ButtonBase = /*#__PURE__*/React$d.forwardRef(function ButtonBase(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiButtonBase'
  });

  const {
    action,
    centerRipple = false,
    children,
    className,
    component = 'button',
    disabled = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    LinkComponent = 'a',
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    touchRippleRef,
    type
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1n);

  const buttonRef = React$d.useRef(null);
  const rippleRef = React$d.useRef(null);
  const handleRippleRef = useForkRef(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React$d.useState(false);

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  React$d.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = React$d.useState(false);
  React$d.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;
  React$d.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);

  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return useEventCallback$1(event => {
      if (eventCallback) {
        eventCallback(event);
      }

      const ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  const handleMouseDown = useRippleHandler('start', onMouseDown);
  const handleContextMenu = useRippleHandler('stop', onContextMenu);
  const handleDragLeave = useRippleHandler('stop', onDragLeave);
  const handleMouseUp = useRippleHandler('stop', onMouseUp);
  const handleMouseLeave = useRippleHandler('stop', event => {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler('start', onTouchStart);
  const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  const handleTouchMove = useRippleHandler('stop', onTouchMove);
  const handleBlur = useRippleHandler('stop', event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = useEventCallback$1(event => {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  const keydownRef = React$d.useRef(false);
  const handleKeyDown = useEventCallback$1(event => {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = useEventCallback$1(event => {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;

  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }

  const buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }

    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }

  const handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  const handleRef = useForkRef(ref, handleOwnRef);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$d.useEffect(() => {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['MUI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  const ownerState = _extends$P({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });

  const classes = useUtilityClasses$Z(ownerState);
  return /*#__PURE__*/jsxs(ButtonBaseRoot, _extends$P({
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ?
    /*#__PURE__*/

    /* TouchRipple is only needed client-side, x2 boost on the server. */
    jsx$1(TouchRipple$1, _extends$P({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$1,

  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes$1.bool,

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes$1.bool,

  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes$1.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes$1.bool,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes$1.string,

  /**
   * @ignore
   */
  href: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .any,

  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes$1.elementType,

  /**
   * @ignore
   */
  onBlur: PropTypes$1.func,

  /**
   * @ignore
   */
  onClick: PropTypes$1.func,

  /**
   * @ignore
   */
  onContextMenu: PropTypes$1.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes$1.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes$1.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes$1.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes$1.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes$1.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes$1.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes$1.func,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * @default 0
   */
  tabIndex: PropTypes$1.number,

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes$1.object,

  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
    current: PropTypes$1.shape({
      pulsate: PropTypes$1.func.isRequired,
      start: PropTypes$1.func.isRequired,
      stop: PropTypes$1.func.isRequired
    })
  })]),

  /**
   * @ignore
   */
  type: PropTypes$1.oneOfType([PropTypes$1.oneOf(['button', 'reset', 'submit']), PropTypes$1.string])
} : void 0;
var ButtonBase$1 = ButtonBase;

function getAccordionSummaryUtilityClass(slot) {
  return generateUtilityClass('MuiAccordionSummary', slot);
}
const accordionSummaryClasses = generateUtilityClasses('MuiAccordionSummary', ['root', 'expanded', 'focusVisible', 'disabled', 'gutters', 'contentGutters', 'content', 'expandIconWrapper']);
var accordionSummaryClasses$1 = accordionSummaryClasses;

const _excluded$1m = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"];

const useUtilityClasses$Y = ownerState => {
  const {
    classes,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ['root', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
    focusVisible: ['focusVisible'],
    content: ['content', expanded && 'expanded', !disableGutters && 'contentGutters'],
    expandIconWrapper: ['expandIconWrapper', expanded && 'expanded']
  };
  return composeClasses(slots, getAccordionSummaryUtilityClass, classes);
};

const AccordionSummaryRoot = styled$1(ButtonBase$1, {
  name: 'MuiAccordionSummary',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return _extends$P({
    display: 'flex',
    minHeight: 48,
    padding: theme.spacing(0, 2),
    transition: theme.transitions.create(['min-height', 'background-color'], transition),
    [`&.${accordionSummaryClasses$1.focusVisible}`]: {
      backgroundColor: theme.palette.action.focus
    },
    [`&.${accordionSummaryClasses$1.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity
    },
    [`&:hover:not(.${accordionSummaryClasses$1.disabled})`]: {
      cursor: 'pointer'
    }
  }, !ownerState.disableGutters && {
    [`&.${accordionSummaryClasses$1.expanded}`]: {
      minHeight: 64
    }
  });
});
const AccordionSummaryContent = styled$1('div', {
  name: 'MuiAccordionSummary',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'flex',
  flexGrow: 1,
  margin: '12px 0'
}, !ownerState.disableGutters && {
  transition: theme.transitions.create(['margin'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses$1.expanded}`]: {
    margin: '20px 0'
  }
}));
const AccordionSummaryExpandIconWrapper = styled$1('div', {
  name: 'MuiAccordionSummary',
  slot: 'ExpandIconWrapper',
  overridesResolver: (props, styles) => styles.expandIconWrapper
})(({
  theme
}) => ({
  display: 'flex',
  color: theme.palette.action.active,
  transform: 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses$1.expanded}`]: {
    transform: 'rotate(180deg)'
  }
}));
const AccordionSummary = /*#__PURE__*/React$d.forwardRef(function AccordionSummary(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiAccordionSummary'
  });

  const {
    children,
    className,
    expandIcon,
    focusVisibleClassName,
    onClick
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1m);

  const {
    disabled = false,
    disableGutters,
    expanded,
    toggle
  } = React$d.useContext(AccordionContext$1);

  const handleChange = event => {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  const ownerState = _extends$P({}, props, {
    expanded,
    disabled,
    disableGutters
  });

  const classes = useUtilityClasses$Y(ownerState);
  return /*#__PURE__*/jsxs(AccordionSummaryRoot, _extends$P({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: clsx(classes.root, className),
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    onClick: handleChange,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx$1(AccordionSummaryContent, {
      className: classes.content,
      ownerState: ownerState,
      children: children
    }), expandIcon && /*#__PURE__*/jsx$1(AccordionSummaryExpandIconWrapper, {
      className: classes.expandIconWrapper,
      ownerState: ownerState,
      children: expandIcon
    })]
  }));
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes$1.node,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes$1.string,

  /**
   * @ignore
   */
  onClick: PropTypes$1.func,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var AccordionSummary$1 = AccordionSummary;

/**
 * @ignore - internal component.
 */

const GridContext = /*#__PURE__*/React$d.createContext();

if (process.env.NODE_ENV !== 'production') {
  GridContext.displayName = 'GridContext';
}

var GridContext$1 = GridContext;

function getGridUtilityClass(slot) {
  return generateUtilityClass('MuiGrid', slot);
}
const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DIRECTIONS = ['column-reverse', 'column', 'row-reverse', 'row'];
const WRAPS = ['nowrap', 'wrap-reverse', 'wrap'];
const GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const gridClasses = generateUtilityClasses('MuiGrid', ['root', 'container', 'item', 'zeroMinWidth', // spacings
...SPACINGS.map(spacing => `spacing-xs-${spacing}`), // direction values
...DIRECTIONS.map(direction => `direction-xs-${direction}`), // wrap values
...WRAPS.map(wrap => `wrap-xs-${wrap}`), // grid sizes for all breakpoints
...GRID_SIZES.map(size => `grid-xs-${size}`), ...GRID_SIZES.map(size => `grid-sm-${size}`), ...GRID_SIZES.map(size => `grid-md-${size}`), ...GRID_SIZES.map(size => `grid-lg-${size}`), ...GRID_SIZES.map(size => `grid-xl-${size}`)]);

const _excluded$1l = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "lg", "md", "rowSpacing", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"];

function getOffset(val) {
  const parse = parseFloat(val);
  return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}

function generateGrid({
  theme,
  ownerState
}) {
  let size;
  return theme.breakpoints.keys.reduce((globalStyles, breakpoint) => {
    // Use side effect over immutability for better performance.
    let styles = {};

    if (ownerState[breakpoint]) {
      size = ownerState[breakpoint];
    }

    if (!size) {
      return globalStyles;
    }

    if (size === true) {
      // For the auto layouting
      styles = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
    } else if (size === 'auto') {
      styles = {
        flexBasis: 'auto',
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: 'none',
        width: 'auto'
      };
    } else {
      const columnsBreakpointValues = resolveBreakpointValues({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
      });
      const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;

      if (columnValue === undefined || columnValue === null) {
        return globalStyles;
      } // Keep 7 significant numbers.


      const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
      let more = {};

      if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
        const themeSpacing = theme.spacing(ownerState.columnSpacing);

        if (themeSpacing !== '0px') {
          const fullWidth = `calc(${width} + ${getOffset(themeSpacing)})`;
          more = {
            flexBasis: fullWidth,
            maxWidth: fullWidth
          };
        }
      } // Close to the bootstrap implementation:
      // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41


      styles = _extends$P({
        flexBasis: width,
        flexGrow: 0,
        maxWidth: width
      }, more);
    } // No need for a media query for the first size.


    if (theme.breakpoints.values[breakpoint] === 0) {
      Object.assign(globalStyles, styles);
    } else {
      globalStyles[theme.breakpoints.up(breakpoint)] = styles;
    }

    return globalStyles;
  }, {});
}
function generateDirection({
  theme,
  ownerState
}) {
  const directionValues = resolveBreakpointValues({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  });
  return handleBreakpoints({
    theme
  }, directionValues, propValue => {
    const output = {
      flexDirection: propValue
    };

    if (propValue.indexOf('column') === 0) {
      output[`& > .${gridClasses.item}`] = {
        maxWidth: 'none'
      };
    }

    return output;
  });
}
function generateRowGap({
  theme,
  ownerState
}) {
  const {
    container,
    rowSpacing
  } = ownerState;
  let styles = {};

  if (container && rowSpacing !== 0) {
    const rowSpacingValues = resolveBreakpointValues({
      values: rowSpacing,
      breakpoints: theme.breakpoints.values
    });
    styles = handleBreakpoints({
      theme
    }, rowSpacingValues, propValue => {
      const themeSpacing = theme.spacing(propValue);

      if (themeSpacing !== '0px') {
        return {
          marginTop: `-${getOffset(themeSpacing)}`,
          [`& > .${gridClasses.item}`]: {
            paddingTop: getOffset(themeSpacing)
          }
        };
      }

      return {};
    });
  }

  return styles;
}
function generateColumnGap({
  theme,
  ownerState
}) {
  const {
    container,
    columnSpacing
  } = ownerState;
  let styles = {};

  if (container && columnSpacing !== 0) {
    const columnSpacingValues = resolveBreakpointValues({
      values: columnSpacing,
      breakpoints: theme.breakpoints.values
    });
    styles = handleBreakpoints({
      theme
    }, columnSpacingValues, propValue => {
      const themeSpacing = theme.spacing(propValue);

      if (themeSpacing !== '0px') {
        return {
          width: `calc(100% + ${getOffset(themeSpacing)})`,
          marginLeft: `-${getOffset(themeSpacing)}`,
          [`& > .${gridClasses.item}`]: {
            paddingLeft: getOffset(themeSpacing)
          }
        };
      }

      return {};
    });
  }

  return styles;
}
function resolveSpacingClasses(spacing, container, styles = {}) {
  // in case of grid item or undefined/null or `spacing` <= 0
  if (!container || !spacing || spacing <= 0) {
    return [];
  } // in case of string/number `spacing`


  if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') {
    return [styles[`spacing-xs-${String(spacing)}`] || `spacing-xs-${String(spacing)}`];
  } // in case of object `spacing`


  const {
    xs,
    sm,
    md,
    lg,
    xl
  } = spacing;
  return [Number(xs) > 0 && (styles[`spacing-xs-${String(xs)}`] || `spacing-xs-${String(xs)}`), Number(sm) > 0 && (styles[`spacing-sm-${String(sm)}`] || `spacing-sm-${String(sm)}`), Number(md) > 0 && (styles[`spacing-md-${String(md)}`] || `spacing-md-${String(md)}`), Number(lg) > 0 && (styles[`spacing-lg-${String(lg)}`] || `spacing-lg-${String(lg)}`), Number(xl) > 0 && (styles[`spacing-xl-${String(xl)}`] || `spacing-xl-${String(xl)}`)];
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',

const GridRoot = styled$1('div', {
  name: 'MuiGrid',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      container,
      direction,
      item,
      lg,
      md,
      sm,
      spacing,
      wrap,
      xl,
      xs,
      zeroMinWidth
    } = props.ownerState;
    return [styles.root, container && styles.container, item && styles.item, zeroMinWidth && styles.zeroMinWidth, ...resolveSpacingClasses(spacing, container, styles), direction !== 'row' && styles[`direction-xs-${String(direction)}`], wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`], xs !== false && styles[`grid-xs-${String(xs)}`], sm !== false && styles[`grid-sm-${String(sm)}`], md !== false && styles[`grid-md-${String(md)}`], lg !== false && styles[`grid-lg-${String(lg)}`], xl !== false && styles[`grid-xl-${String(xl)}`]];
  }
})(({
  ownerState
}) => _extends$P({
  boxSizing: 'border-box'
}, ownerState.container && {
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%'
}, ownerState.item && {
  margin: 0 // For instance, it's useful when used with a `figure` element.

}, ownerState.zeroMinWidth && {
  minWidth: 0
}, ownerState.wrap !== 'wrap' && {
  flexWrap: ownerState.wrap
}), generateDirection, generateRowGap, generateColumnGap, generateGrid);

const useUtilityClasses$X = ownerState => {
  const {
    classes,
    container,
    direction,
    item,
    lg,
    md,
    sm,
    spacing,
    wrap,
    xl,
    xs,
    zeroMinWidth
  } = ownerState;
  const slots = {
    root: ['root', container && 'container', item && 'item', zeroMinWidth && 'zeroMinWidth', ...resolveSpacingClasses(spacing, container), direction !== 'row' && `direction-xs-${String(direction)}`, wrap !== 'wrap' && `wrap-xs-${String(wrap)}`, xs !== false && `grid-xs-${String(xs)}`, sm !== false && `grid-sm-${String(sm)}`, md !== false && `grid-md-${String(md)}`, lg !== false && `grid-lg-${String(lg)}`, xl !== false && `grid-xl-${String(xl)}`]
  };
  return composeClasses(slots, getGridUtilityClass, classes);
};

const Grid$1 = /*#__PURE__*/React$d.forwardRef(function Grid(inProps, ref) {
  const themeProps = useThemeProps({
    props: inProps,
    name: 'MuiGrid'
  });
  const props = extendSxProp(themeProps);

  const {
    className,
    columns: columnsProp,
    columnSpacing: columnSpacingProp,
    component = 'div',
    container = false,
    direction = 'row',
    item = false,
    lg = false,
    md = false,
    rowSpacing: rowSpacingProp,
    sm = false,
    spacing = 0,
    wrap = 'wrap',
    xl = false,
    xs = false,
    zeroMinWidth = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1l);

  const rowSpacing = rowSpacingProp || spacing;
  const columnSpacing = columnSpacingProp || spacing;
  const columnsContext = React$d.useContext(GridContext$1); // columns set with default breakpoint unit of 12

  const columns = container ? columnsProp || 12 : columnsContext;

  const ownerState = _extends$P({}, props, {
    columns,
    container,
    direction,
    item,
    lg,
    md,
    sm,
    rowSpacing,
    columnSpacing,
    wrap,
    xl,
    xs,
    zeroMinWidth
  });

  const classes = useUtilityClasses$X(ownerState);
  return /*#__PURE__*/jsx$1(GridContext$1.Provider, {
    value: columns,
    children: /*#__PURE__*/jsx$1(GridRoot, _extends$P({
      ownerState: ownerState,
      className: clsx(classes.root, className),
      as: component,
      ref: ref
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Grid$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The number of columns.
   * @default 12
   */
  columns: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number, PropTypes$1.object]),

  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])), PropTypes$1.number, PropTypes$1.object, PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: PropTypes$1.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: PropTypes$1.oneOfType([PropTypes$1.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes$1.arrayOf(PropTypes$1.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes$1.object]),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: PropTypes$1.bool,

  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.bool]),

  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.bool]),

  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])), PropTypes$1.number, PropTypes$1.object, PropTypes$1.string]),

  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.bool]),

  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])), PropTypes$1.number, PropTypes$1.object, PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: PropTypes$1.oneOf(['nowrap', 'wrap-reverse', 'wrap']),

  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.bool]),

  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.bool]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: PropTypes$1.bool
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  const requireProp = requirePropFactory('Grid', Grid$1); // eslint-disable-next-line no-useless-concat

  Grid$1['propTypes' + ''] = _extends$P({}, Grid$1.propTypes, {
    direction: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

var Grid$2 = Grid$1;

var Add$1 = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

var ArrowForwardRounded = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z"
}), 'ArrowForwardRounded');

var BarChart$1 = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
}), 'BarChart');

var Check = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

var CheckCircle = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');

var ChevronLeft = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');

var ChevronRight = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

var Close$2 = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var CloudUploadOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
}), 'CloudUploadOutlined');

var DeleteOutline = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');

var DragHandle = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}), 'DragHandle');

var DragIndicator = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'DragIndicator');

var ErrorOutline = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

var ExpandMore = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

var FiberManualRecord = createSvgIcon$1( /*#__PURE__*/jsx$1("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecord');

var FileCopyOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"
}), 'FileCopyOutlined');

var Filter1Outlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
}), 'Filter1Outlined');

var FlagOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "m12.36 6 .4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
}), 'FlagOutlined');

var FormatLineSpacing = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
}), 'FormatLineSpacing');

var GetAppOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z"
}), 'GetAppOutlined');

var Image = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
}), 'Image');

var ImageOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
}), 'ImageOutlined');

var InfoOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'InfoOutlined');

var KeyboardArrowDown = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');

var KeyboardArrowUp = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');

var LockOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
}), 'LockOutlined');

var MailOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"
}), 'MailOutlined');

var MoreHoriz = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

var MoreVert = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');

var NavigateNext = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

var PauseCircleOutline = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
}), 'PauseCircleOutline');

var PlayCircleOutline$2 = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "m10 16.5 6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'PlayCircleOutline');

var Refresh = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
}), 'Refresh');

var RouteOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18c-1.16.41-2 1.51-2 2.82 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82zM6 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), 'RouteOutlined');

var Search$1 = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

var TextFields = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
}), 'TextFields');

var TimelineOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
}), 'TimelineOutlined');

var Visibility = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'Visibility');

var VisibilityOffOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4 1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
}), 'VisibilityOffOutlined');

var VisibilityOutlined = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
}), 'VisibilityOutlined');

function getDividerUtilityClass(slot) {
  return generateUtilityClass('MuiDivider', slot);
}
const dividerClasses = generateUtilityClasses('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
var dividerClasses$1 = dividerClasses;

const _excluded$1k = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];

const useUtilityClasses$W = ownerState => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return composeClasses(slots, getDividerUtilityClass, classes);
};

const DividerRoot = styled$1('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: 'solid',
  borderColor: theme.palette.divider,
  borderBottomWidth: 'thin'
}, ownerState.absolute && {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
}, ownerState.light && {
  borderColor: alpha$2(theme.palette.divider, 0.08)
}, ownerState.variant === 'inset' && {
  marginLeft: 72
}, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  borderBottomWidth: 0,
  borderRightWidth: 'thin'
}, ownerState.flexItem && {
  alignSelf: 'stretch',
  height: 'auto'
}), ({
  theme,
  ownerState
}) => _extends$P({}, ownerState.children && {
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  border: 0,
  '&::before, &::after': {
    position: 'relative',
    width: '100%',
    borderTop: `thin solid ${theme.palette.divider}`,
    top: '50%',
    content: '""',
    transform: 'translateY(50%)'
  }
}), ({
  theme,
  ownerState
}) => _extends$P({}, ownerState.children && ownerState.orientation === 'vertical' && {
  flexDirection: 'column',
  '&::before, &::after': {
    height: '100%',
    top: '0%',
    left: '50%',
    borderTop: 0,
    borderLeft: `thin solid ${theme.palette.divider}`,
    transform: 'translateX(0%)'
  }
}), ({
  ownerState
}) => _extends$P({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '90%'
  },
  '&::after': {
    width: '10%'
  }
}, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '10%'
  },
  '&::after': {
    width: '90%'
  }
}));
const DividerWrapper = styled$1('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'inline-block',
  paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
  paddingRight: `calc(${theme.spacing(1)} * 1.2)`
}, ownerState.orientation === 'vertical' && {
  paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
}));
const Divider$1 = /*#__PURE__*/React$d.forwardRef(function Divider(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDivider'
  });

  const {
    absolute = false,
    children,
    className,
    component = children ? 'div' : 'hr',
    flexItem = false,
    light = false,
    orientation = 'horizontal',
    role = component !== 'hr' ? 'separator' : undefined,
    textAlign = 'center',
    variant = 'fullWidth'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1k);

  const ownerState = _extends$P({}, props, {
    absolute,
    component,
    flexItem,
    light,
    orientation,
    role,
    textAlign,
    variant
  });

  const classes = useUtilityClasses$W(ownerState);
  return /*#__PURE__*/jsx$1(DividerRoot, _extends$P({
    as: component,
    className: clsx(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/jsx$1(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});
process.env.NODE_ENV !== "production" ? Divider$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes$1.bool,

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes$1.bool,

  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   */
  light: PropTypes$1.bool,

  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  role: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .string,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes$1.oneOf(['center', 'left', 'right']),

  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['fullWidth', 'inset', 'middle']), PropTypes$1.string])
} : void 0;
var Divider$2 = Divider$1;

var Divider = function (props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx$1(Divider$2, __assign$3({}, props));
};

var tssReact = {};

var cssAndCx = {};

var classnames = {};

var assert$2 = {};

Object.defineProperty(assert$2, "__esModule", { value: true });
assert$2.assert = void 0;
/** https://docs.tsafe.dev/assert */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function assert$1(condition, msg) {
    if (!condition) {
        throw new Error(msg);
    }
}
assert$2.assert = assert$1;

var typeGuard$1 = {};

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(typeGuard$1, "__esModule", { value: true });
typeGuard$1.typeGuard = void 0;
/** https://docs.tsafe.dev/typeguard */
function typeGuard(_value, isMatched) {
    return isMatched;
}
typeGuard$1.typeGuard = typeGuard;

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.classnames = void 0;
const assert_1 = assert$2;
const typeGuard_1 = typeGuard$1;
/** Copy pasted from
 * https://github.com/emotion-js/emotion/blob/23f43ab9f24d44219b0b007a00f4ac681fe8712e/packages/react/src/class-names.js#L17-L63
 **/
const classnames = (args) => {
    const len = args.length;
    let i = 0;
    let cls = "";
    for (; i < len; i++) {
        const arg = args[i];
        if (arg == null)
            continue;
        let toAdd;
        switch (typeof arg) {
            case "boolean":
                break;
            case "object": {
                if (Array.isArray(arg)) {
                    toAdd = (0, exports.classnames)(arg);
                }
                else {
                    (0, assert_1.assert)(!(0, typeGuard_1.typeGuard)(arg, false));
                    if (process.env.NODE_ENV !== "production" &&
                        arg.styles !== undefined &&
                        arg.name !== undefined) {
                        console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n" +
                            "`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
                    }
                    toAdd = "";
                    for (const k in arg) {
                        if (arg[k] && k) {
                            toAdd && (toAdd += " ");
                            toAdd += k;
                        }
                    }
                }
                break;
            }
            default: {
                toAdd = arg;
            }
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
exports.classnames = classnames;
}(classnames));

var require$$1$3 = /*@__PURE__*/getAugmentedNamespace(emotionSerialize_esm);

var require$$2$2 = /*@__PURE__*/getAugmentedNamespace(emotionUtils_esm);

var useGuaranteedMemo$1 = {};

Object.defineProperty(useGuaranteedMemo$1, "__esModule", { value: true });
useGuaranteedMemo$1.useGuaranteedMemo = void 0;
const react_1$4 = React__default;
/** Like react's useMemo but with guarantee that the fn
 * won't be invoked again if deps hasn't change */
function useGuaranteedMemo(fn, deps) {
    const ref = (0, react_1$4.useRef)();
    if (!ref.current ||
        deps.length !== ref.current.prevDeps.length ||
        ref.current.prevDeps.map((v, i) => v === deps[i]).indexOf(false) >= 0) {
        ref.current = {
            "v": fn(),
            "prevDeps": [...deps],
        };
    }
    return ref.current.v;
}
useGuaranteedMemo$1.useGuaranteedMemo = useGuaranteedMemo;

var cache = {};

var require$$2$1 = /*@__PURE__*/getAugmentedNamespace(emotionCache_esm);

var __importDefault$8 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(cache, "__esModule", { value: true });
cache.TssCacheProvider = cache.useTssEmotionCache = cache.getTssDefaultEmotionCache = cache.getDoExistsTssDefaultEmotionCacheMemoizedValue = void 0;
const jsx_runtime_1$2 = require$$2$3;
const react_1$3 = React__default;
const cache_1$1 = __importDefault$8(require$$2$1);
const { getDoExistsTssDefaultEmotionCacheMemoizedValue, getTssDefaultEmotionCache, reactContext, } = (() => {
    const propertyKey = "__tss-react_context";
    const peerDepObj = 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    react_1$3.createContext;
    let sharedContext = peerDepObj["__tss-react_context"];
    if (sharedContext === undefined) {
        const { getTssDefaultEmotionCache, getDoExistsTssDefaultEmotionCacheMemoizedValue, } = (() => {
            let cache = undefined;
            /**
             * Lazily initialized singleton
             * If doReset is set to true the memoized instance will be
             * discarded and a new one created.
             * */
            function getTssDefaultEmotionCache(params) {
                const { doReset = false } = params !== null && params !== void 0 ? params : {};
                if (doReset) {
                    cache = undefined;
                }
                if (cache === undefined) {
                    cache = (0, cache_1$1.default)({ "key": "tss" });
                }
                return cache;
            }
            return {
                getTssDefaultEmotionCache,
                "getDoExistsTssDefaultEmotionCacheMemoizedValue": () => cache !== undefined,
            };
        })();
        sharedContext = {
            getTssDefaultEmotionCache,
            getDoExistsTssDefaultEmotionCacheMemoizedValue,
            "reactContext": (0, react_1$3.createContext)(undefined),
        };
        Object.defineProperty(peerDepObj, propertyKey, {
            "configurable": false,
            "enumerable": false,
            "writable": false,
            "value": sharedContext,
        });
    }
    return sharedContext;
})();
cache.getDoExistsTssDefaultEmotionCacheMemoizedValue = getDoExistsTssDefaultEmotionCacheMemoizedValue;
cache.getTssDefaultEmotionCache = getTssDefaultEmotionCache;
function useTssEmotionCache() {
    const cacheExplicitlyProvidedForTss = (0, react_1$3.useContext)(reactContext);
    return cacheExplicitlyProvidedForTss !== null && cacheExplicitlyProvidedForTss !== void 0 ? cacheExplicitlyProvidedForTss : getTssDefaultEmotionCache();
}
cache.useTssEmotionCache = useTssEmotionCache;
function TssCacheProvider(props) {
    const { children, value } = props;
    return ((0, jsx_runtime_1$2.jsx)(reactContext.Provider, Object.assign({ value: value }, { children: children })));
}
cache.TssCacheProvider = TssCacheProvider;

var types = {};

Object.defineProperty(types, "__esModule", { value: true });
types.matchCSSObject = void 0;
function matchCSSObject(arg) {
    return (arg instanceof Object &&
        !("styles" in arg) &&
        !("length" in arg) &&
        !("__emotion_styles" in arg));
}
types.matchCSSObject = matchCSSObject;

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCssAndCx = exports.createCssAndCx = void 0;
const classnames_1 = classnames;
const serialize_1 = require$$1$3;
const utils_1 = require$$2$2;
const useGuaranteedMemo_1 = useGuaranteedMemo$1;
const cache_1 = cache;
const types_1 = types;
exports.createCssAndCx = (() => {
    function merge(registered, css, className) {
        const registeredStyles = [];
        const rawClassName = (0, utils_1.getRegisteredStyles)(registered, registeredStyles, className);
        if (registeredStyles.length < 2) {
            return className;
        }
        return rawClassName + css(registeredStyles);
    }
    function createCssAndCx(params) {
        const { cache } = params;
        const css = (...args) => {
            const serialized = (0, serialize_1.serializeStyles)(args, cache.registered);
            (0, utils_1.insertStyles)(cache, serialized, false);
            const className = `${cache.key}-${serialized.name}`;
            scope: {
                const arg = args[0];
                if (!(0, types_1.matchCSSObject)(arg)) {
                    break scope;
                }
                increaseSpecificityToTakePrecedenceOverMediaQuerries.saveClassNameCSSObjectMapping(cache, className, arg);
            }
            return className;
        };
        const cx = (...args) => {
            const className = (0, classnames_1.classnames)(args);
            const feat27FixedClassnames = increaseSpecificityToTakePrecedenceOverMediaQuerries.fixClassName(cache, className, css);
            return merge(cache.registered, css, feat27FixedClassnames);
            //return merge(cache.registered, css, className);
        };
        return { css, cx };
    }
    return { createCssAndCx };
})().createCssAndCx;
/** Will pickup the contextual cache if any */
function useCssAndCx() {
    const cache = (0, cache_1.useTssEmotionCache)();
    const { css, cx } = (0, useGuaranteedMemo_1.useGuaranteedMemo)(() => (0, exports.createCssAndCx)({ cache }), [cache]);
    return { css, cx };
}
exports.useCssAndCx = useCssAndCx;
// https://github.com/garronej/tss-react/issues/27
const increaseSpecificityToTakePrecedenceOverMediaQuerries = (() => {
    const cssObjectMapByCache = new WeakMap();
    return {
        "saveClassNameCSSObjectMapping": (cache, className, cssObject) => {
            let cssObjectMap = cssObjectMapByCache.get(cache);
            if (cssObjectMap === undefined) {
                cssObjectMap = new Map();
                cssObjectMapByCache.set(cache, cssObjectMap);
            }
            cssObjectMap.set(className, cssObject);
        },
        "fixClassName": (() => {
            function fix(classNameCSSObjects) {
                let isThereAnyMediaQueriesInPreviousClasses = false;
                return classNameCSSObjects.map(([className, cssObject]) => {
                    if (cssObject === undefined) {
                        return className;
                    }
                    let out;
                    if (!isThereAnyMediaQueriesInPreviousClasses) {
                        out = className;
                        for (const key in cssObject) {
                            if (key.startsWith("@media")) {
                                isThereAnyMediaQueriesInPreviousClasses = true;
                                break;
                            }
                        }
                    }
                    else {
                        out = {
                            "&&": cssObject,
                        };
                    }
                    return out;
                });
            }
            return (cache, className, css) => {
                const cssObjectMap = cssObjectMapByCache.get(cache);
                return (0, classnames_1.classnames)(fix(className
                    .split(" ")
                    .map(className => [
                    className,
                    cssObjectMap === null || cssObjectMap === void 0 ? void 0 : cssObjectMap.get(className),
                ])).map(classNameOrCSSObject => typeof classNameOrCSSObject === "string"
                    ? classNameOrCSSObject
                    : css(classNameOrCSSObject)));
            };
        })(),
    };
})();
}(cssAndCx));

var mergeClasses$1 = {};

var objectKeys$1 = {};

Object.defineProperty(objectKeys$1, "__esModule", { value: true });
objectKeys$1.objectKeys = void 0;
/** Object.keys() with types */
function objectKeys(o) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(o);
}
objectKeys$1.objectKeys = objectKeys;

var getDependencyArrayRef$1 = {};

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(getDependencyArrayRef$1, "__esModule", { value: true });
getDependencyArrayRef$1.getDependencyArrayRef = void 0;
/**
 * useEffect(
 *    ()=> { ... },
 *    [ { "foo": "bar" } ]
 * )
 * => The callback will be invoked every render.
 * because { "foo": "bar" } is a new instance every render.
 *
 * useEffect(
 *    ()=> { ... },
 *    [ getDependencyArrayRef({ "foo": "bar" }) ]
 * );
 * => The callback will only be invoked once.
 *
 * The optimization will be enabled only if obj is
 * of the form Record<string, string | number | undefined | null>
 * overwise the object is returned (the function is the identity function).
 */
function getDependencyArrayRef(obj) {
    if (!(obj instanceof Object) || typeof obj === "function") {
        return obj;
    }
    const arr = [];
    for (const key in obj) {
        const value = obj[key];
        const typeofValue = typeof value;
        if (!(typeofValue === "string" ||
            (typeofValue === "number" && !isNaN(value)) ||
            typeofValue === "boolean" ||
            value === undefined ||
            value === null)) {
            return obj;
        }
        arr.push(`${key}:${typeofValue}_${value}`);
    }
    return "xSqLiJdLMd9s" + arr.join("|");
}
getDependencyArrayRef$1.getDependencyArrayRef = getDependencyArrayRef;

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(mergeClasses$1, "__esModule", { value: true });
mergeClasses$1.useMergedClasses = mergeClasses$1.mergeClasses = void 0;
const objectKeys_1$1 = objectKeys$1;
const getDependencyArrayRef_1$1 = getDependencyArrayRef$1;
const cssAndCx_1$1 = cssAndCx;
const react_1$2 = React__default;
function mergeClasses(classesFromUseStyles, classesFromProps, cx) {
    //NOTE: We use this test to be resilient in case classesFromProps is not of the expected type.
    if (!(classesFromProps instanceof Object)) {
        return classesFromUseStyles;
    }
    const out = {};
    (0, objectKeys_1$1.objectKeys)(classesFromUseStyles).forEach(ruleName => (out[ruleName] = cx(classesFromUseStyles[ruleName], classesFromProps[ruleName])));
    (0, objectKeys_1$1.objectKeys)(classesFromProps).forEach(ruleName => {
        if (ruleName in classesFromUseStyles) {
            return;
        }
        const className = classesFromProps[ruleName];
        //...Same here, that why we don't do className === undefined
        if (typeof className !== "string") {
            return;
        }
        out[ruleName] = className;
    });
    return out;
}
mergeClasses$1.mergeClasses = mergeClasses;
function useMergedClasses(classes, classesOv) {
    const { cx } = (0, cssAndCx_1$1.useCssAndCx)();
    return (0, react_1$2.useMemo)(() => mergeClasses(classes, classesOv, cx), [classes, (0, getDependencyArrayRef_1$1.getDependencyArrayRef)(classesOv), cx]);
}
mergeClasses$1.useMergedClasses = useMergedClasses;

var makeStyles$1 = {};

var Object_fromEntries = {};

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(Object_fromEntries, "__esModule", { value: true });
Object_fromEntries.objectFromEntries = void 0;
Object_fromEntries.objectFromEntries = !Object
    .fromEntries
    ? (entries) => {
        if (!entries || !entries[Symbol.iterator]) {
            throw new Error("Object.fromEntries() requires a single iterable argument");
        }
        const o = {};
        Object.keys(entries).forEach(key => {
            const [k, v] = entries[key];
            o[k] = v;
        });
        return o;
    }
    : Object.fromEntries;

Object.defineProperty(makeStyles$1, "__esModule", { value: true });
makeStyles$1.createMakeStyles = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1$1 = React__default;
const Object_fromEntries_1 = Object_fromEntries;
const objectKeys_1 = objectKeys$1;
const cssAndCx_1 = cssAndCx;
const getDependencyArrayRef_1 = getDependencyArrayRef$1;
const typeGuard_1 = typeGuard$1;
const cache_1 = cache;
const assert_1 = assert$2;
const mergeClasses_1 = mergeClasses$1;
const getCounter = (() => {
    let counter = 0;
    return () => counter++;
})();
function createMakeStyles(params) {
    const { useTheme } = params;
    /** returns useStyle. */
    function makeStyles(params) {
        const { name: nameOrWrappedName } = params !== null && params !== void 0 ? params : {};
        const name = typeof nameOrWrappedName !== "object"
            ? nameOrWrappedName
            : Object.keys(nameOrWrappedName)[0];
        return function (cssObjectByRuleNameOrGetCssObjectByRuleName) {
            const getCssObjectByRuleName = typeof cssObjectByRuleNameOrGetCssObjectByRuleName ===
                "function"
                ? cssObjectByRuleNameOrGetCssObjectByRuleName
                : () => cssObjectByRuleNameOrGetCssObjectByRuleName;
            const outerCounter = getCounter();
            return function useStyles(params, styleOverrides) {
                var _a, _b;
                const theme = useTheme();
                const { css, cx } = (0, cssAndCx_1.useCssAndCx)();
                const cache = (0, cache_1.useTssEmotionCache)();
                let classes = (0, react_1$1.useMemo)(() => {
                    const refClassesCache = {};
                    const refClasses = typeof Proxy !== "undefined" &&
                        new Proxy({}, {
                            "get": (_target, propertyKey) => {
                                if (typeof propertyKey === "symbol") {
                                    (0, assert_1.assert)(false);
                                }
                                return (refClassesCache[propertyKey] = `${cache.key}-${outerCounter}${name !== undefined ? `-${name}` : ""}-${propertyKey}-ref`);
                            },
                        });
                    const cssObjectByRuleName = getCssObjectByRuleName(theme, params, refClasses || {});
                    const classes = (0, Object_fromEntries_1.objectFromEntries)((0, objectKeys_1.objectKeys)(cssObjectByRuleName).map(ruleName => {
                        const cssObject = cssObjectByRuleName[ruleName];
                        if (!cssObject.label) {
                            cssObject.label = `${name !== undefined ? `${name}-` : ""}${ruleName}`;
                        }
                        return [
                            ruleName,
                            `${css(cssObject)}${(0, typeGuard_1.typeGuard)(ruleName, ruleName in refClassesCache)
                                ? ` ${refClassesCache[ruleName]}`
                                : ""}`,
                        ];
                    }));
                    (0, objectKeys_1.objectKeys)(refClassesCache).forEach(ruleName => {
                        if (ruleName in classes) {
                            return;
                        }
                        classes[ruleName] =
                            refClassesCache[ruleName];
                    });
                    return classes;
                }, [cache, css, cx, theme, (0, getDependencyArrayRef_1.getDependencyArrayRef)(params)]);
                const propsClasses = styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.props.classes;
                {
                    classes = (0, react_1$1.useMemo)(() => (0, mergeClasses_1.mergeClasses)(classes, propsClasses, cx), [classes, (0, getDependencyArrayRef_1.getDependencyArrayRef)(propsClasses), cx]);
                }
                {
                    let cssObjectByRuleNameOrGetCssObjectByRuleName = undefined;
                    try {
                        cssObjectByRuleNameOrGetCssObjectByRuleName =
                            name !== undefined
                                ? (_b = (_a = theme.components) === null || _a === void 0 ? void 0 : _a[name]) === null || _b === void 0 ? void 0 : _b.styleOverrides
                                : undefined;
                        // eslint-disable-next-line no-empty
                    }
                    catch (_c) { }
                    const themeClasses = (0, react_1$1.useMemo)(() => {
                        if (!cssObjectByRuleNameOrGetCssObjectByRuleName) {
                            return undefined;
                        }
                        const themeClasses = {};
                        for (const ruleName in cssObjectByRuleNameOrGetCssObjectByRuleName) {
                            const cssObjectOrGetCssObject = cssObjectByRuleNameOrGetCssObjectByRuleName[ruleName];
                            if (!(cssObjectOrGetCssObject instanceof Object)) {
                                continue;
                            }
                            themeClasses[ruleName] = css(typeof cssObjectOrGetCssObject === "function"
                                ? cssObjectOrGetCssObject(Object.assign({ theme, "ownerState": styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.ownerState }, styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.props))
                                : cssObjectOrGetCssObject);
                        }
                        return themeClasses;
                    }, [
                        cssObjectByRuleNameOrGetCssObjectByRuleName ===
                            undefined
                            ? undefined
                            : JSON.stringify(cssObjectByRuleNameOrGetCssObjectByRuleName),
                        (0, getDependencyArrayRef_1.getDependencyArrayRef)(styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.props),
                        (0, getDependencyArrayRef_1.getDependencyArrayRef)(styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.ownerState),
                        css,
                    ]);
                    classes = (0, react_1$1.useMemo)(() => (0, mergeClasses_1.mergeClasses)(classes, themeClasses, cx), [classes, themeClasses, cx]);
                }
                return {
                    classes,
                    theme,
                    css,
                    cx,
                };
            };
        };
    }
    function useStyles() {
        const theme = useTheme();
        const { css, cx } = (0, cssAndCx_1.useCssAndCx)();
        return { theme, css, cx };
    }
    return { makeStyles, useStyles };
}
makeStyles$1.createMakeStyles = createMakeStyles;

var withStyles = {};

var capitalize$2 = {};

Object.defineProperty(capitalize$2, "__esModule", { value: true });
capitalize$2.capitalize = void 0;
/** @see <https://docs.tsafe.dev/capitalize> */
function capitalize$1(str) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (str.charAt(0).toUpperCase() + str.slice(1));
}
capitalize$2.capitalize = capitalize$1;

var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(withStyles, "__esModule", { value: true });
withStyles.createWithStyles = void 0;
const jsx_runtime_1$1 = require$$2$3;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = React__default;
const makeStyles_1 = makeStyles$1;
const capitalize_1 = capitalize$2;
function createWithStyles(params) {
    const { useTheme } = params;
    const { makeStyles } = (0, makeStyles_1.createMakeStyles)({ useTheme });
    function withStyles(Component, cssObjectByRuleNameOrGetCssObjectByRuleName, params) {
        const Component_ = typeof Component === "string"
            ? (() => {
                const tag = Component;
                const Out = function (_a) {
                    var { children } = _a, props = __rest(_a, ["children"]);
                    return (0, react_1.createElement)(tag, props, children);
                };
                Object.defineProperty(Out, "name", {
                    "value": (0, capitalize_1.capitalize)(tag),
                });
                return Out;
            })()
            : Component;
        const name = (() => {
            const { name } = Component_;
            return typeof name === "string" ? name : undefined;
        })();
        const useStyles = makeStyles((params === null || params === void 0 ? void 0 : params.name) !== undefined ? params : { name })(typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function"
            ? (theme, props, classes) => incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName(theme, props, classes))
            : incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const Out = (0, react_1.forwardRef)(function (props, ref) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { className, classes: _classes } = props, rest = __rest(props, ["className", "classes"]);
            const { classes, cx } = useStyles(props, { props });
            return ((0, jsx_runtime_1$1.jsx)(Component_, Object.assign({ ref: ref, className: cx(classes.root, className) }, (typeof Component === "string" ? {} : { classes }), rest)));
        });
        if (name !== undefined) {
            Object.defineProperty(Out, "name", {
                "value": `${name}WithStyles`,
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Out;
    }
    return { withStyles };
}
withStyles.createWithStyles = createWithStyles;
function incorporateMediaQueries(cssObjectByRuleNameWithMediaQueries) {
    const cssObjectByRuleName = {};
    const cssObjectByRuleNameWithMediaQueriesByMediaQuery = {};
    Object.keys(cssObjectByRuleNameWithMediaQueries).forEach(ruleNameOrMediaQuery => ((ruleNameOrMediaQuery.startsWith("@media")
        ? cssObjectByRuleNameWithMediaQueriesByMediaQuery
        : cssObjectByRuleName)[ruleNameOrMediaQuery] =
        cssObjectByRuleNameWithMediaQueries[ruleNameOrMediaQuery]));
    Object.keys(cssObjectByRuleNameWithMediaQueriesByMediaQuery).forEach(mediaQuery => {
        const cssObjectByRuleNameBis = cssObjectByRuleNameWithMediaQueriesByMediaQuery[mediaQuery];
        Object.keys(cssObjectByRuleNameBis).forEach(ruleName => {
            var _a;
            return (cssObjectByRuleName[ruleName] = Object.assign(Object.assign({}, ((_a = cssObjectByRuleName[ruleName]) !== null && _a !== void 0 ? _a : {})), { [mediaQuery]: cssObjectByRuleNameBis[ruleName] }));
        });
    });
    return cssObjectByRuleName;
}

var require$$4 = /*@__PURE__*/getAugmentedNamespace(emotionReact_esm);

var GlobalStyles$2 = {};

var __createBinding$2 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$2 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$2 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$2(result, mod, k);
    __setModuleDefault$2(result, mod);
    return result;
};
Object.defineProperty(GlobalStyles$2, "__esModule", { value: true });
GlobalStyles$2.GlobalStyles = void 0;
const jsx_runtime_1 = require$$2$3;
const reactEmotion = __importStar$2(require$$4);
function GlobalStyles$1(props) {
    const { styles } = props;
    return (0, jsx_runtime_1.jsx)(reactEmotion.Global, { styles: reactEmotion.css(styles) });
}
GlobalStyles$2.GlobalStyles = GlobalStyles$1;

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMakeAndWithStyles = exports.TssCacheProvider = exports.getTssDefaultEmotionCache = exports.GlobalStyles = exports.keyframes = exports.createWithStyles = exports.createMakeStyles = exports.useMergedClasses = exports.useCssAndCx = void 0;
/** @see <https://docs.tss-react.dev/api-references> */
var cssAndCx_1 = cssAndCx;
Object.defineProperty(exports, "useCssAndCx", { enumerable: true, get: function () { return cssAndCx_1.useCssAndCx; } });
var mergeClasses_1 = mergeClasses$1;
Object.defineProperty(exports, "useMergedClasses", { enumerable: true, get: function () { return mergeClasses_1.useMergedClasses; } });
const makeStyles_1 = makeStyles$1;
Object.defineProperty(exports, "createMakeStyles", { enumerable: true, get: function () { return makeStyles_1.createMakeStyles; } });
const withStyles_1 = withStyles;
Object.defineProperty(exports, "createWithStyles", { enumerable: true, get: function () { return withStyles_1.createWithStyles; } });
/** @see <https://docs.tss-react.dev/api-references/keyframes> */
var react_1 = require$$4;
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return react_1.keyframes; } });
/** @see <https://docs.tss-react.dev/api-references/globalstyles> */
var GlobalStyles_1 = GlobalStyles$2;
Object.defineProperty(exports, "GlobalStyles", { enumerable: true, get: function () { return GlobalStyles_1.GlobalStyles; } });
/** @see <https://docs.tss-react.dev/cache> */
var cache_1 = cache;
Object.defineProperty(exports, "getTssDefaultEmotionCache", { enumerable: true, get: function () { return cache_1.getTssDefaultEmotionCache; } });
Object.defineProperty(exports, "TssCacheProvider", { enumerable: true, get: function () { return cache_1.TssCacheProvider; } });
/** @see <https://docs.tss-react.dev/api-references/makestyles-usestyles> */
function createMakeAndWithStyles(params) {
    return Object.assign(Object.assign({}, (0, makeStyles_1.createMakeStyles)(params)), (0, withStyles_1.createWithStyles)(params));
}
exports.createMakeAndWithStyles = createMakeAndWithStyles;
}(tssReact));

// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.

var _a$2;
var makeStyles = (_a$2 = tssReact.createMakeAndWithStyles({
    useTheme: useTheme
}), _a$2.makeStyles); _a$2.withStyles;

function getIconButtonUtilityClass(slot) {
  return generateUtilityClass('MuiIconButton', slot);
}
const iconButtonClasses = generateUtilityClasses('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
var iconButtonClasses$1 = iconButtonClasses;

const _excluded$1j = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];

const useUtilityClasses$V = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${capitalize$3(color)}`, edge && `edge${capitalize$3(edge)}`, `size${capitalize$3(size)}`]
  };
  return composeClasses(slots, getIconButtonUtilityClass, classes);
};

const IconButtonRoot = styled$1(ButtonBase$1, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${capitalize$3(ownerState.color)}`], ownerState.edge && styles[`edge${capitalize$3(ownerState.edge)}`], styles[`size${capitalize$3(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: theme.palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => _extends$P({}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && _extends$P({
  color: theme.palette[ownerState.color].main
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: alpha$2(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}), ownerState.size === 'small' && {
  padding: 5,
  fontSize: theme.typography.pxToRem(18)
}, ownerState.size === 'large' && {
  padding: 12,
  fontSize: theme.typography.pxToRem(28)
}, {
  [`&.${iconButtonClasses$1.disabled}`]: {
    backgroundColor: 'transparent',
    color: theme.palette.action.disabled
  }
}));
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

const IconButton$1 = /*#__PURE__*/React$d.forwardRef(function IconButton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiIconButton'
  });

  const {
    edge = false,
    children,
    className,
    color = 'default',
    disabled = false,
    disableFocusRipple = false,
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1j);

  const ownerState = _extends$P({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });

  const classes = useUtilityClasses$V(ownerState);
  return /*#__PURE__*/jsx$1(IconButtonRoot, _extends$P({
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? IconButton$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes$1.node, props => {
    const found = React$d.Children.toArray(props.children).some(child => /*#__PURE__*/React$d.isValidElement(child) && child.props.onClick);

    if (found) {
      return new Error(['MUI: You are providing an onClick event listener to a child of a button element.', 'Prefer applying it to the IconButton directly.', 'This guarantees that the whole <button> will be responsive to click events.'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['inherit', 'default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes$1.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes$1.oneOf(['end', 'start', false]),

  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['small', 'medium', 'large']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var IconButton$2 = IconButton$1;

function getTypographyUtilityClass(slot) {
  return generateUtilityClass('MuiTypography', slot);
}
generateUtilityClasses('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);

const _excluded$1i = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];

const useUtilityClasses$U = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${capitalize$3(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return composeClasses(slots, getTypographyUtilityClass, classes);
};

const TypographyRoot = styled$1('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${capitalize$3(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  margin: 0
}, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6

const colorTransformations$1 = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors$1 = color => {
  return colorTransformations$1[color] || color;
};

const Typography = /*#__PURE__*/React$d.forwardRef(function Typography(inProps, ref) {
  const themeProps = useThemeProps({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors$1(themeProps.color);
  const props = extendSxProp(_extends$P({}, themeProps, {
    color
  }));

  const {
    align = 'inherit',
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = 'body1',
    variantMapping = defaultVariantMapping
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1i);

  const ownerState = _extends$P({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });

  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses$U(ownerState);
  return /*#__PURE__*/jsx$1(TypographyRoot, _extends$P({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: clsx(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes$1.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes$1.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes$1.bool,

  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']), PropTypes$1.string]),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .object
} : void 0;
var Typography$1 = Typography;

function getAppBarUtilityClass(slot) {
  return generateUtilityClass('MuiAppBar', slot);
}
generateUtilityClasses('MuiAppBar', ['root', 'positionFixed', 'positionAbsolute', 'positionSticky', 'positionStatic', 'positionRelative', 'colorDefault', 'colorPrimary', 'colorSecondary', 'colorInherit', 'colorTransparent']);

const _excluded$1h = ["className", "color", "enableColorOnDark", "position"];

const useUtilityClasses$T = ownerState => {
  const {
    color,
    position,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$3(color)}`, `position${capitalize$3(position)}`]
  };
  return composeClasses(slots, getAppBarUtilityClass, classes);
};

const AppBarRoot = styled$1(Paper$2, {
  name: 'MuiAppBar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`position${capitalize$3(ownerState.position)}`], styles[`color${capitalize$3(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return _extends$P({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, ownerState.position === 'fixed' && {
    position: 'fixed',
    zIndex: theme.zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0,
    '@media print': {
      // Prevent the app bar to be visible on each printed page.
      position: 'absolute'
    }
  }, ownerState.position === 'absolute' && {
    position: 'absolute',
    zIndex: theme.zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0
  }, ownerState.position === 'sticky' && {
    // ⚠️ sticky is not supported by IE11.
    position: 'sticky',
    zIndex: theme.zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0
  }, ownerState.position === 'static' && {
    position: 'static'
  }, ownerState.position === 'relative' && {
    position: 'relative'
  }, ownerState.color === 'default' && {
    backgroundColor: backgroundColorDefault,
    color: theme.palette.getContrastText(backgroundColorDefault)
  }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
    backgroundColor: theme.palette[ownerState.color].main,
    color: theme.palette[ownerState.color].contrastText
  }, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, ownerState.color === 'transparent' && _extends$P({
    backgroundColor: 'transparent',
    color: 'inherit'
  }, theme.palette.mode === 'dark' && {
    backgroundImage: 'none'
  }));
});
const AppBar = /*#__PURE__*/React$d.forwardRef(function AppBar(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiAppBar'
  });

  const {
    className,
    color = 'primary',
    enableColorOnDark = false,
    position = 'fixed'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1h);

  const ownerState = _extends$P({}, props, {
    color,
    position,
    enableColorOnDark
  });

  const classes = useUtilityClasses$T(ownerState);
  return /*#__PURE__*/jsx$1(AppBarRoot, _extends$P({
    square: true,
    component: "header",
    ownerState: ownerState,
    elevation: 4,
    className: clsx(classes.root, className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? AppBar.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']), PropTypes$1.string]),

  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: PropTypes$1.bool,

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: PropTypes$1.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var AppBar$1 = AppBar;

const PopperRoot = styled$1(PopperUnstyled$1, {
  name: 'MuiPopper',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/components/autocomplete/)
 * - [Menus](https://mui.com/components/menus/)
 * - [Popper](https://mui.com/components/popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/api/popper/)
 */

const Popper = /*#__PURE__*/React$d.forwardRef(function Popper(inProps, ref) {
  const theme = useTheme$2();
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPopper'
  });
  return /*#__PURE__*/jsx$1(PopperRoot, _extends$P({
    direction: theme == null ? void 0 : theme.direction
  }, props, {
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? Popper.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.object, PropTypes$1.func]),

  /**
   * Popper render function or node.
   */
  children: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.node, PropTypes$1.func]),

  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes$1.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes$1.arrayOf(PropTypes$1.shape({
    data: PropTypes$1.object,
    effect: PropTypes$1.func,
    enabled: PropTypes$1.bool,
    fn: PropTypes$1.func,
    name: PropTypes$1.any,
    options: PropTypes$1.object,
    phase: PropTypes$1.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: PropTypes$1.arrayOf(PropTypes$1.string),
    requiresIfExists: PropTypes$1.arrayOf(PropTypes$1.string)
  })),

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes$1.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes$1.shape({
    modifiers: PropTypes$1.array,
    onFirstUpdate: PropTypes$1.func,
    placement: PropTypes$1.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: PropTypes$1.oneOf(['absolute', 'fixed'])
  }),

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType$1,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes$1.bool
} : void 0;
var Popper$1 = Popper;

var CancelIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

function getChipUtilityClass(slot) {
  return generateUtilityClass('MuiChip', slot);
}
const chipClasses = generateUtilityClasses('MuiChip', ['root', 'sizeSmall', 'sizeMedium', 'colorPrimary', 'colorSecondary', 'disabled', 'clickable', 'clickableColorPrimary', 'clickableColorSecondary', 'deletable', 'deletableColorPrimary', 'deletableColorSecondary', 'outlined', 'filled', 'outlinedPrimary', 'outlinedSecondary', 'avatar', 'avatarSmall', 'avatarMedium', 'avatarColorPrimary', 'avatarColorSecondary', 'icon', 'iconSmall', 'iconMedium', 'iconColorPrimary', 'iconColorSecondary', 'label', 'labelSmall', 'labelMedium', 'deleteIcon', 'deleteIconSmall', 'deleteIconMedium', 'deleteIconColorPrimary', 'deleteIconColorSecondary', 'deleteIconOutlinedColorPrimary', 'deleteIconOutlinedColorSecondary', 'focusVisible']);
var chipClasses$1 = chipClasses;

const _excluded$1g = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"];

const useUtilityClasses$S = ownerState => {
  const {
    classes,
    disabled,
    size,
    color,
    onDelete,
    clickable,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, disabled && 'disabled', `size${capitalize$3(size)}`, `color${capitalize$3(color)}`, clickable && 'clickable', clickable && `clickableColor${capitalize$3(color)}`, onDelete && 'deletable', onDelete && `deletableColor${capitalize$3(color)}`, `${variant}${capitalize$3(color)}`],
    label: ['label', `label${capitalize$3(size)}`],
    avatar: ['avatar', `avatar${capitalize$3(size)}`, `avatarColor${capitalize$3(color)}`],
    icon: ['icon', `icon${capitalize$3(size)}`, `iconColor${capitalize$3(color)}`],
    deleteIcon: ['deleteIcon', `deleteIcon${capitalize$3(size)}`, `deleteIconColor${capitalize$3(color)}`, `deleteIconOutlinedColor${capitalize$3(color)}`]
  };
  return composeClasses(slots, getChipUtilityClass, classes);
};

const ChipRoot = styled$1('div', {
  name: 'MuiChip',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      color,
      clickable,
      onDelete,
      size,
      variant
    } = ownerState;
    return [{
      [`& .${chipClasses$1.avatar}`]: styles.avatar
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatar${capitalize$3(size)}`]
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatarColor${capitalize$3(color)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles.icon
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`icon${capitalize$3(size)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`iconColor${capitalize$3(color)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles.deleteIcon
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIcon${capitalize$3(size)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIconColor${capitalize$3(color)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIconOutlinedColor${capitalize$3(color)}`]
    }, styles.root, styles[`size${capitalize$3(size)}`], styles[`color${capitalize$3(color)}`], clickable && styles.clickable, clickable && color !== 'default' && styles[`clickableColor${capitalize$3(color)})`], onDelete && styles.deletable, onDelete && color !== 'default' && styles[`deletableColor${capitalize$3(color)}`], styles[variant], variant === 'outlined' && styles[`outlined${capitalize$3(color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const deleteIconColor = alpha$2(theme.palette.text.primary, 0.26);
  return _extends$P({
    maxWidth: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    // label will inherit this from root, then `clickable` class overrides this for both
    cursor: 'default',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: 'none',
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    [`&.${chipClasses$1.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`& .${chipClasses$1.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${chipClasses$1.avatarColorPrimary}`]: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark
    },
    [`& .${chipClasses$1.avatarColorSecondary}`]: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.dark
    },
    [`& .${chipClasses$1.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    },
    [`& .${chipClasses$1.icon}`]: _extends$P({
      color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    }, ownerState.size === 'small' && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, ownerState.color !== 'default' && {
      color: 'inherit'
    }),
    [`& .${chipClasses$1.deleteIcon}`]: _extends$P({
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      fontSize: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: alpha$2(deleteIconColor, 0.4)
      }
    }, ownerState.size === 'small' && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, ownerState.color !== 'default' && {
      color: alpha$2(theme.palette[ownerState.color].contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette[ownerState.color].contrastText
      }
    })
  }, ownerState.size === 'small' && {
    height: 24
  }, ownerState.color !== 'default' && {
    backgroundColor: theme.palette[ownerState.color].main,
    color: theme.palette[ownerState.color].contrastText
  }, ownerState.onDelete && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: alpha$2(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  }, ownerState.onDelete && ownerState.color !== 'default' && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: theme.palette[ownerState.color].dark
    }
  });
}, ({
  theme,
  ownerState
}) => _extends$P({}, ownerState.clickable && {
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha$2(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: alpha$2(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  },
  '&:active': {
    boxShadow: theme.shadows[1]
  }
}, ownerState.clickable && ownerState.color !== 'default' && {
  [`&:hover, &.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette[ownerState.color].dark
  }
}), ({
  theme,
  ownerState
}) => _extends$P({}, ownerState.variant === 'outlined' && {
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: theme.palette.action.hover
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`& .${chipClasses$1.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses$1.deleteIconSmall}`]: {
    marginRight: 3
  }
}, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
  color: theme.palette[ownerState.color].main,
  border: `1px solid ${alpha$2(theme.palette[ownerState.color].main, 0.7)}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: alpha$2(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: alpha$2(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    color: alpha$2(theme.palette[ownerState.color].main, 0.7),
    '&:hover, &:active': {
      color: theme.palette[ownerState.color].main
    }
  }
}));
const ChipLabel = styled$1('span', {
  name: 'MuiChip',
  slot: 'Label',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      size
    } = ownerState;
    return [styles.label, styles[`label${capitalize$3(size)}`]];
  }
})(({
  ownerState
}) => _extends$P({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: 'nowrap'
}, ownerState.size === 'small' && {
  paddingLeft: 8,
  paddingRight: 8
}));

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


const Chip$1 = /*#__PURE__*/React$d.forwardRef(function Chip(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChip'
  });

  const {
    avatar: avatarProp,
    className,
    clickable: clickableProp,
    color = 'default',
    component: ComponentProp,
    deleteIcon: deleteIconProp,
    disabled = false,
    icon: iconProp,
    label,
    onClick,
    onDelete,
    onKeyDown,
    onKeyUp,
    size = 'medium',
    variant = 'filled'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1g);

  const chipRef = React$d.useRef(null);
  const handleRef = useForkRef(chipRef, ref);

  const handleDeleteIconClick = event => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  const handleKeyDown = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // Will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleKeyUp = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const small = size === 'small';
  const component = clickable || onDelete ? ButtonBase$1 : ComponentProp || 'div';

  const ownerState = _extends$P({}, props, {
    component,
    disabled,
    size,
    color,
    onDelete: !!onDelete,
    clickable,
    variant
  });

  const classes = useUtilityClasses$S(ownerState);
  const moreProps = component === ButtonBase$1 ? _extends$P({
    component: ComponentProp || 'div',
    focusVisibleClassName: classes.focusVisible
  }, onDelete && {
    disableRipple: true
  }) : {};
  let deleteIcon = null;

  if (onDelete) {
    const customClasses = clsx(color !== 'default' && (variant === 'outlined' ? classes[`deleteIconOutlinedColor${capitalize$3(color)}`] : classes[`deleteIconColor${capitalize$3(color)}`]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/React$d.isValidElement(deleteIconProp) ? /*#__PURE__*/React$d.cloneElement(deleteIconProp, {
      className: clsx(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/jsx$1(CancelIcon, {
      className: clsx(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  let avatar = null;

  if (avatarProp && /*#__PURE__*/React$d.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/React$d.cloneElement(avatarProp, {
      className: clsx(classes.avatar, avatarProp.props.className)
    });
  }

  let icon = null;

  if (iconProp && /*#__PURE__*/React$d.isValidElement(iconProp)) {
    icon = /*#__PURE__*/React$d.cloneElement(iconProp, {
      className: clsx(classes.icon, iconProp.props.className)
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('MUI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/jsxs(ChipRoot, _extends$P({
    as: component,
    className: clsx(classes.root, className),
    disabled: clickable && disabled ? true : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef,
    ownerState: ownerState
  }, moreProps, other, {
    children: [avatar || icon, /*#__PURE__*/jsx$1(ChipLabel, {
      className: clsx(classes.label),
      ownerState: ownerState,
      children: label
    }), deleteIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Chip$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The Avatar element to display.
   */
  avatar: PropTypes$1.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes$1.bool,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes$1.element,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * Icon element.
   */
  icon: PropTypes$1.element,

  /**
   * The content of the component.
   */
  label: PropTypes$1.node,

  /**
   * @ignore
   */
  onClick: PropTypes$1.func,

  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes$1.func,

  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['filled', 'outlined']), PropTypes$1.string])
} : void 0;
var MuiChip = Chip$1;

function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/**
 * @ignore - internal component.
 */

const FormControlContext = /*#__PURE__*/React$d.createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}

var FormControlContext$1 = FormControlContext;

function useFormControl() {
  return React$d.useContext(FormControlContext$1);
}

function GlobalStyles(props) {
  return /*#__PURE__*/jsx$1(GlobalStyles$3, _extends$P({}, props, {
    defaultTheme: defaultTheme$2
  }));
}

process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.number, PropTypes$1.object, PropTypes$1.shape({
    __emotion_styles: PropTypes$1.any.isRequired
  }), PropTypes$1.string, PropTypes$1.bool])
} : void 0;

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj, SSR = false) {
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

function getInputBaseUtilityClass(slot) {
  return generateUtilityClass('MuiInputBase', slot);
}
const inputBaseClasses = generateUtilityClasses('MuiInputBase', ['root', 'formControl', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'colorSecondary', 'fullWidth', 'hiddenLabel', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch', 'inputAdornedStart', 'inputAdornedEnd', 'inputHiddenLabel']);
var inputBaseClasses$1 = inputBaseClasses;

const _excluded$1f = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "startAdornment", "type", "value"];
const rootOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.formControl && styles.formControl, ownerState.startAdornment && styles.adornedStart, ownerState.endAdornment && styles.adornedEnd, ownerState.error && styles.error, ownerState.size === 'small' && styles.sizeSmall, ownerState.multiline && styles.multiline, ownerState.color && styles[`color${capitalize$3(ownerState.color)}`], ownerState.fullWidth && styles.fullWidth, ownerState.hiddenLabel && styles.hiddenLabel];
};
const inputOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.input, ownerState.size === 'small' && styles.inputSizeSmall, ownerState.multiline && styles.inputMultiline, ownerState.type === 'search' && styles.inputTypeSearch, ownerState.startAdornment && styles.inputAdornedStart, ownerState.endAdornment && styles.inputAdornedEnd, ownerState.hiddenLabel && styles.inputHiddenLabel];
};

const useUtilityClasses$R = ownerState => {
  const {
    classes,
    color,
    disabled,
    error,
    endAdornment,
    focused,
    formControl,
    fullWidth,
    hiddenLabel,
    multiline,
    size,
    startAdornment,
    type
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$3(color)}`, disabled && 'disabled', error && 'error', fullWidth && 'fullWidth', focused && 'focused', formControl && 'formControl', size === 'small' && 'sizeSmall', multiline && 'multiline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', hiddenLabel && 'hiddenLabel'],
    input: ['input', disabled && 'disabled', type === 'search' && 'inputTypeSearch', multiline && 'inputMultiline', size === 'small' && 'inputSizeSmall', hiddenLabel && 'inputHiddenLabel', startAdornment && 'inputAdornedStart', endAdornment && 'inputAdornedEnd']
  };
  return composeClasses(slots, getInputBaseUtilityClass, classes);
};

const InputBaseRoot = styled$1('div', {
  name: 'MuiInputBase',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$P({}, theme.typography.body1, {
  color: theme.palette.text.primary,
  lineHeight: '1.4375em',
  // 23px
  boxSizing: 'border-box',
  // Prevent padding issue with fullWidth.
  position: 'relative',
  cursor: 'text',
  display: 'inline-flex',
  alignItems: 'center',
  [`&.${inputBaseClasses$1.disabled}`]: {
    color: theme.palette.text.disabled,
    cursor: 'default'
  }
}, ownerState.multiline && _extends$P({
  padding: '4px 0 5px'
}, ownerState.size === 'small' && {
  paddingTop: 1
}), ownerState.fullWidth && {
  width: '100%'
}));
const InputBaseComponent = styled$1('input', {
  name: 'MuiInputBase',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  const placeholderHidden = {
    opacity: '0 !important'
  };
  const placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return _extends$P({
    font: 'inherit',
    letterSpacing: 'inherit',
    color: 'currentColor',
    padding: '4px 0 5px',
    border: 0,
    boxSizing: 'content-box',
    background: 'none',
    height: '1.4375em',
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: 'transparent',
    display: 'block',
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: '100%',
    // Fix IE11 width issue
    animationName: 'mui-auto-fill-cancel',
    animationDuration: '10ms',
    '&::-webkit-input-placeholder': placeholder,
    '&::-moz-placeholder': placeholder,
    // Firefox 19+
    '&:-ms-input-placeholder': placeholder,
    // IE11
    '&::-ms-input-placeholder': placeholder,
    // Edge
    '&:focus': {
      outline: 0
    },
    // Reset Firefox invalid required input style
    '&:invalid': {
      boxShadow: 'none'
    },
    '&::-webkit-search-decoration': {
      // Remove the padding when type=search.
      WebkitAppearance: 'none'
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses$1.formControl} &`]: {
      '&::-webkit-input-placeholder': placeholderHidden,
      '&::-moz-placeholder': placeholderHidden,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderHidden,
      // IE11
      '&::-ms-input-placeholder': placeholderHidden,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholderVisible,
      '&:focus::-moz-placeholder': placeholderVisible,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholderVisible,
      // IE11
      '&:focus::-ms-input-placeholder': placeholderVisible // Edge

    },
    [`&.${inputBaseClasses$1.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: theme.palette.text.disabled // Fix opacity Safari bug

    },
    '&:-webkit-autofill': {
      animationDuration: '5000s',
      animationName: 'mui-auto-fill'
    }
  }, ownerState.size === 'small' && {
    paddingTop: 1
  }, ownerState.multiline && {
    height: 'auto',
    resize: 'none',
    padding: 0,
    paddingTop: 0
  }, ownerState.type === 'search' && {
    // Improve type search style.
    MozAppearance: 'textfield'
  });
});

const inputGlobalStyles = /*#__PURE__*/jsx$1(GlobalStyles, {
  styles: {
    '@keyframes mui-auto-fill': {
      from: {
        display: 'block'
      }
    },
    '@keyframes mui-auto-fill-cancel': {
      from: {
        display: 'block'
      }
    }
  }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */


const InputBase = /*#__PURE__*/React$d.forwardRef(function InputBase(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiInputBase'
  });

  const {
    'aria-describedby': ariaDescribedby,
    autoComplete,
    autoFocus,
    className,
    components = {},
    componentsProps = {},
    defaultValue,
    disabled,
    disableInjectingGlobalStyles,
    endAdornment,
    fullWidth = false,
    id,
    inputComponent = 'input',
    inputProps: inputPropsProp = {},
    inputRef: inputRefProp,
    maxRows,
    minRows,
    multiline = false,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
    onKeyUp,
    placeholder,
    readOnly,
    renderSuffix,
    rows,
    startAdornment,
    type = 'text',
    value: valueProp
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1f);

  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = React$d.useRef(value != null);
  const inputRef = React$d.useRef();
  const handleInputRefWarning = React$d.useCallback(instance => {
    if (process.env.NODE_ENV !== 'production') {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['MUI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `ref` prop.', 'Make sure the `ref` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  const handleInputPropsRefProp = useForkRef(inputPropsProp.ref, handleInputRefWarning);
  const handleInputRefProp = useForkRef(inputRefProp, handleInputPropsRefProp);
  const handleInputRef = useForkRef(inputRef, handleInputRefProp);
  const [focused, setFocused] = React$d.useState(false);
  const muiFormControl = useFormControl();

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$d.useEffect(() => {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'size', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  React$d.useEffect(() => {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  const onFilled = muiFormControl && muiFormControl.onFilled;
  const onEmpty = muiFormControl && muiFormControl.onEmpty;
  const checkDirty = React$d.useCallback(obj => {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect$2(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);

  const handleFocus = event => {
    // Fix a bug with IE11 where the focus/blur events are triggered
    // while the component is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  const handleChange = (event, ...args) => {
    if (!isControlled) {
      const element = event.target || inputRef.current;

      if (element == null) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Expected valid input target. Did you use a custom \`inputComponent\` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.` : formatMuiErrorMessage(1));
      }

      checkDirty({
        value: element.value
      });
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event, ...args);
    } // Perform in the willUpdate


    if (onChange) {
      onChange(event, ...args);
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  React$d.useEffect(() => {
    checkDirty(inputRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = event => {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  let InputComponent = inputComponent;
  let inputProps = inputPropsProp;

  if (multiline && InputComponent === 'input') {
    if (rows) {
      if (process.env.NODE_ENV !== 'production') {
        if (minRows || maxRows) {
          console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
        }
      }

      inputProps = _extends$P({
        type: undefined,
        minRows: rows,
        maxRows: rows
      }, inputProps);
    } else {
      inputProps = _extends$P({
        type: undefined,
        maxRows,
        minRows
      }, inputProps);
    }

    InputComponent = TextareaAutosize$1;
  }

  const handleAutoFill = event => {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  React$d.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);

  const ownerState = _extends$P({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    endAdornment,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    startAdornment,
    type
  });

  const classes = useUtilityClasses$R(ownerState);
  const Root = components.Root || InputBaseRoot;
  const rootProps = componentsProps.root || {};
  const Input = components.Input || InputBaseComponent;
  inputProps = _extends$P({}, inputProps, componentsProps.input);
  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [!disableInjectingGlobalStyles && inputGlobalStyles, /*#__PURE__*/jsxs(Root, _extends$P({}, rootProps, !isHostComponent(Root) && {
      ownerState: _extends$P({}, ownerState, rootProps.ownerState)
    }, {
      ref: ref,
      onClick: handleClick
    }, other, {
      className: clsx(classes.root, rootProps.className, className),
      children: [startAdornment, /*#__PURE__*/jsx$1(FormControlContext$1.Provider, {
        value: null,
        children: /*#__PURE__*/jsx$1(Input, _extends$P({
          ownerState: ownerState,
          "aria-invalid": fcs.error,
          "aria-describedby": ariaDescribedby,
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          defaultValue: defaultValue,
          disabled: fcs.disabled,
          id: id,
          onAnimationStart: handleAutoFill,
          name: name,
          placeholder: placeholder,
          readOnly: readOnly,
          required: fcs.required,
          rows: rows,
          value: value,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          type: type
        }, inputProps, !isHostComponent(Input) && {
          as: InputComponent,
          ownerState: _extends$P({}, ownerState, inputProps.ownerState)
        }, {
          ref: handleInputRef,
          className: clsx(classes.input, inputProps.className),
          onBlur: handleBlur,
          onChange: handleChange,
          onFocus: handleFocus
        }))
      }), endAdornment, renderSuffix ? renderSuffix(_extends$P({}, fcs, {
        startAdornment
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" ? InputBase.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': PropTypes$1.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes$1.string,

  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Input: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    input: PropTypes$1.object,
    root: PropTypes$1.object
  }),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes$1.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes$1.node,

  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes$1.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * If `true`, a [TextareaAutosize](/components/textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes$1.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes$1.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes$1.func,

  /**
   * @ignore
   */
  onClick: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes$1.func,

  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes$1.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes$1.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes$1.func,

  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes$1.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * The size of the component.
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes$1.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes$1.any
} : void 0;
var InputBase$1 = InputBase;

function getInputUtilityClass(slot) {
  return generateUtilityClass('MuiInput', slot);
}

const inputClasses = _extends$P({}, inputBaseClasses$1, generateUtilityClasses('MuiInput', ['root', 'underline', 'input']));

var inputClasses$1 = inputClasses;

function getOutlinedInputUtilityClass(slot) {
  return generateUtilityClass('MuiOutlinedInput', slot);
}

const outlinedInputClasses = _extends$P({}, inputBaseClasses$1, generateUtilityClasses('MuiOutlinedInput', ['root', 'notchedOutline', 'input']));

var outlinedInputClasses$1 = outlinedInputClasses;

function getFilledInputUtilityClass(slot) {
  return generateUtilityClass('MuiFilledInput', slot);
}

const filledInputClasses = _extends$P({}, inputBaseClasses$1, generateUtilityClasses('MuiFilledInput', ['root', 'underline', 'input']));

var filledInputClasses$1 = filledInputClasses;

var ArrowDropDownIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

const _excluded$1e = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
const styles$2 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Fade$1 = /*#__PURE__*/React$d.forwardRef(function Fade(props, ref) {
  const theme = useTheme();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$2
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1e);
  const nodeRef = React$d.useRef(null);
  const foreignRef = useForkRef(children.ref, ref);
  const handleRef = useForkRef(nodeRef, foreignRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  return /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef ,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$d.cloneElement(children, _extends$P({
        style: _extends$P({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$2[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Fade$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes$1.func,

  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes$1.bool,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes$1.oneOfType([PropTypes$1.shape({
    enter: PropTypes$1.string,
    exit: PropTypes$1.string
  }), PropTypes$1.string]),

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes$1.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntered: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntering: PropTypes$1.func,

  /**
   * @ignore
   */
  onExit: PropTypes$1.func,

  /**
   * @ignore
   */
  onExited: PropTypes$1.func,

  /**
   * @ignore
   */
  onExiting: PropTypes$1.func,

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
} : void 0;
var MuiFade = Fade$1;

function getBackdropUtilityClass(slot) {
  return generateUtilityClass('MuiBackdrop', slot);
}
generateUtilityClasses('MuiBackdrop', ['root', 'invisible']);

const _excluded$1d = ["children", "component", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"];

const useUtilityClasses$Q = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return composeClasses(slots, getBackdropUtilityClass, classes);
};

const BackdropRoot = styled$1('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => _extends$P({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/React$d.forwardRef(function Backdrop(inProps, ref) {
  var _components$Root, _componentsProps$root;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiBackdrop'
  });

  const {
    children,
    component = 'div',
    components = {},
    componentsProps = {},
    className,
    invisible = false,
    open,
    transitionDuration,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = MuiFade
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1d);

  const ownerState = _extends$P({}, props, {
    component,
    invisible
  });

  const classes = useUtilityClasses$Q(ownerState);
  return /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/jsx$1(BackdropRoot, {
      "aria-hidden": true,
      as: (_components$Root = components.Root) != null ? _components$Root : component,
      className: clsx(classes.root, className),
      ownerState: _extends$P({}, ownerState, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState),
      classes: classes,
      ref: ref,
      children: children
    })
  }));
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The components used for each slot inside the Backdrop.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Backdrop.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    root: PropTypes$1.object
  }),

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes$1.bool,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
} : void 0;
var Backdrop$1 = Backdrop;

const shouldSpreadAdditionalProps = Slot => {
  return !Slot || !isHostComponent(Slot);
};

var shouldSpreadAdditionalProps$1 = shouldSpreadAdditionalProps;

function getBadgeUtilityClass(slot) {
  return generateUtilityClass('MuiBadge', slot);
}
const badgeClasses = generateUtilityClasses('MuiBadge', ['root', 'badge', 'dot', 'standard', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft', 'invisible', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'overlapRectangular', 'overlapCircular', // TODO: v6 remove the overlap value from these class keys
'anchorOriginTopLeftCircular', 'anchorOriginTopLeftRectangular', 'anchorOriginTopRightCircular', 'anchorOriginTopRightRectangular', 'anchorOriginBottomLeftCircular', 'anchorOriginBottomLeftRectangular', 'anchorOriginBottomRightCircular', 'anchorOriginBottomRightRectangular']);
var badgeClasses$1 = badgeClasses;

const _excluded$1c = ["anchorOrigin", "className", "component", "components", "componentsProps", "overlap", "color", "invisible", "max", "badgeContent", "showZero", "variant"];
const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;

const extendUtilityClasses$2 = ownerState => {
  const {
    color,
    anchorOrigin,
    invisible,
    overlap,
    variant,
    classes = {}
  } = ownerState;
  return {
    root: clsx(classes.root, 'root'),
    badge: clsx(classes.badge, getBadgeUtilityClass('badge'), getBadgeUtilityClass(variant), `anchorOrigin${capitalize$3(anchorOrigin.vertical)}${capitalize$3(anchorOrigin.horizontal)}`, getBadgeUtilityClass(`anchorOrigin${capitalize$3(anchorOrigin.vertical)}${capitalize$3(anchorOrigin.horizontal)}${capitalize$3(overlap)}`), getBadgeUtilityClass(`overlap${capitalize$3(overlap)}`), color !== 'default' && [getBadgeUtilityClass(`color${capitalize$3(color)}`), classes[`color${capitalize$3(color)}`]], invisible && getBadgeUtilityClass('invisible'))
  };
};

const BadgeRoot = styled$1('span', {
  name: 'MuiBadge',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  position: 'relative',
  display: 'inline-flex',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  flexShrink: 0
});
const BadgeBadge = styled$1('span', {
  name: 'MuiBadge',
  slot: 'Badge',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.badge, styles[ownerState.variant], styles[`anchorOrigin${capitalize$3(ownerState.anchorOrigin.vertical)}${capitalize$3(ownerState.anchorOrigin.horizontal)}${capitalize$3(ownerState.overlap)}`], ownerState.color !== 'default' && styles[`color${capitalize$3(ownerState.color)}`], ownerState.invisible && styles.invisible];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  boxSizing: 'border-box',
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(12),
  minWidth: RADIUS_STANDARD * 2,
  lineHeight: 1,
  padding: '0 6px',
  height: RADIUS_STANDARD * 2,
  borderRadius: RADIUS_STANDARD,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.enteringScreen
  })
}, ownerState.color !== 'default' && {
  backgroundColor: theme.palette[ownerState.color].main,
  color: theme.palette[ownerState.color].contrastText
}, ownerState.variant === 'dot' && {
  borderRadius: RADIUS_DOT,
  height: RADIUS_DOT * 2,
  minWidth: RADIUS_DOT * 2,
  padding: 0
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && {
  top: 0,
  right: 0,
  transform: 'scale(1) translate(50%, -50%)',
  transformOrigin: '100% 0%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && {
  bottom: 0,
  right: 0,
  transform: 'scale(1) translate(50%, 50%)',
  transformOrigin: '100% 100%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(50%, 50%)'
  }
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && {
  top: 0,
  left: 0,
  transform: 'scale(1) translate(-50%, -50%)',
  transformOrigin: '0% 0%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(-50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && {
  bottom: 0,
  left: 0,
  transform: 'scale(1) translate(-50%, 50%)',
  transformOrigin: '0% 100%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(-50%, 50%)'
  }
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && {
  top: '14%',
  right: '14%',
  transform: 'scale(1) translate(50%, -50%)',
  transformOrigin: '100% 0%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && {
  bottom: '14%',
  right: '14%',
  transform: 'scale(1) translate(50%, 50%)',
  transformOrigin: '100% 100%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(50%, 50%)'
  }
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && {
  top: '14%',
  left: '14%',
  transform: 'scale(1) translate(-50%, -50%)',
  transformOrigin: '0% 0%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(-50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && {
  bottom: '14%',
  left: '14%',
  transform: 'scale(1) translate(-50%, 50%)',
  transformOrigin: '0% 100%',
  [`&.${badgeClasses$1.invisible}`]: {
    transform: 'scale(0) translate(-50%, 50%)'
  }
}, ownerState.invisible && {
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.leavingScreen
  })
}));
const Badge$1 = /*#__PURE__*/React$d.forwardRef(function Badge(inProps, ref) {
  var _componentsProps$root, _componentsProps$root2, _componentsProps$badg, _componentsProps$badg2;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiBadge'
  });

  const {
    anchorOrigin: anchorOriginProp = {
      vertical: 'top',
      horizontal: 'right'
    },
    className,
    component = 'span',
    components = {},
    componentsProps = {},
    overlap: overlapProp = 'rectangular',
    color: colorProp = 'default',
    invisible: invisibleProp = false,
    max,
    badgeContent: badgeContentProp,
    showZero = false,
    variant: variantProp = 'standard'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1c);

  const prevProps = usePreviousProps$1({
    anchorOrigin: anchorOriginProp,
    color: colorProp,
    overlap: overlapProp,
    variant: variantProp
  });
  let invisible = invisibleProp;

  if (invisibleProp === false && (badgeContentProp === 0 && !showZero || badgeContentProp == null && variantProp !== 'dot')) {
    invisible = true;
  }

  const {
    color = colorProp,
    overlap = overlapProp,
    anchorOrigin = anchorOriginProp,
    variant = variantProp
  } = invisible ? prevProps : props;

  const ownerState = _extends$P({}, props, {
    anchorOrigin,
    invisible,
    color,
    overlap,
    variant
  });

  const classes = extendUtilityClasses$2(ownerState);
  let displayValue;

  if (variant !== 'dot') {
    displayValue = badgeContentProp && Number(badgeContentProp) > max ? `${max}+` : badgeContentProp;
  }

  return /*#__PURE__*/jsx$1(BadgeUnstyled$1, _extends$P({
    invisible: invisibleProp,
    badgeContent: displayValue,
    showZero: showZero,
    max: max
  }, other, {
    components: _extends$P({
      Root: BadgeRoot,
      Badge: BadgeBadge
    }, components),
    className: clsx(className, classes.root, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.className),
    componentsProps: {
      root: _extends$P({}, componentsProps.root, shouldSpreadAdditionalProps$1(components.Root) && {
        as: component,
        ownerState: _extends$P({}, (_componentsProps$root2 = componentsProps.root) == null ? void 0 : _componentsProps$root2.ownerState, {
          anchorOrigin,
          color,
          overlap,
          variant
        })
      }),
      badge: _extends$P({}, componentsProps.badge, {
        className: clsx(classes.badge, (_componentsProps$badg = componentsProps.badge) == null ? void 0 : _componentsProps$badg.className)
      }, shouldSpreadAdditionalProps$1(components.Badge) && {
        ownerState: _extends$P({}, (_componentsProps$badg2 = componentsProps.badge) == null ? void 0 : _componentsProps$badg2.ownerState, {
          anchorOrigin,
          color,
          overlap,
          variant
        })
      })
    },
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? Badge$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: PropTypes$1.shape({
    horizontal: PropTypes$1.oneOf(['left', 'right']).isRequired,
    vertical: PropTypes$1.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes$1.node,

  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Badge: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    badge: PropTypes$1.object,
    root: PropTypes$1.object
  }),

  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: PropTypes$1.bool,

  /**
   * Max count to show.
   * @default 99
   */
  max: PropTypes$1.number,

  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: PropTypes$1.oneOf(['circular', 'rectangular']),

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['dot', 'standard']), PropTypes$1.string])
} : void 0;
var Badge$2 = Badge$1;

const defaultTheme = createTheme();
/**
 * @ignore - do not document.
 */

const Box$1 = createBox$1({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: ClassNameGenerator$1.generate
});
var MuiBox = Box$1;

var MoreHorizIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

const BreadcrumbCollapsedButton = styled$1(ButtonBase$1)(({
  theme
}) => _extends$P({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': _extends$P({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': _extends$P({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: emphasize(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: emphasize(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = styled$1(MoreHorizIcon)({
  width: 24,
  height: 16
});
/**
 * @ignore - internal component.
 */

function BreadcrumbCollapsed(props) {
  const ownerState = props;
  return /*#__PURE__*/jsx$1("li", {
    children: /*#__PURE__*/jsx$1(BreadcrumbCollapsedButton, _extends$P({
      focusRipple: true
    }, props, {
      ownerState: ownerState,
      children: /*#__PURE__*/jsx$1(BreadcrumbCollapsedIcon, {
        ownerState: ownerState
      })
    }))
  });
}

process.env.NODE_ENV !== "production" ? BreadcrumbCollapsed.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.object
} : void 0;

function getBreadcrumbsUtilityClass(slot) {
  return generateUtilityClass('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = generateUtilityClasses('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
var breadcrumbsClasses$1 = breadcrumbsClasses;

const _excluded$1b = ["children", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];

const useUtilityClasses$P = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return composeClasses(slots, getBreadcrumbsUtilityClass, classes);
};

const BreadcrumbsRoot = styled$1(Typography$1, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${breadcrumbsClasses$1.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = styled$1('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = styled$1('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});

function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/jsx$1(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

const Breadcrumbs$1 = /*#__PURE__*/React$d.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });

  const {
    children,
    className,
    component = 'nav',
    expandText = 'Show path',
    itemsAfterCollapse = 1,
    itemsBeforeCollapse = 1,
    maxItems = 8,
    separator = '/'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1b);

  const [expanded, setExpanded] = React$d.useState(false);

  const ownerState = _extends$P({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });

  const classes = useUtilityClasses$P(ownerState);
  const listRef = React$d.useRef(null);

  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.

      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(['MUI: You have provided an invalid combination of props to the Breadcrumbs.', `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`].join('\n'));
      }

      return allItems;
    }

    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/jsx$1(BreadcrumbCollapsed, {
      "aria-label": expandText,
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };

  const allItems = React$d.Children.toArray(children).filter(child => {
    if (process.env.NODE_ENV !== 'production') {
      if (reactIs$3.exports.isFragment(child)) {
        console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/React$d.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/jsx$1("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/jsx$1(BreadcrumbsRoot, _extends$P({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsx$1(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
process.env.NODE_ENV !== "production" ? Breadcrumbs$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   * @default 'Show path'
   */
  expandText: PropTypes$1.string,

  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: integerPropType,

  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: integerPropType,

  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: integerPropType,

  /**
   * Custom separator node.
   * @default '/'
   */
  separator: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var MiuBreadcrumbs = Breadcrumbs$1;

function getButtonUtilityClass(slot) {
  return generateUtilityClass('MuiButton', slot);
}
const buttonClasses = generateUtilityClasses('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
var buttonClasses$1 = buttonClasses;

/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/React$d.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}

var ButtonGroupContext$1 = ButtonGroupContext;

const _excluded$1a = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];

const useUtilityClasses$O = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${capitalize$3(color)}`, `size${capitalize$3(size)}`, `${variant}Size${capitalize$3(size)}`, color === 'inherit' && 'colorInherit', disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['startIcon', `iconSize${capitalize$3(size)}`],
    endIcon: ['endIcon', `iconSize${capitalize$3(size)}`]
  };
  const composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const commonIconStyles = ownerState => _extends$P({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});

const ButtonRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${capitalize$3(ownerState.color)}`], styles[`size${capitalize$3(ownerState.size)}`], styles[`${ownerState.variant}Size${capitalize$3(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;

  return _extends$P({}, theme.typography.button, {
    minWidth: 64,
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': _extends$P({
      textDecoration: 'none',
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$2(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$2(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$2(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'contained' && {
      backgroundColor: (theme.vars || theme).palette.grey.A100,
      boxShadow: (theme.vars || theme).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: (theme.vars || theme).shadows[2],
        backgroundColor: (theme.vars || theme).palette.grey[300]
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    }),
    '&:active': _extends$P({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[8]
    }),
    [`&.${buttonClasses$1.focusVisible}`]: _extends$P({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[6]
    }),
    [`&.${buttonClasses$1.disabled}`]: _extends$P({
      color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    }, ownerState.variant === 'outlined' && ownerState.color === 'secondary' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabled}`
    }, ownerState.variant === 'contained' && {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, ownerState.variant === 'text' && {
    padding: '6px 8px'
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.variant === 'outlined' && {
    padding: '5px 15px',
    border: '1px solid currentColor'
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${alpha$2(theme.palette[ownerState.color].main, 0.5)}`
  }, ownerState.variant === 'contained' && {
    color: theme.vars ? // this is safe because grey does not change between default light/dark mode
    theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: (theme.vars || theme).palette.grey[300],
    boxShadow: (theme.vars || theme).shadows[2]
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.color === 'inherit' && {
    color: 'inherit',
    borderColor: 'currentColor'
  }, ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '4px 5px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '8px 11px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '3px 9px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '7px 21px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '4px 10px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '8px 22px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.fullWidth && {
    width: '100%'
  });
}, ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = styled$1('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${capitalize$3(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$P({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = styled$1('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${capitalize$3(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$P({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button$2 = /*#__PURE__*/React$d.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const contextProps = React$d.useContext(ButtonGroupContext$1);
  const resolvedProps = resolveProps(contextProps, inProps);
  const props = useThemeProps({
    props: resolvedProps,
    name: 'MuiButton'
  });

  const {
    children,
    color = 'primary',
    component = 'button',
    className,
    disabled = false,
    disableElevation = false,
    disableFocusRipple = false,
    endIcon: endIconProp,
    focusVisibleClassName,
    fullWidth = false,
    size = 'medium',
    startIcon: startIconProp,
    type,
    variant = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$1a);

  const ownerState = _extends$P({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });

  const classes = useUtilityClasses$O(ownerState);

  const startIcon = startIconProp && /*#__PURE__*/jsx$1(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });

  const endIcon = endIconProp && /*#__PURE__*/jsx$1(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });

  return /*#__PURE__*/jsxs(ButtonRoot, _extends$P({
    ownerState: ownerState,
    className: clsx(className, contextProps.className),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Button$2.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']), PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes$1.bool,

  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes$1.bool,

  /**
   * Element placed after the children.
   */
  endIcon: PropTypes$1.node,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes$1.string,

  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes$1.string,

  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['small', 'medium', 'large']), PropTypes$1.string]),

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * @ignore
   */
  type: PropTypes$1.oneOfType([PropTypes$1.oneOf(['button', 'reset', 'submit']), PropTypes$1.string]),

  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['contained', 'outlined', 'text']), PropTypes$1.string])
} : void 0;
var Button$3 = Button$2;

function getSwitchBaseUtilityClass(slot) {
  return generateUtilityClass('PrivateSwitchBase', slot);
}
generateUtilityClasses('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);

const _excluded$19 = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];

const useUtilityClasses$N = ownerState => {
  const {
    classes,
    checked,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && `edge${capitalize$3(edge)}`],
    input: ['input']
  };
  return composeClasses(slots, getSwitchBaseUtilityClass, classes);
};

const SwitchBaseRoot = styled$1(ButtonBase$1)(({
  ownerState
}) => _extends$P({
  padding: 9,
  borderRadius: '50%'
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}));
const SwitchBaseInput = styled$1('input')({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});
/**
 * @ignore - internal component.
 */

const SwitchBase = /*#__PURE__*/React$d.forwardRef(function SwitchBase(props, ref) {
  const {
    autoFocus,
    checked: checkedProp,
    checkedIcon,
    className,
    defaultChecked,
    disabled: disabledProp,
    disableFocusRipple = false,
    edge = false,
    icon,
    id,
    inputProps,
    inputRef,
    name,
    onBlur,
    onChange,
    onFocus,
    readOnly,
    required,
    tabIndex,
    type,
    value
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$19);

  const [checked, setCheckedState] = useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  });
  const muiFormControl = useFormControl();

  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  const handleInputChange = event => {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }

    const newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };

  let disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  const hasLabelFor = type === 'checkbox' || type === 'radio';

  const ownerState = _extends$P({}, props, {
    checked,
    disabled,
    disableFocusRipple,
    edge
  });

  const classes = useUtilityClasses$N(ownerState);
  return /*#__PURE__*/jsxs(SwitchBaseRoot, _extends$P({
    component: "span",
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsx$1(SwitchBaseInput, _extends$P({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor && id,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes$1.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes$1.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes$1.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * @ignore
   */
  defaultChecked: PropTypes$1.bool,

  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes$1.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes$1.oneOf(['end', 'start', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes$1.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /*
   * @ignore
   */
  name: PropTypes$1.string,

  /**
   * @ignore
   */
  onBlur: PropTypes$1.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes$1.bool,

  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * The input component prop `type`.
   */
  type: PropTypes$1.string.isRequired,

  /**
   * The value of the component.
   */
  value: PropTypes$1.any
} : void 0;
var SwitchBase$1 = SwitchBase;

var CheckBoxOutlineBlankIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

var CheckBoxIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

var IndeterminateCheckBoxIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

function getCheckboxUtilityClass(slot) {
  return generateUtilityClass('MuiCheckbox', slot);
}
const checkboxClasses = generateUtilityClasses('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
var checkboxClasses$1 = checkboxClasses;

const _excluded$18 = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"];

const useUtilityClasses$M = ownerState => {
  const {
    classes,
    indeterminate,
    color
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${capitalize$3(color)}`]
  };
  const composedClasses = composeClasses(slots, getCheckboxUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const CheckboxRoot = styled$1(SwitchBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles[`color${capitalize$3(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  color: theme.palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: alpha$2(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${checkboxClasses$1.checked}, &.${checkboxClasses$1.indeterminate}`]: {
    color: theme.palette[ownerState.color].main
  },
  [`&.${checkboxClasses$1.disabled}`]: {
    color: theme.palette.action.disabled
  }
}));

const defaultCheckedIcon$1 = /*#__PURE__*/jsx$1(CheckBoxIcon, {});

const defaultIcon$1 = /*#__PURE__*/jsx$1(CheckBoxOutlineBlankIcon, {});

const defaultIndeterminateIcon = /*#__PURE__*/jsx$1(IndeterminateCheckBoxIcon, {});

const Checkbox$1 = /*#__PURE__*/React$d.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiCheckbox'
  });

  const {
    checkedIcon = defaultCheckedIcon$1,
    color = 'primary',
    icon: iconProp = defaultIcon$1,
    indeterminate = false,
    indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
    inputProps,
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$18);

  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;

  const ownerState = _extends$P({}, props, {
    color,
    indeterminate,
    size
  });

  const classes = useUtilityClasses$M(ownerState);
  return /*#__PURE__*/jsx$1(CheckboxRoot, _extends$P({
    type: "checkbox",
    inputProps: _extends$P({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/React$d.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/React$d.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? Checkbox$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes$1.bool,

  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes$1.bool,

  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: PropTypes$1.bool,

  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: PropTypes$1.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: PropTypes$1.bool,

  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: PropTypes$1.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes$1.func,

  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes$1.bool,

  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes$1.any
} : void 0;
var MuiCheckbox = Checkbox$1;

function getCircularProgressUtilityClass(slot) {
  return generateUtilityClass('MuiCircularProgress', slot);
}
generateUtilityClasses('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);

const _excluded$17 = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];

let _$2 = t => t,
    _t$2,
    _t2$2,
    _t3$2,
    _t4$2;
const SIZE = 44;
const circularRotateKeyframe = keyframes(_t$2 || (_t$2 = _$2`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = keyframes(_t2$2 || (_t2$2 = _$2`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));

const useUtilityClasses$L = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${capitalize$3(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${capitalize$3(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return composeClasses(slots, getCircularProgressUtilityClass, classes);
};

const CircularProgressRoot = styled$1('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${capitalize$3(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => _extends$P({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: theme.palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && css(_t3$2 || (_t3$2 = _$2`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = styled$1('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered

});
const CircularProgressCircle = styled$1('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${capitalize$3(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => _extends$P({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.

}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && css(_t4$2 || (_t4$2 = _$2`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

const CircularProgress$1 = /*#__PURE__*/React$d.forwardRef(function CircularProgress(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiCircularProgress'
  });

  const {
    className,
    color = 'primary',
    disableShrink = false,
    size = 40,
    style,
    thickness = 3.6,
    value = 0,
    variant = 'indeterminate'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$17);

  const ownerState = _extends$P({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });

  const classes = useUtilityClasses$L(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};

  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/jsx$1(CircularProgressRoot, _extends$P({
    className: clsx(classes.root, className),
    style: _extends$P({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/jsx$1(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/jsx$1(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? CircularProgress$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes$1.bool, props => {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('MUI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   * @default 40
   */
  size: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes$1.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes$1.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes$1.oneOf(['determinate', 'indeterminate'])
} : void 0;
var CircularProgress$2 = CircularProgress$1;

const _excluded$16 = ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"];

const extendUtilityClasses$1 = ownerState => {
  return ownerState.classes;
};

const ModalRoot = styled$1('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  position: 'fixed',
  zIndex: theme.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = styled$1(Backdrop$1, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const Modal = /*#__PURE__*/React$d.forwardRef(function Modal(inProps, ref) {
  var _componentsProps$root;

  const props = useThemeProps({
    name: 'MuiModal',
    props: inProps
  });

  const {
    BackdropComponent = ModalBackdrop,
    closeAfterTransition = false,
    children,
    components = {},
    componentsProps = {},
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$16);

  const [exited, setExited] = React$d.useState(true);
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };

  const ownerState = _extends$P({}, props, commonProps, {
    exited
  });

  const classes = extendUtilityClasses$1(ownerState);
  return /*#__PURE__*/jsx$1(ModalUnstyled$1, _extends$P({
    components: _extends$P({
      Root: ModalRoot
    }, components),
    componentsProps: {
      root: _extends$P({}, componentsProps.root, (!components.Root || !isHostComponent(components.Root)) && {
        ownerState: _extends$P({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
      })
    },
    BackdropComponent: BackdropComponent,
    onTransitionEnter: () => setExited(false),
    onTransitionExited: () => setExited(true),
    ref: ref
  }, other, {
    classes: classes
  }, commonProps, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? Modal.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes$1.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes$1.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes$1.bool,

  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    root: PropTypes$1.object
  }),

  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes$1.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes$1.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes$1.bool,

  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes$1.bool,

  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes$1.bool,

  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes$1.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes$1.bool,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var Modal$1 = Modal;

function getDialogUtilityClass(slot) {
  return generateUtilityClass('MuiDialog', slot);
}
const dialogClasses = generateUtilityClasses('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
var dialogClasses$1 = dialogClasses;

const DialogContext = /*#__PURE__*/createContext$1({});

if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}

var DialogContext$1 = DialogContext;

const _excluded$15 = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
const DialogBackdrop = styled$1(Backdrop$1, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});

const useUtilityClasses$K = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${capitalize$3(scroll)}`],
    paper: ['paper', `paperScroll${capitalize$3(scroll)}`, `paperWidth${capitalize$3(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return composeClasses(slots, getDialogUtilityClass, classes);
};

const DialogRoot = styled$1(Modal$1, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = styled$1('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${capitalize$3(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => _extends$P({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = styled$1(Paper$2, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${capitalize$3(ownerState.scroll)}`], styles[`paperWidth${capitalize$3(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11

}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

const Dialog$1 = /*#__PURE__*/React$d.forwardRef(function Dialog(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = useTheme();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    'aria-describedby': ariaDescribedby,
    'aria-labelledby': ariaLabelledbyProp,
    BackdropComponent,
    BackdropProps,
    children,
    className,
    disableEscapeKeyDown = false,
    fullScreen = false,
    fullWidth = false,
    maxWidth = 'sm',
    onBackdropClick,
    onClose,
    open,
    PaperComponent = Paper$2,
    PaperProps = {},
    scroll = 'paper',
    TransitionComponent = MuiFade,
    transitionDuration = defaultTransitionDuration,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$15);

  const ownerState = _extends$P({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });

  const classes = useUtilityClasses$K(ownerState);
  const backdropClick = React$d.useRef();

  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };

  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }

    backdropClick.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const ariaLabelledby = useId(ariaLabelledbyProp);
  const dialogContextValue = React$d.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/jsx$1(DialogRoot, _extends$P({
    className: clsx(classes.root, className),
    BackdropProps: _extends$P({
      transitionDuration,
      as: BackdropComponent
    }, BackdropProps),
    closeAfterTransition: true,
    BackdropComponent: DialogBackdrop,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/jsx$1(DialogContainer, {
        className: clsx(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/jsx$1(DialogPaper, _extends$P({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: clsx(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/jsx$1(DialogContext$1.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Dialog$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes$1.string,

  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes$1.string,

  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes$1.elementType,

  /**
   * @ignore
   */
  BackdropProps: PropTypes$1.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes$1.bool,

  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes$1.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), PropTypes$1.string]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes$1.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes$1.object,

  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes$1.oneOf(['body', 'paper']),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes$1.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes$1.object
} : void 0;
var Dialog$2 = Dialog$1;

function getDialogActionsUtilityClass(slot) {
  return generateUtilityClass('MuiDialogActions', slot);
}
generateUtilityClasses('MuiDialogActions', ['root', 'spacing']);

const _excluded$14 = ["className", "disableSpacing"];

const useUtilityClasses$J = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return composeClasses(slots, getDialogActionsUtilityClass, classes);
};

const DialogActionsRoot = styled$1('div', {
  name: 'MuiDialogActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => _extends$P({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  flex: '0 0 auto'
}, !ownerState.disableSpacing && {
  '& > :not(:first-of-type)': {
    marginLeft: 8
  }
}));
const DialogActions = /*#__PURE__*/React$d.forwardRef(function DialogActions(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialogActions'
  });

  const {
    className,
    disableSpacing = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$14);

  const ownerState = _extends$P({}, props, {
    disableSpacing
  });

  const classes = useUtilityClasses$J(ownerState);
  return /*#__PURE__*/jsx$1(DialogActionsRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogActions.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var DialogActions$1 = DialogActions;

function getDialogContentUtilityClass(slot) {
  return generateUtilityClass('MuiDialogContent', slot);
}
generateUtilityClasses('MuiDialogContent', ['root', 'dividers']);

function getDialogTitleUtilityClass(slot) {
  return generateUtilityClass('MuiDialogTitle', slot);
}
const dialogTitleClasses = generateUtilityClasses('MuiDialogTitle', ['root']);
var dialogTitleClasses$1 = dialogTitleClasses;

const _excluded$13 = ["className", "dividers"];

const useUtilityClasses$I = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return composeClasses(slots, getDialogContentUtilityClass, classes);
};

const DialogContentRoot = styled$1('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${theme.palette.divider}`,
  borderBottom: `1px solid ${theme.palette.divider}`
} : {
  [`.${dialogTitleClasses$1.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/React$d.forwardRef(function DialogContent(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialogContent'
  });

  const {
    className,
    dividers = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$13);

  const ownerState = _extends$P({}, props, {
    dividers
  });

  const classes = useUtilityClasses$I(ownerState);
  return /*#__PURE__*/jsx$1(DialogContentRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogContent.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var DialogContent$1 = DialogContent;

const _excluded$12 = ["className", "id"];

const useUtilityClasses$H = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getDialogTitleUtilityClass, classes);
};

const DialogTitleRoot = styled$1(Typography$1, {
  name: 'MuiDialogTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  padding: '16px 24px',
  flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/React$d.forwardRef(function DialogTitle(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialogTitle'
  });

  const {
    className,
    id: idProp
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$12);

  const ownerState = props;
  const classes = useUtilityClasses$H(ownerState);
  const {
    titleId: id = idProp
  } = React$d.useContext(DialogContext$1);
  return /*#__PURE__*/jsx$1(DialogTitleRoot, _extends$P({
    component: "h2",
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    variant: "h6",
    id: id
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogTitle.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * @ignore
   */
  id: PropTypes$1.string,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var DialogTitle$1 = DialogTitle;

const _excluded$11 = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = ownerWindow(node);
  let transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  let offsetX = 0;
  let offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }

    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }

  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }

    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }

  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }

    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  } // direction === 'down'


  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }

  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}

function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}

function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Slide = /*#__PURE__*/React$d.forwardRef(function Slide(props, ref) {
  const theme = useTheme();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    addEndListener,
    appear = true,
    children,
    container: containerProp,
    direction = 'down',
    easing: easingProp = defaultEasing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$2
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$11);

  const childrenRef = React$d.useRef(null);
  const handleRefIntermediary = useForkRef(children.ref, childrenRef);
  const handleRef = useForkRef(handleRefIntermediary, ref);

  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };

  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    reflow(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = getTransitionProps({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', _extends$P({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', _extends$P({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };

  const updatePosition = React$d.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  React$d.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    const handleResize = debounce$5(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = ownerWindow(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  React$d.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$d.cloneElement(children, _extends$P({
        ref: handleRef,
        style: _extends$P({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Slide.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes$1.func,

  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes$1.bool,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: chainPropTypes(PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]), props => {
    if (props.open) {
      const resolvedContainer = resolveContainer(props.container);

      if (resolvedContainer && resolvedContainer.nodeType === 1) {
        const box = resolvedContainer.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `container` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== 'function' || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `container` prop provided to the component is invalid.', 'It should be an HTML element instance.'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: PropTypes$1.oneOf(['down', 'left', 'right', 'up']),

  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: PropTypes$1.oneOfType([PropTypes$1.shape({
    enter: PropTypes$1.string,
    exit: PropTypes$1.string
  }), PropTypes$1.string]),

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes$1.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntered: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntering: PropTypes$1.func,

  /**
   * @ignore
   */
  onExit: PropTypes$1.func,

  /**
   * @ignore
   */
  onExited: PropTypes$1.func,

  /**
   * @ignore
   */
  onExiting: PropTypes$1.func,

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
} : void 0;
var Slide$1 = Slide;

function getDrawerUtilityClass(slot) {
  return generateUtilityClass('MuiDrawer', slot);
}
generateUtilityClasses('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);

const _excluded$10 = ["BackdropProps"],
      _excluded2$5 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];

const overridesResolver$4 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};

const useUtilityClasses$G = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${capitalize$3(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${capitalize$3(anchor)}`]
  };
  return composeClasses(slots, getDrawerUtilityClass, classes);
};

const DrawerRoot = styled$1(Modal$1, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver: overridesResolver$4
})(({
  theme
}) => ({
  zIndex: theme.zIndex.drawer
}));
const DrawerDockedRoot = styled$1('div', {
  shouldForwardProp: rootShouldForwardProp,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver: overridesResolver$4
})({
  flex: '0 0 auto'
});
const DrawerPaper = styled$1(Paper$2, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${capitalize$3(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${capitalize$3(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: theme.zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${theme.palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

const Drawer$1 = /*#__PURE__*/React$d.forwardRef(function Drawer(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = useTheme();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    anchor: anchorProp = 'left',
    BackdropProps,
    children,
    className,
    elevation = 16,
    hideBackdrop = false,
    ModalProps: {
      BackdropProps: BackdropPropsProp
    } = {},
    onClose,
    open = false,
    PaperProps = {},
    SlideProps,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Slide$1,
    transitionDuration = defaultTransitionDuration,
    variant = 'temporary'
  } = props,
        ModalProps = _objectWithoutPropertiesLoose$3(props.ModalProps, _excluded$10),
        other = _objectWithoutPropertiesLoose$3(props, _excluded2$5); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.


  const mounted = React$d.useRef(false);
  React$d.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor(theme, anchorProp);
  const anchor = anchorProp;

  const ownerState = _extends$P({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);

  const classes = useUtilityClasses$G(ownerState);

  const drawer = /*#__PURE__*/jsx$1(DrawerPaper, _extends$P({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: clsx(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));

  if (variant === 'permanent') {
    return /*#__PURE__*/jsx$1(DrawerDockedRoot, _extends$P({
      className: clsx(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }

  const slidingDrawer = /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));

  if (variant === 'persistent') {
    return /*#__PURE__*/jsx$1(DrawerDockedRoot, _extends$P({
      className: clsx(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  } // variant === temporary


  return /*#__PURE__*/jsx$1(DrawerRoot, _extends$P({
    BackdropProps: _extends$P({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: clsx(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
process.env.NODE_ENV !== "production" ? Drawer$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: PropTypes$1.oneOf(['bottom', 'left', 'right', 'top']),

  /**
   * @ignore
   */
  BackdropProps: PropTypes$1.object,

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: integerPropType,

  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes$1.bool,

  /**
   * Props applied to the [`Modal`](/api/modal/) element.
   * @default {}
   */
  ModalProps: PropTypes$1.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: PropTypes$1.bool,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes$1.object,

  /**
   * Props applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })]),

  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: PropTypes$1.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
var MuiDrawer = Drawer$1;

function getFabUtilityClass(slot) {
  return generateUtilityClass('MuiFab', slot);
}
const fabClasses = generateUtilityClasses('MuiFab', ['root', 'primary', 'secondary', 'extended', 'circular', 'focusVisible', 'disabled', 'colorInherit', 'sizeSmall', 'sizeMedium', 'sizeLarge', 'info', 'error', 'warning', 'success']);
var fabClasses$1 = fabClasses;

const _excluded$$ = ["children", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"];

const useUtilityClasses$F = ownerState => {
  const {
    color,
    variant,
    classes,
    size
  } = ownerState;
  const slots = {
    root: ['root', variant, `size${capitalize$3(size)}`, color === 'inherit' ? 'colorInherit' : color]
  };
  return composeClasses(slots, getFabUtilityClass, classes);
};

const FabRoot = styled$1(ButtonBase$1, {
  name: 'MuiFab',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${capitalize$3(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, styles[capitalize$3(ownerState.size)], styles[ownerState.color]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({}, theme.typography.button, {
  minHeight: 36,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
    duration: theme.transitions.duration.short
  }),
  borderRadius: '50%',
  padding: 0,
  minWidth: 0,
  width: 56,
  height: 56,
  zIndex: theme.zIndex.fab,
  boxShadow: theme.shadows[6],
  '&:active': {
    boxShadow: theme.shadows[12]
  },
  color: theme.palette.getContrastText(theme.palette.grey[300]),
  backgroundColor: theme.palette.grey[300],
  '&:hover': {
    backgroundColor: theme.palette.grey.A100,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.palette.grey[300]
    },
    textDecoration: 'none'
  },
  [`&.${fabClasses$1.focusVisible}`]: {
    boxShadow: theme.shadows[6]
  },
  [`&.${fabClasses$1.disabled}`]: {
    color: theme.palette.action.disabled,
    boxShadow: theme.shadows[0],
    backgroundColor: theme.palette.action.disabledBackground
  }
}, ownerState.size === 'small' && {
  width: 40,
  height: 40
}, ownerState.size === 'medium' && {
  width: 48,
  height: 48
}, ownerState.variant === 'extended' && {
  borderRadius: 48 / 2,
  padding: '0 16px',
  width: 'auto',
  minHeight: 'auto',
  minWidth: 48,
  height: 48
}, ownerState.variant === 'extended' && ownerState.size === 'small' && {
  width: 'auto',
  padding: '0 8px',
  borderRadius: 34 / 2,
  minWidth: 34,
  height: 34
}, ownerState.variant === 'extended' && ownerState.size === 'medium' && {
  width: 'auto',
  padding: '0 16px',
  borderRadius: 40 / 2,
  minWidth: 40,
  height: 40
}, ownerState.color === 'inherit' && {
  color: 'inherit'
}), ({
  theme,
  ownerState
}) => _extends$P({}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && theme.palette[ownerState.color] != null && {
  color: theme.palette[ownerState.color].contrastText,
  backgroundColor: theme.palette[ownerState.color].main,
  '&:hover': {
    backgroundColor: theme.palette[ownerState.color].dark,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.palette[ownerState.color].main
    }
  }
}));
const Fab = /*#__PURE__*/React$d.forwardRef(function Fab(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFab'
  });

  const {
    children,
    className,
    color = 'default',
    component = 'button',
    disabled = false,
    disableFocusRipple = false,
    focusVisibleClassName,
    size = 'large',
    variant = 'circular'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$$);

  const ownerState = _extends$P({}, props, {
    color,
    component,
    disabled,
    disableFocusRipple,
    size,
    variant
  });

  const classes = useUtilityClasses$F(ownerState);
  return /*#__PURE__*/jsx$1(FabRoot, _extends$P({
    className: clsx(classes.root, className),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? Fab.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'default'
   */
  color: PropTypes$1.oneOf(['default', 'error', 'info', 'inherit', 'primary', 'secondary', 'success', 'warning']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: PropTypes$1.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes$1.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes$1.string,

  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['small', 'medium', 'large']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['circular', 'extended']), PropTypes$1.string])
} : void 0;
var MUIFab = Fab;

const _excluded$_ = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "type"];

const useUtilityClasses$E = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getFilledInputUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const FilledInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiFilledInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...rootOverridesResolver(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
  return _extends$P({
    position: 'relative',
    backgroundColor,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    '&:hover': {
      backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor
      }
    },
    [`&.${filledInputClasses$1.focused}`]: {
      backgroundColor
    },
    [`&.${filledInputClasses$1.disabled}`]: {
      backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
    }
  }, !ownerState.disableUnderline && {
    '&:after': {
      borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&.${filledInputClasses$1.focused}:after`]: {
      transform: 'scaleX(1)'
    },
    [`&.${filledInputClasses$1.error}:after`]: {
      borderBottomColor: theme.palette.error.main,
      transform: 'scaleX(1)' // error is always underlined in red

    },
    '&:before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&:hover:not(.${filledInputClasses$1.disabled}):before`]: {
      borderBottom: `1px solid ${theme.palette.text.primary}`
    },
    [`&.${filledInputClasses$1.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  }, ownerState.startAdornment && {
    paddingLeft: 12
  }, ownerState.endAdornment && {
    paddingRight: 12
  }, ownerState.multiline && _extends$P({
    padding: '25px 12px 8px'
  }, ownerState.size === 'small' && {
    paddingTop: 21,
    paddingBottom: 4
  }, ownerState.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }));
});
const FilledInputInput = styled$1(InputBaseComponent, {
  name: 'MuiFilledInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$P({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  }
}, ownerState.size === 'small' && {
  paddingTop: 21,
  paddingBottom: 4
}, ownerState.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, ownerState.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}, ownerState.hiddenLabel && ownerState.size === 'small' && {
  paddingTop: 8,
  paddingBottom: 9
}));
const FilledInput = /*#__PURE__*/React$d.forwardRef(function FilledInput(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFilledInput'
  });

  const {
    components = {},
    componentsProps: componentsPropsProp,
    fullWidth = false,
    // declare here to prevent spreading to DOM
    inputComponent = 'input',
    multiline = false,
    type = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$_);

  const ownerState = _extends$P({}, props, {
    fullWidth,
    inputComponent,
    multiline,
    type
  });

  const classes = useUtilityClasses$E(props);
  const filledInputComponentsProps = {
    root: {
      ownerState
    },
    input: {
      ownerState
    }
  };
  const componentsProps = componentsPropsProp ? deepmerge$2(componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
  return /*#__PURE__*/jsx$1(InputBase$1, _extends$P({
    components: _extends$P({
      Root: FilledInputRoot,
      Input: FilledInputInput
    }, components),
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? FilledInput.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes$1.string,

  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary']), PropTypes$1.string]),

  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Input: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    input: PropTypes$1.object,
    root: PropTypes$1.object
  }),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes$1.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes$1.node,

  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes$1.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes$1.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes$1.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * If `true`, a [TextareaAutosize](/components/textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes$1.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes$1.func,

  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes$1.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes$1.bool,

  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes$1.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes$1.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes$1.any
} : void 0;
FilledInput.muiName = 'Input';
var FilledInput$1 = FilledInput;

function getFormControlUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControl', slot);
}
generateUtilityClasses('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);

const _excluded$Z = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];

const useUtilityClasses$D = ownerState => {
  const {
    classes,
    margin,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', margin !== 'none' && `margin${capitalize$3(margin)}`, fullWidth && 'fullWidth']
  };
  return composeClasses(slots, getFormControlUtilityClasses, classes);
};

const FormControlRoot = styled$1('div', {
  name: 'MuiFormControl',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return _extends$P({}, styles.root, styles[`margin${capitalize$3(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
  }
})(({
  ownerState
}) => _extends$P({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: 'top'
}, ownerState.margin === 'normal' && {
  marginTop: 16,
  marginBottom: 8
}, ownerState.margin === 'dense' && {
  marginTop: 8,
  marginBottom: 4
}, ownerState.fullWidth && {
  width: '100%'
}));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */

const FormControl = /*#__PURE__*/React$d.forwardRef(function FormControl(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormControl'
  });

  const {
    children,
    className,
    color = 'primary',
    component = 'div',
    disabled = false,
    error = false,
    focused: visuallyFocused,
    fullWidth = false,
    hiddenLabel = false,
    margin = 'none',
    required = false,
    size = 'medium',
    variant = 'outlined'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$Z);

  const ownerState = _extends$P({}, props, {
    color,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    variant
  });

  const classes = useUtilityClasses$D(ownerState);
  const [adornedStart, setAdornedStart] = React$d.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialAdornedStart = false;

    if (children) {
      React$d.Children.forEach(children, child => {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        const input = isMuiElement(child, ['Select']) ? child.props.input : child;

        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  });
  const [filled, setFilled] = React$d.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;

    if (children) {
      React$d.Children.forEach(children, child => {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        if (isFilled(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  });
  const [focusedState, setFocused] = React$d.useState(false);

  if (disabled && focusedState) {
    setFocused(false);
  }

  const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
  let registerEffect;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const registeredInput = React$d.useRef(false);

    registerEffect = () => {
      if (registeredInput.current) {
        console.error(['MUI: There are multiple `InputBase` components inside a FormControl.', 'This creates visual inconsistencies, only use one `InputBase`.'].join('\n'));
      }

      registeredInput.current = true;
      return () => {
        registeredInput.current = false;
      };
    };
  }

  const onFilled = React$d.useCallback(() => {
    setFilled(true);
  }, []);
  const onEmpty = React$d.useCallback(() => {
    setFilled(false);
  }, []);
  const childContext = {
    adornedStart,
    setAdornedStart,
    color,
    disabled,
    error,
    filled,
    focused,
    fullWidth,
    hiddenLabel,
    size,
    onBlur: () => {
      setFocused(false);
    },
    onEmpty,
    onFilled,
    onFocus: () => {
      setFocused(true);
    },
    registerEffect,
    required,
    variant
  };
  return /*#__PURE__*/jsx$1(FormControlContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsx$1(FormControlRoot, _extends$P({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes$1.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes$1.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes$1.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes$1.bool,

  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes$1.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormControl$1 = FormControl;

function getFormControlLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControlLabel', slot);
}
const formControlLabelClasses = generateUtilityClasses('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label', 'error']);
var formControlLabelClasses$1 = formControlLabelClasses;

const _excluded$Y = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "value"];

const useUtilityClasses$C = ownerState => {
  const {
    classes,
    disabled,
    labelPlacement,
    error
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', `labelPlacement${capitalize$3(labelPlacement)}`, error && 'error'],
    label: ['label', disabled && 'disabled']
  };
  return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
};

const FormControlLabelRoot = styled$1('label', {
  name: 'MuiFormControlLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formControlLabelClasses$1.label}`]: styles.label
    }, styles.root, styles[`labelPlacement${capitalize$3(ownerState.labelPlacement)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'transparent',
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses$1.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.labelPlacement === 'start' && {
  flexDirection: 'row-reverse',
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, ownerState.labelPlacement === 'top' && {
  flexDirection: 'column-reverse',
  marginLeft: 16
}, ownerState.labelPlacement === 'bottom' && {
  flexDirection: 'column',
  marginLeft: 16
}, {
  [`& .${formControlLabelClasses$1.label}`]: {
    [`&.${formControlLabelClasses$1.disabled}`]: {
      color: theme.palette.text.disabled
    }
  }
}));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

const FormControlLabel = /*#__PURE__*/React$d.forwardRef(function FormControlLabel(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormControlLabel'
  });

  const {
    className,
    componentsProps = {},
    control,
    disabled: disabledProp,
    disableTypography,
    label: labelProp,
    labelPlacement = 'end'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$Y);

  const muiFormControl = useFormControl();
  let disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  const controlProps = {
    disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(key => {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['error']
  });

  const ownerState = _extends$P({}, props, {
    disabled,
    labelPlacement,
    error: fcs.error
  });

  const classes = useUtilityClasses$C(ownerState);
  let label = labelProp;

  if (label != null && label.type !== Typography$1 && !disableTypography) {
    label = /*#__PURE__*/jsx$1(Typography$1, _extends$P({
      component: "span",
      className: classes.label
    }, componentsProps.typography, {
      children: label
    }));
  }

  return /*#__PURE__*/jsxs(FormControlLabelRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/React$d.cloneElement(control, controlProps), label]
  }));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    typography: PropTypes$1.object
  }),

  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes$1.element.isRequired,

  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes$1.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes$1.node,

  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes$1.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * @ignore
   */
  name: PropTypes$1.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes$1.func,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The value of the component.
   */
  value: PropTypes$1.any
} : void 0;
var FormControlLabel$1 = FormControlLabel;

function getFormHelperTextUtilityClasses(slot) {
  return generateUtilityClass('MuiFormHelperText', slot);
}
const formHelperTextClasses = generateUtilityClasses('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
var formHelperTextClasses$1 = formHelperTextClasses;

var _span$3;

const _excluded$X = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];

const useUtilityClasses$B = ownerState => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', error && 'error', size && `size${capitalize$3(size)}`, contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
  };
  return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
};

const FormHelperTextRoot = styled$1('p', {
  name: 'MuiFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size && styles[`size${capitalize$3(ownerState.size)}`], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  color: theme.palette.text.secondary
}, theme.typography.caption, {
  textAlign: 'left',
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses$1.disabled}`]: {
    color: theme.palette.text.disabled
  },
  [`&.${formHelperTextClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}, ownerState.size === 'small' && {
  marginTop: 4
}, ownerState.contained && {
  marginLeft: 14,
  marginRight: 14
}));
const FormHelperText = /*#__PURE__*/React$d.forwardRef(function FormHelperText(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormHelperText'
  });

  const {
    children,
    className,
    component = 'p'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$X);

  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
  });

  const ownerState = _extends$P({}, props, {
    component,
    contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });

  const classes = useUtilityClasses$B(ownerState);
  return /*#__PURE__*/jsx$1(FormHelperTextRoot, _extends$P({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: children === ' ' ? // notranslate needed while Google Translate will not fix zero-width space issue
    _span$3 || (_span$3 = /*#__PURE__*/jsx$1("span", {
      className: "notranslate",
      children: "\u200B"
    })) : children
  }));
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes$1.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes$1.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes$1.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   */
  variant: PropTypes$1.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormHelperText$1 = FormHelperText;

function getFormLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormLabel', slot);
}
const formLabelClasses = generateUtilityClasses('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
var formLabelClasses$1 = formLabelClasses;

const _excluded$W = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];

const useUtilityClasses$A = ownerState => {
  const {
    classes,
    color,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$3(color)}`, disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
    asterisk: ['asterisk', error && 'error']
  };
  return composeClasses(slots, getFormLabelUtilityClasses, classes);
};

const FormLabelRoot = styled$1('label', {
  name: 'MuiFormLabel',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return _extends$P({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  color: theme.palette.text.secondary
}, theme.typography.body1, {
  lineHeight: '1.4375em',
  padding: 0,
  position: 'relative',
  [`&.${formLabelClasses$1.focused}`]: {
    color: theme.palette[ownerState.color].main
  },
  [`&.${formLabelClasses$1.disabled}`]: {
    color: theme.palette.text.disabled
  },
  [`&.${formLabelClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}));
const AsteriskComponent = styled$1('span', {
  name: 'MuiFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${formLabelClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}));
const FormLabel = /*#__PURE__*/React$d.forwardRef(function FormLabel(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormLabel'
  });

  const {
    children,
    className,
    component = 'label'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$W);

  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });

  const ownerState = _extends$P({}, props, {
    color: fcs.color || 'primary',
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });

  const classes = useUtilityClasses$A(ownerState);
  return /*#__PURE__*/jsxs(FormLabelRoot, _extends$P({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: [children, fcs.required && /*#__PURE__*/jsxs(AsteriskComponent, {
      ownerState: ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: ["\u2009", '*']
    })]
  }));
});
process.env.NODE_ENV !== "production" ? FormLabel.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes$1.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes$1.bool,

  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var FormLabel$1 = FormLabel;

const _excluded$V = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}

const styles$1 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * Conditionally apply a workaround for the CSS transition bug in Safari 15.4.
 * Remove this workaround once the Safari bug is fixed.
 */

const isSafari154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /version\/15\.[4-9]/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Grow = /*#__PURE__*/React$d.forwardRef(function Grow(props, ref) {
  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = 'auto',
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$2
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$V);

  const timer = React$d.useRef();
  const autoTimeout = React$d.useRef();
  const theme = useTheme();
  const nodeRef = React$d.useRef(null);
  const foreignRef = useForkRef(children.ref, ref);
  const handleRef = useForkRef(nodeRef, foreignRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    let duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isSafari154 ? duration : duration * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    let duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isSafari154 ? duration : duration * 0.666,
      delay: isSafari154 ? delay : delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = 0;
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }

    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  React$d.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$d.cloneElement(children, _extends$P({
        style: _extends$P({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$1[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Grow.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes$1.func,

  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes$1.bool,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes$1.oneOfType([PropTypes$1.shape({
    enter: PropTypes$1.string,
    exit: PropTypes$1.string
  }), PropTypes$1.string]),

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes$1.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntered: PropTypes$1.func,

  /**
   * @ignore
   */
  onEntering: PropTypes$1.func,

  /**
   * @ignore
   */
  onExit: PropTypes$1.func,

  /**
   * @ignore
   */
  onExited: PropTypes$1.func,

  /**
   * @ignore
   */
  onExiting: PropTypes$1.func,

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
var Grow$1 = Grow;

/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const [match, setMatch] = React$d.useState(() => {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  });
  useEnhancedEffect$2(() => {
    let active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    const queryList = matchMedia(query);

    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch(); // TODO: Use `addEventListener` once support for Safari < 14 is dropped

    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);
  return match;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814


const maybeReactUseSyncExternalStore = React$d['useSyncExternalStore' + ''];

function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia) {
  const getDefaultSnapshot = React$d.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = React$d.useMemo(() => {
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }

    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia]);
  const [getSnapshot, subscribe] = React$d.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }

    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}

function useMediaQuery(queryInput, options = {}) {
  const theme = useTheme$2(); // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr
  } = getThemeProps({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });

  if (process.env.NODE_ENV !== 'production') {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['MUI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable

  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$d.useDebugValue({
      query,
      match
    });
  }

  return match;
}

const _excluded$U = ["initialWidth", "width"];
const breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl']; // By default, returns true if screen width is the same or greater than the given breakpoint.

const isWidthUp = (breakpoint, width, inclusive = true) => {
  if (inclusive) {
    return breakpointKeys.indexOf(breakpoint) <= breakpointKeys.indexOf(width);
  }

  return breakpointKeys.indexOf(breakpoint) < breakpointKeys.indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.

const isWidthDown = (breakpoint, width, inclusive = false) => {
  if (inclusive) {
    return breakpointKeys.indexOf(width) <= breakpointKeys.indexOf(breakpoint);
  }

  return breakpointKeys.indexOf(width) < breakpointKeys.indexOf(breakpoint);
};

const withWidth = (options = {}) => Component => {
  const {
    withTheme: withThemeOption = false,
    noSSR = false,
    initialWidth: initialWidthOption
  } = options;

  function WithWidth(props) {
    const contextTheme = useTheme();
    const theme = props.theme || contextTheme;

    const _getThemeProps = getThemeProps({
      theme,
      name: 'MuiWithWidth',
      props
    }),
          {
      initialWidth,
      width
    } = _getThemeProps,
          other = _objectWithoutPropertiesLoose$3(_getThemeProps, _excluded$U);

    const [mountedState, setMountedState] = React$d.useState(false);
    useEnhancedEffect$2(() => {
      setMountedState(true);
    }, []);
    /**
     * innerWidth |xs      sm      md      lg      xl
     *            |-------|-------|-------|-------|------>
     * width      |  xs   |  sm   |  md   |  lg   |  xl
     */

    const keys = theme.breakpoints.keys.slice().reverse();
    const widthComputed = keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null);

    const more = _extends$P({
      width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
    }, withThemeOption ? {
      theme
    } : {}, other); // When rendering the component on the server,
    // we have no idea about the client browser screen width.
    // In order to prevent blinks and help the reconciliation of the React tree
    // we are not rendering the child component.
    //
    // An alternative is to use the `initialWidth` property.


    if (more.width === undefined) {
      return null;
    }

    return /*#__PURE__*/jsx$1(Component, _extends$P({}, more));
  }

  process.env.NODE_ENV !== "production" ? WithWidth.propTypes = {
    /**
     * As `window.innerWidth` is unavailable on the server,
     * we default to rendering an empty component during the first mount.
     * You might want to use a heuristic to approximate
     * the screen width of the client browser screen width.
     *
     * For instance, you could be using the user-agent or the client-hints.
     * https://caniuse.com/#search=client%20hint
     */
    initialWidth: PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

    /**
     * @ignore
     */
    theme: PropTypes$1.object,

    /**
     * Bypass the width calculation logic.
     */
    width: PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
  } : void 0;

  if (process.env.NODE_ENV !== 'production') {
    WithWidth.displayName = `WithWidth(${getDisplayName(Component)})`;
  }

  hoistNonReactStatics_cjs(WithWidth, Component);
  return WithWidth;
};

var withWidth$1 = withWidth;

/**
 * @ignore - internal component.
 */

function HiddenJs(props) {
  const {
    children,
    only,
    width
  } = props;
  const theme = useTheme();
  let visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (let i = 0; i < only.length; i += 1) {
        const breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (let i = 0; i < theme.breakpoints.keys.length; i += 1) {
      const breakpoint = theme.breakpoints.keys[i];
      const breakpointUp = props[`${breakpoint}Up`];
      const breakpointDown = props[`${breakpoint}Down`];

      if (breakpointUp && isWidthUp(breakpoint, width) || breakpointDown && isWidthDown(breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes$1.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use a heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down are hidden.
   */
  lgDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  lgUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   */
  mdDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  mdUp: PropTypes$1.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes$1.oneOfType([PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes$1.arrayOf(PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down are hidden.
   */
  smDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  smUp: PropTypes$1.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: PropTypes$1.string.isRequired,

  /**
   * If `true`, screens this size and down are hidden.
   */
  xlDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  xlUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   */
  xsDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  xsUp: PropTypes$1.bool
};

if (process.env.NODE_ENV !== 'production') {
  HiddenJs.propTypes = exactProp(HiddenJs.propTypes);
}

var HiddenJs$1 = withWidth$1()(HiddenJs);

function getHiddenCssUtilityClass(slot) {
  return generateUtilityClass('PrivateHiddenCss', slot);
}
generateUtilityClasses('PrivateHiddenCss', ['root', 'xlDown', 'xlUp', 'onlyXl', 'lgDown', 'lgUp', 'onlyLg', 'mdDown', 'mdUp', 'onlyMd', 'smDown', 'smUp', 'onlySm', 'xsDown', 'xsUp', 'onlyXs']);

const _excluded$T = ["children", "className", "only"];

const useUtilityClasses$z = ownerState => {
  const {
    classes,
    breakpoints
  } = ownerState;
  const slots = {
    root: ['root', ...breakpoints.map(({
      breakpoint,
      dir
    }) => {
      return dir === 'only' ? `${dir}${capitalize$3(breakpoint)}` : `${breakpoint}${capitalize$3(dir)}`;
    })]
  };
  return composeClasses(slots, getHiddenCssUtilityClass, classes);
};

const HiddenCssRoot = styled$1('div', {
  name: 'PrivateHiddenCss',
  slot: 'Root'
})(({
  theme,
  ownerState
}) => {
  const hidden = {
    display: 'none'
  };
  return _extends$P({}, ownerState.breakpoints.map(({
    breakpoint,
    dir
  }) => {
    if (dir === 'only') {
      return {
        [theme.breakpoints.only(breakpoint)]: hidden
      };
    }

    return dir === 'up' ? {
      [theme.breakpoints.up(breakpoint)]: hidden
    } : {
      [theme.breakpoints.down(breakpoint)]: hidden
    };
  }).reduce((r, o) => {
    Object.keys(o).forEach(k => {
      r[k] = o[k];
    });
    return r;
  }, {}));
});
/**
 * @ignore - internal component.
 */

function HiddenCss(props) {
  const {
    children,
    className,
    only
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$T);

  const theme = useTheme();

  if (process.env.NODE_ENV !== 'production') {
    const unknownProps = Object.keys(other).filter(propName => {
      const isUndeclaredBreakpoint = !theme.breakpoints.keys.some(breakpoint => {
        return `${breakpoint}Up` === propName || `${breakpoint}Down` === propName;
      });
      return !['classes', 'theme', 'isRtl', 'sx'].includes(propName) && isUndeclaredBreakpoint;
    });

    if (unknownProps.length > 0) {
      console.error(`MUI: Unsupported props received by \`<Hidden implementation="css" />\`: ${unknownProps.join(', ')}. Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?`);
    }
  }

  const breakpoints = [];

  for (let i = 0; i < theme.breakpoints.keys.length; i += 1) {
    const breakpoint = theme.breakpoints.keys[i];
    const breakpointUp = other[`${breakpoint}Up`];
    const breakpointDown = other[`${breakpoint}Down`];

    if (breakpointUp) {
      breakpoints.push({
        breakpoint,
        dir: 'up'
      });
    }

    if (breakpointDown) {
      breakpoints.push({
        breakpoint,
        dir: 'down'
      });
    }
  }

  if (only) {
    const onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(breakpoint => {
      breakpoints.push({
        breakpoint,
        dir: 'only'
      });
    });
  }

  const ownerState = _extends$P({}, props, {
    breakpoints
  });

  const classes = useUtilityClasses$z(ownerState);
  return /*#__PURE__*/jsx$1(HiddenCssRoot, {
    className: clsx(classes.root, className),
    ownerState: ownerState,
    children: children
  });
}

process.env.NODE_ENV !== "production" ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes$1.oneOf(['js', 'css']),

  /**
   * If `true`, screens this size and down are hidden.
   */
  lgDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  lgUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   */
  mdDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  mdUp: PropTypes$1.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes$1.oneOfType([PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes$1.arrayOf(PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down are hidden.
   */
  smDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  smUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   */
  xlDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  xlUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   */
  xsDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   */
  xsUp: PropTypes$1.bool
} : void 0;

const _excluded$S = ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"];

function Hidden(props) {
  const {
    implementation = 'js',
    lgDown = false,
    lgUp = false,
    mdDown = false,
    mdUp = false,
    smDown = false,
    smUp = false,
    xlDown = false,
    xlUp = false,
    xsDown = false,
    xsUp = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$S);

  if (implementation === 'js') {
    return /*#__PURE__*/jsx$1(HiddenJs$1, _extends$P({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }

  return /*#__PURE__*/jsx$1(HiddenCss, _extends$P({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}

process.env.NODE_ENV !== "production" ? Hidden.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   * @default 'js'
   */
  implementation: PropTypes$1.oneOf(['css', 'js']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use a heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down are hidden.
   * @default false
   */
  lgDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   * @default false
   */
  lgUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   * @default false
   */
  mdDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   * @default false
   */
  mdUp: PropTypes$1.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes$1.oneOfType([PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes$1.arrayOf(PropTypes$1.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired)]),

  /**
   * If `true`, screens this size and down are hidden.
   * @default false
   */
  smDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   * @default false
   */
  smUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   * @default false
   */
  xlDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   * @default false
   */
  xlUp: PropTypes$1.bool,

  /**
   * If `true`, screens this size and down are hidden.
   * @default false
   */
  xsDown: PropTypes$1.bool,

  /**
   * If `true`, screens this size and up are hidden.
   * @default false
   */
  xsUp: PropTypes$1.bool
} : void 0;

const _excluded$R = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "type"];

const useUtilityClasses$y = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getInputUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const InputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...rootOverridesResolver(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return _extends$P({
    position: 'relative'
  }, ownerState.formControl && {
    'label + &': {
      marginTop: 16
    }
  }, !ownerState.disableUnderline && {
    '&:after': {
      borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&.${inputClasses$1.focused}:after`]: {
      transform: 'scaleX(1)'
    },
    [`&.${inputClasses$1.error}:after`]: {
      borderBottomColor: theme.palette.error.main,
      transform: 'scaleX(1)' // error is always underlined in red

    },
    '&:before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&:hover:not(.${inputClasses$1.disabled}):before`]: {
      borderBottom: `2px solid ${theme.palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        borderBottom: `1px solid ${bottomLineColor}`
      }
    },
    [`&.${inputClasses$1.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  });
});
const InputInput = styled$1(InputBaseComponent, {
  name: 'MuiInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})({});
const Input$7 = /*#__PURE__*/React$d.forwardRef(function Input(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiInput'
  });

  const {
    disableUnderline,
    components = {},
    componentsProps: componentsPropsProp,
    fullWidth = false,
    inputComponent = 'input',
    multiline = false,
    type = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$R);

  const classes = useUtilityClasses$y(props);
  const ownerState = {
    disableUnderline
  };
  const inputComponentsProps = {
    root: {
      ownerState
    }
  };
  const componentsProps = componentsPropsProp ? deepmerge$2(componentsPropsProp, inputComponentsProps) : inputComponentsProps;
  return /*#__PURE__*/jsx$1(InputBase$1, _extends$P({
    components: _extends$P({
      Root: InputRoot,
      Input: InputInput
    }, components),
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? Input$7.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes$1.string,

  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary']), PropTypes$1.string]),

  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Input: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    input: PropTypes$1.object,
    root: PropTypes$1.object
  }),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: PropTypes$1.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes$1.node,

  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes$1.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes$1.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * If `true`, a [TextareaAutosize](/components/textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes$1.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes$1.func,

  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes$1.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes$1.bool,

  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes$1.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes$1.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes$1.any
} : void 0;
Input$7.muiName = 'Input';
var Input$8 = Input$7;

function getInputAdornmentUtilityClass(slot) {
  return generateUtilityClass('MuiInputAdornment', slot);
}
const inputAdornmentClasses = generateUtilityClasses('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
var inputAdornmentClasses$1 = inputAdornmentClasses;

var _span$2;

const _excluded$Q = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];

const overridesResolver$3 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${capitalize$3(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};

const useUtilityClasses$x = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${capitalize$3(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${capitalize$3(size)}`]
  };
  return composeClasses(slots, getInputAdornmentUtilityClass, classes);
};

const InputAdornmentRoot = styled$1('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver: overridesResolver$3
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: theme.palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses$1.positionStart}&:not(.${inputAdornmentClasses$1.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment = /*#__PURE__*/React$d.forwardRef(function InputAdornment(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiInputAdornment'
  });

  const {
    children,
    className,
    component = 'div',
    disablePointerEvents = false,
    disableTypography = false,
    position,
    variant: variantProp
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$Q);

  const muiFormControl = useFormControl() || {};
  let variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === muiFormControl.variant) {
        console.error('MUI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  const ownerState = _extends$P({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });

  const classes = useUtilityClasses$x(ownerState);
  return /*#__PURE__*/jsx$1(FormControlContext$1.Provider, {
    value: null,
    children: /*#__PURE__*/jsx$1(InputAdornmentRoot, _extends$P({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/jsx$1(Typography$1, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/jsxs(React$d.Fragment, {
        children: [position === 'start' ?
        /* notranslate needed while Google Translate will not fix zero-width space issue */
        _span$2 || (_span$2 = /*#__PURE__*/jsx$1("span", {
          className: "notranslate",
          children: "\u200B"
        })) : null, children]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes$1.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes$1.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes$1.oneOf(['end', 'start']).isRequired,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes$1.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputAdornment$1 = InputAdornment;

function getInputLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiInputLabel', slot);
}
generateUtilityClasses('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);

const _excluded$P = ["disableAnimation", "margin", "shrink", "variant"];

const useUtilityClasses$w = ownerState => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size === 'small' && 'sizeSmall', variant],
    asterisk: [required && 'asterisk']
  };
  const composedClasses = composeClasses(slots, getInputLabelUtilityClasses, classes);
  return _extends$P({}, classes, composedClasses);
};

const InputLabelRoot = styled$1(FormLabel$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiInputLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formLabelClasses$1.asterisk}`]: styles.asterisk
    }, styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}, ownerState.formControl && {
  position: 'absolute',
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: 'translate(0, 20px) scale(1)'
}, ownerState.size === 'small' && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: 'translate(0, 17px) scale(1)'
}, ownerState.shrink && {
  transform: 'translate(0, -1.5px) scale(0.75)',
  transformOrigin: 'top left',
  maxWidth: '133%'
}, !ownerState.disableAnimation && {
  transition: theme.transitions.create(['color', 'transform', 'max-width'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.variant === 'filled' && _extends$P({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(12px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 13px) scale(1)'
}, ownerState.shrink && _extends$P({
  userSelect: 'none',
  pointerEvents: 'auto',
  transform: 'translate(12px, 7px) scale(0.75)',
  maxWidth: 'calc(133% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 4px) scale(0.75)'
})), ownerState.variant === 'outlined' && _extends$P({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(14px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(14px, 9px) scale(1)'
}, ownerState.shrink && {
  userSelect: 'none',
  pointerEvents: 'auto',
  maxWidth: 'calc(133% - 24px)',
  transform: 'translate(14px, -9px) scale(0.75)'
})));
const InputLabel = /*#__PURE__*/React$d.forwardRef(function InputLabel(inProps, ref) {
  const props = useThemeProps({
    name: 'MuiInputLabel',
    props: inProps
  });

  const {
    disableAnimation = false,
    shrink: shrinkProp
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$P);

  const muiFormControl = useFormControl();
  let shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['size', 'variant', 'required']
  });

  const ownerState = _extends$P({}, props, {
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required
  });

  const classes = useUtilityClasses$w(ownerState);
  return /*#__PURE__*/jsx$1(InputLabelRoot, _extends$P({
    "data-shrink": shrink,
    ownerState: ownerState,
    ref: ref
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? InputLabel.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), PropTypes$1.string]),

  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes$1.bool,

  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes$1.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes$1.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes$1.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The variant to use.
   */
  variant: PropTypes$1.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputLabel$1 = InputLabel;

function getLinearProgressUtilityClass(slot) {
  return generateUtilityClass('MuiLinearProgress', slot);
}
generateUtilityClasses('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);

const _excluded$O = ["className", "color", "value", "valueBuffer", "variant"];

let _$1 = t => t,
    _t$1,
    _t2$1,
    _t3$1,
    _t4$1,
    _t5,
    _t6;
const TRANSITION_DURATION = 4; // seconds

const indeterminate1Keyframe = keyframes(_t$1 || (_t$1 = _$1`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = keyframes(_t2$1 || (_t2$1 = _$1`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = keyframes(_t3$1 || (_t3$1 = _$1`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));

const useUtilityClasses$v = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$3(color)}`, variant],
    dashed: ['dashed', `dashedColor${capitalize$3(color)}`],
    bar1: ['bar', `barColor${capitalize$3(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${capitalize$3(color)}`, variant === 'buffer' && `color${capitalize$3(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return composeClasses(slots, getLinearProgressUtilityClass, classes);
};

const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }

  return theme.palette.mode === 'light' ? lighten(theme.palette[color].main, 0.62) : darken(theme.palette[color].main, 0.5);
};

const LinearProgressRoot = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${capitalize$3(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => _extends$P({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${capitalize$3(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return _extends$P({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, css(_t4$1 || (_t4$1 = _$1`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize$3(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends$P({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : theme.palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t5 || (_t5 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize$3(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends$P({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : theme.palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t6 || (_t6 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

const LinearProgress = /*#__PURE__*/React$d.forwardRef(function LinearProgress(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiLinearProgress'
  });

  const {
    className,
    color = 'primary',
    value,
    valueBuffer,
    variant = 'indeterminate'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$O);

  const ownerState = _extends$P({}, props, {
    color,
    variant
  });

  const classes = useUtilityClasses$v(ownerState);
  const theme = useTheme();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }

  return /*#__PURE__*/jsxs(LinearProgressRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/jsx$1(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/jsx$1(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/jsx$1(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['inherit', 'primary', 'secondary']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes$1.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes$1.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes$1.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
var MuiLinearProgress = LinearProgress;

function getLinkUtilityClass(slot) {
  return generateUtilityClass('MuiLink', slot);
}
const linkClasses = generateUtilityClasses('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
var linkClasses$1 = linkClasses;

const _excluded$N = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];
const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};

const useUtilityClasses$u = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${capitalize$3(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return composeClasses(slots, getLinkUtilityClass, classes);
};

const LinkRoot = styled$1(Typography$1, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${capitalize$3(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  const color = getPath(theme, `palette.${transformDeprecatedColors(ownerState.color)}`) || ownerState.color;
  return _extends$P({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && {
    textDecoration: 'underline',
    textDecorationColor: color !== 'inherit' ? alpha$2(color, 0.4) : undefined,
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }, ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    [`&.${linkClasses$1.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link$2 = /*#__PURE__*/React$d.forwardRef(function Link(inProps, ref) {
  const theme = useTheme();
  const props = useThemeProps({
    props: inProps,
    name: 'MuiLink'
  });

  const {
    className,
    color = 'primary',
    component = 'a',
    onBlur,
    onFocus,
    TypographyClasses,
    underline = 'always',
    variant = 'inherit',
    sx
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$N);

  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React$d.useState(false);
  const handlerRef = useForkRef(ref, focusVisibleRef);

  const handleBlur = event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  const handleFocus = event => {
    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  const ownerState = _extends$P({}, props, {
    // It is too complex to support any types of `sx`.
    // Need to find a better way to get rid of the color manipulation for `textDecorationColor`.
    color: (typeof sx === 'function' ? sx(theme).color : sx == null ? void 0 : sx.color) || color,
    component,
    focusVisible,
    underline,
    variant
  });

  const classes = useUtilityClasses$u(ownerState);
  return /*#__PURE__*/jsx$1(LinkRoot, _extends$P({
    className: clsx(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [{
      color: colorTransformations[color] || color
    }, ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
process.env.NODE_ENV !== "production" ? Link$2.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the link.
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .any,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * @ignore
   */
  onBlur: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: PropTypes$1.object,

  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: PropTypes$1.oneOf(['always', 'hover', 'none']),

  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']), PropTypes$1.string])
} : void 0;
var Link$3 = Link$2;

/**
 * @ignore - internal component.
 */

const ListContext = /*#__PURE__*/React$d.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

var ListContext$1 = ListContext;

function getListUtilityClass(slot) {
  return generateUtilityClass('MuiList', slot);
}
generateUtilityClasses('MuiList', ['root', 'padding', 'dense', 'subheader']);

const _excluded$M = ["children", "className", "component", "dense", "disablePadding", "subheader"];

const useUtilityClasses$t = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return composeClasses(slots, getListUtilityClass, classes);
};

const ListRoot = styled$1('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => _extends$P({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List$f = /*#__PURE__*/React$d.forwardRef(function List(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiList'
  });

  const {
    children,
    className,
    component = 'ul',
    dense = false,
    disablePadding = false,
    subheader
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$M);

  const context = React$d.useMemo(() => ({
    dense
  }), [dense]);

  const ownerState = _extends$P({}, props, {
    component,
    dense,
    disablePadding
  });

  const classes = useUtilityClasses$t(ownerState);
  return /*#__PURE__*/jsx$1(ListContext$1.Provider, {
    value: context,
    children: /*#__PURE__*/jsxs(ListRoot, _extends$P({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
process.env.NODE_ENV !== "production" ? List$f.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes$1.bool,

  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes$1.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var MiuList = List$f;

function getListItemUtilityClass(slot) {
  return generateUtilityClass('MuiListItem', slot);
}
const listItemClasses = generateUtilityClasses('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
var listItemClasses$1 = listItemClasses;

const listItemButtonClasses = generateUtilityClasses('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
var listItemButtonClasses$1 = listItemButtonClasses;

function getListItemSecondaryActionClassesUtilityClass(slot) {
  return generateUtilityClass('MuiListItemSecondaryAction', slot);
}
generateUtilityClasses('MuiListItemSecondaryAction', ['root', 'disableGutters']);

const _excluded$L = ["className"];

const useUtilityClasses$s = ownerState => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return composeClasses(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};

const ListItemSecondaryActionRoot = styled$1('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(({
  ownerState
}) => _extends$P({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.disableGutters && {
  right: 0
}));
/**
 * Must be used as the last child of ListItem to function properly.
 */

const ListItemSecondaryAction = /*#__PURE__*/React$d.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });

  const {
    className
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$L);

  const context = React$d.useContext(ListContext$1);

  const ownerState = _extends$P({}, props, {
    disableGutters: context.disableGutters
  });

  const classes = useUtilityClasses$s(ownerState);
  return /*#__PURE__*/jsx$1(ListItemSecondaryActionRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemSecondaryAction.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var ListItemSecondaryAction$1 = ListItemSecondaryAction;

const _excluded$K = ["className"],
      _excluded2$4 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected"];
const overridesResolver$2 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};

const useUtilityClasses$r = ownerState => {
  const {
    alignItems,
    button,
    classes,
    dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return composeClasses(slots, getListItemUtilityClass, classes);
};

const ListItemRoot = styled$1('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver: overridesResolver$2
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'left'
}, !ownerState.disablePadding && _extends$P({
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!ownerState.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!ownerState.secondaryAction && {
  [`& > .${listItemButtonClasses$1.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${listItemClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`&.${listItemClasses$1.selected}`]: {
    backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${listItemClasses$1.focusVisible}`]: {
      backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${listItemClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  }
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, ownerState.divider && {
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.button && {
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${listItemClasses$1.selected}:hover`]: {
    backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }
}, ownerState.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}));
const ListItemContainer = styled$1('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: (props, styles) => styles.container
})({
  position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

const ListItem = /*#__PURE__*/React$d.forwardRef(function ListItem(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItem'
  });

  const {
    alignItems = 'center',
    autoFocus = false,
    button = false,
    children: childrenProp,
    className,
    component: componentProp,
    components = {},
    componentsProps = {},
    ContainerComponent = 'li',
    ContainerProps: {
      className: ContainerClassName
    } = {},
    dense = false,
    disabled = false,
    disableGutters = false,
    disablePadding = false,
    divider = false,
    focusVisibleClassName,
    secondaryAction,
    selected = false
  } = props,
        ContainerProps = _objectWithoutPropertiesLoose$3(props.ContainerProps, _excluded$K),
        other = _objectWithoutPropertiesLoose$3(props, _excluded2$4);

  const context = React$d.useContext(ListContext$1);
  const childContext = {
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  };
  const listItemRef = React$d.useRef(null);
  useEnhancedEffect$2(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  const children = React$d.Children.toArray(childrenProp); // v4 implementation, deprecated in v5, will be removed in v6

  const hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);

  const ownerState = _extends$P({}, props, {
    alignItems,
    autoFocus,
    button,
    dense: childContext.dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  });

  const classes = useUtilityClasses$r(ownerState);
  const handleRef = useForkRef(listItemRef, ref);
  const Root = components.Root || ListItemRoot;
  const rootProps = componentsProps.root || {};

  const componentProps = _extends$P({
    className: clsx(classes.root, rootProps.className, className),
    disabled
  }, other);

  let Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(listItemClasses$1.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  } // v4 implementation, deprecated in v5, will be removed in v6


  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/jsx$1(ListContext$1.Provider, {
      value: childContext,
      children: /*#__PURE__*/jsxs(ListItemContainer, _extends$P({
        as: ContainerComponent,
        className: clsx(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/jsx$1(Root, _extends$P({}, rootProps, !isHostComponent(Root) && {
          as: Component,
          ownerState: _extends$P({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }

  return /*#__PURE__*/jsx$1(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxs(Root, _extends$P({}, rootProps, {
      as: Component,
      ref: handleRef,
      ownerState: ownerState
    }, !isHostComponent(Root) && {
      ownerState: _extends$P({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/jsx$1(ListItemSecondaryAction$1, {
        children: secondaryAction
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes$1.oneOf(['center', 'flex-start']),

  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  autoFocus: PropTypes$1.bool,

  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  button: PropTypes$1.bool,

  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes$1.node, props => {
    const children = React$d.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    let secondaryActionIndex = -1;

    for (let i = children.length - 1; i >= 0; i -= 1) {
      const child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('MUI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Root: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    root: PropTypes$1.object
  }),

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: elementTypeAcceptingRef$1,

  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: PropTypes$1.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes$1.bool,

  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes$1.bool,

  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes$1.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes$1.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes$1.string,

  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes$1.node,

  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/api/list-item-button/) instead
   */
  selected: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var ListItem$1 = ListItem;

const listItemIconClasses = generateUtilityClasses('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
var listItemIconClasses$1 = listItemIconClasses;

const listItemTextClasses = generateUtilityClasses('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
var listItemTextClasses$1 = listItemTextClasses;

const _excluded$J = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];

function nextItem$1(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem$1(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  let text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus$1(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }

  return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */


const MenuList = /*#__PURE__*/React$d.forwardRef(function MenuList(props, ref) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions,
    autoFocus = false,
    autoFocusItem = false,
    children,
    className,
    disabledItemsFocusable = false,
    disableListWrap = false,
    onKeyDown,
    variant = 'selectedMenu'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$J);

  const listRef = React$d.useRef(null);
  const textCriteriaRef = React$d.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect$2(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React$d.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, theme) => {
      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      const noExplicitWidth = !listRef.current.style.width;

      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${getScrollbarSize(ownerDocument(containerElement))}px`;
        listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }

      return listRef.current;
    }
  }), []);

  const handleKeyDown = event => {
    const list = listRef.current;
    const key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    const currentFocus = ownerDocument(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus$1(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem$1);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus$1(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem$1);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus$1(list, null, disableListWrap, disabledItemsFocusable, nextItem$1);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus$1(list, null, disableListWrap, disabledItemsFocusable, previousItem$1);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus$1(list, currentFocus, false, disabledItemsFocusable, nextItem$1, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleRef = useForkRef(listRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React$d.Children.forEach(children, (child, index) => {
    if (! /*#__PURE__*/React$d.isValidElement(child)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (reactIs$3.exports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  const items = React$d.Children.map(children, (child, index) => {
    if (index === activeItemIndex) {
      const newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/React$d.cloneElement(child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/jsx$1(MiuList, _extends$P({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
process.env.NODE_ENV !== "production" ? MenuList.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes$1.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes$1.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes$1.node,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes$1.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes$1.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes$1.oneOf(['menu', 'selectedMenu'])
} : void 0;
var MenuList$1 = MenuList;

function getPopoverUtilityClass(slot) {
  return generateUtilityClass('MuiPopover', slot);
}
generateUtilityClasses('MuiPopover', ['root', 'paper']);

const _excluded$I = ["onEntering"],
      _excluded2$3 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];
function getOffsetTop(rect, vertical) {
  let offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  let offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(n => typeof n === 'number' ? `${n}px` : n).join(' ');
}

function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

const useUtilityClasses$q = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return composeClasses(slots, getPopoverUtilityClass, classes);
};

const PopoverRoot = styled$1(Modal$1, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const PopoverPaper = styled$1(Paper$2, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /*#__PURE__*/React$d.forwardRef(function Popover(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPopover'
  });

  const {
    action,
    anchorEl,
    anchorOrigin = {
      vertical: 'top',
      horizontal: 'left'
    },
    anchorPosition,
    anchorReference = 'anchorEl',
    children,
    className,
    container: containerProp,
    elevation = 8,
    marginThreshold = 16,
    open,
    PaperProps = {},
    transformOrigin = {
      vertical: 'top',
      horizontal: 'left'
    },
    TransitionComponent = Grow$1,
    transitionDuration: transitionDurationProp = 'auto',
    TransitionProps: {
      onEntering
    } = {}
  } = props,
        TransitionProps = _objectWithoutPropertiesLoose$3(props.TransitionProps, _excluded$I),
        other = _objectWithoutPropertiesLoose$3(props, _excluded2$3);

  const paperRef = React$d.useRef();
  const handlePaperRef = useForkRef(paperRef, PaperProps.ref);

  const ownerState = _extends$P({}, props, {
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    PaperProps,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  });

  const classes = useUtilityClasses$q(ownerState); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  const getAnchorOffset = React$d.useCallback(() => {
    if (anchorReference === 'anchorPosition') {
      if (process.env.NODE_ENV !== 'production') {
        if (!anchorPosition) {
          console.error('MUI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    const resolvedAnchorEl = resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();

    if (process.env.NODE_ENV !== 'production') {
      const box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the base transform origin using the element

  const getTransformOrigin = React$d.useCallback(elemRect => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = React$d.useCallback(element => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    const elemTransformOrigin = getTransformOrigin(elemRect);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of the anchoring element


    const anchorOffset = getAnchorOffset(); // Calculate element positioning

    let top = anchorOffset.top - elemTransformOrigin.vertical;
    let left = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    const containerWindow = ownerWindow(resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['MUI: The popover component is too tall.', `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`, 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      const diff = left - marginThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    } else if (right > widthThreshold) {
      const diff = right - widthThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    }

    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const setPositioningStyles = React$d.useCallback(() => {
    const element = paperRef.current;

    if (!element) {
      return;
    }

    const positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  const handleEntering = (element, isAppearing) => {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  React$d.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });
  React$d.useImperativeHandle(action, () => open ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open, setPositioningStyles]);
  React$d.useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleResize = debounce$5(() => {
      setPositioningStyles();
    });
    const containerWindow = ownerWindow(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  const container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/jsx$1(PopoverRoot, _extends$P({
    BackdropProps: {
      invisible: true
    },
    className: clsx(classes.root, className),
    container: container,
    open: open,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
      appear: true,
      in: open,
      onEntering: handleEntering,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/jsx$1(PopoverPaper, _extends$P({
        elevation: elevation
      }, PaperProps, {
        ref: handlePaperRef,
        className: clsx(classes.paper, PaperProps.className),
        children: children
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$1,

  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]), props => {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      const resolvedAnchorEl = resolveAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', `It should be an Element instance but it's \`${resolvedAnchorEl}\` instead.`].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes$1.shape({
    horizontal: PropTypes$1.oneOfType([PropTypes$1.oneOf(['center', 'left', 'right']), PropTypes$1.number]).isRequired,
    vertical: PropTypes$1.oneOfType([PropTypes$1.oneOf(['bottom', 'center', 'top']), PropTypes$1.number]).isRequired
  }),

  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes$1.shape({
    left: PropTypes$1.number.isRequired,
    top: PropTypes$1.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes$1.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   * @default 16
   */
  marginThreshold: PropTypes$1.number,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: elementTypeAcceptingRef$1
  }),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes$1.shape({
    horizontal: PropTypes$1.oneOfType([PropTypes$1.oneOf(['center', 'left', 'right']), PropTypes$1.number]).isRequired,
    vertical: PropTypes$1.oneOfType([PropTypes$1.oneOf(['bottom', 'center', 'top']), PropTypes$1.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes$1.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes$1.object
} : void 0;
var Popover$1 = Popover;

function getMenuUtilityClass(slot) {
  return generateUtilityClass('MuiMenu', slot);
}
generateUtilityClasses('MuiMenu', ['root', 'paper', 'list']);

const _excluded$H = ["onEntering"],
      _excluded2$2 = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"];
const RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
const LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};

const useUtilityClasses$p = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return composeClasses(slots, getMenuUtilityClass, classes);
};

const MenuRoot = styled$1(Popover$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const MenuPaper = styled$1(Paper$2, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tapable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = styled$1(MenuList$1, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: (props, styles) => styles.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu$1 = /*#__PURE__*/React$d.forwardRef(function Menu(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiMenu'
  });

  const {
    autoFocus = true,
    children,
    disableAutoFocusItem = false,
    MenuListProps = {},
    onClose,
    open,
    PaperProps = {},
    PopoverClasses,
    transitionDuration = 'auto',
    TransitionProps: {
      onEntering
    } = {},
    variant = 'selectedMenu'
  } = props,
        TransitionProps = _objectWithoutPropertiesLoose$3(props.TransitionProps, _excluded$H),
        other = _objectWithoutPropertiesLoose$3(props, _excluded2$2);

  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  const ownerState = _extends$P({}, props, {
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  });

  const classes = useUtilityClasses$p(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  const menuListActionsRef = React$d.useRef(null);

  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React$d.Children.map(children, (child, index) => {
    if (! /*#__PURE__*/React$d.isValidElement(child)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (reactIs$3.exports.isFragment(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  return /*#__PURE__*/jsx$1(MenuRoot, _extends$P({
    classes: PopoverClasses,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: _extends$P({
      component: MenuPaper
    }, PaperProps, {
      classes: _extends$P({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    className: classes.root,
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: _extends$P({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsx$1(MenuMenuList, _extends$P({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: clsx(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Menu$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes$1.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes$1.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes$1.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes$1.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes$1.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.oneOf(['auto']), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes$1.object,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes$1.oneOf(['menu', 'selectedMenu'])
} : void 0;
var MuiMenu = Menu$1;

function getMenuItemUtilityClass(slot) {
  return generateUtilityClass('MuiMenuItem', slot);
}
const menuItemClasses = generateUtilityClasses('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
var menuItemClasses$1 = menuItemClasses;

const _excluded$G = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"];
const overridesResolver$1 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};

const useUtilityClasses$o = ownerState => {
  const {
    disabled,
    dense,
    divider,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  const composedClasses = composeClasses(slots, getMenuItemUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const MenuItemRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(({
  theme,
  ownerState
}) => _extends$P({}, theme.typography.body1, {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.divider && {
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundClip: 'padding-box'
}, {
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${menuItemClasses$1.selected}`]: {
    backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${menuItemClasses$1.focusVisible}`]: {
      backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses$1.selected}:hover`]: {
    backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`&.${menuItemClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  },
  [`& + .${dividerClasses$1.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${dividerClasses$1.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses$1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses$1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses$1.root}`]: {
    minWidth: 36
  }
}, !ownerState.dense && {
  [theme.breakpoints.up('sm')]: {
    minHeight: 'auto'
  }
}, ownerState.dense && _extends$P({
  minHeight: 32,
  // https://material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, theme.typography.body2, {
  [`& .${listItemIconClasses$1.root} svg`]: {
    fontSize: '1.25rem'
  }
})));
const MenuItem$1 = /*#__PURE__*/React$d.forwardRef(function MenuItem(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiMenuItem'
  });

  const {
    autoFocus = false,
    component = 'li',
    dense = false,
    divider = false,
    disableGutters = false,
    focusVisibleClassName,
    role = 'menuitem',
    tabIndex: tabIndexProp
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$G);

  const context = React$d.useContext(ListContext$1);
  const childContext = {
    dense: dense || context.dense || false,
    disableGutters
  };
  const menuItemRef = React$d.useRef(null);
  useEnhancedEffect$2(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);

  const ownerState = _extends$P({}, props, {
    dense: childContext.dense,
    divider,
    disableGutters
  });

  const classes = useUtilityClasses$o(props);
  const handleRef = useForkRef(menuItemRef, ref);
  let tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/jsx$1(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsx$1(MenuItemRoot, _extends$P({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
process.env.NODE_ENV !== "production" ? MenuItem$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes$1.bool,

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes$1.bool,

  /**
   * @ignore
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes$1.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes$1.bool,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes$1.string,

  /**
   * @ignore
   */
  role: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .string,

  /**
   * @ignore
   */
  selected: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * @default 0
   */
  tabIndex: PropTypes$1.number
} : void 0;
var MuiMenuItem = MenuItem$1;

function getNativeSelectUtilityClasses(slot) {
  return generateUtilityClass('MuiNativeSelect', slot);
}
const nativeSelectClasses = generateUtilityClasses('MuiNativeSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);
var nativeSelectClasses$1 = nativeSelectClasses;

const _excluded$F = ["className", "disabled", "IconComponent", "inputRef", "variant"];

const useUtilityClasses$n = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple'],
    icon: ['icon', `icon${capitalize$3(variant)}`, open && 'iconOpen', disabled && 'disabled']
  };
  return composeClasses(slots, getNativeSelectUtilityClasses, classes);
};

const nativeSelectSelectStyles = ({
  ownerState,
  theme
}) => _extends$P({
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: 'none',
  borderRadius: 0,
  // Reset
  cursor: 'pointer',
  '&:focus': {
    // Show that it's not an text input
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
    borderRadius: 0 // Reset Chrome style

  },
  // Remove IE11 arrow
  '&::-ms-expand': {
    display: 'none'
  },
  [`&.${nativeSelectClasses$1.disabled}`]: {
    cursor: 'default'
  },
  '&[multiple]': {
    height: 'auto'
  },
  '&:not([multiple]) option, &:not([multiple]) optgroup': {
    backgroundColor: theme.palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  '&&&': {
    paddingRight: 24,
    minWidth: 16 // So it doesn't collapse.

  }
}, ownerState.variant === 'filled' && {
  '&&&': {
    paddingRight: 32
  }
}, ownerState.variant === 'outlined' && {
  borderRadius: theme.shape.borderRadius,
  '&:focus': {
    borderRadius: theme.shape.borderRadius // Reset the reset for Chrome style

  },
  '&&&': {
    paddingRight: 32
  }
});
const NativeSelectSelect = styled$1('select', {
  name: 'MuiNativeSelect',
  slot: 'Select',
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.select, styles[ownerState.variant], {
      [`&.${nativeSelectClasses$1.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({
  ownerState,
  theme
}) => _extends$P({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: 'absolute',
  right: 0,
  top: 'calc(50% - .5em)',
  // Center vertically, height is 1em
  pointerEvents: 'none',
  // Don't block pointer events on the select under the icon.
  color: theme.palette.action.active,
  [`&.${nativeSelectClasses$1.disabled}`]: {
    color: theme.palette.action.disabled
  }
}, ownerState.open && {
  transform: 'rotate(180deg)'
}, ownerState.variant === 'filled' && {
  right: 7
}, ownerState.variant === 'outlined' && {
  right: 7
});
const NativeSelectIcon = styled$1('svg', {
  name: 'MuiNativeSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${capitalize$3(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);
/**
 * @ignore - internal component.
 */

const NativeSelectInput = /*#__PURE__*/React$d.forwardRef(function NativeSelectInput(props, ref) {
  const {
    className,
    disabled,
    IconComponent,
    inputRef,
    variant = 'standard'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$F);

  const ownerState = _extends$P({}, props, {
    disabled,
    variant
  });

  const classes = useUtilityClasses$n(ownerState);
  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [/*#__PURE__*/jsx$1(NativeSelectSelect, _extends$P({
      ownerState: ownerState,
      className: clsx(classes.select, className),
      disabled: disabled,
      ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/jsx$1(NativeSelectIcon, {
      as: IconComponent,
      ownerState: ownerState,
      className: classes.icon
    })]
  });
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes$1.string,

  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes$1.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType$1,

  /**
   * @ignore
   */
  multiple: PropTypes$1.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes$1.func,

  /**
   * The input value.
   */
  value: PropTypes$1.any,

  /**
   * The variant to use.
   */
  variant: PropTypes$1.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var NativeSelectInput$1 = NativeSelectInput;

var _span$1;

const _excluded$E = ["children", "classes", "className", "label", "notched"];
const NotchedOutlineRoot$1 = styled$1('fieldset')({
  textAlign: 'left',
  position: 'absolute',
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: 'inherit',
  borderStyle: 'solid',
  borderWidth: 1,
  overflow: 'hidden',
  minWidth: '0%'
});
const NotchedOutlineLegend = styled$1('legend')(({
  ownerState,
  theme
}) => _extends$P({
  float: 'unset',
  // Fix conflict with bootstrap
  overflow: 'hidden'
}, !ownerState.withLabel && {
  padding: 0,
  lineHeight: '11px',
  // sync with `height` in `legend` styles
  transition: theme.transitions.create('width', {
    duration: 150,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.withLabel && _extends$P({
  display: 'block',
  // Fix conflict with normalize.css and sanitize.css
  width: 'auto',
  // Fix conflict with bootstrap
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: '0.75em',
  visibility: 'hidden',
  maxWidth: 0.01,
  transition: theme.transitions.create('max-width', {
    duration: 50,
    easing: theme.transitions.easing.easeOut
  }),
  whiteSpace: 'nowrap',
  '& > span': {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'inline-block',
    opacity: 0,
    visibility: 'visible'
  }
}, ownerState.notched && {
  maxWidth: '100%',
  transition: theme.transitions.create('max-width', {
    duration: 100,
    easing: theme.transitions.easing.easeOut,
    delay: 50
  })
})));
/**
 * @ignore - internal component.
 */

function NotchedOutline(props) {
  const {
    className,
    label,
    notched
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$E);

  const withLabel = label != null && label !== '';

  const ownerState = _extends$P({}, props, {
    notched,
    withLabel
  });

  return /*#__PURE__*/jsx$1(NotchedOutlineRoot$1, _extends$P({
    "aria-hidden": true,
    className: className,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsx$1(NotchedOutlineLegend, {
      ownerState: ownerState,
      children: withLabel ? /*#__PURE__*/jsx$1("span", {
        children: label
      }) : // notranslate needed while Google Translate will not fix zero-width space issue
      _span$1 || (_span$1 = /*#__PURE__*/jsx$1("span", {
        className: "notranslate",
        children: "\u200B"
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The label.
   */
  label: PropTypes$1.node,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes$1.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes$1.object
} : void 0;

const _excluded$D = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "type"];

const useUtilityClasses$m = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    notchedOutline: ['notchedOutline'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getOutlinedInputUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const OutlinedInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiOutlinedInput',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return _extends$P({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
        borderColor
      }
    },
    [`&.${outlinedInputClasses$1.focused} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette[ownerState.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses$1.error} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette.error.main
    },
    [`&.${outlinedInputClasses$1.disabled} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette.action.disabled
    }
  }, ownerState.startAdornment && {
    paddingLeft: 14
  }, ownerState.endAdornment && {
    paddingRight: 14
  }, ownerState.multiline && _extends$P({
    padding: '16.5px 14px'
  }, ownerState.size === 'small' && {
    padding: '8.5px 14px'
  }));
});
const NotchedOutlineRoot = styled$1(NotchedOutline, {
  name: 'MuiOutlinedInput',
  slot: 'NotchedOutline',
  overridesResolver: (props, styles) => styles.notchedOutline
})(({
  theme
}) => ({
  borderColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'
}));
const OutlinedInputInput = styled$1(InputBaseComponent, {
  name: 'MuiOutlinedInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$P({
  padding: '16.5px 14px',
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderRadius: 'inherit'
  }
}, ownerState.size === 'small' && {
  padding: '8.5px 14px'
}, ownerState.multiline && {
  padding: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}));
const OutlinedInput = /*#__PURE__*/React$d.forwardRef(function OutlinedInput(inProps, ref) {
  var _React$Fragment;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiOutlinedInput'
  });

  const {
    components = {},
    fullWidth = false,
    inputComponent = 'input',
    label,
    multiline = false,
    notched,
    type = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$D);

  const classes = useUtilityClasses$m(props);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['required']
  });
  return /*#__PURE__*/jsx$1(InputBase$1, _extends$P({
    components: _extends$P({
      Root: OutlinedInputRoot,
      Input: OutlinedInputInput
    }, components),
    renderSuffix: state => /*#__PURE__*/jsx$1(NotchedOutlineRoot, {
      className: classes.notchedOutline,
      label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/jsxs(React$d.Fragment, {
        children: [label, "\xA0", '*']
      })) : label,
      notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: _extends$P({}, classes, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes$1.string,

  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary']), PropTypes$1.string]),

  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Input: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes$1.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes$1.node,

  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes$1.bool,

  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes$1.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes$1.node,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes$1.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * If `true`, a [TextareaAutosize](/components/textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes$1.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes$1.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes$1.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes$1.func,

  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes$1.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes$1.bool,

  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes$1.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes$1.node,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes$1.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes$1.any
} : void 0;
OutlinedInput.muiName = 'Input';
var OutlinedInput$1 = OutlinedInput;

var RadioButtonUncheckedIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

var RadioButtonCheckedIcon = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

const RadioButtonIconRoot = styled$1('span')({
  position: 'relative',
  display: 'flex'
});
const RadioButtonIconBackground = styled$1(RadioButtonUncheckedIcon)({
  // Scale applied to prevent dot misalignment in Safari
  transform: 'scale(1)'
});
const RadioButtonIconDot = styled$1(RadioButtonCheckedIcon)(({
  theme,
  ownerState
}) => _extends$P({
  left: 0,
  position: 'absolute',
  transform: 'scale(0)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest
  })
}, ownerState.checked && {
  transform: 'scale(1)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.shortest
  })
}));
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  const {
    checked = false,
    classes = {},
    fontSize
  } = props;

  const ownerState = _extends$P({}, props, {
    checked
  });

  return /*#__PURE__*/jsxs(RadioButtonIconRoot, {
    className: classes.root,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx$1(RadioButtonIconBackground, {
      fontSize: fontSize,
      className: classes.background,
      ownerState: ownerState
    }), /*#__PURE__*/jsx$1(RadioButtonIconDot, {
      fontSize: fontSize,
      className: classes.dot,
      ownerState: ownerState
    })]
  });
}

process.env.NODE_ENV !== "production" ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object,

  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: PropTypes$1.oneOf(['small', 'medium'])
} : void 0;

/**
 * @ignore - internal component.
 */
const RadioGroupContext = /*#__PURE__*/React$d.createContext(undefined);

if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

var RadioGroupContext$1 = RadioGroupContext;

function useRadioGroup() {
  return React$d.useContext(RadioGroupContext$1);
}

function getRadioUtilityClass(slot) {
  return generateUtilityClass('MuiRadio', slot);
}
const radioClasses = generateUtilityClasses('MuiRadio', ['root', 'checked', 'disabled', 'colorPrimary', 'colorSecondary']);
var radioClasses$1 = radioClasses;

const _excluded$C = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size"];

const useUtilityClasses$l = ownerState => {
  const {
    classes,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$3(color)}`]
  };
  return _extends$P({}, classes, composeClasses(slots, getRadioUtilityClass, classes));
};

const RadioRoot = styled$1(SwitchBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiRadio',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${capitalize$3(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: alpha$2(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${radioClasses$1.checked}`]: {
    color: theme.palette[ownerState.color].main
  }
}, {
  [`&.${radioClasses$1.disabled}`]: {
    color: theme.palette.action.disabled
  }
}));

function areEqualValues$1(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  } // The value could be a number, the DOM will stringify it anyway.


  return String(a) === String(b);
}

const defaultCheckedIcon = /*#__PURE__*/jsx$1(RadioButtonIcon, {
  checked: true
});

const defaultIcon = /*#__PURE__*/jsx$1(RadioButtonIcon, {});

const Radio$1 = /*#__PURE__*/React$d.forwardRef(function Radio(inProps, ref) {
  var _defaultIcon$props$fo, _defaultCheckedIcon$p;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiRadio'
  });

  const {
    checked: checkedProp,
    checkedIcon = defaultCheckedIcon,
    color = 'primary',
    icon = defaultIcon,
    name: nameProp,
    onChange: onChangeProp,
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$C);

  const ownerState = _extends$P({}, props, {
    color,
    size
  });

  const classes = useUtilityClasses$l(ownerState);
  const radioGroup = useRadioGroup();
  let checked = checkedProp;
  const onChange = createChainedFunction$1(onChangeProp, radioGroup && radioGroup.onChange);
  let name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = areEqualValues$1(radioGroup.value, props.value);
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/jsx$1(RadioRoot, _extends$P({
    type: "radio",
    icon: /*#__PURE__*/React$d.cloneElement(icon, {
      fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
    }),
    checkedIcon: /*#__PURE__*/React$d.cloneElement(checkedIcon, {
      fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
    }),
    ownerState: ownerState,
    classes: classes,
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Radio$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes$1.bool,

  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: PropTypes$1.bool,

  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: PropTypes$1.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes$1.func,

  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes$1.bool,

  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes$1.any
} : void 0;
var MuiRadio = Radio$1;

function getSelectUtilityClasses(slot) {
  return generateUtilityClass('MuiSelect', slot);
}
const selectClasses = generateUtilityClasses('MuiSelect', ['select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'focused', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);
var selectClasses$1 = selectClasses;

var _span;

const _excluded$B = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"];
const SelectSelect = styled$1('div', {
  name: 'MuiSelect',
  slot: 'Select',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [// Win specificity over the input base
    {
      [`&.${selectClasses$1.select}`]: styles.select
    }, {
      [`&.${selectClasses$1.select}`]: styles[ownerState.variant]
    }, {
      [`&.${selectClasses$1.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses$1.select}`]: {
    height: 'auto',
    // Resets for multiple select with chips
    minHeight: '1.4375em',
    // Required for select\text-field height consistency
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
});
const SelectIcon = styled$1('svg', {
  name: 'MuiSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${capitalize$3(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);
const SelectNativeInput = styled$1('input', {
  shouldForwardProp: prop => slotShouldForwardProp(prop) && prop !== 'classes',
  name: 'MuiSelect',
  slot: 'NativeInput',
  overridesResolver: (props, styles) => styles.nativeInput
})({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box'
});

function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  } // The value could be a number, the DOM will stringify it anyway.


  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}

const useUtilityClasses$k = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple'],
    icon: ['icon', `icon${capitalize$3(variant)}`, open && 'iconOpen', disabled && 'disabled'],
    nativeInput: ['nativeInput']
  };
  return composeClasses(slots, getSelectUtilityClasses, classes);
};
/**
 * @ignore - internal component.
 */


const SelectInput = /*#__PURE__*/React$d.forwardRef(function SelectInput(props, ref) {
  const {
    'aria-describedby': ariaDescribedby,
    'aria-label': ariaLabel,
    autoFocus,
    autoWidth,
    children,
    className,
    defaultOpen,
    defaultValue,
    disabled,
    displayEmpty,
    IconComponent,
    inputRef: inputRefProp,
    labelId,
    MenuProps = {},
    multiple,
    name,
    onBlur,
    onChange,
    onClose,
    onFocus,
    onOpen,
    open: openProp,
    readOnly,
    renderValue,
    SelectDisplayProps = {},
    tabIndex: tabIndexProp,
    value: valueProp,
    variant = 'standard'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$B);

  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  });
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: defaultOpen,
    name: 'Select'
  });
  const inputRef = React$d.useRef(null);
  const displayRef = React$d.useRef(null);
  const [displayNode, setDisplayNode] = React$d.useState(null);
  const {
    current: isOpenControlled
  } = React$d.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = React$d.useState();
  const handleRef = useForkRef(ref, inputRefProp);
  const handleDisplayRef = React$d.useCallback(node => {
    displayRef.current = node;

    if (node) {
      setDisplayNode(node);
    }
  }, []);
  React$d.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayRef.current.focus();
    },
    node: inputRef.current,
    value
  }), [value]); // Resize menu on `defaultOpen` automatic toggle.

  React$d.useEffect(() => {
    if (defaultOpen && openState && displayNode && !isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      displayRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [displayNode, autoWidth]); // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
  // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.

  React$d.useEffect(() => {
    if (autoFocus) {
      displayRef.current.focus();
    }
  }, [autoFocus]);
  React$d.useEffect(() => {
    if (!labelId) {
      return undefined;
    }

    const label = ownerDocument(displayRef.current).getElementById(labelId);

    if (label) {
      const handler = () => {
        if (getSelection().isCollapsed) {
          displayRef.current.focus();
        }
      };

      label.addEventListener('click', handler);
      return () => {
        label.removeEventListener('click', handler);
      };
    }

    return undefined;
  }, [labelId]);

  const update = (open, event) => {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  const handleMouseDown = event => {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayRef.current.focus();
    update(true, event);
  };

  const handleClose = event => {
    update(false, event);
  };

  const childrenArray = React$d.Children.toArray(children); // Support autofill.

  const handleChange = event => {
    const index = childrenArray.map(child => child.props.value).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    const child = childrenArray[index];
    setValueState(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  const handleItemClick = child => event => {
    let newValue; // We use the tabindex attribute to signal the available options.

    if (!event.currentTarget.hasAttribute('tabindex')) {
      return;
    }

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);

      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }

    if (child.props.onClick) {
      child.props.onClick(event);
    }

    if (value !== newValue) {
      setValueState(newValue);

      if (onChange) {
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(clonedEvent, child);
      }
    }

    if (!multiple) {
      update(false, event);
    }
  };

  const handleKeyDown = event => {
    if (!readOnly) {
      const validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  const open = displayNode !== null && openState;

  const handleBlur = event => {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      // Preact support, target is read only property on a native event.
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;
  let foundMatch = false; // No need to display any value if the field is empty.

  if (isFilled({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  const items = childrenArray.map(child => {
    if (! /*#__PURE__*/React$d.isValidElement(child)) {
      return null;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (reactIs$3.exports.isFragment(child)) {
        console.error(["MUI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    let selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`value\` prop must be an array when using the \`Select\` component with \`multiple\`.` : formatMuiErrorMessage(2));
      }

      selected = value.some(v => areEqualValues(v, child.props.value));

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/React$d.cloneElement(child, {
      'aria-selected': selected ? 'true' : 'false',
      onClick: handleItemClick(child),
      onKeyUp: event => {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$d.useEffect(() => {
      if (!foundMatch && !multiple && value !== '') {
        const values = childrenArray.map(child => child.props.value);
        console.warn([`MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${values.filter(x => x != null).map(x => `\`${x}\``).join(', ') || '""'}.`].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    if (multiple) {
      if (displayMultiple.length === 0) {
        display = null;
      } else {
        display = displayMultiple.reduce((output, child, index) => {
          output.push(child);

          if (index < displayMultiple.length - 1) {
            output.push(', ');
          }

          return output;
        }, []);
      }
    } else {
      display = displaySingle;
    }
  } // Avoid performing a layout computation in the render method.


  let menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  let tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);

  const ownerState = _extends$P({}, props, {
    variant,
    value,
    open
  });

  const classes = useUtilityClasses$k(ownerState);
  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [/*#__PURE__*/jsx$1(SelectSelect, _extends$P({
      ref: handleDisplayRef,
      tabIndex: tabIndex,
      role: "button",
      "aria-disabled": disabled ? 'true' : undefined,
      "aria-expanded": open ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
      "aria-describedby": ariaDescribedby,
      onKeyDown: handleKeyDown,
      onMouseDown: disabled || readOnly ? null : handleMouseDown,
      onBlur: handleBlur,
      onFocus: onFocus
    }, SelectDisplayProps, {
      ownerState: ownerState,
      className: clsx(classes.select, className, SelectDisplayProps.className) // The id is required for proper a11y
      ,
      id: buttonId,
      children: isEmpty(display) ? // notranslate needed while Google Translate will not fix zero-width space issue
      _span || (_span = /*#__PURE__*/jsx$1("span", {
        className: "notranslate",
        children: "\u200B"
      })) : display
    })), /*#__PURE__*/jsx$1(SelectNativeInput, _extends$P({
      value: Array.isArray(value) ? value.join(',') : value,
      name: name,
      ref: inputRef,
      "aria-hidden": true,
      onChange: handleChange,
      tabIndex: -1,
      disabled: disabled,
      className: classes.nativeInput,
      autoFocus: autoFocus,
      ownerState: ownerState
    }, other)), /*#__PURE__*/jsx$1(SelectIcon, {
      as: IconComponent,
      className: classes.icon,
      ownerState: ownerState
    }), /*#__PURE__*/jsx$1(MuiMenu, _extends$P({
      id: `menu-${name || ''}`,
      anchorEl: displayNode,
      open: open,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, MenuProps, {
      MenuListProps: _extends$P({
        'aria-labelledby': labelId,
        role: 'listbox',
        disableListWrap: true
      }, MenuProps.MenuListProps),
      PaperProps: _extends$P({}, MenuProps.PaperProps, {
        style: _extends$P({
          minWidth: menuMinWidth
        }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
      }),
      children: items
    }))]
  });
});
process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-describedby': PropTypes$1.string,

  /**
   * @ignore
   */
  'aria-label': PropTypes$1.string,

  /**
   * @ignore
   */
  autoFocus: PropTypes$1.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes$1.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes$1.object,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes$1.string,

  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes$1.bool,

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes$1.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes$1.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType$1,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes$1.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes$1.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes$1.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes$1.string,

  /**
   * @ignore
   */
  onBlur: PropTypes$1.func,

  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes$1.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes$1.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes$1.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * @ignore
   */
  type: PropTypes$1.any,

  /**
   * The input value.
   */
  value: PropTypes$1.any,

  /**
   * The variant to use.
   */
  variant: PropTypes$1.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var SelectInput$1 = SelectInput;

var _StyledInput, _StyledFilledInput;

const _excluded$A = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"];

const useUtilityClasses$j = ownerState => {
  const {
    classes
  } = ownerState;
  return classes;
};

const styledRootConfig = {
  name: 'MuiSelect',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => rootShouldForwardProp(prop) && prop !== 'variant',
  slot: 'Root'
};
const StyledInput = styled$1(Input$8, styledRootConfig)('');
const StyledOutlinedInput = styled$1(OutlinedInput$1, styledRootConfig)('');
const StyledFilledInput = styled$1(FilledInput$1, styledRootConfig)('');
const Select$1 = /*#__PURE__*/React$d.forwardRef(function Select(inProps, ref) {
  const props = useThemeProps({
    name: 'MuiSelect',
    props: inProps
  });

  const {
    autoWidth = false,
    children,
    classes: classesProp = {},
    className,
    defaultOpen = false,
    displayEmpty = false,
    IconComponent = ArrowDropDownIcon,
    id,
    input,
    inputProps,
    label,
    labelId,
    MenuProps,
    multiple = false,
    native = false,
    onClose,
    onOpen,
    open,
    renderValue,
    SelectDisplayProps,
    variant: variantProp = 'outlined'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$A);

  const inputComponent = native ? NativeSelectInput$1 : SelectInput$1;
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['variant']
  });
  const variant = fcs.variant || variantProp;
  const InputComponent = input || {
    standard: _StyledInput || (_StyledInput = /*#__PURE__*/jsx$1(StyledInput, {})),
    outlined: /*#__PURE__*/jsx$1(StyledOutlinedInput, {
      label: label
    }),
    filled: _StyledFilledInput || (_StyledFilledInput = /*#__PURE__*/jsx$1(StyledFilledInput, {}))
  }[variant];

  const ownerState = _extends$P({}, props, {
    variant,
    classes: classesProp
  });

  const classes = useUtilityClasses$j(ownerState);
  const inputComponentRef = useForkRef(ref, InputComponent.ref);
  return /*#__PURE__*/React$d.cloneElement(InputComponent, _extends$P({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent,
    inputProps: _extends$P({
      children,
      IconComponent,
      variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple
    }, native ? {
      id
    } : {
      autoWidth,
      defaultOpen,
      displayEmpty,
      labelId,
      MenuProps,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps: _extends$P({
        id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? deepmerge$2(classes, inputProps.classes) : classes
    }, input ? input.props.inputProps : {})
  }, multiple && native && variant === 'outlined' ? {
    notched: true
  } : {}, {
    ref: inputComponentRef,
    className: clsx(InputComponent.props.className, className),
    variant
  }, other));
});
process.env.NODE_ENV !== "production" ? Select$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes$1.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes$1.bool,

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes$1.bool,

  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes$1.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes$1.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes$1.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes$1.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: PropTypes$1.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes$1.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes$1.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes$1.bool,

  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes$1.bool,

  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<T>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes$1.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes$1.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes$1.any,

  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes$1.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select$1.muiName = 'Select';
var MuiSelect = Select$1;

function getSkeletonUtilityClass(slot) {
  return generateUtilityClass('MuiSkeleton', slot);
}
generateUtilityClasses('MuiSkeleton', ['root', 'text', 'rectangular', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);

const _excluded$z = ["animation", "className", "component", "height", "style", "variant", "width"];

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

const useUtilityClasses$i = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return composeClasses(slots, getSkeletonUtilityClass, classes);
};

const pulseKeyframe = keyframes(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = styled$1('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = getUnit(theme.shape.borderRadius) || 'px';
  const radiusValue = toUnitless(theme.shape.borderRadius);
  return _extends$P({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: alpha$2(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && css(_t3 || (_t3 = _`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && css(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(90deg, transparent, ${0}, transparent);
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, theme.palette.action.hover));
const Skeleton$1 = /*#__PURE__*/React$d.forwardRef(function Skeleton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSkeleton'
  });

  const {
    animation = 'pulse',
    className,
    component = 'span',
    height,
    style,
    variant = 'text',
    width
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$z);

  const ownerState = _extends$P({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });

  const classes = useUtilityClasses$i(ownerState);
  return /*#__PURE__*/jsx$1(SkeletonRoot, _extends$P({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: _extends$P({
      width,
      height
    }, style)
  }));
});
process.env.NODE_ENV !== "production" ? Skeleton$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: PropTypes$1.oneOf(['pulse', 'wave', false]),

  /**
   * Optional children to infer width and height from.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * @ignore
   */
  style: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['circular', 'rectangular', 'text']), PropTypes$1.string]),

  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])
} : void 0;
var Skeleton$2 = Skeleton$1;

const _excluded$y = ["component", "components", "componentsProps", "color", "size"];
const sliderClasses = _extends$P({}, sliderUnstyledClasses$1, generateUtilityClasses('MuiSlider', ['colorPrimary', 'colorSecondary', 'thumbColorPrimary', 'thumbColorSecondary', 'sizeSmall', 'thumbSizeSmall']));
const SliderRoot = styled$1('span', {
  name: 'MuiSlider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const marks = ownerState.marksProp === true && ownerState.step !== null ? [...Array(Math.floor((ownerState.max - ownerState.min) / ownerState.step) + 1)].map((_, index) => ({
      value: ownerState.min + ownerState.step * index
    })) : ownerState.marksProp || [];
    const marked = marks.length > 0 && marks.some(mark => mark.label);
    return [styles.root, styles[`color${capitalize$3(ownerState.color)}`], ownerState.size !== 'medium' && styles[`size${capitalize$3(ownerState.size)}`], marked && styles.marked, ownerState.orientation === 'vertical' && styles.vertical, ownerState.track === 'inverted' && styles.trackInverted, ownerState.track === false && styles.trackFalse];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  borderRadius: 12,
  boxSizing: 'content-box',
  display: 'inline-block',
  position: 'relative',
  cursor: 'pointer',
  touchAction: 'none',
  color: theme.palette[ownerState.color].main,
  WebkitTapHighlightColor: 'transparent'
}, ownerState.orientation === 'horizontal' && _extends$P({
  height: 4,
  width: '100%',
  padding: '13px 0',
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  '@media (pointer: coarse)': {
    // Reach 42px touch target, about ~8mm on screen.
    padding: '20px 0'
  }
}, ownerState.size === 'small' && {
  height: 2
}, ownerState.marked && {
  marginBottom: 20
}), ownerState.orientation === 'vertical' && _extends$P({
  height: '100%',
  width: 4,
  padding: '0 13px',
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  '@media (pointer: coarse)': {
    // Reach 42px touch target, about ~8mm on screen.
    padding: '0 20px'
  }
}, ownerState.size === 'small' && {
  width: 2
}, ownerState.marked && {
  marginRight: 44
}), {
  '@media print': {
    colorAdjust: 'exact'
  },
  [`&.${sliderClasses.disabled}`]: {
    pointerEvents: 'none',
    cursor: 'default',
    color: theme.palette.grey[400]
  },
  [`&.${sliderClasses.dragging}`]: {
    [`& .${sliderClasses.thumb}, & .${sliderClasses.track}`]: {
      transition: 'none'
    }
  }
}));
process.env.NODE_ENV !== "production" ? SliderRoot.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;
const SliderRail = styled$1('span', {
  name: 'MuiSlider',
  slot: 'Rail',
  overridesResolver: (props, styles) => styles.rail
})(({
  ownerState
}) => _extends$P({
  display: 'block',
  position: 'absolute',
  borderRadius: 'inherit',
  backgroundColor: 'currentColor',
  opacity: 0.38
}, ownerState.orientation === 'horizontal' && {
  width: '100%',
  height: 'inherit',
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  width: 'inherit',
  left: '50%',
  transform: 'translateX(-50%)'
}, ownerState.track === 'inverted' && {
  opacity: 1
}));
process.env.NODE_ENV !== "production" ? SliderRail.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;
const SliderTrack = styled$1('span', {
  name: 'MuiSlider',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme,
  ownerState
}) => {
  const color = // Same logic as the LinearProgress track color
  theme.palette.mode === 'light' ? lighten(theme.palette[ownerState.color].main, 0.62) : darken(theme.palette[ownerState.color].main, 0.5);
  return _extends$P({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    border: '1px solid currentColor',
    backgroundColor: 'currentColor',
    transition: theme.transitions.create(['left', 'width', 'bottom', 'height'], {
      duration: theme.transitions.duration.shortest
    })
  }, ownerState.size === 'small' && {
    border: 'none'
  }, ownerState.orientation === 'horizontal' && {
    height: 'inherit',
    top: '50%',
    transform: 'translateY(-50%)'
  }, ownerState.orientation === 'vertical' && {
    width: 'inherit',
    left: '50%',
    transform: 'translateX(-50%)'
  }, ownerState.track === false && {
    display: 'none'
  }, ownerState.track === 'inverted' && {
    backgroundColor: color,
    borderColor: color
  });
});
process.env.NODE_ENV !== "production" ? SliderTrack.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;
const SliderThumb = styled$1('span', {
  name: 'MuiSlider',
  slot: 'Thumb',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.thumb, styles[`thumbColor${capitalize$3(ownerState.color)}`], ownerState.size !== 'medium' && styles[`thumbSize${capitalize$3(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  position: 'absolute',
  width: 20,
  height: 20,
  boxSizing: 'border-box',
  borderRadius: '50%',
  outline: 0,
  backgroundColor: 'currentColor',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: theme.transitions.create(['box-shadow', 'left', 'bottom'], {
    duration: theme.transitions.duration.shortest
  })
}, ownerState.size === 'small' && {
  width: 12,
  height: 12
}, ownerState.orientation === 'horizontal' && {
  top: '50%',
  transform: 'translate(-50%, -50%)'
}, ownerState.orientation === 'vertical' && {
  left: '50%',
  transform: 'translate(-50%, 50%)'
}, {
  '&:before': _extends$P({
    position: 'absolute',
    content: '""',
    borderRadius: 'inherit',
    width: '100%',
    height: '100%',
    boxShadow: theme.shadows[2]
  }, ownerState.size === 'small' && {
    boxShadow: 'none'
  }),
  '&::after': {
    position: 'absolute',
    content: '""',
    borderRadius: '50%',
    // 42px is the hit target
    width: 42,
    height: 42,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  [`&:hover, &.${sliderClasses.focusVisible}`]: {
    boxShadow: `0px 0px 0px 8px ${alpha$2(theme.palette[ownerState.color].main, 0.16)}`,
    '@media (hover: none)': {
      boxShadow: 'none'
    }
  },
  [`&.${sliderClasses.active}`]: {
    boxShadow: `0px 0px 0px 14px ${alpha$2(theme.palette[ownerState.color].main, 0.16)}`
  },
  [`&.${sliderClasses.disabled}`]: {
    '&:hover': {
      boxShadow: 'none'
    }
  }
}));
process.env.NODE_ENV !== "production" ? SliderThumb.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;
const SliderValueLabel = styled$1(SliderValueLabelUnstyled, {
  name: 'MuiSlider',
  slot: 'ValueLabel',
  overridesResolver: (props, styles) => styles.valueLabel
})(({
  theme,
  ownerState
}) => _extends$P({
  [`&.${sliderClasses.valueLabelOpen}`]: {
    transform: 'translateY(-100%) scale(1)'
  },
  zIndex: 1,
  whiteSpace: 'nowrap'
}, theme.typography.body2, {
  fontWeight: 500,
  transition: theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.shortest
  }),
  top: -10,
  transformOrigin: 'bottom center',
  transform: 'translateY(-100%) scale(0)',
  position: 'absolute',
  backgroundColor: theme.palette.grey[600],
  borderRadius: 2,
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.25rem 0.75rem'
}, ownerState.size === 'small' && {
  fontSize: theme.typography.pxToRem(12),
  padding: '0.25rem 0.5rem'
}, {
  '&:before': {
    position: 'absolute',
    content: '""',
    width: 8,
    height: 8,
    bottom: 0,
    left: '50%',
    transform: 'translate(-50%, 50%) rotate(45deg)',
    backgroundColor: 'inherit'
  }
}));
process.env.NODE_ENV !== "production" ? SliderValueLabel.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;
const SliderMark = styled$1('span', {
  name: 'MuiSlider',
  slot: 'Mark',
  shouldForwardProp: prop => slotShouldForwardProp(prop) && prop !== 'markActive',
  overridesResolver: (props, styles) => styles.mark
})(({
  theme,
  ownerState,
  markActive
}) => _extends$P({
  position: 'absolute',
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: 'currentColor'
}, ownerState.orientation === 'horizontal' && {
  top: '50%',
  transform: 'translate(-1px, -50%)'
}, ownerState.orientation === 'vertical' && {
  left: '50%',
  transform: 'translate(-50%, 1px)'
}, markActive && {
  backgroundColor: theme.palette.background.paper,
  opacity: 0.8
}));
process.env.NODE_ENV !== "production" ? SliderMark.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;
const SliderMarkLabel = styled$1('span', {
  name: 'MuiSlider',
  slot: 'MarkLabel',
  shouldForwardProp: prop => slotShouldForwardProp(prop) && prop !== 'markLabelActive',
  overridesResolver: (props, styles) => styles.markLabel
})(({
  theme,
  ownerState,
  markLabelActive
}) => _extends$P({}, theme.typography.body2, {
  color: theme.palette.text.secondary,
  position: 'absolute',
  whiteSpace: 'nowrap'
}, ownerState.orientation === 'horizontal' && {
  top: 30,
  transform: 'translateX(-50%)',
  '@media (pointer: coarse)': {
    top: 40
  }
}, ownerState.orientation === 'vertical' && {
  left: 36,
  transform: 'translateY(50%)',
  '@media (pointer: coarse)': {
    left: 44
  }
}, markLabelActive && {
  color: theme.palette.text.primary
}));
process.env.NODE_ENV !== "production" ? SliderMarkLabel.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes$1.node
} : void 0;

const extendUtilityClasses = ownerState => {
  const {
    color,
    size,
    classes = {}
  } = ownerState;
  return _extends$P({}, classes, {
    root: clsx(classes.root, getSliderUtilityClass(`color${capitalize$3(color)}`), classes[`color${capitalize$3(color)}`], size && [getSliderUtilityClass(`size${capitalize$3(size)}`), classes[`size${capitalize$3(size)}`]]),
    thumb: clsx(classes.thumb, getSliderUtilityClass(`thumbColor${capitalize$3(color)}`), classes[`thumbColor${capitalize$3(color)}`], size && [getSliderUtilityClass(`thumbSize${capitalize$3(size)}`), classes[`thumbSize${capitalize$3(size)}`]])
  });
};

const Slider$1 = /*#__PURE__*/React$d.forwardRef(function Slider(inputProps, ref) {
  var _componentsProps$root, _componentsProps$thum, _componentsProps$trac, _componentsProps$valu;

  const props = useThemeProps({
    props: inputProps,
    name: 'MuiSlider'
  });
  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  const {
    // eslint-disable-next-line react/prop-types
    component = 'span',
    components = {},
    componentsProps = {},
    color = 'primary',
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$y);

  const ownerState = _extends$P({}, props, {
    color,
    size
  });

  const classes = extendUtilityClasses(ownerState);
  return /*#__PURE__*/jsx$1(SliderUnstyled$1, _extends$P({}, other, {
    isRtl: isRtl,
    components: _extends$P({
      Root: SliderRoot,
      Rail: SliderRail,
      Track: SliderTrack,
      Thumb: SliderThumb,
      ValueLabel: SliderValueLabel,
      Mark: SliderMark,
      MarkLabel: SliderMarkLabel
    }, components),
    componentsProps: _extends$P({}, componentsProps, {
      root: _extends$P({}, componentsProps.root, shouldSpreadAdditionalProps$1(components.Root) && {
        as: component,
        ownerState: _extends$P({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState, {
          color,
          size
        })
      }),
      thumb: _extends$P({}, componentsProps.thumb, shouldSpreadAdditionalProps$1(components.Thumb) && {
        ownerState: _extends$P({}, (_componentsProps$thum = componentsProps.thumb) == null ? void 0 : _componentsProps$thum.ownerState, {
          color,
          size
        })
      }),
      track: _extends$P({}, componentsProps.track, shouldSpreadAdditionalProps$1(components.Track) && {
        ownerState: _extends$P({}, (_componentsProps$trac = componentsProps.track) == null ? void 0 : _componentsProps$trac.ownerState, {
          color,
          size
        })
      }),
      valueLabel: _extends$P({}, componentsProps.valueLabel, shouldSpreadAdditionalProps$1(components.ValueLabel) && {
        ownerState: _extends$P({}, (_componentsProps$valu = componentsProps.valueLabel) == null ? void 0 : _componentsProps$valu.ownerState, {
          color,
          size
        })
      })
    }),
    classes: classes,
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? Slider$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes$1.string, props => {
    const range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes$1.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes$1.string, props => {
    const range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * @ignore
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary']), PropTypes$1.string]),

  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Input: PropTypes$1.elementType,
    Mark: PropTypes$1.elementType,
    MarkLabel: PropTypes$1.elementType,
    Rail: PropTypes$1.elementType,
    Root: PropTypes$1.elementType,
    Thumb: PropTypes$1.elementType,
    Track: PropTypes$1.elementType,
    ValueLabel: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    input: PropTypes$1.object,
    mark: PropTypes$1.object,
    markLabel: PropTypes$1.object,
    rail: PropTypes$1.object,
    root: PropTypes$1.object,
    thumb: PropTypes$1.object,
    track: PropTypes$1.object,
    valueLabel: PropTypes$1.shape({
      className: PropTypes$1.string,
      components: PropTypes$1.shape({
        Root: PropTypes$1.elementType
      }),
      style: PropTypes$1.object,
      value: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number]),
      valueLabelDisplay: PropTypes$1.oneOf(['auto', 'off', 'on'])
    })
  }),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number]),

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: PropTypes$1.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes$1.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes$1.func,

  /**
   * Indicates whether the theme context has rtl direction. It is set automatically.
   * @default false
   */
  isRtl: PropTypes$1.bool,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.shape({
    label: PropTypes$1.node,
    value: PropTypes$1.number.isRequired
  })), PropTypes$1.bool]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: PropTypes$1.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: PropTypes$1.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes$1.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: PropTypes$1.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes$1.func,

  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical']),

  /**
   * A transformation function, to change the scale of the slider.
   * @default (x) => x
   */
  scale: PropTypes$1.func,

  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['small', 'medium']), PropTypes$1.string]),

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: PropTypes$1.number,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: PropTypes$1.number,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: PropTypes$1.oneOf(['inverted', 'normal', false]),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.number), PropTypes$1.number]),

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: PropTypes$1.oneOf(['auto', 'off', 'on']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @default (x) => x
   */
  valueLabelFormat: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.string])
} : void 0;
var MuiSlider = Slider$1;

function getTooltipUtilityClass(slot) {
  return generateUtilityClass('MuiTooltip', slot);
}
const tooltipClasses = generateUtilityClasses('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
var tooltipClasses$1 = tooltipClasses;

const _excluded$x = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"];

function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}

const useUtilityClasses$h = ownerState => {
  const {
    classes,
    disableInteractive,
    arrow,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ['popper', !disableInteractive && 'popperInteractive', arrow && 'popperArrow'],
    tooltip: ['tooltip', arrow && 'tooltipArrow', touch && 'touch', `tooltipPlacement${capitalize$3(placement.split('-')[0])}`],
    arrow: ['arrow']
  };
  return composeClasses(slots, getTooltipUtilityClass, classes);
};

const TooltipPopper = styled$1(Popper$1, {
  name: 'MuiTooltip',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.popper, !ownerState.disableInteractive && styles.popperInteractive, ownerState.arrow && styles.popperArrow, !ownerState.open && styles.popperClose];
  }
})(({
  theme,
  ownerState,
  open
}) => _extends$P({
  zIndex: theme.zIndex.tooltip,
  pointerEvents: 'none'
}, !ownerState.disableInteractive && {
  pointerEvents: 'auto'
}, !open && {
  pointerEvents: 'none'
}, ownerState.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses$1.arrow}`]: {
    top: 0,
    marginTop: '-0.71em',
    '&::before': {
      transformOrigin: '0 100%'
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses$1.arrow}`]: {
    bottom: 0,
    marginBottom: '-0.71em',
    '&::before': {
      transformOrigin: '100% 0'
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses$1.arrow}`]: _extends$P({}, !ownerState.isRtl ? {
    left: 0,
    marginLeft: '-0.71em'
  } : {
    right: 0,
    marginRight: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '100% 100%'
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses$1.arrow}`]: _extends$P({}, !ownerState.isRtl ? {
    right: 0,
    marginRight: '-0.71em'
  } : {
    left: 0,
    marginLeft: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '0 0'
    }
  })
}));
const TooltipTooltip = styled$1('div', {
  name: 'MuiTooltip',
  slot: 'Tooltip',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.tooltip, ownerState.touch && styles.touch, ownerState.arrow && styles.tooltipArrow, styles[`tooltipPlacement${capitalize$3(ownerState.placement.split('-')[0])}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  backgroundColor: alpha$2(theme.palette.grey[700], 0.92),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: '4px 8px',
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: 'break-word',
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.arrow && {
  position: 'relative',
  margin: 0
}, ownerState.touch && {
  padding: '8px 16px',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: `${round$1(16 / 14)}em`,
  fontWeight: theme.typography.fontWeightRegular
}, {
  [`.${tooltipClasses$1.popper}[data-popper-placement*="left"] &`]: _extends$P({
    transformOrigin: 'right center'
  }, !ownerState.isRtl ? _extends$P({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  }) : _extends$P({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="right"] &`]: _extends$P({
    transformOrigin: 'left center'
  }, !ownerState.isRtl ? _extends$P({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  }) : _extends$P({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="top"] &`]: _extends$P({
    transformOrigin: 'center bottom',
    marginBottom: '14px'
  }, ownerState.touch && {
    marginBottom: '24px'
  }),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="bottom"] &`]: _extends$P({
    transformOrigin: 'center top',
    marginTop: '14px'
  }, ownerState.touch && {
    marginTop: '24px'
  })
}));
const TooltipArrow = styled$1('span', {
  name: 'MuiTooltip',
  slot: 'Arrow',
  overridesResolver: (props, styles) => styles.arrow
})(({
  theme
}) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: '1em',
  height: '0.71em'
  /* = width / sqrt(2) = (length of the hypotenuse) */
  ,
  boxSizing: 'border-box',
  color: alpha$2(theme.palette.grey[700], 0.9),
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)'
  }
}));
let hystersisOpen = false;
let hystersisTimer = null;

function composeEventHandler(handler, eventHandler) {
  return event => {
    if (eventHandler) {
      eventHandler(event);
    }

    handler(event);
  };
} // TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.


const Tooltip$2 = /*#__PURE__*/React$d.forwardRef(function Tooltip(inProps, ref) {
  var _components$Popper, _ref, _components$Transitio, _components$Tooltip, _components$Arrow, _componentsProps$popp;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiTooltip'
  });

  const {
    arrow = false,
    children,
    components = {},
    componentsProps = {},
    describeChild = false,
    disableFocusListener = false,
    disableHoverListener = false,
    disableInteractive: disableInteractiveProp = false,
    disableTouchListener = false,
    enterDelay = 100,
    enterNextDelay = 0,
    enterTouchDelay = 700,
    followCursor = false,
    id: idProp,
    leaveDelay = 0,
    leaveTouchDelay = 1500,
    onClose,
    onOpen,
    open: openProp,
    placement = 'bottom',
    PopperComponent: PopperComponentProp,
    PopperProps = {},
    title,
    TransitionComponent: TransitionComponentProp = Grow$1,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$x);

  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';
  const [childNode, setChildNode] = React$d.useState();
  const [arrowRef, setArrowRef] = React$d.useState(null);
  const ignoreNonTouchEvents = React$d.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = React$d.useRef();
  const enterTimer = React$d.useRef();
  const leaveTimer = React$d.useRef();
  const touchTimer = React$d.useRef();
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  });
  let open = openState;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {
      current: isControlled
    } = React$d.useRef(openProp !== undefined); // eslint-disable-next-line react-hooks/rules-of-hooks

    React$d.useEffect(() => {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['MUI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }

  const id = useId(idProp);
  const prevUserSelect = React$d.useRef();
  const stopTouchInteraction = React$d.useCallback(() => {
    if (prevUserSelect.current !== undefined) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = undefined;
    }

    clearTimeout(touchTimer.current);
  }, []);
  React$d.useEffect(() => {
    return () => {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      stopTouchInteraction();
    };
  }, [stopTouchInteraction]);

  const handleOpen = event => {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen && !open) {
      onOpen(event);
    }
  };

  const handleClose = useEventCallback$1(
  /**
   * @param {React.SyntheticEvent | Event} event
   */
  event => {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(() => {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose && open) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  });

  const handleEnter = event => {
    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
      return;
    } // Remove the title ahead of time.
    // We don't want to wait for the next render commit.
    // We would risk displaying two tooltips at the same time (native + this one).


    if (childNode) {
      childNode.removeAttribute('title');
    }

    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);

    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.current = setTimeout(() => {
        handleOpen(event);
      }, hystersisOpen ? enterNextDelay : enterDelay);
    } else {
      handleOpen(event);
    }
  };

  const handleLeave = event => {
    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);
    leaveTimer.current = setTimeout(() => {
      handleClose(event);
    }, leaveDelay);
  };

  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible(); // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
  // We just need to re-render the Tooltip if the focus-visible state changes.

  const [, setChildIsFocusVisible] = React$d.useState(false);

  const handleBlur = event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setChildIsFocusVisible(false);
      handleLeave(event);
    }
  };

  const handleFocus = event => {
    // Workaround for https://github.com/facebook/react/issues/7769
    // The autoFocus of React might trigger the event before the componentDidMount.
    // We need to account for this eventuality.
    if (!childNode) {
      setChildNode(event.currentTarget);
    }

    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setChildIsFocusVisible(true);
      handleEnter(event);
    }
  };

  const detectTouchStart = event => {
    ignoreNonTouchEvents.current = true;
    const childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  const handleMouseOver = handleEnter;
  const handleMouseLeave = handleLeave;

  const handleTouchStart = event => {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect; // Prevent iOS text selection on long-tap.

    document.body.style.WebkitUserSelect = 'none';
    touchTimer.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleEnter(event);
    }, enterTouchDelay);
  };

  const handleTouchEnd = event => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    stopTouchInteraction();
    clearTimeout(leaveTimer.current);
    leaveTimer.current = setTimeout(() => {
      handleClose(event);
    }, leaveTouchDelay);
  };

  React$d.useEffect(() => {
    if (!open) {
      return undefined;
    }
    /**
     * @param {KeyboardEvent} nativeEvent
     */


    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        handleClose(nativeEvent);
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClose, open]);
  const handleUseRef = useForkRef(setChildNode, ref);
  const handleFocusRef = useForkRef(focusVisibleRef, handleUseRef);
  const handleRef = useForkRef(children.ref, handleFocusRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  }

  const positionRef = React$d.useRef({
    x: 0,
    y: 0
  });
  const popperRef = React$d.useRef();

  const handleMouseMove = event => {
    const childrenProps = children.props;

    if (childrenProps.onMouseMove) {
      childrenProps.onMouseMove(event);
    }

    positionRef.current = {
      x: event.clientX,
      y: event.clientY
    };

    if (popperRef.current) {
      popperRef.current.update();
    }
  };

  const nameOrDescProps = {};
  const titleIsString = typeof title === 'string';

  if (describeChild) {
    nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps['aria-describedby'] = open ? id : null;
  } else {
    nameOrDescProps['aria-label'] = titleIsString ? title : null;
    nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
  }

  const childrenProps = _extends$P({}, nameOrDescProps, other, children.props, {
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  }, followCursor ? {
    onMouseMove: handleMouseMove
  } : {});

  if (process.env.NODE_ENV !== 'production') {
    childrenProps['data-mui-internal-clone-element'] = true; // eslint-disable-next-line react-hooks/rules-of-hooks

    React$d.useEffect(() => {
      if (childNode && !childNode.getAttribute('data-mui-internal-clone-element')) {
        console.error(['MUI: The `children` component of the Tooltip is not forwarding its props correctly.', 'Please make sure that props are spread on the same element that the ref is applied to.'].join('\n'));
      }
    }, [childNode]);
  }

  const interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);

    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);

    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (children.props.title) {
      console.error(['MUI: You have provided a `title` prop to the child of <Tooltip />.', `Remove this title prop \`${children.props.title}\` or the Tooltip component.`].join('\n'));
    }
  }

  const popperOptions = React$d.useMemo(() => {
    var _PopperProps$popperOp;

    let tooltipModifiers = [{
      name: 'arrow',
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];

    if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }

    return _extends$P({}, PopperProps.popperOptions, {
      modifiers: tooltipModifiers
    });
  }, [arrowRef, PopperProps]);

  const ownerState = _extends$P({}, props, {
    isRtl,
    arrow,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  });

  const classes = useUtilityClasses$h(ownerState);
  const PopperComponent = (_components$Popper = components.Popper) != null ? _components$Popper : TooltipPopper;
  const TransitionComponent = (_ref = (_components$Transitio = components.Transition) != null ? _components$Transitio : TransitionComponentProp) != null ? _ref : Grow$1;
  const TooltipComponent = (_components$Tooltip = components.Tooltip) != null ? _components$Tooltip : TooltipTooltip;
  const ArrowComponent = (_components$Arrow = components.Arrow) != null ? _components$Arrow : TooltipArrow;
  const popperProps = appendOwnerState(PopperComponent, _extends$P({}, PopperProps, componentsProps.popper), ownerState);
  const transitionProps = appendOwnerState(TransitionComponent, _extends$P({}, TransitionProps, componentsProps.transition), ownerState);
  const tooltipProps = appendOwnerState(TooltipComponent, _extends$P({}, componentsProps.tooltip), ownerState);
  const tooltipArrowProps = appendOwnerState(ArrowComponent, _extends$P({}, componentsProps.arrow), ownerState);
  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [/*#__PURE__*/React$d.cloneElement(children, childrenProps), /*#__PURE__*/jsx$1(PopperComponent, _extends$P({
      as: PopperComponentProp != null ? PopperComponentProp : Popper$1,
      placement: placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: positionRef.current.y,
          left: positionRef.current.x,
          right: positionRef.current.x,
          bottom: positionRef.current.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef: popperRef,
      open: childNode ? open : false,
      id: id,
      transition: true
    }, interactiveWrapperListeners, popperProps, {
      className: clsx(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_componentsProps$popp = componentsProps.popper) == null ? void 0 : _componentsProps$popp.className),
      popperOptions: popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => {
        var _componentsProps$tool, _componentsProps$arro;

        return /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, transitionProps, {
          children: /*#__PURE__*/jsxs(TooltipComponent, _extends$P({}, tooltipProps, {
            className: clsx(classes.tooltip, (_componentsProps$tool = componentsProps.tooltip) == null ? void 0 : _componentsProps$tool.className),
            children: [title, arrow ? /*#__PURE__*/jsx$1(ArrowComponent, _extends$P({}, tooltipArrowProps, {
              className: clsx(classes.arrow, (_componentsProps$arro = componentsProps.arrow) == null ? void 0 : _componentsProps$arro.className),
              ref: setArrowRef
            })) : null]
          }))
        }));
      }
    }))]
  });
});
process.env.NODE_ENV !== "production" ? Tooltip$2.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes$1.bool,

  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef$1.isRequired,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The components used for each slot inside the Tooltip.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.shape({
    Arrow: PropTypes$1.elementType,
    Popper: PropTypes$1.elementType,
    Tooltip: PropTypes$1.elementType,
    Transition: PropTypes$1.elementType
  }),

  /**
   * The props used for each slot inside the Tooltip.
   * Note that `componentsProps.popper` prop values win over `PopperProps`
   * and `componentsProps.transition` prop values win over `TransitionProps` if both are applied.
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    arrow: PropTypes$1.object,
    popper: PropTypes$1.object,
    tooltip: PropTypes$1.object,
    transition: PropTypes$1.object
  }),

  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes$1.bool,

  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes$1.bool,

  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes$1.bool,

  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes$1.bool,

  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes$1.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes$1.number,

  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes$1.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes$1.number,

  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes$1.bool,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes$1.string,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes$1.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes$1.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes$1.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes$1.func,

  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool,

  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes$1.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: PropTypes$1.elementType,

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   * @default {}
   */
  PopperProps: PropTypes$1.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes$1.elementType,

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes$1.object
} : void 0;
var Tooltip$3 = Tooltip$2;

function getSwitchUtilityClass(slot) {
  return generateUtilityClass('MuiSwitch', slot);
}
const switchClasses = generateUtilityClasses('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
var switchClasses$1 = switchClasses;

const _excluded$w = ["className", "color", "edge", "size", "sx"];

const useUtilityClasses$g = ownerState => {
  const {
    classes,
    edge,
    size,
    color,
    checked,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', edge && `edge${capitalize$3(edge)}`, `size${capitalize$3(size)}`],
    switchBase: ['switchBase', `color${capitalize$3(color)}`, checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
  return _extends$P({}, classes, composedClasses);
};

const SwitchRoot = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.edge && styles[`edge${capitalize$3(ownerState.edge)}`], styles[`size${capitalize$3(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$P({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  }
}, ownerState.edge === 'start' && {
  marginLeft: -8
}, ownerState.edge === 'end' && {
  marginRight: -8
}, ownerState.size === 'small' && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${switchClasses$1.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${switchClasses$1.switchBase}`]: {
    padding: 4,
    [`&.${switchClasses$1.checked}`]: {
      transform: 'translateX(16px)'
    }
  }
}));
const SwitchSwitchBase = styled$1(SwitchBase$1, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.switchBase, {
      [`& .${switchClasses$1.input}`]: styles.input
    }, ownerState.color !== 'default' && styles[`color${capitalize$3(ownerState.color)}`]];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300],
  transition: theme.transitions.create(['left', 'transform'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${switchClasses$1.checked}`]: {
    transform: 'translateX(20px)'
  },
  [`&.${switchClasses$1.disabled}`]: {
    color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses$1.disabled} + .${switchClasses$1.track}`]: {
    opacity: theme.palette.mode === 'light' ? 0.12 : 0.2
  },
  [`& .${switchClasses$1.input}`]: {
    left: '-100%',
    width: '300%'
  }
}), ({
  theme,
  ownerState
}) => _extends$P({
  '&:hover': {
    backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${switchClasses$1.checked}`]: {
    color: theme.palette[ownerState.color].main,
    '&:hover': {
      backgroundColor: alpha$2(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${switchClasses$1.disabled}`]: {
      color: theme.palette.mode === 'light' ? lighten(theme.palette[ownerState.color].main, 0.62) : darken(theme.palette[ownerState.color].main, 0.55)
    }
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    backgroundColor: theme.palette[ownerState.color].main
  }
}));
const SwitchTrack = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => ({
  height: '100%',
  width: '100%',
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: theme.transitions.create(['opacity', 'background-color'], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white,
  opacity: theme.palette.mode === 'light' ? 0.38 : 0.3
}));
const SwitchThumb = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: (props, styles) => styles.thumb
})(({
  theme
}) => ({
  boxShadow: theme.shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%'
}));
const Switch$1 = /*#__PURE__*/React$d.forwardRef(function Switch(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSwitch'
  });

  const {
    className,
    color = 'primary',
    edge = false,
    size = 'medium',
    sx
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$w);

  const ownerState = _extends$P({}, props, {
    color,
    edge,
    size
  });

  const classes = useUtilityClasses$g(ownerState);

  const icon = /*#__PURE__*/jsx$1(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });

  return /*#__PURE__*/jsxs(SwitchRoot, {
    className: clsx(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx$1(SwitchSwitchBase, _extends$P({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: _extends$P({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/jsx$1(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
process.env.NODE_ENV !== "production" ? Switch$1.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes$1.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes$1.bool,

  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: PropTypes$1.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes$1.oneOf(['end', 'start', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes$1.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes$1.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes$1.func,

  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes$1.bool,

  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes$1.any
} : void 0;
var MuiSwitch = Switch$1;

function getTabUtilityClass(slot) {
  return generateUtilityClass('MuiTab', slot);
}
const tabClasses = generateUtilityClasses('MuiTab', ['root', 'labelIcon', 'textColorInherit', 'textColorPrimary', 'textColorSecondary', 'selected', 'disabled', 'fullWidth', 'wrapped', 'iconWrapper']);
var tabClasses$1 = tabClasses;

const _excluded$v = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"];

const useUtilityClasses$f = ownerState => {
  const {
    classes,
    textColor,
    fullWidth,
    wrapped,
    icon,
    label,
    selected,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', icon && label && 'labelIcon', `textColor${capitalize$3(textColor)}`, fullWidth && 'fullWidth', wrapped && 'wrapped', selected && 'selected', disabled && 'disabled'],
    iconWrapper: ['iconWrapper']
  };
  return composeClasses(slots, getTabUtilityClass, classes);
};

const TabRoot = styled$1(ButtonBase$1, {
  name: 'MuiTab',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.label && ownerState.icon && styles.labelIcon, styles[`textColor${capitalize$3(ownerState.textColor)}`], ownerState.fullWidth && styles.fullWidth, ownerState.wrapped && styles.wrapped];
  }
})(({
  theme,
  ownerState
}) => _extends$P({}, theme.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: 'relative',
  minHeight: 48,
  flexShrink: 0,
  padding: '12px 16px',
  overflow: 'hidden',
  whiteSpace: 'normal',
  textAlign: 'center'
}, ownerState.label && {
  flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
}, {
  lineHeight: 1.25
}, ownerState.icon && ownerState.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${tabClasses$1.iconWrapper}`]: _extends$P({}, ownerState.iconPosition === 'top' && {
    marginBottom: 6
  }, ownerState.iconPosition === 'bottom' && {
    marginTop: 6
  }, ownerState.iconPosition === 'start' && {
    marginRight: theme.spacing(1)
  }, ownerState.iconPosition === 'end' && {
    marginLeft: theme.spacing(1)
  })
}, ownerState.textColor === 'inherit' && {
  color: 'inherit',
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${tabClasses$1.selected}`]: {
    opacity: 1
  },
  [`&.${tabClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  }
}, ownerState.textColor === 'primary' && {
  color: theme.palette.text.secondary,
  [`&.${tabClasses$1.selected}`]: {
    color: theme.palette.primary.main
  },
  [`&.${tabClasses$1.disabled}`]: {
    color: theme.palette.text.disabled
  }
}, ownerState.textColor === 'secondary' && {
  color: theme.palette.text.secondary,
  [`&.${tabClasses$1.selected}`]: {
    color: theme.palette.secondary.main
  },
  [`&.${tabClasses$1.disabled}`]: {
    color: theme.palette.text.disabled
  }
}, ownerState.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: 'none'
}, ownerState.wrapped && {
  fontSize: theme.typography.pxToRem(12)
}));
const Tab$2 = /*#__PURE__*/React$d.forwardRef(function Tab(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTab'
  });

  const {
    className,
    disabled = false,
    disableFocusRipple = false,
    // eslint-disable-next-line react/prop-types
    fullWidth,
    icon: iconProp,
    iconPosition = 'top',
    // eslint-disable-next-line react/prop-types
    indicator,
    label,
    onChange,
    onClick,
    onFocus,
    // eslint-disable-next-line react/prop-types
    selected,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus,
    // eslint-disable-next-line react/prop-types
    textColor = 'inherit',
    value,
    wrapped = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$v);

  const ownerState = _extends$P({}, props, {
    disabled,
    disableFocusRipple,
    selected,
    icon: !!iconProp,
    iconPosition,
    label: !!label,
    fullWidth,
    textColor,
    wrapped
  });

  const classes = useUtilityClasses$f(ownerState);
  const icon = iconProp && label && /*#__PURE__*/React$d.isValidElement(iconProp) ? /*#__PURE__*/React$d.cloneElement(iconProp, {
    className: clsx(classes.iconWrapper, iconProp.props.className)
  }) : iconProp;

  const handleClick = event => {
    if (!selected && onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  const handleFocus = event => {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/jsxs(TabRoot, _extends$P({
    focusRipple: !disableFocusRipple,
    className: clsx(classes.root, className),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    ownerState: ownerState,
    tabIndex: selected ? 0 : -1
  }, other, {
    children: [iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/jsxs(React$d.Fragment, {
      children: [icon, label]
    }) : /*#__PURE__*/jsxs(React$d.Fragment, {
      children: [label, icon]
    }), indicator]
  }));
});
process.env.NODE_ENV !== "production" ? Tab$2.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes$1.bool,

  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes$1.bool,

  /**
   * The icon to display.
   */
  icon: PropTypes$1.oneOfType([PropTypes$1.element, PropTypes$1.string]),

  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: PropTypes$1.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * The label element.
   */
  label: PropTypes$1.node,

  /**
   * @ignore
   */
  onChange: PropTypes$1.func,

  /**
   * @ignore
   */
  onClick: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes$1.any,

  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: PropTypes$1.bool
} : void 0;
var Tab$3 = Tab$2;

/**
 * @ignore - internal component.
 */

const TableContext = /*#__PURE__*/React$d.createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

var TableContext$1 = TableContext;

function getTableUtilityClass(slot) {
  return generateUtilityClass('MuiTable', slot);
}
generateUtilityClasses('MuiTable', ['root', 'stickyHeader']);

const _excluded$u = ["className", "component", "padding", "size", "stickyHeader"];

const useUtilityClasses$e = ownerState => {
  const {
    classes,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', stickyHeader && 'stickyHeader']
  };
  return composeClasses(slots, getTableUtilityClass, classes);
};

const TableRoot = styled$1('table', {
  name: 'MuiTable',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => _extends$P({
  display: 'table',
  width: '100%',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  '& caption': _extends$P({}, theme.typography.body2, {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    textAlign: 'left',
    captionSide: 'bottom'
  })
}, ownerState.stickyHeader && {
  borderCollapse: 'separate'
}));
const defaultComponent$3 = 'table';
const Table = /*#__PURE__*/React$d.forwardRef(function Table(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTable'
  });

  const {
    className,
    component = defaultComponent$3,
    padding = 'normal',
    size = 'medium',
    stickyHeader = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$u);

  const ownerState = _extends$P({}, props, {
    component,
    padding,
    size,
    stickyHeader
  });

  const classes = useUtilityClasses$e(ownerState);
  const table = React$d.useMemo(() => ({
    padding,
    size,
    stickyHeader
  }), [padding, size, stickyHeader]);
  return /*#__PURE__*/jsx$1(TableContext$1.Provider, {
    value: table,
    children: /*#__PURE__*/jsx$1(TableRoot, _extends$P({
      as: component,
      role: component === defaultComponent$3 ? null : 'table',
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Table.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: PropTypes$1.oneOf(['checkbox', 'none', 'normal']),

  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var Table$1 = Table;

/**
 * @ignore - internal component.
 */

const Tablelvl2Context = /*#__PURE__*/React$d.createContext();

if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

var Tablelvl2Context$1 = Tablelvl2Context;

function getTableBodyUtilityClass(slot) {
  return generateUtilityClass('MuiTableBody', slot);
}
generateUtilityClasses('MuiTableBody', ['root']);

const _excluded$t = ["className", "component"];

const useUtilityClasses$d = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTableBodyUtilityClass, classes);
};

const TableBodyRoot = styled$1('tbody', {
  name: 'MuiTableBody',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-row-group'
});
const tablelvl2$1 = {
  variant: 'body'
};
const defaultComponent$2 = 'tbody';
const TableBody = /*#__PURE__*/React$d.forwardRef(function TableBody(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableBody'
  });

  const {
    className,
    component = defaultComponent$2
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$t);

  const ownerState = _extends$P({}, props, {
    component
  });

  const classes = useUtilityClasses$d(ownerState);
  return /*#__PURE__*/jsx$1(Tablelvl2Context$1.Provider, {
    value: tablelvl2$1,
    children: /*#__PURE__*/jsx$1(TableBodyRoot, _extends$P({
      className: clsx(classes.root, className),
      as: component,
      ref: ref,
      role: component === defaultComponent$2 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableBody.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var TableBody$1 = TableBody;

function getTableCellUtilityClass(slot) {
  return generateUtilityClass('MuiTableCell', slot);
}
const tableCellClasses = generateUtilityClasses('MuiTableCell', ['root', 'head', 'body', 'footer', 'sizeSmall', 'sizeMedium', 'paddingCheckbox', 'paddingNone', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'stickyHeader']);
var tableCellClasses$1 = tableCellClasses;

const _excluded$s = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"];

const useUtilityClasses$c = ownerState => {
  const {
    classes,
    variant,
    align,
    padding,
    size,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', variant, stickyHeader && 'stickyHeader', align !== 'inherit' && `align${capitalize$3(align)}`, padding !== 'normal' && `padding${capitalize$3(padding)}`, `size${capitalize$3(size)}`]
  };
  return composeClasses(slots, getTableCellUtilityClass, classes);
};

const TableCellRoot = styled$1('td', {
  name: 'MuiTableCell',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${capitalize$3(ownerState.size)}`], ownerState.padding !== 'normal' && styles[`padding${capitalize$3(ownerState.padding)}`], ownerState.align !== 'inherit' && styles[`align${capitalize$3(ownerState.align)}`], ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => _extends$P({}, theme.typography.body2, {
  display: 'table-cell',
  verticalAlign: 'inherit',
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: `1px solid
    ${theme.palette.mode === 'light' ? lighten(alpha$2(theme.palette.divider, 1), 0.88) : darken(alpha$2(theme.palette.divider, 1), 0.68)}`,
  textAlign: 'left',
  padding: 16
}, ownerState.variant === 'head' && {
  color: theme.palette.text.primary,
  lineHeight: theme.typography.pxToRem(24),
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.variant === 'body' && {
  color: theme.palette.text.primary
}, ownerState.variant === 'footer' && {
  color: theme.palette.text.secondary,
  lineHeight: theme.typography.pxToRem(21),
  fontSize: theme.typography.pxToRem(12)
}, ownerState.size === 'small' && {
  padding: '6px 16px',
  [`&.${tableCellClasses$1.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: '0 12px 0 16px',
    '& > *': {
      padding: 0
    }
  }
}, ownerState.padding === 'checkbox' && {
  width: 48,
  // prevent the checkbox column from growing
  padding: '0 0 0 4px'
}, ownerState.padding === 'none' && {
  padding: 0
}, ownerState.align === 'left' && {
  textAlign: 'left'
}, ownerState.align === 'center' && {
  textAlign: 'center'
}, ownerState.align === 'right' && {
  textAlign: 'right',
  flexDirection: 'row-reverse'
}, ownerState.align === 'justify' && {
  textAlign: 'justify'
}, ownerState.stickyHeader && {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: theme.palette.background.default
}));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

const TableCell = /*#__PURE__*/React$d.forwardRef(function TableCell(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableCell'
  });

  const {
    align = 'inherit',
    className,
    component: componentProp,
    padding: paddingProp,
    scope: scopeProp,
    size: sizeProp,
    sortDirection,
    variant: variantProp
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$s);

  const table = React$d.useContext(TableContext$1);
  const tablelvl2 = React$d.useContext(Tablelvl2Context$1);
  const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  let component;

  if (componentProp) {
    component = componentProp;
  } else {
    component = isHeadCell ? 'th' : 'td';
  }

  let scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  const variant = variantProp || tablelvl2 && tablelvl2.variant;

  const ownerState = _extends$P({}, props, {
    align,
    component,
    padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
    size: sizeProp || (table && table.size ? table.size : 'medium'),
    sortDirection,
    stickyHeader: variant === 'head' && table && table.stickyHeader,
    variant
  });

  const classes = useUtilityClasses$c(ownerState);
  let ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/jsx$1(TableCellRoot, _extends$P({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    "aria-sort": ariaSort,
    scope: scope,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableCell.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: PropTypes$1.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: PropTypes$1.oneOf(['checkbox', 'none', 'normal']),

  /**
   * Set scope attribute.
   */
  scope: PropTypes$1.string,

  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: PropTypes$1.oneOf(['small', 'medium']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes$1.oneOf(['asc', 'desc', false]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: PropTypes$1.oneOf(['body', 'footer', 'head'])
} : void 0;
var TableCell$1 = TableCell;

function getTableContainerUtilityClass(slot) {
  return generateUtilityClass('MuiTableContainer', slot);
}
generateUtilityClasses('MuiTableContainer', ['root']);

const _excluded$r = ["className", "component"];

const useUtilityClasses$b = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTableContainerUtilityClass, classes);
};

const TableContainerRoot = styled$1('div', {
  name: 'MuiTableContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  width: '100%',
  overflowX: 'auto'
});
const TableContainer = /*#__PURE__*/React$d.forwardRef(function TableContainer(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableContainer'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$r);

  const ownerState = _extends$P({}, props, {
    component
  });

  const classes = useUtilityClasses$b(ownerState);
  return /*#__PURE__*/jsx$1(TableContainerRoot, _extends$P({
    ref: ref,
    as: component,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableContainer.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `Table`.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var TableContainer$1 = TableContainer;

function getTableHeadUtilityClass(slot) {
  return generateUtilityClass('MuiTableHead', slot);
}
generateUtilityClasses('MuiTableHead', ['root']);

const _excluded$q = ["className", "component"];

const useUtilityClasses$a = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTableHeadUtilityClass, classes);
};

const TableHeadRoot = styled$1('thead', {
  name: 'MuiTableHead',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-header-group'
});
const tablelvl2 = {
  variant: 'head'
};
const defaultComponent$1 = 'thead';
const TableHead = /*#__PURE__*/React$d.forwardRef(function TableHead(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableHead'
  });

  const {
    className,
    component = defaultComponent$1
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$q);

  const ownerState = _extends$P({}, props, {
    component
  });

  const classes = useUtilityClasses$a(ownerState);
  return /*#__PURE__*/jsx$1(Tablelvl2Context$1.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/jsx$1(TableHeadRoot, _extends$P({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      role: component === defaultComponent$1 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableHead.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var TableHead$1 = TableHead;

var KeyboardArrowLeft = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

var KeyboardArrowRight = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

function getTableRowUtilityClass(slot) {
  return generateUtilityClass('MuiTableRow', slot);
}
const tableRowClasses = generateUtilityClasses('MuiTableRow', ['root', 'selected', 'hover', 'head', 'footer']);
var tableRowClasses$1 = tableRowClasses;

const _excluded$p = ["className", "component", "hover", "selected"];

const useUtilityClasses$9 = ownerState => {
  const {
    classes,
    selected,
    hover,
    head,
    footer
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', hover && 'hover', head && 'head', footer && 'footer']
  };
  return composeClasses(slots, getTableRowUtilityClass, classes);
};

const TableRowRoot = styled$1('tr', {
  name: 'MuiTableRow',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.head && styles.head, ownerState.footer && styles.footer];
  }
})(({
  theme
}) => ({
  color: 'inherit',
  display: 'table-row',
  verticalAlign: 'middle',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${tableRowClasses$1.hover}:hover`]: {
    backgroundColor: theme.palette.action.hover
  },
  [`&.${tableRowClasses$1.selected}`]: {
    backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    '&:hover': {
      backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
    }
  }
}));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

const TableRow = /*#__PURE__*/React$d.forwardRef(function TableRow(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableRow'
  });

  const {
    className,
    component = defaultComponent,
    hover = false,
    selected = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$p);

  const tablelvl2 = React$d.useContext(Tablelvl2Context$1);

  const ownerState = _extends$P({}, props, {
    component,
    hover,
    selected,
    head: tablelvl2 && tablelvl2.variant === 'head',
    footer: tablelvl2 && tablelvl2.variant === 'footer'
  });

  const classes = useUtilityClasses$9(ownerState);
  return /*#__PURE__*/jsx$1(TableRowRoot, _extends$P({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    role: component === defaultComponent ? null : 'row',
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableRow.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: PropTypes$1.bool,

  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var TableRow$1 = TableRow;

function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(property, element, to, options = {}, cb = () => {}) {
  const {
    ease = easeInOutSin,
    duration = 300 // standard

  } = options;
  let start = null;
  const from = element[property];
  let cancelled = false;

  const cancel = () => {
    cancelled = true;
  };

  const step = timestamp => {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    const time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(() => {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

const _excluded$o = ["onChange"];
const styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

function ScrollbarSize(props) {
  const {
    onChange
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$o);

  const scrollbarHeight = React$d.useRef();
  const nodeRef = React$d.useRef(null);

  const setMeasurements = () => {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };

  React$d.useEffect(() => {
    const handleResize = debounce$5(() => {
      const prevHeight = scrollbarHeight.current;
      setMeasurements();

      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    const containerWindow = ownerWindow(nodeRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  React$d.useEffect(() => {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /*#__PURE__*/jsx$1("div", _extends$P({
    style: styles,
    ref: nodeRef
  }, other));
}
process.env.NODE_ENV !== "production" ? ScrollbarSize.propTypes = {
  onChange: PropTypes$1.func.isRequired
} : void 0;

function getTabScrollButtonUtilityClass(slot) {
  return generateUtilityClass('MuiTabScrollButton', slot);
}
const tabScrollButtonClasses = generateUtilityClasses('MuiTabScrollButton', ['root', 'vertical', 'horizontal', 'disabled']);
var tabScrollButtonClasses$1 = tabScrollButtonClasses;

var _KeyboardArrowLeft, _KeyboardArrowRight;

const _excluded$n = ["className", "direction", "orientation", "disabled"];

const useUtilityClasses$8 = ownerState => {
  const {
    classes,
    orientation,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation, disabled && 'disabled']
  };
  return composeClasses(slots, getTabScrollButtonUtilityClass, classes);
};

const TabScrollButtonRoot = styled$1(ButtonBase$1, {
  name: 'MuiTabScrollButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.orientation && styles[ownerState.orientation]];
  }
})(({
  ownerState
}) => _extends$P({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${tabScrollButtonClasses$1.disabled}`]: {
    opacity: 0
  }
}, ownerState.orientation === 'vertical' && {
  width: '100%',
  height: 40,
  '& svg': {
    transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
  }
}));
const TabScrollButton = /*#__PURE__*/React$d.forwardRef(function TabScrollButton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTabScrollButton'
  });

  const {
    className,
    direction
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$n);

  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  const ownerState = _extends$P({
    isRtl
  }, props);

  const classes = useUtilityClasses$8(ownerState);
  return /*#__PURE__*/jsx$1(TabScrollButtonRoot, _extends$P({
    component: "div",
    className: clsx(classes.root, className),
    ref: ref,
    role: null,
    ownerState: ownerState,
    tabIndex: null
  }, other, {
    children: direction === 'left' ? _KeyboardArrowLeft || (_KeyboardArrowLeft = /*#__PURE__*/jsx$1(KeyboardArrowLeft, {
      fontSize: "small"
    })) : _KeyboardArrowRight || (_KeyboardArrowRight = /*#__PURE__*/jsx$1(KeyboardArrowRight, {
      fontSize: "small"
    }))
  }));
});
process.env.NODE_ENV !== "production" ? TabScrollButton.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The direction the button should indicate.
   */
  direction: PropTypes$1.oneOf(['left', 'right']).isRequired,

  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes$1.bool,

  /**
   * The component orientation (layout flow direction).
   */
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical']).isRequired,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;
var TabScrollButton$1 = TabScrollButton;

function getTabsUtilityClass(slot) {
  return generateUtilityClass('MuiTabs', slot);
}
const tabsClasses = generateUtilityClasses('MuiTabs', ['root', 'vertical', 'flexContainer', 'flexContainerVertical', 'centered', 'scroller', 'fixed', 'scrollableX', 'scrollableY', 'hideScrollbar', 'scrollButtons', 'scrollButtonsHideMobile', 'indicator']);
var tabsClasses$1 = tabsClasses;

const _excluded$m = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"];

const nextItem = (list, item) => {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return list.firstChild;
};

const previousItem = (list, item) => {
  if (list === item) {
    return list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return list.lastChild;
};

const moveFocus = (list, currentFocus, traversalFunction) => {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus);
    } else {
      nextFocus.focus();
      return;
    }
  }
};

const useUtilityClasses$7 = ownerState => {
  const {
    vertical,
    fixed,
    hideScrollbar,
    scrollableX,
    scrollableY,
    centered,
    scrollButtonsHideMobile,
    classes
  } = ownerState;
  const slots = {
    root: ['root', vertical && 'vertical'],
    scroller: ['scroller', fixed && 'fixed', hideScrollbar && 'hideScrollbar', scrollableX && 'scrollableX', scrollableY && 'scrollableY'],
    flexContainer: ['flexContainer', vertical && 'flexContainerVertical', centered && 'centered'],
    indicator: ['indicator'],
    scrollButtons: ['scrollButtons', scrollButtonsHideMobile && 'scrollButtonsHideMobile'],
    scrollableX: [scrollableX && 'scrollableX'],
    hideScrollbar: [hideScrollbar && 'hideScrollbar']
  };
  return composeClasses(slots, getTabsUtilityClass, classes);
};

const TabsRoot = styled$1('div', {
  name: 'MuiTabs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${tabsClasses$1.scrollButtons}`]: styles.scrollButtons
    }, {
      [`& .${tabsClasses$1.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
    }, styles.root, ownerState.vertical && styles.vertical];
  }
})(({
  ownerState,
  theme
}) => _extends$P({
  overflow: 'hidden',
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.scrollButtonsHideMobile && {
  [`& .${tabsClasses$1.scrollButtons}`]: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
const TabsScroller = styled$1('div', {
  name: 'MuiTabs',
  slot: 'Scroller',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.scroller, ownerState.fixed && styles.fixed, ownerState.hideScrollbar && styles.hideScrollbar, ownerState.scrollableX && styles.scrollableX, ownerState.scrollableY && styles.scrollableY];
  }
})(({
  ownerState
}) => _extends$P({
  position: 'relative',
  display: 'inline-block',
  flex: '1 1 auto',
  whiteSpace: 'nowrap'
}, ownerState.fixed && {
  overflowX: 'hidden',
  width: '100%'
}, ownerState.hideScrollbar && {
  // Hide dimensionless scrollbar on MacOS
  scrollbarWidth: 'none',
  // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Safari + Chrome

  }
}, ownerState.scrollableX && {
  overflowX: 'auto',
  overflowY: 'hidden'
}, ownerState.scrollableY && {
  overflowY: 'auto',
  overflowX: 'hidden'
}));
const FlexContainer = styled$1('div', {
  name: 'MuiTabs',
  slot: 'FlexContainer',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.flexContainer, ownerState.vertical && styles.flexContainerVertical, ownerState.centered && styles.centered];
  }
})(({
  ownerState
}) => _extends$P({
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.centered && {
  justifyContent: 'center'
}));
const TabsIndicator = styled$1('span', {
  name: 'MuiTabs',
  slot: 'Indicator',
  overridesResolver: (props, styles) => styles.indicator
})(({
  ownerState,
  theme
}) => _extends$P({
  position: 'absolute',
  height: 2,
  bottom: 0,
  width: '100%',
  transition: theme.transitions.create()
}, ownerState.indicatorColor === 'primary' && {
  backgroundColor: theme.palette.primary.main
}, ownerState.indicatorColor === 'secondary' && {
  backgroundColor: theme.palette.secondary.main
}, ownerState.vertical && {
  height: '100%',
  width: 2,
  right: 0
}));
const TabsScrollbarSize = styled$1(ScrollbarSize, {
  name: 'MuiTabs',
  slot: 'ScrollbarSize'
})({
  overflowX: 'auto',
  overflowY: 'hidden',
  // Hide dimensionless scrollbar on MacOS
  scrollbarWidth: 'none',
  // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Safari + Chrome

  }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/React$d.forwardRef(function Tabs(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTabs'
  });
  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  const {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    action,
    centered = false,
    children: childrenProp,
    className,
    component = 'div',
    allowScrollButtonsMobile = false,
    indicatorColor = 'primary',
    onChange,
    orientation = 'horizontal',
    ScrollButtonComponent = TabScrollButton$1,
    scrollButtons = 'auto',
    selectionFollowsFocus,
    TabIndicatorProps = {},
    TabScrollButtonProps = {},
    textColor = 'primary',
    value,
    variant = 'standard',
    visibleScrollbar = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$m);

  const scrollable = variant === 'scrollable';
  const vertical = orientation === 'vertical';
  const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  const start = vertical ? 'top' : 'left';
  const end = vertical ? 'bottom' : 'right';
  const clientSize = vertical ? 'clientHeight' : 'clientWidth';
  const size = vertical ? 'height' : 'width';

  const ownerState = _extends$P({}, props, {
    component,
    allowScrollButtonsMobile,
    indicatorColor,
    orientation,
    vertical,
    scrollButtons,
    textColor,
    variant,
    visibleScrollbar,
    fixed: !scrollable,
    hideScrollbar: scrollable && !visibleScrollbar,
    scrollableX: scrollable && !vertical,
    scrollableY: scrollable && vertical,
    centered: centered && !scrollable,
    scrollButtonsHideMobile: !allowScrollButtonsMobile
  });

  const classes = useUtilityClasses$7(ownerState);

  if (process.env.NODE_ENV !== 'production') {
    if (centered && scrollable) {
      console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }

  const [mounted, setMounted] = React$d.useState(false);
  const [indicatorStyle, setIndicatorStyle] = React$d.useState(defaultIndicatorStyle);
  const [displayScroll, setDisplayScroll] = React$d.useState({
    start: false,
    end: false
  });
  const [scrollerStyle, setScrollerStyle] = React$d.useState({
    overflow: 'hidden',
    scrollbarWidth: 0
  });
  const valueToIndex = new Map();
  const tabsRef = React$d.useRef(null);
  const tabListRef = React$d.useRef(null);

  const getTabsMeta = () => {
    const tabsNode = tabsRef.current;
    let tabsMeta;

    if (tabsNode) {
      const rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft

      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: getNormalizedScrollLeft(tabsNode, theme.direction),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }

    let tabMeta;

    if (tabsNode && value !== false) {
      const children = tabListRef.current.children;

      if (children.length > 0) {
        const tab = children[valueToIndex.get(value)];

        if (process.env.NODE_ENV !== 'production') {
          if (!tab) {
            console.error([`MUI: The \`value\` provided to the Tabs component is invalid.`, `None of the Tabs' children match with "${value}".`, valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(', ')}.` : null].join('\n'));
          }
        }

        tabMeta = tab ? tab.getBoundingClientRect() : null;

        if (process.env.NODE_ENV !== 'production') {
          if (process.env.NODE_ENV !== 'test' && !warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0) {
            tabsMeta = null;
            console.error(['MUI: The `value` provided to the Tabs component is invalid.', `The Tab with this \`value\` ("${value}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join('\n'));
            warnedOnceTabPresent = true;
          }
        }
      }
    }

    return {
      tabsMeta,
      tabMeta
    };
  };

  const updateIndicatorState = useEventCallback$1(() => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    let startValue = 0;
    let startIndicator;

    if (vertical) {
      startIndicator = 'top';

      if (tabMeta && tabsMeta) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      }
    } else {
      startIndicator = isRtl ? 'right' : 'left';

      if (tabMeta && tabsMeta) {
        const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
      }
    }

    const newIndicatorStyle = {
      [startIndicator]: startValue,
      // May be wrong until the font is loaded.
      [size]: tabMeta ? tabMeta[size] : 0
    }; // IE11 support, replace with Number.isNaN
    // eslint-disable-next-line no-restricted-globals

    if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
      const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);

      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });

  const scroll = (scrollValue, {
    animation = true
  } = {}) => {
    if (animation) {
      animate(scrollStart, tabsRef.current, scrollValue, {
        duration: theme.transitions.duration.standard
      });
    } else {
      tabsRef.current[scrollStart] = scrollValue;
    }
  };

  const moveTabsScroll = delta => {
    let scrollValue = tabsRef.current[scrollStart];

    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge

      scrollValue *= isRtl && detectScrollType() === 'reverse' ? -1 : 1;
    }

    scroll(scrollValue);
  };

  const getScrollSize = () => {
    const containerSize = tabsRef.current[clientSize];
    let totalSize = 0;
    const children = Array.from(tabListRef.current.children);

    for (let i = 0; i < children.length; i += 1) {
      const tab = children[i];

      if (totalSize + tab[clientSize] > containerSize) {
        break;
      }

      totalSize += tab[clientSize];
    }

    return totalSize;
  };

  const handleStartScrollClick = () => {
    moveTabsScroll(-1 * getScrollSize());
  };

  const handleEndScrollClick = () => {
    moveTabsScroll(getScrollSize());
  }; // TODO Remove <ScrollbarSize /> as browser support for hidding the scrollbar
  // with CSS improves.


  const handleScrollbarSizeChange = React$d.useCallback(scrollbarWidth => {
    setScrollerStyle({
      overflow: null,
      scrollbarWidth
    });
  }, []);

  const getConditionalElements = () => {
    const conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/jsx$1(TabsScrollbarSize, {
      onChange: handleScrollbarSizeChange,
      className: clsx(classes.scrollableX, classes.hideScrollbar)
    }) : null;
    const scrollButtonsActive = displayScroll.start || displayScroll.end;
    const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/jsx$1(ScrollButtonComponent, _extends$P({
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      disabled: !displayScroll.start
    }, TabScrollButtonProps, {
      className: clsx(classes.scrollButtons, TabScrollButtonProps.className)
    })) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/jsx$1(ScrollButtonComponent, _extends$P({
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      disabled: !displayScroll.end
    }, TabScrollButtonProps, {
      className: clsx(classes.scrollButtons, TabScrollButtonProps.className)
    })) : null;
    return conditionalElements;
  };

  const scrollSelectedIntoView = useEventCallback$1(animation => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();

    if (!tabMeta || !tabsMeta) {
      return;
    }

    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart, {
        animation
      });
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
      scroll(nextScrollStart, {
        animation
      });
    }
  });
  const updateScrollButtonState = useEventCallback$1(() => {
    if (scrollable && scrollButtons !== false) {
      const {
        scrollTop,
        scrollHeight,
        clientHeight,
        scrollWidth,
        clientWidth
      } = tabsRef.current;
      let showStartScroll;
      let showEndScroll;

      if (vertical) {
        showStartScroll = scrollTop > 1;
        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
      } else {
        const scrollLeft = getNormalizedScrollLeft(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.

        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
      }

      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  });
  React$d.useEffect(() => {
    const handleResize = debounce$5(() => {
      updateIndicatorState();
      updateScrollButtonState();
    });
    const win = ownerWindow(tabsRef.current);
    win.addEventListener('resize', handleResize);
    let resizeObserver;

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      Array.from(tabListRef.current.children).forEach(child => {
        resizeObserver.observe(child);
      });
    }

    return () => {
      handleResize.clear();
      win.removeEventListener('resize', handleResize);

      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  const handleTabsScroll = React$d.useMemo(() => debounce$5(() => {
    updateScrollButtonState();
  }), [updateScrollButtonState]);
  React$d.useEffect(() => {
    return () => {
      handleTabsScroll.clear();
    };
  }, [handleTabsScroll]);
  React$d.useEffect(() => {
    setMounted(true);
  }, []);
  React$d.useEffect(() => {
    updateIndicatorState();
    updateScrollButtonState();
  });
  React$d.useEffect(() => {
    // Don't animate on the first render.
    scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
  }, [scrollSelectedIntoView, indicatorStyle]);
  React$d.useImperativeHandle(action, () => ({
    updateIndicator: updateIndicatorState,
    updateScrollButtons: updateScrollButtonState
  }), [updateIndicatorState, updateScrollButtonState]);

  const indicator = /*#__PURE__*/jsx$1(TabsIndicator, _extends$P({}, TabIndicatorProps, {
    className: clsx(classes.indicator, TabIndicatorProps.className),
    ownerState: ownerState,
    style: _extends$P({}, indicatorStyle, TabIndicatorProps.style)
  }));

  let childIndex = 0;
  const children = React$d.Children.map(childrenProp, child => {
    if (! /*#__PURE__*/React$d.isValidElement(child)) {
      return null;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (reactIs$3.exports.isFragment(child)) {
        console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    const childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    const selected = childValue === value;
    childIndex += 1;
    return /*#__PURE__*/React$d.cloneElement(child, _extends$P({
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected,
      selectionFollowsFocus,
      onChange,
      textColor,
      value: childValue
    }, childIndex === 1 && value === false && !child.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  });

  const handleKeyDown = event => {
    const list = tabListRef.current;
    const currentFocus = ownerDocument(list).activeElement; // Keyboard navigation assumes that [role="tab"] are siblings
    // though we might warn in the future about nested, interactive elements
    // as a a11y violation

    const role = currentFocus.getAttribute('role');

    if (role !== 'tab') {
      return;
    }

    let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
    let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';

    if (orientation === 'horizontal' && isRtl) {
      // swap previousItemKey with nextItemKey
      previousItemKey = 'ArrowRight';
      nextItemKey = 'ArrowLeft';
    }

    switch (event.key) {
      case previousItemKey:
        event.preventDefault();
        moveFocus(list, currentFocus, previousItem);
        break;

      case nextItemKey:
        event.preventDefault();
        moveFocus(list, currentFocus, nextItem);
        break;

      case 'Home':
        event.preventDefault();
        moveFocus(list, null, nextItem);
        break;

      case 'End':
        event.preventDefault();
        moveFocus(list, null, previousItem);
        break;
    }
  };

  const conditionalElements = getConditionalElements();
  return /*#__PURE__*/jsxs(TabsRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    as: component
  }, other, {
    children: [conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/jsxs(TabsScroller, {
      className: classes.scroller,
      ownerState: ownerState,
      style: {
        overflow: scrollerStyle.overflow,
        [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
      },
      ref: tabsRef,
      onScroll: handleTabsScroll,
      children: [/*#__PURE__*/jsx$1(FlexContainer, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
        className: classes.flexContainer,
        ownerState: ownerState,
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist",
        children: children
      }), mounted && indicator]
    }), conditionalElements.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" ? Tabs.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType$1,

  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: PropTypes$1.bool,

  /**
   * The label for the Tabs as a string.
   */
  'aria-label': PropTypes$1.string,

  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  'aria-labelledby': PropTypes$1.string,

  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: PropTypes$1.bool,

  /**
   * The content of the component.
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,

  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: PropTypes$1.oneOf(['primary', 'secondary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes$1.func,

  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes$1.oneOf(['horizontal', 'vertical']),

  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: PropTypes$1.elementType,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOf(['auto', false, true]),

  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: PropTypes$1.object,

  /**
   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: PropTypes$1.object,

  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: PropTypes$1.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: PropTypes$1.any,

  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: PropTypes$1.oneOf(['fullWidth', 'scrollable', 'standard']),

  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: PropTypes$1.bool
} : void 0;
var Tabs$1 = Tabs;

function getTextFieldUtilityClass(slot) {
  return generateUtilityClass('MuiTextField', slot);
}
generateUtilityClasses('MuiTextField', ['root']);

const _excluded$l = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
const variantComponent = {
  standard: Input$8,
  filled: FilledInput$1,
  outlined: OutlinedInput$1
};

const useUtilityClasses$6 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTextFieldUtilityClass, classes);
};

const TextFieldRoot = styled$1(FormControl$1, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

const TextField = /*#__PURE__*/React$d.forwardRef(function TextField(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTextField'
  });

  const {
    autoComplete,
    autoFocus = false,
    children,
    className,
    color = 'primary',
    defaultValue,
    disabled = false,
    error = false,
    FormHelperTextProps,
    fullWidth = false,
    helperText,
    id: idOverride,
    InputLabelProps,
    inputProps,
    InputProps,
    inputRef,
    label,
    maxRows,
    minRows,
    multiline = false,
    name,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    required = false,
    rows,
    select = false,
    SelectProps,
    type,
    value,
    variant = 'outlined'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$l);

  const ownerState = _extends$P({}, props, {
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select,
    variant
  });

  const classes = useUtilityClasses$6(ownerState);

  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  const InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    InputMore.label = label;
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  const id = useId(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];

  const InputElement = /*#__PURE__*/jsx$1(InputComponent, _extends$P({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));

  return /*#__PURE__*/jsxs(TextFieldRoot, _extends$P({
    className: clsx(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other, {
    children: [label != null && label !== '' && /*#__PURE__*/jsx$1(InputLabel$1, _extends$P({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), select ? /*#__PURE__*/jsx$1(MuiSelect, _extends$P({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement
    }, SelectProps, {
      children: children
    })) : InputElement, helperText && /*#__PURE__*/jsx$1(FormHelperText$1, _extends$P({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? TextField.propTypes
/* remove-proptypes */
= {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes$1.string,

  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes$1.bool,

  /**
   * @ignore
   */
  children: PropTypes$1.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * @ignore
   */
  className: PropTypes$1.string,

  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes$1.string]),

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes$1.any,

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes$1.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes$1.object,

  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes$1.bool,

  /**
   * The helper text content.
   */
  helperText: PropTypes$1.node,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes$1.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes$1.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes$1.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$1,

  /**
   * The label content.
   */
  label: PropTypes$1.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes$1.oneOf(['dense', 'none', 'normal']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes$1.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes$1.string,

  /**
   * @ignore
   */
  onBlur: PropTypes$1.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes$1.func,

  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,

  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes$1.string,

  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes$1.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes$1.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes$1.object,

  /**
   * The size of the component.
   */
  size: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes$1.oneOf(['medium', 'small']), PropTypes$1.string]),

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes$1
  /* @typescript-to-proptypes-ignore */
  .string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes$1.any,

  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes$1.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var TextField$1 = TextField;

var palette$3 = {
    primary: {
        main: '#FF4500',
        900: '#FF1F00',
        800: '#FF2E00',
        700: '#FF3600',
        600: '#FF3E00',
        500: '#FF4500',
        400: '#FF6126',
        300: '#FF7D4D',
        200: '#FFA280',
        100: '#FFC7B3',
        50: '#FFE9E0'
    },
    secondary: {
        main: '#376273',
        900: '#06202E',
        800: '#0B2F3F',
        700: '#0E3748',
        600: '#123F52',
        500: '#14465A',
        400: '#376273',
        300: '#5B7E8C',
        200: '#8AA3AD',
        100: '#B9C8CE',
        50: '#E3E9EB'
    },
    error: {
        main: '#FF0505',
        light: '#FFF2F2'
    },
    background: {
        default: '#fff'
    },
    success: {
        main: '#06AC06'
    },
    warning: {
        main: '#f5a302'
    },
    text: {
        primary: '#333333',
        secondary: '#72758D',
        disabled: '#E5EAF5'
    },
    divider: '#E5EAF5'
};
var typography$2 = {
    fontFamily: [
        'Proxima Nova',
        'Helvetica Neue',
        'Arial',
        'Helvetica',
        'sans-serif'
    ].join(','),
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontSize: 16,
    h1: {
        fontSize: '2.5rem'
    },
    h2: {
        fontSize: '2rem'
    },
    h4: {
        fontSize: '1.5rem'
    },
    h5: {
        fontSize: '1.25rem'
    },
    subtitle1: {
        fontSize: '1.125rem'
    },
    subtitle2: {
        fontSize: '1rem'
    },
    body1: {
        fontSize: '0.875rem'
    },
    body2: {
        fontSize: '0.75rem'
    }
};
var notUsedShadows = Array(23).fill('none');
var theme = createTheme({
    palette: palette$3,
    typography: typography$2,
    shadows: __spreadArray([
        'none',
        '0px 1px 6px 0px rgba(0, 0, 0, 0.1)'
    ], notUsedShadows, true)
});
var additionalPalette = {
    transparent: 'rgba(0, 0, 0, 0)',
    grey: { main: '#989CBE', secondary: '#686C82' },
    lightGrey: { main: '#E5EAF5', secondary: '#F7F7F7' },
    liveBlue: { main: '#0099D6' },
    lightBlue: {
        main: '#F6F9FF',
        secondary: '#F1F4F5'
    },
    darkGrey: { main: '#666666' },
    darkBlue: { main: '#14465A' },
    red: {
        900: '#FF855B',
        800: '#FEE8E6'
    },
    orange: { main: '#FFAB05' },
    green: { main: '#32A852' }
};

var useStyles$Z = makeStyles()(function (theme, _a) {
    var styleProps = _a.styleProps;
    return ({
        accordion: {
            boxShadow: theme.shadows[0],
            padding: theme.spacing(0, 0, 0, styleProps.accordianPaddingLeft || 0),
            '&::before': {
                content: 'none'
            },
            '&.Mui-expanded': {
                margin: 0
            }
        },
        summary: {
            padding: theme.spacing(styleProps.summaryPaddingTopBottom || 0, styleProps.summaryPaddingLeftRight || 0),
            minHeight: theme.spacing(3),
            '&.Mui-expanded': {
                minHeight: theme.spacing(3)
            },
            '& > div.MuiIconButton-root': {
                padding: theme.spacing(0.75),
                marginRight: theme.spacing(-0.75),
                color: theme.palette.secondary.main
            },
            '& > div.MuiAccordionSummary-content': {
                margin: 0
            }
        },
        summaryExpanded: {
            '&.Mui-expanded': {
                margin: 'initial'
            },
            '& > .MuiGrid-root': {
                flexWrap: 'initial'
            }
        },
        details: {
            padding: theme.spacing(0, styleProps.detailsPaddingLeftRight || 0)
        },
        blue: {
            backgroundColor: additionalPalette.lightBlue.main
        },
        white: {
            backgroundColor: theme.palette.background.default
        },
        name: {
            paddingLeft: theme.spacing(1)
        },
        paddingTop: {
            paddingTop: theme.spacing(1)
        }
    });
});

var useStyles$Y = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        root: {
            marginRight: theme.spacing(props.marginRight),
            marginLeft: theme.spacing(props.marginLeft)
        },
        weightBold: {
            fontWeight: theme.typography.fontWeightBold
        },
        weightSemiBold: {
            fontWeight: theme.typography.fontWeightMedium
        },
        weightRegular: {
            fontWeight: theme.typography.fontWeightRegular
        },
        colorWhite: {
            color: theme.palette.background.default
        },
        underlinedText: {
            textDecoration: 'underline'
        },
        notUnderlinedText: {
            textDecoration: 'none'
        }
    });
});

var TextAlign;
(function (TextAlign) {
    TextAlign[TextAlign["Center"] = 0] = "Center";
    TextAlign[TextAlign["Inherit"] = 1] = "Inherit";
    TextAlign[TextAlign["Justify"] = 2] = "Justify";
    TextAlign[TextAlign["Left"] = 3] = "Left";
    TextAlign[TextAlign["Right"] = 4] = "Right";
})(TextAlign || (TextAlign = {}));
var TextSize;
(function (TextSize) {
    TextSize[TextSize["xxl"] = 40] = "xxl";
    TextSize[TextSize["xl"] = 32] = "xl";
    TextSize[TextSize["lxl"] = 24] = "lxl";
    TextSize[TextSize["l"] = 20] = "l";
    TextSize[TextSize["ml"] = 18] = "ml";
    TextSize[TextSize["m"] = 16] = "m";
    TextSize[TextSize["ms"] = 14] = "ms";
    TextSize[TextSize["s"] = 12] = "s";
})(TextSize || (TextSize = {}));
var TextWeight;
(function (TextWeight) {
    TextWeight[TextWeight["Bold"] = 0] = "Bold";
    TextWeight[TextWeight["Regular"] = 1] = "Regular";
    TextWeight[TextWeight["SemiBold"] = 2] = "SemiBold";
})(TextWeight || (TextWeight = {}));
var TextHighlight;
(function (TextHighlight) {
    TextHighlight[TextHighlight["Primary"] = 0] = "Primary";
    TextHighlight[TextHighlight["Emphasis"] = 1] = "Emphasis";
    TextHighlight[TextHighlight["Standard"] = 2] = "Standard";
    TextHighlight[TextHighlight["Background"] = 3] = "Background";
    TextHighlight[TextHighlight["Error"] = 4] = "Error";
    TextHighlight[TextHighlight["Inherit"] = 5] = "Inherit";
    TextHighlight[TextHighlight["White"] = 6] = "White";
})(TextHighlight || (TextHighlight = {}));
var TextDisplay;
(function (TextDisplay) {
    TextDisplay[TextDisplay["Initial"] = 0] = "Initial";
    TextDisplay[TextDisplay["Block"] = 1] = "Block";
    TextDisplay[TextDisplay["Inline"] = 2] = "Inline";
})(TextDisplay || (TextDisplay = {}));
var textVariants = new Map([
    [TextSize.xxl, 'h1'],
    [TextSize.xl, 'h2'],
    [TextSize.lxl, 'h4'],
    [TextSize.l, 'h5'],
    [TextSize.ml, 'subtitle1'],
    [TextSize.m, 'subtitle2'],
    [TextSize.ms, 'body1'],
    [TextSize.s, 'body2']
]);
var textColors$1 = new Map([
    [TextHighlight.Primary, 'primary'],
    [TextHighlight.Emphasis, 'secondary'],
    [TextHighlight.Background, 'textSecondary'],
    [TextHighlight.Error, 'error'],
    [TextHighlight.Standard, 'textPrimary'],
    [TextHighlight.Inherit, 'inherit'],
    [TextHighlight.White, 'inherit']
]);
var textAlignments = new Map([
    [TextAlign.Center, 'center'],
    [TextAlign.Inherit, 'inherit'],
    [TextAlign.Justify, 'justify'],
    [TextAlign.Left, 'left'],
    [TextAlign.Right, 'right']
]);
var textDisplays = new Map([
    [TextDisplay.Initial, 'initial'],
    [TextDisplay.Block, 'block'],
    [TextDisplay.Inline, 'inline']
]);
var Text$1 = function (props) {
    var _a = props.align, align = _a === void 0 ? TextAlign.Inherit : _a, _b = props.display, display = _b === void 0 ? TextDisplay.Block : _b, children = props.children, className = props.className, _c = props.gutterBottom, gutterBottom = _c === void 0 ? false : _c, _d = props.highlight, highlight = _d === void 0 ? TextHighlight.Standard : _d, _e = props.noWrap, noWrap = _e === void 0 ? false : _e, _f = props.marginRight, marginRight = _f === void 0 ? false : _f, _g = props.marginLeft, marginLeft = _g === void 0 ? false : _g, _h = props.size, size = _h === void 0 ? TextSize.m : _h, _j = props.weight, weight = _j === void 0 ? TextWeight.Regular : _j, _k = props.underlined, underlined = _k === void 0 ? false : _k, dataCy = props.dataCy, _l = props.multiline, multiline = _l === void 0 ? false : _l;
    var styleProps = {
        marginRight: marginRight ? 1 : 0,
        marginLeft: marginLeft ? 1 : 0
    };
    var _m = useStyles$Y({ styleProps: styleProps }), classes = _m.classes, classNames = _m.cx;
    var weightCssClasses = new Map([
        [TextWeight.Regular, classes.weightRegular],
        [TextWeight.SemiBold, classes.weightSemiBold],
        [TextWeight.Bold, classes.weightBold]
    ]);
    var underlinedCssClasses = new Map([
        [true, classes.underlinedText],
        [false, classes.notUnderlinedText]
    ]);
    var alignText = textAlignments.get(align);
    var variantText = textVariants.get(size);
    var highlightText = textColors$1.get(highlight);
    var weightCssClass = weightCssClasses.get(weight);
    var underlinedCssClass = underlinedCssClasses.get(underlined);
    var displayText = textDisplays.get(display);
    var cssClass = classNames(classes.root, highlight === TextHighlight.White ? classes.colorWhite : '', weightCssClass, underlinedCssClass, className);
    var content = multiline && typeof children === 'string'
        ? children.split('\n').flatMap(function (line, i) { return [line, jsx$1("br", {}, i)]; })
        : children;
    return (jsx$1(Typography$1, __assign$3({ align: alignText, color: highlightText, className: cssClass, gutterBottom: gutterBottom, noWrap: noWrap, variant: variantText, display: displayText, "data-cy": dataCy }, { children: content })));
};

var classNameBySize = new Map([
    [TextSize.s, 'sizeS'],
    [TextSize.ms, 'sizeMs'],
    [TextSize.m, 'sizeM'],
    [TextSize.ml, 'sizeMl'],
    [TextSize.l, 'sizeL'],
    [TextSize.lxl, 'sizeLxl'],
    [TextSize.xl, 'sizeXl'],
    [TextSize.xxl, 'sizeXxl']
]);
var classNameByHighlight = new Map([
    [TextHighlight.Primary, 'highlightPrimary'],
    [TextHighlight.Emphasis, 'highlightEmphasis'],
    [TextHighlight.Background, 'highlightBackground'],
    [TextHighlight.Error, 'highlightError'],
    [TextHighlight.Standard, 'highlightStandard'],
    [TextHighlight.Inherit, 'highlightInherit'],
    [TextHighlight.White, 'highlightWhite']
]);
var classNameByWeight = new Map([
    [TextWeight.Regular, 'weightRegular'],
    [TextWeight.SemiBold, 'weightSemiBold'],
    [TextWeight.Bold, 'weightBold']
]);
var useTextStyles = makeStyles()(function () {
    var typography = theme.typography, palette = theme.palette, spacing = theme.spacing;
    return {
        default: {
            fontFamily: typography.body1.fontFamily,
            fontSize: typography.subtitle2.fontSize,
            lineHeight: typography.subtitle2.lineHeight,
            fontWeight: typography.fontWeightRegular,
            color: palette.text.primary,
            margin: 0
        },
        highlightPrimary: {
            color: palette.primary.main
        },
        highlightEmphasis: {
            color: palette.secondary.main
        },
        highlightBackground: {
            color: palette.text.secondary
        },
        highlightError: {
            color: palette.error.main
        },
        highlightStandard: {
            color: palette.text.primary
        },
        highlightInherit: {
            color: 'inherit'
        },
        highlightWhite: {
            color: palette.common.white
        },
        weightBold: {
            fontWeight: typography.fontWeightBold
        },
        weightSemiBold: {
            fontWeight: typography.fontWeightMedium
        },
        weightRegular: {
            fontWeight: typography.fontWeightRegular
        },
        sizeS: {
            fontSize: typography.body2.fontSize,
            lineHeight: typography.body2.lineHeight
        },
        sizeMs: {
            fontSize: typography.body1.fontSize,
            lineHeight: typography.body1.lineHeight
        },
        sizeM: {
            fontSize: typography.subtitle2.fontSize,
            lineHeight: typography.subtitle2.lineHeight
        },
        sizeMl: {
            fontSize: typography.subtitle1.fontSize,
            lineHeight: typography.subtitle1.lineHeight
        },
        sizeL: {
            fontSize: typography.h5.fontSize,
            lineHeight: typography.h5.lineHeight
        },
        sizeLxl: {
            fontSize: typography.h4.fontSize,
            lineHeight: typography.h4.lineHeight
        },
        sizeXl: {
            fontSize: typography.h2.fontSize,
            lineHeight: typography.h2.lineHeight
        },
        sizeXxl: {
            fontSize: typography.h1.fontSize,
            lineHeight: typography.h1.lineHeight
        },
        underlinedText: {
            textDecoration: 'underline'
        },
        notUnderlinedText: {
            textDecoration: 'none'
        },
        marginLeft: {
            marginLeft: spacing(1)
        },
        marginRight: {
            marginRight: spacing(1)
        },
        alignCenter: {
            textAlign: 'center'
        },
        alignLeft: {
            textAlign: 'left'
        },
        alignRight: {
            textAlign: 'right'
        },
        gutterBottom: {
            marginBottom: '0.35em'
        },
        noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        displayInline: {
            display: 'inline'
        },
        displayInitial: {
            display: 'initial'
        },
        displayBlock: {
            display: 'block'
        }
    };
});

var text = /*#__PURE__*/Object.freeze({
    __proto__: null,
    classNameBySize: classNameBySize,
    classNameByHighlight: classNameByHighlight,
    classNameByWeight: classNameByWeight,
    useTextStyles: useTextStyles
});

var AccordionVariant;
(function (AccordionVariant) {
    AccordionVariant[AccordionVariant["QuestionnaireAudienceQuestion"] = 0] = "QuestionnaireAudienceQuestion";
    AccordionVariant[AccordionVariant["AudienceBuilder"] = 1] = "AudienceBuilder";
})(AccordionVariant || (AccordionVariant = {}));
var Accordion = function (props) {
    var children = props.children, title = props.title, _a = props.defaultExpanded, defaultExpanded = _a === void 0 ? false : _a, identifier = props.identifier, name = props.name, _b = props.titleDivider, titleDivider = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? AccordionVariant.AudienceBuilder : _c, onExpandedStateChanged = props.onExpandedStateChanged;
    var summaryPaddingTopBottomMap = new Map([
        [AccordionVariant.AudienceBuilder, 0],
        [AccordionVariant.QuestionnaireAudienceQuestion, 2]
    ]);
    var summaryPaddingTopBottom = summaryPaddingTopBottomMap.get(variant);
    var summaryPaddingLeftRightMap = new Map([
        [AccordionVariant.AudienceBuilder, 2],
        [AccordionVariant.QuestionnaireAudienceQuestion, 3]
    ]);
    var summaryPaddingLeftRight = summaryPaddingLeftRightMap.get(variant);
    var detailsPaddingLeftRightMap = new Map([
        [AccordionVariant.AudienceBuilder, 1],
        [AccordionVariant.QuestionnaireAudienceQuestion, 0]
    ]);
    var detailsPaddingLeftRight = detailsPaddingLeftRightMap.get(variant);
    var accordianPaddingLeftMap = new Map([
        [AccordionVariant.AudienceBuilder, 2],
        [AccordionVariant.QuestionnaireAudienceQuestion, 0]
    ]);
    var accordianPaddingLeft = accordianPaddingLeftMap.get(variant);
    var styleProps = {
        detailsPaddingLeftRight: detailsPaddingLeftRight,
        accordianPaddingLeft: accordianPaddingLeft,
        summaryPaddingTopBottom: summaryPaddingTopBottom,
        summaryPaddingLeftRight: summaryPaddingLeftRight
    };
    var _d = useStyles$Z({ styleProps: styleProps }), classes = _d.classes, classNames = _d.cx;
    var textClasses = useTextStyles().classes;
    var backgroundColorMap = new Map([
        [AccordionVariant.AudienceBuilder, classes.blue],
        [AccordionVariant.QuestionnaireAudienceQuestion, classes.white]
    ]);
    var titleSizeMap = new Map([
        [AccordionVariant.AudienceBuilder, textClasses.sizeMs],
        [AccordionVariant.QuestionnaireAudienceQuestion, textClasses.sizeM]
    ]);
    var titleColorMap = new Map([
        [AccordionVariant.AudienceBuilder, textClasses.highlightEmphasis],
        [
            AccordionVariant.QuestionnaireAudienceQuestion,
            textClasses.highlightStandard
        ]
    ]);
    var titleColorClass = titleColorMap.get(variant);
    var titleSizeClass = titleSizeMap.get(variant);
    var backgroundColorClass = backgroundColorMap.get(variant);
    var titleClassName = !!name || !!identifier ? classes.paddingTop : undefined;
    return (jsxs(MuiAccordion, __assign$3({ classes: {
            root: classNames(classes.accordion, backgroundColorClass)
        }, onChange: function (_event, expanded) {
            onExpandedStateChanged && onExpandedStateChanged(expanded);
        }, defaultExpanded: defaultExpanded, "aria-label": title }, { children: [jsx$1(AccordionSummary$1, __assign$3({ classes: {
                    root: classes.summary,
                    content: classes.summaryExpanded
                }, expandIcon: jsx$1(ExpandMore, { "aria-label": title }) }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "column" }, { children: [(identifier || name) && (jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, direction: "row" }, { children: [identifier && (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.highlightBackground, textClasses.weightBold) }, { children: identifier })) }))), name && (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.name }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.highlightBackground) }, { children: name })) })))] }))), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 12, direction: "row", className: titleClassName }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, titleSizeClass, textClasses.weightSemiBold, titleColorClass) }, { children: title })) }))] })) })), titleDivider && jsx$1(Divider, {}), jsx$1(AccordionDetails$1, __assign$3({ classes: {
                    root: classes.details
                } }, { children: jsx$1(Grid$2, __assign$3({ container: true, direction: "column" }, { children: children })) }))] })));
};

var useStyles$X = makeStyles()(function (theme) { return ({
    commonBadgeStyle: {
        borderRadius: theme.spacing(0.25),
        fontSize: theme.spacing(1.5),
        maxHeight: theme.spacing(2.5),
        '& > span': {
            paddingRight: theme.spacing(0.375),
            paddingLeft: theme.spacing(0.375),
            paddingTop: theme.spacing(0.125)
        }
    },
    targetingStyle: {
        color: theme.palette.text.secondary,
        border: "".concat(theme.spacing(0.125), " solid ").concat(additionalPalette.orange.main)
    },
    screeningStyle: {
        backgroundColor: additionalPalette.grey.main,
        color: theme.palette.background.default,
        border: "".concat(theme.spacing(0.125), " solid ").concat(additionalPalette.grey.main)
    }
}); });

var AudienceType;
(function (AudienceType) {
    AudienceType[AudienceType["Targeting"] = 0] = "Targeting";
    AudienceType[AudienceType["Screening"] = 1] = "Screening";
})(AudienceType || (AudienceType = {}));
var BadgeAudience = function (props) {
    var badgeType = props.badgeType, tooltipText = props.tooltipText;
    var _a = useStyles$X(), classes = _a.classes, classNames = _a.cx;
    var labelsEnumMap = new Map([
        [AudienceType.Targeting, 'Targeting'],
        [AudienceType.Screening, 'Screening question']
    ]);
    var classesMap = new Map([
        [AudienceType.Targeting, classes.targetingStyle],
        [AudienceType.Screening, classes.screeningStyle]
    ]);
    var variantsMap = new Map([
        [AudienceType.Targeting, 'outlined'],
        [AudienceType.Screening, 'filled']
    ]);
    var label = labelsEnumMap.get(badgeType) || 'Targeting';
    var selectedClass = classesMap.get(badgeType) || classes.targetingStyle;
    var variant = variantsMap.get(badgeType) || 'outlined';
    var rootCssClass = classes.commonBadgeStyle;
    return (jsx$1(Tooltip$3, __assign$3({ title: tooltipText || '', placement: "right" }, { children: jsx$1(MuiChip, { variant: variant, label: label, className: classNames(rootCssClass, selectedClass) }) })));
};

var Skeleton = function (props) {
    var height = props.height, width = props.width, _a = props.variant, variant = _a === void 0 ? 'text' : _a;
    return jsx$1(Skeleton$2, { variant: variant, height: height, width: width });
};

var API_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
var TOOLTIP_CHARACTERS = 120;

var formatThousandsWithCommas = function (cost) {
    return cost.toLocaleString();
};
var numberToFixedString = function (myNumber) {
    if (Number.isSafeInteger(myNumber)) {
        return myNumber.toFixed(0);
    }
    return myNumber.toFixed(1);
};
var truncate = function (str, numbOfCharacters) {
    return str.length > numbOfCharacters
        ? str.substr(0, numbOfCharacters - 1) + '…'
        : str;
};
var getResponseOptionTooltip = function (value) {
    return typeof value === 'string' && value.length > TOOLTIP_CHARACTERS
        ? value
        : '';
};

var useStyles$W = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        colorPrimary: {
            backgroundColor: props.isProgressNA
                ? additionalPalette.lightGrey.secondary
                : additionalPalette.lightGrey.main
        },
        barColorPrimary: {
            backgroundColor: props.isProgressNA
                ? additionalPalette.lightGrey.secondary
                : additionalPalette.liveBlue.main
        },
        progress: {
            padding: theme.spacing(1, 0)
        },
        stats: {
            minWidth: 20
        }
    });
});

var Progress = function (props) {
    var value = props.value, _a = props.loading, loading = _a === void 0 ? false : _a, _b = props.progressPercentage, progressPercentage = _b === void 0 ? 0 : _b, _c = props.collected, collected = _c === void 0 ? 0 : _c, _d = props.wanted, wanted = _d === void 0 ? 0 : _d, _e = props.isProgressNA, isProgressNA = _e === void 0 ? false : _e;
    var styleProps = { isProgressNA: isProgressNA };
    var classes = useStyles$W({ styleProps: styleProps }).classes;
    var _f = useTextStyles(), textClasses = _f.classes, classNames = _f.cx;
    var progressPercentageControl = loading ? (jsx$1(Skeleton, { variant: "text" })) : (numberToFixedString(progressPercentage));
    var samplesCollectedControl = loading ? (jsx$1(Skeleton, { variant: "text" })) : (formatThousandsWithCommas(collected));
    var samplesWantedControl = loading ? (jsx$1(Skeleton, { variant: "text" })) : (formatThousandsWithCommas(wanted));
    var renderProgressData = function () {
        return isProgressNA ? (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.stats }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.highlightStandard, textClasses.alignRight) }, { children: "N/A" })) }))) : (jsxs(Fragment$1, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.highlightStandard) }, { children: progressPercentageControl })) })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.highlightStandard) }, { children: "%" }))] }));
    };
    return (jsxs(Grid$2, __assign$3({ container: true }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 12, className: classes.progress }, { children: jsx$1(MuiLinearProgress, { classes: {
                        colorPrimary: classes.colorPrimary,
                        barColorPrimary: classes.barColorPrimary
                    }, color: "primary", value: value, variant: "determinate" }) })), jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, justifyContent: "space-between", direction: "row" }, { children: [jsxs(Grid$2, __assign$3({ item: true, container: true, xs: 6, direction: "row" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.highlightStandard, textClasses.alignLeft) }, { children: samplesCollectedControl })) })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.highlightStandard) }, { children: "/" })), jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.highlightStandard) }, { children: samplesWantedControl })) }))] })), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 6, justifyContent: "flex-end", direction: "row" }, { children: renderProgressData() }))] }))] })));
};

var useStyles$V = makeStyles()(function (theme) { return ({
    root: {
        position: 'relative'
    },
    top: {
        position: 'absolute',
        left: 0,
        color: theme.palette.success.main
    },
    circular: {
        color: additionalPalette.lightGrey.main
    }
}); });

var CircularProgress = function (props) {
    var _a = props.current, current = _a === void 0 ? 0 : _a, _b = props.total, total = _b === void 0 ? 1 : _b, className = props.className, style = props.style, _c = props.size, size = _c === void 0 ? 40 : _c, _d = props.variant, variant = _d === void 0 ? 'determinate' : _d;
    var _e = useStyles$V(), classes = _e.classes, classNames = _e.cx;
    return (jsxs("div", __assign$3({ className: classNames(classes.root, className), style: style }, { children: [jsx$1(CircularProgress$2, { variant: variant, className: classes.circular, value: 100, size: size }), variant === 'determinate' && (jsx$1(CircularProgress$2, { variant: "determinate", color: "secondary", className: classes.top, size: size, value: Math.min(100, (current / total) * 100) }))] })));
};

var useStyles$U = makeStyles()(function (theme) { return ({
    buttonNotClickable: {
        textDecoration: 'none',
        textTransform: 'none',
        background: 'none',
        pointerEvents: 'none',
        padding: 0,
        '&:hover': {
            textDecoration: 'none',
            textTransform: 'none',
            background: 'none',
            pointerEvents: 'none'
        }
    },
    buttonClickable: {
        textDecoration: 'none',
        textTransform: 'none',
        background: 'none',
        cursor: 'pointer',
        padding: 0,
        '&:hover': {
            textDecoration: 'none',
            textTransform: 'none',
            background: 'none',
            cursor: 'pointer',
            color: theme.palette.secondary.main
        }
    },
    buttonStyle: {
        minWidth: 0,
        marginRight: theme.spacing(4)
    }
}); });

var FilterButtonVariant;
(function (FilterButtonVariant) {
    FilterButtonVariant[FilterButtonVariant["Selected"] = 0] = "Selected";
    FilterButtonVariant[FilterButtonVariant["Selectable"] = 1] = "Selectable";
    FilterButtonVariant[FilterButtonVariant["Disabled"] = 2] = "Disabled";
})(FilterButtonVariant || (FilterButtonVariant = {}));
var FilterButton = function (props) {
    var _a, _b;
    var _c = useStyles$U(), classes = _c.classes, classNames = _c.cx;
    var textClasses = useTextStyles().classes;
    var variant = props.variant, children = props.children, onClickButton = props.onClickButton;
    var buttonClass = new Map([
        [FilterButtonVariant.Disabled, classes.buttonNotClickable],
        [FilterButtonVariant.Selectable, classes.buttonClickable],
        [FilterButtonVariant.Selected, classes.buttonNotClickable]
    ]);
    var buttonHighlight = new Map([
        [FilterButtonVariant.Disabled, TextHighlight.Background],
        [FilterButtonVariant.Selectable, TextHighlight.Background],
        [FilterButtonVariant.Selected, TextHighlight.Emphasis]
    ]);
    var buttonWeight = new Map([
        [FilterButtonVariant.Disabled, TextWeight.Regular],
        [FilterButtonVariant.Selectable, TextWeight.Regular],
        [FilterButtonVariant.Selected, TextWeight.SemiBold]
    ]);
    var selectedButtonClass = buttonClass.get(variant);
    var selectedButtonTextHighlight = buttonHighlight.get(variant);
    var selectedButtonTextWeight = buttonWeight.get(variant);
    return (jsx$1(Button$3, __assign$3({ disableRipple: true, onClick: onClickButton, className: classNames(selectedButtonClass, classes.buttonStyle) }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses[(_a = classNameByHighlight.get(selectedButtonTextHighlight !== null && selectedButtonTextHighlight !== void 0 ? selectedButtonTextHighlight : TextHighlight.Background)) !== null && _a !== void 0 ? _a : 'highlightBackground'], textClasses.sizeM, textClasses[(_b = classNameByWeight.get(selectedButtonTextWeight !== null && selectedButtonTextWeight !== void 0 ? selectedButtonTextWeight : TextWeight.Regular)) !== null && _b !== void 0 ? _b : 'weightRegular']) }, { children: children })) })));
};

var Filter$2 = function (props) {
    var options = props.options;
    return (jsx$1(Grid$2, __assign$3({ container: true, direction: "row" }, { children: options.map(function (option) {
            return (jsx$1(FilterButton, __assign$3({ variant: option.buttonVariant, onClickButton: function () {
                    return option.onClickFilter && option.onClickFilter(option);
                } }, { children: option.name }), option.name));
        }) })));
};

var noOutlineTextColor = function (theme, isSecondaryNoOutline, isPrimaryNoOutline) {
    if (isSecondaryNoOutline) {
        return theme.palette.text.secondary;
    }
    if (isPrimaryNoOutline) {
        return theme.palette.secondary.main;
    }
    return 'none';
};
var noOutlineBorder = function (isSecondaryNoOutline, isPrimaryNoOutline) {
    if (isSecondaryNoOutline || isPrimaryNoOutline) {
        return '0';
    }
    return '1px solid inherit';
};
var svgUri = encodeURIComponent('<svg width="45" height="30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="#FF6835" d="M25 0H5v6h20zM13 24H0v6h13zM34 12H14v6h20z"/><path fill="#FF855B" d="M20 6H0v6h20z"/><path d="M5 0H2C.8954305 0 0 .8954305 0 2v4h5V0z" fill="#FF4500"/><path fill="#FF855B" d="M45 0H25v6h20zM19 18H0v6h19z"/><path fill="#FA4400" d="M14 12H0v6h14z"/><path fill="#F33D00" d="M40 6H20v6h20z"/></g></svg>');
var useStyles$T = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        customStyle: {
            borderRadius: theme.spacing(0.25),
            border: noOutlineBorder(props === null || props === void 0 ? void 0 : props.isSecondaryNoOutline, props === null || props === void 0 ? void 0 : props.isPrimaryNoOutline),
            '&:hover': {
                border: noOutlineBorder(props === null || props === void 0 ? void 0 : props.isSecondaryNoOutline, props === null || props === void 0 ? void 0 : props.isPrimaryNoOutline)
            },
            color: noOutlineTextColor(theme, props === null || props === void 0 ? void 0 : props.isSecondaryNoOutline, props === null || props === void 0 ? void 0 : props.isPrimaryNoOutline),
            textTransform: 'initial'
        },
        customDisabledButton: {
            '&.Mui-disabled': {
                backgroundColor: additionalPalette.red[900],
                color: additionalPalette.red[800]
            }
        },
        disabledText: {
            '&.Mui-disabled': {
                border: 'none'
            }
        },
        primaryBackground: {
            backgroundImage: "url('data:image/svg+xml;utf8,".concat(svgUri, "')"),
            backgroundRepeat: 'no-repeat'
        },
        linkButton: {
            '&:hover': {
                background: 'none',
                textDecoration: 'none'
            }
        },
        linkButtonNoPadding: {
            padding: 0
        },
        linkButtonAlignTextToEnd: {
            justifyContent: 'end'
        },
        linkButtonText: {
            textTransform: 'none',
            '&:hover': {
                color: theme.palette.primary.main
            }
        },
        linkButtonTextDisabled: {
            textDecoration: 'none',
            textTransform: 'none',
            color: additionalPalette.grey.main
        },
        iconButtonNegativePadding: {
            margin: theme.spacing(-1.5)
        },
        iconButtonShadow: {
            maxHeight: theme.spacing(5),
            maxWidth: theme.spacing(5),
            boxShadow: "0 ".concat(theme.spacing(0.125), " ").concat(theme.spacing(0.375), " 0 rgba(0,0,0,0.1)")
        },
        iconButtonSmallHoverShadowSize: {
            padding: theme.spacing(0.5)
        },
        withText: {
            borderRadius: 0
        },
        smallText: {
            fontSize: theme.typography.fontSize * 0.875
        },
        iconButtonText: {
            marginRight: theme.spacing(1.5)
        }
    });
});

var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant[ButtonVariant["PrimaryFilled"] = 0] = "PrimaryFilled";
    ButtonVariant[ButtonVariant["PrimaryOutlined"] = 1] = "PrimaryOutlined";
    ButtonVariant[ButtonVariant["PrimaryNoOutline"] = 2] = "PrimaryNoOutline";
    ButtonVariant[ButtonVariant["SecondaryFilled"] = 3] = "SecondaryFilled";
    ButtonVariant[ButtonVariant["SecondaryOutlined"] = 4] = "SecondaryOutlined";
    ButtonVariant[ButtonVariant["SecondaryNoOutline"] = 5] = "SecondaryNoOutline";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["Button"] = 0] = "Button";
    ButtonType[ButtonType["Submit"] = 1] = "Submit";
})(ButtonType || (ButtonType = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize[ButtonSize["Medium"] = 0] = "Medium";
    ButtonSize[ButtonSize["Small"] = 1] = "Small";
})(ButtonSize || (ButtonSize = {}));
var colorTextFromEnumMap = new Map([
    [ButtonVariant.PrimaryOutlined, 'primary'],
    [ButtonVariant.PrimaryFilled, 'primary'],
    [ButtonVariant.PrimaryNoOutline, 'secondary'],
    [ButtonVariant.SecondaryFilled, 'secondary'],
    [ButtonVariant.SecondaryOutlined, 'secondary'],
    [ButtonVariant.SecondaryNoOutline, 'secondary']
]);
var variantTextFromEnumMap = new Map([
    [ButtonVariant.PrimaryOutlined, 'outlined'],
    [ButtonVariant.PrimaryNoOutline, 'outlined'],
    [ButtonVariant.PrimaryFilled, 'contained'],
    [ButtonVariant.SecondaryOutlined, 'outlined'],
    [ButtonVariant.SecondaryNoOutline, 'outlined'],
    [ButtonVariant.SecondaryFilled, 'contained']
]);
var buttonTypes = new Map([
    [ButtonType.Button, 'button'],
    [ButtonType.Submit, 'submit']
]);
var Button$1 = function (props) {
    var _a;
    var children = props.children, onClick = props.onClick, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? ButtonVariant.PrimaryFilled : _c, style = props.style, className = props.className, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.hasError, hasError = _e === void 0 ? false : _e, _f = props.isSpan, isSpan = _f === void 0 ? false : _f, _g = props.buttonType, buttonType = _g === void 0 ? ButtonType.Button : _g, _h = props.buttonSize, size = _h === void 0 ? ButtonSize.Medium : _h, dataCy = props.dataCy, startIcon = props.startIcon;
    var isSecondaryNoOutline = variant === ButtonVariant.SecondaryNoOutline;
    var isPrimaryNoOutline = variant === ButtonVariant.PrimaryNoOutline;
    var _j = useStyles$T({
        styleProps: { isPrimaryNoOutline: isPrimaryNoOutline, isSecondaryNoOutline: isSecondaryNoOutline }
    }), classes = _j.classes, classNames = _j.cx;
    var stringVariant = variantTextFromEnumMap.get(variant);
    var color = colorTextFromEnumMap.get(variant);
    var cssClassNames = classNames(classes.customStyle, (_a = {},
        _a[classes.primaryBackground] = variant === ButtonVariant.PrimaryFilled && !disabled,
        _a[classes.smallText] = size === ButtonSize.Small,
        _a), className);
    var disabledCssClassName = hasError
        ? classes.customDisabledButton
        : classes.disabledText;
    return (jsx$1(Button$3
    // why this ignore needed? here and in other places as well
    // @ts-ignore
    , __assign$3({ 
        // why this ignore needed? here and in other places as well
        // @ts-ignore
        component: isSpan ? 'span' : 'button', "aria-label": children === null || children === void 0 ? void 0 : children.toString(), variant: stringVariant, type: buttonTypes.get(buttonType), disabled: disabled, onClick: onClick, classes: { disabled: disabledCssClassName }, color: color, style: style, className: cssClassNames, disableElevation: true, fullWidth: fullWidth, "data-cy": dataCy, startIcon: startIcon }, { children: children })));
};

var useStyles$S = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        text: { marginTop: theme.spacing(2) },
        spinner: {
            width: props.baseSize * 5,
            height: props.baseSize * 5,
            color: props.bkgColor,
            margin: '1px'
        },
        staticConfigurable: {
            background: props.bkgColor,
            width: props.baseSize,
            height: props.baseSize
        },
        // Everything further down cannot be customized with props
        // See https://github.com/mui-org/material-ui/issues/21011
        // and https://stackoverflow.com/questions/61763711/how-can-you-use-dynamic-props-with-keyframes-using-makestyles-from-react-materi
        // TODO: Fix this once there is a solution in the above threads
        staticLarge: {
            animation: "".concat(tssReact.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      0% {\n        box-shadow: \n        0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px, 40px 0px, 40px 40px, \n        40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px, 80px 20px, 80px 40px,\n        80px 60px, 80px 80px\n      },\n      10% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 20px 0px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 40px, 80px 60px, 80px 80px \n      },\n      20% {\n        box-shadow: 0px 20px, 0px 40px, 0px 80px, 20px 0px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 40px, 80px 60px, 80px 80px \n      },\n      30% {\n        box-shadow: 0px 20px, 0px 60px, 0px 80px, 20px 0px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 60px 40px, 60px 80px, 80px 0px, 80px 20px,\n        80px 40px, 80px 60px, 80px 80px\n      },\n      40% {\n        box-shadow: 0px 40px, 0px 60px, 0px 80px, 20px 0px, 40px 0px, 40px 40px,\n        40px 80px, 60px 40px, 80px 0px, 80px 20px, 80px 40px, 80px 60px,\n        80px 80px \n      },\n      50% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 0px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 40px, 80px 60px \n      },\n      60% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 40px 80px, 60px 80px, 80px 0px, 80px 20px,\n        80px 40px, 80px 80px \n      },\n      70% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 60px, 80px 80px \n      },\n      80% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 0px, 40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px,\n        80px 0px, 80px 40px, 80px 60px, 80px 80px \n      },\n      90% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 0px, 40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px,\n        80px 20px, 80px 40px, 80px 60px, 80px 80px \n      }\n      "], ["\n      0% {\n        box-shadow: \n        0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px, 40px 0px, 40px 40px, \n        40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px, 80px 20px, 80px 40px,\n        80px 60px, 80px 80px\n      },\n      10% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 20px 0px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 40px, 80px 60px, 80px 80px \n      },\n      20% {\n        box-shadow: 0px 20px, 0px 40px, 0px 80px, 20px 0px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 40px, 80px 60px, 80px 80px \n      },\n      30% {\n        box-shadow: 0px 20px, 0px 60px, 0px 80px, 20px 0px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 60px 40px, 60px 80px, 80px 0px, 80px 20px,\n        80px 40px, 80px 60px, 80px 80px\n      },\n      40% {\n        box-shadow: 0px 40px, 0px 60px, 0px 80px, 20px 0px, 40px 0px, 40px 40px,\n        40px 80px, 60px 40px, 80px 0px, 80px 20px, 80px 40px, 80px 60px,\n        80px 80px \n      },\n      50% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 0px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 40px, 80px 60px \n      },\n      60% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 40px, 40px 0px,\n        40px 40px, 40px 60px, 40px 80px, 60px 80px, 80px 0px, 80px 20px,\n        80px 40px, 80px 80px \n      },\n      70% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px, 80px 0px,\n        80px 20px, 80px 60px, 80px 80px \n      },\n      80% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 0px, 40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px,\n        80px 0px, 80px 40px, 80px 60px, 80px 80px \n      },\n      90% {\n        box-shadow: 0px 20px, 0px 40px, 0px 60px, 0px 80px, 20px 0px, 20px 40px,\n        40px 0px, 40px 40px, 40px 60px, 40px 80px, 60px 40px, 60px 80px,\n        80px 20px, 80px 40px, 80px 60px, 80px 80px \n      }\n      "]))), " 1s step-end infinite")
        },
        staticMedium: {
            animation: "".concat(tssReact.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      0% {\n        box-shadow: \n        0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px,\n        40px 0px, 40px 10px, 40px 20px, 40px 30px, 40px 40px \n      },\n      10% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 10px 0px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 20px, 40px 30px, 40px 40px \n      },\n      20% {\n        box-shadow: 0px 10px, 0px 20px, 0px 40px, 10px 0px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 20px, 40px 30px, 40px 40px \n      },\n      30% {\n        box-shadow: 0px 10px, 0px 30px, 0px 40px, 10px 0px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 30px 20px, 30px 40px, 40px 0px, 40px 10px,\n        40px 20px, 40px 30px, 40px 40px \n      },\n      40% {\n        box-shadow: 0px 20px, 0px 30px, 0px 40px, 10px 0px, 20px 0px, 20px 20px,\n        20px 40px, 30px 20px, 40px 0px, 40px 10px, 40px 20px, 40px 30px,\n        40px 40px \n      },\n      50% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 20px, 40px 30px \n      },\n      60% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 20px 40px, 30px 40px, 40px 0px, 40px 10px,\n        40px 20px, 40px 40px\n      },\n      70% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 30px, 40px 40px \n      },\n      80% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px,\n        40px 0px, 40px 20px, 40px 30px, 40px 40px \n      },\n      90% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px,\n        40px 10px, 40px 20px, 40px 30px, 40px 40px\n      }\n      "], ["\n      0% {\n        box-shadow: \n        0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px,\n        40px 0px, 40px 10px, 40px 20px, 40px 30px, 40px 40px \n      },\n      10% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 10px 0px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 20px, 40px 30px, 40px 40px \n      },\n      20% {\n        box-shadow: 0px 10px, 0px 20px, 0px 40px, 10px 0px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 20px, 40px 30px, 40px 40px \n      },\n      30% {\n        box-shadow: 0px 10px, 0px 30px, 0px 40px, 10px 0px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 30px 20px, 30px 40px, 40px 0px, 40px 10px,\n        40px 20px, 40px 30px, 40px 40px \n      },\n      40% {\n        box-shadow: 0px 20px, 0px 30px, 0px 40px, 10px 0px, 20px 0px, 20px 20px,\n        20px 40px, 30px 20px, 40px 0px, 40px 10px, 40px 20px, 40px 30px,\n        40px 40px \n      },\n      50% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 20px, 40px 30px \n      },\n      60% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 20px, 20px 0px,\n        20px 20px, 20px 30px, 20px 40px, 30px 40px, 40px 0px, 40px 10px,\n        40px 20px, 40px 40px\n      },\n      70% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px, 40px 0px,\n        40px 10px, 40px 30px, 40px 40px \n      },\n      80% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px,\n        40px 0px, 40px 20px, 40px 30px, 40px 40px \n      },\n      90% {\n        box-shadow: 0px 10px, 0px 20px, 0px 30px, 0px 40px, 10px 0px, 10px 20px,\n        20px 0px, 20px 20px, 20px 30px, 20px 40px, 30px 20px, 30px 40px,\n        40px 10px, 40px 20px, 40px 30px, 40px 40px\n      }\n      "]))), " 1s step-end infinite")
        },
        staticSmall: {
            animation: "".concat(tssReact.keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      0% {\n        box-shadow: \n        0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px,\n        20px 0px, 20px 5px, 20px 10px, 20px 15px, 20px 20px\n      },\n      10% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px,\n        5px 0px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 10px 20px,\n        15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 10px, 20px 15px,\n        20px 20px \n      },\n      20% {\n        box-shadow: 0px 5px, 0px 10px, 0px 20px, 5px 0px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 10px, 20px 15px, 20px 20px \n      },\n      30% {\n        box-shadow: 0px 5px, 0px 15px, 0px 20px, 5px 0px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 15px 10px, 15px 20px, 20px 0px, 20px 5px,\n        20px 10px, 20px 15px, 20px 20px \n      },\n      40% {\n        box-shadow: 0px 10px, 0px 15px, 0px 20px, 5px 0px, 10px 0px, 10px 10px,\n        10px 20px, 15px 10px, 20px 0px, 20px 5px, 20px 10px, 20px 15px,\n        20px 20px \n      },\n      50% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 15px, 10px 20px, 15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 10px, 20px 15px \n      },\n      60% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 10px 20px, 15px 20px, 20px 0px, 20px 5px,\n        20px 10px, 20px 20px \n      },\n      70% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 15px, 20px 20px \n      },\n      80% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px,\n        20px 0px, 20px 10px, 20px 15px, 20px 20px \n      },\n      90% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px,\n        20px 5px, 20px 10px, 20px 15px, 20px 20px\n      }\n      "], ["\n      0% {\n        box-shadow: \n        0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px,\n        20px 0px, 20px 5px, 20px 10px, 20px 15px, 20px 20px\n      },\n      10% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px,\n        5px 0px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 10px 20px,\n        15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 10px, 20px 15px,\n        20px 20px \n      },\n      20% {\n        box-shadow: 0px 5px, 0px 10px, 0px 20px, 5px 0px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 10px, 20px 15px, 20px 20px \n      },\n      30% {\n        box-shadow: 0px 5px, 0px 15px, 0px 20px, 5px 0px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 15px 10px, 15px 20px, 20px 0px, 20px 5px,\n        20px 10px, 20px 15px, 20px 20px \n      },\n      40% {\n        box-shadow: 0px 10px, 0px 15px, 0px 20px, 5px 0px, 10px 0px, 10px 10px,\n        10px 20px, 15px 10px, 20px 0px, 20px 5px, 20px 10px, 20px 15px,\n        20px 20px \n      },\n      50% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 15px, 10px 20px, 15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 10px, 20px 15px \n      },\n      60% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 10px, 10px 0px,\n        10px 10px, 10px 15px, 10px 20px, 15px 20px, 20px 0px, 20px 5px,\n        20px 10px, 20px 20px \n      },\n      70% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px, 20px 0px,\n        20px 5px, 20px 15px, 20px 20px \n      },\n      80% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px,\n        20px 0px, 20px 10px, 20px 15px, 20px 20px \n      },\n      90% {\n        box-shadow: 0px 5px, 0px 10px, 0px 15px, 0px 20px, 5px 0px, 5px 10px,\n        10px 0px, 10px 10px, 10px 15px, 10px 20px, 15px 10px, 15px 20px,\n        20px 5px, 20px 10px, 20px 15px, 20px 20px\n      }\n      "]))), " 1s infinite step-end ")
        }
    });
});
var templateObject_1, templateObject_2, templateObject_3;

var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize[SpinnerSize["s"] = 0] = "s";
    SpinnerSize[SpinnerSize["m"] = 1] = "m";
    SpinnerSize[SpinnerSize["l"] = 2] = "l";
})(SpinnerSize || (SpinnerSize = {}));
var SpinnerColor;
(function (SpinnerColor) {
    SpinnerColor[SpinnerColor["Primary"] = 0] = "Primary";
    SpinnerColor[SpinnerColor["Secondary"] = 1] = "Secondary";
    SpinnerColor[SpinnerColor["Contrast"] = 2] = "Contrast";
})(SpinnerColor || (SpinnerColor = {}));
var Spinner = function (props) {
    var size = props.size, color = props.color, className = props.className;
    var theme = useTheme();
    var spinnerColor = new Map([
        [SpinnerColor.Primary, theme.palette.primary.main],
        [SpinnerColor.Secondary, theme.palette.secondary.main],
        [SpinnerColor.Contrast, theme.palette.background.default]
    ]);
    var bkgColor = spinnerColor.get(color);
    var spinnerSizePx = new Map([
        [SpinnerSize.s, 5],
        [SpinnerSize.m, 10],
        [SpinnerSize.l, 20]
    ]);
    var baseSize = spinnerSizePx.get(size);
    var _a = useStyles$S({
        styleProps: {
            bkgColor: bkgColor || theme.palette.primary.main,
            baseSize: baseSize || 10
        }
    }), classes = _a.classes, classNames = _a.cx;
    var spinner = classes.spinner, staticSmall = classes.staticSmall, staticMedium = classes.staticMedium, staticLarge = classes.staticLarge, staticConfigurable = classes.staticConfigurable;
    var spinnerSizes = new Map([
        [SpinnerSize.s, staticSmall],
        [SpinnerSize.m, staticMedium],
        [SpinnerSize.l, staticLarge]
    ]);
    var spinnerCssClass = spinnerSizes.get(size);
    return (jsx$1("div", __assign$3({ "data-testid": "spinner", className: classNames(spinner, className) }, { children: jsx$1("div", { className: classNames(staticConfigurable, spinnerCssClass) }) })));
};

var SpinnerButton = function (props) {
    var children = props.children, _a = props.loading, loading = _a === void 0 ? false : _a, disabled = props.disabled, onClick = props.onClick, color = props.color, style = props.style, fullWidth = props.fullWidth, buttonType = props.buttonType, className = props.className, dataCy = props.dataCy;
    var _b = useState(0), sizeWidthButton = _b[0], setWidthButton = _b[1];
    var ref = useRef(null);
    useEffect(function () {
        setWidthButton(ref.current ? ref.current.offsetWidth : 0);
    }, []);
    return (jsx$1(Button$1, __assign$3({ disabled: disabled, onClick: loading ? undefined : onClick, "aria-label": children === null || children === void 0 ? void 0 : children.toString(), color: color, style: style, fullWidth: fullWidth, buttonType: buttonType, className: className, variant: ButtonVariant.PrimaryFilled, dataCy: dataCy }, { children: loading ? (jsx$1(Grid$2, __assign$3({ container: true, item: true, alignItems: "center", justifyContent: "center", style: { minWidth: "".concat(sizeWidthButton, "px") } }, { children: jsx$1(Spinner, { size: SpinnerSize.s, color: SpinnerColor.Contrast }) }))) : (jsx$1(Grid$2, __assign$3({ ref: ref }, { children: children }))) })));
};

var useStyles$R = makeStyles()(function (theme) { return ({
    dialogueActions: {
        padding: theme.spacing(1.5, 3.5, 1.5, 4)
    },
    dialogueContent: {
        padding: theme.spacing(4)
    },
    fullSizeContent: {
        padding: 0
    },
    dialogClose: {
        marginRight: theme.spacing(0.25)
    },
    dialogTitle: {
        padding: theme.spacing(1, 2, 1, 4)
    },
    dialogTitleNoClose: {
        padding: theme.spacing(2, 4)
    },
    paper: {
        borderRadius: theme.spacing(0.25)
    },
    fullSizePaper: {
        height: '90%',
        width: '90%'
    },
    containerBackground: {
        backgroundColor: additionalPalette.darkGrey.main
    },
    spacing: {
        justifyContent: 'space-between'
    },
    primaryButtonStatusRight: {
        marginLeft: theme.spacing(2)
    }
}); });

var DialogVariant;
(function (DialogVariant) {
    DialogVariant[DialogVariant["SingleButton"] = 0] = "SingleButton";
    DialogVariant[DialogVariant["DoubleButton"] = 1] = "DoubleButton";
    DialogVariant[DialogVariant["SingleButtonStatus"] = 2] = "SingleButtonStatus";
})(DialogVariant || (DialogVariant = {}));
var DialogMaxWidth;
(function (DialogMaxWidth) {
    DialogMaxWidth[DialogMaxWidth["Sm"] = 0] = "Sm";
    DialogMaxWidth[DialogMaxWidth["Md"] = 1] = "Md";
    DialogMaxWidth[DialogMaxWidth["Lg"] = 2] = "Lg";
})(DialogMaxWidth || (DialogMaxWidth = {}));
var dialogMaxWidth = new Map([
    [DialogMaxWidth.Lg, 'lg'],
    [DialogMaxWidth.Md, 'md'],
    [DialogMaxWidth.Sm, 'sm']
]);
var FullScreenTransition = React$d.forwardRef(function (props, ref) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx$1(Slide$1, __assign$3({ direction: "up", ref: ref }, props));
});
var Dialog = function (props) {
    var _a;
    var children = props.children, _b = props.fullWidth, fullWidth = _b === void 0 ? false : _b, _c = props.fullScreen, fullScreen = _c === void 0 ? false : _c, onClose = props.onClose, onClickOutside = props.onClickOutside, _d = props.open, open = _d === void 0 ? false : _d, primaryButtonClick = props.primaryButtonClick, _e = props.primaryButtonDisabled, primaryButtonDisabled = _e === void 0 ? false : _e, primaryButtonLoading = props.primaryButtonLoading, primaryButtonText = props.primaryButtonText, secondaryButtonClick = props.secondaryButtonClick, _f = props.secondaryButtonDisabled, secondaryButtonDisabled = _f === void 0 ? false : _f, secondaryButtonText = props.secondaryButtonText, title = props.title, _g = props.variant, variant = _g === void 0 ? DialogVariant.SingleButton : _g, _h = props.maxWidth, maxWidth = _h === void 0 ? DialogMaxWidth.Sm : _h, statusComponent = props.statusComponent, _j = props.statusOnRight, statusOnRight = _j === void 0 ? false : _j, _k = props.dataCyPrimaryButton, dataCyPrimaryButton = _k === void 0 ? 'dialog-primary-button' : _k, _l = props.dataCySecondaryButton, dataCySecondaryButton = _l === void 0 ? 'dialog-secondary-button' : _l;
    var _m = useStyles$R(), classes = _m.classes, classNames = _m.cx;
    var textClasses = useTextStyles().classes;
    var getDialogActions = function () {
        return (jsxs(DialogActions$1, __assign$3({ className: classes.dialogueActions, classes: {
                spacing: variant === DialogVariant.SingleButtonStatus && !statusOnRight
                    ? classes.spacing
                    : ''
            } }, { children: [variant === DialogVariant.SingleButtonStatus && statusComponent, variant === DialogVariant.DoubleButton && (jsx$1(Button$1, __assign$3({ variant: ButtonVariant.PrimaryOutlined, disabled: secondaryButtonDisabled, onClick: secondaryButtonClick, dataCy: dataCySecondaryButton }, { children: secondaryButtonText }))), jsx$1(SpinnerButton, __assign$3({ className: statusOnRight ? classes.primaryButtonStatusRight : undefined, "data-testid": "dialog-primary-button", loading: primaryButtonLoading, disabled: primaryButtonDisabled, onClick: primaryButtonClick, dataCy: dataCyPrimaryButton }, { children: primaryButtonText }))] })));
    };
    return (jsxs(Dialog$2, __assign$3({ open: open, fullScreen: fullScreen, TransitionComponent: fullScreen ? FullScreenTransition : undefined, fullWidth: fullWidth, maxWidth: dialogMaxWidth.get(maxWidth), PaperProps: {
            className: classNames((_a = {}, _a[classes.paper] = !fullScreen, _a))
        }, classes: {
            container: classes.containerBackground
        }, "aria-labelledby": "dialog", onClose: onClickOutside }, { children: [jsx$1(DialogTitle$1, __assign$3({ id: "dialog-title", className: onClose ? classes.dialogTitle : classes.dialogTitleNoClose }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "space-between" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, container: true, alignContent: "center", xs: 10 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.weightSemiBold, textClasses.highlightStandard) }, { children: title })) })), onClose && (jsx$1(Grid$2, __assign$3({ item: true, container: true, justifyContent: "flex-end", xs: 2 }, { children: jsx$1(IconButton$2, __assign$3({ "aria-label": "close dialogue", edge: "end", color: "secondary", component: "span", className: classes.dialogClose, onClick: onClose, size: "large" }, { children: jsx$1(Close$2, {}) })) })))] })) })), jsx$1(DialogContent$1, __assign$3({ dividers: true, className: fullScreen ? classes.fullSizeContent : classes.dialogueContent }, { children: children })), getDialogActions()] })));
};

var createIcon = {};

var require$$0$5 = /*@__PURE__*/getAugmentedNamespace(utils$l);

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

var _utils = require$$0$5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(path, name) {
  return (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
    d: path
  }), name);
};

exports["default"] = _default;
}(createIcon));

var ChevronDoubleLeft$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIcon = _interopRequireDefault(createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z', 'ChevronDoubleLeft');

exports["default"] = _default;
}(ChevronDoubleLeft$1));

var ChevronDoubleLeft = /*@__PURE__*/getDefaultExportFromCjs(ChevronDoubleLeft$1);

var ChevronDoubleRight$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIcon = _interopRequireDefault(createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z', 'ChevronDoubleRight');

exports["default"] = _default;
}(ChevronDoubleRight$1));

var ChevronDoubleRight = /*@__PURE__*/getDefaultExportFromCjs(ChevronDoubleRight$1);

var Close$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIcon = _interopRequireDefault(createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z', 'Close');

exports["default"] = _default;
}(Close$1));

var Close = /*@__PURE__*/getDefaultExportFromCjs(Close$1);

var Filter$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIcon = _interopRequireDefault(createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z', 'Filter');

exports["default"] = _default;
}(Filter$1));

var Filter = /*@__PURE__*/getDefaultExportFromCjs(Filter$1);

var FilterOutline$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIcon = _interopRequireDefault(createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z', 'FilterOutline');

exports["default"] = _default;
}(FilterOutline$1));

var FilterOutline = /*@__PURE__*/getDefaultExportFromCjs(FilterOutline$1);

var PlayCircleOutline$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIcon = _interopRequireDefault(createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,16.5L16,12L10,7.5V16.5Z', 'PlayCircleOutline');

exports["default"] = _default;
}(PlayCircleOutline$1));

var PlayCircleOutline = /*@__PURE__*/getDefaultExportFromCjs(PlayCircleOutline$1);

var MediaType;
(function (MediaType) {
    MediaType["Image"] = "Image";
    MediaType["Video"] = "Video";
})(MediaType || (MediaType = {}));

var useStyles$Q = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        videoContainer: {
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden',
            maxWidth: '100%',
            '& iframe': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            }
        },
        dialogueContent: {
            padding: 0,
            backgroundColor: additionalPalette.darkGrey.main,
            border: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& img': {
                maxWidth: '100%',
                maxHeight: '100%'
            }
        },
        containerBackground: {
            backgroundColor: additionalPalette.darkGrey.main,
            borderRadius: 0
        },
        closeButton: {
            marginLeft: 'auto'
        },
        playIcon: {
            color: additionalPalette.lightGrey.main
        },
        thumbnailContainer: {
            width: theme.spacing(8),
            height: '100%',
            minHeight: theme.spacing(3.75),
            backgroundColor: additionalPalette.lightGrey.main,
            border: 'none',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            borderRadius: (props === null || props === void 0 ? void 0 : props.noBorderRadius) ? undefined : '2px',
            backgroundPosition: 'center',
            cursor: 'pointer'
        }
    });
});

var Media = function (props) {
    var mediaUrl = props.mediaUrl, thumbnailUrl = props.thumbnailUrl, mediaType = props.mediaType, _a = props.mediaFullscreen, mediaFullscreen = _a === void 0 ? false : _a, _b = props.noBorderRadius, noBorderRadius = _b === void 0 ? false : _b, _c = props.openMenuOnClick, openMenuOnClick = _c === void 0 ? false : _c, onMediaClick = props.onMediaClick, onMediaMinimized = props.onMediaMinimized;
    var _d = useState(mediaFullscreen), mediaFullScreen = _d[0], setMediaFullScreen = _d[1];
    var classes = useStyles$Q({ styleProps: { noBorderRadius: noBorderRadius } }).classes;
    useEffect(function () {
        setMediaFullScreen(mediaFullscreen);
    }, [mediaFullscreen]);
    var minimizeMedia = function () {
        setMediaFullScreen(false);
        onMediaMinimized === null || onMediaMinimized === void 0 ? void 0 : onMediaMinimized();
    };
    var maximizeMedia = function () {
        setMediaFullScreen(true);
    };
    var handleMediaClick = function (event) {
        if (onMediaClick && openMenuOnClick) {
            onMediaClick(event);
        }
        else
            maximizeMedia();
    };
    return (jsxs(Fragment$1, { children: [jsx$1("button", __assign$3({ type: "button", onClick: handleMediaClick, className: classes.thumbnailContainer, style: { backgroundImage: "url(".concat(thumbnailUrl, ")") } }, { children: mediaType === MediaType.Video && (jsx$1(PlayCircleOutline, { className: classes.playIcon })) })), mediaFullScreen && (jsxs(Dialog$2, __assign$3({ open: mediaFullScreen, fullScreen: true, maxWidth: "lg", classes: {
                    container: classes.containerBackground
                }, "aria-labelledby": "dialog", onClose: minimizeMedia }, { children: [jsx$1(AppBar$1, __assign$3({ style: { backgroundColor: 'transparent' } }, { children: jsx$1(IconButton$2, __assign$3({ className: classes.closeButton, edge: "start", color: "inherit", onClick: minimizeMedia, "aria-label": "close", size: "large" }, { children: jsx$1(Close, {}) })) })), jsxs(DialogContent$1, __assign$3({ className: classes.dialogueContent }, { children: [mediaType === MediaType.Video && (jsx$1("div", __assign$3({ className: classes.videoContainer }, { children: jsx$1("iframe", { src: mediaUrl, title: "YouTube video player", frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope", allowFullScreen: true }) }))), mediaType === MediaType.Image && jsx$1("img", { alt: "name", src: mediaUrl })] }))] })))] }));
};

var useStyles$P = makeStyles()(function (theme) { return ({
    container: {
        boxSizing: 'border-box',
        border: '1px dashed',
        borderColor: theme.palette.text.disabled,
        cursor: 'pointer'
    },
    containerError: {
        border: '1px dashed',
        borderColor: theme.palette.primary.main
    },
    containerDropping: {
        border: '1px solid',
        borderColor: theme.palette.text.disabled
    },
    validImageContainer: {
        height: '80px',
        border: "1px solid ".concat(theme.palette.text.disabled),
        minWidth: '560px',
        marginTop: theme.spacing(4)
    },
    statsContainer: {
        marginLeft: theme.spacing(2)
    },
    nameContainer: {
        maxWidth: '300px',
        overflowWrap: 'break-word'
    },
    previewImage: {
        height: '78px',
        maxWidth: '149px'
    },
    errorContainer: {
        margin: theme.spacing(2, 0, -1, -1)
    },
    negativeMargins: {
        margin: theme.spacing(-1.75)
    },
    dropIcon: {
        marginBottom: theme.spacing(-1)
    },
    tabRoot: {
        textTransform: 'none',
        minWidth: '60px'
    },
    tabSelected: {
        color: theme.palette.secondary.main
    },
    tabsRoot: {
        margin: theme.spacing(-4, -4, 0, -4),
        borderBottom: '1px solid #E5EAF5',
        padding: theme.spacing(0, 3)
    },
    tabsIndicator: {
        height: '1px'
    },
    sizingContainer: {
        height: '180px',
        minWidth: '560px',
        margin: theme.spacing(-1),
        marginTop: theme.spacing(5)
    },
    videoText: {
        marginBottom: theme.spacing(0.5)
    },
    mediaUploader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        maxWidth: '100%'
    }
}); });

var Grid = function (props) {
    var children = props.children;
    /* This is just a wrapper around the Mui Grid component */
    /* eslint-disable react/jsx-props-no-spreading */
    return jsx$1(Grid$2, __assign$3({}, props, { children: children }));
};

var ImageLoaded = function (props) {
    var selectedFile = props.selectedFile, tempImageSource = props.tempImageSource, onRemoveTemporaryImage = props.onRemoveTemporaryImage;
    var classes = useStyles$P().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsxs(Grid, __assign$3({ container: true, direction: "row", justifyContent: "space-between", className: classes.validImageContainer }, { children: [jsxs(Grid, __assign$3({ item: true, container: true, xs: 10, direction: "row", alignItems: "center" }, { children: [jsx$1(Grid, __assign$3({ item: true }, { children: jsx$1("img", { className: classes.previewImage, alt: selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name, src: tempImageSource }) })), jsxs(Grid, __assign$3({ className: classes.statsContainer }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, classes.nameContainer) }, { children: selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.highlightBackground) }, { children: "File size: ".concat(Math.round(((selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.size) || 0) / 1000), "KB") }))] }))] })), jsx$1(Grid, __assign$3({ item: true, container: true, xs: 2, direction: "column", justifyContent: "center", alignItems: "center" }, { children: jsx$1(Button$1, __assign$3({ variant: ButtonVariant.SecondaryNoOutline, onClick: onRemoveTemporaryImage }, { children: "Remove" })) }))] })));
};

var useStyles$O = makeStyles()(function (theme) { return ({
    smallFont: {
        fontSize: '1rem'
    },
    mediumFont: {
        fontSize: '1.25rem'
    },
    largeFont: {
        fontSize: '1.5rem'
    },
    xlargeFont: {
        fontSize: '1.75rem'
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    textColor: {
        color: theme.palette.text.primary
    },
    backgroundColor: {
        color: theme.palette.text.secondary
    },
    emphasisColor: {
        color: theme.palette.secondary.main
    },
    disabledColor: {
        color: theme.palette.text.disabled
    },
    enabledColor: {
        color: theme.palette.success.main
    },
    error: {
        color: theme.palette.error.main
    },
    warning: {
        color: theme.palette.warning.main
    },
    white: {
        color: theme.palette.background.default
    },
    green: {
        color: additionalPalette.green.main
    },
    badgePrimaryColor: {
        color: theme.palette.background.default,
        background: theme.palette.primary.main
    },
    badgeTextColor: {
        color: theme.palette.background.default,
        background: theme.palette.text.primary
    },
    badgeBackgroundColor: {
        color: theme.palette.background.default,
        background: theme.palette.text.secondary
    },
    badgeEmphasisColor: {
        color: theme.palette.background.default,
        background: theme.palette.secondary.main
    },
    badgeDisabledColor: {
        color: theme.palette.text.primary,
        background: theme.palette.text.disabled
    },
    badgeEnabledColor: {
        color: theme.palette.background.default,
        background: theme.palette.success.main
    },
    badgeError: {
        color: theme.palette.background.default,
        background: theme.palette.error.main
    },
    badgeWarning: {
        color: theme.palette.background.default,
        background: theme.palette.warning.main
    },
    badgeWhite: {
        color: theme.palette.text.primary,
        background: theme.palette.background.default
    },
    whiteBorder: {
        border: '1px solid white'
    },
    rtl: {
        display: 'flex',
        justifyContent: 'end'
    }
}); });

var _path$z;

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$O({
    width: 14,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React$d.createElement("path", {
    d: "m9.034.973.087.077 4.243 4.243a1 1 0 0 1 .078 1.327l-.078.087-4.243 4.243A1 1 0 0 1 7.63 9.623l.078-.087 2.535-2.537L1.343 7a1 1 0 0 1-.125-1.992L1.343 5h8.9L7.706 2.463a1 1 0 0 1-.078-1.327l.078-.087A1 1 0 0 1 9.034.973z"
  })));
};

var _path$y;

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$N({
    width: 21,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/React$d.createElement("path", {
    d: "M10.028.004c4.054.1 6.619 2.226 7.886 5.616.39 1.043.633 2.146.762 3.27.07.617.097 1.117.103 1.628l.001.373.033.081c.043.103.132.296.271.544.267.479.68 1.108 1.235 1.883.2.278.308.615.308.96 0 .899-.715 1.627-1.597 1.627h-.044a.208.208 0 0 0-.206.21c0 1.22-.971 2.21-2.17 2.21h-.138a.348.348 0 0 0-.345.352V20c0 1.105-.88 2-1.964 2H4.488v-1c0-2.24-.829-4.549-2.842-7.56C.328 11.486.285 8.078 1.54 5.26 3.02 1.94 5.992-.096 10.028.005zm-6.7 6.083c-.99 2.222-.957 4.896-.062 6.225l.251.38c1.717 2.644 2.62 4.888 2.865 7.067l.024.241h7.757v-1.242c0-1.299 1.034-2.352 2.309-2.352h.139a.208.208 0 0 0 .206-.21l.005-.158a2.206 2.206 0 0 1 1.423-1.92l.133-.044-.16-.23-.314-.47c-.735-1.126-1.087-1.9-1.087-2.483v-.07a13.62 13.62 0 0 0-.091-1.7c-.111-.97-.32-1.914-.646-2.789-1-2.675-2.9-4.25-6.1-4.329-3.222-.08-5.489 1.472-6.653 4.084zM9.827 4c2.711 0 4.909 2.239 4.909 5 0 1.63-1.654 2.828-4.355 3.643C7.496 13.513 4.92 11.9 4.92 9c0-2.761 2.198-5 4.908-5zm0 2C8.202 6 6.883 7.343 6.883 9c0 1.466 1.236 2.24 2.941 1.725 1.929-.581 2.95-1.32 2.95-1.725 0-1.657-1.319-3-2.946-3z"
  })));
};

var _path$x;

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var SvgConsistency = function SvgConsistency(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$M({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/React$d.createElement("path", {
    d: "M21.894 15.553a1 1 0 0 1-.345 1.283l-.102.058-10 5a1 1 0 0 1-.77.052l-.124-.052-10-5a1 1 0 0 1 .787-1.835l.107.047L11 19.88l9.553-4.775a1 1 0 0 1 1.341.447zm0-5a1 1 0 0 1-.345 1.283l-.102.058-10 5a1 1 0 0 1-.77.052l-.124-.052-10-5a1 1 0 0 1 .787-1.835l.107.047L11 14.88l9.553-4.775a1 1 0 0 1 1.341.447zM10.553.106a1 1 0 0 1 .894 0l10 5a1 1 0 0 1 0 1.788l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1 0-1.788zM11 2.118 3.236 6 11 9.881 18.763 6 11 2.118z"
  })));
};

var _path$w;

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4 -4 24 24"
  }, props), _path$w || (_path$w = /*#__PURE__*/React$d.createElement("path", {
    d: "M10 0H2C.9 0 0 .9 0 2v10h2V2h8V0zm3 4H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 12H6V6h7v10z"
  })));
};

var _path$v;

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var SvgDuplicateWrite = function SvgDuplicateWrite(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$K({
    width: 75,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/React$d.createElement("path", {
    d: "M15.621.5a3 3 0 0 1 2.994 2.803l.006.197V6a1 1 0 0 1-1.992.125L16.621 6V3.5a1 1 0 0 0-.874-.992L15.62 2.5h-12a1 1 0 0 0-.992.875l-.008.125v16a1 1 0 0 0 .875.992l.125.008h12a1 1 0 0 0 .993-.875l.015-.25a1 1 0 0 1 1.992.125 3 3 0 0 1-2.802 2.994l-.198.006h-12a3 3 0 0 1-2.993-2.803L.62 19.5v-16A3 3 0 0 1 3.424.506L3.621.5h12zm52 0a1.01 1.01 0 0 1 .247.03l.035.01c.032.01.062.02.091.032l.022.01a.92.92 0 0 1 .086.041l.029.017a.955.955 0 0 1 .197.153L68.236.71c.023.018.045.037.067.057l.025.025 6 6a1 1 0 0 1 .213.313l.007.017a.93.93 0 0 1 .035.103l.006.02c.01.042.02.085.025.129l.006.112.001.013v12a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3v-16a3 3 0 0 1 3-3h8zm-1 1.999-7 .001a1 1 0 0 0-.992.875l-.008.125v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-11h-5a1 1 0 0 1-.992-.875l-.008-.125V2.499zm-1 8.001a1 1 0 0 1 .993.875l.007.125v1.999l2 .001a1 1 0 0 1 .126 1.992l-.126.008-2-.001V17.5a1 1 0 0 1-1.992.125l-.008-.125v-2.001l-2 .001a1 1 0 0 1-.125-1.992l.125-.008 2-.001V11.5a1 1 0 0 1 1-1zM21.992 5.294a2.712 2.712 0 0 1 3.835 3.835l-8.17 8.17a1 1 0 0 1-.444.258l-3.329.908a1.09 1.09 0 0 1-.122.025l-.015.002-.026.004a.999.999 0 0 1-.058.004H5.621a1 1 0 0 1-.125-1.992l.125-.008h7.236l.707-2.592a1 1 0 0 1 .172-.346l.086-.098zm19.663 1.179.088.077 4.242 4.243a1 1 0 0 1 .078 1.327l-.078.087-4.242 4.243a1 1 0 0 1-1.492-1.327l.077-.087 2.535-2.537-8.899.001a1 1 0 0 1-.125-1.992l.125-.008 8.9-.001-2.536-2.535a1 1 0 0 1-.077-1.327l.077-.087a1 1 0 0 1 1.327-.077zm-17.561.051a.712.712 0 0 0-.688.185l-7.982 7.981-.377 1.384 1.383-.378 7.983-7.981a.712.712 0 0 0 .204-.581l-.02-.106a.712.712 0 0 0-.503-.504zM11.62 12.5a1 1 0 0 1 .126 1.992l-.126.008h-6a1 1 0 0 1-.125-1.992l.125-.008h6zm2-4a1 1 0 0 1 .126 1.992l-.126.008h-8a1 1 0 0 1-.125-1.992L5.62 8.5h8zm55-4.586v2.585l2.586.001-2.586-2.586zm-57 .586a1 1 0 0 1 .126 1.992l-.126.008h-6a1 1 0 0 1-.125-1.992L5.62 4.5h6z"
  })));
};

var _path$u;

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var SvgEmptyProjectList = function SvgEmptyProjectList(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$J({
    width: 22,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/React$d.createElement("path", {
    d: "M8 0a1 1 0 0 1 .832.445L10.535 3H19a3 3 0 0 1 2.995 2.824L22 6v11a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-.536 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-9a1 1 0 0 1-.832-.445L7.464 2zM11 8a1 1 0 0 1 .993.883L12 9v2h2a1 1 0 0 1 .117 1.993L14 13h-2v2a1 1 0 0 1-1.993.117L10 15v-2H8a1 1 0 0 1-.117-1.993L8 11h2V9a1 1 0 0 1 1-1z"
  })));
};

var _path$t;

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$I({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/React$d.createElement("path", {
    d: "M18 13v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2ZM7 7l1.41 1.41L11 5.83V14h2V5.83l2.59 2.58L17 7l-5-5-5 5Z"
  })));
};

var _path$s;

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$H({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React$d.createElement("path", {
    d: "M11 0a1.01 1.01 0 0 1 .246.03l.036.01c.031.01.061.02.091.032l.022.01a.92.92 0 0 1 .086.041l.029.017a.955.955 0 0 1 .197.153L11.615.21c.023.018.045.037.067.057l.025.025 6 6a1.002 1.002 0 0 1 .212.313l.007.017a.93.93 0 0 1 .036.103l.005.02c.011.042.02.085.025.129L18 7l-.001.016L18 19a3 3 0 0 1-2.824 2.995L15 22H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h8zm-1 1.999L3 2a1 1 0 0 0-.992.875L2 3v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.001-11H11a1 1 0 0 1-.992-.875L10 7V1.999zM9 10a1 1 0 0 1 .992.875L10 11v1.999L12 13a1 1 0 0 1 .125 1.992L12 15l-2-.001V17a1 1 0 0 1-1.992.125L8 17v-2.001L6 15a1 1 0 0 1-.125-1.992L6 13l2-.001V11a1 1 0 0 1 1-1zm3-6.586v2.585L14.585 6 12 3.414z"
  })));
};

var _path$r;

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var SvgFreetext = function SvgFreetext(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$G({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React$d.createElement("path", {
    d: "M9.945 2.11a.995.995 0 0 1 .116 1.982l-.116.007H2.984c-.51 0-.93.384-.988.878l-.007.116v13.923c0 .51.384.93.879.988l.116.007h13.923c.51 0 .93-.384.988-.879l.006-.116v-6.961a.995.995 0 0 1 1.983-.116l.006.116v6.961a2.984 2.984 0 0 1-2.808 2.979l-.175.005H2.984a2.984 2.984 0 0 1-2.979-2.808L0 19.016V5.093a2.984 2.984 0 0 1 2.808-2.978l.176-.005h6.961zm6.756-1.2a3.104 3.104 0 1 1 4.39 4.39l-9.448 9.447a.995.995 0 0 1-.462.262l-3.978.994a.995.995 0 0 1-1.206-1.206l.994-3.978a.995.995 0 0 1 .262-.462zm2.983 1.406a1.115 1.115 0 0 0-1.577 0l-9.253 9.252-.526 2.104 2.102-.526 9.254-9.253a1.115 1.115 0 0 0 .087-1.48z"
  })));
};

var _path$q;

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var SvgLanguageQuality = function SvgLanguageQuality(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$F({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React$d.createElement("path", {
    d: "M17 0a3 3 0 0 1 3 3v16l-.006.11a1 1 0 0 1-1.594.69L14.667 17H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h14zm0 2H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12l.129.008a1 1 0 0 1 .471.192L18 17V3a1 1 0 0 0-1-1zm-2.26 3.327a1 1 0 0 1 .02 1.323l-.087.09-5.5 5a1 1 0 0 1-1.246.08l-.1-.08-2.5-2.273A1 1 0 0 1 6.575 7.91l.098.078L8.5 9.65l4.827-4.389a1 1 0 0 1 1.413.067z"
  })));
};

var _path$p;

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var SvgMatrix = function SvgMatrix(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$E({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/React$d.createElement("path", {
    d: "M9 14h5V9H9v5zm5 7v-5H9v5h5zm7 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2zM7 21v-5H2v5h5zm9-12v5h5V9h-5zm-9 5V9H2v5h5zm9-7h5V2h-5v5zM7 7V2H2v5h5z"
  })));
};

var _path$o;

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var SvgMultipleChoice = function SvgMultipleChoice(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$D({
    width: 24,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/React$d.createElement("path", {
    d: "M7 12a3 3 0 0 1 2.995 2.824L10 15v4a3 3 0 0 1-2.824 2.995L7 22H3a3 3 0 0 1-2.995-2.824L0 19v-4a3 3 0 0 1 2.824-2.995L3 12h4zm16 6a1 1 0 1 1 0 2H13a1 1 0 1 1 0-2h10zM7 14H3a1 1 0 0 0-.993.883L2 15v4a1 1 0 0 0 .883.993L3 20h4a1 1 0 0 0 .993-.883L8 19v-4a1 1 0 0 0-1-1zm-1 1.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2zM23 14a1 1 0 1 1 0 2H13a1 1 0 1 1 0-2h10zM7 0a3 3 0 0 1 2.995 2.824L10 3v4a3 3 0 0 1-2.824 2.995L7 10H3A3 3 0 0 1 .005 7.176L0 7V3A3 3 0 0 1 2.824.005L3 0h4zm16 6a1 1 0 1 1 0 2H13a1 1 0 1 1 0-2h10zM7 2H3a1 1 0 0 0-.993.883L2 3v4a1 1 0 0 0 .883.993L3 8h4a1 1 0 0 0 .993-.883L8 7V3a1 1 0 0 0-1-1zM6 3.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h2zM23 2a1 1 0 1 1 0 2H13a1 1 0 1 1 0-2h10z",
    fillRule: "evenodd"
  })));
};

var _path$n;

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var SvgNoAudience = function SvgNoAudience(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$C({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/React$d.createElement("path", {
    d: "M12 12a5 5 0 0 1 4.995 4.783L17 17v2a1 1 0 0 1-1.993.117L15 19v-2a3 3 0 0 0-2.824-2.995L12 14H5a3 3 0 0 0-2.995 2.824L2 17v2a1 1 0 0 1-1.993.117L0 19v-2a5 5 0 0 1 4.783-4.995L5 12h7zm6.499-5.906.087.078L20 7.586l1.414-1.414a1 1 0 0 1 1.492 1.327l-.078.087L21.414 9l1.414 1.414a1 1 0 0 1-1.327 1.492l-.087-.078L20 10.414l-1.414 1.414a1 1 0 0 1-1.492-1.327l.078-.087L18.586 9l-1.414-1.414a1 1 0 0 1 1.327-1.492zM8.5 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  })));
};

var _path$m;

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var SvgPenAndPaper = function SvgPenAndPaper(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$B({
    width: 26,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/React$d.createElement("path", {
    d: "M15 0a3 3 0 0 1 2.994 2.803L18 3v2.5a1 1 0 0 1-1.992.125L16 5.5V3a1 1 0 0 0-.875-.992L15 2H3a1 1 0 0 0-.992.875L2 3v16a1 1 0 0 0 .875.992L3 20h12a1 1 0 0 0 .992-.875l.016-.25A1 1 0 0 1 18 19a3 3 0 0 1-2.803 2.994L15 22H3a3 3 0 0 1-2.994-2.803L0 19V3A3 3 0 0 1 2.803.006L3 0h12zM5 18a1 1 0 0 1-.125-1.992L5 16h7.236l.707-2.592a1 1 0 0 1 .172-.346l.086-.098 8.17-8.17a2.712 2.712 0 0 1 3.835 3.835l-8.17 8.17a1 1 0 0 1-.444.258l-3.329.908a1.064 1.064 0 0 1-.009.002.867.867 0 0 1-.113.023l-.016.002-.025.004a.998.998 0 0 1-.058.004H5zM23.472 6.024a.712.712 0 0 0-.687.185l-7.982 7.981-.377 1.384 1.383-.378 7.982-7.981a.712.712 0 0 0 .205-.581l-.02-.106a.712.712 0 0 0-.504-.504zM11 12a1 1 0 0 1 .125 1.992L11 14H5a1 1 0 0 1-.125-1.992L5 12h6zm2-4a1 1 0 0 1 .125 1.992L13 10H5a1 1 0 0 1-.125-1.992L5 8h8zm-2-4a1 1 0 0 1 .125 1.992L11 6H5a1 1 0 0 1-.125-1.992L5 4h6z"
  })));
};

var _path$l;

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var SvgPersonPlus = function SvgPersonPlus(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$A({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React$d.createElement("path", {
    d: "M12 12a5 5 0 0 1 4.995 4.783L17 17v2a1 1 0 0 1-1.993.117L15 19v-2a3 3 0 0 0-2.824-2.995L12 14H5a3 3 0 0 0-2.995 2.824L2 17v2a1 1 0 0 1-1.993.117L0 19v-2a5 5 0 0 1 4.783-4.995L5 12h7Zm8-7a1 1 0 0 1 .993.883L21 6v2h2a1 1 0 0 1 .117 1.993L23 10h-2v2a1 1 0 0 1-1.993.117L19 12v-2h-2a1 1 0 0 1-.117-1.993L17 8h2V6a1 1 0 0 1 1-1ZM8.5 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
    fill: "#72758D",
    fillRule: "nonzero"
  })));
};

var _path$k;

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var SvgQuestionSpeed = function SvgQuestionSpeed(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$z({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React$d.createElement("path", {
    d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 2a1 1 0 0 1 .993.883L12 5v5.382l3.447 1.724a1 1 0 0 1 .494 1.234l-.047.107a1 1 0 0 1-1.234.494l-.107-.047-4-2a1 1 0 0 1-.545-.77L10 11V5a1 1 0 0 1 1-1z"
  })));
};

var _path$j;

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var SvgRanked = function SvgRanked(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$y({
    width: 26,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React$d.createElement("path", {
    d: "M18 8v9h8v8H0V13h8V8h10zM8 15H2v8h6v-8zm8-5h-6v13h6V10zm8 9h-6v4h6v-4zM13 0l.843 2.09L16 2.287 14.365 3.78 14.854 6 13 4.822 11.146 6l.492-2.22L10 2.286l2.157-.192L13 0z"
  })));
};

var _path$i;

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var SvgResponses = function SvgResponses(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$x({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React$d.createElement("path", {
    d: "M15 0a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9.01 15a1 1 0 0 1 .117 1.993L9 17a1 1 0 0 1-.117-1.993L9.01 15zm.586-9.947A4 4 0 0 1 12.92 9c0 1.28-.758 2.29-1.945 3.082a7.575 7.575 0 0 1-1.739.867 1 1 0 0 1-.74-1.854l.294-.114.193-.082c.303-.135.605-.296.882-.481.688-.459 1.055-.948 1.055-1.42a2 2 0 0 0-3.827-.816l-.06.15a1 1 0 1 1-1.886-.664 4 4 0 0 1 4.45-2.615z"
  })));
};

var _path$h;

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$w({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React$d.createElement("path", {
    d: "M11.5 0a.5.5 0 0 1 .492.41L12 .5v4.25a3.5 3.5 0 0 1-3.308 3.495L8.5 8.25H1.706l2.898 2.896a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057-3.75-3.75-.011-.013a.504.504 0 0 1-.033-.039l.044.052A.502.502 0 0 1 0 7.75v-.01c0-.022.002-.043.005-.064L0 7.75a.502.502 0 0 1 .089-.284l.013-.018a.504.504 0 0 1 .033-.04l.011-.012 3.75-3.75a.5.5 0 0 1 .765.638l-.057.07L1.706 7.25H8.5a2.5 2.5 0 0 0 2.495-2.336L11 4.75V.5a.5.5 0 0 1 .5-.5z"
  })));
};

var _path$g;

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var SvgRobot = function SvgRobot(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$v({
    width: 22,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React$d.createElement("path", {
    d: "M11 0a3 3 0 0 1 1 5.829V8h9a1 1 0 0 1 .993.883L22 9v15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h9V5.83A3.001 3.001 0 0 1 11 0zm9 10H2v13h18V10zm-6 9a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h6zm-6-7a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zm6 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1zM11 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  })));
};

var _path$f;

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$u({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React$d.createElement("path", {
    d: "M11 18c1.306 0 2.418.835 2.83 2H23a1 1 0 0 1 0 2h-9.171a3.001 3.001 0 0 1-5.658 0H1a1 1 0 0 1 0-2h7.17A3.001 3.001 0 0 1 11 18zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8-11c1.306 0 2.418.835 2.83 2H23a1 1 0 0 1 0 2h-1.171a3.001 3.001 0 0 1-5.658 0H1a1 1 0 0 1 0-2h15.17A3.001 3.001 0 0 1 19 9zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6 0c1.306 0 2.418.835 2.83 2H23a1 1 0 0 1 0 2H8.829a3.001 3.001 0 0 1-5.658 0H1a1 1 0 0 1 0-2h2.17A3.001 3.001 0 0 1 6 0zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    fillRule: "evenodd"
  })));
};

var _path$e;

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var SvgSearch2 = function SvgSearch2(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$t({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React$d.createElement("path", {
    d: "M8.111.111a8 8 0 0 1 6.251 12.993l3.267 3.267a.889.889 0 0 1-1.167 1.337l-.09-.08-3.268-3.266A8 8 0 1 1 8.11.111Zm0 1.778a6.222 6.222 0 1 0 4.317 10.703.883.883 0 0 1 .077-.087l.087-.077a6.222 6.222 0 0 0-4.48-10.54Z",
    fill: "#376273",
    fillRule: "nonzero"
  })));
};

var _path$d;

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var SvgSignupSuccess = function SvgSignupSuccess(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$s({
    width: 31,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React$d.createElement("path", {
    d: "M15.667 16c3.42 0 6.207 2.71 6.329 6.101l.004.232V25a1 1 0 0 1-1.993.117L20 25v-2.667a4.333 4.333 0 0 0-4.123-4.328l-.21-.005H6.333a4.333 4.333 0 0 0-4.328 4.123l-.005.21V25a1 1 0 0 1-1.993.117L0 25v-2.667c0-3.42 2.71-6.207 6.101-6.329L6.333 16h9.334zm15.04-7.707a1 1 0 0 1 .083 1.32l-.083.094-5.333 5.333a1 1 0 0 1-1.32.084l-.094-.084-2.667-2.666a1 1 0 0 1 1.32-1.498l.094.084 1.959 1.959 4.627-4.626a1 1 0 0 1 1.414 0zM11.333 0a6.333 6.333 0 1 1 0 12.667 6.333 6.333 0 0 1 0-12.667zm0 2a4.333 4.333 0 1 0 0 8.667 4.333 4.333 0 0 0 0-8.667z",
    fill: "#06AC06"
  })));
};
var img$25 = "data:image/svg+xml,%3csvg width='31' height='26' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M15.667 16c3.42 0 6.207 2.71 6.329 6.101l.004.232V25a1 1 0 01-1.993.117L20 25v-2.667a4.333 4.333 0 00-4.123-4.328l-.21-.005H6.333a4.333 4.333 0 00-4.328 4.123l-.005.21V25a1 1 0 01-1.993.117L0 25v-2.667c0-3.42 2.71-6.207 6.101-6.329L6.333 16h9.334zm15.04-7.707a1 1 0 01.083 1.32l-.083.094-5.333 5.333a1 1 0 01-1.32.084l-.094-.084-2.667-2.666a1 1 0 011.32-1.498l.094.084 1.959 1.959 4.627-4.626a1 1 0 011.414 0zM11.333 0a6.333 6.333 0 110 12.667 6.333 6.333 0 010-12.667zm0 2a4.333 4.333 0 100 8.667 4.333 4.333 0 000-8.667z' fill='%2306AC06' fill-rule='nonzero'/%3e%3c/svg%3e";

var _path$c;

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var SvgSingleChoice = function SvgSingleChoice(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$r({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React$d.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm5.305 5.281 1.39 1.438-8.964 8.675-4.429-4.313 1.396-1.433 3.037 2.958 7.57-7.325z"
  })));
};

var _path$b;

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var SvgStraightLiners = function SvgStraightLiners(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$q({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React$d.createElement("path", {
    d: "M15 0a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9.037 5l.018.001a.996.996 0 0 1 .057.005.935.935 0 0 1 .053.007 1.05 1.05 0 0 1 .062.013 1 1 0 0 1 .144.046l-.093-.033a1.005 1.005 0 0 1 .052.017l.041.016a1.02 1.02 0 0 1 .01.004 1.01 1.01 0 0 1 .072.033.88.88 0 0 1 .16.101.927.927 0 0 1 .05.04l.086.087a.992.992 0 0 1 .04.05 1.187 1.187 0 0 1 .09.136l.012.024a1.006 1.006 0 0 1 .033.07l.004.012 4 10a1 1 0 0 1-1.807.848l-.05-.106-.95-2.378a1.004 1.004 0 0 1-.004 0L11 14H7a1.01 1.01 0 0 1-.12-.007l-.952 2.378-.05.106a1 1 0 0 1-1.806-.848l4-10 .004-.011a1.006 1.006 0 0 1 .033-.071l.012-.024a1.003 1.003 0 0 1 .003-.005 1.043 1.043 0 0 1 .127-.18l.086-.087a.992.992 0 0 1 .05-.04 1.187 1.187 0 0 1 .16-.103 1.03 1.03 0 0 1 .07-.032 1.02 1.02 0 0 1 .012-.004l.04-.016a1.005 1.005 0 0 1 .053-.017l-.093.033c.047-.02.096-.035.144-.046a1.04 1.04 0 0 1 .063-.013.93.93 0 0 1 .11-.012A.963.963 0 0 1 9 5h.036zM9 8.692 7.677 12h2.646L9 8.692z"
  })));
};

var _path$a;

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var SvgSurveySpeed = function SvgSurveySpeed(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$p({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React$d.createElement("path", {
    d: "m7 0-.176.005A3 3 0 0 0 4 3v.035l.007.116A1 1 0 0 0 6 3.035l.007-.152A1 1 0 0 1 7 2h12l.117.007A1 1 0 0 1 20 3v16l-.007.117A1 1 0 0 1 19 20H7l-.117-.007A1 1 0 0 1 6 19l-.007-.116A1 1 0 0 0 4 19l.005.176A3 3 0 0 0 7 22h12l.176-.005A3 3 0 0 0 22 19V3l-.005-.176A3 3 0 0 0 19 0H7zM5 14a1 1 0 0 0-.117 1.993L5 16h11a1 1 0 0 0 .117-1.993L16 14H5zm-4-4a1 1 0 0 0-.117 1.993L1 12h15a1 1 0 0 0 .117-1.993L16 10H1zm4-4a1 1 0 0 0-.117 1.993L5 8h11a1 1 0 0 0 .117-1.993L16 6H5z"
  })));
};

var _path$9;

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var SvgTextInstruction = function SvgTextInstruction(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$o({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React$d.createElement("path", {
    d: "M17 0a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-3.625 12a1 1 0 0 1 .117 1.993l-.117.007h-6.75a1 1 0 0 1-.117-1.993L6.625 14h6.75zm0-4a1 1 0 0 1 .117 1.993l-.117.007h-6.75a1 1 0 0 1-.117-1.993L6.625 10h6.75zM14.5 6a1 1 0 0 1 .117 1.993L14.5 8h-9a1 1 0 0 1-.117-1.993L5.5 6h9z"
  })));
};

var _g$1;

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var SvgTickCheck = function SvgTickCheck(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$n({
    width: 20,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React$d.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$d.createElement("path", {
    fill: "#89A2AC",
    d: "M2.828 5.828 9.9 12.9l-2.828 2.829L0 8.657z"
  }), /*#__PURE__*/React$d.createElement("path", {
    fill: "#5B7D8B",
    d: "m17.142 0 2.829 2.828L9.364 13.435l-2.828-2.828z"
  }), /*#__PURE__*/React$d.createElement("path", {
    fill: "#14465A",
    d: "M7.071 10.071 9.9 12.9l-2.828 2.829-2.828-2.829z"
  }))));
};

var _g;

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var SvgThickCancel = function SvgThickCancel(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$m({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React$d.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React$d.createElement("path", {
    fill: "#89A2AC",
    d: "M0 6.095 6.095 0 32 25.905 25.905 32z"
  }), /*#__PURE__*/React$d.createElement("path", {
    fill: "#5B7D8B",
    d: "M6.095 32 0 25.905 25.905 0 32 6.095z"
  }), /*#__PURE__*/React$d.createElement("path", {
    fill: "#14465A",
    d: "M9.905 16 16 9.905 22.095 16 16 22.095z"
  }))));
};

var _path$8;

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var SvgFork = function SvgFork(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$l({
    width: 18,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React$d.createElement("path", {
    d: "M4 0a4 4 0 0 1 1 7.874v7.009c.846-.684 1.977-1.207 3.424-1.682l1.15-.368c2.297-.767 3.173-1.42 3.377-2.973a4 4 0 1 1 2.012.023c-.225 2.505-1.49 3.667-4.255 4.67l-.514.18-.27.089-.623.197c-3.172 1.003-4.243 1.932-4.299 4.742L5 20v1a1 1 0 0 1-1.993.117L3 21V7.874A4.002 4.002 0 0 1 4 0zm10 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM4 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
    fill: "#72758D"
  })));
};

var _path$7;

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var SvgPreview = function SvgPreview(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$k({
    width: 21,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React$d.createElement("path", {
    d: "M10.5 0c2.957 0 5.546 1.451 7.748 3.836a18.18 18.18 0 0 1 1.97 2.57l.208.336.254.433.13.237.098.19a.902.902 0 0 1 0 .796 5.997 5.997 0 0 1-.045.089l-.114.214-.146.258-.177.299-.209.335a18.18 18.18 0 0 1-1.97 2.57C16.048 14.55 13.458 16 10.5 16s-5.546-1.451-7.748-3.836a18.18 18.18 0 0 1-1.97-2.57l-.208-.336-.254-.433-.13-.237-.098-.19a.902.902 0 0 1 0-.796l.045-.089.114-.214.146-.258.177-.299.209-.335a18.18 18.18 0 0 1 1.97-2.57C4.952 1.45 7.542 0 10.5 0zm0 1.778c-2.402 0-4.57 1.215-6.471 3.274A16.425 16.425 0 0 0 2.008 7.77L1.873 8l.135.231.118.195.127.203a16.425 16.425 0 0 0 1.776 2.319c1.9 2.059 4.069 3.274 6.471 3.274s4.57-1.215 6.471-3.274a16.425 16.425 0 0 0 2.021-2.717L19.126 8l-.134-.231-.118-.195-.127-.203a16.425 16.425 0 0 0-1.776-2.319c-1.9-2.059-4.069-3.274-6.471-3.274zm0 2.666C12.433 4.444 14 6.036 14 8s-1.567 3.556-3.5 3.556S7 9.964 7 8s1.567-3.556 3.5-3.556zm0 1.778c-.966 0-1.75.796-1.75 1.778s.784 1.778 1.75 1.778S12.25 8.982 12.25 8s-.784-1.778-1.75-1.778z"
  })));
};

var _path$6;

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var SvgSummary = function SvgSummary(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$j({
    width: 18,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React$d.createElement("path", {
    d: "M17 12a1 1 0 0 1 .117 1.993L17 14H6a1 1 0 0 1-.117-1.993L6 12h11zM1.01 12a1 1 0 0 1 .117 1.993L1.01 14a1 1 0 0 1-.127-1.993L1.01 12zM17 6a1 1 0 0 1 .117 1.993L17 8H6a1 1 0 0 1-.117-1.993L6 6h11zM1.01 6a1 1 0 0 1 .117 1.993L1.01 8a1 1 0 0 1-.127-1.993L1.01 6zM17 0a1 1 0 0 1 .117 1.993L17 2H6A1 1 0 0 1 5.883.007L6 0h11zM1.01 0a1 1 0 0 1 .117 1.993L1.01 2A1 1 0 0 1 .883.007L1.01 0z"
  })));
};

var _path$5, _path2$1;

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var SvgPushPin = function SvgPushPin(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React$d.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React$d.createElement("path", {
    d: "M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4h4m3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1z"
  })));
};

var _path$4, _path2;

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var SvgPushPinFilled = function SvgPushPinFilled(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React$d.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React$d.createElement("path", {
    d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z",
    fillRule: "evenodd"
  })));
};

var _path$3;

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var SvgAddQuestionEmptyState = function SvgAddQuestionEmptyState(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$g({
    width: 24,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React$d.createElement("path", {
    d: "M15 0a3 3 0 0 1 2.995 2.824L18 3v2a1 1 0 0 1-1.993.117L16 5V3a1 1 0 0 0-.883-.993L15 2H3a1 1 0 0 0-.993.883L2 3v16a1 1 0 0 0 .883.993L3 20h12a1 1 0 0 0 .993-.883L16 19v-6a1 1 0 0 1 1.993-.117L18 13v6a3 3 0 0 1-2.824 2.995L15 22H3a3 3 0 0 1-2.995-2.824L0 19V3A3 3 0 0 1 2.824.005L3 0h12Zm-3 14a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2h6Zm8-9a1 1 0 0 1 .993.883L21 6v2h2a1 1 0 0 1 .117 1.993L23 10h-2v2a1 1 0 0 1-1.993.117L19 12v-2h-2a1 1 0 0 1-.117-1.993L17 8h2V6a1 1 0 0 1 1-1Zm-7 5a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h8Zm-1-4a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h6Z",
    fill: "#72758D"
  })));
};

var _path$2;

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var SvgNumber = function SvgNumber(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$f({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React$d.createElement("path", {
    d: "M8.5 0a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 1.545a6.955 6.955 0 1 0 0 13.91 6.955 6.955 0 0 0 0-13.91Zm.936 4.036c.16.13.261.316.282.52v4.636a.773.773 0 0 1-.332.688.773.773 0 0 1-1.26-.587V8.14l.031-.108a3.547 3.547 0 0 1-.347.108.773.773 0 0 1-.773-.417.773.773 0 0 1 .131-.881c.371-.371.773-.773 1.12-1.113.154-.166.358-.278.58-.317a.773.773 0 0 1 .568.168Z",
    fill: "#376273"
  })));
};

var _path$1;

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var SvgSection = function SvgSection(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$e({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React$d.createElement("path", {
    d: "M15.923 11.311a.727.727 0 0 1-.252.934l-.073.042-7.273 3.636a.727.727 0 0 1-.56.038l-.09-.038-7.273-3.636a.727.727 0 0 1 .572-1.335l.078.034L8 14.459l6.947-3.473a.727.727 0 0 1 .976.325Zm0-3.636a.727.727 0 0 1-.252.933l-.073.042-7.273 3.637a.727.727 0 0 1-.56.037l-.09-.037L.402 8.65a.727.727 0 0 1 .572-1.334l.078.034L8 10.823l6.947-3.473a.727.727 0 0 1 .976.325ZM7.675.077a.727.727 0 0 1 .65 0l7.273 3.636a.727.727 0 0 1 0 1.301L8.325 8.65a.727.727 0 0 1-.65 0L.402 5.014a.727.727 0 0 1 0-1.3ZM8 1.54 2.353 4.364 8 7.186l5.645-2.822L8 1.54Z",
    fill: "#376273"
  })));
};

var _path;

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var SvgImportQuestions = function SvgImportQuestions(props) {
  return /*#__PURE__*/React$d.createElement("svg", _extends$d({
    width: 16,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React$d.createElement("path", {
    d: "M16 16.727a2.182 2.182 0 0 1-2.054 2.178l-.128.004H5.091a2.182 2.182 0 0 1-2.178-2.054l-.004-.128L2.91 16h-.728a2.182 2.182 0 0 1-2.178-2.054L0 13.818V2.182C0 1.02.908.07 2.054.004L2.182 0h8.727c1.162 0 2.112.908 2.178 2.054l.004.128v.727h.727c1.162 0 2.112.908 2.178 2.054L16 5.09v11.636Zm-1.455 0V5.091c0-.373-.28-.68-.642-.722l-.085-.005H5.091c-.373 0-.68.28-.722.642l-.005.085v1.454a.727.727 0 0 1-1.45.085l-.005-.085V5.091c0-1.162.908-2.112 2.054-2.178l.128-.004h6.546v-.727c0-.373-.281-.68-.643-.723l-.085-.004H2.182c-.373 0-.68.28-.723.642l-.004.085v11.636c0 .373.28.68.642.723l.085.004h.728v-.727a.727.727 0 0 1 1.449-.085l.005.085v2.91c0 .372.28.68.642.722l.085.005h8.727c.373 0 .68-.281.723-.643l.004-.085Zm-3.636-6.545v.014a.732.732 0 0 1 0 .002v-.016a.732.732 0 0 1-.169.466l-.044.048-2.909 2.91a.727.727 0 0 1-1.089-.96l.06-.07 1.667-1.667H4.364a.727.727 0 0 1-.085-1.45l.085-.004 4.062-.001-1.668-1.667a.727.727 0 0 1-.06-.96l.06-.069a.727.727 0 0 1 .96-.06l.069.06 2.91 2.91.06.07a.73.73 0 0 1 .01.013l-.07-.083a.73.73 0 0 1 .212.514Z",
    fill: "#376273"
  })));
};

var IconColor$1;
(function (IconColor) {
    IconColor[IconColor["Primary"] = 0] = "Primary";
    IconColor[IconColor["Text"] = 1] = "Text";
    IconColor[IconColor["Background"] = 2] = "Background";
    IconColor[IconColor["Emphasis"] = 3] = "Emphasis";
    IconColor[IconColor["Disabled"] = 4] = "Disabled";
    IconColor[IconColor["Enabled"] = 5] = "Enabled";
    IconColor[IconColor["Error"] = 6] = "Error";
    IconColor[IconColor["Warning"] = 7] = "Warning";
    IconColor[IconColor["White"] = 8] = "White";
    IconColor[IconColor["Green"] = 9] = "Green";
})(IconColor$1 || (IconColor$1 = {}));
var BadgeColor;
(function (BadgeColor) {
    BadgeColor[BadgeColor["Primary"] = 0] = "Primary";
    BadgeColor[BadgeColor["Text"] = 1] = "Text";
    BadgeColor[BadgeColor["Background"] = 2] = "Background";
    BadgeColor[BadgeColor["Emphasis"] = 3] = "Emphasis";
    BadgeColor[BadgeColor["Disabled"] = 4] = "Disabled";
    BadgeColor[BadgeColor["Enabled"] = 5] = "Enabled";
    BadgeColor[BadgeColor["Error"] = 6] = "Error";
    BadgeColor[BadgeColor["Warning"] = 7] = "Warning";
    BadgeColor[BadgeColor["White"] = 8] = "White";
})(BadgeColor || (BadgeColor = {}));
var IconSize$1;
(function (IconSize) {
    IconSize[IconSize["Small"] = 0] = "Small";
    IconSize[IconSize["Medium"] = 1] = "Medium";
    IconSize[IconSize["Large"] = 2] = "Large";
    IconSize[IconSize["xLarge"] = 3] = "xLarge";
})(IconSize$1 || (IconSize$1 = {}));
var IconName;
(function (IconName) {
    IconName[IconName["Add"] = 0] = "Add";
    IconName[IconName["Arrow"] = 1] = "Arrow";
    IconName[IconName["ArrowForwardRounded"] = 2] = "ArrowForwardRounded";
    IconName[IconName["Attention"] = 3] = "Attention";
    IconName[IconName["BarChart"] = 4] = "BarChart";
    IconName[IconName["Check"] = 5] = "Check";
    IconName[IconName["CheckCircle"] = 6] = "CheckCircle";
    IconName[IconName["ChevronLeft"] = 7] = "ChevronLeft";
    IconName[IconName["ChevronRight"] = 8] = "ChevronRight";
    IconName[IconName["ChevronDoubleLeft"] = 9] = "ChevronDoubleLeft";
    IconName[IconName["ChevronDoubleRight"] = 10] = "ChevronDoubleRight";
    IconName[IconName["CloudUploadOutlined"] = 11] = "CloudUploadOutlined";
    IconName[IconName["Consistency"] = 12] = "Consistency";
    IconName[IconName["DeleteOutline"] = 13] = "DeleteOutline";
    IconName[IconName["DragIndicator"] = 14] = "DragIndicator";
    IconName[IconName["Duplicate"] = 15] = "Duplicate";
    IconName[IconName["DuplicateWrite"] = 16] = "DuplicateWrite";
    IconName[IconName["EmptyProjectList"] = 17] = "EmptyProjectList";
    IconName[IconName["ErrorOutlineIcon"] = 18] = "ErrorOutlineIcon";
    IconName[IconName["Export"] = 19] = "Export";
    IconName[IconName["FiberManualRecord"] = 20] = "FiberManualRecord";
    IconName[IconName["FileCopyOutlined"] = 21] = "FileCopyOutlined";
    IconName[IconName["Filter"] = 22] = "Filter";
    IconName[IconName["Filter1Outlined"] = 23] = "Filter1Outlined";
    IconName[IconName["FilterOutline"] = 24] = "FilterOutline";
    IconName[IconName["FlagOutlined"] = 25] = "FlagOutlined";
    IconName[IconName["Folder"] = 26] = "Folder";
    IconName[IconName["FormatLineSpacingIcon"] = 27] = "FormatLineSpacingIcon";
    IconName[IconName["Freetext"] = 28] = "Freetext";
    IconName[IconName["GetAppOutlinedIcon"] = 29] = "GetAppOutlinedIcon";
    IconName[IconName["Image"] = 30] = "Image";
    IconName[IconName["ImageOutlined"] = 31] = "ImageOutlined";
    IconName[IconName["InfoOutlinedIcon"] = 32] = "InfoOutlinedIcon";
    IconName[IconName["KeyboardArrowDown"] = 33] = "KeyboardArrowDown";
    IconName[IconName["LanguageQuality"] = 34] = "LanguageQuality";
    IconName[IconName["LockOutlined"] = 35] = "LockOutlined";
    IconName[IconName["MailOutlined"] = 36] = "MailOutlined";
    IconName[IconName["Matrix"] = 37] = "Matrix";
    IconName[IconName["MoreVert"] = 38] = "MoreVert";
    IconName[IconName["MoreHoriz"] = 39] = "MoreHoriz";
    IconName[IconName["MultipleChoice"] = 40] = "MultipleChoice";
    IconName[IconName["NoAudience"] = 41] = "NoAudience";
    IconName[IconName["PauseCircleOutline"] = 42] = "PauseCircleOutline";
    IconName[IconName["PenAndPaper"] = 43] = "PenAndPaper";
    IconName[IconName["PersonPlus"] = 44] = "PersonPlus";
    IconName[IconName["PlayCircleOutline"] = 45] = "PlayCircleOutline";
    IconName[IconName["QuestionSpeed"] = 46] = "QuestionSpeed";
    IconName[IconName["Ranked"] = 47] = "Ranked";
    IconName[IconName["Refresh"] = 48] = "Refresh";
    IconName[IconName["Responses"] = 49] = "Responses";
    IconName[IconName["Return"] = 50] = "Return";
    IconName[IconName["Robot"] = 51] = "Robot";
    IconName[IconName["RouteOutlined"] = 52] = "RouteOutlined";
    IconName[IconName["Scale"] = 53] = "Scale";
    IconName[IconName["Search"] = 54] = "Search";
    IconName[IconName["Search2"] = 55] = "Search2";
    IconName[IconName["SignupSuccess"] = 56] = "SignupSuccess";
    IconName[IconName["SingleChoice"] = 57] = "SingleChoice";
    IconName[IconName["StraightLiners"] = 58] = "StraightLiners";
    IconName[IconName["SurveySpeed"] = 59] = "SurveySpeed";
    IconName[IconName["TextFields"] = 60] = "TextFields";
    IconName[IconName["TextInstruction"] = 61] = "TextInstruction";
    IconName[IconName["TickCheck"] = 62] = "TickCheck";
    IconName[IconName["TimelineOutlined"] = 63] = "TimelineOutlined";
    IconName[IconName["ResponseOptionChecked"] = 64] = "ResponseOptionChecked";
    IconName[IconName["ThickCancel"] = 65] = "ThickCancel";
    IconName[IconName["Visibility"] = 66] = "Visibility";
    IconName[IconName["Fork"] = 67] = "Fork";
    IconName[IconName["Preview"] = 68] = "Preview";
    IconName[IconName["Summary"] = 69] = "Summary";
    IconName[IconName["PushPin"] = 70] = "PushPin";
    IconName[IconName["PushPinFilled"] = 71] = "PushPinFilled";
    IconName[IconName["AddQuestionEmptyState"] = 72] = "AddQuestionEmptyState";
    IconName[IconName["Number"] = 73] = "Number";
    IconName[IconName["Section"] = 74] = "Section";
    IconName[IconName["ImportQuestions"] = 75] = "ImportQuestions";
})(IconName || (IconName = {}));
var iconComponentMap = new Map([
    [IconName.Attention, SvgAttention],
    [IconName.BarChart, BarChart$1],
    [IconName.Consistency, SvgConsistency],
    [IconName.Freetext, SvgFreetext],
    [IconName.LanguageQuality, SvgLanguageQuality],
    [IconName.Matrix, SvgMatrix],
    [IconName.MultipleChoice, SvgMultipleChoice],
    [IconName.QuestionSpeed, SvgQuestionSpeed],
    [IconName.Ranked, SvgRanked],
    [IconName.Responses, SvgResponses],
    [IconName.Return, SvgReturn],
    [IconName.Robot, SvgRobot],
    [IconName.RouteOutlined, RouteOutlined],
    [IconName.Scale, SvgScale],
    [IconName.SingleChoice, SvgSingleChoice],
    [IconName.SignupSuccess, SvgSignupSuccess],
    [IconName.StraightLiners, SvgStraightLiners],
    [IconName.SurveySpeed, SvgSurveySpeed],
    [IconName.TextFields, TextFields],
    [IconName.TextInstruction, SvgTextInstruction],
    [IconName.DeleteOutline, DeleteOutline],
    [IconName.Add, Add$1],
    [IconName.FormatLineSpacingIcon, FormatLineSpacing],
    [IconName.Search, Search$1],
    [IconName.GetAppOutlinedIcon, GetAppOutlined],
    [IconName.DragIndicator, DragIndicator],
    [IconName.MoreVert, MoreVert],
    [IconName.MoreHoriz, MoreHoriz],
    [IconName.Check, Check],
    [IconName.CheckCircle, CheckCircle],
    [IconName.LockOutlined, LockOutlined],
    [IconName.MailOutlined, MailOutlined],
    [IconName.EmptyProjectList, SvgEmptyProjectList],
    [IconName.FileCopyOutlined, FileCopyOutlined],
    [IconName.NoAudience, SvgNoAudience],
    [IconName.InfoOutlinedIcon, InfoOutlined],
    [IconName.TimelineOutlined, TimelineOutlined],
    [IconName.TickCheck, SvgTickCheck],
    [IconName.Duplicate, SvgDuplicate],
    [IconName.ArrowForwardRounded, ArrowForwardRounded],
    [IconName.DuplicateWrite, SvgDuplicateWrite],
    [IconName.Arrow, SvgArrow],
    [IconName.PenAndPaper, SvgPenAndPaper],
    [IconName.Folder, SvgFolder],
    [IconName.PauseCircleOutline, PauseCircleOutline],
    [IconName.PlayCircleOutline, PlayCircleOutline$2],
    [IconName.ErrorOutlineIcon, ErrorOutline],
    [IconName.FiberManualRecord, FiberManualRecord],
    [IconName.ChevronLeft, ChevronLeft],
    [IconName.ChevronRight, ChevronRight],
    [IconName.ChevronDoubleLeft, ChevronDoubleLeft],
    [IconName.ChevronDoubleRight, ChevronDoubleRight],
    [IconName.KeyboardArrowDown, KeyboardArrowDown],
    [IconName.FlagOutlined, FlagOutlined],
    [IconName.Filter, Filter],
    [IconName.Filter1Outlined, Filter1Outlined],
    [IconName.FilterOutline, FilterOutline],
    [IconName.PersonPlus, SvgPersonPlus],
    [IconName.Image, Image],
    [IconName.ImageOutlined, ImageOutlined],
    [IconName.CloudUploadOutlined, CloudUploadOutlined],
    [IconName.ResponseOptionChecked, Check],
    [IconName.ThickCancel, SvgThickCancel],
    [IconName.Refresh, Refresh],
    [IconName.Visibility, Visibility],
    [IconName.Fork, SvgFork],
    [IconName.Search2, SvgSearch2],
    [IconName.Preview, SvgPreview],
    [IconName.Summary, SvgSummary],
    [IconName.Export, SvgExport],
    [IconName.PushPin, SvgPushPin],
    [IconName.PushPinFilled, SvgPushPinFilled],
    [IconName.AddQuestionEmptyState, SvgAddQuestionEmptyState],
    [IconName.Number, SvgNumber],
    [IconName.Section, SvgSection],
    [IconName.ImportQuestions, SvgImportQuestions]
]);
var Icon = function (props) {
    var _a, _b;
    var className = props.className, name = props.name, _c = props.size, size = _c === void 0 ? IconSize$1.Small : _c, _d = props.iconColor, iconColor = _d === void 0 ? IconColor$1.Text : _d, _e = props.badgeVerticalAnchor, badgeVerticalAnchor = _e === void 0 ? 'top' : _e, _f = props.badgeContent, badgeContent = _f === void 0 ? undefined : _f, _g = props.badgeColor, badgeColor = _g === void 0 ? BadgeColor.Text : _g;
    var _h = useStyles$O(), classes = _h.classes, classNames = _h.cx, theme = _h.theme;
    var fontColorClass = new Map([
        [IconColor$1.Primary, classes.primaryColor],
        [IconColor$1.Text, classes.textColor],
        [IconColor$1.Background, classes.backgroundColor],
        [IconColor$1.Emphasis, classes.emphasisColor],
        [IconColor$1.Disabled, classes.disabledColor],
        [IconColor$1.Enabled, classes.enabledColor],
        [IconColor$1.Error, classes.error],
        [IconColor$1.Warning, classes.warning],
        [IconColor$1.White, classes.white],
        [IconColor$1.Green, classes.green]
    ]);
    var badgeColorClass = new Map([
        [BadgeColor.Primary, classes.badgePrimaryColor],
        [BadgeColor.Text, classes.badgeTextColor],
        [BadgeColor.Background, classes.badgeBackgroundColor],
        [BadgeColor.Emphasis, classes.badgeEmphasisColor],
        [BadgeColor.Disabled, classes.badgeDisabledColor],
        [BadgeColor.Enabled, classes.badgeEnabledColor],
        [BadgeColor.Error, classes.badgeError],
        [BadgeColor.Warning, classes.badgeWarning],
        [BadgeColor.White, classes.badgeWhite]
    ]);
    var fontSizeClass = new Map([
        [IconSize$1.Small, classes.smallFont],
        [IconSize$1.Medium, classes.mediumFont],
        [IconSize$1.Large, classes.largeFont],
        [IconSize$1.xLarge, classes.xlargeFont]
    ]);
    var nameToViewBox = new Map([
        [IconName.Arrow, '-5 -5 24 24'],
        [IconName.Duplicate, '-4 -4 24 24'],
        [IconName.Folder, '-3 0 24 24'],
        [IconName.Ranked, '0 0 25 26'],
        [IconName.ResponseOptionChecked, '3 3 32 32'],
        [IconName.Preview, '-2 -5 24 24']
    ]);
    var fontSizeCssClass = fontSizeClass.get(size);
    var component = iconComponentMap.get(name);
    var colorCssClass = fontColorClass.get(iconColor);
    var colorBadgeCssClass = badgeColorClass.get(badgeColor);
    var customViewBox = nameToViewBox.get(name);
    var hasWhiteBorder = badgeColor.valueOf() === iconColor.valueOf();
    if (!component) {
        throw new Error("Name ".concat(name, " not defined as a focaldata icon name. Please add it following the pattern of IconName.Attention"));
    }
    return (jsx$1(Badge$2, __assign$3({ badgeContent: badgeContent, classes: {
            badge: classNames(colorBadgeCssClass, (_a = {},
                _a[classes.whiteBorder] = hasWhiteBorder,
                _a[classes.rtl] = theme.direction === 'rtl',
                _a))
        }, className: classNames((_b = {}, _b[classes.rtl] = theme.direction === 'rtl', _b)), anchorOrigin: { horizontal: 'right', vertical: badgeVerticalAnchor } }, { children: jsx$1(SvgIcon$1, { component: component, className: classNames(colorCssClass, fontSizeCssClass, className), viewBox: customViewBox || '0 0 24 24' }) })));
};

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject$5(evt) && isDataTransfer(evt)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject$5(value.dataTransfer);
}
function isChangeEvt(value) {
    return isObject$5(value) && isObject$5(value.target);
}
function isObject$5(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dt === null) {
                        return [2 /*return*/, []];
                    }
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default$8 = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$m(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default$8(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined$1(file.size)) {
    if (isDefined$1(minSize) && isDefined$1(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined$1(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined$1(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined$1(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * filePickerOptionsTypes returns the {types} option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 * based on the accept attr (see https://github.com/react-dropzone/attr-accept)
 * E.g: converts ['image/*', 'text/*'] to {'image/*': [], 'text/*': []}
 * @param {string|string[]} accept
 */

function filePickerOptionsTypes(accept) {
  accept = typeof accept === "string" ? accept.split(",") : accept;
  return [{
    description: "everything",
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(accept) ? // Accept just MIME types as per spec
    // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
    accept.filter(function (item) {
      return item === "audio/*" || item === "video/*" || item === "image/*" || item === "text/*" || /\w+\/[-+.\w]+/g.test(item);
    }).reduce(function (a, b) {
      return _objectSpread$e(_objectSpread$e({}, a), {}, _defineProperty$m({}, b, []));
    }, {}) : {}
  }];
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}

var _excluded$k = ["children"],
    _excluded2$1 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$l(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded$k);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2$1);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default.createElement(Fragment, null, children(_objectSpread$d(_objectSpread$d({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps$3 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true
};
Dropzone.defaultProps = defaultProps$3;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes$1.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes$1.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes$1.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes$1.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes$1.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes$1.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes$1.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes$1.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes$1.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes$1.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes$1.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes$1.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes$1.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes$1.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes$1.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes$1.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes$1.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes$1.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes$1.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes$1.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes$1.func,

  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: PropTypes$1.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread$d(_objectSpread$d({}, defaultProps$3), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
      useFsAccessApi = _defaultProps$options.useFsAccessApi,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var onFileDialogOpenCb = useMemo$1(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$6;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo$1(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$6;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer$1, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback$1(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback$1(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback$1(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: "setDraggedFiles",
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback$1(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, accept, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback$1(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback$1(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: filePickerOptionsTypes(accept)
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          }
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, accept, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback$1(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback$1(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback$1(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback$1(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo$1(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread$d(_objectSpread$d(_defineProperty$l({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "button"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback$1(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo$1(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty$l({
        accept: accept,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: "off",
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread$d(_objectSpread$d({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread$d(_objectSpread$d({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer$1(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread$d(_objectSpread$d({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread$d(_objectSpread$d({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread$d(_objectSpread$d({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread$d(_objectSpread$d({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread$d(_objectSpread$d({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case "setFiles":
      return _objectSpread$d(_objectSpread$d({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread$d({}, initialState);

    default:
      return state;
  }
}

function noop$6() {}

var isAcceptedFileType = function (file, acceptedExtensions) {
    var extensions = "".concat(acceptedExtensions.join('|'));
    var regexString = "^.*.(".concat(extensions, ")$");
    var regex = new RegExp(regexString, 'i');
    return regex.test(file.name);
};
var isAcceptedFileSize = function (file, maxSizeMb) { return file.size < 1024 * 1024 * maxSizeMb; };
var getImageContentSource = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    if (e.target) {
                        resolve(e.target.result);
                    }
                };
                try {
                    reader.readAsDataURL(file);
                }
                catch (_a) {
                    // just so it fails gracefully
                }
            })];
    });
}); };
var ImageDropZone = function (props) {
    var _a;
    var extensions = props.extensions, maxSizeMb = props.maxSizeMb, inputRef = props.inputRef, errorMessage = props.errorMessage, setErrorMessage = props.setErrorMessage, setIsValidImage = props.setIsValidImage, setSelectedFile = props.setSelectedFile, setTempImageSource = props.setTempImageSource, loading = props.loading;
    var _b = useStyles$P(), classes = _b.classes, classNames = _b.cx;
    var textClasses = useTextStyles().classes;
    var setFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var fileSourceUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getImageContentSource(file)];
                case 1:
                    fileSourceUrl = _a.sent();
                    if (!isAcceptedFileType(file, extensions)) {
                        setErrorMessage('File type is not supported');
                        setIsValidImage(false);
                        return [2 /*return*/];
                    }
                    if (!isAcceptedFileSize(file, maxSizeMb)) {
                        setErrorMessage("File size must be less than ".concat(maxSizeMb, "MB"));
                        setIsValidImage(false);
                        return [2 /*return*/];
                    }
                    setErrorMessage(undefined);
                    setIsValidImage(true);
                    setSelectedFile(file);
                    setTempImageSource(fileSourceUrl);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleImageUploaded = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var file;
        return __generator(this, function (_a) {
            if (event.target.files) {
                file = event.target.files[0];
                setFile(file);
            }
            else {
                setIsValidImage(false);
            }
            return [2 /*return*/];
        });
    }); };
    var onDrop = useCallback$1(function (acceptedFiles) {
        if (acceptedFiles) {
            var file = acceptedFiles[0];
            setFile(file);
        }
        else {
            setIsValidImage(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _c = useDropzone({ onDrop: onDrop }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive;
    return (jsxs(Fragment$1, { children: [jsxs("label", __assign$3({ htmlFor: "icon-button-file" }, { children: [jsx$1("input", __assign$3({}, getInputProps(), { ref: inputRef, disabled: loading, accept: "image/*", style: { display: 'none' }, id: "icon-button-file", type: "file", onChange: handleImageUploaded })), jsxs(Grid, __assign$3({}, getRootProps(), { container: true, direction: "column", alignItems: "center", justifyContent: "center", className: classNames(classes.container, classes.sizingContainer, (_a = {},
                            _a[classes.containerDropping] = isDragActive,
                            _a[classes.containerError] = errorMessage !== undefined,
                            _a)) }, { children: [jsx$1(Grid, __assign$3({ item: true }, { children: jsx$1(Icon, { name: IconName.CloudUploadOutlined, size: IconSize$1.Large, iconColor: IconColor$1.Background, className: classes.dropIcon }) })), jsxs(Grid, __assign$3({ item: true }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.highlightPrimary, textClasses.displayInline, textClasses.weightSemiBold) }, { children: "Upload" })), jsxs("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.highlightBackground, textClasses.displayInline, textClasses.weightSemiBold) }, { children: [' ', "or drop an image here"] }))] })), jsx$1(Grid, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeM, textClasses.highlightBackground) }, { children: "It works for JPG, JPEG or PNG files - 1MB max." })) })] }))] })), errorMessage !== undefined && (jsxs(Grid, __assign$3({ container: true, className: classes.errorContainer, direction: "row" }, { children: [jsx$1(Icon, { name: IconName.InfoOutlinedIcon, iconColor: IconColor$1.Error, size: IconSize$1.Medium }), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.marginLeft, textClasses.weightSemiBold, textClasses.highlightError, textClasses.sizeMs) }, { children: "It works for JPG, JPEG or PNG files - 1MB max." }))] })))] }));
};

var useStyles$N = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        customStyle: {
            '& input.MuiInputBase-input': {
                padding: '8px 16px',
                MozAppearance: 'textfield',
                textAlign: props === null || props === void 0 ? void 0 : props.alignInputTextString,
                paddingLeft: props === null || props === void 0 ? void 0 : props.inputPaddingLeft,
                fontSize: props === null || props === void 0 ? void 0 : props.inputFontSize
            },
            '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: 'none'
            },
            '& input:-internal-autofill-selected': {
                WebkitBoxShadow: '0 0 0 30px #F6F9FE inset'
            },
            '&:after': {
                borderColor: additionalPalette.lightGrey.main
            },
            borderRadius: theme.spacing(0.25)
        },
        customQuotaStyle: {
            '& input.MuiInputBase-input': {
                padding: theme.spacing(1),
                MozAppearance: 'textfield',
                textAlign: 'center'
            },
            '&:after': {
                borderColor: additionalPalette.lightGrey.main
            },
            '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: 'none'
            },
            borderRadius: theme.spacing(0.25),
            fontSize: theme.typography.subtitle2.fontSize,
            color: theme.palette.text.secondary
        },
        datePicker: {
            backgroundColor: additionalPalette.lightBlue.main,
            borderRadius: theme.spacing(0.25),
            '& fieldset': {
                border: 'none'
            },
            '& .MuiSvgIcon-root': {
                color: theme.palette.secondary.light
            },
            '& input': {
                cursor: 'pointer'
            }
        },
        outlinedStyle: {
            backgroundColor: additionalPalette.lightBlue.main,
            '& fieldset': {
                border: (props === null || props === void 0 ? void 0 : props.isError) ? '1px solid' : 'none',
                borderColor: (props === null || props === void 0 ? void 0 : props.isError) ? theme.palette.error.main : undefined
            }
        },
        outlinedSearchBarStyle: {
            height: theme.spacing(5),
            width: '100%',
            maxWidth: theme.spacing(51)
        },
        passwordInput: {
            borderRadius: 0
        },
        passwordRoot: {
            backgroundColor: additionalPalette.lightBlue.main
        },
        root: {
            '& .Mui-disabled': {
                WebkitTextFillColor: theme.palette.text.primary
            },
            '& .MuiOutlinedInput-root ': {
                borderColor: additionalPalette.lightBlue.secondary,
                borderRadius: theme.spacing(0.25)
            },
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                borderColor: (props === null || props === void 0 ? void 0 : props.isError)
                    ? theme.palette.error.main
                    : additionalPalette.lightBlue.secondary
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: additionalPalette.lightBlue.secondary,
                borderWidth: 1
            },
            '& .MuiOutlinedInput-root:hover:before': {
                borderBottomColor: (props === null || props === void 0 ? void 0 : props.isError)
                    ? theme.palette.error.main
                    : theme.palette.primary.main,
                borderBottomWidth: 1
            },
            '& .MuiInput-underline:hover:before': {
                borderBottomColor: additionalPalette.darkBlue.main,
                borderBottomWidth: 1
            },
            '& .MuiOutlinedInput-root:after': {
                borderBottomColor: theme.palette.secondary.main,
                borderBottomWidth: 1
            }
        },
        searchBarIcon: {
            color: theme.palette.primary.main
        },
        searchBarIconBlue: {
            color: theme.palette.secondary.main
        },
        searchBarInputProps: {
            fontSize: theme.spacing(2)
        },
        weightBold: {
            fontWeight: theme.typography.fontWeightBold
        },
        weightSemiBold: {
            fontWeight: theme.typography.fontWeightMedium
        },
        weightRegular: {
            fontWeight: theme.typography.fontWeightRegular
        },
        xxlFont: {
            fontSize: '2.5rem'
        },
        xlFont: {
            fontSize: '2rem'
        },
        lxlFont: {
            fontSize: '1.5rem'
        },
        lFont: {
            fontSize: '1.25rem'
        },
        mlFont: {
            fontSize: '1.125rem'
        },
        mFont: {
            fontSize: '1rem'
        },
        msFont: {
            fontSize: '0.875rem'
        },
        sFont: {
            fontSize: '0.75rem'
        },
        outlinedPercentageStyle: {
            border: (props === null || props === void 0 ? void 0 : props.isPecentageInputError)
                ? "1px solid ".concat(theme.palette.error.main)
                : 'none',
            borderRadius: theme.spacing(0.25),
            backgroundColor: additionalPalette.lightBlue.main,
            '& input.MuiInputBase-input': {
                fontSize: '1rem',
                color: theme.palette.text.secondary
            }
        },
        searchNoResults: {
            padding: theme.spacing(2)
        },
        searchOverlay: {
            position: 'absolute',
            inset: 0,
            zIndex: 1
        },
        searchBoxWrapper: {
            position: 'relative',
            zIndex: 1
        },
        searchPopup: {
            position: 'absolute',
            width: (props === null || props === void 0 ? void 0 : props.menuWidthSameAsSearchBar) && (props === null || props === void 0 ? void 0 : props.minimumMenuWidth)
                ? props.minimumMenuWidth - 2
                : undefined,
            minWidth: (props === null || props === void 0 ? void 0 : props.minimumMenuWidth)
                ? "".concat(props.minimumMenuWidth - 2, "px")
                : '470px',
            border: "1px solid ".concat(theme.palette.divider),
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.spacing(0, 0.25),
            maxHeight: (props === null || props === void 0 ? void 0 : props.maxHeightResultsMenu)
                ? "".concat(props === null || props === void 0 ? void 0 : props.maxHeightResultsMenu, "vh")
                : '70vh',
            overflowY: 'auto'
        },
        cancelIcon: {
            height: theme.spacing(1.75),
            width: theme.spacing(1.75),
            color: theme.palette.text.secondary
        },
        search2: {
            margin: theme.spacing(0.75, 0, 0, 0)
        },
        noResults: {
            paddingTop: 4
        }
    });
});

var InputVariant;
(function (InputVariant) {
    InputVariant[InputVariant["Outlined"] = 0] = "Outlined";
    InputVariant[InputVariant["Filled"] = 1] = "Filled";
    InputVariant[InputVariant["Underlined"] = 2] = "Underlined";
})(InputVariant || (InputVariant = {}));
var InputType;
(function (InputType) {
    InputType[InputType["Text"] = 0] = "Text";
    InputType[InputType["Number"] = 1] = "Number";
})(InputType || (InputType = {}));
var InputWeight;
(function (InputWeight) {
    InputWeight[InputWeight["Bold"] = 0] = "Bold";
    InputWeight[InputWeight["Regular"] = 1] = "Regular";
    InputWeight[InputWeight["SemiBold"] = 2] = "SemiBold";
})(InputWeight || (InputWeight = {}));
var AlignInputText;
(function (AlignInputText) {
    AlignInputText[AlignInputText["Center"] = 0] = "Center";
    AlignInputText[AlignInputText["Left"] = 1] = "Left";
    AlignInputText[AlignInputText["Right"] = 2] = "Right";
})(AlignInputText || (AlignInputText = {}));
var InputFontSize;
(function (InputFontSize) {
    InputFontSize[InputFontSize["xxl"] = 40] = "xxl";
    InputFontSize[InputFontSize["xl"] = 32] = "xl";
    InputFontSize[InputFontSize["lxl"] = 24] = "lxl";
    InputFontSize[InputFontSize["l"] = 20] = "l";
    InputFontSize[InputFontSize["ml"] = 18] = "ml";
    InputFontSize[InputFontSize["m"] = 16] = "m";
    InputFontSize[InputFontSize["ms"] = 14] = "ms";
    InputFontSize[InputFontSize["s"] = 12] = "s";
})(InputFontSize || (InputFontSize = {}));
var getFormattedValue = function (value, maxValueLength) {
    return Math.max(0, parseInt(value, 10)).toString().slice(0, maxValueLength);
};
var alignInputTextOptions = new Map([
    [AlignInputText.Center, 'center'],
    [AlignInputText.Left, 'left'],
    [AlignInputText.Right, 'right']
]);
var inputTypes = new Map([
    [InputType.Number, 'number'],
    [InputType.Text, 'text']
]);
var stringVariants = new Map([
    [InputVariant.Filled, 'outlined'],
    [InputVariant.Outlined, 'outlined'],
    [InputVariant.Underlined, 'standard']
]);
var Input$6 = function (props) {
    var _a = props.alignInputText, alignInputText = _a === void 0 ? AlignInputText.Left : _a, _b = props.autoFocus, autoFocus = _b === void 0 ? false : _b, onFocus = props.onFocus, _c = props.ariaLabel, ariaLabel = _c === void 0 ? 'Input' : _c, children = props.children, className = props.className, defaultValue = props.defaultValue, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.inputType, inputType = _e === void 0 ? InputType.Text : _e, _f = props.isError, isError = _f === void 0 ? false : _f, _g = props.helperText, helperText = _g === void 0 ? 'Whoops, there seems to be an error' : _g, onChange = props.onChange, maxValueLength = props.maxValueLength, _h = props.multiline, multiline = _h === void 0 ? false : _h, placeholder = props.placeholder, style = props.style, value = props.value, _j = props.variant, variant = _j === void 0 ? InputVariant.Outlined : _j, _k = props.disableEnter, disableEnter = _k === void 0 ? false : _k, _l = props.inputWeight, inputWeight = _l === void 0 ? InputWeight.Regular : _l, _m = props.inputFontSize, inputFontSize = _m === void 0 ? InputFontSize.ms : _m, _o = props.disabled, disabled = _o === void 0 ? false : _o, maxLength = props.maxLength, rows = props.rows, rowsMax = props.rowsMax, onBlur = props.onBlur, onPaste = props.onPaste, onSelect = props.onSelect, dataCy = props.dataCy, customFormat = props.customFormat, _p = props.supressHelperText, supressHelperText = _p === void 0 ? false : _p, _q = props.width, width = _q === void 0 ? undefined : _q;
    var alignInputTextString = alignInputTextOptions.get(alignInputText);
    var stringVariant = stringVariants.get(variant);
    var stringType = inputTypes.get(inputType);
    var inputPaddingLeft = variant === InputVariant.Underlined ? 0 : 16;
    var inputFontSizeUnderlined = variant === InputVariant.Underlined ? 16 : 'inherit';
    var _r = useStyles$N({
        styleProps: {
            alignInputTextString: alignInputTextString,
            inputPaddingLeft: inputPaddingLeft,
            inputFontSize: inputFontSizeUnderlined,
            isError: isError
        }
    }), classes = _r.classes, classNames = _r.cx;
    var weightVariant = new Map([
        [InputWeight.Bold, classes.weightBold],
        [InputWeight.SemiBold, classes.weightSemiBold],
        [InputWeight.Regular, classes.weightRegular]
    ]);
    var inputWeightClass = weightVariant.get(inputWeight);
    var fontSizeVariant = new Map([
        [InputFontSize.xxl, classes.xxlFont],
        [InputFontSize.xl, classes.xlFont],
        [InputFontSize.lxl, classes.lxlFont],
        [InputFontSize.l, classes.lFont],
        [InputFontSize.ml, classes.mlFont],
        [InputFontSize.m, classes.mFont],
        [InputFontSize.ms, classes.msFont],
        [InputFontSize.s, classes.sFont]
    ]);
    var inputFontSizeClass = fontSizeVariant.get(inputFontSize);
    var rootCssClasses = new Map([
        [InputVariant.Filled, classes.outlinedStyle],
        [InputVariant.Outlined, ''],
        [InputVariant.Underlined, '']
    ]);
    var rootCssClass = rootCssClasses.get(variant);
    var handlePressEnter = function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };
    return (jsx$1(TextField$1, __assign$3({ disabled: disabled, autoFocus: autoFocus, onFocus: function () {
            if (onFocus) {
                onFocus();
            }
        }, onBlur: onBlur, multiline: multiline, className: classNames(className, classes.root), defaultValue: defaultValue, fullWidth: fullWidth, inputProps: {
            'data-cy': dataCy,
            'aria-label': ariaLabel,
            maxLength: maxLength
        }, 
        // eslint-disable-next-line react/jsx-no-duplicate-props
        InputProps: {
            classes: {
                root: classNames(classes.customStyle, rootCssClass, inputWeightClass, inputFontSizeClass)
            },
            inputComponent: customFormat
        }, onInput: function (event) {
            if (inputType === InputType.Number && maxValueLength) {
                getFormattedValue(event.target.value, maxValueLength);
            }
            else {
                // eslint-disable-next-line no-unused-expressions
                event.target.value;
            }
        }, onKeyPress: function (event) { return disableEnter && handlePressEnter(event); }, onChange: onChange, onPaste: onPaste, onSelect: onSelect, placeholder: placeholder, size: "small", style: style, type: stringType, value: value, variant: stringVariant, error: isError, helperText: isError && !supressHelperText ? helperText : undefined, rows: rows, maxRows: rowsMax, sx: { width: width } }, { children: children })));
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR$1);
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

var MILLISECONDS_IN_MINUTE$1 = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$1);
}

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1000);
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate$2(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate$2(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}

/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */

function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days

  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex$1(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex$1(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$2 = match$1;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$2,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale$1 = locale$1;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$3 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$4 = formatters$3;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$4.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$4.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$4.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$4.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$4.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$4.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$4.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$4.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$2 = formatters$1;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters$2 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$3 = longFormatters$2;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale$1;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$3[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }

    var formatter = formatters$2[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(date, options) {
  requiredArgs(1, arguments);
  var originalDate = toDate(date);

  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }

  var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
  var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual$3(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
var parsers$1 = parsers;

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse$7(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale$1;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$3[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour (and same day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 * 
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? 2 : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate$1(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate$1(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

var longFormatters$1 = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;
}(longFormatters$1, longFormatters$1.exports));

var longFormatters = /*@__PURE__*/getDefaultExportFromCjs(longFormatters$1.exports);

var defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy",
};
var DateFnsUtils = /** @class */ (function () {
    function DateFnsUtils(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, formats = _b.formats;
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = function () {
            if (_this.locale) {
                return /a/.test(_this.locale.formatLong.time());
            }
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = function (format) {
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            var longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            var locale = _this.locale || defaultLocale$1;
            return format
                .match(longFormatRegexp)
                .map(function (token) {
                var firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    var longFormatter = longFormatters[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            })
                .join("")
                .replace(/(aaa|aa|a)/g, "(a|p)m")
                .toLocaleLowerCase();
        };
        this.parseISO = function (isoString) {
            return parseISO(isoString);
        };
        this.toISO = function (value) {
            return formatISO(value, { format: "extended" });
        };
        this.getCurrentLocaleCode = function () {
            var _a;
            return ((_a = _this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = function (value, count) {
            return addSeconds(value, count);
        };
        this.addMinutes = function (value, count) {
            return addMinutes(value, count);
        };
        this.addHours = function (value, count) {
            return addHours(value, count);
        };
        this.addDays = function (value, count) {
            return addDays(value, count);
        };
        this.addWeeks = function (value, count) {
            return addWeeks(value, count);
        };
        this.addMonths = function (value, count) {
            return addMonths(value, count);
        };
        this.isValid = function (value) {
            return isValid(_this.date(value));
        };
        this.getDiff = function (value, comparing, unit) {
            switch (unit) {
                case "years":
                    return differenceInYears(value, _this.date(comparing));
                case "quarters":
                    return differenceInQuarters(value, _this.date(comparing));
                case "months":
                    return differenceInMonths(value, _this.date(comparing));
                case "weeks":
                    return differenceInWeeks(value, _this.date(comparing));
                case "days":
                    return differenceInDays(value, _this.date(comparing));
                case "hours":
                    return differenceInHours(value, _this.date(comparing));
                case "minutes":
                    return differenceInMinutes(value, _this.date(comparing));
                case "seconds":
                    return differenceInSeconds(value, _this.date(comparing));
                default: {
                    return differenceInMilliseconds(value, _this.date(comparing));
                }
            }
        };
        this.isAfter = function (value, comparing) {
            return isAfter(value, comparing);
        };
        this.isBefore = function (value, comparing) {
            return isBefore(value, comparing);
        };
        this.startOfDay = function (value) {
            return startOfDay(value);
        };
        this.endOfDay = function (value) {
            return endOfDay(value);
        };
        this.getHours = function (value) {
            return getHours$1(value);
        };
        this.setHours = function (value, count) {
            return setHours(value, count);
        };
        this.setMinutes = function (value, count) {
            return setMinutes(value, count);
        };
        this.getSeconds = function (value) {
            return getSeconds(value);
        };
        this.setSeconds = function (value, count) {
            return setSeconds(value, count);
        };
        this.isSameDay = function (value, comparing) {
            return isSameDay(value, comparing);
        };
        this.isSameMonth = function (value, comparing) {
            return isSameMonth(value, comparing);
        };
        this.isSameYear = function (value, comparing) {
            return isSameYear(value, comparing);
        };
        this.isSameHour = function (value, comparing) {
            return isSameHour(value, comparing);
        };
        this.startOfYear = function (value) {
            return startOfYear(value);
        };
        this.endOfYear = function (value) {
            return endOfYear(value);
        };
        this.startOfMonth = function (value) {
            return startOfMonth(value);
        };
        this.endOfMonth = function (value) {
            return endOfMonth(value);
        };
        this.startOfWeek = function (value) {
            return startOfWeek(value, { locale: _this.locale });
        };
        this.endOfWeek = function (value) {
            return endOfWeek(value, { locale: _this.locale });
        };
        this.getYear = function (value) {
            return getYear(value);
        };
        this.setYear = function (value, count) {
            return setYear(value, count);
        };
        this.date = function (value) {
            if (typeof value === "undefined") {
                return new Date();
            }
            if (value === null) {
                return null;
            }
            return new Date(value);
        };
        this.toJsDate = function (value) {
            return value;
        };
        this.parse = function (value, formatString) {
            if (value === "") {
                return null;
            }
            return parse$7(value, formatString, new Date(), { locale: _this.locale });
        };
        this.format = function (date, formatKey) {
            return _this.formatByString(date, _this.formats[formatKey]);
        };
        this.formatByString = function (date, formatString) {
            return format$1(date, formatString, { locale: _this.locale });
        };
        this.isEqual = function (date, comparing) {
            if (date === null && comparing === null) {
                return true;
            }
            return isEqual$3(date, comparing);
        };
        this.isNull = function (date) {
            return date === null;
        };
        this.isAfterDay = function (date, value) {
            return isAfter(date, endOfDay(value));
        };
        this.isBeforeDay = function (date, value) {
            return isBefore(date, startOfDay(value));
        };
        this.isBeforeYear = function (date, value) {
            return isBefore(date, startOfYear(value));
        };
        this.isAfterYear = function (date, value) {
            return isAfter(date, endOfYear(value));
        };
        this.isWithinRange = function (date, _a) {
            var start = _a[0], end = _a[1];
            return isWithinInterval(date, { start: start, end: end });
        };
        this.formatNumber = function (numberToFormat) {
            return numberToFormat;
        };
        this.getMinutes = function (date) {
            return date.getMinutes();
        };
        this.getMonth = function (date) {
            return date.getMonth();
        };
        this.getDaysInMonth = function (date) {
            return getDaysInMonth(date);
        };
        this.setMonth = function (date, count) {
            return setMonth(date, count);
        };
        this.getMeridiemText = function (ampm) {
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = function (date) {
            return addMonths(date, 1);
        };
        this.getPreviousMonth = function (date) {
            return addMonths(date, -1);
        };
        this.getMonthArray = function (date) {
            var firstMonth = startOfYear(date);
            var monthArray = [firstMonth];
            while (monthArray.length < 12) {
                var prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(_this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = function (date, time) {
            return _this.setSeconds(_this.setMinutes(_this.setHours(date, _this.getHours(time)), _this.getMinutes(time)), _this.getSeconds(time));
        };
        this.getWeekdays = function () {
            var now = new Date();
            return eachDayOfInterval({
                start: startOfWeek(now, { locale: _this.locale }),
                end: endOfWeek(now, { locale: _this.locale }),
            }).map(function (day) { return _this.formatByString(day, "EEEEEE"); });
        };
        this.getWeekArray = function (date) {
            var start = startOfWeek(startOfMonth(date), { locale: _this.locale });
            var end = endOfWeek(endOfMonth(date), { locale: _this.locale });
            var count = 0;
            var current = start;
            var nestedWeeks = [];
            var lastDay = null;
            while (isBefore(current, end)) {
                var weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                var day = getDay(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = addDays(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = function (start, end) {
            var startDate = startOfYear(start);
            var endDate = endOfYear(end);
            var years = [];
            var current = startDate;
            while (isBefore(current, endDate)) {
                years.push(current);
                current = addYears(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
    return DateFnsUtils;
}());

/* Use it instead of .includes method for IE support */
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(item => array.indexOf(item) !== -1);
  }

  return array.indexOf(itemOrItems) !== -1;
}
const onSpaceOrEnter = (innerFn, onFocus) => event => {
  if (event.key === 'Enter' || event.key === ' ') {
    innerFn(); // prevent any side effects

    event.preventDefault();
    event.stopPropagation();
  }

  if (onFocus) {
    onFocus(event);
  }
};
/* Quick untyped helper to improve function composition readability */

const pipe = (...fns) => fns.reduceRight((prevFn, nextFn) => (...args) => nextFn(prevFn(...args)), value => value);
function createDelegatedEventHandler(fn, onEvent) {
  return event => {
    fn(event);

    if (onEvent) {
      onEvent(event);
    }
  };
}

const _excluded$j = ["disabled", "onSelect", "selected", "value"];
const classes$8 = generateUtilityClasses('PrivatePickersMonth', ['root', 'selected']);
const PickersMonthRoot = styled$1(Typography$1)(({
  theme
}) => _extends$P({
  flex: '1 0 33.33%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus, &:hover': {
    backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    pointerEvents: 'none',
    color: theme.palette.text.secondary
  },
  [`&.${classes$8.selected}`]: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
}));
/**
 * @ignore - do not document.
 */

const PickersMonth = props => {
  const {
    disabled,
    onSelect,
    selected,
    value
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$j);

  const handleSelection = () => {
    onSelect(value);
  };

  return /*#__PURE__*/jsx$1(PickersMonthRoot, _extends$P({
    component: "button",
    className: clsx(classes$8.root, selected && classes$8.selected),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyDown: onSpaceOrEnter(handleSelection),
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    disabled: disabled
  }, other));
};

const MuiPickersAdapterContext = /*#__PURE__*/React$d.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
}

/**
 * @ignore - do not document.
 */
function LocalizationProvider(props) {
  const {
    children,
    dateAdapter: Utils,
    dateFormats,
    dateLibInstance,
    locale
  } = props;
  const utils = React$d.useMemo(() => new Utils({
    locale,
    formats: dateFormats,
    instance: dateLibInstance
  }), [Utils, locale, dateFormats, dateLibInstance]);
  const defaultDates = React$d.useMemo(() => {
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = React$d.useMemo(() => {
    return {
      utils,
      defaultDates
    };
  }, [defaultDates, utils]);
  return /*#__PURE__*/jsx$1(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes$1.node,

  /**
   * DateIO adapter class function
   */
  dateAdapter: PropTypes$1.func.isRequired,

  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes$1.shape({
    dayOfMonth: PropTypes$1.string,
    fullDate: PropTypes$1.string,
    fullDateTime: PropTypes$1.string,
    fullDateTime12h: PropTypes$1.string,
    fullDateTime24h: PropTypes$1.string,
    fullDateWithWeekday: PropTypes$1.string,
    fullTime: PropTypes$1.string,
    fullTime12h: PropTypes$1.string,
    fullTime24h: PropTypes$1.string,
    hours12h: PropTypes$1.string,
    hours24h: PropTypes$1.string,
    keyboardDate: PropTypes$1.string,
    keyboardDateTime: PropTypes$1.string,
    keyboardDateTime12h: PropTypes$1.string,
    keyboardDateTime24h: PropTypes$1.string,
    minutes: PropTypes$1.string,
    month: PropTypes$1.string,
    monthAndDate: PropTypes$1.string,
    monthAndYear: PropTypes$1.string,
    monthShort: PropTypes$1.string,
    normalDate: PropTypes$1.string,
    normalDateWithWeekday: PropTypes$1.string,
    seconds: PropTypes$1.string,
    shortDate: PropTypes$1.string,
    weekday: PropTypes$1.string,
    weekdayShort: PropTypes$1.string,
    year: PropTypes$1.string
  }),

  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes$1.any,

  /**
   * Locale for the date library you are using
   */
  locale: PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string])
} : void 0;

const useLocalizationContext = () => {
  const localization = React$d.useContext(MuiPickersAdapterContext);

  if (localization === null) {
    throw new Error('MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.');
  }

  return localization;
};

const useUtils = () => useLocalizationContext().utils;
const useDefaultDates = () => useLocalizationContext().defaultDates;
const useNow = () => {
  const utils = useUtils();
  const now = React$d.useRef(utils.date());
  return now.current;
};

function getMonthPickerUtilityClass(slot) {
  return generateUtilityClass('MuiMonthPicker', slot);
}
generateUtilityClasses('MuiMonthPicker', ['root']);

const _excluded$i = ["className", "date", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "onMonthChange", "readOnly"];

const useUtilityClasses$5 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getMonthPickerUtilityClass, classes);
};

const MonthPickerRoot = styled$1('div', {
  name: 'MuiMonthPicker',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  width: 310,
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'stretch',
  margin: '0 4px'
});
const MonthPicker = /*#__PURE__*/React$d.forwardRef(function MonthPicker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiMonthPicker'
  });

  const {
    className,
    date,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onChange,
    onMonthChange,
    readOnly
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$i);

  const ownerState = props;
  const classes = useUtilityClasses$5(ownerState);
  const utils = useUtils();
  const now = useNow();
  const currentMonth = utils.getMonth(date || now);

  const shouldDisableMonth = month => {
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    const isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    const isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };

  const onMonthSelect = month => {
    if (readOnly) {
      return;
    }

    const newDate = utils.setMonth(date || now, month);
    onChange(newDate, 'finish');

    if (onMonthChange) {
      onMonthChange(newDate);
    }
  };

  return /*#__PURE__*/jsx$1(MonthPickerRoot, _extends$P({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: utils.getMonthArray(date || now).map(month => {
      const monthNumber = utils.getMonth(month);
      const monthText = utils.format(month, 'monthShort');
      return /*#__PURE__*/jsx$1(PickersMonth, {
        value: monthNumber,
        selected: monthNumber === currentMonth,
        onSelect: onMonthSelect,
        disabled: disabled || shouldDisableMonth(month),
        children: monthText
      }, monthText);
    })
  }));
});
process.env.NODE_ENV !== "production" ? MonthPicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * className applied to the root element.
   */
  className: PropTypes$1.string,

  /**
   * Date value for the MonthPicker
   */
  date: PropTypes$1.any,

  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true` future days are disabled.
   */
  disableFuture: PropTypes$1.bool,

  /**
   * If `true` past days are disabled.
   */
  disablePast: PropTypes$1.bool,

  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes$1.any.isRequired,

  /**
   * Minimal selectable date.
   */
  minDate: PropTypes$1.any.isRequired,

  /**
   * Callback fired on date change.
   */
  onChange: PropTypes$1.func.isRequired,
  onMonthChange: PropTypes$1.func,

  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
} : void 0;

function useValidation$2(props, validate, isSameError) {
  const {
    value,
    onError
  } = props;
  const utils = useUtils();
  const previousValidationErrorRef = React$d.useRef(null);
  const validationError = validate(utils, value, props);
  React$d.useEffect(() => {
    if (onError && !isSameError(validationError, previousValidationErrorRef.current)) {
      onError(validationError, value);
    }

    previousValidationErrorRef.current = validationError;
  }, [isSameError, onError, previousValidationErrorRef, validationError, value]);
  return validationError;
}

const validateDate = (utils, value, {
  disablePast,
  disableFuture,
  minDate,
  maxDate,
  shouldDisableDate
}) => {
  const now = utils.date();
  const date = utils.date(value);

  if (date === null) {
    return null;
  }

  switch (true) {
    case !utils.isValid(value):
      return 'invalidDate';

    case Boolean(shouldDisableDate && shouldDisableDate(date)):
      return 'shouldDisableDate';

    case Boolean(disableFuture && utils.isAfterDay(date, now)):
      return 'disableFuture';

    case Boolean(disablePast && utils.isBeforeDay(date, now)):
      return 'disablePast';

    case Boolean(minDate && utils.isBeforeDay(date, minDate)):
      return 'minDate';

    case Boolean(maxDate && utils.isAfterDay(date, maxDate)):
      return 'maxDate';

    default:
      return null;
  }
};

const isSameDateError = (a, b) => a === b;

const useDateValidation = props => useValidation$2(props, validateDate, isSameDateError);

const createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils) => (state, action) => {
  switch (action.type) {
    case 'changeMonth':
      return _extends$P({}, state, {
        slideDirection: action.direction,
        currentMonth: action.newMonth,
        isMonthSwitchingAnimating: !reduceAnimations
      });

    case 'finishMonthSwitchingAnimation':
      return _extends$P({}, state, {
        isMonthSwitchingAnimating: false
      });

    case 'changeFocusedDay':
      {
        if (state.focusedDay !== null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
          return state;
        }

        const needMonthSwitch = Boolean(action.focusedDay) && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
        return _extends$P({}, state, {
          focusedDay: action.focusedDay,
          isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations,
          currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
          slideDirection: utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
        });
      }

    default:
      throw new Error('missing support');
  }
};
const useCalendarState = ({
  date,
  defaultCalendarMonth,
  disableFuture,
  disablePast,
  disableSwitchToMonthOnDayFocus = false,
  maxDate,
  minDate,
  onMonthChange,
  reduceAnimations,
  shouldDisableDate
}) => {
  var _ref;

  const now = useNow();
  const utils = useUtils();
  const reducerFn = React$d.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  const [calendarState, dispatch] = React$d.useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: date || now,
    currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
    slideDirection: 'left'
  });
  const handleChangeMonth = React$d.useCallback(payload => {
    dispatch(_extends$P({
      type: 'changeMonth'
    }, payload));

    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  const changeMonth = React$d.useCallback(newDate => {
    const newDateRequested = newDate != null ? newDate : now;

    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }

    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, now, utils]);
  const isDateDisabled = React$d.useCallback(day => validateDate(utils, day, {
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    shouldDisableDate
  }) !== null, [disableFuture, disablePast, maxDate, minDate, shouldDisableDate, utils]);
  const onMonthSwitchingAnimationEnd = React$d.useCallback(() => {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  const changeFocusedDay = React$d.useCallback(newFocusedDate => {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate
      });
    }
  }, [isDateDisabled]);
  return {
    calendarState,
    changeMonth,
    changeFocusedDay,
    isDateDisabled,
    onMonthSwitchingAnimationEnd,
    handleChangeMonth
  };
};

const classes$7 = generateUtilityClasses('PrivatePickersFadeTransitionGroup', ['root']);
const animationDuration = 500;
const PickersFadeTransitionGroupRoot = styled$1(TransitionGroup$1)({
  display: 'block',
  position: 'relative'
});
/**
 * @ignore - do not document.
 */

const PickersFadeTransitionGroup = ({
  children,
  className,
  reduceAnimations,
  transKey
}) => {
  if (reduceAnimations) {
    return children;
  }

  return /*#__PURE__*/jsx$1(PickersFadeTransitionGroupRoot, {
    className: clsx(classes$7.root, className),
    children: /*#__PURE__*/jsx$1(MuiFade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: animationDuration,
        enter: animationDuration / 2,
        exit: 0
      },
      children: children
    }, transKey)
  });
};

const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const VIEW_HEIGHT = 358;

function getPickersDayUtilityClass(slot) {
  return generateUtilityClass('MuiPickersDay', slot);
}
const pickersDayClasses = generateUtilityClasses('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);

const _excluded$h = ["allowSameDateSelection", "autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"];

const useUtilityClasses$4 = ownerState => {
  const {
    selected,
    disableMargin,
    disableHighlightToday,
    today,
    outsideCurrentMonth,
    showDaysOutsideCurrentMonth,
    classes
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth'],
    hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
  };
  return composeClasses(slots, getPickersDayUtilityClass, classes);
};

const styleArg = ({
  theme,
  ownerState
}) => _extends$P({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: '50%',
  padding: 0,
  // background required here to prevent collides with the other days when animating with transition group
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:focus': {
    backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: 'background-color',
      backgroundColor: theme.palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      willChange: 'background-color',
      backgroundColor: theme.palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}`]: {
    color: theme.palette.text.disabled
  }
}, !ownerState.disableMargin && {
  margin: `0 ${DAY_MARGIN}px`
}, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
  color: theme.palette.text.secondary
}, !ownerState.disableHighlightToday && ownerState.today && {
  [`&:not(.${pickersDayClasses.selected})`]: {
    border: `1px solid ${theme.palette.text.secondary}`
  }
});

const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};

const PickersDayRoot = styled$1(ButtonBase$1, {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(styleArg);
const PickersDayFiller = styled$1('div', {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => _extends$P({}, styleArg({
  theme,
  ownerState
}), {
  visibility: 'hidden'
}));

const noop$5 = () => {};

const PickersDayRaw = /*#__PURE__*/React$d.forwardRef(function PickersDay(inProps, forwardedRef) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersDay'
  });

  const {
    allowSameDateSelection = false,
    autoFocus = false,
    className,
    day,
    disabled = false,
    disableHighlightToday = false,
    disableMargin = false,
    isAnimating,
    onClick,
    onDayFocus = noop$5,
    onDaySelect,
    onFocus,
    onKeyDown,
    outsideCurrentMonth,
    selected = false,
    showDaysOutsideCurrentMonth = false,
    children,
    today: isToday = false
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$h);

  const ownerState = _extends$P({}, props, {
    allowSameDateSelection,
    autoFocus,
    disabled,
    disableHighlightToday,
    disableMargin,
    selected,
    showDaysOutsideCurrentMonth,
    today: isToday
  });

  const classes = useUtilityClasses$4(ownerState);
  const utils = useUtils();
  const ref = React$d.useRef(null);
  const handleRef = useForkRef(ref, forwardedRef); // Since this is rendered when a Popper is opened we can't use passive effects.
  // Focusing in passive effects in Popper causes scroll jump.

  useEnhancedEffect$2(() => {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      // ref.current being null would be a bug in MUI
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);

  const handleFocus = event => {
    if (onDayFocus) {
      onDayFocus(day);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  const handleClick = event => {
    if (!allowSameDateSelection && selected) {
      return;
    }

    if (!disabled) {
      onDaySelect(day, 'finish');
    }

    if (onClick) {
      onClick(event);
    }
  };

  const theme = useTheme();

  function handleKeyDown(event) {
    if (onKeyDown !== undefined) {
      onKeyDown(event);
    }

    switch (event.key) {
      case 'ArrowUp':
        onDayFocus(utils.addDays(day, -7));
        event.preventDefault();
        break;

      case 'ArrowDown':
        onDayFocus(utils.addDays(day, 7));
        event.preventDefault();
        break;

      case 'ArrowLeft':
        onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;

      case 'ArrowRight':
        onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;

      case 'Home':
        onDayFocus(utils.startOfWeek(day));
        event.preventDefault();
        break;

      case 'End':
        onDayFocus(utils.endOfWeek(day));
        event.preventDefault();
        break;

      case 'PageUp':
        onDayFocus(utils.getNextMonth(day));
        event.preventDefault();
        break;

      case 'PageDown':
        onDayFocus(utils.getPreviousMonth(day));
        event.preventDefault();
        break;
    }
  }

  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /*#__PURE__*/jsx$1(PickersDayFiller, {
      className: clsx(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState: ownerState
    });
  }

  return /*#__PURE__*/jsx$1(PickersDayRoot, _extends$P({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: handleRef,
    centerRipple: true,
    disabled: disabled,
    "aria-label": !children ? utils.format(day, 'fullDate') : undefined,
    tabIndex: selected ? 0 : -1,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }, other, {
    children: !children ? utils.format(day, 'dayOfMonth') : children
  }));
});
const areDayPropsEqual = (prevProps, nextProps) => {
  return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onDayFocus === nextProps.onDayFocus && prevProps.onDaySelect === nextProps.onDaySelect;
};
process.env.NODE_ENV !== "production" ? PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,

  /**
   * The date to show.
   */
  day: PropTypes$1.any.isRequired,

  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes$1.bool,

  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: PropTypes$1.bool,
  isAnimating: PropTypes$1.bool,
  onDayFocus: PropTypes$1.func,
  onDaySelect: PropTypes$1.func.isRequired,

  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: PropTypes$1.bool.isRequired,

  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: PropTypes$1.bool,

  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes$1.bool,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),

  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: PropTypes$1.bool
} : void 0;
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [PickersDay API](https://mui.com/api/pickers-day/)
 */

const PickersDay = /*#__PURE__*/React$d.memo(PickersDayRaw, areDayPropsEqual);

const _excluded$g = ["children", "className", "reduceAnimations", "slideDirection", "transKey"];
const classes$6 = generateUtilityClasses('PrivatePickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);
const slideAnimationDuration = 350;
const PickersSlideTransitionRoot = styled$1(TransitionGroup$1)(({
  theme
}) => {
  const slideTransition = theme.transitions.create('transform', {
    duration: slideAnimationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    display: 'block',
    position: 'relative',
    overflowX: 'hidden',
    '& > *': {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${classes$6['slideEnter-left']}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      zIndex: 1
    },
    [`& .${classes$6['slideEnter-right']}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      zIndex: 1
    },
    [`& .${classes$6.slideEnterActive}`]: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    [`& .${classes$6.slideExit}`]: {
      transform: 'translate(0%)'
    },
    [`& .${classes$6['slideExitActiveLeft-left']}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition,
      zIndex: 0
    },
    [`& .${classes$6['slideExitActiveLeft-right']}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition,
      zIndex: 0
    }
  };
});
/**
 * @ignore - do not document.
 */

const PickersSlideTransition = _ref => {
  let {
    children,
    className,
    reduceAnimations,
    slideDirection,
    transKey
  } = _ref,
      other = _objectWithoutPropertiesLoose$3(_ref, _excluded$g);

  if (reduceAnimations) {
    return /*#__PURE__*/jsx$1("div", {
      className: clsx(classes$6.root, className),
      children: children
    });
  }

  const transitionClasses = {
    exit: classes$6.slideExit,
    enterActive: classes$6.slideEnterActive,
    enter: classes$6[`slideEnter-${slideDirection}`],
    exitActive: classes$6[`slideExitActiveLeft-${slideDirection}`]
  };
  return /*#__PURE__*/jsx$1(PickersSlideTransitionRoot, {
    className: clsx(classes$6.root, className),
    childFactory: element => /*#__PURE__*/React$d.cloneElement(element, {
      classNames: transitionClasses
    }),
    children: /*#__PURE__*/jsx$1(CSSTransition$1, _extends$P({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: slideAnimationDuration,
      classNames: transitionClasses
    }, other, {
      children: children
    }), transKey)
  });
};

const weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 4) * 6;
const PickersCalendarDayHeader = styled$1('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const PickersCalendarWeekDayLabel = styled$1(Typography$1)(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.text.secondary
}));
const PickersCalendarLoadingContainer = styled$1('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = styled$1(PickersSlideTransition)({
  minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = styled$1('div')({
  overflow: 'hidden'
});
const PickersCalendarWeek = styled$1('div')({
  margin: `${DAY_MARGIN}px 0`,
  display: 'flex',
  justifyContent: 'center'
});
/**
 * @ignore - do not document.
 */

function DayPicker(props) {
  const {
    allowSameDateSelection,
    autoFocus,
    onFocusedDayChange: changeFocusedDay,
    className,
    currentMonth,
    date,
    disabled,
    disableHighlightToday,
    focusedDay,
    isDateDisabled,
    isMonthSwitchingAnimating,
    loading,
    onChange,
    onMonthSwitchingAnimationEnd,
    readOnly,
    reduceAnimations,
    renderDay,
    renderLoading = () => /*#__PURE__*/jsx$1("span", {
      children: "..."
    }),
    showDaysOutsideCurrentMonth,
    slideDirection,
    TransitionProps
  } = props;
  const now = useNow();
  const utils = useUtils();
  const handleDaySelect = React$d.useCallback((day, isFinish = 'finish') => {
    if (readOnly) {
      return;
    } // TODO possibly buggy line figure out and add tests


    const finalDate = Array.isArray(date) ? day : utils.mergeDateAndTime(day, date || now);
    onChange(finalDate, isFinish);
  }, [date, now, onChange, readOnly, utils]);
  const currentMonthNumber = utils.getMonth(currentMonth);
  const selectedDates = (Array.isArray(date) ? date : [date]).filter(Boolean).map(selectedDateItem => selectedDateItem && utils.startOfDay(selectedDateItem)); // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.

  const transitionKey = currentMonthNumber; // eslint-disable-next-line react-hooks/exhaustive-deps

  const slideNodeRef = React$d.useMemo(() => /*#__PURE__*/React$d.createRef(), [transitionKey]);
  return /*#__PURE__*/jsxs(React$d.Fragment, {
    children: [/*#__PURE__*/jsx$1(PickersCalendarDayHeader, {
      children: utils.getWeekdays().map((day, i) => /*#__PURE__*/jsx$1(PickersCalendarWeekDayLabel, {
        "aria-hidden": true,
        variant: "caption",
        children: day.charAt(0).toUpperCase()
      }, day + i.toString()))
    }), loading ? /*#__PURE__*/jsx$1(PickersCalendarLoadingContainer, {
      children: renderLoading()
    }) : /*#__PURE__*/jsx$1(PickersCalendarSlideTransition, _extends$P({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations: reduceAnimations,
      slideDirection: slideDirection,
      className: className
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /*#__PURE__*/jsx$1(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "grid",
        children: utils.getWeekArray(currentMonth).map(week => /*#__PURE__*/jsx$1(PickersCalendarWeek, {
          role: "row",
          children: week.map(day => {
            const pickersDayProps = {
              key: day == null ? void 0 : day.toString(),
              day,
              isAnimating: isMonthSwitchingAnimating,
              disabled: disabled || isDateDisabled(day),
              allowSameDateSelection,
              autoFocus: autoFocus && focusedDay !== null && utils.isSameDay(day, focusedDay),
              today: utils.isSameDay(day, now),
              outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
              selected: selectedDates.some(selectedDate => selectedDate && utils.isSameDay(selectedDate, day)),
              disableHighlightToday,
              showDaysOutsideCurrentMonth,
              onDayFocus: changeFocusedDay,
              onDaySelect: handleDaySelect
            };
            return renderDay ? renderDay(day, selectedDates, pickersDayProps) : /*#__PURE__*/jsx$1("div", {
              role: "cell",
              children: /*#__PURE__*/jsx$1(PickersDay, _extends$P({}, pickersDayProps))
            }, pickersDayProps.key);
          })
        }, `week-${week[0]}`))
      })
    }))]
  });
}

function useViews({
  onChange,
  onViewChange,
  openTo,
  view,
  views
}) {
  var _views, _views2;

  const [openView, setOpenView] = useControlled({
    name: 'Picker',
    state: 'view',
    controlled: view,
    default: openTo && arrayIncludes(views, openTo) ? openTo : views[0]
  });
  const previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
  const nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
  const changeView = React$d.useCallback(newView => {
    setOpenView(newView);

    if (onViewChange) {
      onViewChange(newView);
    }
  }, [setOpenView, onViewChange]);
  const openNext = React$d.useCallback(() => {
    if (nextView) {
      changeView(nextView);
    }
  }, [nextView, changeView]);
  const handleChangeAndOpenNext = React$d.useCallback((date, currentViewSelectionState) => {
    const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
    const globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? 'partial' : currentViewSelectionState;
    onChange(date, globalSelectionState);

    if (isSelectionFinishedOnCurrentView) {
      openNext();
    }
  }, [nextView, onChange, openNext]);
  return {
    handleChangeAndOpenNext,
    nextView,
    previousView,
    openNext,
    openView,
    setOpenView: changeView
  };
}

const ArrowDropDown = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
/**
 * @ignore - internal component.
 */

const ArrowLeft = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
/**
 * @ignore - internal component.
 */

const ArrowRight = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
/**
 * @ignore - internal component.
 */

const Calendar = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
/**
 * @ignore - internal component.
 */

const Clock$1 = createSvgIcon$1( /*#__PURE__*/jsxs(React$d.Fragment, {
  children: [/*#__PURE__*/jsx$1("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx$1("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Clock');
/**
 * @ignore - internal component.
 */

createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
/**
 * @ignore - internal component.
 */

const Pen = createSvgIcon$1( /*#__PURE__*/jsx$1("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Pen');
/**
 * @ignore - internal component.
 */

createSvgIcon$1( /*#__PURE__*/jsxs(React$d.Fragment, {
  children: [/*#__PURE__*/jsx$1("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx$1("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Time');

const _excluded$f = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"];
const PickersArrowSwitcherRoot = styled$1('div')({
  display: 'flex'
});
const PickersArrowSwitcherSpacer = styled$1('div')(({
  theme
}) => ({
  width: theme.spacing(3)
}));
const PickersArrowSwitcherButton = styled$1(IconButton$2)(({
  ownerState
}) => _extends$P({}, ownerState.hidden && {
  visibility: 'hidden'
}));
const PickersArrowSwitcher = /*#__PURE__*/React$d.forwardRef(function PickersArrowSwitcher(props, ref) {
  const {
    children,
    className,
    components = {},
    componentsProps = {},
    isLeftDisabled,
    isLeftHidden,
    isRightDisabled,
    isRightHidden,
    leftArrowButtonText,
    onLeftClick,
    onRightClick,
    rightArrowButtonText
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$f);

  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';
  const leftArrowButtonProps = componentsProps.leftArrowButton || {};
  const LeftArrowIcon = components.LeftArrowIcon || ArrowLeft;
  const rightArrowButtonProps = componentsProps.rightArrowButton || {};
  const RightArrowIcon = components.RightArrowIcon || ArrowRight;
  const ownerState = props;
  return /*#__PURE__*/jsxs(PickersArrowSwitcherRoot, _extends$P({
    ref: ref,
    className: className,
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx$1(PickersArrowSwitcherButton, _extends$P({
      as: components.LeftArrowButton,
      size: "small",
      "aria-label": leftArrowButtonText,
      title: leftArrowButtonText,
      disabled: isLeftDisabled,
      edge: "end",
      onClick: onLeftClick
    }, leftArrowButtonProps, {
      className: leftArrowButtonProps.className,
      ownerState: _extends$P({}, ownerState, leftArrowButtonProps, {
        hidden: isLeftHidden
      }),
      children: isRtl ? /*#__PURE__*/jsx$1(RightArrowIcon, {}) : /*#__PURE__*/jsx$1(LeftArrowIcon, {})
    })), children ? /*#__PURE__*/jsx$1(Typography$1, {
      variant: "subtitle1",
      component: "span",
      children: children
    }) : /*#__PURE__*/jsx$1(PickersArrowSwitcherSpacer, {
      ownerState: ownerState
    }), /*#__PURE__*/jsx$1(PickersArrowSwitcherButton, _extends$P({
      as: components.RightArrowButton,
      size: "small",
      "aria-label": rightArrowButtonText,
      title: rightArrowButtonText,
      edge: "start",
      disabled: isRightDisabled,
      onClick: onRightClick
    }, rightArrowButtonProps, {
      className: rightArrowButtonProps.className,
      ownerState: _extends$P({}, ownerState, rightArrowButtonProps, {
        hidden: isRightHidden
      }),
      children: isRtl ? /*#__PURE__*/jsx$1(LeftArrowIcon, {}) : /*#__PURE__*/jsx$1(RightArrowIcon, {})
    }))]
  }));
});

const getMeridiem = (date, utils) => {
  if (!date) {
    return null;
  }

  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const convertValueToMeridiem = (value, meridiem, ampm) => {
  if (ampm) {
    const currentMeridiem = value >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      return meridiem === 'am' ? value - 12 : value + 12;
    }
  }

  return value;
};
const convertToMeridiem = (time, meridiem, ampm, utils) => {
  const newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
  return utils.setHours(time, newHoursAmount);
};
const getSecondsInDay = (date, utils) => {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils) => (dateLeft, dateRight) => {
  if (disableIgnoringDatePartForTimeValidation) {
    return utils.isAfter(dateLeft, dateRight);
  }

  return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
};

function useNextMonthDisabled(month, {
  disableFuture,
  maxDate
}) {
  const utils = useUtils();
  return React$d.useMemo(() => {
    const now = utils.date();
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils]);
}
function usePreviousMonthDisabled(month, {
  disablePast,
  minDate
}) {
  const utils = useUtils();
  return React$d.useMemo(() => {
    const now = utils.date();
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils]);
}
function useMeridiemMode(date, ampm, onChange) {
  const utils = useUtils();
  const meridiemMode = getMeridiem(date, utils);
  const handleMeridiemChange = React$d.useCallback(mode => {
    const timeWithMeridiem = convertToMeridiem(date, mode, Boolean(ampm), utils);
    onChange(timeWithMeridiem, 'partial');
  }, [ampm, date, onChange, utils]);
  return {
    meridiemMode,
    handleMeridiemChange
  };
}

const PickersCalendarHeaderRoot = styled$1('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
});
const PickersCalendarHeaderLabel = styled$1('div')(({
  theme
}) => _extends$P({
  display: 'flex',
  maxHeight: 30,
  overflow: 'hidden',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: 'auto'
}, theme.typography.body1, {
  fontWeight: theme.typography.fontWeightMedium
}));
const PickersCalendarHeaderLabelItem = styled$1('div')({
  marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = styled$1(IconButton$2)({
  marginRight: 'auto'
});
const PickersCalendarHeaderSwitchView = styled$1(ArrowDropDown)(({
  theme,
  ownerState
}) => _extends$P({
  willChange: 'transform',
  transition: theme.transitions.create('transform'),
  transform: 'rotate(0deg)'
}, ownerState.openView === 'year' && {
  transform: 'rotate(180deg)'
}));

function getSwitchingViewAriaText(view) {
  return view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view';
}
/**
 * @ignore - do not document.
 */


function PickersCalendarHeader(props) {
  const {
    components = {},
    componentsProps = {},
    currentMonth: month,
    disabled,
    disableFuture,
    disablePast,
    getViewSwitchingButtonText = getSwitchingViewAriaText,
    leftArrowButtonText = 'Previous month',
    maxDate,
    minDate,
    onMonthChange,
    onViewChange,
    openView: currentView,
    reduceAnimations,
    rightArrowButtonText = 'Next month',
    views
  } = props;
  const utils = useUtils();
  const switchViewButtonProps = componentsProps.switchViewButton || {};

  const selectNextMonth = () => onMonthChange(utils.getNextMonth(month), 'left');

  const selectPreviousMonth = () => onMonthChange(utils.getPreviousMonth(month), 'right');

  const isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture: disableFuture || disabled,
    maxDate
  });
  const isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast: disablePast || disabled,
    minDate
  });

  const handleToggleView = () => {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }

    if (views.length === 2) {
      onViewChange(views.find(view => view !== currentView) || views[0]);
    } else {
      // switching only between first 2
      const nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  }; // No need to display more information


  if (views.length === 1 && views[0] === 'year') {
    return null;
  }

  const ownerState = props;
  return /*#__PURE__*/jsxs(PickersCalendarHeaderRoot, {
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxs(PickersCalendarHeaderLabel, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState: ownerState,
      children: [/*#__PURE__*/jsx$1(PickersFadeTransitionGroup, {
        reduceAnimations: reduceAnimations,
        transKey: utils.format(month, 'month'),
        children: /*#__PURE__*/jsx$1(PickersCalendarHeaderLabelItem, {
          "aria-live": "polite",
          ownerState: ownerState,
          children: utils.format(month, 'month')
        })
      }), /*#__PURE__*/jsx$1(PickersFadeTransitionGroup, {
        reduceAnimations: reduceAnimations,
        transKey: utils.format(month, 'year'),
        children: /*#__PURE__*/jsx$1(PickersCalendarHeaderLabelItem, {
          "aria-live": "polite",
          ownerState: ownerState,
          children: utils.format(month, 'year')
        })
      }), views.length > 1 && !disabled && /*#__PURE__*/jsx$1(PickersCalendarHeaderSwitchViewButton, _extends$P({
        size: "small",
        as: components.SwitchViewButton,
        "aria-label": getViewSwitchingButtonText(currentView)
      }, switchViewButtonProps, {
        children: /*#__PURE__*/jsx$1(PickersCalendarHeaderSwitchView, {
          as: components.SwitchViewIcon,
          ownerState: ownerState
        })
      }))]
    }), /*#__PURE__*/jsx$1(MuiFade, {
      in: currentView === 'day',
      children: /*#__PURE__*/jsx$1(PickersArrowSwitcher, {
        leftArrowButtonText: leftArrowButtonText,
        rightArrowButtonText: rightArrowButtonText,
        components: components,
        componentsProps: componentsProps,
        onLeftClick: selectPreviousMonth,
        onRightClick: selectNextMonth,
        isLeftDisabled: isPreviousMonthDisabled,
        isRightDisabled: isNextMonthDisabled
      })
    })]
  });
}

/**
 * TODO consider getting rid from wrapper variant
 * @ignore - internal component.
 */
const WrapperVariantContext = /*#__PURE__*/React$d.createContext(null);

function getPickersYearUtilityClass(slot) {
  return generateUtilityClass('PrivatePickersYear', slot);
}
const pickersYearClasses = generateUtilityClasses('PrivatePickersYear', ['root', 'modeMobile', 'modeDesktop', 'yearButton', 'disabled', 'selected']);

const useUtilityClasses$3 = ownerState => {
  const {
    wrapperVariant,
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', wrapperVariant && `mode${capitalize$3(wrapperVariant)}`],
    yearButton: ['yearButton', disabled && 'disabled', selected && 'selected']
  };
  return composeClasses(slots, getPickersYearUtilityClass, classes);
};

const PickersYearRoot = styled$1('div')(({
  ownerState
}) => _extends$P({
  flexBasis: '33.3%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}, (ownerState == null ? void 0 : ownerState.wrapperVariant) === 'desktop' && {
  flexBasis: '25%'
}));
const PickersYearButton = styled$1('button')(({
  theme
}) => _extends$P({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus, &:hover': {
    backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  [`&.${pickersYearClasses.disabled}`]: {
    color: theme.palette.text.secondary
  },
  [`&.${pickersYearClasses.selected}`]: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
}));
/**
 * @ignore - internal component.
 */

const PickersYear = /*#__PURE__*/React$d.forwardRef(function PickersYear(props, forwardedRef) {
  const {
    autoFocus,
    className,
    children,
    disabled,
    onClick,
    onKeyDown,
    selected,
    value
  } = props;
  const ref = React$d.useRef(null);
  const refHandle = useForkRef(ref, forwardedRef);
  const wrapperVariant = React$d.useContext(WrapperVariantContext);

  const ownerState = _extends$P({}, props, {
    wrapperVariant
  });

  const classes = useUtilityClasses$3(ownerState); // TODO: Can we just forward this to the button?

  React$d.useEffect(() => {
    if (autoFocus) {
      // `ref.current` being `null` would be a bug in MUIu
      ref.current.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/jsx$1(PickersYearRoot, {
    className: clsx(classes.root, className),
    ownerState: ownerState,
    children: /*#__PURE__*/jsx$1(PickersYearButton, {
      ref: refHandle,
      disabled: disabled,
      type: "button",
      tabIndex: selected ? 0 : -1,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      className: classes.yearButton,
      ownerState: ownerState,
      children: children
    })
  });
});

const findClosestEnabledDate = ({
  date,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  shouldDisableDate,
  utils
}) => {
  const today = utils.startOfDay(utils.date());

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  let forward = date;
  let backward = date;

  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  }

  return today;
};
const parsePickerInputValue = (utils, value) => {
  const parsedValue = utils.date(value);
  return utils.isValid(parsedValue) ? parsedValue : null;
};

function getYearPickerUtilityClass(slot) {
  return generateUtilityClass('MuiYearPicker', slot);
}
generateUtilityClasses('MuiYearPicker', ['root']);

const useUtilityClasses$2 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getYearPickerUtilityClass, classes);
};

const YearPickerRoot = styled$1('div', {
  name: 'MuiYearPicker',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflowY: 'auto',
  height: '100%',
  margin: '0 4px'
});
const YearPicker = /*#__PURE__*/React$d.forwardRef(function YearPicker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiYearPicker'
  });
  const {
    autoFocus,
    className,
    date,
    disabled,
    disableFuture,
    disablePast,
    isDateDisabled,
    maxDate,
    minDate,
    onChange,
    onFocusedDayChange,
    onYearChange,
    readOnly,
    shouldDisableYear
  } = props;
  const ownerState = props;
  const classes = useUtilityClasses$2(ownerState);
  const now = useNow();
  const theme = useTheme();
  const utils = useUtils();
  const selectedDate = date || now;
  const currentYear = utils.getYear(selectedDate);
  const wrapperVariant = React$d.useContext(WrapperVariantContext);
  const selectedYearRef = React$d.useRef(null);
  const [focusedYear, setFocusedYear] = React$d.useState(currentYear);

  const handleYearSelection = (event, year, isFinish = 'finish') => {
    if (readOnly) {
      return;
    }

    const submitDate = newDate => {
      onChange(newDate, isFinish);

      if (onFocusedDayChange) {
        onFocusedDayChange(newDate || now);
      }

      if (onYearChange) {
        onYearChange(newDate);
      }
    };

    const newDate = utils.setYear(selectedDate, year);

    if (isDateDisabled(newDate)) {
      const closestEnabledDate = findClosestEnabledDate({
        utils,
        date: newDate,
        minDate,
        maxDate,
        disablePast: Boolean(disablePast),
        disableFuture: Boolean(disableFuture),
        shouldDisableDate: isDateDisabled
      });
      submitDate(closestEnabledDate || now);
    } else {
      submitDate(newDate);
    }
  };

  const focusYear = React$d.useCallback(year => {
    if (!isDateDisabled(utils.setYear(selectedDate, year))) {
      setFocusedYear(year);
    }
  }, [selectedDate, isDateDisabled, utils]);
  const yearsInRow = wrapperVariant === 'desktop' ? 4 : 3;

  const handleKeyDown = (event, year) => {
    switch (event.key) {
      case 'ArrowUp':
        focusYear(year - yearsInRow);
        event.preventDefault();
        break;

      case 'ArrowDown':
        focusYear(year + yearsInRow);
        event.preventDefault();
        break;

      case 'ArrowLeft':
        focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;

      case 'ArrowRight':
        focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;
    }
  };

  return /*#__PURE__*/jsx$1(YearPickerRoot, {
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    children: utils.getYearRange(minDate, maxDate).map(year => {
      const yearNumber = utils.getYear(year);
      const selected = yearNumber === currentYear;
      return /*#__PURE__*/jsx$1(PickersYear, {
        selected: selected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: autoFocus && yearNumber === focusedYear,
        ref: selected ? selectedYearRef : undefined,
        disabled: disabled || disablePast && utils.isBeforeYear(year, now) || disableFuture && utils.isAfterYear(year, now) || shouldDisableYear && shouldDisableYear(year),
        children: utils.format(year, 'year')
      }, utils.format(year, 'year'));
    })
  });
});
process.env.NODE_ENV !== "production" ? YearPicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes$1.bool,
  classes: PropTypes$1.object,
  className: PropTypes$1.string,
  date: PropTypes$1.any,
  disabled: PropTypes$1.bool,
  disableFuture: PropTypes$1.bool,
  disablePast: PropTypes$1.bool,
  isDateDisabled: PropTypes$1.func.isRequired,
  maxDate: PropTypes$1.any.isRequired,
  minDate: PropTypes$1.any.isRequired,
  onChange: PropTypes$1.func.isRequired,
  onFocusedDayChange: PropTypes$1.func,

  /**
   * Callback firing on year change @DateIOType.
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes$1.func,
  readOnly: PropTypes$1.bool,

  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @param {TDate} year The year to test.
   * @returns {boolean} Return `true` if the year should be disabled.
   */
  shouldDisableYear: PropTypes$1.func
} : void 0;

const PickerViewRoot = styled$1('div')({
  overflowX: 'hidden',
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto'
});

const defaultReduceAnimations = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);

const getCalendarPickerUtilityClass = slot => generateUtilityClass('MuiCalendarPicker', slot);
generateUtilityClasses('MuiCalendarPicker', ['root', 'viewTransitionContainer']);

const _excluded$e = ["autoFocus", "onViewChange", "date", "disableFuture", "disablePast", "defaultCalendarMonth", "loading", "maxDate", "minDate", "onChange", "onMonthChange", "reduceAnimations", "renderLoading", "shouldDisableDate", "shouldDisableYear", "view", "views", "openTo", "className"];

const useUtilityClasses$1 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    viewTransitionContainer: ['viewTransitionContainer']
  };
  return composeClasses(slots, getCalendarPickerUtilityClass, classes);
};

const CalendarPickerRoot = styled$1(PickerViewRoot, {
  name: 'MuiCalendarPicker',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column'
});
const CalendarPickerViewTransitionContainer = styled$1(PickersFadeTransitionGroup, {
  name: 'MuiCalendarPicker',
  slot: 'ViewTransitionContainer',
  overridesResolver: (props, styles) => styles.viewTransitionContainer
})({
  overflowY: 'auto'
});

/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [CalendarPicker API](https://mui.com/api/calendar-picker/)
 */
const CalendarPicker = /*#__PURE__*/React$d.forwardRef(function CalendarPicker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiCalendarPicker'
  });

  const {
    autoFocus,
    onViewChange,
    date,
    disableFuture = false,
    disablePast = false,
    defaultCalendarMonth,
    loading = false,
    maxDate: maxDateProp,
    minDate: minDateProp,
    onChange,
    onMonthChange,
    reduceAnimations = defaultReduceAnimations,
    renderLoading = () => /*#__PURE__*/jsx$1("span", {
      children: "..."
    }),
    shouldDisableDate,
    shouldDisableYear,
    view,
    views = ['year', 'day'],
    openTo = 'day',
    className
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$e);

  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
  const maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate;
  const {
    openView,
    setOpenView
  } = useViews({
    view,
    views,
    openTo,
    onChange,
    onViewChange
  });
  const {
    calendarState,
    changeFocusedDay,
    changeMonth,
    isDateDisabled,
    handleChangeMonth,
    onMonthSwitchingAnimationEnd
  } = useCalendarState({
    date,
    defaultCalendarMonth,
    reduceAnimations,
    onMonthChange,
    minDate,
    maxDate,
    shouldDisableDate,
    disablePast,
    disableFuture
  });
  React$d.useEffect(() => {
    if (date && isDateDisabled(date)) {
      const closestEnabledDate = findClosestEnabledDate({
        utils,
        date,
        minDate,
        maxDate,
        disablePast,
        disableFuture,
        shouldDisableDate: isDateDisabled
      });
      onChange(closestEnabledDate, 'partial');
    } // This call is too expensive to run it on each prop change.
    // So just ensure that we are not rendering disabled as selected on mount.

  }, []); // eslint-disable-line

  React$d.useEffect(() => {
    if (date) {
      changeMonth(date);
    }
  }, [date]); // eslint-disable-line

  const ownerState = props;
  const classes = useUtilityClasses$1(ownerState);
  const monthPickerProps = {
    className,
    date,
    disabled: other.disabled,
    disablePast,
    disableFuture,
    onChange,
    minDate,
    maxDate,
    onMonthChange,
    readOnly: other.readOnly
  };
  return /*#__PURE__*/jsxs(CalendarPickerRoot, {
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx$1(PickersCalendarHeader, _extends$P({}, other, {
      views: views,
      openView: openView,
      currentMonth: calendarState.currentMonth,
      onViewChange: setOpenView,
      onMonthChange: (newMonth, direction) => handleChangeMonth({
        newMonth,
        direction
      }),
      minDate: minDate,
      maxDate: maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      reduceAnimations: reduceAnimations
    })), /*#__PURE__*/jsx$1(CalendarPickerViewTransitionContainer, {
      reduceAnimations: reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: openView,
      ownerState: ownerState,
      children: /*#__PURE__*/jsxs("div", {
        children: [openView === 'year' && /*#__PURE__*/jsx$1(YearPicker, _extends$P({}, other, {
          autoFocus: autoFocus,
          date: date,
          onChange: onChange,
          minDate: minDate,
          maxDate: maxDate,
          disableFuture: disableFuture,
          disablePast: disablePast,
          isDateDisabled: isDateDisabled,
          shouldDisableYear: shouldDisableYear,
          onFocusedDayChange: changeFocusedDay
        })), openView === 'month' && /*#__PURE__*/jsx$1(MonthPicker, _extends$P({}, monthPickerProps)), openView === 'day' && /*#__PURE__*/jsx$1(DayPicker, _extends$P({}, other, calendarState, {
          autoFocus: autoFocus,
          onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
          onFocusedDayChange: changeFocusedDay,
          reduceAnimations: reduceAnimations,
          date: date,
          onChange: onChange,
          isDateDisabled: isDateDisabled,
          loading: loading,
          renderLoading: renderLoading
        }))]
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? CalendarPicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,
  classes: PropTypes$1.object,
  className: PropTypes$1.string,

  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.object,

  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes$1.object,
  date: PropTypes$1.any,

  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: PropTypes$1.any,

  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * @default false
   */
  disableFuture: PropTypes$1.bool,

  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes$1.bool,

  /**
   * @default false
   */
  disablePast: PropTypes$1.bool,

  /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   */
  getViewSwitchingButtonText: PropTypes$1.func,

  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: PropTypes$1.string,

  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes$1.bool,

  /**
   * Max selectable date. @DateIOType
   */
  maxDate: PropTypes$1.any,

  /**
   * Min selectable date. @DateIOType
   */
  minDate: PropTypes$1.any,

  /**
   * Callback fired on date change
   */
  onChange: PropTypes$1.func.isRequired,

  /**
   * Callback firing on month change. @DateIOType
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes$1.func,

  /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */
  onViewChange: PropTypes$1.func,

  /**
   * Callback firing on year change @DateIOType.
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes$1.func,

  /**
   * Initially open view.
   * @default 'day'
   */
  openTo: PropTypes$1.oneOf(['day', 'month', 'year']),

  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes$1.bool,

  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: PropTypes$1.bool,

  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDates The dates currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */
  renderDay: PropTypes$1.func,

  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes$1.func,

  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: PropTypes$1.string,

  /**
   * Disable specific date. @DateIOType
   * @param {TDate} day The date to check.
   * @returns {boolean} If `true` the day will be disabled.
   */
  shouldDisableDate: PropTypes$1.func,

  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @param {TDate} year The year to test.
   * @returns {boolean} Return `true` if the year should be disabled.
   */
  shouldDisableYear: PropTypes$1.func,

  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes$1.bool,

  /**
   * Controlled open view.
   */
  view: PropTypes$1.oneOf(['day', 'month', 'year']),

  /**
   * Views for calendar picker.
   * @default ['year', 'day']
   */
  views: PropTypes$1.arrayOf(PropTypes$1.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

const CLOCK_WIDTH = 220;
const CLOCK_HOUR_WIDTH = 36;
const clockCenter = {
  x: CLOCK_WIDTH / 2,
  y: CLOCK_WIDTH / 2
};
const baseClockPoint = {
  x: clockCenter.x,
  y: 0
};
const cx$8 = baseClockPoint.x - clockCenter.x;
const cy = baseClockPoint.y - clockCenter.y;

const rad2deg = rad => rad * (180 / Math.PI);

const getAngleValue = (step, offsetX, offsetY) => {
  const x = offsetX - clockCenter.x;
  const y = offsetY - clockCenter.y;
  const atan = Math.atan2(cx$8, cy) - Math.atan2(x, y);
  let deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  const value = Math.floor(deg / step) || 0;
  const delta = x ** 2 + y ** 2;
  const distance = Math.sqrt(delta);
  return {
    value,
    distance
  };
};

const getMinutes = (offsetX, offsetY, step = 1) => {
  const angleStep = step * 6;
  let {
    value
  } = getAngleValue(angleStep, offsetX, offsetY);
  value = value * step % 60;
  return value;
};
const getHours = (offsetX, offsetY, ampm) => {
  const {
    value,
    distance
  } = getAngleValue(30, offsetX, offsetY);
  let hour = value || 12;

  if (!ampm) {
    if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
      hour += 12;
      hour %= 24;
    }
  } else {
    hour %= 12;
  }

  return hour;
};

const _excluded$d = ["className", "hasSelected", "isInner", "type", "value"];
const ClockPointerRoot = styled$1('div')(({
  theme,
  ownerState
}) => _extends$P({
  width: 2,
  backgroundColor: theme.palette.primary.main,
  position: 'absolute',
  left: 'calc(50% - 1px)',
  bottom: '50%',
  transformOrigin: 'center bottom 0px'
}, ownerState.toAnimateTransform && {
  transition: theme.transitions.create(['transform', 'height'])
}));
const ClockPointerThumb = styled$1('div')(({
  theme,
  ownerState
}) => _extends$P({
  width: 4,
  height: 4,
  backgroundColor: theme.palette.primary.contrastText,
  borderRadius: '50%',
  position: 'absolute',
  top: -21,
  left: `calc(50% - ${CLOCK_HOUR_WIDTH / 2}px)`,
  border: `${(CLOCK_HOUR_WIDTH - 4) / 2}px solid ${theme.palette.primary.main}`,
  boxSizing: 'content-box'
}, ownerState.hasSelected && {
  backgroundColor: theme.palette.primary.main
}));
/**
 * @ignore - internal component.
 * TODO: Remove class
 */

class ClockPointer extends React$d.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };
  }

  render() {
    const _this$props = this.props,
          {
      className,
      isInner,
      type,
      value
    } = _this$props,
          other = _objectWithoutPropertiesLoose$3(_this$props, _excluded$d);

    const ownerState = _extends$P({}, this.props, this.state);

    const getAngleStyle = () => {
      const max = type === 'hours' ? 12 : 60;
      let angle = 360 / max * value;

      if (type === 'hours' && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: Math.round((isInner ? 0.26 : 0.4) * CLOCK_WIDTH),
        transform: `rotateZ(${angle}deg)`
      };
    };

    return /*#__PURE__*/jsx$1(ClockPointerRoot, _extends$P({
      style: getAngleStyle(),
      className: className,
      ownerState: ownerState
    }, other, {
      children: /*#__PURE__*/jsx$1(ClockPointerThumb, {
        ownerState: ownerState
      })
    }));
  }

}

ClockPointer.getDerivedStateFromProps = (nextProps, state) => {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

const ClockRoot = styled$1('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2)
}));
const ClockClock = styled$1('div')({
  backgroundColor: 'rgba(0,0,0,.07)',
  borderRadius: '50%',
  height: 220,
  width: 220,
  flexShrink: 0,
  position: 'relative',
  pointerEvents: 'none'
});
const ClockSquareMask = styled$1('div')({
  width: '100%',
  height: '100%',
  position: 'absolute',
  pointerEvents: 'auto',
  outline: 0,
  // Disable scroll capabilities.
  touchAction: 'none',
  userSelect: 'none',
  '@media (pointer: fine)': {
    cursor: 'pointer',
    borderRadius: '50%'
  },
  '&:active': {
    cursor: 'move'
  }
});
const ClockPin = styled$1('div')(({
  theme
}) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}));
const ClockAmButton = styled$1(IconButton$2)(({
  theme,
  ownerState
}) => _extends$P({
  zIndex: 1,
  position: 'absolute',
  bottom: ownerState.ampmInClock ? 64 : 8,
  left: 8
}, ownerState.meridiemMode === 'am' && {
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.light
  }
}));
const ClockPmButton = styled$1(IconButton$2)(({
  theme,
  ownerState
}) => _extends$P({
  zIndex: 1,
  position: 'absolute',
  bottom: ownerState.ampmInClock ? 64 : 8,
  right: 8
}, ownerState.meridiemMode === 'pm' && {
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.light
  }
}));
/**
 * @ignore - internal component.
 */

function Clock(props) {
  const {
    ampm,
    ampmInClock,
    autoFocus,
    children,
    date,
    getClockLabelText,
    handleMeridiemChange,
    isTimeDisabled,
    meridiemMode,
    minutesStep = 1,
    onChange,
    selectedId,
    type,
    value
  } = props;
  const ownerState = props;
  const utils = useUtils();
  const wrapperVariant = React$d.useContext(WrapperVariantContext);
  const isMoving = React$d.useRef(false);
  const isSelectedTimeDisabled = isTimeDisabled(value, type);
  const isPointerInner = !ampm && type === 'hours' && (value < 1 || value > 12);

  const handleValueChange = (newValue, isFinish) => {
    if (isTimeDisabled(newValue, type)) {
      return;
    }

    onChange(newValue, isFinish);
  };

  const setTime = (event, isFinish) => {
    let {
      offsetX,
      offsetY
    } = event;

    if (offsetX === undefined) {
      const rect = event.target.getBoundingClientRect();
      offsetX = event.changedTouches[0].clientX - rect.left;
      offsetY = event.changedTouches[0].clientY - rect.top;
    }

    const newSelectedValue = type === 'seconds' || type === 'minutes' ? getMinutes(offsetX, offsetY, minutesStep) : getHours(offsetX, offsetY, Boolean(ampm));
    handleValueChange(newSelectedValue, isFinish);
  };

  const handleTouchMove = event => {
    isMoving.current = true;
    setTime(event, 'shallow');
  };

  const handleTouchEnd = event => {
    if (isMoving.current) {
      setTime(event, 'finish');
      isMoving.current = false;
    }
  };

  const handleMouseMove = event => {
    // event.buttons & PRIMARY_MOUSE_BUTTON
    if (event.buttons > 0) {
      setTime(event.nativeEvent, 'shallow');
    }
  };

  const handleMouseUp = event => {
    if (isMoving.current) {
      isMoving.current = false;
    }

    setTime(event.nativeEvent, 'finish');
  };

  const hasSelected = React$d.useMemo(() => {
    if (type === 'hours') {
      return true;
    }

    return value % 5 === 0;
  }, [type, value]);
  const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
  const listboxRef = React$d.useRef(null); // Since this is rendered when a Popper is opened we can't use passive effects.
  // Focusing in passive effects in Popper causes scroll jump.

  useEnhancedEffect$2(() => {
    if (autoFocus) {
      // The ref not being resolved would be a bug in MUI.
      listboxRef.current.focus();
    }
  }, [autoFocus]);

  const handleKeyDown = event => {
    // TODO: Why this early exit?
    if (isMoving.current) {
      return;
    }

    switch (event.key) {
      case 'Home':
        // annulate both hours and minutes
        handleValueChange(0, 'partial');
        event.preventDefault();
        break;

      case 'End':
        handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
        event.preventDefault();
        break;

      case 'ArrowUp':
        handleValueChange(value + keyboardControlStep, 'partial');
        event.preventDefault();
        break;

      case 'ArrowDown':
        handleValueChange(value - keyboardControlStep, 'partial');
        event.preventDefault();
        break;

    }
  };

  return /*#__PURE__*/jsxs(ClockRoot, {
    children: [/*#__PURE__*/jsxs(ClockClock, {
      children: [/*#__PURE__*/jsx$1(ClockSquareMask, {
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        onMouseUp: handleMouseUp,
        onMouseMove: handleMouseMove
      }), !isSelectedTimeDisabled && /*#__PURE__*/jsxs(React$d.Fragment, {
        children: [/*#__PURE__*/jsx$1(ClockPin, {}), date && /*#__PURE__*/jsx$1(ClockPointer, {
          type: type,
          value: value,
          isInner: isPointerInner,
          hasSelected: hasSelected
        })]
      }), /*#__PURE__*/jsx$1("div", {
        "aria-activedescendant": selectedId,
        "aria-label": getClockLabelText(type, date, utils),
        ref: listboxRef,
        role: "listbox",
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        children: children
      })]
    }), ampm && (wrapperVariant === 'desktop' || ampmInClock) && /*#__PURE__*/jsxs(React$d.Fragment, {
      children: [/*#__PURE__*/jsx$1(ClockAmButton, {
        onClick: () => handleMeridiemChange('am'),
        disabled: meridiemMode === null,
        ownerState: ownerState,
        children: /*#__PURE__*/jsx$1(Typography$1, {
          variant: "caption",
          children: "AM"
        })
      }), /*#__PURE__*/jsx$1(ClockPmButton, {
        disabled: meridiemMode === null,
        onClick: () => handleMeridiemChange('pm'),
        ownerState: ownerState,
        children: /*#__PURE__*/jsx$1(Typography$1, {
          variant: "caption",
          children: "PM"
        })
      })]
    })]
  });
}

const _excluded$c = ["className", "disabled", "index", "inner", "label", "selected"];
const classes$5 = generateUtilityClasses('PrivateClockNumber', ['selected', 'disabled']);
const ClockNumberRoot = styled$1('span')(({
  theme,
  ownerState
}) => _extends$P({
  height: CLOCK_HOUR_WIDTH,
  width: CLOCK_HOUR_WIDTH,
  position: 'absolute',
  left: `calc((100% - ${CLOCK_HOUR_WIDTH}px) / 2)`,
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  '&:focused': {
    backgroundColor: theme.palette.background.paper
  },
  [`&.${classes$5.selected}`]: {
    color: theme.palette.primary.contrastText
  },
  [`&.${classes$5.disabled}`]: {
    pointerEvents: 'none',
    color: theme.palette.text.disabled
  }
}, ownerState.inner && _extends$P({}, theme.typography.body2, {
  color: theme.palette.text.secondary
})));
/**
 * @ignore - internal component.
 */

function ClockNumber(props) {
  const {
    className,
    disabled,
    index,
    inner,
    label,
    selected
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$c);

  const ownerState = props;
  const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
  const length = (CLOCK_WIDTH - CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
  const x = Math.round(Math.cos(angle) * length);
  const y = Math.round(Math.sin(angle) * length);
  return /*#__PURE__*/jsx$1(ClockNumberRoot, _extends$P({
    className: clsx(className, selected && classes$5.selected, disabled && classes$5.disabled),
    "aria-disabled": disabled ? true : undefined,
    "aria-selected": selected ? true : undefined,
    role: "option",
    style: {
      transform: `translate(${x}px, ${y + (CLOCK_WIDTH - CLOCK_HOUR_WIDTH) / 2}px`
    },
    ownerState: ownerState
  }, other, {
    children: label
  }));
}

/**
 * @ignore - internal component.
 */
const getHourNumbers = ({
  ampm,
  date,
  getClockNumberText,
  isDisabled,
  selectedId,
  utils
}) => {
  const currentHours = date ? utils.getHours(date) : null;
  const hourNumbers = [];
  const startHour = ampm ? 1 : 0;
  const endHour = ampm ? 12 : 23;

  const isSelected = hour => {
    if (currentHours === null) {
      return false;
    }

    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (let hour = startHour; hour <= endHour; hour += 1) {
    let label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    const inner = !ampm && (hour === 0 || hour > 12);
    label = utils.formatNumber(label);
    const selected = isSelected(hour);
    hourNumbers.push( /*#__PURE__*/jsx$1(ClockNumber, {
      id: selected ? selectedId : undefined,
      index: hour,
      inner: inner,
      selected: selected,
      disabled: isDisabled(hour),
      label: label,
      "aria-label": getClockNumberText(label)
    }, hour));
  }

  return hourNumbers;
};
const getMinutesNumbers = ({
  utils,
  value,
  isDisabled,
  getClockNumberText,
  selectedId
}) => {
  const f = utils.formatNumber;
  return [[5, f('05')], [10, f('10')], [15, f('15')], [20, f('20')], [25, f('25')], [30, f('30')], [35, f('35')], [40, f('40')], [45, f('45')], [50, f('50')], [55, f('55')], [0, f('00')]].map(([numberValue, label], index) => {
    const selected = numberValue === value;
    return /*#__PURE__*/jsx$1(ClockNumber, {
      label: label,
      id: selected ? selectedId : undefined,
      index: index + 1,
      inner: false,
      disabled: isDisabled(numberValue),
      selected: selected,
      "aria-label": getClockNumberText(label)
    }, numberValue);
  });
};

function getClockPickerUtilityClass(slot) {
  return generateUtilityClass('MuiClockPicker', slot);
}
generateUtilityClasses('MuiClockPicker', ['root', 'arrowSwitcher']);

const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    arrowSwitcher: ['arrowSwitcher']
  };
  return composeClasses(slots, getClockPickerUtilityClass, classes);
};

const ClockPickerRoot = styled$1(PickerViewRoot, {
  name: 'MuiClockPicker',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column'
});
const ClockPickerArrowSwitcher = styled$1(PickersArrowSwitcher, {
  name: 'MuiClockPicker',
  slot: 'ArrowSwitcher',
  overridesResolver: (props, styles) => styles.arrowSwitcher
})({
  position: 'absolute',
  right: 12,
  top: 15
});

const defaultGetClockLabelText = (view, time, adapter) => `Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`;

const defaultGetMinutesClockNumberText = minutes => `${minutes} minutes`;

const defaultGetHoursClockNumberText = hours => `${hours} hours`;

const defaultGetSecondsClockNumberText = seconds => `${seconds} seconds`;

/**
 *
 * API:
 *
 * - [ClockPicker API](https://mui.com/api/clock-picker/)
 */
const ClockPicker = /*#__PURE__*/React$d.forwardRef(function ClockPicker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiClockPicker'
  });
  const {
    ampm = false,
    ampmInClock = false,
    autoFocus,
    components,
    componentsProps,
    date,
    disableIgnoringDatePartForTimeValidation = false,
    getClockLabelText = defaultGetClockLabelText,
    getHoursClockNumberText = defaultGetHoursClockNumberText,
    getMinutesClockNumberText = defaultGetMinutesClockNumberText,
    getSecondsClockNumberText = defaultGetSecondsClockNumberText,
    leftArrowButtonText = 'open previous view',
    maxTime,
    minTime,
    minutesStep = 1,
    rightArrowButtonText = 'open next view',
    shouldDisableTime,
    showViewSwitcher,
    onChange,
    view,
    views = ['hours', 'minutes'],
    openTo,
    onViewChange,
    className
  } = props;
  const {
    openView,
    setOpenView,
    nextView,
    previousView,
    handleChangeAndOpenNext
  } = useViews({
    view,
    views,
    openTo,
    onViewChange,
    onChange
  });
  const now = useNow();
  const utils = useUtils();
  const midnight = utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0);
  const dateOrMidnight = date || midnight;
  const {
    meridiemMode,
    handleMeridiemChange
  } = useMeridiemMode(dateOrMidnight, ampm, handleChangeAndOpenNext);
  const isTimeDisabled = React$d.useCallback((rawValue, viewType) => {
    if (date === null) {
      return false;
    }

    const validateTimeValue = getRequestedTimePoint => {
      const isAfterComparingFn = createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils);
      return Boolean(minTime && isAfterComparingFn(minTime, getRequestedTimePoint('end')) || maxTime && isAfterComparingFn(getRequestedTimePoint('start'), maxTime) || shouldDisableTime && shouldDisableTime(rawValue, viewType));
    };

    switch (viewType) {
      case 'hours':
        {
          const hoursWithMeridiem = convertValueToMeridiem(rawValue, meridiemMode, ampm);
          return validateTimeValue(when => pipe(currentDate => utils.setHours(currentDate, hoursWithMeridiem), dateWithHours => utils.setMinutes(dateWithHours, when === 'start' ? 0 : 59), dateWithMinutes => utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59))(date));
        }

      case 'minutes':
        return validateTimeValue(when => pipe(currentDate => utils.setMinutes(currentDate, rawValue), dateWithMinutes => utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59))(date));

      case 'seconds':
        return validateTimeValue(() => utils.setSeconds(date, rawValue));

      default:
        throw new Error('not supported');
    }
  }, [ampm, date, disableIgnoringDatePartForTimeValidation, maxTime, meridiemMode, minTime, shouldDisableTime, utils]);
  const selectedId = useId();
  const viewProps = React$d.useMemo(() => {
    switch (openView) {
      case 'hours':
        {
          const handleHoursChange = (value, isFinish) => {
            const valueWithMeridiem = convertValueToMeridiem(value, meridiemMode, ampm);
            handleChangeAndOpenNext(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
          };

          return {
            onChange: handleHoursChange,
            value: utils.getHours(dateOrMidnight),
            children: getHourNumbers({
              date,
              utils,
              ampm,
              onChange: handleHoursChange,
              getClockNumberText: getHoursClockNumberText,
              isDisabled: value => isTimeDisabled(value, 'hours'),
              selectedId
            })
          };
        }

      case 'minutes':
        {
          const minutesValue = utils.getMinutes(dateOrMidnight);

          const handleMinutesChange = (value, isFinish) => {
            handleChangeAndOpenNext(utils.setMinutes(dateOrMidnight, value), isFinish);
          };

          return {
            value: minutesValue,
            onChange: handleMinutesChange,
            children: getMinutesNumbers({
              utils,
              value: minutesValue,
              onChange: handleMinutesChange,
              getClockNumberText: getMinutesClockNumberText,
              isDisabled: value => isTimeDisabled(value, 'minutes'),
              selectedId
            })
          };
        }

      case 'seconds':
        {
          const secondsValue = utils.getSeconds(dateOrMidnight);

          const handleSecondsChange = (value, isFinish) => {
            handleChangeAndOpenNext(utils.setSeconds(dateOrMidnight, value), isFinish);
          };

          return {
            value: secondsValue,
            onChange: handleSecondsChange,
            children: getMinutesNumbers({
              utils,
              value: secondsValue,
              onChange: handleSecondsChange,
              getClockNumberText: getSecondsClockNumberText,
              isDisabled: value => isTimeDisabled(value, 'seconds'),
              selectedId
            })
          };
        }

      default:
        throw new Error('You must provide the type for ClockView');
    }
  }, [openView, utils, date, ampm, getHoursClockNumberText, getMinutesClockNumberText, getSecondsClockNumberText, meridiemMode, handleChangeAndOpenNext, dateOrMidnight, isTimeDisabled, selectedId]);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/jsxs(ClockPickerRoot, {
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    children: [showViewSwitcher && /*#__PURE__*/jsx$1(ClockPickerArrowSwitcher, {
      className: classes.arrowSwitcher,
      leftArrowButtonText: leftArrowButtonText,
      rightArrowButtonText: rightArrowButtonText,
      components: components,
      componentsProps: componentsProps,
      onLeftClick: () => setOpenView(previousView),
      onRightClick: () => setOpenView(nextView),
      isLeftDisabled: !previousView,
      isRightDisabled: !nextView,
      ownerState: ownerState
    }), /*#__PURE__*/jsx$1(Clock, _extends$P({
      autoFocus: autoFocus,
      date: date,
      ampmInClock: ampmInClock,
      type: openView,
      ampm: ampm,
      getClockLabelText: getClockLabelText,
      minutesStep: minutesStep,
      isTimeDisabled: isTimeDisabled,
      meridiemMode: meridiemMode,
      handleMeridiemChange: handleMeridiemChange,
      selectedId: selectedId
    }, viewProps))]
  });
});
process.env.NODE_ENV !== "production" ? ClockPicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * 12h/24h view for hour selection clock.
   * @default false
   */
  ampm: PropTypes$1.bool,

  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: PropTypes$1.bool,

  /**
   * Set to `true` if focus should be moved to clock picker.
   */
  autoFocus: PropTypes$1.bool,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  className: PropTypes$1.string,

  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   */
  components: PropTypes$1.object,

  /**
   * The props used for each slot inside.
   */
  componentsProps: PropTypes$1.object,

  /**
   * Selected date @DateIOType.
   */
  date: PropTypes$1.any,

  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes$1.bool,

  /**
   * Accessible text that helps user to understand which time and view is selected.
   * @param {ClockPickerView} view The current view rendered.
   * @param {TDate | null} time The current time.
   * @param {MuiPickersAdapter<TDate>} adapter The current date adapter.
   * @returns {string} The clock label.
   * @default <TDate extends any>(
   *   view: ClockView,
   *   time: TDate | null,
   *   adapter: MuiPickersAdapter<TDate>,
   * ) =>
   *   `Select ${view}. ${
   *     time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`
   *   }`
   */
  getClockLabelText: PropTypes$1.func,

  /**
   * Get clock number aria-text for hours.
   * @param {string} hours The hours to format.
   * @returns {string} the formatted hours text.
   * @default (hours: string) => `${hours} hours`
   */
  getHoursClockNumberText: PropTypes$1.func,

  /**
   * Get clock number aria-text for minutes.
   * @param {string} minutes The minutes to format.
   * @returns {string} the formatted minutes text.
   * @default (minutes: string) => `${minutes} minutes`
   */
  getMinutesClockNumberText: PropTypes$1.func,

  /**
   * Get clock number aria-text for seconds.
   * @param {string} seconds The seconds to format.
   * @returns {string} the formatted seconds text.
   * @default (seconds: string) => `${seconds} seconds`
   */
  getSecondsClockNumberText: PropTypes$1.func,

  /**
   * Left arrow icon aria-label text.
   * @default 'open previous view'
   */
  leftArrowButtonText: PropTypes$1.string,

  /**
   * Max time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */
  maxTime: PropTypes$1.any,

  /**
   * Min time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */
  minTime: PropTypes$1.any,

  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes$1.number,

  /**
   * On change callback @DateIOType.
   */
  onChange: PropTypes$1.func.isRequired,

  /**
   * Callback fired on view change.
   * @param {ClockPickerView} view The new view.
   */
  onViewChange: PropTypes$1.func,

  /**
   * Initially open view.
   * @default 'hours'
   */
  openTo: PropTypes$1.oneOf(['hours', 'minutes', 'seconds']),

  /**
   * Right arrow icon aria-label text.
   * @default 'open next view'
   */
  rightArrowButtonText: PropTypes$1.string,

  /**
   * Dynamically check if time is disabled or not.
   * If returns `false` appropriate time point will ot be acceptable.
   * @param {number} timeValue The value to check.
   * @param {ClockPickerView} clockType The clock type of the timeValue.
   * @returns {boolean} Returns `true` if the time should be disabled
   */
  shouldDisableTime: PropTypes$1.func,
  showViewSwitcher: PropTypes$1.bool,

  /**
   * Controlled open view.
   */
  view: PropTypes$1.oneOf(['hours', 'minutes', 'seconds']),

  /**
   * Views for calendar picker.
   * @default ['hours', 'minutes']
   */
  views: PropTypes$1.arrayOf(PropTypes$1.oneOf(['hours', 'minutes', 'seconds']).isRequired)
} : void 0;

const _excluded$b = ["openTo", "views", "minDate", "maxDate"];
const isYearOnlyView = views => views.length === 1 && views[0] === 'year';
const isYearAndMonthViews = views => views.length === 2 && views.indexOf('month') !== -1 && views.indexOf('year') !== -1;

const getFormatAndMaskByViews = (views, utils) => {
  if (isYearOnlyView(views)) {
    return {
      mask: '____',
      inputFormat: utils.formats.year
    };
  }

  if (isYearAndMonthViews(views)) {
    return {
      disableMaskedInput: true,
      inputFormat: utils.formats.monthAndYear
    };
  }

  return {
    mask: '__/__/____',
    inputFormat: utils.formats.keyboardDate
  };
};

function useDatePickerDefaultizedProps(_ref, name) {
  let {
    openTo = 'day',
    views = ['year', 'day'],
    minDate: minDateProp,
    maxDate: maxDateProp
  } = _ref,
      other = _objectWithoutPropertiesLoose$3(_ref, _excluded$b);

  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
  const maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate; // This is technically unsound if the type parameters appear in optional props.
  // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.

  return useThemeProps({
    props: _extends$P({
      views,
      openTo,
      minDate,
      maxDate
    }, getFormatAndMaskByViews(views, utils), other),
    name
  });
}

const classes$4 = generateUtilityClasses('PrivatePickersToolbar', ['root', 'dateTitleContainer']);
const PickersToolbarRoot = styled$1('div')(({
  theme,
  ownerState
}) => _extends$P({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3)
}, ownerState.isLandscape && {
  height: 'auto',
  maxWidth: 160,
  padding: 16,
  justifyContent: 'flex-start',
  flexWrap: 'wrap'
}));
const PickersToolbarGrid = styled$1(Grid$2)({
  flex: 1
});

const getViewTypeIcon = viewType => viewType === 'clock' ? /*#__PURE__*/jsx$1(Clock$1, {
  color: "inherit"
}) : /*#__PURE__*/jsx$1(Calendar, {
  color: "inherit"
});

function defaultGetKeyboardInputSwitchingButtonText(isKeyboardInputOpen, viewType) {
  return isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`;
}

const PickersToolbar = /*#__PURE__*/React$d.forwardRef(function PickersToolbar(props, ref) {
  const {
    children,
    className,
    getMobileKeyboardInputViewButtonText = defaultGetKeyboardInputSwitchingButtonText,
    isLandscape,
    isMobileKeyboardViewOpen,
    landscapeDirection = 'column',
    penIconClassName,
    toggleMobileKeyboardView,
    toolbarTitle,
    viewType = 'calendar'
  } = props;
  const ownerState = props;
  return /*#__PURE__*/jsxs(PickersToolbarRoot, {
    ref: ref,
    className: clsx(classes$4.root, className),
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx$1(Typography$1, {
      color: "text.secondary",
      variant: "overline",
      children: toolbarTitle
    }), /*#__PURE__*/jsxs(PickersToolbarGrid, {
      container: true,
      justifyContent: "space-between",
      className: classes$4.dateTitleContainer,
      direction: isLandscape ? landscapeDirection : 'row',
      alignItems: isLandscape ? 'flex-start' : 'flex-end',
      children: [children, /*#__PURE__*/jsx$1(IconButton$2, {
        onClick: toggleMobileKeyboardView,
        className: penIconClassName,
        color: "inherit",
        "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType),
        children: isMobileKeyboardViewOpen ? getViewTypeIcon(viewType) : /*#__PURE__*/jsx$1(Pen, {
          color: "inherit"
        })
      })]
    })]
  });
});

const _excluded$a = ["date", "isLandscape", "isMobileKeyboardViewOpen", "onChange", "toggleMobileKeyboardView", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
const classes$3 = generateUtilityClasses('PrivateDatePickerToolbar', ['penIcon']);
const DatePickerToolbarRoot = styled$1(PickersToolbar)({
  [`& .${classes$3.penIcon}`]: {
    position: 'relative',
    top: 4
  }
});
const DatePickerToolbarTitle = styled$1(Typography$1)(({
  ownerState
}) => _extends$P({}, ownerState.isLandscape && {
  margin: 'auto 16px auto auto'
}));

/**
 * @ignore - internal component.
 */
const DatePickerToolbar = /*#__PURE__*/React$d.forwardRef(function DatePickerToolbar(props, ref) {
  const {
    date,
    isLandscape,
    isMobileKeyboardViewOpen,
    toggleMobileKeyboardView,
    toolbarFormat,
    toolbarPlaceholder = '––',
    toolbarTitle = 'Select date',
    views
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$a);

  const utils = useUtils();
  const dateText = React$d.useMemo(() => {
    if (!date) {
      return toolbarPlaceholder;
    }

    if (toolbarFormat) {
      return utils.formatByString(date, toolbarFormat);
    }

    if (isYearOnlyView(views)) {
      return utils.format(date, 'year');
    }

    if (isYearAndMonthViews(views)) {
      return utils.format(date, 'month');
    } // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.


    return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(date, 'normalDateWithWeekday') : utils.format(date, 'normalDate');
  }, [date, toolbarFormat, toolbarPlaceholder, utils, views]);
  const ownerState = props;
  return /*#__PURE__*/jsx$1(DatePickerToolbarRoot, _extends$P({
    ref: ref,
    toolbarTitle: toolbarTitle,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    isLandscape: isLandscape,
    penIconClassName: classes$3.penIcon,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsx$1(DatePickerToolbarTitle, {
      variant: "h4",
      align: isLandscape ? 'left' : 'center',
      ownerState: ownerState,
      children: dateText
    })
  }));
});

const _excluded$9 = ["onClick", "onTouchStart"];
const PickersPopperRoot = styled$1(Popper$1)(({
  theme
}) => ({
  zIndex: theme.zIndex.modal
}));
const PickersPopperPaper = styled$1(Paper$2)(({
  ownerState
}) => _extends$P({
  transformOrigin: 'top center',
  outline: 0
}, ownerState.placement === 'top' && {
  transformOrigin: 'bottom center'
}));
const PickersPopperAction = styled$1(DialogActions$1)(({
  ownerState
}) => _extends$P({}, ownerState.clearable ? {
  justifyContent: 'flex-start',
  '& > *:first-of-type': {
    marginRight: 'auto'
  }
} : {
  padding: 0
}));

function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}

/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */
function useClickAwayListener(active, onClickAway) {
  const movedRef = React$d.useRef(false);
  const syntheticEventRef = React$d.useRef(false);
  const nodeRef = React$d.useRef(null);
  const activatedRef = React$d.useRef(false);
  React$d.useEffect(() => {
    if (!active) {
      return undefined;
    } // Ensure that this hook is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074


    function armClickAwayListener() {
      activatedRef.current = true;
    }

    document.addEventListener('mousedown', armClickAwayListener, true);
    document.addEventListener('touchstart', armClickAwayListener, true);
    return () => {
      document.removeEventListener('mousedown', armClickAwayListener, true);
      document.removeEventListener('touchstart', armClickAwayListener, true);
      activatedRef.current = false;
    };
  }, [active]); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  const handleClickAway = useEventCallback$1(event => {
    if (!activatedRef.current) {
      return;
    } // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.


    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!nodeRef.current || // is a TouchEvent?
    'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && !insideReactTree) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  const handleSynthetic = () => {
    syntheticEventRef.current = true;
  };

  React$d.useEffect(() => {
    if (active) {
      const doc = ownerDocument(nodeRef.current);

      const handleTouchMove = () => {
        movedRef.current = true;
      };

      doc.addEventListener('touchstart', handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener('touchstart', handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [active, handleClickAway]);
  React$d.useEffect(() => {
    // TODO This behavior is not tested automatically
    // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
    // Or if this is a timing related issues due to different Transition components
    // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
    if (active) {
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener('click', handleClickAway);
      return () => {
        doc.removeEventListener('click', handleClickAway); // cleanup `handleClickAway`

        syntheticEventRef.current = false;
      };
    }

    return undefined;
  }, [active, handleClickAway]);
  return [nodeRef, handleSynthetic, handleSynthetic];
}

const PickersPopper = props => {
  const {
    anchorEl,
    children,
    containerRef = null,
    onClose,
    onClear,
    clearable = false,
    clearText = 'Clear',
    open,
    PopperProps,
    role,
    TransitionComponent = Grow$1,
    TrapFocusProps,
    PaperProps = {}
  } = props;
  React$d.useEffect(() => {
    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        onClose();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);
  const lastFocusedElementRef = React$d.useRef(null);
  React$d.useEffect(() => {
    if (role === 'tooltip') {
      return;
    }

    if (open) {
      lastFocusedElementRef.current = document.activeElement;
    } else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) {
      lastFocusedElementRef.current.focus();
    }
  }, [open, role]);
  const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, onClose);
  const paperRef = React$d.useRef(null);
  const handleRef = useForkRef(paperRef, containerRef);
  const handlePaperRef = useForkRef(handleRef, clickAwayRef);
  const ownerState = props;

  const {
    onClick: onPaperClickProp,
    onTouchStart: onPaperTouchStartProp
  } = PaperProps,
        otherPaperProps = _objectWithoutPropertiesLoose$3(PaperProps, _excluded$9);

  return /*#__PURE__*/jsx$1(PickersPopperRoot, _extends$P({
    transition: true,
    role: role,
    open: open,
    anchorEl: anchorEl,
    ownerState: ownerState
  }, PopperProps, {
    children: ({
      TransitionProps,
      placement
    }) => /*#__PURE__*/jsx$1(TrapFocus, _extends$P({
      open: open,
      disableAutoFocus: true,
      disableEnforceFocus: role === 'tooltip',
      isEnabled: () => true
    }, TrapFocusProps, {
      children: /*#__PURE__*/jsx$1(TransitionComponent, _extends$P({}, TransitionProps, {
        children: /*#__PURE__*/jsxs(PickersPopperPaper, _extends$P({
          tabIndex: -1,
          elevation: 8,
          ref: handlePaperRef,
          onClick: event => {
            onPaperClick(event);

            if (onPaperClickProp) {
              onPaperClickProp(event);
            }
          },
          onTouchStart: event => {
            onPaperTouchStart(event);

            if (onPaperTouchStartProp) {
              onPaperTouchStartProp(event);
            }
          },
          ownerState: _extends$P({}, ownerState, {
            placement
          })
        }, otherPaperProps, {
          children: [children, /*#__PURE__*/jsx$1(PickersPopperAction, {
            ownerState: ownerState,
            children: clearable && /*#__PURE__*/jsx$1(Button$3, {
              onClick: onClear,
              children: clearText
            })
          })]
        }))
      }))
    }))
  }));
};

function DesktopWrapper(props) {
  const {
    children,
    DateInputProps,
    KeyboardDateInputComponent,
    onDismiss,
    open,
    PopperProps,
    PaperProps,
    TransitionComponent,
    onClear,
    clearText,
    clearable
  } = props;
  const ownInputRef = React$d.useRef(null);
  const inputRef = useForkRef(DateInputProps.inputRef, ownInputRef);
  return /*#__PURE__*/jsxs(WrapperVariantContext.Provider, {
    value: "desktop",
    children: [/*#__PURE__*/jsx$1(KeyboardDateInputComponent, _extends$P({}, DateInputProps, {
      inputRef: inputRef
    })), /*#__PURE__*/jsx$1(PickersPopper, {
      role: "dialog",
      open: open,
      anchorEl: ownInputRef.current,
      TransitionComponent: TransitionComponent,
      PopperProps: PopperProps,
      PaperProps: PaperProps,
      onClose: onDismiss,
      onClear: onClear,
      clearText: clearText,
      clearable: clearable,
      children: children
    })]
  });
}

const useRifm = props => {
  const [, refresh] = useReducer(c => c + 1, 0);
  const valueRef = useRef(null);
  const {
    replace,
    append
  } = props;
  const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support

  const isDeleleteButtonDownRef = useRef(false);

  const onChange = evt => {
    if (process.env.NODE_ENV !== 'production') {
      if (evt.target.type === 'number') {
        console.error('Rifm does not support input type=number, use type=tel instead.');
        return;
      }

      if (evt.target.type === 'date') {
        console.error('Rifm does not support input type=date.');
        return;
      }
    }

    const eventValue = evt.target.value;
    valueRef.current = [eventValue, // eventValue
    evt.target, // input
    eventValue.length > userValue.length, // isSizeIncreaseOperation
    isDeleleteButtonDownRef.current, // isDeleleteButtonDown
    userValue === props.format(eventValue) // isNoOperation
    ];

    if (process.env.NODE_ENV !== 'production') {
      const formattedEventValue = props.format(eventValue);

      if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) {
        console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
      }
    } // The main trick is to update underlying input with non formatted value (= eventValue)
    // that allows us to calculate right cursor position after formatting (see getCursorPosition)
    // then we format new value and call props.onChange with masked/formatted value
    // and finally we are able to set cursor position into right place


    refresh();
  }; // React prints warn on server in non production mode about useLayoutEffect usage
  // in both cases it's noop


  if (process.env.NODE_ENV === 'production' || typeof window !== 'undefined') {
    useLayoutEffect(() => {
      if (valueRef.current == null) return;
      let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
      isNoOperation] = valueRef.current;
      valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
      // in case of isDeleleteButtonDown cursor should move differently vs backspace

      const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
      const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
      const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
      const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols

      const clean = str => (str.match(props.accept || /\d/g) || []).join('');

      const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
      // This works because we assume that format doesn't change the order of accepted symbols.
      // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
      // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
      // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
      // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
      // so for formatting just this function to determine cursor position after formatting is enough
      // with masking we need to do some additional checks see `mask` below

      const getCursorPosition = val => {
        let start = 0;
        let cleanPos = 0;

        for (let i = 0; i !== valueBeforeSelectionStart.length; ++i) {
          let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
          let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
          // For example fixes edge case with fixed point numbers:
          // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
          // that order of accepted symbols is not changed after format,
          // so here we don't update start position if other accepted symbols was inbetween current and new position

          if (newCleanPos - cleanPos > 1) {
            newPos = start;
            newCleanPos = cleanPos;
          }

          cleanPos = Math.max(newCleanPos, cleanPos);
          start = Math.max(start, newPos);
        }

        return start;
      }; // Masking part, for masks if size of mask is above some value
      // we need to replace symbols instead of do nothing as like in format


      if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
        let start = getCursorPosition(eventValue);
        const c = clean(eventValue.substr(start))[0];
        start = eventValue.indexOf(c, start);
        eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
      }

      let formattedValue = props.format(eventValue);

      if (append != null && // cursor at the end
      input.selectionStart === eventValue.length && !isNoOperation) {
        if (isSizeIncreaseOperation) {
          formattedValue = append(formattedValue);
        } else {
          // If after delete last char is special character and we use append
          // delete it too
          // was: "12-3|" backspace pressed, then should be "12|"
          if (clean(formattedValue.slice(-1)) === '') {
            formattedValue = formattedValue.slice(0, -1);
          }
        }
      }

      const replacedValue = replace ? replace(formattedValue) : formattedValue;

      if (userValue === replacedValue) {
        // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
      } else {
        props.onChange(replacedValue);
      }

      return () => {
        let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
        // like cursor jumping over refused symbols
        // as an example date mask: was "5|1-24-3" then user pressed "6"
        // it becomes "56-|12-43" with this code, and "56|-12-43" without

        if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) {
          while (formattedValue[start] && clean(formattedValue[start]) === '') {
            start += 1;
          }
        }

        input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
      };
    });
  }

  useEffect(() => {
    // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
    // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
    // there is no way I found to distinguish in onChange
    // backspace or delete was called in some situations
    // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
    const handleKeyDown = evt => {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = true;
      }
    };

    const handleKeyUp = evt => {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = false;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  return {
    value: valueRef.current != null ? valueRef.current[0] : userValue,
    onChange
  };
};

function getTextFieldAriaText(rawValue, utils) {
  // TODO: should `isValid` narrow `TDate | null` to `NonNullable<TDate>`?
  // Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
  // Or we ensure `formatByString` is callable with `null`.
  return rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), 'fullDate')}` : 'Choose date';
}
const getDisplayDate = (utils, value, inputFormat) => {
  const date = utils.date(value);
  const isEmpty = value === null;

  if (isEmpty) {
    return '';
  }

  return utils.isValid(date) ? utils.formatByString( // TODO: should `isValid` narrow `TDate | null` to `NonNullable<TDate>`?
  // Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
  // Or we ensure `formatByString` is callable with `null`.
  date, inputFormat) : '';
};
const MASK_USER_INPUT_SYMBOL = '_';
const staticDateWith2DigitTokens = '2019-11-21T22:30:00.000';
const staticDateWith1DigitTokens = '2019-01-01T09:00:00.000';
function checkMaskIsValidForCurrentFormat(mask, format, acceptRegex, utils) {
  const formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
  const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
  const inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
  const isMaskValid = inferredFormatPatternWith2Digits === mask && inferredFormatPatternWith1Digits === mask;

  if (!isMaskValid && utils.lib !== 'luxon' && process.env.NODE_ENV !== 'production') {
    console.warn(`The mask "${mask}" you passed is not valid for the format used ${format}. Falling down to uncontrolled not-masked input.`);
  }

  return isMaskValid;
}
const maskedDateFormatter = (mask, acceptRegexp) => value => {
  return value.split('').map((char, i) => {
    acceptRegexp.lastIndex = 0;

    if (i > mask.length - 1) {
      return '';
    }

    const maskChar = mask[i];
    const nextMaskChar = mask[i + 1];
    const acceptedChar = acceptRegexp.test(char) ? char : '';
    const formattedChar = maskChar === MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;

    if (i === value.length - 1 && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL) {
      // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
      return formattedChar ? formattedChar + nextMaskChar : '';
    }

    return formattedChar;
  }).join('');
};

const useMaskedInput = ({
  acceptRegex = /[\d]/gi,
  disabled,
  disableMaskedInput,
  ignoreInvalidInputs,
  inputFormat,
  inputProps,
  label,
  mask,
  onChange,
  rawValue,
  readOnly,
  rifmFormatter,
  TextFieldProps,
  validationError
}) => {
  const utils = useUtils();
  const [isFocused, setIsFocused] = React$d.useState(false);
  const formatHelperText = utils.getFormatHelperText(inputFormat);
  const shouldUseMaskedInput = React$d.useMemo(() => {
    // formatting of dates is a quite slow thing, so do not make useless .format calls
    if (!mask || disableMaskedInput) {
      return false;
    }

    return checkMaskIsValidForCurrentFormat(mask, inputFormat, acceptRegex, utils);
  }, [acceptRegex, disableMaskedInput, inputFormat, mask, utils]);
  const formatter = React$d.useMemo(() => shouldUseMaskedInput && mask ? maskedDateFormatter(mask, acceptRegex) : st => st, [acceptRegex, mask, shouldUseMaskedInput]); // TODO: Implement with controlled vs uncontrolled `rawValue`

  const currentInputValue = getDisplayDate(utils, rawValue, inputFormat);
  const [innerInputValue, setInnerInputValue] = React$d.useState(currentInputValue);
  const previousInputValueRef = React$d.useRef(currentInputValue);
  React$d.useEffect(() => {
    previousInputValueRef.current = currentInputValue;
  }, [currentInputValue]);
  const notTyping = !isFocused;
  const valueChanged = previousInputValueRef.current !== currentInputValue; // Update the input value only if the value changed outside of typing

  if (notTyping && valueChanged && (rawValue === null || utils.isValid(rawValue))) {
    if (currentInputValue !== innerInputValue) {
      setInnerInputValue(currentInputValue);
    }
  }

  const handleChange = text => {
    const finalString = text === '' || text === mask ? '' : text;
    setInnerInputValue(finalString);
    const date = finalString === null ? null : utils.parse(finalString, inputFormat);

    if (ignoreInvalidInputs && !utils.isValid(date)) {
      return;
    }

    onChange(date, finalString || undefined);
  };

  const rifmProps = useRifm({
    value: innerInputValue,
    onChange: handleChange,
    format: rifmFormatter || formatter
  });
  const inputStateArgs = shouldUseMaskedInput ? rifmProps : {
    value: innerInputValue,
    onChange: event => {
      handleChange(event.currentTarget.value);
    }
  };
  return _extends$P({
    label,
    disabled,
    error: validationError,
    inputProps: _extends$P({}, inputStateArgs, {
      disabled,
      placeholder: formatHelperText,
      readOnly,
      type: shouldUseMaskedInput ? 'tel' : 'text'
    }, inputProps, {
      onFocus: createDelegatedEventHandler(() => {
        setIsFocused(true);
      }, inputProps == null ? void 0 : inputProps.onFocus),
      onBlur: createDelegatedEventHandler(() => {
        setIsFocused(false);
      }, inputProps == null ? void 0 : inputProps.onBlur)
    })
  }, TextFieldProps);
};

const _excluded$8 = ["components", "disableOpenPicker", "getOpenDialogAriaText", "InputAdornmentProps", "InputProps", "inputRef", "openPicker", "OpenPickerButtonProps", "renderInput"];
const KeyboardDateInput = /*#__PURE__*/React$d.forwardRef(function KeyboardDateInput(props, ref) {
  const {
    components = {},
    disableOpenPicker,
    getOpenDialogAriaText = getTextFieldAriaText,
    InputAdornmentProps,
    InputProps,
    inputRef,
    openPicker,
    OpenPickerButtonProps,
    renderInput
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$8);

  const utils = useUtils();
  const textFieldProps = useMaskedInput(other);
  const adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || 'end';
  const OpenPickerIcon = components.OpenPickerIcon || Calendar;
  return renderInput(_extends$P({
    ref,
    inputRef
  }, textFieldProps, {
    InputProps: _extends$P({}, InputProps, {
      [`${adornmentPosition}Adornment`]: disableOpenPicker ? undefined : /*#__PURE__*/jsx$1(InputAdornment$1, _extends$P({
        position: adornmentPosition
      }, InputAdornmentProps, {
        children: /*#__PURE__*/jsx$1(IconButton$2, _extends$P({
          edge: adornmentPosition,
          disabled: other.disabled || other.readOnly,
          "aria-label": getOpenDialogAriaText(other.rawValue, utils)
        }, OpenPickerButtonProps, {
          onClick: openPicker,
          children: /*#__PURE__*/jsx$1(OpenPickerIcon, {})
        }))
      }))
    })
  }));
});
process.env.NODE_ENV !== "production" ? KeyboardDateInput.propTypes = {
  acceptRegex: PropTypes$1.instanceOf(RegExp),
  getOpenDialogAriaText: PropTypes$1.func,
  mask: PropTypes$1.string,
  OpenPickerButtonProps: PropTypes$1.object,
  renderInput: PropTypes$1.func.isRequired,
  rifmFormatter: PropTypes$1.func
} : void 0;

function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }

  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  } // Support IOS safari


  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }

  return 'portrait';
}

const useIsLandscape = (views, customOrientation) => {
  const [orientation, setOrientation] = React$d.useState(getOrientation);
  useEnhancedEffect$2(() => {
    const eventHandler = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener('orientationchange', eventHandler);
    return () => {
      window.removeEventListener('orientationchange', eventHandler);
    };
  }, []);

  if (arrayIncludes(views, ['hours', 'minutes', 'seconds'])) {
    // could not display 13:34:44 in landscape mode
    return false;
  }

  const orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
};

const _excluded$7 = ["autoFocus", "className", "date", "DateInputProps", "isMobileKeyboardViewOpen", "onDateChange", "onViewChange", "openTo", "orientation", "showToolbar", "toggleMobileKeyboardView", "ToolbarComponent", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
const MobileKeyboardInputView = styled$1('div')({
  padding: '16px 24px'
});
const PickerRoot = styled$1('div')(({
  ownerState
}) => _extends$P({
  display: 'flex',
  flexDirection: 'column'
}, ownerState.isLandscape && {
  flexDirection: 'row'
}));
const MobileKeyboardTextFieldProps = {
  fullWidth: true
};

const isDatePickerView = view => view === 'year' || view === 'month' || view === 'day';

const isTimePickerView = view => view === 'hours' || view === 'minutes' || view === 'seconds';

function CalendarOrClockPicker(props) {
  const {
    autoFocus,
    date,
    DateInputProps,
    isMobileKeyboardViewOpen,
    onDateChange,
    onViewChange,
    openTo,
    orientation,
    showToolbar,
    toggleMobileKeyboardView,
    ToolbarComponent = () => null,
    toolbarFormat,
    toolbarPlaceholder,
    toolbarTitle,
    views
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$7);

  const isLandscape = useIsLandscape(views, orientation);
  const wrapperVariant = React$d.useContext(WrapperVariantContext);
  const toShowToolbar = typeof showToolbar === 'undefined' ? wrapperVariant !== 'desktop' : showToolbar;
  const handleDateChange = React$d.useCallback((newDate, selectionState) => {
    onDateChange(newDate, wrapperVariant, selectionState);
  }, [onDateChange, wrapperVariant]);
  const handleViewChange = React$d.useCallback(newView => {
    if (isMobileKeyboardViewOpen) {
      toggleMobileKeyboardView();
    }

    if (onViewChange) {
      onViewChange(newView);
    }
  }, [isMobileKeyboardViewOpen, onViewChange, toggleMobileKeyboardView]);
  const {
    openView,
    setOpenView,
    handleChangeAndOpenNext
  } = useViews({
    view: undefined,
    views,
    openTo,
    onChange: handleDateChange,
    onViewChange: handleViewChange
  });
  return /*#__PURE__*/jsxs(PickerRoot, {
    ownerState: {
      isLandscape
    },
    children: [toShowToolbar && /*#__PURE__*/jsx$1(ToolbarComponent, _extends$P({}, other, {
      views: views,
      isLandscape: isLandscape,
      date: date,
      onChange: handleDateChange,
      setOpenView: setOpenView,
      openView: openView,
      toolbarTitle: toolbarTitle,
      toolbarFormat: toolbarFormat,
      toolbarPlaceholder: toolbarPlaceholder,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: toggleMobileKeyboardView
    })), /*#__PURE__*/jsx$1(PickerViewRoot, {
      children: isMobileKeyboardViewOpen ? /*#__PURE__*/jsx$1(MobileKeyboardInputView, {
        children: /*#__PURE__*/jsx$1(KeyboardDateInput, _extends$P({}, DateInputProps, {
          ignoreInvalidInputs: true,
          disableOpenPicker: true,
          TextFieldProps: MobileKeyboardTextFieldProps
        }))
      }) : /*#__PURE__*/jsxs(React$d.Fragment, {
        children: [isDatePickerView(openView) && /*#__PURE__*/jsx$1(CalendarPicker, _extends$P({
          autoFocus: autoFocus,
          date: date,
          onViewChange: setOpenView,
          onChange: handleChangeAndOpenNext,
          view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
          ,
          views: views.filter(isDatePickerView)
        }, other)), isTimePickerView(openView) && /*#__PURE__*/jsx$1(ClockPicker, _extends$P({}, other, {
          autoFocus: autoFocus,
          date: date,
          view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
          ,
          views: views.filter(isTimePickerView),
          onChange: handleChangeAndOpenNext,
          onViewChange: setOpenView,
          showViewSwitcher: wrapperVariant === 'desktop'
        }))]
      })
    })]
  });
}

const useOpenState = ({
  open,
  onOpen,
  onClose
}) => {
  const isControllingOpenProp = React$d.useRef(typeof open === 'boolean').current;
  const [openState, setIsOpenState] = React$d.useState(false); // It is required to update inner state in useEffect in order to avoid situation when
  // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)

  React$d.useEffect(() => {
    if (isControllingOpenProp) {
      if (typeof open !== 'boolean') {
        throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
      }

      setIsOpenState(open);
    }
  }, [isControllingOpenProp, open]);
  const setIsOpen = React$d.useCallback(newIsOpen => {
    if (!isControllingOpenProp) {
      setIsOpenState(newIsOpen);
    }

    if (newIsOpen && onOpen) {
      onOpen();
    }

    if (!newIsOpen && onClose) {
      onClose();
    }
  }, [isControllingOpenProp, onOpen, onClose]);
  return {
    isOpen: openState,
    setIsOpen
  };
};

const usePickerState = (props, valueManager) => {
  const {
    disableCloseOnSelect,
    onAccept,
    onChange,
    value
  } = props;
  const utils = useUtils();
  const {
    isOpen,
    setIsOpen
  } = useOpenState(props);

  function initDraftableDate(date) {
    return {
      committed: date,
      draft: date
    };
  }

  const parsedDateValue = valueManager.parseInput(utils, value);
  const [draftState, dispatch] = React$d.useReducer((state, action) => {
    switch (action.type) {
      case 'reset':
        return initDraftableDate(action.payload);

      case 'update':
        return _extends$P({}, state, {
          draft: action.payload
        });

      default:
        return state;
    }
  }, parsedDateValue, initDraftableDate);

  if (!valueManager.areValuesEqual(utils, draftState.committed, parsedDateValue)) {
    dispatch({
      type: 'reset',
      payload: parsedDateValue
    });
  }

  const [initialDate, setInitialDate] = React$d.useState(draftState.committed); // Mobile keyboard view is a special case.
  // When it's open picker should work like closed, cause we are just showing text field

  const [isMobileKeyboardViewOpen, setMobileKeyboardViewOpen] = React$d.useState(false);
  const acceptDate = React$d.useCallback((acceptedDate, needClosePicker) => {
    onChange(acceptedDate);

    if (needClosePicker) {
      setIsOpen(false);
      setInitialDate(acceptedDate);

      if (onAccept) {
        onAccept(acceptedDate);
      }
    }
  }, [onAccept, onChange, setIsOpen]);
  const wrapperProps = React$d.useMemo(() => ({
    open: isOpen,
    onClear: () => acceptDate(valueManager.emptyValue, true),
    onAccept: () => acceptDate(draftState.draft, true),
    onDismiss: () => acceptDate(initialDate, true),
    onSetToday: () => {
      const now = utils.date();
      dispatch({
        type: 'update',
        payload: now
      });
      acceptDate(now, !disableCloseOnSelect);
    }
  }), [acceptDate, disableCloseOnSelect, isOpen, utils, draftState.draft, valueManager.emptyValue, initialDate]);
  const pickerProps = React$d.useMemo(() => ({
    date: draftState.draft,
    isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: () => setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen),
    onDateChange: (newDate, wrapperVariant, selectionState = 'partial') => {
      dispatch({
        type: 'update',
        payload: newDate
      });

      if (selectionState === 'partial') {
        acceptDate(newDate, false);
      }

      if (selectionState === 'finish') {
        const shouldCloseOnSelect = !(disableCloseOnSelect != null ? disableCloseOnSelect : wrapperVariant === 'mobile');
        acceptDate(newDate, shouldCloseOnSelect);
      } // if selectionState === "shallow" do nothing (we already update the draft state)

    }
  }), [acceptDate, disableCloseOnSelect, isMobileKeyboardViewOpen, draftState.draft]);
  const inputProps = React$d.useMemo(() => ({
    onChange,
    open: isOpen,
    rawValue: value,
    openPicker: () => setIsOpen(true)
  }), [onChange, isOpen, value, setIsOpen]);
  const pickerState = {
    pickerProps,
    inputProps,
    wrapperProps
  };
  React$d.useDebugValue(pickerState, () => ({
    MuiPickerState: {
      pickerDraft: draftState,
      other: pickerState
    }
  }));
  return pickerState;
};

const _excluded$6 = ["onChange", "PopperProps", "PaperProps", "ToolbarComponent", "TransitionComponent", "value", "clearText", "clearable"];
const valueManager$1 = {
  emptyValue: null,
  parseInput: parsePickerInputValue,
  areValuesEqual: (utils, a, b) => utils.isEqual(a, b)
};

/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/api/desktop-date-picker/)
 */
const DesktopDatePicker = /*#__PURE__*/React$d.forwardRef(function DesktopDatePicker(inProps, ref) {
  // TODO: TDate needs to be instantiated at every usage.
  const props = useDatePickerDefaultizedProps(inProps, 'MuiDesktopDatePicker');
  const validationError = useDateValidation(props) !== null;
  const {
    pickerProps,
    inputProps,
    wrapperProps
  } = usePickerState(props, valueManager$1);

  const {
    PopperProps,
    PaperProps,
    ToolbarComponent = DatePickerToolbar,
    TransitionComponent,
    clearText,
    clearable
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$6);

  const AllDateInputProps = _extends$P({}, inputProps, other, {
    ref,
    validationError
  });

  return /*#__PURE__*/jsx$1(DesktopWrapper, _extends$P({}, wrapperProps, {
    DateInputProps: AllDateInputProps,
    KeyboardDateInputComponent: KeyboardDateInput,
    PopperProps: PopperProps,
    PaperProps: PaperProps,
    TransitionComponent: TransitionComponent,
    clearText: clearText,
    clearable: clearable,
    children: /*#__PURE__*/jsx$1(CalendarOrClockPicker, _extends$P({}, pickerProps, {
      autoFocus: true,
      toolbarTitle: props.label || props.toolbarTitle,
      ToolbarComponent: ToolbarComponent,
      DateInputProps: AllDateInputProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? DesktopDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */
  acceptRegex: PropTypes$1.instanceOf(RegExp),

  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,
  children: PropTypes$1.node,

  /**
   * className applied to the root component.
   */
  className: PropTypes$1.string,

  /**
   * If `true`, it shows the clear action in the picker dialog.
   * @default false
   */
  clearable: PropTypes$1.bool,

  /**
   * Clear text message.
   * @default 'Clear'
   */
  clearText: PropTypes$1.node,

  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.object,

  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes$1.object,

  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: PropTypes$1.any,

  /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  disableCloseOnSelect: PropTypes$1.bool,

  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * @default false
   */
  disableFuture: PropTypes$1.bool,

  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes$1.bool,

  /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */
  disableMaskedInput: PropTypes$1.bool,

  /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */
  disableOpenPicker: PropTypes$1.bool,

  /**
   * @default false
   */
  disablePast: PropTypes$1.bool,

  /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @default (value, utils) => `Choose date, selected date is ${utils.format(utils.date(value), 'fullDate')}`
   * @param {ParseableDate<TDateValue>} value The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDateValue>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   */
  getOpenDialogAriaText: PropTypes$1.func,

  /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   */
  getViewSwitchingButtonText: PropTypes$1.func,
  ignoreInvalidInputs: PropTypes$1.bool,

  /**
   * Props to pass to keyboard input adornment.
   */
  InputAdornmentProps: PropTypes$1.object,

  /**
   * Format string.
   */
  inputFormat: PropTypes$1.string,
  InputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
    current: PropTypes$1.object
  })]),
  label: PropTypes$1.node,

  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: PropTypes$1.string,

  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes$1.bool,

  /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */
  mask: PropTypes$1.string,

  /**
   * Max selectable date. @DateIOType
   */
  maxDate: PropTypes$1.any,

  /**
   * Min selectable date. @DateIOType
   */
  minDate: PropTypes$1.any,

  /**
   * Callback fired when date is accepted @DateIOType.
   * @param {TDateValue} date The date that was just accepted.
   */
  onAccept: PropTypes$1.func,

  /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @param {DateRange<TDate>} date The new parsed date.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */
  onChange: PropTypes$1.func.isRequired,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */
  onClose: PropTypes$1.func,

  /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TDateValue} value The invalid value.
   */
  onError: PropTypes$1.func,

  /**
   * Callback firing on month change. @DateIOType
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes$1.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */
  onOpen: PropTypes$1.func,

  /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */
  onViewChange: PropTypes$1.func,

  /**
   * Callback firing on year change @DateIOType.
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes$1.func,

  /**
   * Control the popup or dialog open state.
   */
  open: PropTypes$1.bool,

  /**
   * Props to pass to keyboard adornment button.
   */
  OpenPickerButtonProps: PropTypes$1.object,

  /**
   * First view to show.
   */
  openTo: PropTypes$1.oneOf(['day', 'month', 'year']),

  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes$1.oneOf(['landscape', 'portrait']),

  /**
   * Paper props passed down to [Paper](https://mui.com/api/paper/) component.
   */
  PaperProps: PropTypes$1.object,

  /**
   * Popper props passed down to [Popper](https://mui.com/api/popper/) component.
   */
  PopperProps: PropTypes$1.object,

  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes$1.bool,

  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: PropTypes$1.bool,

  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDates The dates currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */
  renderDay: PropTypes$1.func,

  /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/api/text-field/#textfield-api) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */
  renderInput: PropTypes$1.func.isRequired,

  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes$1.func,

  /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */
  rifmFormatter: PropTypes$1.func,

  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: PropTypes$1.string,

  /**
   * Disable specific date. @DateIOType
   * @param {TDate} day The date to check.
   * @returns {boolean} If `true` the day will be disabled.
   */
  shouldDisableDate: PropTypes$1.func,

  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @param {TDate} year The year to test.
   * @returns {boolean} Return `true` if the year should be disabled.
   */
  shouldDisableYear: PropTypes$1.func,

  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes$1.bool,

  /**
   * If `true`, show the toolbar even in desktop mode.
   */
  showToolbar: PropTypes$1.bool,

  /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */
  ToolbarComponent: PropTypes$1.elementType,

  /**
   * Date format, that is displaying in toolbar.
   */
  toolbarFormat: PropTypes$1.string,

  /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */
  toolbarPlaceholder: PropTypes$1.node,

  /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */
  toolbarTitle: PropTypes$1.node,

  /**
   * Custom component for popper [Transition](https://mui.com/components/transitions/#transitioncomponent-prop).
   */
  TransitionComponent: PropTypes$1.elementType,

  /**
   * The value of the picker.
   */
  value: PropTypes$1.oneOfType([PropTypes$1.any, PropTypes$1.instanceOf(Date), PropTypes$1.number, PropTypes$1.string]),

  /**
   * Array of views to show.
   */
  views: PropTypes$1.arrayOf(PropTypes$1.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

const PickersModalDialogRoot = styled$1(Dialog$2)({
  [`& .${dialogClasses$1.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses$1.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
});
const PickersModalDialogContent = styled$1(DialogContent$1)({
  '&:first-of-type': {
    padding: 0
  }
});
const PickersModalDialogActions = styled$1(DialogActions$1)(({
  ownerState
}) => _extends$P({}, (ownerState.clearable || ownerState.showTodayButton) && {
  // set justifyContent to default value to fix IE11 layout bug
  // see https://github.com/mui-org/material-ui-pickers/pull/267
  justifyContent: 'flex-start',
  '& > *:first-of-type': {
    marginRight: 'auto'
  }
}));
const PickersModalDialog = props => {
  const {
    cancelText = 'Cancel',
    children,
    clearable = false,
    clearText = 'Clear',
    DialogProps = {},
    okText = 'OK',
    onAccept,
    onClear,
    onDismiss,
    onSetToday,
    open,
    showTodayButton = false,
    todayText = 'Today'
  } = props;
  const ownerState = props;
  return /*#__PURE__*/jsxs(PickersModalDialogRoot, _extends$P({
    open: open,
    onClose: onDismiss
  }, DialogProps, {
    children: [/*#__PURE__*/jsx$1(PickersModalDialogContent, {
      children: children
    }), /*#__PURE__*/jsxs(PickersModalDialogActions, {
      ownerState: ownerState,
      children: [clearable && /*#__PURE__*/jsx$1(Button$3, {
        onClick: onClear,
        children: clearText
      }), showTodayButton && /*#__PURE__*/jsx$1(Button$3, {
        onClick: onSetToday,
        children: todayText
      }), cancelText && /*#__PURE__*/jsx$1(Button$3, {
        onClick: onDismiss,
        children: cancelText
      }), okText && /*#__PURE__*/jsx$1(Button$3, {
        onClick: onAccept,
        children: okText
      })]
    })]
  }));
};

const _excluded$5 = ["cancelText", "children", "clearable", "clearText", "DateInputProps", "DialogProps", "okText", "onAccept", "onClear", "onDismiss", "onSetToday", "open", "PureDateInputComponent", "showTodayButton", "todayText"];
function MobileWrapper(props) {
  const {
    cancelText,
    children,
    clearable,
    clearText,
    DateInputProps,
    DialogProps,
    okText,
    onAccept,
    onClear,
    onDismiss,
    onSetToday,
    open,
    PureDateInputComponent,
    showTodayButton,
    todayText
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$5);

  return /*#__PURE__*/jsxs(WrapperVariantContext.Provider, {
    value: "mobile",
    children: [/*#__PURE__*/jsx$1(PureDateInputComponent, _extends$P({}, other, DateInputProps)), /*#__PURE__*/jsx$1(PickersModalDialog, {
      cancelText: cancelText,
      clearable: clearable,
      clearText: clearText,
      DialogProps: DialogProps,
      okText: okText,
      onAccept: onAccept,
      onClear: onClear,
      onDismiss: onDismiss,
      onSetToday: onSetToday,
      open: open,
      showTodayButton: showTodayButton,
      todayText: todayText,
      children: children
    })]
  });
}

// TODO: why is this called "Pure*" when it's not memoized? Does "Pure" mean "readonly"?
const PureDateInput = /*#__PURE__*/React$d.forwardRef(function PureDateInput(props, ref) {
  const {
    disabled,
    getOpenDialogAriaText = getTextFieldAriaText,
    inputFormat,
    InputProps,
    inputRef,
    label,
    openPicker: onOpen,
    rawValue,
    renderInput,
    TextFieldProps = {},
    validationError
  } = props;
  const utils = useUtils();
  const PureDateInputProps = React$d.useMemo(() => _extends$P({}, InputProps, {
    readOnly: true
  }), [InputProps]);
  const inputValue = getDisplayDate(utils, rawValue, inputFormat);
  return renderInput(_extends$P({
    label,
    disabled,
    ref,
    inputRef,
    error: validationError,
    InputProps: PureDateInputProps,
    inputProps: _extends$P({
      disabled,
      readOnly: true,
      'aria-readonly': true,
      'aria-label': getOpenDialogAriaText(rawValue, utils),
      value: inputValue
    }, !props.readOnly && {
      onClick: onOpen
    }, {
      onKeyDown: onSpaceOrEnter(onOpen)
    })
  }, TextFieldProps));
});
PureDateInput.propTypes = {
  getOpenDialogAriaText: PropTypes$1.func,
  renderInput: PropTypes$1.func.isRequired
};

const _excluded$4 = ["ToolbarComponent", "value", "onChange"];
const valueManager = {
  emptyValue: null,
  parseInput: parsePickerInputValue,
  areValuesEqual: (utils, a, b) => utils.isEqual(a, b)
};

/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/api/mobile-date-picker/)
 */
const MobileDatePicker = /*#__PURE__*/React$d.forwardRef(function MobileDatePicker(inProps, ref) {
  // TODO: TDate needs to be instantiated at every usage.
  const props = useDatePickerDefaultizedProps(inProps, 'MuiMobileDatePicker');
  const validationError = useDateValidation(props) !== null;
  const {
    pickerProps,
    inputProps,
    wrapperProps
  } = usePickerState(props, valueManager); // Note that we are passing down all the value without spread.
  // It saves us >1kb gzip and make any prop available automatically on any level down.

  const {
    ToolbarComponent = DatePickerToolbar
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$4);

  const DateInputProps = _extends$P({}, inputProps, other, {
    ref,
    validationError
  });

  return /*#__PURE__*/jsx$1(MobileWrapper, _extends$P({}, other, wrapperProps, {
    DateInputProps: DateInputProps,
    PureDateInputComponent: PureDateInput,
    children: /*#__PURE__*/jsx$1(CalendarOrClockPicker, _extends$P({}, pickerProps, {
      autoFocus: true,
      toolbarTitle: props.label || props.toolbarTitle,
      ToolbarComponent: ToolbarComponent,
      DateInputProps: DateInputProps
    }, other))
  }));
});
process.env.NODE_ENV !== "production" ? MobileDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */
  acceptRegex: PropTypes$1.instanceOf(RegExp),

  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,

  /**
   * Cancel text message.
   * @default 'Cancel'
   */
  cancelText: PropTypes$1.node,
  children: PropTypes$1.node,

  /**
   * className applied to the root component.
   */
  className: PropTypes$1.string,

  /**
   * If `true`, it shows the clear action in the picker dialog.
   * @default false
   */
  clearable: PropTypes$1.bool,

  /**
   * Clear text message.
   * @default 'Clear'
   */
  clearText: PropTypes$1.node,

  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.object,

  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes$1.object,

  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: PropTypes$1.any,

  /**
   * Props applied to the [`Dialog`](/api/dialog/) element.
   */
  DialogProps: PropTypes$1.object,

  /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  disableCloseOnSelect: PropTypes$1.bool,

  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * @default false
   */
  disableFuture: PropTypes$1.bool,

  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes$1.bool,

  /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */
  disableMaskedInput: PropTypes$1.bool,

  /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */
  disableOpenPicker: PropTypes$1.bool,

  /**
   * @default false
   */
  disablePast: PropTypes$1.bool,

  /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @default (value, utils) => `Choose date, selected date is ${utils.format(utils.date(value), 'fullDate')}`
   * @param {ParseableDate<TDateValue>} value The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDateValue>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   */
  getOpenDialogAriaText: PropTypes$1.func,

  /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   */
  getViewSwitchingButtonText: PropTypes$1.func,
  ignoreInvalidInputs: PropTypes$1.bool,

  /**
   * Props to pass to keyboard input adornment.
   */
  InputAdornmentProps: PropTypes$1.object,

  /**
   * Format string.
   */
  inputFormat: PropTypes$1.string,
  InputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
    current: PropTypes$1.object
  })]),
  label: PropTypes$1.node,

  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: PropTypes$1.string,

  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes$1.bool,

  /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */
  mask: PropTypes$1.string,

  /**
   * Max selectable date. @DateIOType
   */
  maxDate: PropTypes$1.any,

  /**
   * Min selectable date. @DateIOType
   */
  minDate: PropTypes$1.any,

  /**
   * Ok button text.
   * @default 'OK'
   */
  okText: PropTypes$1.node,

  /**
   * Callback fired when date is accepted @DateIOType.
   * @param {TDateValue} date The date that was just accepted.
   */
  onAccept: PropTypes$1.func,

  /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @param {DateRange<TDate>} date The new parsed date.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */
  onChange: PropTypes$1.func.isRequired,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */
  onClose: PropTypes$1.func,

  /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TDateValue} value The invalid value.
   */
  onError: PropTypes$1.func,

  /**
   * Callback firing on month change. @DateIOType
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes$1.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */
  onOpen: PropTypes$1.func,

  /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */
  onViewChange: PropTypes$1.func,

  /**
   * Callback firing on year change @DateIOType.
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes$1.func,

  /**
   * Control the popup or dialog open state.
   */
  open: PropTypes$1.bool,

  /**
   * Props to pass to keyboard adornment button.
   */
  OpenPickerButtonProps: PropTypes$1.object,

  /**
   * First view to show.
   */
  openTo: PropTypes$1.oneOf(['day', 'month', 'year']),

  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes$1.oneOf(['landscape', 'portrait']),

  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes$1.bool,

  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: PropTypes$1.bool,

  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDates The dates currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */
  renderDay: PropTypes$1.func,

  /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/api/text-field/#textfield-api) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */
  renderInput: PropTypes$1.func.isRequired,

  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes$1.func,

  /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */
  rifmFormatter: PropTypes$1.func,

  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: PropTypes$1.string,

  /**
   * Disable specific date. @DateIOType
   * @param {TDate} day The date to check.
   * @returns {boolean} If `true` the day will be disabled.
   */
  shouldDisableDate: PropTypes$1.func,

  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @param {TDate} year The year to test.
   * @returns {boolean} Return `true` if the year should be disabled.
   */
  shouldDisableYear: PropTypes$1.func,

  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes$1.bool,

  /**
   * If `true`, the today button is displayed. **Note** that `showClearButton` has a higher priority.
   * @default false
   */
  showTodayButton: PropTypes$1.bool,

  /**
   * If `true`, show the toolbar even in desktop mode.
   */
  showToolbar: PropTypes$1.bool,

  /**
   * Today text message.
   * @default 'Today'
   */
  todayText: PropTypes$1.node,

  /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */
  ToolbarComponent: PropTypes$1.elementType,

  /**
   * Date format, that is displaying in toolbar.
   */
  toolbarFormat: PropTypes$1.string,

  /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */
  toolbarPlaceholder: PropTypes$1.node,

  /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */
  toolbarTitle: PropTypes$1.node,

  /**
   * The value of the picker.
   */
  value: PropTypes$1.oneOfType([PropTypes$1.any, PropTypes$1.instanceOf(Date), PropTypes$1.number, PropTypes$1.string]),

  /**
   * Array of views to show.
   */
  views: PropTypes$1.arrayOf(PropTypes$1.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

const _excluded$3 = ["cancelText", "clearable", "clearText", "desktopModeMediaQuery", "DialogProps", "okText", "PopperProps", "showTodayButton", "todayText", "TransitionComponent"];

/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/x/react-date-pickers/date-picker/)
 * - [Pickers](https://mui.com/x/react-date-pickers/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/api/date-picker/)
 */
const DatePicker = /*#__PURE__*/React$d.forwardRef(function DatePicker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDatePicker'
  });

  const {
    cancelText,
    clearable,
    clearText,
    desktopModeMediaQuery = '@media (pointer: fine)',
    DialogProps,
    okText,
    PopperProps,
    showTodayButton,
    todayText,
    TransitionComponent
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$3);

  const isDesktop = useMediaQuery(desktopModeMediaQuery);
  return isDesktop ? /*#__PURE__*/jsx$1(DesktopDatePicker, _extends$P({
    ref: ref,
    PopperProps: PopperProps,
    TransitionComponent: TransitionComponent,
    clearText: clearText,
    clearable: clearable
  }, other)) : /*#__PURE__*/jsx$1(MobileDatePicker, _extends$P({
    ref: ref,
    cancelText: cancelText,
    clearable: clearable,
    clearText: clearText,
    DialogProps: DialogProps,
    okText: okText,
    showTodayButton: showTodayButton,
    todayText: todayText
  }, other));
});
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------

  /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */
  acceptRegex: PropTypes$1.instanceOf(RegExp),

  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,

  /**
   * Cancel text message.
   * @default 'Cancel'
   */
  cancelText: PropTypes$1.node,
  children: PropTypes$1.node,

  /**
   * className applied to the root component.
   */
  className: PropTypes$1.string,

  /**
   * If `true`, it shows the clear action in the picker dialog.
   * @default false
   */
  clearable: PropTypes$1.bool,

  /**
   * Clear text message.
   * @default 'Clear'
   */
  clearText: PropTypes$1.node,

  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes$1.object,

  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes$1.object,

  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: PropTypes$1.any,

  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: PropTypes$1.string,

  /**
   * Props applied to the [`Dialog`](/api/dialog/) element.
   */
  DialogProps: PropTypes$1.object,

  /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  disableCloseOnSelect: PropTypes$1.bool,

  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,

  /**
   * @default false
   */
  disableFuture: PropTypes$1.bool,

  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes$1.bool,

  /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */
  disableMaskedInput: PropTypes$1.bool,

  /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */
  disableOpenPicker: PropTypes$1.bool,

  /**
   * @default false
   */
  disablePast: PropTypes$1.bool,

  /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @default (value, utils) => `Choose date, selected date is ${utils.format(utils.date(value), 'fullDate')}`
   * @param {ParseableDate<TDateValue>} value The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDateValue>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   */
  getOpenDialogAriaText: PropTypes$1.func,

  /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   */
  getViewSwitchingButtonText: PropTypes$1.func,
  ignoreInvalidInputs: PropTypes$1.bool,

  /**
   * Props to pass to keyboard input adornment.
   */
  InputAdornmentProps: PropTypes$1.object,

  /**
   * Format string.
   */
  inputFormat: PropTypes$1.string,
  InputProps: PropTypes$1.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
    current: PropTypes$1.object
  })]),
  label: PropTypes$1.node,

  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: PropTypes$1.string,

  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes$1.bool,

  /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */
  mask: PropTypes$1.string,

  /**
   * Max selectable date. @DateIOType
   */
  maxDate: PropTypes$1.any,

  /**
   * Min selectable date. @DateIOType
   */
  minDate: PropTypes$1.any,

  /**
   * Ok button text.
   * @default 'OK'
   */
  okText: PropTypes$1.node,

  /**
   * Callback fired when date is accepted @DateIOType.
   * @param {TDateValue} date The date that was just accepted.
   */
  onAccept: PropTypes$1.func,

  /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @param {DateRange<TDate>} date The new parsed date.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */
  onChange: PropTypes$1.func.isRequired,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */
  onClose: PropTypes$1.func,

  /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TDateValue} value The invalid value.
   */
  onError: PropTypes$1.func,

  /**
   * Callback firing on month change. @DateIOType
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes$1.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */
  onOpen: PropTypes$1.func,

  /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */
  onViewChange: PropTypes$1.func,

  /**
   * Callback firing on year change @DateIOType.
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes$1.func,

  /**
   * Control the popup or dialog open state.
   */
  open: PropTypes$1.bool,

  /**
   * Props to pass to keyboard adornment button.
   */
  OpenPickerButtonProps: PropTypes$1.object,

  /**
   * First view to show.
   */
  openTo: PropTypes$1.oneOf(['day', 'month', 'year']),

  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes$1.oneOf(['landscape', 'portrait']),

  /**
   * Paper props passed down to [Paper](https://mui.com/api/paper/) component.
   */
  PaperProps: PropTypes$1.object,

  /**
   * Popper props passed down to [Popper](https://mui.com/api/popper/) component.
   */
  PopperProps: PropTypes$1.object,

  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes$1.bool,

  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: PropTypes$1.bool,

  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDates The dates currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */
  renderDay: PropTypes$1.func,

  /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/api/text-field/#textfield-api) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */
  renderInput: PropTypes$1.func.isRequired,

  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes$1.func,

  /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */
  rifmFormatter: PropTypes$1.func,

  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: PropTypes$1.string,

  /**
   * Disable specific date. @DateIOType
   * @param {TDate} day The date to check.
   * @returns {boolean} If `true` the day will be disabled.
   */
  shouldDisableDate: PropTypes$1.func,

  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @param {TDate} year The year to test.
   * @returns {boolean} Return `true` if the year should be disabled.
   */
  shouldDisableYear: PropTypes$1.func,

  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes$1.bool,

  /**
   * If `true`, the today button is displayed. **Note** that `showClearButton` has a higher priority.
   * @default false
   */
  showTodayButton: PropTypes$1.bool,

  /**
   * If `true`, show the toolbar even in desktop mode.
   */
  showToolbar: PropTypes$1.bool,

  /**
   * Today text message.
   * @default 'Today'
   */
  todayText: PropTypes$1.node,

  /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */
  ToolbarComponent: PropTypes$1.elementType,

  /**
   * Date format, that is displaying in toolbar.
   */
  toolbarFormat: PropTypes$1.string,

  /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */
  toolbarPlaceholder: PropTypes$1.node,

  /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */
  toolbarTitle: PropTypes$1.node,

  /**
   * Custom component for popper [Transition](https://mui.com/components/transitions/#transitioncomponent-prop).
   */
  TransitionComponent: PropTypes$1.elementType,

  /**
   * The value of the picker.
   */
  value: PropTypes$1.oneOfType([PropTypes$1.any, PropTypes$1.instanceOf(Date), PropTypes$1.number, PropTypes$1.string]),

  /**
   * Array of views to show.
   */
  views: PropTypes$1.arrayOf(PropTypes$1.oneOf(['day', 'month', 'year']).isRequired)
} : void 0;

var DateInput = function (props) {
    var classes = useStyles$N({}).classes;
    var _a = props.initialDate, initialDate = _a === void 0 ? new Date() : _a, onDateChange = props.onDateChange, ariaLabel = props.ariaLabel;
    var _b = useState(initialDate), selectedDate = _b[0], setSelectedDate = _b[1];
    var todayDate = new Date();
    useEffect(function () {
        if (initialDate) {
            setSelectedDate(initialDate);
        }
    }, [initialDate]);
    var handleDateChange = function (date) {
        date && setSelectedDate(date);
        date && onDateChange && onDateChange(date);
    };
    // This function is to NOT allow the user to type into the datepicker
    var handleDateChangeRaw = function (event) {
        event.preventDefault();
    };
    return (jsx$1(LocalizationProvider, __assign$3({ dateAdapter: DateFnsUtils }, { children: jsx$1(DatePicker, { inputFormat: "d MMMM yyyy", disableMaskedInput: true, value: selectedDate, onChange: handleDateChange, minDate: todayDate, className: classes.datePicker, disablePast: true, renderInput: function (props) { return (jsx$1(TextField$1, __assign$3({ "aria-label": ariaLabel, className: classes.datePicker, label: "Date", margin: "normal", onKeyDown: function (event) {
                    handleDateChangeRaw(event);
                } }, props))); } }) })));
};

var PasswordInput = function (props) {
    var value = props.value, _a = props.showPasswordSwitch, showPasswordSwitch = _a === void 0 ? true : _a, _b = props.ariaLabel, ariaLabel = _b === void 0 ? 'Password input' : _b, onChange = props.onChange, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, dataCy = props.dataCy;
    var _d = useStyles$N({}), classes = _d.classes, classNames = _d.cx;
    var _e = useState(false), showPassword = _e[0], setShowPassword = _e[1];
    var handleClickShowPassword = function () {
        setShowPassword(!showPassword);
    };
    var handleMouseDownPassword = function (event) {
        event.preventDefault();
    };
    return (jsx$1(OutlinedInput$1, { type: showPassword ? 'text' : 'password', value: value, onChange: onChange, fullWidth: fullWidth, inputProps: {
            'aria-label': ariaLabel,
            'data-cy': dataCy
        }, classes: {
            root: classNames(classes.outlinedStyle, classes.customStyle)
        }, endAdornment: showPasswordSwitch && (jsx$1(InputAdornment$1, __assign$3({ position: "end" }, { children: jsx$1(IconButton$2, __assign$3({ style: { padding: 2, marginRight: 0 }, "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end", size: "large" }, { children: showPassword ? (jsx$1(VisibilityOutlined, {})) : (jsx$1(VisibilityOffOutlined, {})) })) }))) }));
};

/**
 * react-number-format - 4.9.1
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

//     

                                                               

// basic noop function
function noop$4() {}
function returnTrue$1() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps$2 = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop$4,
  onChange: noop$4,
  onKeyDown: noop$4,
  onMouseUp: noop$4,
  onFocus: noop$4,
  onBlur: noop$4,
  isAllowed: returnTrue$1,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm,
          source: 'prop',
          event: null,
        });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(this.getNumberRegex(true)) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                               
                   
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var source = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //calculate caret position if not defined
      if (caretPos === undefined && setCaretPosition) {
        var inputValue = params.inputValue || input.value;

        var currentCaretPosition = getCurrentCaretPosition(input);

        /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */
        input.value = formattedValue;

        //get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }

      /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */
      input.value = formattedValue;

      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString), { event: event, source: source });
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el,
      event: e,
      source: 'event',
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
          event: e,
          source: 'event',
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e,
          source: 'event',
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    ref.thousandSeparator;
    ref.decimalSeparator;
    ref.allowedDecimalSeparators;
    ref.thousandsGroupStyle;
    ref.decimalScale;
    ref.fixedDecimalScale;
    ref.prefix;
    ref.suffix;
    ref.removeFormatting;
    ref.mask;
    ref.defaultValue;
    ref.isNumericString;
    ref.allowNegative;
    ref.allowEmptyFormatting;
    ref.allowLeadingZeros;
    ref.onValueChange;
    ref.isAllowed;
    ref.customNumerals;
    ref.onChange;
    ref.onKeyDown;
    ref.onMouseUp;
    ref.onFocus;
    ref.onBlur;
    ref.value;
    var rest = objectWithoutProperties( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        React__default.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return React__default.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return React__default.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(React__default.Component));

NumberFormat.defaultProps = defaultProps$2;

// TODO: I could not find a better props type than "unknown"
var NumberFormatCustom$2 = function (props) {
    return (jsx$1(NumberFormat
    // eslint-disable-next-line react/jsx-props-no-spreading
    , __assign$3({}, props, { decimalScale: 1, allowNegative: false, isNumericString: true, allowedDecimalSeparators: [',', '.'] })));
};
var PercentageInput = function (props) {
    var value = props.value, onChange = props.onChange, _a = props.ariaLabel, ariaLabel = _a === void 0 ? 'Percent input' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.defaultValue, defaultValue = _c === void 0 ? '' : _c, _d = props.isError, isError = _d === void 0 ? false : _d, _e = props.readOnly, readOnly = _e === void 0 ? false : _e, dataCy = props.dataCy;
    var _f = useState(value), percentage = _f[0], setPercentage = _f[1];
    var _g = useStyles$N({
        styleProps: {
            isPecentageInputError: isError
        }
    }), classes = _g.classes, classNames = _g.cx;
    useEffect(function () {
        setPercentage(value);
    }, [value]);
    var handlePercentageChange = function (event) {
        setPercentage(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    return (jsx$1(Grid$2, __assign$3({ container: true, alignItems: "center", direction: "row", spacing: 1 }, { children: jsxs(Grid$2, __assign$3({ item: true, xs: 10 }, { children: [!disabled && (jsx$1(TextField$1, { variant: "standard", disabled: readOnly, defaultValue: defaultValue, placeholder: "0", value: percentage, onChange: handlePercentageChange, classes: {
                        root: classNames(classes.outlinedPercentageStyle, classes.customQuotaStyle)
                    }, inputProps: {
                        'data-cy': dataCy,
                        'aria-label': ariaLabel
                    }, 
                    // eslint-disable-next-line react/jsx-no-duplicate-props
                    InputProps: {
                        disableUnderline: true,
                        inputComponent: NumberFormatCustom$2
                    } })), disabled && (jsx$1(TextField$1, { variant: "standard", disabled: disabled, defaultValue: "-", classes: {
                        root: classNames(classes.outlinedPercentageStyle, classes.customQuotaStyle)
                    }, InputProps: {
                        disableUnderline: true,
                        inputComponent: NumberFormatCustom$2
                    } }))] })) })));
};

var getInvalidRangeError = function (min, max, rangeLimit, exceedRangeLimitMessage) {
    var message = '';
    if (max && rangeLimit && max > rangeLimit)
        message = exceedRangeLimitMessage || '';
    if (min && max && min > max)
        message = 'Minimum cannot exceed maximum';
    if (max === 0)
        message = 'Maximum cannot be 0';
    return message;
};
var getIsIntervalValid = function (intervalMin, intervalMax) {
    return !!(intervalMin !== undefined &&
        intervalMax &&
        intervalMin <= intervalMax);
};
var getIsRangeLimitValid = function (intervalMin, intervalMax, rangeLimit) {
    return (!!(intervalMin !== undefined &&
        intervalMax &&
        rangeLimit &&
        intervalMin <= rangeLimit &&
        intervalMax <= rangeLimit) || rangeLimit === undefined);
};

var NumberFormatCustom$1 = function (props) {
    return (jsx$1(NumberFormat
    // eslint-disable-next-line react/jsx-props-no-spreading
    , __assign$3({}, props, { allowNegative: false, isNumericString: true, allowedDecimalSeparators: [',', '.'] })));
};
var IntervalInput = function (props) {
    var min = props.min, max = props.max, rangeLimit = props.rangeLimit, invalidRangeErrorMessage = props.invalidRangeErrorMessage, onIntervalChanged = props.onIntervalChanged, onError = props.onError;
    var _a = useState(min), intervalMin = _a[0], setMin = _a[1];
    var _b = useState(max), intervalMax = _b[0], setMax = _b[1];
    var _c = useState(true), isIntervalValid = _c[0], setIsIntervalValid = _c[1];
    var _d = useState(true), isRangeLimitValid = _d[0], setIsRangeLimitValid = _d[1];
    var isRangeDefined = intervalMin !== undefined && intervalMax !== undefined;
    useEffect(function () {
        var isIntervalValid = getIsIntervalValid(intervalMin, intervalMax);
        var isRangeLimitValid = getIsRangeLimitValid(intervalMin, intervalMax, rangeLimit);
        setIsRangeLimitValid(isRangeLimitValid);
        setIsIntervalValid(isIntervalValid);
        if (isIntervalValid && isRangeLimitValid) {
            onIntervalChanged === null || onIntervalChanged === void 0 ? void 0 : onIntervalChanged(intervalMin || 0, intervalMax || rangeLimit || 0);
        }
        if (isRangeDefined)
            onError === null || onError === void 0 ? void 0 : onError(getInvalidRangeError(intervalMin, intervalMax, rangeLimit, invalidRangeErrorMessage));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intervalMin, intervalMax, rangeLimit]);
    useEffect(function () {
        setMin(min);
    }, [min]);
    useEffect(function () {
        setMax(max);
    }, [max]);
    var onMinChanged = function (event) {
        var newMin = Number.isNaN(event.target.value)
            ? undefined
            : Number(event.target.value);
        setMin(newMin);
    };
    var onMaxChanged = function (event) {
        var newMax = Number.isNaN(event.target.value)
            ? undefined
            : Number(event.target.value);
        setMax(newMax);
    };
    var isError = !(isIntervalValid && isRangeLimitValid) && isRangeDefined;
    return (jsx$1(Grid$2, __assign$3({ container: true }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "end", spacing: 1, flexDirection: "row" }, { children: [jsx$1(Grid$2, __assign$3({ item: true }, { children: jsx$1(Input$6, { isError: isError, placeholder: "Min", onChange: onMinChanged, value: intervalMin, dataCy: "interval-min", customFormat: NumberFormatCustom$1, width: 60, supressHelperText: true, alignInputText: AlignInputText.Center }) })), jsx$1(Grid$2, __assign$3({ item: true, justifyContent: "center", alignItems: "center", display: "flex" }, { children: jsx$1("span", { children: "-" }) })), jsx$1(Grid$2, __assign$3({ item: true }, { children: jsx$1(Input$6, { isError: isError, placeholder: "Max", onChange: onMaxChanged, value: intervalMax, dataCy: "interval-max", customFormat: NumberFormatCustom$1, width: 60, supressHelperText: true, alignInputText: AlignInputText.Center }) }))] })) })));
};

var Search = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireDefault));

var createSvgIcon = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
});

var _utils = require$$0$5;
}(createSvgIcon));

var _interopRequireDefault$h = interopRequireDefault.exports;

Object.defineProperty(Search, "__esModule", {
  value: true
});
var default_1$7 = Search.default = void 0;

var _createSvgIcon$7 = _interopRequireDefault$h(createSvgIcon);

var _jsxRuntime$7 = require$$2$3;

var _default$7 = (0, _createSvgIcon$7.default)( /*#__PURE__*/(0, _jsxRuntime$7.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

default_1$7 = Search.default = _default$7;

var Clear = {};

var _interopRequireDefault$g = interopRequireDefault.exports;

Object.defineProperty(Clear, "__esModule", {
  value: true
});
var default_1$6 = Clear.default = void 0;

var _createSvgIcon$6 = _interopRequireDefault$g(createSvgIcon);

var _jsxRuntime$6 = require$$2$3;

var _default$6 = (0, _createSvgIcon$6.default)( /*#__PURE__*/(0, _jsxRuntime$6.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

default_1$6 = Clear.default = _default$6;

var Cancel = {};

var _interopRequireDefault$f = interopRequireDefault.exports;

Object.defineProperty(Cancel, "__esModule", {
  value: true
});
var default_1$5 = Cancel.default = void 0;

var _createSvgIcon$5 = _interopRequireDefault$f(createSvgIcon);

var _jsxRuntime$5 = require$$2$3;

var _default$5 = (0, _createSvgIcon$5.default)( /*#__PURE__*/(0, _jsxRuntime$5.jsx)("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

default_1$5 = Cancel.default = _default$5;

var SearchBarVariant;
(function (SearchBarVariant) {
    SearchBarVariant[SearchBarVariant["Filter"] = 0] = "Filter";
    SearchBarVariant[SearchBarVariant["Standard"] = 1] = "Standard";
})(SearchBarVariant || (SearchBarVariant = {}));
var SearchBarInput = function (props) {
    var value = props.value, _a = props.placeholder, placeholder = _a === void 0 ? 'Search projects' : _a, _b = props.showResultsPopup, showResultsPopup = _b === void 0 ? false : _b, _c = props.showClearIcon, showClearIcon = _c === void 0 ? false : _c, onChange = props.onChange, onClickClear = props.onClickClear, dataCy = props.dataCy, _d = props.ariaLabel, ariaLabel = _d === void 0 ? 'Search input' : _d, searchResults = props.searchResults, _e = props.variant, variant = _e === void 0 ? SearchBarVariant.Standard : _e, minMenuWidth = props.minMenuWidth, menuWidthSameAsSearchBar = props.menuWidthSameAsSearchBar, maxHeightResultsMenu = props.maxHeightResultsMenu, _f = props.minValueLengthForPopUp, minValueLengthForPopUp = _f === void 0 ? 3 : _f, _g = props.isLoading, isLoading = _g === void 0 ? false : _g;
    var ref = useRef({
        offsetWidth: 470
    });
    var searchBarWidth = ref === null || ref === void 0 ? void 0 : ref.current.offsetWidth;
    var minimumMenuWidth = minMenuWidth || searchBarWidth;
    var _h = useStyles$N({
        styleProps: {
            minimumMenuWidth: minimumMenuWidth,
            menuWidthSameAsSearchBar: menuWidthSameAsSearchBar,
            maxHeightResultsMenu: maxHeightResultsMenu
        }
    }), classes = _h.classes, classNames = _h.cx;
    var textClasses = useTextStyles().classes;
    var _j = useState(false), popupOpen = _j[0], setPopupOpen = _j[1];
    var handleChange = function (event) {
        if (onChange) {
            onChange(event);
        }
        if (event.target.value.length >= minValueLengthForPopUp && !popupOpen) {
            setPopupOpen(true);
        }
        else if (event.target.value.length < minValueLengthForPopUp &&
            popupOpen) {
            setPopupOpen(false);
        }
    };
    var handleFocus = function () {
        if (!popupOpen &&
            value !== undefined &&
            value.toString().length >= minValueLengthForPopUp) {
            setPopupOpen(true);
        }
    };
    var handleBlur = function () {
        setPopupOpen(false);
    };
    var getEndAdornment = function (variant, showClearIcon) {
        switch (variant) {
            case SearchBarVariant.Filter:
                return (jsx$1(InputAdornment$1, __assign$3({ position: "end" }, { children: showClearIcon && (jsx$1(IconButton$2, __assign$3({ size: "small", style: { padding: 2, marginRight: 0 }, edge: "end", onClick: function (event) {
                            if (onClickClear) {
                                onClickClear(event);
                            }
                            setPopupOpen(false);
                        } }, { children: jsx$1(default_1$5, { className: classes.cancelIcon, fontSize: "small" }) }))) })));
            default:
                return (jsx$1(InputAdornment$1, __assign$3({ position: "end" }, { children: !showClearIcon ? (jsx$1(IconButton$2, __assign$3({ style: { padding: 2, marginRight: 0 }, disabled: true, edge: "end", size: "large" }, { children: jsx$1(default_1$7, { className: classes.searchBarIcon }) }))) : (jsx$1(IconButton$2, __assign$3({ style: { padding: 2, marginRight: 0 }, edge: "end", onClick: onClickClear, size: "large" }, { children: jsx$1(default_1$6, { className: classes.searchBarIcon }) }))) })));
        }
    };
    var getStartAdornment = function (variant) {
        switch (variant) {
            case SearchBarVariant.Filter:
                return (jsx$1(Grid$2, __assign$3({ className: classes.search2 }, { children: jsx$1(Icon, { name: IconName.Search2, iconColor: IconColor$1.Emphasis, size: IconSize$1.Large }) })));
            default:
                return undefined;
        }
    };
    var getResultsMenu = function () {
        return (jsxs("div", __assign$3({ style: {
                display: popupOpen ? 'block' : 'none'
            }, className: classes.searchPopup }, { children: [isLoading && (jsx$1(Grid$2, __assign$3({ container: true, justifyContent: "center" }, { children: jsx$1(CircularProgress, { variant: "indeterminate", size: 24 }) }))), searchResults && searchResults.length === 0 && (jsxs(Grid$2, __assign$3({ container: true, className: classes.searchNoResults }, { children: [jsx$1(Grid$2, __assign$3({ className: classes.search2 }, { children: jsx$1(Icon, { name: IconName.Search2, iconColor: IconColor$1.Emphasis, size: IconSize$1.Large }) })), jsx$1(Grid$2, __assign$3({ className: classes.noResults }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground) }, { children: "Sorry, no results" })) }))] }))), searchResults] })));
    };
    var endAdornment = getEndAdornment(variant, showClearIcon);
    var startAdornment = getStartAdornment(variant);
    var resultsMenu = showResultsPopup && getResultsMenu();
    return (jsxs(Fragment$1, { children: [jsx$1("div", { style: {
                    display: popupOpen ? 'block' : 'none'
                }, className: classes.searchOverlay, onClick: handleBlur, onKeyPress: handleBlur, role: "dialog" }), jsxs("div", __assign$3({ className: classes.searchBoxWrapper }, { children: [jsx$1(OutlinedInput$1, { ref: ref, "data-cy": dataCy, type: "text", value: value, onChange: handleChange, onFocus: handleFocus, placeholder: placeholder, inputProps: {
                            'data-cy': dataCy,
                            className: classes.searchBarInputProps,
                            'aria-label': ariaLabel
                        }, classes: {
                            root: classNames(classes.outlinedStyle, classes.outlinedSearchBarStyle, classes.customStyle)
                        }, startAdornment: startAdornment, endAdornment: endAdornment }), resultsMenu] }))] }));
};

var commonjs = {};

var isEmail$1 = {};

// forked from https://github.com/chriso/validator.js
var __assign$2 = (commonjsGlobal && commonjsGlobal.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(isEmail$1, "__esModule", { value: true });
var defaultFqdnOptions = {
    requireTld: true,
    allowUnderscores: false,
    allowTrailingDot: false,
};
var defaultEmailOptions = {
    allowDisplayName: false,
    requireDisplayName: false,
    allowUtf8LocalPart: true,
    requireTld: true,
};
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
    var min = 0;
    var max;
    var len = encodeURI(str).split(/%..|./).length - 1;
    if (options) {
        min = Number(options.min) || 0;
        max = Number(options.max);
    }
    return len >= min && (typeof max === 'undefined' || len <= max);
}
function isFQDN(str, options) {
    options = __assign$2({}, defaultFqdnOptions, options);
    /* Remove the optional trailing dot before checking validity */
    if (options.allowTrailingDot && str[str.length - 1] === '.') {
        str = str.substring(0, str.length - 1);
    }
    var parts = str.split('.');
    if (options.requireTld) {
        var tld = '' + parts.pop();
        if (!parts.length ||
            !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
            return false;
        }
        // disallow spaces
        if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
            return false;
        }
    }
    for (var part = void 0, i = 0; i < parts.length; i++) {
        part = parts[i];
        if (options.allowUnderscores) {
            part = part.replace(/_/g, '');
        }
        if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
            return false;
        }
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) {
            return false;
        }
        if (part[0] === '-' || part[part.length - 1] === '-') {
            return false;
        }
    }
    return true;
}
function isEmail(str, options) {
    options = __assign$2({}, defaultEmailOptions, options);
    if (options.requireDisplayName || options.allowDisplayName) {
        var displayEmail = str.match(displayName);
        if (displayEmail) {
            str = displayEmail[1];
        }
        else if (options.requireDisplayName) {
            return false;
        }
    }
    var parts = str.split('@');
    var domain = '' + parts.pop();
    var lowerDomain = domain.toLowerCase();
    var user = parts.join('@');
    if (lowerDomain === 'gmail.com' || lowerDomain === 'googlemail.com') {
        user = user.replace(/\./g, '').toLowerCase();
    }
    if (!isByteLength(user, { max: 64 }) || !isByteLength(domain, { max: 254 })) {
        return false;
    }
    if (!isFQDN(domain, { requireTld: options.requireTld })) {
        return false;
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allowUtf8LocalPart
            ? quotedEmailUserUtf8.test(user)
            : quotedEmailUser.test(user);
    }
    var pattern = options.allowUtf8LocalPart
        ? emailUserUtf8Part
        : emailUserPart;
    var userParts = user.split('.');
    for (var i = 0; i < userParts.length; i++) {
        if (!pattern.test(userParts[i])) {
            return false;
        }
    }
    return true;
}
isEmail$1.default = isEmail;

var ReactMultiEmail$2 = {};

var __extends$2 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(ReactMultiEmail$2, "__esModule", { value: true });
var React$c = React__default;
var isEmail_1$1 = isEmail$1;
var ReactMultiEmail$1 = /** @class */ (function (_super) {
    __extends$2(ReactMultiEmail, _super);
    function ReactMultiEmail(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            focused: false,
            emails: [],
            inputValue: '',
        };
        _this.findEmailAddress = function (value, isEnter) {
            var validateEmail = _this.props.validateEmail;
            var validEmails = [];
            var inputValue = '';
            var re = /[ ,;]/g;
            var isEmail = validateEmail || isEmail_1$1.default;
            var addEmails = function (email) {
                var emails = _this.state.emails;
                for (var i = 0, l = emails.length; i < l; i++) {
                    if (emails[i] === email) {
                        return false;
                    }
                }
                validEmails.push(email);
                return true;
            };
            if (value !== '') {
                if (re.test(value)) {
                    var arr = value.split(re).filter(function (n) {
                        return n !== '' && n !== undefined && n !== null;
                    });
                    do {
                        if (isEmail('' + arr[0])) {
                            addEmails('' + arr.shift());
                        }
                        else {
                            if (arr.length === 1) {
                                /// 마지막 아이템이면 inputValue로 남겨두기
                                inputValue = '' + arr.shift();
                            }
                            else {
                                arr.shift();
                            }
                        }
                    } while (arr.length);
                }
                else {
                    if (isEnter) {
                        if (isEmail(value)) {
                            addEmails(value);
                        }
                        else {
                            inputValue = value;
                        }
                    }
                    else {
                        inputValue = value;
                    }
                }
            }
            _this.setState({
                emails: _this.state.emails.concat(validEmails),
                inputValue: inputValue,
            });
            if (validEmails.length && _this.props.onChange) {
                _this.props.onChange(_this.state.emails.concat(validEmails));
            }
        };
        _this.onChangeInputValue = function (value) {
            _this.findEmailAddress(value);
        };
        _this.removeEmail = function (index) {
            _this.setState(function (prevState) {
                return {
                    emails: prevState.emails.slice(0, index).concat(prevState.emails.slice(index + 1)),
                };
            }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(_this.state.emails);
                }
            });
        };
        _this.handleOnKeydown = function (e) {
            switch (e.which) {
                case 13:
                case 9:
                    e.preventDefault();
                    break;
                case 8:
                    if (!e.currentTarget.value) {
                        _this.removeEmail(_this.state.emails.length - 1);
                    }
                    break;
            }
        };
        _this.handleOnKeyup = function (e) {
            switch (e.which) {
                case 13:
                case 9:
                    _this.findEmailAddress(e.currentTarget.value, true);
                    break;
            }
        };
        _this.handleOnChange = function (e) {
            return _this.onChangeInputValue(e.currentTarget.value);
        };
        _this.handleOnBlur = function (e) {
            _this.setState({ focused: false });
            _this.findEmailAddress(e.currentTarget.value, true);
        };
        _this.handleOnFocus = function () {
            return _this.setState({
                focused: true,
            });
        };
        _this.emailInputRef = React$c.createRef();
        return _this;
    }
    ReactMultiEmail.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.propsEmails !== nextProps.emails) {
            return {
                propsEmails: nextProps.emails || [],
                emails: nextProps.emails || [],
                inputValue: '',
                focused: false,
            };
        }
        return null;
    };
    ReactMultiEmail.prototype.render = function () {
        var _this = this;
        var _a = this.state, focused = _a.focused, emails = _a.emails, inputValue = _a.inputValue;
        var _b = this.props, style = _b.style, getLabel = _b.getLabel, _c = _b.className, className = _c === void 0 ? '' : _c, noClass = _b.noClass, placeholder = _b.placeholder;
        // removeEmail
        return (React$c.createElement("div", { className: className + " " + (noClass ? '' : 'react-multi-email') + " " + (focused ? 'focused' : '') + " " + (inputValue === '' && emails.length === 0 ? 'empty' : ''), style: style, onClick: function () {
                if (_this.emailInputRef.current) {
                    _this.emailInputRef.current.focus();
                }
            } },
            placeholder ? React$c.createElement("span", { "data-placeholder": true }, placeholder) : null,
            emails.map(function (email, index) {
                return getLabel(email, index, _this.removeEmail);
            }),
            React$c.createElement("input", { ref: this.emailInputRef, type: "text", value: inputValue, onFocus: this.handleOnFocus, onBlur: this.handleOnBlur, onChange: this.handleOnChange, onKeyDown: this.handleOnKeydown, onKeyUp: this.handleOnKeyup })));
    };
    return ReactMultiEmail;
}(React$c.Component));
ReactMultiEmail$2.default = ReactMultiEmail$1;

Object.defineProperty(commonjs, "__esModule", { value: true });
var isEmail_1 = isEmail$1;
commonjs.isEmail = isEmail_1.default;
var ReactMultiEmail_1 = ReactMultiEmail$2;
var ReactMultiEmail = commonjs.ReactMultiEmail = ReactMultiEmail_1.default;

var useStyles$M = makeStyles()(function (theme) { return ({
    reactMultiEmail: {
        margin: 0,
        maxWidth: '100%',
        '-webkit-box-flex': '1',
        '-ms-flex': '1 0 auto',
        flex: '1 0 auto',
        outline: '0',
        '-webkit-tap-highlight-color': '#000',
        textAlign: 'left',
        lineHeight: '1.21428571em',
        padding: '0.4em 0.5em',
        borderRadius: '0.28571429rem',
        '-webkit-transition': 'box-shadow 0.1s ease, border-color 0.1s ease',
        transition: 'box-shadow 0.1s ease, border-color 0.1s ease',
        fontSize: '13px',
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        alignContent: 'flex-start',
        border: 'none',
        background: "".concat(additionalPalette.lightBlue.main),
        minHeight: '128px',
        fontFamily: theme.typography.fontFamily,
        '&.focused': {
            '& span[data-placeholder]': {
                display: 'none'
            },
            backgroundColor: additionalPalette.lightBlue.main
        },
        '& span[data-placeholder]': {
            display: 'none',
            position: 'absolute',
            left: '0.5em',
            top: '0.4em',
            padding: '0.4em',
            lineHeight: '1.5'
        },
        '&.empty > span[data-placeholder]': {
            display: 'inline',
            fontSize: theme.spacing(2),
            lineHeight: '1.5',
            color: additionalPalette.grey.main
        },
        '& input': {
            flexGrow: 1,
            outline: 'none',
            border: '0 none !important',
            display: 'inline-block !important',
            lineHeight: '1.5',
            verticalAlign: 'baseline !important',
            padding: '0.4em',
            color: theme.palette.text.secondary,
            background: additionalPalette.lightBlue.main,
            fontSize: theme.spacing(2),
            fontWeight: 'normal'
        },
        '& [data-tag]': {
            verticalAlign: 'baseline',
            margin: '0.14285714em',
            backgroundImage: 'none',
            textTransform: 'none',
            border: '0 solid transparent',
            borderRadius: theme.spacing(0.5),
            '-webkit-transition': 'background 0.1s ease',
            '-o-transition': 'background 0.1s ease',
            transition: 'background 0.1s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            maxWidth: '100%',
            maxHeight: theme.spacing(4),
            backgroundColor: '#fff',
            lineHeight: '1.5',
            color: theme.palette.text.secondary,
            fontSize: theme.spacing(2),
            padding: theme.spacing(0, 0.5, 0, 1),
            userSelect: 'none',
            fontWeight: 'normal',
            '& [data-tag-item]': {
                maxWidth: '100%',
                overflow: 'hidden'
            },
            '& :first-child': {
                marginLeft: '0'
            },
            '& [data-tag-handle]': {
                cursor: 'pointer',
                display: 'inline-block',
                padding: '4px 8px',
                marginLeft: '5px',
                fontSize: theme.spacing(3),
                fontWeight: 300,
                borderRadius: '50%',
                '&:hover': {
                    color: theme.palette.secondary.main
                }
            }
        }
    }
}); });

var MultiEmaiInput = function (props) {
    var classes = useStyles$M().classes;
    var placeholder = props.placeholder, defaultEmails = props.emails, onEmailsChange = props.onEmailsChange;
    var _a = useState(defaultEmails || []), emails = _a[0], setEmails = _a[1];
    var removeDuplicates = function (list) { return Array.from(new Set(list)); };
    var handleEmailsChange = function (newEmails) {
        var uniqueEmails = removeDuplicates(newEmails);
        setEmails(uniqueEmails);
        onEmailsChange === null || onEmailsChange === void 0 ? void 0 : onEmailsChange(uniqueEmails);
    };
    var email = function (email, index, removeEmail) { return (jsxs("div", __assign$3({ "data-tag": true }, { children: [email, jsx$1("span", __assign$3({ role: "none", "data-tag-handle": true, onClick: function () { return removeEmail(index); } }, { children: "\u00D7" }))] }), index)); };
    return (jsx$1(ReactMultiEmail, { className: classes.reactMultiEmail, placeholder: placeholder, emails: emails, onChange: handleEmailsChange, getLabel: email }));
};

var VideoUploader = function (props) {
    var link = props.link, onChange = props.onChange, isLinkValid = props.isLinkValid;
    var classes = useStyles$P().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    var isError = link !== undefined && link.length > 0 && !isLinkValid;
    return (jsxs(Grid$2, __assign$3({ className: classes.sizingContainer }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, classes.videoText) }, { children: "Use a video from YouTube" })), jsx$1(Input$6, { value: link || '', onChange: function (event) { return onChange(event.target.value); }, variant: InputVariant.Filled, placeholder: "Paste or type a link", fullWidth: true, isError: isError, helperText: "Please enter a valid YouTube URL." })] })));
};

var convertYoutubeLinkToEmbed = function (link) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = link.match(regExp);
    return match && match[7].length === 11
        ? "https://www.youtube.com/embed/".concat(match[7])
        : link;
};
var isYouTubeUrlValid = function (url) {
    if (url.length === 0)
        return false;
    var extendedYouTubeUrlRegExp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/gi;
    return extendedYouTubeUrlRegExp.test(url);
};

var ImageUploader = function (props) {
    var _a = props.noThumbnailBorderRadius, noThumbnailBorderRadius = _a === void 0 ? false : _a, _b = props.shouldHideAddMediaButton, shouldHideAddMediaButton = _b === void 0 ? false : _b, _c = props.shouldHideRemoveMediaButton, shouldHideRemoveMediaButton = _c === void 0 ? false : _c, _d = props.isDialogOpened, isDialogOpened = _d === void 0 ? false : _d, _e = props.isMediaPresent, isMediaPresent = _e === void 0 ? false : _e, mediaType = props.mediaType, mediaUrl = props.mediaUrl, thumbnailUrl = props.thumbnailUrl, _f = props.loading, loading = _f === void 0 ? false : _f, _g = props.extensions, extensions = _g === void 0 ? ['jpg', 'jpeg', 'png'] : _g, _h = props.maxSizeMb, maxSizeMb = _h === void 0 ? 1 : _h, _j = props.allowVideo, allowVideo = _j === void 0 ? true : _j, _k = props.openMenuOnClick, openMenuOnClick = _k === void 0 ? false : _k, onFileUpload = props.onFileUpload, onMediaUrlSet = props.onMediaUrlSet, onRemoveMedia = props.onRemoveMedia, onCloseDialog = props.onCloseDialog;
    var classes = useStyles$P().classes;
    var _l = useTextStyles(), textClasses = _l.classes, classNames = _l.cx;
    var inputRef = useRef(null);
    var _m = useState(isDialogOpened), dialogOpen = _m[0], setDialogOpen = _m[1];
    var _o = useState(0), tabValue = _o[0], setTabValue = _o[1];
    var _p = useState(), internalMediaUrl = _p[0], setInternalMediaUrl = _p[1];
    var _q = useState(false), isValidImage = _q[0], setIsValidImage = _q[1];
    var _r = useState(), selectedFile = _r[0], setSelectedFile = _r[1];
    var _s = useState(), errorMessage = _s[0], setErrorMessage = _s[1];
    var _t = useState(false), mediaFullscreen = _t[0], setMediaFullscreen = _t[1];
    var _u = React__default.useState(null), mediaAnchorEl = _u[0], setMediaAnchorEl = _u[1];
    var _v = useState(false), isValidYouTubeUrl = _v[0], setIsValidYouTubeUrl = _v[1];
    useEffect(function () {
        // make it possible to control dialog state from the outside
        setDialogOpen(isDialogOpened);
    }, [isDialogOpened]);
    var handleRemoveTemporaryImage = function () {
        setIsValidImage(false);
        setInternalMediaUrl('');
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };
    var handleChangeTab = function (_, newValue) {
        setTabValue(newValue);
    };
    var handleVideoUrlChange = function (newUrl) {
        setIsValidImage(false);
        setInternalMediaUrl(newUrl);
        setIsValidYouTubeUrl(isYouTubeUrlValid(newUrl));
    };
    var handleOpenMediaMenu = function (event) {
        setMediaAnchorEl(event.currentTarget);
        return false;
    };
    var handleCloseMediaMenu = function () {
        setMediaAnchorEl(null);
        return false;
    };
    var handleRemoveMedia = function () {
        onRemoveMedia === null || onRemoveMedia === void 0 ? void 0 : onRemoveMedia();
        setMediaAnchorEl(null);
        return false;
    };
    var getImageUploader = function () {
        return !isValidImage ? (jsx$1(ImageDropZone, { extensions: extensions, maxSizeMb: maxSizeMb, inputRef: inputRef, errorMessage: errorMessage, setErrorMessage: setErrorMessage, setIsValidImage: setIsValidImage, setSelectedFile: setSelectedFile, setTempImageSource: setInternalMediaUrl, loading: loading })) : (jsx$1(ImageLoaded, { selectedFile: selectedFile, tempImageSource: internalMediaUrl, onRemoveTemporaryImage: handleRemoveTemporaryImage }));
    };
    var getAddMediaButton = function () {
        if (shouldHideAddMediaButton) {
            return null;
        }
        return (jsx$1(Button$1, __assign$3({ className: classes.negativeMargins, disabled: loading, variant: ButtonVariant.SecondaryNoOutline, onClick: function () { return setDialogOpen(true); }, buttonSize: ButtonSize.Small }, { children: "Add media" })));
    };
    var handleCloseDialog = function () {
        setDialogOpen(false);
        if (onCloseDialog) {
            onCloseDialog();
        }
    };
    var handleViewImage = function () {
        setMediaFullscreen(true);
        handleCloseMediaMenu();
    };
    var handleMediaMinimized = function () {
        setMediaFullscreen(false);
    };
    var isprimaryButtonDisabled = (tabValue === 0 && !isValidImage) || (tabValue === 1 && !isValidYouTubeUrl);
    return (jsxs(Fragment$1, { children: [isMediaPresent ? (jsxs(Fragment$1, { children: [jsxs(Grid$2, __assign$3({ item: true, style: { margin: '-8px -4px' }, className: classes.mediaUploader }, { children: [!shouldHideRemoveMediaButton && (jsx$1(Button$1, __assign$3({ variant: ButtonVariant.SecondaryNoOutline, disabled: loading, onClick: handleRemoveMedia, buttonSize: ButtonSize.Small }, { children: "Remove" }))), jsx$1(Media, { mediaUrl: mediaUrl, thumbnailUrl: thumbnailUrl, mediaType: mediaType, mediaFullscreen: mediaFullscreen, noBorderRadius: noThumbnailBorderRadius, openMenuOnClick: openMenuOnClick, onMediaClick: handleOpenMediaMenu, onMediaMinimized: handleMediaMinimized })] })), jsxs(MuiMenu, __assign$3({ elevation: 1, anchorEl: mediaAnchorEl, open: Boolean(mediaAnchorEl), onClose: handleCloseMediaMenu, anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center'
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        } }, { children: [jsx$1(MuiMenuItem, __assign$3({ onClick: handleViewImage }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeMs) }, { children: "View image" })) })), jsx$1(MuiMenuItem, __assign$3({ onClick: handleRemoveMedia }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeMs) }, { children: "Remove image" })) }))] }))] })) : (getAddMediaButton()), jsx$1(Dialog, __assign$3({ open: dialogOpen, title: "Add media", maxWidth: DialogMaxWidth.Md, primaryButtonText: "Save", primaryButtonDisabled: isprimaryButtonDisabled, onClose: function () {
                    setErrorMessage(undefined);
                    handleCloseDialog();
                }, primaryButtonClick: function () {
                    handleCloseDialog();
                    if (tabValue === 0 && selectedFile) {
                        onFileUpload === null || onFileUpload === void 0 ? void 0 : onFileUpload(selectedFile);
                        setTimeout(function () {
                            handleRemoveTemporaryImage();
                        }, 0);
                    }
                    else if (tabValue === 1 && internalMediaUrl) {
                        onMediaUrlSet === null || onMediaUrlSet === void 0 ? void 0 : onMediaUrlSet(convertYoutubeLinkToEmbed(internalMediaUrl));
                        setTimeout(function () {
                            handleRemoveTemporaryImage();
                        }, 0);
                    }
                } }, { children: jsxs(Grid$2, { children: [jsxs(Tabs$1, __assign$3({ value: tabValue, onChange: handleChangeTab, classes: {
                                root: classes.tabsRoot,
                                indicator: classes.tabsIndicator
                            } }, { children: [jsx$1(Tab$3, { label: "Image", disableRipple: true, classes: { root: classes.tabRoot, selected: classes.tabSelected } }), allowVideo && (jsx$1(Tab$3, { label: "Video", disableRipple: true, classes: {
                                        root: classes.tabRoot,
                                        selected: classes.tabSelected
                                    } }))] })), tabValue === 1 ? (jsx$1(VideoUploader, { link: internalMediaUrl, onChange: handleVideoUrlChange, isLinkValid: isValidYouTubeUrl })) : (getImageUploader())] }) }))] }));
};

var useStyles$L = makeStyles()(function (theme) { return ({
    buttonRoot: {
        padding: theme.spacing(0.5, 1.5, 0.5, 2.5)
    },
    buttonRootTransparent: {
        padding: theme.spacing(0.5, 0.5, 0.5, 0),
        '&:hover': {
            backgroundColor: 'transparent',
            cursor: 'default'
        }
    },
    list: {
        padding: 0
    },
    menu: {
        borderRadius: theme.spacing(0.25),
        marginTop: 1
    },
    menuButton: {
        borderRadius: 0,
        border: 'none',
        '&.MuiButton-outlinedSecondary.Mui-disabled': {
            border: 'none'
        },
        '&:hover': {
            border: 'none'
        },
        height: '100%'
    },
    option: {
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    optionText: {
        '&:hover': {
            color: theme.palette.primary.main
        }
    },
    leftSubtitle: {
        paddingRight: theme.spacing(1),
        textTransform: 'none'
    },
    title: {
        overflow: 'hidden',
        textTransform: 'none'
    },
    listItem: {
        '&.MuiListItem-root': {
            padding: 0
        }
    },
    error: {
        backgroundColor: theme.palette.error.main,
        padding: theme.spacing(0.75, 0.25, 0.75, 0.75),
        borderRadius: theme.spacing(0.25),
        cursor: 'pointer'
    },
    errorText: {
        color: theme.palette.background.default
    }
}); });

var InfoPanelIconVariant;
(function (InfoPanelIconVariant) {
    InfoPanelIconVariant[InfoPanelIconVariant["Chevron"] = 0] = "Chevron";
    InfoPanelIconVariant[InfoPanelIconVariant["Kebab"] = 1] = "Kebab";
})(InfoPanelIconVariant || (InfoPanelIconVariant = {}));
var InfoPanelVariant;
(function (InfoPanelVariant) {
    InfoPanelVariant[InfoPanelVariant["Error"] = 0] = "Error";
    InfoPanelVariant[InfoPanelVariant["Standard"] = 1] = "Standard";
})(InfoPanelVariant || (InfoPanelVariant = {}));
var menuIconMap = new Map([
    [InfoPanelIconVariant.Chevron, IconName.KeyboardArrowDown],
    [InfoPanelIconVariant.Kebab, IconName.MoreVert]
]);
var InfoPanel = function (props) {
    var _a;
    var title = props.title, leftSubtitle = props.leftSubtitle, children = props.children, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.disabledWithColor, disabledWithColor = _c === void 0 ? false : _c, _d = props.iconName, iconName = _d === void 0 ? InfoPanelIconVariant.Chevron : _d, _e = props.closeMenuOnItemClick, closeMenuOnItemClick = _e === void 0 ? false : _e, _f = props.titleTextColor, titleTextColor = _f === void 0 ? TextHighlight.Standard : _f, _g = props.variant, variant = _g === void 0 ? InfoPanelVariant.Standard : _g;
    var classes = useStyles$L().classes;
    var _h = useTextStyles(), textClasses = _h.classes, classNames = _h.cx;
    var _j = React__default.useState(null), anchorEl = _j[0], setAnchorEl = _j[1];
    var handleClick = function (event) {
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var onMenuItemClick = function () {
        if (closeMenuOnItemClick) {
            handleClose();
        }
    };
    var menuIcon = menuIconMap.get(iconName) || IconName.KeyboardArrowDown;
    var iconColor = disabled && disabledWithColor ? IconColor$1.Disabled : IconColor$1.Emphasis;
    return (jsxs(Button$3, __assign$3({ disableTouchRipple: true, className: classes.menuButton, classes: {
            root: variant === InfoPanelVariant.Error
                ? classes.buttonRootTransparent
                : classes.buttonRoot
        }, color: "secondary", onClick: handleClick, variant: "outlined", disabled: disabled }, { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "column", justifyContent: "flex-start", alignContent: "center" }, { children: [variant === InfoPanelVariant.Standard && (jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "flex-start", alignItems: "center" }, { children: [leftSubtitle && (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.sizeMs, textClasses.noWrap, classes.leftSubtitle) }, { children: leftSubtitle }))), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.sizeMs, textClasses.weightSemiBold, textClasses.noWrap, disabledWithColor
                                    ? textClasses.highlightBackground
                                    : textClasses[(_a = classNameByHighlight.get(titleTextColor)) !== null && _a !== void 0 ? _a : 'highlightStandard'], classes.title) }, { children: title })), jsx$1(Icon, { name: menuIcon, size: IconSize$1.Large, iconColor: iconColor })] }))), variant === InfoPanelVariant.Error && (jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "center", alignItems: "center", className: classes.error }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.weightSemiBold, classes.errorText) }, { children: title })), jsx$1(Icon, { iconColor: IconColor$1.White, name: IconName.KeyboardArrowDown, size: IconSize$1.Medium, className: classes.errorText })] })))] })), jsx$1(MuiMenu, __assign$3({ id: "customized-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, color: "secondary", classes: { paper: classes.menu, list: classes.list }, elevation: 1, 
                // getContentAnchorEl={null}
                onClick: onMenuItemClick, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                } }, { children: children }))] })));
};

var ComponentType;
(function (ComponentType) {
    ComponentType["Div"] = "div";
    ComponentType["Li"] = "li";
    ComponentType["Span"] = "span";
})(ComponentType || (ComponentType = {}));

var useStyles$K = makeStyles()(function (theme) { return ({
    paperStyle: {
        width: '100%',
        display: 'inline-block'
    },
    paddingPaper: {
        padding: theme.spacing(2, 3, 2, 3)
    }
}); });

var Paper = function (props) {
    var children = props.children, className = props.className, onClick = props.onClick, innerRef = props.innerRef, _a = props.component, component = _a === void 0 ? ComponentType.Div : _a;
    var _b = useStyles$K(), classes = _b.classes, classNames = _b.cx;
    return (jsx$1(Paper$2, __assign$3({}, props, { ref: innerRef, component: component, elevation: 1, className: classNames(classes.paperStyle, className), onClick: onClick }, { children: children })));
};

var MAX_CONTENT_WIDTH = 640;

var useStyles$J = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        progress: {
            width: '100%'
        },
        marginTop: {
            marginTop: theme.spacing(5)
        },
        marginBottom: {
            marginBottom: theme.spacing(5)
        },
        title: {
            fontSize: theme.spacing(props.isPreviewPanel ? 2 : 3),
            marginTop: theme.spacing(1),
            textAlign: 'center',
            // TODO: remove this once the bug with exporting styles is solved
            padding: props.isPreviewPanel ? theme.spacing(0, 2) : 0,
            '& .public-DraftStyleDefault-block.public-DraftStyleDefault-block': {
                textAlign: 'center'
            }
        },
        marginLeftRight: {
            marginLeft: theme.spacing(2.5),
            marginRight: theme.spacing(2.5)
        },
        content: {
            // There is an issue related to different behaviour of building styles
            // in dev and prod. The issue: https://github.com/mui-org/material-ui/issues/25324
            // Margin cannot be overriden in a simple way (without using !important
            // or increasing specificity with additional classes), so padding does the job.
            // TODO: find a way to override material-ui styles or increase
            // custom styles specificity easily.
            padding: theme.spacing(3)
        },
        textInstructionContent: {
            padding: theme.spacing(0, 5)
        },
        contentMaxWidth: {
            maxWidth: "".concat(MAX_CONTENT_WIDTH, "px")
        },
        page: {
            backgroundColor: additionalPalette.lightBlue.main
        },
        nextButton: {
            marginTop: theme.spacing(3),
            maxWidth: "".concat(MAX_CONTENT_WIDTH, "px")
        }
    });
});

var textColors = new Map([
    [IconColor$1.Primary, TextHighlight.Primary],
    [IconColor$1.Text, TextHighlight.Standard],
    [IconColor$1.Background, TextHighlight.Background]
]);
var IconButton = function (props) {
    var _a, _b, _c, _d;
    var iconName = props.iconName, _e = props.ariaLabel, ariaLabel = _e === void 0 ? 'Icon Button' : _e, onClick = props.onClick, text = props.text, className = props.className, _f = props.disabled, disabled = _f === void 0 ? false : _f, _g = props.size, size = _g === void 0 ? 'large' : _g, _h = props.iconSize, iconSize = _h === void 0 ? IconSize$1.Medium : _h, _j = props.iconColor, iconColor = _j === void 0 ? IconColor$1.Background : _j, _k = props.negativePadding, negativePadding = _k === void 0 ? false : _k, _l = props.hasShadow, hasShadow = _l === void 0 ? false : _l, _m = props.badgeColor, badgeColor = _m === void 0 ? BadgeColor.Text : _m, _o = props.badgeContent, badgeContent = _o === void 0 ? undefined : _o, _p = props.badgeVerticalAnchor, badgeVerticalAnchor = _p === void 0 ? 'top' : _p, _q = props.smallHoverShadowSize, smallHoverShadowSize = _q === void 0 ? false : _q, dataCy = props.dataCy, tooltipText = props.tooltipText;
    var _r = useStyles$T({}), classes = _r.classes, classNames = _r.cx;
    var textClasses = useTextStyles().classes;
    var textHighlight = textColors.get(iconColor);
    var getTextComponent = function () {
        var _a;
        if (!text) {
            return null;
        }
        if (typeof text === 'string') {
            return (jsx$1("p", __assign$3({ "aria-label": ariaLabel, className: classNames(textClasses.default, textClasses.weightBold, textClasses.sizeM, textClasses[(_a = classNameByHighlight.get(textHighlight !== null && textHighlight !== void 0 ? textHighlight : TextHighlight.Background)) !== null && _a !== void 0 ? _a : 'highlightBackground'], classes.iconButtonText) }, { children: text })));
        }
        return text;
    };
    var iconButton = (jsxs(IconButton$2, __assign$3({ className: classNames(className, (_a = {}, _a[classes.iconButtonShadow] = hasShadow, _a), (_b = {}, _b[classes.iconButtonNegativePadding] = negativePadding, _b), (_c = {}, _c[classes.iconButtonSmallHoverShadowSize] = smallHoverShadowSize, _c), (_d = {}, _d[classes.withText] = !!text, _d)), onClick: onClick, disabled: disabled, "aria-label": ariaLabel, size: size, "data-cy": dataCy }, { children: [getTextComponent(), jsx$1(Icon, { "aria-label": ariaLabel, iconColor: iconColor, name: iconName, size: iconSize, badgeContent: badgeContent, badgeColor: badgeColor, badgeVerticalAnchor: badgeVerticalAnchor })] })));
    return tooltipText ? (jsx$1(Tooltip$3, __assign$3({ title: tooltipText, placement: "top" }, { children: iconButton }))) : (iconButton);
};

var useStyles$I = makeStyles()(function (theme) { return ({
    marginTop: {
        marginTop: theme.spacing(5),
        maxWidth: "".concat(MAX_CONTENT_WIDTH, "px")
    },
    forkText: {
        textAlign: 'center'
    }
}); });

var getNextIcon = function (direction) {
    return direction === 'ltr' ? IconName.ChevronRight : IconName.ChevronLeft;
};
var getPreviousIcon = function (direction) {
    return direction === 'ltr' ? IconName.ChevronLeft : IconName.ChevronRight;
};
var SurveyProgress = function (props) {
    var _a;
    var progress = props.progress, preview = props.preview, isPreviewPanel = props.isPreviewPanel;
    var classes = useStyles$I().classes;
    var _b = useTextStyles(), textClasses = _b.classes, classNames = _b.cx;
    var theme = useTheme();
    var textSize = isPreviewPanel ? TextSize.ms : TextSize.ml;
    var nextIcon = getNextIcon(theme.direction);
    var previousIcon = getPreviousIcon(theme.direction);
    var isPreview = preview && preview.isPreview;
    return (jsxs(Grid$2, __assign$3({ container: true, direction: "row", className: classes.marginTop }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, justifyContent: "flex-start", alignItems: "center", xs: 3 }, { children: isPreview && (jsx$1(IconButton, { onClick: preview.onClickRefresh, iconName: IconName.Refresh })) })), jsxs(Grid$2, __assign$3({ item: true, container: true, justifyContent: "center", alignItems: "center", xs: 6 }, { children: [isPreview && (jsx$1(IconButton, { onClick: preview.onNavigateBackward, disabled: progress.current === 0, iconName: previousIcon })), jsxs("p", __assign$3({ className: classNames(textClasses.default, textClasses.marginLeft, textClasses.marginRight, textClasses.highlightBackground, textClasses[(_a = classNameBySize.get(textSize)) !== null && _a !== void 0 ? _a : 'sizeMs']) }, { children: [progress.current + 1, " / ", progress.total] })), isPreview && (jsx$1(IconButton, { onClick: preview.onNavigateForward, disabled: progress.current + 1 === progress.total, iconName: nextIcon }))] })), jsx$1(Grid$2, __assign$3({ item: true, container: true, xs: 3, justifyContent: "flex-end", alignItems: "center" }, { children: isPreview && (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.displayInline, textClasses.sizeS, textClasses.highlightBackground, classes.forkText) }, { children: preview.forkDetails }))) }))] })));
};

var immutable = {exports: {}};

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (module, exports) {
(function (global, factory) {
  module.exports = factory() ;
}(commonjsGlobal, function () {var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); };
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  };

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        };
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value);
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    };
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    };
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    };
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    };
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      };
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    };

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    };
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));
}(immutable));

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var Immutable$q = immutable.exports;

var OrderedMap$6 = Immutable$q.OrderedMap;
var BlockMapBuilder$5 = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap$6(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};
var BlockMapBuilder_1 = BlockMapBuilder$5;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _inheritsLoose$g(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _require$6 = immutable.exports,
    Map$c = _require$6.Map,
    OrderedSet$6 = _require$6.OrderedSet,
    Record$7 = _require$6.Record; // Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET$3 = OrderedSet$6();
var defaultRecord$5 = {
  style: EMPTY_SET$3,
  entity: null
};
var CharacterMetadataRecord = Record$7(defaultRecord$5);

var CharacterMetadata$c = /*#__PURE__*/function (_CharacterMetadataRec) {
  _inheritsLoose$g(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    return _CharacterMetadataRec.apply(this, arguments) || this;
  }

  var _proto = CharacterMetadata.prototype;

  _proto.getStyle = function getStyle() {
    return this.get('style');
  };

  _proto.getEntity = function getEntity() {
    return this.get('entity');
  };

  _proto.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  }
  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */
  ;

  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET$3,
      entity: null
    }; // Fill in unspecified properties, if necessary.

    var configMap = Map$c(defaultConfig).merge(config);
    var existing = pool.get(configMap);

    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  CharacterMetadata.fromJS = function fromJS(_ref) {
    var style = _ref.style,
        entity = _ref.entity;
    return new CharacterMetadata({
      style: Array.isArray(style) ? OrderedSet$6(style) : style,
      entity: Array.isArray(entity) ? OrderedSet$6(entity) : entity
    });
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata$c();
var pool = Map$c([[Map$c(defaultRecord$5), EMPTY]]);
CharacterMetadata$c.EMPTY = EMPTY;
var CharacterMetadata_1 = CharacterMetadata$c;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable$5(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;
  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }

      cursor = nextIndex;
    }

    return nextValue;
  });
  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

var findRangesImmutable_1 = findRangesImmutable$5;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _inheritsLoose$f(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata$b = CharacterMetadata_1;

var findRangesImmutable$4 = findRangesImmutable_1;

var Immutable$p = immutable.exports;

var List$e = Immutable$p.List,
    Map$b = Immutable$p.Map,
    OrderedSet$5 = Immutable$p.OrderedSet,
    Record$6 = Immutable$p.Record,
    Repeat$6 = Immutable$p.Repeat;
var EMPTY_SET$2 = OrderedSet$5();
var defaultRecord$4 = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List$e(),
  depth: 0,
  data: Map$b()
};
var ContentBlockRecord$2 = Record$6(defaultRecord$4);

var decorateCharacterList$1 = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List$e(Repeat$6(CharacterMetadata$b.EMPTY, text.length));
  }

  return config;
};

var ContentBlock$7 = /*#__PURE__*/function (_ContentBlockRecord) {
  _inheritsLoose$f(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    return _ContentBlockRecord.call(this, decorateCharacterList$1(config)) || this;
  }

  var _proto = ContentBlock.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$2;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  }
  /**
   * Execute a callback for every contiguous range of styles within the block.
   */
  ;

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable$4(this.getCharacterList(), haveEqualStyle$1, filterFn, callback);
  }
  /**
   * Execute a callback for every contiguous range of entities within the block.
   */
  ;

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable$4(this.getCharacterList(), haveEqualEntity$1, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord$2);

function haveEqualStyle$1(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity$1(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

var ContentBlock_1 = ContentBlock$7;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

function _inheritsLoose$e(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata$a = CharacterMetadata_1;

var findRangesImmutable$3 = findRangesImmutable_1;

var Immutable$o = immutable.exports;

var List$d = Immutable$o.List,
    Map$a = Immutable$o.Map,
    OrderedSet$4 = Immutable$o.OrderedSet,
    Record$5 = Immutable$o.Record,
    Repeat$5 = Immutable$o.Repeat;
var EMPTY_SET$1 = OrderedSet$4();
var defaultRecord$3 = {
  parent: null,
  characterList: List$d(),
  data: Map$a(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List$d(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List$d(Repeat$5(CharacterMetadata$a.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode$c = /*#__PURE__*/function (_ref) {
  _inheritsLoose$e(ContentBlockNode, _ref);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord$3;

    /* eslint-disable-next-line constructor-super */
    return _ref.call(this, decorateCharacterList(props)) || this;
  }

  var _proto = ContentBlockNode.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$1;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  _proto.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  _proto.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  _proto.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  _proto.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable$3(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable$3(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record$5(defaultRecord$3));

var ContentBlockNode_1 = ContentBlockNode$c;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var CharacterMetadata$9 = CharacterMetadata_1;

var _require$5 = immutable.exports,
    Map$9 = _require$5.Map;

var ContentStateInlineStyle$1 = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },
  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map$9([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;

    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata$9.applyStyle(current, inlineStyle) : CharacterMetadata$9.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var ContentStateInlineStyle_1 = ContentStateInlineStyle$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var CharacterMetadata$8 = CharacterMetadata_1;

function applyEntityToContentBlock$1(contentBlock, startArg, end, entityKey) {
  var start = startArg;
  var characterList = contentBlock.getCharacterList();

  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata$8.applyEntity(characterList.get(start), entityKey));
    start++;
  }

  return contentBlock.set('characterList', characterList);
}

var applyEntityToContentBlock_1 = applyEntityToContentBlock$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var applyEntityToContentBlock = applyEntityToContentBlock_1;

var Immutable$n = immutable.exports;

function applyEntityToContentState$1(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable$n.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var applyEntityToContentState_1 = applyEntityToContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments$1 = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function (
    /*string*/
    segment,
    /*number*/
    ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }

      return segment;
    });
    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.

      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};
var DraftEntitySegments_1 = DraftEntitySegments$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var validateFormat = process.env.NODE_ENV !== "production" ? function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
} : function (format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant$x(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

var invariant_1 = invariant$x;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var invariant$w = invariant_1;
/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */


function getRangesForDraftEntity$1(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({
      start: start,
      end: end
    });
  });
  !!!ranges.length ? process.env.NODE_ENV !== "production" ? invariant$w(false, 'Entity key not found in this range.') : invariant$w(false) : void 0;
  return ranges;
}

var getRangesForDraftEntity_1 = getRangesForDraftEntity$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftEntitySegments = DraftEntitySegments_1;

var getRangesForDraftEntity = getRangesForDraftEntity_1;

var invariant$v = invariant_1;
/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */


function getCharacterRemovalRange$1(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);

  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }

  var newSelectionState = selectionState;

  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);

    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);

    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }

  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();

  var entity = entityMap.__get(entityKey);

  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.

  if (mutability === 'MUTABLE') {
    return selectionState;
  } // Find the entity range that overlaps with our removal range.


  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });
  !(entityRanges.length == 1) ? process.env.NODE_ENV !== "production" ? invariant$v(false, 'There should only be one entity range within this removal range.') : invariant$v(false) : void 0;
  var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.

  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  } // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.


  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

var getCharacterRemovalRange_1 = getCharacterRemovalRange$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey$a() {
  var key;

  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }

  seenKeys[key] = true;
  return key;
}

var generateRandomKey_1 = generateRandomKey$a;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var ContentBlockNode$b = ContentBlockNode_1;

var generateRandomKey$9 = generateRandomKey_1;

var Immutable$m = immutable.exports;

var OrderedMap$5 = Immutable$m.OrderedMap;

var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links

  var lastRootBlock;
  return OrderedMap$5(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey(); // new key that we will use to build linking

      var key = generateRandomKey$9(); // we will add it here to re-use it later

      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);

        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);

        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);

        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap$5(blockMap.toArray().map(function (block) {
    var key = generateRandomKey$9();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys$2 = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode$b;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

var randomizeBlockMapKeys_1 = randomizeBlockMapKeys$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var CharacterMetadata$7 = CharacterMetadata_1;

var findRangesImmutable$2 = findRangesImmutable_1;

var invariant$u = invariant_1;

function removeEntitiesAtEdges$2(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();
  var updatedBlocks = {};
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);

  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}
/**
 * Given a list of characters and an offset that is in the middle of an entity,
 * returns the start and end of the entity that is overlapping the offset.
 * Note: This method requires that the offset be in an entity range.
 */


function getRemovalRange(characters, entityKey, offset) {
  var removalRange; // Iterates through a list looking for ranges of matching items
  // based on the 'isEqual' callback.
  // Then instead of returning the result, call the 'found' callback
  // with each range.
  // Then filters those ranges based on the 'filter' callback
  //
  // Here we use it to find ranges of characters with the same entity key.

  findRangesImmutable$2(characters, // the list to iterate through
  function (a, b) {
    return a.getEntity() === b.getEntity();
  }, // 'isEqual' callback
  function (element) {
    return element.getEntity() === entityKey;
  }, // 'filter' callback
  function (start, end) {
    // 'found' callback
    if (start <= offset && end >= offset) {
      // this entity overlaps the offset index
      removalRange = {
        start: start,
        end: end
      };
    }
  });
  !(typeof removalRange === 'object') ? process.env.NODE_ENV !== "production" ? invariant$u(false, 'Removal range must exist within character list.') : invariant$u(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);

    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;

      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata$7.applyEntity(current, null));
        start++;
      }

      return block.set('characterList', chars);
    }
  }

  return block;
}

var removeEntitiesAtEdges_1 = removeEntitiesAtEdges$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var randomizeBlockMapKeys$1 = randomizeBlockMapKeys_1;

var removeEntitiesAtEdges$1 = removeEntitiesAtEdges_1;

var getContentStateFragment$4 = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.

  var contentWithoutEdgeEntities = removeEntitiesAtEdges$1(contentState, selectionState);
  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;
  return randomizeBlockMapKeys$1(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

var getContentStateFragment_1 = getContentStateFragment$4;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList$2(targetListArg, toInsert, offset) {
  var targetList = targetListArg;

  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }

  return targetList;
}

var insertIntoList_1 = insertIntoList$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var BlockMapBuilder$4 = BlockMapBuilder_1;

var ContentBlockNode$a = ContentBlockNode_1;

var Immutable$l = immutable.exports;

var insertIntoList$1 = insertIntoList_1;

var invariant$t = invariant_1;

var randomizeBlockMapKeys = randomizeBlockMapKeys_1;

var List$c = Immutable$l.List;

var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var mergeBlockData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'REPLACE_WITH_NEW_DATA';
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;
  var data = null;

  switch (mergeBlockData) {
    case 'MERGE_OLD_DATA_TO_NEW_DATA':
      data = fragmentBlock.getData().merge(targetBlock.getData());
      break;

    case 'REPLACE_WITH_NEW_DATA':
      data = fragmentBlock.getData();
      break;
  }

  var type = targetBlock.getType();

  if (text && type === 'unstyled') {
    type = fragmentBlock.getType();
  }

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList$1(chars, fragmentBlock.getCharacterList(), targetOffset),
    type: type,
    data: data
  });
  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */


var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();
  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};
/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */


var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();
  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block

  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks$3 = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    } // update the last root block fragment


    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block

    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    } // update fragment parent links


    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    }); // update targetBlock parent child links

    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();
      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;
      var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children

      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
      blockMapState.setIn([targetParentKey, 'children'], List$c(newChildrenKeysArray));
    }
  });
};

var insertFragment$1 = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode$a;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    } // Insert fragment blocks after the head and before the tail.


    fragment // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    }); // update tail

    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });
  var updatedBlockMap = BlockMapBuilder$4.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks$3(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState$1 = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$t(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant$t(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();
  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode$a) {
    !targetBlock.getChildKeys().isEmpty() ? process.env.NODE_ENV !== "production" ? invariant$t(false, '`insertFragment` should not be called when a container node is selected.') : invariant$t(false) : void 0;
  } // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block


  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset, mergeBlockData);
  }

  return insertFragment$1(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

var insertFragmentIntoContentState_1 = insertFragmentIntoContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var Immutable$k = immutable.exports;

var insertIntoList = insertIntoList_1;

var invariant$s = invariant_1;

var Repeat$4 = Immutable$k.Repeat;

function insertTextIntoContentState$1(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$s(false, '`insertText` should only be called with a collapsed range.') : invariant$s(false) : void 0;
  var len = null;

  if (text != null) {
    len = text.length;
  }

  if (len == null || len === 0) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();
  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat$4(characterMetadata, len).toList(), offset)
  });
  var newOffset = offset + len;
  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

var insertTextIntoContentState_1 = insertTextIntoContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var Immutable$j = immutable.exports;

var Map$8 = Immutable$j.Map;

function modifyBlockForContentState$2(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map$8([[endKey, blockMap.get(endKey)]])).map(operation);
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var modifyBlockForContentState_1 = modifyBlockForContentState$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var ContentBlockNode$9 = ContentBlockNode_1;

var getNextDelimiterBlockKey$2 = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode$9;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);

  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

var getNextDelimiterBlockKey_1 = getNextDelimiterBlockKey$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var ContentBlockNode$8 = ContentBlockNode_1;

var getNextDelimiterBlockKey$1 = getNextDelimiterBlockKey_1;

var Immutable$i = immutable.exports;

Immutable$i.List;
    var Map$7 = Immutable$i.Map;

var transformBlock$2 = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};
/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */


var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);

  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();

    if (parentKey) {
      parents.push(parentKey);
    }

    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};
/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */


var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey$1(block, blockMap);

  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);

    nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance

    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey$1(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks$2 = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock$2(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update endblock if its retained

    transformBlock$2(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update start block parent ancestors

    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock$2(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update start block next - can only happen if startBlock == endBlock

    transformBlock$2(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    }); // update start block prev

    transformBlock$2(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block next

    transformBlock$2(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block prev

    transformBlock$2(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    }); // update end block parent ancestors

    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock$2(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update next delimiters all the way to a root delimiter

    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock$2(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // if parent (startBlock) was deleted

    if (blockMap.get(startBlock.getKey()) == null && blockMap.get(endBlock.getKey()) != null && endBlock.getParentKey() === startBlock.getKey() && endBlock.getPrevSiblingKey() == null) {
      var prevSiblingKey = startBlock.getPrevSiblingKey(); // endBlock becomes next sibling of parent's prevSibling

      transformBlock$2(endBlock.getKey(), blocks, function (block) {
        return block.merge({
          prevSibling: prevSiblingKey
        });
      });
      transformBlock$2(prevSiblingKey, blocks, function (block) {
        return block.merge({
          nextSibling: endBlock.getKey()
        });
      }); // Update parent for previous parent's children, and children for that parent

      var prevSibling = prevSiblingKey ? blockMap.get(prevSiblingKey) : null;
      var newParentKey = prevSibling ? prevSibling.getParentKey() : null;
      startBlock.getChildKeys().forEach(function (childKey) {
        transformBlock$2(childKey, blocks, function (block) {
          return block.merge({
            parent: newParentKey // set to null if there is no parent

          });
        });
      });

      if (newParentKey != null) {
        var newParent = blockMap.get(newParentKey);
        transformBlock$2(newParentKey, blocks, function (block) {
          return block.merge({
            children: newParent.getChildKeys().concat(startBlock.getChildKeys())
          });
        });
      } // last child of deleted parent should point to next sibling


      transformBlock$2(startBlock.getChildKeys().find(function (key) {
        var block = blockMap.get(key);
        return block.getNextSiblingKey() === null;
      }), blocks, function (block) {
        return block.merge({
          nextSibling: startBlock.getNextSiblingKey()
        });
      });
    }
  });
};

var removeRangeFromContentState$1 = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together

  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode$8; // used to retain blocks that should not be deleted to avoid orphan children

  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected siblings so we can not remove its ancestors parents

    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    } // endBlock has children so can not remove this block or any of its ancestors


    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    } // we need to retain all ancestors of the next delimiter block


    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey$1(endBlock, blockMap), blockMap));
  }

  var characterList;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  }); // If cursor (collapsed) is at the start of the first child, delete parent
  // instead of child

  var shouldDeleteParent = isExperimentalTreeBlock && startOffset === 0 && endOffset === 0 && endBlock.getParentKey() === startKey && endBlock.getPrevSiblingKey() == null;
  var newBlocks = shouldDeleteParent ? Map$7([[startKey, null]]) : blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map$7([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });
  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  }); // Only update tree block pointers if the range is across blocks

  if (isExperimentalTreeBlock && startBlock !== endBlock) {
    updatedBlockMap = updateBlockMapLinks$2(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};
/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */


var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }

  return targetList;
};

var removeRangeFromContentState_1 = removeRangeFromContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var ContentBlockNode$7 = ContentBlockNode_1;

var generateRandomKey$8 = generateRandomKey_1;

var Immutable$h = immutable.exports;

var invariant$r = invariant_1;

var modifyBlockForContentState$1 = modifyBlockForContentState_1;

var List$b = Immutable$h.List,
    Map$6 = Immutable$h.Map;

var transformBlock$1 = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks$1 = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey(); // update block parent

    transformBlock$1(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
      return block.merge({
        children: List$b(newChildrenArray)
      });
    }); // update original next block

    transformBlock$1(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    }); // update original block

    transformBlock$1(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    }); // update below block

    transformBlock$1(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState$1 = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$r(false, 'Selection range must be collapsed.') : invariant$r(false) : void 0;
  var key = selectionState.getAnchorKey();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();

  if (!text) {
    var blockType = blockToSplit.getType();

    if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
      return modifyBlockForContentState$1(contentState, selectionState, function (block) {
        return block.merge({
          type: 'unstyled',
          depth: 0
        });
      });
    }
  }

  var offset = selectionState.getAnchorOffset();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey$8();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode$7;
  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map$6()
  });
  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ? process.env.NODE_ENV !== "production" ? invariant$r(false, 'ContentBlockNode must not have children') : invariant$r(false) : void 0;
    newBlocks = updateBlockMapLinks$1(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

var splitBlockInContentState_1 = splitBlockInContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var CharacterMetadata$6 = CharacterMetadata_1;

var ContentStateInlineStyle = ContentStateInlineStyle_1;

var applyEntityToContentState = applyEntityToContentState_1;

var getCharacterRemovalRange = getCharacterRemovalRange_1;

var getContentStateFragment$3 = getContentStateFragment_1;

var Immutable$g = immutable.exports;

var insertFragmentIntoContentState = insertFragmentIntoContentState_1;

var insertTextIntoContentState = insertTextIntoContentState_1;

var invariant$q = invariant_1;

var modifyBlockForContentState = modifyBlockForContentState_1;

var removeEntitiesAtEdges = removeEntitiesAtEdges_1;

var removeRangeFromContentState = removeRangeFromContentState_1;

var splitBlockInContentState = splitBlockInContentState_1;

var OrderedSet$3 = Immutable$g.OrderedSet;
/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier$e = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
    var character = CharacterMetadata$6.create({
      style: inlineStyle || OrderedSet$3(),
      entity: entityKey || null
    });
    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },
  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ? process.env.NODE_ENV !== "production" ? invariant$q(false, 'Target range must be collapsed for `insertText`.') : invariant$q(false) : void 0;
    return DraftModifier$e.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },
  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment$3(contentState, removalRange);
    var afterRemoval = DraftModifier$e.removeRange(contentState, removalRange, 'backward');
    return DraftModifier$e.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },
  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment, mergeBlockData);
  },
  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey, endKey, startBlock, endBlock;

    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }

    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();
    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.

    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, adjustedRemovalRange);
      }
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
    return removeRangeFromContentState(withoutEntities, rangeToRemove);
  },
  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },
  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },
  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },
  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        type: blockType,
        depth: 0
      });
    });
  },
  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: blockData
      });
    });
  },
  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: block.getData().merge(blockData)
      });
    });
  },
  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};
var DraftModifier_1 = DraftModifier$e;

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * 
 * @typechecks
 * @format
 */

/**
 * Retrieve an object's own values as an array. If you want the values in the
 * protoype chain, too, use getObjectValuesIncludingPrototype.
 *
 * If you are looking for a function that creates an Array instance based
 * on an "Array-like" object, use createArrayFrom instead.
 *
 * @param {object} obj An object.
 * @return {array}     The object's values.
 */
function getOwnObjectValues$2(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

var getOwnObjectValues_1 = getOwnObjectValues$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$k(target, key, source[key]); }); } return target; }

function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var findRangesImmutable$1 = findRangesImmutable_1;

var getOwnObjectValues$1 = getOwnObjectValues_1;

var Immutable$f = immutable.exports;

var List$a = Immutable$f.List,
    Repeat$3 = Immutable$f.Repeat,
    Record$4 = Immutable$f.Record;

var returnTrue = function returnTrue() {
  return true;
};

var defaultLeafRange = {
  start: null,
  end: null
};
var LeafRange = Record$4(defaultLeafRange);
var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};
var DecoratorRange = Record$4(defaultDecoratorRange);
var BlockTree$1 = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();

    if (!textLength) {
      return List$a.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List$a.of(new LeafRange({
          start: 0,
          end: 0
        }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List$a(Repeat$3(null, textLength));
    var chars = block.getCharacterList();
    findRangesImmutable$1(decorations, areEqual$1, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });
    return List$a(leafSets);
  },
  fromJS: function fromJS(_ref) {
    var leaves = _ref.leaves,
        other = _objectWithoutPropertiesLoose$1(_ref, ["leaves"]);

    return new DecoratorRange(_objectSpread$c({}, other, {
      leaves: leaves != null ? List$a(Array.isArray(leaves) ? leaves : getOwnObjectValues$1(leaves)).map(function (leaf) {
        return LeafRange(leaf);
      }) : null
    }));
  }
};
/**
 * Generate LeafRange records for a given character list.
 */

function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable$1(inlineStyles, areEqual$1, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List$a(leaves);
}

function areEqual$1(a, b) {
  return a === b;
}

var BlockTree_1 = BlockTree$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @legacyServerCallableInstance
 * @format
 * 
 * @emails oncall+draft_js
 */

function _inheritsLoose$d(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable$e = immutable.exports;

var Record$3 = Immutable$e.Record;
var DraftEntityInstanceRecord = Record$3({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});
/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance$2 = /*#__PURE__*/function (_DraftEntityInstanceR) {
  _inheritsLoose$d(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    return _DraftEntityInstanceR.apply(this, arguments) || this;
  }

  var _proto = DraftEntityInstance.prototype;

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getMutability = function getMutability() {
    return this.get('mutability');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

var DraftEntityInstance_1 = DraftEntityInstance$2;

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @typechecks
 * 
 * @format
 */

/*eslint-disable no-bitwise */

/**
 * Based on the rfc4122-compliant solution posted at
 * http://stackoverflow.com/questions/105034
 */
function uuid$1() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

var uuid_1 = uuid$1;

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } return target; }

function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var DraftEntityInstance$1 = DraftEntityInstance_1;

var Immutable$d = immutable.exports;

var invariant$p = invariant_1;

var uuid = uuid_1;

var Map$5 = Immutable$d.Map;
var instances$1 = Map$5();
var instanceKey = uuid();
/**
 * Temporary utility for generating the warnings
 */

function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity$4 = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity$4.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity$4.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity$4.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity$4.__get(key);
  },

  /**
   * Get all the entities in the content state.
   */
  __getAll: function __getAll() {
    return instances$1;
  },

  /**
   * Load the entity map with the given set of entities.
   */
  __loadWithEntities: function __loadWithEntities(entities) {
    instances$1 = entities;
    instanceKey = uuid();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity$4.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity$4.__replaceData(key, newData);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity$4.__add(new DraftEntityInstance$1({
      type: type,
      mutability: mutability,
      data: data || {}
    }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    instanceKey = uuid();
    instances$1 = instances$1.set(instanceKey, instance);
    return instanceKey;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances$1.get(key);
    !!!instance ? process.env.NODE_ENV !== "production" ? invariant$p(false, 'Unknown DraftEntity key: %s.', key) : invariant$p(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity$4.__get(key);

    var newData = _objectSpread$b({}, instance.getData(), toMerge);

    var newInstance = instance.set('data', newData);
    instances$1 = instances$1.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity$4.__get(key);

    var newInstance = instance.set('data', newData);
    instances$1 = instances$1.set(key, newInstance);
    return newInstance;
  }
};
var DraftEntity_1 = DraftEntity$4;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _inheritsLoose$c(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable$c = immutable.exports;

var Record$2 = Immutable$c.Record;
var defaultRecord$2 = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};
/* $FlowFixMe[unclear-type] This comment suppresses an error found when
 * automatically adding a type annotation with the codemod Komodo/Annotate_
 * exports. To see the error delete this comment and run Flow. */

var SelectionStateRecord = Record$2(defaultRecord$2);

var SelectionState$4 = /*#__PURE__*/function (_SelectionStateRecord) {
  _inheritsLoose$c(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    return _SelectionStateRecord.apply(this, arguments) || this;
  }

  var _proto = SelectionState.prototype;

  _proto.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  _proto.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  _proto.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  _proto.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  _proto.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  _proto.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  _proto.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  }
  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */
  ;

  _proto.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionStart && selectionStart <= end || // selectionStart is between start and end, or
      start <= selectionEnd && selectionEnd <= end // selectionEnd is between start and end
      ;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
    return start <= offsetToCheck && end >= offsetToCheck;
  };

  _proto.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  _proto.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  _proto.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  _proto.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  _proto.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

var SelectionState_1 = SelectionState$4;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */

var gkx$8 = function (name) {
  if (typeof window !== 'undefined' && window.__DRAFT_GKX) {
    return !!window.__DRAFT_GKX[name];
  }

  return false;
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText$2(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

var sanitizeDraftText_1 = sanitizeDraftText$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$i(target, key, source[key]); }); } return target; }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose$b(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BlockMapBuilder$3 = BlockMapBuilder_1;

var CharacterMetadata$5 = CharacterMetadata_1;

var ContentBlock$6 = ContentBlock_1;

var ContentBlockNode$6 = ContentBlockNode_1;

var DraftEntity$3 = DraftEntity_1;

var SelectionState$3 = SelectionState_1;

var generateRandomKey$7 = generateRandomKey_1;

var getOwnObjectValues = getOwnObjectValues_1;

var gkx$7 = gkx$8;

var Immutable$b = immutable.exports;

var sanitizeDraftText$1 = sanitizeDraftText_1;

var List$9 = Immutable$b.List,
    Record$1 = Immutable$b.Record,
    Repeat$2 = Immutable$b.Repeat,
    ImmutableMap = Immutable$b.Map,
    OrderedMap$4 = Immutable$b.OrderedMap;
var defaultRecord$1 = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};
var ContentStateRecord = Record$1(defaultRecord$1);
/* $FlowFixMe[signature-verification-failure] Supressing a `signature-
 * verification-failure` error here. TODO: T65949050 Clean up the branch for
 * this GK */

var ContentBlockNodeRecord = gkx$7('draft_tree_data_support') ? ContentBlockNode$6 : ContentBlock$6;

var ContentState$3 = /*#__PURE__*/function (_ContentStateRecord) {
  _inheritsLoose$b(ContentState, _ContentStateRecord);

  function ContentState() {
    return _ContentStateRecord.apply(this, arguments) || this;
  }

  var _proto = ContentState.prototype;

  _proto.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity$3;
  };

  _proto.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  _proto.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  _proto.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  _proto.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  _proto.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  _proto.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  _proto.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  _proto.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  _proto.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity$3.__getLastCreatedEntityKey();
  };

  _proto.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || // make sure that there are no zero width space chars
    escape(blockMap.first().getText()).replace(/%u200B/g, '').length > 0;
  };

  _proto.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity$3.__create(type, mutability, data);

    return this;
  };

  _proto.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity$3.__mergeData(key, toMerge);

    return this;
  };

  _proto.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity$3.__replaceData(key, newData);

    return this;
  };

  _proto.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity$3.__add(instance);

    return this;
  };

  _proto.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity$3.__get(key);
  };

  _proto.getAllEntities = function getAllEntities() {
    return DraftEntity$3.__getAll();
  };

  _proto.loadWithEntities = function loadWithEntities(entities) {
    return DraftEntity$3.__loadWithEntities(entities);
  };

  ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder$3.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState$3() : SelectionState$3.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity$3,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText$1(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey$7(),
        text: block,
        type: 'unstyled',
        characterList: List$9(Repeat$2(CharacterMetadata$5.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  ContentState.fromJS = function fromJS(state) {
    return new ContentState(_objectSpread$a({}, state, {
      blockMap: OrderedMap$4(state.blockMap).map(ContentState.createContentBlockFromJS),
      selectionBefore: new SelectionState$3(state.selectionBefore),
      selectionAfter: new SelectionState$3(state.selectionAfter)
    }));
  };

  ContentState.createContentBlockFromJS = function createContentBlockFromJS(block) {
    var characterList = block.characterList;
    return new ContentBlockNodeRecord(_objectSpread$a({}, block, {
      data: ImmutableMap(block.data),
      characterList: characterList != null ? List$9((Array.isArray(characterList) ? characterList : getOwnObjectValues(characterList)).map(function (c) {
        return CharacterMetadata$5.fromJS(c);
      })) : undefined
    }));
  };

  return ContentState;
}(ContentStateRecord);

var ContentState_1 = ContentState$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var invariant$o = invariant_1;

var NEUTRAL = 'NEUTRAL'; // No strong direction

var LTR = 'LTR'; // Left-to-Right direction

var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null; // == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */

function isStrong(dir) {
  return dir === LTR || dir === RTL;
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */


function getHTMLDir(dir) {
  !isStrong(dir) ? process.env.NODE_ENV !== "production" ? invariant$o(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant$o(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */


function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ? process.env.NODE_ENV !== "production" ? invariant$o(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant$o(false) : void 0;
  !isStrong(otherDir) ? process.env.NODE_ENV !== "production" ? invariant$o(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant$o(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
} // == Global Direction ==

/**
 * Set the global direction.
 */


function setGlobalDir(dir) {
  globalDir = dir;
}
/**
 * Initialize the global direction
 */


function initGlobalDir() {
  setGlobalDir(LTR);
}
/**
 * Get the global direction
 */


function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }

  !globalDir ? process.env.NODE_ENV !== "production" ? invariant$o(false, 'Global direction not set.') : invariant$o(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection$4 = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};
var UnicodeBidiDirection_1 = UnicodeBidiDirection$4;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var UnicodeBidiDirection$3 = UnicodeBidiDirection_1;

var invariant$n = invariant_1;

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {
  L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
  R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
  AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
};
var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */

function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */


function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);

  if (strongChar == null) {
    return UnicodeBidiDirection$3.NEUTRAL;
  }

  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection$3.RTL : UnicodeBidiDirection$3.LTR;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */


function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection$3.NEUTRAL;

  if (!str.length) {
    return fallback;
  }

  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection$3.NEUTRAL ? fallback : blockDir;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */


function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection$3.getGlobalDir();
  }

  !UnicodeBidiDirection$3.isStrong(strongFallback) ? process.env.NODE_ENV !== "production" ? invariant$n(false, 'Fallback direction must be a strong direction') : invariant$n(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}
/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */


function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection$3.LTR;
}
/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */


function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection$3.RTL;
}

var UnicodeBidi$3 = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};
var UnicodeBidi_1 = UnicodeBidi$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnicodeBidi$2 = UnicodeBidi_1;

var UnicodeBidiDirection$2 = UnicodeBidiDirection_1;

var invariant$m = invariant_1;

var UnicodeBidiService$1 =
/*#__PURE__*/
function () {
  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _defineProperty$h(this, "_defaultDir", void 0);

    _defineProperty$h(this, "_lastDir", void 0);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection$2.getGlobalDir();
    } else {
      !UnicodeBidiDirection$2.isStrong(defaultDir) ? process.env.NODE_ENV !== "production" ? invariant$m(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant$m(false) : void 0;
    }

    this._defaultDir = defaultDir;
    this.reset();
  }
  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  var _proto = UnicodeBidiService.prototype;

  _proto.reset = function reset() {
    this._lastDir = this._defaultDir;
  };
  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  _proto.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi$2.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

var UnicodeBidiService_1 = UnicodeBidiService$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var nullthrows$e = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error("Got unexpected null or undefined");
};

var nullthrows_1 = nullthrows$e;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UnicodeBidiService = UnicodeBidiService_1;

var Immutable$a = immutable.exports;

var nullthrows$d = nullthrows_1;

var OrderedMap$3 = Immutable$a.OrderedMap;
var bidiService;
var EditorBidiService$1 = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows$d(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap$3(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable$a.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};
var EditorBidiService_1 = EditorBidiService$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } return target; }

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockTree = BlockTree_1;

var ContentState$2 = ContentState_1;

var EditorBidiService = EditorBidiService_1;

var SelectionState$2 = SelectionState_1;

var Immutable$9 = immutable.exports;

var OrderedSet$2 = Immutable$9.OrderedSet,
    Record = Immutable$9.Record,
    Stack = Immutable$9.Stack,
    OrderedMap$2 = Immutable$9.OrderedMap,
    List$8 = Immutable$9.List; // When configuring an editor, the user can chose to provide or not provide
// basically all keys. `currentContent` varies, so this type doesn't include it.
// (See the types defined below.)

var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};
var EditorStateRecord = Record(defaultRecord);

var EditorState$q = /*#__PURE__*/function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return this.createWithText('', decorator);
  };

  EditorState.createWithText = function createWithText(text, decorator) {
    return EditorState.createWithContent(ContentState$2.createFromText(text), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    if (contentState.getBlockMap().count() === 0) {
      return EditorState.createEmpty(decorator);
    }

    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState$2.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _objectSpread$9({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });

    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.fromJS = function fromJS(config) {
    return new EditorState(new EditorStateRecord(_objectSpread$9({}, config, {
      directionMap: config.directionMap != null ? OrderedMap$2(config.directionMap) : config.directionMap,
      inlineStyleOverride: config.inlineStyleOverride != null ? OrderedSet$2(config.inlineStyleOverride) : config.inlineStyleOverride,
      nativelyRenderedContent: config.nativelyRenderedContent != null ? ContentState$2.fromJS(config.nativelyRenderedContent) : config.nativelyRenderedContent,
      redoStack: config.redoStack != null ? Stack(config.redoStack.map(function (v) {
        return ContentState$2.fromJS(v);
      })) : config.redoStack,
      selection: config.selection != null ? new SelectionState$2(config.selection) : config.selection,
      treeMap: config.treeMap != null ? OrderedMap$2(config.treeMap).map(function (v) {
        return List$8(v).map(function (v) {
          return BlockTree.fromJS(v);
        });
      }) : config.treeMap,
      undoStack: config.undoStack != null ? Stack(config.undoStack.map(function (v) {
        return ContentState$2.fromJS(v);
      })) : config.undoStack,
      currentContent: ContentState$2.fromJS(config.currentContent)
    })));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;

      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;

        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();

      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });
    return new EditorState(map);
  };

  var _proto = EditorState.prototype;

  _proto.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  _proto.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  _proto.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  _proto.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  _proto.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  _proto.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  _proto.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  _proto.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  _proto.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  _proto.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  _proto.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  }
  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */
  ;

  _proto.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, {
      inlineStyleOverride: inlineStyleOverride
    });
  }
  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */
  ;

  _proto.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();

    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  _proto.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  _proto.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  _proto.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  _proto.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  }
  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */
  ;

  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  }
  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */
  ;

  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }

    return updateSelection(editorState, selection, true);
  }
  /**
   * Move selection to the end of the editor without forcing focus.
   */
  ;

  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();
    return EditorState.acceptSelection(editorState, new SelectionState$2({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  }
  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */
  ;

  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  }
  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */
  ;

  EditorState.push = function push(editorState, contentState, changeType) {
    var forceSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:

    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };
    return EditorState.set(editorState, editorStateChanges);
  }
  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */
  ;

  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  }
  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */
  ;

  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  }
  /**
   * Not for public consumption.
   */
  ;

  function EditorState(immutable) {
    _defineProperty$g(this, "_immutable", void 0);

    this._immutable = immutable;
  }
  /**
   * Not for public consumption.
   */


  _proto.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();
/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState$q.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */


function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}
/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */


function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}
/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */


function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}
/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */


function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.

  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.


  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.

  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  } // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.


  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) {
    return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  }

  return OrderedSet$2();
}

var EditorState_1 = EditorState$q;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var ContentBlockNode$5 = ContentBlockNode_1;

var getNextDelimiterBlockKey = getNextDelimiterBlockKey_1;

var Immutable$8 = immutable.exports;

var invariant$l = invariant_1;

var OrderedMap$1 = Immutable$8.OrderedMap,
    List$7 = Immutable$8.List;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  } // possible values of 'insertionMode' are: 'after', 'before'


  var isInsertedAfterTarget = insertionMode === 'after';
  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList["delete"](parentChildrenList.indexOf(originalBlockKey))
      });
    }); // update old prev

    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    }); // update old next

    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    }); // update new next

    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    }); // update new prev

    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    }); // update new parent

    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
      return block.merge({
        children: List$7(newChildrenArray)
      });
    }); // update block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState$1 = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ? process.env.NODE_ENV !== "production" ? invariant$l(false, 'Replacing blocks is not supported.') : invariant$l(false) : void 0;
  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();
  !(blockKey !== targetKey) ? process.env.NODE_ENV !== "production" ? invariant$l(false, 'Block cannot be moved next to itself.') : invariant$l(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode$5;
  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap["delete"](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks["delete"](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });
  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);
  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });
  var newBlocks = OrderedMap$1();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);
    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ? process.env.NODE_ENV !== "production" ? invariant$l(false, 'Block cannot be moved next to itself.') : invariant$l(false) : void 0;
    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);
    !(!blockAfter || blockAfter.getKey() !== blockKey) ? process.env.NODE_ENV !== "production" ? invariant$l(false, 'Block cannot be moved next to itself.') : invariant$l(false) : void 0;
    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

var moveBlockInContentState_1 = moveBlockInContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$f(target, key, source[key]); }); } return target; }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockMapBuilder$2 = BlockMapBuilder_1;

var CharacterMetadata$4 = CharacterMetadata_1;

var ContentBlock$5 = ContentBlock_1;

var ContentBlockNode$4 = ContentBlockNode_1;

var DraftModifier$d = DraftModifier_1;

var EditorState$p = EditorState_1;

var generateRandomKey$6 = generateRandomKey_1;

var gkx$6 = gkx$8;

var Immutable$7 = immutable.exports;

var moveBlockInContentState = moveBlockInContentState_1;

var experimentalTreeDataSupport$5 = gkx$6('draft_tree_data_support');
var ContentBlockRecord$1 = experimentalTreeDataSupport$5 ? ContentBlockNode$4 : ContentBlock$5;
var List$6 = Immutable$7.List,
    Repeat$1 = Immutable$7.Repeat;
var AtomicBlockUtils$1 = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = DraftModifier$d.removeRange(contentState, selectionState, 'backward');
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier$d.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var asAtomicBlock = DraftModifier$d.setBlockType(afterSplit, insertionTarget, 'atomic');
    var charData = CharacterMetadata$4.create({
      entity: entityKey
    });
    var atomicBlockConfig = {
      key: generateRandomKey$6(),
      type: 'atomic',
      text: character,
      characterList: List$6(Repeat$1(charData, character.length))
    };
    var atomicDividerBlockConfig = {
      key: generateRandomKey$6(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport$5) {
      atomicBlockConfig = _objectSpread$8({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _objectSpread$8({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord$1(atomicBlockConfig), new ContentBlockRecord$1(atomicDividerBlockConfig)];
    var fragment = BlockMapBuilder$2.createFromArray(fragmentArray);
    var withAtomicBlock = DraftModifier$d.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState$p.push(editorState, newContent, 'insert-fragment');
  },
  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var withMovedAtomicBlock;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier$d.removeRange(contentState, targetRange, 'backward');
      var selectionAfterRemoval = afterRemoval.getSelectionAfter();

      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier$d.splitBlock(afterRemoval, selectionAfterRemoval);
        var selectionAfterSplit = afterSplit.getSelectionAfter();

        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState$p.push(editorState, newContent, 'move-block');
  }
};
var AtomicBlockUtils_1 = AtomicBlockUtils$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Immutable$6 = immutable.exports;

var List$5 = Immutable$6.List;
var DELIMITER = '.';
/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator$1 = /*#__PURE__*/function () {
  function CompositeDraftDecorator(decorators) {
    _defineProperty$e(this, "_decorators", void 0);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  var _proto = CompositeDraftDecorator.prototype;

  _proto.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function (
    /*object*/
    decorator,
    /*number*/
    ii) {
      var counter = 0;
      var strategy = decorator.strategy;

      var callback = function callback(
      /*number*/
      start,
      /*number*/
      end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };

      strategy(block, callback, contentState);
    });

    return List$5(decorations);
  };

  _proto.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  _proto.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();
/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }

  return true;
}
/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */


function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

var CompositeDraftDecorator_1 = CompositeDraftDecorator$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx$7(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }

  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

var cx_1 = cx$7;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var React$b = React__default;

var cx$6 = cx_1;

var _require$4 = immutable.exports,
    Map$4 = _require$4.Map;

var UL_WRAP = React$b.createElement("ul", {
  className: cx$6('public/DraftStyleDefault/ul')
});
var OL_WRAP = React$b.createElement("ol", {
  className: cx$6('public/DraftStyleDefault/ol')
});
var PRE_WRAP = React$b.createElement("pre", {
  className: cx$6('public/DraftStyleDefault/pre')
});
var DefaultDraftBlockRenderMap$3 = Map$4({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  section: {
    element: 'section'
  },
  article: {
    element: 'article'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});
var DefaultDraftBlockRenderMap_1 = DefaultDraftBlockRenderMap$3;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DefaultDraftInlineStyle$2 = {
  BOLD: {
    fontWeight: 'bold'
  },
  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },
  UNDERLINE: {
    textDecoration: 'underline'
  }
};

var uaParser = {exports: {}};

(function (module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined$1) {

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.31',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                                }
                            } else {
                                this[q] = match ? match : undefined$1;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined$1 : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined$1 : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined$1;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined$1;
            _browser[VERSION] = undefined$1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined$1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined$1;
            _device[MODEL] = undefined$1;
            _device[TYPE] = undefined$1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined$1;
            _engine[VERSION] = undefined$1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined$1;
            _os[VERSION] = undefined$1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
        // nodejs env
        if (module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : commonjsGlobal);
}(uaParser, uaParser.exports));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var UAParser = uaParser.exports;

var UNKNOWN = 'Unknown';
var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};
/**
 * Convert from UAParser platform name to what we expect.
 */

function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}
/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */


function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }

  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}
/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */


var parser$1 = new UAParser();
var results = parser$1.getResult(); // Do some conversion first.

var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};
var UserAgentData$1 = uaData;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var invariant$k = invariant_1;

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;
/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */

function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange$1.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}
/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);
  !(expressions.length > 0 && expressions.length <= 2) ? process.env.NODE_ENV !== "production" ? invariant$k(false, 'the "-" operator expects exactly 2 operands') : invariant$k(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];
    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ? process.env.NODE_ENV !== "production" ? invariant$k(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant$k(false) : void 0;
    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}
/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkSimpleExpression(range, version) {
  range = range.trim();

  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);

    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);

    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);

    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);

    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);

    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}
/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}
/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}
/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}
/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}
/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}
/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }

  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);

  if (isNumber$2(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}
/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */


function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ? process.env.NODE_ENV !== "production" ? invariant$k(false, 'expected regex to match but it did not') : invariant$k(false) : void 0;
  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}
/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */


function isNumber$2(number) {
  return !isNaN(number) && isFinite(number);
}
/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */


function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}
/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */


function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}
/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */


function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();
  zeroPad(a, b.length); // mark "x" and "*" components as equal

  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);

    if (matches) {
      b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components

      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);
  return [a, b];
}
/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber$2(aNumeric) && isNumber$2(bNumeric) && aNumeric !== bNumeric) {
    return compare$1(aNumeric, bNumeric);
  } else {
    return compare$1(a, b);
  }
}
/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compare$1(a, b) {
  !(typeof a === typeof b) ? process.env.NODE_ENV !== "production" ? invariant$k(false, '"a" and "b" must be of the same type') : invariant$k(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);

    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange$1 = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};
var VersionRange_1 = VersionRange$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */

function mapObject$1(object, callback, context) {
  if (!object) {
    return null;
  }

  var result = {};

  for (var name in object) {
    if (hasOwnProperty$1.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }

  return result;
}

var mapObject_1 = mapObject$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */
/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly$1(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }

    return cache[string];
  };
}

var memoizeStringOnly_1 = memoizeStringOnly$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var UserAgentData = UserAgentData$1;

var VersionRange = VersionRange_1;

var mapObject = mapObject_1;

var memoizeStringOnly = memoizeStringOnly_1;
/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */


function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  } // check for non-matching names


  if (!query.startsWith(name)) {
    return false;
  } // full comparison with version


  var range = query.slice(name.length);

  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}
/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */


function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}
/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */


var UserAgent$e = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },

  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },

  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },

  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },

  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },

  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};
var UserAgent_1 = mapObject(UserAgent$e, memoizeStringOnly);

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getCorrectDocumentFromNode$4(node) {
  if (!node || !node.ownerDocument) {
    return document;
  }

  return node.ownerDocument;
}

var getCorrectDocumentFromNode_1 = getCorrectDocumentFromNode$4;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isElement$9(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return node.nodeType === Node.ELEMENT_NODE;
}

var isElement_1 = isElement$9;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

var isElement$8 = isElement_1;

function getSelectionOffsetKeyForNode$2(node) {
  if (isElement$8(node)) {
    var castedNode = node;
    var offsetKey = castedNode.getAttribute('data-offset-key');

    if (offsetKey) {
      return offsetKey;
    }

    for (var ii = 0; ii < castedNode.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode$2(castedNode.childNodes[ii]);

      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }

  return null;
}

var getSelectionOffsetKeyForNode_1 = getSelectionOffsetKeyForNode$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var getCorrectDocumentFromNode$3 = getCorrectDocumentFromNode_1;

var getSelectionOffsetKeyForNode$1 = getSelectionOffsetKeyForNode_1;
/**
 * Get the key from the node's nearest offset-aware ancestor.
 */


function findAncestorOffsetKey$4(node) {
  var searchNode = node;

  while (searchNode && searchNode !== getCorrectDocumentFromNode$3(node).documentElement) {
    var key = getSelectionOffsetKeyForNode$1(searchNode);

    if (key != null) {
      return key;
    }

    searchNode = searchNode.parentNode;
  }

  return null;
}

var findAncestorOffsetKey_1 = findAncestorOffsetKey$4;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getWindowForNode$2(node) {
  if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) {
    return window;
  }

  return node.ownerDocument.defaultView;
}

var getWindowForNode_1 = getWindowForNode$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserAgent$d = UserAgent_1;

var findAncestorOffsetKey$3 = findAncestorOffsetKey_1;

var getWindowForNode$1 = getWindowForNode_1;

var Immutable$5 = immutable.exports;

var invariant$j = invariant_1;

var nullthrows$c = nullthrows_1;

var Map$3 = Immutable$5.Map;
// Heavily based on Prosemirror's DOMObserver https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
var DOM_OBSERVER_OPTIONS = {
  subtree: true,
  characterData: true,
  childList: true,
  characterDataOldValue: false,
  attributes: false
}; // IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified

var USE_CHAR_DATA = UserAgent$d.isBrowser('IE <= 11');

var DOMObserver$1 = /*#__PURE__*/function () {
  function DOMObserver(container) {
    var _this = this;

    _defineProperty$d(this, "observer", void 0);

    _defineProperty$d(this, "container", void 0);

    _defineProperty$d(this, "mutations", void 0);

    _defineProperty$d(this, "onCharData", void 0);

    this.container = container;
    this.mutations = Map$3();
    var containerWindow = getWindowForNode$1(container);

    if (containerWindow.MutationObserver && !USE_CHAR_DATA) {
      this.observer = new containerWindow.MutationObserver(function (mutations) {
        return _this.registerMutations(mutations);
      });
    } else {
      this.onCharData = function (e) {
        !(e.target instanceof Node) ? process.env.NODE_ENV !== "production" ? invariant$j(false, 'Expected target to be an instance of Node') : invariant$j(false) : void 0;

        _this.registerMutation({
          type: 'characterData',
          target: e.target
        });
      };
    }
  }

  var _proto = DOMObserver.prototype;

  _proto.start = function start() {
    if (this.observer) {
      this.observer.observe(this.container, DOM_OBSERVER_OPTIONS);
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.addEventListener('DOMCharacterDataModified', this.onCharData);
    }
  };

  _proto.stopAndFlushMutations = function stopAndFlushMutations() {
    var observer = this.observer;

    if (observer) {
      this.registerMutations(observer.takeRecords());
      observer.disconnect();
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.removeEventListener('DOMCharacterDataModified', this.onCharData);
    }

    var mutations = this.mutations;
    this.mutations = Map$3();
    return mutations;
  };

  _proto.registerMutations = function registerMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      this.registerMutation(mutations[i]);
    }
  };

  _proto.getMutationTextContent = function getMutationTextContent(mutation) {
    var type = mutation.type,
        target = mutation.target,
        removedNodes = mutation.removedNodes;

    if (type === 'characterData') {
      // When `textContent` is '', there is a race condition that makes
      // getting the offsetKey from the target not possible.
      // These events are also followed by a `childList`, which is the one
      // we are able to retrieve the offsetKey and apply the '' text.
      if (target.textContent !== '') {
        // IE 11 considers the enter keypress that concludes the composition
        // as an input char. This strips that newline character so the draft
        // state does not receive spurious newlines.
        if (USE_CHAR_DATA) {
          return target.textContent.replace('\n', '');
        }

        return target.textContent;
      }
    } else if (type === 'childList') {
      if (removedNodes && removedNodes.length) {
        // `characterData` events won't happen or are ignored when
        // removing the last character of a leaf node, what happens
        // instead is a `childList` event with a `removedNodes` array.
        // For this case the textContent should be '' and
        // `DraftModifier.replaceText` will make sure the content is
        // updated properly.
        return '';
      } else if (target.textContent !== '') {
        // Typing Chinese in an empty block in MS Edge results in a
        // `childList` event with non-empty textContent.
        // See https://github.com/facebook/draft-js/issues/2082
        return target.textContent;
      }
    }

    return null;
  };

  _proto.registerMutation = function registerMutation(mutation) {
    var textContent = this.getMutationTextContent(mutation);

    if (textContent != null) {
      var offsetKey = nullthrows$c(findAncestorOffsetKey$3(mutation.target));
      this.mutations = this.mutations.set(offsetKey, textContent);
    }
  };

  return DOMObserver;
}();

var DOMObserver_1 = DOMObserver$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var KEY_DELIMITER = '-';
var DraftOffsetKey$9 = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },
  decode: function decode(offsetKey) {
    // Extracts the last two parts of offsetKey and captures the rest in blockKeyParts
    var _offsetKey$split$reve = offsetKey.split(KEY_DELIMITER).reverse(),
        leafKey = _offsetKey$split$reve[0],
        decoratorKey = _offsetKey$split$reve[1],
        blockKeyParts = _offsetKey$split$reve.slice(2);

    return {
      // Recomposes the parts of blockKey after reversing them
      blockKey: blockKeyParts.reverse().join(KEY_DELIMITER),
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};
var DraftOffsetKey_1 = DraftOffsetKey$9;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var Keys$4 = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var DraftJsDebugLogging$2 = {
  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
    return null;
  },
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isHTMLElement$5(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  if (!node.ownerDocument.defaultView) {
    return node instanceof HTMLElement;
  }

  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
    return true;
  }

  return false;
}

var isHTMLElement_1 = isHTMLElement$5;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var invariant$i = invariant_1;

var isHTMLElement$4 = isHTMLElement_1;

function getContentEditableContainer$2(editor) {
  var editorNode = editor.editorContainer;
  !editorNode ? process.env.NODE_ENV !== "production" ? invariant$i(false, 'Missing editorNode') : invariant$i(false) : void 0;
  !isHTMLElement$4(editorNode.firstChild) ? process.env.NODE_ENV !== "production" ? invariant$i(false, 'editorNode.firstChild is not an HTMLElement') : invariant$i(false) : void 0;
  var htmlElement = editorNode.firstChild;
  return htmlElement;
}

var getContentEditableContainer_1 = getContentEditableContainer$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftOffsetKey$8 = DraftOffsetKey_1;

var nullthrows$b = nullthrows_1;

function getUpdatedSelectionState$2(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows$b(editorState.getSelection());

  if (!anchorKey || !focusKey) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (process.env.NODE_ENV !== "production") {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorPath = DraftOffsetKey$8.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeafBlockTree = editorState.getBlockTree(anchorBlockKey);
  var anchorLeaf = anchorLeafBlockTree && anchorLeafBlockTree.getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
  var focusPath = DraftOffsetKey$8.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeafBlockTree = editorState.getBlockTree(focusBlockKey);
  var focusLeaf = focusLeafBlockTree && focusLeafBlockTree.getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  if (!anchorLeaf || !focusLeaf) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (process.env.NODE_ENV !== "production") {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');
  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;

  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');

    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

var getUpdatedSelectionState_1 = getUpdatedSelectionState$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var findAncestorOffsetKey$2 = findAncestorOffsetKey_1;

var getSelectionOffsetKeyForNode = getSelectionOffsetKeyForNode_1;

var getUpdatedSelectionState$1 = getUpdatedSelectionState_1;

var invariant$h = invariant_1;

var isElement$7 = isElement_1;

var nullthrows$a = nullthrows_1;

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes$2(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.

  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState$1(editorState, nullthrows$a(findAncestorOffsetKey$2(anchorNode)), anchorOffset, nullthrows$a(findAncestorOffsetKey$2(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows$a(findAncestorOffsetKey$2(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows$a(findAncestorOffsetKey$2(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.

    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState$1(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}
/**
 * Identify the first leaf descendant for the given node.
 */


function getFirstLeaf(node) {
  while (node.firstChild && ( // data-blocks has no offset
  isElement$7(node.firstChild) && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Identify the last leaf descendant for the given node.
 */


function getLastLeaf(node) {
  while (node.lastChild && ( // data-blocks has no offset
  isElement$7(node.lastChild) && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }

  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey$2(node);
  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ? process.env.NODE_ENV !== "production" ? invariant$h(false, 'Unknown node in selection range.') : invariant$h(false) : void 0; // If the editorRoot is the selection, step downward into the content
  // wrapper.

  if (editorRoot === node) {
    node = node.firstChild;
    !isElement$7(node) ? process.env.NODE_ENV !== "production" ? invariant$h(false, 'Invalid DraftEditorContents node.') : invariant$h(false) : void 0;
    var castedNode = node; // assignment only added for flow :/
    // otherwise it throws in line 200 saying that node can be null or undefined

    node = castedNode;
    !(node.getAttribute('data-contents') === 'true') ? process.env.NODE_ENV !== "production" ? invariant$h(false, 'Invalid DraftEditorContents structure.') : invariant$h(false) : void 0;

    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  } // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.


  if (childOffset === 0) {
    var key = null;

    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows$a(getSelectionOffsetKeyForNode(firstLeaf));
    }

    return {
      key: key,
      offset: 0
    };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows$a(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows$a(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}
/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */


function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

var getDraftEditorSelectionWithNodes_1 = getDraftEditorSelectionWithNodes$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var getDraftEditorSelectionWithNodes$1 = getDraftEditorSelectionWithNodes_1;
/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */


function getDraftEditorSelection$2(editorState, root) {
  var selection = root.ownerDocument.defaultView.getSelection();
  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset,
      rangeCount = selection.rangeCount;

  if ( // No active selection.
  rangeCount === 0 || // No selection, ever. As in, the user hasn't selected anything since
  // opening the document.
  anchorNode == null || focusNode == null) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes$1(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset);
}

var getDraftEditorSelection_1 = getDraftEditorSelection$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftJsDebugLogging$1 = DraftJsDebugLogging$2;

var EditorState$o = EditorState_1;

var getContentEditableContainer$1 = getContentEditableContainer_1;

var getDraftEditorSelection$1 = getDraftEditorSelection_1;

function editOnSelect$1(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    if (editor._blockSelectEvents) {
      var _editorState = editor.props.editorState;

      var selectionState = _editorState.getSelection();

      DraftJsDebugLogging$1.logBlockedSelectionEvent({
        // For now I don't think we need any other info
        anonymizedDom: 'N/A',
        extraParams: JSON.stringify({
          stacktrace: new Error().stack
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    return;
  }

  var editorState = editor.props.editorState;
  var documentSelection = getDraftEditorSelection$1(editorState, getContentEditableContainer$1(editor));
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState$o.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState$o.acceptSelection(editorState, updatedSelectionState);
    }

    editor.update(editorState);
  }
}

var editOnSelect_1 = editOnSelect$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Provides utilities for handling draftjs keys.
 *
 * @emails oncall+draft_js
 * 
 * @format
 */

function notEmptyKey$2(key) {
  return key != null && key != '';
}

var draftKeyUtils = {
  notEmptyKey: notEmptyKey$2
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var _require$3 = draftKeyUtils,
    notEmptyKey$1 = _require$3.notEmptyKey;
/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */


function getEntityKeyForSelection$3(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();

    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);

      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }

      return filterKey(contentState.getEntityMap(), entityKey);
    }

    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);
  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
  return filterKey(contentState.getEntityMap(), entityKey);
}
/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */


function filterKey(entityMap, entityKey) {
  if (notEmptyKey$1(entityKey)) {
    var entity = entityMap.__get(entityKey);

    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }

  return null;
}

var getEntityKeyForSelection_1 = getEntityKeyForSelection$3;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DOMObserver = DOMObserver_1;

var DraftModifier$c = DraftModifier_1;

var DraftOffsetKey$7 = DraftOffsetKey_1;

var EditorState$n = EditorState_1;

var Keys$3 = Keys$4;

var UserAgent$c = UserAgent_1;

var editOnSelect = editOnSelect_1;

var getContentEditableContainer = getContentEditableContainer_1;

var getDraftEditorSelection = getDraftEditorSelection_1;

var getEntityKeyForSelection$2 = getEntityKeyForSelection_1;

var nullthrows$9 = nullthrows_1;

var isIE$2 = UserAgent$c.isBrowser('IE');
/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */

var RESOLVE_DELAY = 20;
/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */

var resolved = false;
var stillComposing = false;
var domObserver = null;

function startDOMObserver(editor) {
  if (!domObserver) {
    domObserver = new DOMObserver(getContentEditableContainer(editor));
    domObserver.start();
  }
}

var DraftEditorCompositionHandler$1 = {
  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
    startDOMObserver(editor);
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler$1.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },
  onSelect: editOnSelect,

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler$1.resolveComposition(editor);

      editor._onKeyDown(e);

      return;
    }

    if (e.which === Keys$3.RIGHT || e.which === Keys$3.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(_editor, e) {
    if (e.which === Keys$3.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    var mutations = nullthrows$9(domObserver).stopAndFlushMutations();
    domObserver = null;
    resolved = true;
    var editorState = EditorState$n.set(editor._latestEditorState, {
      inCompositionMode: false
    });
    editor.exitCurrentMode();

    if (!mutations.size) {
      editor.update(editorState);
      return;
    } // TODO, check if Facebook still needs this flag or if it could be removed.
    // Since there can be multiple mutations providing a `composedChars` doesn't
    // apply well on this new model.
    // if (
    //   gkx('draft_handlebeforeinput_composed_text') &&
    //   editor.props.handleBeforeInput &&
    //   isEventHandled(
    //     editor.props.handleBeforeInput(
    //       composedChars,
    //       editorState,
    //       event.timeStamp,
    //     ),
    //   )
    // ) {
    //   return;
    // }


    var contentState = editorState.getCurrentContent();
    mutations.forEach(function (composedChars, offsetKey) {
      var _DraftOffsetKey$decod = DraftOffsetKey$7.decode(offsetKey),
          blockKey = _DraftOffsetKey$decod.blockKey,
          decoratorKey = _DraftOffsetKey$decod.decoratorKey,
          leafKey = _DraftOffsetKey$decod.leafKey;

      var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
          start = _editorState$getBlock.start,
          end = _editorState$getBlock.end;

      var replacementRange = editorState.getSelection().merge({
        anchorKey: blockKey,
        focusKey: blockKey,
        anchorOffset: start,
        focusOffset: end,
        isBackward: false
      });
      var entityKey = getEntityKeyForSelection$2(contentState, replacementRange);
      var currentStyle = contentState.getBlockForKey(blockKey).getInlineStyleAt(start);
      contentState = DraftModifier$c.replaceText(contentState, replacementRange, composedChars, currentStyle, entityKey); // We need to update the editorState so the leaf node ranges are properly
      // updated and multiple mutations are correctly applied.

      editorState = EditorState$n.set(editorState, {
        currentContent: contentState
      });
    }); // When we apply the text changes to the ContentState, the selection always
    // goes to the end of the field, but it should just stay where it is
    // after compositionEnd.

    var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
    var compositionEndSelectionState = documentSelection.selectionState;
    editor.restoreEditorDOM(); // See:
    // - https://github.com/facebook/draft-js/issues/2093
    // - https://github.com/facebook/draft-js/pull/2094
    // Apply this fix only in IE for now. We can test it in
    // other browsers in the future to ensure no regressions

    var editorStateWithUpdatedSelection = isIE$2 ? EditorState$n.forceSelection(editorState, compositionEndSelectionState) : EditorState$n.acceptSelection(editorState, compositionEndSelectionState);
    editor.update(EditorState$n.push(editorStateWithUpdatedSelection, contentState, 'insert-characters'));
  }
};
var DraftEditorCompositionHandler_1 = DraftEditorCompositionHandler$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var _assign$6 = objectAssign;

function _extends$c() { _extends$c = _assign$6 || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function _inheritsLoose$a(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftOffsetKey$6 = DraftOffsetKey_1;

var React$a = React__default;

var UnicodeBidi$1 = UnicodeBidi_1;

var UnicodeBidiDirection$1 = UnicodeBidiDirection_1;

var DraftEditorDecoratedLeaves$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$a(DraftEditorDecoratedLeaves, _React$Component);

  function DraftEditorDecoratedLeaves() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorDecoratedLeaves.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        children = _this$props.children,
        contentState = _this$props.contentState,
        decorator = _this$props.decorator,
        decoratorKey = _this$props.decoratorKey,
        direction = _this$props.direction,
        leafSet = _this$props.leafSet,
        text = _this$props.text;
    var blockKey = block.getKey();
    var leavesForLeafSet = leafSet.get('leaves');
    var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
    var decoratorProps = decorator.getPropsForKey(decoratorKey);
    var decoratorOffsetKey = DraftOffsetKey$6.encode(blockKey, parseInt(decoratorKey, 10), 0);
    var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
    // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

    var dir = UnicodeBidiDirection$1.getHTMLDirIfDifferent(UnicodeBidi$1.getDirection(decoratedText), direction);
    return React$a.createElement(DecoratorComponent, _extends$c({}, decoratorProps, {
      contentState: contentState,
      decoratedText: decoratedText,
      dir: dir,
      key: decoratorOffsetKey,
      entityKey: block.getEntityAt(leafSet.get('start')),
      offsetKey: decoratorOffsetKey
    }), children);
  };

  return DraftEditorDecoratedLeaves;
}(React$a.Component);

var DraftEditorDecoratedLeaves_react = DraftEditorDecoratedLeaves$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose$9(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React$9 = React__default;

var UserAgent$b = UserAgent_1;

var invariant$g = invariant_1;

var isElement$6 = isElement_1; // In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.


var useNewlineChar = UserAgent$b.isBrowser('IE <= 11');
/**
 * Check whether the node should be considered a newline.
 */

function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}
/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */


var NEWLINE_A = function NEWLINE_A(ref) {
  return useNewlineChar ? React$9.createElement("span", {
    key: "A",
    "data-text": "true",
    ref: ref
  }, '\n') : React$9.createElement("br", {
    key: "A",
    "data-text": "true",
    ref: ref
  });
};

var NEWLINE_B = function NEWLINE_B(ref) {
  return useNewlineChar ? React$9.createElement("span", {
    key: "B",
    "data-text": "true",
    ref: ref
  }, '\n') : React$9.createElement("br", {
    key: "B",
    "data-text": "true",
    ref: ref
  });
};

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$9(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.

    _defineProperty$c(_assertThisInitialized$5(_this), "_forceFlag", void 0);

    _defineProperty$c(_assertThisInitialized$5(_this), "_node", void 0);

    _this._forceFlag = false;
    return _this;
  }

  var _proto = DraftEditorTextNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = this._node;
    var shouldBeNewline = nextProps.children === '';
    !isElement$6(node) ? process.env.NODE_ENV !== "production" ? invariant$g(false, 'node is not an Element') : invariant$g(false) : void 0;
    var elementNode = node;

    if (shouldBeNewline) {
      return !isNewline(elementNode);
    }

    return elementNode.textContent !== nextProps.children;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.render = function render() {
    var _this2 = this;

    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A(function (ref) {
        return _this2._node = ref;
      }) : NEWLINE_B(function (ref) {
        return _this2._node = ref;
      });
    }

    return React$9.createElement("span", {
      key: this._forceFlag ? 'A' : 'B',
      "data-text": "true",
      ref: function ref(_ref) {
        return _this2._node = _ref;
      }
    }, this.props.children);
  };

  return DraftEditorTextNode;
}(React$9.Component);

var DraftEditorTextNode_react = DraftEditorTextNode$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement$5 = isElement_1;

function isHTMLBRElement$2(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement$5(node) && node.nodeName === 'BR';
}

var isHTMLBRElement_1 = isHTMLBRElement$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode$2(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var isNode_1 = isNode$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var isNode$1 = isNode_1;
/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */


function isTextNode$1(object) {
  return isNode$1(object) && object.nodeType == 3;
}

var isTextNode_1 = isTextNode$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isTextNode = isTextNode_1;
/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */


function containsNode$3(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode$3(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

var containsNode_1 = containsNode$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement$2(doc)
/*?DOMElement*/
{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

var getActiveElement_1 = getActiveElement$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftJsDebugLogging = DraftJsDebugLogging$2;

var UserAgent$a = UserAgent_1;

var containsNode$2 = containsNode_1;

var getActiveElement$1 = getActiveElement_1;

var getCorrectDocumentFromNode$2 = getCorrectDocumentFromNode_1;

var invariant$f = invariant_1;

var isElement$4 = isElement_1;

var isIE$1 = UserAgent$a.isBrowser('IE');

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);

  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !isElement$4(anonymized) ? process.env.NODE_ENV !== "production" ? invariant$f(false, 'Node must be an Element if it is not a text node.') : invariant$f(false) : void 0;
  var castedElement = anonymized;
  return castedElement.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return getCorrectDocumentFromNode$2(node).createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();

  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }

  var childNodes = node.childNodes;

  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node; // this should only be used after checking with isElement

  var castedNode = currentNode;

  while (currentNode) {
    if (isElement$4(currentNode) && castedNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
      castedNode = currentNode;
    }
  }

  return 'Could not find contentEditable parent of node';
}

function getNodeLength$1(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */


function setDraftEditorSelection$1(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  var documentObject = getCorrectDocumentFromNode$2(node);

  if (!containsNode$2(documentObject.documentElement, node)) {
    return;
  }

  var selection = documentObject.defaultView.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.

  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
  // and be done.

  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    } // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.


    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    } // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.


    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}
/**
 * Extend selection towards focus point.
 */


function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement$1();
  var extend = selection.extend; // containsNode returns false if node is null.
  // Let's refine the type of this value out here so flow knows.

  if (extend && node != null && containsNode$2(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength$1(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({
          offset: offset
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    } // logging to catch bug that is being reported in t18110632


    var nodeWasFocus = node === selection.focusNode;

    try {
      // Fixes some reports of "InvalidStateError: Failed to execute 'extend' on
      // 'Selection': This Selection object doesn't have any Ranges."
      // Note: selection.extend does not exist in IE.
      if (selection.rangeCount > 0 && selection.extend) {
        selection.extend(node, offset);
      }
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];

          if (n === activeElement) {
            labels.push('active element');
          }

          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }

          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }

          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      }); // allow the error to be thrown -
      // better than continuing in a broken state

      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    if (node && selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
      range.setEnd(node, offset);
      selection.addRange(range.cloneRange());
    }
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = getCorrectDocumentFromNode$2(node).createRange(); // logging to catch bug that is being reported in t16250795

  if (offset > getNodeLength$1(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({
        offset: offset
      }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }

  range.setStart(node, offset); // IE sometimes throws Unspecified Error when trying to addRange

  if (isIE$1) {
    try {
      selection.addRange(range);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        /* eslint-disable-next-line no-console */
        console.warn('Call to selection.addRange() threw exception: ', e);
      }
    }
  } else {
    selection.addRange(range);
  }
}

var setDraftEditorSelection_1 = {
  setDraftEditorSelection: setDraftEditorSelection$1,
  addFocusToSelection: addFocusToSelection
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var _assign$5 = objectAssign;

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose$8(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorTextNode = DraftEditorTextNode_react;

var React$8 = React__default;

var invariant$e = invariant_1;

var isHTMLBRElement$1 = isHTMLBRElement_1;

var setDraftEditorSelection = setDraftEditorSelection_1.setDraftEditorSelection;

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf$2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$8(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$b(_assertThisInitialized$4(_this), "leaf", void 0);

    return _this;
  }

  var _proto = DraftEditorLeaf.prototype;

  _proto._setSelection = function _setSelection() {
    var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _this$props = this.props,
        block = _this$props.block,
        start = _this$props.start,
        text = _this$props.text;
    var blockKey = block.getKey();
    var end = start + text.length;

    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    } // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.


    var node = this.leaf;
    !node ? process.env.NODE_ENV !== "production" ? invariant$e(false, 'Missing node') : invariant$e(false) : void 0;
    var child = node.firstChild;
    !child ? process.env.NODE_ENV !== "production" ? invariant$e(false, 'Missing child') : invariant$e(false) : void 0;
    var targetNode;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (isHTMLBRElement$1(child)) {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ? process.env.NODE_ENV !== "production" ? invariant$e(false, 'Missing targetNode') : invariant$e(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = this.leaf;
    !leafNode ? process.env.NODE_ENV !== "production" ? invariant$e(false, 'Missing leafNode') : invariant$e(false) : void 0;
    var shouldUpdate = leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
    return shouldUpdate;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  _proto.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  _proto.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _this$props2 = this.props,
        customStyleMap = _this$props2.customStyleMap,
        customStyleFn = _this$props2.customStyleFn,
        offsetKey = _this$props2.offsetKey,
        styleSet = _this$props2.styleSet;
    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign$5(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign$5(styleObj, newStyles);
    }

    return React$8.createElement("span", {
      "data-offset-key": offsetKey,
      ref: function ref(_ref) {
        return _this2.leaf = _ref;
      },
      style: styleObj
    }, React$8.createElement(DraftEditorTextNode, null, text));
  };

  return DraftEditorLeaf;
}(React$8.Component);

var DraftEditorLeaf_react = DraftEditorLeaf$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

function _inheritsLoose$7(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorDecoratedLeaves = DraftEditorDecoratedLeaves_react;

var DraftEditorLeaf$1 = DraftEditorLeaf_react;

var DraftOffsetKey$5 = DraftOffsetKey_1;

var Immutable$4 = immutable.exports;

var React$7 = React__default;

var cx$5 = cx_1;

Immutable$4.List;

var DraftEditorNode$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$7(DraftEditorNode, _React$Component);

  function DraftEditorNode() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorNode.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState,
        customStyleFn = _this$props.customStyleFn,
        customStyleMap = _this$props.customStyleMap,
        decorator = _this$props.decorator,
        direction = _this$props.direction,
        forceSelection = _this$props.forceSelection,
        hasSelection = _this$props.hasSelection,
        selection = _this$props.selection,
        tree = _this$props.tree;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = tree.size - 1;
    var children = this.props.children || tree.map(function (leafSet, ii) {
      var decoratorKey = leafSet.get('decoratorKey');
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var Leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey$5.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React$7.createElement(DraftEditorLeaf$1, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? selection : null,
          forceSelection: forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: customStyleMap,
          customStyleFn: customStyleFn,
          isLast: decoratorKey === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      if (!decoratorKey || !decorator) {
        return Leaves;
      }

      return React$7.createElement(DraftEditorDecoratedLeaves, {
        block: block,
        children: Leaves,
        contentState: contentState,
        decorator: decorator,
        decoratorKey: decoratorKey,
        direction: direction,
        leafSet: leafSet,
        text: text,
        key: ii
      });
    }).toArray();
    return React$7.createElement("div", {
      "data-offset-key": DraftOffsetKey$5.encode(blockKey, 0, 0),
      className: cx$5({
        'public/DraftStyleDefault/block': true,
        'public/DraftStyleDefault/ltr': direction === 'LTR',
        'public/DraftStyleDefault/rtl': direction === 'RTL'
      })
    }, children);
  };

  return DraftEditorNode;
}(React$7.Component);

var DraftEditorNode_react = DraftEditorNode$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}
/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */


var Scroll$3 = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};
var Scroll_1 = Scroll$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _hyphenPattern = /-(.)/g;
/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */

function camelize$1(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

var camelize_1 = camelize$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */

function hyphenate$1(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var camelize = camelize_1;

var hyphenate = hyphenate_1;

function asString(value)
/*?string*/
{
  return value == null ? value : String(value);
}

function getStyleProperty$1(
/*DOMNode*/
node,
/*string*/
name)
/*?string*/
{
  var computedStyle; // W3C Standard

  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  } // Safari


  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }

    if (name === 'display') {
      return 'none';
    }
  } // Internet Explorer


  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }

    return asString(node.currentStyle[camelize(name)]);
  }

  return asString(node.style && node.style[camelize(name)]);
}

var getStyleProperty_1 = getStyleProperty$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getStyleProperty = getStyleProperty_1;
/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */


function _isNodeScrollable(element, name) {
  var overflow = Style$4.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}
/**
 * Utilities for querying and mutating style properties.
 */


var Style$4 = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }

    var ownerDocument = node.ownerDocument;

    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }

      node = node.parentNode;
    }

    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }
};
var Style_1 = Style$4;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var containsNode$1 = containsNode_1;
/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */


function getElementRect$1(elem) {
  var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.

  if (!('getBoundingClientRect' in elem) || !containsNode$1(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  } // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode


  var rect = elem.getBoundingClientRect();
  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

var getElementRect_1 = getElementRect$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getElementRect = getElementRect_1;
/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */


function getElementPosition$2(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

var getElementPosition_1 = getElementPosition$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getDocumentScrollElement$1(doc) {
  doc = doc || document;

  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }

  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

var getDocumentScrollElement_1 = getDocumentScrollElement$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition$1(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }

  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

var getUnboundedScrollPosition_1 = getUnboundedScrollPosition$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getDocumentScrollElement = getDocumentScrollElement_1;

var getUnboundedScrollPosition = getUnboundedScrollPosition_1;
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */


function getScrollPosition$4(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);

  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }

  var scrollPosition = getUnboundedScrollPosition(scrollable);
  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;
  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
  return scrollPosition;
}

var getScrollPosition_1 = getScrollPosition$4;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks
 */
function getViewportWidth() {
  var width;

  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
}

function getViewportHeight() {
  var height;

  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}
/**
 * Gets the viewport dimensions including any scrollbars.
 */


function getViewportDimensions$2() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}
/**
 * Gets the viewport dimensions excluding any scrollbars.
 */


getViewportDimensions$2.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

var getViewportDimensions_1 = getViewportDimensions$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorBlock.react.js and DraftEditorContents.react.js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var _assign$4 = objectAssign;

function _extends$b() { _extends$b = _assign$4 || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose$6(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$a(target, key, source[key]); }); } return target; }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorNode = DraftEditorNode_react;

var DraftOffsetKey$4 = DraftOffsetKey_1;

var React$6 = React__default;

var Scroll$2 = Scroll_1;

var Style$3 = Style_1;

var getElementPosition$1 = getElementPosition_1;

var getScrollPosition$3 = getScrollPosition_1;

var getViewportDimensions$1 = getViewportDimensions_1;

var Immutable$3 = immutable.exports;

var invariant$d = invariant_1;

var isHTMLElement$3 = isHTMLElement_1;

var SCROLL_BUFFER$1 = 10;
Immutable$3.List; // we should harden up the bellow flow types to make them more strict

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge$1 = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * We will use this helper to identify blocks that need to be wrapped but have siblings that
 * also share the same wrapper element, this way we can do the wrapping once the last sibling
 * is added.
 */


var shouldNotAddWrapperElement = function shouldNotAddWrapperElement(block, contentState) {
  var nextSiblingKey = block.getNextSiblingKey();
  return nextSiblingKey ? contentState.getBlockForKey(nextSiblingKey).getType() === block.getType() : false;
};

var applyWrapperElementToSiblings = function applyWrapperElementToSiblings(wrapperTemplate, Element, nodes) {
  var wrappedSiblings = []; // we check back until we find a sibling that does not have same wrapper

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = nodes.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var sibling = _step.value;

      if (sibling.type !== Element) {
        break;
      }

      wrappedSiblings.push(sibling);
    } // we now should remove from acc the wrappedSiblings and add them back under same wrap

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  nodes.splice(nodes.indexOf(wrappedSiblings[0]), wrappedSiblings.length + 1);
  var childrenIs = wrappedSiblings.reverse();
  var key = childrenIs[0].key;
  nodes.push(React$6.cloneElement(wrapperTemplate, {
    key: "".concat(key, "-wrap"),
    'data-offset-key': DraftOffsetKey$4.encode(key, 0, 0)
  }, childrenIs));
  return nodes;
};

var getDraftRenderConfig = function getDraftRenderConfig(block, blockRenderMap) {
  var configForType = blockRenderMap.get(block.getType()) || blockRenderMap.get('unstyled');
  var wrapperTemplate = configForType.wrapper;
  var Element = configForType.element || blockRenderMap.get('unstyled').element;
  return {
    Element: Element,
    wrapperTemplate: wrapperTemplate
  };
};

var getCustomRenderConfig = function getCustomRenderConfig(block, blockRendererFn) {
  var customRenderer = blockRendererFn(block);

  if (!customRenderer) {
    return {};
  }

  var CustomComponent = customRenderer.component,
      customProps = customRenderer.props,
      customEditable = customRenderer.editable;
  return {
    CustomComponent: CustomComponent,
    customProps: customProps,
    customEditable: customEditable
  };
};

var getElementPropsConfig = function getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, ref) {
  var elementProps = {
    'data-block': true,
    'data-editor': editorKey,
    'data-offset-key': offsetKey,
    key: block.getKey(),
    ref: ref
  };
  var customClass = blockStyleFn(block);

  if (customClass) {
    elementProps.className = customClass;
  }

  if (customConfig.customEditable !== undefined) {
    elementProps = _objectSpread$7({}, elementProps, {
      contentEditable: customConfig.customEditable,
      suppressContentEditableWarning: true
    });
  }

  return elementProps;
};

var DraftEditorBlockNode$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$6(DraftEditorBlockNode, _React$Component);

  function DraftEditorBlockNode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$a(_assertThisInitialized$3(_this), "wrapperRef", React$6.createRef());

    return _this;
  }

  var _proto = DraftEditorBlockNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
        block = _this$props.block,
        direction = _this$props.direction,
        tree = _this$props.tree;
    var isContainerNode = !block.getChildKeys().isEmpty();
    var blockHasChanged = block !== nextProps.block || tree !== nextProps.tree || direction !== nextProps.direction || isBlockOnSelectionEdge$1(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection; // if we have children at this stage we always re-render container nodes
    // else if its a root node we avoid re-rendering by checking for block updates

    return isContainerNode || blockHasChanged;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this.wrapperRef.current;

    if (!blockNode) {
      // This Block Node was rendered without a wrapper element.
      return;
    }

    var scrollParent = Style$3.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition$3(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition$1(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions$1().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER$1);
      }
    } else {
      !isHTMLElement$3(blockNode) ? process.env.NODE_ENV !== "production" ? invariant$d(false, 'blockNode is not an HTMLElement') : invariant$d(false) : void 0;
      var htmlBlockNode = blockNode;
      var blockBottom = htmlBlockNode.offsetHeight + htmlBlockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll$2.setTop(scrollParent, Scroll$2.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER$1);
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        block = _this$props2.block,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        contentState = _this$props2.contentState,
        decorator = _this$props2.decorator,
        editorKey = _this$props2.editorKey,
        editorState = _this$props2.editorState,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        direction = _this$props2.direction,
        forceSelection = _this$props2.forceSelection,
        selection = _this$props2.selection,
        tree = _this$props2.tree;
    var children = null;

    if (block.children.size) {
      children = block.children.reduce(function (acc, key) {
        var offsetKey = DraftOffsetKey$4.encode(key, 0, 0);
        var child = contentState.getBlockForKey(key);
        var customConfig = getCustomRenderConfig(child, blockRendererFn);
        var Component = customConfig.CustomComponent || DraftEditorBlockNode;

        var _getDraftRenderConfig = getDraftRenderConfig(child, blockRenderMap),
            Element = _getDraftRenderConfig.Element,
            wrapperTemplate = _getDraftRenderConfig.wrapperTemplate;

        var elementProps = getElementPropsConfig(child, editorKey, offsetKey, blockStyleFn, customConfig, null);

        var childProps = _objectSpread$7({}, _this2.props, {
          tree: editorState.getBlockTree(key),
          blockProps: customConfig.customProps,
          offsetKey: offsetKey,
          block: child
        });

        acc.push(React$6.createElement(Element, elementProps, React$6.createElement(Component, childProps)));

        if (!wrapperTemplate || shouldNotAddWrapperElement(child, contentState)) {
          return acc;
        } // if we are here it means we are the last block
        // that has a wrapperTemplate so we should wrap itself
        // and all other previous siblings that share the same wrapper


        applyWrapperElementToSiblings(wrapperTemplate, Element, acc);
        return acc;
      }, []);
    }

    var blockKey = block.getKey();
    var offsetKey = DraftOffsetKey$4.encode(blockKey, 0, 0);
    var customConfig = getCustomRenderConfig(block, blockRendererFn);
    var Component = customConfig.CustomComponent;
    var blockNode = Component != null ? React$6.createElement(Component, _extends$b({}, this.props, {
      tree: editorState.getBlockTree(blockKey),
      blockProps: customConfig.customProps,
      offsetKey: offsetKey,
      block: block
    })) : React$6.createElement(DraftEditorNode, {
      block: block,
      children: children,
      contentState: contentState,
      customStyleFn: customStyleFn,
      customStyleMap: customStyleMap,
      decorator: decorator,
      direction: direction,
      forceSelection: forceSelection,
      hasSelection: isBlockOnSelectionEdge$1(selection, blockKey),
      selection: selection,
      tree: tree
    });

    if (block.getParentKey()) {
      return blockNode;
    }

    var _getDraftRenderConfig2 = getDraftRenderConfig(block, blockRenderMap),
        Element = _getDraftRenderConfig2.Element;

    var elementProps = getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, this.wrapperRef); // root block nodes needs to be wrapped

    return React$6.createElement(Element, elementProps, blockNode);
  };

  return DraftEditorBlockNode;
}(React$6.Component);

var DraftEditorBlockNode_react = DraftEditorBlockNode$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorContents.react.js for tree nodes
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var _assign$3 = objectAssign;

function _extends$a() { _extends$a = _assign$3 || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function _inheritsLoose$5(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlockNode = DraftEditorBlockNode_react;

var DraftOffsetKey$3 = DraftOffsetKey_1;

var React$5 = React__default;

var nullthrows$8 = nullthrows_1;

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */
var DraftEditorContentsExperimental = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$5(DraftEditorContentsExperimental, _React$Component);

  function DraftEditorContentsExperimental() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContentsExperimental.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows$8(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var rootBlock = blocksAsArray[0];
    var processedBlocks = [];
    var nodeBlock = rootBlock;

    while (nodeBlock) {
      var blockKey = nodeBlock.getKey();
      var blockProps = {
        blockRenderMap: blockRenderMap,
        blockRendererFn: blockRendererFn,
        blockStyleFn: blockStyleFn,
        contentState: content,
        customStyleFn: customStyleFn,
        customStyleMap: customStyleMap,
        decorator: decorator,
        editorKey: editorKey,
        editorState: editorState,
        forceSelection: forceSelection,
        selection: selection,
        block: nodeBlock,
        direction: textDirectionality ? textDirectionality : directionMap.get(blockKey),
        tree: editorState.getBlockTree(blockKey)
      };
      var configForType = blockRenderMap.get(nodeBlock.getType()) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      processedBlocks.push({
        /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
         * comment suppresses an error found when Flow v0.112 was deployed. To
         * see the error delete this comment and run Flow. */
        block: React$5.createElement(DraftEditorBlockNode, _extends$a({
          key: blockKey
        }, blockProps)),
        wrapperTemplate: wrapperTemplate,
        key: blockKey,
        offsetKey: DraftOffsetKey$3.encode(blockKey, 0, 0)
      });
      var nextBlockKey = nodeBlock.getNextSiblingKey();
      nodeBlock = nextBlockKey ? content.getBlockForKey(nextBlockKey) : null;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var ii = 0; ii < processedBlocks.length;) {
      var info = processedBlocks[ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[ii].block);
          ii++;
        } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React$5.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        ii++;
      }
    }

    return React$5.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContentsExperimental;
}(React$5.Component);

var DraftEditorContentsExperimental_react = DraftEditorContentsExperimental;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var _assign$2 = objectAssign;

function _extends$9() { _extends$9 = _assign$2 || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose$4(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorLeaf = DraftEditorLeaf_react;

var DraftOffsetKey$2 = DraftOffsetKey_1;

var React$4 = React__default;

var Scroll$1 = Scroll_1;

var Style$2 = Style_1;

var UnicodeBidi = UnicodeBidi_1;

var UnicodeBidiDirection = UnicodeBidiDirection_1;

var cx$4 = cx_1;

var getElementPosition = getElementPosition_1;

var getScrollPosition$2 = getScrollPosition_1;

var getViewportDimensions = getViewportDimensions_1;

var invariant$c = invariant_1;

var isHTMLElement$2 = isHTMLElement_1;

var nullthrows$7 = nullthrows_1;

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */


var DraftEditorBlock$2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$4(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$9(_assertThisInitialized$2(_this), "_node", void 0);

    return _this;
  }

  var _proto = DraftEditorBlock.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programmatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.preventScroll) {
      return;
    }

    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this._node;

    if (blockNode == null) {
      return;
    }

    var scrollParent = Style$2.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition$2(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement$2(blockNode) ? process.env.NODE_ENV !== "production" ? invariant$c(false, 'blockNode is not an HTMLElement') : invariant$c(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var pOffset = scrollParent.offsetTop + scrollParent.offsetHeight;
      var scrollBottom = pOffset + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll$1.setTop(scrollParent, Scroll$1.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves'); // T44088704

      if (leavesForLeafSet.size === 0) {
        return null;
      }

      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey$2.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React$4.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();
      var decoratorKey = leafSet.get('decoratorKey');

      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows$7(_this2.props.decorator);
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey$2.encode(blockKey, ii, 0);
      var start = leavesForLeafSet.first().get('start');
      var end = leavesForLeafSet.last().get('end');
      var decoratedText = text.slice(start, end);
      var entityKey = block.getEntityAt(leafSet.get('start')); // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
      var commonProps = {
        contentState: _this2.props.contentState,
        decoratedText: decoratedText,
        dir: dir,
        start: start,
        end: end,
        blockKey: blockKey,
        entityKey: entityKey,
        offsetKey: decoratorOffsetKey
      };
      return React$4.createElement(DecoratorComponent, _extends$9({}, decoratorProps, commonProps, {
        key: decoratorOffsetKey
      }), leaves);
    }).toArray();
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        direction = _this$props.direction,
        offsetKey = _this$props.offsetKey;
    var className = cx$4({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });
    return React$4.createElement("div", {
      "data-offset-key": offsetKey,
      className: className,
      ref: function ref(_ref) {
        return _this3._node = _ref;
      }
    }, this._renderChildren());
  };

  return DraftEditorBlock;
}(React$4.Component);

var DraftEditorBlock_react = DraftEditorBlock$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */
/**
 * Combines multiple className strings into one.
 */

function joinClasses$1(className) {
  var newClassName = className || '';
  var argLength = arguments.length;

  if (argLength > 1) {
    for (var index = 1; index < argLength; index++) {
      var nextClass = arguments[index];

      if (nextClass) {
        newClassName = (newClassName ? newClassName + ' ' : '') + nextClass;
      }
    }
  }

  return newClassName;
}

var joinClasses_1 = joinClasses$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var _assign$1 = objectAssign;

function _extends$8() { _extends$8 = _assign$1 || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose$3(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlock$1 = DraftEditorBlock_react;

var DraftOffsetKey$1 = DraftOffsetKey_1;

var React$3 = React__default;

var cx$3 = cx_1;

var joinClasses = joinClasses_1;

var nullthrows$6 = nullthrows_1;

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx$3({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth >= 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};
/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */


var DraftEditorContents$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$3(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContents.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        preventScroll = _this$props.preventScroll,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows$6(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];
    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];

      var key = _block.getKey();

      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;

      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey$1.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        offsetKey: offsetKey,
        preventScroll: preventScroll,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };
      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();

      var _className = '';

      if (blockStyleFn) {
        _className = blockStyleFn(_block);
      } // List items are special snowflakes, since we handle nesting and
      // counters manually.


      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        _className = joinClasses(_className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock$1;
      var childProps = {
        className: _className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };

      if (customEditable !== undefined) {
        childProps = _objectSpread$6({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React$3.createElement(Element, childProps,
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
       * comment suppresses an error found when Flow v0.112 was deployed. To
       * see the error delete this comment and run Flow. */
      React$3.createElement(Component, _extends$8({}, componentProps, {
        key: key
      })));
      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }

      lastWrapperTemplate = wrapperTemplate;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React$3.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React$3.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContents;
}(React$3.Component);

var DraftEditorContentsCore_react = DraftEditorContents$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */

var gkx$5 = gkx$8;

var experimentalTreeDataSupport$4 = gkx$5('draft_tree_data_support');
var DraftEditorContents_react = experimentalTreeDataSupport$4 ? DraftEditorContentsExperimental_react : DraftEditorContentsCore_react;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType$1 = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType$1.isImage(mimeString) && ( // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

var PhotosMimeType_1 = PhotosMimeType$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var invariant$b = invariant_1;
/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */


function toArray$2(obj) {
  var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).

  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== "production" ? invariant$b(false, 'toArray: Array-like object expected') : invariant$b(false) : void 0;
  !(typeof length === 'number') ? process.env.NODE_ENV !== "production" ? invariant$b(false, 'toArray: Object needs a length property') : invariant$b(false) : void 0;
  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== "production" ? invariant$b(false, 'toArray: Object should have keys for indices') : invariant$b(false) : void 0;
  !(typeof obj.callee !== 'function') ? process.env.NODE_ENV !== "production" ? invariant$b(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant$b(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.

  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {// IE < 9 does not support Array#slice on collections objects
    }
  } // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.


  var ret = Array(length);

  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }

  return ret;
}
/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */


function hasArrayNature(obj) {
  return (// not null/false
    !!obj && ( // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
    'length' in obj && // not window
    !('setInterval' in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && ( // a real array
    Array.isArray(obj) || // arguments
    'callee' in obj || // HTMLCollection/NodeList
    'item' in obj)
  );
}
/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */


function createArrayFromMixed$1(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray$2(obj);
  }
}

var createArrayFromMixed_1 = createArrayFromMixed$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction$2 = function emptyFunction() {};

emptyFunction$2.thatReturns = makeEmptyFunction;
emptyFunction$2.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction$2.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction$2.thatReturnsNull = makeEmptyFunction(null);

emptyFunction$2.thatReturnsThis = function () {
  return this;
};

emptyFunction$2.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var PhotosMimeType = PhotosMimeType_1;

var createArrayFromMixed = createArrayFromMixed_1;

var emptyFunction$1 = emptyFunction_1;

var CR_LF_REGEX = new RegExp("\r\n", 'g');
var LF_ONLY = "\n";
var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};
/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */

function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer$2 =
/*#__PURE__*/
function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    this.data = data; // Types could be DOMStringList or array

    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }
  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  var _proto = DataTransfer.prototype;

  _proto.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    } // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.


    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };
  /**
   * Get raw text.
   *
   * @return {?string}
   */


  _proto.getText = function getText() {
    var text;

    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }

    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };
  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  _proto.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };
  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  _proto.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };
  /**
   * Get a link url.
   *
   * @return {?string}
   */


  _proto.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }

      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };
  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  _proto.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();

    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;

      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  _proto.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }

    return null;
  };
  /**
   * Get files.
   *
   * @return {array}
   */


  _proto.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction$1.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };
  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  _proto.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

var DataTransfer_1 = DataTransfer$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var invariant$a = invariant_1;

var TEXT_CLIPPING_REGEX = /\.textClipping$/;
var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
}; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.

var TEXT_SIZE_UPPER_BOUND = 5000;
/**
 * Extract the text content from a file list.
 */

function getTextContentFromFiles$2(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function (
  /*blob*/
  file) {
    readFile(file, function (
    /*string*/
    text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));

      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}
/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */


function readFile(file, callback) {
  if (!commonjsGlobal.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var _contents = ''; // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.

    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      _contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }

    callback(_contents);
    return;
  }

  var reader = new FileReader();

  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ? process.env.NODE_ENV !== "production" ? invariant$a(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant$a(false) : void 0;
    callback(result);
  };

  reader.onerror = function () {
    callback('');
  };

  reader.readAsText(file);
}

var getTextContentFromFiles_1 = getTextContentFromFiles$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled$4(value) {
  return value === 'handled' || value === true;
}

var isEventHandled_1 = isEventHandled$4;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DataTransfer$1 = DataTransfer_1;

var DraftModifier$b = DraftModifier_1;

var EditorState$m = EditorState_1;

var findAncestorOffsetKey$1 = findAncestorOffsetKey_1;

var getCorrectDocumentFromNode$1 = getCorrectDocumentFromNode_1;

var getTextContentFromFiles$1 = getTextContentFromFiles_1;

var getUpdatedSelectionState = getUpdatedSelectionState_1;

var getWindowForNode = getWindowForNode_1;

var isEventHandled$3 = isEventHandled_1;

var nullthrows$5 = nullthrows_1;
/**
 * Get a SelectionState for the supplied mouse event.
 */


function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;
  var eventTargetDocument = getCorrectDocumentFromNode$1(event.currentTarget);
  /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
   * suppresses an error found when Flow v0.68 was deployed. To see the error
   * delete this comment and run Flow. */

  if (typeof eventTargetDocument.caretRangeFromPoint === 'function') {
    /* $FlowFixMe[incompatible-use] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */
    var dropRange = eventTargetDocument.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows$5(node);
  offset = nullthrows$5(offset);
  var offsetKey = nullthrows$5(findAncestorOffsetKey$1(node));
  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler$1 = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
    endDrag(editor);
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer$1(e.nativeEvent.dataTransfer);
    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
    e.preventDefault();
    editor._dragCount = 0;
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();

    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled$3(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles$1(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';

    if (editor.props.handleDrop && isEventHandled$3(editor.props.handleDrop(dropSelection, data, dragType))) ; else if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
    } else {
      editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
    }

    endDrag(editor);
  }
};

function endDrag(editor) {
  editor._internalDrag = false; // Fix issue #1383
  // Prior to React v16.5.0 onDrop breaks onSelect event:
  // https://github.com/facebook/react/issues/11379.
  // Dispatching a mouseup event on DOM node will make it go back to normal.

  var editorNode = editor.editorContainer;

  if (editorNode) {
    var mouseUpEvent = new MouseEvent('mouseup', {
      view: getWindowForNode(editorNode),
      bubbles: true,
      cancelable: true
    });
    editorNode.dispatchEvent(mouseUpEvent);
  }
}

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier$b.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState$m.push(editorState, newContentState, 'insert-fragment');
}
/**
 * Insert text at a specified selection.
 */


function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier$b.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState$m.push(editorState, newContentState, 'insert-fragment');
}

var DraftEditorDragHandler_1 = DraftEditorDragHandler$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function isSelectionAtLeafStart$1(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();
  var isAtStart = false;
  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');

        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });
  return isAtStart;
}

var isSelectionAtLeafStart_1 = isSelectionAtLeafStart$1;

(function (global, undefined$1) {

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined$1, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof commonjsGlobal === "undefined" ? commonjsGlobal : commonjsGlobal : self));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// the actual function.



var setImmediate$2 = commonjsGlobal.setImmediate;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$a = DraftModifier_1;

var EditorState$l = EditorState_1;

var UserAgent$9 = UserAgent_1;

var getEntityKeyForSelection$1 = getEntityKeyForSelection_1;

var isEventHandled$2 = isEventHandled_1;

var isSelectionAtLeafStart = isSelectionAtLeafStart_1;

var nullthrows$4 = nullthrows_1;

var setImmediate$1 = setImmediate$2; // When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.


var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox$1 = UserAgent$9.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox$1 && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}
/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */


function replaceText(editorState, text, inlineStyle, entityKey, forceSelection) {
  var contentState = DraftModifier$a.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState$l.push(editorState, contentState, 'insert-characters', forceSelection);
}
/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */


function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;
  var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.

  if (!chars) {
    return;
  } // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.


  if (editor.props.handleBeforeInput && isEventHandled$2(editor.props.handleBeforeInput(chars, editorState, e.timeStamp))) {
    e.preventDefault();
    return;
  } // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.


  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();
    editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection$1(editorState.getCurrentContent(), editorState.getSelection()), true));
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection$1(editorState.getCurrentContent(), editorState.getSelection()), false); // Bunch of different cases follow where we need to prevent native insertion.

  var mustPreventNative = false;

  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }

  if (!mustPreventNative) {
    // Let's say we have a decorator that highlights hashtags. In many cases
    // we need to prevent native behavior and rerender ourselves --
    // particularly, any case *except* where the inserted characters end up
    // anywhere except exactly where you put them.
    //
    // Using [] to denote a decorated leaf, some examples:
    //
    // 1. 'hi #' and append 'f'
    // desired rendering: 'hi [#f]'
    // native rendering would be: 'hi #f' (incorrect)
    //
    // 2. 'x [#foo]' and insert '#' before 'f'
    // desired rendering: 'x #[#foo]'
    // native rendering would be: 'x [##foo]' (incorrect)
    //
    // 3. '[#foobar]' and insert ' ' between 'foo' and 'bar'
    // desired rendering: '[#foo] bar'
    // native rendering would be: '[#foo bar]' (incorrect)
    //
    // 4. '[#foo]' and delete '#' [won't use this beforeinput codepath though]
    // desired rendering: 'foo'
    // native rendering would be: '[foo]' (incorrect)
    //
    // 5. '[#foo]' and append 'b'
    // desired rendering: '[#foob]'
    // native rendering would be: '[#foob]'
    // (native insertion here would be ok for decorators like simple spans,
    // but not more complex decorators. To be safe, we need to prevent it.)
    //
    // It is safe to allow native insertion if and only if the full list of
    // decorator ranges matches what we expect native insertion to give, and
    // the range lengths have not changed. We don't need to compare the content
    // because the only possible mutation to consider here is inserting plain
    // text and decorators can't affect text content.
    var oldBlockTree = editorState.getBlockTree(anchorKey);
    var newBlockTree = newEditorState.getBlockTree(anchorKey);
    mustPreventNative = oldBlockTree.size !== newBlockTree.size || oldBlockTree.zip(newBlockTree).some(function (_ref) {
      var oldLeafSet = _ref[0],
          newLeafSet = _ref[1];
      // selectionStart is guaranteed to be selectionEnd here
      var oldStart = oldLeafSet.get('start');
      var adjustedStart = oldStart + (oldStart >= selectionStart ? chars.length : 0);
      var oldEnd = oldLeafSet.get('end');
      var adjustedEnd = oldEnd + (oldEnd >= selectionStart ? chars.length : 0);
      var newStart = newLeafSet.get('start');
      var newEnd = newLeafSet.get('end');
      var newDecoratorKey = newLeafSet.get('decoratorKey');
      return (// Different decorators
        oldLeafSet.get('decoratorKey') !== newDecoratorKey || // Different number of inline styles
        oldLeafSet.get('leaves').size !== newLeafSet.get('leaves').size || // Different effective decorator position
        adjustedStart !== newStart || adjustedEnd !== newEnd || // Decorator already existed and its length changed
        newDecoratorKey != null && newEnd - newStart !== oldEnd - oldStart
      );
    });
  }

  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }

  if (!mustPreventNative) {
    mustPreventNative = nullthrows$4(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows$4(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    newEditorState = EditorState$l.set(newEditorState, {
      forceSelection: true
    });
    editor.update(newEditorState);
    return;
  } // We made it all the way! Let the browser do its thing and insert the char.


  newEditorState = EditorState$l.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  }); // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.

  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate$1(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

var editOnBeforeInput_1 = editOnBeforeInput;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$k = EditorState_1;

var containsNode = containsNode_1;

var getActiveElement = getActiveElement_1;

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  var ownerDocument = e.currentTarget.ownerDocument;

  if ( // This ESLint rule conflicts with `sketchy-null-bool` flow check
  // eslint-disable-next-line no-extra-boolean-cast
  !Boolean(editor.props.preserveSelectionOnBlur) && getActiveElement(ownerDocument) === ownerDocument.body) {
    var _selection = ownerDocument.defaultView.getSelection();

    var editorNode = editor.editor;

    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState$k.acceptSelection(editorState, selection));
}

var editOnBlur_1 = editOnBlur;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$j = EditorState_1;
/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */


function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState$j.set(editor._latestEditorState, {
    inCompositionMode: true
  })); // Allow composition handler to interpret the compositionstart event

  editor._onCompositionStart(e);
}

var editOnCompositionStart_1 = editOnCompositionStart;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var getContentStateFragment$2 = getContentStateFragment_1;

function getFragmentFromSelection$2(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment$2(editorState.getCurrentContent(), selectionState);
}

var getFragmentFromSelection_1 = getFragmentFromSelection$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var getFragmentFromSelection$1 = getFragmentFromSelection_1;
/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */


function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection(); // No selection, so there's nothing to copy.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection$1(editor._latestEditorState));
}

var editOnCopy_1 = editOnCopy;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isInstanceOfNode(target) {
  // we changed the name because of having duplicate module provider (fbjs)
  if (!target || !('ownerDocument' in target)) {
    return false;
  }

  if ('ownerDocument' in target) {
    var node = target;

    if (!node.ownerDocument.defaultView) {
      return node instanceof Node;
    }

    if (node instanceof node.ownerDocument.defaultView.Node) {
      return true;
    }
  }

  return false;
}

var isInstanceOfNode_1 = isInstanceOfNode;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$9 = DraftModifier_1;

var EditorState$i = EditorState_1;

var Style$1 = Style_1;

var getFragmentFromSelection = getFragmentFromSelection_1;

var getScrollPosition$1 = getScrollPosition_1;

var isNode = isInstanceOfNode_1;
/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */


function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition; // No selection, so there's nothing to cut.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  } // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.


  if (isNode(element)) {
    var node = element;
    scrollPosition = getScrollPosition$1(Style$1.getScrollParent(node));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.

  editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.

  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier$9.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState$i.push(editorState, newContent, 'remove-range');
}

var editOnCut_1 = editOnCut;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor.setMode('drag');
  e.preventDefault();
}

var editOnDragOver_1 = editOnDragOver;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

var editOnDragStart_1 = editOnDragStart;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$h = EditorState_1;

var UserAgent$8 = UserAgent_1;

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.

  if (UserAgent$8.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState$h.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState$h.acceptSelection(editorState, selection));
  }
}

var editOnFocus_1 = editOnFocus;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant$9 = invariant_1; // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.


var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */

function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}
/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */


function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ? process.env.NODE_ENV !== "production" ? invariant$9(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant$9(false) : void 0;

  if (index + 1 === str.length) {
    return false;
  }

  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}
/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */


function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}
/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */


function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}
/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */


function strlen$1(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }

  return len;
}
/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */


function substr$2(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char

  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  } // Obvious cases


  var size = str.length;

  if (size <= 0 || start > size || length <= 0) {
    return '';
  } // Find the actual starting position


  var posA = 0;

  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }

    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }

    if (posA < 0) {
      posA = 0;
    }
  } // Find the actual ending position


  var posB = size;

  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}
/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */


function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }

  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr$2(str, start, length);
}
/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */


function getCodePoints(str) {
  var codePoints = [];

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }

  return codePoints;
}

var UnicodeUtils$7 = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen$1,
  substring: substring,
  substr: substr$2
};
var UnicodeUtils_1 = UnicodeUtils$7;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var emptyFunction = emptyFunction_1;
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argIndex = 0;
  var message = 'Warning: ' + format.replace(/%s/g, function () {
    return args[argIndex++];
  });

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {}
}

var warning$8 = process.env.NODE_ENV !== "production" ? function (condition, format) {
  if (format === undefined) {
    throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
  }

  if (!condition) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    printWarning.apply(void 0, [format].concat(args));
  }
} : emptyFunction;
var warning_1 = warning$8;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var warning$7 = warning_1;
/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionBackward$3(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

  process.env.NODE_ENV !== "production" ? warning$7(selection.isCollapsed(), 'moveSelectionBackward should only be called with a collapsed SelectionState') : void 0;
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);

    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

var moveSelectionBackward_1 = moveSelectionBackward$3;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$8 = DraftModifier_1;

var gkx$4 = gkx$8;

var experimentalTreeDataSupport$3 = gkx$4('draft_tree_data_support');
/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */

function removeTextWithStrategy$5(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey();
  var anchorBlock = content.getBlockForKey(anchorKey);

  if (experimentalTreeDataSupport$3) {
    if (direction === 'forward') {
      if (anchorKey !== focusKey) {
        // For now we ignore forward delete across blocks,
        // if there is demand for this we will implement it.
        return content;
      }
    }
  }

  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }

      if (experimentalTreeDataSupport$3) {
        var isAtEndOfBlock = selection.getAnchorOffset() === content.getBlockForKey(anchorKey).getLength();

        if (isAtEndOfBlock) {
          var anchorBlockSibling = content.getBlockForKey(anchorBlock.nextSibling);

          if (!anchorBlockSibling || anchorBlockSibling.getLength() === 0) {
            // For now we ignore forward delete at the end of a block,
            // if there is demand for this we will implement it.
            return content;
          }
        }
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);

    if (target === selection) {
      return content;
    }
  }

  return DraftModifier$8.removeRange(content, target, direction);
}

var removeTextWithStrategy_1 = removeTextWithStrategy$5;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$g = EditorState_1;

var UnicodeUtils$6 = UnicodeUtils_1;

var moveSelectionBackward$2 = moveSelectionBackward_1;

var removeTextWithStrategy$4 = removeTextWithStrategy_1;
/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainBackspace$2(editorState) {
  var afterRemoval = removeTextWithStrategy$4(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward$2(strategyState, charBehind ? UnicodeUtils$6.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState$g.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

var keyCommandPlainBackspace_1 = keyCommandPlainBackspace$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$7 = DraftModifier_1;

var DraftOffsetKey = DraftOffsetKey_1;

var EditorState$f = EditorState_1;

var UserAgent$7 = UserAgent_1;

var _require$2 = draftKeyUtils,
    notEmptyKey = _require$2.notEmptyKey;

var findAncestorOffsetKey = findAncestorOffsetKey_1;

var keyCommandPlainBackspace$1 = keyCommandPlainBackspace_1;

var nullthrows$3 = nullthrows_1;

var isGecko = UserAgent$7.isEngine('Gecko');
var DOUBLE_NEWLINE = '\n\n';

function onInputType(inputType, editorState) {
  switch (inputType) {
    case 'deleteContentBackward':
      return keyCommandPlainBackspace$1(editorState);
  }

  return editorState;
}
/**
 * This function serves two purposes
 *
 * 1. To update the editorState and call onChange method with the new
 * editorState. This editorState is calculated in editOnBeforeInput but the
 * onChange method is not called with the new state until this method does it.
 * It is done to handle a specific case where certain character inputs might
 * be replaced with something else. E.g. snippets ('rc' might be replaced
 * with boilerplate code for react component). More information on the
 * exact problem can be found here -
 * https://github.com/facebook/draft-js/commit/07892ba479bd4dfc6afd1e0ed179aaf51cd138b1
 *
 * 2. intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */


function editOnInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  } // at this point editor is not null for sure (after input)


  var castedEditorElement = editor.editor;
  var domSelection = castedEditorElement.ownerDocument.defaultView.getSelection();
  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;
  var isNotTextOrElementNode = (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.TEXT_NODE && (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.ELEMENT_NODE;

  if (anchorNode == null || isNotTextOrElementNode) {
    // TODO: (t16149272) figure out context for this change
    return;
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;

    if (span == null) {
      // Handle null-parent case.
      return;
    }

    anchorNode.nodeValue = span.textContent;

    for (var child = span.firstChild; child != null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows$3(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.

  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  } // No change -- the DOM is up to date. Nothing to do here.


  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly.
    // Newest versions of Android support the dom-inputevent-inputtype
    // and we can use the `inputType` to properly apply the state changes.

    /* $FlowFixMe[prop-missing] inputType is only defined on a draft of a
     * standard. https://w3c.github.io/input-events/#dom-inputevent-inputtype
     */
    var inputType = e.nativeEvent.inputType;

    if (inputType) {
      var newEditorState = onInputType(inputType, editorState);

      if (newEditorState !== editorState) {
        editor.restoreEditorDOM();
        editor.update(newEditorState);
        return;
      }
    }

    return;
  }

  var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.

  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });
  var entityKey = block.getEntityAt(start);
  var entity = notEmptyKey(entityKey) ? content.getEntity(entityKey) : null;
  var entityType = entity != null ? entity.getMutability() : null;
  var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.

  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
  var newContent = DraftModifier$7.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();
    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  } // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.


  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({
      anchorOffset: anchorOffset,
      focusOffset: focusOffset
    })
  });
  editor.update(EditorState$f.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

var editOnInput_1 = editOnInput;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var Keys$2 = Keys$4;

function isSoftNewlineEvent$1(e) {
  return e.which === Keys$2.RETURN && (e.getModifierState('Shift') || e.getModifierState('Alt') || e.getModifierState('Control'));
}

var isSoftNewlineEvent_1 = isSoftNewlineEvent$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UserAgent$6 = UserAgent_1;

var isSoftNewlineEvent = isSoftNewlineEvent_1;

var isOSX$1 = UserAgent$6.isPlatform('Mac OS X');
var KeyBindingUtil$3 = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },
  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX$1 && e.altKey;
  },
  usesMacOSHeuristics: function usesMacOSHeuristics() {
    return isOSX$1;
  },
  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX$1 ? !!e.metaKey && !e.altKey : KeyBindingUtil$3.isCtrlKeyCommand(e);
  },
  isSoftNewlineEvent: isSoftNewlineEvent
};
var KeyBindingUtil_1 = KeyBindingUtil$3;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$6 = DraftModifier_1;

var EditorState$e = EditorState_1;

var getContentStateFragment$1 = getContentStateFragment_1;

var nullthrows$2 = nullthrows_1;

var clipboard = null;
/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */

var SecondaryClipboard$1 = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        var keyAfter = content.getKeyAfter(anchorKey);

        if (keyAfter == null) {
          return editorState;
        }

        targetRange = selection.set('focusKey', keyAfter).set('focusOffset', 0);
      } else {
        targetRange = selection.set('focusOffset', blockEnd);
      }
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows$2(targetRange); // TODO: This should actually append to the current state when doing
    // successive ^K commands without any other cursor movement

    clipboard = getContentStateFragment$1(content, targetRange);
    var afterRemoval = DraftModifier$6.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState$e.push(editorState, afterRemoval, 'remove-range');
  },
  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier$6.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
    return EditorState$e.push(editorState, newContent, 'insert-fragment');
  }
};
var SecondaryClipboard_1 = SecondaryClipboard$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UserAgent$5 = UserAgent_1;

var invariant$8 = invariant_1;

var isChrome$2 = UserAgent$5.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437

/* eslint-disable consistent-return */

function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;

    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }

    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);

    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }

    tempRange.setEndBefore(ancestor);
  }

  process.env.NODE_ENV !== "production" ? invariant$8(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant$8(false) ;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */


var getRangeClientRects$2 = isChrome$2 ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};
var getRangeClientRects_1 = getRangeClientRects$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var UnicodeUtils$5 = UnicodeUtils_1;

var getCorrectDocumentFromNode = getCorrectDocumentFromNode_1;

var getRangeClientRects$1 = getRangeClientRects_1;

var invariant$7 = invariant_1;
/**
 * Return the computed line height, in pixels, for the provided element.
 */


function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var correctDocument = getCorrectDocumentFromNode(element);
  var div = correctDocument.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';
  var documentBody = correctDocument.body;
  !documentBody ? process.env.NODE_ENV !== "production" ? invariant$7(false, 'Missing document.body') : invariant$7(false) : void 0; // forced layout here

  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);
  return rect.height;
}
/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */


function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];

    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }

    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}
/**
 * Return the length of a node, as used by Range offsets.
 */


function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;

    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;

    default:
      return node.childNodes.length;
  }
}
/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */


function expandRangeToStartOfLine$1(range) {
  !range.collapsed ? process.env.NODE_ENV !== "production" ? invariant$7(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant$7(false) : void 0;
  range = range.cloneRange();
  var containingElement = range.startContainer;

  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }

  var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects$1(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ? process.env.NODE_ENV !== "production" ? invariant$7(false, 'Found unexpected detached subtree when traversing.') : invariant$7(false) : void 0;
    range.setStartBefore(bestContainer);

    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  } // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.
  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.


  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;
    var ii = maxIndexToConsider;

    for (; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils$5.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);

      if (areRectsOnOneLine(getRangeClientRects$1(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

var expandRangeToStartOfLine_1 = expandRangeToStartOfLine$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$d = EditorState_1;

var expandRangeToStartOfLine = expandRangeToStartOfLine_1;

var getDraftEditorSelectionWithNodes = getDraftEditorSelectionWithNodes_1;

var moveSelectionBackward$1 = moveSelectionBackward_1;

var removeTextWithStrategy$3 = removeTextWithStrategy_1;

function keyCommandBackspaceToStartOfLine$1(editorState, e) {
  var afterRemoval = removeTextWithStrategy$3(editorState, function (strategyState) {
    var selection = strategyState.getSelection();

    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward$1(strategyState, 1);
    }

    var ownerDocument = e.currentTarget.ownerDocument;
    var domSelection = ownerDocument.defaultView.getSelection(); // getRangeAt can technically throw if there's no selection, but we know
    // there is one here because text editor has focus (the cursor is a
    // selection of length 0). Therefore, we don't need to wrap this in a
    // try-catch block.

    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);
    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState$d.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandBackspaceToStartOfLine_1 = keyCommandBackspaceToStartOfLine$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + "\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]";
var TokenizeUtil$1 = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var TokenizeUtil = TokenizeUtil$1;

var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.

var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.

var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);
var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord$2 = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },
  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};
var DraftRemovableWord_1 = DraftRemovableWord$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftRemovableWord$1 = DraftRemovableWord_1;

var EditorState$c = EditorState_1;

var moveSelectionBackward = moveSelectionBackward_1;

var removeTextWithStrategy$2 = removeTextWithStrategy_1;
/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */


function keyCommandBackspaceWord$1(editorState) {
  var afterRemoval = removeTextWithStrategy$2(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.

    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord$1.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState$c.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandBackspaceWord_1 = keyCommandBackspaceWord$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var warning$6 = warning_1;
/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionForward$2(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

  process.env.NODE_ENV !== "production" ? warning$6(selection.isCollapsed(), 'moveSelectionForward should only be called with a collapsed SelectionState') : void 0;
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();
  var focusKey = key;
  var focusOffset;
  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset
  });
}

var moveSelectionForward_1 = moveSelectionForward$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftRemovableWord = DraftRemovableWord_1;

var EditorState$b = EditorState_1;

var moveSelectionForward$1 = moveSelectionForward_1;

var removeTextWithStrategy$1 = removeTextWithStrategy_1;
/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */


function keyCommandDeleteWord$1(editorState) {
  var afterRemoval = removeTextWithStrategy$1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text); // If there are no words in front of the cursor, remove the newline.

    return moveSelectionForward$1(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState$b.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandDeleteWord_1 = keyCommandDeleteWord$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$5 = DraftModifier_1;

var EditorState$a = EditorState_1;

function keyCommandInsertNewline$1(editorState) {
  var contentState = DraftModifier$5.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState$a.push(editorState, contentState, 'split-block');
}

var keyCommandInsertNewline_1 = keyCommandInsertNewline$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$9 = EditorState_1;
/**
 * See comment for `moveSelectionToStartOfBlock`.
 */


function keyCommandMoveSelectionToEndOfBlock$1(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState$9.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

var keyCommandMoveSelectionToEndOfBlock_1 = keyCommandMoveSelectionToEndOfBlock$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$8 = EditorState_1;
/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */


function keyCommandMoveSelectionToStartOfBlock$1(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState$8.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

var keyCommandMoveSelectionToStartOfBlock_1 = keyCommandMoveSelectionToStartOfBlock$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$7 = EditorState_1;

var UnicodeUtils$4 = UnicodeUtils_1;

var moveSelectionForward = moveSelectionForward_1;

var removeTextWithStrategy = removeTextWithStrategy_1;
/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainDelete$1(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils$4.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState$7.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

var keyCommandPlainDelete_1 = keyCommandPlainDelete$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$4 = DraftModifier_1;

var EditorState$6 = EditorState_1;

var getContentStateFragment = getContentStateFragment_1;
/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */


function keyCommandTransposeCharacters$1(editorState) {
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();

  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength(); // Nothing to transpose if there aren't two characters.

  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  } // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.


  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier$4.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.

  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });
  var afterInsert = DraftModifier$4.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  var newEditorState = EditorState$6.push(editorState, afterInsert, 'insert-fragment');
  return EditorState$6.acceptSelection(newEditorState, finalSelection);
}

var keyCommandTransposeCharacters_1 = keyCommandTransposeCharacters$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var EditorState$5 = EditorState_1;

function keyCommandUndo$1(e, editorState, updateFn) {
  var undoneState = EditorState$5.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.

  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState$5.set(undoneState, {
      nativelyRenderedContent: nativelyRenderedContent
    }));
    return;
  } // Otheriwse, manage the undo behavior manually.


  e.preventDefault();

  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  } // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.


  updateFn(EditorState$5.set(editorState, {
    nativelyRenderedContent: null
  })); // Wait to ensure that the re-render has occurred before performing
  // the undo action.

  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

var keyCommandUndo_1 = keyCommandUndo$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$3 = DraftModifier_1;

var EditorState$4 = EditorState_1;

var KeyBindingUtil$2 = KeyBindingUtil_1;

var Keys$1 = Keys$4;

var SecondaryClipboard = SecondaryClipboard_1;

var UserAgent$4 = UserAgent_1;

var isEventHandled$1 = isEventHandled_1;

var keyCommandBackspaceToStartOfLine = keyCommandBackspaceToStartOfLine_1;

var keyCommandBackspaceWord = keyCommandBackspaceWord_1;

var keyCommandDeleteWord = keyCommandDeleteWord_1;

var keyCommandInsertNewline = keyCommandInsertNewline_1;

var keyCommandMoveSelectionToEndOfBlock = keyCommandMoveSelectionToEndOfBlock_1;

var keyCommandMoveSelectionToStartOfBlock = keyCommandMoveSelectionToStartOfBlock_1;

var keyCommandPlainBackspace = keyCommandPlainBackspace_1;

var keyCommandPlainDelete = keyCommandPlainDelete_1;

var keyCommandTransposeCharacters = keyCommandTransposeCharacters_1;

var keyCommandUndo = keyCommandUndo_1;

var isOptionKeyCommand = KeyBindingUtil$2.isOptionKeyCommand;
var isChrome$1 = UserAgent$4.isBrowser('Chrome');
/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */

function onKeyCommand(command, editorState, e) {
  switch (command) {
    case 'redo':
      return EditorState$4.redo(editorState);

    case 'delete':
      return keyCommandPlainDelete(editorState);

    case 'delete-word':
      return keyCommandDeleteWord(editorState);

    case 'backspace':
      return keyCommandPlainBackspace(editorState);

    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);

    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState, e);

    case 'split-block':
      return keyCommandInsertNewline(editorState);

    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);

    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);

    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);

    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);

    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);

    default:
      return editorState;
  }
}
/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */


function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  function callDeprecatedHandler(handlerName) {
    var deprecatedHandler = editor.props[handlerName];

    if (deprecatedHandler) {
      deprecatedHandler(e);
      return true;
    } else {
      return false;
    }
  }

  switch (keyCode) {
    case Keys$1.RETURN:
      e.preventDefault(); // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.

      if (editor.props.handleReturn && isEventHandled$1(editor.props.handleReturn(e, editorState))) {
        return;
      }

      break;

    case Keys$1.ESC:
      e.preventDefault();

      if (callDeprecatedHandler('onEscape')) {
        return;
      }

      break;

    case Keys$1.TAB:
      if (callDeprecatedHandler('onTab')) {
        return;
      }

      break;

    case Keys$1.UP:
      if (callDeprecatedHandler('onUpArrow')) {
        return;
      }

      break;

    case Keys$1.RIGHT:
      if (callDeprecatedHandler('onRightArrow')) {
        return;
      }

      break;

    case Keys$1.DOWN:
      if (callDeprecatedHandler('onDownArrow')) {
        return;
      }

      break;

    case Keys$1.LEFT:
      if (callDeprecatedHandler('onLeftArrow')) {
        return;
      }

      break;

    case Keys$1.SPACE:
      // Prevent Chrome on OSX behavior where option + space scrolls.
      if (isChrome$1 && isOptionKeyCommand(e)) {
        e.preventDefault();
      }

  }

  var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.

  if (command == null || command === '') {
    if (keyCode === Keys$1.SPACE && isChrome$1 && isOptionKeyCommand(e)) {
      // The default keydown event has already been prevented in order to stop
      // Chrome from scrolling. Insert a nbsp into the editor as OSX would for
      // other browsers.
      var contentState = DraftModifier$3.replaceText(editorState.getCurrentContent(), editorState.getSelection(), "\xA0");
      editor.update(EditorState$4.push(editorState, contentState, 'insert-characters'));
    }

    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  } // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.


  e.preventDefault(); // Allow components higher up the tree to handle the command first.

  if (editor.props.handleKeyCommand && isEventHandled$1(editor.props.handleKeyCommand(command, editorState, e.timeStamp))) {
    return;
  }

  var newState = onKeyCommand(command, editorState, e);

  if (newState !== editorState) {
    editor.update(newState);
  }
}

var editOnKeyDown_1 = editOnKeyDown;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var URI$1 =
/*#__PURE__*/
function () {
  function URI(uri) {
    _defineProperty$7(this, "_uri", void 0);

    this._uri = uri;
  }

  var _proto = URI.prototype;

  _proto.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

var URI_1 = URI$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UserAgent$3 = UserAgent_1;

var invariant$6 = invariant_1;

var isOldIE = UserAgent$3.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML$2(html) {
  var doc;
  var root = null; // Provides a safe context

  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ? process.env.NODE_ENV !== "production" ? invariant$6(false, 'Missing doc.documentElement') : invariant$6(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }

  return root;
}

var getSafeBodyFromHTML_1 = getSafeBodyFromHTML$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement$3 = isElement_1;

function isHTMLAnchorElement$1(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement$3(node) && node.nodeName === 'A';
}

var isHTMLAnchorElement_1 = isHTMLAnchorElement$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement$2 = isElement_1;

function isHTMLImageElement$1(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement$2(node) && node.nodeName === 'IMG';
}

var isHTMLImageElement_1 = isHTMLImageElement$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var _knownListItemDepthCl;

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata$3 = CharacterMetadata_1;

var ContentBlock$4 = ContentBlock_1;

var ContentBlockNode$3 = ContentBlockNode_1;

var DefaultDraftBlockRenderMap$2 = DefaultDraftBlockRenderMap_1;

var DraftEntity$2 = DraftEntity_1;

var URI = URI_1;

var cx$2 = cx_1;

var generateRandomKey$5 = generateRandomKey_1;

var getSafeBodyFromHTML$1 = getSafeBodyFromHTML_1;

var gkx$3 = gkx$8;

var _require$1 = immutable.exports,
    List$4 = _require$1.List,
    Map$2 = _require$1.Map,
    OrderedSet$1 = _require$1.OrderedSet;

var isHTMLAnchorElement = isHTMLAnchorElement_1;

var isHTMLBRElement = isHTMLBRElement_1;

var isHTMLElement$1 = isHTMLElement_1;

var isHTMLImageElement = isHTMLImageElement_1;

var experimentalTreeDataSupport$2 = gkx$3('draft_tree_data_support');
var NBSP = '&nbsp;';
var SPACE$1 = ' '; // used for replacing characters in HTML

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_LEADING_LF = new RegExp('^\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', 'normal', '100', '200', '300', '400'];
var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty$6(_knownListItemDepthCl, cx$2('public/DraftStyleDefault/depth0'), 0), _defineProperty$6(_knownListItemDepthCl, cx$2('public/DraftStyleDefault/depth1'), 1), _defineProperty$6(_knownListItemDepthCl, cx$2('public/DraftStyleDefault/depth2'), 2), _defineProperty$6(_knownListItemDepthCl, cx$2('public/DraftStyleDefault/depth3'), 3), _defineProperty$6(_knownListItemDepthCl, cx$2('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
var HTMLTagToRawInlineStyleMap = Map$2({
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE',
  mark: 'HIGHLIGHT'
});

/**
 * Build a mapping from HTML tags to draftjs block types
 * out of a BlockRenderMap.
 *
 * The BlockTypeMap for the default BlockRenderMap looks like this:
 *   Map({
 *     h1: 'header-one',
 *     h2: 'header-two',
 *     h3: 'header-three',
 *     h4: 'header-four',
 *     h5: 'header-five',
 *     h6: 'header-six',
 *     blockquote: 'blockquote',
 *     figure: 'atomic',
 *     pre: ['code-block'],
 *     div: 'unstyled',
 *     p: 'unstyled',
 *     li: ['ordered-list-item', 'unordered-list-item'],
 *   })
 */
var buildBlockTypeMap = function buildBlockTypeMap(blockRenderMap) {
  var blockTypeMap = {};
  blockRenderMap.mapKeys(function (blockType, desc) {
    var elements = [desc.element];

    if (desc.aliasedElements !== undefined) {
      elements.push.apply(elements, desc.aliasedElements);
    }

    elements.forEach(function (element) {
      if (blockTypeMap[element] === undefined) {
        blockTypeMap[element] = blockType;
      } else if (typeof blockTypeMap[element] === 'string') {
        blockTypeMap[element] = [blockTypeMap[element], blockType];
      } else {
        blockTypeMap[element].push(blockType);
      }
    });
  });
  return Map$2(blockTypeMap);
};

var detectInlineStyle = function detectInlineStyle(node) {
  if (isHTMLElement$1(node)) {
    var element = node; // Currently only used to detect preformatted inline code

    if (element.style.fontFamily.includes('monospace')) {
      return 'CODE';
    }
  }

  return null;
};
/**
 * If we're pasting from one DraftEditor to another we can check to see if
 * existing list item depth classes are being used and preserve this style
 */


var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible link.
 */


var isValidAnchor = function isValidAnchor(node) {
  if (!isHTMLAnchorElement(node)) {
    return false;
  }

  var anchorNode = node;

  if (!anchorNode.href || anchorNode.protocol !== 'http:' && anchorNode.protocol !== 'https:' && anchorNode.protocol !== 'mailto:' && anchorNode.protocol !== 'tel:') {
    return false;
  }

  try {
    // Just checking whether we can actually create a URI
    var _ = new URI(anchorNode.href);

    return true; // We need our catch statements to have arguments, else
    // UglifyJS (which we use for our OSS builds) will crash.
    // eslint-disable-next-line fb-www/no-unused-catch-bindings
  } catch (_) {
    return false;
  }
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible image.
 */


var isValidImage = function isValidImage(node) {
  if (!isHTMLImageElement(node)) {
    return false;
  }

  var imageNode = node;
  return !!(imageNode.attributes.getNamedItem('src') && imageNode.attributes.getNamedItem('src').value);
};
/**
 * Try to guess the inline style of an HTML element based on its css
 * styles (font-weight, font-style and text-decoration).
 */


var styleFromNodeAttributes = function styleFromNodeAttributes(node, style) {
  if (!isHTMLElement$1(node)) {
    return style;
  }

  var htmlElement = node;
  var fontWeight = htmlElement.style.fontWeight;
  var fontStyle = htmlElement.style.fontStyle;
  var textDecoration = htmlElement.style.textDecoration;
  return style.withMutations(function (style) {
    if (boldValues.indexOf(fontWeight) >= 0) {
      style.add('BOLD');
    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
      style.remove('BOLD');
    }

    if (fontStyle === 'italic') {
      style.add('ITALIC');
    } else if (fontStyle === 'normal') {
      style.remove('ITALIC');
    }

    if (textDecoration === 'underline') {
      style.add('UNDERLINE');
    }

    if (textDecoration === 'line-through') {
      style.add('STRIKETHROUGH');
    }

    if (textDecoration === 'none') {
      style.remove('UNDERLINE');
      style.remove('STRIKETHROUGH');
    }
  });
};
/**
 * Determine if a nodeName is a list type, 'ul' or 'ol'
 */


var isListNode = function isListNode(nodeName) {
  return nodeName === 'ul' || nodeName === 'ol';
};
/**
 *  ContentBlockConfig is a mutable data structure that holds all
 *  the information required to build a ContentBlock and an array of
 *  all the child nodes (childConfigs).
 *  It is being used a temporary data structure by the
 *  ContentBlocksBuilder class.
 */


/**
 * ContentBlocksBuilder builds a list of ContentBlocks and an Entity Map
 * out of one (or several) HTMLElement(s).
 *
 * The algorithm has two passes: first it builds a tree of ContentBlockConfigs
 * by walking through the HTML nodes and their children, then it walks the
 * ContentBlockConfigs tree to compute parents/siblings and create
 * the actual ContentBlocks.
 *
 * Typical usage is:
 *     new ContentBlocksBuilder()
 *        .addDOMNode(someHTMLNode)
 *        .addDOMNode(someOtherHTMLNode)
 *       .getContentBlocks();
 *
 */
var ContentBlocksBuilder = /*#__PURE__*/function () {
  // Most of the method in the class depend on the state of the content builder
  // (i.e. currentBlockType, currentDepth, currentEntity etc.). Though it may
  // be confusing at first, it made the code simpler than the alternative which
  // is to pass those values around in every call.
  // The following attributes are used to accumulate text and styles
  // as we are walking the HTML node tree.
  // Describes the future ContentState as a tree of content blocks
  // The content blocks generated from the blockConfigs
  // Entity map use to store links and images found in the HTML nodes
  // Map HTML tags to draftjs block types and disambiguation function
  function ContentBlocksBuilder(blockTypeMap, disambiguate) {
    _defineProperty$6(this, "characterList", List$4());

    _defineProperty$6(this, "currentBlockType", 'unstyled');

    _defineProperty$6(this, "currentDepth", 0);

    _defineProperty$6(this, "currentEntity", null);

    _defineProperty$6(this, "currentText", '');

    _defineProperty$6(this, "wrapper", null);

    _defineProperty$6(this, "blockConfigs", []);

    _defineProperty$6(this, "contentBlocks", []);

    _defineProperty$6(this, "entityMap", DraftEntity$2);

    _defineProperty$6(this, "blockTypeMap", void 0);

    _defineProperty$6(this, "disambiguate", void 0);

    this.clear();
    this.blockTypeMap = blockTypeMap;
    this.disambiguate = disambiguate;
  }
  /**
   * Clear the internal state of the ContentBlocksBuilder
   */


  var _proto = ContentBlocksBuilder.prototype;

  _proto.clear = function clear() {
    this.characterList = List$4();
    this.blockConfigs = [];
    this.currentBlockType = 'unstyled';
    this.currentDepth = 0;
    this.currentEntity = null;
    this.currentText = '';
    this.entityMap = DraftEntity$2;
    this.wrapper = null;
    this.contentBlocks = [];
  }
  /**
   * Add an HTMLElement to the ContentBlocksBuilder
   */
  ;

  _proto.addDOMNode = function addDOMNode(node) {
    var _this$blockConfigs;

    this.contentBlocks = [];
    this.currentDepth = 0; // Converts the HTML node to block config

    (_this$blockConfigs = this.blockConfigs).push.apply(_this$blockConfigs, this._toBlockConfigs([node], OrderedSet$1())); // There might be some left over text in the builder's
    // internal state, if so make a ContentBlock out of it.


    this._trimCurrentText();

    if (this.currentText !== '') {
      this.blockConfigs.push(this._makeBlockConfig());
    } // for chaining


    return this;
  }
  /**
   * Return the ContentBlocks and the EntityMap that corresponds
   * to the previously added HTML nodes.
   */
  ;

  _proto.getContentBlocks = function getContentBlocks() {
    if (this.contentBlocks.length === 0) {
      if (experimentalTreeDataSupport$2) {
        this._toContentBlocks(this.blockConfigs);
      } else {
        this._toFlatContentBlocks(this.blockConfigs);
      }
    }

    return {
      contentBlocks: this.contentBlocks,
      entityMap: this.entityMap
    };
  } // ***********************************WARNING******************************
  // The methods below this line are private - don't call them directly.

  /**
   * Generate a new ContentBlockConfig out of the current internal state
   * of the builder, then clears the internal state.
   */
  ;

  _proto._makeBlockConfig = function _makeBlockConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = config.key || generateRandomKey$5();

    var block = _objectSpread$5({
      key: key,
      type: this.currentBlockType,
      text: this.currentText,
      characterList: this.characterList,
      depth: this.currentDepth,
      parent: null,
      children: List$4(),
      prevSibling: null,
      nextSibling: null,
      childConfigs: []
    }, config);

    this.characterList = List$4();
    this.currentBlockType = 'unstyled';
    this.currentText = '';
    return block;
  }
  /**
   * Converts an array of HTML elements to a multi-root tree of content
   * block configs. Some text content may be left in the builders internal
   * state to enable chaining sucessive calls.
   */
  ;

  _proto._toBlockConfigs = function _toBlockConfigs(nodes, style) {
    var blockConfigs = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var nodeName = node.nodeName.toLowerCase();

      if (nodeName === 'body' || isListNode(nodeName)) {
        // body, ol and ul are 'block' type nodes so create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        } // body, ol and ul nodes are ignored, but their children are inlined in
        // the parent block config.


        var wasCurrentDepth = this.currentDepth;
        var wasWrapper = this.wrapper;

        if (isListNode(nodeName)) {
          this.wrapper = nodeName;

          if (isListNode(wasWrapper)) {
            this.currentDepth++;
          }
        }

        blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
        this.currentDepth = wasCurrentDepth;
        this.wrapper = wasWrapper;
        continue;
      }

      var blockType = this.blockTypeMap.get(nodeName);

      if (blockType !== undefined) {
        // 'block' type node means we need to create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        }

        var _wasCurrentDepth = this.currentDepth;
        var _wasWrapper = this.wrapper;
        this.wrapper = nodeName === 'pre' ? 'pre' : this.wrapper;

        if (typeof blockType !== 'string') {
          blockType = this.disambiguate(nodeName, this.wrapper) || blockType[0] || 'unstyled';
        }

        if (!experimentalTreeDataSupport$2 && isHTMLElement$1(node) && (blockType === 'unordered-list-item' || blockType === 'ordered-list-item')) {
          var htmlElement = node;
          this.currentDepth = getListItemDepth(htmlElement, this.currentDepth);
        }

        var key = generateRandomKey$5();

        var childConfigs = this._toBlockConfigs(Array.from(node.childNodes), style);

        this._trimCurrentText();

        blockConfigs.push(this._makeBlockConfig({
          key: key,
          childConfigs: childConfigs,
          type: blockType
        }));
        this.currentDepth = _wasCurrentDepth;
        this.wrapper = _wasWrapper;
        continue;
      }

      if (nodeName === '#text') {
        this._addTextNode(node, style);

        continue;
      }

      if (nodeName === 'br') {
        this._addBreakNode(node, style);

        continue;
      }

      if (isValidImage(node)) {
        this._addImgNode(node, style);

        continue;
      }

      if (isValidAnchor(node)) {
        this._addAnchorNode(node, blockConfigs, style);

        continue;
      }

      var newStyle = style;

      if (HTMLTagToRawInlineStyleMap.has(nodeName)) {
        newStyle = newStyle.add(HTMLTagToRawInlineStyleMap.get(nodeName));
      }

      newStyle = styleFromNodeAttributes(node, newStyle);
      var inlineStyle = detectInlineStyle(node);

      if (inlineStyle != null) {
        newStyle = newStyle.add(inlineStyle);
      }

      blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), newStyle));
    }

    return blockConfigs;
  }
  /**
   * Append a string of text to the internal buffer.
   */
  ;

  _proto._appendText = function _appendText(text, style) {
    var _this$characterList;

    this.currentText += text;
    var characterMetadata = CharacterMetadata$3.create({
      style: style,
      entity: this.currentEntity
    });
    this.characterList = (_this$characterList = this.characterList).push.apply(_this$characterList, Array(text.length).fill(characterMetadata));
  }
  /**
   * Trim the text in the internal buffer.
   */
  ;

  _proto._trimCurrentText = function _trimCurrentText() {
    var l = this.currentText.length;
    var begin = l - this.currentText.trimLeft().length;
    var end = this.currentText.trimRight().length; // We should not trim whitespaces for which an entity is defined.

    var entity = this.characterList.findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    begin = entity !== undefined ? Math.min(begin, entity[0]) : begin;
    entity = this.characterList.reverse().findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    end = entity !== undefined ? Math.max(end, l - entity[0]) : end;

    if (begin > end) {
      this.currentText = '';
      this.characterList = List$4();
    } else {
      this.currentText = this.currentText.slice(begin, end);
      this.characterList = this.characterList.slice(begin, end);
    }
  }
  /**
   * Add the content of an HTML text node to the internal state
   */
  ;

  _proto._addTextNode = function _addTextNode(node, style) {
    var text = node.textContent;
    var trimmedText = text.trim(); // If we are not in a pre block and the trimmed content is empty,
    // normalize to a single space.

    if (trimmedText === '' && this.wrapper !== 'pre') {
      text = ' ';
    }

    if (this.wrapper !== 'pre') {
      // Trim leading line feed, which is invisible in HTML
      text = text.replace(REGEX_LEADING_LF, ''); // Can't use empty string because MSWord

      text = text.replace(REGEX_LF, SPACE$1);
    }

    this._appendText(text, style);
  };

  _proto._addBreakNode = function _addBreakNode(node, style) {
    if (!isHTMLBRElement(node)) {
      return;
    }

    this._appendText('\n', style);
  }
  /**
   * Add the content of an HTML img node to the internal state
   */
  ;

  _proto._addImgNode = function _addImgNode(node, style) {
    if (!isHTMLImageElement(node)) {
      return;
    }

    var image = node;
    var entityConfig = {};
    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);

      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    }); // TODO: T15530363 update this when we remove DraftEntity entirely

    this.currentEntity = this.entityMap.__create('IMAGE', 'IMMUTABLE', entityConfig); // The child text node cannot just have a space or return as content (since
    // we strip those out), unless the image is for presentation only.
    // See https://github.com/facebook/draft-js/issues/231 for some context.

    if (gkx$3('draftjs_fix_paste_for_img')) {
      if (image.getAttribute('role') !== 'presentation') {
        this._appendText("\uD83D\uDCF7", style);
      }
    } else {
      this._appendText("\uD83D\uDCF7", style);
    }

    this.currentEntity = null;
  }
  /**
   * Add the content of an HTML 'a' node to the internal state. Child nodes
   * (if any) are converted to Block Configs and appended to the provided
   * blockConfig array.
   */
  ;

  _proto._addAnchorNode = function _addAnchorNode(node, blockConfigs, style) {
    // The check has already been made by isValidAnchor but
    // we have to do it again to keep flow happy.
    if (!isHTMLAnchorElement(node)) {
      return;
    }

    var anchor = node;
    var entityConfig = {};
    anchorAttr.forEach(function (attr) {
      var anchorAttribute = anchor.getAttribute(attr);

      if (anchorAttribute) {
        entityConfig[attr] = anchorAttribute;
      }
    });
    entityConfig.url = new URI(anchor.href).toString(); // TODO: T15530363 update this when we remove DraftEntity completely

    this.currentEntity = this.entityMap.__create('LINK', 'MUTABLE', entityConfig || {});
    blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
    this.currentEntity = null;
  }
  /**
   * Walk the BlockConfig tree, compute parent/children/siblings,
   * and generate the corresponding ContentBlockNode
   */
  ;

  _proto._toContentBlocks = function _toContentBlocks(blockConfigs) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var l = blockConfigs.length - 1;

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      config.parent = parent;
      config.prevSibling = i > 0 ? blockConfigs[i - 1].key : null;
      config.nextSibling = i < l ? blockConfigs[i + 1].key : null;
      config.children = List$4(config.childConfigs.map(function (child) {
        return child.key;
      }));
      this.contentBlocks.push(new ContentBlockNode$3(_objectSpread$5({}, config)));

      this._toContentBlocks(config.childConfigs, config.key);
    }
  }
  /**
   * Remove 'useless' container nodes from the block config hierarchy, by
   * replacing them with their children.
   */
  ;

  _proto._hoistContainersInBlockConfigs = function _hoistContainersInBlockConfigs(blockConfigs) {
    var _this = this;

    var hoisted = List$4(blockConfigs).flatMap(function (blockConfig) {
      // Don't mess with useful blocks
      if (blockConfig.type !== 'unstyled' || blockConfig.text !== '') {
        return [blockConfig];
      }

      return _this._hoistContainersInBlockConfigs(blockConfig.childConfigs);
    });
    return hoisted;
  } // ***********************************************************************
  // The two methods below are used for backward compatibility when
  // experimentalTreeDataSupport is disabled.

  /**
   * Same as _toContentBlocks but replaces nested blocks by their
   * text content.
   */
  ;

  _proto._toFlatContentBlocks = function _toFlatContentBlocks(blockConfigs) {
    var _this2 = this;

    var cleanConfigs = this._hoistContainersInBlockConfigs(blockConfigs);

    cleanConfigs.forEach(function (config) {
      var _this2$_extractTextFr = _this2._extractTextFromBlockConfigs(config.childConfigs),
          text = _this2$_extractTextFr.text,
          characterList = _this2$_extractTextFr.characterList;

      _this2.contentBlocks.push(new ContentBlock$4(_objectSpread$5({}, config, {
        text: config.text + text,
        characterList: config.characterList.concat(characterList)
      })));
    });
  }
  /**
   * Extract the text and the associated inline styles form an
   * array of content block configs.
   */
  ;

  _proto._extractTextFromBlockConfigs = function _extractTextFromBlockConfigs(blockConfigs) {
    var l = blockConfigs.length - 1;
    var text = '';
    var characterList = List$4();

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      text += config.text;
      characterList = characterList.concat(config.characterList);

      if (text !== '' && config.type !== 'unstyled') {
        text += '\n';
        characterList = characterList.push(characterList.last());
      }

      var children = this._extractTextFromBlockConfigs(config.childConfigs);

      text += children.text;
      characterList = characterList.concat(children.characterList);
    }

    return {
      text: text,
      characterList: characterList
    };
  };

  return ContentBlocksBuilder;
}();
/**
 * Converts an HTML string to an array of ContentBlocks and an EntityMap
 * suitable to initialize the internal state of a Draftjs component.
 */


var convertFromHTMLToContentBlocks$1 = function convertFromHTMLToContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML$1;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap$2;
  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  // Remove funky characters from the HTML string
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE$1).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, ''); // Build a DOM tree out of the HTML string

  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Build a BlockTypeMap out of the BlockRenderMap


  var blockTypeMap = buildBlockTypeMap(blockRenderMap); // Select the proper block type for the cases where the blockRenderMap
  // uses multiple block types for the same html tag.

  var disambiguate = function disambiguate(tag, wrapper) {
    if (tag === 'li') {
      return wrapper === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
    }

    return null;
  };

  return new ContentBlocksBuilder(blockTypeMap, disambiguate).addDOMNode(safeBody).getContentBlocks();
};

var convertFromHTMLToContentBlocks_1 = convertFromHTMLToContentBlocks$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock$3 = ContentBlock_1;

var ContentBlockNode$2 = ContentBlockNode_1;

var convertFromHTMLToContentBlocks = convertFromHTMLToContentBlocks_1;

var generateRandomKey$4 = generateRandomKey_1;

var getSafeBodyFromHTML = getSafeBodyFromHTML_1;

var gkx$2 = gkx$8;

var Immutable$2 = immutable.exports;

var sanitizeDraftText = sanitizeDraftText_1;

var List$3 = Immutable$2.List,
    Repeat = Immutable$2.Repeat;
var experimentalTreeDataSupport$1 = gkx$2('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport$1 ? ContentBlockNode$2 : ContentBlock$3;
var DraftPasteProcessor$1 = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey$4();
      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List$3(Repeat(character, textLine.length))
      }; // next block updates previous block

      if (experimentalTreeDataSupport$1 && index !== 0) {
        var prevSiblingIndex = index - 1; // update previous block

        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _objectSpread$4({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));
      return acc;
    }, []);
  }
};
var DraftPasteProcessor_1 = DraftPasteProcessor$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function adjustBlockDepthForContentState$1(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });
  blockMap = blockMap.merge(blocks);
  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var adjustBlockDepthForContentState_1 = adjustBlockDepthForContentState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftModifier$2 = DraftModifier_1;

var EditorState$3 = EditorState_1;

var adjustBlockDepthForContentState = adjustBlockDepthForContentState_1;

var nullthrows$1 = nullthrows_1;

var RichTextEditorUtil$2 = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },
  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return {
      url: uri.toString()
    };
  },
  handleKeyCommand: function handleKeyCommand(editorState, command, eventTimeStamp) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil$2.toggleInlineStyle(editorState, 'BOLD');

      case 'italic':
        return RichTextEditorUtil$2.toggleInlineStyle(editorState, 'ITALIC');

      case 'underline':
        return RichTextEditorUtil$2.toggleInlineStyle(editorState, 'UNDERLINE');

      case 'code':
        return RichTextEditorUtil$2.toggleCode(editorState);

      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil$2.onBackspace(editorState);

      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil$2.onDelete(editorState);

      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },
  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier$2.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
    var newEditorState = EditorState$3.push(editorState, contentState, 'insert-characters');
    return EditorState$3.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    } // First, try to remove a preceding atomic block.


    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()["delete"](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });

      if (withoutAtomicBlock !== content) {
        return EditorState$3.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    } // If that doesn't succeed, try to remove the current block style.


    var withoutBlockStyle = RichTextEditorUtil$2.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState$3.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },
  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.

    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });
    var withoutAtomicBlock = DraftModifier$2.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState$3.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },
  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();

    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();

    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();
    var depth = block.getDepth();

    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
    return EditorState$3.push(editorState, withAdjustment, 'adjust-depth');
  },
  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.

    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows$1(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
    return EditorState$3.push(editorState, DraftModifier$2.setBlockType(content, target, typeToSet), 'change-block-type');
  },
  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil$2.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil$2.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.

    if (selection.isCollapsed()) {
      return EditorState$3.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    } // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.


    var content = editorState.getCurrentContent();
    var newContent; // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.

    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier$2.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier$2.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState$3.push(editorState, newContent, 'change-inline-style');
  },
  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier$2.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
    return EditorState$3.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of a styled block, changes block
   * type to 'unstyled'. Returns null if selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();

    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);
      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);

      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier$2.setBlockType(content, selection, 'unstyled');
      }
    }

    return null;
  }
};
var RichTextEditorUtil_1 = RichTextEditorUtil$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks$1(text) {
  return text.split(NEWLINE_REGEX);
}

var splitTextIntoTextBlocks_1 = splitTextIntoTextBlocks$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var BlockMapBuilder$1 = BlockMapBuilder_1;

var CharacterMetadata$2 = CharacterMetadata_1;

var DataTransfer = DataTransfer_1;

var DraftModifier$1 = DraftModifier_1;

var DraftPasteProcessor = DraftPasteProcessor_1;

var EditorState$2 = EditorState_1;

var RichTextEditorUtil$1 = RichTextEditorUtil_1;

var getEntityKeyForSelection = getEntityKeyForSelection_1;

var getTextContentFromFiles = getTextContentFromFiles_1;

var isEventHandled = isEventHandled_1;

var splitTextIntoTextBlocks = splitTextIntoTextBlocks_1;
/**
 * Paste content.
 */


function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.

  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();

    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (
      /*string*/
      fileText) {
        fileText = fileText || defaultFileText;

        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata$2.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil$1.getCurrentBlockType(editorState);
        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder$1.createFromArray(text);
        var withInsertedText = DraftModifier$1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
        editor.update(EditorState$2.push(editorState, withInsertedText, 'insert-fragment'));
      });
      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.formatPastedText) {
    var _editor$props$formatP = editor.props.formatPastedText(text, html),
        formattedText = _editor$props$formatP.text,
        formattedHtml = _editor$props$formatP.html;

    text = formattedText;
    html = formattedHtml;
  }

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();

    if (!editor.props.formatPastedText && data.isRichText() && internalClipboard) {
      var _html;

      if ( // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      ((_html = html) === null || _html === void 0 ? void 0 : _html.indexOf(editor.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    } // If there is html paste data, try to parse that.


    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);

      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder$1.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    } // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.


    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata$2.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });
    var currentBlockType = RichTextEditorUtil$1.getCurrentBlockType(editorState);
    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
    var textMap = BlockMapBuilder$1.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier$1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState$2.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

var editOnPaste_1 = editOnPaste;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UserAgent$2 = UserAgent_1;

var onBeforeInput = editOnBeforeInput_1;

var onBlur = editOnBlur_1;

var onCompositionStart = editOnCompositionStart_1;

var onCopy = editOnCopy_1;

var onCut = editOnCut_1;

var onDragOver = editOnDragOver_1;

var onDragStart$1 = editOnDragStart_1;

var onFocus = editOnFocus_1;

var onInput = editOnInput_1;

var onKeyDown = editOnKeyDown_1;

var onPaste = editOnPaste_1;

var onSelect = editOnSelect_1;

var isChrome = UserAgent$2.isBrowser('Chrome');
var isFirefox = UserAgent$2.isBrowser('Firefox');
var selectionHandler = isChrome || isFirefox ? onSelect : function (e) {};
var DraftEditorEditHandler$1 = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart$1,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect,
  // In certain cases, contenteditable on chrome does not fire the onSelect
  // event, causing problems with cursor positioning. Therefore, the selection
  // state update handler is added to more events to ensure that the selection
  // state is always synced with the actual cursor positions.
  onMouseUp: selectionHandler,
  onKeyUp: selectionHandler
};
var DraftEditorEditHandler_1 = DraftEditorEditHandler$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var ReactDOMComet = ReactDOM__default;

var flushControlled$1 = ReactDOMComet.unstable_flushControlled;
var DraftEditorFlushControlled = flushControlled$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _inheritsLoose$2(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var React$2 = React__default;

var cx$1 = cx_1;

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorPlaceholder.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  _proto.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();
    var className = cx$1({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });
    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };
    return React$2.createElement("div", {
      className: className
    }, React$2.createElement("div", {
      className: cx$1('public/DraftEditorPlaceholder/inner'),
      id: this.props.accessibilityID,
      style: contentStyle
    }, this.props.text));
  };

  return DraftEditorPlaceholder;
}(React$2.Component);

var DraftEditorPlaceholder_react = DraftEditorPlaceholder$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var KeyBindingUtil$1 = KeyBindingUtil_1;

var Keys = Keys$4;

var UserAgent$1 = UserAgent_1;

var isOSX = UserAgent$1.isPlatform('Mac OS X'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.

var shouldFixFirefoxMovement = isOSX && UserAgent$1.isBrowser('Firefox < 29');
var hasCommandModifier = KeyBindingUtil$1.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil$1.isCtrlKeyCommand;

function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}
/**
 * Get the appropriate undo/redo command for a Z key command.
 */


function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }

  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for PCs on Shift + Delete.
  if (!isOSX && e.shiftKey) {
    return null;
  }

  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }

  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}
/**
 * Retrieve a bound key command for the given event.
 */


function getDefaultKeyBinding$2(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;

    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;

    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;

    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;

    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;

    case 75:
      // K
      return isOSX && isCtrlKeyCommand(e) ? 'secondary-cut' : null;

    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;

    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;

    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;

    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isOSX ? 'secondary-paste' : 'redo';
      }

      return null;

    case 90:
      // Z
      return getZCommand(e) || null;

    case Keys.RETURN:
      return 'split-block';

    case Keys.DELETE:
      return getDeleteCommand(e);

    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.

    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;

    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;

    default:
      return null;
  }
}

var getDefaultKeyBinding_1 = getDefaultKeyBinding$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @preventMunge
 * @emails oncall+draft_js
 */

var _assign = objectAssign;

function _extends$7() { _extends$7 = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } return target; }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap$1 = DefaultDraftBlockRenderMap_1;

var DefaultDraftInlineStyle$1 = DefaultDraftInlineStyle$2;

var DraftEditorCompositionHandler = DraftEditorCompositionHandler_1;

var DraftEditorContents = DraftEditorContents_react;

var DraftEditorDragHandler = DraftEditorDragHandler_1;

var DraftEditorEditHandler = DraftEditorEditHandler_1;

var flushControlled = DraftEditorFlushControlled;

var DraftEditorPlaceholder = DraftEditorPlaceholder_react;

var EditorState$1 = EditorState_1;

var React$1 = React__default;

var Scroll = Scroll_1;

var Style = Style_1;

var UserAgent = UserAgent_1;

var cx = cx_1;

var generateRandomKey$3 = generateRandomKey_1;

var getDefaultKeyBinding$1 = getDefaultKeyBinding_1;

var getScrollPosition = getScrollPosition_1;

var gkx$1 = gkx$8;

var invariant$5 = invariant_1;

var isHTMLElement = isHTMLElement_1;

var nullthrows = nullthrows_1;

var isIE = UserAgent.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.

var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.

var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};
var didInitODS = false;

var UpdateDraftEditorFlags = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(UpdateDraftEditorFlags, _React$Component);

  function UpdateDraftEditorFlags() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = UpdateDraftEditorFlags.prototype;

  _proto.render = function render() {
    return null;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._update();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._update();
  };

  _proto._update = function _update() {
    var editor = this.props.editor;
    /**
     * Sometimes a render triggers a 'focus' or other event, and that will
     * schedule a second render pass.
     * In order to make sure the second render pass gets the latest editor
     * state, we update it here.
     * Example:
     * render #1
     * +
     * |
     * | cWU -> Nothing ... latestEditorState = STALE_STATE :(
     * |
     * | render -> this.props.editorState = FRESH_STATE
     * | +         *and* set latestEditorState = FRESH_STATE
     *   |
     * | |
     * | +--> triggers 'focus' event, calling 'handleFocus' with latestEditorState
     * |                                                +
     * |                                                |
     * +>cdU -> latestEditorState = FRESH_STATE         | the 'handleFocus' call schedules render #2
     *                                                  | with latestEditorState, which is FRESH_STATE
     *                                                  |
     * render #2 <--------------------------------------+
     * +
     * |
     * | cwU -> nothing updates
     * |
     * | render -> this.props.editorState = FRESH_STATE which was passed in above
     * |
     * +>cdU fires and resets latestEditorState = FRESH_STATE
     * ---
     * Note that if we don't set latestEditorState in 'render' in the above
     * diagram, then STALE_STATE gets passed to render #2.
     */

    editor._latestEditorState = this.props.editorState;
    /**
     * The reason we set this 'blockSelectEvents' flag is that  IE will fire a
     * 'selectionChange' event when we programmatically change the selection,
     * meaning it would trigger a new select event while we are in the middle
     * of updating.
     * We found that the 'selection.addRange' was what triggered the stray
     * selectionchange event in IE.
     * To be clear - we have not been able to reproduce specific bugs related
     * to this stray selection event, but have recorded logs that some
     * conditions do cause it to get bumped into during editOnSelect.
     */

    editor._blockSelectEvents = true;
  };

  return UpdateDraftEditorFlags;
}(React$1.Component);
/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */


var DraftEditor$1 = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose$1(DraftEditor, _React$Component2);

  /**
   * Define proxies that can route events to the current handler.
   */
  function DraftEditor(props) {
    var _this;

    _this = _React$Component2.call(this, props) || this;

    _defineProperty$4(_assertThisInitialized$1(_this), "_blockSelectEvents", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_clipboard", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_handler", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_dragCount", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_internalDrag", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_editorKey", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_placeholderAccessibilityID", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_latestEditorState", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_latestCommittedEditorState", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_pendingStateFromBeforeInput", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onBeforeInput", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onBlur", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onCharacterData", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onCompositionEnd", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onCompositionStart", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onCopy", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onCut", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onDragEnd", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onDragOver", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onDragStart", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onDrop", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onInput", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onFocus", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onKeyDown", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onKeyPress", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onKeyUp", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onMouseDown", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onMouseUp", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onPaste", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_onSelect", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "editor", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "editorContainer", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "focus", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "blur", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "setMode", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "exitCurrentMode", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "restoreEditorDOM", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "setClipboard", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "getClipboard", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "getEditorKey", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "update", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "onDragEnter", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "onDragLeave", void 0);

    _defineProperty$4(_assertThisInitialized$1(_this), "_handleEditorContainerRef", function (node) {
      _this.editorContainer = node; // Instead of having a direct ref on the child, we'll grab it here.
      // This is safe as long as the rendered structure is static (which it is).
      // This lets the child support ref={props.editorRef} without merging refs.

      _this.editor = node !== null ? node.firstChild : null;
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "focus", function (scrollPosition) {
      var editorState = _this.props.editorState;
      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = _this.editor;

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !isHTMLElement(editorNode) ? process.env.NODE_ENV !== "production" ? invariant$5(false, 'editorNode is not an HTMLElement') : invariant$5(false) : void 0;
      editorNode.focus(); // Restore scroll position

      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      } // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.


      if (!alreadyHasFocus) {
        _this.update(EditorState$1.forceSelection(editorState, editorState.getSelection()));
      }
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "blur", function () {
      var editorNode = _this.editor;

      if (!editorNode) {
        return;
      }

      !isHTMLElement(editorNode) ? process.env.NODE_ENV !== "production" ? invariant$5(false, 'editorNode is not an HTMLElement') : invariant$5(false) : void 0;
      editorNode.blur();
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "setMode", function (mode) {
      var _this$props = _this.props,
          onPaste = _this$props.onPaste,
          onCut = _this$props.onCut,
          onCopy = _this$props.onCopy;

      var editHandler = _objectSpread$3({}, handlerMap.edit);

      if (onPaste) {
        /* $FlowFixMe[incompatible-type] (>=0.117.0 site=www,mobile) This comment
         * suppresses an error found when Flow v0.117 was deployed. To see the
         * error delete this comment and run Flow. */
        editHandler.onPaste = onPaste;
      }

      if (onCut) {
        editHandler.onCut = onCut;
      }

      if (onCopy) {
        editHandler.onCopy = onCopy;
      }

      var handler = _objectSpread$3({}, handlerMap, {
        edit: editHandler
      });

      _this._handler = handler[mode];
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "exitCurrentMode", function () {
      _this.setMode('edit');
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "restoreEditorDOM", function (scrollPosition) {
      _this.setState({
        contentsKey: _this.state.contentsKey + 1
      }, function () {
        _this.focus(scrollPosition);
      });
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "setClipboard", function (clipboard) {
      _this._clipboard = clipboard;
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "getClipboard", function () {
      return _this._clipboard;
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "update", function (editorState) {
      _this._latestEditorState = editorState;

      _this.props.onChange(editorState);
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "onDragEnter", function () {
      _this._dragCount++;
    });

    _defineProperty$4(_assertThisInitialized$1(_this), "onDragLeave", function () {
      _this._dragCount--;

      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    });

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey$3();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;
    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    if (process.env.NODE_ENV !== "production") {
      ['onDownArrow', 'onEscape', 'onLeftArrow', 'onRightArrow', 'onTab', 'onUpArrow'].forEach(function (propName) {
        if (props.hasOwnProperty(propName)) {
          // eslint-disable-next-line no-console
          console.warn("Supplying an `".concat(propName, "` prop to `DraftEditor` has ") + 'been deprecated. If your handler needs access to the keyboard ' + 'event, supply a custom `keyBindingFn` prop that falls back to ' + 'the default one (eg. https://is.gd/wHKQ3W).');
        }
      });
    } // See `restoreEditorDOM()`.


    _this.state = {
      contentsKey: 0
    };
    return _this;
  }
  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  var _proto2 = DraftEditor.prototype;

  _proto2._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    // Wrap event handlers in `flushControlled`. In sync mode, this is
    // effectively a no-op. In async mode, this ensures all updates scheduled
    // inside the handler are flushed before React yields to the browser.
    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];

        if (method) {
          if (flushControlled) {
            flushControlled(function () {
              return method(_this2, e);
            });
          } else {
            method(_this2, e);
          }
        }
      }
    };
  };

  _proto2._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  _proto2._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This comment
       * suppresses an error found when Flow v0.112 was deployed. To see the
       * error delete this comment and run Flow. */

      return React$1.createElement(DraftEditorPlaceholder, placeHolderProps);
    }

    return null;
  }
  /**
   * returns ariaDescribedBy prop with '{{editor_id_placeholder}}' replaced with
   * the DOM id of the placeholder (if it exists)
   * @returns aria-describedby attribute value
   */
  ;

  _proto2._renderARIADescribedBy = function _renderARIADescribedBy() {
    var describedBy = this.props.ariaDescribedBy || '';
    var placeholderID = this._showPlaceholder() ? this._placeholderAccessibilityID : '';
    return describedBy.replace('{{editor_id_placeholder}}', placeholderID) || undefined;
  };

  _proto2.render = function render() {
    var _this$props2 = this.props,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        editorState = _this$props2.editorState,
        preventScroll = _this$props2.preventScroll,
        readOnly = _this$props2.readOnly,
        textAlignment = _this$props2.textAlignment,
        textDirectionality = _this$props2.textDirectionality;
    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });
    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }; // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.

    /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */

    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _objectSpread$3({}, DefaultDraftInlineStyle$1, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      preventScroll: preventScroll,
      textDirectionality: textDirectionality
    };
    return React$1.createElement("div", {
      className: rootClass
    }, this._renderPlaceholder(), React$1.createElement("div", {
      className: cx('DraftEditor/editorContainer'),
      ref: this._handleEditorContainerRef
    }, React$1.createElement("div", {
      "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
      "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
      "aria-controls": readOnly ? null : this.props.ariaControls,
      "aria-describedby": this._renderARIADescribedBy(),
      "aria-expanded": readOnly ? null : ariaExpanded,
      "aria-label": this.props.ariaLabel,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-multiline": this.props.ariaMultiline,
      "aria-owns": readOnly ? null : this.props.ariaOwneeID,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: cx({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !readOnly,
        'public/DraftEditor/content': true
      }),
      contentEditable: !readOnly,
      "data-testid": this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: this.props.editorRef,
      role: readOnly ? null : ariaRole,
      spellCheck: allowSpellCheck && this.props.spellCheck,
      style: contentStyle,
      suppressContentEditableWarning: true,
      tabIndex: this.props.tabIndex
    }, React$1.createElement(UpdateDraftEditorFlags, {
      editor: this,
      editorState: editorState
    }), React$1.createElement(DraftEditorContents, _extends$7({}, editorContentsProps, {
      key: 'contents' + this.state.contentsKey
    })))));
  };

  _proto2.componentDidMount = function componentDidMount() {
    this._blockSelectEvents = false;

    if (!didInitODS && gkx$1('draft_ods_enabled')) {
      didInitODS = true;
    }

    this.setMode('edit');
    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */

    if (isIE) {
      // editor can be null after mounting
      // https://stackoverflow.com/questions/44074747/componentdidmount-called-before-ref-callback
      if (!this.editor) {
        commonjsGlobal.execCommand('AutoUrlDetect', false, false);
      } else {
        this.editor.ownerDocument.execCommand('AutoUrlDetect', false, false);
      }
    }
  };

  _proto2.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestEditorState = this.props.editorState;
    this._latestCommittedEditorState = this.props.editorState;
  }
  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */
  ;

  return DraftEditor;
}(React$1.Component);

_defineProperty$4(DraftEditor$1, "defaultProps", {
  ariaDescribedBy: '{{editor_id_placeholder}}',
  blockRenderMap: DefaultDraftBlockRenderMap$1,
  blockRendererFn: function blockRendererFn() {
    return null;
  },
  blockStyleFn: function blockStyleFn() {
    return '';
  },
  keyBindingFn: getDefaultKeyBinding$1,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
});

var DraftEditor_react = DraftEditor$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var RawDraftContentState$1 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var require$$15 = /*@__PURE__*/getAugmentedNamespace(RawDraftContentState$1);

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftStringKey$2 = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },
  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};
var DraftStringKey_1 = DraftStringKey$2;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var DraftStringKey$1 = DraftStringKey_1;

var UnicodeUtils$3 = UnicodeUtils_1;

var strlen = UnicodeUtils$3.strlen;
/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges$1(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function (
  /*number*/
  start,
  /*number*/
  end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey$1.stringify(key)])
    });
  });
  return encoded;
}

var encodeEntityRanges_1 = encodeEntityRanges$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UnicodeUtils$2 = UnicodeUtils_1;

var findRangesImmutable = findRangesImmutable_1;

var areEqual = function areEqual(a, b) {
  return a === b;
};

var isTruthy = function isTruthy(a) {
  return !!a;
};

var EMPTY_ARRAY$1 = [];
/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */

function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = []; // Obtain an array with ranges for only the specified style.

  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();
  findRangesImmutable(filteredInlines, areEqual, // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils$2.strlen(text.slice(0, start)),
      length: UnicodeUtils$2.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });
  return ranges;
}
/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */


function encodeInlineStyleRanges$1(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });
  return Array.prototype.concat.apply(EMPTY_ARRAY$1, ranges.toJS());
}

var encodeInlineStyleRanges_1 = encodeInlineStyleRanges$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock$2 = ContentBlock_1;

var ContentBlockNode$1 = ContentBlockNode_1;

var DraftStringKey = DraftStringKey_1;

var encodeEntityRanges = encodeEntityRanges_1;

var encodeInlineStyleRanges = encodeInlineStyleRanges_1;

var invariant$4 = invariant_1;

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock$2) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode$1) ? process.env.NODE_ENV !== "production" ? invariant$4(false, 'block is not a BlockNode') : invariant$4(false) : void 0;
  var parentKey = block.getParentKey();

  var rawBlock = blockCacheRef[block.getKey()] = _objectSpread$2({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;
  var rawBlocks = [];
  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;
  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.

      var stringifiedEntityKey = DraftStringKey.stringify(entityKey); // This makes this function resilient to two entities
      // erroneously having the same key

      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }

      entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode

      entityMap[stringifiedEntityKey] = "".concat(entityStorageKey);
      entityStorageKey++;
    });
    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });
  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
}; // Flip storage map so that our storage keys map to global
// DraftEntity keys.


var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;
  var rawEntityMap = {};
  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });
  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw$1 = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  }; // add blocks

  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities

  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
  return rawDraftContentState;
};

var convertFromDraftStateToRaw_1 = convertFromDraftStateToRaw$1;

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var generateRandomKey$2 = generateRandomKey_1;

var invariant$3 = invariant_1;

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();

  while (stack.length) {
    var _block = stack.pop();

    fn(_block);
    var children = _block.children;
    !Array.isArray(children) ? process.env.NODE_ENV !== "production" ? invariant$3(false, 'Invalid tree raw block') : invariant$3(false) : void 0;
    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }

  var type = block.type;
  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _objectSpread$1({}, child, {
        depth: (block.depth || 0) + 1
      }) : child;
    });
  }
};
/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */


var DraftTreeAdapter$1 = {
  /**
   * Converts from a tree raw state back to draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;
    var transformedBlocks = [];
    !Array.isArray(blocks) ? process.env.NODE_ENV !== "production" ? invariant$3(false, 'Invalid raw state') : invariant$3(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _objectSpread$1({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block); // if it's a non-leaf node, we don't do anything else

        if (block.children != null && block.children.length > 0) {
          return;
        }
      }

      delete newBlock.children;
      transformedBlocks.push(newBlock);
    });
    draftTreeState.blocks = transformedBlocks;
    return _objectSpread$1({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },

  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var transformedBlocks = [];
    var parentStack = [];
    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;

      var treeBlock = _objectSpread$1({}, block, {
        children: []
      });

      if (!isList) {
        transformedBlocks.push(treeBlock);
        return;
      }

      var lastParent = parentStack[0]; // block is non-nested & there are no nested blocks, directly push block

      if (lastParent == null && depth === 0) {
        transformedBlocks.push(treeBlock); // block is first nested block or previous nested block is at a lower level
      } else if (lastParent == null || lastParent.depth < depth - 1) {
        // create new parent block
        var newParent = {
          key: generateRandomKey$2(),
          text: '',
          depth: depth - 1,
          type: block.type,
          children: [],
          entityRanges: [],
          inlineStyleRanges: []
        };
        parentStack.unshift(newParent);

        if (depth === 1) {
          // add as a root-level block
          transformedBlocks.push(newParent);
        } else if (lastParent != null) {
          // depth > 1 => also add as previous parent's child
          lastParent.children.push(newParent);
        }

        newParent.children.push(treeBlock);
      } else if (lastParent.depth === depth - 1) {
        // add as child of last parent
        lastParent.children.push(treeBlock);
      } else {
        // pop out parents at levels above this one from the parent stack
        while (lastParent != null && lastParent.depth >= depth) {
          parentStack.shift();
          lastParent = parentStack[0];
        }

        if (depth > 0) {
          lastParent.children.push(treeBlock);
        } else {
          transformedBlocks.push(treeBlock);
        }
      }
    });
    return _objectSpread$1({}, draftState, {
      blocks: transformedBlocks
    });
  }
};
var DraftTreeAdapter_1 = DraftTreeAdapter$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var warning$5 = warning_1;

var DraftTreeInvariants$1 = {
  /**
   * Check if the block is valid
   */
  isValidBlock: function isValidBlock(block, blockMap) {
    var key = block.getKey(); // is its parent's child

    var parentKey = block.getParentKey();

    if (parentKey != null) {
      var parent = blockMap.get(parentKey);

      if (!parent.getChildKeys().includes(key)) {
        process.env.NODE_ENV !== "production" ? warning$5(true, 'Tree is missing parent -> child pointer on %s', key) : void 0;
        return false;
      }
    } // is its children's parent


    var children = block.getChildKeys().map(function (k) {
      return blockMap.get(k);
    });

    if (!children.every(function (c) {
      return c.getParentKey() === key;
    })) {
      process.env.NODE_ENV !== "production" ? warning$5(true, 'Tree is missing child -> parent pointer on %s', key) : void 0;
      return false;
    } // is its previous sibling's next sibling


    var prevSiblingKey = block.getPrevSiblingKey();

    if (prevSiblingKey != null) {
      var prevSibling = blockMap.get(prevSiblingKey);

      if (prevSibling.getNextSiblingKey() !== key) {
        process.env.NODE_ENV !== "production" ? warning$5(true, "Tree is missing nextSibling pointer on %s's prevSibling", key) : void 0;
        return false;
      }
    } // is its next sibling's previous sibling


    var nextSiblingKey = block.getNextSiblingKey();

    if (nextSiblingKey != null) {
      var nextSibling = blockMap.get(nextSiblingKey);

      if (nextSibling.getPrevSiblingKey() !== key) {
        process.env.NODE_ENV !== "production" ? warning$5(true, "Tree is missing prevSibling pointer on %s's nextSibling", key) : void 0;
        return false;
      }
    } // no 2-node cycles


    if (nextSiblingKey !== null && prevSiblingKey !== null) {
      if (prevSiblingKey === nextSiblingKey) {
        process.env.NODE_ENV !== "production" ? warning$5(true, 'Tree has a two-node cycle at %s', key) : void 0;
        return false;
      }
    } // if it's a leaf node, it has text but no children


    if (block.text != '') {
      if (block.getChildKeys().size > 0) {
        process.env.NODE_ENV !== "production" ? warning$5(true, 'Leaf node %s has children', key) : void 0;
        return false;
      }
    }

    return true;
  },

  /**
   * Checks that this is a connected tree on all the blocks
   * starting from the first block, traversing nextSibling and child pointers
   * should be a tree (preorder traversal - parent, then children)
   * num of connected node === number of blocks
   */
  isConnectedTree: function isConnectedTree(blockMap) {
    // exactly one node has no previous sibling + no parent
    var eligibleFirstNodes = blockMap.toArray().filter(function (block) {
      return block.getParentKey() == null && block.getPrevSiblingKey() == null;
    });

    if (eligibleFirstNodes.length !== 1) {
      process.env.NODE_ENV !== "production" ? warning$5(true, 'Tree is not connected. More or less than one first node') : void 0;
      return false;
    }

    var firstNode = eligibleFirstNodes.shift();
    var nodesSeen = 0;
    var currentKey = firstNode.getKey();
    var visitedStack = [];

    while (currentKey != null) {
      var currentNode = blockMap.get(currentKey);
      var childKeys = currentNode.getChildKeys();
      var nextSiblingKey = currentNode.getNextSiblingKey(); // if the node has children, add parent's next sibling to stack and go to children

      if (childKeys.size > 0) {
        if (nextSiblingKey != null) {
          visitedStack.unshift(nextSiblingKey);
        }

        var children = childKeys.map(function (k) {
          return blockMap.get(k);
        });

        var _firstNode = children.find(function (block) {
          return block.getPrevSiblingKey() == null;
        });

        if (_firstNode == null) {
          process.env.NODE_ENV !== "production" ? warning$5(true, '%s has no first child', currentKey) : void 0;
          return false;
        }

        currentKey = _firstNode.getKey(); // TODO(T32490138): Deal with multi-node cycles here
      } else {
        if (currentNode.getNextSiblingKey() != null) {
          currentKey = currentNode.getNextSiblingKey();
        } else {
          currentKey = visitedStack.shift();
        }
      }

      nodesSeen++;
    }

    if (nodesSeen !== blockMap.size) {
      process.env.NODE_ENV !== "production" ? warning$5(true, 'Tree is not connected. %s nodes were seen instead of %s', nodesSeen, blockMap.size) : void 0;
      return false;
    }

    return true;
  },

  /**
   * Checks that the block map is a connected tree with valid blocks
   */
  isValidTree: function isValidTree(blockMap) {
    var _this = this;

    var blocks = blockMap.toArray();

    if (!blocks.every(function (block) {
      return _this.isValidBlock(block, blockMap);
    })) {
      return false;
    }

    return this.isConnectedTree(blockMap);
  }
};
var DraftTreeInvariants_1 = DraftTreeInvariants$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var CharacterMetadata$1 = CharacterMetadata_1;

var Immutable$1 = immutable.exports;

var List$2 = Immutable$1.List;

function createCharacterList$1(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata$1.create({
      style: style,
      entity: entity
    });
  });
  return List$2(characterArray);
}

var createCharacterList_1 = createCharacterList$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UnicodeUtils$1 = UnicodeUtils_1;

var substr$1 = UnicodeUtils$1.substr;
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges$1(text, ranges) {
  var entities = Array(text.length).fill(null);

  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr$1(text, 0, range.offset).length;
      var end = start + substr$1(text, range.offset, range.length).length;

      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }

  return entities;
}

var decodeEntityRanges_1 = decodeEntityRanges$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var UnicodeUtils = UnicodeUtils_1;

var _require = immutable.exports,
    OrderedSet = _require.OrderedSet;

var substr = UnicodeUtils.substr;
var EMPTY_SET = OrderedSet();
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeInlineStyleRanges$1(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);

  if (ranges) {
    ranges.forEach(function (range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;

      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }

  return styles;
}

var decodeInlineStyleRanges_1 = decodeInlineStyleRanges$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock$1 = ContentBlock_1;

var ContentBlockNode = ContentBlockNode_1;

var ContentState$1 = ContentState_1;

var DraftEntity$1 = DraftEntity_1;

var DraftTreeAdapter = DraftTreeAdapter_1;

var DraftTreeInvariants = DraftTreeInvariants_1;

var SelectionState$1 = SelectionState_1;

var createCharacterList = createCharacterList_1;

var decodeEntityRanges = decodeEntityRanges_1;

var decodeInlineStyleRanges = decodeInlineStyleRanges_1;

var generateRandomKey$1 = generateRandomKey_1;

var gkx = gkx$8;

var Immutable = immutable.exports;

var invariant$2 = invariant_1;

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var List$1 = Immutable.List,
    Map$1 = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;

var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;
  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey$1(),
    data: Map$1(data),
    characterList: decodeCharacterList(block, entityMap)
  };
  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;
  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.

  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _objectSpread({}, range, {
      key: entityMap[range.key]
    });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _objectSpread({}, block, {
    key: block.key || generateRandomKey$1()
  });
};
/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */


var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _objectSpread({}, block, {
      parentRef: parentRef
    });
  }); // since we pop nodes from the stack we need to insert them in reverse

  return stack.concat(nodesWithParentRef.reverse());
};
/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */


var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant$2(false) : void 0; // ensure children have valid keys to enable sibling links

    var children = block.children.map(addKeyIfMissing); // root level nodes

    var contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List$1(children.map(function (child) {
        return child.key;
      }))
    })); // push root node to blockMap

    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

    var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes

    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop(); // parentRef already points to a converted ContentBlockNode

      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();

      var _index = siblings.indexOf(node.key);

      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant$2(false) : void 0;
        break;
      } // ensure children have valid keys to enable sibling links


      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List$1(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      })); // push node to blockMap


      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock$1(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = rawState.blocks.find(function (block) {
    return Array.isArray(block.children) && block.children.length > 0;
  });
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  var blockMap = decodeContentBlockNodes(rawBlocks, entityMap); // in dev mode, check that the tree invariants are met

  if (process.env.NODE_ENV !== "production") {
    !DraftTreeInvariants.isValidTree(blockMap) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Should be a valid tree') : invariant$2(false) : void 0;
  }

  return blockMap;
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;
  var entityMap = {}; // TODO: Update this once we completely remove DraftEntity

  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data; // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity$1.__create(type, mutability, data || {});
  });
  return entityMap;
};

var convertFromRawToDraftState$1 = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'invalid RawDraftContentState') : invariant$2(false) : void 0; // decode entities

  var entityMap = decodeRawEntityMap(rawState); // decode blockMap

  var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection

  var selectionState = blockMap.isEmpty() ? new SelectionState$1() : SelectionState$1.createEmpty(blockMap.first().getKey());
  return new ContentState$1({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

var convertFromRawToDraftState_1 = convertFromRawToDraftState$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var getRangeClientRects = getRangeClientRects_1;

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect$1(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];

      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

var getRangeBoundingClientRect_1 = getRangeBoundingClientRect$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

var getRangeBoundingClientRect = getRangeBoundingClientRect_1;
/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 *
 * When using from an iframe, you should pass the iframe window object
 */


function getVisibleSelectionRect$1(global) {
  var selection = global.getSelection();

  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

var getVisibleSelectionRect_1 = getVisibleSelectionRect$1;

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */

var AtomicBlockUtils = AtomicBlockUtils_1;

var BlockMapBuilder = BlockMapBuilder_1;

var CharacterMetadata = CharacterMetadata_1;

var CompositeDraftDecorator = CompositeDraftDecorator_1;

var ContentBlock = ContentBlock_1;

var ContentState = ContentState_1;

var DefaultDraftBlockRenderMap = DefaultDraftBlockRenderMap_1;

var DefaultDraftInlineStyle = DefaultDraftInlineStyle$2;

var DraftEditor = DraftEditor_react;

var DraftEditorBlock = DraftEditorBlock_react;

var DraftEntity = DraftEntity_1;

var DraftModifier = DraftModifier_1;

var DraftEntityInstance = DraftEntityInstance_1;

var EditorState = EditorState_1;

var KeyBindingUtil = KeyBindingUtil_1;

var RawDraftContentState = require$$15;

var RichTextEditorUtil = RichTextEditorUtil_1;

var SelectionState = SelectionState_1;

var convertFromDraftStateToRaw = convertFromDraftStateToRaw_1;

var convertFromRawToDraftState = convertFromRawToDraftState_1;

var generateRandomKey = generateRandomKey_1;

var getDefaultKeyBinding = getDefaultKeyBinding_1;

var getVisibleSelectionRect = getVisibleSelectionRect_1;

var convertFromHTML = convertFromHTMLToContentBlocks_1;

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,
  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,
  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  RawDraftContentState: RawDraftContentState,
  SelectionState: SelectionState,
  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,
  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
  convertFromHTML: convertFromHTML,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};
var Draft = DraftPublic;

var lib$5 = {};

var Parser$3 = {};

var Tokenizer$1 = {};

var decode_codepoint$1 = {};

var require$$0$4 = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

var __importDefault$7 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(decode_codepoint$1, "__esModule", { value: true });
var decode_json_1$1 = __importDefault$7(require$$0$4);
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var fromCodePoint$1 = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint$1(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1$1.default) {
        codePoint = decode_json_1$1.default[codePoint];
    }
    return fromCodePoint$1(codePoint);
}
decode_codepoint$1.default = decodeCodePoint$1;

var Aacute$3 = "Á";
var aacute$3 = "á";
var Abreve$1 = "Ă";
var abreve$1 = "ă";
var ac$1 = "∾";
var acd$1 = "∿";
var acE$1 = "∾̳";
var Acirc$3 = "Â";
var acirc$3 = "â";
var acute$3 = "´";
var Acy$1 = "А";
var acy$1 = "а";
var AElig$3 = "Æ";
var aelig$3 = "æ";
var af$1 = "⁡";
var Afr$1 = "𝔄";
var afr$1 = "𝔞";
var Agrave$3 = "À";
var agrave$3 = "à";
var alefsym$1 = "ℵ";
var aleph$1 = "ℵ";
var Alpha$1 = "Α";
var alpha$1 = "α";
var Amacr$1 = "Ā";
var amacr$1 = "ā";
var amalg$1 = "⨿";
var amp$5 = "&";
var AMP$3 = "&";
var andand$1 = "⩕";
var And$1 = "⩓";
var and$1 = "∧";
var andd$1 = "⩜";
var andslope$1 = "⩘";
var andv$1 = "⩚";
var ang$1 = "∠";
var ange$1 = "⦤";
var angle$1 = "∠";
var angmsdaa$1 = "⦨";
var angmsdab$1 = "⦩";
var angmsdac$1 = "⦪";
var angmsdad$1 = "⦫";
var angmsdae$1 = "⦬";
var angmsdaf$1 = "⦭";
var angmsdag$1 = "⦮";
var angmsdah$1 = "⦯";
var angmsd$1 = "∡";
var angrt$1 = "∟";
var angrtvb$1 = "⊾";
var angrtvbd$1 = "⦝";
var angsph$1 = "∢";
var angst$1 = "Å";
var angzarr$1 = "⍼";
var Aogon$1 = "Ą";
var aogon$1 = "ą";
var Aopf$1 = "𝔸";
var aopf$1 = "𝕒";
var apacir$1 = "⩯";
var ap$1 = "≈";
var apE$1 = "⩰";
var ape$1 = "≊";
var apid$1 = "≋";
var apos$3 = "'";
var ApplyFunction$1 = "⁡";
var approx$1 = "≈";
var approxeq$1 = "≊";
var Aring$3 = "Å";
var aring$3 = "å";
var Ascr$1 = "𝒜";
var ascr$1 = "𝒶";
var Assign$1 = "≔";
var ast$1 = "*";
var asymp$1 = "≈";
var asympeq$1 = "≍";
var Atilde$3 = "Ã";
var atilde$3 = "ã";
var Auml$3 = "Ä";
var auml$3 = "ä";
var awconint$1 = "∳";
var awint$1 = "⨑";
var backcong$1 = "≌";
var backepsilon$1 = "϶";
var backprime$1 = "‵";
var backsim$1 = "∽";
var backsimeq$1 = "⋍";
var Backslash$1 = "∖";
var Barv$1 = "⫧";
var barvee$1 = "⊽";
var barwed$1 = "⌅";
var Barwed$1 = "⌆";
var barwedge$1 = "⌅";
var bbrk$1 = "⎵";
var bbrktbrk$1 = "⎶";
var bcong$1 = "≌";
var Bcy$1 = "Б";
var bcy$1 = "б";
var bdquo$1 = "„";
var becaus$1 = "∵";
var because$1 = "∵";
var Because$1 = "∵";
var bemptyv$1 = "⦰";
var bepsi$1 = "϶";
var bernou$1 = "ℬ";
var Bernoullis$1 = "ℬ";
var Beta$1 = "Β";
var beta$1 = "β";
var beth$1 = "ℶ";
var between$1 = "≬";
var Bfr$1 = "𝔅";
var bfr$1 = "𝔟";
var bigcap$1 = "⋂";
var bigcirc$1 = "◯";
var bigcup$1 = "⋃";
var bigodot$1 = "⨀";
var bigoplus$1 = "⨁";
var bigotimes$1 = "⨂";
var bigsqcup$1 = "⨆";
var bigstar$1 = "★";
var bigtriangledown$1 = "▽";
var bigtriangleup$1 = "△";
var biguplus$1 = "⨄";
var bigvee$1 = "⋁";
var bigwedge$1 = "⋀";
var bkarow$1 = "⤍";
var blacklozenge$1 = "⧫";
var blacksquare$1 = "▪";
var blacktriangle$1 = "▴";
var blacktriangledown$1 = "▾";
var blacktriangleleft$1 = "◂";
var blacktriangleright$1 = "▸";
var blank$1 = "␣";
var blk12$1 = "▒";
var blk14$1 = "░";
var blk34$1 = "▓";
var block$1 = "█";
var bne$1 = "=⃥";
var bnequiv$1 = "≡⃥";
var bNot$1 = "⫭";
var bnot$1 = "⌐";
var Bopf$1 = "𝔹";
var bopf$1 = "𝕓";
var bot$1 = "⊥";
var bottom$1 = "⊥";
var bowtie$1 = "⋈";
var boxbox$1 = "⧉";
var boxdl$1 = "┐";
var boxdL$1 = "╕";
var boxDl$1 = "╖";
var boxDL$1 = "╗";
var boxdr$1 = "┌";
var boxdR$1 = "╒";
var boxDr$1 = "╓";
var boxDR$1 = "╔";
var boxh$1 = "─";
var boxH$1 = "═";
var boxhd$1 = "┬";
var boxHd$1 = "╤";
var boxhD$1 = "╥";
var boxHD$1 = "╦";
var boxhu$1 = "┴";
var boxHu$1 = "╧";
var boxhU$1 = "╨";
var boxHU$1 = "╩";
var boxminus$1 = "⊟";
var boxplus$1 = "⊞";
var boxtimes$1 = "⊠";
var boxul$1 = "┘";
var boxuL$1 = "╛";
var boxUl$1 = "╜";
var boxUL$1 = "╝";
var boxur$1 = "└";
var boxuR$1 = "╘";
var boxUr$1 = "╙";
var boxUR$1 = "╚";
var boxv$1 = "│";
var boxV$1 = "║";
var boxvh$1 = "┼";
var boxvH$1 = "╪";
var boxVh$1 = "╫";
var boxVH$1 = "╬";
var boxvl$1 = "┤";
var boxvL$1 = "╡";
var boxVl$1 = "╢";
var boxVL$1 = "╣";
var boxvr$1 = "├";
var boxvR$1 = "╞";
var boxVr$1 = "╟";
var boxVR$1 = "╠";
var bprime$1 = "‵";
var breve$1 = "˘";
var Breve$1 = "˘";
var brvbar$3 = "¦";
var bscr$1 = "𝒷";
var Bscr$1 = "ℬ";
var bsemi$1 = "⁏";
var bsim$1 = "∽";
var bsime$1 = "⋍";
var bsolb$1 = "⧅";
var bsol$1 = "\\";
var bsolhsub$1 = "⟈";
var bull$1 = "•";
var bullet$1 = "•";
var bump$1 = "≎";
var bumpE$1 = "⪮";
var bumpe$1 = "≏";
var Bumpeq$1 = "≎";
var bumpeq$1 = "≏";
var Cacute$1 = "Ć";
var cacute$1 = "ć";
var capand$1 = "⩄";
var capbrcup$1 = "⩉";
var capcap$1 = "⩋";
var cap$1 = "∩";
var Cap$1 = "⋒";
var capcup$1 = "⩇";
var capdot$1 = "⩀";
var CapitalDifferentialD$1 = "ⅅ";
var caps$1 = "∩︀";
var caret$1 = "⁁";
var caron$1 = "ˇ";
var Cayleys$1 = "ℭ";
var ccaps$1 = "⩍";
var Ccaron$1 = "Č";
var ccaron$1 = "č";
var Ccedil$3 = "Ç";
var ccedil$3 = "ç";
var Ccirc$1 = "Ĉ";
var ccirc$1 = "ĉ";
var Cconint$1 = "∰";
var ccups$1 = "⩌";
var ccupssm$1 = "⩐";
var Cdot$1 = "Ċ";
var cdot$1 = "ċ";
var cedil$3 = "¸";
var Cedilla$1 = "¸";
var cemptyv$1 = "⦲";
var cent$3 = "¢";
var centerdot$1 = "·";
var CenterDot$1 = "·";
var cfr$1 = "𝔠";
var Cfr$1 = "ℭ";
var CHcy$1 = "Ч";
var chcy$1 = "ч";
var check$1 = "✓";
var checkmark$1 = "✓";
var Chi$1 = "Χ";
var chi$1 = "χ";
var circ$1 = "ˆ";
var circeq$1 = "≗";
var circlearrowleft$1 = "↺";
var circlearrowright$1 = "↻";
var circledast$1 = "⊛";
var circledcirc$1 = "⊚";
var circleddash$1 = "⊝";
var CircleDot$1 = "⊙";
var circledR$1 = "®";
var circledS$1 = "Ⓢ";
var CircleMinus$1 = "⊖";
var CirclePlus$1 = "⊕";
var CircleTimes$1 = "⊗";
var cir$1 = "○";
var cirE$1 = "⧃";
var cire$1 = "≗";
var cirfnint$1 = "⨐";
var cirmid$1 = "⫯";
var cirscir$1 = "⧂";
var ClockwiseContourIntegral$1 = "∲";
var CloseCurlyDoubleQuote$1 = "”";
var CloseCurlyQuote$1 = "’";
var clubs$1 = "♣";
var clubsuit$1 = "♣";
var colon$1 = ":";
var Colon$1 = "∷";
var Colone$1 = "⩴";
var colone$1 = "≔";
var coloneq$1 = "≔";
var comma$1 = ",";
var commat$1 = "@";
var comp$1 = "∁";
var compfn$1 = "∘";
var complement$1 = "∁";
var complexes$1 = "ℂ";
var cong$1 = "≅";
var congdot$1 = "⩭";
var Congruent$1 = "≡";
var conint$1 = "∮";
var Conint$1 = "∯";
var ContourIntegral$1 = "∮";
var copf$1 = "𝕔";
var Copf$1 = "ℂ";
var coprod$1 = "∐";
var Coproduct$1 = "∐";
var copy$4 = "©";
var COPY$3 = "©";
var copysr$1 = "℗";
var CounterClockwiseContourIntegral$1 = "∳";
var crarr$1 = "↵";
var cross$1 = "✗";
var Cross$1 = "⨯";
var Cscr$1 = "𝒞";
var cscr$1 = "𝒸";
var csub$1 = "⫏";
var csube$1 = "⫑";
var csup$1 = "⫐";
var csupe$1 = "⫒";
var ctdot$1 = "⋯";
var cudarrl$1 = "⤸";
var cudarrr$1 = "⤵";
var cuepr$1 = "⋞";
var cuesc$1 = "⋟";
var cularr$1 = "↶";
var cularrp$1 = "⤽";
var cupbrcap$1 = "⩈";
var cupcap$1 = "⩆";
var CupCap$1 = "≍";
var cup$1 = "∪";
var Cup$1 = "⋓";
var cupcup$1 = "⩊";
var cupdot$1 = "⊍";
var cupor$1 = "⩅";
var cups$1 = "∪︀";
var curarr$1 = "↷";
var curarrm$1 = "⤼";
var curlyeqprec$1 = "⋞";
var curlyeqsucc$1 = "⋟";
var curlyvee$1 = "⋎";
var curlywedge$1 = "⋏";
var curren$3 = "¤";
var curvearrowleft$1 = "↶";
var curvearrowright$1 = "↷";
var cuvee$1 = "⋎";
var cuwed$1 = "⋏";
var cwconint$1 = "∲";
var cwint$1 = "∱";
var cylcty$1 = "⌭";
var dagger$1 = "†";
var Dagger$1 = "‡";
var daleth$1 = "ℸ";
var darr$1 = "↓";
var Darr$1 = "↡";
var dArr$1 = "⇓";
var dash$1 = "‐";
var Dashv$1 = "⫤";
var dashv$1 = "⊣";
var dbkarow$1 = "⤏";
var dblac$1 = "˝";
var Dcaron$1 = "Ď";
var dcaron$1 = "ď";
var Dcy$1 = "Д";
var dcy$1 = "д";
var ddagger$1 = "‡";
var ddarr$1 = "⇊";
var DD$1 = "ⅅ";
var dd$1 = "ⅆ";
var DDotrahd$1 = "⤑";
var ddotseq$1 = "⩷";
var deg$3 = "°";
var Del$1 = "∇";
var Delta$1 = "Δ";
var delta$1 = "δ";
var demptyv$1 = "⦱";
var dfisht$1 = "⥿";
var Dfr$1 = "𝔇";
var dfr$1 = "𝔡";
var dHar$1 = "⥥";
var dharl$1 = "⇃";
var dharr$1 = "⇂";
var DiacriticalAcute$1 = "´";
var DiacriticalDot$1 = "˙";
var DiacriticalDoubleAcute$1 = "˝";
var DiacriticalGrave$1 = "`";
var DiacriticalTilde$1 = "˜";
var diam$1 = "⋄";
var diamond$1 = "⋄";
var Diamond$1 = "⋄";
var diamondsuit$1 = "♦";
var diams$1 = "♦";
var die$1 = "¨";
var DifferentialD$1 = "ⅆ";
var digamma$1 = "ϝ";
var disin$1 = "⋲";
var div$2 = "÷";
var divide$3 = "÷";
var divideontimes$1 = "⋇";
var divonx$1 = "⋇";
var DJcy$1 = "Ђ";
var djcy$1 = "ђ";
var dlcorn$1 = "⌞";
var dlcrop$1 = "⌍";
var dollar$1 = "$";
var Dopf$1 = "𝔻";
var dopf$1 = "𝕕";
var Dot$1 = "¨";
var dot$2 = "˙";
var DotDot$1 = "⃜";
var doteq$1 = "≐";
var doteqdot$1 = "≑";
var DotEqual$1 = "≐";
var dotminus$1 = "∸";
var dotplus$1 = "∔";
var dotsquare$1 = "⊡";
var doublebarwedge$1 = "⌆";
var DoubleContourIntegral$1 = "∯";
var DoubleDot$1 = "¨";
var DoubleDownArrow$1 = "⇓";
var DoubleLeftArrow$1 = "⇐";
var DoubleLeftRightArrow$1 = "⇔";
var DoubleLeftTee$1 = "⫤";
var DoubleLongLeftArrow$1 = "⟸";
var DoubleLongLeftRightArrow$1 = "⟺";
var DoubleLongRightArrow$1 = "⟹";
var DoubleRightArrow$1 = "⇒";
var DoubleRightTee$1 = "⊨";
var DoubleUpArrow$1 = "⇑";
var DoubleUpDownArrow$1 = "⇕";
var DoubleVerticalBar$1 = "∥";
var DownArrowBar$1 = "⤓";
var downarrow$1 = "↓";
var DownArrow$1 = "↓";
var Downarrow$1 = "⇓";
var DownArrowUpArrow$1 = "⇵";
var DownBreve$1 = "̑";
var downdownarrows$1 = "⇊";
var downharpoonleft$1 = "⇃";
var downharpoonright$1 = "⇂";
var DownLeftRightVector$1 = "⥐";
var DownLeftTeeVector$1 = "⥞";
var DownLeftVectorBar$1 = "⥖";
var DownLeftVector$1 = "↽";
var DownRightTeeVector$1 = "⥟";
var DownRightVectorBar$1 = "⥗";
var DownRightVector$1 = "⇁";
var DownTeeArrow$1 = "↧";
var DownTee$1 = "⊤";
var drbkarow$1 = "⤐";
var drcorn$1 = "⌟";
var drcrop$1 = "⌌";
var Dscr$1 = "𝒟";
var dscr$1 = "𝒹";
var DScy$1 = "Ѕ";
var dscy$1 = "ѕ";
var dsol$1 = "⧶";
var Dstrok$1 = "Đ";
var dstrok$1 = "đ";
var dtdot$1 = "⋱";
var dtri$1 = "▿";
var dtrif$1 = "▾";
var duarr$1 = "⇵";
var duhar$1 = "⥯";
var dwangle$1 = "⦦";
var DZcy$1 = "Џ";
var dzcy$1 = "џ";
var dzigrarr$1 = "⟿";
var Eacute$3 = "É";
var eacute$3 = "é";
var easter$1 = "⩮";
var Ecaron$1 = "Ě";
var ecaron$1 = "ě";
var Ecirc$3 = "Ê";
var ecirc$3 = "ê";
var ecir$1 = "≖";
var ecolon$1 = "≕";
var Ecy$1 = "Э";
var ecy$1 = "э";
var eDDot$1 = "⩷";
var Edot$1 = "Ė";
var edot$1 = "ė";
var eDot$1 = "≑";
var ee$1 = "ⅇ";
var efDot$1 = "≒";
var Efr$1 = "𝔈";
var efr$1 = "𝔢";
var eg$1 = "⪚";
var Egrave$3 = "È";
var egrave$3 = "è";
var egs$1 = "⪖";
var egsdot$1 = "⪘";
var el$1 = "⪙";
var Element$6 = "∈";
var elinters$1 = "⏧";
var ell$1 = "ℓ";
var els$1 = "⪕";
var elsdot$1 = "⪗";
var Emacr$1 = "Ē";
var emacr$1 = "ē";
var empty$3 = "∅";
var emptyset$1 = "∅";
var EmptySmallSquare$1 = "◻";
var emptyv$1 = "∅";
var EmptyVerySmallSquare$1 = "▫";
var emsp13$1 = " ";
var emsp14$1 = " ";
var emsp$1 = " ";
var ENG$1 = "Ŋ";
var eng$1 = "ŋ";
var ensp$1 = " ";
var Eogon$1 = "Ę";
var eogon$1 = "ę";
var Eopf$1 = "𝔼";
var eopf$1 = "𝕖";
var epar$1 = "⋕";
var eparsl$1 = "⧣";
var eplus$1 = "⩱";
var epsi$1 = "ε";
var Epsilon$1 = "Ε";
var epsilon$1 = "ε";
var epsiv$1 = "ϵ";
var eqcirc$1 = "≖";
var eqcolon$1 = "≕";
var eqsim$1 = "≂";
var eqslantgtr$1 = "⪖";
var eqslantless$1 = "⪕";
var Equal$1 = "⩵";
var equals$1 = "=";
var EqualTilde$1 = "≂";
var equest$1 = "≟";
var Equilibrium$1 = "⇌";
var equiv$1 = "≡";
var equivDD$1 = "⩸";
var eqvparsl$1 = "⧥";
var erarr$1 = "⥱";
var erDot$1 = "≓";
var escr$1 = "ℯ";
var Escr$1 = "ℰ";
var esdot$1 = "≐";
var Esim$1 = "⩳";
var esim$1 = "≂";
var Eta$1 = "Η";
var eta$1 = "η";
var ETH$3 = "Ð";
var eth$3 = "ð";
var Euml$3 = "Ë";
var euml$3 = "ë";
var euro$1 = "€";
var excl$1 = "!";
var exist$1 = "∃";
var Exists$1 = "∃";
var expectation$1 = "ℰ";
var exponentiale$1 = "ⅇ";
var ExponentialE$1 = "ⅇ";
var fallingdotseq$1 = "≒";
var Fcy$1 = "Ф";
var fcy$1 = "ф";
var female$1 = "♀";
var ffilig$1 = "ﬃ";
var fflig$1 = "ﬀ";
var ffllig$1 = "ﬄ";
var Ffr$1 = "𝔉";
var ffr$1 = "𝔣";
var filig$1 = "ﬁ";
var FilledSmallSquare$1 = "◼";
var FilledVerySmallSquare$1 = "▪";
var fjlig$1 = "fj";
var flat$1 = "♭";
var fllig$1 = "ﬂ";
var fltns$1 = "▱";
var fnof$1 = "ƒ";
var Fopf$1 = "𝔽";
var fopf$1 = "𝕗";
var forall$1 = "∀";
var ForAll$1 = "∀";
var fork$1 = "⋔";
var forkv$1 = "⫙";
var Fouriertrf$1 = "ℱ";
var fpartint$1 = "⨍";
var frac12$3 = "½";
var frac13$1 = "⅓";
var frac14$3 = "¼";
var frac15$1 = "⅕";
var frac16$1 = "⅙";
var frac18$1 = "⅛";
var frac23$1 = "⅔";
var frac25$1 = "⅖";
var frac34$3 = "¾";
var frac35$1 = "⅗";
var frac38$1 = "⅜";
var frac45$1 = "⅘";
var frac56$1 = "⅚";
var frac58$1 = "⅝";
var frac78$1 = "⅞";
var frasl$1 = "⁄";
var frown$1 = "⌢";
var fscr$1 = "𝒻";
var Fscr$1 = "ℱ";
var gacute$1 = "ǵ";
var Gamma$1 = "Γ";
var gamma$3 = "γ";
var Gammad$1 = "Ϝ";
var gammad$1 = "ϝ";
var gap$1 = "⪆";
var Gbreve$1 = "Ğ";
var gbreve$1 = "ğ";
var Gcedil$1 = "Ģ";
var Gcirc$1 = "Ĝ";
var gcirc$1 = "ĝ";
var Gcy$1 = "Г";
var gcy$1 = "г";
var Gdot$1 = "Ġ";
var gdot$1 = "ġ";
var ge$1 = "≥";
var gE$1 = "≧";
var gEl$1 = "⪌";
var gel$1 = "⋛";
var geq$1 = "≥";
var geqq$1 = "≧";
var geqslant$1 = "⩾";
var gescc$1 = "⪩";
var ges$1 = "⩾";
var gesdot$1 = "⪀";
var gesdoto$1 = "⪂";
var gesdotol$1 = "⪄";
var gesl$1 = "⋛︀";
var gesles$1 = "⪔";
var Gfr$1 = "𝔊";
var gfr$1 = "𝔤";
var gg$1 = "≫";
var Gg$1 = "⋙";
var ggg$1 = "⋙";
var gimel$1 = "ℷ";
var GJcy$1 = "Ѓ";
var gjcy$1 = "ѓ";
var gla$1 = "⪥";
var gl$1 = "≷";
var glE$1 = "⪒";
var glj$1 = "⪤";
var gnap$1 = "⪊";
var gnapprox$1 = "⪊";
var gne$1 = "⪈";
var gnE$1 = "≩";
var gneq$1 = "⪈";
var gneqq$1 = "≩";
var gnsim$1 = "⋧";
var Gopf$1 = "𝔾";
var gopf$1 = "𝕘";
var grave$1 = "`";
var GreaterEqual$1 = "≥";
var GreaterEqualLess$1 = "⋛";
var GreaterFullEqual$1 = "≧";
var GreaterGreater$1 = "⪢";
var GreaterLess$1 = "≷";
var GreaterSlantEqual$1 = "⩾";
var GreaterTilde$1 = "≳";
var Gscr$1 = "𝒢";
var gscr$1 = "ℊ";
var gsim$1 = "≳";
var gsime$1 = "⪎";
var gsiml$1 = "⪐";
var gtcc$1 = "⪧";
var gtcir$1 = "⩺";
var gt$5 = ">";
var GT$3 = ">";
var Gt$1 = "≫";
var gtdot$1 = "⋗";
var gtlPar$1 = "⦕";
var gtquest$1 = "⩼";
var gtrapprox$1 = "⪆";
var gtrarr$1 = "⥸";
var gtrdot$1 = "⋗";
var gtreqless$1 = "⋛";
var gtreqqless$1 = "⪌";
var gtrless$1 = "≷";
var gtrsim$1 = "≳";
var gvertneqq$1 = "≩︀";
var gvnE$1 = "≩︀";
var Hacek$1 = "ˇ";
var hairsp$1 = " ";
var half$1 = "½";
var hamilt$1 = "ℋ";
var HARDcy$1 = "Ъ";
var hardcy$1 = "ъ";
var harrcir$1 = "⥈";
var harr$1 = "↔";
var hArr$1 = "⇔";
var harrw$1 = "↭";
var Hat$1 = "^";
var hbar$1 = "ℏ";
var Hcirc$1 = "Ĥ";
var hcirc$1 = "ĥ";
var hearts$1 = "♥";
var heartsuit$1 = "♥";
var hellip$1 = "…";
var hercon$1 = "⊹";
var hfr$1 = "𝔥";
var Hfr$1 = "ℌ";
var HilbertSpace$1 = "ℋ";
var hksearow$1 = "⤥";
var hkswarow$1 = "⤦";
var hoarr$1 = "⇿";
var homtht$1 = "∻";
var hookleftarrow$1 = "↩";
var hookrightarrow$1 = "↪";
var hopf$1 = "𝕙";
var Hopf$1 = "ℍ";
var horbar$1 = "―";
var HorizontalLine$1 = "─";
var hscr$1 = "𝒽";
var Hscr$1 = "ℋ";
var hslash$1 = "ℏ";
var Hstrok$1 = "Ħ";
var hstrok$1 = "ħ";
var HumpDownHump$1 = "≎";
var HumpEqual$1 = "≏";
var hybull$1 = "⁃";
var hyphen$1 = "‐";
var Iacute$3 = "Í";
var iacute$3 = "í";
var ic$1 = "⁣";
var Icirc$3 = "Î";
var icirc$3 = "î";
var Icy$1 = "И";
var icy$1 = "и";
var Idot$1 = "İ";
var IEcy$1 = "Е";
var iecy$1 = "е";
var iexcl$3 = "¡";
var iff$1 = "⇔";
var ifr$1 = "𝔦";
var Ifr$1 = "ℑ";
var Igrave$3 = "Ì";
var igrave$3 = "ì";
var ii$1 = "ⅈ";
var iiiint$1 = "⨌";
var iiint$1 = "∭";
var iinfin$1 = "⧜";
var iiota$1 = "℩";
var IJlig$1 = "Ĳ";
var ijlig$1 = "ĳ";
var Imacr$1 = "Ī";
var imacr$1 = "ī";
var image$1 = "ℑ";
var ImaginaryI$1 = "ⅈ";
var imagline$1 = "ℐ";
var imagpart$1 = "ℑ";
var imath$1 = "ı";
var Im$1 = "ℑ";
var imof$1 = "⊷";
var imped$1 = "Ƶ";
var Implies$1 = "⇒";
var incare$1 = "℅";
var infin$1 = "∞";
var infintie$1 = "⧝";
var inodot$1 = "ı";
var intcal$1 = "⊺";
var int$1 = "∫";
var Int$1 = "∬";
var integers$1 = "ℤ";
var Integral$1 = "∫";
var intercal$1 = "⊺";
var Intersection$1 = "⋂";
var intlarhk$1 = "⨗";
var intprod$1 = "⨼";
var InvisibleComma$1 = "⁣";
var InvisibleTimes$1 = "⁢";
var IOcy$1 = "Ё";
var iocy$1 = "ё";
var Iogon$1 = "Į";
var iogon$1 = "į";
var Iopf$1 = "𝕀";
var iopf$1 = "𝕚";
var Iota$1 = "Ι";
var iota$1 = "ι";
var iprod$1 = "⨼";
var iquest$3 = "¿";
var iscr$1 = "𝒾";
var Iscr$1 = "ℐ";
var isin$1 = "∈";
var isindot$1 = "⋵";
var isinE$1 = "⋹";
var isins$1 = "⋴";
var isinsv$1 = "⋳";
var isinv$1 = "∈";
var it$1 = "⁢";
var Itilde$1 = "Ĩ";
var itilde$1 = "ĩ";
var Iukcy$1 = "І";
var iukcy$1 = "і";
var Iuml$3 = "Ï";
var iuml$3 = "ï";
var Jcirc$1 = "Ĵ";
var jcirc$1 = "ĵ";
var Jcy$1 = "Й";
var jcy$1 = "й";
var Jfr$1 = "𝔍";
var jfr$1 = "𝔧";
var jmath$1 = "ȷ";
var Jopf$1 = "𝕁";
var jopf$1 = "𝕛";
var Jscr$1 = "𝒥";
var jscr$1 = "𝒿";
var Jsercy$1 = "Ј";
var jsercy$1 = "ј";
var Jukcy$1 = "Є";
var jukcy$1 = "є";
var Kappa$1 = "Κ";
var kappa$1 = "κ";
var kappav$1 = "ϰ";
var Kcedil$1 = "Ķ";
var kcedil$1 = "ķ";
var Kcy$1 = "К";
var kcy$1 = "к";
var Kfr$1 = "𝔎";
var kfr$1 = "𝔨";
var kgreen$1 = "ĸ";
var KHcy$1 = "Х";
var khcy$1 = "х";
var KJcy$1 = "Ќ";
var kjcy$1 = "ќ";
var Kopf$1 = "𝕂";
var kopf$1 = "𝕜";
var Kscr$1 = "𝒦";
var kscr$1 = "𝓀";
var lAarr$1 = "⇚";
var Lacute$1 = "Ĺ";
var lacute$1 = "ĺ";
var laemptyv$1 = "⦴";
var lagran$1 = "ℒ";
var Lambda$1 = "Λ";
var lambda$1 = "λ";
var lang$1 = "⟨";
var Lang$1 = "⟪";
var langd$1 = "⦑";
var langle$1 = "⟨";
var lap$1 = "⪅";
var Laplacetrf$1 = "ℒ";
var laquo$3 = "«";
var larrb$1 = "⇤";
var larrbfs$1 = "⤟";
var larr$1 = "←";
var Larr$1 = "↞";
var lArr$1 = "⇐";
var larrfs$1 = "⤝";
var larrhk$1 = "↩";
var larrlp$1 = "↫";
var larrpl$1 = "⤹";
var larrsim$1 = "⥳";
var larrtl$1 = "↢";
var latail$1 = "⤙";
var lAtail$1 = "⤛";
var lat$1 = "⪫";
var late$1 = "⪭";
var lates$1 = "⪭︀";
var lbarr$1 = "⤌";
var lBarr$1 = "⤎";
var lbbrk$1 = "❲";
var lbrace$1 = "{";
var lbrack$1 = "[";
var lbrke$1 = "⦋";
var lbrksld$1 = "⦏";
var lbrkslu$1 = "⦍";
var Lcaron$1 = "Ľ";
var lcaron$1 = "ľ";
var Lcedil$1 = "Ļ";
var lcedil$1 = "ļ";
var lceil$1 = "⌈";
var lcub$1 = "{";
var Lcy$1 = "Л";
var lcy$1 = "л";
var ldca$1 = "⤶";
var ldquo$1 = "“";
var ldquor$1 = "„";
var ldrdhar$1 = "⥧";
var ldrushar$1 = "⥋";
var ldsh$1 = "↲";
var le$1 = "≤";
var lE$1 = "≦";
var LeftAngleBracket$1 = "⟨";
var LeftArrowBar$1 = "⇤";
var leftarrow$1 = "←";
var LeftArrow$1 = "←";
var Leftarrow$1 = "⇐";
var LeftArrowRightArrow$1 = "⇆";
var leftarrowtail$1 = "↢";
var LeftCeiling$1 = "⌈";
var LeftDoubleBracket$1 = "⟦";
var LeftDownTeeVector$1 = "⥡";
var LeftDownVectorBar$1 = "⥙";
var LeftDownVector$1 = "⇃";
var LeftFloor$1 = "⌊";
var leftharpoondown$1 = "↽";
var leftharpoonup$1 = "↼";
var leftleftarrows$1 = "⇇";
var leftrightarrow$1 = "↔";
var LeftRightArrow$1 = "↔";
var Leftrightarrow$1 = "⇔";
var leftrightarrows$1 = "⇆";
var leftrightharpoons$1 = "⇋";
var leftrightsquigarrow$1 = "↭";
var LeftRightVector$1 = "⥎";
var LeftTeeArrow$1 = "↤";
var LeftTee$1 = "⊣";
var LeftTeeVector$1 = "⥚";
var leftthreetimes$1 = "⋋";
var LeftTriangleBar$1 = "⧏";
var LeftTriangle$1 = "⊲";
var LeftTriangleEqual$1 = "⊴";
var LeftUpDownVector$1 = "⥑";
var LeftUpTeeVector$1 = "⥠";
var LeftUpVectorBar$1 = "⥘";
var LeftUpVector$1 = "↿";
var LeftVectorBar$1 = "⥒";
var LeftVector$1 = "↼";
var lEg$1 = "⪋";
var leg$1 = "⋚";
var leq$1 = "≤";
var leqq$1 = "≦";
var leqslant$1 = "⩽";
var lescc$1 = "⪨";
var les$1 = "⩽";
var lesdot$1 = "⩿";
var lesdoto$1 = "⪁";
var lesdotor$1 = "⪃";
var lesg$1 = "⋚︀";
var lesges$1 = "⪓";
var lessapprox$1 = "⪅";
var lessdot$1 = "⋖";
var lesseqgtr$1 = "⋚";
var lesseqqgtr$1 = "⪋";
var LessEqualGreater$1 = "⋚";
var LessFullEqual$1 = "≦";
var LessGreater$1 = "≶";
var lessgtr$1 = "≶";
var LessLess$1 = "⪡";
var lesssim$1 = "≲";
var LessSlantEqual$1 = "⩽";
var LessTilde$1 = "≲";
var lfisht$1 = "⥼";
var lfloor$1 = "⌊";
var Lfr$1 = "𝔏";
var lfr$1 = "𝔩";
var lg$1 = "≶";
var lgE$1 = "⪑";
var lHar$1 = "⥢";
var lhard$1 = "↽";
var lharu$1 = "↼";
var lharul$1 = "⥪";
var lhblk$1 = "▄";
var LJcy$1 = "Љ";
var ljcy$1 = "љ";
var llarr$1 = "⇇";
var ll$1 = "≪";
var Ll$1 = "⋘";
var llcorner$1 = "⌞";
var Lleftarrow$1 = "⇚";
var llhard$1 = "⥫";
var lltri$1 = "◺";
var Lmidot$1 = "Ŀ";
var lmidot$1 = "ŀ";
var lmoustache$1 = "⎰";
var lmoust$1 = "⎰";
var lnap$1 = "⪉";
var lnapprox$1 = "⪉";
var lne$1 = "⪇";
var lnE$1 = "≨";
var lneq$1 = "⪇";
var lneqq$1 = "≨";
var lnsim$1 = "⋦";
var loang$1 = "⟬";
var loarr$1 = "⇽";
var lobrk$1 = "⟦";
var longleftarrow$1 = "⟵";
var LongLeftArrow$1 = "⟵";
var Longleftarrow$1 = "⟸";
var longleftrightarrow$1 = "⟷";
var LongLeftRightArrow$1 = "⟷";
var Longleftrightarrow$1 = "⟺";
var longmapsto$1 = "⟼";
var longrightarrow$1 = "⟶";
var LongRightArrow$1 = "⟶";
var Longrightarrow$1 = "⟹";
var looparrowleft$1 = "↫";
var looparrowright$1 = "↬";
var lopar$1 = "⦅";
var Lopf$1 = "𝕃";
var lopf$1 = "𝕝";
var loplus$1 = "⨭";
var lotimes$1 = "⨴";
var lowast$1 = "∗";
var lowbar$1 = "_";
var LowerLeftArrow$1 = "↙";
var LowerRightArrow$1 = "↘";
var loz$1 = "◊";
var lozenge$1 = "◊";
var lozf$1 = "⧫";
var lpar$1 = "(";
var lparlt$1 = "⦓";
var lrarr$1 = "⇆";
var lrcorner$1 = "⌟";
var lrhar$1 = "⇋";
var lrhard$1 = "⥭";
var lrm$1 = "‎";
var lrtri$1 = "⊿";
var lsaquo$1 = "‹";
var lscr$1 = "𝓁";
var Lscr$1 = "ℒ";
var lsh$1 = "↰";
var Lsh$1 = "↰";
var lsim$1 = "≲";
var lsime$1 = "⪍";
var lsimg$1 = "⪏";
var lsqb$1 = "[";
var lsquo$1 = "‘";
var lsquor$1 = "‚";
var Lstrok$1 = "Ł";
var lstrok$1 = "ł";
var ltcc$1 = "⪦";
var ltcir$1 = "⩹";
var lt$5 = "<";
var LT$3 = "<";
var Lt$1 = "≪";
var ltdot$1 = "⋖";
var lthree$1 = "⋋";
var ltimes$1 = "⋉";
var ltlarr$1 = "⥶";
var ltquest$1 = "⩻";
var ltri$1 = "◃";
var ltrie$1 = "⊴";
var ltrif$1 = "◂";
var ltrPar$1 = "⦖";
var lurdshar$1 = "⥊";
var luruhar$1 = "⥦";
var lvertneqq$1 = "≨︀";
var lvnE$1 = "≨︀";
var macr$3 = "¯";
var male$1 = "♂";
var malt$1 = "✠";
var maltese$1 = "✠";
var map$4 = "↦";
var mapsto$1 = "↦";
var mapstodown$1 = "↧";
var mapstoleft$1 = "↤";
var mapstoup$1 = "↥";
var marker$1 = "▮";
var mcomma$1 = "⨩";
var Mcy$1 = "М";
var mcy$1 = "м";
var mdash$1 = "—";
var mDDot$1 = "∺";
var measuredangle$1 = "∡";
var MediumSpace$1 = " ";
var Mellintrf$1 = "ℳ";
var Mfr$1 = "𝔐";
var mfr$1 = "𝔪";
var mho$1 = "℧";
var micro$3 = "µ";
var midast$1 = "*";
var midcir$1 = "⫰";
var mid$1 = "∣";
var middot$3 = "·";
var minusb$1 = "⊟";
var minus$1 = "−";
var minusd$1 = "∸";
var minusdu$1 = "⨪";
var MinusPlus$1 = "∓";
var mlcp$1 = "⫛";
var mldr$1 = "…";
var mnplus$1 = "∓";
var models$1 = "⊧";
var Mopf$1 = "𝕄";
var mopf$1 = "𝕞";
var mp$1 = "∓";
var mscr$1 = "𝓂";
var Mscr$1 = "ℳ";
var mstpos$1 = "∾";
var Mu$1 = "Μ";
var mu$1 = "μ";
var multimap$1 = "⊸";
var mumap$1 = "⊸";
var nabla$1 = "∇";
var Nacute$1 = "Ń";
var nacute$1 = "ń";
var nang$1 = "∠⃒";
var nap$2 = "≉";
var napE$1 = "⩰̸";
var napid$1 = "≋̸";
var napos$1 = "ŉ";
var napprox$1 = "≉";
var natural$1 = "♮";
var naturals$1 = "ℕ";
var natur$1 = "♮";
var nbsp$3 = " ";
var nbump$1 = "≎̸";
var nbumpe$1 = "≏̸";
var ncap$1 = "⩃";
var Ncaron$1 = "Ň";
var ncaron$1 = "ň";
var Ncedil$1 = "Ņ";
var ncedil$1 = "ņ";
var ncong$1 = "≇";
var ncongdot$1 = "⩭̸";
var ncup$1 = "⩂";
var Ncy$1 = "Н";
var ncy$1 = "н";
var ndash$1 = "–";
var nearhk$1 = "⤤";
var nearr$1 = "↗";
var neArr$1 = "⇗";
var nearrow$1 = "↗";
var ne$1 = "≠";
var nedot$1 = "≐̸";
var NegativeMediumSpace$1 = "​";
var NegativeThickSpace$1 = "​";
var NegativeThinSpace$1 = "​";
var NegativeVeryThinSpace$1 = "​";
var nequiv$1 = "≢";
var nesear$1 = "⤨";
var nesim$1 = "≂̸";
var NestedGreaterGreater$1 = "≫";
var NestedLessLess$1 = "≪";
var NewLine$1 = "\n";
var nexist$1 = "∄";
var nexists$1 = "∄";
var Nfr$1 = "𝔑";
var nfr$1 = "𝔫";
var ngE$1 = "≧̸";
var nge$1 = "≱";
var ngeq$1 = "≱";
var ngeqq$1 = "≧̸";
var ngeqslant$1 = "⩾̸";
var nges$1 = "⩾̸";
var nGg$1 = "⋙̸";
var ngsim$1 = "≵";
var nGt$1 = "≫⃒";
var ngt$1 = "≯";
var ngtr$1 = "≯";
var nGtv$1 = "≫̸";
var nharr$1 = "↮";
var nhArr$1 = "⇎";
var nhpar$1 = "⫲";
var ni$1 = "∋";
var nis$1 = "⋼";
var nisd$1 = "⋺";
var niv$1 = "∋";
var NJcy$1 = "Њ";
var njcy$1 = "њ";
var nlarr$1 = "↚";
var nlArr$1 = "⇍";
var nldr$1 = "‥";
var nlE$1 = "≦̸";
var nle$1 = "≰";
var nleftarrow$1 = "↚";
var nLeftarrow$1 = "⇍";
var nleftrightarrow$1 = "↮";
var nLeftrightarrow$1 = "⇎";
var nleq$1 = "≰";
var nleqq$1 = "≦̸";
var nleqslant$1 = "⩽̸";
var nles$1 = "⩽̸";
var nless$1 = "≮";
var nLl$1 = "⋘̸";
var nlsim$1 = "≴";
var nLt$1 = "≪⃒";
var nlt$1 = "≮";
var nltri$1 = "⋪";
var nltrie$1 = "⋬";
var nLtv$1 = "≪̸";
var nmid$1 = "∤";
var NoBreak$1 = "⁠";
var NonBreakingSpace$1 = " ";
var nopf$1 = "𝕟";
var Nopf$1 = "ℕ";
var Not$1 = "⫬";
var not$3 = "¬";
var NotCongruent$1 = "≢";
var NotCupCap$1 = "≭";
var NotDoubleVerticalBar$1 = "∦";
var NotElement$1 = "∉";
var NotEqual$1 = "≠";
var NotEqualTilde$1 = "≂̸";
var NotExists$1 = "∄";
var NotGreater$1 = "≯";
var NotGreaterEqual$1 = "≱";
var NotGreaterFullEqual$1 = "≧̸";
var NotGreaterGreater$1 = "≫̸";
var NotGreaterLess$1 = "≹";
var NotGreaterSlantEqual$1 = "⩾̸";
var NotGreaterTilde$1 = "≵";
var NotHumpDownHump$1 = "≎̸";
var NotHumpEqual$1 = "≏̸";
var notin$1 = "∉";
var notindot$1 = "⋵̸";
var notinE$1 = "⋹̸";
var notinva$1 = "∉";
var notinvb$1 = "⋷";
var notinvc$1 = "⋶";
var NotLeftTriangleBar$1 = "⧏̸";
var NotLeftTriangle$1 = "⋪";
var NotLeftTriangleEqual$1 = "⋬";
var NotLess$1 = "≮";
var NotLessEqual$1 = "≰";
var NotLessGreater$1 = "≸";
var NotLessLess$1 = "≪̸";
var NotLessSlantEqual$1 = "⩽̸";
var NotLessTilde$1 = "≴";
var NotNestedGreaterGreater$1 = "⪢̸";
var NotNestedLessLess$1 = "⪡̸";
var notni$1 = "∌";
var notniva$1 = "∌";
var notnivb$1 = "⋾";
var notnivc$1 = "⋽";
var NotPrecedes$1 = "⊀";
var NotPrecedesEqual$1 = "⪯̸";
var NotPrecedesSlantEqual$1 = "⋠";
var NotReverseElement$1 = "∌";
var NotRightTriangleBar$1 = "⧐̸";
var NotRightTriangle$1 = "⋫";
var NotRightTriangleEqual$1 = "⋭";
var NotSquareSubset$1 = "⊏̸";
var NotSquareSubsetEqual$1 = "⋢";
var NotSquareSuperset$1 = "⊐̸";
var NotSquareSupersetEqual$1 = "⋣";
var NotSubset$1 = "⊂⃒";
var NotSubsetEqual$1 = "⊈";
var NotSucceeds$1 = "⊁";
var NotSucceedsEqual$1 = "⪰̸";
var NotSucceedsSlantEqual$1 = "⋡";
var NotSucceedsTilde$1 = "≿̸";
var NotSuperset$1 = "⊃⃒";
var NotSupersetEqual$1 = "⊉";
var NotTilde$1 = "≁";
var NotTildeEqual$1 = "≄";
var NotTildeFullEqual$1 = "≇";
var NotTildeTilde$1 = "≉";
var NotVerticalBar$1 = "∤";
var nparallel$1 = "∦";
var npar$1 = "∦";
var nparsl$1 = "⫽⃥";
var npart$1 = "∂̸";
var npolint$1 = "⨔";
var npr$1 = "⊀";
var nprcue$1 = "⋠";
var nprec$1 = "⊀";
var npreceq$1 = "⪯̸";
var npre$1 = "⪯̸";
var nrarrc$1 = "⤳̸";
var nrarr$1 = "↛";
var nrArr$1 = "⇏";
var nrarrw$1 = "↝̸";
var nrightarrow$1 = "↛";
var nRightarrow$1 = "⇏";
var nrtri$1 = "⋫";
var nrtrie$1 = "⋭";
var nsc$1 = "⊁";
var nsccue$1 = "⋡";
var nsce$1 = "⪰̸";
var Nscr$1 = "𝒩";
var nscr$1 = "𝓃";
var nshortmid$1 = "∤";
var nshortparallel$1 = "∦";
var nsim$1 = "≁";
var nsime$1 = "≄";
var nsimeq$1 = "≄";
var nsmid$1 = "∤";
var nspar$1 = "∦";
var nsqsube$1 = "⋢";
var nsqsupe$1 = "⋣";
var nsub$1 = "⊄";
var nsubE$1 = "⫅̸";
var nsube$1 = "⊈";
var nsubset$1 = "⊂⃒";
var nsubseteq$1 = "⊈";
var nsubseteqq$1 = "⫅̸";
var nsucc$1 = "⊁";
var nsucceq$1 = "⪰̸";
var nsup$1 = "⊅";
var nsupE$1 = "⫆̸";
var nsupe$1 = "⊉";
var nsupset$1 = "⊃⃒";
var nsupseteq$1 = "⊉";
var nsupseteqq$1 = "⫆̸";
var ntgl$1 = "≹";
var Ntilde$3 = "Ñ";
var ntilde$3 = "ñ";
var ntlg$1 = "≸";
var ntriangleleft$1 = "⋪";
var ntrianglelefteq$1 = "⋬";
var ntriangleright$1 = "⋫";
var ntrianglerighteq$1 = "⋭";
var Nu$1 = "Ν";
var nu$1 = "ν";
var num$1 = "#";
var numero$1 = "№";
var numsp$1 = " ";
var nvap$1 = "≍⃒";
var nvdash$1 = "⊬";
var nvDash$1 = "⊭";
var nVdash$1 = "⊮";
var nVDash$1 = "⊯";
var nvge$1 = "≥⃒";
var nvgt$1 = ">⃒";
var nvHarr$1 = "⤄";
var nvinfin$1 = "⧞";
var nvlArr$1 = "⤂";
var nvle$1 = "≤⃒";
var nvlt$1 = "<⃒";
var nvltrie$1 = "⊴⃒";
var nvrArr$1 = "⤃";
var nvrtrie$1 = "⊵⃒";
var nvsim$1 = "∼⃒";
var nwarhk$1 = "⤣";
var nwarr$1 = "↖";
var nwArr$1 = "⇖";
var nwarrow$1 = "↖";
var nwnear$1 = "⤧";
var Oacute$3 = "Ó";
var oacute$3 = "ó";
var oast$1 = "⊛";
var Ocirc$3 = "Ô";
var ocirc$3 = "ô";
var ocir$1 = "⊚";
var Ocy$1 = "О";
var ocy$1 = "о";
var odash$1 = "⊝";
var Odblac$1 = "Ő";
var odblac$1 = "ő";
var odiv$1 = "⨸";
var odot$1 = "⊙";
var odsold$1 = "⦼";
var OElig$1 = "Œ";
var oelig$1 = "œ";
var ofcir$1 = "⦿";
var Ofr$1 = "𝔒";
var ofr$1 = "𝔬";
var ogon$1 = "˛";
var Ograve$3 = "Ò";
var ograve$3 = "ò";
var ogt$1 = "⧁";
var ohbar$1 = "⦵";
var ohm$1 = "Ω";
var oint$1 = "∮";
var olarr$1 = "↺";
var olcir$1 = "⦾";
var olcross$1 = "⦻";
var oline$1 = "‾";
var olt$1 = "⧀";
var Omacr$1 = "Ō";
var omacr$1 = "ō";
var Omega$1 = "Ω";
var omega$1 = "ω";
var Omicron$1 = "Ο";
var omicron$1 = "ο";
var omid$1 = "⦶";
var ominus$1 = "⊖";
var Oopf$1 = "𝕆";
var oopf$1 = "𝕠";
var opar$1 = "⦷";
var OpenCurlyDoubleQuote$1 = "“";
var OpenCurlyQuote$1 = "‘";
var operp$1 = "⦹";
var oplus$1 = "⊕";
var orarr$1 = "↻";
var Or$1 = "⩔";
var or$1 = "∨";
var ord$1 = "⩝";
var order$1 = "ℴ";
var orderof$1 = "ℴ";
var ordf$3 = "ª";
var ordm$3 = "º";
var origof$1 = "⊶";
var oror$1 = "⩖";
var orslope$1 = "⩗";
var orv$1 = "⩛";
var oS$1 = "Ⓢ";
var Oscr$1 = "𝒪";
var oscr$1 = "ℴ";
var Oslash$3 = "Ø";
var oslash$3 = "ø";
var osol$1 = "⊘";
var Otilde$3 = "Õ";
var otilde$3 = "õ";
var otimesas$1 = "⨶";
var Otimes$1 = "⨷";
var otimes$1 = "⊗";
var Ouml$3 = "Ö";
var ouml$3 = "ö";
var ovbar$1 = "⌽";
var OverBar$1 = "‾";
var OverBrace$1 = "⏞";
var OverBracket$1 = "⎴";
var OverParenthesis$1 = "⏜";
var para$3 = "¶";
var parallel$2 = "∥";
var par$1 = "∥";
var parsim$1 = "⫳";
var parsl$1 = "⫽";
var part$1 = "∂";
var PartialD$1 = "∂";
var Pcy$1 = "П";
var pcy$1 = "п";
var percnt$1 = "%";
var period$1 = ".";
var permil$1 = "‰";
var perp$1 = "⊥";
var pertenk$1 = "‱";
var Pfr$1 = "𝔓";
var pfr$1 = "𝔭";
var Phi$1 = "Φ";
var phi$1 = "φ";
var phiv$1 = "ϕ";
var phmmat$1 = "ℳ";
var phone$1 = "☎";
var Pi$1 = "Π";
var pi$1 = "π";
var pitchfork$1 = "⋔";
var piv$1 = "ϖ";
var planck$1 = "ℏ";
var planckh$1 = "ℎ";
var plankv$1 = "ℏ";
var plusacir$1 = "⨣";
var plusb$1 = "⊞";
var pluscir$1 = "⨢";
var plus$1 = "+";
var plusdo$1 = "∔";
var plusdu$1 = "⨥";
var pluse$1 = "⩲";
var PlusMinus$1 = "±";
var plusmn$3 = "±";
var plussim$1 = "⨦";
var plustwo$1 = "⨧";
var pm$1 = "±";
var Poincareplane$1 = "ℌ";
var pointint$1 = "⨕";
var popf$1 = "𝕡";
var Popf$1 = "ℙ";
var pound$3 = "£";
var prap$1 = "⪷";
var Pr$1 = "⪻";
var pr$1 = "≺";
var prcue$1 = "≼";
var precapprox$1 = "⪷";
var prec$1 = "≺";
var preccurlyeq$1 = "≼";
var Precedes$1 = "≺";
var PrecedesEqual$1 = "⪯";
var PrecedesSlantEqual$1 = "≼";
var PrecedesTilde$1 = "≾";
var preceq$1 = "⪯";
var precnapprox$1 = "⪹";
var precneqq$1 = "⪵";
var precnsim$1 = "⋨";
var pre$1 = "⪯";
var prE$1 = "⪳";
var precsim$1 = "≾";
var prime$1 = "′";
var Prime$1 = "″";
var primes$1 = "ℙ";
var prnap$1 = "⪹";
var prnE$1 = "⪵";
var prnsim$1 = "⋨";
var prod$1 = "∏";
var Product$1 = "∏";
var profalar$1 = "⌮";
var profline$1 = "⌒";
var profsurf$1 = "⌓";
var prop$1 = "∝";
var Proportional$1 = "∝";
var Proportion$1 = "∷";
var propto$1 = "∝";
var prsim$1 = "≾";
var prurel$1 = "⊰";
var Pscr$1 = "𝒫";
var pscr$1 = "𝓅";
var Psi$1 = "Ψ";
var psi$1 = "ψ";
var puncsp$1 = " ";
var Qfr$1 = "𝔔";
var qfr$1 = "𝔮";
var qint$1 = "⨌";
var qopf$1 = "𝕢";
var Qopf$1 = "ℚ";
var qprime$1 = "⁗";
var Qscr$1 = "𝒬";
var qscr$1 = "𝓆";
var quaternions$1 = "ℍ";
var quatint$1 = "⨖";
var quest$1 = "?";
var questeq$1 = "≟";
var quot$5 = "\"";
var QUOT$3 = "\"";
var rAarr$1 = "⇛";
var race$1 = "∽̱";
var Racute$1 = "Ŕ";
var racute$1 = "ŕ";
var radic$1 = "√";
var raemptyv$1 = "⦳";
var rang$1 = "⟩";
var Rang$1 = "⟫";
var rangd$1 = "⦒";
var range$1 = "⦥";
var rangle$1 = "⟩";
var raquo$3 = "»";
var rarrap$1 = "⥵";
var rarrb$1 = "⇥";
var rarrbfs$1 = "⤠";
var rarrc$1 = "⤳";
var rarr$1 = "→";
var Rarr$1 = "↠";
var rArr$1 = "⇒";
var rarrfs$1 = "⤞";
var rarrhk$1 = "↪";
var rarrlp$1 = "↬";
var rarrpl$1 = "⥅";
var rarrsim$1 = "⥴";
var Rarrtl$1 = "⤖";
var rarrtl$1 = "↣";
var rarrw$1 = "↝";
var ratail$1 = "⤚";
var rAtail$1 = "⤜";
var ratio$1 = "∶";
var rationals$1 = "ℚ";
var rbarr$1 = "⤍";
var rBarr$1 = "⤏";
var RBarr$1 = "⤐";
var rbbrk$1 = "❳";
var rbrace$1 = "}";
var rbrack$1 = "]";
var rbrke$1 = "⦌";
var rbrksld$1 = "⦎";
var rbrkslu$1 = "⦐";
var Rcaron$1 = "Ř";
var rcaron$1 = "ř";
var Rcedil$1 = "Ŗ";
var rcedil$1 = "ŗ";
var rceil$1 = "⌉";
var rcub$1 = "}";
var Rcy$1 = "Р";
var rcy$1 = "р";
var rdca$1 = "⤷";
var rdldhar$1 = "⥩";
var rdquo$1 = "”";
var rdquor$1 = "”";
var rdsh$1 = "↳";
var real$1 = "ℜ";
var realine$1 = "ℛ";
var realpart$1 = "ℜ";
var reals$1 = "ℝ";
var Re$1 = "ℜ";
var rect$1 = "▭";
var reg$3 = "®";
var REG$3 = "®";
var ReverseElement$1 = "∋";
var ReverseEquilibrium$1 = "⇋";
var ReverseUpEquilibrium$1 = "⥯";
var rfisht$1 = "⥽";
var rfloor$1 = "⌋";
var rfr$1 = "𝔯";
var Rfr$1 = "ℜ";
var rHar$1 = "⥤";
var rhard$1 = "⇁";
var rharu$1 = "⇀";
var rharul$1 = "⥬";
var Rho$1 = "Ρ";
var rho$1 = "ρ";
var rhov$1 = "ϱ";
var RightAngleBracket$1 = "⟩";
var RightArrowBar$1 = "⇥";
var rightarrow$1 = "→";
var RightArrow$1 = "→";
var Rightarrow$1 = "⇒";
var RightArrowLeftArrow$1 = "⇄";
var rightarrowtail$1 = "↣";
var RightCeiling$1 = "⌉";
var RightDoubleBracket$1 = "⟧";
var RightDownTeeVector$1 = "⥝";
var RightDownVectorBar$1 = "⥕";
var RightDownVector$1 = "⇂";
var RightFloor$1 = "⌋";
var rightharpoondown$1 = "⇁";
var rightharpoonup$1 = "⇀";
var rightleftarrows$1 = "⇄";
var rightleftharpoons$1 = "⇌";
var rightrightarrows$1 = "⇉";
var rightsquigarrow$1 = "↝";
var RightTeeArrow$1 = "↦";
var RightTee$1 = "⊢";
var RightTeeVector$1 = "⥛";
var rightthreetimes$1 = "⋌";
var RightTriangleBar$1 = "⧐";
var RightTriangle$1 = "⊳";
var RightTriangleEqual$1 = "⊵";
var RightUpDownVector$1 = "⥏";
var RightUpTeeVector$1 = "⥜";
var RightUpVectorBar$1 = "⥔";
var RightUpVector$1 = "↾";
var RightVectorBar$1 = "⥓";
var RightVector$1 = "⇀";
var ring$1 = "˚";
var risingdotseq$1 = "≓";
var rlarr$1 = "⇄";
var rlhar$1 = "⇌";
var rlm$1 = "‏";
var rmoustache$1 = "⎱";
var rmoust$1 = "⎱";
var rnmid$1 = "⫮";
var roang$1 = "⟭";
var roarr$1 = "⇾";
var robrk$1 = "⟧";
var ropar$1 = "⦆";
var ropf$1 = "𝕣";
var Ropf$1 = "ℝ";
var roplus$1 = "⨮";
var rotimes$1 = "⨵";
var RoundImplies$1 = "⥰";
var rpar$1 = ")";
var rpargt$1 = "⦔";
var rppolint$1 = "⨒";
var rrarr$1 = "⇉";
var Rrightarrow$1 = "⇛";
var rsaquo$1 = "›";
var rscr$1 = "𝓇";
var Rscr$1 = "ℛ";
var rsh$1 = "↱";
var Rsh$1 = "↱";
var rsqb$1 = "]";
var rsquo$1 = "’";
var rsquor$1 = "’";
var rthree$1 = "⋌";
var rtimes$1 = "⋊";
var rtri$1 = "▹";
var rtrie$1 = "⊵";
var rtrif$1 = "▸";
var rtriltri$1 = "⧎";
var RuleDelayed$1 = "⧴";
var ruluhar$1 = "⥨";
var rx$1 = "℞";
var Sacute$1 = "Ś";
var sacute$1 = "ś";
var sbquo$1 = "‚";
var scap$1 = "⪸";
var Scaron$1 = "Š";
var scaron$1 = "š";
var Sc$1 = "⪼";
var sc$1 = "≻";
var sccue$1 = "≽";
var sce$1 = "⪰";
var scE$1 = "⪴";
var Scedil$1 = "Ş";
var scedil$1 = "ş";
var Scirc$1 = "Ŝ";
var scirc$1 = "ŝ";
var scnap$1 = "⪺";
var scnE$1 = "⪶";
var scnsim$1 = "⋩";
var scpolint$1 = "⨓";
var scsim$1 = "≿";
var Scy$1 = "С";
var scy$1 = "с";
var sdotb$1 = "⊡";
var sdot$1 = "⋅";
var sdote$1 = "⩦";
var searhk$1 = "⤥";
var searr$1 = "↘";
var seArr$1 = "⇘";
var searrow$1 = "↘";
var sect$3 = "§";
var semi$1 = ";";
var seswar$1 = "⤩";
var setminus$1 = "∖";
var setmn$1 = "∖";
var sext$1 = "✶";
var Sfr$1 = "𝔖";
var sfr$1 = "𝔰";
var sfrown$1 = "⌢";
var sharp$1 = "♯";
var SHCHcy$1 = "Щ";
var shchcy$1 = "щ";
var SHcy$1 = "Ш";
var shcy$1 = "ш";
var ShortDownArrow$1 = "↓";
var ShortLeftArrow$1 = "←";
var shortmid$1 = "∣";
var shortparallel$1 = "∥";
var ShortRightArrow$1 = "→";
var ShortUpArrow$1 = "↑";
var shy$3 = "­";
var Sigma$1 = "Σ";
var sigma$1 = "σ";
var sigmaf$1 = "ς";
var sigmav$1 = "ς";
var sim$1 = "∼";
var simdot$1 = "⩪";
var sime$1 = "≃";
var simeq$1 = "≃";
var simg$1 = "⪞";
var simgE$1 = "⪠";
var siml$1 = "⪝";
var simlE$1 = "⪟";
var simne$1 = "≆";
var simplus$1 = "⨤";
var simrarr$1 = "⥲";
var slarr$1 = "←";
var SmallCircle$1 = "∘";
var smallsetminus$1 = "∖";
var smashp$1 = "⨳";
var smeparsl$1 = "⧤";
var smid$1 = "∣";
var smile$1 = "⌣";
var smt$1 = "⪪";
var smte$1 = "⪬";
var smtes$1 = "⪬︀";
var SOFTcy$1 = "Ь";
var softcy$1 = "ь";
var solbar$1 = "⌿";
var solb$1 = "⧄";
var sol$1 = "/";
var Sopf$1 = "𝕊";
var sopf$1 = "𝕤";
var spades$1 = "♠";
var spadesuit$1 = "♠";
var spar$1 = "∥";
var sqcap$1 = "⊓";
var sqcaps$1 = "⊓︀";
var sqcup$1 = "⊔";
var sqcups$1 = "⊔︀";
var Sqrt$1 = "√";
var sqsub$1 = "⊏";
var sqsube$1 = "⊑";
var sqsubset$1 = "⊏";
var sqsubseteq$1 = "⊑";
var sqsup$1 = "⊐";
var sqsupe$1 = "⊒";
var sqsupset$1 = "⊐";
var sqsupseteq$1 = "⊒";
var square$1 = "□";
var Square$1 = "□";
var SquareIntersection$1 = "⊓";
var SquareSubset$1 = "⊏";
var SquareSubsetEqual$1 = "⊑";
var SquareSuperset$1 = "⊐";
var SquareSupersetEqual$1 = "⊒";
var SquareUnion$1 = "⊔";
var squarf$1 = "▪";
var squ$1 = "□";
var squf$1 = "▪";
var srarr$1 = "→";
var Sscr$1 = "𝒮";
var sscr$1 = "𝓈";
var ssetmn$1 = "∖";
var ssmile$1 = "⌣";
var sstarf$1 = "⋆";
var Star$1 = "⋆";
var star$1 = "☆";
var starf$1 = "★";
var straightepsilon$1 = "ϵ";
var straightphi$1 = "ϕ";
var strns$1 = "¯";
var sub$1 = "⊂";
var Sub$1 = "⋐";
var subdot$1 = "⪽";
var subE$1 = "⫅";
var sube$1 = "⊆";
var subedot$1 = "⫃";
var submult$1 = "⫁";
var subnE$1 = "⫋";
var subne$1 = "⊊";
var subplus$1 = "⪿";
var subrarr$1 = "⥹";
var subset$1 = "⊂";
var Subset$1 = "⋐";
var subseteq$1 = "⊆";
var subseteqq$1 = "⫅";
var SubsetEqual$1 = "⊆";
var subsetneq$1 = "⊊";
var subsetneqq$1 = "⫋";
var subsim$1 = "⫇";
var subsub$1 = "⫕";
var subsup$1 = "⫓";
var succapprox$1 = "⪸";
var succ$1 = "≻";
var succcurlyeq$1 = "≽";
var Succeeds$1 = "≻";
var SucceedsEqual$1 = "⪰";
var SucceedsSlantEqual$1 = "≽";
var SucceedsTilde$1 = "≿";
var succeq$1 = "⪰";
var succnapprox$1 = "⪺";
var succneqq$1 = "⪶";
var succnsim$1 = "⋩";
var succsim$1 = "≿";
var SuchThat$1 = "∋";
var sum$1 = "∑";
var Sum$1 = "∑";
var sung$1 = "♪";
var sup1$3 = "¹";
var sup2$3 = "²";
var sup3$3 = "³";
var sup$1 = "⊃";
var Sup$1 = "⋑";
var supdot$1 = "⪾";
var supdsub$1 = "⫘";
var supE$1 = "⫆";
var supe$1 = "⊇";
var supedot$1 = "⫄";
var Superset$1 = "⊃";
var SupersetEqual$1 = "⊇";
var suphsol$1 = "⟉";
var suphsub$1 = "⫗";
var suplarr$1 = "⥻";
var supmult$1 = "⫂";
var supnE$1 = "⫌";
var supne$1 = "⊋";
var supplus$1 = "⫀";
var supset$1 = "⊃";
var Supset$1 = "⋑";
var supseteq$1 = "⊇";
var supseteqq$1 = "⫆";
var supsetneq$1 = "⊋";
var supsetneqq$1 = "⫌";
var supsim$1 = "⫈";
var supsub$1 = "⫔";
var supsup$1 = "⫖";
var swarhk$1 = "⤦";
var swarr$1 = "↙";
var swArr$1 = "⇙";
var swarrow$1 = "↙";
var swnwar$1 = "⤪";
var szlig$3 = "ß";
var Tab$1 = "\t";
var target$1 = "⌖";
var Tau$1 = "Τ";
var tau$1 = "τ";
var tbrk$1 = "⎴";
var Tcaron$1 = "Ť";
var tcaron$1 = "ť";
var Tcedil$1 = "Ţ";
var tcedil$1 = "ţ";
var Tcy$1 = "Т";
var tcy$1 = "т";
var tdot$1 = "⃛";
var telrec$1 = "⌕";
var Tfr$1 = "𝔗";
var tfr$1 = "𝔱";
var there4$1 = "∴";
var therefore$1 = "∴";
var Therefore$1 = "∴";
var Theta$1 = "Θ";
var theta$1 = "θ";
var thetasym$1 = "ϑ";
var thetav$1 = "ϑ";
var thickapprox$1 = "≈";
var thicksim$1 = "∼";
var ThickSpace$1 = "  ";
var ThinSpace$1 = " ";
var thinsp$1 = " ";
var thkap$1 = "≈";
var thksim$1 = "∼";
var THORN$3 = "Þ";
var thorn$3 = "þ";
var tilde$1 = "˜";
var Tilde$1 = "∼";
var TildeEqual$1 = "≃";
var TildeFullEqual$1 = "≅";
var TildeTilde$1 = "≈";
var timesbar$1 = "⨱";
var timesb$1 = "⊠";
var times$3 = "×";
var timesd$1 = "⨰";
var tint$1 = "∭";
var toea$1 = "⤨";
var topbot$1 = "⌶";
var topcir$1 = "⫱";
var top$1 = "⊤";
var Topf$1 = "𝕋";
var topf$1 = "𝕥";
var topfork$1 = "⫚";
var tosa$1 = "⤩";
var tprime$1 = "‴";
var trade$1 = "™";
var TRADE$1 = "™";
var triangle$1 = "▵";
var triangledown$1 = "▿";
var triangleleft$1 = "◃";
var trianglelefteq$1 = "⊴";
var triangleq$1 = "≜";
var triangleright$1 = "▹";
var trianglerighteq$1 = "⊵";
var tridot$1 = "◬";
var trie$1 = "≜";
var triminus$1 = "⨺";
var TripleDot$1 = "⃛";
var triplus$1 = "⨹";
var trisb$1 = "⧍";
var tritime$1 = "⨻";
var trpezium$1 = "⏢";
var Tscr$1 = "𝒯";
var tscr$1 = "𝓉";
var TScy$1 = "Ц";
var tscy$1 = "ц";
var TSHcy$1 = "Ћ";
var tshcy$1 = "ћ";
var Tstrok$1 = "Ŧ";
var tstrok$1 = "ŧ";
var twixt$1 = "≬";
var twoheadleftarrow$1 = "↞";
var twoheadrightarrow$1 = "↠";
var Uacute$3 = "Ú";
var uacute$3 = "ú";
var uarr$1 = "↑";
var Uarr$1 = "↟";
var uArr$1 = "⇑";
var Uarrocir$1 = "⥉";
var Ubrcy$1 = "Ў";
var ubrcy$1 = "ў";
var Ubreve$1 = "Ŭ";
var ubreve$1 = "ŭ";
var Ucirc$3 = "Û";
var ucirc$3 = "û";
var Ucy$1 = "У";
var ucy$1 = "у";
var udarr$1 = "⇅";
var Udblac$1 = "Ű";
var udblac$1 = "ű";
var udhar$1 = "⥮";
var ufisht$1 = "⥾";
var Ufr$1 = "𝔘";
var ufr$1 = "𝔲";
var Ugrave$3 = "Ù";
var ugrave$3 = "ù";
var uHar$1 = "⥣";
var uharl$1 = "↿";
var uharr$1 = "↾";
var uhblk$1 = "▀";
var ulcorn$1 = "⌜";
var ulcorner$1 = "⌜";
var ulcrop$1 = "⌏";
var ultri$1 = "◸";
var Umacr$1 = "Ū";
var umacr$1 = "ū";
var uml$3 = "¨";
var UnderBar$1 = "_";
var UnderBrace$1 = "⏟";
var UnderBracket$1 = "⎵";
var UnderParenthesis$1 = "⏝";
var Union$1 = "⋃";
var UnionPlus$1 = "⊎";
var Uogon$1 = "Ų";
var uogon$1 = "ų";
var Uopf$1 = "𝕌";
var uopf$1 = "𝕦";
var UpArrowBar$1 = "⤒";
var uparrow$1 = "↑";
var UpArrow$1 = "↑";
var Uparrow$1 = "⇑";
var UpArrowDownArrow$1 = "⇅";
var updownarrow$1 = "↕";
var UpDownArrow$1 = "↕";
var Updownarrow$1 = "⇕";
var UpEquilibrium$1 = "⥮";
var upharpoonleft$1 = "↿";
var upharpoonright$1 = "↾";
var uplus$1 = "⊎";
var UpperLeftArrow$1 = "↖";
var UpperRightArrow$1 = "↗";
var upsi$1 = "υ";
var Upsi$1 = "ϒ";
var upsih$1 = "ϒ";
var Upsilon$1 = "Υ";
var upsilon$1 = "υ";
var UpTeeArrow$1 = "↥";
var UpTee$1 = "⊥";
var upuparrows$1 = "⇈";
var urcorn$1 = "⌝";
var urcorner$1 = "⌝";
var urcrop$1 = "⌎";
var Uring$1 = "Ů";
var uring$1 = "ů";
var urtri$1 = "◹";
var Uscr$1 = "𝒰";
var uscr$1 = "𝓊";
var utdot$1 = "⋰";
var Utilde$1 = "Ũ";
var utilde$1 = "ũ";
var utri$1 = "▵";
var utrif$1 = "▴";
var uuarr$1 = "⇈";
var Uuml$3 = "Ü";
var uuml$3 = "ü";
var uwangle$1 = "⦧";
var vangrt$1 = "⦜";
var varepsilon$1 = "ϵ";
var varkappa$1 = "ϰ";
var varnothing$1 = "∅";
var varphi$1 = "ϕ";
var varpi$1 = "ϖ";
var varpropto$1 = "∝";
var varr$1 = "↕";
var vArr$1 = "⇕";
var varrho$1 = "ϱ";
var varsigma$1 = "ς";
var varsubsetneq$1 = "⊊︀";
var varsubsetneqq$1 = "⫋︀";
var varsupsetneq$1 = "⊋︀";
var varsupsetneqq$1 = "⫌︀";
var vartheta$1 = "ϑ";
var vartriangleleft$1 = "⊲";
var vartriangleright$1 = "⊳";
var vBar$1 = "⫨";
var Vbar$1 = "⫫";
var vBarv$1 = "⫩";
var Vcy$1 = "В";
var vcy$1 = "в";
var vdash$1 = "⊢";
var vDash$1 = "⊨";
var Vdash$1 = "⊩";
var VDash$1 = "⊫";
var Vdashl$1 = "⫦";
var veebar$1 = "⊻";
var vee$1 = "∨";
var Vee$1 = "⋁";
var veeeq$1 = "≚";
var vellip$1 = "⋮";
var verbar$1 = "|";
var Verbar$1 = "‖";
var vert$1 = "|";
var Vert$1 = "‖";
var VerticalBar$1 = "∣";
var VerticalLine$1 = "|";
var VerticalSeparator$1 = "❘";
var VerticalTilde$1 = "≀";
var VeryThinSpace$1 = " ";
var Vfr$1 = "𝔙";
var vfr$1 = "𝔳";
var vltri$1 = "⊲";
var vnsub$1 = "⊂⃒";
var vnsup$1 = "⊃⃒";
var Vopf$1 = "𝕍";
var vopf$1 = "𝕧";
var vprop$1 = "∝";
var vrtri$1 = "⊳";
var Vscr$1 = "𝒱";
var vscr$1 = "𝓋";
var vsubnE$1 = "⫋︀";
var vsubne$1 = "⊊︀";
var vsupnE$1 = "⫌︀";
var vsupne$1 = "⊋︀";
var Vvdash$1 = "⊪";
var vzigzag$1 = "⦚";
var Wcirc$1 = "Ŵ";
var wcirc$1 = "ŵ";
var wedbar$1 = "⩟";
var wedge$1 = "∧";
var Wedge$1 = "⋀";
var wedgeq$1 = "≙";
var weierp$1 = "℘";
var Wfr$1 = "𝔚";
var wfr$1 = "𝔴";
var Wopf$1 = "𝕎";
var wopf$1 = "𝕨";
var wp$1 = "℘";
var wr$1 = "≀";
var wreath$1 = "≀";
var Wscr$1 = "𝒲";
var wscr$1 = "𝓌";
var xcap$1 = "⋂";
var xcirc$1 = "◯";
var xcup$1 = "⋃";
var xdtri$1 = "▽";
var Xfr$1 = "𝔛";
var xfr$1 = "𝔵";
var xharr$1 = "⟷";
var xhArr$1 = "⟺";
var Xi$1 = "Ξ";
var xi$1 = "ξ";
var xlarr$1 = "⟵";
var xlArr$1 = "⟸";
var xmap$1 = "⟼";
var xnis$1 = "⋻";
var xodot$1 = "⨀";
var Xopf$1 = "𝕏";
var xopf$1 = "𝕩";
var xoplus$1 = "⨁";
var xotime$1 = "⨂";
var xrarr$1 = "⟶";
var xrArr$1 = "⟹";
var Xscr$1 = "𝒳";
var xscr$1 = "𝓍";
var xsqcup$1 = "⨆";
var xuplus$1 = "⨄";
var xutri$1 = "△";
var xvee$1 = "⋁";
var xwedge$1 = "⋀";
var Yacute$3 = "Ý";
var yacute$3 = "ý";
var YAcy$1 = "Я";
var yacy$1 = "я";
var Ycirc$1 = "Ŷ";
var ycirc$1 = "ŷ";
var Ycy$1 = "Ы";
var ycy$1 = "ы";
var yen$3 = "¥";
var Yfr$1 = "𝔜";
var yfr$1 = "𝔶";
var YIcy$1 = "Ї";
var yicy$1 = "ї";
var Yopf$1 = "𝕐";
var yopf$1 = "𝕪";
var Yscr$1 = "𝒴";
var yscr$1 = "𝓎";
var YUcy$1 = "Ю";
var yucy$1 = "ю";
var yuml$3 = "ÿ";
var Yuml$1 = "Ÿ";
var Zacute$1 = "Ź";
var zacute$1 = "ź";
var Zcaron$1 = "Ž";
var zcaron$1 = "ž";
var Zcy$1 = "З";
var zcy$1 = "з";
var Zdot$1 = "Ż";
var zdot$1 = "ż";
var zeetrf$1 = "ℨ";
var ZeroWidthSpace$1 = "​";
var Zeta$1 = "Ζ";
var zeta$1 = "ζ";
var zfr$1 = "𝔷";
var Zfr$1 = "ℨ";
var ZHcy$1 = "Ж";
var zhcy$1 = "ж";
var zigrarr$1 = "⇝";
var zopf$1 = "𝕫";
var Zopf$1 = "ℤ";
var Zscr$1 = "𝒵";
var zscr$1 = "𝓏";
var zwj$1 = "‍";
var zwnj$1 = "‌";
var require$$1$2 = {
	Aacute: Aacute$3,
	aacute: aacute$3,
	Abreve: Abreve$1,
	abreve: abreve$1,
	ac: ac$1,
	acd: acd$1,
	acE: acE$1,
	Acirc: Acirc$3,
	acirc: acirc$3,
	acute: acute$3,
	Acy: Acy$1,
	acy: acy$1,
	AElig: AElig$3,
	aelig: aelig$3,
	af: af$1,
	Afr: Afr$1,
	afr: afr$1,
	Agrave: Agrave$3,
	agrave: agrave$3,
	alefsym: alefsym$1,
	aleph: aleph$1,
	Alpha: Alpha$1,
	alpha: alpha$1,
	Amacr: Amacr$1,
	amacr: amacr$1,
	amalg: amalg$1,
	amp: amp$5,
	AMP: AMP$3,
	andand: andand$1,
	And: And$1,
	and: and$1,
	andd: andd$1,
	andslope: andslope$1,
	andv: andv$1,
	ang: ang$1,
	ange: ange$1,
	angle: angle$1,
	angmsdaa: angmsdaa$1,
	angmsdab: angmsdab$1,
	angmsdac: angmsdac$1,
	angmsdad: angmsdad$1,
	angmsdae: angmsdae$1,
	angmsdaf: angmsdaf$1,
	angmsdag: angmsdag$1,
	angmsdah: angmsdah$1,
	angmsd: angmsd$1,
	angrt: angrt$1,
	angrtvb: angrtvb$1,
	angrtvbd: angrtvbd$1,
	angsph: angsph$1,
	angst: angst$1,
	angzarr: angzarr$1,
	Aogon: Aogon$1,
	aogon: aogon$1,
	Aopf: Aopf$1,
	aopf: aopf$1,
	apacir: apacir$1,
	ap: ap$1,
	apE: apE$1,
	ape: ape$1,
	apid: apid$1,
	apos: apos$3,
	ApplyFunction: ApplyFunction$1,
	approx: approx$1,
	approxeq: approxeq$1,
	Aring: Aring$3,
	aring: aring$3,
	Ascr: Ascr$1,
	ascr: ascr$1,
	Assign: Assign$1,
	ast: ast$1,
	asymp: asymp$1,
	asympeq: asympeq$1,
	Atilde: Atilde$3,
	atilde: atilde$3,
	Auml: Auml$3,
	auml: auml$3,
	awconint: awconint$1,
	awint: awint$1,
	backcong: backcong$1,
	backepsilon: backepsilon$1,
	backprime: backprime$1,
	backsim: backsim$1,
	backsimeq: backsimeq$1,
	Backslash: Backslash$1,
	Barv: Barv$1,
	barvee: barvee$1,
	barwed: barwed$1,
	Barwed: Barwed$1,
	barwedge: barwedge$1,
	bbrk: bbrk$1,
	bbrktbrk: bbrktbrk$1,
	bcong: bcong$1,
	Bcy: Bcy$1,
	bcy: bcy$1,
	bdquo: bdquo$1,
	becaus: becaus$1,
	because: because$1,
	Because: Because$1,
	bemptyv: bemptyv$1,
	bepsi: bepsi$1,
	bernou: bernou$1,
	Bernoullis: Bernoullis$1,
	Beta: Beta$1,
	beta: beta$1,
	beth: beth$1,
	between: between$1,
	Bfr: Bfr$1,
	bfr: bfr$1,
	bigcap: bigcap$1,
	bigcirc: bigcirc$1,
	bigcup: bigcup$1,
	bigodot: bigodot$1,
	bigoplus: bigoplus$1,
	bigotimes: bigotimes$1,
	bigsqcup: bigsqcup$1,
	bigstar: bigstar$1,
	bigtriangledown: bigtriangledown$1,
	bigtriangleup: bigtriangleup$1,
	biguplus: biguplus$1,
	bigvee: bigvee$1,
	bigwedge: bigwedge$1,
	bkarow: bkarow$1,
	blacklozenge: blacklozenge$1,
	blacksquare: blacksquare$1,
	blacktriangle: blacktriangle$1,
	blacktriangledown: blacktriangledown$1,
	blacktriangleleft: blacktriangleleft$1,
	blacktriangleright: blacktriangleright$1,
	blank: blank$1,
	blk12: blk12$1,
	blk14: blk14$1,
	blk34: blk34$1,
	block: block$1,
	bne: bne$1,
	bnequiv: bnequiv$1,
	bNot: bNot$1,
	bnot: bnot$1,
	Bopf: Bopf$1,
	bopf: bopf$1,
	bot: bot$1,
	bottom: bottom$1,
	bowtie: bowtie$1,
	boxbox: boxbox$1,
	boxdl: boxdl$1,
	boxdL: boxdL$1,
	boxDl: boxDl$1,
	boxDL: boxDL$1,
	boxdr: boxdr$1,
	boxdR: boxdR$1,
	boxDr: boxDr$1,
	boxDR: boxDR$1,
	boxh: boxh$1,
	boxH: boxH$1,
	boxhd: boxhd$1,
	boxHd: boxHd$1,
	boxhD: boxhD$1,
	boxHD: boxHD$1,
	boxhu: boxhu$1,
	boxHu: boxHu$1,
	boxhU: boxhU$1,
	boxHU: boxHU$1,
	boxminus: boxminus$1,
	boxplus: boxplus$1,
	boxtimes: boxtimes$1,
	boxul: boxul$1,
	boxuL: boxuL$1,
	boxUl: boxUl$1,
	boxUL: boxUL$1,
	boxur: boxur$1,
	boxuR: boxuR$1,
	boxUr: boxUr$1,
	boxUR: boxUR$1,
	boxv: boxv$1,
	boxV: boxV$1,
	boxvh: boxvh$1,
	boxvH: boxvH$1,
	boxVh: boxVh$1,
	boxVH: boxVH$1,
	boxvl: boxvl$1,
	boxvL: boxvL$1,
	boxVl: boxVl$1,
	boxVL: boxVL$1,
	boxvr: boxvr$1,
	boxvR: boxvR$1,
	boxVr: boxVr$1,
	boxVR: boxVR$1,
	bprime: bprime$1,
	breve: breve$1,
	Breve: Breve$1,
	brvbar: brvbar$3,
	bscr: bscr$1,
	Bscr: Bscr$1,
	bsemi: bsemi$1,
	bsim: bsim$1,
	bsime: bsime$1,
	bsolb: bsolb$1,
	bsol: bsol$1,
	bsolhsub: bsolhsub$1,
	bull: bull$1,
	bullet: bullet$1,
	bump: bump$1,
	bumpE: bumpE$1,
	bumpe: bumpe$1,
	Bumpeq: Bumpeq$1,
	bumpeq: bumpeq$1,
	Cacute: Cacute$1,
	cacute: cacute$1,
	capand: capand$1,
	capbrcup: capbrcup$1,
	capcap: capcap$1,
	cap: cap$1,
	Cap: Cap$1,
	capcup: capcup$1,
	capdot: capdot$1,
	CapitalDifferentialD: CapitalDifferentialD$1,
	caps: caps$1,
	caret: caret$1,
	caron: caron$1,
	Cayleys: Cayleys$1,
	ccaps: ccaps$1,
	Ccaron: Ccaron$1,
	ccaron: ccaron$1,
	Ccedil: Ccedil$3,
	ccedil: ccedil$3,
	Ccirc: Ccirc$1,
	ccirc: ccirc$1,
	Cconint: Cconint$1,
	ccups: ccups$1,
	ccupssm: ccupssm$1,
	Cdot: Cdot$1,
	cdot: cdot$1,
	cedil: cedil$3,
	Cedilla: Cedilla$1,
	cemptyv: cemptyv$1,
	cent: cent$3,
	centerdot: centerdot$1,
	CenterDot: CenterDot$1,
	cfr: cfr$1,
	Cfr: Cfr$1,
	CHcy: CHcy$1,
	chcy: chcy$1,
	check: check$1,
	checkmark: checkmark$1,
	Chi: Chi$1,
	chi: chi$1,
	circ: circ$1,
	circeq: circeq$1,
	circlearrowleft: circlearrowleft$1,
	circlearrowright: circlearrowright$1,
	circledast: circledast$1,
	circledcirc: circledcirc$1,
	circleddash: circleddash$1,
	CircleDot: CircleDot$1,
	circledR: circledR$1,
	circledS: circledS$1,
	CircleMinus: CircleMinus$1,
	CirclePlus: CirclePlus$1,
	CircleTimes: CircleTimes$1,
	cir: cir$1,
	cirE: cirE$1,
	cire: cire$1,
	cirfnint: cirfnint$1,
	cirmid: cirmid$1,
	cirscir: cirscir$1,
	ClockwiseContourIntegral: ClockwiseContourIntegral$1,
	CloseCurlyDoubleQuote: CloseCurlyDoubleQuote$1,
	CloseCurlyQuote: CloseCurlyQuote$1,
	clubs: clubs$1,
	clubsuit: clubsuit$1,
	colon: colon$1,
	Colon: Colon$1,
	Colone: Colone$1,
	colone: colone$1,
	coloneq: coloneq$1,
	comma: comma$1,
	commat: commat$1,
	comp: comp$1,
	compfn: compfn$1,
	complement: complement$1,
	complexes: complexes$1,
	cong: cong$1,
	congdot: congdot$1,
	Congruent: Congruent$1,
	conint: conint$1,
	Conint: Conint$1,
	ContourIntegral: ContourIntegral$1,
	copf: copf$1,
	Copf: Copf$1,
	coprod: coprod$1,
	Coproduct: Coproduct$1,
	copy: copy$4,
	COPY: COPY$3,
	copysr: copysr$1,
	CounterClockwiseContourIntegral: CounterClockwiseContourIntegral$1,
	crarr: crarr$1,
	cross: cross$1,
	Cross: Cross$1,
	Cscr: Cscr$1,
	cscr: cscr$1,
	csub: csub$1,
	csube: csube$1,
	csup: csup$1,
	csupe: csupe$1,
	ctdot: ctdot$1,
	cudarrl: cudarrl$1,
	cudarrr: cudarrr$1,
	cuepr: cuepr$1,
	cuesc: cuesc$1,
	cularr: cularr$1,
	cularrp: cularrp$1,
	cupbrcap: cupbrcap$1,
	cupcap: cupcap$1,
	CupCap: CupCap$1,
	cup: cup$1,
	Cup: Cup$1,
	cupcup: cupcup$1,
	cupdot: cupdot$1,
	cupor: cupor$1,
	cups: cups$1,
	curarr: curarr$1,
	curarrm: curarrm$1,
	curlyeqprec: curlyeqprec$1,
	curlyeqsucc: curlyeqsucc$1,
	curlyvee: curlyvee$1,
	curlywedge: curlywedge$1,
	curren: curren$3,
	curvearrowleft: curvearrowleft$1,
	curvearrowright: curvearrowright$1,
	cuvee: cuvee$1,
	cuwed: cuwed$1,
	cwconint: cwconint$1,
	cwint: cwint$1,
	cylcty: cylcty$1,
	dagger: dagger$1,
	Dagger: Dagger$1,
	daleth: daleth$1,
	darr: darr$1,
	Darr: Darr$1,
	dArr: dArr$1,
	dash: dash$1,
	Dashv: Dashv$1,
	dashv: dashv$1,
	dbkarow: dbkarow$1,
	dblac: dblac$1,
	Dcaron: Dcaron$1,
	dcaron: dcaron$1,
	Dcy: Dcy$1,
	dcy: dcy$1,
	ddagger: ddagger$1,
	ddarr: ddarr$1,
	DD: DD$1,
	dd: dd$1,
	DDotrahd: DDotrahd$1,
	ddotseq: ddotseq$1,
	deg: deg$3,
	Del: Del$1,
	Delta: Delta$1,
	delta: delta$1,
	demptyv: demptyv$1,
	dfisht: dfisht$1,
	Dfr: Dfr$1,
	dfr: dfr$1,
	dHar: dHar$1,
	dharl: dharl$1,
	dharr: dharr$1,
	DiacriticalAcute: DiacriticalAcute$1,
	DiacriticalDot: DiacriticalDot$1,
	DiacriticalDoubleAcute: DiacriticalDoubleAcute$1,
	DiacriticalGrave: DiacriticalGrave$1,
	DiacriticalTilde: DiacriticalTilde$1,
	diam: diam$1,
	diamond: diamond$1,
	Diamond: Diamond$1,
	diamondsuit: diamondsuit$1,
	diams: diams$1,
	die: die$1,
	DifferentialD: DifferentialD$1,
	digamma: digamma$1,
	disin: disin$1,
	div: div$2,
	divide: divide$3,
	divideontimes: divideontimes$1,
	divonx: divonx$1,
	DJcy: DJcy$1,
	djcy: djcy$1,
	dlcorn: dlcorn$1,
	dlcrop: dlcrop$1,
	dollar: dollar$1,
	Dopf: Dopf$1,
	dopf: dopf$1,
	Dot: Dot$1,
	dot: dot$2,
	DotDot: DotDot$1,
	doteq: doteq$1,
	doteqdot: doteqdot$1,
	DotEqual: DotEqual$1,
	dotminus: dotminus$1,
	dotplus: dotplus$1,
	dotsquare: dotsquare$1,
	doublebarwedge: doublebarwedge$1,
	DoubleContourIntegral: DoubleContourIntegral$1,
	DoubleDot: DoubleDot$1,
	DoubleDownArrow: DoubleDownArrow$1,
	DoubleLeftArrow: DoubleLeftArrow$1,
	DoubleLeftRightArrow: DoubleLeftRightArrow$1,
	DoubleLeftTee: DoubleLeftTee$1,
	DoubleLongLeftArrow: DoubleLongLeftArrow$1,
	DoubleLongLeftRightArrow: DoubleLongLeftRightArrow$1,
	DoubleLongRightArrow: DoubleLongRightArrow$1,
	DoubleRightArrow: DoubleRightArrow$1,
	DoubleRightTee: DoubleRightTee$1,
	DoubleUpArrow: DoubleUpArrow$1,
	DoubleUpDownArrow: DoubleUpDownArrow$1,
	DoubleVerticalBar: DoubleVerticalBar$1,
	DownArrowBar: DownArrowBar$1,
	downarrow: downarrow$1,
	DownArrow: DownArrow$1,
	Downarrow: Downarrow$1,
	DownArrowUpArrow: DownArrowUpArrow$1,
	DownBreve: DownBreve$1,
	downdownarrows: downdownarrows$1,
	downharpoonleft: downharpoonleft$1,
	downharpoonright: downharpoonright$1,
	DownLeftRightVector: DownLeftRightVector$1,
	DownLeftTeeVector: DownLeftTeeVector$1,
	DownLeftVectorBar: DownLeftVectorBar$1,
	DownLeftVector: DownLeftVector$1,
	DownRightTeeVector: DownRightTeeVector$1,
	DownRightVectorBar: DownRightVectorBar$1,
	DownRightVector: DownRightVector$1,
	DownTeeArrow: DownTeeArrow$1,
	DownTee: DownTee$1,
	drbkarow: drbkarow$1,
	drcorn: drcorn$1,
	drcrop: drcrop$1,
	Dscr: Dscr$1,
	dscr: dscr$1,
	DScy: DScy$1,
	dscy: dscy$1,
	dsol: dsol$1,
	Dstrok: Dstrok$1,
	dstrok: dstrok$1,
	dtdot: dtdot$1,
	dtri: dtri$1,
	dtrif: dtrif$1,
	duarr: duarr$1,
	duhar: duhar$1,
	dwangle: dwangle$1,
	DZcy: DZcy$1,
	dzcy: dzcy$1,
	dzigrarr: dzigrarr$1,
	Eacute: Eacute$3,
	eacute: eacute$3,
	easter: easter$1,
	Ecaron: Ecaron$1,
	ecaron: ecaron$1,
	Ecirc: Ecirc$3,
	ecirc: ecirc$3,
	ecir: ecir$1,
	ecolon: ecolon$1,
	Ecy: Ecy$1,
	ecy: ecy$1,
	eDDot: eDDot$1,
	Edot: Edot$1,
	edot: edot$1,
	eDot: eDot$1,
	ee: ee$1,
	efDot: efDot$1,
	Efr: Efr$1,
	efr: efr$1,
	eg: eg$1,
	Egrave: Egrave$3,
	egrave: egrave$3,
	egs: egs$1,
	egsdot: egsdot$1,
	el: el$1,
	Element: Element$6,
	elinters: elinters$1,
	ell: ell$1,
	els: els$1,
	elsdot: elsdot$1,
	Emacr: Emacr$1,
	emacr: emacr$1,
	empty: empty$3,
	emptyset: emptyset$1,
	EmptySmallSquare: EmptySmallSquare$1,
	emptyv: emptyv$1,
	EmptyVerySmallSquare: EmptyVerySmallSquare$1,
	emsp13: emsp13$1,
	emsp14: emsp14$1,
	emsp: emsp$1,
	ENG: ENG$1,
	eng: eng$1,
	ensp: ensp$1,
	Eogon: Eogon$1,
	eogon: eogon$1,
	Eopf: Eopf$1,
	eopf: eopf$1,
	epar: epar$1,
	eparsl: eparsl$1,
	eplus: eplus$1,
	epsi: epsi$1,
	Epsilon: Epsilon$1,
	epsilon: epsilon$1,
	epsiv: epsiv$1,
	eqcirc: eqcirc$1,
	eqcolon: eqcolon$1,
	eqsim: eqsim$1,
	eqslantgtr: eqslantgtr$1,
	eqslantless: eqslantless$1,
	Equal: Equal$1,
	equals: equals$1,
	EqualTilde: EqualTilde$1,
	equest: equest$1,
	Equilibrium: Equilibrium$1,
	equiv: equiv$1,
	equivDD: equivDD$1,
	eqvparsl: eqvparsl$1,
	erarr: erarr$1,
	erDot: erDot$1,
	escr: escr$1,
	Escr: Escr$1,
	esdot: esdot$1,
	Esim: Esim$1,
	esim: esim$1,
	Eta: Eta$1,
	eta: eta$1,
	ETH: ETH$3,
	eth: eth$3,
	Euml: Euml$3,
	euml: euml$3,
	euro: euro$1,
	excl: excl$1,
	exist: exist$1,
	Exists: Exists$1,
	expectation: expectation$1,
	exponentiale: exponentiale$1,
	ExponentialE: ExponentialE$1,
	fallingdotseq: fallingdotseq$1,
	Fcy: Fcy$1,
	fcy: fcy$1,
	female: female$1,
	ffilig: ffilig$1,
	fflig: fflig$1,
	ffllig: ffllig$1,
	Ffr: Ffr$1,
	ffr: ffr$1,
	filig: filig$1,
	FilledSmallSquare: FilledSmallSquare$1,
	FilledVerySmallSquare: FilledVerySmallSquare$1,
	fjlig: fjlig$1,
	flat: flat$1,
	fllig: fllig$1,
	fltns: fltns$1,
	fnof: fnof$1,
	Fopf: Fopf$1,
	fopf: fopf$1,
	forall: forall$1,
	ForAll: ForAll$1,
	fork: fork$1,
	forkv: forkv$1,
	Fouriertrf: Fouriertrf$1,
	fpartint: fpartint$1,
	frac12: frac12$3,
	frac13: frac13$1,
	frac14: frac14$3,
	frac15: frac15$1,
	frac16: frac16$1,
	frac18: frac18$1,
	frac23: frac23$1,
	frac25: frac25$1,
	frac34: frac34$3,
	frac35: frac35$1,
	frac38: frac38$1,
	frac45: frac45$1,
	frac56: frac56$1,
	frac58: frac58$1,
	frac78: frac78$1,
	frasl: frasl$1,
	frown: frown$1,
	fscr: fscr$1,
	Fscr: Fscr$1,
	gacute: gacute$1,
	Gamma: Gamma$1,
	gamma: gamma$3,
	Gammad: Gammad$1,
	gammad: gammad$1,
	gap: gap$1,
	Gbreve: Gbreve$1,
	gbreve: gbreve$1,
	Gcedil: Gcedil$1,
	Gcirc: Gcirc$1,
	gcirc: gcirc$1,
	Gcy: Gcy$1,
	gcy: gcy$1,
	Gdot: Gdot$1,
	gdot: gdot$1,
	ge: ge$1,
	gE: gE$1,
	gEl: gEl$1,
	gel: gel$1,
	geq: geq$1,
	geqq: geqq$1,
	geqslant: geqslant$1,
	gescc: gescc$1,
	ges: ges$1,
	gesdot: gesdot$1,
	gesdoto: gesdoto$1,
	gesdotol: gesdotol$1,
	gesl: gesl$1,
	gesles: gesles$1,
	Gfr: Gfr$1,
	gfr: gfr$1,
	gg: gg$1,
	Gg: Gg$1,
	ggg: ggg$1,
	gimel: gimel$1,
	GJcy: GJcy$1,
	gjcy: gjcy$1,
	gla: gla$1,
	gl: gl$1,
	glE: glE$1,
	glj: glj$1,
	gnap: gnap$1,
	gnapprox: gnapprox$1,
	gne: gne$1,
	gnE: gnE$1,
	gneq: gneq$1,
	gneqq: gneqq$1,
	gnsim: gnsim$1,
	Gopf: Gopf$1,
	gopf: gopf$1,
	grave: grave$1,
	GreaterEqual: GreaterEqual$1,
	GreaterEqualLess: GreaterEqualLess$1,
	GreaterFullEqual: GreaterFullEqual$1,
	GreaterGreater: GreaterGreater$1,
	GreaterLess: GreaterLess$1,
	GreaterSlantEqual: GreaterSlantEqual$1,
	GreaterTilde: GreaterTilde$1,
	Gscr: Gscr$1,
	gscr: gscr$1,
	gsim: gsim$1,
	gsime: gsime$1,
	gsiml: gsiml$1,
	gtcc: gtcc$1,
	gtcir: gtcir$1,
	gt: gt$5,
	GT: GT$3,
	Gt: Gt$1,
	gtdot: gtdot$1,
	gtlPar: gtlPar$1,
	gtquest: gtquest$1,
	gtrapprox: gtrapprox$1,
	gtrarr: gtrarr$1,
	gtrdot: gtrdot$1,
	gtreqless: gtreqless$1,
	gtreqqless: gtreqqless$1,
	gtrless: gtrless$1,
	gtrsim: gtrsim$1,
	gvertneqq: gvertneqq$1,
	gvnE: gvnE$1,
	Hacek: Hacek$1,
	hairsp: hairsp$1,
	half: half$1,
	hamilt: hamilt$1,
	HARDcy: HARDcy$1,
	hardcy: hardcy$1,
	harrcir: harrcir$1,
	harr: harr$1,
	hArr: hArr$1,
	harrw: harrw$1,
	Hat: Hat$1,
	hbar: hbar$1,
	Hcirc: Hcirc$1,
	hcirc: hcirc$1,
	hearts: hearts$1,
	heartsuit: heartsuit$1,
	hellip: hellip$1,
	hercon: hercon$1,
	hfr: hfr$1,
	Hfr: Hfr$1,
	HilbertSpace: HilbertSpace$1,
	hksearow: hksearow$1,
	hkswarow: hkswarow$1,
	hoarr: hoarr$1,
	homtht: homtht$1,
	hookleftarrow: hookleftarrow$1,
	hookrightarrow: hookrightarrow$1,
	hopf: hopf$1,
	Hopf: Hopf$1,
	horbar: horbar$1,
	HorizontalLine: HorizontalLine$1,
	hscr: hscr$1,
	Hscr: Hscr$1,
	hslash: hslash$1,
	Hstrok: Hstrok$1,
	hstrok: hstrok$1,
	HumpDownHump: HumpDownHump$1,
	HumpEqual: HumpEqual$1,
	hybull: hybull$1,
	hyphen: hyphen$1,
	Iacute: Iacute$3,
	iacute: iacute$3,
	ic: ic$1,
	Icirc: Icirc$3,
	icirc: icirc$3,
	Icy: Icy$1,
	icy: icy$1,
	Idot: Idot$1,
	IEcy: IEcy$1,
	iecy: iecy$1,
	iexcl: iexcl$3,
	iff: iff$1,
	ifr: ifr$1,
	Ifr: Ifr$1,
	Igrave: Igrave$3,
	igrave: igrave$3,
	ii: ii$1,
	iiiint: iiiint$1,
	iiint: iiint$1,
	iinfin: iinfin$1,
	iiota: iiota$1,
	IJlig: IJlig$1,
	ijlig: ijlig$1,
	Imacr: Imacr$1,
	imacr: imacr$1,
	image: image$1,
	ImaginaryI: ImaginaryI$1,
	imagline: imagline$1,
	imagpart: imagpart$1,
	imath: imath$1,
	Im: Im$1,
	imof: imof$1,
	imped: imped$1,
	Implies: Implies$1,
	incare: incare$1,
	"in": "∈",
	infin: infin$1,
	infintie: infintie$1,
	inodot: inodot$1,
	intcal: intcal$1,
	int: int$1,
	Int: Int$1,
	integers: integers$1,
	Integral: Integral$1,
	intercal: intercal$1,
	Intersection: Intersection$1,
	intlarhk: intlarhk$1,
	intprod: intprod$1,
	InvisibleComma: InvisibleComma$1,
	InvisibleTimes: InvisibleTimes$1,
	IOcy: IOcy$1,
	iocy: iocy$1,
	Iogon: Iogon$1,
	iogon: iogon$1,
	Iopf: Iopf$1,
	iopf: iopf$1,
	Iota: Iota$1,
	iota: iota$1,
	iprod: iprod$1,
	iquest: iquest$3,
	iscr: iscr$1,
	Iscr: Iscr$1,
	isin: isin$1,
	isindot: isindot$1,
	isinE: isinE$1,
	isins: isins$1,
	isinsv: isinsv$1,
	isinv: isinv$1,
	it: it$1,
	Itilde: Itilde$1,
	itilde: itilde$1,
	Iukcy: Iukcy$1,
	iukcy: iukcy$1,
	Iuml: Iuml$3,
	iuml: iuml$3,
	Jcirc: Jcirc$1,
	jcirc: jcirc$1,
	Jcy: Jcy$1,
	jcy: jcy$1,
	Jfr: Jfr$1,
	jfr: jfr$1,
	jmath: jmath$1,
	Jopf: Jopf$1,
	jopf: jopf$1,
	Jscr: Jscr$1,
	jscr: jscr$1,
	Jsercy: Jsercy$1,
	jsercy: jsercy$1,
	Jukcy: Jukcy$1,
	jukcy: jukcy$1,
	Kappa: Kappa$1,
	kappa: kappa$1,
	kappav: kappav$1,
	Kcedil: Kcedil$1,
	kcedil: kcedil$1,
	Kcy: Kcy$1,
	kcy: kcy$1,
	Kfr: Kfr$1,
	kfr: kfr$1,
	kgreen: kgreen$1,
	KHcy: KHcy$1,
	khcy: khcy$1,
	KJcy: KJcy$1,
	kjcy: kjcy$1,
	Kopf: Kopf$1,
	kopf: kopf$1,
	Kscr: Kscr$1,
	kscr: kscr$1,
	lAarr: lAarr$1,
	Lacute: Lacute$1,
	lacute: lacute$1,
	laemptyv: laemptyv$1,
	lagran: lagran$1,
	Lambda: Lambda$1,
	lambda: lambda$1,
	lang: lang$1,
	Lang: Lang$1,
	langd: langd$1,
	langle: langle$1,
	lap: lap$1,
	Laplacetrf: Laplacetrf$1,
	laquo: laquo$3,
	larrb: larrb$1,
	larrbfs: larrbfs$1,
	larr: larr$1,
	Larr: Larr$1,
	lArr: lArr$1,
	larrfs: larrfs$1,
	larrhk: larrhk$1,
	larrlp: larrlp$1,
	larrpl: larrpl$1,
	larrsim: larrsim$1,
	larrtl: larrtl$1,
	latail: latail$1,
	lAtail: lAtail$1,
	lat: lat$1,
	late: late$1,
	lates: lates$1,
	lbarr: lbarr$1,
	lBarr: lBarr$1,
	lbbrk: lbbrk$1,
	lbrace: lbrace$1,
	lbrack: lbrack$1,
	lbrke: lbrke$1,
	lbrksld: lbrksld$1,
	lbrkslu: lbrkslu$1,
	Lcaron: Lcaron$1,
	lcaron: lcaron$1,
	Lcedil: Lcedil$1,
	lcedil: lcedil$1,
	lceil: lceil$1,
	lcub: lcub$1,
	Lcy: Lcy$1,
	lcy: lcy$1,
	ldca: ldca$1,
	ldquo: ldquo$1,
	ldquor: ldquor$1,
	ldrdhar: ldrdhar$1,
	ldrushar: ldrushar$1,
	ldsh: ldsh$1,
	le: le$1,
	lE: lE$1,
	LeftAngleBracket: LeftAngleBracket$1,
	LeftArrowBar: LeftArrowBar$1,
	leftarrow: leftarrow$1,
	LeftArrow: LeftArrow$1,
	Leftarrow: Leftarrow$1,
	LeftArrowRightArrow: LeftArrowRightArrow$1,
	leftarrowtail: leftarrowtail$1,
	LeftCeiling: LeftCeiling$1,
	LeftDoubleBracket: LeftDoubleBracket$1,
	LeftDownTeeVector: LeftDownTeeVector$1,
	LeftDownVectorBar: LeftDownVectorBar$1,
	LeftDownVector: LeftDownVector$1,
	LeftFloor: LeftFloor$1,
	leftharpoondown: leftharpoondown$1,
	leftharpoonup: leftharpoonup$1,
	leftleftarrows: leftleftarrows$1,
	leftrightarrow: leftrightarrow$1,
	LeftRightArrow: LeftRightArrow$1,
	Leftrightarrow: Leftrightarrow$1,
	leftrightarrows: leftrightarrows$1,
	leftrightharpoons: leftrightharpoons$1,
	leftrightsquigarrow: leftrightsquigarrow$1,
	LeftRightVector: LeftRightVector$1,
	LeftTeeArrow: LeftTeeArrow$1,
	LeftTee: LeftTee$1,
	LeftTeeVector: LeftTeeVector$1,
	leftthreetimes: leftthreetimes$1,
	LeftTriangleBar: LeftTriangleBar$1,
	LeftTriangle: LeftTriangle$1,
	LeftTriangleEqual: LeftTriangleEqual$1,
	LeftUpDownVector: LeftUpDownVector$1,
	LeftUpTeeVector: LeftUpTeeVector$1,
	LeftUpVectorBar: LeftUpVectorBar$1,
	LeftUpVector: LeftUpVector$1,
	LeftVectorBar: LeftVectorBar$1,
	LeftVector: LeftVector$1,
	lEg: lEg$1,
	leg: leg$1,
	leq: leq$1,
	leqq: leqq$1,
	leqslant: leqslant$1,
	lescc: lescc$1,
	les: les$1,
	lesdot: lesdot$1,
	lesdoto: lesdoto$1,
	lesdotor: lesdotor$1,
	lesg: lesg$1,
	lesges: lesges$1,
	lessapprox: lessapprox$1,
	lessdot: lessdot$1,
	lesseqgtr: lesseqgtr$1,
	lesseqqgtr: lesseqqgtr$1,
	LessEqualGreater: LessEqualGreater$1,
	LessFullEqual: LessFullEqual$1,
	LessGreater: LessGreater$1,
	lessgtr: lessgtr$1,
	LessLess: LessLess$1,
	lesssim: lesssim$1,
	LessSlantEqual: LessSlantEqual$1,
	LessTilde: LessTilde$1,
	lfisht: lfisht$1,
	lfloor: lfloor$1,
	Lfr: Lfr$1,
	lfr: lfr$1,
	lg: lg$1,
	lgE: lgE$1,
	lHar: lHar$1,
	lhard: lhard$1,
	lharu: lharu$1,
	lharul: lharul$1,
	lhblk: lhblk$1,
	LJcy: LJcy$1,
	ljcy: ljcy$1,
	llarr: llarr$1,
	ll: ll$1,
	Ll: Ll$1,
	llcorner: llcorner$1,
	Lleftarrow: Lleftarrow$1,
	llhard: llhard$1,
	lltri: lltri$1,
	Lmidot: Lmidot$1,
	lmidot: lmidot$1,
	lmoustache: lmoustache$1,
	lmoust: lmoust$1,
	lnap: lnap$1,
	lnapprox: lnapprox$1,
	lne: lne$1,
	lnE: lnE$1,
	lneq: lneq$1,
	lneqq: lneqq$1,
	lnsim: lnsim$1,
	loang: loang$1,
	loarr: loarr$1,
	lobrk: lobrk$1,
	longleftarrow: longleftarrow$1,
	LongLeftArrow: LongLeftArrow$1,
	Longleftarrow: Longleftarrow$1,
	longleftrightarrow: longleftrightarrow$1,
	LongLeftRightArrow: LongLeftRightArrow$1,
	Longleftrightarrow: Longleftrightarrow$1,
	longmapsto: longmapsto$1,
	longrightarrow: longrightarrow$1,
	LongRightArrow: LongRightArrow$1,
	Longrightarrow: Longrightarrow$1,
	looparrowleft: looparrowleft$1,
	looparrowright: looparrowright$1,
	lopar: lopar$1,
	Lopf: Lopf$1,
	lopf: lopf$1,
	loplus: loplus$1,
	lotimes: lotimes$1,
	lowast: lowast$1,
	lowbar: lowbar$1,
	LowerLeftArrow: LowerLeftArrow$1,
	LowerRightArrow: LowerRightArrow$1,
	loz: loz$1,
	lozenge: lozenge$1,
	lozf: lozf$1,
	lpar: lpar$1,
	lparlt: lparlt$1,
	lrarr: lrarr$1,
	lrcorner: lrcorner$1,
	lrhar: lrhar$1,
	lrhard: lrhard$1,
	lrm: lrm$1,
	lrtri: lrtri$1,
	lsaquo: lsaquo$1,
	lscr: lscr$1,
	Lscr: Lscr$1,
	lsh: lsh$1,
	Lsh: Lsh$1,
	lsim: lsim$1,
	lsime: lsime$1,
	lsimg: lsimg$1,
	lsqb: lsqb$1,
	lsquo: lsquo$1,
	lsquor: lsquor$1,
	Lstrok: Lstrok$1,
	lstrok: lstrok$1,
	ltcc: ltcc$1,
	ltcir: ltcir$1,
	lt: lt$5,
	LT: LT$3,
	Lt: Lt$1,
	ltdot: ltdot$1,
	lthree: lthree$1,
	ltimes: ltimes$1,
	ltlarr: ltlarr$1,
	ltquest: ltquest$1,
	ltri: ltri$1,
	ltrie: ltrie$1,
	ltrif: ltrif$1,
	ltrPar: ltrPar$1,
	lurdshar: lurdshar$1,
	luruhar: luruhar$1,
	lvertneqq: lvertneqq$1,
	lvnE: lvnE$1,
	macr: macr$3,
	male: male$1,
	malt: malt$1,
	maltese: maltese$1,
	"Map": "⤅",
	map: map$4,
	mapsto: mapsto$1,
	mapstodown: mapstodown$1,
	mapstoleft: mapstoleft$1,
	mapstoup: mapstoup$1,
	marker: marker$1,
	mcomma: mcomma$1,
	Mcy: Mcy$1,
	mcy: mcy$1,
	mdash: mdash$1,
	mDDot: mDDot$1,
	measuredangle: measuredangle$1,
	MediumSpace: MediumSpace$1,
	Mellintrf: Mellintrf$1,
	Mfr: Mfr$1,
	mfr: mfr$1,
	mho: mho$1,
	micro: micro$3,
	midast: midast$1,
	midcir: midcir$1,
	mid: mid$1,
	middot: middot$3,
	minusb: minusb$1,
	minus: minus$1,
	minusd: minusd$1,
	minusdu: minusdu$1,
	MinusPlus: MinusPlus$1,
	mlcp: mlcp$1,
	mldr: mldr$1,
	mnplus: mnplus$1,
	models: models$1,
	Mopf: Mopf$1,
	mopf: mopf$1,
	mp: mp$1,
	mscr: mscr$1,
	Mscr: Mscr$1,
	mstpos: mstpos$1,
	Mu: Mu$1,
	mu: mu$1,
	multimap: multimap$1,
	mumap: mumap$1,
	nabla: nabla$1,
	Nacute: Nacute$1,
	nacute: nacute$1,
	nang: nang$1,
	nap: nap$2,
	napE: napE$1,
	napid: napid$1,
	napos: napos$1,
	napprox: napprox$1,
	natural: natural$1,
	naturals: naturals$1,
	natur: natur$1,
	nbsp: nbsp$3,
	nbump: nbump$1,
	nbumpe: nbumpe$1,
	ncap: ncap$1,
	Ncaron: Ncaron$1,
	ncaron: ncaron$1,
	Ncedil: Ncedil$1,
	ncedil: ncedil$1,
	ncong: ncong$1,
	ncongdot: ncongdot$1,
	ncup: ncup$1,
	Ncy: Ncy$1,
	ncy: ncy$1,
	ndash: ndash$1,
	nearhk: nearhk$1,
	nearr: nearr$1,
	neArr: neArr$1,
	nearrow: nearrow$1,
	ne: ne$1,
	nedot: nedot$1,
	NegativeMediumSpace: NegativeMediumSpace$1,
	NegativeThickSpace: NegativeThickSpace$1,
	NegativeThinSpace: NegativeThinSpace$1,
	NegativeVeryThinSpace: NegativeVeryThinSpace$1,
	nequiv: nequiv$1,
	nesear: nesear$1,
	nesim: nesim$1,
	NestedGreaterGreater: NestedGreaterGreater$1,
	NestedLessLess: NestedLessLess$1,
	NewLine: NewLine$1,
	nexist: nexist$1,
	nexists: nexists$1,
	Nfr: Nfr$1,
	nfr: nfr$1,
	ngE: ngE$1,
	nge: nge$1,
	ngeq: ngeq$1,
	ngeqq: ngeqq$1,
	ngeqslant: ngeqslant$1,
	nges: nges$1,
	nGg: nGg$1,
	ngsim: ngsim$1,
	nGt: nGt$1,
	ngt: ngt$1,
	ngtr: ngtr$1,
	nGtv: nGtv$1,
	nharr: nharr$1,
	nhArr: nhArr$1,
	nhpar: nhpar$1,
	ni: ni$1,
	nis: nis$1,
	nisd: nisd$1,
	niv: niv$1,
	NJcy: NJcy$1,
	njcy: njcy$1,
	nlarr: nlarr$1,
	nlArr: nlArr$1,
	nldr: nldr$1,
	nlE: nlE$1,
	nle: nle$1,
	nleftarrow: nleftarrow$1,
	nLeftarrow: nLeftarrow$1,
	nleftrightarrow: nleftrightarrow$1,
	nLeftrightarrow: nLeftrightarrow$1,
	nleq: nleq$1,
	nleqq: nleqq$1,
	nleqslant: nleqslant$1,
	nles: nles$1,
	nless: nless$1,
	nLl: nLl$1,
	nlsim: nlsim$1,
	nLt: nLt$1,
	nlt: nlt$1,
	nltri: nltri$1,
	nltrie: nltrie$1,
	nLtv: nLtv$1,
	nmid: nmid$1,
	NoBreak: NoBreak$1,
	NonBreakingSpace: NonBreakingSpace$1,
	nopf: nopf$1,
	Nopf: Nopf$1,
	Not: Not$1,
	not: not$3,
	NotCongruent: NotCongruent$1,
	NotCupCap: NotCupCap$1,
	NotDoubleVerticalBar: NotDoubleVerticalBar$1,
	NotElement: NotElement$1,
	NotEqual: NotEqual$1,
	NotEqualTilde: NotEqualTilde$1,
	NotExists: NotExists$1,
	NotGreater: NotGreater$1,
	NotGreaterEqual: NotGreaterEqual$1,
	NotGreaterFullEqual: NotGreaterFullEqual$1,
	NotGreaterGreater: NotGreaterGreater$1,
	NotGreaterLess: NotGreaterLess$1,
	NotGreaterSlantEqual: NotGreaterSlantEqual$1,
	NotGreaterTilde: NotGreaterTilde$1,
	NotHumpDownHump: NotHumpDownHump$1,
	NotHumpEqual: NotHumpEqual$1,
	notin: notin$1,
	notindot: notindot$1,
	notinE: notinE$1,
	notinva: notinva$1,
	notinvb: notinvb$1,
	notinvc: notinvc$1,
	NotLeftTriangleBar: NotLeftTriangleBar$1,
	NotLeftTriangle: NotLeftTriangle$1,
	NotLeftTriangleEqual: NotLeftTriangleEqual$1,
	NotLess: NotLess$1,
	NotLessEqual: NotLessEqual$1,
	NotLessGreater: NotLessGreater$1,
	NotLessLess: NotLessLess$1,
	NotLessSlantEqual: NotLessSlantEqual$1,
	NotLessTilde: NotLessTilde$1,
	NotNestedGreaterGreater: NotNestedGreaterGreater$1,
	NotNestedLessLess: NotNestedLessLess$1,
	notni: notni$1,
	notniva: notniva$1,
	notnivb: notnivb$1,
	notnivc: notnivc$1,
	NotPrecedes: NotPrecedes$1,
	NotPrecedesEqual: NotPrecedesEqual$1,
	NotPrecedesSlantEqual: NotPrecedesSlantEqual$1,
	NotReverseElement: NotReverseElement$1,
	NotRightTriangleBar: NotRightTriangleBar$1,
	NotRightTriangle: NotRightTriangle$1,
	NotRightTriangleEqual: NotRightTriangleEqual$1,
	NotSquareSubset: NotSquareSubset$1,
	NotSquareSubsetEqual: NotSquareSubsetEqual$1,
	NotSquareSuperset: NotSquareSuperset$1,
	NotSquareSupersetEqual: NotSquareSupersetEqual$1,
	NotSubset: NotSubset$1,
	NotSubsetEqual: NotSubsetEqual$1,
	NotSucceeds: NotSucceeds$1,
	NotSucceedsEqual: NotSucceedsEqual$1,
	NotSucceedsSlantEqual: NotSucceedsSlantEqual$1,
	NotSucceedsTilde: NotSucceedsTilde$1,
	NotSuperset: NotSuperset$1,
	NotSupersetEqual: NotSupersetEqual$1,
	NotTilde: NotTilde$1,
	NotTildeEqual: NotTildeEqual$1,
	NotTildeFullEqual: NotTildeFullEqual$1,
	NotTildeTilde: NotTildeTilde$1,
	NotVerticalBar: NotVerticalBar$1,
	nparallel: nparallel$1,
	npar: npar$1,
	nparsl: nparsl$1,
	npart: npart$1,
	npolint: npolint$1,
	npr: npr$1,
	nprcue: nprcue$1,
	nprec: nprec$1,
	npreceq: npreceq$1,
	npre: npre$1,
	nrarrc: nrarrc$1,
	nrarr: nrarr$1,
	nrArr: nrArr$1,
	nrarrw: nrarrw$1,
	nrightarrow: nrightarrow$1,
	nRightarrow: nRightarrow$1,
	nrtri: nrtri$1,
	nrtrie: nrtrie$1,
	nsc: nsc$1,
	nsccue: nsccue$1,
	nsce: nsce$1,
	Nscr: Nscr$1,
	nscr: nscr$1,
	nshortmid: nshortmid$1,
	nshortparallel: nshortparallel$1,
	nsim: nsim$1,
	nsime: nsime$1,
	nsimeq: nsimeq$1,
	nsmid: nsmid$1,
	nspar: nspar$1,
	nsqsube: nsqsube$1,
	nsqsupe: nsqsupe$1,
	nsub: nsub$1,
	nsubE: nsubE$1,
	nsube: nsube$1,
	nsubset: nsubset$1,
	nsubseteq: nsubseteq$1,
	nsubseteqq: nsubseteqq$1,
	nsucc: nsucc$1,
	nsucceq: nsucceq$1,
	nsup: nsup$1,
	nsupE: nsupE$1,
	nsupe: nsupe$1,
	nsupset: nsupset$1,
	nsupseteq: nsupseteq$1,
	nsupseteqq: nsupseteqq$1,
	ntgl: ntgl$1,
	Ntilde: Ntilde$3,
	ntilde: ntilde$3,
	ntlg: ntlg$1,
	ntriangleleft: ntriangleleft$1,
	ntrianglelefteq: ntrianglelefteq$1,
	ntriangleright: ntriangleright$1,
	ntrianglerighteq: ntrianglerighteq$1,
	Nu: Nu$1,
	nu: nu$1,
	num: num$1,
	numero: numero$1,
	numsp: numsp$1,
	nvap: nvap$1,
	nvdash: nvdash$1,
	nvDash: nvDash$1,
	nVdash: nVdash$1,
	nVDash: nVDash$1,
	nvge: nvge$1,
	nvgt: nvgt$1,
	nvHarr: nvHarr$1,
	nvinfin: nvinfin$1,
	nvlArr: nvlArr$1,
	nvle: nvle$1,
	nvlt: nvlt$1,
	nvltrie: nvltrie$1,
	nvrArr: nvrArr$1,
	nvrtrie: nvrtrie$1,
	nvsim: nvsim$1,
	nwarhk: nwarhk$1,
	nwarr: nwarr$1,
	nwArr: nwArr$1,
	nwarrow: nwarrow$1,
	nwnear: nwnear$1,
	Oacute: Oacute$3,
	oacute: oacute$3,
	oast: oast$1,
	Ocirc: Ocirc$3,
	ocirc: ocirc$3,
	ocir: ocir$1,
	Ocy: Ocy$1,
	ocy: ocy$1,
	odash: odash$1,
	Odblac: Odblac$1,
	odblac: odblac$1,
	odiv: odiv$1,
	odot: odot$1,
	odsold: odsold$1,
	OElig: OElig$1,
	oelig: oelig$1,
	ofcir: ofcir$1,
	Ofr: Ofr$1,
	ofr: ofr$1,
	ogon: ogon$1,
	Ograve: Ograve$3,
	ograve: ograve$3,
	ogt: ogt$1,
	ohbar: ohbar$1,
	ohm: ohm$1,
	oint: oint$1,
	olarr: olarr$1,
	olcir: olcir$1,
	olcross: olcross$1,
	oline: oline$1,
	olt: olt$1,
	Omacr: Omacr$1,
	omacr: omacr$1,
	Omega: Omega$1,
	omega: omega$1,
	Omicron: Omicron$1,
	omicron: omicron$1,
	omid: omid$1,
	ominus: ominus$1,
	Oopf: Oopf$1,
	oopf: oopf$1,
	opar: opar$1,
	OpenCurlyDoubleQuote: OpenCurlyDoubleQuote$1,
	OpenCurlyQuote: OpenCurlyQuote$1,
	operp: operp$1,
	oplus: oplus$1,
	orarr: orarr$1,
	Or: Or$1,
	or: or$1,
	ord: ord$1,
	order: order$1,
	orderof: orderof$1,
	ordf: ordf$3,
	ordm: ordm$3,
	origof: origof$1,
	oror: oror$1,
	orslope: orslope$1,
	orv: orv$1,
	oS: oS$1,
	Oscr: Oscr$1,
	oscr: oscr$1,
	Oslash: Oslash$3,
	oslash: oslash$3,
	osol: osol$1,
	Otilde: Otilde$3,
	otilde: otilde$3,
	otimesas: otimesas$1,
	Otimes: Otimes$1,
	otimes: otimes$1,
	Ouml: Ouml$3,
	ouml: ouml$3,
	ovbar: ovbar$1,
	OverBar: OverBar$1,
	OverBrace: OverBrace$1,
	OverBracket: OverBracket$1,
	OverParenthesis: OverParenthesis$1,
	para: para$3,
	parallel: parallel$2,
	par: par$1,
	parsim: parsim$1,
	parsl: parsl$1,
	part: part$1,
	PartialD: PartialD$1,
	Pcy: Pcy$1,
	pcy: pcy$1,
	percnt: percnt$1,
	period: period$1,
	permil: permil$1,
	perp: perp$1,
	pertenk: pertenk$1,
	Pfr: Pfr$1,
	pfr: pfr$1,
	Phi: Phi$1,
	phi: phi$1,
	phiv: phiv$1,
	phmmat: phmmat$1,
	phone: phone$1,
	Pi: Pi$1,
	pi: pi$1,
	pitchfork: pitchfork$1,
	piv: piv$1,
	planck: planck$1,
	planckh: planckh$1,
	plankv: plankv$1,
	plusacir: plusacir$1,
	plusb: plusb$1,
	pluscir: pluscir$1,
	plus: plus$1,
	plusdo: plusdo$1,
	plusdu: plusdu$1,
	pluse: pluse$1,
	PlusMinus: PlusMinus$1,
	plusmn: plusmn$3,
	plussim: plussim$1,
	plustwo: plustwo$1,
	pm: pm$1,
	Poincareplane: Poincareplane$1,
	pointint: pointint$1,
	popf: popf$1,
	Popf: Popf$1,
	pound: pound$3,
	prap: prap$1,
	Pr: Pr$1,
	pr: pr$1,
	prcue: prcue$1,
	precapprox: precapprox$1,
	prec: prec$1,
	preccurlyeq: preccurlyeq$1,
	Precedes: Precedes$1,
	PrecedesEqual: PrecedesEqual$1,
	PrecedesSlantEqual: PrecedesSlantEqual$1,
	PrecedesTilde: PrecedesTilde$1,
	preceq: preceq$1,
	precnapprox: precnapprox$1,
	precneqq: precneqq$1,
	precnsim: precnsim$1,
	pre: pre$1,
	prE: prE$1,
	precsim: precsim$1,
	prime: prime$1,
	Prime: Prime$1,
	primes: primes$1,
	prnap: prnap$1,
	prnE: prnE$1,
	prnsim: prnsim$1,
	prod: prod$1,
	Product: Product$1,
	profalar: profalar$1,
	profline: profline$1,
	profsurf: profsurf$1,
	prop: prop$1,
	Proportional: Proportional$1,
	Proportion: Proportion$1,
	propto: propto$1,
	prsim: prsim$1,
	prurel: prurel$1,
	Pscr: Pscr$1,
	pscr: pscr$1,
	Psi: Psi$1,
	psi: psi$1,
	puncsp: puncsp$1,
	Qfr: Qfr$1,
	qfr: qfr$1,
	qint: qint$1,
	qopf: qopf$1,
	Qopf: Qopf$1,
	qprime: qprime$1,
	Qscr: Qscr$1,
	qscr: qscr$1,
	quaternions: quaternions$1,
	quatint: quatint$1,
	quest: quest$1,
	questeq: questeq$1,
	quot: quot$5,
	QUOT: QUOT$3,
	rAarr: rAarr$1,
	race: race$1,
	Racute: Racute$1,
	racute: racute$1,
	radic: radic$1,
	raemptyv: raemptyv$1,
	rang: rang$1,
	Rang: Rang$1,
	rangd: rangd$1,
	range: range$1,
	rangle: rangle$1,
	raquo: raquo$3,
	rarrap: rarrap$1,
	rarrb: rarrb$1,
	rarrbfs: rarrbfs$1,
	rarrc: rarrc$1,
	rarr: rarr$1,
	Rarr: Rarr$1,
	rArr: rArr$1,
	rarrfs: rarrfs$1,
	rarrhk: rarrhk$1,
	rarrlp: rarrlp$1,
	rarrpl: rarrpl$1,
	rarrsim: rarrsim$1,
	Rarrtl: Rarrtl$1,
	rarrtl: rarrtl$1,
	rarrw: rarrw$1,
	ratail: ratail$1,
	rAtail: rAtail$1,
	ratio: ratio$1,
	rationals: rationals$1,
	rbarr: rbarr$1,
	rBarr: rBarr$1,
	RBarr: RBarr$1,
	rbbrk: rbbrk$1,
	rbrace: rbrace$1,
	rbrack: rbrack$1,
	rbrke: rbrke$1,
	rbrksld: rbrksld$1,
	rbrkslu: rbrkslu$1,
	Rcaron: Rcaron$1,
	rcaron: rcaron$1,
	Rcedil: Rcedil$1,
	rcedil: rcedil$1,
	rceil: rceil$1,
	rcub: rcub$1,
	Rcy: Rcy$1,
	rcy: rcy$1,
	rdca: rdca$1,
	rdldhar: rdldhar$1,
	rdquo: rdquo$1,
	rdquor: rdquor$1,
	rdsh: rdsh$1,
	real: real$1,
	realine: realine$1,
	realpart: realpart$1,
	reals: reals$1,
	Re: Re$1,
	rect: rect$1,
	reg: reg$3,
	REG: REG$3,
	ReverseElement: ReverseElement$1,
	ReverseEquilibrium: ReverseEquilibrium$1,
	ReverseUpEquilibrium: ReverseUpEquilibrium$1,
	rfisht: rfisht$1,
	rfloor: rfloor$1,
	rfr: rfr$1,
	Rfr: Rfr$1,
	rHar: rHar$1,
	rhard: rhard$1,
	rharu: rharu$1,
	rharul: rharul$1,
	Rho: Rho$1,
	rho: rho$1,
	rhov: rhov$1,
	RightAngleBracket: RightAngleBracket$1,
	RightArrowBar: RightArrowBar$1,
	rightarrow: rightarrow$1,
	RightArrow: RightArrow$1,
	Rightarrow: Rightarrow$1,
	RightArrowLeftArrow: RightArrowLeftArrow$1,
	rightarrowtail: rightarrowtail$1,
	RightCeiling: RightCeiling$1,
	RightDoubleBracket: RightDoubleBracket$1,
	RightDownTeeVector: RightDownTeeVector$1,
	RightDownVectorBar: RightDownVectorBar$1,
	RightDownVector: RightDownVector$1,
	RightFloor: RightFloor$1,
	rightharpoondown: rightharpoondown$1,
	rightharpoonup: rightharpoonup$1,
	rightleftarrows: rightleftarrows$1,
	rightleftharpoons: rightleftharpoons$1,
	rightrightarrows: rightrightarrows$1,
	rightsquigarrow: rightsquigarrow$1,
	RightTeeArrow: RightTeeArrow$1,
	RightTee: RightTee$1,
	RightTeeVector: RightTeeVector$1,
	rightthreetimes: rightthreetimes$1,
	RightTriangleBar: RightTriangleBar$1,
	RightTriangle: RightTriangle$1,
	RightTriangleEqual: RightTriangleEqual$1,
	RightUpDownVector: RightUpDownVector$1,
	RightUpTeeVector: RightUpTeeVector$1,
	RightUpVectorBar: RightUpVectorBar$1,
	RightUpVector: RightUpVector$1,
	RightVectorBar: RightVectorBar$1,
	RightVector: RightVector$1,
	ring: ring$1,
	risingdotseq: risingdotseq$1,
	rlarr: rlarr$1,
	rlhar: rlhar$1,
	rlm: rlm$1,
	rmoustache: rmoustache$1,
	rmoust: rmoust$1,
	rnmid: rnmid$1,
	roang: roang$1,
	roarr: roarr$1,
	robrk: robrk$1,
	ropar: ropar$1,
	ropf: ropf$1,
	Ropf: Ropf$1,
	roplus: roplus$1,
	rotimes: rotimes$1,
	RoundImplies: RoundImplies$1,
	rpar: rpar$1,
	rpargt: rpargt$1,
	rppolint: rppolint$1,
	rrarr: rrarr$1,
	Rrightarrow: Rrightarrow$1,
	rsaquo: rsaquo$1,
	rscr: rscr$1,
	Rscr: Rscr$1,
	rsh: rsh$1,
	Rsh: Rsh$1,
	rsqb: rsqb$1,
	rsquo: rsquo$1,
	rsquor: rsquor$1,
	rthree: rthree$1,
	rtimes: rtimes$1,
	rtri: rtri$1,
	rtrie: rtrie$1,
	rtrif: rtrif$1,
	rtriltri: rtriltri$1,
	RuleDelayed: RuleDelayed$1,
	ruluhar: ruluhar$1,
	rx: rx$1,
	Sacute: Sacute$1,
	sacute: sacute$1,
	sbquo: sbquo$1,
	scap: scap$1,
	Scaron: Scaron$1,
	scaron: scaron$1,
	Sc: Sc$1,
	sc: sc$1,
	sccue: sccue$1,
	sce: sce$1,
	scE: scE$1,
	Scedil: Scedil$1,
	scedil: scedil$1,
	Scirc: Scirc$1,
	scirc: scirc$1,
	scnap: scnap$1,
	scnE: scnE$1,
	scnsim: scnsim$1,
	scpolint: scpolint$1,
	scsim: scsim$1,
	Scy: Scy$1,
	scy: scy$1,
	sdotb: sdotb$1,
	sdot: sdot$1,
	sdote: sdote$1,
	searhk: searhk$1,
	searr: searr$1,
	seArr: seArr$1,
	searrow: searrow$1,
	sect: sect$3,
	semi: semi$1,
	seswar: seswar$1,
	setminus: setminus$1,
	setmn: setmn$1,
	sext: sext$1,
	Sfr: Sfr$1,
	sfr: sfr$1,
	sfrown: sfrown$1,
	sharp: sharp$1,
	SHCHcy: SHCHcy$1,
	shchcy: shchcy$1,
	SHcy: SHcy$1,
	shcy: shcy$1,
	ShortDownArrow: ShortDownArrow$1,
	ShortLeftArrow: ShortLeftArrow$1,
	shortmid: shortmid$1,
	shortparallel: shortparallel$1,
	ShortRightArrow: ShortRightArrow$1,
	ShortUpArrow: ShortUpArrow$1,
	shy: shy$3,
	Sigma: Sigma$1,
	sigma: sigma$1,
	sigmaf: sigmaf$1,
	sigmav: sigmav$1,
	sim: sim$1,
	simdot: simdot$1,
	sime: sime$1,
	simeq: simeq$1,
	simg: simg$1,
	simgE: simgE$1,
	siml: siml$1,
	simlE: simlE$1,
	simne: simne$1,
	simplus: simplus$1,
	simrarr: simrarr$1,
	slarr: slarr$1,
	SmallCircle: SmallCircle$1,
	smallsetminus: smallsetminus$1,
	smashp: smashp$1,
	smeparsl: smeparsl$1,
	smid: smid$1,
	smile: smile$1,
	smt: smt$1,
	smte: smte$1,
	smtes: smtes$1,
	SOFTcy: SOFTcy$1,
	softcy: softcy$1,
	solbar: solbar$1,
	solb: solb$1,
	sol: sol$1,
	Sopf: Sopf$1,
	sopf: sopf$1,
	spades: spades$1,
	spadesuit: spadesuit$1,
	spar: spar$1,
	sqcap: sqcap$1,
	sqcaps: sqcaps$1,
	sqcup: sqcup$1,
	sqcups: sqcups$1,
	Sqrt: Sqrt$1,
	sqsub: sqsub$1,
	sqsube: sqsube$1,
	sqsubset: sqsubset$1,
	sqsubseteq: sqsubseteq$1,
	sqsup: sqsup$1,
	sqsupe: sqsupe$1,
	sqsupset: sqsupset$1,
	sqsupseteq: sqsupseteq$1,
	square: square$1,
	Square: Square$1,
	SquareIntersection: SquareIntersection$1,
	SquareSubset: SquareSubset$1,
	SquareSubsetEqual: SquareSubsetEqual$1,
	SquareSuperset: SquareSuperset$1,
	SquareSupersetEqual: SquareSupersetEqual$1,
	SquareUnion: SquareUnion$1,
	squarf: squarf$1,
	squ: squ$1,
	squf: squf$1,
	srarr: srarr$1,
	Sscr: Sscr$1,
	sscr: sscr$1,
	ssetmn: ssetmn$1,
	ssmile: ssmile$1,
	sstarf: sstarf$1,
	Star: Star$1,
	star: star$1,
	starf: starf$1,
	straightepsilon: straightepsilon$1,
	straightphi: straightphi$1,
	strns: strns$1,
	sub: sub$1,
	Sub: Sub$1,
	subdot: subdot$1,
	subE: subE$1,
	sube: sube$1,
	subedot: subedot$1,
	submult: submult$1,
	subnE: subnE$1,
	subne: subne$1,
	subplus: subplus$1,
	subrarr: subrarr$1,
	subset: subset$1,
	Subset: Subset$1,
	subseteq: subseteq$1,
	subseteqq: subseteqq$1,
	SubsetEqual: SubsetEqual$1,
	subsetneq: subsetneq$1,
	subsetneqq: subsetneqq$1,
	subsim: subsim$1,
	subsub: subsub$1,
	subsup: subsup$1,
	succapprox: succapprox$1,
	succ: succ$1,
	succcurlyeq: succcurlyeq$1,
	Succeeds: Succeeds$1,
	SucceedsEqual: SucceedsEqual$1,
	SucceedsSlantEqual: SucceedsSlantEqual$1,
	SucceedsTilde: SucceedsTilde$1,
	succeq: succeq$1,
	succnapprox: succnapprox$1,
	succneqq: succneqq$1,
	succnsim: succnsim$1,
	succsim: succsim$1,
	SuchThat: SuchThat$1,
	sum: sum$1,
	Sum: Sum$1,
	sung: sung$1,
	sup1: sup1$3,
	sup2: sup2$3,
	sup3: sup3$3,
	sup: sup$1,
	Sup: Sup$1,
	supdot: supdot$1,
	supdsub: supdsub$1,
	supE: supE$1,
	supe: supe$1,
	supedot: supedot$1,
	Superset: Superset$1,
	SupersetEqual: SupersetEqual$1,
	suphsol: suphsol$1,
	suphsub: suphsub$1,
	suplarr: suplarr$1,
	supmult: supmult$1,
	supnE: supnE$1,
	supne: supne$1,
	supplus: supplus$1,
	supset: supset$1,
	Supset: Supset$1,
	supseteq: supseteq$1,
	supseteqq: supseteqq$1,
	supsetneq: supsetneq$1,
	supsetneqq: supsetneqq$1,
	supsim: supsim$1,
	supsub: supsub$1,
	supsup: supsup$1,
	swarhk: swarhk$1,
	swarr: swarr$1,
	swArr: swArr$1,
	swarrow: swarrow$1,
	swnwar: swnwar$1,
	szlig: szlig$3,
	Tab: Tab$1,
	target: target$1,
	Tau: Tau$1,
	tau: tau$1,
	tbrk: tbrk$1,
	Tcaron: Tcaron$1,
	tcaron: tcaron$1,
	Tcedil: Tcedil$1,
	tcedil: tcedil$1,
	Tcy: Tcy$1,
	tcy: tcy$1,
	tdot: tdot$1,
	telrec: telrec$1,
	Tfr: Tfr$1,
	tfr: tfr$1,
	there4: there4$1,
	therefore: therefore$1,
	Therefore: Therefore$1,
	Theta: Theta$1,
	theta: theta$1,
	thetasym: thetasym$1,
	thetav: thetav$1,
	thickapprox: thickapprox$1,
	thicksim: thicksim$1,
	ThickSpace: ThickSpace$1,
	ThinSpace: ThinSpace$1,
	thinsp: thinsp$1,
	thkap: thkap$1,
	thksim: thksim$1,
	THORN: THORN$3,
	thorn: thorn$3,
	tilde: tilde$1,
	Tilde: Tilde$1,
	TildeEqual: TildeEqual$1,
	TildeFullEqual: TildeFullEqual$1,
	TildeTilde: TildeTilde$1,
	timesbar: timesbar$1,
	timesb: timesb$1,
	times: times$3,
	timesd: timesd$1,
	tint: tint$1,
	toea: toea$1,
	topbot: topbot$1,
	topcir: topcir$1,
	top: top$1,
	Topf: Topf$1,
	topf: topf$1,
	topfork: topfork$1,
	tosa: tosa$1,
	tprime: tprime$1,
	trade: trade$1,
	TRADE: TRADE$1,
	triangle: triangle$1,
	triangledown: triangledown$1,
	triangleleft: triangleleft$1,
	trianglelefteq: trianglelefteq$1,
	triangleq: triangleq$1,
	triangleright: triangleright$1,
	trianglerighteq: trianglerighteq$1,
	tridot: tridot$1,
	trie: trie$1,
	triminus: triminus$1,
	TripleDot: TripleDot$1,
	triplus: triplus$1,
	trisb: trisb$1,
	tritime: tritime$1,
	trpezium: trpezium$1,
	Tscr: Tscr$1,
	tscr: tscr$1,
	TScy: TScy$1,
	tscy: tscy$1,
	TSHcy: TSHcy$1,
	tshcy: tshcy$1,
	Tstrok: Tstrok$1,
	tstrok: tstrok$1,
	twixt: twixt$1,
	twoheadleftarrow: twoheadleftarrow$1,
	twoheadrightarrow: twoheadrightarrow$1,
	Uacute: Uacute$3,
	uacute: uacute$3,
	uarr: uarr$1,
	Uarr: Uarr$1,
	uArr: uArr$1,
	Uarrocir: Uarrocir$1,
	Ubrcy: Ubrcy$1,
	ubrcy: ubrcy$1,
	Ubreve: Ubreve$1,
	ubreve: ubreve$1,
	Ucirc: Ucirc$3,
	ucirc: ucirc$3,
	Ucy: Ucy$1,
	ucy: ucy$1,
	udarr: udarr$1,
	Udblac: Udblac$1,
	udblac: udblac$1,
	udhar: udhar$1,
	ufisht: ufisht$1,
	Ufr: Ufr$1,
	ufr: ufr$1,
	Ugrave: Ugrave$3,
	ugrave: ugrave$3,
	uHar: uHar$1,
	uharl: uharl$1,
	uharr: uharr$1,
	uhblk: uhblk$1,
	ulcorn: ulcorn$1,
	ulcorner: ulcorner$1,
	ulcrop: ulcrop$1,
	ultri: ultri$1,
	Umacr: Umacr$1,
	umacr: umacr$1,
	uml: uml$3,
	UnderBar: UnderBar$1,
	UnderBrace: UnderBrace$1,
	UnderBracket: UnderBracket$1,
	UnderParenthesis: UnderParenthesis$1,
	Union: Union$1,
	UnionPlus: UnionPlus$1,
	Uogon: Uogon$1,
	uogon: uogon$1,
	Uopf: Uopf$1,
	uopf: uopf$1,
	UpArrowBar: UpArrowBar$1,
	uparrow: uparrow$1,
	UpArrow: UpArrow$1,
	Uparrow: Uparrow$1,
	UpArrowDownArrow: UpArrowDownArrow$1,
	updownarrow: updownarrow$1,
	UpDownArrow: UpDownArrow$1,
	Updownarrow: Updownarrow$1,
	UpEquilibrium: UpEquilibrium$1,
	upharpoonleft: upharpoonleft$1,
	upharpoonright: upharpoonright$1,
	uplus: uplus$1,
	UpperLeftArrow: UpperLeftArrow$1,
	UpperRightArrow: UpperRightArrow$1,
	upsi: upsi$1,
	Upsi: Upsi$1,
	upsih: upsih$1,
	Upsilon: Upsilon$1,
	upsilon: upsilon$1,
	UpTeeArrow: UpTeeArrow$1,
	UpTee: UpTee$1,
	upuparrows: upuparrows$1,
	urcorn: urcorn$1,
	urcorner: urcorner$1,
	urcrop: urcrop$1,
	Uring: Uring$1,
	uring: uring$1,
	urtri: urtri$1,
	Uscr: Uscr$1,
	uscr: uscr$1,
	utdot: utdot$1,
	Utilde: Utilde$1,
	utilde: utilde$1,
	utri: utri$1,
	utrif: utrif$1,
	uuarr: uuarr$1,
	Uuml: Uuml$3,
	uuml: uuml$3,
	uwangle: uwangle$1,
	vangrt: vangrt$1,
	varepsilon: varepsilon$1,
	varkappa: varkappa$1,
	varnothing: varnothing$1,
	varphi: varphi$1,
	varpi: varpi$1,
	varpropto: varpropto$1,
	varr: varr$1,
	vArr: vArr$1,
	varrho: varrho$1,
	varsigma: varsigma$1,
	varsubsetneq: varsubsetneq$1,
	varsubsetneqq: varsubsetneqq$1,
	varsupsetneq: varsupsetneq$1,
	varsupsetneqq: varsupsetneqq$1,
	vartheta: vartheta$1,
	vartriangleleft: vartriangleleft$1,
	vartriangleright: vartriangleright$1,
	vBar: vBar$1,
	Vbar: Vbar$1,
	vBarv: vBarv$1,
	Vcy: Vcy$1,
	vcy: vcy$1,
	vdash: vdash$1,
	vDash: vDash$1,
	Vdash: Vdash$1,
	VDash: VDash$1,
	Vdashl: Vdashl$1,
	veebar: veebar$1,
	vee: vee$1,
	Vee: Vee$1,
	veeeq: veeeq$1,
	vellip: vellip$1,
	verbar: verbar$1,
	Verbar: Verbar$1,
	vert: vert$1,
	Vert: Vert$1,
	VerticalBar: VerticalBar$1,
	VerticalLine: VerticalLine$1,
	VerticalSeparator: VerticalSeparator$1,
	VerticalTilde: VerticalTilde$1,
	VeryThinSpace: VeryThinSpace$1,
	Vfr: Vfr$1,
	vfr: vfr$1,
	vltri: vltri$1,
	vnsub: vnsub$1,
	vnsup: vnsup$1,
	Vopf: Vopf$1,
	vopf: vopf$1,
	vprop: vprop$1,
	vrtri: vrtri$1,
	Vscr: Vscr$1,
	vscr: vscr$1,
	vsubnE: vsubnE$1,
	vsubne: vsubne$1,
	vsupnE: vsupnE$1,
	vsupne: vsupne$1,
	Vvdash: Vvdash$1,
	vzigzag: vzigzag$1,
	Wcirc: Wcirc$1,
	wcirc: wcirc$1,
	wedbar: wedbar$1,
	wedge: wedge$1,
	Wedge: Wedge$1,
	wedgeq: wedgeq$1,
	weierp: weierp$1,
	Wfr: Wfr$1,
	wfr: wfr$1,
	Wopf: Wopf$1,
	wopf: wopf$1,
	wp: wp$1,
	wr: wr$1,
	wreath: wreath$1,
	Wscr: Wscr$1,
	wscr: wscr$1,
	xcap: xcap$1,
	xcirc: xcirc$1,
	xcup: xcup$1,
	xdtri: xdtri$1,
	Xfr: Xfr$1,
	xfr: xfr$1,
	xharr: xharr$1,
	xhArr: xhArr$1,
	Xi: Xi$1,
	xi: xi$1,
	xlarr: xlarr$1,
	xlArr: xlArr$1,
	xmap: xmap$1,
	xnis: xnis$1,
	xodot: xodot$1,
	Xopf: Xopf$1,
	xopf: xopf$1,
	xoplus: xoplus$1,
	xotime: xotime$1,
	xrarr: xrarr$1,
	xrArr: xrArr$1,
	Xscr: Xscr$1,
	xscr: xscr$1,
	xsqcup: xsqcup$1,
	xuplus: xuplus$1,
	xutri: xutri$1,
	xvee: xvee$1,
	xwedge: xwedge$1,
	Yacute: Yacute$3,
	yacute: yacute$3,
	YAcy: YAcy$1,
	yacy: yacy$1,
	Ycirc: Ycirc$1,
	ycirc: ycirc$1,
	Ycy: Ycy$1,
	ycy: ycy$1,
	yen: yen$3,
	Yfr: Yfr$1,
	yfr: yfr$1,
	YIcy: YIcy$1,
	yicy: yicy$1,
	Yopf: Yopf$1,
	yopf: yopf$1,
	Yscr: Yscr$1,
	yscr: yscr$1,
	YUcy: YUcy$1,
	yucy: yucy$1,
	yuml: yuml$3,
	Yuml: Yuml$1,
	Zacute: Zacute$1,
	zacute: zacute$1,
	Zcaron: Zcaron$1,
	zcaron: zcaron$1,
	Zcy: Zcy$1,
	zcy: zcy$1,
	Zdot: Zdot$1,
	zdot: zdot$1,
	zeetrf: zeetrf$1,
	ZeroWidthSpace: ZeroWidthSpace$1,
	Zeta: Zeta$1,
	zeta: zeta$1,
	zfr: zfr$1,
	Zfr: Zfr$1,
	ZHcy: ZHcy$1,
	zhcy: zhcy$1,
	zigrarr: zigrarr$1,
	zopf: zopf$1,
	Zopf: Zopf$1,
	Zscr: Zscr$1,
	zscr: zscr$1,
	zwj: zwj$1,
	zwnj: zwnj$1
};

var Aacute$2 = "Á";
var aacute$2 = "á";
var Acirc$2 = "Â";
var acirc$2 = "â";
var acute$2 = "´";
var AElig$2 = "Æ";
var aelig$2 = "æ";
var Agrave$2 = "À";
var agrave$2 = "à";
var amp$4 = "&";
var AMP$2 = "&";
var Aring$2 = "Å";
var aring$2 = "å";
var Atilde$2 = "Ã";
var atilde$2 = "ã";
var Auml$2 = "Ä";
var auml$2 = "ä";
var brvbar$2 = "¦";
var Ccedil$2 = "Ç";
var ccedil$2 = "ç";
var cedil$2 = "¸";
var cent$2 = "¢";
var copy$3 = "©";
var COPY$2 = "©";
var curren$2 = "¤";
var deg$2 = "°";
var divide$2 = "÷";
var Eacute$2 = "É";
var eacute$2 = "é";
var Ecirc$2 = "Ê";
var ecirc$2 = "ê";
var Egrave$2 = "È";
var egrave$2 = "è";
var ETH$2 = "Ð";
var eth$2 = "ð";
var Euml$2 = "Ë";
var euml$2 = "ë";
var frac12$2 = "½";
var frac14$2 = "¼";
var frac34$2 = "¾";
var gt$4 = ">";
var GT$2 = ">";
var Iacute$2 = "Í";
var iacute$2 = "í";
var Icirc$2 = "Î";
var icirc$2 = "î";
var iexcl$2 = "¡";
var Igrave$2 = "Ì";
var igrave$2 = "ì";
var iquest$2 = "¿";
var Iuml$2 = "Ï";
var iuml$2 = "ï";
var laquo$2 = "«";
var lt$4 = "<";
var LT$2 = "<";
var macr$2 = "¯";
var micro$2 = "µ";
var middot$2 = "·";
var nbsp$2 = " ";
var not$2 = "¬";
var Ntilde$2 = "Ñ";
var ntilde$2 = "ñ";
var Oacute$2 = "Ó";
var oacute$2 = "ó";
var Ocirc$2 = "Ô";
var ocirc$2 = "ô";
var Ograve$2 = "Ò";
var ograve$2 = "ò";
var ordf$2 = "ª";
var ordm$2 = "º";
var Oslash$2 = "Ø";
var oslash$2 = "ø";
var Otilde$2 = "Õ";
var otilde$2 = "õ";
var Ouml$2 = "Ö";
var ouml$2 = "ö";
var para$2 = "¶";
var plusmn$2 = "±";
var pound$2 = "£";
var quot$4 = "\"";
var QUOT$2 = "\"";
var raquo$2 = "»";
var reg$2 = "®";
var REG$2 = "®";
var sect$2 = "§";
var shy$2 = "­";
var sup1$2 = "¹";
var sup2$2 = "²";
var sup3$2 = "³";
var szlig$2 = "ß";
var THORN$2 = "Þ";
var thorn$2 = "þ";
var times$2 = "×";
var Uacute$2 = "Ú";
var uacute$2 = "ú";
var Ucirc$2 = "Û";
var ucirc$2 = "û";
var Ugrave$2 = "Ù";
var ugrave$2 = "ù";
var uml$2 = "¨";
var Uuml$2 = "Ü";
var uuml$2 = "ü";
var Yacute$2 = "Ý";
var yacute$2 = "ý";
var yen$2 = "¥";
var yuml$2 = "ÿ";
var require$$2 = {
	Aacute: Aacute$2,
	aacute: aacute$2,
	Acirc: Acirc$2,
	acirc: acirc$2,
	acute: acute$2,
	AElig: AElig$2,
	aelig: aelig$2,
	Agrave: Agrave$2,
	agrave: agrave$2,
	amp: amp$4,
	AMP: AMP$2,
	Aring: Aring$2,
	aring: aring$2,
	Atilde: Atilde$2,
	atilde: atilde$2,
	Auml: Auml$2,
	auml: auml$2,
	brvbar: brvbar$2,
	Ccedil: Ccedil$2,
	ccedil: ccedil$2,
	cedil: cedil$2,
	cent: cent$2,
	copy: copy$3,
	COPY: COPY$2,
	curren: curren$2,
	deg: deg$2,
	divide: divide$2,
	Eacute: Eacute$2,
	eacute: eacute$2,
	Ecirc: Ecirc$2,
	ecirc: ecirc$2,
	Egrave: Egrave$2,
	egrave: egrave$2,
	ETH: ETH$2,
	eth: eth$2,
	Euml: Euml$2,
	euml: euml$2,
	frac12: frac12$2,
	frac14: frac14$2,
	frac34: frac34$2,
	gt: gt$4,
	GT: GT$2,
	Iacute: Iacute$2,
	iacute: iacute$2,
	Icirc: Icirc$2,
	icirc: icirc$2,
	iexcl: iexcl$2,
	Igrave: Igrave$2,
	igrave: igrave$2,
	iquest: iquest$2,
	Iuml: Iuml$2,
	iuml: iuml$2,
	laquo: laquo$2,
	lt: lt$4,
	LT: LT$2,
	macr: macr$2,
	micro: micro$2,
	middot: middot$2,
	nbsp: nbsp$2,
	not: not$2,
	Ntilde: Ntilde$2,
	ntilde: ntilde$2,
	Oacute: Oacute$2,
	oacute: oacute$2,
	Ocirc: Ocirc$2,
	ocirc: ocirc$2,
	Ograve: Ograve$2,
	ograve: ograve$2,
	ordf: ordf$2,
	ordm: ordm$2,
	Oslash: Oslash$2,
	oslash: oslash$2,
	Otilde: Otilde$2,
	otilde: otilde$2,
	Ouml: Ouml$2,
	ouml: ouml$2,
	para: para$2,
	plusmn: plusmn$2,
	pound: pound$2,
	quot: quot$4,
	QUOT: QUOT$2,
	raquo: raquo$2,
	reg: reg$2,
	REG: REG$2,
	sect: sect$2,
	shy: shy$2,
	sup1: sup1$2,
	sup2: sup2$2,
	sup3: sup3$2,
	szlig: szlig$2,
	THORN: THORN$2,
	thorn: thorn$2,
	times: times$2,
	Uacute: Uacute$2,
	uacute: uacute$2,
	Ucirc: Ucirc$2,
	ucirc: ucirc$2,
	Ugrave: Ugrave$2,
	ugrave: ugrave$2,
	uml: uml$2,
	Uuml: Uuml$2,
	uuml: uuml$2,
	Yacute: Yacute$2,
	yacute: yacute$2,
	yen: yen$2,
	yuml: yuml$2
};

var amp$3 = "&";
var apos$2 = "'";
var gt$3 = ">";
var lt$3 = "<";
var quot$3 = "\"";
var require$$3 = {
	amp: amp$3,
	apos: apos$2,
	gt: gt$3,
	lt: lt$3,
	quot: quot$3
};

var __importDefault$6 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Tokenizer$1, "__esModule", { value: true });
var decode_codepoint_1$1 = __importDefault$6(decode_codepoint$1);
var entities_json_1$2 = __importDefault$6(require$$1$2);
var legacy_json_1$1 = __importDefault$6(require$$2);
var xml_json_1$2 = __importDefault$6(require$$3);
function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}
function isASCIIAlpha(c) {
    return (c >= "a" && c <= "z") || (c >= "A" && c <= "Z");
}
function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();
    if (upper === lower) {
        return function (t, c) {
            if (c === lower) {
                t._state = SUCCESS;
            }
            else {
                t._state = FAILURE;
                t._index--;
            }
        };
    }
    return function (t, c) {
        if (c === lower || c === upper) {
            t._state = SUCCESS;
        }
        else {
            t._state = FAILURE;
            t._index--;
        }
    };
}
function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();
    return function (t, c) {
        if (c === lower || c === upper) {
            t._state = NEXT_STATE;
        }
        else {
            t._state = 3 /* InTagName */;
            t._index--; // Consume the token again
        }
    };
}
var stateBeforeCdata1 = ifElseState("C", 24 /* BeforeCdata2 */, 16 /* InDeclaration */);
var stateBeforeCdata2 = ifElseState("D", 25 /* BeforeCdata3 */, 16 /* InDeclaration */);
var stateBeforeCdata3 = ifElseState("A", 26 /* BeforeCdata4 */, 16 /* InDeclaration */);
var stateBeforeCdata4 = ifElseState("T", 27 /* BeforeCdata5 */, 16 /* InDeclaration */);
var stateBeforeCdata5 = ifElseState("A", 28 /* BeforeCdata6 */, 16 /* InDeclaration */);
var stateBeforeScript1 = consumeSpecialNameChar("R", 35 /* BeforeScript2 */);
var stateBeforeScript2 = consumeSpecialNameChar("I", 36 /* BeforeScript3 */);
var stateBeforeScript3 = consumeSpecialNameChar("P", 37 /* BeforeScript4 */);
var stateBeforeScript4 = consumeSpecialNameChar("T", 38 /* BeforeScript5 */);
var stateAfterScript1 = ifElseState("R", 40 /* AfterScript2 */, 1 /* Text */);
var stateAfterScript2 = ifElseState("I", 41 /* AfterScript3 */, 1 /* Text */);
var stateAfterScript3 = ifElseState("P", 42 /* AfterScript4 */, 1 /* Text */);
var stateAfterScript4 = ifElseState("T", 43 /* AfterScript5 */, 1 /* Text */);
var stateBeforeStyle1 = consumeSpecialNameChar("Y", 45 /* BeforeStyle2 */);
var stateBeforeStyle2 = consumeSpecialNameChar("L", 46 /* BeforeStyle3 */);
var stateBeforeStyle3 = consumeSpecialNameChar("E", 47 /* BeforeStyle4 */);
var stateAfterStyle1 = ifElseState("Y", 49 /* AfterStyle2 */, 1 /* Text */);
var stateAfterStyle2 = ifElseState("L", 50 /* AfterStyle3 */, 1 /* Text */);
var stateAfterStyle3 = ifElseState("E", 51 /* AfterStyle4 */, 1 /* Text */);
var stateBeforeSpecialT = consumeSpecialNameChar("I", 54 /* BeforeTitle1 */);
var stateBeforeTitle1 = consumeSpecialNameChar("T", 55 /* BeforeTitle2 */);
var stateBeforeTitle2 = consumeSpecialNameChar("L", 56 /* BeforeTitle3 */);
var stateBeforeTitle3 = consumeSpecialNameChar("E", 57 /* BeforeTitle4 */);
var stateAfterSpecialTEnd = ifElseState("I", 58 /* AfterTitle1 */, 1 /* Text */);
var stateAfterTitle1 = ifElseState("T", 59 /* AfterTitle2 */, 1 /* Text */);
var stateAfterTitle2 = ifElseState("L", 60 /* AfterTitle3 */, 1 /* Text */);
var stateAfterTitle3 = ifElseState("E", 61 /* AfterTitle4 */, 1 /* Text */);
var stateBeforeEntity = ifElseState("#", 63 /* BeforeNumericEntity */, 64 /* InNamedEntity */);
var stateBeforeNumericEntity = ifElseState("X", 66 /* InHexEntity */, 65 /* InNumericEntity */);
var Tokenizer = /** @class */ (function () {
    function Tokenizer(options, cbs) {
        var _a;
        /** The current state the tokenizer is in. */
        this._state = 1 /* Text */;
        /** The read buffer. */
        this.buffer = "";
        /** The beginning of the section that is currently being read. */
        this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */
        this._index = 0;
        /**
         * Data that has already been processed will be removed from the buffer occasionally.
         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
         */
        this.bufferOffset = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
        this.baseState = 1 /* Text */;
        /** For special parsing behavior inside of script and style tags. */
        this.special = 1 /* None */;
        /** Indicates whether the tokenizer has been paused. */
        this.running = true;
        /** Indicates whether the tokenizer has finished running / `.end` has been called. */
        this.ended = false;
        this.cbs = cbs;
        this.xmlMode = !!(options === null || options === void 0 ? void 0 : options.xmlMode);
        this.decodeEntities = (_a = options === null || options === void 0 ? void 0 : options.decodeEntities) !== null && _a !== void 0 ? _a : true;
    }
    Tokenizer.prototype.reset = function () {
        this._state = 1 /* Text */;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 /* Text */;
        this.special = 1 /* None */;
        this.running = true;
        this.ended = false;
    };
    Tokenizer.prototype.write = function (chunk) {
        if (this.ended)
            this.cbs.onerror(Error(".write() after done!"));
        this.buffer += chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function (chunk) {
        if (this.ended)
            this.cbs.onerror(Error(".end() after done!"));
        if (chunk)
            this.write(chunk);
        this.ended = true;
        if (this.running)
            this.finish();
    };
    Tokenizer.prototype.pause = function () {
        this.running = false;
    };
    Tokenizer.prototype.resume = function () {
        this.running = true;
        if (this._index < this.buffer.length) {
            this.parse();
        }
        if (this.ended) {
            this.finish();
        }
    };
    /**
     * The current index within all of the written data.
     */
    Tokenizer.prototype.getAbsoluteIndex = function () {
        return this.bufferOffset + this._index;
    };
    Tokenizer.prototype.stateText = function (c) {
        if (c === "<") {
            if (this._index > this.sectionStart) {
                this.cbs.ontext(this.getSection());
            }
            this._state = 2 /* BeforeTagName */;
            this.sectionStart = this._index;
        }
        else if (this.decodeEntities &&
            c === "&" &&
            (this.special === 1 /* None */ || this.special === 4 /* Title */)) {
            if (this._index > this.sectionStart) {
                this.cbs.ontext(this.getSection());
            }
            this.baseState = 1 /* Text */;
            this._state = 62 /* BeforeEntity */;
            this.sectionStart = this._index;
        }
    };
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */
    Tokenizer.prototype.isTagStartChar = function (c) {
        return (isASCIIAlpha(c) ||
            (this.xmlMode && !whitespace(c) && c !== "/" && c !== ">"));
    };
    Tokenizer.prototype.stateBeforeTagName = function (c) {
        if (c === "/") {
            this._state = 5 /* BeforeClosingTagName */;
        }
        else if (c === "<") {
            this.cbs.ontext(this.getSection());
            this.sectionStart = this._index;
        }
        else if (c === ">" ||
            this.special !== 1 /* None */ ||
            whitespace(c)) {
            this._state = 1 /* Text */;
        }
        else if (c === "!") {
            this._state = 15 /* BeforeDeclaration */;
            this.sectionStart = this._index + 1;
        }
        else if (c === "?") {
            this._state = 17 /* InProcessingInstruction */;
            this.sectionStart = this._index + 1;
        }
        else if (!this.isTagStartChar(c)) {
            this._state = 1 /* Text */;
        }
        else {
            this._state =
                !this.xmlMode && (c === "s" || c === "S")
                    ? 32 /* BeforeSpecialS */
                    : !this.xmlMode && (c === "t" || c === "T")
                        ? 52 /* BeforeSpecialT */
                        : 3 /* InTagName */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInTagName = function (c) {
        if (c === "/" || c === ">" || whitespace(c)) {
            this.emitToken("onopentagname");
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
        if (whitespace(c)) ;
        else if (c === ">") {
            this._state = 1 /* Text */;
        }
        else if (this.special !== 1 /* None */) {
            if (this.special !== 4 /* Title */ && (c === "s" || c === "S")) {
                this._state = 33 /* BeforeSpecialSEnd */;
            }
            else if (this.special === 4 /* Title */ &&
                (c === "t" || c === "T")) {
                this._state = 53 /* BeforeSpecialTEnd */;
            }
            else {
                this._state = 1 /* Text */;
                this._index--;
            }
        }
        else if (!this.isTagStartChar(c)) {
            this._state = 20 /* InSpecialComment */;
            this.sectionStart = this._index;
        }
        else {
            this._state = 6 /* InClosingTagName */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function (c) {
        if (c === ">" || whitespace(c)) {
            this.emitToken("onclosetag");
            this._state = 7 /* AfterClosingTagName */;
            this._index--;
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
        // Skip everything until ">"
        if (c === ">") {
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
        if (c === ">") {
            this.cbs.onopentagend();
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
        else if (c === "/") {
            this._state = 4 /* InSelfClosingTag */;
        }
        else if (!whitespace(c)) {
            this._state = 9 /* InAttributeName */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
        if (c === ">") {
            this.cbs.onselfclosingtag();
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
            this.special = 1 /* None */; // Reset special state, in case of self-closing special tags
        }
        else if (!whitespace(c)) {
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
    };
    Tokenizer.prototype.stateInAttributeName = function (c) {
        if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
            this.cbs.onattribname(this.getSection());
            this.sectionStart = -1;
            this._state = 10 /* AfterAttributeName */;
            this._index--;
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function (c) {
        if (c === "=") {
            this._state = 11 /* BeforeAttributeValue */;
        }
        else if (c === "/" || c === ">") {
            this.cbs.onattribend(undefined);
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
        else if (!whitespace(c)) {
            this.cbs.onattribend(undefined);
            this._state = 9 /* InAttributeName */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
        if (c === '"') {
            this._state = 12 /* InAttributeValueDq */;
            this.sectionStart = this._index + 1;
        }
        else if (c === "'") {
            this._state = 13 /* InAttributeValueSq */;
            this.sectionStart = this._index + 1;
        }
        else if (!whitespace(c)) {
            this._state = 14 /* InAttributeValueNq */;
            this.sectionStart = this._index;
            this._index--; // Reconsume token
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
        if (c === quote) {
            this.emitToken("onattribdata");
            this.cbs.onattribend(quote);
            this._state = 8 /* BeforeAttributeName */;
        }
        else if (this.decodeEntities && c === "&") {
            this.emitToken("onattribdata");
            this.baseState = this._state;
            this._state = 62 /* BeforeEntity */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
        this.handleInAttributeValue(c, '"');
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
        this.handleInAttributeValue(c, "'");
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
        if (whitespace(c) || c === ">") {
            this.emitToken("onattribdata");
            this.cbs.onattribend(null);
            this._state = 8 /* BeforeAttributeName */;
            this._index--;
        }
        else if (this.decodeEntities && c === "&") {
            this.emitToken("onattribdata");
            this.baseState = this._state;
            this._state = 62 /* BeforeEntity */;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
        this._state =
            c === "["
                ? 23 /* BeforeCdata1 */
                : c === "-"
                    ? 18 /* BeforeComment */
                    : 16 /* InDeclaration */;
    };
    Tokenizer.prototype.stateInDeclaration = function (c) {
        if (c === ">") {
            this.cbs.ondeclaration(this.getSection());
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
        if (c === ">") {
            this.cbs.onprocessinginstruction(this.getSection());
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function (c) {
        if (c === "-") {
            this._state = 19 /* InComment */;
            this.sectionStart = this._index + 1;
        }
        else {
            this._state = 16 /* InDeclaration */;
        }
    };
    Tokenizer.prototype.stateInComment = function (c) {
        if (c === "-")
            this._state = 21 /* AfterComment1 */;
    };
    Tokenizer.prototype.stateInSpecialComment = function (c) {
        if (c === ">") {
            this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index));
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateAfterComment1 = function (c) {
        if (c === "-") {
            this._state = 22 /* AfterComment2 */;
        }
        else {
            this._state = 19 /* InComment */;
        }
    };
    Tokenizer.prototype.stateAfterComment2 = function (c) {
        if (c === ">") {
            // Remove 2 trailing chars
            this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index - 2));
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
        else if (c !== "-") {
            this._state = 19 /* InComment */;
        }
        // Else: stay in AFTER_COMMENT_2 (`--->`)
    };
    Tokenizer.prototype.stateBeforeCdata6 = function (c) {
        if (c === "[") {
            this._state = 29 /* InCdata */;
            this.sectionStart = this._index + 1;
        }
        else {
            this._state = 16 /* InDeclaration */;
            this._index--;
        }
    };
    Tokenizer.prototype.stateInCdata = function (c) {
        if (c === "]")
            this._state = 30 /* AfterCdata1 */;
    };
    Tokenizer.prototype.stateAfterCdata1 = function (c) {
        if (c === "]")
            this._state = 31 /* AfterCdata2 */;
        else
            this._state = 29 /* InCdata */;
    };
    Tokenizer.prototype.stateAfterCdata2 = function (c) {
        if (c === ">") {
            // Remove 2 trailing chars
            this.cbs.oncdata(this.buffer.substring(this.sectionStart, this._index - 2));
            this._state = 1 /* Text */;
            this.sectionStart = this._index + 1;
        }
        else if (c !== "]") {
            this._state = 29 /* InCdata */;
        }
        // Else: stay in AFTER_CDATA_2 (`]]]>`)
    };
    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
        if (c === "c" || c === "C") {
            this._state = 34 /* BeforeScript1 */;
        }
        else if (c === "t" || c === "T") {
            this._state = 44 /* BeforeStyle1 */;
        }
        else {
            this._state = 3 /* InTagName */;
            this._index--; // Consume the token again
        }
    };
    Tokenizer.prototype.stateBeforeSpecialSEnd = function (c) {
        if (this.special === 2 /* Script */ && (c === "c" || c === "C")) {
            this._state = 39 /* AfterScript1 */;
        }
        else if (this.special === 3 /* Style */ && (c === "t" || c === "T")) {
            this._state = 48 /* AfterStyle1 */;
        }
        else
            this._state = 1 /* Text */;
    };
    Tokenizer.prototype.stateBeforeSpecialLast = function (c, special) {
        if (c === "/" || c === ">" || whitespace(c)) {
            this.special = special;
        }
        this._state = 3 /* InTagName */;
        this._index--; // Consume the token again
    };
    Tokenizer.prototype.stateAfterSpecialLast = function (c, sectionStartOffset) {
        if (c === ">" || whitespace(c)) {
            this.special = 1 /* None */;
            this._state = 6 /* InClosingTagName */;
            this.sectionStart = this._index - sectionStartOffset;
            this._index--; // Reconsume the token
        }
        else
            this._state = 1 /* Text */;
    };
    // For entities terminated with a semicolon
    Tokenizer.prototype.parseFixedEntity = function (map) {
        if (map === void 0) { map = this.xmlMode ? xml_json_1$2.default : entities_json_1$2.default; }
        // Offset = 1
        if (this.sectionStart + 1 < this._index) {
            var entity = this.buffer.substring(this.sectionStart + 1, this._index);
            if (Object.prototype.hasOwnProperty.call(map, entity)) {
                this.emitPartial(map[entity]);
                this.sectionStart = this._index + 1;
            }
        }
    };
    // Parses legacy entities (without trailing semicolon)
    Tokenizer.prototype.parseLegacyEntity = function () {
        var start = this.sectionStart + 1;
        // The max length of legacy entities is 6
        var limit = Math.min(this._index - start, 6);
        while (limit >= 2) {
            // The min length of legacy entities is 2
            var entity = this.buffer.substr(start, limit);
            if (Object.prototype.hasOwnProperty.call(legacy_json_1$1.default, entity)) {
                this.emitPartial(legacy_json_1$1.default[entity]);
                this.sectionStart += limit + 1;
                return;
            }
            limit--;
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function (c) {
        if (c === ";") {
            this.parseFixedEntity();
            // Retry as legacy entity if entity wasn't parsed
            if (this.baseState === 1 /* Text */ &&
                this.sectionStart + 1 < this._index &&
                !this.xmlMode) {
                this.parseLegacyEntity();
            }
            this._state = this.baseState;
        }
        else if ((c < "0" || c > "9") && !isASCIIAlpha(c)) {
            if (this.xmlMode || this.sectionStart + 1 === this._index) ;
            else if (this.baseState !== 1 /* Text */) {
                if (c !== "=") {
                    // Parse as legacy entity, without allowing additional characters.
                    this.parseFixedEntity(legacy_json_1$1.default);
                }
            }
            else {
                this.parseLegacyEntity();
            }
            this._state = this.baseState;
            this._index--;
        }
    };
    Tokenizer.prototype.decodeNumericEntity = function (offset, base, strict) {
        var sectionStart = this.sectionStart + offset;
        if (sectionStart !== this._index) {
            // Parse entity
            var entity = this.buffer.substring(sectionStart, this._index);
            var parsed = parseInt(entity, base);
            this.emitPartial(decode_codepoint_1$1.default(parsed));
            this.sectionStart = strict ? this._index + 1 : this._index;
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function (c) {
        if (c === ";") {
            this.decodeNumericEntity(2, 10, true);
        }
        else if (c < "0" || c > "9") {
            if (!this.xmlMode) {
                this.decodeNumericEntity(2, 10, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function (c) {
        if (c === ";") {
            this.decodeNumericEntity(3, 16, true);
        }
        else if ((c < "a" || c > "f") &&
            (c < "A" || c > "F") &&
            (c < "0" || c > "9")) {
            if (!this.xmlMode) {
                this.decodeNumericEntity(3, 16, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
    };
    Tokenizer.prototype.cleanup = function () {
        if (this.sectionStart < 0) {
            this.buffer = "";
            this.bufferOffset += this._index;
            this._index = 0;
        }
        else if (this.running) {
            if (this._state === 1 /* Text */) {
                if (this.sectionStart !== this._index) {
                    this.cbs.ontext(this.buffer.substr(this.sectionStart));
                }
                this.buffer = "";
                this.bufferOffset += this._index;
                this._index = 0;
            }
            else if (this.sectionStart === this._index) {
                // The section just started
                this.buffer = "";
                this.bufferOffset += this._index;
                this._index = 0;
            }
            else {
                // Remove everything unnecessary
                this.buffer = this.buffer.substr(this.sectionStart);
                this._index -= this.sectionStart;
                this.bufferOffset += this.sectionStart;
            }
            this.sectionStart = 0;
        }
    };
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */
    Tokenizer.prototype.parse = function () {
        while (this._index < this.buffer.length && this.running) {
            var c = this.buffer.charAt(this._index);
            if (this._state === 1 /* Text */) {
                this.stateText(c);
            }
            else if (this._state === 12 /* InAttributeValueDq */) {
                this.stateInAttributeValueDoubleQuotes(c);
            }
            else if (this._state === 9 /* InAttributeName */) {
                this.stateInAttributeName(c);
            }
            else if (this._state === 19 /* InComment */) {
                this.stateInComment(c);
            }
            else if (this._state === 20 /* InSpecialComment */) {
                this.stateInSpecialComment(c);
            }
            else if (this._state === 8 /* BeforeAttributeName */) {
                this.stateBeforeAttributeName(c);
            }
            else if (this._state === 3 /* InTagName */) {
                this.stateInTagName(c);
            }
            else if (this._state === 6 /* InClosingTagName */) {
                this.stateInClosingTagName(c);
            }
            else if (this._state === 2 /* BeforeTagName */) {
                this.stateBeforeTagName(c);
            }
            else if (this._state === 10 /* AfterAttributeName */) {
                this.stateAfterAttributeName(c);
            }
            else if (this._state === 13 /* InAttributeValueSq */) {
                this.stateInAttributeValueSingleQuotes(c);
            }
            else if (this._state === 11 /* BeforeAttributeValue */) {
                this.stateBeforeAttributeValue(c);
            }
            else if (this._state === 5 /* BeforeClosingTagName */) {
                this.stateBeforeClosingTagName(c);
            }
            else if (this._state === 7 /* AfterClosingTagName */) {
                this.stateAfterClosingTagName(c);
            }
            else if (this._state === 32 /* BeforeSpecialS */) {
                this.stateBeforeSpecialS(c);
            }
            else if (this._state === 21 /* AfterComment1 */) {
                this.stateAfterComment1(c);
            }
            else if (this._state === 14 /* InAttributeValueNq */) {
                this.stateInAttributeValueNoQuotes(c);
            }
            else if (this._state === 4 /* InSelfClosingTag */) {
                this.stateInSelfClosingTag(c);
            }
            else if (this._state === 16 /* InDeclaration */) {
                this.stateInDeclaration(c);
            }
            else if (this._state === 15 /* BeforeDeclaration */) {
                this.stateBeforeDeclaration(c);
            }
            else if (this._state === 22 /* AfterComment2 */) {
                this.stateAfterComment2(c);
            }
            else if (this._state === 18 /* BeforeComment */) {
                this.stateBeforeComment(c);
            }
            else if (this._state === 33 /* BeforeSpecialSEnd */) {
                this.stateBeforeSpecialSEnd(c);
            }
            else if (this._state === 53 /* BeforeSpecialTEnd */) {
                stateAfterSpecialTEnd(this, c);
            }
            else if (this._state === 39 /* AfterScript1 */) {
                stateAfterScript1(this, c);
            }
            else if (this._state === 40 /* AfterScript2 */) {
                stateAfterScript2(this, c);
            }
            else if (this._state === 41 /* AfterScript3 */) {
                stateAfterScript3(this, c);
            }
            else if (this._state === 34 /* BeforeScript1 */) {
                stateBeforeScript1(this, c);
            }
            else if (this._state === 35 /* BeforeScript2 */) {
                stateBeforeScript2(this, c);
            }
            else if (this._state === 36 /* BeforeScript3 */) {
                stateBeforeScript3(this, c);
            }
            else if (this._state === 37 /* BeforeScript4 */) {
                stateBeforeScript4(this, c);
            }
            else if (this._state === 38 /* BeforeScript5 */) {
                this.stateBeforeSpecialLast(c, 2 /* Script */);
            }
            else if (this._state === 42 /* AfterScript4 */) {
                stateAfterScript4(this, c);
            }
            else if (this._state === 43 /* AfterScript5 */) {
                this.stateAfterSpecialLast(c, 6);
            }
            else if (this._state === 44 /* BeforeStyle1 */) {
                stateBeforeStyle1(this, c);
            }
            else if (this._state === 29 /* InCdata */) {
                this.stateInCdata(c);
            }
            else if (this._state === 45 /* BeforeStyle2 */) {
                stateBeforeStyle2(this, c);
            }
            else if (this._state === 46 /* BeforeStyle3 */) {
                stateBeforeStyle3(this, c);
            }
            else if (this._state === 47 /* BeforeStyle4 */) {
                this.stateBeforeSpecialLast(c, 3 /* Style */);
            }
            else if (this._state === 48 /* AfterStyle1 */) {
                stateAfterStyle1(this, c);
            }
            else if (this._state === 49 /* AfterStyle2 */) {
                stateAfterStyle2(this, c);
            }
            else if (this._state === 50 /* AfterStyle3 */) {
                stateAfterStyle3(this, c);
            }
            else if (this._state === 51 /* AfterStyle4 */) {
                this.stateAfterSpecialLast(c, 5);
            }
            else if (this._state === 52 /* BeforeSpecialT */) {
                stateBeforeSpecialT(this, c);
            }
            else if (this._state === 54 /* BeforeTitle1 */) {
                stateBeforeTitle1(this, c);
            }
            else if (this._state === 55 /* BeforeTitle2 */) {
                stateBeforeTitle2(this, c);
            }
            else if (this._state === 56 /* BeforeTitle3 */) {
                stateBeforeTitle3(this, c);
            }
            else if (this._state === 57 /* BeforeTitle4 */) {
                this.stateBeforeSpecialLast(c, 4 /* Title */);
            }
            else if (this._state === 58 /* AfterTitle1 */) {
                stateAfterTitle1(this, c);
            }
            else if (this._state === 59 /* AfterTitle2 */) {
                stateAfterTitle2(this, c);
            }
            else if (this._state === 60 /* AfterTitle3 */) {
                stateAfterTitle3(this, c);
            }
            else if (this._state === 61 /* AfterTitle4 */) {
                this.stateAfterSpecialLast(c, 5);
            }
            else if (this._state === 17 /* InProcessingInstruction */) {
                this.stateInProcessingInstruction(c);
            }
            else if (this._state === 64 /* InNamedEntity */) {
                this.stateInNamedEntity(c);
            }
            else if (this._state === 23 /* BeforeCdata1 */) {
                stateBeforeCdata1(this, c);
            }
            else if (this._state === 62 /* BeforeEntity */) {
                stateBeforeEntity(this, c);
            }
            else if (this._state === 24 /* BeforeCdata2 */) {
                stateBeforeCdata2(this, c);
            }
            else if (this._state === 25 /* BeforeCdata3 */) {
                stateBeforeCdata3(this, c);
            }
            else if (this._state === 30 /* AfterCdata1 */) {
                this.stateAfterCdata1(c);
            }
            else if (this._state === 31 /* AfterCdata2 */) {
                this.stateAfterCdata2(c);
            }
            else if (this._state === 26 /* BeforeCdata4 */) {
                stateBeforeCdata4(this, c);
            }
            else if (this._state === 27 /* BeforeCdata5 */) {
                stateBeforeCdata5(this, c);
            }
            else if (this._state === 28 /* BeforeCdata6 */) {
                this.stateBeforeCdata6(c);
            }
            else if (this._state === 66 /* InHexEntity */) {
                this.stateInHexEntity(c);
            }
            else if (this._state === 65 /* InNumericEntity */) {
                this.stateInNumericEntity(c);
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            }
            else if (this._state === 63 /* BeforeNumericEntity */) {
                stateBeforeNumericEntity(this, c);
            }
            else {
                this.cbs.onerror(Error("unknown _state"), this._state);
            }
            this._index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function () {
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this._index) {
            this.handleTrailingData();
        }
        this.cbs.onend();
    };
    Tokenizer.prototype.handleTrailingData = function () {
        var data = this.buffer.substr(this.sectionStart);
        if (this._state === 29 /* InCdata */ ||
            this._state === 30 /* AfterCdata1 */ ||
            this._state === 31 /* AfterCdata2 */) {
            this.cbs.oncdata(data);
        }
        else if (this._state === 19 /* InComment */ ||
            this._state === 21 /* AfterComment1 */ ||
            this._state === 22 /* AfterComment2 */) {
            this.cbs.oncomment(data);
        }
        else if (this._state === 64 /* InNamedEntity */ && !this.xmlMode) {
            this.parseLegacyEntity();
            if (this.sectionStart < this._index) {
                this._state = this.baseState;
                this.handleTrailingData();
            }
        }
        else if (this._state === 65 /* InNumericEntity */ && !this.xmlMode) {
            this.decodeNumericEntity(2, 10, false);
            if (this.sectionStart < this._index) {
                this._state = this.baseState;
                this.handleTrailingData();
            }
        }
        else if (this._state === 66 /* InHexEntity */ && !this.xmlMode) {
            this.decodeNumericEntity(3, 16, false);
            if (this.sectionStart < this._index) {
                this._state = this.baseState;
                this.handleTrailingData();
            }
        }
        else if (this._state !== 3 /* InTagName */ &&
            this._state !== 8 /* BeforeAttributeName */ &&
            this._state !== 11 /* BeforeAttributeValue */ &&
            this._state !== 10 /* AfterAttributeName */ &&
            this._state !== 9 /* InAttributeName */ &&
            this._state !== 13 /* InAttributeValueSq */ &&
            this._state !== 12 /* InAttributeValueDq */ &&
            this._state !== 14 /* InAttributeValueNq */ &&
            this._state !== 6 /* InClosingTagName */) {
            this.cbs.ontext(data);
        }
        /*
         * Else, ignore remaining data
         * TODO add a way to remove current tag
         */
    };
    Tokenizer.prototype.getSection = function () {
        return this.buffer.substring(this.sectionStart, this._index);
    };
    Tokenizer.prototype.emitToken = function (name) {
        this.cbs[name](this.getSection());
        this.sectionStart = -1;
    };
    Tokenizer.prototype.emitPartial = function (value) {
        if (this.baseState !== 1 /* Text */) {
            this.cbs.onattribdata(value); // TODO implement the new event
        }
        else {
            this.cbs.ontext(value);
        }
    };
    return Tokenizer;
}());
Tokenizer$1.default = Tokenizer;

var __importDefault$5 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Parser$3, "__esModule", { value: true });
Parser$3.Parser = void 0;
var Tokenizer_1 = __importDefault$5(Tokenizer$1);
var formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea",
]);
var pTag = new Set(["p"]);
var openImpliesClose = {
    tr: new Set(["tr", "th", "td"]),
    th: new Set(["th"]),
    td: new Set(["thead", "th", "td"]),
    body: new Set(["head", "link", "script"]),
    li: new Set(["li"]),
    p: pTag,
    h1: pTag,
    h2: pTag,
    h3: pTag,
    h4: pTag,
    h5: pTag,
    h6: pTag,
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: new Set(["option"]),
    optgroup: new Set(["optgroup", "option"]),
    dd: new Set(["dt", "dd"]),
    dt: new Set(["dt", "dd"]),
    address: pTag,
    article: pTag,
    aside: pTag,
    blockquote: pTag,
    details: pTag,
    div: pTag,
    dl: pTag,
    fieldset: pTag,
    figcaption: pTag,
    figure: pTag,
    footer: pTag,
    form: pTag,
    header: pTag,
    hr: pTag,
    main: pTag,
    nav: pTag,
    ol: pTag,
    pre: pTag,
    section: pTag,
    table: pTag,
    ul: pTag,
    rt: new Set(["rt", "rp"]),
    rp: new Set(["rt", "rp"]),
    tbody: new Set(["thead", "tbody"]),
    tfoot: new Set(["thead", "tbody"]),
};
var voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title",
]);
var reNameEnd = /\s|\//;
var Parser$2 = /** @class */ (function () {
    function Parser(cbs, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        /** The start index of the last event. */
        this.startIndex = 0;
        /** The end index of the last event. */
        this.endIndex = null;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.options = options;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames =
            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }
    Parser.prototype.updatePosition = function (initialOffset) {
        if (this.endIndex === null) {
            if (this.tokenizer.sectionStart <= initialOffset) {
                this.startIndex = 0;
            }
            else {
                this.startIndex = this.tokenizer.sectionStart - initialOffset;
            }
        }
        else {
            this.startIndex = this.endIndex + 1;
        }
        this.endIndex = this.tokenizer.getAbsoluteIndex();
    };
    // Tokenizer event handlers
    Parser.prototype.ontext = function (data) {
        var _a, _b;
        this.updatePosition(1);
        this.endIndex--;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
    };
    Parser.prototype.onopentagname = function (name) {
        var _a, _b;
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this.tagname = name;
        if (!this.options.xmlMode &&
            Object.prototype.hasOwnProperty.call(openImpliesClose, name)) {
            var el = void 0;
            while (this.stack.length > 0 &&
                openImpliesClose[name].has((el = this.stack[this.stack.length - 1]))) {
                this.onclosetag(el);
            }
        }
        if (this.options.xmlMode || !voidElements.has(name)) {
            this.stack.push(name);
            if (foreignContextElements.has(name)) {
                this.foreignContext.push(true);
            }
            else if (htmlIntegrationElements.has(name)) {
                this.foreignContext.push(false);
            }
        }
        (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
        if (this.cbs.onopentag)
            this.attribs = {};
    };
    Parser.prototype.onopentagend = function () {
        var _a, _b;
        this.updatePosition(1);
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs);
            this.attribs = null;
        }
        if (!this.options.xmlMode &&
            this.cbs.onclosetag &&
            voidElements.has(this.tagname)) {
            this.cbs.onclosetag(this.tagname);
        }
        this.tagname = "";
    };
    Parser.prototype.onclosetag = function (name) {
        this.updatePosition(1);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) ||
            htmlIntegrationElements.has(name)) {
            this.foreignContext.pop();
        }
        if (this.stack.length &&
            (this.options.xmlMode || !voidElements.has(name))) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    pos = this.stack.length - pos;
                    while (pos--) {
                        // We know the stack has sufficient elements.
                        this.cbs.onclosetag(this.stack.pop());
                    }
                }
                else
                    this.stack.length = pos;
            }
            else if (name === "p" && !this.options.xmlMode) {
                this.onopentagname(name);
                this.closeCurrentTag();
            }
        }
        else if (!this.options.xmlMode && (name === "br" || name === "p")) {
            this.onopentagname(name);
            this.closeCurrentTag();
        }
    };
    Parser.prototype.onselfclosingtag = function () {
        if (this.options.xmlMode ||
            this.options.recognizeSelfClosing ||
            this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag();
        }
        else {
            this.onopentagend();
        }
    };
    Parser.prototype.closeCurrentTag = function () {
        var _a, _b;
        var name = this.tagname;
        this.onopentagend();
        /*
         * Self-closing tags will be on the top of the stack
         * (cheaper check than in onclosetag)
         */
        if (this.stack[this.stack.length - 1] === name) {
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name);
            this.stack.pop();
        }
    };
    Parser.prototype.onattribname = function (name) {
        if (this.lowerCaseAttributeNames) {
            name = name.toLowerCase();
        }
        this.attribname = name;
    };
    Parser.prototype.onattribdata = function (value) {
        this.attribvalue += value;
    };
    Parser.prototype.onattribend = function (quote) {
        var _a, _b;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);
        if (this.attribs &&
            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribname = "";
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function (value) {
        var idx = value.search(reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    };
    Parser.prototype.ondeclaration = function (value) {
        if (this.cbs.onprocessinginstruction) {
            var name_1 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
    };
    Parser.prototype.onprocessinginstruction = function (value) {
        if (this.cbs.onprocessinginstruction) {
            var name_2 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
    };
    Parser.prototype.oncomment = function (value) {
        var _a, _b, _c, _d;
        this.updatePosition(4);
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
    };
    Parser.prototype.oncdata = function (value) {
        var _a, _b, _c, _d, _e, _f;
        this.updatePosition(1);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else {
            this.oncomment("[CDATA[" + value + "]]");
        }
    };
    Parser.prototype.onerror = function (err) {
        var _a, _b;
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    Parser.prototype.onend = function () {
        var _a, _b;
        if (this.cbs.onclosetag) {
            for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i]))
                ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */
    Parser.prototype.reset = function () {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack = [];
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */
    Parser.prototype.parseComplete = function (data) {
        this.reset();
        this.end(data);
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */
    Parser.prototype.write = function (chunk) {
        this.tokenizer.write(chunk);
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */
    Parser.prototype.end = function (chunk) {
        this.tokenizer.end(chunk);
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */
    Parser.prototype.pause = function () {
        this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */
    Parser.prototype.resume = function () {
        this.tokenizer.resume();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */
    Parser.prototype.parseChunk = function (chunk) {
        this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */
    Parser.prototype.done = function (chunk) {
        this.end(chunk);
    };
    return Parser;
}());
Parser$3.Parser = Parser$2;

var lib$4 = {};

var lib$3 = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;
}(lib$3));

var node = {};

var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(node, "__esModule", { value: true });
node.cloneNode = node.hasChildren = node.isDocument = node.isDirective = node.isComment = node.isText = node.isCDATA = node.isTag = node.Element = node.Document = node.NodeWithChildren = node.ProcessingInstruction = node.Comment = node.Text = node.DataNode = node.Node = void 0;
var domelementtype_1$1 = lib$3;
var nodeTypes = new Map([
    [domelementtype_1$1.ElementType.Tag, 1],
    [domelementtype_1$1.ElementType.Script, 1],
    [domelementtype_1$1.ElementType.Style, 1],
    [domelementtype_1$1.ElementType.Directive, 1],
    [domelementtype_1$1.ElementType.Text, 3],
    [domelementtype_1$1.ElementType.CDATA, 4],
    [domelementtype_1$1.ElementType.Comment, 8],
    [domelementtype_1$1.ElementType.Root, 9],
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node$6 = /** @class */ (function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
        this.type = type;
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode$1(this, recursive);
    };
    return Node;
}());
node.Node = Node$6;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends$1(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node$6));
node.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends$1(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1$1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
node.Text = Text;
/**
 * Comments within the document.
 */
var Comment$5 = /** @class */ (function (_super) {
    __extends$1(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1$1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
node.Comment = Comment$5;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends$1(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1$1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
node.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends$1(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node$6));
node.NodeWithChildren = NodeWithChildren;
/**
 * The root node of the document.
 */
var Document$4 = /** @class */ (function (_super) {
    __extends$1(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1$1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
node.Document = Document$4;
/**
 * An element within the DOM.
 */
var Element$5 = /** @class */ (function (_super) {
    __extends$1(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1$1.ElementType.Script
            : name === "style"
                ? domelementtype_1$1.ElementType.Style
                : domelementtype_1$1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
node.Element = Element$5;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1$1.isTag)(node);
}
node.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1$1.ElementType.CDATA;
}
node.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1$1.ElementType.Text;
}
node.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1$1.ElementType.Comment;
}
node.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1$1.ElementType.Directive;
}
node.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1$1.ElementType.Root;
}
node.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
node.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode$1(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment$5(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element$5(node.name, __assign$1({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign$1({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign$1({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1$1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document$4(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
node.cloneNode = cloneNode$1;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode$1(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomHandler = void 0;
var domelementtype_1 = lib$3;
var node_1 = node;
__exportStar(node, exports);
var reWhitespace = /\s+/g;
// Default options
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports.default = DomHandler;
}(lib$4));

var FeedHandler$1 = {};

var lib$2 = {};

var stringify$5 = {};

var lib$1 = {};

var lib = {};

var decode = {};

var Aacute$1 = "Á";
var aacute$1 = "á";
var Abreve = "Ă";
var abreve = "ă";
var ac = "∾";
var acd = "∿";
var acE = "∾̳";
var Acirc$1 = "Â";
var acirc$1 = "â";
var acute$1 = "´";
var Acy = "А";
var acy = "а";
var AElig$1 = "Æ";
var aelig$1 = "æ";
var af = "⁡";
var Afr = "𝔄";
var afr = "𝔞";
var Agrave$1 = "À";
var agrave$1 = "à";
var alefsym = "ℵ";
var aleph = "ℵ";
var Alpha = "Α";
var alpha = "α";
var Amacr = "Ā";
var amacr = "ā";
var amalg = "⨿";
var amp$2 = "&";
var AMP$1 = "&";
var andand = "⩕";
var And = "⩓";
var and = "∧";
var andd = "⩜";
var andslope = "⩘";
var andv = "⩚";
var ang = "∠";
var ange = "⦤";
var angle = "∠";
var angmsdaa = "⦨";
var angmsdab = "⦩";
var angmsdac = "⦪";
var angmsdad = "⦫";
var angmsdae = "⦬";
var angmsdaf = "⦭";
var angmsdag = "⦮";
var angmsdah = "⦯";
var angmsd = "∡";
var angrt = "∟";
var angrtvb = "⊾";
var angrtvbd = "⦝";
var angsph = "∢";
var angst = "Å";
var angzarr = "⍼";
var Aogon = "Ą";
var aogon = "ą";
var Aopf = "𝔸";
var aopf = "𝕒";
var apacir = "⩯";
var ap = "≈";
var apE = "⩰";
var ape = "≊";
var apid = "≋";
var apos$1 = "'";
var ApplyFunction = "⁡";
var approx = "≈";
var approxeq = "≊";
var Aring$1 = "Å";
var aring$1 = "å";
var Ascr = "𝒜";
var ascr = "𝒶";
var Assign = "≔";
var ast = "*";
var asymp = "≈";
var asympeq = "≍";
var Atilde$1 = "Ã";
var atilde$1 = "ã";
var Auml$1 = "Ä";
var auml$1 = "ä";
var awconint = "∳";
var awint = "⨑";
var backcong = "≌";
var backepsilon = "϶";
var backprime = "‵";
var backsim = "∽";
var backsimeq = "⋍";
var Backslash = "∖";
var Barv = "⫧";
var barvee = "⊽";
var barwed = "⌅";
var Barwed = "⌆";
var barwedge = "⌅";
var bbrk = "⎵";
var bbrktbrk = "⎶";
var bcong = "≌";
var Bcy = "Б";
var bcy = "б";
var bdquo = "„";
var becaus = "∵";
var because = "∵";
var Because = "∵";
var bemptyv = "⦰";
var bepsi = "϶";
var bernou = "ℬ";
var Bernoullis = "ℬ";
var Beta = "Β";
var beta = "β";
var beth = "ℶ";
var between = "≬";
var Bfr = "𝔅";
var bfr = "𝔟";
var bigcap = "⋂";
var bigcirc = "◯";
var bigcup = "⋃";
var bigodot = "⨀";
var bigoplus = "⨁";
var bigotimes = "⨂";
var bigsqcup = "⨆";
var bigstar = "★";
var bigtriangledown = "▽";
var bigtriangleup = "△";
var biguplus = "⨄";
var bigvee = "⋁";
var bigwedge = "⋀";
var bkarow = "⤍";
var blacklozenge = "⧫";
var blacksquare = "▪";
var blacktriangle = "▴";
var blacktriangledown = "▾";
var blacktriangleleft = "◂";
var blacktriangleright = "▸";
var blank = "␣";
var blk12 = "▒";
var blk14 = "░";
var blk34 = "▓";
var block = "█";
var bne = "=⃥";
var bnequiv = "≡⃥";
var bNot = "⫭";
var bnot = "⌐";
var Bopf = "𝔹";
var bopf = "𝕓";
var bot = "⊥";
var bottom = "⊥";
var bowtie = "⋈";
var boxbox = "⧉";
var boxdl = "┐";
var boxdL = "╕";
var boxDl = "╖";
var boxDL = "╗";
var boxdr = "┌";
var boxdR = "╒";
var boxDr = "╓";
var boxDR = "╔";
var boxh = "─";
var boxH = "═";
var boxhd = "┬";
var boxHd = "╤";
var boxhD = "╥";
var boxHD = "╦";
var boxhu = "┴";
var boxHu = "╧";
var boxhU = "╨";
var boxHU = "╩";
var boxminus = "⊟";
var boxplus = "⊞";
var boxtimes = "⊠";
var boxul = "┘";
var boxuL = "╛";
var boxUl = "╜";
var boxUL = "╝";
var boxur = "└";
var boxuR = "╘";
var boxUr = "╙";
var boxUR = "╚";
var boxv = "│";
var boxV = "║";
var boxvh = "┼";
var boxvH = "╪";
var boxVh = "╫";
var boxVH = "╬";
var boxvl = "┤";
var boxvL = "╡";
var boxVl = "╢";
var boxVL = "╣";
var boxvr = "├";
var boxvR = "╞";
var boxVr = "╟";
var boxVR = "╠";
var bprime = "‵";
var breve = "˘";
var Breve = "˘";
var brvbar$1 = "¦";
var bscr = "𝒷";
var Bscr = "ℬ";
var bsemi = "⁏";
var bsim = "∽";
var bsime = "⋍";
var bsolb = "⧅";
var bsol = "\\";
var bsolhsub = "⟈";
var bull = "•";
var bullet = "•";
var bump = "≎";
var bumpE = "⪮";
var bumpe = "≏";
var Bumpeq = "≎";
var bumpeq = "≏";
var Cacute = "Ć";
var cacute = "ć";
var capand = "⩄";
var capbrcup = "⩉";
var capcap = "⩋";
var cap = "∩";
var Cap = "⋒";
var capcup = "⩇";
var capdot = "⩀";
var CapitalDifferentialD = "ⅅ";
var caps = "∩︀";
var caret = "⁁";
var caron = "ˇ";
var Cayleys = "ℭ";
var ccaps = "⩍";
var Ccaron = "Č";
var ccaron = "č";
var Ccedil$1 = "Ç";
var ccedil$1 = "ç";
var Ccirc = "Ĉ";
var ccirc = "ĉ";
var Cconint = "∰";
var ccups = "⩌";
var ccupssm = "⩐";
var Cdot = "Ċ";
var cdot = "ċ";
var cedil$1 = "¸";
var Cedilla = "¸";
var cemptyv = "⦲";
var cent$1 = "¢";
var centerdot = "·";
var CenterDot = "·";
var cfr = "𝔠";
var Cfr = "ℭ";
var CHcy = "Ч";
var chcy = "ч";
var check = "✓";
var checkmark = "✓";
var Chi = "Χ";
var chi = "χ";
var circ = "ˆ";
var circeq = "≗";
var circlearrowleft = "↺";
var circlearrowright = "↻";
var circledast = "⊛";
var circledcirc = "⊚";
var circleddash = "⊝";
var CircleDot = "⊙";
var circledR = "®";
var circledS = "Ⓢ";
var CircleMinus = "⊖";
var CirclePlus = "⊕";
var CircleTimes = "⊗";
var cir = "○";
var cirE = "⧃";
var cire = "≗";
var cirfnint = "⨐";
var cirmid = "⫯";
var cirscir = "⧂";
var ClockwiseContourIntegral = "∲";
var CloseCurlyDoubleQuote = "”";
var CloseCurlyQuote = "’";
var clubs = "♣";
var clubsuit = "♣";
var colon = ":";
var Colon = "∷";
var Colone = "⩴";
var colone = "≔";
var coloneq = "≔";
var comma = ",";
var commat = "@";
var comp = "∁";
var compfn = "∘";
var complement = "∁";
var complexes = "ℂ";
var cong = "≅";
var congdot = "⩭";
var Congruent = "≡";
var conint = "∮";
var Conint = "∯";
var ContourIntegral = "∮";
var copf = "𝕔";
var Copf = "ℂ";
var coprod = "∐";
var Coproduct = "∐";
var copy$2 = "©";
var COPY$1 = "©";
var copysr = "℗";
var CounterClockwiseContourIntegral = "∳";
var crarr = "↵";
var cross = "✗";
var Cross = "⨯";
var Cscr = "𝒞";
var cscr = "𝒸";
var csub = "⫏";
var csube = "⫑";
var csup = "⫐";
var csupe = "⫒";
var ctdot = "⋯";
var cudarrl = "⤸";
var cudarrr = "⤵";
var cuepr = "⋞";
var cuesc = "⋟";
var cularr = "↶";
var cularrp = "⤽";
var cupbrcap = "⩈";
var cupcap = "⩆";
var CupCap = "≍";
var cup = "∪";
var Cup = "⋓";
var cupcup = "⩊";
var cupdot = "⊍";
var cupor = "⩅";
var cups = "∪︀";
var curarr = "↷";
var curarrm = "⤼";
var curlyeqprec = "⋞";
var curlyeqsucc = "⋟";
var curlyvee = "⋎";
var curlywedge = "⋏";
var curren$1 = "¤";
var curvearrowleft = "↶";
var curvearrowright = "↷";
var cuvee = "⋎";
var cuwed = "⋏";
var cwconint = "∲";
var cwint = "∱";
var cylcty = "⌭";
var dagger = "†";
var Dagger = "‡";
var daleth = "ℸ";
var darr = "↓";
var Darr = "↡";
var dArr = "⇓";
var dash = "‐";
var Dashv = "⫤";
var dashv = "⊣";
var dbkarow = "⤏";
var dblac = "˝";
var Dcaron = "Ď";
var dcaron = "ď";
var Dcy = "Д";
var dcy = "д";
var ddagger = "‡";
var ddarr = "⇊";
var DD = "ⅅ";
var dd = "ⅆ";
var DDotrahd = "⤑";
var ddotseq = "⩷";
var deg$1 = "°";
var Del = "∇";
var Delta = "Δ";
var delta = "δ";
var demptyv = "⦱";
var dfisht = "⥿";
var Dfr = "𝔇";
var dfr = "𝔡";
var dHar = "⥥";
var dharl = "⇃";
var dharr = "⇂";
var DiacriticalAcute = "´";
var DiacriticalDot = "˙";
var DiacriticalDoubleAcute = "˝";
var DiacriticalGrave = "`";
var DiacriticalTilde = "˜";
var diam = "⋄";
var diamond = "⋄";
var Diamond = "⋄";
var diamondsuit = "♦";
var diams = "♦";
var die = "¨";
var DifferentialD = "ⅆ";
var digamma = "ϝ";
var disin = "⋲";
var div$1 = "÷";
var divide$1 = "÷";
var divideontimes = "⋇";
var divonx = "⋇";
var DJcy = "Ђ";
var djcy = "ђ";
var dlcorn = "⌞";
var dlcrop = "⌍";
var dollar = "$";
var Dopf = "𝔻";
var dopf = "𝕕";
var Dot = "¨";
var dot$1 = "˙";
var DotDot = "⃜";
var doteq = "≐";
var doteqdot = "≑";
var DotEqual = "≐";
var dotminus = "∸";
var dotplus = "∔";
var dotsquare = "⊡";
var doublebarwedge = "⌆";
var DoubleContourIntegral = "∯";
var DoubleDot = "¨";
var DoubleDownArrow = "⇓";
var DoubleLeftArrow = "⇐";
var DoubleLeftRightArrow = "⇔";
var DoubleLeftTee = "⫤";
var DoubleLongLeftArrow = "⟸";
var DoubleLongLeftRightArrow = "⟺";
var DoubleLongRightArrow = "⟹";
var DoubleRightArrow = "⇒";
var DoubleRightTee = "⊨";
var DoubleUpArrow = "⇑";
var DoubleUpDownArrow = "⇕";
var DoubleVerticalBar = "∥";
var DownArrowBar = "⤓";
var downarrow = "↓";
var DownArrow = "↓";
var Downarrow = "⇓";
var DownArrowUpArrow = "⇵";
var DownBreve = "̑";
var downdownarrows = "⇊";
var downharpoonleft = "⇃";
var downharpoonright = "⇂";
var DownLeftRightVector = "⥐";
var DownLeftTeeVector = "⥞";
var DownLeftVectorBar = "⥖";
var DownLeftVector = "↽";
var DownRightTeeVector = "⥟";
var DownRightVectorBar = "⥗";
var DownRightVector = "⇁";
var DownTeeArrow = "↧";
var DownTee = "⊤";
var drbkarow = "⤐";
var drcorn = "⌟";
var drcrop = "⌌";
var Dscr = "𝒟";
var dscr = "𝒹";
var DScy = "Ѕ";
var dscy = "ѕ";
var dsol = "⧶";
var Dstrok = "Đ";
var dstrok = "đ";
var dtdot = "⋱";
var dtri = "▿";
var dtrif = "▾";
var duarr = "⇵";
var duhar = "⥯";
var dwangle = "⦦";
var DZcy = "Џ";
var dzcy = "џ";
var dzigrarr = "⟿";
var Eacute$1 = "É";
var eacute$1 = "é";
var easter = "⩮";
var Ecaron = "Ě";
var ecaron = "ě";
var Ecirc$1 = "Ê";
var ecirc$1 = "ê";
var ecir = "≖";
var ecolon = "≕";
var Ecy = "Э";
var ecy = "э";
var eDDot = "⩷";
var Edot = "Ė";
var edot = "ė";
var eDot = "≑";
var ee = "ⅇ";
var efDot = "≒";
var Efr = "𝔈";
var efr = "𝔢";
var eg = "⪚";
var Egrave$1 = "È";
var egrave$1 = "è";
var egs = "⪖";
var egsdot = "⪘";
var el = "⪙";
var Element$4 = "∈";
var elinters = "⏧";
var ell = "ℓ";
var els = "⪕";
var elsdot = "⪗";
var Emacr = "Ē";
var emacr = "ē";
var empty$2 = "∅";
var emptyset = "∅";
var EmptySmallSquare = "◻";
var emptyv = "∅";
var EmptyVerySmallSquare = "▫";
var emsp13 = " ";
var emsp14 = " ";
var emsp = " ";
var ENG = "Ŋ";
var eng = "ŋ";
var ensp = " ";
var Eogon = "Ę";
var eogon = "ę";
var Eopf = "𝔼";
var eopf = "𝕖";
var epar = "⋕";
var eparsl = "⧣";
var eplus = "⩱";
var epsi = "ε";
var Epsilon = "Ε";
var epsilon = "ε";
var epsiv = "ϵ";
var eqcirc = "≖";
var eqcolon = "≕";
var eqsim = "≂";
var eqslantgtr = "⪖";
var eqslantless = "⪕";
var Equal = "⩵";
var equals = "=";
var EqualTilde = "≂";
var equest = "≟";
var Equilibrium = "⇌";
var equiv = "≡";
var equivDD = "⩸";
var eqvparsl = "⧥";
var erarr = "⥱";
var erDot = "≓";
var escr = "ℯ";
var Escr = "ℰ";
var esdot = "≐";
var Esim = "⩳";
var esim = "≂";
var Eta = "Η";
var eta = "η";
var ETH$1 = "Ð";
var eth$1 = "ð";
var Euml$1 = "Ë";
var euml$1 = "ë";
var euro = "€";
var excl = "!";
var exist = "∃";
var Exists = "∃";
var expectation = "ℰ";
var exponentiale = "ⅇ";
var ExponentialE = "ⅇ";
var fallingdotseq = "≒";
var Fcy = "Ф";
var fcy = "ф";
var female = "♀";
var ffilig = "ﬃ";
var fflig = "ﬀ";
var ffllig = "ﬄ";
var Ffr = "𝔉";
var ffr = "𝔣";
var filig = "ﬁ";
var FilledSmallSquare = "◼";
var FilledVerySmallSquare = "▪";
var fjlig = "fj";
var flat = "♭";
var fllig = "ﬂ";
var fltns = "▱";
var fnof = "ƒ";
var Fopf = "𝔽";
var fopf = "𝕗";
var forall = "∀";
var ForAll = "∀";
var fork = "⋔";
var forkv = "⫙";
var Fouriertrf = "ℱ";
var fpartint = "⨍";
var frac12$1 = "½";
var frac13 = "⅓";
var frac14$1 = "¼";
var frac15 = "⅕";
var frac16 = "⅙";
var frac18 = "⅛";
var frac23 = "⅔";
var frac25 = "⅖";
var frac34$1 = "¾";
var frac35 = "⅗";
var frac38 = "⅜";
var frac45 = "⅘";
var frac56 = "⅚";
var frac58 = "⅝";
var frac78 = "⅞";
var frasl = "⁄";
var frown = "⌢";
var fscr = "𝒻";
var Fscr = "ℱ";
var gacute = "ǵ";
var Gamma = "Γ";
var gamma$2 = "γ";
var Gammad = "Ϝ";
var gammad = "ϝ";
var gap = "⪆";
var Gbreve = "Ğ";
var gbreve = "ğ";
var Gcedil = "Ģ";
var Gcirc = "Ĝ";
var gcirc = "ĝ";
var Gcy = "Г";
var gcy = "г";
var Gdot = "Ġ";
var gdot = "ġ";
var ge = "≥";
var gE = "≧";
var gEl = "⪌";
var gel = "⋛";
var geq = "≥";
var geqq = "≧";
var geqslant = "⩾";
var gescc = "⪩";
var ges = "⩾";
var gesdot = "⪀";
var gesdoto = "⪂";
var gesdotol = "⪄";
var gesl = "⋛︀";
var gesles = "⪔";
var Gfr = "𝔊";
var gfr = "𝔤";
var gg = "≫";
var Gg = "⋙";
var ggg = "⋙";
var gimel = "ℷ";
var GJcy = "Ѓ";
var gjcy = "ѓ";
var gla = "⪥";
var gl = "≷";
var glE = "⪒";
var glj = "⪤";
var gnap = "⪊";
var gnapprox = "⪊";
var gne = "⪈";
var gnE = "≩";
var gneq = "⪈";
var gneqq = "≩";
var gnsim = "⋧";
var Gopf = "𝔾";
var gopf = "𝕘";
var grave = "`";
var GreaterEqual = "≥";
var GreaterEqualLess = "⋛";
var GreaterFullEqual = "≧";
var GreaterGreater = "⪢";
var GreaterLess = "≷";
var GreaterSlantEqual = "⩾";
var GreaterTilde = "≳";
var Gscr = "𝒢";
var gscr = "ℊ";
var gsim = "≳";
var gsime = "⪎";
var gsiml = "⪐";
var gtcc = "⪧";
var gtcir = "⩺";
var gt$2 = ">";
var GT$1 = ">";
var Gt = "≫";
var gtdot = "⋗";
var gtlPar = "⦕";
var gtquest = "⩼";
var gtrapprox = "⪆";
var gtrarr = "⥸";
var gtrdot = "⋗";
var gtreqless = "⋛";
var gtreqqless = "⪌";
var gtrless = "≷";
var gtrsim = "≳";
var gvertneqq = "≩︀";
var gvnE = "≩︀";
var Hacek = "ˇ";
var hairsp = " ";
var half = "½";
var hamilt = "ℋ";
var HARDcy = "Ъ";
var hardcy = "ъ";
var harrcir = "⥈";
var harr = "↔";
var hArr = "⇔";
var harrw = "↭";
var Hat = "^";
var hbar = "ℏ";
var Hcirc = "Ĥ";
var hcirc = "ĥ";
var hearts = "♥";
var heartsuit = "♥";
var hellip = "…";
var hercon = "⊹";
var hfr = "𝔥";
var Hfr = "ℌ";
var HilbertSpace = "ℋ";
var hksearow = "⤥";
var hkswarow = "⤦";
var hoarr = "⇿";
var homtht = "∻";
var hookleftarrow = "↩";
var hookrightarrow = "↪";
var hopf = "𝕙";
var Hopf = "ℍ";
var horbar = "―";
var HorizontalLine = "─";
var hscr = "𝒽";
var Hscr = "ℋ";
var hslash = "ℏ";
var Hstrok = "Ħ";
var hstrok = "ħ";
var HumpDownHump = "≎";
var HumpEqual = "≏";
var hybull = "⁃";
var hyphen = "‐";
var Iacute$1 = "Í";
var iacute$1 = "í";
var ic = "⁣";
var Icirc$1 = "Î";
var icirc$1 = "î";
var Icy = "И";
var icy = "и";
var Idot = "İ";
var IEcy = "Е";
var iecy = "е";
var iexcl$1 = "¡";
var iff = "⇔";
var ifr = "𝔦";
var Ifr = "ℑ";
var Igrave$1 = "Ì";
var igrave$1 = "ì";
var ii = "ⅈ";
var iiiint = "⨌";
var iiint = "∭";
var iinfin = "⧜";
var iiota = "℩";
var IJlig = "Ĳ";
var ijlig = "ĳ";
var Imacr = "Ī";
var imacr = "ī";
var image = "ℑ";
var ImaginaryI = "ⅈ";
var imagline = "ℐ";
var imagpart = "ℑ";
var imath = "ı";
var Im = "ℑ";
var imof = "⊷";
var imped = "Ƶ";
var Implies = "⇒";
var incare = "℅";
var infin = "∞";
var infintie = "⧝";
var inodot = "ı";
var intcal = "⊺";
var int = "∫";
var Int = "∬";
var integers = "ℤ";
var Integral = "∫";
var intercal = "⊺";
var Intersection = "⋂";
var intlarhk = "⨗";
var intprod = "⨼";
var InvisibleComma = "⁣";
var InvisibleTimes = "⁢";
var IOcy = "Ё";
var iocy = "ё";
var Iogon = "Į";
var iogon = "į";
var Iopf = "𝕀";
var iopf = "𝕚";
var Iota = "Ι";
var iota = "ι";
var iprod = "⨼";
var iquest$1 = "¿";
var iscr = "𝒾";
var Iscr = "ℐ";
var isin = "∈";
var isindot = "⋵";
var isinE = "⋹";
var isins = "⋴";
var isinsv = "⋳";
var isinv = "∈";
var it = "⁢";
var Itilde = "Ĩ";
var itilde = "ĩ";
var Iukcy = "І";
var iukcy = "і";
var Iuml$1 = "Ï";
var iuml$1 = "ï";
var Jcirc = "Ĵ";
var jcirc = "ĵ";
var Jcy = "Й";
var jcy = "й";
var Jfr = "𝔍";
var jfr = "𝔧";
var jmath = "ȷ";
var Jopf = "𝕁";
var jopf = "𝕛";
var Jscr = "𝒥";
var jscr = "𝒿";
var Jsercy = "Ј";
var jsercy = "ј";
var Jukcy = "Є";
var jukcy = "є";
var Kappa = "Κ";
var kappa = "κ";
var kappav = "ϰ";
var Kcedil = "Ķ";
var kcedil = "ķ";
var Kcy = "К";
var kcy = "к";
var Kfr = "𝔎";
var kfr = "𝔨";
var kgreen = "ĸ";
var KHcy = "Х";
var khcy = "х";
var KJcy = "Ќ";
var kjcy = "ќ";
var Kopf = "𝕂";
var kopf = "𝕜";
var Kscr = "𝒦";
var kscr = "𝓀";
var lAarr = "⇚";
var Lacute = "Ĺ";
var lacute = "ĺ";
var laemptyv = "⦴";
var lagran = "ℒ";
var Lambda = "Λ";
var lambda = "λ";
var lang = "⟨";
var Lang = "⟪";
var langd = "⦑";
var langle = "⟨";
var lap = "⪅";
var Laplacetrf = "ℒ";
var laquo$1 = "«";
var larrb = "⇤";
var larrbfs = "⤟";
var larr = "←";
var Larr = "↞";
var lArr = "⇐";
var larrfs = "⤝";
var larrhk = "↩";
var larrlp = "↫";
var larrpl = "⤹";
var larrsim = "⥳";
var larrtl = "↢";
var latail = "⤙";
var lAtail = "⤛";
var lat = "⪫";
var late = "⪭";
var lates = "⪭︀";
var lbarr = "⤌";
var lBarr = "⤎";
var lbbrk = "❲";
var lbrace = "{";
var lbrack = "[";
var lbrke = "⦋";
var lbrksld = "⦏";
var lbrkslu = "⦍";
var Lcaron = "Ľ";
var lcaron = "ľ";
var Lcedil = "Ļ";
var lcedil = "ļ";
var lceil = "⌈";
var lcub = "{";
var Lcy = "Л";
var lcy = "л";
var ldca = "⤶";
var ldquo = "“";
var ldquor = "„";
var ldrdhar = "⥧";
var ldrushar = "⥋";
var ldsh = "↲";
var le = "≤";
var lE = "≦";
var LeftAngleBracket = "⟨";
var LeftArrowBar = "⇤";
var leftarrow = "←";
var LeftArrow = "←";
var Leftarrow = "⇐";
var LeftArrowRightArrow = "⇆";
var leftarrowtail = "↢";
var LeftCeiling = "⌈";
var LeftDoubleBracket = "⟦";
var LeftDownTeeVector = "⥡";
var LeftDownVectorBar = "⥙";
var LeftDownVector = "⇃";
var LeftFloor = "⌊";
var leftharpoondown = "↽";
var leftharpoonup = "↼";
var leftleftarrows = "⇇";
var leftrightarrow = "↔";
var LeftRightArrow = "↔";
var Leftrightarrow = "⇔";
var leftrightarrows = "⇆";
var leftrightharpoons = "⇋";
var leftrightsquigarrow = "↭";
var LeftRightVector = "⥎";
var LeftTeeArrow = "↤";
var LeftTee = "⊣";
var LeftTeeVector = "⥚";
var leftthreetimes = "⋋";
var LeftTriangleBar = "⧏";
var LeftTriangle = "⊲";
var LeftTriangleEqual = "⊴";
var LeftUpDownVector = "⥑";
var LeftUpTeeVector = "⥠";
var LeftUpVectorBar = "⥘";
var LeftUpVector = "↿";
var LeftVectorBar = "⥒";
var LeftVector = "↼";
var lEg = "⪋";
var leg = "⋚";
var leq = "≤";
var leqq = "≦";
var leqslant = "⩽";
var lescc = "⪨";
var les = "⩽";
var lesdot = "⩿";
var lesdoto = "⪁";
var lesdotor = "⪃";
var lesg = "⋚︀";
var lesges = "⪓";
var lessapprox = "⪅";
var lessdot = "⋖";
var lesseqgtr = "⋚";
var lesseqqgtr = "⪋";
var LessEqualGreater = "⋚";
var LessFullEqual = "≦";
var LessGreater = "≶";
var lessgtr = "≶";
var LessLess = "⪡";
var lesssim = "≲";
var LessSlantEqual = "⩽";
var LessTilde = "≲";
var lfisht = "⥼";
var lfloor = "⌊";
var Lfr = "𝔏";
var lfr = "𝔩";
var lg = "≶";
var lgE = "⪑";
var lHar = "⥢";
var lhard = "↽";
var lharu = "↼";
var lharul = "⥪";
var lhblk = "▄";
var LJcy = "Љ";
var ljcy = "љ";
var llarr = "⇇";
var ll = "≪";
var Ll = "⋘";
var llcorner = "⌞";
var Lleftarrow = "⇚";
var llhard = "⥫";
var lltri = "◺";
var Lmidot = "Ŀ";
var lmidot = "ŀ";
var lmoustache = "⎰";
var lmoust = "⎰";
var lnap = "⪉";
var lnapprox = "⪉";
var lne = "⪇";
var lnE = "≨";
var lneq = "⪇";
var lneqq = "≨";
var lnsim = "⋦";
var loang = "⟬";
var loarr = "⇽";
var lobrk = "⟦";
var longleftarrow = "⟵";
var LongLeftArrow = "⟵";
var Longleftarrow = "⟸";
var longleftrightarrow = "⟷";
var LongLeftRightArrow = "⟷";
var Longleftrightarrow = "⟺";
var longmapsto = "⟼";
var longrightarrow = "⟶";
var LongRightArrow = "⟶";
var Longrightarrow = "⟹";
var looparrowleft = "↫";
var looparrowright = "↬";
var lopar = "⦅";
var Lopf = "𝕃";
var lopf = "𝕝";
var loplus = "⨭";
var lotimes = "⨴";
var lowast = "∗";
var lowbar = "_";
var LowerLeftArrow = "↙";
var LowerRightArrow = "↘";
var loz = "◊";
var lozenge = "◊";
var lozf = "⧫";
var lpar = "(";
var lparlt = "⦓";
var lrarr = "⇆";
var lrcorner = "⌟";
var lrhar = "⇋";
var lrhard = "⥭";
var lrm = "‎";
var lrtri = "⊿";
var lsaquo = "‹";
var lscr = "𝓁";
var Lscr = "ℒ";
var lsh = "↰";
var Lsh = "↰";
var lsim = "≲";
var lsime = "⪍";
var lsimg = "⪏";
var lsqb = "[";
var lsquo = "‘";
var lsquor = "‚";
var Lstrok = "Ł";
var lstrok = "ł";
var ltcc = "⪦";
var ltcir = "⩹";
var lt$2 = "<";
var LT$1 = "<";
var Lt = "≪";
var ltdot = "⋖";
var lthree = "⋋";
var ltimes = "⋉";
var ltlarr = "⥶";
var ltquest = "⩻";
var ltri = "◃";
var ltrie = "⊴";
var ltrif = "◂";
var ltrPar = "⦖";
var lurdshar = "⥊";
var luruhar = "⥦";
var lvertneqq = "≨︀";
var lvnE = "≨︀";
var macr$1 = "¯";
var male = "♂";
var malt = "✠";
var maltese = "✠";
var map$3 = "↦";
var mapsto = "↦";
var mapstodown = "↧";
var mapstoleft = "↤";
var mapstoup = "↥";
var marker = "▮";
var mcomma = "⨩";
var Mcy = "М";
var mcy = "м";
var mdash = "—";
var mDDot = "∺";
var measuredangle = "∡";
var MediumSpace = " ";
var Mellintrf = "ℳ";
var Mfr = "𝔐";
var mfr = "𝔪";
var mho = "℧";
var micro$1 = "µ";
var midast = "*";
var midcir = "⫰";
var mid = "∣";
var middot$1 = "·";
var minusb = "⊟";
var minus = "−";
var minusd = "∸";
var minusdu = "⨪";
var MinusPlus = "∓";
var mlcp = "⫛";
var mldr = "…";
var mnplus = "∓";
var models = "⊧";
var Mopf = "𝕄";
var mopf = "𝕞";
var mp = "∓";
var mscr = "𝓂";
var Mscr = "ℳ";
var mstpos = "∾";
var Mu = "Μ";
var mu = "μ";
var multimap = "⊸";
var mumap = "⊸";
var nabla = "∇";
var Nacute = "Ń";
var nacute = "ń";
var nang = "∠⃒";
var nap$1 = "≉";
var napE = "⩰̸";
var napid = "≋̸";
var napos = "ŉ";
var napprox = "≉";
var natural = "♮";
var naturals = "ℕ";
var natur = "♮";
var nbsp$1 = " ";
var nbump = "≎̸";
var nbumpe = "≏̸";
var ncap = "⩃";
var Ncaron = "Ň";
var ncaron = "ň";
var Ncedil = "Ņ";
var ncedil = "ņ";
var ncong = "≇";
var ncongdot = "⩭̸";
var ncup = "⩂";
var Ncy = "Н";
var ncy = "н";
var ndash = "–";
var nearhk = "⤤";
var nearr = "↗";
var neArr = "⇗";
var nearrow = "↗";
var ne = "≠";
var nedot = "≐̸";
var NegativeMediumSpace = "​";
var NegativeThickSpace = "​";
var NegativeThinSpace = "​";
var NegativeVeryThinSpace = "​";
var nequiv = "≢";
var nesear = "⤨";
var nesim = "≂̸";
var NestedGreaterGreater = "≫";
var NestedLessLess = "≪";
var NewLine = "\n";
var nexist = "∄";
var nexists = "∄";
var Nfr = "𝔑";
var nfr = "𝔫";
var ngE = "≧̸";
var nge = "≱";
var ngeq = "≱";
var ngeqq = "≧̸";
var ngeqslant = "⩾̸";
var nges = "⩾̸";
var nGg = "⋙̸";
var ngsim = "≵";
var nGt = "≫⃒";
var ngt = "≯";
var ngtr = "≯";
var nGtv = "≫̸";
var nharr = "↮";
var nhArr = "⇎";
var nhpar = "⫲";
var ni = "∋";
var nis = "⋼";
var nisd = "⋺";
var niv = "∋";
var NJcy = "Њ";
var njcy = "њ";
var nlarr = "↚";
var nlArr = "⇍";
var nldr = "‥";
var nlE = "≦̸";
var nle = "≰";
var nleftarrow = "↚";
var nLeftarrow = "⇍";
var nleftrightarrow = "↮";
var nLeftrightarrow = "⇎";
var nleq = "≰";
var nleqq = "≦̸";
var nleqslant = "⩽̸";
var nles = "⩽̸";
var nless = "≮";
var nLl = "⋘̸";
var nlsim = "≴";
var nLt = "≪⃒";
var nlt = "≮";
var nltri = "⋪";
var nltrie = "⋬";
var nLtv = "≪̸";
var nmid = "∤";
var NoBreak = "⁠";
var NonBreakingSpace = " ";
var nopf = "𝕟";
var Nopf = "ℕ";
var Not = "⫬";
var not$1 = "¬";
var NotCongruent = "≢";
var NotCupCap = "≭";
var NotDoubleVerticalBar = "∦";
var NotElement = "∉";
var NotEqual = "≠";
var NotEqualTilde = "≂̸";
var NotExists = "∄";
var NotGreater = "≯";
var NotGreaterEqual = "≱";
var NotGreaterFullEqual = "≧̸";
var NotGreaterGreater = "≫̸";
var NotGreaterLess = "≹";
var NotGreaterSlantEqual = "⩾̸";
var NotGreaterTilde = "≵";
var NotHumpDownHump = "≎̸";
var NotHumpEqual = "≏̸";
var notin = "∉";
var notindot = "⋵̸";
var notinE = "⋹̸";
var notinva = "∉";
var notinvb = "⋷";
var notinvc = "⋶";
var NotLeftTriangleBar = "⧏̸";
var NotLeftTriangle = "⋪";
var NotLeftTriangleEqual = "⋬";
var NotLess = "≮";
var NotLessEqual = "≰";
var NotLessGreater = "≸";
var NotLessLess = "≪̸";
var NotLessSlantEqual = "⩽̸";
var NotLessTilde = "≴";
var NotNestedGreaterGreater = "⪢̸";
var NotNestedLessLess = "⪡̸";
var notni = "∌";
var notniva = "∌";
var notnivb = "⋾";
var notnivc = "⋽";
var NotPrecedes = "⊀";
var NotPrecedesEqual = "⪯̸";
var NotPrecedesSlantEqual = "⋠";
var NotReverseElement = "∌";
var NotRightTriangleBar = "⧐̸";
var NotRightTriangle = "⋫";
var NotRightTriangleEqual = "⋭";
var NotSquareSubset = "⊏̸";
var NotSquareSubsetEqual = "⋢";
var NotSquareSuperset = "⊐̸";
var NotSquareSupersetEqual = "⋣";
var NotSubset = "⊂⃒";
var NotSubsetEqual = "⊈";
var NotSucceeds = "⊁";
var NotSucceedsEqual = "⪰̸";
var NotSucceedsSlantEqual = "⋡";
var NotSucceedsTilde = "≿̸";
var NotSuperset = "⊃⃒";
var NotSupersetEqual = "⊉";
var NotTilde = "≁";
var NotTildeEqual = "≄";
var NotTildeFullEqual = "≇";
var NotTildeTilde = "≉";
var NotVerticalBar = "∤";
var nparallel = "∦";
var npar = "∦";
var nparsl = "⫽⃥";
var npart = "∂̸";
var npolint = "⨔";
var npr = "⊀";
var nprcue = "⋠";
var nprec = "⊀";
var npreceq = "⪯̸";
var npre = "⪯̸";
var nrarrc = "⤳̸";
var nrarr = "↛";
var nrArr = "⇏";
var nrarrw = "↝̸";
var nrightarrow = "↛";
var nRightarrow = "⇏";
var nrtri = "⋫";
var nrtrie = "⋭";
var nsc = "⊁";
var nsccue = "⋡";
var nsce = "⪰̸";
var Nscr = "𝒩";
var nscr = "𝓃";
var nshortmid = "∤";
var nshortparallel = "∦";
var nsim = "≁";
var nsime = "≄";
var nsimeq = "≄";
var nsmid = "∤";
var nspar = "∦";
var nsqsube = "⋢";
var nsqsupe = "⋣";
var nsub = "⊄";
var nsubE = "⫅̸";
var nsube = "⊈";
var nsubset = "⊂⃒";
var nsubseteq = "⊈";
var nsubseteqq = "⫅̸";
var nsucc = "⊁";
var nsucceq = "⪰̸";
var nsup = "⊅";
var nsupE = "⫆̸";
var nsupe = "⊉";
var nsupset = "⊃⃒";
var nsupseteq = "⊉";
var nsupseteqq = "⫆̸";
var ntgl = "≹";
var Ntilde$1 = "Ñ";
var ntilde$1 = "ñ";
var ntlg = "≸";
var ntriangleleft = "⋪";
var ntrianglelefteq = "⋬";
var ntriangleright = "⋫";
var ntrianglerighteq = "⋭";
var Nu = "Ν";
var nu = "ν";
var num = "#";
var numero = "№";
var numsp = " ";
var nvap = "≍⃒";
var nvdash = "⊬";
var nvDash = "⊭";
var nVdash = "⊮";
var nVDash = "⊯";
var nvge = "≥⃒";
var nvgt = ">⃒";
var nvHarr = "⤄";
var nvinfin = "⧞";
var nvlArr = "⤂";
var nvle = "≤⃒";
var nvlt = "<⃒";
var nvltrie = "⊴⃒";
var nvrArr = "⤃";
var nvrtrie = "⊵⃒";
var nvsim = "∼⃒";
var nwarhk = "⤣";
var nwarr = "↖";
var nwArr = "⇖";
var nwarrow = "↖";
var nwnear = "⤧";
var Oacute$1 = "Ó";
var oacute$1 = "ó";
var oast = "⊛";
var Ocirc$1 = "Ô";
var ocirc$1 = "ô";
var ocir = "⊚";
var Ocy = "О";
var ocy = "о";
var odash = "⊝";
var Odblac = "Ő";
var odblac = "ő";
var odiv = "⨸";
var odot = "⊙";
var odsold = "⦼";
var OElig = "Œ";
var oelig = "œ";
var ofcir = "⦿";
var Ofr = "𝔒";
var ofr = "𝔬";
var ogon = "˛";
var Ograve$1 = "Ò";
var ograve$1 = "ò";
var ogt = "⧁";
var ohbar = "⦵";
var ohm = "Ω";
var oint = "∮";
var olarr = "↺";
var olcir = "⦾";
var olcross = "⦻";
var oline = "‾";
var olt = "⧀";
var Omacr = "Ō";
var omacr = "ō";
var Omega = "Ω";
var omega = "ω";
var Omicron = "Ο";
var omicron = "ο";
var omid = "⦶";
var ominus = "⊖";
var Oopf = "𝕆";
var oopf = "𝕠";
var opar = "⦷";
var OpenCurlyDoubleQuote = "“";
var OpenCurlyQuote = "‘";
var operp = "⦹";
var oplus = "⊕";
var orarr = "↻";
var Or = "⩔";
var or = "∨";
var ord = "⩝";
var order = "ℴ";
var orderof = "ℴ";
var ordf$1 = "ª";
var ordm$1 = "º";
var origof = "⊶";
var oror = "⩖";
var orslope = "⩗";
var orv = "⩛";
var oS = "Ⓢ";
var Oscr = "𝒪";
var oscr = "ℴ";
var Oslash$1 = "Ø";
var oslash$1 = "ø";
var osol = "⊘";
var Otilde$1 = "Õ";
var otilde$1 = "õ";
var otimesas = "⨶";
var Otimes = "⨷";
var otimes = "⊗";
var Ouml$1 = "Ö";
var ouml$1 = "ö";
var ovbar = "⌽";
var OverBar = "‾";
var OverBrace = "⏞";
var OverBracket = "⎴";
var OverParenthesis = "⏜";
var para$1 = "¶";
var parallel$1 = "∥";
var par = "∥";
var parsim = "⫳";
var parsl = "⫽";
var part = "∂";
var PartialD = "∂";
var Pcy = "П";
var pcy = "п";
var percnt = "%";
var period = ".";
var permil = "‰";
var perp = "⊥";
var pertenk = "‱";
var Pfr = "𝔓";
var pfr = "𝔭";
var Phi = "Φ";
var phi = "φ";
var phiv = "ϕ";
var phmmat = "ℳ";
var phone = "☎";
var Pi = "Π";
var pi = "π";
var pitchfork = "⋔";
var piv = "ϖ";
var planck = "ℏ";
var planckh = "ℎ";
var plankv = "ℏ";
var plusacir = "⨣";
var plusb = "⊞";
var pluscir = "⨢";
var plus = "+";
var plusdo = "∔";
var plusdu = "⨥";
var pluse = "⩲";
var PlusMinus = "±";
var plusmn$1 = "±";
var plussim = "⨦";
var plustwo = "⨧";
var pm = "±";
var Poincareplane = "ℌ";
var pointint = "⨕";
var popf = "𝕡";
var Popf = "ℙ";
var pound$1 = "£";
var prap = "⪷";
var Pr = "⪻";
var pr = "≺";
var prcue = "≼";
var precapprox = "⪷";
var prec = "≺";
var preccurlyeq = "≼";
var Precedes = "≺";
var PrecedesEqual = "⪯";
var PrecedesSlantEqual = "≼";
var PrecedesTilde = "≾";
var preceq = "⪯";
var precnapprox = "⪹";
var precneqq = "⪵";
var precnsim = "⋨";
var pre = "⪯";
var prE = "⪳";
var precsim = "≾";
var prime = "′";
var Prime = "″";
var primes = "ℙ";
var prnap = "⪹";
var prnE = "⪵";
var prnsim = "⋨";
var prod = "∏";
var Product = "∏";
var profalar = "⌮";
var profline = "⌒";
var profsurf = "⌓";
var prop = "∝";
var Proportional = "∝";
var Proportion = "∷";
var propto = "∝";
var prsim = "≾";
var prurel = "⊰";
var Pscr = "𝒫";
var pscr = "𝓅";
var Psi = "Ψ";
var psi = "ψ";
var puncsp = " ";
var Qfr = "𝔔";
var qfr = "𝔮";
var qint = "⨌";
var qopf = "𝕢";
var Qopf = "ℚ";
var qprime = "⁗";
var Qscr = "𝒬";
var qscr = "𝓆";
var quaternions = "ℍ";
var quatint = "⨖";
var quest = "?";
var questeq = "≟";
var quot$2 = "\"";
var QUOT$1 = "\"";
var rAarr = "⇛";
var race = "∽̱";
var Racute = "Ŕ";
var racute = "ŕ";
var radic = "√";
var raemptyv = "⦳";
var rang = "⟩";
var Rang = "⟫";
var rangd = "⦒";
var range = "⦥";
var rangle = "⟩";
var raquo$1 = "»";
var rarrap = "⥵";
var rarrb = "⇥";
var rarrbfs = "⤠";
var rarrc = "⤳";
var rarr = "→";
var Rarr = "↠";
var rArr = "⇒";
var rarrfs = "⤞";
var rarrhk = "↪";
var rarrlp = "↬";
var rarrpl = "⥅";
var rarrsim = "⥴";
var Rarrtl = "⤖";
var rarrtl = "↣";
var rarrw = "↝";
var ratail = "⤚";
var rAtail = "⤜";
var ratio = "∶";
var rationals = "ℚ";
var rbarr = "⤍";
var rBarr = "⤏";
var RBarr = "⤐";
var rbbrk = "❳";
var rbrace = "}";
var rbrack = "]";
var rbrke = "⦌";
var rbrksld = "⦎";
var rbrkslu = "⦐";
var Rcaron = "Ř";
var rcaron = "ř";
var Rcedil = "Ŗ";
var rcedil = "ŗ";
var rceil = "⌉";
var rcub = "}";
var Rcy = "Р";
var rcy = "р";
var rdca = "⤷";
var rdldhar = "⥩";
var rdquo = "”";
var rdquor = "”";
var rdsh = "↳";
var real = "ℜ";
var realine = "ℛ";
var realpart = "ℜ";
var reals = "ℝ";
var Re = "ℜ";
var rect = "▭";
var reg$1 = "®";
var REG$1 = "®";
var ReverseElement = "∋";
var ReverseEquilibrium = "⇋";
var ReverseUpEquilibrium = "⥯";
var rfisht = "⥽";
var rfloor = "⌋";
var rfr = "𝔯";
var Rfr = "ℜ";
var rHar = "⥤";
var rhard = "⇁";
var rharu = "⇀";
var rharul = "⥬";
var Rho = "Ρ";
var rho = "ρ";
var rhov = "ϱ";
var RightAngleBracket = "⟩";
var RightArrowBar = "⇥";
var rightarrow = "→";
var RightArrow = "→";
var Rightarrow = "⇒";
var RightArrowLeftArrow = "⇄";
var rightarrowtail = "↣";
var RightCeiling = "⌉";
var RightDoubleBracket = "⟧";
var RightDownTeeVector = "⥝";
var RightDownVectorBar = "⥕";
var RightDownVector = "⇂";
var RightFloor = "⌋";
var rightharpoondown = "⇁";
var rightharpoonup = "⇀";
var rightleftarrows = "⇄";
var rightleftharpoons = "⇌";
var rightrightarrows = "⇉";
var rightsquigarrow = "↝";
var RightTeeArrow = "↦";
var RightTee = "⊢";
var RightTeeVector = "⥛";
var rightthreetimes = "⋌";
var RightTriangleBar = "⧐";
var RightTriangle = "⊳";
var RightTriangleEqual = "⊵";
var RightUpDownVector = "⥏";
var RightUpTeeVector = "⥜";
var RightUpVectorBar = "⥔";
var RightUpVector = "↾";
var RightVectorBar = "⥓";
var RightVector = "⇀";
var ring = "˚";
var risingdotseq = "≓";
var rlarr = "⇄";
var rlhar = "⇌";
var rlm = "‏";
var rmoustache = "⎱";
var rmoust = "⎱";
var rnmid = "⫮";
var roang = "⟭";
var roarr = "⇾";
var robrk = "⟧";
var ropar = "⦆";
var ropf = "𝕣";
var Ropf = "ℝ";
var roplus = "⨮";
var rotimes = "⨵";
var RoundImplies = "⥰";
var rpar = ")";
var rpargt = "⦔";
var rppolint = "⨒";
var rrarr = "⇉";
var Rrightarrow = "⇛";
var rsaquo = "›";
var rscr = "𝓇";
var Rscr = "ℛ";
var rsh = "↱";
var Rsh = "↱";
var rsqb = "]";
var rsquo = "’";
var rsquor = "’";
var rthree = "⋌";
var rtimes = "⋊";
var rtri = "▹";
var rtrie = "⊵";
var rtrif = "▸";
var rtriltri = "⧎";
var RuleDelayed = "⧴";
var ruluhar = "⥨";
var rx = "℞";
var Sacute = "Ś";
var sacute = "ś";
var sbquo = "‚";
var scap = "⪸";
var Scaron = "Š";
var scaron = "š";
var Sc = "⪼";
var sc = "≻";
var sccue = "≽";
var sce = "⪰";
var scE = "⪴";
var Scedil = "Ş";
var scedil = "ş";
var Scirc = "Ŝ";
var scirc = "ŝ";
var scnap = "⪺";
var scnE = "⪶";
var scnsim = "⋩";
var scpolint = "⨓";
var scsim = "≿";
var Scy = "С";
var scy = "с";
var sdotb = "⊡";
var sdot = "⋅";
var sdote = "⩦";
var searhk = "⤥";
var searr = "↘";
var seArr = "⇘";
var searrow = "↘";
var sect$1 = "§";
var semi = ";";
var seswar = "⤩";
var setminus = "∖";
var setmn = "∖";
var sext = "✶";
var Sfr = "𝔖";
var sfr = "𝔰";
var sfrown = "⌢";
var sharp = "♯";
var SHCHcy = "Щ";
var shchcy = "щ";
var SHcy = "Ш";
var shcy = "ш";
var ShortDownArrow = "↓";
var ShortLeftArrow = "←";
var shortmid = "∣";
var shortparallel = "∥";
var ShortRightArrow = "→";
var ShortUpArrow = "↑";
var shy$1 = "­";
var Sigma = "Σ";
var sigma = "σ";
var sigmaf = "ς";
var sigmav = "ς";
var sim = "∼";
var simdot = "⩪";
var sime = "≃";
var simeq = "≃";
var simg = "⪞";
var simgE = "⪠";
var siml = "⪝";
var simlE = "⪟";
var simne = "≆";
var simplus = "⨤";
var simrarr = "⥲";
var slarr = "←";
var SmallCircle = "∘";
var smallsetminus = "∖";
var smashp = "⨳";
var smeparsl = "⧤";
var smid = "∣";
var smile = "⌣";
var smt = "⪪";
var smte = "⪬";
var smtes = "⪬︀";
var SOFTcy = "Ь";
var softcy = "ь";
var solbar = "⌿";
var solb = "⧄";
var sol = "/";
var Sopf = "𝕊";
var sopf = "𝕤";
var spades = "♠";
var spadesuit = "♠";
var spar = "∥";
var sqcap = "⊓";
var sqcaps = "⊓︀";
var sqcup = "⊔";
var sqcups = "⊔︀";
var Sqrt = "√";
var sqsub = "⊏";
var sqsube = "⊑";
var sqsubset = "⊏";
var sqsubseteq = "⊑";
var sqsup = "⊐";
var sqsupe = "⊒";
var sqsupset = "⊐";
var sqsupseteq = "⊒";
var square = "□";
var Square = "□";
var SquareIntersection = "⊓";
var SquareSubset = "⊏";
var SquareSubsetEqual = "⊑";
var SquareSuperset = "⊐";
var SquareSupersetEqual = "⊒";
var SquareUnion = "⊔";
var squarf = "▪";
var squ = "□";
var squf = "▪";
var srarr = "→";
var Sscr = "𝒮";
var sscr = "𝓈";
var ssetmn = "∖";
var ssmile = "⌣";
var sstarf = "⋆";
var Star = "⋆";
var star = "☆";
var starf = "★";
var straightepsilon = "ϵ";
var straightphi = "ϕ";
var strns = "¯";
var sub = "⊂";
var Sub = "⋐";
var subdot = "⪽";
var subE = "⫅";
var sube = "⊆";
var subedot = "⫃";
var submult = "⫁";
var subnE = "⫋";
var subne = "⊊";
var subplus = "⪿";
var subrarr = "⥹";
var subset = "⊂";
var Subset = "⋐";
var subseteq = "⊆";
var subseteqq = "⫅";
var SubsetEqual = "⊆";
var subsetneq = "⊊";
var subsetneqq = "⫋";
var subsim = "⫇";
var subsub = "⫕";
var subsup = "⫓";
var succapprox = "⪸";
var succ = "≻";
var succcurlyeq = "≽";
var Succeeds = "≻";
var SucceedsEqual = "⪰";
var SucceedsSlantEqual = "≽";
var SucceedsTilde = "≿";
var succeq = "⪰";
var succnapprox = "⪺";
var succneqq = "⪶";
var succnsim = "⋩";
var succsim = "≿";
var SuchThat = "∋";
var sum = "∑";
var Sum = "∑";
var sung = "♪";
var sup1$1 = "¹";
var sup2$1 = "²";
var sup3$1 = "³";
var sup = "⊃";
var Sup = "⋑";
var supdot = "⪾";
var supdsub = "⫘";
var supE = "⫆";
var supe = "⊇";
var supedot = "⫄";
var Superset = "⊃";
var SupersetEqual = "⊇";
var suphsol = "⟉";
var suphsub = "⫗";
var suplarr = "⥻";
var supmult = "⫂";
var supnE = "⫌";
var supne = "⊋";
var supplus = "⫀";
var supset = "⊃";
var Supset = "⋑";
var supseteq = "⊇";
var supseteqq = "⫆";
var supsetneq = "⊋";
var supsetneqq = "⫌";
var supsim = "⫈";
var supsub = "⫔";
var supsup = "⫖";
var swarhk = "⤦";
var swarr = "↙";
var swArr = "⇙";
var swarrow = "↙";
var swnwar = "⤪";
var szlig$1 = "ß";
var Tab = "\t";
var target = "⌖";
var Tau = "Τ";
var tau = "τ";
var tbrk = "⎴";
var Tcaron = "Ť";
var tcaron = "ť";
var Tcedil = "Ţ";
var tcedil = "ţ";
var Tcy = "Т";
var tcy = "т";
var tdot = "⃛";
var telrec = "⌕";
var Tfr = "𝔗";
var tfr = "𝔱";
var there4 = "∴";
var therefore = "∴";
var Therefore = "∴";
var Theta = "Θ";
var theta = "θ";
var thetasym = "ϑ";
var thetav = "ϑ";
var thickapprox = "≈";
var thicksim = "∼";
var ThickSpace = "  ";
var ThinSpace = " ";
var thinsp = " ";
var thkap = "≈";
var thksim = "∼";
var THORN$1 = "Þ";
var thorn$1 = "þ";
var tilde = "˜";
var Tilde = "∼";
var TildeEqual = "≃";
var TildeFullEqual = "≅";
var TildeTilde = "≈";
var timesbar = "⨱";
var timesb = "⊠";
var times$1 = "×";
var timesd = "⨰";
var tint = "∭";
var toea = "⤨";
var topbot = "⌶";
var topcir = "⫱";
var top = "⊤";
var Topf = "𝕋";
var topf = "𝕥";
var topfork = "⫚";
var tosa = "⤩";
var tprime = "‴";
var trade = "™";
var TRADE = "™";
var triangle = "▵";
var triangledown = "▿";
var triangleleft = "◃";
var trianglelefteq = "⊴";
var triangleq = "≜";
var triangleright = "▹";
var trianglerighteq = "⊵";
var tridot = "◬";
var trie = "≜";
var triminus = "⨺";
var TripleDot = "⃛";
var triplus = "⨹";
var trisb = "⧍";
var tritime = "⨻";
var trpezium = "⏢";
var Tscr = "𝒯";
var tscr = "𝓉";
var TScy = "Ц";
var tscy = "ц";
var TSHcy = "Ћ";
var tshcy = "ћ";
var Tstrok = "Ŧ";
var tstrok = "ŧ";
var twixt = "≬";
var twoheadleftarrow = "↞";
var twoheadrightarrow = "↠";
var Uacute$1 = "Ú";
var uacute$1 = "ú";
var uarr = "↑";
var Uarr = "↟";
var uArr = "⇑";
var Uarrocir = "⥉";
var Ubrcy = "Ў";
var ubrcy = "ў";
var Ubreve = "Ŭ";
var ubreve = "ŭ";
var Ucirc$1 = "Û";
var ucirc$1 = "û";
var Ucy = "У";
var ucy = "у";
var udarr = "⇅";
var Udblac = "Ű";
var udblac = "ű";
var udhar = "⥮";
var ufisht = "⥾";
var Ufr = "𝔘";
var ufr = "𝔲";
var Ugrave$1 = "Ù";
var ugrave$1 = "ù";
var uHar = "⥣";
var uharl = "↿";
var uharr = "↾";
var uhblk = "▀";
var ulcorn = "⌜";
var ulcorner = "⌜";
var ulcrop = "⌏";
var ultri = "◸";
var Umacr = "Ū";
var umacr = "ū";
var uml$1 = "¨";
var UnderBar = "_";
var UnderBrace = "⏟";
var UnderBracket = "⎵";
var UnderParenthesis = "⏝";
var Union = "⋃";
var UnionPlus = "⊎";
var Uogon = "Ų";
var uogon = "ų";
var Uopf = "𝕌";
var uopf = "𝕦";
var UpArrowBar = "⤒";
var uparrow = "↑";
var UpArrow = "↑";
var Uparrow = "⇑";
var UpArrowDownArrow = "⇅";
var updownarrow = "↕";
var UpDownArrow = "↕";
var Updownarrow = "⇕";
var UpEquilibrium = "⥮";
var upharpoonleft = "↿";
var upharpoonright = "↾";
var uplus = "⊎";
var UpperLeftArrow = "↖";
var UpperRightArrow = "↗";
var upsi = "υ";
var Upsi = "ϒ";
var upsih = "ϒ";
var Upsilon = "Υ";
var upsilon = "υ";
var UpTeeArrow = "↥";
var UpTee = "⊥";
var upuparrows = "⇈";
var urcorn = "⌝";
var urcorner = "⌝";
var urcrop = "⌎";
var Uring = "Ů";
var uring = "ů";
var urtri = "◹";
var Uscr = "𝒰";
var uscr = "𝓊";
var utdot = "⋰";
var Utilde = "Ũ";
var utilde = "ũ";
var utri = "▵";
var utrif = "▴";
var uuarr = "⇈";
var Uuml$1 = "Ü";
var uuml$1 = "ü";
var uwangle = "⦧";
var vangrt = "⦜";
var varepsilon = "ϵ";
var varkappa = "ϰ";
var varnothing = "∅";
var varphi = "ϕ";
var varpi = "ϖ";
var varpropto = "∝";
var varr = "↕";
var vArr = "⇕";
var varrho = "ϱ";
var varsigma = "ς";
var varsubsetneq = "⊊︀";
var varsubsetneqq = "⫋︀";
var varsupsetneq = "⊋︀";
var varsupsetneqq = "⫌︀";
var vartheta = "ϑ";
var vartriangleleft = "⊲";
var vartriangleright = "⊳";
var vBar = "⫨";
var Vbar = "⫫";
var vBarv = "⫩";
var Vcy = "В";
var vcy = "в";
var vdash = "⊢";
var vDash = "⊨";
var Vdash = "⊩";
var VDash = "⊫";
var Vdashl = "⫦";
var veebar = "⊻";
var vee = "∨";
var Vee = "⋁";
var veeeq = "≚";
var vellip = "⋮";
var verbar = "|";
var Verbar = "‖";
var vert = "|";
var Vert = "‖";
var VerticalBar = "∣";
var VerticalLine = "|";
var VerticalSeparator = "❘";
var VerticalTilde = "≀";
var VeryThinSpace = " ";
var Vfr = "𝔙";
var vfr = "𝔳";
var vltri = "⊲";
var vnsub = "⊂⃒";
var vnsup = "⊃⃒";
var Vopf = "𝕍";
var vopf = "𝕧";
var vprop = "∝";
var vrtri = "⊳";
var Vscr = "𝒱";
var vscr = "𝓋";
var vsubnE = "⫋︀";
var vsubne = "⊊︀";
var vsupnE = "⫌︀";
var vsupne = "⊋︀";
var Vvdash = "⊪";
var vzigzag = "⦚";
var Wcirc = "Ŵ";
var wcirc = "ŵ";
var wedbar = "⩟";
var wedge = "∧";
var Wedge = "⋀";
var wedgeq = "≙";
var weierp = "℘";
var Wfr = "𝔚";
var wfr = "𝔴";
var Wopf = "𝕎";
var wopf = "𝕨";
var wp = "℘";
var wr = "≀";
var wreath = "≀";
var Wscr = "𝒲";
var wscr = "𝓌";
var xcap = "⋂";
var xcirc = "◯";
var xcup = "⋃";
var xdtri = "▽";
var Xfr = "𝔛";
var xfr = "𝔵";
var xharr = "⟷";
var xhArr = "⟺";
var Xi = "Ξ";
var xi = "ξ";
var xlarr = "⟵";
var xlArr = "⟸";
var xmap = "⟼";
var xnis = "⋻";
var xodot = "⨀";
var Xopf = "𝕏";
var xopf = "𝕩";
var xoplus = "⨁";
var xotime = "⨂";
var xrarr = "⟶";
var xrArr = "⟹";
var Xscr = "𝒳";
var xscr = "𝓍";
var xsqcup = "⨆";
var xuplus = "⨄";
var xutri = "△";
var xvee = "⋁";
var xwedge = "⋀";
var Yacute$1 = "Ý";
var yacute$1 = "ý";
var YAcy = "Я";
var yacy = "я";
var Ycirc = "Ŷ";
var ycirc = "ŷ";
var Ycy = "Ы";
var ycy = "ы";
var yen$1 = "¥";
var Yfr = "𝔜";
var yfr = "𝔶";
var YIcy = "Ї";
var yicy = "ї";
var Yopf = "𝕐";
var yopf = "𝕪";
var Yscr = "𝒴";
var yscr = "𝓎";
var YUcy = "Ю";
var yucy = "ю";
var yuml$1 = "ÿ";
var Yuml = "Ÿ";
var Zacute = "Ź";
var zacute = "ź";
var Zcaron = "Ž";
var zcaron = "ž";
var Zcy = "З";
var zcy = "з";
var Zdot = "Ż";
var zdot = "ż";
var zeetrf = "ℨ";
var ZeroWidthSpace = "​";
var Zeta = "Ζ";
var zeta = "ζ";
var zfr = "𝔷";
var Zfr = "ℨ";
var ZHcy = "Ж";
var zhcy = "ж";
var zigrarr = "⇝";
var zopf = "𝕫";
var Zopf = "ℤ";
var Zscr = "𝒵";
var zscr = "𝓏";
var zwj = "‍";
var zwnj = "‌";
var require$$1$1 = {
	Aacute: Aacute$1,
	aacute: aacute$1,
	Abreve: Abreve,
	abreve: abreve,
	ac: ac,
	acd: acd,
	acE: acE,
	Acirc: Acirc$1,
	acirc: acirc$1,
	acute: acute$1,
	Acy: Acy,
	acy: acy,
	AElig: AElig$1,
	aelig: aelig$1,
	af: af,
	Afr: Afr,
	afr: afr,
	Agrave: Agrave$1,
	agrave: agrave$1,
	alefsym: alefsym,
	aleph: aleph,
	Alpha: Alpha,
	alpha: alpha,
	Amacr: Amacr,
	amacr: amacr,
	amalg: amalg,
	amp: amp$2,
	AMP: AMP$1,
	andand: andand,
	And: And,
	and: and,
	andd: andd,
	andslope: andslope,
	andv: andv,
	ang: ang,
	ange: ange,
	angle: angle,
	angmsdaa: angmsdaa,
	angmsdab: angmsdab,
	angmsdac: angmsdac,
	angmsdad: angmsdad,
	angmsdae: angmsdae,
	angmsdaf: angmsdaf,
	angmsdag: angmsdag,
	angmsdah: angmsdah,
	angmsd: angmsd,
	angrt: angrt,
	angrtvb: angrtvb,
	angrtvbd: angrtvbd,
	angsph: angsph,
	angst: angst,
	angzarr: angzarr,
	Aogon: Aogon,
	aogon: aogon,
	Aopf: Aopf,
	aopf: aopf,
	apacir: apacir,
	ap: ap,
	apE: apE,
	ape: ape,
	apid: apid,
	apos: apos$1,
	ApplyFunction: ApplyFunction,
	approx: approx,
	approxeq: approxeq,
	Aring: Aring$1,
	aring: aring$1,
	Ascr: Ascr,
	ascr: ascr,
	Assign: Assign,
	ast: ast,
	asymp: asymp,
	asympeq: asympeq,
	Atilde: Atilde$1,
	atilde: atilde$1,
	Auml: Auml$1,
	auml: auml$1,
	awconint: awconint,
	awint: awint,
	backcong: backcong,
	backepsilon: backepsilon,
	backprime: backprime,
	backsim: backsim,
	backsimeq: backsimeq,
	Backslash: Backslash,
	Barv: Barv,
	barvee: barvee,
	barwed: barwed,
	Barwed: Barwed,
	barwedge: barwedge,
	bbrk: bbrk,
	bbrktbrk: bbrktbrk,
	bcong: bcong,
	Bcy: Bcy,
	bcy: bcy,
	bdquo: bdquo,
	becaus: becaus,
	because: because,
	Because: Because,
	bemptyv: bemptyv,
	bepsi: bepsi,
	bernou: bernou,
	Bernoullis: Bernoullis,
	Beta: Beta,
	beta: beta,
	beth: beth,
	between: between,
	Bfr: Bfr,
	bfr: bfr,
	bigcap: bigcap,
	bigcirc: bigcirc,
	bigcup: bigcup,
	bigodot: bigodot,
	bigoplus: bigoplus,
	bigotimes: bigotimes,
	bigsqcup: bigsqcup,
	bigstar: bigstar,
	bigtriangledown: bigtriangledown,
	bigtriangleup: bigtriangleup,
	biguplus: biguplus,
	bigvee: bigvee,
	bigwedge: bigwedge,
	bkarow: bkarow,
	blacklozenge: blacklozenge,
	blacksquare: blacksquare,
	blacktriangle: blacktriangle,
	blacktriangledown: blacktriangledown,
	blacktriangleleft: blacktriangleleft,
	blacktriangleright: blacktriangleright,
	blank: blank,
	blk12: blk12,
	blk14: blk14,
	blk34: blk34,
	block: block,
	bne: bne,
	bnequiv: bnequiv,
	bNot: bNot,
	bnot: bnot,
	Bopf: Bopf,
	bopf: bopf,
	bot: bot,
	bottom: bottom,
	bowtie: bowtie,
	boxbox: boxbox,
	boxdl: boxdl,
	boxdL: boxdL,
	boxDl: boxDl,
	boxDL: boxDL,
	boxdr: boxdr,
	boxdR: boxdR,
	boxDr: boxDr,
	boxDR: boxDR,
	boxh: boxh,
	boxH: boxH,
	boxhd: boxhd,
	boxHd: boxHd,
	boxhD: boxhD,
	boxHD: boxHD,
	boxhu: boxhu,
	boxHu: boxHu,
	boxhU: boxhU,
	boxHU: boxHU,
	boxminus: boxminus,
	boxplus: boxplus,
	boxtimes: boxtimes,
	boxul: boxul,
	boxuL: boxuL,
	boxUl: boxUl,
	boxUL: boxUL,
	boxur: boxur,
	boxuR: boxuR,
	boxUr: boxUr,
	boxUR: boxUR,
	boxv: boxv,
	boxV: boxV,
	boxvh: boxvh,
	boxvH: boxvH,
	boxVh: boxVh,
	boxVH: boxVH,
	boxvl: boxvl,
	boxvL: boxvL,
	boxVl: boxVl,
	boxVL: boxVL,
	boxvr: boxvr,
	boxvR: boxvR,
	boxVr: boxVr,
	boxVR: boxVR,
	bprime: bprime,
	breve: breve,
	Breve: Breve,
	brvbar: brvbar$1,
	bscr: bscr,
	Bscr: Bscr,
	bsemi: bsemi,
	bsim: bsim,
	bsime: bsime,
	bsolb: bsolb,
	bsol: bsol,
	bsolhsub: bsolhsub,
	bull: bull,
	bullet: bullet,
	bump: bump,
	bumpE: bumpE,
	bumpe: bumpe,
	Bumpeq: Bumpeq,
	bumpeq: bumpeq,
	Cacute: Cacute,
	cacute: cacute,
	capand: capand,
	capbrcup: capbrcup,
	capcap: capcap,
	cap: cap,
	Cap: Cap,
	capcup: capcup,
	capdot: capdot,
	CapitalDifferentialD: CapitalDifferentialD,
	caps: caps,
	caret: caret,
	caron: caron,
	Cayleys: Cayleys,
	ccaps: ccaps,
	Ccaron: Ccaron,
	ccaron: ccaron,
	Ccedil: Ccedil$1,
	ccedil: ccedil$1,
	Ccirc: Ccirc,
	ccirc: ccirc,
	Cconint: Cconint,
	ccups: ccups,
	ccupssm: ccupssm,
	Cdot: Cdot,
	cdot: cdot,
	cedil: cedil$1,
	Cedilla: Cedilla,
	cemptyv: cemptyv,
	cent: cent$1,
	centerdot: centerdot,
	CenterDot: CenterDot,
	cfr: cfr,
	Cfr: Cfr,
	CHcy: CHcy,
	chcy: chcy,
	check: check,
	checkmark: checkmark,
	Chi: Chi,
	chi: chi,
	circ: circ,
	circeq: circeq,
	circlearrowleft: circlearrowleft,
	circlearrowright: circlearrowright,
	circledast: circledast,
	circledcirc: circledcirc,
	circleddash: circleddash,
	CircleDot: CircleDot,
	circledR: circledR,
	circledS: circledS,
	CircleMinus: CircleMinus,
	CirclePlus: CirclePlus,
	CircleTimes: CircleTimes,
	cir: cir,
	cirE: cirE,
	cire: cire,
	cirfnint: cirfnint,
	cirmid: cirmid,
	cirscir: cirscir,
	ClockwiseContourIntegral: ClockwiseContourIntegral,
	CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
	CloseCurlyQuote: CloseCurlyQuote,
	clubs: clubs,
	clubsuit: clubsuit,
	colon: colon,
	Colon: Colon,
	Colone: Colone,
	colone: colone,
	coloneq: coloneq,
	comma: comma,
	commat: commat,
	comp: comp,
	compfn: compfn,
	complement: complement,
	complexes: complexes,
	cong: cong,
	congdot: congdot,
	Congruent: Congruent,
	conint: conint,
	Conint: Conint,
	ContourIntegral: ContourIntegral,
	copf: copf,
	Copf: Copf,
	coprod: coprod,
	Coproduct: Coproduct,
	copy: copy$2,
	COPY: COPY$1,
	copysr: copysr,
	CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
	crarr: crarr,
	cross: cross,
	Cross: Cross,
	Cscr: Cscr,
	cscr: cscr,
	csub: csub,
	csube: csube,
	csup: csup,
	csupe: csupe,
	ctdot: ctdot,
	cudarrl: cudarrl,
	cudarrr: cudarrr,
	cuepr: cuepr,
	cuesc: cuesc,
	cularr: cularr,
	cularrp: cularrp,
	cupbrcap: cupbrcap,
	cupcap: cupcap,
	CupCap: CupCap,
	cup: cup,
	Cup: Cup,
	cupcup: cupcup,
	cupdot: cupdot,
	cupor: cupor,
	cups: cups,
	curarr: curarr,
	curarrm: curarrm,
	curlyeqprec: curlyeqprec,
	curlyeqsucc: curlyeqsucc,
	curlyvee: curlyvee,
	curlywedge: curlywedge,
	curren: curren$1,
	curvearrowleft: curvearrowleft,
	curvearrowright: curvearrowright,
	cuvee: cuvee,
	cuwed: cuwed,
	cwconint: cwconint,
	cwint: cwint,
	cylcty: cylcty,
	dagger: dagger,
	Dagger: Dagger,
	daleth: daleth,
	darr: darr,
	Darr: Darr,
	dArr: dArr,
	dash: dash,
	Dashv: Dashv,
	dashv: dashv,
	dbkarow: dbkarow,
	dblac: dblac,
	Dcaron: Dcaron,
	dcaron: dcaron,
	Dcy: Dcy,
	dcy: dcy,
	ddagger: ddagger,
	ddarr: ddarr,
	DD: DD,
	dd: dd,
	DDotrahd: DDotrahd,
	ddotseq: ddotseq,
	deg: deg$1,
	Del: Del,
	Delta: Delta,
	delta: delta,
	demptyv: demptyv,
	dfisht: dfisht,
	Dfr: Dfr,
	dfr: dfr,
	dHar: dHar,
	dharl: dharl,
	dharr: dharr,
	DiacriticalAcute: DiacriticalAcute,
	DiacriticalDot: DiacriticalDot,
	DiacriticalDoubleAcute: DiacriticalDoubleAcute,
	DiacriticalGrave: DiacriticalGrave,
	DiacriticalTilde: DiacriticalTilde,
	diam: diam,
	diamond: diamond,
	Diamond: Diamond,
	diamondsuit: diamondsuit,
	diams: diams,
	die: die,
	DifferentialD: DifferentialD,
	digamma: digamma,
	disin: disin,
	div: div$1,
	divide: divide$1,
	divideontimes: divideontimes,
	divonx: divonx,
	DJcy: DJcy,
	djcy: djcy,
	dlcorn: dlcorn,
	dlcrop: dlcrop,
	dollar: dollar,
	Dopf: Dopf,
	dopf: dopf,
	Dot: Dot,
	dot: dot$1,
	DotDot: DotDot,
	doteq: doteq,
	doteqdot: doteqdot,
	DotEqual: DotEqual,
	dotminus: dotminus,
	dotplus: dotplus,
	dotsquare: dotsquare,
	doublebarwedge: doublebarwedge,
	DoubleContourIntegral: DoubleContourIntegral,
	DoubleDot: DoubleDot,
	DoubleDownArrow: DoubleDownArrow,
	DoubleLeftArrow: DoubleLeftArrow,
	DoubleLeftRightArrow: DoubleLeftRightArrow,
	DoubleLeftTee: DoubleLeftTee,
	DoubleLongLeftArrow: DoubleLongLeftArrow,
	DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
	DoubleLongRightArrow: DoubleLongRightArrow,
	DoubleRightArrow: DoubleRightArrow,
	DoubleRightTee: DoubleRightTee,
	DoubleUpArrow: DoubleUpArrow,
	DoubleUpDownArrow: DoubleUpDownArrow,
	DoubleVerticalBar: DoubleVerticalBar,
	DownArrowBar: DownArrowBar,
	downarrow: downarrow,
	DownArrow: DownArrow,
	Downarrow: Downarrow,
	DownArrowUpArrow: DownArrowUpArrow,
	DownBreve: DownBreve,
	downdownarrows: downdownarrows,
	downharpoonleft: downharpoonleft,
	downharpoonright: downharpoonright,
	DownLeftRightVector: DownLeftRightVector,
	DownLeftTeeVector: DownLeftTeeVector,
	DownLeftVectorBar: DownLeftVectorBar,
	DownLeftVector: DownLeftVector,
	DownRightTeeVector: DownRightTeeVector,
	DownRightVectorBar: DownRightVectorBar,
	DownRightVector: DownRightVector,
	DownTeeArrow: DownTeeArrow,
	DownTee: DownTee,
	drbkarow: drbkarow,
	drcorn: drcorn,
	drcrop: drcrop,
	Dscr: Dscr,
	dscr: dscr,
	DScy: DScy,
	dscy: dscy,
	dsol: dsol,
	Dstrok: Dstrok,
	dstrok: dstrok,
	dtdot: dtdot,
	dtri: dtri,
	dtrif: dtrif,
	duarr: duarr,
	duhar: duhar,
	dwangle: dwangle,
	DZcy: DZcy,
	dzcy: dzcy,
	dzigrarr: dzigrarr,
	Eacute: Eacute$1,
	eacute: eacute$1,
	easter: easter,
	Ecaron: Ecaron,
	ecaron: ecaron,
	Ecirc: Ecirc$1,
	ecirc: ecirc$1,
	ecir: ecir,
	ecolon: ecolon,
	Ecy: Ecy,
	ecy: ecy,
	eDDot: eDDot,
	Edot: Edot,
	edot: edot,
	eDot: eDot,
	ee: ee,
	efDot: efDot,
	Efr: Efr,
	efr: efr,
	eg: eg,
	Egrave: Egrave$1,
	egrave: egrave$1,
	egs: egs,
	egsdot: egsdot,
	el: el,
	Element: Element$4,
	elinters: elinters,
	ell: ell,
	els: els,
	elsdot: elsdot,
	Emacr: Emacr,
	emacr: emacr,
	empty: empty$2,
	emptyset: emptyset,
	EmptySmallSquare: EmptySmallSquare,
	emptyv: emptyv,
	EmptyVerySmallSquare: EmptyVerySmallSquare,
	emsp13: emsp13,
	emsp14: emsp14,
	emsp: emsp,
	ENG: ENG,
	eng: eng,
	ensp: ensp,
	Eogon: Eogon,
	eogon: eogon,
	Eopf: Eopf,
	eopf: eopf,
	epar: epar,
	eparsl: eparsl,
	eplus: eplus,
	epsi: epsi,
	Epsilon: Epsilon,
	epsilon: epsilon,
	epsiv: epsiv,
	eqcirc: eqcirc,
	eqcolon: eqcolon,
	eqsim: eqsim,
	eqslantgtr: eqslantgtr,
	eqslantless: eqslantless,
	Equal: Equal,
	equals: equals,
	EqualTilde: EqualTilde,
	equest: equest,
	Equilibrium: Equilibrium,
	equiv: equiv,
	equivDD: equivDD,
	eqvparsl: eqvparsl,
	erarr: erarr,
	erDot: erDot,
	escr: escr,
	Escr: Escr,
	esdot: esdot,
	Esim: Esim,
	esim: esim,
	Eta: Eta,
	eta: eta,
	ETH: ETH$1,
	eth: eth$1,
	Euml: Euml$1,
	euml: euml$1,
	euro: euro,
	excl: excl,
	exist: exist,
	Exists: Exists,
	expectation: expectation,
	exponentiale: exponentiale,
	ExponentialE: ExponentialE,
	fallingdotseq: fallingdotseq,
	Fcy: Fcy,
	fcy: fcy,
	female: female,
	ffilig: ffilig,
	fflig: fflig,
	ffllig: ffllig,
	Ffr: Ffr,
	ffr: ffr,
	filig: filig,
	FilledSmallSquare: FilledSmallSquare,
	FilledVerySmallSquare: FilledVerySmallSquare,
	fjlig: fjlig,
	flat: flat,
	fllig: fllig,
	fltns: fltns,
	fnof: fnof,
	Fopf: Fopf,
	fopf: fopf,
	forall: forall,
	ForAll: ForAll,
	fork: fork,
	forkv: forkv,
	Fouriertrf: Fouriertrf,
	fpartint: fpartint,
	frac12: frac12$1,
	frac13: frac13,
	frac14: frac14$1,
	frac15: frac15,
	frac16: frac16,
	frac18: frac18,
	frac23: frac23,
	frac25: frac25,
	frac34: frac34$1,
	frac35: frac35,
	frac38: frac38,
	frac45: frac45,
	frac56: frac56,
	frac58: frac58,
	frac78: frac78,
	frasl: frasl,
	frown: frown,
	fscr: fscr,
	Fscr: Fscr,
	gacute: gacute,
	Gamma: Gamma,
	gamma: gamma$2,
	Gammad: Gammad,
	gammad: gammad,
	gap: gap,
	Gbreve: Gbreve,
	gbreve: gbreve,
	Gcedil: Gcedil,
	Gcirc: Gcirc,
	gcirc: gcirc,
	Gcy: Gcy,
	gcy: gcy,
	Gdot: Gdot,
	gdot: gdot,
	ge: ge,
	gE: gE,
	gEl: gEl,
	gel: gel,
	geq: geq,
	geqq: geqq,
	geqslant: geqslant,
	gescc: gescc,
	ges: ges,
	gesdot: gesdot,
	gesdoto: gesdoto,
	gesdotol: gesdotol,
	gesl: gesl,
	gesles: gesles,
	Gfr: Gfr,
	gfr: gfr,
	gg: gg,
	Gg: Gg,
	ggg: ggg,
	gimel: gimel,
	GJcy: GJcy,
	gjcy: gjcy,
	gla: gla,
	gl: gl,
	glE: glE,
	glj: glj,
	gnap: gnap,
	gnapprox: gnapprox,
	gne: gne,
	gnE: gnE,
	gneq: gneq,
	gneqq: gneqq,
	gnsim: gnsim,
	Gopf: Gopf,
	gopf: gopf,
	grave: grave,
	GreaterEqual: GreaterEqual,
	GreaterEqualLess: GreaterEqualLess,
	GreaterFullEqual: GreaterFullEqual,
	GreaterGreater: GreaterGreater,
	GreaterLess: GreaterLess,
	GreaterSlantEqual: GreaterSlantEqual,
	GreaterTilde: GreaterTilde,
	Gscr: Gscr,
	gscr: gscr,
	gsim: gsim,
	gsime: gsime,
	gsiml: gsiml,
	gtcc: gtcc,
	gtcir: gtcir,
	gt: gt$2,
	GT: GT$1,
	Gt: Gt,
	gtdot: gtdot,
	gtlPar: gtlPar,
	gtquest: gtquest,
	gtrapprox: gtrapprox,
	gtrarr: gtrarr,
	gtrdot: gtrdot,
	gtreqless: gtreqless,
	gtreqqless: gtreqqless,
	gtrless: gtrless,
	gtrsim: gtrsim,
	gvertneqq: gvertneqq,
	gvnE: gvnE,
	Hacek: Hacek,
	hairsp: hairsp,
	half: half,
	hamilt: hamilt,
	HARDcy: HARDcy,
	hardcy: hardcy,
	harrcir: harrcir,
	harr: harr,
	hArr: hArr,
	harrw: harrw,
	Hat: Hat,
	hbar: hbar,
	Hcirc: Hcirc,
	hcirc: hcirc,
	hearts: hearts,
	heartsuit: heartsuit,
	hellip: hellip,
	hercon: hercon,
	hfr: hfr,
	Hfr: Hfr,
	HilbertSpace: HilbertSpace,
	hksearow: hksearow,
	hkswarow: hkswarow,
	hoarr: hoarr,
	homtht: homtht,
	hookleftarrow: hookleftarrow,
	hookrightarrow: hookrightarrow,
	hopf: hopf,
	Hopf: Hopf,
	horbar: horbar,
	HorizontalLine: HorizontalLine,
	hscr: hscr,
	Hscr: Hscr,
	hslash: hslash,
	Hstrok: Hstrok,
	hstrok: hstrok,
	HumpDownHump: HumpDownHump,
	HumpEqual: HumpEqual,
	hybull: hybull,
	hyphen: hyphen,
	Iacute: Iacute$1,
	iacute: iacute$1,
	ic: ic,
	Icirc: Icirc$1,
	icirc: icirc$1,
	Icy: Icy,
	icy: icy,
	Idot: Idot,
	IEcy: IEcy,
	iecy: iecy,
	iexcl: iexcl$1,
	iff: iff,
	ifr: ifr,
	Ifr: Ifr,
	Igrave: Igrave$1,
	igrave: igrave$1,
	ii: ii,
	iiiint: iiiint,
	iiint: iiint,
	iinfin: iinfin,
	iiota: iiota,
	IJlig: IJlig,
	ijlig: ijlig,
	Imacr: Imacr,
	imacr: imacr,
	image: image,
	ImaginaryI: ImaginaryI,
	imagline: imagline,
	imagpart: imagpart,
	imath: imath,
	Im: Im,
	imof: imof,
	imped: imped,
	Implies: Implies,
	incare: incare,
	"in": "∈",
	infin: infin,
	infintie: infintie,
	inodot: inodot,
	intcal: intcal,
	int: int,
	Int: Int,
	integers: integers,
	Integral: Integral,
	intercal: intercal,
	Intersection: Intersection,
	intlarhk: intlarhk,
	intprod: intprod,
	InvisibleComma: InvisibleComma,
	InvisibleTimes: InvisibleTimes,
	IOcy: IOcy,
	iocy: iocy,
	Iogon: Iogon,
	iogon: iogon,
	Iopf: Iopf,
	iopf: iopf,
	Iota: Iota,
	iota: iota,
	iprod: iprod,
	iquest: iquest$1,
	iscr: iscr,
	Iscr: Iscr,
	isin: isin,
	isindot: isindot,
	isinE: isinE,
	isins: isins,
	isinsv: isinsv,
	isinv: isinv,
	it: it,
	Itilde: Itilde,
	itilde: itilde,
	Iukcy: Iukcy,
	iukcy: iukcy,
	Iuml: Iuml$1,
	iuml: iuml$1,
	Jcirc: Jcirc,
	jcirc: jcirc,
	Jcy: Jcy,
	jcy: jcy,
	Jfr: Jfr,
	jfr: jfr,
	jmath: jmath,
	Jopf: Jopf,
	jopf: jopf,
	Jscr: Jscr,
	jscr: jscr,
	Jsercy: Jsercy,
	jsercy: jsercy,
	Jukcy: Jukcy,
	jukcy: jukcy,
	Kappa: Kappa,
	kappa: kappa,
	kappav: kappav,
	Kcedil: Kcedil,
	kcedil: kcedil,
	Kcy: Kcy,
	kcy: kcy,
	Kfr: Kfr,
	kfr: kfr,
	kgreen: kgreen,
	KHcy: KHcy,
	khcy: khcy,
	KJcy: KJcy,
	kjcy: kjcy,
	Kopf: Kopf,
	kopf: kopf,
	Kscr: Kscr,
	kscr: kscr,
	lAarr: lAarr,
	Lacute: Lacute,
	lacute: lacute,
	laemptyv: laemptyv,
	lagran: lagran,
	Lambda: Lambda,
	lambda: lambda,
	lang: lang,
	Lang: Lang,
	langd: langd,
	langle: langle,
	lap: lap,
	Laplacetrf: Laplacetrf,
	laquo: laquo$1,
	larrb: larrb,
	larrbfs: larrbfs,
	larr: larr,
	Larr: Larr,
	lArr: lArr,
	larrfs: larrfs,
	larrhk: larrhk,
	larrlp: larrlp,
	larrpl: larrpl,
	larrsim: larrsim,
	larrtl: larrtl,
	latail: latail,
	lAtail: lAtail,
	lat: lat,
	late: late,
	lates: lates,
	lbarr: lbarr,
	lBarr: lBarr,
	lbbrk: lbbrk,
	lbrace: lbrace,
	lbrack: lbrack,
	lbrke: lbrke,
	lbrksld: lbrksld,
	lbrkslu: lbrkslu,
	Lcaron: Lcaron,
	lcaron: lcaron,
	Lcedil: Lcedil,
	lcedil: lcedil,
	lceil: lceil,
	lcub: lcub,
	Lcy: Lcy,
	lcy: lcy,
	ldca: ldca,
	ldquo: ldquo,
	ldquor: ldquor,
	ldrdhar: ldrdhar,
	ldrushar: ldrushar,
	ldsh: ldsh,
	le: le,
	lE: lE,
	LeftAngleBracket: LeftAngleBracket,
	LeftArrowBar: LeftArrowBar,
	leftarrow: leftarrow,
	LeftArrow: LeftArrow,
	Leftarrow: Leftarrow,
	LeftArrowRightArrow: LeftArrowRightArrow,
	leftarrowtail: leftarrowtail,
	LeftCeiling: LeftCeiling,
	LeftDoubleBracket: LeftDoubleBracket,
	LeftDownTeeVector: LeftDownTeeVector,
	LeftDownVectorBar: LeftDownVectorBar,
	LeftDownVector: LeftDownVector,
	LeftFloor: LeftFloor,
	leftharpoondown: leftharpoondown,
	leftharpoonup: leftharpoonup,
	leftleftarrows: leftleftarrows,
	leftrightarrow: leftrightarrow,
	LeftRightArrow: LeftRightArrow,
	Leftrightarrow: Leftrightarrow,
	leftrightarrows: leftrightarrows,
	leftrightharpoons: leftrightharpoons,
	leftrightsquigarrow: leftrightsquigarrow,
	LeftRightVector: LeftRightVector,
	LeftTeeArrow: LeftTeeArrow,
	LeftTee: LeftTee,
	LeftTeeVector: LeftTeeVector,
	leftthreetimes: leftthreetimes,
	LeftTriangleBar: LeftTriangleBar,
	LeftTriangle: LeftTriangle,
	LeftTriangleEqual: LeftTriangleEqual,
	LeftUpDownVector: LeftUpDownVector,
	LeftUpTeeVector: LeftUpTeeVector,
	LeftUpVectorBar: LeftUpVectorBar,
	LeftUpVector: LeftUpVector,
	LeftVectorBar: LeftVectorBar,
	LeftVector: LeftVector,
	lEg: lEg,
	leg: leg,
	leq: leq,
	leqq: leqq,
	leqslant: leqslant,
	lescc: lescc,
	les: les,
	lesdot: lesdot,
	lesdoto: lesdoto,
	lesdotor: lesdotor,
	lesg: lesg,
	lesges: lesges,
	lessapprox: lessapprox,
	lessdot: lessdot,
	lesseqgtr: lesseqgtr,
	lesseqqgtr: lesseqqgtr,
	LessEqualGreater: LessEqualGreater,
	LessFullEqual: LessFullEqual,
	LessGreater: LessGreater,
	lessgtr: lessgtr,
	LessLess: LessLess,
	lesssim: lesssim,
	LessSlantEqual: LessSlantEqual,
	LessTilde: LessTilde,
	lfisht: lfisht,
	lfloor: lfloor,
	Lfr: Lfr,
	lfr: lfr,
	lg: lg,
	lgE: lgE,
	lHar: lHar,
	lhard: lhard,
	lharu: lharu,
	lharul: lharul,
	lhblk: lhblk,
	LJcy: LJcy,
	ljcy: ljcy,
	llarr: llarr,
	ll: ll,
	Ll: Ll,
	llcorner: llcorner,
	Lleftarrow: Lleftarrow,
	llhard: llhard,
	lltri: lltri,
	Lmidot: Lmidot,
	lmidot: lmidot,
	lmoustache: lmoustache,
	lmoust: lmoust,
	lnap: lnap,
	lnapprox: lnapprox,
	lne: lne,
	lnE: lnE,
	lneq: lneq,
	lneqq: lneqq,
	lnsim: lnsim,
	loang: loang,
	loarr: loarr,
	lobrk: lobrk,
	longleftarrow: longleftarrow,
	LongLeftArrow: LongLeftArrow,
	Longleftarrow: Longleftarrow,
	longleftrightarrow: longleftrightarrow,
	LongLeftRightArrow: LongLeftRightArrow,
	Longleftrightarrow: Longleftrightarrow,
	longmapsto: longmapsto,
	longrightarrow: longrightarrow,
	LongRightArrow: LongRightArrow,
	Longrightarrow: Longrightarrow,
	looparrowleft: looparrowleft,
	looparrowright: looparrowright,
	lopar: lopar,
	Lopf: Lopf,
	lopf: lopf,
	loplus: loplus,
	lotimes: lotimes,
	lowast: lowast,
	lowbar: lowbar,
	LowerLeftArrow: LowerLeftArrow,
	LowerRightArrow: LowerRightArrow,
	loz: loz,
	lozenge: lozenge,
	lozf: lozf,
	lpar: lpar,
	lparlt: lparlt,
	lrarr: lrarr,
	lrcorner: lrcorner,
	lrhar: lrhar,
	lrhard: lrhard,
	lrm: lrm,
	lrtri: lrtri,
	lsaquo: lsaquo,
	lscr: lscr,
	Lscr: Lscr,
	lsh: lsh,
	Lsh: Lsh,
	lsim: lsim,
	lsime: lsime,
	lsimg: lsimg,
	lsqb: lsqb,
	lsquo: lsquo,
	lsquor: lsquor,
	Lstrok: Lstrok,
	lstrok: lstrok,
	ltcc: ltcc,
	ltcir: ltcir,
	lt: lt$2,
	LT: LT$1,
	Lt: Lt,
	ltdot: ltdot,
	lthree: lthree,
	ltimes: ltimes,
	ltlarr: ltlarr,
	ltquest: ltquest,
	ltri: ltri,
	ltrie: ltrie,
	ltrif: ltrif,
	ltrPar: ltrPar,
	lurdshar: lurdshar,
	luruhar: luruhar,
	lvertneqq: lvertneqq,
	lvnE: lvnE,
	macr: macr$1,
	male: male,
	malt: malt,
	maltese: maltese,
	"Map": "⤅",
	map: map$3,
	mapsto: mapsto,
	mapstodown: mapstodown,
	mapstoleft: mapstoleft,
	mapstoup: mapstoup,
	marker: marker,
	mcomma: mcomma,
	Mcy: Mcy,
	mcy: mcy,
	mdash: mdash,
	mDDot: mDDot,
	measuredangle: measuredangle,
	MediumSpace: MediumSpace,
	Mellintrf: Mellintrf,
	Mfr: Mfr,
	mfr: mfr,
	mho: mho,
	micro: micro$1,
	midast: midast,
	midcir: midcir,
	mid: mid,
	middot: middot$1,
	minusb: minusb,
	minus: minus,
	minusd: minusd,
	minusdu: minusdu,
	MinusPlus: MinusPlus,
	mlcp: mlcp,
	mldr: mldr,
	mnplus: mnplus,
	models: models,
	Mopf: Mopf,
	mopf: mopf,
	mp: mp,
	mscr: mscr,
	Mscr: Mscr,
	mstpos: mstpos,
	Mu: Mu,
	mu: mu,
	multimap: multimap,
	mumap: mumap,
	nabla: nabla,
	Nacute: Nacute,
	nacute: nacute,
	nang: nang,
	nap: nap$1,
	napE: napE,
	napid: napid,
	napos: napos,
	napprox: napprox,
	natural: natural,
	naturals: naturals,
	natur: natur,
	nbsp: nbsp$1,
	nbump: nbump,
	nbumpe: nbumpe,
	ncap: ncap,
	Ncaron: Ncaron,
	ncaron: ncaron,
	Ncedil: Ncedil,
	ncedil: ncedil,
	ncong: ncong,
	ncongdot: ncongdot,
	ncup: ncup,
	Ncy: Ncy,
	ncy: ncy,
	ndash: ndash,
	nearhk: nearhk,
	nearr: nearr,
	neArr: neArr,
	nearrow: nearrow,
	ne: ne,
	nedot: nedot,
	NegativeMediumSpace: NegativeMediumSpace,
	NegativeThickSpace: NegativeThickSpace,
	NegativeThinSpace: NegativeThinSpace,
	NegativeVeryThinSpace: NegativeVeryThinSpace,
	nequiv: nequiv,
	nesear: nesear,
	nesim: nesim,
	NestedGreaterGreater: NestedGreaterGreater,
	NestedLessLess: NestedLessLess,
	NewLine: NewLine,
	nexist: nexist,
	nexists: nexists,
	Nfr: Nfr,
	nfr: nfr,
	ngE: ngE,
	nge: nge,
	ngeq: ngeq,
	ngeqq: ngeqq,
	ngeqslant: ngeqslant,
	nges: nges,
	nGg: nGg,
	ngsim: ngsim,
	nGt: nGt,
	ngt: ngt,
	ngtr: ngtr,
	nGtv: nGtv,
	nharr: nharr,
	nhArr: nhArr,
	nhpar: nhpar,
	ni: ni,
	nis: nis,
	nisd: nisd,
	niv: niv,
	NJcy: NJcy,
	njcy: njcy,
	nlarr: nlarr,
	nlArr: nlArr,
	nldr: nldr,
	nlE: nlE,
	nle: nle,
	nleftarrow: nleftarrow,
	nLeftarrow: nLeftarrow,
	nleftrightarrow: nleftrightarrow,
	nLeftrightarrow: nLeftrightarrow,
	nleq: nleq,
	nleqq: nleqq,
	nleqslant: nleqslant,
	nles: nles,
	nless: nless,
	nLl: nLl,
	nlsim: nlsim,
	nLt: nLt,
	nlt: nlt,
	nltri: nltri,
	nltrie: nltrie,
	nLtv: nLtv,
	nmid: nmid,
	NoBreak: NoBreak,
	NonBreakingSpace: NonBreakingSpace,
	nopf: nopf,
	Nopf: Nopf,
	Not: Not,
	not: not$1,
	NotCongruent: NotCongruent,
	NotCupCap: NotCupCap,
	NotDoubleVerticalBar: NotDoubleVerticalBar,
	NotElement: NotElement,
	NotEqual: NotEqual,
	NotEqualTilde: NotEqualTilde,
	NotExists: NotExists,
	NotGreater: NotGreater,
	NotGreaterEqual: NotGreaterEqual,
	NotGreaterFullEqual: NotGreaterFullEqual,
	NotGreaterGreater: NotGreaterGreater,
	NotGreaterLess: NotGreaterLess,
	NotGreaterSlantEqual: NotGreaterSlantEqual,
	NotGreaterTilde: NotGreaterTilde,
	NotHumpDownHump: NotHumpDownHump,
	NotHumpEqual: NotHumpEqual,
	notin: notin,
	notindot: notindot,
	notinE: notinE,
	notinva: notinva,
	notinvb: notinvb,
	notinvc: notinvc,
	NotLeftTriangleBar: NotLeftTriangleBar,
	NotLeftTriangle: NotLeftTriangle,
	NotLeftTriangleEqual: NotLeftTriangleEqual,
	NotLess: NotLess,
	NotLessEqual: NotLessEqual,
	NotLessGreater: NotLessGreater,
	NotLessLess: NotLessLess,
	NotLessSlantEqual: NotLessSlantEqual,
	NotLessTilde: NotLessTilde,
	NotNestedGreaterGreater: NotNestedGreaterGreater,
	NotNestedLessLess: NotNestedLessLess,
	notni: notni,
	notniva: notniva,
	notnivb: notnivb,
	notnivc: notnivc,
	NotPrecedes: NotPrecedes,
	NotPrecedesEqual: NotPrecedesEqual,
	NotPrecedesSlantEqual: NotPrecedesSlantEqual,
	NotReverseElement: NotReverseElement,
	NotRightTriangleBar: NotRightTriangleBar,
	NotRightTriangle: NotRightTriangle,
	NotRightTriangleEqual: NotRightTriangleEqual,
	NotSquareSubset: NotSquareSubset,
	NotSquareSubsetEqual: NotSquareSubsetEqual,
	NotSquareSuperset: NotSquareSuperset,
	NotSquareSupersetEqual: NotSquareSupersetEqual,
	NotSubset: NotSubset,
	NotSubsetEqual: NotSubsetEqual,
	NotSucceeds: NotSucceeds,
	NotSucceedsEqual: NotSucceedsEqual,
	NotSucceedsSlantEqual: NotSucceedsSlantEqual,
	NotSucceedsTilde: NotSucceedsTilde,
	NotSuperset: NotSuperset,
	NotSupersetEqual: NotSupersetEqual,
	NotTilde: NotTilde,
	NotTildeEqual: NotTildeEqual,
	NotTildeFullEqual: NotTildeFullEqual,
	NotTildeTilde: NotTildeTilde,
	NotVerticalBar: NotVerticalBar,
	nparallel: nparallel,
	npar: npar,
	nparsl: nparsl,
	npart: npart,
	npolint: npolint,
	npr: npr,
	nprcue: nprcue,
	nprec: nprec,
	npreceq: npreceq,
	npre: npre,
	nrarrc: nrarrc,
	nrarr: nrarr,
	nrArr: nrArr,
	nrarrw: nrarrw,
	nrightarrow: nrightarrow,
	nRightarrow: nRightarrow,
	nrtri: nrtri,
	nrtrie: nrtrie,
	nsc: nsc,
	nsccue: nsccue,
	nsce: nsce,
	Nscr: Nscr,
	nscr: nscr,
	nshortmid: nshortmid,
	nshortparallel: nshortparallel,
	nsim: nsim,
	nsime: nsime,
	nsimeq: nsimeq,
	nsmid: nsmid,
	nspar: nspar,
	nsqsube: nsqsube,
	nsqsupe: nsqsupe,
	nsub: nsub,
	nsubE: nsubE,
	nsube: nsube,
	nsubset: nsubset,
	nsubseteq: nsubseteq,
	nsubseteqq: nsubseteqq,
	nsucc: nsucc,
	nsucceq: nsucceq,
	nsup: nsup,
	nsupE: nsupE,
	nsupe: nsupe,
	nsupset: nsupset,
	nsupseteq: nsupseteq,
	nsupseteqq: nsupseteqq,
	ntgl: ntgl,
	Ntilde: Ntilde$1,
	ntilde: ntilde$1,
	ntlg: ntlg,
	ntriangleleft: ntriangleleft,
	ntrianglelefteq: ntrianglelefteq,
	ntriangleright: ntriangleright,
	ntrianglerighteq: ntrianglerighteq,
	Nu: Nu,
	nu: nu,
	num: num,
	numero: numero,
	numsp: numsp,
	nvap: nvap,
	nvdash: nvdash,
	nvDash: nvDash,
	nVdash: nVdash,
	nVDash: nVDash,
	nvge: nvge,
	nvgt: nvgt,
	nvHarr: nvHarr,
	nvinfin: nvinfin,
	nvlArr: nvlArr,
	nvle: nvle,
	nvlt: nvlt,
	nvltrie: nvltrie,
	nvrArr: nvrArr,
	nvrtrie: nvrtrie,
	nvsim: nvsim,
	nwarhk: nwarhk,
	nwarr: nwarr,
	nwArr: nwArr,
	nwarrow: nwarrow,
	nwnear: nwnear,
	Oacute: Oacute$1,
	oacute: oacute$1,
	oast: oast,
	Ocirc: Ocirc$1,
	ocirc: ocirc$1,
	ocir: ocir,
	Ocy: Ocy,
	ocy: ocy,
	odash: odash,
	Odblac: Odblac,
	odblac: odblac,
	odiv: odiv,
	odot: odot,
	odsold: odsold,
	OElig: OElig,
	oelig: oelig,
	ofcir: ofcir,
	Ofr: Ofr,
	ofr: ofr,
	ogon: ogon,
	Ograve: Ograve$1,
	ograve: ograve$1,
	ogt: ogt,
	ohbar: ohbar,
	ohm: ohm,
	oint: oint,
	olarr: olarr,
	olcir: olcir,
	olcross: olcross,
	oline: oline,
	olt: olt,
	Omacr: Omacr,
	omacr: omacr,
	Omega: Omega,
	omega: omega,
	Omicron: Omicron,
	omicron: omicron,
	omid: omid,
	ominus: ominus,
	Oopf: Oopf,
	oopf: oopf,
	opar: opar,
	OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
	OpenCurlyQuote: OpenCurlyQuote,
	operp: operp,
	oplus: oplus,
	orarr: orarr,
	Or: Or,
	or: or,
	ord: ord,
	order: order,
	orderof: orderof,
	ordf: ordf$1,
	ordm: ordm$1,
	origof: origof,
	oror: oror,
	orslope: orslope,
	orv: orv,
	oS: oS,
	Oscr: Oscr,
	oscr: oscr,
	Oslash: Oslash$1,
	oslash: oslash$1,
	osol: osol,
	Otilde: Otilde$1,
	otilde: otilde$1,
	otimesas: otimesas,
	Otimes: Otimes,
	otimes: otimes,
	Ouml: Ouml$1,
	ouml: ouml$1,
	ovbar: ovbar,
	OverBar: OverBar,
	OverBrace: OverBrace,
	OverBracket: OverBracket,
	OverParenthesis: OverParenthesis,
	para: para$1,
	parallel: parallel$1,
	par: par,
	parsim: parsim,
	parsl: parsl,
	part: part,
	PartialD: PartialD,
	Pcy: Pcy,
	pcy: pcy,
	percnt: percnt,
	period: period,
	permil: permil,
	perp: perp,
	pertenk: pertenk,
	Pfr: Pfr,
	pfr: pfr,
	Phi: Phi,
	phi: phi,
	phiv: phiv,
	phmmat: phmmat,
	phone: phone,
	Pi: Pi,
	pi: pi,
	pitchfork: pitchfork,
	piv: piv,
	planck: planck,
	planckh: planckh,
	plankv: plankv,
	plusacir: plusacir,
	plusb: plusb,
	pluscir: pluscir,
	plus: plus,
	plusdo: plusdo,
	plusdu: plusdu,
	pluse: pluse,
	PlusMinus: PlusMinus,
	plusmn: plusmn$1,
	plussim: plussim,
	plustwo: plustwo,
	pm: pm,
	Poincareplane: Poincareplane,
	pointint: pointint,
	popf: popf,
	Popf: Popf,
	pound: pound$1,
	prap: prap,
	Pr: Pr,
	pr: pr,
	prcue: prcue,
	precapprox: precapprox,
	prec: prec,
	preccurlyeq: preccurlyeq,
	Precedes: Precedes,
	PrecedesEqual: PrecedesEqual,
	PrecedesSlantEqual: PrecedesSlantEqual,
	PrecedesTilde: PrecedesTilde,
	preceq: preceq,
	precnapprox: precnapprox,
	precneqq: precneqq,
	precnsim: precnsim,
	pre: pre,
	prE: prE,
	precsim: precsim,
	prime: prime,
	Prime: Prime,
	primes: primes,
	prnap: prnap,
	prnE: prnE,
	prnsim: prnsim,
	prod: prod,
	Product: Product,
	profalar: profalar,
	profline: profline,
	profsurf: profsurf,
	prop: prop,
	Proportional: Proportional,
	Proportion: Proportion,
	propto: propto,
	prsim: prsim,
	prurel: prurel,
	Pscr: Pscr,
	pscr: pscr,
	Psi: Psi,
	psi: psi,
	puncsp: puncsp,
	Qfr: Qfr,
	qfr: qfr,
	qint: qint,
	qopf: qopf,
	Qopf: Qopf,
	qprime: qprime,
	Qscr: Qscr,
	qscr: qscr,
	quaternions: quaternions,
	quatint: quatint,
	quest: quest,
	questeq: questeq,
	quot: quot$2,
	QUOT: QUOT$1,
	rAarr: rAarr,
	race: race,
	Racute: Racute,
	racute: racute,
	radic: radic,
	raemptyv: raemptyv,
	rang: rang,
	Rang: Rang,
	rangd: rangd,
	range: range,
	rangle: rangle,
	raquo: raquo$1,
	rarrap: rarrap,
	rarrb: rarrb,
	rarrbfs: rarrbfs,
	rarrc: rarrc,
	rarr: rarr,
	Rarr: Rarr,
	rArr: rArr,
	rarrfs: rarrfs,
	rarrhk: rarrhk,
	rarrlp: rarrlp,
	rarrpl: rarrpl,
	rarrsim: rarrsim,
	Rarrtl: Rarrtl,
	rarrtl: rarrtl,
	rarrw: rarrw,
	ratail: ratail,
	rAtail: rAtail,
	ratio: ratio,
	rationals: rationals,
	rbarr: rbarr,
	rBarr: rBarr,
	RBarr: RBarr,
	rbbrk: rbbrk,
	rbrace: rbrace,
	rbrack: rbrack,
	rbrke: rbrke,
	rbrksld: rbrksld,
	rbrkslu: rbrkslu,
	Rcaron: Rcaron,
	rcaron: rcaron,
	Rcedil: Rcedil,
	rcedil: rcedil,
	rceil: rceil,
	rcub: rcub,
	Rcy: Rcy,
	rcy: rcy,
	rdca: rdca,
	rdldhar: rdldhar,
	rdquo: rdquo,
	rdquor: rdquor,
	rdsh: rdsh,
	real: real,
	realine: realine,
	realpart: realpart,
	reals: reals,
	Re: Re,
	rect: rect,
	reg: reg$1,
	REG: REG$1,
	ReverseElement: ReverseElement,
	ReverseEquilibrium: ReverseEquilibrium,
	ReverseUpEquilibrium: ReverseUpEquilibrium,
	rfisht: rfisht,
	rfloor: rfloor,
	rfr: rfr,
	Rfr: Rfr,
	rHar: rHar,
	rhard: rhard,
	rharu: rharu,
	rharul: rharul,
	Rho: Rho,
	rho: rho,
	rhov: rhov,
	RightAngleBracket: RightAngleBracket,
	RightArrowBar: RightArrowBar,
	rightarrow: rightarrow,
	RightArrow: RightArrow,
	Rightarrow: Rightarrow,
	RightArrowLeftArrow: RightArrowLeftArrow,
	rightarrowtail: rightarrowtail,
	RightCeiling: RightCeiling,
	RightDoubleBracket: RightDoubleBracket,
	RightDownTeeVector: RightDownTeeVector,
	RightDownVectorBar: RightDownVectorBar,
	RightDownVector: RightDownVector,
	RightFloor: RightFloor,
	rightharpoondown: rightharpoondown,
	rightharpoonup: rightharpoonup,
	rightleftarrows: rightleftarrows,
	rightleftharpoons: rightleftharpoons,
	rightrightarrows: rightrightarrows,
	rightsquigarrow: rightsquigarrow,
	RightTeeArrow: RightTeeArrow,
	RightTee: RightTee,
	RightTeeVector: RightTeeVector,
	rightthreetimes: rightthreetimes,
	RightTriangleBar: RightTriangleBar,
	RightTriangle: RightTriangle,
	RightTriangleEqual: RightTriangleEqual,
	RightUpDownVector: RightUpDownVector,
	RightUpTeeVector: RightUpTeeVector,
	RightUpVectorBar: RightUpVectorBar,
	RightUpVector: RightUpVector,
	RightVectorBar: RightVectorBar,
	RightVector: RightVector,
	ring: ring,
	risingdotseq: risingdotseq,
	rlarr: rlarr,
	rlhar: rlhar,
	rlm: rlm,
	rmoustache: rmoustache,
	rmoust: rmoust,
	rnmid: rnmid,
	roang: roang,
	roarr: roarr,
	robrk: robrk,
	ropar: ropar,
	ropf: ropf,
	Ropf: Ropf,
	roplus: roplus,
	rotimes: rotimes,
	RoundImplies: RoundImplies,
	rpar: rpar,
	rpargt: rpargt,
	rppolint: rppolint,
	rrarr: rrarr,
	Rrightarrow: Rrightarrow,
	rsaquo: rsaquo,
	rscr: rscr,
	Rscr: Rscr,
	rsh: rsh,
	Rsh: Rsh,
	rsqb: rsqb,
	rsquo: rsquo,
	rsquor: rsquor,
	rthree: rthree,
	rtimes: rtimes,
	rtri: rtri,
	rtrie: rtrie,
	rtrif: rtrif,
	rtriltri: rtriltri,
	RuleDelayed: RuleDelayed,
	ruluhar: ruluhar,
	rx: rx,
	Sacute: Sacute,
	sacute: sacute,
	sbquo: sbquo,
	scap: scap,
	Scaron: Scaron,
	scaron: scaron,
	Sc: Sc,
	sc: sc,
	sccue: sccue,
	sce: sce,
	scE: scE,
	Scedil: Scedil,
	scedil: scedil,
	Scirc: Scirc,
	scirc: scirc,
	scnap: scnap,
	scnE: scnE,
	scnsim: scnsim,
	scpolint: scpolint,
	scsim: scsim,
	Scy: Scy,
	scy: scy,
	sdotb: sdotb,
	sdot: sdot,
	sdote: sdote,
	searhk: searhk,
	searr: searr,
	seArr: seArr,
	searrow: searrow,
	sect: sect$1,
	semi: semi,
	seswar: seswar,
	setminus: setminus,
	setmn: setmn,
	sext: sext,
	Sfr: Sfr,
	sfr: sfr,
	sfrown: sfrown,
	sharp: sharp,
	SHCHcy: SHCHcy,
	shchcy: shchcy,
	SHcy: SHcy,
	shcy: shcy,
	ShortDownArrow: ShortDownArrow,
	ShortLeftArrow: ShortLeftArrow,
	shortmid: shortmid,
	shortparallel: shortparallel,
	ShortRightArrow: ShortRightArrow,
	ShortUpArrow: ShortUpArrow,
	shy: shy$1,
	Sigma: Sigma,
	sigma: sigma,
	sigmaf: sigmaf,
	sigmav: sigmav,
	sim: sim,
	simdot: simdot,
	sime: sime,
	simeq: simeq,
	simg: simg,
	simgE: simgE,
	siml: siml,
	simlE: simlE,
	simne: simne,
	simplus: simplus,
	simrarr: simrarr,
	slarr: slarr,
	SmallCircle: SmallCircle,
	smallsetminus: smallsetminus,
	smashp: smashp,
	smeparsl: smeparsl,
	smid: smid,
	smile: smile,
	smt: smt,
	smte: smte,
	smtes: smtes,
	SOFTcy: SOFTcy,
	softcy: softcy,
	solbar: solbar,
	solb: solb,
	sol: sol,
	Sopf: Sopf,
	sopf: sopf,
	spades: spades,
	spadesuit: spadesuit,
	spar: spar,
	sqcap: sqcap,
	sqcaps: sqcaps,
	sqcup: sqcup,
	sqcups: sqcups,
	Sqrt: Sqrt,
	sqsub: sqsub,
	sqsube: sqsube,
	sqsubset: sqsubset,
	sqsubseteq: sqsubseteq,
	sqsup: sqsup,
	sqsupe: sqsupe,
	sqsupset: sqsupset,
	sqsupseteq: sqsupseteq,
	square: square,
	Square: Square,
	SquareIntersection: SquareIntersection,
	SquareSubset: SquareSubset,
	SquareSubsetEqual: SquareSubsetEqual,
	SquareSuperset: SquareSuperset,
	SquareSupersetEqual: SquareSupersetEqual,
	SquareUnion: SquareUnion,
	squarf: squarf,
	squ: squ,
	squf: squf,
	srarr: srarr,
	Sscr: Sscr,
	sscr: sscr,
	ssetmn: ssetmn,
	ssmile: ssmile,
	sstarf: sstarf,
	Star: Star,
	star: star,
	starf: starf,
	straightepsilon: straightepsilon,
	straightphi: straightphi,
	strns: strns,
	sub: sub,
	Sub: Sub,
	subdot: subdot,
	subE: subE,
	sube: sube,
	subedot: subedot,
	submult: submult,
	subnE: subnE,
	subne: subne,
	subplus: subplus,
	subrarr: subrarr,
	subset: subset,
	Subset: Subset,
	subseteq: subseteq,
	subseteqq: subseteqq,
	SubsetEqual: SubsetEqual,
	subsetneq: subsetneq,
	subsetneqq: subsetneqq,
	subsim: subsim,
	subsub: subsub,
	subsup: subsup,
	succapprox: succapprox,
	succ: succ,
	succcurlyeq: succcurlyeq,
	Succeeds: Succeeds,
	SucceedsEqual: SucceedsEqual,
	SucceedsSlantEqual: SucceedsSlantEqual,
	SucceedsTilde: SucceedsTilde,
	succeq: succeq,
	succnapprox: succnapprox,
	succneqq: succneqq,
	succnsim: succnsim,
	succsim: succsim,
	SuchThat: SuchThat,
	sum: sum,
	Sum: Sum,
	sung: sung,
	sup1: sup1$1,
	sup2: sup2$1,
	sup3: sup3$1,
	sup: sup,
	Sup: Sup,
	supdot: supdot,
	supdsub: supdsub,
	supE: supE,
	supe: supe,
	supedot: supedot,
	Superset: Superset,
	SupersetEqual: SupersetEqual,
	suphsol: suphsol,
	suphsub: suphsub,
	suplarr: suplarr,
	supmult: supmult,
	supnE: supnE,
	supne: supne,
	supplus: supplus,
	supset: supset,
	Supset: Supset,
	supseteq: supseteq,
	supseteqq: supseteqq,
	supsetneq: supsetneq,
	supsetneqq: supsetneqq,
	supsim: supsim,
	supsub: supsub,
	supsup: supsup,
	swarhk: swarhk,
	swarr: swarr,
	swArr: swArr,
	swarrow: swarrow,
	swnwar: swnwar,
	szlig: szlig$1,
	Tab: Tab,
	target: target,
	Tau: Tau,
	tau: tau,
	tbrk: tbrk,
	Tcaron: Tcaron,
	tcaron: tcaron,
	Tcedil: Tcedil,
	tcedil: tcedil,
	Tcy: Tcy,
	tcy: tcy,
	tdot: tdot,
	telrec: telrec,
	Tfr: Tfr,
	tfr: tfr,
	there4: there4,
	therefore: therefore,
	Therefore: Therefore,
	Theta: Theta,
	theta: theta,
	thetasym: thetasym,
	thetav: thetav,
	thickapprox: thickapprox,
	thicksim: thicksim,
	ThickSpace: ThickSpace,
	ThinSpace: ThinSpace,
	thinsp: thinsp,
	thkap: thkap,
	thksim: thksim,
	THORN: THORN$1,
	thorn: thorn$1,
	tilde: tilde,
	Tilde: Tilde,
	TildeEqual: TildeEqual,
	TildeFullEqual: TildeFullEqual,
	TildeTilde: TildeTilde,
	timesbar: timesbar,
	timesb: timesb,
	times: times$1,
	timesd: timesd,
	tint: tint,
	toea: toea,
	topbot: topbot,
	topcir: topcir,
	top: top,
	Topf: Topf,
	topf: topf,
	topfork: topfork,
	tosa: tosa,
	tprime: tprime,
	trade: trade,
	TRADE: TRADE,
	triangle: triangle,
	triangledown: triangledown,
	triangleleft: triangleleft,
	trianglelefteq: trianglelefteq,
	triangleq: triangleq,
	triangleright: triangleright,
	trianglerighteq: trianglerighteq,
	tridot: tridot,
	trie: trie,
	triminus: triminus,
	TripleDot: TripleDot,
	triplus: triplus,
	trisb: trisb,
	tritime: tritime,
	trpezium: trpezium,
	Tscr: Tscr,
	tscr: tscr,
	TScy: TScy,
	tscy: tscy,
	TSHcy: TSHcy,
	tshcy: tshcy,
	Tstrok: Tstrok,
	tstrok: tstrok,
	twixt: twixt,
	twoheadleftarrow: twoheadleftarrow,
	twoheadrightarrow: twoheadrightarrow,
	Uacute: Uacute$1,
	uacute: uacute$1,
	uarr: uarr,
	Uarr: Uarr,
	uArr: uArr,
	Uarrocir: Uarrocir,
	Ubrcy: Ubrcy,
	ubrcy: ubrcy,
	Ubreve: Ubreve,
	ubreve: ubreve,
	Ucirc: Ucirc$1,
	ucirc: ucirc$1,
	Ucy: Ucy,
	ucy: ucy,
	udarr: udarr,
	Udblac: Udblac,
	udblac: udblac,
	udhar: udhar,
	ufisht: ufisht,
	Ufr: Ufr,
	ufr: ufr,
	Ugrave: Ugrave$1,
	ugrave: ugrave$1,
	uHar: uHar,
	uharl: uharl,
	uharr: uharr,
	uhblk: uhblk,
	ulcorn: ulcorn,
	ulcorner: ulcorner,
	ulcrop: ulcrop,
	ultri: ultri,
	Umacr: Umacr,
	umacr: umacr,
	uml: uml$1,
	UnderBar: UnderBar,
	UnderBrace: UnderBrace,
	UnderBracket: UnderBracket,
	UnderParenthesis: UnderParenthesis,
	Union: Union,
	UnionPlus: UnionPlus,
	Uogon: Uogon,
	uogon: uogon,
	Uopf: Uopf,
	uopf: uopf,
	UpArrowBar: UpArrowBar,
	uparrow: uparrow,
	UpArrow: UpArrow,
	Uparrow: Uparrow,
	UpArrowDownArrow: UpArrowDownArrow,
	updownarrow: updownarrow,
	UpDownArrow: UpDownArrow,
	Updownarrow: Updownarrow,
	UpEquilibrium: UpEquilibrium,
	upharpoonleft: upharpoonleft,
	upharpoonright: upharpoonright,
	uplus: uplus,
	UpperLeftArrow: UpperLeftArrow,
	UpperRightArrow: UpperRightArrow,
	upsi: upsi,
	Upsi: Upsi,
	upsih: upsih,
	Upsilon: Upsilon,
	upsilon: upsilon,
	UpTeeArrow: UpTeeArrow,
	UpTee: UpTee,
	upuparrows: upuparrows,
	urcorn: urcorn,
	urcorner: urcorner,
	urcrop: urcrop,
	Uring: Uring,
	uring: uring,
	urtri: urtri,
	Uscr: Uscr,
	uscr: uscr,
	utdot: utdot,
	Utilde: Utilde,
	utilde: utilde,
	utri: utri,
	utrif: utrif,
	uuarr: uuarr,
	Uuml: Uuml$1,
	uuml: uuml$1,
	uwangle: uwangle,
	vangrt: vangrt,
	varepsilon: varepsilon,
	varkappa: varkappa,
	varnothing: varnothing,
	varphi: varphi,
	varpi: varpi,
	varpropto: varpropto,
	varr: varr,
	vArr: vArr,
	varrho: varrho,
	varsigma: varsigma,
	varsubsetneq: varsubsetneq,
	varsubsetneqq: varsubsetneqq,
	varsupsetneq: varsupsetneq,
	varsupsetneqq: varsupsetneqq,
	vartheta: vartheta,
	vartriangleleft: vartriangleleft,
	vartriangleright: vartriangleright,
	vBar: vBar,
	Vbar: Vbar,
	vBarv: vBarv,
	Vcy: Vcy,
	vcy: vcy,
	vdash: vdash,
	vDash: vDash,
	Vdash: Vdash,
	VDash: VDash,
	Vdashl: Vdashl,
	veebar: veebar,
	vee: vee,
	Vee: Vee,
	veeeq: veeeq,
	vellip: vellip,
	verbar: verbar,
	Verbar: Verbar,
	vert: vert,
	Vert: Vert,
	VerticalBar: VerticalBar,
	VerticalLine: VerticalLine,
	VerticalSeparator: VerticalSeparator,
	VerticalTilde: VerticalTilde,
	VeryThinSpace: VeryThinSpace,
	Vfr: Vfr,
	vfr: vfr,
	vltri: vltri,
	vnsub: vnsub,
	vnsup: vnsup,
	Vopf: Vopf,
	vopf: vopf,
	vprop: vprop,
	vrtri: vrtri,
	Vscr: Vscr,
	vscr: vscr,
	vsubnE: vsubnE,
	vsubne: vsubne,
	vsupnE: vsupnE,
	vsupne: vsupne,
	Vvdash: Vvdash,
	vzigzag: vzigzag,
	Wcirc: Wcirc,
	wcirc: wcirc,
	wedbar: wedbar,
	wedge: wedge,
	Wedge: Wedge,
	wedgeq: wedgeq,
	weierp: weierp,
	Wfr: Wfr,
	wfr: wfr,
	Wopf: Wopf,
	wopf: wopf,
	wp: wp,
	wr: wr,
	wreath: wreath,
	Wscr: Wscr,
	wscr: wscr,
	xcap: xcap,
	xcirc: xcirc,
	xcup: xcup,
	xdtri: xdtri,
	Xfr: Xfr,
	xfr: xfr,
	xharr: xharr,
	xhArr: xhArr,
	Xi: Xi,
	xi: xi,
	xlarr: xlarr,
	xlArr: xlArr,
	xmap: xmap,
	xnis: xnis,
	xodot: xodot,
	Xopf: Xopf,
	xopf: xopf,
	xoplus: xoplus,
	xotime: xotime,
	xrarr: xrarr,
	xrArr: xrArr,
	Xscr: Xscr,
	xscr: xscr,
	xsqcup: xsqcup,
	xuplus: xuplus,
	xutri: xutri,
	xvee: xvee,
	xwedge: xwedge,
	Yacute: Yacute$1,
	yacute: yacute$1,
	YAcy: YAcy,
	yacy: yacy,
	Ycirc: Ycirc,
	ycirc: ycirc,
	Ycy: Ycy,
	ycy: ycy,
	yen: yen$1,
	Yfr: Yfr,
	yfr: yfr,
	YIcy: YIcy,
	yicy: yicy,
	Yopf: Yopf,
	yopf: yopf,
	Yscr: Yscr,
	yscr: yscr,
	YUcy: YUcy,
	yucy: yucy,
	yuml: yuml$1,
	Yuml: Yuml,
	Zacute: Zacute,
	zacute: zacute,
	Zcaron: Zcaron,
	zcaron: zcaron,
	Zcy: Zcy,
	zcy: zcy,
	Zdot: Zdot,
	zdot: zdot,
	zeetrf: zeetrf,
	ZeroWidthSpace: ZeroWidthSpace,
	Zeta: Zeta,
	zeta: zeta,
	zfr: zfr,
	Zfr: Zfr,
	ZHcy: ZHcy,
	zhcy: zhcy,
	zigrarr: zigrarr,
	zopf: zopf,
	Zopf: Zopf,
	Zscr: Zscr,
	zscr: zscr,
	zwj: zwj,
	zwnj: zwnj
};

var Aacute = "Á";
var aacute = "á";
var Acirc = "Â";
var acirc = "â";
var acute = "´";
var AElig = "Æ";
var aelig = "æ";
var Agrave = "À";
var agrave = "à";
var amp$1 = "&";
var AMP = "&";
var Aring = "Å";
var aring = "å";
var Atilde = "Ã";
var atilde = "ã";
var Auml = "Ä";
var auml = "ä";
var brvbar = "¦";
var Ccedil = "Ç";
var ccedil = "ç";
var cedil = "¸";
var cent = "¢";
var copy$1 = "©";
var COPY = "©";
var curren = "¤";
var deg = "°";
var divide = "÷";
var Eacute = "É";
var eacute = "é";
var Ecirc = "Ê";
var ecirc = "ê";
var Egrave = "È";
var egrave = "è";
var ETH = "Ð";
var eth = "ð";
var Euml = "Ë";
var euml = "ë";
var frac12 = "½";
var frac14 = "¼";
var frac34 = "¾";
var gt$1 = ">";
var GT = ">";
var Iacute = "Í";
var iacute = "í";
var Icirc = "Î";
var icirc = "î";
var iexcl = "¡";
var Igrave = "Ì";
var igrave = "ì";
var iquest = "¿";
var Iuml = "Ï";
var iuml = "ï";
var laquo = "«";
var lt$1 = "<";
var LT = "<";
var macr = "¯";
var micro = "µ";
var middot = "·";
var nbsp = " ";
var not = "¬";
var Ntilde = "Ñ";
var ntilde = "ñ";
var Oacute = "Ó";
var oacute = "ó";
var Ocirc = "Ô";
var ocirc = "ô";
var Ograve = "Ò";
var ograve = "ò";
var ordf = "ª";
var ordm = "º";
var Oslash = "Ø";
var oslash = "ø";
var Otilde = "Õ";
var otilde = "õ";
var Ouml = "Ö";
var ouml = "ö";
var para = "¶";
var plusmn = "±";
var pound = "£";
var quot$1 = "\"";
var QUOT = "\"";
var raquo = "»";
var reg = "®";
var REG = "®";
var sect = "§";
var shy = "­";
var sup1 = "¹";
var sup2 = "²";
var sup3 = "³";
var szlig = "ß";
var THORN = "Þ";
var thorn = "þ";
var times = "×";
var Uacute = "Ú";
var uacute = "ú";
var Ucirc = "Û";
var ucirc = "û";
var Ugrave = "Ù";
var ugrave = "ù";
var uml = "¨";
var Uuml = "Ü";
var uuml = "ü";
var Yacute = "Ý";
var yacute = "ý";
var yen = "¥";
var yuml = "ÿ";
var require$$1 = {
	Aacute: Aacute,
	aacute: aacute,
	Acirc: Acirc,
	acirc: acirc,
	acute: acute,
	AElig: AElig,
	aelig: aelig,
	Agrave: Agrave,
	agrave: agrave,
	amp: amp$1,
	AMP: AMP,
	Aring: Aring,
	aring: aring,
	Atilde: Atilde,
	atilde: atilde,
	Auml: Auml,
	auml: auml,
	brvbar: brvbar,
	Ccedil: Ccedil,
	ccedil: ccedil,
	cedil: cedil,
	cent: cent,
	copy: copy$1,
	COPY: COPY,
	curren: curren,
	deg: deg,
	divide: divide,
	Eacute: Eacute,
	eacute: eacute,
	Ecirc: Ecirc,
	ecirc: ecirc,
	Egrave: Egrave,
	egrave: egrave,
	ETH: ETH,
	eth: eth,
	Euml: Euml,
	euml: euml,
	frac12: frac12,
	frac14: frac14,
	frac34: frac34,
	gt: gt$1,
	GT: GT,
	Iacute: Iacute,
	iacute: iacute,
	Icirc: Icirc,
	icirc: icirc,
	iexcl: iexcl,
	Igrave: Igrave,
	igrave: igrave,
	iquest: iquest,
	Iuml: Iuml,
	iuml: iuml,
	laquo: laquo,
	lt: lt$1,
	LT: LT,
	macr: macr,
	micro: micro,
	middot: middot,
	nbsp: nbsp,
	not: not,
	Ntilde: Ntilde,
	ntilde: ntilde,
	Oacute: Oacute,
	oacute: oacute,
	Ocirc: Ocirc,
	ocirc: ocirc,
	Ograve: Ograve,
	ograve: ograve,
	ordf: ordf,
	ordm: ordm,
	Oslash: Oslash,
	oslash: oslash,
	Otilde: Otilde,
	otilde: otilde,
	Ouml: Ouml,
	ouml: ouml,
	para: para,
	plusmn: plusmn,
	pound: pound,
	quot: quot$1,
	QUOT: QUOT,
	raquo: raquo,
	reg: reg,
	REG: REG,
	sect: sect,
	shy: shy,
	sup1: sup1,
	sup2: sup2,
	sup3: sup3,
	szlig: szlig,
	THORN: THORN,
	thorn: thorn,
	times: times,
	Uacute: Uacute,
	uacute: uacute,
	Ucirc: Ucirc,
	ucirc: ucirc,
	Ugrave: Ugrave,
	ugrave: ugrave,
	uml: uml,
	Uuml: Uuml,
	uuml: uuml,
	Yacute: Yacute,
	yacute: yacute,
	yen: yen,
	yuml: yuml
};

var amp = "&";
var apos = "'";
var gt = ">";
var lt = "<";
var quot = "\"";
var require$$0$3 = {
	amp: amp,
	apos: apos,
	gt: gt,
	lt: lt,
	quot: quot
};

var decode_codepoint = {};

var require$$0$2 = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

var __importDefault$4 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(decode_codepoint, "__esModule", { value: true });
var decode_json_1 = __importDefault$4(require$$0$2);
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
    }
    return fromCodePoint(codePoint);
}
decode_codepoint.default = decodeCodePoint;

var __importDefault$3 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(decode, "__esModule", { value: true });
decode.decodeHTML = decode.decodeHTMLStrict = decode.decodeXML = void 0;
var entities_json_1$1 = __importDefault$3(require$$1$1);
var legacy_json_1 = __importDefault$3(require$$1);
var xml_json_1$1 = __importDefault$3(require$$0$3);
var decode_codepoint_1 = __importDefault$3(decode_codepoint);
var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
decode.decodeXML = getStrictDecoder(xml_json_1$1.default);
decode.decodeHTMLStrict = getStrictDecoder(entities_json_1$1.default);
function getStrictDecoder(map) {
    var replace = getReplacer(map);
    return function (str) { return String(str).replace(strictEntityRe, replace); };
}
var sorter$1 = function (a, b) { return (a < b ? 1 : -1); };
decode.decodeHTML = (function () {
    var legacy = Object.keys(legacy_json_1.default).sort(sorter$1);
    var keys = Object.keys(entities_json_1$1.default).sort(sorter$1);
    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        }
        else {
            keys[i] += ";";
        }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1$1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";")
            str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function (str) { return String(str).replace(re, replacer); };
})();
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") {
                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
            }
            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}

var encode$1 = {};

var __importDefault$2 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(encode$1, "__esModule", { value: true });
encode$1.escapeUTF8 = encode$1.escape = encode$1.encodeNonAsciiHTML = encode$1.encodeHTML = encode$1.encodeXML = void 0;
var xml_json_1 = __importDefault$2(require$$0$3);
var inverseXML = getInverseObj(xml_json_1.default);
var xmlReplacer = getInverseReplacer(inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
encode$1.encodeXML = getASCIIEncoder(inverseXML);
var entities_json_1 = __importDefault$2(require$$1$1);
var inverseHTML = getInverseObj(entities_json_1.default);
var htmlReplacer = getInverseReplacer(inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
encode$1.encodeHTML = getInverse(inverseHTML, htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
encode$1.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
        var k = _a[_i];
        if (k.length === 1) {
            // Add value to single array
            single.push("\\" + k);
        }
        else {
            // Add value to multiple array
            multiple.push(k);
        }
    }
    // Add ranges to single characters.
    single.sort();
    for (var start = 0; start < single.length - 1; start++) {
        // Find the end of a run of characters
        var end = start;
        while (end < single.length - 1 &&
            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
            end += 1;
        }
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3)
            continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var getCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        function (str) { return str.codePointAt(0); }
    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        function (c) {
            return (c.charCodeAt(0) - 0xd800) * 0x400 +
                c.charCodeAt(1) -
                0xdc00 +
                0x10000;
        };
function singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
        .toString(16)
        .toUpperCase() + ";";
}
function getInverse(inverse, re) {
    return function (data) {
        return data
            .replace(re, function (name) { return inverse[name]; })
            .replace(reNonASCII, singleCharReplacer);
    };
}
var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
function escape$2(data) {
    return data.replace(reEscapeChars, singleCharReplacer);
}
encode$1.escape = escape$2;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
function escapeUTF8(data) {
    return data.replace(xmlReplacer, singleCharReplacer);
}
encode$1.escapeUTF8 = escapeUTF8;
function getASCIIEncoder(obj) {
    return function (data) {
        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
    };
}

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
var decode_1 = decode;
var encode_1 = encode$1;
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */
function decode$1(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
}
exports.decode = decode$1;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */
function decodeStrict(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */
function encode(data, level) {
    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
}
exports.encode = encode;
var encode_2 = encode$1;
Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } });
Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return encode_2.escapeUTF8; } });
// Legacy aliases (deprecated)
Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
var decode_2 = decode;
Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
// Legacy aliases (deprecated)
Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });
}(lib));

var foreignNames = {};

Object.defineProperty(foreignNames, "__esModule", { value: true });
foreignNames.attributeNames = foreignNames.elementNames = void 0;
foreignNames.elementNames = new Map([
    ["altglyph", "altGlyph"],
    ["altglyphdef", "altGlyphDef"],
    ["altglyphitem", "altGlyphItem"],
    ["animatecolor", "animateColor"],
    ["animatemotion", "animateMotion"],
    ["animatetransform", "animateTransform"],
    ["clippath", "clipPath"],
    ["feblend", "feBlend"],
    ["fecolormatrix", "feColorMatrix"],
    ["fecomponenttransfer", "feComponentTransfer"],
    ["fecomposite", "feComposite"],
    ["feconvolvematrix", "feConvolveMatrix"],
    ["fediffuselighting", "feDiffuseLighting"],
    ["fedisplacementmap", "feDisplacementMap"],
    ["fedistantlight", "feDistantLight"],
    ["fedropshadow", "feDropShadow"],
    ["feflood", "feFlood"],
    ["fefunca", "feFuncA"],
    ["fefuncb", "feFuncB"],
    ["fefuncg", "feFuncG"],
    ["fefuncr", "feFuncR"],
    ["fegaussianblur", "feGaussianBlur"],
    ["feimage", "feImage"],
    ["femerge", "feMerge"],
    ["femergenode", "feMergeNode"],
    ["femorphology", "feMorphology"],
    ["feoffset", "feOffset"],
    ["fepointlight", "fePointLight"],
    ["fespecularlighting", "feSpecularLighting"],
    ["fespotlight", "feSpotLight"],
    ["fetile", "feTile"],
    ["feturbulence", "feTurbulence"],
    ["foreignobject", "foreignObject"],
    ["glyphref", "glyphRef"],
    ["lineargradient", "linearGradient"],
    ["radialgradient", "radialGradient"],
    ["textpath", "textPath"],
]);
foreignNames.attributeNames = new Map([
    ["definitionurl", "definitionURL"],
    ["attributename", "attributeName"],
    ["attributetype", "attributeType"],
    ["basefrequency", "baseFrequency"],
    ["baseprofile", "baseProfile"],
    ["calcmode", "calcMode"],
    ["clippathunits", "clipPathUnits"],
    ["diffuseconstant", "diffuseConstant"],
    ["edgemode", "edgeMode"],
    ["filterunits", "filterUnits"],
    ["glyphref", "glyphRef"],
    ["gradienttransform", "gradientTransform"],
    ["gradientunits", "gradientUnits"],
    ["kernelmatrix", "kernelMatrix"],
    ["kernelunitlength", "kernelUnitLength"],
    ["keypoints", "keyPoints"],
    ["keysplines", "keySplines"],
    ["keytimes", "keyTimes"],
    ["lengthadjust", "lengthAdjust"],
    ["limitingconeangle", "limitingConeAngle"],
    ["markerheight", "markerHeight"],
    ["markerunits", "markerUnits"],
    ["markerwidth", "markerWidth"],
    ["maskcontentunits", "maskContentUnits"],
    ["maskunits", "maskUnits"],
    ["numoctaves", "numOctaves"],
    ["pathlength", "pathLength"],
    ["patterncontentunits", "patternContentUnits"],
    ["patterntransform", "patternTransform"],
    ["patternunits", "patternUnits"],
    ["pointsatx", "pointsAtX"],
    ["pointsaty", "pointsAtY"],
    ["pointsatz", "pointsAtZ"],
    ["preservealpha", "preserveAlpha"],
    ["preserveaspectratio", "preserveAspectRatio"],
    ["primitiveunits", "primitiveUnits"],
    ["refx", "refX"],
    ["refy", "refY"],
    ["repeatcount", "repeatCount"],
    ["repeatdur", "repeatDur"],
    ["requiredextensions", "requiredExtensions"],
    ["requiredfeatures", "requiredFeatures"],
    ["specularconstant", "specularConstant"],
    ["specularexponent", "specularExponent"],
    ["spreadmethod", "spreadMethod"],
    ["startoffset", "startOffset"],
    ["stddeviation", "stdDeviation"],
    ["stitchtiles", "stitchTiles"],
    ["surfacescale", "surfaceScale"],
    ["systemlanguage", "systemLanguage"],
    ["tablevalues", "tableValues"],
    ["targetx", "targetX"],
    ["targety", "targetY"],
    ["textlength", "textLength"],
    ["viewbox", "viewBox"],
    ["viewtarget", "viewTarget"],
    ["xchannelselector", "xChannelSelector"],
    ["ychannelselector", "yChannelSelector"],
    ["zoomandpan", "zoomAndPan"],
]);

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding$1 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
    __setModuleDefault$1(result, mod);
    return result;
};
Object.defineProperty(lib$1, "__esModule", { value: true });
/*
 * Module dependencies
 */
var ElementType = __importStar$1(lib$3);
var entities_1 = lib;
/**
 * Mixed-case SVG and MathML tags & attributes
 * recognized by the HTML parser.
 *
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */
var foreignNames_1 = foreignNames;
var unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript",
]);
/**
 * Format attributes
 */
function formatAttributes(attributes, opts) {
    if (!attributes)
        return;
    return Object.keys(attributes)
        .map(function (key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") {
            /* Fix up mixed-case attribute names */
            key = (_b = foreignNames_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        }
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
            return key;
        }
        return key + "=\"" + (opts.decodeEntities !== false
            ? entities_1.encodeXML(value)
            : value.replace(/"/g, "&quot;")) + "\"";
    })
        .join(" ");
}
/**
 * Self-enclosing tags
 */
var singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */
function render$1(node, options) {
    if (options === void 0) { options = {}; }
    var nodes = "length" in node ? node : [node];
    var output = "";
    for (var i = 0; i < nodes.length; i++) {
        output += renderNode(nodes[i], options);
    }
    return output;
}
lib$1.default = render$1;
function renderNode(node, options) {
    switch (node.type) {
        case ElementType.Root:
            return render$1(node.children, options);
        case ElementType.Directive:
        case ElementType.Doctype:
            return renderDirective(node);
        case ElementType.Comment:
            return renderComment(node);
        case ElementType.CDATA:
            return renderCdata(node);
        case ElementType.Script:
        case ElementType.Style:
        case ElementType.Tag:
            return renderTag(node, options);
        case ElementType.Text:
            return renderText$1(node, options);
    }
}
var foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title",
]);
var foreignElements = new Set(["svg", "math"]);
function renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */
        elem.name = (_a = foreignNames_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */
        if (elem.parent &&
            foreignModeIntegrationPoints.has(elem.parent.name)) {
            opts = __assign(__assign({}, opts), { xmlMode: false });
        }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
    }
    var tag = "<" + elem.name;
    var attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
        tag += " " + attribs;
    }
    if (elem.children.length === 0 &&
        (opts.xmlMode
            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
                opts.selfClosingTags !== false
            : // User explicitly asked for self-closing tags, even in HTML mode
                opts.selfClosingTags && singleTag.has(elem.name))) {
        if (!opts.xmlMode)
            tag += " ";
        tag += "/>";
    }
    else {
        tag += ">";
        if (elem.children.length > 0) {
            tag += render$1(elem.children, opts);
        }
        if (opts.xmlMode || !singleTag.has(elem.name)) {
            tag += "</" + elem.name + ">";
        }
    }
    return tag;
}
function renderDirective(elem) {
    return "<" + elem.data + ">";
}
function renderText$1(elem, opts) {
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (opts.decodeEntities !== false &&
        !(!opts.xmlMode &&
            elem.parent &&
            unencodedElements.has(elem.parent.name))) {
        data = entities_1.encodeXML(data);
    }
    return data;
}
function renderCdata(elem) {
    return "<![CDATA[" + elem.children[0].data + "]]>";
}
function renderComment(elem) {
    return "<!--" + elem.data + "-->";
}

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(stringify$5, "__esModule", { value: true });
stringify$5.innerText = stringify$5.textContent = stringify$5.getText = stringify$5.getInnerHTML = stringify$5.getOuterHTML = void 0;
var domhandler_1$5 = lib$4;
var dom_serializer_1 = __importDefault$1(lib$1);
var domelementtype_1 = lib$3;
/**
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s outer HTML.
 */
function getOuterHTML(node, options) {
    return (0, dom_serializer_1.default)(node, options);
}
stringify$5.getOuterHTML = getOuterHTML;
/**
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s inner HTML.
 */
function getInnerHTML(node, options) {
    return (0, domhandler_1$5.hasChildren)(node)
        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
        : "";
}
stringify$5.getInnerHTML = getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags.
 *
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */
function getText(node) {
    if (Array.isArray(node))
        return node.map(getText).join("");
    if ((0, domhandler_1$5.isTag)(node))
        return node.name === "br" ? "\n" : getText(node.children);
    if ((0, domhandler_1$5.isCDATA)(node))
        return getText(node.children);
    if ((0, domhandler_1$5.isText)(node))
        return node.data;
    return "";
}
stringify$5.getText = getText;
/**
 * Get a node's text content.
 *
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
function textContent(node) {
    if (Array.isArray(node))
        return node.map(textContent).join("");
    if ((0, domhandler_1$5.hasChildren)(node) && !(0, domhandler_1$5.isComment)(node)) {
        return textContent(node.children);
    }
    if ((0, domhandler_1$5.isText)(node))
        return node.data;
    return "";
}
stringify$5.textContent = textContent;
/**
 * Get a node's inner text.
 *
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */
function innerText(node) {
    if (Array.isArray(node))
        return node.map(innerText).join("");
    if ((0, domhandler_1$5.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1$5.isCDATA)(node))) {
        return innerText(node.children);
    }
    if ((0, domhandler_1$5.isText)(node))
        return node.data;
    return "";
}
stringify$5.innerText = innerText;

var traversal = {};

Object.defineProperty(traversal, "__esModule", { value: true });
traversal.prevElementSibling = traversal.nextElementSibling = traversal.getName = traversal.hasAttrib = traversal.getAttributeValue = traversal.getSiblings = traversal.getParent = traversal.getChildren = void 0;
var domhandler_1$4 = lib$4;
var emptyArray = [];
/**
 * Get a node's children.
 *
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */
function getChildren$1(elem) {
    var _a;
    return (_a = elem.children) !== null && _a !== void 0 ? _a : emptyArray;
}
traversal.getChildren = getChildren$1;
/**
 * Get a node's parent.
 *
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node.
 */
function getParent(elem) {
    return elem.parent || null;
}
traversal.getParent = getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first.
 * If we don't have a parent (the element is a root node),
 * we walk the element's `prev` & `next` to get all remaining nodes.
 *
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings.
 */
function getSiblings(elem) {
    var _a, _b;
    var parent = getParent(elem);
    if (parent != null)
        return getChildren$1(parent);
    var siblings = [elem];
    var prev = elem.prev, next = elem.next;
    while (prev != null) {
        siblings.unshift(prev);
        (_a = prev, prev = _a.prev);
    }
    while (next != null) {
        siblings.push(next);
        (_b = next, next = _b.next);
    }
    return siblings;
}
traversal.getSiblings = getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */
function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
traversal.getAttributeValue = getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */
function hasAttrib(elem, name) {
    return (elem.attribs != null &&
        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
        elem.attribs[name] != null);
}
traversal.hasAttrib = hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */
function getName(elem) {
    return elem.name;
}
traversal.getName = getName;
/**
 * Returns the next element sibling of a node.
 *
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag.
 */
function nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while (next !== null && !(0, domhandler_1$4.isTag)(next))
        (_a = next, next = _a.next);
    return next;
}
traversal.nextElementSibling = nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag.
 */
function prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while (prev !== null && !(0, domhandler_1$4.isTag)(prev))
        (_a = prev, prev = _a.prev);
    return prev;
}
traversal.prevElementSibling = prevElementSibling;

var manipulation = {};

Object.defineProperty(manipulation, "__esModule", { value: true });
manipulation.prepend = manipulation.prependChild = manipulation.append = manipulation.appendChild = manipulation.replaceElement = manipulation.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @param elem The element to be removed
 */
function removeElement(elem) {
    if (elem.prev)
        elem.prev.next = elem.next;
    if (elem.next)
        elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
    }
}
manipulation.removeElement = removeElement;
/**
 * Replace an element in the dom
 *
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */
function replaceElement(elem, replacement) {
    var prev = (replacement.prev = elem.prev);
    if (prev) {
        prev.next = replacement;
    }
    var next = (replacement.next = elem.next);
    if (next) {
        next.prev = replacement;
    }
    var parent = (replacement.parent = elem.parent);
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
    }
}
manipulation.replaceElement = replaceElement;
/**
 * Append a child to an element.
 *
 * @param elem The element to append to.
 * @param child The element to be added as a child.
 */
function appendChild(elem, child) {
    removeElement(child);
    child.next = null;
    child.parent = elem;
    if (elem.children.push(child) > 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    }
    else {
        child.prev = null;
    }
}
manipulation.appendChild = appendChild;
/**
 * Append an element after another.
 *
 * @param elem The element to append after.
 * @param next The element be added.
 */
function append(elem, next) {
    removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    }
    else if (parent) {
        parent.children.push(next);
    }
}
manipulation.append = append;
/**
 * Prepend a child to an element.
 *
 * @param elem The element to prepend before.
 * @param child The element to be added as a child.
 */
function prependChild(elem, child) {
    removeElement(child);
    child.parent = elem;
    child.prev = null;
    if (elem.children.unshift(child) !== 1) {
        var sibling = elem.children[1];
        sibling.prev = child;
        child.next = sibling;
    }
    else {
        child.next = null;
    }
}
manipulation.prependChild = prependChild;
/**
 * Prepend an element before another.
 *
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */
function prepend(elem, prev) {
    removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) {
        elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
manipulation.prepend = prepend;

var querying = {};

Object.defineProperty(querying, "__esModule", { value: true });
querying.findAll = querying.existsOne = querying.findOne = querying.findOneChild = querying.find = querying.filter = void 0;
var domhandler_1$3 = lib$4;
/**
 * Search a node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function filter$1(test, node, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    if (!Array.isArray(node))
        node = [node];
    return find$1(test, node, recurse, limit);
}
querying.filter = filter$1;
/**
 * Search an array of node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function find$1(test, nodes, recurse, limit) {
    var result = [];
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var elem = nodes_1[_i];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0)
                break;
        }
        if (recurse && (0, domhandler_1$3.hasChildren)(elem) && elem.children.length > 0) {
            var children = find$1(test, elem.children, recurse, limit);
            result.push.apply(result, children);
            limit -= children.length;
            if (limit <= 0)
                break;
        }
    }
    return result;
}
querying.find = find$1;
/**
 * Finds the first element inside of an array that matches a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 */
function findOneChild(test, nodes) {
    return nodes.find(test);
}
querying.findOneChild = findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first child node that passes `test`.
 */
function findOne(test, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    var elem = null;
    for (var i = 0; i < nodes.length && !elem; i++) {
        var checked = nodes[i];
        if (!(0, domhandler_1$3.isTag)(checked)) {
            continue;
        }
        else if (test(checked)) {
            elem = checked;
        }
        else if (recurse && checked.children.length > 0) {
            elem = findOne(test, checked.children);
        }
    }
    return elem;
}
querying.findOne = findOne;
/**
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing a test.
 */
function existsOne(test, nodes) {
    return nodes.some(function (checked) {
        return (0, domhandler_1$3.isTag)(checked) &&
            (test(checked) ||
                (checked.children.length > 0 &&
                    existsOne(test, checked.children)));
    });
}
querying.existsOne = existsOne;
/**
 * Search and array of nodes and its children for nodes passing a test function.
 *
 * Same as `find`, only with less options, leading to reduced complexity.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */
function findAll(test, nodes) {
    var _a;
    var result = [];
    var stack = nodes.filter(domhandler_1$3.isTag);
    var elem;
    while ((elem = stack.shift())) {
        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(domhandler_1$3.isTag);
        if (children && children.length > 0) {
            stack.unshift.apply(stack, children);
        }
        if (test(elem))
            result.push(elem);
    }
    return result;
}
querying.findAll = findAll;

var legacy = {};

Object.defineProperty(legacy, "__esModule", { value: true });
legacy.getElementsByTagType = legacy.getElementsByTagName = legacy.getElementById = legacy.getElements = legacy.testElement = void 0;
var domhandler_1$2 = lib$4;
var querying_1 = querying;
var Checks = {
    tag_name: function (name) {
        if (typeof name === "function") {
            return function (elem) { return (0, domhandler_1$2.isTag)(elem) && name(elem.name); };
        }
        else if (name === "*") {
            return domhandler_1$2.isTag;
        }
        return function (elem) { return (0, domhandler_1$2.isTag)(elem) && elem.name === name; };
    },
    tag_type: function (type) {
        if (typeof type === "function") {
            return function (elem) { return type(elem.type); };
        }
        return function (elem) { return elem.type === type; };
    },
    tag_contains: function (data) {
        if (typeof data === "function") {
            return function (elem) { return (0, domhandler_1$2.isText)(elem) && data(elem.data); };
        }
        return function (elem) { return (0, domhandler_1$2.isText)(elem) && elem.data === data; };
    },
};
/**
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a particular value.
 */
function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
        return function (elem) { return (0, domhandler_1$2.isTag)(elem) && value(elem.attribs[attrib]); };
    }
    return function (elem) { return (0, domhandler_1$2.isTag)(elem) && elem.attribs[attrib] === value; };
}
/**
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either
 * of the input functions returns `true` for the node.
 */
function combineFuncs(a, b) {
    return function (elem) { return a(elem) || b(elem); };
}
/**
 * @param options An object describing nodes to look for.
 * @returns A function executing all checks in `options` and returning `true`
 * if any of them match a node.
 */
function compileTest(options) {
    var funcs = Object.keys(options).map(function (key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call(Checks, key)
            ? Checks[key](value)
            : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */
function testElement(options, node) {
    var test = compileTest(options);
    return test ? test(node) : true;
}
legacy.testElement = testElement;
/**
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */
function getElements$1(options, nodes, recurse, limit) {
    if (limit === void 0) { limit = Infinity; }
    var test = compileTest(options);
    return test ? (0, querying_1.filter)(test, nodes, recurse, limit) : [];
}
legacy.getElements = getElements$1;
/**
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */
function getElementById(id, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    if (!Array.isArray(nodes))
        nodes = [nodes];
    return (0, querying_1.findOne)(getAttribCheck("id", id), nodes, recurse);
}
legacy.getElementById = getElementById;
/**
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */
function getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_1.filter)(Checks.tag_name(tagName), nodes, recurse, limit);
}
legacy.getElementsByTagName = getElementsByTagName;
/**
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */
function getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_1.filter)(Checks.tag_type(type), nodes, recurse, limit);
}
legacy.getElementsByTagType = getElementsByTagType;

var helpers = {};

Object.defineProperty(helpers, "__esModule", { value: true });
helpers.uniqueSort = helpers.compareDocumentPosition = helpers.removeSubsets = void 0;
var domhandler_1$1 = lib$4;
/**
 * Given an array of nodes, remove any member that is contained by another.
 *
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't subtrees of each other.
 */
function removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */
    while (--idx >= 0) {
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
            if (nodes.includes(ancestor)) {
                nodes.splice(idx, 1);
                break;
            }
        }
    }
    return nodes;
}
helpers.removeSubsets = removeSubsets;
/**
 * Compare the position of one node against another node in any other document.
 * The return value is a bitmask with the following values:
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent./
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
        return 0;
    }
    var current = (0, domhandler_1$1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, domhandler_1$1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
        idx++;
    }
    if (idx === 0) {
        return 1 /* DISCONNECTED */;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
            return 4 /* FOLLOWING */ | 16 /* CONTAINED_BY */;
        }
        return 4 /* FOLLOWING */;
    }
    if (sharedParent === nodeA) {
        return 2 /* PRECEDING */ | 8 /* CONTAINS */;
    }
    return 2 /* PRECEDING */;
}
helpers.compareDocumentPosition = compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document and
 * remove any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */
function uniqueSort(nodes) {
    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
    nodes.sort(function (a, b) {
        var relative = compareDocumentPosition(a, b);
        if (relative & 2 /* PRECEDING */) {
            return -1;
        }
        else if (relative & 4 /* FOLLOWING */) {
            return 1;
        }
        return 0;
    });
    return nodes;
}
helpers.uniqueSort = uniqueSort;

var feeds = {};

Object.defineProperty(feeds, "__esModule", { value: true });
feeds.getFeed = void 0;
var stringify_1$1 = stringify$5;
var legacy_1 = legacy;
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */
function getFeed(doc) {
    var feedRoot = getOneElement$1(isValidFeed$1, doc);
    return !feedRoot
        ? null
        : feedRoot.name === "feed"
            ? getAtomFeed(feedRoot)
            : getRssFeed(feedRoot);
}
feeds.getFeed = getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, legacy_1.getElementsByTagName)("entry", childs).map(function (item) {
            var _a;
            var children = item.children;
            var entry = { media: getMediaElements$1(children) };
            addConditionally$1(entry, "id", "id", children);
            addConditionally$1(entry, "title", "title", children);
            var href = (_a = getOneElement$1("link", children)) === null || _a === void 0 ? void 0 : _a.attribs.href;
            if (href) {
                entry.link = href;
            }
            var description = fetch$1("summary", children) || fetch$1("content", children);
            if (description) {
                entry.description = description;
            }
            var pubDate = fetch$1("updated", children);
            if (pubDate) {
                entry.pubDate = new Date(pubDate);
            }
            return entry;
        }),
    };
    addConditionally$1(feed, "id", "id", childs);
    addConditionally$1(feed, "title", "title", childs);
    var href = (_a = getOneElement$1("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs.href;
    if (href) {
        feed.link = href;
    }
    addConditionally$1(feed, "description", "subtitle", childs);
    var updated = fetch$1("updated", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally$1(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = getOneElement$1("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, legacy_1.getElementsByTagName)("item", feedRoot.children).map(function (item) {
            var children = item.children;
            var entry = { media: getMediaElements$1(children) };
            addConditionally$1(entry, "id", "guid", children);
            addConditionally$1(entry, "title", "title", children);
            addConditionally$1(entry, "link", "link", children);
            addConditionally$1(entry, "description", "description", children);
            var pubDate = fetch$1("pubDate", children);
            if (pubDate)
                entry.pubDate = new Date(pubDate);
            return entry;
        }),
    };
    addConditionally$1(feed, "title", "title", childs);
    addConditionally$1(feed, "link", "link", childs);
    addConditionally$1(feed, "description", "description", childs);
    var updated = fetch$1("lastBuildDate", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally$1(feed, "author", "managingEditor", childs, true);
    return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width",
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */
function getMediaElements$1(where) {
    return (0, legacy_1.getElementsByTagName)("media:content", where).map(function (elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs.medium,
            isDefault: !!attribs.isDefault,
        };
        for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) {
                media[attrib] = attribs[attrib];
            }
        }
        for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) {
                media[attrib] = parseInt(attribs[attrib], 10);
            }
        }
        if (attribs.expression) {
            media.expression =
                attribs.expression;
        }
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */
function getOneElement$1(tagName, node) {
    return (0, legacy_1.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where  Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */
function fetch$1(tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    return (0, stringify_1$1.textContent)((0, legacy_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */
function addConditionally$1(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    var val = fetch$1(tagName, where, recurse);
    if (val)
        obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */
function isValidFeed$1(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
__exportStar(stringify$5, exports);
__exportStar(traversal, exports);
__exportStar(manipulation, exports);
__exportStar(querying, exports);
__exportStar(legacy, exports);
__exportStar(helpers, exports);
__exportStar(feeds, exports);
/** @deprecated Use these methods from `domhandler` directly. */
var domhandler_1 = lib$4;
Object.defineProperty(exports, "isTag", { enumerable: true, get: function () { return domhandler_1.isTag; } });
Object.defineProperty(exports, "isCDATA", { enumerable: true, get: function () { return domhandler_1.isCDATA; } });
Object.defineProperty(exports, "isText", { enumerable: true, get: function () { return domhandler_1.isText; } });
Object.defineProperty(exports, "isComment", { enumerable: true, get: function () { return domhandler_1.isComment; } });
Object.defineProperty(exports, "isDocument", { enumerable: true, get: function () { return domhandler_1.isDocument; } });
Object.defineProperty(exports, "hasChildren", { enumerable: true, get: function () { return domhandler_1.hasChildren; } });
}(lib$2));

var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(FeedHandler$1, "__esModule", { value: true });
FeedHandler$1.parseFeed = FeedHandler$1.FeedHandler = void 0;
var domhandler_1 = __importDefault(lib$4);
var DomUtils = __importStar(lib$2);
var Parser_1 = Parser$3;
var FeedItemMediaMedium;
(function (FeedItemMediaMedium) {
    FeedItemMediaMedium[FeedItemMediaMedium["image"] = 0] = "image";
    FeedItemMediaMedium[FeedItemMediaMedium["audio"] = 1] = "audio";
    FeedItemMediaMedium[FeedItemMediaMedium["video"] = 2] = "video";
    FeedItemMediaMedium[FeedItemMediaMedium["document"] = 3] = "document";
    FeedItemMediaMedium[FeedItemMediaMedium["executable"] = 4] = "executable";
})(FeedItemMediaMedium || (FeedItemMediaMedium = {}));
var FeedItemMediaExpression;
(function (FeedItemMediaExpression) {
    FeedItemMediaExpression[FeedItemMediaExpression["sample"] = 0] = "sample";
    FeedItemMediaExpression[FeedItemMediaExpression["full"] = 1] = "full";
    FeedItemMediaExpression[FeedItemMediaExpression["nonstop"] = 2] = "nonstop";
})(FeedItemMediaExpression || (FeedItemMediaExpression = {}));
// TODO: Consume data as it is coming in
var FeedHandler = /** @class */ (function (_super) {
    __extends(FeedHandler, _super);
    /**
     *
     * @param callback
     * @param options
     */
    function FeedHandler(callback, options) {
        var _this = this;
        if (typeof callback === "object") {
            callback = undefined;
            options = callback;
        }
        _this = _super.call(this, callback, options) || this;
        return _this;
    }
    FeedHandler.prototype.onend = function () {
        var _a, _b;
        var feedRoot = getOneElement(isValidFeed, this.dom);
        if (!feedRoot) {
            this.handleCallback(new Error("couldn't find root of feed"));
            return;
        }
        var feed = {};
        if (feedRoot.name === "feed") {
            var childs = feedRoot.children;
            feed.type = "atom";
            addConditionally(feed, "id", "id", childs);
            addConditionally(feed, "title", "title", childs);
            var href = getAttribute("href", getOneElement("link", childs));
            if (href) {
                feed.link = href;
            }
            addConditionally(feed, "description", "subtitle", childs);
            var updated = fetch("updated", childs);
            if (updated) {
                feed.updated = new Date(updated);
            }
            addConditionally(feed, "author", "email", childs, true);
            feed.items = getElements("entry", childs).map(function (item) {
                var entry = {};
                var children = item.children;
                addConditionally(entry, "id", "id", children);
                addConditionally(entry, "title", "title", children);
                var href = getAttribute("href", getOneElement("link", children));
                if (href) {
                    entry.link = href;
                }
                var description = fetch("summary", children) || fetch("content", children);
                if (description) {
                    entry.description = description;
                }
                var pubDate = fetch("updated", children);
                if (pubDate) {
                    entry.pubDate = new Date(pubDate);
                }
                entry.media = getMediaElements(children);
                return entry;
            });
        }
        else {
            var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
            feed.type = feedRoot.name.substr(0, 3);
            feed.id = "";
            addConditionally(feed, "title", "title", childs);
            addConditionally(feed, "link", "link", childs);
            addConditionally(feed, "description", "description", childs);
            var updated = fetch("lastBuildDate", childs);
            if (updated) {
                feed.updated = new Date(updated);
            }
            addConditionally(feed, "author", "managingEditor", childs, true);
            feed.items = getElements("item", feedRoot.children).map(function (item) {
                var entry = {};
                var children = item.children;
                addConditionally(entry, "id", "guid", children);
                addConditionally(entry, "title", "title", children);
                addConditionally(entry, "link", "link", children);
                addConditionally(entry, "description", "description", children);
                var pubDate = fetch("pubDate", children);
                if (pubDate)
                    entry.pubDate = new Date(pubDate);
                entry.media = getMediaElements(children);
                return entry;
            });
        }
        this.feed = feed;
        this.handleCallback(null);
    };
    return FeedHandler;
}(domhandler_1.default));
FeedHandler$1.FeedHandler = FeedHandler;
function getMediaElements(where) {
    return getElements("media:content", where).map(function (elem) {
        var media = {
            medium: elem.attribs.medium,
            isDefault: !!elem.attribs.isDefault,
        };
        if (elem.attribs.url) {
            media.url = elem.attribs.url;
        }
        if (elem.attribs.fileSize) {
            media.fileSize = parseInt(elem.attribs.fileSize, 10);
        }
        if (elem.attribs.type) {
            media.type = elem.attribs.type;
        }
        if (elem.attribs.expression) {
            media.expression = elem.attribs
                .expression;
        }
        if (elem.attribs.bitrate) {
            media.bitrate = parseInt(elem.attribs.bitrate, 10);
        }
        if (elem.attribs.framerate) {
            media.framerate = parseInt(elem.attribs.framerate, 10);
        }
        if (elem.attribs.samplingrate) {
            media.samplingrate = parseInt(elem.attribs.samplingrate, 10);
        }
        if (elem.attribs.channels) {
            media.channels = parseInt(elem.attribs.channels, 10);
        }
        if (elem.attribs.duration) {
            media.duration = parseInt(elem.attribs.duration, 10);
        }
        if (elem.attribs.height) {
            media.height = parseInt(elem.attribs.height, 10);
        }
        if (elem.attribs.width) {
            media.width = parseInt(elem.attribs.width, 10);
        }
        if (elem.attribs.lang) {
            media.lang = elem.attribs.lang;
        }
        return media;
    });
}
function getElements(tagName, where) {
    return DomUtils.getElementsByTagName(tagName, where, true);
}
function getOneElement(tagName, node) {
    return DomUtils.getElementsByTagName(tagName, node, true, 1)[0];
}
function fetch(tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    return DomUtils.getText(DomUtils.getElementsByTagName(tagName, where, recurse, 1)).trim();
}
function getAttribute(name, elem) {
    if (!elem) {
        return null;
    }
    var attribs = elem.attribs;
    return attribs[name];
}
function addConditionally(obj, prop, what, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    var tmp = fetch(what, where, recurse);
    if (tmp)
        obj[prop] = tmp;
}
function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this option, you should set `xmlMode` to `true`.
 */
function parseFeed(feed, options) {
    if (options === void 0) { options = { xmlMode: true }; }
    var handler = new FeedHandler(options);
    new Parser_1.Parser(handler, options).end(feed);
    return handler.feed;
}
FeedHandler$1.parseFeed = parseFeed;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RssHandler = exports.DefaultHandler = exports.DomUtils = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DomHandler = exports.Parser = void 0;
var Parser_1 = Parser$3;
Object.defineProperty(exports, "Parser", { enumerable: true, get: function () { return Parser_1.Parser; } });
var domhandler_1 = lib$4;
Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function () { return domhandler_1.DomHandler; } });
Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function () { return domhandler_1.DomHandler; } });
// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */
function parseDocument(data, options) {
    var handler = new domhandler_1.DomHandler(undefined, options);
    new Parser_1.Parser(handler, options).end(data);
    return handler.root;
}
exports.parseDocument = parseDocument;
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 * @deprecated Use `parseDocument` instead.
 */
function parseDOM(data, options) {
    return parseDocument(data, options).children;
}
exports.parseDOM = parseDOM;
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param cb A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
 */
function createDomStream(cb, options, elementCb) {
    var handler = new domhandler_1.DomHandler(cb, options, elementCb);
    return new Parser_1.Parser(handler, options);
}
exports.createDomStream = createDomStream;
var Tokenizer_1 = Tokenizer$1;
Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function () { return __importDefault(Tokenizer_1).default; } });
var ElementType = __importStar(lib$3);
exports.ElementType = ElementType;
/*
 * All of the following exports exist for backwards-compatibility.
 * They should probably be removed eventually.
 */
__exportStar(FeedHandler$1, exports);
exports.DomUtils = __importStar(lib$2);
var FeedHandler_1 = FeedHandler$1;
Object.defineProperty(exports, "RssHandler", { enumerable: true, get: function () { return FeedHandler_1.FeedHandler; } });
}(lib$5));

var escapeStringRegexp$1 = string => {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
};

var isPlainObject$5 = {};

Object.defineProperty(isPlainObject$5, '__esModule', { value: true });

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject$4(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject$4(o) {
  var ctor,prot;

  if (isObject$4(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject$4(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

isPlainObject$5.isPlainObject = isPlainObject$4;

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge$1(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge$1
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge$1
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge$1(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge$1.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge$1(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge$1;

var cjs = deepmerge_1;

var parseSrcset$1 = {exports: {}};

/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */

(function (module) {
(function (root, factory) {
	if (module.exports) {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.parseSrcset = factory();
	}
}(commonjsGlobal, function () {

	// 1. Let input be the value passed to this algorithm.
	return function (input) {

		// UTILITY FUNCTIONS

		// Manual is faster than RegEx
		// http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
		// http://jsperf.com/whitespace-character/5
		function isSpace(c) {
			return (c === "\u0020" || // space
			c === "\u0009" || // horizontal tab
			c === "\u000A" || // new line
			c === "\u000C" || // form feed
			c === "\u000D");  // carriage return
		}

		function collectCharacters(regEx) {
			var chars,
				match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,

			// (Don't use \s, to avoid matching non-breaking space)
			regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
			regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
			regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
			regexTrailingCommas = /[,]+$/,
			regexNonNegativeInteger = /^\d+$/,

			// ( Positive or negative or unsigned integers or decimals, without or without exponents.
			// Must include at least one digit.
			// According to spec tests any decimal point must be followed by a digit.
			// No leading plus sign is allowed.)
			// https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
			regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,

			url,
			descriptors,
			currentDescriptor,
			state,
			c,

			// 2. Let position be a pointer into input, initially pointing at the start
			//    of the string.
			pos = 0,

			// 3. Let candidates be an initially empty source set.
			candidates = [];

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

				//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

			// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)

		/**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

					// Space character
					// If current descriptor is not empty, append current descriptor to
					// descriptors and let current descriptor be the empty string.
					// Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

						// U+002C COMMA (,)
						// Advance position to the next character in input. If current descriptor
						// is not empty, append current descriptor to descriptors. Jump to the step
						// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

						// U+0028 LEFT PARENTHESIS (()
						// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

						// EOF
						// If current descriptor is not empty, append current descriptor to
						// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

						// Anything else
						// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
					// (end "in descriptor"

					// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

						// EOF
						// Append current descriptor to descriptors. Jump to the step labeled
						// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

						// Anything else
						// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

					// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) ; else if (c === "") {
						parseDescriptors();
						return;

						// Anything else
						// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

				// Repeat this step.
			} // (close while true loop)
		}

		/**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */
		// Declared outside of the while loop so that it's only created once.
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

				// 10. Let width be absent.
				// 11. Let density be absent.
				// 12. Let future-compat-h be absent. (We're implementing it now as h)
				w, d, h, i,
				candidate = {},
				desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

					// If the descriptor consists of a valid floating-point number followed by
					// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

					// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;
				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				candidates.push(candidate);
			} else if (console && console.log) {
				console.log("Invalid srcset descriptor found in '" +
					input + "' at '" + desc + "'.");
			}
		} // (close parseDescriptors fn)

	}
}));
}(parseSrcset$1));

var picocolors = {exports: {}};

let tty = require$$0$6;

let isColorSupported =
	!("NO_COLOR" in process.env || process.argv.includes("--no-color")) &&
	("FORCE_COLOR" in process.env ||
		process.argv.includes("--color") ||
		process.platform === "win32" ||
		(tty.isatty(1) && process.env.TERM !== "dumb") ||
		"CI" in process.env);

let formatter$1 =
	(open, close, replace = open) =>
	input => {
		let string = "" + input;
		let index = string.indexOf(close, open.length);
		return ~index
			? open + replaceClose(string, close, replace, index) + close
			: open + string + close
	};

let replaceClose = (string, close, replace, index) => {
	let start = string.substring(0, index) + replace;
	let end = string.substring(index + close.length);
	let nextIndex = end.indexOf(close);
	return ~nextIndex ? start + replaceClose(end, close, replace, nextIndex) : start + end
};

let createColors = (enabled = isColorSupported) => ({
	isColorSupported: enabled,
	reset: enabled ? s => `\x1b[0m${s}\x1b[0m` : String,
	bold: enabled ? formatter$1("\x1b[1m", "\x1b[22m", "\x1b[22m\x1b[1m") : String,
	dim: enabled ? formatter$1("\x1b[2m", "\x1b[22m", "\x1b[22m\x1b[2m") : String,
	italic: enabled ? formatter$1("\x1b[3m", "\x1b[23m") : String,
	underline: enabled ? formatter$1("\x1b[4m", "\x1b[24m") : String,
	inverse: enabled ? formatter$1("\x1b[7m", "\x1b[27m") : String,
	hidden: enabled ? formatter$1("\x1b[8m", "\x1b[28m") : String,
	strikethrough: enabled ? formatter$1("\x1b[9m", "\x1b[29m") : String,
	black: enabled ? formatter$1("\x1b[30m", "\x1b[39m") : String,
	red: enabled ? formatter$1("\x1b[31m", "\x1b[39m") : String,
	green: enabled ? formatter$1("\x1b[32m", "\x1b[39m") : String,
	yellow: enabled ? formatter$1("\x1b[33m", "\x1b[39m") : String,
	blue: enabled ? formatter$1("\x1b[34m", "\x1b[39m") : String,
	magenta: enabled ? formatter$1("\x1b[35m", "\x1b[39m") : String,
	cyan: enabled ? formatter$1("\x1b[36m", "\x1b[39m") : String,
	white: enabled ? formatter$1("\x1b[37m", "\x1b[39m") : String,
	gray: enabled ? formatter$1("\x1b[90m", "\x1b[39m") : String,
	bgBlack: enabled ? formatter$1("\x1b[40m", "\x1b[49m") : String,
	bgRed: enabled ? formatter$1("\x1b[41m", "\x1b[49m") : String,
	bgGreen: enabled ? formatter$1("\x1b[42m", "\x1b[49m") : String,
	bgYellow: enabled ? formatter$1("\x1b[43m", "\x1b[49m") : String,
	bgBlue: enabled ? formatter$1("\x1b[44m", "\x1b[49m") : String,
	bgMagenta: enabled ? formatter$1("\x1b[45m", "\x1b[49m") : String,
	bgCyan: enabled ? formatter$1("\x1b[46m", "\x1b[49m") : String,
	bgWhite: enabled ? formatter$1("\x1b[47m", "\x1b[49m") : String,
});

picocolors.exports = createColors();
picocolors.exports.createColors = createColors;

const SINGLE_QUOTE = "'".charCodeAt(0);
const DOUBLE_QUOTE = '"'.charCodeAt(0);
const BACKSLASH = '\\'.charCodeAt(0);
const SLASH = '/'.charCodeAt(0);
const NEWLINE = '\n'.charCodeAt(0);
const SPACE = ' '.charCodeAt(0);
const FEED = '\f'.charCodeAt(0);
const TAB = '\t'.charCodeAt(0);
const CR = '\r'.charCodeAt(0);
const OPEN_SQUARE = '['.charCodeAt(0);
const CLOSE_SQUARE = ']'.charCodeAt(0);
const OPEN_PARENTHESES = '('.charCodeAt(0);
const CLOSE_PARENTHESES = ')'.charCodeAt(0);
const OPEN_CURLY = '{'.charCodeAt(0);
const CLOSE_CURLY = '}'.charCodeAt(0);
const SEMICOLON = ';'.charCodeAt(0);
const ASTERISK = '*'.charCodeAt(0);
const COLON = ':'.charCodeAt(0);
const AT = '@'.charCodeAt(0);

const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const RE_BAD_BRACKET = /.[\n"'(/\\]/;
const RE_HEX_ESCAPE = /[\da-f]/i;

var tokenize = function tokenizer(input, options = {}) {
  let css = input.css.valueOf();
  let ignore = options.ignoreErrors;

  let code, next, quote, content, escape;
  let escaped, escapePos, prev, n, currentToken;

  let length = css.length;
  let pos = 0;
  let buffer = [];
  let returned = [];

  function position() {
    return pos
  }

  function unclosed(what) {
    throw input.error('Unclosed ' + what, pos)
  }

  function endOfFile() {
    return returned.length === 0 && pos >= length
  }

  function nextToken(opts) {
    if (returned.length) return returned.pop()
    if (pos >= length) return

    let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;

    code = css.charCodeAt(pos);

    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED: {
        next = pos;
        do {
          next += 1;
          code = css.charCodeAt(next);
        } while (
          code === SPACE ||
          code === NEWLINE ||
          code === TAB ||
          code === CR ||
          code === FEED
        )

        currentToken = ['space', css.slice(pos, next)];
        pos = next - 1;
        break
      }

      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES: {
        let controlChar = String.fromCharCode(code);
        currentToken = [controlChar, controlChar, pos];
        break
      }

      case OPEN_PARENTHESES: {
        prev = buffer.length ? buffer.pop()[1] : '';
        n = css.charCodeAt(pos + 1);
        if (
          prev === 'url' &&
          n !== SINGLE_QUOTE &&
          n !== DOUBLE_QUOTE &&
          n !== SPACE &&
          n !== NEWLINE &&
          n !== TAB &&
          n !== FEED &&
          n !== CR
        ) {
          next = pos;
          do {
            escaped = false;
            next = css.indexOf(')', next + 1);
            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos;
                break
              } else {
                unclosed('bracket');
              }
            }
            escapePos = next;
            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped)

          currentToken = ['brackets', css.slice(pos, next + 1), pos, next];

          pos = next;
        } else {
          next = css.indexOf(')', pos + 1);
          content = css.slice(pos, next + 1);

          if (next === -1 || RE_BAD_BRACKET.test(content)) {
            currentToken = ['(', '(', pos];
          } else {
            currentToken = ['brackets', content, pos, next];
            pos = next;
          }
        }

        break
      }

      case SINGLE_QUOTE:
      case DOUBLE_QUOTE: {
        quote = code === SINGLE_QUOTE ? "'" : '"';
        next = pos;
        do {
          escaped = false;
          next = css.indexOf(quote, next + 1);
          if (next === -1) {
            if (ignore || ignoreUnclosed) {
              next = pos + 1;
              break
            } else {
              unclosed('string');
            }
          }
          escapePos = next;
          while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
            escapePos -= 1;
            escaped = !escaped;
          }
        } while (escaped)

        currentToken = ['string', css.slice(pos, next + 1), pos, next];
        pos = next;
        break
      }

      case AT: {
        RE_AT_END.lastIndex = pos + 1;
        RE_AT_END.test(css);
        if (RE_AT_END.lastIndex === 0) {
          next = css.length - 1;
        } else {
          next = RE_AT_END.lastIndex - 2;
        }

        currentToken = ['at-word', css.slice(pos, next + 1), pos, next];

        pos = next;
        break
      }

      case BACKSLASH: {
        next = pos;
        escape = true;
        while (css.charCodeAt(next + 1) === BACKSLASH) {
          next += 1;
          escape = !escape;
        }
        code = css.charCodeAt(next + 1);
        if (
          escape &&
          code !== SLASH &&
          code !== SPACE &&
          code !== NEWLINE &&
          code !== TAB &&
          code !== CR &&
          code !== FEED
        ) {
          next += 1;
          if (RE_HEX_ESCAPE.test(css.charAt(next))) {
            while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
              next += 1;
            }
            if (css.charCodeAt(next + 1) === SPACE) {
              next += 1;
            }
          }
        }

        currentToken = ['word', css.slice(pos, next + 1), pos, next];

        pos = next;
        break
      }

      default: {
        if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
          next = css.indexOf('*/', pos + 2) + 1;
          if (next === 0) {
            if (ignore || ignoreUnclosed) {
              next = css.length;
            } else {
              unclosed('comment');
            }
          }

          currentToken = ['comment', css.slice(pos, next + 1), pos, next];
          pos = next;
        } else {
          RE_WORD_END.lastIndex = pos + 1;
          RE_WORD_END.test(css);
          if (RE_WORD_END.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_WORD_END.lastIndex - 2;
          }

          currentToken = ['word', css.slice(pos, next + 1), pos, next];
          buffer.push(currentToken);
          pos = next;
        }

        break
      }
    }

    pos++;
    return currentToken
  }

  function back(token) {
    returned.push(token);
  }

  return {
    back,
    nextToken,
    endOfFile,
    position
  }
};

let pico$1 = picocolors.exports;

let tokenizer$1 = tokenize;

let Input$5;

function registerInput(dependant) {
  Input$5 = dependant;
}

const HIGHLIGHT_THEME = {
  'brackets': pico$1.cyan,
  'at-word': pico$1.cyan,
  'comment': pico$1.gray,
  'string': pico$1.green,
  'class': pico$1.yellow,
  'hash': pico$1.magenta,
  'call': pico$1.cyan,
  '(': pico$1.cyan,
  ')': pico$1.cyan,
  '{': pico$1.yellow,
  '}': pico$1.yellow,
  '[': pico$1.yellow,
  ']': pico$1.yellow,
  ':': pico$1.yellow,
  ';': pico$1.yellow
};

function getTokenType([type, value], processor) {
  if (type === 'word') {
    if (value[0] === '.') {
      return 'class'
    }
    if (value[0] === '#') {
      return 'hash'
    }
  }

  if (!processor.endOfFile()) {
    let next = processor.nextToken();
    processor.back(next);
    if (next[0] === 'brackets' || next[0] === '(') return 'call'
  }

  return type
}

function terminalHighlight$2(css) {
  let processor = tokenizer$1(new Input$5(css), { ignoreErrors: true });
  let result = '';
  while (!processor.endOfFile()) {
    let token = processor.nextToken();
    let color = HIGHLIGHT_THEME[getTokenType(token, processor)];
    if (color) {
      result += token[1]
        .split(/\r?\n/)
        .map(i => color(i))
        .join('\n');
    } else {
      result += token[1];
    }
  }
  return result
}

terminalHighlight$2.registerInput = registerInput;

var terminalHighlight_1 = terminalHighlight$2;

let pico = picocolors.exports;

let terminalHighlight$1 = terminalHighlight_1;

class CssSyntaxError$3 extends Error {
  constructor(message, line, column, source, file, plugin) {
    super(message);
    this.name = 'CssSyntaxError';
    this.reason = message;

    if (file) {
      this.file = file;
    }
    if (source) {
      this.source = source;
    }
    if (plugin) {
      this.plugin = plugin;
    }
    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
      if (typeof line === 'number') {
        this.line = line;
        this.column = column;
      } else {
        this.line = line.line;
        this.column = line.column;
        this.endLine = column.line;
        this.endColumn = column.column;
      }
    }

    this.setMessage();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CssSyntaxError$3);
    }
  }

  setMessage() {
    this.message = this.plugin ? this.plugin + ': ' : '';
    this.message += this.file ? this.file : '<css input>';
    if (typeof this.line !== 'undefined') {
      this.message += ':' + this.line + ':' + this.column;
    }
    this.message += ': ' + this.reason;
  }

  showSourceCode(color) {
    if (!this.source) return ''

    let css = this.source;
    if (color == null) color = pico.isColorSupported;
    if (terminalHighlight$1) {
      if (color) css = terminalHighlight$1(css);
    }

    let lines = css.split(/\r?\n/);
    let start = Math.max(this.line - 3, 0);
    let end = Math.min(this.line + 2, lines.length);

    let maxWidth = String(end).length;

    let mark, aside;
    if (color) {
      let { bold, red, gray } = pico.createColors(true);
      mark = text => bold(red(text));
      aside = text => gray(text);
    } else {
      mark = aside = str => str;
    }

    return lines
      .slice(start, end)
      .map((line, index) => {
        let number = start + 1 + index;
        let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
        if (number === this.line) {
          let spacing =
            aside(gutter.replace(/\d/g, ' ')) +
            line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');
          return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^')
        }
        return ' ' + aside(gutter) + line
      })
      .join('\n')
  }

  toString() {
    let code = this.showSourceCode();
    if (code) {
      code = '\n\n' + code + '\n';
    }
    return this.name + ': ' + this.message + code
  }
}

var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;

var symbols = {};

symbols.isClean = Symbol('isClean');

symbols.my = Symbol('my');

const DEFAULT_RAW = {
  colon: ': ',
  indent: '    ',
  beforeDecl: '\n',
  beforeRule: '\n',
  beforeOpen: ' ',
  beforeClose: '\n',
  beforeComment: '\n',
  after: '\n',
  emptyBody: '',
  commentLeft: ' ',
  commentRight: ' ',
  semicolon: false
};

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1)
}

class Stringifier$2 {
  constructor(builder) {
    this.builder = builder;
  }

  stringify(node, semicolon) {
    /* c8 ignore start */
    if (!this[node.type]) {
      throw new Error(
        'Unknown AST node type ' +
          node.type +
          '. ' +
          'Maybe you need to change PostCSS stringifier.'
      )
    }
    /* c8 ignore stop */
    this[node.type](node, semicolon);
  }

  document(node) {
    this.body(node);
  }

  root(node) {
    this.body(node);
    if (node.raws.after) this.builder(node.raws.after);
  }

  comment(node) {
    let left = this.raw(node, 'left', 'commentLeft');
    let right = this.raw(node, 'right', 'commentRight');
    this.builder('/*' + left + node.text + right + '*/', node);
  }

  decl(node, semicolon) {
    let between = this.raw(node, 'between', 'colon');
    let string = node.prop + between + this.rawValue(node, 'value');

    if (node.important) {
      string += node.raws.important || ' !important';
    }

    if (semicolon) string += ';';
    this.builder(string, node);
  }

  rule(node) {
    this.block(node, this.rawValue(node, 'selector'));
    if (node.raws.ownSemicolon) {
      this.builder(node.raws.ownSemicolon, node, 'end');
    }
  }

  atrule(node, semicolon) {
    let name = '@' + node.name;
    let params = node.params ? this.rawValue(node, 'params') : '';

    if (typeof node.raws.afterName !== 'undefined') {
      name += node.raws.afterName;
    } else if (params) {
      name += ' ';
    }

    if (node.nodes) {
      this.block(node, name + params);
    } else {
      let end = (node.raws.between || '') + (semicolon ? ';' : '');
      this.builder(name + params + end, node);
    }
  }

  body(node) {
    let last = node.nodes.length - 1;
    while (last > 0) {
      if (node.nodes[last].type !== 'comment') break
      last -= 1;
    }

    let semicolon = this.raw(node, 'semicolon');
    for (let i = 0; i < node.nodes.length; i++) {
      let child = node.nodes[i];
      let before = this.raw(child, 'before');
      if (before) this.builder(before);
      this.stringify(child, last !== i || semicolon);
    }
  }

  block(node, start) {
    let between = this.raw(node, 'between', 'beforeOpen');
    this.builder(start + between + '{', node, 'start');

    let after;
    if (node.nodes && node.nodes.length) {
      this.body(node);
      after = this.raw(node, 'after');
    } else {
      after = this.raw(node, 'after', 'emptyBody');
    }

    if (after) this.builder(after);
    this.builder('}', node, 'end');
  }

  raw(node, own, detect) {
    let value;
    if (!detect) detect = own;

    // Already had
    if (own) {
      value = node.raws[own];
      if (typeof value !== 'undefined') return value
    }

    let parent = node.parent;

    if (detect === 'before') {
      // Hack for first rule in CSS
      if (!parent || (parent.type === 'root' && parent.first === node)) {
        return ''
      }

      // `root` nodes in `document` should use only their own raws
      if (parent && parent.type === 'document') {
        return ''
      }
    }

    // Floating child without parent
    if (!parent) return DEFAULT_RAW[detect]

    // Detect style by other nodes
    let root = node.root();
    if (!root.rawCache) root.rawCache = {};
    if (typeof root.rawCache[detect] !== 'undefined') {
      return root.rawCache[detect]
    }

    if (detect === 'before' || detect === 'after') {
      return this.beforeAfter(node, detect)
    } else {
      let method = 'raw' + capitalize(detect);
      if (this[method]) {
        value = this[method](root, node);
      } else {
        root.walk(i => {
          value = i.raws[own];
          if (typeof value !== 'undefined') return false
        });
      }
    }

    if (typeof value === 'undefined') value = DEFAULT_RAW[detect];

    root.rawCache[detect] = value;
    return value
  }

  rawSemicolon(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length && i.last.type === 'decl') {
        value = i.raws.semicolon;
        if (typeof value !== 'undefined') return false
      }
    });
    return value
  }

  rawEmptyBody(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length === 0) {
        value = i.raws.after;
        if (typeof value !== 'undefined') return false
      }
    });
    return value
  }

  rawIndent(root) {
    if (root.raws.indent) return root.raws.indent
    let value;
    root.walk(i => {
      let p = i.parent;
      if (p && p !== root && p.parent && p.parent === root) {
        if (typeof i.raws.before !== 'undefined') {
          let parts = i.raws.before.split('\n');
          value = parts[parts.length - 1];
          value = value.replace(/\S/g, '');
          return false
        }
      }
    });
    return value
  }

  rawBeforeComment(root, node) {
    let value;
    root.walkComments(i => {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;
        if (value.includes('\n')) {
          value = value.replace(/[^\n]+$/, '');
        }
        return false
      }
    });
    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (value) {
      value = value.replace(/\S/g, '');
    }
    return value
  }

  rawBeforeDecl(root, node) {
    let value;
    root.walkDecls(i => {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;
        if (value.includes('\n')) {
          value = value.replace(/[^\n]+$/, '');
        }
        return false
      }
    });
    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeRule');
    } else if (value) {
      value = value.replace(/\S/g, '');
    }
    return value
  }

  rawBeforeRule(root) {
    let value;
    root.walk(i => {
      if (i.nodes && (i.parent !== root || root.first !== i)) {
        if (typeof i.raws.before !== 'undefined') {
          value = i.raws.before;
          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }
          return false
        }
      }
    });
    if (value) value = value.replace(/\S/g, '');
    return value
  }

  rawBeforeClose(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length > 0) {
        if (typeof i.raws.after !== 'undefined') {
          value = i.raws.after;
          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }
          return false
        }
      }
    });
    if (value) value = value.replace(/\S/g, '');
    return value
  }

  rawBeforeOpen(root) {
    let value;
    root.walk(i => {
      if (i.type !== 'decl') {
        value = i.raws.between;
        if (typeof value !== 'undefined') return false
      }
    });
    return value
  }

  rawColon(root) {
    let value;
    root.walkDecls(i => {
      if (typeof i.raws.between !== 'undefined') {
        value = i.raws.between.replace(/[^\s:]/g, '');
        return false
      }
    });
    return value
  }

  beforeAfter(node, detect) {
    let value;
    if (node.type === 'decl') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (node.type === 'comment') {
      value = this.raw(node, null, 'beforeComment');
    } else if (detect === 'before') {
      value = this.raw(node, null, 'beforeRule');
    } else {
      value = this.raw(node, null, 'beforeClose');
    }

    let buf = node.parent;
    let depth = 0;
    while (buf && buf.type !== 'root') {
      depth += 1;
      buf = buf.parent;
    }

    if (value.includes('\n')) {
      let indent = this.raw(node, null, 'indent');
      if (indent.length) {
        for (let step = 0; step < depth; step++) value += indent;
      }
    }

    return value
  }

  rawValue(node, prop) {
    let value = node[prop];
    let raw = node.raws[prop];
    if (raw && raw.value === value) {
      return raw.raw
    }

    return value
  }
}

var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;

let Stringifier$1 = stringifier;

function stringify$4(node, builder) {
  let str = new Stringifier$1(builder);
  str.stringify(node);
}

var stringify_1 = stringify$4;
stringify$4.default = stringify$4;

let { isClean: isClean$2, my: my$2 } = symbols;
let CssSyntaxError$2 = cssSyntaxError;
let Stringifier = stringifier;
let stringify$3 = stringify_1;

function cloneNode(obj, parent) {
  let cloned = new obj.constructor();

  for (let i in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      /* c8 ignore next 2 */
      continue
    }
    if (i === 'proxyCache') continue
    let value = obj[i];
    let type = typeof value;

    if (i === 'parent' && type === 'object') {
      if (parent) cloned[i] = parent;
    } else if (i === 'source') {
      cloned[i] = value;
    } else if (Array.isArray(value)) {
      cloned[i] = value.map(j => cloneNode(j, cloned));
    } else {
      if (type === 'object' && value !== null) value = cloneNode(value);
      cloned[i] = value;
    }
  }

  return cloned
}

class Node$5 {
  constructor(defaults = {}) {
    this.raws = {};
    this[isClean$2] = false;
    this[my$2] = true;

    for (let name in defaults) {
      if (name === 'nodes') {
        this.nodes = [];
        for (let node of defaults[name]) {
          if (typeof node.clone === 'function') {
            this.append(node.clone());
          } else {
            this.append(node);
          }
        }
      } else {
        this[name] = defaults[name];
      }
    }
  }

  error(message, opts = {}) {
    if (this.source) {
      let { start, end } = this.rangeBy(opts);
      return this.source.input.error(
        message,
        { line: start.line, column: start.column },
        { line: end.line, column: end.column },
        opts
      )
    }
    return new CssSyntaxError$2(message)
  }

  warn(result, text, opts) {
    let data = { node: this };
    for (let i in opts) data[i] = opts[i];
    return result.warn(text, data)
  }

  remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }
    this.parent = undefined;
    return this
  }

  toString(stringifier = stringify$3) {
    if (stringifier.stringify) stringifier = stringifier.stringify;
    let result = '';
    stringifier(this, i => {
      result += i;
    });
    return result
  }

  assign(overrides = {}) {
    for (let name in overrides) {
      this[name] = overrides[name];
    }
    return this
  }

  clone(overrides = {}) {
    let cloned = cloneNode(this);
    for (let name in overrides) {
      cloned[name] = overrides[name];
    }
    return cloned
  }

  cloneBefore(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned
  }

  cloneAfter(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned
  }

  replaceWith(...nodes) {
    if (this.parent) {
      let bookmark = this;
      let foundSelf = false;
      for (let node of nodes) {
        if (node === this) {
          foundSelf = true;
        } else if (foundSelf) {
          this.parent.insertAfter(bookmark, node);
          bookmark = node;
        } else {
          this.parent.insertBefore(bookmark, node);
        }
      }

      if (!foundSelf) {
        this.remove();
      }
    }

    return this
  }

  next() {
    if (!this.parent) return undefined
    let index = this.parent.index(this);
    return this.parent.nodes[index + 1]
  }

  prev() {
    if (!this.parent) return undefined
    let index = this.parent.index(this);
    return this.parent.nodes[index - 1]
  }

  before(add) {
    this.parent.insertBefore(this, add);
    return this
  }

  after(add) {
    this.parent.insertAfter(this, add);
    return this
  }

  root() {
    let result = this;
    while (result.parent && result.parent.type !== 'document') {
      result = result.parent;
    }
    return result
  }

  raw(prop, defaultType) {
    let str = new Stringifier();
    return str.raw(this, prop, defaultType)
  }

  cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween) delete this.raws.between;
  }

  toJSON(_, inputs) {
    let fixed = {};
    let emitInputs = inputs == null;
    inputs = inputs || new Map();
    let inputsNextIndex = 0;

    for (let name in this) {
      if (!Object.prototype.hasOwnProperty.call(this, name)) {
        /* c8 ignore next 2 */
        continue
      }
      if (name === 'parent' || name === 'proxyCache') continue
      let value = this[name];

      if (Array.isArray(value)) {
        fixed[name] = value.map(i => {
          if (typeof i === 'object' && i.toJSON) {
            return i.toJSON(null, inputs)
          } else {
            return i
          }
        });
      } else if (typeof value === 'object' && value.toJSON) {
        fixed[name] = value.toJSON(null, inputs);
      } else if (name === 'source') {
        let inputId = inputs.get(value.input);
        if (inputId == null) {
          inputId = inputsNextIndex;
          inputs.set(value.input, inputsNextIndex);
          inputsNextIndex++;
        }
        fixed[name] = {
          inputId,
          start: value.start,
          end: value.end
        };
      } else {
        fixed[name] = value;
      }
    }

    if (emitInputs) {
      fixed.inputs = [...inputs.keys()].map(input => input.toJSON());
    }

    return fixed
  }

  positionInside(index) {
    let string = this.toString();
    let column = this.source.start.column;
    let line = this.source.start.line;

    for (let i = 0; i < index; i++) {
      if (string[i] === '\n') {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }

    return { line, column }
  }

  positionBy(opts) {
    let pos = this.source.start;
    if (opts.index) {
      pos = this.positionInside(opts.index);
    } else if (opts.word) {
      let index = this.toString().indexOf(opts.word);
      if (index !== -1) pos = this.positionInside(index);
    }
    return pos
  }

  rangeBy(opts) {
    let start = {
      line: this.source.start.line,
      column: this.source.start.column
    };
    let end = this.source.end
      ? {
          line: this.source.end.line,
          column: this.source.end.column + 1
        }
      : {
          line: start.line,
          column: start.column + 1
        };

    if (opts.word) {
      let index = this.toString().indexOf(opts.word);
      if (index !== -1) {
        start = this.positionInside(index);
        end = this.positionInside(index + opts.word.length);
      }
    } else {
      if (opts.start) {
        start = {
          line: opts.start.line,
          column: opts.start.column
        };
      } else if (opts.index) {
        start = this.positionInside(opts.index);
      }

      if (opts.end) {
        end = {
          line: opts.end.line,
          column: opts.end.column
        };
      } else if (opts.endIndex) {
        end = this.positionInside(opts.endIndex);
      } else if (opts.index) {
        end = this.positionInside(opts.index + 1);
      }
    }

    if (
      end.line < start.line ||
      (end.line === start.line && end.column <= start.column)
    ) {
      end = { line: start.line, column: start.column + 1 };
    }

    return { start, end }
  }

  getProxyProcessor() {
    return {
      set(node, prop, value) {
        if (node[prop] === value) return true
        node[prop] = value;
        if (
          prop === 'prop' ||
          prop === 'value' ||
          prop === 'name' ||
          prop === 'params' ||
          prop === 'important' ||
          /* c8 ignore next */
          prop === 'text'
        ) {
          node.markDirty();
        }
        return true
      },

      get(node, prop) {
        if (prop === 'proxyOf') {
          return node
        } else if (prop === 'root') {
          return () => node.root().toProxy()
        } else {
          return node[prop]
        }
      }
    }
  }

  toProxy() {
    if (!this.proxyCache) {
      this.proxyCache = new Proxy(this, this.getProxyProcessor());
    }
    return this.proxyCache
  }

  addToError(error) {
    error.postcssNode = this;
    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
      let s = this.source;
      error.stack = error.stack.replace(
        /\n\s{4}at /,
        `$&${s.input.from}:${s.start.line}:${s.start.column}$&`
      );
    }
    return error
  }

  markDirty() {
    if (this[isClean$2]) {
      this[isClean$2] = false;
      let next = this;
      while ((next = next.parent)) {
        next[isClean$2] = false;
      }
    }
  }

  get proxyOf() {
    return this
  }
}

var node_1 = Node$5;
Node$5.default = Node$5;

let Node$4 = node_1;

class Declaration$4 extends Node$4 {
  constructor(defaults) {
    if (
      defaults &&
      typeof defaults.value !== 'undefined' &&
      typeof defaults.value !== 'string'
    ) {
      defaults = { ...defaults, value: String(defaults.value) };
    }
    super(defaults);
    this.type = 'decl';
  }

  get variable() {
    return this.prop.startsWith('--') || this.prop[0] === '$'
  }
}

var declaration = Declaration$4;
Declaration$4.default = Declaration$4;

var sourceMap = {};

var sourceMapGenerator = {};

var base64Vlq = {};

var base64$1 = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
base64$1.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};

/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
base64$1.decode = function (charCode) {
  var bigA = 65;     // 'A'
  var bigZ = 90;     // 'Z'

  var littleA = 97;  // 'a'
  var littleZ = 122; // 'z'

  var zero = 48;     // '0'
  var nine = 57;     // '9'

  var plus = 43;     // '+'
  var slash = 47;    // '/'

  var littleOffset = 26;
  var numberOffset = 52;

  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
  if (bigA <= charCode && charCode <= bigZ) {
    return (charCode - bigA);
  }

  // 26 - 51: abcdefghijklmnopqrstuvwxyz
  if (littleA <= charCode && charCode <= littleZ) {
    return (charCode - littleA + littleOffset);
  }

  // 52 - 61: 0123456789
  if (zero <= charCode && charCode <= nine) {
    return (charCode - zero + numberOffset);
  }

  // 62: +
  if (charCode == plus) {
    return 62;
  }

  // 63: /
  if (charCode == slash) {
    return 63;
  }

  // Invalid base64 digit.
  return -1;
};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

var base64 = base64$1;

// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5;

// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;

// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;

/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(aValue) {
  return aValue < 0
    ? ((-aValue) << 1) + 1
    : (aValue << 1) + 0;
}

/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative
    ? -shifted
    : shifted;
}

/**
 * Returns the base 64 VLQ encoded value.
 */
base64Vlq.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;

  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);

  return encoded;
};

/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
base64Vlq.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};

var util$8 = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

(function (exports) {
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
exports.getArg = getArg;

var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;

function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
exports.urlParse = urlParse;

function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port;
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
exports.urlGenerate = urlGenerate;

var MAX_CACHED_INPUTS = 32;

/**
 * Takes some function `f(input) -> result` and returns a memoized version of
 * `f`.
 *
 * We keep at most `MAX_CACHED_INPUTS` memoized results of `f` alive. The
 * memoization is a dumb-simple, linear least-recently-used cache.
 */
function lruMemoize(f) {
  var cache = [];

  return function(input) {
    for (var i = 0; i < cache.length; i++) {
      if (cache[i].input === input) {
        var temp = cache[0];
        cache[0] = cache[i];
        cache[i] = temp;
        return cache[0].result;
      }
    }

    var result = f(input);

    cache.unshift({
      input,
      result,
    });

    if (cache.length > MAX_CACHED_INPUTS) {
      cache.pop();
    }

    return result;
  };
}

/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
var normalize = lruMemoize(function normalize(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = exports.isAbsolute(path);
  // Split the path into parts between `/` characters. This is much faster than
  // using `.split(/\/+/g)`.
  var parts = [];
  var start = 0;
  var i = 0;
  while (true) {
    start = i;
    i = path.indexOf("/", start);
    if (i === -1) {
      parts.push(path.slice(start));
      break;
    } else {
      parts.push(path.slice(start, i));
      while (i < path.length && path[i] === "/") {
        i++;
      }
    }
  }

  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        // The first part is blank if the path is absolute. Trying to go
        // above the root is a no-op. Therefore we can remove all '..' parts
        // directly after the root.
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');

  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }

  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
});
exports.normalize = normalize;

/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }

  // `join(foo, '//www.example.org')`
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }

  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }

  // `join('http://', 'www.example.com')`
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }

  var joined = aPath.charAt(0) === '/'
    ? aPath
    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
exports.join = join;

exports.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || urlRegexp.test(aPath);
};

/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }

  aRoot = aRoot.replace(/\/$/, '');

  // It is possible for the path to be above the root. In this case, simply
  // checking whether the root is a prefix of the path won't work. Instead, we
  // need to remove components from the root one by one, until either we find
  // a prefix that fits, or we run out of components to remove.
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }

    // If the only part of the root that is left is the scheme (i.e. http://,
    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
    // have exhausted all components, so the path is not relative to the root.
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }

    ++level;
  }

  // Make sure we add a "../" for each component we removed from the root.
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;

var supportsNullProto = (function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}());

function identity (s) {
  return s;
}

/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }

  return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;

function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }

  return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;

function isProtoString(s) {
  if (!s) {
    return false;
  }

  var length = s.length;

  if (length < 9 /* "__proto__".length */) {
    return false;
  }

  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
      s.charCodeAt(length - 9) !== 95  /* '_' */) {
    return false;
  }

  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36 /* '$' */) {
      return false;
    }
  }

  return true;
}

/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByOriginalPositions = compareByOriginalPositions;

function compareByOriginalPositionsNoSource(mappingA, mappingB, onlyCompareOriginal) {
  var cmp;

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByOriginalPositionsNoSource = compareByOriginalPositionsNoSource;

/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

function compareByGeneratedPositionsDeflatedNoLine(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsDeflatedNoLine = compareByGeneratedPositionsDeflatedNoLine;

function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }

  if (aStr1 === null) {
    return 1; // aStr2 !== null
  }

  if (aStr2 === null) {
    return -1; // aStr1 !== null
  }

  if (aStr1 > aStr2) {
    return 1;
  }

  return -1;
}

/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;

/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */
function parseSourceMapInput(str) {
  return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
exports.parseSourceMapInput = parseSourceMapInput;

/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */
function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
  sourceURL = sourceURL || '';

  if (sourceRoot) {
    // This follows what Chrome does.
    if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') {
      sourceRoot += '/';
    }
    // The spec says:
    //   Line 4: An optional source root, useful for relocating source
    //   files on a server or removing repeated values in the
    //   “sources” entry.  This value is prepended to the individual
    //   entries in the “source” field.
    sourceURL = sourceRoot + sourceURL;
  }

  // Historically, SourceMapConsumer did not take the sourceMapURL as
  // a parameter.  This mode is still somewhat supported, which is why
  // this code block is conditional.  However, it's preferable to pass
  // the source map URL to SourceMapConsumer, so that this function
  // can implement the source URL resolution algorithm as outlined in
  // the spec.  This block is basically the equivalent of:
  //    new URL(sourceURL, sourceMapURL).toString()
  // ... except it avoids using URL, which wasn't available in the
  // older releases of node still supported by this library.
  //
  // The spec says:
  //   If the sources are not absolute URLs after prepending of the
  //   “sourceRoot”, the sources are resolved relative to the
  //   SourceMap (like resolving script src in a html document).
  if (sourceMapURL) {
    var parsed = urlParse(sourceMapURL);
    if (!parsed) {
      throw new Error("sourceMapURL could not be parsed");
    }
    if (parsed.path) {
      // Strip the last path component, but keep the "/".
      var index = parsed.path.lastIndexOf('/');
      if (index >= 0) {
        parsed.path = parsed.path.substring(0, index + 1);
      }
    }
    sourceURL = join(urlGenerate(parsed), sourceURL);
  }

  return normalize(sourceURL);
}
exports.computeSourceURL = computeSourceURL;
}(util$8));

var arraySet = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util$7 = util$8;
var has$1 = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";

/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet$2() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}

/**
 * Static method for creating ArraySet instances from an existing array.
 */
ArraySet$2.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet$2();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};

/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet$2.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};

/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet$2.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : util$7.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has$1.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};

/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet$2.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = util$7.toSetString(aStr);
    return has$1.call(this._set, sStr);
  }
};

/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet$2.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);
    if (idx >= 0) {
        return idx;
    }
  } else {
    var sStr = util$7.toSetString(aStr);
    if (has$1.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }

  throw new Error('"' + aStr + '" is not in the set.');
};

/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet$2.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};

/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet$2.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

arraySet.ArraySet = ArraySet$2;

var mappingList = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util$6 = util$8;

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */
function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA ||
         util$6.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}

/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */
function MappingList$1() {
  this._array = [];
  this._sorted = true;
  // Serves as infimum
  this._last = {generatedLine: -1, generatedColumn: 0};
}

/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */
MappingList$1.prototype.unsortedForEach =
  function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
  };

/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */
MappingList$1.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};

/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */
MappingList$1.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util$6.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};

mappingList.MappingList = MappingList$1;

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var base64VLQ$1 = base64Vlq;
var util$5 = util$8;
var ArraySet$1 = arraySet.ArraySet;
var MappingList = mappingList.MappingList;

/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */
function SourceMapGenerator$4(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util$5.getArg(aArgs, 'file', null);
  this._sourceRoot = util$5.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util$5.getArg(aArgs, 'skipValidation', false);
  this._sources = new ArraySet$1();
  this._names = new ArraySet$1();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}

SourceMapGenerator$4.prototype._version = 3;

/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */
SourceMapGenerator$4.fromSourceMap =
  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator$4({
      file: aSourceMapConsumer.file,
      sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function (mapping) {
      var newMapping = {
        generated: {
          line: mapping.generatedLine,
          column: mapping.generatedColumn
        }
      };

      if (mapping.source != null) {
        newMapping.source = mapping.source;
        if (sourceRoot != null) {
          newMapping.source = util$5.relative(sourceRoot, newMapping.source);
        }

        newMapping.original = {
          line: mapping.originalLine,
          column: mapping.originalColumn
        };

        if (mapping.name != null) {
          newMapping.name = mapping.name;
        }
      }

      generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var sourceRelative = sourceFile;
      if (sourceRoot !== null) {
        sourceRelative = util$5.relative(sourceRoot, sourceFile);
      }

      if (!generator._sources.has(sourceRelative)) {
        generator._sources.add(sourceRelative);
      }

      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        generator.setSourceContent(sourceFile, content);
      }
    });
    return generator;
  };

/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */
SourceMapGenerator$4.prototype.addMapping =
  function SourceMapGenerator_addMapping(aArgs) {
    var generated = util$5.getArg(aArgs, 'generated');
    var original = util$5.getArg(aArgs, 'original', null);
    var source = util$5.getArg(aArgs, 'source', null);
    var name = util$5.getArg(aArgs, 'name', null);

    if (!this._skipValidation) {
      this._validateMapping(generated, original, source, name);
    }

    if (source != null) {
      source = String(source);
      if (!this._sources.has(source)) {
        this._sources.add(source);
      }
    }

    if (name != null) {
      name = String(name);
      if (!this._names.has(name)) {
        this._names.add(name);
      }
    }

    this._mappings.add({
      generatedLine: generated.line,
      generatedColumn: generated.column,
      originalLine: original != null && original.line,
      originalColumn: original != null && original.column,
      source: source,
      name: name
    });
  };

/**
 * Set the source content for a source file.
 */
SourceMapGenerator$4.prototype.setSourceContent =
  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) {
      source = util$5.relative(this._sourceRoot, source);
    }

    if (aSourceContent != null) {
      // Add the source content to the _sourcesContents map.
      // Create a new _sourcesContents map if the property is null.
      if (!this._sourcesContents) {
        this._sourcesContents = Object.create(null);
      }
      this._sourcesContents[util$5.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
      // Remove the source file from the _sourcesContents map.
      // If the _sourcesContents map is empty, set the property to null.
      delete this._sourcesContents[util$5.toSetString(source)];
      if (Object.keys(this._sourcesContents).length === 0) {
        this._sourcesContents = null;
      }
    }
  };

/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */
SourceMapGenerator$4.prototype.applySourceMap =
  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
      if (aSourceMapConsumer.file == null) {
        throw new Error(
          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
          'or the source map\'s "file" property. Both were omitted.'
        );
      }
      sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) {
      sourceFile = util$5.relative(sourceRoot, sourceFile);
    }
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new ArraySet$1();
    var newNames = new ArraySet$1();

    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function (mapping) {
      if (mapping.source === sourceFile && mapping.originalLine != null) {
        // Check if it can be mapped by the source map, then update the mapping.
        var original = aSourceMapConsumer.originalPositionFor({
          line: mapping.originalLine,
          column: mapping.originalColumn
        });
        if (original.source != null) {
          // Copy mapping
          mapping.source = original.source;
          if (aSourceMapPath != null) {
            mapping.source = util$5.join(aSourceMapPath, mapping.source);
          }
          if (sourceRoot != null) {
            mapping.source = util$5.relative(sourceRoot, mapping.source);
          }
          mapping.originalLine = original.line;
          mapping.originalColumn = original.column;
          if (original.name != null) {
            mapping.name = original.name;
          }
        }
      }

      var source = mapping.source;
      if (source != null && !newSources.has(source)) {
        newSources.add(source);
      }

      var name = mapping.name;
      if (name != null && !newNames.has(name)) {
        newNames.add(name);
      }

    }, this);
    this._sources = newSources;
    this._names = newNames;

    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aSourceMapPath != null) {
          sourceFile = util$5.join(aSourceMapPath, sourceFile);
        }
        if (sourceRoot != null) {
          sourceFile = util$5.relative(sourceRoot, sourceFile);
        }
        this.setSourceContent(sourceFile, content);
      }
    }, this);
  };

/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */
SourceMapGenerator$4.prototype._validateMapping =
  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
                                              aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        throw new Error(
            'original.line and original.column are not numbers -- you probably meant to omit ' +
            'the original mapping entirely and only map the generated position. If so, pass ' +
            'null for the original mapping instead of an object with empty or null values.'
        );
    }

    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
        && aGenerated.line > 0 && aGenerated.column >= 0
        && !aOriginal && !aSource && !aName) {
      // Case 1.
      return;
    }
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
             && aGenerated.line > 0 && aGenerated.column >= 0
             && aOriginal.line > 0 && aOriginal.column >= 0
             && aSource) {
      // Cases 2 and 3.
      return;
    }
    else {
      throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
      }));
    }
  };

/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */
SourceMapGenerator$4.prototype._serializeMappings =
  function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;

    var mappings = this._mappings.toArray();
    for (var i = 0, len = mappings.length; i < len; i++) {
      mapping = mappings[i];
      next = '';

      if (mapping.generatedLine !== previousGeneratedLine) {
        previousGeneratedColumn = 0;
        while (mapping.generatedLine !== previousGeneratedLine) {
          next += ';';
          previousGeneratedLine++;
        }
      }
      else {
        if (i > 0) {
          if (!util$5.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
            continue;
          }
          next += ',';
        }
      }

      next += base64VLQ$1.encode(mapping.generatedColumn
                                 - previousGeneratedColumn);
      previousGeneratedColumn = mapping.generatedColumn;

      if (mapping.source != null) {
        sourceIdx = this._sources.indexOf(mapping.source);
        next += base64VLQ$1.encode(sourceIdx - previousSource);
        previousSource = sourceIdx;

        // lines are stored 0-based in SourceMap spec version 3
        next += base64VLQ$1.encode(mapping.originalLine - 1
                                   - previousOriginalLine);
        previousOriginalLine = mapping.originalLine - 1;

        next += base64VLQ$1.encode(mapping.originalColumn
                                   - previousOriginalColumn);
        previousOriginalColumn = mapping.originalColumn;

        if (mapping.name != null) {
          nameIdx = this._names.indexOf(mapping.name);
          next += base64VLQ$1.encode(nameIdx - previousName);
          previousName = nameIdx;
        }
      }

      result += next;
    }

    return result;
  };

SourceMapGenerator$4.prototype._generateSourcesContent =
  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function (source) {
      if (!this._sourcesContents) {
        return null;
      }
      if (aSourceRoot != null) {
        source = util$5.relative(aSourceRoot, source);
      }
      var key = util$5.toSetString(source);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
        ? this._sourcesContents[key]
        : null;
    }, this);
  };

/**
 * Externalize the source map.
 */
SourceMapGenerator$4.prototype.toJSON =
  function SourceMapGenerator_toJSON() {
    var map = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    if (this._file != null) {
      map.file = this._file;
    }
    if (this._sourceRoot != null) {
      map.sourceRoot = this._sourceRoot;
    }
    if (this._sourcesContents) {
      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    }

    return map;
  };

/**
 * Render the source map being generated to a string.
 */
SourceMapGenerator$4.prototype.toString =
  function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
  };

sourceMapGenerator.SourceMapGenerator = SourceMapGenerator$4;

var sourceMapConsumer = {};

var binarySearch$2 = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

(function (exports) {
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

exports.GREATEST_LOWER_BOUND = 1;
exports.LEAST_UPPER_BOUND = 2;

/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */
function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
  // This function terminates when one of the following is true:
  //
  //   1. We find the exact element we are looking for.
  //
  //   2. We did not find the exact element, but we can return the index of
  //      the next-closest element.
  //
  //   3. We did not find the exact element, and there is no next-closest
  //      element than the one we are searching for, so we return -1.
  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
  var cmp = aCompare(aNeedle, aHaystack[mid], true);
  if (cmp === 0) {
    // Found the element we are looking for.
    return mid;
  }
  else if (cmp > 0) {
    // Our needle is greater than aHaystack[mid].
    if (aHigh - mid > 1) {
      // The element is in the upper half.
      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
    }

    // The exact needle element was not found in this haystack. Determine if
    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return aHigh < aHaystack.length ? aHigh : -1;
    } else {
      return mid;
    }
  }
  else {
    // Our needle is less than aHaystack[mid].
    if (mid - aLow > 1) {
      // The element is in the lower half.
      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
    }

    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return mid;
    } else {
      return aLow < 0 ? -1 : aLow;
    }
  }
}

/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */
exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
  if (aHaystack.length === 0) {
    return -1;
  }

  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
  if (index < 0) {
    return -1;
  }

  // We have found either the exact element, or the next-closest element than
  // the one we are searching for. However, there may be more than one such
  // element. Make sure we always return the smallest of these.
  while (index - 1 >= 0) {
    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
      break;
    }
    --index;
  }

  return index;
};
}(binarySearch$2));

var quickSort$1 = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.

function SortTemplate(comparator) {

/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */
function swap(ary, x, y) {
  var temp = ary[x];
  ary[x] = ary[y];
  ary[y] = temp;
}

/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */
function randomIntInRange(low, high) {
  return Math.round(low + (Math.random() * (high - low)));
}

/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */
function doQuickSort(ary, comparator, p, r) {
  // If our lower bound is less than our upper bound, we (1) partition the
  // array into two pieces and (2) recurse on each half. If it is not, this is
  // the empty array and our base case.

  if (p < r) {
    // (1) Partitioning.
    //
    // The partitioning chooses a pivot between `p` and `r` and moves all
    // elements that are less than or equal to the pivot to the before it, and
    // all the elements that are greater than it after it. The effect is that
    // once partition is done, the pivot is in the exact place it will be when
    // the array is put in sorted order, and it will not need to be moved
    // again. This runs in O(n) time.

    // Always choose a random pivot so that an input array which is reverse
    // sorted does not cause O(n^2) running time.
    var pivotIndex = randomIntInRange(p, r);
    var i = p - 1;

    swap(ary, pivotIndex, r);
    var pivot = ary[r];

    // Immediately after `j` is incremented in this loop, the following hold
    // true:
    //
    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
    //
    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
    for (var j = p; j < r; j++) {
      if (comparator(ary[j], pivot, false) <= 0) {
        i += 1;
        swap(ary, i, j);
      }
    }

    swap(ary, i + 1, j);
    var q = i + 1;

    // (2) Recurse on each half.

    doQuickSort(ary, comparator, p, q - 1);
    doQuickSort(ary, comparator, q + 1, r);
  }
}

  return doQuickSort;
}

function cloneSort(comparator) {
  let template = SortTemplate.toString();
  let templateFn = new Function(`return ${template}`)();
  return templateFn(comparator);
}

/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */

let sortCache = new WeakMap();
quickSort$1.quickSort = function (ary, comparator, start = 0) {
  let doQuickSort = sortCache.get(comparator);
  if (doQuickSort === void 0) {
    doQuickSort = cloneSort(comparator);
    sortCache.set(comparator, doQuickSort);
  }
  doQuickSort(ary, comparator, start, ary.length - 1);
};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util$4 = util$8;
var binarySearch$1 = binarySearch$2;
var ArraySet = arraySet.ArraySet;
var base64VLQ = base64Vlq;
var quickSort = quickSort$1.quickSort;

function SourceMapConsumer$3(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util$4.parseSourceMapInput(aSourceMap);
  }

  return sourceMap.sections != null
    ? new IndexedSourceMapConsumer(sourceMap, aSourceMapURL)
    : new BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}

SourceMapConsumer$3.fromSourceMap = function(aSourceMap, aSourceMapURL) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};

/**
 * The version of the source mapping spec that we are consuming.
 */
SourceMapConsumer$3.prototype._version = 3;

// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.

SourceMapConsumer$3.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer$3.prototype, '_generatedMappings', {
  configurable: true,
  enumerable: true,
  get: function () {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__generatedMappings;
  }
});

SourceMapConsumer$3.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer$3.prototype, '_originalMappings', {
  configurable: true,
  enumerable: true,
  get: function () {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__originalMappings;
  }
});

SourceMapConsumer$3.prototype._charIsMappingSeparator =
  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
SourceMapConsumer$3.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
  };

SourceMapConsumer$3.GENERATED_ORDER = 1;
SourceMapConsumer$3.ORIGINAL_ORDER = 2;

SourceMapConsumer$3.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer$3.LEAST_UPPER_BOUND = 2;

/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */
SourceMapConsumer$3.prototype.eachMapping =
  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || SourceMapConsumer$3.GENERATED_ORDER;

    var mappings;
    switch (order) {
    case SourceMapConsumer$3.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;
    case SourceMapConsumer$3.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;
    default:
      throw new Error("Unknown order of iteration.");
    }

    var sourceRoot = this.sourceRoot;
    var boundCallback = aCallback.bind(context);
    var names = this._names;
    var sources = this._sources;
    var sourceMapURL = this._sourceMapURL;

    for (var i = 0, n = mappings.length; i < n; i++) {
      var mapping = mappings[i];
      var source = mapping.source === null ? null : sources.at(mapping.source);
      source = util$4.computeSourceURL(sourceRoot, source, sourceMapURL);
      boundCallback({
        source: source,
        generatedLine: mapping.generatedLine,
        generatedColumn: mapping.generatedColumn,
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: mapping.name === null ? null : names.at(mapping.name)
      });
    }
  };

/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */
SourceMapConsumer$3.prototype.allGeneratedPositionsFor =
  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = util$4.getArg(aArgs, 'line');

    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
      source: util$4.getArg(aArgs, 'source'),
      originalLine: line,
      originalColumn: util$4.getArg(aArgs, 'column', 0)
    };

    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) {
      return [];
    }

    var mappings = [];

    var index = this._findMapping(needle,
                                  this._originalMappings,
                                  "originalLine",
                                  "originalColumn",
                                  util$4.compareByOriginalPositions,
                                  binarySearch$1.LEAST_UPPER_BOUND);
    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (aArgs.column === undefined) {
        var originalLine = mapping.originalLine;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we found. Since
        // mappings are sorted, this is guaranteed to find all mappings for
        // the line we found.
        while (mapping && mapping.originalLine === originalLine) {
          mappings.push({
            line: util$4.getArg(mapping, 'generatedLine', null),
            column: util$4.getArg(mapping, 'generatedColumn', null),
            lastColumn: util$4.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      } else {
        var originalColumn = mapping.originalColumn;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we were searching for.
        // Since mappings are sorted, this is guaranteed to find all mappings for
        // the line we are searching for.
        while (mapping &&
               mapping.originalLine === line &&
               mapping.originalColumn == originalColumn) {
          mappings.push({
            line: util$4.getArg(mapping, 'generatedLine', null),
            column: util$4.getArg(mapping, 'generatedColumn', null),
            lastColumn: util$4.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      }
    }

    return mappings;
  };

sourceMapConsumer.SourceMapConsumer = SourceMapConsumer$3;

/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */
function BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util$4.parseSourceMapInput(aSourceMap);
  }

  var version = util$4.getArg(sourceMap, 'version');
  var sources = util$4.getArg(sourceMap, 'sources');
  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
  // requires the array) to play nice here.
  var names = util$4.getArg(sourceMap, 'names', []);
  var sourceRoot = util$4.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = util$4.getArg(sourceMap, 'sourcesContent', null);
  var mappings = util$4.getArg(sourceMap, 'mappings');
  var file = util$4.getArg(sourceMap, 'file', null);

  // Once again, Sass deviates from the spec and supplies the version as a
  // string rather than a number, so we use loose equality checking here.
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  if (sourceRoot) {
    sourceRoot = util$4.normalize(sourceRoot);
  }

  sources = sources
    .map(String)
    // Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map(util$4.normalize)
    // Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function (source) {
      return sourceRoot && util$4.isAbsolute(sourceRoot) && util$4.isAbsolute(source)
        ? util$4.relative(sourceRoot, source)
        : source;
    });

  // Pass `true` below to allow duplicate names and sources. While source maps
  // are intended to be compressed and deduplicated, the TypeScript compiler
  // sometimes generates source maps with duplicates in them. See Github issue
  // #72 and bugzil.la/889492.
  this._names = ArraySet.fromArray(names.map(String), true);
  this._sources = ArraySet.fromArray(sources, true);

  this._absoluteSources = this._sources.toArray().map(function (s) {
    return util$4.computeSourceURL(sourceRoot, s, aSourceMapURL);
  });

  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this._sourceMapURL = aSourceMapURL;
  this.file = file;
}

BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer$3.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer$3;

/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */
BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
  var relativeSource = aSource;
  if (this.sourceRoot != null) {
    relativeSource = util$4.relative(this.sourceRoot, relativeSource);
  }

  if (this._sources.has(relativeSource)) {
    return this._sources.indexOf(relativeSource);
  }

  // Maybe aSource is an absolute URL as returned by |sources|.  In
  // this case we can't simply undo the transform.
  var i;
  for (i = 0; i < this._absoluteSources.length; ++i) {
    if (this._absoluteSources[i] == aSource) {
      return i;
    }
  }

  return -1;
};

/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */
BasicSourceMapConsumer.fromSourceMap =
  function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create(BasicSourceMapConsumer.prototype);

    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
                                                            smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function (s) {
      return util$4.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });

    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.

    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];

    for (var i = 0, length = generatedMappings.length; i < length; i++) {
      var srcMapping = generatedMappings[i];
      var destMapping = new Mapping;
      destMapping.generatedLine = srcMapping.generatedLine;
      destMapping.generatedColumn = srcMapping.generatedColumn;

      if (srcMapping.source) {
        destMapping.source = sources.indexOf(srcMapping.source);
        destMapping.originalLine = srcMapping.originalLine;
        destMapping.originalColumn = srcMapping.originalColumn;

        if (srcMapping.name) {
          destMapping.name = names.indexOf(srcMapping.name);
        }

        destOriginalMappings.push(destMapping);
      }

      destGeneratedMappings.push(destMapping);
    }

    quickSort(smc.__originalMappings, util$4.compareByOriginalPositions);

    return smc;
  };

/**
 * The version of the source mapping spec that we are consuming.
 */
BasicSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function () {
    return this._absoluteSources.slice();
  }
});

/**
 * Provide the JIT with a nice shape / hidden class.
 */
function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */

const compareGenerated = util$4.compareByGeneratedPositionsDeflatedNoLine;
function sortGenerated(array, start) {
  let l = array.length;
  let n = array.length - start;
  if (n <= 1) {
    return;
  } else if (n == 2) {
    let a = array[start];
    let b = array[start + 1];
    if (compareGenerated(a, b) > 0) {
      array[start] = b;
      array[start + 1] = a;
    }
  } else if (n < 20) {
    for (let i = start; i < l; i++) {
      for (let j = i; j > start; j--) {
        let a = array[j - 1];
        let b = array[j];
        if (compareGenerated(a, b) <= 0) {
          break;
        }
        array[j - 1] = b;
        array[j] = a;
      }
    }
  } else {
    quickSort(array, compareGenerated, start);
  }
}
BasicSourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, segment, end, value;

    let subarrayStart = 0;
    while (index < length) {
      if (aStr.charAt(index) === ';') {
        generatedLine++;
        index++;
        previousGeneratedColumn = 0;

        sortGenerated(generatedMappings, subarrayStart);
        subarrayStart = generatedMappings.length;
      }
      else if (aStr.charAt(index) === ',') {
        index++;
      }
      else {
        mapping = new Mapping();
        mapping.generatedLine = generatedLine;

        for (end = index; end < length; end++) {
          if (this._charIsMappingSeparator(aStr, end)) {
            break;
          }
        }
        aStr.slice(index, end);

        segment = [];
        while (index < end) {
          base64VLQ.decode(aStr, index, temp);
          value = temp.value;
          index = temp.rest;
          segment.push(value);
        }

        if (segment.length === 2) {
          throw new Error('Found a source, but no line and column');
        }

        if (segment.length === 3) {
          throw new Error('Found a source and line, but no column');
        }

        // Generated column.
        mapping.generatedColumn = previousGeneratedColumn + segment[0];
        previousGeneratedColumn = mapping.generatedColumn;

        if (segment.length > 1) {
          // Original source.
          mapping.source = previousSource + segment[1];
          previousSource += segment[1];

          // Original line.
          mapping.originalLine = previousOriginalLine + segment[2];
          previousOriginalLine = mapping.originalLine;
          // Lines are stored 0-based
          mapping.originalLine += 1;

          // Original column.
          mapping.originalColumn = previousOriginalColumn + segment[3];
          previousOriginalColumn = mapping.originalColumn;

          if (segment.length > 4) {
            // Original name.
            mapping.name = previousName + segment[4];
            previousName += segment[4];
          }
        }

        generatedMappings.push(mapping);
        if (typeof mapping.originalLine === 'number') {
          let currentSource = mapping.source;
          while (originalMappings.length <= currentSource) {
            originalMappings.push(null);
          }
          if (originalMappings[currentSource] === null) {
            originalMappings[currentSource] = [];
          }
          originalMappings[currentSource].push(mapping);
        }
      }
    }

    sortGenerated(generatedMappings, subarrayStart);
    this.__generatedMappings = generatedMappings;

    for (var i = 0; i < originalMappings.length; i++) {
      if (originalMappings[i] != null) {
        quickSort(originalMappings[i], util$4.compareByOriginalPositionsNoSource);
      }
    }
    this.__originalMappings = [].concat(...originalMappings);
  };

/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */
BasicSourceMapConsumer.prototype._findMapping =
  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
                                         aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.

    if (aNeedle[aLineName] <= 0) {
      throw new TypeError('Line must be greater than or equal to 1, got '
                          + aNeedle[aLineName]);
    }
    if (aNeedle[aColumnName] < 0) {
      throw new TypeError('Column must be greater than or equal to 0, got '
                          + aNeedle[aColumnName]);
    }

    return binarySearch$1.search(aNeedle, aMappings, aComparator, aBias);
  };

/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */
BasicSourceMapConsumer.prototype.computeColumnSpans =
  function SourceMapConsumer_computeColumnSpans() {
    for (var index = 0; index < this._generatedMappings.length; ++index) {
      var mapping = this._generatedMappings[index];

      // Mappings do not contain a field for the last generated columnt. We
      // can come up with an optimistic estimate, however, by assuming that
      // mappings are contiguous (i.e. given two consecutive mappings, the
      // first mapping ends where the second one starts).
      if (index + 1 < this._generatedMappings.length) {
        var nextMapping = this._generatedMappings[index + 1];

        if (mapping.generatedLine === nextMapping.generatedLine) {
          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
          continue;
        }
      }

      // The last mapping for each line spans the entire line.
      mapping.lastGeneratedColumn = Infinity;
    }
  };

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */
BasicSourceMapConsumer.prototype.originalPositionFor =
  function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util$4.getArg(aArgs, 'line'),
      generatedColumn: util$4.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      util$4.compareByGeneratedPositionsDeflated,
      util$4.getArg(aArgs, 'bias', SourceMapConsumer$3.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._generatedMappings[index];

      if (mapping.generatedLine === needle.generatedLine) {
        var source = util$4.getArg(mapping, 'source', null);
        if (source !== null) {
          source = this._sources.at(source);
          source = util$4.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
        }
        var name = util$4.getArg(mapping, 'name', null);
        if (name !== null) {
          name = this._names.at(name);
        }
        return {
          source: source,
          line: util$4.getArg(mapping, 'originalLine', null),
          column: util$4.getArg(mapping, 'originalColumn', null),
          name: name
        };
      }
    }

    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
  function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) {
      return false;
    }
    return this.sourcesContent.length >= this._sources.size() &&
      !this.sourcesContent.some(function (sc) { return sc == null; });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
BasicSourceMapConsumer.prototype.sourceContentFor =
  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) {
      return null;
    }

    var index = this._findSourceIndex(aSource);
    if (index >= 0) {
      return this.sourcesContent[index];
    }

    var relativeSource = aSource;
    if (this.sourceRoot != null) {
      relativeSource = util$4.relative(this.sourceRoot, relativeSource);
    }

    var url;
    if (this.sourceRoot != null
        && (url = util$4.urlParse(this.sourceRoot))) {
      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
      // many users. We can help them out when they expect file:// URIs to
      // behave like it would if they were running a local HTTP server. See
      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
      var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
      if (url.scheme == "file"
          && this._sources.has(fileUriAbsPath)) {
        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
      }

      if ((!url.path || url.path == "/")
          && this._sources.has("/" + relativeSource)) {
        return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
      }
    }

    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + relativeSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */
BasicSourceMapConsumer.prototype.generatedPositionFor =
  function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = util$4.getArg(aArgs, 'source');
    source = this._findSourceIndex(source);
    if (source < 0) {
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    }

    var needle = {
      source: source,
      originalLine: util$4.getArg(aArgs, 'line'),
      originalColumn: util$4.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      util$4.compareByOriginalPositions,
      util$4.getArg(aArgs, 'bias', SourceMapConsumer$3.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (mapping.source === needle.source) {
        return {
          line: util$4.getArg(mapping, 'generatedLine', null),
          column: util$4.getArg(mapping, 'generatedColumn', null),
          lastColumn: util$4.getArg(mapping, 'lastGeneratedColumn', null)
        };
      }
    }

    return {
      line: null,
      column: null,
      lastColumn: null
    };
  };

sourceMapConsumer.BasicSourceMapConsumer = BasicSourceMapConsumer;

/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */
function IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util$4.parseSourceMapInput(aSourceMap);
  }

  var version = util$4.getArg(sourceMap, 'version');
  var sections = util$4.getArg(sourceMap, 'sections');

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  this._sources = new ArraySet();
  this._names = new ArraySet();

  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      // The url field will require support for asynchronicity.
      // See https://github.com/mozilla/source-map/issues/16
      throw new Error('Support for url field in sections not implemented.');
    }
    var offset = util$4.getArg(s, 'offset');
    var offsetLine = util$4.getArg(offset, 'line');
    var offsetColumn = util$4.getArg(offset, 'column');

    if (offsetLine < lastOffset.line ||
        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }
    lastOffset = offset;

    return {
      generatedOffset: {
        // The offset fields are 0-based, but we use 1-based indices when
        // encoding/decoding from VLQ.
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer$3(util$4.getArg(s, 'map'), aSourceMapURL)
    }
  });
}

IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer$3.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer$3;

/**
 * The version of the source mapping spec that we are consuming.
 */
IndexedSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function () {
    var sources = [];
    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }
    return sources;
  }
});

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */
IndexedSourceMapConsumer.prototype.originalPositionFor =
  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util$4.getArg(aArgs, 'line'),
      generatedColumn: util$4.getArg(aArgs, 'column')
    };

    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = binarySearch$1.search(needle, this._sections,
      function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) {
          return cmp;
        }

        return (needle.generatedColumn -
                section.generatedOffset.generatedColumn);
      });
    var section = this._sections[sectionIndex];

    if (!section) {
      return {
        source: null,
        line: null,
        column: null,
        name: null
      };
    }

    return section.consumer.originalPositionFor({
      line: needle.generatedLine -
        (section.generatedOffset.generatedLine - 1),
      column: needle.generatedColumn -
        (section.generatedOffset.generatedLine === needle.generatedLine
         ? section.generatedOffset.generatedColumn - 1
         : 0),
      bias: aArgs.bias
    });
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function (s) {
      return s.consumer.hasContentsOfAllSources();
    });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
IndexedSourceMapConsumer.prototype.sourceContentFor =
  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      var content = section.consumer.sourceContentFor(aSource, true);
      if (content) {
        return content;
      }
    }
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */
IndexedSourceMapConsumer.prototype.generatedPositionFor =
  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      // Only consider this section if the requested source is in the list of
      // sources of the consumer.
      if (section.consumer._findSourceIndex(util$4.getArg(aArgs, 'source')) === -1) {
        continue;
      }
      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
      if (generatedPosition) {
        var ret = {
          line: generatedPosition.line +
            (section.generatedOffset.generatedLine - 1),
          column: generatedPosition.column +
            (section.generatedOffset.generatedLine === generatedPosition.line
             ? section.generatedOffset.generatedColumn - 1
             : 0)
        };
        return ret;
      }
    }

    return {
      line: null,
      column: null
    };
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
IndexedSourceMapConsumer.prototype._parseMappings =
  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];
      var sectionMappings = section.consumer._generatedMappings;
      for (var j = 0; j < sectionMappings.length; j++) {
        var mapping = sectionMappings[j];

        var source = section.consumer._sources.at(mapping.source);
        source = util$4.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
        this._sources.add(source);
        source = this._sources.indexOf(source);

        var name = null;
        if (mapping.name) {
          name = section.consumer._names.at(mapping.name);
          this._names.add(name);
          name = this._names.indexOf(name);
        }

        // The mappings coming from the consumer for the section have
        // generated positions relative to the start of the section, so we
        // need to offset them to be relative to the start of the concatenated
        // generated file.
        var adjustedMapping = {
          source: source,
          generatedLine: mapping.generatedLine +
            (section.generatedOffset.generatedLine - 1),
          generatedColumn: mapping.generatedColumn +
            (section.generatedOffset.generatedLine === mapping.generatedLine
            ? section.generatedOffset.generatedColumn - 1
            : 0),
          originalLine: mapping.originalLine,
          originalColumn: mapping.originalColumn,
          name: name
        };

        this.__generatedMappings.push(adjustedMapping);
        if (typeof adjustedMapping.originalLine === 'number') {
          this.__originalMappings.push(adjustedMapping);
        }
      }
    }

    quickSort(this.__generatedMappings, util$4.compareByGeneratedPositionsDeflated);
    quickSort(this.__originalMappings, util$4.compareByOriginalPositions);
  };

sourceMapConsumer.IndexedSourceMapConsumer = IndexedSourceMapConsumer;

var sourceNode = {};

/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var SourceMapGenerator$3 = sourceMapGenerator.SourceMapGenerator;
var util$3 = util$8;

// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var REGEX_NEWLINE = /(\r?\n)/;

// Newline character code for charCodeAt() comparisons
var NEWLINE_CODE = 10;

// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var isSourceNode = "$$$isSourceNode$$$";

/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */
function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}

/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */
SourceNode.fromStringWithSourceMap =
  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new SourceNode();

    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
      var lineContents = getNextLine();
      // The last line of a file might not have a newline.
      var newLine = getNextLine() || "";
      return lineContents + newLine;

      function getNextLine() {
        return remainingLinesIndex < remainingLines.length ?
            remainingLines[remainingLinesIndex++] : undefined;
      }
    };

    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;

    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;

    aSourceMapConsumer.eachMapping(function (mapping) {
      if (lastMapping !== null) {
        // We add the code from "lastMapping" to "mapping":
        // First check if there is a new line in between.
        if (lastGeneratedLine < mapping.generatedLine) {
          // Associate first line with "lastMapping"
          addMappingWithCode(lastMapping, shiftNextLine());
          lastGeneratedLine++;
          lastGeneratedColumn = 0;
          // The remaining code is added without mapping
        } else {
          // There is no new line in between.
          // Associate the code between "lastGeneratedColumn" and
          // "mapping.generatedColumn" with "lastMapping"
          var nextLine = remainingLines[remainingLinesIndex] || '';
          var code = nextLine.substr(0, mapping.generatedColumn -
                                        lastGeneratedColumn);
          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
                                              lastGeneratedColumn);
          lastGeneratedColumn = mapping.generatedColumn;
          addMappingWithCode(lastMapping, code);
          // No more remaining code, continue
          lastMapping = mapping;
          return;
        }
      }
      // We add the generated code until the first mapping
      // to the SourceNode without any mapping.
      // Each line is added as separate string.
      while (lastGeneratedLine < mapping.generatedLine) {
        node.add(shiftNextLine());
        lastGeneratedLine++;
      }
      if (lastGeneratedColumn < mapping.generatedColumn) {
        var nextLine = remainingLines[remainingLinesIndex] || '';
        node.add(nextLine.substr(0, mapping.generatedColumn));
        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
      }
      lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
      if (lastMapping) {
        // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
      }
      // and add the remaining lines without any mapping
      node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }

    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aRelativePath != null) {
          sourceFile = util$3.join(aRelativePath, sourceFile);
        }
        node.setSourceContent(sourceFile, content);
      }
    });

    return node;

    function addMappingWithCode(mapping, code) {
      if (mapping === null || mapping.source === undefined) {
        node.add(code);
      } else {
        var source = aRelativePath
          ? util$3.join(aRelativePath, mapping.source)
          : mapping.source;
        node.add(new SourceNode(mapping.originalLine,
                                mapping.originalColumn,
                                source,
                                code,
                                mapping.name));
      }
    }
  };

/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length-1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;
  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];
    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    }
    else {
      if (chunk !== '') {
        aFn(chunk, { source: this.source,
                     line: this.line,
                     column: this.column,
                     name: this.name });
      }
    }
  }
};

/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */
SourceNode.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;
  if (len > 0) {
    newChildren = [];
    for (i = 0; i < len-1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }
    newChildren.push(this.children[i]);
    this.children = newChildren;
  }
  return this;
};

/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */
SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];
  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  }
  else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  }
  else {
    this.children.push(''.replace(aPattern, aReplacement));
  }
  return this;
};

/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */
SourceNode.prototype.setSourceContent =
  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[util$3.toSetString(aSourceFile)] = aSourceContent;
  };

/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walkSourceContents =
  function SourceNode_walkSourceContents(aFn) {
    for (var i = 0, len = this.children.length; i < len; i++) {
      if (this.children[i][isSourceNode]) {
        this.children[i].walkSourceContents(aFn);
      }
    }

    var sources = Object.keys(this.sourceContents);
    for (var i = 0, len = sources.length; i < len; i++) {
      aFn(util$3.fromSetString(sources[i]), this.sourceContents[sources[i]]);
    }
  };

/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */
SourceNode.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};

/**
 * Returns the string representation of this source node along with a source
 * map.
 */
SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new SourceMapGenerator$3(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;
    if (original.source !== null
        && original.line !== null
        && original.column !== null) {
      if(lastOriginalSource !== original.source
         || lastOriginalLine !== original.line
         || lastOriginalColumn !== original.column
         || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }
      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }
    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0;
        // Mappings end at eol
        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });

  return { code: generated.code, map: map };
};

sourceNode.SourceNode = SourceNode;

/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

sourceMap.SourceMapGenerator = sourceMapGenerator.SourceMapGenerator;
sourceMap.SourceMapConsumer = sourceMapConsumer.SourceMapConsumer;
sourceMap.SourceNode = sourceNode.SourceNode;

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = '';
    let i = size;
    while (i--) {
      id += alphabet[(Math.random() * alphabet.length) | 0];
    }
    return id
  }
};
let nanoid$1 = (size = 21) => {
  let id = '';
  let i = size;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id
};
var nonSecure = { nanoid: nanoid$1, customAlphabet };

let { SourceMapConsumer: SourceMapConsumer$2, SourceMapGenerator: SourceMapGenerator$2 } = sourceMap;
let { existsSync, readFileSync } = require$$1$4;
let { dirname: dirname$1, join } = require$$2$4;

function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, 'base64').toString()
  } else {
    /* c8 ignore next 2 */
    return window.atob(str)
  }
}

class PreviousMap$2 {
  constructor(css, opts) {
    if (opts.map === false) return
    this.loadAnnotation(css);
    this.inline = this.startWith(this.annotation, 'data:');

    let prev = opts.map ? opts.map.prev : undefined;
    let text = this.loadMap(opts.from, prev);
    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }
    if (this.mapFile) this.root = dirname$1(this.mapFile);
    if (text) this.text = text;
  }

  consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new SourceMapConsumer$2(this.text);
    }
    return this.consumerCache
  }

  withContent() {
    return !!(
      this.consumer().sourcesContent &&
      this.consumer().sourcesContent.length > 0
    )
  }

  startWith(string, start) {
    if (!string) return false
    return string.substr(0, start.length) === start
  }

  getAnnotationURL(sourceMapString) {
    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim()
  }

  loadAnnotation(css) {
    let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
    if (!comments) return

    // sourceMappingURLs from comments, strings, etc.
    let start = css.lastIndexOf(comments.pop());
    let end = css.indexOf('*/', start);

    if (start > -1 && end > -1) {
      // Locate the last sourceMappingURL to avoid pickin
      this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
  }

  decodeInline(text) {
    let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    let baseUri = /^data:application\/json;base64,/;
    let charsetUri = /^data:application\/json;charset=utf-?8,/;
    let uri = /^data:application\/json,/;

    if (charsetUri.test(text) || uri.test(text)) {
      return decodeURIComponent(text.substr(RegExp.lastMatch.length))
    }

    if (baseCharsetUri.test(text) || baseUri.test(text)) {
      return fromBase64(text.substr(RegExp.lastMatch.length))
    }

    let encoding = text.match(/data:application\/json;([^,]+),/)[1];
    throw new Error('Unsupported source map encoding ' + encoding)
  }

  loadFile(path) {
    this.root = dirname$1(path);
    if (existsSync(path)) {
      this.mapFile = path;
      return readFileSync(path, 'utf-8').toString().trim()
    }
  }

  loadMap(file, prev) {
    if (prev === false) return false

    if (prev) {
      if (typeof prev === 'string') {
        return prev
      } else if (typeof prev === 'function') {
        let prevPath = prev(file);
        if (prevPath) {
          let map = this.loadFile(prevPath);
          if (!map) {
            throw new Error(
              'Unable to load previous source map: ' + prevPath.toString()
            )
          }
          return map
        }
      } else if (prev instanceof SourceMapConsumer$2) {
        return SourceMapGenerator$2.fromSourceMap(prev).toString()
      } else if (prev instanceof SourceMapGenerator$2) {
        return prev.toString()
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev)
      } else {
        throw new Error(
          'Unsupported previous source map format: ' + prev.toString()
        )
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation)
    } else if (this.annotation) {
      let map = this.annotation;
      if (file) map = join(dirname$1(file), map);
      return this.loadFile(map)
    }
  }

  isMap(map) {
    if (typeof map !== 'object') return false
    return (
      typeof map.mappings === 'string' ||
      typeof map._mappings === 'string' ||
      Array.isArray(map.sections)
    )
  }
}

var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;

let { SourceMapConsumer: SourceMapConsumer$1, SourceMapGenerator: SourceMapGenerator$1 } = sourceMap;
let { fileURLToPath, pathToFileURL: pathToFileURL$1 } = require$$1$5;
let { resolve: resolve$2, isAbsolute } = require$$2$4;
let { nanoid } = nonSecure;

let terminalHighlight = terminalHighlight_1;
let CssSyntaxError$1 = cssSyntaxError;
let PreviousMap$1 = previousMap;

let fromOffsetCache = Symbol('fromOffsetCache');

let sourceMapAvailable$1 = Boolean(SourceMapConsumer$1 && SourceMapGenerator$1);
let pathAvailable$1 = Boolean(resolve$2 && isAbsolute);

class Input$4 {
  constructor(css, opts = {}) {
    if (
      css === null ||
      typeof css === 'undefined' ||
      (typeof css === 'object' && !css.toString)
    ) {
      throw new Error(`PostCSS received ${css} instead of CSS string`)
    }

    this.css = css.toString();

    if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    if (opts.from) {
      if (
        !pathAvailable$1 ||
        /^\w+:\/\//.test(opts.from) ||
        isAbsolute(opts.from)
      ) {
        this.file = opts.from;
      } else {
        this.file = resolve$2(opts.from);
      }
    }

    if (pathAvailable$1 && sourceMapAvailable$1) {
      let map = new PreviousMap$1(this.css, opts);
      if (map.text) {
        this.map = map;
        let file = map.consumer().file;
        if (!this.file && file) this.file = this.mapResolve(file);
      }
    }

    if (!this.file) {
      this.id = '<input css ' + nanoid(6) + '>';
    }
    if (this.map) this.map.file = this.from;
  }

  fromOffset(offset) {
    let lastLine, lineToIndex;
    if (!this[fromOffsetCache]) {
      let lines = this.css.split('\n');
      lineToIndex = new Array(lines.length);
      let prevIndex = 0;

      for (let i = 0, l = lines.length; i < l; i++) {
        lineToIndex[i] = prevIndex;
        prevIndex += lines[i].length + 1;
      }

      this[fromOffsetCache] = lineToIndex;
    } else {
      lineToIndex = this[fromOffsetCache];
    }
    lastLine = lineToIndex[lineToIndex.length - 1];

    let min = 0;
    if (offset >= lastLine) {
      min = lineToIndex.length - 1;
    } else {
      let max = lineToIndex.length - 2;
      let mid;
      while (min < max) {
        mid = min + ((max - min) >> 1);
        if (offset < lineToIndex[mid]) {
          max = mid - 1;
        } else if (offset >= lineToIndex[mid + 1]) {
          min = mid + 1;
        } else {
          min = mid;
          break
        }
      }
    }
    return {
      line: min + 1,
      col: offset - lineToIndex[min] + 1
    }
  }

  error(message, line, column, opts = {}) {
    let result, endLine, endColumn;

    if (line && typeof line === 'object') {
      let start = line;
      let end = column;
      if (typeof line.offset === 'number') {
        let pos = this.fromOffset(start.offset);
        line = pos.line;
        column = pos.col;
      } else {
        line = start.line;
        column = start.column;
      }
      if (typeof end.offset === 'number') {
        let pos = this.fromOffset(end.offset);
        endLine = pos.line;
        endColumn = pos.col;
      } else {
        endLine = end.line;
        endColumn = end.column;
      }
    } else if (!column) {
      let pos = this.fromOffset(line);
      line = pos.line;
      column = pos.col;
    }

    let origin = this.origin(line, column, endLine, endColumn);
    if (origin) {
      result = new CssSyntaxError$1(
        message,
        origin.endLine === undefined
          ? origin.line
          : { line: origin.line, column: origin.column },
        origin.endLine === undefined
          ? origin.column
          : { line: origin.endLine, column: origin.endColumn },
        origin.source,
        origin.file,
        opts.plugin
      );
    } else {
      result = new CssSyntaxError$1(
        message,
        endLine === undefined ? line : { line, column },
        endLine === undefined ? column : { line: endLine, column: endColumn },
        this.css,
        this.file,
        opts.plugin
      );
    }

    result.input = { line, column, endLine, endColumn, source: this.css };
    if (this.file) {
      if (pathToFileURL$1) {
        result.input.url = pathToFileURL$1(this.file).toString();
      }
      result.input.file = this.file;
    }

    return result
  }

  origin(line, column, endLine, endColumn) {
    if (!this.map) return false
    let consumer = this.map.consumer();

    let from = consumer.originalPositionFor({ line, column });
    if (!from.source) return false

    let to;
    if (typeof endLine === 'number') {
      to = consumer.originalPositionFor({ line: endLine, column: endColumn });
    }

    let fromUrl;

    if (isAbsolute(from.source)) {
      fromUrl = pathToFileURL$1(from.source);
    } else {
      fromUrl = new URL(
        from.source,
        this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile)
      );
    }

    let result = {
      url: fromUrl.toString(),
      line: from.line,
      column: from.column,
      endLine: to && to.line,
      endColumn: to && to.column
    };

    if (fromUrl.protocol === 'file:') {
      if (fileURLToPath) {
        result.file = fileURLToPath(fromUrl);
      } else {
        /* c8 ignore next 2 */
        throw new Error(`file: protocol is not available in this PostCSS build`)
      }
    }

    let source = consumer.sourceContentFor(from.source);
    if (source) result.source = source;

    return result
  }

  mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file
    }
    return resolve$2(this.map.consumer().sourceRoot || this.map.root || '.', file)
  }

  get from() {
    return this.file || this.id
  }

  toJSON() {
    let json = {};
    for (let name of ['hasBOM', 'css', 'file', 'id']) {
      if (this[name] != null) {
        json[name] = this[name];
      }
    }
    if (this.map) {
      json.map = { ...this.map };
      if (json.map.consumerCache) {
        json.map.consumerCache = undefined;
      }
    }
    return json
  }
}

var input = Input$4;
Input$4.default = Input$4;

if (terminalHighlight && terminalHighlight.registerInput) {
  terminalHighlight.registerInput(Input$4);
}

let { SourceMapConsumer, SourceMapGenerator } = sourceMap;
let { dirname, resolve: resolve$1, relative, sep } = require$$2$4;
let { pathToFileURL } = require$$1$5;

let Input$3 = input;

let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
let pathAvailable = Boolean(dirname && resolve$1 && relative && sep);

class MapGenerator$2 {
  constructor(stringify, root, opts, cssString) {
    this.stringify = stringify;
    this.mapOpts = opts.map || {};
    this.root = root;
    this.opts = opts;
    this.css = cssString;
  }

  isMap() {
    if (typeof this.opts.map !== 'undefined') {
      return !!this.opts.map
    }
    return this.previous().length > 0
  }

  previous() {
    if (!this.previousMaps) {
      this.previousMaps = [];
      if (this.root) {
        this.root.walk(node => {
          if (node.source && node.source.input.map) {
            let map = node.source.input.map;
            if (!this.previousMaps.includes(map)) {
              this.previousMaps.push(map);
            }
          }
        });
      } else {
        let input = new Input$3(this.css, this.opts);
        if (input.map) this.previousMaps.push(input.map);
      }
    }

    return this.previousMaps
  }

  isInline() {
    if (typeof this.mapOpts.inline !== 'undefined') {
      return this.mapOpts.inline
    }

    let annotation = this.mapOpts.annotation;
    if (typeof annotation !== 'undefined' && annotation !== true) {
      return false
    }

    if (this.previous().length) {
      return this.previous().some(i => i.inline)
    }
    return true
  }

  isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== 'undefined') {
      return this.mapOpts.sourcesContent
    }
    if (this.previous().length) {
      return this.previous().some(i => i.withContent())
    }
    return true
  }

  clearAnnotation() {
    if (this.mapOpts.annotation === false) return

    if (this.root) {
      let node;
      for (let i = this.root.nodes.length - 1; i >= 0; i--) {
        node = this.root.nodes[i];
        if (node.type !== 'comment') continue
        if (node.text.indexOf('# sourceMappingURL=') === 0) {
          this.root.removeChild(i);
        }
      }
    } else if (this.css) {
      this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, '');
    }
  }

  setSourcesContent() {
    let already = {};
    if (this.root) {
      this.root.walk(node => {
        if (node.source) {
          let from = node.source.input.from;
          if (from && !already[from]) {
            already[from] = true;
            this.map.setSourceContent(
              this.toUrl(this.path(from)),
              node.source.input.css
            );
          }
        }
      });
    } else if (this.css) {
      let from = this.opts.from
        ? this.toUrl(this.path(this.opts.from))
        : '<no source>';
      this.map.setSourceContent(from, this.css);
    }
  }

  applyPrevMaps() {
    for (let prev of this.previous()) {
      let from = this.toUrl(this.path(prev.file));
      let root = prev.root || dirname(prev.file);
      let map;

      if (this.mapOpts.sourcesContent === false) {
        map = new SourceMapConsumer(prev.text);
        if (map.sourcesContent) {
          map.sourcesContent = map.sourcesContent.map(() => null);
        }
      } else {
        map = prev.consumer();
      }

      this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
    }
  }

  isAnnotation() {
    if (this.isInline()) {
      return true
    }
    if (typeof this.mapOpts.annotation !== 'undefined') {
      return this.mapOpts.annotation
    }
    if (this.previous().length) {
      return this.previous().some(i => i.annotation)
    }
    return true
  }

  toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString('base64')
    } else {
      return window.btoa(unescape(encodeURIComponent(str)))
    }
  }

  addAnnotation() {
    let content;

    if (this.isInline()) {
      content =
        'data:application/json;base64,' + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === 'string') {
      content = this.mapOpts.annotation;
    } else if (typeof this.mapOpts.annotation === 'function') {
      content = this.mapOpts.annotation(this.opts.to, this.root);
    } else {
      content = this.outputFile() + '.map';
    }
    let eol = '\n';
    if (this.css.includes('\r\n')) eol = '\r\n';

    this.css += eol + '/*# sourceMappingURL=' + content + ' */';
  }

  outputFile() {
    if (this.opts.to) {
      return this.path(this.opts.to)
    } else if (this.opts.from) {
      return this.path(this.opts.from)
    } else {
      return 'to.css'
    }
  }

  generateMap() {
    if (this.root) {
      this.generateString();
    } else if (this.previous().length === 1) {
      let prev = this.previous()[0].consumer();
      prev.file = this.outputFile();
      this.map = SourceMapGenerator.fromSourceMap(prev);
    } else {
      this.map = new SourceMapGenerator({ file: this.outputFile() });
      this.map.addMapping({
        source: this.opts.from
          ? this.toUrl(this.path(this.opts.from))
          : '<no source>',
        generated: { line: 1, column: 0 },
        original: { line: 1, column: 0 }
      });
    }

    if (this.isSourcesContent()) this.setSourcesContent();
    if (this.root && this.previous().length > 0) this.applyPrevMaps();
    if (this.isAnnotation()) this.addAnnotation();

    if (this.isInline()) {
      return [this.css]
    } else {
      return [this.css, this.map]
    }
  }

  path(file) {
    if (file.indexOf('<') === 0) return file
    if (/^\w+:\/\//.test(file)) return file
    if (this.mapOpts.absolute) return file

    let from = this.opts.to ? dirname(this.opts.to) : '.';

    if (typeof this.mapOpts.annotation === 'string') {
      from = dirname(resolve$1(from, this.mapOpts.annotation));
    }

    file = relative(from, file);
    return file
  }

  toUrl(path) {
    if (sep === '\\') {
      path = path.replace(/\\/g, '/');
    }
    return encodeURI(path).replace(/[#?]/g, encodeURIComponent)
  }

  sourcePath(node) {
    if (this.mapOpts.from) {
      return this.toUrl(this.mapOpts.from)
    } else if (this.mapOpts.absolute) {
      if (pathToFileURL) {
        return pathToFileURL(node.source.input.from).toString()
      } else {
        throw new Error(
          '`map.absolute` option is not available in this PostCSS build'
        )
      }
    } else {
      return this.toUrl(this.path(node.source.input.from))
    }
  }

  generateString() {
    this.css = '';
    this.map = new SourceMapGenerator({ file: this.outputFile() });

    let line = 1;
    let column = 1;

    let noSource = '<no source>';
    let mapping = {
      source: '',
      generated: { line: 0, column: 0 },
      original: { line: 0, column: 0 }
    };

    let lines, last;
    this.stringify(this.root, (str, node, type) => {
      this.css += str;

      if (node && type !== 'end') {
        mapping.generated.line = line;
        mapping.generated.column = column - 1;
        if (node.source && node.source.start) {
          mapping.source = this.sourcePath(node);
          mapping.original.line = node.source.start.line;
          mapping.original.column = node.source.start.column - 1;
          this.map.addMapping(mapping);
        } else {
          mapping.source = noSource;
          mapping.original.line = 1;
          mapping.original.column = 0;
          this.map.addMapping(mapping);
        }
      }

      lines = str.match(/\n/g);
      if (lines) {
        line += lines.length;
        last = str.lastIndexOf('\n');
        column = str.length - last;
      } else {
        column += str.length;
      }

      if (node && type !== 'start') {
        let p = node.parent || { raws: {} };
        if (node.type !== 'decl' || node !== p.last || p.raws.semicolon) {
          if (node.source && node.source.end) {
            mapping.source = this.sourcePath(node);
            mapping.original.line = node.source.end.line;
            mapping.original.column = node.source.end.column - 1;
            mapping.generated.line = line;
            mapping.generated.column = column - 2;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            this.map.addMapping(mapping);
          }
        }
      }
    });
  }

  generate() {
    this.clearAnnotation();
    if (pathAvailable && sourceMapAvailable && this.isMap()) {
      return this.generateMap()
    } else {
      let result = '';
      this.stringify(this.root, i => {
        result += i;
      });
      return [result]
    }
  }
}

var mapGenerator = MapGenerator$2;

let Node$3 = node_1;

class Comment$4 extends Node$3 {
  constructor(defaults) {
    super(defaults);
    this.type = 'comment';
  }
}

var comment = Comment$4;
Comment$4.default = Comment$4;

let { isClean: isClean$1, my: my$1 } = symbols;
let Declaration$3 = declaration;
let Comment$3 = comment;
let Node$2 = node_1;

let parse$6, Rule$4, AtRule$4;

function cleanSource(nodes) {
  return nodes.map(i => {
    if (i.nodes) i.nodes = cleanSource(i.nodes);
    delete i.source;
    return i
  })
}

function markDirtyUp(node) {
  node[isClean$1] = false;
  if (node.proxyOf.nodes) {
    for (let i of node.proxyOf.nodes) {
      markDirtyUp(i);
    }
  }
}

class Container$7 extends Node$2 {
  push(child) {
    child.parent = this;
    this.proxyOf.nodes.push(child);
    return this
  }

  each(callback) {
    if (!this.proxyOf.nodes) return undefined
    let iterator = this.getIterator();

    let index, result;
    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
      index = this.indexes[iterator];
      result = callback(this.proxyOf.nodes[index], index);
      if (result === false) break

      this.indexes[iterator] += 1;
    }

    delete this.indexes[iterator];
    return result
  }

  walk(callback) {
    return this.each((child, i) => {
      let result;
      try {
        result = callback(child, i);
      } catch (e) {
        throw child.addToError(e)
      }
      if (result !== false && child.walk) {
        result = child.walk(callback);
      }

      return result
    })
  }

  walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk((child, i) => {
        if (child.type === 'decl') {
          return callback(child, i)
        }
      })
    }
    if (prop instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'decl' && prop.test(child.prop)) {
          return callback(child, i)
        }
      })
    }
    return this.walk((child, i) => {
      if (child.type === 'decl' && child.prop === prop) {
        return callback(child, i)
      }
    })
  }

  walkRules(selector, callback) {
    if (!callback) {
      callback = selector;

      return this.walk((child, i) => {
        if (child.type === 'rule') {
          return callback(child, i)
        }
      })
    }
    if (selector instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'rule' && selector.test(child.selector)) {
          return callback(child, i)
        }
      })
    }
    return this.walk((child, i) => {
      if (child.type === 'rule' && child.selector === selector) {
        return callback(child, i)
      }
    })
  }

  walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk((child, i) => {
        if (child.type === 'atrule') {
          return callback(child, i)
        }
      })
    }
    if (name instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'atrule' && name.test(child.name)) {
          return callback(child, i)
        }
      })
    }
    return this.walk((child, i) => {
      if (child.type === 'atrule' && child.name === name) {
        return callback(child, i)
      }
    })
  }

  walkComments(callback) {
    return this.walk((child, i) => {
      if (child.type === 'comment') {
        return callback(child, i)
      }
    })
  }

  append(...children) {
    for (let child of children) {
      let nodes = this.normalize(child, this.last);
      for (let node of nodes) this.proxyOf.nodes.push(node);
    }

    this.markDirty();

    return this
  }

  prepend(...children) {
    children = children.reverse();
    for (let child of children) {
      let nodes = this.normalize(child, this.first, 'prepend').reverse();
      for (let node of nodes) this.proxyOf.nodes.unshift(node);
      for (let id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }

    this.markDirty();

    return this
  }

  cleanRaws(keepBetween) {
    super.cleanRaws(keepBetween);
    if (this.nodes) {
      for (let node of this.nodes) node.cleanRaws(keepBetween);
    }
  }

  insertBefore(exist, add) {
    exist = this.index(exist);

    let type = exist === 0 ? 'prepend' : false;
    let nodes = this.normalize(add, this.proxyOf.nodes[exist], type).reverse();
    for (let node of nodes) this.proxyOf.nodes.splice(exist, 0, node);

    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (exist <= index) {
        this.indexes[id] = index + nodes.length;
      }
    }

    this.markDirty();

    return this
  }

  insertAfter(exist, add) {
    exist = this.index(exist);

    let nodes = this.normalize(add, this.proxyOf.nodes[exist]).reverse();
    for (let node of nodes) this.proxyOf.nodes.splice(exist + 1, 0, node);

    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (exist < index) {
        this.indexes[id] = index + nodes.length;
      }
    }

    this.markDirty();

    return this
  }

  removeChild(child) {
    child = this.index(child);
    this.proxyOf.nodes[child].parent = undefined;
    this.proxyOf.nodes.splice(child, 1);

    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (index >= child) {
        this.indexes[id] = index - 1;
      }
    }

    this.markDirty();

    return this
  }

  removeAll() {
    for (let node of this.proxyOf.nodes) node.parent = undefined;
    this.proxyOf.nodes = [];

    this.markDirty();

    return this
  }

  replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }

    this.walkDecls(decl => {
      if (opts.props && !opts.props.includes(decl.prop)) return
      if (opts.fast && !decl.value.includes(opts.fast)) return

      decl.value = decl.value.replace(pattern, callback);
    });

    this.markDirty();

    return this
  }

  every(condition) {
    return this.nodes.every(condition)
  }

  some(condition) {
    return this.nodes.some(condition)
  }

  index(child) {
    if (typeof child === 'number') return child
    if (child.proxyOf) child = child.proxyOf;
    return this.proxyOf.nodes.indexOf(child)
  }

  get first() {
    if (!this.proxyOf.nodes) return undefined
    return this.proxyOf.nodes[0]
  }

  get last() {
    if (!this.proxyOf.nodes) return undefined
    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1]
  }

  normalize(nodes, sample) {
    if (typeof nodes === 'string') {
      nodes = cleanSource(parse$6(nodes).nodes);
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);
      for (let i of nodes) {
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type === 'root' && this.type !== 'document') {
      nodes = nodes.nodes.slice(0);
      for (let i of nodes) {
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === 'undefined') {
        throw new Error('Value field is missed in node creation')
      } else if (typeof nodes.value !== 'string') {
        nodes.value = String(nodes.value);
      }
      nodes = [new Declaration$3(nodes)];
    } else if (nodes.selector) {
      nodes = [new Rule$4(nodes)];
    } else if (nodes.name) {
      nodes = [new AtRule$4(nodes)];
    } else if (nodes.text) {
      nodes = [new Comment$3(nodes)];
    } else {
      throw new Error('Unknown node type in node creation')
    }

    let processed = nodes.map(i => {
      /* c8 ignore next */
      if (!i[my$1]) Container$7.rebuild(i);
      i = i.proxyOf;
      if (i.parent) i.parent.removeChild(i);
      if (i[isClean$1]) markDirtyUp(i);
      if (typeof i.raws.before === 'undefined') {
        if (sample && typeof sample.raws.before !== 'undefined') {
          i.raws.before = sample.raws.before.replace(/\S/g, '');
        }
      }
      i.parent = this.proxyOf;
      return i
    });

    return processed
  }

  getProxyProcessor() {
    return {
      set(node, prop, value) {
        if (node[prop] === value) return true
        node[prop] = value;
        if (prop === 'name' || prop === 'params' || prop === 'selector') {
          node.markDirty();
        }
        return true
      },

      get(node, prop) {
        if (prop === 'proxyOf') {
          return node
        } else if (!node[prop]) {
          return node[prop]
        } else if (
          prop === 'each' ||
          (typeof prop === 'string' && prop.startsWith('walk'))
        ) {
          return (...args) => {
            return node[prop](
              ...args.map(i => {
                if (typeof i === 'function') {
                  return (child, index) => i(child.toProxy(), index)
                } else {
                  return i
                }
              })
            )
          }
        } else if (prop === 'every' || prop === 'some') {
          return cb => {
            return node[prop]((child, ...other) =>
              cb(child.toProxy(), ...other)
            )
          }
        } else if (prop === 'root') {
          return () => node.root().toProxy()
        } else if (prop === 'nodes') {
          return node.nodes.map(i => i.toProxy())
        } else if (prop === 'first' || prop === 'last') {
          return node[prop].toProxy()
        } else {
          return node[prop]
        }
      }
    }
  }

  getIterator() {
    if (!this.lastEach) this.lastEach = 0;
    if (!this.indexes) this.indexes = {};

    this.lastEach += 1;
    let iterator = this.lastEach;
    this.indexes[iterator] = 0;

    return iterator
  }
}

Container$7.registerParse = dependant => {
  parse$6 = dependant;
};

Container$7.registerRule = dependant => {
  Rule$4 = dependant;
};

Container$7.registerAtRule = dependant => {
  AtRule$4 = dependant;
};

var container = Container$7;
Container$7.default = Container$7;

/* c8 ignore start */
Container$7.rebuild = node => {
  if (node.type === 'atrule') {
    Object.setPrototypeOf(node, AtRule$4.prototype);
  } else if (node.type === 'rule') {
    Object.setPrototypeOf(node, Rule$4.prototype);
  } else if (node.type === 'decl') {
    Object.setPrototypeOf(node, Declaration$3.prototype);
  } else if (node.type === 'comment') {
    Object.setPrototypeOf(node, Comment$3.prototype);
  }

  node[my$1] = true;

  if (node.nodes) {
    node.nodes.forEach(child => {
      Container$7.rebuild(child);
    });
  }
};

let Container$6 = container;

let LazyResult$4, Processor$3;

class Document$3 extends Container$6 {
  constructor(defaults) {
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    super({ type: 'document', ...defaults });

    if (!this.nodes) {
      this.nodes = [];
    }
  }

  toResult(opts = {}) {
    let lazy = new LazyResult$4(new Processor$3(), this, opts);

    return lazy.stringify()
  }
}

Document$3.registerLazyResult = dependant => {
  LazyResult$4 = dependant;
};

Document$3.registerProcessor = dependant => {
  Processor$3 = dependant;
};

var document$1 = Document$3;
Document$3.default = Document$3;

/* eslint-disable no-console */

let printed = {};

var warnOnce$2 = function warnOnce(message) {
  if (printed[message]) return
  printed[message] = true;

  if (typeof console !== 'undefined' && console.warn) {
    console.warn(message);
  }
};

class Warning$2 {
  constructor(text, opts = {}) {
    this.type = 'warning';
    this.text = text;

    if (opts.node && opts.node.source) {
      let range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }

    for (let opt in opts) this[opt] = opts[opt];
  }

  toString() {
    if (this.node) {
      return this.node.error(this.text, {
        plugin: this.plugin,
        index: this.index,
        word: this.word
      }).message
    }

    if (this.plugin) {
      return this.plugin + ': ' + this.text
    }

    return this.text
  }
}

var warning$4 = Warning$2;
Warning$2.default = Warning$2;

let Warning$1 = warning$4;

class Result$3 {
  constructor(processor, root, opts) {
    this.processor = processor;
    this.messages = [];
    this.root = root;
    this.opts = opts;
    this.css = undefined;
    this.map = undefined;
  }

  toString() {
    return this.css
  }

  warn(text, opts = {}) {
    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }

    let warning = new Warning$1(text, opts);
    this.messages.push(warning);

    return warning
  }

  warnings() {
    return this.messages.filter(i => i.type === 'warning')
  }

  get content() {
    return this.css
  }
}

var result = Result$3;
Result$3.default = Result$3;

let Container$5 = container;

class AtRule$3 extends Container$5 {
  constructor(defaults) {
    super(defaults);
    this.type = 'atrule';
  }

  append(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...children)
  }

  prepend(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...children)
  }
}

var atRule = AtRule$3;
AtRule$3.default = AtRule$3;

Container$5.registerAtRule(AtRule$3);

let Container$4 = container;

let LazyResult$3, Processor$2;

class Root$7 extends Container$4 {
  constructor(defaults) {
    super(defaults);
    this.type = 'root';
    if (!this.nodes) this.nodes = [];
  }

  removeChild(child, ignore) {
    let index = this.index(child);

    if (!ignore && index === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index].raws.before;
    }

    return super.removeChild(child)
  }

  normalize(child, sample, type) {
    let nodes = super.normalize(child);

    if (sample) {
      if (type === 'prepend') {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (let node of nodes) {
          node.raws.before = sample.raws.before;
        }
      }
    }

    return nodes
  }

  toResult(opts = {}) {
    let lazy = new LazyResult$3(new Processor$2(), this, opts);
    return lazy.stringify()
  }
}

Root$7.registerLazyResult = dependant => {
  LazyResult$3 = dependant;
};

Root$7.registerProcessor = dependant => {
  Processor$2 = dependant;
};

var root$3 = Root$7;
Root$7.default = Root$7;

let list$2 = {
  split(string, separators, last) {
    let array = [];
    let current = '';
    let split = false;

    let func = 0;
    let quote = false;
    let escape = false;

    for (let letter of string) {
      if (escape) {
        escape = false;
      } else if (letter === '\\') {
        escape = true;
      } else if (quote) {
        if (letter === quote) {
          quote = false;
        }
      } else if (letter === '"' || letter === "'") {
        quote = letter;
      } else if (letter === '(') {
        func += 1;
      } else if (letter === ')') {
        if (func > 0) func -= 1;
      } else if (func === 0) {
        if (separators.includes(letter)) split = true;
      }

      if (split) {
        if (current !== '') array.push(current.trim());
        current = '';
        split = false;
      } else {
        current += letter;
      }
    }

    if (last || current !== '') array.push(current.trim());
    return array
  },

  space(string) {
    let spaces = [' ', '\n', '\t'];
    return list$2.split(string, spaces)
  },

  comma(string) {
    return list$2.split(string, [','], true)
  }
};

var list_1 = list$2;
list$2.default = list$2;

let Container$3 = container;
let list$1 = list_1;

class Rule$3 extends Container$3 {
  constructor(defaults) {
    super(defaults);
    this.type = 'rule';
    if (!this.nodes) this.nodes = [];
  }

  get selectors() {
    return list$1.comma(this.selector)
  }

  set selectors(values) {
    let match = this.selector ? this.selector.match(/,\s*/) : null;
    let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
    this.selector = values.join(sep);
  }
}

var rule = Rule$3;
Rule$3.default = Rule$3;

Container$3.registerRule(Rule$3);

let Declaration$2 = declaration;
let tokenizer = tokenize;
let Comment$2 = comment;
let AtRule$2 = atRule;
let Root$6 = root$3;
let Rule$2 = rule;

const SAFE_COMMENT_NEIGHBOR = {
  empty: true,
  space: true
};

function findLastWithPosition(tokens) {
  for (let i = tokens.length - 1; i >= 0; i--) {
    let token = tokens[i];
    let pos = token[3] || token[2];
    if (pos) return pos
  }
}

class Parser$1 {
  constructor(input) {
    this.input = input;

    this.root = new Root$6();
    this.current = this.root;
    this.spaces = '';
    this.semicolon = false;
    this.customProperty = false;

    this.createTokenizer();
    this.root.source = { input, start: { offset: 0, line: 1, column: 1 } };
  }

  createTokenizer() {
    this.tokenizer = tokenizer(this.input);
  }

  parse() {
    let token;
    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();

      switch (token[0]) {
        case 'space':
          this.spaces += token[1];
          break

        case ';':
          this.freeSemicolon(token);
          break

        case '}':
          this.end(token);
          break

        case 'comment':
          this.comment(token);
          break

        case 'at-word':
          this.atrule(token);
          break

        case '{':
          this.emptyRule(token);
          break

        default:
          this.other(token);
          break
      }
    }
    this.endFile();
  }

  comment(token) {
    let node = new Comment$2();
    this.init(node, token[2]);
    node.source.end = this.getPosition(token[3] || token[2]);

    let text = token[1].slice(2, -2);
    if (/^\s*$/.test(text)) {
      node.text = '';
      node.raws.left = text;
      node.raws.right = '';
    } else {
      let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
      node.text = match[2];
      node.raws.left = match[1];
      node.raws.right = match[3];
    }
  }

  emptyRule(token) {
    let node = new Rule$2();
    this.init(node, token[2]);
    node.selector = '';
    node.raws.between = '';
    this.current = node;
  }

  other(start) {
    let end = false;
    let type = null;
    let colon = false;
    let bracket = null;
    let brackets = [];
    let customProperty = start[1].startsWith('--');

    let tokens = [];
    let token = start;
    while (token) {
      type = token[0];
      tokens.push(token);

      if (type === '(' || type === '[') {
        if (!bracket) bracket = token;
        brackets.push(type === '(' ? ')' : ']');
      } else if (customProperty && colon && type === '{') {
        if (!bracket) bracket = token;
        brackets.push('}');
      } else if (brackets.length === 0) {
        if (type === ';') {
          if (colon) {
            this.decl(tokens, customProperty);
            return
          } else {
            break
          }
        } else if (type === '{') {
          this.rule(tokens);
          return
        } else if (type === '}') {
          this.tokenizer.back(tokens.pop());
          end = true;
          break
        } else if (type === ':') {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0) bracket = null;
      }

      token = this.tokenizer.nextToken();
    }

    if (this.tokenizer.endOfFile()) end = true;
    if (brackets.length > 0) this.unclosedBracket(bracket);

    if (end && colon) {
      if (!customProperty) {
        while (tokens.length) {
          token = tokens[tokens.length - 1][0];
          if (token !== 'space' && token !== 'comment') break
          this.tokenizer.back(tokens.pop());
        }
      }
      this.decl(tokens, customProperty);
    } else {
      this.unknownWord(tokens);
    }
  }

  rule(tokens) {
    tokens.pop();

    let node = new Rule$2();
    this.init(node, tokens[0][2]);

    node.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node, 'selector', tokens);
    this.current = node;
  }

  decl(tokens, customProperty) {
    let node = new Declaration$2();
    this.init(node, tokens[0][2]);

    let last = tokens[tokens.length - 1];
    if (last[0] === ';') {
      this.semicolon = true;
      tokens.pop();
    }

    node.source.end = this.getPosition(
      last[3] || last[2] || findLastWithPosition(tokens)
    );

    while (tokens[0][0] !== 'word') {
      if (tokens.length === 1) this.unknownWord(tokens);
      node.raws.before += tokens.shift()[1];
    }
    node.source.start = this.getPosition(tokens[0][2]);

    node.prop = '';
    while (tokens.length) {
      let type = tokens[0][0];
      if (type === ':' || type === 'space' || type === 'comment') {
        break
      }
      node.prop += tokens.shift()[1];
    }

    node.raws.between = '';

    let token;
    while (tokens.length) {
      token = tokens.shift();

      if (token[0] === ':') {
        node.raws.between += token[1];
        break
      } else {
        if (token[0] === 'word' && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }
        node.raws.between += token[1];
      }
    }

    if (node.prop[0] === '_' || node.prop[0] === '*') {
      node.raws.before += node.prop[0];
      node.prop = node.prop.slice(1);
    }

    let firstSpaces = [];
    let next;
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break
      firstSpaces.push(tokens.shift());
    }

    this.precheckMissedSemicolon(tokens);

    for (let i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];
      if (token[1].toLowerCase() === '!important') {
        node.important = true;
        let string = this.stringFrom(tokens, i);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== ' !important') node.raws.important = string;
        break
      } else if (token[1].toLowerCase() === 'important') {
        let cache = tokens.slice(0);
        let str = '';
        for (let j = i; j > 0; j--) {
          let type = cache[j][0];
          if (str.trim().indexOf('!') === 0 && type !== 'space') {
            break
          }
          str = cache.pop()[1] + str;
        }
        if (str.trim().indexOf('!') === 0) {
          node.important = true;
          node.raws.important = str;
          tokens = cache;
        }
      }

      if (token[0] !== 'space' && token[0] !== 'comment') {
        break
      }
    }

    let hasWord = tokens.some(i => i[0] !== 'space' && i[0] !== 'comment');

    if (hasWord) {
      node.raws.between += firstSpaces.map(i => i[1]).join('');
      firstSpaces = [];
    }
    this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);

    if (node.value.includes(':') && !customProperty) {
      this.checkMissedSemicolon(tokens);
    }
  }

  atrule(token) {
    let node = new AtRule$2();
    node.name = token[1].slice(1);
    if (node.name === '') {
      this.unnamedAtrule(node, token);
    }
    this.init(node, token[2]);

    let type;
    let prev;
    let shift;
    let last = false;
    let open = false;
    let params = [];
    let brackets = [];

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      type = token[0];

      if (type === '(' || type === '[') {
        brackets.push(type === '(' ? ')' : ']');
      } else if (type === '{' && brackets.length > 0) {
        brackets.push('}');
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
      }

      if (brackets.length === 0) {
        if (type === ';') {
          node.source.end = this.getPosition(token[2]);
          this.semicolon = true;
          break
        } else if (type === '{') {
          open = true;
          break
        } else if (type === '}') {
          if (params.length > 0) {
            shift = params.length - 1;
            prev = params[shift];
            while (prev && prev[0] === 'space') {
              prev = params[--shift];
            }
            if (prev) {
              node.source.end = this.getPosition(prev[3] || prev[2]);
            }
          }
          this.end(token);
          break
        } else {
          params.push(token);
        }
      } else {
        params.push(token);
      }

      if (this.tokenizer.endOfFile()) {
        last = true;
        break
      }
    }

    node.raws.between = this.spacesAndCommentsFromEnd(params);
    if (params.length) {
      node.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node, 'params', params);
      if (last) {
        token = params[params.length - 1];
        node.source.end = this.getPosition(token[3] || token[2]);
        this.spaces = node.raws.between;
        node.raws.between = '';
      }
    } else {
      node.raws.afterName = '';
      node.params = '';
    }

    if (open) {
      node.nodes = [];
      this.current = node;
    }
  }

  end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.semicolon = false;

    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
    this.spaces = '';

    if (this.current.parent) {
      this.current.source.end = this.getPosition(token[2]);
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  }

  endFile() {
    if (this.current.parent) this.unclosedBlock();
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
  }

  freeSemicolon(token) {
    this.spaces += token[1];
    if (this.current.nodes) {
      let prev = this.current.nodes[this.current.nodes.length - 1];
      if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = '';
      }
    }
  }

  // Helpers

  getPosition(offset) {
    let pos = this.input.fromOffset(offset);
    return {
      offset,
      line: pos.line,
      column: pos.col
    }
  }

  init(node, offset) {
    this.current.push(node);
    node.source = {
      start: this.getPosition(offset),
      input: this.input
    };
    node.raws.before = this.spaces;
    this.spaces = '';
    if (node.type !== 'comment') this.semicolon = false;
  }

  raw(node, prop, tokens, customProperty) {
    let token, type;
    let length = tokens.length;
    let value = '';
    let clean = true;
    let next, prev;

    for (let i = 0; i < length; i += 1) {
      token = tokens[i];
      type = token[0];
      if (type === 'space' && i === length - 1 && !customProperty) {
        clean = false;
      } else if (type === 'comment') {
        prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
        next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
          if (value.slice(-1) === ',') {
            clean = false;
          } else {
            value += token[1];
          }
        } else {
          clean = false;
        }
      } else {
        value += token[1];
      }
    }
    if (!clean) {
      let raw = tokens.reduce((all, i) => all + i[1], '');
      node.raws[prop] = { value, raw };
    }
    node[prop] = value;
  }

  spacesAndCommentsFromEnd(tokens) {
    let lastTokenType;
    let spaces = '';
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space' && lastTokenType !== 'comment') break
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces
  }

  spacesAndCommentsFromStart(tokens) {
    let next;
    let spaces = '';
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break
      spaces += tokens.shift()[1];
    }
    return spaces
  }

  spacesFromEnd(tokens) {
    let lastTokenType;
    let spaces = '';
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space') break
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces
  }

  stringFrom(tokens, from) {
    let result = '';
    for (let i = from; i < tokens.length; i++) {
      result += tokens[i][1];
    }
    tokens.splice(from, tokens.length - from);
    return result
  }

  colon(tokens) {
    let brackets = 0;
    let token, type, prev;
    for (let [i, element] of tokens.entries()) {
      token = element;
      type = token[0];

      if (type === '(') {
        brackets += 1;
      }
      if (type === ')') {
        brackets -= 1;
      }
      if (brackets === 0 && type === ':') {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === 'word' && prev[1] === 'progid') {
          continue
        } else {
          return i
        }
      }

      prev = token;
    }
    return false
  }

  // Errors

  unclosedBracket(bracket) {
    throw this.input.error(
      'Unclosed bracket',
      { offset: bracket[2] },
      { offset: bracket[2] + 1 }
    )
  }

  unknownWord(tokens) {
    throw this.input.error(
      'Unknown word',
      { offset: tokens[0][2] },
      { offset: tokens[0][2] + tokens[0][1].length }
    )
  }

  unexpectedClose(token) {
    throw this.input.error(
      'Unexpected }',
      { offset: token[2] },
      { offset: token[2] + 1 }
    )
  }

  unclosedBlock() {
    let pos = this.current.source.start;
    throw this.input.error('Unclosed block', pos.line, pos.column)
  }

  doubleColon(token) {
    throw this.input.error(
      'Double colon',
      { offset: token[2] },
      { offset: token[2] + token[1].length }
    )
  }

  unnamedAtrule(node, token) {
    throw this.input.error(
      'At-rule without name',
      { offset: token[2] },
      { offset: token[2] + token[1].length }
    )
  }

  precheckMissedSemicolon(/* tokens */) {
    // Hook for Safe Parser
  }

  checkMissedSemicolon(tokens) {
    let colon = this.colon(tokens);
    if (colon === false) return

    let founded = 0;
    let token;
    for (let j = colon - 1; j >= 0; j--) {
      token = tokens[j];
      if (token[0] !== 'space') {
        founded += 1;
        if (founded === 2) break
      }
    }
    // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
    // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
    // And because we need it after that one we do +1 to get the next one.
    throw this.input.error(
      'Missed semicolon',
      token[0] === 'word' ? token[3] + 1 : token[2]
    )
  }
}

var parser = Parser$1;

let Container$2 = container;
let Parser = parser;
let Input$2 = input;

function parse$5(css, opts) {
  let input = new Input$2(css, opts);
  let parser = new Parser(input);
  try {
    parser.parse();
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      if (e.name === 'CssSyntaxError' && opts && opts.from) {
        if (/\.scss$/i.test(opts.from)) {
          e.message +=
            '\nYou tried to parse SCSS with ' +
            'the standard CSS parser; ' +
            'try again with the postcss-scss parser';
        } else if (/\.sass/i.test(opts.from)) {
          e.message +=
            '\nYou tried to parse Sass with ' +
            'the standard CSS parser; ' +
            'try again with the postcss-sass parser';
        } else if (/\.less$/i.test(opts.from)) {
          e.message +=
            '\nYou tried to parse Less with ' +
            'the standard CSS parser; ' +
            'try again with the postcss-less parser';
        }
      }
    }
    throw e
  }

  return parser.root
}

var parse_1 = parse$5;
parse$5.default = parse$5;

Container$2.registerParse(parse$5);

let { isClean, my } = symbols;
let MapGenerator$1 = mapGenerator;
let stringify$2 = stringify_1;
let Container$1 = container;
let Document$2 = document$1;
let warnOnce$1 = warnOnce$2;
let Result$2 = result;
let parse$4 = parse_1;
let Root$5 = root$3;

const TYPE_TO_CLASS_NAME = {
  document: 'Document',
  root: 'Root',
  atrule: 'AtRule',
  rule: 'Rule',
  decl: 'Declaration',
  comment: 'Comment'
};

const PLUGIN_PROPS = {
  postcssPlugin: true,
  prepare: true,
  Once: true,
  Document: true,
  Root: true,
  Declaration: true,
  Rule: true,
  AtRule: true,
  Comment: true,
  DeclarationExit: true,
  RuleExit: true,
  AtRuleExit: true,
  CommentExit: true,
  RootExit: true,
  DocumentExit: true,
  OnceExit: true
};

const NOT_VISITORS = {
  postcssPlugin: true,
  prepare: true,
  Once: true
};

const CHILDREN = 0;

function isPromise(obj) {
  return typeof obj === 'object' && typeof obj.then === 'function'
}

function getEvents(node) {
  let key = false;
  let type = TYPE_TO_CLASS_NAME[node.type];
  if (node.type === 'decl') {
    key = node.prop.toLowerCase();
  } else if (node.type === 'atrule') {
    key = node.name.toLowerCase();
  }

  if (key && node.append) {
    return [
      type,
      type + '-' + key,
      CHILDREN,
      type + 'Exit',
      type + 'Exit-' + key
    ]
  } else if (key) {
    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key]
  } else if (node.append) {
    return [type, CHILDREN, type + 'Exit']
  } else {
    return [type, type + 'Exit']
  }
}

function toStack(node) {
  let events;
  if (node.type === 'document') {
    events = ['Document', CHILDREN, 'DocumentExit'];
  } else if (node.type === 'root') {
    events = ['Root', CHILDREN, 'RootExit'];
  } else {
    events = getEvents(node);
  }

  return {
    node,
    events,
    eventIndex: 0,
    visitors: [],
    visitorIndex: 0,
    iterator: 0
  }
}

function cleanMarks(node) {
  node[isClean] = false;
  if (node.nodes) node.nodes.forEach(i => cleanMarks(i));
  return node
}

let postcss$1 = {};

class LazyResult$2 {
  constructor(processor, css, opts) {
    this.stringified = false;
    this.processed = false;

    let root;
    if (
      typeof css === 'object' &&
      css !== null &&
      (css.type === 'root' || css.type === 'document')
    ) {
      root = cleanMarks(css);
    } else if (css instanceof LazyResult$2 || css instanceof Result$2) {
      root = cleanMarks(css.root);
      if (css.map) {
        if (typeof opts.map === 'undefined') opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      let parser = parse$4;
      if (opts.syntax) parser = opts.syntax.parse;
      if (opts.parser) parser = opts.parser;
      if (parser.parse) parser = parser.parse;

      try {
        root = parser(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }

      if (root && !root[my]) {
        /* c8 ignore next 2 */
        Container$1.rebuild(root);
      }
    }

    this.result = new Result$2(processor, root, opts);
    this.helpers = { ...postcss$1, result: this.result, postcss: postcss$1 };
    this.plugins = this.processor.plugins.map(plugin => {
      if (typeof plugin === 'object' && plugin.prepare) {
        return { ...plugin, ...plugin.prepare(this.result) }
      } else {
        return plugin
      }
    });
  }

  get [Symbol.toStringTag]() {
    return 'LazyResult'
  }

  get processor() {
    return this.result.processor
  }

  get opts() {
    return this.result.opts
  }

  get css() {
    return this.stringify().css
  }

  get content() {
    return this.stringify().content
  }

  get map() {
    return this.stringify().map
  }

  get root() {
    return this.sync().root
  }

  get messages() {
    return this.sync().messages
  }

  warnings() {
    return this.sync().warnings()
  }

  toString() {
    return this.css
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== 'production') {
      if (!('from' in this.opts)) {
        warnOnce$1(
          'Without `from` option PostCSS could generate wrong source map ' +
            'and will not find Browserslist config. Set it to CSS file path ' +
            'or to `undefined` to prevent this warning.'
        );
      }
    }
    return this.async().then(onFulfilled, onRejected)
  }

  catch(onRejected) {
    return this.async().catch(onRejected)
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally)
  }

  async() {
    if (this.error) return Promise.reject(this.error)
    if (this.processed) return Promise.resolve(this.result)
    if (!this.processing) {
      this.processing = this.runAsync();
    }
    return this.processing
  }

  sync() {
    if (this.error) throw this.error
    if (this.processed) return this.result
    this.processed = true;

    if (this.processing) {
      throw this.getAsyncError()
    }

    for (let plugin of this.plugins) {
      let promise = this.runOnRoot(plugin);
      if (isPromise(promise)) {
        throw this.getAsyncError()
      }
    }

    this.prepareVisitors();
    if (this.hasListener) {
      let root = this.result.root;
      while (!root[isClean]) {
        root[isClean] = true;
        this.walkSync(root);
      }
      if (this.listeners.OnceExit) {
        if (root.type === 'document') {
          for (let subRoot of root.nodes) {
            this.visitSync(this.listeners.OnceExit, subRoot);
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root);
        }
      }
    }

    return this.result
  }

  stringify() {
    if (this.error) throw this.error
    if (this.stringified) return this.result
    this.stringified = true;

    this.sync();

    let opts = this.result.opts;
    let str = stringify$2;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;

    let map = new MapGenerator$1(str, this.result.root, this.result.opts);
    let data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];

    return this.result
  }

  walkSync(node) {
    node[isClean] = true;
    let events = getEvents(node);
    for (let event of events) {
      if (event === CHILDREN) {
        if (node.nodes) {
          node.each(child => {
            if (!child[isClean]) this.walkSync(child);
          });
        }
      } else {
        let visitors = this.listeners[event];
        if (visitors) {
          if (this.visitSync(visitors, node.toProxy())) return
        }
      }
    }
  }

  visitSync(visitors, node) {
    for (let [plugin, visitor] of visitors) {
      this.result.lastPlugin = plugin;
      let promise;
      try {
        promise = visitor(node, this.helpers);
      } catch (e) {
        throw this.handleError(e, node.proxyOf)
      }
      if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
        return true
      }
      if (isPromise(promise)) {
        throw this.getAsyncError()
      }
    }
  }

  runOnRoot(plugin) {
    this.result.lastPlugin = plugin;
    try {
      if (typeof plugin === 'object' && plugin.Once) {
        if (this.result.root.type === 'document') {
          let roots = this.result.root.nodes.map(root =>
            plugin.Once(root, this.helpers)
          );

          if (isPromise(roots[0])) {
            return Promise.all(roots)
          }

          return roots
        }

        return plugin.Once(this.result.root, this.helpers)
      } else if (typeof plugin === 'function') {
        return plugin(this.result.root, this.result)
      }
    } catch (error) {
      throw this.handleError(error)
    }
  }

  getAsyncError() {
    throw new Error('Use process(css).then(cb) to work with async plugins')
  }

  handleError(error, node) {
    let plugin = this.result.lastPlugin;
    try {
      if (node) node.addToError(error);
      this.error = error;
      if (error.name === 'CssSyntaxError' && !error.plugin) {
        error.plugin = plugin.postcssPlugin;
        error.setMessage();
      } else if (plugin.postcssVersion) {
        if (process.env.NODE_ENV !== 'production') {
          let pluginName = plugin.postcssPlugin;
          let pluginVer = plugin.postcssVersion;
          let runtimeVer = this.result.processor.version;
          let a = pluginVer.split('.');
          let b = runtimeVer.split('.');

          if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
            // eslint-disable-next-line no-console
            console.error(
              'Unknown error from PostCSS plugin. Your current PostCSS ' +
                'version is ' +
                runtimeVer +
                ', but ' +
                pluginName +
                ' uses ' +
                pluginVer +
                '. Perhaps this is the source of the error below.'
            );
          }
        }
      }
    } catch (err) {
      /* c8 ignore next 3 */
      // eslint-disable-next-line no-console
      if (console && console.error) console.error(err);
    }
    return error
  }

  async runAsync() {
    this.plugin = 0;
    for (let i = 0; i < this.plugins.length; i++) {
      let plugin = this.plugins[i];
      let promise = this.runOnRoot(plugin);
      if (isPromise(promise)) {
        try {
          await promise;
        } catch (error) {
          throw this.handleError(error)
        }
      }
    }

    this.prepareVisitors();
    if (this.hasListener) {
      let root = this.result.root;
      while (!root[isClean]) {
        root[isClean] = true;
        let stack = [toStack(root)];
        while (stack.length > 0) {
          let promise = this.visitTick(stack);
          if (isPromise(promise)) {
            try {
              await promise;
            } catch (e) {
              let node = stack[stack.length - 1].node;
              throw this.handleError(e, node)
            }
          }
        }
      }

      if (this.listeners.OnceExit) {
        for (let [plugin, visitor] of this.listeners.OnceExit) {
          this.result.lastPlugin = plugin;
          try {
            if (root.type === 'document') {
              let roots = root.nodes.map(subRoot =>
                visitor(subRoot, this.helpers)
              );

              await Promise.all(roots);
            } else {
              await visitor(root, this.helpers);
            }
          } catch (e) {
            throw this.handleError(e)
          }
        }
      }
    }

    this.processed = true;
    return this.stringify()
  }

  prepareVisitors() {
    this.listeners = {};
    let add = (plugin, type, cb) => {
      if (!this.listeners[type]) this.listeners[type] = [];
      this.listeners[type].push([plugin, cb]);
    };
    for (let plugin of this.plugins) {
      if (typeof plugin === 'object') {
        for (let event in plugin) {
          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
            throw new Error(
              `Unknown event ${event} in ${plugin.postcssPlugin}. ` +
                `Try to update PostCSS (${this.processor.version} now).`
            )
          }
          if (!NOT_VISITORS[event]) {
            if (typeof plugin[event] === 'object') {
              for (let filter in plugin[event]) {
                if (filter === '*') {
                  add(plugin, event, plugin[event][filter]);
                } else {
                  add(
                    plugin,
                    event + '-' + filter.toLowerCase(),
                    plugin[event][filter]
                  );
                }
              }
            } else if (typeof plugin[event] === 'function') {
              add(plugin, event, plugin[event]);
            }
          }
        }
      }
    }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }

  visitTick(stack) {
    let visit = stack[stack.length - 1];
    let { node, visitors } = visit;

    if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
      stack.pop();
      return
    }

    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
      let [plugin, visitor] = visitors[visit.visitorIndex];
      visit.visitorIndex += 1;
      if (visit.visitorIndex === visitors.length) {
        visit.visitors = [];
        visit.visitorIndex = 0;
      }
      this.result.lastPlugin = plugin;
      try {
        return visitor(node.toProxy(), this.helpers)
      } catch (e) {
        throw this.handleError(e, node)
      }
    }

    if (visit.iterator !== 0) {
      let iterator = visit.iterator;
      let child;
      while ((child = node.nodes[node.indexes[iterator]])) {
        node.indexes[iterator] += 1;
        if (!child[isClean]) {
          child[isClean] = true;
          stack.push(toStack(child));
          return
        }
      }
      visit.iterator = 0;
      delete node.indexes[iterator];
    }

    let events = visit.events;
    while (visit.eventIndex < events.length) {
      let event = events[visit.eventIndex];
      visit.eventIndex += 1;
      if (event === CHILDREN) {
        if (node.nodes && node.nodes.length) {
          node[isClean] = true;
          visit.iterator = node.getIterator();
        }
        return
      } else if (this.listeners[event]) {
        visit.visitors = this.listeners[event];
        return
      }
    }
    stack.pop();
  }
}

LazyResult$2.registerPostcss = dependant => {
  postcss$1 = dependant;
};

var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;

Root$5.registerLazyResult(LazyResult$2);
Document$2.registerLazyResult(LazyResult$2);

let MapGenerator = mapGenerator;
let stringify$1 = stringify_1;
let warnOnce = warnOnce$2;
let parse$3 = parse_1;
const Result$1 = result;

class NoWorkResult$1 {
  constructor(processor, css, opts) {
    css = css.toString();
    this.stringified = false;

    this._processor = processor;
    this._css = css;
    this._opts = opts;
    this._map = undefined;
    let root;

    let str = stringify$1;
    this.result = new Result$1(this._processor, root, this._opts);
    this.result.css = css;

    let self = this;
    Object.defineProperty(this.result, 'root', {
      get() {
        return self.root
      }
    });

    let map = new MapGenerator(str, root, this._opts, css);
    if (map.isMap()) {
      let [generatedCSS, generatedMap] = map.generate();
      if (generatedCSS) {
        this.result.css = generatedCSS;
      }
      if (generatedMap) {
        this.result.map = generatedMap;
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'NoWorkResult'
  }

  get processor() {
    return this.result.processor
  }

  get opts() {
    return this.result.opts
  }

  get css() {
    return this.result.css
  }

  get content() {
    return this.result.css
  }

  get map() {
    return this.result.map
  }

  get root() {
    if (this._root) {
      return this._root
    }

    let root;
    let parser = parse$3;

    try {
      root = parser(this._css, this._opts);
    } catch (error) {
      this.error = error;
    }

    if (this.error) {
      throw this.error
    } else {
      this._root = root;
      return root
    }
  }

  get messages() {
    return []
  }

  warnings() {
    return []
  }

  toString() {
    return this._css
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== 'production') {
      if (!('from' in this._opts)) {
        warnOnce(
          'Without `from` option PostCSS could generate wrong source map ' +
            'and will not find Browserslist config. Set it to CSS file path ' +
            'or to `undefined` to prevent this warning.'
        );
      }
    }

    return this.async().then(onFulfilled, onRejected)
  }

  catch(onRejected) {
    return this.async().catch(onRejected)
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally)
  }

  async() {
    if (this.error) return Promise.reject(this.error)
    return Promise.resolve(this.result)
  }

  sync() {
    if (this.error) throw this.error
    return this.result
  }
}

var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;

let NoWorkResult = noWorkResult;
let LazyResult$1 = lazyResult;
let Document$1 = document$1;
let Root$4 = root$3;

class Processor$1 {
  constructor(plugins = []) {
    this.version = '8.4.14';
    this.plugins = this.normalize(plugins);
  }

  use(plugin) {
    this.plugins = this.plugins.concat(this.normalize([plugin]));
    return this
  }

  process(css, opts = {}) {
    if (
      this.plugins.length === 0 &&
      typeof opts.parser === 'undefined' &&
      typeof opts.stringifier === 'undefined' &&
      typeof opts.syntax === 'undefined'
    ) {
      return new NoWorkResult(this, css, opts)
    } else {
      return new LazyResult$1(this, css, opts)
    }
  }

  normalize(plugins) {
    let normalized = [];
    for (let i of plugins) {
      if (i.postcss === true) {
        i = i();
      } else if (i.postcss) {
        i = i.postcss;
      }

      if (typeof i === 'object' && Array.isArray(i.plugins)) {
        normalized = normalized.concat(i.plugins);
      } else if (typeof i === 'object' && i.postcssPlugin) {
        normalized.push(i);
      } else if (typeof i === 'function') {
        normalized.push(i);
      } else if (typeof i === 'object' && (i.parse || i.stringify)) {
        if (process.env.NODE_ENV !== 'production') {
          throw new Error(
            'PostCSS syntaxes cannot be used as plugins. Instead, please use ' +
              'one of the syntax/parser/stringifier options as outlined ' +
              'in your PostCSS runner documentation.'
          )
        }
      } else {
        throw new Error(i + ' is not a PostCSS plugin')
      }
    }
    return normalized
  }
}

var processor = Processor$1;
Processor$1.default = Processor$1;

Root$4.registerProcessor(Processor$1);
Document$1.registerProcessor(Processor$1);

let Declaration$1 = declaration;
let PreviousMap = previousMap;
let Comment$1 = comment;
let AtRule$1 = atRule;
let Input$1 = input;
let Root$3 = root$3;
let Rule$1 = rule;

function fromJSON$1(json, inputs) {
  if (Array.isArray(json)) return json.map(n => fromJSON$1(n))

  let { inputs: ownInputs, ...defaults } = json;
  if (ownInputs) {
    inputs = [];
    for (let input of ownInputs) {
      let inputHydrated = { ...input, __proto__: Input$1.prototype };
      if (inputHydrated.map) {
        inputHydrated.map = {
          ...inputHydrated.map,
          __proto__: PreviousMap.prototype
        };
      }
      inputs.push(inputHydrated);
    }
  }
  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(n => fromJSON$1(n, inputs));
  }
  if (defaults.source) {
    let { inputId, ...source } = defaults.source;
    defaults.source = source;
    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }
  if (defaults.type === 'root') {
    return new Root$3(defaults)
  } else if (defaults.type === 'decl') {
    return new Declaration$1(defaults)
  } else if (defaults.type === 'rule') {
    return new Rule$1(defaults)
  } else if (defaults.type === 'comment') {
    return new Comment$1(defaults)
  } else if (defaults.type === 'atrule') {
    return new AtRule$1(defaults)
  } else {
    throw new Error('Unknown node type: ' + json.type)
  }
}

var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;

let CssSyntaxError = cssSyntaxError;
let Declaration = declaration;
let LazyResult = lazyResult;
let Container = container;
let Processor = processor;
let stringify = stringify_1;
let fromJSON = fromJSON_1;
let Document = document$1;
let Warning = warning$4;
let Comment = comment;
let AtRule = atRule;
let Result = result;
let Input = input;
let parse$2 = parse_1;
let list = list_1;
let Rule = rule;
let Root$2 = root$3;
let Node$1 = node_1;

function postcss(...plugins) {
  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }
  return new Processor(plugins)
}

postcss.plugin = function plugin(name, initializer) {
  let warningPrinted = false;
  function creator(...args) {
    // eslint-disable-next-line no-console
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true;
      // eslint-disable-next-line no-console
      console.warn(
        name +
          ': postcss.plugin was deprecated. Migration guide:\n' +
          'https://evilmartians.com/chronicles/postcss-8-plugin-migration'
      );
      if (process.env.LANG && process.env.LANG.startsWith('cn')) {
        /* c8 ignore next 7 */
        // eslint-disable-next-line no-console
        console.warn(
          name +
            ': 里面 postcss.plugin 被弃用. 迁移指南:\n' +
            'https://www.w3ctech.com/topic/2226'
        );
      }
    }
    let transformer = initializer(...args);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new Processor().version;
    return transformer
  }

  let cache;
  Object.defineProperty(creator, 'postcss', {
    get() {
      if (!cache) cache = creator();
      return cache
    }
  });

  creator.process = function (css, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css, processOpts)
  };

  return creator
};

postcss.stringify = stringify;
postcss.parse = parse$2;
postcss.fromJSON = fromJSON;
postcss.list = list;

postcss.comment = defaults => new Comment(defaults);
postcss.atRule = defaults => new AtRule(defaults);
postcss.decl = defaults => new Declaration(defaults);
postcss.rule = defaults => new Rule(defaults);
postcss.root = defaults => new Root$2(defaults);
postcss.document = defaults => new Document(defaults);

postcss.CssSyntaxError = CssSyntaxError;
postcss.Declaration = Declaration;
postcss.Container = Container;
postcss.Processor = Processor;
postcss.Document = Document;
postcss.Comment = Comment;
postcss.Warning = Warning;
postcss.AtRule = AtRule;
postcss.Result = Result;
postcss.Input = Input;
postcss.Rule = Rule;
postcss.Root = Root$2;
postcss.Node = Node$1;

LazyResult.registerPostcss(postcss);

var postcss_1 = postcss;
postcss.default = postcss;

const htmlparser = lib$5;
const escapeStringRegexp = escapeStringRegexp$1;
const { isPlainObject: isPlainObject$3 } = isPlainObject$5;
const deepmerge = cjs;
const parseSrcset = parseSrcset$1.exports;
const { parse: postcssParse } = postcss_1;
// Tags that can conceivably represent stand-alone media.
const mediaTags = [
  'img', 'audio', 'video', 'picture', 'svg',
  'object', 'map', 'iframe', 'embed'
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const vulnerableTags = [ 'script', 'style' ];

function each$1(obj, cb) {
  if (obj) {
    Object.keys(obj).forEach(function (key) {
      cb(obj[key], key);
    });
  }
}

// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function has(obj, key) {
  return ({}).hasOwnProperty.call(obj, key);
}

// Returns those elements of `a` for which `cb(a)` returns truthy
function filter(a, cb) {
  const n = [];
  each$1(a, function(v) {
    if (cb(v)) {
      n.push(v);
    }
  });
  return n;
}

function isEmptyObject(obj) {
  for (const key in obj) {
    if (has(obj, key)) {
      return false;
    }
  }
  return true;
}

function stringifySrcset(parsedSrcset) {
  return parsedSrcset.map(function(part) {
    if (!part.url) {
      throw new Error('URL missing');
    }

    return (
      part.url +
      (part.w ? ` ${part.w}w` : '') +
      (part.h ? ` ${part.h}h` : '') +
      (part.d ? ` ${part.d}x` : '')
    );
  }).join(', ');
}

var sanitizeHtml_1 = sanitizeHtml;

// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;

// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  if (html == null) {
    return '';
  }

  let result = '';
  // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
  let tempResult = '';

  function Frame(tag, attribs) {
    const that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text
    this.mediaChildren = [];

    this.updateParentNodeText = function() {
      if (stack.length) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.text += that.text;
      }
    };

    this.updateParentNodeMediaChildren = function() {
      if (stack.length && mediaTags.includes(this.tag)) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.mediaChildren.push(this.tag);
      }
    };
  }

  options = Object.assign({}, sanitizeHtml.defaults, options);
  options.parser = Object.assign({}, htmlParserDefaults, options.parser);

  // vulnerableTags
  vulnerableTags.forEach(function (tag) {
    if (
      options.allowedTags && options.allowedTags.indexOf(tag) > -1 &&
      !options.allowVulnerableTags
    ) {
      console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    }
  });

  // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.
  const nonTextTagsArray = options.nonTextTags || [
    'script',
    'style',
    'textarea',
    'option'
  ];
  let allowedAttributesMap;
  let allowedAttributesGlobMap;
  if (options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each$1(options.allowedAttributes, function(attributes, tag) {
      allowedAttributesMap[tag] = [];
      const globRegex = [];
      attributes.forEach(function(obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    });
  }
  const allowedClassesMap = {};
  const allowedClassesGlobMap = {};
  const allowedClassesRegexMap = {};
  each$1(options.allowedClasses, function(classes, tag) {
    // Implicitly allows the class attribute
    if (allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push('class');
    }

    allowedClassesMap[tag] = [];
    allowedClassesRegexMap[tag] = [];
    const globRegex = [];
    classes.forEach(function(obj) {
      if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
        globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
      } else if (obj instanceof RegExp) {
        allowedClassesRegexMap[tag].push(obj);
      } else {
        allowedClassesMap[tag].push(obj);
      }
    });
    if (globRegex.length) {
      allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
    }
  });

  const transformTagsMap = {};
  let transformTagsAll;
  each$1(options.transformTags, function(transform, tag) {
    let transFun;
    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === 'string') {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });

  let depth;
  let stack;
  let skipMap;
  let transformMap;
  let skipText;
  let skipTextDepth;
  let addedText = false;

  initializeState();

  const parser = new htmlparser.Parser({
    onopentag: function(name, attribs) {
      // If `enforceHtmlBoundary` is `true` and this has found the opening
      // `html` tag, reset the state.
      if (options.enforceHtmlBoundary && name === 'html') {
        initializeState();
      }

      if (skipText) {
        skipTextDepth++;
        return;
      }
      const frame = new Frame(name, attribs);
      stack.push(frame);

      let skip = false;
      const hasText = !!frame.text;
      let transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);

        frame.attribs = attribs = transformedTag.attribs;

        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);

        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if ((options.allowedTags && options.allowedTags.indexOf(name) === -1) || (options.disallowedTagsMode === 'recursiveEscape' && !isEmptyObject(skipMap)) || (options.nestingLimit != null && depth >= options.nestingLimit)) {
        skip = true;
        skipMap[depth] = true;
        if (options.disallowedTagsMode === 'discard') {
          if (nonTextTagsArray.indexOf(name) !== -1) {
            skipText = true;
            skipTextDepth = 1;
          }
        }
        skipMap[depth] = true;
      }
      depth++;
      if (skip) {
        if (options.disallowedTagsMode === 'discard') {
          // We want the contents but not this tag
          return;
        }
        tempResult = result;
        result = '';
      }
      result += '<' + name;

      if (name === 'script') {
        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
          frame.innerText = '';
        }
      }

      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each$1(attribs, function(value, a) {
          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
            // This prevents part of an attribute name in the output from being
            // interpreted as the end of an attribute, or end of a tag.
            delete frame.attribs[a];
            return;
          }
          let parsed;
          // check allowedAttributesMap for the element and attribute and modify the value
          // as necessary if there are specific values defined.
          let passedAllowedAttributesMapCheck = false;
          if (!allowedAttributesMap ||
            (has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1) ||
            (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1) ||
            (has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a)) ||
            (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
            passedAllowedAttributesMapCheck = true;
          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
            for (const o of allowedAttributesMap[name]) {
              if (isPlainObject$3(o) && o.name && (o.name === a)) {
                passedAllowedAttributesMapCheck = true;
                let newValue = '';
                if (o.multiple === true) {
                  // verify the values that are allowed
                  const splitStrArray = value.split(' ');
                  for (const s of splitStrArray) {
                    if (o.values.indexOf(s) !== -1) {
                      if (newValue === '') {
                        newValue = s;
                      } else {
                        newValue += ' ' + s;
                      }
                    }
                  }
                } else if (o.values.indexOf(value) >= 0) {
                  // verified an allowed value matches the entire attribute value
                  newValue = value;
                }
                value = newValue;
              }
            }
          }
          if (passedAllowedAttributesMapCheck) {
            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }

            if (name === 'script' && a === 'src') {

              let allowed = true;

              try {
                const parsed = new URL(value);

                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                  const allowedHostname = (options.allowedScriptHostnames || []).find(function (hostname) {
                    return hostname === parsed.hostname;
                  });
                  const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                    return parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`);
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                allowed = false;
              }

              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }

            if (name === 'iframe' && a === 'src') {
              let allowed = true;
              try {
                // Chrome accepts \ as a substitute for / in the // at the
                // start of a URL, so rewrite accordingly to prevent exploit.
                // Also drop any whitespace at that point in the URL
                value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
                if (value.startsWith('relative:')) {
                  // An attempt to exploit our workaround for base URLs being
                  // mandatory for relative URL validation in the WHATWG
                  // URL parser, reject it
                  throw new Error('relative: exploit attempt');
                }
                // naughtyHref is in charge of whether protocol relative URLs
                // are cool. Here we are concerned just with allowed hostnames and
                // whether to allow relative URLs.
                //
                // Build a placeholder "base URL" against which any reasonable
                // relative URL may be parsed successfully
                let base = 'relative://relative-site';
                for (let i = 0; (i < 100); i++) {
                  base += `/${i}`;
                }
                const parsed = new URL(value, base);
                const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
                if (isRelativeUrl) {
                  // default value of allowIframeRelativeUrls is true
                  // unless allowedIframeHostnames or allowedIframeDomains specified
                  allowed = has(options, 'allowIframeRelativeUrls')
                    ? options.allowIframeRelativeUrls
                    : (!options.allowedIframeHostnames && !options.allowedIframeDomains);
                } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                  const allowedHostname = (options.allowedIframeHostnames || []).find(function (hostname) {
                    return hostname === parsed.hostname;
                  });
                  const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                    return parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`);
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                // Unparseable iframe src
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'srcset') {
              try {
                parsed = parseSrcset(value);
                parsed.forEach(function(value) {
                  if (naughtyHref('srcset', value.url)) {
                    value.evil = true;
                  }
                });
                parsed = filter(parsed, function(v) {
                  return !v.evil;
                });
                if (!parsed.length) {
                  delete frame.attribs[a];
                  return;
                } else {
                  value = stringifySrcset(filter(parsed, function(v) {
                    return !v.evil;
                  }));
                  frame.attribs[a] = value;
                }
              } catch (e) {
                // Unparseable srcset
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'class') {
              const allowedSpecificClasses = allowedClassesMap[name];
              const allowedWildcardClasses = allowedClassesMap['*'];
              const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
              const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
              const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
              const allowedClassesGlobs = [
                allowedSpecificClassesGlob,
                allowedWildcardClassesGlob
              ]
                .concat(allowedSpecificClassesRegex)
                .filter(function (t) {
                  return t;
                });
              if (allowedSpecificClasses && allowedWildcardClasses) {
                value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
              } else {
                value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
              }
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'style') {
              try {
                const abstractSyntaxTree = postcssParse(name + ' {' + value + '}');
                const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);

                value = stringifyStyleAttributes(filteredAST);

                if (value.length === 0) {
                  delete frame.attribs[a];
                  return;
                }
              } catch (e) {
                delete frame.attribs[a];
                return;
              }
            }
            result += ' ' + a;
            if (value && value.length) {
              result += '="' + escapeHtml(value, true) + '"';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result += ' />';
      } else {
        result += '>';
        if (frame.innerText && !hasText && !options.textFilter) {
          result += escapeHtml(frame.innerText);
          addedText = true;
        }
      }
      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
    },
    ontext: function(text) {
      if (skipText) {
        return;
      }
      const lastFrame = stack[stack.length - 1];
      let tag;

      if (lastFrame) {
        tag = lastFrame.tag;
        // If inner text was set by transform function then let's use it
        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }

      if (options.disallowedTagsMode === 'discard' && ((tag === 'script') || (tag === 'style'))) {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else {
        const escaped = escapeHtml(text, false);
        if (options.textFilter && !addedText) {
          result += options.textFilter(escaped, tag);
        } else if (!addedText) {
          result += escaped;
        }
      }
      if (stack.length) {
        const frame = stack[stack.length - 1];
        frame.text += text;
      }
    },
    onclosetag: function(name) {

      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }

      const frame = stack.pop();
      if (!frame) {
        // Do not crash on bad markup
        return;
      }
      skipText = options.enforceHtmlBoundary ? name === 'html' : false;
      depth--;
      const skip = skipMap[depth];
      if (skip) {
        delete skipMap[depth];
        if (options.disallowedTagsMode === 'discard') {
          frame.updateParentNodeText();
          return;
        }
        tempResult = result;
        result = '';
      }

      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }

      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
        result = result.substr(0, frame.tagPosition);
        return;
      }

      frame.updateParentNodeMediaChildren();
      frame.updateParentNodeText();

      if (options.selfClosing.indexOf(name) !== -1) {
        // Already output />
        if (skip) {
          result = tempResult;
          tempResult = '';
        }
        return;
      }

      result += '</' + name + '>';
      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
      addedText = false;
    }
  }, options.parser);
  parser.write(html);
  parser.end();

  return result;

  function initializeState() {
    result = '';
    depth = 0;
    stack = [];
    skipMap = {};
    transformMap = {};
    skipText = false;
    skipTextDepth = 0;
  }

  function escapeHtml(s, quote) {
    if (typeof (s) !== 'string') {
      s = s + '';
    }
    if (options.parser.decodeEntities) {
      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      if (quote) {
        s = s.replace(/"/g, '&quot;');
      }
    }
    // TODO: this is inadequate because it will pass `&0;`. This approach
    // will not work, each & must be considered with regard to whether it
    // is followed by a 100% syntactically valid entity or not, and escaped
    // if it is not. If this bothers you, don't set parser.decodeEntities
    // to false. (The default is true.)
    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    if (quote) {
      s = s.replace(/"/g, '&quot;');
    }
    return s;
  }

  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    // eslint-disable-next-line no-control-regex
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    href = href.replace(/<!--.*?-->/g, '');
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    // Allow more characters after the first so we don't get faked
    // out by certain schemes browsers accept
    const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!matches) {
      // Protocol-relative URL starting with any combination of '/' and '\'
      if (href.match(/^[/\\]{2}/)) {
        return !options.allowProtocolRelative;
      }

      // No scheme
      return false;
    }
    const scheme = matches[1].toLowerCase();

    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }

    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }

  /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */
  function filterCss(abstractSyntaxTree, allowedStyles) {
    if (!allowedStyles) {
      return abstractSyntaxTree;
    }

    const astRules = abstractSyntaxTree.nodes[0];
    let selectedRule;

    // Merge global and tag-specific styles into new AST.
    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
      selectedRule = deepmerge(
        allowedStyles[astRules.selector],
        allowedStyles['*']
      );
    } else {
      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
    }

    if (selectedRule) {
      abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
    }

    return abstractSyntaxTree;
  }

  /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */
  function stringifyStyleAttributes(filteredAST) {
    return filteredAST.nodes[0].nodes
      .reduce(function(extractedAttributes, attrObject) {
        extractedAttributes.push(
          `${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`
        );
        return extractedAttributes;
      }, [])
      .join(';');
  }

  /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */
  function filterDeclarations(selectedRule) {
    return function (allowedDeclarationsList, attributeObject) {
      // If this property is allowlisted...
      if (has(selectedRule, attributeObject.prop)) {
        const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
          return regularExpression.test(attributeObject.value);
        });

        if (matchesRegex) {
          allowedDeclarationsList.push(attributeObject);
        }
      }
      return allowedDeclarationsList;
    };
  }

  function filterClasses(classes, allowed, allowedGlobs) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function(clss) {
      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
        return glob.test(clss);
      });
    }).join(' ');
  }
}

// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish

const htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    'address', 'article', 'aside', 'footer', 'header',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup',
    'main', 'nav', 'section',
    // Text content
    'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure',
    'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul',
    // Inline text semantics
    'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
    'em', 'i', 'kbd', 'mark', 'q',
    'rb', 'rp', 'rt', 'rtc', 'ruby',
    's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr',
    // Table content
    'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr'
  ],
  disallowedTagsMode: 'discard',
  allowedAttributes: {
    a: [ 'href', 'name', 'target' ],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading' ]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
  // URL schemes we permit
  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false
};

sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
  merge = (merge === undefined) ? true : merge;
  newAttribs = newAttribs || {};

  return function(tagName, attribs) {
    let attrib;
    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }

    return {
      tagName: newTagName,
      attribs: attribs
    };
  };
};

var sanitizeHtml$1 = sanitizeHtml_1;

var useStyles$H = makeStyles()(function (theme, _a) {
    var _b = _a.styleProps, isError = _b.isError, readOnly = _b.readOnly;
    return ({
        editor: {
            width: '100%',
            fontFamily: theme.typography.fontFamily,
            position: 'relative',
            '& .DraftEditor-editorContainer': {
                position: 'relative',
                height: 'inherit',
                textAlign: 'initial',
                backgroundColor: 'rgba(255, 255, 255, 0)',
                borderLeft: '0.1px solid transparent',
                zIndex: 1
            },
            '& .DraftEditor-root': {
                position: 'relative',
                height: 'inherit',
                textAlign: 'initial'
            },
            '& .public-DraftEditorPlaceholder-root': {
                top: theme.spacing(1),
                color: '#9197a3',
                position: 'absolute',
                width: '100%',
                zIndex: 1
            },
            '& .public-DraftEditor-content': {
                height: 'inherit',
                textAlign: 'initial',
                padding: theme.spacing(1, 0)
            },
            '& .public-DraftEditor-content[contenteditable="true"]': {
                WebkitUserModify: 'read-write-plaintext-only'
            },
            '& .public-DraftEditor-content:before': readOnly
                ? null
                : {
                    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
                    left: 0,
                    bottom: 0,
                    content: '""',
                    position: 'absolute',
                    right: 0,
                    transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                },
            '& .public-DraftEditor-content:focus:before': {
                borderBottomColor: '#14465A'
            },
            '& .public-DraftEditor-content:after': {
                borderBottom: "2px solid ".concat(isError ? theme.palette.error.main : additionalPalette.lightGrey.main),
                left: 0,
                bottom: 0,
                content: '""',
                position: 'absolute',
                right: 0,
                transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
                transform: "scaleX(".concat(isError ? 1 : 0, ")")
            },
            '& .public-DraftEditor-content:focus:after': isError
                ? null
                : {
                    transform: 'scaleX(1)'
                },
            '& .public-DraftEditor-block': {
                position: 'relative'
            },
            '& .DraftEditor-alignLeft .public-DraftStyleDefault-block': {
                textAlign: 'left'
            },
            '& .DraftEditor-alignLeft .public-DraftEditorPlaceholder-root': {
                left: 0,
                textAlign: 'left'
            },
            '& .DraftEditor-alignCenter .public-DraftStyleDefault-block': {
                textAlign: 'center'
            },
            '& .DraftEditor-alignCenter .public-DraftEditorPlaceholder-root': {
                margin: '0 auto',
                textAlign: 'center',
                width: '100%'
            },
            '& .DraftEditor-alignRight .public-DraftStyleDefault-block': {
                textAlign: 'right'
            },
            '& .DraftEditor-alignRight .public-DraftEditorPlaceholder-root': {
                right: 0,
                textAlign: 'right'
            },
            '& .public-DraftEditorPlaceholder-hasFocus': {
                color: '#bdc1c9'
            },
            '& .DraftEditorPlaceholder-hidden': {
                display: 'none'
            },
            '& .public-DraftStyleDefault-block': {
                position: 'relative',
                whiteSpace: 'pre-wrap'
            },
            '& .public-DraftStyleDefault-ltr': {
                direction: 'ltr',
                textAlign: 'left'
            },
            '& .public-DraftStyleDefault-rtl': {
                direction: 'rtl',
                textAlign: 'right'
            },
            '& .public-DraftStyleDefault-listLTR': {
                direction: 'ltr'
            },
            '& .public-DraftStyleDefault-listRTL': {
                direction: 'rtl'
            },
            '& .public-DraftStyleDefault-ol': {
                margin: '16px 0',
                padding: 0
            },
            '& .public-DraftStyleDefault-ul': {
                margin: '16px 0',
                padding: 0
            },
            '& .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR': {
                marginLeft: '1.5em'
            },
            '& .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL': {
                marginRight: '1.5em'
            },
            '& .public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR': {
                marginLeft: '3em'
            },
            '& .public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL': {
                marginRight: '3em'
            },
            '& .public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR': {
                marginLeft: '4.5em'
            },
            '& .public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL': {
                marginRight: '4.5em'
            },
            '& .public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR': {
                marginLeft: '6em'
            },
            '& .public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL': {
                marginRight: '6em'
            },
            '& .public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR': {
                marginLeft: '7.5em'
            },
            '& .public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL': {
                marginRight: '7.5em'
            },
            '& .public-DraftStyleDefault-unorderedListItem': {
                listStyleType: 'square',
                position: 'relative'
            },
            '& .public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0': {
                listStyleType: 'disc'
            },
            '& .public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1': {
                listStyleType: 'circle'
            },
            '& .public-DraftStyleDefault-orderedListItem': {
                listStyleType: 'none',
                position: 'relative'
            },
            '& .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before': {
                left: -36,
                position: 'absolute',
                textAlign: 'right',
                width: 30
            },
            '& .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before': {
                position: 'absolute',
                right: -36,
                textAlign: 'left',
                width: 30
            },
            '& .public-DraftStyleDefault-orderedListItem:before': {
                content: 'counter(ol0) ". "',
                counterIncrement: 'ol0'
            },
            '& .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before': {
                content: 'counter(ol1, lower-alpha) ". "',
                counterIncrement: 'ol1'
            },
            '& .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before': {
                content: 'counter(ol2, lower-roman) ". "',
                counterIncrement: 'ol2'
            },
            '& .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before': {
                content: 'counter(ol3) ". "',
                counterIncrement: 'ol3'
            },
            '& .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before': {
                content: 'counter(ol4, lower-alpha) ". "',
                counterIncrement: 'ol4'
            },
            '& .public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset': {
                counterReset: 'ol0'
            },
            '& .public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset': {
                counterReset: 'ol1'
            },
            '& .public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset': {
                counterReset: 'ol2'
            },
            '& .public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset': {
                counterReset: 'ol3'
            },
            '& .public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset': {
                counterReset: 'ol4'
            }
        },
        helperText: {
            fontSize: '0.875rem',
            color: theme.palette.error.main,
            margin: theme.spacing(0.5, 0, 0, 0)
        },
        editorControls: {
            zIndex: 100,
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: '0px 0px 5px -1px rgba(0,0,0,0.5)',
            color: 'black',
            display: 'flex',
            padding: 4
        }
    });
});

var FormatItalic = {};

var _interopRequireDefault$e = interopRequireDefault.exports;

Object.defineProperty(FormatItalic, "__esModule", {
  value: true
});
var default_1$4 = FormatItalic.default = void 0;

var _createSvgIcon$4 = _interopRequireDefault$e(createSvgIcon);

var _jsxRuntime$4 = require$$2$3;

var _default$4 = (0, _createSvgIcon$4.default)( /*#__PURE__*/(0, _jsxRuntime$4.jsx)("path", {
  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
}), 'FormatItalic');

default_1$4 = FormatItalic.default = _default$4;

var FormatBold = {};

var _interopRequireDefault$d = interopRequireDefault.exports;

Object.defineProperty(FormatBold, "__esModule", {
  value: true
});
var default_1$3 = FormatBold.default = void 0;

var _createSvgIcon$3 = _interopRequireDefault$d(createSvgIcon);

var _jsxRuntime$3 = require$$2$3;

var _default$3 = (0, _createSvgIcon$3.default)( /*#__PURE__*/(0, _jsxRuntime$3.jsx)("path", {
  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), 'FormatBold');

default_1$3 = FormatBold.default = _default$3;

var FormatUnderlined = {};

var _interopRequireDefault$c = interopRequireDefault.exports;

Object.defineProperty(FormatUnderlined, "__esModule", {
  value: true
});
var default_1$2 = FormatUnderlined.default = void 0;

var _createSvgIcon$2 = _interopRequireDefault$c(createSvgIcon);

var _jsxRuntime$2 = require$$2$3;

var _default$2 = (0, _createSvgIcon$2.default)( /*#__PURE__*/(0, _jsxRuntime$2.jsx)("path", {
  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
}), 'FormatUnderlined');

default_1$2 = FormatUnderlined.default = _default$2;

var useStyles$G = makeStyles()({
    editorControlsButton: {
        color: theme.palette.secondary.main,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightBold,
        display: 'flex',
        cursor: 'pointer',
        width: theme.spacing(3),
        height: theme.spacing(3),
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.spacing(0.25),
        margin: 1,
        '&:hover': {
            backgroundColor: theme.palette.secondary[50]
        }
    },
    editorControlsButtonSelected: {
        backgroundColor: theme.palette.secondary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main
        }
    }
});

var CONTROL_ICON_SIZE = 20;
var INLINE_CONTROLS = [
    {
        command: 'BOLD',
        icon: jsx$1(default_1$3, { sx: { fontSize: CONTROL_ICON_SIZE } })
    },
    {
        command: 'ITALIC',
        icon: jsx$1(default_1$4, { sx: { fontSize: CONTROL_ICON_SIZE } })
    },
    {
        command: 'UNDERLINE',
        icon: jsx$1(default_1$2, { sx: { fontSize: CONTROL_ICON_SIZE } })
    }
];
var EditorControls = function (_a) {
    var editorState = _a.editorState, onToggle = _a.onToggle;
    var _b = useStyles$G(), classes = _b.classes, classNames = _b.cx;
    var currentStyle = editorState.getCurrentInlineStyle();
    return (jsx$1(Fragment$1, { children: INLINE_CONTROLS.map(function (_a) {
            var _b;
            var command = _a.command, icon = _a.icon;
            return (jsx$1("a", __assign$3({ role: "button", tabIndex: 0, className: classNames(classes.editorControlsButton, (_b = {},
                    _b[classes.editorControlsButtonSelected] = currentStyle.has(command),
                    _b)), onMouseDown: function (e) {
                    e.preventDefault();
                    onToggle(command);
                } }, { children: icon }), command));
        }) }));
};

function useEvent(element, event, callback, enabled = true, capture = false) {
  return useEffect(() => {
    if (!enabled || !element) {
      return;
    }

    const cb = callback;
    const el = Array.isArray(element) ? element : [element];
    const ev = Array.isArray(event) ? event : [event];
    el.forEach(e => {
      ev.forEach(event => {
        e.addEventListener(event, cb, capture);
      });
    });
    return () => {
      el.forEach(e => {
        ev.forEach(event => {
          e.removeEventListener(event, cb, capture);
        });
      });
    };
  }, [callback, element, enabled, event, capture]);
}

const OutsideClickContext = /*#__PURE__*/React__default.createContext({});

function isChildOf(parent, target) {
  if (parent === target) {
    return true;
  }

  const hasChildren = parent.children && parent.children.length > 0;

  if (hasChildren) {
    // tslint:disable-next-line
    for (let i = 0; i < parent.children.length; i++) {
      const child = parent.children[i];

      if (child && isChildOf(child, target)) {
        return true;
      }
    }
  }

  return false;
}

function OutsideClickGroupProvider({
  refs,
  children
}) {
  const isPartOfGroup = typeof React__default.useContext(OutsideClickContext) === "function";

  if (isPartOfGroup) {
    return children;
  }

  return /*#__PURE__*/React__default.createElement(OutsideClickContext.Provider, {
    value: React__default.useCallback(layerRef => {
      refs.current.add(layerRef);
    }, [])
  }, children);
}

function useRegisterGroup(refs) {
  const registerRefToGroup = React__default.useContext(OutsideClickContext);
  React__default.useEffect(() => {
    const [layerRef] = refs.current.values();

    if (typeof registerRefToGroup === "function" && layerRef) {
      registerRefToGroup(layerRef);
    }
  }, [registerRefToGroup, refs]);
}

function useOutsideClick(refs, callback) {
  const [events] = React__default.useState(["click"]);
  useRegisterGroup(refs);
  useEvent(typeof document !== "undefined" ? document : null, events, React__default.useCallback(evt => {
    for (const ref of refs.current) {
      if (!ref.current) {
        continue;
      }

      if (isChildOf(ref.current, evt.target)) {
        return;
      }
    }

    callback();
  }, [callback]), true, true);
}

function useOnScroll(elements, onScroll, environment, trackScroll = true) {
  const memoElements = useMemo$1(() => typeof environment !== "undefined" ? [environment, ...elements] : [], [elements]);
  useEvent(memoElements, "scroll", onScroll, trackScroll);
}

function useOnWindowResize(onResize, environment, trackResize = true) {
  useEvent(typeof environment !== "undefined" ? environment : null, "resize", onResize, trackResize);
}

const useIsomorphicLayoutEffect$2 = typeof window !== "undefined" ? useLayoutEffect : useEffect;

function useTrackElementResize(injectedResizeObserver, layerRef, triggerElement, isOpen, callback, environment) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const ResizeObserver = injectedResizeObserver || (typeof environment === "undefined" ? class ResizeObserver {} : environment.ResizeObserver);

  if (!ResizeObserver) {
    throw new Error("This browser does not support `ResizeObserver` out of the box. Please provide a polyfill as a prop.");
  }

  const resizeObserver = useRef(new ResizeObserver(() => {
    if (layerRef.current) {
      callbackRef.current();
    }
  }));
  useIsomorphicLayoutEffect$2(() => {
    if (isOpen) {
      if (triggerElement) {
        resizeObserver.current.observe(triggerElement);
      }
    } else {
      if (triggerElement) {
        resizeObserver.current.unobserve(triggerElement);
      }

      if (layerRef.current) {
        resizeObserver.current.unobserve(layerRef.current);
      }
    }
  }, [isOpen, triggerElement]);
  useEffect(() => {
    return () => {
      resizeObserver.current.disconnect();
    };
  }, []);
  return resizeObserver.current;
}

const EMPTY_STYLE = {};
function isSet(value) {
  return value !== undefined && value !== null;
}

function areStylesTheSame(a, b) {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  for (let i = 0; i < Math.max(aKeys.length, bKeys.length); i++) {
    const key = aKeys[i] || bKeys[i];

    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}

function shouldUpdateStyles(prev, next) {
  if (areStylesTheSame(prev.layer, next.layer) && areStylesTheSame(prev.arrow, next.arrow)) {
    return false;
  }

  return true;
} // creates a ClientRect-like object from the viewport's dimensions

function getWindowClientRect(environment) {
  return {
    top: 0,
    left: 0,
    right: environment ? environment.innerWidth : 0,
    bottom: environment ? environment.innerHeight : 0,
    height: environment ? environment.innerHeight : 0,
    width: environment ? environment.innerWidth : 0
  };
}

const convertFloat = value => parseFloat(value.replace("px", "")); // get the outer width / height of an element
// We effectively want the same width / height that `getBoundingClientRect()`
// gives, minus optional `scale` transforms


function getContentBox(element, environment) {
  if (!environment) {
    return {
      width: 0,
      height: 0
    };
  }

  const {
    width,
    height,
    boxSizing,
    borderLeft,
    borderRight,
    borderTop,
    borderBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom
  } = environment.getComputedStyle(element);
  return {
    width: boxSizing === "border-box" ? convertFloat(width) : [width, borderLeft, borderRight, paddingLeft, paddingRight].reduce((total, value) => total + (value ? convertFloat(value) : 0), 0),
    height: boxSizing === "border-box" ? convertFloat(height) : [height, borderTop, borderBottom, paddingTop, paddingBottom].reduce((total, value) => total + (value ? convertFloat(value) : 0), 0)
  };
} // converts a ClientRect (or DOMRect) to a plain js-object
// usefull for destructuring for instance

function clientRectToObject(clientRect) {
  return {
    top: clientRect.top,
    left: clientRect.left,
    right: clientRect.right,
    bottom: clientRect.bottom,
    width: clientRect.width,
    height: clientRect.height
  };
}
function getElementFromAnchorNode(anchorNode) {
  let currentElement = anchorNode;

  while (!currentElement.getBoundingClientRect) {
    if (!currentElement.parentElement) {
      return null;
    }

    currentElement = currentElement.parentElement;
  }

  return currentElement;
}
function minMax(value, {
  min,
  max
}) {
  return value < min ? min : value > max ? max : value;
}

function useStyleState(anchor) {
  const [INITIAL_STYLES] = useState({
    layer: EMPTY_STYLE,
    arrow: EMPTY_STYLE,
    layerSide: anchor.split("_")[0].toLowerCase()
  });
  const [styles, setStyles] = useState(INITIAL_STYLES);
  const lastStyles = useRef(styles);
  return {
    styles,
    lastStyles,
    setStyles,
    resetLastStyles: () => {
      lastStyles.current = INITIAL_STYLES;
    }
  };
}

const Anchor = {
  BOTTOM_LEFT: "BOTTOM_LEFT",
  BOTTOM_RIGHT: "BOTTOM_RIGHT",
  BOTTOM_CENTER: "BOTTOM_CENTER",
  TOP_LEFT: "TOP_LEFT",
  TOP_CENTER: "TOP_CENTER",
  TOP_RIGHT: "TOP_RIGHT",
  LEFT_BOTTOM: "LEFT_BOTTOM",
  LEFT_CENTER: "LEFT_CENTER",
  LEFT_TOP: "LEFT_TOP",
  RIGHT_BOTTOM: "RIGHT_BOTTOM",
  RIGHT_CENTER: "RIGHT_CENTER",
  RIGHT_TOP: "RIGHT_TOP"
};
const POSSIBLE_ANCHORS = Object.keys(Anchor);
function getPrimaryDirection(anchor) {
  return anchor.startsWith("TOP_") || anchor.startsWith("BOTTOM_") ? "Y" : "X";
}

function primaryIsY(primary) {
  return primary === "TOP" || primary === "BOTTOM";
}

function getPrimaryByIndex(index, preferedPrimary, preferedX, preferedY) {
  const prefferedIsY = primaryIsY(preferedPrimary);

  if (index < 3) {
    return preferedPrimary;
  }

  if (index < 6) {
    return prefferedIsY ? preferedX : preferedY;
  }

  if (index < 9) {
    if (prefferedIsY) {
      return ["LEFT", "RIGHT"].filter(x => x !== preferedX)[0];
    } else {
      return ["TOP", "BOTTOM"].filter(x => x !== preferedY)[0];
    }
  }

  if (prefferedIsY) {
    return ["TOP", "BOTTOM"].filter(x => x !== preferedPrimary)[0];
  } else {
    return ["LEFT", "RIGHT"].filter(x => x !== preferedPrimary)[0];
  }
}

function getSecondaryByIndex(index, preferedPrimary, preferedSecondary, rects) {
  const prefferedIsY = primaryIsY(preferedPrimary);
  const triggerHasBiggerHeight = rects.trigger.height > rects.layer.height;
  const triggerHasBiggerWidth = rects.trigger.width > rects.layer.width;

  switch (index) {
    case 9:
    case 0:
      return preferedSecondary;

    case 1:
    case 10:
      {
        if (preferedSecondary === "CENTER") {
          return prefferedIsY ? "RIGHT" : "BOTTOM";
        }

        return "CENTER";
      }

    case 4:
    case 7:
      return "CENTER";

    case 2:
    case 11:
      {
        if (prefferedIsY) {
          return ["LEFT", "RIGHT"].filter(x => x !== preferedSecondary)[0];
        } else {
          return ["TOP", "BOTTOM"].filter(x => x !== preferedSecondary)[0];
        }
      }

    case 3:
    case 6:
      {
        if (prefferedIsY) {
          return preferedPrimary === "BOTTOM" ? triggerHasBiggerHeight ? "BOTTOM" : "TOP" : triggerHasBiggerHeight ? "TOP" : "BOTTOM";
        }

        return preferedPrimary === "LEFT" ? triggerHasBiggerWidth ? "LEFT" : "RIGHT" : triggerHasBiggerWidth ? "RIGHT" : "LEFT";
      }

    case 5:
    case 8:
      {
        if (prefferedIsY) {
          return preferedPrimary === "BOTTOM" ? triggerHasBiggerHeight ? "TOP" : "BOTTOM" : triggerHasBiggerHeight ? "BOTTOM" : "TOP";
        }

        return preferedPrimary === "LEFT" ? triggerHasBiggerWidth ? "RIGHT" : "LEFT" : triggerHasBiggerWidth ? "LEFT" : "RIGHT";
      }
  }
  /* istanbul ignore next */


  return "LEFT";
}

function getSecondaryAnchorOptionsByPrimary(primary, anchorOptions) {
  return anchorOptions.filter(anchor => anchor.startsWith(primary));
}
function splitAnchor(anchor) {
  const [primary, secondary] = anchor.split("_");
  return {
    primary,
    secondary
  };
}
function getLayerSideByAnchor(anchor) {
  if (anchor === "CENTER") {
    return "center";
  }

  return splitAnchor(anchor).primary.toLowerCase();
}
function getAnchorPriority(preferedAnchor, possibleAnchors, preferedX, preferedY, rects) {
  const {
    primary,
    secondary
  } = preferedAnchor !== "CENTER" ? splitAnchor(preferedAnchor) : {
    primary: preferedY,
    secondary: "CENTER"
  };
  let anchors = POSSIBLE_ANCHORS.map((_, index) => {
    return getPrimaryByIndex(index, primary, preferedX, preferedY) + "_" + getSecondaryByIndex(index, primary, secondary, rects);
  }).filter(anchor => possibleAnchors.indexOf(anchor) > -1); // include prefered anchor if not included in possibleAnchors

  if (anchors.indexOf(preferedAnchor) === -1) {
    /* istanbul ignore next */
    anchors = [preferedAnchor, ...anchors];
  }

  return anchors;
}

function getPrimaryStyle(primary, rects, scroll, triggerOffset) {
  const prop = primary === "TOP" || primary === "BOTTOM" ? "top" : "left";
  const size = primary === "TOP" || primary === "BOTTOM" ? "height" : "width";

  if (primary === "TOP" || primary === "LEFT") {
    return {
      [prop]: rects.trigger[prop] - rects.layer[size] - (rects.relativeParent[prop] - scroll[prop]) - triggerOffset
    };
  }

  return {
    [prop]: rects.trigger[prop] + rects.trigger[size] - (rects.relativeParent[prop] - scroll[prop]) + triggerOffset
  };
}

function getCenter(rects, scroll, offsetSecondary, prop, size) {
  return minMax(rects.trigger[prop] - rects.relativeParent[prop] + scroll[prop] + rects.trigger[size] / 2 - rects.layer[size] / 2 - offsetSecondary, getLimits(rects, scroll)[prop]);
}

function getLimits(rects, scroll) {
  const topBase = rects.trigger.top - rects.relativeParent.top + scroll.top;
  const leftBase = rects.trigger.left - rects.relativeParent.left + scroll.left;
  return {
    top: {
      min: topBase - (rects.layer.height - rects.arrow.height),
      max: topBase + (rects.trigger.height - rects.arrow.height)
    },
    left: {
      min: leftBase - (rects.layer.width - rects.arrow.width),
      max: leftBase + (rects.trigger.width - rects.arrow.width)
    }
  };
}

function getSecondaryStyle$1(secondary, rects, scroll, offsetSecondary, primaryDirection) {
  if (secondary === "CENTER") {
    const prop = primaryDirection === "X" ? "top" : "left";
    const size = primaryDirection === "X" ? "height" : "width";
    return {
      [prop]: getCenter(rects, scroll, offsetSecondary, prop, size)
    };
  }

  const prop = secondary === "TOP" || secondary === "BOTTOM" ? "top" : "left";
  const size = secondary === "TOP" || secondary === "BOTTOM" ? "height" : "width";

  if (secondary === "TOP" || secondary === "LEFT") {
    return {
      [prop]: minMax(rects.trigger[prop] - rects.relativeParent[prop] + scroll[prop] + offsetSecondary, getLimits(rects, scroll)[prop])
    };
  }

  return {
    [prop]: minMax(rects.trigger[prop] + rects.trigger[size] - rects.layer[size] - (rects.relativeParent[prop] - scroll[prop]) - offsetSecondary, getLimits(rects, scroll)[prop])
  };
}

function getAbsolutePositions({
  anchor,
  rects,
  triggerOffset,
  offsetSecondary,
  scrollLeft,
  scrollTop
}) {
  const scroll = {
    left: scrollLeft,
    top: scrollTop
  };

  if (anchor === "CENTER") {
    return {
      top: getCenter(rects, scroll, 0, "top", "height"),
      left: getCenter(rects, scroll, 0, "left", "width")
    };
  }

  const {
    primary,
    secondary
  } = splitAnchor(anchor);
  const primaryDirection = getPrimaryDirection(anchor);
  return { ...getPrimaryStyle(primary, rects, scroll, triggerOffset),
    ...getSecondaryStyle$1(secondary, rects, scroll, offsetSecondary, primaryDirection)
  };
}

// anticipate the width / height based on the current anchor

function fixLayerDimensions(originalLayer, anchor, layerDimensions) {
  const dimensions = typeof layerDimensions === "function" ? layerDimensions(getLayerSideByAnchor(anchor)) : layerDimensions;
  return { ...clientRectToObject(originalLayer),
    ...dimensions
  };
}

const propMap = {
  TOP: {
    side1: "bottom",
    side2: "top",
    size: "height",
    factor: -1
  },
  BOTTOM: {
    side1: "top",
    side2: "bottom",
    size: "height",
    factor: 1
  },
  LEFT: {
    side1: "right",
    side2: "left",
    size: "width",
    factor: -1
  },
  RIGHT: {
    side1: "left",
    side2: "right",
    size: "width",
    factor: 1
  }
};

function getPrimaryRect(primary, trigger, layer, triggerOffset) {
  const {
    side1,
    side2,
    size,
    factor
  } = propMap[primary];
  const value = trigger[side2] + triggerOffset * factor;
  return {
    [side1]: value,
    [side2]: value + layer[size] * factor
  };
}

function getCenter$1(trigger, layer, offsetSecondary, prop, size) {
  const value = trigger[prop] + trigger[size] / 2 - layer[size] / 2 - offsetSecondary;
  return {
    [prop]: value,
    [prop === "left" ? "right" : "bottom"]: value + layer[size]
  };
}

function getSecondaryRect(secondary, trigger, layer, offsetSecondary, primaryDirection) {
  if (secondary === "CENTER") {
    const prop = primaryDirection === "X" ? "top" : "left";
    const size = primaryDirection === "X" ? "height" : "width";
    return getCenter$1(trigger, layer, offsetSecondary, prop, size);
  }

  const {
    side1,
    side2,
    size,
    factor
  } = propMap[secondary];
  const value = trigger[side2] - offsetSecondary * factor;
  return {
    [side2]: value,
    [side1]: value - layer[size] * factor
  };
}

function getLayerRectByAnchor({
  trigger,
  layer,
  anchor,
  triggerOffset,
  scrollOffset = 0,
  offsetSecondary = 0,
  layerDimensions
}) {
  let primaryRect;
  let secondaryRect; // get the correct anticipated ClientRect based on the provided Anchor

  const layerRect = layerDimensions ? fixLayerDimensions(layer, anchor, layerDimensions) : layer;

  if (anchor === "CENTER") {
    primaryRect = getCenter$1(trigger, layerRect, 0, "top", "height");
    secondaryRect = getCenter$1(trigger, layerRect, 0, "left", "width");
  } else {
    const {
      primary,
      secondary
    } = splitAnchor(anchor);
    const primaryDirection = getPrimaryDirection(anchor);
    primaryRect = getPrimaryRect(primary, trigger, layerRect, triggerOffset);
    secondaryRect = getSecondaryRect(secondary, trigger, layerRect, offsetSecondary, primaryDirection);
  }

  const result = { ...layerRect,
    ...primaryRect,
    ...secondaryRect
  }; // correct scrollOffsets

  result.top = result.top - scrollOffset;
  result.right = result.right + scrollOffset;
  result.left = result.left - scrollOffset;
  result.bottom = result.bottom + scrollOffset;
  return result;
}

const ALL_OFFSET_SIDES = ["bottom", "top", "left", "right"];

function getLayerOffsetsToParent(layer, parent) {
  return {
    top: layer.top - parent.top,
    bottom: parent.bottom - layer.bottom,
    left: layer.left - parent.left,
    right: parent.right - layer.right
  };
}

function getLayerOffsetsToParents(layer, parents) {
  return parents.map(parent => getLayerOffsetsToParent(layer, parent));
}

function isLayerCompletelyInvisible(layer, parents) {
  return parents.some(parent => {
    return layer.bottom <= parent.top || layer.right <= parent.left || layer.top >= parent.bottom || layer.left >= parent.right;
  });
}
function doesEntireLayerFitWithinScrollParents(layer, parents) {
  const parentOffsets = getLayerOffsetsToParents(layer, parents);
  return parentOffsets.every(offsets => {
    return ALL_OFFSET_SIDES.every(side => offsets[side] >= 0);
  });
}
function reduceOffsets(parentOffsets) {
  const parentOffsetsCombined = parentOffsets.reduce((result, offsets) => {
    ALL_OFFSET_SIDES.forEach(side => {
      result[side] = [...result[side], offsets[side]];
    });
    return result;
  }, {
    top: [],
    bottom: [],
    left: [],
    right: []
  });
  return ALL_OFFSET_SIDES.reduce((result, side) => {
    result[side] = parentOffsetsCombined[side].sort((a, b) => a - b)[0];
    return result;
  }, {});
}
function getNegativeOffsetSides(parentOffsets) {
  const offsets = reduceOffsets(parentOffsets);
  return ALL_OFFSET_SIDES.filter(side => offsets[side] < 0);
}

function getVisibleLayerSurface(layer, parent) {
  const offsets = getLayerOffsetsToParent(layer, parent);
  const {
    width,
    height
  } = ALL_OFFSET_SIDES.filter(side => offsets[side] < 0).reduce((rect, side) => {
    const affectedProperty = side === "top" || side === "bottom" ? "height" : "width";
    return { ...rect,
      [affectedProperty]: rect[affectedProperty] + offsets[side]
    };
  }, layer);
  const result = width * height;
  return width < 0 && height < 0 ? -result : result;
}

function getVisibleLayerSurfaceWithinScrollParent(layer, parents) {
  const surfaces = parents.map(parent => getVisibleLayerSurface(layer, parent)); // pick smallest

  return surfaces.sort((a, b) => a - b)[0];
}
function doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, layerDimensions) {
  const layerRect = getLayerRectByAnchor({
    anchor,
    trigger: rects.trigger,
    layer: rects.layer,
    triggerOffset,
    scrollOffset,
    layerDimensions
  });
  return doesEntireLayerFitWithinScrollParents(layerRect, rects.scrollParents);
}
function getLayerOffsetsToScrollParentsByAnchor(anchor, rects, triggerOffset, scrollOffset) {
  return getLayerOffsetsToParents(getLayerRectByAnchor({
    anchor,
    trigger: rects.trigger,
    layer: rects.layer,
    triggerOffset,
    scrollOffset,
    layerDimensions: null
  }), rects.scrollParents);
}
function triggerIsBiggerThanLayer(layerSide, layer, trigger) {
  return (layerSide === "top" || layerSide === "bottom") && trigger.width > layer.width || (layerSide === "left" || layerSide === "right") && trigger.height > layer.height;
}

function getOffsetSurface(anchor, layer, triggerOffset, scrollOffset) {
  const primaryDirection = getPrimaryDirection(anchor);
  const primarySize = layer[primaryDirection === "X" ? "width" : "height"] - triggerOffset - scrollOffset * 2;
  const secondarySize = layer[primaryDirection === "X" ? "height" : "width"] - triggerOffset - scrollOffset * 2;
  return primarySize * secondarySize;
}

function findAnchorByLayerSurface(rects, anchorOptions, triggerOffset, scrollOffset, layerDimensions) {
  const result = anchorOptions.map(anchor => {
    // get layerRect based on all offsets
    const layerRect = getLayerRectByAnchor({
      anchor,
      layer: rects.layer,
      trigger: rects.trigger,
      scrollOffset,
      triggerOffset,
      layerDimensions
    }); // get smallest visible layer surface for current anchor

    const surface = getVisibleLayerSurfaceWithinScrollParent(layerRect, rects.scrollParents); // get surface of the offsets
    // offsets are important for collision detection, but
    // eventually we are interested in the 'meat' of the layer

    const offsetSurface = getOffsetSurface(anchor, layerRect, triggerOffset, scrollOffset);
    return {
      anchor,
      square: surface - offsetSurface
    };
  }) // sort -> biggest surface first
  .sort((a, b) => b.square - a.square);
  return result[0].anchor;
}

function findBestSuitableAnchor(rects, anchorOptions, triggerOffset, scrollOffset, layerDimensions) {
  // STRATEGY A
  // find first that fits parent
  const anchor = anchorOptions.find(anchor => doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, layerDimensions));

  if (anchor) {
    return anchor;
  } // STRATEGY B
  // find first with biggest surface


  return findAnchorByLayerSurface(rects, anchorOptions, triggerOffset, scrollOffset, layerDimensions);
}

function getSecondaryOffsetSide(currentAnchor, firstAnchorThatDoesNotFit, rects, triggerOffset, scrollOffset) {
  const primaryDirection = getPrimaryDirection(currentAnchor);
  const offsets = getLayerOffsetsToScrollParentsByAnchor(firstAnchorThatDoesNotFit, rects, triggerOffset, scrollOffset);
  const sides = getNegativeOffsetSides(offsets);
  return sides.find(side => {
    if (primaryDirection === "X") {
      return side === "top" || side === "bottom";
    }

    return side === "left" || side === "right";
  });
}

function findSecondaryOffset(anchor, anchorOptions, rects, triggerOffset, scrollOffset) {
  const {
    primary
  } = splitAnchor(anchor);
  /**
   * A.
   * Check which other anchors available
   */

  const secondaryAnchorOptions = getSecondaryAnchorOptionsByPrimary(primary, anchorOptions);
  /**
   * B.
   * Check whether current anchor is the preffered anchor and whether
   * it fits
   * If so, skip secondary offset
   */

  const currentAnchorHasHighestPriority = secondaryAnchorOptions.indexOf(anchor) === 0;
  const currentAnchorFits = doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, null);

  if (currentAnchorHasHighestPriority && currentAnchorFits) {
    return 0;
  }
  /**
   * C.
   * Retrieve the first anchor on same primary side (by priority) that
   * does not fit.
   * Check if there's a relevant side that has a negative offset.
   * If not, skip secondary offset
   */


  const firstAnchorThatDoesNotFit = secondaryAnchorOptions.find(anchor => {
    return !doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, null);
  });
  const affectedSide = getSecondaryOffsetSide(anchor, firstAnchorThatDoesNotFit, rects, triggerOffset, scrollOffset);

  if (!affectedSide) {
    return 0;
  }
  /**
   * Determine the final secondary offset
   */


  const currentOffsets = reduceOffsets(getLayerOffsetsToScrollParentsByAnchor(anchor, rects, triggerOffset, scrollOffset));
  let secondaryOffset = -currentOffsets[affectedSide];
  const triggerIsBigger = triggerIsBiggerThanLayer(getLayerSideByAnchor(anchor), rects.layer, rects.trigger);
  const isCenter = anchor.includes("_CENTER");
  const isLeft = anchor.includes("_LEFT");
  const isTop = anchor.includes("_TOP"); // when trigger is bigger, make `secondaryOffset` positive
  // conditionally

  if (triggerIsBigger && (isLeft && affectedSide === "right" || affectedSide === "left" || isTop && affectedSide === "bottom" || affectedSide === "top")) {
    secondaryOffset = -secondaryOffset;
  } else if ( // when current anchor is center, make `secondaryOffset` positive
  // when affectedSide is top or right
  !triggerIsBigger && isCenter && (affectedSide === "top" || affectedSide === "left")) {
    secondaryOffset = -secondaryOffset;
  }

  return secondaryOffset;
}

function getOffsets(layer, trigger, arrow) {
  const left = layer.left + layer.width / 2 - trigger.left - arrow.width / 2;
  const right = layer.right - layer.width / 2 - trigger.right + arrow.width / 2;
  const top = layer.top + layer.height / 2 - trigger.top - arrow.height / 2;
  const bottom = layer.bottom - layer.height / 2 - trigger.bottom + arrow.height / 2;
  return {
    left: left < 0 ? -left : 0,
    right: right > 0 ? -right : 0,
    top: top < 0 ? -top : 0,
    bottom: bottom > 0 ? -bottom : 0
  };
}

function getArrowStyle(layer, trigger, layerSide, arrow) {
  const triggerIsBigger = triggerIsBiggerThanLayer(layerSide, layer, trigger);
  const limitsDefault = {
    left: {
      min: arrow.width / 2,
      max: layer.width - arrow.width / 2
    },
    top: {
      min: arrow.height / 2,
      max: layer.height - arrow.height / 2
    }
  };
  const offsets = getOffsets(layer, trigger, arrow);

  if (layerSide === "bottom") {
    return {
      bottom: "100%",
      top: null,
      left: minMax(triggerIsBigger ? layer.width / 2 + (offsets.left + offsets.right) : trigger.left + trigger.width / 2 - layer.left, limitsDefault.left),
      right: null
    };
  }

  if (layerSide === "right") {
    return {
      right: "100%",
      left: null,
      top: minMax(triggerIsBigger ? layer.height / 2 + (offsets.top + offsets.bottom) : trigger.top + trigger.height / 2 - layer.top, limitsDefault.top),
      bottom: null
    };
  }

  if (layerSide === "top") {
    return {
      top: "100%",
      bottom: null,
      left: minMax(triggerIsBigger ? layer.width / 2 + (offsets.left + offsets.right) : trigger.left + trigger.width / 2 - layer.left, limitsDefault.left),
      right: null
    };
  }

  return {
    left: "100%",
    right: null,
    top: minMax(triggerIsBigger ? layer.height / 2 + (offsets.top + offsets.bottom) : trigger.top + trigger.height / 2 - layer.top, limitsDefault.top),
    bottom: null
  };
}

function getAbsoluteStyle({
  rects,
  scrollTop,
  scrollLeft,
  triggerOffset,
  scrollOffset,
  possibleAnchors,
  preferedAnchor,
  preferedX,
  preferedY,
  autoAdjust,
  snapToAnchor,
  layerDimensions
}) {
  // get a list of possible anchors bases on user set props
  const possibleAnchorsByPriority = getAnchorPriority(preferedAnchor, possibleAnchors, preferedX, preferedY, rects); // on `autoAdjust` find best suitable anchor based on
  // window's / scrollParent's position

  const anchor = autoAdjust ? findBestSuitableAnchor(rects, possibleAnchorsByPriority, triggerOffset, scrollOffset, layerDimensions) : preferedAnchor; // calculate a secondary offset when `autoAdjust` is set
  // and `snapToAnchor` is not.
  // Basically it creates a visual effect where it seems that
  // the layer has glued to it's parents sides
  // Note: `offsetSecondary` is disabled when anchor is CENTER

  const offsetSecondary = autoAdjust && !snapToAnchor && anchor !== "CENTER" ? findSecondaryOffset(anchor, possibleAnchorsByPriority, rects, triggerOffset, scrollOffset) : 0;
  const layerStyle = getAbsolutePositions({
    anchor,
    rects,
    triggerOffset,
    offsetSecondary,
    scrollLeft,
    scrollTop
  });
  const layerRect = getLayerRectByAnchor({
    anchor,
    trigger: rects.trigger,
    layer: rects.layer,
    triggerOffset,
    offsetSecondary,
    layerDimensions
  });

  if (layerDimensions) {
    layerStyle.width = layerRect.width;
    layerStyle.height = layerRect.height;
  }

  return {
    layerStyle,
    layerRect,
    anchor
  };
}

function compensateScrollbars(rect, clientWidth, clientHeight) {
  const scrollbarWidth = rect.width - clientWidth;
  const scrollbarHeight = rect.height - clientHeight;
  return {
    left: rect.left,
    top: rect.top,
    width: rect.width - scrollbarWidth,
    right: rect.right - scrollbarWidth,
    height: rect.height - scrollbarHeight,
    bottom: rect.bottom - scrollbarHeight
  };
}

function getArrowRect(layerElement, arrowOffset) {
  const arrowElement = layerElement.querySelector("[data-arrow]");

  if (!arrowElement) {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  const rect = arrowElement.getBoundingClientRect();
  return { ...clientRectToObject(rect),
    width: rect.width + arrowOffset * 2,
    height: rect.height + arrowOffset * 2
  };
}

const defaultPlacement = {
  autoAdjust: false,
  snapToAnchor: false,
  anchor: "TOP_CENTER",
  layerDimensions: null,
  possibleAnchors: POSSIBLE_ANCHORS,
  preferX: "RIGHT",
  preferY: "BOTTOM",
  scrollOffset: 10,
  triggerOffset: 0,
  arrowOffset: 0
};
function getPositioning({
  triggerRect,
  layerElement,
  relativeParentElement,
  scrollParents,
  placement = {},
  environment,
  fixed
}) {
  /**
   * A.
   * Calculate new layer positions
   */
  // sometimes ResizeObserver calls this function when all values in the
  // trigger ClientRect are 0. Return early in that case
  if (triggerRect.height === 0) {
    return;
  }

  if (!layerElement) {
    return;
  } // gather all scroll parents (including the window ClientRect)
  // in order to check for collisions


  const scrollParentRects = fixed ? [getWindowClientRect(environment)] : [...scrollParents.map(parent => compensateScrollbars(parent.getBoundingClientRect(), parent.clientWidth, parent.clientHeight)), getWindowClientRect(environment)];
  const options = {
    autoAdjust: placement.autoAdjust || defaultPlacement.autoAdjust,
    snapToAnchor: placement.snapToAnchor || defaultPlacement.snapToAnchor,
    triggerOffset: isSet(placement.triggerOffset) ? placement.triggerOffset : defaultPlacement.triggerOffset,
    scrollOffset: isSet(placement.scrollOffset) ? placement.scrollOffset : defaultPlacement.scrollOffset,
    possibleAnchors: placement.possibleAnchors || defaultPlacement.possibleAnchors,
    preferedAnchor: placement.anchor || defaultPlacement.anchor,
    preferedX: placement.preferX || defaultPlacement.preferX,
    preferedY: placement.preferY || defaultPlacement.preferY,
    scrollLeft: relativeParentElement === document.body ? 0 : relativeParentElement.scrollLeft,
    scrollTop: relativeParentElement === document.body ? 0 : relativeParentElement.scrollTop,
    relativeParentElement,
    layerDimensions: placement.layerDimensions || defaultPlacement.layerDimensions
  };
  const layerBox = layerElement.getBoundingClientRect(); // construct layerRect

  const layer = {
    top: layerBox.top,
    left: layerBox.left,
    right: layerBox.right,
    bottom: layerBox.bottom,
    // use `window.getComputedProperty` for width / height in order
    // to handle things like scale-transforms
    ...getContentBox(layerElement, environment)
  };
  const rects = {
    layer,
    relativeParent: relativeParentElement.getBoundingClientRect(),
    scrollParents: scrollParentRects,
    trigger: triggerRect,
    arrow: getArrowRect(layerElement, placement.arrowOffset || defaultPlacement.arrowOffset)
  };
  const {
    layerRect,
    layerStyle,
    anchor
  } = getAbsoluteStyle({
    rects,
    ...options
  });

  if (fixed) {
    layerStyle.top = layerRect.top;
    layerStyle.left = layerRect.left;
  } // determine in which side to layer will be relative to
  // the trigger


  const layerSide = getLayerSideByAnchor(anchor); // get optional arrow positions
  // anchor-style is pointless when rendered anchor is CENTER

  const arrowStyle = anchor === "CENTER" ? EMPTY_STYLE : getArrowStyle(layerRect, triggerRect, layerSide, rects.arrow);
  const styles = {
    layer: layerStyle,
    arrow: arrowStyle,
    layerSide
  };
  return {
    styles,
    layerRect
  };
}

/**
 * Tracks an element and keeps it in state
 * (together with other relevant state that depends on the element)
 */

function useElementRef(initialState, elementToState) {
  const [state, setState] = useState(initialState || null);
  const lastElement = useRef(null);
  const setRef = useCallback$1(node => {
    if (node && node !== lastElement.current) {
      lastElement.current = node;

      if (elementToState) {
        setState(elementToState(node));
      } else {
        setState(node);
      }
    }
  }, []);
  return [setRef, state, lastElement];
}

function findScrollContainers(element, environment) {
  const result = [];

  if (!element || !environment) {
    return result;
  }

  if (element === document.body) {
    return result;
  }

  const {
    overflow,
    overflowX,
    overflowY
  } = environment.getComputedStyle(element);

  if ([overflow, overflowX, overflowY].some(prop => prop === "auto" || prop === "scroll")) {
    result.push(element);
  }

  return [...result, ...findScrollContainers(element.parentElement, environment)];
}

function useElementState(container, fixed, environment) {
  return useElementRef({
    triggerElement: null,
    relativeParentElement: null,
    scrollParents: []
  }, useCallback$1(triggerElement => {
    const scrollParents = findScrollContainers(triggerElement, environment);
    const relativeParentElement = scrollParents[0] || document.body;

    if (relativeParentElement === document.body) {
      document.body.style.position = "relative";
    } else if (process.env.NODE_ENV === "development" && environment) {
      // Check if we should warn the user about 'position: relative; stuff...'
      const containerElement = typeof container === "function" ? container() : container;
      const position = environment.getComputedStyle(relativeParentElement).position;
      const shouldWarnAboutPositionStyle = position !== "relative" && position !== "absolute" && position !== "fixed" && !fixed && !containerElement;

      if (shouldWarnAboutPositionStyle) {
        console.error("react-laag: Set the 'position' style of the nearest scroll-container to 'relative', 'absolute' or 'fixed', or set the 'fixed' prop to true. This is needed in order to position the layers properly. Currently the scroll-container is positioned: \"" + position + "\". Visit https://react-laag.com/docs/#position-relative for more info.", relativeParentElement);
      }
    }

    return {
      triggerElement,
      relativeParentElement,
      scrollParents
    };
  }, []));
}

function getWidthBasedOnAngle(angle, size) {
  return Math.tan(angle * (Math.PI / 180)) * size;
}

function getViewBox(sizeA, sizeB, layerSide, borderWidth) {
  switch (layerSide) {
    case "bottom":
      return "0 " + -borderWidth + " " + sizeB + " " + sizeA;

    case "top":
      return "0 0 " + sizeB + " " + (sizeA + borderWidth);

    case "right":
      return -borderWidth + " 0 " + sizeA + " " + sizeB;

    case "left":
      return "0 0 " + (sizeA + borderWidth) + " " + sizeB;
  }

  return "";
}

function getTrianglePath({
  sizeA,
  sizeB,
  layerSide,
  roundness,
  angle
}) {
  const relativeRoundness = roundness / 10 * sizeA * 2;
  const A = layerSide === "bottom" ? "0 " + sizeA : layerSide === "top" ? "0 0" : layerSide === "right" ? sizeA + " " + sizeB : "0 " + sizeB;
  const B = (layerSide === "bottom" || layerSide === "top" ? "H" : "V") + " " + (layerSide === "bottom" || layerSide === "top" ? sizeB : 0);
  const cPoint = sizeB / 2;
  const c1A = sizeB / 2 + getWidthBasedOnAngle(angle, sizeA / 8);
  const c1B = sizeA / 8;
  const C = layerSide === "bottom" ? "C " + c1A + " " + c1B + " " + (cPoint + relativeRoundness) + " 0 " + cPoint + " 0" : layerSide === "top" ? "C " + c1A + " " + (sizeA - c1B) + " " + (cPoint + relativeRoundness) + " " + sizeA + " " + cPoint + " " + sizeA : layerSide === "right" ? "C " + c1B + " " + (sizeB - c1A) + " 0 " + (cPoint - relativeRoundness) + " 0 " + cPoint : "C " + (sizeA - c1B) + " " + (sizeB - c1A) + " " + sizeA + " " + (cPoint - relativeRoundness) + " " + sizeA + " " + cPoint;
  const d1A = sizeB / 2 - getWidthBasedOnAngle(angle, sizeA / 8);
  const d1B = sizeA / 8;
  const D = layerSide === "bottom" ? "C " + (cPoint - relativeRoundness) + " 0 " + d1A + " " + d1B + " " + A : layerSide === "top" ? "C " + (cPoint - relativeRoundness) + " " + sizeA + " " + d1A + " " + (sizeA - d1B) + " " + A : layerSide === "right" ? "C 0 " + (cPoint + relativeRoundness) + " " + d1B + " " + (sizeB - d1A) + " " + A : "C" + sizeA + " " + (cPoint + relativeRoundness) + " " + (sizeA - d1B) + " " + (sizeB - d1A) + " " + A;
  return "M " + A + " " + B + " " + C + " " + D;
}

function getBorderMaskPath({
  sizeA,
  sizeB,
  borderWidth,
  layerSide,
  angle
}) {
  const borderOffset = getWidthBasedOnAngle(angle, borderWidth);

  if (layerSide === "bottom" || layerSide === "top") {
    return "M " + borderWidth + " " + (layerSide === "bottom" ? sizeA : 0) + " H " + (sizeB - borderWidth) + " L " + (sizeB - borderWidth - borderOffset) + " " + (layerSide === "bottom" ? sizeA - borderWidth : borderWidth) + " H " + (borderOffset + borderWidth) + " Z";
  }

  return "M " + (layerSide === "right" ? sizeA : 0) + " " + borderWidth + " V " + (sizeB - borderWidth) + " L " + (layerSide === "right" ? sizeA - borderWidth : borderWidth) + " " + (sizeB - borderWidth - borderOffset) + " V " + (borderOffset + borderWidth) + " Z";
}

const Arrow = ({
  size = 8,
  angle = 45,
  borderWidth = 0,
  borderColor = "black",
  roundness = 0,
  backgroundColor = "white",
  layerSide = "top",
  style = {}
}) => {
  if (layerSide === "center") {
    return null;
  }

  const sizeA = size;
  const sizeB = getWidthBasedOnAngle(angle, size) * 2;
  return /*#__PURE__*/createElement("svg", {
    style: { ...style,
      transform: "translate" + (layerSide === "left" || layerSide === "right" ? "Y" : "X") + "(-50%)"
    },
    "data-arrow": "true",
    width: layerSide === "left" || layerSide === "right" ? sizeA : sizeB,
    viewBox: getViewBox(sizeA, sizeB, layerSide, borderWidth)
  }, /*#__PURE__*/createElement("path", {
    fill: backgroundColor,
    strokeWidth: borderWidth,
    stroke: borderColor,
    d: getTrianglePath({
      angle,
      layerSide,
      roundness,
      sizeA,
      sizeB
    })
  }), /*#__PURE__*/createElement("path", {
    fill: backgroundColor,
    d: getBorderMaskPath({
      sizeA,
      sizeB,
      angle,
      borderWidth,
      layerSide
    })
  }));
};

function useToggleLayer(renderLayer, {
  onStyle,
  closeOnOutsideClick,
  closeOnDisappear,
  fixed,
  container,
  placement = {},
  environment = typeof window !== "undefined" ? window : undefined,
  ...props
} = {}) {
  /**
   * Tracks trigger element and keeps it in state together with it's
   * relative/absolute positioned parent
   */
  const [setTargetRef, {
    relativeParentElement,
    triggerElement: targetElement,
    scrollParents
  }, normalTriggerRef] = useElementState(container, fixed, environment);
  const {
    styles,
    setStyles,
    lastStyles,
    resetLastStyles
  } = useStyleState(placement.anchor || defaultPlacement.anchor);
  const layerRef = useRef(null);
  const triggerRectRef = useRef(null);

  function getTriggerRect() {
    return typeof triggerRectRef.current === "function" ? triggerRectRef.current() : triggerRectRef.current;
  }

  const [isOpen, setOpen] = useState(false);

  function close() {
    triggerRectRef.current = null;
    setOpen(false);
  }

  const handlePositioning = useCallback$1(() => {
    const triggerRect = getTriggerRect();

    if (!triggerRect) {
      return;
    }

    const result = getPositioning({
      triggerRect,
      layerElement: layerRef.current,
      placement,
      relativeParentElement,
      scrollParents,
      fixed,
      environment
    });

    if (!result) {
      return;
    }

    const {
      layerRect,
      styles
    } = result; // only update styles when necessary

    if (shouldUpdateStyles(lastStyles.current, styles)) {
      // is parent in control of styles? (onStyle)
      if (isSet(onStyle)) {
        lastStyles.current = styles;
        onStyle(styles.layer, styles.arrow, styles.layerSide);
      } // ... otherwise set styles internally
      else {
          setStyles(styles);
        }
    }
    /**
     * B.
     * Manage disappearance
     */
    // Should we respond to the layer's partial or full disappearance?
    // (trigger's disappearance when `fixed` props is set)


    if (closeOnDisappear) {
      const allScrollParents = [...scrollParents.map(parent => parent.getBoundingClientRect()), getWindowClientRect(environment)];
      const partial = !doesEntireLayerFitWithinScrollParents(fixed ? triggerRect : layerRect, allScrollParents);
      const full = isLayerCompletelyInvisible(fixed ? triggerRect : layerRect, allScrollParents);

      if (closeOnDisappear === "partial" && partial) {
        close();
      }

      if (closeOnDisappear === "full" && full) {
        close();
      }
    }
  }, [relativeParentElement, isOpen, targetElement, scrollParents, fixed, placement]); // call `handlePositioning` when the layer's / targets's
  // height and / or width changes

  const resizeObserver = useTrackElementResize(props.ResizeObserver, layerRef, targetElement, isOpen, handlePositioning, environment); // On every render, check a few things...

  useIsomorphicLayoutEffect$2(() => {
    /**
     * A.
     * Ignore when render is caused by internal style change
     */
    const styleIsSetInterally = !isSet(onStyle);
    const effectBecauseOfInternalStyleChange = styles !== lastStyles.current;

    if (effectBecauseOfInternalStyleChange && styleIsSetInterally) {
      lastStyles.current = styles;
      return;
    } // reset `lastStyles` when closed


    if (!isOpen) {
      resetLastStyles();
      return;
    }
    /**
     * B.
     * Prepare to calculate new layer style
     */


    handlePositioning();
  }); // calculate new layer style when window size changes

  useOnWindowResize(handlePositioning, environment, isOpen); // calculate new layer style when user scrolls

  useOnScroll(scrollParents, handlePositioning, environment, isOpen);
  const outsideClickRefs = useRef(new Set([layerRef, normalTriggerRef])); // handle clicks that are not originated from the trigger / layer
  // element

  useOutsideClick(outsideClickRefs, useCallback$1(() => {
    if (!isOpen) {
      return;
    }

    if (closeOnOutsideClick) {
      close();
    }
  }, [isOpen, setOpen, closeOnOutsideClick]));
  const containerElement = typeof container === "function" ? container() : container;

  function open({
    clientRect,
    target
  }) {
    triggerRectRef.current = clientRect;

    if (isOpen && target === targetElement) {
      handlePositioning();
    } else {
      setTargetRef(target);
      setOpen(true);
    }
  }

  const payload = {
    isOpen,
    close,
    open,
    openFromContextMenuEvent: evt => {
      evt.preventDefault();
      const target = evt.target;
      const clientRect = {
        top: evt.clientY,
        left: evt.clientX,
        bottom: evt.clientY + 1,
        right: evt.clientX + 1,
        width: 1,
        height: 1
      };
      open({
        clientRect,
        target
      });
    },
    openFromMouseEvent: evt => {
      const currentTarget = evt.currentTarget;

      if (!currentTarget || !currentTarget.getBoundingClientRect) {
        return;
      }

      const clientRect = () => currentTarget.getBoundingClientRect();

      open({
        clientRect,
        target: currentTarget
      });
    },
    openFromRef: ref => {
      if (!ref.current) {
        console.error("Error inside useTooltip(): Expected a valid ref to a trigger element, but got " + typeof ref.current);
        return;
      }

      open({
        target: ref.current,
        clientRect: ref.current.getBoundingClientRect()
      });
    },
    openFromSelection: selection => {
      if (!selection.anchorNode || selection.isCollapsed) {
        return;
      }

      const element = getElementFromAnchorNode(selection.anchorNode);

      if (!element) {
        return;
      }

      const range = selection.getRangeAt(0);
      open({
        clientRect: () => range.getBoundingClientRect(),
        target: element
      });
    },
    layerSide: isOpen ? styles.layerSide : null
  };
  const element = relativeParentElement && /*#__PURE__*/createPortal(renderLayer({
    layerProps: {
      ref: element => {
        if (element) {
          // observe the layer for resizing
          // it's ok to observe the same element multiple times
          // since multiple observes of same element are ignored
          resizeObserver.observe(element);
        }

        layerRef.current = element;
      },
      style: { ...(isSet(onStyle) ? EMPTY_STYLE : styles.layer),
        position: fixed ? "fixed" : "absolute",
        willChange: "top, bottom, left, right, width, height"
      }
    },
    arrowStyle: { ...(isSet(onStyle) ? EMPTY_STYLE : styles.arrow),
      position: "absolute",
      willChange: "top, bottom, left, right"
    },
    isOpen,
    layerSide: styles.layerSide,
    triggerRect: getTriggerRect(),
    close: () => {
      close();
    }
  }), containerElement || relativeParentElement);
  return [/*#__PURE__*/createElement(OutsideClickGroupProvider, {
    refs: outsideClickRefs
  }, element), payload];
}

var useEditorControls = function (editorControls, editorState) {
    var isSelectionCollapsed = editorState.getSelection().isCollapsed();
    var hasSelectionFocus = editorState.getSelection().getHasFocus();
    var classes = useStyles$H({
        styleProps: {}
    }).classes;
    var _a = useToggleLayer(function (_a) {
        var isOpen = _a.isOpen, layerProps = _a.layerProps, arrowStyle = _a.arrowStyle;
        return isOpen && (jsxs("div", __assign$3({ ref: layerProps.ref, className: classes.editorControls, style: __assign$3({}, layerProps.style), "data-test-id": "editor-input-controls" }, { children: [jsx$1(Arrow, { style: __assign$3(__assign$3({}, arrowStyle), { zIndex: 100 }), layerSide: "bottom", size: 8, angle: 45, roundness: 1, borderWidth: 2, borderColor: "rgba(0,0,0,0.1)", backgroundColor: "white" }), editorControls] })));
    }, { placement: { triggerOffset: 8, anchor: 'BOTTOM_CENTER' } }), layeredControls = _a[0], toggleLayerProps = _a[1];
    var closeControls = function () { return toggleLayerProps.close(); };
    var handlePressEscape = function (e) {
        if (e.key === 'Escape') {
            closeControls();
        }
    };
    useEffect(function () {
        document.addEventListener('keyup', handlePressEscape);
        return function () { return document.removeEventListener('keyup', handlePressEscape); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var isCollapsed = editorState.getSelection().isCollapsed();
        if (!editorState.getSelection().getHasFocus()) {
            closeControls();
            return;
        }
        if (isCollapsed) {
            closeControls();
        }
        else {
            toggleLayerProps.open({
                clientRect: function () { return Draft.getVisibleSelectionRect(window); },
                target: document.body
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSelectionCollapsed, hasSelectionFocus]);
    return layeredControls;
};

var EditorInputState = /** @class */ (function () {
    function EditorInputState(editorState, editor) {
        this.editorState = editorState;
        this.editor = editor;
        this.selectionState = editorState.getSelection();
    }
    EditorInputState.prototype.toRaw = function () {
        return Draft.convertToRaw(this.editorState.getCurrentContent());
    };
    EditorInputState.prototype.toHTML = function () {
        var _a;
        return sanitizeHtml$1((_a = this.editor) === null || _a === void 0 ? void 0 : _a.outerHTML, {
            allowedTags: ['span'],
            allowedAttributes: { span: ['style'] }
        });
    };
    EditorInputState.prototype.toText = function () {
        return this.editorState.getCurrentContent().getPlainText();
    };
    return EditorInputState;
}());
var createEditorState = function (rawValue, value) {
    return Draft.EditorState.createWithContent((rawValue === null || rawValue === void 0 ? void 0 : rawValue.blocks.length)
        ? Draft.convertFromRaw(rawValue)
        : Draft.ContentState.createFromText(value));
};
// There is an old bug https://github.com/facebook/draft-js/issues/1198 that does not allow to make component controllable in a way that it is updated when new value prop comes to it. The issue is that when you make such functionality with the help of `useEffect` cursor starts jumping.
// eslint-disable-next-line max-statements
var EditorInput = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, rawValue = _a.rawValue, isError = _a.isError, helperText = _a.helperText, placeholder = _a.placeholder, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, _d = _a.autoFocus, autoFocus = _d === void 0 ? false : _d, ariaLabel = _a.ariaLabel, _e = _a.shouldHandlePasteManually, shouldHandlePasteManually = _e === void 0 ? false : _e, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onPaste = _a.onPaste, onNativePaste = _a.onNativePaste;
    var classes = useStyles$H({
        styleProps: {
            isError: isError,
            readOnly: readOnly
        }
    }).classes;
    var _f = useState(createEditorState(rawValue, value)), editorState = _f[0], setEditorState = _f[1];
    var editorRef = useRef(null);
    var mounted = useRef(false);
    var handleNativePaste = function (e) {
        var _a;
        var inputState = new EditorInputState(editorState, (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor);
        onNativePaste === null || onNativePaste === void 0 ? void 0 : onNativePaste(e, inputState);
    };
    useEffect(function () {
        var _a, _b;
        if (autoFocus) {
            (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setEditorState(Draft.EditorState.moveFocusToEnd(editorState));
        }
        var editorNode = (_b = editorRef.current) === null || _b === void 0 ? void 0 : _b.editor;
        if (onNativePaste) {
            editorNode === null || editorNode === void 0 ? void 0 : editorNode.addEventListener('paste', handleNativePaste);
        }
        return function () {
            if (onNativePaste) {
                editorNode === null || editorNode === void 0 ? void 0 : editorNode.removeEventListener('paste', handleNativePaste);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This useEffect should handle only paste event. Change event cannot be controlled from the outside because of the bug https://github.com/facebook/draft-js/issues/1198
    useEffect(function () {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        setEditorState(createEditorState(rawValue, ''));
    }, [rawValue]);
    // update read-only component with a new title when component receives new prop
    useEffect(function () {
        if (readOnly) {
            setEditorState(createEditorState(rawValue, value));
        }
    }, [value, rawValue, readOnly]);
    var toggleInlineStyle = function (inlineStyle) {
        var _a;
        var newState = Draft.RichUtils.toggleInlineStyle(editorState, inlineStyle);
        setEditorState(newState);
        var inputState = new EditorInputState(newState, (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor);
        onChange === null || onChange === void 0 ? void 0 : onChange(inputState);
    };
    var handleKeyCommand = function (command, editorState) {
        var newState = Draft.RichUtils.handleKeyCommand(editorState, command);
        if (!newState) {
            return 'not-handled';
        }
        switch (command) {
            case 'bold':
            case 'italic':
            case 'underline':
                setEditorState(newState);
                return 'handled';
            default:
                return 'not-handled';
        }
    };
    var handleOnFocus = function () {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    };
    var handleOnBlur = function () {
        var _a;
        var inputState = new EditorInputState(editorState, (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(inputState);
    };
    var handleOnChange = function (newState) {
        var _a;
        setEditorState(newState);
        var inputState = new EditorInputState(newState, (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor);
        onChange === null || onChange === void 0 ? void 0 : onChange(inputState);
    };
    var editorControlsLayer = useEditorControls(jsx$1(EditorControls, { editorState: editorState, onToggle: toggleInlineStyle }), editorState);
    var handlePastedText = function (pastedText) {
        var _a;
        // if shouldHandlePasteManually === false, paste will be handled by component
        // otherwise, paste should be handled manually
        if (!shouldHandlePasteManually) {
            return 'not-handled';
        }
        var selection = editorState.getSelection();
        var startPositionSelectedText = selection.getStartOffset();
        var endPositionSelectedText = selection.getEndOffset();
        if (onPaste) {
            onPaste === null || onPaste === void 0 ? void 0 : onPaste(new EditorInputState(editorState, (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor), pastedText, {
                startPositionSelectedText: startPositionSelectedText,
                endPositionSelectedText: endPositionSelectedText
            });
        }
        return 'handled';
    };
    return (jsxs("div", __assign$3({ className: classes.editor, "data-test-id": "editor-input" }, { children: [editorControlsLayer, jsx$1(Draft.Editor, { ref: editorRef, ariaLabel: ariaLabel, readOnly: readOnly, editorState: editorState, onChange: handleOnChange, onFocus: handleOnFocus, onBlur: handleOnBlur, handlePastedText: handlePastedText, handleKeyCommand: handleKeyCommand, placeholder: placeholder, stripPastedStyles: true }), isError ? (jsx$1("p", __assign$3({ className: classes.helperText, "data-test-id": "editor-input-helper-text" }, { children: helperText }))) : null] })));
};

var wrapTextInstruction = function (component, className) {
    return (jsx$1(Grid$2, __assign$3({ container: true, alignItems: "center", direction: "column", className: className }, { children: component })));
};
var getRawTitleValue = function (titleStyling) {
    if (!titleStyling) {
        return undefined;
    }
    try {
        return JSON.parse(titleStyling);
    }
    catch (e) {
        return undefined;
    }
};
var SurveyQuestionLayout = function (props) {
    var _a, _b;
    var _c;
    var loc = props.loc, content = props.content, progress = props.progress, title = props.title, titleStyling = props.titleStyling, preview = props.preview, next = props.next, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.isPreviewPanel, isPreviewPanel = _e === void 0 ? false : _e, _f = props.isTextInstruction, isTextInstruction = _f === void 0 ? false : _f;
    var _g = useStyles$J({
        styleProps: { isPreviewPanel: isPreviewPanel }
    }), classes = _g.classes, classNames = _g.cx;
    var textClasses = useTextStyles().classes;
    var locTextSize = isPreviewPanel ? TextSize.ms : TextSize.m;
    var instructionsContent = (jsxs(Fragment$1, { children: [jsx$1("div", __assign$3({ className: classNames(classes.title, classes.marginLeftRight) }, { children: jsx$1(EditorInput, { readOnly: true, value: title, rawValue: getRawTitleValue(titleStyling) }) })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses[(_c = classNameBySize.get(locTextSize)) !== null && _c !== void 0 ? _c : 'sizeM'], textClasses.highlightBackground, classes.marginBottom, (_a = {},
                    _a[classes.marginLeftRight] = !isTextInstruction,
                    _a)) }, { children: loc.instructions }))] }));
    var questionContent = (jsxs(Grid$2, __assign$3({ item: true, container: true, direction: "column", justifyContent: "center", alignItems: "center" }, { children: [jsx$1(MuiLinearProgress, { value: ((progress.current + 1) / progress.total) * 100, color: "secondary", variant: "determinate", className: classes.progress }), jsx$1(SurveyProgress, { progress: progress, preview: preview, isPreviewPanel: isPreviewPanel }), isTextInstruction
                ? wrapTextInstruction(instructionsContent, classes.textInstructionContent)
                : instructionsContent] })));
    return (jsxs(Grid$2, __assign$3({ container: true, direction: "column", className: classes.page }, { children: [isTextInstruction ? questionContent : jsx$1(Paper, { children: questionContent }), jsx$1(Grid$2, __assign$3({ item: true, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ item: true, container: true, className: classNames(classes.content, (_b = {},
                        _b[classes.contentMaxWidth] = !fullWidth,
                        _b)) }, { children: [content, jsx$1(Grid$2, __assign$3({ container: true, justifyContent: "center" }, { children: jsx$1(SpinnerButton, __assign$3({ fullWidth: true, disabled: next.disabled, loading: next.loading, onClick: next.onNext, className: classes.nextButton }, { children: loc.next })) }))] })) }))] })));
};

var dayjs_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
}(dayjs_min));

var dayjs = dayjs_min.exports;

var getValueFromSettings = function (settings, code) {
    var _a;
    var valueAsString = (_a = settings === null || settings === void 0 ? void 0 : settings.find(function (setting) { return setting.code === code; })) === null || _a === void 0 ? void 0 : _a.value;
    return valueAsString;
};
var getChoiceLimitFromSettings = function (settingValues) {
    var valueAsString = getValueFromSettings(settingValues, 'choice_limit');
    return valueAsString ? parseInt(valueAsString, 10) : undefined;
};
var getChoiceIntervalMinFromSettings = function (settingValues) {
    var valueAsString = getValueFromSettings(settingValues, 'choice_interval_min');
    return valueAsString ? parseInt(valueAsString, 10) : undefined;
};
var getChoiceIntervalMaxFromSettings = function (settingValues) {
    var valueAsString = getValueFromSettings(settingValues, 'choice_interval_max');
    return valueAsString ? parseInt(valueAsString, 10) : undefined;
};
var isMatrixMultipleChoice = function (settingValues) {
    var valueAsString = getValueFromSettings(settingValues, 'matrix_choice');
    return valueAsString === 'multiple_choice';
};
var getTimestampString = function () {
    var currentTimestamp = dayjs().format(API_DATETIME_FORMAT);
    return currentTimestamp;
};
var getNewSelectedResponseObj = function (position) {
    return {
        selectedPosition: position,
        timestamp: getTimestampString()
    };
};
var isResponseOptionSelected = function (selectedResponses, position) {
    var _a;
    return ((_a = selectedResponses === null || selectedResponses === void 0 ? void 0 : selectedResponses.some(function (selectedResponse) { return selectedResponse.selectedPosition === position; })) !== null && _a !== void 0 ? _a : false);
};
var isDefaultOrExclusiveSelected = function (selectedResponses, responseOptions) {
    var _a;
    return ((_a = responseOptions === null || responseOptions === void 0 ? void 0 : responseOptions.some(function (responseOption) {
        return (responseOption.option.isDefaultOption ||
            responseOption.option.isExclusiveOption) &&
            isResponseOptionSelected(selectedResponses, responseOption.position);
    })) !== null && _a !== void 0 ? _a : false);
};
var isMinNoOfResponsesReached = function (selectedResponses, settingValues, responseOptions) {
    var intervalMin = getChoiceIntervalMinFromSettings(settingValues || []);
    var intervalMax = getChoiceIntervalMaxFromSettings(settingValues || []);
    var minNoReached = !!(intervalMin && intervalMax
        ? selectedResponses.length >= intervalMin
        : true);
    var defaultOrExclusiveSelected = selectedResponses.some(function (sr) {
        return isResponseDefaultOrExclusive(responseOptions, sr.selectedPosition);
    });
    return minNoReached || defaultOrExclusiveSelected;
};
var isResponseLimitReached = function (selectedResponses, settingValues) {
    var limit = getChoiceLimitFromSettings(settingValues || []);
    var intervalMax = getChoiceIntervalMaxFromSettings(settingValues || []);
    return (selectedResponses.length === limit ||
        selectedResponses.length === intervalMax);
};
var isResponseOptionDisabled = function (settingValues, responseOptions, selectedResponses, position) {
    return ((isResponseLimitReached(selectedResponses, settingValues) ||
        isDefaultOrExclusiveSelected(selectedResponses, responseOptions)) &&
        !isResponseOptionSelected(selectedResponses, position));
};
var isResponseDefaultOrExclusive = function (responseOptions, position) {
    return !!(responseOptions === null || responseOptions === void 0 ? void 0 : responseOptions.find(function (responseOption) {
        return responseOption.position === position &&
            (responseOption.option.isDefaultOption ||
                responseOption.option.isExclusiveOption);
    }));
};

var useSimpleValidation = function (enabled, matchPattern) {
    var _a = useState({ isValid: true, isSupressed: true }), internalValidation = _a[0], setInternalValidation = _a[1];
    var handleTextChangeValidation = useCallback$1(function (newText) {
        if (enabled) {
            var isValid = matchPattern === null || matchPattern === void 0 ? void 0 : matchPattern.test(newText);
            if (isValid !== internalValidation.isValid) {
                setInternalValidation(__assign$3(__assign$3({}, internalValidation), { isValid: isValid === undefined ? true : isValid }));
            }
        }
    }, [matchPattern, internalValidation, enabled]);
    var handleBlurValidation = useCallback$1(function () {
        if (internalValidation.isSupressed) {
            setInternalValidation(__assign$3(__assign$3({}, internalValidation), { isSupressed: false }));
        }
    }, [internalValidation]);
    var resetValidation = useCallback$1(function () {
        setInternalValidation({ isValid: true, isSupressed: true });
    }, []);
    var displayValidationErrors = enabled && !internalValidation.isValid && !internalValidation.isSupressed;
    return {
        handleTextChangeValidation: handleTextChangeValidation,
        handleBlurValidation: handleBlurValidation,
        resetValidation: resetValidation,
        displayValidationErrors: displayValidationErrors
    };
};

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf$1 = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf$1(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$1(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber$1(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$3(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject$2(val) {
  if (kindOf$1(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate$1 = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$1(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject$3(val) && isFunction$1(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction$1(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge$2(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$2(result[key]) && isPlainObject$2(val)) {
      result[key] = merge$2(result[key], val);
    } else if (isPlainObject$2(val)) {
      result[key] = merge$2({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend$2(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray$1(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

var utils$k = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber$1,
  isObject: isObject$3,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$1,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge$2,
  extend: extend$2,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf$1,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray$1,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};

var utils$j = utils$k;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$3 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$j.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$j.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$j.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$j.forEach(val, function parseValue(v) {
        if (utils$j.isDate(v)) {
          v = v.toISOString();
        } else if (utils$j.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$i = utils$k;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$i.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$h = utils$k;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$h.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var utils$g = utils$k;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError$6(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$g.inherits(AxiosError$6, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError$6.prototype;
var descriptors$1 = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors$1[code] = {value: code};
});

Object.defineProperties(AxiosError$6, descriptors$1);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError$6.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils$g.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError$6.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

var AxiosError_1 = AxiosError$6;

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var utils$f = utils$k;

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData$1(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils$f.isDate(value)) {
      return value.toISOString();
    }

    if (utils$f.isArrayBuffer(value) || utils$f.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils$f.isPlainObject(data) || utils$f.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils$f.forEach(data, function each(value, key) {
        if (utils$f.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils$f.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils$f.endsWith(key, '[]') && (arr = utils$f.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils$f.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

var toFormData_1 = toFormData$1;

var AxiosError$5 = AxiosError_1;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$2 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$5(
      'Request failed with status code ' + response.status,
      [AxiosError$5.ERR_BAD_REQUEST, AxiosError$5.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};

var utils$e = utils$k;

var cookies$1 = (
  utils$e.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$e.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$e.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$e.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$3 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$d = utils$k;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$d.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$d.trim(line.substr(0, i)).toLowerCase();
    val = utils$d.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var utils$c = utils$k;

var isURLSameOrigin$1 = (
  utils$c.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$c.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var AxiosError$4 = AxiosError_1;
var utils$b = utils$k;

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError$4(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError$4.call(this, message == null ? 'canceled' : message, AxiosError$4.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils$b.inherits(CanceledError$4, AxiosError$4, {
  __CANCEL__: true
});

var CanceledError_1 = CanceledError$4;

var parseProtocol$1 = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};

var utils$a = utils$k;
var settle$1 = settle$2;
var cookies = cookies$1;
var buildURL$2 = buildURL$3;
var buildFullPath$2 = buildFullPath$3;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var transitionalDefaults$2 = transitional;
var AxiosError$3 = AxiosError_1;
var CanceledError$3 = CanceledError_1;
var parseProtocol = parseProtocol$1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$a.isFormData(requestData) && utils$a.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath$2(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL$2(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle$1(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError$3('Request aborted', AxiosError$3.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError$3('Network Error', AxiosError$3.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults$2;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError$3(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError$3.ETIMEDOUT : AxiosError$3.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$a.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$a.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$a.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError$3() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError$3('Unsupported protocol ' + protocol + ':', AxiosError$3.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};

var followRedirects = {exports: {}};

var debug$1;

var debug_1 = function () {
  if (!debug$1) {
    try {
      /* eslint global-require: off */
      debug$1 = require("debug")("follow-redirects");
    }
    catch (error) { /* */ }
    if (typeof debug$1 !== "function") {
      debug$1 = function () { /* */ };
    }
  }
  debug$1.apply(null, arguments);
};

var url$1 = require$$1$5;
var URL$1 = url$1.URL;
var http$2 = require$$1$6;
var https$2 = require$$2$5;
var Writable = require$$3$1.Writable;
var assert = require$$4$1;
var debug = debug_1;

// Create handlers that pass events from native requests
var events$1 = ["abort", "aborted", "connect", "error", "socket", "timeout"];
var eventHandlers = Object.create(null);
events$1.forEach(function (event) {
  eventHandlers[event] = function (arg1, arg2, arg3) {
    this._redirectable.emit(event, arg1, arg2, arg3);
  };
});

// Error types with codes
var RedirectionError = createErrorType(
  "ERR_FR_REDIRECTION_FAILURE",
  "Redirected request failed"
);
var TooManyRedirectsError = createErrorType(
  "ERR_FR_TOO_MANY_REDIRECTS",
  "Maximum number of redirects exceeded"
);
var MaxBodyLengthExceededError = createErrorType(
  "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
  "Request body larger than maxBodyLength limit"
);
var WriteAfterEndError = createErrorType(
  "ERR_STREAM_WRITE_AFTER_END",
  "write after end"
);

// An HTTP(S) request that can be redirected
function RedirectableRequest(options, responseCallback) {
  // Initialize the request
  Writable.call(this);
  this._sanitizeOptions(options);
  this._options = options;
  this._ended = false;
  this._ending = false;
  this._redirectCount = 0;
  this._redirects = [];
  this._requestBodyLength = 0;
  this._requestBodyBuffers = [];

  // Attach a callback if passed
  if (responseCallback) {
    this.on("response", responseCallback);
  }

  // React to responses of native requests
  var self = this;
  this._onNativeResponse = function (response) {
    self._processResponse(response);
  };

  // Perform the first request
  this._performRequest();
}
RedirectableRequest.prototype = Object.create(Writable.prototype);

RedirectableRequest.prototype.abort = function () {
  abortRequest(this._currentRequest);
  this.emit("abort");
};

// Writes buffered data to the current native request
RedirectableRequest.prototype.write = function (data, encoding, callback) {
  // Writing is not allowed if end has been called
  if (this._ending) {
    throw new WriteAfterEndError();
  }

  // Validate input and shift parameters if necessary
  if (!(typeof data === "string" || typeof data === "object" && ("length" in data))) {
    throw new TypeError("data should be a string, Buffer or Uint8Array");
  }
  if (typeof encoding === "function") {
    callback = encoding;
    encoding = null;
  }

  // Ignore empty buffers, since writing them doesn't invoke the callback
  // https://github.com/nodejs/node/issues/22066
  if (data.length === 0) {
    if (callback) {
      callback();
    }
    return;
  }
  // Only write when we don't exceed the maximum body length
  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
    this._requestBodyLength += data.length;
    this._requestBodyBuffers.push({ data: data, encoding: encoding });
    this._currentRequest.write(data, encoding, callback);
  }
  // Error when we exceed the maximum body length
  else {
    this.emit("error", new MaxBodyLengthExceededError());
    this.abort();
  }
};

// Ends the current native request
RedirectableRequest.prototype.end = function (data, encoding, callback) {
  // Shift parameters if necessary
  if (typeof data === "function") {
    callback = data;
    data = encoding = null;
  }
  else if (typeof encoding === "function") {
    callback = encoding;
    encoding = null;
  }

  // Write data if needed and end
  if (!data) {
    this._ended = this._ending = true;
    this._currentRequest.end(null, null, callback);
  }
  else {
    var self = this;
    var currentRequest = this._currentRequest;
    this.write(data, encoding, function () {
      self._ended = true;
      currentRequest.end(null, null, callback);
    });
    this._ending = true;
  }
};

// Sets a header value on the current native request
RedirectableRequest.prototype.setHeader = function (name, value) {
  this._options.headers[name] = value;
  this._currentRequest.setHeader(name, value);
};

// Clears a header value on the current native request
RedirectableRequest.prototype.removeHeader = function (name) {
  delete this._options.headers[name];
  this._currentRequest.removeHeader(name);
};

// Global timeout for all underlying requests
RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
  var self = this;

  // Destroys the socket on timeout
  function destroyOnTimeout(socket) {
    socket.setTimeout(msecs);
    socket.removeListener("timeout", socket.destroy);
    socket.addListener("timeout", socket.destroy);
  }

  // Sets up a timer to trigger a timeout event
  function startTimer(socket) {
    if (self._timeout) {
      clearTimeout(self._timeout);
    }
    self._timeout = setTimeout(function () {
      self.emit("timeout");
      clearTimer();
    }, msecs);
    destroyOnTimeout(socket);
  }

  // Stops a timeout from triggering
  function clearTimer() {
    // Clear the timeout
    if (self._timeout) {
      clearTimeout(self._timeout);
      self._timeout = null;
    }

    // Clean up all attached listeners
    self.removeListener("abort", clearTimer);
    self.removeListener("error", clearTimer);
    self.removeListener("response", clearTimer);
    if (callback) {
      self.removeListener("timeout", callback);
    }
    if (!self.socket) {
      self._currentRequest.removeListener("socket", startTimer);
    }
  }

  // Attach callback if passed
  if (callback) {
    this.on("timeout", callback);
  }

  // Start the timer if or when the socket is opened
  if (this.socket) {
    startTimer(this.socket);
  }
  else {
    this._currentRequest.once("socket", startTimer);
  }

  // Clean up on events
  this.on("socket", destroyOnTimeout);
  this.on("abort", clearTimer);
  this.on("error", clearTimer);
  this.on("response", clearTimer);

  return this;
};

// Proxy all other public ClientRequest methods
[
  "flushHeaders", "getHeader",
  "setNoDelay", "setSocketKeepAlive",
].forEach(function (method) {
  RedirectableRequest.prototype[method] = function (a, b) {
    return this._currentRequest[method](a, b);
  };
});

// Proxy all public ClientRequest properties
["aborted", "connection", "socket"].forEach(function (property) {
  Object.defineProperty(RedirectableRequest.prototype, property, {
    get: function () { return this._currentRequest[property]; },
  });
});

RedirectableRequest.prototype._sanitizeOptions = function (options) {
  // Ensure headers are always present
  if (!options.headers) {
    options.headers = {};
  }

  // Since http.request treats host as an alias of hostname,
  // but the url module interprets host as hostname plus port,
  // eliminate the host property to avoid confusion.
  if (options.host) {
    // Use hostname if set, because it has precedence
    if (!options.hostname) {
      options.hostname = options.host;
    }
    delete options.host;
  }

  // Complete the URL object when necessary
  if (!options.pathname && options.path) {
    var searchPos = options.path.indexOf("?");
    if (searchPos < 0) {
      options.pathname = options.path;
    }
    else {
      options.pathname = options.path.substring(0, searchPos);
      options.search = options.path.substring(searchPos);
    }
  }
};


// Executes the next native request (initial or redirect)
RedirectableRequest.prototype._performRequest = function () {
  // Load the native protocol
  var protocol = this._options.protocol;
  var nativeProtocol = this._options.nativeProtocols[protocol];
  if (!nativeProtocol) {
    this.emit("error", new TypeError("Unsupported protocol " + protocol));
    return;
  }

  // If specified, use the agent corresponding to the protocol
  // (HTTP and HTTPS use different types of agents)
  if (this._options.agents) {
    var scheme = protocol.slice(0, -1);
    this._options.agent = this._options.agents[scheme];
  }

  // Create the native request and set up its event handlers
  var request = this._currentRequest =
        nativeProtocol.request(this._options, this._onNativeResponse);
  request._redirectable = this;
  for (var event of events$1) {
    request.on(event, eventHandlers[event]);
  }

  // RFC7230§5.3.1: When making a request directly to an origin server, […]
  // a client MUST send only the absolute path […] as the request-target.
  this._currentUrl = /^\//.test(this._options.path) ?
    url$1.format(this._options) :
    // When making a request to a proxy, […]
    // a client MUST send the target URI in absolute-form […].
    this._currentUrl = this._options.path;

  // End a redirected request
  // (The first request must be ended explicitly with RedirectableRequest#end)
  if (this._isRedirect) {
    // Write the request entity and end
    var i = 0;
    var self = this;
    var buffers = this._requestBodyBuffers;
    (function writeNext(error) {
      // Only write if this request has not been redirected yet
      /* istanbul ignore else */
      if (request === self._currentRequest) {
        // Report any write errors
        /* istanbul ignore if */
        if (error) {
          self.emit("error", error);
        }
        // Write the next buffer if there are still left
        else if (i < buffers.length) {
          var buffer = buffers[i++];
          /* istanbul ignore else */
          if (!request.finished) {
            request.write(buffer.data, buffer.encoding, writeNext);
          }
        }
        // End the request if `end` has been called on us
        else if (self._ended) {
          request.end();
        }
      }
    }());
  }
};

// Processes a response from the current native request
RedirectableRequest.prototype._processResponse = function (response) {
  // Store the redirected response
  var statusCode = response.statusCode;
  if (this._options.trackRedirects) {
    this._redirects.push({
      url: this._currentUrl,
      headers: response.headers,
      statusCode: statusCode,
    });
  }

  // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
  // that further action needs to be taken by the user agent in order to
  // fulfill the request. If a Location header field is provided,
  // the user agent MAY automatically redirect its request to the URI
  // referenced by the Location field value,
  // even if the specific status code is not understood.

  // If the response is not a redirect; return it as-is
  var location = response.headers.location;
  if (!location || this._options.followRedirects === false ||
      statusCode < 300 || statusCode >= 400) {
    response.responseUrl = this._currentUrl;
    response.redirects = this._redirects;
    this.emit("response", response);

    // Clean up
    this._requestBodyBuffers = [];
    return;
  }

  // The response is a redirect, so abort the current request
  abortRequest(this._currentRequest);
  // Discard the remainder of the response to avoid waiting for data
  response.destroy();

  // RFC7231§6.4: A client SHOULD detect and intervene
  // in cyclical redirections (i.e., "infinite" redirection loops).
  if (++this._redirectCount > this._options.maxRedirects) {
    this.emit("error", new TooManyRedirectsError());
    return;
  }

  // Store the request headers if applicable
  var requestHeaders;
  var beforeRedirect = this._options.beforeRedirect;
  if (beforeRedirect) {
    requestHeaders = Object.assign({
      // The Host header was set by nativeProtocol.request
      Host: response.req.getHeader("host"),
    }, this._options.headers);
  }

  // RFC7231§6.4: Automatic redirection needs to done with
  // care for methods not known to be safe, […]
  // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
  // the request method from POST to GET for the subsequent request.
  var method = this._options.method;
  if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
      // RFC7231§6.4.4: The 303 (See Other) status code indicates that
      // the server is redirecting the user agent to a different resource […]
      // A user agent can perform a retrieval request targeting that URI
      // (a GET or HEAD request if using HTTP) […]
      (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
    this._options.method = "GET";
    // Drop a possible entity and headers related to it
    this._requestBodyBuffers = [];
    removeMatchingHeaders(/^content-/i, this._options.headers);
  }

  // Drop the Host header, as the redirect might lead to a different host
  var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);

  // If the redirect is relative, carry over the host of the last request
  var currentUrlParts = url$1.parse(this._currentUrl);
  var currentHost = currentHostHeader || currentUrlParts.host;
  var currentUrl = /^\w+:/.test(location) ? this._currentUrl :
    url$1.format(Object.assign(currentUrlParts, { host: currentHost }));

  // Determine the URL of the redirection
  var redirectUrl;
  try {
    redirectUrl = url$1.resolve(currentUrl, location);
  }
  catch (cause) {
    this.emit("error", new RedirectionError(cause));
    return;
  }

  // Create the redirected request
  debug("redirecting to", redirectUrl);
  this._isRedirect = true;
  var redirectUrlParts = url$1.parse(redirectUrl);
  Object.assign(this._options, redirectUrlParts);

  // Drop confidential headers when redirecting to a less secure protocol
  // or to a different domain that is not a superdomain
  if (redirectUrlParts.protocol !== currentUrlParts.protocol &&
     redirectUrlParts.protocol !== "https:" ||
     redirectUrlParts.host !== currentHost &&
     !isSubdomain(redirectUrlParts.host, currentHost)) {
    removeMatchingHeaders(/^(?:authorization|cookie)$/i, this._options.headers);
  }

  // Evaluate the beforeRedirect callback
  if (typeof beforeRedirect === "function") {
    var responseDetails = {
      headers: response.headers,
      statusCode: statusCode,
    };
    var requestDetails = {
      url: currentUrl,
      method: method,
      headers: requestHeaders,
    };
    try {
      beforeRedirect(this._options, responseDetails, requestDetails);
    }
    catch (err) {
      this.emit("error", err);
      return;
    }
    this._sanitizeOptions(this._options);
  }

  // Perform the redirected request
  try {
    this._performRequest();
  }
  catch (cause) {
    this.emit("error", new RedirectionError(cause));
  }
};

// Wraps the key/value object of protocols with redirect functionality
function wrap(protocols) {
  // Default settings
  var exports = {
    maxRedirects: 21,
    maxBodyLength: 10 * 1024 * 1024,
  };

  // Wrap each protocol
  var nativeProtocols = {};
  Object.keys(protocols).forEach(function (scheme) {
    var protocol = scheme + ":";
    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

    // Executes a request, following redirects
    function request(input, options, callback) {
      // Parse parameters
      if (typeof input === "string") {
        var urlStr = input;
        try {
          input = urlToOptions(new URL$1(urlStr));
        }
        catch (err) {
          /* istanbul ignore next */
          input = url$1.parse(urlStr);
        }
      }
      else if (URL$1 && (input instanceof URL$1)) {
        input = urlToOptions(input);
      }
      else {
        callback = options;
        options = input;
        input = { protocol: protocol };
      }
      if (typeof options === "function") {
        callback = options;
        options = null;
      }

      // Set defaults
      options = Object.assign({
        maxRedirects: exports.maxRedirects,
        maxBodyLength: exports.maxBodyLength,
      }, input, options);
      options.nativeProtocols = nativeProtocols;

      assert.equal(options.protocol, protocol, "protocol mismatch");
      debug("options", options);
      return new RedirectableRequest(options, callback);
    }

    // Executes a GET request, following redirects
    function get(input, options, callback) {
      var wrappedRequest = wrappedProtocol.request(input, options, callback);
      wrappedRequest.end();
      return wrappedRequest;
    }

    // Expose the properties on the wrapped protocol
    Object.defineProperties(wrappedProtocol, {
      request: { value: request, configurable: true, enumerable: true, writable: true },
      get: { value: get, configurable: true, enumerable: true, writable: true },
    });
  });
  return exports;
}

/* istanbul ignore next */
function noop$3() { /* empty */ }

// from https://github.com/nodejs/node/blob/master/lib/internal/url.js
function urlToOptions(urlObject) {
  var options = {
    protocol: urlObject.protocol,
    hostname: urlObject.hostname.startsWith("[") ?
      /* istanbul ignore next */
      urlObject.hostname.slice(1, -1) :
      urlObject.hostname,
    hash: urlObject.hash,
    search: urlObject.search,
    pathname: urlObject.pathname,
    path: urlObject.pathname + urlObject.search,
    href: urlObject.href,
  };
  if (urlObject.port !== "") {
    options.port = Number(urlObject.port);
  }
  return options;
}

function removeMatchingHeaders(regex, headers) {
  var lastValue;
  for (var header in headers) {
    if (regex.test(header)) {
      lastValue = headers[header];
      delete headers[header];
    }
  }
  return (lastValue === null || typeof lastValue === "undefined") ?
    undefined : String(lastValue).trim();
}

function createErrorType(code, defaultMessage) {
  function CustomError(cause) {
    Error.captureStackTrace(this, this.constructor);
    if (!cause) {
      this.message = defaultMessage;
    }
    else {
      this.message = defaultMessage + ": " + cause.message;
      this.cause = cause;
    }
  }
  CustomError.prototype = new Error();
  CustomError.prototype.constructor = CustomError;
  CustomError.prototype.name = "Error [" + code + "]";
  CustomError.prototype.code = code;
  return CustomError;
}

function abortRequest(request) {
  for (var event of events$1) {
    request.removeListener(event, eventHandlers[event]);
  }
  request.on("error", noop$3);
  request.abort();
}

function isSubdomain(subdomain, domain) {
  const dot = subdomain.length - domain.length - 1;
  return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
}

// Exports
followRedirects.exports = wrap({ http: http$2, https: https$2 });
followRedirects.exports.wrap = wrap;

var data = {
  "version": "0.27.2"
};

var utils$9 = utils$k;
var settle = settle$2;
var buildFullPath$1 = buildFullPath$3;
var buildURL$1 = buildURL$3;
var http$1 = require$$1$6;
var https$1 = require$$2$5;
var httpFollow = followRedirects.exports.http;
var httpsFollow = followRedirects.exports.https;
var url = require$$1$5;
var zlib = require$$8;
var VERSION$1 = data.version;
var transitionalDefaults$1 = transitional;
var AxiosError$2 = AxiosError_1;
var CanceledError$2 = CanceledError_1;

var isHttps = /https:?/;

var supportedProtocols = [ 'http:', 'https:', 'file:' ];

/**
 *
 * @param {http.ClientRequestArgs} options
 * @param {AxiosProxyConfig} proxy
 * @param {string} location
 */
function setProxy(options, proxy, location) {
  options.hostname = proxy.host;
  options.host = proxy.host;
  options.port = proxy.port;
  options.path = location;

  // Basic proxy authorization
  if (proxy.auth) {
    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
  }

  // If a proxy is used, any redirects must also pass through the proxy
  options.beforeRedirect = function beforeRedirect(redirection) {
    redirection.headers.host = redirection.host;
    setProxy(redirection, proxy, redirection.href);
  };
}

/*eslint consistent-return:0*/
var http_1 = function httpAdapter(config) {
  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }
    var resolve = function resolve(value) {
      done();
      resolvePromise(value);
    };
    var rejected = false;
    var reject = function reject(value) {
      done();
      rejected = true;
      rejectPromise(value);
    };
    var data = config.data;
    var headers = config.headers;
    var headerNames = {};

    Object.keys(headers).forEach(function storeLowerName(name) {
      headerNames[name.toLowerCase()] = name;
    });

    // Set User-Agent (required by some servers)
    // See https://github.com/axios/axios/issues/69
    if ('user-agent' in headerNames) {
      // User-Agent is specified; handle case where no UA header is desired
      if (!headers[headerNames['user-agent']]) {
        delete headers[headerNames['user-agent']];
      }
      // Otherwise, use specified value
    } else {
      // Only set header if it hasn't been set in config
      headers['User-Agent'] = 'axios/' + VERSION$1;
    }

    // support for https://www.npmjs.com/package/form-data api
    if (utils$9.isFormData(data) && utils$9.isFunction(data.getHeaders)) {
      Object.assign(headers, data.getHeaders());
    } else if (data && !utils$9.isStream(data)) {
      if (Buffer.isBuffer(data)) ; else if (utils$9.isArrayBuffer(data)) {
        data = Buffer.from(new Uint8Array(data));
      } else if (utils$9.isString(data)) {
        data = Buffer.from(data, 'utf-8');
      } else {
        return reject(new AxiosError$2(
          'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
          AxiosError$2.ERR_BAD_REQUEST,
          config
        ));
      }

      if (config.maxBodyLength > -1 && data.length > config.maxBodyLength) {
        return reject(new AxiosError$2(
          'Request body larger than maxBodyLength limit',
          AxiosError$2.ERR_BAD_REQUEST,
          config
        ));
      }

      // Add Content-Length header if data exists
      if (!headerNames['content-length']) {
        headers['Content-Length'] = data.length;
      }
    }

    // HTTP basic authentication
    var auth = undefined;
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      auth = username + ':' + password;
    }

    // Parse url
    var fullPath = buildFullPath$1(config.baseURL, config.url);
    var parsed = url.parse(fullPath);
    var protocol = parsed.protocol || supportedProtocols[0];

    if (supportedProtocols.indexOf(protocol) === -1) {
      return reject(new AxiosError$2(
        'Unsupported protocol ' + protocol,
        AxiosError$2.ERR_BAD_REQUEST,
        config
      ));
    }

    if (!auth && parsed.auth) {
      var urlAuth = parsed.auth.split(':');
      var urlUsername = urlAuth[0] || '';
      var urlPassword = urlAuth[1] || '';
      auth = urlUsername + ':' + urlPassword;
    }

    if (auth && headerNames.authorization) {
      delete headers[headerNames.authorization];
    }

    var isHttpsRequest = isHttps.test(protocol);
    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

    try {
      buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, '');
    } catch (err) {
      var customErr = new Error(err.message);
      customErr.config = config;
      customErr.url = config.url;
      customErr.exists = true;
      reject(customErr);
    }

    var options = {
      path: buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
      method: config.method.toUpperCase(),
      headers: headers,
      agent: agent,
      agents: { http: config.httpAgent, https: config.httpsAgent },
      auth: auth
    };

    if (config.socketPath) {
      options.socketPath = config.socketPath;
    } else {
      options.hostname = parsed.hostname;
      options.port = parsed.port;
    }

    var proxy = config.proxy;
    if (!proxy && proxy !== false) {
      var proxyEnv = protocol.slice(0, -1) + '_proxy';
      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
      if (proxyUrl) {
        var parsedProxyUrl = url.parse(proxyUrl);
        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
        var shouldProxy = true;

        if (noProxyEnv) {
          var noProxy = noProxyEnv.split(',').map(function trim(s) {
            return s.trim();
          });

          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
            if (!proxyElement) {
              return false;
            }
            if (proxyElement === '*') {
              return true;
            }
            if (proxyElement[0] === '.' &&
                parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
              return true;
            }

            return parsed.hostname === proxyElement;
          });
        }

        if (shouldProxy) {
          proxy = {
            host: parsedProxyUrl.hostname,
            port: parsedProxyUrl.port,
            protocol: parsedProxyUrl.protocol
          };

          if (parsedProxyUrl.auth) {
            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
            proxy.auth = {
              username: proxyUrlAuth[0],
              password: proxyUrlAuth[1]
            };
          }
        }
      }
    }

    if (proxy) {
      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
    }

    var transport;
    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
    if (config.transport) {
      transport = config.transport;
    } else if (config.maxRedirects === 0) {
      transport = isHttpsProxy ? https$1 : http$1;
    } else {
      if (config.maxRedirects) {
        options.maxRedirects = config.maxRedirects;
      }
      if (config.beforeRedirect) {
        options.beforeRedirect = config.beforeRedirect;
      }
      transport = isHttpsProxy ? httpsFollow : httpFollow;
    }

    if (config.maxBodyLength > -1) {
      options.maxBodyLength = config.maxBodyLength;
    }

    if (config.insecureHTTPParser) {
      options.insecureHTTPParser = config.insecureHTTPParser;
    }

    // Create the request
    var req = transport.request(options, function handleResponse(res) {
      if (req.aborted) return;

      // uncompress the response body transparently if required
      var stream = res;

      // return the last request in case of redirects
      var lastRequest = res.req || req;


      // if no content, is HEAD request or decompress disabled we should not decompress
      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
        switch (res.headers['content-encoding']) {
        /*eslint default-case:0*/
        case 'gzip':
        case 'compress':
        case 'deflate':
        // add the unzipper to the body stream processing pipeline
          stream = stream.pipe(zlib.createUnzip());

          // remove the content-encoding in order to not confuse downstream operations
          delete res.headers['content-encoding'];
          break;
        }
      }

      var response = {
        status: res.statusCode,
        statusText: res.statusMessage,
        headers: res.headers,
        config: config,
        request: lastRequest
      };

      if (config.responseType === 'stream') {
        response.data = stream;
        settle(resolve, reject, response);
      } else {
        var responseBuffer = [];
        var totalResponseBytes = 0;
        stream.on('data', function handleStreamData(chunk) {
          responseBuffer.push(chunk);
          totalResponseBytes += chunk.length;

          // make sure the content length is not over the maxContentLength if specified
          if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
            // stream.destoy() emit aborted event before calling reject() on Node.js v16
            rejected = true;
            stream.destroy();
            reject(new AxiosError$2('maxContentLength size of ' + config.maxContentLength + ' exceeded',
              AxiosError$2.ERR_BAD_RESPONSE, config, lastRequest));
          }
        });

        stream.on('aborted', function handlerStreamAborted() {
          if (rejected) {
            return;
          }
          stream.destroy();
          reject(new AxiosError$2(
            'maxContentLength size of ' + config.maxContentLength + ' exceeded',
            AxiosError$2.ERR_BAD_RESPONSE,
            config,
            lastRequest
          ));
        });

        stream.on('error', function handleStreamError(err) {
          if (req.aborted) return;
          reject(AxiosError$2.from(err, null, config, lastRequest));
        });

        stream.on('end', function handleStreamEnd() {
          try {
            var responseData = responseBuffer.length === 1 ? responseBuffer[0] : Buffer.concat(responseBuffer);
            if (config.responseType !== 'arraybuffer') {
              responseData = responseData.toString(config.responseEncoding);
              if (!config.responseEncoding || config.responseEncoding === 'utf8') {
                responseData = utils$9.stripBOM(responseData);
              }
            }
            response.data = responseData;
          } catch (err) {
            reject(AxiosError$2.from(err, null, config, response.request, response));
          }
          settle(resolve, reject, response);
        });
      }
    });

    // Handle errors
    req.on('error', function handleRequestError(err) {
      // @todo remove
      // if (req.aborted && err.code !== AxiosError.ERR_FR_TOO_MANY_REDIRECTS) return;
      reject(AxiosError$2.from(err, null, config, req));
    });

    // set tcp keep alive to prevent drop connection by peer
    req.on('socket', function handleRequestSocket(socket) {
      // default interval of sending ack packet is 1 minute
      socket.setKeepAlive(true, 1000 * 60);
    });

    // Handle request timeout
    if (config.timeout) {
      // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
      var timeout = parseInt(config.timeout, 10);

      if (isNaN(timeout)) {
        reject(new AxiosError$2(
          'error trying to parse `config.timeout` to int',
          AxiosError$2.ERR_BAD_OPTION_VALUE,
          config,
          req
        ));

        return;
      }

      // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
      // And then these socket which be hang up will devoring CPU little by little.
      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
      req.setTimeout(timeout, function handleRequestTimeout() {
        req.abort();
        var transitional = config.transitional || transitionalDefaults$1;
        reject(new AxiosError$2(
          'timeout of ' + timeout + 'ms exceeded',
          transitional.clarifyTimeoutError ? AxiosError$2.ETIMEDOUT : AxiosError$2.ECONNABORTED,
          config,
          req
        ));
      });
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (req.aborted) return;

        req.abort();
        reject(!cancel || (cancel && cancel.type) ? new CanceledError$2() : cancel);
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }


    // Send the request
    if (utils$9.isStream(data)) {
      data.on('error', function handleStreamError(err) {
        reject(AxiosError$2.from(err, config, null, req));
      }).pipe(req);
    } else {
      req.end(data);
    }
  });
};

var Stream$2 = require$$3$1.Stream;
var util$2 = require$$1$7;

var delayed_stream = DelayedStream$1;
function DelayedStream$1() {
  this.source = null;
  this.dataSize = 0;
  this.maxDataSize = 1024 * 1024;
  this.pauseStream = true;

  this._maxDataSizeExceeded = false;
  this._released = false;
  this._bufferedEvents = [];
}
util$2.inherits(DelayedStream$1, Stream$2);

DelayedStream$1.create = function(source, options) {
  var delayedStream = new this();

  options = options || {};
  for (var option in options) {
    delayedStream[option] = options[option];
  }

  delayedStream.source = source;

  var realEmit = source.emit;
  source.emit = function() {
    delayedStream._handleEmit(arguments);
    return realEmit.apply(source, arguments);
  };

  source.on('error', function() {});
  if (delayedStream.pauseStream) {
    source.pause();
  }

  return delayedStream;
};

Object.defineProperty(DelayedStream$1.prototype, 'readable', {
  configurable: true,
  enumerable: true,
  get: function() {
    return this.source.readable;
  }
});

DelayedStream$1.prototype.setEncoding = function() {
  return this.source.setEncoding.apply(this.source, arguments);
};

DelayedStream$1.prototype.resume = function() {
  if (!this._released) {
    this.release();
  }

  this.source.resume();
};

DelayedStream$1.prototype.pause = function() {
  this.source.pause();
};

DelayedStream$1.prototype.release = function() {
  this._released = true;

  this._bufferedEvents.forEach(function(args) {
    this.emit.apply(this, args);
  }.bind(this));
  this._bufferedEvents = [];
};

DelayedStream$1.prototype.pipe = function() {
  var r = Stream$2.prototype.pipe.apply(this, arguments);
  this.resume();
  return r;
};

DelayedStream$1.prototype._handleEmit = function(args) {
  if (this._released) {
    this.emit.apply(this, args);
    return;
  }

  if (args[0] === 'data') {
    this.dataSize += args[1].length;
    this._checkIfMaxDataSizeExceeded();
  }

  this._bufferedEvents.push(args);
};

DelayedStream$1.prototype._checkIfMaxDataSizeExceeded = function() {
  if (this._maxDataSizeExceeded) {
    return;
  }

  if (this.dataSize <= this.maxDataSize) {
    return;
  }

  this._maxDataSizeExceeded = true;
  var message =
    'DelayedStream#maxDataSize of ' + this.maxDataSize + ' bytes exceeded.';
  this.emit('error', new Error(message));
};

var util$1 = require$$1$7;
var Stream$1 = require$$3$1.Stream;
var DelayedStream = delayed_stream;

var combined_stream = CombinedStream$1;
function CombinedStream$1() {
  this.writable = false;
  this.readable = true;
  this.dataSize = 0;
  this.maxDataSize = 2 * 1024 * 1024;
  this.pauseStreams = true;

  this._released = false;
  this._streams = [];
  this._currentStream = null;
  this._insideLoop = false;
  this._pendingNext = false;
}
util$1.inherits(CombinedStream$1, Stream$1);

CombinedStream$1.create = function(options) {
  var combinedStream = new this();

  options = options || {};
  for (var option in options) {
    combinedStream[option] = options[option];
  }

  return combinedStream;
};

CombinedStream$1.isStreamLike = function(stream) {
  return (typeof stream !== 'function')
    && (typeof stream !== 'string')
    && (typeof stream !== 'boolean')
    && (typeof stream !== 'number')
    && (!Buffer.isBuffer(stream));
};

CombinedStream$1.prototype.append = function(stream) {
  var isStreamLike = CombinedStream$1.isStreamLike(stream);

  if (isStreamLike) {
    if (!(stream instanceof DelayedStream)) {
      var newStream = DelayedStream.create(stream, {
        maxDataSize: Infinity,
        pauseStream: this.pauseStreams,
      });
      stream.on('data', this._checkDataSize.bind(this));
      stream = newStream;
    }

    this._handleErrors(stream);

    if (this.pauseStreams) {
      stream.pause();
    }
  }

  this._streams.push(stream);
  return this;
};

CombinedStream$1.prototype.pipe = function(dest, options) {
  Stream$1.prototype.pipe.call(this, dest, options);
  this.resume();
  return dest;
};

CombinedStream$1.prototype._getNext = function() {
  this._currentStream = null;

  if (this._insideLoop) {
    this._pendingNext = true;
    return; // defer call
  }

  this._insideLoop = true;
  try {
    do {
      this._pendingNext = false;
      this._realGetNext();
    } while (this._pendingNext);
  } finally {
    this._insideLoop = false;
  }
};

CombinedStream$1.prototype._realGetNext = function() {
  var stream = this._streams.shift();


  if (typeof stream == 'undefined') {
    this.end();
    return;
  }

  if (typeof stream !== 'function') {
    this._pipeNext(stream);
    return;
  }

  var getStream = stream;
  getStream(function(stream) {
    var isStreamLike = CombinedStream$1.isStreamLike(stream);
    if (isStreamLike) {
      stream.on('data', this._checkDataSize.bind(this));
      this._handleErrors(stream);
    }

    this._pipeNext(stream);
  }.bind(this));
};

CombinedStream$1.prototype._pipeNext = function(stream) {
  this._currentStream = stream;

  var isStreamLike = CombinedStream$1.isStreamLike(stream);
  if (isStreamLike) {
    stream.on('end', this._getNext.bind(this));
    stream.pipe(this, {end: false});
    return;
  }

  var value = stream;
  this.write(value);
  this._getNext();
};

CombinedStream$1.prototype._handleErrors = function(stream) {
  var self = this;
  stream.on('error', function(err) {
    self._emitError(err);
  });
};

CombinedStream$1.prototype.write = function(data) {
  this.emit('data', data);
};

CombinedStream$1.prototype.pause = function() {
  if (!this.pauseStreams) {
    return;
  }

  if(this.pauseStreams && this._currentStream && typeof(this._currentStream.pause) == 'function') this._currentStream.pause();
  this.emit('pause');
};

CombinedStream$1.prototype.resume = function() {
  if (!this._released) {
    this._released = true;
    this.writable = true;
    this._getNext();
  }

  if(this.pauseStreams && this._currentStream && typeof(this._currentStream.resume) == 'function') this._currentStream.resume();
  this.emit('resume');
};

CombinedStream$1.prototype.end = function() {
  this._reset();
  this.emit('end');
};

CombinedStream$1.prototype.destroy = function() {
  this._reset();
  this.emit('close');
};

CombinedStream$1.prototype._reset = function() {
  this.writable = false;
  this._streams = [];
  this._currentStream = null;
};

CombinedStream$1.prototype._checkDataSize = function() {
  this._updateDataSize();
  if (this.dataSize <= this.maxDataSize) {
    return;
  }

  var message =
    'DelayedStream#maxDataSize of ' + this.maxDataSize + ' bytes exceeded.';
  this._emitError(new Error(message));
};

CombinedStream$1.prototype._updateDataSize = function() {
  this.dataSize = 0;

  var self = this;
  this._streams.forEach(function(stream) {
    if (!stream.dataSize) {
      return;
    }

    self.dataSize += stream.dataSize;
  });

  if (this._currentStream && this._currentStream.dataSize) {
    this.dataSize += this._currentStream.dataSize;
  }
};

CombinedStream$1.prototype._emitError = function(err) {
  this._reset();
  this.emit('error', err);
};

var mimeTypes = {};

var require$$0$1 = {
	"application/1d-interleaved-parityfec": {
	source: "iana"
},
	"application/3gpdash-qoe-report+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/3gpp-ims+xml": {
	source: "iana",
	compressible: true
},
	"application/3gpphal+json": {
	source: "iana",
	compressible: true
},
	"application/3gpphalforms+json": {
	source: "iana",
	compressible: true
},
	"application/a2l": {
	source: "iana"
},
	"application/ace+cbor": {
	source: "iana"
},
	"application/activemessage": {
	source: "iana"
},
	"application/activity+json": {
	source: "iana",
	compressible: true
},
	"application/alto-costmap+json": {
	source: "iana",
	compressible: true
},
	"application/alto-costmapfilter+json": {
	source: "iana",
	compressible: true
},
	"application/alto-directory+json": {
	source: "iana",
	compressible: true
},
	"application/alto-endpointcost+json": {
	source: "iana",
	compressible: true
},
	"application/alto-endpointcostparams+json": {
	source: "iana",
	compressible: true
},
	"application/alto-endpointprop+json": {
	source: "iana",
	compressible: true
},
	"application/alto-endpointpropparams+json": {
	source: "iana",
	compressible: true
},
	"application/alto-error+json": {
	source: "iana",
	compressible: true
},
	"application/alto-networkmap+json": {
	source: "iana",
	compressible: true
},
	"application/alto-networkmapfilter+json": {
	source: "iana",
	compressible: true
},
	"application/alto-updatestreamcontrol+json": {
	source: "iana",
	compressible: true
},
	"application/alto-updatestreamparams+json": {
	source: "iana",
	compressible: true
},
	"application/aml": {
	source: "iana"
},
	"application/andrew-inset": {
	source: "iana",
	extensions: [
		"ez"
	]
},
	"application/applefile": {
	source: "iana"
},
	"application/applixware": {
	source: "apache",
	extensions: [
		"aw"
	]
},
	"application/at+jwt": {
	source: "iana"
},
	"application/atf": {
	source: "iana"
},
	"application/atfx": {
	source: "iana"
},
	"application/atom+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"atom"
	]
},
	"application/atomcat+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"atomcat"
	]
},
	"application/atomdeleted+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"atomdeleted"
	]
},
	"application/atomicmail": {
	source: "iana"
},
	"application/atomsvc+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"atomsvc"
	]
},
	"application/atsc-dwd+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"dwd"
	]
},
	"application/atsc-dynamic-event-message": {
	source: "iana"
},
	"application/atsc-held+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"held"
	]
},
	"application/atsc-rdt+json": {
	source: "iana",
	compressible: true
},
	"application/atsc-rsat+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rsat"
	]
},
	"application/atxml": {
	source: "iana"
},
	"application/auth-policy+xml": {
	source: "iana",
	compressible: true
},
	"application/bacnet-xdd+zip": {
	source: "iana",
	compressible: false
},
	"application/batch-smtp": {
	source: "iana"
},
	"application/bdoc": {
	compressible: false,
	extensions: [
		"bdoc"
	]
},
	"application/beep+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/calendar+json": {
	source: "iana",
	compressible: true
},
	"application/calendar+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xcs"
	]
},
	"application/call-completion": {
	source: "iana"
},
	"application/cals-1840": {
	source: "iana"
},
	"application/captive+json": {
	source: "iana",
	compressible: true
},
	"application/cbor": {
	source: "iana"
},
	"application/cbor-seq": {
	source: "iana"
},
	"application/cccex": {
	source: "iana"
},
	"application/ccmp+xml": {
	source: "iana",
	compressible: true
},
	"application/ccxml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"ccxml"
	]
},
	"application/cdfx+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"cdfx"
	]
},
	"application/cdmi-capability": {
	source: "iana",
	extensions: [
		"cdmia"
	]
},
	"application/cdmi-container": {
	source: "iana",
	extensions: [
		"cdmic"
	]
},
	"application/cdmi-domain": {
	source: "iana",
	extensions: [
		"cdmid"
	]
},
	"application/cdmi-object": {
	source: "iana",
	extensions: [
		"cdmio"
	]
},
	"application/cdmi-queue": {
	source: "iana",
	extensions: [
		"cdmiq"
	]
},
	"application/cdni": {
	source: "iana"
},
	"application/cea": {
	source: "iana"
},
	"application/cea-2018+xml": {
	source: "iana",
	compressible: true
},
	"application/cellml+xml": {
	source: "iana",
	compressible: true
},
	"application/cfw": {
	source: "iana"
},
	"application/city+json": {
	source: "iana",
	compressible: true
},
	"application/clr": {
	source: "iana"
},
	"application/clue+xml": {
	source: "iana",
	compressible: true
},
	"application/clue_info+xml": {
	source: "iana",
	compressible: true
},
	"application/cms": {
	source: "iana"
},
	"application/cnrp+xml": {
	source: "iana",
	compressible: true
},
	"application/coap-group+json": {
	source: "iana",
	compressible: true
},
	"application/coap-payload": {
	source: "iana"
},
	"application/commonground": {
	source: "iana"
},
	"application/conference-info+xml": {
	source: "iana",
	compressible: true
},
	"application/cose": {
	source: "iana"
},
	"application/cose-key": {
	source: "iana"
},
	"application/cose-key-set": {
	source: "iana"
},
	"application/cpl+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"cpl"
	]
},
	"application/csrattrs": {
	source: "iana"
},
	"application/csta+xml": {
	source: "iana",
	compressible: true
},
	"application/cstadata+xml": {
	source: "iana",
	compressible: true
},
	"application/csvm+json": {
	source: "iana",
	compressible: true
},
	"application/cu-seeme": {
	source: "apache",
	extensions: [
		"cu"
	]
},
	"application/cwt": {
	source: "iana"
},
	"application/cybercash": {
	source: "iana"
},
	"application/dart": {
	compressible: true
},
	"application/dash+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mpd"
	]
},
	"application/dash-patch+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mpp"
	]
},
	"application/dashdelta": {
	source: "iana"
},
	"application/davmount+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"davmount"
	]
},
	"application/dca-rft": {
	source: "iana"
},
	"application/dcd": {
	source: "iana"
},
	"application/dec-dx": {
	source: "iana"
},
	"application/dialog-info+xml": {
	source: "iana",
	compressible: true
},
	"application/dicom": {
	source: "iana"
},
	"application/dicom+json": {
	source: "iana",
	compressible: true
},
	"application/dicom+xml": {
	source: "iana",
	compressible: true
},
	"application/dii": {
	source: "iana"
},
	"application/dit": {
	source: "iana"
},
	"application/dns": {
	source: "iana"
},
	"application/dns+json": {
	source: "iana",
	compressible: true
},
	"application/dns-message": {
	source: "iana"
},
	"application/docbook+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"dbk"
	]
},
	"application/dots+cbor": {
	source: "iana"
},
	"application/dskpp+xml": {
	source: "iana",
	compressible: true
},
	"application/dssc+der": {
	source: "iana",
	extensions: [
		"dssc"
	]
},
	"application/dssc+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xdssc"
	]
},
	"application/dvcs": {
	source: "iana"
},
	"application/ecmascript": {
	source: "iana",
	compressible: true,
	extensions: [
		"es",
		"ecma"
	]
},
	"application/edi-consent": {
	source: "iana"
},
	"application/edi-x12": {
	source: "iana",
	compressible: false
},
	"application/edifact": {
	source: "iana",
	compressible: false
},
	"application/efi": {
	source: "iana"
},
	"application/elm+json": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/elm+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.cap+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/emergencycalldata.comment+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.control+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.deviceinfo+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.ecall.msd": {
	source: "iana"
},
	"application/emergencycalldata.providerinfo+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.serviceinfo+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.subscriberinfo+xml": {
	source: "iana",
	compressible: true
},
	"application/emergencycalldata.veds+xml": {
	source: "iana",
	compressible: true
},
	"application/emma+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"emma"
	]
},
	"application/emotionml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"emotionml"
	]
},
	"application/encaprtp": {
	source: "iana"
},
	"application/epp+xml": {
	source: "iana",
	compressible: true
},
	"application/epub+zip": {
	source: "iana",
	compressible: false,
	extensions: [
		"epub"
	]
},
	"application/eshop": {
	source: "iana"
},
	"application/exi": {
	source: "iana",
	extensions: [
		"exi"
	]
},
	"application/expect-ct-report+json": {
	source: "iana",
	compressible: true
},
	"application/express": {
	source: "iana",
	extensions: [
		"exp"
	]
},
	"application/fastinfoset": {
	source: "iana"
},
	"application/fastsoap": {
	source: "iana"
},
	"application/fdt+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"fdt"
	]
},
	"application/fhir+json": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/fhir+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/fido.trusted-apps+json": {
	compressible: true
},
	"application/fits": {
	source: "iana"
},
	"application/flexfec": {
	source: "iana"
},
	"application/font-sfnt": {
	source: "iana"
},
	"application/font-tdpfr": {
	source: "iana",
	extensions: [
		"pfr"
	]
},
	"application/font-woff": {
	source: "iana",
	compressible: false
},
	"application/framework-attributes+xml": {
	source: "iana",
	compressible: true
},
	"application/geo+json": {
	source: "iana",
	compressible: true,
	extensions: [
		"geojson"
	]
},
	"application/geo+json-seq": {
	source: "iana"
},
	"application/geopackage+sqlite3": {
	source: "iana"
},
	"application/geoxacml+xml": {
	source: "iana",
	compressible: true
},
	"application/gltf-buffer": {
	source: "iana"
},
	"application/gml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"gml"
	]
},
	"application/gpx+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"gpx"
	]
},
	"application/gxf": {
	source: "apache",
	extensions: [
		"gxf"
	]
},
	"application/gzip": {
	source: "iana",
	compressible: false,
	extensions: [
		"gz"
	]
},
	"application/h224": {
	source: "iana"
},
	"application/held+xml": {
	source: "iana",
	compressible: true
},
	"application/hjson": {
	extensions: [
		"hjson"
	]
},
	"application/http": {
	source: "iana"
},
	"application/hyperstudio": {
	source: "iana",
	extensions: [
		"stk"
	]
},
	"application/ibe-key-request+xml": {
	source: "iana",
	compressible: true
},
	"application/ibe-pkg-reply+xml": {
	source: "iana",
	compressible: true
},
	"application/ibe-pp-data": {
	source: "iana"
},
	"application/iges": {
	source: "iana"
},
	"application/im-iscomposing+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/index": {
	source: "iana"
},
	"application/index.cmd": {
	source: "iana"
},
	"application/index.obj": {
	source: "iana"
},
	"application/index.response": {
	source: "iana"
},
	"application/index.vnd": {
	source: "iana"
},
	"application/inkml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"ink",
		"inkml"
	]
},
	"application/iotp": {
	source: "iana"
},
	"application/ipfix": {
	source: "iana",
	extensions: [
		"ipfix"
	]
},
	"application/ipp": {
	source: "iana"
},
	"application/isup": {
	source: "iana"
},
	"application/its+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"its"
	]
},
	"application/java-archive": {
	source: "apache",
	compressible: false,
	extensions: [
		"jar",
		"war",
		"ear"
	]
},
	"application/java-serialized-object": {
	source: "apache",
	compressible: false,
	extensions: [
		"ser"
	]
},
	"application/java-vm": {
	source: "apache",
	compressible: false,
	extensions: [
		"class"
	]
},
	"application/javascript": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"js",
		"mjs"
	]
},
	"application/jf2feed+json": {
	source: "iana",
	compressible: true
},
	"application/jose": {
	source: "iana"
},
	"application/jose+json": {
	source: "iana",
	compressible: true
},
	"application/jrd+json": {
	source: "iana",
	compressible: true
},
	"application/jscalendar+json": {
	source: "iana",
	compressible: true
},
	"application/json": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"json",
		"map"
	]
},
	"application/json-patch+json": {
	source: "iana",
	compressible: true
},
	"application/json-seq": {
	source: "iana"
},
	"application/json5": {
	extensions: [
		"json5"
	]
},
	"application/jsonml+json": {
	source: "apache",
	compressible: true,
	extensions: [
		"jsonml"
	]
},
	"application/jwk+json": {
	source: "iana",
	compressible: true
},
	"application/jwk-set+json": {
	source: "iana",
	compressible: true
},
	"application/jwt": {
	source: "iana"
},
	"application/kpml-request+xml": {
	source: "iana",
	compressible: true
},
	"application/kpml-response+xml": {
	source: "iana",
	compressible: true
},
	"application/ld+json": {
	source: "iana",
	compressible: true,
	extensions: [
		"jsonld"
	]
},
	"application/lgr+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"lgr"
	]
},
	"application/link-format": {
	source: "iana"
},
	"application/load-control+xml": {
	source: "iana",
	compressible: true
},
	"application/lost+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"lostxml"
	]
},
	"application/lostsync+xml": {
	source: "iana",
	compressible: true
},
	"application/lpf+zip": {
	source: "iana",
	compressible: false
},
	"application/lxf": {
	source: "iana"
},
	"application/mac-binhex40": {
	source: "iana",
	extensions: [
		"hqx"
	]
},
	"application/mac-compactpro": {
	source: "apache",
	extensions: [
		"cpt"
	]
},
	"application/macwriteii": {
	source: "iana"
},
	"application/mads+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mads"
	]
},
	"application/manifest+json": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"webmanifest"
	]
},
	"application/marc": {
	source: "iana",
	extensions: [
		"mrc"
	]
},
	"application/marcxml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mrcx"
	]
},
	"application/mathematica": {
	source: "iana",
	extensions: [
		"ma",
		"nb",
		"mb"
	]
},
	"application/mathml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mathml"
	]
},
	"application/mathml-content+xml": {
	source: "iana",
	compressible: true
},
	"application/mathml-presentation+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-associated-procedure-description+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-deregister+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-envelope+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-msk+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-msk-response+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-protection-description+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-reception-report+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-register+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-register-response+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-schedule+xml": {
	source: "iana",
	compressible: true
},
	"application/mbms-user-service-description+xml": {
	source: "iana",
	compressible: true
},
	"application/mbox": {
	source: "iana",
	extensions: [
		"mbox"
	]
},
	"application/media-policy-dataset+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mpf"
	]
},
	"application/media_control+xml": {
	source: "iana",
	compressible: true
},
	"application/mediaservercontrol+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mscml"
	]
},
	"application/merge-patch+json": {
	source: "iana",
	compressible: true
},
	"application/metalink+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"metalink"
	]
},
	"application/metalink4+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"meta4"
	]
},
	"application/mets+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mets"
	]
},
	"application/mf4": {
	source: "iana"
},
	"application/mikey": {
	source: "iana"
},
	"application/mipc": {
	source: "iana"
},
	"application/missing-blocks+cbor-seq": {
	source: "iana"
},
	"application/mmt-aei+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"maei"
	]
},
	"application/mmt-usd+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"musd"
	]
},
	"application/mods+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mods"
	]
},
	"application/moss-keys": {
	source: "iana"
},
	"application/moss-signature": {
	source: "iana"
},
	"application/mosskey-data": {
	source: "iana"
},
	"application/mosskey-request": {
	source: "iana"
},
	"application/mp21": {
	source: "iana",
	extensions: [
		"m21",
		"mp21"
	]
},
	"application/mp4": {
	source: "iana",
	extensions: [
		"mp4s",
		"m4p"
	]
},
	"application/mpeg4-generic": {
	source: "iana"
},
	"application/mpeg4-iod": {
	source: "iana"
},
	"application/mpeg4-iod-xmt": {
	source: "iana"
},
	"application/mrb-consumer+xml": {
	source: "iana",
	compressible: true
},
	"application/mrb-publish+xml": {
	source: "iana",
	compressible: true
},
	"application/msc-ivr+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/msc-mixer+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/msword": {
	source: "iana",
	compressible: false,
	extensions: [
		"doc",
		"dot"
	]
},
	"application/mud+json": {
	source: "iana",
	compressible: true
},
	"application/multipart-core": {
	source: "iana"
},
	"application/mxf": {
	source: "iana",
	extensions: [
		"mxf"
	]
},
	"application/n-quads": {
	source: "iana",
	extensions: [
		"nq"
	]
},
	"application/n-triples": {
	source: "iana",
	extensions: [
		"nt"
	]
},
	"application/nasdata": {
	source: "iana"
},
	"application/news-checkgroups": {
	source: "iana",
	charset: "US-ASCII"
},
	"application/news-groupinfo": {
	source: "iana",
	charset: "US-ASCII"
},
	"application/news-transmission": {
	source: "iana"
},
	"application/nlsml+xml": {
	source: "iana",
	compressible: true
},
	"application/node": {
	source: "iana",
	extensions: [
		"cjs"
	]
},
	"application/nss": {
	source: "iana"
},
	"application/oauth-authz-req+jwt": {
	source: "iana"
},
	"application/oblivious-dns-message": {
	source: "iana"
},
	"application/ocsp-request": {
	source: "iana"
},
	"application/ocsp-response": {
	source: "iana"
},
	"application/octet-stream": {
	source: "iana",
	compressible: false,
	extensions: [
		"bin",
		"dms",
		"lrf",
		"mar",
		"so",
		"dist",
		"distz",
		"pkg",
		"bpk",
		"dump",
		"elc",
		"deploy",
		"exe",
		"dll",
		"deb",
		"dmg",
		"iso",
		"img",
		"msi",
		"msp",
		"msm",
		"buffer"
	]
},
	"application/oda": {
	source: "iana",
	extensions: [
		"oda"
	]
},
	"application/odm+xml": {
	source: "iana",
	compressible: true
},
	"application/odx": {
	source: "iana"
},
	"application/oebps-package+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"opf"
	]
},
	"application/ogg": {
	source: "iana",
	compressible: false,
	extensions: [
		"ogx"
	]
},
	"application/omdoc+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"omdoc"
	]
},
	"application/onenote": {
	source: "apache",
	extensions: [
		"onetoc",
		"onetoc2",
		"onetmp",
		"onepkg"
	]
},
	"application/opc-nodeset+xml": {
	source: "iana",
	compressible: true
},
	"application/oscore": {
	source: "iana"
},
	"application/oxps": {
	source: "iana",
	extensions: [
		"oxps"
	]
},
	"application/p21": {
	source: "iana"
},
	"application/p21+zip": {
	source: "iana",
	compressible: false
},
	"application/p2p-overlay+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"relo"
	]
},
	"application/parityfec": {
	source: "iana"
},
	"application/passport": {
	source: "iana"
},
	"application/patch-ops-error+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xer"
	]
},
	"application/pdf": {
	source: "iana",
	compressible: false,
	extensions: [
		"pdf"
	]
},
	"application/pdx": {
	source: "iana"
},
	"application/pem-certificate-chain": {
	source: "iana"
},
	"application/pgp-encrypted": {
	source: "iana",
	compressible: false,
	extensions: [
		"pgp"
	]
},
	"application/pgp-keys": {
	source: "iana",
	extensions: [
		"asc"
	]
},
	"application/pgp-signature": {
	source: "iana",
	extensions: [
		"asc",
		"sig"
	]
},
	"application/pics-rules": {
	source: "apache",
	extensions: [
		"prf"
	]
},
	"application/pidf+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/pidf-diff+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/pkcs10": {
	source: "iana",
	extensions: [
		"p10"
	]
},
	"application/pkcs12": {
	source: "iana"
},
	"application/pkcs7-mime": {
	source: "iana",
	extensions: [
		"p7m",
		"p7c"
	]
},
	"application/pkcs7-signature": {
	source: "iana",
	extensions: [
		"p7s"
	]
},
	"application/pkcs8": {
	source: "iana",
	extensions: [
		"p8"
	]
},
	"application/pkcs8-encrypted": {
	source: "iana"
},
	"application/pkix-attr-cert": {
	source: "iana",
	extensions: [
		"ac"
	]
},
	"application/pkix-cert": {
	source: "iana",
	extensions: [
		"cer"
	]
},
	"application/pkix-crl": {
	source: "iana",
	extensions: [
		"crl"
	]
},
	"application/pkix-pkipath": {
	source: "iana",
	extensions: [
		"pkipath"
	]
},
	"application/pkixcmp": {
	source: "iana",
	extensions: [
		"pki"
	]
},
	"application/pls+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"pls"
	]
},
	"application/poc-settings+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/postscript": {
	source: "iana",
	compressible: true,
	extensions: [
		"ai",
		"eps",
		"ps"
	]
},
	"application/ppsp-tracker+json": {
	source: "iana",
	compressible: true
},
	"application/problem+json": {
	source: "iana",
	compressible: true
},
	"application/problem+xml": {
	source: "iana",
	compressible: true
},
	"application/provenance+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"provx"
	]
},
	"application/prs.alvestrand.titrax-sheet": {
	source: "iana"
},
	"application/prs.cww": {
	source: "iana",
	extensions: [
		"cww"
	]
},
	"application/prs.cyn": {
	source: "iana",
	charset: "7-BIT"
},
	"application/prs.hpub+zip": {
	source: "iana",
	compressible: false
},
	"application/prs.nprend": {
	source: "iana"
},
	"application/prs.plucker": {
	source: "iana"
},
	"application/prs.rdf-xml-crypt": {
	source: "iana"
},
	"application/prs.xsf+xml": {
	source: "iana",
	compressible: true
},
	"application/pskc+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"pskcxml"
	]
},
	"application/pvd+json": {
	source: "iana",
	compressible: true
},
	"application/qsig": {
	source: "iana"
},
	"application/raml+yaml": {
	compressible: true,
	extensions: [
		"raml"
	]
},
	"application/raptorfec": {
	source: "iana"
},
	"application/rdap+json": {
	source: "iana",
	compressible: true
},
	"application/rdf+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rdf",
		"owl"
	]
},
	"application/reginfo+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rif"
	]
},
	"application/relax-ng-compact-syntax": {
	source: "iana",
	extensions: [
		"rnc"
	]
},
	"application/remote-printing": {
	source: "iana"
},
	"application/reputon+json": {
	source: "iana",
	compressible: true
},
	"application/resource-lists+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rl"
	]
},
	"application/resource-lists-diff+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rld"
	]
},
	"application/rfc+xml": {
	source: "iana",
	compressible: true
},
	"application/riscos": {
	source: "iana"
},
	"application/rlmi+xml": {
	source: "iana",
	compressible: true
},
	"application/rls-services+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rs"
	]
},
	"application/route-apd+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rapd"
	]
},
	"application/route-s-tsid+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"sls"
	]
},
	"application/route-usd+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rusd"
	]
},
	"application/rpki-ghostbusters": {
	source: "iana",
	extensions: [
		"gbr"
	]
},
	"application/rpki-manifest": {
	source: "iana",
	extensions: [
		"mft"
	]
},
	"application/rpki-publication": {
	source: "iana"
},
	"application/rpki-roa": {
	source: "iana",
	extensions: [
		"roa"
	]
},
	"application/rpki-updown": {
	source: "iana"
},
	"application/rsd+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"rsd"
	]
},
	"application/rss+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"rss"
	]
},
	"application/rtf": {
	source: "iana",
	compressible: true,
	extensions: [
		"rtf"
	]
},
	"application/rtploopback": {
	source: "iana"
},
	"application/rtx": {
	source: "iana"
},
	"application/samlassertion+xml": {
	source: "iana",
	compressible: true
},
	"application/samlmetadata+xml": {
	source: "iana",
	compressible: true
},
	"application/sarif+json": {
	source: "iana",
	compressible: true
},
	"application/sarif-external-properties+json": {
	source: "iana",
	compressible: true
},
	"application/sbe": {
	source: "iana"
},
	"application/sbml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"sbml"
	]
},
	"application/scaip+xml": {
	source: "iana",
	compressible: true
},
	"application/scim+json": {
	source: "iana",
	compressible: true
},
	"application/scvp-cv-request": {
	source: "iana",
	extensions: [
		"scq"
	]
},
	"application/scvp-cv-response": {
	source: "iana",
	extensions: [
		"scs"
	]
},
	"application/scvp-vp-request": {
	source: "iana",
	extensions: [
		"spq"
	]
},
	"application/scvp-vp-response": {
	source: "iana",
	extensions: [
		"spp"
	]
},
	"application/sdp": {
	source: "iana",
	extensions: [
		"sdp"
	]
},
	"application/secevent+jwt": {
	source: "iana"
},
	"application/senml+cbor": {
	source: "iana"
},
	"application/senml+json": {
	source: "iana",
	compressible: true
},
	"application/senml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"senmlx"
	]
},
	"application/senml-etch+cbor": {
	source: "iana"
},
	"application/senml-etch+json": {
	source: "iana",
	compressible: true
},
	"application/senml-exi": {
	source: "iana"
},
	"application/sensml+cbor": {
	source: "iana"
},
	"application/sensml+json": {
	source: "iana",
	compressible: true
},
	"application/sensml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"sensmlx"
	]
},
	"application/sensml-exi": {
	source: "iana"
},
	"application/sep+xml": {
	source: "iana",
	compressible: true
},
	"application/sep-exi": {
	source: "iana"
},
	"application/session-info": {
	source: "iana"
},
	"application/set-payment": {
	source: "iana"
},
	"application/set-payment-initiation": {
	source: "iana",
	extensions: [
		"setpay"
	]
},
	"application/set-registration": {
	source: "iana"
},
	"application/set-registration-initiation": {
	source: "iana",
	extensions: [
		"setreg"
	]
},
	"application/sgml": {
	source: "iana"
},
	"application/sgml-open-catalog": {
	source: "iana"
},
	"application/shf+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"shf"
	]
},
	"application/sieve": {
	source: "iana",
	extensions: [
		"siv",
		"sieve"
	]
},
	"application/simple-filter+xml": {
	source: "iana",
	compressible: true
},
	"application/simple-message-summary": {
	source: "iana"
},
	"application/simplesymbolcontainer": {
	source: "iana"
},
	"application/sipc": {
	source: "iana"
},
	"application/slate": {
	source: "iana"
},
	"application/smil": {
	source: "iana"
},
	"application/smil+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"smi",
		"smil"
	]
},
	"application/smpte336m": {
	source: "iana"
},
	"application/soap+fastinfoset": {
	source: "iana"
},
	"application/soap+xml": {
	source: "iana",
	compressible: true
},
	"application/sparql-query": {
	source: "iana",
	extensions: [
		"rq"
	]
},
	"application/sparql-results+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"srx"
	]
},
	"application/spdx+json": {
	source: "iana",
	compressible: true
},
	"application/spirits-event+xml": {
	source: "iana",
	compressible: true
},
	"application/sql": {
	source: "iana"
},
	"application/srgs": {
	source: "iana",
	extensions: [
		"gram"
	]
},
	"application/srgs+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"grxml"
	]
},
	"application/sru+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"sru"
	]
},
	"application/ssdl+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"ssdl"
	]
},
	"application/ssml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"ssml"
	]
},
	"application/stix+json": {
	source: "iana",
	compressible: true
},
	"application/swid+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"swidtag"
	]
},
	"application/tamp-apex-update": {
	source: "iana"
},
	"application/tamp-apex-update-confirm": {
	source: "iana"
},
	"application/tamp-community-update": {
	source: "iana"
},
	"application/tamp-community-update-confirm": {
	source: "iana"
},
	"application/tamp-error": {
	source: "iana"
},
	"application/tamp-sequence-adjust": {
	source: "iana"
},
	"application/tamp-sequence-adjust-confirm": {
	source: "iana"
},
	"application/tamp-status-query": {
	source: "iana"
},
	"application/tamp-status-response": {
	source: "iana"
},
	"application/tamp-update": {
	source: "iana"
},
	"application/tamp-update-confirm": {
	source: "iana"
},
	"application/tar": {
	compressible: true
},
	"application/taxii+json": {
	source: "iana",
	compressible: true
},
	"application/td+json": {
	source: "iana",
	compressible: true
},
	"application/tei+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"tei",
		"teicorpus"
	]
},
	"application/tetra_isi": {
	source: "iana"
},
	"application/thraud+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"tfi"
	]
},
	"application/timestamp-query": {
	source: "iana"
},
	"application/timestamp-reply": {
	source: "iana"
},
	"application/timestamped-data": {
	source: "iana",
	extensions: [
		"tsd"
	]
},
	"application/tlsrpt+gzip": {
	source: "iana"
},
	"application/tlsrpt+json": {
	source: "iana",
	compressible: true
},
	"application/tnauthlist": {
	source: "iana"
},
	"application/token-introspection+jwt": {
	source: "iana"
},
	"application/toml": {
	compressible: true,
	extensions: [
		"toml"
	]
},
	"application/trickle-ice-sdpfrag": {
	source: "iana"
},
	"application/trig": {
	source: "iana",
	extensions: [
		"trig"
	]
},
	"application/ttml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"ttml"
	]
},
	"application/tve-trigger": {
	source: "iana"
},
	"application/tzif": {
	source: "iana"
},
	"application/tzif-leap": {
	source: "iana"
},
	"application/ubjson": {
	compressible: false,
	extensions: [
		"ubj"
	]
},
	"application/ulpfec": {
	source: "iana"
},
	"application/urc-grpsheet+xml": {
	source: "iana",
	compressible: true
},
	"application/urc-ressheet+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"rsheet"
	]
},
	"application/urc-targetdesc+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"td"
	]
},
	"application/urc-uisocketdesc+xml": {
	source: "iana",
	compressible: true
},
	"application/vcard+json": {
	source: "iana",
	compressible: true
},
	"application/vcard+xml": {
	source: "iana",
	compressible: true
},
	"application/vemmi": {
	source: "iana"
},
	"application/vividence.scriptfile": {
	source: "apache"
},
	"application/vnd.1000minds.decision-model+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"1km"
	]
},
	"application/vnd.3gpp-prose+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp-prose-pc3ch+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp-v2x-local-service-information": {
	source: "iana"
},
	"application/vnd.3gpp.5gnas": {
	source: "iana"
},
	"application/vnd.3gpp.access-transfer-events+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.bsf+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.gmop+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.gtpc": {
	source: "iana"
},
	"application/vnd.3gpp.interworking-data": {
	source: "iana"
},
	"application/vnd.3gpp.lpp": {
	source: "iana"
},
	"application/vnd.3gpp.mc-signalling-ear": {
	source: "iana"
},
	"application/vnd.3gpp.mcdata-affiliation-command+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcdata-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcdata-payload": {
	source: "iana"
},
	"application/vnd.3gpp.mcdata-service-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcdata-signalling": {
	source: "iana"
},
	"application/vnd.3gpp.mcdata-ue-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcdata-user-profile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-affiliation-command+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-floor-request+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-location-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-mbms-usage-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-service-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-signed+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-ue-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-ue-init-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcptt-user-profile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-affiliation-command+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-affiliation-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-location-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-mbms-usage-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-service-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-transmission-request+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-ue-config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mcvideo-user-profile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.mid-call+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.ngap": {
	source: "iana"
},
	"application/vnd.3gpp.pfcp": {
	source: "iana"
},
	"application/vnd.3gpp.pic-bw-large": {
	source: "iana",
	extensions: [
		"plb"
	]
},
	"application/vnd.3gpp.pic-bw-small": {
	source: "iana",
	extensions: [
		"psb"
	]
},
	"application/vnd.3gpp.pic-bw-var": {
	source: "iana",
	extensions: [
		"pvb"
	]
},
	"application/vnd.3gpp.s1ap": {
	source: "iana"
},
	"application/vnd.3gpp.sms": {
	source: "iana"
},
	"application/vnd.3gpp.sms+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.srvcc-ext+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.srvcc-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.state-and-event-info+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp.ussd+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp2.bcmcsinfo+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.3gpp2.sms": {
	source: "iana"
},
	"application/vnd.3gpp2.tcap": {
	source: "iana",
	extensions: [
		"tcap"
	]
},
	"application/vnd.3lightssoftware.imagescal": {
	source: "iana"
},
	"application/vnd.3m.post-it-notes": {
	source: "iana",
	extensions: [
		"pwn"
	]
},
	"application/vnd.accpac.simply.aso": {
	source: "iana",
	extensions: [
		"aso"
	]
},
	"application/vnd.accpac.simply.imp": {
	source: "iana",
	extensions: [
		"imp"
	]
},
	"application/vnd.acucobol": {
	source: "iana",
	extensions: [
		"acu"
	]
},
	"application/vnd.acucorp": {
	source: "iana",
	extensions: [
		"atc",
		"acutc"
	]
},
	"application/vnd.adobe.air-application-installer-package+zip": {
	source: "apache",
	compressible: false,
	extensions: [
		"air"
	]
},
	"application/vnd.adobe.flash.movie": {
	source: "iana"
},
	"application/vnd.adobe.formscentral.fcdt": {
	source: "iana",
	extensions: [
		"fcdt"
	]
},
	"application/vnd.adobe.fxp": {
	source: "iana",
	extensions: [
		"fxp",
		"fxpl"
	]
},
	"application/vnd.adobe.partial-upload": {
	source: "iana"
},
	"application/vnd.adobe.xdp+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xdp"
	]
},
	"application/vnd.adobe.xfdf": {
	source: "iana",
	extensions: [
		"xfdf"
	]
},
	"application/vnd.aether.imp": {
	source: "iana"
},
	"application/vnd.afpc.afplinedata": {
	source: "iana"
},
	"application/vnd.afpc.afplinedata-pagedef": {
	source: "iana"
},
	"application/vnd.afpc.cmoca-cmresource": {
	source: "iana"
},
	"application/vnd.afpc.foca-charset": {
	source: "iana"
},
	"application/vnd.afpc.foca-codedfont": {
	source: "iana"
},
	"application/vnd.afpc.foca-codepage": {
	source: "iana"
},
	"application/vnd.afpc.modca": {
	source: "iana"
},
	"application/vnd.afpc.modca-cmtable": {
	source: "iana"
},
	"application/vnd.afpc.modca-formdef": {
	source: "iana"
},
	"application/vnd.afpc.modca-mediummap": {
	source: "iana"
},
	"application/vnd.afpc.modca-objectcontainer": {
	source: "iana"
},
	"application/vnd.afpc.modca-overlay": {
	source: "iana"
},
	"application/vnd.afpc.modca-pagesegment": {
	source: "iana"
},
	"application/vnd.age": {
	source: "iana",
	extensions: [
		"age"
	]
},
	"application/vnd.ah-barcode": {
	source: "iana"
},
	"application/vnd.ahead.space": {
	source: "iana",
	extensions: [
		"ahead"
	]
},
	"application/vnd.airzip.filesecure.azf": {
	source: "iana",
	extensions: [
		"azf"
	]
},
	"application/vnd.airzip.filesecure.azs": {
	source: "iana",
	extensions: [
		"azs"
	]
},
	"application/vnd.amadeus+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.amazon.ebook": {
	source: "apache",
	extensions: [
		"azw"
	]
},
	"application/vnd.amazon.mobi8-ebook": {
	source: "iana"
},
	"application/vnd.americandynamics.acc": {
	source: "iana",
	extensions: [
		"acc"
	]
},
	"application/vnd.amiga.ami": {
	source: "iana",
	extensions: [
		"ami"
	]
},
	"application/vnd.amundsen.maze+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.android.ota": {
	source: "iana"
},
	"application/vnd.android.package-archive": {
	source: "apache",
	compressible: false,
	extensions: [
		"apk"
	]
},
	"application/vnd.anki": {
	source: "iana"
},
	"application/vnd.anser-web-certificate-issue-initiation": {
	source: "iana",
	extensions: [
		"cii"
	]
},
	"application/vnd.anser-web-funds-transfer-initiation": {
	source: "apache",
	extensions: [
		"fti"
	]
},
	"application/vnd.antix.game-component": {
	source: "iana",
	extensions: [
		"atx"
	]
},
	"application/vnd.apache.arrow.file": {
	source: "iana"
},
	"application/vnd.apache.arrow.stream": {
	source: "iana"
},
	"application/vnd.apache.thrift.binary": {
	source: "iana"
},
	"application/vnd.apache.thrift.compact": {
	source: "iana"
},
	"application/vnd.apache.thrift.json": {
	source: "iana"
},
	"application/vnd.api+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.aplextor.warrp+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.apothekende.reservation+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.apple.installer+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mpkg"
	]
},
	"application/vnd.apple.keynote": {
	source: "iana",
	extensions: [
		"key"
	]
},
	"application/vnd.apple.mpegurl": {
	source: "iana",
	extensions: [
		"m3u8"
	]
},
	"application/vnd.apple.numbers": {
	source: "iana",
	extensions: [
		"numbers"
	]
},
	"application/vnd.apple.pages": {
	source: "iana",
	extensions: [
		"pages"
	]
},
	"application/vnd.apple.pkpass": {
	compressible: false,
	extensions: [
		"pkpass"
	]
},
	"application/vnd.arastra.swi": {
	source: "iana"
},
	"application/vnd.aristanetworks.swi": {
	source: "iana",
	extensions: [
		"swi"
	]
},
	"application/vnd.artisan+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.artsquare": {
	source: "iana"
},
	"application/vnd.astraea-software.iota": {
	source: "iana",
	extensions: [
		"iota"
	]
},
	"application/vnd.audiograph": {
	source: "iana",
	extensions: [
		"aep"
	]
},
	"application/vnd.autopackage": {
	source: "iana"
},
	"application/vnd.avalon+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.avistar+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.balsamiq.bmml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"bmml"
	]
},
	"application/vnd.balsamiq.bmpr": {
	source: "iana"
},
	"application/vnd.banana-accounting": {
	source: "iana"
},
	"application/vnd.bbf.usp.error": {
	source: "iana"
},
	"application/vnd.bbf.usp.msg": {
	source: "iana"
},
	"application/vnd.bbf.usp.msg+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.bekitzur-stech+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.bint.med-content": {
	source: "iana"
},
	"application/vnd.biopax.rdf+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.blink-idb-value-wrapper": {
	source: "iana"
},
	"application/vnd.blueice.multipass": {
	source: "iana",
	extensions: [
		"mpm"
	]
},
	"application/vnd.bluetooth.ep.oob": {
	source: "iana"
},
	"application/vnd.bluetooth.le.oob": {
	source: "iana"
},
	"application/vnd.bmi": {
	source: "iana",
	extensions: [
		"bmi"
	]
},
	"application/vnd.bpf": {
	source: "iana"
},
	"application/vnd.bpf3": {
	source: "iana"
},
	"application/vnd.businessobjects": {
	source: "iana",
	extensions: [
		"rep"
	]
},
	"application/vnd.byu.uapi+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.cab-jscript": {
	source: "iana"
},
	"application/vnd.canon-cpdl": {
	source: "iana"
},
	"application/vnd.canon-lips": {
	source: "iana"
},
	"application/vnd.capasystems-pg+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.cendio.thinlinc.clientconf": {
	source: "iana"
},
	"application/vnd.century-systems.tcp_stream": {
	source: "iana"
},
	"application/vnd.chemdraw+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"cdxml"
	]
},
	"application/vnd.chess-pgn": {
	source: "iana"
},
	"application/vnd.chipnuts.karaoke-mmd": {
	source: "iana",
	extensions: [
		"mmd"
	]
},
	"application/vnd.ciedi": {
	source: "iana"
},
	"application/vnd.cinderella": {
	source: "iana",
	extensions: [
		"cdy"
	]
},
	"application/vnd.cirpack.isdn-ext": {
	source: "iana"
},
	"application/vnd.citationstyles.style+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"csl"
	]
},
	"application/vnd.claymore": {
	source: "iana",
	extensions: [
		"cla"
	]
},
	"application/vnd.cloanto.rp9": {
	source: "iana",
	extensions: [
		"rp9"
	]
},
	"application/vnd.clonk.c4group": {
	source: "iana",
	extensions: [
		"c4g",
		"c4d",
		"c4f",
		"c4p",
		"c4u"
	]
},
	"application/vnd.cluetrust.cartomobile-config": {
	source: "iana",
	extensions: [
		"c11amc"
	]
},
	"application/vnd.cluetrust.cartomobile-config-pkg": {
	source: "iana",
	extensions: [
		"c11amz"
	]
},
	"application/vnd.coffeescript": {
	source: "iana"
},
	"application/vnd.collabio.xodocuments.document": {
	source: "iana"
},
	"application/vnd.collabio.xodocuments.document-template": {
	source: "iana"
},
	"application/vnd.collabio.xodocuments.presentation": {
	source: "iana"
},
	"application/vnd.collabio.xodocuments.presentation-template": {
	source: "iana"
},
	"application/vnd.collabio.xodocuments.spreadsheet": {
	source: "iana"
},
	"application/vnd.collabio.xodocuments.spreadsheet-template": {
	source: "iana"
},
	"application/vnd.collection+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.collection.doc+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.collection.next+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.comicbook+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.comicbook-rar": {
	source: "iana"
},
	"application/vnd.commerce-battelle": {
	source: "iana"
},
	"application/vnd.commonspace": {
	source: "iana",
	extensions: [
		"csp"
	]
},
	"application/vnd.contact.cmsg": {
	source: "iana",
	extensions: [
		"cdbcmsg"
	]
},
	"application/vnd.coreos.ignition+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.cosmocaller": {
	source: "iana",
	extensions: [
		"cmc"
	]
},
	"application/vnd.crick.clicker": {
	source: "iana",
	extensions: [
		"clkx"
	]
},
	"application/vnd.crick.clicker.keyboard": {
	source: "iana",
	extensions: [
		"clkk"
	]
},
	"application/vnd.crick.clicker.palette": {
	source: "iana",
	extensions: [
		"clkp"
	]
},
	"application/vnd.crick.clicker.template": {
	source: "iana",
	extensions: [
		"clkt"
	]
},
	"application/vnd.crick.clicker.wordbank": {
	source: "iana",
	extensions: [
		"clkw"
	]
},
	"application/vnd.criticaltools.wbs+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"wbs"
	]
},
	"application/vnd.cryptii.pipe+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.crypto-shade-file": {
	source: "iana"
},
	"application/vnd.cryptomator.encrypted": {
	source: "iana"
},
	"application/vnd.cryptomator.vault": {
	source: "iana"
},
	"application/vnd.ctc-posml": {
	source: "iana",
	extensions: [
		"pml"
	]
},
	"application/vnd.ctct.ws+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.cups-pdf": {
	source: "iana"
},
	"application/vnd.cups-postscript": {
	source: "iana"
},
	"application/vnd.cups-ppd": {
	source: "iana",
	extensions: [
		"ppd"
	]
},
	"application/vnd.cups-raster": {
	source: "iana"
},
	"application/vnd.cups-raw": {
	source: "iana"
},
	"application/vnd.curl": {
	source: "iana"
},
	"application/vnd.curl.car": {
	source: "apache",
	extensions: [
		"car"
	]
},
	"application/vnd.curl.pcurl": {
	source: "apache",
	extensions: [
		"pcurl"
	]
},
	"application/vnd.cyan.dean.root+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.cybank": {
	source: "iana"
},
	"application/vnd.cyclonedx+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.cyclonedx+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.d2l.coursepackage1p0+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.d3m-dataset": {
	source: "iana"
},
	"application/vnd.d3m-problem": {
	source: "iana"
},
	"application/vnd.dart": {
	source: "iana",
	compressible: true,
	extensions: [
		"dart"
	]
},
	"application/vnd.data-vision.rdz": {
	source: "iana",
	extensions: [
		"rdz"
	]
},
	"application/vnd.datapackage+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.dataresource+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.dbf": {
	source: "iana",
	extensions: [
		"dbf"
	]
},
	"application/vnd.debian.binary-package": {
	source: "iana"
},
	"application/vnd.dece.data": {
	source: "iana",
	extensions: [
		"uvf",
		"uvvf",
		"uvd",
		"uvvd"
	]
},
	"application/vnd.dece.ttml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"uvt",
		"uvvt"
	]
},
	"application/vnd.dece.unspecified": {
	source: "iana",
	extensions: [
		"uvx",
		"uvvx"
	]
},
	"application/vnd.dece.zip": {
	source: "iana",
	extensions: [
		"uvz",
		"uvvz"
	]
},
	"application/vnd.denovo.fcselayout-link": {
	source: "iana",
	extensions: [
		"fe_launch"
	]
},
	"application/vnd.desmume.movie": {
	source: "iana"
},
	"application/vnd.dir-bi.plate-dl-nosuffix": {
	source: "iana"
},
	"application/vnd.dm.delegation+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dna": {
	source: "iana",
	extensions: [
		"dna"
	]
},
	"application/vnd.document+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.dolby.mlp": {
	source: "apache",
	extensions: [
		"mlp"
	]
},
	"application/vnd.dolby.mobile.1": {
	source: "iana"
},
	"application/vnd.dolby.mobile.2": {
	source: "iana"
},
	"application/vnd.doremir.scorecloud-binary-document": {
	source: "iana"
},
	"application/vnd.dpgraph": {
	source: "iana",
	extensions: [
		"dpg"
	]
},
	"application/vnd.dreamfactory": {
	source: "iana",
	extensions: [
		"dfac"
	]
},
	"application/vnd.drive+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ds-keypoint": {
	source: "apache",
	extensions: [
		"kpxx"
	]
},
	"application/vnd.dtg.local": {
	source: "iana"
},
	"application/vnd.dtg.local.flash": {
	source: "iana"
},
	"application/vnd.dtg.local.html": {
	source: "iana"
},
	"application/vnd.dvb.ait": {
	source: "iana",
	extensions: [
		"ait"
	]
},
	"application/vnd.dvb.dvbisl+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.dvbj": {
	source: "iana"
},
	"application/vnd.dvb.esgcontainer": {
	source: "iana"
},
	"application/vnd.dvb.ipdcdftnotifaccess": {
	source: "iana"
},
	"application/vnd.dvb.ipdcesgaccess": {
	source: "iana"
},
	"application/vnd.dvb.ipdcesgaccess2": {
	source: "iana"
},
	"application/vnd.dvb.ipdcesgpdd": {
	source: "iana"
},
	"application/vnd.dvb.ipdcroaming": {
	source: "iana"
},
	"application/vnd.dvb.iptv.alfec-base": {
	source: "iana"
},
	"application/vnd.dvb.iptv.alfec-enhancement": {
	source: "iana"
},
	"application/vnd.dvb.notif-aggregate-root+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.notif-container+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.notif-generic+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.notif-ia-msglist+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.notif-ia-registration-request+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.notif-ia-registration-response+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.notif-init+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.dvb.pfr": {
	source: "iana"
},
	"application/vnd.dvb.service": {
	source: "iana",
	extensions: [
		"svc"
	]
},
	"application/vnd.dxr": {
	source: "iana"
},
	"application/vnd.dynageo": {
	source: "iana",
	extensions: [
		"geo"
	]
},
	"application/vnd.dzr": {
	source: "iana"
},
	"application/vnd.easykaraoke.cdgdownload": {
	source: "iana"
},
	"application/vnd.ecdis-update": {
	source: "iana"
},
	"application/vnd.ecip.rlp": {
	source: "iana"
},
	"application/vnd.eclipse.ditto+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ecowin.chart": {
	source: "iana",
	extensions: [
		"mag"
	]
},
	"application/vnd.ecowin.filerequest": {
	source: "iana"
},
	"application/vnd.ecowin.fileupdate": {
	source: "iana"
},
	"application/vnd.ecowin.series": {
	source: "iana"
},
	"application/vnd.ecowin.seriesrequest": {
	source: "iana"
},
	"application/vnd.ecowin.seriesupdate": {
	source: "iana"
},
	"application/vnd.efi.img": {
	source: "iana"
},
	"application/vnd.efi.iso": {
	source: "iana"
},
	"application/vnd.emclient.accessrequest+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.enliven": {
	source: "iana",
	extensions: [
		"nml"
	]
},
	"application/vnd.enphase.envoy": {
	source: "iana"
},
	"application/vnd.eprints.data+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.epson.esf": {
	source: "iana",
	extensions: [
		"esf"
	]
},
	"application/vnd.epson.msf": {
	source: "iana",
	extensions: [
		"msf"
	]
},
	"application/vnd.epson.quickanime": {
	source: "iana",
	extensions: [
		"qam"
	]
},
	"application/vnd.epson.salt": {
	source: "iana",
	extensions: [
		"slt"
	]
},
	"application/vnd.epson.ssf": {
	source: "iana",
	extensions: [
		"ssf"
	]
},
	"application/vnd.ericsson.quickcall": {
	source: "iana"
},
	"application/vnd.espass-espass+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.eszigno3+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"es3",
		"et3"
	]
},
	"application/vnd.etsi.aoc+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.asic-e+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.etsi.asic-s+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.etsi.cug+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvcommand+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvdiscovery+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvprofile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvsad-bc+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvsad-cod+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvsad-npvr+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvservice+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvsync+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.iptvueprofile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.mcid+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.mheg5": {
	source: "iana"
},
	"application/vnd.etsi.overload-control-policy-dataset+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.pstn+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.sci+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.simservs+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.timestamp-token": {
	source: "iana"
},
	"application/vnd.etsi.tsl+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.etsi.tsl.der": {
	source: "iana"
},
	"application/vnd.eu.kasparian.car+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.eudora.data": {
	source: "iana"
},
	"application/vnd.evolv.ecig.profile": {
	source: "iana"
},
	"application/vnd.evolv.ecig.settings": {
	source: "iana"
},
	"application/vnd.evolv.ecig.theme": {
	source: "iana"
},
	"application/vnd.exstream-empower+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.exstream-package": {
	source: "iana"
},
	"application/vnd.ezpix-album": {
	source: "iana",
	extensions: [
		"ez2"
	]
},
	"application/vnd.ezpix-package": {
	source: "iana",
	extensions: [
		"ez3"
	]
},
	"application/vnd.f-secure.mobile": {
	source: "iana"
},
	"application/vnd.familysearch.gedcom+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.fastcopy-disk-image": {
	source: "iana"
},
	"application/vnd.fdf": {
	source: "iana",
	extensions: [
		"fdf"
	]
},
	"application/vnd.fdsn.mseed": {
	source: "iana",
	extensions: [
		"mseed"
	]
},
	"application/vnd.fdsn.seed": {
	source: "iana",
	extensions: [
		"seed",
		"dataless"
	]
},
	"application/vnd.ffsns": {
	source: "iana"
},
	"application/vnd.ficlab.flb+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.filmit.zfc": {
	source: "iana"
},
	"application/vnd.fints": {
	source: "iana"
},
	"application/vnd.firemonkeys.cloudcell": {
	source: "iana"
},
	"application/vnd.flographit": {
	source: "iana",
	extensions: [
		"gph"
	]
},
	"application/vnd.fluxtime.clip": {
	source: "iana",
	extensions: [
		"ftc"
	]
},
	"application/vnd.font-fontforge-sfd": {
	source: "iana"
},
	"application/vnd.framemaker": {
	source: "iana",
	extensions: [
		"fm",
		"frame",
		"maker",
		"book"
	]
},
	"application/vnd.frogans.fnc": {
	source: "iana",
	extensions: [
		"fnc"
	]
},
	"application/vnd.frogans.ltf": {
	source: "iana",
	extensions: [
		"ltf"
	]
},
	"application/vnd.fsc.weblaunch": {
	source: "iana",
	extensions: [
		"fsc"
	]
},
	"application/vnd.fujifilm.fb.docuworks": {
	source: "iana"
},
	"application/vnd.fujifilm.fb.docuworks.binder": {
	source: "iana"
},
	"application/vnd.fujifilm.fb.docuworks.container": {
	source: "iana"
},
	"application/vnd.fujifilm.fb.jfi+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.fujitsu.oasys": {
	source: "iana",
	extensions: [
		"oas"
	]
},
	"application/vnd.fujitsu.oasys2": {
	source: "iana",
	extensions: [
		"oa2"
	]
},
	"application/vnd.fujitsu.oasys3": {
	source: "iana",
	extensions: [
		"oa3"
	]
},
	"application/vnd.fujitsu.oasysgp": {
	source: "iana",
	extensions: [
		"fg5"
	]
},
	"application/vnd.fujitsu.oasysprs": {
	source: "iana",
	extensions: [
		"bh2"
	]
},
	"application/vnd.fujixerox.art-ex": {
	source: "iana"
},
	"application/vnd.fujixerox.art4": {
	source: "iana"
},
	"application/vnd.fujixerox.ddd": {
	source: "iana",
	extensions: [
		"ddd"
	]
},
	"application/vnd.fujixerox.docuworks": {
	source: "iana",
	extensions: [
		"xdw"
	]
},
	"application/vnd.fujixerox.docuworks.binder": {
	source: "iana",
	extensions: [
		"xbd"
	]
},
	"application/vnd.fujixerox.docuworks.container": {
	source: "iana"
},
	"application/vnd.fujixerox.hbpl": {
	source: "iana"
},
	"application/vnd.fut-misnet": {
	source: "iana"
},
	"application/vnd.futoin+cbor": {
	source: "iana"
},
	"application/vnd.futoin+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.fuzzysheet": {
	source: "iana",
	extensions: [
		"fzs"
	]
},
	"application/vnd.genomatix.tuxedo": {
	source: "iana",
	extensions: [
		"txd"
	]
},
	"application/vnd.gentics.grd+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.geo+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.geocube+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.geogebra.file": {
	source: "iana",
	extensions: [
		"ggb"
	]
},
	"application/vnd.geogebra.slides": {
	source: "iana"
},
	"application/vnd.geogebra.tool": {
	source: "iana",
	extensions: [
		"ggt"
	]
},
	"application/vnd.geometry-explorer": {
	source: "iana",
	extensions: [
		"gex",
		"gre"
	]
},
	"application/vnd.geonext": {
	source: "iana",
	extensions: [
		"gxt"
	]
},
	"application/vnd.geoplan": {
	source: "iana",
	extensions: [
		"g2w"
	]
},
	"application/vnd.geospace": {
	source: "iana",
	extensions: [
		"g3w"
	]
},
	"application/vnd.gerber": {
	source: "iana"
},
	"application/vnd.globalplatform.card-content-mgt": {
	source: "iana"
},
	"application/vnd.globalplatform.card-content-mgt-response": {
	source: "iana"
},
	"application/vnd.gmx": {
	source: "iana",
	extensions: [
		"gmx"
	]
},
	"application/vnd.google-apps.document": {
	compressible: false,
	extensions: [
		"gdoc"
	]
},
	"application/vnd.google-apps.presentation": {
	compressible: false,
	extensions: [
		"gslides"
	]
},
	"application/vnd.google-apps.spreadsheet": {
	compressible: false,
	extensions: [
		"gsheet"
	]
},
	"application/vnd.google-earth.kml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"kml"
	]
},
	"application/vnd.google-earth.kmz": {
	source: "iana",
	compressible: false,
	extensions: [
		"kmz"
	]
},
	"application/vnd.gov.sk.e-form+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.gov.sk.e-form+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.gov.sk.xmldatacontainer+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.grafeq": {
	source: "iana",
	extensions: [
		"gqf",
		"gqs"
	]
},
	"application/vnd.gridmp": {
	source: "iana"
},
	"application/vnd.groove-account": {
	source: "iana",
	extensions: [
		"gac"
	]
},
	"application/vnd.groove-help": {
	source: "iana",
	extensions: [
		"ghf"
	]
},
	"application/vnd.groove-identity-message": {
	source: "iana",
	extensions: [
		"gim"
	]
},
	"application/vnd.groove-injector": {
	source: "iana",
	extensions: [
		"grv"
	]
},
	"application/vnd.groove-tool-message": {
	source: "iana",
	extensions: [
		"gtm"
	]
},
	"application/vnd.groove-tool-template": {
	source: "iana",
	extensions: [
		"tpl"
	]
},
	"application/vnd.groove-vcard": {
	source: "iana",
	extensions: [
		"vcg"
	]
},
	"application/vnd.hal+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.hal+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"hal"
	]
},
	"application/vnd.handheld-entertainment+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"zmm"
	]
},
	"application/vnd.hbci": {
	source: "iana",
	extensions: [
		"hbci"
	]
},
	"application/vnd.hc+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.hcl-bireports": {
	source: "iana"
},
	"application/vnd.hdt": {
	source: "iana"
},
	"application/vnd.heroku+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.hhe.lesson-player": {
	source: "iana",
	extensions: [
		"les"
	]
},
	"application/vnd.hl7cda+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/vnd.hl7v2+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/vnd.hp-hpgl": {
	source: "iana",
	extensions: [
		"hpgl"
	]
},
	"application/vnd.hp-hpid": {
	source: "iana",
	extensions: [
		"hpid"
	]
},
	"application/vnd.hp-hps": {
	source: "iana",
	extensions: [
		"hps"
	]
},
	"application/vnd.hp-jlyt": {
	source: "iana",
	extensions: [
		"jlt"
	]
},
	"application/vnd.hp-pcl": {
	source: "iana",
	extensions: [
		"pcl"
	]
},
	"application/vnd.hp-pclxl": {
	source: "iana",
	extensions: [
		"pclxl"
	]
},
	"application/vnd.httphone": {
	source: "iana"
},
	"application/vnd.hydrostatix.sof-data": {
	source: "iana",
	extensions: [
		"sfd-hdstx"
	]
},
	"application/vnd.hyper+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.hyper-item+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.hyperdrive+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.hzn-3d-crossword": {
	source: "iana"
},
	"application/vnd.ibm.afplinedata": {
	source: "iana"
},
	"application/vnd.ibm.electronic-media": {
	source: "iana"
},
	"application/vnd.ibm.minipay": {
	source: "iana",
	extensions: [
		"mpy"
	]
},
	"application/vnd.ibm.modcap": {
	source: "iana",
	extensions: [
		"afp",
		"listafp",
		"list3820"
	]
},
	"application/vnd.ibm.rights-management": {
	source: "iana",
	extensions: [
		"irm"
	]
},
	"application/vnd.ibm.secure-container": {
	source: "iana",
	extensions: [
		"sc"
	]
},
	"application/vnd.iccprofile": {
	source: "iana",
	extensions: [
		"icc",
		"icm"
	]
},
	"application/vnd.ieee.1905": {
	source: "iana"
},
	"application/vnd.igloader": {
	source: "iana",
	extensions: [
		"igl"
	]
},
	"application/vnd.imagemeter.folder+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.imagemeter.image+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.immervision-ivp": {
	source: "iana",
	extensions: [
		"ivp"
	]
},
	"application/vnd.immervision-ivu": {
	source: "iana",
	extensions: [
		"ivu"
	]
},
	"application/vnd.ims.imsccv1p1": {
	source: "iana"
},
	"application/vnd.ims.imsccv1p2": {
	source: "iana"
},
	"application/vnd.ims.imsccv1p3": {
	source: "iana"
},
	"application/vnd.ims.lis.v2.result+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ims.lti.v2.toolconsumerprofile+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ims.lti.v2.toolproxy+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ims.lti.v2.toolproxy.id+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ims.lti.v2.toolsettings+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ims.lti.v2.toolsettings.simple+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.informedcontrol.rms+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.informix-visionary": {
	source: "iana"
},
	"application/vnd.infotech.project": {
	source: "iana"
},
	"application/vnd.infotech.project+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.innopath.wamp.notification": {
	source: "iana"
},
	"application/vnd.insors.igm": {
	source: "iana",
	extensions: [
		"igm"
	]
},
	"application/vnd.intercon.formnet": {
	source: "iana",
	extensions: [
		"xpw",
		"xpx"
	]
},
	"application/vnd.intergeo": {
	source: "iana",
	extensions: [
		"i2g"
	]
},
	"application/vnd.intertrust.digibox": {
	source: "iana"
},
	"application/vnd.intertrust.nncp": {
	source: "iana"
},
	"application/vnd.intu.qbo": {
	source: "iana",
	extensions: [
		"qbo"
	]
},
	"application/vnd.intu.qfx": {
	source: "iana",
	extensions: [
		"qfx"
	]
},
	"application/vnd.iptc.g2.catalogitem+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.iptc.g2.conceptitem+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.iptc.g2.knowledgeitem+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.iptc.g2.newsitem+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.iptc.g2.newsmessage+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.iptc.g2.packageitem+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.iptc.g2.planningitem+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.ipunplugged.rcprofile": {
	source: "iana",
	extensions: [
		"rcprofile"
	]
},
	"application/vnd.irepository.package+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"irp"
	]
},
	"application/vnd.is-xpr": {
	source: "iana",
	extensions: [
		"xpr"
	]
},
	"application/vnd.isac.fcs": {
	source: "iana",
	extensions: [
		"fcs"
	]
},
	"application/vnd.iso11783-10+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.jam": {
	source: "iana",
	extensions: [
		"jam"
	]
},
	"application/vnd.japannet-directory-service": {
	source: "iana"
},
	"application/vnd.japannet-jpnstore-wakeup": {
	source: "iana"
},
	"application/vnd.japannet-payment-wakeup": {
	source: "iana"
},
	"application/vnd.japannet-registration": {
	source: "iana"
},
	"application/vnd.japannet-registration-wakeup": {
	source: "iana"
},
	"application/vnd.japannet-setstore-wakeup": {
	source: "iana"
},
	"application/vnd.japannet-verification": {
	source: "iana"
},
	"application/vnd.japannet-verification-wakeup": {
	source: "iana"
},
	"application/vnd.jcp.javame.midlet-rms": {
	source: "iana",
	extensions: [
		"rms"
	]
},
	"application/vnd.jisp": {
	source: "iana",
	extensions: [
		"jisp"
	]
},
	"application/vnd.joost.joda-archive": {
	source: "iana",
	extensions: [
		"joda"
	]
},
	"application/vnd.jsk.isdn-ngn": {
	source: "iana"
},
	"application/vnd.kahootz": {
	source: "iana",
	extensions: [
		"ktz",
		"ktr"
	]
},
	"application/vnd.kde.karbon": {
	source: "iana",
	extensions: [
		"karbon"
	]
},
	"application/vnd.kde.kchart": {
	source: "iana",
	extensions: [
		"chrt"
	]
},
	"application/vnd.kde.kformula": {
	source: "iana",
	extensions: [
		"kfo"
	]
},
	"application/vnd.kde.kivio": {
	source: "iana",
	extensions: [
		"flw"
	]
},
	"application/vnd.kde.kontour": {
	source: "iana",
	extensions: [
		"kon"
	]
},
	"application/vnd.kde.kpresenter": {
	source: "iana",
	extensions: [
		"kpr",
		"kpt"
	]
},
	"application/vnd.kde.kspread": {
	source: "iana",
	extensions: [
		"ksp"
	]
},
	"application/vnd.kde.kword": {
	source: "iana",
	extensions: [
		"kwd",
		"kwt"
	]
},
	"application/vnd.kenameaapp": {
	source: "iana",
	extensions: [
		"htke"
	]
},
	"application/vnd.kidspiration": {
	source: "iana",
	extensions: [
		"kia"
	]
},
	"application/vnd.kinar": {
	source: "iana",
	extensions: [
		"kne",
		"knp"
	]
},
	"application/vnd.koan": {
	source: "iana",
	extensions: [
		"skp",
		"skd",
		"skt",
		"skm"
	]
},
	"application/vnd.kodak-descriptor": {
	source: "iana",
	extensions: [
		"sse"
	]
},
	"application/vnd.las": {
	source: "iana"
},
	"application/vnd.las.las+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.las.las+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"lasxml"
	]
},
	"application/vnd.laszip": {
	source: "iana"
},
	"application/vnd.leap+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.liberty-request+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.llamagraphics.life-balance.desktop": {
	source: "iana",
	extensions: [
		"lbd"
	]
},
	"application/vnd.llamagraphics.life-balance.exchange+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"lbe"
	]
},
	"application/vnd.logipipe.circuit+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.loom": {
	source: "iana"
},
	"application/vnd.lotus-1-2-3": {
	source: "iana",
	extensions: [
		"123"
	]
},
	"application/vnd.lotus-approach": {
	source: "iana",
	extensions: [
		"apr"
	]
},
	"application/vnd.lotus-freelance": {
	source: "iana",
	extensions: [
		"pre"
	]
},
	"application/vnd.lotus-notes": {
	source: "iana",
	extensions: [
		"nsf"
	]
},
	"application/vnd.lotus-organizer": {
	source: "iana",
	extensions: [
		"org"
	]
},
	"application/vnd.lotus-screencam": {
	source: "iana",
	extensions: [
		"scm"
	]
},
	"application/vnd.lotus-wordpro": {
	source: "iana",
	extensions: [
		"lwp"
	]
},
	"application/vnd.macports.portpkg": {
	source: "iana",
	extensions: [
		"portpkg"
	]
},
	"application/vnd.mapbox-vector-tile": {
	source: "iana",
	extensions: [
		"mvt"
	]
},
	"application/vnd.marlin.drm.actiontoken+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.marlin.drm.conftoken+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.marlin.drm.license+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.marlin.drm.mdcf": {
	source: "iana"
},
	"application/vnd.mason+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.maxar.archive.3tz+zip": {
	source: "iana",
	compressible: false
},
	"application/vnd.maxmind.maxmind-db": {
	source: "iana"
},
	"application/vnd.mcd": {
	source: "iana",
	extensions: [
		"mcd"
	]
},
	"application/vnd.medcalcdata": {
	source: "iana",
	extensions: [
		"mc1"
	]
},
	"application/vnd.mediastation.cdkey": {
	source: "iana",
	extensions: [
		"cdkey"
	]
},
	"application/vnd.meridian-slingshot": {
	source: "iana"
},
	"application/vnd.mfer": {
	source: "iana",
	extensions: [
		"mwf"
	]
},
	"application/vnd.mfmp": {
	source: "iana",
	extensions: [
		"mfm"
	]
},
	"application/vnd.micro+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.micrografx.flo": {
	source: "iana",
	extensions: [
		"flo"
	]
},
	"application/vnd.micrografx.igx": {
	source: "iana",
	extensions: [
		"igx"
	]
},
	"application/vnd.microsoft.portable-executable": {
	source: "iana"
},
	"application/vnd.microsoft.windows.thumbnail-cache": {
	source: "iana"
},
	"application/vnd.miele+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.mif": {
	source: "iana",
	extensions: [
		"mif"
	]
},
	"application/vnd.minisoft-hp3000-save": {
	source: "iana"
},
	"application/vnd.mitsubishi.misty-guard.trustweb": {
	source: "iana"
},
	"application/vnd.mobius.daf": {
	source: "iana",
	extensions: [
		"daf"
	]
},
	"application/vnd.mobius.dis": {
	source: "iana",
	extensions: [
		"dis"
	]
},
	"application/vnd.mobius.mbk": {
	source: "iana",
	extensions: [
		"mbk"
	]
},
	"application/vnd.mobius.mqy": {
	source: "iana",
	extensions: [
		"mqy"
	]
},
	"application/vnd.mobius.msl": {
	source: "iana",
	extensions: [
		"msl"
	]
},
	"application/vnd.mobius.plc": {
	source: "iana",
	extensions: [
		"plc"
	]
},
	"application/vnd.mobius.txf": {
	source: "iana",
	extensions: [
		"txf"
	]
},
	"application/vnd.mophun.application": {
	source: "iana",
	extensions: [
		"mpn"
	]
},
	"application/vnd.mophun.certificate": {
	source: "iana",
	extensions: [
		"mpc"
	]
},
	"application/vnd.motorola.flexsuite": {
	source: "iana"
},
	"application/vnd.motorola.flexsuite.adsi": {
	source: "iana"
},
	"application/vnd.motorola.flexsuite.fis": {
	source: "iana"
},
	"application/vnd.motorola.flexsuite.gotap": {
	source: "iana"
},
	"application/vnd.motorola.flexsuite.kmr": {
	source: "iana"
},
	"application/vnd.motorola.flexsuite.ttc": {
	source: "iana"
},
	"application/vnd.motorola.flexsuite.wem": {
	source: "iana"
},
	"application/vnd.motorola.iprm": {
	source: "iana"
},
	"application/vnd.mozilla.xul+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xul"
	]
},
	"application/vnd.ms-3mfdocument": {
	source: "iana"
},
	"application/vnd.ms-artgalry": {
	source: "iana",
	extensions: [
		"cil"
	]
},
	"application/vnd.ms-asf": {
	source: "iana"
},
	"application/vnd.ms-cab-compressed": {
	source: "iana",
	extensions: [
		"cab"
	]
},
	"application/vnd.ms-color.iccprofile": {
	source: "apache"
},
	"application/vnd.ms-excel": {
	source: "iana",
	compressible: false,
	extensions: [
		"xls",
		"xlm",
		"xla",
		"xlc",
		"xlt",
		"xlw"
	]
},
	"application/vnd.ms-excel.addin.macroenabled.12": {
	source: "iana",
	extensions: [
		"xlam"
	]
},
	"application/vnd.ms-excel.sheet.binary.macroenabled.12": {
	source: "iana",
	extensions: [
		"xlsb"
	]
},
	"application/vnd.ms-excel.sheet.macroenabled.12": {
	source: "iana",
	extensions: [
		"xlsm"
	]
},
	"application/vnd.ms-excel.template.macroenabled.12": {
	source: "iana",
	extensions: [
		"xltm"
	]
},
	"application/vnd.ms-fontobject": {
	source: "iana",
	compressible: true,
	extensions: [
		"eot"
	]
},
	"application/vnd.ms-htmlhelp": {
	source: "iana",
	extensions: [
		"chm"
	]
},
	"application/vnd.ms-ims": {
	source: "iana",
	extensions: [
		"ims"
	]
},
	"application/vnd.ms-lrm": {
	source: "iana",
	extensions: [
		"lrm"
	]
},
	"application/vnd.ms-office.activex+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.ms-officetheme": {
	source: "iana",
	extensions: [
		"thmx"
	]
},
	"application/vnd.ms-opentype": {
	source: "apache",
	compressible: true
},
	"application/vnd.ms-outlook": {
	compressible: false,
	extensions: [
		"msg"
	]
},
	"application/vnd.ms-package.obfuscated-opentype": {
	source: "apache"
},
	"application/vnd.ms-pki.seccat": {
	source: "apache",
	extensions: [
		"cat"
	]
},
	"application/vnd.ms-pki.stl": {
	source: "apache",
	extensions: [
		"stl"
	]
},
	"application/vnd.ms-playready.initiator+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.ms-powerpoint": {
	source: "iana",
	compressible: false,
	extensions: [
		"ppt",
		"pps",
		"pot"
	]
},
	"application/vnd.ms-powerpoint.addin.macroenabled.12": {
	source: "iana",
	extensions: [
		"ppam"
	]
},
	"application/vnd.ms-powerpoint.presentation.macroenabled.12": {
	source: "iana",
	extensions: [
		"pptm"
	]
},
	"application/vnd.ms-powerpoint.slide.macroenabled.12": {
	source: "iana",
	extensions: [
		"sldm"
	]
},
	"application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
	source: "iana",
	extensions: [
		"ppsm"
	]
},
	"application/vnd.ms-powerpoint.template.macroenabled.12": {
	source: "iana",
	extensions: [
		"potm"
	]
},
	"application/vnd.ms-printdevicecapabilities+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.ms-printing.printticket+xml": {
	source: "apache",
	compressible: true
},
	"application/vnd.ms-printschematicket+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.ms-project": {
	source: "iana",
	extensions: [
		"mpp",
		"mpt"
	]
},
	"application/vnd.ms-tnef": {
	source: "iana"
},
	"application/vnd.ms-windows.devicepairing": {
	source: "iana"
},
	"application/vnd.ms-windows.nwprinting.oob": {
	source: "iana"
},
	"application/vnd.ms-windows.printerpairing": {
	source: "iana"
},
	"application/vnd.ms-windows.wsd.oob": {
	source: "iana"
},
	"application/vnd.ms-wmdrm.lic-chlg-req": {
	source: "iana"
},
	"application/vnd.ms-wmdrm.lic-resp": {
	source: "iana"
},
	"application/vnd.ms-wmdrm.meter-chlg-req": {
	source: "iana"
},
	"application/vnd.ms-wmdrm.meter-resp": {
	source: "iana"
},
	"application/vnd.ms-word.document.macroenabled.12": {
	source: "iana",
	extensions: [
		"docm"
	]
},
	"application/vnd.ms-word.template.macroenabled.12": {
	source: "iana",
	extensions: [
		"dotm"
	]
},
	"application/vnd.ms-works": {
	source: "iana",
	extensions: [
		"wps",
		"wks",
		"wcm",
		"wdb"
	]
},
	"application/vnd.ms-wpl": {
	source: "iana",
	extensions: [
		"wpl"
	]
},
	"application/vnd.ms-xpsdocument": {
	source: "iana",
	compressible: false,
	extensions: [
		"xps"
	]
},
	"application/vnd.msa-disk-image": {
	source: "iana"
},
	"application/vnd.mseq": {
	source: "iana",
	extensions: [
		"mseq"
	]
},
	"application/vnd.msign": {
	source: "iana"
},
	"application/vnd.multiad.creator": {
	source: "iana"
},
	"application/vnd.multiad.creator.cif": {
	source: "iana"
},
	"application/vnd.music-niff": {
	source: "iana"
},
	"application/vnd.musician": {
	source: "iana",
	extensions: [
		"mus"
	]
},
	"application/vnd.muvee.style": {
	source: "iana",
	extensions: [
		"msty"
	]
},
	"application/vnd.mynfc": {
	source: "iana",
	extensions: [
		"taglet"
	]
},
	"application/vnd.nacamar.ybrid+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.ncd.control": {
	source: "iana"
},
	"application/vnd.ncd.reference": {
	source: "iana"
},
	"application/vnd.nearst.inv+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.nebumind.line": {
	source: "iana"
},
	"application/vnd.nervana": {
	source: "iana"
},
	"application/vnd.netfpx": {
	source: "iana"
},
	"application/vnd.neurolanguage.nlu": {
	source: "iana",
	extensions: [
		"nlu"
	]
},
	"application/vnd.nimn": {
	source: "iana"
},
	"application/vnd.nintendo.nitro.rom": {
	source: "iana"
},
	"application/vnd.nintendo.snes.rom": {
	source: "iana"
},
	"application/vnd.nitf": {
	source: "iana",
	extensions: [
		"ntf",
		"nitf"
	]
},
	"application/vnd.noblenet-directory": {
	source: "iana",
	extensions: [
		"nnd"
	]
},
	"application/vnd.noblenet-sealer": {
	source: "iana",
	extensions: [
		"nns"
	]
},
	"application/vnd.noblenet-web": {
	source: "iana",
	extensions: [
		"nnw"
	]
},
	"application/vnd.nokia.catalogs": {
	source: "iana"
},
	"application/vnd.nokia.conml+wbxml": {
	source: "iana"
},
	"application/vnd.nokia.conml+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.nokia.iptv.config+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.nokia.isds-radio-presets": {
	source: "iana"
},
	"application/vnd.nokia.landmark+wbxml": {
	source: "iana"
},
	"application/vnd.nokia.landmark+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.nokia.landmarkcollection+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.nokia.n-gage.ac+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"ac"
	]
},
	"application/vnd.nokia.n-gage.data": {
	source: "iana",
	extensions: [
		"ngdat"
	]
},
	"application/vnd.nokia.n-gage.symbian.install": {
	source: "iana",
	extensions: [
		"n-gage"
	]
},
	"application/vnd.nokia.ncd": {
	source: "iana"
},
	"application/vnd.nokia.pcd+wbxml": {
	source: "iana"
},
	"application/vnd.nokia.pcd+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.nokia.radio-preset": {
	source: "iana",
	extensions: [
		"rpst"
	]
},
	"application/vnd.nokia.radio-presets": {
	source: "iana",
	extensions: [
		"rpss"
	]
},
	"application/vnd.novadigm.edm": {
	source: "iana",
	extensions: [
		"edm"
	]
},
	"application/vnd.novadigm.edx": {
	source: "iana",
	extensions: [
		"edx"
	]
},
	"application/vnd.novadigm.ext": {
	source: "iana",
	extensions: [
		"ext"
	]
},
	"application/vnd.ntt-local.content-share": {
	source: "iana"
},
	"application/vnd.ntt-local.file-transfer": {
	source: "iana"
},
	"application/vnd.ntt-local.ogw_remote-access": {
	source: "iana"
},
	"application/vnd.ntt-local.sip-ta_remote": {
	source: "iana"
},
	"application/vnd.ntt-local.sip-ta_tcp_stream": {
	source: "iana"
},
	"application/vnd.oasis.opendocument.chart": {
	source: "iana",
	extensions: [
		"odc"
	]
},
	"application/vnd.oasis.opendocument.chart-template": {
	source: "iana",
	extensions: [
		"otc"
	]
},
	"application/vnd.oasis.opendocument.database": {
	source: "iana",
	extensions: [
		"odb"
	]
},
	"application/vnd.oasis.opendocument.formula": {
	source: "iana",
	extensions: [
		"odf"
	]
},
	"application/vnd.oasis.opendocument.formula-template": {
	source: "iana",
	extensions: [
		"odft"
	]
},
	"application/vnd.oasis.opendocument.graphics": {
	source: "iana",
	compressible: false,
	extensions: [
		"odg"
	]
},
	"application/vnd.oasis.opendocument.graphics-template": {
	source: "iana",
	extensions: [
		"otg"
	]
},
	"application/vnd.oasis.opendocument.image": {
	source: "iana",
	extensions: [
		"odi"
	]
},
	"application/vnd.oasis.opendocument.image-template": {
	source: "iana",
	extensions: [
		"oti"
	]
},
	"application/vnd.oasis.opendocument.presentation": {
	source: "iana",
	compressible: false,
	extensions: [
		"odp"
	]
},
	"application/vnd.oasis.opendocument.presentation-template": {
	source: "iana",
	extensions: [
		"otp"
	]
},
	"application/vnd.oasis.opendocument.spreadsheet": {
	source: "iana",
	compressible: false,
	extensions: [
		"ods"
	]
},
	"application/vnd.oasis.opendocument.spreadsheet-template": {
	source: "iana",
	extensions: [
		"ots"
	]
},
	"application/vnd.oasis.opendocument.text": {
	source: "iana",
	compressible: false,
	extensions: [
		"odt"
	]
},
	"application/vnd.oasis.opendocument.text-master": {
	source: "iana",
	extensions: [
		"odm"
	]
},
	"application/vnd.oasis.opendocument.text-template": {
	source: "iana",
	extensions: [
		"ott"
	]
},
	"application/vnd.oasis.opendocument.text-web": {
	source: "iana",
	extensions: [
		"oth"
	]
},
	"application/vnd.obn": {
	source: "iana"
},
	"application/vnd.ocf+cbor": {
	source: "iana"
},
	"application/vnd.oci.image.manifest.v1+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.oftn.l10n+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.contentaccessdownload+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.contentaccessstreaming+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.cspg-hexbinary": {
	source: "iana"
},
	"application/vnd.oipf.dae.svg+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.dae.xhtml+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.mippvcontrolmessage+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.pae.gem": {
	source: "iana"
},
	"application/vnd.oipf.spdiscovery+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.spdlist+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.ueprofile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oipf.userprofile+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.olpc-sugar": {
	source: "iana",
	extensions: [
		"xo"
	]
},
	"application/vnd.oma-scws-config": {
	source: "iana"
},
	"application/vnd.oma-scws-http-request": {
	source: "iana"
},
	"application/vnd.oma-scws-http-response": {
	source: "iana"
},
	"application/vnd.oma.bcast.associated-procedure-parameter+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.drm-trigger+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.imd+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.ltkm": {
	source: "iana"
},
	"application/vnd.oma.bcast.notification+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.provisioningtrigger": {
	source: "iana"
},
	"application/vnd.oma.bcast.sgboot": {
	source: "iana"
},
	"application/vnd.oma.bcast.sgdd+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.sgdu": {
	source: "iana"
},
	"application/vnd.oma.bcast.simple-symbol-container": {
	source: "iana"
},
	"application/vnd.oma.bcast.smartcard-trigger+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.sprov+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.bcast.stkm": {
	source: "iana"
},
	"application/vnd.oma.cab-address-book+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.cab-feature-handler+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.cab-pcc+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.cab-subs-invite+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.cab-user-prefs+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.dcd": {
	source: "iana"
},
	"application/vnd.oma.dcdc": {
	source: "iana"
},
	"application/vnd.oma.dd2+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"dd2"
	]
},
	"application/vnd.oma.drm.risd+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.group-usage-list+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.lwm2m+cbor": {
	source: "iana"
},
	"application/vnd.oma.lwm2m+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.lwm2m+tlv": {
	source: "iana"
},
	"application/vnd.oma.pal+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.poc.detailed-progress-report+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.poc.final-report+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.poc.groups+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.poc.invocation-descriptor+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.poc.optimized-progress-report+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.push": {
	source: "iana"
},
	"application/vnd.oma.scidm.messages+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oma.xcap-directory+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.omads-email+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/vnd.omads-file+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/vnd.omads-folder+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/vnd.omaloc-supl-init": {
	source: "iana"
},
	"application/vnd.onepager": {
	source: "iana"
},
	"application/vnd.onepagertamp": {
	source: "iana"
},
	"application/vnd.onepagertamx": {
	source: "iana"
},
	"application/vnd.onepagertat": {
	source: "iana"
},
	"application/vnd.onepagertatp": {
	source: "iana"
},
	"application/vnd.onepagertatx": {
	source: "iana"
},
	"application/vnd.openblox.game+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"obgx"
	]
},
	"application/vnd.openblox.game-binary": {
	source: "iana"
},
	"application/vnd.openeye.oeb": {
	source: "iana"
},
	"application/vnd.openofficeorg.extension": {
	source: "apache",
	extensions: [
		"oxt"
	]
},
	"application/vnd.openstreetmap.data+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"osm"
	]
},
	"application/vnd.opentimestamps.ots": {
	source: "iana"
},
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawing+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.presentation": {
	source: "iana",
	compressible: false,
	extensions: [
		"pptx"
	]
},
	"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.slide": {
	source: "iana",
	extensions: [
		"sldx"
	]
},
	"application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
	source: "iana",
	extensions: [
		"ppsx"
	]
},
	"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.template": {
	source: "iana",
	extensions: [
		"potx"
	]
},
	"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
	source: "iana",
	compressible: false,
	extensions: [
		"xlsx"
	]
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
	source: "iana",
	extensions: [
		"xltx"
	]
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.theme+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.themeoverride+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.vmldrawing": {
	source: "iana"
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
	source: "iana",
	compressible: false,
	extensions: [
		"docx"
	]
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
	source: "iana",
	extensions: [
		"dotx"
	]
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-package.core-properties+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.openxmlformats-package.relationships+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oracle.resource+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.orange.indata": {
	source: "iana"
},
	"application/vnd.osa.netdeploy": {
	source: "iana"
},
	"application/vnd.osgeo.mapguide.package": {
	source: "iana",
	extensions: [
		"mgp"
	]
},
	"application/vnd.osgi.bundle": {
	source: "iana"
},
	"application/vnd.osgi.dp": {
	source: "iana",
	extensions: [
		"dp"
	]
},
	"application/vnd.osgi.subsystem": {
	source: "iana",
	extensions: [
		"esa"
	]
},
	"application/vnd.otps.ct-kip+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.oxli.countgraph": {
	source: "iana"
},
	"application/vnd.pagerduty+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.palm": {
	source: "iana",
	extensions: [
		"pdb",
		"pqa",
		"oprc"
	]
},
	"application/vnd.panoply": {
	source: "iana"
},
	"application/vnd.paos.xml": {
	source: "iana"
},
	"application/vnd.patentdive": {
	source: "iana"
},
	"application/vnd.patientecommsdoc": {
	source: "iana"
},
	"application/vnd.pawaafile": {
	source: "iana",
	extensions: [
		"paw"
	]
},
	"application/vnd.pcos": {
	source: "iana"
},
	"application/vnd.pg.format": {
	source: "iana",
	extensions: [
		"str"
	]
},
	"application/vnd.pg.osasli": {
	source: "iana",
	extensions: [
		"ei6"
	]
},
	"application/vnd.piaccess.application-licence": {
	source: "iana"
},
	"application/vnd.picsel": {
	source: "iana",
	extensions: [
		"efif"
	]
},
	"application/vnd.pmi.widget": {
	source: "iana",
	extensions: [
		"wg"
	]
},
	"application/vnd.poc.group-advertisement+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.pocketlearn": {
	source: "iana",
	extensions: [
		"plf"
	]
},
	"application/vnd.powerbuilder6": {
	source: "iana",
	extensions: [
		"pbd"
	]
},
	"application/vnd.powerbuilder6-s": {
	source: "iana"
},
	"application/vnd.powerbuilder7": {
	source: "iana"
},
	"application/vnd.powerbuilder7-s": {
	source: "iana"
},
	"application/vnd.powerbuilder75": {
	source: "iana"
},
	"application/vnd.powerbuilder75-s": {
	source: "iana"
},
	"application/vnd.preminet": {
	source: "iana"
},
	"application/vnd.previewsystems.box": {
	source: "iana",
	extensions: [
		"box"
	]
},
	"application/vnd.proteus.magazine": {
	source: "iana",
	extensions: [
		"mgz"
	]
},
	"application/vnd.psfs": {
	source: "iana"
},
	"application/vnd.publishare-delta-tree": {
	source: "iana",
	extensions: [
		"qps"
	]
},
	"application/vnd.pvi.ptid1": {
	source: "iana",
	extensions: [
		"ptid"
	]
},
	"application/vnd.pwg-multiplexed": {
	source: "iana"
},
	"application/vnd.pwg-xhtml-print+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.qualcomm.brew-app-res": {
	source: "iana"
},
	"application/vnd.quarantainenet": {
	source: "iana"
},
	"application/vnd.quark.quarkxpress": {
	source: "iana",
	extensions: [
		"qxd",
		"qxt",
		"qwd",
		"qwt",
		"qxl",
		"qxb"
	]
},
	"application/vnd.quobject-quoxdocument": {
	source: "iana"
},
	"application/vnd.radisys.moml+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-audit+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-audit-conf+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-audit-conn+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-audit-dialog+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-audit-stream+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-conf+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog-base+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog-fax-detect+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog-group+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog-speech+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.radisys.msml-dialog-transform+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.rainstor.data": {
	source: "iana"
},
	"application/vnd.rapid": {
	source: "iana"
},
	"application/vnd.rar": {
	source: "iana",
	extensions: [
		"rar"
	]
},
	"application/vnd.realvnc.bed": {
	source: "iana",
	extensions: [
		"bed"
	]
},
	"application/vnd.recordare.musicxml": {
	source: "iana",
	extensions: [
		"mxl"
	]
},
	"application/vnd.recordare.musicxml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"musicxml"
	]
},
	"application/vnd.renlearn.rlprint": {
	source: "iana"
},
	"application/vnd.resilient.logic": {
	source: "iana"
},
	"application/vnd.restful+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.rig.cryptonote": {
	source: "iana",
	extensions: [
		"cryptonote"
	]
},
	"application/vnd.rim.cod": {
	source: "apache",
	extensions: [
		"cod"
	]
},
	"application/vnd.rn-realmedia": {
	source: "apache",
	extensions: [
		"rm"
	]
},
	"application/vnd.rn-realmedia-vbr": {
	source: "apache",
	extensions: [
		"rmvb"
	]
},
	"application/vnd.route66.link66+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"link66"
	]
},
	"application/vnd.rs-274x": {
	source: "iana"
},
	"application/vnd.ruckus.download": {
	source: "iana"
},
	"application/vnd.s3sms": {
	source: "iana"
},
	"application/vnd.sailingtracker.track": {
	source: "iana",
	extensions: [
		"st"
	]
},
	"application/vnd.sar": {
	source: "iana"
},
	"application/vnd.sbm.cid": {
	source: "iana"
},
	"application/vnd.sbm.mid2": {
	source: "iana"
},
	"application/vnd.scribus": {
	source: "iana"
},
	"application/vnd.sealed.3df": {
	source: "iana"
},
	"application/vnd.sealed.csf": {
	source: "iana"
},
	"application/vnd.sealed.doc": {
	source: "iana"
},
	"application/vnd.sealed.eml": {
	source: "iana"
},
	"application/vnd.sealed.mht": {
	source: "iana"
},
	"application/vnd.sealed.net": {
	source: "iana"
},
	"application/vnd.sealed.ppt": {
	source: "iana"
},
	"application/vnd.sealed.tiff": {
	source: "iana"
},
	"application/vnd.sealed.xls": {
	source: "iana"
},
	"application/vnd.sealedmedia.softseal.html": {
	source: "iana"
},
	"application/vnd.sealedmedia.softseal.pdf": {
	source: "iana"
},
	"application/vnd.seemail": {
	source: "iana",
	extensions: [
		"see"
	]
},
	"application/vnd.seis+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.sema": {
	source: "iana",
	extensions: [
		"sema"
	]
},
	"application/vnd.semd": {
	source: "iana",
	extensions: [
		"semd"
	]
},
	"application/vnd.semf": {
	source: "iana",
	extensions: [
		"semf"
	]
},
	"application/vnd.shade-save-file": {
	source: "iana"
},
	"application/vnd.shana.informed.formdata": {
	source: "iana",
	extensions: [
		"ifm"
	]
},
	"application/vnd.shana.informed.formtemplate": {
	source: "iana",
	extensions: [
		"itp"
	]
},
	"application/vnd.shana.informed.interchange": {
	source: "iana",
	extensions: [
		"iif"
	]
},
	"application/vnd.shana.informed.package": {
	source: "iana",
	extensions: [
		"ipk"
	]
},
	"application/vnd.shootproof+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.shopkick+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.shp": {
	source: "iana"
},
	"application/vnd.shx": {
	source: "iana"
},
	"application/vnd.sigrok.session": {
	source: "iana"
},
	"application/vnd.simtech-mindmapper": {
	source: "iana",
	extensions: [
		"twd",
		"twds"
	]
},
	"application/vnd.siren+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.smaf": {
	source: "iana",
	extensions: [
		"mmf"
	]
},
	"application/vnd.smart.notebook": {
	source: "iana"
},
	"application/vnd.smart.teacher": {
	source: "iana",
	extensions: [
		"teacher"
	]
},
	"application/vnd.snesdev-page-table": {
	source: "iana"
},
	"application/vnd.software602.filler.form+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"fo"
	]
},
	"application/vnd.software602.filler.form-xml-zip": {
	source: "iana"
},
	"application/vnd.solent.sdkm+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"sdkm",
		"sdkd"
	]
},
	"application/vnd.spotfire.dxp": {
	source: "iana",
	extensions: [
		"dxp"
	]
},
	"application/vnd.spotfire.sfs": {
	source: "iana",
	extensions: [
		"sfs"
	]
},
	"application/vnd.sqlite3": {
	source: "iana"
},
	"application/vnd.sss-cod": {
	source: "iana"
},
	"application/vnd.sss-dtf": {
	source: "iana"
},
	"application/vnd.sss-ntf": {
	source: "iana"
},
	"application/vnd.stardivision.calc": {
	source: "apache",
	extensions: [
		"sdc"
	]
},
	"application/vnd.stardivision.draw": {
	source: "apache",
	extensions: [
		"sda"
	]
},
	"application/vnd.stardivision.impress": {
	source: "apache",
	extensions: [
		"sdd"
	]
},
	"application/vnd.stardivision.math": {
	source: "apache",
	extensions: [
		"smf"
	]
},
	"application/vnd.stardivision.writer": {
	source: "apache",
	extensions: [
		"sdw",
		"vor"
	]
},
	"application/vnd.stardivision.writer-global": {
	source: "apache",
	extensions: [
		"sgl"
	]
},
	"application/vnd.stepmania.package": {
	source: "iana",
	extensions: [
		"smzip"
	]
},
	"application/vnd.stepmania.stepchart": {
	source: "iana",
	extensions: [
		"sm"
	]
},
	"application/vnd.street-stream": {
	source: "iana"
},
	"application/vnd.sun.wadl+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"wadl"
	]
},
	"application/vnd.sun.xml.calc": {
	source: "apache",
	extensions: [
		"sxc"
	]
},
	"application/vnd.sun.xml.calc.template": {
	source: "apache",
	extensions: [
		"stc"
	]
},
	"application/vnd.sun.xml.draw": {
	source: "apache",
	extensions: [
		"sxd"
	]
},
	"application/vnd.sun.xml.draw.template": {
	source: "apache",
	extensions: [
		"std"
	]
},
	"application/vnd.sun.xml.impress": {
	source: "apache",
	extensions: [
		"sxi"
	]
},
	"application/vnd.sun.xml.impress.template": {
	source: "apache",
	extensions: [
		"sti"
	]
},
	"application/vnd.sun.xml.math": {
	source: "apache",
	extensions: [
		"sxm"
	]
},
	"application/vnd.sun.xml.writer": {
	source: "apache",
	extensions: [
		"sxw"
	]
},
	"application/vnd.sun.xml.writer.global": {
	source: "apache",
	extensions: [
		"sxg"
	]
},
	"application/vnd.sun.xml.writer.template": {
	source: "apache",
	extensions: [
		"stw"
	]
},
	"application/vnd.sus-calendar": {
	source: "iana",
	extensions: [
		"sus",
		"susp"
	]
},
	"application/vnd.svd": {
	source: "iana",
	extensions: [
		"svd"
	]
},
	"application/vnd.swiftview-ics": {
	source: "iana"
},
	"application/vnd.sycle+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.syft+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.symbian.install": {
	source: "apache",
	extensions: [
		"sis",
		"sisx"
	]
},
	"application/vnd.syncml+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"xsm"
	]
},
	"application/vnd.syncml.dm+wbxml": {
	source: "iana",
	charset: "UTF-8",
	extensions: [
		"bdm"
	]
},
	"application/vnd.syncml.dm+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"xdm"
	]
},
	"application/vnd.syncml.dm.notification": {
	source: "iana"
},
	"application/vnd.syncml.dmddf+wbxml": {
	source: "iana"
},
	"application/vnd.syncml.dmddf+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"ddf"
	]
},
	"application/vnd.syncml.dmtnds+wbxml": {
	source: "iana"
},
	"application/vnd.syncml.dmtnds+xml": {
	source: "iana",
	charset: "UTF-8",
	compressible: true
},
	"application/vnd.syncml.ds.notification": {
	source: "iana"
},
	"application/vnd.tableschema+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.tao.intent-module-archive": {
	source: "iana",
	extensions: [
		"tao"
	]
},
	"application/vnd.tcpdump.pcap": {
	source: "iana",
	extensions: [
		"pcap",
		"cap",
		"dmp"
	]
},
	"application/vnd.think-cell.ppttc+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.tmd.mediaflex.api+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.tml": {
	source: "iana"
},
	"application/vnd.tmobile-livetv": {
	source: "iana",
	extensions: [
		"tmo"
	]
},
	"application/vnd.tri.onesource": {
	source: "iana"
},
	"application/vnd.trid.tpt": {
	source: "iana",
	extensions: [
		"tpt"
	]
},
	"application/vnd.triscape.mxs": {
	source: "iana",
	extensions: [
		"mxs"
	]
},
	"application/vnd.trueapp": {
	source: "iana",
	extensions: [
		"tra"
	]
},
	"application/vnd.truedoc": {
	source: "iana"
},
	"application/vnd.ubisoft.webplayer": {
	source: "iana"
},
	"application/vnd.ufdl": {
	source: "iana",
	extensions: [
		"ufd",
		"ufdl"
	]
},
	"application/vnd.uiq.theme": {
	source: "iana",
	extensions: [
		"utz"
	]
},
	"application/vnd.umajin": {
	source: "iana",
	extensions: [
		"umj"
	]
},
	"application/vnd.unity": {
	source: "iana",
	extensions: [
		"unityweb"
	]
},
	"application/vnd.uoml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"uoml"
	]
},
	"application/vnd.uplanet.alert": {
	source: "iana"
},
	"application/vnd.uplanet.alert-wbxml": {
	source: "iana"
},
	"application/vnd.uplanet.bearer-choice": {
	source: "iana"
},
	"application/vnd.uplanet.bearer-choice-wbxml": {
	source: "iana"
},
	"application/vnd.uplanet.cacheop": {
	source: "iana"
},
	"application/vnd.uplanet.cacheop-wbxml": {
	source: "iana"
},
	"application/vnd.uplanet.channel": {
	source: "iana"
},
	"application/vnd.uplanet.channel-wbxml": {
	source: "iana"
},
	"application/vnd.uplanet.list": {
	source: "iana"
},
	"application/vnd.uplanet.list-wbxml": {
	source: "iana"
},
	"application/vnd.uplanet.listcmd": {
	source: "iana"
},
	"application/vnd.uplanet.listcmd-wbxml": {
	source: "iana"
},
	"application/vnd.uplanet.signal": {
	source: "iana"
},
	"application/vnd.uri-map": {
	source: "iana"
},
	"application/vnd.valve.source.material": {
	source: "iana"
},
	"application/vnd.vcx": {
	source: "iana",
	extensions: [
		"vcx"
	]
},
	"application/vnd.vd-study": {
	source: "iana"
},
	"application/vnd.vectorworks": {
	source: "iana"
},
	"application/vnd.vel+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.verimatrix.vcas": {
	source: "iana"
},
	"application/vnd.veritone.aion+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.veryant.thin": {
	source: "iana"
},
	"application/vnd.ves.encrypted": {
	source: "iana"
},
	"application/vnd.vidsoft.vidconference": {
	source: "iana"
},
	"application/vnd.visio": {
	source: "iana",
	extensions: [
		"vsd",
		"vst",
		"vss",
		"vsw"
	]
},
	"application/vnd.visionary": {
	source: "iana",
	extensions: [
		"vis"
	]
},
	"application/vnd.vividence.scriptfile": {
	source: "iana"
},
	"application/vnd.vsf": {
	source: "iana",
	extensions: [
		"vsf"
	]
},
	"application/vnd.wap.sic": {
	source: "iana"
},
	"application/vnd.wap.slc": {
	source: "iana"
},
	"application/vnd.wap.wbxml": {
	source: "iana",
	charset: "UTF-8",
	extensions: [
		"wbxml"
	]
},
	"application/vnd.wap.wmlc": {
	source: "iana",
	extensions: [
		"wmlc"
	]
},
	"application/vnd.wap.wmlscriptc": {
	source: "iana",
	extensions: [
		"wmlsc"
	]
},
	"application/vnd.webturbo": {
	source: "iana",
	extensions: [
		"wtb"
	]
},
	"application/vnd.wfa.dpp": {
	source: "iana"
},
	"application/vnd.wfa.p2p": {
	source: "iana"
},
	"application/vnd.wfa.wsc": {
	source: "iana"
},
	"application/vnd.windows.devicepairing": {
	source: "iana"
},
	"application/vnd.wmc": {
	source: "iana"
},
	"application/vnd.wmf.bootstrap": {
	source: "iana"
},
	"application/vnd.wolfram.mathematica": {
	source: "iana"
},
	"application/vnd.wolfram.mathematica.package": {
	source: "iana"
},
	"application/vnd.wolfram.player": {
	source: "iana",
	extensions: [
		"nbp"
	]
},
	"application/vnd.wordperfect": {
	source: "iana",
	extensions: [
		"wpd"
	]
},
	"application/vnd.wqd": {
	source: "iana",
	extensions: [
		"wqd"
	]
},
	"application/vnd.wrq-hp3000-labelled": {
	source: "iana"
},
	"application/vnd.wt.stf": {
	source: "iana",
	extensions: [
		"stf"
	]
},
	"application/vnd.wv.csp+wbxml": {
	source: "iana"
},
	"application/vnd.wv.csp+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.wv.ssp+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.xacml+json": {
	source: "iana",
	compressible: true
},
	"application/vnd.xara": {
	source: "iana",
	extensions: [
		"xar"
	]
},
	"application/vnd.xfdl": {
	source: "iana",
	extensions: [
		"xfdl"
	]
},
	"application/vnd.xfdl.webform": {
	source: "iana"
},
	"application/vnd.xmi+xml": {
	source: "iana",
	compressible: true
},
	"application/vnd.xmpie.cpkg": {
	source: "iana"
},
	"application/vnd.xmpie.dpkg": {
	source: "iana"
},
	"application/vnd.xmpie.plan": {
	source: "iana"
},
	"application/vnd.xmpie.ppkg": {
	source: "iana"
},
	"application/vnd.xmpie.xlim": {
	source: "iana"
},
	"application/vnd.yamaha.hv-dic": {
	source: "iana",
	extensions: [
		"hvd"
	]
},
	"application/vnd.yamaha.hv-script": {
	source: "iana",
	extensions: [
		"hvs"
	]
},
	"application/vnd.yamaha.hv-voice": {
	source: "iana",
	extensions: [
		"hvp"
	]
},
	"application/vnd.yamaha.openscoreformat": {
	source: "iana",
	extensions: [
		"osf"
	]
},
	"application/vnd.yamaha.openscoreformat.osfpvg+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"osfpvg"
	]
},
	"application/vnd.yamaha.remote-setup": {
	source: "iana"
},
	"application/vnd.yamaha.smaf-audio": {
	source: "iana",
	extensions: [
		"saf"
	]
},
	"application/vnd.yamaha.smaf-phrase": {
	source: "iana",
	extensions: [
		"spf"
	]
},
	"application/vnd.yamaha.through-ngn": {
	source: "iana"
},
	"application/vnd.yamaha.tunnel-udpencap": {
	source: "iana"
},
	"application/vnd.yaoweme": {
	source: "iana"
},
	"application/vnd.yellowriver-custom-menu": {
	source: "iana",
	extensions: [
		"cmp"
	]
},
	"application/vnd.youtube.yt": {
	source: "iana"
},
	"application/vnd.zul": {
	source: "iana",
	extensions: [
		"zir",
		"zirz"
	]
},
	"application/vnd.zzazz.deck+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"zaz"
	]
},
	"application/voicexml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"vxml"
	]
},
	"application/voucher-cms+json": {
	source: "iana",
	compressible: true
},
	"application/vq-rtcpxr": {
	source: "iana"
},
	"application/wasm": {
	source: "iana",
	compressible: true,
	extensions: [
		"wasm"
	]
},
	"application/watcherinfo+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"wif"
	]
},
	"application/webpush-options+json": {
	source: "iana",
	compressible: true
},
	"application/whoispp-query": {
	source: "iana"
},
	"application/whoispp-response": {
	source: "iana"
},
	"application/widget": {
	source: "iana",
	extensions: [
		"wgt"
	]
},
	"application/winhlp": {
	source: "apache",
	extensions: [
		"hlp"
	]
},
	"application/wita": {
	source: "iana"
},
	"application/wordperfect5.1": {
	source: "iana"
},
	"application/wsdl+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"wsdl"
	]
},
	"application/wspolicy+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"wspolicy"
	]
},
	"application/x-7z-compressed": {
	source: "apache",
	compressible: false,
	extensions: [
		"7z"
	]
},
	"application/x-abiword": {
	source: "apache",
	extensions: [
		"abw"
	]
},
	"application/x-ace-compressed": {
	source: "apache",
	extensions: [
		"ace"
	]
},
	"application/x-amf": {
	source: "apache"
},
	"application/x-apple-diskimage": {
	source: "apache",
	extensions: [
		"dmg"
	]
},
	"application/x-arj": {
	compressible: false,
	extensions: [
		"arj"
	]
},
	"application/x-authorware-bin": {
	source: "apache",
	extensions: [
		"aab",
		"x32",
		"u32",
		"vox"
	]
},
	"application/x-authorware-map": {
	source: "apache",
	extensions: [
		"aam"
	]
},
	"application/x-authorware-seg": {
	source: "apache",
	extensions: [
		"aas"
	]
},
	"application/x-bcpio": {
	source: "apache",
	extensions: [
		"bcpio"
	]
},
	"application/x-bdoc": {
	compressible: false,
	extensions: [
		"bdoc"
	]
},
	"application/x-bittorrent": {
	source: "apache",
	extensions: [
		"torrent"
	]
},
	"application/x-blorb": {
	source: "apache",
	extensions: [
		"blb",
		"blorb"
	]
},
	"application/x-bzip": {
	source: "apache",
	compressible: false,
	extensions: [
		"bz"
	]
},
	"application/x-bzip2": {
	source: "apache",
	compressible: false,
	extensions: [
		"bz2",
		"boz"
	]
},
	"application/x-cbr": {
	source: "apache",
	extensions: [
		"cbr",
		"cba",
		"cbt",
		"cbz",
		"cb7"
	]
},
	"application/x-cdlink": {
	source: "apache",
	extensions: [
		"vcd"
	]
},
	"application/x-cfs-compressed": {
	source: "apache",
	extensions: [
		"cfs"
	]
},
	"application/x-chat": {
	source: "apache",
	extensions: [
		"chat"
	]
},
	"application/x-chess-pgn": {
	source: "apache",
	extensions: [
		"pgn"
	]
},
	"application/x-chrome-extension": {
	extensions: [
		"crx"
	]
},
	"application/x-cocoa": {
	source: "nginx",
	extensions: [
		"cco"
	]
},
	"application/x-compress": {
	source: "apache"
},
	"application/x-conference": {
	source: "apache",
	extensions: [
		"nsc"
	]
},
	"application/x-cpio": {
	source: "apache",
	extensions: [
		"cpio"
	]
},
	"application/x-csh": {
	source: "apache",
	extensions: [
		"csh"
	]
},
	"application/x-deb": {
	compressible: false
},
	"application/x-debian-package": {
	source: "apache",
	extensions: [
		"deb",
		"udeb"
	]
},
	"application/x-dgc-compressed": {
	source: "apache",
	extensions: [
		"dgc"
	]
},
	"application/x-director": {
	source: "apache",
	extensions: [
		"dir",
		"dcr",
		"dxr",
		"cst",
		"cct",
		"cxt",
		"w3d",
		"fgd",
		"swa"
	]
},
	"application/x-doom": {
	source: "apache",
	extensions: [
		"wad"
	]
},
	"application/x-dtbncx+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"ncx"
	]
},
	"application/x-dtbook+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"dtb"
	]
},
	"application/x-dtbresource+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"res"
	]
},
	"application/x-dvi": {
	source: "apache",
	compressible: false,
	extensions: [
		"dvi"
	]
},
	"application/x-envoy": {
	source: "apache",
	extensions: [
		"evy"
	]
},
	"application/x-eva": {
	source: "apache",
	extensions: [
		"eva"
	]
},
	"application/x-font-bdf": {
	source: "apache",
	extensions: [
		"bdf"
	]
},
	"application/x-font-dos": {
	source: "apache"
},
	"application/x-font-framemaker": {
	source: "apache"
},
	"application/x-font-ghostscript": {
	source: "apache",
	extensions: [
		"gsf"
	]
},
	"application/x-font-libgrx": {
	source: "apache"
},
	"application/x-font-linux-psf": {
	source: "apache",
	extensions: [
		"psf"
	]
},
	"application/x-font-pcf": {
	source: "apache",
	extensions: [
		"pcf"
	]
},
	"application/x-font-snf": {
	source: "apache",
	extensions: [
		"snf"
	]
},
	"application/x-font-speedo": {
	source: "apache"
},
	"application/x-font-sunos-news": {
	source: "apache"
},
	"application/x-font-type1": {
	source: "apache",
	extensions: [
		"pfa",
		"pfb",
		"pfm",
		"afm"
	]
},
	"application/x-font-vfont": {
	source: "apache"
},
	"application/x-freearc": {
	source: "apache",
	extensions: [
		"arc"
	]
},
	"application/x-futuresplash": {
	source: "apache",
	extensions: [
		"spl"
	]
},
	"application/x-gca-compressed": {
	source: "apache",
	extensions: [
		"gca"
	]
},
	"application/x-glulx": {
	source: "apache",
	extensions: [
		"ulx"
	]
},
	"application/x-gnumeric": {
	source: "apache",
	extensions: [
		"gnumeric"
	]
},
	"application/x-gramps-xml": {
	source: "apache",
	extensions: [
		"gramps"
	]
},
	"application/x-gtar": {
	source: "apache",
	extensions: [
		"gtar"
	]
},
	"application/x-gzip": {
	source: "apache"
},
	"application/x-hdf": {
	source: "apache",
	extensions: [
		"hdf"
	]
},
	"application/x-httpd-php": {
	compressible: true,
	extensions: [
		"php"
	]
},
	"application/x-install-instructions": {
	source: "apache",
	extensions: [
		"install"
	]
},
	"application/x-iso9660-image": {
	source: "apache",
	extensions: [
		"iso"
	]
},
	"application/x-iwork-keynote-sffkey": {
	extensions: [
		"key"
	]
},
	"application/x-iwork-numbers-sffnumbers": {
	extensions: [
		"numbers"
	]
},
	"application/x-iwork-pages-sffpages": {
	extensions: [
		"pages"
	]
},
	"application/x-java-archive-diff": {
	source: "nginx",
	extensions: [
		"jardiff"
	]
},
	"application/x-java-jnlp-file": {
	source: "apache",
	compressible: false,
	extensions: [
		"jnlp"
	]
},
	"application/x-javascript": {
	compressible: true
},
	"application/x-keepass2": {
	extensions: [
		"kdbx"
	]
},
	"application/x-latex": {
	source: "apache",
	compressible: false,
	extensions: [
		"latex"
	]
},
	"application/x-lua-bytecode": {
	extensions: [
		"luac"
	]
},
	"application/x-lzh-compressed": {
	source: "apache",
	extensions: [
		"lzh",
		"lha"
	]
},
	"application/x-makeself": {
	source: "nginx",
	extensions: [
		"run"
	]
},
	"application/x-mie": {
	source: "apache",
	extensions: [
		"mie"
	]
},
	"application/x-mobipocket-ebook": {
	source: "apache",
	extensions: [
		"prc",
		"mobi"
	]
},
	"application/x-mpegurl": {
	compressible: false
},
	"application/x-ms-application": {
	source: "apache",
	extensions: [
		"application"
	]
},
	"application/x-ms-shortcut": {
	source: "apache",
	extensions: [
		"lnk"
	]
},
	"application/x-ms-wmd": {
	source: "apache",
	extensions: [
		"wmd"
	]
},
	"application/x-ms-wmz": {
	source: "apache",
	extensions: [
		"wmz"
	]
},
	"application/x-ms-xbap": {
	source: "apache",
	extensions: [
		"xbap"
	]
},
	"application/x-msaccess": {
	source: "apache",
	extensions: [
		"mdb"
	]
},
	"application/x-msbinder": {
	source: "apache",
	extensions: [
		"obd"
	]
},
	"application/x-mscardfile": {
	source: "apache",
	extensions: [
		"crd"
	]
},
	"application/x-msclip": {
	source: "apache",
	extensions: [
		"clp"
	]
},
	"application/x-msdos-program": {
	extensions: [
		"exe"
	]
},
	"application/x-msdownload": {
	source: "apache",
	extensions: [
		"exe",
		"dll",
		"com",
		"bat",
		"msi"
	]
},
	"application/x-msmediaview": {
	source: "apache",
	extensions: [
		"mvb",
		"m13",
		"m14"
	]
},
	"application/x-msmetafile": {
	source: "apache",
	extensions: [
		"wmf",
		"wmz",
		"emf",
		"emz"
	]
},
	"application/x-msmoney": {
	source: "apache",
	extensions: [
		"mny"
	]
},
	"application/x-mspublisher": {
	source: "apache",
	extensions: [
		"pub"
	]
},
	"application/x-msschedule": {
	source: "apache",
	extensions: [
		"scd"
	]
},
	"application/x-msterminal": {
	source: "apache",
	extensions: [
		"trm"
	]
},
	"application/x-mswrite": {
	source: "apache",
	extensions: [
		"wri"
	]
},
	"application/x-netcdf": {
	source: "apache",
	extensions: [
		"nc",
		"cdf"
	]
},
	"application/x-ns-proxy-autoconfig": {
	compressible: true,
	extensions: [
		"pac"
	]
},
	"application/x-nzb": {
	source: "apache",
	extensions: [
		"nzb"
	]
},
	"application/x-perl": {
	source: "nginx",
	extensions: [
		"pl",
		"pm"
	]
},
	"application/x-pilot": {
	source: "nginx",
	extensions: [
		"prc",
		"pdb"
	]
},
	"application/x-pkcs12": {
	source: "apache",
	compressible: false,
	extensions: [
		"p12",
		"pfx"
	]
},
	"application/x-pkcs7-certificates": {
	source: "apache",
	extensions: [
		"p7b",
		"spc"
	]
},
	"application/x-pkcs7-certreqresp": {
	source: "apache",
	extensions: [
		"p7r"
	]
},
	"application/x-pki-message": {
	source: "iana"
},
	"application/x-rar-compressed": {
	source: "apache",
	compressible: false,
	extensions: [
		"rar"
	]
},
	"application/x-redhat-package-manager": {
	source: "nginx",
	extensions: [
		"rpm"
	]
},
	"application/x-research-info-systems": {
	source: "apache",
	extensions: [
		"ris"
	]
},
	"application/x-sea": {
	source: "nginx",
	extensions: [
		"sea"
	]
},
	"application/x-sh": {
	source: "apache",
	compressible: true,
	extensions: [
		"sh"
	]
},
	"application/x-shar": {
	source: "apache",
	extensions: [
		"shar"
	]
},
	"application/x-shockwave-flash": {
	source: "apache",
	compressible: false,
	extensions: [
		"swf"
	]
},
	"application/x-silverlight-app": {
	source: "apache",
	extensions: [
		"xap"
	]
},
	"application/x-sql": {
	source: "apache",
	extensions: [
		"sql"
	]
},
	"application/x-stuffit": {
	source: "apache",
	compressible: false,
	extensions: [
		"sit"
	]
},
	"application/x-stuffitx": {
	source: "apache",
	extensions: [
		"sitx"
	]
},
	"application/x-subrip": {
	source: "apache",
	extensions: [
		"srt"
	]
},
	"application/x-sv4cpio": {
	source: "apache",
	extensions: [
		"sv4cpio"
	]
},
	"application/x-sv4crc": {
	source: "apache",
	extensions: [
		"sv4crc"
	]
},
	"application/x-t3vm-image": {
	source: "apache",
	extensions: [
		"t3"
	]
},
	"application/x-tads": {
	source: "apache",
	extensions: [
		"gam"
	]
},
	"application/x-tar": {
	source: "apache",
	compressible: true,
	extensions: [
		"tar"
	]
},
	"application/x-tcl": {
	source: "apache",
	extensions: [
		"tcl",
		"tk"
	]
},
	"application/x-tex": {
	source: "apache",
	extensions: [
		"tex"
	]
},
	"application/x-tex-tfm": {
	source: "apache",
	extensions: [
		"tfm"
	]
},
	"application/x-texinfo": {
	source: "apache",
	extensions: [
		"texinfo",
		"texi"
	]
},
	"application/x-tgif": {
	source: "apache",
	extensions: [
		"obj"
	]
},
	"application/x-ustar": {
	source: "apache",
	extensions: [
		"ustar"
	]
},
	"application/x-virtualbox-hdd": {
	compressible: true,
	extensions: [
		"hdd"
	]
},
	"application/x-virtualbox-ova": {
	compressible: true,
	extensions: [
		"ova"
	]
},
	"application/x-virtualbox-ovf": {
	compressible: true,
	extensions: [
		"ovf"
	]
},
	"application/x-virtualbox-vbox": {
	compressible: true,
	extensions: [
		"vbox"
	]
},
	"application/x-virtualbox-vbox-extpack": {
	compressible: false,
	extensions: [
		"vbox-extpack"
	]
},
	"application/x-virtualbox-vdi": {
	compressible: true,
	extensions: [
		"vdi"
	]
},
	"application/x-virtualbox-vhd": {
	compressible: true,
	extensions: [
		"vhd"
	]
},
	"application/x-virtualbox-vmdk": {
	compressible: true,
	extensions: [
		"vmdk"
	]
},
	"application/x-wais-source": {
	source: "apache",
	extensions: [
		"src"
	]
},
	"application/x-web-app-manifest+json": {
	compressible: true,
	extensions: [
		"webapp"
	]
},
	"application/x-www-form-urlencoded": {
	source: "iana",
	compressible: true
},
	"application/x-x509-ca-cert": {
	source: "iana",
	extensions: [
		"der",
		"crt",
		"pem"
	]
},
	"application/x-x509-ca-ra-cert": {
	source: "iana"
},
	"application/x-x509-next-ca-cert": {
	source: "iana"
},
	"application/x-xfig": {
	source: "apache",
	extensions: [
		"fig"
	]
},
	"application/x-xliff+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"xlf"
	]
},
	"application/x-xpinstall": {
	source: "apache",
	compressible: false,
	extensions: [
		"xpi"
	]
},
	"application/x-xz": {
	source: "apache",
	extensions: [
		"xz"
	]
},
	"application/x-zmachine": {
	source: "apache",
	extensions: [
		"z1",
		"z2",
		"z3",
		"z4",
		"z5",
		"z6",
		"z7",
		"z8"
	]
},
	"application/x400-bp": {
	source: "iana"
},
	"application/xacml+xml": {
	source: "iana",
	compressible: true
},
	"application/xaml+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"xaml"
	]
},
	"application/xcap-att+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xav"
	]
},
	"application/xcap-caps+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xca"
	]
},
	"application/xcap-diff+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xdf"
	]
},
	"application/xcap-el+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xel"
	]
},
	"application/xcap-error+xml": {
	source: "iana",
	compressible: true
},
	"application/xcap-ns+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xns"
	]
},
	"application/xcon-conference-info+xml": {
	source: "iana",
	compressible: true
},
	"application/xcon-conference-info-diff+xml": {
	source: "iana",
	compressible: true
},
	"application/xenc+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xenc"
	]
},
	"application/xhtml+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xhtml",
		"xht"
	]
},
	"application/xhtml-voice+xml": {
	source: "apache",
	compressible: true
},
	"application/xliff+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xlf"
	]
},
	"application/xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xml",
		"xsl",
		"xsd",
		"rng"
	]
},
	"application/xml-dtd": {
	source: "iana",
	compressible: true,
	extensions: [
		"dtd"
	]
},
	"application/xml-external-parsed-entity": {
	source: "iana"
},
	"application/xml-patch+xml": {
	source: "iana",
	compressible: true
},
	"application/xmpp+xml": {
	source: "iana",
	compressible: true
},
	"application/xop+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xop"
	]
},
	"application/xproc+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"xpl"
	]
},
	"application/xslt+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xsl",
		"xslt"
	]
},
	"application/xspf+xml": {
	source: "apache",
	compressible: true,
	extensions: [
		"xspf"
	]
},
	"application/xv+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"mxml",
		"xhvml",
		"xvml",
		"xvm"
	]
},
	"application/yang": {
	source: "iana",
	extensions: [
		"yang"
	]
},
	"application/yang-data+json": {
	source: "iana",
	compressible: true
},
	"application/yang-data+xml": {
	source: "iana",
	compressible: true
},
	"application/yang-patch+json": {
	source: "iana",
	compressible: true
},
	"application/yang-patch+xml": {
	source: "iana",
	compressible: true
},
	"application/yin+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"yin"
	]
},
	"application/zip": {
	source: "iana",
	compressible: false,
	extensions: [
		"zip"
	]
},
	"application/zlib": {
	source: "iana"
},
	"application/zstd": {
	source: "iana"
},
	"audio/1d-interleaved-parityfec": {
	source: "iana"
},
	"audio/32kadpcm": {
	source: "iana"
},
	"audio/3gpp": {
	source: "iana",
	compressible: false,
	extensions: [
		"3gpp"
	]
},
	"audio/3gpp2": {
	source: "iana"
},
	"audio/aac": {
	source: "iana"
},
	"audio/ac3": {
	source: "iana"
},
	"audio/adpcm": {
	source: "apache",
	extensions: [
		"adp"
	]
},
	"audio/amr": {
	source: "iana",
	extensions: [
		"amr"
	]
},
	"audio/amr-wb": {
	source: "iana"
},
	"audio/amr-wb+": {
	source: "iana"
},
	"audio/aptx": {
	source: "iana"
},
	"audio/asc": {
	source: "iana"
},
	"audio/atrac-advanced-lossless": {
	source: "iana"
},
	"audio/atrac-x": {
	source: "iana"
},
	"audio/atrac3": {
	source: "iana"
},
	"audio/basic": {
	source: "iana",
	compressible: false,
	extensions: [
		"au",
		"snd"
	]
},
	"audio/bv16": {
	source: "iana"
},
	"audio/bv32": {
	source: "iana"
},
	"audio/clearmode": {
	source: "iana"
},
	"audio/cn": {
	source: "iana"
},
	"audio/dat12": {
	source: "iana"
},
	"audio/dls": {
	source: "iana"
},
	"audio/dsr-es201108": {
	source: "iana"
},
	"audio/dsr-es202050": {
	source: "iana"
},
	"audio/dsr-es202211": {
	source: "iana"
},
	"audio/dsr-es202212": {
	source: "iana"
},
	"audio/dv": {
	source: "iana"
},
	"audio/dvi4": {
	source: "iana"
},
	"audio/eac3": {
	source: "iana"
},
	"audio/encaprtp": {
	source: "iana"
},
	"audio/evrc": {
	source: "iana"
},
	"audio/evrc-qcp": {
	source: "iana"
},
	"audio/evrc0": {
	source: "iana"
},
	"audio/evrc1": {
	source: "iana"
},
	"audio/evrcb": {
	source: "iana"
},
	"audio/evrcb0": {
	source: "iana"
},
	"audio/evrcb1": {
	source: "iana"
},
	"audio/evrcnw": {
	source: "iana"
},
	"audio/evrcnw0": {
	source: "iana"
},
	"audio/evrcnw1": {
	source: "iana"
},
	"audio/evrcwb": {
	source: "iana"
},
	"audio/evrcwb0": {
	source: "iana"
},
	"audio/evrcwb1": {
	source: "iana"
},
	"audio/evs": {
	source: "iana"
},
	"audio/flexfec": {
	source: "iana"
},
	"audio/fwdred": {
	source: "iana"
},
	"audio/g711-0": {
	source: "iana"
},
	"audio/g719": {
	source: "iana"
},
	"audio/g722": {
	source: "iana"
},
	"audio/g7221": {
	source: "iana"
},
	"audio/g723": {
	source: "iana"
},
	"audio/g726-16": {
	source: "iana"
},
	"audio/g726-24": {
	source: "iana"
},
	"audio/g726-32": {
	source: "iana"
},
	"audio/g726-40": {
	source: "iana"
},
	"audio/g728": {
	source: "iana"
},
	"audio/g729": {
	source: "iana"
},
	"audio/g7291": {
	source: "iana"
},
	"audio/g729d": {
	source: "iana"
},
	"audio/g729e": {
	source: "iana"
},
	"audio/gsm": {
	source: "iana"
},
	"audio/gsm-efr": {
	source: "iana"
},
	"audio/gsm-hr-08": {
	source: "iana"
},
	"audio/ilbc": {
	source: "iana"
},
	"audio/ip-mr_v2.5": {
	source: "iana"
},
	"audio/isac": {
	source: "apache"
},
	"audio/l16": {
	source: "iana"
},
	"audio/l20": {
	source: "iana"
},
	"audio/l24": {
	source: "iana",
	compressible: false
},
	"audio/l8": {
	source: "iana"
},
	"audio/lpc": {
	source: "iana"
},
	"audio/melp": {
	source: "iana"
},
	"audio/melp1200": {
	source: "iana"
},
	"audio/melp2400": {
	source: "iana"
},
	"audio/melp600": {
	source: "iana"
},
	"audio/mhas": {
	source: "iana"
},
	"audio/midi": {
	source: "apache",
	extensions: [
		"mid",
		"midi",
		"kar",
		"rmi"
	]
},
	"audio/mobile-xmf": {
	source: "iana",
	extensions: [
		"mxmf"
	]
},
	"audio/mp3": {
	compressible: false,
	extensions: [
		"mp3"
	]
},
	"audio/mp4": {
	source: "iana",
	compressible: false,
	extensions: [
		"m4a",
		"mp4a"
	]
},
	"audio/mp4a-latm": {
	source: "iana"
},
	"audio/mpa": {
	source: "iana"
},
	"audio/mpa-robust": {
	source: "iana"
},
	"audio/mpeg": {
	source: "iana",
	compressible: false,
	extensions: [
		"mpga",
		"mp2",
		"mp2a",
		"mp3",
		"m2a",
		"m3a"
	]
},
	"audio/mpeg4-generic": {
	source: "iana"
},
	"audio/musepack": {
	source: "apache"
},
	"audio/ogg": {
	source: "iana",
	compressible: false,
	extensions: [
		"oga",
		"ogg",
		"spx",
		"opus"
	]
},
	"audio/opus": {
	source: "iana"
},
	"audio/parityfec": {
	source: "iana"
},
	"audio/pcma": {
	source: "iana"
},
	"audio/pcma-wb": {
	source: "iana"
},
	"audio/pcmu": {
	source: "iana"
},
	"audio/pcmu-wb": {
	source: "iana"
},
	"audio/prs.sid": {
	source: "iana"
},
	"audio/qcelp": {
	source: "iana"
},
	"audio/raptorfec": {
	source: "iana"
},
	"audio/red": {
	source: "iana"
},
	"audio/rtp-enc-aescm128": {
	source: "iana"
},
	"audio/rtp-midi": {
	source: "iana"
},
	"audio/rtploopback": {
	source: "iana"
},
	"audio/rtx": {
	source: "iana"
},
	"audio/s3m": {
	source: "apache",
	extensions: [
		"s3m"
	]
},
	"audio/scip": {
	source: "iana"
},
	"audio/silk": {
	source: "apache",
	extensions: [
		"sil"
	]
},
	"audio/smv": {
	source: "iana"
},
	"audio/smv-qcp": {
	source: "iana"
},
	"audio/smv0": {
	source: "iana"
},
	"audio/sofa": {
	source: "iana"
},
	"audio/sp-midi": {
	source: "iana"
},
	"audio/speex": {
	source: "iana"
},
	"audio/t140c": {
	source: "iana"
},
	"audio/t38": {
	source: "iana"
},
	"audio/telephone-event": {
	source: "iana"
},
	"audio/tetra_acelp": {
	source: "iana"
},
	"audio/tetra_acelp_bb": {
	source: "iana"
},
	"audio/tone": {
	source: "iana"
},
	"audio/tsvcis": {
	source: "iana"
},
	"audio/uemclip": {
	source: "iana"
},
	"audio/ulpfec": {
	source: "iana"
},
	"audio/usac": {
	source: "iana"
},
	"audio/vdvi": {
	source: "iana"
},
	"audio/vmr-wb": {
	source: "iana"
},
	"audio/vnd.3gpp.iufp": {
	source: "iana"
},
	"audio/vnd.4sb": {
	source: "iana"
},
	"audio/vnd.audiokoz": {
	source: "iana"
},
	"audio/vnd.celp": {
	source: "iana"
},
	"audio/vnd.cisco.nse": {
	source: "iana"
},
	"audio/vnd.cmles.radio-events": {
	source: "iana"
},
	"audio/vnd.cns.anp1": {
	source: "iana"
},
	"audio/vnd.cns.inf1": {
	source: "iana"
},
	"audio/vnd.dece.audio": {
	source: "iana",
	extensions: [
		"uva",
		"uvva"
	]
},
	"audio/vnd.digital-winds": {
	source: "iana",
	extensions: [
		"eol"
	]
},
	"audio/vnd.dlna.adts": {
	source: "iana"
},
	"audio/vnd.dolby.heaac.1": {
	source: "iana"
},
	"audio/vnd.dolby.heaac.2": {
	source: "iana"
},
	"audio/vnd.dolby.mlp": {
	source: "iana"
},
	"audio/vnd.dolby.mps": {
	source: "iana"
},
	"audio/vnd.dolby.pl2": {
	source: "iana"
},
	"audio/vnd.dolby.pl2x": {
	source: "iana"
},
	"audio/vnd.dolby.pl2z": {
	source: "iana"
},
	"audio/vnd.dolby.pulse.1": {
	source: "iana"
},
	"audio/vnd.dra": {
	source: "iana",
	extensions: [
		"dra"
	]
},
	"audio/vnd.dts": {
	source: "iana",
	extensions: [
		"dts"
	]
},
	"audio/vnd.dts.hd": {
	source: "iana",
	extensions: [
		"dtshd"
	]
},
	"audio/vnd.dts.uhd": {
	source: "iana"
},
	"audio/vnd.dvb.file": {
	source: "iana"
},
	"audio/vnd.everad.plj": {
	source: "iana"
},
	"audio/vnd.hns.audio": {
	source: "iana"
},
	"audio/vnd.lucent.voice": {
	source: "iana",
	extensions: [
		"lvp"
	]
},
	"audio/vnd.ms-playready.media.pya": {
	source: "iana",
	extensions: [
		"pya"
	]
},
	"audio/vnd.nokia.mobile-xmf": {
	source: "iana"
},
	"audio/vnd.nortel.vbk": {
	source: "iana"
},
	"audio/vnd.nuera.ecelp4800": {
	source: "iana",
	extensions: [
		"ecelp4800"
	]
},
	"audio/vnd.nuera.ecelp7470": {
	source: "iana",
	extensions: [
		"ecelp7470"
	]
},
	"audio/vnd.nuera.ecelp9600": {
	source: "iana",
	extensions: [
		"ecelp9600"
	]
},
	"audio/vnd.octel.sbc": {
	source: "iana"
},
	"audio/vnd.presonus.multitrack": {
	source: "iana"
},
	"audio/vnd.qcelp": {
	source: "iana"
},
	"audio/vnd.rhetorex.32kadpcm": {
	source: "iana"
},
	"audio/vnd.rip": {
	source: "iana",
	extensions: [
		"rip"
	]
},
	"audio/vnd.rn-realaudio": {
	compressible: false
},
	"audio/vnd.sealedmedia.softseal.mpeg": {
	source: "iana"
},
	"audio/vnd.vmx.cvsd": {
	source: "iana"
},
	"audio/vnd.wave": {
	compressible: false
},
	"audio/vorbis": {
	source: "iana",
	compressible: false
},
	"audio/vorbis-config": {
	source: "iana"
},
	"audio/wav": {
	compressible: false,
	extensions: [
		"wav"
	]
},
	"audio/wave": {
	compressible: false,
	extensions: [
		"wav"
	]
},
	"audio/webm": {
	source: "apache",
	compressible: false,
	extensions: [
		"weba"
	]
},
	"audio/x-aac": {
	source: "apache",
	compressible: false,
	extensions: [
		"aac"
	]
},
	"audio/x-aiff": {
	source: "apache",
	extensions: [
		"aif",
		"aiff",
		"aifc"
	]
},
	"audio/x-caf": {
	source: "apache",
	compressible: false,
	extensions: [
		"caf"
	]
},
	"audio/x-flac": {
	source: "apache",
	extensions: [
		"flac"
	]
},
	"audio/x-m4a": {
	source: "nginx",
	extensions: [
		"m4a"
	]
},
	"audio/x-matroska": {
	source: "apache",
	extensions: [
		"mka"
	]
},
	"audio/x-mpegurl": {
	source: "apache",
	extensions: [
		"m3u"
	]
},
	"audio/x-ms-wax": {
	source: "apache",
	extensions: [
		"wax"
	]
},
	"audio/x-ms-wma": {
	source: "apache",
	extensions: [
		"wma"
	]
},
	"audio/x-pn-realaudio": {
	source: "apache",
	extensions: [
		"ram",
		"ra"
	]
},
	"audio/x-pn-realaudio-plugin": {
	source: "apache",
	extensions: [
		"rmp"
	]
},
	"audio/x-realaudio": {
	source: "nginx",
	extensions: [
		"ra"
	]
},
	"audio/x-tta": {
	source: "apache"
},
	"audio/x-wav": {
	source: "apache",
	extensions: [
		"wav"
	]
},
	"audio/xm": {
	source: "apache",
	extensions: [
		"xm"
	]
},
	"chemical/x-cdx": {
	source: "apache",
	extensions: [
		"cdx"
	]
},
	"chemical/x-cif": {
	source: "apache",
	extensions: [
		"cif"
	]
},
	"chemical/x-cmdf": {
	source: "apache",
	extensions: [
		"cmdf"
	]
},
	"chemical/x-cml": {
	source: "apache",
	extensions: [
		"cml"
	]
},
	"chemical/x-csml": {
	source: "apache",
	extensions: [
		"csml"
	]
},
	"chemical/x-pdb": {
	source: "apache"
},
	"chemical/x-xyz": {
	source: "apache",
	extensions: [
		"xyz"
	]
},
	"font/collection": {
	source: "iana",
	extensions: [
		"ttc"
	]
},
	"font/otf": {
	source: "iana",
	compressible: true,
	extensions: [
		"otf"
	]
},
	"font/sfnt": {
	source: "iana"
},
	"font/ttf": {
	source: "iana",
	compressible: true,
	extensions: [
		"ttf"
	]
},
	"font/woff": {
	source: "iana",
	extensions: [
		"woff"
	]
},
	"font/woff2": {
	source: "iana",
	extensions: [
		"woff2"
	]
},
	"image/aces": {
	source: "iana",
	extensions: [
		"exr"
	]
},
	"image/apng": {
	compressible: false,
	extensions: [
		"apng"
	]
},
	"image/avci": {
	source: "iana",
	extensions: [
		"avci"
	]
},
	"image/avcs": {
	source: "iana",
	extensions: [
		"avcs"
	]
},
	"image/avif": {
	source: "iana",
	compressible: false,
	extensions: [
		"avif"
	]
},
	"image/bmp": {
	source: "iana",
	compressible: true,
	extensions: [
		"bmp"
	]
},
	"image/cgm": {
	source: "iana",
	extensions: [
		"cgm"
	]
},
	"image/dicom-rle": {
	source: "iana",
	extensions: [
		"drle"
	]
},
	"image/emf": {
	source: "iana",
	extensions: [
		"emf"
	]
},
	"image/fits": {
	source: "iana",
	extensions: [
		"fits"
	]
},
	"image/g3fax": {
	source: "iana",
	extensions: [
		"g3"
	]
},
	"image/gif": {
	source: "iana",
	compressible: false,
	extensions: [
		"gif"
	]
},
	"image/heic": {
	source: "iana",
	extensions: [
		"heic"
	]
},
	"image/heic-sequence": {
	source: "iana",
	extensions: [
		"heics"
	]
},
	"image/heif": {
	source: "iana",
	extensions: [
		"heif"
	]
},
	"image/heif-sequence": {
	source: "iana",
	extensions: [
		"heifs"
	]
},
	"image/hej2k": {
	source: "iana",
	extensions: [
		"hej2"
	]
},
	"image/hsj2": {
	source: "iana",
	extensions: [
		"hsj2"
	]
},
	"image/ief": {
	source: "iana",
	extensions: [
		"ief"
	]
},
	"image/jls": {
	source: "iana",
	extensions: [
		"jls"
	]
},
	"image/jp2": {
	source: "iana",
	compressible: false,
	extensions: [
		"jp2",
		"jpg2"
	]
},
	"image/jpeg": {
	source: "iana",
	compressible: false,
	extensions: [
		"jpeg",
		"jpg",
		"jpe"
	]
},
	"image/jph": {
	source: "iana",
	extensions: [
		"jph"
	]
},
	"image/jphc": {
	source: "iana",
	extensions: [
		"jhc"
	]
},
	"image/jpm": {
	source: "iana",
	compressible: false,
	extensions: [
		"jpm"
	]
},
	"image/jpx": {
	source: "iana",
	compressible: false,
	extensions: [
		"jpx",
		"jpf"
	]
},
	"image/jxr": {
	source: "iana",
	extensions: [
		"jxr"
	]
},
	"image/jxra": {
	source: "iana",
	extensions: [
		"jxra"
	]
},
	"image/jxrs": {
	source: "iana",
	extensions: [
		"jxrs"
	]
},
	"image/jxs": {
	source: "iana",
	extensions: [
		"jxs"
	]
},
	"image/jxsc": {
	source: "iana",
	extensions: [
		"jxsc"
	]
},
	"image/jxsi": {
	source: "iana",
	extensions: [
		"jxsi"
	]
},
	"image/jxss": {
	source: "iana",
	extensions: [
		"jxss"
	]
},
	"image/ktx": {
	source: "iana",
	extensions: [
		"ktx"
	]
},
	"image/ktx2": {
	source: "iana",
	extensions: [
		"ktx2"
	]
},
	"image/naplps": {
	source: "iana"
},
	"image/pjpeg": {
	compressible: false
},
	"image/png": {
	source: "iana",
	compressible: false,
	extensions: [
		"png"
	]
},
	"image/prs.btif": {
	source: "iana",
	extensions: [
		"btif"
	]
},
	"image/prs.pti": {
	source: "iana",
	extensions: [
		"pti"
	]
},
	"image/pwg-raster": {
	source: "iana"
},
	"image/sgi": {
	source: "apache",
	extensions: [
		"sgi"
	]
},
	"image/svg+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"svg",
		"svgz"
	]
},
	"image/t38": {
	source: "iana",
	extensions: [
		"t38"
	]
},
	"image/tiff": {
	source: "iana",
	compressible: false,
	extensions: [
		"tif",
		"tiff"
	]
},
	"image/tiff-fx": {
	source: "iana",
	extensions: [
		"tfx"
	]
},
	"image/vnd.adobe.photoshop": {
	source: "iana",
	compressible: true,
	extensions: [
		"psd"
	]
},
	"image/vnd.airzip.accelerator.azv": {
	source: "iana",
	extensions: [
		"azv"
	]
},
	"image/vnd.cns.inf2": {
	source: "iana"
},
	"image/vnd.dece.graphic": {
	source: "iana",
	extensions: [
		"uvi",
		"uvvi",
		"uvg",
		"uvvg"
	]
},
	"image/vnd.djvu": {
	source: "iana",
	extensions: [
		"djvu",
		"djv"
	]
},
	"image/vnd.dvb.subtitle": {
	source: "iana",
	extensions: [
		"sub"
	]
},
	"image/vnd.dwg": {
	source: "iana",
	extensions: [
		"dwg"
	]
},
	"image/vnd.dxf": {
	source: "iana",
	extensions: [
		"dxf"
	]
},
	"image/vnd.fastbidsheet": {
	source: "iana",
	extensions: [
		"fbs"
	]
},
	"image/vnd.fpx": {
	source: "iana",
	extensions: [
		"fpx"
	]
},
	"image/vnd.fst": {
	source: "iana",
	extensions: [
		"fst"
	]
},
	"image/vnd.fujixerox.edmics-mmr": {
	source: "iana",
	extensions: [
		"mmr"
	]
},
	"image/vnd.fujixerox.edmics-rlc": {
	source: "iana",
	extensions: [
		"rlc"
	]
},
	"image/vnd.globalgraphics.pgb": {
	source: "iana"
},
	"image/vnd.microsoft.icon": {
	source: "iana",
	compressible: true,
	extensions: [
		"ico"
	]
},
	"image/vnd.mix": {
	source: "iana"
},
	"image/vnd.mozilla.apng": {
	source: "iana"
},
	"image/vnd.ms-dds": {
	compressible: true,
	extensions: [
		"dds"
	]
},
	"image/vnd.ms-modi": {
	source: "iana",
	extensions: [
		"mdi"
	]
},
	"image/vnd.ms-photo": {
	source: "apache",
	extensions: [
		"wdp"
	]
},
	"image/vnd.net-fpx": {
	source: "iana",
	extensions: [
		"npx"
	]
},
	"image/vnd.pco.b16": {
	source: "iana",
	extensions: [
		"b16"
	]
},
	"image/vnd.radiance": {
	source: "iana"
},
	"image/vnd.sealed.png": {
	source: "iana"
},
	"image/vnd.sealedmedia.softseal.gif": {
	source: "iana"
},
	"image/vnd.sealedmedia.softseal.jpg": {
	source: "iana"
},
	"image/vnd.svf": {
	source: "iana"
},
	"image/vnd.tencent.tap": {
	source: "iana",
	extensions: [
		"tap"
	]
},
	"image/vnd.valve.source.texture": {
	source: "iana",
	extensions: [
		"vtf"
	]
},
	"image/vnd.wap.wbmp": {
	source: "iana",
	extensions: [
		"wbmp"
	]
},
	"image/vnd.xiff": {
	source: "iana",
	extensions: [
		"xif"
	]
},
	"image/vnd.zbrush.pcx": {
	source: "iana",
	extensions: [
		"pcx"
	]
},
	"image/webp": {
	source: "apache",
	extensions: [
		"webp"
	]
},
	"image/wmf": {
	source: "iana",
	extensions: [
		"wmf"
	]
},
	"image/x-3ds": {
	source: "apache",
	extensions: [
		"3ds"
	]
},
	"image/x-cmu-raster": {
	source: "apache",
	extensions: [
		"ras"
	]
},
	"image/x-cmx": {
	source: "apache",
	extensions: [
		"cmx"
	]
},
	"image/x-freehand": {
	source: "apache",
	extensions: [
		"fh",
		"fhc",
		"fh4",
		"fh5",
		"fh7"
	]
},
	"image/x-icon": {
	source: "apache",
	compressible: true,
	extensions: [
		"ico"
	]
},
	"image/x-jng": {
	source: "nginx",
	extensions: [
		"jng"
	]
},
	"image/x-mrsid-image": {
	source: "apache",
	extensions: [
		"sid"
	]
},
	"image/x-ms-bmp": {
	source: "nginx",
	compressible: true,
	extensions: [
		"bmp"
	]
},
	"image/x-pcx": {
	source: "apache",
	extensions: [
		"pcx"
	]
},
	"image/x-pict": {
	source: "apache",
	extensions: [
		"pic",
		"pct"
	]
},
	"image/x-portable-anymap": {
	source: "apache",
	extensions: [
		"pnm"
	]
},
	"image/x-portable-bitmap": {
	source: "apache",
	extensions: [
		"pbm"
	]
},
	"image/x-portable-graymap": {
	source: "apache",
	extensions: [
		"pgm"
	]
},
	"image/x-portable-pixmap": {
	source: "apache",
	extensions: [
		"ppm"
	]
},
	"image/x-rgb": {
	source: "apache",
	extensions: [
		"rgb"
	]
},
	"image/x-tga": {
	source: "apache",
	extensions: [
		"tga"
	]
},
	"image/x-xbitmap": {
	source: "apache",
	extensions: [
		"xbm"
	]
},
	"image/x-xcf": {
	compressible: false
},
	"image/x-xpixmap": {
	source: "apache",
	extensions: [
		"xpm"
	]
},
	"image/x-xwindowdump": {
	source: "apache",
	extensions: [
		"xwd"
	]
},
	"message/cpim": {
	source: "iana"
},
	"message/delivery-status": {
	source: "iana"
},
	"message/disposition-notification": {
	source: "iana",
	extensions: [
		"disposition-notification"
	]
},
	"message/external-body": {
	source: "iana"
},
	"message/feedback-report": {
	source: "iana"
},
	"message/global": {
	source: "iana",
	extensions: [
		"u8msg"
	]
},
	"message/global-delivery-status": {
	source: "iana",
	extensions: [
		"u8dsn"
	]
},
	"message/global-disposition-notification": {
	source: "iana",
	extensions: [
		"u8mdn"
	]
},
	"message/global-headers": {
	source: "iana",
	extensions: [
		"u8hdr"
	]
},
	"message/http": {
	source: "iana",
	compressible: false
},
	"message/imdn+xml": {
	source: "iana",
	compressible: true
},
	"message/news": {
	source: "iana"
},
	"message/partial": {
	source: "iana",
	compressible: false
},
	"message/rfc822": {
	source: "iana",
	compressible: true,
	extensions: [
		"eml",
		"mime"
	]
},
	"message/s-http": {
	source: "iana"
},
	"message/sip": {
	source: "iana"
},
	"message/sipfrag": {
	source: "iana"
},
	"message/tracking-status": {
	source: "iana"
},
	"message/vnd.si.simp": {
	source: "iana"
},
	"message/vnd.wfa.wsc": {
	source: "iana",
	extensions: [
		"wsc"
	]
},
	"model/3mf": {
	source: "iana",
	extensions: [
		"3mf"
	]
},
	"model/e57": {
	source: "iana"
},
	"model/gltf+json": {
	source: "iana",
	compressible: true,
	extensions: [
		"gltf"
	]
},
	"model/gltf-binary": {
	source: "iana",
	compressible: true,
	extensions: [
		"glb"
	]
},
	"model/iges": {
	source: "iana",
	compressible: false,
	extensions: [
		"igs",
		"iges"
	]
},
	"model/mesh": {
	source: "iana",
	compressible: false,
	extensions: [
		"msh",
		"mesh",
		"silo"
	]
},
	"model/mtl": {
	source: "iana",
	extensions: [
		"mtl"
	]
},
	"model/obj": {
	source: "iana",
	extensions: [
		"obj"
	]
},
	"model/step": {
	source: "iana"
},
	"model/step+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"stpx"
	]
},
	"model/step+zip": {
	source: "iana",
	compressible: false,
	extensions: [
		"stpz"
	]
},
	"model/step-xml+zip": {
	source: "iana",
	compressible: false,
	extensions: [
		"stpxz"
	]
},
	"model/stl": {
	source: "iana",
	extensions: [
		"stl"
	]
},
	"model/vnd.collada+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"dae"
	]
},
	"model/vnd.dwf": {
	source: "iana",
	extensions: [
		"dwf"
	]
},
	"model/vnd.flatland.3dml": {
	source: "iana"
},
	"model/vnd.gdl": {
	source: "iana",
	extensions: [
		"gdl"
	]
},
	"model/vnd.gs-gdl": {
	source: "apache"
},
	"model/vnd.gs.gdl": {
	source: "iana"
},
	"model/vnd.gtw": {
	source: "iana",
	extensions: [
		"gtw"
	]
},
	"model/vnd.moml+xml": {
	source: "iana",
	compressible: true
},
	"model/vnd.mts": {
	source: "iana",
	extensions: [
		"mts"
	]
},
	"model/vnd.opengex": {
	source: "iana",
	extensions: [
		"ogex"
	]
},
	"model/vnd.parasolid.transmit.binary": {
	source: "iana",
	extensions: [
		"x_b"
	]
},
	"model/vnd.parasolid.transmit.text": {
	source: "iana",
	extensions: [
		"x_t"
	]
},
	"model/vnd.pytha.pyox": {
	source: "iana"
},
	"model/vnd.rosette.annotated-data-model": {
	source: "iana"
},
	"model/vnd.sap.vds": {
	source: "iana",
	extensions: [
		"vds"
	]
},
	"model/vnd.usdz+zip": {
	source: "iana",
	compressible: false,
	extensions: [
		"usdz"
	]
},
	"model/vnd.valve.source.compiled-map": {
	source: "iana",
	extensions: [
		"bsp"
	]
},
	"model/vnd.vtu": {
	source: "iana",
	extensions: [
		"vtu"
	]
},
	"model/vrml": {
	source: "iana",
	compressible: false,
	extensions: [
		"wrl",
		"vrml"
	]
},
	"model/x3d+binary": {
	source: "apache",
	compressible: false,
	extensions: [
		"x3db",
		"x3dbz"
	]
},
	"model/x3d+fastinfoset": {
	source: "iana",
	extensions: [
		"x3db"
	]
},
	"model/x3d+vrml": {
	source: "apache",
	compressible: false,
	extensions: [
		"x3dv",
		"x3dvz"
	]
},
	"model/x3d+xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"x3d",
		"x3dz"
	]
},
	"model/x3d-vrml": {
	source: "iana",
	extensions: [
		"x3dv"
	]
},
	"multipart/alternative": {
	source: "iana",
	compressible: false
},
	"multipart/appledouble": {
	source: "iana"
},
	"multipart/byteranges": {
	source: "iana"
},
	"multipart/digest": {
	source: "iana"
},
	"multipart/encrypted": {
	source: "iana",
	compressible: false
},
	"multipart/form-data": {
	source: "iana",
	compressible: false
},
	"multipart/header-set": {
	source: "iana"
},
	"multipart/mixed": {
	source: "iana"
},
	"multipart/multilingual": {
	source: "iana"
},
	"multipart/parallel": {
	source: "iana"
},
	"multipart/related": {
	source: "iana",
	compressible: false
},
	"multipart/report": {
	source: "iana"
},
	"multipart/signed": {
	source: "iana",
	compressible: false
},
	"multipart/vnd.bint.med-plus": {
	source: "iana"
},
	"multipart/voice-message": {
	source: "iana"
},
	"multipart/x-mixed-replace": {
	source: "iana"
},
	"text/1d-interleaved-parityfec": {
	source: "iana"
},
	"text/cache-manifest": {
	source: "iana",
	compressible: true,
	extensions: [
		"appcache",
		"manifest"
	]
},
	"text/calendar": {
	source: "iana",
	extensions: [
		"ics",
		"ifb"
	]
},
	"text/calender": {
	compressible: true
},
	"text/cmd": {
	compressible: true
},
	"text/coffeescript": {
	extensions: [
		"coffee",
		"litcoffee"
	]
},
	"text/cql": {
	source: "iana"
},
	"text/cql-expression": {
	source: "iana"
},
	"text/cql-identifier": {
	source: "iana"
},
	"text/css": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"css"
	]
},
	"text/csv": {
	source: "iana",
	compressible: true,
	extensions: [
		"csv"
	]
},
	"text/csv-schema": {
	source: "iana"
},
	"text/directory": {
	source: "iana"
},
	"text/dns": {
	source: "iana"
},
	"text/ecmascript": {
	source: "iana"
},
	"text/encaprtp": {
	source: "iana"
},
	"text/enriched": {
	source: "iana"
},
	"text/fhirpath": {
	source: "iana"
},
	"text/flexfec": {
	source: "iana"
},
	"text/fwdred": {
	source: "iana"
},
	"text/gff3": {
	source: "iana"
},
	"text/grammar-ref-list": {
	source: "iana"
},
	"text/html": {
	source: "iana",
	compressible: true,
	extensions: [
		"html",
		"htm",
		"shtml"
	]
},
	"text/jade": {
	extensions: [
		"jade"
	]
},
	"text/javascript": {
	source: "iana",
	compressible: true
},
	"text/jcr-cnd": {
	source: "iana"
},
	"text/jsx": {
	compressible: true,
	extensions: [
		"jsx"
	]
},
	"text/less": {
	compressible: true,
	extensions: [
		"less"
	]
},
	"text/markdown": {
	source: "iana",
	compressible: true,
	extensions: [
		"markdown",
		"md"
	]
},
	"text/mathml": {
	source: "nginx",
	extensions: [
		"mml"
	]
},
	"text/mdx": {
	compressible: true,
	extensions: [
		"mdx"
	]
},
	"text/mizar": {
	source: "iana"
},
	"text/n3": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"n3"
	]
},
	"text/parameters": {
	source: "iana",
	charset: "UTF-8"
},
	"text/parityfec": {
	source: "iana"
},
	"text/plain": {
	source: "iana",
	compressible: true,
	extensions: [
		"txt",
		"text",
		"conf",
		"def",
		"list",
		"log",
		"in",
		"ini"
	]
},
	"text/provenance-notation": {
	source: "iana",
	charset: "UTF-8"
},
	"text/prs.fallenstein.rst": {
	source: "iana"
},
	"text/prs.lines.tag": {
	source: "iana",
	extensions: [
		"dsc"
	]
},
	"text/prs.prop.logic": {
	source: "iana"
},
	"text/raptorfec": {
	source: "iana"
},
	"text/red": {
	source: "iana"
},
	"text/rfc822-headers": {
	source: "iana"
},
	"text/richtext": {
	source: "iana",
	compressible: true,
	extensions: [
		"rtx"
	]
},
	"text/rtf": {
	source: "iana",
	compressible: true,
	extensions: [
		"rtf"
	]
},
	"text/rtp-enc-aescm128": {
	source: "iana"
},
	"text/rtploopback": {
	source: "iana"
},
	"text/rtx": {
	source: "iana"
},
	"text/sgml": {
	source: "iana",
	extensions: [
		"sgml",
		"sgm"
	]
},
	"text/shaclc": {
	source: "iana"
},
	"text/shex": {
	source: "iana",
	extensions: [
		"shex"
	]
},
	"text/slim": {
	extensions: [
		"slim",
		"slm"
	]
},
	"text/spdx": {
	source: "iana",
	extensions: [
		"spdx"
	]
},
	"text/strings": {
	source: "iana"
},
	"text/stylus": {
	extensions: [
		"stylus",
		"styl"
	]
},
	"text/t140": {
	source: "iana"
},
	"text/tab-separated-values": {
	source: "iana",
	compressible: true,
	extensions: [
		"tsv"
	]
},
	"text/troff": {
	source: "iana",
	extensions: [
		"t",
		"tr",
		"roff",
		"man",
		"me",
		"ms"
	]
},
	"text/turtle": {
	source: "iana",
	charset: "UTF-8",
	extensions: [
		"ttl"
	]
},
	"text/ulpfec": {
	source: "iana"
},
	"text/uri-list": {
	source: "iana",
	compressible: true,
	extensions: [
		"uri",
		"uris",
		"urls"
	]
},
	"text/vcard": {
	source: "iana",
	compressible: true,
	extensions: [
		"vcard"
	]
},
	"text/vnd.a": {
	source: "iana"
},
	"text/vnd.abc": {
	source: "iana"
},
	"text/vnd.ascii-art": {
	source: "iana"
},
	"text/vnd.curl": {
	source: "iana",
	extensions: [
		"curl"
	]
},
	"text/vnd.curl.dcurl": {
	source: "apache",
	extensions: [
		"dcurl"
	]
},
	"text/vnd.curl.mcurl": {
	source: "apache",
	extensions: [
		"mcurl"
	]
},
	"text/vnd.curl.scurl": {
	source: "apache",
	extensions: [
		"scurl"
	]
},
	"text/vnd.debian.copyright": {
	source: "iana",
	charset: "UTF-8"
},
	"text/vnd.dmclientscript": {
	source: "iana"
},
	"text/vnd.dvb.subtitle": {
	source: "iana",
	extensions: [
		"sub"
	]
},
	"text/vnd.esmertec.theme-descriptor": {
	source: "iana",
	charset: "UTF-8"
},
	"text/vnd.familysearch.gedcom": {
	source: "iana",
	extensions: [
		"ged"
	]
},
	"text/vnd.ficlab.flt": {
	source: "iana"
},
	"text/vnd.fly": {
	source: "iana",
	extensions: [
		"fly"
	]
},
	"text/vnd.fmi.flexstor": {
	source: "iana",
	extensions: [
		"flx"
	]
},
	"text/vnd.gml": {
	source: "iana"
},
	"text/vnd.graphviz": {
	source: "iana",
	extensions: [
		"gv"
	]
},
	"text/vnd.hans": {
	source: "iana"
},
	"text/vnd.hgl": {
	source: "iana"
},
	"text/vnd.in3d.3dml": {
	source: "iana",
	extensions: [
		"3dml"
	]
},
	"text/vnd.in3d.spot": {
	source: "iana",
	extensions: [
		"spot"
	]
},
	"text/vnd.iptc.newsml": {
	source: "iana"
},
	"text/vnd.iptc.nitf": {
	source: "iana"
},
	"text/vnd.latex-z": {
	source: "iana"
},
	"text/vnd.motorola.reflex": {
	source: "iana"
},
	"text/vnd.ms-mediapackage": {
	source: "iana"
},
	"text/vnd.net2phone.commcenter.command": {
	source: "iana"
},
	"text/vnd.radisys.msml-basic-layout": {
	source: "iana"
},
	"text/vnd.senx.warpscript": {
	source: "iana"
},
	"text/vnd.si.uricatalogue": {
	source: "iana"
},
	"text/vnd.sosi": {
	source: "iana"
},
	"text/vnd.sun.j2me.app-descriptor": {
	source: "iana",
	charset: "UTF-8",
	extensions: [
		"jad"
	]
},
	"text/vnd.trolltech.linguist": {
	source: "iana",
	charset: "UTF-8"
},
	"text/vnd.wap.si": {
	source: "iana"
},
	"text/vnd.wap.sl": {
	source: "iana"
},
	"text/vnd.wap.wml": {
	source: "iana",
	extensions: [
		"wml"
	]
},
	"text/vnd.wap.wmlscript": {
	source: "iana",
	extensions: [
		"wmls"
	]
},
	"text/vtt": {
	source: "iana",
	charset: "UTF-8",
	compressible: true,
	extensions: [
		"vtt"
	]
},
	"text/x-asm": {
	source: "apache",
	extensions: [
		"s",
		"asm"
	]
},
	"text/x-c": {
	source: "apache",
	extensions: [
		"c",
		"cc",
		"cxx",
		"cpp",
		"h",
		"hh",
		"dic"
	]
},
	"text/x-component": {
	source: "nginx",
	extensions: [
		"htc"
	]
},
	"text/x-fortran": {
	source: "apache",
	extensions: [
		"f",
		"for",
		"f77",
		"f90"
	]
},
	"text/x-gwt-rpc": {
	compressible: true
},
	"text/x-handlebars-template": {
	extensions: [
		"hbs"
	]
},
	"text/x-java-source": {
	source: "apache",
	extensions: [
		"java"
	]
},
	"text/x-jquery-tmpl": {
	compressible: true
},
	"text/x-lua": {
	extensions: [
		"lua"
	]
},
	"text/x-markdown": {
	compressible: true,
	extensions: [
		"mkd"
	]
},
	"text/x-nfo": {
	source: "apache",
	extensions: [
		"nfo"
	]
},
	"text/x-opml": {
	source: "apache",
	extensions: [
		"opml"
	]
},
	"text/x-org": {
	compressible: true,
	extensions: [
		"org"
	]
},
	"text/x-pascal": {
	source: "apache",
	extensions: [
		"p",
		"pas"
	]
},
	"text/x-processing": {
	compressible: true,
	extensions: [
		"pde"
	]
},
	"text/x-sass": {
	extensions: [
		"sass"
	]
},
	"text/x-scss": {
	extensions: [
		"scss"
	]
},
	"text/x-setext": {
	source: "apache",
	extensions: [
		"etx"
	]
},
	"text/x-sfv": {
	source: "apache",
	extensions: [
		"sfv"
	]
},
	"text/x-suse-ymp": {
	compressible: true,
	extensions: [
		"ymp"
	]
},
	"text/x-uuencode": {
	source: "apache",
	extensions: [
		"uu"
	]
},
	"text/x-vcalendar": {
	source: "apache",
	extensions: [
		"vcs"
	]
},
	"text/x-vcard": {
	source: "apache",
	extensions: [
		"vcf"
	]
},
	"text/xml": {
	source: "iana",
	compressible: true,
	extensions: [
		"xml"
	]
},
	"text/xml-external-parsed-entity": {
	source: "iana"
},
	"text/yaml": {
	compressible: true,
	extensions: [
		"yaml",
		"yml"
	]
},
	"video/1d-interleaved-parityfec": {
	source: "iana"
},
	"video/3gpp": {
	source: "iana",
	extensions: [
		"3gp",
		"3gpp"
	]
},
	"video/3gpp-tt": {
	source: "iana"
},
	"video/3gpp2": {
	source: "iana",
	extensions: [
		"3g2"
	]
},
	"video/av1": {
	source: "iana"
},
	"video/bmpeg": {
	source: "iana"
},
	"video/bt656": {
	source: "iana"
},
	"video/celb": {
	source: "iana"
},
	"video/dv": {
	source: "iana"
},
	"video/encaprtp": {
	source: "iana"
},
	"video/ffv1": {
	source: "iana"
},
	"video/flexfec": {
	source: "iana"
},
	"video/h261": {
	source: "iana",
	extensions: [
		"h261"
	]
},
	"video/h263": {
	source: "iana",
	extensions: [
		"h263"
	]
},
	"video/h263-1998": {
	source: "iana"
},
	"video/h263-2000": {
	source: "iana"
},
	"video/h264": {
	source: "iana",
	extensions: [
		"h264"
	]
},
	"video/h264-rcdo": {
	source: "iana"
},
	"video/h264-svc": {
	source: "iana"
},
	"video/h265": {
	source: "iana"
},
	"video/iso.segment": {
	source: "iana",
	extensions: [
		"m4s"
	]
},
	"video/jpeg": {
	source: "iana",
	extensions: [
		"jpgv"
	]
},
	"video/jpeg2000": {
	source: "iana"
},
	"video/jpm": {
	source: "apache",
	extensions: [
		"jpm",
		"jpgm"
	]
},
	"video/jxsv": {
	source: "iana"
},
	"video/mj2": {
	source: "iana",
	extensions: [
		"mj2",
		"mjp2"
	]
},
	"video/mp1s": {
	source: "iana"
},
	"video/mp2p": {
	source: "iana"
},
	"video/mp2t": {
	source: "iana",
	extensions: [
		"ts"
	]
},
	"video/mp4": {
	source: "iana",
	compressible: false,
	extensions: [
		"mp4",
		"mp4v",
		"mpg4"
	]
},
	"video/mp4v-es": {
	source: "iana"
},
	"video/mpeg": {
	source: "iana",
	compressible: false,
	extensions: [
		"mpeg",
		"mpg",
		"mpe",
		"m1v",
		"m2v"
	]
},
	"video/mpeg4-generic": {
	source: "iana"
},
	"video/mpv": {
	source: "iana"
},
	"video/nv": {
	source: "iana"
},
	"video/ogg": {
	source: "iana",
	compressible: false,
	extensions: [
		"ogv"
	]
},
	"video/parityfec": {
	source: "iana"
},
	"video/pointer": {
	source: "iana"
},
	"video/quicktime": {
	source: "iana",
	compressible: false,
	extensions: [
		"qt",
		"mov"
	]
},
	"video/raptorfec": {
	source: "iana"
},
	"video/raw": {
	source: "iana"
},
	"video/rtp-enc-aescm128": {
	source: "iana"
},
	"video/rtploopback": {
	source: "iana"
},
	"video/rtx": {
	source: "iana"
},
	"video/scip": {
	source: "iana"
},
	"video/smpte291": {
	source: "iana"
},
	"video/smpte292m": {
	source: "iana"
},
	"video/ulpfec": {
	source: "iana"
},
	"video/vc1": {
	source: "iana"
},
	"video/vc2": {
	source: "iana"
},
	"video/vnd.cctv": {
	source: "iana"
},
	"video/vnd.dece.hd": {
	source: "iana",
	extensions: [
		"uvh",
		"uvvh"
	]
},
	"video/vnd.dece.mobile": {
	source: "iana",
	extensions: [
		"uvm",
		"uvvm"
	]
},
	"video/vnd.dece.mp4": {
	source: "iana"
},
	"video/vnd.dece.pd": {
	source: "iana",
	extensions: [
		"uvp",
		"uvvp"
	]
},
	"video/vnd.dece.sd": {
	source: "iana",
	extensions: [
		"uvs",
		"uvvs"
	]
},
	"video/vnd.dece.video": {
	source: "iana",
	extensions: [
		"uvv",
		"uvvv"
	]
},
	"video/vnd.directv.mpeg": {
	source: "iana"
},
	"video/vnd.directv.mpeg-tts": {
	source: "iana"
},
	"video/vnd.dlna.mpeg-tts": {
	source: "iana"
},
	"video/vnd.dvb.file": {
	source: "iana",
	extensions: [
		"dvb"
	]
},
	"video/vnd.fvt": {
	source: "iana",
	extensions: [
		"fvt"
	]
},
	"video/vnd.hns.video": {
	source: "iana"
},
	"video/vnd.iptvforum.1dparityfec-1010": {
	source: "iana"
},
	"video/vnd.iptvforum.1dparityfec-2005": {
	source: "iana"
},
	"video/vnd.iptvforum.2dparityfec-1010": {
	source: "iana"
},
	"video/vnd.iptvforum.2dparityfec-2005": {
	source: "iana"
},
	"video/vnd.iptvforum.ttsavc": {
	source: "iana"
},
	"video/vnd.iptvforum.ttsmpeg2": {
	source: "iana"
},
	"video/vnd.motorola.video": {
	source: "iana"
},
	"video/vnd.motorola.videop": {
	source: "iana"
},
	"video/vnd.mpegurl": {
	source: "iana",
	extensions: [
		"mxu",
		"m4u"
	]
},
	"video/vnd.ms-playready.media.pyv": {
	source: "iana",
	extensions: [
		"pyv"
	]
},
	"video/vnd.nokia.interleaved-multimedia": {
	source: "iana"
},
	"video/vnd.nokia.mp4vr": {
	source: "iana"
},
	"video/vnd.nokia.videovoip": {
	source: "iana"
},
	"video/vnd.objectvideo": {
	source: "iana"
},
	"video/vnd.radgamettools.bink": {
	source: "iana"
},
	"video/vnd.radgamettools.smacker": {
	source: "iana"
},
	"video/vnd.sealed.mpeg1": {
	source: "iana"
},
	"video/vnd.sealed.mpeg4": {
	source: "iana"
},
	"video/vnd.sealed.swf": {
	source: "iana"
},
	"video/vnd.sealedmedia.softseal.mov": {
	source: "iana"
},
	"video/vnd.uvvu.mp4": {
	source: "iana",
	extensions: [
		"uvu",
		"uvvu"
	]
},
	"video/vnd.vivo": {
	source: "iana",
	extensions: [
		"viv"
	]
},
	"video/vnd.youtube.yt": {
	source: "iana"
},
	"video/vp8": {
	source: "iana"
},
	"video/vp9": {
	source: "iana"
},
	"video/webm": {
	source: "apache",
	compressible: false,
	extensions: [
		"webm"
	]
},
	"video/x-f4v": {
	source: "apache",
	extensions: [
		"f4v"
	]
},
	"video/x-fli": {
	source: "apache",
	extensions: [
		"fli"
	]
},
	"video/x-flv": {
	source: "apache",
	compressible: false,
	extensions: [
		"flv"
	]
},
	"video/x-m4v": {
	source: "apache",
	extensions: [
		"m4v"
	]
},
	"video/x-matroska": {
	source: "apache",
	compressible: false,
	extensions: [
		"mkv",
		"mk3d",
		"mks"
	]
},
	"video/x-mng": {
	source: "apache",
	extensions: [
		"mng"
	]
},
	"video/x-ms-asf": {
	source: "apache",
	extensions: [
		"asf",
		"asx"
	]
},
	"video/x-ms-vob": {
	source: "apache",
	extensions: [
		"vob"
	]
},
	"video/x-ms-wm": {
	source: "apache",
	extensions: [
		"wm"
	]
},
	"video/x-ms-wmv": {
	source: "apache",
	compressible: false,
	extensions: [
		"wmv"
	]
},
	"video/x-ms-wmx": {
	source: "apache",
	extensions: [
		"wmx"
	]
},
	"video/x-ms-wvx": {
	source: "apache",
	extensions: [
		"wvx"
	]
},
	"video/x-msvideo": {
	source: "apache",
	extensions: [
		"avi"
	]
},
	"video/x-sgi-movie": {
	source: "apache",
	extensions: [
		"movie"
	]
},
	"video/x-smv": {
	source: "apache",
	extensions: [
		"smv"
	]
},
	"x-conference/x-cooltalk": {
	source: "apache",
	extensions: [
		"ice"
	]
},
	"x-shader/x-fragment": {
	compressible: true
},
	"x-shader/x-vertex": {
	compressible: true
}
};

/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 */

var mimeDb = require$$0$1;

/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

(function (exports) {

/**
 * Module dependencies.
 * @private
 */

var db = mimeDb;
var extname = require$$2$4.extname;

/**
 * Module variables.
 * @private
 */

var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var TEXT_TYPE_REGEXP = /^text\//i;

/**
 * Module exports.
 * @public
 */

exports.charset = charset;
exports.charsets = { lookup: charset };
exports.contentType = contentType;
exports.extension = extension;
exports.extensions = Object.create(null);
exports.lookup = lookup;
exports.types = Object.create(null);

// Populate the extensions/types maps
populateMaps(exports.extensions, exports.types);

/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function charset (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type);
  var mime = match && db[match[1].toLowerCase()];

  if (mime && mime.charset) {
    return mime.charset
  }

  // default text/* to utf-8
  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
    return 'UTF-8'
  }

  return false
}

/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */

function contentType (str) {
  // TODO: should this even be in this module?
  if (!str || typeof str !== 'string') {
    return false
  }

  var mime = str.indexOf('/') === -1
    ? exports.lookup(str)
    : str;

  if (!mime) {
    return false
  }

  // TODO: use content-type or other module
  if (mime.indexOf('charset') === -1) {
    var charset = exports.charset(mime);
    if (charset) mime += '; charset=' + charset.toLowerCase();
  }

  return mime
}

/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function extension (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type);

  // get extensions
  var exts = match && exports.extensions[match[1].toLowerCase()];

  if (!exts || !exts.length) {
    return false
  }

  return exts[0]
}

/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */

function lookup (path) {
  if (!path || typeof path !== 'string') {
    return false
  }

  // get the extension ("ext" or ".ext" or full path)
  var extension = extname('x.' + path)
    .toLowerCase()
    .substr(1);

  if (!extension) {
    return false
  }

  return exports.types[extension] || false
}

/**
 * Populate the extensions and types maps.
 * @private
 */

function populateMaps (extensions, types) {
  // source preference (least -> most)
  var preference = ['nginx', 'apache', undefined, 'iana'];

  Object.keys(db).forEach(function forEachMimeType (type) {
    var mime = db[type];
    var exts = mime.extensions;

    if (!exts || !exts.length) {
      return
    }

    // mime -> extensions
    extensions[type] = exts;

    // extension -> mime
    for (var i = 0; i < exts.length; i++) {
      var extension = exts[i];

      if (types[extension]) {
        var from = preference.indexOf(db[types[extension]].source);
        var to = preference.indexOf(mime.source);

        if (types[extension] !== 'application/octet-stream' &&
          (from > to || (from === to && types[extension].substr(0, 12) === 'application/'))) {
          // skip the remapping
          continue
        }
      }

      // set the extension -> mime
      types[extension] = type;
    }
  });
}
}(mimeTypes));

var defer_1 = defer$1;

/**
 * Runs provided function on next iteration of the event loop
 *
 * @param {function} fn - function to run
 */
function defer$1(fn)
{
  var nextTick = typeof setImmediate == 'function'
    ? setImmediate
    : (
      typeof process == 'object' && typeof process.nextTick == 'function'
      ? process.nextTick
      : null
    );

  if (nextTick)
  {
    nextTick(fn);
  }
  else
  {
    setTimeout(fn, 0);
  }
}

var defer = defer_1;

// API
var async_1 = async$2;

/**
 * Runs provided callback asynchronously
 * even if callback itself is not
 *
 * @param   {function} callback - callback to invoke
 * @returns {function} - augmented callback
 */
function async$2(callback)
{
  var isAsync = false;

  // check if async happened
  defer(function() { isAsync = true; });

  return function async_callback(err, result)
  {
    if (isAsync)
    {
      callback(err, result);
    }
    else
    {
      defer(function nextTick_callback()
      {
        callback(err, result);
      });
    }
  };
}

// API
var abort_1 = abort$2;

/**
 * Aborts leftover active jobs
 *
 * @param {object} state - current state object
 */
function abort$2(state)
{
  Object.keys(state.jobs).forEach(clean$3.bind(state));

  // reset leftover jobs
  state.jobs = {};
}

/**
 * Cleans up leftover job by invoking abort function for the provided job id
 *
 * @this  state
 * @param {string|number} key - job id to abort
 */
function clean$3(key)
{
  if (typeof this.jobs[key] == 'function')
  {
    this.jobs[key]();
  }
}

var async$1 = async_1
  , abort$1 = abort_1
  ;

// API
var iterate_1 = iterate$2;

/**
 * Iterates over each job object
 *
 * @param {array|object} list - array or object (named list) to iterate over
 * @param {function} iterator - iterator to run
 * @param {object} state - current job status
 * @param {function} callback - invoked when all elements processed
 */
function iterate$2(list, iterator, state, callback)
{
  // store current index
  var key = state['keyedList'] ? state['keyedList'][state.index] : state.index;

  state.jobs[key] = runJob(iterator, key, list[key], function(error, output)
  {
    // don't repeat yourself
    // skip secondary callbacks
    if (!(key in state.jobs))
    {
      return;
    }

    // clean up jobs
    delete state.jobs[key];

    if (error)
    {
      // don't process rest of the results
      // stop still active jobs
      // and reset the list
      abort$1(state);
    }
    else
    {
      state.results[key] = output;
    }

    // return salvaged results
    callback(error, state.results);
  });
}

/**
 * Runs iterator over provided job element
 *
 * @param   {function} iterator - iterator to invoke
 * @param   {string|number} key - key/index of the element in the list of jobs
 * @param   {mixed} item - job description
 * @param   {function} callback - invoked after iterator is done with the job
 * @returns {function|mixed} - job abort function or something else
 */
function runJob(iterator, key, item, callback)
{
  var aborter;

  // allow shortcut if iterator expects only two arguments
  if (iterator.length == 2)
  {
    aborter = iterator(item, async$1(callback));
  }
  // otherwise go with full three arguments
  else
  {
    aborter = iterator(item, key, async$1(callback));
  }

  return aborter;
}

// API
var state_1 = state;

/**
 * Creates initial state object
 * for iteration over list
 *
 * @param   {array|object} list - list to iterate over
 * @param   {function|null} sortMethod - function to use for keys sort,
 *                                     or `null` to keep them as is
 * @returns {object} - initial state object
 */
function state(list, sortMethod)
{
  var isNamedList = !Array.isArray(list)
    , initState =
    {
      index    : 0,
      keyedList: isNamedList || sortMethod ? Object.keys(list) : null,
      jobs     : {},
      results  : isNamedList ? {} : [],
      size     : isNamedList ? Object.keys(list).length : list.length
    }
    ;

  if (sortMethod)
  {
    // sort array keys based on it's values
    // sort object's keys just on own merit
    initState.keyedList.sort(isNamedList ? sortMethod : function(a, b)
    {
      return sortMethod(list[a], list[b]);
    });
  }

  return initState;
}

var abort = abort_1
  , async = async_1
  ;

// API
var terminator_1 = terminator$2;

/**
 * Terminates jobs in the attached state context
 *
 * @this  AsyncKitState#
 * @param {function} callback - final callback to invoke after termination
 */
function terminator$2(callback)
{
  if (!Object.keys(this.jobs).length)
  {
    return;
  }

  // fast forward iteration index
  this.index = this.size;

  // abort jobs
  abort(this);

  // send back results we have so far
  async(callback)(null, this.results);
}

var iterate$1    = iterate_1
  , initState$1  = state_1
  , terminator$1 = terminator_1
  ;

// Public API
var parallel_1 = parallel;

/**
 * Runs iterator over provided array elements in parallel
 *
 * @param   {array|object} list - array or object (named list) to iterate over
 * @param   {function} iterator - iterator to run
 * @param   {function} callback - invoked when all elements processed
 * @returns {function} - jobs terminator
 */
function parallel(list, iterator, callback)
{
  var state = initState$1(list);

  while (state.index < (state['keyedList'] || list).length)
  {
    iterate$1(list, iterator, state, function(error, result)
    {
      if (error)
      {
        callback(error, result);
        return;
      }

      // looks like it's the last one
      if (Object.keys(state.jobs).length === 0)
      {
        callback(null, state.results);
        return;
      }
    });

    state.index++;
  }

  return terminator$1.bind(state, callback);
}

var serialOrdered$2 = {exports: {}};

var iterate    = iterate_1
  , initState  = state_1
  , terminator = terminator_1
  ;

// Public API
serialOrdered$2.exports = serialOrdered$1;
// sorting helpers
serialOrdered$2.exports.ascending  = ascending$2;
serialOrdered$2.exports.descending = descending;

/**
 * Runs iterator over provided sorted array elements in series
 *
 * @param   {array|object} list - array or object (named list) to iterate over
 * @param   {function} iterator - iterator to run
 * @param   {function} sortMethod - custom sort function
 * @param   {function} callback - invoked when all elements processed
 * @returns {function} - jobs terminator
 */
function serialOrdered$1(list, iterator, sortMethod, callback)
{
  var state = initState(list, sortMethod);

  iterate(list, iterator, state, function iteratorHandler(error, result)
  {
    if (error)
    {
      callback(error, result);
      return;
    }

    state.index++;

    // are we there yet?
    if (state.index < (state['keyedList'] || list).length)
    {
      iterate(list, iterator, state, iteratorHandler);
      return;
    }

    // done here
    callback(null, state.results);
  });

  return terminator.bind(state, callback);
}

/*
 * -- Sort methods
 */

/**
 * sort helper to sort array elements in ascending order
 *
 * @param   {mixed} a - an item to compare
 * @param   {mixed} b - an item to compare
 * @returns {number} - comparison result
 */
function ascending$2(a, b)
{
  return a < b ? -1 : a > b ? 1 : 0;
}

/**
 * sort helper to sort array elements in descending order
 *
 * @param   {mixed} a - an item to compare
 * @param   {mixed} b - an item to compare
 * @returns {number} - comparison result
 */
function descending(a, b)
{
  return -1 * ascending$2(a, b);
}

var serialOrdered = serialOrdered$2.exports;

// Public API
var serial_1 = serial;

/**
 * Runs iterator over provided array elements in series
 *
 * @param   {array|object} list - array or object (named list) to iterate over
 * @param   {function} iterator - iterator to run
 * @param   {function} callback - invoked when all elements processed
 * @returns {function} - jobs terminator
 */
function serial(list, iterator, callback)
{
  return serialOrdered(list, iterator, null, callback);
}

var asynckit$1 =
{
  parallel      : parallel_1,
  serial        : serial_1,
  serialOrdered : serialOrdered$2.exports
};

// populates missing values
var populate$1 = function(dst, src) {

  Object.keys(src).forEach(function(prop)
  {
    dst[prop] = dst[prop] || src[prop];
  });

  return dst;
};

var CombinedStream = combined_stream;
var util = require$$1$7;
var path = require$$2$4;
var http = require$$1$6;
var https = require$$2$5;
var parseUrl = require$$1$5.parse;
var fs = require$$1$4;
var Stream = require$$3$1.Stream;
var mime = mimeTypes;
var asynckit = asynckit$1;
var populate = populate$1;

// Public API
var form_data = FormData$2;

// make it a Stream
util.inherits(FormData$2, CombinedStream);

/**
 * Create readable "multipart/form-data" streams.
 * Can be used to submit forms
 * and file uploads to other web applications.
 *
 * @constructor
 * @param {Object} options - Properties to be added/overriden for FormData and CombinedStream
 */
function FormData$2(options) {
  if (!(this instanceof FormData$2)) {
    return new FormData$2(options);
  }

  this._overheadLength = 0;
  this._valueLength = 0;
  this._valuesToMeasure = [];

  CombinedStream.call(this);

  options = options || {};
  for (var option in options) {
    this[option] = options[option];
  }
}

FormData$2.LINE_BREAK = '\r\n';
FormData$2.DEFAULT_CONTENT_TYPE = 'application/octet-stream';

FormData$2.prototype.append = function(field, value, options) {

  options = options || {};

  // allow filename as single option
  if (typeof options == 'string') {
    options = {filename: options};
  }

  var append = CombinedStream.prototype.append.bind(this);

  // all that streamy business can't handle numbers
  if (typeof value == 'number') {
    value = '' + value;
  }

  // https://github.com/felixge/node-form-data/issues/38
  if (util.isArray(value)) {
    // Please convert your array into string
    // the way web server expects it
    this._error(new Error('Arrays are not supported.'));
    return;
  }

  var header = this._multiPartHeader(field, value, options);
  var footer = this._multiPartFooter();

  append(header);
  append(value);
  append(footer);

  // pass along options.knownLength
  this._trackLength(header, value, options);
};

FormData$2.prototype._trackLength = function(header, value, options) {
  var valueLength = 0;

  // used w/ getLengthSync(), when length is known.
  // e.g. for streaming directly from a remote server,
  // w/ a known file a size, and not wanting to wait for
  // incoming file to finish to get its size.
  if (options.knownLength != null) {
    valueLength += +options.knownLength;
  } else if (Buffer.isBuffer(value)) {
    valueLength = value.length;
  } else if (typeof value === 'string') {
    valueLength = Buffer.byteLength(value);
  }

  this._valueLength += valueLength;

  // @check why add CRLF? does this account for custom/multiple CRLFs?
  this._overheadLength +=
    Buffer.byteLength(header) +
    FormData$2.LINE_BREAK.length;

  // empty or either doesn't have path or not an http response or not a stream
  if (!value || ( !value.path && !(value.readable && value.hasOwnProperty('httpVersion')) && !(value instanceof Stream))) {
    return;
  }

  // no need to bother with the length
  if (!options.knownLength) {
    this._valuesToMeasure.push(value);
  }
};

FormData$2.prototype._lengthRetriever = function(value, callback) {

  if (value.hasOwnProperty('fd')) {

    // take read range into a account
    // `end` = Infinity –> read file till the end
    //
    // TODO: Looks like there is bug in Node fs.createReadStream
    // it doesn't respect `end` options without `start` options
    // Fix it when node fixes it.
    // https://github.com/joyent/node/issues/7819
    if (value.end != undefined && value.end != Infinity && value.start != undefined) {

      // when end specified
      // no need to calculate range
      // inclusive, starts with 0
      callback(null, value.end + 1 - (value.start ? value.start : 0));

    // not that fast snoopy
    } else {
      // still need to fetch file size from fs
      fs.stat(value.path, function(err, stat) {

        var fileSize;

        if (err) {
          callback(err);
          return;
        }

        // update final size based on the range options
        fileSize = stat.size - (value.start ? value.start : 0);
        callback(null, fileSize);
      });
    }

  // or http response
  } else if (value.hasOwnProperty('httpVersion')) {
    callback(null, +value.headers['content-length']);

  // or request stream http://github.com/mikeal/request
  } else if (value.hasOwnProperty('httpModule')) {
    // wait till response come back
    value.on('response', function(response) {
      value.pause();
      callback(null, +response.headers['content-length']);
    });
    value.resume();

  // something else
  } else {
    callback('Unknown stream');
  }
};

FormData$2.prototype._multiPartHeader = function(field, value, options) {
  // custom header specified (as string)?
  // it becomes responsible for boundary
  // (e.g. to handle extra CRLFs on .NET servers)
  if (typeof options.header == 'string') {
    return options.header;
  }

  var contentDisposition = this._getContentDisposition(value, options);
  var contentType = this._getContentType(value, options);

  var contents = '';
  var headers  = {
    // add custom disposition as third element or keep it two elements if not
    'Content-Disposition': ['form-data', 'name="' + field + '"'].concat(contentDisposition || []),
    // if no content type. allow it to be empty array
    'Content-Type': [].concat(contentType || [])
  };

  // allow custom headers.
  if (typeof options.header == 'object') {
    populate(headers, options.header);
  }

  var header;
  for (var prop in headers) {
    if (!headers.hasOwnProperty(prop)) continue;
    header = headers[prop];

    // skip nullish headers.
    if (header == null) {
      continue;
    }

    // convert all headers to arrays.
    if (!Array.isArray(header)) {
      header = [header];
    }

    // add non-empty headers.
    if (header.length) {
      contents += prop + ': ' + header.join('; ') + FormData$2.LINE_BREAK;
    }
  }

  return '--' + this.getBoundary() + FormData$2.LINE_BREAK + contents + FormData$2.LINE_BREAK;
};

FormData$2.prototype._getContentDisposition = function(value, options) {

  var filename
    , contentDisposition
    ;

  if (typeof options.filepath === 'string') {
    // custom filepath for relative paths
    filename = path.normalize(options.filepath).replace(/\\/g, '/');
  } else if (options.filename || value.name || value.path) {
    // custom filename take precedence
    // formidable and the browser add a name property
    // fs- and request- streams have path property
    filename = path.basename(options.filename || value.name || value.path);
  } else if (value.readable && value.hasOwnProperty('httpVersion')) {
    // or try http response
    filename = path.basename(value.client._httpMessage.path || '');
  }

  if (filename) {
    contentDisposition = 'filename="' + filename + '"';
  }

  return contentDisposition;
};

FormData$2.prototype._getContentType = function(value, options) {

  // use custom content-type above all
  var contentType = options.contentType;

  // or try `name` from formidable, browser
  if (!contentType && value.name) {
    contentType = mime.lookup(value.name);
  }

  // or try `path` from fs-, request- streams
  if (!contentType && value.path) {
    contentType = mime.lookup(value.path);
  }

  // or if it's http-reponse
  if (!contentType && value.readable && value.hasOwnProperty('httpVersion')) {
    contentType = value.headers['content-type'];
  }

  // or guess it from the filepath or filename
  if (!contentType && (options.filepath || options.filename)) {
    contentType = mime.lookup(options.filepath || options.filename);
  }

  // fallback to the default content type if `value` is not simple value
  if (!contentType && typeof value == 'object') {
    contentType = FormData$2.DEFAULT_CONTENT_TYPE;
  }

  return contentType;
};

FormData$2.prototype._multiPartFooter = function() {
  return function(next) {
    var footer = FormData$2.LINE_BREAK;

    var lastPart = (this._streams.length === 0);
    if (lastPart) {
      footer += this._lastBoundary();
    }

    next(footer);
  }.bind(this);
};

FormData$2.prototype._lastBoundary = function() {
  return '--' + this.getBoundary() + '--' + FormData$2.LINE_BREAK;
};

FormData$2.prototype.getHeaders = function(userHeaders) {
  var header;
  var formHeaders = {
    'content-type': 'multipart/form-data; boundary=' + this.getBoundary()
  };

  for (header in userHeaders) {
    if (userHeaders.hasOwnProperty(header)) {
      formHeaders[header.toLowerCase()] = userHeaders[header];
    }
  }

  return formHeaders;
};

FormData$2.prototype.setBoundary = function(boundary) {
  this._boundary = boundary;
};

FormData$2.prototype.getBoundary = function() {
  if (!this._boundary) {
    this._generateBoundary();
  }

  return this._boundary;
};

FormData$2.prototype.getBuffer = function() {
  var dataBuffer = new Buffer.alloc( 0 );
  var boundary = this.getBoundary();

  // Create the form content. Add Line breaks to the end of data.
  for (var i = 0, len = this._streams.length; i < len; i++) {
    if (typeof this._streams[i] !== 'function') {

      // Add content to the buffer.
      if(Buffer.isBuffer(this._streams[i])) {
        dataBuffer = Buffer.concat( [dataBuffer, this._streams[i]]);
      }else {
        dataBuffer = Buffer.concat( [dataBuffer, Buffer.from(this._streams[i])]);
      }

      // Add break after content.
      if (typeof this._streams[i] !== 'string' || this._streams[i].substring( 2, boundary.length + 2 ) !== boundary) {
        dataBuffer = Buffer.concat( [dataBuffer, Buffer.from(FormData$2.LINE_BREAK)] );
      }
    }
  }

  // Add the footer and return the Buffer object.
  return Buffer.concat( [dataBuffer, Buffer.from(this._lastBoundary())] );
};

FormData$2.prototype._generateBoundary = function() {
  // This generates a 50 character boundary similar to those used by Firefox.
  // They are optimized for boyer-moore parsing.
  var boundary = '--------------------------';
  for (var i = 0; i < 24; i++) {
    boundary += Math.floor(Math.random() * 10).toString(16);
  }

  this._boundary = boundary;
};

// Note: getLengthSync DOESN'T calculate streams length
// As workaround one can calculate file size manually
// and add it as knownLength option
FormData$2.prototype.getLengthSync = function() {
  var knownLength = this._overheadLength + this._valueLength;

  // Don't get confused, there are 3 "internal" streams for each keyval pair
  // so it basically checks if there is any value added to the form
  if (this._streams.length) {
    knownLength += this._lastBoundary().length;
  }

  // https://github.com/form-data/form-data/issues/40
  if (!this.hasKnownLength()) {
    // Some async length retrievers are present
    // therefore synchronous length calculation is false.
    // Please use getLength(callback) to get proper length
    this._error(new Error('Cannot calculate proper length in synchronous way.'));
  }

  return knownLength;
};

// Public API to check if length of added values is known
// https://github.com/form-data/form-data/issues/196
// https://github.com/form-data/form-data/issues/262
FormData$2.prototype.hasKnownLength = function() {
  var hasKnownLength = true;

  if (this._valuesToMeasure.length) {
    hasKnownLength = false;
  }

  return hasKnownLength;
};

FormData$2.prototype.getLength = function(cb) {
  var knownLength = this._overheadLength + this._valueLength;

  if (this._streams.length) {
    knownLength += this._lastBoundary().length;
  }

  if (!this._valuesToMeasure.length) {
    process.nextTick(cb.bind(this, null, knownLength));
    return;
  }

  asynckit.parallel(this._valuesToMeasure, this._lengthRetriever, function(err, values) {
    if (err) {
      cb(err);
      return;
    }

    values.forEach(function(length) {
      knownLength += length;
    });

    cb(null, knownLength);
  });
};

FormData$2.prototype.submit = function(params, cb) {
  var request
    , options
    , defaults = {method: 'post'}
    ;

  // parse provided url if it's string
  // or treat it as options object
  if (typeof params == 'string') {

    params = parseUrl(params);
    options = populate({
      port: params.port,
      path: params.pathname,
      host: params.hostname,
      protocol: params.protocol
    }, defaults);

  // use custom params
  } else {

    options = populate(params, defaults);
    // if no port provided use default one
    if (!options.port) {
      options.port = options.protocol == 'https:' ? 443 : 80;
    }
  }

  // put that good code in getHeaders to some use
  options.headers = this.getHeaders(params.headers);

  // https if specified, fallback to http in any other case
  if (options.protocol == 'https:') {
    request = https.request(options);
  } else {
    request = http.request(options);
  }

  // get content length and fire away
  this.getLength(function(err, length) {
    if (err && err !== 'Unknown stream') {
      this._error(err);
      return;
    }

    // add content length
    if (length) {
      request.setHeader('Content-Length', length);
    }

    this.pipe(request);
    if (cb) {
      var onResponse;

      var callback = function (error, responce) {
        request.removeListener('error', callback);
        request.removeListener('response', onResponse);

        return cb.call(this, error, responce);
      };

      onResponse = callback.bind(this, null);

      request.on('error', callback);
      request.on('response', onResponse);
    }
  }.bind(this));

  return request;
};

FormData$2.prototype._error = function(err) {
  if (!this.error) {
    this.error = err;
    this.pause();
    this.emit('error', err);
  }
};

FormData$2.prototype.toString = function () {
  return '[object FormData]';
};

// eslint-disable-next-line strict
var FormData$1 = form_data;

var utils$8 = utils$k;
var normalizeHeaderName = normalizeHeaderName$1;
var AxiosError$1 = AxiosError_1;
var transitionalDefaults = transitional;
var toFormData = toFormData_1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$8.isUndefined(headers) && utils$8.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = http_1;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$8.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$8.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$6 = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$8.isFormData(data) ||
      utils$8.isArrayBuffer(data) ||
      utils$8.isBuffer(data) ||
      utils$8.isStream(data) ||
      utils$8.isFile(data) ||
      utils$8.isBlob(data)
    ) {
      return data;
    }
    if (utils$8.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$8.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils$8.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils$8.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$6.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$8.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: FormData$1
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils$8.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$6.headers[method] = {};
});

utils$8.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$6.headers[method] = utils$8.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$6;

var utils$7 = utils$k;
var defaults$5 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$5;
  /*eslint no-param-reassign:0*/
  utils$7.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$6 = utils$k;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$4 = defaults_1;
var CanceledError$1 = CanceledError_1;

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$6.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$6.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$4.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$5 = utils$k;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$5.isPlainObject(target) && utils$5.isPlainObject(source)) {
      return utils$5.merge(target, source);
    } else if (utils$5.isPlainObject(source)) {
      return utils$5.merge({}, source);
    } else if (utils$5.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$5.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$5.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var VERSION = data.version;
var AxiosError = AxiosError_1;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$4 = utils$k;
var buildURL = buildURL$3;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var buildFullPath = buildFullPath$3;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils$4.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$4.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios$1.prototype[method] = generateHTTPMethod();

  Axios$1.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios_1 = Axios$1;

var CanceledError = CanceledError_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var utils$3 = utils$k;

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return utils$3.isObject(payload) && (payload.isAxiosError === true);
};

var utils$2 = utils$k;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults$3 = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$2.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils$2.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults$3);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.CanceledError = CanceledError_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.toFormData = toFormData_1;

// Expose AxiosError class
axios$1.AxiosError = AxiosError_1;

// alias for CanceledError for backward compatibility
axios$1.Cancel = axios$1.CanceledError;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

var YOUTUBE_THUMBNAIL_ENDPOINT = 'https://img.youtube.com/vi';
var FULL_SIZE_IMAGE_ARGUMENT = 's0';
var THUMBNAIL_ARGUMENT = 's64';
var getYoutubeThumbnailUrl = function (mediaUrl) {
    var videoId = mediaUrl.split('/').pop();
    return "".concat(YOUTUBE_THUMBNAIL_ENDPOINT, "/").concat(videoId, "/default.jpg");
};
var getImageUrl = function (mediaUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var imageId, imageUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                imageId = mediaUrl.split('/').pop();
                return [4 /*yield*/, axios.get("".concat(process.env.REACT_APP_IMAGE_RESIZE_ENDPOINT).concat(imageId))];
            case 1:
                imageUrl = _a.sent();
                return [2 /*return*/, imageUrl.data.image_url];
        }
    });
}); };
var useMediaUrlAndThumbnailUrl = function (vars) {
    var url = vars.url, mediaType = vars.type;
    var _a = useState(), mediaUrl = _a[0], setMediaUrl = _a[1];
    var _b = useState(), thumbnailUrl = _b[0], setThumbnailUrl = _b[1];
    useEffect(function () {
        if (url && mediaType) {
            switch (mediaType) {
                case MediaType.Image: {
                    getImageUrl(url).then(function (data) {
                        setMediaUrl("".concat(data, "=").concat(FULL_SIZE_IMAGE_ARGUMENT));
                        setThumbnailUrl("".concat(data, "=").concat(THUMBNAIL_ARGUMENT));
                    });
                    break;
                }
                case MediaType.Video: {
                    setMediaUrl(url);
                    setThumbnailUrl(getYoutubeThumbnailUrl(url));
                    break;
                }
            }
        }
    }, [url, mediaType]);
    return { mediaUrl: mediaUrl, thumbnailUrl: thumbnailUrl };
};

var useStyles$F = makeStyles()(function (theme, _a) {
    var _b, _c;
    var props = _a.styleProps;
    return ({
        imageContainer: {
            display: 'flex',
            maxHeight: "".concat((_b = props === null || props === void 0 ? void 0 : props.maxHeight) !== null && _b !== void 0 ? _b : 500, "px"),
            overflow: 'hidden',
            marginBottom: theme.spacing((_c = props === null || props === void 0 ? void 0 : props.marginBottom) !== null && _c !== void 0 ? _c : 0),
            width: '100%',
            background: (props === null || props === void 0 ? void 0 : props.greyBackground) ? theme.palette.grey[100] : undefined
        },
        image: {
            maxWidth: '100%',
            maxHeight: '100%',
            margin: 'auto',
            display: 'block'
        },
        videoContainer: {
            float: 'none',
            clear: 'both',
            width: '100%',
            position: 'relative',
            paddingBottom: '56.25%',
            marginBottom: theme.spacing(4),
            height: 0,
            '& iframe': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            }
        }
    });
});

var MediaControl = function (props) {
    var media = props.media, _a = props.alt, alt = _a === void 0 ? 'Question support' : _a, responseOptionMedia = props.responseOptionMedia;
    var classes = useStyles$F({
        styleProps: {
            marginBottom: responseOptionMedia ? 0 : 4,
            greyBackground: responseOptionMedia,
            maxHeight: responseOptionMedia ? 400 : 500
        }
    }).classes;
    var _b = useState(), renderedMedia = _b[0], setRenderedMedia = _b[1];
    var showVideo = media && media.mediaType === MediaType.Video;
    var mediaUrl = useMediaUrlAndThumbnailUrl({
        url: media === null || media === void 0 ? void 0 : media.mediaUrl,
        type: media === null || media === void 0 ? void 0 : media.mediaType
    }).mediaUrl;
    useEffect(function () {
        if (mediaUrl !== undefined) {
            var renderedMedia_1 = {
                mediaUrl: mediaUrl || '',
                mediaType: (media === null || media === void 0 ? void 0 : media.mediaType) || MediaType.Image
            };
            setRenderedMedia(renderedMedia_1);
        }
    }, [media, mediaUrl]);
    var getMediaComponent = function () {
        return showVideo ? (jsx$1("div", __assign$3({ className: classes.videoContainer }, { children: jsx$1("iframe", { width: "100%", height: "100%", src: mediaUrl, title: "YouTube video player", frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope", allowFullScreen: true }) }))) : (jsx$1("div", __assign$3({ className: classes.imageContainer }, { children: jsx$1("img", { className: classes.image, src: renderedMedia === null || renderedMedia === void 0 ? void 0 : renderedMedia.mediaUrl, alt: alt }) })));
    };
    var mediaComponent = media ? getMediaComponent() : null;
    return (renderedMedia === null || renderedMedia === void 0 ? void 0 : renderedMedia.mediaUrl) ? mediaComponent : jsx$1(Fragment$1, { children: " " });
};

var getCharacterLimitFromSettings = function (settingValues) {
    var valueAsString = getValueFromSettings(settingValues, 'character_limit');
    return valueAsString ? parseInt(valueAsString, 10) : undefined;
};
var NumberFormatCustom = function (props) {
    return (jsx$1(NumberFormat
    // eslint-disable-next-line react/jsx-props-no-spreading
    , __assign$3({}, props, { isNumericString: true, allowedDecimalSeparators: [',', '.'] })));
};
var FreeText = function (props) {
    var loc = props.loc, progress = props.progress, item = props.item, next = props.next, preview = props.preview, _a = props.settings, settings = _a === void 0 ? {} : _a, _b = props.isPreviewPanel, isPreviewPanel = _b === void 0 ? false : _b, validation = props.validation;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var limit = getCharacterLimitFromSettings(item.settingValues) || 0;
    var _d = useSimpleValidation(!!validation, validation === null || validation === void 0 ? void 0 : validation.matchPattern), handleTextChangeValidation = _d.handleTextChangeValidation, handleBlurValidation = _d.handleBlurValidation, resetValidation = _d.resetValidation, displayValidationErrors = _d.displayValidationErrors;
    var _e = useState({
        text: '',
        timestamp: undefined
    }), inputText = _e[0], setResponseText = _e[1];
    var handleTextChange = function (newText) {
        handleTextChangeValidation(newText);
        setResponseText({ text: newText, timestamp: getTimestampString() });
    };
    useEffect(function () {
        setResponseText({ text: '', timestamp: undefined });
        resetValidation();
    }, [item, resetValidation]);
    var freeTextContent = (jsxs(Fragment$1, { children: [jsx$1(MediaControl, { media: item.questionMedia }), !settings.isCompact && (jsx$1(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "flex-end" }, { children: jsx$1("p", __assign$3({ className: textClasses.default }, { children: "".concat(limit - inputText.text.length, " ").concat(loc.characterLimit) })) }))), jsx$1(Paper, { children: jsx$1(Input$6, { maxLength: limit, rows: 8, onBlur: handleBlurValidation, isError: displayValidationErrors, supressHelperText: true, rowsMax: 12, fullWidth: true, inputFontSize: InputFontSize.m, multiline: !settings.isCompact, placeholder: loc.typeYourAnswerHere, onChange: function (event) { return handleTextChange(event.target.value); }, value: inputText.text, dataCy: "free-text-input-field", customFormat: settings.numericOnly ? NumberFormatCustom : undefined }) }), displayValidationErrors && (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightError, textClasses.sizeS, textClasses.marginLeft) }, { children: validation === null || validation === void 0 ? void 0 : validation.helperText })))] }));
    return (jsx$1(SurveyQuestionLayout, { loc: loc, progress: progress, title: item.question.text, titleStyling: item.question.titleStyling, content: freeTextContent, preview: preview, next: __assign$3(__assign$3({}, next), { disabled: inputText.text.length === 0 || displayValidationErrors, onNext: function () {
                next.onNext(inputText);
            } }), isPreviewPanel: isPreviewPanel }));
};

var MatrixDesktop = function (props) {
    var _a;
    var item = props.item, selection = props.selection, onResponseOptionClick = props.onResponseOptionClick;
    var multipleChoice = isMatrixMultipleChoice(item.settingValues);
    var _b = useTextStyles(), textClasses = _b.classes, classNames = _b.cx;
    return (jsx$1(TableContainer$1, __assign$3({ component: Grid$2 }, { children: jsxs(Table$1, __assign$3({ "aria-label": "simple table" }, { children: [jsx$1(TableHead$1, { children: jsxs(TableRow$1, { children: [jsx$1(TableCell$1, {}), item.responseOptions.map(function (responseOption) {
                                return (jsx$1(TableCell$1, __assign$3({ align: "center" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default) }, { children: responseOption.option.value })) }), "matrix-column-".concat(responseOption.option.responseOptionId)));
                            })] }) }), jsx$1(TableBody$1, { children: (_a = item.matrixRows) === null || _a === void 0 ? void 0 : _a.map(function (entryMatrixRow, rowIndex) {
                        return (jsxs(TableRow$1, { children: [jsx$1(TableCell$1, __assign$3({ align: "center", scope: "row" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default) }, { children: entryMatrixRow.question.text })) })), item.responseOptions.map(function (responseOption, responseIndex) {
                                    return (jsx$1(TableCell$1, __assign$3({ align: "center" }, { children: multipleChoice ? (jsx$1(MuiCheckbox, { "data-cy": "checkbox-".concat(rowIndex, "-").concat(responseIndex), onClick: function () {
                                                return onResponseOptionClick(rowIndex, responseOption.position);
                                            }, checked: isResponseOptionSelected(selection[rowIndex], responseOption.position), disabled: isResponseOptionDisabled(item.settingValues, item.responseOptions, selection[rowIndex] || [], responseOption.position), color: "primary", inputProps: {
                                                'aria-label': 'disabled checkbox'
                                            } })) : (jsx$1(MuiRadio, { "data-cy": "radio-".concat(rowIndex, "-").concat(responseIndex), onClick: function () {
                                                return onResponseOptionClick(rowIndex, responseOption.position);
                                            }, checked: isResponseOptionSelected(selection[rowIndex], responseOption.position), color: "primary" })) }), "matrix-option-".concat(responseOption.option.responseOptionId)));
                                })] }, "matrix-row-".concat(entryMatrixRow.question.questionId)));
                    }) })] })) })));
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore$1(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore$1)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$3(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators$1(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning$3('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var ReactReduxContext = /*#__PURE__*/React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = useMemo$1(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo$1(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$1(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: PropTypes$1.shape({
      subscribe: PropTypes$1.func.isRequired,
      dispatch: PropTypes$1.func.isRequired,
      getState: PropTypes$1.func.isRequired
    }),
    context: PropTypes$1.object,
    children: PropTypes$1.any
  };
}

var _excluded$2 = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect$1(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose$3(_ref2, _excluded$2);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !reactIs$3.exports.isValidElementType(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends$P({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo$1 : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo$1(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose$3(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo$1(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIs$3.exports.isContextConsumer( /*#__PURE__*/React__default.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo$1(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo$1(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo$1(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends$P({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo$1(function () {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends$P({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo$1(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React__default.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React__default.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = React__default.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React__default.createElement(Connect, _extends$P({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$2(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning$2(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends$P({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      warning$2("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

var _excluded$1 = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose$3(_ref2, _excluded$1);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose$3(_ref3, _excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends$P({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = /*#__PURE__*/createConnect();

// with standard React renderers (ReactDOM, React Native)

setBatch(unstable_batchedUpdates);

function areInputsEqual$1(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = useRef(true);
  var committed = useRef(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual$1(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  useEffect(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

var isProduction$2 = process.env.NODE_ENV === 'production';
var prefix$2 = 'Invariant failed';
function invariant$1(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction$2) {
        throw new Error(prefix$2);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix$2 + ": " + provided : prefix$2;
    throw new Error(value);
}

var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing$1 : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing$1 : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing$1 : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse$1 = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant$1(false) : void 0;
  return result;
};

var getWindowScroll$1 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll$1();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse$1(styles.marginTop),
    right: parse$1(styles.marginRight),
    bottom: parse$1(styles.marginBottom),
    left: parse$1(styles.marginLeft)
  };
  var padding = {
    top: parse$1(styles.paddingTop),
    right: parse$1(styles.paddingRight),
    bottom: parse$1(styles.paddingBottom),
    left: parse$1(styles.paddingLeft)
  };
  var border = {
    top: parse$1(styles.borderTopWidth),
    right: parse$1(styles.borderRightWidth),
    bottom: parse$1(styles.borderBottomWidth),
    left: parse$1(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual$2(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual$2(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

var rafSchd$1 = rafSchd;

var isProduction = process.env.NODE_ENV === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean$1 = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage$1 = function getDevMessage(message) {
  return clean$1("\n  %creact-beautiful-dnd\n\n  %c" + clean$1(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage$1 = function getFormattedMessage(message) {
  return [getDevMessage$1(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log$1(type, message) {
  var _console;

  if (isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage$1(message));
}
var warning$1 = log$1.bind(null, 'warn');
var error = log$1.bind(null, 'error');

function noop$2() {}

function getOptions(shared, fromBinding) {
  return _extends$P({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1 = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1) {
    throw new RbdInvariant(prefix);
  } else {
    throw new RbdInvariant(prefix + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  _inheritsLoose$h(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop$2;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
        process.env.NODE_ENV !== "production" ? warning$1("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (process.env.NODE_ENV !== 'production') {
          error(err.message);
        }
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (process.env.NODE_ENV !== 'production') {
        error(err.message);
      }

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(React__default.Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return _extends$P({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = _extends$P({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = _extends$P({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function values(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = memoizeOne(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoizeOne(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoizeOne(function (droppables) {
  return values(droppables);
});
var toDraggableList = memoizeOne(function (draggables) {
  return values(draggables);
});

var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = memoizeOne(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return _extends$P({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find displaced item in set') : invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(_extends$P({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(_extends$P({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(_extends$P({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget$1(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget$1(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot move in direction without previous impact location') : invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = _extends$P({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get clipped area from droppable') : invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return _extends$P({}, frame, {
    scroll: _extends$P({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should not add placeholder space to home list') : invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return _extends$P({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return _extends$P({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot remove placeholder form subject when there was none') : invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return _extends$P({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$P({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return _extends$P({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return _extends$P({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = _extends$P({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return _extends$P({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant(false, 'Must be over a destination in SNAP movement mode') : invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected draggable to be inside home list') : invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var start$1 = function start(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};
var finish = function finish(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = _extends$P({}, draggable, {
    placeholder: _extends$P({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected Droppable to have a frame') : invariant(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var publishWhileDraggingInVirtual = (function (_ref) {
  var state = _ref.state,
      published = _ref.published;
  start$1();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = _extends$P({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = _extends$P({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = _extends$P({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = _extends$P({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return _extends$P({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return _extends$P({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Collection cannot start from phase " + state.phase) : invariant(false) : void 0;

    var _result = _extends$P({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " not permitted in phase " + state.phase) : invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant(false) : void 0;

    var updated = _extends$P({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant(false) : void 0;

    var _updated = _extends$P({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot move by window in phase " + state.phase) : invariant(false) : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant(false, 'Window scrolling is currently not supported for fixed lists') : invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = _extends$P({}, state.viewport, {
      scroll: _extends$P({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return _extends$P({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, action.type + " received while not in DRAGGING phase") : invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant(false) : void 0;

    var newState = _extends$P({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot animate drop from phase " + state.phase) : invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!Object.keys(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
  process.env.NODE_ENV !== "production" ? warning$1("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
}

function validateDimensions(critical, dimensions) {
  if (process.env.NODE_ENV !== 'production') {
    var insideDestination = getDraggablesInsideDroppable(critical.droppable.id, dimensions.draggables);
    checkIndexes(insideDestination);
  }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Unexpected phase to start a drag') : invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = _extends$P({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot drop in phase: " + state.phase) : invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(getWindowScroll());
  }

  var scheduled = rafSchd$1(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop$2;

  function isActive() {
    return unbind !== noop$2;
  }

  function start() {
    !!isActive() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start scroll listener when already active') : invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop scroll listener when not active') : invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop$2;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning$1('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find timer') : invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start$1();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeCapture as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = _extends$P({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only flush responders while dragging') : invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = _extends$P({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers = process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: 'react-beautiful-dnd'
}) : compose;
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore$1(reducer, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start$1();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find document.documentElement') : invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start$1();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should only be subscribed when a collection is occurring') : invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = memoizeOne(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant(false, 'Invalid result') : invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd$1(scrollWindow);
  var scheduleDroppableScroll = rafSchd$1(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot fluid scroll if not dragging') : invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1$1 = function start$1$1(state) {
    start$1();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot start auto scrolling when already started') : invariant(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable$1 = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable$1.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find the head to append a style to') : invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = useRef(null);
  var dynamicRef = useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function (proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot set dynamic style element if it is not set') : invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant(false, 'style elements already mounted') : invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot unmount ref as it is not set') : invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find any drag handles in the context \"" + contextId + "\"") : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find drag handle with id \"" + draggableId + "\" as no handle with a matching id was found") : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle needs to be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = useRef({});
  var recordRef = useRef(null);
  var restoreFocusFrameRef = useRef(null);
  var isMountedRef = useRef(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find draggable entry with id [" + id + "]") : invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot find droppable entry with id [" + id + "]") : invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = useMemo(createRegistry, []);
  useEffect(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = React__default.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot find document.body') : invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = useRef(null);
  useEffect(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    _extends$P(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

    process.env.NODE_ENV !== "production" ? warning$1("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var count = 0;
var defaults$2 = {
  separator: '::'
};
function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults$2;
  }

  return useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  useEffect(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = React__default.createContext(null);

var peerDependencies = {
	react: "^16.8.5 || ^17.0.0",
	"react-dom": "^16.8.5 || ^17.0.0"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Unable to parse React version " + value) : invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
});

function useDev(useHook) {
  if (process.env.NODE_ENV !== 'production') {
    useHook();
  }
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    useEffect(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, React__default.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = useRef(current);
  useEffect(function () {
    ref.current = current;
  });
  return ref;
}

function create$1() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot claim lock as it is already claimed') : invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot release lock when there is no lock') : invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var escape$1 = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot be IDLE') : invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === escape$1) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Unexpected phase') : invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = useRef(idle$1);
  var unbindEventsRef = useRef(noop$2);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === escape$1) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = useRef(noop$1$1);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop capturing a keyboard drag when not capturing') : invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === escape$1) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useTouchSensor(api) {
  var phaseRef = useRef(idle$2);
  var unbindEventsRef = useRef(noop$2);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot start dragging from phase " + phase.type) : invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected to move from IDLE to PENDING drag') : invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot change the amount of sensor hooks after mounting') : invariant(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

function isElement$1(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement$1(target)) {
    process.env.NODE_ENV !== "production" ? warning$1('event.target must be a Element') : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle must be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable$1.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1$1 = find(possible, function (el) {
    return el.getAttribute(draggable$1.id) === draggableId;
  });

  if (!draggable$1$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1$1)) {
    process.env.NODE_ENV !== "production" ? warning$1('Draggable element is not a HTMLElement') : void 0;
    return null;
  }

  return draggable$1$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable with id: " + draggableId) : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable element with id: " + draggableId) : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop$2);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ? process.env.NODE_ENV !== "production" ? invariant(false, "Cannot lift in phase " + phase) : invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return _extends$P({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = rafSchd$1(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return _extends$P({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop$2,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = useState(function () {
    return create$1();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find store from lazy ref') : invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = useRef(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function () {
    return bindActionCreators$1({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller(_extends$P({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators$1({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (process.env.NODE_ENV !== 'production') {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning$1('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  useEffect(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return React__default.createElement(AppContext.Provider, {
    value: appContext
  }, React__default.createElement(Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;
function useInstanceCount() {
  return useMemo(function () {
    return "" + count$1++;
  }, []);
}
function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return React__default.createElement(ErrorBoundary, null, function (setCallbacks) {
    return React__default.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ? process.env.NODE_ENV !== "production" ? invariant(false) : invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = useContext(Context);
  !result ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find required context') : invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = useRef(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return memoizeOne(function (x, y) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only update scroll when dragging') : invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return rafSchd$1(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find scroll options while scrolling') : invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot collect without a droppable ref') : invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (process.env.NODE_ENV !== 'production') {
        checkForNestedScrollContainers(scrollable);
      }
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot stop drag when no active drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot scroll when there is no drag') : invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning$1('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2$1() {}

var empty$1 = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty$1;
  }

  if (animate === 'close') {
    return empty$1;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle$1 = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = useState(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  useEffect(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2$1;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2$1;
    }

    if (animateOpenTimerRef.current) {
      return noop$2$1;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle$1({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React__default.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = React__default.memo(Placeholder);

var DroppableContext = React__default.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ? process.env.NODE_ENV !== "production" ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant(false, 'A Droppable requires a droppableId prop') : invariant(false) : void 0;
  !(typeof props.droppableId === 'string') ? process.env.NODE_ENV !== "production" ? invariant(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ? process.env.NODE_ENV !== "production" ? invariant(false, 'isDropDisabled must be a boolean') : invariant(false) : void 0;
  !isBoolean(props.isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant(false, 'isCombineEnabled must be a boolean') : invariant(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ? process.env.NODE_ENV !== "production" ? invariant(false, 'ignoreContainerClipping must be a boolean') : invariant(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n      Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ") : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ? process.env.NODE_ENV !== "production" ? invariant(false, 'Must provide a clone render function (renderClone) for virtual lists') : invariant(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected virtual list to not have a placeholder') : invariant(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  _inheritsLoose$h(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(React__default.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant(false, 'Cannot get dimension when no ref is set') : invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = useRef(entry);
  var isFirstPublishRef = useRef(true);
  useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ? process.env.NODE_ENV !== "production" ? invariant(false, 'Draggable requires a draggableId') : invariant(false) : void 0;
    !(typeof id === 'string') ? process.env.NODE_ENV !== "production" ? invariant(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant(false) : void 0;
    !isInteger(props.index) ? process.env.NODE_ENV !== "production" ? invariant(false, prefix(id) + " requires an integer index prop") : invariant(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ? process.env.NODE_ENV !== "production" ? invariant(false, prefix(id) + " Unable to find drag handle") : invariant(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = useRef(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Draggable isClone prop value changed during component life') : invariant(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = useRef(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoizeOne(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
  var getMemoizedProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return React__default.createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return React__default.createElement(PrivateDraggable, _extends$P({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = useContext(AppContext);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant(false, 'Could not find app context') : invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = useRef(null);
  var placeholderRef = useRef(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = React__default.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return React__default.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = React__default.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return ReactDOM__default.createPortal(node, getContainerForClone());
  }

  return React__default.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = _extends$P({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = memoizeOne(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoizeOne(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ? process.env.NODE_ENV !== "production" ? invariant(false, 'document.body is not ready') : invariant(false) : void 0;
  return document.body;
}

var defaultProps$1 = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps$1;

var useStyles$E = makeStyles()(function (theme) { return ({
    text: {
        padding: theme.spacing(1, 2)
    },
    paperWithImage: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    paper: {
        cursor: 'pointer',
        marginBottom: theme.spacing(1.5),
        borderRadius: theme.spacing(0.25)
    },
    selected: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.palette.success.main,
        '& > div:nth-child(2)': {
            padding: theme.spacing(0.875, 2)
        }
    },
    disabled: {
        cursor: 'default',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: additionalPalette.lightGrey.main,
        backgroundColor: additionalPalette.lightBlue.main,
        boxShadow: 'none',
        '& > div': {
            padding: theme.spacing(0.875, 2)
        }
    },
    dragHandle: {
        margin: theme.spacing(1)
    },
    indexText: {
        marginLeft: theme.spacing(-3),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(1),
        width: theme.spacing(2)
    },
    marker: {
        height: theme.spacing(1.5),
        width: theme.spacing(1.5),
        borderWidth: '1px',
        borderStyle: 'solid',
        margin: theme.spacing(0.625, 0)
    },
    markerSingleChoice: {
        borderRadius: theme.spacing(0.75),
        borderColor: theme.palette.text.secondary
    },
    markerMultipleChoice: {
        borderRadius: '2px',
        borderColor: theme.palette.text.secondary
    },
    markerSelectedSingleChoice: {
        borderColor: theme.palette.success.main
    },
    markerSelectedMultipleChoice: {
        borderColor: theme.palette.success.main,
        backgroundColor: theme.palette.success.main
    },
    markerCircle: {
        height: theme.spacing(1),
        width: theme.spacing(1),
        margin: theme.spacing(0.25),
        borderRadius: theme.spacing(0.5),
        backgroundColor: theme.palette.success.main
    },
    responseOptionMarker: {
        display: 'flex',
        justifyContent: 'center'
    }
}); });

var ResponseOptionMarker = function (props) {
    var _a;
    var multipleChoice = props.multipleChoice, selected = props.selected;
    var _b = useStyles$E(), classes = _b.classes, classNames = _b.cx;
    return (jsx$1("div", __assign$3({ className: classNames(classes.marker, (_a = {},
            _a[classes.markerSingleChoice] = !multipleChoice,
            _a[classes.markerMultipleChoice] = multipleChoice,
            _a[classes.markerSelectedSingleChoice] = !multipleChoice && selected,
            _a[classes.markerSelectedMultipleChoice] = multipleChoice && selected,
            _a)) }, { children: selected &&
            (multipleChoice ? (jsx$1(Icon, { name: IconName.ResponseOptionChecked, size: IconSize$1.Medium, iconColor: IconColor$1.White })) : (jsx$1("div", { className: classes.markerCircle }))) })));
};

var ResponseOption = function (props) {
    var _a, _b;
    var _c, _d;
    var item = props.item, index = props.index, onClick = props.onClick, _e = props.noMarker, noMarker = _e === void 0 ? false : _e, _f = props.multipleChoice, multipleChoice = _f === void 0 ? false : _f, _g = props.selected, selected = _g === void 0 ? false : _g, _h = props.disabled, disabled = _h === void 0 ? false : _h, _j = props.canReorder, canReorder = _j === void 0 ? false : _j, dataCy = props.dataCy, locTypeYourAnswerHere = props.locTypeYourAnswerHere, inputText = props.inputText, handleTextChange = props.handleTextChange;
    var _k = useStyles$E(), classes = _k.classes, classNames = _k.cx;
    var textClasses = useTextStyles().classes;
    return canReorder ? (jsx$1(PublicDraggable, __assign$3({ isDragDisabled: !canReorder, draggableId: "dr-id-".concat(item.position), index: index }, { children: function (provided) {
            var _a;
            return (jsxs(Grid$2, __assign$3({ container: true, direction: "row", "data-cy": dataCy }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, classes.indexText) }, { children: "".concat(index + 1, ".") })), jsxs(Paper, __assign$3({}, provided.draggableProps, provided.dragHandleProps, { component: ComponentType.Li, className: classNames(classes.paper, (_a = {},
                            _a[classes.selected] = selected,
                            _a[classes.disabled] = disabled,
                            _a[classes.paperWithImage] = !!item.option.media,
                            _a)), onClick: function () { return !disabled && onClick(); }, innerRef: provided.innerRef }, { children: [jsx$1(MediaControl, { media: item.option.media, alt: "", responseOptionMedia: true }), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "space-between" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, classes.text) }, { children: item.option.value })), canReorder && (jsx$1(Icon, { className: classes.dragHandle, name: IconName.DragIndicator, size: IconSize$1.Large, iconColor: IconColor$1.Disabled }))] }))] }))] })));
        } }))) : (jsxs(Fragment$1, { children: [jsxs(Paper, __assign$3({ className: classNames((_a = {},
                    _a[classes.paper] = !selected || !((_c = item === null || item === void 0 ? void 0 : item.option) === null || _c === void 0 ? void 0 : _c.isTextEntry),
                    _a[classes.selected] = selected,
                    _a[classes.disabled] = disabled,
                    _a[classes.paperWithImage] = !!item.option.media,
                    _a)), onClick: function () { return !disabled && onClick(); } }, { children: [jsx$1(MediaControl, { media: item.option.media, alt: "", responseOptionMedia: true }), jsxs(Grid$2, __assign$3({ className: classes.text, container: true, justifyContent: "space-between", direction: "row", "data-cy": dataCy }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 11 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground) }, { children: item.option.value })) })), jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.responseOptionMarker }, { children: !noMarker && !disabled && (jsx$1(ResponseOptionMarker, { multipleChoice: multipleChoice, selected: selected })) }))] }))] })), selected && ((_d = item === null || item === void 0 ? void 0 : item.option) === null || _d === void 0 ? void 0 : _d.isTextEntry) && (jsx$1(Paper, __assign$3({ component: ComponentType.Li, className: classNames(classes.paper, (_b = {},
                    _b[classes.paperWithImage] = !!item.option.media,
                    _b)) }, { children: jsx$1(Input$6, { rows: 3, supressHelperText: true, fullWidth: true, inputFontSize: InputFontSize.m, multiline: true, placeholder: locTypeYourAnswerHere, onChange: function (event) { return handleTextChange === null || handleTextChange === void 0 ? void 0 : handleTextChange(event.target.value); }, value: inputText, dataCy: "free-text-input-field" }) })))] }));
};

var MatrixMobile = function (props) {
    var item = props.item, selection = props.selection, mobileProgress = props.mobileProgress, onResponseOptionClick = props.onResponseOptionClick;
    var multipleChoice = isMatrixMultipleChoice(item.settingValues);
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsxs(Fragment$1, { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "space-between", alignItems: "baseline" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 11 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMl, textClasses.weightSemiBold) }, { children: item.matrixRows.length > mobileProgress &&
                                item.matrixRows[mobileProgress].question.text })) })), jsx$1(Grid$2, __assign$3({ item: true, xs: true }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignRight, textClasses.highlightBackground, textClasses.sizeMs) }, { children: "".concat(mobileProgress + 1, "/").concat(item.matrixRows.length) })) }))] })), jsx$1(MiuList, __assign$3({ style: { width: '100%' } }, { children: item.responseOptions.map(function (responseOption, index) { return (jsx$1(ResponseOption, { index: index, disabled: multipleChoice &&
                        isResponseOptionDisabled(item.settingValues, item.responseOptions, selection[mobileProgress], responseOption.position), multipleChoice: multipleChoice, selected: isResponseOptionSelected(selection[mobileProgress], responseOption.position), onClick: function () {
                        return onResponseOptionClick(mobileProgress, responseOption.position);
                    }, item: responseOption }, responseOption.position)); }) }))] }));
};

var Matrix = function (props) {
    var loc = props.loc, progress = props.progress, item = props.item, next = props.next, preview = props.preview, _a = props.isPreviewPanel, isPreviewPanel = _a === void 0 ? false : _a, onMobileNext = props.onMobileNext;
    var _b = useState(0), mobileProgress = _b[0], setMobileProgress = _b[1];
    var multipleChoice = isMatrixMultipleChoice(item.settingValues);
    var _c = useState(item.matrixRows.map(function () { return []; })), selection = _c[0], setSelection = _c[1];
    var theme = useTheme();
    var isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    var isSelectionValid = function () {
        if (isDesktop && !isPreviewPanel) {
            var nothingSelected = selection.length !== item.matrixRows.length ||
                selection.some(function (selectedResponse) { return selectedResponse.length === 0; });
            var minReached = selection.every(function (s) {
                return isMinNoOfResponsesReached(s, item.settingValues, item.responseOptions);
            });
            return !nothingSelected && minReached;
        }
        return (selection[mobileProgress].length > 0 &&
            isMinNoOfResponsesReached(selection[mobileProgress], item.settingValues, item.responseOptions));
    };
    var handleResponseOptionClick = function (row, position) {
        var posIndex = selection[row].findIndex(function (selectedRow) { return selectedRow.selectedPosition === position; });
        var newSelection = __spreadArray([], selection, true);
        if (posIndex > -1) {
            newSelection[row].splice(posIndex, 1);
        }
        else if (isResponseDefaultOrExclusive(item.responseOptions, position) ||
            !multipleChoice) {
            newSelection[row] = [getNewSelectedResponseObj(position)];
        }
        else {
            newSelection[row].push(getNewSelectedResponseObj(position));
        }
        setSelection(newSelection);
    };
    var handleMobileNext = function () {
        if (onMobileNext) {
            onMobileNext();
        }
        if (mobileProgress === item.matrixRows.length - 1) {
            next.onNext(selection);
            return;
        }
        setMobileProgress(mobileProgress + 1);
    };
    var handleDesktopNext = function () {
        next.onNext(selection);
    };
    var showMobileView = !isDesktop || isPreviewPanel;
    var showDesktopView = isDesktop && !isPreviewPanel;
    var matrixContent = (jsxs(Fragment$1, { children: [showDesktopView && (jsx$1(MatrixDesktop, { item: item, selection: selection, onResponseOptionClick: handleResponseOptionClick })), showMobileView && (jsx$1(MatrixMobile, { item: item, selection: selection, mobileProgress: mobileProgress, onResponseOptionClick: handleResponseOptionClick }))] }));
    useEffect(function () {
        setSelection(item.matrixRows.map(function () { return []; }));
        setMobileProgress(0);
    }, [item]);
    var getInstructions = function () {
        var desktop = isDesktop && !isPreviewPanel;
        if (desktop && multipleChoice)
            return loc.matrixInstructions.multiSelectDesktop;
        if (desktop && !multipleChoice)
            return loc.matrixInstructions.singleSelectDesktop;
        if (!desktop && multipleChoice)
            return loc.matrixInstructions.multiSelectMobile;
        if (!desktop && !multipleChoice)
            return loc.matrixInstructions.singleSelectMobile;
        return undefined;
    };
    var locInternal = {
        next: loc.next,
        instructions: getInstructions()
    };
    return (jsx$1(SurveyQuestionLayout, { loc: locInternal, progress: progress, title: item.matrixTitle.title, titleStyling: item.matrixTitle.titleStyling, content: matrixContent, fullWidth: showDesktopView, preview: preview, next: __assign$3(__assign$3({}, next), { disabled: !isSelectionValid(), onNext: showDesktopView ? handleDesktopNext : handleMobileNext }), isPreviewPanel: isPreviewPanel }));
};

var MultipleChoice = function (props) {
    var _a;
    var item = props.item, loc = props.loc, progress = props.progress, next = props.next, preview = props.preview, _b = props.isPreviewPanel, isPreviewPanel = _b === void 0 ? false : _b, dataCy = props.dataCy;
    var _c = useState([]), selectedResponses = _c[0], setSelectedResponses = _c[1];
    var getResponseOptionInputText = function (position) {
        var _a;
        var selectedResponse = selectedResponses.find(function (ro) { return ro.selectedPosition === position; });
        return (_a = selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.inputText) === null || _a === void 0 ? void 0 : _a.text;
    };
    var handleTextChange = function (newText, position) {
        var positionIndex = selectedResponses.findIndex(function (selectedResponse) { return selectedResponse.selectedPosition === position; });
        if (positionIndex > -1) {
            var newSelectedResponses = __spreadArray([], selectedResponses, true);
            newSelectedResponses.splice(positionIndex, 1);
            setSelectedResponses(__spreadArray(__spreadArray([], newSelectedResponses, true), [
                __assign$3(__assign$3({}, getNewSelectedResponseObj(position)), { inputText: { text: newText, timestamp: getTimestampString() } })
            ], false));
        }
    };
    var handleResponseOptionClick = function (position) {
        var positionIndex = selectedResponses.findIndex(function (selectedResponse) { return selectedResponse.selectedPosition === position; });
        if (positionIndex > -1) {
            var newSelectedResponses = __spreadArray([], selectedResponses, true);
            newSelectedResponses.splice(positionIndex, 1);
            setSelectedResponses(newSelectedResponses);
        }
        else if (isResponseDefaultOrExclusive(item.responseOptions, position)) {
            setSelectedResponses([getNewSelectedResponseObj(position)]);
        }
        else {
            setSelectedResponses(__spreadArray(__spreadArray([], selectedResponses, true), [
                __assign$3(__assign$3({}, getNewSelectedResponseObj(position)), { inputText: { text: '', timestamp: undefined } })
            ], false));
        }
    };
    var multipleChoiceContent = (jsxs(Fragment$1, { children: [jsx$1(MediaControl, { media: item.questionMedia }), jsx$1(MiuList, __assign$3({ style: { width: '100%' } }, { children: (_a = item.responseOptions) === null || _a === void 0 ? void 0 : _a.map(function (responseOption, index) { return (jsx$1(ResponseOption, { index: index, multipleChoice: true, disabled: isResponseOptionDisabled(item.settingValues, item.responseOptions, selectedResponses, responseOption.position), selected: isResponseOptionSelected(selectedResponses, responseOption.position), onClick: function () { return handleResponseOptionClick(responseOption.position); }, item: responseOption, locTypeYourAnswerHere: loc.typeYourAnswerHere, inputText: getResponseOptionInputText(responseOption.position), handleTextChange: function (newString) {
                        return handleTextChange(newString, responseOption.position);
                    }, dataCy: "".concat(dataCy, "-").concat(index) }, responseOption.position)); }) }))] }));
    useEffect(function () {
        setSelectedResponses([]);
    }, [item]);
    var anyTextInputIsEmpty = function () {
        return selectedResponses.some(function (sr) {
            var _a, _b, _c, _d;
            return ((_c = (_b = (_a = item.responseOptions) === null || _a === void 0 ? void 0 : _a.find(function (ro) { return ro.position === sr.selectedPosition; })) === null || _b === void 0 ? void 0 : _b.option) === null || _c === void 0 ? void 0 : _c.isTextEntry) &&
                (sr.inputText === undefined || ((_d = sr.inputText) === null || _d === void 0 ? void 0 : _d.text.length) === 0);
        });
    };
    return (jsx$1(SurveyQuestionLayout, { loc: loc, progress: progress, title: item.question.text, titleStyling: item.question.titleStyling, content: multipleChoiceContent, preview: preview, next: __assign$3(__assign$3({}, next), { disabled: selectedResponses.length === 0 ||
                anyTextInputIsEmpty() ||
                !isMinNoOfResponsesReached(selectedResponses, item.settingValues, item.responseOptions), onNext: function () {
                next.onNext(selectedResponses);
            } }), isPreviewPanel: isPreviewPanel }));
};

var RankedList = function (props) {
    var rankedResponseOptions = props.rankedResponseOptions, loc = props.loc, handleDragEnd = props.handleDragEnd, handleRankedResponseOptionClick = props.handleRankedResponseOptionClick;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsxs(Fragment$1, { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "space-between" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.gutterBottom) }, { children: loc.tapToRemove })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.gutterBottom) }, { children: loc.dragToReorder }))] })), jsx$1(DragDropContext, __assign$3({ onDragEnd: handleDragEnd }, { children: jsx$1(ConnectedDroppable, __assign$3({ droppableId: "ranked" }, { children: function (provided) { return (jsxs(MiuList, __assign$3({ style: { width: '100%' } }, provided.droppableProps, { ref: provided.innerRef }, { children: [rankedResponseOptions.map(function (responseOption, index) { return (jsx$1(ResponseOption, { index: index, canReorder: true, onClick: function () {
                                    return handleRankedResponseOptionClick(responseOption.position);
                                }, item: responseOption }, responseOption.position)); }), provided.placeholder] }))); } })) }))] }));
};

var getChoiceRequisiteFromSettings = function (settingValues) {
    var valueAsString = getValueFromSettings(settingValues, 'choice_requisite');
    return valueAsString ? parseInt(valueAsString, 10) : undefined;
};
var Ranked = function (props) {
    var _a, _b;
    var loc = props.loc, progress = props.progress, next = props.next, item = props.item, preview = props.preview, _c = props.isPreviewPanel, isPreviewPanel = _c === void 0 ? false : _c, dataCy = props.dataCy;
    var requisite = getChoiceRequisiteFromSettings(item.settingValues);
    var responseOptions = item.responseOptions;
    var _d = useState([]), rankedResponseOptions = _d[0], setRankedResponseOptions = _d[1];
    var _e = useState(responseOptions || []), unrankedResponseOptions = _e[0], setUnrankedResponseOptions = _e[1];
    var _f = useTextStyles(), textClasses = _f.classes, classNames = _f.cx;
    var handleUnrankedResponseOptionClick = function (position) {
        var unrankedPosition = unrankedResponseOptions.findIndex(function (unrankedResponseOption) { return unrankedResponseOption.position === position; });
        if (unrankedPosition > -1) {
            var responseOption = unrankedResponseOptions[unrankedPosition];
            var newUnrankedResponseOptions = __spreadArray([], unrankedResponseOptions, true);
            var newRankedResponseOptions = __spreadArray([], rankedResponseOptions, true);
            newUnrankedResponseOptions.splice(unrankedPosition, 1);
            if (requisite && rankedResponseOptions.length === requisite) {
                var rankedToUnrank = newRankedResponseOptions[newRankedResponseOptions.length - 1];
                newRankedResponseOptions.pop();
                newUnrankedResponseOptions.push(rankedToUnrank);
            }
            setUnrankedResponseOptions(newUnrankedResponseOptions);
            setRankedResponseOptions(__spreadArray(__spreadArray([], newRankedResponseOptions, true), [
                __assign$3(__assign$3({}, responseOption), { timestamp: getTimestampString() })
            ], false));
        }
    };
    var handleRankedResponseOptionClick = function (position) {
        var rankedPosition = rankedResponseOptions.findIndex(function (rankedResponseOption) { return rankedResponseOption.position === position; });
        if (rankedPosition > -1) {
            var responseOption = rankedResponseOptions[rankedPosition];
            var newRankedResponseOptions = __spreadArray([], rankedResponseOptions, true);
            newRankedResponseOptions.splice(rankedPosition, 1);
            setRankedResponseOptions(newRankedResponseOptions);
            setUnrankedResponseOptions(__spreadArray(__spreadArray([], unrankedResponseOptions, true), [responseOption], false));
        }
    };
    var handleDragEnd = function (result) {
        if (!result.destination) {
            return;
        }
        var newRanked = __spreadArray([], rankedResponseOptions, true);
        var removed = newRanked.splice(result.source.index, 1)[0];
        newRanked.splice(result.destination.index, 0, removed);
        setRankedResponseOptions(newRanked);
    };
    var isNextButtonDisabled = requisite &&
        item.responseOptions &&
        requisite <= ((_a = item.responseOptions) === null || _a === void 0 ? void 0 : _a.length)
        ? rankedResponseOptions.length !== requisite
        : rankedResponseOptions.length !== ((_b = item.responseOptions) === null || _b === void 0 ? void 0 : _b.length);
    var multipleChoiceContent = (jsxs(Fragment$1, { children: [rankedResponseOptions.length > 0 && (jsx$1(RankedList, { rankedResponseOptions: rankedResponseOptions, loc: loc, handleDragEnd: handleDragEnd, handleRankedResponseOptionClick: handleRankedResponseOptionClick })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.weightSemiBold, textClasses.sizeMs, textClasses.gutterBottom) }, { children: loc.tapToSelect })), unrankedResponseOptions.map(function (responseOption, index) {
                var _a;
                return (jsx$1(ResponseOption, { index: index, noMarker: true, onClick: function () {
                        return handleUnrankedResponseOptionClick(responseOption.position);
                    }, item: responseOption, dataCy: "".concat(dataCy, "-").concat(index) }, (_a = responseOption.option) === null || _a === void 0 ? void 0 : _a.responseOptionId));
            })] }));
    useEffect(function () {
        if (responseOptions) {
            setUnrankedResponseOptions(responseOptions);
        }
    }, [responseOptions]);
    useEffect(function () {
        setRankedResponseOptions([]);
    }, [item]);
    return (jsx$1(SurveyQuestionLayout, { loc: loc, progress: progress, title: item.question.text, titleStyling: item.question.titleStyling, content: multipleChoiceContent, preview: preview, next: __assign$3(__assign$3({}, next), { disabled: isNextButtonDisabled, onNext: function () {
                next.onNext(rankedResponseOptions.map(function (responseOption) { return ({
                    selectedPosition: responseOption.position,
                    timestamp: responseOption.timestamp
                }); }));
            } }), isPreviewPanel: isPreviewPanel }));
};

var useStyles$D = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        sliderOutput: {
            marginBottom: theme.spacing(3)
        },
        slider: {
            color: theme.palette.success.main,
            '& .MuiSlider-thumb': {
                '&:focus, &:hover, &:active': {
                    boxShadow: '0px 0px 0px 8px rgba(6,172,6, 0.1)'
                }
            },
            '& .MuiSlider-rail': {
                color: theme.palette.text.disabled
            },
            '& .MuiSlider-mark': {
                backgroundColor: theme.palette.text.disabled,
                height: theme.spacing(0.75),
                width: theme.spacing(0.25)
                // marginTop: `-${theme.spacing(0.25)}`
            },
            '& .MuiSlider-markActive': {
                backgroundColor: props.disabled
                    ? additionalPalette.grey.main
                    : theme.palette.success.main
            }
        },
        sliderGrid: {
            padding: theme.spacing(1, 2.5)
        },
        labelsContainer: {
            marginTop: "-".concat(theme.spacing(0.75))
        },
        alternativeOptions: {
            paddingTop: theme.spacing(4.5)
        }
    });
});

var SliderComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var item = props.item, selectedSliderResponse = props.selectedSliderResponse, shouldShowLabels = props.shouldShowLabels, onChangeSlider = props.onChangeSlider, onClickDefaultResponseOption = props.onClickDefaultResponseOption;
    var _k = useTextStyles(), textClasses = _k.classes, classNames = _k.cx;
    var minValue = ((_a = item.questionScale) === null || _a === void 0 ? void 0 : _a.range.min) || ((_b = item.questionScale) === null || _b === void 0 ? void 0 : _b.range.min) === 0
        ? (_c = item.questionScale) === null || _c === void 0 ? void 0 : _c.range.min
        : 0;
    var maxValue = ((_d = item.questionScale) === null || _d === void 0 ? void 0 : _d.range.max) || ((_e = item.questionScale) === null || _e === void 0 ? void 0 : _e.range.max) === 0
        ? (_f = item.questionScale) === null || _f === void 0 ? void 0 : _f.range.max
        : 100;
    var defaultValue = Math.floor((maxValue + minValue) / 2);
    var step = ((_g = item.questionScale) === null || _g === void 0 ? void 0 : _g.range.step) || 1;
    var labels = (_h = item.questionScale) === null || _h === void 0 ? void 0 : _h.labels;
    var sliderOutput = selectedSliderResponse.sliderOutput;
    var disabled = selectedSliderResponse.selectedDefaultOptionPosition !== undefined;
    var classes = useStyles$D({ styleProps: { disabled: disabled } }).classes;
    var middleValue = (maxValue + minValue) / 2;
    var customMarks = [
        {
            value: minValue
        },
        {
            value: middleValue
        },
        {
            value: maxValue
        }
    ];
    var getLabelTextByPosition = function (labels, index) {
        var _a;
        if (labels) {
            var labelText = ((_a = labels.find(function (labelObj) { return labelObj.position === index; })) === null || _a === void 0 ? void 0 : _a.label.text) || '';
            return labelText;
        }
        return '';
    };
    var handleChangeSlider = function (_, newValue) {
        onChangeSlider(newValue, getTimestampString());
    };
    var getSliderLabels = function () {
        if (!shouldShowLabels) {
            return null;
        }
        return (jsxs(Grid, __assign$3({ container: true, className: classes.labelsContainer }, { children: [jsx$1(Grid, __assign$3({ container: true, item: true, xs: 4, justifyContent: "flex-start" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.sizeMs, textClasses.highlightBackground) }, { children: getLabelTextByPosition(labels, 0) })) })), jsx$1(Grid, __assign$3({ container: true, item: true, xs: 4, justifyContent: "center" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignCenter, textClasses.sizeMs, textClasses.highlightBackground) }, { children: getLabelTextByPosition(labels, 1) })) })), jsx$1(Grid, __assign$3({ container: true, item: true, xs: 4, justifyContent: "flex-end" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignRight, textClasses.sizeMs, textClasses.highlightBackground) }, { children: getLabelTextByPosition(labels, 2) })) }))] })));
    };
    return (jsxs(Grid, __assign$3({ container: true, direction: "column", alignItems: "center" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeXxl, textClasses.weightSemiBold, classes.sliderOutput) }, { children: sliderOutput !== undefined ? sliderOutput : '—' })), jsx$1(Paper, { children: jsxs(Grid, __assign$3({ container: true, alignItems: "center", className: classes.sliderGrid }, { children: [jsx$1(MuiSlider, { size: "small", defaultValue: defaultValue, step: step, min: minValue, max: maxValue, marks: customMarks, valueLabelDisplay: "off", onChange: handleChangeSlider, className: classes.slider, disabled: disabled, "data-cy": "slider-rail" }), getSliderLabels()] })) }), item.responseOptions && item.responseOptions.length > 0 && (jsxs(Grid, __assign$3({ container: true, className: classes.alternativeOptions }, { children: [jsx$1(Grid, __assign$3({ item: true }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.weightSemiBold, textClasses.highlightBackground) }, { children: "Alternative options" })) })), jsx$1(MiuList, __assign$3({ style: { width: '100%' } }, { children: (_j = item.responseOptions) === null || _j === void 0 ? void 0 : _j.map(function (responseOption, index) { return (jsx$1(ResponseOption, { index: index, selected: selectedSliderResponse.selectedDefaultOptionPosition ===
                                responseOption.position, onClick: function () {
                                return onClickDefaultResponseOption(responseOption.position);
                            }, item: responseOption, disabled: selectedSliderResponse.selectedDefaultOptionPosition !==
                                responseOption.position }, responseOption.position)); }) }))] })))] })));
};

var Slider = function (props) {
    var loc = props.loc, progress = props.progress, next = props.next, item = props.item, _a = props.shouldShowLabels, shouldShowLabels = _a === void 0 ? true : _a, isPreviewPanel = props.isPreviewPanel, preview = props.preview;
    var _b = useState({
        sliderOutput: undefined,
        selectedDefaultOptionPosition: undefined,
        timestamp: undefined
    }), selectedSliderResponse = _b[0], setSelectedSliderResponse = _b[1];
    var isDefaultResponseOptionAlreadySelected = function (position) {
        var isAlreadySelected = selectedSliderResponse.selectedDefaultOptionPosition === position;
        return isAlreadySelected;
    };
    var handleClickDefaultResponseOption = function (position) {
        var isResponseOptionAlreadySelected = isDefaultResponseOptionAlreadySelected(position);
        setSelectedSliderResponse({
            sliderOutput: undefined,
            selectedDefaultOptionPosition: isResponseOptionAlreadySelected
                ? undefined
                : position,
            timestamp: getTimestampString()
        });
    };
    var handleChangeSlider = function (sliderOutput, timestamp) {
        setSelectedSliderResponse({
            sliderOutput: sliderOutput,
            selectedDefaultOptionPosition: undefined,
            timestamp: timestamp
        });
    };
    useEffect(function () {
        setSelectedSliderResponse({
            sliderOutput: undefined,
            selectedDefaultOptionPosition: undefined,
            timestamp: undefined
        });
    }, [item]);
    return (jsx$1(SurveyQuestionLayout, { loc: loc, progress: progress, preview: preview, isPreviewPanel: isPreviewPanel, title: item.question.text, titleStyling: item.question.titleStyling, content: jsx$1(SliderComponent, { item: item, selectedSliderResponse: selectedSliderResponse, shouldShowLabels: shouldShowLabels, onChangeSlider: function (newValue, timestamp) {
                return handleChangeSlider(newValue, timestamp);
            }, onClickDefaultResponseOption: handleClickDefaultResponseOption }), next: __assign$3(__assign$3({}, next), { disabled: selectedSliderResponse.selectedDefaultOptionPosition === undefined &&
                selectedSliderResponse.sliderOutput === undefined, onNext: function () {
                next.onNext(selectedSliderResponse);
            } }) }));
};

var SingleChoice = function (props) {
    var _a;
    var item = props.item, loc = props.loc, progress = props.progress, next = props.next, preview = props.preview, _b = props.isPreviewPanel, isPreviewPanel = _b === void 0 ? false : _b, dataCy = props.dataCy;
    var _c = useState(__assign$3(__assign$3({}, getNewSelectedResponseObj(-1)), { inputText: {
            text: '',
            timestamp: undefined
        } })), selectedResponse = _c[0], setSelectedResponse = _c[1];
    var handleTextChange = function (newText) {
        setSelectedResponse(__assign$3(__assign$3({}, selectedResponse), { inputText: { text: newText, timestamp: getTimestampString() } }));
    };
    var handleResponseOptionClick = function (position) {
        if (position === (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.selectedPosition)) {
            setSelectedResponse(getNewSelectedResponseObj(-1));
        }
        else {
            setSelectedResponse(getNewSelectedResponseObj(position));
        }
    };
    var singleChoiceContent = (jsxs(Fragment$1, { children: [jsx$1(MediaControl, { media: item.questionMedia }), jsx$1(MiuList, __assign$3({ style: { width: '100%' } }, { children: (_a = item.responseOptions) === null || _a === void 0 ? void 0 : _a.map(function (responseOption, index) {
                    var _a;
                    return (jsx$1(ResponseOption, { index: index, selected: selectedResponse.selectedPosition === responseOption.position, onClick: function () { return handleResponseOptionClick(responseOption.position); }, item: responseOption, locTypeYourAnswerHere: loc.typeYourAnswerHere, inputText: (_a = selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.inputText) === null || _a === void 0 ? void 0 : _a.text, handleTextChange: handleTextChange, dataCy: "".concat(dataCy, "-").concat(index) }, responseOption.position));
                }) }))] }));
    useEffect(function () {
        setSelectedResponse(getNewSelectedResponseObj(-1));
    }, [item]);
    var textInputIsEmpty = function () {
        var _a, _b, _c, _d;
        return (!!((_c = (_b = (_a = item.responseOptions) === null || _a === void 0 ? void 0 : _a.find(function (ro) { return ro.position === selectedResponse.selectedPosition; })) === null || _b === void 0 ? void 0 : _b.option) === null || _c === void 0 ? void 0 : _c.isTextEntry) &&
            ((selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.inputText) === undefined ||
                ((_d = selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.inputText) === null || _d === void 0 ? void 0 : _d.text.length) === 0));
    };
    return (jsx$1(SurveyQuestionLayout, { loc: loc, progress: progress, title: item.question.text, titleStyling: item.question.titleStyling, content: singleChoiceContent, preview: preview, next: __assign$3(__assign$3({}, next), { disabled: selectedResponse.selectedPosition === -1 || textInputIsEmpty(), onNext: function () {
                next.onNext(selectedResponse);
            } }), isPreviewPanel: isPreviewPanel }));
};

var TextInstructions = function (props) {
    var loc = props.loc, item = props.item, progress = props.progress, next = props.next, preview = props.preview, _a = props.isPreviewPanel, isPreviewPanel = _a === void 0 ? false : _a;
    var textInstructionsContent = (jsx$1(MediaControl, { media: item.questionMedia }));
    return (jsx$1(SurveyQuestionLayout, { loc: loc, isTextInstruction: true, progress: progress, preview: preview, content: textInstructionsContent, isPreviewPanel: isPreviewPanel, title: item.textCard.title, titleStyling: item.textCard.titleStyling, next: next }));
};

var Add = {};

var _interopRequireDefault$b = interopRequireDefault.exports;

Object.defineProperty(Add, "__esModule", {
  value: true
});
var default_1$1 = Add.default = void 0;

var _createSvgIcon$1 = _interopRequireDefault$b(createSvgIcon);

var _jsxRuntime$1 = require$$2$3;

var _default$1 = (0, _createSvgIcon$1.default)( /*#__PURE__*/(0, _jsxRuntime$1.jsx)("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

default_1$1 = Add.default = _default$1;

var Remove = {};

var _interopRequireDefault$a = interopRequireDefault.exports;

Object.defineProperty(Remove, "__esModule", {
  value: true
});
var default_1 = Remove.default = void 0;

var _createSvgIcon = _interopRequireDefault$a(createSvgIcon);

var _jsxRuntime = require$$2$3;

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 13H5v-2h14v2z"
}), 'Remove');

default_1 = Remove.default = _default;

var useStyles$C = makeStyles()(function (theme) { return ({
    addIcon: {
        transform: 'scale(0.75)',
        color: theme.palette.secondary.main,
        fontSize: theme.spacing(2.5),
        marginLeft: "-".concat(theme.spacing(0.375)),
        '&:hover': {
            color: theme.palette.primary.main,
            cursor: 'pointer'
        }
    },
    removeIcon: {
        transform: 'scale(0.75)',
        color: theme.palette.secondary.main,
        fontSize: theme.spacing(2.5),
        marginRight: "-".concat(theme.spacing(0.375)),
        '&:hover': {
            color: theme.palette.primary.main,
            cursor: 'pointer'
        }
    }
}); });

var Increment = function (props) {
    var onClickAdd = props.onClickAdd, onClickRemove = props.onClickRemove, _a = props.disableAdd, disableAdd = _a === void 0 ? false : _a, _b = props.disableRemove, disableRemove = _b === void 0 ? false : _b;
    var classes = useStyles$C().classes;
    return (jsxs(Fragment$1, { children: [jsx$1(default_1, { onClick: !disableRemove ? onClickRemove : undefined, className: classes.removeIcon }), jsx$1(default_1$1, { onClick: !disableAdd ? onClickAdd : undefined, className: classes.addIcon })] }));
};

var LayoutVisibility;
(function (LayoutVisibility) {
    LayoutVisibility[LayoutVisibility["Mobile"] = 0] = "Mobile";
    LayoutVisibility[LayoutVisibility["Desktop"] = 1] = "Desktop";
})(LayoutVisibility || (LayoutVisibility = {}));
// TODO: Replace Hidden component as it is deprecated:
// https://mui.com/material-ui/migration/v5-component-changes/#hidden
var HiddenLayout = function (props) {
    var children = props.children, visibility = props.visibility;
    return visibility === LayoutVisibility.Mobile ? (jsx$1(Hidden, __assign$3({ mdUp: true }, { children: children }))) : (
    // <Paper sx={{ display: { xs: 'block', md: 'none' } }}>{children}</Paper>
    jsx$1(Hidden, __assign$3({ mdDown: true }, { children: children }))
    // <Paper sx={{ display: { md: 'none', xl: 'block' } }}>{children}</Paper>
    );
};

var useStyles$B = makeStyles()(function (theme) { return ({
    container: {
        padding: theme.spacing(7)
    },
    spinner: {
        padding: theme.spacing(1)
    },
    text: {
        padding: theme.spacing(2, 0, 1, 0)
    },
    containerBackground: {
        backgroundColor: additionalPalette.darkGrey.main
    }
}); });

var SpinnerDialog = function (props) {
    var isVisible = props.isVisible, text = props.text, subtext = props.subtext;
    var classes = useStyles$B().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsx$1(Dialog$2, __assign$3({ open: isVisible, fullWidth: true, classes: {
            container: classes.containerBackground
        } }, { children: jsxs(Grid$2, __assign$3({ className: classes.container, container: true, justifyContent: "center", direction: "column", alignItems: "center" }, { children: [jsx$1(Spinner, { className: classes.spinner, color: SpinnerColor.Primary, size: SpinnerSize.m }), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeL, classes.text) }, { children: text })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeM, textClasses.highlightBackground) }, { children: subtext }))] })) })));
};

var useStyles$A = makeStyles()(function (theme, _a) {
    var styleProps = _a.styleProps;
    return ({
        grid: {
            zIndex: 1,
            position: styleProps.position,
            bottom: 0,
            width: '100%',
            height: theme.spacing(7),
            borderRadius: theme.spacing(0),
            boxShadow: "0 -".concat(theme.spacing(0.125), " ").concat(theme.spacing(0.75), " 0 rgba(0,0,0,0.1)"),
            padding: theme.spacing(0, 4),
            backgroundColor: theme.palette.background.default
        },
        button: {
            height: theme.spacing(5)
        },
        link: {
            paddingLeft: theme.spacing(2)
        },
        linkText: {
            fontSize: 16,
            color: theme.palette.text.secondary,
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'underline',
            display: 'inline',
            margin: 0,
            padding: 0
        },
        iconButton: {
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark
            }
        }
    });
});

var useStyles$z = makeStyles()(function (theme) { return ({
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
}); });

var PositionType$1;
(function (PositionType) {
    PositionType[PositionType["Fixed"] = 0] = "Fixed";
    PositionType[PositionType["Relative"] = 1] = "Relative";
})(PositionType$1 || (PositionType$1 = {}));
var NUMBER_OF_CHARACTERS = 7;
var BottomNav$1 = function (props) {
    var onClickRightButton = props.onClickRightButton, _a = props.rightButtonDisabled, rightButtonDisabled = _a === void 0 ? false : _a, rightButtonText = props.rightButtonText, secondaryRightButtonText = props.secondaryRightButtonText, _b = props.secondaryRightButtonDisabled, secondaryRightButtonDisabled = _b === void 0 ? false : _b, onClickSecondaryRightButton = props.onClickSecondaryRightButton;
    var classes = useStyles$z().classes;
    return (jsxs(Grid$2, __assign$3({ container: true, justifyContent: "flex-end", alignItems: "center" }, { children: [secondaryRightButtonText && onClickSecondaryRightButton && (jsxs(Button$1, __assign$3({ className: classes.marginLeft, disabled: secondaryRightButtonDisabled, onClick: onClickSecondaryRightButton, variant: ButtonVariant.PrimaryOutlined }, { children: [jsx$1(MuiBox, __assign$3({ display: { xs: 'block', md: 'none' } }, { children: truncate(secondaryRightButtonText, NUMBER_OF_CHARACTERS) })), jsx$1(MuiBox, __assign$3({ display: { xs: 'none', md: 'block' } }, { children: secondaryRightButtonText }))] }))), rightButtonText && onClickRightButton && (jsxs(Button$1, __assign$3({ className: classes.marginLeft, disabled: rightButtonDisabled, onClick: onClickRightButton, variant: ButtonVariant.PrimaryFilled }, { children: [jsx$1(MuiBox, __assign$3({ display: { xs: 'block', md: 'none' } }, { children: truncate(rightButtonText, NUMBER_OF_CHARACTERS) })), jsx$1(MuiBox, __assign$3({ display: { xs: 'none', md: 'block' } }, { children: rightButtonText }))] })))] })));
};

var PositionType;
(function (PositionType) {
    PositionType[PositionType["Fixed"] = 0] = "Fixed";
    PositionType[PositionType["Relative"] = 1] = "Relative";
})(PositionType || (PositionType = {}));
var BottomNav = function (props) {
    var middleButtonText = props.middleButtonText, middleButtonDisabled = props.middleButtonDisabled, middleButtonControl = props.middleButtonControl, onClickRightButton = props.onClickRightButton, onClickMiddleButton = props.onClickMiddleButton, _a = props.position, position = _a === void 0 ? PositionType.Fixed : _a, _b = props.rightButtonDisabled, rightButtonDisabled = _b === void 0 ? false : _b, rightButtonText = props.rightButtonText, secondaryRightButtonText = props.secondaryRightButtonText, _c = props.secondaryRightButtonDisabled, secondaryRightButtonDisabled = _c === void 0 ? false : _c, onClickSecondaryRightButton = props.onClickSecondaryRightButton;
    var positionTypes = new Map([
        [PositionType.Fixed, 'fixed'],
        [PositionType.Relative, 'relative']
    ]);
    var positionString = positionTypes.get(position);
    var styleProps = { position: positionString || 'fixed' };
    var classes = useStyles$A({ styleProps: styleProps }).classes;
    var getMiddleButton = function () {
        if (middleButtonControl) {
            return middleButtonControl;
        }
        if (middleButtonText && onClickMiddleButton) {
            return (jsxs(Fragment$1, { children: [jsx$1(MuiBox, __assign$3({ display: { xs: 'block', md: 'none' } }, { children: jsx$1(IconButton, __assign$3({ disabled: middleButtonDisabled, className: classes.iconButton, onClick: onClickMiddleButton, iconName: IconName.Add, iconSize: IconSize$1.Large, iconColor: IconColor$1.White, ariaLabel: "Add question", hasShadow: true }, { children: middleButtonText })) })), jsx$1(MuiBox, __assign$3({ display: { xs: 'none', md: 'block' } }, { children: jsx$1(Button$1, __assign$3({ disabled: middleButtonDisabled, className: classes.button, onClick: onClickMiddleButton, variant: ButtonVariant.SecondaryFilled }, { children: middleButtonText })) }))] }));
        }
        return null;
    };
    return (jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, justifyContent: "space-between", alignItems: "center", className: classes.grid }, { children: [jsx$1(Grid$2, { container: true, item: true, xs: 5, justifyContent: "flex-start" }), jsx$1(Grid$2, __assign$3({ item: true, container: true, xs: 1, sm: 2, direction: "row", justifyContent: "center", alignItems: "center" }, { children: getMiddleButton() })), jsx$1(Grid$2, __assign$3({ item: true, container: true, xs: 6, sm: 5, justifyContent: "flex-end" }, { children: jsx$1(BottomNav$1, { onClickRightButton: onClickRightButton, rightButtonDisabled: rightButtonDisabled, rightButtonText: rightButtonText, secondaryRightButtonText: secondaryRightButtonText, secondaryRightButtonDisabled: secondaryRightButtonDisabled, onClickSecondaryRightButton: onClickSecondaryRightButton }) }))] })));
};

var useStyles$y = makeStyles()(function (theme) { return ({
    separatorStyle: {
        color: theme.palette.secondary[100]
    },
    buttonNotClickable: {
        textDecoration: 'none',
        textTransform: 'none',
        background: 'none',
        pointerEvents: 'none',
        padding: 0,
        '&:hover': {
            textDecoration: 'none',
            textTransform: 'none',
            background: 'none',
            pointerEvents: 'none'
        }
    },
    buttonClickable: {
        textDecoration: 'none',
        textTransform: 'none',
        background: 'none',
        cursor: 'pointer',
        padding: 0,
        color: theme.palette.secondary.main,
        '&:hover': {
            textDecoration: 'underline',
            textTransform: 'none',
            background: 'none',
            cursor: 'pointer',
            color: theme.palette.secondary.main
        }
    }
}); });

var BreadcrumbLinkVariant;
(function (BreadcrumbLinkVariant) {
    BreadcrumbLinkVariant[BreadcrumbLinkVariant["Selected"] = 0] = "Selected";
    BreadcrumbLinkVariant[BreadcrumbLinkVariant["Selectable"] = 1] = "Selectable";
    BreadcrumbLinkVariant[BreadcrumbLinkVariant["Disabled"] = 2] = "Disabled";
})(BreadcrumbLinkVariant || (BreadcrumbLinkVariant = {}));
var BreadcrumbLink = function (props) {
    var _a, _b;
    var classes = useStyles$y().classes;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var variant = props.variant, children = props.children, onClick = props.onClick;
    var linkButtonClass = new Map([
        [BreadcrumbLinkVariant.Disabled, classes.buttonNotClickable],
        [BreadcrumbLinkVariant.Selectable, classes.buttonClickable],
        [BreadcrumbLinkVariant.Selected, classes.buttonNotClickable]
    ]);
    var linkHighlight = new Map([
        [BreadcrumbLinkVariant.Disabled, TextHighlight.Background],
        [BreadcrumbLinkVariant.Selectable, TextHighlight.Emphasis],
        [BreadcrumbLinkVariant.Selected, TextHighlight.Standard]
    ]);
    var linkWeigth = new Map([
        [BreadcrumbLinkVariant.Disabled, TextWeight.Regular],
        [BreadcrumbLinkVariant.Selectable, TextWeight.Regular],
        [BreadcrumbLinkVariant.Selected, TextWeight.SemiBold]
    ]);
    var selectedButtonClass = linkButtonClass.get(variant);
    var selectedLinkTextWeight = linkWeigth.get(variant);
    var selectedLinkTextHighlight = linkHighlight.get(variant);
    return (jsx$1(Button$3, __assign$3({ disableRipple: true, onClick: onClick, className: selectedButtonClass }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses[(_a = classNameByHighlight.get(selectedLinkTextHighlight !== null && selectedLinkTextHighlight !== void 0 ? selectedLinkTextHighlight : TextHighlight.Background)) !== null && _a !== void 0 ? _a : 'highlightBackground'], textClasses.sizeM, textClasses[(_b = classNameByWeight.get(selectedLinkTextWeight !== null && selectedLinkTextWeight !== void 0 ? selectedLinkTextWeight : TextWeight.Regular)) !== null && _b !== void 0 ? _b : 'weightRegular']) }, { children: children })) })));
};

var Breadcrumbs = function (props) {
    var classes = useStyles$y().classes;
    var options = props.options;
    return (jsx$1(MiuBreadcrumbs, __assign$3({ separator: jsx$1(NavigateNext, { fontSize: "small", className: classes.separatorStyle }) }, { children: options.map(function (option) {
            return (jsx$1(BreadcrumbLink, __assign$3({ variant: option.linkVariant, onClick: option.onClick }, { children: option.name }), option.name));
        }) })));
};

var LinkButton = function (props) {
    var _a;
    var _b, _c, _d;
    var onClick = props.onClick, children = props.children, disabled = props.disabled, _e = props.size, size = _e === void 0 ? TextSize.ms : _e, _f = props.weight, weight = _f === void 0 ? TextWeight.Regular : _f, _g = props.highlight, highlight = _g === void 0 ? TextHighlight.Standard : _g, _h = props.noPadding, noPadding = _h === void 0 ? false : _h, _j = props.alignTextToEnd, alignTextToEnd = _j === void 0 ? false : _j, _k = props.underlined, underlined = _k === void 0 ? false : _k, dataCy = props.dataCy;
    var _l = useStyles$T({}), classes = _l.classes, classNames = _l.cx;
    var textClasses = useTextStyles().classes;
    return (jsx$1(Button$3, __assign$3({ disableRipple: true, disabled: disabled, "aria-label": children === null || children === void 0 ? void 0 : children.toString(), className: classNames([
            classes.linkButton,
            (_a = {},
                _a[classes.linkButtonAlignTextToEnd] = alignTextToEnd,
                _a[classes.linkButtonNoPadding] = noPadding,
                _a)
        ]), onClick: onClick, component: Link$3, role: "link", "data-cy": dataCy }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses[(_b = classNameBySize.get(size)) !== null && _b !== void 0 ? _b : 'sizeMs'], textClasses[(_c = classNameByHighlight.get(highlight)) !== null && _c !== void 0 ? _c : 'highlightStandard'], textClasses[(_d = classNameByWeight.get(weight)) !== null && _d !== void 0 ? _d : 'weightRegular'], underlined
                ? textClasses.underlinedText
                : textClasses.notUnderlinedText, disabled ? classes.linkButtonTextDisabled : classes.linkButtonText) }, { children: children })) })));
};

var useStyles$x = makeStyles()(function (theme) { return ({
    invertedSecondary: {
        backgroundColor: 'white',
        '&:hover': {
            backgroundColor: theme.palette.secondary[50]
        }
    },
    invertedPrimary: {
        backgroundColor: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary[50]
        }
    }
}); });

var FabButton = function (props) {
    var _a, _b;
    var iconName = props.iconName, _c = props.ariaLabel, ariaLabel = _c === void 0 ? 'Fab button' : _c, _d = props.badgeContent, badgeContent = _d === void 0 ? 0 : _d, _e = props.size, size = _e === void 0 ? 'large' : _e, _f = props.iconSize, iconSize = _f === void 0 ? IconSize$1.Large : _f, _g = props.color, color = _g === void 0 ? 'primary' : _g, _h = props.iconColor, iconColor = _h === void 0 ? IconColor$1.White : _h, _j = props.badgeColor, badgeColor = _j === void 0 ? BadgeColor.White : _j, _k = props.disabled, disabled = _k === void 0 ? false : _k, className = props.className, _l = props.inverted, inverted = _l === void 0 ? false : _l, onClick = props.onClick;
    var _m = useStyles$x(), classes = _m.classes, classNames = _m.cx;
    return (jsx$1(MUIFab, __assign$3({ className: className, color: color, size: size, onClick: onClick, disabled: disabled, "aria-label": ariaLabel, classes: {
            primary: classNames((_a = {},
                _a[classes.invertedPrimary] = color === 'primary' && inverted,
                _a)),
            secondary: classNames((_b = {},
                _b[classes.invertedSecondary] = color === 'secondary' && inverted,
                _b))
        } }, { children: jsx$1(Icon, { name: iconName, iconColor: iconColor, badgeContent: badgeContent, size: iconSize, badgeColor: badgeColor, badgeVerticalAnchor: "bottom" }) })));
};

var useStyles$w = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        error: {
            color: theme.palette.error.main
        },
        primary: {
            color: theme.palette.text.secondary
        },
        iconStyle: {
            paddingLeft: props.paddingLeft ? theme.spacing(1) : 0
        },
        warning: {
            color: theme.palette.warning.main
        },
        smallFont: {
            fontSize: '1rem'
        },
        mediumFont: {
            fontSize: '1.25rem'
        },
        largeFont: {
            fontSize: '1.5rem'
        }
    });
});

var IconColor;
(function (IconColor) {
    IconColor[IconColor["Error"] = 0] = "Error";
    IconColor[IconColor["Primary"] = 1] = "Primary";
    IconColor[IconColor["Warning"] = 2] = "Warning";
})(IconColor || (IconColor = {}));
var IconSize;
(function (IconSize) {
    IconSize[IconSize["Small"] = 0] = "Small";
    IconSize[IconSize["Medium"] = 1] = "Medium";
    IconSize[IconSize["Large"] = 2] = "Large";
})(IconSize || (IconSize = {}));
var TooltipPlacement;
(function (TooltipPlacement) {
    TooltipPlacement[TooltipPlacement["Left"] = 0] = "Left";
    TooltipPlacement[TooltipPlacement["Right"] = 1] = "Right";
    TooltipPlacement[TooltipPlacement["Top"] = 2] = "Top";
    TooltipPlacement[TooltipPlacement["Bottom"] = 3] = "Bottom";
})(TooltipPlacement || (TooltipPlacement = {}));
var tooltipPlacementMap = new Map([
    [TooltipPlacement.Left, 'left'],
    [TooltipPlacement.Right, 'right'],
    [TooltipPlacement.Top, 'top'],
    [TooltipPlacement.Bottom, 'bottom']
]);
var InfoIcon$1 = function (props) {
    var className = props.className, _a = props.tooltipPlacement, tooltipPlacement = _a === void 0 ? TooltipPlacement.Right : _a, _b = props.iconColor, iconColor = _b === void 0 ? IconColor.Primary : _b, text = props.text, _c = props.size, size = _c === void 0 ? IconSize.Medium : _c, style = props.style, _d = props.paddingLeft, paddingLeft = _d === void 0 ? true : _d;
    var _e = useStyles$w({
        styleProps: {
            paddingLeft: paddingLeft
        }
    }), classes = _e.classes, classNames = _e.cx;
    var getIconColorFromIconColor = new Map([
        [IconColor.Error, classes.error],
        [IconColor.Primary, classes.primary],
        [IconColor.Warning, classes.warning]
    ]);
    var getIconSizeClassFromIconSize = new Map([
        [IconSize.Small, classes.smallFont],
        [IconSize.Medium, classes.mediumFont],
        [IconSize.Large, classes.largeFont]
    ]);
    var colorCssClass = getIconColorFromIconColor.get(iconColor) || classes.primary;
    var sizeClass = getIconSizeClassFromIconSize.get(size) || classes.mediumFont;
    return (jsx$1(Tooltip$3, __assign$3({ title: text, placement: tooltipPlacementMap.get(tooltipPlacement) }, { children: jsx$1(InfoOutlined, { className: classNames(classes.iconStyle, className, colorCssClass, sizeClass), style: style }) })));
};

var useStyles$v = makeStyles()(function (theme, _a) {
    var color = _a.color;
    return ({
        checkboxLabel: {
            color: theme.palette.text.secondary,
            marginLeft: 0,
            '& span.MuiButtonBase-root': {
                color: color
            }
        },
        root: {
            padding: theme.spacing(1)
        },
        rootGrouped: {
            padding: theme.spacing(0.5)
        },
        noPadding: {
            padding: 0
        },
        errorIcon: {
            padding: theme.spacing(0.25, 0.25, 0.25, 1)
        },
        rootNoWrap: {
            marginRight: 0
        },
        fullWidth: {
            width: '100%'
        },
        labelWidth: {
            width: 'calc(100% - 38.84px)'
        }
    });
});

var _a$1;
var palette$2 = theme.palette;
var TextColors = (_a$1 = {},
    _a$1[TextHighlight.Primary] = palette$2.primary.main,
    _a$1[TextHighlight.Emphasis] = palette$2.secondary.main,
    _a$1[TextHighlight.Background] = palette$2.text.secondary,
    _a$1[TextHighlight.Error] = palette$2.error.main,
    _a$1[TextHighlight.Standard] = palette$2.text.primary,
    _a$1[TextHighlight.Inherit] = 'inherit',
    _a$1);
var Checkbox = function (props) {
    var _a, _b, _c, _d;
    var checked = props.checked, className = props.className, defaultChecked = props.defaultChecked, disabled = props.disabled, label = props.label, ariaLabel = props.ariaLabel, _e = props.noWrap, noWrap = _e === void 0 ? false : _e, onChange = props.onChange, _f = props.isGrouped, isGrouped = _f === void 0 ? false : _f, _g = props.hasError, hasError = _g === void 0 ? false : _g, _h = props.errorText, errorText = _h === void 0 ? '' : _h, _j = props.textSize, textSize = _j === void 0 ? TextSize.ms : _j, _k = props.textHighlight, textHighlight = _k === void 0 ? TextHighlight.Inherit : _k, dataCy = props.dataCy, _l = props.noPadding, noPadding = _l === void 0 ? false : _l, _m = props.color, color = _m === void 0 ? theme.palette.secondary.main : _m;
    var _o = useStyles$v({ color: color }), classes = _o.classes, classNames = _o.cx;
    var labelComponent = (jsx$1("p", __assign$3({ style: {
            fontSize: textSize,
            margin: 0,
            color: hasError ? theme.palette.error.main : TextColors[textHighlight]
        } }, { children: label })));
    return (jsx$1(Tooltip$3, __assign$3({ arrow: true, enterDelay: 750, title: noWrap && label ? label : '', placement: "top" }, { children: jsx$1(FormControlLabel$1, { className: classNames(classes.checkboxLabel, className, (_a = {},
                _a[classes.fullWidth] = noWrap,
                _a)), classes: {
                label: classNames((_b = {}, _b[classes.labelWidth] = noWrap, _b)),
                root: classNames((_c = {}, _c[classes.rootNoWrap] = noWrap, _c))
            }, control: jsx$1(MuiCheckbox, { inputProps: {
                    'aria-label': ariaLabel
                }, defaultChecked: defaultChecked, checked: checked, classes: {
                    root: classNames((_d = {},
                        _d[classes.rootGrouped] = isGrouped && !noPadding,
                        _d[classes.root] = !isGrouped && !noPadding,
                        _d[classes.noPadding] = noPadding,
                        _d))
                }, color: "secondary", disabled: disabled, onChange: onChange, size: "small", "data-testid": "checkbox-data-testid", "data-cy": dataCy }), label: hasError ? (jsxs(Grid$2, __assign$3({ container: true, direction: "row" }, { children: [labelComponent, jsx$1(InfoIcon$1, { className: classes.errorIcon, text: errorText, iconColor: IconColor.Error })] }))) : (labelComponent) }) })));
};

var useStyles$u = makeStyles()(function (theme) { return ({
    icon: {
        padding: theme.spacing(1)
    }
}); });

var shouldShowError = function (allowNoSelection, allFalse) { return allowNoSelection && allFalse; };
var CheckboxGroup = function (props) {
    var children = props.children, _a = props.allowNoSelection, allowNoSelection = _a === void 0 ? true : _a, onChangeAll = props.onChangeAll;
    var classes = useStyles$u().classes;
    var _b = useTextStyles(), textClasses = _b.classes, classNames = _b.cx;
    var checkedArray = React__default.Children.map(children, function (child) {
        var ch = child;
        return ch.props.checked;
    });
    var allFalse = checkedArray !== undefined &&
        checkedArray !== null &&
        checkedArray.every(function (check) { return check === false; });
    var allTrue = checkedArray !== undefined &&
        checkedArray !== null &&
        checkedArray.every(function (check) { return check === true; });
    return (jsxs("div", { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "row", alignItems: "center" }, { children: [jsx$1(LinkButton, __assign$3({ disabled: allTrue, highlight: TextHighlight.Background, onClick: function () {
                            onChangeAll && onChangeAll(true);
                        } }, { children: "Select all" })), jsx$1(LinkButton, __assign$3({ disabled: allFalse, highlight: TextHighlight.Background, onClick: function () {
                            onChangeAll && onChangeAll(false);
                        } }, { children: "Deselect all" })), shouldShowError(allowNoSelection, allFalse) && (jsxs(Fragment$1, { children: [jsx$1(Icon, { name: IconName.InfoOutlinedIcon, iconColor: IconColor$1.Error, size: IconSize$1.Small, className: classes.icon }), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightError, textClasses.sizeS) }, { children: "Please select an option" }))] }))] })), jsx$1("div", { children: children })] }));
};

var useStyles$t = makeStyles()(function (theme) { return ({
    marginBottom: {
        marginBottom: theme.spacing(1)
    },
    marginTop: {
        marginTop: theme.spacing(1)
    },
    paper: {
        backgroundColor: theme.palette.error.light,
        borderLeft: "".concat(theme.spacing(0.25), " solid ").concat(theme.palette.error.main),
        borderRadius: 0,
        boxShadow: 'none',
        elevation: 0,
        padding: theme.spacing(1.5, 0.5, 1.5, 1),
        position: 'absolute',
        top: theme.spacing(8),
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: theme.spacing(62.5)
    }
}); });

var DynamicError = function (props) {
    var title = props.title, body = props.body, onClose = props.onClose;
    var _a = useStyles$t(), classes = _a.classes, theme = _a.theme;
    var _b = useTextStyles(), textClasses = _b.classes, classNames = _b.cx;
    return (jsx$1(Paper$2, __assign$3({ className: classes.paper }, { children: jsx$1(Grid$2, __assign$3({ container: true, spacing: 1 }, { children: jsxs(Grid$2, __assign$3({ item: true, container: true, xs: 12 }, { children: [jsxs(Grid$2, __assign$3({ item: true, xs: true }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.displayBlock, textClasses.highlightError, textClasses.sizeMl, textClasses.alignCenter) }, { children: title })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.displayBlock, textClasses.highlightBackground, textClasses.sizeS, textClasses.alignCenter, classes.marginTop) }, { children: body }))] })), onClose && (jsx$1(Grid$2, __assign$3({ item: true }, { children: jsx$1(IconButton$2, __assign$3({ edge: "start", color: "inherit", onClick: onClose, "aria-label": "close", size: "small" }, { children: jsx$1(Close, { sx: { fontSize: theme.spacing(2) } }) })) })))] })) })) })));
};

var Drawer = function (props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx$1(MuiDrawer, __assign$3({}, props));
};

var useStyles$s = makeStyles()(function (theme) { return ({
    emptyInnerDiv: {
        minHeight: theme.spacing(18)
    },
    emptyOuterDiv: {
        minHeight: theme.spacing(30)
    },
    emptyPaperStyle: {
        width: '100%',
        minHeight: theme.spacing(30)
    }
}); });

var EmptyState = function (props) {
    var onClick = props.onClick, style = props.style, title = props.title, subtitle = props.subtitle, buttonText = props.buttonText, iconName = props.iconName, hasElevation = props.hasElevation;
    var classes = useStyles$s().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsx$1(Paper$2, __assign$3({ className: classes.emptyPaperStyle, style: style, elevation: hasElevation ? 1 : 0 }, { children: jsx$1(Grid$2, __assign$3({ container: true, className: classes.emptyOuterDiv, direction: "column", alignItems: "center", justifyContent: "center" }, { children: jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "column", alignItems: "center", className: classes.emptyInnerDiv, spacing: 2 }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 12 }, { children: jsx$1(Icon, { name: iconName, size: IconSize$1.Large, iconColor: IconColor$1.Background }) })), jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, direction: "column", alignItems: "center" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 12 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeL, textClasses.weightRegular) }, { children: title })) })), jsx$1(Grid$2, __assign$3({ item: true, xs: 12 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeM, textClasses.weightRegular) }, { children: subtitle })) }))] })), buttonText && (jsx$1(Grid$2, __assign$3({ item: true, xs: 12 }, { children: jsx$1(Button$1, __assign$3({ variant: ButtonVariant.PrimaryOutlined, onClick: onClick }, { children: buttonText })) })))] })) })) })));
};

var useStyles$r = makeStyles()(function (theme) { return ({
    divider: {
        width: '25%',
        borderColor: theme.palette.primary.main
    },
    emptyPaperStyle: {
        width: '100%'
    }
}); });

var ErrorPage = function (props) {
    var onClick = props.onClick, style = props.style, errorCode = props.errorCode, title = props.title, subtitle = props.subtitle, contactInfo = props.contactInfo, buttonText = props.buttonText;
    var classes = useStyles$r().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsx$1(Paper$2, __assign$3({ style: style, elevation: 0, className: classes.emptyPaperStyle }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "column", spacing: 5 }, { children: [jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, direction: "column", spacing: 2 }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 5 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeXxl, textClasses.highlightPrimary, textClasses.weightRegular) }, { children: errorCode })) })), jsx$1(Grid$2, __assign$3({ item: true, xs: 5 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeXl, textClasses.highlightStandard, textClasses.weightRegular) }, { children: title })) }))] })), jsx$1(Grid$2, __assign$3({ item: true }, { children: jsx$1(Divider$2, { className: classes.divider }) })), jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, direction: "column", spacing: 2 }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 9 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.highlightStandard, textClasses.weightRegular) }, { children: subtitle })) })), jsx$1(Grid$2, __assign$3({ item: true, xs: 9 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.highlightStandard, textClasses.weightRegular) }, { children: contactInfo })) }))] })), buttonText && (jsx$1(Grid$2, __assign$3({ container: true, item: true }, { children: jsx$1(Button$1, __assign$3({ variant: ButtonVariant.PrimaryFilled, onClick: onClick }, { children: buttonText })) })))] })) })));
};

var Fade = function (props) {
    var children = props.children;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx$1(MuiFade, __assign$3({}, props, { children: jsx$1("div", { children: children }) })));
};

var Box = function (props) {
    var children = props.children;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx$1(MuiBox, __assign$3({}, props, { children: children }));
};

var useStyles$q = makeStyles()(function (theme) {
    var OPACITY = 0.25;
    return {
        primaryColor: {
            backgroundColor: alpha$2(theme.palette.primary.main, OPACITY)
        },
        secondaryColor: {
            backgroundColor: alpha$2(theme.palette.secondary.main, OPACITY)
        },
        textColor: {
            backgroundColor: alpha$2(theme.palette.text.primary, OPACITY)
        },
        backgroundColor: {
            backgroundColor: alpha$2(theme.palette.text.secondary, OPACITY)
        },
        emphasisColor: {
            backgroundColor: alpha$2(theme.palette.secondary.main, OPACITY)
        },
        disabledColor: {
            backgroundColor: alpha$2(theme.palette.text.disabled, OPACITY)
        },
        enabledColor: {
            backgroundColor: alpha$2(theme.palette.success.main, OPACITY)
        },
        errorColor: {
            backgroundColor: alpha$2(theme.palette.error.main, OPACITY)
        },
        warningColor: {
            backgroundColor: alpha$2(theme.palette.warning.main, OPACITY)
        },
        whiteColor: {
            backgroundColor: alpha$2(theme.palette.background.default, OPACITY)
        },
        primaryBarColor: {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 5
        },
        secondaryBarColor: {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: 5
        },
        textBarColor: {
            backgroundColor: theme.palette.text.primary,
            borderRadius: 5
        },
        backgroundBarColor: {
            backgroundColor: theme.palette.text.secondary,
            borderRadius: 5
        },
        emphasisBarColor: {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: 5
        },
        disabledBarColor: {
            backgroundColor: theme.palette.text.disabled,
            borderRadius: 5
        },
        enabledBarColor: {
            backgroundColor: theme.palette.success.main,
            borderRadius: 5
        },
        errorBarColor: {
            backgroundColor: theme.palette.error.main,
            borderRadius: 5
        },
        warningBarColor: {
            backgroundColor: theme.palette.warning.main,
            borderRadius: 5
        },
        whiteBarColor: {
            backgroundColor: theme.palette.background.default,
            borderRadius: 5
        }
    };
});

var LoadingBarColor;
(function (LoadingBarColor) {
    LoadingBarColor[LoadingBarColor["Primary"] = 0] = "Primary";
    LoadingBarColor[LoadingBarColor["Secondary"] = 1] = "Secondary";
    LoadingBarColor[LoadingBarColor["Text"] = 2] = "Text";
    LoadingBarColor[LoadingBarColor["Background"] = 3] = "Background";
    LoadingBarColor[LoadingBarColor["Emphasis"] = 4] = "Emphasis";
    LoadingBarColor[LoadingBarColor["Disabled"] = 5] = "Disabled";
    LoadingBarColor[LoadingBarColor["Enabled"] = 6] = "Enabled";
    LoadingBarColor[LoadingBarColor["Error"] = 7] = "Error";
    LoadingBarColor[LoadingBarColor["Warning"] = 8] = "Warning";
    LoadingBarColor[LoadingBarColor["White"] = 9] = "White";
})(LoadingBarColor || (LoadingBarColor = {}));
var LoadingBar = function (props) {
    var classes = useStyles$q().classes;
    var _a = props.barColor, barColor = _a === void 0 ? LoadingBarColor.Primary : _a, _b = props.isLoading, isLoading = _b === void 0 ? true : _b, _c = props.timeout, timeout = _c === void 0 ? 750 : _c, restOfProps = __rest$1(props, ["barColor", "isLoading", "timeout"]);
    var loadingBarColors = new Map([
        [LoadingBarColor.Primary, classes.primaryBarColor],
        [LoadingBarColor.Secondary, classes.secondaryBarColor],
        [LoadingBarColor.Text, classes.textBarColor],
        [LoadingBarColor.Background, classes.backgroundBarColor],
        [LoadingBarColor.Emphasis, classes.emphasisBarColor],
        [LoadingBarColor.Disabled, classes.disabledBarColor],
        [LoadingBarColor.Enabled, classes.enabledBarColor],
        [LoadingBarColor.Error, classes.errorBarColor],
        [LoadingBarColor.Warning, classes.warningBarColor],
        [LoadingBarColor.White, classes.whiteBarColor]
    ]);
    var loadingColors = new Map([
        [LoadingBarColor.Primary, classes.primaryColor],
        [LoadingBarColor.Secondary, classes.secondaryColor],
        [LoadingBarColor.Text, classes.textColor],
        [LoadingBarColor.Background, classes.backgroundColor],
        [LoadingBarColor.Emphasis, classes.emphasisColor],
        [LoadingBarColor.Disabled, classes.disabledColor],
        [LoadingBarColor.Enabled, classes.enabledColor],
        [LoadingBarColor.Error, classes.errorColor],
        [LoadingBarColor.Warning, classes.warningColor],
        [LoadingBarColor.White, classes.whiteColor]
    ]);
    var loadingBarColorCSS = loadingBarColors.get(barColor);
    var loadingColorCSS = loadingColors.get(barColor);
    return (jsx$1(Collapse$1, __assign$3({ in: isLoading, timeout: timeout }, { children: jsx$1(MuiLinearProgress, __assign$3({ classes: {
                barColorPrimary: loadingBarColorCSS,
                colorPrimary: loadingColorCSS
            }, variant: "indeterminate" }, restOfProps)) })));
};

var InfoPanelItem = React__default.forwardRef(function (props, ref) {
    var children = props.children;
    var classes = useStyles$L().classes;
    return (jsx$1(ListItem$1, __assign$3({ ref: ref, className: classes.listItem }, { children: children })));
});

var useStyles$p = makeStyles()(function () { return ({
    listStyle: {
        width: '100%'
    }
}); });

var List = function (props) {
    var children = props.children, className = props.className, _a = props.canReorderItems, canReorderItems = _a === void 0 ? false : _a, _b = props.droppableId, droppableId = _b === void 0 ? '' : _b, onReorderedItems = props.onReorderedItems;
    var _c = useStyles$p(), classes = _c.classes, classNames = _c.cx;
    var handleDragEnd = function (result) {
        onReorderedItems && onReorderedItems(result);
    };
    return canReorderItems ? (jsx$1(DragDropContext, __assign$3({ onDragEnd: handleDragEnd }, { children: jsx$1(ConnectedDroppable, __assign$3({ droppableId: droppableId }, { children: function (provided) { return (jsxs(MiuList
            // we're using react-beautiful-dnd which requires prop spreading
            /* eslint-disable react/jsx-props-no-spreading */
            , __assign$3({}, provided.droppableProps, { ref: provided.innerRef, disablePadding: true, className: classNames(classes.listStyle, className), component: "ul" }, { children: [children, provided.placeholder] }))); } })) }))) : (jsx$1(MiuList, __assign$3({ disablePadding: true, className: classes.listStyle, component: "ul" }, { children: children })));
};

var modules = {};

var Link$1 = {};

var scrollLink = {};

var scrollSpy$2 = {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$2 = function() {
  return root$2.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$3(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$2(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$3(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_throttle = throttle$1;

var passiveEventListeners = {};

Object.defineProperty(passiveEventListeners, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
passiveEventListeners.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

passiveEventListeners.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

Object.defineProperty(scrollSpy$2, "__esModule", {
  value: true
});

var _lodash = lodash_throttle;

var _lodash2 = _interopRequireDefault$9(_lodash);

var _passiveEventListeners$1 = passiveEventListeners;

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy$1 = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy$1.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy$1.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners$1.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy$1.scrollSpyContainers[scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy$1.currentPositionX(scrollSpyContainer), scrollSpy$1.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy$1.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy$1.scrollSpyContainers[scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy$1.currentPositionX(scrollSpyContainer), scrollSpy$1.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy$1.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy$1.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy$1.spySetState && scrollSpy$1.spySetState.length) {
      scrollSpy$1.spySetState.splice(scrollSpy$1.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy$1.scrollHandler);
  },


  update: function update() {
    return scrollSpy$1.scrollSpyContainers.forEach(function (c) {
      return scrollSpy$1.scrollHandler(c);
    });
  }
};

scrollSpy$2.default = scrollSpy$1;

var scroller$1 = {};

var utils$1 = {};

Object.defineProperty(utils$1, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

utils$1.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

var animateScroll$2 = {};

var smooth = {};

Object.defineProperty(smooth, "__esModule", {
  value: true
});
smooth.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

var cancelEvents = {};

Object.defineProperty(cancelEvents, "__esModule", {
  value: true
});

var _passiveEventListeners = passiveEventListeners;

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

cancelEvents.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

var scrollEvents = {};

Object.defineProperty(scrollEvents, "__esModule", {
	value: true
});

var Events$1 = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events$1.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events$1.registered[evtName] = null;
		}
	}
};

scrollEvents.default = Events$1;

Object.defineProperty(animateScroll$2, "__esModule", {
  value: true
});

var _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils$2 = utils$1;

_interopRequireDefault$8(_utils$2);

var _smooth = smooth;

var _smooth2 = _interopRequireDefault$8(_smooth);

var _cancelEvents = cancelEvents;

var _cancelEvents2 = _interopRequireDefault$8(_cancelEvents);

var _scrollEvents$2 = scrollEvents;

var _scrollEvents2$2 = _interopRequireDefault$8(_scrollEvents$2);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll$1 = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2$2.default.registered['end']) {
      _scrollEvents2$2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  }
  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2$2.default.registered['end']) {
    _scrollEvents2$2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2$2.default.registered['end']) {
      _scrollEvents2$2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll$1.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2$2.default.registered['begin']) {
        _scrollEvents2$2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2$2.default.registered['begin']) {
    _scrollEvents2$2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends$6({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

animateScroll$2.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

Object.defineProperty(scroller$1, "__esModule", {
  value: true
});

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils$1 = utils$1;

var _utils2$1 = _interopRequireDefault$7(_utils$1);

var _animateScroll$1 = animateScroll$2;

var _animateScroll2$1 = _interopRequireDefault$7(_animateScroll$1);

var _scrollEvents$1 = scrollEvents;

var _scrollEvents2$1 = _interopRequireDefault$7(_scrollEvents$1);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

scroller$1.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends$5({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2$1.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2$1.default.registered['begin']) {
        _scrollEvents2$1.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2$1.default.registered['end']) {
        _scrollEvents2$1.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2$1.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

var scrollHash$2 = {};

Object.defineProperty(scrollHash$2, "__esModule", {
  value: true
});

var _utils = utils$1;

var _utils2 = _interopRequireDefault$6(_utils);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash$1 = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

scrollHash$2.default = scrollHash$1;

Object.defineProperty(scrollLink, "__esModule", {
  value: true
});

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$4 = React__default;

var _react2$4 = _interopRequireDefault$5(_react$4);

var _scrollSpy$1 = scrollSpy$2;

var _scrollSpy2$1 = _interopRequireDefault$5(_scrollSpy$1);

var _scroller$2 = scroller$1;

var _scroller2$2 = _interopRequireDefault$5(_scroller$2);

var _propTypes$2 = propTypes.exports;

var _propTypes2$2 = _interopRequireDefault$5(_propTypes$2);

var _scrollHash = scrollHash$2;

var _scrollHash2 = _interopRequireDefault$5(_scrollHash);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes$1 = {
  to: _propTypes2$2.default.string.isRequired,
  containerId: _propTypes2$2.default.string,
  container: _propTypes2$2.default.object,
  activeClass: _propTypes2$2.default.string,
  spy: _propTypes2$2.default.bool,
  horizontal: _propTypes2$2.default.bool,
  smooth: _propTypes2$2.default.oneOfType([_propTypes2$2.default.bool, _propTypes2$2.default.string]),
  offset: _propTypes2$2.default.number,
  delay: _propTypes2$2.default.number,
  isDynamic: _propTypes2$2.default.bool,
  onClick: _propTypes2$2.default.func,
  duration: _propTypes2$2.default.oneOfType([_propTypes2$2.default.number, _propTypes2$2.default.func]),
  absolute: _propTypes2$2.default.bool,
  onSetActive: _propTypes2$2.default.func,
  onSetInactive: _propTypes2$2.default.func,
  ignoreCancelEvents: _propTypes2$2.default.bool,
  hashSpy: _propTypes2$2.default.bool,
  saveHashHistory: _propTypes2$2.default.bool,
  spyThrottle: _propTypes2$2.default.number
};

scrollLink.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2$2.default;

  var Link = function (_React$PureComponent) {
    _inherits$5(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck$5(this, Link);

      var _this = _possibleConstructorReturn$5(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass$5(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2$1.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2$1.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2$1.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2$1.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends$4({}, this.props);

        for (var prop in protoTypes$1) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2$4.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2$4.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends$4({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  Link.propTypes = protoTypes$1;

  Link.defaultProps = { offset: 0 };

  return Link;
};

Object.defineProperty(Link$1, "__esModule", {
  value: true
});

var _react$3 = React__default;

var _react2$3 = _interopRequireDefault$4(_react$3);

var _scrollLink$2 = scrollLink;

var _scrollLink2$2 = _interopRequireDefault$4(_scrollLink$2);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits$4(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$4(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2$3.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn$4(_this, _ret);
  }

  return LinkElement;
}(_react2$3.default.Component);

Link$1.default = (0, _scrollLink2$2.default)(LinkElement);

var Button = {};

Object.defineProperty(Button, "__esModule", {
  value: true
});

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$2 = React__default;

var _react2$2 = _interopRequireDefault$3(_react$2);

var _scrollLink$1 = scrollLink;

var _scrollLink2$1 = _interopRequireDefault$3(_scrollLink$1);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits$3(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck$3(this, ButtonElement);

    return _possibleConstructorReturn$3(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass$4(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2$2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2$2.default.Component);

Button.default = (0, _scrollLink2$1.default)(ButtonElement);

var Element$3 = {};

var scrollElement = {};

Object.defineProperty(scrollElement, "__esModule", {
  value: true
});

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1 = React__default;

var _react2$1 = _interopRequireDefault$2(_react$1);

var _reactDom = ReactDOM__default;

_interopRequireDefault$2(_reactDom);

var _scroller$1 = scroller$1;

var _scroller2$1 = _interopRequireDefault$2(_scroller$1);

var _propTypes$1 = propTypes.exports;

var _propTypes2$1 = _interopRequireDefault$2(_propTypes$1);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

scrollElement.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits$2(Element, _React$Component);

    function Element(props) {
      _classCallCheck$2(this, Element);

      var _this = _possibleConstructorReturn$2(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass$3(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2$1.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2$1.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2$1.default.createElement(Component, _extends$3({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2$1.default.Component);

  Element.propTypes = {
    name: _propTypes2$1.default.string,
    id: _propTypes2$1.default.string
  };

  return Element;
};

Object.defineProperty(Element$3, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _react2 = _interopRequireDefault$1(_react);

var _scrollElement$1 = scrollElement;

var _scrollElement2$1 = _interopRequireDefault$1(_scrollElement$1);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault$1(_propTypes);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits$1(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck$1(this, ElementWrapper);

    return _possibleConstructorReturn$1(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass$2(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends$2({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends$2({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

Element$3.default = (0, _scrollElement2$1.default)(ElementWrapper);

/* DEPRECATED */

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = React__default;
var scrollSpy = scrollSpy$2;
var defaultScroller = scroller$1;
var PropTypes = propTypes.exports;
var scrollHash = scrollHash$2;

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass$1(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends$1({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends$1({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass$1(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends$1({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

var Helpers_1 = Helpers;

Object.defineProperty(modules, "__esModule", {
  value: true
});
modules.Helpers = modules.ScrollElement = modules.ScrollLink = animateScroll = modules.animateScroll = modules.scrollSpy = Events = modules.Events = scroller = modules.scroller = Element$2 = modules.Element = modules.Button = Link = modules.Link = undefined;

var _Link = Link$1;

var _Link2 = _interopRequireDefault(_Link);

var _Button = Button;

var _Button2 = _interopRequireDefault(_Button);

var _Element = Element$3;

var _Element2 = _interopRequireDefault(_Element);

var _scroller = scroller$1;

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = scrollEvents;

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = scrollSpy$2;

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = animateScroll$2;

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = scrollLink;

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = scrollElement;

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = Helpers_1;

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = modules.Link = _Link2.default;
modules.Button = _Button2.default;
var Element$2 = modules.Element = _Element2.default;
var scroller = modules.scroller = _scroller2.default;
var Events = modules.Events = _scrollEvents2.default;
modules.scrollSpy = _scrollSpy2.default;
var animateScroll = modules.animateScroll = _animateScroll2.default;
modules.ScrollLink = _scrollLink2.default;
modules.ScrollElement = _scrollElement2.default;
modules.Helpers = _Helpers2.default;
modules.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

var visibilitySensor = {exports: {}};

(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(React__default, ReactDOM__default);
})(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(5)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value; // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.

  switch (offsetDir) {
    case 'top':
      return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;

    case 'left':
      return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;

    case 'bottom':
      return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;

    case 'right':
      return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VisibilitySensor; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function normalizeRect(rect) {
  if (rect.width === undefined) {
    rect.width = rect.right - rect.left;
  }

  if (rect.height === undefined) {
    rect.height = rect.bottom - rect.top;
  }

  return rect;
}

var VisibilitySensor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VisibilitySensor, _React$Component);

  function VisibilitySensor(props) {
    var _this;

    _classCallCheck(this, VisibilitySensor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VisibilitySensor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getContainer", function () {
      return _this.props.containment || window;
    });

    _defineProperty(_assertThisInitialized(_this), "addEventListener", function (target, event, delay, throttle) {
      if (!_this.debounceCheck) {
        _this.debounceCheck = {};
      }

      var timeout;
      var func;

      var later = function later() {
        timeout = null;

        _this.check();
      };

      if (throttle > -1) {
        func = function func() {
          if (!timeout) {
            timeout = setTimeout(later, throttle || 0);
          }
        };
      } else {
        func = function func() {
          clearTimeout(timeout);
          timeout = setTimeout(later, delay || 0);
        };
      }

      var info = {
        target: target,
        fn: func,
        getLastTimeout: function getLastTimeout() {
          return timeout;
        }
      };
      target.addEventListener(event, info.fn);
      _this.debounceCheck[event] = info;
    });

    _defineProperty(_assertThisInitialized(_this), "startWatching", function () {
      if (_this.debounceCheck || _this.interval) {
        return;
      }

      if (_this.props.intervalCheck) {
        _this.interval = setInterval(_this.check, _this.props.intervalDelay);
      }

      if (_this.props.scrollCheck) {
        _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
      }

      if (_this.props.resizeCheck) {
        _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
      } // if dont need delayed call, check on load ( before the first interval fires )


      !_this.props.delayedCall && _this.check();
    });

    _defineProperty(_assertThisInitialized(_this), "stopWatching", function () {
      if (_this.debounceCheck) {
        // clean up event listeners and their debounce callers
        for (var debounceEvent in _this.debounceCheck) {
          if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
            var debounceInfo = _this.debounceCheck[debounceEvent];
            clearTimeout(debounceInfo.getLastTimeout());
            debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
            _this.debounceCheck[debounceEvent] = null;
          }
        }
      }

      _this.debounceCheck = null;

      if (_this.interval) {
        _this.interval = clearInterval(_this.interval);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "check", function () {
      var el = _this.node;
      var rect;
      var containmentRect; // if the component has rendered to null, dont update visibility

      if (!el) {
        return _this.state;
      }

      rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));

      if (_this.props.containment) {
        var containmentDOMRect = _this.props.containment.getBoundingClientRect();

        containmentRect = {
          top: containmentDOMRect.top,
          left: containmentDOMRect.left,
          bottom: containmentDOMRect.bottom,
          right: containmentDOMRect.right
        };
      } else {
        containmentRect = {
          top: 0,
          left: 0,
          bottom: window.innerHeight || document.documentElement.clientHeight,
          right: window.innerWidth || document.documentElement.clientWidth
        };
      } // Check if visibility is wanted via offset?


      var offset = _this.props.offset || {};
      var hasValidOffset = _typeof(offset) === "object";

      if (hasValidOffset) {
        containmentRect.top += offset.top || 0;
        containmentRect.left += offset.left || 0;
        containmentRect.bottom -= offset.bottom || 0;
        containmentRect.right -= offset.right || 0;
      }

      var visibilityRect = {
        top: rect.top >= containmentRect.top,
        left: rect.left >= containmentRect.left,
        bottom: rect.bottom <= containmentRect.bottom,
        right: rect.right <= containmentRect.right
      }; // https://github.com/joshwnj/react-visibility-sensor/pull/114

      var hasSize = rect.height > 0 && rect.width > 0;
      var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right; // check for partial visibility

      if (hasSize && _this.props.partialVisibility) {
        var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left; // account for partial visibility on a single edge

        if (typeof _this.props.partialVisibility === "string") {
          partialVisible = visibilityRect[_this.props.partialVisibility];
        } // if we have minimum top visibility set by props, lets check, if it meets the passed value
        // so if for instance element is at least 200px in viewport, then show it.


        isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
      } // Deprecated options for calculating offset.


      if (typeof offset.direction === "string" && typeof offset.value === "number") {
        console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset.direction, offset.value);
        isVisible = _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default()(offset, rect, containmentRect);
      }

      var state = _this.state; // notify the parent when the value changes

      if (_this.state.isVisible !== isVisible) {
        state = {
          isVisible: isVisible,
          visibilityRect: visibilityRect
        };

        _this.setState(state);

        if (_this.props.onChange) _this.props.onChange(isVisible);
      }

      return state;
    });

    _this.state = {
      isVisible: null,
      visibilityRect: {}
    };
    return _this;
  }

  _createClass(VisibilitySensor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);

      if (this.props.active) {
        this.startWatching();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopWatching();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // re-register node in componentDidUpdate if children diffs [#103]
      this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);

      if (this.props.active && !prevProps.active) {
        this.setState({
          isVisible: null,
          visibilityRect: {}
        });
        this.startWatching();
      } else if (!this.props.active) {
        this.stopWatching();
      }
    }
  }, {
    key: "roundRectDown",
    value: function roundRectDown(rect) {
      return {
        top: Math.floor(rect.top),
        left: Math.floor(rect.left),
        bottom: Math.floor(rect.bottom),
        right: Math.floor(rect.right)
      };
    }
    /**
     * Check if the element is within the visible viewport
     */

  }, {
    key: "render",
    value: function render() {
      if (this.props.children instanceof Function) {
        return this.props.children({
          isVisible: this.state.isVisible,
          visibilityRect: this.state.visibilityRect
        });
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
    }
  }]);

  return VisibilitySensor;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

_defineProperty(VisibilitySensor, "defaultProps", {
  active: true,
  partialVisibility: false,
  minTopValue: 0,
  scrollCheck: false,
  scrollDelay: 250,
  scrollThrottle: -1,
  resizeCheck: false,
  resizeDelay: 250,
  resizeThrottle: -1,
  intervalCheck: true,
  intervalDelay: 100,
  delayedCall: false,
  offset: {},
  containment: null,
  children: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null)
});

_defineProperty(VisibilitySensor, "propTypes", {
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  active: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  partialVisibility: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(["top", "right", "bottom", "left"])]),
  delayedCall: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  offset: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    top: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    left: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    bottom: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    right: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
  }), // deprecated offset property
  prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    direction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(["top", "right", "bottom", "left"]),
    value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
  })]),
  scrollCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  scrollDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  scrollThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  resizeCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  resizeDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  resizeThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  intervalCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  containment: typeof window !== "undefined" ? prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(window.Element) : prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func]),
  minTopValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
});



/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(6);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })
/******/ ]);
});
}(visibilitySensor));

var VizSensor = /*@__PURE__*/getDefaultExportFromCjs(visibilitySensor.exports);

var useStyles$o = makeStyles()(function () { return ({
    linkComponentStyle: {
        width: '100%'
    }
}); });

var ScrollToBottom = function () {
    animateScroll.scrollToBottom();
};
var ScrollLink = function (props) {
    var children = props.children, _a = props.duration, duration = _a === void 0 ? 500 : _a, _b = props.offset, offset = _b === void 0 ? 0 : _b, containerId = props.containerId, to = props.to;
    var classes = useStyles$o().classes;
    return (jsx$1(Link, __assign$3({ duration: duration, offset: offset, smooth: true, containerId: containerId, spy: true, to: to, className: classes.linkComponentStyle }, { children: children })));
};
var ScrollElement = function (props) {
    var children = props.children, elementId = props.elementId, onScrollEnd = props.onScrollEnd, onChangeVisible = props.onChangeVisible, partialVisibility = props.partialVisibility, offset = props.offset, minTopValue = props.minTopValue, _a = props.containment, containment = _a === void 0 ? null : _a;
    useEffect(function () {
        Events.scrollEvent.register('end', function (to, element) {
            if (onScrollEnd) {
                onScrollEnd(to, element);
            }
        });
        // The next line cleans ups to prevent memory leaks
        return function cleanup() {
            Events.scrollEvent.remove('end');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (jsx$1(VizSensor, __assign$3({ delayedCall: true, partialVisibility: partialVisibility, offset: offset, minTopValue: minTopValue, intervalCheck: true, intervalDelay: 200, containment: containment, onChange: function (isVisible) {
            if (onChangeVisible) {
                onChangeVisible(isVisible);
            }
        } }, { children: jsx$1(Element$2, __assign$3({ name: "".concat(elementId) }, { children: children })) })));
};
var ScrollTo = function (elementId, containerId, smooth, isDynamic, offset) {
    if (smooth === void 0) { smooth = true; }
    if (isDynamic === void 0) { isDynamic = true; }
    if (offset === void 0) { offset = 0; }
    scroller.scrollTo(elementId, {
        smooth: smooth,
        containerId: containerId,
        isDynamic: isDynamic,
        offset: offset
    });
};

var RoType;
(function (RoType) {
    RoType[RoType["RoDouble"] = 0] = "RoDouble";
    RoType[RoType["RoInt"] = 1] = "RoInt";
    RoType[RoType["RoLink"] = 2] = "RoLink";
    RoType[RoType["RoString"] = 3] = "RoString";
})(RoType || (RoType = {}));
var TextEntryState;
(function (TextEntryState) {
    TextEntryState["TextEntryEnabled"] = "TextEntryEnabled";
    TextEntryState["TextEntryDisabled"] = "TextEntryDisabled";
})(TextEntryState || (TextEntryState = {}));

var palette$1 = theme.palette, typography$1 = theme.typography;
var menuItemTextRegular$1 = {
    fontFamily: typography$1.fontFamily,
    fontSize: typography$1.body1.fontSize,
    fontWeight: typography$1.fontWeightRegular,
    color: palette$1.text.secondary,
    textAlign: typography$1.body1.textAlign,
    margin: 0,
    lineHeight: 1.5
};
var useStyles$n = makeStyles()(function (theme) { return ({
    endOfSurveyOption: {
        paddingRight: theme.spacing(1.5)
    },
    menu: {
        maxHeight: 200,
        padding: theme.spacing(1, 1, 1, 3),
        border: "1px solid ".concat(palette$1.divider),
        overflow: 'auto'
    },
    endOfSurveyContainer: {
        padding: theme.spacing(1, 1, 1, 3),
        borderLeft: "1px solid ".concat(palette$1.divider),
        borderBottom: "1px solid ".concat(palette$1.divider),
        borderRight: "1px solid ".concat(palette$1.divider)
    },
    menuItem: {
        cursor: 'pointer',
        minWidth: 300,
        overflow: 'hidden'
    },
    menuItemText: {
        maxWidth: '438px'
    },
    menuItemTextRegular: menuItemTextRegular$1,
    menuItemNumber: {
        paddingRight: theme.spacing(3.5),
        width: theme.spacing(2.5)
    },
    menuItemTextSemiBold: __assign$3(__assign$3({}, menuItemTextRegular$1), { fontWeight: 'bolder' }),
    dialogHeader: __assign$3(__assign$3({}, menuItemTextRegular$1), { marginBottom: theme.spacing(2.5) })
}); });

var useStyles$m = makeStyles()(function (theme) { return ({
    radioStyle: {
        color: theme.palette.text.secondary,
        '& span.MuiButtonBase-root': {
            color: theme.palette.secondary.main
        }
    },
    condensed: {
        padding: theme.spacing(0.5)
    }
}); });

var Radio = function (props) {
    var checked = props.checked, disabled = props.disabled, _a = props.label, label = _a === void 0 ? '' : _a, onChange = props.onChange, dataCy = props.dataCy, _b = props.condensed, condensed = _b === void 0 ? false : _b;
    var classes = useStyles$m().classes;
    return (jsx$1(FormControlLabel$1, { value: "end", control: jsx$1(MuiRadio, { "data-cy": dataCy, checked: checked, color: "secondary", disabled: disabled, onChange: onChange, "data-testid": "radio-data-testid", size: "small", classes: {
                root: condensed ? classes.condensed : undefined
            } }), className: classes.radioStyle, label: label }));
};

var truncateText$1 = function (text) {
    if (text && text.length > 66) {
        var start = text.slice(0, 32);
        var end = text.slice(text.length - 31, text.length);
        return "".concat(start, "...").concat(end);
    }
    return text || '';
};

var EntryType$1;
(function (EntryType) {
    EntryType["QuestionEntryType"] = "QuestionEntryType";
    EntryType["TextCardEntryType"] = "TextCardEntryType";
    EntryType["MatrixEntryType"] = "MatrixEntryType";
    EntryType["ForkEntryType"] = "ForkEntryType";
    EntryType["StandardAudience"] = "Standard";
    EntryType["CustomAudience"] = "Custom";
})(EntryType$1 || (EntryType$1 = {}));
var FieldworkAudienceType;
(function (FieldworkAudienceType) {
    FieldworkAudienceType["Interlock"] = "Interlock";
    FieldworkAudienceType["Standard"] = "Standard";
    FieldworkAudienceType["Custom"] = "Custom";
})(FieldworkAudienceType || (FieldworkAudienceType = {}));
var QuestionsDialogDialog = function (props) {
    var title = props.title, dialogHeader = props.dialogHeader, primaryButtonText = props.primaryButtonText, endOfSurveyNumber = props.endOfSurveyNumber, showEndOfSurvey = props.showEndOfSurvey, isQuestionDialogOpen = props.isQuestionDialogOpen, questionDialogItems = props.questionDialogItems, onSelectQuestionDialogItem = props.onSelectQuestionDialogItem, onQuestionDialogClose = props.onQuestionDialogClose;
    var _a = useStyles$n(), classes = _a.classes, classNames = _a.cx;
    // TODO rename
    var _b = useState(null), questionItemSelection = _b[0], setQuestionItemSelection = _b[1];
    var handlePrimaryButtonClick = function () {
        if (onSelectQuestionDialogItem && questionItemSelection) {
            onSelectQuestionDialogItem(questionItemSelection.selectedMenuItemNumber, questionItemSelection.index);
            onQuestionDialogClose();
        }
    };
    var getEntryPrefix = function (entryType) {
        switch (entryType) {
            case EntryType$1.TextCardEntryType:
                return 'T';
            case EntryType$1.StandardAudience:
            case EntryType$1.CustomAudience:
                return 'A';
            default:
                return 'Q';
        }
    };
    var getDialogItems = function (questionDialogItems, isRoutingMenuEmpty) {
        return (questionDialogItems &&
            questionDialogItems.map(function (menuItem, index) {
                return (jsx$1(Radio, { condensed: true, onChange: function () {
                        setQuestionItemSelection({
                            selectedMenuItemNumber: menuItem.number,
                            index: index
                        });
                    }, checked: (questionItemSelection === null || questionItemSelection === void 0 ? void 0 : questionItemSelection.selectedMenuItemNumber) ===
                        menuItem.number && (questionItemSelection === null || questionItemSelection === void 0 ? void 0 : questionItemSelection.index) === index, label: jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "flex-start", alignContent: "flex-start", className: classes.menuItem }, { children: [!isRoutingMenuEmpty && (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.menuItemNumber }, { children: jsxs("p", __assign$3({ className: classes.menuItemTextSemiBold }, { children: [getEntryPrefix(menuItem.entryType), menuItem.contextPosition + 1] })) }))), jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.menuItemText }, { children: jsx$1("p", __assign$3({ className: classes.menuItemTextRegular }, { children: truncateText$1(menuItem.text) })) }))] }), "menu-item-".concat(menuItem.id)) }, menuItem.id));
            }));
    };
    var isRoutingMenuEmpty = (questionDialogItems === null || questionDialogItems === void 0 ? void 0 : questionDialogItems.length) === 0;
    var menuItems = isQuestionDialogOpen &&
        getDialogItems(questionDialogItems, isRoutingMenuEmpty);
    return (jsxs(Dialog, __assign$3({ title: title, primaryButtonText: primaryButtonText, fullWidth: true, open: isQuestionDialogOpen, onClose: onQuestionDialogClose, primaryButtonClick: handlePrimaryButtonClick }, { children: [dialogHeader && jsx$1("p", __assign$3({ className: classes.dialogHeader }, { children: dialogHeader })), jsx$1("div", __assign$3({ className: classes.menu }, { children: menuItems })), endOfSurveyNumber !== undefined &&
                (showEndOfSurvey ||
                    (!isRoutingMenuEmpty && showEndOfSurvey !== false)) && (jsx$1("div", __assign$3({ className: classes.endOfSurveyContainer }, { children: jsx$1(Radio, { condensed: true, onChange: function () {
                        setQuestionItemSelection({
                            selectedMenuItemNumber: endOfSurveyNumber,
                            index: null
                        });
                    }, checked: (questionItemSelection === null || questionItemSelection === void 0 ? void 0 : questionItemSelection.selectedMenuItemNumber) ===
                        endOfSurveyNumber, label: jsxs(Grid$2, __assign$3({ container: true, direction: "column", className: classNames(classes.menuItem, classes.endOfSurveyOption) }, { children: [jsx$1("p", __assign$3({ className: classes.menuItemTextSemiBold }, { children: "End of survey" })), jsx$1("p", __assign$3({ className: classes.menuItemTextRegular }, { children: "Route to end of survey" }))] })) }) })))] })));
};

var useStyles$l = makeStyles()(function (theme) { return ({
    label: {
        paddingRight: theme.spacing(1),
        color: theme.palette.text.secondary
    },
    labelPlacementStart: {
        marginLeft: 0
    },
    switchBase: {
        color: additionalPalette.grey.main
    },
    track: {
        '& span.MuiSwitch-track': {
            backgroundColor: additionalPalette.lightGrey.main
        }
    },
    formControl: {
        margin: theme.spacing(0, 2)
    },
    first: {
        marginLeft: 0
    },
    last: {
        marginRight: 0
    }
}); });

var Switch = function (props) {
    var defaultChecked = props.defaultChecked, checked = props.checked, disabled = props.disabled, _a = props.ariaLabel, ariaLabel = _a === void 0 ? 'Switch' : _a, _b = props.label, label = _b === void 0 ? '' : _b, onChange = props.onChange, _c = props.first, first = _c === void 0 ? false : _c, _d = props.last, last = _d === void 0 ? false : _d;
    var _e = useStyles$l(), classes = _e.classes, classNames = _e.cx;
    return (jsx$1(FormControlLabel$1, { labelPlacement: "start", className: classNames(classes.formControl, first ? classes.first : undefined, last ? classes.last : undefined), control: jsx$1(MuiSwitch, { color: "secondary", size: "small", inputProps: {
                'aria-label': ariaLabel || label
            }, defaultChecked: defaultChecked, checked: checked, disabled: disabled, onChange: onChange, "data-testid": "switch-data-testid", classes: {
                switchBase: classes.switchBase
            }, className: classes.track }), label: label, classes: {
            label: classes.label,
            labelPlacementStart: classes.labelPlacementStart
        } }));
};

var KebabMenuIconPosition;
(function (KebabMenuIconPosition) {
    KebabMenuIconPosition[KebabMenuIconPosition["Left"] = 0] = "Left";
    KebabMenuIconPosition[KebabMenuIconPosition["Right"] = 1] = "Right";
})(KebabMenuIconPosition || (KebabMenuIconPosition = {}));

var useStyles$k = makeStyles()(function (theme, _a) {
    var iconPosition = _a.iconPosition;
    return ({
        customMenuItem: {
            padding: theme.spacing(0.25, 0, 0.25, 0),
            minWidth: theme.spacing(24),
            '&:hover': {
                color: theme.palette.primary.main
            }
        },
        list: {
            padding: theme.spacing(0.25, 0, 0.25, 0)
        },
        option: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: 'transparent',
                color: 'inherit'
            }
        },
        optionItem: {
            color: 'inherit'
        },
        iconStyle: {
            color: 'inherit',
            marginRight: iconPosition === KebabMenuIconPosition.Right
                ? theme.spacing(0)
                : theme.spacing(1)
        },
        kebabIcon: {
            width: theme.spacing(4),
            height: theme.spacing(4)
        },
        iconText: {
            fontSize: '0.875rem',
            fontWeight: 600,
            color: '#376273',
            padding: "".concat(theme.spacing(0.5), " ").concat(theme.spacing(1))
        }
    });
});

var KebabMenuItem = React__default.forwardRef(function (props, ref) {
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    var classes = props.classes, kebabMenuOption = props.kebabMenuOption, onClickClosing = props.onClickClosing, iconPosition = props.iconPosition;
    var textItem = kebabMenuOption.textItem, iconName = kebabMenuOption.iconName, _b = kebabMenuOption.iconSize, iconSize = _b === void 0 ? IconSize$1.Medium : _b, _c = kebabMenuOption.disabled, disabled = _c === void 0 ? false : _c, _d = kebabMenuOption.hasDivider, hasDivider = _d === void 0 ? false : _d, onClickItem = kebabMenuOption.onClickItem;
    var stopPropagation = function (event) {
        event.stopPropagation();
    };
    var menuItemIcon = iconName && (jsx$1(Icon, { name: iconName, iconColor: IconColor$1.Emphasis, size: iconSize, className: classes.iconStyle }));
    return (jsxs(Fragment$1, { children: [jsx$1(Grid$2, __assign$3({ ref: ref, className: classes.customMenuItem }, { children: jsx$1(MuiMenuItem, __assign$3({ onClick: function (event) {
                        onClickItem && onClickItem();
                        onClickClosing && onClickClosing(event);
                        stopPropagation(event);
                    }, classes: { root: classes.option }, disabled: disabled }, { children: jsxs(Grid$2, __assign$3({ container: true, className: classes.option, alignItems: "start", justifyContent: iconPosition === KebabMenuIconPosition.Left
                            ? 'flex-start'
                            : 'space-between' }, { children: [iconPosition === KebabMenuIconPosition.Left && menuItemIcon, jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.sizeMs, textClasses.highlightEmphasis, textClasses.noWrap, classes.optionItem) }, { children: textItem })), iconPosition === KebabMenuIconPosition.Right && menuItemIcon] })) }), "menu-item-".concat(textItem)) })), hasDivider && jsx$1(Divider$2, {})] }));
});

var KebabMenu = function (props) {
    var _a;
    var kebabMenuOptions = props.kebabMenuOptions, text = props.text, _b = props.iconColor, iconColor = _b === void 0 ? IconColor$1.Emphasis : _b, _c = props.iconPosition, iconPosition = _c === void 0 ? KebabMenuIconPosition.Right : _c, _d = props.horizontal, horizontal = _d === void 0 ? false : _d, tooltipText = props.tooltipText, menuButton = props.menuButton, _e = props.anchorOrigin, anchorOrigin = _e === void 0 ? {
        vertical: 'bottom',
        horizontal: 'right'
    } : _e, _f = props.transformOrigin, transformOrigin = _f === void 0 ? {
        vertical: 'top',
        horizontal: 'right'
    } : _f;
    var _g = useStyles$k({ iconPosition: iconPosition }), classes = _g.classes, classNames = _g.cx;
    var _h = React__default.useState(null), anchorEl = _h[0], setAnchorEl = _h[1];
    var handleMenuButtonClick = function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        stopPropagation(event);
    };
    var stopPropagation = function (event) {
        event.stopPropagation();
    };
    var handleClose = function (event) {
        stopPropagation(event);
        setAnchorEl(null);
    };
    var textComponent = text && jsx$1("span", __assign$3({ className: classes.iconText }, { children: text }));
    var iconName = horizontal ? IconName.MoreHoriz : IconName.MoreVert;
    var newMenuButton;
    if (menuButton) {
        newMenuButton = React__default.cloneElement(menuButton, {
            onClick: handleMenuButtonClick
        });
    }
    var shouldBeOpened = Boolean(anchorEl);
    var menuItems = shouldBeOpened &&
        kebabMenuOptions.map(function (kebabMenuOption) {
            return (jsx$1(KebabMenuItem, { kebabMenuOption: kebabMenuOption, classes: classes, onClickClosing: handleClose, iconPosition: iconPosition }, "menu-item-".concat(kebabMenuOption.id)));
        });
    return (jsxs(Fragment$1, { children: [newMenuButton || (jsx$1(IconButton, { iconName: iconName, iconSize: IconSize$1.Large, iconColor: iconColor, ariaLabel: "Icon kebab", onClick: handleMenuButtonClick, className: classNames((_a = {}, _a[classes.kebabIcon] = !text, _a)), text: textComponent, size: "small", tooltipText: tooltipText })), jsx$1(MuiMenu, __assign$3({ id: "customized-menu", anchorEl: anchorEl, open: shouldBeOpened, onClose: handleClose, color: "secondary", classes: { list: classes.list }, elevation: 1, 
                // getContentAnchorEl={null}
                anchorOrigin: anchorOrigin, transformOrigin: transformOrigin }, { children: menuItems }))] }));
};

var TipPlacement;
(function (TipPlacement) {
    TipPlacement[TipPlacement["BottomEnd"] = 0] = "BottomEnd";
    TipPlacement[TipPlacement["BottomStart"] = 1] = "BottomStart";
    TipPlacement[TipPlacement["Bottom"] = 2] = "Bottom";
    TipPlacement[TipPlacement["LeftEnd"] = 3] = "LeftEnd";
    TipPlacement[TipPlacement["LeftStart"] = 4] = "LeftStart";
    TipPlacement[TipPlacement["Left"] = 5] = "Left";
    TipPlacement[TipPlacement["RightEnd"] = 6] = "RightEnd";
    TipPlacement[TipPlacement["RightStart"] = 7] = "RightStart";
    TipPlacement[TipPlacement["Right"] = 8] = "Right";
    TipPlacement[TipPlacement["TopEnd"] = 9] = "TopEnd";
    TipPlacement[TipPlacement["TopStart"] = 10] = "TopStart";
    TipPlacement[TipPlacement["Top"] = 11] = "Top";
})(TipPlacement || (TipPlacement = {}));
var Tooltip$1 = function (props) {
    var children = props.children, title = props.title, tipPlacement = props.tipPlacement, open = props.open, _a = props.disableInteractive, disableInteractive = _a === void 0 ? true : _a, onOpen = props.onOpen, onClose = props.onClose;
    var placementStringsMap = new Map([
        [TipPlacement.BottomEnd, 'bottom-end'],
        [TipPlacement.BottomStart, 'bottom-start'],
        [TipPlacement.Bottom, 'bottom'],
        [TipPlacement.LeftEnd, 'left-end'],
        [TipPlacement.LeftStart, 'left-start'],
        [TipPlacement.Left, 'left'],
        [TipPlacement.RightEnd, 'right-end'],
        [TipPlacement.RightStart, 'right-start'],
        [TipPlacement.Right, 'right'],
        [TipPlacement.TopEnd, 'top-end'],
        [TipPlacement.TopStart, 'top-start'],
        [TipPlacement.Top, 'top']
    ]);
    var placementString = placementStringsMap.get(tipPlacement);
    return (jsx$1(Tooltip$3, __assign$3({ open: open, onOpen: onOpen, onClose: onClose, title: title, placement: placementString, disableInteractive: disableInteractive }, { children: jsx$1("div", { children: children }) })));
};

var palette = theme.palette, typography = theme.typography;
var menuItemTextRegular = {
    fontFamily: typography.fontFamily,
    fontSize: typography.body1.fontSize,
    fontWeight: typography.fontWeightRegular,
    color: palette.text.secondary,
    textAlign: typography.body1.textAlign,
    margin: 0,
    lineHeight: 1.5
};
var useStyles$j = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        grid: {
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            width: '100%'
        },
        gridItem: {
            margin: 0,
            flexBasis: '100%'
        },
        gridItemXs: {
            margin: 0,
            flexBasis: '0',
            maxWidth: '100%',
            flexGrow: '1'
        },
        gridItemXsAutoCentered: {
            margin: 0,
            flexBasis: 'auto',
            flexGrow: '0',
            width: 'auto',
            maxWidth: 'none',
            justifyContent: 'center',
            alignItems: 'center'
        },
        listItem: {
            paddingTop: theme.spacing(0.75),
            paddingBottom: theme.spacing(0.75)
        },
        dragHandle: {
            cursor: 'grab'
        },
        errorIcon: {
            marginLeft: theme.spacing(1)
        },
        greenBackground: {
            background: additionalPalette.green.main
        },
        enterAdornment: {
            width: theme.spacing(7)
        },
        enterAdornmentIcon: {
            marginTop: theme.spacing(1.5),
            marginLeft: theme.spacing(0.5)
        },
        endOfSurveyOption: {
            paddingRight: theme.spacing(1.5)
        },
        iconButton: {
            padding: theme.spacing(0.5)
        },
        inputStyle: {
            paddingRight: theme.spacing(1.5),
            '& input.MuiInputBase-input': {
                padding: theme.spacing(1.25, 2),
                fontSize: theme.typography.subtitle2.fontSize,
                color: theme.palette.text.secondary
            },
            borderRadius: theme.spacing(0.25)
        },
        inputRootStyle: {
            marginRight: (props === null || props === void 0 ? void 0 : props.inputMarginRight)
                ? theme.spacing(props === null || props === void 0 ? void 0 : props.inputMarginRight)
                : 0,
            '&.MuiOutlinedInput-root > fieldset': {
                borderColor: (props === null || props === void 0 ? void 0 : props.isError)
                    ? theme.palette.error.main
                    : additionalPalette.lightBlue.secondary
            },
            '&.MuiOutlinedInput-root:hover > fieldset': {
                borderColor: (props === null || props === void 0 ? void 0 : props.isError)
                    ? theme.palette.error.main
                    : additionalPalette.lightBlue.secondary
            },
            '&.MuiOutlinedInput-root.Mui-disabled > fieldset': {
                borderColor: additionalPalette.lightBlue.secondary
            },
            '&.MuiOutlinedInput-root.Mui-focused > fieldset': {
                borderColor: additionalPalette.lightBlue.secondary,
                borderWidth: 1
            }
        },
        list: {
            padding: 0
        },
        menu: {
            borderRadius: theme.spacing(0.25),
            maxHeight: 200,
            overflowY: 'scroll'
        },
        menuItem: {
            padding: theme.spacing(1, 2, 1, 2),
            cursor: 'pointer',
            minWidth: 300,
            maxWidth: 500,
            '&:hover': {
                backgroundColor: additionalPalette.lightGrey.secondary
            },
            '&:focus': {
                outline: 0
            }
        },
        menuItemTextRegular: menuItemTextRegular,
        menuItemNumber: {
            paddingRight: theme.spacing(3.5),
            width: theme.spacing(2.5)
        },
        menuItemTextSemiBold: __assign$3(__assign$3({}, menuItemTextRegular), { fontWeight: 'bolder' }),
        percentContainer: {
            paddingLeft: theme.spacing(3)
        },
        removeRouting: {
            padding: theme.spacing(1),
            '&:focus': {
                outline: 0
            }
        },
        removeRoutingDivider: {
            padding: theme.spacing(0, 2)
        },
        removeRoutingIcon: {
            paddingRight: theme.spacing(1)
        },
        routing: {
            width: 30,
            color: theme.palette.success.main
        },
        routingEntryNumber: {
            marginBottom: "-".concat(theme.spacing(1.75))
        },
        percentageAdornment: {
            marginLeft: "-".concat(theme.spacing(1.75))
        }
    });
});

var Focused = function () {
    var classes = useStyles$j({}).classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsx$1("div", __assign$3({ className: classes.enterAdornment }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "flex-start", direction: "row", alignItems: "center" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeS, textClasses.weightRegular) }, { children: "Enter" })), jsx$1("div", __assign$3({ className: classes.enterAdornmentIcon }, { children: jsx$1(Icon, { name: IconName.Return, iconColor: IconColor$1.Background, size: IconSize$1.Medium }) }))] })) })));
};

var InputEndAdornments = function (props) {
    var responseOptionId = props.responseOptionId, responseActions = props.responseActions, canBeReordered = props.canBeReordered, ariaLabel = props.ariaLabel, dragHandleProps = props.dragHandleProps, editable = props.editable, enableRouting = props.enableRouting, isExclusive = props.isExclusive, isTextEntry = props.isTextEntry, inputRef = props.inputRef, routingBadgeDisplayString = props.routingBadgeDisplayString, routingIconColor = props.routingIconColor, _a = props.cannotDelete, cannotDelete = _a === void 0 ? false : _a, _b = props.isRoutingDisabled, isRoutingDisabled = _b === void 0 ? false : _b, maskingIconButton = props.maskingIconButton, pinningIconButton = props.pinningIconButton, onDelete = props.onDelete, onDisableTextEntry = props.onDisableTextEntry, onRoutingMenuClick = props.onRoutingMenuClick, onExclusiveIconClick = props.onExclusiveIconClick;
    var iconColor = isRoutingDisabled ? IconColor$1.Disabled : routingIconColor;
    var classes = useStyles$j({}).classes;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var _d = React__default.useState(null), textEntryAnchorEl = _d[0], setTextEntryAnchorEl = _d[1];
    var _e = React__default.useState(null), exclusiveAnchorEl = _e[0], setExclusiveAnchorEl = _e[1];
    var handleOpenTextEntryMenu = function (event) {
        setTextEntryAnchorEl(event.currentTarget);
        return false;
    };
    var handleOpenExclusiveMenu = function (event) {
        setExclusiveAnchorEl(event.currentTarget);
        return false;
    };
    var handleCloseTextEntryMenu = function () {
        setTextEntryAnchorEl(null);
        return false;
    };
    var handleCloseExclusiveMenu = function () {
        setExclusiveAnchorEl(null);
        return false;
    };
    var disableTextEntry = function () {
        setTextEntryAnchorEl(null);
        onDisableTextEntry === null || onDisableTextEntry === void 0 ? void 0 : onDisableTextEntry();
    };
    var disableExclusive = function () {
        setExclusiveAnchorEl(null);
        onExclusiveIconClick === null || onExclusiveIconClick === void 0 ? void 0 : onExclusiveIconClick();
    };
    return (jsxs(InputAdornment$1, __assign$3({ position: "end" }, { children: [jsx$1(Grid$2, __assign$3({ item: true }, { children: jsx$1(Focused, {}) })), isExclusive && (jsx$1(Tooltip$1, __assign$3({ title: "Exclusive response", tipPlacement: TipPlacement.Top }, { children: jsxs(Fragment$1, { children: [jsx$1(IconButton, { smallHoverShadowSize: true, iconSize: IconSize$1.Large, iconName: IconName.Filter1Outlined, iconColor: IconColor$1.Green, onClick: handleOpenExclusiveMenu }), jsx$1(MuiMenu, __assign$3({ elevation: 1, anchorEl: exclusiveAnchorEl, open: Boolean(exclusiveAnchorEl), onClose: handleCloseExclusiveMenu, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center'
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            } }, { children: jsx$1(MuiMenuItem, __assign$3({ onClick: disableExclusive }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeMs) }, { children: "Make non-exclusive" })) })) }))] }) }))), isTextEntry && (jsx$1(Tooltip$1, __assign$3({ title: "Text entry", tipPlacement: TipPlacement.Top }, { children: jsxs(Fragment$1, { children: [jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " text entry"), iconName: IconName.TextFields, onClick: handleOpenTextEntryMenu, iconSize: IconSize$1.Large, className: classes.iconButton, iconColor: IconColor$1.Enabled }), jsx$1(MuiMenu, __assign$3({ elevation: 1, anchorEl: textEntryAnchorEl, open: Boolean(textEntryAnchorEl), onClose: handleCloseTextEntryMenu, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center'
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            } }, { children: jsx$1(MuiMenuItem, __assign$3({ onClick: disableTextEntry }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeMs) }, { children: "Disable text entry" })) })) }))] }) }))), pinningIconButton, maskingIconButton, enableRouting && (jsxs(Grid$2, __assign$3({ container: true, className: classes.routing, justifyContent: "center", alignItems: "flex-start" }, { children: [routingBadgeDisplayString && (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightInherit, textClasses.sizeS, textClasses.weightSemiBold, classes.routingEntryNumber) }, { children: routingBadgeDisplayString }))), jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " routing"), iconName: IconName.TimelineOutlined, iconColor: iconColor, onClick: function () { return onRoutingMenuClick(inputRef); }, iconSize: IconSize$1.Large, className: classes.iconButton, disabled: isRoutingDisabled })] }))), editable && !cannotDelete && (jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " delete"), iconName: IconName.DeleteOutline, onClick: function () { return onDelete === null || onDelete === void 0 ? void 0 : onDelete(responseOptionId); }, iconSize: IconSize$1.Large, className: classes.iconButton })), responseActions.length > 0 && (jsx$1(KebabMenu, { kebabMenuOptions: responseActions, horizontal: true, iconPosition: KebabMenuIconPosition.Left, iconColor: IconColor$1.Background, tooltipText: "Configure this response option" })), canBeReordered ? (jsx$1("div", __assign$3({}, dragHandleProps, { children: jsx$1(Grid$2, __assign$3({ container: true, alignItems: "center", "aria-label": "".concat(ariaLabel, " drag") }, { children: jsx$1(Icon, { className: classes.dragHandle, iconColor: IconColor$1.Disabled, name: IconName.DragIndicator, size: IconSize$1.Large }) })) }))) : undefined] })));
};

var truncateText = function (text) {
    if (text && text.length > 66) {
        var start = text.slice(0, 32);
        var end = text.slice(text.length - 31, text.length);
        return "".concat(start, "...").concat(end);
    }
    return text || '';
};

var EntryType;
(function (EntryType) {
    EntryType["QuestionEntryType"] = "QuestionEntryType";
    EntryType["TextCardEntryType"] = "TextCardEntryType";
    EntryType["MatrixEntryType"] = "MatrixEntryType";
    EntryType["ForkEntryType"] = "ForkEntryType";
})(EntryType || (EntryType = {}));
var RoutingMenu = function (props) {
    var anchorEl = props.anchorEl, endOfSurveyNumber = props.endOfSurveyNumber, showEndOfSurvey = props.showEndOfSurvey, isRoutingMenuOpen = props.isRoutingMenuOpen, hasRouting = props.hasRouting, routingMenuItems = props.routingMenuItems, onRoutingMenuItemClick = props.onRoutingMenuItemClick, onRoutingMenuClose = props.onRoutingMenuClose;
    var _a = useStyles$j({}), classes = _a.classes, classNames = _a.cx;
    var getEntryPrefix = function (entryType) {
        switch (entryType) {
            case EntryType.TextCardEntryType:
                return 'T';
            default:
                return 'Q';
        }
    };
    var getMenuItems = function (routingMenuItems, isRoutingMenuEmpty) {
        return (routingMenuItems &&
            routingMenuItems.map(function (menuItem, index) {
                return (jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "flex-start", className: classes.menuItem, onClick: function () {
                        onRoutingMenuItemClick &&
                            // This prevents 'onRoutingMenuItemClick' if default option is clicked
                            menuItem.number !== -1 &&
                            onRoutingMenuItemClick(menuItem.number, index);
                        onRoutingMenuClose();
                    } }, { children: [!isRoutingMenuEmpty && (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.menuItemNumber }, { children: jsxs("p", __assign$3({ className: classes.menuItemTextSemiBold }, { children: [getEntryPrefix(menuItem.entryType), menuItem.contextPosition + 1] })) }))), jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsx$1("p", __assign$3({ className: classes.menuItemTextRegular }, { children: truncateText(menuItem.text) })) }))] }), "menu-item-".concat(menuItem.id)));
            }));
    };
    var isRoutingMenuEmpty = (routingMenuItems === null || routingMenuItems === void 0 ? void 0 : routingMenuItems.length) === 0;
    var menuItems = isRoutingMenuOpen && getMenuItems(routingMenuItems, isRoutingMenuEmpty);
    return (jsxs(MuiMenu, __assign$3({ id: "customized-menu", anchorEl: anchorEl, open: isRoutingMenuOpen, onClose: onRoutingMenuClose, color: "secondary", classes: { paper: classes.menu, list: classes.list }, elevation: 1, 
        // getContentAnchorEl={null}
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
        } }, { children: [hasRouting && (jsxs("div", { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "row", alignItems: "center", className: classNames(classes.menuItem, classes.removeRouting), onClick: function () {
                            onRoutingMenuItemClick && onRoutingMenuItemClick(null, null);
                            onRoutingMenuClose();
                        } }, { children: [jsx$1(IconButton, { ariaLabel: "Remove response option", iconName: IconName.DeleteOutline, iconSize: IconSize$1.Large, className: classNames(classes.iconButton, classes.removeRoutingIcon) }), jsx$1("p", __assign$3({ className: classes.menuItemTextRegular }, { children: "Remove routing" }))] })), jsx$1(Grid$2, __assign$3({ item: true, xs: 12, className: classes.removeRoutingDivider }, { children: jsx$1(Divider, {}) }))] })), menuItems, (showEndOfSurvey === true ||
                (!isRoutingMenuEmpty && showEndOfSurvey !== false)) && (jsxs("div", { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 12, className: classes.removeRoutingDivider }, { children: jsx$1(Divider, {}) })), jsxs(Grid$2, __assign$3({ container: true, direction: "column", className: classNames(classes.menuItem, classes.endOfSurveyOption), onClick: function () {
                            onRoutingMenuItemClick &&
                                onRoutingMenuItemClick(endOfSurveyNumber, null);
                            onRoutingMenuClose();
                        } }, { children: [jsx$1("p", __assign$3({ className: classes.menuItemTextSemiBold }, { children: "End of survey" })), jsx$1("p", __assign$3({ className: classes.menuItemTextRegular }, { children: "Route to end of survey" }))] }))] }))] })));
};

// TODO: This needs to be broken down into 2 components (audience, questionnaire)
var ListItemResponseOption = function (props) {
    var _a = props.responseActions, responseActions = _a === void 0 ? [] : _a, _b = props.autoFocus, autoFocus = _b === void 0 ? false : _b, _c = props.ariaLabel, ariaLabel = _c === void 0 ? 'ListItemResponseOption' : _c, _d = props.index, index = _d === void 0 ? 0 : _d, _e = props.editable, editable = _e === void 0 ? false : _e, _f = props.isRoutingVisible, isRoutingVisible = _f === void 0 ? false : _f, _g = props.isRoutingDisabled, isRoutingDisabled = _g === void 0 ? false : _g, _h = props.isRoutingPickerOpen, isRoutingPickerOpen = _h === void 0 ? false : _h, _j = props.isExclusive, isExclusive = _j === void 0 ? false : _j, _k = props.isTextEntry, isTextEntry = _k === void 0 ? false : _k, _l = props.isAddImageDialogOpened, isAddImageDialogOpened = _l === void 0 ? false : _l, _m = props.isMediaPresent, isMediaPresent = _m === void 0 ? false : _m, _o = props.isMediaLoading, isMediaLoading = _o === void 0 ? false : _o, _p = props.endOfSurveyNumber, endOfSurveyNumber = _p === void 0 ? Number.MAX_SAFE_INTEGER : _p, showEndOfSurveyRouting = props.showEndOfSurveyRouting, routingMenuItems = props.routingMenuItems, routingBadgeDisplayString = props.routingBadgeDisplayString, defaultValue = props.defaultValue, value = props.value, _q = props.valuePlaceholder, valuePlaceholder = _q === void 0 ? '' : _q, quotaValue = props.quotaValue, _r = props.disableGutters, disableGutters = _r === void 0 ? false : _r, _s = props.disableQuotaInput, disableQuotaInput = _s === void 0 ? false : _s, _t = props.canBeReordered, canBeReordered = _t === void 0 ? false : _t, _u = props.draggableId, draggableId = _u === void 0 ? '' : _u, _v = props.hasQualification, hasQualification = _v === void 0 ? false : _v, _w = props.hasQuota, hasQuota = _w === void 0 ? false : _w, _x = props.hasInputMarginRight, hasInputMarginRight = _x === void 0 ? true : _x, _y = props.isQualifying, isQualifying = _y === void 0 ? false : _y, _z = props.cannotDelete, cannotDelete = _z === void 0 ? false : _z, _0 = props.isError, isError = _0 === void 0 ? false : _0, _1 = props.helperText, helperText = _1 === void 0 ? '' : _1, _2 = props.isQuotaValueError, isQuotaValueError = _2 === void 0 ? false : _2, _3 = props.errorMessageQuotaValue, errorMessageQuotaValue = _3 === void 0 ? '' : _3, _4 = props.renderMaskingIconButton, renderMaskingIconButton = _4 === void 0 ? undefined : _4, _5 = props.renderPinningIconButton, renderPinningIconButton = _5 === void 0 ? undefined : _5, _6 = props.mediaUrl, mediaUrl = _6 === void 0 ? undefined : _6, _7 = props.thumbnailUrl, thumbnailUrl = _7 === void 0 ? undefined : _7, onFocus = props.onFocus, onEnter = props.onEnter, onDelete = props.onDelete, onDisableTextEntry = props.onDisableTextEntry, onInputChange = props.onInputChange, onRouteSelected = props.onRouteSelected, onQualifyingChange = props.onQualifyingChange, onQuotaChange = props.onQuotaChange, _8 = props.tooltip, tooltip = _8 === void 0 ? value || '' : _8, onPaste = props.onPaste, onSelect = props.onSelect, onRoutingPickerOpenChange = props.onRoutingPickerOpenChange, onExclusiveIconClick = props.onExclusiveIconClick, onCloseAddImageDialog = props.onCloseAddImageDialog, onImageUpload = props.onImageUpload, onRemoveImage = props.onRemoveImage;
    var inputMarginRight = hasInputMarginRight ? 4 : 0;
    var styleProps = {
        inputMarginRight: inputMarginRight,
        isError: isError
    };
    var classes = useStyles$j({ styleProps: styleProps }).classes;
    var _9 = useTextStyles(), textClasses = _9.classes, classNames = _9.cx;
    var _10 = useState(false), isFocused = _10[0], setIsFocused = _10[1];
    var _11 = useState(isQualifying), isQualified = _11[0], setIsQualified = _11[1];
    var hasRouting = !!routingBadgeDisplayString;
    var routingIconColor = hasRouting ? IconColor$1.Enabled : IconColor$1.Background;
    var inputRef = useRef();
    var isRoutingDialogOpen = isRoutingPickerOpen && !hasRouting;
    var isRoutingMenuOpen = isRoutingPickerOpen && hasRouting;
    var openPicker = function () {
        onRoutingPickerOpenChange && onRoutingPickerOpenChange(true);
    };
    var closePicker = function () {
        onRoutingPickerOpenChange && onRoutingPickerOpenChange(false);
    };
    var getInputGridColumnNr = function (hasQuota, hasQualification) {
        if (hasQuota) {
            return hasQualification ? 9 : 10;
        }
        return hasQualification ? 11 : 12;
    };
    var TOOLTIP_CHARACTERS = 120;
    var textTooltip = typeof tooltip === 'string' && tooltip.length > TOOLTIP_CHARACTERS
        ? tooltip
        : '';
    var handleOnFocus = useCallback$1(function () {
        if (onFocus) {
            onFocus();
        }
        setIsFocused(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleKeyPress = useCallback$1(function (event) {
        if (event.key === 'Enter') {
            onEnter && onEnter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleBlur = useCallback$1(function () {
        setIsFocused(false);
    }, []);
    var handleOnQualificationChange = useCallback$1(function () {
        setIsQualified(!isQualified);
        onQualifyingChange && onQualifyingChange(!isQualified);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isQualified]);
    var getInnerListItem = function (dragHandleProps) { return (jsxs(Grid$2, __assign$3({ container: true, direction: "row" }, { children: [jsxs(Fragment$1, { children: [jsxs(Grid$2, __assign$3({ container: true, item: true, xs: getInputGridColumnNr(hasQuota, hasQualification) }, { children: [(isMediaPresent || isAddImageDialogOpened) && (jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: "auto", justifyContent: "center", alignItems: "center" }, { children: jsx$1(ImageUploader, { noThumbnailBorderRadius: true, allowVideo: false, isDialogOpened: isAddImageDialogOpened, shouldHideAddMediaButton: true, shouldHideRemoveMediaButton: true, openMenuOnClick: true, isMediaPresent: isMediaPresent, loading: isMediaLoading, mediaUrl: mediaUrl, thumbnailUrl: thumbnailUrl, mediaType: MediaType.Image, onFileUpload: onImageUpload, onRemoveMedia: onRemoveImage, onCloseDialog: onCloseAddImageDialog }) }))), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: true }, { children: jsx$1(Tooltip$3, __assign$3({ title: textTooltip, placement: "top-start" }, { children: jsx$1(OutlinedInput$1, { ref: inputRef, inputProps: {
                                            'aria-label': ariaLabel
                                        }, onKeyPress: handleKeyPress, autoFocus: autoFocus, defaultValue: defaultValue, value: value, onChange: onInputChange, placeholder: valuePlaceholder, fullWidth: true, disabled: !editable, className: classes.inputRootStyle, classes: {
                                            root: classes.inputStyle
                                        }, onFocus: handleOnFocus, onPaste: onPaste, onBlur: handleBlur, onSelect: onSelect, endAdornment: jsx$1(InputEndAdornments, { responseOptionId: "", responseActions: responseActions, ariaLabel: ariaLabel, isFocused: isFocused, onEnter: onEnter, canBeReordered: canBeReordered, dragHandleProps: dragHandleProps, cannotDelete: cannotDelete, onDisableTextEntry: onDisableTextEntry, editable: editable, enableRouting: isRoutingVisible, routingBadgeDisplayString: routingBadgeDisplayString, routingIconColor: routingIconColor, inputRef: inputRef, onDelete: onDelete, onRoutingMenuClick: openPicker, isRoutingDisabled: isRoutingDisabled, maskingIconButton: renderMaskingIconButton, pinningIconButton: renderPinningIconButton, onExclusiveIconClick: onExclusiveIconClick, isExclusive: isExclusive, isTextEntry: isTextEntry }) }) })) }))] })), jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 2, justifyContent: "center", alignItems: "center", style: { display: hasQuota ? 'inherit' : 'none' } }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 8 }, { children: jsx$1(PercentageInput, { disabled: disableQuotaInput, defaultValue: quotaValue, value: quotaValue, onChange: onQuotaChange, isError: isQuotaValueError }) })), jsx$1(Grid$2, __assign$3({ item: true, xs: 4 }, { children: jsx$1(Grid$2, __assign$3({ item: true, xs: 2 }, { children: isQuotaValueError ? (jsx$1(InfoIcon$1, { tooltipPlacement: TooltipPlacement.Top, text: errorMessageQuotaValue, iconColor: IconColor.Error, paddingLeft: false })) : (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeM) }, { children: "%" }))) })) }))] })), hasQualification && (jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", item: true, xs: 1 }, { children: [jsx$1(Grid$2, __assign$3({ container: true, justifyContent: "center", item: true, xs: 7 }, { children: jsx$1(Switch, { checked: isQualified, onChange: handleOnQualificationChange }) })), jsx$1(Grid$2, { item: true, xs: 5 })] }))), jsx$1(QuestionsDialogDialog, { title: "Add skip logic", primaryButtonText: "Add skip logic", endOfSurveyNumber: endOfSurveyNumber, showEndOfSurvey: showEndOfSurveyRouting, isQuestionDialogOpen: isRoutingDialogOpen, onQuestionDialogClose: closePicker, questionDialogItems: routingMenuItems, onSelectQuestionDialogItem: onRouteSelected }), jsx$1(RoutingMenu, { anchorEl: inputRef && inputRef.current, endOfSurveyNumber: endOfSurveyNumber, showEndOfSurvey: showEndOfSurveyRouting, hasRouting: hasRouting, isRoutingMenuOpen: isRoutingMenuOpen, onRoutingMenuClose: closePicker, routingMenuItems: routingMenuItems, onRoutingMenuItemClick: onRouteSelected })] }), isError && jsx$1(FormHelperText$1, __assign$3({ error: true }, { children: helperText }))] }))); };
    return canBeReordered ? (jsx$1(PublicDraggable, __assign$3({ isDragDisabled: !canBeReordered, draggableId: draggableId, index: index }, { children: function (provided) { return (jsx$1(ListItem$1, __assign$3({}, provided.draggableProps, { ref: provided.innerRef, disableGutters: disableGutters, className: classes.listItem }, { children: getInnerListItem(provided.dragHandleProps) }))); } }))) : (jsx$1(ListItem$1, __assign$3({ disableGutters: disableGutters, className: classes.listItem, "aria-label": ariaLabel }, { children: getInnerListItem() })));
};

var useStyles$i = makeStyles()(function () { return ({
    dragHandle: {
        cursor: 'grab'
    }
}); });

var DragHandleButton = function (props) {
    var ariaLabel = props.ariaLabel, dragHandleProps = props.dragHandleProps;
    var classes = useStyles$i().classes;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx$1("div", __assign$3({}, dragHandleProps, { children: jsx$1(Grid$2, __assign$3({ container: true, alignItems: "center", "aria-label": "".concat(ariaLabel, " drag") }, { children: jsx$1(Icon, { className: classes.dragHandle, iconColor: IconColor$1.Disabled, name: IconName.DragIndicator, size: IconSize$1.Large }) })) })));
};

var draggable = function (Component) {
    return function draggableHoc(hocProps) {
        var _a = hocProps.canBeReordered, canBeReordered = _a === void 0 ? false : _a, _b = hocProps.draggableId, draggableId = _b === void 0 ? '' : _b, _c = hocProps.index, index = _c === void 0 ? 0 : _c;
        return canBeReordered ? (jsx$1(PublicDraggable, __assign$3({ isDragDisabled: !canBeReordered, draggableId: draggableId, index: index }, { children: function (provided) { return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            jsx$1(Component, __assign$3({}, hocProps, { provided: provided }))); } }))) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        jsx$1(Component, __assign$3({}, hocProps)));
    };
};

var ListItemQuestionnaireResponseOption = function (props) {
    var responseOptionId = props.responseOptionId, value = props.value, ariaLabel = props.ariaLabel, placeholder = props.placeholder, _a = props.editable, editable = _a === void 0 ? false : _a, _b = props.cannotDelete, cannotDelete = _b === void 0 ? false : _b, _c = props.isError, isError = _c === void 0 ? false : _c, _d = props.helperText, helperText = _d === void 0 ? '' : _d, autoFocus = props.autoFocus, _e = props.disableGutters, disableGutters = _e === void 0 ? false : _e, canBeReordered = props.canBeReordered, provided = props.provided, maskingIconButton = props.maskingIconButton, pinningIconButton = props.pinningIconButton, mediaButton = props.mediaButton, exclusiveButton = props.exclusiveButton, textEntryButton = props.textEntryButton, routingButton = props.routingButton, responseActionsMenu = props.responseActionsMenu, questionsDialog = props.questionsDialog, renderRoutingMenu = props.renderRoutingMenu, onBlur = props.onBlur, onChange = props.onChange, onDelete = props.onDelete, onEnter = props.onEnter, onFocus = props.onFocus, onPaste = props.onPaste, onSelect = props.onSelect;
    var inputRef = useRef();
    var styleProps = {
        inputMarginRight: 0,
        isError: isError
    };
    var _f = useStyles$j({ styleProps: styleProps }), classes = _f.classes, classname = _f.cx;
    var _g = useState(value), responseOptionValue = _g[0], setResponseOptionValue = _g[1];
    var _h = useState(false), isFocused = _h[0], setIsFocused = _h[1];
    var handleOnBlur = function () {
        var _a;
        setIsFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || '');
    };
    useEffect(function () {
        setResponseOptionValue(value);
    }, [value]);
    var handleInternalValueChange = function (event) {
        setResponseOptionValue(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
    };
    var handleKeyPress = useCallback$1(function (event) {
        if (event.key === 'Enter') {
            onEnter && onEnter();
        }
    }, [onEnter]);
    var handleOnFocus = useCallback$1(function () {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        setIsFocused(true);
    }, [onFocus]);
    var handleOnPaste = function (event) {
        if (onPaste) {
            // prevent default paste behaviour only if `onPaste` handler was provided, otherwise keep default paste functionality
            event.preventDefault();
            event.stopPropagation();
            onPaste(event.clipboardData.getData('text'));
        }
    };
    var handleOnSelect = function (event) {
        var customTarget = event.target;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(customTarget.selectionStart, customTarget.selectionEnd);
    };
    var textTooltip = getResponseOptionTooltip(responseOptionValue);
    var input = (jsx$1(OutlinedInput$1, { inputRef: inputRef, inputProps: {
            'aria-label': ariaLabel
        }, value: responseOptionValue, disabled: !editable, fullWidth: true, placeholder: placeholder, autoFocus: autoFocus, className: classes.inputRootStyle, classes: {
            root: classes.inputStyle
        }, onBlur: handleOnBlur, onChange: handleInternalValueChange, onKeyPress: handleKeyPress, onFocus: handleOnFocus, onPaste: handleOnPaste, onSelect: handleOnSelect, endAdornment: jsxs(InputAdornment$1, __assign$3({ position: "end" }, { children: [isFocused && jsx$1(Focused, {}), exclusiveButton, textEntryButton, pinningIconButton, maskingIconButton, routingButton, editable && !cannotDelete && (jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " delete"), iconName: IconName.DeleteOutline, onClick: function () { return onDelete === null || onDelete === void 0 ? void 0 : onDelete(responseOptionId); }, iconSize: IconSize$1.Large, className: classes.iconButton })), responseActionsMenu, canBeReordered && (jsx$1(DragHandleButton, { ariaLabel: ariaLabel, dragHandleProps: provided === null || provided === void 0 ? void 0 : provided.dragHandleProps }))] })) }));
    var inputWithTooltipIfNeeded = textTooltip ? (jsx$1(Tooltip$3, __assign$3({ title: textTooltip, placement: "top-start" }, { children: input }))) : (input);
    return (jsx$1(ListItem$1
    // eslint-disable-next-line react/jsx-props-no-spreading
    , __assign$3({}, provided === null || provided === void 0 ? void 0 : provided.draggableProps, { ref: provided === null || provided === void 0 ? void 0 : provided.innerRef, disableGutters: disableGutters, className: classes.listItem, "aria-label": ariaLabel }, { children: jsxs("div", __assign$3({ className: classes.grid }, { children: [jsxs("div", __assign$3({ className: classname(classes.grid, classes.gridItem) }, { children: [mediaButton && (jsx$1("div", __assign$3({ className: classname(classes.grid, classes.gridItemXsAutoCentered) }, { children: mediaButton }))), jsx$1("div", __assign$3({ className: classname(classes.grid, classes.gridItemXs) }, { children: inputWithTooltipIfNeeded })), questionsDialog, renderRoutingMenu === null || renderRoutingMenu === void 0 ? void 0 : renderRoutingMenu(inputRef)] })), isError && jsx$1(FormHelperText$1, __assign$3({ error: true }, { children: helperText }))] })) })));
};
var ListItemQuestionnaireResponseOption$1 = memo(draggable(ListItemQuestionnaireResponseOption));

var ListItemAudienceResponseOption = function (props) {
    var responseOptionId = props.responseOptionId, value = props.value, ariaLabel = props.ariaLabel, placeholder = props.placeholder, _a = props.editable, editable = _a === void 0 ? false : _a, _b = props.cannotDelete, cannotDelete = _b === void 0 ? false : _b, _c = props.isError, isError = _c === void 0 ? false : _c, _d = props.helperText, helperText = _d === void 0 ? '' : _d, _e = props.disableGutters, disableGutters = _e === void 0 ? false : _e, hasQuota = props.hasQuota, _f = props.disableQuotaInput, disableQuotaInput = _f === void 0 ? false : _f, quotaValue = props.quotaValue, _g = props.isQuotaValueError, isQuotaValueError = _g === void 0 ? false : _g, _h = props.errorMessageQuotaValue, errorMessageQuotaValue = _h === void 0 ? '' : _h, hasQualification = props.hasQualification, _j = props.isQualifying, isQualifying = _j === void 0 ? false : _j, canBeReordered = props.canBeReordered, provided = props.provided, onBlur = props.onBlur, onChange = props.onChange, onDelete = props.onDelete, onQuotaChange = props.onQuotaChange, onQualifyingChange = props.onQualifyingChange;
    var inputRef = useRef();
    var styleProps = {
        inputMarginRight: hasQualification || hasQuota ? 4 : 0,
        isError: isError
    };
    var classes = useStyles$j({ styleProps: styleProps }).classes;
    var _k = useState(value), responseOptionValue = _k[0], setResponseOptionValue = _k[1];
    var _l = useState(isQualifying), isQualified = _l[0], setIsQualified = _l[1];
    var handleOnBlur = function () {
        var _a;
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || '');
    };
    useEffect(function () {
        setResponseOptionValue(value);
    }, [value]);
    var handleInternalValueChange = function (event) {
        setResponseOptionValue(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
    };
    var handleOnQualificationChange = useCallback$1(function () {
        setIsQualified(!isQualified);
        onQualifyingChange === null || onQualifyingChange === void 0 ? void 0 : onQualifyingChange(!isQualified);
    }, [isQualified, onQualifyingChange]);
    var getInputGridColumnNr = function () {
        if (hasQuota) {
            return hasQualification ? 9 : 10;
        }
        return hasQualification ? 11 : 12;
    };
    var textTooltip = getResponseOptionTooltip(responseOptionValue);
    return (jsx$1(ListItem$1, __assign$3({}, provided === null || provided === void 0 ? void 0 : provided.draggableProps, { ref: provided === null || provided === void 0 ? void 0 : provided.innerRef, disableGutters: disableGutters, className: classes.listItem, "aria-label": ariaLabel }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "row" }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: getInputGridColumnNr() }, { children: jsx$1(Tooltip$3, __assign$3({ title: textTooltip, placement: "top-start" }, { children: jsx$1(OutlinedInput$1, { inputRef: inputRef, inputProps: {
                                'aria-label': ariaLabel
                            }, value: responseOptionValue, disabled: !editable, fullWidth: true, placeholder: placeholder, className: classes.inputRootStyle, classes: {
                                root: classes.inputStyle
                            }, onBlur: handleOnBlur, onChange: handleInternalValueChange, endAdornment: jsxs(Fragment$1, { children: [editable && !cannotDelete && (jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " delete"), iconName: IconName.DeleteOutline, onClick: function () { return onDelete === null || onDelete === void 0 ? void 0 : onDelete(responseOptionId); }, iconSize: IconSize$1.Large, className: classes.iconButton })), canBeReordered ? (jsx$1("div", __assign$3({}, provided === null || provided === void 0 ? void 0 : provided.dragHandleProps, { children: jsx$1(Grid$2, __assign$3({ container: true, alignItems: "center", "aria-label": "".concat(ariaLabel, " drag") }, { children: jsx$1(Icon, { className: classes.dragHandle, iconColor: IconColor$1.Disabled, name: IconName.DragIndicator, size: IconSize$1.Large }) })) }))) : undefined] }) }) })) })), hasQuota && (jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 2, justifyContent: "center", alignItems: "center" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 8 }, { children: jsx$1(PercentageInput, { disabled: disableQuotaInput, value: quotaValue, onChange: function (e) { return onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange(e.target.value); }, isError: isQuotaValueError }) })), jsx$1(Grid$2, __assign$3({ item: true, xs: 4 }, { children: jsx$1(Grid$2, __assign$3({ item: true, xs: 2 }, { children: isQuotaValueError ? (jsx$1(InfoIcon$1, { tooltipPlacement: TooltipPlacement.Top, text: errorMessageQuotaValue, iconColor: IconColor.Error, paddingLeft: false })) : (jsx$1(Text$1, __assign$3({ size: TextSize.m, highlight: TextHighlight.Background }, { children: "%" }))) })) }))] }))), hasQualification && (jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", item: true, xs: 1 }, { children: [jsx$1(Grid$2, __assign$3({ container: true, justifyContent: "center", item: true, xs: 7 }, { children: jsx$1(Switch, { checked: isQualified, onChange: handleOnQualificationChange }) })), jsx$1(Grid$2, { item: true, xs: 5 })] }))), isError && jsx$1(FormHelperText$1, __assign$3({ error: true }, { children: helperText }))] })) })));
};
var ListItemAudienceResponseOption$1 = memo(draggable(ListItemAudienceResponseOption));

var bottomUrl = encodeURIComponent('<svg width="96" height="428" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="#123F52" d="M0 357V238h32v119z"/><path fill="#376273" d="M0 428v-71h32v71z"/><path fill="#123F52" d="M32.5 169.5v-119h32v119z"/><path fill="#376273" d="M.5 119.5V.5h32v119z"/><path fill="#06202E" d="M.5 238.5v-119h32v119z"/><path fill="#8AA3AD" d="M64 361V233h32v128z"/><path fill="#123F52" d="M64 428v-67h32v67z"/><path fill="#5B7E8C" d="M32 297V169h32v128z"/><path fill="#0B2F3F" d="M32 425V297h32v128z"/><path fill="#14465A" d="M32 428v-3h32v3z"/><path fill="#376273" d="M64 233V105h32v128z"/></g></svg>');
var topUrl = encodeURIComponent('<svg width="96" height="428" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="#0B2F3F" d="M96 71v119H64V71z"/><path fill="#376273" d="M96 0v71H64V0z"/><path fill="#5B7E8C" d="M63.5 258.5v119h-32v-119z"/><path fill="#376273" d="M95.5 308.5v119h-32v-119z"/><path fill="#123F52" d="M95.5 189.5v119h-32v-119z"/><path fill="#8AA3AD" d="M32 67v128H0V67z"/><path fill="#5B7E8C" d="M32 0v67H0V0z"/><path fill="#06202E" d="M64 131v128H32V131z"/><path fill="#123F52" d="M64 3v128H32V3z"/><path fill="#14465A" d="M64 0v3H32V0z"/><path fill="#376273" d="M32 195v128H0V195z"/></g></svg>');
var useStyles$h = makeStyles()(function (theme) {
    var _a;
    return ({
        bold: { fontWeight: theme.typography.fontWeightBold },
        button: {
            borderRadius: 0,
            boxShadow: 'none',
            height: theme.spacing(7),
            marginTop: theme.spacing(2),
            width: '100%'
        },
        logo: {
            width: 160
        },
        subtitle: (_a = {
                margin: theme.spacing(2, 0, 5, 0)
            },
            _a[theme.breakpoints.down('lg')] = {
                margin: theme.spacing(2, 0, 4, 0)
            },
            _a),
        marginTop: { marginTop: theme.spacing(4) },
        hoverOrange: {
            color: theme.palette.secondary.main,
            textDecoration: 'underline',
            textTransform: 'none',
            '&:hover': {
                color: theme.palette.primary.main,
                cursor: 'pointer',
                background: 'none',
                '& > span': {
                    color: theme.palette.primary.main,
                    background: 'none'
                }
            }
        },
        margin: {
            margin: theme.spacing(1)
        },
        textField: {
            width: '25ch'
        },
        linkText: {
            '&:hover': {
                color: theme.palette.primary.main,
                background: 'none'
            }
        },
        container: {
            borderRadius: 2,
            backgroundColor: '#FFF',
            padding: theme.spacing(4)
        },
        signupContainer: {
            borderRadius: 2,
            backgroundColor: '#FFF',
            padding: theme.spacing(4, 4, 0, 4)
        },
        gridItem: {
            padding: theme.spacing(1, 2, 1, 2)
        },
        maxWidth: {
            width: 500
        },
        page: {
            height: '100vh',
            backgroundColor: additionalPalette.darkBlue.main,
            backgroundImage: "url('data:image/svg+xml;utf8,".concat(bottomUrl, "'), url('data:image/svg+xml;utf8,").concat(topUrl, "')"),
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'left bottom, right top'
        },
        lastName: {
            paddingLeft: theme.spacing(2)
        },
        firstName: {
            paddingRight: theme.spacing(2)
        },
        successLogo: {
            height: 30,
            width: 35,
            padding: theme.spacing(2)
        },
        paddingRight: {
            paddingRight: theme.spacing(0.7)
        },
        helperText: {
            marginTop: theme.spacing(5)
        },
        signupHelperText: {
            marginTop: theme.spacing(2)
        },
        passwordChecklist: {
            padding: theme.spacing(1, 2)
        },
        checkListTitle: {
            paddingBottom: theme.spacing(1)
        },
        checkListItem: {
            height: theme.spacing(4),
            padding: theme.spacing(0.5, 0)
        },
        uncheckedCircle: {
            margin: theme.spacing(0, 0.25),
            height: theme.spacing(2.5),
            width: theme.spacing(2.5),
            borderRadius: 50,
            backgroundColor: additionalPalette.lightGrey.main
        }
    });
});

var FailStatus;
(function (FailStatus) {
    FailStatus["unauthorized"] = "401";
    FailStatus["notFound"] = "404";
})(FailStatus || (FailStatus = {}));
var Login = function (props) {
    var logoSrc = props.logoSrc, onLogin = props.onLogin, onGoToRegister = props.onGoToRegister, onForgotPassword = props.onForgotPassword;
    var _a = useState(false), loading = _a[0], onLoading = _a[1];
    var _b = useState({
        error: undefined,
        email: '',
        password: '',
        showPassword: false
    }), state = _b[0], setState = _b[1];
    var handleLogin = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var loginResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    onLoading(true);
                    return [4 /*yield*/, onLogin((_a = state.email) === null || _a === void 0 ? void 0 : _a.toLowerCase(), state.password)];
                case 1:
                    loginResponse = _b.sent();
                    if (loginResponse) {
                        onLoading(false);
                    }
                    if (loginResponse instanceof Error) {
                        setState(__assign$3(__assign$3({}, state), { error: loginResponse }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var renderErrorMessage = function (errorState) {
        if (errorState.message === FailStatus.unauthorized ||
            errorState.message === FailStatus.notFound) {
            return 'Your username or password are incorrect. Please try again.';
        }
        return "There's an issue connecting to the server. Please try again.";
    };
    var classes = useStyles$h().classes;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var handleChange = function (prop) { return function (event) {
        var _a;
        setState(__assign$3(__assign$3({}, state), (_a = {}, _a[prop] = event.target.value, _a)));
    }; };
    return (jsx$1(Grid$2, __assign$3({ className: classes.page, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ className: classes.maxWidth }, { children: [jsx$1("form", __assign$3({ onSubmit: handleLogin }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", direction: "column", alignItems: "center", className: classes.container }, { children: [jsx$1("img", { className: classes.logo, src: logoSrc, alt: "focaldata-logo" }), jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.weightBold) }, { children: "Please log in" })) })), jsxs(Grid$2, __assign$3({ item: true, container: true, direction: "column", alignItems: "flex-start", className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Email" })), jsx$1(Input$6, { fullWidth: true, value: state.email, onChange: handleChange('email'), variant: InputVariant.Filled })] })), jsxs(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Password" })), jsx$1(PasswordInput, { fullWidth: true, value: state.password, onChange: handleChange('password') })] })), jsx$1(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: jsx$1(SpinnerButton, __assign$3({ onClick: handleLogin, className: classes.button, loading: loading, fullWidth: true, buttonType: ButtonType.Submit }, { children: "Log in" })) })), state.error && (jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", alignItems: "center", className: classes.gridItem }, { children: [jsx$1(Icon, { name: IconName.InfoOutlinedIcon, iconColor: IconColor$1.Error }), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightError) }, { children: renderErrorMessage(state.error) }))] })))] })) })), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classes.helperText }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightWhite) }, { children: "Don't have an account?" })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, onClick: onGoToRegister, noPadding: true, underlined: true }, { children: "Sign up" }))] })), jsx$1(Grid$2, __assign$3({ container: true, justifyContent: "center" }, { children: jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, onClick: onForgotPassword, noPadding: true, underlined: true }, { children: "Forgot your password?" })) }))] })) })));
};

var SignupErrorText = function (props) {
    var _a;
    var error = props.error;
    var _b = useTextStyles(), textClasses = _b.classes, classNames = _b.cx;
    var isServerError = error && ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) !== 409;
    if (isServerError) {
        return (jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", alignItems: "center" }, { children: [jsx$1(Icon, { name: IconName.InfoOutlinedIcon, iconColor: IconColor$1.Error }), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightError) }, { children: "There's an issue connecting to the server. Please try again." }))] })));
    }
    return null;
};

var PasswordChecklist = function (props) {
    var isLengthValid = props.isLengthValid, isUsingNumbers = props.isUsingNumbers, isUsingCapitals = props.isUsingCapitals;
    var classes = useStyles$h().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    var getCheckedIcon = function (isValid) {
        if (isValid) {
            return (jsx$1(Icon, { name: IconName.CheckCircle, iconColor: IconColor$1.Enabled, size: IconSize$1.Large }));
        }
        return jsx$1("div", { className: classes.uncheckedCircle });
    };
    var lengthCheckIcon = getCheckedIcon(isLengthValid);
    var numberCheckIcon = getCheckedIcon(isUsingNumbers);
    var caseCheckIcon = getCheckedIcon(isUsingCapitals);
    return (jsxs(Grid$2, __assign$3({ container: true, direction: "column", className: classes.passwordChecklist }, { children: [jsx$1(Grid$2, __assign$3({ container: true, xs: "auto", alignItems: "center", className: classes.checkListTitle }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.weightSemiBold) }, { children: "Your password must have:" })) })), jsxs(Grid$2, __assign$3({ container: true, xs: "auto", alignItems: "center", className: classes.checkListItem }, { children: [lengthCheckIcon, jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.marginLeft) }, { children: "8 or more characters" }))] })), jsxs(Grid$2, __assign$3({ container: true, xs: "auto", alignItems: "center", className: classes.checkListItem }, { children: [numberCheckIcon, jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.marginLeft) }, { children: "At least one number (0-9)" }))] })), jsxs(Grid$2, __assign$3({ container: true, xs: "auto", alignItems: "center", className: classes.checkListItem }, { children: [caseCheckIcon, jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.marginLeft) }, { children: "Upper and lowercase letters" }))] }))] })));
};

var minimumLengthCheck = function (password) {
    var minPasswordLen = 8;
    var isValid = password.length >= minPasswordLen;
    return isValid;
};
var usingNumbersCheck = function (password) {
    var isValid = /\d/.test(password);
    return isValid;
};
var usingCapitalsCheck = function (password) {
    var isValid = password.toLowerCase() !== password;
    return isValid;
};
var usingLowercaseCheck = function (password) {
    var isValid = password.toUpperCase() !== password;
    return isValid;
};
var isPasswordStrong = function (password) {
    return (minimumLengthCheck(password) &&
        usingNumbersCheck(password) &&
        usingLowercaseCheck(password) &&
        usingCapitalsCheck(password));
};

var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
var validate = function(email)
{
	if (!email)
		return false;
		
	if(email.length>254)
		return false;

	var valid = tester.test(email);
	if(!valid)
		return false;

	// Further checking of some things regex can't handle
	var parts = email.split("@");
	if(parts[0].length>64)
		return false;

	var domainParts = parts[1].split(".");
	if(domainParts.some(function(part) { return part.length>63; }))
		return false;

	return true;
};

var checkIfPersonalEmailAddress = function (email) {
    var personalEmailDomains = [
        // 'gmail.com',
        'hotmail.com',
        'yahoo.com',
        'aol.com',
        'outlook.com'
    ];
    var isPersonalEmail = personalEmailDomains.some(function (domain) {
        return email.includes(domain);
    });
    return isPersonalEmail;
};
var useSignupForm = function (props) {
    var _a = useState(''), firstName = _a[0], setFirstName = _a[1];
    var _b = useState(''), lastName = _b[0], setLastName = _b[1];
    var _c = useState(props.email || ''), email = _c[0], setEmail = _c[1];
    var _d = useState(props.organisation || ''), organisation = _d[0], setOrganisation = _d[1];
    var _e = useState(props.error), error = _e[0], setError = _e[1];
    var _f = useState(), emailErrorMessage = _f[0], setEmailErrorMessage = _f[1];
    var validateEmail = function (email) {
        var isEmailFormatValid = validate(email);
        var isPersonalEmail = checkIfPersonalEmailAddress(email);
        var isValid = isEmailFormatValid && !isPersonalEmail;
        var errorMessage = isPersonalEmail
            ? 'You have entered a personal email address. Please use your work email address instead.'
            : 'You have entered an invalid email address.';
        if (!isValid)
            setEmailErrorMessage(errorMessage);
        return isValid;
    };
    var handleFirstNameChange = function (event) {
        setFirstName(event.target.value);
    };
    var handleLastNameChange = function (event) {
        setLastName(event.target.value);
    };
    var handleEmailChange = function (event) {
        setEmailErrorMessage(undefined);
        setEmail(event.target.value);
    };
    var handleOrganisationChange = function (event) {
        setOrganisation(event.target.value);
    };
    var getEmailInputErrorMessage = function (error) {
        var _a;
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 409) {
            return 'This email is already in use.';
        }
        if (emailErrorMessage) {
            return emailErrorMessage;
        }
        return undefined;
    };
    var isFormValid = function () {
        return (emailErrorMessage === undefined &&
            firstName.length > 0 &&
            lastName.length > 0 &&
            email.length > 0 &&
            organisation.length > 0);
    };
    return {
        firstName: firstName,
        lastName: lastName,
        email: email,
        organisation: organisation,
        error: error,
        emailErrorMessage: emailErrorMessage,
        handleFirstNameChange: handleFirstNameChange,
        handleLastNameChange: handleLastNameChange,
        handleEmailChange: handleEmailChange,
        setEmail: setEmail,
        handleOrganisationChange: handleOrganisationChange,
        setOrganisation: setOrganisation,
        setError: setError,
        validateEmail: validateEmail,
        getEmailInputErrorMessage: getEmailInputErrorMessage,
        isFormValid: isFormValid
    };
};

var SignupForm = function (props) {
    var _a;
    var predefinedOrganisation = props.predefinedOrganisation, predefinedEmail = props.predefinedEmail, onSignup = props.onSignup, onSignupError = props.onSignupError;
    var _b = useState(false), loading = _b[0], onLoading = _b[1];
    var classes = useStyles$h().classes;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var _d = useSignupForm({
        email: predefinedEmail,
        organisation: predefinedOrganisation
    }), firstName = _d.firstName, lastName = _d.lastName, email = _d.email, organisation = _d.organisation, error = _d.error, emailErrorMessage = _d.emailErrorMessage, handleFirstNameChange = _d.handleFirstNameChange, handleLastNameChange = _d.handleLastNameChange, handleEmailChange = _d.handleEmailChange, handleOrganisationChange = _d.handleOrganisationChange, setError = _d.setError, setEmail = _d.setEmail, setOrganisation = _d.setOrganisation, validateEmail = _d.validateEmail, getEmailInputErrorMessage = _d.getEmailInputErrorMessage, isFormValid = _d.isFormValid;
    useEffect(function () {
        setEmail(predefinedEmail || '');
        if (predefinedEmail)
            validateEmail(predefinedEmail);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [predefinedEmail]);
    useEffect(function () {
        setOrganisation(predefinedOrganisation || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [predefinedOrganisation]);
    var _e = useState(''), password = _e[0], setPassword = _e[1];
    var handleSignup = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var signupResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!validateEmail(email)) return [3 /*break*/, 2];
                    onLoading(true);
                    return [4 /*yield*/, onSignup(firstName, lastName, email === null || email === void 0 ? void 0 : email.toLowerCase(), organisation, password)];
                case 1:
                    signupResponse = _a.sent();
                    if (signupResponse) {
                        onLoading(false);
                    }
                    if (signupResponse instanceof Error) {
                        setError(signupResponse);
                        onSignupError(signupResponse);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handlePasswordChange = function (event) {
        setPassword(event.target.value);
    };
    var isEmailAddressError = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 409 || !!emailErrorMessage;
    var emailInputErrorMessage = getEmailInputErrorMessage(error);
    var isDisabled = !isFormValid() ||
        (!isPasswordStrong(password) && predefinedEmail && predefinedOrganisation);
    return (jsxs(Fragment$1, { children: [jsxs(Grid$2, __assign$3({ item: true, xs: 12, container: true, justifyContent: "space-between", className: classes.gridItem }, { children: [jsxs(Grid$2, __assign$3({ item: true, xs: 6, container: true, direction: "column", alignItems: "flex-start", className: classes.firstName }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "First name" })), jsx$1(Input$6, { fullWidth: true, value: firstName, onChange: handleFirstNameChange, variant: InputVariant.Filled })] })), jsxs(Grid$2, __assign$3({ item: true, xs: 6, container: true, direction: "column", alignItems: "flex-start", className: classes.lastName }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Last name" })), jsx$1(Input$6, { fullWidth: true, value: lastName, onChange: handleLastNameChange, variant: InputVariant.Filled })] }))] })), jsxs(Grid$2, __assign$3({ item: true, xs: 12, container: true, direction: "column", alignItems: "flex-start", className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Work email" })), jsx$1(Input$6, { disabled: !!predefinedEmail, fullWidth: true, value: email, onChange: handleEmailChange, variant: InputVariant.Filled, isError: isEmailAddressError, helperText: emailInputErrorMessage })] })), jsxs(Grid$2, __assign$3({ item: true, xs: 12, container: true, className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Organisation" })), jsx$1(Input$6, { disabled: !!predefinedOrganisation, fullWidth: true, value: organisation, onChange: handleOrganisationChange, variant: InputVariant.Filled })] })), predefinedEmail && predefinedOrganisation && (jsxs(Fragment$1, { children: [jsxs(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Password" })), jsx$1(PasswordInput, { fullWidth: true, value: password, onChange: handlePasswordChange })] })), jsx$1(PasswordChecklist, { isLengthValid: minimumLengthCheck(password), isUsingNumbers: usingNumbersCheck(password), isUsingCapitals: usingCapitalsCheck(password) && usingLowercaseCheck(password) })] })), jsx$1(Grid$2, __assign$3({ item: true, xs: 12, container: true, className: classes.gridItem }, { children: jsx$1(SpinnerButton, __assign$3({ onClick: handleSignup, className: classes.button, loading: loading, fullWidth: true, buttonType: ButtonType.Submit, disabled: !!isDisabled }, { children: "Sign up" })) }))] }));
};

var Signup = function (props) {
    var logoSrc = props.logoSrc, predefinedOrganisation = props.predefinedOrganisation, predefinedEmail = props.predefinedEmail, onSignup = props.onSignup, onClickPrivacyPolicy = props.onClickPrivacyPolicy, onClickTerms = props.onClickTerms, onGoToLogin = props.onGoToLogin;
    var _a = useState(), signupError = _a[0], setSignupError = _a[1];
    var classes = useStyles$h().classes;
    var _b = useTextStyles(), textClasses = _b.classes, classNames = _b.cx;
    return (jsx$1(Grid$2, __assign$3({ className: classes.page, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ className: classes.maxWidth }, { children: [jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", direction: "column", alignItems: "center", className: classes.container }, { children: [jsx$1("img", { className: classes.logo, src: logoSrc, alt: "focaldata-logo" }), jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.weightBold) }, { children: "Create your account" })) })), !(predefinedEmail && predefinedOrganisation) && (jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeMs, textClasses.alignCenter) }, { children: "If your team already has an account, then ask a team member to invite you." })) }))), jsx$1(SignupForm, { predefinedEmail: predefinedEmail, predefinedOrganisation: predefinedOrganisation, onSignup: onSignup, onSignupError: function (e) { return setSignupError(e); } }), jsxs(Grid$2, __assign$3({ item: true, xs: 12, container: true, justifyContent: "center", alignItems: "center", direction: "column", className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground) }, { children: "By clicking \u2018Sign up\u2019 you agree to Focaldata\u2019s" })), jsxs(Grid$2, __assign$3({ item: true, xs: 12, container: true, justifyContent: "center", alignItems: "center", direction: "row" }, { children: [jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.Background, weight: TextWeight.Regular, size: TextSize.s, onClick: onClickTerms, underlined: true }, { children: "Terms & Conditions" })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground) }, { children: "and" })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.Background, weight: TextWeight.Regular, size: TextSize.s, onClick: onClickPrivacyPolicy, underlined: true }, { children: "Privacy Policy" }))] }))] })), jsx$1(SignupErrorText, { error: signupError }), !(predefinedEmail && predefinedOrganisation) && (jsx$1(Grid$2, { item: true, xs: 12, container: true, justifyContent: "center", className: classes.gridItem }))] })), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classes.helperText }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightWhite) }, { children: "Already have an account?" })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, onClick: onGoToLogin, noPadding: true, underlined: true }, { children: "Log in" }))] }))] })) })));
};

var SignupSuccessful = function (props) {
    var email = props.email, onClickButton = props.onClickButton;
    var classes = useStyles$h().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsx$1(Grid$2, __assign$3({ className: classes.page, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ className: classes.maxWidth }, { children: [jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", direction: "column", alignItems: "center", className: classes.container }, { children: [jsx$1("img", { className: classes.successLogo, src: img$25, alt: "focaldata-logo" }), jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold, textClasses.sizeL) }, { children: "Thank you for signing up with Focaldata." })) })), jsxs(Grid$2, __assign$3({ item: true, container: true, direction: "row", justifyContent: "center" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, className: classes.paddingRight }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightRegular, textClasses.highlightBackground) }, { children: "We will send a confirmation email to" })) })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeM, textClasses.weightSemiBold, textClasses.highlightBackground) }, { children: email })), jsx$1(Grid$2, __assign$3({ item: true, container: true, justifyContent: "center" }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignCenter, textClasses.weightRegular, textClasses.highlightBackground) }, { children: "once your account has been approved." })) }))] })), jsx$1(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: jsx$1(SpinnerButton, __assign$3({ onClick: onClickButton, className: classes.button, fullWidth: true, buttonType: ButtonType.Submit }, { children: "Back to focaldata.com" })) })), jsx$1(Grid$2, { item: true, xs: 12, container: true, justifyContent: "center", className: classes.gridItem })] })), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classes.helperText }, { children: [jsx$1(Grid$2, __assign$3({ className: classes.paddingRight }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeM, textClasses.highlightWhite) }, { children: "Need help? Contact" })) })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, 
                            // onClick={onGoToLogin}
                            noPadding: true, underlined: true }, { children: "support@focaldata.com" }))] }))] })) })));
};

var CreatePassword = function (props) {
    var disabled = props.disabled, logoSrc = props.logoSrc, onCreatePassword = props.onCreatePassword;
    var _a = useState(false), loading = _a[0], onLoading = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var classes = useStyles$h().classes;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var minimumLengthCheck = function (password) {
        var minPasswordLen = 8;
        var isValid = password.length >= minPasswordLen;
        return isValid;
    };
    var useOfNumbersCheck = function (password) {
        var isValid = /\d/.test(password);
        return isValid;
    };
    var usingCapitalsCheck = function (password) {
        var isValid = password.toLowerCase() !== password;
        return isValid;
    };
    var handleCreatePassword = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var createPasswordResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    onLoading(true);
                    return [4 /*yield*/, onCreatePassword(password)];
                case 1:
                    createPasswordResponse = _a.sent();
                    if (createPasswordResponse) {
                        onLoading(false);
                    }
                    if (createPasswordResponse instanceof Error) {
                        onLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var isLengthValid = minimumLengthCheck(password);
    var isUsingNumbers = useOfNumbersCheck(password);
    var isUsingCapitals = usingCapitalsCheck(password);
    var isDisabled = !isLengthValid || !isUsingNumbers || !isUsingCapitals || disabled;
    return (jsx$1(Grid$2, __assign$3({ className: classes.page, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ className: classes.maxWidth }, { children: [jsx$1("form", __assign$3({ onSubmit: handleCreatePassword }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", direction: "column", alignItems: "center", className: classes.container }, { children: [jsx$1("img", { className: classes.logo, src: logoSrc, alt: "focaldata-logo" }), jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.weightBold) }, { children: "Set your password for your account" })) })), jsxs(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Password" })), jsx$1(PasswordInput, { fullWidth: true, value: password, onChange: function (event) {
                                            setPassword(event.target.value);
                                        } })] })), jsx$1(PasswordChecklist, { isLengthValid: isLengthValid, isUsingNumbers: isUsingNumbers, isUsingCapitals: isUsingCapitals }), jsx$1(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: jsx$1(SpinnerButton, __assign$3({ onClick: handleCreatePassword, loading: loading, className: classes.button, fullWidth: true, buttonType: ButtonType.Submit, disabled: isDisabled }, { children: "Create password" })) })), jsx$1(Grid$2, { item: true, xs: 12, container: true, justifyContent: "center", className: classes.gridItem })] })) })), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classes.helperText }, { children: [jsx$1(Grid$2, __assign$3({ className: classes.paddingRight }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightWhite) }, { children: "Need help? Contact" })) })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, noPadding: true, underlined: true }, { children: "support@focaldata.com" }))] }))] })) })));
};

var ForgotPassowrd = function (props) {
    var logoSrc = props.logoSrc, onSendEmail = props.onSendEmail, onGoToRegister = props.onGoToRegister;
    var _a = useState(false), loading = _a[0], onLoading = _a[1];
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var classes = useStyles$h().classes;
    var _c = useTextStyles(), textClasses = _c.classes, classNames = _c.cx;
    var handleSubmitEmail = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var sendEmailResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    onLoading(true);
                    return [4 /*yield*/, onSendEmail(email === null || email === void 0 ? void 0 : email.toLowerCase())];
                case 1:
                    sendEmailResponse = _a.sent();
                    if (sendEmailResponse) {
                        onLoading(false);
                    }
                    if (sendEmailResponse instanceof Error) {
                        onLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var isDisabled = email.length === 0 || loading;
    return (jsx$1(Grid$2, __assign$3({ className: classes.page, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ className: classes.maxWidth }, { children: [jsx$1("form", __assign$3({ onSubmit: handleSubmitEmail }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", direction: "column", alignItems: "center", className: classes.container }, { children: [jsx$1("img", { className: classes.logo, src: logoSrc, alt: "focaldata-logo" }), jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.weightBold) }, { children: "Reset your password" })) })), jsxs(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.weightSemiBold) }, { children: "Email" })), jsx$1(Input$6, { fullWidth: true, value: email, onChange: function (event) {
                                            setEmail(event.target.value);
                                        }, variant: InputVariant.Filled })] })), jsx$1(Grid$2, __assign$3({ item: true, container: true, className: classes.gridItem }, { children: jsx$1(SpinnerButton, __assign$3({ onClick: handleSubmitEmail, loading: loading, className: classes.button, fullWidth: true, buttonType: ButtonType.Submit, disabled: isDisabled }, { children: "Send reset email" })) })), jsx$1(Grid$2, { item: true, xs: 12, container: true, justifyContent: "center", className: classes.gridItem })] })) })), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classes.helperText }, { children: [jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classes.helperText }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightWhite) }, { children: "Don't have an account?" })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, onClick: onGoToRegister, noPadding: true, underlined: true }, { children: "Sign up" }))] })), jsx$1(Grid$2, __assign$3({ className: classes.paddingRight }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightWhite) }, { children: "Need help? Contact" })) })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, noPadding: true, underlined: true }, { children: "support@focaldata.com" }))] }))] })) })));
};

var ForgotPasswordSucessful = function (props) {
    var disabled = props.disabled, onClickButton = props.onClickButton;
    var _a = useStyles$h(), classes = _a.classes, classNames = _a.cx;
    var textClasses = useTextStyles().classes;
    return (jsx$1(Grid$2, __assign$3({ className: classes.page, container: true, justifyContent: "center", alignItems: "center" }, { children: jsxs(Grid$2, __assign$3({ className: classes.maxWidth }, { children: [jsxs(Grid$2, __assign$3({ container: true, spacing: 4, justifyContent: "center", direction: "column", alignItems: "center", className: classes.container }, { children: [jsx$1("img", { className: classes.successLogo, src: img$25, alt: "focaldata-logo" }), jsx$1(Grid$2, __assign$3({ item: true, className: classes.gridItem }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeL, textClasses.weightSemiBold) }, { children: "Check your email" })) })), jsx$1(Grid$2, __assign$3({ item: true, container: true, direction: "row", justifyContent: "center", className: classes.paddingRight }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.alignCenter) }, { children: "You will receive an email with instructions about how to reset your password in a few minutes." })) })), jsx$1(Grid$2, __assign$3({ item: true, container: true }, { children: jsx$1(SpinnerButton, __assign$3({ onClick: onClickButton, className: classNames(classes.button, classes.gridItem), fullWidth: true, buttonType: ButtonType.Submit, disabled: disabled }, { children: "Resend email" })) })), jsx$1(Grid$2, { item: true, xs: 12, container: true, justifyContent: "center", className: classes.gridItem })] })), jsxs(Grid$2, __assign$3({ container: true, justifyContent: "center", className: classNames(classes.helperText, classes.gridItem) }, { children: [jsx$1(Grid$2, __assign$3({ className: classes.paddingRight }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightWhite) }, { children: "Need help? Contact" })) })), jsx$1(LinkButton, __assign$3({ highlight: TextHighlight.White, size: TextSize.m, weight: TextWeight.Bold, 
                            // onClick={onGoToLogin}
                            noPadding: true, underlined: true }, { children: "support@focaldata.com" }))] }))] })) })));
};

var useStyles$g = makeStyles()(function (theme) { return ({
    highlight: {
        '&:hover': {
            color: theme.palette.primary.main,
            cursor: 'pointer'
        }
    }
}); });

var Highlight = function (props) {
    var text = props.text, highlight = props.highlight, collapsed = props.collapsed, _a = props.characterLimit, characterLimit = _a === void 0 ? 50 : _a;
    var theme = useTheme();
    var _b = useState(text), collapsedText = _b[0], setCollapsedText = _b[1];
    var _c = useState(false), showMore = _c[0], setShowMore = _c[1];
    var classes = useStyles$g().classes;
    var trimmedHighlight = highlight === null || highlight === void 0 ? void 0 : highlight.trim();
    useEffect(function () {
        if (collapsed) {
            if (showMore) {
                setCollapsedText(text);
            }
            else {
                setCollapsedText(text.substring(0, characterLimit));
            }
        }
    }, [collapsed, text, characterLimit, showMore]);
    if (!trimmedHighlight) {
        return jsx$1("span", { children: text });
    }
    var parts = [];
    var highlightLength = trimmedHighlight === null || trimmedHighlight === void 0 ? void 0 : trimmedHighlight.length;
    for (var i = 0; i < collapsedText.length; i += 1) {
        var foundIdx = collapsedText === null || collapsedText === void 0 ? void 0 : collapsedText.toLowerCase().indexOf(trimmedHighlight === null || trimmedHighlight === void 0 ? void 0 : trimmedHighlight.toLowerCase(), i);
        if (foundIdx > -1) {
            var part1 = collapsedText.substring(i, foundIdx);
            var part2 = collapsedText.substring(foundIdx, foundIdx + highlightLength);
            i = foundIdx + highlightLength - 1;
            parts.push(part1, part2);
        }
        else {
            parts.push(collapsedText.substring(i));
            i = collapsedText.length;
        }
    }
    return (jsxs("span", { children: [parts.map(function (part, index) {
                return (part === null || part === void 0 ? void 0 : part.toLowerCase()) === (trimmedHighlight === null || trimmedHighlight === void 0 ? void 0 : trimmedHighlight.toLowerCase()) ? (jsx$1("span", __assign$3({ style: { color: theme.palette.primary.main } }, { children: part }), index)) : (part);
            }), collapsed && !showMore && text.length > characterLimit && (jsx$1(Tooltip$3, __assign$3({ title: "Show more", placement: "top" }, { children: jsx$1("span", __assign$3({ className: classes.highlight, onClick: function (event) {
                        setShowMore(!showMore);
                        event.preventDefault();
                        event.stopPropagation();
                    }, "aria-hidden": "true" }, { children: ' (...)' })) })))] }));
};

var fdLogoSvgUri = encodeURIComponent('<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 755.90668 113.13333" height="113.13333" width="755.90668" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /></cc:Work></rdf:RDF></metadata><defs id="defs6" /><g transform="matrix(1.3333333,0,0,-1.3333333,0,113.13333)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 1169.15,652.496 c 0,135.84 76.83,195.969 187.06,195.969 25.61,0 44.54,-3.336 44.54,-3.336 V 728.215 c 0,0 -6.68,2.223 -24.5,2.223 -53.44,0 -74.6,-22.266 -74.6,-85.735 v -53.445 h 119.07 V 485.48 H 1301.65 V 13.3594 h -132.5 V 485.48 H 1060.1 v 105.778 h 109.05 v 61.238" /><path id="path16" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 1727.35,116.918 c 96.87,0 168.14,73.484 168.14,184.832 0,112.473 -71.27,185.953 -168.14,185.953 -95.75,0 -167.01,-73.48 -167.01,-185.953 0,-111.348 71.26,-184.832 167.01,-184.832 z M 1427.83,301.75 c 0,162.566 115.8,302.867 299.52,302.867 184.84,0 300.64,-140.301 300.64,-302.867 0,-162.559 -115.8,-301.74609375 -300.64,-301.74609375 -183.72,0 -299.52,139.18709375 -299.52,301.74609375" /><path id="path18" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 2359.75,604.617 c 171.48,0 258.33,-119.137 273.92,-222.691 h -135.84 c -15.59,62.347 -67.92,105.777 -139.19,105.777 -94.65,0 -154.77,-76.832 -154.77,-185.953 0,-107.996 60.12,-184.832 154.77,-184.832 71.27,0 123.6,43.426 139.19,105.777 h 135.84 C 2618.08,119.145 2531.23,0.00390625 2359.75,0.00390625 2189.39,0.00390625 2071.37,134.738 2071.37,301.75 c 0,168.137 118.02,302.867 288.38,302.867" /><path id="path20" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 2911.98,261.66 c -81.28,-12.242 -108,-42.305 -108,-82.39 0,-54.559 38.97,-75.711 102.44,-75.711 106.89,0 159.22,66.804 159.22,144.746 v 36.746 z m -234.94,-86.844 c 0,97.989 69.03,161.454 221.58,182.61 l 167.02,23.387 v 8.906 c 0,70.144 -44.54,105.781 -123.6,105.781 -72.37,0 -113.57,-32.293 -122.47,-85.742 h -129.16 c 11.13,101.328 80.16,194.859 254.98,194.859 169.24,0 249.41,-83.508 249.41,-216.012 V 122.48 c 0,-37.8589 6.68,-85.73 16.7,-109.1206 h -125.82 c -1.11,0 -7.79,28.957 -7.79,75.7148 C 3038.92,30.0625 2972.11,0.00390625 2879.7,0.00390625 2736.05,0.00390625 2677.04,75.7148 2677.04,174.816" /><path id="path22" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 3301.01,13.3594 V 848.465 h 132.5 V 13.3594 h -132.5" /><path id="path24" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 3808.05,487.703 c -100.22,0 -162.57,-80.172 -162.57,-185.953 0,-103.543 62.35,-184.832 162.57,-184.832 101.32,0 162.57,81.289 162.57,184.832 0,105.781 -61.25,185.953 -162.57,185.953 z m 157,360.762 h 132.5 V 13.3594 H 3975.07 V 95.7656 C 3938.32,35.6289 3870.4,0.00390625 3780.21,0.00390625 3609.85,0.00390625 3512.98,136.957 3512.98,301.75 c 0,165.906 96.87,302.867 267.23,302.867 90.19,0 152.54,-40.086 184.84,-89.078 v 332.926" /><path id="path26" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 4411.95,261.66 c -81.28,-12.242 -107.99,-42.305 -107.99,-82.39 0,-54.559 38.96,-75.711 102.43,-75.711 106.89,0 159.24,66.804 159.24,144.746 v 36.746 z m -234.94,-86.844 c 0,97.989 69.04,161.454 221.59,182.61 l 167.03,23.387 v 8.906 c 0,70.144 -44.55,105.781 -123.61,105.781 -72.37,0 -113.57,-32.293 -122.48,-85.742 h -129.16 c 11.13,101.328 80.17,194.859 254.98,194.859 169.25,0 249.43,-83.508 249.43,-216.012 V 122.48 c 0,-37.8589 6.67,-85.73 16.69,-109.1206 h -125.82 c -1.12,0 -7.8,28.957 -7.8,75.7148 C 4538.9,30.0625 4472.09,0.00390625 4379.67,0.00390625 4236.04,0.00390625 4177.01,75.7148 4177.01,174.816" /><path id="path28" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 5076.82,16.6992 c 0,0 -24.51,-6.6797 -69.05,-6.6797 -118.02,0 -169.24,61.2422 -169.24,170.3635 V 485.48 h -87.96 v 105.778 h 87.96 v 150.316 h 132.51 V 591.258 h 108 V 485.48 h -108 V 193.754 c 0,-45.664 18.92,-67.934 64.58,-67.934 22.26,0 41.2,5.571 41.2,5.571 V 16.6992" /><path id="path30" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 5369.77,261.66 c -81.28,-12.242 -108,-42.305 -108,-82.39 0,-54.559 38.96,-75.711 102.43,-75.711 106.89,0 159.23,66.804 159.23,144.746 v 36.746 z m -234.95,-86.844 c 0,97.989 69.04,161.454 221.59,182.61 l 167.02,23.387 v 8.906 c 0,70.144 -44.53,105.781 -123.6,105.781 -72.38,0 -113.58,-32.293 -122.48,-85.742 h -129.17 c 11.15,101.328 80.18,194.859 254.99,194.859 169.25,0 249.42,-83.508 249.42,-216.012 V 122.48 c 0,-37.8589 6.68,-85.73 16.7,-109.1206 h -125.82 c -1.11,0 -7.8,28.957 -7.8,75.7148 C 5496.7,30.0625 5429.9,0.00390625 5337.48,0.00390625 5193.85,0.00390625 5134.82,75.7148 5134.82,174.816" /><path id="path32" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 167.02,514.426 V 681.445 H 0 V 13.3594 H 167.02 V 180.383 347.402 H 334.043 V 514.426 H 167.02" /><path id="path34" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 501.059,681.445 v 167.02 H 167.02 v -167.02 h 167.023 167.016" /><path id="path36" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 501.059,347.402 H 334.043 V 13.3594 H 668.082 V 180.383 H 501.059 v 167.019" /><path id="path38" style="fill:#ff6e5a;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 668.082,848.465 V 514.426 H 501.059 V 347.402 H 668.082 V 180.383 h 167.02 v 167.019 167.024 167.019 167.02 h -167.02" /><path id="path40" style="fill:#ffc5bd;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 167.02,848.465 H 0 v -167.02 h 167.02 v 167.02" /><path id="path42" style="fill:#ffc5bd;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 167.02,13.3594 H 334.043 V 180.383 H 167.02 V 13.3594" /><path id="path44" style="fill:#ffc5bd;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 334.043,514.426 H 501.059 V 681.445 H 334.043 V 514.426" /><path id="path46" style="fill:#ffc5bd;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 668.082,848.465 H 501.059 v -167.02 h 167.023 v 167.02" /><path id="path48" style="fill:#ffc5bd;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 668.082,180.383 V 13.3594 h 167.02 V 180.383 h -167.02" /><path id="path50" style="fill:#ffe2de;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 167.02,681.445 V 514.426 H 334.043 V 681.445 H 167.02" /><path id="path52" style="fill:#ffe2de;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 167.02,180.383 H 334.043 V 347.402 H 167.02 V 180.383" /><path id="path54" style="fill:#ffe2de;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 334.043,514.426 V 347.402 H 501.059 V 514.426 H 334.043" /><path id="path56" style="fill:#ffe2de;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 668.082,681.445 H 501.059 V 514.426 h 167.023 v 167.019" /><path id="path58" style="fill:#ffe2de;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 668.082,180.383 V 347.402 H 501.059 V 180.383 h 167.023" /></g></g></svg>');
var logoWidth = 160;
var logoHeight = 24;
var useStyles$f = makeStyles()(function (theme) { return ({
    button: {
        padding: theme.spacing(0),
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    logo: {
        width: logoWidth,
        height: logoHeight,
        backgroundSize: "".concat(logoWidth, "px ").concat(logoHeight, "px"),
        backgroundImage: "url('data:image/svg+xml;utf8,".concat(fdLogoSvgUri, "')"),
        backgroundRepeat: 'no-repeat',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    header: {
        height: 57,
        borderBottom: "1px solid ".concat(theme.palette.divider),
        padding: theme.spacing(0, 4)
    },
    menuContainer: {
        height: '100%',
        marginRight: "-".concat(theme.spacing(2.5))
    },
    shadow: {
        boxShadow: "0 ".concat(theme.spacing(0.25), " ").concat(theme.spacing(0.75), " 0 rgba(0,0,0,0.1)")
    }
}); });

var Header = function (props) {
    var onClickLogo = props.onClickLogo, rightChild = props.rightChild, _a = props.shadow, shadow = _a === void 0 ? false : _a;
    var _b = useStyles$f(), classes = _b.classes, classNames = _b.cx;
    var className = shadow
        ? classNames(classes.header, classes.shadow)
        : classes.header;
    return (jsxs(Grid$2, __assign$3({ className: className, container: true, justifyContent: "space-between", alignItems: "center" }, { children: [jsx$1(Button$3, __assign$3({ onClick: onClickLogo, disableFocusRipple: true, disableRipple: true, className: classes.button }, { children: jsx$1("div", { className: classes.logo }) })), jsx$1(Grid$2, __assign$3({ className: classes.menuContainer }, { children: rightChild }))] })));
};

var MenuVariant;
(function (MenuVariant) {
    MenuVariant[MenuVariant["Header"] = 0] = "Header";
    MenuVariant[MenuVariant["Body"] = 1] = "Body";
    MenuVariant[MenuVariant["Link"] = 2] = "Link";
    MenuVariant[MenuVariant["SecondaryLink"] = 3] = "SecondaryLink";
    MenuVariant[MenuVariant["QuestionType"] = 4] = "QuestionType";
})(MenuVariant || (MenuVariant = {}));
var MenuItem = React__default.forwardRef(function (props, ref) {
    var _a;
    var classes = props.classes, index = props.index, menuItem = props.menuOption, _b = props.variant, variant = _b === void 0 ? MenuVariant.Header : _b;
    var title = menuItem.title, subtitle = menuItem.subtitle, options = menuItem.options;
    var _c = useState(undefined), hoveredItemIndex = _c[0], setHoveredItemIndex = _c[1];
    var _d = useTextStyles(), textClasses = _d.classes, classNames = _d.cx;
    var menuItemTextSizes = new Map([
        [MenuVariant.Header, TextSize.ms],
        [MenuVariant.Body, TextSize.m],
        [MenuVariant.QuestionType, TextSize.ms]
    ]);
    var menuItemTextSize = menuItemTextSizes.get(variant);
    return (jsxs("div", __assign$3({ className: classes.customMenuItem }, { children: [index !== 0 && jsx$1(Divider$2, {}), title && (jsx$1(ListItem$1, __assign$3({ ref: ref }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "column" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.sizeMs, textClasses.weightBold, textClasses.noWrap, (_a = {}, _a[textClasses.gutterBottom] = !!subtitle, _a)) }, { children: title })), subtitle && (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.sizeS, textClasses.noWrap, textClasses.highlightBackground) }, { children: subtitle })))] })) }))), options &&
                options.map(function (option, index) {
                    var _a;
                    return (jsx$1(MuiMenuItem, __assign$3({ disabled: option.disabled, onClick: option.onClick, classes: { root: classes.option }, onMouseEnter: function () { return setHoveredItemIndex(index); }, onMouseLeave: function () { return setHoveredItemIndex(undefined); } }, { children: jsxs(Grid$2, __assign$3({ container: true, justifyContent: "space-between", alignItems: "center" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, classes.optionText, textClasses.alignLeft, textClasses[(_a = classNameBySize.get(menuItemTextSize !== null && menuItemTextSize !== void 0 ? menuItemTextSize : TextSize.m)) !== null && _a !== void 0 ? _a : 'sizeM'], textClasses.noWrap, hoveredItemIndex === index
                                        ? textClasses.highlightPrimary
                                        : textClasses.highlightEmphasis) }, { children: option.text })), option.iconName && (jsx$1(Icon, { name: option.iconName || IconName.SingleChoice, iconColor: hoveredItemIndex === index
                                        ? IconColor$1.Primary
                                        : IconColor$1.Emphasis }))] })) }), "menu-item-".concat(option.text)));
                })] })));
});

var useStyles$e = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        buttonRoot: {
            textTransform: 'none',
            padding: props.variant === MenuVariant.QuestionType ||
                props.variant === MenuVariant.Link ||
                props.variant === MenuVariant.SecondaryLink
                ? theme.spacing(0)
                : theme.spacing(0.5, 1.5, 0.5, 2.5),
            cursor: props.variant === MenuVariant.Link ||
                props.variant === MenuVariant.SecondaryLink
                ? 'auto'
                : 'pointer',
            '&:hover': {
                cursor: props.variant === MenuVariant.Link ||
                    props.variant === MenuVariant.SecondaryLink
                    ? 'auto'
                    : 'pointer',
                backgroundColor: props.variant === MenuVariant.QuestionType ? 'transparent' : undefined
            }
        },
        customMenuItem: {
            padding: theme.spacing(0.25, 0),
            minWidth: theme.spacing(21.625),
            fontSize: '30px'
        },
        list: {
            padding: 0
        },
        menu: {
            borderRadius: theme.spacing(0.25),
            marginTop: 1,
            left: theme.spacing(3)
        },
        menuButton: {
            borderRadius: 0,
            border: 'none',
            height: '100%',
            '&:hover': {
                border: 'none'
            }
        },
        menuButtonBody: {
            borderRadius: 0,
            border: 'none',
            height: '100%',
            minWidth: theme.spacing(21.625),
            '&:hover': {
                border: 'none'
            }
        },
        menuButtonBodyOpen: {
            borderRadius: theme.spacing(0.25),
            border: "1px solid ".concat(theme.palette.secondary.main),
            backgroundColor: theme.palette.secondary.main,
            minWidth: theme.spacing(21.625),
            height: '100%',
            '&:hover': {
                borderRadius: theme.spacing(0.25),
                border: "1px solid ".concat(theme.palette.secondary.main)
            }
        },
        menuButtonBodyClosed: {
            borderRadius: theme.spacing(0.25),
            border: "1px solid ".concat(theme.palette.secondary.main),
            backgroundColor: theme.palette.background.default,
            minWidth: theme.spacing(21.625),
            height: '100%',
            '&:hover': {
                borderRadius: theme.spacing(0.25),
                border: "1px solid ".concat(theme.palette.secondary.main)
            }
        },
        menuButtonLinkOpen: {
            borderRadius: theme.spacing(0.25),
            border: "0px solid ".concat(theme.palette.secondary.main),
            minWidth: theme.spacing(21.625),
            height: '100%',
            '&:hover': {
                borderRadius: theme.spacing(0.25),
                border: "0px solid ".concat(theme.palette.secondary.main)
            }
        },
        menuButtonLinkClosed: {
            borderRadius: theme.spacing(0.25),
            border: "0px solid ".concat(theme.palette.secondary.main),
            minWidth: theme.spacing(21.625),
            height: '100%',
            '&:hover': {
                backgroundColor: theme.palette.background.default,
                cursor: 'auto',
                borderRadius: theme.spacing(0.25),
                border: "0px solid ".concat(theme.palette.secondary.main)
            }
        },
        option: {
            '&:hover': {
                backgroundColor: 'transparent'
            }
        },
        optionText: {
            '&:hover': {
                color: theme.palette.primary.main
            }
        },
        subtitle: {
            marginTop: theme.spacing(-0.5),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '8rem'
        },
        title: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: props.titleWidth ? props.titleWidth : '7rem'
        },
        titleBodyOpen: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '7rem',
            color: theme.palette.background.default
        },
        titleBodyClosed: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '7rem',
            color: theme.palette.secondary.main
        },
        titleLinkOpen: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '7rem',
            color: theme.palette.secondary.main,
            '&:hover': {
                color: theme.palette.primary.main,
                cursor: 'pointer'
            }
        },
        titleLinkClosed: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '7rem',
            color: theme.palette.secondary.main,
            '&:hover': {
                color: theme.palette.primary.main,
                cursor: 'pointer'
            }
        },
        iconOpen: {
            color: theme.palette.secondary.main
        },
        iconOpenBody: {
            color: theme.palette.secondary.main
        },
        iconClosed: {
            color: theme.palette.secondary.main
        },
        iconClosedBody: {
            color: theme.palette.background.default
        }
    });
});

var Menu = function (props) {
    var _a, _b;
    var menuItems = props.menuOptions, title = props.title, titleWidth = props.titleWidth, subtitle = props.subtitle, _c = props.variant, variant = _c === void 0 ? MenuVariant.Header : _c;
    var classes = useStyles$e({ styleProps: { titleWidth: titleWidth, variant: variant } }).classes;
    var _d = useTextStyles(), textClasses = _d.classes, classNames = _d.cx;
    var _e = React__default.useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var handleClick = function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var titleTextSizes = new Map([
        [MenuVariant.Header, TextSize.s],
        [MenuVariant.Body, TextSize.m],
        [MenuVariant.Link, TextSize.m],
        [MenuVariant.SecondaryLink, TextSize.m],
        [MenuVariant.QuestionType, TextSize.ms]
    ]);
    var titleTextWeights = new Map([
        [MenuVariant.Header, TextWeight.Bold],
        [MenuVariant.Body, TextWeight.Bold],
        [MenuVariant.Link, TextWeight.SemiBold],
        [MenuVariant.SecondaryLink, TextWeight.Regular],
        [MenuVariant.QuestionType, TextWeight.Regular]
    ]);
    var iconOpenClasses = new Map([
        [MenuVariant.Header, classes.iconOpen],
        [MenuVariant.Body, classes.iconOpenBody]
    ]);
    var iconClosedClasses = new Map([
        [MenuVariant.Header, classes.iconClosed],
        [MenuVariant.Body, classes.iconClosedBody]
    ]);
    var titleTextSize = titleTextSizes.get(variant);
    var titleTextWeight = titleTextWeights.get(variant);
    var classIconOpen = iconOpenClasses.get(variant);
    var classIconClosed = iconClosedClasses.get(variant);
    var TextClassClassMap = new Map([
        [MenuVariant.Body, classes.titleBodyOpen],
        [MenuVariant.Link, classes.titleLinkOpen],
        [MenuVariant.SecondaryLink, classes.titleLinkOpen]
    ]);
    var TextClassAnchoredClassMap = new Map([
        [MenuVariant.Body, classes.titleBodyClosed],
        [MenuVariant.Link, classes.titleLinkClosed],
        [MenuVariant.SecondaryLink, classes.titleLinkClosed]
    ]);
    var textClass = anchorEl
        ? TextClassClassMap.get(variant)
        : TextClassAnchoredClassMap.get(variant);
    var MenuButtonClassMap = new Map([
        [MenuVariant.Body, classes.menuButtonBodyOpen],
        [MenuVariant.Link, classes.menuButtonLinkOpen],
        [MenuVariant.SecondaryLink, classes.menuButtonLinkOpen]
    ]);
    var MenuButtonAnchoredClassMap = new Map([
        [MenuVariant.Body, classes.menuButtonBodyClosed],
        [MenuVariant.Link, classes.menuButtonLinkClosed],
        [MenuVariant.SecondaryLink, classes.menuButtonLinkClosed]
    ]);
    var getChevron = function (variant) {
        if (variant !== MenuVariant.Link && variant !== MenuVariant.SecondaryLink) {
            return !anchorEl ? (jsx$1(KeyboardArrowDown, { className: classIconOpen })) : (jsx$1(KeyboardArrowUp, { className: classIconClosed }));
        }
        return null;
    };
    var menuButtonClass = anchorEl
        ? MenuButtonClassMap.get(variant)
        : MenuButtonAnchoredClassMap.get(variant);
    return (jsxs(Button$3, __assign$3({ disableTouchRipple: true, className: menuButtonClass || classes.menuButton, classes: { root: classes.buttonRoot }, color: "secondary", onClick: handleClick, variant: "outlined" }, { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "column", justifyContent: "flex-start", alignContent: "center" }, { children: [title && (jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.highlightBackground, textClasses.noWrap, textClasses[(_a = classNameBySize.get(titleTextSize !== null && titleTextSize !== void 0 ? titleTextSize : TextSize.s)) !== null && _a !== void 0 ? _a : 'sizeS'], textClasses[(_b = classNameByWeight.get(titleTextWeight !== null && titleTextWeight !== void 0 ? titleTextWeight : TextWeight.Bold)) !== null && _b !== void 0 ? _b : 'weightBold'], textClass) }, { children: title })), getChevron(variant)] }))), subtitle && (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.alignLeft, textClasses.highlightBackground, textClasses.noWrap, textClasses.sizeS, classes.subtitle) }, { children: subtitle })))] })), jsx$1(MuiMenu, __assign$3({ id: "customized-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, color: "secondary", classes: { paper: classes.menu, list: classes.list }, elevation: 1, 
                // getContentAnchorEl={null}
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                } }, { children: menuItems.map(function (menuItem, index) {
                    return (jsx$1(MenuItem, { menuOption: menuItem, index: index, variant: variant, classes: classes }, "menu-item-".concat(menuItem.id)));
                }) }))] })));
};

var useStyles$d = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        paperStyle: {
            width: '100%'
        },
        paperItemPadding: {
            padding: theme.spacing(props.paddingTopBottom, 3)
        }
    });
});

var PaperGroupItem = function (props) {
    var children = props.children, _a = props.paddingTopBottom, paddingTopBottom = _a === void 0 ? 3 : _a;
    var classes = useStyles$d({ styleProps: { paddingTopBottom: paddingTopBottom } }).classes;
    return (jsxs(Grid$2, __assign$3({ container: true, direction: "column" }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, className: classes.paperItemPadding }, { children: children })), jsx$1(Divider$2, {})] })));
};

var useStyles$c = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    return ({
        subheader: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            zIndex: 1300,
            padding: theme.spacing(props.topBottomPadding, props.leftRightPadding)
        },
        shadow: {
            boxShadow: "0 ".concat(theme.spacing(0.5), " ").concat(theme.spacing(0.25), " -").concat(theme.spacing(0.25), " rgba(0,0,0,0.1)")
        }
    });
});

var Subheader = function (props) {
    var leftChild = props.leftChild, rightChild = props.rightChild, _a = props.topBottomPadding, topBottomPadding = _a === void 0 ? false : _a, _b = props.leftRightPadding, leftRightPadding = _b === void 0 ? true : _b, _c = props.shadow, shadow = _c === void 0 ? false : _c;
    var _d = useStyles$c({
        styleProps: {
            topBottomPadding: topBottomPadding ? 1 : 0,
            leftRightPadding: leftRightPadding ? 8 : 4
        }
    }), classes = _d.classes, classNames = _d.cx;
    var className = shadow
        ? classNames(classes.subheader, classes.shadow)
        : classes.subheader;
    return (jsxs(Grid$2, __assign$3({ className: className, container: true, justifyContent: "space-between", alignItems: "center" }, { children: [leftChild, rightChild] })));
};

var BORDER_RADIUS$2 = theme.spacing(0.25);
var useStyles$b = makeStyles()(function (theme) { return ({
    completeStyle: {
        borderRadius: BORDER_RADIUS$2,
        color: 'white',
        backgroundColor: theme.palette.success.main,
        '&.MuiChip-outlined': {
            color: theme.palette.success.main,
            borderColor: theme.palette.success.main,
            backgroundColor: additionalPalette.transparent
        }
    },
    draftStyle: {
        borderRadius: BORDER_RADIUS$2,
        color: 'white',
        backgroundColor: theme.palette.text.secondary,
        '&.MuiChip-outlined': {
            color: theme.palette.text.secondary,
            borderColor: theme.palette.text.secondary,
            backgroundColor: additionalPalette.transparent
        }
    },
    liveStyle: {
        borderRadius: BORDER_RADIUS$2,
        color: 'white',
        backgroundColor: additionalPalette.liveBlue.main,
        '&.MuiChip-outlined': {
            color: additionalPalette.liveBlue.main,
            borderColor: additionalPalette.liveBlue.main,
            backgroundColor: additionalPalette.transparent
        }
    }
}); });

var Status$1;
(function (Status) {
    Status[Status["COMPLETE"] = 0] = "COMPLETE";
    Status[Status["DRAFT"] = 1] = "DRAFT";
    Status[Status["LIVE"] = 2] = "LIVE";
    Status[Status["PAUSED"] = 3] = "PAUSED";
    Status[Status["HALTED"] = 4] = "HALTED";
    Status[Status["SCHEDULED"] = 5] = "SCHEDULED";
})(Status$1 || (Status$1 = {}));
var Variant;
(function (Variant) {
    Variant["filled"] = "filled";
    Variant["outlined"] = "outlined";
})(Variant || (Variant = {}));
var Badge = function (props) {
    var status = props.status, style = props.style, className = props.className, _a = props.variant, variant = _a === void 0 ? Variant.outlined : _a, label = props.label, tooltipText = props.tooltipText;
    var _b = useStyles$b(), classes = _b.classes, classNames = _b.cx;
    var statusToClassMap = new Map([
        [Status$1.DRAFT, classes.draftStyle],
        [Status$1.SCHEDULED, classes.draftStyle],
        [Status$1.LIVE, classes.liveStyle],
        [Status$1.PAUSED, classes.draftStyle],
        [Status$1.HALTED, classes.draftStyle],
        [Status$1.COMPLETE, classes.completeStyle]
    ]);
    var rootCssClass = statusToClassMap.get(status) || classes.draftStyle;
    return tooltipText ? (jsx$1(Tooltip$1, __assign$3({ title: tooltipText, tipPlacement: TipPlacement.Top }, { children: jsx$1(MuiChip, { variant: variant || 'filled', style: style, label: label, className: classNames(rootCssClass, className) }) }))) : (jsx$1(MuiChip, { variant: variant || 'filled', style: style, label: label, className: classNames(rootCssClass, className) }));
};

var useStyles$a = makeStyles()(function (theme) { return ({
    cardContentStyle: {
        padding: theme.spacing(2),
        minHeight: theme.spacing(9.75)
    },
    cardStyle: {
        cursor: 'pointer',
        borderLeft: "".concat(theme.spacing(0.25), " solid transparent"),
        borderRadius: theme.spacing(0.25),
        padding: theme.spacing(1.25),
        marginBottom: theme.spacing(2),
        width: '100%',
        '&:hover': {
            borderLeft: "".concat(theme.spacing(0.25), " solid ").concat(theme.palette.secondary.main),
            boxShadow: "\n        ".concat(theme.spacing(0.25), "\n        ").concat(theme.spacing(0.25), "\n        ").concat(theme.spacing(1), "\n        ").concat(theme.spacing(0.25), "\n        rgba(0, 0, 0, 0.1)")
        }
    },
    statusDiv: {
        marginRight: theme.spacing(1)
    },
    listItemStyle: {
        width: '100%',
        paddingBottom: theme.spacing(0)
    },
    projectDetails: {
        marginTop: theme.spacing(0.5)
    },
    projectItem: {
        maxWidth: '25%',
        paddingRight: theme.spacing(2.5)
    },
    lastProjectItem: {
        maxWidth: '25%'
    }
}); });

var BORDER_RADIUS$1 = theme.spacing(0.25);
var useStyles$9 = makeStyles()(function (theme) { return ({
    completeStyle: {
        borderRadius: BORDER_RADIUS$1,
        color: theme.palette.success.main,
        borderColor: theme.palette.success.main
    },
    draftStyle: {
        borderRadius: BORDER_RADIUS$1,
        color: theme.palette.text.secondary,
        borderColor: theme.palette.text.secondary
    },
    liveStyle: {
        borderRadius: BORDER_RADIUS$1,
        color: additionalPalette.liveBlue.main,
        borderColor: additionalPalette.liveBlue.main
    }
}); });

var Status;
(function (Status) {
    Status[Status["COMPLETE"] = 0] = "COMPLETE";
    Status[Status["DRAFT"] = 1] = "DRAFT";
    Status[Status["LIVE"] = 2] = "LIVE";
    Status[Status["PAUSED"] = 3] = "PAUSED";
    Status[Status["HALTED"] = 4] = "HALTED";
    Status[Status["SCHEDULED"] = 5] = "SCHEDULED";
})(Status || (Status = {}));
var stringStatusEnumMap$1 = new Map([
    [Status.DRAFT, 'DRAFT'],
    [Status.SCHEDULED, 'SCHEDULED'],
    [Status.LIVE, 'LIVE'],
    [Status.PAUSED, 'PAUSED'],
    [Status.HALTED, 'HALTED'],
    [Status.COMPLETE, 'COMPLETE']
]);
var StatusBadge = function (props) {
    var status = props.status, style = props.style, className = props.className;
    var _a = useStyles$9(), classes = _a.classes, classNames = _a.cx;
    var statusToClassMap = new Map([
        [Status.DRAFT, classes.draftStyle],
        [Status.SCHEDULED, classes.draftStyle],
        [Status.LIVE, classes.liveStyle],
        [Status.PAUSED, classes.draftStyle],
        [Status.HALTED, classes.draftStyle],
        [Status.COMPLETE, classes.completeStyle]
    ]);
    var label = stringStatusEnumMap$1.get(status) || 'DRAFT';
    var rootCssClass = statusToClassMap.get(status) || classes.draftStyle;
    return (jsx$1(MuiChip, { variant: "outlined", style: style, label: label, className: classNames(rootCssClass, className) }));
};

var ProjectType;
(function (ProjectType) {
    ProjectType["AdHoc"] = "AdHoc";
    ProjectType["MultiMarket"] = "MultiMarket";
})(ProjectType || (ProjectType = {}));
var stringToStatusMap = new Map([
    ['draft', Status.DRAFT],
    ['scheduled', Status.SCHEDULED],
    ['live', Status.LIVE],
    ['paused', Status.PAUSED],
    ['halted', Status.HALTED],
    ['completed', Status.COMPLETE]
]);
var stringStatusEnumMap = new Map([
    [Status.DRAFT, 'DRAFT'],
    [Status.SCHEDULED, 'SCHEDULED'],
    [Status.LIVE, 'LIVE'],
    [Status.PAUSED, 'PAUSED'],
    [Status.HALTED, 'HALTED'],
    [Status.COMPLETE, 'COMPLETE']
]);
var stringProjectTypeEnumMap = new Map([
    [ProjectType.AdHoc, 'AD HOC'],
    [ProjectType.MultiMarket, 'MULTI MARKET']
]);
var getKebabMenuOptions = function (args) {
    var project = args.project, onDuplicateProject = args.onDuplicateProject, onDeleteProject = args.onDeleteProject, onPauseProject = args.onPauseProject, onUnpauseProject = args.onUnpauseProject;
    var status = project.status;
    var commonOptions = [
        {
            id: 0,
            textItem: 'Duplicate project',
            onClickItem: function () { return onDuplicateProject && onDuplicateProject(project); },
            iconName: IconName.Duplicate,
            iconSize: IconSize$1.Large
        }
    ];
    switch (stringToStatusMap.get(status)) {
        case Status.DRAFT:
            return __spreadArray(__spreadArray([], commonOptions, true), [
                {
                    id: 1,
                    textItem: 'Delete project',
                    onClickItem: function () { return onDeleteProject && onDeleteProject(project); },
                    iconName: IconName.DeleteOutline,
                    iconSize: IconSize$1.Large
                }
            ], false);
        case Status.LIVE:
            return __spreadArray([
                {
                    id: 1,
                    textItem: 'Pause project',
                    onClickItem: function () { return onPauseProject && onPauseProject(project); },
                    iconName: IconName.PauseCircleOutline,
                    iconSize: IconSize$1.Large
                }
            ], commonOptions, true);
        case Status.PAUSED:
            return __spreadArray([
                {
                    id: 1,
                    textItem: 'Unpause project',
                    onClickItem: function () { return onUnpauseProject && onUnpauseProject(project); },
                    iconName: IconName.PlayCircleOutline,
                    iconSize: IconSize$1.Large
                }
            ], commonOptions, true);
        default:
            return commonOptions;
    }
};

// eslint-disable-next-line complexity
var ListItemProject = function (props) {
    var project = props.project, style = props.style, onClickProject = props.onClickProject, onDuplicateProject = props.onDuplicateProject, onPauseProject = props.onPauseProject, onUnpauseProject = props.onUnpauseProject, onDeleteProject = props.onDeleteProject, dataCy = props.dataCy;
    var creator = project.creator, completionDate = project.completionDate, lastUpdate = project.lastUpdate, percent = project.percent, progress = project.progress, status = project.status, title = project.title, projectType = project.projectType;
    var classes = useStyles$a().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    var isMultiMarket = projectType === ProjectType.MultiMarket;
    var showProgress = !isMultiMarket && progress;
    var showCompletionDate = !isMultiMarket && completionDate;
    var showLastUpdate = lastUpdate;
    var showCreator = !isMultiMarket && creator;
    var badgeLabel = !isMultiMarket
        ? stringStatusEnumMap.get(stringToStatusMap.get(status) || Status$1.COMPLETE)
        : stringProjectTypeEnumMap.get(projectType);
    var badgeStatus = !isMultiMarket
        ? stringToStatusMap.get(status) || Status$1.COMPLETE
        : Status$1.LIVE;
    return (jsx$1(ListItem$1, __assign$3({ className: classes.listItemStyle, component: "li", "data-cy": dataCy }, { children: jsx$1(Paper$2, __assign$3({ onClick: function () {
                onClickProject && onClickProject();
            }, className: classes.cardStyle, style: style, elevation: 1 }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "space-between", alignItems: "center", className: classes.cardContentStyle }, { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "column", item: true, xs: 10 }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeM, textClasses.weightSemiBold) }, { children: title })), jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "row", className: classes.projectDetails }, { children: [showProgress && (jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "column", className: classes.projectItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightSemiBold) }, { children: "Progress:\u00A0" })), jsxs(Grid$2, __assign$3({ container: true, direction: "row" }, { children: [jsxs("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightRegular) }, { children: [progress, "\u00A0"] })), jsxs("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightRegular) }, { children: ["(", percent, "%)"] }))] }))] }))), showCompletionDate && (jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "column", className: classes.projectItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightSemiBold) }, { children: "Completion date:\u00A0" })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground) }, { children: completionDate }))] }))), showLastUpdate && (jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "column", className: classes.projectItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightSemiBold) }, { children: "Last status update:\u00A0" })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightRegular) }, { children: lastUpdate }))] }))), showCreator && (jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "column", className: classes.lastProjectItem }, { children: [jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightSemiBold) }, { children: "Creator:\u00A0" })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeS, textClasses.highlightBackground, textClasses.weightRegular) }, { children: creator }))] })))] }))] })), jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsxs(Grid$2, __assign$3({ container: true, item: true, justifyContent: "center", alignItems: "center" }, { children: [jsx$1(Badge, { label: badgeLabel, status: badgeStatus, className: classes.statusDiv }), !isMultiMarket && (jsx$1(KebabMenu, { kebabMenuOptions: getKebabMenuOptions({
                                        project: project,
                                        onDuplicateProject: onDuplicateProject,
                                        onPauseProject: onPauseProject,
                                        onUnpauseProject: onUnpauseProject,
                                        onDeleteProject: onDeleteProject
                                    }) }))] })) }))] })) })) })));
};

var ListItemProjectLoading = function () {
    var classes = useStyles$a().classes;
    return (jsx$1(ListItem$1, __assign$3({ className: classes.listItemStyle, component: "li" }, { children: jsx$1(Paper$2, __assign$3({ className: classes.cardStyle, elevation: 1 }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "row", justifyContent: "space-between", alignItems: "center", className: classes.cardContentStyle }, { children: [jsxs(Grid$2, __assign$3({ container: true, direction: "column", item: true, xs: 10 }, { children: [jsx$1(Skeleton, { height: 32, width: 160 }), jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "row", xs: 12, className: classes.projectDetails }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, direction: "row", xs: 3 }, { children: jsx$1(Skeleton, { height: 24, width: 46 }) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, direction: "row", xs: 3 }, { children: jsx$1(Skeleton, { height: 24, width: 46 }) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, direction: "row", xs: 3 }, { children: jsx$1(Skeleton, { height: 24, width: 46 }) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, direction: "row", xs: 3 }, { children: jsx$1(Skeleton, { height: 24, width: 46 }) }))] }))] })), jsx$1(Grid$2, { item: true, xs: "auto" })] })) })) })));
};

/*!
 * Chart.js v3.7.0
 * https://www.chartjs.org
 * (c) 2021 Chart.js Contributors
 * Released under the MIT License
 */
const requestAnimFrame = (function() {
  if (typeof window === 'undefined') {
    return function(callback) {
      return callback();
    };
  }
  return window.requestAnimationFrame;
}());
function throttled(fn, thisArg, updateFn) {
  const updateArgs = updateFn || ((args) => Array.prototype.slice.call(args));
  let ticking = false;
  let args = [];
  return function(...rest) {
    args = updateArgs(rest);
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, args);
      });
    }
  };
}
function debounce$2(fn, delay) {
  let timeout;
  return function(...args) {
    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
const _toLeftRightCenter = (align) => align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
const _alignStartEnd = (align, start, end) => align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
const _textX = (align, left, right, rtl) => {
  const check = rtl ? 'left' : 'right';
  return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};

function noop$1() {}
const uid = (function() {
  let id = 0;
  return function() {
    return id++;
  };
}());
function isNullOrUndef(value) {
  return value === null || typeof value === 'undefined';
}
function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type = Object.prototype.toString.call(value);
  if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
    return true;
  }
  return false;
}
function isObject$1(value) {
  return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
const isNumberFinite = (value) => (typeof value === 'number' || value instanceof Number) && isFinite(+value);
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
function valueOrDefault(value, defaultValue) {
  return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension) =>
  typeof value === 'string' && value.endsWith('%') ?
    parseFloat(value) / 100
    : value / dimension;
const toDimension = (value, dimension) =>
  typeof value === 'string' && value.endsWith('%') ?
    parseFloat(value) / 100 * dimension
    : +value;
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === 'function') {
    return fn.apply(thisArg, args);
  }
}
function each(loopable, fn, thisArg, reverse) {
  let i, len, keys;
  if (isArray(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject$1(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
function clone$1(source) {
  if (isArray(source)) {
    return source.map(clone$1);
  }
  if (isObject$1(source)) {
    const target = Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k = 0;
    for (; k < klen; ++k) {
      target[keys[k]] = clone$1(source[keys[k]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}
function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject$1(tval) && isObject$1(sval)) {
    merge$1(tval, sval, options);
  } else {
    target[key] = clone$1(sval);
  }
}
function merge$1(target, source, options) {
  const sources = isArray(source) ? source : [source];
  const ilen = sources.length;
  if (!isObject$1(target)) {
    return target;
  }
  options = options || {};
  const merger = options.merger || _merger;
  for (let i = 0; i < ilen; ++i) {
    source = sources[i];
    if (!isObject$1(source)) {
      continue;
    }
    const keys = Object.keys(source);
    for (let k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, source, options);
    }
  }
  return target;
}
function mergeIf(target, source) {
  return merge$1(target, source, {merger: _mergerIf});
}
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject$1(tval) && isObject$1(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone$1(sval);
  }
}
const emptyString = '';
const dot = '.';
function indexOfDotOrLength(key, start) {
  const idx = key.indexOf(dot, start);
  return idx === -1 ? key.length : idx;
}
function resolveObjectKey(obj, key) {
  if (key === emptyString) {
    return obj;
  }
  let pos = 0;
  let idx = indexOfDotOrLength(key, pos);
  while (obj && idx > pos) {
    obj = obj[key.substr(pos, idx - pos)];
    pos = idx + 1;
    idx = indexOfDotOrLength(key, pos);
  }
  return obj;
}
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value) => typeof value !== 'undefined';
const isFunction = (value) => typeof value === 'function';
const setsEqual = (a, b) => {
  if (a.size !== b.size) {
    return false;
  }
  for (const item of a) {
    if (!b.has(item)) {
      return false;
    }
  }
  return true;
};
function _isClickEvent(e) {
  return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}

const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function niceNum(range) {
  const roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
  const niceRange = Math.pow(10, Math.floor(log10(range)));
  const fraction = range / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a, b) => a - b).pop();
  return result;
}
function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}
function almostWhole(x, epsilon) {
  const rounded = Math.round(x);
  return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
}
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }
  let e = 1;
  let p = 0;
  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }
  return p;
}
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < (-0.5 * PI)) {
    angle += TAU;
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}
function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}
function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  const a = _normalizeAngle(angle);
  const s = _normalizeAngle(start);
  const e = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s - a);
  const angleToEnd = _normalizeAngle(e - a);
  const startToAngle = _normalizeAngle(a - s);
  const endToAngle = _normalizeAngle(a - e);
  return a === s || a === e || (sameAngleIsFullCircle && s === e)
    || (angleToStart > angleToEnd && startToAngle < endToAngle);
}
function _limitValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
function _isBetween(value, start, end, epsilon = 1e-6) {
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}

const atEdge = (t) => t === 0 || t === 1;
const elasticIn = (t, s, p) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p) => Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
const effects = {
  linear: t => t,
  easeInQuad: t => t * t,
  easeOutQuad: t => -t * (t - 2),
  easeInOutQuad: t => ((t /= 0.5) < 1)
    ? 0.5 * t * t
    : -0.5 * ((--t) * (t - 2) - 1),
  easeInCubic: t => t * t * t,
  easeOutCubic: t => (t -= 1) * t * t + 1,
  easeInOutCubic: t => ((t /= 0.5) < 1)
    ? 0.5 * t * t * t
    : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: t => t * t * t * t,
  easeOutQuart: t => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: t => ((t /= 0.5) < 1)
    ? 0.5 * t * t * t * t
    : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: t => t * t * t * t * t,
  easeOutQuint: t => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: t => ((t /= 0.5) < 1)
    ? 0.5 * t * t * t * t * t
    : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: t => -Math.cos(t * HALF_PI) + 1,
  easeOutSine: t => Math.sin(t * HALF_PI),
  easeInOutSine: t => -0.5 * (Math.cos(PI * t) - 1),
  easeInExpo: t => (t === 0) ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: t => (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: t => atEdge(t) ? t : t < 0.5
    ? 0.5 * Math.pow(2, 10 * (t * 2 - 1))
    : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: t => (t >= 1) ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: t => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: t => ((t /= 0.5) < 1)
    ? -0.5 * (Math.sqrt(1 - t * t) - 1)
    : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: t => atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
  easeOutElastic: t => atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
  easeInOutElastic(t) {
    const s = 0.1125;
    const p = 0.45;
    return atEdge(t) ? t :
      t < 0.5
        ? 0.5 * elasticIn(t * 2, s, p)
        : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack(t) {
    const s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack(t) {
    const s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack(t) {
    let s = 1.70158;
    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
    }
    return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
  },
  easeInBounce: t => 1 - effects.easeOutBounce(1 - t),
  easeOutBounce(t) {
    const m = 7.5625;
    const d = 2.75;
    if (t < (1 / d)) {
      return m * t * t;
    }
    if (t < (2 / d)) {
      return m * (t -= (1.5 / d)) * t + 0.75;
    }
    if (t < (2.5 / d)) {
      return m * (t -= (2.25 / d)) * t + 0.9375;
    }
    return m * (t -= (2.625 / d)) * t + 0.984375;
  },
  easeInOutBounce: t => (t < 0.5)
    ? effects.easeInBounce(t * 2) * 0.5
    : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5,
};

/*!
 * @kurkle/color v0.1.9
 * https://github.com/kurkle/color#readme
 * (c) 2020 Jukka Kurkela
 * Released under the MIT License
 */
const map$2 = {0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15};
const hex$2 = '0123456789ABCDEF';
const h1 = (b) => hex$2[b & 0xF];
const h2 = (b) => hex$2[(b & 0xF0) >> 4] + hex$2[b & 0xF];
const eq = (b) => (((b & 0xF0) >> 4) === (b & 0xF));
function isShort(v) {
	return eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
}
function hexParse(str) {
	var len = str.length;
	var ret;
	if (str[0] === '#') {
		if (len === 4 || len === 5) {
			ret = {
				r: 255 & map$2[str[1]] * 17,
				g: 255 & map$2[str[2]] * 17,
				b: 255 & map$2[str[3]] * 17,
				a: len === 5 ? map$2[str[4]] * 17 : 255
			};
		} else if (len === 7 || len === 9) {
			ret = {
				r: map$2[str[1]] << 4 | map$2[str[2]],
				g: map$2[str[3]] << 4 | map$2[str[4]],
				b: map$2[str[5]] << 4 | map$2[str[6]],
				a: len === 9 ? (map$2[str[7]] << 4 | map$2[str[8]]) : 255
			};
		}
	}
	return ret;
}
function hexString(v) {
	var f = isShort(v) ? h1 : h2;
	return v
		? '#' + f(v.r) + f(v.g) + f(v.b) + (v.a < 255 ? f(v.a) : '')
		: v;
}
function round(v) {
	return v + 0.5 | 0;
}
const lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
	return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
	return lim(round(v * 255), 0, 255);
}
function b2n(v) {
	return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
	return lim(round(v * 100), 0, 100);
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
	const m = RGB_RE.exec(str);
	let a = 255;
	let r, g, b;
	if (!m) {
		return;
	}
	if (m[7] !== r) {
		const v = +m[7];
		a = 255 & (m[8] ? p2b(v) : v * 255);
	}
	r = +m[1];
	g = +m[3];
	b = +m[5];
	r = 255 & (m[2] ? p2b(r) : r);
	g = 255 & (m[4] ? p2b(g) : g);
	b = 255 & (m[6] ? p2b(b) : b);
	return {
		r: r,
		g: g,
		b: b,
		a: a
	};
}
function rgbString(v) {
	return v && (
		v.a < 255
			? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})`
			: `rgb(${v.r}, ${v.g}, ${v.b})`
	);
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
	const a = s * Math.min(l, 1 - l);
	const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
	const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
	return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
	const rgb = hsl2rgbn(h, 1, 0.5);
	let i;
	if (w + b > 1) {
		i = 1 / (w + b);
		w *= i;
		b *= i;
	}
	for (i = 0; i < 3; i++) {
		rgb[i] *= 1 - w - b;
		rgb[i] += w;
	}
	return rgb;
}
function rgb2hsl(v) {
	const range = 255;
	const r = v.r / range;
	const g = v.g / range;
	const b = v.b / range;
	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	const l = (max + min) / 2;
	let h, s, d;
	if (max !== min) {
		d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		h = max === r
			? ((g - b) / d) + (g < b ? 6 : 0)
			: max === g
				? (b - r) / d + 2
				: (r - g) / d + 4;
		h = h * 60 + 0.5;
	}
	return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
	return (
		Array.isArray(a)
			? f(a[0], a[1], a[2])
			: f(a, b, c)
	).map(n2b);
}
function hsl2rgb$2(h, s, l) {
	return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
	return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
	return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
	return (h % 360 + 360) % 360;
}
function hueParse(str) {
	const m = HUE_RE.exec(str);
	let a = 255;
	let v;
	if (!m) {
		return;
	}
	if (m[5] !== v) {
		a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
	}
	const h = hue(+m[2]);
	const p1 = +m[3] / 100;
	const p2 = +m[4] / 100;
	if (m[1] === 'hwb') {
		v = hwb2rgb(h, p1, p2);
	} else if (m[1] === 'hsv') {
		v = hsv2rgb(h, p1, p2);
	} else {
		v = hsl2rgb$2(h, p1, p2);
	}
	return {
		r: v[0],
		g: v[1],
		b: v[2],
		a: a
	};
}
function rotate(v, deg) {
	var h = rgb2hsl(v);
	h[0] = hue(h[0] + deg);
	h = hsl2rgb$2(h);
	v.r = h[0];
	v.g = h[1];
	v.b = h[2];
}
function hslString(v) {
	if (!v) {
		return;
	}
	const a = rgb2hsl(v);
	const h = a[0];
	const s = n2p(a[1]);
	const l = n2p(a[2]);
	return v.a < 255
		? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})`
		: `hsl(${h}, ${s}%, ${l}%)`;
}
const map$1$1 = {
	x: 'dark',
	Z: 'light',
	Y: 're',
	X: 'blu',
	W: 'gr',
	V: 'medium',
	U: 'slate',
	A: 'ee',
	T: 'ol',
	S: 'or',
	B: 'ra',
	C: 'lateg',
	D: 'ights',
	R: 'in',
	Q: 'turquois',
	E: 'hi',
	P: 'ro',
	O: 'al',
	N: 'le',
	M: 'de',
	L: 'yello',
	F: 'en',
	K: 'ch',
	G: 'arks',
	H: 'ea',
	I: 'ightg',
	J: 'wh'
};
const names = {
	OiceXe: 'f0f8ff',
	antiquewEte: 'faebd7',
	aqua: 'ffff',
	aquamarRe: '7fffd4',
	azuY: 'f0ffff',
	beige: 'f5f5dc',
	bisque: 'ffe4c4',
	black: '0',
	blanKedOmond: 'ffebcd',
	Xe: 'ff',
	XeviTet: '8a2be2',
	bPwn: 'a52a2a',
	burlywood: 'deb887',
	caMtXe: '5f9ea0',
	KartYuse: '7fff00',
	KocTate: 'd2691e',
	cSO: 'ff7f50',
	cSnflowerXe: '6495ed',
	cSnsilk: 'fff8dc',
	crimson: 'dc143c',
	cyan: 'ffff',
	xXe: '8b',
	xcyan: '8b8b',
	xgTMnPd: 'b8860b',
	xWay: 'a9a9a9',
	xgYF: '6400',
	xgYy: 'a9a9a9',
	xkhaki: 'bdb76b',
	xmagFta: '8b008b',
	xTivegYF: '556b2f',
	xSange: 'ff8c00',
	xScEd: '9932cc',
	xYd: '8b0000',
	xsOmon: 'e9967a',
	xsHgYF: '8fbc8f',
	xUXe: '483d8b',
	xUWay: '2f4f4f',
	xUgYy: '2f4f4f',
	xQe: 'ced1',
	xviTet: '9400d3',
	dAppRk: 'ff1493',
	dApskyXe: 'bfff',
	dimWay: '696969',
	dimgYy: '696969',
	dodgerXe: '1e90ff',
	fiYbrick: 'b22222',
	flSOwEte: 'fffaf0',
	foYstWAn: '228b22',
	fuKsia: 'ff00ff',
	gaRsbSo: 'dcdcdc',
	ghostwEte: 'f8f8ff',
	gTd: 'ffd700',
	gTMnPd: 'daa520',
	Way: '808080',
	gYF: '8000',
	gYFLw: 'adff2f',
	gYy: '808080',
	honeyMw: 'f0fff0',
	hotpRk: 'ff69b4',
	RdianYd: 'cd5c5c',
	Rdigo: '4b0082',
	ivSy: 'fffff0',
	khaki: 'f0e68c',
	lavFMr: 'e6e6fa',
	lavFMrXsh: 'fff0f5',
	lawngYF: '7cfc00',
	NmoncEffon: 'fffacd',
	ZXe: 'add8e6',
	ZcSO: 'f08080',
	Zcyan: 'e0ffff',
	ZgTMnPdLw: 'fafad2',
	ZWay: 'd3d3d3',
	ZgYF: '90ee90',
	ZgYy: 'd3d3d3',
	ZpRk: 'ffb6c1',
	ZsOmon: 'ffa07a',
	ZsHgYF: '20b2aa',
	ZskyXe: '87cefa',
	ZUWay: '778899',
	ZUgYy: '778899',
	ZstAlXe: 'b0c4de',
	ZLw: 'ffffe0',
	lime: 'ff00',
	limegYF: '32cd32',
	lRF: 'faf0e6',
	magFta: 'ff00ff',
	maPon: '800000',
	VaquamarRe: '66cdaa',
	VXe: 'cd',
	VScEd: 'ba55d3',
	VpurpN: '9370db',
	VsHgYF: '3cb371',
	VUXe: '7b68ee',
	VsprRggYF: 'fa9a',
	VQe: '48d1cc',
	VviTetYd: 'c71585',
	midnightXe: '191970',
	mRtcYam: 'f5fffa',
	mistyPse: 'ffe4e1',
	moccasR: 'ffe4b5',
	navajowEte: 'ffdead',
	navy: '80',
	Tdlace: 'fdf5e6',
	Tive: '808000',
	TivedBb: '6b8e23',
	Sange: 'ffa500',
	SangeYd: 'ff4500',
	ScEd: 'da70d6',
	pOegTMnPd: 'eee8aa',
	pOegYF: '98fb98',
	pOeQe: 'afeeee',
	pOeviTetYd: 'db7093',
	papayawEp: 'ffefd5',
	pHKpuff: 'ffdab9',
	peru: 'cd853f',
	pRk: 'ffc0cb',
	plum: 'dda0dd',
	powMrXe: 'b0e0e6',
	purpN: '800080',
	YbeccapurpN: '663399',
	Yd: 'ff0000',
	Psybrown: 'bc8f8f',
	PyOXe: '4169e1',
	saddNbPwn: '8b4513',
	sOmon: 'fa8072',
	sandybPwn: 'f4a460',
	sHgYF: '2e8b57',
	sHshell: 'fff5ee',
	siFna: 'a0522d',
	silver: 'c0c0c0',
	skyXe: '87ceeb',
	UXe: '6a5acd',
	UWay: '708090',
	UgYy: '708090',
	snow: 'fffafa',
	sprRggYF: 'ff7f',
	stAlXe: '4682b4',
	tan: 'd2b48c',
	teO: '8080',
	tEstN: 'd8bfd8',
	tomato: 'ff6347',
	Qe: '40e0d0',
	viTet: 'ee82ee',
	JHt: 'f5deb3',
	wEte: 'ffffff',
	wEtesmoke: 'f5f5f5',
	Lw: 'ffff00',
	LwgYF: '9acd32'
};
function unpack() {
	const unpacked = {};
	const keys = Object.keys(names);
	const tkeys = Object.keys(map$1$1);
	let i, j, k, ok, nk;
	for (i = 0; i < keys.length; i++) {
		ok = nk = keys[i];
		for (j = 0; j < tkeys.length; j++) {
			k = tkeys[j];
			nk = nk.replace(k, map$1$1[k]);
		}
		k = parseInt(names[ok], 16);
		unpacked[nk] = [k >> 16 & 0xFF, k >> 8 & 0xFF, k & 0xFF];
	}
	return unpacked;
}
let names$1;
function nameParse(str) {
	if (!names$1) {
		names$1 = unpack();
		names$1.transparent = [0, 0, 0, 0];
	}
	const a = names$1[str.toLowerCase()];
	return a && {
		r: a[0],
		g: a[1],
		b: a[2],
		a: a.length === 4 ? a[3] : 255
	};
}
function modHSL(v, i, ratio) {
	if (v) {
		let tmp = rgb2hsl(v);
		tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
		tmp = hsl2rgb$2(tmp);
		v.r = tmp[0];
		v.g = tmp[1];
		v.b = tmp[2];
	}
}
function clone(v, proto) {
	return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
	var v = {r: 0, g: 0, b: 0, a: 255};
	if (Array.isArray(input)) {
		if (input.length >= 3) {
			v = {r: input[0], g: input[1], b: input[2], a: 255};
			if (input.length > 3) {
				v.a = n2b(input[3]);
			}
		}
	} else {
		v = clone(input, {r: 0, g: 0, b: 0, a: 1});
		v.a = n2b(v.a);
	}
	return v;
}
function functionParse(str) {
	if (str.charAt(0) === 'r') {
		return rgbParse(str);
	}
	return hueParse(str);
}
class Color$2 {
	constructor(input) {
		if (input instanceof Color$2) {
			return input;
		}
		const type = typeof input;
		let v;
		if (type === 'object') {
			v = fromObject(input);
		} else if (type === 'string') {
			v = hexParse(input) || nameParse(input) || functionParse(input);
		}
		this._rgb = v;
		this._valid = !!v;
	}
	get valid() {
		return this._valid;
	}
	get rgb() {
		var v = clone(this._rgb);
		if (v) {
			v.a = b2n(v.a);
		}
		return v;
	}
	set rgb(obj) {
		this._rgb = fromObject(obj);
	}
	rgbString() {
		return this._valid ? rgbString(this._rgb) : this._rgb;
	}
	hexString() {
		return this._valid ? hexString(this._rgb) : this._rgb;
	}
	hslString() {
		return this._valid ? hslString(this._rgb) : this._rgb;
	}
	mix(color, weight) {
		const me = this;
		if (color) {
			const c1 = me.rgb;
			const c2 = color.rgb;
			let w2;
			const p = weight === w2 ? 0.5 : weight;
			const w = 2 * p - 1;
			const a = c1.a - c2.a;
			const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			w2 = 1 - w1;
			c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
			c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
			c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
			c1.a = p * c1.a + (1 - p) * c2.a;
			me.rgb = c1;
		}
		return me;
	}
	clone() {
		return new Color$2(this.rgb);
	}
	alpha(a) {
		this._rgb.a = n2b(a);
		return this;
	}
	clearer(ratio) {
		const rgb = this._rgb;
		rgb.a *= 1 - ratio;
		return this;
	}
	greyscale() {
		const rgb = this._rgb;
		const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
		rgb.r = rgb.g = rgb.b = val;
		return this;
	}
	opaquer(ratio) {
		const rgb = this._rgb;
		rgb.a *= 1 + ratio;
		return this;
	}
	negate() {
		const v = this._rgb;
		v.r = 255 - v.r;
		v.g = 255 - v.g;
		v.b = 255 - v.b;
		return this;
	}
	lighten(ratio) {
		modHSL(this._rgb, 2, ratio);
		return this;
	}
	darken(ratio) {
		modHSL(this._rgb, 2, -ratio);
		return this;
	}
	saturate(ratio) {
		modHSL(this._rgb, 1, ratio);
		return this;
	}
	desaturate(ratio) {
		modHSL(this._rgb, 1, -ratio);
		return this;
	}
	rotate(deg) {
		rotate(this._rgb, deg);
		return this;
	}
}
function index_esm(input) {
	return new Color$2(input);
}

const isPatternOrGradient = (value) => value instanceof CanvasGradient || value instanceof CanvasPattern;
function color$2(value) {
  return isPatternOrGradient(value) ? value : index_esm(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value)
    ? value
    : index_esm(value).saturate(0.5).darken(0.1).hexString();
}

const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys = key.split('.');
  for (let i = 0, n = keys.length; i < n; ++i) {
    const k = keys[i];
    node = node[k] || (node[k] = Object.create(null));
  }
  return node;
}
function set$2(root, scope, values) {
  if (typeof scope === 'string') {
    return merge$1(getScope$1(root, scope), values);
  }
  return merge$1(getScope$1(root, ''), scope);
}
class Defaults {
  constructor(_descriptors) {
    this.animation = undefined;
    this.backgroundColor = 'rgba(0,0,0,0.1)';
    this.borderColor = 'rgba(0,0,0,0.1)';
    this.color = '#666';
    this.datasets = {};
    this.devicePixelRatio = (context) => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = [
      'mousemove',
      'mouseout',
      'click',
      'touchstart',
      'touchmove'
    ];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: 'normal',
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = 'x';
    this.interaction = {
      mode: 'nearest',
      intersect: true
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = undefined;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors);
  }
  set(scope, values) {
    return set$2(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set$2(descriptors, scope, values);
  }
  override(scope, values) {
    return set$2(overrides, scope, values);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = '_' + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject$1(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
}
var defaults$1 = new Defaults({
  _scriptable: (name) => !name.startsWith('on'),
  _indexable: (name) => name !== 'events',
  hover: {
    _fallback: 'interaction'
  },
  interaction: {
    _scriptable: false,
    _indexable: false,
  }
});

function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    if (thing !== undefined && thing !== null && isArray(thing) !== true) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function clearCanvas(canvas, ctx) {
  ctx = ctx || canvas.getContext('2d');
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x, y) {
  let type, xOffset, yOffset, size, cornerRadius;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === 'object') {
    type = style.toString();
    if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
  default:
    ctx.arc(x, y, radius, 0, TAU);
    ctx.closePath();
    break;
  case 'triangle':
    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
    rad += TWO_THIRDS_PI;
    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
    rad += TWO_THIRDS_PI;
    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
    ctx.closePath();
    break;
  case 'rectRounded':
    cornerRadius = radius * 0.516;
    size = radius - cornerRadius;
    xOffset = Math.cos(rad + QUARTER_PI) * size;
    yOffset = Math.sin(rad + QUARTER_PI) * size;
    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
    ctx.closePath();
    break;
  case 'rect':
    if (!rotation) {
      size = Math.SQRT1_2 * radius;
      ctx.rect(x - size, y - size, 2 * size, 2 * size);
      break;
    }
    rad += QUARTER_PI;
  case 'rectRot':
    xOffset = Math.cos(rad) * radius;
    yOffset = Math.sin(rad) * radius;
    ctx.moveTo(x - xOffset, y - yOffset);
    ctx.lineTo(x + yOffset, y - xOffset);
    ctx.lineTo(x + xOffset, y + yOffset);
    ctx.lineTo(x - yOffset, y + xOffset);
    ctx.closePath();
    break;
  case 'crossRot':
    rad += QUARTER_PI;
  case 'cross':
    xOffset = Math.cos(rad) * radius;
    yOffset = Math.sin(rad) * radius;
    ctx.moveTo(x - xOffset, y - yOffset);
    ctx.lineTo(x + xOffset, y + yOffset);
    ctx.moveTo(x + yOffset, y - xOffset);
    ctx.lineTo(x - yOffset, y + xOffset);
    break;
  case 'star':
    xOffset = Math.cos(rad) * radius;
    yOffset = Math.sin(rad) * radius;
    ctx.moveTo(x - xOffset, y - yOffset);
    ctx.lineTo(x + xOffset, y + yOffset);
    ctx.moveTo(x + yOffset, y - xOffset);
    ctx.lineTo(x - yOffset, y + xOffset);
    rad += QUARTER_PI;
    xOffset = Math.cos(rad) * radius;
    yOffset = Math.sin(rad) * radius;
    ctx.moveTo(x - xOffset, y - yOffset);
    ctx.lineTo(x + xOffset, y + yOffset);
    ctx.moveTo(x + yOffset, y - xOffset);
    ctx.lineTo(x - yOffset, y + xOffset);
    break;
  case 'line':
    xOffset = Math.cos(rad) * radius;
    yOffset = Math.sin(rad) * radius;
    ctx.moveTo(x - xOffset, y - yOffset);
    ctx.lineTo(x + xOffset, y + yOffset);
    break;
  case 'dash':
    ctx.moveTo(x, y);
    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
    break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || (point && point.x > area.left - margin && point.x < area.right + margin &&
		point.y > area.top - margin && point.y < area.bottom + margin);
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
function _steppedLineTo(ctx, previous, target, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === 'middle') {
    const midpoint = (previous.x + target.x) / 2.0;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === 'after' !== !!flip) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
function _bezierCurveTo(ctx, previous, target, flip) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(
    flip ? previous.cp1x : previous.cp2x,
    flip ? previous.cp1y : previous.cp2y,
    flip ? target.cp2x : target.cp1x,
    flip ? target.cp2y : target.cp1y,
    target.x,
    target.y);
}
function renderText(ctx, text, x, y, font, opts = {}) {
  const lines = isArray(text) ? text : [text];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
  let i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line = lines[i];
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x, y, opts.maxWidth);
    }
    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += font.lineHeight;
  }
  ctx.restore();
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    const metrics = ctx.measureText(line);
    const left = x - metrics.actualBoundingBoxLeft;
    const right = x + metrics.actualBoundingBoxRight;
    const top = y - metrics.actualBoundingBoxAscent;
    const bottom = y + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function addRoundedRectPath(ctx, rect) {
  const {x, y, w, h, radius} = rect;
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -HALF_PI, PI, true);
  ctx.lineTo(x, y + h - radius.bottomLeft);
  ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x + w - radius.bottomRight, y + h);
  ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x + w, y + radius.topRight);
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x + radius.topLeft, y);
}

const LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function toLineHeight(value, size) {
  const matches = ('' + value).match(LINE_HEIGHT);
  if (!matches || matches[1] === 'normal') {
    return size * 1.2;
  }
  value = +matches[2];
  switch (matches[3]) {
  case 'px':
    return value;
  case '%':
    value /= 100;
    break;
  }
  return size * value;
}
const numberOrZero = v => +v || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject$1(props);
  const keys = objProps ? Object.keys(props) : props;
  const read = isObject$1(value)
    ? objProps
      ? prop => valueOrDefault(value[prop], value[props[prop]])
      : prop => value[prop]
    : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read(prop));
  }
  return ret;
}
function toTRBL(value) {
  return _readValueToProps(value, {top: 'y', right: 'x', bottom: 'y', left: 'x'});
}
function toTRBLCorners(value) {
  return _readValueToProps(value, ['topLeft', 'topRight', 'bottomLeft', 'bottomRight']);
}
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults$1.font;
  let size = valueOrDefault(options.size, fallback.size);
  if (typeof size === 'string') {
    size = parseInt(size, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !('' + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = '';
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ''
  };
  font.string = toFontString(font);
  return font;
}
function resolve(inputs, context, index, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === undefined) {
      continue;
    }
    if (context !== undefined && typeof value === 'function') {
      value = value(context);
      cacheable = false;
    }
    if (index !== undefined && isArray(value)) {
      value = value[index % value.length];
      cacheable = false;
    }
    if (value !== undefined) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
function _addGrace(minmax, grace, beginAtZero) {
  const {min, max} = minmax;
  const change = toDimension(grace, (max - min) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min, -Math.abs(change)),
    max: keepZero(max, change)
  };
}
function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}

function _lookup(table, value, cmp) {
  cmp = cmp || ((index) => table[index] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = (lo + hi) >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return {lo, hi};
}
const _lookupByKey = (table, key, value) =>
  _lookup(table, value, index => table[index][key] < value);
const _rlookupByKey = (table, key, value) =>
  _lookup(table, value, index => table[index][key] >= value);
function _filterBetween(values, min, max) {
  let start = 0;
  let end = values.length;
  while (start < end && values[start] < min) {
    start++;
  }
  while (end > start && values[end - 1] > max) {
    end--;
  }
  return start > 0 || end < values.length
    ? values.slice(start, end)
    : values;
}
const arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, '_chartjs', {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [listener]
    }
  });
  arrayEvents.forEach((key) => {
    const method = '_onData' + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach((object) => {
          if (typeof object[method] === 'function') {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index = listeners.indexOf(listener);
  if (index !== -1) {
    listeners.splice(index, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach((key) => {
    delete array[key];
  });
  delete array._chartjs;
}
function _arrayUnique(items) {
  const set = new Set();
  let i, ilen;
  for (i = 0, ilen = items.length; i < ilen; ++i) {
    set.add(items[i]);
  }
  if (set.size === ilen) {
    return items;
  }
  return Array.from(set);
}

function _createResolver(scopes, prefixes = [''], rootScopes = scopes, fallback, getTarget = () => scopes[0]) {
  if (!defined(fallback)) {
    fallback = _resolve('_fallback', scopes);
  }
  const cache = {
    [Symbol.toStringTag]: 'Object',
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: rootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: (scope) => _createResolver([scope, ...scopes], prefixes, rootScopes, fallback),
  };
  return new Proxy(cache, {
    deleteProperty(target, prop) {
      delete target[prop];
      delete target._keys;
      delete scopes[0][prop];
      return true;
    },
    get(target, prop) {
      return _cached(target, prop,
        () => _resolveWithPrefixes(prop, prefixes, scopes, target));
    },
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value;
      delete target._keys;
      return true;
    }
  });
}
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: (ctx) => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: (scope) => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    deleteProperty(target, prop) {
      delete target[prop];
      delete proxy[prop];
      return true;
    },
    get(target, prop, receiver) {
      return _cached(target, prop,
        () => _resolveWithContext(target, prop, receiver));
    },
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys
        ? Reflect.has(proxy, prop) ? {enumerable: true, configurable: true} : undefined
        : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    set(target, prop, value) {
      proxy[prop] = value;
      delete target[prop];
      return true;
    }
  });
}
function _descriptors(proxy, defaults = {scriptable: true, indexable: true}) {
  const {_scriptable = defaults.scriptable, _indexable = defaults.indexable, _allKeys = defaults.allKeys} = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
const readKey = (prefix, name) => prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value) => isObject$1(value) && prop !== 'adapters' &&
  (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
  if (Object.prototype.hasOwnProperty.call(target, prop)) {
    return target[prop];
  }
  const value = resolve();
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const {_proxy, _context, _subProxy, _descriptors: descriptors} = target;
  let value = _proxy[prop];
  if (isFunction(value) && descriptors.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
  }
  return value;
}
function _resolveScriptable(prop, value, target, receiver) {
  const {_proxy, _context, _subProxy, _stack} = target;
  if (_stack.has(prop)) {
    throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
  }
  _stack.add(prop);
  value = value(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const {_proxy, _context, _subProxy, _descriptors: descriptors} = target;
  if (defined(_context.index) && isIndexable(prop)) {
    value = value[_context.index % value.length];
  } else if (isObject$1(value[0])) {
    const arr = value;
    const scopes = _proxy._scopes.filter(s => s !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent) => key === true ? parent
  : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (defined(fallback) && fallback !== key && fallback !== parentFallback) {
        return fallback;
      }
    } else if (scope === false && defined(parentFallback) && key !== parentFallback) {
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [...parentScopes, ...rootScopes];
  const set = new Set();
  set.add(value);
  let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (defined(fallback) && fallback !== prop) {
    key = addScopesFromKey(set, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(Array.from(set), [''], rootScopes, fallback,
    () => subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray(target) && isObject$1(value)) {
    return value;
  }
  return target;
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix of prefixes) {
    value = _resolve(readKey(prefix, prop), scopes);
    if (defined(value)) {
      return needsSubResolver(prop, value)
        ? createSubResolver(scopes, proxy, prop, value)
        : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (defined(value)) {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set = new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter(k => !k.startsWith('_'))) {
      set.add(key);
    }
  }
  return Array.from(set);
}

const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis) => indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t * s01;
  const fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
function splineCurveMonotone(points, indexAxis = 'x') {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i]
      : !pointAfter ? deltaK[i - 1]
      : (sign(deltaK[i - 1]) !== sign(deltaK[i])) ? 0
      : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
  return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  if (options.spanGaps) {
    points = points.filter((pt) => !pt.skip);
  }
  if (options.cubicInterpolationMode === 'monotone') {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(
        prev,
        point,
        points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen],
        options.tension
      );
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}

function _isDomSupported() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === '[object ShadowRoot]') {
    parent = parent.host;
  }
  return parent;
}
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === 'string') {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf('%') !== -1) {
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
const getComputedStyle$1 = (element) => window.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle$1(el).getPropertyValue(property);
}
const positions = ['top', 'right', 'bottom', 'left'];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? '-' + suffix : '';
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
const useOffsetPos = (x, y, target) => (x > 0 || y > 0) && (!target || !target.shadowRoot);
function getCanvasPosition(evt, canvas) {
  const e = evt.native || evt;
  const touches = e.touches;
  const source = touches && touches.length ? touches[0] : e;
  const {offsetX, offsetY} = source;
  let box = false;
  let x, y;
  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }
  return {x, y, box};
}
function getRelativePosition$1(evt, chart) {
  const {canvas, currentDevicePixelRatio} = chart;
  const style = getComputedStyle$1(canvas);
  const borderBox = style.boxSizing === 'border-box';
  const paddings = getPositionedStyle(style, 'padding');
  const borders = getPositionedStyle(style, 'border', 'width');
  const {x, y, box} = getCanvasPosition(evt, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let {width, height} = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height) {
  let maxWidth, maxHeight;
  if (width === undefined || height === undefined) {
    const container = _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect();
      const containerStyle = getComputedStyle$1(container);
      const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
      const containerPadding = getPositionedStyle(containerStyle, 'padding');
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
    }
  }
  return {
    width,
    height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
const round1 = v => Math.round(v * 10) / 10;
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle$1(canvas);
  const margins = getPositionedStyle(style, 'margin');
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let {width, height} = containerSize;
  if (style.boxSizing === 'content-box') {
    const borders = getPositionedStyle(style, 'border', 'width');
    const paddings = getPositionedStyle(style, 'padding');
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
  if (width && !height) {
    height = round1(width / 2);
  }
  return {
    width,
    height
  };
}
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = deviceHeight / pixelRatio;
  chart.width = deviceWidth / pixelRatio;
  const canvas = chart.canvas;
  if (canvas.style && (forceStyle || (!canvas.style.height && !canvas.style.width))) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio
      || canvas.height !== deviceHeight
      || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
const supportsEventListenerOptions = (function() {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener('test', null, options);
    window.removeEventListener('test', null, options);
  } catch (e) {
  }
  return passiveSupported;
}());
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : undefined;
}

function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}
function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y
    : mode === 'after' ? t < 1 ? p1.y : p2.y
    : t > 0 ? p2.y : p1.y
  };
}
function _bezierInterpolation(p1, p2, t, mode) {
  const cp1 = {x: p1.cp2x, y: p1.cp2y};
  const cp2 = {x: p2.cp1x, y: p2.cp1y};
  const a = _pointInLine(p1, cp1, t);
  const b = _pointInLine(cp1, cp2, t);
  const c = _pointInLine(cp2, p2, t);
  const d = _pointInLine(a, b, t);
  const e = _pointInLine(b, c, t);
  return _pointInLine(d, e, t);
}

const intlCache = new Map();
function getNumberFormat(locale, options) {
  options = options || {};
  const cacheKey = locale + JSON.stringify(options);
  let formatter = intlCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter);
  }
  return formatter;
}
function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}

const getRightToLeftAdapter = function(rectX, width) {
  return {
    x(x) {
      return rectX + rectX + width - x;
    },
    setWidth(w) {
      width = w;
    },
    textAlign(align) {
      if (align === 'center') {
        return align;
      }
      return align === 'right' ? 'left' : 'right';
    },
    xPlus(x, value) {
      return x - value;
    },
    leftForLtr(x, itemWidth) {
      return x - itemWidth;
    },
  };
};
const getLeftToRightAdapter = function() {
  return {
    x(x) {
      return x;
    },
    setWidth(w) {
    },
    textAlign(align) {
      return align;
    },
    xPlus(x, value) {
      return x + value;
    },
    leftForLtr(x, _itemWidth) {
      return x;
    },
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === 'ltr' || direction === 'rtl') {
    style = ctx.canvas.style;
    original = [
      style.getPropertyValue('direction'),
      style.getPropertyPriority('direction'),
    ];
    style.setProperty('direction', direction, 'important');
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== undefined) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty('direction', original[0], original[1]);
  }
}

function propertyFn(property) {
  if (property === 'angle') {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle,
    };
  }
  return {
    between: _isBetween,
    compare: (a, b) => a - b,
    normalize: x => x
  };
}
function normalizeSegment({start, end, count, loop, style}) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const {property, start: startBound, end: endBound} = bounds;
  const {between, normalize} = propertyFn(property);
  const count = points.length;
  let {start, end, loop} = segment;
  let i, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return {start, end, loop, style: segment.style};
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [segment];
  }
  const {property, start: startBound, end: endBound} = bounds;
  const count = points.length;
  const {compare, between, normalize} = propertyFn(property);
  const {start, end, loop, style} = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start, prev = start; i <= end; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({start: subStart, end: i, loop, count, style}));
      subStart = null;
    }
    prev = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({start: subStart, end, loop, count, style}));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return {start, end};
}
function solidSegments(points, start, max, loop) {
  const count = points.length;
  const result = [];
  let last = start;
  let prev = points[start];
  let end;
  for (end = start + 1; end <= max; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({start: start % count, end: (end - 1) % count, loop});
        start = last = cur.stop ? end : null;
      }
    } else {
      last = end;
      if (prev.skip) {
        start = end;
      }
    }
    prev = cur;
  }
  if (last !== null) {
    result.push({start: start % count, end: last % count, loop});
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const {start, end} = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [{start, end, loop}], points, segmentOptions);
  }
  const max = end < start ? end + count : end;
  const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const {_datasetIndex: datasetIndex, options: {spanGaps}} = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i = start;
  function addStyle(s, e, l, st) {
    const dir = spanGaps ? -1 : 1;
    if (s === e) {
      return;
    }
    s += count;
    while (points[s % count].skip) {
      s -= dir;
    }
    while (points[e % count].skip) {
      e += dir;
    }
    if (s % count !== e % count) {
      result.push({start: s % count, end: e % count, loop: l, style: st});
      prevStyle = st;
      start = e % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev = points[start % count];
    let style;
    for (i = start + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext(chartContext, {
        type: 'segment',
        p0: prev,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
      prev = pt;
      prevStyle = style;
    }
    if (start < i - 1) {
      addStyle(start, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}

/*!
 * Chart.js v3.7.0
 * https://www.chartjs.org
 * (c) 2021 Chart.js Contributors
 * Released under the MIT License
 */

class Animator {
  constructor() {
    this._request = null;
    this._charts = new Map();
    this._running = false;
    this._lastDate = undefined;
  }
  _notify(chart, anims, date, type) {
    const callbacks = anims.listeners[type];
    const numSteps = anims.duration;
    callbacks.forEach(fn => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw) {
        chart.draw();
        this._notify(chart, anims, date, 'progress');
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, 'complete');
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), 'complete');
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
}
var animator = new Animator();

const transparent = 'transparent';
const interpolators = {
  boolean(from, to, factor) {
    return factor > 0.5 ? to : from;
  },
  color(from, to, factor) {
    const c0 = color$2(from || transparent);
    const c1 = c0.valid && color$2(to || transparent);
    return c1 && c1.valid
      ? c1.mix(c0, factor).hexString()
      : to;
  },
  number(from, to, factor) {
    return from + (to - from) * factor;
  }
};
class Animation {
  constructor(cfg, target, prop, to) {
    const currentValue = target[prop];
    to = resolve([cfg.to, to, currentValue, cfg.from]);
    const from = resolve([cfg.from, currentValue, to]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from;
    this._to = to;
    this._promises = undefined;
  }
  active() {
    return this._active;
  }
  update(cfg, to, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([cfg.to, to, currentValue, cfg.from]);
      this._from = resolve([cfg.from, currentValue, to]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from = this._from;
    const loop = this._loop;
    const to = this._to;
    let factor;
    this._active = from !== to && (loop || (elapsed < duration));
    if (!this._active) {
      this._target[prop] = to;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from;
      return;
    }
    factor = (elapsed / duration) % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from, to, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({res, rej});
    });
  }
  _notify(resolved) {
    const method = resolved ? 'res' : 'rej';
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
}

const numbers = ['x', 'y', 'borderWidth', 'radius', 'tension'];
const colors$1 = ['color', 'borderColor', 'backgroundColor'];
defaults$1.set('animation', {
  delay: undefined,
  duration: 1000,
  easing: 'easeOutQuart',
  fn: undefined,
  from: undefined,
  loop: undefined,
  to: undefined,
  type: undefined,
});
const animationOptions = Object.keys(defaults$1.animation);
defaults$1.describe('animation', {
  _fallback: false,
  _indexable: false,
  _scriptable: (name) => name !== 'onProgress' && name !== 'onComplete' && name !== 'fn',
});
defaults$1.set('animations', {
  colors: {
    type: 'color',
    properties: colors$1
  },
  numbers: {
    type: 'number',
    properties: numbers
  },
});
defaults$1.describe('animations', {
  _fallback: 'animation',
});
defaults$1.set('transitions', {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: 'transparent'
      },
      visible: {
        type: 'boolean',
        duration: 0
      },
    }
  },
  hide: {
    animations: {
      colors: {
        to: 'transparent'
      },
      visible: {
        type: 'boolean',
        easing: 'linear',
        fn: v => v | 0
      },
    }
  }
});
class Animations {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject$1(config)) {
      return;
    }
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach(key => {
      const cfg = config[key];
      if (!isObject$1(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [key]).forEach((prop) => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {
      });
    }
    return animations;
  }
  _createAnimations(target, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === '$') {
        continue;
      }
      if (prop === 'options') {
        animations.push(...this._animateOptions(target, values));
        continue;
      }
      const value = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values) {
    if (this._properties.size === 0) {
      Object.assign(target, values);
      return;
    }
    const animations = this._createAnimations(target, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
}
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target.options;
  if (!options) {
    target.options = newOptions;
    return;
  }
  if (options.$shared) {
    target.options = options = Object.assign({}, options, {$shared: false, $animations: {}});
  }
  return options;
}

function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min = opts.min === undefined ? allowedOverflow : 0;
  const max = opts.max === undefined ? allowedOverflow : 0;
  return {
    start: reverse ? max : min,
    end: reverse ? min : max
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x = scaleClip(xScale, allowedOverflow);
  const y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}
function toClip(value) {
  let t, r, b, l;
  if (isObject$1(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }
  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
  const keys = stack.keys;
  const singleMode = options.mode === 'single';
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || (value === 0 || sign(value) === sign(otherValue)))) {
      value += otherValue;
    }
  }
  return value;
}
function convertObjectDataToArray(data) {
  const keys = Object.keys(data);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      x: key,
      y: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || (stacked === undefined && meta.stack !== undefined);
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const {min, max, minDefined, maxDefined} = scale.getUserBounds();
  return {
    min: minDefined ? min : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
  for (const meta of vScale.getMatchingVisibleMetas(type).reverse()) {
    const value = stack[meta.index];
    if ((positive && value > 0) || (!positive && value < 0)) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const {chart, _cachedMeta: meta} = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const {iScale, vScale, index: datasetIndex} = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const {[iAxis]: index, [vAxis]: value} = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
  }
}
function getFirstScaleId(chart, axis) {
  const scales = chart.scales;
  return Object.keys(scales).filter(key => scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
  return createContext(parent,
    {
      active: false,
      dataset: undefined,
      datasetIndex: index,
      index,
      mode: 'default',
      type: 'dataset'
    }
  );
}
function createDataContext(parent, index, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index,
    parsed: undefined,
    raw: undefined,
    element,
    index,
    mode: 'default',
    type: 'data'
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) {
      return;
    }
    delete stacks[axis][datasetIndex];
  }
}
const isDirectUpdateMode = (mode) => mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked
  && {keys: getSortedDatasetIndices(chart, true), values: null};
class DatasetController {
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = undefined;
    this._parsing = false;
    this._data = undefined;
    this._objectData = undefined;
    this._sharedOptions = undefined;
    this._drawStart = undefined;
    this._drawCount = undefined;
    this.enableOptionSharing = false;
    this.$context = undefined;
    this._syncList = [];
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x, y, r) => axis === 'x' ? x : axis === 'r' ? r : y;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, 'x'));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, 'y'));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, 'r'));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale
      ? meta.vScale
      : meta.iScale;
  }
  reset() {
    this._update('reset');
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject$1(data)) {
      this._data = convertObjectDataToArray(data);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const {_cachedMeta: meta, _data: data} = this;
    const {iScale, _stacked} = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data.length ? true : meta._sorted;
    let prev = start > 0 && meta._parsed[start - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start])) {
        parsed = this.parseArrayData(meta, data, start, count);
      } else if (isObject$1(data[start])) {
        parsed = this.parseObjectData(meta, data, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || (prev && cur[iAxis] < prev[iAxis]);
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start, count) {
    const {iScale, vScale} = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index], index),
        [vAxis]: vScale.parse(data[index], index)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const {xScale, yScale} = meta;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      item = data[index];
      parsed[i] = {
        x: xScale.parse(item[0], index),
        y: yScale.parse(item[1], index)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const {xScale, yScale} = meta;
    const {xAxisKey = 'x', yAxisKey = 'y'} = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      item = data[index];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index)
      };
    }
    return parsed;
  }
  getParsed(index) {
    return this._cachedMeta._parsed[index];
  }
  getDataElement(index) {
    return this._cachedMeta.data[index];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]
    };
    return applyStack(stack, value, meta.index, {mode});
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    const parsedValue = parsed[scale.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values = stack && parsed._stacks[scale.axis];
    if (stack && values) {
      stack.values = values;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range.min = Math.min(range.min, value);
    range.max = Math.max(range.max, value);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack = createStack(canStack, meta, this.chart);
    const range = {min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY};
    const {min: otherMin, max: otherMax} = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range, scale, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range, scale, parsed, stack);
        break;
      }
    }
    return range;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale.axis];
      if (isNumberFinite(value)) {
        values.push(value);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index);
    return {
      label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
      value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || 'default');
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {}
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || (elements.length - start);
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i = start; i < start + count; ++i) {
      const element = elements[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active.length; ++i) {
      active[i].draw(ctx, area);
    }
  }
  getStyle(index, active) {
    const mode = active ? 'active' : 'default';
    return index === undefined && this._cachedMeta.dataset
      ? this.resolveDatasetElementOptions(mode)
      : this.resolveDataElementOptions(index || 0, mode);
  }
  getContext(index, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index >= 0 && index < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index];
      context = element.$context ||
        (element.$context = createDataContext(this.getContext(), index, element));
      context.parsed = this.getParsed(index);
      context.raw = dataset.data[index];
      context.index = context.dataIndex = index;
    } else {
      context = this.$context ||
        (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index);
  }
  _resolveElementOptions(elementType, mode = 'default', index) {
    const active = mode === 'active';
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + '-' + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active ? [`${elementType}Hover`, 'hover', elementType, ''] : [elementType, ''];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names = Object.keys(defaults$1.elements[elementType]);
    const context = () => this.getContext(index, active);
    const values = config.resolveNamedOptions(scopes, names, context, prefixes);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  updateElement(element, index, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index, mode, active) {
    element.active = active;
    const options = this.getStyle(index, active);
    this._resolveAnimations(index, mode, active).update(element, {
      options: (!active && this.getSharedOptions(options)) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index) {
    this._setStyle(element, index, 'active', false);
  }
  setHoverStyle(element, datasetIndex, index) {
    this._setStyle(element, index, 'active', true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, undefined, 'active', false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, undefined, 'active', true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end = start + count;
    let i;
    const move = (arr) => {
      arr.length += count;
      for (i = arr.length - 1; i >= end; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data);
    for (i = start; i < end; ++i) {
      data[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data, start, count, 'reset');
    }
  }
  updateElements(element, start, count, mode) {}
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([this.index, ...args]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync(['_insertElements', this.getDataset().data.length - count, count]);
  }
  _onDataPop() {
    this._sync(['_removeElements', this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(['_removeElements', 0, 1]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync(['_removeElements', start, count]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync(['_insertElements', start, newCount]);
    }
  }
  _onDataUnshift() {
    this._sync(['_insertElements', 0, arguments.length]);
  }
}
DatasetController.defaults = {};
DatasetController.prototype.datasetElementType = null;
DatasetController.prototype.dataElementType = null;

function getAllScaleValues(scale, type) {
  if (!scale._cache.$bar) {
    const visibleMetas = scale.getMatchingVisibleMetas(type);
    let values = [];
    for (let i = 0, ilen = visibleMetas.length; i < ilen; i++) {
      values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
    }
    scale._cache.$bar = _arrayUnique(values.sort((a, b) => a - b));
  }
  return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
  const scale = meta.iScale;
  const values = getAllScaleValues(scale, meta.type);
  let min = scale._length;
  let i, ilen, curr, prev;
  const updateMinAndPrev = () => {
    if (curr === 32767 || curr === -32768) {
      return;
    }
    if (defined(prev)) {
      min = Math.min(min, Math.abs(curr - prev) || min);
    }
    prev = curr;
  };
  for (i = 0, ilen = values.length; i < ilen; ++i) {
    curr = scale.getPixelForValue(values[i]);
    updateMinAndPrev();
  }
  prev = undefined;
  for (i = 0, ilen = scale.ticks.length; i < ilen; ++i) {
    curr = scale.getPixelForTick(i);
    updateMinAndPrev();
  }
  return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
  const thickness = options.barThickness;
  let size, ratio;
  if (isNullOrUndef(thickness)) {
    size = ruler.min * options.categoryPercentage;
    ratio = options.barPercentage;
  } else {
    size = thickness * stackCount;
    ratio = 1;
  }
  return {
    chunk: size / stackCount,
    ratio,
    start: ruler.pixels[index] - (size / 2)
  };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
  const pixels = ruler.pixels;
  const curr = pixels[index];
  let prev = index > 0 ? pixels[index - 1] : null;
  let next = index < pixels.length - 1 ? pixels[index + 1] : null;
  const percent = options.categoryPercentage;
  if (prev === null) {
    prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
  }
  if (next === null) {
    next = curr + curr - prev;
  }
  const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
  const size = Math.abs(next - prev) / 2 * percent;
  return {
    chunk: size / stackCount,
    ratio: options.barPercentage,
    start
  };
}
function parseFloatBar(entry, item, vScale, i) {
  const startValue = vScale.parse(entry[0], i);
  const endValue = vScale.parse(entry[1], i);
  const min = Math.min(startValue, endValue);
  const max = Math.max(startValue, endValue);
  let barStart = min;
  let barEnd = max;
  if (Math.abs(min) > Math.abs(max)) {
    barStart = max;
    barEnd = min;
  }
  item[vScale.axis] = barEnd;
  item._custom = {
    barStart,
    barEnd,
    start: startValue,
    end: endValue,
    min,
    max
  };
}
function parseValue(entry, item, vScale, i) {
  if (isArray(entry)) {
    parseFloatBar(entry, item, vScale, i);
  } else {
    item[vScale.axis] = vScale.parse(entry, i);
  }
  return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
  const iScale = meta.iScale;
  const vScale = meta.vScale;
  const labels = iScale.getLabels();
  const singleScale = iScale === vScale;
  const parsed = [];
  let i, ilen, item, entry;
  for (i = start, ilen = start + count; i < ilen; ++i) {
    entry = data[i];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
    parsed.push(parseValue(entry, item, vScale, i));
  }
  return parsed;
}
function isFloatBar(custom) {
  return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
  if (size !== 0) {
    return sign(size);
  }
  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
  let reverse, start, end, top, bottom;
  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start = 'left';
    end = 'right';
  } else {
    reverse = properties.base < properties.y;
    start = 'bottom';
    end = 'top';
  }
  if (reverse) {
    top = 'end';
    bottom = 'start';
  } else {
    top = 'start';
    bottom = 'end';
  }
  return {start, end, reverse, top, bottom};
}
function setBorderSkipped(properties, options, stack, index) {
  let edge = options.borderSkipped;
  const res = {};
  if (!edge) {
    properties.borderSkipped = res;
    return;
  }
  const {start, end, reverse, top, bottom} = borderProps(properties);
  if (edge === 'middle' && stack) {
    properties.enableBorderRadius = true;
    if ((stack._top || 0) === index) {
      edge = top;
    } else if ((stack._bottom || 0) === index) {
      edge = bottom;
    } else {
      res[parseEdge(bottom, start, end, reverse)] = true;
      edge = top;
    }
  }
  res[parseEdge(edge, start, end, reverse)] = true;
  properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
  if (reverse) {
    edge = swap(edge, a, b);
    edge = startEnd(edge, b, a);
  } else {
    edge = startEnd(edge, a, b);
  }
  return edge;
}
function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
  return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, {inflateAmount}, ratio) {
  properties.inflateAmount = inflateAmount === 'auto'
    ? ratio === 1 ? 0.33 : 0
    : inflateAmount;
}
class BarController extends DatasetController {
  parsePrimitiveData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseArrayData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseObjectData(meta, data, start, count) {
    const {iScale, vScale} = meta;
    const {xAxisKey = 'x', yAxisKey = 'y'} = this._parsing;
    const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
    const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
    const parsed = [];
    let i, ilen, item, obj;
    for (i = start, ilen = start + count; i < ilen; ++i) {
      obj = data[i];
      item = {};
      item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
      parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
    }
    return parsed;
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    super.updateRangeFromParsed(range, scale, parsed, stack);
    const custom = parsed._custom;
    if (custom && scale === this._cachedMeta.vScale) {
      range.min = Math.min(range.min, custom.min);
      range.max = Math.max(range.max, custom.max);
    }
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const {iScale, vScale} = meta;
    const parsed = this.getParsed(index);
    const custom = parsed._custom;
    const value = isFloatBar(custom)
      ? '[' + custom.start + ', ' + custom.end + ']'
      : '' + vScale.getLabelForValue(parsed[vScale.axis]);
    return {
      label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
      value
    };
  }
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
    const meta = this._cachedMeta;
    meta.stack = this.getDataset().stack;
  }
  update(mode) {
    const meta = this._cachedMeta;
    this.updateElements(meta.data, 0, meta.data.length, mode);
  }
  updateElements(bars, start, count, mode) {
    const reset = mode === 'reset';
    const {index, _cachedMeta: {vScale}} = this;
    const base = vScale.getBasePixel();
    const horizontal = vScale.isHorizontal();
    const ruler = this._getRuler();
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    for (let i = start; i < start + count; i++) {
      const parsed = this.getParsed(i);
      const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {base, head: base} : this._calculateBarValuePixels(i);
      const ipixels = this._calculateBarIndexPixels(i, ruler);
      const stack = (parsed._stacks || {})[vScale.axis];
      const properties = {
        horizontal,
        base: vpixels.base,
        enableBorderRadius: !stack || isFloatBar(parsed._custom) || (index === stack._top || index === stack._bottom),
        x: horizontal ? vpixels.head : ipixels.center,
        y: horizontal ? ipixels.center : vpixels.head,
        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
      }
      const options = properties.options || bars[i].options;
      setBorderSkipped(properties, options, stack, index);
      setInflateAmount(properties, options, ruler.ratio);
      this.updateElement(bars[i], i, properties, mode);
    }
  }
  _getStacks(last, dataIndex) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const metasets = iScale.getMatchingVisibleMetas(this._type);
    const stacked = iScale.options.stacked;
    const ilen = metasets.length;
    const stacks = [];
    let i, item;
    for (i = 0; i < ilen; ++i) {
      item = metasets[i];
      if (!item.controller.options.grouped) {
        continue;
      }
      if (typeof dataIndex !== 'undefined') {
        const val = item.controller.getParsed(dataIndex)[
          item.controller._cachedMeta.vScale.axis
        ];
        if (isNullOrUndef(val) || isNaN(val)) {
          continue;
        }
      }
      if (stacked === false || stacks.indexOf(item.stack) === -1 ||
				(stacked === undefined && item.stack === undefined)) {
        stacks.push(item.stack);
      }
      if (item.index === last) {
        break;
      }
    }
    if (!stacks.length) {
      stacks.push(undefined);
    }
    return stacks;
  }
  _getStackCount(index) {
    return this._getStacks(undefined, index).length;
  }
  _getStackIndex(datasetIndex, name, dataIndex) {
    const stacks = this._getStacks(datasetIndex, dataIndex);
    const index = (name !== undefined)
      ? stacks.indexOf(name)
      : -1;
    return (index === -1)
      ? stacks.length - 1
      : index;
  }
  _getRuler() {
    const opts = this.options;
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const pixels = [];
    let i, ilen;
    for (i = 0, ilen = meta.data.length; i < ilen; ++i) {
      pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
    }
    const barThickness = opts.barThickness;
    const min = barThickness || computeMinSampleSize(meta);
    return {
      min,
      pixels,
      start: iScale._startPixel,
      end: iScale._endPixel,
      stackCount: this._getStackCount(),
      scale: iScale,
      grouped: opts.grouped,
      ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
    };
  }
  _calculateBarValuePixels(index) {
    const {_cachedMeta: {vScale, _stacked}, options: {base: baseValue, minBarLength}} = this;
    const actualBase = baseValue || 0;
    const parsed = this.getParsed(index);
    const custom = parsed._custom;
    const floating = isFloatBar(custom);
    let value = parsed[vScale.axis];
    let start = 0;
    let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
    let head, size;
    if (length !== value) {
      start = length - value;
      length = value;
    }
    if (floating) {
      value = custom.barStart;
      length = custom.barEnd - custom.barStart;
      if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
        start = 0;
      }
      start += value;
    }
    const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
    let base = vScale.getPixelForValue(startValue);
    if (this.chart.getDataVisibility(index)) {
      head = vScale.getPixelForValue(start + length);
    } else {
      head = base;
    }
    size = head - base;
    if (Math.abs(size) < minBarLength) {
      size = barSign(size, vScale, actualBase) * minBarLength;
      if (value === actualBase) {
        base -= size / 2;
      }
      head = base + size;
    }
    if (base === vScale.getPixelForValue(actualBase)) {
      const halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
      base += halfGrid;
      size -= halfGrid;
    }
    return {
      size,
      base,
      head,
      center: head + size / 2
    };
  }
  _calculateBarIndexPixels(index, ruler) {
    const scale = ruler.scale;
    const options = this.options;
    const skipNull = options.skipNull;
    const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
    let center, size;
    if (ruler.grouped) {
      const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
      const range = options.barThickness === 'flex'
        ? computeFlexCategoryTraits(index, ruler, options, stackCount)
        : computeFitCategoryTraits(index, ruler, options, stackCount);
      const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
      center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
      size = Math.min(maxBarThickness, range.chunk * range.ratio);
    } else {
      center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
      size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
    }
    return {
      base: center - size / 2,
      head: center + size / 2,
      center,
      size
    };
  }
  draw() {
    const meta = this._cachedMeta;
    const vScale = meta.vScale;
    const rects = meta.data;
    const ilen = rects.length;
    let i = 0;
    for (; i < ilen; ++i) {
      if (this.getParsed(i)[vScale.axis] !== null) {
        rects[i].draw(this._ctx);
      }
    }
  }
}
BarController.id = 'bar';
BarController.defaults = {
  datasetElementType: false,
  dataElementType: 'bar',
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: true,
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'base', 'width', 'height']
    }
  }
};
BarController.overrides = {
  scales: {
    _index_: {
      type: 'category',
      offset: true,
      grid: {
        offset: true
      }
    },
    _value_: {
      type: 'linear',
      beginAtZero: true,
    }
  }
};

class BubbleController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
  }
  parsePrimitiveData(meta, data, start, count) {
    const parsed = super.parsePrimitiveData(meta, data, start, count);
    for (let i = 0; i < parsed.length; i++) {
      parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const parsed = super.parseArrayData(meta, data, start, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data[start + i];
      parsed[i]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i + start).radius);
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const parsed = super.parseObjectData(meta, data, start, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data[start + i];
      parsed[i]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
    }
    return parsed;
  }
  getMaxOverflow() {
    const data = this._cachedMeta.data;
    let max = 0;
    for (let i = data.length - 1; i >= 0; --i) {
      max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
    }
    return max > 0 && max;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const {xScale, yScale} = meta;
    const parsed = this.getParsed(index);
    const x = xScale.getLabelForValue(parsed.x);
    const y = yScale.getLabelForValue(parsed.y);
    const r = parsed._custom;
    return {
      label: meta.label,
      value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
    };
  }
  update(mode) {
    const points = this._cachedMeta.data;
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === 'reset';
    const {iScale, vScale} = this._cachedMeta;
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    for (let i = start; i < start + count; i++) {
      const point = points[i];
      const parsed = !reset && this.getParsed(i);
      const properties = {};
      const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
      const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
      properties.skip = isNaN(iPixel) || isNaN(vPixel);
      if (includeOptions) {
        properties.options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
        if (reset) {
          properties.options.radius = 0;
        }
      }
      this.updateElement(point, i, properties, mode);
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  resolveDataElementOptions(index, mode) {
    const parsed = this.getParsed(index);
    let values = super.resolveDataElementOptions(index, mode);
    if (values.$shared) {
      values = Object.assign({}, values, {$shared: false});
    }
    const radius = values.radius;
    if (mode !== 'active') {
      values.radius = 0;
    }
    values.radius += valueOrDefault(parsed && parsed._custom, radius);
    return values;
  }
}
BubbleController.id = 'bubble';
BubbleController.defaults = {
  datasetElementType: false,
  dataElementType: 'point',
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'borderWidth', 'radius']
    }
  }
};
BubbleController.overrides = {
  scales: {
    x: {
      type: 'linear'
    },
    y: {
      type: 'linear'
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return '';
        }
      }
    }
  }
};

function getRatioAndOffset(rotation, circumference, cutout) {
  let ratioX = 1;
  let ratioY = 1;
  let offsetX = 0;
  let offsetY = 0;
  if (circumference < TAU) {
    const startAngle = rotation;
    const endAngle = startAngle + circumference;
    const startX = Math.cos(startAngle);
    const startY = Math.sin(startAngle);
    const endX = Math.cos(endAngle);
    const endY = Math.sin(endAngle);
    const calcMax = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
    const calcMin = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
    const maxX = calcMax(0, startX, endX);
    const maxY = calcMax(HALF_PI, startY, endY);
    const minX = calcMin(PI, startX, endX);
    const minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }
  return {ratioX, ratioY, offsetX, offsetY};
}
class DoughnutController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.enableOptionSharing = true;
    this.innerRadius = undefined;
    this.outerRadius = undefined;
    this.offsetX = undefined;
    this.offsetY = undefined;
  }
  linkScales() {}
  parse(start, count) {
    const data = this.getDataset().data;
    const meta = this._cachedMeta;
    if (this._parsing === false) {
      meta._parsed = data;
    } else {
      let getter = (i) => +data[i];
      if (isObject$1(data[start])) {
        const {key = 'value'} = this._parsing;
        getter = (i) => +resolveObjectKey(data[i], key);
      }
      let i, ilen;
      for (i = start, ilen = start + count; i < ilen; ++i) {
        meta._parsed[i] = getter(i);
      }
    }
  }
  _getRotation() {
    return toRadians(this.options.rotation - 90);
  }
  _getCircumference() {
    return toRadians(this.options.circumference);
  }
  _getRotationExtents() {
    let min = TAU;
    let max = -TAU;
    for (let i = 0; i < this.chart.data.datasets.length; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        const controller = this.chart.getDatasetMeta(i).controller;
        const rotation = controller._getRotation();
        const circumference = controller._getCircumference();
        min = Math.min(min, rotation);
        max = Math.max(max, rotation + circumference);
      }
    }
    return {
      rotation: min,
      circumference: max - min,
    };
  }
  update(mode) {
    const chart = this.chart;
    const {chartArea} = chart;
    const meta = this._cachedMeta;
    const arcs = meta.data;
    const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
    const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
    const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
    const chartWeight = this._getRingWeight(this.index);
    const {circumference, rotation} = this._getRotationExtents();
    const {ratioX, ratioY, offsetX, offsetY} = getRatioAndOffset(rotation, circumference, cutout);
    const maxWidth = (chartArea.width - spacing) / ratioX;
    const maxHeight = (chartArea.height - spacing) / ratioY;
    const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
    const outerRadius = toDimension(this.options.radius, maxRadius);
    const innerRadius = Math.max(outerRadius * cutout, 0);
    const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
    this.offsetX = offsetX * outerRadius;
    this.offsetY = offsetY * outerRadius;
    meta.total = this.calculateTotal();
    this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
    this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _circumference(i, reset) {
    const opts = this.options;
    const meta = this._cachedMeta;
    const circumference = this._getCircumference();
    if ((reset && opts.animation.animateRotate) || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
      return 0;
    }
    return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === 'reset';
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const animateScale = reset && animationOpts.animateScale;
    const innerRadius = animateScale ? 0 : this.innerRadius;
    const outerRadius = animateScale ? 0 : this.outerRadius;
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    let startAngle = this._getRotation();
    let i;
    for (i = 0; i < start; ++i) {
      startAngle += this._circumference(i, reset);
    }
    for (i = start; i < start + count; ++i) {
      const circumference = this._circumference(i, reset);
      const arc = arcs[i];
      const properties = {
        x: centerX + this.offsetX,
        y: centerY + this.offsetY,
        startAngle,
        endAngle: startAngle + circumference,
        circumference,
        outerRadius,
        innerRadius
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
      }
      startAngle += circumference;
      this.updateElement(arc, i, properties, mode);
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  calculateTotal() {
    const meta = this._cachedMeta;
    const metaData = meta.data;
    let total = 0;
    let i;
    for (i = 0; i < metaData.length; i++) {
      const value = meta._parsed[i];
      if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
        total += Math.abs(value);
      }
    }
    return total;
  }
  calculateCircumference(value) {
    const total = this._cachedMeta.total;
    if (total > 0 && !isNaN(value)) {
      return TAU * (Math.abs(value) / total);
    }
    return 0;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index], chart.options.locale);
    return {
      label: labels[index] || '',
      value,
    };
  }
  getMaxBorderWidth(arcs) {
    let max = 0;
    const chart = this.chart;
    let i, ilen, meta, controller, options;
    if (!arcs) {
      for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          meta = chart.getDatasetMeta(i);
          arcs = meta.data;
          controller = meta.controller;
          break;
        }
      }
    }
    if (!arcs) {
      return 0;
    }
    for (i = 0, ilen = arcs.length; i < ilen; ++i) {
      options = controller.resolveDataElementOptions(i);
      if (options.borderAlign !== 'inner') {
        max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
      }
    }
    return max;
  }
  getMaxOffset(arcs) {
    let max = 0;
    for (let i = 0, ilen = arcs.length; i < ilen; ++i) {
      const options = this.resolveDataElementOptions(i);
      max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
    }
    return max;
  }
  _getRingWeightOffset(datasetIndex) {
    let ringWeightOffset = 0;
    for (let i = 0; i < datasetIndex; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        ringWeightOffset += this._getRingWeight(i);
      }
    }
    return ringWeightOffset;
  }
  _getRingWeight(datasetIndex) {
    return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
DoughnutController.id = 'doughnut';
DoughnutController.defaults = {
  datasetElementType: false,
  dataElementType: 'arc',
  animation: {
    animateRotate: true,
    animateScale: false
  },
  animations: {
    numbers: {
      type: 'number',
      properties: ['circumference', 'endAngle', 'innerRadius', 'outerRadius', 'startAngle', 'x', 'y', 'offset', 'borderWidth', 'spacing']
    },
  },
  cutout: '50%',
  rotation: 0,
  circumference: 360,
  radius: '100%',
  spacing: 0,
  indexAxis: 'r',
};
DoughnutController.descriptors = {
  _scriptable: (name) => name !== 'spacing',
  _indexable: (name) => name !== 'spacing',
};
DoughnutController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const {labels: {pointStyle}} = chart.legend.options;
            return data.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle: pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return '';
        },
        label(tooltipItem) {
          let dataLabel = tooltipItem.label;
          const value = ': ' + tooltipItem.formattedValue;
          if (isArray(dataLabel)) {
            dataLabel = dataLabel.slice();
            dataLabel[0] += value;
          } else {
            dataLabel += value;
          }
          return dataLabel;
        }
      }
    }
  }
};

class LineController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const {dataset: line, data: points = [], _dataset} = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let {start, count} = getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, undefined, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === 'reset';
    const {iScale, vScale, _stacked, _dataset} = this._cachedMeta;
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const {spanGaps, segment} = this.options;
    const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = start; i < start + count; ++i) {
      const point = points[i];
      const parsed = this.getParsed(i);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && (parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
}
LineController.id = 'line';
LineController.defaults = {
  datasetElementType: 'line',
  dataElementType: 'point',
  showLine: true,
  spanGaps: false,
};
LineController.overrides = {
  scales: {
    _index_: {
      type: 'category',
    },
    _value_: {
      type: 'linear',
    },
  }
};
function getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const {iScale, _parsed} = meta;
    const axis = iScale.axis;
    const {min, max, minDefined, maxDefined} = iScale.getUserBounds();
    if (minDefined) {
      start = _limitValue(Math.min(
        _lookupByKey(_parsed, iScale.axis, min).lo,
        animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo),
      0, pointCount - 1);
    }
    if (maxDefined) {
      count = _limitValue(Math.max(
        _lookupByKey(_parsed, iScale.axis, max).hi + 1,
        animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max)).hi + 1),
      start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }
  return {start, count};
}
function scaleRangesChanged(meta) {
  const {xScale, yScale, _scaleRanges} = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min
		|| _scaleRanges.xmax !== xScale.max
		|| _scaleRanges.ymin !== yScale.min
		|| _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}

class PolarAreaController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.innerRadius = undefined;
    this.outerRadius = undefined;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index].r, chart.options.locale);
    return {
      label: labels[index] || '',
      value,
    };
  }
  update(mode) {
    const arcs = this._cachedMeta.data;
    this._updateRadius();
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _updateRadius() {
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
    const outerRadius = Math.max(minSize / 2, 0);
    const innerRadius = Math.max(opts.cutoutPercentage ? (outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
    const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
    this.outerRadius = outerRadius - (radiusLength * this.index);
    this.innerRadius = this.outerRadius - radiusLength;
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === 'reset';
    const chart = this.chart;
    const dataset = this.getDataset();
    const opts = chart.options;
    const animationOpts = opts.animation;
    const scale = this._cachedMeta.rScale;
    const centerX = scale.xCenter;
    const centerY = scale.yCenter;
    const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * PI;
    let angle = datasetStartAngle;
    let i;
    const defaultAngle = 360 / this.countVisibleElements();
    for (i = 0; i < start; ++i) {
      angle += this._computeAngle(i, mode, defaultAngle);
    }
    for (i = start; i < start + count; i++) {
      const arc = arcs[i];
      let startAngle = angle;
      let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
      let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(dataset.data[i]) : 0;
      angle = endAngle;
      if (reset) {
        if (animationOpts.animateScale) {
          outerRadius = 0;
        }
        if (animationOpts.animateRotate) {
          startAngle = endAngle = datasetStartAngle;
        }
      }
      const properties = {
        x: centerX,
        y: centerY,
        innerRadius: 0,
        outerRadius,
        startAngle,
        endAngle,
        options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
      };
      this.updateElement(arc, i, properties, mode);
    }
  }
  countVisibleElements() {
    const dataset = this.getDataset();
    const meta = this._cachedMeta;
    let count = 0;
    meta.data.forEach((element, index) => {
      if (!isNaN(dataset.data[index]) && this.chart.getDataVisibility(index)) {
        count++;
      }
    });
    return count;
  }
  _computeAngle(index, mode, defaultAngle) {
    return this.chart.getDataVisibility(index)
      ? toRadians(this.resolveDataElementOptions(index, mode).angle || defaultAngle)
      : 0;
  }
}
PolarAreaController.id = 'polarArea';
PolarAreaController.defaults = {
  dataElementType: 'arc',
  animation: {
    animateRotate: true,
    animateScale: true
  },
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius']
    },
  },
  indexAxis: 'r',
  startAngle: 0,
};
PolarAreaController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const {labels: {pointStyle}} = chart.legend.options;
            return data.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle: pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return '';
        },
        label(context) {
          return context.chart.data.labels[context.dataIndex] + ': ' + context.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: 'radialLinear',
      angleLines: {
        display: false
      },
      beginAtZero: true,
      grid: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      startAngle: 0
    }
  }
};

class PieController extends DoughnutController {
}
PieController.id = 'pie';
PieController.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: '100%'
};

class RadarController extends DatasetController {
  getLabelAndValue(index) {
    const vScale = this._cachedMeta.vScale;
    const parsed = this.getParsed(index);
    return {
      label: vScale.getLabels()[index],
      value: '' + vScale.getLabelForValue(parsed[vScale.axis])
    };
  }
  update(mode) {
    const meta = this._cachedMeta;
    const line = meta.dataset;
    const points = meta.data || [];
    const labels = meta.iScale.getLabels();
    line.points = points;
    if (mode !== 'resize') {
      const options = this.resolveDatasetElementOptions(mode);
      if (!this.options.showLine) {
        options.borderWidth = 0;
      }
      const properties = {
        _loop: true,
        _fullLoop: labels.length === points.length,
        options
      };
      this.updateElement(line, undefined, properties, mode);
    }
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const dataset = this.getDataset();
    const scale = this._cachedMeta.rScale;
    const reset = mode === 'reset';
    for (let i = start; i < start + count; i++) {
      const point = points[i];
      const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
      const pointPosition = scale.getPointPositionForValue(i, dataset.data[i]);
      const x = reset ? scale.xCenter : pointPosition.x;
      const y = reset ? scale.yCenter : pointPosition.y;
      const properties = {
        x,
        y,
        angle: pointPosition.angle,
        skip: isNaN(x) || isNaN(y),
        options
      };
      this.updateElement(point, i, properties, mode);
    }
  }
}
RadarController.id = 'radar';
RadarController.defaults = {
  datasetElementType: 'line',
  dataElementType: 'point',
  indexAxis: 'r',
  showLine: true,
  elements: {
    line: {
      fill: 'start'
    }
  },
};
RadarController.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: 'radialLinear',
    }
  }
};

class ScatterController extends LineController {
}
ScatterController.id = 'scatter';
ScatterController.defaults = {
  showLine: false,
  fill: false
};
ScatterController.overrides = {
  interaction: {
    mode: 'point'
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return '';
        },
        label(item) {
          return '(' + item.label + ', ' + item.formattedValue + ')';
        }
      }
    }
  },
  scales: {
    x: {
      type: 'linear'
    },
    y: {
      type: 'linear'
    }
  }
};

var controllers = /*#__PURE__*/Object.freeze({
__proto__: null,
BarController: BarController,
BubbleController: BubbleController,
DoughnutController: DoughnutController,
LineController: LineController,
PolarAreaController: PolarAreaController,
PieController: PieController,
RadarController: RadarController,
ScatterController: ScatterController
});

function abstract() {
  throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
class DateAdapter {
  constructor(options) {
    this.options = options || {};
  }
  formats() {
    return abstract();
  }
  parse(value, format) {
    return abstract();
  }
  format(timestamp, format) {
    return abstract();
  }
  add(timestamp, amount, unit) {
    return abstract();
  }
  diff(a, b, unit) {
    return abstract();
  }
  startOf(timestamp, unit, weekday) {
    return abstract();
  }
  endOf(timestamp, unit) {
    return abstract();
  }
}
DateAdapter.override = function(members) {
  Object.assign(DateAdapter.prototype, members);
};
var adapters = {
  _date: DateAdapter
};

function getRelativePosition(e, chart) {
  if ('native' in e) {
    return {
      x: e.x,
      y: e.y
    };
  }
  return getRelativePosition$1(e, chart);
}
function evaluateAllVisibleItems(chart, handler) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  let index, data, element;
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    ({index, data} = metasets[i]);
    for (let j = 0, jlen = data.length; j < jlen; ++j) {
      element = data[j];
      if (!element.skip) {
        handler(element, index, j);
      }
    }
  }
}
function binarySearch(metaset, axis, value, intersect) {
  const {controller, data, _sorted} = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data, axis, value);
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range = typeof el.getRange === 'function' && el.getRange(axis);
      if (range) {
        const start = lookupMethod(data, axis, value - range);
        const end = lookupMethod(data, axis, value + range);
        return {lo: start.lo, hi: end.hi};
      }
    }
  }
  return {lo: 0, hi: data.length - 1};
}
function optimizedEvaluateItems(chart, axis, position, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const {index, data} = metasets[i];
    const {lo, hi} = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf('x') !== -1;
  const useY = axis.indexOf('y') !== -1;
  return function(pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position, axis, useFinalPosition) {
  const items = [];
  if (!_isPointInArea(position, chart.chartArea, chart._minPadding)) {
    return items;
  }
  const evaluationFunc = function(element, datasetIndex, index) {
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({element, datasetIndex, index});
    }
  };
  optimizedEvaluateItems(chart, axis, position, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index) {
    const {startAngle, endAngle} = element.getProps(['startAngle', 'endAngle'], useFinalPosition);
    const {angle} = getAngleFromPoint(element, {x: position.x, y: position.y});
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({element, datasetIndex, index});
    }
  }
  optimizedEvaluateItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index) {
    const inRange = element.inRange(position.x, position.y, useFinalPosition);
    if (intersect && !inRange) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = _isPointInArea(center, chart.chartArea, chart._minPadding);
    if (!pointInArea && !inRange) {
      return;
    }
    const distance = distanceMetric(position, center);
    if (distance < minDistance) {
      items = [{element, datasetIndex, index}];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({element, datasetIndex, index});
    }
  }
  optimizedEvaluateItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition) {
  if (!_isPointInArea(position, chart.chartArea, chart._minPadding)) {
    return [];
  }
  return axis === 'r' && !intersect
    ? getNearestRadialItems(chart, position, axis, useFinalPosition)
    : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition);
}
function getAxisItems(chart, e, options, useFinalPosition) {
  const position = getRelativePosition(e, chart);
  const items = [];
  const axis = options.axis;
  const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
  let intersectsItem = false;
  evaluateAllVisibleItems(chart, (element, datasetIndex, index) => {
    if (element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({element, datasetIndex, index});
    }
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      intersectsItem = true;
    }
  });
  if (options.intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  modes: {
    index(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'x';
      const items = options.intersect
        ? getIntersectItems(chart, position, axis, useFinalPosition)
        : getNearestItems(chart, position, axis, false, useFinalPosition);
      const elements = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach((meta) => {
        const index = items[0].index;
        const element = meta.data[index];
        if (element && !element.skip) {
          elements.push({element, datasetIndex: meta.index, index});
        }
      });
      return elements;
    },
    dataset(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      let items = options.intersect
        ? getIntersectItems(chart, position, axis, useFinalPosition) :
        getNearestItems(chart, position, axis, false, useFinalPosition);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data.length; ++i) {
          items.push({element: data[i], datasetIndex, index: i});
        }
      }
      return items;
    },
    point(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      return getIntersectItems(chart, position, axis, useFinalPosition);
    },
    nearest(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition);
    },
    x(chart, e, options, useFinalPosition) {
      return getAxisItems(chart, e, {axis: 'x', intersect: options.intersect}, useFinalPosition);
    },
    y(chart, e, options, useFinalPosition) {
      return getAxisItems(chart, e, {axis: 'y', intersect: options.intersect}, useFinalPosition);
    }
  }
};

const STATIC_POSITIONS = ['left', 'top', 'right', 'bottom'];
function filterByPosition(array, position) {
  return array.filter(v => v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter(v => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a, b) => {
    const v0 = reverse ? b : a;
    const v1 = reverse ? a : b;
    return v0.weight === v1.weight ?
      v0.index - v1.index :
      v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    ({position: pos, options: {stack, stackWeight = 1}} = box);
    layoutBoxes.push({
      index: i,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && (pos + stack),
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts) {
  const stacks = {};
  for (const wrap of layouts) {
    const {stack, pos, stackWeight} = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = {count: 0, placed: 0, weight: 0, size: 0});
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts, params) {
  const stacks = buildStacks(layouts);
  const {vBoxMaxWidth, hBoxMaxHeight} = params;
  let i, ilen, layout;
  for (i = 0, ilen = layouts.length; i < ilen; ++i) {
    layout = layouts[i];
    const {fullSize} = layout.box;
    const stack = stacks[layout.stack];
    const factor = stack && layout.stackWeight / stack.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter(wrap => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
  const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, 'chartArea'),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const {pos, box} = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject$1(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack = stacks[layout.stack] || {size: 0, count: 1};
    stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal
    ? {same: widthChanged, other: heightChanged}
    : {same: heightChanged, other: widthChanged};
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos('top');
  chartArea.x += updatePos('left');
  updatePos('right');
  updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions) {
    const margin = {left: 0, top: 0, right: 0, bottom: 0};
    positions.forEach((pos) => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal
    ? marginForPositions(['left', 'right'])
    : marginForPositions(['top', 'bottom']);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout, box, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box = layout.box;
    box.update(
      layout.width || chartArea.w,
      layout.height || chartArea.h,
      getMargins(layout.horizontal, chartArea)
    );
    const {same, other} = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height;
  box.width = width;
  box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let {x, y} = chartArea;
  for (const layout of boxes) {
    const box = layout.box;
    const stack = stacks[layout.stack] || {count: 1, placed: 0, weight: 1};
    const weight = (layout.stackWeight / stack.weight) || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height = stack.size || box.height;
      if (defined(stack.start)) {
        y = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
      } else {
        setBoxDims(box, chartArea.left + stack.placed, y, width, height);
      }
      stack.start = y;
      stack.placed += width;
      y = box.bottom;
    } else {
      const height = chartArea.h * weight;
      const width = stack.size || box.width;
      if (defined(stack.start)) {
        x = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x, chartArea.top + stack.placed, width, height);
      }
      stack.start = x;
      stack.placed += height;
      x = box.right;
    }
  }
  chartArea.x = x;
  chartArea.y = y;
}
defaults$1.set('layout', {
  autoPadding: true,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || 'top';
    item.weight = item.weight || 0;
    item._layers = item._layers || function() {
      return [{
        z: 0,
        draw(chartArea) {
          item.draw(chartArea);
        }
      }];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index !== -1) {
      chart.boxes.splice(index, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, box => {
      if (typeof box.beforeLayout === 'function') {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) =>
      wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w,
    };
    each(boxes.chartArea, (layout) => {
      const box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, {left: 0, top: 0, right: 0, bottom: 0});
    });
  }
};

class BasePlatform {
  acquireContext(canvas, aspectRatio) {}
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type, listener) {}
  removeEventListener(chart, type, listener) {}
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height, aspectRatio) {
    width = Math.max(0, width || element.width);
    height = height || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {
  }
}

class BasicPlatform extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext('2d') || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
}

const EXPANDO_KEY$1 = '$chartjs';
const EVENT_TYPES = {
  touchstart: 'mousedown',
  touchmove: 'mousemove',
  touchend: 'mouseup',
  pointerenter: 'mouseenter',
  pointerdown: 'mousedown',
  pointermove: 'mousemove',
  pointerup: 'mouseup',
  pointerleave: 'mouseout',
  pointerout: 'mouseout'
};
const isNullOrEmpty = value => value === null || value === '';
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute('height');
  const renderWidth = canvas.getAttribute('width');
  canvas[EXPANDO_KEY$1] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || 'block';
  style.boxSizing = style.boxSizing || 'border-box';
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, 'width');
    if (displayWidth !== undefined) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === '') {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, 'height');
      if (displayHeight !== undefined) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
function addListener(node, type, listener) {
  node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
  chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
  const type = EVENT_TYPES[event.type] || event.type;
  const {x, y} = getRelativePosition$1(event, chart);
  return {
    type,
    chart,
    native: event,
    x: x !== undefined ? x : null,
    y: y !== undefined ? y : null,
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver(entries => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {childList: true, subtree: true});
  return observer;
}
function createDetachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver(entries => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {childList: true, subtree: true});
  return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener('resize', onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener('resize', onWindowResize);
  }
}
function createResizeObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height) => {
    const w = container.clientWidth;
    listener(width, height);
    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver(entries => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height = entry.contentRect.height;
    if (width === 0 && height === 0) {
      return;
    }
    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type === 'resize') {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type, listener) {
  const canvas = chart.canvas;
  const proxy = throttled((event) => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart, (args) => {
    const event = args[0];
    return [event, event.offsetX, event.offsetY];
  });
  addListener(canvas, type, proxy);
  return proxy;
}
class DomPlatform extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext('2d');
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY$1]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY$1].initial;
    ['height', 'width'].forEach((prop) => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach((key) => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY$1];
    return true;
  }
  addEventListener(chart, type, listener) {
    this.removeEventListener(chart, type);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers[type] || createProxyAndListen;
    proxies[type] = handler(chart, type, listener);
  }
  removeEventListener(chart, type) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type];
    if (!proxy) {
      return;
    }
    const handlers = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers[type] || removeListener;
    handler(chart, type, proxy);
    proxies[type] = undefined;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height, aspectRatio) {
    return getMaximumSize(canvas, width, height, aspectRatio);
  }
  isAttached(canvas) {
    const container = _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
}

function _detectPlatform(canvas) {
  if (!_isDomSupported() || (typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas)) {
    return BasicPlatform;
  }
  return DomPlatform;
}

class Element$1 {
  constructor() {
    this.x = undefined;
    this.y = undefined;
    this.active = false;
    this.options = undefined;
    this.$animations = undefined;
  }
  tooltipPosition(useFinalPosition) {
    const {x, y} = this.getProps(['x', 'y'], useFinalPosition);
    return {x, y};
  }
  hasValue() {
    return isNumber(this.x) && isNumber(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      return this;
    }
    const ret = {};
    props.forEach(prop => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
}
Element$1.defaults = {};
Element$1.defaultRoutes = undefined;

const formatters = {
  values(value) {
    return isArray(value) ? value : '' + value;
  },
  numeric(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e+15) {
        notation = 'scientific';
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = {notation, minimumFractionDigits: numDecimal, maximumFractionDigits: numDecimal};
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }
    const remain = tickValue / (Math.pow(10, Math.floor(log10(tickValue))));
    if (remain === 1 || remain === 2 || remain === 5) {
      return formatters.numeric.call(this, tickValue, index, ticks);
    }
    return '';
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = {formatters};

defaults$1.set('scale', {
  display: true,
  offset: false,
  reverse: false,
  beginAtZero: false,
  bounds: 'ticks',
  grace: 0,
  grid: {
    display: true,
    lineWidth: 1,
    drawBorder: true,
    drawOnChartArea: true,
    drawTicks: true,
    tickLength: 8,
    tickWidth: (_ctx, options) => options.lineWidth,
    tickColor: (_ctx, options) => options.color,
    offset: false,
    borderDash: [],
    borderDashOffset: 0.0,
    borderWidth: 1
  },
  title: {
    display: false,
    text: '',
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: false,
    textStrokeWidth: 0,
    textStrokeColor: '',
    padding: 3,
    display: true,
    autoSkip: true,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Ticks.formatters.values,
    minor: {},
    major: {},
    align: 'center',
    crossAlign: 'near',
    showLabelBackdrop: false,
    backdropColor: 'rgba(255, 255, 255, 0.75)',
    backdropPadding: 2,
  }
});
defaults$1.route('scale.ticks', 'color', '', 'color');
defaults$1.route('scale.grid', 'color', '', 'borderColor');
defaults$1.route('scale.grid', 'borderColor', '', 'borderColor');
defaults$1.route('scale.title', 'color', '', 'color');
defaults$1.describe('scale', {
  _fallback: false,
  _scriptable: (name) => !name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
  _indexable: (name) => name !== 'borderDash' && name !== 'tickBorderDash',
});
defaults$1.describe('scales', {
  _fallback: 'scale',
});
defaults$1.describe('scale.ticks', {
  _scriptable: (name) => name !== 'backdropPadding' && name !== 'callback',
  _indexable: (name) => name !== 'backdropPadding',
});

function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const ticksLimit = tickOpts.maxTicksLimit || determineMaxTicks(scale);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i;
  spacing = Math.ceil(spacing);
  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start;
  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }
  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }
  return diff;
}

const reverseAlign = (align) => align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset) => edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex = Math.min(index, length - 1);
  const start = scale._startPixel;
  const end = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex);
  let offset;
  if (offsetGridLines) {
    if (length === 1) {
      offset = Math.max(lineValue - start, end - lineValue);
    } else if (index === 0) {
      offset = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
    }
    lineValue += validIndex < index ? offset : -offset;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, (cache) => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return (lines * font.lineHeight) + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext(parent, {
    scale,
    type: 'scale'
  });
}
function createTickContext(parent, index, tick) {
  return createContext(parent, {
    tick,
    index,
    type: 'tick'
  });
}
function titleAlign(align, position, reverse) {
  let ret = _toLeftRightCenter(align);
  if ((reverse && position !== 'right') || (!reverse && position === 'right')) {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset, position, align) {
  const {top, left, bottom, right, chart} = scale;
  const {chartArea, scales} = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height = bottom - top;
  const width = right - left;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject$1(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
    } else if (position === 'center') {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
    } else {
      titleY = offsetFromEdge(scale, position, offset);
    }
    maxWidth = right - left;
  } else {
    if (isObject$1(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
    } else if (position === 'center') {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
    } else {
      titleX = offsetFromEdge(scale, position, offset);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position === 'left' ? -HALF_PI : HALF_PI;
  }
  return {titleX, titleY, maxWidth, rotation};
}
class Scale extends Element$1 {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = undefined;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.width = undefined;
    this.height = undefined;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = undefined;
    this.maxHeight = undefined;
    this.paddingTop = undefined;
    this.paddingBottom = undefined;
    this.paddingLeft = undefined;
    this.paddingRight = undefined;
    this.axis = undefined;
    this.labelRotation = undefined;
    this.min = undefined;
    this.max = undefined;
    this._range = undefined;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = undefined;
    this._endPixel = undefined;
    this._reversePixels = false;
    this._userMax = undefined;
    this._userMin = undefined;
    this._suggestedMax = undefined;
    this._suggestedMin = undefined;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = undefined;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index) {
    return raw;
  }
  getUserBounds() {
    let {_userMin, _userMax, _suggestedMin, _suggestedMax} = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let {min, max, minDefined, maxDefined} = this.getUserBounds();
    let range;
    if (minDefined && maxDefined) {
      return {min, max};
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min = Math.min(min, range.min);
      }
      if (!maxDefined) {
        max = Math.max(max, range.max);
      }
    }
    min = maxDefined && min > max ? max : min;
    max = minDefined && min > max ? min : max;
    return {
      min: finiteOrDefault(min, finiteOrDefault(max, min)),
      max: finiteOrDefault(max, finiteOrDefault(min, max))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [this]);
  }
  update(maxWidth, maxHeight, margins) {
    const {beginAtZero, grace, ticks: tickOpts} = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal()
      ? this.width + margins.left + margins.right
      : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [this]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [this]);
  }
  beforeDataLimits() {
    this._callHooks('beforeDataLimits');
  }
  determineDataLimits() {}
  afterDataLimits() {
    this._callHooks('afterDataLimits');
  }
  beforeBuildTicks() {
    this._callHooks('beforeBuildTicks');
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks('afterBuildTicks');
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [tick.value, i, ticks], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = this.ticks.length;
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid)
				- tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(
        Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)),
        Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))
      ));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [this]);
  }
  beforeFit() {
    callback(this.options.beforeFit, [this]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const {chart, options: {ticks: tickOpts, title: titleOpts, grid: gridOpts}} = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const {first, last, widest, highest} = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last, sin, cos) {
    const {ticks: {align, padding}, position} = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position !== 'top' && this.axis === 'x';
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last.width;
        }
      } else if (align === 'start') {
        paddingRight = last.width;
      } else if (align === 'end') {
        paddingLeft = first.width;
      } else {
        paddingLeft = first.width / 2;
        paddingRight = last.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last.height / 2;
      let paddingBottom = first.height / 2;
      if (align === 'start') {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === 'end') {
        paddingTop = last.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const {axis, position} = this.options;
    return position === 'top' || position === 'bottom' || axis === 'x';
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length) {
    const {ctx, _longestTextCache: caches} = this;
    const widths = [];
    const heights = [];
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
    for (i = 0; i < length; ++i) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = (idx) => ({width: widths[idx] || 0, height: heights[idx] || 0});
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights,
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index) {
    return NaN;
  }
  getValueForPixel(pixel) {}
  getPixelForTick(index) {
    const ticks = this.ticks;
    if (index < 0 || index > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const {min, max} = this;
    return min < 0 && max < 0 ? max :
      min > 0 && max > 0 ? min :
      0;
  }
  getContext(index) {
    const ticks = this.ticks || [];
    if (index >= 0 && index < ticks.length) {
      const tick = ticks[index];
      return tick.$context ||
				(tick.$context = createTickContext(this.getContext(), index, tick));
    }
    return this.$context ||
			(this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w = labelSizes ? labelSizes.widest.width + padding : 0;
    const h = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal()
      ? h * cos > w * sin ? w / cos : h / sin
      : h * sin < w * cos ? h / cos : w / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== 'auto') {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const {grid, position} = options;
    const offset = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = grid.setContext(this.getContext());
    const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function(pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position === 'top') {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position === 'bottom') {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position === 'left') {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position === 'right') {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === 'x') {
      if (position === 'center') {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === 'y') {
      if (position === 'center') {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const optsAtIndex = grid.setContext(this.getContext(i));
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = grid.borderDash || [];
      const borderDashOffset = optsAtIndex.borderDashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset);
      if (lineValue === undefined) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset,
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const {position, ticks: optionTicks} = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const {align, crossAlign, padding, mirror} = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = 'middle';
    if (position === 'top') {
      y = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === 'bottom') {
      y = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === 'left') {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (position === 'right') {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (axis === 'x') {
      if (position === 'center') {
        y = ((chartArea.top + chartArea.bottom) / 2) + tickAndPadding;
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === 'y') {
      if (position === 'center') {
        x = ((chartArea.left + chartArea.right) / 2) - tickAndPadding;
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        x = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === 'y') {
      if (align === 'start') {
        textBaseline = 'top';
      } else if (align === 'end') {
        textBaseline = 'bottom';
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      if (isHorizontal) {
        x = pixel;
        if (position === 'top') {
          if (crossAlign === 'near' || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === 'center') {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === 'near' || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === 'center') {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
      } else {
        y = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top = y + textOffset - labelPadding.top;
        let left = x - labelPadding.left;
        switch (textBaseline) {
        case 'middle':
          top -= height / 2;
          break;
        case 'bottom':
          top -= height;
          break;
        }
        switch (textAlign) {
        case 'center':
          left -= width / 2;
          break;
        case 'right':
          left -= width;
          break;
        }
        backdrop = {
          left,
          top,
          width: width + labelPadding.width,
          height: height + labelPadding.height,
          color: optsAtIndex.backdropColor,
        };
      }
      items.push({
        rotation,
        label,
        font,
        color,
        strokeColor,
        strokeWidth,
        textOffset,
        textAlign,
        textBaseline,
        translation: [x, y],
        backdrop,
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const {position, ticks} = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position === 'top' ? 'left' : 'right';
    }
    let align = 'center';
    if (ticks.align === 'start') {
      align = 'left';
    } else if (ticks.align === 'end') {
      align = 'right';
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const {position, ticks: {crossAlign, mirror, padding}} = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x;
    if (position === 'left') {
      if (mirror) {
        x = this.right + padding;
        if (crossAlign === 'near') {
          textAlign = 'left';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x += (widest / 2);
        } else {
          textAlign = 'right';
          x += widest;
        }
      } else {
        x = this.right - tickAndPadding;
        if (crossAlign === 'near') {
          textAlign = 'right';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x -= (widest / 2);
        } else {
          textAlign = 'left';
          x = this.left;
        }
      }
    } else if (position === 'right') {
      if (mirror) {
        x = this.left + padding;
        if (crossAlign === 'near') {
          textAlign = 'right';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x -= (widest / 2);
        } else {
          textAlign = 'left';
          x -= widest;
        }
      } else {
        x = this.left + tickAndPadding;
        if (crossAlign === 'near') {
          textAlign = 'left';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x += widest / 2;
        } else {
          textAlign = 'right';
          x = this.right;
        }
      }
    } else {
      textAlign = 'right';
    }
    return {textAlign, x};
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position = this.options.position;
    if (position === 'left' || position === 'right') {
      return {top: 0, left: this.left, bottom: chart.height, right: this.right};
    } if (position === 'top' || position === 'bottom') {
      return {top: this.top, left: 0, bottom: this.bottom, right: chart.width};
    }
  }
  drawBackground() {
    const {ctx, options: {backgroundColor}, left, top, width, height} = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index = ticks.findIndex(t => t.value === value);
    if (index >= 0) {
      const opts = grid.setContext(this.getContext(index));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine(
            {x: item.x1, y: item.y1},
            {x: item.x2, y: item.y2},
            item
          );
        }
        if (grid.drawTicks) {
          drawLine(
            {x: item.tx1, y: item.ty1},
            {x: item.tx2, y: item.ty2},
            {
              color: item.tickColor,
              width: item.tickWidth,
              borderDash: item.tickBorderDash,
              borderDashOffset: item.tickBorderDashOffset
            }
          );
        }
      }
    }
  }
  drawBorder() {
    const {chart, ctx, options: {grid}} = this;
    const borderOpts = grid.setContext(this.getContext());
    const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.borderWidth;
    ctx.strokeStyle = borderOpts.borderColor;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    let i, ilen;
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      const item = items[i];
      const tickFont = item.font;
      const label = item.label;
      if (item.backdrop) {
        ctx.fillStyle = item.backdrop.color;
        ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
      }
      let y = item.textOffset;
      renderText(ctx, label, 0, y, tickFont, item);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const {ctx, options: {position, title, reverse}} = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset = font.lineHeight / 2;
    if (position === 'bottom' || position === 'center' || isObject$1(position)) {
      offset += padding.bottom;
      if (isArray(title.text)) {
        offset += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset += padding.top;
    }
    const {titleX, titleY, maxWidth, rotation} = titleArgs(this, offset, position, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position, reverse),
      textBaseline: 'middle',
      translation: [titleX, titleY],
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
      return [{
        z: tz,
        draw: (chartArea) => {
          this.draw(chartArea);
        }
      }];
    }
    return [{
      z: gz,
      draw: (chartArea) => {
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawTitle();
      }
    }, {
      z: gz + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: tz,
      draw: (chartArea) => {
        this.drawLabels(chartArea);
      }
    }];
  }
  getMatchingVisibleMetas(type) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + 'AxisID';
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type || meta.type === type)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index) {
    const opts = this.options.ticks.setContext(this.getContext(index));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
}

class TypedRegistry {
  constructor(type, scope, override) {
    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = Object.create(null);
  }
  isForType(type) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id = item.id;
    const scope = this.scope + '.' + id;
    if (!id) {
      throw new Error('class does not have id: ' + item);
    }
    if (id in items) {
      return scope;
    }
    items[id] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults$1.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id) {
    return this.items[id];
  }
  unregister(item) {
    const items = this.items;
    const id = item.id;
    const scope = this.scope;
    if (id in items) {
      delete items[id];
    }
    if (scope && id in defaults$1[scope]) {
      delete defaults$1[scope][id];
      if (this.override) {
        delete overrides[id];
      }
    }
  }
}
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge$1(Object.create(null), [
    parentScope ? defaults$1.get(parentScope) : {},
    defaults$1.get(scope),
    item.defaults
  ]);
  defaults$1.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults$1.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach(property => {
    const propertyParts = property.split('.');
    const sourceName = propertyParts.pop();
    const sourceScope = [scope].concat(propertyParts).join('.');
    const parts = routes[property].split('.');
    const targetName = parts.pop();
    const targetScope = parts.join('.');
    defaults$1.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return 'id' in proto && 'defaults' in proto;
}

class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
    this.elements = new TypedRegistry(Element$1, 'elements');
    this.plugins = new TypedRegistry(Object, 'plugins');
    this.scales = new TypedRegistry(Scale, 'scales');
    this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...args) {
    this._each('register', args);
  }
  remove(...args) {
    this._each('unregister', args);
  }
  addControllers(...args) {
    this._each('register', args, this.controllers);
  }
  addElements(...args) {
    this._each('register', args, this.elements);
  }
  addPlugins(...args) {
    this._each('register', args, this.plugins);
  }
  addScales(...args) {
    this._each('register', args, this.scales);
  }
  getController(id) {
    return this._get(id, this.controllers, 'controller');
  }
  getElement(id) {
    return this._get(id, this.elements, 'element');
  }
  getPlugin(id) {
    return this._get(id, this.plugins, 'plugin');
  }
  getScale(id) {
    return this._get(id, this.scales, 'scale');
  }
  removeControllers(...args) {
    this._each('unregister', args, this.controllers);
  }
  removeElements(...args) {
    this._each('unregister', args, this.elements);
  }
  removePlugins(...args) {
    this._each('unregister', args, this.plugins);
  }
  removeScales(...args) {
    this._each('unregister', args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [...args].forEach(arg => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || (reg === this.plugins && arg.id)) {
        this._exec(method, reg, arg);
      } else {
        each(arg, item => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry, component) {
    const camelMethod = _capitalize(method);
    callback(component['before' + camelMethod], [], component);
    registry[method](component);
    callback(component['after' + camelMethod], [], component);
  }
  _getRegistryForType(type) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id, typedRegistry, type) {
    const item = typedRegistry.get(id);
    if (item === undefined) {
      throw new Error('"' + id + '" is not a registered ' + type + '.');
    }
    return item;
  }
}
var registry = new Registry();

class PluginService {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === 'beforeInit') {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, 'install');
    }
    const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors, chart, hook, args);
    if (hook === 'afterDestroy') {
      this._notify(descriptors, chart, 'stop');
      this._notify(this._init, chart, 'uninstall');
    }
    return result;
  }
  _notify(descriptors, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors) {
      const plugin = descriptor.plugin;
      const method = plugin[hook];
      const params = [chart, args, descriptor.options];
      if (callback(method, params, plugin) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = undefined;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors = this._cache;
    const diff = (a, b) => a.filter(x => !b.some(y => x.plugin.id === y.plugin.id));
    this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
    this._notify(diff(descriptors, previousDescriptors), chart, 'start');
  }
}
function allPlugins(config) {
  const plugins = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins.push(registry.getPlugin(keys[i]));
  }
  const local = config.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin = local[i];
    if (plugins.indexOf(plugin) === -1) {
      plugins.push(plugin);
    }
  }
  return plugins;
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, plugins, options, all) {
  const result = [];
  const context = chart.getContext();
  for (let i = 0; i < plugins.length; i++) {
    const plugin = plugins[i];
    const id = plugin.id;
    const opts = getOpts(options[id], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin,
      options: pluginOpts(chart.config, plugin, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, plugin, opts, context) {
  const keys = config.pluginScopeKeys(plugin);
  const scopes = config.getOptionScopes(opts, keys);
  return config.createResolver(scopes, context, [''], {scriptable: false, indexable: false, allKeys: true});
}

function getIndexAxis(type, options) {
  const datasetDefaults = defaults$1.datasets[type] || {};
  const datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
  let axis = id;
  if (id === '_index_') {
    axis = indexAxis;
  } else if (id === '_value_') {
    axis = indexAxis === 'x' ? 'y' : 'x';
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? '_index_' : '_value_';
}
function axisFromPosition(position) {
  if (position === 'top' || position === 'bottom') {
    return 'x';
  }
  if (position === 'left' || position === 'right') {
    return 'y';
  }
}
function determineAxis(id, scaleOptions) {
  if (id === 'x' || id === 'y') {
    return id;
  }
  return scaleOptions.axis || axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || {scales: {}};
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const firstIDs = Object.create(null);
  const scales = Object.create(null);
  Object.keys(configScales).forEach(id => {
    const scaleConf = configScales[id];
    if (!isObject$1(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
    }
    const axis = determineAxis(id, scaleConf);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    firstIDs[axis] = firstIDs[axis] || id;
    scales[id] = mergeIf(Object.create(null), [{axis}, scaleConf, defaultScaleOptions[axis], defaultScaleOptions[defaultId]]);
  });
  config.data.datasets.forEach(dataset => {
    const type = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    const datasetDefaults = overrides[type] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach(defaultID => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id = dataset[axis + 'AxisID'] || firstIDs[axis] || axis;
      scales[id] = scales[id] || Object.create(null);
      mergeIf(scales[id], [{axis}, configScales[id], defaultScaleOptions[defaultID]]);
    });
  });
  Object.keys(scales).forEach(key => {
    const scale = scales[key];
    mergeIf(scale, [defaults$1.scales[scale.type], defaults$1.scale]);
  });
  return scales;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
const addIfFound = (set, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== undefined) {
    set.add(opts);
  }
};
class Config {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = new Map();
    this._resolverCache = new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type) {
    this._config.type = type;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(datasetType,
      () => [[
        `datasets.${datasetType}`,
        ''
      ]]);
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(`${datasetType}.transition.${transition}`,
      () => [
        [
          `datasets.${datasetType}.transitions.${transition}`,
          `transitions.${transition}`,
        ],
        [
          `datasets.${datasetType}`,
          ''
        ]
      ]);
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(`${datasetType}-${elementType}`,
      () => [[
        `datasets.${datasetType}.elements.${elementType}`,
        `datasets.${datasetType}`,
        `elements.${elementType}`,
        ''
      ]]);
  }
  pluginScopeKeys(plugin) {
    const id = plugin.id;
    const type = this.type;
    return cachedKeys(`${type}-plugin-${id}`,
      () => [[
        `plugins.${id}`,
        ...plugin.additionalOptionScopes || [],
      ]]);
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const {options, type} = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = new Set();
    keyLists.forEach(keys => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach(key => addIfFound(scopes, mainScope, key));
      }
      keys.forEach(key => addIfFound(scopes, options, key));
      keys.forEach(key => addIfFound(scopes, overrides[type] || {}, key));
      keys.forEach(key => addIfFound(scopes, defaults$1, key));
      keys.forEach(key => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const {options, type} = this;
    return [
      options,
      overrides[type] || {},
      defaults$1.datasets[type] || {},
      {type},
      defaults$1,
      descriptors
    ];
  }
  resolveNamedOptions(scopes, names, context, prefixes = ['']) {
    const result = {$shared: true};
    const {resolver, subPrefixes} = getResolver(this._resolverCache, scopes, prefixes);
    let options = resolver;
    if (needContext(resolver, names)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [''], descriptorDefaults) {
    const {resolver} = getResolver(this._resolverCache, scopes, prefixes);
    return isObject$1(context)
      ? _attachContext(resolver, context, undefined, descriptorDefaults)
      : resolver;
  }
}
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter(p => !p.toLowerCase().includes('hover'))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
const hasFunction = value => isObject$1(value)
  && Object.getOwnPropertyNames(value).reduce((acc, key) => acc || isFunction(value[key]), false);
function needContext(proxy, names) {
  const {isScriptable, isIndexable} = _descriptors(proxy);
  for (const prop of names) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if ((scriptable && (isFunction(value) || hasFunction(value)))
      || (indexable && isArray(value))) {
      return true;
    }
  }
  return false;
}

var version = "3.7.0";

const KNOWN_POSITIONS = ['top', 'bottom', 'left', 'right', 'chartArea'];
function positionIsHorizontal(position, axis) {
  return position === 'top' || position === 'bottom' || (KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x');
}
function compare2Level(l1, l2) {
  return function(a, b) {
    return a[l1] === b[l1]
      ? a[l2] - b[l2]
      : a[l1] - b[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  chart.notifyPlugins('afterRender');
  callback(animationOptions && animationOptions.onComplete, [context], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [context], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === 'string') {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
const instances = {};
const getChart = (key) => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter((c) => c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === 'mouseout') {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e;
}
class Chart$1 {
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error(
        'Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' +
				' must be destroyed before the canvas can be reused.'
      );
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = undefined;
    this.boxes = [];
    this.currentDevicePixelRatio = undefined;
    this.chartArea = undefined;
    this._active = [];
    this._lastEvent = undefined;
    this._listeners = {};
    this._responsiveListeners = undefined;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = undefined;
    this.$context = undefined;
    this._doResize = debounce$2(mode => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, 'complete', onAnimationsComplete);
    animator.listen(this, 'progress', onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const {options: {aspectRatio, maintainAspectRatio}, width, height, _aspectRatio} = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height ? width / height : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  _initialize() {
    this.notifyPlugins('beforeInit');
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins('afterInit');
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height) {
    if (!animator.running(this)) {
      this._resize(width, height);
    } else {
      this._resizeBeforeDraw = {width, height};
    }
  }
  _resize(width, height) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? 'resize' : 'attach';
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins('resize', {size: newSize});
    callback(options.onResize, [this, newSize], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales = this.scales;
    const updated = Object.keys(scales).reduce((obj, id) => {
      obj[id] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(
        Object.keys(scaleOpts).map((id) => {
          const scaleOptions = scaleOpts[id];
          const axis = determineAxis(id, scaleOptions);
          const isRadial = axis === 'r';
          const isHorizontal = axis === 'x';
          return {
            options: scaleOptions,
            dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
            dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
          };
        })
      );
    }
    each(items, (item) => {
      const scaleOptions = item.options;
      const id = scaleOptions.id;
      const axis = determineAxis(id, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id] = true;
      let scale = null;
      if (id in scales && scales[id].type === scaleType) {
        scale = scales[id];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id) => {
      if (!hasUpdated) {
        delete scales[id];
      }
    });
    each(scales, (scale) => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a, b) => a.index - b.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
  }
  _removeUnreferencedMetasets() {
    const {_metasets: metasets, data: {datasets}} = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index) => {
      if (datasets.filter(x => x === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type = dataset.type || this.config.type;
      if (meta.type && meta.type !== type) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = '' + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type);
        const {datasetElementType, dataElementType} = defaults$1.datasets[type];
        Object.assign(ControllerClass.prototype, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins('reset');
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins('beforeUpdate', {mode, cancelable: true}) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins('beforeElementsUpdate');
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const {controller} = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, (controller) => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins('afterUpdate', {mode});
    this._layers.sort(compare2Level('z', '_idx'));
    const {_active, _lastEvent} = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, (scale) => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const {_hiddenIndices} = this;
    const changes = this._getUniformDataChanges() || [];
    for (const {method, start, count} of changes) {
      const move = method === '_removeElements' ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = (idx) => new Set(
      _dataChanges
        .filter(c => c[0] === idx)
        .map((c, i) => i + ',' + c.splice(1).join(','))
    );
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet)
      .map(c => c.split(','))
      .map(a => ({method: a[1], start: +a[2], count: +a[3]}));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins('beforeLayout', {cancelable: true}) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, (box) => {
      if (noArea && box.position === 'chartArea') {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index) => {
      item._idx = index;
    });
    this.notifyPlugins('afterLayout');
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins('beforeDatasetsUpdate', {mode, cancelable: true}) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({datasetIndex: i}) : mode);
    }
    this.notifyPlugins('afterDatasetsUpdate', {mode});
  }
  _updateDataset(index, mode) {
    const meta = this.getDatasetMeta(index);
    const args = {meta, index, mode, cancelable: true};
    if (this.notifyPlugins('beforeDatasetUpdate', args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins('afterDatasetUpdate', args);
  }
  render() {
    if (this.notifyPlugins('beforeRender', {cancelable: true}) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({chart: this});
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const {width, height} = this._resizeBeforeDraw;
      this._resize(width, height);
      this._resizeBeforeDraw = null;
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins('beforeDraw', {cancelable: true}) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins('afterDraw');
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins('beforeDatasetsDraw', {cancelable: true}) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins('afterDatasetsDraw');
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = this.chartArea;
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins('beforeDatasetDraw', args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins('afterDatasetDraw', args);
  }
  getElementsAtEventForMode(e, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === 'function') {
      return method(this, e, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter(x => x && x._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, {chart: this, type: 'chart'}));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index) {
    this._hiddenIndices[index] = !this._hiddenIndices[index];
  }
  getDataVisibility(index) {
    return !this._hiddenIndices[index];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? 'show' : 'hide';
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(undefined, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, {visible});
      this.update((ctx) => ctx.datasetIndex === datasetIndex ? mode : undefined);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins('beforeDestroy');
    const {canvas, ctx} = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    this.notifyPlugins('destroy');
    delete instances[this.id];
    this.notifyPlugins('afterDestroy');
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type, listener) => {
      platform.addEventListener(this, type, listener);
      listeners[type] = listener;
    };
    const listener = (e, x, y) => {
      e.offsetX = x;
      e.offsetY = y;
      this._eventHandler(e);
    };
    each(this.options.events, (type) => _add(type, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type, listener) => {
      platform.addEventListener(this, type, listener);
      listeners[type] = listener;
    };
    const _remove = (type, listener) => {
      if (listeners[type]) {
        platform.removeEventListener(this, type, listener);
        delete listeners[type];
      }
    };
    const listener = (width, height) => {
      if (this.canvas) {
        this.resize(width, height);
      }
    };
    let detached;
    const attached = () => {
      _remove('attach', attached);
      this.attached = true;
      this.resize();
      _add('resize', listener);
      _add('detach', detached);
    };
    detached = () => {
      this.attached = false;
      _remove('resize', listener);
      this._stop();
      this._resize(0, 0);
      _add('attach', attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._responsiveListeners = undefined;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? 'set' : 'remove';
    let meta, item, i, ilen;
    if (mode === 'dataset') {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller['_' + prefix + 'DatasetHoverStyle']();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({datasetIndex, index}) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error('No dataset found at index ' + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index],
        index,
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a, b) => a.filter(x => !b.some(y => x.datasetIndex === y.datasetIndex && x.index === y.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e, replay) {
    const args = {
      event: e,
      replay,
      cancelable: true,
      inChartArea: _isPointInArea(e, this.chartArea, this._minPadding)
    };
    const eventFilter = (plugin) => (plugin.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins('afterEvent', args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e, replay, inChartArea) {
    const {_active: lastActive = [], options} = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e);
    const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [e, active, this], this);
      if (isClick) {
        callback(options.onClick, [e, active, this], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
}
const invalidatePlugins = () => each(Chart$1.instances, (chart) => chart._plugins.invalidate());
const enumerable = true;
Object.defineProperties(Chart$1, {
  defaults: {
    enumerable,
    value: defaults$1
  },
  instances: {
    enumerable,
    value: instances
  },
  overrides: {
    enumerable,
    value: overrides
  },
  registry: {
    enumerable,
    value: registry
  },
  version: {
    enumerable,
    value: version
  },
  getChart: {
    enumerable,
    value: getChart
  },
  register: {
    enumerable,
    value: (...items) => {
      registry.add(...items);
      invalidatePlugins();
    }
  },
  unregister: {
    enumerable,
    value: (...items) => {
      registry.remove(...items);
      invalidatePlugins();
    }
  }
});

function clipArc(ctx, element, endAngle) {
  const {startAngle, pixelMargin, x, y, outerRadius, innerRadius} = element;
  let angleMargin = pixelMargin / outerRadius;
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }
  ctx.closePath();
  ctx.clip();
}
function toRadiusCorners(value) {
  return _readValueToProps(value, ['outerStart', 'outerEnd', 'innerStart', 'innerEnd']);
}
function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  const o = toRadiusCorners(arc.options.borderRadius);
  const halfThickness = (outerRadius - innerRadius) / 2;
  const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
  const computeOuterLimit = (val) => {
    const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };
  return {
    outerStart: computeOuterLimit(o.outerStart),
    outerEnd: computeOuterLimit(o.outerEnd),
    innerStart: _limitValue(o.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o.innerEnd, 0, innerLimit),
  };
}
function rThetaToXY(r, theta, x, y) {
  return {
    x: x + r * Math.cos(theta),
    y: y + r * Math.sin(theta),
  };
}
function pathArc(ctx, element, offset, spacing, end) {
  const {x, y, startAngle: start, pixelMargin, innerRadius: innerR} = element;
  const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
  const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
  let spacingOffset = 0;
  const alpha = end - start;
  if (spacing) {
    const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
    const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
    const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    const adjustedAngle = avNogSpacingRadius !== 0 ? (alpha * avNogSpacingRadius) / (avNogSpacingRadius + spacing) : alpha;
    spacingOffset = (alpha - adjustedAngle) / 2;
  }
  const beta = Math.max(0.001, alpha * outerRadius - offset / PI) / outerRadius;
  const angleOffset = (alpha - beta) / 2;
  const startAngle = start + angleOffset + spacingOffset;
  const endAngle = end - angleOffset - spacingOffset;
  const {outerStart, outerEnd, innerStart, innerEnd} = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
  const outerStartAdjustedRadius = outerRadius - outerStart;
  const outerEndAdjustedRadius = outerRadius - outerEnd;
  const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  const innerStartAdjustedRadius = innerRadius + innerStart;
  const innerEndAdjustedRadius = innerRadius + innerEnd;
  const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
  if (outerEnd > 0) {
    const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
    ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
  }
  const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
  ctx.lineTo(p4.x, p4.y);
  if (innerEnd > 0) {
    const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
    ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
  }
  ctx.arc(x, y, innerRadius, endAngle - (innerEnd / innerRadius), startAngle + (innerStart / innerRadius), true);
  if (innerStart > 0) {
    const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
    ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
  }
  const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
  ctx.lineTo(p8.x, p8.y);
  if (outerStart > 0) {
    const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
    ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
  }
  ctx.closePath();
}
function drawArc(ctx, element, offset, spacing) {
  const {fullCircles, startAngle, circumference} = element;
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset, spacing, startAngle + TAU);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.fill();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + circumference % TAU;
      if (circumference % TAU === 0) {
        endAngle += TAU;
      }
    }
  }
  pathArc(ctx, element, offset, spacing, endAngle);
  ctx.fill();
  return endAngle;
}
function drawFullCircleBorders(ctx, element, inner) {
  const {x, y, startAngle, pixelMargin, fullCircles} = element;
  const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
  const innerRadius = element.innerRadius + pixelMargin;
  let i;
  if (inner) {
    clipArc(ctx, element, startAngle + TAU);
  }
  ctx.beginPath();
  ctx.arc(x, y, innerRadius, startAngle + TAU, startAngle, true);
  for (i = 0; i < fullCircles; ++i) {
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle, startAngle + TAU);
  for (i = 0; i < fullCircles; ++i) {
    ctx.stroke();
  }
}
function drawBorder(ctx, element, offset, spacing, endAngle) {
  const {options} = element;
  const {borderWidth, borderJoinStyle} = options;
  const inner = options.borderAlign === 'inner';
  if (!borderWidth) {
    return;
  }
  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || 'round';
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || 'bevel';
  }
  if (element.fullCircles) {
    drawFullCircleBorders(ctx, element, inner);
  }
  if (inner) {
    clipArc(ctx, element, endAngle);
  }
  pathArc(ctx, element, offset, spacing, endAngle);
  ctx.stroke();
}
class ArcElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = undefined;
    this.circumference = undefined;
    this.startAngle = undefined;
    this.endAngle = undefined;
    this.innerRadius = undefined;
    this.outerRadius = undefined;
    this.pixelMargin = 0;
    this.fullCircles = 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(chartX, chartY, useFinalPosition) {
    const point = this.getProps(['x', 'y'], useFinalPosition);
    const {angle, distance} = getAngleFromPoint(point, {x: chartX, y: chartY});
    const {startAngle, endAngle, innerRadius, outerRadius, circumference} = this.getProps([
      'startAngle',
      'endAngle',
      'innerRadius',
      'outerRadius',
      'circumference'
    ], useFinalPosition);
    const rAdjust = this.options.spacing / 2;
    const _circumference = valueOrDefault(circumference, endAngle - startAngle);
    const betweenAngles = _circumference >= TAU || _angleBetween(angle, startAngle, endAngle);
    const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
    return (betweenAngles && withinRadius);
  }
  getCenterPoint(useFinalPosition) {
    const {x, y, startAngle, endAngle, innerRadius, outerRadius} = this.getProps([
      'x',
      'y',
      'startAngle',
      'endAngle',
      'innerRadius',
      'outerRadius',
      'circumference',
    ], useFinalPosition);
    const {offset, spacing} = this.options;
    const halfAngle = (startAngle + endAngle) / 2;
    const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
    return {
      x: x + Math.cos(halfAngle) * halfRadius,
      y: y + Math.sin(halfAngle) * halfRadius
    };
  }
  tooltipPosition(useFinalPosition) {
    return this.getCenterPoint(useFinalPosition);
  }
  draw(ctx) {
    const {options, circumference} = this;
    const offset = (options.offset || 0) / 2;
    const spacing = (options.spacing || 0) / 2;
    this.pixelMargin = (options.borderAlign === 'inner') ? 0.33 : 0;
    this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
    if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
      return;
    }
    ctx.save();
    let radiusOffset = 0;
    if (offset) {
      radiusOffset = offset / 2;
      const halfAngle = (this.startAngle + this.endAngle) / 2;
      ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
      if (this.circumference >= PI) {
        radiusOffset = offset;
      }
    }
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    const endAngle = drawArc(ctx, this, radiusOffset, spacing);
    drawBorder(ctx, this, radiusOffset, spacing, endAngle);
    ctx.restore();
  }
}
ArcElement.id = 'arc';
ArcElement.defaults = {
  borderAlign: 'center',
  borderColor: '#fff',
  borderJoinStyle: undefined,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: undefined,
};
ArcElement.defaultRoutes = {
  backgroundColor: 'backgroundColor'
};

function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const {start: paramsStart = 0, end: paramsEnd = count - 1} = params;
  const {start: segmentStart, end: segmentEnd} = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line, segment, params) {
  const {points, options} = line;
  const {count, start, loop, ilen} = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let {move = true, reverse} = params || {};
  let i, point, prev;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const {count, start, ilen} = pathVars(points, segment, params);
  const {move = true, reverse} = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = (index) => (start + (reverse ? ilen - index : index)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x = point.x;
    const y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }
    lastY = y;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
  const {segments, options} = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, {start, end: start + count - 1})) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}
class LineElement extends Element$1 {
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = undefined;
    this._chart = undefined;
    this._loop = undefined;
    this._fullLoop = undefined;
    this._path = undefined;
    this._points = undefined;
    this._segments = undefined;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, {property, start: value, end: value});
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const {start, end} = segments[i];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || (this.points.length - start);
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, {start, end: start + count - 1});
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = undefined;
    }
  }
}
LineElement.id = 'line';
LineElement.defaults = {
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: 'miter',
  borderWidth: 3,
  capBezierPoints: true,
  cubicInterpolationMode: 'default',
  fill: false,
  spanGaps: false,
  stepped: false,
  tension: 0,
};
LineElement.defaultRoutes = {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
};
LineElement.descriptors = {
  _scriptable: true,
  _indexable: (name) => name !== 'borderDash' && name !== 'fill',
};

function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const {[axis]: value} = el.getProps([axis], useFinalPosition);
  return (Math.abs(pos - value) < options.radius + options.hitRadius);
}
class PointElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = undefined;
    this.parsed = undefined;
    this.skip = undefined;
    this.stop = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const {x, y} = this.getProps(['x', 'y'], useFinalPosition);
    return ((Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2)) < Math.pow(options.hitRadius + options.radius, 2));
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, 'x', useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, 'y', useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const {x, y} = this.getProps(['x', 'y'], useFinalPosition);
    return {x, y};
  }
  size(options) {
    options = options || this.options || {};
    let radius = options.radius || 0;
    radius = Math.max(radius, radius && options.hoverRadius || 0);
    const borderWidth = radius && options.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    return options.radius + options.hitRadius;
  }
}
PointElement.id = 'point';
PointElement.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: 'circle',
  radius: 3,
  rotation: 0
};
PointElement.defaultRoutes = {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
};

function getBarBounds(bar, useFinalPosition) {
  const {x, y, base, width, height} = bar.getProps(['x', 'y', 'base', 'width', 'height'], useFinalPosition);
  let left, right, top, bottom, half;
  if (bar.horizontal) {
    half = height / 2;
    left = Math.min(x, base);
    right = Math.max(x, base);
    top = y - half;
    bottom = y + half;
  } else {
    half = width / 2;
    left = x - half;
    right = x + half;
    top = Math.min(y, base);
    bottom = Math.max(y, base);
  }
  return {left, top, right, bottom};
}
function skipOrLimit(skip, value, min, max) {
  return skip ? 0 : _limitValue(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
  const value = bar.options.borderWidth;
  const skip = bar.borderSkipped;
  const o = toTRBL(value);
  return {
    t: skipOrLimit(skip.top, o.top, 0, maxH),
    r: skipOrLimit(skip.right, o.right, 0, maxW),
    b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
    l: skipOrLimit(skip.left, o.left, 0, maxW)
  };
}
function parseBorderRadius(bar, maxW, maxH) {
  const {enableBorderRadius} = bar.getProps(['enableBorderRadius']);
  const value = bar.options.borderRadius;
  const o = toTRBLCorners(value);
  const maxR = Math.min(maxW, maxH);
  const skip = bar.borderSkipped;
  const enableBorder = enableBorderRadius || isObject$1(value);
  return {
    topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
  };
}
function boundingRects$1(bar) {
  const bounds = getBarBounds(bar);
  const width = bounds.right - bounds.left;
  const height = bounds.bottom - bounds.top;
  const border = parseBorderWidth(bar, width / 2, height / 2);
  const radius = parseBorderRadius(bar, width / 2, height / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height,
      radius
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r)),
      }
    }
  };
}
function inRange(bar, x, y, useFinalPosition) {
  const skipX = x === null;
  const skipY = y === null;
  const skipBoth = skipX && skipY;
  const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
  return bounds
		&& (skipX || _isBetween(x, bounds.left, bounds.right))
		&& (skipY || _isBetween(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
  return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
  const x = rect.x !== refRect.x ? -amount : 0;
  const y = rect.y !== refRect.y ? -amount : 0;
  const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
  const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
  return {
    x: rect.x + x,
    y: rect.y + y,
    w: rect.w + w,
    h: rect.h + h,
    radius: rect.radius
  };
}
class BarElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = undefined;
    this.horizontal = undefined;
    this.base = undefined;
    this.width = undefined;
    this.height = undefined;
    this.inflateAmount = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  draw(ctx) {
    const {inflateAmount, options: {borderColor, backgroundColor}} = this;
    const {inner, outer} = boundingRects$1(this);
    const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
    ctx.save();
    if (outer.w !== inner.w || outer.h !== inner.h) {
      ctx.beginPath();
      addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
      ctx.clip();
      addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
      ctx.fillStyle = borderColor;
      ctx.fill('evenodd');
    }
    ctx.beginPath();
    addRectPath(ctx, inflateRect(inner, inflateAmount));
    ctx.fillStyle = backgroundColor;
    ctx.fill();
    ctx.restore();
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange(this, null, mouseY, useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const {x, y, base, horizontal} = this.getProps(['x', 'y', 'base', 'horizontal'], useFinalPosition);
    return {
      x: horizontal ? (x + base) / 2 : x,
      y: horizontal ? y : (y + base) / 2
    };
  }
  getRange(axis) {
    return axis === 'x' ? this.width / 2 : this.height / 2;
  }
}
BarElement.id = 'bar';
BarElement.defaults = {
  borderSkipped: 'start',
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: 'auto',
  pointStyle: undefined
};
BarElement.defaultRoutes = {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
};

var elements = /*#__PURE__*/Object.freeze({
__proto__: null,
ArcElement: ArcElement,
LineElement: LineElement,
PointElement: PointElement,
BarElement: BarElement
});

function lttbDecimation(data, start, count, availableWidth, options) {
  const samples = options.samples || availableWidth;
  if (samples >= count) {
    return data.slice(start, start + count);
  }
  const decimated = [];
  const bucketWidth = (count - 2) / (samples - 2);
  let sampledIndex = 0;
  const endIndex = start + count - 1;
  let a = start;
  let i, maxAreaPoint, maxArea, area, nextA;
  decimated[sampledIndex++] = data[a];
  for (i = 0; i < samples - 2; i++) {
    let avgX = 0;
    let avgY = 0;
    let j;
    const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
    const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
    const avgRangeLength = avgRangeEnd - avgRangeStart;
    for (j = avgRangeStart; j < avgRangeEnd; j++) {
      avgX += data[j].x;
      avgY += data[j].y;
    }
    avgX /= avgRangeLength;
    avgY /= avgRangeLength;
    const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
    const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
    const {x: pointAx, y: pointAy} = data[a];
    maxArea = area = -1;
    for (j = rangeOffs; j < rangeTo; j++) {
      area = 0.5 * Math.abs(
        (pointAx - avgX) * (data[j].y - pointAy) -
        (pointAx - data[j].x) * (avgY - pointAy)
      );
      if (area > maxArea) {
        maxArea = area;
        maxAreaPoint = data[j];
        nextA = j;
      }
    }
    decimated[sampledIndex++] = maxAreaPoint;
    a = nextA;
  }
  decimated[sampledIndex++] = data[endIndex];
  return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
  let avgX = 0;
  let countX = 0;
  let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
  const decimated = [];
  const endIndex = start + count - 1;
  const xMin = data[start].x;
  const xMax = data[endIndex].x;
  const dx = xMax - xMin;
  for (i = start; i < start + count; ++i) {
    point = data[i];
    x = (point.x - xMin) / dx * availableWidth;
    y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
        minIndex = i;
      } else if (y > maxY) {
        maxY = y;
        maxIndex = i;
      }
      avgX = (countX * avgX + point.x) / ++countX;
    } else {
      const lastIndex = i - 1;
      if (!isNullOrUndef(minIndex) && !isNullOrUndef(maxIndex)) {
        const intermediateIndex1 = Math.min(minIndex, maxIndex);
        const intermediateIndex2 = Math.max(minIndex, maxIndex);
        if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) {
          decimated.push({
            ...data[intermediateIndex1],
            x: avgX,
          });
        }
        if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) {
          decimated.push({
            ...data[intermediateIndex2],
            x: avgX
          });
        }
      }
      if (i > 0 && lastIndex !== startIndex) {
        decimated.push(data[lastIndex]);
      }
      decimated.push(point);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
      minIndex = maxIndex = startIndex = i;
    }
  }
  return decimated;
}
function cleanDecimatedDataset(dataset) {
  if (dataset._decimated) {
    const data = dataset._data;
    delete dataset._decimated;
    delete dataset._data;
    Object.defineProperty(dataset, 'data', {value: data});
  }
}
function cleanDecimatedData(chart) {
  chart.data.datasets.forEach((dataset) => {
    cleanDecimatedDataset(dataset);
  });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
  const pointCount = points.length;
  let start = 0;
  let count;
  const {iScale} = meta;
  const {min, max, minDefined, maxDefined} = iScale.getUserBounds();
  if (minDefined) {
    start = _limitValue(_lookupByKey(points, iScale.axis, min).lo, 0, pointCount - 1);
  }
  if (maxDefined) {
    count = _limitValue(_lookupByKey(points, iScale.axis, max).hi + 1, start, pointCount) - start;
  } else {
    count = pointCount - start;
  }
  return {start, count};
}
var plugin_decimation = {
  id: 'decimation',
  defaults: {
    algorithm: 'min-max',
    enabled: false,
  },
  beforeElementsUpdate: (chart, args, options) => {
    if (!options.enabled) {
      cleanDecimatedData(chart);
      return;
    }
    const availableWidth = chart.width;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const {_data, indexAxis} = dataset;
      const meta = chart.getDatasetMeta(datasetIndex);
      const data = _data || dataset.data;
      if (resolve([indexAxis, chart.options.indexAxis]) === 'y') {
        return;
      }
      if (meta.type !== 'line') {
        return;
      }
      const xAxis = chart.scales[meta.xAxisID];
      if (xAxis.type !== 'linear' && xAxis.type !== 'time') {
        return;
      }
      if (chart.options.parsing) {
        return;
      }
      let {start, count} = getStartAndCountOfVisiblePointsSimplified(meta, data);
      const threshold = options.threshold || 4 * availableWidth;
      if (count <= threshold) {
        cleanDecimatedDataset(dataset);
        return;
      }
      if (isNullOrUndef(_data)) {
        dataset._data = data;
        delete dataset.data;
        Object.defineProperty(dataset, 'data', {
          configurable: true,
          enumerable: true,
          get: function() {
            return this._decimated;
          },
          set: function(d) {
            this._data = d;
          }
        });
      }
      let decimated;
      switch (options.algorithm) {
      case 'lttb':
        decimated = lttbDecimation(data, start, count, availableWidth, options);
        break;
      case 'min-max':
        decimated = minMaxDecimation(data, start, count, availableWidth);
        break;
      default:
        throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
      }
      dataset._decimated = decimated;
    });
  },
  destroy(chart) {
    cleanDecimatedData(chart);
  }
};

function getLineByIndex(chart, index) {
  const meta = chart.getDatasetMeta(index);
  const visible = meta && chart.isDatasetVisible(index);
  return visible ? meta.dataset : null;
}
function parseFillOption(line) {
  const options = line.options;
  const fillOption = options.fill;
  let fill = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill === undefined) {
    fill = !!options.backgroundColor;
  }
  if (fill === false || fill === null) {
    return false;
  }
  if (fill === true) {
    return 'origin';
  }
  return fill;
}
function decodeFill(line, index, count) {
  const fill = parseFillOption(line);
  if (isObject$1(fill)) {
    return isNaN(fill.value) ? false : fill;
  }
  let target = parseFloat(fill);
  if (isNumberFinite(target) && Math.floor(target) === target) {
    if (fill[0] === '-' || fill[0] === '+') {
      target = index + target;
    }
    if (target === index || target < 0 || target >= count) {
      return false;
    }
    return target;
  }
  return ['origin', 'start', 'end', 'stack', 'shape'].indexOf(fill) >= 0 && fill;
}
function computeLinearBoundary(source) {
  const {scale = {}, fill} = source;
  let target = null;
  let horizontal;
  if (fill === 'start') {
    target = scale.bottom;
  } else if (fill === 'end') {
    target = scale.top;
  } else if (isObject$1(fill)) {
    target = scale.getPixelForValue(fill.value);
  } else if (scale.getBasePixel) {
    target = scale.getBasePixel();
  }
  if (isNumberFinite(target)) {
    horizontal = scale.isHorizontal();
    return {
      x: horizontal ? target : null,
      y: horizontal ? null : target
    };
  }
  return null;
}
class simpleArc {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const {x, y, radius} = this;
    bounds = bounds || {start: 0, end: TAU};
    ctx.arc(x, y, radius, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const {x, y, radius} = this;
    const angle = point.angle;
    return {
      x: x + Math.cos(angle) * radius,
      y: y + Math.sin(angle) * radius,
      angle
    };
  }
}
function computeCircularBoundary(source) {
  const {scale, fill} = source;
  const options = scale.options;
  const length = scale.getLabels().length;
  const target = [];
  const start = options.reverse ? scale.max : scale.min;
  const end = options.reverse ? scale.min : scale.max;
  let i, center, value;
  if (fill === 'start') {
    value = start;
  } else if (fill === 'end') {
    value = end;
  } else if (isObject$1(fill)) {
    value = fill.value;
  } else {
    value = scale.getBaseValue();
  }
  if (options.grid.circular) {
    center = scale.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value)
    });
  }
  for (i = 0; i < length; ++i) {
    target.push(scale.getPointPositionForValue(i, value));
  }
  return target;
}
function computeBoundary(source) {
  const scale = source.scale || {};
  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function findSegmentEnd(start, end, points) {
  for (;end > start; end--) {
    const point = points[end];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end;
}
function pointsFromSegments(boundary, line) {
  const {x = null, y = null} = boundary || {};
  const linePoints = line.points;
  const points = [];
  line.segments.forEach(({start, end}) => {
    end = findSegmentEnd(start, end, linePoints);
    const first = linePoints[start];
    const last = linePoints[end];
    if (y !== null) {
      points.push({x: first.x, y});
      points.push({x: last.x, y});
    } else if (x !== null) {
      points.push({x, y: first.y});
      points.push({x, y: last.y});
    }
  });
  return points;
}
function buildStackLine(source) {
  const {scale, index, line} = source;
  const points = [];
  const segments = line.segments;
  const sourcePoints = line.points;
  const linesBelow = getLinesBelow(scale, index);
  linesBelow.push(createBoundaryLine({x: null, y: scale.bottom}, line));
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({points, options: {}});
}
function getLinesBelow(scale, index) {
  const below = [];
  const metas = scale.getMatchingVisibleMetas('line');
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    if (meta.index === index) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line = linesBelow[j];
    const {first, last, point} = findPoint(line, sourcePoint, 'x');
    if (!point || (first && last)) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
  const point = line.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line.segments;
  const linePoints = line.points;
  let first = false;
  let last = false;
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last = pointValue === lastValue;
      break;
    }
  }
  return {first, last, point};
}
function getTarget(source) {
  const {chart, fill, line} = source;
  if (isNumberFinite(fill)) {
    return getLineByIndex(chart, fill);
  }
  if (fill === 'stack') {
    return buildStackLine(source);
  }
  if (fill === 'shape') {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return createBoundaryLine(boundary, line);
}
function createBoundaryLine(boundary, line) {
  let points = [];
  let _loop = false;
  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = pointsFromSegments(boundary, line);
  }
  return points.length ? new LineElement({
    points,
    options: {tension: 0},
    _loop,
    _fullLoop: _loop
  }) : null;
}
function resolveTarget(sources, index, propagate) {
  const source = sources[index];
  let fill = source.fill;
  const visited = [index];
  let target;
  if (!propagate) {
    return fill;
  }
  while (fill !== false && visited.indexOf(fill) === -1) {
    if (!isNumberFinite(fill)) {
      return fill;
    }
    target = sources[fill];
    if (!target) {
      return false;
    }
    if (target.visible) {
      return fill;
    }
    visited.push(fill);
    fill = target.fill;
  }
  return false;
}
function _clip(ctx, target, clipY) {
  ctx.beginPath();
  target.path(ctx);
  ctx.lineTo(target.last().x, clipY);
  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function getBounds(property, first, last, loop) {
  if (loop) {
    return;
  }
  let start = first[property];
  let end = last[property];
  if (property === 'angle') {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }
  return {property, start, end};
}
function _getEdge(a, b, prop, fn) {
  if (a && b) {
    return fn(a[prop], b[prop]);
  }
  return a ? a[prop] : b ? b[prop] : 0;
}
function _segments(line, target, property) {
  const segments = line.segments;
  const points = line.points;
  const tpoints = target.points;
  const parts = [];
  for (const segment of segments) {
    let {start, end} = segment;
    end = findSegmentEnd(start, end, points);
    const bounds = getBounds(property, points[start], points[end], segment.loop);
    if (!target.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start],
        end: points[end]
      });
      continue;
    }
    const targetSegments = _boundSegments(target, bounds);
    for (const tgt of targetSegments) {
      const subBounds = getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, 'start', Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, 'end', Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function clipBounds(ctx, scale, bounds) {
  const {top, bottom} = scale.chart.chartArea;
  const {property, start, end} = bounds || {};
  if (property === 'x') {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target, point, property) {
  const interpolatedPoint = target.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
function _fill(ctx, cfg) {
  const {line, target, property, color, scale} = cfg;
  const segments = _segments(line, target, property);
  for (const {source: src, target: tgt, start, end} of segments) {
    const {style: {backgroundColor = color} = {}} = src;
    const notShape = target !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale, notShape && getBounds(property, start, end));
    ctx.beginPath();
    const lineLoop = !!line.pathSegment(ctx, src);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target, end, property);
      }
      const targetLoop = !!target.pathSegment(ctx, tgt, {move: lineLoop, reverse: true});
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target, start, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? 'evenodd' : 'nonzero');
    ctx.restore();
  }
}
function doFill(ctx, cfg) {
  const {line, target, above, below, area, scale} = cfg;
  const property = line._loop ? 'angle' : cfg.axis;
  ctx.save();
  if (property === 'x' && below !== above) {
    _clip(ctx, target, area.top);
    _fill(ctx, {line, target, color: above, scale, property});
    ctx.restore();
    ctx.save();
    _clip(ctx, target, area.bottom);
  }
  _fill(ctx, {line, target, color: below, scale, property});
  ctx.restore();
}
function drawfill(ctx, source, area) {
  const target = getTarget(source);
  const {line, scale, axis} = source;
  const lineOpts = line.options;
  const fillOption = lineOpts.fill;
  const color = lineOpts.backgroundColor;
  const {above = color, below = color} = fillOption || {};
  if (target && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, {line, target, above, below, area, scale, axis});
    unclipArea(ctx);
  }
}
var plugin_filler = {
  id: 'filler',
  afterDatasetsUpdate(chart, _args, options) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i, line, source;
    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line = meta.dataset;
      source = null;
      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: decodeFill(line, i, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line,
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i = 0; i < count; ++i) {
      source = sources[i];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = resolveTarget(sources, i, options.propagate);
    }
  },
  beforeDraw(chart, _args, options) {
    const draw = options.drawTime === 'beforeDraw';
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw) {
        drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== 'beforeDatasetsDraw') {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (source) {
        drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options) {
    const source = args.meta.$filler;
    if (!source || source.fill === false || options.drawTime !== 'beforeDatasetDraw') {
      return;
    }
    drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: 'beforeDatasetDraw'
  }
};

const getBoxSize = (labelOpts, fontSize) => {
  let {boxHeight = fontSize, boxWidth = fontSize} = labelOpts;
  if (labelOpts.usePointStyle) {
    boxHeight = Math.min(boxHeight, fontSize);
    boxWidth = Math.min(boxWidth, fontSize);
  }
  return {
    boxWidth,
    boxHeight,
    itemHeight: Math.max(fontSize, boxHeight)
  };
};
const itemsEqual = (a, b) => a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element$1 {
  constructor(config) {
    super();
    this._added = false;
    this.legendHitBoxes = [];
    this._hoveredItem = null;
    this.doughnutMode = false;
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this.legendItems = undefined;
    this.columnSizes = undefined;
    this.lineWidths = undefined;
    this.maxHeight = undefined;
    this.maxWidth = undefined;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.height = undefined;
    this.width = undefined;
    this._margins = undefined;
    this.position = undefined;
    this.weight = undefined;
    this.fullSize = undefined;
  }
  update(maxWidth, maxHeight, margins) {
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins;
    this.setDimensions();
    this.buildLabels();
    this.fit();
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = this._margins.left;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = this._margins.top;
      this.bottom = this.height;
    }
  }
  buildLabels() {
    const labelOpts = this.options.labels || {};
    let legendItems = callback(labelOpts.generateLabels, [this.chart], this) || [];
    if (labelOpts.filter) {
      legendItems = legendItems.filter((item) => labelOpts.filter(item, this.chart.data));
    }
    if (labelOpts.sort) {
      legendItems = legendItems.sort((a, b) => labelOpts.sort(a, b, this.chart.data));
    }
    if (this.options.reverse) {
      legendItems.reverse();
    }
    this.legendItems = legendItems;
  }
  fit() {
    const {options, ctx} = this;
    if (!options.display) {
      this.width = this.height = 0;
      return;
    }
    const labelOpts = options.labels;
    const labelFont = toFont(labelOpts.font);
    const fontSize = labelFont.size;
    const titleHeight = this._computeTitleHeight();
    const {boxWidth, itemHeight} = getBoxSize(labelOpts, fontSize);
    let width, height;
    ctx.font = labelFont.string;
    if (this.isHorizontal()) {
      width = this.maxWidth;
      height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    } else {
      height = this.maxHeight;
      width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    }
    this.width = Math.min(width, options.maxWidth || this.maxWidth);
    this.height = Math.min(height, options.maxHeight || this.maxHeight);
  }
  _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
    const {ctx, maxWidth, options: {labels: {padding}}} = this;
    const hitboxes = this.legendHitBoxes = [];
    const lineWidths = this.lineWidths = [0];
    const lineHeight = itemHeight + padding;
    let totalHeight = titleHeight;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    let row = -1;
    let top = -lineHeight;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
      if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
        totalHeight += lineHeight;
        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
        top += lineHeight;
        row++;
      }
      hitboxes[i] = {left: 0, top, row, width: itemWidth, height: itemHeight};
      lineWidths[lineWidths.length - 1] += itemWidth + padding;
    });
    return totalHeight;
  }
  _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
    const {ctx, maxHeight, options: {labels: {padding}}} = this;
    const hitboxes = this.legendHitBoxes = [];
    const columnSizes = this.columnSizes = [];
    const heightLimit = maxHeight - titleHeight;
    let totalWidth = padding;
    let currentColWidth = 0;
    let currentColHeight = 0;
    let left = 0;
    let col = 0;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
      if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
        totalWidth += currentColWidth + padding;
        columnSizes.push({width: currentColWidth, height: currentColHeight});
        left += currentColWidth + padding;
        col++;
        currentColWidth = currentColHeight = 0;
      }
      hitboxes[i] = {left, top: currentColHeight, col, width: itemWidth, height: itemHeight};
      currentColWidth = Math.max(currentColWidth, itemWidth);
      currentColHeight += itemHeight + padding;
    });
    totalWidth += currentColWidth;
    columnSizes.push({width: currentColWidth, height: currentColHeight});
    return totalWidth;
  }
  adjustHitBoxes() {
    if (!this.options.display) {
      return;
    }
    const titleHeight = this._computeTitleHeight();
    const {legendHitBoxes: hitboxes, options: {align, labels: {padding}, rtl}} = this;
    const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
    if (this.isHorizontal()) {
      let row = 0;
      let left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
      for (const hitbox of hitboxes) {
        if (row !== hitbox.row) {
          row = hitbox.row;
          left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
        }
        hitbox.top += this.top + titleHeight + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
        left += hitbox.width + padding;
      }
    } else {
      let col = 0;
      let top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
      for (const hitbox of hitboxes) {
        if (hitbox.col !== col) {
          col = hitbox.col;
          top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
        }
        hitbox.top = top;
        hitbox.left += this.left + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
        top += hitbox.height + padding;
      }
    }
  }
  isHorizontal() {
    return this.options.position === 'top' || this.options.position === 'bottom';
  }
  draw() {
    if (this.options.display) {
      const ctx = this.ctx;
      clipArea(ctx, this);
      this._draw();
      unclipArea(ctx);
    }
  }
  _draw() {
    const {options: opts, columnSizes, lineWidths, ctx} = this;
    const {align, labels: labelOpts} = opts;
    const defaultColor = defaults$1.color;
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const labelFont = toFont(labelOpts.font);
    const {color: fontColor, padding} = labelOpts;
    const fontSize = labelFont.size;
    const halfFontSize = fontSize / 2;
    let cursor;
    this.drawTitle();
    ctx.textAlign = rtlHelper.textAlign('left');
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 0.5;
    ctx.font = labelFont.string;
    const {boxWidth, boxHeight, itemHeight} = getBoxSize(labelOpts, fontSize);
    const drawLegendBox = function(x, y, legendItem) {
      if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
        return;
      }
      ctx.save();
      const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
      ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
      ctx.lineCap = valueOrDefault(legendItem.lineCap, 'butt');
      ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
      ctx.lineJoin = valueOrDefault(legendItem.lineJoin, 'miter');
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
      ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
      if (labelOpts.usePointStyle) {
        const drawOptions = {
          radius: boxWidth * Math.SQRT2 / 2,
          pointStyle: legendItem.pointStyle,
          rotation: legendItem.rotation,
          borderWidth: lineWidth
        };
        const centerX = rtlHelper.xPlus(x, boxWidth / 2);
        const centerY = y + halfFontSize;
        drawPoint(ctx, drawOptions, centerX, centerY);
      } else {
        const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
        const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
        const borderRadius = toTRBLCorners(legendItem.borderRadius);
        ctx.beginPath();
        if (Object.values(borderRadius).some(v => v !== 0)) {
          addRoundedRectPath(ctx, {
            x: xBoxLeft,
            y: yBoxTop,
            w: boxWidth,
            h: boxHeight,
            radius: borderRadius,
          });
        } else {
          ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
        }
        ctx.fill();
        if (lineWidth !== 0) {
          ctx.stroke();
        }
      }
      ctx.restore();
    };
    const fillText = function(x, y, legendItem) {
      renderText(ctx, legendItem.text, x, y + (itemHeight / 2), labelFont, {
        strikethrough: legendItem.hidden,
        textAlign: rtlHelper.textAlign(legendItem.textAlign)
      });
    };
    const isHorizontal = this.isHorizontal();
    const titleHeight = this._computeTitleHeight();
    if (isHorizontal) {
      cursor = {
        x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
        y: this.top + padding + titleHeight,
        line: 0
      };
    } else {
      cursor = {
        x: this.left + padding,
        y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
        line: 0
      };
    }
    overrideTextDirection(this.ctx, opts.textDirection);
    const lineHeight = itemHeight + padding;
    this.legendItems.forEach((legendItem, i) => {
      ctx.strokeStyle = legendItem.fontColor || fontColor;
      ctx.fillStyle = legendItem.fontColor || fontColor;
      const textWidth = ctx.measureText(legendItem.text).width;
      const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
      const width = boxWidth + halfFontSize + textWidth;
      let x = cursor.x;
      let y = cursor.y;
      rtlHelper.setWidth(this.width);
      if (isHorizontal) {
        if (i > 0 && x + width + padding > this.right) {
          y = cursor.y += lineHeight;
          cursor.line++;
          x = cursor.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
        }
      } else if (i > 0 && y + lineHeight > this.bottom) {
        x = cursor.x = x + columnSizes[cursor.line].width + padding;
        cursor.line++;
        y = cursor.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
      }
      const realX = rtlHelper.x(x);
      drawLegendBox(realX, y, legendItem);
      x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
      fillText(rtlHelper.x(x), y, legendItem);
      if (isHorizontal) {
        cursor.x += width + padding;
      } else {
        cursor.y += lineHeight;
      }
    });
    restoreTextDirection(this.ctx, opts.textDirection);
  }
  drawTitle() {
    const opts = this.options;
    const titleOpts = opts.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    if (!titleOpts.display) {
      return;
    }
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const ctx = this.ctx;
    const position = titleOpts.position;
    const halfFontSize = titleFont.size / 2;
    const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
    let y;
    let left = this.left;
    let maxWidth = this.width;
    if (this.isHorizontal()) {
      maxWidth = Math.max(...this.lineWidths);
      y = this.top + topPaddingPlusHalfFontSize;
      left = _alignStartEnd(opts.align, left, this.right - maxWidth);
    } else {
      const maxHeight = this.columnSizes.reduce((acc, size) => Math.max(acc, size.height), 0);
      y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
    }
    const x = _alignStartEnd(position, left, left + maxWidth);
    ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
    ctx.textBaseline = 'middle';
    ctx.strokeStyle = titleOpts.color;
    ctx.fillStyle = titleOpts.color;
    ctx.font = titleFont.string;
    renderText(ctx, titleOpts.text, x, y, titleFont);
  }
  _computeTitleHeight() {
    const titleOpts = this.options.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
  }
  _getLegendItemAt(x, y) {
    let i, hitBox, lh;
    if (_isBetween(x, this.left, this.right)
      && _isBetween(y, this.top, this.bottom)) {
      lh = this.legendHitBoxes;
      for (i = 0; i < lh.length; ++i) {
        hitBox = lh[i];
        if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width)
          && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
          return this.legendItems[i];
        }
      }
    }
    return null;
  }
  handleEvent(e) {
    const opts = this.options;
    if (!isListened(e.type, opts)) {
      return;
    }
    const hoveredItem = this._getLegendItemAt(e.x, e.y);
    if (e.type === 'mousemove') {
      const previous = this._hoveredItem;
      const sameItem = itemsEqual(previous, hoveredItem);
      if (previous && !sameItem) {
        callback(opts.onLeave, [e, previous, this], this);
      }
      this._hoveredItem = hoveredItem;
      if (hoveredItem && !sameItem) {
        callback(opts.onHover, [e, hoveredItem, this], this);
      }
    } else if (hoveredItem) {
      callback(opts.onClick, [e, hoveredItem, this], this);
    }
  }
}
function isListened(type, opts) {
  if (type === 'mousemove' && (opts.onHover || opts.onLeave)) {
    return true;
  }
  if (opts.onClick && (type === 'click' || type === 'mouseup')) {
    return true;
  }
  return false;
}
var plugin_legend = {
  id: 'legend',
  _element: Legend,
  start(chart, _args, options) {
    const legend = chart.legend = new Legend({ctx: chart.ctx, options, chart});
    layouts.configure(chart, legend, options);
    layouts.addBox(chart, legend);
  },
  stop(chart) {
    layouts.removeBox(chart, chart.legend);
    delete chart.legend;
  },
  beforeUpdate(chart, _args, options) {
    const legend = chart.legend;
    layouts.configure(chart, legend, options);
    legend.options = options;
  },
  afterUpdate(chart) {
    const legend = chart.legend;
    legend.buildLabels();
    legend.adjustHitBoxes();
  },
  afterEvent(chart, args) {
    if (!args.replay) {
      chart.legend.handleEvent(args.event);
    }
  },
  defaults: {
    display: true,
    position: 'top',
    align: 'center',
    fullSize: true,
    reverse: false,
    weight: 1000,
    onClick(e, legendItem, legend) {
      const index = legendItem.datasetIndex;
      const ci = legend.chart;
      if (ci.isDatasetVisible(index)) {
        ci.hide(index);
        legendItem.hidden = true;
      } else {
        ci.show(index);
        legendItem.hidden = false;
      }
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (ctx) => ctx.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(chart) {
        const datasets = chart.data.datasets;
        const {labels: {usePointStyle, pointStyle, textAlign, color}} = chart.legend.options;
        return chart._getSortedDatasetMetas().map((meta) => {
          const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
          const borderWidth = toPadding(style.borderWidth);
          return {
            text: datasets[meta.index].label,
            fillStyle: style.backgroundColor,
            fontColor: color,
            hidden: !meta.visible,
            lineCap: style.borderCapStyle,
            lineDash: style.borderDash,
            lineDashOffset: style.borderDashOffset,
            lineJoin: style.borderJoinStyle,
            lineWidth: (borderWidth.width + borderWidth.height) / 4,
            strokeStyle: style.borderColor,
            pointStyle: pointStyle || style.pointStyle,
            rotation: style.rotation,
            textAlign: textAlign || style.textAlign,
            borderRadius: 0,
            datasetIndex: meta.index
          };
        }, this);
      }
    },
    title: {
      color: (ctx) => ctx.chart.options.color,
      display: false,
      position: 'center',
      text: '',
    }
  },
  descriptors: {
    _scriptable: (name) => !name.startsWith('on'),
    labels: {
      _scriptable: (name) => !['generateLabels', 'filter', 'sort'].includes(name),
    }
  },
};

class Title extends Element$1 {
  constructor(config) {
    super();
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this._padding = undefined;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.width = undefined;
    this.height = undefined;
    this.position = undefined;
    this.weight = undefined;
    this.fullSize = undefined;
  }
  update(maxWidth, maxHeight) {
    const opts = this.options;
    this.left = 0;
    this.top = 0;
    if (!opts.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = maxWidth;
    this.height = this.bottom = maxHeight;
    const lineCount = isArray(opts.text) ? opts.text.length : 1;
    this._padding = toPadding(opts.padding);
    const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
    if (this.isHorizontal()) {
      this.height = textSize;
    } else {
      this.width = textSize;
    }
  }
  isHorizontal() {
    const pos = this.options.position;
    return pos === 'top' || pos === 'bottom';
  }
  _drawArgs(offset) {
    const {top, left, bottom, right, options} = this;
    const align = options.align;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (this.isHorizontal()) {
      titleX = _alignStartEnd(align, left, right);
      titleY = top + offset;
      maxWidth = right - left;
    } else {
      if (options.position === 'left') {
        titleX = left + offset;
        titleY = _alignStartEnd(align, bottom, top);
        rotation = PI * -0.5;
      } else {
        titleX = right - offset;
        titleY = _alignStartEnd(align, top, bottom);
        rotation = PI * 0.5;
      }
      maxWidth = bottom - top;
    }
    return {titleX, titleY, maxWidth, rotation};
  }
  draw() {
    const ctx = this.ctx;
    const opts = this.options;
    if (!opts.display) {
      return;
    }
    const fontOpts = toFont(opts.font);
    const lineHeight = fontOpts.lineHeight;
    const offset = lineHeight / 2 + this._padding.top;
    const {titleX, titleY, maxWidth, rotation} = this._drawArgs(offset);
    renderText(ctx, opts.text, 0, 0, fontOpts, {
      color: opts.color,
      maxWidth,
      rotation,
      textAlign: _toLeftRightCenter(opts.align),
      textBaseline: 'middle',
      translation: [titleX, titleY],
    });
  }
}
function createTitle(chart, titleOpts) {
  const title = new Title({
    ctx: chart.ctx,
    options: titleOpts,
    chart
  });
  layouts.configure(chart, title, titleOpts);
  layouts.addBox(chart, title);
  chart.titleBlock = title;
}
var plugin_title = {
  id: 'title',
  _element: Title,
  start(chart, _args, options) {
    createTitle(chart, options);
  },
  stop(chart) {
    const titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate(chart, _args, options) {
    const title = chart.titleBlock;
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: 'center',
    display: false,
    font: {
      weight: 'bold',
    },
    fullSize: true,
    padding: 10,
    position: 'top',
    text: '',
    weight: 2000
  },
  defaultRoutes: {
    color: 'color'
  },
  descriptors: {
    _scriptable: true,
    _indexable: false,
  },
};

const map$1 = new WeakMap();
var plugin_subtitle = {
  id: 'subtitle',
  start(chart, _args, options) {
    const title = new Title({
      ctx: chart.ctx,
      options,
      chart
    });
    layouts.configure(chart, title, options);
    layouts.addBox(chart, title);
    map$1.set(chart, title);
  },
  stop(chart) {
    layouts.removeBox(chart, map$1.get(chart));
    map$1.delete(chart);
  },
  beforeUpdate(chart, _args, options) {
    const title = map$1.get(chart);
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: 'center',
    display: false,
    font: {
      weight: 'normal',
    },
    fullSize: true,
    padding: 0,
    position: 'top',
    text: '',
    weight: 1500
  },
  defaultRoutes: {
    color: 'color'
  },
  descriptors: {
    _scriptable: true,
    _indexable: false,
  },
};

const positioners$1 = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let x = 0;
    let y = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        x += pos.x;
        y += pos.y;
        ++count;
      }
    }
    return {
      x: x / count,
      y: y / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x = eventPosition.x;
    let y = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d = distanceBetweenPoints(eventPosition, center);
        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }
    return {
      x,
      y
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
    return str.split('\n');
  }
  return str;
}
function createTooltipItem(chart, item) {
  const {element, datasetIndex, index} = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const {label, value} = controller.getLabelAndValue(index);
  return {
    chart,
    label,
    parsed: controller.getParsed(index),
    raw: chart.data.datasets[datasetIndex].data[index],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const {body, footer, title} = tooltip;
  const {boxWidth, boxHeight} = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight
			+ (titleLineCount - 1) * options.titleSpacing
			+ options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight
			+ (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight
			+ (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height += options.footerMarginTop
			+ footerLineCount * footerFont.lineHeight
			+ (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function(line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? (boxWidth + 2 + options.boxPadding) : 0;
  each(body, (bodyItem) => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {width, height};
}
function determineYAlign(chart, size) {
  const {y, height} = size;
  if (y < height / 2) {
    return 'top';
  } else if (y > (chart.height - height / 2)) {
    return 'bottom';
  }
  return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
  const {x, width} = size;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === 'left' && x + width + caret > chart.width) {
    return true;
  }
  if (xAlign === 'right' && x - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size, yAlign) {
  const {x, width} = size;
  const {width: chartWidth, chartArea: {left, right}} = chart;
  let xAlign = 'center';
  if (yAlign === 'center') {
    xAlign = x <= (left + right) / 2 ? 'left' : 'right';
  } else if (x <= width / 2) {
    xAlign = 'left';
  } else if (x >= chartWidth - width / 2) {
    xAlign = 'right';
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = 'center';
  }
  return xAlign;
}
function determineAlignment(chart, options, size) {
  const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign
  };
}
function alignX(size, xAlign) {
  let {x, width} = size;
  if (xAlign === 'right') {
    x -= width;
  } else if (xAlign === 'center') {
    x -= (width / 2);
  }
  return x;
}
function alignY(size, yAlign, paddingAndSize) {
  let {y, height} = size;
  if (yAlign === 'top') {
    y += paddingAndSize;
  } else if (yAlign === 'bottom') {
    y -= height + paddingAndSize;
  } else {
    y -= (height / 2);
  }
  return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
  const {caretSize, caretPadding, cornerRadius} = options;
  const {xAlign, yAlign} = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const {topLeft, topRight, bottomLeft, bottomRight} = toTRBLCorners(cornerRadius);
  let x = alignX(size, xAlign);
  const y = alignY(size, yAlign, paddingAndSize);
  if (yAlign === 'center') {
    if (xAlign === 'left') {
      x += paddingAndSize;
    } else if (xAlign === 'right') {
      x -= paddingAndSize;
    }
  } else if (xAlign === 'left') {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === 'right') {
    x += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === 'center'
    ? tooltip.x + tooltip.width / 2
    : align === 'right'
      ? tooltip.x + tooltip.width - padding.right
      : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
  return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip,
    tooltipItems,
    type: 'tooltip'
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
class Tooltip extends Element$1 {
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = undefined;
    this._size = undefined;
    this._cachedAnimations = undefined;
    this._tooltipItems = [];
    this.$animations = undefined;
    this.$context = undefined;
    this.chart = config.chart || config._chart;
    this._chart = this.chart;
    this.options = config.options;
    this.dataPoints = undefined;
    this.title = undefined;
    this.beforeBody = undefined;
    this.body = undefined;
    this.afterBody = undefined;
    this.footer = undefined;
    this.xAlign = undefined;
    this.yAlign = undefined;
    this.x = undefined;
    this.y = undefined;
    this.height = undefined;
    this.width = undefined;
    this.caretX = undefined;
    this.caretY = undefined;
    this.labelColors = undefined;
    this.labelPointStyles = undefined;
    this.labelTextColors = undefined;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = undefined;
    this.$context = undefined;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context ||
			(this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const {callbacks} = options;
    const beforeTitle = callbacks.beforeTitle.apply(this, [context]);
    const title = callbacks.title.apply(this, [context]);
    const afterTitle = callbacks.afterTitle.apply(this, [context]);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [tooltipItems]));
  }
  getBody(tooltipItems, options) {
    const {callbacks} = options;
    const bodyItems = [];
    each(tooltipItems, (context) => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(scoped.beforeLabel.call(this, context)));
      pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
      pushOrConcat(bodyItem.after, splitNewlines(scoped.afterLabel.call(this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [tooltipItems]));
  }
  getFooter(tooltipItems, options) {
    const {callbacks} = options;
    const beforeFooter = callbacks.beforeFooter.apply(this, [tooltipItems]);
    const footer = callbacks.footer.apply(this, [tooltipItems]);
    const afterFooter = callbacks.afterFooter.apply(this, [tooltipItems]);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active[i]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index, array) => options.filter(element, index, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a, b) => options.itemSort(a, b, data));
    }
    each(tooltipItems, (context) => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(scoped.labelColor.call(this, context));
      labelPointStyles.push(scoped.labelPointStyle.call(this, context));
      labelTextColors.push(scoped.labelTextColor.call(this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position = positioners$1[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, size);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size.width,
        height: size.height,
        caretX: position.x,
        caretY: position.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = undefined;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, {chart: this.chart, tooltip: this, replay});
    }
  }
  drawCaret(tooltipPoint, ctx, size, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size, options) {
    const {xAlign, yAlign} = this;
    const {caretSize, cornerRadius} = options;
    const {topLeft, topRight, bottomLeft, bottomRight} = toTRBLCorners(cornerRadius);
    const {x: ptX, y: ptY} = tooltipPoint;
    const {width, height} = size;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === 'center') {
      y2 = ptY + (height / 2);
      if (xAlign === 'left') {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === 'left') {
        x2 = ptX + Math.max(topLeft, bottomLeft) + (caretSize);
      } else if (xAlign === 'right') {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === 'top') {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return {x1, x2, x3, y1, y2, y3};
  }
  drawTitle(pt, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = 'middle';
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length) {
          pt.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options) {
    const labelColors = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const {boxHeight, boxWidth, boxPadding} = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, 'left', options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColors.borderColor;
      ctx.fillStyle = labelColors.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = labelColors.borderWidth || 1;
      ctx.strokeStyle = labelColors.borderColor;
      ctx.setLineDash(labelColors.borderDash || []);
      ctx.lineDashOffset = labelColors.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
      const borderRadius = toTRBLCorners(labelColors.borderRadius);
      if (Object.values(borderRadius).some(v => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius,
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColors.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius,
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColors.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options) {
    const {body} = this;
    const {bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding} = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function(line) {
      ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = 'middle';
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== 'right'
      ? bodyAlign === 'center' ? (boxWidth / 2 + boxPadding) : (boxWidth + 2 + boxPadding)
      : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.footerAlign, options);
      pt.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = 'middle';
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options) {
    const {xAlign, yAlign} = this;
    const {x, y} = pt;
    const {width, height} = tooltipSize;
    const {topLeft, topRight, bottomLeft, bottomRight} = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x + topLeft, y);
    if (yAlign === 'top') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width - topRight, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
    if (yAlign === 'center' && xAlign === 'right') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width, y + height - bottomRight);
    ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
    if (yAlign === 'bottom') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + bottomLeft, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
    if (yAlign === 'center' && xAlign === 'left') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x, y + topLeft);
    ctx.quadraticCurveTo(x, y, x + topLeft, y);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position = positioners$1[options.position].call(this, this._active, this._eventPosition);
      if (!position) {
        return;
      }
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size.width;
        this.height = size.height;
        this.caretX = position.x;
        this.caretY = position.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options);
      this.drawBody(pt, ctx, options);
      this.drawFooter(pt, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({datasetIndex, index}) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error('Cannot find a dataset at index ' + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index],
        index,
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e.x,
          y: e.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e) {
    const {caretX, caretY, options} = this;
    const position = positioners$1[options.position].call(this, active, e);
    return position !== false && (caretX !== position.x || caretY !== position.y);
  }
}
Tooltip.positioners = positioners$1;
var plugin_tooltip = {
  id: 'tooltip',
  _element: Tooltip,
  positioners: positioners$1,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip({chart, options});
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    const args = {
      tooltip
    };
    if (chart.notifyPlugins('beforeTooltipDraw', args) === false) {
      return;
    }
    if (tooltip) {
      tooltip.draw(chart.ctx);
    }
    chart.notifyPlugins('afterTooltipDraw', args);
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: 'average',
    backgroundColor: 'rgba(0,0,0,0.8)',
    titleColor: '#fff',
    titleFont: {
      weight: 'bold',
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: 'left',
    bodyColor: '#fff',
    bodySpacing: 2,
    bodyFont: {
    },
    bodyAlign: 'left',
    footerColor: '#fff',
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: 'bold',
    },
    footerAlign: 'left',
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: '#fff',
    displayColors: true,
    boxPadding: 0,
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: 'easeOutQuart',
    },
    animations: {
      numbers: {
        type: 'number',
        properties: ['x', 'y', 'width', 'height', 'caretX', 'caretY'],
      },
      opacity: {
        easing: 'linear',
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: noop$1,
      title(tooltipItems) {
        if (tooltipItems.length > 0) {
          const item = tooltipItems[0];
          const labels = item.chart.data.labels;
          const labelCount = labels ? labels.length : 0;
          if (this && this.options && this.options.mode === 'dataset') {
            return item.dataset.label || '';
          } else if (item.label) {
            return item.label;
          } else if (labelCount > 0 && item.dataIndex < labelCount) {
            return labels[item.dataIndex];
          }
        }
        return '';
      },
      afterTitle: noop$1,
      beforeBody: noop$1,
      beforeLabel: noop$1,
      label(tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') {
          return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        }
        let label = tooltipItem.dataset.label || '';
        if (label) {
          label += ': ';
        }
        const value = tooltipItem.formattedValue;
        if (!isNullOrUndef(value)) {
          label += value;
        }
        return label;
      },
      labelColor(tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          borderColor: options.borderColor,
          backgroundColor: options.backgroundColor,
          borderWidth: options.borderWidth,
          borderDash: options.borderDash,
          borderDashOffset: options.borderDashOffset,
          borderRadius: 0,
        };
      },
      labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle(tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          pointStyle: options.pointStyle,
          rotation: options.rotation,
        };
      },
      afterLabel: noop$1,
      afterBody: noop$1,
      beforeFooter: noop$1,
      footer: noop$1,
      afterFooter: noop$1
    }
  },
  defaultRoutes: {
    bodyFont: 'font',
    footerFont: 'font',
    titleFont: 'font'
  },
  descriptors: {
    _scriptable: (name) => name !== 'filter' && name !== 'itemSort' && name !== 'external',
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false,
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: 'animation'
    }
  },
  additionalOptionScopes: ['interaction']
};

var plugins = /*#__PURE__*/Object.freeze({
__proto__: null,
Decimation: plugin_decimation,
Filler: plugin_filler,
Legend: plugin_legend,
SubTitle: plugin_subtitle,
Title: plugin_title,
Tooltip: plugin_tooltip
});

const addIfString = (labels, raw, index, addedLabels) => {
  if (typeof raw === 'string') {
    index = labels.push(raw) - 1;
    addedLabels.unshift({index, label: raw});
  } else if (isNaN(raw)) {
    index = null;
  }
  return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index, addedLabels);
  }
  const last = labels.lastIndexOf(raw);
  return first !== last ? index : first;
}
const validIndex = (index, max) => index === null ? null : _limitValue(Math.round(index), 0, max);
class CategoryScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this._startValue = undefined;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const {index, label} of added) {
        if (labels[index] === label) {
          labels.splice(index, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index = isFinite(index) && labels[index] === raw ? index
      : findOrAddLabel(labels, raw, valueOrDefault(index, raw), this._addedLabels);
    return validIndex(index, labels.length - 1);
  }
  determineDataLimits() {
    const {minDefined, maxDefined} = this.getUserBounds();
    let {min, max} = this.getMinMax(true);
    if (this.options.bounds === 'ticks') {
      if (!minDefined) {
        min = 0;
      }
      if (!maxDefined) {
        max = this.getLabels().length - 1;
      }
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const min = this.min;
    const max = this.max;
    const offset = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = (min === 0 && max === labels.length - 1) ? labels : labels.slice(min, max + 1);
    this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
    this._startValue = this.min - (offset ? 0.5 : 0);
    for (let value = min; value <= max; value++) {
      ticks.push({value});
    }
    return ticks;
  }
  getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) {
      return labels[value];
    }
    return value;
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== 'number') {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index) {
    const ticks = this.ticks;
    if (index < 0 || index > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
CategoryScale.id = 'category';
CategoryScale.defaults = {
  ticks: {
    callback: CategoryScale.prototype.getLabelForValue
  }
};

function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const {bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds} = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const {min: rmin, max: rmax} = dataRange;
  const minDefined = !isNullOrUndef(min);
  const maxDefined = !isNullOrUndef(max);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [{value: rmin}, {value: rmax}];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === 'ticks') {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1000)) {
    numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
    spacing = (max - min) / numSpaces;
    niceMin = min;
    niceMax = max;
  } else if (countDefined) {
    niceMin = minDefined ? min : niceMin;
    niceMax = maxDefined ? max : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(
    _decimalPlaces(spacing),
    _decimalPlaces(niceMin)
  );
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min) {
      ticks.push({value: min});
      if (niceMin < min) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    ticks.push({value: Math.round((niceMin + j * spacing) * factor) / factor});
  }
  if (maxDefined && includeBounds && niceMax !== max) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max;
    } else {
      ticks.push({value: max});
    }
  } else if (!maxDefined || niceMax === max) {
    ticks.push({value: niceMax});
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, {horizontal, minRotation}) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
  const length = 0.75 * minSpacing * ('' + value).length;
  return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = undefined;
    this.end = undefined;
    this._startValue = undefined;
    this._endValue = undefined;
    this._valueRange = 0;
  }
  parse(raw, index) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const {beginAtZero} = this.options;
    const {minDefined, maxDefined} = this.getUserBounds();
    let {min, max} = this;
    const setMin = v => (min = minDefined ? min : v);
    const setMax = v => (max = maxDefined ? max : v);
    if (beginAtZero) {
      const minSign = sign(min);
      const maxSign = sign(max);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min === max) {
      let offset = 1;
      if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) {
        offset = Math.abs(max * 0.05);
      }
      setMax(max + offset);
      if (!beginAtZero) {
        setMin(min - offset);
      }
    }
    this.min = min;
    this.max = max;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let {maxTicksLimit, stepSize} = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1000) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1000;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === 'ticks') {
      _setMinAndMaxByKey(ticks, this, 'value');
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset;
      end += offset;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
}

class LinearScale extends LinearScaleBase {
  determineDataLimits() {
    const {min, max} = this.getMinMax(true);
    this.min = isNumberFinite(min) ? min : 0;
    this.max = isNumberFinite(max) ? max : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
}
LinearScale.id = 'linear';
LinearScale.defaults = {
  ticks: {
    callback: Ticks.formatters.numeric
  }
};

function isMajor(tickVal) {
  const remain = tickVal / (Math.pow(10, Math.floor(log10(tickVal))));
  return remain === 1;
}
function generateTicks(generationOptions, dataRange) {
  const endExp = Math.floor(log10(dataRange.max));
  const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
  const ticks = [];
  let tickVal = finiteOrDefault(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
  let exp = Math.floor(log10(tickVal));
  let significand = Math.floor(tickVal / Math.pow(10, exp));
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  do {
    ticks.push({value: tickVal, major: isMajor(tickVal)});
    ++significand;
    if (significand === 10) {
      significand = 1;
      ++exp;
      precision = exp >= 0 ? 1 : precision;
    }
    tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
  } while (exp < endExp || (exp === endExp && significand < endSignificand));
  const lastTick = finiteOrDefault(generationOptions.max, tickVal);
  ticks.push({value: lastTick, major: isMajor(tickVal)});
  return ticks;
}
class LogarithmicScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = undefined;
    this.end = undefined;
    this._startValue = undefined;
    this._valueRange = 0;
  }
  parse(raw, index) {
    const value = LinearScaleBase.prototype.parse.apply(this, [raw, index]);
    if (value === 0) {
      this._zero = true;
      return undefined;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const {min, max} = this.getMinMax(true);
    this.min = isNumberFinite(min) ? Math.max(0, min) : null;
    this.max = isNumberFinite(max) ? Math.max(0, max) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const {minDefined, maxDefined} = this.getUserBounds();
    let min = this.min;
    let max = this.max;
    const setMin = v => (min = minDefined ? min : v);
    const setMax = v => (max = maxDefined ? max : v);
    const exp = (v, m) => Math.pow(10, Math.floor(log10(v)) + m);
    if (min === max) {
      if (min <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(exp(min, -1));
        setMax(exp(max, +1));
      }
    }
    if (min <= 0) {
      setMin(exp(max, -1));
    }
    if (max <= 0) {
      setMax(exp(min, +1));
    }
    if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) {
      setMin(exp(min, -1));
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === 'ticks') {
      _setMinAndMaxByKey(ticks, this, 'value');
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === undefined
      ? '0'
      : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value) {
    if (value === undefined || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min
      ? 0
      : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
}
LogarithmicScale.id = 'logarithmic';
LogarithmicScale.defaults = {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: true
    }
  }
};

function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults$1.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [label];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size, min, max) {
  if (angle === min || angle === max) {
    return {
      start: pos - (size / 2),
      end: pos + (size / 2)
    };
  } else if (angle < min || angle > max) {
    return {
      start: pos - size,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(
    orig.l - limits.l,
    limits.r - orig.r,
    orig.t - limits.t,
    limits.b - orig.b
  );
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x = 0;
  let y = 0;
  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }
  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const extra = getTickBackdropHeight(opts) / 2;
  const outerDistance = scale.drawingArea;
  const additionalAngle = opts.pointLabels.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
    const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
    const size = labelSizes[i];
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    items.push({
      x: pointLabelPosition.x,
      y,
      textAlign,
      left,
      top: y,
      right: left + size.w,
      bottom: y + size.h
    });
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return 'center';
  } else if (angle < 180) {
    return 'left';
  }
  return 'right';
}
function leftForTextAlign(x, w, align) {
  if (align === 'right') {
    x -= w;
  } else if (align === 'center') {
    x -= (w / 2);
  }
  return x;
}
function yForAngle(y, h, angle) {
  if (angle === 90 || angle === 270) {
    y -= (h / 2);
  } else if (angle > 270 || angle < 90) {
    y -= h;
  }
  return y;
}
function drawPointLabels(scale, labelCount) {
  const {ctx, options: {pointLabels}} = scale;
  for (let i = labelCount - 1; i >= 0; i--) {
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    const plFont = toFont(optsAtIndex.font);
    const {x, y, textAlign, left, top, right, bottom} = scale._pointLabelItems[i];
    const {backdropColor} = optsAtIndex;
    if (!isNullOrUndef(backdropColor)) {
      const padding = toPadding(optsAtIndex.backdropPadding);
      ctx.fillStyle = backdropColor;
      ctx.fillRect(left - padding.left, top - padding.top, right - left + padding.width, bottom - top + padding.height);
    }
    renderText(
      ctx,
      scale._pointLabels[i],
      x,
      y + (plFont.lineHeight / 2),
      plFont,
      {
        color: optsAtIndex.color,
        textAlign: textAlign,
        textBaseline: 'middle'
      }
    );
  }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
  const {ctx} = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const {color, lineWidth} = gridLineOpts;
  if ((!circular && !labelCount) || !color || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(gridLineOpts.borderDash);
  ctx.lineDashOffset = gridLineOpts.borderDashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index, label) {
  return createContext(parent, {
    label,
    index,
    type: 'pointLabel'
  });
}
class RadialLinearScale extends LinearScaleBase {
  constructor(cfg) {
    super(cfg);
    this.xCenter = undefined;
    this.yCenter = undefined;
    this.drawingArea = undefined;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w = this.width = this.maxWidth - padding.width;
    const h = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w, h) / 2);
  }
  determineDataLimits() {
    const {min, max} = this.getMinMax(false);
    this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
    this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels()
      .map((value, index) => {
        const label = callback(this.options.pointLabels.callback, [value, index], this);
        return label || label === 0 ? label : '';
      })
      .filter((v, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index) {
    const pointLabels = this._pointLabels || [];
    if (index >= 0 && index < pointLabels.length) {
      const pointLabel = pointLabels[index];
      return createPointLabelContext(this.getContext(), index, pointLabel);
    }
  }
  getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index, value) {
    return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index) {
    return this.getPointPositionForValue(index || 0, this.getBaseValue());
  }
  getPointLabelPosition(index) {
    const {left, top, right, bottom} = this._pointLabelItems[index];
    return {
      left,
      top,
      right,
      bottom,
    };
  }
  drawBackground() {
    const {backgroundColor, grid: {circular}} = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const {angleLines, grid} = opts;
    const labelCount = this._pointLabels.length;
    let i, offset, position;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index) => {
        if (index !== 0) {
          offset = this.getDistanceFromCenterForValue(tick.value);
          const optsAtIndex = grid.setContext(this.getContext(index - 1));
          drawRadiusLine(this, optsAtIndex, offset, labelCount);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const {color, lineWidth} = optsAtIndex;
        if (!lineWidth || !color) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
        position = this.getPointPosition(i, offset);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {}
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    this.ticks.forEach((tick, index) => {
      if (index === 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index));
      const tickFont = toFont(optsAtIndex.font);
      offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(
          -width / 2 - padding.left,
          -offset - tickFont.size / 2 - padding.top,
          width + padding.width,
          tickFont.size + padding.height
        );
      }
      renderText(ctx, tick.label, 0, -offset, tickFont, {
        color: optsAtIndex.color,
      });
    });
    ctx.restore();
  }
  drawTitle() {}
}
RadialLinearScale.id = 'radialLinear';
RadialLinearScale.defaults = {
  display: true,
  animate: true,
  position: 'chartArea',
  angleLines: {
    display: true,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0.0
  },
  grid: {
    circular: false
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: undefined,
    backdropPadding: 2,
    display: true,
    font: {
      size: 10
    },
    callback(label) {
      return label;
    },
    padding: 5,
    centerPointLabels: false
  }
};
RadialLinearScale.defaultRoutes = {
  'angleLines.color': 'borderColor',
  'pointLabels.color': 'color',
  'ticks.color': 'color'
};
RadialLinearScale.descriptors = {
  angleLines: {
    _fallback: 'grid'
  }
};

const INTERVALS = {
  millisecond: {common: true, size: 1, steps: 1000},
  second: {common: true, size: 1000, steps: 60},
  minute: {common: true, size: 60000, steps: 60},
  hour: {common: true, size: 3600000, steps: 24},
  day: {common: true, size: 86400000, steps: 30},
  week: {common: false, size: 604800000, steps: 4},
  month: {common: true, size: 2.628e9, steps: 12},
  quarter: {common: false, size: 7.884e9, steps: 4},
  year: {common: true, size: 3.154e10}
};
const UNITS = (Object.keys(INTERVALS));
function sorter(a, b) {
  return a - b;
}
function parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const {parser, round, isoWeekday} = scale._parseOpts;
  let value = input;
  if (typeof parser === 'function') {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === 'string'
      ? adapter.parse(value, parser)
      : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round) {
    value = round === 'week' && (isNumber(isoWeekday) || isoWeekday === true)
      ? adapter.startOf(value, 'isoWeek', isoWeekday)
      : adapter.startOf(value, round);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const {lo, hi} = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last = ticks[ticks.length - 1].value;
  let major, index;
  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index = map[major];
    if (index >= 0) {
      ticks[index].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map = {};
  const ilen = values.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = 'day';
    this._majorUnit = undefined;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = undefined;
  }
  init(scaleOpts, opts) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index) {
    if (raw === undefined) {
      return null;
    }
    return parse(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || 'day';
    let {min, max, minDefined, maxDefined} = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min = Math.min(min, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max = Math.max(max, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') {
        _applyBounds(this.getMinMax(false));
      }
    }
    min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
    max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min, max - 1);
    this.max = Math.max(min + 1, max);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min = arr[0];
      max = arr[arr.length - 1];
    }
    return {min, max};
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === 'ticks' && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min = this.min;
    const max = this.max;
    const ticks = _filterBetween(timestamps, min, max);
    this._unit = timeOpts.unit || (tickOpts.autoSkip
      ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min))
      : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined
      : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  initOffsets(timestamps) {
    let start = 0;
    let end = 0;
    let first, last;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last;
      } else {
        end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit);
    end = _limitValue(end, 0, limit);
    this._offsets = {start, end, factor: 1 / (start + 1 + end)};
  }
  _generate() {
    const adapter = this._adapter;
    const min = this.min;
    const max = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
    const stepSize = valueOrDefault(timeOpts.stepSize, 1);
    const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber(weekday) || weekday === true;
    const ticks = {};
    let first = min;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, 'isoWeek', weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
    if (adapter.diff(max, min, minor) > 100000 * stepSize) {
      throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
    }
    const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
    for (time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max || options.bounds === 'ticks' || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort((a, b) => a - b).map(x => +x);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  _tickFormatFunction(time, index, ticks, format) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index];
    const major = majorUnit && majorFormat && tick && tick.major;
    const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    const formatter = options.ticks.callback;
    return formatter ? callback(formatter, [label, index, ticks], this) : label;
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
      h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [exampleTime], this._majorUnit), format);
    const size = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return (this._cache.data = metas[0].controller.getAllParsedValues(this));
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return (this._cache.data = this.normalize(timestamps));
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse(this, labels[i]));
    }
    return (this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps));
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
}
TimeScale.id = 'time';
TimeScale.defaults = {
  bounds: 'data',
  adapters: {},
  time: {
    parser: false,
    unit: false,
    round: false,
    isoWeekday: false,
    minUnit: 'millisecond',
    displayFormats: {}
  },
  ticks: {
    source: 'auto',
    major: {
      enabled: false
    }
  }
};

function interpolate$2(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({lo, hi} = _lookupByKey(table, 'pos', val));
    }
    ({pos: prevSource, time: prevTarget} = table[lo]);
    ({pos: nextSource, time: nextTarget} = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({lo, hi} = _lookupByKey(table, 'time', val));
    }
    ({time: prevSource, pos: prevTarget} = table[lo]);
    ({time: nextSource, pos: nextTarget} = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = undefined;
    this._tableRange = undefined;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate$2(table, this.min);
    this._tableRange = interpolate$2(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const {min, max} = this;
    const items = [];
    const table = [];
    let i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min && curr <= max) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [
        {time: min, pos: 0},
        {time: max, pos: 1}
      ];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({time: curr, pos: i / (ilen - 1)});
      }
    }
    return table;
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate$2(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate$2(this._table, decimal * this._tableRange + this._minPos, true);
  }
}
TimeSeriesScale.id = 'timeseries';
TimeSeriesScale.defaults = TimeScale.defaults;

var scales = /*#__PURE__*/Object.freeze({
__proto__: null,
CategoryScale: CategoryScale,
LinearScale: LinearScale,
LogarithmicScale: LogarithmicScale,
RadialLinearScale: RadialLinearScale,
TimeScale: TimeScale,
TimeSeriesScale: TimeSeriesScale
});

const registerables = [
  controllers,
  elements,
  plugins,
  scales,
];

const defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref) {
        ref.current = value;
    }
}
function setOptions(chart, nextOptions) {
    chart.options = {
        ...nextOptions
    };
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]
        );
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
            return {
                ...nextDataset
            };
        }
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}

function ChartComponent(param, ref) {
    let { height =150 , width =300 , redraw =false , datasetIdKey , type , data , options , plugins =[] , fallbackContent , ...props } = param;
    const canvasRef = useRef(null);
    const chartRef = useRef();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new Chart$1(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options,
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    useEffect(()=>{
        if (!redraw && chartRef.current && options) {
            setOptions(chartRef.current, options);
        }
    }, [
        redraw,
        options
    ]);
    useEffect(()=>{
        if (!redraw && chartRef.current) {
            setLabels(chartRef.current.config.data, data.labels);
        }
    }, [
        redraw,
        data.labels
    ]);
    useEffect(()=>{
        if (!redraw && chartRef.current && data.datasets) {
            setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
        }
    }, [
        redraw,
        data.datasets
    ]);
    useEffect(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else {
            chartRef.current.update();
        }
    }, [
        redraw,
        options,
        data.labels,
        data.datasets
    ]);
    useEffect(()=>{
        renderChart();
        return ()=>destroyChart()
        ;
    }, []);
    return(/*#__PURE__*/ React__default.createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, props), fallbackContent));
}
const Chart = /*#__PURE__*/ forwardRef(ChartComponent);

function createTypedChart(type, registerables) {
    Chart$1.register(registerables);
    return(/*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React__default.createElement(Chart, Object.assign({}, props, {
            ref: ref,
            type: type
        }))
    ));
}
const Bar = /* #__PURE__ */ createTypedChart('bar', BarController);

/*!
 * chartjs-plugin-datalabels v2.0.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2021 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */

var devicePixelRatio = (function() {
  if (typeof window !== 'undefined') {
    if (window.devicePixelRatio) {
      return window.devicePixelRatio;
    }

    // devicePixelRatio is undefined on IE10
    // https://stackoverflow.com/a/20204180/8837887
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
    var screen = window.screen;
    if (screen) {
      return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
  }

  return 1;
}());

var utils = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: function(inputs) {
    var lines = [];
    var input;

    inputs = [].concat(inputs);
    while (inputs.length) {
      input = inputs.pop();
      if (typeof input === 'string') {
        lines.unshift.apply(lines, input.split('\n'));
      } else if (Array.isArray(input)) {
        inputs.push.apply(inputs, input);
      } else if (!isNullOrUndef(inputs)) {
        lines.unshift('' + input);
      }
    }

    return lines;
  },

  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: function(ctx, lines, font) {
    var items = [].concat(lines);
    var ilen = items.length;
    var prev = ctx.font;
    var width = 0;
    var i;

    ctx.font = font.string;

    for (i = 0; i < ilen; ++i) {
      width = Math.max(ctx.measureText(items[i]).width, width);
    }

    ctx.font = prev;

    return {
      height: ilen * font.lineHeight,
      width: width
    };
  },

  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: function(min, value, max) {
    return Math.max(min, Math.min(value, max));
  },

  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: function(a0, a1) {
    var prev = a0.slice();
    var updates = [];
    var i, j, ilen, v;

    for (i = 0, ilen = a1.length; i < ilen; ++i) {
      v = a1[i];
      j = prev.indexOf(v);

      if (j === -1) {
        updates.push([v, 1]);
      } else {
        prev.splice(j, 1);
      }
    }

    for (i = 0, ilen = prev.length; i < ilen; ++i) {
      updates.push([prev[i], -1]);
    }

    return updates;
  },

  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: function(v) {
    return Math.round(v * devicePixelRatio) / devicePixelRatio;
  }
};

function orient(point, origin) {
  var x0 = origin.x;
  var y0 = origin.y;

  if (x0 === null) {
    return {x: 0, y: -1};
  }
  if (y0 === null) {
    return {x: 1, y: 0};
  }

  var dx = point.x - x0;
  var dy = point.y - y0;
  var ln = Math.sqrt(dx * dx + dy * dy);

  return {
    x: ln ? dx / ln : 0,
    y: ln ? dy / ln : -1
  };
}

function aligned(x, y, vx, vy, align) {
  switch (align) {
  case 'center':
    vx = vy = 0;
    break;
  case 'bottom':
    vx = 0;
    vy = 1;
    break;
  case 'right':
    vx = 1;
    vy = 0;
    break;
  case 'left':
    vx = -1;
    vy = 0;
    break;
  case 'top':
    vx = 0;
    vy = -1;
    break;
  case 'start':
    vx = -vx;
    vy = -vy;
    break;
  case 'end':
    // keep natural orientation
    break;
  default:
    // clockwise rotation (in degree)
    align *= (Math.PI / 180);
    vx = Math.cos(align);
    vy = Math.sin(align);
    break;
  }

  return {
    x: x,
    y: y,
    vx: vx,
    vy: vy
  };
}

// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm

var R_INSIDE = 0;
var R_LEFT = 1;
var R_RIGHT = 2;
var R_BOTTOM = 4;
var R_TOP = 8;

function region(x, y, rect) {
  var res = R_INSIDE;

  if (x < rect.left) {
    res |= R_LEFT;
  } else if (x > rect.right) {
    res |= R_RIGHT;
  }
  if (y < rect.top) {
    res |= R_TOP;
  } else if (y > rect.bottom) {
    res |= R_BOTTOM;
  }

  return res;
}

function clipped(segment, area) {
  var x0 = segment.x0;
  var y0 = segment.y0;
  var x1 = segment.x1;
  var y1 = segment.y1;
  var r0 = region(x0, y0, area);
  var r1 = region(x1, y1, area);
  var r, x, y;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (!(r0 | r1) || (r0 & r1)) {
      // both points inside or on the same side: no clipping
      break;
    }

    // at least one point is outside
    r = r0 || r1;

    if (r & R_TOP) {
      x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
      y = area.top;
    } else if (r & R_BOTTOM) {
      x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
      y = area.bottom;
    } else if (r & R_RIGHT) {
      y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
      x = area.right;
    } else if (r & R_LEFT) {
      y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
      x = area.left;
    }

    if (r === r0) {
      x0 = x;
      y0 = y;
      r0 = region(x0, y0, area);
    } else {
      x1 = x;
      y1 = y;
      r1 = region(x1, y1, area);
    }
  }

  return {
    x0: x0,
    x1: x1,
    y0: y0,
    y1: y1
  };
}

function compute$1(range, config) {
  var anchor = config.anchor;
  var segment = range;
  var x, y;

  if (config.clamp) {
    segment = clipped(segment, config.area);
  }

  if (anchor === 'start') {
    x = segment.x0;
    y = segment.y0;
  } else if (anchor === 'end') {
    x = segment.x1;
    y = segment.y1;
  } else {
    x = (segment.x0 + segment.x1) / 2;
    y = (segment.y0 + segment.y1) / 2;
  }

  return aligned(x, y, range.vx, range.vy, config.align);
}

var positioners = {
  arc: function(el, config) {
    var angle = (el.startAngle + el.endAngle) / 2;
    var vx = Math.cos(angle);
    var vy = Math.sin(angle);
    var r0 = el.innerRadius;
    var r1 = el.outerRadius;

    return compute$1({
      x0: el.x + vx * r0,
      y0: el.y + vy * r0,
      x1: el.x + vx * r1,
      y1: el.y + vy * r1,
      vx: vx,
      vy: vy
    }, config);
  },

  point: function(el, config) {
    var v = orient(el, config.origin);
    var rx = v.x * el.options.radius;
    var ry = v.y * el.options.radius;

    return compute$1({
      x0: el.x - rx,
      y0: el.y - ry,
      x1: el.x + rx,
      y1: el.y + ry,
      vx: v.x,
      vy: v.y
    }, config);
  },

  bar: function(el, config) {
    var v = orient(el, config.origin);
    var x = el.x;
    var y = el.y;
    var sx = 0;
    var sy = 0;

    if (el.horizontal) {
      x = Math.min(el.x, el.base);
      sx = Math.abs(el.base - el.x);
    } else {
      y = Math.min(el.y, el.base);
      sy = Math.abs(el.base - el.y);
    }

    return compute$1({
      x0: x,
      y0: y + sy,
      x1: x + sx,
      y1: y,
      vx: v.x,
      vy: v.y
    }, config);
  },

  fallback: function(el, config) {
    var v = orient(el, config.origin);

    return compute$1({
      x0: el.x,
      y0: el.y,
      x1: el.x,
      y1: el.y,
      vx: v.x,
      vy: v.y
    }, config);
  }
};

var rasterize = utils.rasterize;

function boundingRects(model) {
  var borderWidth = model.borderWidth || 0;
  var padding = model.padding;
  var th = model.size.height;
  var tw = model.size.width;
  var tx = -tw / 2;
  var ty = -th / 2;

  return {
    frame: {
      x: tx - padding.left - borderWidth,
      y: ty - padding.top - borderWidth,
      w: tw + padding.width + borderWidth * 2,
      h: th + padding.height + borderWidth * 2
    },
    text: {
      x: tx,
      y: ty,
      w: tw,
      h: th
    }
  };
}

function getScaleOrigin(el, context) {
  var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;

  if (!scale) {
    return null;
  }

  if (scale.xCenter !== undefined && scale.yCenter !== undefined) {
    return {x: scale.xCenter, y: scale.yCenter};
  }

  var pixel = scale.getBasePixel();
  return el.horizontal ?
    {x: pixel, y: null} :
    {x: null, y: pixel};
}

function getPositioner(el) {
  if (el instanceof ArcElement) {
    return positioners.arc;
  }
  if (el instanceof PointElement) {
    return positioners.point;
  }
  if (el instanceof BarElement) {
    return positioners.bar;
  }
  return positioners.fallback;
}

function drawRoundedRect(ctx, x, y, w, h, radius) {
  var HALF_PI = Math.PI / 2;

  if (radius) {
    var r = Math.min(radius, h / 2, w / 2);
    var left = x + r;
    var top = y + r;
    var right = x + w - r;
    var bottom = y + h - r;

    ctx.moveTo(x, top);
    if (left < right && top < bottom) {
      ctx.arc(left, top, r, -Math.PI, -HALF_PI);
      ctx.arc(right, top, r, -HALF_PI, 0);
      ctx.arc(right, bottom, r, 0, HALF_PI);
      ctx.arc(left, bottom, r, HALF_PI, Math.PI);
    } else if (left < right) {
      ctx.moveTo(left, y);
      ctx.arc(right, top, r, -HALF_PI, HALF_PI);
      ctx.arc(left, top, r, HALF_PI, Math.PI + HALF_PI);
    } else if (top < bottom) {
      ctx.arc(left, top, r, -Math.PI, 0);
      ctx.arc(left, bottom, r, 0, Math.PI);
    } else {
      ctx.arc(left, top, r, -Math.PI, Math.PI);
    }
    ctx.closePath();
    ctx.moveTo(x, y);
  } else {
    ctx.rect(x, y, w, h);
  }
}

function drawFrame(ctx, rect, model) {
  var bgColor = model.backgroundColor;
  var borderColor = model.borderColor;
  var borderWidth = model.borderWidth;

  if (!bgColor && (!borderColor || !borderWidth)) {
    return;
  }

  ctx.beginPath();

  drawRoundedRect(
    ctx,
    rasterize(rect.x) + borderWidth / 2,
    rasterize(rect.y) + borderWidth / 2,
    rasterize(rect.w) - borderWidth,
    rasterize(rect.h) - borderWidth,
    model.borderRadius);

  ctx.closePath();

  if (bgColor) {
    ctx.fillStyle = bgColor;
    ctx.fill();
  }

  if (borderColor && borderWidth) {
    ctx.strokeStyle = borderColor;
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = 'miter';
    ctx.stroke();
  }
}

function textGeometry(rect, align, font) {
  var h = font.lineHeight;
  var w = rect.w;
  var x = rect.x;
  var y = rect.y + h / 2;

  if (align === 'center') {
    x += w / 2;
  } else if (align === 'end' || align === 'right') {
    x += w;
  }

  return {
    h: h,
    w: w,
    x: x,
    y: y
  };
}

function drawTextLine(ctx, text, cfg) {
  var shadow = ctx.shadowBlur;
  var stroked = cfg.stroked;
  var x = rasterize(cfg.x);
  var y = rasterize(cfg.y);
  var w = rasterize(cfg.w);

  if (stroked) {
    ctx.strokeText(text, x, y, w);
  }

  if (cfg.filled) {
    if (shadow && stroked) {
      // Prevent drawing shadow on both the text stroke and fill, so
      // if the text is stroked, remove the shadow for the text fill.
      ctx.shadowBlur = 0;
    }

    ctx.fillText(text, x, y, w);

    if (shadow && stroked) {
      ctx.shadowBlur = shadow;
    }
  }
}

function drawText(ctx, lines, rect, model) {
  var align = model.textAlign;
  var color = model.color;
  var filled = !!color;
  var font = model.font;
  var ilen = lines.length;
  var strokeColor = model.textStrokeColor;
  var strokeWidth = model.textStrokeWidth;
  var stroked = strokeColor && strokeWidth;
  var i;

  if (!ilen || (!filled && !stroked)) {
    return;
  }

  // Adjust coordinates based on text alignment and line height
  rect = textGeometry(rect, align, font);

  ctx.font = font.string;
  ctx.textAlign = align;
  ctx.textBaseline = 'middle';
  ctx.shadowBlur = model.textShadowBlur;
  ctx.shadowColor = model.textShadowColor;

  if (filled) {
    ctx.fillStyle = color;
  }
  if (stroked) {
    ctx.lineJoin = 'round';
    ctx.lineWidth = strokeWidth;
    ctx.strokeStyle = strokeColor;
  }

  for (i = 0, ilen = lines.length; i < ilen; ++i) {
    drawTextLine(ctx, lines[i], {
      stroked: stroked,
      filled: filled,
      w: rect.w,
      x: rect.x,
      y: rect.y + rect.h * i
    });
  }
}

var Label = function(config, ctx, el, index) {
  var me = this;

  me._config = config;
  me._index = index;
  me._model = null;
  me._rects = null;
  me._ctx = ctx;
  me._el = el;
};

merge$1(Label.prototype, {
  /**
   * @private
   */
  _modelize: function(display, lines, config, context) {
    var me = this;
    var index = me._index;
    var font = toFont(resolve([config.font, {}], context, index));
    var color = resolve([config.color, defaults$1.color], context, index);

    return {
      align: resolve([config.align, 'center'], context, index),
      anchor: resolve([config.anchor, 'center'], context, index),
      area: context.chart.chartArea,
      backgroundColor: resolve([config.backgroundColor, null], context, index),
      borderColor: resolve([config.borderColor, null], context, index),
      borderRadius: resolve([config.borderRadius, 0], context, index),
      borderWidth: resolve([config.borderWidth, 0], context, index),
      clamp: resolve([config.clamp, false], context, index),
      clip: resolve([config.clip, false], context, index),
      color: color,
      display: display,
      font: font,
      lines: lines,
      offset: resolve([config.offset, 0], context, index),
      opacity: resolve([config.opacity, 1], context, index),
      origin: getScaleOrigin(me._el, context),
      padding: toPadding(resolve([config.padding, 0], context, index)),
      positioner: getPositioner(me._el),
      rotation: resolve([config.rotation, 0], context, index) * (Math.PI / 180),
      size: utils.textSize(me._ctx, lines, font),
      textAlign: resolve([config.textAlign, 'start'], context, index),
      textShadowBlur: resolve([config.textShadowBlur, 0], context, index),
      textShadowColor: resolve([config.textShadowColor, color], context, index),
      textStrokeColor: resolve([config.textStrokeColor, color], context, index),
      textStrokeWidth: resolve([config.textStrokeWidth, 0], context, index)
    };
  },

  update: function(context) {
    var me = this;
    var model = null;
    var rects = null;
    var index = me._index;
    var config = me._config;
    var value, label, lines;

    // We first resolve the display option (separately) to avoid computing
    // other options in case the label is hidden (i.e. display: false).
    var display = resolve([config.display, true], context, index);

    if (display) {
      value = context.dataset.data[index];
      label = valueOrDefault(callback(config.formatter, [value, context]), value);
      lines = isNullOrUndef(label) ? [] : utils.toTextLines(label);

      if (lines.length) {
        model = me._modelize(display, lines, config, context);
        rects = boundingRects(model);
      }
    }

    me._model = model;
    me._rects = rects;
  },

  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },

  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },

  visible: function() {
    return this._model && this._model.opacity;
  },

  model: function() {
    return this._model;
  },

  draw: function(chart, center) {
    var me = this;
    var ctx = chart.ctx;
    var model = me._model;
    var rects = me._rects;
    var area;

    if (!this.visible()) {
      return;
    }

    ctx.save();

    if (model.clip) {
      area = model.area;
      ctx.beginPath();
      ctx.rect(
        area.left,
        area.top,
        area.right - area.left,
        area.bottom - area.top);
      ctx.clip();
    }

    ctx.globalAlpha = utils.bound(0, model.opacity, 1);
    ctx.translate(rasterize(center.x), rasterize(center.y));
    ctx.rotate(model.rotation);

    drawFrame(ctx, rects.frame, model);
    drawText(ctx, model.lines, rects.text, model);

    ctx.restore();
  }
});

var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;  // eslint-disable-line es/no-number-maxsafeinteger

function rotated(point, center, angle) {
  var cos = Math.cos(angle);
  var sin = Math.sin(angle);
  var cx = center.x;
  var cy = center.y;

  return {
    x: cx + cos * (point.x - cx) - sin * (point.y - cy),
    y: cy + sin * (point.x - cx) + cos * (point.y - cy)
  };
}

function projected(points, axis) {
  var min = MAX_INTEGER;
  var max = MIN_INTEGER;
  var origin = axis.origin;
  var i, pt, vx, vy, dp;

  for (i = 0; i < points.length; ++i) {
    pt = points[i];
    vx = pt.x - origin.x;
    vy = pt.y - origin.y;
    dp = axis.vx * vx + axis.vy * vy;
    min = Math.min(min, dp);
    max = Math.max(max, dp);
  }

  return {
    min: min,
    max: max
  };
}

function toAxis(p0, p1) {
  var vx = p1.x - p0.x;
  var vy = p1.y - p0.y;
  var ln = Math.sqrt(vx * vx + vy * vy);

  return {
    vx: (p1.x - p0.x) / ln,
    vy: (p1.y - p0.y) / ln,
    origin: p0,
    ln: ln
  };
}

var HitBox = function() {
  this._rotation = 0;
  this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};

merge$1(HitBox.prototype, {
  center: function() {
    var r = this._rect;
    return {
      x: r.x + r.w / 2,
      y: r.y + r.h / 2
    };
  },

  update: function(center, rect, rotation) {
    this._rotation = rotation;
    this._rect = {
      x: rect.x + center.x,
      y: rect.y + center.y,
      w: rect.w,
      h: rect.h
    };
  },

  contains: function(point) {
    var me = this;
    var margin = 1;
    var rect = me._rect;

    point = rotated(point, me.center(), -me._rotation);

    return !(point.x < rect.x - margin
      || point.y < rect.y - margin
      || point.x > rect.x + rect.w + margin * 2
      || point.y > rect.y + rect.h + margin * 2);
  },

  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: function(other) {
    var r0 = this._points();
    var r1 = other._points();
    var axes = [
      toAxis(r0[0], r0[1]),
      toAxis(r0[0], r0[3])
    ];
    var i, pr0, pr1;

    if (this._rotation !== other._rotation) {
      // Only separate with r1 axis if the rotation is different,
      // else it's enough to separate r0 and r1 with r0 axis only!
      axes.push(
        toAxis(r1[0], r1[1]),
        toAxis(r1[0], r1[3])
      );
    }

    for (i = 0; i < axes.length; ++i) {
      pr0 = projected(r0, axes[i]);
      pr1 = projected(r1, axes[i]);

      if (pr0.max < pr1.min || pr1.max < pr0.min) {
        return false;
      }
    }

    return true;
  },

  /**
   * @private
   */
  _points: function() {
    var me = this;
    var rect = me._rect;
    var angle = me._rotation;
    var center = me.center();

    return [
      rotated({x: rect.x, y: rect.y}, center, angle),
      rotated({x: rect.x + rect.w, y: rect.y}, center, angle),
      rotated({x: rect.x + rect.w, y: rect.y + rect.h}, center, angle),
      rotated({x: rect.x, y: rect.y + rect.h}, center, angle)
    ];
  }
});

function coordinates(el, model, geometry) {
  var point = model.positioner(el, model);
  var vx = point.vx;
  var vy = point.vy;

  if (!vx && !vy) {
    // if aligned center, we don't want to offset the center point
    return {x: point.x, y: point.y};
  }

  var w = geometry.w;
  var h = geometry.h;

  // take in account the label rotation
  var rotation = model.rotation;
  var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
  var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));

  // scale the unit vector (vx, vy) to get at least dx or dy equal to
  // w or h respectively (else we would calculate the distance to the
  // ellipse inscribed in the bounding rect)
  var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
  dx *= vx * vs;
  dy *= vy * vs;

  // finally, include the explicit offset
  dx += model.offset * vx;
  dy += model.offset * vy;

  return {
    x: point.x + dx,
    y: point.y + dy
  };
}

function collide(labels, collider) {
  var i, j, s0, s1;

  // IMPORTANT Iterate in the reverse order since items at the end of the
  // list have an higher weight/priority and thus should be less impacted
  // by the overlapping strategy.

  for (i = labels.length - 1; i >= 0; --i) {
    s0 = labels[i].$layout;

    for (j = i - 1; j >= 0 && s0._visible; --j) {
      s1 = labels[j].$layout;

      if (s1._visible && s0._box.intersects(s1._box)) {
        collider(s0, s1);
      }
    }
  }

  return labels;
}

function compute(labels) {
  var i, ilen, label, state, geometry, center, proxy;

  // Initialize labels for overlap detection
  for (i = 0, ilen = labels.length; i < ilen; ++i) {
    label = labels[i];
    state = label.$layout;

    if (state._visible) {
      // Chart.js 3 removed el._model in favor of getProps(), making harder to
      // abstract reading values in positioners. Also, using string arrays to
      // read values (i.e. var {a,b,c} = el.getProps(["a","b","c"])) would make
      // positioners inefficient in the normal case (i.e. not the final values)
      // and the code a bit ugly, so let's use a Proxy instead.
      proxy = new Proxy(label._el, {get: (el, p) => el.getProps([p], true)[p]});

      geometry = label.geometry();
      center = coordinates(proxy, label.model(), geometry);
      state._box.update(center, geometry, label.rotation());
    }
  }

  // Auto hide overlapping labels
  return collide(labels, function(s0, s1) {
    var h0 = s0._hidable;
    var h1 = s1._hidable;

    if ((h0 && h1) || h1) {
      s1._visible = false;
    } else if (h0) {
      s0._visible = false;
    }
  });
}

var layout = {
  prepare: function(datasets) {
    var labels = [];
    var i, j, ilen, jlen, label;

    for (i = 0, ilen = datasets.length; i < ilen; ++i) {
      for (j = 0, jlen = datasets[i].length; j < jlen; ++j) {
        label = datasets[i][j];
        labels.push(label);
        label.$layout = {
          _box: new HitBox(),
          _hidable: false,
          _visible: true,
          _set: i,
          _idx: j
        };
      }
    }

    // TODO New `z` option: labels with a higher z-index are drawn
    // of top of the ones with a lower index. Lowest z-index labels
    // are also discarded first when hiding overlapping labels.
    labels.sort(function(a, b) {
      var sa = a.$layout;
      var sb = b.$layout;

      return sa._idx === sb._idx
        ? sb._set - sa._set
        : sb._idx - sa._idx;
    });

    this.update(labels);

    return labels;
  },

  update: function(labels) {
    var dirty = false;
    var i, ilen, label, model, state;

    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      label = labels[i];
      model = label.model();
      state = label.$layout;
      state._hidable = model && model.display === 'auto';
      state._visible = label.visible();
      dirty |= state._hidable;
    }

    if (dirty) {
      compute(labels);
    }
  },

  lookup: function(labels, point) {
    var i, state;

    // IMPORTANT Iterate in the reverse order since items at the end of
    // the list have an higher z-index, thus should be picked first.

    for (i = labels.length - 1; i >= 0; --i) {
      state = labels[i].$layout;

      if (state && state._visible && state._box.contains(point)) {
        return labels[i];
      }
    }

    return null;
  },

  draw: function(chart, labels) {
    var i, ilen, label, state, geometry, center;

    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      label = labels[i];
      state = label.$layout;

      if (state._visible) {
        geometry = label.geometry();
        center = coordinates(label._el, label.model(), geometry);
        state._box.update(center, geometry, label.rotation());
        label.draw(chart, center);
      }
    }
  }
};

var formatter = function(value) {
  if (isNullOrUndef(value)) {
    return null;
  }

  var label = value;
  var keys, klen, k;
  if (isObject$1(value)) {
    if (!isNullOrUndef(value.label)) {
      label = value.label;
    } else if (!isNullOrUndef(value.r)) {
      label = value.r;
    } else {
      label = '';
      keys = Object.keys(value);
      for (k = 0, klen = keys.length; k < klen; ++k) {
        label += (k !== 0 ? ', ' : '') + keys[k] + ': ' + value[keys[k]];
      }
    }
  }

  return '' + label;
};

/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */

var defaults = {
  align: 'center',
  anchor: 'center',
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: false,
  clip: false,
  color: undefined,
  display: true,
  font: {
    family: undefined,
    lineHeight: 1.2,
    size: undefined,
    style: undefined,
    weight: null
  },
  formatter: formatter,
  labels: undefined,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: 'start',
  textStrokeColor: undefined,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: undefined
};

/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */

var EXPANDO_KEY = '$datalabels';
var DEFAULT_KEY = '$default';

function configure(dataset, options) {
  var override = dataset.datalabels;
  var listeners = {};
  var configs = [];
  var labels, keys;

  if (override === false) {
    return null;
  }
  if (override === true) {
    override = {};
  }

  options = merge$1({}, [options, override]);
  labels = options.labels || {};
  keys = Object.keys(labels);
  delete options.labels;

  if (keys.length) {
    keys.forEach(function(key) {
      if (labels[key]) {
        configs.push(merge$1({}, [
          options,
          labels[key],
          {_key: key}
        ]));
      }
    });
  } else {
    // Default label if no "named" label defined.
    configs.push(options);
  }

  // listeners: {<event-type>: {<label-key>: <fn>}}
  listeners = configs.reduce(function(target, config) {
    each(config.listeners || {}, function(fn, event) {
      target[event] = target[event] || {};
      target[event][config._key || DEFAULT_KEY] = fn;
    });

    delete config.listeners;
    return target;
  }, {});

  return {
    labels: configs,
    listeners: listeners
  };
}

function dispatchEvent$1(chart, listeners, label) {
  if (!listeners) {
    return;
  }

  var context = label.$context;
  var groups = label.$groups;
  var callback$1;

  if (!listeners[groups._set]) {
    return;
  }

  callback$1 = listeners[groups._set][groups._key];
  if (!callback$1) {
    return;
  }

  if (callback(callback$1, [context]) === true) {
    // Users are allowed to tweak the given context by injecting values that can be
    // used in scriptable options to display labels differently based on the current
    // event (e.g. highlight an hovered label). That's why we update the label with
    // the output context and schedule a new chart render by setting it dirty.
    chart[EXPANDO_KEY]._dirty = true;
    label.update(context);
  }
}

function dispatchMoveEvents(chart, listeners, previous, label) {
  var enter, leave;

  if (!previous && !label) {
    return;
  }

  if (!previous) {
    enter = true;
  } else if (!label) {
    leave = true;
  } else if (previous !== label) {
    leave = enter = true;
  }

  if (leave) {
    dispatchEvent$1(chart, listeners.leave, previous);
  }
  if (enter) {
    dispatchEvent$1(chart, listeners.enter, label);
  }
}

function handleMoveEvents(chart, event) {
  var expando = chart[EXPANDO_KEY];
  var listeners = expando._listeners;
  var previous, label;

  if (!listeners.enter && !listeners.leave) {
    return;
  }

  if (event.type === 'mousemove') {
    label = layout.lookup(expando._labels, event);
  } else if (event.type !== 'mouseout') {
    return;
  }

  previous = expando._hovered;
  expando._hovered = label;
  dispatchMoveEvents(chart, listeners, previous, label);
}

function handleClickEvents(chart, event) {
  var expando = chart[EXPANDO_KEY];
  var handlers = expando._listeners.click;
  var label = handlers && layout.lookup(expando._labels, event);
  if (label) {
    dispatchEvent$1(chart, handlers, label);
  }
}

var plugin = {
  id: 'datalabels',

  defaults: defaults,

  beforeInit: function(chart) {
    chart[EXPANDO_KEY] = {
      _actives: []
    };
  },

  beforeUpdate: function(chart) {
    var expando = chart[EXPANDO_KEY];
    expando._listened = false;
    expando._listeners = {};     // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
    expando._datasets = [];      // per dataset labels: [Label[]]
    expando._labels = [];        // layouted labels: Label[]
  },

  afterDatasetUpdate: function(chart, args, options) {
    var datasetIndex = args.index;
    var expando = chart[EXPANDO_KEY];
    var labels = expando._datasets[datasetIndex] = [];
    var visible = chart.isDatasetVisible(datasetIndex);
    var dataset = chart.data.datasets[datasetIndex];
    var config = configure(dataset, options);
    var elements = args.meta.data || [];
    var ctx = chart.ctx;
    var i, j, ilen, jlen, cfg, key, el, label;

    ctx.save();

    for (i = 0, ilen = elements.length; i < ilen; ++i) {
      el = elements[i];
      el[EXPANDO_KEY] = [];

      if (visible && el && chart.getDataVisibility(i) && !el.skip) {
        for (j = 0, jlen = config.labels.length; j < jlen; ++j) {
          cfg = config.labels[j];
          key = cfg._key;

          label = new Label(cfg, ctx, el, i);
          label.$groups = {
            _set: datasetIndex,
            _key: key || DEFAULT_KEY
          };
          label.$context = {
            active: false,
            chart: chart,
            dataIndex: i,
            dataset: dataset,
            datasetIndex: datasetIndex
          };

          label.update(label.$context);
          el[EXPANDO_KEY].push(label);
          labels.push(label);
        }
      }
    }

    ctx.restore();

    // Store listeners at the chart level and per event type to optimize
    // cases where no listeners are registered for a specific event.
    merge$1(expando._listeners, config.listeners, {
      merger: function(event, target, source) {
        target[event] = target[event] || {};
        target[event][args.index] = source[event];
        expando._listened = true;
      }
    });
  },

  afterUpdate: function(chart, options) {
    chart[EXPANDO_KEY]._labels = layout.prepare(
      chart[EXPANDO_KEY]._datasets,
      options);
  },

  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: function(chart) {
    layout.draw(chart, chart[EXPANDO_KEY]._labels);
  },

  beforeEvent: function(chart, args) {
    // If there is no listener registered for this chart, `listened` will be false,
    // meaning we can immediately ignore the incoming event and avoid useless extra
    // computation for users who don't implement label interactions.
    if (chart[EXPANDO_KEY]._listened) {
      var event = args.event;
      switch (event.type) {
      case 'mousemove':
      case 'mouseout':
        handleMoveEvents(chart, event);
        break;
      case 'click':
        handleClickEvents(chart, event);
        break;
      }
    }
  },

  afterEvent: function(chart) {
    var expando = chart[EXPANDO_KEY];
    var previous = expando._actives;
    var actives = expando._actives = chart.getActiveElements();
    var updates = utils.arrayDiff(previous, actives);
    var i, ilen, j, jlen, update, label, labels;

    for (i = 0, ilen = updates.length; i < ilen; ++i) {
      update = updates[i];
      if (update[1]) {
        labels = update[0].element[EXPANDO_KEY] || [];
        for (j = 0, jlen = labels.length; j < jlen; ++j) {
          label = labels[j];
          label.$context.active = (update[1] === 1);
          label.update(label.$context);
        }
      }
    }

    if (expando._dirty || updates.length) {
      layout.update(expando._labels);
      chart.render();
    }

    delete expando._dirty;
  }
};

Chart$1.register(...registerables);

var MAX_LABEL_ROW_LENGTH = 40;
var NUMBER_OF_TICKS = 5;
var DIGITS_FOLLOWED_BY_THREE_DIGITS_REGEX = /(\d)(?=(\d{3})+(?!\d))/g;
var getMaxStringLessThan = function (myString, maxLength) {
    var shards = myString.split(' ');
    var constructed = [];
    var len = 0;
    shards.forEach(function (shard) {
        len += shard.length + 1;
        if (len <= maxLength) {
            constructed.push(shard);
        }
    });
    return constructed.join(' ');
};
var roundFloatingMultipleOfFive = function (floatingNumb) {
    return (Math.ceil(parseFloat(floatingNumb.toFixed(2)) * 20) * 5) / 100;
};
var calculateTickStepSizeDefault = function (maxBarValue) {
    var largestOptions = roundFloatingMultipleOfFive(maxBarValue);
    var nonRoundedTickStep = largestOptions / NUMBER_OF_TICKS;
    var roundedTickStep = roundFloatingMultipleOfFive(nonRoundedTickStep);
    return roundedTickStep;
};
var calculateMaxTickDefault = function (maxBarValue) {
    var roundedLargestOptions = calculateTickStepSizeDefault(maxBarValue);
    var actualNrOfTicks = Math.ceil(maxBarValue / roundedLargestOptions);
    return roundedLargestOptions * actualNrOfTicks;
};
var formatTooltipLabelDefault = function (item) {
    var itemValue = item.raw;
    var totalSamples = item.dataset.totalSamples;
    var completesPerRow = item.dataset.completesPerRow;
    var ratio = 1;
    if (completesPerRow && item.dataIndex !== undefined)
        ratio = totalSamples / completesPerRow[item.dataIndex];
    var optionValue = (Number(itemValue) / ratio).toString();
    var responsesPerBar = optionValue
        ? (parseFloat(optionValue) * totalSamples)
            .toFixed(0)
            // separates digits with comma, e.g. '12345' -> '12,345'
            .replace(DIGITS_FOLLOWED_BY_THREE_DIGITS_REGEX, '$1,')
        : 'N/A';
    var percentPerBar = itemValue
        ? (parseFloat(itemValue) * 100).toFixed(1)
        : undefined;
    return "".concat(percentPerBar || 'N/A', "% ").concat(responsesPerBar, " responses");
};
var formatTooltipTitle = function (item) {
    // Each label row has length of MAX_LABEL_ROW_LENGTH, I know that the label gets truncated on the second
    // row so when the lenght of the label is greater than MAX_LABEL_ROW_LENGTH  * 2
    var LENGTH_LABEL_BEFORE_TRUNCATION = MAX_LABEL_ROW_LENGTH * 2;
    var yAxisLabel = item[0].label || 'N/A';
    if (yAxisLabel.length > LENGTH_LABEL_BEFORE_TRUNCATION) {
        // ChartJs allows multilines in the tooltip title by passing an array of strings
        // I am splitting the text in equal parts (after MAX_LABEL_ROW_LENGTH characters)
        var labelArray = yAxisLabel.match(/.{1,40}(\s|$)/g);
        return labelArray || yAxisLabel;
    }
    // Return empty string to hide the tootltip title
    // when the repons eoption is short ad does not need truncation
    return '';
};
var getBarColor = function (index) {
    var colors = [
        '#14465A',
        '#FF6E5A',
        '#59A14F',
        '#EDC948',
        '#B9C8CE',
        '#F28E2B',
        '#B07AA1',
        '#4E79A7',
        '#FFD4CE',
        '#9C755F',
        '#58B5DA',
        '#F8E9B5',
        '#A5D09F',
        '#F3F6F7',
        '#F8C28C',
        '#DEE2E6',
        '#88AAAA',
        '#F88DF6',
        '#52F4AE',
        '#E9FF70'
    ];
    return colors[index];
};
var percentFormatterDefault = function (barValue) {
    var barPercent = "".concat((barValue * 100).toFixed(0), "%");
    return "".concat(barPercent);
};
var getDefaultOptions = function (theme, maxBarValue) {
    var maxTickDefault = calculateMaxTickDefault(maxBarValue);
    var tickSizeDefault = calculateTickStepSizeDefault(maxBarValue);
    var pluginOptions = {
        datalabels: {
            display: true,
            clamp: true,
            clip: false,
            font: {
                family: theme.typography.fontFamily,
                size: theme.typography.fontSize * 0.75,
                weight: 500
            },
            formatter: function (value) { return percentFormatterDefault(value); }
        },
        tooltip: {
            callbacks: {
                title: formatTooltipTitle,
                label: formatTooltipLabelDefault
            }
        }
    };
    var layoutOptions = {
        padding: {
            top: 0,
            bottom: 0,
            left: 22,
            right: 35
        }
    };
    var options = {
        maintainAspectRatio: false,
        responsive: true,
        animation: {
            duration: 100
        },
        plugins: pluginOptions,
        layout: layoutOptions
    };
    options.scales = {
        x: {
            grid: {
                drawBorder: false,
                display: false
            },
            min: 0,
            max: maxTickDefault,
            ticks: {
                stepSize: tickSizeDefault,
                display: false,
                padding: 5,
                color: theme.palette.text.secondary,
                font: {
                    family: theme.typography.fontFamily,
                    size: theme.typography.fontSize * 0.875
                },
                callback: function (value) { return percentFormatterDefault(value); }
            }
        },
        y: {
            title: {
                display: false
            },
            grid: {
                drawBorder: false,
                display: false
            },
            ticks: {
                font: {
                    family: theme.typography.fontFamily,
                    size: theme.typography.fontSize * 0.75
                },
                color: theme.palette.text.primary,
                // This type seems to be missing the string[] return value
                // @ts-ignore
                // eslint-disable-next-line func-names
                callback: function (tickValue) {
                    var label = this.getLabelForValue(tickValue) || '';
                    if (label.length > 2 * MAX_LABEL_ROW_LENGTH) {
                        var firstLine = getMaxStringLessThan(label, MAX_LABEL_ROW_LENGTH);
                        return [
                            firstLine,
                            "".concat(label.slice(firstLine.length, 2 * MAX_LABEL_ROW_LENGTH - 3), "...")
                        ];
                    }
                    if (label.length > MAX_LABEL_ROW_LENGTH) {
                        var firstLine = getMaxStringLessThan(label, MAX_LABEL_ROW_LENGTH);
                        return [firstLine, label.slice(firstLine.length)];
                    }
                    return label;
                }
            }
        }
    };
    return options;
};
// 40px for each bar and another 35 for bottom and top spacing
var calculateChartHeight = function (datasetLenght) { return datasetLenght * 40 + 35 + 35; };
var getAdjustedMaxBarValueIfNeeded = function (maxBarValue, data) {
    var dataTotalsPerBar = data.datasets[0].data.map(function (_, i) {
        return data.datasets.reduce(function (acc, dataset) {
            return dataset.data[i] + acc;
        }, 0);
    });
    var maxBarValueFound = Math.max.apply(Math, dataTotalsPerBar);
    var shouldAdjustBars = maxBarValueFound < maxBarValue;
    return shouldAdjustBars ? maxBarValueFound : maxBarValue;
};

var TOOLTIP_ID = 'chartjs-tooltip';
var TOOLTIP_CARET_ID = 'chartjs-tooltip-caret';
var buildTooltipTitle = function (titleEl, tooltipModel) {
    var titleLines = tooltipModel.title || [];
    Object.assign(titleEl.style, {
        color: tooltipModel.options.titleColor,
        fontSize: "".concat(tooltipModel.options.titleFont._proxy.size, "px"),
        fontWeight: "".concat(tooltipModel.options.titleFont._proxy.style),
        textAlign: tooltipModel.options.titleAlign
    });
    if (titleLines.length) {
        Object.assign(titleEl.style, {
            marginBottom: "".concat(tooltipModel.options.titleMarginBottom, "px")
        });
        titleLines.forEach(function (title) {
            var row = document.createElement('div');
            titleEl.append(row);
            row.textContent = title;
        });
    }
};
var createCaret = function (tooltipModel) {
    var _a;
    var caretEl = document.getElementById(TOOLTIP_CARET_ID);
    if (caretEl) {
        // remove existing caret to create styles from scratch and escape any styling collisions
        caretEl.remove();
    }
    caretEl = document.createElement('div');
    caretEl.id = TOOLTIP_CARET_ID;
    Object.assign(caretEl.style, {
        position: 'absolute',
        border: "".concat(tooltipModel.options.caretSize, "px solid transparent")
    });
    switch (tooltipModel.yAlign) {
        case 'top':
            Object.assign(caretEl.style, {
                top: "".concat(-2 * parseFloat(tooltipModel.options.caretSize.toString()), "px"),
                left: '50%',
                marginLeft: "".concat(-0.5 * parseFloat(tooltipModel.options.caretSize.toString()), "px"),
                borderBottomColor: tooltipModel.options.backgroundColor
            });
            break;
        case 'center':
            Object.assign(caretEl.style, (_a = {
                    top: '50%',
                    marginTop: "".concat(-tooltipModel.options.caretSize, "px"),
                    left: tooltipModel.xAlign === 'left' ? '0' : '100%'
                },
                _a[tooltipModel.xAlign === 'left'
                    ? 'borderRightColor'
                    : 'borderLeftColor'] = tooltipModel.options.backgroundColor,
                _a[tooltipModel.xAlign === 'left' ? 'marginLeft' : 'marginRight'] = "".concat(-2 * parseFloat(tooltipModel.options.caretSize.toString()), "px"),
                _a));
            break;
        default:
            Object.assign(caretEl.style, {
                top: '100%',
                left: '50%',
                marginLeft: "".concat(-0.5 * parseFloat(tooltipModel.options.caretSize.toString()), "px"),
                borderTopColor: tooltipModel.options.backgroundColor
            });
    }
    return caretEl;
};
var createTooltip$1 = function (canvas, tooltipModel) {
    var position = canvas.getBoundingClientRect();
    var tooltipEl = document.getElementById(TOOLTIP_ID);
    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = TOOLTIP_ID;
        document.body.append(tooltipEl);
    }
    Object.assign(tooltipEl.style, {
        opacity: '1',
        position: 'absolute',
        left: "".concat(position.left + window.pageXOffset + tooltipModel.x, "px"),
        top: "".concat(position.top + window.pageYOffset + tooltipModel.y, "px"),
        color: tooltipModel.options.bodyColor,
        borderRadius: "".concat(tooltipModel.options.cornerRadius, "px"),
        padding: "".concat(tooltipModel.options.padding, "px"),
        pointerEvents: 'none',
        backgroundColor: tooltipModel.options.backgroundColor,
        borderWidth: "".concat(tooltipModel.options.borderWidth, "px"),
        borderColor: tooltipModel.options.borderColor,
        fontFamily: "".concat(tooltipModel.options.bodyFont._proxy.family)
    });
    return tooltipEl;
};
var buildTooltipBody = function (bodyEl, tooltipModel) {
    var bodyLines = tooltipModel.body.map(function (bodyItem) { return bodyItem.lines; });
    bodyLines.forEach(function (bodyLine, i) {
        var color = tooltipModel.labelColors[i];
        var labelMark = document.createElement('span');
        var labelText = document.createElement('span');
        var bodyLineEl = document.createElement('div');
        Object.assign(bodyEl.style, {
            color: tooltipModel.options.bodyColor,
            fontSize: "".concat(tooltipModel.options.bodyFont._proxy.size, "px")
        });
        Object.assign(labelMark.style, {
            backgroundColor: color.backgroundColor,
            borderColor: color.borderColor,
            display: 'inline-block',
            boxSizing: 'border-box',
            width: "".concat(tooltipModel.options.titleFont._proxy.size, "px"),
            height: "".concat(tooltipModel.options.titleFont._proxy.size, "px"),
            margin: "".concat(tooltipModel.options.titleSpacing, "px"),
            verticalAlign: 'middle',
            border: "1px solid ".concat(tooltipModel.labelTextColors[i])
        });
        labelText.append(bodyLine[0]);
        labelText.style.verticalAlign = 'middle';
        bodyLineEl.append(labelMark, labelText);
        bodyEl.append(bodyLineEl);
    });
};

var BarChart = function (props) {
    var _a, _b;
    var data = props.data, colorIndex = props.colorIndex, _c = props.minCanvasHeight, minCanvasHeight = _c === void 0 ? 180 : _c, _d = props.canvasReductionValue, canvasReductionValue = _d === void 0 ? 0 : _d;
    var theme = useTheme();
    var height = calculateChartHeight((data === null || data === void 0 ? void 0 : data.datasets[0].data.length) || 0);
    var maxBarValue = ((data === null || data === void 0 ? void 0 : data.datasets[0].data) && Math.max.apply(Math, data.datasets[0].data)) || 0;
    var options = getDefaultOptions(theme, maxBarValue);
    if (options) {
        options.indexAxis = 'y';
        options.plugins = {
            datalabels: __assign$3(__assign$3({}, (_a = options.plugins) === null || _a === void 0 ? void 0 : _a.datalabels), { color: theme.palette.text.primary, anchor: 'end', align: 'right' }),
            legend: {
                display: false
            },
            tooltip: __assign$3(__assign$3({}, (_b = options.plugins) === null || _b === void 0 ? void 0 : _b.tooltip), { intersect: false, axis: 'y', mode: 'index', enabled: false, external: function (_a) {
                    var tooltipModel = _a.tooltip, chart = _a.chart;
                    var canvas = chart.canvas;
                    var tooltipEl = createTooltip$1(canvas, tooltipModel);
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = '0';
                        return;
                    }
                    var caretEl = createCaret(tooltipModel);
                    if (tooltipModel.body) {
                        var titleEl = document.createElement('div');
                        var bodyEl = document.createElement('div');
                        buildTooltipTitle(titleEl, tooltipModel);
                        buildTooltipBody(bodyEl, tooltipModel);
                        tooltipEl.innerHTML = '';
                        tooltipEl.append(titleEl, bodyEl, caretEl);
                    }
                } })
        };
    }
    var getSingleMultipleColor = function (index) {
        var indexModulo = index % 10; // 10 are the primary colors for the charts
        var selectedColor = getBarColor(indexModulo);
        return selectedColor;
    };
    var dataCallback = __assign$3(__assign$3({}, data), { datasets: [
            {
                totalSamples: data === null || data === void 0 ? void 0 : data.totalSamples,
                data: data === null || data === void 0 ? void 0 : data.datasets[0].data,
                backgroundColor: getSingleMultipleColor(colorIndex || 0),
                hoverBackgroundColor: getSingleMultipleColor(colorIndex || 0)
            }
        ] });
    var getCanvasHeight = function (height, minCanvasHeight, canvasReductionValue) {
        if (height - canvasReductionValue < minCanvasHeight) {
            return minCanvasHeight;
        }
        return height - canvasReductionValue;
    };
    var canvasHeight = getCanvasHeight(height, minCanvasHeight, canvasReductionValue);
    Chart$1.register(plugin);
    return jsx$1(Bar, { height: canvasHeight, data: dataCallback, options: options });
};

var StackedBarChart = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var data = props.data;
    var theme = useTheme();
    var height = useState(calculateChartHeight(((_a = data === null || data === void 0 ? void 0 : data.datasets[0].data) === null || _a === void 0 ? void 0 : _a.length) || 0))[0];
    var percentFormatterStackedChart = function (optionValue, context) {
        var optionPercent = optionValue * 100; // The sum of each option value is 1
        var widthChart = context.chart.width;
        if (optionPercent < 8 && widthChart && widthChart < 610) {
            return '';
        }
        if (optionPercent < 4) {
            return '';
        }
        return "".concat(optionPercent.toFixed(0), "%");
    };
    // The max for a stacked bar is 100%. If it is less than 100% adjusted value is applied to scale the chart
    var maxBarValue = getAdjustedMaxBarValueIfNeeded(1, data);
    var options = getDefaultOptions(theme, maxBarValue);
    options.indexAxis = 'y';
    options.plugins = __assign$3(__assign$3({}, options.plugins), { datalabels: __assign$3(__assign$3({}, (_b = options.plugins) === null || _b === void 0 ? void 0 : _b.datalabels), { color: theme.palette.background.default, clip: true, clamp: false, anchor: 'center', align: 'center', formatter: function (value, context) {
                return percentFormatterStackedChart(value, context);
            } // This overwrites the one provided by "getDefaultOptions"
         }), tooltip: __assign$3(__assign$3({}, (_c = options.plugins) === null || _c === void 0 ? void 0 : _c.tooltip), { axis: 'y', mode: 'index' }) });
    var defaultX = ((_d = options.scales) === null || _d === void 0 ? void 0 : _d.x) ? (_e = options.scales) === null || _e === void 0 ? void 0 : _e.x : undefined;
    var defaultY = ((_f = options.scales) === null || _f === void 0 ? void 0 : _f.y) ? (_g = options.scales) === null || _g === void 0 ? void 0 : _g.y : undefined;
    options.scales = {
        x: __assign$3(__assign$3({}, defaultX), { stacked: true }),
        y: __assign$3(__assign$3({}, defaultY), { stacked: true })
    };
    var dataWithColors = __assign$3(__assign$3({}, data), { datasets: data === null || data === void 0 ? void 0 : data.datasets.map(function (dataset, index) {
            return __assign$3(__assign$3({}, dataset), { backgroundColor: getBarColor(index), hoverBackgroundColor: getBarColor(index), totalSamples: data.totalSamples, completesPerRow: data.completesPerRow });
        }) });
    Chart$1.register(plugin);
    return jsx$1(Bar, { height: height, data: dataWithColors, options: options });
};

var GroupedChart = function (props) {
    var _a, _b;
    var data = props.data;
    var theme = useTheme();
    var numMaxOptionsPerQuestion = (data === null || data === void 0 ? void 0 : data.datasets.length) || 1;
    var AVG_HEIGHT_BAR = 30;
    var AVG_UNUSED_SPACE = 50; // The white space ChartJS places between top/bottom of the chart
    var highMultiplicator = numMaxOptionsPerQuestion * AVG_HEIGHT_BAR + AVG_UNUSED_SPACE;
    var height = ((data === null || data === void 0 ? void 0 : data.datasets[0].data.length) || 0) * highMultiplicator;
    var percentagesReponses = data === null || data === void 0 ? void 0 : data.datasets.map(function (dataset) { return dataset.data; }).flatMap(function (percent) { return percent; });
    var maxBarValue = percentagesReponses
        ? Math.max.apply(Math, percentagesReponses) : 0;
    var options = getDefaultOptions(theme, maxBarValue);
    options.indexAxis = 'y';
    options.plugins = __assign$3(__assign$3({}, options.plugins), { datalabels: __assign$3(__assign$3({}, (_a = options.plugins) === null || _a === void 0 ? void 0 : _a.datalabels), { color: theme.palette.text.primary, anchor: 'end', align: 'right' }), tooltip: __assign$3(__assign$3({}, (_b = options.plugins) === null || _b === void 0 ? void 0 : _b.tooltip), { axis: 'y', mode: 'index' }) });
    var dataWithColor = __assign$3(__assign$3({}, data), { datasets: data === null || data === void 0 ? void 0 : data.datasets.map(function (dataset, index) {
            return __assign$3(__assign$3({}, dataset), { backgroundColor: getBarColor(index), hoverBackgroundColor: getBarColor(index), totalSamples: data.totalSamples });
        }) });
    Chart$1.register(plugin);
    return jsx$1(Bar, { height: height, data: dataWithColor, options: options });
};

var useStyles$8 = makeStyles()(function (theme) { return ({
    meanText: {
        fontSize: theme.spacing(8)
    }
}); });

var MeanChart = function (props) {
    var data = props.data;
    var classes = useStyles$8().classes;
    var _a = useTextStyles(), textClasses = _a.classes, classNames = _a.cx;
    return (jsxs(Grid, __assign$3({ container: true, justifyContent: "center", alignItems: "center", direction: "column", style: { height: 200 } }, { children: [jsx$1(Grid, __assign$3({ item: true }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.sizeM) }, { children: "Mean" })) })), jsx$1(Grid, __assign$3({ item: true }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, classes.meanText) }, { children: data.mean })) }))] })));
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce$1;

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
}

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

function none() {}

function selector(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}

function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function empty() {
  return [];
}

function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

function selection_selectAll(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection$1(subgroups, parents);
}

function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function sparse(update) {
  return new Array(update.length);
}

function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

function constant$2(x) {
  return function() {
    return x;
  };
}

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

function selection_data(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$2(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection$1(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

function selection_merge(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection$1(merges, this._parents);
}

function selection_order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

function selection_sort(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection$1(sortgroups, this._parents).order();
}

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

function selection_nodes() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
}

function selection_node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

function selection_size() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}

function selection_empty() {
  return !this.node();
}

function selection_each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS$1(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction$1(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS$1(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

function selection_attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS$1 : attrRemove$1) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)))(fullname, value));
}

function defaultView(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction$1(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

function selection_style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove$1 : typeof value === "function"
            ? styleFunction$1
            : styleConstant$1)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

function selection_property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

function selection_classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

function textRemove() {
  this.textContent = "";
}

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction$1
          : textConstant$1)(value))
      : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

function selection_html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

function selection_on(typename, value, capture) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
}

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

var root = [null];

function Selection$1(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection$1([[document.documentElement]], root);
}

Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

function a(selector) {
  return typeof selector === "string"
      ? new Selection$1([[document.querySelector(selector)]], [document.documentElement])
      : new Selection$1([[selector]], root);
}

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser$1 || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser$1 || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser$1) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
})();

var noop = {value: function() {}};

function dispatch$1() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch$1.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set$1(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get$1(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set$1(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var src = /*#__PURE__*/Object.freeze({
    __proto__: null,
    dispatch: dispatch$1
});

var frame = 0, // is an animation frame pending?
    timeout$1 = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout$1) timeout$1 = clearTimeout(timeout$1);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function timeout(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

var emptyOn = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

function interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}

function define$1(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend$1(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color$1() {}

var darker$1 = 0.7;
var brighter$1 = 1 / darker$1;

var reI$1 = "\\s*([+-]?\\d+)\\s*",
    reN$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex$1 = /^#([0-9a-f]{3,8})$/,
    reRgbInteger$1 = new RegExp("^rgb\\(" + [reI$1, reI$1, reI$1] + "\\)$"),
    reRgbPercent$1 = new RegExp("^rgb\\(" + [reP$1, reP$1, reP$1] + "\\)$"),
    reRgbaInteger$1 = new RegExp("^rgba\\(" + [reI$1, reI$1, reI$1, reN$1] + "\\)$"),
    reRgbaPercent$1 = new RegExp("^rgba\\(" + [reP$1, reP$1, reP$1, reN$1] + "\\)$"),
    reHslPercent$1 = new RegExp("^hsl\\(" + [reN$1, reP$1, reP$1] + "\\)$"),
    reHslaPercent$1 = new RegExp("^hsla\\(" + [reN$1, reP$1, reP$1, reN$1] + "\\)$");

var named$1 = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define$1(Color$1, color$1, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$1, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex$1,
  formatHsl: color_formatHsl$1,
  formatRgb: color_formatRgb$1,
  toString: color_formatRgb$1
});

function color_formatHex$1() {
  return this.rgb().formatHex();
}

function color_formatHsl$1() {
  return hslConvert$1(this).formatHsl();
}

function color_formatRgb$1() {
  return this.rgb().formatRgb();
}

function color$1(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex$1.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn$1(m) // #ff0000
      : l === 3 ? new Rgb$1((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba$1(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba$1((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger$1.exec(format)) ? new Rgb$1(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent$1.exec(format)) ? new Rgb$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger$1.exec(format)) ? rgba$1(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent$1.exec(format)) ? rgba$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named$1.hasOwnProperty(format) ? rgbn$1(named$1[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb$1(NaN, NaN, NaN, 0)
      : null;
}

function rgbn$1(n) {
  return new Rgb$1(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba$1(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb$1(r, g, b, a);
}

function rgbConvert$1(o) {
  if (!(o instanceof Color$1)) o = color$1(o);
  if (!o) return new Rgb$1;
  o = o.rgb();
  return new Rgb$1(o.r, o.g, o.b, o.opacity);
}

function rgb$2(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert$1(r) : new Rgb$1(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb$1(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define$1(Rgb$1, rgb$2, extend$1(Color$1, {
  brighter: function(k) {
    k = k == null ? brighter$1 : Math.pow(brighter$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker$1 : Math.pow(darker$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex$1, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex$1,
  formatRgb: rgb_formatRgb$1,
  toString: rgb_formatRgb$1
}));

function rgb_formatHex$1() {
  return "#" + hex$1(this.r) + hex$1(this.g) + hex$1(this.b);
}

function rgb_formatRgb$1() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex$1(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla$1(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl$1(h, s, l, a);
}

function hslConvert$1(o) {
  if (o instanceof Hsl$1) return new Hsl$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$1)) o = color$1(o);
  if (!o) return new Hsl$1;
  if (o instanceof Hsl$1) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl$1(h, s, l, o.opacity);
}

function hsl$1(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert$1(h) : new Hsl$1(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl$1(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define$1(Hsl$1, hsl$1, extend$1(Color$1, {
  brighter: function(k) {
    k = k == null ? brighter$1 : Math.pow(brighter$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker$1 : Math.pow(darker$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb$1(
      hsl2rgb$1(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb$1(h, m1, m2),
      hsl2rgb$1(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb$1(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

function constant$1(x) {
  return function() {
    return x;
  };
}

function linear$2(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential$1(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma$1(y) {
  return (y = +y) === 1 ? nogamma$1 : function(a, b) {
    return b - a ? exponential$1(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}

function nogamma$1(a, b) {
  var d = b - a;
  return d ? linear$2(a, d) : constant$1(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color = gamma$1(y);

  function rgb(start, end) {
    var r = color((start = rgb$2(start)).r, (end = rgb$2(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma$1(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function interpolateNumber$1(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

var reA$1 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB$1 = new RegExp(reA$1.source, "g");

function zero$1(b) {
  return function() {
    return b;
  };
}

function one$1(b) {
  return function(t) {
    return b(t) + "";
  };
}

function interpolateString(a, b) {
  var bi = reA$1.lastIndex = reB$1.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA$1.exec(a))
      && (bm = reB$1.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber$1(am, bm)});
    }
    bi = reB$1.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one$1(q[0].x)
      : zero$1(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: interpolateNumber$1(xa, xb)}, {i: i - 2, x: interpolateNumber$1(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber$1(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber$1(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: interpolateNumber$1(xa, xb)}, {i: i - 2, x: interpolateNumber$1(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

function transition_tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get(node, id).value[name];
  };
}

function interpolate$1(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber$1
      : b instanceof color$1 ? interpolateRgb
      : (c = color$1(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
}

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}

function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

function transition_delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get(this.node(), id).delay;
}

function durationFunction(id, value) {
  return function() {
    set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set(this, id).duration = value;
  };
}

function transition_duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get(this.node(), id).duration;
}

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set(this, id).ease = value;
  };
}

function transition_ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get(this.node(), id).ease;
}

function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
}

function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
}

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
}

function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
}

var Selection = selection.prototype.constructor;

function transition_selection() {
  return new Selection(this._groups, this._parents);
}

function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
}

function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(tweenValue(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
}

function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

function transition_transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
}

function transition_end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });
  });
}

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  end: transition_end
};

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

function selection_transition(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
}

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function ascendingComparator(f) {
  return (d, x) => ascending(f(d), x);
}

function number$1(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$1).center;
var bisect = bisectRight;

function c(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function max(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}

function min(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  }
  return min;
}

function f(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

var require$$0 = /*@__PURE__*/getAugmentedNamespace(src);

// Word cloud layout by Jason Davies, https://www.jasondavies.com/wordcloud/
// Algorithm due to Jonathan Feinberg, http://static.mrfeinberg.com/bv_ch03.pdf

var dispatch = require$$0.dispatch;

var cloudRadians = Math.PI / 180,
    cw = 1 << 11 >> 5,
    ch = 1 << 11;

var d3Cloud = function() {
  var size = [256, 256],
      text = cloudText,
      font = cloudFont,
      fontSize = cloudFontSize,
      fontStyle = cloudFontNormal,
      fontWeight = cloudFontNormal,
      rotate = cloudRotate,
      padding = cloudPadding,
      spiral = archimedeanSpiral,
      words = [],
      timeInterval = Infinity,
      event = dispatch("word", "end"),
      timer = null,
      random = Math.random,
      cloud = {},
      canvas = cloudCanvas;

  cloud.canvas = function(_) {
    return arguments.length ? (canvas = functor(_), cloud) : canvas;
  };

  cloud.start = function() {
    var contextAndRatio = getContext(canvas()),
        board = zeroArray((size[0] >> 5) * size[1]),
        bounds = null,
        n = words.length,
        i = -1,
        tags = [],
        data = words.map(function(d, i) {
          d.text = text.call(this, d, i);
          d.font = font.call(this, d, i);
          d.style = fontStyle.call(this, d, i);
          d.weight = fontWeight.call(this, d, i);
          d.rotate = rotate.call(this, d, i);
          d.size = ~~fontSize.call(this, d, i);
          d.padding = padding.call(this, d, i);
          return d;
        }).sort(function(a, b) { return b.size - a.size; });

    if (timer) clearInterval(timer);
    timer = setInterval(step, 0);
    step();

    return cloud;

    function step() {
      var start = Date.now();
      while (Date.now() - start < timeInterval && ++i < n && timer) {
        var d = data[i];
        d.x = (size[0] * (random() + .5)) >> 1;
        d.y = (size[1] * (random() + .5)) >> 1;
        cloudSprite(contextAndRatio, d, data, i);
        if (d.hasText && place(board, d, bounds)) {
          tags.push(d);
          event.call("word", cloud, d);
          if (bounds) cloudBounds(bounds, d);
          else bounds = [{x: d.x + d.x0, y: d.y + d.y0}, {x: d.x + d.x1, y: d.y + d.y1}];
          // Temporary hack
          d.x -= size[0] >> 1;
          d.y -= size[1] >> 1;
        }
      }
      if (i >= n) {
        cloud.stop();
        event.call("end", cloud, tags, bounds);
      }
    }
  };

  cloud.stop = function() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    return cloud;
  };

  function getContext(canvas) {
    canvas.width = canvas.height = 1;
    var ratio = Math.sqrt(canvas.getContext("2d").getImageData(0, 0, 1, 1).data.length >> 2);
    canvas.width = (cw << 5) / ratio;
    canvas.height = ch / ratio;

    var context = canvas.getContext("2d");
    context.fillStyle = context.strokeStyle = "red";
    context.textAlign = "center";

    return {context: context, ratio: ratio};
  }

  function place(board, tag, bounds) {
    [{x: 0, y: 0}, {x: size[0], y: size[1]}];
        var startX = tag.x,
        startY = tag.y,
        maxDelta = Math.sqrt(size[0] * size[0] + size[1] * size[1]),
        s = spiral(size),
        dt = random() < .5 ? 1 : -1,
        t = -dt,
        dxdy,
        dx,
        dy;

    while (dxdy = s(t += dt)) {
      dx = ~~dxdy[0];
      dy = ~~dxdy[1];

      if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) break;

      tag.x = startX + dx;
      tag.y = startY + dy;

      if (tag.x + tag.x0 < 0 || tag.y + tag.y0 < 0 ||
          tag.x + tag.x1 > size[0] || tag.y + tag.y1 > size[1]) continue;
      // TODO only check for collisions within current bounds.
      if (!bounds || !cloudCollide(tag, board, size[0])) {
        if (!bounds || collideRects(tag, bounds)) {
          var sprite = tag.sprite,
              w = tag.width >> 5,
              sw = size[0] >> 5,
              lx = tag.x - (w << 4),
              sx = lx & 0x7f,
              msx = 32 - sx,
              h = tag.y1 - tag.y0,
              x = (tag.y + tag.y0) * sw + (lx >> 5),
              last;
          for (var j = 0; j < h; j++) {
            last = 0;
            for (var i = 0; i <= w; i++) {
              board[x + i] |= (last << msx) | (i < w ? (last = sprite[j * w + i]) >>> sx : 0);
            }
            x += sw;
          }
          delete tag.sprite;
          return true;
        }
      }
    }
    return false;
  }

  cloud.timeInterval = function(_) {
    return arguments.length ? (timeInterval = _ == null ? Infinity : _, cloud) : timeInterval;
  };

  cloud.words = function(_) {
    return arguments.length ? (words = _, cloud) : words;
  };

  cloud.size = function(_) {
    return arguments.length ? (size = [+_[0], +_[1]], cloud) : size;
  };

  cloud.font = function(_) {
    return arguments.length ? (font = functor(_), cloud) : font;
  };

  cloud.fontStyle = function(_) {
    return arguments.length ? (fontStyle = functor(_), cloud) : fontStyle;
  };

  cloud.fontWeight = function(_) {
    return arguments.length ? (fontWeight = functor(_), cloud) : fontWeight;
  };

  cloud.rotate = function(_) {
    return arguments.length ? (rotate = functor(_), cloud) : rotate;
  };

  cloud.text = function(_) {
    return arguments.length ? (text = functor(_), cloud) : text;
  };

  cloud.spiral = function(_) {
    return arguments.length ? (spiral = spirals[_] || _, cloud) : spiral;
  };

  cloud.fontSize = function(_) {
    return arguments.length ? (fontSize = functor(_), cloud) : fontSize;
  };

  cloud.padding = function(_) {
    return arguments.length ? (padding = functor(_), cloud) : padding;
  };

  cloud.random = function(_) {
    return arguments.length ? (random = _, cloud) : random;
  };

  cloud.on = function() {
    var value = event.on.apply(event, arguments);
    return value === event ? cloud : value;
  };

  return cloud;
};

function cloudText(d) {
  return d.text;
}

function cloudFont() {
  return "serif";
}

function cloudFontNormal() {
  return "normal";
}

function cloudFontSize(d) {
  return Math.sqrt(d.value);
}

function cloudRotate() {
  return (~~(Math.random() * 6) - 3) * 30;
}

function cloudPadding() {
  return 1;
}

// Fetches a monochrome sprite bitmap for the specified text.
// Load in batches for speed.
function cloudSprite(contextAndRatio, d, data, di) {
  if (d.sprite) return;
  var c = contextAndRatio.context,
      ratio = contextAndRatio.ratio;

  c.clearRect(0, 0, (cw << 5) / ratio, ch / ratio);
  var x = 0,
      y = 0,
      maxh = 0,
      n = data.length;
  --di;
  while (++di < n) {
    d = data[di];
    c.save();
    c.font = d.style + " " + d.weight + " " + ~~((d.size + 1) / ratio) + "px " + d.font;
    var w = c.measureText(d.text + "m").width * ratio,
        h = d.size << 1;
    if (d.rotate) {
      var sr = Math.sin(d.rotate * cloudRadians),
          cr = Math.cos(d.rotate * cloudRadians),
          wcr = w * cr,
          wsr = w * sr,
          hcr = h * cr,
          hsr = h * sr;
      w = (Math.max(Math.abs(wcr + hsr), Math.abs(wcr - hsr)) + 0x1f) >> 5 << 5;
      h = ~~Math.max(Math.abs(wsr + hcr), Math.abs(wsr - hcr));
    } else {
      w = (w + 0x1f) >> 5 << 5;
    }
    if (h > maxh) maxh = h;
    if (x + w >= (cw << 5)) {
      x = 0;
      y += maxh;
      maxh = 0;
    }
    if (y + h >= ch) break;
    c.translate((x + (w >> 1)) / ratio, (y + (h >> 1)) / ratio);
    if (d.rotate) c.rotate(d.rotate * cloudRadians);
    c.fillText(d.text, 0, 0);
    if (d.padding) c.lineWidth = 2 * d.padding, c.strokeText(d.text, 0, 0);
    c.restore();
    d.width = w;
    d.height = h;
    d.xoff = x;
    d.yoff = y;
    d.x1 = w >> 1;
    d.y1 = h >> 1;
    d.x0 = -d.x1;
    d.y0 = -d.y1;
    d.hasText = true;
    x += w;
  }
  var pixels = c.getImageData(0, 0, (cw << 5) / ratio, ch / ratio).data,
      sprite = [];
  while (--di >= 0) {
    d = data[di];
    if (!d.hasText) continue;
    var w = d.width,
        w32 = w >> 5,
        h = d.y1 - d.y0;
    // Zero the buffer
    for (var i = 0; i < h * w32; i++) sprite[i] = 0;
    x = d.xoff;
    if (x == null) return;
    y = d.yoff;
    var seen = 0,
        seenRow = -1;
    for (var j = 0; j < h; j++) {
      for (var i = 0; i < w; i++) {
        var k = w32 * j + (i >> 5),
            m = pixels[((y + j) * (cw << 5) + (x + i)) << 2] ? 1 << (31 - (i % 32)) : 0;
        sprite[k] |= m;
        seen |= m;
      }
      if (seen) seenRow = j;
      else {
        d.y0++;
        h--;
        j--;
        y++;
      }
    }
    d.y1 = d.y0 + seenRow;
    d.sprite = sprite.slice(0, (d.y1 - d.y0) * w32);
  }
}

// Use mask-based collision detection.
function cloudCollide(tag, board, sw) {
  sw >>= 5;
  var sprite = tag.sprite,
      w = tag.width >> 5,
      lx = tag.x - (w << 4),
      sx = lx & 0x7f,
      msx = 32 - sx,
      h = tag.y1 - tag.y0,
      x = (tag.y + tag.y0) * sw + (lx >> 5),
      last;
  for (var j = 0; j < h; j++) {
    last = 0;
    for (var i = 0; i <= w; i++) {
      if (((last << msx) | (i < w ? (last = sprite[j * w + i]) >>> sx : 0))
          & board[x + i]) return true;
    }
    x += sw;
  }
  return false;
}

function cloudBounds(bounds, d) {
  var b0 = bounds[0],
      b1 = bounds[1];
  if (d.x + d.x0 < b0.x) b0.x = d.x + d.x0;
  if (d.y + d.y0 < b0.y) b0.y = d.y + d.y0;
  if (d.x + d.x1 > b1.x) b1.x = d.x + d.x1;
  if (d.y + d.y1 > b1.y) b1.y = d.y + d.y1;
}

function collideRects(a, b) {
  return a.x + a.x1 > b[0].x && a.x + a.x0 < b[1].x && a.y + a.y1 > b[0].y && a.y + a.y0 < b[1].y;
}

function archimedeanSpiral(size) {
  var e = size[0] / size[1];
  return function(t) {
    return [e * (t *= .1) * Math.cos(t), t * Math.sin(t)];
  };
}

function rectangularSpiral(size) {
  var dy = 4,
      dx = dy * size[0] / size[1],
      x = 0,
      y = 0;
  return function(t) {
    var sign = t < 0 ? -1 : 1;
    // See triangular numbers: T_n = n * (n + 1) / 2.
    switch ((Math.sqrt(1 + 4 * sign * t) - sign) & 3) {
      case 0:  x += dx; break;
      case 1:  y += dy; break;
      case 2:  x -= dx; break;
      default: y -= dy; break;
    }
    return [x, y];
  };
}

// TODO reuse arrays?
function zeroArray(n) {
  var a = [],
      i = -1;
  while (++i < n) a[i] = 0;
  return a;
}

function cloudCanvas() {
  return document.createElement("canvas");
}

function functor(d) {
  return typeof d === "function" ? d : function() { return d; };
}

var spirals = {
  archimedean: archimedeanSpiral,
  rectangular: rectangularSpiral
};

var lodash_clonedeep = {exports: {}};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;
}(lodash_clonedeep, lodash_clonedeep.exports));

var d = lodash_clonedeep.exports;

var alea$1 = {exports: {}};

(function (module) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -

// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



(function(global, module, define) {

function Alea(seed) {
  var me = this, mash = Mash();

  me.next = function() {
    var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
    me.s0 = me.s1;
    me.s1 = me.s2;
    return me.s2 = t - (me.c = t | 0);
  };

  // Apply the seeding algorithm from Baagoe.
  me.c = 1;
  me.s0 = mash(' ');
  me.s1 = mash(' ');
  me.s2 = mash(' ');
  me.s0 -= mash(seed);
  if (me.s0 < 0) { me.s0 += 1; }
  me.s1 -= mash(seed);
  if (me.s1 < 0) { me.s1 += 1; }
  me.s2 -= mash(seed);
  if (me.s2 < 0) { me.s2 += 1; }
  mash = null;
}

function copy(f, t) {
  t.c = f.c;
  t.s0 = f.s0;
  t.s1 = f.s1;
  t.s2 = f.s2;
  return t;
}

function impl(seed, opts) {
  var xg = new Alea(seed),
      state = opts && opts.state,
      prng = xg.next;
  prng.int32 = function() { return (xg.next() * 0x100000000) | 0; };
  prng.double = function() {
    return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
  };
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

function Mash() {
  var n = 0xefc8249d;

  var mash = function(data) {
    data = String(data);
    for (var i = 0; i < data.length; i++) {
      n += data.charCodeAt(i);
      var h = 0.02519603282416938 * n;
      n = h >>> 0;
      h -= n;
      h *= n;
      n = h >>> 0;
      h -= n;
      n += h * 0x100000000; // 2^32
    }
    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
  };

  return mash;
}


if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.alea = impl;
}

})(
  commonjsGlobal,
  module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
}(alea$1));

var xor128$1 = {exports: {}};

(function (module) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;

  // Set up generator function.
  me.next = function() {
    var t = me.x ^ (me.x << 11);
    me.x = me.y;
    me.y = me.z;
    me.z = me.w;
    return me.w ^= (me.w >>> 19) ^ t ^ (t >>> 8);
  };

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xor128 = impl;
}

})(
  commonjsGlobal,
  module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
}(xor128$1));

var xorwow$1 = {exports: {}};

(function (module) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var t = (me.x ^ (me.x >>> 2));
    me.x = me.y; me.y = me.z; me.z = me.w; me.w = me.v;
    return (me.d = (me.d + 362437 | 0)) +
       (me.v = (me.v ^ (me.v << 4)) ^ (t ^ (t << 1))) | 0;
  };

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;
  me.v = 0;

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    if (k == strseed.length) {
      me.d = me.x << 10 ^ me.x >>> 4;
    }
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  t.v = f.v;
  t.d = f.d;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xorwow = impl;
}

})(
  commonjsGlobal,
  module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
}(xorwow$1));

var xorshift7$1 = {exports: {}};

(function (module) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    // Update xor generator.
    var X = me.x, i = me.i, t, v;
    t = X[i]; t ^= (t >>> 7); v = t ^ (t << 24);
    t = X[(i + 1) & 7]; v ^= t ^ (t >>> 10);
    t = X[(i + 3) & 7]; v ^= t ^ (t >>> 3);
    t = X[(i + 4) & 7]; v ^= t ^ (t << 7);
    t = X[(i + 7) & 7]; t = t ^ (t << 13); v ^= t ^ (t << 9);
    X[i] = v;
    me.i = (i + 1) & 7;
    return v;
  };

  function init(me, seed) {
    var j, X = [];

    if (seed === (seed | 0)) {
      // Seed state array using a 32-bit integer.
      X[0] = seed;
    } else {
      // Seed state using a string.
      seed = '' + seed;
      for (j = 0; j < seed.length; ++j) {
        X[j & 7] = (X[j & 7] << 15) ^
            (seed.charCodeAt(j) + X[(j + 1) & 7] << 13);
      }
    }
    // Enforce an array length of 8, not all zeroes.
    while (X.length < 8) X.push(0);
    for (j = 0; j < 8 && X[j] === 0; ++j);
    if (j == 8) X[7] = -1;

    me.x = X;
    me.i = 0;

    // Discard an initial 256 values.
    for (j = 256; j > 0; --j) {
      me.next();
    }
  }

  init(me, seed);
}

function copy(f, t) {
  t.x = f.x.slice();
  t.i = f.i;
  return t;
}

function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.x) copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xorshift7 = impl;
}

})(
  commonjsGlobal,
  module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
}(xorshift7$1));

var xor4096$1 = {exports: {}};

(function (module) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    var w = me.w,
        X = me.X, i = me.i, t, v;
    // Update Weyl generator.
    me.w = w = (w + 0x61c88647) | 0;
    // Update xor generator.
    v = X[(i + 34) & 127];
    t = X[i = ((i + 1) & 127)];
    v ^= v << 13;
    t ^= t << 17;
    v ^= v >>> 15;
    t ^= t >>> 12;
    // Update Xor generator array state.
    v = X[i] = v ^ t;
    me.i = i;
    // Result is the combination.
    return (v + (w ^ (w >>> 16))) | 0;
  };

  function init(me, seed) {
    var t, v, i, j, w, X = [], limit = 128;
    if (seed === (seed | 0)) {
      // Numeric seeds initialize v, which is used to generates X.
      v = seed;
      seed = null;
    } else {
      // String seeds are mixed into v and X one character at a time.
      seed = seed + '\0';
      v = 0;
      limit = Math.max(limit, seed.length);
    }
    // Initialize circular array and weyl value.
    for (i = 0, j = -32; j < limit; ++j) {
      // Put the unicode characters into the array, and shuffle them.
      if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
      // After 32 shuffles, take v as the starting w value.
      if (j === 0) w = v;
      v ^= v << 10;
      v ^= v >>> 15;
      v ^= v << 4;
      v ^= v >>> 13;
      if (j >= 0) {
        w = (w + 0x61c88647) | 0;     // Weyl.
        t = (X[j & 127] ^= (v + w));  // Combine xor and weyl to init array.
        i = (0 == t) ? i + 1 : 0;     // Count zeroes.
      }
    }
    // We have detected all zeroes; make the key nonzero.
    if (i >= 128) {
      X[(seed && seed.length || 0) & 127] = -1;
    }
    // Run the generator 512 times to further mix the state before using it.
    // Factoring this as a function slows the main generator, so it is just
    // unrolled here.  The weyl generator is not advanced while warming up.
    i = 127;
    for (j = 4 * 128; j > 0; --j) {
      v = X[(i + 34) & 127];
      t = X[i = ((i + 1) & 127)];
      v ^= v << 13;
      t ^= t << 17;
      v ^= v >>> 15;
      t ^= t >>> 12;
      X[i] = v ^ t;
    }
    // Storing state as object members is faster than using closure variables.
    me.w = w;
    me.X = X;
    me.i = i;
  }

  init(me, seed);
}

function copy(f, t) {
  t.i = f.i;
  t.w = f.w;
  t.X = f.X.slice();
  return t;
}
function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.X) copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xor4096 = impl;
}

})(
  commonjsGlobal,                                     // window object or global
  module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
}(xor4096$1));

var tychei$1 = {exports: {}};

(function (module) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var b = me.b, c = me.c, d = me.d, a = me.a;
    b = (b << 25) ^ (b >>> 7) ^ c;
    c = (c - d) | 0;
    d = (d << 24) ^ (d >>> 8) ^ a;
    a = (a - b) | 0;
    me.b = b = (b << 20) ^ (b >>> 12) ^ c;
    me.c = c = (c - d) | 0;
    me.d = (d << 16) ^ (c >>> 16) ^ a;
    return me.a = (a - b) | 0;
  };

  /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */

  me.a = 0;
  me.b = 0;
  me.c = 2654435769 | 0;
  me.d = 1367130551;

  if (seed === Math.floor(seed)) {
    // Integer seed.
    me.a = (seed / 0x100000000) | 0;
    me.b = seed | 0;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 20; k++) {
    me.b ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.a = f.a;
  t.b = f.b;
  t.c = f.c;
  t.d = f.d;
  return t;
}
function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); };
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.tychei = impl;
}

})(
  commonjsGlobal,
  module,    // present in node.js
  (typeof undefined) == 'function'    // present with an AMD loader
);
}(tychei$1));

var seedrandom$1 = {exports: {}};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

(function (module) {
(function (global, pool, math) {
//
// The following constants are related to IEEE 754 limits.
//

var width = 256,        // each RC4 output is 0 <= x < 256
    chunks = 6,         // at least six RC4 outputs for each double
    digits = 52,        // there are 52 significant digits in a double
    rngname = 'random', // rngname: name for Math.random and Math.seedrandom
    startdenom = math.pow(width, chunks),
    significance = math.pow(2, digits),
    overflow = significance * 2,
    mask = width - 1,
    nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
function seedrandom(seed, options, callback) {
  var key = [];
  options = (options == true) ? { entropy: true } : (options || {});

  // Flatten the seed string or build one from local entropy if needed.
  var shortseed = mixkey(flatten(
    options.entropy ? [seed, tostring(pool)] :
    (seed == null) ? autoseed() : seed, 3), key);

  // Use the seed to initialize an ARC4 generator.
  var arc4 = new ARC4(key);

  // This function returns a random double in [0, 1) that contains
  // randomness in every bit of the mantissa of the IEEE 754 value.
  var prng = function() {
    var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
        d = startdenom,                 //   and denominator d = 2 ^ 48.
        x = 0;                          //   and no 'extra last byte'.
    while (n < significance) {          // Fill up all significant digits by
      n = (n + x) * width;              //   shifting numerator and
      d *= width;                       //   denominator and generating a
      x = arc4.g(1);                    //   new least-significant-byte.
    }
    while (n >= overflow) {             // To avoid rounding up, before adding
      n /= 2;                           //   last byte, shift everything
      d /= 2;                           //   right using integer math until
      x >>>= 1;                         //   we have exactly the desired bits.
    }
    return (n + x) / d;                 // Form the number within [0, 1).
  };

  prng.int32 = function() { return arc4.g(4) | 0; };
  prng.quick = function() { return arc4.g(4) / 0x100000000; };
  prng.double = prng;

  // Mix the randomness into accumulated entropy.
  mixkey(tostring(arc4.S), pool);

  // Calling convention: what to return as a function of prng, seed, is_math.
  return (options.pass || callback ||
      function(prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) { copy(state, arc4); }
          // Only provide the .state method if requested via options.state.
          prng.state = function() { return copy(arc4, {}); };
        }

        // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.
        if (is_math_call) { math[rngname] = prng; return seed; }

        // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(
  prng,
  shortseed,
  'global' in options ? options.global : (this == math),
  options.state);
}

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
function ARC4(key) {
  var t, keylen = key.length,
      me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

  // The empty key [] is treated as [0].
  if (!keylen) { key = [keylen++]; }

  // Set up S using the standard key scheduling algorithm.
  while (i < width) {
    s[i] = i++;
  }
  for (i = 0; i < width; i++) {
    s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
    s[j] = t;
  }

  // The "g" method returns the next (count) outputs as one number.
  (me.g = function(count) {
    // Using instance members instead of closure state nearly doubles speed.
    var t, r = 0,
        i = me.i, j = me.j, s = me.S;
    while (count--) {
      t = s[i = mask & (i + 1)];
      r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
    }
    me.i = i; me.j = j;
    return r;
    // For robust unpredictability, the function call below automatically
    // discards an initial batch of values.  This is called RC4-drop[256].
    // See http://google.com/search?q=rsa+fluhrer+response&btnI
  })(width);
}

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
function copy(f, t) {
  t.i = f.i;
  t.j = f.j;
  t.S = f.S.slice();
  return t;
}
//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function flatten(obj, depth) {
  var result = [], typ = (typeof obj), prop;
  if (depth && typ == 'object') {
    for (prop in obj) {
      try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
    }
  }
  return (result.length ? result : typ == 'string' ? obj : obj + '\0');
}

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function mixkey(seed, key) {
  var stringseed = seed + '', smear, j = 0;
  while (j < stringseed.length) {
    key[mask & j] =
      mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
  }
  return tostring(key);
}

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
function autoseed() {
  try {
    var out;
    if (nodecrypto && (out = nodecrypto.randomBytes)) {
      // The use of 'out' to remember randomBytes makes tight minified code.
      out = out(width);
    } else {
      out = new Uint8Array(width);
      (global.crypto || global.msCrypto).getRandomValues(out);
    }
    return tostring(out);
  } catch (e) {
    var browser = global.navigator,
        plugins = browser && browser.plugins;
    return [+new Date, global, plugins, global.screen, tostring(pool)];
  }
}

//
// tostring()
// Converts an array of charcodes to a string
//
function tostring(a) {
  return String.fromCharCode.apply(0, a);
}

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//
if (module.exports) {
  module.exports = seedrandom;
  // When in node.js, try using crypto package for autoseeding.
  try {
    nodecrypto = require('crypto');
  } catch (ex) {}
} else {
  // When included as a plain script, set up Math.seedrandom global.
  math['seed' + rngname] = seedrandom;
}


// End anonymous scope, and pass initial values.
})(
  // global: `self` in browsers (including strict mode and web workers),
  // otherwise `this` in Node and other environments
  (typeof self !== 'undefined') ? self : commonjsGlobal,
  [],     // pool: entropy pool starts empty
  Math    // math: package containing random, pow, and seedrandom
);
}(seedrandom$1));

// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.

// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.
var alea = alea$1.exports;

// xor128, a pure xor-shift generator by George Marsaglia.
// Period: 2^128-1.
// Reported to fail: MatrixRank and LinearComp.
var xor128 = xor128$1.exports;

// xorwow, George Marsaglia's 160-bit xor-shift combined plus weyl.
// Period: 2^192-2^32
// Reported to fail: CollisionOver, SimpPoker, and LinearComp.
var xorwow = xorwow$1.exports;

// xorshift7, by François Panneton and Pierre L'ecuyer, takes
// a different approach: it adds robustness by allowing more shifts
// than Marsaglia's original three.  It is a 7-shift generator
// with 256 bits, that passes BigCrush with no systmatic failures.
// Period 2^256-1.
// No systematic BigCrush failures reported.
var xorshift7 = xorshift7$1.exports;

// xor4096, by Richard Brent, is a 4096-bit xor-shift with a
// very long period that also adds a Weyl generator. It also passes
// BigCrush with no systematic failures.  Its long period may
// be useful if you have many generators and need to avoid
// collisions.
// Period: 2^4128-2^32.
// No systematic BigCrush failures reported.
var xor4096 = xor4096$1.exports;

// Tyche-i, by Samuel Neves and Filipe Araujo, is a bit-shifting random
// number generator derived from ChaCha, a modern stream cipher.
// https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
// Period: ~2^127
// No systematic BigCrush failures reported.
var tychei = tychei$1.exports;

// The original ARC4-based prng included in this library.
// Period: ~2^1600
var sr = seedrandom$1.exports;

sr.alea = alea;
sr.xor128 = xor128;
sr.xorwow = xorwow;
sr.xorshift7 = xorshift7;
sr.xor4096 = xor4096;
sr.tychei = tychei;

var seedrandom = sr;

/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (process.env.NODE_ENV !== "production") {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (process.env.NODE_ENV !== "production") {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (process.env.NODE_ENV !== "production") {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

Object.assign({}, applyStyles$1, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

tippy.setDefaultProps({
  render: render
});

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb$1, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : string)
      : b instanceof color ? rgb
      : b instanceof Date ? date
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function constants(x) {
  return function() {
    return x;
  };
}

function number(x) {
  return +x;
}

var unit = [0, 1];

function identity$1(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer$1() {
  var domain = unit,
      range = unit,
      interpolate$1 = interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$1,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$1) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate$1 = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$1, rescale()) : clamp !== identity$1;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer$1()(identity$1, identity$1);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
var formatPrefix;

defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(transformer$1()).domain([1, 10]);

  scale.copy = function() {
    return copy(scale, log()).base(scale.base());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function transformPow(exponent) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(identity$1, identity$1),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(identity$1, identity$1)
        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
        : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return linearish(scale);
}

function pow() {
  var scale = powish(transformer$1());

  scale.copy = function() {
    return copy(scale, pow()).exponent(scale.exponent());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}

function colors(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

var w = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

function M(){return (M=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var r=arguments[n];for(var e in r)Object.prototype.hasOwnProperty.call(r,e)&&(t[e]=r[e]);}return t}).apply(this,arguments)}var z=Math.PI/180;function k(t){return t.text}function W(){return "serif"}function S(){return "normal"}function O(t){return Math.sqrt(t.value)}function T(){return 30*(~~(6*Math.random())-3)}function j(){return 1}function A(t,n,r,e){if(!n.sprite){var o=t.context,a=t.ratio;o.clearRect(0,0,2048/a,2048/a);var i=0,u=0,f=0,l=r.length;for(--e;++e<l;){n=r[e],o.save(),o.font=n.style+" "+n.weight+" "+~~((n.size+1)/a)+"px "+n.font;var s=o.measureText(n.text+"m").width*a,c=n.size<<1;if(n.rotate){var h=Math.sin(n.rotate*z),d=Math.cos(n.rotate*z),m=s*d,y=s*h,p=c*d,x=c*h;s=Math.max(Math.abs(m+x),Math.abs(m-x))+31>>5<<5,c=~~Math.max(Math.abs(y+p),Math.abs(y-p));}else s=s+31>>5<<5;if(c>f&&(f=c),i+s>=2048&&(i=0,u+=f,f=0),u+c>=2048)break;o.translate((i+(s>>1))/a,(u+(c>>1))/a),n.rotate&&o.rotate(n.rotate*z),o.fillText(n.text,0,0),n.padding&&(o.lineWidth=2*n.padding,o.strokeText(n.text,0,0)),o.restore(),n.width=s,n.height=c,n.xoff=i,n.yoff=u,n.x1=s>>1,n.y1=c>>1,n.x0=-n.x1,n.y0=-n.y1,n.hasText=!0,i+=s;}for(var v=o.getImageData(0,0,2048/a,2048/a).data,g=[];--e>=0;)if((n=r[e]).hasText){for(var b=(s=n.width)>>5,w=(c=n.y1-n.y0,0);w<c*b;w++)g[w]=0;if(null==(i=n.xoff))return;u=n.yoff;for(var M=0,k=-1,W=0;W<c;W++){for(w=0;w<s;w++){var S=v[2048*(u+W)+(i+w)<<2]?1<<31-w%32:0;g[b*W+(w>>5)]|=S,M|=S;}M?k=W:(n.y0++,c--,W--,u++);}n.y1=n.y0+k,n.sprite=g.slice(0,(n.y1-n.y0)*b);}}}function I(t,n,r){for(var e,o=t.sprite,a=t.width>>5,i=t.x-(a<<4),u=127&i,f=32-u,l=t.y1-t.y0,s=(t.y+t.y0)*(r>>=5)+(i>>5),c=0;c<l;c++){e=0;for(var h=0;h<=a;h++)if((e<<f|(h<a?(e=o[c*a+h])>>>u:0))&n[s+h])return !0;s+=r;}return !1}function q(t,n){var r=t[0],e=t[1];n.x+n.x0<r.x&&(r.x=n.x+n.x0),n.y+n.y0<r.y&&(r.y=n.y+n.y0),n.x+n.x1>e.x&&(e.x=n.x+n.x1),n.y+n.y1>e.y&&(e.y=n.y+n.y1);}function E(t){var n=t[0]/t[1];return function(t){return [n*(t*=.1)*Math.cos(t),t*Math.sin(t)]}}function C(){return document.createElement("canvas")}function D(t){return "function"==typeof t?t:function(){return t}}var F={archimedean:E,rectangular:function(t){var n=4*t[0]/t[1],r=0,e=0;return function(t){var o=t<0?-1:1;switch(Math.sqrt(1+4*o*t)-o&3){case 0:r+=n;break;case 1:e+=4;break;case 2:r-=n;break;default:e-=4;}return [r,e]}}};function P(t,n){return t[Math.floor(n()*t.length)]}function L(t){return t.size+"px"}function N(t){return t.text}function R(t){return "translate("+t.x+", "+t.y+")"+("number"==typeof t.rotate?"rotate("+t.rotate+")":"")}function U(t){var n,r=t.callbacks,e=t.maxWords,o=t.options,a=t.selection,u=t.size,f=o.deterministic,x=o.enableOptimizations,w=o.fontFamily,z=o.fontStyle,U=o.fontSizes,H=o.fontWeight,B=o.padding,G=o.randomSeed,J=o.rotations,K=o.rotationAngles,Q=o.spiral,V=o.scale,X=t.words.concat().sort(function(t,n){return c(t.value,n.value)}).slice(0,e),Y=seedrandom(f?G||"deterministic":null);(n=x?function(){var t=[256,256],n=k,r=W,e=O,o=S,a=S,i=T,u=j,f=E,l=[],s=Infinity,c=dispatch$1("word","end"),h=Math.random,d={},m=C,y=!1;function x(n,r,e){for(var o,a,i,u,l,s=r.x,c=r.y,d=Math.sqrt(t[0]*t[0]+t[1]*t[1]),m=f(t),y=h()<.5?1:-1,p=-y;(o=m(p+=y))&&(a=~~o[0],i=~~o[1],!(Math.min(Math.abs(a),Math.abs(i))>=d));)if(r.x=s+a,r.y=c+i,!(r.x+r.x0<0||r.y+r.y0<0||r.x+r.x1>t[0]||r.y+r.y1>t[1]||e&&I(r,n,t[0])||e&&!((u=r).x+u.x1>(l=e)[0].x&&u.x+u.x0<l[1].x&&u.y+u.y1>l[0].y&&u.y+u.y0<l[1].y))){for(var x,v=r.sprite,g=r.width>>5,b=t[0]>>5,w=r.x-(g<<4),M=127&w,z=32-M,k=r.y1-r.y0,W=(r.y+r.y0)*b+(w>>5),S=0;S<k;S++){x=0;for(var O=0;O<=g;O++)n[W+O]|=x<<z|(O<g?(x=v[S*g+O])>>>M:0);W+=b;}return delete r.sprite,!0}return !1}return d.canvas=function(t){return arguments.length?(m=D(t),d):m},d.start=function(){var f=function(t){t.width=t.height=1;var n=Math.sqrt(t.getContext("2d").getImageData(0,0,1,1).data.length>>2);t.width=2048/n,t.height=2048/n;var r=t.getContext("2d");return r.fillStyle=r.strokeStyle="red",r.textAlign="center",{context:r,ratio:n}}(m()),s=new Uint32Array((t[0]>>5)*t[1]),p=null,v=[],g=l.map(function(t,f){return t.text=n.call(this,t,f),t.font=r.call(this,t,f),t.style=o.call(this,t,f),t.weight=a.call(this,t,f),t.rotate=i.call(this,t,f),t.size=~~e.call(this,t,f),t.padding=u.call(this,t,f),t}).sort(function(t,n){return n.size-t.size});return setTimeout(function(){return function n(r){var e=50*r,o=Math.min(50*(r+1),l.length);!function(n,r){for(var e=n;e<r;e+=1){var o=g[e];o.x=t[0]*(h()+.5)>>1,o.y=t[1]*(h()+.5)>>1,A(f,o,g,e),o.hasText&&x(s,o,p)&&(v.push(o),c.call("word",d,o),p?q(p,o):p=[{x:o.x+o.x0,y:o.y+o.y0},{x:o.x+o.x1,y:o.y+o.y1}],o.x-=t[0]>>1,o.y-=t[1]>>1);}}(e,o),y||(o<l.length?setTimeout(function(){return n(r+1)},0):(d.stop(),c.call("end",d,v,p)));}(0)},0),d},d.revive=function(){return y=!1,d},d.stop=function(){return y=!0,d},d.timeInterval=function(t){return arguments.length?(s=null==t?Infinity:t,d):s},d.words=function(t){return arguments.length?(l=t,d):l},d.size=function(n){return arguments.length?(t=[+n[0],+n[1]],d):t},d.font=function(t){return arguments.length?(r=D(t),d):r},d.fontStyle=function(t){return arguments.length?(o=D(t),d):o},d.fontWeight=function(t){return arguments.length?(a=D(t),d):a},d.rotate=function(t){return arguments.length?(i=D(t),d):i},d.text=function(t){return arguments.length?(n=D(t),d):n},d.spiral=function(t){return arguments.length?(f=F[t]||t,d):f},d.fontSize=function(t){return arguments.length?(e=D(t),d):e},d.padding=function(t){return arguments.length?(u=D(t),d):u},d.random=function(t){return arguments.length?(h=t,d):h},d.on=function(){var t=c.on.apply(c,arguments);return t===c?d:t},d}():d3Cloud()).size(u).padding(B).words(d(X)).rotate(function(){return void 0===J?30*(~~(6*Y())-3):function(t,n,r){if(t<1)return 0;var e=[];if(1===t)e=[n[0]];else {e=[].concat(n);for(var o=(n[1]-n[0])/(t-1),a=n[0]+o;a<n[1];)e.push(a),a+=o;}return P(e,r)}(J,K,Y)}).spiral(Q).random(Y).text(N).font(w).fontStyle(z).fontWeight(H),function t(e,u){void 0===u&&(u=1),x&&n.revive(),n.fontSize(function(t){return function(t,n,r){var e,o=min(t,function(t){return Number(t.value)}),a=max(t,function(t){return Number(t.value)});switch(r){case"log":e=log;break;case"sqrt":e=sqrt;break;case"linear":default:e=linear;}return e().domain([o,a]).range(n)}(X,e,V)(t.value)}).on("end",function(n){if(X.length!==n.length&&u<=10){10===u&&console.warn("Unable to layout "+(X.length-n.length)+" word(s) after "+u+" attempts.  Consider: (1) Increasing the container/component size. (2) Lowering the max font size. (3) Limiting the rotation angles.");var f=Math.max(.95*e[0],1);t([f,Math.max(.95*e[1],f)],u+1);}else !function(t){var n,r=t.callbacks,e=t.options,o=t.random,a=t.words,u=r.getWordColor,f=r.getWordTooltip,l=r.onWordClick,s=r.onWordMouseOver,c=r.onWordMouseOut,h=e.colors,d=e.enableTooltip,m=e.fontStyle,p=e.fontWeight,x=e.textAttributes,v=e.tooltipOptions,g=e.fontFamily,b=e.transitionDuration;function w(t){return u?u(t):P(h,o)}t.selection.selectAll("text").data(a).join(function(t){var r=t.append("text").on("click",function(t){l&&l(t,event);}).on("mouseover",function(t){d&&(n=tippy(event.target,M({animation:"scale",arrow:!0,content:function(){return f(t)}},v))),s&&s(t,event);}).on("mouseout",function(t){n&&n.destroy(),c&&c(t,event);}).attr("cursor",l?"pointer":"default").attr("fill",w).attr("font-family",g).attr("font-style",m).attr("font-weight",p).attr("text-anchor","middle").attr("transform","translate(0, 0) rotate(0)");"object"==typeof x&&Object.keys(x).forEach(function(t){r=r.attr(t,x[t]);}),r=r.call(function(t){return t.transition().duration(b).attr("font-size",L).attr("transform",R).text(N)});},function(t){t.transition().duration(b).attr("fill",w).attr("font-family",g).attr("font-size",L).attr("transform",R).text(N);},function(t){t.transition().duration(b).attr("fill-opacity",0).remove();});}({callbacks:r,options:o,random:Y,selection:a,words:n});}).start();}(U);}var H={getWordTooltip:function(t){return t.text+" ("+t.value+")"}},B={colors:f(20).map(function(t){return t.toString()}).map(ordinal(w)),deterministic:!1,enableOptimizations:!1,enableTooltip:!0,fontFamily:"times new roman",fontSizes:[4,32],fontStyle:"normal",fontWeight:"normal",padding:1,rotationAngles:[-90,90],scale:"sqrt",spiral:"rectangular",tooltipOptions:{},transitionDuration:600};function G(i){var f=i.callbacks,l=i.maxWords,s=void 0===l?100:l,c=i.minSize,h=i.options,d=i.size,m=i.words,y=function(t,n){if(null==t)return {};var r,e,o={},a=Object.keys(t);for(e=0;e<a.length;e++)n.indexOf(r=a[e])>=0||(o[r]=t[r]);return o}(i,["callbacks","maxWords","minSize","options","size","words"]),p=M({},H,f),x=M({},B,h),v=function(t,n,i){var f=useRef(),l=useState(n),s=l[0],c=l[1],h=useState(null),d=h[0],m=h[1];return useEffect(function(){var r=f.current,e=a(r).append("svg").style("display","block");"object"==typeof i&&Object.keys(i).forEach(function(t){e=e.attr(t,i[t]);});var o=e.append("g");function l(t,n){e.attr("height",n).attr("width",t),o.attr("transform","translate("+t/2+", "+n/2+")"),c([t,n]);}m(o);var s=0,h=0;void 0===n?(s=r.parentElement.offsetWidth,h=r.parentElement.offsetHeight):(s=n[0],h=n[1]),l(s=Math.max(s,t[0]),h=Math.max(h,t[1]));var d=new index(function(t){if(t&&0!==t.length&&void 0===n){var r=t[0].contentRect;l(r.width,r.height);}});return d.observe(r),function(){d.unobserve(r),a(r).selectAll("*").remove();}},[n,t,i]),[f,d,s]}(c,d,h.svgAttributes),g=v[0],b=v[1],w=v[2],z=useRef(lodash_debounce(U,100));return useEffect(function(){b&&z.current({callbacks:p,maxWords:s,options:x,selection:b,size:w,words:m});},[s,p,x,b,w,m]),React__default.createElement("div",M({ref:g,style:{height:"100%",width:"100%"}},y))}G.defaultProps={callbacks:H,maxWords:100,minSize:[300,300],options:B};

var createTooltip = function (word, value) {
    var tooltipEl = document.createElement('div');
    Object.assign(tooltipEl.style, {
        'background-color': 'rgba(0,0,0,0.8)',
        'border-radius': '6px',
        padding: '6px',
        opacity: 1,
        'font-family': theme.typography.fontFamily
    });
    var span = document.createElement('span');
    Object.assign(span.style, {
        color: '#fff'
    });
    span.append("".concat(word, " (").concat(value, ")"));
    tooltipEl.append(span);
    return tooltipEl;
};
var WordCloudChart = function (props) {
    var data = props.data;
    var theme = useTheme();
    var getValueForWord = function (word) { var _a; return (_a = data.words.find(function (w) { return w.text === word; })) === null || _a === void 0 ? void 0 : _a.value; };
    var wordCloudOptions = __assign$3({ fontFamily: theme.typography.fontFamily, fontSizes: [12, 64], colors: [additionalPalette.liveBlue.main, additionalPalette.darkBlue.main], rotations: 0, padding: 5, tooltipOptions: {
            content: function (ref) {
                return createTooltip(ref.textContent, getValueForWord(ref.textContent));
            }
        } }, data.options);
    return jsx$1(G, { options: wordCloudOptions, words: data.words });
};

var useStyles$7 = makeStyles()(function (theme) { return ({
    equalIcon: {
        color: additionalPalette.lightGrey.main
    },
    listItem: {
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.75)
    },
    inputStyle: {
        '& .Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.primary
        },
        '& input.MuiInputBase-input': {
            padding: theme.spacing(1.25, 2),
            fontSize: theme.typography.subtitle2.fontSize,
            color: theme.palette.text.secondary
        },
        borderRadius: theme.spacing(0.25)
    },
    inputRootStyle: {
        '&.MuiOutlinedInput-root > fieldset': {
            borderColor: additionalPalette.lightBlue.secondary
        },
        '&.MuiOutlinedInput-root:hover > fieldset': {
            borderColor: additionalPalette.lightBlue.secondary
        },
        '&.MuiOutlinedInput-root.Mui-disabled > fieldset': {
            borderColor: additionalPalette.lightBlue.secondary
        },
        '&.MuiOutlinedInput-root.Mui-focused > fieldset': {
            borderColor: additionalPalette.lightBlue.secondary,
            borderWidth: 1
        }
    }
}); });

var ListItemQuota = function (props) {
    var _a = props.questionText, questionText = _a === void 0 ? '' : _a, _b = props.disableGutters, disableGutters = _b === void 0 ? false : _b, onQuotaChange = props.onQuotaChange, _c = props.defaultQuotaValue, defaultQuotaValue = _c === void 0 ? '0' : _c, totalCompletes = props.totalCompletes;
    var classes = useStyles$7().classes;
    var _d = useTextStyles(), textClasses = _d.classes, classNames = _d.cx;
    var calculateTotalCompletes = function (completes, percentage) {
        return Math.round((completes * percentage + Number.EPSILON) / 100);
    };
    var TOOLTIP_CHARACTERS = 120;
    var textTooltip = questionText.length > TOOLTIP_CHARACTERS ? questionText : '';
    return (jsx$1(ListItem$1, __assign$3({ disableGutters: disableGutters, className: classes.listItem }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "row", alignItems: "center" }, { children: [jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 9, direction: "row", alignItems: "center", justifyContent: "space-evenly" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 11 }, { children: jsx$1(Tooltip$3, __assign$3({ title: textTooltip, placement: "top-start" }, { children: jsx$1(OutlinedInput$1, { value: questionText, fullWidth: true, disabled: true, className: classes.inputRootStyle, classes: {
                                        root: classes.inputStyle
                                    } }) })) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 1, className: classes.equalIcon, justifyContent: "center" }, { children: jsx$1(DragHandle, {}) }))] })), jsxs(Grid$2, __assign$3({ container: true, item: true, direction: "row", justifyContent: "center", xs: 2 }, { children: [jsx$1(Grid$2, __assign$3({ item: true, xs: 7 }, { children: jsx$1(PercentageInput, { value: defaultQuotaValue, defaultValue: defaultQuotaValue, onChange: onQuotaChange }) })), jsx$1(Grid$2, { item: true, xs: 5 })] })), jsxs(Grid$2, __assign$3({ container: true, item: true, justifyContent: "center", xs: 1 }, { children: [jsx$1(Grid$2, __assign$3({ container: true, justifyContent: "center", item: true, xs: 7 }, { children: jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses.sizeM) }, { children: calculateTotalCompletes(totalCompletes, parseFloat(defaultQuotaValue)) })) })), jsx$1(Grid$2, { item: true, xs: 5 })] }))] })) })));
};

var useStyles$6 = makeStyles()(function (theme, _a) {
    var props = _a.styleProps;
    var palette = theme.palette, typography = theme.typography;
    var questionTitle = {
        fontFamily: typography.fontFamily,
        fontSize: typography.body1.fontSize,
        fontWeight: typography.fontWeightRegular,
        color: palette.text.secondary,
        margin: 0,
        lineHeight: 1.5
    };
    return {
        listItem: {
            backgroundColor: additionalPalette.lightBlue.main,
            borderRadius: "".concat(theme.spacing(2.75), " 0px 0px ").concat(theme.spacing(2.75)),
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(0),
            marginTop: theme.spacing(0.75),
            marginBottom: theme.spacing(0.75)
        },
        listItemDragging: {
            backgroundColor: theme.palette.background.default,
            borderRadius: "".concat(theme.spacing(2.75), " 0px 0px ").concat(theme.spacing(2.75)),
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(0),
            '& svg': {
                color: additionalPalette.lightGrey.main
            }
        },
        draggableDiv: {
            width: '100%',
            borderRadius: "".concat(theme.spacing(2.75), " 0px 0px ").concat(theme.spacing(2.75)),
            backgroundColor: (props === null || props === void 0 ? void 0 : props.isSelected)
                ? theme.palette.background.default
                : additionalPalette.transparent,
            '&:hover': {
                backgroundColor: theme.palette.background.default
            },
            '&:focus': {
                outline: 0
            }
        },
        nonDraggableDiv: {
            width: '100%',
            borderRadius: "".concat(theme.spacing(2.75), " 0px 0px ").concat(theme.spacing(2.75)),
            backgroundColor: (props === null || props === void 0 ? void 0 : props.isSelected)
                ? theme.palette.background.default
                : additionalPalette.transparent,
            '&:hover': {
                backgroundColor: theme.palette.background.default,
                cursor: 'pointer'
            },
            '&:focus': {
                outline: 0
            }
        },
        dragHandle: {
            color: additionalPalette.lightBlue.main
        },
        infoContainer: {
            width: '100%',
            padding: theme.spacing(1.5, 0, 1.5, 2.25)
        },
        icon: {
            color: theme.palette.error.main
        },
        questionTitle: questionTitle,
        questionNumber: __assign$3(__assign$3({}, questionTitle), { fontWeight: typography.fontWeightMedium, color: palette.text.secondary }),
        questionItemError: {
            color: palette.error.main
        },
        questionItemSelected: {
            color: palette.secondary.main
        }
    };
});

var ListItemSidebar = function (props) {
    var _a, _b;
    var _c = props.index, index = _c === void 0 ? 0 : _c, _d = props.questionNumber, questionNumber = _d === void 0 ? '' : _d, _e = props.questionTitle, questionTitle = _e === void 0 ? '' : _e, _f = props.canBeReordered, canBeReordered = _f === void 0 ? false : _f, _g = props.draggableId, draggableId = _g === void 0 ? '' : _g, isSelected = props.isSelected, _h = props.isError, isError = _h === void 0 ? false : _h, onClickItem = props.onClickItem;
    var styleProps = { isSelected: isSelected };
    var _j = useStyles$6({ styleProps: styleProps }), classes = _j.classes, classNames = _j.cx;
    var draggableList = (jsx$1(PublicDraggable, __assign$3({ isDragDisabled: !canBeReordered, draggableId: draggableId, index: index }, { children: function (provided, snapshot) {
            var _a, _b;
            return (jsx$1(ListItem$1, __assign$3({}, provided.draggableProps, { ref: provided.innerRef, disableGutters: true, className: snapshot.isDragging ? classes.listItemDragging : classes.listItem }, { children: jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, onClick: onClickItem }, provided.dragHandleProps, { className: classes.draggableDiv }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 10, alignItems: "center", direction: "row", className: classes.infoContainer }, { children: jsxs(Grid$2, __assign$3({ container: true, alignItems: "flex-start" }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 2 }, { children: jsx$1("p", __assign$3({ className: classNames(classes.questionNumber, (_a = {},
                                                _a[classes.questionItemSelected] = !isError && isSelected,
                                                _a[classes.questionItemError] = isError,
                                                _a)) }, { children: questionNumber })) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 10 }, { children: jsx$1("p", __assign$3({ className: classNames(classes.questionTitle, (_b = {},
                                                _b[classes.questionItemSelected] = isSelected,
                                                _b)) }, { children: questionTitle })) }))] })) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 1, alignItems: "center" }, { children: isError && (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto" }, { children: jsx$1(Icon, { className: classes.icon, name: IconName.InfoOutlinedIcon, iconColor: IconColor$1.Error, size: IconSize$1.Medium }) }))) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 1, alignItems: "center" }, { children: jsx$1(Icon, { iconColor: IconColor$1.Disabled, name: IconName.DragIndicator, size: IconSize$1.Large, className: classes.dragHandle }) }))] })) })));
        } })));
    var nonDraggableList = (jsx$1(ListItem$1, __assign$3({ disableGutters: true, className: classes.listItem }, { children: jsxs(Grid$2, __assign$3({ container: true, item: true, xs: 12, onClick: onClickItem, className: classes.nonDraggableDiv }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 10, alignItems: "center", direction: "row", className: classes.infoContainer }, { children: jsxs(Grid$2, __assign$3({ container: true, alignItems: "flex-start" }, { children: [jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 2 }, { children: jsx$1("p", __assign$3({ className: classNames(classes.questionNumber, (_a = {},
                                        _a[classes.questionItemSelected] = isSelected,
                                        _a)) }, { children: questionNumber })) })), jsx$1(Grid$2, __assign$3({ container: true, item: true, xs: 10 }, { children: jsx$1("p", __assign$3({ className: classNames(classes.questionTitle, (_b = {},
                                        _b[classes.questionItemSelected] = isSelected,
                                        _b)) }, { children: questionTitle })) }))] })) })), jsx$1(Grid$2, { item: true, xs: 2 })] })) })));
    return canBeReordered ? draggableList : nonDraggableList;
};

var BORDER_RADIUS = theme.spacing(0.25);
var useStyles$5 = makeStyles()(function (theme) { return ({
    arrowIconPrimary: {
        marginTop: "-".concat(theme.spacing(0.25)),
        color: theme.palette.primary.main
    },
    arrowIconSecondary: {
        marginTop: "-".concat(theme.spacing(0.25)),
        color: theme.palette.secondary.main
    },
    dropdownStyle: {
        borderRadius: BORDER_RADIUS,
        border: '1px solid',
        borderColor: additionalPalette.lightGrey.main,
        padding: 0,
        '& ul.MuiList-padding': {
            padding: 0
        }
    },
    select: {
        borderRadius: BORDER_RADIUS
    },
    selectFilled: {
        borderRadius: BORDER_RADIUS,
        backgroundColor: additionalPalette.lightBlue.main,
        '& fieldset': {
            border: 'none'
        }
    },
    notchedOutline: {
        borderColor: "".concat(additionalPalette.lightGrey.main, " !important")
    },
    menuItem: {
        minHeight: 0,
        paddingLeft: theme.spacing(1.25)
    },
    menuItemGrid: {
        marginRight: theme.spacing(5)
    },
    menuItemGridNoWhiteSpace: {
        marginRight: theme.spacing(1)
    },
    menuItemIcon: {
        paddingRight: theme.spacing(1)
    },
    outlinedInput: {
        '&.MuiOutlinedInput-input': {
            padding: theme.spacing(1, 0, 1, 1.25)
        }
    },
    selectBackground: {
        '&:focus': {
            backgroundColor: additionalPalette.transparent
        }
    },
    underlineStyle: {
        borderRadius: BORDER_RADIUS,
        border: '1px solid',
        borderColor: additionalPalette.lightGrey.main,
        padding: 0,
        '& ul.MuiList-padding': {
            padding: 0
        }
    },
    countryFlag: {
        marginTop: theme.spacing(0.25),
        paddingRight: theme.spacing(1)
    }
}); });

var img$24 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 7410 3900'%3e%3crect width='7410' height='3900' fill='%23b22234'/%3e%3cpath d='M0%2c450H7410m0%2c600H0m0%2c600H7410m0%2c600H0m0%2c600H7410m0%2c600H0' stroke='white' stroke-width='300'/%3e%3crect width='2964' height='2100' fill='%233c3b6e'/%3e%3cg fill='white'%3e%3cg id='s18'%3e%3cg id='s9'%3e%3cg id='s5'%3e%3cg id='s4'%3e%3cpath id='s' d='M247%2c90 317.534230%2c307.082039 132.873218%2c172.917961H361.126782L176.465770%2c307.082039z'/%3e%3cuse xlink:href='%23s' y='420'/%3e%3cuse xlink:href='%23s' y='840'/%3e%3cuse xlink:href='%23s' y='1260'/%3e%3c/g%3e%3cuse xlink:href='%23s' y='1680'/%3e%3c/g%3e%3cuse xlink:href='%23s4' x='247' y='210'/%3e%3c/g%3e%3cuse xlink:href='%23s9' x='494'/%3e%3c/g%3e%3cuse xlink:href='%23s18' x='988'/%3e%3cuse xlink:href='%23s9' x='1976'/%3e%3cuse xlink:href='%23s5' x='2470'/%3e%3c/g%3e%3c/svg%3e";

var img$23 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v30h60V0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M30 15h30v15zv15H0zH0V0zV0h30z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath d='M0 0v30h60V0z' fill='%23012169'/%3e%3cpath d='M0 0l60 30m0-30L0 30' stroke='white' stroke-width='6'/%3e%3cpath d='M0 0l60 30m0-30L0 30' clip-path='url(%23b)' stroke='%23C8102E' stroke-width='4'/%3e%3cpath d='M30 0v30M0 15h60' stroke='white' stroke-width='10'/%3e%3cpath d='M30 0v30M0 15h60' stroke='%23C8102E' stroke-width='6'/%3e%3c/g%3e%3c/svg%3e";

var img$22 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3e%3crect width='16' height='10' fill='%23006aa7'/%3e%3crect width='2' height='10' x='5' fill='%23fecc00'/%3e%3crect width='16' height='2' y='4' fill='%23fecc00'/%3e%3c/svg%3e";

var img$21 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3cdesc%3eFlag of Germany%3c/desc%3e%3crect id='black_stripe' width='5' height='3' y='0' x='0' fill='black'/%3e%3crect id='red_stripe' width='5' height='2' y='1' x='0' fill='%23D00'/%3e%3crect id='gold_stripe' width='5' height='1' y='2' x='0' fill='%23FFCE00'/%3e%3c/svg%3e";

var img$20 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 370 280'%3e%3crect width='370' height='280' fill='%23c60c30'/%3e%3crect width='40' height='280' x='120' fill='white'/%3e%3crect width='370' height='40' y='120' fill='white'/%3e%3c/svg%3e";

var img$1$ = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1800 1100'%3e%3crect width='1800' height='1100' fill='white'/%3e%3crect width='1800' height='300' y='400' fill='%23003580'/%3e%3crect width='300' height='1100' x='500' fill='%23003580'/%3e%3c/svg%3e";

var img$1_ = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3e%3crect width='1100' height='800' fill='%23ef2b2d'/%3e%3crect width='200' height='800' x='300' fill='white'/%3e%3crect width='1100' height='200' y='300' fill='white'/%3e%3crect width='100' height='800' x='350' fill='%23002868'/%3e%3crect width='1100' height='100' y='350' fill='%23002868'/%3e%3c/svg%3e";

var img$1Z = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3e%3cpath fill='%23c60b1e' d='M0 0h750v500H0z'/%3e%3cpath fill='%23ffc400' d='M0 125h750v250H0z'/%3e%3cg stroke='black' stroke-width='.39'%3e%3cg stroke-width='.26'%3e%3cpath fill='%23ad1519' stroke-linejoin='round' d='M167.99 222.24s-.51 0-.79-.16-1.13-.96-1.13-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.91.91-1.23 1.42-1.5.51-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.32 1.3-.32s.28-.16.56-.27c.29-.11.68-.11.91-.16.22-.06.79-.24 1.13-.26.52-.02 1.36.1 1.64.1s1.24.05 1.64.05c.39 0 1.8-.11 2.2-.11.39 0 .68-.05 1.13 0 .45.06 1.24.32 1.47.43s1.58.59 2.09.75 1.75.37 2.32.64c.56.27.91.72 1.19 1.1.28.37.34.78.45 1.05.11.26.11.84 0 1.11-.11.26-.51.81-.51.81l-.62 1.02-.79.64s-.57.54-1.02.48c-.45-.04-5.03-.86-7.97-.86s-7.64.86-7.64.86h.01z'/%3e%3cg fill='%23c8b100'%3e%3cellipse cx='175.66' cy='215.68' rx='1.38' ry='2.5'/%3e%3cellipse cx='175.68' cy='215.68' rx='.64' ry='2.3'/%3e%3cellipse cx='175.68' cy='213.04' rx='.93' ry='.87' stroke='none'/%3e%3cpath stroke-width='.3' d='M176.96 212.74v.58h-2.53v-.58h.94v-1.32h-.62v-.57h.62v-.57h.6v.57h.62v.57h-.62v1.32h.99'/%3e%3cpath fill='none' d='M175.94 212.2a.93.87 0 11-.5 0'/%3e%3cpath d='M175.68 222.08h-4.81l-.11-1.18-.23-1.23-.23-1.53c-1.33-1.75-2.55-2.9-2.96-2.65.1-.32.22-.56.47-.71 1.18-.7 3.61.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.82-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.41-.24-1.62.9-2.96 2.65l-.23 1.53-.23 1.23-.1 1.18h-4.84z'/%3e%3cpath fill='none' d='M167.55 215.44c.91-.53 3.02 1.14 4.73 3.74m11.55-3.74c-.91-.53-3.01 1.14-4.73 3.74'/%3e%3c/g%3e%3cg id='a' fill='%23c8b100'%3e%3cpath d='M168.58 224.25c-.2-.57-.58-1.08-.58-1.08 1.95-.57 4.66-.93 7.67-.94 3.01.01 5.75.37 7.69.94 0 0-.22.38-.52.91-.17.3-.39.81-.38.81-1.75-.54-4.02-.81-6.8-.82-2.79.01-5.46.35-6.86.86.02 0-.1-.32-.23-.68h.01'/%3e%3cpath d='M175.67 226.73c2.43-.01 5.11-.38 6.1-.63.66-.2 1.05-.49.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.71-.8-2.63 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.64.98.84.99.25 3.68.62 6.11.63zm7.81-4.65l-.59-.53s-.57.34-1.28.24c-.7-.11-.93-.97-.93-.97s-.79.67-1.44.62c-.65-.06-1.07-.62-1.07-.62s-.71.51-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72-1.47-.62-1.47-.62-.45.73-.99.92c-.54.18-1.24-.27-1.24-.27s-.12.27-.2.43-.31.19-.31.19l.18.47c1.93-.56 4.56-.91 7.53-.91s5.67.35 7.61.92l.2-.54h-.01z'/%3e%3cpath d='M175.69 219.49l.28.05c-.05.12-.06.24-.06.38 0 .58.5 1.05 1.12 1.05.49 0 .91-.31 1.06-.73.01.01.11-.38.15-.38.03 0 .03.41.05.41.07.53.55.89 1.1.89.62 0 1.11-.47 1.11-1.06 0-.04 0-.08-.01-.12l.35-.35.19.44c-.07.14-.1.29-.1.46 0 .56.47 1.01 1.06 1.01.37 0 .69-.18.88-.45l.23-.29v.36c0 .34.14.66.49.71 0 0 .38.03.91-.38.52-.41.8-.75.8-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.31-.95.25-.32-.05-.55-.31-.67-.61-.23.14-.51.22-.8.22-.63 0-1.2-.35-1.42-.86-.29.31-.69.5-1.16.5-.51 0-.97-.23-1.26-.58-.28.27-.67.43-1.09.43-.55 0-1.05-.28-1.33-.69-.29.41-.78.69-1.34.69-.42 0-.81-.16-1.09-.43-.29.35-.75.58-1.25.58-.48 0-.88-.19-1.17-.5-.22.51-.79.86-1.42.86-.29 0-.56-.08-.79-.22-.12.3-.35.56-.68.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.29.34.81.75.91.38.91.38c.34-.05.49-.37.49-.71v-.36l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.89.89 0 00-.1-.46l.19-.44.35.35c-.01.04-.01.08-.01.12 0 .59.49 1.06 1.11 1.06.55 0 1.03-.36 1.11-.89.01 0 .01-.41.04-.41.05 0 .14.39.16.38.14.42.56.73 1.06.73.61 0 1.11-.47 1.11-1.05 0-.14 0-.26-.05-.38l.29-.05h.01z'/%3e%3cpath stroke-linejoin='round' d='M175.67 222.23c-3.01.01-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.98 7.82-.98s5.88.38 7.83.98c.13.04.22.19.18.32-.04.11-.2.21-.33.17-1.95-.57-4.67-.93-7.68-.94z'/%3e%3cpath d='M165.43 221c-.01.01-.38-.48-.65-.73-.2-.18-.68-.33-.68-.33 0-.08.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.35.32c.12.29.05.72.05.72s-.05.2-.14.3zm1.89-.78l-.11.66-1.4.15-.21-.12.04-.23 1.06-.87.62.41'/%3e%3cpath d='M165.45 220.75c.12-.12.36-.09.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5zm2.57.13c-.06-.18 0-.37.13-.42.14-.03.3.09.37.27.06.19 0 .38-.14.42-.13.04-.29-.08-.36-.27zm.65-.84l.51.48 1.22-.66.09-.21-.17-.17-1.4-.12-.25.68'/%3e%3cpath d='M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32'/%3e%3cpath d='M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.22 1.22-.64.52.52'/%3e%3cellipse cx='170.51' cy='219.65' rx='.49' ry='.47'/%3e%3cpath d='M172.87 219.95c-.03-.2.07-.37.21-.39s.28.13.3.33c.03.19-.07.37-.21.38-.14.02-.28-.13-.3-.32zm.91-.71l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62'/%3e%3cpath d='M175.66 217.15l-.86.52.64 1.38.22.14.22-.14.64-1.38-.86-.52'/%3e%3cpath d='M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.39.62'/%3e%3cellipse cx='175.67' cy='219.21' rx='.49' ry='.47'/%3e%3cpath d='M178.5 219.95c.02-.2-.08-.37-.22-.39s-.28.13-.3.33c-.02.19.07.37.21.38.14.02.28-.13.31-.32zm.49-.65l.26.63 1.4-.13.18-.16-.1-.22-1.22-.64-.52.52'/%3e%3cpath d='M181.27 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32'/%3e%3cpath d='M182.68 220.04l-.51.48-1.22-.66-.1-.21.19-.17 1.4-.12.24.68'/%3e%3cellipse cx='180.85' cy='219.65' rx='.49' ry='.47'/%3e%3cpath d='M183.34 220.88c.06-.18 0-.37-.13-.42-.14-.03-.3.09-.37.27-.06.19 0 .38.14.42.13.04.29-.08.36-.27zm2.39.12c.01.01.38-.48.66-.73.19-.18.67-.33.67-.33 0-.08-.28-.28-.58-.28-.18 0-.35.07-.45.2l-.04-.2s-.24.05-.36.32c-.11.29-.03.72-.03.72s.04.2.13.3zm-1.89-.78l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41'/%3e%3cpath d='M185.74 220.75c-.11-.12-.35-.09-.53.06s-.24.38-.12.5c.12.13.36.1.54-.06.18-.15.23-.38.11-.5z'/%3e%3c/g%3e%3cg id='b' fill='none'%3e%3cpath fill='%23ad1519' d='M168.05 224.3l.31-.5.65.13-.38.56-.58-.19'/%3e%3cpath fill='%23058e6e' d='M170.85 223.81l-.69.11c-.18.02-.35-.09-.38-.26a.32.32 0 01.27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11'/%3e%3cellipse fill='white' cx='173.19' cy='223.3' rx='.44' ry='.41'/%3e%3cpath fill='%23ad1519' d='M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31s.14-.31.32-.31h1.96c.19 0 .33.14.33.31s-.15.31-.33.31h-.99'/%3e%3cellipse fill='white' cx='178.16' cy='223.3' rx='.44' ry='.41'/%3e%3cpath fill='%23058e6e' d='M180.5 223.81l.69.11c.18.02.35-.09.38-.26a.313.313 0 00-.27-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.37.25a.3.3 0 00.27.35l.71.11'/%3e%3cpath fill='%23ad1519' d='M183.24 224.33l-.25-.53-.67.06.32.59.6-.12'/%3e%3cpath fill='%23ad1519' stroke-linejoin='round' d='M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.69 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.43-3.89.65-6.33.65z'/%3e%3cpath stroke-width='.01' d='M176.8 226.08v-1.16m-.58 1.2l.01-1.23m-.43 1.25v-1.26'/%3e%3cpath stroke-width='.02' d='M175.44 226.15v-1.27'/%3e%3cpath stroke-width='.03' d='M175.09 226.15v-1.27'/%3e%3cpath stroke-width='.04' d='M174.77 226.15v-1.27m-.33 1.27v-1.27'/%3e%3cpath stroke-width='.05' d='M174.16 226.15v-1.27'/%3e%3cpath stroke-width='.06' d='M173.61 226.08l-.01-1.15m.27 1.17v-1.21'/%3e%3cpath stroke-width='.07' d='M173.1 226.03v-1.06m.26 1.09l-.01-1.13'/%3e%3cpath stroke-width='.08' d='M172.42 225.97v-.93m.23.94V225m.23 1.02V225'/%3e%3cpath stroke-width='.09' d='M172.19 225.96v-.9'/%3e%3cpath stroke-width='.1' d='M171.97 225.92v-.85'/%3e%3cpath stroke-width='.11' d='M171.73 225.89v-.78'/%3e%3cpath stroke-width='.12' d='M171.24 225.82l-.01-.62m.26.66v-.7m-.5.61v-.55'/%3e%3cpath stroke-width='.13' d='M170.76 225.73v-.46'/%3e%3cpath stroke-width='.14' d='M170.51 225.67v-.36'/%3e%3cpath stroke-width='.15' d='M170.26 225.64v-.27'/%3e%3cpath stroke-width='.18' d='M169.99 225.58v-.13'/%3e%3c/g%3e%3c/g%3e%3cg id='c'%3e%3cg fill='%23005bbf'%3e%3cpath d='M191.28 330.68c-1.54 0-2.91-.33-3.93-.87-1-.51-2.36-.82-3.86-.82-1.51 0-2.9.32-3.91.83-1.01.53-2.4.86-3.92.86-1.54 0-2.92-.36-3.93-.9-1-.49-2.33-.79-3.79-.79-1.52 0-2.86.29-3.86.81-1.02.54-2.42.88-3.95.88v2.41c1.53 0 2.93-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.31 3.79.8 1.01.53 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1.01-.52 2.4-.84 3.91-.84 1.5 0 2.86.32 3.86.83 1.02.54 2.37.87 3.91.87l.02-2.41z'/%3e%3cpath fill='%23ccc' d='M191.28 333.09c-1.54 0-2.91-.33-3.93-.87-1-.51-2.36-.83-3.86-.83-1.51 0-2.9.32-3.91.84-1.01.53-2.4.86-3.92.86-1.54 0-2.92-.37-3.93-.9-1-.49-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v2.41c1.53 0 2.93-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.31 3.79.8 1.01.54 2.39.9 3.93.9 1.52 0 2.91-.34 3.92-.86s2.4-.84 3.91-.84c1.5 0 2.86.32 3.86.84 1.02.53 2.37.86 3.91.86l.02-2.41'/%3e%3cpath d='M191.28 335.5c-1.54 0-2.91-.33-3.93-.86-1-.52-2.36-.84-3.86-.84-1.51 0-2.9.32-3.91.84s-2.4.86-3.92.86c-1.54 0-2.92-.36-3.93-.9-1-.49-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v2.4c1.53 0 2.93-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1.01.54 2.39.89 3.93.89 1.52 0 2.91-.32 3.92-.85 1.01-.52 2.4-.83 3.91-.83 1.5 0 2.86.31 3.86.82 1.02.55 2.37.86 3.91.86l.02-2.4'/%3e%3cpath fill='%23ccc' d='M191.26 340.32c-1.54 0-2.89-.33-3.91-.87-1-.51-2.36-.82-3.86-.82-1.51 0-2.9.31-3.91.83s-2.4.86-3.92.86c-1.54 0-2.92-.37-3.93-.9-1-.5-2.33-.79-3.79-.79-1.52 0-2.86.29-3.86.81-1.02.53-2.42.88-3.95.88v-2.4c1.53 0 2.93-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1.01.54 2.39.89 3.93.89 1.52 0 2.91-.32 3.92-.85 1.01-.52 2.4-.83 3.91-.83 1.5 0 2.86.31 3.86.82 1.02.55 2.39.86 3.93.86l-.02 2.42'/%3e%3cpath d='M191.26 342.73c-1.54 0-2.89-.33-3.91-.86-1-.52-2.36-.84-3.86-.84-1.51 0-2.9.32-3.91.84s-2.4.86-3.92.86c-1.54 0-2.92-.37-3.93-.9-1-.5-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v-2.39c1.53 0 2.93-.37 3.95-.9 1-.52 2.34-.81 3.86-.81 1.45 0 2.79.3 3.79.79 1.01.53 2.39.9 3.93.9 1.52 0 2.91-.34 3.92-.86s2.4-.83 3.91-.83c1.5 0 2.86.31 3.86.82 1.02.54 2.38.87 3.93.87l-.02 2.41z'/%3e%3c/g%3e%3cg fill='%23c8b100'%3e%3cpath stroke-linejoin='round' d='M166.92 320.78c.05.21.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.09-.62-.13.05-.29.06-.44.06h-16.69c-.13 0-.29-.02-.41-.06z'/%3e%3cpath d='M167.33 319.27h16.69c.57 0 1.02.35 1.02.78s-.45.79-1.02.79h-16.69c-.56 0-1.02-.36-1.02-.79s.46-.78 1.02-.78zm-3.06 10.59h22.87v-5.83h-22.87v5.83z'/%3e%3c/g%3e%3cpath fill='%23ccc' d='M167.55 318.32h16.25v-79.63h-16.25v79.63z'/%3e%3cpath fill='none' d='M179.13 238.8v79.46m1.83-79.46v79.46'/%3e%3cg fill='%23c8b100'%3e%3cpath d='M164.58 232.37h22.29v-5.84h-22.29v5.84z'/%3e%3cpath stroke-linejoin='round' d='M166.92 236.26a.91.91 0 01.41-.07h16.69c.17 0 .32.03.46.08-.58-.19-.99-.71-.99-1.32s.45-1.14 1.03-1.33c-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.09.02c.6.18.94.71.94 1.29 0 .56-.38 1.13-.97 1.31z'/%3e%3cpath d='M167.33 236.19h16.69c.57 0 1.02.35 1.02.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78zm0-3.82h16.7c.57 0 1.03.3 1.03.66 0 .37-.46.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z'/%3e%3c/g%3e%3c/g%3e%3cg id='d' fill='%23ad1519'%3e%3cpath d='M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.61.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-.9-3.56-2.34-4.64z'/%3e%3cpath stroke-linejoin='round' d='M200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39.02-5.04.25-7.79.7-9.72 1.63-17.13 5.51-16.54 8.67.01.06.04.2.05.26 0 0-3.64-8.21-3.7-8.52-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.69-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82'/%3e%3cpath d='M167.52 278.47c-4.51-.32-7.58-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79m16.31-6.09c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.11 5.67l.03-7.83'/%3e%3cpath stroke-linejoin='round' d='M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-.09-.17c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-.01z'/%3e%3c/g%3e%3cg stroke-width='.26'%3e%3cpath fill='%23ad1519' stroke-width='.27' d='M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.51-1.08.64c-.59.14-1.41-.66-1.41-.66s-.57.8-1.07.99c-.51.18-1.13-.24-1.13-.24s-.23.39-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.31-1.07c-.02-.16-.08-.57-.08-.57-.13-.65.87-1.4 2.3-1.72.82-.19 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.19.82.53-.16 1.24-.17 2.07.02 1.42.32 2.43 1.07 2.3 1.72 0 0-.06.41-.08.57-.03.16-.32 1.07-.32 1.07l-.62.24-.68.72-.58.38s-.3.14-.48.05c-.43-.21-.66-.61-.66-.61s-.62.42-1.13.24c-.51-.19-1.07-.99-1.07-.99s-.82.8-1.42.66c-.59-.13-1.07-.64-1.07-.64s-.68.59-1.21.49c-.54-.11-1.27-.89-1.27-.89z'/%3e%3cg fill='%23c8b100'%3e%3cellipse cx='324.82' cy='216.2' rx='1.38' ry='1.96'/%3e%3cellipse cx='324.85' cy='216.2' rx='.63' ry='1.81'/%3e%3cellipse cx='324.84' cy='213.95' rx='.93' ry='.88' stroke='none'/%3e%3cpath stroke-width='.3' d='M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.58h.62v-.58h.61v.58h.61v.58h-.61v1.3h.98'/%3e%3cpath fill='none' d='M325.11 213.12a.93.88 0 11-.51-.01'/%3e%3c/g%3e%3cg fill='none' stroke-width='.21'%3e%3cpath stroke-width='.26' stroke-linecap='round' d='M314.41 219.99c-.13-.33-.22-.7-.22-1.08 0-1.59 1.26-2.88 2.83-2.88.5 0 .96.13 1.37.37'/%3e%3cpath stroke-width='.26' d='M319.48 217.93c-.15-.26-.29-.54-.29-.84 0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45m6.69 2.5c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.19.17-1.64.45'/%3e%3cpath stroke-width='.26' stroke-linecap='round' d='M335.21 219.99c.13-.33.21-.7.21-1.08 0-1.59-1.26-2.88-2.82-2.88-.5 0-.97.13-1.38.37'/%3e%3cellipse cx='313.57' cy='218.68' rx='.45' ry='.43'/%3e%3cellipse cx='313.74' cy='217.1' rx='.45' ry='.43'/%3e%3cellipse cx='314.76' cy='215.9' rx='.45' ry='.43'/%3e%3cellipse cx='316.11' cy='215.25' rx='.45' ry='.43'/%3e%3cellipse cx='317.55' cy='215.31' rx='.45' ry='.43'/%3e%3cellipse fill='white' cx='318.43' cy='217.08' rx='.45' ry='.43'/%3e%3cellipse cx='318.68' cy='215.58' rx='.45' ry='.43'/%3e%3cellipse cx='319.81' cy='214.64' rx='.45' ry='.43'/%3e%3cellipse cx='321.23' cy='214.19' rx='.45' ry='.43'/%3e%3cellipse cx='322.67' cy='214.24' rx='.45' ry='.43'/%3e%3cellipse cx='326.94' cy='214.24' rx='.45' ry='.43'/%3e%3cellipse cx='328.39' cy='214.19' rx='.45' ry='.43'/%3e%3cellipse cx='329.8' cy='214.64' rx='.45' ry='.43'/%3e%3cellipse cx='330.93' cy='215.58' rx='.45' ry='.43'/%3e%3cellipse fill='white' cx='331.18' cy='217.08' rx='.45' ry='.43'/%3e%3cellipse cx='332.06' cy='215.31' rx='.45' ry='.43'/%3e%3cellipse cx='333.51' cy='215.25' rx='.45' ry='.43'/%3e%3cellipse cx='334.86' cy='215.9' rx='.45' ry='.43'/%3e%3cellipse cx='335.88' cy='217.1' rx='.45' ry='.43'/%3e%3cellipse cx='336.05' cy='218.68' rx='.45' ry='.43'/%3e%3c/g%3e%3cuse xlink:href='%23a' x='149.17'/%3e%3cuse xlink:href='%23b' x='149.17'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='149.17'/%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 500.57 0)'/%3e%3cpath d='M166.42 264.65c1.99-.72 3.29-1.58 2.66-3.14-.41-1-1.43-1.19-2.97-.63l-2.71.99 2.44 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.08-2.64v-.01zm-1.18-2.91l.69-.25c.57-.21 1.21.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43m7.54-2.52c-.29.08-.57.16-.86.22-.29.05-.59.09-.88.12l1.41 6.28 4.38-.88c-.05-.12-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.61.46-2.61.66l-1.26-5.61m8.78 5.41c.82-2.28 1.82-4.46 2.81-6.67-.18.03-.36.06-.54.07s-.37.01-.54 0c-.53 1.61-1.18 3.21-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.09-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.11 3.64 6.23.16-.03.32-.06.5-.08.16-.01.33.01.5.02m9.16-4.83c.15-.31.31-.6.48-.89-.24-.22-.96-.55-1.81-.63-1.79-.18-2.81.61-2.93 1.69-.26 2.26 3.31 2.07 3.14 3.57-.07.64-.75.9-1.48.83-.81-.08-1.41-.53-1.51-1.19l-.22-.02c-.12.39-.29.77-.48 1.15.53.34 1.21.53 1.85.59 1.83.19 3.22-.54 3.35-1.74.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02m119.58 5.18c.62-2.33 1.41-4.58 2.19-6.87-.17.05-.35.09-.53.11-.17.03-.36.04-.54.05-.37 1.64-.88 3.29-1.42 4.94-.96-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2s-.69.07-1.04.11c1.45 1.94 2.85 3.89 4.2 5.91.16-.04.32-.1.5-.12.16-.02.33-.02.49-.03m6.18-6.82c-.29.01-.59.04-.88.03-.3 0-.6-.04-.89-.06l-.12 6.41 4.49.08c-.03-.13-.06-.28-.06-.41s.04-.27.07-.4c-.81.05-1.68.1-2.71.08l.1-5.73m7.04 1.05c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.41.01-.13.06-.26.1-.39l-6.07-.5c.01.14.03.27.02.4-.01.14-.06.27-.1.4.62-.02 1.37-.02 2.21.05l-.53 5.77c.29 0 .59 0 .88.03.3.02.59.07.88.11l.53-5.77m2.49 6.32c.29.05.59.09.88.15.28.06.57.15.85.23l.72-2.94.08.01c.16.41.38.9.49 1.19l.9 2.22c.36.06.71.11 1.05.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-.99-2.01-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.68-1.53-.44-.31-1.28-.47-1.83-.6l-2.44-.53-1.54 6.29m3.14-5.42c.71.16 1.59.27 1.59 1.07-.01.21-.03.35-.06.48-.23.94-.94 1.26-2.13.91l.6-2.46m8.42 7.35c-.05.69-.18 1.37-.31 2.1.3.14.61.27.9.44.3.16.57.34.86.52l.6-7.23c-.14-.06-.27-.12-.41-.19-.13-.07-.25-.15-.37-.24l-6.38 4.05c.17.08.35.16.51.25.17.09.31.19.47.28.54-.45 1.1-.82 1.74-1.3l2.39 1.31v.01zm-1.81-1.66l2.13-1.37-.25 2.4-1.88-1.03' fill='%23c8b100' stroke='none'/%3e%3cpath fill='%23ad1519' stroke-width='.26' d='M249.65 182.72c6.64 0 12.56.99 16.41 2.51 2.2 1 5.16 1.73 8.4 2.17 2.47.33 4.81.39 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.21 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.79-2.25-2.61-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4c1.82-1.7 4.54-3.46 7.8-4.91 3.95-1.74 7.89-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24 3.24-.44 6.2-1.17 8.4-2.17 3.86-1.52 9.44-2.51 16.08-2.51z'/%3e%3cg fill='%23c8b100'%3e%3cpath d='M225.34 191.42l1.38 1.11 2.08-3.4c-2.25-1.38-3.8-3.78-3.8-6.51 0-.31.02-.61.06-.91.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86-2.43-1.42-5.6-2.28-9.05-2.28-7.71 0-13.74 4.39-14.03 9.57-.03.31-.05.61-.05.92 0 2.76 1.26 5.26 3.26 6.99l-1.1 1.81'/%3e%3cpath d='M225.43 191.46c-2.63-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.41-2.07 1.67-3.33 3.83-3.51 6.23-.03.31-.05.61-.05.92 0 2.76 1.26 5.26 3.26 6.99l-1.01 1.85'/%3e%3cpath d='M202.21 194.89c-1.48-1.65-2.38-3.79-2.38-6.12 0-1.41.33-2.75.91-3.95 2.13-4.38 8.82-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.36 2.83-15.12 6.65a7.33 7.33 0 00-.73 3.2c0 2.32 1.09 4.4 2.79 5.82l-2.63 4.3-1.41-1.12 1.81-2.88z'/%3e%3cpath d='M204.9 180.48c-1.91 1.21-3.36 2.69-4.16 4.34-.58 1.2-.91 2.54-.91 3.95 0 2.33.9 4.47 2.38 6.12l-1.6 2.59c-1.53-1.96-2.42-4.26-2.42-6.7 0-4.2 2.67-7.87 6.71-10.3zm45.14-9.21c1.76 0 3.28 1.16 3.64 2.73.23 1.38.38 2.95.41 4.62.01.18-.01.35-.01.52 0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.29-8.52 0-.2.04-.41.04-.61 0-.17-.01-.34-.01-.52.03-1.67.18-3.24.41-4.62.36-1.57 1.94-2.73 3.7-2.73z'/%3e%3cpath d='M250.04 172.94c.91 0 1.68.58 1.87 1.39.23 1.31.37 2.8.4 4.38 0 .16-.01.32-.01.48 0 .2.03.39.04.59.05 3.32.53 6.25 1.21 8.05l-3.54 3.35-3.54-3.35c.67-1.8 1.15-4.73 1.21-8.05 0-.2.04-.39.04-.59 0-.16-.01-.32-.01-.48.03-1.58.17-3.07.4-4.38.18-.81 1.02-1.39 1.93-1.39zm24.66 18.48l-1.39 1.11-2.08-3.4c2.26-1.38 3.81-3.78 3.81-6.51 0-.31-.02-.61-.06-.91-.21-4.34-5.5-7.92-12.2-7.92-3.49 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86 2.44-1.42 5.6-2.28 9.06-2.28 7.71 0 13.74 4.39 14.03 9.57.03.31.05.61.05.92 0 2.76-1.27 5.26-3.27 6.99l1.11 1.81'/%3e%3cpath d='M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.41 2.07 1.67 3.33 3.83 3.51 6.23.03.31.05.61.05.92 0 2.76-1.27 5.26-3.27 6.99l1.02 1.85'/%3e%3cpath d='M297.83 194.89c1.47-1.65 2.38-3.79 2.38-6.12 0-1.41-.33-2.75-.91-3.95-2.14-4.38-8.82-7.57-16.76-7.57-2.16 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.81-2.88z'/%3e%3cpath d='M295.14 180.48c1.91 1.21 3.36 2.69 4.16 4.34.58 1.2.91 2.54.91 3.95 0 2.33-.91 4.47-2.38 6.12l1.6 2.59c1.53-1.96 2.41-4.26 2.41-6.7 0-4.2-2.67-7.87-6.7-10.3z'/%3e%3cellipse fill='%23005bbf' stroke-width='.26' cx='250.05' cy='167.3' rx='4.43' ry='4.2'/%3e%3cpath stroke-width='.26' d='M248.89 155.54v2.26h-2.42v2.3h2.42v6.61h-3.05c-.03.21-.22.37-.22.59 0 .58.12 1.14.35 1.64 0 .02.02.02.03.03h8.12c0-.01.02-.01.03-.03.22-.5.35-1.06.35-1.64 0-.22-.19-.38-.22-.59h-2.96v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z'/%3e%3c/g%3e%3cg fill='white'%3e%3cellipse cx='250.04' cy='188.94' rx='1.91' ry='1.8'/%3e%3cellipse cx='250.04' cy='185.4' rx='1.91' ry='1.8'/%3e%3cellipse cx='250.04' cy='181.6' rx='1.52' ry='1.44'/%3e%3cellipse cx='250.04' cy='178.18' rx='1.1' ry='1.04'/%3e%3cellipse cx='250.04' cy='175.18' rx='.88' ry='.83'/%3e%3cellipse cx='198.94' cy='198.67' rx='1.1' ry='1.04'/%3e%3cellipse cx='197.44' cy='196.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='196.44' cy='192.94' rx='1.1' ry='1.04'/%3e%3cellipse cx='196.31' cy='189.64' rx='1.1' ry='1.04'/%3e%3cellipse cx='197.12' cy='186.4' rx='1.1' ry='1.04'/%3e%3cellipse cx='198.81' cy='183.45' rx='1.1' ry='1.04'/%3e%3cellipse cx='201.06' cy='181.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='203.68' cy='179.01' rx='1.1' ry='1.04'/%3e%3cellipse cx='206.8' cy='177.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='210.04' cy='176.19' rx='1.1' ry='1.04'/%3e%3cellipse cx='213.66' cy='175.54' rx='1.1' ry='1.04'/%3e%3cellipse cx='217.1' cy='175.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='220.47' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='224.21' cy='190.32' rx='1.1' ry='1.04'/%3e%3cellipse cx='222.34' cy='187.65' rx='1.1' ry='1.04'/%3e%3cellipse cx='221.35' cy='184.75' rx='1.1' ry='1.04'/%3e%3cellipse cx='221.47' cy='181.57' rx='1.1' ry='1.04'/%3e%3cellipse cx='222.16' cy='178.37' rx='1.1' ry='1.04'/%3e%3cellipse cx='223.84' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='226.4' cy='173.47' rx='1.1' ry='1.04'/%3e%3cellipse cx='229.39' cy='171.81' rx='1.1' ry='1.04'/%3e%3cellipse cx='232.7' cy='170.82' rx='1.1' ry='1.04'/%3e%3cellipse cx='236.13' cy='170.23' rx='1.1' ry='1.04'/%3e%3cellipse cx='239.5' cy='170.28' rx='1.1' ry='1.04'/%3e%3cellipse cx='242.99' cy='170.87' rx='1.1' ry='1.04'/%3e%3cellipse cx='246.23' cy='171.99' rx='1.1' ry='1.04'/%3e%3cellipse cx='253.8' cy='171.99' rx='1.1' ry='1.04'/%3e%3cellipse cx='257.04' cy='170.87' rx='1.1' ry='1.04'/%3e%3cellipse cx='260.54' cy='170.28' rx='1.1' ry='1.04'/%3e%3cellipse cx='263.9' cy='170.23' rx='1.1' ry='1.04'/%3e%3cellipse cx='267.34' cy='170.82' rx='1.1' ry='1.04'/%3e%3cellipse cx='270.64' cy='171.81' rx='1.1' ry='1.04'/%3e%3cellipse cx='273.64' cy='173.47' rx='1.1' ry='1.04'/%3e%3cellipse cx='276.19' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='277.88' cy='178.37' rx='1.1' ry='1.04'/%3e%3cellipse cx='278.57' cy='181.57' rx='1.1' ry='1.04'/%3e%3cellipse cx='278.69' cy='184.75' rx='1.1' ry='1.04'/%3e%3cellipse cx='277.69' cy='187.65' rx='1.1' ry='1.04'/%3e%3cellipse cx='275.83' cy='190.32' rx='1.1' ry='1.04'/%3e%3cellipse cx='279.57' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='282.94' cy='175.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='286.38' cy='175.54' rx='1.1' ry='1.04'/%3e%3cellipse cx='290' cy='176.19' rx='1.1' ry='1.04'/%3e%3cellipse cx='293.24' cy='177.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='296.36' cy='179.01' rx='1.1' ry='1.04'/%3e%3cellipse cx='298.97' cy='181.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='301.22' cy='183.45' rx='1.1' ry='1.04'/%3e%3cellipse cx='302.91' cy='186.4' rx='1.1' ry='1.04'/%3e%3cellipse cx='303.72' cy='189.64' rx='1.1' ry='1.04'/%3e%3cellipse cx='303.6' cy='192.94' rx='1.1' ry='1.04'/%3e%3cellipse cx='302.6' cy='196.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='301.1' cy='198.67' rx='1.1' ry='1.04'/%3e%3c/g%3e%3cg fill='%23c8b100'%3e%3cpath d='M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83-.57-.18-.87-.7-.84-1.25-.01-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.09-3.83 12.27.02 23.25 1.47 31.09 3.83.55.17.84.65.83 1.17.03.55-.27 1.07-.83 1.25-7.84 2.36-18.82 3.81-31.09 3.83'/%3e%3cpath d='M250.07 216.09c-12.41.03-23.55 1.58-31.39 4 .65-.31.59-1.12-.22-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.11-2.51 2.42-.81 2.08-.87 2.89-.21 3.2-7.84-2.42-19.19-3.97-31.6-4'/%3e%3cpath d='M250.12 210.3c-13.43.02-25.5 1.62-34.16 4.18-.58.17-1.19-.05-1.38-.6s.12-1.18.7-1.35c8.71-2.67 21.08-4.35 34.84-4.38 13.77.03 26.19 1.71 34.9 4.38.58.17.89.8.7 1.35s-.8.77-1.38.6c-8.67-2.56-20.78-4.16-34.22-4.18'/%3e%3cpath d='M250.2 199.78l1.23.22c-.19.5-.24 1.05-.24 1.63 0 2.57 2.21 4.65 4.92 4.65 2.18 0 4.04-1.35 4.67-3.21.08.05.47-1.68.68-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93 2.71 0 4.91-2.08 4.91-4.65 0-.19-.01-.38-.04-.57l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.69 4.44 1.63 0 3.06-.78 3.9-1.97l.99-1.25-.01 1.53c0 1.55.66 2.93 2.16 3.18 0 0 1.73.1 4.03-1.7 2.29-1.8 3.55-3.29 3.55-3.29l.2 1.8s-1.9 2.95-3.97 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.48-1.4-3.01-2.74-1.03.61-2.25.97-3.55.97-2.81 0-5.33-1.54-6.32-3.86-1.29 1.4-3.09 2.25-5.2 2.25-2.24 0-4.29-1.01-5.57-2.56a7.198 7.198 0 01-4.88 1.87c-2.48 0-4.69-1.22-5.94-3.05-1.25 1.83-3.46 3.05-5.94 3.05-1.89 0-3.61-.71-4.87-1.87-1.28 1.55-3.34 2.56-5.58 2.56-2.11 0-3.9-.85-5.19-2.25-1 2.32-3.52 3.86-6.32 3.86-1.31 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.02 2.74-1.36.22-3.08-.47-4.22-1.13-2.08-1.2-3.98-4.15-3.98-4.15l.2-1.8s1.27 1.49 3.56 3.29c2.29 1.81 4.02 1.7 4.02 1.7 1.51-.25 2.16-1.63 2.16-3.18l-.01-1.53.99 1.25c.84 1.19 2.28 1.97 3.9 1.97 2.59 0 4.69-1.98 4.69-4.44 0-.73-.13-1.42-.46-2.03l.83-1.94 1.54 1.52c-.02.19-.04.38-.04.57 0 2.57 2.2 4.65 4.91 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.71.67 1.66.64 1.86 2.49 3.21 4.68 3.21 2.71 0 4.91-2.08 4.91-4.65 0-.58-.03-1.13-.24-1.63l1.29-.22'/%3e%3cpath d='M208.37 206.32a2.24 2.24 0 00-.72-1.06c-.79-.68-1.84-.79-2.36-.25-.07.07-.13.17-.17.25 0 0-1.11-2.08-2.41-2.78-1.29-.7-3.49-.52-3.49-.52 0-1.6 1.3-2.89 2.99-2.89.99 0 1.92.41 2.48 1.11l.23-1.07s1.36.27 1.98 1.82-.06 3.8-.06 3.8.34-.96.85-1.61c.51-.64 1.81-1.34 2.49-1.66.67-.31 1.37-.79 1.37-.79s.03.18.05.61c.03.51-.01.83-.01.83 1.24-.17 2.69.04 3.83.48-.49.95-1.41 1.84-2.62 2.3 0 0 .44.36.83.75.34.34.44.49.44.49s-.85.13-1.27.19c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22'/%3e%3cpath fill='%23ad1519' d='M205.29 205.01c.52-.54 1.57-.43 2.36.25.8.67 1.02 1.66.51 2.19-.51.54-1.57.42-2.36-.25-.79-.68-1.02-1.66-.51-2.19'/%3e%3cpath fill='white' d='M216.39 205.91c-.28-.83-.03-1.65.57-1.83.6-.19 1.32.33 1.6 1.16s.03 1.65-.57 1.84c-.6.18-1.31-.34-1.6-1.17'/%3e%3cpath d='M226.12 201.86c-.33-.27-.59-.64-.67-1.08s.01-.87.23-1.23c0 0-.88-.44-1.83-.69-.72-.19-1.99-.2-2.37-.2-.38-.02-1.15-.03-1.15-.03s.07.17.28.55c.27.46.5.75.5.75-1.27.29-2.35 1.12-3.03 2.09.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61s.71-.26 1.07-.39c.35-.13 1.54-.55 2.15-.96.8-.54 1.48-1.25 1.48-1.25'/%3e%3cpath d='M225.68 191.65c1.06.67 1.98 1.79 2.3 3.03 0 0 .13-.25.71-.59.59-.33 1.09-.32 1.09-.32s-.17.97-.25 1.32c-.09.34-.09 1.38-.32 2.32-.23.93-.63 1.68-.63 1.68-.42-.34-.99-.51-1.58-.41-.58.1-1.06.44-1.32.9 0 0-.66-.58-1.21-1.38-.55-.81-.93-1.78-1.13-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32-.14-1.28.28-2.62 1.04-3.59'/%3e%3cpath d='M228.97 201.38a1.727 1.727 0 00-.42-2.3s.67-.71 1.47-1.26c.6-.41 1.8-.82 2.15-.95.36-.13 1.07-.4 1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.29 3.61.98-.69.97-1.77 1.79-3.04 2.08 0 0 .23.28.5.74.21.39.28.56.28.56l-1.15-.03c-.38 0-1.65-.01-2.37-.2-.95-.25-1.84-.69-1.84-.69'/%3e%3cellipse fill='%23ad1519' cx='227.37' cy='200.45' rx='2.17' ry='2.06'/%3e%3cpath fill='white' d='M237.76 201.77c-.11-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.62.07-1.22-.57-1.34-1.44'/%3e%3cpath d='M248.5 199.83c-.32-.36-.53-.82-.53-1.33 0-.5.19-.97.51-1.32 0 0-.89-.67-1.89-1.12-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93-1.47.08-2.85.81-3.81 1.76.96.94 2.34 1.66 3.81 1.75 0 0-.2.36-.4.93-.16.46-.2.67-.2.67l1.28-.24c.42-.08 1.83-.32 2.6-.67 1-.46 1.91-1.11 1.91-1.11'/%3e%3cpath d='M250.11 188.36c1.05.95 1.85 2.36 1.95 3.82 0 0 .19-.27.91-.53.73-.26 1.28-.16 1.28-.16s-.39 1.05-.55 1.42c-.17.37-.39 1.53-.84 2.53-.44 1-1.05 1.76-1.05 1.76-.4-.45-1-.75-1.67-.75-.68 0-1.27.3-1.67.75 0 0-.61-.76-1.05-1.76-.45-1-.67-2.16-.84-2.53s-.56-1.42-.56-1.42.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.89-3.82'/%3e%3cpath d='M251.76 199.83c.33-.36.53-.82.53-1.33 0-.5-.19-.97-.51-1.32 0 0 .89-.67 1.9-1.12.76-.35 2.17-.59 2.6-.67l1.26-.24s-.02.2-.19.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76-.95.94-2.33 1.66-3.81 1.75 0 0 .2.36.4.93.16.46.19.67.19.67l-1.26-.24c-.43-.08-1.84-.32-2.6-.67-1.01-.46-1.92-1.11-1.92-1.11'/%3e%3cellipse fill='%23ad1519' cx='250.14' cy='198.5' rx='2.17' ry='2.06'/%3e%3cpath fill='white' d='M262.58 201.77c.11-.87-.3-1.63-.93-1.7s-1.23.57-1.34 1.44c-.11.86.31 1.63.93 1.7.63.07 1.23-.57 1.34-1.44'/%3e%3cpath d='M271.38 201.38c-.22-.35-.32-.79-.25-1.23.09-.44.33-.81.67-1.07 0 0-.67-.71-1.47-1.26-.61-.41-1.8-.82-2.16-.95-.35-.13-1.06-.4-1.06-.4s-.01.18.06.61c.08.52.19.87.19.87-1.29-.14-2.61.29-3.6.98.68.97 1.77 1.79 3.03 2.08 0 0-.23.28-.49.74-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66-.01 2.37-.2.95-.25 1.84-.69 1.84-.69'/%3e%3cpath d='M274.67 191.65c-1.06.67-1.98 1.79-2.31 3.03 0 0-.12-.25-.71-.59-.58-.33-1.09-.32-1.09-.32s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.51 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.21-1.38.54-.81.92-1.78 1.12-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32.15-1.28-.28-2.62-1.03-3.59'/%3e%3cpath d='M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.83-.69.72-.19 1.99-.2 2.36-.2.39-.02 1.15-.03 1.15-.03s-.06.17-.28.55c-.26.46-.49.75-.49.75 1.26.29 2.34 1.12 3.03 2.09-.99.68-2.31 1.1-3.6.97 0 0 .11.34.19.86.06.43.06.61.06.61s-.71-.26-1.06-.39c-.36-.13-1.55-.55-2.16-.96-.79-.54-1.48-1.25-1.48-1.25'/%3e%3cellipse fill='%23ad1519' cx='272.98' cy='200.45' rx='2.17' ry='2.06'/%3e%3cpath fill='white' d='M283.96 205.91c.28-.83.03-1.65-.57-1.83-.6-.19-1.32.33-1.61 1.16-.28.83-.03 1.65.57 1.84.6.18 1.32-.34 1.61-1.17'/%3e%3cpath d='M291.97 206.32c.11-.37.36-.75.72-1.06.79-.68 1.85-.79 2.36-.25.07.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78s3.5-.52 3.5-.52c0-1.6-1.31-2.89-3-2.89-.99 0-1.92.41-2.47 1.11l-.23-1.07s-1.36.27-1.98 1.82.05 3.8.05 3.8-.33-.96-.84-1.61c-.51-.64-1.81-1.34-2.49-1.66-.68-.31-1.37-.79-1.37-.79s-.03.18-.06.61c-.02.51.02.83.02.83-1.25-.17-2.7.04-3.83.48.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.43.49-.43.49s.85.13 1.27.19c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22'/%3e%3cpath fill='%23ad1519' d='M295.05 205.01c-.51-.54-1.57-.43-2.36.25-.79.67-1.02 1.66-.51 2.19.51.54 1.57.42 2.36-.25.79-.68 1.02-1.66.51-2.19'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath fill='%23ad1519' stroke-linejoin='round' d='M250.12 224.57c-11.06-.01-21.07-1.29-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.19 11.07.02 21.13 1.22 28.74 3.19-7.61 1.97-17.67 3.25-28.74 3.26z'/%3e%3cpath stroke-width='.05' d='M258.04 224.28v-6.01m-3.02 6.21l.04-6.37m-2.24 6.45v-6.49'/%3e%3cpath stroke-width='.09' d='M250.95 224.64v-6.57'/%3e%3cpath stroke-width='.14' d='M249.16 224.64v-6.57'/%3e%3cpath stroke-width='.18' d='M247.48 224.64v-6.57'/%3e%3cpath stroke-width='.23' d='M245.81 224.64v-6.57'/%3e%3cpath stroke-width='.28' d='M244.32 224.64v-6.57'/%3e%3cpath stroke-width='.33' d='M241.48 224.28l-.04-5.97m1.39 6.05v-6.25'/%3e%3cpath stroke-width='.37' d='M238.86 224.01v-5.5m1.33 5.66l-.04-5.86'/%3e%3cpath stroke-width='.42' d='M235.35 223.7v-4.84m1.15 4.92v-5.08m1.19 5.24v-5.28'/%3e%3cpath stroke-width='.46' d='M234.12 223.66v-4.68'/%3e%3cpath stroke-width='.51' d='M232.97 223.42v-4.36'/%3e%3cpath stroke-width='.56' d='M231.74 223.31v-4.06'/%3e%3cpath stroke-width='.6' d='M229.22 222.95l-.04-3.22m1.33 3.38v-3.62'/%3e%3cpath stroke-width='.63' d='M227.93 222.68v-2.84'/%3e%3cpath stroke-width='.68' d='M226.74 222.45v-2.36'/%3e%3cpath stroke-width='.73' d='M225.45 222.13v-1.85'/%3e%3cpath stroke-width='.77' d='M224.12 221.98v-1.38'/%3e%3cpath stroke-width='.91' d='M222.72 221.66v-.67'/%3e%3cpath d='M220.12 221.66c7.75-2.18 18.29-3.52 30-3.54 11.72.02 22.31 1.36 30.06 3.54'/%3e%3cpath fill='%23ad1519' d='M216.72 217.16l1.22-1.59 3.37.43-2.69 1.96-1.9-.8'/%3e%3cpath fill='white' d='M224.03 215.28c0-.58.49-1.04 1.1-1.04s1.1.46 1.1 1.04c0 .57-.49 1.04-1.1 1.04s-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23058e6e' d='M233.64 215.07l-2.36.27c-.61.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9s-.36 1.09-.96 1.16l-2.41.28'/%3e%3cpath fill='white' d='M240.54 213.35c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23ad1519' d='M250.15 214.16h-3.29c-.6 0-1.11-.46-1.11-1.03 0-.58.49-1.04 1.1-1.04h6.64c.61 0 1.1.46 1.1 1.04 0 .57-.51 1.03-1.11 1.03h-3.33'/%3e%3cpath fill='white' d='M257.56 213.35c0-.58.5-1.04 1.1-1.04.61 0 1.1.46 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23058e6e' d='M266.66 215.07l2.36.27c.6.07 1.17-.33 1.24-.9s-.36-1.09-.96-1.15l-2.37-.28-2.42-.28c-.61-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28'/%3e%3cpath fill='white' d='M274.07 215.28c0-.58.49-1.04 1.1-1.04s1.1.46 1.1 1.04c0 .57-.49 1.04-1.1 1.04s-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23ad1519' d='M283.57 217.16l-1.21-1.59-3.37.43 2.69 1.96 1.89-.8'/%3e%3c/g%3e%3cg stroke-width='.52'%3e%3cpath fill='%23ccc' d='M250.49 344.33c-13.08 0-26.05-3.2-36.95-8.54-8.03-3.98-13.36-12-13.36-21.19v-33.3H300.6v33.3c0 9.19-5.32 17.21-13.36 21.19-10.9 5.34-23.66 8.54-36.75 8.54z'/%3e%3cpath fill='%23ffd691' d='M252.91 329.55c2.09.63 3.15 2.19 3.15 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.42-1.8-5.42-4.18 0-1.79 1-3.8 3.08-3.94 0 0-.06-.19-.24-.5-.22-.23-.64-.66-.64-.66s.79-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.79-.49c.37-.15.84-.26.84-.26s-.13.46-.22.69-.14.72-.14.72'/%3e%3cpath fill='%23058e6e' d='M250.32 340.32s-3.98-2.68-5.7-3.04c-2.21-.47-4.69-.09-5.76-.15.03.03 1.29.93 1.84 1.48s2.39 1.65 3.43 1.91c3.22.81 6.19-.2 6.19-.2m1.14.24s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.49-1.56.87-.55.37-1.97 1.57-4.14 1.59-2.18.03-4.58-.23-4.97-.17-.4.06-.98.15-.98.15'/%3e%3cpath fill='%23ad1519' d='M250.69 337.28c-1-.93-1.62-2.25-1.62-3.72 0-1.46.62-2.78 1.63-3.71a5.08 5.08 0 01-.01 7.43'/%3e%3cpath fill='%23058e6e' d='M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.39 1.16.39 2.17c0 1.02-.18 2.37-.18 2.37s-.55.08-.73.17c-.19.09-.8.29-.8.29'/%3e%3cg fill='%23c8b100'%3e%3cpath fill='%23ad1519' d='M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82s-25.15-10.66-25.15-23.82v-33.35h50.2v33.35'/%3e%3cpath d='M200.03 314.12c.15 7.02 2.95 12.25 5.73 15.67v-49.47h-5.66l-.07 33.8zm11.05 20.11c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19zm11.2 4.02c2.3.23 4.01.19 5.87 0v-58.21h-5.87v58.21zm11.04-1.25c2.3-.46 4.9-1.89 6.03-2.63v-54.33h-5.88l-.15 56.96zm11.49-7.76c2.45-2.18 4.75-7.12 5.59-12.76l.14-36.44h-5.87l.14 49.2z'/%3e%3c/g%3e%3cpath fill='%23ad1519' d='M300.65 281.22v33.35c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82v-33.35h50.33'/%3e%3cpath id='e' fill='%23c8b100' stroke='%23c8b100' stroke-width='.26' d='M272.71 306.14c.05-.14.12-.27.19-.4l-4.26-4.74-1.67.72-3.06-3.39 1-1.46-5.34-5.99c-.07.02-.2.02-.27.04l.03 4.02 1.75.5v4.46l-1.75.48-.03 4.08c.84.26 1.48.88 1.74 1.67l3.21.01.51-1.67h4.72l.5 1.67zm-6.98-18.5v1.61h2.76v-1.61zm-7.3 20.37c.64 0 1.16-.49 1.16-1.1s-.52-1.11-1.16-1.11c-.65 0-1.17.5-1.17 1.11s.52 1.1 1.17 1.1zm15.99-9.73l-1.76-.48v-4.46l1.76-.5-.01-1.92c-.85-.25-1.51-.87-1.79-1.67h-2.68l-.51 1.67h-4.71l-.51-1.67h-3.09c-.08.22-.17.42-.29.61l5.38 5.96 1.67-.71 3.06 3.4-1 1.45 4.18 4.64c.09-.04.18-.08.28-.12zm-7.25-1.39l-1.29 1.04 1.77 1.98 1.29-1.05zm8.004 36.186c-1.24-.065-2.255-.902-2.514-2.016-1.67-.23-3.25-.66-4.73-1.3l.84-1.43c1.29.55 2.66.91 4.08 1.11.31-.66.86-1.16 1.58-1.4l.01-5.62-1.76-.49v-4.46l1.76-.48v-7.64a.882.882 0 01-.2-.09l-3.98 4.42 1 1.44-3.06 3.4-1.67-.71-3.3 3.67c.57.87.55 2-.11 2.85a15.58 15.58 0 003.24 2.75l-.84 1.44c-1.42-.89-2.7-1.99-3.79-3.22-.87.26-1.86.11-2.6-.5-1.15-.93-1.29-2.56-.3-3.64l.14-.16c-.69-1.56-1.16-3.24-1.32-5l1.71.01c.14 1.5.51 2.93 1.09 4.27.49-.06 1-.01 1.46.16l3.32-3.68-1-1.45 3.06-3.4 1.67.72 3.99-4.43a2.15 2.15 0 01-.21-.46l-2.76.01-.5 1.67h-4.72l-.51-1.67-3.24-.01c-.27.76-.9 1.36-1.69 1.62l-.01 4.04-1.71-.01v-4.01c-1.1-.33-1.91-1.31-1.91-2.47 0-1.15.82-2.15 1.92-2.48l.01-4.05-1.76-.48v-4.46l1.76-.5v-4.05c-1.08-.35-1.84-1.32-1.84-2.45 0-1.43 1.22-2.58 2.73-2.58 1.22 0 2.25.74 2.61 1.78h3.09l.51-1.67h4.71l.51 1.67h2.68c.357-1.031 1.363-1.767 2.559-1.78l.071 8.37h-.85v2.61h.845l-.021 21.59h-.784v2.61h.78zm-5.914-18.306l-1.29-1.04-1.78 1.98 1.29 1.04zm-9.96-18.44h-1.69l-.01 2.61h1.7zm9.16 11.41v-1.6h-2.85v1.6zm-10.6 9.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.74.19 2.24.19 2.24l-1.76.58c-.18-.9-.24-1.84-.24-2.79zm10.81 16.93l.39-1.7c-1.52-.48-2.93-1.18-4.17-2.09l-1.26 1.11c1.48 1.15 3.19 2.08 5.04 2.68zm-.85 1.44l-1.3 1.22c-1.47-.54-2.86-1.26-4.12-2.11l.38-1.77c1.5 1.13 3.21 2.03 5.04 2.66z'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 550.43 0)'/%3e%3cpath fill='%23058e6e' d='M272.59 306.94c0-1.44 1.23-2.6 2.74-2.6s2.73 1.16 2.73 2.6c0 1.43-1.22 2.58-2.73 2.58s-2.74-1.15-2.74-2.58' stroke='none'/%3e%3cg fill='%23c8b100' stroke-width='.46'%3e%3cpath fill='%23ad1519' stroke-width='.52' d='M200.12 281.25h50.18v-55.72h-50.18v55.72z'/%3e%3cpath d='M217.34 238.41h-.92v-.92h-1.62v3.69h1.62v2.55h-3.47v7.39h1.85v14.79h-3.7v7.63h28.42v-7.63h-3.69v-14.79h1.85v-7.39h-3.47v-2.55h1.62v-3.69h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.69h1.62v2.55h-3.46v-8.09h1.84v-3.7h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.55h1.62v-3.69h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.31h7.16m-12.47 7.86h3.69m-5.31-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.69-1.85v1.85m3.47-1.85v1.85m-1.85-1.85v-2.08m1.85-1.84v1.84m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.69v1.84m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.85 1.85v1.85m-3.47 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.84v1.84m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.69v1.84m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.55v-1.85m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.69m3.47-5.54h3.47m3.46 5.54h3.7'/%3e%3cpath d='M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z'/%3e%3cpath d='M222.19 268.91l-2.31-.23c0-.92.23-2.31.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zm3.93-2.31l1.16-2.08c-.46-.23-1.39-.46-2.08-.46-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zm2.31 2.31l2.31-.23c0-.92-.23-2.31-.92-2.77l-2.08 1.62c.23.23.69.92.69 1.38zm-6.7-8.08v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zm7.16 0v-5.09c0-1.38.93-2.54 2.55-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zm-8.78-12.48l.23-4.62h-4.39l.47 4.62h3.69zm6.94 0l.46-4.62h-4.39l.23 4.62h3.7zm3.46 0l-.46-4.62h4.62l-.46 4.62h-3.7z'/%3e%3cpath d='M228.43 273.54v-4.16c0-.7-.46-2.78-3.23-2.78-2.54 0-3.01 2.08-3.01 2.78v4.16h6.24zm-7.16-13.18v-4.39c0-1.15-.69-2.31-2.08-2.31s-2.08 1.16-2.08 2.31v4.39h4.16zm8.09 0v-4.39c0-1.15.69-2.31 2.08-2.31 1.38 0 2.08 1.16 2.08 2.31v4.39h-4.16z' fill='%230039f0' stroke='none'/%3e%3c/g%3e%3cpath fill='%23ccc' d='M250.28 281.25h50.32v-55.72h-50.32v55.72z'/%3e%3cpath fill='%23db4446' stroke-width='.39' d='M275.93 239.26l.05-.62.09-.34s-1.61.13-2.46-.11-1.61-.59-2.4-1.25c-.79-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.31 1.59 1.41 1.95 1.53c.59.18 2.66.05 3.22.07.57.03 1.84.19 1.84.19z'/%3e%3cg fill='none' stroke-width='.39'%3e%3cpath fill='%23ed72aa' d='M283.46 237s.01.72.08 1.4c.06.67-.22 1.24-.11 1.61s.16.66.3.93c.14.26.21.94.21.94s-.38-.28-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.89.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.39-.14-1.26-.62-1.26-.62s.79.79.79 1.55c0 .75-.32 1.6-.32 1.6s-.36-.68-.83-1.12c-.47-.45-1.13-.9-1.13-.9s.52 1.17.52 1.95c0 .79-.15 2.47-.15 2.47s-.39-.64-.79-.96c-.4-.31-.87-.58-1.02-.78-.14-.21.48.64.54 1.16.07.51.32 2.35 1.92 4.69.94 1.37 2.39 3.77 5.5 2.98 3.11-.78 1.96-4.97 1.3-6.92-.65-1.95-.98-4.11-.94-4.87.04-.75.58-2.97.51-3.39-.07-.41-.24-2 .14-3.28.4-1.33.73-1.85.95-2.4.21-.55.39-.86.46-1.34s.07-1.37.07-1.37.58 1.06.73 1.44c.14.38.14 1.5.14 1.5s.11-1.12.98-1.67 1.88-1.13 2.13-1.44.33-.51.33-.51-.08 1.92-.62 2.67c-.36.49-1.77 2.09-1.77 2.09s.73-.28 1.23-.3c.51-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22s-1.05 1-1.78 1.58c-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.79.03 1.03.21 3.33-1.6 4.8-1.16.95-3.07.96-3.51 1.23-.43.28-1.29 1.13-1.29 2.91 0 1.79.64 2.06 1.15 2.51.51.44 1.16.2 1.3.55.15.34.22.54.44.75.21.2.36.44.29.82-.08.38-.91 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47s-.07.99.18 1.37c0 0 .91 1.06.29 1.26-.4.14-.78-.25-.97-.2-.54.14-.83.47-.98.45-.36-.07-.36-.25-.4-.76-.03-.51-.01-.72-.17-.72-.22 0-.33.18-.37.45s-.04.89-.29.89-.61-.45-.83-.55-.83-.2-.87-.48c-.03-.27.36-.85.76-.96.4-.1.76-.3.51-.51-.26-.2-.51-.2-.76 0-.25.21-.79.04-.76-.27.04-.31.11-.69.07-.86-.03-.17-.47-.51.1-.82.59-.31.84.27 1.42.17s.86-.31 1.08-.65.18-1.06-.22-1.5c-.39-.45-.79-.52-.94-.8-.14-.27-.36-.92-.36-.92s.11 1.2.04 1.37-.04.89-.04.89-.39-.45-.72-.79c-.32-.34-.65-1.37-.65-1.37s-.03.96-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86-.18-.14-.76-.58-1.01-1.06s-.44-1.16-.51-1.41c-.07-.24-.19-1.31-.07-1.58.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.59.28s-.15 1.54.21 2.88c.37 1.33.58 1.98.48 2.22-.11.24-.58.79-.76.89-.19.11-.69.07-.91-.03-.21-.1-.57-.27-1.26-.27s-1.12.03-1.37-.03c-.26-.07-.88-.38-1.17-.31s-.79.32-.65.72c.22.61-.21.75-.51.72-.29-.04-.53-.14-.9-.24-.36-.11-.9 0-.83-.42.07-.41.22-.44.4-.74.18-.32.25-.52.04-.54-.25-.02-.51-.05-.7.11-.2.16-.51.51-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13s.06-.51-.28-.78-.76-.43-.31-.77c.45-.35.56-.35.74-.54.17-.18.41-.79.73-.64.62.3.02.73.65 1.42.62.69 1.01.94 2.06.83 1.04-.11 1.33-.24 1.33-.54 0-.29-.09-.82-.12-1.04-.02-.21.15-.99.15-.99s-.48.3-.63.59c-.13.29-.42.8-.42.8s-.11-.6-.08-1.09c.02-.29.12-.79.11-.89-.03-.27-.23-.94-.23-.94s-.16.73-.28.94c-.11.21-.16 1.07-.16 1.07s-.67-.58-.48-1.55c.13-.75-.12-1.74.11-2.06.22-.33.75-1.64 2.06-1.69 1.3-.05 2.31.05 2.77.03.45-.03 2.06-.33 2.06-.33s-2.97-1.52-3.64-1.98c-.68-.45-1.73-1.63-2.07-2.16-.34-.54-.65-1.58-.65-1.58s-.53.02-1.02.29c-.48.27-.96.67-1.24.99s-.73 1.05-.73 1.05.08-.94.08-1.23-.06-.86-.06-.86-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.11-1.9.56-.08.45.2 1.07.03 1.39s-.54.54-.54.54-.42-.35-.79-.38c-.36-.03-.71.16-.71.16s-.31-.4-.19-.67c.11-.26.67-.66.54-.83-.15-.16-.6.06-.88.19-.28.14-.88.27-.82-.19.05-.45.2-.72.05-1.04-.14-.32-.05-.53.18-.61.22-.08 1.12.02 1.21-.19.08-.21-.22-.48-.82-.61-.59-.14-.88-.49-.57-.78.32-.3.4-.38.54-.64.14-.27.2-.76.74-.51.53.24.42.83.99 1.01.56.19 1.89-.08 2.17-.24s1.19-.83 1.5-.99c.31-.15 1.61-1.12 1.61-1.12s-.76-.53-1.05-.8c-.28-.27-.78-.91-1.04-1.05-.25-.13-1.5-.61-1.92-.64-.42-.02-1.72-.48-1.72-.48s.59-.19.79-.35c.19-.16.64-.56.87-.53.22.02.28.02.28.02s-1.21-.05-1.47-.13c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.27-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.59-.59s-.85.38-1.16.35-.54-.22-.57-.67c-.02-.46 0-.3-.1-.54-.12-.24-.57-.8-.15-.93.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.26.62-.37.79-.61s.37-.91.74-.7c.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83s.51.43.96.46c.45.02 1.13-.11 1.07.21-.05.32-.31.71-.62 1.06-.3.36-.45 1.05-.25 1.5.2.46.71 1.19 1.16 1.48s1.3.51 1.84.85c.53.35 1.78 1.34 2.2 1.45s.85.32.85.32.48-.21 1.13-.21 2.14.1 2.71-.14 1.3-.64 1.08-1.15c-.23-.51-1.47-.96-1.36-1.36s.57-.43 1.33-.46c.76-.02 1.8.14 2-.94.2-1.06.26-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.39-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.96-.25.25-.18.3-.69.61-.91.31-.21 1.53-.4 1.53-.4s1.46.71 2.8 1.71c1.21.9 2.3 2.23 2.3 2.23'/%3e%3cpath d='M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3s1.27-.35 1.27-.35-.74.86-.65 1.45c.08.58.19.85.17 1.15-.06.72-.6 1.61-.6 1.61s.31-.19 1.05-.35c.73-.16 1.36-.51 1.75-.81.39-.29.9-1.02.9-1.02s-.16 1 0 1.42c.17.44.23 1.67.23 1.67s.47-.42.85-.62c.19-.11.7-.38.9-.7.14-.22.32-1.06.32-1.06s.11.9.39 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21.68-.8.7-1.07c.03-.27-.08-.85-.08-.85l.39.85m-11.41.61s.48-.83.93-1.1c.46-.26 1.08-.74 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75c.68-.4 1.16-1.12 1.16-1.12'/%3e%3cpath stroke-width='.26' d='M282.57 240.9s-.34-.48-.42-.65c-.09-.15-.23-.48-.23-.48'/%3e%3cpath d='M278.33 257.41s2.04 1.26 1.98 2.31c-.06 1.04-1.13 2.41-1.13 2.41'/%3e%3c/g%3e%3cpath stroke-width='.26' d='M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.34.37-.05.11-.19.27-.19.27z'/%3e%3cpath stroke-width='.05' d='M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.91 1.05-.1.09-.54-.27-.85-.37 0 0-.23.05-.45.05-.23 0-.34-.11-.37-.21-.03-.12.03-.3.03-.3l-.34-.05z'/%3e%3cpath d='M273.08 240.14l.33-.53.34.49-.67.04m.81-.02l.4-.53.43.48-.83.05m-.36-3.29l.82.29-.74.38-.08-.67m.99.27l.73.18-.59.46-.14-.64' stroke-width='.26'/%3e%3cpath d='M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.05 0 .17-.54.11-.91-.2-1.2-1.3-1.47-1.3-1.47s.33.73.17 1.07c-.23.48-.65.86-.65.86zm-2.29 1.04s-.43-.77-1.33-.67c-.9.11-1.5.81-1.5.81s1-.03 1.25.13c.37.24.48.86.48.86s.54-.32.71-.54c.16-.21.39-.59.39-.59zm-1.1 3.13s-.77.11-1.19.59c-.43.49-.36 1.4-.36 1.4s.5-.54.95-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.81-.34-.81zm2.57 10.12s-.42-.45-1.16-.32c-.74.14-1.22.97-1.22.97s.63-.17 1-.08c.36.08.62.45.62.45s.34-.29.45-.45.31-.57.31-.57zm-.85 2.97s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.51-.43.91-.37c.39.05.87.27.87.27s.08-.51.11-.64c.09-.38-.17-.84-.17-.84zm1.45 2.74s-.05.79.33 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.79.06-.79.06zm7.34 7.04s-.51-.64-1.21-.62c-.71.03-1.45.69-1.45.69s.88-.07 1.11.22c.23.3.45.67.45.67s.4-.21.57-.35c.17-.13.53-.61.53-.61zm-2.17 2.81s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56 1.08.32 1.08.32-.09-.53-.15-.78c-.05-.24-.19-.69-.19-.69zm2.01 2.97s-.46.64-.12 1.15 1.05.75 1.05.75-.26-.37-.14-.8c.09-.34.67-.8.67-.8l-1.46-.3zm12.4 1.21s-.81-.19-1.27.08c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45zm.4 2.99s-.62.64-.4 1.18c.23.54.62 1.1.62 1.1s-.02-.8.23-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35zm3.11.94s-.31.78.28 1.28c.59.52 1.11.57 1.11.57s-.46-.81-.32-1.23c.15-.45.54-.72.54-.72s-.74-.25-.85-.22c-.11.02-.76.32-.76.32z' fill='%23db4446' stroke-width='.39'/%3e%3cg fill='%23c8b100' stroke-width='.26'%3e%3cpath d='M282.88 232.71l-.29.02c-.01.03-.14.24-.26.35-.26.25-.65.28-.86.07a.486.486 0 01-.14-.41c-.17.09-.35.09-.51-.01-.26-.15-.32-.5-.14-.79.03-.06.06-.14.11-.18l-.02-.32-.35.08-.1.19c-.22.25-.54.31-.7.17a.526.526 0 01-.13-.27c0 .01-.09.09-.17.11-.54.13-.75-1.05-.77-1.35l-.17.25s.16.7.08 1.3c-.08.59-.29 1.19-.29 1.19.74.19 1.86.8 2.97 1.65s1.98 1.78 2.34 2.42c0 0 .58-.32 1.18-.51s1.36-.2 1.36-.2l.22-.21c-.32.05-1.58.1-1.56-.43 0-.08.07-.18.08-.18a.697.697 0 01-.3-.06c-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.11.09-.15.13-.27.23-.65.25-.86.03a.416.416 0 01-.11-.46.58.58 0 01-.45-.05c-.26-.15-.31-.52-.11-.8.09-.14.28-.31.31-.32l-.07-.3h-.01z'/%3e%3cpath d='M280.63 233.4c.05-.07.15-.06.23 0s.1.16.06.21c-.05.06-.15.06-.24-.01-.07-.05-.1-.15-.05-.2zm.95.79l-.33-.25c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.33.26.33.25c.05.04.08.12.04.16s-.12.04-.18 0l-.33-.26m-1.74-1.19l-.26-.15c-.07-.04-.1-.12-.07-.17s.11-.06.17-.02l.26.16.26.15c.06.03.09.11.07.16-.03.05-.11.06-.17.02l-.26-.15m-1.04-.71c.05-.06.16-.06.24 0 .08.07.1.16.05.22-.05.05-.15.05-.23-.01s-.1-.15-.06-.21zm3.83 2.63c.05-.05.03-.14-.05-.21-.08-.06-.19-.06-.24 0-.04.05-.02.15.06.21s.18.06.23 0zm.57.66l.22.21c.05.05.13.07.18.03.04-.04.04-.11-.01-.16l-.21-.21-.22-.21c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21m.95.81c.05-.06.03-.15-.05-.21-.08-.07-.18-.07-.23-.01s-.03.15.05.22c.08.05.18.06.23 0z' fill='black' stroke-width='.05'/%3e%3cpath d='M281.4 230.36l-.59.01-.11.87.06.14.15-.01.76-.51-.27-.5'/%3e%3cpath d='M281.4 230.36l-.59.01-.11.87.06.14.15-.01.76-.51-.27-.5'/%3e%3cpath d='M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.71-.5.27'/%3e%3cpath d='M281.7 231.92l-.49.27-.54-.71-.01-.15.14-.06.93.11-.03.54'/%3e%3cpath d='M280.51 231.25c.08-.13.26-.17.39-.09.14.07.18.24.1.37s-.26.17-.39.09a.26.26 0 01-.1-.37zm-2.15-.9c-.02.01-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.05.42-.19.87.09.38.31-.03.87-.03.87s-.09.14-.19.18z'/%3e%3cpath d='M279.39 230.66l-.42.37-.68-.6.06-.08.03-.15.92-.07.09.53'/%3e%3cpath d='M278.24 230.29c.05-.15.18-.23.28-.2.11.04.15.18.1.33s-.18.23-.29.2c-.11-.04-.15-.18-.09-.33zm5.43 1.48l-.59-.06-.25.85.05.14.15.01.83-.41-.19-.53'/%3e%3cpath d='M282.01 232.03l-.1.54.9.23.15-.04.01-.14-.43-.79-.53.2'/%3e%3cpath d='M283.73 233.36l-.53.2-.42-.78.01-.15.15-.03.89.23-.1.53'/%3e%3cpath d='M282.65 232.54c.1-.12.28-.13.4-.04.13.09.15.26.05.38s-.28.13-.41.04a.26.26 0 01-.04-.38zm2.99 1.07l.11.55-.87.3-.16-.04-.01-.14.36-.81.57.14'/%3e%3cpath d='M285.49 235.2l-.56.13-.31-.83.04-.15.15-.02.85.35-.17.52'/%3e%3cpath d='M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13'/%3e%3cpath d='M284.91 234.63c.12-.11.12-.28.02-.39a.318.318 0 00-.41-.02c-.11.11-.12.28-.01.39.1.11.29.12.4.02zm1.38 1.8c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.12-.42-.28-.79-.39-.28-.88.22-.88.22s-.12.12-.15.21z'/%3e%3cpath d='M285.75 235.54l-.29.46.76.51.09-.08.13-.04-.12-.88-.57.03'/%3e%3cpath d='M286.37 236.53c.14-.07.21-.22.15-.31s-.22-.1-.36-.02-.2.22-.14.31c.05.09.21.1.35.02z'/%3e%3c/g%3e%3cg stroke-width='.61'%3e%3cellipse fill='%23ad1519' cx='250.43' cy='281.01' rx='16.26' ry='18.3'/%3e%3cellipse fill='%23005bbf' cx='250.44' cy='280.97' rx='11.44' ry='13.42'/%3e%3cg id='f' fill='%23c8b100' stroke-width='.34'%3e%3cpath stroke-linejoin='round' d='M245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39.57 2.54.57 2.54-.21-.55-.76-.94-1.41-.94-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.59 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25l-1.22.01v1.03h1.09l-.81 1.61 1.07-.42.81.91.84-.91 1.07.42-.8-1.61h1.08v-1.03l-1.22-.01c-.02-.08-.02-.16-.02-.25 0-.56.47-1.01 1.06-1.01.44 0 .82.2.98.57l.49-.99c.1-.19.24-.55.24-.77 0-.79-.67-1.42-1.49-1.42-.66 0-1.21.39-1.41.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z'/%3e%3cpath d='M242.87 281.11h4.36v-1.03h-4.36v1.03z'/%3e%3c/g%3e%3cuse xlink:href='%23f' x='10.63'/%3e%3cuse xlink:href='%23f' x='5.31' y='9.14'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$1Y = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3crect width='1' height='2' fill='%23009246'/%3e%3crect width='1' height='2' x='1' fill='white'/%3e%3crect width='1' height='2' x='2' fill='%23ce2b37'/%3e%3c/svg%3e";

var img$1X = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3crect fill='%23436F4D' width='6' height='3'/%3e%3crect fill='white' width='6' height='2'/%3e%3crect fill='%23CD2A3E' width='6' height='1'/%3e%3c/svg%3e";

var img$1W = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3e%3crect fill='%230D5EAF' width='27' height='18'/%3e%3cpath fill='none' stroke-width='2' stroke='white' d='M5%2c0V11 M0%2c5H10 M10%2c3H27 M10%2c7H27 M0%2c11H27 M0%2c15H27'/%3e%3c/svg%3e";

var img$1V = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 320'%3e%3crect fill='%23D52B1E' height='320' width='320'/%3e%3crect fill='white' height='60' width='200' x='60' y='130'/%3e%3crect fill='white' height='200' width='60' x='130' y='60'/%3e%3c/svg%3e";

var img$1U = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 390'%3e%3crect fill='%23ED2939' width='450' height='390'/%3e%3crect fill='%23FAE042' width='300' height='390'/%3e%3crect width='150' height='390'/%3e%3c/svg%3e";

var img$1T = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3crect fill='%2321468B' width='9' height='6'/%3e%3crect fill='white' width='9' height='4'/%3e%3crect fill='%23AE1C28' width='9' height='2'/%3e%3c/svg%3e";

var img$1S = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Flag of Poland' viewBox='0 0 16 10'%3e%3crect width='16' height='10' fill='white'/%3e%3crect width='16' height='5' fill='crimson' y='5'/%3e%3c/svg%3e";

var img$1R = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 21'%3e%3crect fill='white' width='33' height='21'/%3e%3crect width='33' height='14'/%3e%3crect fill='%234891D9' width='33' height='7'/%3e%3c/svg%3e";

var img$1Q = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3crect fill='%23C1272D' width='5' height='3'/%3e%3crect fill='%23006A44' width='5' height='2'/%3e%3crect fill='%23FDB913' width='5' height='1'/%3e%3c/svg%3e";

var img$1P = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3crect width='5' height='3' fill='white'/%3e%3crect width='5' height='2' y='1' fill='%2300966E'/%3e%3crect width='5' height='1' y='2' fill='%23D62612'/%3e%3c/svg%3e";

var img$1O = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cpath fill='%239E3039' d='m0%2c0h1200v600H0'/%3e%3cpath fill='white' d='m0%2c240h1200v120H0'/%3e%3c/svg%3e";

var img$1N = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3crect fill='white' width='9' height='3'/%3e%3crect fill='%23d52b1e' y='3' width='9' height='3'/%3e%3crect fill='%230039a6' y='2' width='9' height='2'/%3e%3c/svg%3e";

var img$1M = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23ED2939' d='M0 0h3v2H0z'/%3e%3cpath fill='white' d='M0 0h2v2H0z'/%3e%3cpath fill='%23002395' d='M0 0h1v2H0z'/%3e%3c/svg%3e";

var img$1L = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3e%3cdefs%3e%3cclipPath id='b'%3e%3cpath d='M0 0h6v3H0z'/%3e%3c/clipPath%3e%3cclipPath id='c'%3e%3cpath d='M0 0v1.5h6V3zm6 0H3v3H0z'/%3e%3c/clipPath%3e%3cpath id='a' d='M0-360l69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z'/%3e%3cpath id='e' d='M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z'/%3e%3cuse id='d' xlink:href='%23a' transform='scale(2.1)'/%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h10080v5040H0z'/%3e%3cpath d='M0 0l6 3m0-3L0 3' stroke='white' stroke-width='.6' clip-path='url(%23b)' transform='scale(840)'/%3e%3cpath d='M0 0l6 3m0-3L0 3' stroke='%23e4002b' stroke-width='.4' clip-path='url(%23c)' transform='scale(840)'/%3e%3cpath d='M2520 0v2520M0 1260h5040' stroke='white' stroke-width='840'/%3e%3cpath d='M2520 0v2520M0 1260h5040' stroke='%23e4002b' stroke-width='504'/%3e%3cg fill='white'%3e%3cuse xlink:href='%23d' x='2520' y='3780'/%3e%3cuse xlink:href='%23a' x='7560' y='4200'/%3e%3cuse xlink:href='%23a' x='6300' y='2205'/%3e%3cuse xlink:href='%23a' x='7560' y='840'/%3e%3cuse xlink:href='%23a' x='8680' y='1869'/%3e%3cuse xlink:href='%23e' x='8064' y='2730'/%3e%3c/g%3e%3c/svg%3e";

var img$1K = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3e%3crect width='1200' height='800' fill='%23005BBB'/%3e%3crect width='1200' height='400' y='400' fill='%23FFD500'/%3e%3c/svg%3e";

var img$1J = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect fill='white' height='600' width='900'/%3e%3ccircle fill='%23bc002d' cx='450' cy='300' r='180'/%3e%3c/svg%3e";

var img$1I = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3e%3crect width='600' height='400' fill='red'/%3e%3crect width='240' height='400' fill='%23060'/%3e%3cg fill='%23ff0' fill-rule='evenodd' stroke='black' stroke-width='0.573' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m318.24%2c262.04c-30.21-0.91-168.74-87.38-169.69-101.15l7.6496-12.757c13.741%2c19.966%2c155.36%2c104.06%2c169.27%2c101.08l-7.2299%2c12.823'/%3e%3cpath d='m154.59%2c146.4c-2.7101%2c7.2937%2c36.149%2c31.318%2c82.903%2c59.754%2c46.752%2c28.434%2c87.065%2c46.006%2c90.053%2c43.486%2c0.18256-0.32544%2c1.4701-2.5409%2c1.352-2.5232-0.56001%2c0.84402-1.9234%2c1.1104-4.0506%2c0.49741-12.631-3.6433-45.575-18.765-86.374-43.506-40.798-24.743-76.294-47.544-81.811-57.232-0.38363-0.67116-0.65702-1.8962-0.60146-2.8487l-0.13405-0.002-1.1747%2c2.0532-0.16139%2c0.32191h-0.00088zm164.36%2c116.04c-0.51238%2c0.92957-1.4675%2c0.96044-3.2816%2c0.76112-11.3-1.2506-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.1509-2.0346%2c0.22665%2c0.0706c-3.8037%2c11.405%2c76.948%2c57.578%2c81.702%2c60.522%2c46.724%2c28.947%2c86.115%2c45.851%2c89.601%2c41.458l-1.2682%2c2.181v-0.002z'/%3e%3cpath d='m240.17%2c169.23c30.237-0.23901%2c67.55-4.1319%2c89.023-12.69l-4.6265-7.5168c-12.692%2c7.0247-50.21%2c11.644-84.652%2c12.335-40.736-0.37483-69.49-4.1681-83.897-13.835l-4.3672%2c8.0045c26.484%2c11.207%2c53.623%2c13.587%2c88.52%2c13.703'/%3e%3cpath d='m330.44%2c156.71c-0.73904%2c1.1818-14.743%2c6.0113-35.373%2c9.5753-13.988%2c2.1325-32.234%2c3.9555-55.004%2c3.9776-21.633%2c0.0203-39.305-1.5196-52.684-3.3329-21.656-3.3955-32.833-8.1201-36.965-9.7896%2c0.39509-0.78581%2c0.64908-1.337%2c1.0301-2.0708%2c11.895%2c4.736%2c23.124%2c7.5918%2c36.279%2c9.6158%2c13.291%2c1.8%2c30.75%2c3.362%2c52.276%2c3.3417%2c22.664-0.0229%2c40.709-1.9844%2c54.616-4.0534%2c21.155-3.4122%2c32.711-7.8034%2c34.334-9.8425l1.494%2c2.5788h-0.002zm-4.0603-7.6226c-2.293%2c1.8415-13.718%2c5.8932-33.819%2c9.1034-13.415%2c1.9226-30.472%2c3.6433-52.265%2c3.6645-20.704%2c0.0203-37.619-1.375-50.485-3.2491-20.414-2.6661-31.279-7.4754-35.196-8.8776%2c0.3898-0.67381%2c0.78666-1.3423%2c1.1941-2.0135%2c3.0479%2c1.5346%2c13.533%2c5.7909%2c34.226%2c8.7224%2c12.72%2c1.8036%2c29.661%2c3.1477%2c50.262%2c3.1265%2c21.69-0.0221%2c38.553-1.7762%2c51.883-3.6883%2c20.205-2.7799%2c31.077-7.9472%2c32.728-9.241l1.4728%2c2.4509v0.002z'/%3e%3cpath d='m140.88%2c205.66c18.598%2c10.003%2c59.905%2c15.044%2c98.994%2c15.391%2c35.591%2c0.0564%2c81.958-5.5016%2c99.297-14.69l-0.47712-10.012c-5.4246%2c8.4773-55.113%2c16.609-99.206%2c16.276-44.093-0.3325-85.038-7.1429-98.687-15.959l0.0794%2c8.9914'/%3e%3cpath d='m340.12%2c204.22%2c0.00088%2c2.3874c-2.606%2c3.1159-18.946%2c7.8255-39.437%2c11.142-15.595%2c2.391-35.927%2c4.1945-61.262%2c4.1945-24.069%2c0-43.263-1.7163-58.148-4.0014-23.529-3.4264-38.579-9.4262-41.6-11.217l0.0132-2.7852c9.0748%2c6.0334%2c33.661%2c10.447%2c41.917%2c11.798%2c14.788%2c2.2701%2c33.868%2c3.9732%2c57.817%2c3.9732%2c25.216%2c0%2c45.434-1.7912%2c60.931-4.1663%2c14.701-2.1237%2c35.644-7.6465%2c39.767-11.324h0.00088zm0.01-8.4922%2c0.00088%2c2.3874c-2.606%2c3.1142-18.946%2c7.8237-39.437%2c11.14-15.595%2c2.391-35.927%2c4.1945-61.262%2c4.1945-24.069%2c0-43.263-1.7145-58.148-4.0014-23.529-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7852c9.0748%2c6.0325%2c33.661%2c10.447%2c41.917%2c11.796%2c14.788%2c2.2719%2c33.868%2c3.9758%2c57.817%2c3.9758%2c25.216%2c0%2c45.434-1.7921%2c60.931-4.169%2c14.701-2.1237%2c35.644-7.6465%2c39.767-11.324l0.00088%2c0.002z'/%3e%3cpath d='m239.79%2c260.32c-42.772-0.25489-79.421-11.659-87.16-13.544l5.6433%2c8.8344c13.67%2c5.7503%2c49.424%2c14.32%2c81.927%2c13.371%2c32.504-0.94809%2c60.91-3.466%2c80.928-13.211l5.7862-9.1555c-13.642%2c6.425-60.068%2c13.639-87.125%2c13.705'/%3e%3cpath stroke-width='0.55' d='m323.3%2c253.72c-0.85016%2c1.2991-1.7171%2c2.5823-2.5963%2c3.8294-9.4417%2c3.3293-24.319%2c6.8245-30.597%2c7.844-12.824%2c2.6423-32.665%2c4.594-50.274%2c4.6029-37.89-0.55474-68.905-7.9719-83.496-14.299l-1.1773-2.0241%2c0.19225-0.30427%2c1.9966%2c0.77435c25.948%2c9.2834%2c55.091%2c12.987%2c82.698%2c13.652%2c17.538%2c0.0617%2c35.095-2.01%2c49.292-4.5491%2c21.771-4.3621%2c30.574-7.65%2c33.275-9.1405l0.68701-0.38541h-0.00088zm5.0172-8.2753c0.022%2c0.0256%2c0.0441%2c0.0503%2c0.0653%2c0.0776-0.63585%2c1.0733-1.2911%2c2.1652-1.9622%2c3.2623-5.0357%2c1.8-18.702%2c5.7988-38.659%2c8.5893-13.149%2c1.7912-21.322%2c3.526-47.479%2c4.034-49.015-1.2471-80.75-10.831-88.289-13.195l-1.1174-2.1431c28.406%2c7.4154%2c57.422%2c12.592%2c89.408%2c13.121%2c23.931-0.50976%2c34.112-2.2719%2c47.152-4.0499%2c23.271-3.6186%2c34.996-7.4498%2c38.515-8.5558-0.0441-0.0635-0.0961-0.13053-0.15433-0.19932l2.5231-0.9428-0.002%2c0.002z'/%3e%3cpath d='m328.83%2c197.76c0.13873%2c28.137-14.26%2c53.386-25.858%2c64.525-16.408%2c15.759-38.163%2c25.896-63.569%2c26.363-28.37%2c0.52117-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243%2c1.7376-30.709%2c13.793-52.1%2c31.268-66.769s40.743-21.813%2c60.121-21.302c22.358%2c0.59003%2c48.475%2c11.558%2c66.521%2c33.332%2c11.823%2c14.266%2c16.943%2c29.748%2c19.627%2c53.193zm-89.186-96.342c54.485%2c0%2c99.296%2c44.338%2c99.296%2c98.703%2c0%2c54.364-44.811%2c98.704-99.296%2c98.704s-98.924-44.339-98.924-98.704%2c44.439-98.703%2c98.924-98.703'/%3e%3cpath d='m239.91%2c101.08c54.534%2c0%2c99.011%2c44.483%2c99.011%2c99.022%2c0%2c54.538-44.478%2c99.02-99.011%2c99.02-54.534%2c0-99.011-44.481-99.011-99.02s44.478-99.022%2c99.011-99.022zm-96.832%2c99.0224c0%2c53.26%2c43.736%2c96.842%2c96.832%2c96.842%2c53.097%2c0%2c96.833-43.582%2c96.833-96.842%2c0-53.262-43.737-96.844-96.833-96.844s-96.832%2c43.584-96.832%2c96.844z'/%3e%3cpath d='m239.99%2c109.31c49.731%2c0%2c90.693%2c40.821%2c90.693%2c90.704%2c0%2c49.884-40.963%2c90.703-90.693%2c90.703s-90.693-40.819-90.693-90.703c0-49.883%2c40.964-90.704%2c90.693-90.704zm-88.515%2c90.7034c0%2c48.685%2c39.979%2c88.524%2c88.515%2c88.524s88.515-39.839%2c88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536%2c0-88.515%2c39.839-88.515%2c88.525z'/%3e%3cpath d='m243.98%2c100.68-8.48545%2c0%2c0.01%2c198.96%2c8.51455%2c0z'/%3e%3cpath d='m243.13%2c99.546h2.1598l0.0185%2c201.25h-2.1616l-0.0159-201.25zm-8.4213%2c0.0018h2.1766l0.003%2c201.25h-2.1783v-201.25z'/%3e%3cpath d='m338.99%2c203.935%2c0-7.3554-5.99-5.58-34-9-49-5-59%2c3-42%2c10-8.48%2c6.28%2c0%2c7.3572l21.48-9.637%2c51-8h49l36%2c4%2c25%2c6z'/%3e%3cpath d='m239.95%2c184.77c23.383-0.0432%2c46.07%2c2.2154%2c64.065%2c5.7194%2c18.569%2c3.7121%2c31.637%2c8.3556%2c36.105%2c13.571l-0.005%2c2.5823c-5.3884-6.4902-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.7168-63.647-5.6736-24.538%2c0.0459-47.387%2c2.3698-64.984%2c5.8032-14.12%2c2.8019-32.951%2c8.3679-35.302%2c13.858v-2.689c1.2911-3.8003%2c15.313-9.4792%2c34.984-13.417%2c17.729-3.4572%2c40.62-5.7415%2c65.302-5.7864zm0.01-8.4922c23.383-0.0423%2c46.07%2c2.2172%2c64.065%2c5.7194%2c18.569%2c3.7139%2c31.637%2c8.3556%2c36.105%2c13.571l-0.005%2c2.5823c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.858-3.4757-40.393-5.7185-63.647-5.6736-24.538%2c0.0441-47.276%2c2.3698-64.875%2c5.8014-13.626%2c2.5832-33.226%2c8.3696-35.412%2c13.86v-2.6908c1.2911-3.7588%2c15.597-9.6414%2c34.985-13.417%2c17.729-3.4572%2c40.62-5.7397%2c65.302-5.7864z'/%3e%3cpath d='m239.48%2c132.96c36.849-0.18433%2c68.99%2c5.1523%2c83.695%2c12.685l5.3638%2c9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854%2c0.20814-70.027%2c3.7271-88.176%2c13.41l6.4035-10.709c14.895-7.7241%2c50.022-11.643%2c81.72-11.684'/%3e%3cpath d='m239.97%2c140.62c21.017-0.0556%2c41.325%2c1.1298%2c57.476%2c4.0437%2c15.041%2c2.7993%2c29.385%2c7.0009%2c31.436%2c9.2604l1.5901%2c2.8099c-4.9881-3.257-17.401-6.8836-33.339-9.906-16.006-3.0083-36.3-4.0049-57.2-3.9502-23.722-0.0811-42.152%2c1.1712-57.969%2c3.9291-16.728%2c3.13-28.334%2c7.6015-31.197%2c9.7261l1.5583-2.9704c5.5631-2.8381%2c14.39-6.2592%2c29.223-8.9297%2c16.357-2.988%2c34.983-3.8841%2c58.423-4.0128h-0.00088zm-0.009-8.4843c20.113-0.0529%2c39.972%2c1.068%2c55.452%2c3.8506%2c12.209%2c2.3768%2c24.283%2c6.0872%2c28.704%2c9.3892l2.3256%2c3.6954c-3.9536-4.3947-18.836-8.5593-31.974-10.892-15.361-2.6494-34.395-3.698-54.508-3.8656-21.108%2c0.0591-40.615%2c1.352-55.752%2c4.1081-14.441%2c2.7481-23.76%2c6.0016-27.703%2c8.5425l2.0451-3.0868c5.4414-2.8646%2c14.232-5.4954%2c25.303-7.6465%2c15.249-2.7764%2c34.876-4.0358%2c56.108-4.0949z'/%3e%3cpath d='m289.15%2c241.26c-18.218-3.4008-36.469-3.8947-49.217-3.7447-61.407%2c0.71967-81.244%2c12.609-83.665%2c16.209l-4.5894-7.4815c15.634-11.332%2c49.073-17.687%2c88.587-17.037%2c20.518%2c0.33602%2c38.224%2c1.6986%2c53.119%2c4.5835l-4.2358%2c7.4727'/%3e%3cpath stroke-width='0.55' d='m239.58%2c236.46c17.082%2c0.25488%2c33.849%2c0.96044%2c50.033%2c3.9784l-1.172%2c2.069c-15.031-2.7746-31.055-3.8365-48.803-3.75-22.663-0.17727-45.585%2c1.9394-65.541%2c7.6668-6.2968%2c1.7524-16.721%2c5.8006-17.784%2c9.1458l-1.1659-1.9226c0.33601-1.9773%2c6.6363-6.081%2c18.414-9.3901%2c22.858-6.5458%2c44.239-7.6491%2c66.019-7.799v0.002zm0.77519-8.5963c17.698%2c0.33073%2c35.975%2c1.1492%2c53.74%2c4.6681l-1.2206%2c2.1537c-16.042-3.1847-31.369-4.2466-52.415-4.5702-22.735%2c0.0414-46.851%2c1.6625-68.778%2c8.0372-7.0791%2c2.062-19.297%2c6.5202-19.704%2c10.05l-1.1659-2.0655c0.26545-3.2059%2c10.842-7.388%2c20.358-10.156%2c22.096-6.4241%2c46.275-8.076%2c69.186-8.1174z'/%3e%3cpath d='M327.58%2c247.38%2c320.201%2c258.829%2c299%2c240%2c244%2c203%2c182%2c169%2c149.81%2c157.99%2c156.67%2c145.27%2c159%2c144l20%2c5%2c66%2c34%2c38%2c24%2c32%2c23%2c13%2c15z'/%3e%3cpath d='m148.65%2c158.29c5.646-3.8294%2c47.139%2c14.655%2c90.555%2c40.834%2c43.301%2c26.254%2c84.677%2c55.921%2c80.942%2c61.473l-1.2285%2c1.9323-0.56354%2c0.4445c0.12083-0.0864%2c0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.309-87.041-45.371-90.997-40.494l1.247-2.3892h-0.00089zm180.44%2c88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.4278%2c2.5991c-0.0124%2c0.14287%2c0.052-0.17727%2c0.35364-0.4101%2c1.1685-1.0195%2c3.1052-0.95074%2c3.9792-0.96662%2c11.065%2c0.16581%2c42.667%2c14.709%2c87.006%2c40.128%2c19.428%2c11.315%2c82.071%2c51.491%2c81.832%2c62.789%2c0.0168%2c0.97102%2c0.0803%2c1.1712-0.28485%2c1.6519l1.5936-2.4236v-0.002z'/%3e%3c/g%3e%3cg%3e%3cpath fill='white' stroke='black' stroke-width='0.67037' d='m180.6%2c211.01c0%2c16.271%2c6.6628%2c30.987%2c17.457%2c41.742%2c10.815%2c10.778%2c25.512%2c17.579%2c41.809%2c17.579%2c16.381%2c0%2c31.247-6.6525%2c42.016-17.389%2c10.769-10.735%2c17.443-25.552%2c17.446-41.88h-0.002v-79.189l-118.74-0.14111%2c0.0123%2c79.278h0.002z'/%3e%3cpath fill='red' stroke='black' stroke-width='0.50734' d='m182.82%2c211.12v0.045c0%2c15.557%2c6.4414%2c29.724%2c16.775%2c40.009%2c10.354%2c10.305%2c24.614%2c16.712%2c40.214%2c16.712%2c15.681%2c0%2c29.912-6.3606%2c40.222-16.626%2c10.308-10.265%2c16.697-24.433%2c16.699-40.044h-0.002v-76.826l-113.84-0.0185-0.0697%2c76.748m91.022-53.747%2c0.004%2c48.891-0.0414%2c5.1717h0.00088c0%2c1.3608-0.082%2c2.9122-0.24076%2c4.2333-0.92512%2c7.7294-4.4801%2c14.467-9.7451%2c19.708-6.1636%2c6.1357-14.671%2c9.9413-24.047%2c9.9413-9.327%2c0-17.639-3.9379-23.829-10.1-6.3497-6.32-10.03-14.986-10.03-23.947l-0.0132-54.023%2c67.94%2c0.12259%2c0.002%2c0.002z'/%3e%3cg id='castle3'%3e%3cg id='castle' fill='%23ff0' stroke='black' stroke-width='0.5'%3e%3cpath stroke='none' d='m190.19%2c154.43c0.13493-5.521%2c4.0524-6.828%2c4.0806-6.8474%2c0.0282-0.0185%2c4.2314%2c1.4076%2c4.2173%2c6.8986l-8.2978-0.0512'/%3e%3cpath d='m186.81%2c147.69-0.68172%2c6.3447%2c4.1406%2c0.009c0.0397-5.2493%2c3.9739-6.1225%2c4.0691-6.1031%2c0.0891-0.005%2c3.9889%2c1.1606%2c4.0929%2c6.1031h4.1511l-0.74962-6.3932-15.022%2c0.0379v0.002z'/%3e%3cpath d='m185.85%2c154.06h16.946c0.35717%2c0%2c0.64908%2c0.35277%2c0.64908%2c0.78404%2c0%2c0.43039-0.29191%2c0.78141-0.64908%2c0.78141h-16.946c-0.35717%2c0-0.64908-0.35102-0.64908-0.78141%2c0-0.43127%2c0.29191-0.78404%2c0.64908-0.78404z'/%3e%3cpath d='m192.01%2c154.03c0.0185-3.3126%2c2.2621-4.2501%2c2.2736-4.2483%2c0.00088%2c0%2c2.3423%2c0.96661%2c2.3609%2c4.2483h-4.6344'/%3e%3cpath d='m186.21%2c145.05h16.245c0.34218%2c0%2c0.62263%2c0.31839%2c0.62263%2c0.70468%2c0%2c0.38717-0.28045%2c0.70467-0.62263%2c0.70467h-16.245c-0.34218%2c0-0.62263-0.31573-0.62263-0.70467%2c0-0.38629%2c0.28045-0.70468%2c0.62263-0.70468z'/%3e%3cpath d='m186.55%2c146.47h15.538c0.32719%2c0%2c0.59529%2c0.31662%2c0.59529%2c0.70379%2c0%2c0.38805-0.2681%2c0.70467-0.59529%2c0.70467h-15.538c-0.32719%2c0-0.59529-0.31662-0.59529-0.70467%2c0-0.38717%2c0.2681-0.70379%2c0.59529-0.70379z'/%3e%3cpath d='m191.57%2c135.88%2c1.2267%2c0.002v0.87136h0.89513v-0.89076l1.2567%2c0.004v0.88723h0.89778v-0.89076h1.2576l-0.002%2c2.0117c0%2c0.31574-0.25398%2c0.52035-0.54854%2c0.52035h-4.4113c-0.29633%2c0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z'/%3e%3cpath d='m196.19%2c138.57%2c0.27691%2c6.4514-4.3028-0.0159%2c0.28486-6.4523%2c3.741%2c0.0168'/%3e%3cpath id='cp1' d='m190.94%2c141.56%2c0.13141%2c3.4775-4.1256%2c0.002%2c0.11641-3.4793h3.8786-0.00089z'/%3e%3cuse xlink:href='%23cp1' x='10.609'/%3e%3cpath id='cp2' d='m186.3%2c139.04%2c1.1994%2c0.003v0.87224h0.8775v-0.89253l1.2294%2c0.004v0.889h0.87926v-0.89253l1.2302%2c0.002-0.002%2c2.0117c0%2c0.31398-0.2487%2c0.51859-0.5362%2c0.51859h-4.3169c-0.28926%2c0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z'/%3e%3cuse xlink:href='%23cp2' x='10.609'/%3e%3cpath fill='black' stroke='none' d='m193.9%2c140.61c-0.0265-0.62706%2c0.87661-0.63411%2c0.86603%2c0v1.5364h-0.866v-1.536'/%3e%3cpath id='cp3' fill='black' stroke='none' d='m188.57%2c142.84c-0.003-0.6059%2c0.83693-0.61824%2c0.82635%2c0v1.1871h-0.826v-1.187'/%3e%3cuse xlink:href='%23cp3' x='10.641'/%3e%3c/g%3e%3cuse xlink:href='%23castle' y='46.3198'/%3e%3cuse xlink:href='%23castle' transform='matrix(0.70460892%2c-0.70959585%2c0.70959585%2c0.70460892%2c-35.341459%2c275.10898)'/%3e%3c/g%3e%3cuse xlink:href='%23castle' x='45.7138'/%3e%3cuse xlink:href='%23castle3' transform='matrix(-1%2c0%2c0%2c1%2c479.79195%2c0)'/%3e%3cg id='quina' fill='white'%3e%3cpath fill='%23039' d='m232.636%2c202.406v0.005c0%2c2.2119%2c0.84927%2c4.2272%2c2.2118%2c5.6894%2c1.3652%2c1.4667%2c3.2454%2c2.3777%2c5.302%2c2.3777%2c2.0672%2c0%2c3.9439-0.90487%2c5.3029-2.3654%2c1.3581-1.4587%2c2.2021-3.47219%2c2.2021-5.693v-10.768l-14.992-0.0123-0.0273%2c10.766'/%3e%3ccircle cx='236.074' cy='195.735' r='1.486'/%3e%3ccircle cx='244.392' cy='195.742' r='1.486'/%3e%3ccircle cx='240.225' cy='199.735' r='1.486'/%3e%3ccircle cx='236.074' cy='203.916' r='1.486'/%3e%3ccircle cx='244.383' cy='203.905' r='1.486'/%3e%3c/g%3e%3cuse xlink:href='%23quina' y='-26.016'/%3e%3cuse xlink:href='%23quina' x='-20.799'/%3e%3cuse xlink:href='%23quina' x='20.745'/%3e%3cuse xlink:href='%23quina' y='25.784'/%3e%3c/g%3e%3c/svg%3e";

var img$1H = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3crect width='1' height='2' x='0' y='0' fill='%23002B7F'/%3e%3crect width='1' height='2' x='1' y='0' fill='%23FCD116'/%3e%3crect width='1' height='2' x='2' y='0' fill='%23CE1126'/%3e%3c/svg%3e";

var img$1G = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2100 -1470 4200 2940'%3e%3cdefs%3e%3cpath id='D' fill-rule='evenodd' d='m-31.5 0h33a30 30 0 0 0 30 -30v-10a30 30 0 0 0 -30 -30h-33zm13-13h19a19 19 0 0 0 19 -19v-6a19 19 0 0 0 -19 -19h-19z'/%3e%3cpath id='E' transform='translate(-31.5)' d='m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z'/%3e%3cpath id='e' d='m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z'/%3e%3cg id='G'%3e%3cclipPath id='gcut'%3e%3cpath d='m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z'/%3e%3c/clipPath%3e%3cuse xlink:href='%23O' clip-path='url(%23gcut)'/%3e%3crect y='-35' x='5' height='10' width='26.5'/%3e%3crect y='-35' x='21.5' height='35' width='10'/%3e%3c/g%3e%3cpath id='M' d='m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z'/%3e%3cpath id='O' fill-rule='evenodd' d='m0 0a31.5 35 0 0 0 0 -70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0 -44 18.5 22 0 0 0 0 44'/%3e%3cpath id='P' fill-rule='evenodd' d='m-31.5 0h13v-26h28a22 22 0 0 0 0 -44h-40zm13-39h27a9 9 0 0 0 0 -18h-27z'/%3e%3cg id='R'%3e%3cuse xlink:href='%23P'/%3e%3cpath d='m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32'/%3e%3c/g%3e%3cpath id='S' d='m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z'/%3e%3cg id='star' fill='white'%3e%3cg id='c'%3e%3cpath id='t' transform='rotate(18 0%2c-1)' d='m0-1v1h0.5'/%3e%3cuse xlink:href='%23t' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(72)'/%3e%3cuse xlink:href='%23c' transform='rotate(-72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3cuse xlink:href='%23c' transform='rotate(216)'/%3e%3c/g%3e%3cuse id='star1' xlink:href='%23star' transform='scale(31.5)'/%3e%3cuse id='star2' xlink:href='%23star' transform='scale(26.25)'/%3e%3cuse id='star3' xlink:href='%23star' transform='scale(21)'/%3e%3cuse id='star4' xlink:href='%23star' transform='scale(15)'/%3e%3cuse id='star5' xlink:href='%23star' transform='scale(10.5)'/%3e%3c/defs%3e%3crect y='-50%25' x='-50%25' height='100%25' fill='%23009b3a' width='100%25'/%3e%3cpath d='m-1743 0 1743 1113 1743-1113-1743-1113z' fill='%23fedf00'/%3e%3ccircle r='735' fill='%23002776'/%3e%3cclipPath id='band'%3e%3ccircle r='735'/%3e%3c/clipPath%3e%3cpath fill='white' d='m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0 -3360 0z' clip-path='url(%23band)'/%3e%3cg transform='translate(-420%2c1470)' fill='%23009b3a'%3e%3cuse y='-1697.5' xlink:href='%23O' transform='rotate(-7)'/%3e%3cuse y='-1697.5' xlink:href='%23R' transform='rotate(-4)'/%3e%3cuse y='-1697.5' xlink:href='%23D' transform='rotate(-1)'/%3e%3cuse y='-1697.5' xlink:href='%23E' transform='rotate(2)'/%3e%3cuse y='-1697.5' xlink:href='%23M' transform='rotate(5)'/%3e%3cuse y='-1697.5' xlink:href='%23e' transform='rotate(9.75)'/%3e%3cuse y='-1697.5' xlink:href='%23P' transform='rotate(14.5)'/%3e%3cuse y='-1697.5' xlink:href='%23R' transform='rotate(17.5)'/%3e%3cuse y='-1697.5' xlink:href='%23O' transform='rotate(20.5)'/%3e%3cuse y='-1697.5' xlink:href='%23G' transform='rotate(23.5)'/%3e%3cuse y='-1697.5' xlink:href='%23R' transform='rotate(26.5)'/%3e%3cuse y='-1697.5' xlink:href='%23E' transform='rotate(29.5)'/%3e%3cuse y='-1697.5' xlink:href='%23S' transform='rotate(32.5)'/%3e%3cuse y='-1697.5' xlink:href='%23S' transform='rotate(35.5)'/%3e%3cuse y='-1697.5' xlink:href='%23O' transform='rotate(38.5)'/%3e%3c/g%3e%3cuse id='%26%23x3B1%3bCMi' y='-132' x='-600' xlink:href='%23star1'/%3e%3cuse id='%26%23x3B1%3bCMa' y='177' x='-535' xlink:href='%23star1'/%3e%3cuse id='%26%23x3B2%3bCMa' y='243' x='-625' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B3%3bCMa' y='132' x='-463' xlink:href='%23star4'/%3e%3cuse id='%26%23x3B4%3bCMa' y='250' x='-382' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B5%3bCMa' y='323' x='-404' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B1%3bVir' y='-228' x='228' xlink:href='%23star1'/%3e%3cuse id='%26%23x3B1%3bSco' y='258' x='515' xlink:href='%23star1'/%3e%3cuse id='%26%23x3B2%3bSco' y='265' x='617' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B5%3bSco' y='323' x='545' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B8%3bSco' y='477' x='368' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B9%3bSco' y='551' x='367' xlink:href='%23star3'/%3e%3cuse id='%26%23x3BA%3bSco' y='419' x='441' xlink:href='%23star3'/%3e%3cuse id='%26%23x3BB%3bSco' y='382' x='500' xlink:href='%23star2'/%3e%3cuse id='%26%23x3BC%3bSco' y='405' x='365' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B1%3bHya' y='30' x='-280' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B3%3bHya' y='-37' x='200' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B1%3bCru' y='330' xlink:href='%23star1'/%3e%3cuse id='%26%23x3B2%3bCru' y='184' x='85' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B3%3bCru' y='118' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B4%3bCru' y='184' x='-74' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B5%3bCru' y='235' x='-37' xlink:href='%23star4'/%3e%3cuse id='%26%23x3B1%3bTrA' y='495' x='220' xlink:href='%23star2'/%3e%3cuse id='%26%23x3B2%3bTrA' y='430' x='283' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B3%3bTrA' y='412' x='162' xlink:href='%23star3'/%3e%3cuse id='%26%23x3B1%3bCar' y='390' x='-295' xlink:href='%23star1'/%3e%3cuse id='%26%23x3C3%3bOct' y='575' xlink:href='%23star5'/%3e%3c/svg%3e";

var img$1F = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect fill='%23ed2939' width='900' height='600'/%3e%3crect fill='white' y='200' width='900' height='200'/%3e%3c/svg%3e";

var img$1E = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9600 4800'%3e%3cpath fill='%23d52b1e' d='M0 0h2400l99 99h4602l99-99h2400v4800H7200l-99-99H2499l-99 99H0z'/%3e%3cpath fill='white' d='M2400 0h4800v4800H2400zm2490 4430l-45-863a95 95 0 01111-98l859 151-116-320a65 65 0 0120-73l941-762-212-99a65 65 0 01-34-79l186-572-542 115a65 65 0 01-73-38l-105-247-423 454a65 65 0 01-111-57l204-1052-327 189a65 65 0 01-91-27l-332-652-332 652a65 65 0 01-91 27l-327-189 204 1052a65 65 0 01-111 57l-423-454-105 247a65 65 0 01-73 38l-542-115 186 572a65 65 0 01-34 79l-212 99 941 762a65 65 0 0120 73l-116 320 859-151a95 95 0 01111 98l-45 863z'/%3e%3c/svg%3e";

var img$1D = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3e%3crect width='1200' height='800' fill='%23E30A17'/%3e%3ccircle cx='425' cy='400' r='200' style='fill:white'/%3e%3ccircle cx='475' cy='400' r='160' style='fill:%23E30A17'/%3e%3cpolygon style='fill:white' points='583.334%2c400 764.235%2c458.779 652.431%2c304.894 652.431%2c495.106 764.235%2c341.221'/%3e%3c/svg%3e";

var img$1C = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 980 560'%3e%3cdefs%3e%3cradialGradient id='b' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='842.31' cy='103.66' r='25.859' gradientTransform='matrix(.18574 .04718 -.04532 .18635 233.798 198.77)'/%3e%3cradialGradient id='c' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='651.52' cy='550.46' r='25.859' gradientTransform='matrix(-.17642 -.07067 .06515 -.16392 430.544 377.876)'/%3e%3cradialGradient id='d' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='380.84' cy='740.37' r='25.859' gradientTransform='matrix(.0989 .0037 -.0045 .1943 442.362 123.304)'/%3e%3clinearGradient id='a'%3e%3cstop stop-color='white' offset='0'/%3e%3cstop stop-color='%23f15770' offset='1'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath d='M0 0h980v560H0z' fill='%23ce1126'/%3e%3cpath d='M0 0h653.333v560H0z' fill='white'/%3e%3cpath d='M0 0h326.667v560H0z' fill='%23006847'/%3e%3cg transform='translate(-.699 1.184) scale(1.16833)' fill='%23fcca3e' stroke='%23aa8c30'%3e%3cpath d='M466.96 303.53l.293 5.878 2.22-1.467-1.702-4.839z' stroke-width='.35'/%3e%3ccircle cx='466.703' cy='301.93' r='1.892' stroke-width='.3'/%3e%3cpath d='M474 312.69l-4.3-4.119-1.932 1.553 5.843 3.405z' stroke-width='.35'/%3e%3cpath d='M473.63 315.01c-.608-.815-.403-2.003.446-2.658.853-.655 2.037-.524 2.645.288.602.815.403 2.007-.448 2.662-.854.653-2.037.52-2.643-.292z' stroke-width='.3'/%3e%3cpath d='M507.04 251.22l4.407 4.384.512-2.219-4.028-2.7z' stroke-width='.35'/%3e%3ccircle cx='506.451' cy='250.09' r='1.845' stroke-width='.3'/%3e%3cpath d='M518.65 253.82l-6.733 1.921.554-2.224 5.79-.563z' stroke-width='.35'/%3e%3ccircle cx='519.742' cy='252.89' r='1.803' stroke-width='.3'/%3e%3cpath d='M496.03 287l-4.108-6.398.661-.33 4.647 5.489z' stroke-width='.35'/%3e%3ccircle cx='491.518' cy='279.115' r='1.909' stroke-width='.3'/%3e%3cpath d='M496.29 287.17l5.218.953.192-.715-4.37-1.732z' stroke-width='.35'/%3e%3ccircle cx='503.102' cy='288.18' r='1.889' stroke-width='.3'/%3e%3cpath d='M373.59 301.72c0 .91-.714 1.556-1.391 1.556-.672 0-1.22-.735-1.22-1.64 0-.909.548-1.644 1.22-1.644.677 0 1.391.824 1.391 1.728z' stroke-width='.3'/%3e%3cpath d='M373.56 304.65l1.195 6.566-1.59-.628-.57-5.705z' stroke-width='.35'/%3e%3cpath d='M375.01 302.42c.767.994-.531 2.511-1.91 2.889-1.377.375-3.097-.26-3.08-1.522.018-1.432 2.01-.687 2.545-.853.825-.26 1.62-1.584 2.445-.514z' stroke-width='.3'/%3e%3cellipse cx='363.566' cy='312.49' rx='2.045' ry='1.483' stroke-width='.3'/%3e%3cpath d='M367.03 312.14l6.307-.314-1.068-1.256-5.18.563z' stroke-width='.35'/%3e%3cpath d='M367.56 311.41c.526 1.597.57 3.774-1.218 3.545-1.791-.233-1.452-1.833-1.591-2.45-.256-1.121-1.307-2.13-.228-3.223 1.08-1.097 2.508.528 3.037 2.128z' stroke-width='.3'/%3e%3cellipse cx='347.006' cy='276.955' rx='1.236' ry='1.881' stroke-width='.3'/%3e%3cpath d='M347.03 281.12l.144 6.11-1.59-1.444.112-4.866z' stroke-width='.35'/%3e%3cpath d='M349.39 279.26c.322 1.41-1.745 2.204-3.152 1.942-1.406-.258-2.47-.993-2.257-2.289.213-1.299 1.96-1.007 2.556-.647.596.355 2.405-.985 2.853.994z' stroke-width='.3'/%3e%3cellipse cx='336.229' cy='286.5' rx='2.13' ry='.973' stroke-width='.3'/%3e%3cpath d='M340.06 286.5l4.797-.325 2.043 1.58-6.915-.26z' stroke-width='.35'/%3e%3cpath d='M338.3 283.93c1.294.041 2.187 1.467 2.002 2.981-.183 1.514-1.348 2.738-2.54 2.553-1.194-.192-1.108-1.199-1.08-1.5.03-.304.696-.852.768-1.341.07-.486-.341-1.57-.187-2.073.157-.505.455-.638 1.037-.62zm-3.87-37.19c-.536.852-1.555 1.499-2.07 1.167-.518-.333-.333-1.52.201-2.373.533-.85 1.385-1.274 1.902-.941.517.334.5 1.294-.033 2.147z' stroke-width='.3'/%3e%3cpath d='M329.08 256.35l2.678-6.311-.4-.346-3.036 4.432z' stroke-width='.35'/%3e%3cpath d='M331.27 250.05c-1.326-.97-1.619-1.964-1.192-2.943.425-.979 1.419-.344 1.419-.344s.653.722 1.135.978c.483.262 1.252-.083 1.819.72.569.807.227 1.613-.228 1.816-.455.2-1.845.576-2.953-.227zm-11.13-.83c.95.543 1.456 1.458 1.13 2.056-.328.59-1.367.634-2.32.09-.947-.54-1.453-1.458-1.125-2.053.327-.594 1.363-.635 2.315-.093z' stroke-width='.3'/%3e%3cpath d='M322.92 251.99l4.946 2.966-.144 2.333-5.368-4.612z' stroke-width='.35'/%3e%3cpath d='M322.88 252.55c-1.097 1.225-2.104 1.41-3.013.868-.912-.543-.177-1.473-.177-1.473s.78-.574 1.089-1.03c.31-.459.06-1.272.914-1.751.855-.478 1.605-.043 1.753.44.144.48.35 1.922-.566 2.946z' stroke-width='.3'/%3e%3c/g%3e%3cg fill='%23aa8c30'%3e%3cpath d='M546.112 356.319s-.42.28-.65.733c-.22.452-.473 1.362-.473 1.362l.026-2.22.748-.432.35.557z'/%3e%3cpath d='M546.44 354.929s-.517.876-1.744.807c-1.221-.066-1.822-.636-1.97-1.262-.15-.62-.15-1.074.245-1.801.399-.723-.579.69-.579.69v1.381l.896 1.062.76.234.752.048.961-.317.645-.488zm6.461 11.286s-.619.322-1.091.15c-2.898-1.028-5.33-2.727-5.33-2.727l5.82 3.615zm3.621 1.647s-.064 1.018-1.191 1.524c-1.125.507-1.914.274-2.326-.213-.41-.488-.615-.891-.588-1.72.036-.828-.205.88-.205.88l.619 1.232 1.272.53.79-.139.686-.302.714-.728.36-.734zm37.212-72.961s-.148.228-.148.605c0 .38-.023 1.062-.023 1.062l-1.268-1.411.64-.834zm-.678-1.835c.074 1.01-1.392 2.446-2.487 1.992-1.094-.45-1.89-1.59-1.291-2.727.596-1.136-.3.43-.3.43l.152 1.667 1.041.957 1.296.077 1.021-.577.621-1.14zm15.387 2.746s-.248-.692-.121.087c.12.785-.883 2.463-2.057 2.31-1.166-.151-1.702-1.172-1.602-2.122.099-.945-.198.328-.198.328l.185 1.266.626.593.895.53 1.044-.18.947-.606.421-.89v-.634z'/%3e%3cpath d='M603.173 296.98s.04.53-.656.91a81.278 81.278 0 00-2.015 1.162l4.33-1.261-.359-1.05-1.3.24zm-26.217 34.337s-.233.255-.246.793a6.47 6.47 0 00.11 1.192l-2.426-3.837.72-.456 1.843 2.308zm-1.332-3.61c-.432 1.012-2.198 1.654-3.045 1.162-.846-.49-1.566-2.324-.532-3.13l-.538.469-.275 1.045.389 1.097.846.957.781.24 1.247-.25.907-.708s.658-1.89.22-.882zm8.552 8.798s.024.452-.77.452c-.795 0-2.462.026-2.462.026l4.03.778.2-.804z'/%3e%3cpath d='M589.13 337.45c.361 1.346-.834 2.642-2.376 2.189-1.542-.458-1.957-1.989-1.472-2.814l-.381.961.28 1.28.946.823.967.21.989-.244 1-.959.248-1.145zm-151.8 17.105c.416.47-.23 2.221-1.973 2.928-1.742.703-2.606.032-3.07-.556-.464-.588-.432-1.21-.432-1.21l-.248.317.233.912.881.755 1.54.335 1.147-.216 1.129-.607.579-.607.498-.74.067-.907-.283-.457h-.067l-.027.036z'/%3e%3cpath d='M435.776 358.376s-.298.098-.563.54c-.263.435-.364 1.207-.364 1.207l-.135-2.05.898-.473zm-5.806 6.168s-.165.439.299.672c.465.24 1.56.506 1.56.506l-2.854.1-.298-1.108 1.293-.17zm-.97 1.776s.033.102.027.29c-.01.19-.06.467-.226.821-.333.703-.465 1.516-1.492 1.31-1.03-.2-1.46-.976-1.56-1.646-.1-.673-.332-.941-.332-.941v.905l.629 1.515 1.028.473h.897l.697-.27.33-.91.17-.74z'/%3e%3cpath d='M421.803 366.122s.333 1.313 1.793 1.346c1.46.037 1.825-.407 1.825-.407l.165.507-.53.268-1.268.144-1.116-.221-.519-.384-.395-.689zm-14.476-38.953s.05.15-.05.631c-.1.477-.994 1.616-2.663 1.639-1.666.028-2.362-.531-2.81-1.086-.449-.554-.524-1.337-.524-1.337l-.05.833.647 1.035 1.642.773 1.568.01 1.593-.466.697-.773.163-.847-.213-.41zm-2.64 3.54s-.596.052-.895.318c-.297.268-.56.592-.56.592l-.024-1.981 1.479.112zm-7.173 5.235s-.115.115.749.505c.863.388 4.795.806 4.795.806l-6.306-.17.233-1.076zm-.713.116s-.017.24-.331.877c-.314.64-1.109 2.34-2.437 2.105-1.33-.236-1.162-1.163-1.162-1.312 0-.153-.018-.473-.018-.473l-.231.961.314.672.547.34 1.08.134.728-.322.796-.759.416-.807.332-.858zm-3.4.164s-.036.3-1.08.339c-1.045.027-2.537-.424-2.537-.424l.496.621.863.22 1.078.016.846-.083zm-3.213-44.292s.232.675-.365 1.112c-.596.436-1.893.705-2.721.233-.83-.471-2.325-1.985-2.325-1.985l.7 1.248 1.093.91 1.525.434 1.46-.23.665-.578.2-.469z'/%3e%3cpath d='M385.737 293.954s.032.173 0 .843c-.033.674-.3 1.787-.3 1.787l1.328-2.967-.53-.472zm-8.225 2.324s-.198-.204.198.673c.398.878 3.65 4.006 3.65 4.006l-5.176-4.371.596-.848.731.54zm-1.73.503s-.664.41-1.261.439c-.597.035-1.592-.032-1.725-.741-.132-.703.199-1.006.199-1.006l-.43.975.165.535.765.44 1.062.101.96-.471.266-.27zm-2.09-2.22s.064.202-.898.068c-.962-.135-2.122-1.245-2.122-1.245l.762 1.21 1.627.674z'/%3e%3c/g%3e%3cg fill='%239ca168'%3e%3cpath d='M612.45 280.238c-.47 5.88-6.27 8.882-9.305 11.08-3.04 2.2-4.507 4.926-4.507 4.926l-1.02 3.428-.5 2.193-.098.763c.2.61.46 1.67.497 3.26.079 2.673-.17 6.483-.17 6.483l4.082-2.928 2.958-1.111.895-.144s-3.284 3.266-4.578 6.8c-1.292 3.535-3.683 11.042-8.162 13.462-4.476 2.426-7.268 1.418-8.76 2.731-1.49 1.31-1.543 1.662-1.543 1.662l-1.907 2.611-1.51 1.952-1.411.976-.891.722c-.031.728-.119 1.672-.362 2.54-.49 1.726-1.072 3.646-1.072 3.646s.894-.544 1.98-.679c1.078-.14 2.086-.127 2.086-.127s-.844 1.034-1.141 2.044c-.3 1.011.198 7.07-5.573 10.703-5.775 3.635-20.474 3.063-20.474 3.063l-2.784 1.108-2.62 1.957-2.393 2.623-.179.707s-1.807 2.204-3.106 3.065c-1.29.857-4.276 2.823-4.276 2.823s2.534-.096 3.385.201c.843.309 5.372 2.327 5.372 2.327s-3.318-.067-5.573.806c-2.259.875-12.541 6.698-17.518 6.53-4.974-.165-12.079-7.439-12.079-7.439l-3.218-2.254-5.34-1.041-6.605-.372.094-.865.125-1.068s2.241-.254 5.846.17c3.082.37 4.108 1.393 6.694 1.694 2.59.303 4.502-.074 5.45-.5.946-.437 8.932-7.199 8.932-7.199l8.982-3.151 3.433.5 1.52.406 1.396.404s-.47.733-1.469 1.667c-.994.931-2.241 1.566-2.241 1.566l1.098.878 5.67-.905 1.852.478s.144.039.533.284c.088-.409.315-1.257.826-1.924.697-.907 3.883-3.508 5.248-4.416 1.374-.908 1.67-1.035 2.12-1.515.446-.48 2.288-5.229 2.288-5.229l.25-2.419 6.271-6.036 4.228-4.493 1.844-5.124-.2-1.033s1.519 1.564 1.244 4.744c-.273 3.18-.971 4.292-.971 4.292s4.277-2.954 6.57-3.965c1.837-.81 3.194-.756 3.664-.705.604-.343 2.252-1.362 3.251-2.826 1.246-1.815 1.57-2.35 1.57-3.08 0-.733.2-4.267.2-4.267l-.4-10.83 3.684-8.153 5.348-4.797 1.021-.607s-.425 1.135-.5 1.92c-.074.781-.074 2.168-.074 2.168s2.711-3.708 4.106-4.39c.319-.155.601-.288.856-.407a10.71 10.71 0 001.104-2.994c.43-2.053.5-4.81.5-4.81l.082-4.485-.871-3.487-2.49-6.69-.1-8.808-1.864-2.515s1.766-.138 3.954 3.02c2.189 3.157 2.839 7.598 2.839 7.598l5.083-15.6s1.364 1.842 2.328 4.921c.976 3.08 1.272 5.175 1.272 5.175l2.001-4.33c-.017.046-.06.3.24 1.529.345 1.437 3.455 3.232 2.985 9.113zm-103.194 99.711s-.951-2.388-5.845-4.812c-4.895-2.421-8.54-2.893-8.54-2.893l-.054 1.8 7.683 3.35 3.83 3.131 2.925-.576z'/%3e%3cpath d='M544.232 365.291c.472-.63 4.608-4.314 6.72-5.4 2.117-1.088 4.925-1.287 4.925-1.287 2.913-.534 3.386-.102 10.105-3.812 6.72-3.709 8.213-7.978 9.506-9.012 1.293-1.037 3.655-1.287 3.655-1.287s-2.812 3.307-5.272 6.006c-2.464 2.705-5.104 4.418-8.888 6.97-3.78 2.549-11.64 2.676-11.64 2.676-3.312.76-4.43 1.562-6.273 3.177a22.266 22.266 0 00-3.092 3.376s-.217-.775.254-1.407zm18.54-19.461c-6.218 5.68-8.262 10.957-8.262 10.957s5.526-4.744 8.362-7.47c2.838-2.727 6.816-4.042 8.61-5.708 1.793-1.667 1.892-3.078 3.035-4.141 1.143-1.058 1.994-1.565 1.994-1.565s-2.74-2.118-13.74 7.927zm-13.12 13.147s2.66-1.167 3.666-3.555c.748-1.767.35-2.218 1.494-4.24 0 0 6.469-6.248 8.755-8.937 4.083-4.797 2.241-8.733 2.241-8.733s.447 2.02-1.243 4.138c-1.693 2.12-10.039 7.826-11.05 11.11-1.014 3.282-.447 3.4-.896 5.147-1.034 4.022-2.967 5.07-2.967 5.07zm-4.299 16.138s-3.254-2.184-6.9-1.952c-7.432.473-13.719 5.047-18.627 5.182-4.915.136-6.844-2.328-10.637-4.914-4.046-2.759-14.066-2.358-14.066-2.358l-.063.239-.07.292s6.89.07 9.827.885c5.612 1.548 8.636 7.39 15.008 7.018 8.268-.488 15.047-5.523 18.427-5.506 5.807.038 7.1 1.114 7.1 1.114zm-36.867-3.764s5.765 1.039 10.243-2.246c4.479-3.282 9.801-7.723 12.74-7.925 2.936-.202 6.023.555 6.023.555s-3.736-1.666-6.718-1.618c-2.99.052-6.023.457-8.813 2.123-2.786 1.667-4.13 4.693-7.164 6.613-3.038 1.922-6.312 2.498-6.312 2.498zm-1.03 7.752c-.77 0-1.668.5-1.967.453-.297-.048-2.063-1.869-4.527-3.179-2.465-1.312-6.137-2.105-6.137-2.105s-.458.114.364.389c.82.28 3.856 1.31 5.795 2.219 1.943.913 3.906 2.98 4.083 3.308.174.333.871 1.261 2.314 1.21 1.445-.049 2.017-.877 1.863-1.438-.143-.553-1.017-.857-1.788-.857zm4.056-5.602s2.283 1.302 6.069 1.21c8.065-.202 13.14-5.722 18.423-7.741 5.27-2.023 7.975-.272 7.975-.272s.14-.285-.03-.408c-.745-.557-3.194-1.886-5.894-1.846-8.86.135-17.151 5.721-20.765 7.235-3.495 1.462-5.777 1.822-5.777 1.822zm85.747-61.07c-2.717 2.806-6.772 11.767-8.561 14.213-1.789 2.45-4.034 3.18-5.001 4.167-.851.865-4.106 5.249-4.853 6.312-.745 1.058-.971.756-1.493 1.21-.52.453-.796.48.074.25.871-.223 1.145-.755 2.488-2.269 1.342-1.516 1.27-2.198 3.407-4.115 2.14-1.922 6.016-4.106 7.942-6.465 1.921-2.355 5.848-11.475 7.9-13.695 2.224-2.409 6.107-3.84 6.107-3.84s-3.06-.892-8.01 4.232zm-13.785 16.993s-.1-1.617 1.891-3.992c1.99-2.375 2.688-2.068 4.278-5.554 1.592-3.483 2.294-6.864 3.585-10.549 1.291-3.69 3.532-7.326 3.532-7.326s-2.089.202-4.23 3.084c-2.143 2.878-5.527 8.13-7.269 13.279-1.742 5.15-1.787 11.057-1.787 11.057zm-2.54 3.376s.747-.398.844-4.892c.103-4.494-.246-10.803 1.049-13.934 1.291-3.129 8.161-10.655 8.161-10.655s-2.839.707-6.819 3.888c-3.977 3.179-5.672 7.172-5.473 10.196.2 3.035 1.894 6.465 2.043 9.446.143 2.976.196 5.951.196 5.951zm16.172-30.926s1.695-6.092 2.388-7.575c.703-1.483.734-2.357 4.181-6.225 1.978-2.22 3.92-3.64 4.744-6.733.831-3.101.801-11.746.801-11.746s-.896.803-1.625 2.32c-.733 1.518-.2 7.133-1.495 9.724-1.296 2.595-4.213 8.69-5.675 10 0 0-.297-4.375.234-8.786.53-4.408 2.026-5.752 2.687-8.649.664-2.89.265-10.367.265-10.367s-2.353 2.428-3.519 5.218c-1.156 2.793-1.855 7.807-1.889 11.577-.035 3.772.865 6.835.998 8.988.127 2.154.294 3.165-.568 5.52-.861 2.356-.429.74-.961 3.03a52.855 52.855 0 01-1.092 4.007zm-5.37-33.053s2.054 2.59 1.72 5.553c-.332 2.96-1.458 6.867-.297 9.963 1.162 3.094 2.888 3.4 3.353 5.18.466 1.784.495 5.266.495 5.266s.962-6.613.3-8.43c-.662-1.814-.962-.977-1.923-2.894-.964-1.915.031-7.166-.698-10.228-.729-3.065-2.95-4.411-2.95-4.411z' fill='%23717732'/%3e%3cpath d='M469.61 379.429s.624-1.74 4.804-3.783c4.18-2.046 10.473-4.8 11.071-4.446.598.355-.324 2.629-.324 2.629l-4.054 1.234-3.234 1.896-3.782 2.447z'/%3e%3cpath d='M480.266 368.435c-5.342.202-8.255 1.515-9.282 1.718-.354.07-1.123.615-1.78.29-1.252-.62-2.342-2.34-2.342-2.34l-1.129-.943-.265 3.834-7.797-6.761-.831 4.472-.995 2.058-7.73-7.307.365 5.654s-2.023.266-2.123.202l-5.508-3.837-1.624.54 1.792 3.33-6.97.541s-.562.306-1.509 1.176c-.945.872-1.469 1.691-1.469 1.691s-.21.355.037.518c.25.164 2.155.127 2.752-.102.597-.228.982-1.06 1.157-.72.172.344.396 1.871 1.319 1.72.92-.153 4.159-2.607 6.469-1.528 2.573 1.199-3.335 2.941-2.724 4.772.605 1.82 4.863 1.047 5.945.463 1.082-.577 4.315-4.61 5.636-3.078 1.842 2.134-3.867 3.787-2.81 5.918 1.02 2.057 4.205 1.594 5.746.708 1.545-.882 5.13-6.4 5.925-5.212 1.379 2.067-3.024 4.04-1.919 5.64 1.109 1.602 3.547-.058 5.166-1.198 1.617-1.136 2.264-3.84 4.502-5.099 2.24-1.262 2.089-.735 2.704-.757.618-.028 2.347-1.74 2.347-1.74l5.265-2.236 2.576.188 1.33.63 2.639.369.31-2.225s-3.053-1.428-5.175-1.35zm-42.123.042l1.115-1.978-.631-.96s-1.858-1.04-3.55-2.754c-1.692-1.72-2.31-2.113-3.086-2.5-.775-.391-3.382-2.089-3.382-2.089l-1.176-4.338-.695-1.254-2.01.788-2.65-9.332-.516-1.672-1.094-.064-2.171 5.657-2.428-3.533-.617-7.733-1.513 1.697-1.95 1.98-3.463-7.01s-.282-.18-.459.404c-.175.569-.473 2.782-.257 4.095-.926-.578-2.518-1.67-4.649-3.506-3.518-3.03-4.364-4.587-4.364-4.587l-1.64-3.707 1.54-3.259.772-3.887-3.384 1.385-.597-8.786-.523-2.774-4.081 5.832s-1.59-2.248-1.59-2.5c0-.25.073-5.552.073-5.552l-1.095-.33-1.67 3.13s-1.603-3.23-2.31-3.919c.113-1.24.298-4.409-.455-6.856-.955-3.115-2.07-4.773-1.673-7.315.401-2.543 1.433-2.786 1.315-3.918-.12-1.129-1.792.73-1.234-.765.558-1.492 5.893-4.886 4.778-6.663-1.116-1.778-6.25 2.787-5.057-.28 1.193-3.07 6.13-3.113 6.41-7.392.173-2.666-4.66 1.657-5.097.322-.437-1.331 2.984-4.076 2.947-5.813-.04-1.736.637-1.936-.32-2.866-.954-.929-3.9 3.633-3.9 3.633l-3.224-1.214-1.117 4.607-.993 3.915-3.982-2.338 1.074 4.765.957 4.644-4.142-1.051 2.191 3.956 2.853 2.9 1.763 2.39 1.277.686 1.71 1.7.597 2.544s.997 2.788.997 2.91c0 .12.158 2.744.158 2.744l.04 1.815-.09 1.41-.06.531-.088.606-.035 1.662c-.779.075-2.043-1.191-2.505-.402-.496.86 2.39 3.08 1.842 3.635-.547.559-4.777-.857-5.025.505-.25 1.364.398 3.28 2.837 3.887 2.437.607 8.11 1.918 7.166 3.027-.947 1.115-7.117-3.38-6.867-.097.248 3.279 2.389 4.642 3.981 5.25 1.592.607 7.811-.098 7.464 1.363-.348 1.466-5.076-.455-5.524 1.665-.447 2.124 3.285 2.423 4.084 2.423.795 0 3.381-.099 4.376.658.997.757 4.478 4.443 6.67 6.311 1.859 1.584 5.873 4.365 7.045 5.173l-.057-.007c-1.18-.11-3.623-.369-4.011.511-.495 1.136 9.359 4.649 6.53 5.74-2.826 1.086-5.873-3.01-6.689-.507-.818 2.503 1.872 4.62 3.407 5.53 1.532.91 10.27.185 8.558 2.16-1.712 1.983-8.043-1.332-8.102 1.013-.06 2.345 4.22 6.059 6.41 5.955 2.191-.099 4.597-3.614 5.594-1.715.996 1.898-1.693 2.667.417 3.172 2.11.502 3.603-2.162 6.051-1.679 2.448.486 6.292 2.037 8.442 3.996a121.125 121.125 0 014.358 4.222z'/%3e%3cpath d='M472.17 378.342c1.494.027 1.692.833 1.892.81.2-.028 2.713-2.173 5.1-3.485 2.39-1.315 6.022-2.095 6.022-2.095l.226.328s-4.327 1.081-6.419 2.548c-2.59 1.819-4.628 2.957-4.755 3.283-.125.325-1.068.96-2.537.986-1.467.02-2.091-.855-2.091-1.29 0-.426 1.07-1.108 2.561-1.085zm13.039-6.605s-1.292.135-2.023-.507c-.73-.64-2.356-1.21-3.917-1.21-1.558 0-4.056.86-6.035 2.756-.16.155-.557.884-2.26 2.023.592.114 1.738-.671 2.987-1.682 1.793-1.458 4.048-1.853 5.64-2.083 1.592-.242 2.589.67 3.32 1.171.729.51 2.22.369 2.22.369zm-77.4-31.631c.16-.068.136-.42.03-1.032-.24-.09-1.204-.496-3.369-1.787-2.537-1.515-7.813-5.708-7.813-5.708s2.193 2.123 4.382 4.092c2.188 1.967 6.122 4.39 6.122 4.39l.02.016c.335.033.576.052.628.029zm54.642 38.707s.796-1.045 2.214-3.325c1.418-2.282 2.712-3.011 2.91-3.29.2-.276-.547-1.388-.971-2.248-.421-.858-.347-1.765-.347-1.84 0-.076.52 1.336 1.566 2.12a14.6 14.6 0 011.676 1.437s2.08-.277 2.133-.681c.05-.406-.052-.682-.4-.832-.346-.153-.746.31-1.691-.105-1.965-.854-2.763-3.835-3.933-3.935-1.168-.1-.333 3.157-.846 3.204-1.817.176-3.235-6.612-7.59-6.89-3.064-.198-3.608.38-3.757 1.06-.147.68 3.708 4.749 2.414 5.324-1.294.586-5.4-6.384-8.386-6.463-2.984-.075-3.234 1.064-3.01 1.719.222.657 3.309 1.236 2.587 3.41-.7 2.108-3.707-3.255-6.468-2.956-2.762.303-3.062.505-3.187 1.287-.122.783.971 1.919.574 2.196-.398.277-2.141.2-3.534 1.16-1.392.963-3.335 3.587-3.335 3.587s1.817-2.574 4.23-2.853c2.413-.275 8.511.027 8.511.027s-.82-.507-1.716-1.314c-.896-.809-1.669-2.448-1.669-2.448s1.345 1.263 2.64 2.321c1.292 1.064 2.91 1.87 2.91 1.87s2.588.253 2.763.557c.173.303-.077.907-1.144 2.066-1.072 1.162-2.614 2.529-2.614 2.529s2.587-1.97 3.085-2.4c.498-.428 2.29-1.792 2.29-1.792s1.892.25 2.09.202c.198-.05.108-.707-1.161-2.574-1.268-1.868-2.472-3.89-2.472-3.89s1.56 1.433 3.135 3.511c1.575 2.077 1.344 3.036 1.99 3.14.648.1 1.692.242 2.164.219.636-.033.473.905-.623 2.574-1.093 1.666-1.739 3.809-1.739 3.809s1.117-1.793 2.312-3.027c1.194-1.238 1.818-2.704 2.29-2.78.475-.074 2.074.126 2.3.03.22-.104-.384-.76-1.229-2.48-.846-1.714-1.12-4.09-1.12-4.09s.821 2.227 2.116 3.84c1.294 1.614 1.792 2.914 2.073 2.932.281.013 1.282-.116 2.008-.106.365.007.406-.08.447.15.124.713-.175 1.139-1.044 2.78-.871 1.64-1.442 3.258-1.442 3.258zm-33.045-19.165c1.866.636 2.587.636 2.587.636s-2.563-1.518-3.235-3.664c-.674-2.143-.074-6.665-1.169-6.612-1.095.052-1.718 3.332-2.812 2.677-1.096-.655.372-6.693-.822-9.264-1.193-2.577-4.006-4.37-4.654-3.437-.646.94-.495 6.489-2.238 5.278-1.742-1.21.15-5.958-.375-8.129-.521-2.173-1.839-3.737-2.834-3.207-.998.534.394 4.596-1.172 4.645-1.567.052-1.343-2.854-2.015-3.13-.67-.277-.896.585-1.27.03-.373-.559-.172-2.629-.994-2.427-.821.202-.671 1.793-.449 2.673.224.886.721 2.149 1.07 2.73.347.581 1.593 1.31 1.495 1.794-.1.48-.75.884-1.592.907-.848.026-2.764-.053-2.764-.053s2.039.635 2.81.711c.772.074 2.268-.328 2.639.353.372.684 2.165 3.104 2.165 3.104s.421-1.262.646-3.486c.224-2.217.124-4.166.124-4.166s.597 2.578.522 4.119c-.072 1.536-.646 4.541-.646 4.541s1.69 1.414 1.195 1.793c-.497.38-2.265.331-4.33.304-2.064-.027-5.001-.733-5.001-.733s2.638 1.264 4.477 1.564c1.843.306 5.849.405 5.849.405l2.737 3.102s1.31-2.25 1.493-4.487c.184-2.241-.05-4.839-.05-4.839s.572 2.337.674 4.333c.098 1.997-.65 5.528-.897 5.83-.25.305-1.647 1.173-2.879 1.483-1.807.455-5.433.914-5.433.914s3.345.447 5.749-.127c2.406-.568 2.687-1.237 3.358-.831.674.406 1.271 1.138 1.271 1.138s1.44 1.117 2.091 1.412c.1.225-1.111.725-1.727 1.113-.612.386-2.231 1.135-2.231 1.135s2.365-.859 3.41-1.135c.523-.143 1.792-.608 1.792-.608l.696.38s.05-.505-.148-1.917a41.847 41.847 0 00-.499-2.78s.821 1.289 1.072 2.5c.246 1.211.246 2.447.246 2.447s.2.35 2.067.981zm-47.678-54.624s.532-2.56.532-5.519c0-2.967-2.06-7.545-2.39-8.013a7.528 7.528 0 01-.531-.878l1.392-2.15-1.79 1.41s-.994-.203-1.857-.739a3.978 3.978 0 01-1.295-1.344s.915.676 1.792 1.042c.875.362 1.094.235 1.094.235l-.691-2.988s-.913-.364-2.945-1.495c-2.031-1.132-3.863-2.907-3.863-2.907s2.748 1.657 4.3 2.3c1.554.649 2.43.69 2.43.69s1.632-.488 2.468-.974c.835-.483 2.549-1.777 2.549-1.777s-1.633.931-2.708 1.173c-1.075.245-2.428.4-2.428.4l-.48-3.63-1.71-1.776c-1.352-1.779-2.391-4.321-2.391-4.321s1.394 1.773 2.512 2.621c1.115.853 2.149 2.223 2.149 2.223s1.273-.688 2.507-1.533c1.232-.847 4.298-3.071 4.298-3.071s-1.75.927-4.179 2.06c-2.43 1.13-2.51 1.011-2.51 1.011s-.197-1.574.161-2.263c.36-.684 1.117-1.816.996-2.502-.12-.69-.636-.446-.836-1.011-.2-.568.637-4.036.637-4.036s.2 1.251.24 1.894c.04.644-.319 1.535.557 1.535.876 0 4.977-4.119 5.493-4.887.517-.766 1.276-2.866-.878-2.017-2.147.847-1.634 2.682-3.421 2.542-.519-.04-1.115-2.341-1.792-1.777-.677.57-2.19 1.98-2.47 3.596-.276 1.615.36 4.08-.556 4.805-.917.728-1.712-2.786-3.505-2.303-1.79.485-2.188 2.948-1.909 3.918.28.968 4.18 5.491 2.947 6.06-1.236.564-4.262-3.84-5.894-.85-1.633 2.986 5.136 6.059 5.97 6.786.836.729.082.932 1.275 2.424 1.195 1.491 2.789 1.858 3.624 2.87.834 1.009 3.304 5.81 3.304 8.92 0 3.111-.198 4.246-.198 4.246zm17.979 26.215s-1.658-1.935-1.108-5.111c.547-3.18 2.738-8.788 1.99-9.494-.745-.704-3.083 3.434-3.682 2.477-.598-.961 1.344-6.565.35-8.89-.998-2.32-1.095-3.784-3.086-3.582-1.993.201-2.837 6.765-3.782 5.605-.948-1.16.545-4.087-.1-5.653-.648-1.566-.997-2.123-1.992-1.873-.994.254-1.443 3.282-2.14 3.235-.697-.052-1.842-3.641-3.284-3.128-1.443.502 3.432 6.863 3.432 6.863s.87-.757 1.32-1.842c.448-1.088.895-2.273.895-2.273s.4 2.07.05 2.879c-.347.805-.621 2.701-.621 2.701s-1.196.378-3.16.073c-1.966-.299-3.584-1.108-3.584-1.108s1.32.884 3.333 1.412a125.61 125.61 0 014.156 1.189s.525.655 1.418 1.84a436.86 436.86 0 001.668 2.195s.574-1.21 1.146-3.204c.572-1.994 1.94-5.275 1.94-5.275s-.423 3.963-.897 5.906c-.47 1.946-.969 4.696-.969 4.696s-1.742-.175-4.08-.605c-2.339-.433-5.526-1.236-5.526-1.236s2.788 1.111 5.501 1.842c2.711.727 4.404 1.186 4.404 1.186l2.13 2.816s.583-1.024 1.429-2.207c.845-1.193 1.494-2.807 1.494-2.807s-.374 2.2-1.022 3.511c-.647 1.313-1.095 2.095-1.095 2.095s-1.37.33-2.637.3c-1.27-.022-3.858-.05-3.858-.05s2.166.731 3.882 1.015c1.717.275 2.962.45 2.962.45s.124.781 1.045 2.098c.919 1.31 2.078 1.954 2.078 1.954z' fill='%23717732'/%3e%3c/g%3e%3cpath d='M481.47 388.624s-.972-1.045-2.265-1.727c-1.293-.679-1.728-.478-1.728-.478l-.599-.213 1.134-2.955 8.522-8.142 1.319-8.181.314-.01 4.937-.05-.052 11.168 1.566.709 9.512 5.704-.03 2.483s-.47.167-1.39.53c-.922.367-1.143.637-1.143.637l-3.59.337-6.269-4.546-2.59-2.722-4.725 6.055-2.924 1.4z' fill='white'/%3e%3cpath d='M488.175 366.916s-.14.431-.2 1.69c-.065 1.257.082 7.855-.24 8.758-.32.9-4.908 2.794-7.531 5.079-2.62 2.293-2.719 3.973-2.719 3.973s-.864.067-2.49.672c-1.625.603-2.355 1.514-2.355 1.514s.963-4.07 5.208-7.838c4.25-3.775 6.304-4.093 6.776-4.726.476-.63 0-7.85.102-8.432.096-.58.607-.631.958-.682.35-.05 2.491-.007 2.491-.007zm10.83 24.114s.67-1.31 1.1-1.75c.427-.437 1.461-1.178 1.461-1.178s.161-.166-2.16-1.178c-2.324-1.008-3.518-.673-5.175-1.848-1.659-1.177-3.319-3.199-3.319-3.199l-2.223 1.985s1.33 1.885 2.59 3.097c1.256 1.209 4.11 1.615 5.372 2.322 1.261.709 2.355 1.749 2.355 1.749z' fill='%23016848'/%3e%3cpath d='M492.335 366.869s2.514-.15 2.864.24c.347.388.296.82.31.948.01.122.13 6.099-.31 8.065-.468 2.053-1.529 4.103-2.128 4.71-.598.606-4.377 3.908-6.17 5.655-1.792 1.749-3.615 4.244-3.615 4.244s-.664-.741-1.228-1.451c-.561-.706-1.131-.942-.997-1.412.132-.47 2.026-3.3 5.045-5.285 3.018-1.987 5.542-4.24 6.104-7.47.569-3.233.125-8.244.125-8.244z' fill='%23cd202a'/%3e%3cpath d='M509.135 387.292s-.604-.61-2.73-.644c-2.135-.037-2.31.285-2.31.285s-1.17-1.477-3.05-2.7c-1.883-1.226-3.301-1.045-5.323-2.376-2.024-1.334-3.085-3.278-3.085-3.278l1.559-3.166s1.742 2.45 3.548 3.78c1.81 1.33 5.82 2.626 7.1 3.748 1.277 1.116 4.292 4.35 4.292 4.35z' fill='%23cd202a'/%3e%3cg transform='translate(-.699 1.184) scale(1.16833)'%3e%3cpath d='M452.73 299.48s-4.686-1.817-4.347-3.462c.341-1.64 10.824-4.404 10.824-4.404l.167-2.765s-1.533-.086-4.175.778-6.817 1.987-11.328 1.987c-2.74 0-4.226-.287-4.97-.511-.484-.147-36.95-2.289-38.14-2.277-.513.01-1.166-.007-1.99-.063-4.855-.346-7.978-7.778-7.978-7.778l-2.3.402s.706 3.652-.513 3.975c-2.384.635-18.229-7.837-18.229-7.837l-.875 3.436s9.688 5.183 9.396 7.11c-.292 1.926-3.164 1.78-3.164 1.78l1.231 2.31c.435.039 15.95.787 16.214 5.446.108 1.881-3.805 2.995-3.805 2.995l1.305 1.593v.793s8.617.051 11.003 1.384c2.385 1.334 3.6 3.258 6.523 4.936 2.92 1.68 22.752 1.27 25.85.399 3.503-.987 5.655-4.956 11.35-6.684 5.696-1.726 7.536-1.813 7.536-1.813z' fill='%2330c2dc' stroke='%230872a7' stroke-width='.7'/%3e%3ccircle cx='373.416' cy='292.05' r='2.745' fill='white' stroke='%230872a7' stroke-width='1.37'/%3e%3ccircle cx='389.095' cy='279.26' r='2.746' fill='white' stroke='%230872a7' stroke-width='1.37'/%3e%3ccircle cx='454.822' cy='299.74' r='2.817' fill='white' stroke='%230872a7' stroke-width='1.37'/%3e%3cpath d='M361.11 275.15c-.895 2.072 2.638 6.005 5.11 6.437 2.47.432 3.833-.171 4.26-1.382.427-1.214.095-2.528-.469-3.282-1.576-2.12-8.01-3.847-8.9-1.773z' fill='%23f8c83c'/%3e%3cpath d='M368.9 278.31c-.067-1.252-2.129-2.466-3.45-2.466-1.32 0-2.642-.04-2.428.652.212.689 3.621 1.6 3.705 1.987.086.389-1.021.862-.468 1.382.554.52 1.236.132 1.79-.258s.893-.52.851-1.297z' fill='white'/%3e%3cpath d='M390.71 301.99c.567 1.825-.851 2.718-2.684 3.542-1.832.82-5.58.343-6.43-1.123-.854-1.47 1.362-3.847 3.62-4.41 2.257-.56 4.982.347 5.494 1.991z' fill='%23f8c83c'/%3e%3cpath d='M386.92 303.07c.716-.124.725 1.083 1.364.992.639-.084 1.192-1.12 1.021-1.814-.17-.692-1.364-1.642-2.385-1.554-1.022.087-4.046 2.634-3.707 3.326.342.69 1.023.606 1.578.347.554-.26 1.363-1.167 2.129-1.297z' fill='white'/%3e%3cpath d='M458.35 292.53c1.661 2.21 4.656.173 5.45-.688.796-.865 3.237-2.277 2.244-3.718-.997-1.44-2.697-1.324-3.834-1.27-1.136.058-3.465 1.732-3.86 2.507-.399.781-.74 2.193 0 3.169z' fill='%23f8c83c'/%3e%3cpath d='M458.89 291.07s.145-2.407 2.39-2.507c1.276-.057 1.332.347 2.3.896.962.544 1.332-.72 1.332-.72s.058 1.7-1.501 1.755c-1.564.056-.999-.69-2.53-.921-1.35-.205-1.991 1.497-1.991 1.497z' fill='white'/%3e%3c/g%3e%3cg fill='%23f9aa51' stroke='%23953220' stroke-width='.7' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M492.837 335.792l-1.295-.84s-2.589-.133-4.346-.1c-1.76.032-5.242.202-5.242.202l5.206 15.111 6.239 8.988 2.391.859 4.844-.321.824-2.355-1.823-14.575-6.797-6.97z' stroke-width='.701'/%3e%3cpath d='M475.64 336.738l.249-1.717s1.177-.15 2.82-.2c1.642-.054 3.077.108 3.253.236.17.127 3.634 4.36 4.825 7.133 1.192 2.78 2.587 7.421 4.13 10.254 1.544 2.824 4.88 7.571 4.88 7.571s-1.67.098-3.138.098-3.1.051-3.1.051l-2.799-1.084-8.782-13.656-2.339-8.687z' stroke-width='.701'/%3e%3cpath d='M471.971 334.88s3.583-.066 3.916.135c.331.203 4.312 3.74 5.903 8.112 1.595 4.374.797 4.982 2.857 9.493 2.053 4.51 4.91 7.538 4.91 7.538s-5.973.337-9.357-.27c-3.385-.606-4.58-.538-5.378-1.477-.794-.947-2.654-2.09-2.654-2.09h-3.381l.794-4.712-.927-10.567.199-5.458 3.117-.704zm35.832 2.792l-5.705-2.353-10.617-.54s.393 2.83.792 5.455c.4 2.622 2.26 8.814 3.985 11.846 1.723 3.029 3.452 6.732 4.382 7.605.931.876 7.035-1.649 7.035-1.649l3.979-.605-.531-4.344-.566-1.345.933-12.353-.867-1.917z' stroke-width='.701'/%3e%3cpath d='M470.242 337.742c0 1.35 1.428 1.416 1.792 1.35.364-.07 1.593-.54 1.593-2.36 0-1.817-1.127-3.228-3.352-3.364-2.223-.134-3.914 2.66-3.914 4.543 0 1.884 1.89 2.86 1.89 3.57 0 0-1.89 1.75-1.792 4.81.099 3.065 2.59 5.421 2.59 5.421s-2.657 2.12-2.657 4.241c0 2.121 2.027 3.531 3.917 3.531 1.89 0 4.313-1.21 4.313-2.822 0-1.618-1.427-2.59-2.62-2.59-1.195 0-1.693.702-1.693 1.241m39.317-16.717c0 1.313-.849 1.368-1.596 1.368-.746 0-1.74-.407-1.74-2.075 0-1.665 2.191-2.574 3.585-2.574 1.389 0 3.781 1.918 3.781 4.243 0 2.32-1.692 3.885-1.692 3.885s1.043.504 1.043 3.43c0 2.932-1.888 5.05-1.888 5.05s2.466.962 2.466 3.992c0 3.024-2.093 4.016-3.538 4.016-1.445 0-3.96-.861-3.96-2.931 0-2.074 1.297-2.801 2.29-2.801.996 0 1.968 1.161 1.968 2.296' stroke-width='.701'/%3e%3cpath d='M473.899 354.601s.37.244.649.836c.284.6.488 1.557 1.143 2.14 1.294 1.162 11.146 1.519 14.135 1.519 2.984 0 11.942.404 13.635-.607 1.694-1.008 1.892-2.677 2.936-3.435 1.045-.755 1.344-.703 1.344-.703l-1.295 1.108-.094 2.119.766 1.161s-.17.61-1.219 1.266c-1.044.657-1.99.857-3.433 1.01-1.443.152-20.301.1-23.343-.403-3.034-.508-2.834-.457-3.73-1.112a6.604 6.604 0 01-1.394-1.363l.399-1.362-.5-2.173zm30.598-18.096l1.692.74s-1.445.45-2.534 3.432c-1.098 2.983-.202 3.94-.946 4.24-.748.306-8.91.052-8.91.052l-1.398-3.386z' fill='%23953220' stroke='none'/%3e%3c/g%3e%3cg fill='%23231f20'%3e%3cpath d='M530.527 335.324s-1.394-.505-2.039-1.666c-.65-1.162-1.196-2.626-.7-2.93.503-.303 1.544.704 1.448 1.619-.103.906 1.291 2.978 1.291 2.978zm15.948-4.404s.995 1.814 1.342 2.016c.35.2 1.939.914 1.939.914s-2.237 0-2.932-.609c-.7-.607-1.694-2.273-1.694-2.273z'/%3e%3cpath d='M551.289 332.392s-1.344.805-2.486.352c-1.145-.454-2.038-1.113-1.597-1.614.452-.507.746-.304 1.344.35.599.661 2.739.912 2.739.912zm8.107-6.87s-1.095.964-1.89.964c-.797 0-2.39-.307-2.39-.66 0-.353 2.087-.555 2.437-.503.352.05 1.843.2 1.843.2zm-12.15-16.1s-1.794.554-2.388 1.466c-.594.908-.449 1.917.3 1.865.743-.048.944-1.058.944-1.362 0-.298 1.144-1.969 1.144-1.969zm-8.003 4.393s-1.342.854-1.693 1.615c-.35.755-.649 2.369.148 2.423.799.05 1.049-1.214 1.095-1.869.053-.656.45-2.169.45-2.169z'/%3e%3cpath d='M524.92 323.501l-4.393 4.65s10.102 5.656 17.863 5.404c7.768-.25 16.627-6.31 17.22-7.574.6-1.258.102-6.664-.896-8.382-.996-1.715-6.37-5.905-8.408-5.704-2.038.201-5.627 2.928-8.96 6.16-3.335 3.232-2.99 5.954-7.615 5.708-4.628-.254-4.814-.262-4.814-.262z' fill='%238cbebf' stroke='%2304534e' stroke-width='.701'/%3e%3cpath d='M523.798 325.359s10.815 1.618 13.93-1.143c3.124-2.758 6.505-8.144 8.696-9.358 2.191-1.214 3.181-1.214 3.181-1.214s1.613 1.027 2.357 1.67c.748.636 2.754 2.285 2.754 2.285l.865 5.137.065 2.824-3.38 2.765-6.209 2.86-5.936 1.85-5.043-.136-10.217-2.962-2.591-1.834-.665-.59z' fill='%230c8489'/%3e%3cpath d='M540.283 319.13c0-.92.604-.875 1.428-.875s1.725.157 1.725 1.078c0 .922-.9 2.253-1.725 2.253-.825 0-1.428-1.532-1.428-2.455zm4.346 2.724c0-.83.636-1.28 1.623-1.28.991 0 1.892 1.109 1.892 1.935 0 .828-.8 1.499-1.785 1.499-.99 0-1.73-1.327-1.73-2.154zm-1.496 6.472c0-1.034.634-1.249 1.626-1.249.987 0 1.595.466 1.595 1.498 0 1.03-.807 1.869-1.795 1.869-.991 0-1.426-1.09-1.426-2.118zm-5.7-1.986c0-1.104 1.048-1.449 1.938-1.449.89 0 1.61.897 1.61 2.007 0 1.107-.72 2-1.61 2-.89 0-1.939-1.452-1.939-2.558zm-9.032 1.098a2.208 2.208 0 114.415 0 2.206 2.206 0 01-2.209 2.202 2.206 2.206 0 01-2.206-2.202z' fill='%2304534e'/%3e%3cpath d='M544.63 321.854c0-.746 1.019-1.28 1.622-1.28.609 0 1.098.6 1.098 1.349 0 .74-.49 1.345-1.097 1.345-.604 0-1.624-.673-1.624-1.414zm-1.462 6.204c0-.858.791-1.214 1.695-1.214.905 0 1.589.355 1.589 1.214 0 .853-.735 1.545-1.64 1.545-.907 0-1.644-.692-1.644-1.545zm-5.7-1.893c0-.945 1.552-1.376 2.194-1.376.641 0 .53.632.53 1.58 0 .952-.525 1.717-1.166 1.717-.64 0-1.559-.968-1.559-1.921zm2.686-7.14c0-.863.672-.909 1.232-.909.554 0 .96.26.96 1.128 0 .864-.453 1.564-1.011 1.564-.561 0-1.181-.917-1.181-1.782zm-11.777 7.747c0-1.004.874-1.951 2.158-1.951 1.283 0 2.586.443 2.586 1.444 0 1.004-1.568 2.728-2.852 2.728-1.287 0-1.892-1.217-1.892-2.221z' fill='%238cbebf'/%3e%3cpath d='M532.513 325.02s-1.492.254-2.29 1.01c-.793.759-.896 1.62-.446 1.87.446.25.997-.556 1.145-.909.146-.355 1.592-1.972 1.592-1.972zm7.174-1.566s-1.442 1.012-1.59 2.023c-.152 1.013 0 1.514.4 1.566.398.048.643-1.316.496-1.82-.148-.501.694-1.769.694-1.769z'/%3e%3cpath d='M540.879 324.973s-.944.048-1.592.655c-.644.608-1.242 1.363-.793 1.415.444.048 1.146-.302 1.19-.708.051-.402 1.195-1.362 1.195-1.362zm1.542-8.33s-.748.607-1.145.958c-.401.356-.895 1.364-.401 1.62.5.254.848-.204 1.196-.907.35-.713.35-1.67.35-1.67zm5.433 3.481s-1.397.197-1.843.804c-.445.607-.749 1.316-.15 1.316.596 0 .745-.304.997-.857.25-.555.996-1.262.996-1.262zm-.853 6.414s-.297.96-1.144 1.412c-.846.46-1.092.862-1.442.254-.35-.604.098-.91.547-1.064.447-.147 2.039-.6 2.039-.6z'/%3e%3cpath d='M555.658 322.192s.6 2.979-1.987 4.44c-2.587 1.467-9.854 6.616-16.72 6.01-6.87-.608-14.684-4.543-14.684-4.543l-1.092.504 1.74.757 5.325 2.22 6.067 1.77 3.786.25 3.285-.405 6.068-2.015 5.143-2.628 2.67-2.12.715-.877-.066-1.243v-1.717z' fill='%2304534e'/%3e%3cpath d='M420.81 283.38s1.593 1.364 1.443 2.524c-.15 1.161-.548 1.62-.994 1.416-.45-.203-.45-1.416-.35-1.917.1-.51-.1-2.023-.1-2.023zm11.776 10.948s-.448 2.017-1.246 2.219c-.795.202-1.392-.655-1.243-1.01.15-.354.796-.05 1.145-.354.348-.298 1.344-.855 1.344-.855zm-25.632 1.565s.546 1.162 1.592 1.364c1.044.2 1.543-.507 1.393-.86-.148-.35-.597-.254-1.145-.254-.547 0-1.84-.25-1.84-.25zm4.58 8.985s.947 1.113 2.24 1.263c1.291.15 1.94-.859 2.038-1.161.1-.304-1.492-.255-1.99.15-.497.405-2.289-.252-2.289-.252zm8.108 6.917s2.089-.405 2.435-.958c.35-.557.897-1.515.451-2.073-.45-.553-.797.86-1.046 1.412-.249.559-1.84 1.619-1.84 1.619z'/%3e%3cpath d='M432.691 306.303s1.396-9.359-6.17-15.956c-7.566-6.595-12.476-4.982-15.066-2.554-2.587 2.42-4.843 10.366 3.185 17.301 8.031 6.933 17.92 4.779 17.92 4.779l.131-3.57z' fill='%238cbebf' stroke='%2304534e' stroke-width='.701'/%3e%3cpath d='M409.618 296.396s-.144-5.142 2.284-6.672c2.428-1.537 10.428-2.87 14.371 4.727 3.943 7.589 4.021 11.386 3.027 15.225l-4.22-.042-6.53-2.662-5.416-4-3.517-6.576z' fill='%230c8489'/%3e%3cpath d='M431.687 307.647s-1.325 1.482-4.048 1.348c-2.72-.137-15.394-3.435-18.58-14.81l.201 2.49.13.808.837 2.293 2.666 3.871 3.347 2.869 4.22 2.183 3.026.887 3.94.688h2.27l1.992-2.627z' fill='%2304534e'/%3e%3cpath d='M425.086 304.364c0-1.015.52-1.047 1.328-1.047.806 0 1.426-.355 1.426.655 0 1.015-.554 2.476-1.36 2.476-.807 0-1.394-1.075-1.394-2.084zm.537-6.018c0-.7.638-1.264 1.43-1.264.788 0 1.423.564 1.423 1.264 0 .698-.635 1.258-1.423 1.258-.79 0-1.43-.56-1.43-1.258zm-5.748 6.637c0-.547.72-.992 1.61-.992.889 0 1.609.445 1.609.992 0 .547-1.6 1.295-2.489 1.295-.887 0-.73-.747-.73-1.295zm-.525-7.092c0-.891.432-.607 1.211-.607.781 0 1.743.254 1.743 1.147 0 .892-.963 2.086-1.743 2.086-.778 0-1.211-1.736-1.211-2.626zm-5.34 1.191c0-.75.507-1.801 1.46-1.801.951 0 1.989 1.05 1.989 1.802s-.771 1.362-1.726 1.362c-.951 0-1.722-.61-1.722-1.362zm.958-6.273c0-.778.531-.738 1.508-.738.982 0 1.777.397 1.777 1.181 0 .778-1.145 1.748-2.124 1.748-.98 0-1.16-1.406-1.16-2.191zm5.784-.607c0-.755.642-.508 1.559-.508.918 0 1.66.61 1.66 1.364 0 .751-1.173 1.597-2.09 1.597-.917 0-1.13-1.702-1.13-2.453z' fill='%2304534e'/%3e%3cpath d='M414.968 292.645c.131-.54.507-.911 1.194-.911.686 0 1.293.13 1.293.911 0 .778-.557 1.416-1.243 1.416-.688 0-1.431-.66-1.244-1.416zm-1.063 6.157c0-.761.381-1.479 1.16-1.479.779 0 1.394.077 1.394.841 0 .765-.682 1.65-1.46 1.65-.779 0-1.094-.249-1.094-1.012zm6.8-6.495c0-.606.518-.673 1.26-.673.741 0 1.227.155 1.227.755 0 .608-.6 1.095-1.343 1.095s-1.145-.573-1.145-1.177zm-1.32 5.9c0 .828.607 1.501 1.36 1.501.75 0 1.558-.658 1.558-1.482 0-.833-.84-1.619-1.593-1.619-.75 0-1.325.773-1.325 1.6zm6.472-.865c0 .75.652 1.364 1.458 1.364.807 0 1.46-.615 1.46-1.364 0-.754-.653-1.362-1.46-1.362-.805 0-1.458.608-1.458 1.362zm-6.24 7.57c0-.657.685-1.294 1.363-1.294.677 0 1.327.419 1.327 1.077 0 .66-1.179 1.549-1.858 1.549-.678 0-.831-.671-.831-1.331zm5.504-.969c0-.807.616-.875 1.46-.875s1.26.081 1.26.89c0 .81-.681 1.47-1.525 1.47-.844 0-1.195-.675-1.195-1.485z' fill='%238cbebf'/%3e%3cpath d='M426.617 294.48s.844 1.057.993 1.865c.148.807.148 1.718-.15 1.82-.298.1-.795-.507-.944-1.262-.149-.76.1-2.423.1-2.423zm-4.826-5.152s.547.86.547 1.618c0 .757-.1 1.564-.497 1.564-.398 0-.398-.756-.398-1.313 0-.554.348-1.87.348-1.87zm-5.678.759s.549.86.549 1.618c0 .755-.1 1.565-.498 1.565-.4 0-.4-.757-.4-1.31 0-.56.349-1.872.349-1.872z'/%3e%3cpath d='M414.127 291.15s.746.203 1.392.705c.648.505.896 1.109.648 1.413-.25.304-.845-.148-.994-.504-.15-.354-1.046-1.614-1.046-1.614zm4.323 5.947s1.095.05 1.693.607c.596.556 1.093 1.011.746 1.416-.349.402-1.195-.305-1.544-.706-.348-.404-.895-1.317-.895-1.317zm-5.27-.199s.997.25 1.493.603c.5.357.649 1.064.4 1.214-.25.148-.597-.102-1.045-.555-.449-.456-.847-1.262-.847-1.262zm12.736 3.996s.35 1.212.35 2.065c0 .861.1 1.618-.3 1.618-.398 0-.597-1.058-.597-1.716 0-.66.547-1.967.547-1.967zm-1.437 1.963s.896.352 1.294.705c.397.355.498.911.2 1.011-.299.1-.499-.555-.748-.807-.247-.252-.746-.91-.746-.91zm-5.678.35s.957.113 1.376.399c.415.284.458 1.594.415 1.764-.04.168-.665.054-.918-.57-.246-.625-.873-1.593-.873-1.593z'/%3e%3cpath d='M416.604 285.893s-5.013 1.086-5.929 4.319c-.917 3.231-.957 6.825-.957 6.825L409 292.92l.997-2.667 1.458-2.45 2.207-1.389 1.988-.686zm15.644 19.172s.52-1.252-.954-5.208c-1.475-3.959-4.499-9.131-4.499-9.131l2.35 2.665 1.87 3.03.915 2.786.677 2.546-.039 2.5z' fill='%2304534e'/%3e%3cpath d='M437.318 298.662s1.74 1.14 1.916 1.768c.175.634.247.837-.199 1.012-.448.181-1.17-.528-1.37-1.012-.2-.48-.347-1.768-.347-1.768zm-7.348 19.745s.822-1.54 1.915-2.12c1.095-.58 1.916-.506 2.215-.15.299.353-.72 1.16-1.467 1.439-.747.278-2.663.83-2.663.83zm12.35 4.72s1.219-.58 2.015-1.44c.797-.855.896-1.46.597-1.765-.298-.302-1.294.203-1.743.883-.447.678-.87 2.322-.87 2.322zm-1.345-1.157s.424-1.588.848-2.095c.423-.505 1.019-.781 1.468-.505.45.277.174.989-.15 1.362-.323.38-2.166 1.238-2.166 1.238z'/%3e%3cpath d='M461.62 312.566s-7.693-11.126-19.641-11.714c-9.556-.472-12.575 8.061-12.227 10.635.342 2.534 3.932 8.095 16.672 9.034 12.741.944 14.797-6.005 15.329-6.343.53-.338-.133-1.612-.133-1.612z' fill='%238cbebf' stroke='%2304534e' stroke-width='.701'/%3e%3cpath d='M452.542 304.925s3.184 2.427 4.53 4.344c1.342 1.917 1.642 3.333.846 3.586-.798.247-7.715-6.164-13.388-7.524-5.675-1.365-10.6-.1-11.696 2.626-1.092 2.728-.695 6.816 1.893 8.478 2.589 1.672 14.731 3.637 14.731 3.637s5.524-.757 5.722-.856c.2-.101 3.534-1.97 3.534-1.97l.745-1.92.898-2.524.398-1.01-2.937-3.23-5.275-3.637z' fill='%230c8489'/%3e%3cpath d='M442.786 306.49c0 .713-.75 1.066-1.492 1.066-.743 0-1.37-.376-1.37-1.087 0-.712.602-1.289 1.345-1.289.742 0 1.517.599 1.517 1.31zm-7.01 2.524c0-.714.801-.703 1.607-.703.804 0 1.456.585 1.456 1.3 0 .713-1.265 1.698-1.993 1.352-.893-.43-1.07-1.228-1.07-1.95zm7.536 4.123c0-.907.769-1.645 1.719-1.645.947 0 1.715.738 1.715 1.645 0 .904-1.291 1.888-2.239 1.888s-1.195-.984-1.195-1.888z' fill='%2304534e'/%3e%3cpath d='M437.61 314.82c0-.793.817-.958 1.519-.958.699 0 1.592.747 1.592 1.54 0 .794-.893 1.337-1.592 1.337-.701 0-1.519-1.123-1.519-1.92z' fill='%238cbebf'/%3e%3cpath d='M447.81 317.589c0-.647.385-1.224 1.046-1.224.66 0 1.467.388 1.467 1.033 0 .651-.656 1.364-1.317 1.364a1.184 1.184 0 01-1.196-1.173zm4.58-3.493c0-.824.466-.736 1.27-.736s1.617.465 1.617 1.289c0 .824-1.012 1.261-1.816 1.261s-1.072-.996-1.072-1.814z' fill='%2304534e'/%3e%3cpath d='M442.342 305.836c0 .637-.264.98-.896.98-.631 0-1.394-.343-1.394-.98 0-.644.29-.838.921-.838.632 0 1.37.194 1.37.838zm-3.657 2.98c0 .7-1.057 1.137-1.717 1.137-.66 0-1.095-.437-1.095-1.138 0-.696.51-.906 1.172-.906.66 0 1.64.21 1.64.906zm1.624 5.888c0 .61-.232 1.081-.944 1.081-.714 0-1.643-.47-1.643-1.081 0-.613.257-1.037.971-1.037s1.616.424 1.616 1.037zm6.087-1.998c0 .64-1.255 1.363-1.917 1.363-.66 0-.944-1.179-.944-1.816 0-.644.532-1.16 1.194-1.16.66 0 1.667.972 1.667 1.613zm8.832 1.893c0 .667-1.061.63-1.667.63-.603 0-1.145-.747-1.145-1.41 0-.673.2-1.29 1.693-1.114.6.07 1.12 1.228 1.12 1.893zm-5.222 2.698c0 .666-.51 1.21-1.142 1.21-.63 0-1.145-.544-1.145-1.21 0-.67.514-.935 1.144-.935.632 0 1.143.264 1.143.935z' fill='%238cbebf'/%3e%3cpath d='M450.801 313.617s1.242-.404 2.187-.308c.947.104.999.458.999.607 0 .154-.748.458-1.097.352-.35-.096-2.089-.65-2.089-.65zm-5.176 4.381s.996-.607 1.742-.755c.745-.15 1.344.098 1.293.553-.05.457-.296.559-1.043.559-.745 0-1.992-.357-1.992-.357zm-3.33-7.665s2.138.91 2.589 1.767c.446.86.646 1.061.198 1.314-.447.252-.947-.307-1.244-.707-.3-.403-1.542-2.374-1.542-2.374z'/%3e%3cpath d='M441.746 313.056s1.643-.452 2.389-.452c.748 0 .947.05 1.046.404.1.35-.166.503-.78.47-.613-.036-2.655-.422-2.655-.422zm-5.245.105s1.792.239 2.239.707c.449.471.449.896.265 1.16-.182.271-1.029.102-1.293-.168-.266-.27-1.212-1.699-1.212-1.699z'/%3e%3cpath d='M436.243 315.743c.083-.083.695-1.011 1.343-1.227.646-.22 1.393-.184 1.525.149.136.336-.562.84-1.026.944-.465.1-1.842.134-1.842.134zm-1.354-7.839l1.774.488c.648.488.796.876.648 1.063-.15.182-.78.285-1.312-.067-.781-.527-1.111-1.484-1.111-1.484zm3.89-4.521s1.81.504 2.407 1.327c.595.827.512 1.315.214 1.483-.298.169-.997-.25-1.392-.62-.4-.374-1.229-2.19-1.229-2.19z'/%3e%3cpath d='M459.458 316.386s-3.682 3.132-11.992 2.83c-8.312-.304-15.828-3.84-17.717-7.727l.745 1.919 1.843 2.473 5.823 2.98 6.52 1.46 5.175.306 4.877-.858s3.582-1.717 3.783-1.817c.198-.1.597-.96.597-.96zm1.098-3.938s-1.392-1.718-3.335-3.535c-1.942-1.82-9.505-6.72-9.505-6.72l6.12 2.78 4.033 3.386 2.886 3.175-.198.914z' fill='%2304534e'/%3e%3cpath d='M460.907 305.076s2.09.81 2.439 1.314c.35.503.795.96.795.96s-.546 1.362-1.043.808c-.5-.558-.598-.558-1.146-1.316-.548-.76-1.045-1.766-1.045-1.766zm6.215-3.33s1.943.81 2.638 1.77c.697.96.549 1.766.25 1.867-.3.103-1.592-1.011-1.792-1.463-.2-.452-1.096-2.173-1.096-2.173z'/%3e%3cpath d='M469.073 301.35s1.84 1.366 2.138 1.968c.3.607.897 1.412.3 1.615-.598.202-1.443-.705-1.692-1.258-.25-.56-.746-2.325-.746-2.325zm10.492 2.464s1.444.5 1.594 1.717c.148 1.213-.15 2.07-.15 2.07s-.996-.857-.996-1.113c0-.248.15-.453 0-1.005a561.67 561.67 0 00-.448-1.669zm2.792.97s1.145 1.162 1.296 1.917c.147.756.295 1.265-.348 1.363-.649.106-.995-.657-.995-1.31 0-.66.047-1.97.047-1.97zm-18.81 22.923s.895.403 1.74.1c.847-.304 1.547-1.06 1.394-1.565-.148-.509-.595-.961-1.244-.303-.647.655-.296.961-.796 1.207l-1.094.561zm10.352 2.815s1.394-.201 2.34-1.215c.945-1.005 1.344-1.712.696-1.966-.646-.253-1.493 0-1.642.806-.15.809-1.394 2.375-1.394 2.375zm8.505.305s1.049-.608 1.846-1.362c.794-.76 1.24-1.21.693-1.767-.546-.56-.945-.156-1.192.1-.25.254 0 .254-.298 1.06-.303.807-1.049 1.969-1.049 1.969z'/%3e%3cpath d='M484.998 330.78s1.121-1.364 1.382-2.126c.25-.754.398-1.612-.111-1.564-.51.048-1.127.76-1.16 1.316-.04.553-.111 2.373-.111 2.373z'/%3e%3cpath d='M459.108 316.993c.073-3.74 5.375-12.369 11.493-12.27 2.549.045 7.545 1.37 11.597 3.183 3.38 1.513 4.48 3.185 6.72 3.736 2.24.555 5.623.15 5.623.15l7.614-.857-5.971 8.737-2.136 1.916s-1.895 3.686-7.318 5.804c-5.426 2.12-14.583.555-18.714-.453-4.13-1.008-9.007-4.944-8.908-9.945z' fill='%238cbebf' stroke='%2304534e' stroke-width='.701'/%3e%3cpath d='M459.108 316.993l.399.009c.012-.84.337-2.037.92-3.325.87-1.938 2.316-4.1 4.086-5.757 1.772-1.654 3.85-2.793 5.984-2.793h.098c1.214.023 3.085.357 5.138.912a45.125 45.125 0 016.305 2.232c1.657.74 2.743 1.517 3.724 2.196.978.672 1.862 1.27 3.061 1.564.967.24 2.095.308 3.098.308 1.458 0 2.658-.143 2.667-.146l6.743-.761-5.446 7.965-2.16 1.938-.035.066-.003.008c-.087.164-1.965 3.598-7.102 5.61-1.9.741-4.33 1.024-6.837 1.024-4.394 0-9.035-.86-11.638-1.497-1.968-.477-4.143-1.666-5.804-3.32-1.662-1.655-2.803-3.756-2.802-6.082l.003-.142-.4-.01-.399-.01-.002.161c.002 2.603 1.272 4.9 3.04 6.658 1.773 1.764 4.053 3.009 6.175 3.53 2.651.645 7.333 1.523 11.825 1.523 2.568 0 5.077-.286 7.122-1.083 5.544-2.17 7.501-5.943 7.527-5.997l-.35-.187.262.3 2.173-1.947 6.501-9.504-8.486.956-.2.019c-.394.04-1.321.117-2.376.117-.969 0-2.05-.065-2.91-.278-1.04-.26-1.822-.775-2.798-1.451-.974-.672-2.127-1.492-3.855-2.26-2.047-.922-4.326-1.708-6.42-2.277-2.094-.57-3.995-.917-5.329-.945h-.112c-1.612 0-3.15.57-4.543 1.462-2.091 1.333-3.872 3.395-5.15 5.485-1.276 2.093-2.058 4.2-2.094 5.719l.399.01z' fill='%2304534e'/%3e%3cpath d='M496.085 318.162c-.645.505-1.342.505-2.139.505-.8 0-17.766-10.35-23.042-9.898-5.274.453-10.3 2.728-10.45 8.132-.148 5.398 1.195 5.452 2.288 6.966 1.097 1.515 11.448 3.789 11.448 3.789l6.32-.107 5.08-.552 4.476-2.423 2.44-1.967 1.64-2.021 1.94-2.423z' fill='%230c8489'/%3e%3cpath d='M469.272 315.405c0 1.06-.41 1.801-1.442 1.801-1.028 0-1.798-.467-1.798-1.528 0-1.055.586-1.452 1.616-1.452 1.032 0 1.624.12 1.624 1.179zm1.776-4.721c0-.881.851-1.266 1.827-1.266s1.726.355 1.726 1.235c0 .875-.771 1.55-1.746 1.55-.977 0-1.807-.642-1.807-1.52zm10.164 2.758c0-.765.657-1.385 1.47-1.385.809 0 1.465.62 1.465 1.385 0 .766-.656 1.387-1.465 1.387-.813 0-1.47-.621-1.47-1.387zm2.045 6.227c0-.979.711-1.769 1.592-1.769.88 0 1.7.413 1.7 1.387s-.318 1.925-1.197 1.925c-.878 0-2.095-.568-2.095-1.542zm-4.93 3.983c0-.837.744-1.514 1.668-1.514.92 0 1.664.676 1.664 1.514 0 .84-.657 1.382-1.575 1.382-.922 0-1.758-.542-1.758-1.382zm-9.312-1.612c0-.811.656-1.464 1.467-1.464a1.465 1.465 0 110 2.928 1.465 1.465 0 01-1.467-1.464z' fill='%2304534e'/%3e%3cpath d='M469.213 315.182c0 .832-.714 1.515-1.592 1.515-.881 0-1.594-.682-1.594-1.515 0-.838.707-1.17 1.585-1.17.88.002 1.602.332 1.602 1.17zm4.931-4.801c0 .809-.251 1.331-1.104 1.331-.851 0-1.981-.522-1.981-1.331 0-.81.693-1.462 1.542-1.462.851 0 1.542.652 1.542 1.463zm9.85 2.628c0 .696-.647 1.257-1.444 1.257-.798 0-1.443-.562-1.443-1.257 0-.698.645-1.266 1.442-1.266.798 0 1.444.568 1.444 1.266z' fill='%238cbebf'/%3e%3cpath d='M478.77 317.168c0 1.066-.41 1.808-1.441 1.808-1.03 0-1.8-.471-1.8-1.53 0-1.06.585-1.45 1.617-1.45 1.031 0 1.625.12 1.625 1.172z' fill='%2304534e'/%3e%3cpath d='M471.656 321.69c0 .84-.715 1.516-1.593 1.516-.879 0-1.593-.676-1.593-1.516 0-.83 1.012-1.258 1.893-1.258.877 0 1.292.428 1.292 1.258zm6.81-4.697c0 .836-.69 1.513-1.542 1.513-.851 0-1.542-.676-1.542-1.512 0-.834.691-1.518 1.542-1.518.852 0 1.542.684 1.542 1.517zm8.05 2.08c0 .921-.56 1.655-1.522 1.655s-1.74-.747-1.74-1.662c0-.921.279-1.236 1.238-1.236.96 0 2.025.323 2.025 1.243zm-5.151 4.229c0 .867-.583 1.36-1.464 1.36-.88 0-1.724-.493-1.724-1.36 0-.862.754-1.22 1.632-1.22.876 0 1.556.358 1.556 1.22z' fill='%238cbebf'/%3e%3cpath d='M481.96 318.255s2.532-.254 2.983.202c.45.455.4 1.108.199 1.312-.2.202-1.197.251-1.443-.098-.247-.357-1.739-1.416-1.739-1.416zm-2.488-8.178s1.942.5 2.736 1.31c.797.808.649 1.618.5 1.768-.15.149-.849.305-1.394-.3-.546-.607-1.842-2.778-1.842-2.778zm-5.772 3.937s2.265 1.235 2.764 1.94c.497.706.621 1.265.398 1.565-.225.303-1.347-.076-1.519-.454-.173-.377-1.642-3.051-1.642-3.051zm-.993 1.741s2.538.33 3.16.807c.622.481 1.07.506 1.02.884-.048.38-.321.66-.72.606-.4-.052-1.495-.531-1.742-.757a811.17 811.17 0 00-1.718-1.54zm-2.92-7.43s2.589.406 3.12.808c.53.406.663 1.552.066 1.89-.598.33-1.26-.337-1.46-.809-.2-.471-1.727-1.89-1.727-1.89zm-5.586 3.913s2.382 1.133 3.122 2.186c.398.568.747 1.058 0 1.314-.683.226-1.393-1.01-1.393-1.314 0-.302-1.729-2.186-1.729-2.186z'/%3e%3cpath d='M463.675 315.335s1.526-.338 2.258-.338c.728 0 1.778-.253 1.791.338.01.59-.895.703-1.434.533-.532-.182-2.614-.533-2.614-.533zm13.18 8.505s1.668-1.039 2.488-.862c.82.18 1.094.105 1.094.607 0 .506-.971.405-1.27.405-.299 0-2.313-.15-2.313-.15zm-9.23-1.344s.644-.96 1.342-1.056c.697-.104.994-.052 1.095.248.1.307-.597.86-.897.86-.297 0-1.54-.052-1.54-.052z'/%3e%3cpath d='M494.005 320.813s-2.536 3.055-6.071 4.57c-3.532 1.516-6.22 2.017-11.148 1.715-4.926-.302-7.314-1.06-10.65-2.774-3.335-1.717-5.972-4.19-6.47-5.251-.496-1.064.549 1.767.549 1.767l3.036 3.985 3.632 1.618 5.325 1.31 5.027.607 3.83-.096 4.58-.713 2.935-1.054 1.993-1.215 1.544-1.266zm-4.743-9.018s-1.38.456-4.414-1.416c-3.038-1.865-6.672-4.293-13.539-4.34-6.867-.049-9.056 4.649-9.505 4.996-.449.355 3.084-4.085 3.084-4.085l3.136-1.669 2.44-.404 2.338.102 3.036.809 2.737.857 3.188 1.059 2.784 1.524 3.365 1.756 1.35.81zm9.218 2.02s-4.029-.052-5.175.048c-1.148.1-1.195.304-1.347.607-.15.303-.447.707-.447.707l-1.244-2.677 5.475-.76 2.98 1.116z' fill='%2304534e'/%3e%3cpath d='M491.061 341.983c.277.735.916 1.402 1.717 1.42.803.023 2.491-.03 2.491-.03l5.449-.326 1.917-2.198 1.17-4.924s1.471-1.789 1.471-1.865c0-.075 5.074-2.803 5.074-2.803l4.382-1.264 2.81-.3 3.878-1.287 2.864-1.49 1.245-1.845 1.217-2.8-1.217-3.79-3.038-4.062-5.145-2.095h-4.261l-4.776 1.743-8.41 1.99s-4.63 2.02-6.547 5.63c-1.91 3.609-1.888 4.547-2.21 9.315-.328 4.776-.08 10.981-.08 10.981z' fill='%230c8489' stroke='%2304534e' stroke-width='.701'/%3e%3cpath d='M493.34 340.103c1.61 0 .366-2.663 2.193-5.829 1.824-3.157 4.046-7 4.61-7 .563 0 .66.575 1.323.375.665-.201 1.797-1.213 1.863-1.485.066-.267.066-2.052 1.457-3.197 1.397-1.145 3.353-2.76 4.279-2.962.931-.197 1.364-.37 1.528.067.166.437-.533 1.044.101 1.247.631.204 2.091.137 2.454-.81.364-.942.265-1.443.265-1.443s.963-.942 2.789-.54c1.827.404 2.055.3 2.221 1.01.165.706-.831.807-.63 1.312.197.501-.138.448.05.832.185.38.478 1.456 1.704 1.424 1.231-.033 1.762-.742 1.762-.742l.36-.647s.338-.765-.13-1.068c-.466-.304-.297-.674.169-.473.462.203 2.32 2.794 2.952 1.715.633-1.075.699-2.59.365-2.96-.332-.37-2.953-4.31-2.953-4.31l-4.68-1.582-6.2.51-6.009 3.43-5.505 2.929s-.3 4.507-1.296 3.702c-.995-.809-2.424-3.029-2.85-2.289-.435.742-1.395 4.038-1.96 5.685-.565 1.65-2.19 6.735-2.026 8.621.168 1.883 1.199 4.479 1.794 4.479z' fill='%238cbebf'/%3e%3cpath d='M498.877 332.812c-.434.033-1.063.472-1.26.722-.2.255-.481.795-.3 1.382.182.588 1.045 1.162 1.113 1.23l.69-.02 1.495-.435s.477-.54.504-1.242c.03-.711-.403-.897-.615-.964-.22-.066-1.627-.673-1.627-.673zm9.487-7.839c-.848-.302-1.222.276-1.37.528-.148.254-.084.87-.084.87s.186 1.173.633 1.391c.446.212 1.619.62 1.987.212.378-.4.756-.68.73-1.437-.02-.759-1.076-1.132-1.076-1.132zm7.64 1.834c-.035-.289-.78-.49-1.28-.403-.496.087-1.163.721-.925 1.683.228.956 1.142 1.041 1.857.858.712-.186.577-1.199.577-1.347 0-.15-.228-.791-.228-.791zm-22.069 1.542c0 .438.796 1.349 1.861 1.282 1.058-.068 1.718-.877 1.826-1.515.094-.642-.567.535-1.364.74-.794.2-1.26.404-1.626-.035-.364-.437-.697-.471-.697-.471z' fill='%238cbebf'/%3e%3cpath d='M501.12 334.448s.115.975-.588 1.48c-.702.504-1.152.452-1.557.452-.404 0-.845-.082-1.14-.487-.295-.405-.516-.977-.516-.977s.775 1.276 1.993.94c1.22-.333 1.809-1.408 1.809-1.408zm20.552-12.734s-.01.981-.775 1.388c-.76.407-1.105.523-1.51.472-.4-.055-.959-.218-1.224-.642-.901-1.409-.369-2.329-.369-2.329s.65 2.443 1.903 2.273c1.254-.172 1.975-1.162 1.975-1.162zm-18.32 4.38s-.626 1.918-1.89 1.918c-1.259 0-1.156-.367-1.062-.607.104-.232.567.24 1.13.068.565-.164 1.822-1.378 1.822-1.378zm3.552-.339s-.13 1.39.336 1.858c.465.474.997.713 1.528.713s.93-.14 1.325-.674c.4-.54.166-1.115.166-1.115s.008.292-.389.694c-.4.405-.726.471-1.125.471-.397 0-1.077-.05-1.28-.52-.202-.47-.561-1.427-.561-1.427zm6.507-6.682s.4 1.04-.399 1.884c-.793.84-2.32.37-2.32.37s1.229.3 1.827-.37c.597-.674.892-1.883.892-1.883z' fill='%2304534e'/%3e%3cpath d='M492.639 343.024s8.076-.137 8.725-1.249c.644-1.107-.7-5.452 4.179-8.883 4.875-3.431 8.661-3.384 11.247-3.588 2.589-.2 8.176-1.942 9.158-6.912.595-3.033-3.485-3.235-5.027-6.11-1.542-2.88-5.522-1.716-5.722-1.716-.198 0-4.62-.128-6.719 1.917-1.247 1.214-1.096 2.728-1.693 3.433-.6.707-5.925 0-6.52.86-.597.856.149 2.671-.252 3.077-.393.403-1.687-1.164-1.687-1.164l.445-4.29 6.82-3.987 7.759-4.292s5.081.25 5.28.152c.2-.104 5.225 2.624 5.373 2.675.148.053 2.636 3.03 2.636 3.03s.49 1.216.699 3.583c.1 1.125.006 2.093-.24 2.975-1.255 4.47-5.632 7.474-10.241 7.703-4.607.23-8.76 2.311-10.863 3.835-2.108 1.528-3.156 8.256-3.186 9.063-.03.806-10.037.26-10.037.26l-.135-.372z' fill='%2304534e'/%3e%3cpath d='M496.038 327.298c-.41.33-1.017.31-1.148-.155-.37-1.32.415-3.278.415-3.278s-.02 2.05.134 2.388c.15.338.56.26.746.54.066.097.18.24-.147.505zm5.083-1.04c-.391-.12-.323-1.363-.026-1.895.3-.528 2.566-2.199 2.566-2.199s-.723 1.67-1 2.277c-.272.603-1.047 1.97-1.54 1.817zm-1.998 8.202c-.318.067-.42-.634-.42-1.518 0-.883 1.543-2.497 1.543-2.497s-.472 1.416-.525 1.866c-.047.456.252.86.199 1.392-.048.527-.444.682-.797.757z'/%3e%3cpath d='M502.885 332.193s-.72.835-1.545 1.29c-.817.45-1.712 1.13-2.215.984-.494-.155.32-1.229.599-1.341 1.395-.553 3.161-.933 3.161-.933zm6.916-9.873s-.917.762-1.365 1.843c-.45 1.086-.648 1.972-.2 2.173.453.201 1.12-1.239 1.172-1.72.048-.476.393-2.296.393-2.296z'/%3e%3cpath d='M512.337 325.78s-.645-.603-1.793-.882c-1.142-.28-1.665-.025-1.789.304-.125.325-.972.845-.548 1.097.423.25.919-.44 1.267-.52.352-.075.752-.327 1.37-.225.62.101 1.493.225 1.493.225zm-1.485-6.777c.407.352 1.026-.304 1.596-.944.561-.64.994-1.818.994-1.818s-1.165.607-1.658 1.011c-.502.403-1.163 1.55-.932 1.75zm10.55-.246s-1.358.643-1.822 1.247c-.466.606-1.064 1.277-.598 1.614.465.338.89-.3 1.262-.805.36-.504 1.158-2.056 1.158-2.056zm-3.014 7.068s-.46.945-1.323 1.516c-.862.575-1.892.84-2.055.537-.17-.3.133-.944.46-1.107.337-.17.535-.137 1.295-.338.763-.2 1.623-.608 1.623-.608z'/%3e%3c/g%3e%3cg transform='translate(-.699 1.184) scale(1.16833)'%3e%3cellipse cx='385.551' cy='257.828' rx='3.769' ry='5.631' transform='rotate(8.667 385.551 257.828)' fill='url(%23b)'/%3e%3cg fill='%23fcca3e' stroke='%23aa8c30'%3e%3cpath d='M387.66 247.73l-2.24 5.602 1.83-.254 1.056-4.931z' stroke-width='.35'/%3e%3cpath d='M388.7 245.35c-.797-.1-1.53.507-1.634 1.36-.104.85.459 1.618 1.256 1.722.8.1 1.529-.51 1.634-1.358.103-.852-.456-1.62-1.256-1.724z' stroke-width='.3'/%3e%3cpath d='M485.22 259.35l-5.522 5.18 2.278.579 3.788-4.99z' stroke-width='.35'/%3e%3cpath d='M487.68 257.21c-.884-.488-2.054-.155-2.616.743-.566.895-.304 2.019.578 2.505.884.488 2.055.155 2.62-.742.562-.897.303-2.02-.582-2.506z' stroke-width='.3'/%3e%3cpath d='M344.88 229.45l2.913 6.42 1.254-1.787-3.297-4.86z' stroke-width='.35'/%3e%3cpath d='M343.71 226.65c-.723.613-.798 1.731-.166 2.5.63.776 1.728.905 2.453.295.722-.609.798-1.731.167-2.5-.632-.773-1.729-.905-2.454-.295z' stroke-width='.3'/%3e%3c/g%3e%3cg fill='%23aa8c30'%3e%3cpath d='M389.25 245.56s.45.244-.07.084c-.522-.159-1.758.442-1.76 1.314 0 .874.647 1.359 1.3 1.365.656.006-.242.119-.242.119l-.842-.248-.35-.507-.28-.705.216-.756.497-.645.65-.234.43.051z'/%3e%3cpath d='M387.99 249.33s-.356-.072-.68.408c-.32.48-.972 1.385-.972 1.385l1.251-3.082.682.356zm100.23 8.36s.403.485-.126.061c-.53-.422-2.287-.34-2.744.632-.458.974.056 1.816.815 2.131.766.317-.341.02-.341.02l-.861-.67-.143-.732.03-.92.646-.736.92-.482.88.041.475.267.45.388z'/%3e%3cpath d='M484.78 261.3s-.382-.254-1.01.132c-.624.384-1.856 1.083-1.856 1.083l3.06-2.841.616.719zm-140.45-34.97s.564-.198.012.129c-.55.325-1.037 1.873-.304 2.574.733.702 1.66.529 2.188-.032.531-.56-.094.305-.094.305l-.882.531-.705-.109-.819-.32-.461-.788-.143-.95.322-.75.39-.326z'/%3e%3cpath d='M346.49 230.45s-.348.252-.203.912c.15.664.387 1.95.387 1.95l-1.59-3.546.846-.309z'/%3e%3c/g%3e%3cellipse cx='351.47' cy='241.607' rx='6.06' ry='4.079' transform='rotate(62.907 351.47 241.607)' fill='url(%23c)'/%3e%3cg fill='%23e92736'%3e%3cpath d='M344.65 240.24s1.25.288 1.93-.057c.682-.347.796-.866.964-1.034.172-.173.343-.808.286-1.212-.058-.404-.965-1.786-1.25-1.9-.284-.116-1.25 0-1.418-.174-.17-.174.142-.55-.23-.635-.367-.086-2.269 2.077-1.93 2.422.342.343.54-.172.652.117.114.284.03 1.092.03 1.436 0 .346.966 1.037.966 1.037z'/%3e%3cpath d='M346.5 236.2c.149.3.852 1.237 1.136 1.352.284.118 1.136.148 1.42.034.285-.116 1.193-.982 1.222-1.357.028-.374 0-.662-.17-1.04-.17-.374-.072-1.38-.412-1.437-.341-.058-.49-.104-.66-.302-.17-.204.106-.564-.15-.936-.253-.377-3.294 1.412-3.067 1.756.228.346.54-.026.653.203.113.227-.143 1.38.028 1.727z'/%3e%3cpath d='M353.37 235.43c.17-.458.113-1.959-.198-2.277-.313-.317-.825-.343-.854-.547-.026-.2.37-.289.37-.635 0-.344-3.379.115-3.152.494.228.372.797.172.767.4-.028.23-.569.518-.625.809-.056.287.173 1.24.313 1.467.142.235-.056.518.341.664.4.145.34.145.711.26.368.115 1.703.056 1.875-.09.167-.143.282-.085.452-.545zm28.73 16.88s.554.96 1.167 1.189c.612.227.996-.003 1.204.003.205.007.693-.256.907-.528.214-.274.531-1.658.436-1.905-.096-.247-.731-.793-.725-.998.006-.212.418-.23.256-.515-.165-.286-2.603-.221-2.616.196-.012.42.422.242.31.481-.11.242-.653.66-.866.86-.214.203-.073 1.217-.073 1.217z'/%3e%3cpath d='M385.66 251.11c-.1.268-.264 1.263-.167 1.512.097.244.578.8.813.91.238.116 1.3.183 1.545-.018.249-.2.409-.387.538-.715.13-.327.807-.856.645-1.105-.165-.247-.224-.366-.2-.59.023-.233.406-.262.486-.645.08-.38-2.795-1.256-2.874-.91-.079.346.333.323.257.53-.075.206-.932.722-1.043 1.031z'/%3e%3cpath d='M390.16 255c.384-.162 1.272-1.073 1.283-1.458.012-.382-.269-.723-.163-.857.106-.137.392.063.606-.14.211-.2-2.049-2.066-2.147-1.703-.097.363.358.603.201.72-.159.116-.651-.057-.86.078-.212.13-.662.833-.72 1.057-.058.224-.353.269-.207.603.143.337.11.3.256.602.145.302.96 1.11 1.15 1.133.188.025.22.13.601-.035zm86.74 7.25s.049 1.07.461 1.551c.416.479.837.467 1.01.57.17.103.697.111.992-.015.297-.13 1.168-1.146 1.197-1.4.026-.25-.27-1.01-.172-1.183.096-.171.448.004.437-.31-.015-.318-2.089-1.416-2.28-1.07-.194.347.246.4.05.552-.196.152-.84.243-1.103.312-.268.071-.592.993-.592.993z'/%3e%3cpath d='M480.26 262.95c-.214.156-.842.823-.891 1.05-.049.227.052.86.184 1.052.13.191.936.723 1.234.688.299-.04.52-.104.787-.29.27-.187 1.07-.271 1.064-.533-.005-.259.01-.379.142-.532.133-.159.455-.01.709-.26.256-.245-1.584-2.207-1.818-1.983-.238.223.096.393-.065.511-.162.12-1.099.116-1.346.297z'/%3e%3cpath d='M480.96 267.83c.364.14 1.557.135 1.82-.092.26-.226.297-.61.457-.623.16-.017.22.283.496.293.276.006 0-2.544-.302-2.384-.304.162-.166.596-.345.567-.182-.026-.4-.439-.627-.489-.226-.051-.988.097-1.18.198-.184.104-.408-.055-.533.24-.125.294-.125.251-.226.527-.102.275-.096 1.277.016 1.41.11.129.064.216.424.353z'/%3e%3c/g%3e%3cpath d='M346.72 237.45c.278.417-.09 1.421-.317 1.706-.226.284-1.74-.13-1.762-.41-.024-.284-.134-.759.064-1.025.2-.265.709-.873 1.094-.796.384.07.822.383.921.525zm.41-1.88c-.178.38.077.808.272 1.017.196.208 1.283.479 1.58.299.297-.183.75-1.869.541-2.129-.208-.26-.793-.304-.99-.275-.198.035-1.28.824-1.403 1.088zm3.62-1.72c-.146.345-.098.821.025.968.123.148.831.644 1.248.623.416-.026.614-1.194.614-1.418 0-.224-.124-.32-.418-.448-.292-.122-1.469.275-1.469.275zm34.27 18.13c-.093.417-.926.775-1.232.796-.309.023-.94-1.175-.78-1.355.16-.18.386-.53.666-.556.278-.03.951-.066 1.13.223.18.282.247.743.216.892zm1.4-.84c-.34.108-.454.522-.466.77-.015.244.456 1.09.74 1.169.285.082 1.588-.619 1.623-.904.036-.283-.276-.68-.413-.784-.13-.106-1.252-.327-1.484-.251zm3.17 1.29c-.3.107-.56.417-.583.584-.018.163.093.9.351 1.149.259.247 1.09-.31 1.228-.442.136-.132.127-.265.03-.525-.094-.26-1.026-.766-1.026-.766zm89.98 10.76c-.26.311-1.115.22-1.385.089-.266-.124-.273-1.431-.061-1.507.21-.076.554-.259.803-.153.243.104.825.397.852.72.024.325-.121.742-.209.851zm1.27.12c-.323-.074-.623.185-.756.36-.135.177-.185 1.024-.002 1.208.18.193 1.57.264 1.74.066.17-.198.122-.633.07-.773-.053-.138-.83-.813-1.052-.86zm1.45 2.59c-.27-.114-.65-.09-.774-.005-.117.09-.536.612-.526.925.009.315.933.49 1.108.495.18.009.263-.083.37-.299.108-.217-.178-1.116-.178-1.116z' fill='%23f7e204'/%3e%3cellipse cx='476.695' cy='268.569' rx='2.938' ry='5.862' transform='rotate(47.855 476.695 268.568)' fill='url(%23d)'/%3e%3c/g%3e%3cg transform='translate(-.699 1.184) scale(1.16833)' fill='%2378732e'%3e%3cpath d='M375.12 185.22s-5.026.432-8.52-.173c-3.492-.605-2.725-9.507-2.811-9.766-.084-.26-2.13-2.42-1.79-4.407.342-1.989 6.795-7.233 7.668-7.519.597-.195 1.874.347 1.874.347s1.631-1.587 2.115-1.587c.499 0 1.187.915.996 1.306-.193.388-2.408 1.684-2.579 2.678-.17.994.022 1.988-.618 2.96-.638.972-1.874 2.29-2.023 3.111-.149.821-.51 1.535.107 1.837.618.303 2.727.043 4.537-.777 1.809-.822 2.554-1.924 2.81-1.815.256.107-1.043 2.267-3.045 3.112-2.001.842-3.323 1.813-4.324 1.663 0 0-1.107 2.658 2.323 2.808 3.428.152 5.324-.755 5.324-.755zm-19.64 20.96s2.64 1.035 2.64 3.978c0 2.937-2.894 5.399-2.81 10.584.086 5.188.89 5.239 7.753 10.804.213.174 1.661 1.644 2.044 3.33.385 1.683 1.618 11.623 8.223 11.577 6.6-.041 7.496-4.23 7.496-4.23l-2.812-4.15s-2.3.688-3.536.388c-1.234-.303-2.34-1.124-3.067-2.722-.723-1.6-.92-5.408-2.044-7.086-2.769-4.15-7.71-4.841-7.752-9.206-.043-4.366 3.023-4.839 2.171-10.027-.85-5.184-7.028-7.691-7.028-7.691l-2.512-1.016-.873 5.207z' fill='%23a8ac71'/%3e%3cpath d='M373.67 169.89c2.214-.517.937-6.29.937-6.29l-1.533 1.276s.948 1.233.948 2.56c0 1.326-.352 2.454-.352 2.454z' fill='%23f1a720'/%3e%3cpath d='M377.71 227.47s-1.027-.844-1.129-.914c-.791-.526-4.257-3.327-3.702-11.656.626-9.421 14.325-14.376 15.22-18.122.992-4.148 4.093-5.96-6.815-14.49l-2.557 2.996 4.473 3.357s.99-.556 1.047.714c.058 1.266-1.193 2.355-1.5 3.348-.283.906-7.086 5.632-7.597 6.094-.51.462-3.906 3.101-3.906 3.101s-1.77 1.741-3.419 5.4c-1.645 3.66-.797 8.354-.797 8.354s.054 10.003 10.681 11.817z' fill='%23a8ac71'/%3e%3cpath d='M371.03 232.74l.767 3.543-2.172.799-.937-.042-.68.3-1.683 1.625-.427-.134s-.256.09-.34-.95c-.086-1.035-.235-1.944-.235-1.944l2.045.84.723.046.511-.173.895-1.943zm-6.35.65s-.682-.821-1.022-1.317c-.29-.424-.436-.523-1.193-1.127l1.49-.839 1.598.02-.234 1.923zm3.63-5.69s1 .496 1.32 1.252c.32.758.788 1.686.788 1.686l-2.534-.192-1.939-.61 1.257-1.749zm-.99 15.67s-.513-.322-.81-1.14c-.3-.824-.534-2.142-.534-2.142l1.684-.322 1.98.796.555.047s-.469.992-.533 1.037c-.063.043-1.917 1.66-1.917 1.66zm6.72-5.43s-1.488-.468-1.724-1.169c-.255-.754-.448-.601-.448-.601l-.467 2.006-.597 1.882s.127.323.194.323c.062 0 1.425-.346 1.512-.387.084-.041 1.125-1.125 1.148-1.189.021-.065.382-.865.382-.865zm-6.27 6.31s.745.41 1.788 1.016c1.045.603 1.662.603 1.662.603l.788-.841.809-1.6.107-.194-4.026.364zm5.82-1.55l3.431-2.054.233-1.856-.68-.52s.128.063-.809.063h-1.172l-.618 2.271zm-2.45 3.24s2.405 1.036 6.558-.476c1.882-.685 2.237-1.598 2.237-1.598l-1.662-.646-1.574 1.405-5.56 1.315zm-3.28-26.63s-.243-.775-.479-1.789c-.233-1.015-.213-1.448-.213-1.448l1.223.635 1.768 1.316-1.257.998zm2.89 4.89s-.598-.605-1.11-1.38c-.51-.78-.865-1.5-.865-1.5l1.3.268 1.513.731-.668 1.956z'/%3e%3cpath d='M363.02 169.18c-.228.836-.54 2.363.625 2.651.63.155 3.127-.051 5.963-3.284 1.364-1.557 1.39-3.086 1.39-3.086l.54-1.754s-1.107-.808-2.897.315c-1.608 1.01-5.621 5.158-5.621 5.158z' fill='%23c6c7a6'/%3e%3cellipse cx='370.771' cy='164.639' rx='.502' ry='.531' fill='%231c242f'/%3e%3cpath d='M367.16 165.17c-1.211.945-2.343 2.162-2.343 2.162s1.916-.542 3.44-1.926c.864-.785 2.55-1.09 3.438-.884.462.106.301-.49.086-.66-.497-.393-1.882-.591-2.184-.362-.042.033-1.218.718-2.437 1.67z' fill='%23a8ac71'/%3e%3cpath d='M372.92 218.3s-.084-.399-.138-1.393c-.054-.995.06-1.493.06-1.493l-1.135.986-1.087 1.512 1.682.603zm-5.88-3.36s-.156-1.546-.07-3.014c.083-1.467.68-4.135.68-4.135l.718 1.825 2.065 3.218.66.477-1.746 1.276-1.788.582zm5.92-.82s.105-.733.287-1.413c.176-.664.695-1.727.695-1.727s.028.108-.057.126c-.085.023-1.81 1.451-1.853 1.514-.043.066-.809.733-.809.733l1.085.824.7-.04m-4.818-7.657s.263-.965 1.178-2.132c.915-1.166 1.818-2.362 1.818-2.362l.78 3.134.468 2.676.085.566s-.637.282-.894.259c-.256-.022-2.173-.132-2.407-.455-.233-.324-1.028-1.686-1.028-1.686zm6.21 3.65s.582-.618 1.093-1.092c.51-.478 1.324-1.395 1.324-1.395l-4.208.77.597 1.423zm-2.54-8.7s.39-.139 1.52-1.281c1.127-1.148 1.703-1.01 1.703-1.01l.47 4.517-2.216-.65z'/%3e%3cpath d='M377.1 207.36l2.534-2.571-4.215-1.207.769 2.96zm1.77-6.8l.256-4.364s-.86.402-1.946 1.308c-1.085.907-1.59 1.196-1.59 1.196l.51.78 1.492.97zm3.75-4.23l.006-3.436-.148.066s-.604.93-1.305 1.512c-.704.583-1.024.993-1.024.993l1.13.736 1.34.129zm1.57 4.6s1.188-.988 2.057-1.674c1.298-1.029 1.947-2.15 1.947-2.15l-5.451-.412.213 2.183zm-12.68-18.05l-.17 2.392 4.545-.027-1.11-1.526-1.387-.866-1.307-1.326zm8.78 21.31c.24-.18 1.423-1.067 1.98-1.633.617-.626 1.587-1.253 1.587-1.253l-4.324-.476.086 2.854zm8.23-7.79s.464-1.74.42-3.404c-.042-1.663-.314-2.407-.314-2.407l-3.236 2.203.467 1.642 1.237 1.341z'/%3e%3cpath d='M382.98 192.4s.958-1.16 1.022-1.828c.064-.67.057-.462.057-.462l2.557.043 1.532.128.192.154-1.15 1.36-1.576.906-2.023.24zm5.18-2.55s-1-1.716-1.566-2.67c-.563-.95-1.118-1.403-1.118-1.403l-1.248 3.714-.126.359z'/%3e%3cpath d='M356.53 215.28l-.489 1.034s1.703-.884 3.025-.84c1.319.044 2.79 1.687 2.79 1.687l.319-1.194s-1.747-1.705-2.897-1.787c-1.152-.089-2.748 1.1-2.748 1.1zm.852-7.626s.363.43.447.56c.084.13.128-1.275 1.852-2.009 1.726-.735 2.664-.151 2.664-.151s-.341-.995-1.106-1.21c-.768-.218-1.513-.065-2.452.605-.936.67-1.405 2.205-1.405 2.205zm5.857 5.743s-.809-1.723-2.214-2.07c-1.407-.346-3.196.73-3.196.73l-.296.91s1.915-1.082 3.321-.518c1.406.56 1.96 2.162 1.96 2.162zm-6.58-6.696c.084.304.426.69.426.69s-.193-1.856.66-2.807c.852-.951 1.49-1.296 1.49-1.296l-.788-.413s-1.128.757-1.514 1.579c-.382.82-.36 1.944-.274 2.247zm-.76-3.039c.396-.921 1.568-1.325 1.568-1.325s-.119-.204-.383-.347c-.266-.141-.542.012-.542.012s-.757.392-1.212 1.43c-.453 1.035-.396 2.534-.396 2.534l.702.39s-.136-1.772.262-2.694zm10.336-25.064c1.08-.577 1.875-.461 1.875-.461s-1.594 1.678-.825 3.768c-.905 1.75-1.19 3.081-1.19 3.081h.85s.289-1.363.625-2.437c.923 1.786 2.472 2.79 2.472 2.79l1.305-.057s.002-1.74.673-3.255l.125.142c1.417 1.499 2.611 1.847 2.611 1.847l.014-.447s-1.49-.88-2.342-2.032l-.085-.124.025-.05c1.024-1.611 2.388-2.13 2.388-2.13l.909.75.225-.289-.68-.864-.788.022s-1.412 1.177-2.323 2.204a12.015 12.015 0 01-1.034-2.054l-.584-.214s-1.414.163-2.68 2.208c-.157-1.5 1.573-3.138 1.573-3.138l-.085-.627s-1.748.33-3.11.734c-1.363.404-2.194 1.686-2.194 1.686l-.056.92s1.227-1.397 2.306-1.972zm1.875 2.766c.795-1.153 2.555-1.901 2.555-1.901s.045.933 1.015 2.173c-.662 1.162-.957 2.953-.957 2.953s-1.363-.862-2.556-2.592a2.12 2.12 0 01-.21-.387c.05-.087.1-.17.153-.246zm-9.94 27.758l.065 1.012s1.043-1.141 2.62-1.185c1.576-.045 2.918 1.185 2.918 1.185s.02-1.359-.192-1.486c-.213-.132-1.492-.867-2.685-.867-1.192 0-2.725 1.34-2.725 1.34zm28.116-14.74a13.338 13.338 0 01-.612-1.348c.238-.09.474-.21.696-.376a16.368 16.368 0 002.258-2.074l-.469-.736h-2.13c-.417 0-1.303-.105-1.804-.17.093-.326.356-1.243.663-2.196.384-1.189.73-1.827.73-1.827l-.724-.733s.17.676-1.108.849c-1.278.173-3.635-1.035-3.635-1.035v.518s2.073.663 3.265.835a2.316 2.316 0 001.59-.351c-.183.378-.52 1.117-.702 1.776-.155.566-.377.935-.362 1.18.01.16.242.304.242.304l-.113 1.11s1.278.171 1.873.171c.597 0 2.215.13 2.215.13s-1.15 1.342-2.257 1.859c-.146.07-.3.123-.46.17-.059-.157-1.322-2.085-1.322-2.085l-.128.713s.904 1.241.994 1.504c-.817.108-1.994-.172-1.994-.172l-.511.563s-.037 1.6.012 3.255a35.242 35.242 0 01-2.341-.749l-.457.346.022-.08-.588.47s-.511 1.942-.382 4.148l.007.112c-2.1-.52-3.16-1.756-3.16-1.756l-.511.434s-.345 1.904.13 4.203c-1.795-.356-3.354-1.913-3.354-1.913l-.667.56s.398 3.719.823 5.748c.035.174.085.323.13.477a6.426 6.426 0 01-.982.042c-1.83-.087-2.967-1.772-2.967-1.772l-.54 1.309s.697 3.575 2.698 5.174l.451.36c-1.71 1.396-3.76 1.615-3.76 1.615l.127 1.128s1.222.958 2.414 1.782c.118.076.243.153.373.221-.951.85-2.116 1.194-2.116 1.194l.313.747s1.583-1.105 2.317-1.7c1.06.427 2.456.595 2.456.595v-.606s-1.027-.092-1.978-.396l.139-.129c.596-.577 1.76-2.361 1.76-2.361l.113-1.296s-.733-.104-1.527-.737c2.416-1.652 2.508-2.404 2.508-2.404l.456-.854s-.816-.35-1.418-1.538c1.657-.322 3.804-.858 3.835-.948.042-.129.287-.27.287-.27s-.929-1.521-1.325-3.384c1.91.494 3.859.813 3.859.813l.61-.522s-.47-1.544-.621-3.226c2.265.143 4.186.313 4.186.313l.383-.433s-1.277-2.442-1.234-3.824l.003-.127a6.2 6.2 0 001.273.127c1.877-.045 3.962 0 3.962 0l.32-.714s-1.81-1.232-2.235-2.012zm-13.79 20.332s-.608 1.236-1.844 2.662c-.1.112-.198.211-.295.312a6.054 6.054 0 01-.642-.312c-1.448-.822-1.819-1.759-1.819-1.759s.8-.392 3.237-2.026c1.288 1.02 1.364 1.123 1.364 1.123zm1.136-4.124s-.76.905-2.534 2.488a5.418 5.418 0 01-.546-.599c-1.136-1.472-2.556-2.738-2.413-4.956 0 0 .88 1.586 2.841 1.382.4-.038.86-.109 1.336-.191.522 1.313 1.316 1.876 1.316 1.876zm2.642-3.326s-1.815.596-3.5.867a6.964 6.964 0 01-.207-.565c-.637-2.074-.637-5.229-.637-5.229s1.415.979 3.4 1.53c.577 2.354.944 3.397.944 3.397zm-.601-3.837c-.294-1.935.091-3.855.091-3.855s1.055 1.054 3.023 1.384c.135 1.789.342 2.677.342 2.677s-1.495.083-3.456-.206zm7.63-2.948s-1.269.492-3.708.15a19.81 19.81 0 01-.04-.712c-.085-2.203.109-3.987.109-3.987l.007-.026c.347.153 1.645.684 2.855.979l.011.14c.17 1.987.766 3.456.766 3.456zm-.172-4.104l-.131-.031c.083-1.413.077-3.47.077-3.47s1.187.317 2.101.193c.242.6.085.757.68 1.664.598.909 1.492 1.644 1.492 1.644s-3.025.257-4.219 0zm-9.88 24.441l-.17-.706s-1.192.886-1.53 1.796a2.163 2.163 0 01-.375-.094 181.81 181.81 0 01-2.667-1.02l.268.53s1.945.894 2.455 1.01l.165.03a72.103 72.103 0 01-.645 1.84l.313.434s.177-1.314.679-2.233c.667.066 1.592.1 1.592.1s-.114.517-.286 1.094c-.168.577-.511 1.931-.511 1.931l.583.361 2.714.056-.457-.539s-.084-.135-.965-.163c-.881-.03-1.42.116-1.42.116s.113-.55.454-1.646c.34-1.096.356-1.032.356-1.032l-.342-.95s-.867.24-1.443.22a3.985 3.985 0 011.232-1.135zm-14.825-1.711c1.662 0 3.067 1.12 3.067 1.12l-.063-.794s-1.299-1.752-2.79-1.752c-1.492 0-3.259 1.535-3.259 1.535v1.64s1.383-1.75 3.045-1.75zm17.507 25.497c-1.703.732-3.62.732-3.62.732s.518-.742 1.026-2.025c3.332-.935 4-3.159 4-3.159l-.213-.821s-.807 2.033-3.492 3.154c.497-1.575 1-4.234 1-4.234l-.915-.237s-1.314 1.644-2.553 2.06c.84-1.636.956-3.51.956-3.51l-.405-.713s-.895.8-2.301 1.06a2.314 2.314 0 01-.687.007l.005-.007c.768-1.079 2.238-4.192 2.238-4.192l-.257-.585s-1.128 2.748-2.279 4.127c-.147.18-.29.346-.436.507-1.176-.34-2.863-1.348-2.863-1.348l.19.52s.956.73 2.349 1.173c-.849.89-1.774 1.72-1.774 1.72l.083 1.253s2.16.41 3.933.59c-1.428 2.02-2.589 2.693-2.589 2.693l.575.866s1.754-.011 4.902-.785c-.896 1.692-1.578 2.427-1.578 2.427s2.874.198 4.834-.8c1.96-.994 2.555-2.03 2.555-2.03l-.553-.608s-.426 1.429-2.13 2.165zm-9.072-5.407s.846-.93 1.572-1.885l.09.025c2 .432 2.553-.173 2.553-.173s.38 1.085-.84 3.034c-1.44-.06-3.375-1.001-3.375-1.001zm1.788 4.02l1.79-2.078a5.3 5.3 0 00.341-.437c1.962-.07 3.067-1.68 3.067-1.68s.23 1.625-.648 3.627c-2.493.908-4.55.568-4.55.568zm-2.428-12.88c1.875.13 4.303 1.013 4.303 1.013l-.298-.992s-2.308-.564-3.745-.75c.642-1.438 2.061-2.122 2.061-2.122l-.638-.347s-.786.129-1.853 1.946a5.376 5.376 0 00-.24.451 5.485 5.485 0 00-.4-.018c-1.703-.046-3.13.948-3.13.948l.256.52s1.484-.642 2.946-.668c-.53 1.475-.924 3.152-.924 3.152l.385.887s.742-2.37 1.261-4.02zm-3.94-8.038l-.405-1.04s-2-.709-3.534.023c-1.534.735-2.684 2.507-2.684 2.507l.64 1.21s1.064-1.966 2.47-2.44c1.404-.477 3.514-.26 3.514-.26zm3.898 3.046l-1.32-.693s-2.172.629-2.94 1.407c-.767.78-1.384 2.767-1.172 3.327.213.56.896.928.896.928s.36-2.095 1.426-3.088c1.066-.994 3.11-1.881 3.11-1.881zm-5.067-.625c.892-.864 2.512-1.19 2.512-1.19l-.81-.734s-1.96.238-2.982 1.146c-1.022.909-2.343 2.788-2.343 2.788l1.152 1.121s1.576-2.27 2.471-3.13zm6.744-58.716l.07-.09c1.033-1.328 2.035-1.328 2.428-1.22.165.045.385.026.581-.007l-.007.006.031-.011c.05-.01.094-.018.138-.028.05 0 .096.017.122.066-.328.518-.793 1.937-1.035 3.13-.3 1.468-.936 1.642-1.405 2.548-.468.91-1.447 2.423-1.49 3.717-.043 1.297.297 1.988.638 2.162.342.173.967-.564.937-.864-.043-.432-.382 0-.638 0-.255 0-.213-.432-.341-1.21-.129-.779.935-2.939 1.32-3.631.383-.691 1.192-1.512 1.362-2.68.153-1.04.911-3.319.911-3.327 0-.064-.58-.223-1.708-.302-.84-.061-1.973.676-2.509 1.5-.532.821-2.209 1.48-2.209 1.48s1.837.013 2.805-1.239z' fill='white'/%3e%3cpath d='M374.33 178.91l-3.27.087.938 2.446zm-3.85-.13s-.475-.301-.703-.562c-.227-.26-.404-.368-.404-.368l-1.178.742-.682 2.42.34.346zm-.44 6.56l-2.386-3.515-1.362 2.932.652.23s.653.064 1.647.208c.994.145 1.449.145 1.449.145zm9.7 58.72l-.12.082c-.565.378-3.069 1.906-6.141 1.906a8.76 8.76 0 01-4.535-1.248c-.916-.546-1.542-1.36-2.003-2.347-.692-1.476-.995-3.335-1.311-5.139-.322-1.803-.649-3.551-1.444-4.836-1.072-1.708-3.09-2.776-4.899-4.298-1.813-1.522-3.424-3.45-3.761-6.875-.034-.347-.05-.69-.05-1.026-.001-2.262.726-4.23 1.462-5.952.733-1.727 1.49-3.196 1.495-4.523 0-.222-.022-.441-.072-.653-.243-1.025-1.127-1.884-1.94-2.52-.814-.628-1.567-1.015-1.575-1.02l-.017-.008-1.27-.351-.108.398 1.25.347.054-.2-.092.185s.043.021.121.066c.281.155.998.577 1.683 1.15.687.574 1.33 1.312 1.495 2.045.042.18.06.37.06.56.007 1.163-.715 2.622-1.46 4.359-.741 1.739-1.496 3.764-1.497 6.116 0 .352.018.706.053 1.066.343 3.552 2.054 5.607 3.907 7.157 1.855 1.548 3.84 2.626 4.813 4.203.984 1.57 1.244 4.081 1.716 6.499.237 1.205.531 2.392 1.016 3.43.483 1.038 1.164 1.93 2.166 2.525a9.171 9.171 0 004.74 1.304c3.665-.003 6.481-2.054 6.5-2.067z'/%3e%3cpath d='M376.91 237.6l-.025.02c-.14.082-.796.448-1.64.448-.678-.003-1.476-.224-2.284-1.02-.987-.973-1.276-1.877-1.525-3.024-.244-1.148-.434-2.53-1.212-4.34-.804-1.867-2.784-3.357-4.625-4.821-1.85-1.456-3.547-2.888-3.852-4.444a4.306 4.306 0 01-.087-.877c-.004-1.314.564-2.647 1.15-4.154.585-1.506 1.181-3.191 1.181-5.215 0-.342-.016-.695-.053-1.055-.272-2.608-2.26-4.547-4.151-5.841a18.497 18.497 0 00-3.724-1.953l-.136.391s.107.038.304.119c.683.278 2.414 1.05 4.018 2.288 1.606 1.24 3.07 2.932 3.282 5.04.034.345.051.685.051 1.011 0 1.94-.57 3.562-1.151 5.062-.58 1.5-1.178 2.872-1.18 4.307 0 .32.03.639.094.962.376 1.785 2.158 3.218 4 4.687 1.851 1.461 3.778 2.948 4.505 4.66.756 1.762.937 3.088 1.187 4.258.248 1.171.582 2.2 1.64 3.239.878.868 1.8 1.138 2.568 1.133a3.659 3.659 0 001.89-.533z'/%3e%3cpath d='M388.97 227.59s2.29.54 2.206 2.397c-.086 1.86-1.108 4.45-1.108 4.45l-3.153-2.853 1.775-1.57.652-.933z' fill='%23a8ac71'/%3e%3cpath d='M349.61 205.23s-2.257.777-2.725-.216c-.47-.994-.256-1.773-.298-1.987-.044-.216-1.365-.303-1.236-1.6.127-1.297 1.788-1.21 2.13-1.21.342 0 .425-1.99 1.577-1.9 1.15.085 1.703 1.424 1.703 1.424z' fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35'/%3e%3cpath d='M352.12 205.84s-1.916.996-2.514.043c-.596-.952 0-2.162-.213-2.378-.214-.214-1.361-.604-1.15-1.726.214-1.124 1.406-.78 1.833-.996.425-.215.723-1.901 1.916-1.598 1.192.304 1.406 1.253 1.406 1.253s-.939 4.493-1.278 5.402z' fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35'/%3e%3cpath d='M355.36 206.27s-.555 1.212-1.917.948c-1.364-.256-.937-2.244-1.151-2.592-.212-.343-1.192-.604-1.022-1.857.17-1.252 1.406-1.08 1.874-1.252.469-.174.979-2.119 1.874-1.817.896.304 1.746 1.427 1.576 1.946 0 0-1.916.603-2.172 1.9-.255 1.298.938 2.724.938 2.724z' fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35'/%3e%3cpath d='M385.51 227.14s-1.703-1.872-2.896-3.512c-1.193-1.645-3.04-3.52-3.04-3.52l-2.923-1.468-1.846-3.083-.23-3.63.797-2.102 1.108-1.614s-6.057 2.169-2.983 13.771c1.308 4.927 4.658 5.644 4.658 5.644l5.566-.34z' fill='%23af7029'/%3e%3cpath d='M382.71 188.39c.576.018.86.21 1.034.45.173.244.228.57.227.851 0 .153-.016.289-.031.386l-.02.112-.008.035.199.053-.187-.084c-2.003 4.438-6.255 6.51-10.07 9.274-1.904 1.384-3.693 2.947-5.007 5.078-1.315 2.136-2.145 4.838-2.145 8.469 0 .183.002.372.007.56.146 6.673 2.67 10.264 5.448 12.142 2.775 1.885 5.777 2.075 6.91 2.078.297 0 .466-.013.47-.013l.006-.003h.006c.002 0 .777-.1 1.894-.202 1.114-.097 2.566-.2 3.904-.2.855 0 1.666.042 2.303.149.639.1 1.1.287 1.242.48.178.224.245.447.247.676.004.505-.365 1.087-.815 1.551-.443.465-.965.825-1.15.91l.172.375c.265-.124.787-.49 1.272-.996.478-.503.924-1.141.93-1.84a1.48 1.48 0 00-.34-.938c-.292-.348-.817-.51-1.493-.628-.674-.11-1.5-.15-2.368-.15-2.714 0-5.845.4-5.851.4l.026.208-.017-.208-.11.005a8.314 8.314 0 01-.328.006c-1.09 0-4.014-.192-6.684-2.003-2.667-1.817-5.112-5.233-5.266-11.807-.002-.186-.006-.37-.006-.553.003-3.57.811-6.183 2.082-8.247 1.905-3.099 4.88-4.984 7.787-6.945 2.906-1.96 5.752-4.004 7.315-7.458l.008-.016.004-.018c.002-.01.071-.28.071-.638-.002-.33-.057-.74-.304-1.094-.243-.354-.69-.611-1.354-.623l-.01.415z' fill='%23816c2a'/%3e%3cpath d='M390.88 229.04s-1.436 2.631-1.8 2.658c-.366.026 1.242.415 1.606 1.035l-.343.643s-1.59-1.131-2.586-1.179l-.09-.97s.813-.275 1.487-.89c.554-.506 1.132-1.922 1.143-2.248z' fill='white'/%3e%3cpath d='M396.48 230.77l-3.579.98-1.824-1.14s.15-1.49-.66-2.129c-.835-.66-1.33-.854-2.055-1.157-.724-.302-3.28-.356-3.28-.356l-6.465-7 2.415.256 3.819-.474 3.55-.302 1.875.276 2 .618 1.052.89 1.092.967 1.095 1.8.696 2.033.284 2.188z' fill='%23fcca3d'/%3e%3cpath d='M396.62 230.54s-1.28.378-2.897.345c-1.62-.023-2.65-.274-2.65-.274s.094.102-.248 1.17a15.072 15.072 0 01-.654 1.727l.059 4.204 3.407.668 1.79-.694.909-4.582z' fill='%23af7029'/%3e%3cpath d='M395.67 228.76l.155 1.63.667.194-.016-1.467zm-3.21-39.29l-.398-2.865-1.122-1.901-1.42-1.946-1.52-1.672-.85-.76-.356-.563-3.735.173-1.958 2.334s5.1 3.599 7.02 7.532c1.651.496 2.936 1.54 3.669 2.255l.173-.31z' fill='%23fcca3d'/%3e%3cpath d='M388.84 192.63c-.053 2.92-.554 4.308-.942 4.955l2.262-2.594 1.63-2.93c-.733-.715-2.018-1.76-3.67-2.255.456.938.735 1.892.72 2.824z' fill='%23af7029'/%3e%3cpath d='M394.11 235.87c-.003-.002-1.052-1.313-1.834-2.08-.799-.776-1.722-1.201-1.733-1.208l-.17.378s.05.023.144.074c.282.149.923.52 1.475 1.059.375.366.828.879 1.184 1.294.357.42.617.744.617.745z' fill='%23816c2a'/%3e%3cpath d='M396.31 232.73s-.342 1.264-1.619 2.416c-1.279 1.154-2.897 1.932-2.897 1.932l3.663 1.354 2.442-2.274z' fill='%236f5b24'/%3e%3cpath d='M396.85 235.77l-.224.433-.688.666-.54.573.913-3.8.651 1.121.085.606z' fill='%23404118'/%3e%3cpath d='M375.12 185.22s-5.026.432-8.52-.173c-3.492-.605-2.725-9.507-2.811-9.766-.084-.26-2.13-2.42-1.79-4.407.342-1.989 6.795-7.233 7.668-7.519.597-.195 1.874.347 1.874.347s1.631-1.587 2.115-1.587c.499 0 1.187.915.996 1.306-.193.388-2.408 1.684-2.579 2.678-.17.994.022 1.988-.618 2.96-.638.972-1.874 2.29-2.023 3.111-.149.821-.51 1.535.107 1.837.618.303 2.727.043 4.537-.777 1.809-.822 2.554-1.924 2.81-1.815.256.107-1.043 2.267-3.045 3.112-2.001.842-3.323 1.813-4.324 1.663 0 0-1.107 2.658 2.323 2.808 3.428.152 5.324-.755 5.324-.755z' fill='none' stroke='%2378732e' stroke-width='.3'/%3e%3c/g%3e%3cg fill='%23d2a567'%3e%3cpath d='M487.942 173.581s-10.755-2.03-10.58 6.924c.057 2.826.684 3.806 2.958 4.443 2.274.634 6.83.866 10.695 4.328 3.862 3.462 4.15 6 4.15 8.077 0 2.076-.964 3.982-.964 3.982l2.441 11.828 2.45 8.77 7.278-4.213 4.267-12.982-5.46-23.369z' fill='%23ab6d29' stroke='%234d2a15' stroke-width='.511'/%3e%3cpath d='M498.62 218.597s3.747-1.416 4.712-4.444c.264-.831-3.785-4.474-3.883-4.474-.097 0 2.058 1.041 3.054 1.95.994.91 1.757 1.281 2.053 1.146.3-.135 2.028-4.142 1.364-5.017-.664-.874-1.696-2.927-3.254-3.97-1.557-1.044-3.615-.91-3.615-.91s2.855-.908 4.28-.1c1.423.807 1.558 1.75 1.723 1.414.167-.337-.3-4.343-.945-5.69-.646-1.346-1.309-1.986-3.036-2.322-1.72-.338-3.58-.204-3.58-.204s2.488-1.379 4.376-.907c1.89.472 1.861 1.414 2.023 1.212.17-.203-.93-3.669-1.372-4.545-.451-.874-2.707-2.626-3.338-2.828-.628-.202-2.688-.265-2.688-.265l-.995.013s1.432-.992 3.256-.824c1.82.169 1.92.774 2.183.674.267-.1-.199-.336-1.306-1.112-1.114-.772-6.489-3.063-6.489-3.063l-4.91-.068s-.052-1.244 1.378-1.479c1.427-.237 1.84.184 1.74-.187-.098-.368-4.143-1.26-4.143-1.26s-2.326.068-3.322.1c-.993.037-4.612.454-4.612.454s.315-.793 1.023-1.412c.539-.475 1.375-.771 2.064-.96 1.59-.438-.896-1.683-.896-1.683l1.328-2.018 5.974.502 12.607 7.373 5.908 5.084 3.746 9.558-1.128 16.424-8.43 6.969s-3.713.573-3.713.404c0-.17.863-3.535.863-3.535z' fill='%234d2a15'/%3e%3cpath d='M487.626 177.8s-.4-1.162-.4-2.626.25-1.414.25-1.414-4.03-.557-6.968 1.766c-2.934 2.323-1.244 6.361-1.244 6.361s1.282-1.262 2.92-1.87c1.643-.601 4.597-.502 4.597-.502.248-.254-.646-1.415-1.742-1.667-1.098-.252-3.235-.252-3.235-.252s1.245-.86 3.385-.655c2.141.2 2.437.858 2.437.858z'/%3e%3cpath d='M500.232 220.01l-2.723.945 1.66 11.443 10.881 18.644 5.707-1.005 1.926-3.435 1.526.674c.657.674 2.788 4.307 4.58 5.047 1.79.741 2.716.472 4.312 1.756 1.594 1.275 7.415 9.944 7.716 10.276.294.338-.335-3.717-.335-3.717l-1.774-5.184-2.201-3.618-.334-.975 3.019.033 1.872 1.147 2.871 2.401 1.491 1.769.781 1.82.329 1.594.768 2.476 1.588 3.435 1.913 3.264.61-1.331-.93-3.836-2.919-9.307-1.79-3.13s2.355 1.697 2.983 1.916c.631.223 2.772 3.42 2.772 3.42l1.362 3.296.98 3.062.671 2.678.984 2.857 1.69-.973-.296-2.067-1.46-6.382-.63-6.916s.816-.02 1.805 1.074c1 1.092 1.895 3.571 1.895 3.571l.733 6.26.991 5.737 1.857 5.859 1.94 3.683 1.263 2.067s.067-2.926.048-3.06c-.015-.132-2.373-24.498-2.373-24.498l.318-1.027s.281-.154 1.094 1.008c.812 1.16 1.627 2.976 1.627 2.976l.713 3.82.347 2.644.498 4.98.663 5.4 2.491 5.794 1.344 3.128.748-3.717-1.182-26.204.552-.757s1.39 1.145 1.853 1.955c.468.804 1.332 1.594 1.332 1.594l.811 5.774.731 16.527.58 4.257 4.86-43.286 3.002-.655.348-.826-2.192-1.683-4.922-7.64-3.32-7.388-5.822-10.728-10.105-12.318s-6.269-5.354-7.862-6.566c-1.593-1.21-2.911-1.967-2.911-1.967l.498-1.54 1.666-2.702-.272-.126-1.3.078-3.38.48-3.41-1.012-6.691-4.67-7.167-3.408-4.208-1.489-10.151-2.575-10.1-1.364-4.533-.062-4.129.77s-2.099.865-2.756 2.162c-.653 1.296-.705 2.203-.504 4.096.197 1.895 1.342 2.879 4.18 4.042 2.842 1.16 9.505 5.604 9.505 5.604l3.214 3.229 1.191 1.541.174 1.188 2.163 17.039-4.278 9.263-3.068 1.592z' fill='%238f4620'/%3e%3cpath d='M511.157 246.567s1.822 3.097 4.41.709c2.593-2.39-1.13-9.191-1.091-9.596.032-.404 1.191-.537 1.191-.537l1.894 3.5s1.127 1.884.693 4.88c-.428 2.996-3.315 5.587-3.315 5.587l-3.285-.74z' fill='%23ab6d29'/%3e%3cpath d='M574.713 286.5l-2.34-6.92s-.691-4.442-.691-5.35c0-.912-.45-12.17-.651-14.288-.198-2.12-.095-4.547-.32-4.845a962.59 962.59 0 00-2.54-3.36l-.992-1.037.702-.503s.862.944 1.098.435c.227-.501-.038-2.957-.995-6.797-.965-3.837-5.877-12.823-5.877-12.823l.53.436L564 232.83l2.887 2.32 6.24 2.289 3.385.54 2.186 4.376s1.559 7.54 1.46 11.339c-.1 3.807-.334 6.903-1.792 10.705-1.457 3.806-1.822 15.855-2.023 17.77-.2 1.923-.929 3.806-.929 3.806z' fill='%234d2a15'/%3e%3cpath d='M574.737 266.486s1.306-1.556 1.88-3.695c.57-2.133.794-18.922-1.192-21-1.994-2.077-6.059-3.715-6.259-3.578-.2.137 1.624 5.473 1.624 5.473s.611.782 1.235 2.17c.344.774.816 2.172.897 2.683.225 1.445 1.416 4.849 1.592 9.235.168 4.384.223 8.712.223 8.712z' fill='%238f4620'/%3e%3cpath d='M565.565 277.025s.855-7.943.456-13.76c-.395-5.816-.877-6.543-1.43-7.594a49.455 49.455 0 01-3.906-9.697c-1.352-4.844-2.229-8.561-3.104-9.53-.876-.97-2.63-3.069-3.025-2.502-.4.565-.4 1.777-.4 1.777l-2.39-.65-.556-1.533.766-2.473-.151-1.062-.28-1.75 3.087 2.457 6.338 4.343 3.184 13.145 2.951 8.18.415 13.853-.299 12.197zm3.727-37.9s1.658 1.564 2.626 2.106c.973.544 2.804 1.669 2.439 1.794-.358.125-2.078-.545-3.149-1.15a8.974 8.974 0 01-1.8-1.349z' fill='%234d2a15'/%3e%3cpath d='M556.943 273.894s1.264-2.788 1.063-6.324c-.2-3.535-1.888-12.051-2.42-13.13-.532-1.08-3.05-2.689-5.31-7.471-2.256-4.781-2.025-5.756-3.513-7.505a139.956 139.956 0 01-3.057-3.735l.464-5.118 5.508 2.794 2.356 1.177 2.79 13.394 2.49 3.737 1.057 5.356 1.332 12.485.724 9.93-.395.874zm-6.355-5.666s.147-3.939-.851-7.47c-.997-3.536-1.69-6.166-2.788-7.273-1.094-1.108-3.877-3.988-6.366-7.725-2.49-3.736-5.927-7.674-5.927-7.674l.09-5.011s1.653 1.555 3.062 2.239c1.409.684 3.52 1.865 3.52 1.865l1.472 5.746 1.9 4.134 2.784 3.697 1.779 1.642 1.134 6.186.61 3.48 1.467 4.968-.485 2.488-1.402-1.292zm-4.58.046l-1.52-1.462s.821-.989.424-2.958c-.399-1.965-.922-3.861-1.819-5.728-.893-1.866-1.163-3.005-1.712-3.558-.551-.554-5.205-4.95-6.82-6.284-1.615-1.342-4.103-3.891-5.649-4.877-1.542-.98-2.664-1.235-2.664-1.235l-.871-6.161s2.043 2.726 3.262 3.18c1.22.456 3.213 1.086 3.213 1.086l4.324 7.65 1.47 1.944 4.006 3.204 1.642 3.307 1.22 3.814 1.518 5.253.274 3.178zm-8.506-1.718s-2.553-2.927-2.954-4.817c-.397-1.882.268-1.882-.532-4.036-.798-2.152-3.45-5.315-5.64-7.07-2.193-1.75-5.307-4.305-5.107-5.721.2-1.412.596-1.48.596-1.48l1.328 1.142 6.83 7.274 2.095 3.806 1.593 4.743 1.06 2.223 1.028 2.829zm24.652-35.68s4.709 5.841 5.906.472c.531-2.39-1.633-6.94-1.633-6.94s-4.377-7.667-5.868-9.519c-1.492-1.85-8.793-11.209-8.793-11.209l-5.337-2.49 1.822 3.132s3.98 3.97 9.061 12.754c5.073 8.785 4.077 13.631 4.077 13.631l.764.17zm-27.35-35.201s9.352 7.977 15.378 16.608c6.019 8.635 8.408 14.393 7.063 15.55-1.344 1.162-5.127-.653-6.664-3.078-1.544-2.423-2.844-6.664-8.514-13.129-5.674-6.46-8.408-7.421-8.408-7.421l-4.083-6.614zM529.93 214.8s5.524 4.594 9.006 8.33c3.487 3.737 5.279 6.412 5.279 6.412l2.236 2.22s-1.343-2.37-.595-3.18c.744-.806 1.644-.402 1.644-.402l-17.57-18.431zm-1.144.514s1.792 3.433 4.728 6.31a741.936 741.936 0 006.168 5.959l1.248 4.492s-8.012-6.156-8.062-4.644c-.052 1.514 1.942 4.644 1.942 4.644l-2.44-1.311-3.385-4.9-2.042-4.24-2.288-5.858 4.13-.452z' fill='%234d2a15'/%3e%3cpath d='M504.555 234.3s4.18 3.735 6.472.1c2.29-3.635.497-7.825.497-7.825s5.902 8.702 7.566.554c.299-1.464-3.585-7.12-3.585-7.12l1.393-1.309 2.981 5.048s2.795-1.262 2.795-4.747c0-3.483-2.886-7.978-2.886-7.978l2.751 3.063s5.456.12 5.558-3.215c.097-3.33-4.58-6.815-4.58-6.815s3.733.252 3.68-1.92c-.045-2.168-5.07-3.684-5.173-5.046-.099-1.364 1.492-3.689 3.783-2.426 2.29 1.262 5.474 2.273 6.767-.2 1.295-2.477-.099-2.978-.099-2.978s-2.94-.607-3.231-.707c-.304-.102-5.23-2.778-5.23-2.778l-4.137-1.564-4.27-.557 1.585 3.18 1.102 8.735.045 4.04.796 8.786-2.09 7.32-1.084 1.32-.77.982-1.822 3.865-2.557 2.769-3.271 4.184-2.985 3.238z' fill='%234d2a15'/%3e%3cpath d='M534.185 250.703s-1.057-2.622-3.312-4.375c-2.26-1.753-5.843-1.886-5.843-1.886l6.134 6.5zm8.587 1.483s-1.99-3.968-4.31-6.395c-2.324-2.424-3.852-5.554-4.484-5.554-.627 0-1.091.135-1.091.135l.596 5.014 4.246 4.11s3.983 2.96 5.043 2.69zm7.068-.304s-.992-4.61-3.35-9.052c-2.35-4.444-4.842-6.262-4.842-6.262l.56 4.746 1.932 4.577 3.114 4.512zm5.77-2.593s1.66-9.492.168-12.12c-1.49-2.625-4.31-3.128-4.31-3.128l-.901 1.378.901 6.766 2.252 5.181zm5.679-15.82s1.392.707 3.084 3.903c1.69 3.198 4.082 12.659 4.044 13.163-.03.5-.893.385-1.124.272-.232-.124-5.974-9.093-5.974-9.093l-.911-8.382z' fill='%23ab6d29'/%3e%3cpath d='M521.216 244.499s3.036-.657 3.036-1.716c0-1.062-3.629-3.183-3.331-4.9.145-.856 3.084.153 3.285-.454.198-.604-3.034-5.653-2.043-6.814.996-1.161 3.734 5.452 3.734 5.452s1.64 3.111 1.044 4.897c-1.842 5.503-5.725 3.535-5.725 3.535zm7.115-6.87c.147-.441 4.779.606 4.828.303.178-1.087-4.179-4.443-4.179-4.443s-.997-1.916-.693-2.219c.294-.304 3.083.303 3.235-.102.145-.404-3.19-4.797-3.19-5.603 0-.81.9-.103.9-.103s2.636 2.728 4.032 4.949c1.388 2.221 2.698 4.04 2.235 7.573-.493 3.785-7.561.856-7.168-.356zm20.913-6.964s-.751-3.13-.302-3.535c.451-.402 1.647-.757 1.647-.757s-2.469-1.539-3.638-1.566c-1.17-.025-1.342-.365-1.64.127-.301.49 2.114 3.533 2.114 3.533z'/%3e%3cpath d='M535.154 233.084s7.117 1.768 7.415 1.264c.299-.505-5.675-6.062-5.675-6.062s-.396-1.005-.296-1.36c.098-.352 2.586-.404 3.333.201.744.606 0 1.766.25 2.221.246.455 2.49 3.888 2.888 3.331.4-.554-.453-4.745-.25-5.047.197-.302 2.739 2.372 3.429 2.827.699.455 4.682 3.586 5.08 2.121.4-1.462.647-1.716.495-2.576-.147-.857 1.33 4.041-.531 4.644-1.857.609-3.996-.652-3.996-.652l-1.644-1.265-.962-1.01s1.064 3.788-.182 4.19c-1.242.406-2.687.204-2.687.204l-2.984-.304-3.683-2.726zm16.345-4.86s7.596 4.557 8.345 3.752c.751-.806-1.984-11.505-1.543-12.62.352-.893 6.167 12.15 3.334 13.934-2.166 1.359-3.235.403-3.235.403l-3.731-1.97-3.17-3.5zm21.135 19.195s.687.509 1.655.783c.308.088 1.222.366.969.393-.247.02-2.023.238-2.151.287-.123.05-.473-1.462-.473-1.462zm-7.372-25.106s.724.413 1.173.538c.449.127 1.022.406 1.022.481 0 .077-.561.315-.96.265a2.422 2.422 0 01-.647-.164l-.588-1.121zm-2.185-3.74s.779.358 1.773-.351c1-.707 1.064-1.178.984-1.55-.084-.37-1.646-.37-2.173-.725-.532-.35-.5-.99-.5-.99l-1.71-.034-.63.235zm6.706 22.035s2.324 1.364 2.975 1.492c.643.127 1.742.734 1.59.934-.146.202-1.863.354-2.734-.15-.872-.507-1.159-.194-1.159-.194l-.672-2.083zm-12.513-34.594l.038.013c.13.037.56.147.929.107.442-.05.81-.32.966-.149.312.349.06 1.965-.57 2.426-.626.461-1.392.835-1.503.806-.116-.027-2.45-3.375-2.45-3.375zm-10.888-9.743s1.521-.09 2.28-.088c.76 0 1.642.55 2.325.982.683.432 1.367 5.02.995 5.886-.369.867-5.486-2.972-5.624-3.315-.146-.349-2.367-3.783-2.367-3.783zm-4.802-2.08s3.725.23 3.384-2.133c-.339-2.37-2.047-3.405-2.047-3.405l-4.462 3.172 3.124 2.366zm-9.99-4.359s.998.551 2.107.115c1.108-.432 4.037-4.24 6.17-4.703 2.135-.46 2.56-.43 2.963.06.396.489.197 2.654-.289 3.258-.48.608-6.684 3.232-6.684 3.232s-1.292-.077-2.294-.31a14.74 14.74 0 01-2.028-.668l.055-.984zm-1.156-6.857c-.942-2.201-2.617-3.098-3.244-2.952-.626.145 2.132 2.337 2.53 5.368.399 3.027.369 5.06.315 5.234-.056.17 1.28.19 1.28.19l.255-1.157.16-.826-.016-.746-.182-1.565-.329-1.235-.27-.948c-.001 0-.017-.227-.499-1.363zm-8.821-3.132c-2.855-3.333-8.029-5.706-8.381-5.706-.352 0 6.021 3.84 7.464 6.311 1.442 2.476 1.494 5.806 2.14 6.261.645.457 1.246-.225 1.297-.3.047-.078.521-.76.447-.962-.076-.2-.4-1.59-.4-1.59l-.991-1.665-.6-1.037zm-8.458-3.48c-3.612-3.183-10.156-4.696-15.457-4.77-5.303-.078-8.012.4-7.243 3.303.776 2.904 3.165 4.166 7.64 4.166 4.484 0 5.554-.479 7.966.277 2.415.759 4.626 2.123 5.498 3.03.874.91-1.665-2.221-3.953-3.938-2.29-1.715-3.794-2.615-3.794-2.615s-.44-.945 2.651-.514c3.08.426 7.21 2.424 8.332 4.999 1.119 2.576.945 3.99.921 4.543-.028.555 1.07-.302 1.07-.302l.447-1.264s.177-1.01-.42-2.144c-.597-1.137-.7-1.516-2.09-3.154-1.395-1.644-1.568-1.618-1.568-1.618zm-14.71 43.706c2.257-.067 7.3-4.375 8.034-10.364.73-5.993-2.989-18.178-3.851-19.456-.861-1.282 1.39-.607 2.62.672 1.231 1.279 3.75 9.964 3.75 16.291 0 6.331-1.261 8.145-4.646 11.378-3.384 3.23-6.106 2.894-6.106 2.894l.2-1.415zm7.84 17.782s1.126 1.414 2.383.94c2.326-.867 5.907-2.582 5.907-5.923 0-2.155-2.784-4.037-2.917-4.846-.133-.807 0-1.481 0-1.481l2.452.54.701 3.43s.96 1.012 1.956.608c1-.407 3.846-2.49 3.448-4.511-.395-2.021-3.115-4.51-3.38-5.52-.266-1.012.064-1.886.064-1.886l2.325.404.711 2.952s.612 1.021 1.942.75c1.327-.268 3.65-2.692 3.12-3.837-.532-1.143-2.256-3.839-2.389-4.105-.133-.269-.066-1.28-.066-1.28l.93.522s.895.353 2.687-.176c1.793-.53 3.536-1.742 3.507-2.979-.022-1.237-1.342-2.423-1.445-3.103-.098-.681-.024-.962-.024-.962l1.172.178 1.442 1.792.346 2.145-.52 1.842-2.188 2.375-2.168.91-.594-.053 1.32 2.299-.428 3.055-1.913 1.764-2.568 1.542-.197 2.853-1.418 3.08-3.285 1.943h-.965l-.378 1.867-2.06 2.93-3.558 2.371-2.592.48-1.492-2.171z'/%3e%3cpath d='M525.913 205.5s5.958 1.682 5.772-2.088c-.102-2.121-5.836-7-6.202-7.807-.364-.81-.265-1.92-.265-1.92l2.968 2.719s3.788.901 4.867-1.287c1.076-2.184.208-3.56.019-3.61-.186-.048.87-.19.87-.19l1.754.358-.21 3.372-1.943 8.48s.516 3.329-2.108 3.566c-2.621.238-5.522-1.592-5.522-1.592zm5.643 45.179s.102-1.718-1.225-2.914c-1.33-1.195-3.883-2.322-4.296-2.576-.416-.25 4.261 5.317 4.261 5.317zm8.633.28s-2.988-3.685-3.632-4.95c-.649-1.259-2.191-4.039-3.437-4.166-1.242-.125 1.172 4.595 1.172 4.595l4.849 4.421zm8.179-.08s-2.562-4.846-3.186-6.262c-.62-1.416-1.966-5.278-3.485-6.338-1.513-1.06.2 1.767.2 1.767l1.619 5.023 2.842 4.369zm6.028-3.518s-.174-4.136-.676-7.016c-.493-2.878-2.735-5.276-2.883-5.174-.15.102.17 5.124.17 5.124zm12.443 3.12s-2.09-4.975-2.936-7.323c-.846-2.348-2.935-6.286-3.159-6.336-.224-.05.622 4.517.622 4.517l2.537 7.272zm10.795-13.027s-1.916-1.969-6.048-3.587c-4.127-1.612-8.26-1.793-8.26-1.793l.499.531 1.875 1.592 4.318 2.22 5.638 1.364z'/%3e%3cpath d='M533.284 239.895s.033 3.603 1.89 5.792c1.86 2.19 6.238 6.192 7.103 7.002.863.805 1.592 5.25 2.887 8.952 1.289 3.7 1.595 6.734 2.155 7.775.564 1.04 1.723 2.724.864 2.557-.864-.168-1.662-1.179-2.193-2.524-.532-1.344-.366-1.344-.294-3.198.064-1.853-2.822-11.343-4.151-12.385-1.33-1.047-7.433-6.125-9.79-9.628-2.353-3.5-1.854-4.31-1.854-4.31l3.384-.034z' fill='%23202020'/%3e%3cpath d='M543.133 263.624c-1.295-2.659-1.526-5.014-1.925-6.597-.4-1.582-5.541-5.888-6.771-6.463-.93-.435-2.867.118-3.646-.471-.778-.587-5.641-6.106-5.641-6.106s-.731.69-.498.89c.233.205 5.274 5.656 7.096 7.403 1.832 1.752 2.822 5.656 4.151 8.686 1.329 3.025.797 2.422.931 3.9.132 1.484 1.062 2.328 1.99 2.328.927 0 1.16-.44.816-.694-.353-.25-2.245-2.471-3.338-5.351-.999-2.626-2.29-7.471-3.883-9.292-.102-.112-.222-.254-.358-.404.375-.044 1.009-.164 1.982-.217 1.231-.067 6.304 4.612 6.74 5.992.43 1.382-.036 1.917 2.09 6.531 2.123 4.614 3.116 5.688 3.116 5.688h.37s-1.93-3.164-3.22-5.823zm-7.98-30.54s3.685 2.323 4.777 2.626c1.091.302 1.891.405 1.891.405s.55 6.718 3.235 10.5c2.684 3.79 4.875 5.153 4.875 5.153s.1 7.317 2.092 12.369c1.993 5.047 2.388 11.156 1.94 12.113-.448.96-2.142-2.976-3.232-6.461-1.098-3.485-2.143-7.266-2.888-9.592-.746-2.323-2.788-5.809-3.93-6.767-1.15-.96-.227-.856.446-.253.67.607 2.612 3.005 3.857 6.87 1.242 3.86 1.74 7.773 2.412 7.8.673.023 1.192-.63 1.172-1.416-.027-.778-.872-2.8-1.492-6.411-.625-3.61-1.248-6.082-1.845-7.093-.6-1.008-1.47-1.186-3.78-5.225-2.314-4.038-3.336-6.285-3.736-8.155-.398-1.869.073-1.69-.325-1.969-.396-.277-.693.027-2.457-.957-1.77-.985-3.011-3.535-3.011-3.535z' fill='%23202020'/%3e%3cpath d='M544.7 231.717s2.255 1.751 3.514 2.29c1.262.537 3.086.636 3.086.636s-.46 6.363 2.028 10.505c2.487 4.14 5.074 6.561 5.074 6.561s.398 1.55 1.197 10.433c.797 8.89.827 9.055 1.06 12.623.232 3.568.343 16.21-.17 15.821-1.92-1.482-.33-8.348-1.29-11.172-.961-2.832-2.486-3.304-4.346-11.31-1.859-8.014-.667-9.832-1.99-12.826-1.327-2.998-3.085-3.265-3.085-3.265s2.453.471 3.482 2.995c1.031 2.523 1.188 9.231 2.027 12.556 1.89 7.505 4.479 11.307 4.479 11.307s-.566-9.424-1.295-14.774c-.731-5.356-.695-9.827-1.69-11.881-1-2.057-3.156-3.705-4.447-6.432-1.295-2.726-1.76-8.078-2.393-9.458-.627-1.38-.988-.951-1.888-1.311-2.92-1.178-3.354-3.3-3.354-3.3z' fill='%23202020'/%3e%3cpath d='M551.5 228.224s1.99 2.219 4.772 3.87c2.792 1.649 4.183 1.147 4.616 1.481.431.337-.565 5.992 2.356 11.208 2.92 5.218 3.982 5.319 4.049 6.029.065.701.595 16.087.963 21.302.362 5.217.759 22.72-1.396 22.72s-.2-12.929-1.26-15.955c-1.066-3.033-1.027-2.155-2.055-4.574-1.033-2.428-1.018-12.01-2.657-17.676-1.225-4.239-2.49-4.915-2.49-4.915s2.064 1.11 3.02 4.614c.963 3.498 1.262 15.248 2.39 17.128 1.125 1.888 2.752 4.21 3.119 5.963.367 1.747-.232-22.32-.729-23.764-.496-1.451-5.344-10.166-5.71-14.98-.36-4.811-.532-5.285-.957-5.652-.436-.375-1.823-.07-4.113-2.224-2.294-2.153-3.919-4.576-3.919-4.576z' fill='%23202020'/%3e%3cpath d='M562.446 230.993c.137-.463 1.519 2.587 5.848 4.306 4.33 1.715 8.462 1.413 9.01 1.866.547.454 3.286 6.97 3.382 15.65.105 8.687-1.493 7.878-2.834 15.353-1.342 7.472-1.396 22.665-2.24 24.99-.4.856-.847 1.209-1.297 2.677-.446 1.46.346 4.239-.997 4.289-1.34.05-1.491-2.12-1.491-3.282 0-1.161 1.396-5.3 1.396-9.441 0-4.142-.898-4.645-1.496-9.596-.597-4.945-.646-20.696-1.192-22.211-.548-1.512-3.251-4.792-3.251-4.792s2.903 1.863 3.6 3.982c.694 2.125.763 19.615 1.542 23.127.797 3.583.547-.808.846-2.83.296-2.017 1.344-10.602 1.192-15.196-.15-4.59-2.092-14.539-3.684-16.206 0 0 .829.965 1.74 3.151.023.062.585.637 1.238 1.015.689.396 1.477.599 1.5.67.023.053-.873-.074-1.578-.382-.521-.225-.904-.65-.887-.61.982 2.599 1.971 6.617 2.065 12.36.137 7.827-1.141 25.046.103 25.247 1.246.204 1-9.39 2.29-17.165 1.292-7.776 3.035-8.89 2.488-15.248-.547-6.361-2.237-13.23-3.58-14.088-1.342-.858-5.177-.555-8.565-2.728-3.379-2.168-5.289-4.447-5.147-4.907zm-54.864 8.762s1.247.555 2.688-.15c1.447-.708 5.277-3.735 5.277-5 0-1.262.053-2.524.053-2.524s.048.557 1.146.705c1.09.157 4.226-2.219 4.471-3.733.253-1.514.253-4.189-.094-4.745-.35-.555.943.555 1.59-.052.647-.606 3.682-2.575 3.637-4.593-.053-2.021-1.695-3.89-1.695-3.89s1.494.203 2.386 0c.9-.198 3.886-1.967 3.785-3.785-.1-1.818-1.142-4.594-3.485-4.797 0 0 1.743.406 3.437-.2 1.69-.606 2.29-1.566 2.29-3.487 0-1.917-3.435-6.056-4.033-6.41-.596-.35 3.681 1.212 4.777-.505 1.09-1.716 1.242-2.928.944-3.886-.298-.96-1.194-1.211-1.194-1.211s1.845.502 4.333-.76c2.487-1.261 4.676-2.926 5.822-2.876 1.144.05-3.635 2.573-3.885 3.99-.1.583 1.303 1.585 3.464 3.168.137.096.2.188.418.304.98.529 4.698.681 4.948.87.31.229-3.593.144-3.259.398 2.628 2.009 5.823 4.7 8.746 8.252.11.132.729.669 1.442.875.871.248 1.865.17 1.993.334.095.128-2.524-.065-2.429.06a100.076 100.076 0 015.017 7.198c.103.16.712.874 1.41 1.174.762.328 1.62.249 1.724.422.194.303-2.13.012-1.953.306a125.562 125.562 0 015.067 9.213s-4.686-8.24-10.414-14.654c-5.723-6.411-7.066-7.269-7.363-6.662-.3.605 4.28 6.26 6.719 10.246 2.435 3.991 4.652 8.952 4.652 8.952s-5.748-11.93-13.81-19.25c-8.065-7.32-8.906-8.532-9.803-8.23-.898.305-1.59 5.707-1.046 6.816.547 1.112 6.42 5.554 11.443 11.461 5.028 5.908 11.4 16.055 11.4 16.055s-4.526-7.32-12.192-15.45c-7.666-8.128-10.598-9.996-11.196-9.946-.597.05-.65 1.516-1.542 2.728-.897 1.21-2.74 1.059-2.793 1.616-.045.555 6.475 6.56 7.767 7.269 1.292.707 1.99.354 2.985.909.995.555 2.073 1.482 2.073 1.482s-1.371-.523-2.37-.825c-.997-.304-1.993-.355-1.993-.05 0 .3 5.278 6.762 6.171 7.167.897.406 1.395.203 2.59.658 1.191.455 2.89 1.666 2.89 1.666s-1.848-1.061-3.14-1.315c-1.292-.252-1.84 0-1.793.356.053.351 4.033 5.452 3.835 5.553-.197.1-6.17-7.07-11.249-11.562-5.077-4.494-7.364-5.453-7.615-5.301-.246.15-.098 1.466-1.343 1.919-1.244.454-2.39.606-2.39 1.06 0 .454 4.58 4.746 7.812 8.33a229.033 229.033 0 016.023 6.969s-3.283-3.283-6.866-6.665c-3.585-3.382-5.423-4.694-5.772-4.493-.35.2-.398 1.918-.052 2.372.348.455 6.97 8.282 6.771 8.482-.199.202-7.813-9.39-8.31-9.39-.502 0-.8 1.21-1.296 1.767-.5.556-2.638.556-2.638 1.311 0 .758 10.748 11.307 10.45 11.56 0 0-8.905-7.673-9.205-7.218-.3.454 3.73 7.825 3.482 7.977-.25.152-5.226-7.724-5.676-7.673-.44.048-.398.908-1.69 2.069-1.293 1.162-2.935.657-2.986 1.162-.05.504 7.417 8.786 7.215 8.936-.199.15-7.56-7.877-7.762-7.422-.05.12-.446.465-.247 1.161.548 1.937 2.21 5.458 1.99 5.755 0 0-2.389-4.897-3.038-4.695-.645.202-.645 1.164-1.743 1.869-1.09.707-1.987.556-2.089 1.06-.096.503 1.295 1.363 1.895 2.527.593 1.161 1.094 3.686 1.094 3.686s-.748-2.125-1.792-3.486c-1.045-1.364-1.994-2.273-2.788-2.273-.795 0-1.344.758-1.344.758l-.748-1.769z' fill='%23202020'/%3e%3cpath d='M577.319 237.174s2.436-.15 2.734-.655c.3-.507-.896-.154-3.085-2.524-2.188-2.375-7.779-18.564-13.884-26.712-9.996-13.33-19.358-19.435-19.358-19.435s11.136 6.445 19.76 19.034c8.754 12.792 10.88 22.822 13.331 25.446 2.459 2.625 4.847 3.095 4.715 3.837-.133.741-.533 1.279-1.462 1.414-.928.134-3.187.336-3.187.336l.435-.741zm-73.57-3.53s.065.196.516.248c.458.057 3.483-2.961 3.316-3.832 0 0-1.344-.504-2.434-1.615-1.094-1.111-1.347-2.878-1.347-2.878s.998 1.969 1.843 2.524c.846.554 2.19.857 2.687.454.5-.404 4.952-3.702 4.678-4.999 0 0-1.392.05-2.688-.909-1.292-.96-1.528-2.93-1.528-2.93s.835 1.583 2.162 2.225c1.321.64 2.618.37 2.985-.102.364-.473 3.284-4.48 2.95-5.653 0 0-1.49.167-2.819-.775-1.328-.945-2.023-3.3-2.023-3.3s.961 1.986 2.652 2.321c1.692.338 3.087-.672 3.35-1.882.265-1.212 1.195-5.722-.227-6.868 0 0-2.195.707-3.752-.1-1.555-.808-2.121-2.793-2.121-2.793s1.325 1.817 3.08 2.052c1.762.235 2.527-.705 2.821-1.414.304-.707.369-3.264-.164-4.677-.53-1.415-1.626-1.315-1.887-3.433 0 0-.57.84-2.826.84-2.255 0-3.451-2.558-3.451-2.558s1.796 1.651 3.585 1.516c1.79-.135 2.455-1.616 2.493-2.761.027-1.147-.901-2.156-1.395-3.333-.499-1.178-.534-2.592-.865-2.423-.332.168-.761 1.245-3.087.875-2.32-.368-2.82-1.953-2.82-1.953s1.693 1.18 2.985 1.078c1.3-.1 2.123-.707 2.123-1.58 0-.878-.494-2.494-3.415-4.985a89.147 89.147 0 00-5.308-4.205s3.783 2.086 6.236 4.14c2.46 2.053 3.848 4.04 3.848 4.04s2.692.874 2.988-.035c.296-.91.252-2.044-.596-3.66-.828-1.58-3.133-3.938-3.133-3.938s2.411 1.993 3.555 4.063c1.142 2.07.627 3.51.72 4.014.103.503 5.128 2.45 6.248 1.768 1.12-.682.597-2.146-.348-3.637-.943-1.488-1.722-2.725-1.722-2.725s1.173 1.29 2.017 2.751c.848 1.466 1.544 2.628 1.221 3.307-.32.682-1.021.985-.945 1.264.076.275 1.737 1.16 3.434 2.044 1.693.884 3.656 1.666 3.907 1.186.25-.48.423-1.641.278-3.282-.154-1.64-1.098-4.14-1.098-4.14s1.117 2.424 1.317 4.14c.198 1.718-.22 3.005.175 3.61.399.606 1.64.759 1.64.759s-.995.705-3.208.05c-2.214-.658-11.72-5.455-12.17-5-.446.454 4.431 3.409 6.671 5.53 2.241 2.119 3.334 4.34 3.334 4.34s-1.742-1.464-3.432-2.397c-1.692-.934-6.77-3.535-7.096-3.182-.317.355 1.92.807 2.09 1.214.175.404-1.59 1.993-1.59 2.65 0 .655 7.241 5.678 7.016 6.233-.223.557-1.839 1.869-2.137 1.794-.3-.077-3.88-2.828-3.88-2.398 0 .43 2.06 2.17 2.038 2.548-.023.38-1.367 1.289-1.125 2.147.253.858 4.038 3.965 4.011 5.023-.027 1.06-2.165 1.969-1.765 2.65.394.683 2.337 3.08 2.337 3.08s-2.091-1.388-2.765-2.118c-.672-.734-2.019-2.323-2.258-2.073-.251.255-1.595 3.208-1.471 3.865.127.655 1.817 1.664 2.14 3.455.324 1.794-.25 3.66-.376 3.66-.124 0-2.508-3.078-2.985-3.128-.47-.05-1.067.153-1.466.935-.4.782-1.795 3.23-1.616 3.685.169.453 2.507.984 2.561 2.853.05 1.869-1.47 3.608-1.618 3.608-.15 0-2.911-3.71-3.185-3.71s-3.41 3.485-3.484 3.912c-.077.43 2.139 1.996 1.743 2.603-.4.605-1.895-.23-2.742.25-.842.482-2.335 1.085-2.636 1.085-.296 0-.746-1.007-.746-1.007z' fill='%23202020'/%3e%3cpath d='M543.648 187.999s.25-.985.725-1.49c.47-.506 2.393-2.627 1.667-3.054-.72-.427-3.16.355-4.701.225-1.545-.124-2.564.254-7.043-3.458 0 0-14.204-9.93-36.206-11.208-6.969-.403-10.089 2.089-10.42 3.4-.03.302 1.828-2.828 8.826-2.726 3.087.033 25.24 1.822 36.728 10.838.6.47 4.405 4.115 7.963 3.71 3.56-.404 4.307-.807 4.231-.303-.074.505-1.192 1.819-1.442 2.421-.247.607-.494 1.719-.494 1.719zm-38.392 2.932s-.019-.064-.057-.18c-.199-.606-1.614-2.582-4.021-4.817-2.887-2.678-11.85-6.413-12.297-6.564-.446-.153 9.201 4.444 11.898 7.018 4.326 4.14 4.478 4.543 4.478 4.543z' fill='%23202020'/%3e%3cpath d='M505.233 206.738s-.588-.971-2.476-2.184a15.123 15.123 0 00-3.785-1.716l4.378 1.111c1.295 1.11 1.882 2.79 1.882 2.79zm-1.133-8.236s-.597-.858-3.284-1.717c-2.688-.858-3.333-.808-3.333-.808s2.488-1.06 4.377-.098c1.89.956 2.24 2.624 2.24 2.624zm-1.59-6.765s-.547-1.212-2.937-2.069c-2.388-.86-4.082-1.011-4.082-1.011s2.487-.704 4.88.253c2.389.958 2.14 2.827 2.14 2.827zm-2.885-4.346s-.7-.957-5.174-2.017c-4.483-1.063-6.225-1.114-6.225-1.114s6.372-.502 8.064.205c1.688.705 3.335 2.926 3.335 2.926zm-8.213-4.697s-2.734-.757-5.373-.96c-2.639-.201-6.771.151-6.771.151s7.666-1.21 9.704-.755c2.043.453 2.44 1.564 2.44 1.564z'/%3e%3c/g%3e%3cg fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35'%3e%3cpath d='M466.199 277.562s1.362 2.39 4.048 2.49c2.689.1 4.777 3.94 4.777 3.94l-2.953 2.894-7.099.335-2.287-3.669 3.515-5.99zm.164-2.454c.232-.467-2.09-5.05-3.75-5.822-1.658-.77.564 1.483.2 2.424-.364.943-.61 2.105-.478 2.273.134.167 1.371 2.105.71 2.98-.665.874 3.318-1.854 3.318-1.854z'/%3e%3cpath d='M465.09 282.095s1.262.63 2.258.34c.995-.294 1.88-1.305 1.88-1.305m-5.423-.81s3.983-2.895 3.652-4.44c-.335-1.55-1.13-1.483-1.662-1.347-.53.133-2.984 2.153-3.116 2.623-.133.471 1.126 3.164 1.126 3.164z'/%3e%3cpath d='M460.989 282.306s.729 1.92 2.022 1.92c1.295 0 3.153-1.044 3.185-1.814.034-.781-1.294-2.193-2.157-2.594-.861-.402-2.853.638-2.853.638z'/%3e%3cpath d='M464.61 279.689c-.198.6-2.72 1.781-3.55 1.849-.828.067-2.52-2.053-1.826-2.359.7-.302 1.562-.271 2.191-.604.631-.34.797-1.178 1.162-1.213.364-.033 1.393.237 1.658.872.267.644.564.848.366 1.455z'/%3e%3cpath d='M462.017 281.36s-3.911 5.287-5.538 5.02c-1.626-.27.662-7.508.662-7.508s.632.405 1.925.81c1.294.402 2.589.874 2.951 1.677z'/%3e%3cpath d='M455.053 277.597s5.044.874 5.278 1.684c.231.808-2.424 1.884-3.85 1.884-1.428 0-1.428-3.568-1.428-3.568z'/%3e%3cpath d='M442.505 285.238s.667 2.425 2.857 2.56c2.19.136 4.246-2.29 4.246-2.29l-5.177-2.019z' fill='%23202220' stroke='none'/%3e%3cpath d='M442.505 285.238l-.112.033c0 .012.17.626.624 1.27.45.638 1.196 1.312 2.338 1.378l.184.008c2.206-.014 4.147-2.338 4.159-2.339l.11-.133-5.402-2.104-2.036 1.85.022.07.113-.033.085.09 1.868-1.702 5.106 1.994.043-.112-.088-.079s-.117.137-.332.353c-.637.64-2.122 1.903-3.648 1.897l-.17-.004c-1.05-.063-1.731-.674-2.158-1.277a4.346 4.346 0 01-.455-.823c-.047-.113-.08-.208-.103-.27l-.03-.097-.118.03.085.09z' fill='%234b4139' stroke='none'/%3e%3cpath d='M443.966 284.56s.862 1.823 3.716 1.89c2.854.066 5.109-2.29 5.109-2.29l-4.512-3.568z' fill='%23202220' stroke='none'/%3e%3cpath d='M443.966 284.56l-.106.055c.005.02.91 1.888 3.819 1.956h.124c2.862-.004 5.064-2.32 5.075-2.324l.092-.097-4.696-3.713-4.454 4.099.04.079.106-.054.08.09 4.239-3.9 4.434 3.503.072-.093-.087-.088-.094.1c-.45.427-2.42 2.16-4.807 2.156h-.118c-1.402-.037-2.3-.493-2.857-.944a3.37 3.37 0 01-.585-.605 1.746 1.746 0 01-.13-.2l-.037-.07-.11.05.08.091-.08-.09z' fill='%234b4139' stroke='none'/%3e%3cpath d='M444.352 284.981s1.26 1.044 2.754 1.127c1.493.083 3.352-.386 3.352-.386l-1.71.618-1.227.138-1.162-.186-1.044-.388-.813-.605z' fill='%234b4139' stroke='none'/%3e%3cpath d='M447.682 282.469s1.26 3.1 3.914 2.763c2.654-.34 2.72-1.884 2.72-1.884l-2.985-4.311-3.65 3.433z' fill='%23202220' stroke='none'/%3e%3cpath d='M447.682 282.469l-.11.05c.002.009.288.713.883 1.422.592.713 1.502 1.439 2.74 1.439.136 0 .275-.012.416-.029 1.348-.17 2.063-.653 2.432-1.11.371-.454.395-.873.395-.89v-.039l-3.09-4.455-3.808 3.583.03.079.11-.05.083.093 3.549-3.337 2.907 4.194.096-.07-.117-.005-.007.052c-.052.262-.328 1.415-2.61 1.715-.132.019-.26.026-.385.026-1.142 0-1.987-.67-2.559-1.35a6.108 6.108 0 01-.639-.938c-.069-.127-.12-.235-.156-.306a2.152 2.152 0 01-.05-.118l-.11.044.08.092z' fill='%234b4139' stroke='none'/%3e%3cpath d='M448.055 283.077s1.593 1.937 2.988 1.905c1.39-.035 2.272-.56 2.272-.56l.065.221-.731.37-1.262.256-1.292-.17-1.061-.64-.979-1.381zm-5.035 3.107s1.227 1.26 2.353 1.312c1.132.05 2.856-.91 2.856-.91l.215-.067-.297.27-1.163.638-1.41.405-1.112-.203-.845-.52-.515-.654z' fill='%234b4139' stroke='none'/%3e%3cpath d='M454.75 277.329c1.193-.168 3.681 3.232 3.681 4.914 0 1.683-.728 4.209-1.956 4.141-1.23-.069-4.015-2.56-4.646-3.835-.631-1.28-1.26-2.157-.795-2.832.462-.673 3.716-2.388 3.716-2.388zm-12.373.303s-1.99-1.544-2.788-.738c-.796.805-.53 3.499 0 4.039.531.538 2.918-1.282 2.918-1.282z'/%3e%3cpath d='M442.109 279.514s-2.655.271-2.655 1.483c0 1.214 1.26 2.49 1.525 2.759.265.27 2.654-1.078 2.654-1.078z'/%3e%3cpath d='M443.171 281.733s-2.722.809-2.722 1.75c0 .938 1.195 2.693 2.055 2.693.866 0 1.53-1.688 1.86-2.02.333-.338-1.192-2.422-1.192-2.422zm1.332-7.874s-.53-.738-1.66-.27c-1.127.472-2.388 1.617-2.188 3.434.199 1.815.861 3.028.861 3.028l4.116-1.415z'/%3e%3cpath d='M444.83 277.025s-3.514 1.145-3.647 2.489c-.134 1.349.797 2.698 1.725 2.96.93.273 3.915-2.623 3.915-2.623z'/%3e%3cpath d='M447.88 282.621s-3.45 2.283-3.916 2.283c-.463 0-1.725-1.817-1.462-3.027.267-1.212 2.59-2.086 3.52-2.424.93-.338 1.858 3.168 1.858 3.168zm3.026-12.525s-1.095-.911-3.185-.756c-2.091.15-3.632 2.876-3.882 4.24-.25 1.36-.05 3.937.746 4.342.795.401 5.127-3.082 5.127-3.082z'/%3e%3cpath d='M446.676 280.436c-1.442-.153-2.737-2.224-2.49-3.482.248-1.265 3.088-3.437 4.58-3.182 1.492.25 1.192 3.99 1.192 3.99s-1.84 2.825-3.282 2.675z'/%3e%3cpath d='M451.268 280.12s-.73 1.686-2.19 2.428c-1.46.737-2.322.13-3.185-1.079-.861-1.213.399-1.752 1.063-2.359.663-.6 2.586-1.075 2.586-1.075z'/%3e%3cpath d='M448.944 275.681s-1.627 1.31-.696 2.828c.928 1.516 1.659 2.052 2.818 2.252 1.163.205 1.922-.267 2.855-1.381.929-1.11 2.288-1.613 2.157-2.995-.134-1.38-.665-2.457-1.494-2.86-.829-.402-3.35.035-5.64 2.156z'/%3e%3cpath d='M453.57 269.185s-1.678-.643-2.974.116c-1.293.757-2.188 2.298-2.236 3.708-.05 1.416.25 3.397.25 3.397s1.777-.506 2.921-1.466c1.145-.957 1.522-1.219 1.362-1.712-.097-.3-.567-.634-.567-1.82 0-2.073 1.244-2.223 1.244-2.223z' fill='%23202220' stroke='none'/%3e%3cpath d='M453.57 269.185s-1.939-.327-2.908.304c-.971.628-1.793 1.565-2.141 2.826-.35 1.265-.1 1.593-.1 1.593s-.182-1.099.161-2.15c.398-1.205 1.387-2.405 2.353-2.688 1.177-.345 2.634.116 2.634.116z' fill='%234b4139' stroke='none'/%3e%3cpath d='M503.527 305.976s1.402-.59 2.37-1.121c.973-.533 3.064-1.896 3.064-1.896l.67 3.488-2.686 2.07-2.341.023-1.415-1.032z'/%3e%3cpath d='M499.777 306.327s.037.044 1.673.08c1.63.043 1.789-.567 2.078-.427.288.14.748 1.883.748 1.883l-.597 1.091-2.353 1.333-1.985-1.091-.162-2.746zm18.635-1.122s-.468-.78-1.4-1.587l-3.319-2.895-.017 7.555 3.486-.086 1.663-2.336z'/%3e%3cpath d='M499.777 306.327s-.518-.765-1.995-.603c-1.466.16-3.024 1.36-3.18 2.38-.163 1.013 0 3.96.796 4.526.794.565 1.791.85 3.381.444 1.597-.404 9.716-5.414 9.716-5.414s-.955.2-2.07.448c-1.111.24-2.149-.247-2.149-.247s-1.115 1.255-2.387 1.457c-1.278.202-1.632-.607-1.874-1.21-.238-.604-.238-1.782-.238-1.782z'/%3e%3cpath d='M505.198 308.943s-1.196.457-1.647.786c-.446.326-2.053.892-2.053.892l.614 2.463 3.455.884 2.168-1.79.024-2.478zm16.076-1.74s-.547-.507-1.196-1.237c-.64-.73-1.44-.882-1.665-.759-.224.13-1.863 2.246-1.863 2.246l-.125 1.595 1.914 1.035 1.344.25 1.767-1.161z'/%3e%3cpath d='M509.404 305.987s-1.544.704-2.293 1.337c-.747.632-1.913 1.337-1.913 1.615 0 .276 1.743 2.083 1.743 2.083l1.766.143 3.83-2.68-.25-2.449-2.884-.048zm14.557 3.179s-.294-.606-.892-1.162c-.6-.558-1.342-.856-1.795-.807-.444.048-1.94 2.273-1.94 2.273l-.186.628 1.382 1.604 2.45.596 1.689-1.705z'/%3e%3cpath d='M517.644 311.843l1.743.3s-.053.458.45.861c.495.403.546.096.546.096s.248 1.67 2.088 3.083c0 0 2.143.709 3.234.102 1.098-.607.945.186.945.186l3.087-3.82s0-.76-.746-.808c0 0 .545-2.374-1.445-2.88-1.987-.505-3.583.202-3.583.202s-1.527 2.8-2.436 2.423c-.213-.09-.733-.368-1.096-.755-.841-.912-1.096-1.364-1.096-1.364s-.645.203-1.392-.303c-.75-.505-1.392-1.72-1.392-1.72s-1.144-.2-1.542-.603c-.398-.404-.81-1.201-.81-1.201l-2.85 2.048s-.09.903-1.751 2.115c-1.658 1.215-2.651 1.215-2.651 1.215s-.463 2.488-2.324 2.08c-1.857-.4-3.119-2.483-3.119-2.483s-1.329-.203-2.191.937c-.863 1.147-1.265 1.552-1.265 2.695 0 1.145.733 2.758 1.33 3.299.601.536 2.46 2.016 4.645.872 2.193-1.143 1.462-3.026 1.462-3.026s-.066.135 1.262-.741c1.324-.878 2.783-2.223 3.78-2.624' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M514.241 296.618l.015 4.884s.596 4.34-.353 5.704c-.942 1.363-4.38 1.06-4.872-.102-.498-1.16-.25-4.945-.25-4.945z'/%3e%3cpath d='M510.386 311.42s-.731 1.294 1.528 1.48c.64.056 1.07-.173 1.358-.503.583-.674.455-1.234.455-1.234s-.2 1.805 1.833 1.872c2.26.08 2.06-2.087 2.06-2.087' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M491.81 315.428s-1.258-2.125.235-2.896c1.492-.775 2.289.035 3.181.068.896.035.604-2.298.407-2.77-.201-.47-.672-1.471-1.033-1.739-.367-.27-5.302.223-5.264 3.535.036 3.183 2.473 3.802 2.473 3.802zm7.733 7.909s-1.592-2.254-.729-3.6c.867-1.348 1.522-.539 1.96-.575.428-.031.627-1.008-.102-2.488-.733-1.483-1.625-2.225-2.157-2.293-.533-.066-3.505 2.12-2.917 4.915.703 3.379 3.945 4.04 3.945 4.04zm27.842-2.722s5.365 2.253 5.738-3.164c.2-2.895-2.39-4.897-3.217-4.878-.565.01-.995.333-1.956 1.478-.965 1.145-1.696 1.984-1.298 2.426.398.436 1.99-.47 2.688 1.243 1.196 2.931-1.955 2.895-1.955 2.895z' fill='%23202220' stroke='none'/%3e%3cpath d='M499.543 323.337s-4.18-.921-4.145-5.008c.02-2.726 3.058-3.94 3.058-3.94s-2.81 1.492-2.858 3.888c-.087 4.158 3.945 5.06 3.945 5.06zm-7.676-7.91s-2.412-.531-2.674-4.002c-.264-3.47 5.461-3.334 5.461-3.334s-5.487.263-5.2 3.587c.296 3.432 2.413 3.75 2.413 3.75zm35.518 5.188s1.076.52 2.308.473c1.227-.048 2.704-.373 3.217-2.424.512-2.052.3-3.024-1.052-4.835-.95-1.26-1.82-1.236-1.82-1.236s.925.182 1.656 1.324c.731 1.146 1.793 2.426 1.063 4.73-.733 2.306-2.952 2.354-3.765 2.286a8.432 8.432 0 01-1.607-.318z' fill='%234b4139' stroke='none'/%3e%3c/g%3e%3cg fill='%234d2a15'%3e%3cpath d='M463.36 206.949l-1.01-.209.73-1.688 2.824-1.031 2.818-.114 2.967-.12 1.365.942 1.52 3.517-5.622 3.35-.91.304-.349-1.384-.861-2.27z' fill='%23904720'/%3e%3cpath d='M515.947 288.404l-.35-8.436-22.745 7.02 9.007 8.43z' fill='%23202020'/%3e%3cpath d='M473.829 273.718l-1.914-1.5s-1.374-.969-2.137-1.204c-.761-.238-1.74-.05-1.74-.05l-.314.448.298.781 2.075 2.419s3.383 1.752 3.466 1.786c.083.033 1.225 1.179 1.225 1.179l.798.337zm-.538 3.576l1.297.17 1.297 1.487.804 1.587 1.06 2.1.336 1.22-2.538-.557-7.367-2.283.636-1.752 1.29-1.181 1.066-.469 1.502-.227z' fill='%23d2a567'/%3e%3cpath d='M478.08 283.357l1.217-.101.823-.701-.387-2.758.449-8.834-5.985-7.076-1.221 4.078 1.758 7.152 1.296 4.288z' fill='%23d2a567'/%3e%3cpath d='M473.794 267.2s-.397.737.1 3.059c.498 2.32 1.36 7.508 3.417 11.043 2.057 3.53-1.989-2.794-1.989-2.794s-3.185-7.17-2.689-12.59c.499-5.42 1.16 1.282 1.16 1.282z' fill='%23ab6d29'/%3e%3cpath d='M478.14 271.674s-1.294 1.686-1.493 2.93c-.2 1.241.1 3.365.1 3.365s-.2-1.613 1.128-1.988c1.326-.367 1.16 3.64 1.226 4.005.065.373.764-7.167.764-7.167zm.666 14.803l-6.739-1.547c-3.48-1.55-5.324-2.764-5.257-3.602.067-.84 6.188.202 7.083.405.894.202 3.635 1.58 3.635 1.58h1.573l2.857-1.263.396 3.047-3.55 1.38zm-11.251-1.274s1.66 1.177.863 1.682c-.796.505-2.921.572-3.584.405a1718.039 1718.039 0 016.502 1.579s1.392-1.179 1.294-1.246c-.099-.07-5.075-2.42-5.075-2.42z' fill='%23ab6d29'/%3e%3cpath d='M465.778 283.427c.25-.404.451.944 2.771 1.247 2.324.3 3.385-.405 3.385-.405l1.029.674 1.226.27-1.127 1.681-4.247-1.249-2.289-1.274z' fill='%23d2a567'/%3e%3cpath d='M480.909 280.378l1.197 1.713.74-3.73-.05-3.89-2.436-1.612z' fill='%23ab6d29'/%3e%3cpath d='M474.19 274.081l-1.99-3.335-2.588-4.742 1.592-2.728 1.943 2.824s-.55 1.92-.2 3.737c.348 1.82 1.244 4.244 1.244 4.244z'/%3e%3cpath d='M460.556 286.196s.862-1.434 2.888-1.596c2.023-.173 3.648.27 3.648.27l4.113 2.147.831 1.351-7.763-1.041-3.716-1.13z' fill='%23d2a567'/%3e%3cpath d='M480.757 272.469s.148 4.641.295 6.106c.15 1.463 1.05 2.876.9 3.483-.15.607-.45.91-1.447 1.262-.994.353-2.984 0-2.984 0s1.94-.254 2.039-.655c.1-.404-.596-2.17-.698-3.787-.098-1.616.102-3.383-.446-3.383s-1.144.707-1.245.91c-.099.202.545-5.757 1.194-6.414.65-.653 2.392 2.478 2.392 2.478z' fill='%238f4620'/%3e%3cpath d='M466.562 284.666s-.794-.742-.779-1.247c.016-.506.93 2.438 5.192 2.273 4.263-.168 4.014-.24 4.014-.24h1.991s-.446 1.857-.797 2.023c-.347.166-3.317 2.17-3.367 2.224l-1.064.584.086-.3-.2.015-.348-3.281-3.681-1.414z' fill='%23ab6d29'/%3e%3cpath d='M474.19 274.081s-4.927-5.101-6.568-8.482c-1.643-3.386-.647-8.03-.647-8.03l4.63 6.06s-.598 1.16-.4 3.078c.2 1.92 2.985 7.373 2.985 7.373z' fill='%238f4620'/%3e%3cpath d='M471.036 292.657c-.164-.353-.35-1.474.598-2.658 2.927-3.653 10.334-6.276 10.334-6.276l.008 4.466-9.505 4.57z' fill='%23ab6d29'/%3e%3cpath d='M471.597 289.28c.413-.296 2.07-1.525 2.129-2.054.067-.603-1.127-.705-3.282-1.143a15.417 15.417 0 01-3.916-1.412s2.654 2.052 3.684 2.457c1.026.406.93.808.796 1.078-.132.27.53 1.116.589 1.075zm12.723 1.04s-1.37-2.045-1.81-3.298c-.434-1.251-.456-3.27-.539-3.291-.078-.024-.914.666-1.528.951-.618.278-2.809.987-2.928 1.072-.12.078 3.024-.068 3.007 1.023-.02 1.095-4.521 1.56-4.54 1.638-.02.078 3.624-.805 3.404.078-.22.892-1.83.974-3.782 1.779-1.95.81-2.806 1.218-3.528 1.637-.722.415-1.07.734-1.07.734s.87.491 2.255.441c1.378-.052 4.438-.808 4.438-.808l5.876-2.235.745.28z' fill='%238f4620'/%3e%3cpath d='M484.32 290.32s-1.64-.572-2.804-7.415c-1.17-6.837-.828-8.68-.828-8.68l2.769 1.932 2.479 4.51z' fill='%23ab6d29'/%3e%3cpath d='M485.208 278.94s-1.293 3.836-1.293 6.061c0 2.218-.228 3.73.407 5.31.636 1.572 2.813 3.532 2.813 3.532l.992-1.038.447-3.102.25-5.152-3.615-5.61z' fill='%238f4620'/%3e%3cpath d='M489.099 284.151s.627 9.658-1.817 9.923c-1.17.128-2.938-3.637-2.96-3.759-.026-.127 2.13 3.503 2.934 3.175 1.544-.63 1.07-10.044 1.07-10.044l.773.706zm-4.78 6.169s-.413-.18-1.085-1.275c-.672-1.096-.087.969-5.234 2.788-5.153 1.818-6.993.81-6.993.81s1.717 1.336 6.916-.18c5.201-1.513 4.728-1.844 5.422-1.993.701-.15.975-.15.975-.15z' fill='%23202020'/%3e%3cpath d='M474.74 278.018s.811.694 1.74 2.575c.93 1.883 1.593 3.2 1.593 3.2l.232-.239s-.63-1.814-1.492-3.23c-.862-1.415-3.353-4.847-3.353-4.847z' fill='%23ab6d29'/%3e%3cpath d='M471.609 290.005s.53-1.807 0-2.143c-.533-.335-1.032.03-4.545-.404a52.222 52.222 0 01-6.505-1.264s2.388 1.465 4.677 2.071c2.29.604 5.275 1.278 5.275 1.278l.797.135z' fill='%238f4620'/%3e%3cpath d='M471.609 290.005s.073-.426-.325-.86c-.397-.43-1.12.205-5.377-.984-4.253-1.182-5.348-1.966-5.348-1.966s1.517 1.338 5.275 2.297c3.758.96 5.775 1.513 5.775 1.513z' fill='%23202020'/%3e%3cpath d='M473.524 277.282s-3.22.175-4.256 1.005c-1.03.834-2.453 3.043-2.453 3.043l2.093.243s-.26-1.944.736-2.917c.994-.97 2.501-1.06 3.88-1.374z' fill='%23ab6d29'/%3e%3cpath d='M467.426 271.16s1.295 1.714 2.638 2.321c1.344.606 2.687 1.112 3.336 1.766.644.656 1.343 2.776 1.343 2.776s-4.63-2.067-5.524-3.08c-.897-1.01-1.792-3.783-1.792-3.783z' fill='%238f4620'/%3e%3cpath d='M471.912 272.223s-.42-.692-1.69-1.273-2.203-.49-2.564-.228c-.36.266-.236.432-.236.432l1.692 2.55.945-.228s-2.515-1.585-1.927-2.083c1.23-1.05 3.78.83 3.78.83z' fill='%238f4620'/%3e%3cpath d='M484.39 266.393l25.907-13.38 12.261 17.067-22.39 6.002-11.85 1.011-5.774-4.186z' fill='%23202020'/%3e%3cpath d='M519.124 273.706l32.296 27.97-3.577 2.46-7.568-2.155-15.727-15.544-5.822-5.863z'/%3e%3cpath d='M560.483 296.138s-8.022-6.325-18.445-14.064c-10.421-7.744-23.307-17.504-23.307-17.504l.595 8.347 26.66 24.502 8.793 4.24 4.446-1.345 2.257-2.356-1-1.82z'/%3e%3cpath d='M519.031 276.36s9.303 10.498 16.375 15.852c7.064 5.347 13.835 11.205 15.225 10.394 1.394-.809.896-1.712.896-1.712l-32.694-26.659.197 2.123z' fill='%23803f1d'/%3e%3cpath d='M541.871 303.195l-3.284 2.555-3.778-1.542-19.86-20.3.998-3.736 2.78.404z'/%3e%3cpath d='M560.483 296.138s-2.434 5.741-7.611 4.399c-5.176-1.35-33.678-28.428-33.678-28.428l-.066 2.826s28.883 26.458 34.46 27.534c5.573 1.079 10.14-3.76 9.553-4.306-.39-.367-2.658-2.024-2.658-2.024z' fill='%23202020'/%3e%3cpath d='M515.841 280.6s9.209 11.813 14.087 16.154c4.88 4.344 9.06 7.773 11.05 7.374 1.988-.405-1.195-2.624-1.195-2.624l-13.936-13.736-7.115-7.168c-.001 0-2.787-1.11-2.89 0z' fill='%23803f1d'/%3e%3cpath d='M518.132 280.6s23.379 23.83 25.23 24.37c3.918 1.144 9.492-2.897 9.492-2.897l-2.059-1.21-.265.738s-.998 2.425-6.039 1.347c-5.044-1.073-25.562-23.155-25.562-23.155l-.798.806z' fill='%23202020'/%3e%3cpath d='M526.94 303.406l-8.508-9.795-1.889-3.232-.505-4.142 16.974 17.068-2.387 1.613-2.095-.702z'/%3e%3cpath d='M542.316 303.744s-2.059 3.031-4.85 2.424c-2.784-.603-4.376-2.624-4.376-2.624l-16.274-15.935-.398-2.43s17.854 18.892 21.048 19.726c2.325.607 4.056-2.225 4.056-2.225l.794 1.08z' fill='%23202020'/%3e%3cpath d='M533.284 303.207s-.797 2.357-3.181 2.023c-2.394-.337-3.123-1.282-3.123-1.282l-9.968-11.846-.198-3.16s10.365 14.333 12.758 15.143c2.388.807 2.984-1.619 2.984-1.619l.73.741z' fill='%23202020'/%3e%3cpath d='M522.63 272.141s9.655 8.28 10.453 8.685c.795.406 4.177.506 4.375 1.007.2.509-2.183 0-2.385.509-.196.502 4.877 4.646 5.672 4.744.796.103 4.879.103 4.78.605-.1.509-2.787 0-2.886.607-.1.605 4.382 4.142 5.174 4.242.8.102 5.971.102 5.971.603 0 .51-4.183-.098-4.078.81.097.908 7.068 5.249 6.767 5.858-.3.603-8.362-5.454-8.559-5.152-.201.302-.499 2.223-1 2.525-.493.303 0-2.525-.399-3.736-.397-1.212-5.073-4.746-5.57-4.34-.495.402-.098 2.523-.597 2.523-.498 0 .102-2.626-.4-3.535-.497-.908-4.876-4.546-5.471-4.546-.599 0-.2 1.923-.599 2.224-.4.302-.297-2.224-.896-3.03-.594-.805-10.75-9.994-10.352-10.603z' fill='%23b07229'/%3e%3cpath d='M506.075 298.942s.076 3.658-1.569 4.192c-1.64.532-4.75-6.72-4.75-6.72l-.722-6.759 4.828 4.491 2.213 4.797zm12.944-1.857s.068-1.072-.057-1.951a39.666 39.666 0 00-.404-2.22l-.315-3.767-.895-2.523-.723-1.59-1.047.075-2.538 1.8-.87 2.443 1.341 4.572 1.245 4.165 1.889.606 2.375-1.61z'/%3e%3cpath d='M515.69 303.476c.57-.172-.53-5.182-.53-5.182l-2.984-7.407-.797-2.624-2.421-.913-1.593 1.822.364 2.929s2.321 4.877 3.453 6.599c1.127 1.712 3.517 5.08 4.507 4.776z'/%3e%3cpath d='M513.014 287.761c.867.603 1.86 2.592 2.09 3.936 0 0 1.992 5.45 1.727 5.991-.266.541-1.462.607-1.462.607s2.659 2.76 3.455 2.424c.794-.337.461-3.03.195-3.637-.264-.607-1.129-.2-1.457-.807-.333-.608-1.332-4.24-1.396-6.398-.065-2.149-.132-3.632.134-4.173.266-.537 2.257 4.51 2.257 7.208l.862 1.01s-.533-3.706-.862-4.85c-.332-1.142-1.061-3.097-1.061-3.5 0-.404.4-1.347.4-2.289 0-.941-.067-1.546-.067-1.546s1.057.736 1.458.674c.397-.07.994-.607 1.257-2.966.269-2.353-.263-9.204-.263-9.204l-10.35 13.65 3.083 3.871z' fill='%23202020'/%3e%3cpath d='M513.014 286.582s-.4 3.67.963 7.437c1.362 3.773 1.722 3.909 1.99 4.447.264.535.238 4.509-.268 5.012 0 0-2.648-6.764-3.543-10.097-.898-3.332-1.128-4.613-1.594-4.884-.465-.269-1.232-.336-1.232-.336z' fill='%23202020'/%3e%3cpath d='M512.033 306.116c.297-.062.114-1.558.114-1.558l-.43-3.533-3.634-7.46-3.983-3.584-2.091-3.231-.297 6.16s2.887 6.157 4.777 7.925c1.89 1.765 5.017 5.414 5.544 5.28z'/%3e%3cpath d='M497.16 289.304s.625 1.652.625 2.733v2.086s1.456 2.962 2.786 5.321c1.329 2.35 2.587 4.778 3.713 4.24 1.13-.54 1.531-2.29 1.596-2.494.065-.198-1.261 2.02-1.928 1.683-.661-.335-3.644-9.958-3.578-10.164.065-.202-.798-.604-1.463-1.278s-1.751-2.127-1.751-2.127zm10.842 8.389s-2.063-3.361-2.725-4.845c-.662-1.482-1.791-2.63-2.123-2.63-.332 0-.763-3.012-.763-3.012s1.095 2.004 2.487 2.675c1.396.673 2.253 1.214 2.924.944 0 0 .397 1.55.397 3.1 0 1.548-.197 3.768-.197 3.768z' fill='%23202020'/%3e%3cpath d='M501.366 292.738s.695 2.118 2.055 4.138c1.36 2.021 3.593 4.447 3.593 4.447s-2.466-2.426-3.755-4.311c-1.296-1.886-2.158-4.347-2.158-4.347z' fill='%235c3a1d'/%3e%3cpath d='M508.458 290.227s.657-1.832 1.227-1.92c.568-.085 1.765-.445 1.765-.445s-1.025-.255-1.847-1.214c-.862-1.019-1.062-.944-2-2.034 0 0 .532 2.034.693 2.993.162.96.162 2.62.162 2.62zm-.655.596s2.952 6.326 3.712 8.447c.76 2.123.631 5.29.631 5.29s-.365-2.256-1.027-4.11c-.666-1.851-3.354-7-3.581-7.605-.238-.608.265-2.023.265-2.023z' fill='%23202020'/%3e%3cpath d='M511.823 286.71l.698-9.294-.698-3.282-4.184-9.287s-.2 1.364-1.244 1.31c-1.044-.052-3.831-1.512-4.782-2.778 0 0 .551 2.173.354 4.242-.2 2.073-.547 3.18-.547 3.18l8.061 15.148z'/%3e%3cpath d='M495.793 292.809s1.259 1.518 1.99 1.315c.727-.2.46-3.099-.465-4.711-.931-1.615-10.753-14.743-12.211-15.552-1.458-.804 10.687 18.949 10.687 18.949z' fill='%238b441f'/%3e%3cpath d='M502.5 287.388c.196.607.903 4.793-.795 5.183-2.343.541-13.135-14.366-14.804-16.412 0 0-6.773-4.236-6.905-5.315-.135-1.078 7.304 1.464 7.304 1.464l14.466 13.833s.53.64.733 1.247z' fill='%238b441f' stroke='%235c3a1d' stroke-width='.07'/%3e%3cpath d='M495.793 292.809s-1.195-2.12-1.3-3.632c-.096-1.514-.593-2.323-.692-2.83-.1-.502-7.962-11.91-8.76-12.622-.793-.704-3.481-2.219-3.481-2.219s.31 1.817.31 2.626c0 .806.088 1.035.088 1.035s2.489 4.724 6.071 8.862a702.928 702.928 0 007.764 8.78z' fill='%23202020'/%3e%3cpath d='M507.803 290.823c1.06-.607.595-4.24.2-5.386-.403-1.145-6.836-14.535-6.836-14.535l-1.93.737-3.645-2.86-2.053-2.222s.723 3.2.659 4.749c-.068 1.547-.133 2.488-.133 2.488l5.107 8.952 8.632 8.078zm7.232-8.074l1.53-2.018-.797-6.665-4.246-14.537s-1.063.268-2.126-.404c-1.06-.676-2.155-1.955-2.155-1.955l1.032 8.683 4.381 12.185.263 3.638 2.118 1.074z'/%3e%3cpath d='M501.764 286.15s-4.277-4.647-5.675-6.969a120.33 120.33 0 01-2.586-4.544s-1.192.506-2.688-.098c-1.494-.61-3.48-2.728-3.48-2.728s-1.195 2.321 4.975 8.582c7.064 7.167 9.454 5.756 9.454 5.756z' fill='%23202020'/%3e%3cpath d='M512.068 287.715c1.8-.723 1.743-8.281.053-13.38-1.697-5.102-4.482-9.49-4.482-9.49s3.486 8.177 4.23 11.512c.746 3.333 0 5.701-.598 5.5-.597-.202-.597-1.965-1.99-5.201-1.39-3.228-2.336-4.036-2.336-4.036s4.924 13.477 3.529 13.226c-1.39-.253-8.26-15.197-8.557-15.602-.304-.405-.498.554-.498.554s6.12 18.73 10.65 16.917z' fill='%238b441f'/%3e%3cpath d='M516.064 251.31l3.023 6.42.954 6.788.238 5.724s.197 11.294-1.192 11.563c-1.394.27-2.059-1.079-2.123-1.349-.068-.27-2.59-12.723-2.59-12.723l-2.651-12.991.941-.91.316-1.916 2.055-.138z'/%3e%3cpath d='M507.803 290.823c1.202-.165 0-3.229 0-3.229s-.997 1.48-1.794.472c-.798-1.009-2.061-4.748-2.061-4.748l-.796-2.253s-.86 2.488-1.985 2.488c-1.132 0-6.97-9.895-6.97-9.895l-.698.977s8.227 17.031 14.304 16.188z' fill='%238b441f'/%3e%3cpath d='M503.948 283.322s.997-2.423.598-4.642c-.398-2.225-3.38-7.773-3.38-7.773s-.898.203-2.09-.204c-1.195-.404-3.484-1.92-3.484-1.92s1.592 4.141 3.38 7.172c1.796 3.026 4.977 7.367 4.977 7.367zm4.778-3.435s-.746-5.255-3.131-10.101c-2.392-4.847-3.988-6.413-3.988-6.413s.202 1.063.152 3.031c-.047 1.967 0 2.371 0 2.371s2.19.81 3.836 3.738c1.64 2.929 3.131 7.375 3.131 7.375zm6.508-8.985s-.332-5.656-1.227-8.891c-.896-3.227-1.84-7.519-1.84-7.519s.112-.434.494-.659c.223-.138.549-.204 1-.05 1.192.404 1.69 3.383 1.69 3.383s-.147-4.593-.25-4.793c-.095-.204-.4-.76-.4-.76s-.394.202-.944.154a25.246 25.246 0 01-1.193-.155s.374 1.412-.224 2.072c-.435.479-.85-.43-1.092-.554-.092-.05-.226.653-.226.653s.446 1.615.547 3.031a10.353 10.353 0 01-.148 2.576s.877 3.379 1.822 5.454c.951 2.066 1.99 6.058 1.99 6.058zm5.047-.653s.995-8.128-.843-13.327c-1.846-5.204-3.388-6.565-3.388-6.565l-.843 1.012s2.77 4.414 3.58 8.529c.852 4.29 1.494 10.35 1.494 10.35zm-8.167 4.088s-.901-6.359-2.046-10.447c-1.143-4.094-1.466-5.556-1.466-5.556l-1.74-1.615s1.022 4.34.92 5.606c-.1 1.258-.2 2.12-.2 2.12s.847 2.17 1.993 3.983c1.143 1.82 2.54 5.91 2.54 5.91z' fill='%23202020'/%3e%3cpath d='M516.367 284.432c1.624.048.2-9.15-.464-11.507-.665-2.355-4.452-13.417-4.452-13.417s4.554 15.73 4.183 16.516c-.538 1.167-2.317-4.779-2.649-4.712-.33.063 3.382 10.635 2.05 10.77-1.322.136-1.983-2.225-1.983-2.225l.129 2.293s.864 2.222 3.186 2.283z' fill='%23904720'/%3e%3cpath d='M518.353 279.782c1.108 0-.31-8.68-1.103-12.52-.794-3.84-3.012-11.511-3.012-11.511s2.252 5.319 3.517 11.444c1.258 6.122 2.116 14.001.927 14.136-1.192.135-1.793-1.145-1.793-1.145l-.197-1.416s.53 1.013 1.662 1.013z' fill='%23904720'/%3e%3cpath d='M503.41 289.982c.171.618.138 3.597-1.441 3.383-1.581-.214-4.47-2.88-5.063-4.633 0 0 3.432 3.797 4.613 3.773 1.182-.026 1.178-3.92.98-4.929-.2-1.007.912 2.406.912 2.406z' fill='%23312317'/%3e%3cpath d='M511.67 248.635s2.043 1.308 3.684.35c1.643-.959 2.739-3.281 2.689-4.544-.053-1.26-.1-2.373-1.098-3.685-.993-1.312 1.592 1.11 1.545 3.535-.05 2.425.148 6.611-3.735 7.522-3.883.91-2.19-.202-2.19-.202z' fill='%23d2a567'/%3e%3cpath d='M508.598 241.215s2.45 4.016 3.393 7.625c.946 3.61.771 4.997.174 5.071-.598.08-.82-.425-.971-1.334-.147-.913-2.596-11.36-2.596-11.36z' fill='%238f4620'/%3e%3cpath d='M465.627 246.146l16.22 23.53 20.31-22.923-12.842-13.229z' fill='%231e2121'/%3e%3cpath d='M486.131 231.706l-.941 3.686 1.988 6.261 3.385 3.485 3.927 2.617.898-2.928.948-3.427.991-.354 2.487.961 1.645-2.372 2.638-4.749-.549-1.84-.63-1.31-4.108-7.157-1.384 2.707-1.29.784-2.393-1.36-2.887 3.781-3.528-1.637z'/%3e%3cpath d='M494.496 247.77s.703-.501 1-2.37c.301-1.868.35-7.573-.149-9.847-.496-2.269-1.992-6.763-2.29-6.41-.296.354 2.341 4.948 1.943 10.552-.398 5.603-.2 7.17-1.396 7.724-1.197.554.892.35.892.35z' fill='%235c3818'/%3e%3cpath d='M495.443 238.33s2.686 3.836 3.983 2.472c1.292-1.362.646-6.261-.196-8.178-.851-1.92-1.744-4.697-1.744-4.697l.798-.807s.892 3.23 1.39 5.252c.497 2.018 1.99 7.974.197 9.038-1.789 1.058-4.38-2.173-4.38-2.173l-.048-.908z' fill='%235c3818'/%3e%3cpath d='M486.762 240.97s.895-1.312 2.123-1.446c1.228-.135 1.464.403 1.464.403l1.092 3.163 1.825 3.267 1.624 1.612-.962.91-1.29.237s-3.856-2.02-3.917-2.154c-.066-.135-1.064-1.415-1.064-1.415l-.895-4.576z' fill='%238f4620'/%3e%3cpath d='M493.141 274.384c-1.265.657-4.176-.795-5.818-2.243-1.642-1.444-10.3-10.281-10.3-10.281l-1.212-4.9 3.35.912 5.874-2.524 1.096-2.07 7.064-3.686 3.937-2.119 8.556-.152 2.041-4.192s2.871 4.964 3.35 7.002c.481 2.037.38 8.299-.365 8.7-.744.404-3.532-1.871-3.93-2.02-.4-.15 2.09 8.787 0 9.137-2.093.353-5.575-3.33-5.575-3.33s1.393 7.974-.247 8.027c-1.645.051-5.89-2-7.698-3.956 0 0 2.02 6.582-.123 7.695z' fill='%23d2a567'/%3e%3cpath d='M491.459 264.033s1.379 2.023 1.807 2.658c.431.638-.074 4.42-.334 5.118-.532 1.448-2.488-1.715-3.551-4.51 0 0-3.114-5.184-3.315-5.856-.198-.675 5.393 2.59 5.393 2.59zm16.672-19.756s3.019 12.454 1.56 12.888c-1.461.438-5.61-3.939-6.072-4.577-.468-.638-6.239-9.826-6.239-9.826l-1.227-1.247.364-.64 2.454.94 9.16 2.46z' fill='%238f4620'/%3e%3cpath d='M486.762 268.204c-.672.433-1.957-1.615-2.553-2.153-.6-.536-2.622-3.032-4.613-5.05-1.988-2.016-3.449-3.5-3.449-3.905 0-.405-1.196-1.682-1.196-1.682l1.063-1.341 1.394-.206s8.229 6.562 8.792 7.602c.561 1.05.93 6.498.561 6.735zm12.384.105c-.388.306-5.839-3.638-8.13-6.902-2.291-3.265-4.678-6.126-5.244-7.642a112.547 112.547 0 01-1.029-2.892l1.66.367s13.37 16.561 12.744 17.069zm1.952-5.76c-.304.372-2.687-1.411-4.15-3.332-1.46-1.917-.692-4.306-.692-4.306s5.137 7.272 4.842 7.639zm3.049-.735c-.741.351-3.866-3.418-6.467-7.673-1.926-3.147-2.404-3.618-2.82-3.869-.713-.434-2.06-.639-2.06-.639l-.268-.404 1.396-.34 1.032-1.207 1.622-2.09 6.473 13.061s1.589 2.928 1.092 3.16z' fill='%238f4620'/%3e%3cpath d='M487.334 272.141c.052.475-.026.954-1.79.777-1.765-.177-10.998-5.1-15.156-11.89a3345.15 3345.15 0 01-4.702-7.7l1.843-2.095 14.657 16.71 5.149 4.198z' fill='%23ab6d29'/%3e%3cpath d='M487.334 272.141c.198.777-.728.979-1.657.741-.932-.234-4.614-1.548-10.486-8.078-5.87-6.53-8.16-11.206-8.16-11.31 0-.097-.298-2.793-.298-2.793l1.724-.74 10.088 15.38 8.79 6.8z' fill='%238f4620'/%3e%3cpath d='M497.137 265.54s-3.04-2.173-4.981-4.495c-1.937-2.323-5.873-7.721-5.773-8.786.1-1.058 1.742-1.058 1.742-1.058l-.098-2.722.498-.916 2.838 1.162 3.58 4.397 1.314 1.783s2.321 5.586 1.87 6.091c-.445.506-3.731-3.13-4.13-2.675-.4.456 3.738 6.815 3.14 7.22zm-5.678-1.507s.995 1.515.543 2.575c-.441 1.058-.842 1.616-2.337-.604-1.494-2.225-3.298-4.712-3.465-4.533-.165.186.18 3.42-.564 3.42-.75 0-3.087-2.776-4.58-5-1.493-2.22-3.781-5.906-3.781-5.906s.2-.759.1-3.281c-.1-2.527-.3-3.836-.3-3.836s.217.79.481 1.38c.265.588.663 1.009.663 1.009l5.475 6.449 1.538-1.072 3.242 6.321 2.984 3.078zm-20.75-9.394s4.231 7.423 8.162 11.567c3.932 4.136 8.462 5.937 8.462 5.937l-12.788-15.127-3.836-2.376zm32.444 4.394c-.22.152-2.837-2.678-4.477-5.202-1.644-2.523-2.935-6.06-2.837-7.625.103-1.566.547-5.35.547-5.35s4.382 4.545 5.221 6.664c.851 2.123 2.652 5.011 2.256 5.368-.397.352-3.344-1.987-3.695-1.428-.35.555 3.435 7.268 2.985 7.573zm4.978-4.744c-.535.27-2.734-2.323-3.335-3.939-.598-1.618-.797-4.797-.797-4.797l-1.941-4.594.2-5.097 1.94-.306 2.934 4.042s1.147 2.371 1.097 5.805c-.052 3.433.496 8.582-.098 8.886zm-34.49 12.478c-3.932-4.847-6.32-9.394-6.32-9.394l-1.294-4.34.698.556s1.143 4.998 7.213 10.952c6.073 5.963 7.418 6.464 7.418 6.464s1.192 3.286.597 4.446c0 0-4.379-3.84-8.311-8.684z'/%3e%3cpath d='M480.196 273.718s-5.177-4.572-9.292-9.756c-4.113-5.183-6.702-10.165-6.702-10.165l1.793-1.685s3.417 7.977 5.872 11.143c2.456 3.164 8.329 10.464 8.329 10.464zm7.138-1.577s-6.005-5.955-9.057-9.321c-3.05-3.363-4.742-6.766-4.742-6.766l2.52.976s.996 2.624 3.185 5.354c2.193 2.726 8.094 9.757 8.094 9.757zm-1.133-10.678s-3.284-4.004-4.843-6.526c-1.562-2.524-3.155-5.756-3.155-5.756s4.414 5.049 5.708 5.383c1.293.34 1.26-.03 1.26-.03s-.53 1.815-.1 3.33c.432 1.517 1.13 3.6 1.13 3.6zm1.332-16.24s.532 2.822.167 4.475c-.363 1.647-1.242 1.636-1.242 1.636s1.706 2.403 2.704 3.41c.991 1.012 3.484 2.761 3.484 2.761s-1.994-2.76-2.792-4.172c-.796-1.414-1.956-2.996-1.455-4.377.495-1.383 3.185.945 3.945 1.583.767.637 3.919 4.376 3.919 4.376s-1.166-3.875-2.723-5.285c-1.56-1.412-6.007-4.407-6.007-4.407z' fill='%23202020'/%3e%3cpath d='M500.77 253.693s-1.692-4.068-2.659-6.56c-.961-2.493-2.468-7.892-2.468-7.892s.114 2.473-.02 4.292c-.132 1.817-.777 4.593-1.571 4.995-.798.404-.976.482-2.442.079-1.467-.405 1.02.682 1.02.682s1.494-.048 2.143-.781c.642-.737.79-2.302 1.494-2.074.694.23 1.439 2.602 2.016 3.637.567 1.033 2.487 3.623 2.487 3.623z' fill='%23202020'/%3e%3cpath d='M495.618 239.194s3.156 3.535 4.523 1.944c1.371-1.589.573-6.083.573-6.083s1.917.734 2.514.254c.598-.48.321-2.246.321-2.246s3.405 4.972 5.046 8.151c1.645 3.18 2.487 8.923 2.487 8.923s-2.817-4.58-4.246-8.923c-1.302-3.95-3.209-5.753-3.56-5.375-.346.377-.87 3.154-.447 4.594.427 1.437 1.592 3.308 2.39 5.352.797 2.043 1.689 5.251 1.689 5.251s-1.617-2.45-2.559-3.787c-.946-1.337-1.943-1.869-2.59-2.497-.645-.634-1.618-1.795-2.56-2.173-.948-.377-2.813-1.314-2.813-.58 0 .73-.373-1.44-.373-1.44z' fill='%23202020'/%3e%3cpath d='M485.045 254.336s1.741 3.487 3.132 5.303a327.882 327.882 0 013.288 4.393s-2.984-2.726-4.181-4.443c-1.196-1.719-2.24-5.253-2.24-5.253z' fill='%23171717'/%3e%3cpath d='M505.595 255.247c-.448.178-1.895-.35-2.045.178-.146.527.824 2.602 1.895 3.688 1.065 1.083 1.518 1.131 1.768 1.007.247-.128-.114-1.086-.288-2.198-.175-1.11-.038-2.296-.162-2.653-.124-.35-1.168-.022-1.168-.022z' fill='%238f4620'/%3e%3cpath d='M468.407 233.026l-1.811 1.188-2.19 4.445.596 8.146s2.025 2.861 3.268 4.662c1.245 1.801 5.36 6.443 6.421 6.176 1.062-.27 2.192-3.498 2.323-5.25.133-1.754.266-4.98.266-4.98s.996 1.749 2.72 3.63c1.725 1.888 3.185 3.637 3.983 3.505.797-.137 3.182-4.915 3.248-5.522.065-.602-5.972-15.415-5.972-15.415l-2.685-1.392-10.167.808z' fill='%23d2a567'/%3e%3cpath d='M481.96 245.351s1.042 3.785 1.69 5.656c.648 1.865-.018 3.483.333 3.533.347.046 3.5-4.192 3.547-6.108.052-1.917.052-3.887-.793-9.746-.85-5.856.273-7.559.273-7.559l-1.816-1.48-3.136 6.314-.098 9.391zm-10.609-3.33s.697 5.705 1.095 7.573c.4 1.869 1.492 5.047 2.092 4.995.597-.046 2.487-5.047 2.537-6.763 0 0-1.293-2.422-1.244-8.532.05-6.11-.598-6.715-.598-6.715l-3.882 9.443z' fill='%23ab6d29'/%3e%3cpath d='M463.174 230.234s-4.777 6.933-4.68 10.737c.101 3.802.73 2.96 1.828 6.391 1.093 3.44 1.692 8.521 1.756 8.959.067.434.763-.24.863-.742.1-.505.233-25.346.233-25.346z' fill='%2345392d'/%3e%3cpath d='M463.15 231.05s-4.18 6.462-3.88 10.032c.297 3.563.861 3.467 2.055 6.665 1.194 3.198 1.294 8.41 1.294 8.41s1.327-.4 2.82-1.462c1.492-1.063 2.836-3.23 2.836-3.23s-.512-1.162-1.476-3.246c-.961-2.09-1.062-2.898-1.062-2.898l-1.226-1.75.364-6.194 1.094-4.476v-1.685z' fill='%23ab6d29'/%3e%3cpath d='M485.734 242.174s-2.09-.455-2.936-.96c-.843-.504-1.193-1.716-1.193-1.716l.499-1.212z' fill='%23dbad6c'/%3e%3cpath d='M464.003 231.752s-3.017 6.5-2.654 10.972c.367 4.48 2.821 10.2 3.053 10.268.233.067.13-.437.199-1.448.067-1.007-.131-13.361-.131-13.361l1.46-4.342.065-2.256-1.992.168z' fill='%23d2a567'/%3e%3cpath d='M471.305 233.201s.4 1.953.132 2.762c-.264.807-1.857 1.817-2.52 3.096-.665 1.28-1.592 4.24-1.592 4.24s.728-1.682 1.725-2.758c.994-1.077 1.394-1.817 1.593-1.213.197.607.531 3.166.33 3.639-.197.467-.996 1.24-1.523 3.026-.565 1.902.064 3.637.064 3.637s.348-2.173.666-3.3c.277-.996 1.125-1.484 1.125-1.484l1.66 3.575s0-1.687.268-2.968c.264-1.276 1.655-3.078 2.103-3.078.45 0 1.146-.252-.548-1.112-.546-.352-.197-6.562.25-6.814.448-.25 2.786-.34 2.54-1.199-.25-.857-2.278-3.17-2.477-3.372-.2-.2-3.796 3.323-3.796 3.323z' fill='%238f4620'/%3e%3cpath d='M485.395 246.415s-1.448-.253-2.243-.405c-.795-.15-.895-.907-.895-.907l.252-.958 1.838 1.01z' fill='%23dbad6c'/%3e%3cpath d='M466.153 247.15c-.04.668-.534 1.349-.855 2.281-.388 1.128-.611 2.468-.611 2.468s-.45-2.982-.598-5.078c-.15-2.094-.298-3.458-.547-3.584-.25-.125-.971.983-.971.983s0-2.349.447-3.482c.448-1.135.82-2.752.424-3.005-.4-.253-1.244.456-1.616 1.06-.376.607-1.072 1.919-1.072 1.919s.447-1.993.92-2.801c.473-.809 2.738-3.41 3.161-4.42.422-1.008.423-2.095.423-2.095l1.57-.075s1.635 1.277 1.65 2.387c.01.626-1.567 1.327-1.602 1.4-.102.202-1.319-.102-1.618 5.099-.3 5.202 1.031 4.775.895 6.944zm14.311-13.306s.348 2.826.05 3.685c-.3.858-1.144 1.564-1.741 2.675-.598 1.111-.549 3.79-.549 3.79s.3-1.317.8-2.126c.494-.804.893-1.513 1.094-1.513.197 0 .795 1.012 1.193 2.477.399 1.462 1.196 3.935 1.196 3.935s-.346-1.92.147-1.92c.496 0 .695-.15 1.344.356a22.702 22.702 0 011.395 1.21s-.05-.705-.997-1.717c-.944-1.01-1.49-.957-1.793-2.321-.295-1.364-.442-2.726-.295-3.283.146-.552.796.356 1.342 1.01.548.657 2.29 2.173 2.29 2.173s-.746-1.162-.947-1.516c-.199-.355-.05-3.029 0-4.545.05-1.513-.05-2.926.495-3.328.551-.407.651-2.378.398-2.73-.245-.352-5.42 3.688-5.42 3.688z' fill='%238f4620'/%3e%3cpath d='M497.113 228.026s.135 3.194.567 5.049c.428 1.85 1.66 5.888 1.66 5.888s-1.66-2.995-2.392-5.587c-.731-2.59-1.395-5.383-2.058-5.586-.661-.202-1.426 1.245-1.426 2.322 0 1.076.698 5.117 1.595 6.53.896 1.415-1.429-1.852-1.994-3.601-.56-1.752-1.128-3.298-1.128-3.298s-.561 1.48-.33 3.13c.233 1.649 1.63 4.005 1.63 4.005s-.902-.775-1.463-1.449a8.652 8.652 0 00-1.064-1.075s.099 2.256.697 3.23c.594.976 1.758 2.524 1.758 2.524s-1.392-1.042-1.923-1.649c-.532-.604-.695-1.04-.695-1.04s.296 3.229.995 4.947c.695 1.714 2.221 4.544 2.221 4.544s-1.826-1.45-3.053-4.273c-1.225-2.83-1.826-11.258-1.527-12.54 0 0 .936-1.592 1.8-2.838.864-1.245 1.956-7.194 1.956-7.194s1.356 5.502 2.283 6.547c.932 1.041 1.89 1.414 1.89 1.414zm-13.167-1.66s.703 1.475 1.149 2.133c.447.657.897 1.5.897 1.5s-1.646 1.769-3.485 3.183c-1.845 1.412-4.283 2.977-4.829 2.171-.546-.81-.52-1.502-.52-1.502s2.025-1.212 3.618-2.827c1.59-1.616 2.14-2.464 2.491-3.32.349-.861.68-1.338.68-1.338zm-16.754 5.456s.286 3.435 1.73 3.383c1.445-.05 5.723-4.391 6.021-4.593.299-.202.585-1.264.585-1.618 0-.352-.26-1.162-.26-1.162s-4.606 4.723-6.246 4.875c-1.2.11-1.83-.885-1.83-.885zm.14-4.51s-.548 2.416-.472 3.098a4.917 4.917 0 00.29 1.21s-3.301 1.16-3.848.152c-.549-1.01-.187-2.449-.187-2.449s1.53.007 2.376-.193c.847-.203 1.843-1.817 1.843-1.817zm31.16-4.848s1.346 3.54 2.21 4.957c.866 1.414 2.221 4.34 2.221 4.34s-2.221-2.59-2.918-3.163c-.697-.572-1.828-1.526-1.828-1.526s.326-.953.326-1.691c0-.741-.01-2.916-.01-2.916z' fill='%231e2121'/%3e%3cpath d='M462.6 229.345s1.228.153 1.982.11c.759-.04 1.255-.344 1.255-.344l1.254-1.875s-.639 2.22-.198 3.796c.438 1.575 1.352 1.817 1.71 1.817.358 0 2.11-.364 3.465-1.778 1.352-1.412 3.224-2.885 3.224-2.885s-.439 2.038.278 4.056c.718 2.021 1.869 1.98 3.423.729 1.552-1.252 3.149-3.396 4-4.345.467-.52 1.06-1.604 1.06-1.604l1.709-1.362 1.472-8.32-.797-1.092-2.155 1.028-2.58-1.028-.758-1.05-1.472 2.504-1.552 1.01-.786.13-1.803.355-.796-1.616-.479-1.252-.876-.403-3.71 3.743-2.101-.108-2.111 3.311-1.513 2.098-1.555 3.68z' fill='%23dbad6c'/%3e%3cpath d='M480.616 220.922s.3 2.071-.745 5.553c-1.044 3.485-2.487 5.959-2.487 5.959s3.731-2.273 5.526-6.361c1.785-4.092 1.372-8.788 1.372-8.788l-3.666 3.638zm4.522-3.797s.45.604.052 3.735c-.4 3.13-1.145 6.16-1.145 6.16s.443.757.945 1.767c.495 1.01 1.742 2.778 2.637 2.475.897-.304 2.288-1.364 3.233-3.437.946-2.069 1.793-4.087 2.14-4.392.349-.302.5.202.651.356.148.152.438 1.918 1.33 2.675.896.756 2.066 1.943 2.613 1.59.546-.352 1.081-1.386.983-1.895-.098-.503-1.992-6.159-1.992-6.159l-2.386-6.108-1.53-2.374-4.346.406-3.184 5.2z' fill='%238f4620'/%3e%3cpath d='M492.674 211.517s1.226 2.626 1.298 5.454c.066 2.828-.565 5.788-.565 5.788s.264-3.533-.134-5.653c-.398-2.12-1.028-3.502-.96-4.108.064-.605.36-1.482.36-1.482z' fill='%23ab6d29'/%3e%3cpath d='M498.574 222.569s.246 2.44 0 3.599c-.25 1.164-1.945-.755-2.984-4.593-1.05-3.837-.85-4.695-1.646-6.563-.8-1.87-1.28-3.485-1.28-3.485l2.177-.3 3.733 11.343zm-10.644 7.127s4.15-2.353 4.677-9.443c.252-3.331-1.89-8.734-1.89-8.734s0 5.754-1.542 9.467c-1.543 3.71-2.814 6.186-2.814 6.186s.996-.431 1.496-1.036c.495-.605 1.191-1.642 1.191-1.642s.225 1.063-.147 2.45c-.373 1.388-.971 2.752-.971 2.752zm-3.656-12.42s-.134 1.568-1.876 2.98c-1.742 1.415-4.874 2.98-4.874 2.98s2.288-2.12 3.132-3.989c.849-1.87.2-3.08.2-3.08s-.296 1.008-1.292 1.767c-.995.76-2.438.908-2.438.908s.12-.958 1.015-1.967c.184-.207.15-.681.275-1.072.491-1.515 1.793-3.625 1.793-3.625s.995 2.223 1.99 3.182a78.667 78.667 0 002.074 1.916z'/%3e%3cpath d='M497.253 208.9s.994 2.56 1.392 6.058c.399 3.503-.065 7.61-.065 7.61s-2.123-3.3-2.654-4.647c-.53-1.347-.53-3.365-.996-4.376-.279-.605-1.042-1.212-1.602-1.602-.369-.256-1.55-.2-1.55-.2s1.225-.587 1.33-1.664c.094-1.077 0-1.65 0-1.65s.793.404 2.09.574c1.291.167 2.055-.103 2.055-.103zm-9.3 14.943s2.267-3.165 2.859-7.07c.599-3.903-.098-5.25-.098-5.25s-.929-.134-1.69-.876c-.765-.74-1.955-2.659-1.955-2.659s.33 2.021-.105 4.477c-.428 2.456-2.686 4.81-2.686 4.81s1.198.416 2.258-.2c2.25-1.315 2.089-3.802 2.089-3.802s.496.302.43 3.397c-.068 3.1-1.101 7.173-1.101 7.173z' fill='%231e2121'/%3e%3cpath d='M461.152 229.24c-.48-.067 1.494-3.132 2.838-5.251l3.234-5.101s.351.355 1.145.304c.796-.052 2.837-.96 3.683-2.526.847-1.564 1.492-3.28 1.545-3.787.05-.503-.15 2.728 1.391 4.494 1.545 1.767 1.494 1.617 2.142 1.465 0 0-.05 2.223-.648 4.292-.597 2.07-1.194 5.05-1.194 5.05s.248-3.887-.4-5c-.645-1.11-.994.102-1.54 1.516-.548 1.412-1.741 2.423-1.741 2.423s.894-1.716 1.492-3.535c.596-1.816.3-1.868.147-1.918-.148-.05-.446-.1-1.092.657-.648.757-1.295.959-1.295.959s.796-.657 1.045-1.566c.25-.908.996-2.221 1.442-2.726.448-.505.747-1.112.747-1.464 0-.355-.1-1.112-.4-1.112-.295 0-.694.457-2.135 1.819-1.445 1.362-1.696 1.462-1.944 1.969-.25.504-.449 1.158-1.345 3.99-.894 2.825-1.492 3.989-1.64 4.241-.15.25-.797.672-.797.672s.498-1.582 1.244-3.652c.746-2.068 1.743-4.797 1.493-5.251-.248-.453-.896-.403-1.094 0-.198.404-1.643 2.17-3.086 4.29-1.444 2.123-1.444 4.748-1.792 4.848 0 0-.961-.032-1.445-.1z' fill='%238f4620'/%3e%3cpath d='M498.68 206.61c-.03.245.132 1.759-1.427 2.288-1.561.532-3.45-.1-3.651-.275-.197-.177-.197-2.173-.197-2.173z' fill='%23874f20'/%3e%3cpath d='M468.49 211.552s-.285 1.442-1.137 3.23c-.855 1.788-2.27 3.277-2.095 3.505.173.226.971 1.061 2.214 1.036 1.245-.026 1.692-7.45 1.692-7.45l-.218-.266z' fill='%23b27129'/%3e%3cpath d='M487.603 207.462s-.562 9.84-3.324 9.821c-2.761-.013-4.011-4.974-4.011-4.974s-.228 6.636-3.755 6.636c-1.593 0-3.273-5.123-2.914-6.053 0 0-.654 3.533-2.318 4.841-3.3 2.597-5.403 1.327-5.516.922-.114-.402 2.786-3.17 3.185-7.04 0 0 .51.175 1.307-.98.796-1.153 1.252-2.42 2.047-2.192.797.23 4.778-1.615 4.778-1.615l2.087-2.644s.245.856 1.78-.182c1.535-1.042 2.048-2.597 2.048-2.597l4.094 3.46.512 2.598z' fill='%23dbad6c'/%3e%3cpath d='M476.831 198.116s2.476 3.75 4.131 5.833c.097.122.91-.784.91-.784.546.75.848 1.4.681 1.793-.646 1.517-1.989 3.585-.896 5.757 0 0-.348-1.212.251-2.777.598-1.566 1.045-2.123 1.394-2.07.348.05.947 8.986 1.544 8.936.595-.052 1.392-4.04 1.392-6.866 0-2.83.565-.507.832.05.265.555 2.7 4.545 4.79 3.938 2.091-.605 1.796-4.292 1.742-5.097-.045-.812-1.49-5.707-1.49-5.707l-9.358-5.89s-.274.738-.772 2.405c-.5 1.667-5.15.48-5.15.48z' fill='%23b27129'/%3e%3cpath d='M490.115 197.24s.546.505 1.447 2.828c.893 2.323.991 9.846-.2 9.794-1.197-.05-3.587-1.412-3.982-2.424-.4-1.009.147-4.744-.647-5.756-.797-1.01-1.742-3.533-1.794-4.24-.051-.706.152-2.978.152-2.978l2.087-.76z' fill='%238f4620'/%3e%3cpath d='M489.449 194.904l3.982 5.923 3.519 5.083s1.772.588 1.726.706c-.05.12-2.043 2.288-4.804.75-1.373-.768-.673-3.158-2.411-6.994-1.745-3.837-4.879-5.503-4.879-5.503l1.097-1.06z'/%3e%3cpath d='M487.253 191.667s3.557 2.35 4.817 4.909c1.262 2.558 1.995 4.107 3.522 6.597 1.522 2.49 3.154 3.265 3.082 3.433-.064.17-1.093.405-1.857-.167-.766-.573-1.557-1.245-2.19-2.39s-2.854-5.318-3.685-6.397c-.829-1.076-3.48-3.095-3.548-2.893-.065.203.83.81 2.357 3.265 1.525 2.457 1.89 4.678 1.791 4.713-.1.035-.433-.91-1.76-3.13-1.326-2.224-4.212-5.085-4.379-4.68-.166.405 1.425 3.03 2.223 4.544.796 1.514 2.125 5.05 1.991 5.05-.132 0-1.062-1.987-2.657-4.445-1.59-2.457-1.89-2.153-2.555-2.96-.661-.81-2.081-2.673-2.081-2.673s1.422.45 2.812-.458c1.397-.91 2.117-2.318 2.117-2.318z' fill='%231e2121'/%3e%3cpath d='M478.198 198.221s2.29.528 3.53.376c1.248-.15 1.67-.1 1.67-.1s.744 1.011.744 2.17c0 1.162-.797 3.334-1.143 3.384-.349.05-.297-1.97-.841-2.676-.551-.707-3.96-3.154-3.96-3.154z' fill='%238f4620'/%3e%3cpath d='M479.413 204.227s.74 2.482.172 5.942c-.57 3.464-2.56 7.04-3.072 7.04-.511 0-.342-3.923-.568-5.998a59.615 59.615 0 00-.072-.635c-.033-.288-.784 2.616-.811 2.365-.031-.263.66-3.677.636-3.897-.099-.822-.16-1.304-.16-1.304l2.568-3.052z' fill='%23b27129'/%3e%3cpath d='M475.056 206.808c-.697.86-1.765.626-2.752.935-.926.287-1.26 1.7-1.26 1.7s.748-.556 1.096-.405c.348.152.763.12.066 1.833-.697 1.719-3.416 4.63-3.285 4.665.133.035 3.037-2.459 3.982-3.873.945-1.412.862-2.253 1.061-2.76.198-.504 1.327-1.11 1.575-1.16.25-.051.8.05 1.046 1.06.25 1.01.648 3.888.847 3.988.2.1.895-2.626 1.194-3.988.298-1.364.285-4.367.285-4.367s-.185-.075-.883-.23c-.696-.15-2.366-1.347-2.366-1.347s.328 2.798-.606 3.95z' fill='%238f4620'/%3e%3cpath d='M487.334 189.214s.945 2.348-.996 3.99c-.575.483-1.129.806-2.156.858-1.032.048-2.672-.834-2.672-.834l-5.949-2.475-3.134-.983-1.542-.43.221-1.716 4.654.203 4.605 1.764 2.015.657 1.715.302h1.296l1.07-.302s.494-.202.643-.478c.153-.28.23-.556.23-.556z' fill='%23dbad6c'/%3e%3cpath d='M487.334 189.214c.196.404-.35 1.716-.797 1.918-.45.203-1.249.555-3.038.15-1.79-.402-3.632-1.564-5.622-2.119-1.99-.555-3.484-1.061-5.028-1.011-1.543.053-.796-.657-.796-.657s3.534-.4 6.62.76c3.09 1.16 4.416 1.95 5.975 1.916 2.336-.048 2.686-.957 2.686-.957z' fill='%23ab6d29'/%3e%3cpath d='M471.06 187.344s.695.15 1.294.05c.598-.101 1.047-.455 1.047-.455s.1.81-.3 1.062c-.399.252-1.592.15-1.793.15-.2 0-.248-.807-.248-.807z'/%3e%3cpath d='M482.755 194.693s2.082 2.038 1.525 3.803l-4.013-1.845-6.545-2.725-3.545-1.06-.436-.556s.672-.63.994-1.235c.324-.607.225-1.187.225-1.187l4.329.581 4.528 1.39z' fill='%23dbad6c'/%3e%3cpath d='M478.303 197.613s3.733 4.822 2.861 6.412l-8.71-5.502-3.07 5.057-7.165-3.533s5.78-4.453 6.454-5.286c.67-.834.72-1.136.72-1.136l3.236.63 5.098 1.618z' fill='%23dbad6c'/%3e%3cpath d='M476.282 190.487s3.05.741 5.011 1.749c1.957 1.01 4.695 1.238 4.695 1.238s-1.1 1.16-3.237 1.22c-.631.017-2.156-1.211-3.153-1.916-.994-.71-3.865-1.55-3.865-1.55z' fill='%23ab6d29'/%3e%3cpath d='M470.908 188.851s2.19.455 3.535 1.06c1.344.606 1.444.454 1.792.304.348-.152.397-.304.397-.304s.275 1.315-.771 1.315-1.467-.354-2.81-.961c-1.345-.605-2.241 0-2.241 0z'/%3e%3cpath d='M483.012 197.322s1.562.976 1.26 1.177c-.296.202-1.079.572-2.437.657-1.358.085-2.009-.083-2.972-.523-.96-.437-1.557-2.121-3.88-3.028-2.323-.91-2.722-1.044-4.314-1.45-1.592-.402-1.957-.369-1.957-.369l1.462-.607 5.007 1.012 4.28 1.244 2.589 1.247.96.64zm-8.412 2.944l.995 3.938-.547 2.375-1.344.857-1.244-.504-.349-.707s.548-.908 0-1.717c-.544-.807-3.084-1.816-3.084-1.816s.996-1.921 2.14-2.374c1.143-.454.594-1.918.594-1.918z' fill='%23ab6d29'/%3e%3cpath d='M469.716 192.24s.795.672 2.423.841c.691.074 1.983.305 3.313.723.447.14 1.54-.466 1.63-.439l-.945.567c1.445.416 3.26 1.048 3.899 1.34 1.727.78 3.084 2.019 2.984 2.052-.054.017-.984-.54-2.984-1.382-1.452-.61-3.3-1.18-4.646-1.448-2.987-.586-5.973-.4-6.601-.605-.633-.2.264-.235.595-.572.332-.336.332-1.077.332-1.077z'/%3e%3cpath d='M480.862 203.046s.948 1.01-.048 1.362c-.996.356-3.71.292-5.001-1.072 0 0-.325-1.3-.823-1.903-.496-.607-2.487-1.87-3.633-2.577-1.143-.707.396-.808.396-.808s4.084 1.566 5.578 2.373c1.493.81 3.53 2.625 3.53 2.625z' fill='%23ab6d29'/%3e%3cpath d='M480.92 203.14s-2.01-2.778-7.596-4.98c-.153-.06 1.9-.352 1.74-.41-.24-.092-2.693.048-2.947-.04-.42-.144-.857-.288-1.314-.427-2.937-.891-3.15-.806-3.35-1.212-.2-.402-.565.067-.862.572-.3.505-1.128 1.6-1.063 1.5.066-.103 2.158-.59 3.815-.185 1.66.4 1.593 1.008 1.46 1.648-.132.64-2.156 3.098-1.923 3.165.232.066 1.392-2.326 2.918-1.986 1.527.337 2.026 1.177 2.026 1.177s-.035-.875-.33-1.247c-.301-.37-1.993-1.95-1.529-1.95.465 0 2.356.436 5.077 1.816 2.65 1.349 3.082 1.752 3.878 2.56z'/%3e%3cpath d='M471.807 198.77s4.282 1.212 4.083 5.756c-.2 4.543-3.518 3.703-3.818 2.053-.296-1.65.399.791 1.594.571 1.304-.236 1.576-1.544 1.493-3.296-.08-1.682-.43-2.525-1.46-3.502a18.521 18.521 0 00-1.892-1.582z' fill='%23dbad6c'/%3e%3cpath d='M453.29 187.824s.447.344-.771 3.552c-1.222 3.205-1.881 4.347-3.732 6.388-3.46 3.81-4.978 3.835-4.605 5.451.374 1.617 1.717 1.185 2.015 1.237.3.05 6.52-9.113 6.52-9.113l1.369-5.504-.324-1.539z' fill='%236c3f18'/%3e%3cpath d='M468.723 181.27s1.792 2.688 1.226 7.772c-.563 5.082-7.262 9.526-7.262 9.526l-9.789 6.765-4.09-.244s-.633.09-1.226-.064c-.643-.168-1.247-.834-1.385-.834-.266 0-.764-1.719-.764-1.719l1.294-1.58 3.55-3.538 2.223-3.195s.996-1.852 1.128-3.636c.134-1.784-.33-2.693-.33-2.693l.83 1.28.463 2.692-.366 2.995 2.556-1.715 3.383-1.513s.932-.136 1.594-2.021c.662-1.886 1.22-4.656 1.23-5.89.013-1.24-.137-2.726-.137-2.726s.213-.014.426.113c.21.125 1.105 1.692 1.105 2.586 0 .897.572 4.193.572 4.193l1.57-1.593s1.155-1.452 1.467-2.206c.31-.758.745-1.953.732-2.756z' fill='%23dbad6c'/%3e%3cpath d='M469.81 206.703s.671.555.422 2.399c-.249 1.843-1.766 2.853-2.51 2.878l.071-2.574-2.163-1.718-2.316-.705s.15-.127.423-.405c.275-.277 2.664-1.262 2.664-1.262z' fill='%23904720'/%3e%3cpath d='M468.116 206.726s.67.656 1.742.378c1.07-.275 1.52-1.996.946-2.676-.573-.68-.324 1.642-1.019 1.895-.698.252-1.443-1.743-2.39-1.944-.946-.202-2.44.455-2.811 1.082-.374.634 1.519.13 1.519.13l1.017.276.748.177z' fill='%23ab6d29'/%3e%3cpath d='M453.979 199.67s1.271.383 2.65.197c1.377-.188 4.762-1.6 4.762-1.6s1.558-.876 2.704-1.985c1.142-1.11 4.762-3.368 5.16-7.876.395-4.511-.532-7.135-.532-7.135s5.346 5.843.662 12.555c-3.05 4.374-5.705 5.654-5.705 5.654s5.177-1.515 5.641-.27c.461 1.244-.24 3.182-.375 3.485 0 0 2.936.682 3.359 2.17.254.895-3.334-1.036-6.045-.379-2.712.657-3.905 2.271-3.905 2.271s-.5-.782-2.913-.805c-2.415-.027-3.509 1.11-4.878 1.06-1.367-.052-5.67-.97-6.502-2.147 0 0 1.027-1.282 2.847-3.359 1.245-2.393 3.07-1.835 3.07-1.835z' fill='%23904720'/%3e%3cpath d='M465.101 187.566s2.091-2.053 2.786-3.567c.7-1.515.832-2.727.832-2.727s.233 1.648-.995 3.5a19.807 19.807 0 01-2.586 3.132z' fill='%23ab6d29'/%3e%3cpath d='M464.529 182.987s1.71 6.63-.117 9.356c-1.825 2.726-9.765 6.256-9.765 6.256s6.018-3.26 7.909-7.013c1.89-3.755 1.757-6.884 1.757-6.884l.217-1.715z' fill='%23904720'/%3e%3cpath d='M456.63 199.857s2.54-.052 3.983-.91c1.444-.856 3.485-2.675 3.485-2.675s-1.892 1.666-2.44 1.666-.995-.856-.746-1.514c0 0-.448 1.262-1.593 2.119-1.143.859-2.689 1.314-2.689 1.314zm5.913-8.272s2.139-2.223 2.089-6.867c-.05-4.644-1.793-3.785-1.793-3.785s1.444 1.058 1.145 4.593c-.297 3.534-1.442 6.059-1.442 6.059zm2.594.456s2.41-.581 3.258-1.996c.844-1.412.822-4.113.822-4.113s-.25 2.473-.948 3.38c-.695.911-3.132 2.729-3.132 2.729zm-1.402 14.534s1.195-2.323 2.788-1.716c1.59.603 1.59 1.868 1.59 1.868s-.645-1.01-1.838-1.061c-1.197-.05-2.54.91-2.54.91zm-4.522-4.183s3.532-.861 5.623-1.516c2.089-.655 4.48-1.666 4.48-1.666s-1.742 2.17-4.332 3.635c-2.588 1.464-4.726 1.565-4.726 1.565s4.878-2.12 5.274-2.977c0 0-4.677 1.262-6.319.96z' fill='%231e2121'/%3e%3cpath d='M453.558 196.936a4.048 4.124 67.762 01-4.646 6.68' fill='white'/%3e%3cpath d='M453.348 197.392a3.565 3.632 67.771 01-4.176 5.808' fill='%23f16e16'/%3e%3cpath d='M451.77 199.355a1.432 1.432 0 11-1.394 2.165' fill='black'/%3e%3cpath d='M451.969 201.178a.458.458 0 11-.901-.158.456.456 0 01.527-.377c.25.042.415.282.374.535z' fill='%23d5d3ca'/%3e%3cpath d='M454.457 194.424s2.357-2.32 2.886-5.386c.532-3.063.21-4.804.21-4.804l1.285 1.337.495 2.326-.83 3.867 2.592-1.177c.86-1.176 2.22-6.429 1.755-9.658 0 0 .7 1.414-.231 5.822-.928 4.411-1.686 4.933-5.003 6.75-1.713.936-3.868 2.733-5.81 6.473-.866 1.662-3.204 4.29-3.58 4.674-.06.063 1.662-2.353 2.503-4.155 1.259-2.7 2.634-4.216 2.634-4.216l1.094-1.852z' fill='%23ab6d29'/%3e%3cpath d='M453.36 196.282s1.027-3.098 1.027-4.78c0-1.682-1.094-3.67-1.094-3.67s1.492-.202 1.625 3.465c.132 3.673-.665 3.876-1.558 4.985z' fill='%23904720'/%3e%3cpath d='M458.092 192.333s1.093-2.726 1.021-4.545c-.077-1.817-1.567-3.56-1.567-3.56s1.84.355 1.99 3.664c.149 3.304-.424 3.331-1.444 4.44z'/%3e%3cpath d='M447.226 204.764s-.851-1.094-.753-1.951c.1-.857.033-1.052 2.147-3.275 2.115-2.221 3.285-3.583 3.807-4.77.524-1.188 2.24-4.426.872-6.934 0 0 .945 3.655-1.17 6.557-2.116 2.901-3.333 4.415-5.076 5.704-1.74 1.287-1.915 1.892-1.866 2.626.05.73.224 1.464.523 1.64.53.314 1.516.403 1.516.403z' fill='%23ab6d29'/%3e%3cpath d='M467.73 211.973s.47.05.771-.505c.298-.555.298-1.489-.448-2.423-.747-.935-1.594-1.49-2.64-1.794-1.045-.302-3.057-.505-3.057-.505s.684 1.182 2.038 1.943c.662.377 1.793-.1 2.514.607.722.709.821 2.677.821 2.677z' fill='%236c4119'/%3e%3cpath d='M467.73 211.973s2.35-.763 2.512-3.028c.1-1.403-.199-1.895-.199-1.895s.347.732 1.294 1.01l.847-.328s-1.394 4.392-4.454 4.24z' fill='%236c4119'/%3e%3c/g%3e%3cg fill='%23f9c83a'%3e%3cpath d='M451.327 211.54s.459.19 1.33 1.2c.872 1.01 1.283 1.34 1.283 1.34l5.698-1.464 1.843-1.819-1.544-2.446h-4.08z' fill='%23bf802d'/%3e%3cpath d='M465.137 209.6l-1.098-1.479s-.233-.571-1.062-1.01c-.829-.436-4.28-.404-4.28-.404l-2.488.505s-.697.64-1.959.37c-1.26-.267-4.047-1.413-4.047-1.413l-2.787-1.212s-2.089-.875-2.553-.707c-.467.167-2.19 2.053-2.19 2.053s-.3 1.011.364 1.042c.662.035-.996.338-.996.338s-4.33 2.375-5.025 6.617c-.7 4.237 7.115 10.499 10 7.318 0 0-4.23-3.13-3.383-5.756.845-2.625 2.787-4.242 6.12-4.44 3.335-.202 3.536-.609 4.978-1.618 1.443-1.01 4.13-1.615 6.121.454 1.99 2.07-7.564 4.042-7.564 4.042l1.043 1.512c.003 0 11.799-4.04 10.806-6.212z' stroke='%238f4620' stroke-width='.481'/%3e%3cpath d='M443.09 219.66s-4.777-1.162-4.381-5.553c.4-4.39 4.381-6.007 5.077-6.209.697-.204.549-2.426 1.345-2.676.796-.253 2.324 0 3.022.656.697.657 2.177 1.275 2.177 1.275s-8.459 3.765-8.533 8.62c-.052 3.23 1.292 3.888 1.292 3.888z' fill='%23fcf3d8'/%3e%3cpath d='M465.112 209.134s-.577.352-.735.062c-.894-1.664-2.985-2.108-4.678-2.081-2.156.033-3.618.836-5.08.836-1.458 0-1.06-.233-2.785-.304-1.727-.066-5.408-2.791-6.24-2.522-.828.27-1.16 1.295-1.06 1.8.1.504-1.498.535-1.73.163-.233-.37 1.27-2.751 2.765-2.751 4.013 0 6.994 2.705 8.92 2.705 1.924 0 2.588-1.112 5.174-1.112 2.59 0 5.383 1.15 5.45 3.204z' fill='%23fdeaaf'/%3e%3cpath d='M451.969 212.253s1.919-.38 3.359-1.01c1.445-.63 3.367-1.134 3.367-1.134s-1.764 1.168-2.984 1.752c-1.22.577-3.194.897-3.194.897z' fill='%23513625'/%3e%3cpath d='M445.204 222.183c-.346.138-2.023.067-4.693-1.715-2.671-1.785-3.367-4.812-3.367-4.812s-.614-2.898 2.156-5.841c2.77-2.945 3.224-2.097 3.373-1.961.127.12-.14.262-.14.262l-2.439 1.987-1.21 2.036-1.073 1.833.084 2.167 1.235 2.178 3.821 2.386 2.253 1.481z'/%3e%3cpath d='M443.744 205.559l-.154-.365v.397c.124-.007.14-.03.154-.032l-.154-.365v.397-.403l-.275.287c.1.096.215.116.275.116v-.403l-.275.287.275-.287h-.395a.4.4 0 00.12.287l.275-.287h-.395.393l-.36-.166c-.01.029-.03.06-.033.166h.393l-.36-.166.312.142-.278-.202-.033.06.312.142-.279-.202.07.05-.065-.053-.005.004.07.05-.066-.054c-.018.024-.108.122-.214.247-.163.19-.38.45-.564.736-.18.29-.352.587-.361.963l.012.139c.05.384.311.689.597.822.287.146.59.177.878.18.638-.003 1.227-.187 1.248-.191a.406.406 0 00.265-.506.397.397 0 00-.496-.27l-.017.007c-.098.03-.575.152-1 .15-.216.003-.414-.034-.52-.092-.11-.063-.14-.092-.169-.226v-.012c-.006-.04.032-.178.12-.33a4.617 4.617 0 01.515-.73c.09-.105.17-.198.234-.268l.078-.094.038-.046.03-.049.027-.057c.007-.027.023-.064.025-.143a.4.4 0 00-.4-.406c-.121.007-.142.029-.157.033a.405.405 0 00-.21.526.395.395 0 00.52.216z' fill='%238b5122'/%3e%3cpath d='M451.864 209.66s-5.713 1.598-5.859 1.702c-.42.302 1.831-.048 3.596-.102a6.675 6.675 0 012.055.26s.687-.02 1.382-.288c2.19-.856 6.8-2.57 7.229-.551.357 1.682-6.367 3.162-6.367 3.162l-.06.664 5.406-1.345 2.787-1.465.896-1.439-2.688-1.916h-3.932l-1.817.504z'/%3e%3cpath d='M443.51 217.92c.423 1.186 1.378 2.913 2.455 3.464 0 0 .183.02.117.135-.067.119-.864.61-2.688.136-1.825-.471-4.612-1.212-6.304-6.326l.052 1.126.994 2.004 1.79 1.85 2.806 1.767 1.922.47 1.627-.42.73-.555-1.677-1.514-2.055-3.502s-.083.486.23 1.364z' fill='%238f4620'/%3e%3c/g%3e%3cg fill='%23816c2a'%3e%3cpath d='M462.543 268.718l-.087 1.853-1.023-.101.18-2.321zm-7.162-52.82l-1.889-2.125-1.228.184 1.87 2.662z' fill='%23fcca3d'/%3e%3cpath d='M462.449 273.053c-.003 0-1.142-.75-2.619-1.432-1.508-.693-3.626-1.007-3.637-1.01l-.07.477s.128.02.345.06c.655.121 2.11.426 3.166.914a21.871 21.871 0 012.556 1.397zm-.164-4.732c-.002 0-1.044-.075-2.157-.075-.769 0-1.567.035-2.113.163-1.276.316-2.11.963-2.127.975l.288.385.032-.023a5.82 5.82 0 011.923-.865c.457-.113 1.246-.157 1.997-.15a26.51 26.51 0 012.123.074zm-.548-4.066c-.005.004-2.638 1.242-3.86 2.052-1.21.801-2.478 1.843-2.481 1.845l.301.38s.312-.258.776-.616a28.12 28.12 0 011.663-1.205c.58-.381 1.537-.892 2.339-1.298a57.071 57.071 0 011.462-.717zm-2.536-4.183v.007c.001.091-.022 1.065-.494 1.814-.116.186-.487.636-.961 1.171-.715.804-1.672 1.84-2.455 2.672-.779.826-1.38 1.452-1.38 1.452l.342.34a271.81 271.81 0 002.211-2.34 135.9 135.9 0 001.637-1.798c.482-.546.85-.985 1.01-1.235.559-.901.566-1.94.568-2.075v-.007h-.478zm-3.307-1.869l.02.087c.037.177.11.614.11 1.198 0 .6-.08 1.357-.357 2.142-.32.922-.953 2.24-1.5 3.321-.275.544-.528 1.023-.712 1.376-.184.344-.298.553-.298.553l.414.24c.005-.007 1.869-3.403 2.547-5.33a6.949 6.949 0 00.384-2.302c0-.834-.142-1.392-.147-1.408zm-3.2-.385s.02.19.04.505c.022.32.043.757.043 1.24.002.898-.074 1.96-.338 2.69-.287.814-.68 1.882-1.004 2.746l-.566 1.522.446.17s.992-2.638 1.575-4.276c.295-.834.363-1.927.365-2.852 0-.996-.085-1.793-.085-1.797zm-2.466-.012s-.003.813-.054 1.824c-.049 1.012-.146 2.218-.32 2.967-.37 1.58-.758 3.857-.758 3.857l.47.083s.097-.57.238-1.332c.143-.758.333-1.717.514-2.496.374-1.618.385-4.891.387-4.9zm-2.663.433s.034.298.066.759c.033.461.066 1.074.066 1.696 0 .715-.047 1.441-.176 1.933-.389 1.479-.62 3.798-.621 3.804l.476.052c0-.004.056-.577.162-1.334.106-.755.26-1.695.445-2.397.15-.57.19-1.324.19-2.058 0-1.28-.13-2.506-.134-2.51zm-2.091.28s.007.094.007.273c0 .571-.05 1.951-.446 3.372-.266.947-.579 2.067-.831 2.947-.247.882-.43 1.524-.43 1.524l.46.136s.729-2.577 1.26-4.48c.412-1.484.46-2.903.46-3.499 0-.186-.002-.292-.002-.294l-.478.02zm-2.338.023s.013.106.03.285c.012.189.028.449.028.762.002.893-.124 2.189-.677 3.201-.468.853-1.349 1.687-2.115 2.29a15.031 15.031 0 01-.988.725c-.128.086-.232.151-.303.198l-.11.066.243.42c.012-.014 2.638-1.558 3.692-3.468.617-1.13.735-2.494.735-3.43 0-.66-.06-1.104-.06-1.112zm-1.437-.456s-.036.12-.103.322c-.206.61-.726 1.963-1.462 2.877-.487.603-1.288 1.24-1.962 1.71-.337.238-.644.43-.865.571-.221.138-.356.213-.356.215l.234.421c.01-.007 2.237-1.274 3.318-2.613 1.072-1.333 1.649-3.347 1.654-3.364zm-2.278-1.144l-.133.261c-.13.246-.339.63-.575.996-.236.372-.506.73-.726.923-.312.267-.931.663-1.457.972-.529.315-.971.555-.974.557l.225.428c.002-.004.453-.244.991-.565.539-.32 1.158-.711 1.524-1.028.384-.332.756-.907 1.05-1.408.294-.496.5-.921.5-.921zm-1.11-1.426s-.143.17-.373.434c-.35.397-.894.996-1.438 1.517a9.76 9.76 0 01-.783.684c-.24.187-.459.315-.584.353l.134.465c.31-.097.639-.338 1.006-.643 1.087-.928 2.399-2.49 2.4-2.496zm-.548-.958s-.133.107-.347.274c-.32.246-.826.619-1.333.921-.498.305-1.025.539-1.28.53h-.013v.484h.013c.309-.003.641-.13.992-.302 1.05-.522 2.261-1.53 2.268-1.53zm-.42-1.028c-.004 0-.532.306-1.142.62-.307.157-.63.318-.92.441-.283.123-.54.207-.656.219l.047.478c.222-.023.488-.12.794-.25.912-.387 2.108-1.09 2.115-1.09l-.24-.418zm-.504-2.126l-.05.053a5.19 5.19 0 01-.82.713c-.398.285-.887.527-1.33.527l.006.484c.688-.015 1.31-.388 1.777-.739a5.55 5.55 0 00.773-.72zm.176-3.342c-.002 0-.432.34-.906.79-.47.453-.984.99-1.175 1.483a.896.896 0 01-.14.19l-.104.088-.03.019h-.005l.007.029v-.03h-.007l.007.03v-.03.482c.23-.01.363-.136.476-.25.114-.127.195-.24.24-.354.113-.326.605-.876 1.06-1.301.226-.218.445-.412.608-.547.16-.138.265-.217.265-.217l-.297-.38zm16.403-19.616s1.076.006 1.756.006c.157 0 .29-.003.39-.003h.112l.035-.003h.02l.021-.004.036-.01.058-.026.058-.055.05-.145-.044-.14-.087-.074-.068-.026-.036-.003-.02.483.008-.188-.02.188h.012l.008-.188-.02.188.024-.23-.048.226.023.004.025-.232-.048.227.05-.237-.087.225.037.012.05-.237-.087.225.088-.225-.141.194.053.031.087-.224-.14.194-.055-.055.195-.14h-.238l.044.14.195-.14h-.238l.048-.145.095-.075.093.217-.027-.236-.066.019.093.217-.027-.237.017.16-.005-.16h-.012l.017.16-.005-.16h-.523l-1.752-.002-.005.484zm.058-1.437l.152.01c.34-.003.678-.14 1.024-.322.515-.277 1.048-.676 1.53-1.005.24-.163.47-.31.667-.41.196-.1.366-.153.47-.153l-.008-.486c-.303.009-.593.152-.909.336-.473.278-.991.674-1.49.997-.494.33-.975.565-1.284.555l-.088-.003zm-.198-2.302c.357-.048.73-.221 1.131-.447.597-.337 1.244-.797 1.837-1.171.588-.378 1.143-.653 1.44-.65l-.007-.485c-.345.01-.701.162-1.089.369-.576.314-1.22.77-1.824 1.157-.603.39-1.18.705-1.547.746l.06.48zm-.854-2.138c.575-.306 1.445-.977 2.349-1.676.901-.698 1.83-1.422 2.455-1.803l-.248-.415c-.667.407-1.595 1.135-2.496 1.833-.896.695-1.778 1.366-2.278 1.631l.218.43zm-1.612-2.442c1.145-.807 3.944-2.812 4.992-3.478l-.252-.41c-1.076.683-3.866 2.685-5.011 3.492zm-2.138-2.348c.755-.643 1.825-1.36 2.81-1.992.99-.63 1.888-1.18 2.338-1.514l-.28-.39c-.415.307-1.323.863-2.314 1.495-.992.637-2.07 1.359-2.858 2.03zm-1.682-1.449c0-.002 1.126-.82 2.353-1.688a97.855 97.855 0 011.786-1.238c.53-.358.969-.635 1.132-.711l-.198-.439c-.232.11-.657.382-1.198.746-1.612 1.085-4.153 2.936-4.156 2.938z'/%3e%3cpath d='M450.836 211.587l.29.233c.654.533 2.298 1.95 3.771 3.797 1.474 1.847 2.764 4.124 2.759 6.347 0 .213-.01.428-.035.638-.33 2.894-1.783 5.442-3.796 7.798-3.02 3.532-7.296 6.611-10.83 9.732-1.77 1.558-3.353 3.13-4.504 4.793-1.148 1.662-1.865 3.422-1.865 5.323 0 .087.003.173.006.259.06 1.749.626 3.662 1.717 5.204 1.092 1.542 2.72 2.72 4.867 2.934.356.036.718.05 1.08.05 2.76-.002 5.767-.882 8.635-.878 2.415.004 4.704.599 6.743 2.828 1.946 2.127 2.544 5.55 2.54 8.843 0 2.36-.3 4.647-.6 6.346a38.43 38.43 0 01-.601 2.794l.458.133c.004-.014 1.221-4.477 1.221-9.273-.004-3.35-.589-6.882-2.672-9.173-2.129-2.34-4.604-2.99-7.09-2.982-2.958 0-5.971.881-8.635.876-.35 0-.695-.015-1.032-.048-1.996-.202-3.497-1.276-4.526-2.728-1.03-1.456-1.572-3.29-1.63-4.947l-.002-.238c0-2.37 1.183-4.53 3.026-6.634 2.767-3.158 6.983-6.143 10.647-9.453 3.663-3.308 6.794-6.96 7.317-11.504.026-.23.04-.462.04-.693-.007-2.758-1.776-5.432-3.52-7.434a26.415 26.415 0 00-3.492-3.326l-.286.383z' fill='%2378732e'/%3e%3cpath d='M447.214 216.284l-.574-.494-.491.177.928.76zm1.542 1.46l-.43-.443-.225.127.356.468z' fill='%23a8ac71'/%3e%3cpath d='M450.906 220.115l-.368-.467-.225.29.375.43zm1.613 2.408l-.269-.48-.43.075.56.607zm.91 2.266l-.211-.658-.062.114-.039.5zm.106 2.278l.025-.626-.287-.177.038.86zm-.094 1.46l.063-.708-.187-.126.012.923zm-18.623 22.631s.05-.581.214-1.086c.158-.507-.46.238-.46.238l-.077.697.323.15z' fill='%2378732e'/%3e%3cpath d='M434.666 252.607l-.274.125.1.68.15-.214s.024-.381.024-.59z' fill='white'/%3e%3cpath d='M434.713 255.305l-.038-.664-.199-.075v1.082z' fill='%2378732e'/%3e%3cpath d='M434.889 256.812l-.064-.6-.21.032-.014.568zm.408 2.174l-.124-.581-.137.138.112.582zm.573 2.232l-.237-.784-.175.075.237.753z' fill='white'/%3e%3cpath d='M437.318 264.208l-.323-.487-.306-.05.393.594zm2.208 2.185s-.298-.177-.735-.53c-.434-.354-.173.329-.173.329l.623.33zm14.99 1.122s-.35-.239-.597-.353c-.25-.113.135.024.348.519.21.493.25-.166.25-.166z' fill='%23a8ac71'/%3e%3cpath d='M455.801 268.554s-.286-.363-.475-.49c-.186-.124-.122.377-.122.377l.385.166z' fill='white'/%3e%3cpath d='M456.059 269.15c-.16-.213-.334.316-.334.316l.459.431s.037-.529-.125-.747zm.07 2.068s.1-.44.074-.721c-.024-.276-.248.099-.248.099l.025.622z' fill='%23a8ac71'/%3e%3cpath d='M455.404 273.403l.175-.544-.224.006-.138.563zm-22.818-79.855s.86-.177.21.796c-.646.971.435-.871.435-.871l-.347-.102z' fill='white'/%3e%3c/g%3e%3cpath d='M451.082 210.98l.521.531s-.486-.127-.696-.152c-.211-.027.175-.38.175-.38z' fill='%23f9c83a'/%3e%3cpath d='M451.595 211.517s-.735.1-.994.138c-.262.037.298-.29.298-.29z' fill='%238f4620'/%3e%3cpath d='M460.755 278.613s.624-.065.904-.448c.277-.38-.178.6-.178.6l-.4.15-.326-.3z' fill='%23977c2e'/%3e%3c/svg%3e";

var img$1B = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2000 1000'%3e%3ctitle%3eFlag of Kazakhstan%3c/title%3e%3crect width='2000' height='1000' fill='%2300afca'/%3e%3cg id='sun' fill='%23fec50c' transform='translate(1080.4716%2c420)'%3e%3ccircle r='134.5497'/%3e%3cg id='r16'%3e%3cg id='r4'%3e%3cpath id='r' d='m0%2c-152.9c8%2c-0.1 11%2c-5.1 11%2c-11.1c0%2c-8 -11%2c-46.1 -11%2c-46.1s-11%2c38.1 -11%2c46.1c0%2c6 3%2c11.1 11%2c11.1z'/%3e%3cuse xlink:href='%23r' transform='rotate(90)'/%3e%3cuse xlink:href='%23r' transform='rotate(180)'/%3e%3cuse xlink:href='%23r' transform='rotate(270)'/%3e%3c/g%3e%3cuse xlink:href='%23r4' transform='rotate(22.5)'/%3e%3cuse xlink:href='%23r4' transform='rotate(45)'/%3e%3cuse xlink:href='%23r4' transform='rotate(67.5)'/%3e%3c/g%3e%3cuse xlink:href='%23r16' transform='rotate(11.25)'/%3e%3c/g%3e%3cg id='bird' fill='%23fec50c'%3e%3cpath d='M316.94%2c213.44c-1.08%2c0.06-2.13%2c0.2-3.16%2c0.53-1.41%2c0.19-2.76%2c0.68-4.16%2c0.91l-0.56%2c0.09-0.94%2c0.09c0.06%2c0.26%2c0.1%2c0.52%2c0.1%2c0.78%2c0%2c0.27-0.03%2c0.53-0.1%2c0.75-0.06%2c0.21-0.25%2c0.47-0.4%2c0.63-0.2%2c0.22-0.41%2c0.41-0.66%2c0.53-0.24%2c0.12-0.51%2c0.17-0.78%2c0.19-0.27%2c0.01-0.55%2c0-0.81-0.1-0.27-0.09-0.52-0.26-0.75-0.46-0.28%2c0.07-0.57%2c0.12-0.84%2c0.15-0.28%2c0.03-0.54%2c0.03-0.79%2c0-0.28-0.08-0.57-0.17-0.84-0.28s-0.53-0.25-0.78-0.41c-1.02%2c0.6-2.16%2c1.17-2.78%2c2.22-0.35%2c0.48-0.42%2c1.03-0.5%2c1.6-0.05%2c0.7%2c0.13%2c1.44%2c0.43%2c2.09%2c0.11%2c0.19%2c0.2-0.69%2c0.54-0.81%2c0.57-0.47%2c1.28-0.81%2c2-1%2c0.61-0.31%2c0.53%2c0.02%2c0.28%2c0.5-0.06%2c0.25-0.4%2c1.2%2c0.06%2c0.72%2c2.03-0.9%2c4.28-1.08%2c6.47-1.25%2c3.18-0.33%2c6.37-0.4%2c9.56-0.44%2c3%2c0.04%2c6%2c0.08%2c9%2c0.19%2c1.43%2c0.04%2c2.87%2c0.36%2c4.28%2c0.12%2c0.34-0.09%2c0.87-0.11%2c1.07-0.31-0.64-0.37-1.39-0.38-2.1-0.47h-5.72c-1.59-0.16-3.25-0.18-4.75-0.78-0.4-0.16-0.77-0.54-1.15-0.13-0.57%2c0.2-1.18%2c0.34-1.78%2c0.38-1.05%2c0.08-2.1-0.14-3.07-0.53%2c0.7-0.97%2c1.54-1.82%2c2.31-2.72-0.62-0.1-1.22-0.23-1.84-0.38%2c1.09-0.75%2c2.1-1.6%2c3.16-2.4z' transform='scale(3.3333333%2c3.3333333)'/%3e%3cpath d='m1212.2%2c746.01c-7.2452%2c4.3503-12.775-3.3623-18.831-5.6752-4.3249%2c2.3488-4.7288%2c10.208-8.7706%2c13.93-4.8342%2c5.5019-10.76-1.5363-10.318-6.9649-5.7825%2c4.8741-8.7067%2c15.922-18.057%2c14.446-4.4308-3.6151-7.7219-11.201-11.106-2.5636-2.7613%2c4.2221-10.11%2c10.229-13.916%2c3.8533-1.1784-5.6287-4.0008-12.25-7.0634-3.3078-2.1024%2c6.3247-8.8507%2c10.978-15.379%2c8.2088-3.5737-2.9216%2c2.8649-13.727-1.6841-12.958-6.7998%2c4.4958-10.753%2c15.658-20.242%2c14.764-3.6847-4.1359%2c2.236-11.144-1.8057-15.735-4.7711%2c6.1235-10.063%2c15.089-18.315%2c15.735-3.9884-3.2319%2c0.1571-12.501-2.3893-13.873-8.4677%2c5.0781-17.402%2c14.128-28.05%2c11.294%2c4.1497-15.873%2c21.49-21.442%2c36.072-22.68%2c25.089-3.0835%2c51.484%2c2.5863%2c75.624-6.469%2c3.9004-2.3734%2c13.35-5.7392%2c9.9847-11.244-2.9805-4.3463%2c7.7529-2.647%2c8.7855-7.7238-0.639-6.4302%2c4.9265-5.5452%2c10.364-6.108%2c24.376-1.0516%2c48.455%2c4.0818%2c72.758%2c4.9546%2c1.8358%2c11.842-11.301%2c20.157-21.876%2c16.5-5.0519%2c0.81828-12.627-11.615-11.142-2.5698-1.0183%2c4.7472-0.3056%2c11.017-4.6433%2c14.188m-207.4-24.248c5.6435%2c5.1653%2c9.6005-0.97254%2c14.875-3.2155%2c17.692-6.085%2c33.128-16.719%2c48.346-27.344%2c9.221-7.6305%2c17.214-17.525%2c29.597-20%2c24.155-7.303%2c49.832-6.4173%2c74.081-13.157%2c18.464-25.281%2c49.825-34.299%2c76.096-48.831%2c5.8991-1.8316%2c8.1781-6.6867%2c10.062-12.047%2c10.028-15.83%2c23.689-29.857%2c39.845-39.439%2c7.6441-4.1767%2c16.764-6.5825%2c25.418-4.6718-0.6201%2c10.307-6.5329%2c19.442-13.672%2c26.57%2c5.842-0.12861%2c10.863-3.8191%2c16.767-3.6114%2c2.0233%2c10.578-9.4007%2c16.114-15.478%2c22.7%2c3.3855%2c0.78754%2c16.353%2c1.7684%2c9.2865%2c5.1591-9.0054%2c6.2497-19.289%2c10.541-27.602%2c17.799%2c7.6694%2c1.3778%2c8.5436%2c3.0082%2c0.7445%2c5.782-4.2215%2c2.8617-12.341%2c3.8616-13.126%2c9.4374%2c5.7939%2c3.5608-2.6685%2c7.0964-5.933%2c8.2546-6.2414%2c1.4535-12.798%2c4.1652-4.5067%2c8.9071-3.1365%2c4.7384-9.8653%2c5.7486-15.356%2c5.2805%2c1.6661%2c5.3701%2c4.0776%2c11.378-2.8919%2c13.747-15.624%2c11.811-33.96%2c20.402-53.601%2c22.367%2c24.536%2c1.8866%2c49.807-2.668%2c70.773-16.011%2c2.768-3.2727%2c17.282-6.7896%2c9.1636-9.5419-3.822-1.5904-12.016-3.3567-12.57-6.2707%2c11.355-7.006%2c25.664-4.514%2c37.88-8.6758%2c0.3163-3.9551-9.2914-2.8547-12.874-3.7554-8.5427-0.69975-8.0417-2.8803%2c0.1954-3.6882%2c10.422-2.759%2c22.226-3.3028%2c30.993-10.098-7.1383-3.3066-16.116-0.39512-23.732-3.0955%2c12.911-5.6498%2c28.142-6.2167%2c39.726-14.704%2c5.2763-5.871-6.7598-4.0356-10.267-3.8931-7.1509%2c1.2447-10.456-2.1779-2.3324-5.1489%2c13.871-10.227%2c31.433-16.871%2c41.176-31.697%2c2.3078-3.3186%2c5.4328-13.319-1.9277-9.7216-9.681%2c3.2185-18.198%2c14.101-29.228%2c10.735%2c21.733-16.844%2c42.413-36.02%2c57.267-59.33%2c0.7674-6.7232-9.7852-7.4509-12.532-2.172-13.963%2c13.454-26.6%2c29.335-44.477%2c37.77%2c17.121-16.525%2c31.276-36.092%2c43.626-56.372%2c2.6476-6.0321%2c9.7642-13.286%2c5.9021-19.983-6.2255-5.1532-14.013-0.43606-17.248%2c5.7304-10.854%2c14.169-19.096%2c30.708-33.054%2c42.25%2c12.219-23.322%2c24.871-48.148%2c25.179-75.047-0.037-5.5382-1.1493-13.694-8.6693-12.659-5.9622%2c1.0681-4.5464%2c9.9912-7.0042%2c14.504-5.4111%2c18.377-7.9508%2c38.279-19.05%2c54.371%2c2.4971-14.934%2c6.8661-30.5%2c3.512-45.58-1.5667-6.7396-12.45-3.8412-11.048%2c2.8288-13.002%2c65.86-57.194%2c123.46-114.99%2c156.78-26.464%2c14.973-56.023%2c24.626-86.096%2c29.002-8.0899%2c1.7718-16.839%2c0.73198-24.572%2c3.4906-18.736%2c14.367-30.079%2c38.407-53.802%2c45.935-10.632%2c5.2835-24.496%2c6.3556-32.098%2c16.233-0.658%2c1.2632-0.7991%2c2.7266-0.7739%2c4.1273'/%3e%3cpath d='m1075.8%2c654.95c-3.5006%2c6.354-5.5592%2c13.658-10.06%2c19.347-13.541-12.321-33.171-11.914-50.347-12.734-14.177-0.75657-29.594-2.0646-40.563-12.176-11.539-9.452-20.958-21.724-33.852-29.393-11.769-3.2001-23.633-7.2042-33.095-15.271-20.22-16.482-31.8-40.937-51.558-57.933-3.7669-3.7078-8.209-6.5812-12.429-9.7268-4.0096%2c0.97695-2.1955%2c9.6311-7.1022%2c5.2194-2.6694-1.8995-9.348-2.0844-9.9492%2c0.56937%2c6.0404%2c7.96%2c12.087%2c17.049%2c12.924%2c27.23-4.1198%2c0.4224-11.445-0.87064-13.487%2c0.66378%2c5.4715%2c8.2003%2c12.484%2c15.473%2c20.452%2c21.263-3.8217%2c0.61454-11.353%2c0.27988-12.818%2c1.8198%2c7.9092%2c6.4462%2c16.391%2c13.034%2c26.747%2c14.69%2c2.12%2c2.7948-3.099%2c8.1901%2c1.2898%2c10.576%2c2.5458%2c1.0399%2c10.945%2c2.7801%2c5.1592%2c5.6751-3.9705%2c2.6755-2.4971%2c8.9111%2c2.5797%2c8.7706%2c3.2101%2c1.6391%2c10.418%2c2.0412%2c10.982%2c4.879-2.8453%2c2.8956-11.698%2c6.3288-4.1637%2c9.0409%2c7.039%2c3.904%2c15.067%2c6.4384%2c23.105%2c6.7168-4.0336%2c3.3936-9.004%2c5.3206-13.156%2c8.5127%2c18.55%2c10.877%2c39.113%2c18.03%2c59.433%2c24.919%2c8.0909%2c2.7031%2c16.274%2c5.2237%2c24.661%2c6.8102-24.369-1.4066-47.922-8.6212-70.116-18.495-11.503-5.0452-23.084-9.9197-34.873-14.265%2c5.1692-2.6897%2c11.148-3.3471%2c16.509-5.6751-11.128-2.2291-23.285-2.9605-33.067-9.0768%2c1.4997-2.6758%2c7.1829-2.8021%2c10.326-4.1642%2c5.9114-1.416%2c9.5779-3.1339%2c1.2438-3.6475-8.4057-2.2812-18.045-1.2576-25.452-6.3278%2c0.4769-3.04%2c8.2283-1.9813%2c11.386-3.2934%2c3.9751-0.683%2c8.3958-1.2548%2c11.573-3.9294-12.994-5.388-29.99-1.5707-40.168-13.046-2.3476-4.3712%2c7.2884-0.85006%2c10.033-1.5782%2c6.9723%2c0.00003%2c14.467%2c2.2158%2c21.107-0.59559-18.934-8.3124-39.215-16.095-53.655-31.471-1.6039-2.4716-6.4071-9.2249-2.5317-10.06%2c11.239%2c1.4869%2c19.374%2c13.753%2c31.396%2c11.844%2c1.5973-2.1526-6.9835-5.6809-9.1254-8.7582-17.528-15.041-34.541-31.364-46.825-51.066-0.84492-6.5792%2c9.4971-7.565%2c12.22-2.4832%2c13.405%2c12.911%2c25.514%2c27.977%2c42.209%2c36.791%2c5.9247%2c2.8724-3.4012-3.4-4.6433-5.6751-15.427-17.914-30.113-36.834-40.895-57.932-1.9299-3.8028-5.1284-10.686%2c0.64643-12.71%2c5.7722-2.8919%2c11.501%2c1.0476%2c14.428%2c6.0066%2c11.342%2c14.305%2c19.688%2c31.307%2c33.817%2c43.225-12.037-23.359-24.889-47.948-25.2-74.828%2c0.28226-5.2109%2c0.61728-13.092%2c7.6832-12.878%2c5.9331-0.89942%2c4.9962%2c6.696%2c6.941%2c10.318%2c5.845%2c19.747%2c8.3946%2c41.121%2c20.121%2c58.556-2.5904-14.649-6.4022-29.735-3.8694-44.627%2c0.58422-4.8898%2c6.0884-6.37%2c9.6818-3.4138%2c2.9046%2c7.11%2c3.5106%2c15.889%2c6.1574%2c23.491%2c15.06%2c51.519%2c48.875%2c96.832%2c92.941%2c127.24%2c36.292%2c24.891%2c79.362%2c39.749%2c123.32%2c42.341%2c3.9698%2c0.346%2c7.9556%2c0.46548%2c11.932%2c0.70954'/%3e%3ccircle cx='1020' cy='720.887' r='2.367'/%3e%3ccircle cx='1019.8' cy='720.507' r='0.965' stroke='%2300afca' stroke-width='0.38127393'/%3e%3c/g%3e%3cg id='ornament' fill='%23fec50c'%3e%3cg id='oh'%3e%3cg id='oq'%3e%3cpath d='m120%2c72.922s-9.6109-8.0762-12.874-4.0253c-5.2494%2c6.5154%2c16.14%2c38.968%2c16.14%2c50.396%2c0%2c18.759-12.517%2c23.861-27.973%2c26.539-10.371%2c1.7981-27.259-0.752-27.259-0.752%2c3.1796-4.2726%2c5.2478-5.5316%2c10.606-5.8731-5.9648-3.0968-12.039-9.8188-12.039-20.284%2c0-16.138%2c6.6434-22.789%2c6.6434-40.983%2c0-10.093-8.2759-22.941-8.2759-22.941%2c14.628%2c1.464%2c21.878%2c15.009%2c17.753%2c25.834%2c2.3286%2c0.33542%2c4.4428-0.18873%2c6.2586-1.9094%2c1.0706%2c3.0005-0.61945%2c6.4832-2.8834%2c9.4837%2c1.8233%2c0.97432%2c3.1624%2c0.39003%2c6.0661-0.20942-0.27536%2c3.0915-2.1278%2c6.3758-6.6597%2c9.4671%2c13.151-3.4144%2c21.243%2c5.7517%2c21.243%2c15.347%2c0%2c7.248-5.0791%2c12.443-10.044%2c12.443-1.6044%2c0-3.9611-0.66078-5.2908-1.6532-0.93725%2c1.9948-0.45429%2c4.6646%2c0.51121%2c6.6596-3.6388-0.96187-5.9484-3.1229-4.3043-7.6212-2.7948-0.25675-5.0181-1.2011-6.5305-3.0005%2c1.5323-1.9624%2c3.8568-3.0927%2c6.5305-3.0005-2.035-4.1994%2c0.23284-6.5505%2c3.5373-8.456%2c0%2c0-2.1015%2c8.4558%2c3.2654%2c8.4558%2c2.4133%2c0%2c4.6122-0.78561%2c4.6122-4.3421%2c0-3.097-2.7075-7.387-8.9659-7.1142-6.2586%2c0.27277-11.332%2c4.3152-11.332%2c14.306%2c0%2c9.2162%2c7.4334%2c13.8%2c17.229%2c14.096%2c8.8338%2c0.27277%2c15.501-4.5126%2c15.501-13.625%2c0-12.128-17.508-39.773-17.508-50.581%2c0-8.109%2c7.2922-12.635%2c14.427-12.635%2c9.2518%2c0%2c17.058%2c9.1612%2c17.058%2c9.1612l-5.4352%2c6.8146z'/%3e%3cpath id='op' d='m122.02%2c292.14c0%2c20.27-18.198%2c30.688-32.498%2c30.688-19.266%2c0-29.524-11.519-29.524-26.598%2c0-8.5475%2c1.5661-13.911%2c5.5074-22.092%2c0%2c0%2c31.78-66.091%2c44.153-91.653%2c1.543-3.1882%2c2.0408-6.8175%2c2.0408-12.138%2c0-8.2171-7.97-14.933-16.327-15.139-7.618-0.19053-15.918%2c7.1022-15.918%2c15.412%2c0%2c10.093%2c5.2358%2c14.593%2c10.612%2c14.593%2c6.6157%2c0%2c9.2518-2.7198%2c9.2518-7.3649%2c0-3.2366-1.5632-4.6371-3.8095-4.6371-5.6744%2c0-4.0817%2c7.6376-4.0817%2c7.6376-2.8183-0.617-5.1335-3.4965-3.8095-7.0921-2.0617-0.45904-3.9929-1.5413-5.5102-3.2733%2c1.5211-1.4747%2c3.266-2.6132%2c5.5102-3.0005-1.3289-4.3872%2c0.44687-6.5308%2c4.2857-7.433-0.77466%2c1.6876-0.80131%2c3.2401-0.54421%2c4.7054%2c6.0436-1.7186%2c15.306%2c1.0163%2c15.306%2c11.456%2c0%2c10.365-7.1935%2c19.093-20.681%2c16.912%2c3.2087%2c1.5341%2c4.8407%2c4.6732%2c5.1701%2c8.1832-2.4491-0.9547-5.1701-1.0911-5.1701-1.0911%2c1.577%2c2.7808%2c3.7672%2c5.1776%2c3.6734%2c10.638-2.5006-1.1368-4.8227-3.2419-8.0272-1.9094%2c5.0294%2c9.8968-1.1497%2c23.511-16.871%2c26.732%2c5.7537-6.7443%2c8.5714-14.027%2c8.5714-21.277%2c0-23.496-6.5305-27.445-6.5305-43.78%2c0-6.8343%2c3.5133-14.215%2c10.476-19.231v0.27276c-4.6021-1.2324-7.5502-3.4985-9.2447-6.5775%2c10.515-2.9816%2c25.799-2.9269%2c34.006%2c0.30202%2c9.434%2c1.0925%2c16.019%2c8.3308%2c17.959%2c12.004%2c1.9406%2c3.6708%2c5.7096%2c16.953%2c0%2c28.912-6.2487%2c13.088-35.711%2c75.559-44.897%2c95.198-1.9484%2c4.1654-3.1293%2c8.5827-3.1293%2c13.366%2c0%2c12.03%2c11.02%2c16.23%2c17.279%2c16.23%2c7.4829%2c0%2c15.102-5.7008%2c15.102-12.82%2c0-4.5112-2.4491-7.2285-5.9864-7.2285-8.4587%2c0-7.9449%2c7.1957-6.2586%2c11.729-5.2643-2.3667-8.3243-6.5917-7.4829-11.047-2.9805-0.40822-5.8174-1.822-8.4353-4.7735%2c2.0598-2.601%2c4.5722-4.5671%2c8.4353-4.6371-1.6873-6.9119%2c2.9406-9.8352%2c7.4829-11.456-1.437%2c5.0729-2.3803%2c10.911%2c6.2586%2c10.911%2c6.2986%2c0%2c11.258%2c1.0911%2c14.15%2c5.1827%2c0.17007-5.4553%2c0.68027-27.005%2c0.68027-27.005%2c0.36281-8.0977-10.839-7.8662-17.959-5.4554%2c2.6871-9.3276%2c8.1979-14.371%2c20.952-13.093-3.0953-1.2957-6.3946-4.2084-6.3946-9.8198%2c0.002-7.593%2c6.1621-16.005%2c10.206-18.492l2.022%2c79.051z'/%3e%3cuse xlink:href='%23op' transform='matrix(1%2c0%2c0%2c-1%2c0%2c645.08)'/%3e%3c/g%3e%3cuse xlink:href='%23oq' transform='matrix(-1%2c0%2c0%2c1%2c240%2c0)'/%3e%3c/g%3e%3cuse xlink:href='%23oh' transform='matrix(1%2c0%2c0%2c-1%2c0%2c1000)'/%3e%3c/g%3e%3c/svg%3e";

var img$1A = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect width='900' height='600' fill='%23d7141a'/%3e%3crect width='900' height='300' fill='white'/%3e%3cpath d='M 450%2c300 0%2c0 V 600 z' fill='%2311457e'/%3e%3c/svg%3e";

var img$1z = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 500'%3e%3crect width='800' fill='%2374acdf' height='500'/%3e%3crect y='166.67' width='800' fill='white' height='166.67'/%3e%3cg id='rays'%3e%3cpath id='ray1' stroke-width='1.1116' stroke='%2385340a' fill='%23f6b40e' d='m396.84 251.31l28.454 61.992s0.4896 1.185 1.28 0.8586c0.7902-0.3267 0.2988-1.5116 0.2988-1.5116l-23.715-63.956m-0.68 24.12c-0.3465 9.4278 5.4526 14.613 4.6943 23.032-0.7569 8.42 3.8673 13.18 4.9396 16.454 1.0733 3.2744-1.16 5.2323-0.198 5.6982 0.96336 0.4662 3.07-2.1207 2.3833-6.7756-0.68675-4.6549-4.2204-6.0368-3.3898-16.32 0.83-10.283-4.206-12.678-2.98-22.058'/%3e%3cuse xlink:href='%23ray1' transform='rotate(22.5 400%2c250)'/%3e%3cuse xlink:href='%23ray1' transform='rotate(45 400%2c250)'/%3e%3cuse xlink:href='%23ray1' transform='rotate(67.5 400%2c250)'/%3e%3cpath id='ray2' fill='%2385340a' d='m404.31 274.41c0.45334 9.0538 5.5867 13.063 4.5787 21.314 2.2133-6.5249-3.1233-11.583-2.82-21.22m-7.6487-23.757l19.487 42.577-16.329-43.887'/%3e%3cuse xlink:href='%23ray2' transform='rotate(22.5 400%2c250)'/%3e%3cuse xlink:href='%23ray2' transform='rotate(45 400%2c250)'/%3e%3cuse xlink:href='%23ray2' transform='rotate(67.5 400%2c250)'/%3e%3c/g%3e%3cuse xlink:href='%23rays' transform='rotate(90 400%2c250)'/%3e%3cuse xlink:href='%23rays' transform='rotate(180 400%2c250)'/%3e%3cuse xlink:href='%23rays' transform='rotate(270 400%2c250)'/%3e%3ccircle r='27.778' stroke='%2385340a' cy='250' cx='400' stroke-width='1.5' fill='%23f6b40e'/%3e%3cpath id='loweyecontour' fill='%23843511' d='m409.47 244.06c-1.8967 0.00003-3.7131 0.82183-4.7812 2.5312 2.1367 1.9227 6.8565 2.1318 10.062-0.21875-1.3883-1.4954-3.3845-2.3125-5.2812-2.3125zm-0.0312 0.4375c1.8462-0.0335 3.5717 0.81446 3.8125 1.6562-2.1367 2.3504-5.5508 2.1463-7.6875 0.4375 0.9348-1.4957 2.4391-2.0677 3.875-2.0938z'/%3e%3cuse xlink:href='%23uppalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3e%3cuse xlink:href='%23eyebrow_nose' transform='matrix(-1 0 0 1 800.25 0)'/%3e%3cuse xlink:href='%23pupil' transform='translate(18.862)'/%3e%3cuse xlink:href='%23lowpalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3e%3cpath d='m395.75 253.84c-0.91341 0.16668-1.5625 0.97727-1.5625 1.9062 0 1.0614 0.87748 1.9062 1.9375 1.9062 0.62667 0 1.2025-0.2968 1.5625-0.8125 0.73952 0.55614 1.7646 0.61511 2.3125 0.625 0.0843 0.002 0.19312 0 0.25 0 0.54791-0.01 1.573-0.0689 2.3125-0.625 0.36 0.5157 0.93583 0.8125 1.5625 0.8125 1.06 0 1.9375-0.84488 1.9375-1.9062 0-0.92898-0.64918-1.7396-1.5625-1.9062 0.513 0.1809 0.84375 0.6765 0.84375 1.2188 0 0.7074-0.57124 1.2812-1.2812 1.2812-0.6804 0-1.2413-0.54015-1.2812-1.2188-0.20862 0.41637-1.0341 1.6551-2.6562 1.7188-1.6222-0.0636-2.4476-1.3024-2.6562-1.7188-0.04 0.6786-0.60085 1.2188-1.2812 1.2188-0.71001 0-1.2812-0.57385-1.2812-1.2812 0-0.54225 0.33075-1.0378 0.84375-1.2188z' fill='%2385340a'/%3e%3cpath d='m397.84 259.53c-2.138 0-2.9829 1.9368-4.9062 3.2188 1.0687-0.42633 1.9096-1.2693 3.4062-2.125 1.496-0.85442 2.7717 0.1875 3.625 0.1875h0.0312c0.8532 0 2.129-1.0416 3.625-0.1875 1.4967 0.8559 2.3688 1.6987 3.4375 2.125-1.9233-1.282-2.7996-3.2188-4.9375-3.2188-0.4266 0-1.2716 0.23055-2.125 0.65625h-0.0312c-0.85334-0.42642-1.6983-0.65625-2.125-0.65625z' fill='%2385340a'/%3e%3cpath d='m397.12 262.06c-0.8439 0.0374-1.9596 0.20675-3.5625 0.6875 3.8473-0.85434 4.6962 0.4375 6.4062 0.4375h0.0312c1.71 0 2.5588-1.292 6.4062-0.4375-4.2744-1.282-5.1242-0.4375-6.4062-0.4375h-0.0312c-0.80125 0-1.4372-0.3124-2.8438-0.25z' fill='%2385340a'/%3e%3cpath d='m393.75 262.72c-0.24819 0.003-0.51871 0.005-0.8125 0.0312 4.488 0.42766 2.3306 3 7.0312 3h0.0312c4.7007 0 2.5745-2.5724 7.0625-3-4.7007-0.4266-3.2146 2.3438-7.0625 2.3438h-0.0312c-3.6075 0-2.4959-2.4215-6.2188-2.375z' fill='%2385340a'/%3e%3cpath d='m403.85 269.66c0-2.1234-1.7233-3.8465-3.8463-3.8465-2.1233 0-3.8463 1.723-3.8463 3.8465 0.423-1.781 2.0166-3.0393 3.8463-3.0393 1.8333 0 3.424 1.2586 3.8463 3.0393v0 0z' fill='%2385340a'/%3e%3cpath id='eyebrow_nose' fill='%2385340a' d='m382.73 244.02c4.9146-4.2729 11.11-4.9147 14.53-1.7086 0.837 1.1207 1.3733 2.319 1.5934 3.5696 0.4302 2.433-0.3303 5.0617-2.2367 7.7559 0.2151-0.001 0.6435 0.2124 0.8568 0.4266 1.6967-3.244 2.2967-6.5761 1.74-9.7454-0.1458-0.828-0.3735-1.643-0.6696-2.4357-4.7007-3.8452-11.11-4.2729-15.811 2.1377z'/%3e%3cpath id='uppalpebra' fill='%2385340a' d='m390.42 242.74c2.7767 0 3.4186 0.6417 4.7007 1.71 1.2833 1.0683 1.9233 0.8541 2.1367 1.0683 0.2124 0.2142 0 0.8541-0.4266 0.6399s-1.2833-0.6399-2.5633-1.7086c-1.2833-1.0696-2.5633-1.0683-3.8463-1.0683-3.8463 0-5.983 3.2046-6.4094 2.9907-0.4266-0.2142 2.1367-3.6325 6.4094-3.6325z'/%3e%3cuse xlink:href='%23loweyecontour' transform='translate(-19.181)'/%3e%3ccircle id='pupil' cy='246.15' cx='390.54' r='1.923' fill='%2385340a'/%3e%3cpath id='lowpalpebra' fill='%2385340a' d='m385.29 247.44c3.6327 2.7783 7.265 2.5644 9.4017 1.282 2.1367-1.282 2.1367-1.7086 1.71-1.7086-0.4266 0-0.8532 0.4266-2.5633 1.281-1.71 0.8559-4.273 0.8559-8.546-0.8541z'/%3e%3c/svg%3e";

var img$1y = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-4 -4 24 16'%3e%3cpath d='M20%2c12H-4V-4H20z' fill='%23d52b1e'/%3e%3cpath d='M4%2c4H20V-4H-4z' fill='white'/%3e%3cpath d='M4%2c4H-4V-4H4z' fill='%230039a6'/%3e%3cg id='f'%3e%3cg id='t'%3e%3cpath d='M0%2c-2V0H1z' fill='white' transform='rotate(18%2c0%2c-2)' id='o'/%3e%3cuse xlink:href='%23o' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(-72)'/%3e%3cuse xlink:href='%23f' transform='rotate(144)'/%3e%3c/svg%3e";

var img$1x = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1440 960'%3e%3cdefs%3e%3clinearGradient id='d' y2='277.58' gradientUnits='userSpaceOnUse' x2='601.38' gradientTransform='matrix(1.14637 0 0 1.17117 33.18 82.14)' y1='342.3' x1='597.92'%3e%3cstop stop-color='white' offset='0'/%3e%3cstop stop-color='%231ea8d1' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='e' y2='399.5' gradientUnits='userSpaceOnUse' x2='600.31' gradientTransform='matrix(1.14637 0 0 1.17117 33.18 82.14)' y1='326.43' x1='599.96'%3e%3cstop stop-color='white' offset='0'/%3e%3cstop stop-color='%23c1d3e8' offset='.13'/%3e%3cstop stop-color='%2388b0d5' offset='.3'/%3e%3cstop stop-color='%235998c6' offset='.46'/%3e%3cstop stop-color='%232c87bc' offset='.62'/%3e%3cstop stop-color='%23007db5' offset='.76'/%3e%3cstop stop-color='%230077b0' offset='.9'/%3e%3cstop stop-color='%230075af' offset='1'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='%23ed1c24' d='M0 0h1440v960H0z'/%3e%3cpath fill='%23034ea2' d='M0 0h1440v720H0z'/%3e%3cpath fill='%23fd0' d='M0 0h1440v480H0z'/%3e%3cg id='a' stroke='black' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath fill='%23b1babf' d='M452.3 476.58a.57.57 0 0 1-.11.18s-2.73 1.42-5.71 1.62c0 0-2.7 8.42-5.89 11 3.72-2.49 9.8-4.76 11.33-4.92.08-2.35.51-5.13 2.02-6l.22-.05a9.58 9.58 0 0 0-1.86-1.83z'/%3e%3cpath fill='none' stroke-width='.23' d='M442.15 487.98l10.95-10.45M451.94 484.32l-5.44-6.08'/%3e%3cpath fill='%23b1babf' d='M472.76 455.57l3.2 3.78-20.28 19.03h-1.26l-2.3-2.06.12-1.6z'/%3e%3cpath fill='none' stroke-width='.23' d='M454.08 476.66l19.83-18.34'/%3e%3cpath fill='%23b1babf' d='M478.97 217.63l8.48 8.02-2.18.92-8.36-7.9 2.06-1.04'/%3e%3cpath fill='%23034ea2' d='M509.97 317.7l11.08 10.95 5.2-12.53.99-7.69c-.78-22.02-.38-43.66-.38-43.66l3.26 2.84-12.44-12.45-7.33-7.2s-.14 46.32-.38 69.74z'/%3e%3cpath fill='%23ed1c24' d='M527.24 308.43l11-32.7-11.38-10.96s-.4 21.64.38 43.66z'/%3e%3cpath fill='%23fd0' d='M510.36 247.96l7.32 7.2c-13.33-13.35-28.93-29-36.85-37.02-1.46-1.48-1.8 31.9-1.64 69.12l30.79 30.44c.24-23.42.38-69.74.38-69.74z'/%3e%3cpath fill='none' stroke-width='.23' d='M534.98 272.44l-59.13-59.49'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M476.98 214.13c-.12-.06-.2-.11-.21-.14 0 0-1.68-3.45-1.86-7.2 0 0-10.18-3.55-13.26-7.6 2.96 4.7 5.6 12.38 5.76 14.3 2.86.15 6.22.75 7.26 2.66l.05.27c.84-.64 1.6-1.4 2.26-2.29z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M484.95 223.48l-2.6-2.65c-.2.6-.5 1.62-1 3.41-1.04 3.82-.23 16.62-.8 21.01s-1.63 10.41-1.74 12.99l-.02.16c-.03 3.05 1.12 6.8 1.12 6.8s1.83.94 2.14.12.46-7.2.46-8.52.38-2.08 1.52-8.4.61-9.9.16-13.75c-.46-3.85.76-11.17.76-11.17z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M480.06 218.04s-2.87 7.83-2.75 13.85c.11 6.01-.81 14.32-.93 15.56-.09.92-1.18 5.8-1.28 9.47-.04 1.3.29 1.16.59 1.93 0 0 1.98 1.24 3.1-.45l.02-.16c.11-2.58 1.15-8.6 1.73-12.99.58-4.39-.23-17.19.81-21 .5-1.8.8-2.83 1-3.42.2-.67.27-.79.27-.79l-2.56-2z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M487.82 216.7a86.75 86.75 0 0 1-7.84 1.64c6.5.13 9.11 4.02 9.11 4.02l2.2-2.65c1.96-3.24-1.74-3.59-3.47-3.01z'/%3e%3cpath fill='%23ed1c24' stroke-width='.23' d='M479.99 218.34l.17.33c.77 1.4 3.94 6.65 7.59 4.73l1.35-1.03s-2.6-3.9-9.11-4.03z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M480.53 218.34s6.41-3.56 7.3-3.53c.9.04 1.01 1.51 1.23 2.37s-.02 1.91-3.2 1.82c-3.16-.08-2.23-.43-5.33-.66z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M490.62 214.23c-.95-4.4-5.46-3.48-5.46-3.48-4.43.74-4.99 6.12-5.06 7.54l-.01.34c10.45-8.9 9 .21 9 .21 1.05-1.85 1.53-4.61 1.53-4.61z'/%3e%3cpath fill='none' stroke-width='.23' d='M462.2 200.03l13.75 15.31M467.41 213.52l7.57-6.7'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M480.04 203.82a2 2 0 0 0-.43-.46c.48 2.86.2 5.81-1 8.46a12.7 12.7 0 0 1-3.73 4.76c-3.45 2.64-8.22 3.26-12.77 1.43l.25.17c.38.25.77.5 1.17.72 7.19 4.06 15.19 2.52 17.87-3.43 1.6-3.55.95-7.88-1.36-11.65z'/%3e%3ccircle fill='%23e8b909' cx='477.02' cy='257.56' r='2.09'/%3e%3cpath fill='%23e8b909' d='M479.63 269.7c-2.96-.11-4.6-.28-6.53-.4.25-4.08.6-9.75 3.86-9.55 3.23.2 2.92 5.86 2.67 9.95z'/%3e%3cpath fill='none' d='M475.83 263.2s-.56 5.84-.61 6.18M477.45 263.26s.07 4.43-.28 6.26'/%3e%3ccircle fill='%23e8b909' cx='480.7' cy='263.46' r='2.09'/%3e%3cpath fill='%23e8b909' d='M484.04 275.42c-2.97.07-4.62 0-6.54 0 0-4.1 0-9.77 3.27-9.77 3.24 0 3.27 5.68 3.27 9.77z'/%3e%3cpath fill='none' d='M479.86 269.15s-.2 5.86-.24 6.2M481.48 269.12s.34 4.42.1 6.27'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1439.03 0)'/%3e%3cg stroke='black' stroke-width='.34'%3e%3cpath fill='none' d='M529.89 257.24c-3.95 1.18-6.94 3.1-11.21 3.63' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M511.32 264.35s-.4-8.1-.07-9c.32-.88 7.38-6.38 5.24-20.15 0 0-1.39-4.62-.67-5.76 0 0-6.12 11.66-6.62 15.14-.51 3.48.36 9.15.7 10.53.34 1.38.89 5.1.89 5.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M515.3 233.09c0 1.67-.57 3.39-.85 5.02-.28 1.62-.5 3.13-1.06 4.68-.71 1.98-1.68 4.03-2.05 6.08-.3 1.72-.3 3.47-.35 5.22M510.66 255.44c-.1-1.5 1.77-3.5 2.96-4.53M511.26 249.28c.44-1.09-.95-3.34-1.1-4.54M511.16 251.06c-.05-2.64 3.2-3.36 3.32-5.76M512.36 245.31c-.28-1.27-2.34-2.27-1.71-3.73' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M513.32 242.88c.26-.8.92-1.6 1.41-2.35.45-.67 1.32-1.16 1.64-1.86M514 240.05c.06-1.67-.48-3-.42-4.62' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M518.47 255.06c.02-2.97.41-4.65 2.81-6.48 2.1-1.6 4.84-2.35 5.73-4.98-.48.9-.28 2.07-.5 3.06a16.46 16.46 0 0 1-1.24 3.52 28.45 28.45 0 0 1-2.97 4.75' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M508 264.51c1.63-3.75 4.27-6.78 8.07-8.46 2.91-1.28 6.03-1.72 9.16-1.88 1.9-.1 3.67-.12 5.52-.73 1.34-.44 3.67-1.05 4.53-2.2-5.33 2.99-8.41 8.88-14.2 11.26-4.56 1.87-10.6.94-14.61 4.05' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M508.38 264.89c2.88-2.97 6.5-5 10.48-6.1 3.12-.86 6.65-1.9 9.44-3.6M518.98 259.15c.91.46 3 1.46 4.08 1.28M522.82 257.73c.95 0 2.54.75 3.32.38M519.74 258.51c-1.1-1.93 1.65-2.06 2.3-3.2' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M536.73 243.83c1-1.15.65-4.4 1.18-5.97.68-2.04 2.24-3.48 3.14-5.36-.82 1.85-.09 4.39-.74 6.35-.74 2.18-2.48 4.05-3.7 6' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M538.26 241.27c-.2-1.84 1.28-3.33 1.66-4.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M505.23 305.87c2.2 3.34 4.85 8.7 1.85 12.42-.65-.96-.71-2.81-1.75-3.48-.75-.48-2.12-.27-3.01-.65-2.39-1.01-1.93-3.59-3.53-4.88l-.38-.94 6.28-3.1.54.63z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M502.38 308.56c2.8 2.08 4.74 5.5 4.47 9.06M502 308.43c.8 1.92.11 3.38.28 5.2.08-.11.14-.24.23-.35M503.14 308.94c1.83 1.35 3.09 2.36 4.34 4.21' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M495.23 296.18c1.02-1.23 1.29-3.41 2.17-4.86 1.11-1.8 2.98-3.6 4.97-4.3a24.56 24.56 0 0 1 7.39-1.44c2.43-.1 5.25.96 7.32.76-4.26 1.56-9.49 1.75-13.41 4.19-2.56 1.58-5.13 4.24-7.16 6.45-1.7 1.84-2.13 3.9-3.07 6.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M495.36 297.71c1.04-2.53 3.19-5.73 5.4-7.4 2.2-1.7 5.08-2.71 7.88-2.56M497.14 294.39c1.44-1 3.37-1.94 4.6-3.2' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M505.44 288.1c1.35-1.52 3.25-1.39 4.98-1.63M493.57 305.11c.56-.75.85-1.72 1.3-2.58.63-1.18 1.47-2.19 2.28-3.27a43.6 43.6 0 0 1 5.23-6.02 14.55 14.55 0 0 1 6.4-3.43c2.2-.5 6.09.04 7.73-1.64-1.22 1.47-1.77 3.28-3.2 4.7-2.07 2.07-4.23 4.37-6.86 5.82-2 1.1-4.61 2.32-6.79 2.82-1.91.44-5.23.44-6.33 2.43.1.05.18.14.24.22.35-.23.71-.52 1.02-.84' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M494.85 302.56c1.13-.38 2.16-1.98 3.03-2.8 1.26-1.2 2.6-2.14 4.08-3.07a38.18 38.18 0 0 1 5.75-3.1c1.64-.69 3.23-1.3 4.63-2.4' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M500.97 297.33c1.35-.44 2.68-1.04 4.08-1.28.79-.13 1.73.03 2.43-.38M503.02 295.92c1.01-1.48 2.69-2.72 3.32-4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M524.72 254.04c1.75-2.38 3.82-4.09 6.17-5.93 1.56-1.24 2.77-2.91 4.66-3.68 5.01-2.05 10.55 1.9 15.69 1.81-2.23.97-4.19 2.37-6.6 2.98-2.4.61-4.77.97-7.27.99-4.41.04-10.25.1-12.78 4.47' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M527.66 251.49c2.9-.72 5.77-2.56 8.58-3.67 2.85-1.11 5.98-.52 8.78-1.44M536.15 247.91c1.85-.68 4.49.76 6.51.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M533.41 249.06c.92-.76 1.86-1.6 2.84-2.3.74-.51 1.78-1 2.01-1.91' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M504.58 280.18c2.1-.42 2.83-4.03 3.4-5.62.76-2.18 1.42-5.22 2.78-7.09.9-1.21 2.62-2.16 3.88-3.06 1.6-1.15 2.37-1.57 4.25-1.85 2.52-.38 5.2-.63 7.76-.65 2.3-.03 4.93.36 7.07-.73-2.34.78-4.69 2.75-6.11 4.61-2.23 2.92-3.66 5.6-7 7.7-2.97 1.89-6.64 2.77-10.01 3.8-1.92.58-5.12 1.27-5.6 3.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M507.61 277.54c3.65-3.69 5.16-9 10.73-10.47 3.4-.9 8.7-1.37 10.98-4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M510.51 274.11a6.2 6.2 0 0 1 4.31-1.79c1.64 0 3.37.41 4.88-.38M518.72 267.32c1-.37 2.02.25 3.03.26 1.05.01 1.88-.6 2.84-.77M515.4 268.34c.47-2 1.51-2.83 2.56-4.47' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M501.48 285.78c1.62-.1 2.35-2.1 2.85-2.98.7-1.18 1.34-2.87 2.46-3.85.74-.63 2.1-1.06 3.1-1.49a7.4 7.4 0 0 1 3.34-.78c1.93-.05 3.99-.03 5.94.12 1.76.13 3.75.52 5.43.04a11 11 0 0 0-4.88 2.23c-1.84 1.52-3.06 2.95-5.7 3.93-2.35.88-5.2 1.15-7.81 1.52-1.5.2-3.96.4-4.43 1.61' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M503.92 284.47c2.96-1.86 4.36-4.79 8.68-5.26 2.64-.3 6.69-.23 8.57-1.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M506.92 282.53a5.68 5.68 0 0 1 3.37-.74c1.25.1 2.55.45 3.74.1M512.87 279.37c.78-.14 1.53.27 2.3.34.8.07 1.46-.21 2.2-.26M510.29 279.74c.45-1.1 1.28-1.5 2.16-2.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M491.42 308.23s-13.45-14.3-6.2-32.03c0 0 .22 4.9.65 5.55.43.64 7.9 11.85 6.83 21.57-1.06 9.72-.53 5.77-.53 5.77l-.75-.86z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M491.42 307.05s-1.7-11.32-3.84-14.42c-2.14-3.1-2.46-9.6-2.25-10.78M487.57 291.36c.58-.73 1.21-1.5 1.28-2.46M489.5 296.16c.6-.8.7-1.84.96-2.67M489.28 298.4c-.7-.88-3.29-1.04-3.42-2.03M487.15 293.07c-.52-1.08-3.15-1.36-3.2-2.67M485.22 286.77c-1.01-.76-1.22-1.4-1.6-2.56M490.35 302.57c-1.02-1.16-2.16-1.54-3.31-2.24M490.46 300.11c.2-1.01 1.22-2 1.18-2.99' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M514.17 250.18s3.23-7.34 3.92-7.98c.68-.64 9.48-2.23 13.66-15.39 0 0 .8-4.72 1.95-5.39 0 0-10.68 7.48-12.68 10.32s-3.74 8.25-4.04 9.63c-.3 1.37-1.46 4.91-1.46 4.91' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M531.62 224.41c-.73 1.48-2.02 2.73-3 4.04-.96 1.3-1.83 2.54-3.02 3.64-1.52 1.43-3.3 2.8-4.54 4.43-1.08 1.43-1.87 3.07-2.73 4.64M517.52 242.01c.58-1.38 3.15-2.27 4.68-2.64M520.79 236.85c.88-.76.62-3.39 1.02-4.51M520.32 237.5c.81-2.35 5.55-.33 6.52-2.32M523.55 233.85c.31-1.25-1.1-3.08.11-4.08' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M525.49 232.15c.6-.6 1.54-1 2.31-1.42.7-.39 1.7-.42 2.3-.89M527.36 229.96c.79-1.45.9-2.88 1.67-4.27' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M496.94 255.01s.5-4.56.29-5.06c-.22-.5-5.3-3.6-3.36-11.35 0 0 1.14-2.6.64-3.24 0 0 4.22 6.56 4.5 8.53s-.5 5.15-.78 5.92c-.29.78-.79 2.87-.79 2.87' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M494.84 237.54c-.05.94.34 1.9.5 2.83.17.9.3 1.76.66 2.63.47 1.12 1.14 2.27 1.36 3.42.19 1.01.12 2.04.12 3.07M497.7 250.13c.11-.85-1.22-1.97-2.07-2.55M497.41 246.66c-.3-.61.79-1.88.93-2.55M497.49 247.12c.3-1.4-3.43-1.61-3.36-2.87M496.7 244.43c.24-.71 1.79-1.27 1.36-2.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M496.06 243.06c-.17-.45-.64-.9-.98-1.32-.31-.38-.95-.66-1.16-1.05M495.63 241.46c0-.94.43-1.7.43-2.6' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M496.44 275.23s.5-9.38.9-10.37c.41-.99 7.74-6.47 7.2-22.6 0 0-.82-5.48-.01-6.7 0 0-7.1 12.69-7.96 16.64-.86 3.95-.65 10.59-.48 12.22s.29 5.98.29 5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M503.64 239.7c-.17 1.92-.92 3.83-1.36 5.68-.44 1.83-.82 3.55-1.51 5.26-.9 2.2-2.04 4.44-2.62 6.76-.5 2.02-.67 4.14-.93 6.22M496.79 264.88c.07-1.75 2.07-3.81 3.32-4.86M498.03 257.86c.54-1.2-.54-3.96-.56-5.36M498.04 258.92c-.04-2.9 4.84-2.71 5.06-5.3M499.51 253.43c-.13-1.5-1.98-2.9-1.23-4.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M500.69 250.75c.33-.9 1.05-1.74 1.6-2.53.5-.72 1.4-1.18 1.77-1.95M501.64 247.56c.24-1.91-.13-3.52.1-5.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M495.94 265.35s-2.67-4.48-3.52-6.94c-.86-2.46-2.35-4.8-2.89-5.23s5.88 3.3 6.3 4.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M495.83 261.29c-.9-2.1-2.11-4.9-4.27-5.98M495.08 260.97c-.21-.94-1.26-1.61-1.92-2.14M494.87 259.26c-.26-.85-.42-1.84-.64-2.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M496.36 280.08s.75-9.72 5.13-12.28c0 0 4.27-2.14 6.08-3.84 0 0 2.57-3.53.96-1.28-1.6 2.24-2.67 14.73-2.77 15.48-.1.74-1.71 5.55-4.7 9.18s-4.38 5.87-5.02 7.16c-.64 1.28-1.18 4.7-1.18 4.7' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M495.94 291.19c1.61-1.34 1.94-3.46 2.67-5.37.8-2.1 1.74-4.07 2.05-6.28.33-2.27.9-4.27 1.82-6.37.94-2.16 2.7-3.76 3.82-5.69M500.72 280.47c1.4-1.93 2.96-1.98 4.72-3.2M498.57 286.26c.99-1.51 3.1-1.22 3.83-3.06M499.32 282c.57-2.07-1.24-3.22-1.66-5.1M501.41 276.03a7.24 7.24 0 0 1 0-6.26M496.89 274.22a23.85 23.85 0 0 1 2.04-7.8c.62-1.35 1.54-2.63 2.27-3.91.5-.9 1.15-2.18 2.08-2.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M503.27 259.4c-.1.48.6.77 1.13.49.04-.12.02-.23.04-.35.65.2 2.15.2 1.3-.78.6-.1 1.57-.67.74-1.18.48-.47.52-1.32-.02-1.77-.08.07-.17.17-.26.23-.04-.58-.55-.83-1.12-.7-.02.1.01.22-.01.31-.4-.27-.87-.3-1.27-.05.04.08.15.15.19.23-.36-.06-.53.13-.83.15.06.1.07.4.12.5.1-.01.1-.02 0-.02-.4.14-.67.43-.77.87.15.04.31.14.47.18-.76.22-.74.87-.08 1.13.1 0 .1 0 0-.01-.74.67.56.84 1 .26' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M611.07 383.12c.5.3.23 1.16 1.2 1.24.18-.5.33-.66.44-1.18-.29 0-1.43.17-.79.37' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M504.45 265.29c-.1.48.6.77 1.13.49.04-.12.02-.23.04-.35.65.2 2.15.2 1.3-.78.6-.1 1.57-.67.74-1.18.48-.47.52-1.32-.02-1.77-.08.07-.17.17-.26.23-.04-.58-.55-.83-1.12-.7-.02.1.01.22-.01.31-.4-.27-.87-.3-1.27-.05.04.08.15.15.19.23-.36-.06-.53.13-.83.14.06.1.07.4.12.5.1 0 .1-.01 0-.01-.4.14-.67.43-.77.87.15.04.31.14.47.18-.76.22-.74.87-.08 1.13.1 0 .1 0 0-.01-.74.67.56.84 1 .26' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M612.47 389.93c.44.31.2 1.2 1.07 1.28.17-.52.3-.68.4-1.21-.25 0-1.28.17-.7.38' stroke='none'/%3e%3cpath fill='none' d='M503.78 264.38c-4.63 2.68-8.54 7.49-7.4 13.15' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M513.74 252.13c3.73-1.83 4.71-6.08 8.2-8.14 2.27-1.33 4.95-1.71 7.5-2.2 1.8-.34 4.23-.66 5.3-2.37-1.6 1.95-3.47 3.46-5.27 5.18-1.9 1.8-3.5 3.32-6.12 4.09-2 .58-4.07.37-6.03 1.05-1.63.56-2.59 1.89-3.96 2.9l.38-.51z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M517.45 249.44c1.9-1.18 3.12-3.06 5.2-3.92 2.31-.96 4.92-1.18 7.19-2.2M520.26 247.11c1.68-.96 4.07 0 5.62-1.15M522.94 245.36c.85-.72 1.9-1.34 2.68-2.04M514.64 261.32c-2.1 1.01-6.44 1.68-7.28 4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M514.64 261.19c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.72-.61.44-1.13-.15 0-.33-.04-.47-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.85 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M624.46 386.4c.05 2.38 1.94-1.32.03-.12.03.19.21.16.26.27' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M522.3 267.32c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M633.24 393.57c.05 2.4 1.94-1.31.03-.1.03.18.21.15.27.25' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M517.57 270.77c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.17.64-.1.73-.6.45-1.12-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M627.82 397.6c.05 2.4 1.94-1.31.02-.1.03.18.22.14.27.25' stroke='none'/%3e%3cpath fill='%23ffdf4f' d='M619.34 399.85c.31.9 1.16 1.2 2.02 1.03l.17-.41c1.07.5 2.1-.28 1.37-1.37.74-.12.84-.72.52-1.32-.18 0-.38-.05-.55-.05 1.27-1.63-2.78-2.87-2.82-1.04-.76-.04-1.76.51-.91 1.06-.79.43-.97 1.7.05 1.95' stroke='none'/%3e%3cpath fill='%23de2126' d='M620.66 398.2c.04 2.39 1.93-1.32.02-.11.03.18.22.15.27.26' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M506.59 276.51c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M615.23 404.34c.05 2.39 1.94-1.32.03-.11.03.18.21.15.27.26' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M530.08 258.51c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M642.16 383.24c.05 2.4 1.94-1.31.03-.1.03.18.21.15.27.25' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M538.64 246c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.17.64-.1.73-.6.45-1.12-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M651.98 368.6c.04 2.38 1.93-1.32.02-.12.03.19.21.15.27.26' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M531.75 245.49c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M644.08 368c.04 2.38 1.93-1.32.02-.12.03.19.22.16.27.27' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M514.12 281.11c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M623.88 409.71c.04 2.4 1.94-1.31.02-.1.03.18.22.14.27.25' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M506.98 283.54c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M615.67 412.56c.04 2.39 1.94-1.32.02-.11.03.18.22.15.27.26' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M506.59 294.26c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M615.23 425.13c.05 2.38 1.94-1.32.03-.12.03.19.21.16.27.27' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M500.08 298.73c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67l.14.08' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M607.77 430.36c.05 2.39 1.94-1.32.03-.11.02.18.21.15.26.26' stroke='none'/%3e%3cpath stroke-width='.23' fill='%23ffdf4f' d='M520.13 253.4c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' d='M630.76 377.27c.04 2.39 1.93-1.32.02-.11.03.19.22.15.27.26' stroke='none'/%3e%3cpath fill='%2339b54a' d='M537.75 242.93c2.74-2.5 2.59-6.66 6.38-8.43 1.92-.89 4.22-1.43 5.83-2.76-2.95 5-7.02 8.71-12.21 11.19' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M537.11 243.19c1.87-.68 3.25-2.28 5.04-3.12 2-.93 3.69-.26 5.8-.45 2.1-.18 4.03-.72 6.01-1.4-3.8 5.2-11.86 1.37-16.6 4.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M539.28 241.15c1.69-.3 2.5-2.2 3.42-3.44 1.08-1.47 2.62-1.8 4.24-2.56M499.22 291.68c.95-1.32 1.79-2.83 2.94-3.96' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M492.65 309.16c.66-1.44.85-3.01 1.94-4.18 1.21-1.3 3.3-2.67 4.9-3.42 4.46-2.1 10.47-1.28 14.22-4.75-1.6 4.51-7.27 8.45-11.47 10.43-1.75.83-3.61 1.61-5.53 1.92-1.5.25-3.4-.08-4.83.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M492.9 309.28c1.45-.66 2.33-2.02 3.6-2.83a19.97 19.97 0 0 1 4.7-2.18c2.01-.64 4.1-1.27 6.05-2.12.74-.32 3.02-1.34 3.14-2.06M497.13 306.35c1.39.38 2.68 1.35 4.21.51M500.56 304.43c2.56.01 4.57.36 7.02-.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M497.37 306.15c.56-.58.65-1.43 1.11-2.08.45-.63 1.16-1.18 1.57-1.8M501.58 303.92c.53-.62 1.05-1.23 1.76-1.7.7-.45 1.81-.62 2.33-1.36M491.62 308.57c.27-1.81 1.58-3.13 2.34-4.71.48-1.03.93-3.06.98-4.17' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M493.27 305.39s.75-10.68.43-11.85c-.32-1.18-7.9-8.44-5.02-26.6 0 0 1.7-6.08.96-7.57 0 0 6.3 15.37 6.73 19.96.42 4.6-.75 12.07-1.18 13.89-.42 1.81-1.17 6.72-1.17 6.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M490.06 264.17c-.07 2.2.5 4.47.75 6.62.24 2.13.43 4.13.98 6.17.71 2.61 1.7 5.31 2.03 8.02.29 2.36.19 4.78.19 7.17' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M494.34 293.64c.17-1.99-1.82-4.61-3.1-5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M493.91 285.53c-.45-1.43 1.18-4.4 1.39-5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M494.02 286.6c.45-3.27-5.13-3.77-5.02-6.73' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M492.84 280.29c.36-1.67 2.67-2.98 2.03-4.91M491.88 277.09c-.26-1.06-.95-2.12-1.47-3.1-.46-.88-1.41-1.53-1.73-2.45M491.24 273.35c0-2.2.64-3.96.64-6.09' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cg stroke='black'%3e%3cg fill='%23009c4f' stroke-width='.43'%3e%3cpath d='M706.69 299.29c-.76-11.43-6.04-56.73-16.34-71.32 0 0 10 14.14 11.1 76.8l5.24-5.48z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M705.16 292.54c-5.62-35.75-25.08-67.02-25.08-67.02 7.35 15.13 20.25 53.84 23.64 77.45l2.33-2.23-.89-8.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M674.47 227.34c16.47 29.84 23.28 73.26 24.32 80.45l5.79-5.56c-5.35-33.64-30.11-74.89-30.11-74.89' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M664.8 224.38c2.81 4.74 15.4 29.58 20.51 43.94 4.15 11.63 8.35 32.79 10.21 42.73l7.13-6.85c-6.56-30.92-33.85-73.69-37.84-79.82' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M654.57 221.39s21.01 32.36 27.47 54.44c2.04 6.99 8.15 28.02 10.46 37.93l8.22-6.55c-6.51-19.03-26.9-67.2-46.15-85.82' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M654.81 240.03c10.93 14.65 29.6 49.29 34.66 76.94l9.45-9.09c-8.15-22.15-34.4-55.83-44.11-67.85' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M661.97 260.62c13.04 17.11 23.02 45.73 23.75 59.02l8.08-6.54c-8.23-22.02-31.83-52.48-31.83-52.48' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cg fill='none' stroke-width='.27' stroke-linecap='round'%3e%3cpath d='M823.61 452.48c-3-14.1-10.05-29.28-16.96-42.47M829.61 446.19c-6.6-19.32-18.14-41.61-31.06-61.33M827.66 427.33c-7.95-20.24-24.31-59.8-36.91-75.74M834.41 435.46c-5.7-21.77-18.3-50.74-25.06-64.4M836.36 428.87c-6-24.07-13.65-45.23-18.46-56.27M840.26 432.09c-1.8-19.16-11.7-51.05-19.2-67.76M838.16 408.17c-.75-9.35-3.75-28.67-5.85-37.1'/%3e%3c/g%3e%3c/g%3e%3cg id='b' fill='none' stroke='black' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath fill='%23b1babf' d='M486.92 512.12a.57.57 0 0 1-.11.18s-2.73 1.42-5.71 1.62c0 0-2.7 8.42-5.89 11 3.72-2.49 9.8-4.76 11.33-4.92.08-2.36.51-5.13 2.02-6l.22-.05a9.5 9.5 0 0 0-1.86-1.83z'/%3e%3cpath stroke-width='.23' d='M476.77 523.52l10.95-10.45M486.55 519.85l-5.44-6.08'/%3e%3cpath fill='%23b1babf' d='M527.78 478.26l-37.48 35.65h-1.26l-2.3-2.07.12-1.6 37.71-35.76 3.21 3.78'/%3e%3cpath stroke-width='.23' d='M488.69 512.19l35.19-33.01'/%3e%3cpath fill='%23fd0' d='M517.38 449.99c-24.76-15.59-28.8-63.2-28.43-69.69s.61-82.52.61-82.52l7.33 7.2c-13.33-13.35-28.93-29-36.85-37.02-2.54-2.57-.72 99.61-.72 144.98 0 21.28 13.27 96.33 91.1 58.56 0 0 38.9-13.96 50.25-30.8-2.65 0-5.27-.16-7.85-.49a41.85 41.85 0 0 1-3.78 1.78c-44.89 30.25-71.66 8-71.66 8z'/%3e%3cpath fill='%23034ea2' d='M488.96 380.3c-.38 6.5 3.67 54.1 28.43 69.69 0 0 26.77 22.25 71.66-8-13.57 5.6-24.65 6.78-31.91 4.63-21.7-6.41-44.65-31.48-48.31-56.84-3.67-25.37-2.75-75.2-2.75-75.2l3.25 2.85-12.43-12.45-7.33-7.2s-.23 76.02-.61 82.52z'/%3e%3cpath fill='%23ed1c24' d='M520.74 347.46c-.22-2.3-.38-10.48-.4-19.4-5.11-5.12.98 1.16-10.95-10.77l-3.32-3.41-.01 1.63c-.1 6.9-.61 50.93 2.76 74.27 3.67 25.37 25.99 50.44 47.69 56.85 7.26 2.15 18.96.97 32.54-4.63.91-.62 1.84-1.25 2.77-1.91-39.25-5.6-66.33-42.19-71.08-92.63z'/%3e%3cpath stroke-width='.23' d='M519.52 327.41l-59.13-59.49'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M458.98 264.71c-.91-.9-2-1.46-3.06-1.65.17-.7.07-1.32-.32-1.7-.83-.83-2.69-.3-4.15 1.17-1.46 1.48-1.97 3.35-1.14 4.17.4.39 1 .47 1.7.3a5.9 5.9 0 0 0 1.68 3.06c1.95 1.93 4.7 2.3 6.17.82 1.46-1.48 1.07-4.24-.88-6.17z'/%3e%3cpath d='M458.96 267.62l-.17-.33.17.33zM467.89 271.31l-1.35 1.03c.44-.23.9-.56 1.35-1.03z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M460.84 324.05c.3-1 .46-8.71.46-10.31 0-1.61.38-2.53 1.53-10.17 1.14-7.64.6-12 .15-16.66-.46-4.66 1-14.65 1-14.65l-2.85-2.08c-.19.72-.5 1.96-.99 4.14-1.04 4.62-.23 20.11-.8 25.43-.58 5.32-1.62 12.6-1.74 15.73l-.01.19c-.04 3.7 1.1 8.23 1.1 8.23'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M458.64 267.84s-2.66 8.44-2.54 15.72c.11 7.29-.81 17.35-.93 18.85-.11 1.5-2.08 11.8-.92 15.38l1.38 1.96s1.77-1.1 1.96-4.09v-.18c.13-3.13 1.17-10.4 1.74-15.73.58-5.32-.23-20.81.81-25.44.5-2.17.8-3.41 1-4.13.2-.82.28-.95.28-.95l-2.78-1.39z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M466.62 265.65a86.75 86.75 0 0 1-7.84 1.64c6.5.13 9.11 4.02 9.11 4.02l2.2-2.65c1.96-3.24-1.74-3.59-3.47-3.01z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M458.78 267.28l.17.33c.77 1.4 3.94 6.65 7.59 4.73l1.35-1.03s-2.6-3.9-9.11-4.03z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M459.21 267.21s5.1-5.28 5.96-5.5c.87-.24 1.4 1.14 1.86 1.9.46.77.53 1.84-2.52 2.68-3.06.84-2.27.24-5.3.92z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M467.66 260.33c-2.2-3.93-6.24-1.73-6.24-1.73-4.01 2-2.98 7.31-2.64 8.69l.1.32c7.4-11.56 8.66-2.42 8.66-2.42.47-2.09.12-4.86.12-4.86z'/%3e%3cpath fill='%23e8b909' stroke-width='.53' d='M558.44 469.55c.28-4.79.64-11.43-3.06-11.66-3.74-.23-4.14 6.4-4.42 11.23 2.2.16 4.08.36 7.48.49' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3e%3ccircle fill='%23e8b909' cx='455.52' cy='318.82' r='2.09'/%3e%3cpath d='M454.26 324.19s-.56 5.84-.61 6.18M455.88 324.26s.07 4.43-.28 6.26'/%3e%3cpath fill='%23e8b909' stroke-width='.53' d='M560.55 463.61s.39 5.17.12 7.34m-1.98-7.3s-.23 6.87-.27 7.26m5.07.08c-3.4.08-5.3 0-7.5 0 0-4.8 0-11.45 3.75-11.45 3.7 0 3.75 6.65 3.75 11.45z' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3e%3ccircle fill='%23e8b909' cx='459.27' cy='321.64' r='2.09'/%3e%3cellipse fill='%23c0cad0' stroke-width='.23' cx='452.96' cy='264.03' rx='1.97' ry='3.5' transform='rotate(44.76 452.94 264)'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M448.94 274.96s-2.8-1.6-3.08-4.92c-.19-2.32 1.43-4.41 2.44-5.48.47.33.87.53 1.07.54l.61-.36 2.16-2.23 1.36-1.34c.5-.63.86-1.15.87-1.36l-.2-.5c1.75-1.9 5.71-6.56 3.94-7.73-1.52-.98-6.03 2.68-7.56 3.99l-.74-.32c-.2.02-.57.27-1.02.64a31.9 31.9 0 0 1-3.12-10.4s-15.83-4.7-20.83-10.68c4.84 6.99 9.44 18.55 9.84 21.46 4.08.01 8.86.63 10.88 3.01-.29.38-.49.71-.5.87-.04.38.08.8.28 1.22a9.95 9.95 0 0 1-4.98 2.8c-3 .54-5.74-2.72-5.74-2.72h-.05a11.31 11.31 0 0 0-.52 3.4c0 6.14 4.84 11.1 10.8 11.1 1.5 0 2.92-.3 4.21-.87l-.12-.12z'/%3e%3cpath stroke-width='.23' d='M426.06 236.42l21.32 21.32M434.65 256.4l10.88-10.71'/%3e%3cpath stroke-width='.34' d='M446.18 260.15a3.37 3.37 0 0 1 3.44-3.3c1.83.07 3.27 1.64 3.21 3.51s-1.6 3.36-3.43 3.3a3.37 3.37 0 0 1-3.22-3.51z'/%3e%3cpath stroke-width='.27' d='M533 389.88c-.27 2.3.93 7.18 3.35 9.65s6.2 4.31 10.26 3.8' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(-1 0 0 1 1440 0)'/%3e%3cg id='c' stroke='black' stroke-width='.46'%3e%3cpath fill='%23fd0' d='M581.88 467.92c-6.19.17-17.65 1.6-17.65 1.6s-19.97 26.48-20.46 32.01c-.48 5.53-.48 10.1 12.76 8.18 0 0 6.4-1.21 11.69-1.6 5.82-1.9 6.46-.52 7.07-.12.47-2.02 1.6-6.86 2.96-12.5 2.7-11.14 6.28-25.38 7.35-26.87l.05-.38c-.33-.3-1.77-.38-3.77-.32z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23ed1c24' d='M587.08 458.22s-.29 1.86-.73 4.96l5.3 2.5s-.48 7.7-.72 12.27c-.16 3.02-2.2 23.76-3.58 37.5l-1.06 10.56c.28 4.22-3.06 8-3.06 8-2.23 2.18-3.33 3.97-3.68 5.42l-.11 1.24c.01.17.04.34.07.5.57 2.54 4.04 3.48 6.37 3.2 3.85-.49 11.07-5.1 11.07-5.1l.72-73.11-10.59-7.94z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23034ea2' stroke-linecap='round' d='M586.35 463.18c-.2 1.44-.45 3.15-.7 5.05.1.1.1.2-.01.33l-.05.06c-1.07 1.5-4.65 15.72-7.34 26.88-1.36 5.63-3.02 12.35-3.49 14.37-.57 1.25-10.67 12.84-10.86 16.6-.08 1.53 1.16 2.46 4.65 2.25 5.33-.32 9.05-1.3 11.69-1.95 3.32-.82 4.94-1.14 5.88.99l.18-1.75c.2-2.1.6-5.93 1.05-10.56 1.38-13.74 3.42-34.48 3.58-37.5.24-4.57.72-12.27.72-12.27l-5.3-2.5z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23ebc900' d='M574.87 507.48c-.42-.3-.12-1.38-7.42.68-1.63 7.31-3.55 18.31-3.55 18.31.03-3.72 7.8-11.38 10.06-14.85 1.13-1.75 1.44-3.26.91-4.14z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23023f88' d='M585.7 529.77l.51-2.01c-.95-2.13-2.59-1.8-5.96-.99-.18 4.42-.4 9.33-.68 12.68.35-1.45 1.45-3.27 3.71-5.44 0 0 1.7-1.43 2.42-4.24z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='matrix(-1 0 0 1 1435.18 0)'/%3e%3cg fill='%23452c25' stroke='black' stroke-width='.47'%3e%3cpath stroke-width='.58' d='M593.68 214.48s-8.43 19.15-5.51 21.05c0 0 8.54-14.87 16.05-20.5 3.9-3.6 6.27.04 6.77-3.13s-10.26-7.7-10.26-7.7l-6.9 9.49' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M562.94 229.06s-12.25 20.87-9.04 21.11c3.22.25 16.31-26.6 16.31-26.6l-4.46.74-2.81 4.75z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M566.64 223.25s-12.8 20.53-9.6 20.86c3.2.33 17.01-26.16 17.01-26.16l-4.48.63-2.93 4.67z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M569.23 219.67s-14.57 19.31-11.41 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.53.23-3.33 4.39z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M573.13 216.28s-17.07 17.15-14.02 18.19c3.05 1.04 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M573.74 210.04s-14.9 19.07-11.74 19.74 19.67-24.23 19.67-24.23l-4.52.15-3.41 4.34zM569.94 226.43s-14.57 19.31-11.41 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.52.23-3.34 4.39zM578.14 222.61s-8.53 15.72-7.56 16.37c.98.65 11.34-8.96 16.46-18.32s-9.27 1.56-9.27 1.56' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.58' d='M586.61 219.12s-8.43 19.15-5.51 21.05c0 0 10.56-11.55 13.32-20.73s0-.64 0-.64l-.76-9.97-6.9 9.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.58' d='M579.05 221.05s-8.43 19.15-5.51 21.05c0 0 10.56-11.55 13.32-20.73s0-.64 0-.64l-.76-9.97-6.9 9.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M574.68 219.38s-17.07 17.15-14.02 18.19 22.43-21.7 22.43-21.7l-4.51-.39-3.9 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M576.03 221.7s-17.07 17.15-14.02 18.19c3.05 1.04 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M577.39 224.42s-17.07 17.15-14.02 18.19 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9zM578.66 200.87s-12.68 15.85-10.85 18.58c1.83 2.73 13.4-7.28 17.07-14.3 3.65-7-6.1-4.8-6.1-4.8' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M578.26 217.71s-10.87 20.36-8.06 19.19c2.8-1.17 13.82-16.48 15.04-19.86 1.22-3.38.8-6.9.8-6.9l-8.4 5.06.71 3.94' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.4' d='M578.33 211.01s9.02-16.23-.06 3.06c-9.08 19.28-12.48 16.1-12.48 16.1-.7-1.1 7.9-14.17 7.9-14.17s6.38-10.05 7.9-11' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.43' d='M588 208.86s10.03-16.12-.02 3.06C577.92 231.1 574 227.86 574 227.86c-.81-1.12 8.78-14.07 8.78-14.07s7.13-9.97 8.85-10.9' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M588.39 209.96s-10.13 21.1-7.8 22.65c0 0 8.4-9.48 10.6-17.02 2.19-7.53 0-.52 0-.52l2.8-13.56M598.82 205.26s-10.13 21.1-7.81 22.65c0 0 8.41-9.48 10.6-17.02 2.2-7.53 0-.52 0-.52l2.82-13.56' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M584.32 202.05s-12.68 15.85-10.85 18.58c1.83 2.73 13.4-7.28 17.07-14.3 3.65-7-6.1-4.8-6.1-4.8' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cg fill='%23c69024' stroke='black' stroke-width='.53'%3e%3cpath fill='%23b1babf' stroke-width='.46' d='M682.1 459.3c0 2.91-.97 3.47-.97 3.47H532.06v-6.64h149.08s.97.26.97 3.17z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23b87510' d='M655.42 620.46c0 1.17.02 2.32.07 3.48h126.56a90.35 90.35 0 0 0-.02-7.55H655.5c-.06 1.35-.1 2.7-.1 4.07z'/%3e%3cpath fill='%23b76e11' d='M655.51 616.38h126.52c-.08-1.91-.22-3.8-.42-5.68H655.93c-.2 1.87-.34 3.77-.42 5.68z'/%3e%3cpath fill='%23ac620e' d='M655.94 610.69h125.68c-.2-1.88-.45-3.74-.76-5.58H656.7c-.31 1.84-.57 3.7-.77 5.58z'/%3e%3cpath fill='%23a2550b' d='M776.82 599.51h-116.1c-2.33 0-3.7 3.7-4.02 5.58h124.15c-.32-1.88-1.81-5.58-4.02-5.58z'/%3e%3cpath fill='%23b76e11' d='M655.91 630.01h125.72c.2-2 .35-4.02.42-6.07H655.5c.08 2.05.22 4.07.42 6.07z'/%3e%3cpath fill='%23ac620e' d='M656.56 634.94h124.43c.26-1.62.47-3.27.65-4.93H655.92c.17 1.66.38 3.3.64 4.93z'/%3e%3cpath fill='%23a2550b' d='M660.71 640.2H776.8c2.28 0 3.9-3.48 4.18-5.25H656.55c.28 1.78 1.72 5.25 4.15 5.25z'/%3e%3cpath d='M671.4 640.34c-1.14-3.61-1.95-12.01-2.09-20.9-.13-8.9 2.56-20.28 2.56-20.28h-6.27s-2.7 11.39-2.56 20.28c.14 8.89.95 17.29 2.1 20.9h6.26zM766.43 640.4c1.15-3.61 1.95-12.01 2.09-20.9.13-8.9-2.56-20.28-2.56-20.28h6.27s2.7 11.39 2.56 20.28c-.14 8.89-.95 17.29-2.1 20.9h-6.26zM708.86 640.34c-.94-5.4-1.05-12.53-1.05-20.9s.89-17.9 1.52-20.28h-6.27c-1.1 3.55-1.51 13.04-1.51 20.28 0 7.24.2 15.68 1.04 20.9h6.27zM728.44 640.34c.94-5.4 1.05-12.53 1.05-20.9s-.89-17.9-1.52-20.28h6.27c1.1 3.55 1.51 13.04 1.51 20.28 0 7.24-.2 15.68-1.04 20.9h-6.27z'/%3e%3cpath stroke-width='.55' d='M686.12 620.17c3.7 6.65 11.28 20.39 11.28 20.39l5.3-.16s-3.09-6.54-11.43-20.63c-8.35-14.1-13.94-20.82-13.94-20.82l-5.3.15s10.39 14.42 14.09 21.07zM751.71 620.17c-3.7 6.65-11.28 20.39-11.28 20.39l-5.3-.16s3.09-6.54 11.43-20.63c8.34-14.1 13.94-20.82 13.94-20.82l5.3.15s-10.39 14.42-14.09 21.07z'/%3e%3cpath stroke-width='.55' d='M749.23 620.17a8113.7 8113.7 0 0 1 11.28 20.39l5.3-.16s-3.09-6.54-11.43-20.63c-8.35-14.1-13.95-20.82-13.95-20.82l-5.3.15s10.4 14.42 14.1 21.07z'/%3e%3cpath fill='%23b1babf' d='M634.54 627.22s2.77-13.45-1.63-21c-4.4-7.56-10.11-9.77-11.42-9.22-1.3.55 14.02-22.67 30.33-.37 0 0-14.35 1.66-11.41 29.67'/%3e%3cpath fill='%23d3dce0' d='M623.71 597.01c4.45-4.96 14.81-12.42 25.97.29a8.1 8.1 0 0 1 2.13-.67c-16.3-22.3-31.62.92-30.32.37.37-.16 1.08-.1 2.01.24l.21-.23' stroke='none'/%3e%3cpath fill='%23b1babf' d='M631.92 622.28a27.8 27.8 0 0 0-8.4 4.62s-10.85-5.92-17.86-6.51c-.6-.05-1.19-.14-1.72-.1.55-.1 1.13-.15 1.7-.28 7.12-1.64 15.85-5.45 17.75-6.93 2.55 2.59 5.9 5.23 8.63 5'/%3e%3cpath fill='none' stroke-width='.4' d='M605.71 620.21h26.48M623.45 612.98l.1 13.7'/%3e%3cpath fill='%23b1babf' d='M640.52 627.22c-.2 4.17-1.38 7.37-2.8 7.37-1.44 0-2.63-3.3-2.81-7.56'/%3e%3cpath fill='%23b1babf' d='M631.2 613.4h13.05v13.64H631.2z'/%3e%3cpath fill='none' d='M633.81 616.12h7.83v8.18h-7.83z'/%3e%3cpath fill='none' d='M636.16 618.58h3.13v3.27h-3.13zM649.58 597.36l.3-.1c1.21-.53 2.03-.63 2.03-.63-16.31-22.3-31.63.92-30.32.37.34-.15 1-.1 1.86.2.05 0 .16.08.21.1'/%3e%3cpath fill='none' stroke-width='.27' d='M649.56 597.28c-11.26-12.77-21.7-5.04-26.06-.09'/%3e%3cpath stroke-width='.55' d='M688.61 620.17c-3.7 6.65-11.28 20.39-11.28 20.39l-5.3-.16s3.09-6.54 11.43-20.63c8.35-14.1 13.94-20.82 13.94-20.82l5.3.15s-10.39 14.42-14.09 21.07z'/%3e%3c/g%3e%3cg%3e%3cpath fill='url(%23d)' d='M631.37 476.35c0 62.57 39.41 113.29 88.03 113.29s88.04-50.72 88.04-113.29c0-62.57-39.42-113.3-88.04-113.3s-88.03 50.72-88.03 113.3'/%3e%3cpath fill='%23395054' stroke='black' stroke-width='.46' d='M641.6 329.09c3.35-2.15 6.54-2.11 10.55-3.38 2.79-.88 6.16-1.05 8.87-1.69 2.47-.58 9.95 4.32 12.45 5.07l.17 6.8s-12.4 1.3-16.82-.38c-4.42-1.67-15.22-6.84-15.22-6.84' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23006c3c' d='M683.24 486.82c1.6 1.33.26 1.9-.67 2.99-.53.62 3.06 3.39 6.9 4.6a5.2 5.2 0 0 1 2.93 2.31c.53.81 1.72 1.63 3.58 2.98 1.85 1.36.4 1.77 4.78 1.9 4.37.14 6.1 1.22 7.83 1.63 1.72.4 2.78.68 7.03 1.22 4.25.54 19.3-.04 18.9.1-.4.13-10.55 2.27-11.48 2.81-.93.55-5.7-.6-6.63-.06-.92.54-1.85 1.35-2.91 2.17-1.07.8-.27 1.08.8 1.35s2.25.54 4.1 1.5c1.86.94 1.86 1.08 5.98 1.62 4.11.54 2.52 0 6.37.81 3.85.82 2.92.55 7.3.68 4.38.14.93.54 6.63.14 5.71-.41 4.38-.27 6.64-.27 2.25 0 2.26-.41 4.78-.55s4.3 3.84 1.77 3.84 1.98-.8.26-.67c-1.73.14-6.28-.32-7.2.22-.94.55-1.87 1.63-4.39 3.53-2.52 1.9-.53 2.85.27 3.39s1.99.81 3.05 1.22c1.06.4 2.12.27 5.44 1.49 3.32 1.22 4.12 1.36 6.24 1.49 2.12.14 5.18.95 5.18.95s4.1 1.76 6.23 1.9c2.13.13 1.33.54 3.98 1.76 2.66 1.22 2.52.27 4.65.27 2.12 0 2.92.27 4.11 1.09 1.2.8 2.92 1.49 2.92 1.49s-.93 2.57-9.69 17.08c-8.75 14.51-22.3 23.19-32.24 28.88-9.96 5.7-22.96 6.37-41.28 4.47-18.31-1.9-36.1-20.74-43.8-30.5a68.07 68.07 0 0 1-10.74-19.53l1.59-.13c.93-.14 1.86-.27 3.32-.54 1.46-.28 1.33-.14 3.05-.55s2.26-.4 3.85-1.08c1.6-.68 1.06-.95 3.58-1.63s1.73-.54 2.39-.68c.66-.13 1.73-.27 3.18-.81 1.46-.54 3.19-1.35 1.6-2.17s0-.95 0-.95 1.72.14 4.11.27c2.39.14 1.46.4 3.05.54 1.6.14 1.46 0 2.66-.27 1.2-.27-.27-1.62-.53-2.98-.27-1.36-.93-.54-1.46-1.09-.53-.54-1.06-.27-2.79-1.35-1.73-1.09-1.2-.14-4.91-1.36-3.72-1.21-.39 1.1-5.03-.26s-2.07.95-5.92-.27-5.1-3.94-1.52-3.4 1.06-.13 1.45-.68 1.07-.13 3.19-.27c2.12-.13 1.86 0 3.85-.13 1.99-.14 2.79-.68 2.79-.68s1.72.68 2.91.68.8-.27.8-1.09 1.2 0 2.12.27c.93.27 3.19-.13 3.19-.13s1.06-.14 3.05-.14c2 0 .8-.4 2.66-1.08 1.85-.68 0-1.36-.67-1.5-.66-.13-.8-.4-1.72-1.21a7.9 7.9 0 0 0-2.9-1.71c-1.2-.41-8.19.52-9.91-.02s-1.66-2.75 1.8-2.88c3.44-.14 1.32 0 3.04 0s1.33.27 2 .27c.66 0 1.32 0 4.1-.41 2.8-.4 1.6-.54 3.46-1.36s3.85-.54 5.44-1.22c1.6-.67-.66-1.35-2.65-2.3-2-.95 0 .54-1.46-.95-1.46-1.5-8.88-5.85-11.14-7.88-2.08-1.87 1.8-1.17 3.75-2.07 0 0 .84-1.97-1.33-2.71s-1.93-.74-4.22-1.6-3.38-2.47-5.07-2.84c-1.69-.37-2.53-.86-2.53-.86'/%3e%3cpath fill='%236dbe45' d='M683.24 486.82c-1.02.76-1.02 1.8-.67 2.99.24.79 1.77 4.1 5.62 5.32 1.6.5 3.67.78 4.2 1.59.53.81 1.73 1.63 3.59 2.98 1.85 1.36.4 1.77 4.78 1.9 4.37.14 6.1 1.22 7.83 1.63 1.72.4 2.78.68 7.03 1.22 4.25.54 18.52.17 18.13.3-.4.14-12.76 2.72-13.7 3.26-.92.54-2.7-1.26-3.64-.71-.92.54-1.85 1.35-2.91 2.17-1.07.8-.27 1.08.8 1.35s2.25.54 4.1 1.5c1.86.94 1.86 1.08 5.98 1.62 4.11.54 2.52 0 6.37.81 3.85.82 2.92.55 7.3.68 4.38.14.88 1.06 6.59.66s3.78.09 6.04.09 2.9.67 5.43.53c2.52-.13 8.46 1.65 5.94 1.65-1.57 0-4.02-.72-6.79-.5-1.73.13-3.41-.26-4.34.28-.93.54-1.86 1.63-4.38 3.53-2.52 1.9-.53 2.84.27 3.39.8.54 1.99.81 3.05 1.22 1.06.4 2.12.27 5.44 1.49 3.32 1.22 4.11 1.35 6.24 1.49 2.12.13 5.17.95 5.17.95s4.12 1.76 6.24 1.9c2.12.13 1.33.54 3.98 1.76 2.66 1.22 2.52.27 4.65.27 2.12 0 2.92.27 4.11 1.09.75.5 1.7.96 2.32 1.23 0 0 5.47-15.31 7.6-21.97 2.12-6.66 4.39-25.9 4.39-27.06 0-1.16-3.12-2.9-4.11-2.6-.99.28-5.24.28-6.52.28h-17.85c-1.13 0-1.98.87-4.1-.14-2.13-1.01-5.95-1.6-7.23-1.45-1.27.15-6.52.3-7.65.3-1.13 0-13.74-.59-15.86-.44s-6.1.14-8.65 0c-2.55-.15-5.8-.15-7.08-.3-1.27-.14-5.95-.43-7.08.44-1.14.87-4.25 1.16-5.67 1.45s-5.24 1.01-7.22 1.16c-1.99.14-7.8 1.3-9.63 1-1.85-.28-8.11-.3-8.11-.3'/%3e%3cpath d='M683.24 486.68c-1.18 1.03-1.03 2.53-.43 3.86a9.08 9.08 0 0 0 5.38 4.72c1.31.45 2.94.5 4.05 1.41.36.29.63.76.98 1.08.62.56 1.32 1.04 2 1.53a10.5 10.5 0 0 1 1.92 1.7c.5.58 1.33.6 2.02.67 1.66.15 3.31.13 4.96.43 1.18.2 2.32.6 3.45.98 1.89.63 3.9.93 5.85 1.22 4.7.69 9.44.62 14.17.6l4.38-.02c.3 0 1.53-.2 1.78.02v-.27c-.24.15-.65.16-.92.22l-2.53.55c-2.15.47-4.3.95-6.45 1.45-1.34.32-2.7.6-3.99 1.12-.86.34-2.15-.82-3.03-.9-.61-.06-1.38.75-1.83 1.09-.66.5-1.5 1-1.98 1.7-.68 1.02 3.24 1.67 3.73 1.85 1.06.4 2.03 1 3.06 1.45.91.4 1.91.54 2.88.7 2.28.34 4.6.37 6.85.8 2.33.43 4.46.85 6.83.88 1.23.02 2.51-.03 3.72.25.4.1.74.36 1.15.46 1.06.27 2.33.06 3.4-.02 1.3-.08 2.6-.2 3.91-.14 1.29.06 2.72.2 3.98.4 2.56.43 5.11.32 7.65.93.78.2 1.66.38 2.36.81.13.08.08-.06-.03-.03-.14.05-.32.03-.46.04-.78.01-1.58-.14-2.34-.25a33.94 33.94 0 0 0-5.38-.23c-1.48.02-2.8-.25-4.04.7-1.02.8-1.96 1.69-2.96 2.48-.7.55-2 1.25-2.03 2.3-.04 1.75 2.5 2.49 3.75 2.9 1.3.43 2.6.67 3.9 1.02 2.13.56 4.13 1.54 6.29 1.99 1.82.38 3.7.37 5.52.75 1.04.21 1.97.47 2.95.86 1.67.66 3.44 1.33 5.24 1.5 1.71.15 2.87 1.27 4.43 1.95 1.7.75 3.3.03 5.1.1 2.13.08 3.65 1.45 5.53 2.3 1.16-3.24 2.3-6.48 3.44-9.73 1.6-4.58 3.41-9.19 4.63-13.9 1.25-4.82 1.94-9.81 2.64-14.74.5-3.5 1.03-7.01 1.28-10.53.1-1.33-1.33-2.1-2.34-2.6-.9-.44-1.54-.4-2.47-.29-1.28.16-2.6.15-3.88.16-3.4.05-6.8.01-10.21.01h-6.54c-1.21 0-2.54-.15-3.74.1a5.3 5.3 0 0 1-3.69-.37c-1.41-.64-3-.94-4.52-1.17-2.18-.33-4.42-.01-6.62.06-3.63.12-7.23-.05-10.86-.18-4.43-.17-8.81-.05-13.23-.07-3.3-.01-6.61-.17-9.9-.32-2.25-.1-4.47-.4-6.72-.1-1 .14-1.72.72-2.65 1.04-1.35.45-2.8.58-4.19.82-2.55.45-5.07 1-7.65 1.22-3.13.26-6.46 1.43-9.6.98-2.61-.38-5.33-.28-7.95-.3-.02 0-.02.27 0 .27 3.94.02 7.94.6 11.85.11 5.1-.64 10.13-1.47 15.19-2.31 1.2-.2 2.55-.4 3.59-1.1.88-.6 2.17-.56 3.17-.6 2.4-.07 4.8.25 7.18.31 3.37.1 6.73.3 10.1.24 1.84-.04 3.66-.13 5.51-.1 4.11.1 8.22.31 12.33.43 4.25.12 8.41-.7 12.6.28 1.44.33 2.76 1.13 4.2 1.36.93.14 1.8-.33 2.73-.33h16.62c1.64 0 3.27 0 4.91-.05.96-.03 1.89-.1 2.83-.27 1.02-.18 2.36.79 3.1 1.38 1.25 1 .72 2.49.56 3.89-.26 2.29-.56 4.57-.87 6.86a149.06 149.06 0 0 1-2.7 15.41c-1.17 4.7-3 9.28-4.6 13.83-1.16 3.35-2.34 6.7-3.53 10.03-.02.05-3.24-1.8-3.62-1.95a7.49 7.49 0 0 0-4.23-.2 4.7 4.7 0 0 1-3.22-.44c-1-.44-1.86-1.3-2.89-1.62-1.1-.34-2.32-.31-3.44-.63a34.74 34.74 0 0 1-3.48-1.24 19.53 19.53 0 0 0-5.88-1.14c-2.82-.19-5.29-1.35-7.96-2.14-2.22-.66-4.63-.83-6.62-2.14-.36-.23-.7-.46-1-.76-.99-.98.6-2.06 1.28-2.58 1.15-.87 2.21-1.86 3.34-2.77 1.07-.87 2.27-.75 3.59-.7 1.97.05 3.85-.06 5.83.22.36.05 3.21.79 2.94-.18-.1-.39-1.39-.62-1.68-.7-1.19-.36-2.41-.6-3.64-.73-1.3-.15-2.58 0-3.88-.24-1.2-.22-2.35-.28-3.55-.38-1.32-.1-2.53-.22-3.89-.15-1.87.1-3.82.54-5.58-.24-.85-.38-1.96-.31-2.86-.34-1.19-.03-2.37 0-3.55-.08-2-.15-3.91-.82-5.9-1.05-2.12-.24-4.24-.36-6.36-.73-1.83-.32-3.3-1.3-5.01-1.99-1.12-.45-2.35-.59-3.46-1.07-.55-.25 1.57-1.83 1.72-1.94.52-.41 1.14-1.01 1.82-1.1.83-.09 1.78.72 2.58.9.42.1.93-.2 1.33-.32 1.52-.46 3.09-.79 4.63-1.14 1.87-.43 3.75-.84 5.62-1.25.8-.17 2.05-.2 2.76-.62.03-.02.03-.24 0-.27-.12-.11-.67-.02-.82-.03l-2.44.01c-2.37.02-4.73.03-7.09.02-4.6-.03-9.13-.25-13.64-1.25-2.02-.45-3.95-1.25-6-1.61-1.62-.3-3.26-.25-4.9-.4-.69-.06-1.32-.17-1.8-.72-.64-.76-1.39-1.29-2.19-1.87-.56-.41-1.12-.83-1.65-1.28-.44-.38-.73-.88-1.17-1.24-1.08-.88-2.97-.95-4.25-1.39a8.81 8.81 0 0 1-3.68-2.57c-1.19-1.35-2.6-3.82-.88-5.33.05-.04-.03-.24 0-.27'/%3e%3cpath fill='%236dbe45' d='M680.46 490.44c1.41 1.74.15.55-3.24 2.38-2.66 1.43 11.47 8.81 12.93 10.3 1.46 1.5-.53 0 1.46.95 2 .95 4.25 1.63 2.65 2.3-1.59.69-3.58.42-5.44 1.23-1.85.81-.66.95-3.45 1.35s-3.45.41-4.11.41c-.66 0-.5-.25-2.23-.25s-.28.35-3.73.48c-.34.01-4.87.53-4.83.53 2.18.24 7.33.46 9.64.55 1.28.06 2.46.67 4.2 1.27 1.2.4 2 .95 2.92 1.76.93.81 1.06 1.08 1.73 1.22s2.52.81.66 1.5c-1.86.67-.66 1.08-2.65 1.08-2 0-3.06.13-3.06.13s-2.25.4-3.18.14c-.93-.27-2.13-1.09-2.13-.27s.4 1.08-.8 1.08-2.91-.68-2.91-.68-.8.55-2.79.68c-1.99.14-1.72 0-3.85.14-2.12.13-3.25-.4-3.18.27.13 1.31-1.83.71-1.5 1.67.29.1-2.46.1-2.24.17 3.85 1.22 4.93-.49 9.58.87 4.64 1.36 1.46.68 5.17 1.9 3.72 1.22 3.19.27 4.91 1.35s2.26.82 2.8 1.36c.52.54 1.19-.27 1.45 1.08.27 1.36 1.73 2.71.53 2.99s-1.06.4-2.65.27c-1.6-.14-.67-.41-3.05-.55-2.4-.13-4.12-.26-4.12-.26s-1.6.13 0 .94c1.6.82-.13 1.63-1.6 2.17-1.45.55-2.51.68-3.18.82-.66.13.14 0-2.39.67-2.52.68-1.98.96-3.58 1.63-1.6.68-2.12.68-3.85 1.09-1.72.4-1.59.27-3.05.54-1.46.27-2.39.4-3.32.54-.93.14-2.64.43-2.64.43s-6.11-10.1-9.15-22.64c-3.05-12.55-4.42-32.93-4.42-33.93s4.5-1.04 6.01-.49c1.52.56 8.8 1.11 12.17 1.56 3.37.44 11.73 1.66 12.38 1.88.65.23 2.65-1.12 4.28 0 1.63 1.1 6.37 4.44 6.37 4.44'/%3e%3cpath d='M680.46 490.57c.2.24.76.67.32.85-.4.16-.86.2-1.27.32-.7.18-2.33.52-2.6 1.3-.21.6.32 1.2.68 1.59 1.25 1.35 2.92 2.37 4.44 3.37 1.8 1.18 3.63 2.3 5.45 3.42.64.4 1.27.8 1.9 1.23.2.14.4.28.59.44l.18.16.42.45c.14.28.2.28.15-.01-.2.1.82.48.9.51.79.37 1.6.7 2.37 1.1 1.1.54.3.97-.49 1.2-.94.27-1.97.3-2.94.46a6.88 6.88 0 0 0-3.06 1.3c-.95.7-2.66.64-3.77.78-.78.1-1.56.18-2.35.18-.93 0-1.83-.28-2.78-.24-.4.01-.74.19-1.13.28-.83.2-1.71.14-2.56.22-1.47.15-2.98.24-4.43.5-.03 0-.03.27 0 .27 5.63.58 12.1-.4 16.75 3.58.48.4.89.9 1.47 1.15.45.2.91.24 1.36.48.86.46-.87.99-1.14 1.13-.37.19-.56.56-.96.7-1.12.37-2.65.07-3.85.18-.78.07-1.55.22-2.34.25-.61.02-1.12-.1-1.68-.33-.4-.16-1.06-.6-1.44-.25-.27.26.18.93-.1 1.2-.64.62-2.81-.27-3.5-.52-.21-.07-.23 0-.44.09-.63.3-1.35.4-2.03.49-1.16.15-2.33.09-3.5.13-.84.03-1.66.08-2.5.03-.41-.02-1.09-.22-1.46.06-.07.05-.06.23-.06.3-.02.46-.23.67-.63.84-.4.17-.91.16-.91.72 0 .1 0 .26.07.33v-.27c-.69.25-1.55 0-2.26.14-.03 0-.03.24 0 .26.15.25 1.17.32 1.45.37a9 9 0 0 0 1.8.11c1.3-.02 2.55-.2 3.85-.1 1.92.17 4 .78 5.72 1.69 1.8.94 3.79 1.1 5.71 1.53.98.21 1.81 1 2.75 1.35.36.13.72.21 1.04.43.43.3.75.25 1.21.44.4.17.7 1.66.9 2.07.35.7.64 1.25-.31 1.48a6.36 6.36 0 0 1-3.22.05c-1.06-.28-2.04-.39-3.15-.45-1-.06-2.16-.32-3.17-.21-.27.02-.68.09-.68.43 0 .87 2.11 1.02.65 2-1.73 1.15-3.99 1.29-5.95 1.86-1.2.34-2.45.57-3.5 1.27a10.7 10.7 0 0 1-3.56 1.42c-2.71.62-5.45 1.05-8.19 1.47-.32.04-2.24.56-2.39.3l-.71-1.24a88.76 88.76 0 0 1-3.04-6.09 87.4 87.4 0 0 1-6.38-20.05 215.26 215.26 0 0 1-2.56-18.83c-.24-2.38-.45-4.76-.63-7.14-.06-.77-.6-2.9.21-3.34 1.7-.9 4.27-.34 6 .1 2.41.61 5 .7 7.45.96 4.95.5 9.88 1.21 14.79 2 .62.1 1.25.2 1.86.35.4.1.8-.06 1.19-.17a4.95 4.95 0 0 1 2.42-.17c.98.21 2.03 1.25 2.84 1.8l3.16 2.23 1.09.76c-.03-.02.05-.23 0-.27l-4.75-3.33c-.97-.67-1.86-1.47-3.07-1.56-1.04-.09-2.01.63-3.03.4-4.32-.98-8.85-1.45-13.25-1.97-2.77-.32-5.55-.55-8.32-.9-2-.26-3.89-.89-5.92-.88-.79 0-2.93-.09-2.89 1.13.04 1.08.13 2.15.21 3.23 1.4 18.36 3.72 37.32 13.37 53.32 4.9-.83 10.15-1.06 14.56-3.55 1.56-.88 3.64-1.2 5.4-1.56 1.02-.21 4.8-.88 4.22-2.6-.07-.2-1.36-.8-1.1-.98.13-.1.4-.15.56-.14 1.36.1 2.73.2 4.09.27 2.1.12 3.84.96 5.95.18.27-.1.24-.5.22-.73-.04-.39-.3-.77-.47-1.1-.26-.5-.38-1.6-.75-1.95-.31-.3-.67-.2-1.05-.33-.32-.1-.58-.42-.93-.54-1.08-.37-1.99-1.09-3.05-1.46-.47-.16-1.02-.14-1.5-.21a19.3 19.3 0 0 1-3.61-1.05c-1.06-.39-2-.89-3.09-1.22a16.22 16.22 0 0 0-4.36-.82c-1.04-.02-2.08.14-3.12.16-.5.01-1.02-.04-1.52-.12-.36-.05-.71-.14-1.06-.23-.22-.06-.52.13-.1.11.6-.04 1.4.1 1.97-.11.02-.01.02-.25 0-.27-.22-.18.95-.57 1.01-.6.26-.1.42-.32.47-.59.04-.23 0-.5.27-.57.57-.16 1.4.07 2 .08 1.22.04 2.46-.06 3.68-.1 1.26-.03 2.65-.09 3.8-.69.48-.26 3.88 1.62 3.85.17 0-.35-.17-.9.27-.97.52-.07 1.3.46 1.78.62.95.32 2.2.03 3.16-.12.85-.15 1.74-.13 2.6-.14.56-.01 1.25.1 1.76-.2.5-.3.8-.66 1.38-.9 1.82-.73.1-1.55-.93-1.82-.56-.15-1.05-.78-1.46-1.15a9.93 9.93 0 0 0-1.84-1.3 16.1 16.1 0 0 0-4.94-1.7c-2.72-.42-5.62-.25-8.37-.44a49.5 49.5 0 0 1-1.61-.14v.27c1.2-.22 2.44-.28 3.65-.41 1.23-.14 2.6 0 3.77-.44 1.1-.43 2.25.04 3.36.09 1.64.06 3.35-.27 4.95-.54.55-.1 1.04-.23 1.48-.57a6.66 6.66 0 0 1 2.88-1.16c.74-.14 4.28-.13 4.25-1.32-.01-.38-.23-.51-.53-.71a15 15 0 0 0-3.45-1.58c-.37-.12-.13.35-.1.34.04-.02.02-.23 0-.26-.17-.54-.92-1-1.36-1.31-.87-.6-1.78-1.16-2.68-1.71-2.29-1.42-4.58-2.8-6.77-4.37-.82-.6-1.63-1.21-2.33-1.94-.27-.27-.5-.57-.65-.92-.23-.57 1.28-.98 1.54-1.09.41-.17 2.44-.4 2.55-.9.1-.45-.34-.85-.57-1.15.03.04-.05.21 0 .27'/%3e%3cpath fill='%23557176' d='M635.57 484.14s.26-2.15 5.52-2.15 3.68.54 9.72 1.35c6.04.8 10.51.8 12.62 1.07s6.56.8 8.14 1.34c1.58.54 4.2 1.88 4.2 1.88s-1.04.8 3.42.8c4.47 0 3.15-.26 9.46-.26s2.1 1.6 10.25 0c8.14-1.61 14.45-2.42 16.55-2.96 2.1-.53-2.36-2.14 5.52-1.07s11.57.27 12.88.27c1.31 0 6.83.27 9.46.27 2.63 0 6.3 0 7.88.26 1.58.27 3.94-.26 7.36.27 3.42.54 4.2-1.07 6.83.54s7.36.54 9.2.27c1.84-.27 5.52 0 6.57 0s6.04.53 8.4.53c2.37 0 7.1-.53 7.1-.53l4.47.53s.79-11.54.79-12.88c0-1.35 2.85-3.36-2.18-3.85-18.5-1.79-11.34-2.94-22.26-3.67-2.63-.54-15.24-3.76-17.87-4.3-2.63-.53-16.82-4.83-21.02-4.83-4.2 0-14.72.54-17.35.54s-25.49-.54-28.64-.54c0 0-8.4-2.95-10.51-3.76s-2.37-.53-9.2-.27-8.4 1.08-14.71.27-11.57 0-14.46.54c-2.89.54-7.1 2.15-7.1 2.15l-1.04 28.2z'/%3e%3cpath d='M635.6 484.36c.09-.64.82-1.1 1.32-1.37 1.8-.95 4.11-.77 6.05-.7 1.29.04 2.5.29 3.74.58 2.32.55 4.7.83 7.08 1.07 3.91.41 7.85.49 11.76 1 1.94.25 3.94.47 5.84 1 1.52.44 2.99 1.23 4.4 1.95v-.54c-.24.2-.2.76.03.94.68.54 2.12.38 2.9.4 1.15.03 2.3 0 3.46-.06 3.7-.2 7.39-.48 11.01.43.58.14 1.2.08 1.79.02 1.66-.16 3.3-.53 4.94-.85 3.51-.68 7.04-1.27 10.57-1.85 1.12-.19 2.25-.37 3.37-.57.64-.12 1.44-.17 2.02-.5.2-.12.25-.33.25-.55.01-.25.07-.89-.06-.44.11-.39 1.07-.28 1.33-.28 1.7.02 3.4.35 5.08.55 2.86.34 5.76.46 8.64.29 4.08-.25 8.12.04 12.2.06 2.9 0 5.76.18 8.65.34 1.4.07 2.82-.08 4.23-.04 1.78.06 3.47.48 5.27.23 1.16-.17 2.13-.3 3.25.18.65.27 1.2.66 1.87.88.78.26 1.62.32 2.43.35 2.61.09 5.15-.7 7.75-.72 4.76-.04 9.5.84 14.26.61 1.3-.06 2.59-.18 3.88-.3.55-.06 1.23-.26 1.78-.19l4.45.54c.02 0 .02-.13.02-.14.24-3.53.48-7.06.68-10.6.09-1.42.1-2.44.7-3.74.42-.95.3-1.9-.68-2.35-1.46-.69-3.42-.56-4.99-.74a132 132 0 0 1-4.8-.6 44.42 44.42 0 0 1-5.17-1c-2.07-.56-4-1.23-6.15-1.5-1.77-.2-3.47-.3-5.2-.72-2.29-.54-4.57-1.1-6.84-1.67-3.6-.88-7.24-1.67-10.83-2.6-4.7-1.24-9.36-2.6-14.1-3.63-1.85-.4-3.72-.8-5.62-.78-2.54.01-5.08.12-7.62.22-3.7.14-7.39.35-11.08.3l-12.48-.26c-4.2-.08-8.38-.18-12.57-.24-.98-.02-1.74 0-2.66-.32l-6.27-2.23c-2.26-.8-4.35-1.82-6.78-1.76-4.77.11-9.51.62-14.27.85-2.61.12-5.17-.23-7.76-.48a44.24 44.24 0 0 0-20.04 2.84c-.03.02-.02.18-.02.2l-1.05 28.19c0 .17.03.52.05.14l.73-19.58.31-8.4.01-.2c-.01.3.16.12.4.03 1.25-.46 2.52-.88 3.8-1.26 2.67-.81 5.45-1.22 8.23-1.45 3.8-.33 7.48.09 11.26.42 2.76.24 5.5 0 8.26-.23 3.2-.27 6.43-.39 9.65-.52a9.3 9.3 0 0 1 3.84.52c3.48 1.31 7 2.52 10.5 3.75.32.11.86.01 1.2.02l2.28.03 6.25.12c7.64.16 15.3.54 22.94.26 2.78-.1 5.55-.22 8.32-.31 2.06-.07 4.18-.26 6.24-.03 4.8.52 9.55 2.02 14.2 3.28a506.04 506.04 0 0 0 23.1 5.69c1.68.36 3.48.3 5.18.58.96.16 1.89.41 2.81.72 3.28 1.07 6.67 1.55 10.08 1.96 1.8.22 3.63.34 5.42.6 1.02.15 2.4.5 1.83 1.77-.52 1.14-.55 1.95-.62 3.2-.2 3.73-.46 7.45-.71 11.17.01-.15-3.7-.5-4.28-.58-.46-.05-.95.07-1.4.11-1.36.14-2.72.26-4.09.35-4.84.3-9.72-.59-14.58-.6-2.6 0-5.13.74-7.74.72a7.85 7.85 0 0 1-3.98-1.07c-1.16-.67-2.32-.54-3.58-.34-1.64.25-3.2-.08-4.83-.2-1.55-.11-3.11.05-4.67.01-1.17-.03-2.35-.24-3.54-.29-1.7-.06-3.4-.05-5.1-.05-4.1 0-8.13-.33-12.2-.06-2.89.2-5.78.03-8.65-.29-1.62-.18-3.22-.45-4.84-.54-.4-.02-1.26-.14-1.56.24-.1.13-.07.38-.06.53 0 .08 0 .17.02.26.05.35.04 0 .02.05-.15.37-.89.42-1.2.49-.93.2-1.87.35-2.8.5-2.93.5-5.86.96-8.77 1.49-2.95.52-5.92 1.35-8.92 1.53-.98.06-1.8-.33-2.75-.51-2.3-.45-4.8-.23-7.14-.13-1.54.06-3.06.18-4.6.2-1.2 0-2.43.04-3.6-.22-.2-.05-.46-.12-.57-.31.23.4-.13.43.08.26.05-.04.06-.5 0-.54a29.82 29.82 0 0 0-4.4-1.94c-1.97-.63-4.14-.79-6.18-1.05-4.11-.54-8.26-.6-12.37-1.05-3.66-.4-7.23-1.52-10.9-1.59-1.49-.02-6.02-.18-6.37 2.18-.02.1.02.5.02.46'/%3e%3cg fill='%2399afca'%3e%3cpath d='M784.27 477.04c-.5 1.01-1 2.01-1.58 2.97-.07.13.05.46.01.52.58-.96 1.09-1.97 1.58-2.97.06-.14-.05-.45-.01-.52M649.45 475.31c-.61.88-1.21 1.76-1.7 2.72-.06.13.05.45.02.52a21.8 21.8 0 0 1 1.7-2.73c.08-.1-.05-.46-.02-.51M652.96 473.86c-.02.13-.1.24-.12.37-.02.12-.02.24 0 .36 0 .02.01.2.03.1.02-.13.1-.24.12-.37.02-.12.01-.25 0-.37 0-.01-.01-.2-.03-.1M657.2 472.09c-.26 1.01-.6 2-.97 2.97-.05.14.05.43.02.51.36-.98.71-1.96.97-2.97.03-.15-.04-.42-.02-.51M658.64 471.23c-.01.6-.12 1.18-.23 1.75-.03.12-.02.25-.01.37 0 .02.01.2.03.1.15-.74.25-1.47.26-2.22 0-.3-.05-.3-.05 0M661.32 469.26a96.66 96.66 0 0 0-3.64 6.68c-.06.13.05.45.02.51a97.16 97.16 0 0 1 3.63-6.68c.08-.12-.04-.46-.01-.51M662.89 468.33c-.17 1.64-.83 3.13-1.44 4.63-.06.14.04.44.01.52.64-1.55 1.3-3.09 1.47-4.77 0-.07-.02-.59-.04-.38M664.33 468.32a16.41 16.41 0 0 1-.47 3.18c-.02.1.02.5.03.46.25-1.16.47-2.31.5-3.5 0-.17-.05-.52-.06-.14M666.16 468.08c.07.88-.3 1.73-.6 2.53-.05.14.04.43.02.51.42-1.14.71-2.19.61-3.41-.02-.21-.04.3-.03.37M653.58 480.8c.6-.34 1.1-.8 1.7-1.12.1-.06-.04-.51 0-.54-.6.33-1.1.79-1.7 1.12-.1.05.04.5 0 .53M657.08 478.9c-.21.33-.4.67-.6 1-.05.07-.03.24-.03.32 0 .02.02.22.04.19l.6-1c.05-.06.02-.24.02-.32 0-.02-.02-.21-.03-.18M676.34 464.17c-.13.37-.34.7-.6.98-.05.05-.03.21-.03.27l.03.27c.27-.29.48-.63.61-1 .03-.1.02-.23.02-.33a.78.78 0 0 0-.03-.19M677.32 468.28a7.9 7.9 0 0 0 1.96-5.47c-.02-.33-.05.18-.04.27.1 1.66-.9 3.44-1.92 4.67-.1.12.07.45 0 .53M681.29 462.5a16.57 16.57 0 0 1-.47 3.32c-.03.1.01.5.02.46.26-1.2.48-2.4.5-3.63 0-.17-.05-.51-.05-.14M678.03 462.94c-.41 1.43-1.19 2.7-1.94 3.96-.07.13.05.46.02.52.75-1.27 1.52-2.53 1.94-3.96.04-.15-.04-.43-.02-.52M663.01 476.55c-.26.67-.53 1.34-.84 1.98-.07.14.04.45.01.52.31-.65.59-1.32.85-1.98.05-.15-.04-.44-.02-.52M664.6 476.55a14.1 14.1 0 0 1-1.57 2.1c-.1.1.06.46 0 .53.61-.64 1.1-1.37 1.58-2.11.08-.12-.05-.47-.01-.52M667.86 477.17l-.72 1.49c-.04.08-.02.24-.02.33 0 .02.02.2.03.18l.73-1.48c.04-.09.02-.24.02-.33 0-.02-.02-.21-.04-.19M669.32 475.69c-.63 1.4-1.3 2.77-2.3 3.95-.1.11.07.45 0 .53 1-1.18 1.68-2.57 2.31-3.97.06-.14-.04-.44-.01-.51M699.48 465.4a2.4 2.4 0 0 0-.73.88c-.05.08-.02.24-.02.32 0 .02.02.22.03.2.17-.35.41-.64.72-.86.04-.04.02-.23.02-.27a4 4 0 0 0-.02-.27M699.13 470.4c1.87-1.19 2.78-3.68 2.8-5.84.01-.3-.04-.3-.05 0-.02 1.94-1.11 4.26-2.75 5.3-.1.06.04.5 0 .53M684.7 473.33a7.63 7.63 0 0 1-2.3 2.1c-.1.06.05.5 0 .53a7.68 7.68 0 0 0 2.32-2.11c.08-.12-.05-.47-.02-.52M680.83 480.17c3.06-.86 5.55-3.49 7.15-6.2.07-.12-.05-.45-.01-.5-1.6 2.69-4.1 5.3-7.14 6.17-.08.02 0 .53 0 .53M685.68 483.64a9.57 9.57 0 0 0 3.15-3.1c.08-.12-.04-.47-.01-.52a9.53 9.53 0 0 1-3.14 3.09c-.1.05.04.5 0 .53M692.45 479.14a37.17 37.17 0 0 1-6.17 6.56c-.1.09.05.48 0 .53a37.21 37.21 0 0 0 6.17-6.56c.1-.12-.06-.44 0-.53M694.29 478.3c.37-.78.76-1.57 1.32-2.22.1-.12-.06-.46 0-.54-.57.67-.96 1.46-1.34 2.24-.06.14.05.45.02.52M699.37 483.12c1.05-1.93 2.02-4.03 3.62-5.56.1-.1-.06-.47 0-.53-1.6 1.54-2.58 3.64-3.64 5.58-.07.13.05.45.02.51M703.72 479.02c-1.07 1.21-2.26 2.32-3.27 3.59-.1.12.07.45 0 .53 1.01-1.27 2.2-2.38 3.27-3.58.1-.12-.06-.47 0-.54M716.08 476.82c.54-1.49.78-3.07.74-4.66 0-.37-.05-.03-.05.14.04 1.36-.25 2.74-.7 4-.06.15.04.44.01.52M715.34 472.24c-.35 1.58-.48 3.22-1.21 4.68-.07.13.05.45.01.51.74-1.47.88-3.14 1.22-4.73.02-.1-.01-.5-.02-.46M718.25 472.12c-.23 1.53-.18 3.1-.72 4.56-.06.14.04.43.01.51.56-1.49.5-3.05.73-4.6.02-.11-.02-.51-.02-.47M719.8 473.52c-.03 1.52-.47 3-1.07 4.4-.06.13.05.43.02.5.65-1.5 1.07-3.1 1.1-4.76.01-.17-.04-.52-.04-.14M721.39 474.47c.16 3.05-1.22 6.1-3.13 8.38-.1.12.07.46 0 .53a13.19 13.19 0 0 0 3.17-9.18c-.01-.33-.05.18-.04.27M722.97 475.2c-.5 1.37-1.08 2.7-1.58 4.08-.05.14.05.43.02.51.5-1.37 1.08-2.7 1.57-4.08.06-.15-.04-.44-.01-.52M724.18 474.44c-.34.92-.85 1.75-1.33 2.6-.07.13.05.46.02.52.48-.86.98-1.69 1.33-2.6.05-.15-.04-.44-.02-.52M725.15 476.18c-.95 1.83-1.72 3.78-3.27 5.19-.1.09.06.47 0 .53 1.56-1.42 2.33-3.37 3.28-5.2.07-.14-.05-.46-.01-.52M726.24 475.35a6.42 6.42 0 0 1-.6 1.95c-.07.12.05.45.01.51.35-.62.48-1.31.61-2 .03-.12.02-.25.01-.37 0-.02-.01-.2-.03-.1M727.95 474.95c-1.05 2.08-2.46 3.9-3.76 5.81-.08.12.05.47.02.52 1.3-1.92 2.7-3.74 3.75-5.82.07-.13-.05-.45-.01-.51M734.95 469.57c.08.76-.31 1.6-.6 2.28-.05.14.05.44.02.51a6.4 6.4 0 0 0 .62-3.17c-.02-.2-.05.31-.04.38M734.5 477.31a19.6 19.6 0 0 0 3.39-7.7c.02-.1-.02-.5-.03-.46a19.48 19.48 0 0 1-3.38 7.65c-.08.11.04.47.01.51M739.91 469.31a4.61 4.61 0 0 1-.7 2.42c-.08.12.04.46.01.51.53-.85.73-1.78.74-2.78 0-.17-.04-.52-.05-.15M729.53 476.91c-1.2 1.36-2.27 2.8-3.4 4.21-.09.12.07.45 0 .53 1.13-1.4 2.2-2.85 3.4-4.2.1-.12-.07-.46 0-.54M731.21 477.8a156.62 156.62 0 0 1-3.87 5.18c-.1.13.07.45 0 .53 1.32-1.71 2.64-3.43 3.88-5.2.09-.12-.04-.47 0-.52M732.06 480.12l-1.7 1.36c-.1.09.06.5 0 .54l1.7-1.36c.1-.09-.06-.5 0-.54M748.17 472.09c-.47.7-1.1 1.25-1.7 1.85-.1.1.07.46 0 .53.6-.6 1.23-1.16 1.71-1.87.08-.11-.05-.46-.01-.51M748.79 474.97c.9-.64 1.21-1.84 1.23-2.92 0-.17-.04-.51-.05-.14-.02.94-.41 1.98-1.18 2.53-.1.07.05.5 0 .53M741.72 478.84c0 .44-.1.91-.34 1.3-.05.07-.02.24-.02.32 0 .02.02.21.03.19.3-.5.37-1.1.38-1.67 0-.1.02-.23-.02-.33l-.03.19M743.82 483.12c.69-1.64 1.5-3.22 1.7-5.02.02-.07 0-.58-.03-.37-.2 1.75-1.02 3.29-1.68 4.88-.06.14.04.44.01.51M743.57 477.8c-.35.91-.85 1.74-1.33 2.6-.07.12.04.45.01.5.48-.85.98-1.68 1.33-2.6.06-.14-.04-.43-.01-.5M746.57 477.5c.05 1.33-1.1 2.52-1.67 3.63-.07.13.04.45.01.52.74-1.44 1.77-2.58 1.71-4.29-.01-.38-.05-.03-.05.14M747.46 482c.43-.9 1.05-1.72 1.21-2.74.02-.12.02-.24.01-.37 0-.01-.02-.2-.03-.1-.16 1-.79 1.82-1.2 2.7-.07.14.04.45 0 .52M750.95 472.35a20.65 20.65 0 0 0-1.7 3.59c-.05.14.05.43.02.5.49-1.23.98-2.46 1.7-3.58.07-.12-.05-.46-.02-.51M753.74 473.48a9.45 9.45 0 0 1-1.33 3.2c-.07.11.05.46.02.5a9.59 9.59 0 0 0 1.34-3.24c.02-.1-.02-.5-.03-.46M755.92 474.44a15.3 15.3 0 0 1-1.46 3.47c-.07.12.05.46.02.51a15.4 15.4 0 0 0 1.45-3.46c.04-.15-.04-.43-.01-.52M757.75 480.53c.6-.9.5-1.94.5-2.98 0-.3-.05-.3-.05 0 0 .88.03 1.72-.46 2.47-.08.12.04.46.01.51M760.15 478.3c-.1 2.12-1.73 3.82-3.01 5.34-.09.1.06.41 0 .48 1.36-1.62 2.95-3.34 3.05-5.58 0-.08-.03-.54-.04-.24M753.14 480.38c-.49.5-.98.99-1.57 1.36-.1.07.04.5 0 .54.59-.38 1.08-.87 1.57-1.37.05-.04.03-.2.03-.26l-.03-.27M756.4 480a21.93 21.93 0 0 0-2.78 2.85c-.1.12.07.46 0 .54.87-1.02 1.75-2.01 2.79-2.85.1-.09-.06-.49 0-.53M766.92 474.2c0 .3-.02.58-.1.87-.03.1-.02.22-.02.32l.03.19c.14-.45.14-.9.14-1.37 0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27M768.38 472.86a5.05 5.05 0 0 1-1.08 3.2c-.08.11.05.47.02.51a5.98 5.98 0 0 0 1.1-3.98c-.02-.32-.05.18-.04.27M770.82 473.95a68.63 68.63 0 0 0-2.06 4.2c-.06.15.04.45.01.52a70.68 70.68 0 0 1 2.06-4.2c.07-.13-.04-.46-.01-.52M772.62 475.26a9.95 9.95 0 0 1-1.2 3.65c-.07.12.05.45.01.51.64-1.2 1.08-2.43 1.23-3.78 0-.07-.02-.59-.04-.38M775.18 476.18l-2.55 4.82c-.07.13.05.45.02.52l2.54-4.83c.07-.13-.05-.45-.01-.51M776.63 478.65a24.76 24.76 0 0 1-2.41 4.2c-.1.12.06.44 0 .53a24.8 24.8 0 0 0 2.42-4.22c.07-.13-.04-.44 0-.51M778.82 480.63c-1.22 1.4-2.1 3.1-3.51 4.33-.1.09.06.48 0 .53 1.4-1.23 2.3-2.93 3.51-4.33.1-.11-.06-.46 0-.53M767.31 484c.47-.16.87-.37 1.13-.8.27-.47.43-.91.8-1.3.11-.11-.06-.47 0-.53-.33.35-.53.74-.74 1.18-.25.5-.67.75-1.19.92-.08.03.01.53 0 .53M770.8 481.56c-.04 1-.78 1.78-1.32 2.54-.08.11.05.47.02.52.65-.93 1.3-1.73 1.35-2.91 0-.17-.04-.52-.05-.15M772.38 482.31c-.06 1.4-1.29 2.41-2.16 3.34-.09.1.06.4 0 .46 1.01-1.08 2.14-2.08 2.2-3.67 0-.15-.03-.45-.04-.13'/%3e%3cpath d='M785.83 475.13c-.22 1.98-1.91 3.38-3.02 4.88-.09.12.07.44 0 .53 1.15-1.57 2.82-2.97 3.05-5.03 0-.07-.01-.59-.03-.38M786.46 480.04a10.1 10.1 0 0 0 2.06-3.35c.06-.14-.04-.44-.01-.51a10.03 10.03 0 0 1-2.05 3.33c-.1.1.06.47 0 .53M790.32 476.18a22.53 22.53 0 0 1-2.54 4.2c-.08.12.04.47 0 .52.96-1.34 1.9-2.68 2.55-4.2.06-.15-.04-.45-.01-.52M792.99 476.3c-1.09 1.36-2.13 2.75-3.4 3.95-.1.1.07.48 0 .54 1.27-1.2 2.31-2.6 3.4-3.96.1-.12-.07-.45 0-.54M794.69 476.8a11.34 11.34 0 0 1-1.34 2.97c-.07.12.05.46.02.51.56-.93 1.05-1.9 1.33-2.97.04-.15-.04-.42-.01-.51M792.14 482.11c-1.18 1.53-2.9 2.42-4.6 3.22-.1.05.03.52 0 .53 1.7-.8 3.42-1.69 4.6-3.21.1-.13-.06-.45 0-.54M784.63 483.75c.77-.57 1.67-.9 2.55-1.23.08-.04-.02-.53 0-.54-.88.34-1.78.67-2.55 1.24-.1.08.06.5 0 .53M794.69 482.11c-.69 1.19-1.88 1.94-3.03 2.6-.1.05.04.5 0 .53 1.16-.66 2.35-1.42 3.04-2.61.07-.13-.05-.46-.01-.52M758.46 466.66c-.66 1.13-1.82 1.71-3.02 2.09-.08.03.01.53 0 .53 1.2-.38 2.37-.97 3.04-2.11.07-.12-.05-.46-.02-.51M709.65 471.34c.27 1.78-.79 3.26-1.93 4.45-.1.11.07.47 0 .54 1.47-1.54 2.28-3.3 1.95-5.45 0-.05-.04.35-.02.46M656.85 462.44a41.5 41.5 0 0 1-4.85 2.85c-.1.05.04.51 0 .53 1.67-.86 3.3-1.77 4.85-2.85.1-.07-.05-.5 0-.53M649.58 461.69a13.64 13.64 0 0 1-3.76 3.1c-.1.05.04.5 0 .53a13.56 13.56 0 0 0 3.76-3.1c.1-.11-.06-.46 0-.53'/%3e%3c/g%3e%3cpath fill='url(%23e)' d='M722.72 507.13h.01c.04 0 .06-.02.05-.02l-.06.02m.9-.18l4.14-.9c-1.48.3-2.96.6-4.13.9m4.86-1.07l-.73.17c3.02-.6 6.04-1.14 6.46-1.42-.06 0-2.9.63-5.73 1.25m5.73-1.25zm-60.41-33.45c-1.12.74-5.52 2.69-7.82 3.83-2.3 1.14-2.36 3.42-1.58 3.83.8.4 6.05 3.62 6.44 4.22.4.6-2.23 1.74-2.54 1.92-.3.18-.15.9-.15.9 2.78 3.81 13.55 4.03 11.82 5.26-1.72 1.21-4.87 1.01-2.71 3.15a39.23 39.23 0 0 0 7.35 5.5c3.23 1.65 3.06 3.03 3.77 3.77 1.46 1.49.62 1 2.6 1.94 2 .95 4.25 1.63 2.66 2.3-1.6.69-3.58.42-5.44 1.23-1.86.81-.66.95-3.45 1.35-2.79.41-3.45.41-4.11.41-.67 0-.27-.27-2-.27-1.72 0 .4-.13-3.05 0-3.05.12-8.9-1.35-10.21-1.69 1.43.38 8.19 2.16 10.08 2.64 2.12.54 1.99.27 3.72.82 1.72.54 3.31.67 4.5 1.08 1.2.4 2 .95 2.93 1.76.93.81 1.06 1.09 1.72 1.22.67.14 2.53.82.67 1.5-1.86.67-.67 1.08-2.66 1.08-1.99 0-3.05.13-3.05.13s-2.26.41-3.18.14c-.93-.27-2.13-1.08-2.13-.27s.4 1.08-.8 1.08c-1.19 0-2.91-.67-2.91-.67s-.8.54-2.8.67c-.99.07-1.42.07-1.86.07-.45 0-.92 0-1.98.07-.77.05-1.35.03-1.8 0-.77-.04-1.13-.07-1.38.27-.4.54 2.12 1.22-1.47.68-3.58-.54-2.25-.54 1.6.68 3.85 1.22 1.06 0 5.7 1.35 4.65 1.36 1.47.68 5.18 1.9s3.19.27 4.91 1.36c1.73 1.08 2.26.81 2.79 1.35.53.54 1.2-.27 1.46 1.09.27 1.35 1.72 2.7.53 2.98-1.2.27-1.06.4-2.65.27-1.6-.13-.67-.4-3.06-.54-2.38-.14-4.11-.27-4.11-.27s-1.6.13 0 .95c1.6.81-.13 1.63-1.6 2.17-1.45.54-2.52.68-3.18.81-.66.14.13 0-2.39.68s-1.99.95-3.58 1.63c-1.6.67-2.12.67-3.85 1.08-1.72.4-1.6.27-3.05.54-1.46.27-2.39.41-3.32.55-.93.13-1.6.13-1.6.13s3.06 9.76 10.76 19.52c7.7 9.77 25.48 28.61 43.8 30.5 18.3 1.9 31.31 1.23 41.27-4.46 9.95-5.7 23.49-14.37 32.25-28.88 8.76-14.5 9.4-16.57 9.4-16.57s-1.82-.82-3.22-.51c-1.4.31-1.4-2.58-3.53-2.58s-2 .95-4.65-.27c-2.65-1.22-1.85-1.63-3.98-1.77-2.12-.13-6.23-1.9-6.23-1.9s-3.05-.8-5.18-.94c-2.12-.14-2.92-.27-6.24-1.5-3.32-1.21-4.38-1.08-5.44-1.48-1.06-.41-2.26-.68-3.05-1.22-.8-.55-2.79-1.5-.26-3.4 2.51-1.9 3.45-2.98 4.37-3.52.93-.54 2.92-1.76 4.65-1.9 1.72-.13 1.86-.54 4.38-.54 2.52 0-1.33-1.09-3.85-.95-2.52.13-2.52.54-4.78.54-2.26 0-.93-.13-6.63.27-5.71.4-2.26 0-6.64-.13-4.38-.14-3.45.13-7.3-.68s-2.25-.27-6.37-.81-4.11-.68-5.97-1.63c-1.86-.95-3.05-1.22-4.12-1.5-1.06-.26-1.85-.53-.8-1.35 1.07-.81 5.15-3.92 6.07-4.47a9.9 9.9 0 0 1 2.15-.73 33.7 33.7 0 0 1-1.34.28c-.7.12-2.2.23-4.75-.1-4.25-.54-5.3-.8-7.03-1.21-1.73-.41-3.45-1.5-7.83-1.63-4.38-.14-2.92-.55-4.78-1.9-1.86-1.36-3.05-2.17-3.58-2.98a5.18 5.18 0 0 0-2.92-2.3c-3.85-1.23-7.44-4-6.9-4.62.93-1.08 2.26-1.65.66-2.98-1.63-1.35-10.82-2.95-13.4-3.76 0 0 .06-.44.2-.49.58-.2 1.91-.56 2.9-1.25 1.25-.87 0-1.41-1.51-2.22-2.06-1.1-5.59-2.68-7.16-3.82-1.64-1.19 1.7-3.22 5.06-4.7 3.35-1.48 11.75-8.73 13-9.87l-.06-.4s-9.26 7.45-10.38 8.18'/%3e%3cpath d='M684.26 463.26a120.91 120.91 0 0 1-6.62 5.52 65.81 65.81 0 0 1-4.24 3.1c-1.6 1.08-3.4 1.76-5.07 2.71-.91.52-2.55 1.39-2.58 2.64-.03 1.07 1.7 1.66 2.43 2.06 1.98 1.08 4.04 2.02 6.03 3.08 2.97 1.6-2.23 2.09-2.46 3.26 0 .03-.03.24 0 .25 4.22 1.28 8.95 1.47 12.93 3.45.52.26 1.4.9 1.1 1.62-.26.6-.98.86-1.29 1.4a.72.72 0 0 0-.02.54c.35.84 1.29 1.42 1.98 1.91a19.05 19.05 0 0 0 4.95 2.43c1.43.47 2.12 1.35 3.04 2.48.94 1.14 2.28 1.95 3.46 2.8.52.38.87.87 1.32 1.3.6.6 1.82.52 2.58.57 1.66.1 3.28.16 4.9.52 1.1.24 2.14.64 3.2.97 2.02.64 4.17.92 6.24 1.2 1.63.23 3.26.43 4.91.4.52-.02 1.24 0 1.74-.23.02-.01.01-.26 0-.27l-.08.02c-.03.02-.02.27 0 .27.5.08 1.26-.26 1.74-.36l3.9-.85 3.95-.88c.57-.12 1.33-.44 1.92-.4v-.28c-1.31.73-3.27.8-4.71 1.07-2.24.44-4.5.84-6.7 1.47-1.74.5-3.12 1.75-4.56 2.83l-2.58 1.96c-.4.3-.79.55-.76 1.1.04.66 1.67.8 2.14.93 1.42.37 2.74 1 4.05 1.67 2.08 1.06 4.57 1.19 6.84 1.42 2.2.23 4.3.56 6.5.98 2.24.44 4.54.24 6.81.38 1.26.08 2.37.27 3.65.2 2.26-.14 4.53-.43 6.8-.42 1.85.01 3.59-.24 5.43-.45a13.5 13.5 0 0 1 4.3.26c.4.08.83.18 1.19.39-.11-.07.1-.12-.23-.06-.46.08-.95.03-1.41.04-2.66.1-5.37.83-7.68 2.15-.84.49-1.54 1.1-2.28 1.73-1.17 1.01-2.8 1.88-3.63 3.2-1.84 2.9 6.63 4.22 8.17 4.68 2.68.8 5.09 1.86 7.9 2.05 1.91.13 3.97.46 5.76 1.2 1.08.43 2.19.82 3.3 1.16 1.2.36 2.46.33 3.63.7.94.28 1.82 1.13 2.7 1.55 1.25.6 2.17.67 3.46.39 1.14-.25 2.12-.13 2.9.8.5.63.85 1.79 1.82 1.66.74-.09 1.4-.04 2.13.14.43.1.94.53 1.08.11l-.07.16c-.82 1.97-1.96 3.82-3 5.67-3.42 6.03-6.83 12.21-11.15 17.63a77.85 77.85 0 0 1-14.85 13.95 99.14 99.14 0 0 1-14.51 9.06c-5.08 2.52-10.72 3.64-16.3 4.12-7.17.62-14.4.16-21.55-.52-6.6-.64-12.62-2.84-18.36-6.2-10.28-5.99-19.16-14.73-26.6-24.06a69.56 69.56 0 0 1-11.04-19.83c0-.03-.02-.06-.03-.08.13.4.34.24.76.21 2.8-.2 5.65-.85 8.39-1.44 1.24-.27 2.48-.63 3.58-1.3a13.33 13.33 0 0 1 3.5-1.38c1.99-.55 4.04-.88 5.92-1.76.49-.23 1.07-.56 1.06-1.18-.02-.62-1.8-1.16-.91-1.4.64-.17 1.47.05 2.12.1 1.34.09 2.9-.06 4.19.45.67.27 1.45.27 2.17.28.39 0 1.85-.17 2-.55.34-.9-.54-1.9-.84-2.68-.33-.88-.24-1.12-1.18-1.23-.3-.04-.53-.36-.79-.49-.3-.16-.67-.23-1-.36-.84-.31-1.53-.92-2.37-1.22-.48-.16-1.02-.14-1.51-.21a12.97 12.97 0 0 1-4.53-1.47c-1.26-.76-2.9-1.04-4.3-1.42-.92-.25-1.84-.29-2.75-.5-1.81-.43-3.57-1.08-5.39-1.52v.26c.58.06 4.06.92 4.06.35 0-.24-.18-.33-.34-.48-.66-.6 1.94-.44 2.14-.44 1.21.01 2.44-.07 3.66-.1 1.25-.04 2.65-.1 3.79-.7.49-.26 3.88 1.62 3.86.17 0-.35-.17-.9.27-.97.51-.07 1.3.46 1.78.62.94.32 2.2.03 3.15-.13.85-.14 1.75-.12 2.6-.13.57-.01 1.26.09 1.76-.21.5-.29.81-.65 1.38-.88 1.83-.74.1-1.56-.92-1.83-.56-.15-1.06-.78-1.47-1.15a9.88 9.88 0 0 0-1.84-1.3c-1.55-.86-3.44-.97-5.12-1.41-4.83-1.27-9.7-2.39-14.54-3.66 0 0-.04.25 0 .26 1.73.47 3.48.86 5.24 1.2 2.48.47 4.8.46 7.31.5 1.12.03 2.24.35 3.34.33.95 0 1.9-.15 2.85-.27 1.05-.14 2.34-.15 3.22-.84 1.07-.83 2.44-1.1 3.74-1.28.6-.08 3.29-.16 3.38-1.06.03-.32-.07-.48-.3-.69-1.07-.97-2.86-1.34-4.14-2-1.45-.76-1.95-2.69-3.1-3.78-1.07-1-2.5-1.55-3.71-2.33a42.5 42.5 0 0 1-3.91-2.93c-.58-.47-3.04-2.23-2.21-3.02.79-.76 2.23-.85 3.15-1.45.48-.31.07-.76-.27-.91-1.63-.72-3.56-.9-5.26-1.35-2.05-.55-4.29-1.24-5.86-2.76-1.55-1.5 2.32-1.73 2.32-3.07 0-.32-.28-.48-.5-.65-.86-.7-1.82-1.27-2.75-1.87-.88-.56-1.77-1.1-2.66-1.63-.23-.14-.48-.26-.7-.4-.9-.6.05-2.1.52-2.64.85-.97 2.4-1.44 3.53-1.97 1.37-.65 2.74-1.28 4.09-1.95 2.24-1.12 4.15-2.88 6.1-4.43 1.9-1.5 3.77-3 5.65-4.51.05-.04-.03-.25 0-.27-2.7 2.17-5.39 4.32-8.1 6.46a22 22 0 0 1-3.65 2.48c-1.24.63-2.5 1.2-3.76 1.8-1.3.6-2.8 1.11-3.86 2.12-.56.54-1.37 2.28-.62 3.06.44.47 1.22.76 1.77 1.1 1.06.64 2.1 1.3 3.14 2 .31.2 1.98 1.07 1.59 1.54-.57.7-1.62 1.01-2.38 1.43-.25.13-.22.64-.2.86.07.7.84 1.17 1.37 1.54 1.82 1.29 4.15 1.84 6.27 2.36.91.22 1.83.42 2.74.65.5.12 1.19.23 1.6.6.12.11-2.19 1.07-2.49 1.18-.53.2-1.06.44-1.08 1.08-.02.54.4.95.74 1.3.96 1.03 2.12 1.9 3.21 2.75 1.16.9 2.36 1.74 3.62 2.48 1.34.78 2.66 1.41 3.52 2.77.42.66.7 1.19 1.25 1.77a6.03 6.03 0 0 0 2.13 1.45c.79.37 1.6.7 2.38 1.1 1.1.54.3.96-.49 1.19-1.76.5-3.54.37-5.22 1.23-.64.32-1.04.72-1.77.9-1.39.32-2.86.46-4.28.57-1.15.08-2.22-.23-3.37-.25-1.05-.01-2.1.01-3.16.01-3.33 0-6.77-.9-9.97-1.77v.27c3.6.95 7.2 1.94 10.8 2.83 2.8.69 5.85.94 8.52 2.08 1.36.57 2.22 1.77 3.44 2.53.38.23.93.27 1.35.45 1.18.51-.46 1-.92 1.24-.32.16-.5.47-.8.64-.52.32-1.5.13-2.07.14-.8.02-1.62.05-2.41.17-1.06.17-2.2.34-3.23-.01-.44-.15-1.8-1.03-1.82-.07 0 .2.02.4.04.6.08.62-1.21.36-1.51.33-.77-.1-1.8-.8-2.51-.48-1.17.56-2.58.57-3.84.6-1.36.04-2.74.13-4.1.09-.45-.02-2.14-.12-1.58.83.08.14.24.25.36.36.12.1.08-.08-.06-.06-.19.02-.4-.02-.6-.04-1.1-.1-2.18-.4-3.28-.5 0 0-.03.26 0 .26 1.99.48 3.98 1.41 6 1.64 1.98.22 3.93.82 5.8 1.5 1.57.57 3 1.29 4.66 1.67.67.16 1.36.14 2.02.32 1.07.3 1.97 1.1 3.04 1.45.38.12.62.32.93.55.5.36.8-.15 1.18.57.31.6.45 1.35.77 1.99.51 1-.12 1.09-.94 1.3-.88.24-2 .18-2.86-.11-1.26-.43-2.6-.39-3.9-.47-.34-.03-3.03-.59-2.97.35 0 .18.01.17.13.33.2.26.67.43.94.6.7.44-.61 1.1-.77 1.18-1.39.75-2.96 1.02-4.48 1.34-1.05.21-2.11.59-3.13.9-1.46.45-2.67 1.44-4.15 1.9-1.56.48-3.21.75-4.82 1-1.85.26-3.7.76-5.57.78-.02 0-.01.24 0 .27 3.08 9.78 9.33 18.36 16.1 25.82 8.5 9.38 18.75 18.3 30.76 22.47a40.95 40.95 0 0 0 9.66 1.94c3.8.36 7.63.62 11.45.72 6.24.16 12.57-.17 18.66-1.72 5.28-1.34 9.9-3.98 14.52-6.84a98.27 98.27 0 0 0 15.2-11.42 69.1 69.1 0 0 0 9.52-10.91c2.82-4.02 5.23-8.38 7.68-12.64 1.14-1.98 2.27-3.96 3.3-6 .22-.42.47-.86.62-1.32 0-.03.03-.24 0-.26-1.02-.45-2.13-.68-3.22-.51-.94.15-1.36-1.03-1.83-1.66-.73-1-1.78-1-2.89-.8a5.1 5.1 0 0 1-3.45-.4c-.96-.41-1.75-1.16-2.7-1.55-.48-.2-1.04-.18-1.54-.23-.7-.06-1.4-.27-2.1-.46-1.67-.48-3.23-1.27-4.93-1.67-2.46-.58-5.02-.54-7.46-1.2-2.6-.71-5.08-1.7-7.72-2.29-1.23-.27-2.6-.75-3.68-1.4-.34-.21-.68-.44-.98-.7-1.2-1.02.34-2.14 1.12-2.74 2.14-1.62 3.9-3.36 6.36-4.48 1.24-.56 2.52-.6 3.82-.88.52-.11 1.03-.2 1.56-.25.65-.06 1.42.1 2.04-.13.1-.03.05-.27.04-.34-.11-.49-2.21-.64-2.56-.69-2.56-.35-5.02.47-7.57.44-1.4-.02-2.77.05-4.17.15-1.9.13-4.04.59-5.93.2-2.06-.44-4.25-.18-6.34-.3-2.2-.12-4.32-.96-6.53-1.1-2.4-.15-4.9-.3-7.2-.99-1.03-.3-1.97-.91-2.94-1.36-.77-.36-1.58-.63-2.4-.86-.55-.15-2.78-.41-1.51-1.39 1.94-1.49 3.86-3.1 5.94-4.38.72-.44 1.65-.6 2.44-.8 1.37-.34 2.76-.62 4.15-.9 1.34-.26 2.68-.5 4.01-.78.68-.14 1.52-.22 2.14-.56.03-.02.02-.27 0-.27-.54-.03-1.21.26-1.73.37l-3.9.85c-1.31.3-2.63.59-3.95.87-.53.12-1.38.49-1.93.4v.28c.02-.01.05-.03.07-.02v-.27c-.42.2-1.02.18-1.47.2-1.73.12-3.46-.14-5.17-.37-2.09-.28-4.2-.6-6.24-1.2-.97-.29-1.9-.65-2.89-.9-1.71-.44-3.46-.52-5.21-.6-.8-.03-1.81 0-2.5-.49-.53-.36-.88-.98-1.4-1.37-1.12-.85-2.35-1.59-3.32-2.63-1.05-1.14-1.63-2.1-3.18-2.66a22.85 22.85 0 0 1-4.64-2.22c-.55-.35-1.08-.75-1.57-1.19a4.92 4.92 0 0 1-.48-.5c-.4-.48.18-.85.5-1.17 3.1-3-5.58-4.4-7.03-4.74-1.78-.42-3.57-.8-5.35-1.23a23.4 23.4 0 0 1-.93-.25c-.24-.07 1.13-.63 1.19-.65.75-.27 2.11-.69 2.28-1.6.22-1.12-2.23-1.87-2.94-2.23-2.1-1.08-4.61-1.96-6.43-3.51-1.46-1.26 5.14-4.2 5.76-4.52 1.63-.84 3.12-2 4.58-3.1 2.72-2.05 5.39-4.22 7.91-6.52.06-.04-.02-.23 0-.26M642.55 467.89c-.6.96-1.38 1.78-2.17 2.58-.1.1.06.47 0 .54.8-.82 1.58-1.64 2.19-2.61.07-.12-.05-.46-.02-.51M643.64 469c-.5.79-.96 1.6-1.33 2.47-.06.14.04.44.01.52.37-.87.83-1.69 1.34-2.48.07-.12-.05-.46-.02-.51'/%3e%3cg fill='%234f91c5'%3e%3cpath d='M702.98 507.39c.93-.66 1.78-.36 2.8-.1.93.22 1.67.07 2.54-.29.05-.02-.01-.26 0-.27-.89.37-1.6.48-2.54.28-1.03-.21-1.85-.56-2.8.11-.05.04.02.25 0 .27M704.49 508.6c.24-.6 1.13-.44 1.63-.44.02 0 .02-.26 0-.26-.51 0-1.4-.17-1.64.45-.02.07.03.22.01.26M701.59 506.49c1.02-.67 2-.5 3.14-.65.03 0 .01-.26 0-.26-1.13.15-2.12-.03-3.14.64-.05.03.02.25 0 .27M695.4 509.66c-2.21-.96-4.5.66-6.73-.26.01 0-.05.25 0 .27 2.24.92 4.52-.7 6.73.26-.01 0 .05-.25 0-.27'/%3e%3cpath d='M690.77 510.08c-1.32-.59-2.6.47-3.96.01.01 0-.04.26 0 .27 1.37.46 2.64-.6 3.96-.01-.01 0 .05-.25 0-.27M688.13 511.11c-.99-.79-2.58-.08-3.7-.12-.03 0-.03.26 0 .26 1.12.04 2.71-.66 3.7.13-.03-.02.05-.23 0-.27M692.16 567.14c-1.08.42-3.27.58-4.16-.34-1.17-1.21-2.4-.54-3.9-.37-.03 0-.01.26 0 .26 1.23-.13 2.76-.89 3.74.19.97 1.06 3.07 1.02 4.32.53.04-.02-.02-.26 0-.27M674.08 536.08c2.16-1.25 4.32.4 6.57-.27.04 0 0-.26 0-.26-2.25.66-4.4-.99-6.57.27-.05.03.02.25 0 .26M655.55 540.92c.9-.34 1.67-.48 2.6-.2.85.27 1.61.66 2.5.8 2.22.33 4.52-.55 6.73-.6.02 0 .02-.27 0-.27-2.26.06-4.46.79-6.72.6-.88-.08-1.7-.49-2.51-.79-.9-.33-1.74-.13-2.6.2-.04 0 .01.26 0 .26M657.78 543.33c2.46-.98 5.09.04 7.62-.53.03-.01 0-.27 0-.27-2.53.57-5.16-.45-7.62.53-.05.02 0 .27 0 .27M678.67 534.34c2.18-.86 4.2-.31 6.44-.27.02 0 .02-.27 0-.27-2.25-.04-4.26-.6-6.44.27-.04.02.01.26 0 .27M685.63 532.1c1.32-.2 2.49-.25 3.81-.04.01 0 .03-.27 0-.27-1.32-.2-2.49-.15-3.8.04-.04 0-.02.27 0 .27M663.04 550.45c2.69-1.51 5.67.95 8.28-.67.05-.03-.03-.25 0-.26-2.61 1.61-5.6-.85-8.28.67-.05.02.02.25 0 .26M665.27 552.45c1.79-.38 3.59-.67 5.39-.94.03 0 0-.26 0-.26-1.8.26-3.6.55-5.39.94-.03 0 0 .26 0 .26M671.05 545.74c1.72-.95 4 .17 5.39-1.47.05-.06-.03-.23 0-.27-1.4 1.64-3.67.53-5.39 1.48-.05.03.02.25 0 .26M679.73 555.28c1.94-1.49 4.43.05 6.44-1.21.05-.03-.03-.25 0-.27-2 1.26-4.5-.27-6.44 1.21-.05.04.03.25 0 .27M679.06 550.31c1.3-.18 2.64-.62 3.94-.31 1.25.3 2.2 1.15 3.55 1.12.03 0 .02-.27 0-.27-1.17.02-2.12-.56-3.18-1-1.37-.55-2.91 0-4.3.2-.03 0-.01.26 0 .26M680.38 565.35c1.99-.96 3.81-.9 5.92-.4 1.82.42 3.02 1.17 4.46-.54.05-.06-.03-.23 0-.27-1.36 1.62-2.7 1.12-4.46.54a7.83 7.83 0 0 0-5.92.4c-.05.03.02.26 0 .27M698.78 559.58c2.2.43 4.02.16 6.1-.6 1.08-.4 2.12-.85 3.28-.96 1.07-.1 2.17.13 3.23.21.02 0 .03-.26 0-.26-1.07-.08-2.15-.24-3.23-.21-1.15.03-2.23.55-3.29.95a10.55 10.55 0 0 1-6.09.6s-.03.26 0 .27M713.36 558.5c1.73-.27 3.4-.76 5.17-.62 1.78.15 3.2 1.1 4.95.22.05-.03-.02-.26 0-.27-1.54.78-2.89.18-4.47-.13-1.9-.38-3.78.25-5.65.53-.03 0 0 .27 0 .27M727.3 558.23c3.4-1.27 5.91 1.78 9.19 2.01.01 0 .02-.26 0-.26-3.28-.24-5.8-3.29-9.2-2.02-.04.02.01.27 0 .27M740.3 558.77c1.52-.5 2.94-.23 4.47.1 1.64.35 3.09.3 4.59-.5.05-.03-.02-.26 0-.27-1.51.82-2.94.84-4.59.5-1.54-.32-2.94-.6-4.48-.1-.04.01 0 .27 0 .27M751.2 560.11c2.45-1.38 5.02-.92 7.63-1.6.03-.02 0-.27 0-.27-2.61.69-5.18.22-7.63 1.6-.05.04.02.26 0 .27M733.07 568.57c1.16-1 2.49-.95 3.92-.73 1.33.2 2.75.56 3.83-.48.05-.05-.03-.23 0-.26-1 .95-2.28.73-3.52.52-1.52-.25-2.98-.4-4.23.68-.05.05.03.24 0 .27M734.78 571.4c1.96-1.6 4.43-.92 6.57-2.02.05-.03-.02-.26 0-.27-2.14 1.1-4.6.42-6.57 2.02-.06.04.03.24 0 .26M759.08 565.08c2.24-.1 4.48.1 6.7-.27.03 0 0-.27 0-.27-2.22.38-4.46.17-6.7.27-.02 0-.02.27 0 .27M759.87 567.63a5.68 5.68 0 0 1 2.53-.73c.78-.02 1.55.1 2.33.06.03 0 .02-.26 0-.26-.78.03-1.55-.06-2.33-.07-.9-.02-1.73.32-2.53.74-.05.02.02.25 0 .26M764.6 562.13c.72-.78 1.84-.47 2.76-.67.04-.01 0-.27 0-.27-.92.2-2.04-.1-2.75.67-.05.06.03.23 0 .27M701.53 566.16c1.32-1.05 2.7-1.08 4.3-1 1.75.07 3.17-.22 4.5-1.42.06-.04-.02-.24 0-.26-1.34 1.2-2.75 1.47-4.5 1.4-1.6-.06-2.97-.04-4.3 1.01-.05.04.03.25 0 .27M702.85 567.63c2.06-1.6 4.65-.27 6.97-.94.03 0 0-.26 0-.26-2.32.66-4.91-.67-6.97.94-.05.04.03.24 0 .26M699.82 562.4c3.03-1.7 6.83 1.76 9.46-.94.06-.05-.03-.24 0-.27-2.63 2.7-6.43-.75-9.46.94-.05.03.02.26 0 .27M709.95 575.28c1.23-.93 1.94-.47 3.28-.13 1.91.47 3.82.53 5.78.53a.65.65 0 0 0 0-.26c-1.78 0-3.54-.05-5.29-.42-1.5-.31-2.4-1.03-3.77.02-.06.03.02.24 0 .26M709.95 577.3c2.37-1.73 5.3.95 7.88.53.03 0 0-.27 0-.27-2.58.42-5.51-2.26-7.88-.53-.05.04.02.25 0 .27M694.96 533.53c2.45-1.77 5.02.5 7.62-.4.05-.02 0-.27 0-.27-2.6.9-5.18-1.36-7.62.4-.05.04.03.25 0 .27M696.4 534.88c1.67-.44 3.34.3 5-.14.04 0 0-.27 0-.27-1.66.44-3.33-.3-5 .14-.03 0 .01.27 0 .27M682.88 547.9c2.03-.9 4.02-.7 6.18-.67.02 0 .02-.27 0-.27-2.16-.02-4.14-.23-6.18.67-.05.02.01.26 0 .27M756.58 551.66c1.47-1.74 3.92-1.25 5.91-1.48.03 0 .01-.27 0-.27-2 .23-4.44-.26-5.9 1.48-.06.06.02.23 0 .27M750.54 556.09c2.42-2.37 5.47-.34 8.28-1.48.04-.02-.01-.26 0-.27-2.8 1.14-5.86-.9-8.28 1.48-.05.05.03.24 0 .27M691.16 559.97c1.55-2.05 3.85-1.43 6.04-2 .04-.02 0-.28 0-.28-2.19.59-4.49-.04-6.04 2.02-.05.06.03.22 0 .26M775.54 539.2c1.4-.3 2.71-.67 4.15-.55 1.47.12 2.7.27 4.09-.36.05-.02-.01-.26 0-.27-1.36.62-2.64.54-4.09.36-1.41-.17-2.78.25-4.15.55-.03 0 0 .27 0 .27M774.44 541.72c.97-.2 1.87-.24 2.85-.28a4.76 4.76 0 0 0 2.18-.82c.05-.03-.02-.25 0-.26a5.3 5.3 0 0 1-1.95.8c-1.04.14-2.04.08-3.08.3-.03 0 0 .26 0 .26M770.51 536.7c1.77-.83 4.52 1.04 5.79-.91.04-.06-.02-.23 0-.26-1.27 1.94-4.03.08-5.79.9-.05.02.01.25 0 .26M777.7 543.09c.98-.35 1.8-.6 2.84-.57.9.03 1.7.2 2.52-.27.05-.03-.03-.25 0-.27-.8.46-1.63.34-2.52.27-1.02-.07-1.88.23-2.83.57-.04.01 0 .26 0 .27M764.38 536.06c1.7-1.97 4.7 1.07 6.73-.26.05-.03-.03-.25 0-.27-2.03 1.33-5.03-1.7-6.73.26-.05.06.03.23 0 .27M760.93 535.09c.6-1 1.91-.67 2.89-.75 1.1-.1 1.93-.74 2.7-1.5.05-.05-.03-.23 0-.26a4.63 4.63 0 0 1-2.7 1.49c-1 .14-2.27-.26-2.9.76-.04.06.02.23 0 .26M709.97 513.1c1.62-.8 3.24.14 4.9-.27.04 0 0-.26 0-.26-1.66.4-3.28-.54-4.9.26-.05.02.02.25 0 .26M711.98 514.58c.82-.69 1.8-.03 2.7-.45.05-.02-.02-.26 0-.27-.9.42-1.88-.23-2.7.45-.06.05.02.24 0 .27M748.35 561.59c.88-.1 1.88.4 2.7-.07.06-.02-.02-.25 0-.26-.82.45-1.82-.04-2.7.06-.03 0-.01.27 0 .27M684.3 520.04a7.18 7.18 0 0 0-4.09-.38c-.92.23-.86 1.15-1.98.8 0 .01-.04.26 0 .28 1.01.3 1.16-.43 1.98-.81 1.16-.54 2.96-.02 4.08.37 0 0 .05-.25 0-.26M683.48 521.45c-2.3-1.06-4.76-.13-7.17-.38-.02 0-.03.26 0 .26 2.4.25 4.87-.67 7.17.39-.02 0 .04-.24 0-.27'/%3e%3cpath d='M680.52 522.8c-1.19-.42-2.3-1-3.5-1.37-1.38-.42-2.9-.42-4.3-.75 0 0-.04.26 0 .27 1.27.3 2.55.45 3.84.64 1.38.2 2.65 1.02 3.96 1.48 0 0 .04-.25 0-.27M675.49 547.62c1.62-2.07 4.02-.62 6.16-1.1.04 0 0-.26 0-.26-2.14.47-4.54-.98-6.16 1.1-.05.05.03.22 0 .26M675.56 548.84c.78-.36 1.5-.83 2.39-.84.8-.01 1.6.53 2.39.64 0 0 .03-.26 0-.26-.83-.12-1.57-.53-2.4-.65-.81-.11-1.68.52-2.38.84-.05.02.01.26 0 .27M677 552.37c.49-.48.95-.63 1.59-.4.52.2.95.42 1.5.15.04-.03-.02-.26 0-.27-.54.27-.98.07-1.5-.14-.63-.25-1.11-.08-1.59.4-.05.05.03.23 0 .26M678.07 544.34c.6-.36 1.13-.34 1.77-.08.65.27 1.16.43 1.81.08.05-.03-.02-.26 0-.27-.59.32-1.08.23-1.68-.02-.68-.29-1.23-.37-1.9.02-.05.03.02.26 0 .27M671.77 543.57c1.05-.26 1.84.33 2.86.48.79.11 1.66-.4 2.43-.55.03 0 0-.27 0-.27-.82.16-1.6.58-2.43.55-1.05-.04-1.77-.75-2.86-.48-.03 0 0 .27 0 .27M686.94 557.9c1.28-1.34 3.1-.22 4.6-.96.04-.03-.03-.26 0-.27-1.5.75-3.32-.37-4.6.96-.05.06.03.24 0 .27M715 559.9c1.7-1.04 3.5-.32 5.34-.33.02 0 .02-.27 0-.27-1.85.01-3.64-.7-5.35.32-.05.04.02.26 0 .27M726.82 559.58c2.17-.79 3.88 1.27 6.04.83.04 0 0-.27 0-.27-2.16.44-3.87-1.62-6.04-.83-.04.01.01.26 0 .27M741.72 559.95c1.75-.32 4.37 1.38 5.8-.13.04-.05-.04-.23 0-.26-1.43 1.5-4.05-.2-5.8.12-.03 0 0 .27 0 .27M752.11 561.3c.64-1.3 1.98-.74 3.12-.62 1.36.15 2.63.03 3.73-.86.06-.04-.02-.24 0-.26-1.23 1-2.63.98-4.13.82-1.08-.12-2.14-.52-2.73.66-.03.07.03.22.01.26M703.67 560.47c1.15-.06 2.13-.53 3.21-.9 1.2-.42 2.48-.03 3.64-.52.05-.02-.01-.26 0-.27-1.03.44-2.19.17-3.27.41-1.25.27-2.28.95-3.58 1.01-.03 0-.02.27 0 .27M711.53 571c1.82-2.12 4.64-.04 6.8-1.34.04-.03-.03-.26 0-.27-2.16 1.3-4.98-.77-6.8 1.35-.05.06.03.23 0 .27M714.05 571.72c1.73-.62 4.52.44 5.79-1.22.05-.06-.04-.22 0-.27-1.27 1.66-4.06.6-5.79 1.22-.04.02.01.27 0 .27M730.4 578.78c1.28-1.35 2.73-1.5 4.46-1.18 2.03.39 3.93.81 5.98.35.04-.01 0-.27 0-.27-1.88.43-3.66.13-5.52-.25-1.9-.39-3.49-.42-4.92 1.09-.05.05.03.23 0 .26'/%3e%3cpath d='M731.22 579.37c1.06-.73 2.2-1 3.46-.84.01 0 .03-.26 0-.26-1.26-.17-2.4.1-3.46.83-.05.04.03.25 0 .27M696.36 556.98c.85-1.08 2.46-.44 3.57-.94.05-.02-.02-.26 0-.27-1.11.5-2.72-.14-3.57.94-.05.06.04.22 0 .27M702.48 557.07c.27-1.5 2.4-.72 3.36-1.34.05-.03-.02-.25 0-.26-1 .63-3.09-.19-3.37 1.37l.01.23M713.37 556.09c-.87-.06-1.66-.38-2.54-.32-.98.07-1.93.55-2.86.84-.04 0 .01.26 0 .26.96-.3 1.87-.67 2.86-.83.86-.14 1.7.26 2.54.31.02 0 .03-.26 0-.26M717.25 556.57a10.1 10.1 0 0 1 3.45-.12c.97.12 2.01.68 2.97.53.03 0 0-.27 0-.27-.84.13-1.72-.31-2.56-.46a9.85 9.85 0 0 0-3.86.05c-.04 0 0 .27 0 .27M729.58 556.98c1.49-.16 3.03.32 4.28-.73.05-.05-.02-.25 0-.27-1.25 1.05-2.8.57-4.28.73-.02 0 0 .27 0 .27M737.63 556.67c2.4-2.52 5.8.12 8.66-.73.04-.01 0-.26 0-.26-2.86.85-6.25-1.8-8.66.73-.05.05.03.23 0 .26M685.46 556.67c1.12-.9 2.47-.9 3.77-1.35.04-.02 0-.27 0-.27-1.3.45-2.65.46-3.77 1.36-.05.04.03.24 0 .26M726.02 556.76c.96-1.39 2.6-1.46 4.07-1.86.04-.02 0-.27 0-.27-1.48.4-3.12.48-4.08 1.88-.04.05.03.23 0 .25M747.51 555.94c.97-.99 2.34-.76 3.57-1.04.03 0 0-.26 0-.26-1.23.28-2.6.05-3.57 1.04-.05.05.04.23 0 .26M753.42 553.86c.89-.66 1.9-.63 2.95-.73.03 0 .02-.27 0-.27-1.05.1-2.06.08-2.95.73-.06.04.02.25 0 .27M753.42 551.05c.98-.29 2-.43 2.85-1.04.05-.04-.02-.25 0-.27-.85.61-1.88.75-2.85 1.04-.04.02 0 .27 0 .27M681.29 551.88c1.12-.12 2.22-.48 3.36-.31 0 0 .03-.26 0-.27-1.14-.17-2.24.19-3.36.32-.03 0-.01.26 0 .26'/%3e%3c/g%3e%3cpath fill='white' stroke='black' stroke-width='.46' d='M523.83 317.68s8.07-.73 7.67.65c-.39 1.38.4 1.38 2.57 1.38s8.09-.79 8.68.2c.6.98 6.31-.4 8.48-.8 2.17-.39 3.75-.39 4.93-.59 1.19-.2 3.36-.78 3.36 0s.59 2.57.59 2.57 2.56 2.17 4.34 2.17c1.77 0 2.37.6 2.76 1.18.4.6 0 1.78 1.58 1.38 1.58-.39.2.4 3.94-.98 3.75-1.38 2.17-.2 3.16-.99a4.34 4.34 0 0 1 3.95-.98c1.77.4 3.15 1.18 3.74.98.6-.2 1.98-.59 4.54.6 2.56 1.18 5.33 1.57 7.5 1.77s3.35.6 4.53 0 3.95-.6 4.74-.6-.8-.39 3.75.2c4.53.6 4.93.6 5.52 0s2.17-.98 2.96-1.18c.79-.2 1.18-1.18 1.97-.79.79.4 2.76 1.19 4.34 1.97 1.58.8 5.33 1.19 7.5.8 2.17-.4.79-.2 4.34.59 3.55.78 4.73.98 6.11.98s6.35-.59 6.35-.59l-1.81-.41c-2.17-1.78-1.18-.18-5.33-2.35s-2.36-1.38-8.48-2.76c-6.11-1.39-4.73-2.57-6.7-3.75-1.98-1.19-2.18 0-4.35 0-2.17 0-1.38-1.38-6.5-5.13-5.13-3.75-4.74-2.76-6.71-4.34-1.98-1.58-6.12-4.14-8.29-6.12-2.17-1.97-6.7-1.5-8.68-1.57-4.37-.15-6.04-4.31-9.86-3.48-1.72.38-4.74-2.25-9.08-3.23-4.34-.99-8.48 2.56-11.63 4.54-3.16 1.97-10.66 6.11-14.01 9.07-3.35 2.96-10.53 6.5-14.87 7.88s-7.47 1.35-7.47 1.35' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M690.58 437.7c-.63.42-1.32.69-2.03.93-.08.03.02.53 0 .53.71-.24 1.4-.5 2.03-.92.1-.07-.04-.5 0-.54M721.57 442.79c-2.4 1.3-4.26 3.39-6.56 4.85-.1.06.05.5 0 .53 2.3-1.46 4.16-3.55 6.56-4.85.1-.05-.04-.51 0-.53M721.77 439.3a14.76 14.76 0 0 1-4.64 4.47c-.1.06.04.51 0 .54a14.85 14.85 0 0 0 4.65-4.49c.08-.11-.05-.47-.01-.51M719.93 437.6a7.18 7.18 0 0 1-2.98 1.79c-.07.02 0 .53 0 .53 1.16-.3 2.1-1 2.98-1.79.1-.1-.06-.48 0-.53M720.1 439.04c-1.31 1.35-2.55 2.87-4.29 3.67-.1.04.03.52 0 .53 1.74-.8 2.98-2.31 4.3-3.67.1-.1-.07-.47 0-.53M720.98 445.93c-1.22 1.61-2 3.62-3.95 4.47-.09.04.03.52 0 .53 1.96-.85 2.73-2.85 3.95-4.47.09-.13-.07-.45 0-.53M719.93 449.78c-.71.84-1.29 1.92-2.36 2.33-.1.03.02.52 0 .53 1.07-.4 1.65-1.49 2.36-2.33.1-.11-.06-.46 0-.53M720.46 452.81c1.03.75 1.5 2.03 2.54 2.78-.05-.04.1-.46 0-.54-1.03-.74-1.5-2.02-2.54-2.77.05.04-.1.46 0 .53M722.73 458.27c.5.36.8.9 1.22 1.34l.03-.27c0-.05.02-.21-.03-.26-.42-.44-.72-.99-1.22-1.34l-.03.26c0 .05-.02.24.03.27M688.13 442.34c-1.39 1.48-3 2.71-4.82 3.58-.1.05.04.52 0 .53 1.82-.86 3.43-2.1 4.82-3.58.1-.1-.06-.46 0-.53M685.85 446.37c-2.22 1.93-4.88 3.02-7.62 3.94-.08.03.01.53 0 .53 2.74-.91 5.4-2 7.62-3.94.1-.09-.06-.48 0-.53M682.17 450.41c-1.16 1.68-2.86 3.7-4.9 4.2-.07.02 0 .53 0 .53 2.05-.5 3.75-2.52 4.91-4.21.08-.12-.04-.47 0-.52M669.65 452.2c-1.26.81-2.54 1.59-3.94 2.14-.09.03.02.52 0 .53 1.4-.55 2.68-1.32 3.94-2.15.1-.06-.04-.5 0-.53M667.03 451.3c-.33.1-.64.24-.97.36-.08.03.02.53 0 .53.33-.11.64-.26.97-.36.07-.02 0-.53 0-.53M686.03 454.7c-.66.39-1.3.8-1.92 1.25-.1.07.05.5 0 .53.62-.45 1.26-.86 1.92-1.25.1-.06-.04-.5 0-.53M710.12 455.78c-.93.43-1.84.9-2.72 1.43-.1.06.05.5 0 .53.88-.53 1.8-1 2.72-1.43.1-.05-.03-.52 0-.53M716.34 454.7c-.62.37-1.13.9-1.5 1.53-.04.08-.01.24-.01.33 0 .02.02.2.03.18.36-.63.87-1.14 1.48-1.5.1-.07-.04-.52 0-.54'/%3e%3cg opacity='.59' fill='%23007638'%3e%3cpath d='M658.31 514.56c-.1 1.21-.1 2.57.6 3.62-.03-.05.09-.4.01-.52a4.19 4.19 0 0 1-.57-2.73c0-.07-.02-.58-.04-.37M657.62 517.96c-.42-.64-1.15-1.54-1.1-2.36 0-.09-.03-.6-.05-.27-.06 1.23.48 2.15 1.13 3.15-.03-.05.1-.4.02-.52M655.75 517.47a10.7 10.7 0 0 1-2.21-6.13c-.02-.33-.05.18-.05.26.14 2.3.8 4.61 2.26 6.4-.07-.07.1-.4 0-.53M660.5 517.67c-.18-.2-.27-.42-.37-.65-.01-.03-.03.16-.03.18 0 .1-.03.24.01.33.12.24.2.48.38.67l.03-.26c0-.06.02-.22-.03-.27M661.7 517.86c-.22-.08-.43-.16-.55-.37-.02-.03-.03.17-.03.18 0 .09-.03.25.01.33.13.22.34.31.57.4-.02-.01.08-.51 0-.54M652.3 516.72c-.77-1.53-.82-3.22-.9-4.9-.03-.34-.06.17-.05.26.1 1.77.13 3.55.94 5.16-.03-.07.08-.39.02-.52M653.67 502.54c.01.94.4 2.93-.8 3.25-.09.02 0 .53 0 .53 1.28-.34.87-2.8.85-3.78 0-.3-.05-.3-.05 0M651.65 506.42c.26-.28.45-.6.57-.96.03-.1.02-.23.02-.33l-.03-.19c-.12.36-.3.68-.55.94-.05.05-.03.21-.03.27 0 .02.03.26.02.27M653.98 506.42c.77-.54.68-1.52.68-2.36 0-.3-.05-.3-.05 0 0 .71 0 1.38-.63 1.82-.1.08.05.5 0 .54M662.53 503.95c.29.7.08 1.56.08 2.3 0 .3.04.3.05 0 0-.9.24-1.96-.11-2.82.03.08-.08.37-.02.52M655 506.51c1-.63 1.04-2.09.85-3.16 0-.04-.04.36-.03.46.15.82-.1 1.72-.82 2.17-.1.06.05.5 0 .53M661.8 506.31c.21-.35.29-.73.3-1.14 0-.1.01-.23-.02-.32-.01-.02-.03.16-.03.18-.01.27-.13.54-.27.77-.04.07-.02.24-.01.32 0 .02.01.22.03.2M657.97 502.14c.45 1.14-.16 2.65-.29 3.83 0 .07.01.59.04.38.17-1.49.85-3.25.26-4.72.04.07-.07.37 0 .51M663.3 506.15v-1.05c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.05c0 .02 0 .26.03.26.02 0 .02-.24.02-.26M673.14 507.56c.61-.68.58-1.66.58-2.54 0-.3-.05-.3-.05 0 0 .73-.03 1.45-.53 2.01-.1.11.06.46 0 .53M658.44 506.23c.93-1.12 1.04-2.53 1.14-3.93 0-.09-.02-.6-.05-.27-.09 1.32-.22 2.62-1.09 3.67-.1.12.07.45 0 .53M656.02 506.42c1.66-.55.97-3.62.76-4.87 0-.05-.04.36-.03.46.2 1.18.75 3.39-.73 3.87-.08.03.01.53 0 .54M660.1 504.03c-.05.68-.13 1.44-.73 1.86-.1.07.05.5 0 .53.67-.47.72-1.37.77-2.12 0-.1-.03-.6-.05-.27M663.46 506.51c.3-.22.38-.5.4-.86 0-.1.02-.23-.02-.33a.8.8 0 0 0-.03.19c0 .18-.22.37-.35.47-.04.03-.02.22-.02.26l.02.27M660.58 506.51a6.46 6.46 0 0 0 1.15-3.9c0-.17-.05-.52-.06-.14a5.84 5.84 0 0 1-1.09 3.5c-.09.13.07.45 0 .54M650.73 506.14c.1-.1.16-.18.2-.32.02-.12.01-.25 0-.37 0-.02 0-.2-.03-.1-.04.1-.1.18-.17.25-.05.05-.03.21-.03.27l.03.27M654.26 517.1c-.95-1.23-1.29-2.78-1.67-4.27.02.1-.05.37-.01.52.38 1.49.72 3.04 1.68 4.28-.07-.09.1-.4 0-.53M651.01 516.72a8.19 8.19 0 0 1-.74-1.52l-.03.19c0 .1-.02.23.02.33.18.54.45 1.03.74 1.52.01.02.03-.17.03-.19 0-.08.03-.25-.02-.33M663.07 516.5c.03.35.1.69.2 1.02l.03-.19c0-.1.01-.22-.02-.33a4.52 4.52 0 0 1-.17-.88c-.01-.09-.03-.09-.04 0a1.8 1.8 0 0 0 0 .38M672.19 526.67c.06.62.46 1.06.75 1.58.02.03.03-.16.03-.18 0-.09.03-.25-.02-.33-.25-.46-.68-.9-.73-1.45 0-.09-.03-.09-.04 0v.38M672.12 528.5c-.48-.42-.67-1.02-.83-1.61.02.09-.06.36-.02.51.17.6.36 1.2.85 1.63-.06-.06.1-.45 0-.54M725.01 507.18c.94-.63 1.29-1.75 1.68-2.77.05-.14-.04-.43-.01-.5-.4 1-.74 2.12-1.67 2.74-.1.06.05.5 0 .53M727.35 506.6c1.13-1.92.79-4.25.67-6.37-.02-.33-.05.18-.05.27.1 1.9.37 3.9-.63 5.59-.08.12.04.46 0 .51M776.73 512.8v-1.24c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.24c0 .02 0 .27.03.27s.02-.25.02-.27M782.12 513.03c.09-.39.1-.78.1-1.18 0-.01.01-.26-.02-.26s-.02.25-.02.26c0 .25-.03.48-.08.72-.03.12-.02.25-.01.37 0 .02 0 .2.03.1M777.65 513.72c.64-1.48.84-3.07.94-4.68.01-.09-.02-.6-.04-.27-.1 1.53-.3 3.03-.91 4.44-.06.14.04.44.01.51M780.74 513.37c0-1.08.17-2.15.18-3.23 0-.3-.05-.3-.05 0-.01 1.08-.17 2.15-.19 3.23 0 .3.05.3.06 0M779.42 513.24c.56-2 1.1-3.97 1.13-6.07 0-.17-.04-.52-.05-.14-.04 1.97-.57 3.82-1.1 5.7-.04.15.04.43.02.51M775.62 513.19c0-.51.09-1.01.1-1.52 0-.02 0-.27-.03-.27s-.03.25-.03.27c0 .5-.08 1-.09 1.52 0 .01 0 .26.03.26s.02-.25.02-.26M778.3 513.72c.54-1.73.4-3.56.66-5.34.02-.1-.02-.5-.02-.46-.26 1.76-.12 3.58-.65 5.29-.04.15.04.43.01.51M777.1 513.8c.2-.88.37-1.74.39-2.63 0-.17-.05-.52-.06-.15 0 .8-.19 1.55-.35 2.31-.03.12-.02.25-.01.37 0 .02 0 .2.03.1M779.15 513.28c.02-1 .17-1.98.19-2.97 0-.17-.05-.51-.05-.14-.02 1.04-.18 2.07-.19 3.1 0 .31.05.31.05 0M726.23 506.9a6.58 6.58 0 0 0 1.32-3.8c0-.18-.04-.52-.05-.15a6.1 6.1 0 0 1-1.27 3.41c-.1.13.06.45 0 .54M723.91 507.37c.26-.52.54-1.03.84-1.53.04-.07.02-.24.02-.32 0-.02-.02-.22-.04-.19-.29.5-.58 1-.83 1.52-.05.09-.03.24-.02.33 0 .02.02.21.03.19M728.84 505.91c.1-.7.1-1.42.1-2.13 0-.02 0-.26-.02-.26s-.03.24-.03.26c0 .56 0 1.12-.08 1.67v.37c0 .01.02.2.03.1M730.97 505.27c.36-1.42.57-2.87.85-4.3.02-.1-.02-.51-.03-.46-.27 1.41-.48 2.84-.83 4.24-.04.16.03.43.01.52M732.58 504.34c0-.82.08-1.64.09-2.47 0-.3-.05-.3-.05 0 0 .83-.09 1.65-.1 2.47 0 .3.05.3.06 0M734.04 503.75c.47-1.47.74-2.96.86-4.5 0-.08-.03-.6-.05-.26-.1 1.44-.38 2.86-.82 4.24-.05.15.04.43.01.52M736.08 503.47c.54-.97.66-2.03.76-3.11 0-.07-.02-.59-.04-.38a7.31 7.31 0 0 1-.73 2.97c-.07.13.05.46.01.52M737.76 503.95c.62-.97.83-2.07.94-3.2 0-.08-.02-.6-.04-.38a6.64 6.64 0 0 1-.92 3.06c-.07.12.05.46.02.52M740.54 502.9c1-.86 1.66-1.97 2.06-3.24.04-.14-.04-.43-.02-.51a6.89 6.89 0 0 1-2.04 3.22c-.1.1.06.48 0 .53M744.36 502.98c.85-1.17.67-2.73.76-4.1 0-.1-.02-.6-.04-.28-.09 1.32.08 2.75-.73 3.87-.08.11.04.47.01.51M746.58 502.14c1.15-.64 1.5-1.88 1.52-3.14 0-.17-.05-.51-.05-.14-.02 1.13-.46 2.2-1.47 2.75-.1.05.04.51 0 .53M742.53 503.02c0-.43 0-.86.08-1.29.02-.12.01-.25 0-.36 0-.02-.01-.2-.03-.1-.1.58-.1 1.16-.1 1.75 0 .02 0 .27.02.27s.03-.25.03-.27M736.85 504.25c0-.53 0-1.05.08-1.58.02-.11.02-.24.01-.36 0-.02-.02-.2-.03-.1-.1.68-.1 1.36-.11 2.04 0 .02 0 .26.02.26.04 0 .03-.24.03-.26M734.12 505.56c.67-.63.68-1.59.77-2.45 0-.07-.02-.59-.04-.38-.09.82-.1 1.7-.73 2.3-.1.1.06.47 0 .53M732.83 505.75c.38-.83.4-1.73.4-2.63 0-.3-.06-.3-.06 0 0 .74-.04 1.44-.36 2.12-.06.13.05.44.02.5'/%3e%3cpath d='M731.09 506.53v-1.33c0-.01 0-.26-.03-.26s-.03.25-.03.26v1.33c0 .02 0 .27.03.27s.03-.25.03-.27M729.39 507.07c.48-1.43 1.1-2.8 1.4-4.3.02-.1-.02-.5-.02-.46-.3 1.47-.92 2.83-1.4 4.25-.04.14.05.43.02.51M738.97 504.13c.46-.98.65-2.03.76-3.1 0-.08-.02-.6-.04-.38a8.94 8.94 0 0 1-.73 2.97c-.06.13.05.44.01.51M740.92 503.56c.1-.22.2-.44.28-.67.03-.1.02-.22.02-.32a.8.8 0 0 0-.03-.19 5.4 5.4 0 0 1-.28.67c-.04.08-.02.23-.02.32 0 .02.02.21.03.19M743.52 503.08c.76-1.4.42-3.02.3-4.53-.02-.21-.05.3-.04.38.1 1.22.34 2.5-.27 3.63-.07.13.05.46.01.52M745.76 502.8c.73-1.5.84-3.14.94-4.78.01-.09-.02-.6-.04-.27-.1 1.56-.22 3.11-.91 4.53-.07.14.04.45.01.52M722.67 503.97c-.1.88-.55 1.7-.37 2.6.02.1.04-.08.04-.1 0-.11.01-.24-.01-.36-.06-.29.15-.71.22-1 .07-.25.13-.5.16-.77 0-.06-.01-.58-.04-.37M722.7 507.46c.16-.7.27-1.4.46-2.1.04-.14-.04-.41-.02-.5-.18.69-.3 1.39-.46 2.09-.04.15.04.42.01.5M731.92 505.4v-1.05c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.05c0 .02 0 .26.03.26s.02-.24.02-.26M735.45 504.57c-.01-.9-.26-1.71-.48-2.57.02.1-.05.37-.01.52.18.72.43 1.43.44 2.19.01.37.06.03.05-.14M739.62 503.84a9.7 9.7 0 0 0 1.12-3.54c.01-.1-.02-.5-.03-.46a9.61 9.61 0 0 1-1.1 3.49c-.08.12.04.45 0 .51M754.31 517.52c.54-1.01 1-2.06 1.4-3.14.05-.14-.05-.43-.02-.5-.39 1.07-.86 2.11-1.4 3.13-.06.12.05.45.02.5M757.56 517.25a6.32 6.32 0 0 0 1.5-3.27c.01-.1-.02-.5-.03-.46a6.16 6.16 0 0 1-1.47 3.2c-.1.11.06.45 0 .53M760.25 516.77a5.76 5.76 0 0 0 1.22-4.58c0-.05-.04.35-.02.46.2 1.35-.4 2.57-1.2 3.59-.1.12.07.45 0 .53M762.77 516.1c.88-1.64.68-3.6.48-5.38-.03-.21-.05.3-.04.37.17 1.54.29 3.11-.45 4.5-.07.13.04.45.01.51M756.43 515.05c.12.37.47.94 0 1.18-.09.06.05.52 0 .54.35-.18.34-.62.32-.97-.03-.44-.17-.85-.3-1.27.02.09-.06.37-.02.52M758.68 516.97c.52-.58.5-1.43.5-2.17 0-.02 0-.27-.03-.27s-.03.25-.03.27c0 .6-.03 1.18-.44 1.64-.1.1.06.46 0 .53M761.66 516.38c.3-.73.47-1.47.48-2.27 0-.17-.04-.52-.05-.14 0 .66-.2 1.29-.44 1.9-.06.14.04.44.01.51M755.63 516.8c0-.35 0-.68.08-1.01.02-.12.02-.25 0-.37 0-.02 0-.2-.03-.1-.1.49-.1.98-.1 1.47 0 .02 0 .27.02.27.03 0 .03-.25.03-.27M753.02 517.68c.08-.44.17-.89.36-1.3.04-.09.02-.24.02-.33 0-.02-.02-.2-.03-.18-.2.42-.29.9-.38 1.35-.02.12-.02.25 0 .37 0 .01 0 .2.03.1M760.88 511.78c-.04 1.05-.66 2.01-.35 3.08-.03-.08.05-.36.01-.51-.13-.46.16-1.04.26-1.49.08-.31.12-.61.13-.94 0-.17-.03-.51-.05-.14M757.57 514.18a9 9 0 0 1-.08-1.38c0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .61 0 1.23.1 1.84.02.1.04-.08.04-.1l-.01-.36M759.62 514.56l.28-2v-.36c0-.02-.01-.2-.03-.1l-.28 2v.36c0 .02.02.2.03.1M758.23 514.32c0-.43.02-.85.17-1.26.03-.1.02-.23.02-.33l-.03-.18c-.2.56-.2 1.18-.21 1.77 0 .02 0 .27.03.27s.02-.25.02-.27M762.61 514.13c0-.46 0-.91-.1-1.37-.03-.1-.04.08-.04.1 0 .12-.02.25 0 .36.08.3.09.6.09.91 0 .02 0 .27.02.27.03 0 .03-.25.03-.27M759.42 516.76c.21-.45.3-.93.3-1.42 0-.1.02-.23-.02-.33a.9.9 0 0 0-.03.19c0 .36-.1.72-.26 1.04-.04.1-.02.24-.02.33 0 .02.02.21.03.19M756.56 514.25c0-.41-.09-.82-.1-1.23a.85.85 0 0 0-.03-.19c-.03.1-.02.23-.01.33 0 .41.08.82.09 1.23 0 .03.02.21.03.19.03-.1.02-.23.02-.33M787.05 525.76c.29-2.03 1.96-3.48 2.33-5.5.01-.11-.02-.51-.03-.47-.37 2.03-2.04 3.47-2.32 5.51-.02.1.01.5.02.46M788.36 525.03c0-.56.2-1.06.63-1.42.1-.1-.06-.48 0-.54-.54.47-.67 1.13-.68 1.81 0 .17.04.52.05.15M785.93 525.5c.26-.53.56-1.03 1.02-1.41.04-.04.02-.22.02-.27l-.02-.26c-.47.39-.77.9-1.03 1.43-.05.09-.02.24-.02.33 0 .02.02.21.03.19M789.37 524.65c.36-1.17.47-2.37.57-3.58 0-.07-.02-.59-.04-.38-.1 1.17-.2 2.33-.55 3.45-.04.15.04.43.02.51M785.26 524.8c-.05-.14-.07-.18-.07-.12 0-.1-.03-.09-.04 0v.38c.01.1.05.18.11.26l.03-.26c0-.07.02-.21-.03-.27M789.83 525.41a9.91 9.91 0 0 0 1.22-6.43c-.03-.2-.05.31-.04.38a8.52 8.52 0 0 1-1.2 5.54c-.07.12.05.46.02.51M781.38 513.28c.1-.87.1-1.75-.1-2.6-.02-.1-.03.07-.04.1 0 .1-.01.24.01.36.14.58.16 1.16.1 1.76-.02.07 0 .59.03.38'/%3e%3cpath d='M790.66 524.75c.91-1.5.75-3.43.94-5.1.01-.08 0-.6-.03-.38-.2 1.65-.03 3.5-.92 4.96-.07.12.05.46.01.52M771.77 525.25c-.04.37-.04.76.1 1.1.02.03.04-.16.04-.18 0-.1.02-.23-.02-.33-.02-.04-.09-.16-.08-.22v-.37c-.01-.1-.03-.09-.04 0M719.26 504.61c1.1-.7 1.55-2 1.86-3.24.04-.15-.03-.42-.01-.51-.31 1.23-.75 2.51-1.85 3.22-.1.07.04.5 0 .53M770.78 526.38c0-.33.02-.7-.1-1.01-.02-.03-.04.16-.04.18 0 .1-.02.24.02.33.07.16.07.33.07.5 0 .02 0 .27.03.27s.02-.25.02-.27M772.65 526.2v-2.38c0-.3-.05-.3-.05 0v2.38c0 .3.05.3.05 0M719.42 500.64c-.1 1.13-.14 2.5-1.2 3.15-.1.07.05.51 0 .54 1.1-.68 1.13-2.15 1.23-3.31 0-.07-.02-.58-.03-.38M723.07 507.65a15.2 15.2 0 0 0 1.04-5.22c0-.17-.04-.52-.05-.15a14.1 14.1 0 0 1-1 4.85c-.05.14.04.44.01.52M717.4 504.32c.17-.27.27-.56.37-.85.03-.1.02-.23.02-.33l-.03-.19c-.1.3-.2.59-.37.86-.05.07-.02.24-.02.32 0 .02.01.22.03.19M721.51 506.9v-.66c0-.01 0-.26-.02-.26-.03 0-.03.25-.03.26v.67c0 .02 0 .26.03.26s.02-.24.02-.26M716.64 504.24a.37.37 0 0 0 .19-.1c.04-.04.02-.21.02-.27l-.02-.26a.37.37 0 0 1-.19.1c-.07 0 0 .53 0 .53M770.22 495.24c0-.35.04-.66.23-.97.04-.08.01-.25.01-.33 0-.02-.01-.21-.03-.18-.27.44-.26.98-.26 1.48 0 .02 0 .27.03.27s.02-.25.02-.27M785.66 495.62c.01-.46.12-.9.22-1.35a1.21 1.21 0 0 0 0-.5 8.27 8.27 0 0 0-.27 1.85c0 .02 0 .27.03.27s.02-.25.02-.27M777.93 495.88c.6-2 .73-4.09.74-6.17 0-.3-.05-.3-.05 0-.01 1.91-.15 3.81-.7 5.65-.05.15.03.43 0 .52M776.01 495.86v-1.35c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27v1.35c0 .02 0 .27.03.27s.02-.25.02-.27M782.15 496c.14-.55.05-1.1-.12-1.63-.01-.02-.04.16-.04.19 0 .1-.01.22.02.32.06.18.17.41.12.6-.02.1-.02.22-.02.33 0 .02.03.2.04.18M774.33 495.37c.01-1.26.23-2.5.35-3.75 0-.07-.02-.59-.03-.38-.14 1.38-.36 2.74-.37 4.13 0 .3.04.3.05 0M779.97 495.75c.6-.94.62-2.07.73-3.15.01-.07-.01-.59-.03-.38-.11 1.04-.13 2.11-.71 3.01-.08.12.04.47 0 .52M771.66 495.6c.12-.65.12-1.31.24-1.96.02-.12.01-.25 0-.37 0-.02-.01-.2-.03-.1-.12.66-.12 1.32-.24 1.98-.02.11-.02.24 0 .36 0 .02 0 .2.03.1M776.96 495.84c.14-.6.14-1.22.14-1.83 0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .46-.01.92-.11 1.37-.03.12-.02.25-.01.37 0 .01.01.19.03.1M774.79 496c.5-1.37 1.18-2.66 1.45-4.1.02-.1-.02-.5-.03-.46-.26 1.43-.94 2.7-1.44 4.04-.05.14.05.43.02.51M772.73 494.99c-.19-.31-.33-.68-.34-1.05 0-.02-.02-.21-.03-.19-.04.1-.02.23-.02.33.01.5.12.99.38 1.42.02.02.03-.17.03-.19 0-.08.03-.25-.02-.32M779.24 495.75c.11-.24.14-.5.25-.74.03-.1.02-.23.02-.33 0-.02-.03-.2-.04-.18-.1.23-.13.5-.24.73-.04.1-.02.24-.02.33 0 .02.02.21.03.19M784.42 493.66c.26.57.2 1.13.1 1.73v.37c0 .02.02.2.04.1.13-.9.26-1.87-.13-2.71.03.07-.08.38-.01.51M780.69 496.13c.4-.29.6-.76.73-1.24.03-.1.02-.22.02-.33l-.03-.18a2.1 2.1 0 0 1-.72 1.22c-.04.03-.02.22-.02.27l.02.26M783.48 496.46c.26-1.6.75-3.49-.25-4.92.03.05-.1.4-.02.51.84 1.2.47 2.6.24 3.95-.02.1.02.5.03.46M778.3 495.56c.12-1.06.33-2.1.59-3.14.03-.15-.04-.41-.02-.5a27.26 27.26 0 0 0-.61 3.26c-.01.07 0 .59.03.38M773.24 495.49v-2.46c0-.3-.05-.3-.05 0v2.46c0 .3.05.3.05 0M770.68 495.51c.18-.2.15-.5.15-.75 0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .1-.03.15-.1.22-.04.05-.02.2-.02.27l.02.26M783.13 495.37c0-.86 0-1.72-.13-2.57-.02-.1-.04.08-.04.1l.01.36c.1.7.1 1.4.1 2.11 0 .3.06.3.06 0M785.88 495.5c.12-.28.14-.57.14-.87 0-.02 0-.27-.02-.27s-.03.25-.03.27c0 .12-.05.24-.1.36-.04.09-.02.23-.02.32 0 .02.02.21.03.2M773.6 495.55c-.1-1-.12-2.01-.12-3.02 0-.3-.05-.3-.05 0 0 1.14.01 2.27.13 3.4.02.2.04-.31.03-.38'/%3e%3cpath d='M775.16 496.12c.12-1.72.13-3.45.24-5.17.01-.09-.02-.6-.04-.27-.11 1.72-.13 3.45-.24 5.17 0 .09.02.6.04.27M777.45 495.5c.27-.91.27-1.94 0-2.85.02.08-.06.36-.02.51.19.62.19 1.2 0 1.83-.04.14.04.42.02.51M779.61 496c.26-.82.37-1.63.38-2.48 0-.3-.05-.3-.05 0 0 .67-.14 1.32-.34 1.96-.05.15.04.43.01.51M782 493.9c.2.65.65 1.45.6 2.14 0 .07.02.58.04.38.08-1.1-.3-2.01-.62-3.04.03.09-.06.37-.01.52M771.07 495.24v-.49c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27v.5c0 .01 0 .26.03.26.02 0 .02-.25.02-.27M786.6 495.1a.84.84 0 0 1-.23-.48c0-.02-.01-.2-.03-.1-.02.12-.02.25-.01.37.02.28.08.53.26.75l.03-.27c0-.06.02-.22-.03-.27M780.94 495.84c.26-1.38.37-2.77.38-4.17 0-.3-.05-.3-.06 0 0 1.25-.12 2.48-.35 3.71-.02.1.02.5.03.46M775.87 513.62c.14-.55.25-1.1.26-1.67 0-.1.02-.23-.01-.32-.01-.02-.04.16-.04.18 0 .44-.12.87-.22 1.3a1.3 1.3 0 0 0 .01.5M779.73 513.26c.63-.71.63-1.71.63-2.61 0-.3-.05-.3-.06 0 0 .75-.05 1.5-.57 2.07-.1.11.06.46 0 .54M789.12 523.41l.12 1.35c0 .1.02.1.03 0v-.37l-.12-1.36c0-.09-.03-.08-.03 0-.02.13-.01.25 0 .38M773.18 525.44v.61c0 .02 0 .27.03.27s.02-.25.02-.27v-.61c0-.02 0-.27-.02-.27s-.03.25-.03.27M772.22 523.96v2.59c0 .3.05.3.05 0v-2.59c0-.3-.05-.3-.05 0M762.36 515.47c.5-.91.72-1.86.74-2.9 0-.17-.05-.51-.05-.14a5.4 5.4 0 0 1-.7 2.53c-.07.12.04.45 0 .51M762.71 518.43a2.22 2.22 0 0 0 1.23-2.12c0-.02-.02-.2-.03-.1-.12.78-.5 1.33-1.2 1.69-.1.05.04.51 0 .53M771.3 526.6a7.6 7.6 0 0 0-.26-1.67l-.03.19c0 .1 0 .22.02.33.1.42.21.85.22 1.29 0 .02.02.2.03.18.04-.1.02-.22.02-.32'/%3e%3cpath d='M762.35 515.96c.14.48.1.97.1 1.47 0 .02 0 .27.02.27.03 0 .03-.25.03-.27 0-.67.06-1.34-.14-1.98.03.08-.06.36-.01.51M761.04 517.53c.12-.63.24-1.24.25-1.88 0-.1.02-.23-.02-.33l-.03.19c0 .53-.12 1.04-.22 1.56-.03.12-.02.25-.01.37 0 .01.01.2.03.1M755.33 510.15c0 1.34.17 2.71-.46 3.93-.07.13.05.45.01.52.72-1.38.51-2.95.5-4.45 0-.3-.05-.3-.05 0M756.48 517.43c0-.3.02-.57.1-.86.03-.1.02-.22.02-.32l-.03-.19c-.14.44-.14.9-.14 1.37 0 .01 0 .26.02.26.03 0 .03-.25.03-.26M764.27 513.3c.1 1.13-.67 2.37-1.43 3.12-.1.1.07.47 0 .53a5.03 5.03 0 0 0 1.47-4.02c-.02-.21-.04.3-.04.37M757.4 511.77c-.12.9-.39 1.77-.38 2.7 0 .3.06.3.05 0 0-.76.26-1.5.35-2.24.02-.12.02-.24.01-.37 0-.01-.02-.2-.03-.1M759.58 517.45a5.14 5.14 0 0 0 1.23-3.24c0-.01-.02-.2-.03-.1a5.01 5.01 0 0 1-1.2 2.8c-.1.12.07.47 0 .54M736.16 503.45c.01.33-.22.69-.45.9-.05.04-.03.21-.03.27l.03.26c.45-.4.52-.99.5-1.57a.8.8 0 0 0-.03-.18c-.03.1-.02.22-.02.32M731.75 505.47v-1.48c0-.02 0-.27-.03-.27-.02 0-.02.25-.02.27v1.48c0 .02 0 .26.02.26.03 0 .03-.24.03-.26M729.2 505.73c.3-.5.4-1.18.24-1.75a.9.9 0 0 0-.04.19c0 .1 0 .22.02.32.06.22-.12.54-.24.72-.05.08-.02.25-.02.33 0 .02.02.21.03.19M724.74 506.57c.11-.52.13-1.06.13-1.59 0-.02 0-.26-.03-.26s-.02.24-.02.26c0 .38-.03.76-.11 1.13-.03.11-.02.25-.01.36 0 .02.01.2.04.1M719.9 507.22c.34-.35.5-.68.5-1.18 0-.1.02-.23-.01-.33-.01-.02-.04.17-.04.2 0 .3-.25.57-.45.78-.05.05-.03.21-.03.27l.03.26M720.86 503.64c-.04.2-.17.24-.35.21-.01 0-.06.52 0 .53.23.04.34-.06.38-.28.02-.12.01-.24 0-.36 0-.02-.01-.2-.03-.1M723.65 507.08c.36-.5.68-1.04.96-1.6.04-.08.02-.23.02-.32 0-.02-.02-.22-.03-.19-.28.56-.6 1.1-.97 1.6-.08.11.05.47.02.51M739.66 501.88c-.03.68-.15 1.31-.58 1.84-.1.12.07.45 0 .54.49-.6.6-1.35.63-2.1 0-.1-.03-.6-.05-.28M742.8 501.05c.01.46.07.95-.23 1.33-.04.05-.02.2-.02.26 0 .03.03.26.02.27.45-.56.3-1.47.27-2.12-.02-.33-.05.18-.05.26M745 502.65a2.2 2.2 0 0 0 .24-1.23c-.02-.1-.04.08-.04.1-.01.21-.13.42-.22.61-.04.09-.02.24-.02.33 0 .02.02.21.03.19M748.34 501.58c0-.07-.04-.1-.1-.07-.04 0-.03.53 0 .53.17 0 .14-.18.15-.32 0-.1.02-.23-.02-.33l-.03.19M720.16 490.68c.14-.6.13-1.22.13-1.84 0-.01 0-.26-.02-.26s-.03.25-.03.26c0 .47 0 .92-.1 1.38-.03.11-.02.24-.01.36 0 .02 0 .2.03.1M727.77 489.7c.01-.86.12-1.72.12-2.58 0-.3-.05-.3-.05 0 0 .86-.11 1.72-.12 2.58 0 .3.05.3.05 0M723.99 486.48c.1.58.4 1.5-.23 1.85-.1.05.04.51 0 .53.83-.44.38-2.13.26-2.84-.02-.1-.04.08-.04.1 0 .12-.01.24.01.36M725.82 488.09c-.08-.28-.1-.56-.1-.86 0-.01 0-.26-.02-.26-.03 0-.03.25-.03.26 0 .47.01.93.14 1.37l.03-.19c0-.1.01-.22-.02-.32M722.66 486.12c-.04.82.02 1.71-.35 2.47-.06.13.05.44.02.5.4-.8.34-1.81.37-2.7.01-.09-.03-.6-.04-.27M726.54 488.61c.25-.29.26-.63.26-1 0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27 0 .2-.1.34-.21.47-.05.05-.03.2-.03.27l.03.26M720.9 490.38c0-.31.12-.62.22-.92.03-.1.02-.23.02-.33 0-.02-.03-.2-.04-.18a4.6 4.6 0 0 0-.26 1.3c0 .1-.01.22.02.32.01.02.03-.16.03-.19M722.92 488.85c.14-.28.24-.55.26-.86v-.37c-.03-.1-.04.08-.04.1-.02.22-.14.43-.23.61-.04.09-.02.24-.02.33 0 .02.02.21.03.19M721.25 489.4c0-.33.1-.65.12-.99 0-.1.02-.23-.02-.32a.9.9 0 0 0-.03.18c-.01.33-.11.65-.12.99 0 .1-.02.23.02.33a.8.8 0 0 0 .03-.2M724.85 488.32a.42.42 0 0 1-.1-.22c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27 0 .25 0 .55.15.75l.03-.26c0-.07.01-.21-.03-.27M726.66 489.6c.26-.28.37-.64.5-1 .02-.1.01-.22 0-.32a.9.9 0 0 0-.02-.2c-.12.36-.23.71-.48.99-.04.05-.02.2-.02.26 0 .03.03.26.02.27M648.3 489.95v-4.68c0-.3-.06-.3-.06 0v4.68c0 .3.06.3.06 0M643.2 490.56c-1.43-2.13-2.34-4.6-1.68-7.25.03-.15-.04-.42-.02-.51-.72 2.92.03 5.82 1.7 8.27-.04-.05.08-.4 0-.51M646.83 490.18c-.26-.46-.43-.93-.24-1.45.05-.15-.05-.44-.02-.52-.28.8-.16 1.76.24 2.49-.03-.06.09-.39.02-.52M648.87 490.7a7.1 7.1 0 0 0 .14-1.61c0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .37-.02.73-.1 1.1a1.06 1.06 0 0 0 .01.51M645.02 490.31c-.59-1-.94-2.1-1.08-3.26-.02-.2-.04.31-.03.38a8.7 8.7 0 0 0 1.1 3.4c-.04-.06.08-.4 0-.52M647.68 490.34c-.12-.59-.23-1.17-.37-1.75.02.09-.05.36-.02.5.14.57.25 1.14.36 1.7.02.1.03-.07.04-.09l-.01-.36M645.5 490.06c-.45-1.22-.72-2.82.11-3.92.1-.12-.06-.44 0-.53-.98 1.3-.64 3.55-.12 4.96-.04-.08.06-.37 0-.51'/%3e%3cpath d='M642.96 489.07c-.55-1.33-.26-2.7 1.08-3.3.1-.03-.02-.51 0-.53-1.66.73-1.71 2.85-1.09 4.35-.03-.08.07-.38.01-.52M649.6 489.82a.96.96 0 0 1-.1-.36c0-.02 0-.27-.02-.27-.04 0-.03.25-.03.27 0 .3.02.6.14.87.01.03.03-.16.03-.18 0-.1.02-.24-.02-.33M646.1 486.85c-.41.5-.46 1.25-.61 1.85-.04.15.03.43.01.52.15-.6.2-1.35.6-1.84.1-.12-.07-.45 0-.53M643.93 490.18c-.2-.31-.34-.66-.35-1.04 0-.03-.02-.21-.03-.19-.03.1-.02.23-.02.33.01.52.1.98.38 1.42.02.02.04-.17.04-.19 0-.08.02-.25-.02-.33M646.35 490.06a2 2 0 0 1-.23-.74c0-.02-.02-.2-.03-.1a2.59 2.59 0 0 0 .25 1.35l.03-.19c0-.09.02-.24-.02-.32M649.33 489.82v.99c0 .02 0 .26.02.26.03 0 .03-.24.03-.26v-.99c0-.02 0-.26-.03-.26s-.02.24-.02.26M641.9 490.57c0-1.27-.11-2.55-.12-3.82 0-.3-.06-.3-.05 0 0 1.28.11 2.55.12 3.82 0 .3.05.3.05 0'/%3e%3c/g%3e%3cpath fill='%23999b9e' d='M692.79 473.45c-.43.16-.8.41-1.18.67-.05.03-.03.22-.03.27l.03.26c.38-.25.75-.51 1.18-.67.09-.03-.02-.53 0-.53M686.56 470.11a9.5 9.5 0 0 0-2.78 2.48c-.1.13.07.45 0 .54.76-1 1.7-1.86 2.78-2.49.1-.06-.04-.5 0-.53'/%3e%3cg fill='none' stroke='black' stroke-width='.92'%3e%3cpath fill='%23949699' stroke-width='.23' d='M660.05 288.89c.78 1.4 4.05 12.05 4.05 12.05-10.84-11.93-36.22-20.3-65.8-20.3-29.17 0-54.44 8.16-65.53 19.83-.18.19 1.69-5.34 3.9-10.62 2.16-5.16 4.67-10.08 4.83-10.18 13.05-7.96 33.64-13.09 56.8-13.09 23.33 0 44.05 5.2 57.08 13.26 0 0 4.02 6.37 4.67 9.05z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cg fill='%23fd0' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath d='M597.16 284.19s1.03 5.9 1.97 7.87c0 0 2.23-6.29 2.23-7.78M593.36 282.54s-1.48 5.8-1.42 7.99c0 0 4.6-4.83 5.21-6.2M590.43 279.25s-3.85 4.6-4.74 6.58c0 0 6.24-2.36 7.38-3.32'/%3e%3cpath d='M589.27 275.66s-5.29 2.83-6.86 4.34c0 0 6.67.14 8.1-.33'/%3e%3cpath d='M589.52 271.93s-5.96.68-7.97 1.5c0 0 6.14 2.6 7.64 2.68'/%3e%3cpath d='M591.04 268.71s-5.81-1.47-8-1.42c0 0 4.84 4.6 6.2 5.21'/%3e%3cpath d='M593.73 266.13s-4.86-3.51-6.9-4.27c0 0 2.79 6.06 3.83 7.13M597.64 264.65s-2.98-5.2-4.54-6.73c0 0 .05 6.67.57 8.08'/%3e%3cpath d='M601.08 264.74s-1.02-5.9-1.96-7.88c0 0-2.23 6.3-2.23 7.79M604.97 266.45s1.54-5.8 1.5-7.97c0 0-4.65 4.77-5.27 6.13'/%3e%3cpath d='M607.56 269.24s3.6-4.79 4.4-6.82c0 0-6.12 2.67-7.2 3.7'/%3e%3cpath d='M608.9 272.79s5.14-3.09 6.64-4.67c0 0-6.67.18-8.07.72'/%3e%3cpath d='M608.9 276.11s5.87-1.22 7.81-2.22c0 0-6.36-2.03-7.85-1.98'/%3e%3cpath d='M607.74 279.37s5.93.87 8.1.6c0 0-5.28-4.1-6.7-4.56'/%3e%3cpath d='M605.43 282.12s5.23 2.93 7.35 3.44c0 0-3.47-5.7-4.63-6.64M601.44 284.11s3.42 4.92 5.1 6.31c0 0-.62-6.64-1.26-8'/%3e%3cellipse cx='599.04' cy='274.46' rx='10.52' ry='10.1'/%3e%3c/g%3e%3cg transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath fill='black' d='M595.62 271.52c0 .49-.42.89-.94.89s-.94-.4-.94-.89.42-.88.94-.88.94.4.94.88' stroke='none'/%3e%3cpath stroke-width='.68' d='M592.77 271.5c1.02-1.52 2.71-1.45 3.88 0'/%3e%3cpath fill='black' d='M604.29 271.64c0 .49-.42.88-.94.88s-.94-.4-.94-.88c0-.49.42-.88.94-.88s.94.4.94.88' stroke='none'/%3e%3cpath stroke-width='.68' d='M601.44 271.61c1.02-1.52 2.71-1.45 3.88 0M597.38 275.32c.61.05 1.04.33 1.67.36.65.03 1.03-.26 1.58-.42'/%3e%3cellipse stroke-width='.68' cx='599' cy='278.37' rx='2.34' ry='.33'/%3e%3cpath stroke-width='.81' d='M598.04 280.83c.6 0 1.19.12 1.74-.06'/%3e%3c/g%3e%3cpath d='M557.53 278.96l-.95-2s-2.95.2-4.32 2.74c0 0-1.9-2.22-5.16-.95l-.1 2.95s2.21-3.06 4.53-.95c0 0-1.06 4.42 1.58 4.21 2.63-.2.84-3.9.31-4.1l-.52-.22s1.47-2.52 4.63-1.68zm-4.33 3.57c.15.62.07 1.18-.18 1.24-.25.06-.58-.39-.74-1-.16-.63-.08-1.18.17-1.25s.59.39.75 1zM575 271.52c-.21-.13-.73-.47-1.48-.34 0 0 .69.64.58.9 0 0-.1.55-.7.49 0 0-2.34-.26-4.24 1 0 0-1.33.2-1.43-.08 0 0-.23-.45-.03-.63a.19.19 0 0 1 .05-.03c.28-.15-1.42.23-1.03 1.04.39.82 1.28 1.12 2.05 1.05h.12v-.02s.56-.03 0 .01c.05.13 2.17 4.78 3.54 4.31 1.4-.47 1.57-4.85 1.42-5.33l-.07-.19s-.05-.16 0 0c.03 0 3.02-1.1 1.22-2.18zm-2.87 6.05c-1 .2-2.22-2.94-2.1-3.03 1.32-1.03 2.3-.89 2.57-.82-.16-.2.09.02.09.02l-.09-.02c.18.22.54 3.66-.47 3.85z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='1.61' d='M626.1 274.92c0-.38-.02-.75-.11-1.1a2.35 2.35 0 0 0-.44-.8 4.04 4.04 0 0 0-.9-.85c-.55-.34-1.11-.08-1.08.58.03.66.6 1.2 1.13 1.52.44.26.91.47 1.4.65 1.67.6 3.31.94 4.26 1.55.4.25.76.51 1.2.69a2.4 2.4 0 0 0 2.1-.09c.46-.27 1.15-.97.63-1.5-.6-.59-1.64-.38-2.36-.11-.56.21-1.17.55-1.64.9.27.58-.1 1.18-.23 1.83-.16.5-.32 1.01-.31 1.55.01.72 1.08 2.26 1.53.98.26-.74.13-1.85-.63-2.25-.2-.1-.39-.2-.59-.28-1.46-.6-2.97-.86-4.26-1.44a3.76 3.76 0 0 0-1.55-.3c-.45.03-.9.2-1.1.62-.17.32-.36.73-.15 1.07.43.7 1.6.06 2.06-.28.35-.26.58-.67.74-1.1a6 6 0 0 0 .3-1.84z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M645.98 282.55s-1.35-.7-2.25.73c0 0-3.35-.37-1.22-5.5.06-.14-2.16.92-1.69 4.2 0 0 .43 2.75 3.6 4.01 0 0 2.65.58 2.55-1.99 0 0-.13-1.24-.99-1.45zm-.77 2.25c-.32 0-.58-.27-.58-.6s.26-.6.58-.6c.32 0 .58.27.58.6 0 .33-.26.6-.58.6z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M644.19 281.61s1.46.43 2.06-1.15c0 0 3.37-.3 2.27 5.16-.03.15 1.94-1.33.84-4.45 0 0-.96-2.62-4.3-3.24 0 0-2.72-.05-2.12 2.44 0 0 .37 1.2 1.25 1.24zm.32-2.35c.3-.07.62.15.68.47a.59.59 0 0 1-.45.7.59.59 0 0 1-.68-.47.59.59 0 0 1 .45-.7z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23fd0' d='M672.31 408.85l-1.09-2.35s-3.38.25-4.95 3.21c0 0-2.17-2.6-5.91-1.11l-.12 3.45s2.54-3.57 5.19-1.1c0 0-1.2 5.17 1.81 4.93 3.02-.25.97-4.57.36-4.81l-.6-.25s1.69-2.96 5.31-1.97m-4.97 4.18c.18.72.1 1.37-.2 1.45-.29.07-.67-.45-.85-1.18-.18-.73-.09-1.38.2-1.45s.67.45.85 1.18M692.34 400.13c-.25-.15-.83-.55-1.7-.4 0 0 .8.75.67 1.06 0 0-.12.65-.81.57 0 0-2.67-.3-4.86 1.18 0 0-1.52.22-1.64-.1 0 0-.26-.52-.03-.74a.22.22 0 0 1 .05-.04c.32-.17-1.61.28-1.17 1.23.44.95 1.47 1.3 2.35 1.23l.13-.01v-.02s.65-.04 0 .02c.07.15 2.5 5.59 4.07 5.04 1.6-.55 1.79-5.68 1.62-6.24l-.08-.22s-.05-.19 0 0c.03-.01 3.46-1.3 1.4-2.56m-3.29 7.1c-1.15.22-2.54-3.45-2.4-3.56 1.5-1.2 2.62-1.04 2.94-.96-.19-.24.1.03.1.03l-.1-.03c.2.26.61 4.29-.54 4.51' stroke='none'/%3e%3cpath stroke='%23fd0' d='M626.1 274.92c0-.38-.02-.75-.11-1.1a2.35 2.35 0 0 0-.44-.8 4.04 4.04 0 0 0-.9-.85c-.55-.34-1.11-.08-1.08.58.03.66.6 1.2 1.13 1.52.44.26.91.47 1.4.65 1.67.6 3.31.94 4.26 1.55.4.25.76.51 1.2.69a2.4 2.4 0 0 0 2.1-.09c.46-.27 1.15-.97.63-1.5-.6-.59-1.64-.38-2.36-.11-.56.21-1.17.55-1.64.9.27.58-.1 1.18-.23 1.83-.16.5-.32 1.01-.31 1.55.01.72 1.08 2.26 1.53.98.26-.74.13-1.85-.63-2.25-.2-.1-.39-.2-.59-.28-1.46-.6-2.97-.86-4.26-1.44a3.76 3.76 0 0 0-1.55-.3c-.45.03-.9.2-1.1.62-.17.32-.36.73-.15 1.07.43.7 1.6.06 2.06-.28.35-.26.58-.67.74-1.1a6 6 0 0 0 .3-1.84z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23fd0' d='M773.7 413.05s-1.54-.83-2.57.85c0 0-3.85-.42-1.4-6.44.07-.17-2.47 1.08-1.93 4.91 0 0 .49 3.24 4.12 4.71 0 0 3.04.68 2.92-2.33 0 0-.15-1.45-1.13-1.7m-.88 2.63c-.37 0-.67-.31-.67-.7s.3-.7.67-.7c.36 0 .66.31.66.7 0 .39-.3.7-.66.7' stroke='none'/%3e%3cpath fill='%23fd0' d='M771.66 411.95s1.67.5 2.36-1.35c0 0 3.86-.35 2.6 6.04-.04.18 2.22-1.55.96-5.2 0 0-1.1-3.08-4.94-3.8 0 0-3.1-.06-2.41 2.86 0 0 .41 1.4 1.43 1.45m.36-2.76c.36-.07.7.18.78.56.08.38-.15.75-.51.82-.36.07-.71-.18-.79-.56-.07-.38.16-.74.52-.82' stroke='none'/%3e%3c/g%3e%3cg%3e%3cpath fill='%23fd0' d='M716.54 549.26l.09-3.64s16.09.7 23.83.62v2.84s-21.14.36-23.92.18'/%3e%3cpath fill='%235c5342' d='M744.34 543.92h6.45v1.66h-6.45z'/%3e%3cpath d='M753.97 544.68v3.4h-.35v-3.4L750 525.76l.2-.05 3.64 18.78 3.09-6.28.18.03M740.68 545.91h.35v2.3h-.35zM741.29 545.91h.35v2.3h-.35zM742.76 545.91h.35v2.3h-.35zM743.59 545.91h.35v2.3h-.35zM744.84 545.91h.35v2.3h-.35zM746.12 545.91h.35v2.3h-.35zM746.95 545.91h.35v2.3h-.35zM747.99 545.91h.35v2.3h-.35zM749.03 545.91h.35v2.3h-.35zM750.02 545.91h.35v2.3h-.35zM751.42 545.91h.35v2.3h-.35zM755.06 545.68h.35v2.3h-.35zM756.01 542.28h.35v5.34h-.35zM751.98 543.24h.35v4.97h-.35zM741.99 547.59h.48v.62h-.48z'/%3e%3cpath d='M752.88 547.84l.03-.02c.25-.17 2.09-1.45 2.6-1.44.53.01 1.13-.03 1.13-.03v.38l-1.17.04-2.03 1.06M754.73 548l.03-.02c.24-.18 2.07-1.48 2.57-1.48.54 0 1.14-.05 1.14-.05v.38l-1.16.06-2.01 1.09M750.75 543.04h1.6v.29h-1.6z'/%3e%3cpath d='M752.37 541.74c-.2.03-.36.62-.34 1.32.02.7.2 1.25.41 1.22.2-.02.36-.62.34-1.32-.02-.7-.2-1.25-.41-1.22m.06 2.17c-.15.02-.28-.37-.3-.86 0-.5.1-.92.25-.94.15-.02.28.37.29.87.01.5-.1.91-.24.93M746.04 528.22l-9.02.39v-.23l9.4-.34'/%3e%3cpath d='M737.14 522.23l4.04 23.16-3.74-12.84.04-.65 2.8 9.78-3.18-17.96.04-1.49z'/%3e%3cpath d='M739.27 545.55l-1.8-14.64-.15.57 1.57 13.87.3.11M738.15 545.43s-.04-5.31-.67-6.76l-.08.42.6 6.26c.04.46.15.08.15.08M737.44 533.88l-1.5 11.43.26.15 1.35-11.23M737.06 528.27l-1.94 16.01.19.27 1.71-15.94'/%3e%3cpath d='M737.36 532.4l-12.46 8.29-.15-.23 12.53-8.3v.16'/%3e%3cpath fill='%23858d8d' d='M744.7 542.83h6.45l-.35 1.09h-6.45z'/%3e%3cpath fill='%23755338' d='M755.24 545.24l.02-.12 1.9-8.03.25.05-1.9 7.9'/%3e%3cpath fill='%23fd0' d='M761.19 540.61c-.82.3-1.87-1.45-2.36-2.3-.48-.83-1.72-.53-1.72-.53l-.31 1.06c.24-.05 1.23-.19 1.66.55.49.84 1.53 2.6 2.36 2.29l-.46 1.33h.01l.82-2.4z'/%3e%3cpath fill='%23034ea2' d='M758.46 539.39c-.42-.73-1.42-.6-1.66-.55l-.17.57c.31-.06 1.2-.14 1.6.55.5.84 1.54 2.6 2.36 2.3l-.25.74.02.02.46-1.34c-.83.3-1.87-1.45-2.36-2.29'/%3e%3cpath fill='%23ed1c24' d='M756.52 539.77h.07c1.34.04 1.72 1.03 1.98 1.68.24.6 1.56 1.42 1.76 1.55l.26-.74c-.82.3-1.87-1.46-2.36-2.3-.4-.69-1.3-.6-1.6-.56l-.1.31s-.03.06-.01.06'/%3e%3cg fill='%23a37853'%3e%3cpath d='M737.46 533.62l13.1-8v-.17h-.28l-12.85 7.66v.37'/%3e%3cpath d='M737.6 528.53l.26 16.77-.5.2-.43-16.23.06-12.98.14.09.11 12z'/%3e%3cpath d='M736.25 545.64c0 .22.16.4.35.4l19.45-.29c.2 0 .35-.18.34-.4 0-.23-.16-.4-.35-.4l-19.45.28c-.2 0-.34.19-.34.41'/%3e%3c/g%3e%3cg stroke='black' stroke-width='.13'%3e%3cpath fill='%23616264' d='M727.71 541.95s.8.04 2.43.3c0 0-1.8.24-2.77.55-.98.32-2.87 2.18-3.27 2.54-.4.35-.58.53-.58.53l-3.06-.02s1.42-1.83 2.03-2.27c.6-.45 1.81-1.26 2.4-1.36.6-.1 1.7-.36 2.82-.3' stroke='none'/%3e%3cpath fill='%23a3a5a8' d='M736.66 546.21a6.06 6.06 0 0 0-5.93-3.95h-.1c-4.53.19-4.76 2.05-6.47 3.61h-.32l-.04.06s9.32.28 12.86.28z'/%3e%3cg fill='%23797a7d' stroke='none'%3e%3cpath d='M735.41 545.57a.1.1 0 0 1-.14-.05.11.11 0 0 1 .05-.15.1.1 0 0 1 .14.06.1.1 0 0 1-.05.14M735.17 545.08a.11.11 0 0 1-.15-.03.1.1 0 0 1 .03-.15.11.11 0 0 1 .15.03.1.1 0 0 1-.03.15M734.87 544.63c-.05.03-.11.03-.14-.02-.04-.05-.04-.11.01-.15.05-.04.12-.04.15.01.04.05.03.12-.02.16M734.52 544.22a.1.1 0 0 1-.15 0 .12.12 0 0 1 0-.16.1.1 0 0 1 .15 0c.05.05.04.12 0 .16M734.14 543.84a.11.11 0 0 1-.15.02c-.05-.04-.05-.1-.02-.15s.1-.06.15-.02c.05.04.06.1.02.15M733.73 543.51c-.03.05-.1.06-.15.03a.1.1 0 0 1-.03-.14c.03-.05.1-.07.15-.04.06.03.06.1.03.15M733.27 543.23c-.03.05-.1.07-.14.04a.12.12 0 0 1-.05-.15.1.1 0 0 1 .15-.04c.05.03.07.1.04.15M732.79 543a.11.11 0 0 1-.14.06.11.11 0 0 1-.06-.14.1.1 0 0 1 .14-.06.1.1 0 0 1 .06.14M732.29 542.8a.11.11 0 0 1-.13.08.1.1 0 0 1-.08-.13c.02-.05.08-.1.13-.08.06.02.1.07.08.13M731.77 542.69c-.01.06-.06.1-.12.09a.12.12 0 0 1-.09-.13c.01-.06.06-.1.12-.09.06.01.1.07.09.13M731.24 542.62c0 .06-.05.1-.11.1a.1.1 0 0 1-.1-.1c0-.07.05-.12.11-.11.06 0 .1.05.1.11M730.71 542.6c0 .06-.04.1-.1.1a.1.1 0 0 1-.11-.1c0-.05.04-.1.1-.11.06 0 .1.05.11.11M730.18 542.64c0 .06-.04.11-.1.12a.1.1 0 0 1-.11-.1.1.1 0 0 1 .1-.12.1.1 0 0 1 .11.1M729.65 542.69c0 .06-.03.11-.1.12a.11.11 0 0 1-.11-.1.1.1 0 0 1 .09-.12c.06 0 .11.04.12.1M729.13 542.77c.01.06-.02.12-.08.13a.1.1 0 0 1-.13-.08.11.11 0 0 1 .09-.13.1.1 0 0 1 .12.08M728.61 542.89a.1.1 0 0 1-.07.13c-.06.01-.12-.03-.14-.08a.1.1 0 0 1 .08-.13c.06-.01.11.02.13.08M728.11 543.06c.02.06 0 .12-.06.14a.1.1 0 0 1-.14-.06.1.1 0 0 1 .06-.14.1.1 0 0 1 .14.06M727.62 543.27c.03.06.01.12-.04.15a.1.1 0 0 1-.14-.03.11.11 0 0 1 .04-.15.1.1 0 0 1 .14.03M727.17 543.56c.03.05.02.12-.02.15-.05.03-.11.03-.15-.02-.04-.05-.03-.12.02-.16.05-.03.12-.02.15.03M726.76 543.91a.1.1 0 0 1 0 .15.11.11 0 0 1-.16 0 .1.1 0 0 1 0-.16.1.1 0 0 1 .16.01M726.39 544.29c.04.04.05.1 0 .15a.1.1 0 0 1-.14.01.11.11 0 0 1-.01-.15.1.1 0 0 1 .15 0M726.03 544.7c.05.04.05.1.01.15a.1.1 0 0 1-.15.02.11.11 0 0 1 0-.16.1.1 0 0 1 .14-.01M725.68 545.1a.1.1 0 0 1 0 .15.1.1 0 0 1-.15 0 .11.11 0 0 1 0-.15.1.1 0 0 1 .15 0'/%3e%3c/g%3e%3cpath fill='%23939598' d='M729.55 542.2c-4.65.17-4.85 2.06-6.59 3.63l.88.03.32.01c1.71-1.56 1.93-3.42 6.48-3.6a6.23 6.23 0 0 0-1.09-.07z'/%3e%3cg fill='%23442c13' stroke-width='.12'%3e%3cpath d='M596.42 395.94l.13-2.25.52-.03v.62l3.72-.1-.81 2.09-3.53-.13-.06-.3' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M598.22 389.02l.1 5.58-.46.03.23-5.61zM600.28 388.69l.1 5.68-.33.06.03-5.74zM602.59 393.2l-.23-5.42-.13.04.1 5.41zM605.91 392.63l.99-4.98-.1.07-1.2 4.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M602.23 387.81l-2.25 6.5-.36-.07 2.35-6.46zM602.75 387.91l.56 4.9.29-.04-.62-4.86z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cpath fill='%23a48b58' stroke-width='.12' d='M606.8 387.71h-5.1l-3.61 1.3 4.27.14z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23a37853' stroke-width='.12' d='M597.96 389.15l3.85-1.27 5.1-.1.02-.36-5.22.1-3.72 1.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M722.38 542.35c0-.8.53-1.45 1.2-1.45.57 0 1.05.5 1.16 1.16l.25-.04c-.13-.8-.71-1.41-1.42-1.41-.8 0-1.44.78-1.44 1.74 0 .28.06.54.16.78l.22-.15c-.08-.19-.13-.4-.13-.63z'/%3e%3cpath fill='%23939598' d='M721.11 545.75c1.9-1.6 1.96-3.58 6.67-3.78a6.25 6.25 0 0 0-1.09-.06c-4.8.17-4.85 2.18-6.76 3.78a.6.6 0 0 0-.1.13l1.19.03.09-.1z'/%3e%3c/g%3e%3cpath fill='%23fd0' d='M743.67 548.94v-.25s12.6.02 12.66-.71c.08-.75-6.1-.45-15.75.05'/%3e%3cpath fill='%23696161' opacity='.75' d='M708.02 530.86c-.75.09-1.3-.77-2 .34l-.06.07c-.48.56-.73 1.34-.43 1.93.17.35 1 .66 1.37.71.92.13 1.66-.63 1.75-1.52.43.54 1.68.56 2.31.6 1.1.06 1.4-.14 1.58-1.32.65.93 1.17 1 2.27.8 1.27-.22 2.74-.37 3.67-1.33.35.55.86.85 1.48.85.54.01 1.25-.09 1.75-.28.42-.16.89-.75 1.31-.83.33.5.98.3 1.41.39.81.5 1.69.82 2.99.11.34-.19 1.56.27 1.98.07.3-.15.36-.44.6-.6.54.42 1.4-.01 1.97-.16.45.02 1.08-.05 1.25-.6.79-.49.56-.9.31-1.12-1.26-.52-2.13-.52-3.3.34-.4-.1-.59-.1-.87.42-.5-.78-1.39-1-2.3-.44-.78-.45-1.18-.12-1.81-.1-1.26-.96-3.5-.83-5.06.1-1.77-.84-2.31-.36-3.48.53-.66-.3-1.47-.11-2.2-.06-.64.05-.98.89-1.55.6-1.27-.61-1.88.34-2.83.3-1.04-.91-2.1.2-2.1.2'/%3e%3cg%3e%3cpath fill='%2384848a' d='M707.99 548.97c0 .61-.48 1.1-1.08 1.1-.6 0-1.08-.5-1.08-1.1v-13.59c0-.6.48-1.1 1.08-1.1.6 0 1.08.5 1.08 1.1v13.59z'/%3e%3cpath fill='%23453717' d='M717.07 546.5s-.7.69-.87.75c-.17.05-1.01.42-1.18.42-.17 0-.53.03-.92.03h-.76l-.68-.05.28 1.34 3.76.09.37-2.58z'/%3e%3cpath fill='%236a5e46' d='M713 546.61h-1.4l-.02.14h-1.22l-.27 2.26 2.85-.02'/%3e%3cg fill='%23453717'%3e%3cpath d='M710.59 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17a.06.06 0 1 1 .11 0v1.17zM710.9 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17a.06.06 0 1 1 .11 0v1.17zM711.23 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17c0-.04.02-.06.05-.06s.06.02.06.06v1.17zM711.74 548.62a.06.06 0 1 1-.11 0v-1.17c0-.04.02-.06.05-.06.03 0 .06.02.06.06v1.17zM712.21 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17c0-.04.02-.06.05-.06s.06.02.06.06v1.17zM712.61 548.62c0 .03-.02.06-.06.06s-.05-.03-.05-.06v-1.17c0-.04.02-.06.05-.06.04 0 .06.02.06.06v1.17z'/%3e%3c/g%3e%3cpath fill='%232f2311' d='M709.66 548.93v-.12l.06-2.6-.28.08-.03 1.33-.28.1-.11-.3h-.68l-.23.1v1.23zM700.94 547.33l-.37.03v.2h-.42l-.03-.41h-.36v-.32l-.45-.02-.08-1.09H699v-1.49l-.31-.03.1 3.18-.18.03v.35h.2l-.09 1.05 4.27.24-.12-1.72h-.4v.23l-1.1-.12-.07.4h-.28z'/%3e%3cpath fill='%23866d46' d='M703.75 547.72l-.91-.04.15 1.25.78-.08z'/%3e%3cpath fill='%23acacad' d='M708.09 539.94a1.7 1.7 0 0 0-1.19-.44c-.48 0-.91.17-1.18.44a.57.57 0 0 0-.02.14c0 .05 0 .1.02.14.27-.27.7-.44 1.18-.44.5 0 .92.17 1.19.44l.02-.14-.02-.14'/%3e%3cpath fill='%23866d46' d='M707.28 547.33l-.04-.38.27-.34-.68-.12-.04.36-.35.02-.06.2h-.25l-.17.06-.12.37-.2-.26.09 1.6 2.22-.05v-1.44'/%3e%3cpath fill='%232f2311' d='M703.5 548.93l2.4-.08-.08-1.23-2.25.02'/%3e%3cpath fill='%23453717' d='M698.38 548.94l.04-1.76-.49.08h-.34l-.26-.15-.04.11-1.23.04-.15-.38-.75.07-.04.27-.93.04-.15-.35h-.26v-1.9l-.41.03-.19 2.3-.37.03v-.3l-.49-.04-.07.57-.57-.08.04-.53h-.52l-.08.61-3.17.08.15-2.76-.53-.07.04 2.75s-2.06-.69-2.4-1.03l1.24 1.49s4.11.8 11.93.88'/%3e%3cpath fill='%23895f33' d='M685.52 547.95s-.67-.2-5.9-1.8c-5.25-1.6-7.75-2.75-8.24-2.9-.49-.15-1.2 0 1.01 1 2.2.99 10.51 3.85 11.9 3.82 1.38-.04 1.5.07 2.43-.12.93-.2-1.2 0-1.2 0'/%3e%3cpath fill='white' d='M708.02 530.86c-.76.09-1.3-.77-2 .35l-.06.06c-.48.56-.73 1.34-.44 1.93.18.35 1 .66 1.38.72.91.12 1.66-.64 1.74-1.53.44.54 1.69.56 2.32.6 1.1.06 1.4-.14 1.58-1.32.65.93 1.16 1 2.27.8 1.27-.21 2.74-.37 3.67-1.33.35.55.86.85 1.48.86a5.2 5.2 0 0 0 1.75-.29c.42-.16.88-.75 1.31-.83.33.5.98.3 1.41.4.8.5 1.69.8 2.99.1.34-.18 1.55.27 1.98.07.3-.15.36-.44.6-.6.54.42 1.4 0 1.97-.16.45.03 1.08-.05 1.25-.6.79-.49.56-.9.3-1.12-1.25-.51-2.12-.51-3.3.34-.39-.1-.58-.09-.86.42-.5-.78-1.39-1-2.3-.44-.78-.45-1.19-.12-1.81-.1-1.26-.96-3.5-.83-5.07.1-1.76-.84-2.3-.36-3.47.53-.66-.3-1.47-.11-2.2-.05-.65.05-.98.88-1.56.6-1.26-.62-1.87.33-2.82.29-1.04-.91-2.11.2-2.11.2'/%3e%3c/g%3e%3cg%3e%3cpath fill='%23ffe600' d='M740.68 548.21l.61.77H716.6l-18.03-.23s-7.85-.2-11.7-.58c-3.86-.38-8.24-1.49-8.24-1.49.04 1.19.87 1.8 1.54 2.41.09.08.25.17.46.25 1.45.59 5.41 1.32 6.68 1.55 1.46.27 6.66.57 10.18.53 3.51-.03 39.24-.19 39.24-.19v-.34c1.38.23 18.93-1.07 18.93-1.07.05-.08.1-.21.17-.37.18-.44.38-1.1.47-1.36l.03-.12-15.65.24z'/%3e%3cpath d='M683.35 552.03l-8.83-7.03.68.23 8.15 6.5z'/%3e%3ccircle transform='matrix(1.14637 0 0 1.17117 33.18 82.14)' fill='%23565759' stroke='black' stroke-width='.23' cx='567.74' cy='398.67' r='.48'/%3e%3cpath fill='%23565759' stroke='black' stroke-width='.13' d='M684.74 550.52l.06.2c-.36.4-.67.21-.67.21v-1.58a.22.22 0 0 0 .14-.2c0-.13-.1-.23-.22-.23-.11 0-.21.1-.21.22 0 .09.05.16.12.2v1.6s-.32.19-.68-.23l.06-.2-.48.07.19.44.08-.13s.5.43.89.43h.04c.38 0 .9-.43.9-.43l.08.13.19-.44-.49-.06z'/%3e%3cpath d='M686 549.04c0-.18.15-.33.33-.33.17 0 .32.15.32.33 0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33M689.02 549.65c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M692 549.76c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M695.42 549.71c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M698.73 549.76c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M701.82 549.71c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M710.57 550.05c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33M719.55 550.28c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M722.63 550.39c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M725.33 550.39c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M728.08 550.39c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M730.71 550.34c0-.18.15-.33.33-.33.17 0 .32.15.32.33s-.15.33-.32.33a.33.33 0 0 1-.33-.33M733.24 550.22c0-.18.15-.33.33-.33s.32.15.32.33c0 .18-.14.33-.32.33s-.33-.14-.33-.33M735.88 550.22c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M704.79 549.76c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33M707.6 549.93c0-.18.15-.33.33-.33.17 0 .32.15.32.33 0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33'/%3e%3cg fill='none' stroke-width='.23' stroke='black' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3ccircle cx='622.02' cy='399.23' r='.35'/%3e%3ccircle cx='624.18' cy='399.04' r='.35'/%3e%3ccircle cx='626.28' cy='398.89' r='.35'/%3e%3c/g%3e%3cpath fill='%23ed1c24' d='M682.56 551.38l.5.4-.09.31a1 1 0 0 0 .22.29l.09.09h.03c1.05 1.03 3.88 2.59 3.88 2.59l12.15.35h.22s55.16-.37 55.16-.66-.47-2.56-.47-2.56-.29-.23-.59-.16c-.73.17-4.72.52-7.57.81-.94.1-1.79.18-2.31.25-2.09.31-.28 0-.28 0s-21.54.24-24.53.16c-2.99-.07-20.38.09-20.38.09s-10.91-.78-11.81-.78-2.69-.76-3.44-.84a2.55 2.55 0 0 1-.78-.34z'/%3e%3cpath fill='%23034ea2' d='M755.83 549.45c-.06.16-.12.3-.17.37 0 0-17.55 1.3-18.93 1.07v.34s-35.73.16-39.24.2a82.1 82.1 0 0 1-10.18-.54c-1.27-.23-5.23-.96-6.67-1.54l-.73.09s1.57 1.3 2.64 1.94c.34.2.62.33.8.35.74.08 2.54.84 3.44.84s11.82.77 11.82.77 17.36-.16 20.35-.08c3 .08 24.54-.15 24.54-.15s-1.8.3.3 0 8.9-.84 9.87-1.07c.3-.08.65-.36.97-.72.68-.77 1.28-1.88 1.28-1.88l-.09.01'/%3e%3cpath fill='%23fd0' d='M716.54 549.26l.09-3.64s16.09.7 23.83.62v2.84s-21.14.36-23.92.18'/%3e%3cg fill='%239b7e39'%3e%3cpath d='M730.02 554.92l.39.29.42-.29-.17-2.78-.53-.02-.11 2.8zM729.34 552.14l-.83 2.47.28.38.49-.15.62-2.72h-.1l-.46.02M727.16 553.87l.17.46h.5l1.2-2.18-.7.04-1.17 1.68zM726.12 552.82l.04.48.49.14 1.23-1.23-1.05.03-.71.58zM731.86 554.7l.46.13.3-.41-.96-2.24-.6-.02.8 2.54zM732.96 554.21l.47.02.2-.47-1.13-1.55-.72-.03 1.18 2.03zM734.1 553.31l.47-.1.07-.52-.55-.43-1.1-.03 1.11 1.08z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3cg fill='none' stroke='%23d0c9ce' stroke-width='.13'%3e%3cpath fill='white' stroke='%23999b9e' d='M716.79 523.61l.12.1s.12-.2.24-.2.43.15.43.15l.06-.2.54.15-.03-.26s.36.05.35.02l-.04-.22.45.03-.03-.2s.61.08.6.04l-.13-.24s.5.05.7.05c.2 0 .18.06.18.06v-.16l.8-.02-.13-.19.6-.01-.26-.28s1.2.4 1.57.04c0 0-.55.04-1.16-.16-.62-.2-1.2-.26-1.42-.32a8.02 8.02 0 0 1-1.7-.66h.21s-1.34-.51-2.03-.62c0 0-.87-.18-1.28.12 0 0-.19.24-.34.3-.15.07-.48.29-.5.32-.03.03-.1-.07-.5.17 0 0-.1.04-.12.03 0 0-.77-.39-1.68-.03l-.07.04s-.37-.17-.66-.17c-.03 0-.34-.18-.4-.21l-.02-.01s-.37-.77-1.06-.7c-.68.06-1 .22-1.1.25-.1.02-.8.27-.94.3-.14.03-.45.17-.45.17s-.62.27-.76.3c-.15.02-.99.21-1.02.21-.04 0 .08.04.1.04 0 0-.64.2-1.02.24-.36.05-1.5.23-1.6.2-.08-.02-.03 0-.03 0s.33.17 1.27.08l.37-.01h.04l-.41.2c.02-.01.99-.01.8.03-.07.02-.3.18-.3.18l.93.01-.13.13s.86.04.95.02l-.15.18s.44-.02.74-.1l-.15.22.63-.03-.23.23s.4.06.5.04l.05-.01-.17.14h.6l-.06.12.53-.1.14.16s.42-.19.47-.18l.27.2s.27-.23.3-.24h.04s.1.22.21.28c0 0 .2-.14.26-.13.05 0 .15.15.15.15l.14-.13.35.13s.07-.2.17-.17c.1.02.52.79 1.46.85 1.18.07 1.65-.59 1.65-.59l.35-.22.05.21.37-.17v.1s.47-.2.48-.28l.17.24s.3-.2.33-.19c.05.01.1.14.34.18'/%3e%3cpath d='M713.3 523.5l.06.08M713.12 523.57c0 .04.02.08.04.11'/%3e%3cpath stroke='white' d='M706.23 522.25a.15.15 0 0 1-.1.05M705.93 522.31c-.05.02-.09.06-.15.07'/%3e%3cpath d='M720.25 522.73s-1.37-.35-1.83-.83c0 0 .04-.09-.02-.16s-.03-.02-.03-.02.24.14.45.12c0 0-.02-.17-.14-.25M719.97 521.74s-.72.03-1.17-.02'/%3e%3cpath d='M720.57 522.06s-.24 0-.41.04c-.17.03-.7.05-.89-.06-.19-.12-.3-.13-.44-.17M719.34 522.77c-.04 0-1.01-.34-1.33-.72M718.89 522.99s-.67-.13-1.45-.92M718.48 523.17c-.04-.03-1.45-.46-1.5-1.13M718.16 523.36s-.8-.16-1.5-1.19M717.64 523.46s-.82-.63-1.04-1.12M717.16 523.53c-.02-.04-.59-.76-.67-1.23M716.43 523.42s-.3-.9-.19-1.29M715.94 523.38c0-.03-.04-.08.02-.34a.78.78 0 0 0-.05-.51M715.45 523.56c0-.02 0-.31.1-.52.1-.21.14-.41-.01-.65M715.03 523.53s-.06-.2.13-.45l.02-.23s.07.01.05-.04l-.06-.14M714.37 522.05c.08-.07.2-.24.19-.27l-.05-.1.08.1s.04.01.13-.05c.1-.07.2-.07.26-.14.06-.06.1-.12.15-.14.04-.03.12.02.2-.01.07-.03.3-.15.34-.2l.1-.14c.04-.03.1-.12.1-.12s.25.07.42.07l.4-.01c.15 0 .5-.03.64 0l.53.08c.05 0 .2.05.33.07.11.02.31-.04.38-.06'/%3e%3cpath d='M715.05 522.61c.06.02.2.08.22.13-.05-.12.13-.2.2-.28.07-.09.07-.19.07-.3M715.39 521.98c.21.18.39.38.56.6.02-.13.02-.25.07-.38.03-.06.14-.13.12-.21'/%3e%3cpath d='M715.78 521.36l.15.34c.05.1.09.22.16.3.06.08.15.14.24.2.07.04.16.11.24.13.06-.05.08-.16.08-.23 0-.08-.1-.2-.05-.27M716.39 521.32c.03.32.22.48.5.65.11.06.33.17.45.15.18-.02.1-.22.1-.32'/%3e%3cpath d='M716.72 521.41c.08.08.2.12.3.18l.2.2c.04-.03.04-.1.02-.12M717.01 521.26c.02.1.12.25.19.33.1.12.22.23.36.3.08.06.23.13.33.13.14.01.13-.13.08-.21.08.13.33.08.45.12'/%3e%3cpath d='M715.74 521.37c.24 0 .46-.07.7-.1.16-.02.34-.04.5-.02.15.02.29.08.43.08.04-.08-.04-.2-.09-.26M717.44 521.12c.12.1.24.19.4.24.06.03.13.03.19.06.05.02.08.06.12.1M717.56 521.41c.13.04.26.08.3.22M714.87 522.73c-.06.09-.1.18-.18.26M715.4 522.74c0 .06.02.12 0 .17M715.38 523.17c-.02.08-.06.17-.05.26.02 0 .02-.01.03-.02M715.87 523.18l-.03.12M715.6 522.3c.05.07.07.14.12.2.04.06.08.09.09.15M716.14 522.54a.2.2 0 0 1-.05-.1M716.1 522.32l.06.12M716.11 522.18l.04.08M716.31 523.31l.04.05M716.54 523.05c.04.06.04.13.06.2M716.86 523.41c-.04-.05-.02-.11-.04-.17M717.63 523.25c.04.04.08.07.14.08M717.93 523.41c.04.04.16.06.17 0M717.91 523c.04.06.1.11.17.14M718.83 522.68c.1-.01.18.07.28.08M718.86 522.27c.03.05.16.2.23.2M719.43 522.56c.02.06.19.06.24.09M717.15 520.76l.2.1c.05.02.13.06.19.03M716.92 520.76c.11 0 .19.09.3.09a.46.46 0 0 0-.12-.05M716.67 520.78c.12.03.12.04.2.12v-.03M716.43 520.72c.05.05.13.07.16.14M716.3 520.73c0 .04.03.07.07.09M716 520.8a.17.17 0 0 1-.08-.1M716.11 521.45c.19.1.23.3.28.47M718.7 521.38c.15.03.21.13.33.2 0-.03-.01-.02-.03-.03M718.24 521.29c.12.05.25.05.34.13l.11.12.02-.04M717.34 522.2c.07.05.15.13.2.2.03.04.05.11.09.14M714.95 521.66c.08.07.26.08.24.21 0 .05-.06.08-.07.13 0 .05.03.1.04.14M714.88 521.86c.03.06.1.1.04.17l.01-.02M715.35 521.5c.12.09.25.14.35.25.05.05.1.2.16.21M715.19 521.16c.18.06.2-.1.32-.17M715.58 521.09c.07-.07.04-.23.15-.26M715.4 520.85c.12-.1.16-.23.34-.25M714.21 521.58c.07.03.14.07.13.15M714.16 521.73c.02.03.05.06.05.1a.25.25 0 0 1-.04-.03M713.95 521.65l.06.08c.03.03.02.05.03.04M714.36 522.18c-.03.08 0 .17 0 .23M714.01 523.45c.02.04.05.24-.03.22M711.49 522.3c.06 0 .06-.05.1-.07.05-.03.1-.03.16-.03M711.78 522.47c.02.03.02.06 0 .06M711.62 522.49v.05M711.5 522.48l-.01.06M712.08 521.56a.92.92 0 0 0-.12.25h.03M712.25 521.65a.22.22 0 0 0-.05.15M712.53 521.4l-.16.11M711.49 521.82c-.15-.05-.18-.1-.19-.22-.12 0-.3-.19-.2-.3-.04.21-.3.13-.43.06a1 1 0 0 1-.45-.46c-.05.09-.13.08-.24.08-.21 0-.42.03-.64.04-.23.02-.45-.07-.68-.06-.2 0-.36.1-.55.13l-.5.01M711.71 521.48c-.1.02-.22.01-.3.08.02.01 0 .02 0 .03M705.85 521.64c.27.01.54.07.81.06.14 0 .27-.03.4-.05.12-.02.26-.03.36-.08M705.95 522.57c.24-.01.5-.1.74-.17.26-.06.52-.13.75-.26a.45.45 0 0 0 .23-.24c.04-.1.11-.2.12-.31M706.75 522.74c.12-.03.23-.17.34-.23.11-.07.24-.1.37-.14.27-.09.52-.23.71-.42M707.33 522.84c.1-.1.26-.11.39-.17a2.74 2.74 0 0 0 .94-.8M707.85 522.99l.8-.4c.13-.08.24-.17.36-.28.09-.08.13-.22.22-.3M708.17 523.26c.28-.17.57-.35.84-.55.23-.18.5-.3.62-.58M708.58 523.42c.14-.25.38-.45.62-.62.19-.13.37-.28.39-.51M709.08 523.44c0-.09.09-.18.14-.25l.23-.31c.08-.13.13-.26.19-.4M709.7 523.4c.09-.25.1-.54.13-.8v-.2c0-.1.04-.18.07-.28M710.27 523.33c.02-.06-.02-.11-.02-.17 0-.06.03-.1.04-.15.02-.1 0-.24 0-.34 0-.1-.04-.23-.01-.33.02-.08.12-.13.2-.17M710.75 523.5c-.08-.26-.28-.5-.26-.77 0-.12.01-.29.13-.35M711.02 523.53c.07-.17.07-.47.01-.64M711.56 523.49c-.08-.16-.24-.26-.2-.45.02-.1.08-.17.1-.27'/%3e%3cpath d='M711.3 522.71a.4.4 0 0 1-.23.16c-.09.02-.2-.02-.27.06-.06-.08-.03-.29-.03-.39 0-.13-.02-.27.03-.4.09-.22.31-.35.56-.39'/%3e%3cpath d='M711.18 521.61c-.12.18-.37.09-.51.24-.13.14-.15.41-.11.58.04-.04.1-.05.16-.09M710.45 521.28c-.04.12-.17.18-.24.28-.07.09-.09.18-.11.28-.03.1-.04.2 0 .3.04.1.08.18.1.27M710.06 521.06c-.03.21-.32.4-.48.54-.07.07-.13.15-.11.25.02.07.08.12.12.18l.05.14a.56.56 0 0 1 .18-.1c.08-.02.19-.02.24-.08M707.94 521.14c-.2.18-.57.27-.68.52M708.67 521.72c-.07.06-.14.15-.22.2-.1.04-.2.03-.31.03M707.66 521.94c.12-.06.54-.06.56-.22M708.77 522.11c.16-.01.3-.01.38-.15M708.21 521.71c-.02.08-.07.16-.08.23M708.66 521.74c.11.1 0 .3.13.38M709.56 521.2l-.25.27c-.06.05-.15.1-.18.18-.04.1.01.2.03.3M708.94 521.08c.08.08.2 0 .3.02.06 0 .14.03.25.02.09-.01.17-.04.26 0 .05.04.08.1.16.1M709.42 521.86a.93.93 0 0 1-.26.12M708.25 521.53l-.04.11M708.49 521.5c.1-.15.2-.19.34-.26M711 521.08c0 .04-.02.09 0 .12v-.03M710.8 520.92c0 .1.02.12.06.21l-.04-.05M710.68 520.89c-.01.05-.01.12.01.15M710.37 520.73a.5.5 0 0 1 .1-.12M710.33 520.6a.46.46 0 0 1-.14.14M710.15 520.58a.2.2 0 0 1-.13.15M709.94 520.64a.35.35 0 0 1-.16.11M709.63 520.66a.52.52 0 0 1-.14.1M709.36 520.67c-.01.03-.05.05-.09.05M711.39 522.05c.02-.09.18-.1.26-.08M711.2 522.18c.04-.01.07-.05.07-.08M710.12 522.61c0 .1.01.17-.06.26M709.92 523.42v-.1M710.04 523.29c0 .02 0 .05-.02.07M709.87 523.21c0 .02 0 .04-.02.06M709.32 523.42s0-.03.02-.04M709.54 523.29v.06M709.76 522.47c0 .1 0 .26-.1.35M710.25 521.28c-.1.13-.42.24-.4.41M709.35 521.25a.15.15 0 0 1-.07.06M709.6 521.32l-.1.15M710.66 521.59c-.15.05-.29.1-.32.25M708.75 522.2c.02.14-.15.26-.29.3M709.42 522.19c-.05.06-.13.14-.21.16M708.39 522.89c-.02.05-.07.08-.1.11M708.09 523.04c-.04.02-.12.1-.16.07M707.6 522.44c-.02.06-.1.09-.14.12M707.11 522.67l-.24.06'/%3e%3cpath stroke='white' d='M706.76 522.55c-.03.05-.1.08-.15.09'/%3e%3cpath d='M707.13 521.42a.8.8 0 0 0-.4.14'/%3e%3cpath stroke='white' d='M706.03 522.48c-.04.02-.11.06-.16.04M704.9 522.16c.2-.12.48-.17.7-.22.12-.03.21-.05.3-.1.1-.05.18-.11.26-.14'/%3e%3cpath d='M706.66 522.49h-.14'/%3e%3c/g%3e%3cpath fill='%232f3b30' stroke='white' stroke-width='.13' d='M711.87 544.25s.26-1.37 1.24-1.63c.98-.27 2.01-1.06 2.01-2.06s-.57-1.58-1.19-1.9c0 0 1.86-1.26 1.86-3.1 0-1.85-1.96-2.85-1.96-2.85s3-1.16 3.2-2.69c.2-1.53-1.34-3.32-1.8-3.84-.47-.53-1.2-.58-1.2-.58l.32.63-.62-.27s.3.87 1.13 1.59c.62.53 1.7 1.63 1.4 2.47-.31.85-3.05 2.22-3.05 2.22v1.15s1.96 1.22 1.91 2.27c-.05 1.06-1.75 2.27-1.75 2.27l-.1 1.05s1.18.8 1.13 1.63c-.05.85-1.3 1.27-1.3 1.27s-1.49.68-1.28 2.21'/%3e%3cpath fill='%232f3b30' stroke='white' stroke-width='.13' d='M714.47 544.25s-.26-1.37-1.24-1.63c-.98-.27-2.01-1.06-2.01-2.06s.57-1.58 1.19-1.9c0 0-1.86-1.26-1.86-3.1 0-1.85 1.96-2.85 1.96-2.85s-3-1.16-3.2-2.69c-.2-1.53 1.34-3.32 1.8-3.84.47-.53 1.2-.58 1.2-.58l-.32.63.62-.27s-.3.87-1.13 1.59c-.62.53-1.7 1.63-1.4 2.47.31.85 3.05 2.22 3.05 2.22v1.15s-1.96 1.22-1.91 2.27c.05 1.06 1.75 2.27 1.75 2.27l.1 1.05s-1.18.8-1.13 1.63c.05.85 1.3 1.27 1.3 1.27s1.49.68 1.28 2.21'/%3e%3cpath fill='%2364472d' d='M712.67 520.55h.75v27.9h-.75z'/%3e%3cpath fill='%2364472d' d='M712.94 520.2h.2v.53h-.2z'/%3e%3cpath fill='%2364472d' d='M712.32 519.45c0-.42.34-.76.75-.76.4 0 .75.34.75.76s-.34.77-.75.77a.76.76 0 0 1-.75-.77'/%3e%3c/g%3e%3c/g%3e%3cg fill='none' stroke='black'%3e%3cpath stroke-width='1.28' d='M630.79 241.91c27.11 16.28 45.97 52.4 45.97 94.32 0 49.9-26.7 91.57-62.26 101.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.64' d='M629.83 243.6c26.74 15.87 45.37 51.37 45.37 92.63 0 48.97-26.25 89.84-61.16 99.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='1.3' d='M581.76 438.03a59.66 59.66 0 0 0 34-.13' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='1.29' d='M658.8 386.73c-10.25 22.96-27.38 39.6-47.5 44.6l.2-1a51.65 51.65 0 0 1-27.03-.48l.12 1.14c-18.5-5.08-34.39-20.06-44.54-40.7l.53 1.06c10.16 20.1 25.82 34.64 44.01 39.64l-.12-1.14a51.73 51.73 0 0 0 27.02.47l-.19 1c19.75-4.9 36.63-21.02 46.93-43.33' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23b1babf' d='M756.95 364.67s-16.9-10.47-38.95-10.22c-16.15.2-34.57 9.45-34.57 9.45-18.49 11.06-33.66 30.64-43.12 54.73a155.82 155.82 0 0 0-10.57 57.08c0 59.12 32.85 106.44 73.9 117.7 0 0 6.1 2.68 14.45 2.68 8.36 0 16.03-1.07 16.03-1.07 41.87-10.38 74.9-58.76 74.9-118.67 0-77.67-60.07-116.67-52.07-111.68m-22.8 222.67s-8.44 1.54-15.96 1.54a64.65 64.65 0 0 1-14.71-1.93c-36.96-10.3-66.32-55.13-66.32-109.25 0-19 4.2-37.76 10.24-53.43 8.52-22.05 22.99-39.13 39.63-49.25 0 0 16.79-10.44 31.32-10.61 19.85-.24 34.87 11.32 34.87 11.32 27.85 17.65 47.2 56.53 47.2 101.65 0 54.85-28.57 100.46-66.26 109.96' stroke='none'/%3e%3cg fill='%23c69024' stroke='%23080101' stroke-width='.46'%3e%3cpath d='M566.69 242.43c-26.9 15.88-45.66 51.71-45.66 93.37 0 49.34 26.31 90.51 61.3 100.03l-.94 1.87c-35.39-10.02-61.93-51.84-61.93-101.89 0-41.96 18.57-78.14 45.46-94.64l1.77 1.27zM630.28 242.57c26.94 15.88 45.73 51.73 45.73 93.4 0 49.36-26.35 90.54-61.39 100.06l.93 1.88c35.45-10.04 62.03-51.86 62.03-101.94 0-41.98-18.68-78.17-45.61-94.68l-.21-.15-1.9 1.22.42.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M570.08 251.03c-24.52 14.61-41.62 47.6-41.62 85.96 0 45.42 23.98 83.32 55.87 92.08l.59 2.34-1.44-.61c-32.26-9.24-56.45-47.73-56.45-93.81 0-38.64 17-71.94 41.51-87.13l.2-.14 1.72 1.12-.38.19z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.49' d='M631.14 240.63l.24.17-4.73 9.93-.16-.09c-3.84-2.37-15.17-8.52-29.13-8.33-11.1.15-23.56 6.6-26.46 8.2.92-2.26-5.08-9.89-5.08-9.89l1.31-.75s16.04-9.16 30.1-9.34c19.19-.25 33.91 10.1 33.91 10.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M626.76 251.03c24.56 14.62 41.69 47.62 41.69 85.99 0 45.44-24.03 83.35-55.96 92.11l.05 2 1.27-.41c32.07-9.48 56.07-47.83 56.07-93.7 0-38.65-17.03-71.96-41.58-87.16l-.02-.02-1.42-.82-.48 1.82.38.19z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.57' d='M758.74 365.2l-.08.04c-2.57 1.26-4.68 4.3-5.52 8.1-.26 1.2-.4 2.7-.36 3.77 0 0-2.87-1.56-2.87-1.8-.02-.98.08-2.03.32-3.1.93-4.24 3.49-7.66 6.4-8.58.04 0 2.11 1.57 2.11 1.57zM679.17 365.5l.08.04c2.57 1.26 4.68 4.3 5.52 8.1.26 1.2.4 2.7.36 3.77 0 0 2.87-1.56 2.87-1.8.02-.98-.08-2.03-.31-3.1-.94-4.24-3.45-7.64-6.37-8.55a70.56 70.56 0 0 0-2.15 1.54z'/%3e%3cpath stroke-width='.53' d='M738.76 595.14s-.6-.47-1.37-1.32c-.56-3.65-2.58-5.31-2.58-5.31l-.43.04c-.37-1.32-.52-2.8-.26-4.41l-.21.03a65.33 65.33 0 0 1-15.93 1.84 56.54 56.54 0 0 1-13.75-2.12c-.04-.02-.8-.01-.78.06.54 1.58.45 3.14.06 4.56h-.03s-1.81 1.49-2.48 4.74c-.78.98-1.41 1.57-1.41 1.57l1.17.34-.01.22c-.08 3.18 2.9 3.72 4.87 3.74.6 4.02 3.13 3.39 4.46 2.74l-.29.39c.2 2.7 1.6 2.92 3.16 4.25.14.12 1.14.76 1.47 1.22l.06-.02c1.46 2.04 2.55 7.17 4.45 7.17h.5c1.9 0 2.98-5.09 4.44-7.15.32-.46 1.32-1.1 1.46-1.22 1.57-1.33 2.96-1.55 3.16-4.25l-.29-.39c1.33.65 3.85 1.28 4.46-2.74 1.96-.02 4.9-.55 4.87-3.65l1.23-.33z'/%3e%3cpath stroke-width='.53' d='M740.44 594.56c-2.12-1.25-3.9-4.13-4.4-7.48a11.56 11.56 0 0 1-.08-2.98l-2.37-.23c-.27 1.2-.32 2.57-.1 4.03.57 3.79 2.77 6.97 5.24 7.88l1.71-1.22zM698.03 594.44c2.12-1.25 3.9-4.13 4.4-7.48.17-1.05.18-2.05.08-2.98l2.37-.23c.27 1.2.32 2.57.1 4.03-.57 3.79-2.77 6.97-5.24 7.88l-1.71-1.22z'/%3e%3c/g%3e%3cg fill='black' stroke='none'%3e%3cpath d='M705.48 599.31c1.82-1.34 2.43-3.6 2.9-5.74.03-.1-.01-.51-.02-.46-.47 2.1-1.08 4.34-2.88 5.67-.1.08.05.5 0 .53M709.73 602.29c2.12-.87 3.22-4.2 3.75-6.25.04-.15-.04-.42-.01-.52-.53 2.07-1.64 5.37-3.74 6.24-.09.03.03.52 0 .53M714.61 607.9a13.02 13.02 0 0 0 2.38-6.86c0-.07-.02-.58-.03-.37a12.7 12.7 0 0 1-2.35 6.7c-.1.13.07.44 0 .53M732.58 598.77c-1.8-1.33-2.4-3.56-2.88-5.67 0-.05-.05.36-.02.46.48 2.13 1.08 4.4 2.9 5.74-.05-.04.1-.45 0-.53M728.47 601.76c-2.1-.87-3.2-4.17-3.74-6.23.03.09-.05.36-.01.51.53 2.06 1.63 5.38 3.75 6.25-.02 0 .1-.5 0-.53M723.59 607.52a12.7 12.7 0 0 1-2.35-6.7c-.01-.21-.04.3-.03.37.21 2.54.88 4.8 2.38 6.86-.06-.09.1-.4 0-.53'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%3e%3cg fill='%23452c25' stroke='black' stroke-width='.55'%3e%3cpath d='M662.23 304.61s-4.2 9.73-1.93 10.68c2.28.96 8.06-.57 12.97-9.35 4.9-8.77-2.91-5.49-2.91-5.49l-8.13 4.16zM688.15 311.1s-.7 12.78 0 13.73c.7.96 7.18.96 7.53-8.58.35-9.54-1.4-9.92-1.4-9.92l-6.3 4.39'/%3e%3cpath d='M692.03 295.69s-4.55 14.3-.17 17.17c4.37 2.86 7.88-14.12 8.05-17.93.18-3.82-7.88.76-7.88.76zM695.16 313.96s.88 13.35 3.33 13.93c2.45.57 6.48-3.82 6.48-7.25 0-3.44-4.2-11.45-4.2-11.45l-5.79 4.2'/%3e%3cpath d='M695.28 297.97s-4.55 14.3-.18 17.17c4.38 2.86 7.89-14.12 8.06-17.93.18-3.82-7.88.76-7.88.76zM695.63 275.01s-6.66 6.87-6.48 10.68c.17 3.82 9.8-5.15 10.68-6.87.88-1.71-4.2-3.81-4.2-3.81z'/%3e%3cpath d='M691.06 271.16s-5.26 9.73-3.85 12.78 6.48-2.29 8.93-5.72c2.45-3.44-5.08-7.06-5.08-7.06zM679.24 272.84s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95z'/%3e%3cpath d='M686.82 272.73s-6.66 6.87-6.48 10.68c.17 3.82 9.8-5.15 10.68-6.87.88-1.71-4.2-3.81-4.2-3.81zM573.28 273.7s-13.76 6.9-14.96 9.86c-1.2 2.95 41.49-4.48 64.95-21.06l-9.52-5.63-40.47 16.83z'/%3e%3cpath d='M589.51 276.18s-25.05 9.35-6.95 9.72c0 0 35.88-7.47 54.99-22.08l-4.83-7.14-43.21 19.5z'/%3e%3cpath d='M626.31 251.19s-26.45 13.54-23.48 15.07c2.98 1.53 21.73-2.67 31.54-8.77 9.81-6.1 14.02-9.54 14.02-9.54l-11.74-3.25-10.34 6.49zM616.32 280.9s-9.45 7.91-8.36 8.81c1.1.9 20.42-2.14 35.48-13.96l-1.9-6.97-25.41 11.75'/%3e%3cpath d='M599.85 279.39s-9.06 7.22-7.07 7.8c1.98.6 9.66 6.04 43.64-16.12l4.01-2.47-6-8.46-34.58 19.25zM592.86 253.31c-28.58 10-57.24 29.91-57.24 29.91 2.8-.95 73.54-29.43 73.54-29.43M655.57 297.93s-6.13 9.35-4.9 10.5c1.22 1.14 8.76 4.76 17.51-7.26 8.76-12.01-8.23-10.1-8.23-10.1l-4.38 6.86z'/%3e%3cpath d='M648.65 289.83s-9.2 11.54-7.27 13.07c1.93 1.52 12.44 1.33 20.32-9.73 7.89-11.07.18-.57.18-.57l-2.28-10.11-10.95 7.34z'/%3e%3cpath d='M639.8 284.39s-8.93 10.68-8.06 12.4c.88 1.72 12.97 1.14 22.95-9.35s1.93-14.3 1.93-14.3l-16.64 10.68'/%3e%3cpath d='M623.95 284.87l-5.7 7.92s1.58 7.44 21.2-6.1c19.63-13.55 18.58-12.4 18.58-12.4l-10.52-1.91-23.56 12.5zM561.45 273.47l-12.44 5.59s-2.8 2.46 4.5 2.65c7.3.18 22.4-1.84 48.65-16.72a136.13 136.13 0 0 0 19.38-13.15l-9.56-3.56-50.53 25.19z'/%3e%3cpath d='M540.15 281.31s17.9-1.95 25-6.6c0 0-1.45 2.17 7.7-1.4l51.97-25.36-1.73-3.38s-56.61 24.25-60.9 25.6c-4.28 1.35-22.04 11.14-22.04 11.14z'/%3e%3cpath stroke-width='.64' d='M670.11 304.2s-1.75 14.18.35 14.7c2.1.53 8.06-3.93 10.51-12.6 2.45-8.67-9.63-7.62-9.63-7.62l-1.75 5'/%3e%3cpath d='M679.4 310.24s-1.05 10.4.35 11.35c1.4.95 4.9 1.34 9.11-6.87 4.2-8.2 2.28-5.15 2.28-5.15l-9.46-5.15-2.28 5.82z'/%3e%3cpath d='M682.02 292.21s-7.7 16.79-3.33 16.6c4.38-.2 10.34-12.79 11.21-15.65.88-2.86-7.88-.95-7.88-.95z'/%3e%3cpath d='M681.35 292.06s-2.9 18.5 1.24 16.93c4.14-1.56 6.48-15.5 6.56-18.51.07-3.02-7.8 1.58-7.8 1.58z'/%3e%3cpath d='M687.63 293.93s-4.55 14.3-.18 17.17c4.38 2.86 7.89-14.12 8.06-17.93.18-3.82-7.88.76-7.88.76zM669.67 289.22s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95zM637 262.07s-11.74 9.73-10.34 11.26c1.4 1.52 15.07-1.15 21.2-5.35 6.13-4.2 8.58-6.48 8.58-6.48l-10.5-6.49-8.94 7.06z'/%3e%3cpath d='M647.34 252.15s-7.53 6.1-6.13 7.63c1.4 1.53 14.89-4 17.34-6.68 2.45-2.67 2.28-5.53 2.28-5.53l-13.49 4.58z'/%3e%3cpath d='M654.52 251s-9.64 8.58-7.18 11.64c2.45 3.05 16.64-10.5 18.57-12.21 1.92-1.72-11.39.57-11.39.57z'/%3e%3cpath d='M650.49 247.38l-20.5 9.73s-17.34 11.25-15.59 12.4c1.75 1.14 15.24-2.48 24.88-7.25 9.63-4.77 20.32-12.78 20.32-12.78M656.2 258.45s-22.18 19.07-18.85 20.98c3.33 1.9 15.37-3.33 25.35-12.49'/%3e%3cpath d='M659.84 263.77s-13.38 22.14-11.98 24.24c1.4 2.1 10.5-4.96 15.07-10.3 4.55-5.34 8.13-13.23 8.13-13.23'/%3e%3cpath d='M666.23 266.6s-13.6 25.27-12.02 27.37c1.57 2.1 9.46.38 14.19-9.54 4.73-9.92 4.32-16.32 4.32-16.32l-6.49-1.51z'/%3e%3cpath d='M674.13 267.81s-15.11 31.2-12.13 34.24c2.98 3.06 19.7-23.65 20.48-27.43 1.34-6.63-8.53-7.38-8.53-7.38M642.26 247.19s-13.66 6.49-10.86 7.82c2.8 1.34 15.59-4.39 17.34-4.96 1.75-.57-6.48-2.86-6.48-2.86z'/%3e%3cpath d='M644.36 249.29s-8.4 6.68-6.66 8.4c1.75 1.71 14.54-5.16 17-7.26 2.45-2.1-10.34-1.14-10.34-1.14z'/%3e%3cpath stroke-width='.58' d='M662 249.82s-11.5 15.45-7.97 16.06c3.52.61 16.87-9.96 17.05-11.79.19-1.83-9.08-4.27-9.08-4.27z'/%3e%3cpath d='M667.13 253.29s-12.26 15.45-8.76 16.4c3.5.96 3.85-1.52 3.85-1.52s9.64-8.01 10.34-10.11c.7-2.1-5.08-4.96-5.08-4.96'/%3e%3cpath d='M670.99 256.92s-8.94 15.45-6.66 16.4c2.28.96 5.96-2.86 9.64-7.43 3.68-4.58-2.98-8.97-2.98-8.97z'/%3e%3cpath d='M673.26 263.98s-5.26 9.73-3.85 12.78c1.4 3.05 6.48-2.29 8.93-5.72 2.45-3.44-5.08-7.06-5.08-7.06zM675.47 290.98s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95z'/%3e%3cpath d='M699.54 273.18s-3.5-1.14-6.13-1.14c0 0-7.71-6.1-11.91-6.68-4.2-.57-.62-.67-.62-.67s-.44-10.01-1.66-10.78c0 0-.7-10.3-7.18-11.06-6.49-.76-21.03.57-23.66-.38-2.62-.96-10.68-4.32-25.92-.2-15.6 4.23-46.3 18.01-47.88 18.4-1.58.37 35.26-8.1 45.6-12.67 0 0 10.33-.76 13.49-1.72 0 0-11.74 5.73-.88 3.25 10.86-2.48 8.41 0 8.41 0s-1.05 2.48 5.08 1.14 6.13 0 6.13 0 7.01 2.48 12.44-.76c0 0 2.8 9.73 6.3 11.06 0 0 4.17 8.92 12.93 10.63 0 0 4.16 2.95 5.04 3.52l4.95 1.63 5.3-4.14'/%3e%3cpath d='M627.71 246.81s-35.04 12.59-33.81 16.02c1.22 3.44 36.61-9.72 42.22-13.35 5.6-3.62-7.88-2.86-7.88-2.86'/%3e%3c/g%3e%3cg fill='%23452c25' stroke='black' stroke-width='.55'%3e%3cpath stroke-width='.49' d='M869.44 278.12l13.78 7.82s3.36 2.79-4.02 1.15c-7.38-1.65-23.11-7.08-52.84-26.2-13.44-8.66-17.68-8.41-17.68-8.41l18.73.5 42.03 25.14z'/%3e%3cpath stroke-width='.49' d='M873.99 274.72l13.78 7.82s3.36 2.79-4.02 1.15c-7.38-1.65-23.11-7.08-52.84-26.2-13.44-8.66-2.63 7.13-2.63 7.13l2.28-10.38 43.43 20.48z'/%3e%3cpath stroke-width='.48' d='M896.91 282.25s-16.45-3.06-22.45-7.44c0 0 1.06 1.89-7-1.77 0 0 3.11 7.05-19.54-8.38-22.66-15.44-14.74-7.68-14.74-7.68l6.34-1.64s34.78 13.9 38.6 15.35c3.81 1.46 18.8 11.56 18.8 11.56z'/%3e%3cpath d='M810.88 288.41l5.51 7.86s-1.83 7.37-20.97-6.97c-19.13-14.34-18.13-13.15-18.13-13.15l10.57-1.48 23.21 13.18M786.02 292.35s8.89 11.63 6.9 13.07c-1.97 1.45-12.47.83-19.96-10.55-7.5-11.38-.16-.58-.16-.58l.7-18.4 12.71 15.9'/%3e%3cpath d='M795.15 287s8.56 11.04 7.62 12.72c-.93 1.68-13 .61-22.6-10.28-9.62-10.9-1.44-14.38-1.44-14.38L795 286.42M843.91 280.48s24.39 10.49 6.3 9.8c0 0-35.43-9.54-53.76-25.24l5.18-6.85 42 21.68'/%3e%3cpath d='M856.71 277.45s13.2 8 14.18 11.05c.99 3.05-41.02-7.84-63.18-26.3l9.9-4.84 39.1 20.09zM818.37 284.71s9.55 7.84 8.46 8.75c-1.08.9-20.44-1.99-35.64-13.69l1.82-6.98 25.55 11.55'/%3e%3cpath d='M834.7 284.04s9.42 6.5 7.47 7.18c-1.96.68-9.35 6.49-44.4-14.04l-4.13-2.27 5.57-8.75 35.5 17.3'/%3e%3cpath d='M798.72 264.81s11.4 10.2 9.94 11.67c-1.45 1.47-15.02-1.76-21-6.2-5.98-4.45-10.33-10.15-10.33-10.15l12.7-2.74 8.69 7.42z'/%3e%3cpath d='M785.14 247.77l20.76 12.37s16.94 11.96 15.15 13.03c-1.8 1.07-15.14-3.1-24.6-8.26-9.47-5.17-20.45-16.28-20.45-16.28M772.04 306.29s3.87 9.9 1.56 10.75c-2.31.86-8.04-.9-12.64-9.87-4.6-8.97 2.43-4.29 2.43-4.29l8.65 3.41z'/%3e%3cpath d='M778.92 299.89s5.8 9.6 4.54 10.69c-1.27 1.09-8.92 4.4-17.26-7.97-8.33-12.37 8.58-9.76 8.58-9.76l4.14 7.04z'/%3e%3cpath d='M761.58 256.61s19.8 38.23 18.15 40.26c-1.65 2.03-9.47 0-13.85-10.11-4.38-10.11-7.96-23.23-7.96-23.23l3.66-6.92zM784.64 266.33s16.52 14.04 13.13 15.81c-3.4 1.77-9.97-.79-19.63-10.35-9.66-9.56 6.34-6.04 6.34-6.04'/%3e%3cpath d='M776.64 266.57s11.8 21.68 10.33 23.72c-1.47 2.04-10.33-5.39-14.7-10.91-4.36-5.53-7.67-13.56-7.67-13.56'/%3e%3cpath d='M764.94 258.27s8.4 15.8 6.08 16.67c-2.3.86-5.85-3.1-9.37-7.83-3.51-4.73 3.29-8.84 3.29-8.84zM765.13 290.6s3.04 13.3.37 14.52c-5.23 2.4-8.14-9.45-8.46-13.9-.35-4.98 8.09-.62 8.09-.62zM754.67 311.68s.7 9.96-.73 10.85c-1.43.9-4.94 1.13-8.86-7.24-3.92-8.36-2.1-5.24-2.1-5.24l9.63-4.75 2.1 5.43'/%3e%3cpath d='M764.03 309.58s1.4 10.37-.72 10.66c-2.11.3-7.95-3.19-10.19-9.58-2.23-6.4 9.82-5.13 9.82-5.13l1.63 3.69'/%3e%3cpath d='M754.39 277.06s10.82 24.22 9.08 27.67c-3.4 6.75-13.24-14.75-16.21-23.15-3.32-9.39 7.13-4.52 7.13-4.52z'/%3e%3cpath d='M749.37 281.11s14.76 26.66 8.53 27.28c-6.22.62-17.53-19.34-19.43-23.97-1.9-4.64 10.9-3.3 10.9-3.3z'/%3e%3cpath d='M748.49 286.64s7.26 25.55 2.58 23.29c-4.67-2.26-10.3-21.5-11.07-25.66-.77-4.15 8.49 2.37 8.49 2.37zM773.99 250.32s11.2 17.1 7.56 17.6c-3.63.51-16.9-11.42-17.02-13.4-.12-1.97 9.46-4.2 9.46-4.2z'/%3e%3cpath d='M767 251.04s14.27 19.48 9.97 20.47c-4.3.99-4.63-2.06-4.63-2.06s-11.39-10.26-12.15-12.86c-.77-2.6 6.39-5.8 6.39-5.8M793.99 249.73s13.43 7.04 10.58 8.26c-2.84 1.22-15.43-5.02-17.16-5.67-1.73-.64 6.58-2.59 6.58-2.59zM781.14 251.34s9.81 10.12 7.24 13.55c-2.58 3.43-16.2-12.82-18.06-14.88-1.86-2.07 11.89.93 11.89.93M757.34 265.4s15.8 30.78 12.9 33.91c-2.92 3.13-20.48-23.08-21.1-26.88-.6-3.8 8.36-7.6 8.36-7.6'/%3e%3cpath stroke-width='.64' d='M748.26 268.19s6.32 9.63 5.96 14.82c-.36 5.19-9.55-7.43-10.34-9.8-.8-2.38 4.38-5.02 4.38-5.02z'/%3e%3cpath d='M761.25 263.2s4.92 9.94 3.4 12.93c-1.5 3-8.2-6.04-10.53-9.57-2.33-3.53 7.13-3.36 7.13-3.36z'/%3e%3cpath stroke-width='.66' d='M738.45 272.97s7.71 8.56 7.34 13.12c-.37 4.56-11.57-6.66-12.55-8.76-.98-2.1 5.21-4.36 5.21-4.36z'/%3e%3cpath d='M788.31 248.28s11.68 10.47 9.86 12.12c-1.8 1.64-17.6-9.67-19.98-11.87-2.38-2.2 10.12-.25 10.12-.25z'/%3e%3cpath d='M778.44 247.52l9.13 7.7s8.49 5.66 7.03 7.13c-1.45 1.47-14.74-4.62-17.1-7.39-2.36-2.77-2.08-5.62-2.08-5.62l3.02-1.82zM808.53 249.94s34.58 14.02 33.23 17.4c-1.34 3.38-36.25-11.22-41.73-15.08-5.47-3.85 7.98-2.53 7.98-2.53'/%3e%3cpath d='M809.78 254.39s25.96 14.62 22.94 16.02c-3.03 1.4-21.62-3.56-31.21-10.06-9.6-6.5-13.68-10.1-13.68-10.1l11.84-2.77 10.11 6.91zM745.86 272.16s4.92 9.94 3.4 12.93c-1.5 3-6.39-2.55-8.72-6.08-2.33-3.54 5.32-6.85 5.32-6.85zM747.03 294.57s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.04-3.82 7.85 1.09 7.85 1.09z'/%3e%3cpath d='M726.92 270.71s14.44-6.34 17-5.83c0 0 3.03-.76 4.65-2.03 1.63-1.27 5.36-4.31 5.36-4.31s-2.56-17.5 15.83-15.72c18.4 1.78 42.61 4.06 47.5 4.82 4.9.76 22.82 5.83 27.02 7.86 4.19 2.03 31.5 14.39 37.09 16.42 3.3 1.2 10.6 5.76 16.01 9.29 3.72 2.42-.11.69-.11.69s-44.23-23.48-59.87-26.62c-3.91-.79.27 4.48.27 4.48s-10.16-4-14.35-5.78c-4.2-1.78-7.68-2.54-11.64-2.29-3.96.26-6.99-.5-9.32-1.26-2.32-.76-15.6-1.27-17.92-1.52-2.33-.26-4.2-.76-4.2-.76l.94 1.52-6.52-1.02-1.87 2.8s-6.28 1.26-6.75-.77c-.46-2.03-3.73 9.13-5.36 12.42-1.63 3.3-7.68 3.3-9.54 5.33-1.86 2.03-3.03 3.3-3.96 3.8-.93.51-5.59 3.3-7.22 3.3s-11.64.76-11.64.76l-2.56-4.06 1.16-1.52zM745.91 311.7s.26 12.8-.48 13.72c-.73.93-7.2.66-7.23-8.88-.02-9.55 1.75-9.86 1.75-9.86l6.15 4.65'/%3e%3cpath d='M742.56 296.15s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.05-3.82 7.85 1.09 7.85 1.09z'/%3e%3cpath d='M739.24 298.29s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.04-3.82 7.85 1.09 7.85 1.09z'/%3e%3c/g%3e%3cg fill='%23d9c0b9' stroke-width='.55' stroke='black'%3e%3cpath d='M741.9 357.31s2.49 3.1 2.18 4.1c0 0 2.56-2.58-.74-6.24l-1.44 2.14zM721.32 351.43h1.5l.56 1.4-.21 1.28-1.3.6s-2.11-.55-1.6 1.98c0 0-.99-4.64 1.05-5.26zM731.86 361.82l1.54-1.7 1.66.87s-.69 4.5-.95 4.83c-.26.33-.3.38-.3.51s-.27-.85-.77-1.42c-.5-.56-1.01-3.04-1.18-3.09zM715.75 356.23l-.76-2.27.88-1.2 1.79-.01.75.36s1.44 3.27.18 4.98c0 0-.53-1.84-1.14-2.1 0 0-1.33-.2-1.7.24zM699.07 360.14s-2.51 4.2.75 6.3c0 0-.2-3.92 2.35-4.76l-3.1-1.54zM690.43 358.44l2.27-.59.22.1s-1.49 2.87-1.09 3.57c.41.7-2.03-1.27-1.4-3.08z'/%3e%3c/g%3e%3cpath fill='%23bd8759' stroke='black' stroke-width='.55' d='M730.39 333.74s.08 7.8.08 9.18c0 1.39-.16 3.47-.96 4.68-.79 1.21-1.59 1.9-2.86 1.9-1.27 0-4.61-.17-5.25 1.05-.64 1.2-1.11 1.9-1.11 1.9s2.06-1.21 2.38 0c.32 1.21-.8 2.25-.8 2.25s1.92.35 3.67-.69 2.7-1.21 3.5-1.21c.8 0 1.43.86 1.43.86s.48 2.6.32 4.16c-.16 1.56-.48 4.68 1.27 4.68 0 0 .64-1.56 1.27-1.73.64-.17 2.39 1.56 2.07 2.08 0 0 .32-3.3-.32-5.2-.63-1.9-.95-3.99-.95-3.99s5.41 1.91 5.89 2.6c.47.7 1.75 1.91 2.22 1.74.48-.18 0-1.74.96-2.08.95-.35 1.43.52 1.43.52s-1.59-3.64-3.98-4.85c-2.38-1.22-3.98-1.22-4.93-2.26-.95-1.04-1.12-2.25-1.27-3.46-.16-1.22.04-11.69.04-11.69l-4.1-.44zM703.37 353.57s-3.96 3.07-4.4 4.51c-.45 1.45-.58 2.84-.58 2.84s3.55-.43 3.11 1.53c0 0 1.15.66 2.98-3.59s3.56-6.08 4.86-5.96c1.3.13 2.95 1.39 3.78 2.27.83.9 1.98 1.55 3.43 1.14 0 0-1.52-2.31-.56-2.82.95-.5 2.41-.4 2.41-.4s-1.2-2.88-3.8-3.3c-2.6-.42-4.4-1.14-3.79-2.27.62-1.13 3.94-9.91 3.94-9.91l-4.4-6.47-1.77 5.63s.58 3.32.6 4.18c.02.85-3.5 8.12-3.98 8.54-.47.43-9.92 4.08-11.04 4.44-1.12.36-3.47 3.15-3.47 3.15l-.27 2.1s1.58-1.3 2.09-.52c0 0 1.1-1.39 2.08-.87.98.52.82.72.82.72s1.75-1.15 2.06-1.72c.3-.56.4-.5.4-.5l2.78-.48'/%3e%3cg fill='none' stroke='black' stroke-width='.55'%3e%3cpath d='M708.49 345.51c-.41.07-.7.01-.98-.18M710.01 341.66a3.3 3.3 0 0 1-1.3-.46M708.44 343.64c.3.17.63.23.98.18M705.2 349.67c.19.13.41.21.65.23M732.38 346.04c.65.11 1.24.46 1.91.52M733.5 344.13c-.51.13-.95.03-1.27-.35M733.81 341.88c-.6.07-1.23.04-1.75-.17M731.59 349.5c.6.08 1.17.38 1.75.52M731.75 351.93c.3-.07.57-.01.8.17M732.22 358.51c.4-.07.78-.01 1.11.17M712.33 350c-.5.08-.9.38-1.1.87M715.57 350.31c-.7.4-1.32.97-1.4 1.78M695.45 353.88c.54.5 1.34.78 1.81 1.23M738.11 351.24c-.41.19-.69.56-.8 1.04M740.34 351.93a.76.76 0 0 0-.48.7'/%3e%3c/g%3e%3cpath fill='%23452c25' stroke='black' stroke-width='.55' d='M747.46 301.88s-1.23-5.54-2.1-6.3c-.88-.77.35-1.54.35-1.54s-2.28-5.54-3.68-6.5c-1.4-.95.17-1.71.17-1.71s-2.45-3.83-4.2-4.97c-1.75-1.15 0-1.34 0-1.34s-1.83-5.13-6.1-7.48c0 0-2.83-2.98-5.72-3.8-2.89-.82-10.05-1.58-18.7-1.42-9.12.16-12.98 6.48-12.98 6.48l-.59 7.33 1.32-.9-1.93 9.14c-.3 2.09 1.63 5.71 1.74 10.08.03 1.38.12 2.82.28 4.3a37.88 37.88 0 0 0 3.1 11.9c.15.3.28 1.2.45.9.44-.76 1.44 2.6 2.34 3.8 0 0 .54 4.55.97 2.86.17-.65 1.63 2.58 2.54 4.61.32.74 2.05 5.76 1.98 3.47-.07-2.5 1.52 5.32 1.52 6.45l2.1-3.06 1.05 3.44 1.75-.2-.52 3.26s4.9-4.02 5.08-5.55c.17-1.52.35-2.67.35-2.67l1.58-1.53 2.45-3.82s6.13 4.77 6.83 6.5c.7 1.71 1.4 3.24 1.4 3.24l1.58-1.53 1.4 3.44.88-1.72.85 2.4.07-.15.56 1.57c.43.4 1.4.6 3.25-2.48 2.62-4.4 2.45-7.83 2.62-8.6.18-.76 1.23 1.34 1.23 1.34s2.28-4.2 1.93-6.88c-.35-2.68 1.4-1.72 1.4-1.72s.35-7.07 0-8.8c-.35-1.71 1.23-1.33 1.23-1.33s-.53-8.4-1.06-9.36c-.52-.96 1.23-1.15 1.23-1.15z'/%3e%3cpath d='M735.18 282.43c1.24.37 1.84 1.76 2.37 2.85-.03-.07.08-.38.01-.52-.53-1.08-1.14-2.5-2.38-2.86 0 0-.08.5 0 .53M736.3 287.71c2.28 1.93 2.48 4.57 2.35 7.45 0 .1.03.6.05.27.13-3.05.1-6.14-2.4-8.25.06.05-.1.44 0 .53M741.05 290.41c1.26 2.07 1.38 4.35 1.38 6.74 0 .3.05.3.05 0 0-2.54-.06-5.03-1.42-7.25.04.05-.09.39-.01.51M742.71 300.4c-.14 1.48-.4 2.93-.7 4.39-.01.1.02.5.03.46.3-1.49.56-2.97.7-4.47.01-.07-.01-.59-.03-.38M741.18 308.06c.12.97.24 1.93.14 2.9 0 .08.01.6.04.39.13-1.24 0-2.44-.14-3.67-.03-.2-.05.31-.04.38M738.23 298.44c0 1.64.01 3.27.15 4.9.02.21.04-.3.03-.38-.12-1.5-.13-3-.13-4.52 0-.3-.05-.3-.05 0M736.98 309.06c.13 1.55.13 3.1.13 4.67 0 .3.05.3.05 0 0-1.69 0-3.37-.14-5.05-.02-.2-.05.31-.04.38M743.99 307.71c.68.71 1.1 1.55 1.24 2.53.02.1.04-.08.04-.1v-.36a4.8 4.8 0 0 0-1.28-2.6c.06.07-.1.42 0 .53M743.57 296.99c.7.58 1.26 1.29 1.82 2-.07-.08.1-.41 0-.53a12.8 12.8 0 0 0-1.82-2c.06.05-.1.44 0 .53M737.81 305.01c0 1.46-.14 2.9-.4 4.34-.03.1.01.5.02.46.3-1.59.42-3.19.43-4.8 0-.3-.05-.3-.05 0M734.75 308.2c.12 1.3.12 2.6 0 3.9 0 .08.02.6.04.38.14-1.55.14-3.1 0-4.66-.02-.2-.05.31-.04.38M724.71 273.96c.8.13 1.48.5 2.2.87.02 0 .33.2.38.12.06-.08-.21-.32-.23-.34a6.35 6.35 0 0 0-1.5-1.1c-.9-.48-1.8-.97-2.83-1.14-.2-.03.56.7.6.73.37.3.9.78 1.38.86M697.43 300.41c.52 1 .6 2.15 1.12 3.14-.03-.06.08-.38.01-.51-.52-1-.6-2.15-1.12-3.14.04.06-.08.38-.01.51M702.19 273.43c1.17-.42 2.41-.43 3.64-.57.05 0 .02-.54 0-.53-1.22.14-2.47.15-3.64.57-.09.03.02.52 0 .53M709.18 272.86a7.93 7.93 0 0 1 3.5-.57c.03 0 .03-.53 0-.53-1.2 0-2.39.04-3.5.57-.1.04.03.52 0 .53M697.02 279.04c-.15.03-.15.14-.16.28v.36c.02.1.04-.08.04-.1 0 .1.06 0 .12 0 .07-.02.01-.54 0-.54M696.29 297.87c0 .98 0 1.97.15 2.94.02.1.04-.08.04-.1l-.01-.36c-.13-.82-.13-1.65-.13-2.48 0-.3-.05-.3-.05 0M730.99 279.29c.5.14.8.5.97.99a.8.8 0 0 0 .03-.19c0-.1.02-.23-.02-.32-.16-.5-.48-.87-.98-1.01 0 0-.08.5 0 .53M731.55 287.85a6.94 6.94 0 0 1 1.67 2.85c-.02-.09.06-.37.02-.52a7 7 0 0 0-1.69-2.86c.06.06-.1.42 0 .53M729.73 281.57c.76.66 1.4 1.42 2.1 2.14-.07-.06.1-.43 0-.53-.7-.72-1.34-1.49-2.1-2.14.06.05-.1.44 0 .53M731.82 295.82a6.06 6.06 0 0 1-.55 3.51c-.06.14.04.44.01.52.61-1.46.83-2.93.57-4.49-.01-.05-.05.36-.03.46M733.77 300.24c.1.66.12 1.3 0 1.97a1.6 1.6 0 0 0 0 .36c0 .02 0 .2.03.1a8.9 8.9 0 0 0 0-2.89c-.02-.1-.04.08-.04.1l.01.36M741.33 315.84c.5 1.79.54 3.61.54 5.46 0 .3.05.3.05 0 0-2.02-.03-4.02-.58-5.97.03.08-.05.36-.01.51M740.07 319.47a30.58 30.58 0 0 1-1.4 3.71c-.06.14.05.45.02.52.57-1.2.98-2.46 1.4-3.72.04-.14-.05-.43-.02-.51M697.86 307.42c1.17 1.52 1.8 3.35 2.79 4.99-.03-.06.09-.4.01-.51-.99-1.65-1.62-3.48-2.8-5.01.07.08-.1.4 0 .53M705.27 307.6c-1.07.14-1.33-1.4-2.24-1.71.02 0-.08.5 0 .53.9.32 1.17 1.85 2.24 1.71.06 0 .02-.53 0-.53M701.07 314.69c.77 1.35 1.27 2.83 2.1 4.14-.04-.05.09-.4.01-.51-.82-1.31-1.33-2.8-2.1-4.14.04.05-.08.38-.01.51M705.97 316.42a11.07 11.07 0 0 1 2.09 3.42c-.03-.08.06-.37.01-.52a11.2 11.2 0 0 0-2.1-3.43c.07.08-.1.41 0 .53M705.54 321.55c.43.9.82 1.82 1.26 2.71-.03-.06.08-.38.01-.51-.43-.9-.82-1.82-1.26-2.71.04.06-.07.38-.01.51M710.15 322.55c.25.94.4 1.9.4 2.88 0 .3.05.3.05 0a13.55 13.55 0 0 0-.44-3.4c.03.1-.05.37-.01.52M708.19 326.81c.3 1.36.7 2.68 1.4 3.88-.03-.05.09-.39.02-.51-.7-1.18-1.1-2.5-1.4-3.83 0-.05-.04.36-.02.46M709.32 308.71c1.1.42 2.21.84 3.36 1.14 0 0 .07-.51 0-.53-1.15-.3-2.25-.72-3.36-1.14.02 0-.09.5 0 .53M710.16 313.42c1.32.73 2.7 1.32 4.05 2-.03-.02.1-.48 0-.53-1.34-.68-2.73-1.27-4.05-2 .04.02-.1.47 0 .53M711.42 318.7c.68.83 1.42 1.59 2.24 2.29-.06-.06.1-.45 0-.54-.82-.7-1.56-1.45-2.24-2.28.07.08-.1.41 0 .53M712.81 325.26c.57.9.83 1.91.97 2.97.02.1.04-.08.04-.1l-.01-.36a7.39 7.39 0 0 0-.99-3.02c.04.05-.08.39-.01.51M716.72 308.95c.12.63.27 1.26.43 1.88-.03-.09.05-.36.01-.51-.15-.6-.3-1.22-.41-1.83-.02-.1-.04.08-.04.1 0 .12-.01.24.01.36M726.51 305.04c-.28.7-.6 1.36-.98 2-.07.12.05.46.01.51.38-.64.7-1.3.98-2 .06-.14-.04-.43-.01-.51M730.54 304.87c0 1.12-.02 2.24-.27 3.34-.02.1.02.51.03.46.28-1.25.3-2.52.3-3.8 0-.3-.06-.3-.06 0M731.39 311.06c.1.96 0 1.91-.13 2.87-.02.1.02.5.02.46.17-1.24.28-2.46.15-3.7-.03-.21-.05.3-.04.37M734.47 316.92a5.44 5.44 0 0 1-1.94 3.25c-.1.1.06.48 0 .53a5.54 5.54 0 0 0 1.97-3.32c.01-.1-.02-.5-.03-.46M724.55 311.18c-.28.56-.64 1.06-.98 1.57-.05.07-.02.25-.02.33 0 .02.02.21.03.18.34-.51.7-1.01.98-1.57.04-.08.02-.23.02-.32 0-.02-.02-.21-.03-.19M725.68 319.03a7.8 7.8 0 0 1-1.4 1.57c-.1.08.06.49 0 .53.56-.43.98-1 1.4-1.57.04-.06.03-.2.03-.26 0-.03-.04-.26-.03-.27M722.18 323.17c-1.37-1.35-2-3.08-1.4-5.05.06-.14-.03-.43 0-.51a5.9 5.9 0 0 0 1.4 6.1c-.06-.07.1-.44 0-.54M717.56 318.81c.1.8.1 1.6-.13 2.37-.05.15.04.43.01.51.33-1.08.3-2.23.15-3.34-.02-.1-.04.08-.04.1l.01.36M728.19 324.04c-.29.97-.81 1.82-1.26 2.71-.06.14.05.45.02.52.44-.9.97-1.75 1.25-2.72.05-.14-.04-.42-.01-.51M735.04 326.89a38.1 38.1 0 0 1-1.96 3c-.08.11.05.47.02.51.68-.98 1.36-1.95 1.95-3 .07-.12-.04-.45-.01-.51M738.38 330.49a70.2 70.2 0 0 0-.57 5.52c0 .09.02.6.05.27.13-1.78.27-3.56.55-5.33.01-.1-.02-.5-.03-.46M742.71 324.08c.01.62.13 1.24.14 1.86 0 .37.05.02.05-.15-.01-.62-.13-1.23-.14-1.85 0-.38-.05-.03-.05.14M696.73 303.93a11.3 11.3 0 0 0 .57 5.34c-.03-.08.06-.37 0-.51a9.03 9.03 0 0 1-.54-4.37c.01-.1-.03-.5-.03-.46'/%3e%3cpath fill='%23dcddde' d='M697.1 285.19s-.53-5.3.96-5.88c0 0 .53-4.87 7.01-4.2 0 0 2.2-3.62 5.7-1.71 0 0 3.32-1.63 5.25-.67 1.93.95 4.3 2.57 4.47 2.95 0 0 2.8-.57 4.11.48s.7 4.48.7 4.48 3.16 2.42 3.42 4.55c.26 2.13.26 2.99-.44 3.56 0 0 1.4 1.15 1.14 2.77s-1.58 3.97-1.84 3.97.18 4.23-1.22 5.66c-1.4 1.43-2.72 1.72-3.33 1.91-.61.2-2.2 2.48-3.68 2.77-1.49.28-3.5-2.3-3.68-3.06-.18-.76-2.19-1.62-2.19-1.62s-4.56 4.87-7.62 4.1a7.93 7.93 0 0 1-4.82-3.81c-.26-.48-1.14-4-1.14-4s-3.41-2.01-3.15-3.92c.26-1.9 1.66-4.2 1.66-4.2l-1.31-4.13z'/%3e%3cg fill='white'%3e%3cpath d='M712.57 281.17c2.95-2.7 6.85-5.56 11.04-4.56 0 0 .07-.52 0-.54-4.19-1-8.09 1.86-11.04 4.57-.1.1.06.47 0 .53M726.76 284.4c-2.96-2.01-8.14-2.75-11.04-.27-.1.1.06.48 0 .53 2.9-2.48 8.08-1.74 11.04.27-.05-.03.1-.46 0-.53M715.46 288.95c1.21 3.93 2.78 7.93 2.1 12.13-.02.1.02.5.02.46.74-4.55-.78-8.82-2.1-13.1.02.08-.07.36-.02.51M710.72 291.34c.73 3.97.26 7.99 0 11.98-.02.1.01.6.04.27.28-4.23.76-8.5-.01-12.7-.01-.06-.05.35-.03.45M717.04 288.42c3.86.92 7.64 3.49 9.72 6.97-.04-.06.08-.39.01-.51a15.86 15.86 0 0 0-9.73-7s-.07.52 0 .54M713.6 293.79c.01 2.44.2 4.89-.5 7.26-.05.15.03.43 0 .51.77-2.53.57-5.15.55-7.77 0-.3-.05-.3-.05 0M719.67 293.25c2.43 2 4.35 5.04 4.71 8.24.03.21.05-.3.04-.37a13.17 13.17 0 0 0-4.75-8.4c.06.05-.1.44 0 .53M701.8 299.95c.8-1.15 1.8-2.45 3.15-2.94.08-.04-.02-.53 0-.54-1.36.5-2.35 1.81-3.16 2.97-.08.11.04.46.01.51M707.58 279.07c-.51-2.18-2.15-3.47-3.9-4.65.04.03-.1.42 0 .48 1.74 1.16 3.38 2.45 3.89 4.63-.02-.09.04-.32.01-.46M704.16 279.03c-2.02-.96-4.11-1.07-6.3-1.07-.05 0-.05.53 0 .53 2.19 0 4.28.11 6.3 1.07-.03-.01.1-.48 0-.53M710.48 278.69c.27-2.1-.04-4.08-1.85-5.37.04.03-.1.4 0 .46 1.52 1.09 2.07 2.6 1.83 4.5a2 2 0 0 0 .02.41M718.09 281.17c1.9-1.01 3.97-.82 6.04-.8.04 0 .04-.54 0-.54-2.07-.01-4.14-.2-6.04.8-.1.06.04.52 0 .54M721.51 286.27c2.93.31 5.17 1.82 7.1 4.03-.13-.15.2-.84 0-1.07-1.93-2.2-4.17-3.72-7.1-4.03-.04 0-.11 1.06 0 1.07M708.62 294.35c-.7 2.8-.16 6.35-3.4 7.5-.18.06.03 1.05 0 1.06 3.28-1.16 2.73-4.7 3.43-7.53.07-.3-.08-.85-.03-1.03'/%3e%3cpath d='M715.45 292.16c1.12 2.95 2.7 5.96 2.09 9.23-.04.2.03 1.01.05.92.74-4.03-.7-7.48-2.11-11.18.06.16-.14.75-.03 1.03M719.67 291.64a6.95 6.95 0 0 1 5.75 5.83c.03.21.08-.16.08-.19.01-.24 0-.49-.02-.73-.39-2.97-2.88-5.6-5.81-5.98-.04 0-.12 1.06 0 1.07M719.64 295.86c.45 2.45 1.14 4.9.27 7.35-.1.29.09.86.03 1.03 1.08-3.06.31-6.22-.25-9.3-.02-.1-.09.71-.05.92M718.09 285.2c3.15-.53 6.47-1 9.2 1.07-.11-.08.2-.9 0-1.06-2.73-2.08-6.05-1.6-9.2-1.08-.13.03-.02 1.07 0 1.07M712.33 278.95c.38-2.6 2.67-4.46 4.97-5.3.17-.06-.04-1.05 0-1.06-2.38.86-4.64 2.77-5.02 5.44a3.7 3.7 0 0 0-.02.73c0 .03.04.4.07.19M709.46 280.51c-.08-2.88-1.34-5.2-2.58-7.73.05.12-.14.68-.03.91 1.12 2.26 2.45 4.47 2.52 7.07.02.66.1.05.09-.25M706.82 282.06c-.56-2.57-2.25-4.27-4.5-5.44.08.04-.19.96 0 1.06 2.17 1.14 3.9 2.8 4.45 5.3.02.1.1-.71.05-.92M702.58 281.03c-1.47-1.02-3.01-1.99-4.8-2.26-.02 0-.1.82 0 .83 1.79.28 3.33 1.24 4.8 2.26-.08-.05.16-.72 0-.83M711.75 293.09c.25 2.73.6 5.48-.77 7.97-.13.25.1.9.03 1.03 1.63-2.98 1.11-6.5.81-9.75-.03-.42-.08.61-.07.75'/%3e%3cpath d='M714.92 291.62c.91 2.56 1.99 5.3 1.8 8.08 0 .17.06 1.2.1.54.22-3.4-.75-6.5-1.87-9.65.05.16-.13.74-.03 1.03M717.04 287.88c2.6.8 5.2 1.65 7.1 3.76-.13-.14.2-.84 0-1.07-1.9-2.1-4.5-2.95-7.1-3.76.02.01-.16 1.02 0 1.07M709.98 282.09c.28-2.27.52-4.53.54-6.82 0-.6-.1-.6-.1 0a54.3 54.3 0 0 1-.51 6.07c-.02.14.02 1.17.07.75M705.21 280.64a23.15 23.15 0 0 1-5.26-3.49c.12.1-.2.89 0 1.07a23.12 23.12 0 0 0 5.26 3.49c-.06-.03.19-.98 0-1.07M704.42 294.33a6.64 6.64 0 0 0-2.64 3.24c-.08.19-.04.46-.04.66 0 .04.05.41.07.37a6.57 6.57 0 0 1 2.61-3.2c.2-.13-.1-1.01 0-1.07M707.79 296.33c-.05 1.87-1.08 3.42-2.32 4.7-.2.22.13.94 0 1.08a7.93 7.93 0 0 0 2.42-5.5c0-.34-.08-1.03-.1-.28M716.61 281.63c1.55-2.45 5.3-2.65 7.8-3.34.16-.04 0-1.06 0-1.06-2.53.69-6.26.9-7.83 3.37-.15.24.1.93.03 1.03M699.38 281.59a8.55 8.55 0 0 1-1.7-.8c.05.03-.12.6 0 .66.55.31 1.1.62 1.7.8-.01 0 .1-.63 0-.66M699.72 294.13c-.54.22-1.1.45-1.47.93-.1.1-.05.4-.05.53l.01.38c0-.02.03.17.04.15.37-.48.93-.7 1.47-.92.08-.04.05-.47.05-.54 0-.02-.02-.54-.05-.53M701.98 294.71a6.8 6.8 0 0 0-2.62 2.45c-.12.17.08.73.03.8a6.73 6.73 0 0 1 2.6-2.41c.14-.07-.05-.82-.01-.84M706.27 295.77c-.97 2.37-3.62 4.98-1.7 7.63-.06-.1.19-.81.03-1.03-1.33-1.83 1.01-3.9 1.7-5.57.11-.28-.1-.88-.03-1.03M709.3 295.73c.07 2.41-.35 4.8-.77 7.15-.04.21.04 1.02.05.92.5-2.77.9-5.53.82-8.35-.02-.75-.11-.06-.1.28M717.05 292.88c1.76 2.3 3.31 4.78 4.06 7.62-.04-.18.11-.73.03-1.03-.75-2.86-2.32-5.34-4.09-7.66.13.18-.19.82 0 1.07M717.96 291.03c2.89 2.2 6.1 4.27 8.14 7.39-.06-.1.18-.8.03-1.03-2.05-3.13-5.27-5.21-8.17-7.43.1.09-.2.91 0 1.07'/%3e%3cpath d='M719.66 287.22a6.78 6.78 0 0 1 3.1.31c.92.34 1.68 1.1 2.51 1.6.84.5 1.69.97 2.37 1.69.9.94.91 2.55 1.17 3.77.02.08.09-.61.05-.79-.22-1-.33-2-.67-2.97-.33-.94-1.14-1.52-1.94-2.02-.95-.61-1.88-1.23-2.82-1.85-1.12-.73-2.5-.77-3.77-.65-.1.01-.04.91 0 .91'/%3e%3cpath d='M726.73 293.14c.32.93.7 1.85 1.01 2.78-.03-.1.08-.48.02-.67-.32-.93-.7-1.85-1.01-2.78.03.11-.08.48-.02.67M718.64 278.41c2.04-.56 4.12-.93 6.12-1.62.17-.06-.03-1.06 0-1.07-2 .7-4.08 1.06-6.12 1.62-.16.05.01 1.07 0 1.07M710.15 279.43a9.3 9.3 0 0 1 1.36-2.88c.76-1.13.87-2.55 1.8-3.58.2-.23-.13-.93 0-1.07-.77.85-1.04 1.95-1.48 2.98-.52 1.25-1.35 2.17-1.7 3.52-.09.3.07.85.02 1.03M703.2 298.49a9.33 9.33 0 0 0 .35 5.26c-.06-.16.14-.75.03-1.03a5.63 5.63 0 0 1-.33-3.31c.05-.23.03-.5.02-.73 0-.04-.03-.4-.07-.19M707.42 301.8c-.73 1-.74 2.5-.35 3.65.01.04.06-.31.06-.35 0-.2.02-.44-.04-.62-.21-.64-.05-1.16.33-1.68.08-.1.05-.37.05-.5 0-.05-.07-.47-.05-.5M710.56 300.12c-.03 1.01-.57 1.97-1 2.86-.08.2.07.64.03.74.52-1.1 1-2.16 1.04-3.4.01-.24-.05-.74-.07-.2M710.65 294.2v1.27c0 .04 0 .54.05.54.06 0 .05-.5.05-.54v-1.27c0-.04.01-.53-.05-.53-.06 0-.05.5-.05.53M709.22 294.94c.08.15.15.3.2.46.04.23.06.24.06.04l-.05.26c-.04.24-.03.5-.01.73 0 .04.03.4.07.2.16-.88.2-1.92-.24-2.72-.03-.05-.07.34-.07.38 0 .17-.05.5.04.65M707.18 294.27a14.3 14.3 0 0 0-.47 2.02c-.03.24-.03.5-.01.73 0 .03.03.4.07.2.1-.66.24-1.3.44-1.92.06-.2.04-.45.03-.66 0-.05-.05-.41-.06-.37M705.61 294.36a11.7 11.7 0 0 1-3.51 2.66c-.2.11.08 1.02 0 1.07a11.7 11.7 0 0 0 3.51-2.66c.09-.11.05-.4.05-.54 0-.05-.07-.51-.05-.53M702.89 294.82c-.58.46-1.23.8-1.93 1.04-.17.06.03 1.06 0 1.07.7-.25 1.35-.58 1.93-1.04.1-.08.05-.44.05-.54l-.05-.53M699.04 293.88c-.56.25-1.14.47-1.7.72-.15.06.04.83 0 .85.56-.25 1.14-.46 1.7-.72.15-.06-.04-.83 0-.85M710.77 293.41c.01.7.12 1.37.25 2.06.04.2.07-.16.07-.2.02-.23.03-.5-.02-.73-.09-.46-.2-.94-.2-1.41 0-.05-.05-.42-.06-.37-.07.19-.04.45-.04.65M712.58 292.58c0 .82.09 1.6.38 2.37.01.04.06-.33.06-.38 0-.2.04-.46-.03-.65-.16-.43-.3-.88-.3-1.34 0-.04 0-.53-.06-.53s-.05.5-.05.53M713.98 292.4c.24.34.52.81.53 1.25 0 .04.05.41.06.37.07-.2.05-.45.04-.65a3.44 3.44 0 0 0-.6-2c-.04-.05-.07.34-.07.38 0 .15-.05.52.04.65M715.69 291.72c.6.13 1.14.37 1.59.81l.05-.53c0-.11.04-.45-.05-.54a3.15 3.15 0 0 0-1.59-.8s-.14 1.03 0 1.06M716.6 290.33c.7.58 1.47 1.02 2.38 1.16.03 0 .12-1.05 0-1.07a4.83 4.83 0 0 1-2.38-1.16l-.05.54c0 .1-.04.45.05.53M718.52 285.7c.61 0 1.21.1 1.81.23.01 0 .14-1.04 0-1.06-.6-.13-1.2-.23-1.81-.24-.08 0-.08 1.07 0 1.07M717.63 283.49c.37-.6.92-1.05 1.46-1.49.09-.07.05-.43.05-.53l-.05-.53c-.55.45-1.11.9-1.49 1.52-.09.15-.04.5-.04.66 0 .03.04.42.07.37M715.94 281.35c.1-.7.34-1.33.77-1.9.08-.11.05-.4.05-.53 0-.06-.07-.5-.05-.53a4.3 4.3 0 0 0-.84 2.77c0 .03.04.4.07.19M714.57 280.36c.7-.98 1.17-2.1 1.81-3.12.1-.15.04-.5.04-.66 0-.04-.03-.42-.07-.37-.64 1.01-1.11 2.14-1.8 3.12-.1.14-.05.5-.04.66 0 .03.02.42.06.37'/%3e%3cpath d='M711.45 276.86c.03 1.2.11 2.39.36 3.56.05.2.07-.15.08-.2.01-.22.03-.5-.02-.72-.21-.96-.3-1.94-.32-2.92-.02-.75-.1-.06-.1.28M706.39 277.7c.18.43.42.84.64 1.26a8.28 8.28 0 0 1 .46 1.12c-.06-.22.05-.16-.08.07-.15.24.1.9.03 1.02.3-.53.26-1.39.12-1.96-.22-.92-.78-1.68-1.14-2.54.06.15-.15.75-.03 1.03M705.38 279.78a18.6 18.6 0 0 0-2.27-1.85l-.05.53c0 .1-.04.47.05.53a18.8 18.8 0 0 1 2.27 1.86l.05-.54c0-.11.04-.44-.05-.53M708.69 280.89c.47-2.34.38-4.68-.58-6.88.06.15-.15.75-.03 1.03.7 1.6.91 3.17.56 4.93-.05.23-.03.5-.02.73 0 .03.03.4.07.19M713.65 277.83c.08 0 .08-1.07 0-1.07s-.08 1.07 0 1.07'/%3e%3cpath d='M708.04 280.99c.12-1.32.43-2.62.57-3.94a5.8 5.8 0 0 0 0-1.13c-.03-.27-.09-.26-.11 0-.14 1.32-.45 2.62-.57 3.94a6.1 6.1 0 0 0 0 1.13c.03.27.08.27.11 0M722.38 289.21a4.68 4.68 0 0 1 2.81 2.29c.04.07.1-.5.1-.56 0-.28.06-.73-.06-.99a4.76 4.76 0 0 0-2.85-2.34c.04.01-.25 1.52 0 1.6M718.5 297.17c.2.68.22 1.3.1 2.01-.07.35-.05.74-.03 1.1 0 .05.05.59.1.28.3-1.6.34-3.37-.13-4.93-.01-.06-.1.49-.1.56 0 .3-.03.68.06.98M715.27 295.01c0 1.32.08 2.64-.19 3.94-.07.35-.05.74-.02 1.1 0 .05.04.58.1.28.36-1.75.28-3.54.27-5.32 0-.05.01-.8-.08-.8s-.08.74-.08.8M713.63 296.44c-.46 1.75-.9 3.51-1.27 5.29-.06.35-.04.74-.02 1.1 0 .05.04.58.1.28.35-1.73.79-3.43 1.23-5.13.12-.45-.11-1.27-.04-1.54M715.84 297.56c.01 1.5.19 3.03.02 4.53-.04.37-.03.76 0 1.13.03.27.08.26.11 0 .22-1.9.05-3.77.03-5.66 0-.06.01-.8-.08-.8s-.08.74-.08.8M705.23 298.36c.03-.48.03-.57-.01-.29a2.5 2.5 0 0 1-.31.8c-.13.23-.06.72-.06.98 0 .05.06.64.1.56.56-1 .51-2.32.36-3.43-.04-.3-.1.24-.1.29-.03.36-.03.73.02 1.09M709.89 295.2c.31.6.29 1.12.28 1.78 0 .05 0 .8.08.8.09 0 .08-.75.08-.8 0-1.1.12-2.31-.4-3.32-.04-.08-.1.5-.1.56 0 .26-.07.73.06.98M711.16 294.65c.17.14.32.29.44.48l.12.27c.04.1.05.39.04.05 0 .16.01.32.04.48 0 0 .02.18.06.08.1-.29.06-.68.06-.98-.02-.78-.13-1.48-.76-1.98-.03-.02-.06.26-.06.24a5.49 5.49 0 0 0 0 1.13c.01.04.01.19.06.23M712.73 293.23c.25.5.54 1 .8 1.5.03.09.05-.06.05-.08.03-.15.03-.31.04-.47l-.01-.62c0-.1 0-.27-.05-.37-.25-.5-.54-1-.79-1.5-.04-.08-.06.07-.06.08l-.03.48v.61c0 .1 0 .27.05.37M716.24 291.96a39.9 39.9 0 0 0 1.95 2.58c-.03-.03.07-.72.07-.8 0-.2.06-.64-.07-.8-.68-.81-1.3-1.66-1.9-2.52-.06-.08-.1.5-.1.56-.01.22-.1.78.05.98M718.05 288.95c.47.83 1.01 1.6 1.6 2.34-.02-.03.08-.72.08-.8 0-.19.06-.63-.07-.8a17 17 0 0 1-1.57-2.28c-.04-.08-.1.5-.1.56 0 .25-.07.75.06.98M700.4 280.9a7.08 7.08 0 0 0-1.7-1.04 4.6 4.6 0 0 0-.08.8c0 .1-.04.74.08.8.62.26 1.18.62 1.7 1.04l.08-.8c0-.15.06-.69-.08-.8M705.93 279a4.55 4.55 0 0 1 .17.48c0 .16.01.33.04.48 0 0 .02.18.06.08.1-.29.06-.68.05-.98 0-.55-.06-1.1-.28-1.6-.04-.09-.06.07-.06.08l-.03.48c-.01.28-.07.71.05.98M710.29 274.85a5.74 5.74 0 0 1-.62 3.07c-.14.23-.07.73-.06.98 0 .06.05.64.1.56.84-1.44.77-3.41.73-5.04 0-.06-.07-.62-.1-.55-.1.29-.06.68-.05.98M711.27 280.76a6.46 6.46 0 0 0 2.06-2.58c.12-.25.06-.71.06-.98 0-.05-.06-.63-.1-.56a6.3 6.3 0 0 1-2.02 2.52c-.13.1-.08.67-.08.8 0 .05.06.81.08.8M713.99 280.65c.32-.33.59-.7.9-1.04.05-.05.05-.17.06-.24a5.83 5.83 0 0 0 0-1.13c0 .03-.03-.25-.05-.23-.32.33-.6.7-.91 1.04-.05.05-.05.17-.06.24a5.49 5.49 0 0 0 0 1.13c0-.03.04.25.06.23M718.07 281.36c-1.02 0-2.04-.01-3.06-.12-.07 0-.16 1.59 0 1.6 1.02.1 2.04.12 3.06.12.11 0 .12-1.6 0-1.6M717.16 285.04c1.36.82 2.68 1.7 4.08 2.43-.1-.06.3-1.44 0-1.6-1.4-.73-2.72-1.61-4.08-2.43.13.08-.3 1.42 0 1.6'/%3e%3cpath d='M717.28 287.82c1.21.77 2.53 1.36 3.63 2.32l.07-.8c0-.16.06-.68-.07-.8-1.1-.96-2.42-1.55-3.63-2.32-.02-.01-.08.76-.08.8 0 .13-.05.71.08.8M709.48 282.01c.17-.58.17-1.2.17-1.81 0-.06.01-.8-.08-.8s-.08.74-.08.8c0 .22 0 .03 0 0 0 .1-.02.18-.05.27-.1.3-.06.67-.06.98 0 .16.01.32.04.48 0-.02.03.18.06.08M699.94 277.75c1.06 1.3 2.41 2.25 3.72 3.27.97.75 1.7 2.04 2.74 2.63-.12-.07.3-1.42 0-1.6-.94-.53-1.58-1.67-2.41-2.37-1.39-1.16-2.89-2.1-4.05-3.53.2.24-.3 1.24 0 1.6M702.21 282.06a31.68 31.68 0 0 1-1.81-2.08c-.02-.02-.06.26-.06.23-.02.19-.02.38-.02.57 0 .19-.06.63.08.8.58.71 1.17 1.42 1.8 2.08l.09-.8c0-.17.06-.66-.08-.8M700.94 292.62c-.43.78-.79 1.59-1.34 2.29-.13.16-.08.6-.08.8 0 .08.1.76.08.8.57-.72.94-1.55 1.38-2.35.13-.24.06-.72.06-.98 0-.06-.06-.64-.1-.56M702.13 294.22c-.02.89-.32 1.78-.43 2.66-.05.37-.04.76 0 1.13.02.27.07.26.1 0 .15-1.14.46-2.21.48-3.36 0-.3.05-.7-.05-.99-.03-.06-.1.5-.1.56M706.31 301.57c.76-2.53.67-5.2.62-7.81-.02-1.12-.16-.09-.15.42.04 1.98.06 3.94-.51 5.85-.13.44.12 1.28.04 1.54M708.76 295.43c.29.88.35 1.68.2 2.6a5.2 5.2 0 0 0-.02 1.08c0 .05.06.6.1.29.28-1.8.34-3.76-.24-5.51-.02-.06-.1.49-.1.56 0 .3-.04.68.06.98M711.16 294.54a5.55 5.55 0 0 1 1.06 3.9c-.01.25.08 1.78.14.8.13-2.08.18-4.6-1.2-6.3.02.03-.08.72-.08.8 0 .2-.05.64.08.8'/%3e%3cpath d='M711.82 293.47c.55 2.3.98 4.62 1.21 6.97.06.63.13-.92.11-1.13a55.1 55.1 0 0 0-1.28-7.38c.07.28-.15 1.08-.04 1.54M714.09 292.89a15 15 0 0 1 2.38 4.51c.02.06.1-.48.1-.55 0-.32.03-.68-.06-.99a14.98 14.98 0 0 0-2.38-4.51c.1.13-.28 1.21-.04 1.54M718.77 289.03c-.47-.8-1.45-.9-2.29-.84-.15.01-.07 1.6 0 1.6.8-.07 1.8 0 2.25.78.04.08.1-.5.1-.56 0-.25.07-.75-.06-.98'/%3e%3cpath d='M716.37 288.4c1.47-.21 2.94-.23 4.42-.23.12 0 .12-1.6 0-1.6-1.48 0-2.95.02-4.42.23-.18.03-.05 1.6 0 1.6M719.09 276.27c-1.17 1.4-1.8 3.31-2.2 5.09-.07.34-.04.74-.02 1.09 0 .06.04.59.1.29.38-1.69 1-3.54 2.12-4.87.14-.16.08-.61.08-.8 0-.08-.1-.77-.08-.8M712.71 277.64c.22 1.35.77 2.6 1.15 3.9.02.06.1-.49.1-.56 0-.31.03-.68-.06-.98-.36-1.25-.9-2.45-1.11-3.74-.05-.3-.1.24-.1.29-.03.36-.04.73.02 1.09M711.5 279.97a6.39 6.39 0 0 1-1.22-2.17c-.04-.1-.07.1-.06.08-.03.16-.04.32-.04.48 0 .3-.04.68.05.98.26.84.73 1.55 1.27 2.23.02.02.06-.26.06-.24l.02-.56c0-.2.05-.63-.08-.8M709.35 281.02a16.4 16.4 0 0 1-4.99-2.43c.17.12-.3 1.36 0 1.6a16.4 16.4 0 0 0 4.99 2.43c-.04-.01.25-1.52 0-1.6'/%3e%3c/g%3e%3cg stroke-width='0'%3e%3cpath fill='%23d9c0b9' stroke='black' stroke-width='.55' d='M670.35 297.23s-2.95-5.08 5.24-7.57c0 0 2.48 1.35 3.05 2.28 0 0-1.43 2.39-6.1 3 0 0-2.1.63-2.19 2.29z'/%3e%3cpath fill='%235e3f17' d='M675.77 290.98c-1.34.82-3.45.83-3.87 2.68v.12c.43-1.85 2.54-1.85 3.87-2.67.03-.01-.01-.12 0-.13'/%3e%3cpath fill='%23d9c0b9' stroke='black' stroke-width='.55' d='M671.21 296.4s3.3.7 5.52-.93c1.83-1.34 2.48-.73 2.96-.63 0 0 .1-1.65-1.05-2.9 0 0-2.32 1.91-4.03 2.43-1.71.52-2.87.35-3.4 2.03z'/%3e%3cpath fill='%23dba05f' stroke='black' stroke-width='.55' d='M711.3 280.57s-7.05 1.2-8.9 1.63a50.5 50.5 0 0 1-7.54.86c-1.47 0-3.72-1.18-5.3-1.5-1.56-.32-6.65-.85-8.5 1.07s-3.04 2.56-3.63 3.2c-.58.64-2.94 2.73-3.04 3.65-.09.93.6 2.31 1.77 2.31 1.18 0 3.64 2.5 3.64 3.03 0 .87 3.22 1.8 6.27 1.79 5.49-.03 8.19-2.8 16.42-1.83 4.48.53 12.72-2.99 14.2-5.12 1.46-2.13 2.34-4.37.87-6.82-1.46-2.45-5.87-2.2-6.26-2.27z'/%3e%3cpath d='M681.79 288.47s-.02.16-.05-.09l-.04-.18-.05-.13-.01-.15c-.03-.05.15.04.72-.52l.48-.73c-.04.02.7-.91 1.77-1.16 1.08-.25 2.07-.07 2.21-.06.05-.06-2.44-.1-2.6.2 0-.2 2.4-.28 2.52-.11.03-.06-2.25-.08-2.42.24 0-.14 2.07-.24 2.3-.05 0 0-.39-.05-.5-.04l.19.04h-.3l-.16-.02c0-.01.45.05.48.1 0 0 .2-.07-.6-.02 0 0-.5-.1-1.3.16-1.07.16-1.03 1.6-2.64 2.52'/%3e%3cpath fill='none' d='M681.62 287.87c.1 0 .79-.27 1.45-1.5-.19-.33 2.49-1.38 2.77-1.04 0-.01.73 0 1.14.07'/%3e%3cpath fill='none' d='M684.27 285.55c-.27-.04-1.63 1.1-1.5 1.17-.3.7-1.07 1.17-1.15 1.15M684.38 285.72c0-.09 1.84-.26 2.2-.13M684.04 286.21c-.05-.2 1.91-.46 2.1-.33'/%3e%3cpath d='M686.09 287.46s.08.05-.03-.06l-.08-.1-.05-.08-.07-.06s-.06.03-.56.46c0 0-.21.16-.47.4 0-.02-.48.4-1 .69-.57.08-1.38.45-1.38.6-.05-.23 1.61-.66 1.59-.69.12.08-1.48.37-1.5.7-.06-.2 1.46-.58 1.52-.59.08.1-1.34.33-1.38.63 0 .01.2-.19.27-.2l-.1.08c.05-.05.12-.06.18-.08l.1-.05s-.28.13-.27.19c.01.03-.16-.02.37-.16 0 .05 1.34-.27 2.86-1.68'/%3e%3cpath fill='none' d='M685.84 287.12c0-.02-.59.58-1.2 1 0 .1-1.24.84-1.57.75-.02-.04-.53.22-.74.48'/%3e%3cpath fill='none' d='M683.99 288.6c.1-.1.88-.63.88-.64.28-.3.97-.85.98-.85M684.02 288.74c.07.06-1.17.23-1.37.53M684.37 288.71c.08.16-1.32.53-1.38.58'/%3e%3cpath fill='%23c6262c' stroke='black' stroke-width='.55' d='M688.04 281.76s-.1-2.24-2.25-3.1c-2.15-.84-4.6-.95-5.48-.84-.88.1-1.03.5-2.13.67-1.1.18-2.28.71-2.28.71s0-.1-.58.96c-.6 1.07-1.57 1.6-1.08 2.56s.17 1.13.77 1.3c.6.2-.3-.32-.3-.32s-3.77 1.22-2.86 3.53c.92 2.31 1.84 1.45 2.12 1.4.27-.05 2.13-1 2.13-1l3.06-2.86s3.6-1.41 3.99-1.52c.39-.1 2.1.04 2.1.04l2.79-1.53z'/%3e%3cpath d='M685.31 287.01c0 .56-.57 1.28-1.27 1.6-.7.34-1.26.15-1.26-.4 0-.56.56-1.28 1.26-1.61.7-.33 1.27-.15 1.27.41'/%3e%3cpath fill='%235e3f17' d='M708.62 292.91a5.35 5.35 0 0 0 2.05-.93'/%3e%3cg fill='%23842116'%3e%3cpath d='M674.86 285.06c.58.01 1.25.31 1.16 1.02v.38c.01.09.03.09.04 0 .06-.43.08-.93-.09-1.34-.18-.45-.67-.58-1.11-.6-.04 0-.04.54 0 .54M677.63 286.13a2.7 2.7 0 0 0-.26-2.4c.03.05-.1.4-.02.52.3.42.45.85.27 1.37-.06.14.04.43.01.51M679.87 283.76c-.14-.93-.47-1.97-1.33-2.45.04.02-.1.47 0 .53.84.47 1.17 1.47 1.3 2.38.02.1.04-.08.04-.1l-.01-.36M681.84 283.28c.12-.87.05-1.8-.67-2.38.06.05-.1.45 0 .54.4.32.72.84.64 1.38v.36c0 .02.02.2.03.1M678.54 280.37c1.93-.98 5.85-1.41 7.36.54-.07-.09.1-.41 0-.54-1.51-1.94-5.43-1.51-7.36-.53-.1.05.04.51 0 .53'/%3e%3c/g%3e%3cg fill='%237a2e26'%3e%3cpath d='M680.38 294.73c.61 0 1.24 0 1.84-.13.07-.02 0-.54 0-.54-.6.14-1.23.14-1.84.14-.04 0-.04.53 0 .53M679.22 286.19c-.5 0-.35.61-.66.87-.04.03-.02.21-.02.26l.02.27c.3-.26.17-.86.66-.87.04 0 .04-.53 0-.53M680.92 287.34c.26-.48.76-.67 1.22-.9.1-.05-.04-.52 0-.54-.47.24-.97.44-1.23.93-.04.08-.02.24-.02.32 0 .02.02.22.03.19M683.13 290.28c.42.03.74-.15.99-.48.04-.06.02-.2.02-.27 0-.03-.03-.25-.02-.26-.25.33-.57.51-.99.48-.03 0-.05.53 0 .53M684.87 289.66a3.1 3.1 0 0 0 1.56-1.35c.04-.08.02-.25.02-.33 0-.02-.02-.21-.03-.19a3.07 3.07 0 0 1-1.55 1.34c-.1.04.02.52 0 .53M682.13 286.78c-.39.65-1.11.98-1.55 1.59-.08.1.04.47.01.51.44-.6 1.17-.94 1.55-1.59.05-.07.03-.24.02-.32 0-.02-.02-.22-.03-.19M683.32 295.28c1.4.07 2.74-.11 4.1-.48.07-.02-.01-.53 0-.53-1.36.36-2.7.55-4.1.48-.03 0-.05.53 0 .53M689.76 295.04c1.82-1.32 3.36-2.46 3.96-4.77.04-.15-.04-.42-.02-.51-.59 2.3-2.14 3.44-3.94 4.75-.1.07.05.5 0 .53M690.85 291.87a6.43 6.43 0 0 0 2.74-3.42c.05-.15-.05-.44-.02-.52a6.39 6.39 0 0 1-2.72 3.4c-.1.07.04.51 0 .54M690.23 283.8c1-.12 2.08.7 2.78 1.35-.07-.06.1-.44 0-.54-.7-.64-1.79-1.46-2.78-1.34-.06 0-.02.53 0 .53M716.07 287.82c1.13-1.83.51-4.12-.66-5.75.03.04-.1.4-.01.51.99 1.39 1.65 3.13.66 4.73-.08.12.04.46.01.51M696.35 285.24c1.14.83 4.29 2.94 3.43 4.67-.07.13.04.45.01.51 1.18-2.37-1.86-4.57-3.44-5.71.05.03-.1.45 0 .53M705.21 293.75a5.98 5.98 0 0 0 .3-1.89c-.02-.09-.03-.09-.04 0-.05.47-.1.93-.27 1.38-.04.1-.02.23-.02.32 0 .02.02.21.03.19M673.95 288.41c.44-.65.3-1.52-.13-2.12.03.04-.1.4-.02.51.12.16.21.32.29.5.1.22-.03.42-.15.6-.05.06-.02.25-.02.32 0 .02.01.22.03.19M693.62 294.06c.62-.4 1.05-.98 1.2-1.73.02-.11.01-.24 0-.36 0-.02-.01-.2-.03-.1-.13.71-.58 1.28-1.17 1.66-.1.06.05.5 0 .53M696.57 293.82c.27-.3.36-.65.38-1.04 0-.1.02-.23-.02-.33l-.03.19c0 .23-.19.49-.33.65-.04.05-.03.2-.03.26 0 .03.04.26.03.27M714.39 284.04c.48.86.56 1.8.35 2.77-.03.1.01.5.02.46a5.37 5.37 0 0 0-.36-3.74c.04.06-.08.38-.01.51M712.61 285.85c.35.87.32 1.77.22 2.69 0 .07.02.59.04.38a7.24 7.24 0 0 0-.25-3.58c.03.07-.07.37-.01.51M710.94 287.4c0 .65 0 1.3-.22 1.91-.05.15.05.44.02.52.28-.77.25-1.62.25-2.43 0-.3-.05-.3-.05 0'/%3e%3c/g%3e%3c/g%3e%3cpath fill='%23dcddde' stroke='black' stroke-width='.27' d='M694.56 275.41c-7.07.4-14.05-4.3-14.05-4.3-8.76-1.7-9.27-9.63-9.27-9.63-3.5-1.34-6.52-10.34-6.52-10.34-5.43 3.24-12.23.04-12.23.04s0-1.34-6.13 0c-6.13 1.33-5.08-1.15-5.08-1.15s2.45-2.48-8.4 0c-10.87 2.48.87-3.24.87-3.24-3.16.95-13.5 1.72-13.5 1.72-3.78.17-7.63 2.04-11.83 3.23-2.6.75-7.07 1.61-9.33 2.58-6.02 2.57-18.09 8.1-28.05 12.02-13.1 5.14-23.5 9.05-22.81 8.89.82-.2 14.23-8.7 31.03-16.31 15.6-7.08 33.5-13.62 42.53-16.19 11.7-3.88 21.3-2.02 26.74-.05 2.63.96 17.13-.44 23.6.32 6.5.76 7.17 11.42 7.17 11.42 1.22.76 1.66 10.78 1.66 10.78s-3.6.1.61.67c4.2.57 11.92 6.67 11.92 6.67 2.62 0 2.92-.1 2.92-.1s1.53-1.92 3.63-2.72c2.1-.8 4.03-1.61 6.4-1.79 2.36-.18 5.7-.2 8.06.07 2.37.27 5.16.29 8.5.91 3.32.63 3.67.81 4.72 1.17 1.05.36 2 .12 2 .12 4.32-1.8 12.35-5 14.2-4.64 0 0 3.03-.76 4.66-2.03 1.62-1.26 5.35-4.3 5.35-4.3s-2.57-18.11 15.82-16.34c18.4 1.78 42.79 4.14 47.68 4.9 4.89.76 22.4 5.76 26.59 7.8 4.2 2.02 16.24 7.42 21.6 9.79 2.17.96 10.46 4.63 16.59 7.05a61.3 61.3 0 0 1 16.08 9.69c-5.77-2.44-10.43-5.23-15-7.21-3.7-1.6-7.56-2.35-10.56-3.69-6.38-2.83-11.3-5.41-15.16-7.21-14.24-6.64-14.11-6.9-19.88-7.36-3.98-.3 2.86 4.86 2.86 4.86s-13.04-5.07-17.23-6.85c-4.2-1.77-7.69-2.53-11.65-2.28-3.95.25-6.98-.5-9.3-1.27-2.34-.76-15.61-1.27-17.94-1.52-2.33-.25-4.19-.76-4.19-.76l.93 1.52-6.52-1.01-1.86 2.79s-6.29 1.26-6.75-.77c-.47-2.02-3.73 9.13-5.36 12.43-1.63 3.3-9.07 2.2-10.93 4.23-1.86 2.03-5.84 3.39-6.77 3.9-.93.5-3.75.26-5.38.26-2.43 0-.36.04-4.34.8 0 0-3.44-.04-4.75-.58a73.89 73.89 0 0 0-5.66-1.78c-1.99-.57-13.05-.82-14.63-.73-1.57.09-4.24.9-6 1.62-1.74.72-4.8 2.6-4.8 3.04'/%3e%3cpath fill='%23452c25' d='M695.29 273.29s-.74.57-.93 2c-.18 1.42-.1.85-.1.85'/%3e%3cpath fill='%23574f4c' d='M731.03 271.21c.94.7 1.9 1.41 2.74 2.24.02.03.3.28.2.08-.1-.22-.28-.42-.44-.58a26.97 26.97 0 0 0-3.02-2.5c-.18-.13.01.18.04.22.13.2.29.4.48.54'/%3e%3c/g%3e%3c/svg%3e";

var img$1w = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23d91023' d='M0 0h900v600H0z'/%3e%3cpath fill='white' d='M300 0h300v600H300z'/%3e%3cg transform='matrix(.25 0 0 .25 345 179.188)' stroke='%23d4af37' stroke-width='2' fill='%2300a854'%3e%3cg transform='matrix(.44722 -.20656 .2582 .35777 89.404 -67.294)' id='g' stroke-width='4.33'%3e%3cpath d='M480.212 566.87c31.28 33.04 62.37 68.152 78.925 111.21 25.21 69.711 18.346 151.527-22.518 213.983-34.388 51.789-85.32 91.514-141.97 116.401-51.945 21.524-112.113 23.773-164.827 3.54-20.114-7.373-38.889-17.914-57.51-28.315-8.441-1.44-13.874 8.648-6.988 13.292 62.35 40.624 130.86 42.249 202.053 28.197 36.106-9.534 69.76-27.273 98.991-50.401 44.36-33.229 82.625-77.439 99.76-130.902 26.131-78.994 9.286-171.344-45.167-234.649-13.723-16.785-28.875-32.351-44.687-47.168l3.938 4.813z'/%3e%3cpath d='M170.57 983.29c-8.079-.843-12.167 11.815-5.077 13.643 4.182-1.01 10.665-12.011 5.076-13.642zM474.835 552.405c-4.503-5.593-14.062-2.886-17.759-7.3-3.94-4.706 2.887-6.51-.226-9.991-3.113-3.48-7.746-1.747-11.998-6.498-4.251-4.75-.422-8.776-4.09-12.099-3.667-3.322-4.171.887-8.372-3.724-4.2-4.612-1.717-12.71-6.304-18.558-4.481-5.712-2.984-12.5 2.496-11.257 3.644.826 5.064 4.385 10.468 5.756 5.404 1.372 7.577-2.577 11.118.904 3.542 3.481.308 9.122 4.105 13.971 3.798 4.85 5.83 1.303 8.515 5.626 2.686 4.323.5 6.61 2.228 11.666 1.729 5.056 8.377 3.105 10.869 10.748 2.492 7.643-1.05 20.756-1.05 20.756z'/%3e%3cpath d='M478.146 564.793c-5.561-26.182-26.97-56.915-52.595-79.474 15.222 11.956 44.848 40.53 54.361 79.28l-1.766.194z'/%3e%3cpath d='M460.18 524.426c-4.162-2.885-7.254-2.85-10.507-3.257 2.963-.163 5.873-.472 9.492 1.156l1.014 2.101zM445.001 505.477c-4.502-1.455-7.443-.392-10.62.29 2.794-1.147 5.51-2.419 9.262-2.021l1.358 1.73zM449.378 508.855c-2.195-5.54-2.198-9.678-2.533-14.028-.094 3.967-.298 7.863.952 12.69l1.58 1.338zM462.899 527.04c-2.195-5.54-2.198-9.677-2.533-14.027-.094 3.966-.298 7.863.953 12.69l1.58 1.338zM555.176 682.062c-8.257-3.177-17.17-.031-23.877-2.453-7.148-2.582 1.14-8.575-4.41-10.366-5.548-1.79-10.208 5.644-17.785 3.202-7.578-2.442-6.322-10.125-12.54-11.417-6.218-1.291-6.37 7.191-13.822 4.865-7.453-2.327-7.5-12.33-15.974-15.724-8.276-3.314-9.088-11.348-1.33-13.33 5.16-1.318 10.29 1.936 18.002.135s6.976-8.643 13.093-7.11c6.116 1.535 4.355 10.427 11.373 13.246 7.017 2.818 11.366-4.905 16.697-1.972 5.33 2.932.26 9.424 4.625 13.701 4.367 4.277 7.736-2.34 14.176 4.2 6.44 6.538 11.772 23.023 11.772 23.023z'/%3e%3cpath d='M563.504 691.584c-22.904-25.577-58.656-41.392-101.83-49.728 25.052 3.433 76.71 14.954 105.234 49.976l-3.404-.248z'/%3e%3cpath d='M524.282 661.447c-6.69-.536-10.766 1.355-15.236 2.88 3.851-1.95 7.573-4.02 13.029-4.48l2.207 1.6zM496.411 650.636c-6.554 1.172-10.006 4.054-13.927 6.677 3.224-2.882 6.292-5.848 11.419-7.682l2.508 1.005zM503.589 651.561c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.841 8.443 6.48 12.767l2.64.458zM528.954 662.563c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.84 8.443 6.48 12.767l2.64.458zM554.74 885.605c6.924-5.379 9.128-14.933 14.625-19.391 5.859-4.753 6.268 5.877 10.646 2.066 4.377-3.81.889-12.104 6.864-17.31 5.974-5.206 11.467.264 15.799-4.413 4.332-4.678-2.387-9.643 3.43-14.807 5.815-5.163 13.859.495 21.071-4.949 7.045-5.317 13.915-1.447 11.39 6.438-1.679 5.243-7.007 7.856-9.652 15.597-2.645 7.74 3.23 10.999-1.243 15.45-4.472 4.452-10.667-2.148-16.646 2.356-5.98 4.504-2.095 12.69-7.272 15.661-5.177 2.97-7.692-5.144-13.435-3.78-5.743 1.366-2.226 8.069-10.882 9.95-8.655 1.883-24.696-2.868-24.696-2.868z'/%3e%3cpath d='M542.691 887.43c32.645-5.369 64.277-27.486 93.849-60.328-16.034 19.857-52.657 58.27-95.853 63.151l2.004-2.822z'/%3e%3cpath d='M587.643 870.452c3.977-5.52 4.621-10.146 5.77-14.907-.48 4.464-.794 8.885-3.317 13.897l-2.453 1.01zM611.085 852.345c2.535-6.374 2.056-11.022 2.032-15.93.6 4.448 1.352 8.81.103 14.318l-2.135 1.612zM606.538 858.067c6.36-1.944 10.75-.953 15.437-.406-4.187-1.095-8.275-2.337-13.67-1.631l-1.767 2.037zM584.271 873.884c6.36-1.945 10.75-.954 15.437-.406-4.187-1.096-8.275-2.337-13.67-1.632l-1.767 2.038zM586.501 789.94c5.85-6.618 6.32-16.43 10.93-21.87 4.915-5.797 7.205 4.57 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.266 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.742-15.21 4.799-6.194 13.709-2.18 19.83-8.917 5.98-6.58 13.42-4.098 12.338 4.136-.72 5.476-5.492 9.068-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.423-3.605 5.235-10.865-.06-15.942 5.517-5.077 5.576.195 12.875-4.366 16.79-4.56 3.914-8.473-3.577-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.514-24.78 1.93-24.78 1.93z'/%3e%3cpath d='M574.984 794.051c31.13-11.555 58.291-39.374 81.522-77.336-12.232 22.597-41.404 67.391-82.99 80.496l1.468-3.16z'/%3e%3cpath d='M616.148 768.72c2.928-6.189 2.74-10.86 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.463zM635.972 746.418c1.36-6.752.063-11.227-.832-16.047 1.38 4.257 2.893 8.4 2.644 14.052l-1.812 1.995zM632.52 752.916c5.905-3.134 10.394-3.004 15.098-3.368-4.309-.271-8.547-.705-13.724 1.025l-1.375 2.343zM613.444 772.742c5.905-3.135 10.395-3.005 15.099-3.368-4.309-.272-8.547-.706-13.724 1.025l-1.375 2.343zM567.287 741.198c-7.882-5.63-18.267-4.844-24.713-9.25-6.871-4.697 3.657-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.841-12.336-10.09-15.426-6.25-3.09-8.83 5.718-16.099 1.202s-4.466-14.966-12.516-20.881c-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.12 5.186 8.722.281 5.015-4.332 11.087-1.017 6.073 3.314 4.839 12.095 11.504 17.002 6.665 4.907 15.195-4.66 20.032-.107 4.837 4.554-2.411 9.907 1.016 15.593s8.9-.273 13.89 8.353c4.99 8.627 5.963 27.322 5.963 27.322z'/%3e%3cpath d='M573.434 753.467c-17.083-33.105-50.623-59.625-94.197-80.421 25.684 10.602 77.379 37.099 97.75 81.634l-3.553-1.213z'/%3e%3cpath d='M540.285 711.031c-6.968-2.434-11.845-1.602-17.038-1.264 4.656-.955 9.207-2.073 15.145-1.024l1.893 2.288zM513.705 691.94c-7.31-.612-11.806 1.427-16.727 3.065 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75zM521.08 694.918c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.68 1.218zM544.939 713.505c-4.23-6.155-4.807-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218zM588.02 750.362c4.442-7.713 2.994-17.422 6.451-23.72 3.685-6.712 7.945 2.959 10.603-2.297 2.659-5.256-3.596-11.547.03-18.725 3.628-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.232-15.052 3.495-7.076 13.002-5.022 17.686-12.908 4.577-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.651 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506-7.32 5.162-23.893 7.11-23.893 7.11z'/%3e%3cpath d='M577.541 756.813c28.24-17.872 49.428-50.836 64.795-92.905-7.584 24.705-27.44 74.716-65.618 96.309l.823-3.404z'/%3e%3cpath d='M612.927 723.337c1.664-6.678.572-11.212-.104-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904zM628.003 697.32c.019-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335zM625.886 704.411c5.174-4.313 9.596-5.132 14.132-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583zM611.06 727.844c5.175-4.313 9.597-5.132 14.133-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583z'/%3e%3cg%3e%3cpath d='M557.393 638.911c3.616-8.648.844-18.542 3.621-25.58 2.96-7.5 8.651 1.957 10.732-3.884 2.081-5.842-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.715-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.951-8.855 13.596-.309 1.094 5.685-2.453 10.95-.99 19.43 1.463 8.482 8.444 8.267 6.597 14.743-1.847 6.476-10.791 3.821-13.985 11.162-3.194 7.34 4.44 12.69 1.211 18.2-3.23 5.508-9.58-.518-14.13 3.835-4.548 4.354 2.01 8.552-4.934 14.954-6.943 6.403-23.931 10.765-23.931 10.765z'/%3e%3cpath d='M547.331 647.1c27.05-22.572 44.8-59.846 55.309-105.768-4.672 26.765-18.816 81.581-55.722 109.423l.413-3.656z'/%3e%3cpath d='M579.785 607.29c.86-7.18-.866-11.741-2.202-16.699 1.796 4.326 3.722 8.52 3.931 14.452l-1.73 2.247zM592.08 578.105c-.879-7.177-3.64-11.15-6.118-15.606 2.772 3.725 5.64 7.29 7.257 12.982l-1.138 2.624zM590.801 585.779c4.821-5.216 9.315-6.69 13.859-8.731-4.361 1.27-8.707 2.353-13.268 5.918l-.59 2.813zM578.43 612.242c4.821-5.216 9.315-6.691 13.859-8.731-4.362 1.27-8.707 2.353-13.269 5.918l-.59 2.813z'/%3e%3c/g%3e%3cg%3e%3cpath d='M533.383 605.314c4.26-6.586-1.069-18.724 2.254-24.109 3.541-5.739 7.22 2.947 9.785-1.556 2.564-4.504-.434-10.335 3.065-16.486 3.5-6.15 8.534-1.658 10.788-6.866 2.254-5.208-2.035-5.336 1.341-11.402 3.377-6.067 12.051-3.846 16.538-10.574 4.383-6.571 11.49-5.472 11.791 1.839.2 4.863-2.913 7.166-2.76 14.395.152 7.229 4.65 9.567 2.204 14.63-2.446 5.064-8.907 1.554-12.63 7.124-3.723 5.57.338 7.774-3.175 11.827-3.514 4.052-6.377 1.487-10.88 4.382-4.502 2.895-.728 11.329-7.568 15.547s-20.753 1.249-20.753 1.249z'/%3e%3cpath d='M522.094 611.2c24.26-10.566 48.596-42.396 63.7-78.703-7.548 21.385-27.469 63.674-63.017 80.985l-.683-2.282z'/%3e%3cpath d='M556.883 582.647c1.686-5.797.792-9.83.287-14.13.986 3.85 2.1 7.61 1.503 12.54l-1.79 1.59zM571.338 560.438c.18-6.063-1.686-9.768-3.242-13.83 1.908 3.503 3.918 6.889 4.57 11.838l-1.328 1.992zM569.226 566.578c4.85-3.565 8.928-4.091 13.122-5.077-3.936.378-7.833.604-12.243 2.845l-.88 2.232zM555.063 586.528c4.85-3.566 8.928-4.092 13.123-5.077-3.936.377-7.834.603-12.244 2.845l-.879 2.232z'/%3e%3c/g%3e%3cg%3e%3cpath d='M381.788 1012.273c3.569-9.036.931-19.718 3.674-27.08 2.923-7.845 8.403 2.52 10.462-3.601 2.06-6.121-5.034-12.523-2.226-20.882 2.808-8.358 10.325-5.832 11.926-12.792 1.601-6.959-6.764-8.331-4.076-16.563 2.687-8.233 12.564-6.875 16.358-16.128 3.706-9.039 11.678-8.837 13.227.354 1.03 6.113-2.451 11.546-1.078 20.658 1.374 9.112 8.166 9.234 6.33 16.043-1.834 6.81-10.52 3.53-13.67 11.194-3.15 7.662 4.245 13.748 1.071 19.457-3.174 5.709-9.316-1.033-13.767 3.379-4.45 4.411 1.903 9.215-4.888 15.69-6.792 6.474-23.343 10.271-23.343 10.271z'/%3e%3cpath d='M375.216 1016.418c26.447-22.698 40.67-57.455 51.163-105.87-4.703 28.292-15.521 81.925-51.587 109.746l.424-3.876z'/%3e%3cpath d='M403.757 979.697c.88-7.61-.773-12.557-2.044-17.907 1.722 4.7 3.57 9.266 3.739 15.598l-1.695 2.309zM415.89 949.21c-.813-7.694-3.476-12.066-5.86-16.94 2.675 4.11 5.443 8.053 6.983 14.2l-1.123 2.74zM414.6 957.324c4.72-5.317 9.1-6.663 13.533-8.61-4.25 1.135-8.484 2.072-12.942 5.642l-.591 2.968zM402.41 984.906c4.72-5.317 9.1-6.663 13.532-8.61-4.25 1.135-8.483 2.072-12.942 5.642l-.59 2.968z'/%3e%3c/g%3e%3cg%3e%3cpath d='M561.082 832.168c-7.131-7.46-19.244-10.076-25.142-16.004-6.287-6.318 7.034-6.423 2.01-11.151-5.023-4.73-15.242-1.31-22.104-7.764-6.862-6.454-.297-12.072-6.405-16.78-6.11-4.707-11.974 2.218-18.774-4.068-6.8-6.286-.138-14.585-7.367-22.35-7.06-7.585-2.579-14.703 7.456-11.801 6.675 1.93 10.246 7.624 20.107 10.648 9.861 3.025 13.63-3.063 19.462 1.785 5.833 4.849-2.112 11.171 3.87 17.609 5.98 6.438 16.044 2.598 20.056 8.142 4.013 5.545-6.035 7.945-4.007 14.037 2.027 6.092 10.249 2.594 13.085 11.77 2.837 9.176-2.247 25.927-2.247 25.927z'/%3e%3cpath d='M540.258 797.04c-7.147-4.36-12.989-5.181-19.028-6.537 5.63.643 11.196 1.109 17.626 3.922l1.402 2.614zM516.245 771.787c-8.14-2.867-13.947-2.505-20.108-2.63 5.552-.496 10.986-1.153 17.968.331l2.14 2.299zM523.677 776.753c-2.79-6.76-1.786-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924zM544.75 800.697c-2.789-6.76-1.785-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924z'/%3e%3cpath d='M561.704 840.054c-8.529-34.554-35.695-63.696-78.54-95.86 25.804 17.503 73.699 52.404 82.193 98.058l-3.653-2.198z'/%3e%3c/g%3e%3cg id='d'%3e%3cpath d='M527.296 890.544c-3.353-8.85-19.798-13.112-22.673-20.186-3.064-7.54 9.126-5.225 6.542-10.926-2.584-5.701-13.345-4.096-16.877-11.879-3.532-7.782 4.826-12.277 1.244-18.154-3.583-5.876-11.854.07-15.4-7.532-3.547-7.6 6.031-14.792 2.719-23.969-3.235-8.964 3.857-15.356 11.781-10.593 5.271 3.167 6.123 9.582 13.838 14.436 7.715 4.855 13.721-.624 16.993 5.346 3.271 5.97-6.643 10.926-3.907 18.532 2.736 7.606 13.533 5.547 14.85 11.89 1.318 6.344-8.857 6.948-9.58 13.485-.724 6.537 8.25 4.488 6.962 14.295-1.288 9.807-6.492 25.255-6.492 25.255z'/%3e%3cpath d='M520.011 853.111c-4.675-5.713-13.031-8.939-17.965-11.41 4.862 1.675 13.116 4.49 17.792 8.508l.173 2.902zM510.082 828.225c.311-7.352 3.166-11.82 5.636-16.725-2.893 4.223-5.912 8.302-7.244 14.293l1.608 2.432zM522.503 854.289c.311-7.352-.15-9.81 2.32-14.714-2.892 4.222-2.596 6.292-3.928 12.283l1.608 2.431z'/%3e%3cpath d='M525.2 906.633c6.813-36.538-12.825-78.385-38.311-118.74 16.138 22.413 52.245 73.859 40.713 121.63l-2.402-2.89z'/%3e%3cpath d='M505.403 821.845c-6.213-4.382-11.66-5.071-17.225-6.319 5.271.507 10.504.83 16.244 3.602l.98 2.717z'/%3e%3c/g%3e%3cg%3e%3cpath d='M493.56 566.123c-1.927-7.016-11.717-8.589-13.368-14.187-1.76-5.967 5.18-4.726 3.698-9.223-1.483-4.498-6.394-4.876-8.42-11.015-2.028-6.14 3.044-8.197.993-12.785-2.052-4.588-4.158-.956-6.193-6.947-2.035-5.99 3.4-12.339 1.494-19.622-1.861-7.115 2.16-12.683 6.68-9.229 3.006 2.298 2.912 6.15 7.313 9.69 4.4 3.541 7.928.853 9.803 5.533 1.875 4.68-3.284 8.464-1.71 14.502 1.573 6.037 4.815 3.657 5.578 8.743.764 5.087-2.126 6.251-2.523 11.602-.398 5.35 6.438 6.382 5.727 14.42-.71 8.037-9.071 18.518-9.071 18.518z'/%3e%3cpath d='M491.743 578.842c5.153-26.274-2.39-63.414-16.983-94.87 9.233 17.366 25.128 56.012 18.673 95.44l-1.69-.57z'/%3e%3cpath d='M491.108 534.358c-2.673-4.397-5.511-5.675-8.324-7.424 2.77 1.106 5.55 2.055 8.219 5.074l.105 2.35zM484.65 510.62c-3.545-3.235-6.647-3.508-9.815-4.23 3 .135 5.978.123 9.25 2.074l.565 2.157zM487.327 515.56c.16-5.991 1.774-9.773 3.169-13.888-1.636 3.584-3.345 7.057-4.09 11.996l.92 1.892zM492.57 537.898c.16-5.991 1.775-9.773 3.17-13.888-1.637 3.583-3.346 7.057-4.09 11.996l.92 1.892z'/%3e%3c/g%3e%3cg%3e%3cpath d='M509.672 575.22c-.207-6.888-6.92-11.393-7.205-16.889-.304-5.858 14.644-4.381 14.25-8.797-.392-4.416-5.461-4.804-6.001-10.832-.54-6.028 5.332-8.027 4.364-12.534-.968-4.506-4.128-.952-4.714-6.834-.586-5.883 1.959-12.396 1.845-19.545-.112-6.984 5.565-12.43 9.425-9.027 2.567 2.264 1.468 6.042 5.18 9.53 3.712 3.486 8.359.996 11.29 4.523 2.915 3.507 2.309 6.345 2.397 12.272.09 5.926 4.118 3.603 3.602 8.594-.517 4.99-3.861 6.123-5.668 11.368-1.807 5.246 5.12 6.282 2.285 14.161-2.835 7.88-31.05 24.01-31.05 24.01z'/%3e%3cpath d='M499.22 585.584c24.422-21.57 36.501-63.212 18.317-93.996 8.18 15.13 12.468 31.125 8.112 50.275-3.15 13.846-10.823 30.446-24.8 44.286l-1.63-.565z'/%3e%3cpath d='M522.267 550.763c-1.672-4.322-6.172-9.786-8.678-11.51 2.628 1.093 7.152 6.235 9.177 9.205l-.499 2.305zM526.287 523.946c-2.89-3.185-6.084-3.465-9.23-4.183 3.121.143 6.259.14 9.196 2.066l.034 2.117zM527.441 524.146c1.724-5.874 4.405-9.577 6.94-13.608-2.652 3.509-5.352 6.91-7.417 11.75l.477 1.858zM523.17 551.67c1.723-5.874 7.855-3.776 12.463-5.225-3.495.052-10.876-1.474-12.942 3.368l.478 1.857z'/%3e%3c/g%3e%3cg%3e%3cpath d='M478.903 575.873c-6.493-4.618-4.563-15.69-9.703-19.496-5.479-4.057-6.718 3.84-10.79.614-4.074-3.225-2.685-8.63-8.243-13.035-5.56-4.406-9.503.287-13.463-3.581-3.96-3.868.525-4.807-4.88-9.168-5.403-4.36-13.875-.838-20.651-5.53-6.62-4.581-13.78-2.292-11.875 3.812 1.267 4.06 5.25 5.359 7.286 11.366 2.037 6.006-1.995 8.813 2.123 12.525 4.118 3.712 9.864-.446 15.482 3.436 5.619 3.882 2.006 6.494 6.943 9.162 4.937 2.668 7.176-.009 12.804 1.51 5.627 1.519 4.21 9.225 12.706 11.384 8.495 2.16 22.261-2.999 22.261-2.999z'/%3e%3cpath d='M492.596 578.547c-28.791-4.023-64.127-25.614-91.088-52.699 14.459 16.215 48.316 47.311 91.062 54.718l.026-2.02z'/%3e%3cpath d='M447.235 561.697c-3.54-4.466-3.822-7.974-4.597-11.627.13 3.374.099 6.7 2.227 10.66l2.37.967zM425.243 546.142c-2.033-4.978-1.192-8.404-.785-12.065-.947 3.267-2.037 6.457-1.22 10.676l2.005 1.389zM429.337 550.809c-6.199-2.006-10.658-1.649-15.38-1.649 4.264-.452 8.443-1.023 13.774-.026l1.606 1.675zM450.334 564.552c-6.199-2.005-10.658-1.648-15.38-1.648 4.264-.453 8.443-1.023 13.774-.027l1.606 1.675z'/%3e%3c/g%3e%3cg%3e%3cpath d='M500.517 605.577c-8.06-3.492-6.615-15.421-13.007-18.344-6.814-3.114-7.68 5.366-12.762 2.833-5.082-2.534-3.845-8.447-10.78-11.909-6.936-3.461-11.258 2.23-16.254-.997-4.996-3.226.255-5.115-6.493-8.56-6.748-3.446-16.535 1.944-24.936-1.567-8.207-3.43-16.533.41-13.805 6.384 1.815 3.972 6.641 4.517 9.518 10.363 2.876 5.845-1.695 9.59 3.476 12.62 5.172 3.032 11.675-2.469 18.64.435 6.966 2.905 2.878 6.36 8.942 8.137 6.064 1.777 8.517-1.468 15.313-1.028 6.796.44 5.704 8.758 15.953 9.281 10.248.524 26.195-7.648 26.195-7.648z'/%3e%3cpath d='M516.976 605.581c-34.484 1.658-78.077-13.661-112.15-36.407 18.4 13.96 60.967 39.483 112.273 38.517l-.123-2.11z'/%3e%3cpath d='M461.843 597.24c-4.542-3.935-5.146-7.533-6.345-11.182.413 3.488.63 6.96 3.458 10.655l2.887.527zM434.55 585.499c-2.794-4.774-2.057-8.516-1.853-12.413-.875 3.597-1.925 7.142-.634 11.373l2.487 1.04zM439.766 589.53c-7.51-.83-12.777.447-18.383 1.407 5.028-1.338 9.945-2.782 16.35-2.826l2.033 1.419zM465.74 599.585c-7.511-.83-12.777.447-18.383 1.407 5.028-1.338 9.944-2.781 16.35-2.826l2.033 1.419z'/%3e%3c/g%3e%3cg%3e%3cpath d='M517.502 629.672c-8.279-2.962-7.618-14.951-14.193-17.452-7.009-2.666-7.318 5.846-12.559 3.648-5.24-2.198-4.393-8.174-11.546-11.178-7.152-3.004-11.095 2.95-16.296.055-5.2-2.894-.08-5.117-7.045-8.117-6.965-3-16.384 3.007-25.005.048-8.42-2.89-16.482 1.477-13.366 7.257 2.073 3.844 6.928 4.076 10.184 9.72 3.255 5.643-1.063 9.67 4.3 12.36 5.363 2.688 11.496-3.216 18.642-.77 7.147 2.446 3.291 6.155 9.463 7.536 6.172 1.38 8.409-2.014 15.224-2.014 6.816-.001 6.27 8.364 16.539 8.225 10.269-.14 25.658-9.318 25.658-9.318z'/%3e%3cpath d='M533.937 628.613c-34.327 3.88-78.864-8.58-114.381-29.062 19.291 12.731 63.471 35.434 114.642 31.158l-.261-2.096z'/%3e%3cpath d='M478.335 623.855c-4.795-3.63-5.633-7.179-7.07-10.74.641 3.452 1.085 6.9 4.152 10.402l2.918.338zM450.31 613.91c-3.104-4.58-2.613-8.359-2.666-12.258-.637 3.643-1.453 7.247.114 11.382l2.552.876zM455.782 617.593c-7.554-.344-12.73 1.271-18.264 2.59 4.933-1.66 9.748-3.416 16.14-3.874l2.124 1.284zM482.38 625.942c-7.555-.343-12.73 1.271-18.265 2.59 4.933-1.659 9.748-3.415 16.14-3.874l2.124 1.284z'/%3e%3c/g%3e%3cg id='a'%3e%3cpath d='M207.197 997.382c6.594-4.258 15.187-3.229 20.577-6.552 5.746-3.542-2.93-7.124 1.577-9.691 4.508-2.568 10.299 2.924 16.456-.579s3.323-9.842 8.535-12.107c5.212-2.265 7.249 4.965 13.322 1.584 6.072-3.38 3.87-11.948 10.607-16.432 6.58-4.38 5.496-11.406-1.813-11.654-4.862-.166-8.671 3.576-15.899 3.473-7.227-.103-8.111-6.094-13.18-3.641-5.068 2.453-1.515 9.734-7.092 13.454-5.577 3.72-11.157-2.076-15.216 1.427-4.06 3.503 1.884 8.112-1.02 12.586s-7.37-.559-11.601 6.237c-4.233 6.796-5.253 21.895-5.253 21.895z'/%3e%3cpath d='M201.964 1007.083c14.53-26.156 42.618-46.357 78.95-61.542-21.397 7.61-64.522 27.103-81.906 62.39l2.956-.848z'/%3e%3cpath d='M229.91 973.981c5.8-1.706 9.83-.848 14.128-.377-3.846-.95-7.603-2.027-12.534-1.404l-1.594 1.781zM252.146 959.533c6.062-.22 9.763 1.602 13.82 3.115-3.498-1.864-6.878-3.83-11.826-4.443l-1.994 1.327zM246.003 961.663c3.575-4.823 4.11-8.86 5.104-13.017-.386 3.897-.62 7.754-2.87 12.133l-2.234.884zM226.026 975.808c3.575-4.823 4.11-8.86 5.105-13.017-.386 3.896-.62 7.754-2.871 12.132l-2.234.885z'/%3e%3c/g%3e%3cg id='b'%3e%3cpath d='M210.31 1024.483c9.07 3.59 19.283 0 26.659 2.74 7.86 2.916-1.833 9.73 4.283 11.752 6.117 2.023 11.83-6.42 20.182-3.663 8.353 2.757 6.447 11.475 13.346 12.93 6.9 1.455 7.619-8.17 15.839-5.544 8.22 2.627 7.627 13.976 16.924 17.811 9.081 3.746 9.475 12.86.633 15.122-5.88 1.505-11.432-2.178-20.209-.12-8.777 2.057-8.393 9.818-15.164 8.089-6.77-1.73-4.218-11.822-11.918-15.007-7.7-3.185-13.082 5.584-18.88 2.267-5.797-3.318.317-10.693-4.31-15.538-4.628-4.844-8.839 2.668-15.65-4.738-6.81-7.407-11.734-26.101-11.734-26.101z'/%3e%3cpath d='M201.572 1013.693c24.073 28.978 63.205 46.859 111.156 56.24-27.914-3.851-85.188-16.83-114.963-56.515l3.807.275z'/%3e%3cpath d='M243.677 1047.816c7.48.597 12.179-1.557 17.298-3.294-4.452 2.218-8.765 4.574-14.923 5.107l-2.375-1.812zM274.281 1060.033c7.437-1.342 11.5-4.618 16.073-7.601-3.807 3.275-7.445 6.647-13.32 8.736l-2.753-1.135zM266.28 1058.996c5.53 5.104 7.165 10.033 9.39 14.989-1.42-4.792-2.646-9.575-6.455-14.474l-2.935-.515zM238.502 1046.558c5.53 5.104 7.166 10.034 9.39 14.99-1.42-4.793-2.646-9.575-6.454-14.475l-2.936-.515z'/%3e%3c/g%3e%3cuse transform='translate(43.941 17.372)' width='744.094' height='1052.362' xlink:href='%23a'/%3e%3cuse transform='translate(59.27 11.24)' width='744.094' height='1052.362' xlink:href='%23b'/%3e%3cg id='e'%3e%3cpath d='M353.525 1034.119c9.75.938 18.788-5.287 26.67-4.699 8.403.627.695 9.792 7.17 10.044 6.474.252 9.888-9.375 18.729-9.035 8.84.34 9.205 9.186 16.298 8.681 7.093-.504 5.34-9.89 14.018-9.638 8.679.252 10.993 11.25 21.029 12.36 9.802 1.084 12.508 9.676 4.47 14.262-5.345 3.05-11.693 1.057-19.72 5.43-8.027 4.371-5.676 11.676-12.713 11.882-7.037.207-7.122-10.128-15.435-11.056-8.314-.928-11.323 8.921-17.817 7.345-6.494-1.576-2.416-10.294-8.16-13.65-5.743-3.355-7.93 4.972-16.454-.23-8.524-5.202-18.085-21.696-18.085-21.696z'/%3e%3cpath d='M342.262 1026.217c30.838 21.058 73.521 27.39 122.63 23.187-28.178 3.984-87.287 7.308-126.41-22.406l3.78-.781z'/%3e%3cpath d='M391.98 1047.238c7.44-1.483 11.469-4.828 16.014-7.891-3.772 3.34-7.374 6.772-13.238 8.97l-2.776-1.078zM424.91 1050.503c6.904-3.321 10.028-7.563 13.723-11.666-2.874 4.171-5.56 8.388-10.751 11.995l-2.971-.329zM416.85 1051.709c6.689 3.355 9.539 7.612 12.969 11.732-2.605-4.185-5.018-8.414-9.977-12.046l-2.992.314zM386.618 1047.457c6.688 3.355 9.538 7.612 12.968 11.733-2.605-4.185-5.018-8.415-9.977-12.046l-2.991.313z'/%3e%3c/g%3e%3cg%3e%3cpath d='M292.72 1024.547c4.983-5.068 13.172-6.262 17.286-10.274 4.385-4.277-4.539-5.162-1.043-8.344 3.495-3.182 10.25-.04 15.024-4.383 4.775-4.342.528-8.882 4.75-11.982 4.222-3.1 7.963 2.36 12.692-1.861 4.728-4.222.49-10.745 5.546-16.031 4.939-5.164 2.13-10.684-4.674-9.153-4.526 1.019-7.074 5-13.765 6.632-6.69 1.631-9.05-3.085-13.09.136-4.042 3.22 1.11 8.363-3.074 12.747-4.184 4.383-10.823.942-13.663 4.787-2.84 3.844 3.828 6.223 2.303 10.591-1.525 4.369-6.939 1.29-9.09 7.884-2.152 6.593.798 19.25.798 19.25z'/%3e%3cpath d='M292.089 1030.323c6.657-24.958 25.657-44.795 55.246-65.91-17.769 11.34-50.817 34.166-57.754 67.31l2.508-1.4z'/%3e%3cpath d='M307.634 999.911c4.908-2.78 8.845-3.032 12.929-3.665-3.79.132-7.533.139-11.919 1.822l-1.01 1.843zM324.414 982.75c5.533-1.62 9.415-1 13.547-.72-3.707-.702-7.33-1.516-12.05-.845l-1.497 1.565zM319.298 985.96c2.054-4.814 1.507-8.261 1.352-11.915.649 3.296 1.427 6.523.48 10.658l-1.832 1.258zM304.523 1002.335c2.054-4.814 1.507-8.262 1.353-11.915.648 3.295 1.426 6.523.479 10.658l-1.832 1.257z'/%3e%3c/g%3e%3cg%3e%3cpath d='M345.42 1017.313c4.024-6.249 12.081-9.145 15.439-14.127 3.579-5.31-5.644-4.413-2.745-8.41 2.898-3.998 10.379-2.124 14.34-7.58 3.96-5.457-1.262-9.286 2.39-13.347 3.651-4.06 8.547.823 12.485-4.5 3.938-5.323-1.676-11.202 2.378-17.692 3.96-6.34-.004-11.472-6.59-8.508-4.38 1.971-6.157 6.603-12.608 9.647-6.45 3.045-9.795-1.35-13.24 2.8-3.443 4.148 2.819 8.416-.534 13.795-3.354 5.38-10.778 3.172-12.879 7.721-2.1 4.55 5.138 5.654 4.477 10.478-.662 4.823-6.771 2.742-7.618 9.992-.846 7.25 4.705 19.73 4.705 19.73z'/%3e%3cpath d='M345.948 1023.41c1.698-27.142 16.94-51.5 42.655-79.326-15.714 15.325-44.589 45.623-44.914 81.28l2.259-1.954z'/%3e%3cpath d='M355.549 988.827c4.412-3.87 8.351-4.929 12.362-6.413-3.815.907-7.606 1.673-11.71 4.304l-.652 2.109zM369.083 967.686c5.28-2.797 9.34-2.946 13.584-3.495-3.899.027-7.736-.078-12.383 1.574l-1.2 1.921zM364.548 972.043c1.107-5.392-.145-8.843-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672zM352.887 991.964c1.108-5.393-.144-8.844-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672z'/%3e%3c/g%3e%3cg id='f'%3e%3cpath d='M505.882 948.746c7.671-4.14 11.335-13.195 17.453-16.668 6.522-3.7 5.27 6.858 10.184 3.836 4.913-3.022 2.763-11.794 9.47-15.923 6.706-4.129 11.274 2.196 16.277-1.689 5.003-3.884-.853-9.918 5.69-14.032 6.545-4.114 13.6 2.827 21.565-1.327 7.78-4.059 13.956.92 10.236 8.274-2.474 4.891-8.14 6.57-11.955 13.762-3.816 7.192 1.473 11.399-3.634 15.037-5.106 3.638-10.19-3.92-16.792-.485-6.603 3.436-4.045 12.17-9.616 14.227-5.571 2.058-6.789-6.374-12.668-5.996-5.88.377-3.454 7.585-12.288 7.982-8.834.396-23.922-6.998-23.922-6.998z' transform='translate(9.389 -7.87)'/%3e%3cpath d='M493.71 948.513c33.048.211 67.707-16.276 102.004-43.693-18.915 16.888-61.038 48.614-104.421 46.14l2.417-2.447z' transform='translate(9.389 -7.87)'/%3e%3cpath d='M540.711 939.345c4.784-4.776 6.14-9.232 8.016-13.736-1.17 4.324-2.167 8.633-5.438 13.154l-2.578.582zM566.664 925.434c3.495-5.863 3.745-10.53 4.487-15.378-.1 4.492-.04 8.923-2.13 14.148l-2.357 1.23zM561.285 930.313c6.58-.846 10.756.873 15.296 2.204-3.96-1.787-7.8-3.702-13.234-3.917l-2.062 1.713zM536.85 942.163c6.578-.846 10.755.873 15.294 2.204-3.96-1.788-7.8-3.703-13.234-3.917l-2.06 1.713z' transform='translate(9.389 -7.87)'/%3e%3c/g%3e%3cg%3e%3cpath d='M582.995 716.21c3.617-8.648.845-18.541 3.621-25.579 2.96-7.501 8.651 1.956 10.732-3.885 2.082-5.841-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.716-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.952-8.855 13.596-.308 1.094 5.684-2.453 10.95-.99 19.43 1.464 8.481 8.445 8.267 6.598 14.743-1.847 6.475-10.792 3.82-13.986 11.16-3.193 7.341 4.44 12.692 1.211 18.2-3.23 5.51-9.58-.517-14.13 3.837-4.548 4.353 2.01 8.552-4.934 14.954-6.943 6.402-23.931 10.764-23.931 10.764z'/%3e%3cpath d='M572.933 724.398c27.051-22.571 44.801-59.844 55.31-105.767-4.673 26.766-18.817 81.581-55.723 109.423l.413-3.656z'/%3e%3cpath d='M605.387 684.59c.861-7.18-.866-11.742-2.202-16.7 1.797 4.326 3.722 8.52 3.931 14.452l-1.729 2.248zM617.683 655.404c-.88-7.177-3.642-11.15-6.12-15.606 2.774 3.725 5.64 7.29 7.259 12.982l-1.139 2.624zM616.404 663.078c4.82-5.216 9.315-6.69 13.858-8.731-4.361 1.27-8.706 2.354-13.268 5.918l-.59 2.813zM604.032 689.54c4.821-5.215 9.315-6.69 13.86-8.73-4.362 1.27-8.708 2.354-13.27 5.918l-.59 2.813z'/%3e%3c/g%3e%3cg%3e%3cpath d='M572.265 672.078c4.442-7.713 2.993-17.421 6.45-23.719 3.686-6.712 7.945 2.958 10.604-2.298 2.658-5.255-3.596-11.547.03-18.725 3.627-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.233-15.052 3.496-7.076 13.002-5.021 17.687-12.908 4.576-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.652 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506s-23.893 7.11-23.893 7.11z'/%3e%3cpath d='M561.786 678.53c28.239-17.873 49.427-50.837 64.795-92.906-7.584 24.705-27.44 74.716-65.619 96.309l.824-3.404z'/%3e%3cpath d='M597.172 645.053c1.664-6.678.571-11.212-.105-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904zM612.248 619.036c.018-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335zM610.13 626.127c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.891 2.583zM595.305 649.56c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.892 2.583z'/%3e%3c/g%3e%3cg%3e%3cpath d='M566.742 775.935c-7.882-5.63-18.266-4.844-24.713-9.25-6.871-4.697 3.658-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.84-12.336-10.09-15.426-6.249-3.09-8.83 5.718-16.099 1.202-7.268-4.516-4.466-14.966-12.516-20.881-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.121 5.186 8.721.281 5.014-4.332 11.087-1.017 6.072 3.314 4.838 12.095 11.503 17.002 6.665 4.907 15.195-4.66 20.033-.107 4.837 4.554-2.412 9.907 1.015 15.593 3.427 5.686 8.9-.273 13.89 8.353 4.99 8.627 5.963 27.322 5.963 27.322z'/%3e%3cpath d='M572.89 788.204c-17.083-33.105-50.624-59.625-94.197-80.421 25.684 10.602 77.378 37.099 97.749 81.634l-3.552-1.213z'/%3e%3cpath d='M539.74 745.768c-6.968-2.434-11.845-1.602-17.037-1.264 4.655-.955 9.207-2.073 15.145-1.024l1.892 2.288zM513.16 726.678c-7.31-.613-11.805 1.426-16.727 3.064 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75zM520.536 729.655c-4.231-6.155-4.808-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218zM544.394 748.242c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.679 1.218z'/%3e%3c/g%3e%3cg%3e%3cpath d='M574.693 843.39c5.85-6.617 6.32-16.43 10.93-21.87 4.915-5.796 7.205 4.571 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.265 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.741-15.21 4.8-6.194 13.71-2.18 19.831-8.916 5.98-6.581 13.42-4.099 12.338 4.135-.72 5.476-5.492 9.069-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.424-3.605 5.235-10.865-.06-15.942 5.516s.195 12.875-4.366 16.79c-4.56 3.915-8.473-3.576-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.515-24.78 1.93-24.78 1.93z'/%3e%3cpath d='M563.176 847.501c31.13-11.554 58.29-39.374 81.522-77.336-12.232 22.598-41.404 67.392-82.99 80.496l1.468-3.16z'/%3e%3cpath d='M604.34 822.17c2.928-6.189 2.74-10.859 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.464zM624.164 799.868c1.36-6.752.063-11.227-.832-16.046 1.38 4.256 2.893 8.399 2.644 14.051l-1.812 1.995zM620.711 806.366c5.906-3.134 10.395-3.004 15.1-3.368-4.31-.271-8.548-.705-13.725 1.026l-1.375 2.342zM601.635 826.192c5.906-3.134 10.396-3.004 15.1-3.368-4.31-.271-8.547-.705-13.725 1.025l-1.375 2.343z'/%3e%3c/g%3e%3cuse transform='rotate(15 310.012 758.36)' width='744.094' height='1052.362' xlink:href='%23c'/%3e%3cuse transform='rotate(5 93.23 577.125)' id='c' width='744.094' height='1052.362' xlink:href='%23d'/%3e%3cuse transform='rotate(-10 274.952 690.264)' width='744.094' height='1052.362' xlink:href='%23e'/%3e%3cuse transform='rotate(10 225.439 653.89)' width='744.094' height='1052.362' xlink:href='%23f'/%3e%3c/g%3e%3cuse transform='matrix(-1 0 0 1 840 .113)' width='1' height='1' xlink:href='%23g'/%3e%3c/g%3e%3cg stroke='%23d4af37' stroke-width='3'%3e%3cpath d='M409.242 237.563l-19.765 24.609c6.548 6.237 10.26 16.668 10.273 25.148.016 10.607-1.723 17.955-3.867 24.657-.023.07-.048.14-.07.21H450v-74.124c-11.935 7.409-28.331 10.36-40.758-.5z' fill='%23007ea8' stroke-width='.75'/%3e%3cpath d='M490.758 237.563c-12.427 10.86-28.823 7.909-40.758.5v74.125h54.188c-.023-.071-.048-.14-.07-.211-2.145-6.702-3.884-14.05-3.868-24.657.013-8.48 3.725-18.911 10.273-25.148l-19.765-24.61z' fill='white' stroke-width='.75'/%3e%3cpath d='M395.813 312.188c-2.952 9.169-6.658 17.15-7.813 30.414-1.705 19.584 14.046 30.306 20.555 33.375 10.034 4.731 20.518 3.095 31.25 4.468 4.98.638 7.766 3.789 10.195 6.368 2.429-2.58 5.215-5.73 10.195-6.368 10.732-1.373 21.216.263 31.25-4.468 6.509-3.07 22.26-13.791 20.555-33.375-1.155-13.264-4.861-21.245-7.813-30.414H395.813z' fill='%23d91023' stroke-width='.75'/%3e%3c/g%3e%3cg stroke='%23d4af37' stroke-width='3'%3e%3cg transform='matrix(.119 0 0 .125 327.413 310.562)' fill='%2300a854' stroke-width='6.156'%3e%3cg id='j' stroke-width='3.078'%3e%3cg stroke-width='9.649'%3e%3cpath d='M1074.733-201.404s5.849-20.366 17.932-29.304c12.084-8.938 25.212-5.671 33.195-8.854-5.322 6.748-5.925 20.263-17.932 29.305-12.006 9.041-33.195 8.853-33.195 8.853zM1123.432-237.75c-8.333 2.219-13.523-.31-24.954 3.897M1115.763-232.026c-8.333 2.219-14.117-1.33-25.335 3.386M1106.56-225.157c-7.912 2.781-11.632-1.2-22.466 4.03M1097.357-218.289c-7.912 2.782-9.57-1.713-17.49 4.297M1089.177-212.184c-5.168 1.667-7.531-.17-12.134 5.076M1123.432-237.75c-4.497 7.358-3.55 13.053-10.835 22.815M1115.763-232.026c-4.497 7.358-2.742 13.912-10.454 23.325M1106.56-225.157c-4.918 6.794-2.159 11.492-10.256 20.39M1097.357-218.289c-4.918 6.794-1.08 9.663-9.096 15.545M1089.177-212.184c-3.068 4.48-1.98 7.268-8.318 10.188' stroke-width='3.0778380199999997'/%3e%3cpath d='M1130.782-243.633s-13.538 10.037-24.157 18.03c-10.62 7.992-31.636 24.008-31.636 24.008s21.334-15.59 32.017-23.497c10.684-7.907 24.158-18.03 24.158-18.03' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cg stroke-width='9.649'%3e%3cpath d='M1108.115-316.994s16.753 12.975 20.58 27.51c3.828 14.534-4.068 25.52-4.068 34.113-4.297-7.442-16.628-13.007-20.58-27.509-3.953-14.501 4.068-34.114 4.068-34.114zM1123.843-258.298c1.025-8.562 5.296-12.446 5.62-24.622M1121.366-267.541c1.025-8.562 6.463-12.621 6.237-24.788M1118.394-278.633c.346-8.38 5.422-10.36 4.576-22.362M1115.422-289.725c.346-8.38 5.135-8.257 2.485-17.839M1112.78-299.585c.366-5.418 2.946-6.933-.222-13.15M1123.843-258.298c-5.17-6.902-10.81-8.13-17.18-18.513M1121.366-267.541c-5.17-6.902-11.908-7.699-17.796-18.348M1118.394-278.633c-4.49-7.084-9.877-6.262-15.144-17.078M1115.422-289.725c-4.49-7.084-8.576-4.583-11.072-14.206M1112.78-299.585c-3.026-4.509-6.019-4.53-6.384-11.499' stroke-width='3.0778380199999997'/%3e%3cpath d='M1126.586-249.291s-4.31-16.293-7.802-29.117c-3.491-12.824-10.586-38.277-10.586-38.277s6.581 25.59 9.97 38.442a5074.411 5074.411 0 0 0 7.802 29.117' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cg id='h' stroke-width='9.649'%3e%3cpath d='M1206.423-261.845s16.752 12.975 20.58 27.51c3.828 14.534-4.069 25.519-4.069 34.113-4.297-7.443-16.628-13.008-20.58-27.509-3.952-14.501 4.069-34.114 4.069-34.114zM1222.15-203.15c1.025-8.56 5.296-12.445 5.621-24.622M1219.673-212.393c1.026-8.561 6.464-12.62 6.238-24.787M1216.701-223.485c.347-8.38 5.423-10.36 4.576-22.36M1213.73-234.577c.345-8.38 5.135-8.256 2.485-17.838M1211.087-244.436c.366-5.418 2.947-6.933-.221-13.15M1222.15-203.15c-5.169-6.901-10.81-8.13-17.18-18.512M1219.673-212.393c-5.168-6.902-11.907-7.698-17.795-18.348M1216.701-223.485c-4.49-7.084-9.876-6.26-15.143-17.077M1213.73-234.577c-4.49-7.084-8.576-4.582-11.072-14.205M1211.087-244.436c-3.025-4.51-6.018-4.53-6.383-11.5' stroke-width='3.0778380199999997'/%3e%3cpath d='M1224.894-194.142s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.97 38.443c3.39 12.852 7.803 29.117 7.803 29.117' stroke-width='3.0778380199999997'/%3e%3cg%3e%3cpath d='M1170.504-136.72s2.86-20.996 13.533-31.579c10.673-10.582 24.135-9.236 31.578-13.533-4.297 7.443-2.951 20.904-13.534 31.578-10.582 10.673-31.577 13.533-31.577 13.533zM1213.472-179.69c-7.928 3.394-13.427 1.637-24.135 7.444M1206.705-172.923c-7.927 3.393-14.161.714-24.585 6.993M1198.585-164.803c-7.43 3.89-11.684.485-21.653 7.218M1190.465-156.683c-7.43 3.89-9.718-.319-16.69 6.767M1183.247-149.465c-4.874 2.392-7.477.915-11.277 6.767M1213.472-179.69c-3.393 7.928-1.637 13.428-7.444 24.135M1206.705-172.923c-3.393 7.928-.713 14.162-6.992 24.586M1198.585-164.803c-3.89 7.43-.484 11.684-7.218 21.654M1190.465-156.683c-3.89 7.43.32 9.718-6.767 16.692M1183.247-149.465c-2.391 4.875-.914 7.477-6.766 11.278' stroke-width='3.0778380199999997'/%3e%3cpath d='M1219.9-186.569s-11.954 11.88-21.315 21.315c-9.36 9.436-27.856 28.308-27.856 28.308s18.871-18.496 28.307-27.857a5074.411 5074.411 0 0 0 21.315-21.315' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3c/g%3e%3cg stroke-width='9.649'%3e%3cpath d='M1057.073-278.588s20.562-5.119 34.344.877c13.783 5.996 17.517 18.999 24.265 24.321-8.505-1.235-20.511 5-34.344-.877-13.834-5.878-24.265-24.321-24.265-24.321zM1112.898-254.587c-6.087-6.107-6.492-11.866-15.851-19.662M1104.107-258.366c-6.088-6.108-5.907-12.891-15.6-20.249M1093.557-262.902c-6.365-5.462-4.777-10.674-14.723-17.441M1083.007-267.438c-6.365-5.462-3.302-9.145-12.466-12.999M1073.63-271.47c-4.027-3.642-3.619-6.607-10.462-7.97M1112.898-254.587c-8.62-.216-13.078 3.452-25.175 2.024M1104.107-258.366c-8.62-.217-13.42 4.581-25.427 2.609M1093.557-262.902c-8.343-.862-11.032 3.877-22.787 1.314M1083.007-267.438c-8.342-.862-8.908 3.895-18.01-.105M1073.63-271.47c-5.414-.416-7.284 1.92-12.982-2.109' stroke-width='3.0778380199999997'/%3e%3cpath d='M1121.669-251.163s-15.462-6.705-27.693-11.906c-12.232-5.201-36.61-15.393-36.61-15.393s24.168 10.68 36.358 15.979c12.19 5.298 27.693 11.906 27.693 11.906' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cg stroke-width='9.649'%3e%3cpath d='M1072.283-383.91s14.687-15.274 29.546-17.531c14.86-2.257 24.941 6.766 33.486 7.682-7.858 3.479-14.706 15.147-29.546 17.53-14.84 2.385-33.486-7.681-33.486-7.681zM1132.321-393.291c-8.404-1.933-11.81-6.593-23.883-8.214M1122.866-391.814c-8.403-1.932-11.86-7.772-23.981-8.844M1111.52-390.041c-8.295-1.238-9.723-6.496-21.745-6.934M1100.175-388.268c-8.295-1.238-7.662-5.987-17.472-4.373M1090.09-386.692c-5.348-.942-6.58-3.67-13.099-1.182M1132.321-393.291c-7.414 4.403-9.237 9.881-20.239 15.108M1122.866-391.814c-7.413 4.404-8.923 11.02-20.14 15.738M1111.52-390.041c-7.522 3.709-7.278 9.152-18.594 13.237M1100.175-388.268c-7.522 3.709-5.47 8.038-15.305 9.494M1090.09-386.692c-4.806 2.527-5.146 5.5-12.114 5.121' stroke-width='3.0778380199999997'/%3e%3cpath d='M1141.57-395.06s-16.66 2.55-29.783 4.654c-13.124 2.105-39.188 6.447-39.188 6.447s26.146-3.817 39.286-5.816c13.14-2 29.783-4.654 29.783-4.654' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cg stroke-width='9.649'%3e%3cpath d='M1102.133-454.901s19.984 7.045 28.19 19.637c8.207 12.592 4.168 25.504 6.872 33.661-6.42-5.713-19.876-7.115-28.19-19.637-8.314-12.52-6.872-33.661-6.872-33.661zM1135.53-404.135c-1.721-8.45 1.11-13.48-2.412-25.14M1130.27-412.13c-1.72-8.449 2.164-14.013-1.878-25.49M1123.96-421.723c-2.309-8.063 1.887-11.54-2.693-22.665M1117.648-431.317c-2.308-8.063 2.277-9.452-3.253-17.714M1112.038-439.844c-1.357-5.258.616-7.508-4.347-12.413M1135.53-404.135c-7.078-4.925-12.82-4.316-22.132-12.167M1130.27-412.13c-7.078-4.925-13.725-3.56-22.664-11.817M1123.96-421.723c-6.491-5.312-11.345-2.836-19.748-11.445M1117.648-431.317c-6.49-5.311-9.582-1.651-14.979-10M1112.038-439.844c-4.29-3.328-7.138-2.407-9.677-8.907' stroke-width='3.0778380199999997'/%3e%3cpath d='M1140.968-396.448s-9.218-14.11-16.567-25.184c-7.349-11.075-22.092-33.003-22.092-33.003s14.299 22.22 21.56 33.354c7.26 11.133 16.566 25.183 16.566 25.183' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cg id='i' stroke-width='9.649'%3e%3cpath d='M1213.668-401.795s16.753 12.975 20.58 27.51c3.828 14.534-4.068 25.519-4.068 34.113-4.297-7.443-16.628-13.008-20.58-27.51-3.953-14.5 4.068-34.113 4.068-34.113zM1229.395-343.1c1.026-8.561 5.297-12.446 5.622-24.622M1226.919-352.343c1.025-8.561 6.463-12.62 6.237-24.787M1223.947-363.435c.346-8.38 5.422-10.36 4.575-22.36M1220.974-374.527c.347-8.38 5.136-8.256 2.486-17.838M1218.333-384.386c.365-5.418 2.946-6.933-.222-13.15M1229.395-343.1c-5.168-6.901-10.81-8.13-17.179-18.512M1226.919-352.343c-5.17-6.902-11.908-7.698-17.796-18.348M1223.947-363.435c-4.49-7.084-9.877-6.26-15.144-17.077M1220.974-374.527c-4.49-7.084-8.575-4.582-11.071-14.205M1218.333-384.386c-3.026-4.51-6.019-4.531-6.384-11.5' stroke-width='3.0778380199999997'/%3e%3cpath d='M1232.139-334.092s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.971 38.443a5074.411 5074.411 0 0 0 7.802 29.117' stroke-width='3.0778380199999997'/%3e%3cg%3e%3cpath d='M1167.114-294.907s8.197-19.54 21.245-27c13.05-7.458 25.704-2.674 34.005-4.899-6.077 6.077-8.261 19.429-21.245 27-12.984 7.57-34.005 4.899-34.005 4.899zM1219.74-325.29c-8.536 1.225-13.393-1.895-25.239.943M1211.452-320.506c-8.535 1.226-13.863-2.976-25.557.391M1201.507-314.764c-8.184 1.834-11.41-2.556-22.783 1.368M1191.562-309.022c-8.184 1.834-9.304-2.824-17.873 2.216M1182.722-303.918c-5.327 1.048-7.459-1.052-12.644 3.617M1219.74-325.29c-5.33 6.779-5.056 12.546-13.437 21.385M1211.452-320.506c-5.329 6.78-4.354 13.495-13.117 21.938M1201.507-314.764c-5.68 6.17-3.492 11.16-12.576 19.047M1191.562-309.022c-5.68 6.17-2.206 9.47-10.856 14.37M1182.722-303.918c-3.572 4.089-2.818 6.985-9.455 9.142' stroke-width='3.0778380199999997'/%3e%3cpath d='M1227.73-330.272s-14.622 8.38-26.106 15.072c-11.484 6.692-34.233 20.133-34.233 20.133s23.015-12.98 34.552-19.58a5074.411 5074.411 0 0 0 26.105-15.072' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3c/g%3e%3cg stroke-width='9.649'%3e%3cpath d='M1182.237-442.008s19.633-7.97 34.124-3.98c14.49 3.991 20.024 16.337 27.455 20.653-8.594-.022-19.6 7.845-34.124 3.98-14.525-3.867-27.455-20.653-27.455-20.653zM1240.89-426.127c-6.888-5.187-8.102-10.83-18.467-17.228M1231.654-428.628c-6.888-5.187-7.667-11.928-18.301-17.843M1220.57-431.629c-7.072-4.508-6.236-9.893-17.038-15.188M1209.485-434.63c-7.072-4.509-4.56-8.588-14.176-11.11M1199.633-437.298c-4.5-3.037-4.515-6.03-11.482-6.414M1240.89-426.127c-8.564 1.003-12.46 5.264-24.636 5.557M1231.654-428.628c-8.564 1.003-12.638 6.43-24.804 6.172M1220.57-431.629c-8.381.324-10.375 5.395-22.373 4.517M1209.485-434.63c-8.38.324-8.27 5.113-17.844 2.438M1199.633-437.298c-5.419.352-6.94 2.928-13.15-.256' stroke-width='3.0778380199999997'/%3e%3cpath d='M1250.057-423.975s-16.253-4.456-29.096-7.879c-12.843-3.422-38.416-10.07-38.416-10.07s25.434 7.161 38.25 10.686a5074.41 5074.41 0 0 0 29.095 7.878' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cg stroke-width='9.649'%3e%3cpath d='M1215.135-497.138s19.518 8.248 26.943 21.316c7.425 13.068 2.608 25.71 4.81 34.017-6.06-6.093-19.406-8.312-26.943-21.316-7.537-13.004-4.81-34.017-4.81-34.017zM1245.38-444.433c-1.203-8.539 1.93-13.388-.877-25.241M1240.617-452.733c-1.203-8.539 3.013-13.856-.324-25.558M1234.902-462.693c-1.813-8.189 2.586-11.404-1.308-22.787M1229.186-472.653c-1.813-8.189 2.848-9.297-2.17-17.88M1224.105-481.506c-1.034-5.33 1.072-7.456-3.584-12.654M1245.38-444.433c-6.765-5.347-12.532-5.089-21.35-13.492M1240.617-452.733c-6.765-5.347-13.483-4.39-21.903-13.175M1234.902-462.693c-6.156-5.697-11.151-3.521-19.015-12.626M1229.186-472.653c-6.155-5.697-9.464-2.232-14.342-10.894M1224.105-481.506c-4.08-3.583-6.978-2.837-9.117-9.48' stroke-width='3.0778380199999997'/%3e%3cpath d='M1250.34-436.43s-8.342-14.644-15.003-26.145c-6.662-11.502-20.043-34.286-20.043-34.286s12.92 23.049 19.49 34.603c6.569 11.555 15.003 26.145 15.003 26.145' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3cuse transform='translate(-32 -18)' width='744.094' height='1052.362' xlink:href='%23h'/%3e%3cg stroke-width='9.649'%3e%3cpath d='M1142.423-297.845s16.752 12.975 20.58 27.51c3.828 14.534-4.069 25.519-4.069 34.113-4.297-7.443-16.628-13.008-20.58-27.509-3.952-14.501 4.069-34.114 4.069-34.114zM1158.15-239.15c1.025-8.56 5.296-12.445 5.621-24.622M1155.673-248.393c1.026-8.561 6.464-12.62 6.238-24.787M1152.701-259.485c.347-8.38 5.423-10.36 4.576-22.36M1149.73-270.577c.345-8.38 5.135-8.256 2.485-17.838M1147.087-280.436c.366-5.418 2.947-6.933-.221-13.15M1158.15-239.15c-5.169-6.901-10.81-8.13-17.18-18.512M1155.673-248.393c-5.168-6.902-11.907-7.698-17.795-18.348M1152.701-259.485c-4.49-7.084-9.876-6.26-15.143-17.077M1149.73-270.577c-4.49-7.084-8.576-4.582-11.072-14.205M1147.087-280.436c-3.025-4.51-6.018-4.53-6.383-11.5' stroke-width='3.0778380199999997'/%3e%3cpath d='M1160.894-230.142s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.97 38.443c3.39 12.852 7.803 29.117 7.803 29.117' stroke-width='3.0778380199999997'/%3e%3cg%3e%3cpath d='M1106.504-172.72s2.86-20.996 13.533-31.579c10.673-10.582 24.135-9.236 31.578-13.533-4.297 7.443-2.951 20.904-13.534 31.578-10.582 10.673-31.577 13.533-31.577 13.533zM1149.472-215.69c-7.928 3.394-13.427 1.637-24.135 7.444M1142.705-208.923c-7.927 3.393-14.161.714-24.585 6.993M1134.585-200.803c-7.43 3.89-11.684.485-21.653 7.218M1126.465-192.683c-7.43 3.89-9.718-.319-16.69 6.767M1119.247-185.465c-4.874 2.392-7.477.915-11.277 6.767M1149.472-215.69c-3.393 7.928-1.637 13.428-7.444 24.135M1142.705-208.923c-3.393 7.928-.713 14.162-6.992 24.586M1134.585-200.803c-3.89 7.43-.484 11.684-7.218 21.654M1126.465-192.683c-3.89 7.43.32 9.718-6.767 16.692M1119.247-185.465c-2.391 4.875-.914 7.477-6.766 11.278' stroke-width='3.0778380199999997'/%3e%3cpath d='M1155.9-222.569s-11.954 11.88-21.315 21.315c-9.36 9.436-27.856 28.308-27.856 28.308s18.871-18.496 28.307-27.857a5074.411 5074.411 0 0 0 21.315-21.315' stroke-width='3.0778380199999997'/%3e%3c/g%3e%3c/g%3e%3cuse transform='translate(-62 -40)' width='744.094' height='1052.362' xlink:href='%23i'/%3e%3cuse transform='translate(-31 -20)' width='744.094' height='1052.362' xlink:href='%23i'/%3e%3c/g%3e%3cuse transform='matrix(-1 0 0 1 2501 0)' width='744.094' height='1052.362' xlink:href='%23j'/%3e%3cpath d='M1250.5-437.125c-8.62 41.666-8.594 79.156-8.594 79.156-.505 13.948-7.41 23.678-13.781 20-54.887-31.689-60.291-37.57-89.125-59.669 24.306 26.461 31.231 38.23 86.719 70.266 10.728 6.193 12.062 16.378 11.625 29.469l-1.688 61.716c-.302 9.035 5.747 50.084-22.562 34.218-65.373-36.637-63.772-33.585-95.094-51.669 38.074 32.327 24.373 23.468 90.594 61.7 11.943 6.896 24.531 24.497 24.531 32.844 0 124.331 1.865 101.486-12.813 139.096h60.376c-14.678-37.61-12.813-14.765-12.813-139.096 0-8.347 12.588-25.948 24.531-32.844 66.221-38.232 51.52-29.373 89.594-61.7-31.322 18.084-28.72 15.032-94.094 51.67-28.309 15.865-22.26-25.184-22.562-34.22l-1.688-61.715c-.437-13.09.897-23.276 11.625-29.47 55.488-32.035 62.413-43.804 86.719-70.265-28.834 22.099-34.238 27.98-89.125 59.67-6.37 3.677-13.276-6.053-13.781-20 0 0 .027-37.49-8.594-79.157z' fill='%23947245'/%3e%3c/g%3e%3cg stroke-width='2.727'%3e%3cpath d='M264.452 424.637c-.25.946 1.503 12.373.546 15.66-.508 4.54-.635 5.238-1.704 11.12-1.069 5.881-2.364 17.308-4.391 24.163-.17.576-.408 1.358-.452 2.042-.567 3.502-.584 5.981-.211 10.35l3.512 19.415s1.634 1.918 1.881 2.722c.247.804-.172 2.006-.006 2.25.927 1.362 1.074 2.702 2.177 3.848.173.18.92.107 1.118.356.171.216 1.485.3 1.74.466.784.74.646 1.276 1.049 2.404l-6.321.026c.162-2.822-2.057-3.938-2.057-3.938-.244-.308-2.823-1.017-3.121-2.683-.413-2.392-.068-2.869-.068-2.869s-2.115-9.062-2.996-11.33c-.504-1.758-.605-2.592-.855-4.127-.76-4.24-1.017-6.075-3.32-12.405-.547-1.097-1.987-1.453-1.869-2.898.154-.557.427-.979.701-1.462l.072-1.11c.336-5.183.625-10.384 1.056-15.547a1.85 1.85 0 0 0 .236-.741c.602-8.797-4.079-17.02-7.1-24.897-.548-1.43-.075-2.995-.696-4.423-3.214-1.108-5.415-6.475-6.563-9.854-1.122-3.303-1.617-8.284-.764-11.589.278-1.077.434-1.814.964-2.522M300.323 443.746c1.026-.24 1.416-.319 2.51-.308 0 0 .74 1.02.959 1.499 1.529 2.753 3.371 15.341 4.434 21.193.33 1.814 1.094 5.943 1.434 7.866 0 0-.377 2.066.288 4.345.203.695.426 1.387.609 2.085.803 3.062 1.716 3.813 1.716 3.813.214.733 1.468 6.751 1.681 7.484 1.842 8.241 2.741 13.212 2.623 16.652-.115 4.714-.09 4.254.284 4.639 1.037 1.068 1.567.406 3.787 6.085.133.454.265-.217.505.234.287.538.78.477 1.18.53.73.096.59.23 1.181.307a6.248 6.248 0 0 0 1.58.015l5.461.037c-.67-1.992-2.887-3.369-4.828-3.386-.857-.528-1.85-1.282-2.155-2.287-1.251-2.003-1.608-2.427-2.262-3.335.108-.722-.414-1.692-.64-2.47l-1.958-23.232s.403-2.328.372-4.745c-.164-12.768.578-25.616 1.05-38.434.16-1.074 4.04-4.71 4.04-4.71' fill='%23e3e4e5' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z' fill='white' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M438.616 251.458a2.003 2.003 0 0 0-1.493.691c-.491.682-.813 2.086-.849 2.93-.01.223.082.393.012.593-.239.682-.434 1.273-.45 1.364-.208 1.191-.25 5.464-.548 7.101-.299 1.637-1.638 4.049-2.184 4.785-.302.408-1.03.568-1.243.617-.214.05-1.973-.133-1.973-.133-2.321-.164-5.774-1.454-8.09-1.768-2.315-.314-5.117-.165-7.299-.398 0 0-2.728-1.015-5.24-.28-2.476.723-3.868 2.063-6.02 5.391 0 0-.923 1.136-.934 1.51-.036 1.2.467 2.705 1.373 3.495.017.014.296.194.313.208.04-1.935.353-2.857.353-2.857-.021.972.16 1.915.47 2.809.203.588.699 1.131 1.013 1.693.486 1.314.851 5.16 1.095 6.762.126.825-.494 3.606-.906 4.853-.799 2.419-1.15 4.591-.21 2.954.42-.73 2.02-3.79 2.842-6.64.822-2.85 1.624-4.5 1.374-5.08-.081-.188-.314-4.142-.367-4.296a2.36 2.36 0 0 1-.07-.24c-.022-.091-.078-.165-.018-.479l.39-2.024c4.024 7.526 10.439 8.46 14.79 3.202-.655 2.134-.683 5.237-.606 6.545.076 1.309.066.749.044 1.207l-.769 7.184-.068.141s-.174.395-.174.767c0 .175.007.376 0 .606-.01.337-.003.525.04.577l.124.154c.007.257-.006.512-.025.767-.005.086-.014.197-.022.296l.096-.12c.269-.338.418-.858.529-1.469 0 0 .008-.054.014-.077a4.054 4.054 0 0 0 .144-.473c.054-.222.064-.422.064-.422l-.041-.179.03-.181s1.358-8.274 1.36-8.319a.773.773 0 0 1 .071-.232c.26-.365.842-.773 1.057-1.023.221-.255 1.022-3.622.901-5.722-.278-4.815 6.057-6.183 8.178-3.806.796-.431 1.462-1.051 2.03-1.8.537-.709.98-1.538 1.355-2.44.05-.181.112-.377.157-.548.117-.454.21-.87.274-1.223.052-.293.095-.586.132-.878.037-.293.069-.587.096-.882.053-.59.092-1.185.14-1.794.047-.61.102-1.231.188-1.875a20.739 20.739 0 0 1 .372-2.003c.036-.149.094-.289.164-.427.069-.138.148-.273.227-.409.08-.135.157-.27.223-.41.065-.141.118-.287.147-.441l-.012-.113.217-.029c.002-.006.002-.015.003-.021-1.025.215-.564.05-1.554.181-.293 0-.541-.017-.776-.12-.5-.351-.921-.813-1.136-1.42 0-.68.221-1.975.407-2.324.617-1.156 1.122-.28 2.349.06 1.166.325 2.907 1.238 3.564 1.87.076.074.962.116 1.05.068.065-.036.136-.025.203-.048.001-.018.011-.038.015-.057.003-.016 0-.027.005-.045.027-.109.073-.237.073-.328a2.39 2.39 0 0 0-.01-.238.646.646 0 0 0-.044-.192c-.024-.053-.044-.087-.066-.123a.639.639 0 0 0-.159-.182c-.098-.08-.148-.186-.252-.243-.77-.667-1.108-1.165-1.65-1.68.09-.113.075-.17.042-.357-.248-.753-.723-.892-1.525-1.504-.75-.435-1.73-.91-2.768-1.007h-.448a1.832 1.832 0 0 0-.11-.002z' fill='%23d18219' stroke='none'/%3e%3cpath d='M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z' fill='none' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M382.265 343.818c0 .332-.169.795-.268 1.19-.015.064-.007.106-.017.165.083-.398.294-.837.294-1.22 0-.048-.009-.088-.009-.135z' fill='%23d39044' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M334.948 432.87c-2.059 8.327-7.182 10.024-3.42 17.087 0 0-1.618-.118-2.592-2.837-.487-1.36-.813-3.37-.696-6.343.059-1.486.228-3.212.544-5.218.158-1.002.352-2.075.587-3.222' fill='white' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M338.745 429.429c-2.058 8.327-7.182 10.024-3.42 17.087 0 0-2.025-.03-2.999-2.75-.487-1.359-.838-3.642-.858-5.371-.02-1.73.45-4.684.788-5.924.337-1.24 1.238-3.31 1.238-3.31' fill='white' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M345.773 418.39c-2.934 5.509-5.297 10.213-6.52 14.3-1.225 4.089-1.996 6.272.31 10.602 0 0-1.567-.817-3.628-4.632-.65-1.204-1.086-3.867-.789-6.592a30.55 30.55 0 0 1 .776-4.396c.207-.808.465-1.662.79-2.58' fill='white' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M348.502 414.884c-1.818 2.792-2.406 5.465-3.414 7.733-2.016 4.537-3.085 7.944-3.085 10.44 0 2.029-.357 3.709 1.905 7.156 0 0-1.061-.124-1.753-.543-.692-.419-1.56-1.194-2.269-2.62-.708-1.427-1.255-3.504-1.303-6.527-.024-1.511.478-3.745.89-5.217.413-1.473 1.807-4.55 1.807-4.55' fill='white' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M353.27 334.537c.119-.233-11.574-3.636-13.242-13.858 2.275-2.15 14.25 5.702 14.438 12.987' fill='%23d18219' fill-rule='evenodd' stroke-width='1.364' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M340.423 320.825c.093.205 6.265.184 11.133 10.596-1.095-1.244-6.04 1.675-11.092-10.204' fill-opacity='.502' fill-rule='evenodd' stroke-width='1.364' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M368.707 335.545c.165-.134.396-.452.122-.75-5.102-3.192-4.857.706-8.443.706 1.71 0 1.706.234 2.345.926 2.32 2.515 3.917 2.265 5.976-.176' fill-rule='evenodd' stroke-width='1.364' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M381.193 349.763c-.565.67-2.538-.793-3.984-.967' fill='none' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M382.326 345.923s-.54-.438-4.32-.932c.004.07 2.605-2.673 2.835.29' fill-rule='evenodd' stroke-linecap='square' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M302.663 436.88a33.59 33.59 0 0 0-.914 1.815c-1.068 2.348-1.409 4.538.472 8.069 0 0-1.617-.117-2.591-2.837-.487-1.36-.813-3.37-.696-6.343.03-.743.086-1.546.175-2.414' fill='white' fill-rule='evenodd' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath d='M230.708 419.108s-1.55-6.161 2.09-13.014' fill='none' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3c/g%3e%3cg fill='%23e7ca00' stroke-width='2.294'%3e%3cpath d='M401.415 879.458c-2.045-1.515-4.023-6.243-3.27-8.842-2.694-2.22-9.659 2.184-6.276 8.588 3.354 6.388 7.986 5.85 9.57.267l-.024-.013zM420.519 885.467c.56-3.612-.686-9.663-6.934-10.747-6.235-1.067-8.153 4.548-6.958 10.324 4.5-3.395 11.623-1.683 13.892.423z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M407.416 882.052c1.063-4.786 5.835-6.083 10.57-5.594-2.96-3.38-6.044-8.823-10.264-5.651-3.317 2.504-5.617 6.151-.299 11.225l-.008.02z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M404.77 879.344c.56-3.612 2.025-8.456 5.93-10.433-3.367-3.054-11.69-2.136-12.302 4.1-.632 6.231 3.047 7.49 6.383 6.307l-.01.026zM388.887 919.375c5.28.85 12.283-1.796 10.307-13.708-1.878-11.299-10.192-14.04-10.816-11.348 4.77 1.667 4.154 17.65.475 25.103l.034-.047z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M396.765 918.122c5.294.946 13.706-2.13 9.908-13.822-3.71-11.462-12.224-10.052-12.808-7.164 4.779 1.845 6.512 13.045 2.871 21.008l.03-.022z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M376.728 918.168c3.859 3.455 13.822 4.688 17.015-6.829 3.011-10.905.276-14.41-3.62-16.18 1.943 5.672-5.07 21.665-13.412 22.991l.018.018zM402.151 917.195c3.263-1.816 10.612-5.074 5.805-16.066-3.936-8.966-10.087-5.15-11.753-3.603 4.31 1.812 8.14 11.493 5.948 19.67z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M409.224 914.63c3.051-2.059 10.717-7.101 4.569-17.83-6.09-10.543-14.194-3.537-14.215-.648 3.563.888 9.641 9.955 9.673 18.46l-.027.017z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M416.718 907.263c2.017-2.81 7.176-9.719-.7-16.792-7.758-6.967-12.759 1.783-12.047 4.285 3.199-.447 10.595 5.25 12.77 12.52l-.023-.013z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M421.176 896.276c.56-3.612 2.045-12.624-7.034-14.705-8.902-2.034-9.573 8.603-8.069 10.431 2.395-2.185 10.557-1.078 15.103 4.274zM370.892 914.922c3.375 4.144 13.412 7.063 18.657-4.145 4.966-10.665 2.772-14.71-.953-17.146 1.016 6.117-8.907 21.318-17.712 21.318l.009-.027z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M360.848 906.698c3.225 6.56 19.288 14.058 25.522 1.927 5.916-11.504 1.012-22.081-3.9-26.14 2.33 11.768-12.11 29.737-21.626 24.184l.004.029z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M352.366 898.402c7.864 17.16 24.132 14.152 29.643 1.691 5.229-11.823 3.75-18.756-2.177-24.424-4.094 15.2-12.2 23.738-27.49 22.705l.024.028z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M341.921 884.056c5.964 21.484 27.137 18.887 36.131 6.547 6.355-8.705 4.117-15.146.905-18.94-6.961 8.212-18.98 15.534-37.069 12.368l.033.025z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M337.98 870.931c.633 21.914 26.07 24.33 37.372 11.791 7.983-8.845 7.368-15.426 5.227-19.305-8.432 8.338-25.238 18.384-42.626 7.488l.026.026z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M332.703 850.203c-3.87 28.348 29.128 37.617 43.467 20.689 7.698-9.07 7.333-15.432 5.2-19.31-14.3 10.02-39.159 11.185-48.688-1.376l.021-.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.46 823.53c-9.486 30.632 19.29 41.583 38.047 38.528 14.855-2.403 23.204-19.886 21.094-23.738-18.552 13.087-55.366 1.82-59.157-14.759l.016-.032z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.06 799.67c-12.676 29.897 15.364 47.446 38.583 45.69 15.216-1.153 27.753-7.06 27.202-19.552-22.745 8.013-58.219-5.432-65.807-26.134l.021-.004z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.966 774.93c-12.693 30.576 14.747 55.711 43.465 56.342 14.648.316 21.34-3.593 27.196-13.299-20.73 3.532-64.889-27.938-70.661-43.044z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.57 765.272c-11.333 35.923 80.312 80.423 84.993 33.705-21.913 11.482-81.753-20.668-84.992-33.705z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M327.523 755.606c-15.379 19.757 93.055 78.167 95.506 28.363-9.762 5.009-29.87.684-49.265-8.106-19.38-8.787-33.155-22.855-46.237-20.233l-.005-.024z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M310.962 751.12c19.613.483 61.382 30.938 89.302 36.03 17.874 3.25 32.459-4.197 24.146-35.544-28.487 29.115-82.917-17.824-111.77-6.766-2.968-1.407.62 8.346-1.655 6.276l-.023.004z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M314.738 755.54c19.01-11.796 58.328 10.083 86.15 11.273 17.08.697 38.39-18.62 24.406-47.052-21.874 37.6-82.887 7.493-108.6 27.333-1.927 4.301-.85 9.998-1.984 8.422l.028.025z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M307.104 756.761c20.232-14.78 61.569-6.196 88.05-8.343 17.572-1.444 43.746-32.009 19.805-57.475-14.86 53.842-64.483 27.223-107.269 58.258-2.12 5.473.796 8.86-.59 7.531l.005.03z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M314.385 751.966c16.663-15.72 57.604-14.669 81.93-27.066 16.32-8.304 32.874-43.645 4.386-61.42-2.962 56.707-55.186 38.963-87.452 80.94-.782 6.006 2.732 8.47 1.112 7.55l.025-.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M316.126 744.463c12.345-22.09 50.302-27.61 70.82-45.993 18.351-16.443 23.318-46.355-7.626-55.908-2.63 59.192-43.855 46.685-60.74 82.265-3.214 7.812-1.534 20.485-2.45 19.665l-.004-.029z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M325.504 721.914c12.654-20.094 22.161-13.181 42.356-33.822 17.383-17.772 22.62-60.366-7.793-61.346 4.545 51.455-15.245 51.997-29.134 79.625.503 6.14-3.665 15.957-5.404 15.54l-.025.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cg stroke-width='3.041'%3e%3cpath d='M310.424 602.663l-10.497 5.67-49.929 153.76 18.14 40.066 17.139 2.478 20.712-1.52 30.737-138.479 8.666-56.418-21.061-12.406-13.907 6.85z' fill-rule='evenodd' transform='matrix(.01816 -.28057 .21499 .02864 268.014 416.628)'/%3e%3cpath d='M309.263 597.474c.415 2.04.853 4.105 1.293 6.14 9.833-6.845 20.436-.176 23.345 15.636 2.902 15.806-3.027 38.861-13.668 56.633-6.681 14.63-14.639 32.223-16.986 56.246-1.823 18.767 1.856 41.713-2.283 62.595-2.528 10.013-7.857 9.093-18.2 8.451 4.162 6.833 9.334 10.587 16.036 10.365 14.42-3.208 24.74-16.165 28.494-44.84-4.283-23.95-3.188-47.936 9.852-72.08 11.634-11.987 22.336-25.543 26.268-49.987 1.883-12.145-.47-25.209-9.616-39.046-11.482-17.358-20.812-17.994-29.61-16.439-4.964 2.075-9.942 4.22-14.925 6.326z' transform='matrix(.01816 -.28057 .21499 .02864 268.014 416.628)'/%3e%3c/g%3e%3cpath d='M-325.656 629.664c.001-3.088 2.01-5.59 4.489-5.59 2.478 0 4.487 2.502 4.488 5.59h-8.977z' transform='matrix(1.42023 .479 .59921 -1.38227 519.312 1387.444)' fill-rule='evenodd' stroke-width='.5'/%3e%3cpath d='M295.504 723.041c-3.802 7.233-11.304 10.594-16.734 7.42-5.396-3.156-6.684-11.681-2.921-18.968 3.798-7.261 11.303-10.593 16.734-7.42 5.395 3.156 6.683 11.682 2.921 18.968zM276.557 641.066c-2.604-3.571-6.329-5.807-10.315-5.098-2.38.416-4.722 1.872-6.674 3.928-.077-.335-.154-.67-.206-1.009-1.39-7.709 4.797-16.772 11.401-17.96 2.956-.504 5.787.562 8.115 2.677-1.25 2.797-1.784 5.89-1.26 8.804a15.217 15.217 0 0 0 1.071 3.588 18.318 18.318 0 0 0-2.107 5.066l-.025.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M300.305 632.437c-2.852-3.625-6.749-5.866-11.004-5.267-4.033.568-7.999 3.659-10.677 7.768a18.765 18.765 0 0 1-1.132-4.147c-1.379-8.954 6.038-19.14 13.72-20.221 1.936-.273 3.81.037 5.537.831-.14 1.345-.13 2.69.075 4.016.624 4.048 2.48 7.614 5.04 10.154-.948 2.18-1.497 4.524-1.564 6.837l.004.029zM258.047 677.375c-.141.19-.302.418-.445.637-3.207-.469-6.187-2.176-8.529-4.746 2.477 2.462 5.648 3.974 8.97 4.08l.004.029zM264.755 663.75c-4.083-2.303-7.247-6.804-8.091-12.286-1.336-8.673 5.853-18.57 13.294-19.617a9.12 9.12 0 0 1 2.192-.044c-2.664 3.71-4.224 8.47-3.54 12.915.442 2.867 1.507 5.478 3.055 7.652-3.307 2.732-5.946 6.931-6.89 11.347l-.02.033z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M258.333 689.203c-2.006.599-4.083.405-5.87-.778-4.37-2.896-5.54-10.496-2.61-16.944 2.96-6.423 8.955-9.313 13.354-6.392 1.681 1.11 2.896 2.926 3.583 5.133a7.544 7.544 0 0 0-5.375.382c-4.698 2.155-7.138 8.593-5.42 14.328a11.05 11.05 0 0 0 2.343 4.3l-.004-.03z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M262.393 693.964c-3.06-.953-5.817-3.465-7.408-7.237-2.952-6.974-.85-15.61 4.763-19.248 2.876-1.84 6.1-2.036 8.974-.859-.526 3.151-.222 6.56 1.094 9.65 1.357 3.231 3.617 5.555 6.195 6.745-2.549-.671-5.28-.316-7.754 1.269-3.12 2.021-5.157 5.613-5.848 9.619l-.016.061zM257.279 743.409c-7.009-4.475-11.336-13.985-9.674-21.123 1.4-5.975 6.675-8.44 12.495-6.39-2.556 5.19-3.25 11.933-1.444 18.2 1.494 5.228 4.476 9.203 8.076 11.404-2.763.647-6.115.052-9.429-2.095l-.024.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M251.674 769.938a12.338 12.338 0 0 1-.917-.99c-5.64-6.455-7.08-16.8-3.218-22.981 3.619-5.802 10.678-5.957 16.217-.642-2.971 6.512-2.259 15.325 1.637 22.195-3.235-1.473-6.876-1.563-10.343.132a14.099 14.099 0 0 0-3.352 2.282l-.024.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M268.083 783.814c-5.381-.309-10.723-6.313-12.475-14.487-1.953-9.153 1.305-17.664 7.28-18.91l.266-.037c2.876 4.717 7.182 7.526 11.73 7.725.033.047.066.1.105.184-6.72 4.626-9.86 15.335-7.062 25.003.05.162.101.332.156.522zM265.208 717.594c-6.588 2.105-14.435-2.685-17.468-10.685-3.008-7.997-.113-16.28 6.5-18.396 1.694-.526 3.484-.6 5.256-.335 1.523 4.76 4.285 8.457 7.625 10.57-1.374 4.536-1.511 9.759-.05 14.727.264.942.58 1.847.956 2.685-.853.576-1.786 1.082-2.823 1.405l.004.029z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M269.946 727.884c-7.013-4.51-11.361-13.99-9.673-21.123 1.673-7.11 8.767-9.257 15.78-4.754 2.025 1.297 3.856 3.048 5.367 5.022-4.177 5.416-5.767 13.84-3.536 21.6.128.504.303 1.023.48 1.514-2.54.328-5.486-.376-8.418-2.26z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M284.7 750.888c-3.681 7.63-11.189 10.503-16.705 6.352-5.491-4.115-6.942-13.723-3.283-21.381 3.681-7.63 11.188-10.503 16.704-6.352 5.486 4.115 6.941 13.715 3.284 21.381zM275.434 703.142c-3.779 1.886-7.908 2.151-11.274.358-6.168-3.363-7.576-12.505-3.14-20.38 3.15-5.529 8.39-8.998 13.392-9.385 2.208 1.985 5.027 2.972 7.878 2.57.168.146.341.328.495.505-7.94 3.422-12.165 13.327-9.413 22.051a16.01 16.01 0 0 0 2.034 4.263l.028.018z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M284.18 666.044c1.218 7.903-4.118 15.27-10.446 16.162-6.308.888-12.472-4.831-13.693-12.763-.864-5.605 1.874-11.709 5.799-15.11 2.616 4.35 6.942 6.957 11.389 6.33 1.595-.224 3.156-.841 4.56-1.82a23.142 23.142 0 0 1 2.367 7.204l.024-.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M287.201 705.726c-5.672 2.926-12.188-1.39-14.474-9.664-2.285-8.275.45-17.434 6.142-20.392 1.763-.903 3.602-1.11 5.392-.73a25.498 25.498 0 0 0-1.654 3.538c-3.388 9.103-1.72 20.056 3.749 24.342.9.713 1.867 1.21 2.867 1.466a9.937 9.937 0 0 1-2.001 1.408l-.02.032z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M304.5 667.948c.426 2.76-.017 5.464-1.083 7.859-5.203-3.176-12.142.017-15.889 7.242-4.182-1.796-7.535-6.13-8.367-11.533-1.183-7.679 5.123-16.42 11.7-17.457.027.342.078.674.13 1.012 1.146 7.435 7.098 12.89 13.466 12.427l.064.418-.02.032z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M303.513 696.658c-4.26 9.226-12.873 13.369-19.195 9.203-6.288-4.15-7.974-15.092-3.725-24.346 4.26-9.226 12.872-13.375 19.196-9.202 6.288 4.15 7.974 15.092 3.724 24.345zM289.382 655.22c-1.417 2.99-3.648 5.49-6.347 6.878-6.282 3.152-13.95-.31-17.067-7.746-3.098-7.44.944-18.534 7.22-21.721 2.655-1.353 5.524-1.146 8.18.055-.028.151-.056.295-.079.475-1.667 9.692 1.944 19.186 8.093 22.06zM320.61 614.137c.4 2.594.033 5.177-.908 7.437-2.47-3.075-5.82-4.959-9.444-4.448-4.329.61-8.583 4.542-10.675 9.378-2.219-2.219-3.83-5.297-4.372-8.812-1.197-7.774 5.22-16.611 11.888-17.55 6.643-.935 12.326 6.176 13.526 13.97l-.015.025z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M322.452 630.627c1.01 6.556-3.192 12.756-8.577 14.633-2.38-3.426-5.837-5.648-9.628-5.114a9.624 9.624 0 0 0-2.845.894c-1.484-1.919-2.569-4.327-2.985-7.028-1.13-7.341 4.957-15.736 11.26-16.623 6.308-.888 11.69 5.862 12.824 13.231l-.05.007z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M293.229 654.4c-3.093 1.87-6.583 2.104-9.461.235-5.117-3.394-6.486-12.284-3.047-19.782 3.457-7.501 10.464-10.872 15.58-7.486 2.723 1.802 4.368 5.14 4.824 9.044-5.169 3.775-8.978 11.09-7.955 17.732l.04.259.019-.003zM256.479 798.67c-5.803 2.083-12.089-2.383-14.383-10.509-2.41-8.633.555-18.22 6.643-21.323 5.695-2.9 12.154.88 14.95 8.45-6.2 4.464-9.267 14.214-7.215 23.353l.004.03z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M270.605 803.782c-6.263 2.781-13.224-1.096-15.517-8.766-2.294-7.67.943-16.318 7.258-19.217 5.442-2.496 11.415.057 14.436 5.725-5.846 4.71-8.578 13.89-6.18 22.237l.003.021z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M267.557 817.92c-5.657 2.577-11.968-.899-14.041-7.797-1.382-4.663-.507-9.733 1.976-13.306 3.978 3.385 9.068 4.39 13.799 2.083a14.505 14.505 0 0 0 3-1.976 14.325 14.325 0 0 1 1.746 3.78c.713 2.373.828 4.889.445 7.24-2.093 2.252-3.666 5.204-4.587 8.498-.7.585-1.49 1.071-2.338 1.478zM276.083 847.28c-6.371 2.907-13.464-1.01-15.799-8.786-2.325-7.754.966-16.497 7.33-19.403.46-.212.951-.391 1.45-.52-.24 3.08.033 6.288.932 9.415 2.072 7.178 6.908 11.988 12.306 13.068-1.376 2.755-3.518 5.014-6.215 6.255l-.004-.028z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M285.171 848.437c-6.135 2.792-12.96-.987-15.2-8.466a17.692 17.692 0 0 1-.001-9.943c4.011 3.6 9.243 4.704 14.112 2.348 2.663-1.295 4.898-3.48 6.55-6.207a16.606 16.606 0 0 1 1.591 3.596c2.239 7.479-.92 15.858-7.051 18.672z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M293.142 863.357c-6.142 2.793-12.968-.993-15.207-8.472-.611-2.041-.808-4.14-.683-6.197 2.383.415 4.88.086 7.294-1.056 4.181-2.024 7.283-6.259 8.816-11.362 3.03 1.414 5.585 4.388 6.8 8.42 2.238 7.471-.914 15.85-7.045 18.67l.025-.003zM272.959 786.054c-2.764-1.739-5.05-4.729-6.214-8.59-2.452-8.252 1.007-17.505 7.788-20.616 6.75-3.108 14.31 1.09 16.794 9.337 1.87 6.236.33 13.062-3.474 17.366-3.14-1.972-6.987-2.409-10.58-.754-1.641.753-3.098 1.878-4.314 3.257zM319.823 651.64c1.07 6.56-5.47 16.885-12.166 18.31-6.695 1.424-10.884-1.834-13.949-6.191-3.064-4.357-4.273-10.017-2.61-15.188 1.663-5.171 6.083-10.364 10.441-12.278 4.358-1.915 7.371-1.174 10.919 1.74 3.547 2.914 6.296 7.046 7.365 13.606z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M285.163 808.599c-6.136 2.785-12.968-.993-15.207-8.472-2.231-7.473.92-15.851 7.052-18.673 6.135-2.792 12.961.994 15.195 8.438 2.239 7.479-.913 15.857-7.044 18.678l.004.029z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M283.132 834.193c-6.042 2.742-12.815-.985-15.011-8.352-2.197-7.368.9-15.657 6.962-18.432 6.043-2.779 12.81.956 15.01 8.345 2.197 7.368-.893 15.656-6.96 18.439z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3c/g%3e%3c/g%3e%3cpath d='M409.148 236.484l-.492.61-19.765 24.61-.43.538.5.477c6.348 6.046 10.027 16.339 10.039 24.601.016 10.524-1.697 17.768-3.828 24.43-2.945 9.203-6.749 17.31-7.922 30.79-.87 10.002 2.735 17.795 7.367 23.42 4.632 5.627 10.27 9.118 13.617 10.696 10.277 4.846 20.881 3.175 31.477 4.531 4.707.603 7.3 3.549 9.742 6.141l.547.578.547-.578c2.442-2.592 5.035-5.538 9.742-6.14 10.596-1.357 21.2.314 31.477-4.532 3.347-1.578 8.985-5.07 13.617-10.695 4.632-5.626 8.238-13.42 7.367-23.422-1.173-13.479-4.977-21.586-7.922-30.789-2.131-6.662-3.844-13.906-3.828-24.43.012-8.262 3.69-18.555 10.04-24.601l.5-.477-.43-.539-19.766-24.61-.492-.609-.586.516c-6.065 5.3-13.055 7.214-20.04 6.914-6.984-.3-13.953-2.845-19.828-6.492l-.398-.242-.398.242c-5.875 3.647-12.844 6.193-19.829 6.492-6.984.3-13.974-1.614-20.039-6.914l-.586-.516zm.211 2.125c6.226 5.172 13.403 7.108 20.477 6.805 6.851-.294 13.601-2.637 19.414-6.031v72.054h-52.414c2.045-6.542 3.68-13.83 3.664-24.117-.013-8.482-3.597-18.715-10.031-25.18l18.89-23.53zm81.282 0l18.89 23.532c-6.434 6.464-10.018 16.697-10.031 25.18-.016 10.286 1.619 17.574 3.664 24.116H450.75v-72.054c5.813 3.394 12.563 5.737 19.414 6.031 7.074.303 14.251-1.633 20.477-6.805zm-94.29 74.328h107.297c2.937 9 6.479 16.826 7.602 29.727.834 9.582-2.579 16.945-7.023 22.344-4.445 5.398-9.941 8.799-13.102 10.289-9.792 4.617-20.157 3.015-31.023 4.406-4.884.625-7.775 3.551-10.102 6.024-2.327-2.473-5.218-5.399-10.102-6.024-10.866-1.39-21.231.21-31.023-4.406-3.16-1.49-8.657-4.89-13.102-10.29-4.444-5.398-7.857-12.761-7.023-22.343 1.123-12.901 4.665-20.727 7.602-29.726z' fill='%23e7ca00' stroke='%23d4af37' stroke-width='.75'/%3e%3cg fill='%23008f4c'%3e%3cpath d='M524.96 203.558c-.109.012-.18.051-.211.13-.143.495-.574 3.182-.86 5.936-.214 2.753-.569 5.01-.64 5.01-.071 0-1.575-.634-3.36-1.41-4.354-1.907-13.421-2.968-13.921-1.627-.357.847.647 5.646 2.289 11.153.357 1.2-.07 1.56-2.64 2.336-1.714.494-3.646 1.339-4.36 1.904-1.214.847-1.07 1.13 2 3.954l3.36 3.037-1.579 1.272c-1.499 1.2-1.496 1.197 3.93 6.351 5.997 5.649 9.118 7.377 13.187 7.377 1.25 0 2.637.234 3.64-.054 1.336-.23 2.382-.68 5.665-1.033 3.548.312 7.041 2.05 8.445 2.82.345.76.639 1.446.86 2.013-2.539-2.755-8.164-3.851-9.336-3.893-1.173-.042-1.768.271-3.024.655s-1.735.964-2.93 2.621c-.856 2.189.844 4.466 2.914 4.748 2.57.353 4.493-1.061 4.493-3.391 0-1.907-1.094-3.283-.196-3.215 3.132.238 7.838 2.72 8.766 5.897 1.07 3.954.857 4.17-1.07 1.488-1.785-2.33-4.573-4.809-5.43-4.88-.643 0-2.07 3.464-2.07 5.088 0 1.059-.283 1.27-1.211.917-.714-.353-2.287-.707-3.5-.848l-2.211-.354.57 3.53c.286 1.906 1.215 4.806 2 6.359l1.5 2.89-3.43-1.056c-7.353-2.259-6.85-2.334-6.351 1.55.214 1.906.645 4.028.86 4.663.428 1.06.068 1.272-2.43 1.272-1.642 0-2.93.212-2.93.424 0 1.624 5.785 9.318 8.64 11.577 3.499 2.683 10.14 5.65 12.782 5.65.785 0 3.138.633 5.351 1.48l3.93 1.41v4.24c0 4.66-1.434 14.052-2.219 14.052-.214 0-1.496-1.977-2.781-4.448-2.927-5.366-2.785-5.294-3.57-4.024-.572.848-.711.777-.711-.423 0-2.048-3.29-8.19-5.36-10.167l-1.71-1.627-.86 1.904-.852 1.835-3.859-4.232c-2.142-2.33-4.136-4.097-4.422-3.885-.357.141-.784 2.052-1.07 4.17-.714 6.143-1.003 6.491-3.36 4.232l-2-1.904-.5 1.904c-.856 3.389.22 15.32 1.72 19.486.785 2.188 1.781 6.218 2.28 8.972.857 5.295 3.928 11.364 7.712 15.177 1.356 1.412 1.567 1.973.71 1.973-.57 0-1.568.566-2.21 1.272-2.785 3.036-.213 6.989 4 6.212 2.07-.353 2.496-.212 3.21 1.342 1.071 2.259 1.14 6.359.141 8.124-.714 1.341-4.927 3.103-5.64 2.397-.215-.212-.353-2.612-.282-5.295l.07-4.872-3.64 1.912c-8.781 4.66-16.167 16.664-18.047 25.914-.627 3.087-2.402 3.427-4.632 7.083-2.182 1.236-4.308 2.859-6.375 4.988-3.57 3.46-4.505 3.953-9.86 5.295-6.567 1.624-20.628 3.882-31.194 4.94-9.21.919-38.191 5.575-39.976 6.352-.785.353-2.643 1.131-4.07 1.696-1.428.565-3.146 1.839-3.86 2.898-1 1.553-1.066 2.048-.28 3.53 1.927 3.53 5.637 3.457 13.561-.285 3.499-1.694 7.78-3.105 10.922-3.6 2.784-.423 6.928-1.27 9.07-1.765 2.142-.565 8.134-1.627 13.203-2.474 28.842-4.59 39.407-6.85 51.187-10.945 7.853-2.754 7.789-2.749 15-2.043 8.138.777 18.412-1.768 22.624-5.58.928-.848 3.358-3.813 5.5-6.637 2.07-2.824 4.641-5.647 5.64-6.282 2.713-1.765 1.146-2.405-5.85-2.405h-5.86l2-4.37c2.284-5.084 4.639-11.794 4.21-12.217-.142-.142-2.207.136-4.491.701-2.356.494-4.359.85-4.43.779-.143-.142.142-1.197.57-2.398.571-1.553 1.356-2.4 2.64-2.682 1.072-.212 2.36-.568 2.93-.71.5-.14 2.142.001 3.641.425 2.642.706 2.716.848 2.36 3.037-.429 2.753 1.07 4.732 3.64 4.732 1.856 0 3.992-2.051 3.992-3.746 0-1.906-2.779-4.162-4.492-3.738-.857.141-3.288-.211-5.43-.917l-3.851-1.341 3.71-.779c5.64-1.2 7.497-.987 8.282.779.5 1.13 1.43 1.693 3 1.834 4.497.424 5.924-5.935 1.64-7.276-1.57-.494-5 1.203-5 2.474 0 .424-1.212.701-2.64.701-2.966.031-5.852.6-8.39 1.573l5.46-2.698c3.284-.988 7.573-2.543 9.5-3.46 6.354-2.966 12.636-10.308 14.992-17.297 1.5-4.449 3.784-18.36 3.07-18.36-.357 0-2.712.92-5.21 2.05-4.57 2.118-4.641 2.115-4.641.562.071-2.895 1.281-11.44 1.781-12.71.357-.777.213-1.195-.43-1.195-2.141 0-9.063 3.813-13.632 7.484-4.426 3.53-4.86 3.742-4.86 2.259 0-.918.645-2.683 1.43-3.954 1.285-2.118 1.641-2.258 4.211-1.835 2.499.424 2.93.206 4-1.418 1.5-2.26.646-4.943-1.781-5.72-1.357-.423-1.219-.632 1.351-1.903 3.213-1.554 6.641-5.153 9.211-9.812l1.711-2.899-2.57.286c-1.428.14-2.563.209-2.563.138 0-.07.5-1.482 1.07-3.106.572-1.624 1.07-4.305 1.07-5.858 0-2.966-2.64-13.77-3.64-14.9-.357-.423-1.787.216-3.43 1.557l-2.78 2.19-2.649-5.79c-1.428-3.176-2.779-5.932-2.922-6.073-.143-.212-1.07.423-2.07 1.341-2.213 2.048-2.357.92-.43-3.245 1.714-3.671 2.501-4.17 4.5-2.829 2.428 1.554 5.136.075 5.422-2.89.143-1.765-.144-2.474-1.5-3.392-.928-.565-2.211-.92-2.71-.709-.643.212-1.29-.354-1.86-1.696-.5-1.341-1.427-2.252-2.64-2.605-3.713-.918-6.284 3.738-3.571 6.42 1.07.99 1.074 1.768.289 6.923-1.285 8.33-1.711 9.106-2.71 5.364-1.143-4.165-.649-15.742.85-19.13 2.57-5.861 1.073-15.117-3.21-19.918-3.547-3.972-13.366-10.978-14.992-10.791zm-4.961 19.323c.62.021 3.29 2.277 7.625 7.4 3.622 4.298 7.933 11.711 10.726 17.235-.98-1.142-1.64-1.204-4.484-5.118-2.356-3.248-6.18-10.402-9.82-14.144-3.28-3.31-4.546-5.253-4.102-5.365a.196.196 0 0 1 .055-.008z' fill='%2300a854'/%3e%3cpath d='M537.86 298.711c-.68 2.67-1.233 3.15.195 5.197.642.989 1.856 1.554 3.07 1.554 1.927 0 2.998 1.412 4.64 6.354.214.777.357.777.357-.212.072-.706-.571-2.47-1.356-4.024-.857-1.695-1.143-2.895-.714-3.177 1.356-.848.785-4.448-.857-5.578-2.213-1.553-2.932-1.139-5.336-.114z'/%3e%3c/g%3e%3cpath d='M405.906 414.495c-1.499 1.209-1.888 3.13-.777 4.23 1.61 1.592 7.219.164 7.83-2.033.777-3.075-3.998-4.558-7.053-2.197z' fill='%239eab05'/%3e%3cg fill='%2375b52b'%3e%3cpath d='M526.632 209.418c.571 3.53 3.998 10.732 6.568 13.698 1.071 1.27 2.07 2.189 2.285 2.047.143-.212-1.856-4.448-4.498-9.39-3.712-7.06-4.712-8.473-4.355-6.355zM502.859 228.411c.785.847 11.422 3.883 11.422 3.248 0-1.27-3.426-2.754-7.496-3.177-2.356-.283-4.14-.283-3.926-.07zM507.285 237.025c.857.847 13.35 6.566 16.777 7.696 2.07.706 4.783 1.13 6.068.988 2.142-.211 1.928-.353-2.57-1.835-2.713-.918-6.425-2.401-8.21-3.319-4.355-2.189-13.35-4.801-12.065-3.53zM547.907 255.17c-1.07 3.248-2.784 14.121-3.284 21.182-.357 4.59-.286 6.142.571 7.202.928 1.27 1.07.706 1.856-5.649 1.071-8.967 2.213-24.5 1.928-24.853-.143-.141-.643.848-1.071 2.118zM535.913 261.03c.357 5.649 2.784 11.721 3.641 9.038.286-.847-.428-3.954-1.713-7.696l-2.213-6.284.285 4.943zM527.917 261.172c.5.706 1.714 2.189 2.57 3.248l1.642 2.047v-1.836c0-1.059-.714-2.33-1.856-3.177-2.284-1.836-3.64-1.906-2.356-.282zM517.85 278.611c0 .353 7.783 6.284 10.353 7.908 2.07 1.27 2.07 1.27-.571-1.836-2.713-3.177-7.14-6.354-8.853-6.354-.5 0-.928.141-.928.282zM521.777 293.862c1.857 7.837 3.285 12.285 4.07 12.78.5.282 1 .494 1.07.352.358-.353-3.355-11.085-4.497-13.062l-1.07-1.835.427 1.765zM529.988 300.004c0 1.06.642 3.248 1.427 4.802.786 1.553 1.285 2.33 1.143 1.694-.143-.635-.571-2.612-.786-4.448-.57-3.671-1.784-5.084-1.784-2.048zM515.495 305.3c1.356 4.519 4.855 11.65 9.78 19.628 3.642 6.001 3.642 6.001 3.856 3.53.143-1.977-.571-3.742-3.213-8.19-1.856-3.107-4.997-8.614-6.996-12.144-1.928-3.6-3.784-6.496-4.07-6.496-.285 0 0 1.695.643 3.672zM559.83 306.359c-3.142 3.389-9.424 12.144-11.495 16.168-.714 1.413-.928 2.825-.642 3.954.428 1.624 1.428.353 8.495-10.802 4.355-6.99 7.71-12.638 7.425-12.638-.357 0-1.999 1.482-3.784 3.318zM548.55 358.818c-1.071 1.977.285 4.237 2.57 4.237 2.07 0 3.355-2.472 2.284-4.448-.857-1.624-3.926-1.554-4.855.211z'/%3e%3c/g%3e%3cg fill='%23d91023'%3e%3cpath d='M527.56 251.005c-2.713 1.906.143 6.707 2.999 5.013 1.713-1.13 1.999-3.884.428-5.013-.714-.495-1.5-.918-1.713-.918-.215 0-1 .423-1.714.918zM546.265 235.754c-1.642.424-2.285 2.612-1.285 4.448 1.428 2.613 4.997 1.553 4.997-1.483 0-2.118-1.642-3.389-3.712-2.965zM550.977 241.19c-.214.565-.286 1.766-.143 2.684.143 1.27.643 1.624 2.285 1.624 2.57 0 3.997-1.907 2.855-3.743-1-1.553-4.426-1.976-4.997-.564zM524.205 346.745c-2.642 2.118-.143 5.86 3.141 4.59 1.5-.566 2.07-2.26 1.214-3.813-1-1.907-2.57-2.19-4.355-.777zM538.731 299.412c-.785.777-.57 3.389.357 4.307 2.142 2.118 5.355 0 4.57-3.036-.357-1.342-.929-1.765-2.5-1.765-1.07 0-2.212.212-2.427.494zM551.967 299.317c-.5 2.047.714 3.883 2.57 3.883 1.713 0 2.999-1.694 2.713-3.671-.143-1.271-.714-1.695-2.499-1.836-1.999-.212-2.356.07-2.784 1.624zM553.832 351.405c-.5 2.047.714 3.883 2.57 3.883 1.714 0 2.999-1.694 2.713-3.671-.142-1.271-.713-1.695-2.498-1.836-2-.212-2.356.07-2.785 1.624zM549.489 357.94c-2.642 2.118-.143 5.86 3.141 4.59 1.5-.565 2.07-2.26 1.214-3.813-1-1.907-2.57-2.19-4.355-.777z'/%3e%3c/g%3e%3cpath d='M519.886 223.47c.288.456 1.667 2.076 3.047 3.61 2.644 2.872 4.8 5.857 8.795 12.082 2.817 4.406 6.381 8.897 6.381 8.073 0-.853-6.323-11.456-8.824-14.81-3.305-4.378-8.565-9.807-9.571-9.807-.201 0-.144.313.172.853z' fill='%2375b52b'/%3e%3cpath d='M538.141 312.72c-.086.483-.822 5.236-1.138 10.808-.747 12.905-1.408 19.846-2.874 28.175-.633 3.667-1.236 7.249-1.322 7.96l.19 1.182 1.178-1.649c1.264-1.734 2.586-2.985 4.483-4.264.633-.455 2.673-2.36 4.484-4.292 9.083-9.58 11.612-12.564 19.43-22.911 7.243-9.637 8.997-12.053 8.853-12.223-.287-.256-2.54 1.887-11.566 13.059-2.5 3.098-6.737 7.959-9.295 10.801-6.295 6.936-13.327 13.385-15.182 15.879-.17.229.258-1.62.603-2.985 1.61-6.794 2.271-14.27 2.472-28.88.086-6.368.115-11.57.029-11.57-.086 0-.23.398-.345.91zM520.508 359.377c-.546.91-2.242 3.894-3.794 6.623-4.83 8.642-10.405 16.459-14.63 20.524-1.524 1.478-1.09 1.605-1.409 1.933-1.668 1.717 5.059 2.928 10.175 3.44 6.898.681 10.721-.683 29.145-10.405 4.312-2.274 5.461-2.984 4.599-2.842-1.696.284-4.369.91-12.36 4.719-7.817 3.695-11.312 5.31-14.848 6.106-2.76.625-6.806.682-9.192.113l-1.627-.108.863-.284c.718-.17 1.833-.21 2.207-.523.374-.342 1.84-1.388 3.248-2.098 3.19-1.62 6.703-4.542 11.532-8.863 3.707-3.298 10.836-10.49 10.836-10.944 0-.313-3.334 2.416-7.617 6.197-8.853 7.845-17.533 13.672-21.241 14.27l-1.092.17 1.15-1.023c.373-.54 1.77-2.604 3.207-4.708 3.45-5.031 4.771-7.43 7.99-13.997 2.96-6.054 4.18-9.664 3.979-9.835-.058-.057-.575.626-1.121 1.535zM520.722 268.268c-.087.484 3.69 5.047 8.042 10.035 4.449 5.1 7.062 7.11 10.604 11.563 3.54 4.452 3.906 4.78 7.858 8.345 4.928-6.48 7.952-15.308 10.037-20.922 2.062-5.549 3.723-10.314 3.774-17.632-2.826 6.119-2.911 8.318-5.12 14.99-2.228 6.733-7.19 18.392-9.046 20.886-.17.229-10.422-12.355-14.895-17.57-4.749-5.54-11.273-10.272-11.254-9.695z' fill='%23eac102' fill-opacity='.502'/%3e%3cpath d='M524.08 208.323l-.859 6.377-2.579-1.276c-2.722-1.275-9.743-2.763-13.11-2.763-1.863 0-1.935.142-1.577 2.267.43 2.268 2.221 8.715 2.866 10.132.143.425-1.075 1.134-2.723 1.63-1.719.496-3.653 1.346-4.37 1.913-1.29.921-1.146 1.134 1.576 3.543 3.224 2.905 3.51 3.684 1.72 4.96-1.075.779-.645 1.416 4.084 5.951 2.937 2.834 6.59 5.74 8.024 6.448 3.653 1.913 10.746 1.913 14.543 0 2.65-1.347 2.866-1.347 4.585-.213 1.72 1.063 1.791 1.063.86-.07-.573-.638-3.94-2.693-7.45-4.464-9.888-5.102-17.983-14.03-21.422-23.878-1.72-4.889-1.72-7.51.071-7.51 2.938 0 9.17 1.558 12.681 3.117 5.23 2.41 14.544 11.337 17.123 16.509 1.863 3.613 2.078 4.889 2.15 10.274 0 6.235 1.002 8.856 1.146 3.188.286-7.156.501-8.786 1.576-11.478 2.149-5.243 1.074-13.25-2.365-17.997-1.146-1.488-4.871-4.747-8.382-7.227-3.439-2.409-6.52-4.676-6.734-5.101-.287-.355-.932 2.196-1.433 5.668zm9.171 1.063c4.8 3.33 6.162 4.747 7.666 7.793 2.293 4.748 3.01 10.487 1.72 14.738l-1.004 3.188-1.862-3.967c-1.218-2.693-3.797-5.881-8.024-10.062-3.367-3.4-6.52-6.164-6.95-6.164-.788 0-.501-4.818.573-8.998.43-1.842 0-2.055 7.881 3.472zm-22.997 17.359c.645 1.133 1.79 2.338 2.436 2.834.716.496 1.433 1.559 1.647 2.338.359 1.275 0 1.417-3.367 1.417s-3.94-.213-6.52-2.834c-1.504-1.559-2.65-2.976-2.435-3.118.573-.566 5.23-2.48 6.09-2.55.501 0 1.432.85 2.149 1.913zm9.528 10.982c4.156 3.826 5.374 4.605 10.389 6.59 2.65 1.062 2.794 1.204 1.647 2.267-1.576 1.558-9.457 2.125-13.039.92-3.08-.991-14.257-11.052-13.11-11.761 1.218-.78 4.943-1.559 7.665-1.63 1.935-.07 3.153.638 6.448 3.614zM540.487 250.764c-.286.354 0 1.913.573 3.472 1.29 3.613 1.218 4.676-.071 7.156-.573 1.134-1.075 3.33-1.075 4.818 0 1.559-.358 3.826-.86 5.101l-.788 2.268-2.364-1.488c-1.29-.85-2.507-2.197-2.722-2.976-.645-2.126-.359-6.66.501-10.982.645-3.047 1.146-3.897 2.15-3.826 1.074.141 1.146-.071.358-.921-.717-.922-1.003-.922-1.791.212-.502.709-1.147 2.267-1.362 3.543-.43 2.338-.43 2.338-2.507 1.346-3.08-1.63-4.227-1.346-4.227.992s1.218 6.093 2.722 8.431c1.648 2.48 1.72 1.418.072-1.77-1.934-3.898-2.58-8.007-1.29-8.007.574 0 1.72.496 2.58 1.062 1.29.922 1.504 1.701 1.36 5.881-.07 5.669-.572 5.952-7.307 3.685-2.22-.78-4.227-1.276-4.442-1.134-.286.354.86 6.306 1.648 8.219.287.85-.215 1.063-2.937.78l-3.368-.213 2.006 3.4c4.442 7.724 10.89 12.33 19.774 14.171 2.794.567 6.161 1.56 7.38 2.197 1.719.921 2.005.921 1.36.142-.43-.567-2.077-1.488-3.582-1.984-4.083-1.488-8.024-4.322-13.182-9.778-5.158-5.456-7.81-10.061-7.81-13.604 0-1.842.216-2.267 1.075-1.913.645.213 3.081.921 5.517 1.559 6.018 1.488 7.594 2.409 11.463 6.518 4.084 4.322 5.445 6.873 6.663 12.683.573 2.55 1.146 4.747 1.36 4.96.932.992 1.219-2.267.43-5.03-1.289-4.677.646-13.746 4.73-21.753 1.79-3.542 7.307-8.927 8.167-7.935.286.283 1.217 3.33 2.149 6.73 1.934 7.228 1.648 9.353-1.791 16.51-2.508 5.101-4.872 8.077-8.597 10.77-2.794 1.983-2.006 2.62 1.862 1.629 3.44-.921 8.956-5.952 11.965-10.911l1.576-2.693-2.794.496-2.723.425 1.29-3.755c1.648-4.818 1.648-6.731 0-12.47-.788-2.622-1.576-5.668-1.863-6.731l-.43-1.984-2.292 1.63c-1.29.85-2.508 1.842-2.723 2.196-.86 1.204-1.862-.142-4.298-5.527-1.29-2.905-2.58-5.314-2.866-5.314-.358 0-1.433.85-2.507 1.913l-1.863 1.984.43-1.984c.358-1.346.215-1.842-.287-1.558-.358.212-.716 1.133-.716 1.984 0 3.4-1.218 3.4-2.293.07-.573-1.842-1.218-3.046-1.433-2.692zm10.388 17.855c-2.077 4.11-3.51 8.36-4.083 11.62l-.86 5.101-1.146-2.834c-.645-1.63-2.078-3.897-3.08-5.172-1.935-2.197-1.935-2.338-1.147-7.369 1.218-8.006 2.794-12.328 5.66-15.446l2.579-2.905 2.65 5.243 2.651 5.173-3.224 6.589zm-27.152 11.69c8.74 9.07 11.75 12.613 10.245 12.117-6.52-1.913-11.105-5.314-14.544-10.628-1.361-2.055-2.436-3.968-2.436-4.18 0-.213.86-.355 1.863-.355 1.29 0 2.866.992 4.872 3.047zm40.765 5.598c-2.866 4.535-4.586 6.235-7.738 7.794l-2.866 1.488 2.866-3.118c1.576-1.7 3.654-4.322 4.514-5.739 1.433-2.267 2.436-2.976 4.657-3.33.286 0-.359 1.276-1.433 2.905z' fill='%23cab313' fill-opacity='.502'/%3e%3cpath d='M538.41 256.361c1.003 2.126 2.865 4.322 2.937 3.543 0-.425-.86-1.7-1.863-2.834-1.003-1.205-1.504-1.488-1.074-.709z' fill='%23005000'/%3e%3cpath d='M519.496 293.347c-.287 1.488-.788 3.897-1.218 5.455l-.645 2.693-2.078-1.913-2.006-1.913-.573 3.33c-.645 4.605.144 11.478 2.15 17.926.93 2.976 1.934 7.014 2.22 8.998.86 6.519 6.233 14.17 13.183 18.918 1.29.921 1.79 2.126 2.22 5.314l.574 4.11-.143-3.897c-.072-2.126-.932-7.37-1.863-11.691-2.221-10.274-1.576-14.596 3.582-25.082l3.725-7.51 3.798 7.58c5.086 10.133 5.588 13.534 2.865 21.823-1.074 3.33-2.292 6.377-2.65 6.873-.359.496-.502 1.134-.359 1.488.215.283.072.992-.358 1.559-.573.85-.645.78-.287-.354.287-.78-.716-.071-2.364 1.77-1.576 1.772-3.009 3.827-3.224 4.606-.358 1.276-.286 1.276.86-.141a225.01 225.01 0 0 0 2.508-3.401c.716-.992 1.576-1.63 1.862-1.417 1.075.566 2.078-1.276 4.442-7.865 3.296-9.211 5.373-12.825 9.887-17.36 3.009-2.975 5.946-4.888 10.961-7.297 3.797-1.771 7.021-3.26 7.165-3.26.573 0-1.577 12.33-2.794 15.943-1.362 4.322-5.23 10.415-8.311 13.25-3.01 2.763-9.027 5.738-14.687 7.297-2.436.709-4.657 1.488-4.872 1.842-.358.638 5.302-.92 10.532-2.905 7.594-2.763 14.758-10.132 17.696-17.925 1.29-3.401 4.083-18.139 3.51-18.635-.143-.142-2.507.85-5.373 2.197l-5.087 2.409.43-4.748c.215-2.621.788-6.235 1.29-8.148.86-3.259.86-3.33-.645-2.905-3.582 1.063-10.03 4.96-13.899 8.503l-4.227 3.755.215-6.519c.215-4.393.072-6.093-.358-5.101-.358.78-.716 2.834-.716 4.605-.072 3.614-1.577 10.628-2.293 10.628-.287 0-1.576-2.054-2.866-4.605-2.364-4.393-3.439-5.597-3.582-3.755 0 .496-.716-.992-1.648-3.401-.86-2.338-2.507-5.456-3.653-6.944l-2.078-2.692-1.146 2.196-1.147 2.197-2.722-3.543c-1.505-1.984-3.367-3.897-4.084-4.251-1.146-.638-1.361-.355-1.72 1.913zm4.871 2.196c2.723 3.33 8.67 14.525 9.457 17.855l.43 1.772-1.29-1.772c-2.292-3.259-8.525-8.856-12.322-11.053-1.863-1.063-1.934-1.417-1.433-3.755.287-1.417.717-3.401 1.003-4.535.215-1.062.645-1.913.932-1.913.286.071 1.719 1.559 3.223 3.401zm9.959 6.873c2.078 4.322 2.507 7.014 1.361 8.786-.931 1.488-6.806-10.84-6.233-13.108.43-1.559.645-1.7 1.648-.85.645.496 2.078 2.834 3.224 5.172zm-12.681 2.267c4.585 3.047 9.242 7.652 10.46 10.416.645 1.275.43 2.267-.716 4.534-1.935 3.756-3.01 11.479-2.293 16.58.287 2.267.287 4.11 0 4.11-.931 0-6.09-6.59-8.454-10.7-4.728-8.29-8.096-21.822-6.95-27.845l.502-2.692 1.576 1.346c.86.78 3.51 2.693 5.875 4.251zm43.273 0c-.359 1.913-.789 5.173-1.003 7.298-.43 3.826-.502 3.968-4.657 6.519-2.365 1.488-5.588 4.322-7.308 6.518-1.648 2.126-3.224 3.755-3.51 3.543-.359-.142-.788-1.842-1.075-3.684-.215-1.843-.931-4.393-1.433-5.74-.931-2.125-.86-2.55.502-4.463 3.009-4.18 15.761-13.32 18.627-13.32.215 0 .143 1.487-.143 3.33zm-38.473 34.648c2.65 2.692 4.227 4.818 4.012 5.597-.143.992-.931.567-3.869-2.196-3.94-3.685-7.092-8.503-7.809-11.975-.43-1.842-.215-1.7 1.433 1.063 1.003 1.771 3.797 5.172 6.233 7.51z' fill='%23cab313' fill-opacity='.502'/%3e%3cpath d='M519.424 356.902c-7.737 5.172-14.263 15.949-16.256 24.587-.144 2.196-2.485 4.037-2.127 3.825.287 1.06 2.49-.047 3.484-3.542 1.881-6.616 7.09-18.493 13.896-23.24 2.078-1.417 4.155-2.622 4.514-2.622.358 0 .501 2.693.358 6.164-.143 4.748-.645 7.015-1.935 9.637-2.149 4.322-7.952 10.698-12.036 13.037-3.438 1.983-3.725 2.834-.573 1.63 3.51-1.347 11.821-9.92 14.042-14.526 1.147-2.338 2.078-4.676 2.078-5.172 0-.496.86-1.275 2.006-1.7 2.58-.992 15.403-4.18 15.69-3.827.573.567-4.898 12.04-6.689 14.378-2.722 3.471-9.242 8.431-12.466 9.423-1.504.425-4.744 2.17-7.138 2.615-2.605.483-3.387.522-6.428.85l-2.528 1.5 2.508-.424c1.361-.213 4.8-.638 7.522-.921 7.887-2.737 10.917-4.444 16.081-8.4l3.355-2.84 6.428.328 5.23.425-2.436 2.905a676.904 676.904 0 0 0-5.588 6.802c-1.648 2.126-4.012 4.393-5.23 5.102-3.44 1.984-10.962 3.613-17.266 3.613-5.732.071-5.875 0-8.74-2.55-2.938-2.622-4.085-3.118-4.514-1.984-.072.354-2.58 1.417-5.374 2.48-5.588 1.912-6.806 1.417-3.582-1.56 1.218-1.133 2.496-1.128 5.075-1.27 0 0 5.419 1.208 5.473.095.054-1.107-5.4-1.02-5.4-1.02-2.546.15-3.137.065-1.135-2.537 2.351-1.477 3.28-4.36 2-3.73-3.132 3.784-5.16 5.283-9.881 9.88-4.508 3.122-5.08 3.335-11.248 5.034-3.94.92-10.46 1.983-14.328 2.48-7.51.848-10.697 2.735-3.44 1.413 3.672-.669 8.38-1.2 14.4-2.264 8.681-2.126 9.258-2.27 13.54-4.538 3.5-3.6 4.072-4.023 2.222-1.062-.645 2.196.43 2.125 7.307-.496 5.445-2.126 5.589-2.126 6.95-.78 1.361 1.346 1.29 1.417-1.433 2.55-5.803 2.41-17.123 5.527-28.657 7.795-6.592 1.346-12.18 2.621-12.395 2.905-.573.567 7.81-.355 9.6-1.134.789-.283 6.735-1.842 13.255-3.33 6.52-1.559 13.97-3.684 16.62-4.747 4.443-1.772 5.16-1.842 8.956-1.134 4.8.85 12.753.071 18.556-1.842 4.442-1.417 7.522-4.039 12.036-10.345 1.863-2.621 4.227-5.384 5.23-6.093l1.862-1.346-6.304-.425c-3.439-.213-6.448-.567-6.591-.78-.144-.141.215-1.275.86-2.48.573-1.204 2.077-4.818 3.223-7.935l2.15-5.81-2.508.496c-1.361.212-3.654.638-5.015.85l-2.507.496 1.074-2.621c.573-1.418.932-2.551.717-2.551-.144 0-.788 1.133-1.362 2.48-1.217 2.763-2.65 3.33-2.149.85.215-1.134 0-.921-.86.708-.716 1.276-2.077 2.551-3.08 2.976-1.003.355-2.436.85-3.224 1.134-1.218.567-1.29.212-1.003-4.818.143-3.472 0-5.456-.502-5.456-.43 0-2.364 1.063-4.37 2.41z' fill='%23cab313' fill-opacity='.502'/%3e%3cpath d='M452.51 403.878c-4.156.354-12.538 1.63-26.509 3.897-7.307 1.134-13.612 2.125-14.113 2.196-.502 0-.717.284-.573.567.215.284-.788.709-2.15.921-3.152.638-6.806 3.614-6.806 5.669 0 2.054 2.364 4.18 4.084 3.755 1.146-.284 1.075-.355-.143-.425-3.153-.142-4.37-3.826-1.935-5.952 2.006-1.842 11.463-4.606 16.836-5.03 6.806-.567 26.437-3.26 27.296-3.827.43-.212 3.01-.78 5.803-1.275 4.729-.78 3.798-1.063-1.79-.496z' fill='%23cab313' fill-opacity='.502'/%3e%3cpath d='M440.688 410.75c-12.895 2.48-20.92 4.535-24.788 6.52-5.015 2.48-4.299 2.692 1.074.283 2.508-1.134 6.807-2.41 9.529-2.835 2.65-.425 8.597-1.558 13.11-2.48 4.514-.92 10.03-1.983 12.18-2.338l3.94-.637-3.224-.071c-1.79 0-7.092.708-11.82 1.559z' fill='%23cab313' fill-opacity='.502'/%3e%3cpath d='M497.182 391.946c-2.24 1.348-4.552 4.011-2.046 3.609 1.901-.168 9.019-2.331 9.574-3.735-2.724.24-4.962-.417-7.528.126z' fill='white'/%3e%3cg stroke='%23d4af37' stroke-width='.904'%3e%3cpath d='M367.709 432.44c-1.503.459-2.482.902-9.093.441-4.507-.307-10.173-1.117-13.102-1.194-5.56-.077-5.603.349-15.52 7.111-6.986 4.764-16 4.41-22.667 2.93-4.057-1.844-5.8-2.26-5.199-1.261 1.127 1.844 9.01 4.402 13.368 4.402 7.061 0 12.245-1.768 20.734-7.07 6.535-4.15 9.465-4.534 18.48-2.459 10.621 2.102 12.195 1.195 20.868-2.706-2.588-.073-3.194-.001-4.064.351 1.494-1.625 1.555-3.144 1.85-4.183.43-.566-.721.19-2.11 1.164-1.39.974-3.02 2.166-3.545 2.474z' fill='white' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath d='M354.025 429.835c-4.883-.768-8.23-1.435-11.29-1.092-3.41.38-5.839 2.075-9.895 4.61-4.057 2.613-7.708 4.495-8.159 4.495-.526 0-5.764 1.22-9.746 1.22-1.878 0-5.913-1.245-8.617-2.244-5.71-2.151-7.794 1.329-1.86 3.865 5.276 1.8 10.625 2.506 15.617 1.763 4.991-.743 9.625-2.935 13.47-5.77 7.627-5.624 3.166-2.918 6.206-4.207 3.04-1.288 5.848-.851 5.848-.851 3.982.153 11.88 1.466 15.862 1.543 7.287-.658 6.037-.672 8.441-2.05.838-.48 3.488-2.234 3.65-2.63.16-.398 1.39-2.702 1.154-2.793-7.452 5.131-11.202 5.12-20.681 4.141z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath d='M341.028 435.395c-1.052.461-4.207 2.306-7.137 3.996-6.16 3.765-11.96 5.57-18.748 5.647-3.08.463-13.072-3.606-11.57-3.145 1.608 3.033 3.952 3.425 9.676 4.508 3.993.756 6.582.13 11.062-.826 5.02-.615 7.078-2.888 8.956-4.271 4.357-3.228 11.893-5.37 13.996-5.37.977 0 4.757 2.065 8.902 2.962 4.145.896 6.145 1.127 10.443.444s8.724-4.2 12.84-6.924c-.669.21-2.132.214-4.14.276-5.895 3.474-15.88 4.783-21.134 2.425-5.333-1.306-10.517-.951-13.146.278z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3c/g%3e%3cg%3e%3cpath d='M388.708 210.486c-9.086 2.995-18.677 10.198-24.662 18.471-1.298 1.783-2.452 3.138-2.596 2.996-.072-.143.577-3.78 1.586-8.06 1.01-4.278 1.803-8.557 1.731-9.556 0-1.64-.144-1.569-2.884 1.427-3.462 3.85-8.005 12.337-9.736 18.186-.937 3.137-1.298 6.632-1.298 13.122l.072 8.915-1.73-6.276c-1.803-6.704-3.678-11.268-5.553-13.622-.937-1.212-1.226-1.284-1.875-.357-1.37 2.069-.433 10.912 1.875 17.473.216.785-.649-.356-1.947-2.496-1.37-2.14-2.812-3.78-3.173-3.566-.865.428-.937 7.417-.072 10.341.649 2.069.649 2.069-1.803-.713-4.038-4.635-4.976-4.992-4.976-1.783 0 1.213.505 3.352 1.082 4.779.577 1.355 1.082 2.638 1.082 2.71 0 .07-1.01.356-2.308.641-3.173.642-4.182 1.64-4.182 4.28 0 2.852 1.947 9.485 2.956 10.127 1.082.641 1.442 0 2.38-4.137l.865-3.708 2.668 3.423c3.822 4.992 9.52 16.403 12.404 24.89 3.029 9.057 3.173 10.84.36 5.277-1.153-2.21-3.173-5.563-4.398-7.417-2.74-3.85-17.812-19.47-18.822-19.47-1.082 0 0 4.85 1.947 8.915.938 1.997 3.75 5.92 6.13 8.772 2.452 2.782 4.254 5.135 4.038 5.135-.216 0-1.947-1.14-3.75-2.496-3.678-2.781-7.427-4.92-7.932-4.493-.144.214 1.298 3.21 3.245 6.775l3.461 6.49-2.307-.356c-1.298-.214-3.03 0-3.894.427-1.298.714-1.515 1.498-1.515 4.921 0 4.565 1.154 9.414 2.236 9.414 1.01 0 2.812-4.493 2.812-6.918 0-1.925.072-1.854 3.678 1.57 5.12 4.992 11.97 13.478 18.75 23.32l5.696 8.344-6.706-4.992c-6.418-4.707-19.615-12.052-21.778-12.052-.577 0-1.082.285-1.082.641 0 .357 4.254 4.636 9.447 9.557l9.374 8.915-4.903-1.64c-2.669-.856-6.058-1.784-7.428-2.069-2.452-.499-2.452-.356 3.029 4.707 3.028 2.853 8.509 7.06 12.259 9.414 3.678 2.282 6.057 3.923 5.264 3.709-6.562-1.855-16.225-3.424-16.225-2.568 0 .999 4.976 4.921 8.509 6.704 1.947.927 6.85 2.924 10.961 4.28 8.365 2.923 13.413 5.562 17.668 9.27l2.884 2.568-5.048-2.211c-5.769-2.567-21.417-7.774-23.22-7.774-1.803 0 5.409 7.06 12.403 12.267 6.419 4.778 18.606 10.84 27.403 13.693 7.356 2.353 13.558 3.566 25.24 5.064 5.192.641 10.096 1.426 11.033 1.782.865.428 7.211 1.355 14.062 2.14 20.047 2.353 34.686 5.777 43.268 10.127 2.307 1.141 4.831 1.57 10.095 1.854 7.789.357 8.15.143 5.914-4.136-1.875-3.566-5.192-5.42-12.26-6.704-3.533-.713-9.374-1.854-12.98-2.567-7.572-1.57-22.138-4.137-40.6-7.06-19.83-3.21-28.412-6.633-37.714-14.978-13.774-12.266-20.985-32.164-18.75-51.847.505-4.208.794-7.703.65-7.845-.65-.57-5.265 8.914-6.49 13.193l-1.299 4.707.289-7.56c.505-11.767 4.903-22.75 11.538-29.097 1.442-1.355 2.596-2.71 2.596-2.995 0-.286-1.37-.143-3.029.285-2.163.5-4.255 1.854-6.85 4.493l-3.75 3.709 1.73-3.352c2.668-5.278 7.284-10.555 11.683-13.48l4.11-2.638-2.38-.214c-4.76-.5-13.34 5.705-18.1 13.122-2.74 4.35-2.74 2.996.072-3.637 2.668-6.49 6.779-12.837 11.25-17.544 2.524-2.639 2.956-3.495 2.019-3.495-3.75 0-10.096 4.85-15.36 11.768-1.515 2.068-1.515 1.925.216-2.14 2.164-4.85 5.48-10.27 8.582-13.693 2.235-2.567 1.586-2.924-2.164-1.212-3.39 1.64-8.87 7.702-12.043 13.55-1.514 2.71-2.596 4.28-2.38 3.495.217-.785.722-2.853 1.082-4.636 2.668-11.839 9.159-23.392 17.956-31.879 3.39-3.21 4.255-4.493 3.318-4.493-2.74 0-9.159 3.637-13.413 7.631-4.4 4.137-4.471 4.137-2.74 1.284 6.057-10.199 15.143-19.47 25.6-26.102 3.317-2.14 6.057-4.065 6.129-4.28 0-1.07-10.961 2.211-15.937 4.708-1.154.641-3.894 2.567-6.202 4.421-3.461 2.782-3.822 2.996-2.524 1.141 2.452-3.423 10.745-10.769 14.062-12.48 2.452-1.284 2.74-1.64 1.515-1.855-3.317-.499-12.548 4.35-19.76 10.342l-3.172 2.71 1.73-2.853c5.625-9.2 12.548-16.546 20.697-21.823 2.884-1.855 5.697-3.495 6.202-3.709.432-.142.72-.5.504-.713-.216-.214-2.812.357-5.697 1.355zm108.386 203.968c1.01 1.07 1.875 2.211 1.875 2.497 0 .356-1.587.641-3.606.641-3.461 0-3.605-.07-3.605-1.996 0-3.638 2.307-4.066 5.336-1.142z' fill='%2300a854'/%3e%3cpath d='M492.543 413.18c-1.731 1.64-1.443 4.35.505 4.85 3.028.784 6.994.498 6.994-.571 0-1.07-4.615-5.42-5.769-5.42-.36 0-1.153.499-1.73 1.14z' fill='%239eab05'/%3e%3cpath d='M392.463 209.25c-7.627 1.33-14.279 5.866-20.117 10.72-.815.751-1.259 1.178-1.29 1.286-.43.489-4.3 3.934-6.68 7.252-1.156 1.334-2.76 3.613-3.593 4.99.179-1.354 1.193-5.411 2.227-9.98 1.158-5.44 1.668-9.844 1.523-10.058-.724-.645-5.95 6.198-8.555 11.422-3.835 7.515-4.96 12.695-4.96 23.43l-.079 8.928-1.757-6.784c-1.882-7.085-5.121-14.463-6.64-14.892-.507-.143-1.079.875-1.368 2.378-.434 2.362-.032 4.636 3.008 16.803.217 1.002-.567.08-1.797-2.067-2.75-4.795-3.696-5.88-4.492-5.38l1.953 2.807c1.085 1.575 3.033 5.298 4.336 8.304 3.546 8.374 8.837 26.119 7.968 26.978-.217.143-.653-.434-1.015-1.365-.362-.93-1.358-3.642-2.227-6.003-.868-2.362-2.816-6.605-4.336-9.396-3.4-6.226-5.86-13.092-6.367-17.816l-.39-3.47c-1.002.779-.597 4.921.82 9.474.724 2.433 1.283 4.366 1.21 4.366-.144 0-1.711-2.004-3.593-4.366-2.605-3.292-3.634-4.147-4.14-3.43-.652 1.073-.27 3.203 1.25 7.211l.976 2.73h-2.383c-1.302 0-2.948.434-3.672.935-1.23.859-1.31 1.43-.586 5.224.833 4.688 1.998 8.13 2.891 8.187 1.43.09 1.388-1.412 2.11-5.497.29-1.171.787-1.894.898-2.573.306.43.747.953 1.367 1.598 6.089 8.285 11.569 19.632 14.101 27.29 2.027 6.083 5.786 22.104 5.352 22.533-.145.215-1.04-2.497-1.836-6.004-2.895-12.166-6.984-19.358-19.648-31.811 0 0-4.347-5.2-7.852-7.213.058 2.933.664 3.431.664 3.431.869 4.437 3.108 8.3 9.766 16.1 2.967 3.508 5.351 6.615 5.351 6.901 0 .215-1.65-1.102-3.75-2.963-3.835-3.363-9.772-7.2-10.351-6.627-.217.143 1.21 3.29 3.164 6.94 2.46 4.58 3.218 6.445 2.422 6.159-2.822-1.145-3.855-1.145-5.664 0-1.882 1.217-1.88 1.332-1.445 6.198.217 2.72.815 5.652 1.25 6.51.868 1.432.85 1.446 1.718-.272.507-.93 1.078-2.941 1.367-4.444.29-1.432.72-2.651.938-2.651.244 0 3.916 3.822 5.703 5.575.714.93 1.548 1.943 2.422 3.001 4.27 5.225 16.062 20.273 19.101 25.068l1.524 2.495-2.461-1.91c-8.178-7.002-21.575-14.832-26.64-16.335-1.419-.42-1.8-.016-1.133.74-.025.003-.064-.013-.079 0 3.477 4.695 13.69 13.262 16.368 15.517 2.677 2.254 2.65 3.092 2.578 3.235-.145.072-2.012-.797-5.196-1.87-8.177-2.864-10.304-2.927-9.218-1.638.506.572 1.732.98 2.89 1.052 4.198.072 14.845 4.73 22.227 9.669 4.776 3.22 16.214 14.095 17.734 16.958.796 1.575.512 1.426-2.383-.936-3.908-3.149-14.756-9.311-15.625-8.81-.29.215-2.836-.26-5.586-.975-2.822-.716-7.026-1.507-9.414-1.793l-4.257-.507 2.539 2.3c3.328 3.006 8.9 5.707 18.164 8.928 4.124 1.431 8.837 3.358 10.43 4.288 3.473 2.004 10.634 7.595 10.272 7.953-.144.143-2.78-.862-5.82-2.222-5.138-2.362-17.857-6.795-22.343-7.797-1.665-.358-1.1.345 3.242 4.64 2.894 2.719 7.831 6.74 11.015 8.888 15.342 10.09 29.249 14.537 55.156 17.543 4.125.5 7.21 1.123 6.992 1.481-.217.358 6.3 1.318 13.32 2.106 18.816 2.218 30.546 4.789 41.328 9.083 4.704 1.932 7.468 2.56 12.461 2.846 4.776.286 6.406.215 6.406-.429 0-1.646-2.07-4.87-4.531-7.017-2.171-1.861-3.61-2.974-12.148-4.406-5.355-.858-10.17-2.02-10.82-2.378-.652-.357-11.403-1.855-23.633-3.86-26.848-4.293-35.101-6.232-42.265-9.667-17.73-8.589-29.807-27.28-30.82-48.965-.218-4.366-.083-10.074.351-12.866.434-2.72.73-5.08.586-5.224-.651-.644-6.124 10.241-6.992 14.464l-.352 2.729-.273-4.912c-.072-11.165 3.525-20.885 9.531-29.044 0 0 4.009-3.943 4.57-4.99.039-.03.037-.08.04-.117.018-.055.019-.095 0-.117-.022-.024-.028-.054-.079-.039-.015-.015-.019-.024-.039-.039-2.863-.895-5.953 1.458-10.117 5.185-2.587 2.61-2.941 3.256-3.086 3.041.164-1.874 7.66-13.255 9.18-13.255.29 0 2.134-2.163 2.812-2.807.869-2.218-4.479 2.696-8.242 7.992-8.438 11.243-10.356 22.604-9.922 37.777.145 4.652-.2 8.303-.273 8.303-.362 0-2.547-5.42-3.633-8.927-2.75-8.875 1.469-27.387 8.633-36.763 1.23-1.574 4.22-4.987 4.687-5.77 1.014-1.932-4.938 4.778-7.109 8.07-.491.992-1.171 1.6-1.289 1.365-.118-.235.256-1.3.82-3.041 2.678-7.801 7.303-15.846 13.164-22.144 2.171-2.361 2.24-2.333.43-1.832-4.27 1.217-8.127 4.51-12.305 9.278-1.013 1.575-1.93 2.416-3.086 3.743.4-1.951 4.16-9.87 7.344-14.307 1.954-2.649 3.828-4.442 3.75-5.03-.078-.588-2.108.044-5.039 2.223-4.414 3.22-6.922 6.621-10.703 12.787-1.737 3.507-1.484 2.521-2.07 3.157 1.954-9.876 3.345-14.532 6.601-20.973 2.967-5.798 5.873-9.72 11.445-15.516 3.908-4.008 4.696-5.147 3.32-4.718-4.269 1.289-8.804 4.147-12.929 8.226-2.388 2.434-3.36 3.165-3.36 2.807 0-.358 1.167-2.354 3.556-6.004 5.065-7.729 12.39-15.762 19.843-20.7 3.69-2.506 9.519-5.263 8.867-5.692a.685.685 0 0 0-.312-.078c.388-.633-1.658-.19-6.836 1.403-5.138 1.575-10.639 4.634-16.211 8.928-2.154 2.015-1.728.351 3.555-4.873 2.822-2.863 7.165-6.347 9.336-7.564 3.618-2.147 3.33-2.645 1.015-2.144-5.427 1.074-15.867 7.006-18.906 10.8-.017.02-.022.017-.039.038-.13.05-.245.067-.43.156-1.643 1.01-3.231 3.275-2.851 2.3.38-.975 1.207-1.799 3.125-4.912 5.862-9.447 13.64-16.353 23.554-22.221 2.443-1.477 2.54-2.2.82-2.028zm-54.648 38.087c.021-.017.055-.025.078-.038l-.078-.078v.116zm48.944-35.398a.312.312 0 0 1 .196.078c.145.215-.774 1.006-2.149 1.793-2.677 1.718-11.714 10.6-14.609 14.464-3.69 4.795-7.997 12.584-10.312 18.596-1.303 3.363-2.305 5.562-2.305 4.99-.072-1.575 1.977-12.14 2.773-14.932a10.75 10.75 0 0 0 .43-2.027c.363-.227.931-.858 1.875-2.339a59.077 59.077 0 0 1 3.672-4.951c1.62-2.003 6.658-7.274 6.523-7.407-.02-.02-.094.025-.156.039.495-.354 1.01-.732 1.758-1.287 4.749-3.489 11.002-7.058 12.304-7.017zm-23.788 3.86c.052-.004.099.02.117.078.144.429-.758 6.65-2.422 13.878-3.329 15.244-5.76 27.2-6.484 35.36-.507 5.01-.66 5.454-1.094 3.235-.362-1.36-.765-8.313-1.055-15.399-.506-14.027.054-18.124 3.672-25.925 2.035-4.495 6.478-11.174 7.266-11.227zm19.492 11.734c.217 0-1.725 1.933-4.258 4.366-10.349 9.59-17.885 22.5-22.227 38.245l-1.367 4.99.43-4.64c.217-2.576.743-6.604 1.25-8.966.651-2.863 2.186-7.585 3.75-11.812 1.564-4.228 3.038-7.824 6.21-10.994.69-.728 2.145-2.032 2.5-2.612.76-.537 1.897-1.365 3.946-2.963 2.895-2.29 8.68-5.614 9.766-5.614zm8.554 3.626c.34-.017.508.037.508.234 0 .143-1.897 1.46-4.14 2.962-5.5 3.579-15.696 14.112-19.532 19.766-3.473 5.153-8.733 15.273-10.976 21.714-2.026 5.94-1.898 2.747.273-5.77 1.954-7.514 6.815-18.705 10.469-24.131.678-.984 1.083-1.598 2.07-2.924.98-1.107 1.28-1.657 1.64-1.442.363.214 2.014-.791 3.75-2.222 3.8-3.194 13.566-8.069 15.938-8.187zm-48.476 5.34c.181-.062.425.25.86.858.506.716 1.894 4.005 3.124 7.368 3.33 9.304 7.743 34.195 6.368 35.555-.218.286-.43-.188-.43-.975 0-.787-1.6-6.47-3.555-12.553-5.644-17.32-7.598-25.888-6.875-28.966.217-.787.327-1.224.508-1.286zm37.265 15.36c.145 0-1.456 1.74-3.554 3.743-9.697 9.805-16.05 23.123-18.438 38.868-.579 3.937-1.396 7.44-1.757 7.797-.29.287-.844-1.296-1.133-3.586-.941-7.443 1.595-19.546 5.937-28.42.941-1.933 1.035-2.772 1.797-3.977.51-.432.989-1.439 1.875-2.612 3.237-3.555 8.558-8.873 12.031-10.448 1.665-.716 3.098-1.364 3.242-1.364zm-46.913 1.794l1.445 1.793c.796 1.002 2.822 3.72 4.414 6.082 3.04 4.437 11 20.125 11.797 23.274.29 1.002-.707-.568-2.227-3.43-1.52-2.863-4.855-7.943-7.46-11.306-5.862-7.73-7.97-11.478-7.97-14.269v-2.144zm-1.64 10.409c.223-.023.49 0 .78 0 2.099 0 6.528 3.91 10.508 9.278 4.56 6.155 9.85 19.108 12.383 30.058 1.23 5.582 3.32 19.897 3.32 23.118v2.3l-1.172-2.144c-.651-1.217-1.57-4.817-2.148-8.109-1.665-9.447-4.277-18.585-7.461-26.744-3.184-8.087-10.007-19.566-13.047-22.572-.456-.445-.82-.69-1.054-.78-.49-.804-1.539-1.64-2.032-2.066-1.583-1.44-1.646-2.18-.078-2.339zm-3.556 1.209l1.72 1.052c2.406 1.703 3.33 2.382 2.773 4.561-.307 2.137-.66 4.19-1.094 4.834-.507 1.002-1.1.263-1.68-2.027-.434-1.574-.921-4.15-1.21-5.653l-.509-2.767zm47.54 9.55c.206.02.17.268-.157.78-.666.551-2.296 2.682-3.164 3.899-4.632 6.227-11.354 23.417-12.656 33.293-.724 5.153-1.608 2.797-1.68-4.288-.145-10.234 4.426-21.686 11.445-28.771 2.877-2.952 5.59-4.968 6.211-4.912zm-48.282 4.484c.673.141 2.713 2.118 7.54 6.94 4.486 4.58 9.288 10.067 10.663 12.358 2.75 4.652 5.644 11.463 6.367 14.97.362 2.004-.367 1.21-4.492-4.444-2.75-3.722-6.606-8.71-8.632-11.072-7.816-9.018-10.7-13.457-11.641-17.894-.136-.582-.11-.922.195-.858zm53.515 1.91c.145 0-1.618 2.147-3.789 4.796-2.17 2.72-5.115 7.15-6.562 9.94-2.895 5.726-7.191 18.696-8.71 26.783-1.593 8.302-1.73 8.141-1.368-1.091.651-17.75 7.039-32.102 16.953-38.4 1.81-1.074 3.332-2.028 3.476-2.028zm-52.773 12.748l2.188 1.131c1.23.644 4.169 2.746 6.484 4.678 2.388 2.004 4.555 3.366 4.844 3.08.362-.286.451-.234.234.195-.217.358 1.608 3.452 4.141 6.744 4.849 6.298 10.196 16.222 12.656 23.235.796 2.362 1.356 4.373 1.211 4.445-.072.143-2.233-3.14-4.766-7.29-5.5-9.09-12.009-17.168-16.64-20.818-2.533-2.004-4.42-4.465-6.953-9.045l-3.399-6.355zm57.031 9.435c.05 0 .073.002.117 0-1.287 1.066-4.023 4.171-4.023 4.171-3.618 3.936-7.738 11.304-9.258 17.816-1.664 7.443-1.116 26.564 1.055 34.58.796 2.934 1.395 5.425 1.25 5.497-.507.5-4.79-11.437-5.586-15.516-1.23-6.227-1.158-20.83 0-25.77 1.375-5.582 4.482-12.093 7.305-15.242 2.46-2.791 6.97-5.536 9.14-5.536zm-55.39 2.456c1.092.05 2.367.622 4.375 1.91 7.743 4.867 17.5 17.744 28.789 37.855 9.046 16.246 14.256 28.494 6.875 16.256-10.493-17.32-27.567-40.43-34.297-47.444-.705-.734-1.058-1.012-1.133-.975l-.117-.195c-.94-1.145-3.736-3.423-5.039-4.21-2.894-1.79-2.968-2.508-.508-3.08a3.5 3.5 0 0 1 1.055-.117zm-2.734 3.275c.579 0 1.44.44 1.875 1.013.868 1.074.382 6.568-.703 7.212-.796.573-1.18-.26-1.758-4.483-.434-3.006-.283-3.742.586-3.742zm50.741 19.336s-.083 3.769-.156 8.42c-.651 19.897 6.245 36.643 19.922 48.81 8.177 7.229 17.424 11.179 32.187 13.684 4.921.859 9.421 1.578 10 1.793.579.215 7.387.922 6.953 1.637-.217.287.432.45 1.445.234 2.895-.5 11.87 1.45 14.258 1.52 3.69.072 27.772 5.072 33.36 7.057 1.953.787 6.21 5.71 6.21 7.212 0 .43-2.236.592-6.289.234-4.92-.358-7.466-.998-11.953-3.002-9.335-4.15-22.354-7.106-38.203-8.537-8.177-.716-34.672-5.359-42.343-6.862-9.48-1.932-16.277-4.237-24.96-8.46-9.264-4.508-14.485-8.01-20.274-13.45l-4.688-4.483 3.985 1.131c11.65 3.364 21.061 7.599 32.93 14.97 9.334 5.797 12.433 7.289 17.499 8.577 4.631 1.217 6.016 1.294 6.016.507 0-.287-2.385-1.286-5.352-2.144-20.19-6.227-35.39-27.06-35.39-48.459 0-3.578.353-7.879.86-9.668.723-2.791 3.694-10.72 3.983-10.72zm-46.952 2.3c.363.154.729.293 1.054.351 4.27.644 21.437 11.512 27.227 17.31 2.026 2.003 4.79 5.669 6.093 8.03l2.305 4.367-3.984-3.236c-2.244-1.79-6.307-4.585-8.984-6.16-2.823-1.646-8.813-6.952-14.024-11.89-3.682-3.434-7.625-7.14-9.687-8.772zm11.836 30.136c.303-.013.814.06 1.601.195 1.375.214 5.058 1.006 8.242 1.793 11.434 2.648 25.123 11.287 32.07 20.233l3.125 4.016-3.203-1.638c-1.737-.859-3.113-1.78-2.969-2.066.435-.716-6.795-6.735-10.703-8.81-1.953-1.074-7.456-3.28-12.304-5.069-8.829-3.149-14.044-5.754-15.781-7.758-.498-.626-.584-.875-.078-.896z' fill='%23cab313' fill-opacity='.502'/%3e%3cpath d='M382.785 291.842c-1.583.548-4.01 2.864-5.592 4.038-3.166 2.349-3.591 3.201-.584 1.088 2.217-1.565 5.972-4.38 9.335-4.795.314-.038-1.335 1.61-2.206 2.55-1.187 1.33-.87 1.253 1.9-.548 1.82-1.174 3.324-2.27 3.324-2.426 0-.626-3.407-.925-6.177.093zM333.983 345.218c0 1.79 22.196 18.156 23.21 17.154.144-.143-2.75-2.147-6.514-4.437-3.69-2.219-8.472-6.08-10.933-8.227-2.388-2.147-5.408-5.617-5.763-4.49z' fill='%23cab313' fill-opacity='.502'/%3e%3c/g%3e%3cg stroke='%23d4af37' stroke-width='.904'%3e%3cpath d='M246.162 432.318c-5.483 1.69-12.845 1.998-16.376.691-1.277-.46-5.204-.206-6.18-.052 3.564 2.386 2.118 1.386 2.83 1.881 1.291.76.754.603 3.064 1.633-.395.45-.589.627-2.405 1.29 2.412.567 5.403.8 8.302.67a37.042 37.042 0 0 0 8.747-1.455c3.756-1.076 7.803-1.777 9.005-1.777 1.127 0 5.333 1.259 9.39 3.41 8.545 4.735 14.518 5.95 20.528 5.95 4.131 0 8.44-.922 13.329-4.113 3.613-2.36.568-2.302-3.027-.722-4.958 1.998-15.13 2.89-26.924-3.18-7.136-3.688-12.695-5.84-14.648-5.686-.376 0-2.93.691-5.635 1.46z' fill='white' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath d='M219.856 429.486c1.465 1.23 1.25 1.471 3.79 3.53 3.558.349 10.643 1.11 13.273 1.11 2.328 0 6.826-.404 9.906-1.25 6.233-1.314 9.223-.93 20.567 4.056 13.146 6.763 20.53 5.524 27.29 2.22 9.43-3.586.254-2.04-3.165-3.031-1.127.384-2.568 1.84-5.253 2.817-3.754 1.367-5.765 1.324-10.272-.981-2.855-1.46-5.387-2.152-7.946-3.552-2.52-1.46-3.15-1.289-7.358-2.672l-6.196-1.22-9.38-.496c-8.113 1.69-16.09.4-21.5-1.29-5.408-1.69-6.385-1.393-3.756.759z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath d='M244.35 436.83c-6.46 1.921-14.34 2.016-17.27.94-1.532.62-.008-.018-3.84 1.365-5.033 1.69-5.108 1.768-2.93 2.382 1.278.385 6.311.692 11.27.615 8.563 0 9.314-.153 14.047-2.459 2.78-1.383 5.86-2.459 6.911-2.459.977 0 4.602 2.067 7.757 3.68 8.79 4.61 12.134 5.969 19.42 5.892 7.287-.077 16.694-5.291 17.862-7.074-5.596 3.396-10.23 5.156-17.312 4.87-7.082-.287-12.552-2.834-19.764-6.907-5.784-3.227-7.812-3.304-16.151-.845z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cg stroke-width='.807'%3e%3cpath d='M293.47 417.689c1.216-1.4.855-1.915-2.49-2.381-8.288-1.323-18.856-6.3-23.113-10.888-2.129-2.334-3.117-2.567-3.117-.7 0 1.944 6.766 8.088 11.632 10.577 4.258 2.255 11.67 4.724 14.483 4.724.836 0 1.92-.477 2.604-1.332z' fill='white' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3e%3cpath d='M290.67 421.403c.238-.407-.408-2.4-3.112-2.97-6.682-1.384-14.159-5.289-18.931-9.845-3.58-3.5-5.332-3.843-4.139-.67 1.62 4.575 14.327 11.001 19.259 12.547 5.011 1.628 6.206 2.077 6.922.938z' fill='%23d91023' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3e%3cpath d='M295.457 415.365l.827-1.39-4.033-2.547c-4.601-.588-12.942-3.604-18.55-6.766-2.517-1.398-5.249-2.575-6.112-2.575-1.51 0-1.61 0 .116 1.913 3.954 4.34 14.336 9.397 21.742 10.427 2.373.367 4.788 2.042 6.01.938z' fill='%23ed1c24' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3e%3cpath d='M293.47 417.689c1.216-1.4.855-1.915-2.49-2.381-8.288-1.323-18.856-6.3-23.113-10.888-2.129-2.334-3.117-2.567-3.117-.7 0 1.944 6.766 8.088 11.632 10.577 4.258 2.255 11.67 4.724 14.483 4.724.836 0 1.92-.477 2.604-1.332z' fill='white' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3e%3cpath d='M288.923 420.615c.146-.251 1.314-1.57-1.365-2.182-6.682-1.384-14.159-5.289-18.931-9.845-4.24-4.604-6.35-5.55-4.139-.67 1.62 4.575 14.327 11.001 19.259 12.547 5.011 1.628 4.46 1.289 5.176.15z' fill='%23d91023' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3e%3cpath d='M295.457 415.365l.827-1.39-4.033-2.547c-4.601-.588-12.942-3.604-18.55-6.766-2.517-1.398-5.249-2.575-6.112-2.575-1.51 0-1.61 0 .116 1.913 3.954 4.34 14.336 9.397 21.742 10.427 2.373.367 4.788 2.042 6.01.938z' fill='%23ed1c24' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3e%3c/g%3e%3cpath d='M319.677 402.697c-6.356 1.817-11.424 5.84-16.665 13.131-2.07 2.879-4.032 4.339-2.635 5.038 1.538.77 2.898-1.393 5.658-4.15 6.96-6.955 12.479-9.89 19.997-9.972h5.969l-1.783-2.478c-2.17-2.973-4.573-3.303-10.541-1.569zM269.234 405.082c-1.273 1.465-.895 2.003 2.604 2.491 8.67 1.384 19.727 6.591 24.181 11.392 2.227 2.44 3.261 2.685 3.261.732 0-2.034-7.079-8.462-12.17-11.066-4.454-2.36-12.208-4.942-15.152-4.942-.874 0-2.008.498-2.724 1.393z' fill='white' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3e%3cpath d='M318.582 399.536c-1.706.578-4.108 1.651-5.426 2.312-3.566 1.982-9.02 8.373-9.834 9.58-.87 1.29-2.14 2.793-3.002 4.19-1.274 2.068-1.482 3.204-.845 3.33.637.126 2.12-.758 3.527-2.73 6.022-8.443 11.55-12.223 19.765-13.874 4.263-.826 4.883-.826 6.356.66 1.162 1.074-.337-.236-.57-.979-.542-1.817-1.91-2.737-4.546-3.233-1.24-.165-3.72.083-5.425.744z' fill='%23d91023' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3e%3cpath d='M271.987 403.32c-.238.406 1.83 1.139 4.534 1.708 6.682 1.383 14.159 5.289 18.931 9.845 3.58 3.499 5.332 3.843 4.139.67-1.62-4.575-14.327-11.002-19.259-12.548-5.011-1.627-7.629-.815-8.345.324zM320.52 407.381c-4.884 1.734-9.767 4.79-13.642 8.506-3.953 3.882-5.738 6.35-4.188 6.35.31 0 2.715-1.89 4.343-3.294 7.053-6.029 19.763-9.425 25.421-7.36 2.713.99 1.436-2.011-.424-4.736-1.162-1.735-8.023-.705-11.51.534zM267.423 407.115l-3.307 3.14 4.928.794c5.091.651 14.318 3.987 20.522 7.486 2.784 1.546 5.807 2.847 6.761 2.847 1.67 0 1.782 0-.127-2.115-4.375-4.8-15.86-10.396-24.053-11.535-2.625-.407-3.372-1.837-4.724-.617z' fill='%23d91023' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3e%3cg%3e%3cpath d='M304.493 422.389c-1.651 5.417-1.432 10.396-.97 14.138 1.605-.193 2.662-.24 5.27-.725.273-2.198.686-4.745.573-7.435.338-3.7-.019-1.771 2.183-4.736-2.375-1.526-3.013-1.66-7.056-1.242z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3e%3cpath d='M296.203 428.628c-.084 4.215.317 5.13.27 7.137 2.355.385 7.422 1.07 7.121.225.02.922-.076-4.911-.002-7.985l.854-5.533-3.587-.549-3.23.405-1.426 6.3z' fill='white' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3e%3cpath d='M291.002 428.828c.15 3.343-.53 4.487-.13 6.445 1.05.318 5.047.184 6.286.568-.176-4.355-.176-.547-.598-6.234l1.266-7.28-3.595.287s-2.221-.69-3.732-.72c1.303 2.274.503 6.934.503 6.934z' fill='%23d91023' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$1v = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 4'%3e%3crect fill='%23CE1126' width='6' height='4'/%3e%3crect fill='%23003893' width='6' height='3'/%3e%3crect fill='%23FCD116' width='6' height='2'/%3e%3c/svg%3e";

var img$1u = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 960 600'%3e%3cdefs%3e%3cradialGradient id='a'%3e%3cstop stop-color='%23f9f0aa' offset='.22'/%3e%3cstop stop-color='%23b07e09' offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='d' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='447.42' cy='308.27' r='16.53'/%3e%3cradialGradient id='e' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='451.56' cy='313' r='10.91'/%3e%3cradialGradient id='f' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='454.11' cy='308.64' r='9.78'/%3e%3cradialGradient id='g' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='458.39' cy='307.06' r='17.35'/%3e%3cradialGradient id='j' xlink:href='%23a' gradientUnits='userSpaceOnUse' cx='445.98' cy='252.36' r='13.02'/%3e%3cradialGradient id='m' gradientUnits='userSpaceOnUse' cx='477.86' cy='215.27' r='.34'%3e%3cstop stop-color='%23a50a0a' offset='.26'/%3e%3cstop stop-color='%234c0505' offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='n'%3e%3cstop stop-color='white' offset='0'/%3e%3cstop stop-color='white' stop-opacity='0' offset='1'/%3e%3c/radialGradient%3e%3clinearGradient id='h' gradientUnits='userSpaceOnUse' x1='473.91' y1='259.17' x2='472.36' y2='231.96'%3e%3cstop stop-color='%23b07e09' stop-opacity='0' offset='.22'/%3e%3cstop stop-color='%23b07e09' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='i' gradientUnits='userSpaceOnUse' x1='483.13' y1='296.66' x2='485.49' y2='326.58'%3e%3cstop stop-color='%23b07e09' stop-opacity='0' offset='.22'/%3e%3cstop stop-color='%23b07e09' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='k' gradientUnits='userSpaceOnUse' x1='451.54' y1='249.52' x2='455.37' y2='240.58'%3e%3cstop stop-color='%23f9f0aa' offset='.22'/%3e%3cstop stop-color='%23b07e09' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='l' gradientUnits='userSpaceOnUse' x1='473.31' y1='237.25' x2='475.93' y2='270.45'%3e%3cstop stop-color='%23f9f0aa' offset='.22'/%3e%3cstop stop-color='%23b07e09' offset='1'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='%234997d0' d='M0 0h960v600H0z'/%3e%3cpath fill='white' d='M320 0h320v600H320z'/%3e%3cg stroke='%2324420e'%3e%3cg fill='none' stroke-width='.44'%3e%3cpath d='M452.12 377.48c2.67-.4 4.2-1.14 6.04-1.79M460.37 371.64a13.03 13.03 0 0 1 3 4.64M455.25 371.2a15.4 15.4 0 0 1 3.14 4.15M408.81 238.77c-1.04 1.6-3.1 2.73-4.78 3.43M403.69 242c.04-1.37-.24-3.03.05-4.4M401.76 242.63c.11.37.44 1.4.68 2.03M404.46 245.58c-.38.08-1.52.26-2.03.34M398.48 245.04c-.01 2.52.29 5.55.53 7.82M397.22 251.9c.47.76.95 1.5 1.54 1.88M394.18 260.25c.49.94.94 2.12 1.3 3.96M399.2 259.58c-.41.2-1.21.93-1.93 1.54M398.86 265.52c-.98.87-2.2 1.5-3.43 2.12M391.62 308.05a15.98 15.98 0 0 0 3.96 4.68M396.16 314.42a8 8 0 0 1-2.95-.97M397.61 321.86l1.69.97M398.86 326.3c1.25.82 2.51 2.28 3.77 3.86M401.18 333.01c1.39.3 2.5.64 3.23 1.06M403.35 336.49l2.12.07M406.68 331.18c-.1 1.53-.25 2.97-.48 4.25M407.21 337.02l.43-1.64M412.33 341.37l-.15 3.24M451.39 372.51l-1.16 1.6M447.82 370.19l-.68-1.83'/%3e%3c/g%3e%3cg stroke-width='.16'%3e%3cpath fill='%23406325' d='M486.11 384.93c-.8-1.26-2.1-2.03-3.28-2.66-7.72-4.05-15.4-5.84-24.11-7.24-2.02-.34-4.03-2.22-6.09-3.19-4.96-2.36-10.49-3.28-15.31-5.7a7.78 7.78 0 0 1-2.1-1.54c-1.93-2.22-5.4-2.9-7.55-4.97-8.33-7.87-17.18-15.12-21.77-25.55-5.57-12.7-12.5-25.79-11.57-40.23.61-9.12-.75-18.35 1.5-27.04 3.33-12.9 7.59-25.64 15.4-36.31l-1.3.82c-7.87 10.67-12.13 23.42-15.46 36.31-2.24 8.7-.89 17.92-1.5 27.04-.93 14.44 6 27.53 11.57 40.28 4.59 10.38 13.49 17.62 21.78 25.55 2.15 2.02 5.62 2.7 7.53 4.97.57.63 1.83 1.4 2.11 1.54 4.83 2.42 10.35 3.34 15.31 5.65 2.06 1.02 4.08 2.85 6.1 3.2 8.7 1.4 16.38 3.23 24.1 7.23a8.02 8.02 0 0 1 3.28 2.66l1.36-.82'/%3e%3cg fill='%2367923d'%3e%3cpath d='M406.34 331.62c-2.8-6.3-1.36-21.6-.2-23.53 6.63 13 4.43 23.74.2 23.53zM452.2 377.01c-7.1.36-20.61 9.3-21.86 11.4 15.08.11 24.02-7.32 21.86-11.4zM459.66 372.72c-6.85-5.45-14.19-23.66-14.03-26.5 15.1 10.83 18.93 24.28 14.03 26.5z'/%3e%3cpath d='M454.61 372.78c-6.95-4.24-15.79-20.11-15.94-22.75 15.2 8.19 20.2 20.12 15.94 22.75zM439.05 366c.98-7.82-5.67-24.24-7.59-25.98-2.95 16.47 3 27.57 7.59 25.98zM411.74 341.72c-2.3-5.65-.61-19.32.47-21 5.52 11.7 3.26 21.22-.47 21zM398.03 264.89c3.59-6.65 18.38-15.71 20.99-15.93-6.77 14.57-18.04 19.83-20.99 15.93z'/%3e%3cpath d='M398.74 259.33c2.15-7.28 14.87-19.27 17.36-20.03-3.73 15.67-13.68 23.17-17.36 20.03zM426.55 358.48c-5-6.18-8.01-23.86-7.29-26.36 11.27 12.51 12.03 25.23 7.29 26.36zM397.9 322.02c-6.9 1.09-21.36-4.64-22.92-6.34 14.53-3.15 24.29 2.07 22.92 6.34zM395.68 312.34c.82-5.58 8.67-15.8 10.36-16.66-1.1 11.96-7.45 18.6-10.36 16.66zM447.01 370.88c-8.48.43-24.63 11.1-26.13 13.62 18.03.14 28.7-8.74 26.13-13.62z'/%3e%3c/g%3e%3cg fill='%23406325'%3e%3cpath d='M406.41 331.47c4.23.21 6.4-10.4-.27-23.38 1.21 12.32 1.2 22.31.27 23.38zM417.59 351.46c-4.47-5.47-19.38-11.33-21.71-11.14 8.88 12.08 19.88 15.1 21.71 11.14zM393.17 298.48c-1.15-8.04-12.33-22.71-14.74-23.97 1.51 17.18 10.55 26.7 14.74 23.97zM401.56 332.77c-5-3.68-18.97-5.34-20.94-4.72 10.14 8.3 20.21 8.46 20.94 4.72zM392.2 307.94c-2.89-5.69-14.81-13.48-16.9-13.7 5.53 12.39 14.57 16.94 16.9 13.7zM394.93 260.4c.9-7.57-5.53-23.45-7.34-25.16-2.87 15.93 2.91 26.67 7.34 25.16zM399.4 245.48c2.66-6.5.76-22.43-.52-24.42-6.4 13.51-3.83 24.65.52 24.42z'/%3e%3cpath d='M404.42 237.83c3.14-4.77 4.16-17.68 3.48-19.47-7.23 9.71-6.95 18.94-3.48 19.47zM410.37 231.69c4.4-3.48 9.22-15.5 9.08-17.43-9.74 6.95-12.22 15.84-9.08 17.43zM394.32 274.89c.1.87-.98-8.18-10.05-18.31.4 14.81 6.25 20.42 10.05 18.31zM426.88 360.67c-6.18-4.56-23.39-6.73-25.77-5.93 12.56 10.36 24.88 10.55 25.77 5.93zM438.95 365.91c-4.54 1.6-10.44-9.42-7.54-25.88 2.81 13.95 6.18 25.06 7.54 25.88zM452.25 377.06c2.12 4.08-6.7 11.44-21.79 11.31 11.96-4.89 21.24-9.86 21.79-11.31zM459.64 372.59c4.86-2.25 1.1-15.54-14-26.37 8.59 13.21 14.45 24.61 14 26.37z'/%3e%3cpath d='M454.57 372.67c4.28-2.67-.69-14.44-15.9-22.64 9.41 11.18 16.1 20.97 15.9 22.64zM411.78 341.68c3.73.22 5.96-9.26.48-20.92.72 10.97.42 19.97-.48 20.92zM398.02 264.94c2.95 3.9 14.05-1.3 20.84-15.92-10.17 9.34-19.23 16.06-20.84 15.92z'/%3e%3cpath d='M398.86 259.33c3.68 3.14 13.54-4.3 17.27-19.98-8.1 11.25-15.64 19.74-17.27 19.98zM426.58 358.42c4.74-1.12 3.95-13.78-7.25-26.27 5 13.41 8.01 24.75 7.25 26.27zM397.71 321.96c1.4-4.24-8.3-9.37-22.8-6.26 12.26 2.2 22.04 5.04 22.8 6.26zM395.77 312.35c2.9 1.89 9.18-4.66 10.29-16.62-4.68 9.18-9.17 16.27-10.29 16.62zM446.97 371.03c2.58 4.88-7.96 13.67-26.04 13.52 14.29-5.84 25.38-11.78 26.04-13.52z'/%3e%3cpath d='M399.36 326.3c-2.66-6.26-14.8-15.46-16.98-15.84 4.94 13.64 14.25 19.15 16.98 15.84z'/%3e%3c/g%3e%3cg fill='%2367923d'%3e%3cpath d='M392.42 273.92c4.07-4.67 17.47-9.13 19.6-8.86-8.04 10.4-17.94 12.51-19.6 8.86zM417.49 351.51c-1.8 3.92-12.7.92-21.65-11.15 10.89 6.83 20.25 11.5 21.65 11.15zM393.1 298.46c-4.2 2.73-13.13-6.74-14.69-23.88 6.63 13.2 13.04 23.38 14.69 23.88zM401.52 332.8c-.77 3.73-10.69 3.59-20.86-4.72 10.72 3.4 19.73 5.34 20.86 4.72zM392.07 307.85c-2.33 3.24-11.29-1.27-16.8-13.66 8.19 7.97 15.48 13.75 16.8 13.66zM394.83 260.3c-4.43 1.56-10.16-9.08-7.3-25 2.67 13.48 5.94 24.17 7.3 25zM399.3 245.44c-4.3.23-6.87-10.81-.47-24.32-.82 12.8-.5 23.23.47 24.32zM404.34 237.77c-3.47-.53-3.72-9.66 3.52-19.37-2.74 9.98-4.15 18.37-3.52 19.37zM410.32 231.69c-3.14-1.64-.7-10.43 9.04-17.34-5.53 8.65-9.32 16.18-9.04 17.34z'/%3e%3cpath d='M394.25 274.9c-3.8 2.1-9.58-3.5-9.99-18.32 5.1 11.68 8.6 17.8 9.99 18.32zM426.82 360.7c-.89 4.63-13.14 4.4-25.68-5.9 13.17 4.28 24.25 6.7 25.68 5.9zM418.65 351.22c-4.02-4.34-7.16-17.35-6.75-19.24 9.01 8.74 10.22 18.16 6.75 19.24zM401.77 326.23c-3.57-5.79-3.88-20.9-2.92-22.96 8.26 11.81 7.25 22.59 2.92 22.96zM399.14 326.32c-2.74 3.3-11.93-2.16-16.87-15.83 8.13 9.1 15.47 15.8 16.87 15.83z'/%3e%3c/g%3e%3cg fill='%23406325'%3e%3cpath d='M392.37 274c1.62 3.62 11.45 1.53 19.5-8.88-11.98 6.8-16.72 9.74-19.5 8.88zM401.71 326.07c4.33-.37 5.33-11.04-2.93-22.85 2.66 11.86 3.79 21.68 2.93 22.85zM418.67 351.18c3.47-1.07 2.25-10.45-6.71-19.18 4.4 9.73 7.2 18.01 6.71 19.18z'/%3e%3cpath d='M394.23 291.77c2.06-8.39-1.7-22.6-4.3-25.56-4.72 15.43-.24 26.6 4.3 25.56z'/%3e%3c/g%3e%3cpath fill='%2367923d' d='M393.93 293.77c-5.9 1.34-8.64-12.03-4.08-27.08 1.07 13.55 2.83 26.15 4.08 27.08z'/%3e%3cpath fill='%2367923d' d='M392.73 293.72c-.56-7.53 6.93-23.09 8.91-24.7 2.02 15.8-4.46 26.3-8.91 24.7z'/%3e%3cpath fill='%23406325' d='M392.84 293.61c4.41 1.64 10.85-8.76 8.83-24.56-3.5 13.26-7.44 23.76-8.83 24.56z'/%3e%3cpath fill='%2367923d' d='M394.13 303.26c0-7.6 8.47-22.23 10.56-23.62.84 16.16-6.33 25.83-10.56 23.62z'/%3e%3cpath fill='%23406325' d='M394.21 303.41c4.23 2.21 11.3-7.36 10.47-23.52-4.4 12.85-9.05 22.9-10.47 23.52z'/%3e%3c/g%3e%3cg fill='%23ba1f3e' stroke='%23511124' stroke-width='.22'%3e%3ccircle stroke-width='.19' cx='396.83' cy='251.27' r='1.08'/%3e%3ccircle stroke-width='.19' cx='405.2' cy='245.07' r='1.08'/%3e%3ccircle stroke-width='.19' cx='401.56' cy='241.71' r='1.09'/%3e%3ccircle cx='392.5' cy='313.12' r='1.28'/%3e%3ccircle cx='395.03' cy='297.13' r='1.28'/%3e%3ccircle cx='408.21' cy='334.46' r='1.28'/%3e%3ccircle cx='402.39' cy='336.43' r='1.28'/%3e%3ccircle cx='446.7' cy='367.63' r='1.28'/%3e%3ccircle cx='449.61' cy='374.71' r='1.28'/%3e%3c/g%3e%3c/g%3e%3cg stroke='%2324420e'%3e%3cg fill='none' stroke-width='.44'%3e%3cpath d='M561.15 258.97c.62.62 1.17.8 2.3 1.9M556.82 241.92c-.04-1.37-.63-3.6-.92-4.97M559.35 239.93c.06 1.95-.22 3.8-1.06 5.5M554.13 244.9c1.75 1.58 3.5 3.08 5.26 3.9M563.21 250.02a18.7 18.7 0 0 1-.68 5.94M562.85 257.47l1.31-2.26M562.3 267.43c1.4.3 2.81 1.95 3.5 3.48M566.28 269.62l1.64-2.19M569.63 298.16a23.98 23.98 0 0 1-2.46 3.48M563.21 301.57c.79 1.46 1.56 2.95 2.6 4.03M568.26 311.47a13.19 13.19 0 0 1-4.44 4.03M563.96 320c-1.1.75-2.43 2.95-3.69 4.71M568.71 304.53l-2.12.87M565.19 297.91l1.26 1.11M557.15 336.41c-.84-.1-1.46 0-2.12.07M553.03 334.55l.61 1.64M545.93 341.31c-.26 1.87-.07 3.73.2 5.6M550.44 337.89l1.02 2.25M555.29 339.94l-2.53.41M521.91 365.62l-.92 1.74M532.89 363.43c-1.5.19-2.78-.04-4.1-.2M523.33 369.17a27.28 27.28 0 0 0-2.94-.96M505.65 370.87c-.9.77-1.99 2.44-3.07 4.1M502.03 370.4c-2.43 1.25-3.18 3.71-4.44 5.8M500.39 379.07a52.47 52.47 0 0 1-5.33-2.05M511.83 376.34c-2.32-1.2-4.75-1.09-7.14-1.47M515.45 374.53c-3.63-.7-7.01-.61-10.28-.14M512.95 371.79l-1.4-.58M506.02 376.71l-2.32-1.3M561.64 326.22c-1.26.82-2.51 2.28-3.77 3.86M559.7 250.46l-2.15-.72'/%3e%3c/g%3e%3cg stroke-width='.16'%3e%3cpath fill='%23406325' d='M474.39 384.85c.8-1.26 2.1-2.03 3.28-2.66 7.72-4.05 15.4-5.84 24.11-7.24 2.02-.34 4.03-2.22 6.1-3.19 4.95-2.36 10.48-3.28 15.3-5.7a7.78 7.78 0 0 0 2.11-1.54c1.92-2.22 5.38-2.9 7.54-4.97 8.33-7.87 17.18-15.12 21.77-25.55 5.57-12.7 12.5-25.79 11.57-40.22-.61-9.13.75-18.35-1.5-27.05-3.33-12.9-7.59-25.64-15.4-36.31l1.3.82c7.87 10.67 12.13 23.42 15.46 36.31 2.24 8.7.89 17.92 1.5 27.05.93 14.43-6 27.52-11.57 40.27-4.6 10.38-13.49 17.63-21.78 25.55-2.15 2.02-5.62 2.7-7.54 4.97a9.98 9.98 0 0 1-2.1 1.54c-4.83 2.42-10.35 3.34-15.31 5.66-2.06 1-4.08 2.84-6.1 3.18-8.7 1.4-16.38 3.24-24.1 7.25a8.02 8.02 0 0 0-3.28 2.65l-1.36-.82'/%3e%3cg fill='%23406325'%3e%3cpath d='M553.65 334.6c2.74-7.42 0-24.84-1.49-26.95-6.65 15.37-3.34 27.5 1.49 26.95z'/%3e%3cpath d='M546.54 341.64c2.3-5.65.61-19.32-.47-21-5.52 11.7-3.26 21.22.47 21zM563.35 267.49c-3.3-6.1-16.87-14.42-19.26-14.62 6.21 13.37 16.55 18.2 19.26 14.62z'/%3e%3cpath d='M561.76 259.47c-1.8-6.07-12.4-16.05-14.47-16.7 3.1 13.07 11.4 19.32 14.47 16.7zM566.5 274.43c-3.54-4.05-15.16-7.93-17.01-7.7 6.98 9.04 15.57 10.87 17.01 7.7zM563.7 320.76c6.13.97 18.96-4.12 20.34-5.63-12.9-2.8-21.55 1.84-20.34 5.63zM563.55 315.12c-.04-5.64-6.4-16.86-7.96-17.93-.55 12 4.8 19.45 7.96 17.93z'/%3e%3cpath d='M563.96 301.44c0-7.6-8.47-22.23-10.56-23.62-.84 16.16 6.33 25.83 10.56 23.62zM511.07 376.71c4.48 5.5 19.65 11.13 22.09 10.9-8.8-12.23-20.07-15.05-22.09-10.9z'/%3e%3c/g%3e%3cg fill='%2367923d'%3e%3cpath d='M553.56 334.43c-4.82.55-8.09-11.44-1.4-26.79-.49 14.2.24 25.63 1.4 26.79zM500.19 378.09c7.1.36 20.61 9.3 21.86 11.4-15.08.11-24.02-7.32-21.86-11.4zM500.19 370.15c2.1-7.97 15-21.21 17.51-22.15-3.6 17.13-13.74 25.53-17.51 22.15zM521.46 365.92c-.98-7.82 5.67-24.24 7.58-25.98 2.96 16.47-3 27.58-7.58 25.98zM542.92 351.38c4.47-5.47 19.38-11.33 21.71-11.14-8.88 12.08-19.88 15.1-21.71 11.14zM568.71 298.12c.9-6.33 9.71-17.88 11.6-18.87-1.19 13.52-8.3 21.02-11.6 18.87z'/%3e%3cpath d='M557.02 336.18c5.82-4.29 22.1-6.23 24.4-5.5-11.81 9.67-23.55 9.85-24.4 5.5zM567.29 311.66c3.03-5.98 15.57-14.17 17.75-14.4-5.8 13.02-15.3 17.8-17.75 14.4zM565.81 266.1c-.1-7.63 7.98-22.73 9.97-24.24 1.16 16.14-5.73 26.2-9.97 24.24zM558.88 240.18c-2.32-5.28-1.1-18.41-.1-20.07 5.56 10.96 3.68 20.17.1 20.07zM554.65 238c-5.27-4.68-10.64-19.76-10.41-22.1 11.75 9.26 14.39 20.36 10.41 22.1z'/%3e%3cpath d='M566.28 272.54c-.32.82 2.94-7.7 14.22-15.3-4.01 14.26-11.04 18.27-14.22 15.3zM532.18 362.44c7-5.17 26.53-7.63 29.23-6.72-14.25 11.74-28.22 11.97-29.23 6.72zM546.51 341.6c-3.73.22-5.96-9.26-.48-20.92-.72 10.97-.42 19.97.48 20.92zM563.36 267.53c-2.7 3.58-12.9-1.2-19.12-14.61 9.33 8.57 17.64 14.74 19.12 14.61zM561.66 259.47c-3.07 2.62-11.29-3.58-14.4-16.65 6.76 9.37 13.05 16.45 14.4 16.65zM566.55 274.5c-1.4 3.15-9.94 1.33-16.92-7.7 10.39 5.89 14.5 8.45 16.92 7.7zM563.86 320.71c-1.25-3.76 7.36-8.32 20.24-5.56-10.88 1.95-19.57 4.48-20.24 5.56zM563.46 315.11c-3.14 1.47-8.45-5.88-7.89-17.88 3.36 9.74 6.83 17.38 7.89 17.88z'/%3e%3cpath d='M563.88 301.59c-4.23 2.2-11.3-7.36-10.47-23.52 4.4 12.85 9.05 22.9 10.47 23.52zM511.19 376.66c2.02-4.15 13.15-1.38 21.98 10.89-11-6.75-20.49-11.3-21.98-10.89z'/%3e%3c/g%3e%3cg fill='%23406325'%3e%3cpath d='M521.55 365.83c4.54 1.6 10.44-9.42 7.54-25.88-2.81 13.95-6.18 25.06-7.54 25.88z'/%3e%3cpath d='M531.83 360.59c4.34-6.65 5.55-24.55 4.58-26.97-9.94 13.6-9.41 26.33-4.58 26.97zM500.14 378.13c-2.12 4.08 6.7 11.44 21.79 11.31-11.95-4.88-21.24-9.86-21.79-11.31zM500.3 370.08c3.79 3.34 13.8-4.95 17.4-22.08-8.12 12.42-15.71 21.8-17.4 22.08zM543.01 351.43c1.8 3.92 12.7.92 21.65-11.15-10.89 6.83-20.25 11.51-21.65 11.15zM568.76 298.1c3.3 2.15 10.34-5.3 11.56-18.8-5.21 10.4-10.26 18.4-11.56 18.8zM557.07 336.21c.9 4.35 12.45 4.18 24.31-5.5-12.5 3.97-23 6.22-24.31 5.5zM567.43 311.57c2.45 3.4 11.87-1.33 17.66-14.35-8.6 8.37-16.28 14.44-17.66 14.35zM565.92 266.01c4.24 2.02 11.06-7.95 9.9-24.1-4.08 13.14-8.46 23.42-9.9 24.1zM558.96 240.14c3.54.1 5.41-9.03-.13-20 .95 10.5.9 19.08.13 20zM554.73 237.9c3.97-1.74 1.33-12.71-10.42-21.97 6.47 11.02 10.85 20.57 10.42 21.97zM566.34 272.57c3.17 2.97 10.14-1.06 14.15-15.33-7.8 10.08-12.68 15.17-14.15 15.33zM532.25 362.48c1 5.25 14.91 5 29.13-6.69-14.94 4.85-27.5 7.6-29.13 6.69z'/%3e%3cpath d='M539.14 354.75c3.27-4.93 4.27-18.27 3.56-20.08-7.48 10.08-7.16 19.57-3.56 20.08zM558.74 326.14c3.57-5.79 3.88-20.9 2.92-22.96-8.26 11.81-7.25 22.59-2.92 22.96z'/%3e%3c/g%3e%3cg fill='%2367923d'%3e%3cpath d='M531.79 360.54c-4.83-.64-5.33-13.31 4.55-26.87-3.62 13.85-5.46 25.44-4.55 26.87zM566.95 292.21c-.94-7.76 3.98-20.14 6.63-22.52 2.58 14.38-2.66 23.95-6.63 22.52zM539.11 354.7c-3.6-.5-3.9-9.95 3.54-20-2.78 10.3-4.21 18.93-3.54 20zM562.47 250.46c-2.17-5.88.03-20.04 1.24-21.77 5.28 12.25 2.63 22.11-1.24 21.77zM504.39 370.61c2.47-8.1 16.2-21.08 18.8-21.91-4.33 17.42-15.06 25.52-18.8 21.91zM558.92 329.02c2.66-6.26 14.8-15.46 16.98-15.84-4.94 13.64-14.25 19.14-16.98 15.84zM558.8 325.99c-4.33-.37-5.33-11.04 2.93-22.85-2.66 11.86-3.79 21.68-2.93 22.85z'/%3e%3c/g%3e%3cpath fill='%23406325' d='M567 294.04c5.16 1.84 9.08-9.89 6.6-23.91-2.43 12.06-5.38 23.2-6.6 23.91z'/%3e%3cpath fill='%23406325' d='M567.77 293.64c.56-7.53-6.93-23.09-8.92-24.7-2.01 15.8 4.47 26.3 8.92 24.7zM562.55 250.42c3.83.34 6.47-9.43 1.19-21.69.33 11.45-.29 20.75-1.19 21.69zM504.5 370.53c3.79 3.62 14.37-4.42 18.7-21.84-8.84 12.35-16.96 21.61-18.7 21.84zM559.14 329.04c2.74 3.3 11.93-2.16 16.87-15.83-8.13 9.1-15.47 15.8-16.87 15.83z'/%3e%3cpath fill='%2367923d' d='M567.66 293.53c-4.41 1.64-10.85-8.76-8.83-24.56 3.5 13.26 7.44 23.76 8.83 24.56z'/%3e%3c/g%3e%3cg fill='%23ba1f3e' stroke='%23511124' stroke-width='.22'%3e%3ccircle cx='564.63' cy='254.9' r='1.08'/%3e%3ccircle cx='568.41' cy='266.82' r='1.08'/%3e%3ccircle cx='569.76' cy='304.3' r='1.28'/%3e%3ccircle cx='564.65' cy='297.29' r='1.28'/%3e%3ccircle cx='549.91' cy='337.17' r='1.28'/%3e%3ccircle cx='556.2' cy='339.9' r='1.28'/%3e%3ccircle cx='513.8' cy='372.26' r='1.28'/%3e%3ccircle cx='506.8' cy='377.29' r='1.28'/%3e%3ccircle cx='557.05' cy='249.25' r='1.08'/%3e%3c/g%3e%3c/g%3e%3cg id='b' fill='%238c959d' stroke='%23485654' stroke-width='.11'%3e%3cpath d='M434.25 336.27c-.13 1.07.84 2.34 2.13 2.07.38-.08.62-.58.13-.49-.43.1-.88-.07-1.2-.37a1.68 1.68 0 0 1-.4-1.92l-.66.7v.01z'/%3e%3cpath stroke='none' d='M437.24 338.34c-1.02 1.17-2.57 1.68-3.43.83-.57-.56-.77-1.2-.47-1.9l-1.12 1.22c.05.1.72 1.31 1.71 1.76 1.22.55 2.97-.28 4.02-1.56.74-.91 1.56-2.43.97-3.61a3.98 3.98 0 0 0-1.97-1.7l-1.03 1.1c.51-.24 1.15-.13 1.7.31 1.27 1.04.53 2.5-.38 3.55z'/%3e%3cpath fill='%23485654' stroke='none' d='M437.24 338.34a4 4 0 0 1-1.16.96c-.45.23-.96.39-1.47.31-.26-.03-.51-.13-.72-.3-.2-.16-.37-.35-.5-.57a1.61 1.61 0 0 1-.25-.74c-.02-.26.04-.53.14-.77l.12.08-1.11 1.24.01-.1c.28.48.63.94 1.05 1.3a1.99 1.99 0 0 0 1.5.57c.53-.01 1.07-.2 1.56-.47a5.1 5.1 0 0 0 1.3-1.05c.37-.41.69-.88.93-1.38.24-.5.41-1.05.38-1.6a1.83 1.83 0 0 0-.23-.77c-.13-.24-.3-.46-.5-.66-.39-.4-.86-.72-1.37-.93l.1-.02-1.04 1.09-.09-.12c.24-.1.5-.14.76-.11.25.02.5.11.71.24.43.26.8.65.93 1.14.13.5 0 1.01-.21 1.45a5.1 5.1 0 0 1-.84 1.2v.01zm0 0c.31-.38.6-.78.8-1.23.19-.44.3-.94.16-1.4-.13-.46-.5-.83-.9-1.06-.4-.24-.92-.3-1.34-.1l-.09-.12 1.02-1.11.04-.04.05.02a4.17 4.17 0 0 1 1.98 1.66c.15.25.23.55.25.85.05.6-.13 1.17-.38 1.7-.25.52-.58 1-.96 1.44-.4.43-.85.8-1.36 1.08a3.7 3.7 0 0 1-1.67.5 2.2 2.2 0 0 1-1.62-.63 5 5 0 0 1-1.07-1.37l-.03-.05.04-.05 1.13-1.22.12.08c-.1.22-.15.46-.14.7.01.24.1.48.22.68.12.21.29.4.47.56.19.16.42.25.66.3.49.08 1-.06 1.43-.28.45-.22.85-.54 1.19-.91z'/%3e%3cpath fill='%236c301e' stroke='%23351710' stroke-width='.22' stroke-linejoin='round' d='M515.24 249.25l-40.14 39.52c-3.05 3.03-37.96 36.37-41.1 39.38-1.1 1.32-4.23 4.86-4.56 5.35-2.13 2.31-4.44 5.33-7.2 8.03-.5.62-1.14.4-1.73.74a23.38 23.38 0 0 0-5.06 4.37l-12.2 13.5c-.8.86-1 1.39-.47 1.88l6.62 8.85c1.23 1.2 2.65 1.83 3.2.81 3.15-5.44 10.96-13.75 13.91-20.33 1.77-3.93 3.98-11.06 5.56-12.78 1.94-2.16 7.17-7.73 11.8-12.7l.94-1 .94-1.02c23.51-23.95 50.72-53.05 70.53-73.56-.78-.78-.29-.31-1.04-1.04z'/%3e%3cpath d='M431.89 328.11c-1.23.04-2.02-.7-2.85-1.4 1.17.35 2.35.8 3.45.34l-.6 1.06z'/%3e%3cpath fill='%23b2b6ba' stroke-width='.22' d='M557.05 220.1l-31.8 26.22c-.31.37-.63.27-.93 0l-2.9-2.42.02-.1c0-.17-.04-.33-.09-.47l1.42-1.45c.18-.22.12-.3-.12-.55l-.59-.6c-.22-.17-.41-.03-.64.18L520 242.4c-.74.03-1.33.63-1.35 1.36-19.24 18.73-35.8 35.44-54.94 53.87l-22.57 21.55c-.81 1.05-4.3 2.91-6.6 4.41a5.63 5.63 0 0 0-1.82 1.55l-1.84 5.43c-.58 1.2-2.43 4-2.51 4.2 2.36 2.38 2.24 2.2 3.86 3.72 1.82-2.02 6.7-7.1 11.12-11.85.35-.38.38-.42.83-.97a13.32 13.32 0 0 0-2.6-2.74l-.62-.55c-.17-.16.24-.44.42-.64 26.47-25.58 54.96-53.7 78.28-76.6a1.41 1.41 0 0 0 1.02-.1l2.79 3.22c.65.65 1.2.63 1.73.4l31.86-28.55z'/%3e%3cpath fill='%23485654' stroke='none' d='M430.95 330.39c.2.03.4.05.6.03.2-.02.4-.07.58-.16l-.02.02a139.62 139.62 0 0 1 1.47-4.74l.01.02c-.2-.22-.43-.42-.73-.5.3.06.56.25.77.46l.01.02v.01l-.71 2.38-.75 2.37v.01h-.02c-.19.1-.4.15-.6.15-.2 0-.41-.03-.61-.07z'/%3e%3ccircle fill='none' stroke-width='.16' cx='438.18' cy='328.13' r='.62'/%3e%3ccircle fill='none' stroke-width='.16' cx='434.44' cy='331.88' r='.62'/%3e%3cpath fill='%23485654' stroke='none' d='M440.97 322.38a11.74 11.74 0 0 1-1.74-1.63 11.63 11.63 0 0 1 1.74 1.63z'/%3e%3cpath d='M502.17 259.06l3.49 3.41.64-.59-3.48-3.4-.65.58z'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='scale(-1 1) rotate(-2.84 -9.26 19640.24)'/%3e%3cg stroke='%2324420e' stroke-width='.16'%3e%3cpath fill='%2367923d' d='M433.91 365.36c-7.87-3.32-26.89-.67-29.22.93 16.29 8.01 29.54 4.58 29.22-.93zM522.93 368.68c7.87-3.32 26.89-.67 29.22.93-16.29 7.98-29.54 4.58-29.22-.93z'/%3e%3cpath fill='%23406325' d='M433.76 365.48c.32 5.5-12.79 8.89-29.07.9 15.29.94 27.79.38 29.07-.9zM523.08 368.77c-.32 5.5 12.79 8.89 29.07.9-15.29.94-27.79.41-29.07-.9z'/%3e%3c/g%3e%3cg id='c'%3e%3cpath fill='%23b2b6ba' stroke='%23485654' stroke-width='.22' d='M508.49 359.99c-20.73-30.12-52-54.61-76.1-68 3.55-.16 11.46 3.89 14.67 5.96 23.94 15.42 44.3 35.8 65.66 59.82a35.2 35.2 0 0 1-3.44 3.05l-.79-.83z'/%3e%3cpath fill='%238c959d' d='M510.55 359.75l-1.45 1.4C486.09 331.51 454 303.2 432.43 292c30.08 13.86 55.4 41.77 78.03 67.65l.09.09z'/%3e%3cpath fill='%23485654' d='M510.56 359.75l-1.45 1.4a302.96 302.96 0 0 0-16.87-19.73 336.02 336.02 0 0 0-18.37-18.34 284.92 284.92 0 0 0-19.8-16.76 195.86 195.86 0 0 0-10.55-7.56c-3.6-2.4-7.3-4.66-11.13-6.65l.1-.2c7.89 3.65 15.33 8.2 22.37 13.29a210.61 210.61 0 0 1 20.03 16.63 359.99 359.99 0 0 1 18.33 18.5c5.9 6.36 11.63 12.89 17.34 19.42za897.45 897.45 0 0 0-17.42-19.35c-5.92-6.35-12-12.56-18.35-18.47-6.36-5.9-13-11.51-20.04-16.59a134.67 134.67 0 0 0-22.36-13.23l.1-.2c3.84 2 7.54 4.28 11.14 6.68 3.6 2.4 7.11 4.95 10.55 7.58a284.86 284.86 0 0 1 19.8 16.8 336.06 336.06 0 0 1 18.34 18.37 302.66 302.66 0 0 1 16.8 19.8h-.01l1.45-1.39z'/%3e%3cg fill='%23fab81c' stroke='%236c301e' stroke-width='.11'%3e%3cpath stroke-width='.22' d='M517.5 355.07a18.32 18.32 0 0 0-5.26 2.23c-.23 1.4-1.95 2.95-3.58 3.3l-.6-.76a.13.13 0 0 0-.17-.04 6.9 6.9 0 0 0-.57.34c-.6-.1-1.34.2-1.66.97-.38.97.39 2.25 1.23 3.09.92.73 1.38 1.07 2.45.92 1.09-.23 1.68-1.22 1.93-1.53 3.72 4.5 6.52 6.93 11.23 10.64 2.1.02 3.22-1.3 2.52-2.8-.23-.5-.84-.84-1.33-.66.04-.15.02-.3 0-.45 2.46-2.26 3.5-5.08.91-9.87-2.22-4.03-4.71-5.4-7.09-5.38h-.01zm6.25 4.53c.43.74.69 1.38 1.02 2.05 1.48 3 .2 6.6-2.33 7.71-.13 0-.09-.02-.22.02.42-.69-.82-2.15-1.46-1.64.3-.76-.67-2.02-1.46-1.7.42-.7-.53-1.9-1.42-1.5.46-.77-.32-1.87-1.24-1.67.27-.82-.42-1.76-1.35-1.6.07-.72-.16-1.12-.51-1.45 1.11-.85 2.35-2.15 3.44-2.74 2.72-1.18 4.4 1.07 5.52 2.52z'/%3e%3cpath d='M524.89 362.77c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3e%3cpath d='M524.59 361.75c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3e%3cpath d='M523.97 360.62c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3e%3cpath d='M523.19 359.6c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.44-1.26.2v-.01z'/%3e%3cpath d='M522.16 358.61c-.52-.25-.76-.76-.59-1.1.03-.05.01-.14.06-.12.2.1.64.19.6-.14-.07-.1-.15-.22-.07-.14.14 0 .46.14.63.22.52.26.8.75.63 1.1-.17.33-.74.44-1.26.19v-.01z'/%3e%3c/g%3e%3cg fill='%23fab81c'%3e%3cpath d='M511.27 363.6c.68-1.77 2.05-3.41 3.5-3.8M511.5 363.85c1.26.26 3.3-1.24 3.8-2.59M512.69 365.3c1.66.38 3.3-1.22 3.93-2.4M514.18 366.88c1.96.06 3.16-1.33 3.74-2.39M515.69 368.41c1.66.01 3.17-1.36 3.65-2.42M517.15 369.81c1.8-.07 3.08-.9 3.62-2.07M518.79 371.23c1.66.1 3-.9 3.44-1.86M520.57 372.68c1.66.1 2.7-.93 3.14-1.9'/%3e%3c/g%3e%3cg fill='%236c301e'%3e%3cpath d='M511.27 363.6a7.03 7.03 0 0 1 2.3-3.24c.36-.26.77-.47 1.2-.57-.42.14-.8.37-1.16.63-.35.27-.66.58-.95.92a9.24 9.24 0 0 0-1.39 2.26zM511.5 363.85c.4.06.8-.04 1.18-.2a5.65 5.65 0 0 0 1.95-1.4c.27-.29.51-.62.68-.99-.13.4-.36.74-.62 1.06a5.26 5.26 0 0 1-1.98 1.42 2.1 2.1 0 0 1-1.21.11zM512.69 365.3c.4.07.82.04 1.2-.09.39-.12.75-.3 1.08-.54a6.24 6.24 0 0 0 1.65-1.77 5.2 5.2 0 0 1-1.6 1.86c-.33.23-.7.43-1.1.53-.4.11-.84.13-1.23.01zM514.18 366.88a3.83 3.83 0 0 0 2.18-.69c.32-.21.6-.48.86-.76.26-.3.5-.6.7-.94-.33.7-.85 1.34-1.5 1.79a3.37 3.37 0 0 1-2.24.6zM515.69 368.41a4.1 4.1 0 0 0 2.11-.77 5.16 5.16 0 0 0 1.54-1.65c-.14.36-.36.68-.61.97a4.25 4.25 0 0 1-1.9 1.29c-.37.12-.76.18-1.14.16zM517.15 369.81c.36-.04.73-.1 1.08-.19a4.63 4.63 0 0 0 1.89-1.01c.26-.26.48-.55.65-.87-.13.34-.34.65-.6.93a3.5 3.5 0 0 1-.88.66c-.66.34-1.4.5-2.14.48zM518.79 371.23a4.54 4.54 0 0 0 1.97-.48c.3-.15.58-.35.84-.58s.47-.5.63-.8c-.12.32-.33.61-.58.86a3.58 3.58 0 0 1-2.86 1zM520.57 372.68c.33 0 .65-.04.96-.12a3.3 3.3 0 0 0 1.62-.99c.22-.23.4-.5.56-.79a2.96 2.96 0 0 1-3.14 1.9z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23c' transform='scale(-1 1) rotate(-3.41 -13.8 16470.84)'/%3e%3cg stroke='%2324420e' stroke-width='.16'%3e%3cpath fill='%23406325' d='M409.24 240.02c7.21-2.37 18.73-15.45 19.48-17.92-15.6 4.16-22.76 14.35-19.48 17.92zM554.98 244.72c-1.7-7.04-13.28-19.01-15.57-19.91 2.77 15.16 11.92 22.76 15.57 19.91z'/%3e%3cpath fill='%2367923d' d='M409.24 240.02c-3.32-3.57 3.8-13.67 19.34-17.82-10.96 8.4-19.2 16.18-19.34 17.82zM554.98 244.72c-3.66 2.9-12.72-4.65-15.49-19.77 7.17 11.07 13.94 19.51 15.49 19.77z'/%3e%3c/g%3e%3cg stroke='%23999270' stroke-width='.16'%3e%3cpath fill='url(%23d)' d='M452.21 318.1s-6.16.66-7.88-7.83c-1.85-9.09 5.3-10.06 5.3-10.06s8.1-.78 13.15-.9l2.24 17.95-12.81.84z'/%3e%3cpath fill='url(%23e)' d='M453.02 315.36s-3.98.76-4.8-5.55c-.59-4.48 2.18-5.11 2.18-5.11l9.23 1.56.05 8.24-6.66.86z'/%3e%3cpath fill='url(%23f)' d='M450.4 304.7s5.9-.43 8.99-.83l1.28 5.71-7.1.45s-.49-5.16-3.17-5.33z'/%3e%3cpath fill='url(%23g)' d='M449.16 300.36s7.58-1.86 8.52 6.49c.24 2.18-.94 7.17-4.66 8.51l13.88-1.45-1.26-15.01-4.68.39s-9.92.34-11.8 1.07z'/%3e%3cpath fill='%23f9f0aa' d='M452.2 318.1c.05 0 51.9-3.5 57.22-3.27 15.74-8.64-.08-42.56-13.35-61.54 1.52-4.27-29.85-13.89-44.04-13.02-1.78.1-3.5.23-5.16.35-7.7.82-7.77 10.7-4.63 16.93 3.04 6.04 30.31 55.12 11.14 60.31l-1.18.24z'/%3e%3cpath fill='url(%23h)' d='M507.79 273.34a148.36 148.36 0 0 0-11.72-20.05c1.52-4.27-29.86-13.89-44.04-13.02-1.79.1-3.51.23-5.16.35-7.7.82-7.77 10.7-4.64 16.93.96 1.9 4.3 8.04 7.85 15.73'/%3e%3cpath fill='url(%23i)' d='M455.04 284.95c5.55 14.65 8.66 30.12-1.64 32.9l-1.18.24c.05 0 51.9-3.49 57.22-3.27 8.54-4.68 7.8-16.8 3.2-29.94'/%3e%3cpath fill='url(%23j)' d='M447.4 243.49c-3.7 0-4.66 3.56-4.6 5.82.13 5.9 4.6 6.19 4.6 6.19l5.96-.33 2.86-12.17-8.82.49z'/%3e%3cpath fill='url(%23k)' d='M447.4 243.53l8.82-.49.91 9.09-7.7.34s2.5-7.28-2.03-8.94z'/%3e%3cpath fill='url(%23l)' d='M496.12 253.29c6.69-1.07 6.6-10.07 2.03-13.67-15.5-.57-35.9-.15-50.63.96 1.67-.05 6.33.37 6.85 6.5a8.2 8.2 0 0 1-3.06 7 6.93 6.93 0 0 1-3.9 1.45c.24.1 2.16.01 3.6-.08.73-.05 2.54-.27 3.05-.33 21.01-2.76 41.99-1.83 41.99-1.83h.07z'/%3e%3cg fill='%23b07e09' stroke='none'%3e%3cpath d='M458.47 267.42c-.14-.33-.32-.75-.73-.8-.25 0-.65-.06-.57-.4.24-.11.54-.04.8-.06.56 0 1.11-.12 1.67-.15.34.1.26.54-.1.46-.41.1-.18.57-.08.81.44 1.04.87 2.08 1.33 3.1.12.31.38.58.72.61.36.04.75.05 1.09-.11.3-.2.24-.63.2-.94-.13-.36.54-.28.5.04.12.43.27.86.44 1.27-.02.2-.28.15-.42.17-1 .08-1.99.13-2.98.22-.32-.01-.8.28-.99-.1-.12-.38.51-.16.6-.45 0-.33-.2-.62-.31-.92l-1.17-2.75zM463.3 267.08c-.14-.32-.3-.72-.69-.8-.24-.02-.65-.01-.61-.37.15-.16.45-.06.67-.1.59.03 1.17-.08 1.76-.14.29-.02.4.52.02.45-.35.01-.38.4-.23.65.47 1.14.96 2.28 1.44 3.41.1.25.24.55.54.59.25.05.65-.03.7.32-.04.26-.43.11-.63.16a6.58 6.58 0 0 0-1.55.12c-.23.06-.55.02-.56-.27.05-.28.58-.07.6-.4-.03-.33-.2-.62-.32-.93l-1.14-2.69zM467.76 267.79c.09.23.4.06.59.08.26-.03.54-.22.51-.51-.04-.45-.26-.91-.63-1.19-.34-.24-.78-.21-1.17-.16-.02.16.1.3.15.45l.55 1.33zm.67 1.6c.16.35.28.74.56 1.01.25.17.57.1.85.07.3-.02.48-.33.38-.61-.14-.64-.55-1.3-1.24-1.44-.3-.05-.61-.06-.91 0-.02.15.09.3.13.43l.23.54zm-2.04-2.38c-.15-.34-.3-.76-.68-.92-.25-.08-.65.03-.7-.32.06-.3.56-.1.8-.16.86-.03 1.74-.27 2.6 0 .73.17 1.39.8 1.44 1.58.03.38-.26.68-.58.84-.04-.14.37.06.5.08.6.19 1.13.58 1.39 1.14.2.4.35.93.04 1.32-.36.4-.94.41-1.44.43-.75.02-1.5.03-2.25.18-.26.04-.45-.48-.08-.45.37-.02.4-.42.24-.67l-1.28-3.05zM473.81 265.11c.33-.05.36.32.46.53.1.29.27.54.35.83-.28.28-.5-.14-.63-.36-.14-.24-.38-.47-.69-.45-.4 0-.81.02-1.22.07-.14.16.07.4.12.58.19.45.36.9.56 1.34.27-.02.62.02.81-.2.08-.24-.27-.75.21-.65.3.17.26.6.42.89.12.38.38.72.49 1.11-.26.29-.53-.13-.62-.36-.19-.35-.63-.3-.96-.3-.24-.05-.08.17-.04.28.21.5.38 1.01.66 1.48.2.34.65.3 1 .28.32-.02.72-.03.92-.34.21-.25-.28-.75.13-.83.35-.03.34.38.43.6.07.29.18.56.28.83-.02.2-.28.14-.42.16-1.02.07-2.04.11-3.06.2-.3 0-.8.23-.9-.2.02-.3.64-.14.55-.55-.07-.35-.25-.66-.37-1-.38-.89-.73-1.8-1.12-2.68-.14-.3-.37-.62-.73-.63-.24.04-.6-.13-.47-.41.35-.07.72-.02 1.07-.06l2.77-.16zM476.12 266.43c-.15-.35-.3-.77-.68-.93-.26-.08-.72.01-.7-.4.25-.18.66-.03.97-.08.8-.01 1.62-.24 2.41 0 .82.23 1.52.97 1.57 1.84.03.41-.3.75-.68.86-.3.02.23.1.3.2.64.3 1.08.87 1.41 1.47.08.23.52.7.59.25-.03-.5.64-.08.49.26 0 .36-.35.59-.68.58-.47.04-.9-.23-1.14-.62-.42-.55-.71-1.22-1.27-1.66-.23-.17-.56-.27-.83-.15-.05.14.07.28.1.41.19.41.31.85.55 1.22.2.31.6.36.94.36.36.09.25.58-.13.43-.58 0-1.17-.04-1.75.08-.27.13-.87.01-.65-.37.28-.02.67-.17.48-.53-.33-.87-.7-1.73-1.05-2.6l-.25-.62zm1.4.9c.14.32.6.14.87.1.35-.07.34-.5.23-.77-.16-.47-.37-1.03-.9-1.2-.25-.03-.84-.2-.88.16.2.53.43 1.05.63 1.58l.05.12zM484.74 269.04c.1.26.21.61.54.66.25.05.66-.03.71.33-.04.26-.43.1-.63.14a7.1 7.1 0 0 0-1.6.08c-.24.07-.56-.03-.53-.32.13-.2.65-.03.62-.4-.08-.4-.27-.77-.41-1.15l-1.15-2.88c-.1-.31-.45-.3-.7-.28-.28 0-.69.06-.69.41-.08.23.22.62-.04.74-.3.06-.36-.28-.43-.5-.1-.31-.26-.6-.38-.92.03-.21.32-.17.49-.2l4.13-.16c.3-.05.5.19.52.47.1.34.27.66.41.98-.11.33-.5.04-.55-.2-.2-.35-.51-.7-.94-.7-.26 0-.64-.1-.82.14.01.24.15.45.22.67l1.23 3.09zM488.47 268.13c-.2 0-.1.24-.12.37.01.28-.02.57.03.85.13.3.53.23.79.31.23.13.17.5-.14.4-.42-.03-.85-.08-1.27.02-.25.14-.71-.12-.49-.39.2-.03.45-.1.5-.33.07-.42.03-.84.04-1.26l.02-3.71c.12-.28.52-.05.6.16 1.2 1.52 2.38 3.05 3.6 4.54.2.23.46.4.77.42.26 0 .4.53.03.42-.52-.03-1.03-.06-1.54.03-.23 0-.5.1-.7-.03-.24-.17-.07-.43.2-.4.35-.1 0-.48-.12-.65-.19-.26-.38-.52-.59-.75-.17-.09-.37-.03-.55-.04l-1.06.04zm1.17-.51c.19.01-.05-.16-.08-.24l-1.28-1.66c.09-.01.02.18.04.26v1.68l1.32-.04zM492.7 265.77c-.15-.4-.35-.89-.82-.98-.24.04-.7-.18-.45-.44.55 0 1.1.03 1.65-.02.7-.06 1.42-.04 2.08.2a4.35 4.35 0 0 1 2.92 3.33c.1.6-.08 1.3-.63 1.64-.73.47-1.64.38-2.47.33-.47-.02-.94.04-1.4.09-.3-.04-.34-.51.02-.46.37 0 .37-.42.23-.66l-1.13-3.03zm1.97 2.5c.15.33.24.75.56.97.3.14.66.12.98.08.44-.06.72-.5.72-.91a4.27 4.27 0 0 0-.63-2.13 2.65 2.65 0 0 0-1.84-1.37c-.33-.05-.67-.1-1-.05-.07.13.06.27.1.4l1.11 3zM473.56 280.68c.12.35.44.6.8.63.26.05.7-.01.72.36-.14.23-.53.07-.77.12-.52 0-1.04 0-1.55.1-.28 0-.57.12-.84.04-.24-.12-.2-.47.1-.43.26-.05.61-.13.63-.44-.02-.29-.18-.54-.28-.8l-1.15-2.75c-.09-.33-.45-.34-.71-.29-.25.05-.62.13-.68-.22.03-.29.5-.24.7-.39.31-.12.62-.25.94-.35.22-.05.32.15.38.32l1.71 4.1zM474.31 276.17c.68-.03 1.37.08 2.05 0 .3-.03.1-.5.38-.47.37.02.31.48.33.74a.52.52 0 0 1-.56.58c-.54.03-1.07-.05-1.6-.02.12.42.29.81.44 1.21.03-.13.46-.15.64-.18a2.78 2.78 0 0 1 2.61 1.54c.22.48.33 1.1-.02 1.55-.4.45-1.03.54-1.6.55-.49 0-1.06-.11-1.35-.55-.17-.22-.14-.68.22-.64.3 0 .66.26.6.6.17.22.53.14.78.13.3 0 .59-.24.57-.55 0-.49-.18-.97-.45-1.36-.3-.43-.78-.71-1.3-.7-.3-.05-.55.15-.83.15-.29-.04-.34-.37-.44-.58-.23-.6-.46-1.2-.65-1.82-.02-.1.08-.2.18-.18zM481.16 277.19c-.16-.4-.37-.88-.84-.97-.24.06-.7-.17-.46-.43.55-.02 1.11 0 1.67-.07.7-.08 1.43-.07 2.1.18 1.5.5 2.71 1.82 2.94 3.39.09.58-.11 1.24-.63 1.56-.72.47-1.61.4-2.43.38-.45 0-.9.07-1.34.13-.3-.04-.36-.5 0-.46.38-.03.35-.45.2-.69l-1.21-3.02zm2.03 2.46c.16.34.26.75.59.97.3.14.65.1.97.05.44-.07.69-.52.68-.94 0-.76-.32-1.48-.7-2.13a2.64 2.64 0 0 0-1.86-1.33 3 3 0 0 0-.98-.02c-.07.13.06.27.1.4l1.2 3zM489.63 275.39c.31-.05.35.3.44.5.1.29.24.55.34.84-.19.3-.5-.06-.59-.29-.14-.24-.35-.52-.67-.5-.41-.03-.82 0-1.23.03-.23.1.01.39.05.56.18.45.35.92.54 1.36.27 0 .58.01.8-.15.18-.21-.27-.74.21-.68.33.12.28.57.42.84.12.4.35.74.49 1.14-.18.33-.54-.06-.6-.3-.14-.33-.51-.37-.82-.36-.2-.03-.37.01-.23.22.22.51.38 1.05.66 1.54.2.35.65.3 1 .3.32-.01.73 0 .93-.32.2-.24-.2-.66.08-.8.34-.1.42.27.47.51.08.31.18.6.29.9-.03.2-.28.14-.43.16-1.03.04-2.06.06-3.09.12-.28-.01-.69.21-.87-.1-.18-.4.5-.19.53-.53.03-.3-.15-.58-.25-.86-.38-.96-.75-1.94-1.14-2.9-.14-.31-.36-.66-.74-.68-.24.04-.6-.13-.46-.4.36-.07.73-.01 1.1-.04l2.77-.11zM462.35 289.67c.15.49.67.69 1.11.82.77.26 1.6.52 2.15 1.16.3.37.52.85.5 1.34-.04.5-.47.87-.93.99-.57.18-1.2.13-1.73-.1-.27-.11-.17.47-.5.27-.24-.18-.16-.56-.3-.81-.1-.33-.24-.65-.38-.97.01-.32.48-.15.5.1.32.6.92 1.12 1.63 1.13.36 0 .8-.18.83-.59.01-.53-.41-.95-.86-1.18-.64-.33-1.38-.44-2-.81a1.94 1.94 0 0 1-.94-1.61c.01-.44.37-.78.77-.9.5-.17 1.05-.2 1.56-.06.24.13.34-.27.6-.07.11.2.08.46.2.67.07.29.26.54.33.82-.16.25-.47.02-.52-.2-.22-.36-.52-.77-.98-.8-.35-.03-.79-.03-1.01.29-.1.15-.1.35-.03.51zM469.04 288.02c.33-.06.34.31.42.53.08.27.2.53.29.8-.14.28-.5.02-.54-.21-.14-.26-.34-.58-.67-.56-.41 0-.82.03-1.23.08-.23.1 0 .39.03.57l.46 1.36c.27-.02.58-.01.8-.18.2-.2-.19-.6.14-.7.38-.05.35.44.44.68.1.45.33.85.46 1.29-.14.32-.53.01-.55-.25-.1-.33-.48-.4-.79-.37-.17 0-.42 0-.27.22.18.5.32 1.02.55 1.5.12.3.45.35.73.33.39-.03.84.01 1.15-.28.24-.24.04-.59.1-.85.24-.2.52.06.5.34.06.34.15.68.26 1.02-.04.2-.3.14-.44.17-1.02.08-2.04.13-3.06.23-.28-.02-.68.23-.85-.1-.16-.37.45-.2.53-.5.09-.29-.1-.57-.17-.85-.33-.98-.65-1.96-1-2.94-.12-.3-.33-.66-.7-.66-.24.06-.6-.13-.43-.4.35-.07.71-.03 1.07-.07l2.77-.2zM473.22 292.16c.1.3.27.64.61.7.25.09.67-.07.73.29 0 .32-.49.15-.7.2-.52-.03-1.03 0-1.53.1-.22.04-.55.11-.6-.18-.06-.34.45-.15.56-.4.08-.26-.06-.52-.13-.77-.34-1-.66-2.01-1.01-3.01-.11-.3-.27-.68-.63-.71-.23-.01-.63-.03-.56-.37.18-.16.49-.05.71-.08.74.01 1.45-.2 2.19-.15.75.03 1.48.51 1.73 1.23.17.4.22.92-.08 1.28-.39.45-1.02.55-1.58.62-.21-.03-.04.2-.03.3l.32.95zm-.57-1.72c.2.03.46-.03.67-.08.32-.07.48-.4.4-.7a2.24 2.24 0 0 0-.54-1.17c-.3-.26-.75-.26-1.12-.17-.13.12 0 .32.04.47l.55 1.65zM478.8 291.87c.09.25.17.61.5.65.24.06.65-.03.68.32-.06.27-.44.12-.64.16a7.09 7.09 0 0 0-1.6.1c-.23.09-.55-.01-.5-.3.14-.22.65-.05.64-.42-.05-.39-.21-.75-.33-1.13l-.95-2.9c-.07-.31-.43-.3-.68-.27-.25.02-.62.05-.69.35-.08.25.04.53-.01.78-.24.16-.47-.1-.46-.33-.08-.35-.2-.68-.34-1-.01-.24.3-.22.47-.24l4.15-.25c.3-.05.49.19.48.47.08.34.22.66.34.98-.06.28-.48.13-.5-.12-.17-.36-.44-.74-.87-.76-.28 0-.63-.06-.86.12-.05.2.08.4.13.6l1.04 3.19zM480.9 288.58c-.1-.3-.22-.7-.57-.79-.24-.06-.65.01-.63-.35.1-.22.42-.09.61-.12.6.02 1.2-.06 1.79-.12.26-.12.48.42.15.42-.25 0-.55.19-.44.47.13.53.32 1.05.48 1.57.24.73.47 1.47.72 2.2.07.23.25.43.5.44.24 0 .66.04.59.38-.18.16-.48.06-.71.08-.54-.04-1.07.05-1.6.11-.24.1-.54-.13-.4-.37.2-.1.65-.05.62-.39-.08-.4-.24-.8-.36-1.2l-.75-2.33zM486.66 286.98c.32-.06.33.3.4.52.08.27.2.54.28.81-.14.29-.5.02-.53-.22-.13-.26-.33-.57-.67-.56-.4-.01-.82.02-1.23.05-.23.1-.01.4.02.57.14.45.28.91.44 1.36.27-.01.58 0 .8-.16.2-.2-.18-.61.16-.7.37-.03.34.45.42.7.09.45.32.85.44 1.29-.11.29-.52.04-.52-.22-.1-.32-.43-.45-.74-.42-.15.02-.5-.07-.36.17.17.52.3 1.05.53 1.55.12.28.45.35.73.33.4-.02.85.03 1.16-.26.25-.22.05-.58.11-.84.26-.2.53.07.5.35.06.34.15.68.25 1.02-.05.2-.28.14-.43.16-1.03.05-2.07.1-3.1.17-.27-.02-.64.2-.83-.07-.22-.39.38-.25.5-.48.14-.27-.04-.55-.1-.81l-.96-3c-.12-.31-.32-.7-.7-.7-.25.05-.6-.15-.43-.41.34-.07.7-.02 1.05-.05l2.81-.15zM488.66 287.94c-.07-.36-.34-.68-.73-.62-.38.1-.5-.57-.04-.43.51 0 1.03-.08 1.53.03.25.27.44.58.66.86l2.17 2.9c-.15.04-.03-.18-.05-.3l.36-3.54c.27-.22.73-.13 1.07-.2.29-.04.93-.13.75.35-.34.06-.77.22-.54.65.36 1.2.74 2.39 1.12 3.58.07.41.49.54.86.52.31.02.33.57-.05.43-.6 0-1.2-.04-1.78.07-.27.09-.82.06-.64-.36.3-.05.8-.14.58-.57-.31-1.06-.65-2.11-.98-3.17.07.1-.01.25 0 .38-.1.99-.23 1.97-.3 2.97-.04.26.05.57-.07.8-.24.1-.39-.12-.5-.28l-2.86-3.7c.1-.04.09.2.14.3.3.95.59 1.92.91 2.87.1.39.5.5.85.5.38.2.1.55-.23.41-.5-.07-1 .03-1.5.08-.3 0-.32-.5.03-.44.47 0 .33-.53.22-.8l-1.02-3.28.04-.01zM497.4 288.79c.06.22.36.07.53.1.28-.02.62-.18.63-.5.01-.44-.16-.9-.5-1.19-.33-.25-.77-.23-1.16-.2-.04.15.06.31.1.46l.4 1.33zm.49 1.6c.12.35.19.74.45 1.02.24.18.56.1.84.09.26-.02.49-.23.46-.5-.03-.6-.31-1.26-.9-1.5a2.4 2.4 0 0 0-1.07-.09c-.12.1.03.3.05.43l.17.55zm-1.78-2.4c-.11-.35-.22-.77-.58-.94-.23-.09-.64.02-.66-.34.08-.28.54-.07.77-.13.89 0 1.8-.23 2.66.06.7.18 1.28.82 1.28 1.56 0 .4-.33.71-.69.86-.02-.13.36.07.5.1.53.19 1.02.55 1.23 1.1.17.4.28.94-.04 1.32-.36.4-.95.43-1.45.44-.8 0-1.59-.01-2.37.12-.29.03-.4-.5-.04-.45.36 0 .46-.38.32-.66l-.93-3.04zM501.12 287.81c-.11-.35-.22-.77-.58-.94-.24-.09-.69.02-.66-.37.19-.25.65-.04.95-.1.68 0 1.36-.13 2.04-.05.79.1 1.54.65 1.74 1.45.14.42.05.95-.36 1.19-.09.1-.52.2-.45.19.6.24 1.12.69 1.41 1.27.16.26.25.58.47.8.27.2.3-.17.34-.33.35-.18.53.32.39.58-.15.42-.68.5-1.06.4-.34-.07-.6-.34-.76-.64-.34-.54-.55-1.17-1.03-1.61-.22-.2-.56-.31-.85-.2-.07.14.04.29.06.43.13.4.21.8.39 1.17.16.33.54.41.87.41.32 0 .35.56-.03.43-.6 0-1.22-.07-1.83.03-.22 0-.53.14-.67-.1-.22-.42.41-.22.55-.46.1-.28-.06-.56-.12-.84l-.81-2.71zm1.31.92c.1.32.56.15.8.14.3-.03.47-.32.4-.6-.07-.45-.19-.94-.54-1.25-.3-.23-.72-.23-1.08-.16-.16.12-.01.34.02.5l.4 1.37zM509.32 286.19c.31-.05.33.3.38.51.08.28.2.55.26.83-.13.26-.49.03-.51-.2-.13-.26-.3-.6-.63-.6a9.5 9.5 0 0 0-1.28 0c-.24.08-.03.38-.01.56.13.45.25.91.4 1.36.25 0 .53 0 .77-.1.29-.16-.1-.6.2-.7.36-.09.36.39.42.63.06.47.3.9.4 1.35-.12.28-.52.02-.52-.23-.08-.3-.37-.46-.66-.44-.15.02-.56-.12-.44.13.16.53.27 1.07.49 1.57.1.3.44.36.72.36.4-.01.85.06 1.18-.22.26-.22.07-.58.14-.84.26-.18.53.1.49.37.05.34.12.68.21 1.02-.05.2-.3.12-.45.14-1.04.02-2.07.03-3.11.07-.27-.03-.6.15-.82-.06-.26-.38.3-.3.47-.47.2-.22.04-.5-.02-.75-.3-1.03-.58-2.06-.89-3.08-.1-.3-.27-.68-.63-.72-.24.01-.61-.1-.49-.4.3-.1.66 0 .98-.04l2.95-.05zM476.5 299.32c-.1-.37-.22-.85-.64-.95-.24 0-.65-.06-.5-.4.3-.12.67-.02 1-.07.82-.04 1.65-.24 2.46-.02a3.54 3.54 0 0 1 2.59 2.36c.22.73.26 1.6-.23 2.24-.52.67-1.42.85-2.22.86-.61 0-1.23 0-1.84.12-.24.14-.63-.1-.42-.36.25-.07.67-.15.59-.52-.1-.51-.25-1.01-.36-1.52l-.43-1.74zm1.64 2.44c.1.32.14.7.4.94.28.17.62.1.92.08.47-.07.82-.48.9-.94a3.91 3.91 0 0 0-.39-2.22c-.26-.6-.8-1.08-1.44-1.22a2.98 2.98 0 0 0-1.16-.04c-.08.12.02.27.04.4l.73 3zM485.2 297.33c.32-.06.31.3.36.51.06.28.16.54.22.82-.13.26-.5.06-.5-.19-.12-.25-.27-.58-.6-.58-.42-.02-.85.02-1.27.06-.24.08-.05.38-.04.57.12.45.21.9.34 1.35.27-.01.58 0 .82-.17.21-.19-.13-.61.2-.69.38-.04.3.45.37.69.05.44.25.85.34 1.29-.12.28-.53.05-.5-.21-.08-.33-.41-.46-.71-.42-.15.02-.5-.07-.37.17.13.52.22 1.05.4 1.55.1.3.44.35.7.33.42-.02.9.02 1.22-.3.25-.23.02-.61.17-.84.3-.17.49.14.45.4.03.34.09.66.16.99-.06.2-.3.14-.47.16-1.02.07-2.05.12-3.07.2-.26-.01-.56.15-.78.01-.26-.27.1-.4.32-.44.3-.1.26-.44.19-.68-.27-1.08-.51-2.16-.79-3.24-.08-.3-.23-.67-.6-.7-.23.03-.6-.08-.46-.39.3-.12.65-.03.97-.07l2.93-.18zM491.69 301.43c.04.3.28.57.6.62.23.1.6-.04.73.24.1.35-.39.24-.6.25-.56 0-1.14-.02-1.7.07-.3.02-.58.1-.87.07-.27-.12-.15-.5.15-.45.27-.06.63-.13.7-.44.04-.27-.07-.53-.12-.79l-.64-2.76c-.03-.33-.39-.34-.64-.3-.22.01-.58.17-.66-.16-.03-.34.47-.27.67-.4.37-.13.74-.28 1.11-.38.21-.05.3.15.32.32l.95 4.11zM495.38 298.11c-.07-.36-.28-.79-.69-.84-.3-.05-.67.03-.78.34-.1.38.04.81.37 1.03.28.2.6.3.9.45.06-.12.24-.35.23-.56.02-.14 0-.29-.03-.42zm.84 2.9c-.1-.5-.57-.78-1-.96-.18-.03-.44-.27-.56-.17-.3.27-.46.71-.32 1.1.12.49.48.97 1 1 .35.05.77-.1.87-.47a.96.96 0 0 0 0-.5zm.89-.22a1.2 1.2 0 0 1-.47 1.3 2.4 2.4 0 0 1-2.02.24 1.67 1.67 0 0 1-1.19-1.28c-.12-.49.08-1.04.52-1.31.1-.1.49-.14.17-.22-.5-.24-.99-.64-1.09-1.22-.12-.49.1-1.03.55-1.27.86-.47 2.09-.2 2.59.67.21.37.25.86 0 1.22-.15.2-.33.4-.57.45.49.1.93.4 1.22.79.14.19.24.4.29.63zM500.37 301.35c.24 0 .5-.14.54-.4.09-.19-.08-.6.26-.58.3.02.27.37.3.6.03.4 0 .87-.34 1.13-.25.16-.56.1-.84.1-.56-.02-1.12-.14-1.68-.07-.24.02-.5.28-.72.1-.19-.23-.07-.52 0-.77.2-.61.62-1.12 1.1-1.54.33-.3.7-.65.76-1.13.04-.41-.08-.84-.3-1.19-.28-.45-.94-.6-1.4-.32-.22.15-.4.5-.22.75.21.16.6.01.7.35.13.23 0 .6-.3.6-.44.06-.84-.28-.95-.7a1.2 1.2 0 0 1 .5-1.4c.5-.3 1.13-.3 1.68-.17.57.14 1.04.58 1.22 1.14.15.43.16.93-.08 1.34-.38.72-1.15 1.07-1.66 1.67-.14.16-.25.38-.19.59.08-.2.4-.13.58-.17.35-.01.7.08 1.04.07zM504.31 300.93c.04.31.27.58.58.63.23.1.57-.01.72.23.14.34-.33.28-.54.27-.59-.02-1.18-.05-1.77.02-.29.02-.58.09-.86.05-.28-.13-.13-.5.16-.44.27-.05.63-.11.72-.42.03-.27-.07-.53-.11-.79l-.58-2.77c-.02-.28-.32-.34-.55-.3-.24-.03-.56.16-.71-.1-.18-.35.34-.35.55-.44.4-.12.8-.28 1.22-.38.21-.05.3.15.31.32l.86 4.12z'/%3e%3c/g%3e%3c/g%3e%3cg fill='%23448127' stroke='%2334541f' stroke-width='.22'%3e%3cpath fill='url(%23m)' stroke='%234c0505' d='M475.8 219.41l-3.77 4.48c-1.2 5.24 1.78 9.19 7.65 12.62 4.75 2.95 13.55 3.69 16.33 1.3l-13.72-13.06-6.49-5.34z'/%3e%3cpath d='M503.58 354.27c-.67-.81-1.35-1.62-2.04-2.42-8.55 11.3-19.24 21.42-32.61 28.57 15.07-4.27 24.94-15.26 34.65-26.15zM488.14 389.98c5.32-10.77 11.73-21.54 18.2-32.32-.7-.88-1.42-1.76-2.14-2.63-7.35 12.18-15.98 26.68-16.06 34.95zM529.87 275.48c-.98-4.25-2.27-8.84-4.3-13.05-2.67-5.44-6.63-10.84-11.84-16.8-9.38-10.18-18.77-20-31.93-27.26l.07-.14.08.05h.16l-.16-.2h.47l-.25-.26h.43l-.35-.4h.46l-.32-.33h.49l-.28-.36.4.03-.37-.39.55-.1-.45-.28.48-.1-.4-.27.59-.19-.52-.3.65-.3-.63-.45.67-.23-.73-.3.62-.31-.73-.13.5-.57-.7.04.31-.6-.67.05-.04-.05.37-.45-.68.12.3-.61-.65.32.18-.7-.62.43.1-.72-.59.5.06-.7-.5.54.04-.72-.5.6-.06-.7-.4.55-.2-.67-.34.67-.17-.71-.32.71-.15-.71-.27.71-.2-.67-.22.67-.16-.6-.24.72-.23-.67-.24.77-.29-.69-.13.82-.35-.67-.04.8-.38-.6-.03.78-.4-.57.03.7-.44-.37.22.74-.53-.3.2.65-.43-.24.15.63-.4-.13.21.47-.03.07-.3-.06.17.36a9.03 9.03 0 0 0-.35 3.52c.02.23.6.46.69.6.28.44.23.67.23.67-1.6 2.58-3.02 4.57-3.18 7.53 1.28-1.62 2.6-3.6 4.46-3.6-.92 1.54-1.35 6.17-.32 6.88l.77-1.36c.03 1.08.18 1.8.39 2.33.32-.65.64-1.28.96-1.75.07 1.51.27 2.72.7 3.32.43-.74 1.01-1.2 1.62-1.57-.2.86-.52 1.67-.39 2.7.65-1.1 1.3-1.75 1.94-2.51-.38 1.58-.04 2.77.41 4.52.4-2.08.56-2.3 1.52-3.17.1 1.9-.26 3.63.14 4.7.88-1.68 1.46-1.44 1.98-2.53-.1 1.58-.41 3.3-.01 4.7a4.48 4.48 0 0 1 1.94-2.67c.06 2.2.57 1.84-.8 3.7.58.27 2.54-.37 3.6-.83-.5 1.18-.35 2.1-.87 2.94 1.08-.54 2-1.42 2.9-2.32-.42 1.35-1.52 2.7-.97 4.05.25-1.26 1.28-2.3 2.24-2.49-.15.7-.25 2.17-1.27 2.88 2.44.25 3.4-1.4 4.64-2.7-.16 1.36-.12 2.44 1.55 4.35-.34-2.43.24-1.93 1.34-3.39.54 2.15 1.15 4.43 3.39 6.02-.93-2.27-1.1-3.44-.58-4.87.29 1.48 1.69 3.25 2.02 4.65.2-1.55.44-3.05.96-4.06.65 1.76 1.2 3.57 1.36 5.6.48-1 .88-2.03 1.16-3.08 19.73 20.62 24.13 46.84 2.5 74.54 7.78-5.25 9.78-13.57 14.1-20.67-4.21 9.3-6.09 19.74-13.51 27.43 7.19-6.2 8.71-11.89 13.03-17.87-4.6 12.5-10.98 26.2-19.82 38.75 1.57 1.7 3.14 3.44 4.72 5.18l4.1-6.84c9.37-15.44 24.65-37.5 16.91-71.15z'/%3e%3c/g%3e%3cpath fill='%23eac102' stroke='%23a08307' stroke-width='.22' d='M473.16 215.29c-1 .23-1.4.64-2.11 1.44.92.2 1.7.25 2.52.27.26-.03.34-.35.29-.59l-.13-.95c-.02-.22-.6-.2-.87-.09l.3-.08z'/%3e%3cpath fill='%23a08307' d='M471.04 216.73a9.89 9.89 0 0 1 2.13-.49 9.82 9.82 0 0 1-2.13.49z'/%3e%3cellipse stroke='black' stroke-width='.1' cx='477.68' cy='215.42' rx='.78' ry='.81'/%3e%3cellipse fill='url(%23n)' cx='477.86' cy='215.26' rx='.34' ry='.35'/%3e%3cg fill='%2334541f'%3e%3cpath d='M488.18 389.69a83.38 83.38 0 0 1 3.31-8.79c1.26-2.86 2.66-5.67 4.14-8.43a199.58 199.58 0 0 1 7.11-12.16l2.51-3.97-2.42 4.03-2.4 4.03c-1.58 2.7-3.14 5.41-4.61 8.17a133.67 133.67 0 0 0-4.18 8.4 98.1 98.1 0 0 0-3.46 8.72zM469.34 380.23a75.8 75.8 0 0 0 26.08-19.07 153.49 153.49 0 0 0 6.95-8.34 111.9 111.9 0 0 1-6.83 8.45 81.9 81.9 0 0 1-7.74 7.63 69.95 69.95 0 0 1-18.46 11.33zM506.62 350.89a136.2 136.2 0 0 0 4.3-6.66c1.37-2.26 2.69-4.55 3.96-6.86a331.1 331.1 0 0 0 3.75-6.99l3.68-7.03-1.75 3.57-1.78 3.54c-1.2 2.35-2.44 4.7-3.71 7.01-1.29 2.31-2.6 4.6-4 6.85a93.84 93.84 0 0 1-4.45 6.57zM512.51 325.78a60.2 60.2 0 0 0 8.5-13.4 72.56 72.56 0 0 0 4.98-15.06l.41-1.95a61.14 61.14 0 0 0 .7-5.91c.17-2.65.17-5.3-.04-7.95a53.36 53.36 0 0 0-3.64-15.42 50.47 50.47 0 0 1 3.79 15.41 54.3 54.3 0 0 1-.32 11.94c-.08.66-.17 1.3-.28 1.97l-.41 1.95a72.68 72.68 0 0 1-5.06 15.09 58.22 58.22 0 0 1-8.63 13.33z'/%3e%3cpath d='M510.87 320.07a35.91 35.91 0 0 0 4.9-5.85 52.06 52.06 0 0 0 3.8-6.62c1.1-2.3 2.1-4.65 3.02-7.02.46-1.18.92-2.38 1.36-3.57l.33-.9.3-.9c.18-.6.35-1.22.58-1.83v.02c.5-2.53.77-5.1.8-7.67.03-2.58-.17-5.16-.57-7.7-.4-2.55-1-5.06-1.73-7.53-.73-2.48-1.6-4.91-2.56-7.3 1 2.38 1.9 4.8 2.66 7.27a57.63 57.63 0 0 1 1.77 7.54c.42 2.55.63 5.13.61 7.72a41.44 41.44 0 0 1-.78 7.71v.02c-.22.59-.4 1.2-.58 1.81l-.3.91-.34.9c-.45 1.2-.91 2.38-1.38 3.57a96.55 96.55 0 0 1-3.07 7.01 51.58 51.58 0 0 1-3.84 6.62 35.96 35.96 0 0 1-4.98 5.79z'/%3e%3cpath d='M505.05 349.23c1.2-1.66 2.39-3.33 3.57-5l1.78-2.5c.59-.84 1.2-1.66 1.73-2.54a68.5 68.5 0 0 0 2.9-5.4c.9-1.85 1.82-3.68 2.71-5.52 1.78-3.69 3.5-7.4 4.97-11.23a75.28 75.28 0 0 0 3.45-11.76c.85-4 1.41-8.06 1.88-12.13.43-4.06.48-8.18.04-12.25a52.36 52.36 0 0 0-2.72-11.94 72.65 72.65 0 0 0-5.1-11.16 72.6 72.6 0 0 1 5.2 11.13 52.4 52.4 0 0 1 2.77 11.96c.44 4.08.41 8.2 0 12.28-.46 4.07-1.02 8.14-1.86 12.15a75.52 75.52 0 0 1-3.5 11.79 145.12 145.12 0 0 1-5 11.22c-.9 1.85-1.82 3.67-2.73 5.51a67.34 67.34 0 0 1-2.92 5.4c-.53.89-1.16 1.7-1.75 2.53l-1.8 2.5c-1.2 1.65-2.4 3.31-3.62 4.96z'/%3e%3cpath d='M507.81 352.25c2.36-3.84 4.71-7.68 6.95-11.58 2.25-3.9 4.49-7.82 6.47-11.86a81.9 81.9 0 0 0 5-12.52 74.15 74.15 0 0 0 2.71-13.2c.59-4.46.93-8.96.93-13.46s-.37-9-1.2-13.42a57.58 57.58 0 0 0-3.98-12.87 54 54 0 0 0-6.96-11.53 54.08 54.08 0 0 1 7.06 11.49 57.58 57.58 0 0 1 4.02 12.88 73.26 73.26 0 0 1 1.24 13.45 102.9 102.9 0 0 1-1.37 16.83 74.24 74.24 0 0 1-2.28 9.88 82.1 82.1 0 0 1-5.04 12.53c-2 4.05-4.24 7.96-6.5 11.85a442.64 442.64 0 0 1-7.05 11.53zM480 220.77c.47-.01.95.04 1.42.11a18.85 18.85 0 0 1 4.08 1.25c1.74.77 3.37 1.77 4.9 2.9a35.81 35.81 0 0 1 6.16 5.9c.6.74 1.2 1.48 1.76 2.24a60.86 60.86 0 0 0-3.78-4.23 37.82 37.82 0 0 0-4.27-3.73 26.78 26.78 0 0 0-4.84-2.93c-.86-.4-1.74-.74-2.65-1-.9-.27-1.83-.47-2.78-.51z'/%3e%3c/g%3e%3cg fill='%23448127'%3e%3cpath d='M496.38 231.57s3.06 1.8 4.73 4.44c0 0-4.72-.88-8.07-4.65'/%3e%3cpath fill='%2334541f' d='M496.38 231.57a14.43 14.43 0 0 1 2.66 1.9 13.11 13.11 0 0 1 2.16 2.48l.13.22-.24-.06a15.7 15.7 0 0 1-4.41-1.75c-1.37-.79-2.63-1.8-3.64-3a15.17 15.17 0 0 0 3.72 2.86c.68.38 1.4.72 2.12 1 .73.28 1.49.52 2.25.68l-.12.17c-.28-.46-.6-.9-.96-1.3a16.08 16.08 0 0 0-2.36-2.23c-.42-.34-.86-.67-1.31-.97z'/%3e%3cpath d='M489.58 230.69s7.23 4.61 8.27 4.98c0 0-1.6-3.48-5.05-4.97'/%3e%3cpath fill='%2334541f' d='M489.58 230.69l4.14 2.49a156.88 156.88 0 0 0 3.11 1.84c.35.2.7.4 1.06.55l-.13.14a12.91 12.91 0 0 0-2.07-2.9 10.73 10.73 0 0 0-2.89-2.11c.56.22 1.1.5 1.6.85a11.03 11.03 0 0 1 3.55 4.08l.12.24-.25-.1c-.77-.33-1.44-.76-2.14-1.17l-2.06-1.27c-1.36-.86-2.7-1.73-4.04-2.64z'/%3e%3cpath d='M492.46 228.36s3.76 1.6 4.61 4.38c0 0-6.75-2.84-7.96-4.35'/%3e%3cpath fill='%2334541f' d='M492.46 228.36a10.67 10.67 0 0 1 2.8 1.68c.43.35.81.75 1.14 1.2.33.44.61.93.77 1.47l.07.22-.21-.1a77.2 77.2 0 0 1-4.13-1.93c-.68-.35-1.35-.71-2-1.11-.32-.2-.64-.4-.95-.63-.3-.23-.6-.47-.84-.77.25.29.56.5.87.72.32.21.65.4.98.6a84.15 84.15 0 0 0 6.16 2.94l-.15.12c-.16-.5-.41-.98-.73-1.42a7.8 7.8 0 0 0-1.09-1.18 12.7 12.7 0 0 0-2.7-1.81z'/%3e%3cpath d='M486.76 231.25s6.65 4.76 8.61 4.76c0 0-1.95-3.26-5.39-4.75'/%3e%3cpath fill='%2334541f' d='M486.76 231.25a124.04 124.04 0 0 0 4.18 2.65c.7.42 1.42.83 2.16 1.2.37.18.74.36 1.12.5.37.15.77.3 1.15.3l-.09.16a15.68 15.68 0 0 0-2.32-2.76 12.98 12.98 0 0 0-2.98-2.04c1.13.45 2.17 1.13 3.09 1.93a12.97 12.97 0 0 1 2.4 2.76l.1.17h-.2a3.76 3.76 0 0 1-1.23-.31c-.39-.16-.77-.34-1.13-.53-.74-.38-1.46-.8-2.16-1.22a63.89 63.89 0 0 1-4.09-2.81z'/%3e%3cpath d='M486.76 232.74s3.46 2.92 5.43 2.92c0 0-1.95-3.26-5.4-4.75'/%3e%3cpath fill='%2334541f' d='M486.76 232.74a32.06 32.06 0 0 0 2.59 1.74c.44.26.9.5 1.37.7.24.1.48.2.73.26.24.07.49.11.74.12l-.1.15c-.3-.5-.67-.99-1.06-1.45a13 13 0 0 0-4.23-3.35c1.13.45 2.16 1.13 3.08 1.93a12.95 12.95 0 0 1 2.4 2.77l.1.15h-.2c-.54 0-1.06-.18-1.54-.39-.48-.2-.94-.46-1.39-.74a20.06 20.06 0 0 1-2.49-1.89z'/%3e%3cpath d='M485.03 226.18s7.2 5.12 8.06 7.9c0 0-6.52-3-7.73-4.5'/%3e%3cpath fill='%2334541f' d='M485.03 226.18a51.63 51.63 0 0 1 4.5 3.49c.73.62 1.42 1.28 2.06 1.99.32.35.63.71.91 1.1.28.4.55.8.7 1.28l.06.24-.22-.1a79.6 79.6 0 0 1-4-2.04c-.66-.37-1.31-.74-1.94-1.15-.32-.2-.62-.42-.92-.65-.3-.23-.6-.47-.82-.77.25.29.55.5.85.73.3.21.62.4.94.6.64.39 1.3.75 1.96 1.1 1.33.69 2.66 1.36 4.02 1.98l-.14.13a4.68 4.68 0 0 0-.66-1.22c-.27-.39-.57-.75-.89-1.1-.63-.7-1.32-1.35-2.02-2a71.2 71.2 0 0 0-4.4-3.62z'/%3e%3c/g%3e%3cg stroke='%2324420e' stroke-width='.16'%3e%3cpath fill='%23406325' d='M445.02 370.33c-4.89 3.64-18.55 5.43-20.45 4.8 9.94-8.27 19.73-8.47 20.45-4.8zM514.78 374.77c5.25 4.77 21.1 8.05 23.48 7.46-10.55-10.77-22.1-11.86-23.48-7.46z'/%3e%3cpath fill='%2367923d' d='M444.98 370.3c-.72-3.67-10.46-3.45-20.38 4.78 10.45-3.45 19.24-5.41 20.38-4.78zM514.89 374.71c1.37-4.4 12.8-3.34 23.36 7.46-11.88-5.02-21.94-8.1-23.36-7.46z'/%3e%3c/g%3e%3c/svg%3e";

var img$1t = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600' fill='white'%3e%3cpath d='M0 0h900v600H0'/%3e%3cpath stroke='%23E00' stroke-width='120' d='M0 60h900m0 240H0m0 240h900'/%3e%3cpath fill='%230050F0' d='M0 0v600l520-300'/%3e%3cpath d='M114 382l59-183 59 183L77 269h192'/%3e%3c/svg%3e";

var img$1s = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 120'%3e%3cdefs%3e%3cg id='s' transform='translate(0%2c-36)'%3e%3cg id='f'%3e%3cg id='t'%3e%3cpath d='M0%2c-5V0H3z' fill='white' transform='rotate(18%2c0%2c-5)' id='o'/%3e%3cuse xlink:href='%23o' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(-72)'/%3e%3cuse xlink:href='%23f' transform='rotate(144)'/%3e%3c/g%3e%3c/defs%3e%3cpath d='M0%2c0H180V120H0z' fill='%23cf142b'/%3e%3cpath d='M0%2c0H180V80H0z' fill='%2300247d'/%3e%3cpath d='M0%2c0H180V40H0z' fill='%23ffcc00'/%3e%3cg transform='translate(90%2c84)'%3e%3cg id='s4'%3e%3cg id='s2'%3e%3cuse xlink:href='%23s' transform='rotate(10)'/%3e%3cuse xlink:href='%23s' transform='rotate(30)'/%3e%3c/g%3e%3cuse xlink:href='%23s2' transform='rotate(40)'/%3e%3c/g%3e%3cuse xlink:href='%23s4' transform='rotate(-80)'/%3e%3c/g%3e%3c/svg%3e";

var img$1r = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-5 -5 27 18'%3e%3ctitle%3eFlag of Uruguay%3c/title%3e%3crect x='-5' y='-5' width='27' height='18' fill='white'/%3e%3cg fill='%230038a8'%3e%3crect x='5' y='-3' width='17' height='2'/%3e%3crect x='5' y='1' width='17' height='2'/%3e%3crect x='-5' y='5' width='27' height='2'/%3e%3crect x='-5' y='9' width='27' height='2'/%3e%3c/g%3e%3cg transform='scale(0.11)' fill='%23fcd116' stroke='black' stroke-width='0.6' stroke-miterlimit='20'%3e%3cg id='u'%3e%3cg id='t'%3e%3cg id='s'%3e%3cg transform='rotate(22.5)'%3e%3cpath d='M 1.5%2c9 6%2c12 C -2%2c25 7%2c27 0%2c33 3%2c26 -3%2c28 -3%2c16' stroke-linecap='square'/%3e%3cpath d='M 0%2c11 C -2%2c24 4.5%2c28 0%2c33' fill='none'/%3e%3c/g%3e%3cpath d='M 0%2c0 h 6 l -6%2c33 l -6%2c-33 h 6 v 33'/%3e%3c/g%3e%3cuse xlink:href='%23s' transform='rotate(45)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(90)'/%3e%3c/g%3e%3cuse xlink:href='%23u' transform='rotate(180)'/%3e%3ccircle r='11'/%3e%3c/g%3e%3cg transform='scale(0.011)'%3e%3cg id='right'%3e%3cpath d='M 81%2c-44 c -7%2c8 -11%2c-6 -36%2c-6 -25%2c0 -29%2c15 -33%2c12 -4%2c-3 21%2c-21 29%2c-22 8%2c-1 31%2c7 40%2c16 M 52%2c-35 c 7%2c6 1%2c19 -6%2c19 -7%2c0 -20%2c-12 -14%2c-20'/%3e%3cpath d=' M 19%2c-26 c 1%2c-12 11%2c-14 27%2c-14 16%2c0 23%2c12 29%2c15 -7%2c0 -13%2c-10 -29%2c-10 -16%2c0 -16%2c0 -27%2c10 M 22%2c-23 c 4%2c-6 9%2c6 20%2c6 11%2c0 17%2c-3 24%2c-8 7%2c-5 -10%2c12 -21%2c12 -11%2c0 -26%2c-6 -23%2c-10'/%3e%3cpath d='M 56%2c-17 c 13%2c-7 5%2c-17 0%2c-19 2%2c2 10%2c12 0%2c19 M 0%2c43 c 6%2c0 8%2c-2 16%2c-2 8%2c0 27%2c11 38%2c7 -23%2c9 -14%2c3 -54%2c3 h -5 M 58%2c57 c -4%2c-7 -3%2c-5 -11%2c-16 8%2c6 10%2c9 11%2c16 M 0%2c67 C 25%2c67 21%2c62 54%2c48 30%2c51 25%2c59 0%2c59 h -5 M 0%2c30 c 7%2c0 9%2c-5 17%2c-5 8%2c0 19%2c3 24%2c7 1%2c1 -3%2c-8 -11%2c-9 C 22%2c22 25%2c9 16%2c7 c 0%2c4 3%2c3 4%2c9 0%2c5 -9%2c5 -11%2c0 2%2c8 -4%2c8 -9%2c8'/%3e%3c/g%3e%3cuse xlink:href='%23right' transform='scale(-1%2c1)'/%3e%3cpath d='M 0%2c76 c -5%2c0 -18%2c3 0%2c3 18%2c0 5%2c-3 0%2c-3'/%3e%3c/g%3e%3c/svg%3e";

var img$1q = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3ctitle%3eFlag of Slovakia%3c/title%3e%3crect width='9' height='6' fill='%23ee1c25'/%3e%3crect width='9' height='4' fill='%230b4ea2'/%3e%3crect width='9' height='2' fill='white'/%3e%3cg%3e%3cpath fill='white' d='M3.16255%2c4.635c-0.53781-0.25905-1.3071-0.77323-1.3071-1.79033%2c0-1.01711%2c0.04863-1.47967%2c0.04863-1.47967h1.25847%2c1.2585s0.04864%2c0.46256%2c0.04864%2c1.47967c0%2c1.0171-0.76929%2c1.53128-1.30714%2c1.79033z'/%3e%3cpath fill='%23ee1c25' d='M3.16255%2c4.5c-0.4934-0.23766-1.19917-0.70938-1.19917-1.64251%2c0-0.933128%2c0.044612-1.35749%2c0.044612-1.35749h1.15456%2c1.15459s0.044626%2c0.424365%2c0.044626%2c1.35749c0%2c0.933128-0.705776%2c1.40485-1.19921%2c1.64251z'/%3e%3cpath fill='white' d='m3.26808%2c2.61284c0.133599%2c0.00216%2c0.394255%2c0.00739%2c0.626352-0.070273%2c0%2c0-0.00613%2c0.083055-0.00613%2c0.179805%2c0%2c0.096773%2c0.00613%2c0.179822%2c0.00613%2c0.179822-0.21289-0.07125-0.4758-0.07273-0.62635-0.07082v0.515391h-0.211033v-0.515391c-0.150545-0.00191-0.41345-0.0004252-0.626352%2c0.070815%2c0%2c0%2c0.00613-0.083049%2c0.00613-0.179822%2c0-0.09675-0.00613-0.179805-0.00613-0.179805%2c0.2321%2c0.077665%2c0.492753%2c0.072432%2c0.626352%2c0.070273v-0.323676c-0.121766-0.00108-0.297234%2c0.00473-0.49563%2c0.071126%2c0%2c0%2c0.00613-0.083055%2c0.00613-0.179822%2c0-0.096756-0.00613-0.179811-0.00613-0.179811%2c0.198103%2c0.066283%2c0.373356%2c0.072192%2c0.495088%2c0.071137-0.00626-0.20498-0.06597-0.46332-0.06597-0.46332s0.12289%2c0.00959%2c0.172016%2c0.00959c0.049178%2c0%2c0.172031-0.00959%2c0.172031-0.00959s-0.059695%2c0.258346-0.065964%2c0.463301c0.121741%2c0.00106%2c0.296989-0.00485%2c0.495086-0.071137%2c0%2c0-0.00613%2c0.083055-0.00613%2c0.179811%2c0%2c0.096767%2c0.00613%2c0.179822%2c0.00613%2c0.179822-0.198388-0.066392-0.373863-0.072207-0.495627-0.071126v0.323676z'/%3e%3cpath fill='%230b4ea2' d='m3.1625%2c3.29094c-0.24847%2c0-0.381562%2c0.344688-0.381562%2c0.344688s-0.073834-0.163438-0.276562-0.163438c-0.137161%2c0-0.238243%2c0.12201-0.3025%2c0.235%2c0.24954%2c0.39705%2c0.64768%2c0.64207%2c0.96062%2c0.79281%2c0.31299-0.15075%2c0.71139-0.39571%2c0.96094-0.79281-0.064256-0.11299-0.165339-0.235-0.3025-0.235-0.202734%2c0-0.276875%2c0.163438-0.276875%2c0.163438s-0.133073-0.344688-0.381562-0.344688z'/%3e%3c/g%3e%3c/svg%3e";

var img$1p = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 9 6'%3e%3cclipPath id='c'%3e%3cpath d='M0 0l4.5 3L0 6' id='b'/%3e%3c/clipPath%3e%3cclipPath id='a'%3e%3cpath d='M0 0h9v6H0z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath d='M0 0v6h9V0z' fill='%23001489'/%3e%3cpath d='M0 0v3h9V0z' fill='%23e03c31'/%3e%3cg stroke-width='2' stroke='white'%3e%3cpath d='M0 0l4.5 3L0 6m4.5-3H9' id='d'/%3e%3cuse xlink:href='%23b' stroke='%23ffb81c' clip-path='url(%23c)'/%3e%3c/g%3e%3cuse xlink:href='%23d' fill='none' stroke='%23007749' stroke-width='1.2'/%3e%3c/g%3e%3c/svg%3e";

var img$1o = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cdefs%3e%3cclipPath id='b'%3e%3cpath d='M0 0h600v300H0z'/%3e%3c/clipPath%3e%3cclipPath id='c'%3e%3cpath d='M0 0l300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z'/%3e%3c/clipPath%3e%3cg id='d'%3e%3cg id='a'%3e%3cpath d='M0 0v.5L1 0z' transform='translate(0 -.325)'/%3e%3cpath d='M0 0v-.5L1 0z' transform='rotate(-36 .5 -.162)'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3cuse xlink:href='%23a' transform='rotate(72 0 0)'/%3e%3cuse xlink:href='%23a' transform='rotate(-72 0 0)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1) rotate(72)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='white' d='M0 0l600 300M0 300L600 0' stroke-width='60' clip-path='url(%23b)'/%3e%3cpath stroke='%23C8102E' d='M0 0l600 300M0 300L600 0' stroke-width='40' clip-path='url(%23c)'/%3e%3cpath stroke='white' d='M300 0v300M0 150h600' stroke-width='100' clip-path='url(%23b)'/%3e%3cpath stroke='%23C8102E' d='M300 0v300M0 150h600' stroke-width='60' clip-path='url(%23b)'/%3e%3cuse xlink:href='%23d' fill='white' transform='matrix(45.4 0 0 45.4 900 120)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='matrix(30 0 0 30 900 120)'/%3e%3cg transform='rotate(82 900 240)'%3e%3cuse xlink:href='%23d' fill='white' transform='rotate(-82 519.022 -457.666) scale(40.4)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='rotate(-82 519.022 -457.666) scale(25)'/%3e%3c/g%3e%3cg transform='rotate(82 900 240)'%3e%3cuse xlink:href='%23d' fill='white' transform='rotate(-82 668.57 -327.666) scale(45.4)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='rotate(-82 668.57 -327.666) scale(30)'/%3e%3c/g%3e%3cuse xlink:href='%23d' fill='white' transform='matrix(50.4 0 0 50.4 900 480)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='matrix(35 0 0 35 900 480)'/%3e%3c/svg%3e";

var img$1n = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z' fill='white'/%3e%3cpath d='M0 0h390v240H0z' fill='%23002d62'/%3e%3cpath d='M0 360h390v240H0z' fill='%23ce1126'/%3e%3cpath d='M510 360h390v240H510z' fill='%23002d62'/%3e%3cpath d='M510 0h390v240H510z' fill='%23ce1126'/%3e%3cpath d='M434.183 245.772c-8.326-.144-16.733 1.755-23.725 6.092-3.214 1.995-3.97 2.666-2.203 5.871-.417.287-3.343 1.181-4.066 1.437-2.677 1.013-5.393 2.032-7.667 3.397-1.383.83-1.961 1.451-3.022 2.553l6.671-.512c-.21.431-.692 1.053-.966 1.467-1.14 1.645-1.848 2.953-2.845 4.675 1.89-1.279 3.59-2.475 5.771-3.542 4.774-2.407 13.357-2.472 16.878-6.7.9-1.068.353-1.706-.404-3.444 2.606-.863 3.586-1.467 6.752-2.186 7.652-1.706 12.925.32 16.622-.59 1.156-.288 2.282-.925 2.362-2.138l-.546-3.86 12.424-.016c.016 2.187-2.089 4.993 1.77 5.998 3.487.909 10.543-1.084 16.635.606l6.752 2.184c-.033.321-.516 1.182-.66 1.63-.289.78-.257 1.195.242 1.753.658.75 1.59 1.5 2.587 2.074 1.977 1.13 4.565 1.85 7.01 2.44 7.023 1.707 7.682 2.153 13.083 5.759-.354-1.053-2.926-4.802-3.778-6.126l6.64.527c-1.143-1.739-4.646-3.573-6.672-4.37l-8.086-2.952c.737-1.41 1.35-2.584.612-3.748-1.125-1.707-7.873-5.023-9.58-5.488a85.494 85.495 0 00-8.852-1.903c-2.879-.46-8.411-.857-8.411-.857-.397-.418.762-2.613-1.013-4.148-1.044-.828-2.555-1.116-4.1-1.276-6.17-.59-14.578-.414-20.815 0-1.8.111-3.068.305-4.1 1.277-1.253 1.18-1.413 1.897-1.302 4.116z' fill='%23201b18'/%3e%3cg fill='%23002d62'%3e%3cpath d='M435.915 250.17c.915-.815 1.044-1.053 2.506-1.548 3.183-1.068 8.198-.973 11.558-.973 2.733.015 5.402-.032 8.101.224 2.733.27 4.34.605 6.157 2.184.322-1.898.74-3.524.803-5.614.081-2.248-1.189-2.92-3.183-3.318-3.295-.686-8.824-.622-12.375-.59-2.316.015-10.545.08-12.218.686-1.527.542-2.733 1.738-2.603 3.812.047 1.036.82 4.483 1.254 5.136z'/%3e%3cpath d='M411.7 260.922c.563-.511.177-1.022 2.781-2.473 3.28-1.835 7.877-3.525 11.637-4.275 3.263-.638 6.623-.622 10.03-.367 1.511.112 3.505.352 5 .112 0 0 1.612-.377 2.065-.777.592-.523.555-1.728.555-1.728-1.093-.878-4.212 2.154-7.04 1.197-.917-.302-1.174-1.787-1.529-2.807l-.915-3.478c-5.175-.67-14.049 1.405-18.839 3.542-2.17.957-5.738 2.76-7.072 4.147-1.19 1.212.032 2.984.707 3.876.852 1.105 2 2.412 2.62 3.03zm44.535-9.591c-.29 1.818 1.045 2.344 2.653 2.583 3.326.465 8.31-1.051 14.917.24 2.829.559 5.593 1.5 8.052 2.504.997.414 4.468 2.027 5.176 2.729l1.254 1.5c.354-.192 2.266-2.49 2.652-2.984.74-.942 1.833-2.632.706-3.924-.979-1.133-5.255-3.35-7.151-4.164-2.532-1.086-6.558-2.056-9.68-2.584-3.182-.537-9.526-1-9.526-1s-.405 5.898-2.028 6.391c-3.167.941-4.71-1.706-7.025-1.291z'/%3e%3cpath d='M481.266 258.653c-.209.91-.61.989 1.062 2.377 3.906 3.222 10.479 3.382 14.594 5.152 2.089.908 3.247 1.658 5.095 2.775-.177-.543-2.571-4.003-3.166-4.913 1.832-.032 4.228.144 6.108.256-.095-.064-.145-.16-.257-.256-2.765-2.424-9.806-4.642-13.342-5.806-1.02 1.193-1.996 2.352-3.118 3.525-.434.414-.706.703-1.574.463-1.093-.303-1.946-1.244-2.604-1.835-.643-.574-1.946-1.657-2.798-1.738zm-24.934-7.914c1.994.144 2.267.51 3.778 1.181.61.27 1.383.398 2.17.335 1.077-.08 1.205-.224 1.495-1.07.417-1.21-1.625-2.008-2.572-2.217l-4.388-.653zm-12.698.022l-.418-2.394c-1.318-.143-7.426.895-6.976 2.776.224.878.418 1.021 1.383 1.117 2.652.24 3.07-1.419 6.01-1.499zm-31.439 10.527c.885 1.578 3.248-1.244 4.629-2.266.788-.59.885-.575 1.768-.94l-.481-.767c-.756.16-2.654 1.196-3.36 1.58-1.045.573-2.202 1.323-2.556 2.392z'/%3e%3cpath d='M481.439 258.083c.288.143.578.175.915.383 1.977 1.148 4.388 4.227 5.337 3.078.578-.717-1.575-2.186-2.235-2.536l-3.486-1.675a1.988 1.988 0 00-.531.75zm-62.781.635c.208.909.61.99-1.062 2.376-3.906 3.223-10.48 3.383-14.594 5.152-2.089.91-3.248 1.66-5.097 2.776.178-.542 2.573-4.004 3.167-4.913-1.832-.032-4.228.144-6.109.255.097-.064.147-.16.259-.255 2.765-2.424 9.805-4.643 13.341-5.806.37.383.674.797 1.012 1.197.418.51 1.64 1.88 2.106 2.328.434.414.706.702 1.574.462 1.094-.303 1.946-1.243 2.604-1.834.644-.575 1.946-1.659 2.799-1.739z'/%3e%3c/g%3e%3cpath d='M419.582 249.718c-.564-.012-1.07.266-1.574.475-.162.048-.586.206-.263.355.25.112.25.432.367.65.135.377.253.757.41 1.127.186.61.414 1.208.641 1.805.04.15-.146.538.173.38.323-.128.654-.235.979-.366a1.851 1.851 0 001.091-.878c.12-.186.132-.414.192-.624a1.01 1.01 0 00-.002-.538c-.04-.26-.059-.532-.187-.767-.133-.333-.273-.679-.544-.923-.231-.254-.5-.486-.829-.595a.94.94 0 00-.454-.101zm-.268.393c.383-.022.657.312.834.61.157.306.281.627.424.94.158.495.336 1.01.262 1.54-.059.28-.333.459-.56.607-.248.139-.486-.099-.49-.347-.09-.25-.202-.492-.278-.747-.186-.434-.298-.896-.493-1.326a5.81 5.81 0 01-.279-.902c-.07-.293.304-.363.517-.38a.384.384 0 01.063.005zm2.203-1.093c.09.14.313.165.306.37.09.26.183.518.242.787.068.209.105.425.192.628.075.275.158.549.233.825.092.263.194.525.246.8.035.209.194.448.06.646-.085.094-.052.235.094.159.219-.015.404-.151.621-.161.123-.043.421-.043.407-.19-.133-.113-.313-.192-.307-.399-.093-.314-.197-.625-.282-.938-.067-.225-.128-.453-.206-.672-.05-.172-.075-.355-.14-.526a62.622 62.622 0 01-.33-1.096c-.06-.152-.105-.302.032-.434.048-.223-.291-.025-.411-.026-.257.053-.502.16-.757.227zm3.666-1.021c-.333-.014-.634.182-.871.398-.25.296-.43.667-.418 1.062-.02.35-.05.707.05 1.048.11.537.375 1.032.706 1.466.229.228.511.4.81.516.255.059.531.08.785.012.423-.137.754-.494.878-.918.103-.29.186-.596.171-.907.007-.295-.103-.575-.153-.862a3.207 3.207 0 00-.396-.88c-.182-.245-.418-.446-.634-.656a1.41 1.411 0 00-.886-.276l-.04-.002zm-.019.285c.363.054.611.376.733.7.242.471.342.996.495 1.5.067.21.05.435.106.648.042.296.039.616-.088.892-.155.248-.534.326-.758.126-.232-.153-.327-.426-.46-.656-.086-.315-.235-.609-.299-.93-.059-.258-.17-.5-.19-.765-.063-.408-.168-.843-.017-1.245.07-.199.284-.272.477-.27zm2.956-.64c-.152.203-.276.419-.307.67-.052.258.036.516.087.767a1 1 0 00.476.568c.333.242.716.4 1.083.582.246.096.512.248.59.52.059.183.083.393.016.577-.09.203-.288.385-.525.322a.829.829 0 01-.596-.266 1.486 1.486 0 01-.463-.732c-.096-.186-.283 0-.224.147-.043.21-.083.44-.036.648.139.15.346.217.512.333.218.1.454.185.698.186.229-.034.476-.02.679-.147.224-.111.425-.26.526-.5.136-.28.201-.612.105-.916a1.427 1.427 0 00-.863-1.074 5.026 5.026 0 00-.756-.344c-.287-.137-.626-.307-.695-.648-.064-.232-.003-.54.247-.633.235-.103.502-.01.68.156.157.135.257.32.341.504-.045.247.343.152.216-.05-.067-.201.213-.5-.054-.626-.215-.127-.44-.25-.694-.275a1.158 1.158 0 00-.798.11c-.082.041-.163.085-.246.122zm14.008-5.483c-.373 0-.739.091-1.105.152-.15.113-.515-.026-.541.195a.829.829 0 01.254.534c.049.345-.038.7.06 1.04.016.244-.043.5.055.735.032.366-.05.747.07 1.102.032.229.104.512-.09.692-.205.17.134.258.264.169.262-.03.526-.054.786-.091.197-.053.072-.212-.035-.275-.153-.256-.109-.568-.13-.851-.005-.22 0-.44-.007-.658.257-.128.555-.095.819-.202.498-.115.989-.475 1.082-1.003.104-.47-.111-.975-.476-1.274a1.762 1.762 0 00-1.006-.265zm-.084.386c.316-.043.533.257.63.52.075.228.068.474.06.713-.017.368-.343.65-.69.702-.17.022-.473.076-.406-.185-.03-.283-.078-.564-.053-.85-.014-.268-.155-.562-.005-.817.113-.144.315-.042.464-.083zm3.333-.59c-.242-.063-.457.17-.425.403-.068.289-.09.588-.18.87a12.343 12.343 0 01-.232 1.254c-.109.513-.186 1.037-.363 1.534-.007.147-.33.329-.15.426.258-.029.518-.014.779-.026.232-.09-.111-.259-.153-.385-.035-.197.017-.403.05-.599.019-.109.027-.235.166-.197l.97-.007c.022.267.179.515.153.787-.066.12-.161.396.081.335.305-.006.603-.101.909-.079.254-.074-.09-.246-.119-.383-.126-.283-.201-.585-.285-.881-.084-.368-.202-.726-.293-1.09-.085-.202-.118-.414-.181-.622a11.659 11.659 0 01-.322-1.256c-.015-.137-.295-.064-.405-.084zm-.198 1.008c.189.537.284 1.103.48 1.637.11.195-.09.303-.258.251-.19-.03-.612.179-.616-.128.083-.209.11-.43.147-.65a8.63 8.63 0 00.147-.828c.023-.097.06-.19.101-.282zm3.659-1.149l-1.56.018a1.05 1.05 0 01-.081.485l-.066.51c.173.029.233-.177.337-.272.16-.166.33-.372.583-.362.13.007.337-.075.283.13.007.217.079.424.059.64.01.96.033 1.92.014 2.88-.005.133-.152.18-.202.296.05.062.31.011.44.03.248 0 .496.007.746-.006.116.025.104-.171-.033-.177-.093-.22-.073-.469-.09-.703-.01-1.03-.045-2.059-.004-3.088.127-.075.29-.154.424-.058.117.07.243.13.356.205l.232.341c-.036.027.25.148.177-.028.012-.197-.084-.375-.09-.57-.036-.153.023-.382-.21-.317-.44-.03-.875.042-1.314.047zm3.558-.117c-.336-.019-.663.085-.999.06-.108-.005-.32.038-.145.142.197.141.135.386.139.591-.022 1.04.03 2.08-.024 3.121-.035.174-.066.365-.235.46.034.137.314.028.443.067.272.008.545.012.817.02-.006-.161-.235-.234-.172-.41l.007-1.446c.235-.072.401.08.415.318.034.218.147.408.234.606.112.216.249.42.402.605.184.151.337.343.542.467.152.054.313.08.47.121.006-.196-.19-.304-.275-.463-.175-.29-.265-.621-.41-.927a2.402 2.402 0 01-.194-.634c-.13-.206.128-.179.249-.27a1.262 1.262 0 00.527-.544c.137-.229.123-.505.108-.762-.015-.233-.165-.422-.293-.605-.144-.165-.36-.257-.551-.356a4.126 4.126 0 00-.749-.158c-.1-.005-.205 0-.305-.003zm.307.341c.23-.016.434.107.577.275.111.143.15.336.168.517 0 .191.017.391-.033.578-.09.247-.283.485-.56.515-.2.024-.414.068-.61.026-.048-.141-.005-.308-.02-.46 0-.389-.004-.779.012-1.168.024-.273.25-.273.466-.283zm2.78.402c-.007.194-.062.383-.045.578-.01.341-.014.683-.055 1.02-.046.575-.013 1.151-.03 1.725-.036.168-.08.344-.197.475-.07.07-.112.141.022.114.171-.02.33.04.495.066.207 0 .412.013.616.015.202-.061-.111-.155-.084-.281-.103-.237-.046-.497.004-.738.03-.542-.022-1.09.07-1.63.03-.33-.034-.665.026-.994.1-.192-.034-.458.169-.605.044-.081.123-.179-.026-.149-.25-.002-.504.011-.75-.051-.118.007-.403-.093-.41.061.065.13.228.236.195.392zm3.15-.151c-.081.358-.24.694-.328 1.051-.063.217-.145.43-.204.65-.13.343-.22.7-.347 1.047-.136.437-.248.901-.549 1.261-.171.059-.14.346.068.239.204.012.4.08.609.064.166.057.211-.115.055-.182-.197-.155-.215-.43-.09-.631-.006-.249.2-.373.423-.303.252.022.505.075.76.068.008.239.111.467.116.709.04.172-.3.495.008.481.265.029.525.09.792.081.122.008.295-.006.162-.15-.175-.347-.193-.746-.275-1.12-.012-.403-.132-.79-.165-1.19-.072-.405-.184-.806-.199-1.22a2.36 2.36 0 00-.11-.59c.022-.166-.102-.25-.253-.2-.159-.015-.312-.085-.474-.066zm.05.951c.12.253.078.538.14.804.048.316.06.638.155.944.09.354-.354.184-.54.165-.168.013-.49.002-.328-.25.07-.181.112-.375.177-.56.055-.18.105-.358.152-.539.148-.15.107-.4.224-.563l.02-.002zm8.003 4.424c.003.198.28.275.227.5-.02.476.002.952.039 1.428.01.728.051 1.456.004 2.183a.38.38 0 01-.13.296c-.15.103.09.148.18.128l2.192-.08c.06-.326.143-.651.153-.983-.002-.163-.144-.087-.172.032-.196.279-.464.566-.827.58-.18-.004-.42.065-.554-.08-.066-.175-.047-.372-.067-.555a39.65 39.65 0 01-.02-2.943c-.017-.207.095-.386.17-.57zm2.979 4.418l1.18-.004c-.01-.235-.158-.098-.182-.437-.02-.298.019-3.434.048-3.645.057-.388.177-.225.177-.408l-1.16-.03c.003.306.148.03.157.477.004.196-.005.404-.005.598 0 .506.01 2.67-.02 3.008-.023.295-.185.211-.195.441zm1.839-4.525c.045.174.228.293.171.505.01.49-.093.971-.096 1.461a32.664 32.664 0 01-.093 1.719c-.03.205-.016.428-.112.615-.087.038-.28.167-.08.204.481.096.98.06 1.459.18.353.087.72-.027 1.03-.197.423-.288.531-.874.41-1.344-.044-.23-.223-.38-.387-.527a16.22 16.22 0 00-.42-.37.952.952 0 00.825-.734c.076-.313.026-.68-.216-.912-.072-.083-.136-.18-.246-.22-.179-.104-.358-.212-.568-.237-.554-.1-1.118-.108-1.677-.143zm1.041.409c.23.016.502-.02.661.185.28.3.265.768.09 1.118-.025.153-.205.252-.346.298-.185.046-.378.023-.565.011-.047-.37.047-.743.038-1.116.005-.171.018-.354.123-.496zm-.235 1.946c.332.016.704.07.923.349.206.264.14.618.155.928-.036.394-.42.756-.825.686-.216-.012-.346-.154-.305-.368a11.336 11.336 0 01.052-1.595zm2.14 2.492c.092.16.312.113.464.176.365.08.73.16 1.09.257.312.06.623.129.934.191.057-.242.248-.438.276-.691.133-.179-.146-.295-.23-.11a1.153 1.153 0 01-1.09.193c-.257-.01-.436-.229-.345-.477.027-.515.082-1.034.223-1.53.156-.056.359.03.514.093.22.093.333.31.432.51.15.116.14-.24.165-.338.02-.303.062-.606.098-.907-.244.036-.343.428-.64.28-.19-.076-.625.038-.517-.283.03-.357.137-.702.216-1.052.384-.122.808.063 1.042.376.137.123.232.425.365.456.074-.3.022-.612.026-.917-.116-.187-.393-.134-.577-.222-.56-.133-1.115-.296-1.685-.379-.32-.06.109.232.034.39l-.303 2.043c-.08.525-.121 1.056-.23 1.578a.606.606 0 01-.262.363zm3.774-3.568c.13.246.145.535.069.8-.137.666-.32 1.323-.415 1.998-.079.404-.154.808-.23 1.21-.036.18-.472.313-.145.427.28.116.577.182.861.281.284.011-.066-.296.024-.451.042-.305.145-.599.171-.905.05-.158 0-.47.235-.472.254.018.121.351.187.515.09.483.227.963.43 1.41.151.292.426.49.692.663.065-.184-.16-.474-.187-.696-.091-.31-.096-.63-.108-.95l-.037-.744c.257-.082.528-.141.732-.33.293-.319.4-.795.286-1.214a1.655 1.655 0 00-.82-1.034c-.464-.27-1.016-.285-1.513-.46a1.456 1.456 0 00-.232-.048zm1.01.602a.806.806 0 01.744.464c.159.443.104.962-.16 1.353-.159.215-.446.234-.686.173-.207-.01-.476-.077-.347-.34.069-.44.185-.87.253-1.312a.898.898 0 01.196-.338zm1.914 1.452c.207.02.336-.216.535-.257.185-.076.426-.171.59-.005.121.145.039.355-.008.515-.08.274-.135.558-.207.836l-.485 2.038c-.07.186-.07.426-.307.479-.103.212.286.201.414.302.231.101.464.194.71.262-.012-.185-.171-.341-.09-.545.092-.528.249-1.042.363-1.568a39.122 39.122 0 01.485-1.896c.266-.083.485.156.59.372.1.202.152.424.256.624.167-.109.101-.342.128-.51l.049-.5c-.336-.177-.71-.267-1.053-.432-.25-.115-.515-.202-.773-.306l-.82-.318c-.16.228-.213.508-.366.74a.347.347 0 00-.01.168zm4.204.84c-.175.113-.237.332-.344.503-.12.21-.286.391-.401.605-.362.586-.717 1.178-1.084 1.762-.153.206-.327.421-.57.524-.16.214.225.243.344.33.118.08.35.279.44.191-.038-.214-.192-.424-.072-.64.096-.168.143-.555.404-.38.251.157.538.263.752.473.07.19-.076.4-.04.605.075.218-.285.36-.191.52.19.145.42.223.62.349.14.058.411.272.333-.014-.01-.292-.07-.592-.007-.88.11-.212.057-.47.083-.702-.002-.32.077-.632.098-.949.053-.521.097-1.043.157-1.564.016-.173.152-.478-.09-.519-.15-.05-.262-.255-.432-.215zm-.3.934c.028.071.084.14.053.22-.061.55-.15 1.096-.19 1.647.006.272-.316-.026-.44-.077-.165-.1-.469-.168-.268-.4.164-.284.397-.523.538-.821.109-.185.245-.36.307-.57zm2.751.57c-.046.272-.008.565-.207.788a5.615 5.615 0 01-.446.747c-.16.289-.303.585-.482.863a61.4 61.4 0 01-.682 1.128c-.134.034-.388.061-.181.233.163.211.392.359.564.565.256.234.515.468.759.71.386.277.96.408 1.37.105.195-.192.41-.365.58-.58a4.239 4.239 0 00.4-.815c.112-.371.178-.762.132-1.15-.04-.617-.354-1.191-.773-1.633-.244-.244-.512-.466-.76-.706-.103-.07-.181-.17-.274-.255zm.743 1.107c.33.232.545.627.515 1.037-.034.649-.337 1.25-.702 1.772-.199.323-.43.692-.827.778-.302.079-.608-.124-.747-.381-.128-.287.088-.576.202-.83.322-.563.686-1.107.979-1.688.112-.233.246-.47.45-.636.04-.02.081-.06.13-.052z' fill='%23eac102'/%3e%3cpath d='M435.984 348.957c.799.274 2.433 1.036 3.094 1.343 0 0 2.288 4.27 2.257 4.208.869.616.73.48 1.702.72l-5.384 2.223c-1.563.582-.938 1.95-.208 2.224.8.24 2.466-.445 3.057-.719 2.674-1.232 5.104-2.497 7.5-4.037.384-.24 2.155-1.47 2.503-1.403l9.517 5.406c.694.308 2.084 1.198 2.848.65.312-.205.8-.685.625-1.232-.14-.58-.521-.684-.972-.854-.73-.309-5.037-2.259-5.176-2.259l1.147-.308c.347-.24-.252-.95.2-.813l2.37-3.875 2.952-1.06c-.02-2.72-22.224-4.412-28.032-.214z' fill='%23006300'/%3e%3cpath d='M437.527 358.098c-.8.24-.59 1.78 1.008 1.266 1.077-.377.244-1.675-1.006-1.265zm23.62.065c-.244.581-.21.854.347 1.094.59.274.938.274 1.32-.137.52-.512.104-.718-.348-.957-.486-.275-.104-.24-.486-.138-.277.103-.486.07-.833.138z' fill='%23ff0'/%3e%3cpath d='M482.247 269.909c-.07.109-.136.072.075.432 2 4.022 1.29 2.12 2.94 7.364-.316-.323-.738-.896-1.054-1.326-.877-1.185-1.676-2.48-2.412-3.773-.176-.36-.287-.464-.602-.715-.14.395.56 2.508.735 3.084.737 2.586 2.704 5.537 4.142 7.872-.421-.215-.668-.547-1.018-.87-1.263-1.04-.91-.782-1.646-2.075-.701-1.222-1.263-2.522-1.754-3.85a62.435 62.435 0 00-1.085-2.723c-.14.18-.038-.145-.142.25-.105.36.031.787.067 1.145.175 1.51.421 3.023.668 4.531-1.018-.43-.761-.504-1.65-1.23-.21-.109-.487-.713-.734-.785l-.847-.998c-.21.54 1.138 3.014 1.489 3.3.427.735 2.233 2.01 2.443 2.513.771 1.797 1.472 3.198 2.663 4.634l1.055 1.362-2.315-2.335c-1.684-1.545-2.348-2.186-4.243-3.695.036.539.702 1.003 1.052 1.327l2.895 3.177c.91 1.185 2.011 2.285 2.818 3.541l1.83 3.085c-.21-.36-.739-1.037-1.02-1.396l-2.8-3.484c-.983-1.186-2.07-2.009-3.333-3.014-1.053-.863-2.474-1.779-2.474-1.779 0 .462 2.355 3.434 4.052 4.328.53.499 1.035 1.024 1.511 1.575.492.54.948 1.011 1.404 1.587.841 1.149 1.676 2.472 2.414 3.729l1.127 1.98c-.876-.32-4.948-4.954-5.93-5.96-.807-.826-1.154-1.298-2.172-1.8.07.503 2.836 3.668 3.467 4.35.28.287.39.463.601.715l1.228 1.404c.807.97 2.278 2.687 2.84 3.764l.843 1.732c-.036-.18-1.65-2.298-1.897-2.55a11.75 11.75 0 00-1.052-1.258c-.912-1.005-2.42-2.7-3.506-3.453l-2.808-1.612c-.14.289.46.713.81.999l1.053 1.009c1.263 1.005 2.977 2.945 3.959 4.238.666.79 1.158 1.55 1.72 2.411-.35-.215-.632-.539-.877-.826-.386-.396-.56-.504-.91-.827-.526-.54-1.228-1.039-1.93-1.543l-4.526-2.23c.07.36 1.576 1.29 1.996 1.542.877.574 2.352 1.508 3.124 2.334.35.36.527.617.843.904.666.61 1.161 1.253 1.687 2.008.526.755.979 1.328 1.47 2.12.527.825.84 1.548 1.261 2.445l1.545 5.711c-.49-1.868-1.438-3.922-2.104-5.754-.526-1.4-1.687-4.805-3.475-4.195-.665.251-.98.967-1.261 1.543-.421.789-.986-.29-2.389 2.583-.77 1.616-1.293 3.485-1.645 5.28a1.79 1.79 0 000 .862c.35-.144.595-1.11.736-1.543.7-1.759 1.406-2.8 2.388-4.452l-1.336 6.072c.455-.07.601-.869.776-1.3.596-1.51 1.118-3.013 1.68-4.523 1.998 1.4 2.633 8.945 2.914 11.638-.211-.933-.983-2.944-1.403-3.842l-2.039-3.377c-1.192.145-1.331 1.65-1.611 2.585-.35-.467-.705-1.252-1.512-1.18-.736.036-1.014.896-1.12 1.723a9.6 9.6 0 00.034 2.652c.036.18.246 1.942.352 2.085l.25.25.418-5.168c.771.358 2.248 3.7 2.037 5.065-.77 4.993-1.234 6.568-3.9 10.697-.455.72-.944 1.473-1.47 2.12-.246.36-.488.685-.769 1.008l-.876.973c1.368-2.37 1.957-3.308 2.94-6.038.7-2.048 1.299-4.2 1.544-6.392.042-.347.03-.698-.033-1.042-.281.107-.354.503-.46.826-2.315 7.185-2.625 7.432-6.414 13.825l.703-4.091c-.351.035-.287.216-.427.611-.105.288-.204.505-.31.793-.525 1.58-1.053 3.121-1.895 4.522.07-.43.311-1.008.45-1.438.387-1.33.633-2.761.844-4.126l.034-.94c-.421-.036-.45.789-.626 1.293-.455 1.472-1.121 2.77-1.787 4.134v-.396c.14-.899.384-2.264.209-3.161 0 0 .136.22-.11-.319-.35.108-.42.788-.492 1.11-.107.425-.235.845-.384 1.258-.876 2.443-1.96 4.019-3.224 6.246-.74-.022-.158.052.167.077-.104-.026-.18-.044-.175-.052.515.072.39.07.175.052 1.048.265 7.025 1.395 7.025 1.395 3.472-.143 5.781-.427 9.22-.068.525.036 2.666.432 2.981.18-1.018-.574-1.993-.828-3.115-1.187l-3.3-.828 9.362-.25-.843-.466c-1.542-.61-5.717-.865-7.365-.972 3.086-.288 5.373-.532 8.46-.569.805-.23 3.552.657 2.346-.577-1.087-.755-4.63-.862-5.787-.827l5.545-.25c.882-.227 6.581 1.101 4.56-.215-1.578-.79-5.056-1.515-6.74-1.765.983-.575 1.863-1.147 2.915-1.576 2.104-.899 4.42-1.544 6.665-2.154 2.471-.385 4.332-1.563 1.085-1.043-1.998.216-4.417.785-6.172.965l1.58-.862c1.542-.79 3.326-1.113 5.01-1.688.316-.108.213.003.317-.284l-.275-.103c-.315-.037-.603.102-.919.137 1.018-.61 3.825-1.187 4.877-1.438a73.75 73.75 0 003.792-.999c.386-.108.91-.108 1.119-.431l-.242-.147c-.386-.144-7.189.865-7.926 1.008-.666.107-1.935.396-2.497.396 2.07-.861 4.106-1.764 6.281-2.411.385-.108 1.969-.391 2.18-.75-.422-.18-.774-.073-1.37.034-2.035.324-4.001.863-5.93 1.474-.666.215-1.582.571-2.214.714 6.98-2.693 4.32-1.904 10.775-3.16.736-.145 1.332-.075 1.402-.577l-3.716-.217c-1.228.037-2.49.326-3.507.362l2.763-2.334c.773-.647.422-.825 1.754-.86.527-.038 2.141.075 2.457-.104-.948-.97-1.227-.47-2.139-.974l1.128-1.37c.28-.358.558-.678.768-1.145.105-.215.104-.175.033-.319l-.45.07-2.882 2.367c-.491.36-.382.327-1.12.362-1.262.109-2.492.5-3.65.716 1.37-1.078 2.242-1.72 3.752-2.62.666-.43 1.37-.793 2.07-1.188.562-.288 1.966-.752 2.071-1.11l-4.45 1.145c-.878.323-3.3 1.472-3.826 1.903 1.964-2.19 4.976-4.7 7.29-6.46.281-.216.99-.572 1.095-.896-.175-.071-.25-.114-.426-.078-1.228.252-3.997 2.12-4.944 2.731-1.578 1.042-3.3 2.19-4.702 3.411.841-.899 1.617-1.723 2.563-2.55.211-.215.49-.466.735-.646.246-.215.423-.396.668-.611.492-.395.88-.785 1.37-1.18.947-.791 1.89-1.62 2.73-2.481l1.404-1.223c.317-.289 1.263-.86 1.228-1.362-1.929 1.078-3.713 2.257-5.538 3.515-.91.61-1.753 1.258-2.63 1.87-.666.43-2.037 1.686-2.563 1.937 1.087-1.76 2.213-3.59 3.615-5.099 1.72-1.903 3.89-3.88 5.855-5.495.526-.432 1.021-.968 1.512-1.328v-.18c-.456-.036-1.971 1.082-2.322 1.369-2.105 1.545-4.168 3.26-5.921 5.057-.317.323-.562.651-.877.939-.912.862-1.795 2.008-2.53 3.05-.984 1.4-2.038 2.909-2.949 4.418.596-2.73 2.527-4.845 4-6.46l3.367-3.705c.244-.252.357-.43.567-.68 2.248-2.47 3.329-4.386 3.784-7.28-.383.56-.926 1.215-1.78 2.275-.269.314-.5.55-.768.904l-6.832 7.865c.308-1.1 1.65-3.459 2.264-4.402a75.658 75.658 0 012.689-3.893c.653-.905 3.647-4.802 4.376-5.471l.317-.319c.079-.478.462-.72.961-1.136.56-.467.67-.718 1.336-1.076-.632-.647-2.985.82-3.44 1.145-2.982 2.047-5.117 4.847-7.29 7.65.279-1.51 2.063-5.928 2.904-7.185.702-.933 1.337-2.153 2.038-3.015l1.964-3.093c-.457.036-.98.721-1.262 1.009l-.56.577c-2.63 2.8-4.18 5.923-6.004 9.371.105-1.724 1.654-4.628 2.497-6.03 1.088-1.868 2.31-3.449 3.433-5.246-.633-.18-2.492 2.049-2.808 2.516-.806 1.006-1.611 2.012-2.313 3.162-1.263 2.12-2.49 4.483-3.332 6.891l-.209.508c.141-2.263 2.384-7.656 3.366-9.416.596-1.04 1.227-1.866 1.93-2.764.28-.323.455-.607.701-.93.49-.61.912-1.156 1.403-1.767l1.37-1.825c-.877-.324-4.04 3.268-4.636 4.023-.771.97-1.472 2.042-2.137 3.084.35-1.725 1.65-4.129 2.596-5.566.843-1.293 1.718-2.33 2.665-3.48.31-.355.581-.742.81-1.154-.982-.144-5.015 4.567-5.82 5.608-.351.467-.638.894-.953 1.361l-1.328 2.12c-.07.143-.111.215-.218.395l-.275.362c.211-1.653 1.194-5.107 1.72-6.616.737-1.94 1.748-3.695 2.59-5.6-.702-.107-2.028 1.692-2.414 2.267l-1.578 3.015c.175-1.4 2.344-6.284 3.081-8.079-.421.107-.699.751-1.085 1.325-.982 1.545-1.861 3.054-2.773 4.634.14-1.58 1.16-3.234 1.862-4.6-1.299.575-3.474 5.213-4 6.686-.245.61-.493 1.323-.669 2.006l-.275.724c-.07-3.556.66-7.188 1.186-10.673-.316.072-.386.435-.527.758l-.384.897c-.21.646-.455 1.254-.701 1.972l-1.019 4.239c-1.51-2.12-1.888-6.031-4.87-10.45-.946-1.4-1.267-1.548-2.53-2.446zm1.587 42.39c1.226 3.412 1.718 4.598 2.63 8.226a.84.84 0 00-.35.353c-.141.36-.281 1.013-.527 1.516l-.91-3.162c-.351-1.149.144-3.489-.244-3.884-.35.61-.246.721-.316 1.834-.21-.252-.42-.967-.56-1.326-.7-1.94-.806-1.368-.35-2.481.14-.323.345-.932.626-1.077z' fill='%23006300' stroke='olive' stroke-width='.283'/%3e%3cg fill='%23008f4c'%3e%3cpath d='M493.057 306.366c.453-4.74 6.302-15.95 8.018-16.19.258-.036-1.923 3.126-3.438 6.253-1.515 3.128-3.13 7.218-3.667 9.117-.503 1.88-.963 3.307-1.006 3.222-.043-.083-.008-1.17.093-2.403zm12.72-2.92c-.017.091-1.075 1.143-2.4 2.33-4.428 4.134-9.586 11.362-11.955 17.195-2.516 6.244-1.88 4.663-1.14 1.628 1.923-6.55 7.18-14.855 12.075-18.899 1.72-1.455 3.483-2.588 3.42-2.253zm-14.723-10.653c.006-4.323.413-5.83 2.897-11.02 1.589-3.33 2.188-4.423 2.363-4.172.11.183-.033.784-.333 1.362-1.47 2.84-3.873 10.947-4.286 14.49-.142 1.187-.353 2.185-.458 2.19-.116.028-.197-1.252-.182-2.85zm-7 24.14c.279 3.364-.28 7.19-1.761 11.04-.893 2.305-4.413 7.632-5.252 7.973-.412.16-.311-.062.617-1.14 3.684-4.362 6.134-10.84 6.183-16.802-.21-3.236.017-3.664.214-1.07z'/%3e%3cpath d='M494.773 312.864c.504 1.513.575 5.08.029 6.92-1.325 4.45-4.492 7.706-9.005 9.281-.886.297-1.65.52-1.71.462-.04-.038.64-.43 1.547-.839 5.63-2.64 9.14-7.963 9.18-13.905.007-1.108-.217-1.648-.28-1.925-.102-.46-.203-.817-.056-.935.077-.06-.075-.167.295.94z'/%3e%3cpath d='M507.088 322.335c-.061.055-2.512.514-5.435 1.026-2.923.494-6.71 1.21-8.378 1.576-2.574.552-3.09.625-3.252.4-.1-.152-.183-.303-.182-.36 0-.112 7.946-1.54 12.454-2.214 3.272-.49 5.04-.652 4.794-.428zm-23.118-49.624c1.876 2.264 2.318 3.24 3.273 7.105.617 2.476.778 3.325.577 3.275-.135-.044-.321-.426-.417-.865-.466-2.166-2.73-7.52-4.055-9.564-.441-.688-.764-1.307-.712-1.358.049-.069.648.564 1.334 1.407z'/%3e%3cpath d='M481.934 275.481c.89 2.833 1.466 3.733 4.159 6.594 1.724 1.838 2.34 2.424 2.404 2.222.034-.145-.183-.507-.497-.822-1.546-1.54-4.783-6.333-5.781-8.567-.337-.748-.68-1.355-.748-1.335-.083.006.126.864.465 1.91zm16.813 8.79c-2.978 2.726-7.804 11.444-7.1 12.802.109.203 1.35-1.8 2.698-4.473 1.348-2.675 3.298-5.91 4.309-7.258 1.016-1.314 1.75-2.368 1.67-2.357-.077.011-.796.59-1.577 1.285zm1.343 2.226c-3.326 3.045-8.718 12.784-7.93 14.301.12.227 1.505-2.01 3.012-4.997 1.506-2.987 3.684-6.6 4.813-8.107 1.137-1.468 1.955-2.645 1.868-2.633-.088.014-.89.658-1.764 1.436zm-19.081-8.928c.525 2.93.983 3.897 3.294 7.094 1.479 2.053 2.017 2.716 2.105 2.525.052-.138-.118-.528-.39-.88-1.34-1.736-3.948-6.92-4.656-9.267-.24-.788-.503-1.436-.574-1.426-.083-.004.017.874.22 1.953z'/%3e%3cpath d='M485.557 283.401c2.363.776 3.176.99 3.14.781-.038-.143-.395-.357-.817-.48-2.098-.565-8.002-3.227-8.094-4.261-.265-.379-1.26-1.875-1.26-1.875s5.089 5.152 7.03 5.835zm20.22 10.33c-4.524 3.14-12.621 14.071-11.903 16.046.11.298 2.15-2.188 4.453-5.565 2.304-3.377 5.524-7.402 7.136-9.044 1.614-1.593 2.794-2.886 2.686-2.886-.108.001-1.186.65-2.37 1.448zm-.691 6.69c-1.976 3.972-9.566 11.578-11.143 11.18-.237-.063 1.47-1.954 3.834-4.142 2.364-2.19 5.137-5.182 6.24-6.647 1.065-1.46 1.942-2.542 1.95-2.455.01.09-.384 1.025-.882 2.064zm-26.677 27.411c-.81 3.916-5.655 12.334-7.111 12.37-.22.003.83-2.046 2.38-4.513 1.55-2.465 3.273-5.727 3.895-7.262.59-1.52 1.104-2.669 1.132-2.595.029.074-.1.98-.296 2zm12.4-23.522c-.792-2.508-3.022-5.528-6.105-8.264-3.096-2.783-4.042-3.227-1.32-.619 2.51 2.386 5.65 6.64 6.774 9.18.478 1.03.944 1.853 1.046 1.781.13-.06-.047-.989-.394-2.078zm2.334 31.832c-3.481-1.016-12.418-.913-13.128.143-.106.16 2.008.231 4.688.105 2.68-.126 6.07-.05 7.575.122 1.483.19 2.633.285 2.587.234-.044-.05-.823-.33-1.723-.604zm-3.824 1.545c-3.518-.875-12.444-.41-13.113.675-.1.163 2.016.148 4.689-.086 2.672-.234 6.062-.296 7.575-.185 1.487.13 2.64.178 2.593.13-.048-.05-.836-.297-1.744-.534zm-3.932 1.906c-3.538-.78-12.45-.078-13.09 1.022-.096.167 2.02.096 4.684-.21 2.666-.304 6.053-.456 7.568-.384 1.49.09 2.643.108 2.596.06-.05-.048-.844-.273-1.758-.488z'/%3e%3cpath d='M483.064 341.831c-3-1.13-10.774-1.323-11.42-.29-.095.154 1.74.296 4.074.26 2.334-.039 5.28.15 6.586.371 1.283.24 2.28.372 2.243.32-.038-.053-.708-.356-1.483-.66zm13.893-11.027c-7.338 2.087-16.204 3.357-16.712 5.114-.073.264 3.239-.273 6.498-1.565 3.258-1.293 7.463-2.603 9.38-2.993 1.894-.354 3.379-.773 3.339-.965-.075-.052-1.302.415-2.506.41zm9.567-4.708c-.074.066-2.988.611-6.464 1.22-3.477.587-7.981 1.438-9.966 1.876-3.06.655-3.673.741-3.866.473-.122-.18-.217-.359-.217-.426 0-.134 9.45-1.833 14.81-2.634 3.893-.586 5.997-.777 5.7-.51z'/%3e%3cpath d='M504.254 324.2c-.056.061-2.45.765-5.31 1.571-2.863.788-6.564 1.882-8.188 2.417-2.508.81-3.014.933-3.197.724-.117-.14-.211-.282-.217-.337-.01-.113 7.762-2.338 12.183-3.465 3.21-.82 4.955-1.16 4.728-.91z'/%3e%3cpath d='M502.442 315.56c-5.07 2.074-15.24 10.972-14.946 13.06.047.314 2.553-1.665 5.502-4.459 2.949-2.793 6.926-6.019 8.84-7.268 1.906-1.2 3.328-2.204 3.22-2.227-.104-.023-1.292.374-2.615.893z'/%3e%3cpath d='M506.204 317.988c-5.055.333-16.53 5.497-16.86 7.574-.048.313 2.719-.757 6.107-2.457 3.388-1.699 7.804-3.477 9.843-4.045 2.019-.525 3.555-1.019 3.468-1.074-.086-.056-1.245-.063-2.558.003z'/%3e%3cpath d='M506.044 318.553c-12.933 10.868-20.2 16.18-22.78 15.057-.386-.173 4.753-3.124 9.146-5.934 4.395-2.81 9.628-6.794 11.762-8.82 2.069-2.03 3.749-3.508 3.749-3.363 0 .145-.841 1.536-1.877 3.06zm-13.84 3.398c2.608-4.243 3.915-5.46 9.477-8.968 3.566-2.255 4.812-2.944 4.833-2.585-.005.248-.506.747-1.146 1.124-3.154 1.847-10.393 8.272-12.932 11.486-.855 1.078-1.663 1.921-1.767 1.86-.133-.046.558-1.357 1.536-2.916zm1.418-12.22c.453-4.738 8.567-20.568 10.282-20.81.258-.035-1.922 3.127-3.437 6.254-1.515 3.128-3.13 7.22-3.67 9.117-.502 1.88-3.467 8.772-3.51 8.69-.043-.084.234-2.019.334-3.25zm-3.42-18.259c-1.363-3.216-1.407-4.448-.413-8.989.633-2.913.922-3.89 1.188-3.752.173.107.212.593.077 1.105-.661 2.515-.647 9.203.036 11.951.226.923.317 1.722.208 1.754-.114.053-.606-.877-1.096-2.069zm2.482 17.365c-.714-2.257-2.72-4.977-5.496-7.44-2.79-2.505-3.64-2.906-1.187-.558 2.259 2.15 5.084 5.977 6.096 8.267.43.926.852 1.668.944 1.602.116-.053-.043-.89-.355-1.87zm-12.432 3.643c2.553-9.193 4.577-7.6 4.577-7.6 5.588 5.264 2.843 23.352 2.843 23.352-.048-37.02-7.42-15.752-7.42-15.752z'/%3e%3cpath d='M482.318 311.841c2.554-9.193 3.23-8.794 3.23-8.794 4.624.943 4.334 21.217 4.334 21.217-2.023-34.785-7.564-12.424-7.564-12.424zm-2.44 7.138c-.101-6.603 1.203-5.615 1.203-5.615 3.738 3.345 5.127 16.195 5.127 16.195-5.802-25.949-6.33-10.58-6.33-10.58zm11.336-19.4c-1.122-3.547-4.586-7.214-8.147-11.864-4.381-3.938-5.72-4.566-1.867-.877 2.545 1.543 7.543 8.806 9.092 13.163.677 1.458 1.337 2.622 1.48 2.52.186-.086-.065-1.4-.558-2.942z'/%3e%3cpath d='M490.84 296.47c-.862-2.73-3.102-6.235-6.46-9.215l-2.04-1.92c2.012 2.396 6.566 8.69 7.79 11.458.523 1.121 1.03 2.02 1.14 1.94.144-.066-.05-1.077-.43-2.265zm-18.6 36.593c-.265 2.005-2.4 6.436-3.133 6.512-.11.01.344-1.064 1.035-2.368.692-1.302 1.44-3.014 1.698-3.81.243-.79.46-1.39.478-1.354.016.036-.015.5-.078 1.02zm-1.842 1.162c-.265 2.005-2.402 6.436-3.134 6.511-.111.012.344-1.064 1.035-2.367.692-1.304 1.44-3.015 1.698-3.812.244-.79.46-1.389.477-1.353.017.036-.014.5-.076 1.02zm2.78.148c-.266 2.006-2.4 6.437-3.133 6.512-.111.011.344-1.063 1.035-2.367.692-1.303 1.44-3.015 1.698-3.812.243-.79.46-1.388.477-1.353.017.037-.015.5-.077 1.02z'/%3e%3c/g%3e%3cpath d='M404.997 283.802c.013.992.286 1.25.727 1.877l.112-1.942c-.364-.222-.504-.035-.84.065z' fill='%2300873f'/%3e%3cg transform='translate(-82.672 -25.552) scale(1.06534)' fill='none' stroke='%23006300' stroke-width='.627'%3e%3cpath d='M455.17 303.94l-.866-.693m1.776-4.627c-.693-.996-.736-.996-.736-.996m-1.774 13.456c-.26-2.12-1.472-2.727-1.472-2.727m11.342 29.987c-5.4-5.97-7.165-16.77-7.165-16.77 1.765-4.518 4.102-5.557 4.102-5.557m-4.097 5.507c-1.765-6.957-1.325-14.228-1.325-14.228.623-8.93 3.454-16.822 3.454-16.822m-3.509 19.31c1.432-6.536 6.87-5.746 6.87-5.746'/%3e%3cpath d='M454.83 310.99c4.883-1.983 4.3-6.288 5.177-8.04 1.321-2.644 2.276-3.415 2.276-3.415M459.7 332.37c-1.661-4.206.312-4.984.312-4.984m-.982 3.634c-2.13-2.752-4.83-2.543-4.83-2.543m3.89-10.277c1.298-2.388-.052-4.78-.052-4.78m.692 16.3l-3.798-4.925m2.278-30.435c.514-1.946-1.028-2.827-1.028-2.827'/%3e%3cg transform='translate(442.052 224.217) scale(.1567)'%3e%3cpath d='M91.376 425.97a5.975 5.975 0 11-11.95 0 5.975 5.975 0 0111.95 0z' id='a' fill='red' stroke-width='2'/%3e%3c/g%3e%3cuse height='100%25' width='100%25' transform='matrix(.1567 0 0 .18128 444.567 235.353)' xlink:href='%23a'/%3e%3cuse height='100%25' width='100%25' transform='translate(443.685 248.32) scale(.1567)' xlink:href='%23a'/%3e%3cuse height='100%25' width='100%25' transform='translate(439.992 252.043) scale(.16899)' xlink:href='%23a'/%3e%3cuse height='100%25' width='100%25' transform='translate(438.744 256.228) scale(.16899)' xlink:href='%23a'/%3e%3cuse height='100%25' width='100%25' transform='translate(440.286 257.844) scale(.16899)' xlink:href='%23a'/%3e%3cuse height='100%25' width='100%25' transform='translate(463.222 286.05) scale(.12289)' xlink:href='%23a'/%3e%3cuse height='100%25' width='100%25' transform='translate(464.293 287.305) scale(.12289)' xlink:href='%23a'/%3e%3cpath d='M458.76 316.61c-.22-.955-1.101-1.248-1.101-1.248M472.4 339.53c1.591 1.163 2.081.428 2.081.428'/%3e%3c/g%3e%3cg fill='%23006300'%3e%3cpath d='M422.703 339.796c-1.044-3.718-.783-4.565-.783-4.565m-8.113-2.136s-.621-1.45.393-2.28c.6-.492 3.2.922 4.535-4.878 0 0-.81-.094-2.67.748v-.46s-.414-1.292-.23-2.906c0 0 .886-1.36.914-1.909 0 0-1.676-.62-4.95 3.592 0 0-.298-.9-2.696-2.513 0 0-1.3 3.68-.645 5.764.508 1.618.545 2.192 2.26 3.367 0 0 1.382.6 1.566 2.444.646 0 1.488-.11 1.488-.11s.08.018.035-.859zm-2.44 4.293c-.53.3-.766.572-1.706.692-4.224.541-6.594-5.026-6.594-5.026-.14-1.107.37-.522 1.245-.208 1.153.415 1.496.09 2.79-.069 1.706-.207 3.62 1.476 3.62 1.476 1.083.945 1.176 2.836 1.176 2.836-.116.3-.531.3-.531.3zm-5.017-10.046c-4.418-1.875-7.043.23-7.043.23-.163.276.261.406.261.406 2.771.342 1.88.213 3.032 1.793 1.973 2.706 5.46 2.135 5.46 2.135.719.163 1.436 1.028 1.436 1.028-.293-2.413-3.146-5.592-3.146-5.592zm-7.65-17.493c-.848-.588-.656.587-.656.587-1.826-3.196-6.647-3.44-6.647-3.44-.394-.019-.624-.318-.624-.318-.806 0 .185 1.613.185 1.613 1.452 3.873 2.835 4.312 2.835 4.312-1.646.94-4.281-1.105-3.689.391 2.56 2.697 4.288 3.066 4.288 3.066 3.229.785 4.658 0 4.658 0 .738 1.338 1.222 1.522 1.222 1.522 2.928.877 3.573 2.56 3.573 2.56 0-3.205-1.205-7.158-1.205-7.158-.916-1.375-3.94-3.138-3.94-3.138z'/%3e%3cpath d='M421.499 340.903c-1.565.49-1.696 1.598-1.696 1.598-1.532 2.086-7.042.1-7.042.1-1.696-.459-1.37-.915-1.37-.915 1.532-.782 2.054-1.4 2.054-1.4-2.934-2.642-3.358-6.066-3.358-6.066 4.565-.913 5.967-.065 5.967-.065-.294-1.762-1.793-1.794-1.793-1.794-.36-.555.424-.587.424-.587 4.01.392 6.162 2.902 6.162 2.902 1.5 2.12 1.043 4.206 1.043 4.206.359 2.12-.391 2.022-.391 2.022zm-18.633-18.387c-2.22-.653-3.504.07-3.504.07-1.153.46-3.252-.877-3.252-.877-2.766-2.304-3.296-3.734-3.296-3.734 0-.415 2.442-.322 2.442-.322 3.22-.078 3.954.583 3.954.583 1.663.945 1.491 1.812 2.086 2.16 1.436.84 1.665 1.23 1.665 1.23.407.556.584 1.09-.095.89zm4.304 1.13c1.52-1.754 3.596-.554 3.596-.554 3.182.37 4.196-3.227 4.196-3.227.738-1.476 1.292-2.168 1.292-2.168.184-.83-1.384-.138-1.384-.138-2.72.691-2.813.968-2.813.968.462-4.289.462-4.334.462-4.334.045-.692-.738-.184-.738-.184-3.92 2.26-4.38 3.918-4.38 3.918l-1.615-3.043c-.507-1.245-.876.14-.876.14-.738 3.688-.461 4.011-.461 4.011.508 1.982 1.015 2.535 1.015 2.535.92 1.2.92 1.66.92 1.66z'/%3e%3cpath d='M430.234 333.734c-.62.163-2.25 2.74-2.25 2.74-1.956-3.685-4.564-4.273-4.564-4.273-.522.23.065 1.077.065 1.077.782 1.956-.131 3.488-.131 3.488-.293 1.435.033 1.76.033 1.76-3.097-1.597-3.293-1.434-3.293-1.434-.034 1.99 2.348 5.706 2.348 5.706 5.15-1.37 5.542-1.27 5.542-1.27 1.924-.294 1.875-.328 1.875-.328 1.548-4.433.375-7.466.375-7.466zm-25.248-20.284c1.988.978 2.12 2.282 2.12 2.282.52 1.696 5.15 2.086 5.15 2.086 3.783-.39 3.39-1.075 3.39-1.075-2.183-1.923-1.555-1.77-2.476-2.675-1.65-1.613-3.815-1.662-3.815-1.662-2.902.457-3.521-.13-3.521-.13-1.044.555-.848 1.173-.848 1.173zm-4.486-6.648c-.934-3.408 2.153-7.63 2.153-7.63 2.575 4.795 2.086 6.13 2.086 6.13-.913 3.196-2.176 5.543-2.176 5.543-.472-2.413-1.72-2.793-2.063-4.043z'/%3e%3cpath d='M398.849 308.134c-3.265.093-6.379-3.605-6.379-3.605 4.869-1.262 5.962-.53 5.962-.53 2.669 1.52 4.5 3.17 4.5 3.17-2.27-.105-2.885.931-4.082.965z'/%3e%3cpath d='M396.335 303.543c-2.075.322-3.873-1.707-3.873-1.707-2.767-3.689-1.845-4.887-1.845-4.887.23-.139.554.322.554.322.876.784 2.443.968 2.443.968-4.426-2.766-1.521-8.9-1.521-8.9.554-.599.738.877.738.877.6 1.615 2.351 2.582 2.351 2.582.922 1.245.922 1.753.922 1.753.461-2.076.97-1.522.97-1.522.552 1.66 2.388 2.821 2.627 3.965.646 3.09.139 3.505.139 3.505-.37 1.797-.393 3.158-.393 3.158-1.682-.62-3.112-.115-3.112-.115zm10.42 7.425c1.06-1.43 0-4.104 0-4.104-.415-2.859 3.873-5.58 3.873-5.58 1.245 2.306 1.106 3.69 1.106 3.69 3.274-.784 4.012-1.015 4.012-1.015.138 1.844-1.614 4.52-1.614 4.52 2.675.782 3.596-.508 3.596-.508-1.29 5.948-6.962 4.75-6.962 4.75-2.352-1.522-4.011-1.754-4.011-1.754z'/%3e%3cpath d='M397.86 293.624c.324-3.587.977-3.718.977-3.718.386.143.576 1.737 1.092 1.976 2.248 1.036 2.234 3.438 2.234 3.438-.066 2.868-.482 2.61-.482 2.61-3.136-.04-3.822-4.305-3.822-4.305zm10.375.715c1.095-4.066.433-4.474.433-4.474-.48 0-1.334 1.672-1.998 1.724-2.885.225-3.842 2.864-3.842 2.864-1.091 3.174-.53 3.06-.53 3.06 3.456 1.226 5.548-1.73 5.937-3.174z'/%3e%3cpath d='M397.997 286.901c.38-4.192 1.142-4.346 1.142-4.346.451.167.673 2.031 1.278 2.31 2.628 1.21 2.613 4.016 2.613 4.016-.075 3.355-.561 3.054-.561 3.054-3.667-.046-4.607-3.542-4.472-5.034zm11.708 1.001c1.187-4.04.533-4.46.533-4.46-.48-.012-1.371 1.64-2.035 1.677-2.89.162-3.906 2.78-3.906 2.78-1.162 3.147-.6 3.045-.6 3.045 3.43 1.303 5.586-1.604 6.008-3.04zm4.816 11.294c3.334-2.57 3.055-3.296 3.055-3.296-.383-.292-2.076.522-2.634.16-2.432-1.568-4.793-.049-4.793-.049-2.79 1.863-2.275 2.112-2.275 2.112 2.006 3.07 5.46 1.986 6.647 1.073z'/%3e%3cpath d='M414.414 301.401c3.176-1.457 3.066-2.06 3.066-2.06-.266-.284-1.795.078-2.195-.287-1.741-1.587-3.94-.786-3.94-.786-2.608 1-2.225 1.27-2.225 1.27 1.138 2.675 4.164 2.381 5.293 1.863zm-10.952-19.25c-1.265-3.763 2.544-8.739 2.544-8.739a50.635 50.635 0 011.238 4.173c3.027-3.074 5.712-3.548 5.712-3.548l-.103 2.375c2.022-.196 2.87-.652 2.87-.652-.436 3.015-4.24 6.064-4.24 6.064-1.435.913-3.196.587-3.196.587-2.754.783-3.398 2.657-3.398 2.657-.27-1.63-.46-.042-1.427-2.919zm5.55 12.58c1.707-2.259 4.428-1.29 4.428-1.29 2.443.184 4.519-2.353 4.519-2.353 1.106-1.798 1.797-2.213 1.797-2.213-.092-.599-.691-.507-.691-.507-1.476.323-1.476.37-1.476.37 1.108-4.104.508-4.288.508-4.288-.37 0-.6.276-.6.276-.645 1.89-3.273 1.798-3.273 1.798-.138-2.72-.74-2.352-.74-2.352-.414.692-1.29 1.107-1.29 1.107-2.582 2.582-2.582 3.69-2.582 3.69.139 3.042-.6 5.764-.6 5.764z'/%3e%3c/g%3e%3cg fill='%2300863d'%3e%3cpath d='M408.523 309.657c.344-.393 1.12-.985 1.714-1.32.595-.343.406-.2.693-.85.266-.614.188-.477.615-.9l-.377 1.15c.602-.344.826-.536 1.672-.993.07.337-.552.636-1.064.971a28.29 28.29 0 01-1.323.85l-2.308 1.956c2.183-.506 1.79-.142 2.883-.322 2.337-.384 3.443-3.69 4.233-5.618-1.602.3-3.26.657-4.436 1.45-1.505 1.013-1.393 1.934-2.302 3.626zm-5.966 8.331c-.14-.356-.546-.949-.77-1.343-.623-1.113-.693-1.44-1.504-2.712-.518-.82-.329-.393-.666-1.306.308.022.736.95 1.085 1.328l-.006-1.35c.37.03.266.357.286.764.07 1.32-.056 1.092.756 2.542l1.644 2.705c-.097-.428-.308-.807-.427-1.248-.483-1.765.623-3.862-3.736-6.454l-1.078-.657c.078 2.141.315 5.675 2.282 6.781.342.193.74.28 1.112.428.399.172.679.366 1.02.522zm-1.011-26.814c-.162-.549-.418-1.035-.585-1.65-.156-.555-.067-.426-.456-.7l-.51-.622.643.328a4.152 4.152 0 00-.516-1.006c-.403-.575-.222-.192-.638-.938.745-.082 1.531 2.13 1.698 2.704.51 1.706.49 1.5 1.498 2.87-.007-.233-.37-.65-.464-1-.269-.938.745-2.21-.255-4.218-.597-1.206-1.832-1.404-2.436-2.418l-.53-1.04c-.196.362-.498 1.794-.524 2.266-.088 1.472.268 3.404 1.288 4.384.37.348 1.283.848 1.787 1.04zm5.56-10.622c.21-.15.615-.72.98-1.035l1.064-.892-.161-.986c.21.071.125-.093.335.672.273-.243.91-1.314 1.19-1.743.21.293-.413 1.2-.602 1.485-.31.493-.602.844-1.057 1.192l-2.036 2.5c.426-.136.74-.286 1.203-.378 1.323-.265 1.833-.38 2.758-1.858.874-1.39 1.112-3.105 1.462-4.71-1.89.756-3.884 1.52-4.864 3.29-.364.65-.203 1.207-.273 2.463zm-11.921 17.866c-.54-1.392-2.022-3.027-2.183-3.734l-.218-1.656c.309.043.169-.078.26.214 0 0 .083.936.195 1.2l.672 1.206c.029-.807-.105-.407.21-1.099.322.413-.175 1.128.308 1.935.252.421.595 1.084.91 1.45-.015-1.15.777-2.92-.525-4.599-.455-.578-.988-.779-1.554-1.257l-1.092-1.72c-.88 1.871-.713 5.675 1.05 6.94.336.242.644.328 1.008.527.189.107.308.171.49.286.167.107.293.214.469.307zm8.522-7.425c.762-.626.522-.875 2.293-2.206.437-.328.757-.697 1.135-1.115.543-.593.36-.473 1.085-1.173.18.317-.99 1.53-1.357 1.976l.71.085c-.113.423-.51.11-1.085.267-.518.13-1.887 1.69-2.265 2.086.34-.098.65-.24 1.06-.319 1.098-.215 1.784.078 2.968-1.435.996-1.263 1.35-2.854 1.837-4.4-1.518.357-3.351 1.128-4.2 1.957-1.215 1.174-1.113 2.18-1.574 3.23-.182.404-.44.676-.607 1.047zm-5.923 11.441c-.175-.256-.77-.713-1.063-.928-.61-.436-.686-.442-1.532-.507l-2.541-1.406c.315-.164.476.207 1.07.522l1.19.514-.147-.657c.224.014.245.05.344.293l.069.421c1.14.092.958.113 2.093.835-.127-.514-.197-.486-.519-.744-.28-.22-.343-.39-.566-.699-.357-.493.041.23-.567-.692-.987-1.485-2.072-.835-2.77-1.014l-1.813-.743a7.01 7.01 0 002.134 3.898c.476.443 1.029.95 1.903 1.1.273.043 2.365-.129 2.715-.193zm-1.022 9.483c-.358-.35-.756-.644-1.183-.958-.308-.222-.462-.193-.882-.235l-.818-.279.923-.035c-.105-.072-.294-.243-.426-.35-.652-.52-.777-.515-1.198-1.143.182-.17.302.043.554.236.748.585 2.204 1.756 2.932 2.255l1.357.75c-.063-.727-1.302-3.069-2.324-3.52l-4.534-1.24c.232.762 1.358 2.876 1.827 3.511 1.322 1.8 1.462 1.2 2.421 1.057.49-.07.868-.036 1.35-.05zm2.172-10.218l-1.716-5.68c.312.102.27.481.454 1.12l.455 1.175c.227-.494-.094-.068.397-.844.218.25-.036.788-.129 1.106-.174.6-.16.377.078.99l.81 2.1c.04-.474-.005-.729.083-1.218.259-1.374.476-2.139-.177-3.573-.57-1.258-1.52-2.18-2.404-3.162-.132.24-.402 1.877-.457 2.272-.214 1.46-.094 3.454 1.068 4.398.916.753.383.158 1.538 1.316zm3.388 7.351c.035-.586-.063-3.29-.042-4.519 0-.264.015-.52.015-.785.006-.414-.036-.278.188-.586.1.144.117.308.111.515l-.026 1.863.538-.914c.344.128.049.471-.104.792-.127.25-.407.721-.449.957l.09 2.67c.016-.022.037-.07.043-.057.028.042.295-.693.455-.957.553-.943 1.197-2.29.93-3.498l-1.49-4.29c-.314.527-.7 1.413-.959 1.991a9.153 9.153 0 00-.678 2.364c-.28 1.997.259 2.405.875 3.44.188.322.328.664.503 1.014zm2.397-25.472c.022-.508.23-3.127.168-3.349-.021-.07-.174-.37-.216-.499l-.245-1.05c.37.044.217.271.427.657l.14.2.063-.77c.04-.523-.036-.265.188-.773.21.123.09-.085.147.237a3.706 3.706 0 01-.028.393c-.182 1.75-.252 3.668-.336 5.425.169-.286.23-.743.413-1.085.455-.892 1.24-2.427 1.162-3.47l-.987-5.133c-.357.543-.707 1.4-1.008 2.02-.671 1.372-1.287 3.456-.874 5.013l.874 2.027c.064.114.05.086.11.157zm-13.71 29.553c.307.377.937.928 1.378 1.263.86.643 2.869 1.492 3.876 1.428l2.303-.422-.357-1.07c-.428.014-.756.192-1.245.2a8.35 8.35 0 01-1.414-.1 18.466 18.466 0 01-1.31-.228c-.777-.165-.502-.045-1.098-.458l2.422.357c-.63-.485-.406-.236-.868-.87.35-.037 1.07.655 1.379.87l2.07-.1-.16-1.22c-1.036-.43-2.492-.407-3.555-.036-2.148.735-1.385.563-3.421.386zm2.726 5.37c.127.4 2.303 2.89 2.821 3.062l4.772.2c-.595-.33-1.435-.672-2.106-.944-.917-.37-.972-.178-2.456-.02.078-.328.356-.265 1.154-.45-.335-.178-1.784-.585-1.805-.6l-.21-.228c.099-.1.029-.115.245-.094.07.008.273.086.37.115 2.205.721 2.835 1.006 4.928 1.87-.673-.513-.833-.692-1.345-1.349-1.917-2.434-3.932-1.642-6.367-1.563zm16.589-26.624l.73-1.335c.358-.756-.211-.779.044-1.792.259.081.18.058.314.93l.884-2.026c.253.682-1.143 3.274-1.442 3.905l-.473 1.31c1.143-1.273 2.537-1.868 2.76-2.93l.17-5.116c-.821.677-1.934 1.773-2.494 2.673-.83 1.327-.754 2.546-.493 4.38zm-2.207 30.213c.42-.186.735-.435 1.219-.628 1.882-.522 1.133.378 2.33-1.286l-.315.886c.854-.285 1.077-.815 1.707-1.443.16.314-.33.844-.58 1.086-1.057 1.043-2.128.707-2.75.95l-1.24.613c1.42-.222 1.26.036 2.436.214 2.393.364 3.072-2.027 3.884-3.44l.566-1c-1.357.142-3.002.97-4.05 1.556-.792.435-1.051.672-1.61 1.192-.218.2-.477.472-.735.657-.358.264-.63.335-.862.644z'/%3e%3cpath d='M407.948 309.412c.839-.799.658-2.67 1.28-3.797.119-.215.21-.329.35-.5.23-.293.146-.236.448-.228.098.22-.357.456-.532.856l-.378 1.207c.078-.058.049-.036.126-.115.063-.07.084-.1.126-.164.588-.836 1.12-1.043 1.967-1.578l-.813-3.02-1.483 1.285a7.036 7.036 0 00-1.26 1.55c-1.056 1.863.09 2.74.169 4.505zm-.438 12.401l1.96-3.213v-1.51c.299.047.194-.113.388.896.66-.97.2-.857.95-1.343.053.29-.765 1.767-.868 1.92-.833 1.166-1.233 1.901-1.953 3.136.467-.189 1.106-.87 1.44-1.182.283-.257.438-.394.743-.59.282-.183.58-.32.847-.494l.832-4.6c-.75.317-2.77 1.736-3.358 2.478-1.226 1.562-1.292 2.04-.98 4.502zm4.4-11.272l2.555-.234c-.078.335-.442.341-1.162.45-1.147.177-3.275.155-4.505.177.355.2.712.321 1.076.536.37.221.637.4 1.016.592.804.414 1.776.38 2.637.05l3.345-3.113c-1.757.408-.791.472-3.163-.006-.364.314-.525.7-1.287 1.213-.155.107-.372.207-.51.336zm-18.152-6.178c.72 1.48 2.83 3.254 4.728 3.02.847-.108 1.001-.377 1.51-.873-.112-.13.023-.027-.143-.11a.816.816 0 00-.217-.065c-1.452-.287-1.63-.172-3.11-.008l.672-.346c-.389-.1-.774-.186-1.154-.29-.607-.17-.525-.147-.991-.48.17-.166.128-.127.428-.039 1.939.621 2.395.586 4.504.912-.2-.638-1.864-1.432-2.757-1.554-1.41-.178-1.897.544-3.47-.167zm12.517 16.992l-.643-4.127c.335.093.237.222.398 1.085l.735 3.741c.063-1.42.546-2.435.118-3.897l-1.47-2.82c-.272.67-.467 2.57-.412 3.37.09 1.255.35 1.634 1.008 2.39.126.144.119.15.266.258zm5.593-42.134c.21-.129.378-.35.566-.586l.61-.47c.013.35-.49.756-.826 1.177-.483.613-.784.713-1.021 1.006-.946 1.193-.848.992-2.345 1.65 3.078.186 4.744-3.064 6.067-5.276-2.91.414-2.38.614-2.66 1.45-.125.363-.3.706-.391 1.05zm1 13.007l.84-1.39c.505-.736.833-.224 1.63-1.004-.214-.194-.15-.133-1.025.211l1.395-1.903c-.766.133-2.408 2.813-2.83 3.426l-.954 1.138c.56-1.735.362-3.342 1.22-4.12l4.63-2.899c-.183 1.121-.6 2.736-1.128 3.734-.78 1.477-1.945 2.062-3.777 2.808zm-11.547 5.465c-.251-.763-1.176-1.556-1.329-1.977l-.666-2.685c.372.044.372.757.442 1.071l.356 1.15c.224-.82-.146-.243.364-1.035.252.5-.3 1.335.042 1.798.343.472.37.408.91 1.214.308-1.235.356-2.805-.392-3.655l-2.148-2.356c-.546.792-.497 3.034-.112 4.17.44 1.27.931 1.413 1.736 1.841.314.165.496.33.797.464zm1.865-.298c.547-.72 1.82-1.223 2.137-1.615l1.69-2.609c-.41-.09-.671.668-.86.977l-.801 1.09c.063-.954.244-.204-.008-1.233-.45.44-.168 1.53-.703 1.897-.537.375-.544.297-1.412.957.125-1.426.648-3.113 1.756-3.742l3.147-1.717c.29 1.042-.584 3.407-1.41 4.472-.934 1.19-1.506 1.162-2.52 1.322-.394.06-.647.166-1.016.2zm5.656.32c.84-.043 3.128-.078 3.829-.45l.965-.45c0 .257 0 .123-.364.493.923-.043.517-.107 1.406.05-.105.186.182.157-.734.214-1.03.071-1.575.178-2.498.278l-3.415.344c2.183.792 2.54 1.997 5.01 1.076 1.966-.734 2.359-1.533 3.604-3.033-3.072.714-3.402-1.885-6.41.1-.364.243-1.176 1.063-1.393 1.377z'/%3e%3cpath d='M412.934 299.601c.804.1.468-.014 1.14.3-.315.27-1.652-.065-2.183.042l-2.204-.042c.707.977 1.888 1.45 3.562 1.277 1.643-.178 2.07-.6 3.392-1.406l-2.497-.82zm-.917 14.34c-.21-.208-.756-.478-1.1-.608-1.391-.528-2.482-.028-3.19-.042l-1.59-.186c.422.464 2.129 1.1 2.96 1.234 2.143.35.7.915 2.92-.4zm.224 1.576l.636.571c-.166.086-.398-.072-.665-.2l-.118 1.45 2.904-.365c-.917-1.157-1.505-1.714-2.597-2.727-.083.45-.21.778-.16 1.27zm-3.728.82l1.734-1.313c-.44-.344-1.245-.329-1.853-.515l-1.674-.67c.4.556.413.428.89 1.248.266.457.46.943.903 1.25zm8.405-25.707c-.755.442-1.285 1.127-2.128 1.48-1.138.462-2.355.006-3.071.737 1.92-.11 3.186.622 4.675-.75.914-.845 1.713-2.145 2.46-3.223-.301-.019-1.294.284-1.494.49-.105.104-.248.441-.358.611-.343.547-.112.142-.084.655zm-6.34 43.701l1.4 2.841 1.93 2.364c.4-.187.848-.507 1.303-.736l1.553-.55c-.867-.37-.91-.8-1.4-.835-1.195-.079-.496.114-2.085-.158.147-.256.077-.135.903-.15l1.008-.028c-.588-.543-1.315-.92-1.973-1.399l2.072 1.057-.064-1.378c.504.057.196.835.426 1.6.112.35.777.791 1.135.97.685.343.937.264 1.644.443l1.624.513c-.666-.943-.364.122-1.492-2.206-.455-.942-.88-1.513-1.651-1.992-1.875-1.163-4.184-.385-6.332-.356zm2.356-2.792c.02-1.142-.064-2.184.027-3.348.043-.543-.21-1.942-.3-2.74.266.077.223.2.286.534l.21.743c.266-1.2.33-1.165.98-2.028.105.278-.644 1.214-.777 2.578l-.133 3.39c.133-.157.147-.213.3-.385.12-.136.21-.229.337-.364.238-.243.406-.479.637-.836 1.623-2.527.637-3.968.665-4.718l.469-2.448c-.504.206-1.89 1.212-2.205 1.534-1.252 1.27-2.49 3.506-1.707 5.418.182.45.433.83.63 1.265.196.442.35 1.021.58 1.405z'/%3e%3cpath d='M412.07 341.245c.273.17 1.84.678 2.246.8 1.49.464 3.829.635 4.863-.75.567-.764.91-.964 1.624-1.535-1.106.022-1.868.443-2.833.663-.722.165-.77.672-1.36 1.23l-.544.376c.007-.356.693-1.027 1.015-1.406l-2.17-.02c.07-.35.652-.178 1.61-.265 1.875-.158 2.19-.657 4.226-.899a.839.839 0 00.4-.115c-3.038-.014-3.702-2.055-7.341.53zm13.892-1.876v-1.52c-.665-.507-.665-.67-1.07-1.45.356.03.504.6 1.05.986-.056-.728-.357-1.949-.525-2.728.35.058.517 1.03.602 1.38.427 1.776.055 3.147.37 3.72l.868 1.17c.294-1.236 1.567-2.036.049-5.077-.923-1.856-1.673-2.17-3.226-3.34.188.85.4 1.15.266 2.191-.098.728-.385 1.278-.468 1.992-.197 1.642.307 1.55.63 1.734.545.307 1.049.636 1.455.943zm-15.031-2.886l-.462-1.02c-1.28.021-1.66.542-3.444-.658-.468-.314-.391-.278-.65-.77l1.973 1.105c-.105-.22-.343-.45-.734-1.256.063-.042-.043-.136.182-.008.09.05.125.122.167.18l.959 1.27 1.315-.143c-.028-.222-.252-.592-.35-.82-.188-.444-.097-.515-.432-.758-.442-.322-.988-.636-1.66-.699-.825-.079-1.316.207-2.063.264l-2.016-.42c.09.391.847 1.648 1.057 1.947.854 1.2 3.114 2.95 5.03 2.2.28-.108.889-.287 1.128-.414zm-10.495-9.343l.105.057c.1.05.064.035.156.07.572.237 1.076.5 1.482.965.517.585.553.871 1.343 1.528 1.274 1.063 2.652 1.028 4.354 1.25-.156-.237-.575-.723-.777-.929-1.36-1.45-1.113-1.37-1.981-1.25l-1.42.115c.063-.293.916-.35 1.539-.485a3.94 3.94 0 00-.917-.293c-.714-.13-.21.056-1.03-.25.373-.5 2.206.156 3.053.95.63.578 1.413 1.506 2.015 2.213l-.987-2.128c-1.008-1.835-3.674-2.492-5.632-2.14-.315.05-1.029.163-1.302.327zm11.858 4.857c-.706-2.24-1.862-3.19-2.176-4.554-.21-.928-.133-1.014.035-1.857.455.622-.385 1.05.944 3.277-.076-.72-.258-1.043-.133-1.913.055-.35.484-1.684.477-1.72-.063-.364-1.673-1.842-2.114-2.306-.23 1.978-.741 3.74-.098 5.71.665 2.043 1.756 1.566 3.065 3.363zM423 342.087l1.413-.378c-.21-.172-.707-.815-.917-1.13-.616-.898-.546-.977-.3-1.427.077.136.02.014.056.186.034.242-.022.314.153.622.133.227.23.362.406.584.35.464.58.735 1.015 1.071-.028-.707-.161-1.05.035-1.47.267.1.09-.079.189.192l.084 1.214 1.567-.414c-1.056-1.864-3.085-2.535-4.94-3.27.168.721.336 1.471.51 2.191.196.836.428 1.314.729 2.03zm-2.482-4.027c-.17-.422-.47-.87-.7-1.357-.504-1.092-.427-1.592-1.442-2.642-.174-.177-.314-.357-.525-.52-.104-.079-.377-.243-.42-.35-.007-.007-.013-.028-.013-.043l.014-.15c.35-.072 1.05.735 1.266.95.609.585 2.008 3.547 2.478 4.46-.063-.406-.273-.89-.133-1.284.405-1.17-.722-2.977-1.274-3.348l-4.387-1.942c.525.5.832.786 1.196 1.593.286.642.42.085 1.56 1.306 1.21 1.277 1.113 2.87 2.38 3.327z'/%3e%3cpath d='M428.572 338.05c.078-.209.155-.423.23-.65.142-.4.03-.237.365-.565.168.264 0 .407-.182.964-.356 1.063-.588 1.955-.888 3.04.972-.127.93-.15 1.343-.876.252-.444.448-1.065.546-1.636l-.12-4.127-1.265 1.65c-.658.95-.245.435-.03 2.2zm-13.188-9.365c.314-.179 1.049-1.064 1.365-1.414.18.335-.666 1.214-.848 1.398-.713.68-.266 0-1.196 1.114 1.882.28 2.659-2.206 3.268-3.476-.372.022-1.568.415-1.862.592-.252.143-.174.072-.244.393-.05.2-.064.293-.133.5-.098.307-.231.6-.35.893z'/%3e%3c/g%3e%3cg fill='%23ce1126' stroke='black'%3e%3cpath d='M434.474 352.26l2.366 1.228-1.347 2.655c.983-.167 4.55-1.394 5.716-1.76-.291-.828-.4-.928-.291-1.957l-.4-1.892-2.877.962a23.979 23.979 0 01-3.167.764zm31.055-.415l-2.368 1.227 1.348 2.656c-.984-.167-4.551-1.394-5.717-1.76.291-.83.4-.928.291-1.958l.4-1.89 2.877.961a24.18 24.18 0 003.169.764z' stroke-width='.295'/%3e%3cpath d='M443.061 356.021c2.661-.376 5.043-1.786 5.043-1.786.407.439 2.536.126 2.536.126.971-.19 1.41-.344 1.41-.344 2.663 1.69 4.698 1.942 4.698 1.942 2.35-.126 2.412-1.942 2.412-1.942-.093-1.598-.251-1.66-.251-1.66 1.254-1.974-.093-3.54-.093-3.54-.627-.72-4.26.438-4.26.438-2.444 1.16-2.6.658-2.6.658-.694-1.088-3.244-.895-4.354-.062-2.693-.596-3.07-.784-3.07-.784-2.725-1.033-3.163-.407-3.163-.407-.971 1.16-.658 2.38-.658 2.38 0 .69.22 1.285.22 1.285-.596 3.507 2.13 3.696 2.13 3.696z' stroke-width='.301'/%3e%3cpath d='M452.041 353.059c5.857 1.318 5.442 2.153 5.442 2.153-.355.613-2.075-.174-2.075-.174-4.57-1.6-3.367-1.98-3.367-1.98zm-3.633.022c-5.858 1.317-5.443 2.153-5.443 2.153.356.613 2.076-.175 2.076-.175 4.57-1.6 3.367-1.978 3.367-1.978z' stroke-width='.239'/%3e%3cpath d='M448.654 349.107c-2.518.447-.53 2.325-.443 3.488 0 .626-.618 1.698.045 1.968.618.267 1.942-.045 2.648-.045.973-.045 1.634.045 1.502-1.208-.089-.94-.397-1.252-.397-2.46-.045-.848.133-1.788-.795-1.877-.574-.045-1.986.044-2.561.133z' fill='%23aa241e' stroke-width='.223'/%3e%3cpath d='M452.126 350.502c6.68-.033 6.188-1.1 6.188-1.1m-6.071 3.135c6.614.888 5.722 1.851 5.722 1.851' fill='none' stroke-width='.241'/%3e%3cpath d='M448.099 352.346c-6.16 1.369-5.606 2.345-5.606 2.345m4.925-4.327c-6.295.455-5.662-.613-5.662-.613' fill='none' stroke-width='.234'/%3e%3c/g%3e%3cpath d='M422.666 342.607c-3.374 1.108-5.613 1.88-8.838 3.771-1.23-1.849-2.91-4.585-4.101-6.173-.672-.852-1.604-1.776-2.76-2.368-1.827-.851-2.499-.592-3.655.407l-.82-1.552c-1.64-2.885-3.356-4.215-5.183-6.546l-1.642-1.922c-.223-.258-.297-.443-.595-.592.706 2.322 1.218 4.54 1.677 7.063-1.007-.555-1.939-1.11-2.983-1.552-.783-.297-2.796-.74-3.766-.63l1.192 1.073c2.052 1.81 3.394 4.215 4.214 6.914.896 2.92 2.984 6.026 5.184 8.17.448.444 1.715 1.59 2.535 1.886 2.461.888 2.35-.037 3.244-.48 1.894 3.206 3.113 4.813 5.296 7.246 2.349 2.478 6.042 3.143 9.397 2.367 1.492-.37 2.424-.777 3.58-1.443 4.364-2.514 2.276-4.473 1.753-6.47 1.417-.443 6.966-2.122 8.961-2.491 7.026-1.3 20.048-1.471 28.378-.259.746.108 9.144 2.344 9.964 2.825-.592 1.392-.827 2.082-.743 3.612.142 1.415 1.358 2.155 2.44 2.783 1.155.666 2.087 1.073 3.579 1.443a12.34 12.34 0 004.51.185c3.134-.518 4.775-2.33 6.118-3.956 2.23-2.546 2.925-4.09 4.065-5.88 0 0 .636.592 1.088.74.426.139 1.82-.111 2.194-.26 1.08-.405 1.752-1.219 2.496-1.922 2.314-2.218 4.253-5.102 5.185-8.244 1.118-3.698 2.647-5.435 5.37-7.839-3.518.12-4.733 1.076-6.713 2.182l.747-3.623c.223-.999.782-2.478.894-3.44-1.6 1.704-3.02 3.487-4.437 5.066-.672.888-1.418 1.627-2.089 2.588-1.41 2.176-1.141 2.243-1.678 2.958-4.95-2.75-7.174 3.949-10.516 8.06-6.204-3.487-11.608-4.582-18.907-5.916-1.635-.172-3.094-.405-4.437-.554-9.173-1.072-19.278-1.034-28.415.333-4.717.596-7.635 1.462-11.783 2.441z'/%3e%3cg fill='%23ce1126'%3e%3cpath d='M416.284 356.874c.568-1.626 1.278-1.98 2.685-2.662 4.511-2.07 6.75-2.92 11.894-4.288a66.397 66.397 0 019.062-1.703c1.574-.255 1.957-.271 4.736-.443 4.102-.222 6.488-.222 10.591 0 1.777.019 3.296.208 4.736.443 3.057.37 6.3.926 9.173 1.701 4.623 1.185 7.682 2.294 11.857 4.253 1.902.887 1.642.924 2.722 2.662 1.381-.925 2.388-2.921 3.171-4.252.41-.703 1.007-1.664 1.268-2.478.448-1.369-.411-1.81-1.045-2.329-2.31-1.997-6.637-3.734-10.33-4.77-15.848-4.399-37.66-4.584-53.474-.037-3.842 1.11-7.757 2.663-10.294 4.696-.334.258-.67.554-.967.889-.896 1.034.577 3.086 1.042 3.956.467.867.87 1.717 1.344 2.366.573.783 1.275 1.456 1.828 1.997z'/%3e%3cpath d='M400.624 342.757c1.79.334 2.423.852 3.579 2.405 2.573 3.55 2.686 6.063 7.048 10.87 1.007 1.108 1.753 1.996 3.282 2.661 1.602.703 3.281.925 5.184.667 1.788-.222 3.132-.703 4.474-1.48 0 0 1.608-.923 2.03-1.49.422-.568.506-1.91.506-1.91-1.306-.408-3.654 2.143-5.183 3.142-2.798 1.849-3.879 1.183-5.855-.556-1.716-1.478-2.35-3.068-3.469-4.991-.447-.777-1.267-1.959-.969-3.18l2.089-2.144c-.826-1.356-1.859-2.866-2.61-4.03-1.045-1.59-1.641-2.662-2.984-3.697-.783-.629-2.35-1.552-3.467-.887-.938.733-1.612 1.594-2.425 2.587-.447.517-.97 1.257-1.23 2.033z'/%3e%3cpath d='M397.644 335.944c-.412-.15-1.902-1.294-2.687-1.627l-3.281-1.11c.448.555.896.888 1.79 1.997 2.088 2.662 2.088 4.806 3.73 7.987.558 1.07 1.528 2.476 2.348 3.438.559.701 2.45 2.504 2.946 2.92 1.146.952 2.346 1.088 2.993.298.149-.56-1.352-1.555-2.171-1.961-1.008-.556-1.902-1.147-2.61-1.812-1.94-1.96-.449-4.363 1.043-6.064l1.007-1.183c.223-.802-1.406-3.075-2.275-4.214-.895-1.073-3.17-3.623-4.177-4.77.15.925.448 2.18.634 3.143.15.665.671 2.44.71 2.958zm28.975 17.937l-.784-1.848c-1.08.112-6.376 2.441-7.607 3.218-.372.222-1.863 1.404-1.156 2.144 2.052 2.218 5.147-1.034 6.974-2.441.634-.517 1.454-1.11 2.573-1.073z'/%3e%3cpath d='M406.143 349.605c-.337-.111-.262-.775-1.455-1.664-.448-.37-3.146-1.773-3.609-2.291 0 0-.884-.631-.778-1.54.08-.697.658-.827.658-.827 2.424.074 5.294 6.026 5.184 6.322zm93.32-6.74c-1.789.333-2.422.851-3.579 2.404-2.573 3.55-2.684 6.065-7.049 10.87-1.006 1.11-1.751 1.998-3.281 2.662-1.603.704-3.28.925-5.182.666-1.79-.221-3.133-.702-4.476-1.48 0 0-1.606-.923-2.03-1.49-.421-.567-.506-1.91-.506-1.91 1.305-.408 3.655 2.144 5.185 3.142 2.796 1.85 3.877 1.183 5.854-.554 1.716-1.48 2.35-3.07 3.467-4.992.447-.776 1.27-1.958.97-3.179l-2.089-2.145c.825-1.356 1.86-2.866 2.61-4.03 1.046-1.59 1.643-2.662 2.984-3.697.784-.628 2.349-1.553 3.47-.888.935.734 1.61 1.596 2.422 2.588.448.517.97 1.257 1.23 2.034z'/%3e%3cpath d='M502.455 336.061c.41-.147 1.902-1.293 2.686-1.626l3.281-1.11c-.448.556-.894.89-1.79 1.997-2.087 2.663-2.087 4.808-3.73 7.987-.558 1.072-1.528 2.477-2.349 3.44-.558.7-2.449 2.502-2.946 2.919-1.145.953-2.632.946-2.992.3-.147-.563 1.352-1.557 2.172-1.964 1.007-.554 1.901-1.145 2.61-1.81 1.94-1.96.448-4.364-1.044-6.064l-1.007-1.183c.303-1.52 1.407-3.075 2.275-4.217.896-1.071 3.17-3.622 4.176-4.77-.149.925-.446 2.183-.633 3.143-.242.987-.49 1.981-.71 2.96zm-28.977 17.94l.785-1.848c1.08.11 6.376 2.44 7.607 3.215.372.223 1.864 1.406 1.156 2.145-2.051 2.219-5.146-1.035-6.974-2.44-.633-.517-1.454-1.11-2.572-1.072z'/%3e%3cpath d='M493.956 349.714c.336-.112.26-.777 1.455-1.666.447-.369 3.146-1.772 3.609-2.29 0 0 .882-.632.778-1.539-.08-.697-.659-.828-.659-.828-2.424.074-5.295 6.027-5.183 6.323z'/%3e%3c/g%3e%3cpath d='M421.811 346.17c-.262.002-.519.097-.77.166-.382.158-.755.333-1.142.476-.158.04-.193.221 0 .24.213.17.159.479.274.705.073.26.135.524.221.78.078.333.196.656.257.991.088.327.198.648.25.982.022.144-.274.446.017.355.292-.067.545-.26.848-.284.116-.005.32-.2.089-.202-.27-.142-.178-.507-.318-.738-.062-.246-.142-.489-.192-.736.068-.286.447-.092.473.135.155.207.351.388.551.554.245.173.482.383.788.436a1.05 1.05 0 00.664-.056c-.296-.26-.646-.468-.874-.799-.194-.26-.359-.543-.544-.81.285-.265.55-.596.609-.993.027-.42-.187-.862-.558-1.07a1.581 1.581 0 00-.642-.131zm-.352.373c.234.004.421.162.535.354.13.242.213.523.19.797a.695.695 0 01-.392.571c-.168.132-.602.416-.623.034-.115-.423-.26-.842-.338-1.276-.063-.266.214-.373.416-.432a1.176 1.176 0 01.213-.048zm1.835-.966c.034.202.3.292.266.527.055.312.133.62.214.925.024.284.12.553.158.834.045.2.112.393.14.597.048.275.13.546.168.825.055.12-.273.375-.041.36.76-.213 1.53-.396 2.29-.616.2.032.261-.117.223-.289l.004-.693c-.233 0-.223.321-.4.422-.272.29-.655.435-1.028.54-.215.03-.324-.182-.352-.36-.074-.177-.048-.37-.113-.548-.067-.266-.108-.538-.166-.806.273-.113.58-.174.872-.117.147.01.27.295.397.155 0-.24-.096-.472-.138-.707-.05-.099-.075-.467-.23-.36-.078.159-.101.38-.3.438a1.834 1.834 0 01-.624.209c-.141-.144-.142-.457-.173-.676.019-.236-.142-.593.189-.644a.985.985 0 011.028.042c.112.082.369.332.382.051-.142-.225-.152-.54-.33-.73-.212-.03-.402.105-.609.134-.614.14-1.222.321-1.828.487zm5.085-1.392c-.309.018-.61.095-.913.16-.33.098-.659.205-.988.306-.254.142.252.243.227.446.036.216.07.435.123.646.041.219.1.435.122.658.08.317.13.64.195.962.023.3.157.58.159.885.056.191-.048.393-.101.54.325-.079.655-.146.975-.245.168.013.247-.221.048-.235-.141-.212-.141-.483-.21-.722-.042-.258-.103-.51-.153-.765.456-.11.92-.255 1.295-.543.25-.216.456-.51.46-.853a1.389 1.389 0 00-.251-.868 1.31 1.31 0 00-.46-.319c-.17-.048-.35-.048-.528-.053zm.567.057zm-.926.297a.681.681 0 01.631.463c.107.26.157.552.11.831-.05.183-.154.365-.346.429-.188.079-.36.258-.578.217-.13-.125-.04-.371-.14-.538-.077-.329-.116-.669-.215-.992-.041-.199.131-.352.313-.382a1.054 1.054 0 01.225-.028zm4.117-1.133c.124.116.252.225.331.38.117.155.081.36.14.537.077.26.07.537.138.798.045.22.092.44.092.664.094.274.087.574.075.858-.062.41-.497.724-.907.638a.556.556 0 01-.427-.333c-.132-.158-.176-.36-.217-.557-.048-.285-.108-.57-.146-.858-.032-.291-.084-.578-.12-.868-.035-.233-.096-.46-.13-.693-.046-.128.292-.406.026-.36-.338.033-.663.134-.998.182-.248.166.183.228.169.427.045.204.03.416.08.619.076.443.182.877.216 1.326.03.206.093.402.105.609.05.21.176.39.29.57.194.18.42.353.696.37.476.08 1.008-.03 1.349-.392.14-.177.261-.386.298-.608.012-.324.014-.653-.071-.966-.034-.325-.036-.656-.14-.967-.034-.269-.083-.538-.108-.808a.618.618 0 01-.02-.4c-.01-.14.243-.268.127-.37-.208-.01-.406.082-.613.08-.09.009-.187.04-.233.122zm3.262-.615c-.45-.013-.891.094-1.331.164-.18.07-.477.05-.582.2.128.138.28.266.254.48.091.455.128.922.212 1.38.003.29.104.567.113.856.027.337.08.676.072 1.012.013.118-.24.388 0 .335.182-.076.375-.033.564-.1a5.241 5.241 0 01.748-.111 4.792 4.792 0 00.892-.223 2.53 2.53 0 00.431-.382.7.7 0 00.194-.494c.023-.312-.027-.681-.287-.887-.164-.137-.375-.188-.574-.26-.142-.038-.32-.165-.094-.228.235-.138.442-.342.511-.612a.782.782 0 00-.161-.737c-.096-.233-.345-.31-.572-.355a2.406 2.406 0 00-.39-.038zm-.604.334c.286-.066.618.036.776.295.155.206.1.482.075.72-.01.267-.29.354-.497.44-.15.09-.529.205-.483-.095.046-.207-.037-.405-.056-.609a4.97 4.97 0 01-.02-.577zm.334 1.825c.227-.01.503-.022.657.18.213.183.276.473.274.743-.007.219.004.483-.197.625-.206.135-.463.248-.714.212-.234-.108-.216-.423-.25-.643-.03-.223-.09-.443-.103-.669-.056-.163-.099-.468.167-.416a.653.653 0 01.166-.032zm2.073-2.537c-.024.164.236.179.227.37.036.227.001.46.074.684.035.22 0 .449.057.668.07.268-.007.558.091.821.053.274-.022.562.073.828.063.244.034.529-.146.716-.085.139.22.08.307.048.328-.026.657-.038.982-.09.19-.02.38-.03.565-.077l.663-.067a3.94 3.94 0 00.113-.839c.02-.101.03-.27-.11-.177-.065.18-.193.33-.303.483a.918.918 0 01-.356.185c-.16.045-.318.107-.487.092-.184.046-.383-.03-.39-.243-.056-.26-.026-.531-.09-.791-.061-.504-.08-1.01-.115-1.515-.037-.304-.102-.608-.064-.915.018-.124.34-.369.065-.321a1.87 1.87 0 01-.477.057c-.172.018-.34.07-.515.065a1.046 1.046 0 00-.164.018zm3.143-.346c-.038.148.174.075.199.235.086.162.008.358.083.525.029.197.033.398.051.596l.145 1.911c.055.16.051.329.049.495.023.142-.203.255-.168.358.402-.01.81-.027 1.203-.116.13-.023-.002-.176-.087-.178-.119-.131-.11-.327-.132-.493-.023-.304-.026-.61-.087-.907-.029-.236.011-.479-.049-.712-.055-.33-.01-.668-.093-.993-.02-.211-.067-.434.002-.639.032-.075.272-.25.074-.233a6.928 6.928 0 00-1.125.128.255.255 0 00-.064.023zm4.99 2.58c-.218-.02-.298.204-.42.339-.13.208-.37.299-.598.35-.26.066-.492-.128-.673-.289a2.025 2.025 0 01-.338-.675c-.084-.218-.101-.452-.157-.677a4.194 4.194 0 010-1.022c.079-.235.16-.5.362-.658.262-.161.618-.082.819.142.188.15.25.382.352.588.15.235.229-.11.236-.241.024-.167.132-.343.089-.507-.14-.172-.369-.241-.574-.308-.483-.141-1.051-.061-1.427.293-.152.107-.258.26-.349.417-.115.146-.17.318-.218.494-.085.223-.093.465-.139.699-.037.51.089 1.023.28 1.492.137.236.349.415.515.632.154.207.429.263.67.293.304.027.622-.038.867-.225.221-.142.375-.359.497-.587a1.186 1.186 0 00.202-.483.135.135 0 00.003-.066zm1.729-3.152c-.18.04-.43-.02-.568.065-.04.314-.121.622-.18.933-.049.218-.116.428-.123.65-.142.544-.245 1.095-.357 1.645-.11.258-.196.526-.309.782-.128.078-.096.254.068.185l.78-.018c-.016-.175-.252-.233-.273-.423-.06-.192.02-.369.03-.555.016-.226.339-.076.49-.125l.667-.014c-.03.25.195.45.165.704.045.137-.26.419.013.391.309.023.609-.08.916-.077.282-.016-.068-.27-.091-.403-.087-.314-.215-.619-.292-.937-.127-.446-.26-.889-.383-1.336-.123-.39-.215-.79-.326-1.183-.039-.132-.014-.32-.207-.284h-.021zm-.42.968c.163.536.319 1.075.482 1.612.082.22-.154.162-.288.183-.17.017-.34.04-.511.035-.117-.166.036-.407.048-.599.023-.25.134-.484.138-.737.057-.162.01-.357.13-.495zm5.365-1.12l-1.216.077c-.072.141.215.161.159.33.028.328.007.658.007.986-.017.89-.046 1.78-.06 2.67-.013.12-.332.371-.06.349.596.02 1.209.078 1.794-.075.19-.047.345-.164.487-.292.198-.173.349-.4.472-.63a2.92 2.92 0 00.2-.832 3.362 3.362 0 00-.026-.896c-.039-.253-.142-.495-.236-.73-.125-.16-.201-.348-.342-.49a2.078 2.078 0 00-.544-.365c-.216-.003-.416-.131-.635-.1zm.101.328c.248-.009.512.126.594.372.09.167.158.338.183.528.056.197.011.405.06.605.07.375.003.756-.049 1.127a1.728 1.728 0 01-.229.782c-.064.2-.29.261-.452.345-.21.055-.498.04-.546-.222-.037-.234-.016-.475-.022-.712.004-.852.007-1.704.061-2.555-.014-.24.2-.309.4-.268zm3.712-.198a1 1 0 00-.718.208c-.243.164-.377.436-.548.665-.184.326-.252.701-.296 1.067.013.308-.046.62.009.928.098.226.152.472.233.706.075.304.3.545.543.73.194.114.395.215.624.23.427.044.832-.225 1.081-.556.188-.27.393-.545.447-.878.081-.259.104-.528.132-.796.012-.204-.034-.405-.04-.608-.03-.27-.142-.52-.256-.764-.174-.268-.312-.587-.601-.753a1.095 1.095 0 00-.61-.18zm-.012.263c.322.009.52.337.562.625.066.23.09.466.119.703-.016.389.012.779-.03 1.166-.069.247-.027.51-.125.748-.045.243-.14.487-.322.66-.166.108-.388.17-.547.01-.193-.11-.21-.342-.3-.524-.11-.317-.064-.658-.073-.987.008-.466.026-.934.042-1.399.062-.236.094-.484.203-.704a.5.5 0 01.47-.297zm1.622 4.327c.264-.026.522.095.783.086.193-.172-.21-.314-.158-.535-.022-.267.04-.532.102-.789.041-.243.068-.49.107-.733.064-.237.063-.488.126-.726.028-.205.036-.548.115-.661.13.21.056.468.133.693.043.264.054.527.101.79.051.277.09.554.11.833.05.247.08.504.114.756.056.18-.052.532.25.458.273.096.181-.27.303-.427.094-.385.167-.775.27-1.156.09-.215.12-.451.19-.672.096-.364.18-.732.33-1.08 0 1.047.08 2.098.006 3.143-.048.118-.322.314-.03.332.266.016.53.042.793.089.253.064.215-.159.056-.259-.16-.267-.058-.588-.076-.88.01-.517-.042-1.03-.035-1.547a12.06 12.06 0 01.043-1.423c.059-.08.295-.281.073-.29l-.94-.044c-.04.255-.151.495-.188.75a11.172 11.172 0 01-.24.889c-.031.273-.128.53-.183.798-.008.114-.102.237-.106.046.019-.24-.118-.461-.085-.704-.006-.2-.104-.382-.077-.588-.022-.414-.157-.817-.157-1.233-.055-.2-.335-.096-.495-.175-.172-.005-.345-.01-.517-.02.075.267.145.537.087.815-.04.232-.097.461-.114.696-.086.542-.214 1.076-.277 1.62-.077.193-.057.408-.143.595-.06.175-.108.34-.274.442a.172.172 0 00.002.111zm4.166.453c.227.092.479.073.709.148.117 0 .395.12.406-.042-.096-.146-.23-.281-.172-.474.026-.241.08-.481.068-.726-.004-.22.079-.43.078-.65a27.473 27.473 0 01.104-1.46 1.647 1.647 0 01.076-.54c-.015-.142.099-.21.189-.272.067-.233-.233-.129-.363-.166-.255-.018-.506-.089-.764-.085-.058.109.162.196.141.335.037.18-.01.364-.016.545-.079.265-.05.547-.079.82-.015.259-.045.517-.069.776-.079.19-.068.403-.07.608a3.163 3.163 0 01-.06.705c.012.154-.044.326-.17.395-.002.029-.003.056-.006.083zm1.449.315c.204-.016.4.093.6.076.111.044.34.112.228-.092a.94.94 0 01-.16-.598c-.011-.365.044-.728.095-1.088a2.47 2.47 0 01.081-.762c.022-.236.028-.476.093-.705.124.114.155.378.247.549.336.857.659 1.718.991 2.576.08.167.12.419.32.474.247.102.186-.191.196-.338.017-.216.132-.413.081-.639.035-.236.082-.472.081-.713.057-.233.089-.47.08-.71.042-.23.095-.458.079-.696.004-.253.08-.495.134-.74.005-.165.436-.335.17-.435-.233.007-.548-.158-.731-.074.048.189.213.342.18.556.029.487-.101.964-.097 1.45-.053.24-.07.503-.101.732-.134-.18-.18-.462-.284-.678-.105-.262-.193-.53-.318-.783-.053-.225-.173-.427-.236-.648l-.362-.892a4.32 4.32 0 01-.81-.168c-.208.121.12.314.086.491.065.353.003.709-.046 1.06a5.271 5.272 0 01-.076.695c-.001.25-.004.502-.09.741a7.1 7.1 0 01-.109.778c-.009.222-.219.332-.321.483-.004.033 0 .066 0 .098zm3.801-3.64c.023.153.216.254.13.434.004.209-.032.414-.067.618a3.866 3.866 0 01-.079.582c-.03.317-.097.63-.095.95-.005.19-.081.37-.073.564-.015.148-.073.288-.083.438-.02.132-.039.262-.068.391-.057.071-.094.15-.192.158-.09.188.267.168.384.199.208.046.416.065.61.138.159.056.222-.12.082-.192-.15-.195-.04-.446-.027-.667.016-.168.029-.34.071-.507.034-.224.019-.455.084-.674.023-.174.01-.355.075-.52.038-.226.002-.463.083-.681-.01-.193.044-.378.087-.563-.004-.175.046-.36.205-.45a1.552 1.552 0 00-.485-.142c-.17-.015-.33-.087-.499-.114a.202.202 0 00-.143.037zm1.328 2.98c-.016.234.01.466.047.695.048.314.196.604.382.86.11.206.335.296.52.425.233.14.537.124.78.019.146-.067.325-.102.406-.259.165-.195.364-.379.44-.632-.107-.228-.262.112-.372.178-.245.19-.618.259-.889.085-.19-.132-.289-.344-.36-.555-.044-.208-.134-.406-.111-.62a8.818 8.818 0 01.023-.845c.112-.22.047-.48.142-.707.086-.188.124-.41.266-.569a.575.575 0 01.464-.233c.188.03.31.21.43.345a.967.967 0 01.188.63c-.044.158.146.365.244.165.06-.23.219-.438.235-.675-.04-.196-.234-.298-.366-.43-.142-.104-.303-.178-.46-.256-.293-.083-.646-.123-.908.071a1.453 1.453 0 00-.467.349c-.208.2-.301.484-.41.745a3.53 3.53 0 00-.213.855c-.01.12-.01.24-.01.36zm4.364-1.632c-.266.552-.482 1.125-.743 1.677-.097.199-.146.419-.258.61-.128.294-.233.6-.406.872-.13.186-.172.466-.388.571-.178.038-.137.227.04.22.22.025.421.162.627.174.176-.103-.094-.243-.068-.39-.03-.208.057-.41.143-.59.155-.16.385-.017.565.02.137.089.365.037.461.142 0 .298-.003.595-.004.892-.162.08-.129.288.06.284.2.049.396.102.59.162.112.051.34.096.209-.09-.133-.289-.093-.611-.108-.918-.009-.256.01-.517-.036-.768-.064-.21-.017-.431-.035-.646.004-.466.032-.932-.02-1.395-.01-.22.007-.44-.02-.66-.183-.077-.386-.097-.576-.156l-.034-.01zm-.088.92l.032 1.96c-.252-.004-.484-.12-.728-.168-.137-.197.174-.372.159-.582.122-.304.276-.594.395-.9.064-.096.057-.23.142-.31zm1.956 4.114c-.011-.249-.203-.467-.124-.727-.017-.32.092-.622.16-.93.01-.223.107-.434.118-.659.05-.27.15-.529.162-.804.097-.243.177.07.19.185.143.443.243.9.366 1.348.056.197.093.398.17.587.128.367.183.755.32 1.121-.014.226.108.511.374.455.113-.25.14-.54.207-.81.064-.237.043-.492.155-.714.087-.407.108-.831.25-1.227.083-.322.165-.647.23-.973.072-.125.453-.31.17-.416-.216-.034-.46-.235-.659-.17.037.174.144.335.135.523.011.259-.083.507-.09.763a5.707 5.707 0 00-.164.655c-.053.254-.1.51-.145.764-.18-.165-.11-.448-.216-.656-.08-.293-.183-.578-.237-.878a7.466 7.466 0 01-.226-.863 2.66 2.66 0 01-.183-.666c-.152-.217-.446-.223-.672-.322-.203-.113-.362.013-.199.203.109.44.001.896-.094 1.328-.086.38-.205.758-.236 1.147-.099.24-.105.5-.17.748-.077.203-.15.44-.347.558-.254.213.234.225.365.289a.886.886 0 00.39.142zm4.266-2.873c-.142.324-.333.624-.49.942-.128.307-.312.587-.47.88-.302.528-.618 1.049-.925 1.574-.154.054-.355.282-.073.313.214.075.405.218.626.27.16-.083-.1-.293-.066-.433.02-.222.095-.431.194-.629.135-.087.341.102.501.136.16.116.53.083.489.34.013.271.013.551-.084.81-.127-.002-.2.105-.07.187.16.074.333.121.492.201.155.03.314.18.47.107-.048-.193-.125-.409-.104-.624.02-.336.02-.671.023-1.009-.004-.229.072-.45.058-.68l.044-2.217c-.223.02-.391-.178-.615-.168zm-.136.889l-.028 1.98c-.168-.038-.324-.12-.486-.178-.12-.093-.446-.123-.263-.31.135-.265.284-.521.416-.784.101-.245.237-.475.36-.71z' fill='%23eac102'/%3e%3cg transform='matrix(1.11591 0 0 1.11592 -106.897 -41.652)'%3e%3cpath d='M474.5 281.05c.065.433.033 36.778.033 40.539 0 3.595.042 5.876 1.751 8.152 1.407 1.97 3.767 3.592 6.075 4.13 1.63.333 7.631.2 9.718.2 4.635-.217 5.188.814 6.943 3.107 1.994-3.22 4.187-3.267 8.287-3.107 2.087 0 6.554.166 8.413-.233 2.217-.53 3.948-1.589 5.38-3.362 2.349-2.696 2.218-6.058 2.218-9.586v-38.312c0-1.73-.195-1.298.685-2.197l5.772-6.058-61.668.034 6.392 6.69z' fill='white'/%3e%3cpath d='M493.76 299.09v-24.768h-25.509l6.333 6.69.06 18.078z' fill='%23002d62'/%3e%3cpath d='M503.98 299.09v-24.768h25.986l-6.631 7.108v17.66zm-10.22 10.23h-19.299l-.057 15.602c.874 6.814 5.913 9.135 10.433 9.112 3.059.033 4.1-.02 8.923-.055z' fill='%23ce1126'/%3e%3cpath d='M503.98 309.32h19.418l-.063 15.602c-.456 6.754-5.913 9.135-10.433 9.112l-8.922-.055z' fill='%23002d62'/%3e%3cpath d='M474.61 281.05c.065.433.033 36.778.033 40.539 0 3.595 0 5.791 1.793 8.321 1.408 1.97 3.43 3.55 6.033 3.961 1.63.333 7.631.2 9.718.2 2.674 0 3.913-.133 5.707 1.664.554.533.685.799 1.109 1.465.228-.167.228-.2.359-.433a5.27 5.27 0 012.674-2.33c1.402-.566 3.75-.366 5.38-.366 2.088 0 6.555.166 8.414-.233 2.217-.53 4.18-1.948 5.38-3.362 2.349-2.696 2.218-6.058 2.218-9.586v-38.312c0-1.73-.195-1.298.685-2.197l5.772-6.058-61.668.033 6.392 6.69z' fill='none' stroke='black' stroke-width='.454'/%3e%3cpath d='M497.92 280.41v2.773h-2.798v2.346h2.798v9.926h2.303v-9.926h2.833v-2.346h-2.833v-2.773z' fill='%23eac102' stroke='black' stroke-width='.273'/%3e%3cg id='b'%3e%3cpath d='M481.88 284.06l.03 4.53-1.91-1.93.28 31.93c0 4.76 3.43 8.6 7.66 8.6 4.19 0 7.6-3.79 7.65-8.5l-.31-16.44-2.06-2.13-.03-1.68z' fill='white'/%3e%3cpath d='M481.88 284.22l.03 4.56-1.91-1.94.16 18.19 8.25 7.85.06-17.41-.31-.35v-2.93z' fill='%23002d62'/%3e%3cpath d='M490.77 295.51l2.424 3.079.016 1.045-2.446-2.51zm4.53 6.91l.218 11.442c-1.177 2.21-3.569 1.012-3.569 1.012l.076-15.79z' fill='%23ce1126'/%3e%3cpath d='M495.55 319.64c-3.128 2.339-3.997-1.128-3.997-1.128 2.341-.227 3.454-1.596 3.977-2.978z' fill='%23002d62'/%3e%3cpath d='M480.21 309.72c4.293 4.872 7.965 7.502 7.965 7.502.965 7.668 5.5 5.12 7.134 3.925-.923 3.596-3.868 6.223-7.359 6.223-4.23 0-7.66-3.86-7.66-8.621z' fill='%23ce1126'/%3e%3cpath d='M493.2 299.63l-.018-1.159-11.32-14.382.029 3.963z' fill='none' stroke='black' stroke-width='.262'/%3e%3cpath d='M480 286.66l.294 31.922c0 4.76 3.428 8.62 7.656 8.62 4.196 0 7.603-3.801 7.654-8.512l-.31-16.445z' fill='none' stroke='black' stroke-width='.317'/%3e%3cg fill='%23eac102' stroke='black' stroke-width='.064'%3e%3cpath d='M486.17 281.23c-.778-1.457-.622-2.085-.081-2.641l-2.933-3.006.816 4.2c.84-.212 1.425 0 2.198 1.447zm-3.02-5.65l3.002 5.623'/%3e%3cpath d='M498.07 300.74l-.762.292-11.924-20.42.702-.396z'/%3e%3cpath d='M484.98 280.59c-.102-.19.107-.507.469-.71.36-.201.736-.212.838-.022.103.19-.107.507-.468.709-.361.202-.737.212-.839.023zm-3.96 1.63c-.955-1.342-.88-1.986-.414-2.609l-3.287-2.594 1.34 4.057c.805-.32 1.412-.188 2.361 1.146zm-3.7-5.2l3.686 5.182'/%3e%3cpath d='M495.28 300.01l-.719.39-14.401-18.682.647-.484z'/%3e%3cpath d='M479.76 281.75c-.125-.175.043-.517.375-.765.333-.248.703-.308.829-.133.125.174-.043.517-.375.765-.333.248-.704.307-.829.133zm.42 4.61c-1.098-1.224-1.094-1.872-.7-2.545l-3.555-2.199 1.781 3.877c.765-.411 1.383-.349 2.474.867zm-4.25-4.75l4.237 4.724'/%3e%3cpath d='M495.66 302.86l-16.38-16.905.589-.556 16.462 16.99z'/%3e%3cpath d='M478.88 286.03c-.144-.159-.015-.518.288-.803.303-.285.665-.387.809-.228.144.159.015.518-.288.803-.303.285-.665.387-.809.228z'/%3e%3c/g%3e%3c/g%3e%3cuse height='100%25' width='100%25' transform='matrix(-1 0 0 1 998.257 0)' xlink:href='%23b'/%3e%3cg stroke='black' stroke-width='.236'%3e%3cpath d='M496.73 314.54l-.634 10.104c-.64-.057-1.877-.16-1.97-.981-.052-.464 1.263-8.732 1.313-9.536.437.12.893.323 1.291.413z' fill='%23ce1126'/%3e%3cpath d='M495.77 314.12c-.063.396-.283 2.806-.22 3.094.189.971 1.383.827 2.043.863l.126-5.18c-.22.215-1.698 1.115-1.949 1.223z' fill='%23002d62'/%3e%3cpath d='M495.88 327.04c1.664-2.085 4.784-.536 4.784-.536 3.415.766 2.565-3.136 2.565-3.136-.693-7.804-1.52-13.144-1.52-13.144l-4.989 3.331z' fill='%23002d62'/%3e%3cpath d='M495.86 327.17c-.36 2.317 1.958 1.977 1.958 1.977 2.757-.04 1.968-2.956 1.968-2.956-2.957-.849-3.926.979-3.926.979z' fill='%23002d62' stroke-width='.188'/%3e%3cpath d='M497.83 312.74c-.173 8.072-.246 8.895-.246 8.895.115 2.212 2.532 1.016 2.532 1.016.575-.24 1.208-.06 1.208-.06l-.115-2.75c4.022-.298 3.087-2.64 3.087-2.64-1.64-7.623-1.747-7.29-1.747-7.29z' fill='%23ce1126'/%3e%3cpath d='M501.31 319.81c-2.537-.04-3.568.96-3.568.96l-.103.22' fill='none' stroke-width='.225'/%3e%3cpath d='M500.99 326.45l-.875-15.193 1.75-1.172 1.517 14.216v.146c0 2.638-2.392 2.003-2.392 2.003z' fill='white' stroke-width='.209'/%3e%3c/g%3e%3cg fill='white' stroke='black'%3e%3cpath d='M488.23 302.2l6.788 12.45 14.63-9.712-7.62-11.249z' fill='black' stroke-width='.042'/%3e%3cpath d='M488.49 302.1l13.753-8.014 7.52 10.823-14.53 9.347z' stroke-width='.272'/%3e%3cpath d='M495.43 313.53l13.697-8.82-1.053-1.686-6.862-9.323-4.962 4.008-6.335 3.51-1.116-.696.223 1.488z' fill='black' stroke-width='.039'/%3e%3cpath d='M496.18 297.77c-2.026-.96-4.38 2.067-5.057 2.668-.678.601-2.041.24-2.041.24l6.179 11.086c1.823.72 2.999-1.615 3.846-2.338 1.553-1.325 3.376-1.223 3.376-1.223z' stroke-width='.148'/%3e%3cpath d='M496.36 297.88c.006-2.378 2.952-3.135 3.738-3.557.787-.422 1.033-1.906 1.033-1.906l6.927 10.563c-.126 2.081-2.591 2.288-3.55 2.826-1.758.987-1.997 2.509-1.997 2.509z' stroke-width='.148'/%3e%3cpath d='M495.02 311.82c-3.953-7.236-6.127-11.017-6.127-11.017-.093 1.326-.02 1.242-.02 1.242 4.611 7.43 6.489 11.413 6.489 11.413-.103-.548-.224-1.093-.342-1.638z' stroke-width='.105'/%3e%3cg fill='black' stroke='none'%3e%3cpath d='M490.87 302.2l.113.185c.032-.017.06-.049.055-.088.006-.029-.032-.066-.017-.085.01-.005.014.017.02.023l.13.212c-.024.021-.036-.037-.06-.04-.031-.029-.09-.023-.11.007.034.054.066.11.102.163.021.024.051.003.071-.01.056-.031.105-.085.105-.152.011-.026-.026-.067.002-.082l.068.158-.388.246c-.015-.013 0-.018.012-.025.042-.021.023-.07 0-.097l-.196-.32c-.016-.034-.059-.023-.082-.004-.01.007-.018-.016-.002-.016l.364-.231.082.134c-.024.02-.04-.034-.067-.038-.047-.028-.103-.005-.145.023zm.4-.28l.243.398a.045.045 0 00.066.023c.008.009.005.014-.005.018l-.155.099c-.02-.02.03-.03.014-.056-.017-.037-.041-.071-.062-.107l-.158-.259a.044.044 0 00-.066-.022c-.008-.008-.008-.014.003-.018zm.52-.36l.096.15c-.023.023-.037-.029-.061-.032-.057-.035-.14-.035-.186.02-.032.034-.019.101.031.11.059.015.119-.002.178-.003.056-.003.12.003.16.048.05.05.054.132.02.192a.231.231 0 01-.18.107c-.035.001-.036.04-.044.06-.01.011-.012-.008-.019-.014l-.093-.153c.022-.02.036.028.058.032.058.045.15.056.208.004.044-.032.046-.112-.01-.135-.055-.023-.117-.004-.175-.003-.062.005-.135-.003-.175-.057-.053-.062-.04-.161.02-.213a.214.214 0 01.134-.053c.035.003.038-.033.03-.055l.009-.006zm.51.27c-.015.047-.036.1-.084.122-.04.018-.087-.011-.096-.053-.014-.052.017-.101.04-.146.012-.027.04-.053.045-.08-.016-.023-.028-.049-.048-.069-.034-.022-.09.014-.082.053.022.015.061.021.056.058-.002.044-.064.068-.095.037-.033-.04-.012-.098.017-.134a.217.217 0 01.125-.08c.048-.009.091.02.11.063.033.052.064.105.098.157.009.023.04.012.036-.012.027-.003.01.032.008.048-.012.038-.053.069-.093.061a.077.077 0 01-.036-.025zm-.015-.025l-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.145-.435l.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.115.185.01.025.039.018.055.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.02-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.183c.01.024.037.03.056.025.01.009.001.013-.008.018l-.143.09c-.02-.02.03-.034.008-.06-.026-.048-.057-.094-.085-.14-.02-.034-.039-.068-.063-.099-.013-.024-.049.012-.051-.015l.126-.08zm.31-.35l.07.115.074-.047.02.033-.073.047c.043.07.085.141.13.211.01.033.06.028.061-.008.003-.014-.004-.035.017-.028.01.05-.013.108-.063.127a.09.09 0 01-.117-.046l-.121-.197-.04.026c-.017-.018.01-.04.01-.06a.452.452 0 00.021-.165l.011-.007zm.31-.05a.162.162 0 01.183.004.24.24 0 01.1.178.162.162 0 01-.074.148.152.152 0 01-.151.018.224.224 0 01-.123-.274.16.16 0 01.065-.074zm.016.023c-.044.03-.01.085.009.12.03.054.059.11.101.155.03.037.097.01.085-.039-.008-.04-.033-.074-.052-.11-.024-.04-.046-.081-.078-.114-.017-.016-.044-.028-.065-.012zm-1.666 2.067l.113.185c.032-.017.06-.049.055-.088.006-.029-.032-.066-.017-.085.01-.005.014.017.02.023l.13.212c-.024.021-.036-.037-.06-.04-.031-.029-.09-.023-.11.006.034.055.066.111.102.164.021.024.05.003.071-.01.056-.031.105-.085.105-.152.011-.026-.026-.067.002-.082l.068.158-.388.246c-.015-.013 0-.018.012-.025.042-.021.023-.07 0-.097l-.196-.32c-.016-.034-.059-.023-.082-.004-.011.007-.018-.016-.002-.016l.364-.231.082.134c-.025.02-.04-.034-.067-.038-.047-.028-.103-.005-.145.023zm.7.18l-.274-.191c-.021-.016-.05-.03-.074-.022-.005-.006-.009-.012.001-.015l.157-.1c.008.009.01.016-.004.022-.022.033.024.056.046.073l.118.082c-.01-.056-.018-.113-.03-.168-.002-.028-.027-.06-.056-.038-.005.006-.017-.012-.008-.013l.097-.061c.019.016-.015.028-.01.048.001.046.011.091.017.137l.036.236zm.33-.3c-.015.047-.036.1-.084.122-.04.018-.087-.011-.096-.053-.014-.052.017-.101.04-.146.012-.027.04-.053.045-.079-.016-.024-.028-.05-.048-.07-.034-.022-.09.014-.082.053.021.016.061.021.056.058-.002.043-.064.068-.095.037-.033-.04-.013-.098.017-.134a.217.217 0 01.125-.08c.048-.009.091.02.11.063l.097.157c.01.023.04.012.036-.012.028-.003.01.032.008.048-.011.038-.052.069-.092.061a.072.072 0 01-.036-.025zm-.015-.025l-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.155-.425l.025.04c.007-.05.033-.102.084-.12.045-.016.093.013.115.052.04.06.075.125.115.185.01.025.039.018.055.015.01.01 0 .013-.008.018l-.144.091c-.018-.018.023-.032.006-.055-.022-.044-.05-.085-.075-.127-.02-.031-.036-.064-.06-.092-.042-.033-.074.033-.067.07l.113.184c.01.024.037.03.057.024.01.009 0 .013-.008.018l-.144.09c-.02-.019.03-.034.008-.059-.026-.049-.057-.096-.086-.144-.02-.032-.038-.066-.062-.095-.013-.024-.049.012-.05-.015l.125-.08zm.45-.28l.104-.066.023.037-.06.037c.062.01.103.078.087.137a.184.184 0 01-.103.12c-.05.011-.029.1.021.07.054-.031.102-.073.163-.087.044-.01.086.022.098.063.016.05-.011.102-.048.136a.368.368 0 01-.178.096c-.05.015-.09-.047-.052-.085.006-.01.027-.025.003-.019a.071.071 0 01-.077-.066c-.004-.035.014-.068.033-.097-.048.013-.104.004-.137-.036-.046-.052-.033-.136.014-.183a.193.193 0 01.11-.057zm-.053.044c-.037.026-.015.077.003.108.022.035.044.085.091.088.044-.003.05-.06.03-.09a.281.281 0 00-.077-.105.042.042 0 00-.047 0zm.194.361c-.035.012-.073.07-.023.09.043.012.082-.02.117-.04.031-.023.08-.067.047-.107-.045-.018-.084.027-.123.045zm.339-.535l-.17.108c.028.041.07.08.122.083.049.003.083-.044.082-.09-.001-.012-.002-.022.012-.019.012 0 .002.025.006.033a.156.156 0 01-.047.125c-.04.037-.1.056-.152.034a.246.246 0 01-.13-.151c-.024-.071-.004-.162.063-.202.053-.035.126-.019.169.024a.304.304 0 01.045.055zm-.095.03c-.024-.035-.043-.081-.088-.09-.048 0-.045.06-.031.091.007.02.018.038.029.056l.09-.058zm.085-.41l.243.398a.045.045 0 00.066.023c.008.009.005.014-.005.018l-.155.099c-.02-.02.03-.03.014-.056-.017-.037-.041-.071-.062-.107l-.158-.259a.044.044 0 00-.065-.022c-.008-.008-.008-.014.003-.018l.12-.076zm.13-.11c.032-.023.082-.002.09.036.011.04-.025.083-.066.077-.044-.004-.069-.062-.042-.096a.051.051 0 01.018-.017zm.14.123l.156.256a.045.045 0 00.066.023c.007.008.007.014-.004.017l-.157.1c-.02-.019.026-.026.015-.05-.012-.034-.033-.062-.05-.093l-.09-.144c-.01-.027-.042-.025-.06-.017-.009-.007-.008-.013.002-.016l.12-.076zm.21-.133a.162.162 0 01.183.004c.059.043.1.113.1.187a.161.161 0 01-.079.141.15.15 0 01-.154.012.224.224 0 01-.114-.27.16.16 0 01.064-.074zm.016.023c-.044.03-.01.085.009.12.03.054.059.11.101.155.03.038.097.01.085-.039-.008-.04-.033-.074-.052-.11-.026-.04-.048-.085-.083-.118-.016-.014-.041-.022-.06-.008zm-1.946 2.207l.096.15c-.023.023-.037-.029-.061-.033-.057-.034-.14-.034-.186.02-.032.035-.019.102.031.112.059.014.119-.003.178-.004.056-.003.12.003.16.048.05.05.054.132.02.192a.231.231 0 01-.18.107c-.035.001-.036.04-.044.06-.01.011-.012-.008-.018-.014l-.093-.153c.021-.02.035.028.057.032.058.045.15.056.208.004.044-.032.046-.112-.009-.135-.056-.023-.117-.004-.175-.003-.063.005-.135-.004-.176-.056-.054-.065-.038-.169.027-.22a.215.215 0 01.127-.047c.036.003.038-.033.03-.055a.03.03 0 01.008-.005zm.53.08l-.17.108c.028.041.07.08.122.083.049.003.083-.044.082-.09-.001-.012-.002-.022.012-.019.012 0 .002.025.006.033a.156.156 0 01-.047.125c-.04.037-.1.056-.152.034a.245.245 0 01-.13-.151c-.024-.071-.004-.162.063-.202.053-.035.126-.019.169.024a.301.301 0 01.045.055zm-.095.03c-.024-.035-.044-.081-.088-.09-.048 0-.045.06-.031.091.007.02.018.038.029.056l.09-.058zm.235-.33l.104-.066.023.037-.06.037c.062.01.103.078.087.137a.184.184 0 01-.103.12c-.05.011-.028.1.021.07.054-.031.102-.073.163-.087.044-.01.086.022.098.063.016.05-.011.102-.048.136a.37.37 0 01-.178.096c-.05.014-.09-.047-.052-.085.006-.01.027-.025.003-.02a.071.071 0 01-.077-.065c-.004-.035.014-.069.033-.097-.048.013-.104.004-.137-.036-.046-.052-.033-.136.014-.183a.19.19 0 01.11-.057zm-.053.044c-.037.026-.015.077.003.108.022.035.044.085.091.088.044-.003.05-.06.03-.09a.284.284 0 00-.077-.105.042.042 0 00-.047 0zm.194.361c-.035.012-.073.07-.023.09.043.012.082-.02.117-.04.031-.023.08-.067.047-.107-.045-.018-.084.027-.123.045zm.299-.685l.16.262a.04.04 0 00.059.02c.008.008.005.014-.005.018l-.115.072-.025-.042c-.005.051-.033.104-.083.121-.044.015-.092-.01-.114-.048-.042-.061-.077-.126-.118-.188-.01-.024-.038-.017-.054-.014-.009-.008-.004-.013.005-.017l.115-.073.145.236c.015.042.074.03.076-.013.005-.02.01-.04-.005-.056l-.103-.167a.04.04 0 00-.057-.02c-.008-.008-.008-.014.003-.018zm.21-.13l.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.116.185.01.025.038.018.054.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.02-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.184c.01.023.037.03.056.024.01.009.001.013-.008.018l-.143.09c-.02-.019.03-.034.008-.059-.027-.05-.058-.096-.086-.144-.02-.032-.038-.066-.062-.096-.013-.024-.049.013-.051-.015l.126-.08zm.62-.6l.096.15c-.023.023-.037-.029-.061-.033-.057-.034-.14-.034-.186.02-.032.035-.019.102.031.112.059.014.119-.003.178-.004.056-.003.12.003.16.048.05.05.054.132.02.192a.231.231 0 01-.18.107c-.035.001-.036.04-.044.06-.01.012-.012-.008-.018-.014l-.094-.153c.022-.02.036.028.058.032.058.045.15.056.208.004.044-.032.046-.112-.009-.135-.056-.023-.117-.004-.175-.003-.063.005-.135-.003-.176-.056a.158.158 0 01.02-.214.213.213 0 01.134-.053c.036.003.038-.033.03-.055l.008-.006zm.5.24c-.015.047-.036.1-.084.122-.04.019-.087-.012-.096-.053-.014-.05.015-.098.038-.14.012-.03.041-.057.047-.085-.016-.024-.028-.05-.048-.07-.033-.022-.09.014-.082.053.021.016.061.021.056.058-.002.044-.064.068-.095.037-.033-.04-.013-.098.017-.133a.216.216 0 01.125-.081.104.104 0 01.11.063l.097.157c.01.023.04.012.036-.012.028-.003.01.032.007.048-.011.038-.052.069-.092.061a.075.075 0 01-.037-.025zm-.015-.025l-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.155-.415l.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.116.185.01.025.038.018.054.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.019-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.184c.01.023.037.03.057.024.01.009 0 .013-.008.018l-.144.09c-.02-.02.03-.034.008-.059-.026-.05-.057-.096-.086-.144-.02-.032-.038-.066-.062-.096-.013-.024-.049.013-.05-.015l.125-.079zm.42-.44c-.008-.009-.009-.015.003-.02l.227-.144c.008.01.01.016-.003.02-.038.015-.043.06-.016.09l.155.254c.024.041.044.091.025.138a.194.194 0 01-.146.119c-.048.008-.108-.012-.124-.062-.014-.042.03-.088.072-.074.044.01.031.062.043.092.04.024.097-.03.065-.071-.04-.075-.087-.147-.131-.22-.028-.044-.053-.09-.083-.133-.02-.026-.056-.012-.077.004l-.01.006zm.64-.23l.16.262a.04.04 0 00.059.02c.008.008.005.014-.005.018l-.115.072-.025-.042c-.005.049-.03.099-.076.119a.097.097 0 01-.118-.042c-.043-.062-.079-.129-.12-.192-.01-.024-.039-.017-.055-.014-.009-.008-.004-.013.005-.017l.115-.073c.048.079.095.158.145.236.015.042.074.03.076-.013.005-.02.009-.04-.005-.056l-.103-.167a.04.04 0 00-.058-.02c-.008-.008-.008-.014.003-.018zm.41.1c-.015.047-.036.1-.084.122-.04.019-.087-.012-.096-.053-.014-.052.017-.101.04-.146.012-.027.04-.053.045-.08-.016-.023-.028-.049-.048-.069-.034-.022-.09.014-.082.053.021.015.061.02.056.057-.002.044-.064.069-.095.037-.033-.04-.013-.097.017-.133a.216.216 0 01.125-.08c.048-.009.091.02.11.063l.097.157c.01.023.04.012.036-.012.028-.003.01.032.008.048-.011.038-.052.069-.092.061a.074.074 0 01-.037-.025zm-.015-.025l-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.145-.425l.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.115.185.01.025.039.018.055.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.019-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.184c.01.023.037.03.057.024.01.009 0 .013-.008.018l-.144.09c-.02-.02.03-.034.008-.059-.026-.05-.057-.096-.086-.144-.02-.032-.038-.066-.062-.096-.013-.024-.049.012-.051-.015l.125-.079zm-2.7 4.74l.105.148c-.022.018-.04-.03-.064-.033a.165.165 0 00-.187.012.17.17 0 00-.07.161c.009.078.048.15.098.209.042.049.107.082.173.07.076-.013.147-.071.16-.15.012-.02-.001-.062.017-.07.02.001.002.042.006.057a.23.23 0 01-.112.177.238.238 0 01-.225.026.304.304 0 01-.16-.387.262.262 0 01.223-.159c.035.002.025-.04.028-.056zm.54.08l-.174.11c.007.042.01.085.021.126.008.042.057.017.077.01.012.01 0 .015-.01.02l-.126.08c-.022-.022.034-.035.024-.064.002-.05-.011-.1-.018-.151l-.059-.397c.009-.01.017-.005.025.003l.391.281c.03.027.076.032.108.017.012.01 0 .014-.01.02l-.161.102c-.023-.022.035-.029.025-.057-.008-.03-.04-.044-.062-.062l-.051-.037zm-.025-.019l-.188-.136.034.234.155-.098zm.305-.251c.031.05.061.102.094.152.015.035.058.038.084.014.007-.011.016 0 .016.007l-.191.121c-.009-.009-.009-.015.004-.02.041-.016.04-.066.014-.096l-.192-.314a.053.053 0 00-.086-.018c-.008.01-.018.002-.018-.007.067-.042.132-.086.2-.125.048-.028.109-.042.161-.018.075.035.106.14.058.207a.283.283 0 01-.144.097zm-.012-.02c.042-.014.092-.036.1-.086.016-.063-.03-.131-.09-.151-.047-.014-.094.014-.125.05l.115.188zm.592-.05c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.042-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm.13-.71l.07.104c-.024.021-.035-.036-.064-.034-.043-.015-.08.018-.115.039l-.026.017.221.362c.015.037.059.043.087.017.007-.013.02.006.012.01l-.186.118c-.011-.01-.006-.016.006-.021.043-.02.033-.07.008-.1l-.212-.346c-.034.023-.072.04-.1.072-.023.03-.001.074 0 .1-.01.012-.012-.007-.018-.014l-.05-.091.367-.232zm.36-.2c-.012-.01-.004-.017.007-.022l.144-.091c.012.01.004.017-.007.022-.042.022-.03.075-.004.105.044.074.091.147.133.222.026.046.042.102.023.153-.024.075-.097.12-.166.149a.159.159 0 01-.19-.063c-.05-.072-.093-.148-.139-.222-.018-.027-.031-.062-.064-.072-.022-.005-.041.016-.058.02-.013-.01 0-.015.01-.021l.177-.113c.012.011.004.017-.007.023-.042.019-.033.07-.008.1.045.072.089.146.135.218.029.04.064.089.119.089a.178.178 0 00.147-.094.129.129 0 00.002-.127c-.033-.068-.077-.131-.115-.197-.021-.032-.037-.068-.065-.094-.025-.017-.051.003-.073.015zm.74-.05c.013-.01.015.002.017.013.01.044.022.087.033.13l-.348.22c-.011-.01-.005-.016.006-.021.044-.02.032-.072.007-.102l-.188-.307a.054.054 0 00-.087-.018c-.007.013-.023-.004-.014-.009l.2-.126c.021.023-.033.028-.039.05-.023.033.007.066.023.094.059.097.117.194.177.29.022.046.07.014.098-.007.038-.026.083-.047.106-.089.019-.036.013-.079.008-.118zm.08-.5c.1-.067.243-.04.321.048a.3.3 0 01.076.277.256.256 0 01-.276.193.274.274 0 01-.2-.14.278.278 0 01-.026-.253.26.26 0 01.105-.125zm.009.029a.152.152 0 00-.07.15.423.423 0 00.105.217c.043.049.106.093.174.081a.161.161 0 00.128-.157.387.387 0 00-.088-.211c-.04-.054-.097-.107-.169-.107a.155.155 0 00-.08.026zm.881-.589c.021.02-.025.033-.02.058-.006.046.008.092.013.139l.068.41c-.009.01-.017.008-.026 0l-.415-.29c-.025-.029-.067-.008-.09-.006-.012-.01.004-.013.011-.018l.167-.106c.024.023-.038.032-.028.062.01.03.041.046.066.064l.264.185-.06-.353c.002-.043-.041-.07-.077-.044-.007.004-.017-.015-.003-.016l.13-.084zm.49.31c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.042-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm.23-.15c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.041-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm.22-.14c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.042-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm-3.92 4.12c-.009-.055-.003-.12.043-.158.035-.032.088-.05.134-.029.053.02.07.082.06.133.002.014-.018.046-.005.047a.14.14 0 01.143.057.185.185 0 01-.008.225.271.271 0 01-.121.083c-.034.015-.07-.033-.033-.054.038-.021.089-.003.123-.036.047-.037.048-.113.007-.155a.12.12 0 00-.12-.042c-.025 0-.05.019-.068.027-.015-.017.025-.027.026-.046a.12.12 0 000-.142c-.03-.048-.104-.046-.138-.003-.026.023-.024.067-.033.092a.28.28 0 01-.01 0zm.36-.29l.076-.123c.008-.008.014-.007.017.004l.24.39c.011.032.046.046.073.024.01-.012.017-.008.022.004l-.169.107c-.022-.022.03-.026.033-.05.008-.028-.018-.051-.03-.075-.056-.091-.11-.183-.168-.274-.011-.03-.052-.052-.071-.016-.01.013-.01.02-.023.01zm.73-.51l.157-.1c.02.018-.015.02-.019.037-.032.048-.022.107-.025.161l-.002.195c.03.046.056.095.088.14.018.034.058.022.082.003.01-.004.017.016.001.017l-.18.114c-.012-.01-.005-.017.007-.022.043-.02.03-.071.006-.1l-.064-.105c-.094-.043-.187-.089-.281-.13-.026-.019-.065.003-.084-.003-.01-.01.012-.013.018-.02l.17-.108c.02.018-.016.02-.021.037-.03.038.023.06.052.073l.174.082.002-.216a.046.046 0 00-.075-.045.047.047 0 01-.005-.01zm.82.04c-.008.052-.043.101-.095.115-.068.02-.142-.02-.178-.078a.225.225 0 01-.016-.226c.026-.044.08-.08.132-.067-.025-.04-.048-.082-.076-.12-.018-.027-.044 0-.056.01-.013-.005-.007-.012 0-.02.02-.027.039-.056.06-.083.007-.006.015-.011.019.002.079.129.156.257.236.385.01.026.047.054.066.02.005-.015.024.005.01.012l-.061.086c-.008.005-.016.014-.02 0l-.02-.036zm-.014-.024l-.097-.158c-.025-.037-.078-.06-.12-.035-.044.03-.043.095-.023.14.025.059.07.122.138.132a.082.082 0 00.094-.051.147.147 0 00.008-.028zm.094-.236c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.023.046.007.053-.006.113-.05.146a.148.148 0 01-.163.012.248.248 0 01-.106-.136.166.166 0 01.051-.188.134.134 0 01.138-.023c.027.012.063.04.066.066zm-.012-.02l.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.117a.14.14 0 00.008.02zm.572-.22a.184.184 0 01-.014.172.134.134 0 01-.145.05c-.066-.016-.112-.073-.138-.133-.033-.075-.009-.175.064-.218a.124.124 0 01.132-.008c.03.015.027.061-.007.07-.046.02-.055-.06-.102-.042-.048.013-.068.067-.056.112a.208.208 0 00.123.145c.05.02.109-.01.126-.06.015-.026.003-.064.007-.087zm-.1-.44c.047-.032.088.054.035.072-.045.017-.076-.047-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.051-.003-.03-.024-.053-.038-.078-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.01-.008-.006-.014-.01-.005-.017.022-.03.042-.06.064-.088zm.414.107c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.124a1.04 1.04 0 01.076-.108c-.015-.026-.03-.055-.06-.067-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.099.073-.124.034-.022.08-.042.118-.018.028.02.042.052.06.08.029.045.055.092.086.136.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02-.005 0-.004-.015-.01-.013zm-.013-.022l-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.068.032-.014.045-.052.056-.08zm.113-.608c-.006-.008-.01-.015.001-.018l.183-.116c.006.008.01.014-.001.018-.033.014-.048.055-.024.084l.158.26c.026.045.042.1.025.152a.115.115 0 01-.103.081c-.049.006-.079-.072-.023-.086.035-.011.064.055.094.021.01-.03-.014-.056-.028-.081l-.186-.303c-.014-.037-.059-.042-.087-.018zm.42.09c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.023.046.007.053-.006.113-.05.146a.147.147 0 01-.156.016.242.242 0 01-.113-.14.166.166 0 01.05-.188.134.134 0 01.14-.023c.026.012.062.04.065.066zm-.012-.02l.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.117a.14.14 0 00.008.02zm.382-.39l.064.105c-.017.018-.03-.018-.046-.023a.087.087 0 00-.122.018c-.03.04.014.09.058.082.047 0 .093-.014.14-.008a.099.099 0 01.087.087c.005.055-.033.107-.083.128-.025.016-.067.012-.077.044-.007.008-.01.001-.014-.006l-.06-.1c.017-.017.027.019.044.023.04.03.104.03.137-.011.026-.03.008-.08-.03-.09-.058-.013-.118.01-.176-.003-.057-.016-.085-.09-.058-.14.018-.04.06-.062.1-.071.017-.001.029-.014.026-.03l.01-.006zm.35-.19c.049.079.096.158.146.236.013.034.052.027.066.004.01.004.01.01.003.017-.02.03-.04.059-.062.087-.007.003-.015.013-.018 0l-.035-.058c-.01.045-.017.099-.058.127-.036.03-.092.02-.12-.016-.033-.038-.056-.084-.083-.127-.018-.028-.033-.059-.055-.084-.02-.022-.05.006-.065.005-.009-.008-.003-.013.005-.016l.095-.06.133.215c.017.043.077.051.103.012.014-.023.038-.057.027-.083l-.106-.173c-.014-.032-.052-.023-.073-.009-.006-.007-.01-.013.002-.017zm.26-.19l.064.105c-.017.018-.03-.018-.046-.023a.087.087 0 00-.122.018c-.03.04.015.09.058.082.047 0 .093-.014.14-.008a.099.099 0 01.087.087c.005.055-.033.107-.082.128-.026.016-.068.012-.078.044-.007.008-.01.001-.014-.006l-.06-.1c.017-.017.027.019.044.023.04.03.104.03.137-.011.026-.03.008-.08-.03-.09-.06-.014-.123.014-.184-.005-.053-.021-.076-.093-.048-.143.02-.037.06-.056.099-.066.016-.002.028-.013.025-.03zm.57.02c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.124.023-.038.05-.073.076-.108-.015-.026-.031-.055-.06-.067-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.1.073-.125.034-.02.08-.04.118-.018.028.02.042.052.06.08.029.046.055.093.086.137.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02l-.004-.007-.004-.006zm-.013-.022l-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.068.032-.014.045-.052.056-.08zm-4.497 3.472l.258.42c.013.039.055.03.077.016.009.008.003.013-.006.017l-.137.087c-.021-.02.03-.024.022-.05-.004-.03-.025-.053-.039-.08-.06-.096-.117-.193-.178-.288-.01-.027-.044-.047-.062-.016-.003.012-.025-.003-.012-.01.021-.029.041-.06.063-.088l.014-.009zm.33 0a.16.16 0 01.158-.01.21.21 0 01.117.184.167.167 0 01-.08.154.153.153 0 01-.157.007.211.211 0 01-.115-.193.165.165 0 01.077-.142zm.003.028c-.038.024-.044.076-.028.115a.284.284 0 00.135.155c.04.022.096.008.115-.035.02-.046-.005-.094-.029-.133-.03-.05-.074-.1-.135-.113a.087.087 0 00-.058.011zm.377-.268l.064.105c-.017.018-.03-.018-.046-.023-.036-.03-.095-.02-.122.018-.03.04.015.09.058.082.047 0 .093-.014.14-.008a.099.099 0 01.087.087c.005.055-.033.107-.083.128-.025.016-.067.012-.077.044-.007.008-.01.001-.014-.006l-.06-.1c.017-.017.027.019.044.023.04.03.104.029.137-.011.026-.03.008-.08-.03-.09-.058-.013-.118.01-.176-.003-.057-.016-.084-.09-.058-.14.018-.04.06-.061.1-.07.017-.002.029-.015.026-.03l.01-.007zm.22-.35c.048-.032.089.054.035.073-.045.017-.074-.048-.035-.073zm.127.143l.198.324c.03.05.046.117.013.17-.024.036-.07.075-.115.06-.042-.028.008-.08.045-.06a.039.039 0 00.049-.057c-.034-.064-.075-.125-.112-.188-.032-.05-.06-.102-.096-.15-.018-.028-.043.009-.056.01-.014-.004-.002-.013.003-.02.02-.028.038-.056.059-.082zm.363-.213c.049.079.096.158.146.236.013.034.052.027.066.004.01.004.01.01.003.017-.02.03-.04.059-.062.087-.007.003-.015.013-.018 0l-.035-.058c-.01.045-.017.099-.058.127-.036.03-.092.02-.12-.016-.032-.038-.055-.083-.082-.126-.019-.028-.034-.06-.056-.086-.02-.022-.05.006-.065.005-.009-.008-.003-.012.005-.016l.095-.06.133.216c.017.042.077.051.103.012.014-.023.038-.057.027-.084l-.106-.172c-.014-.032-.052-.024-.073-.009-.006-.007-.01-.014.002-.017zm.45.1c-.008.052-.043.101-.095.115-.068.02-.142-.02-.178-.078a.225.225 0 01-.016-.226c.027-.044.08-.08.132-.067-.025-.04-.048-.082-.077-.12-.017-.027-.043 0-.055.01-.013-.005-.007-.012 0-.02.02-.027.039-.056.06-.083.007-.006.015-.011.019.002.078.128.156.257.236.385.01.026.046.054.066.02.005-.015.024.005.01.011-.02.03-.04.059-.061.087-.008.005-.016.014-.02 0l-.02-.036zm-.014-.024l-.097-.158c-.025-.037-.078-.06-.12-.035-.044.03-.043.095-.023.14.025.06.07.122.138.132a.082.082 0 00.094-.051.137.137 0 00.008-.028zm-.056-.556c.047-.032.088.054.035.072-.045.017-.076-.047-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.052-.003-.029-.024-.052-.038-.077-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.01-.008-.006-.014-.01-.005-.017.022-.03.042-.06.064-.088zm.224-.153a.16.16 0 01.158-.01.21.21 0 01.117.184.167.167 0 01-.08.154.153.153 0 01-.157.007.211.211 0 01-.115-.193.165.165 0 01.077-.142zm.003.028c-.038.024-.044.076-.028.115a.284.284 0 00.135.155c.04.022.096.008.115-.035.02-.046-.005-.094-.029-.133-.03-.05-.074-.1-.135-.113a.082.082 0 00-.058.011zm.387-.278l.064.105c-.021.018-.037-.028-.06-.03-.045-.028-.119.004-.118.06.007.046.063.053.1.045.052-.004.107-.02.153.01.044.03.054.094.027.137-.024.049-.078.069-.126.083-.013.003-.022.044-.033.017l-.06-.099c.02-.018.035.03.06.031.042.024.108.013.13-.035.016-.038-.02-.08-.06-.078-.056-.005-.115.017-.17-.004a.105.105 0 01-.032-.154c.024-.035.068-.045.106-.058.015-.008 0-.025.019-.03zm.5-.32l.25.409c.013.036.054.028.076.012.01.009.005.015-.005.02l-.14.088c-.02-.016.01-.02.018-.034.02-.026-.007-.053-.02-.077l-.073-.12c-.006.05-.022.109-.072.132-.06.027-.133-.004-.172-.053-.049-.059-.074-.142-.046-.216.02-.058.075-.11.14-.11.025.002.02-.045.044-.051zm.093.277c-.032-.052-.063-.105-.096-.156-.02-.037-.071-.044-.104-.02-.049.03-.056.098-.032.146.024.054.064.114.128.122a.093.093 0 00.103-.079c-.004.001.007-.014.002-.013zm.257-.467c.049.079.096.158.146.236.013.034.052.027.066.004.01.004.01.01.003.017-.02.03-.04.059-.062.087-.007.003-.015.013-.018 0l-.035-.058c-.01.045-.017.099-.058.127-.036.03-.092.02-.12-.016-.032-.038-.055-.083-.082-.126-.019-.028-.034-.06-.056-.086-.02-.022-.05.006-.065.005-.009-.008-.003-.012.005-.016l.095-.06.133.216c.017.042.077.051.103.012.014-.023.038-.057.027-.084l-.106-.172c-.014-.032-.051-.024-.073-.009-.006-.007-.01-.014.002-.017zm.19.02c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.024.046.007.053-.006.113-.05.146a.147.147 0 01-.156.016.242.242 0 01-.114-.14.166.166 0 01.051-.188.134.134 0 01.138-.023c.027.012.063.04.066.066l-.206.13zm-.012-.02l.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.117a.14.14 0 00.008.02zm.372-.59l.258.42c.013.039.055.03.077.016.009.008.003.014-.006.018l-.137.087c-.021-.021.03-.025.022-.05-.004-.03-.025-.054-.039-.08-.06-.096-.117-.193-.178-.29-.01-.026-.044-.046-.062-.015-.003.013-.025-.003-.012-.01.021-.029.041-.059.063-.087l.014-.01zm.3.2c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.024.046.007.053-.006.113-.05.146a.147.147 0 01-.156.016.242.242 0 01-.114-.14.166.166 0 01.051-.188.134.134 0 01.138-.023c.027.012.063.04.066.066zm-.012-.02l.14-.089c-.018-.034-.056-.06-.096-.048-.048.013-.07.073-.052.117a.14.14 0 00.008.02zm-3.718 3.19l.137.225c.01-.049.02-.107.07-.132.043-.027.096.002.12.04.043.06.077.125.118.185.014.03.049.014.066.008.011.01-.003.014-.011.02l-.133.084c-.02-.02.024-.022.025-.042.01-.027-.014-.049-.025-.07-.032-.051-.06-.104-.097-.151-.03-.044-.091-.014-.105.028-.007.022-.024.048-.005.067.035.057.069.115.106.171.014.035.053.004.07.006.01.01-.007.014-.013.02l-.133.083c-.02-.022.037-.029.024-.058-.013-.037-.038-.069-.057-.103-.055-.088-.108-.178-.164-.265-.013-.035-.052-.025-.067-.004-.014-.005-.005-.014.001-.022.02-.027.039-.055.06-.082l.013-.009zm.68.16c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.124a1.04 1.04 0 01.076-.108c-.015-.026-.031-.055-.06-.067-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.1.073-.125.034-.02.08-.04.118-.018.028.02.042.053.06.08.029.046.055.093.086.137.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02l-.004-.007-.004-.006zm-.013-.022l-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.067.032-.013.045-.05.056-.08zm.093-.328c.002-.052.022-.112.075-.132.063-.026.137.01.174.062a.215.215 0 01.044.19.178.178 0 01-.136.133c-.024 0-.062.019-.078 0l-.214-.35c-.011-.027-.047-.053-.067-.019-.004.014-.025-.004-.011-.01a1.4 1.4 0 01.063-.088c.007-.005.016-.013.019 0zm.013.021l.113.184c.044.012.103 0 .12-.047.023-.059-.006-.121-.04-.168-.028-.04-.08-.072-.129-.056-.038.012-.057.051-.064.087zm.197-.451c.047-.032.087.054.035.072-.045.017-.076-.048-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.052-.003-.029-.024-.052-.038-.077-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.01-.008-.006-.014-.01-.005-.017.022-.03.042-.06.064-.088l.013-.01zm.414.107c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.123a1.04 1.04 0 01.076-.11c-.015-.025-.031-.054-.06-.066-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.1.073-.124.034-.022.08-.042.118-.018.028.02.042.052.06.08.029.045.055.092.086.136.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02-.005 0-.004-.014-.01-.013zm-.013-.022l-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.067.032-.013.044-.05.056-.08zm.113-.308c.007-.052.023-.113.074-.136.044-.023.094.008.119.045.039.058.072.12.11.177.014.032.052.024.07.012.01.008.004.014-.005.017l-.139.088c-.01-.01-.004-.017.01-.022.034-.022.01-.061-.007-.085-.03-.047-.057-.096-.088-.142a.058.058 0 00-.102-.007c-.014.023-.038.056-.024.082l.106.173c.014.035.054.018.073.009.009.008.003.013-.006.017l-.139.088c-.011-.012-.002-.017.01-.024.03-.024.004-.06-.01-.084-.036-.056-.068-.113-.106-.167-.015-.027-.045-.01-.057.007-.008-.005-.014-.01-.005-.017.021-.03.041-.06.063-.088.007-.005.015-.013.018 0zm.76-.3a.184.184 0 01-.014.172.134.134 0 01-.145.05c-.066-.016-.112-.073-.138-.133-.033-.075-.009-.175.064-.218a.124.124 0 01.132-.008c.03.015.027.061-.007.07-.046.02-.055-.06-.102-.042-.048.013-.068.067-.056.112a.208.208 0 00.123.145c.05.02.109-.01.126-.06.015-.026.003-.064.007-.087zm.01-.28l.042.07c0-.042 0-.093.036-.12.036-.031.096.02.06.056-.021.025-.073-.012-.077.032 0 .023-.01.05.005.07.03.049.06.1.092.148.015.034.059.032.082.017.004.006.008.012-.002.015l-.147.094c-.019-.019.02-.023.023-.041.01-.026-.012-.047-.023-.068-.034-.055-.067-.111-.103-.165-.014-.029-.049-.014-.06.006-.005-.005-.015-.009-.007-.015l.066-.09c.004-.004.01-.006.013-.009zm.25-.01c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.023.046.007.053-.006.113-.05.146a.147.147 0 01-.156.016.242.242 0 01-.113-.14.166.166 0 01.051-.188.134.134 0 01.138-.023c.027.012.063.04.066.066zm-.012-.02l.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.118a.12.12 0 00.008.02zm.172-.47c.047-.032.087.054.035.072-.045.017-.076-.047-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.052-.003-.029-.024-.052-.038-.077-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.008-.008-.005-.014-.009-.005-.016.022-.03.042-.06.064-.088l.013-.01zm.474.107c-.008.054-.046.105-.101.117-.07.016-.143-.027-.177-.088a.224.224 0 01-.011-.218c.026-.044.08-.08.132-.068-.025-.04-.048-.082-.077-.12-.017-.026-.043.002-.055.011-.013-.005-.007-.013 0-.02.02-.028.039-.056.06-.083.007-.006.015-.011.019.002.079.128.156.257.236.384.01.027.046.055.066.02.005-.014.024.006.01.012-.02.029-.04.059-.061.087-.008.005-.016.014-.02 0l-.02-.036zm-.014-.024l-.097-.158c-.025-.037-.078-.06-.12-.035-.044.03-.043.095-.023.14.025.06.07.122.138.132a.083.083 0 00.094-.051.137.137 0 00.008-.028zm.114-.426a.16.16 0 01.158-.01.209.209 0 01.117.19.168.168 0 01-.088.153.156.156 0 01-.164-.006.215.215 0 01-.093-.234.169.169 0 01.07-.093zm.003.028c-.039.024-.044.076-.028.115a.283.283 0 00.135.155c.04.021.096.008.114-.036.021-.045-.005-.094-.028-.132-.03-.05-.075-.1-.135-.113a.085.085 0 00-.058.011zm-1.023-9.288l.082.135c-.018.02-.027-.026-.045-.03-.05-.044-.14-.032-.172.027-.02.036-.002.09.041.095.075.013.151-.009.226.002a.119.119 0 01.092.138c-.011.068-.074.116-.139.128-.025.005-.071.015-.053.05-.008.008-.013.003-.017-.006l-.074-.121c.02-.02.03.026.049.03.053.044.139.023.177-.03.032-.042.006-.107-.046-.114-.052-.008-.104.003-.157 0-.047.002-.1-.008-.128-.05-.04-.053-.018-.134.035-.171.032-.032.082-.026.118-.047.011-.015-.01-.03.011-.036zm.12-.11c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.044.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.012-.008zm.212-.113l.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.021-.022-.034-.038-.019-.004.012-.018-.007-.01-.009l.08-.051c.003.005.014.012.001.015-.019.017-.012.044-.009.066l.044.272c-.005.001-.01.01-.015.005l-.232-.166c-.018-.018-.046-.009-.063-.007a.03.03 0 01-.005-.007zm.43-.28a.137.137 0 01.142-.006c.066.033.1.111.093.183-.008.077-.089.14-.166.123a.175.175 0 01-.132-.144.15.15 0 01.028-.124.138.138 0 01.035-.032zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.039 0-.08.012-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.19-.11a.137.137 0 01.142-.006c.066.033.1.111.092.183-.008.077-.088.14-.165.123a.175.175 0 01-.132-.144.149.149 0 01.034-.131.155.155 0 01.029-.025zm.003.024c-.043.026-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.177-.264l.053.086.06-.038a.449.449 0 00.013.02l-.06.039.107.176c.01.025.046.037.06.01.012-.013 0-.033.017-.039.011.038-.003.091-.044.105-.038.012-.067-.02-.082-.05l-.105-.172-.041.026c-.015-.014.011-.028.01-.044.015-.037.007-.078.006-.114zm.22-.02l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.012l.056-.078zm.24-.15a.137.137 0 01.142-.006c.066.033.1.111.093.183-.008.077-.089.14-.166.123a.175.175 0 01-.132-.144.15.15 0 01.028-.124.138.138 0 01.035-.032zm.003.024c-.043.026-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234l.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 01-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.039 0-.08.012-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm-2.08 2.39c.02-.028.04-.057.061-.084.007-.007.012-.006.016.003l.031.051c-.002-.042.006-.09.045-.115.04-.027.094-.015.129.014.062.05.098.14.07.218a.124.124 0 01-.106.079c-.014-.002-.025-.005-.013.008.02.032.039.067.062.097.016.023.043-.006.057-.003.009.008 0 .011-.007.015l-.124.08c-.01-.01-.004-.015.007-.02.033-.021.009-.057-.007-.08l-.158-.257c-.01-.03-.044-.017-.057-.002l-.007-.005zm.119-.012c.027.044.053.09.083.133.026.034.082.028.107-.005.028-.038.011-.09-.01-.126-.024-.043-.063-.089-.116-.087-.044.004-.06.048-.064.085zm.271-.148c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.044.125a.128.128 0 01-.146.007.22.22 0 01-.089-.13.139.139 0 01.055-.149.112.112 0 01.118-.012c.02.01.046.033.051.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016-.019.028-.016.064-.002.092zm.23-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077z'/%3e%3cpath d='M498.8 298.84c.009-.045.02-.1.068-.12a.077.077 0 01.088.021c.006-.046.02-.098.067-.119.04-.02.087.008.107.044.032.05.06.101.093.15.012.028.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.052-.011-.027-.03-.052-.045-.077-.021-.034-.04-.07-.065-.1-.037-.04-.09.008-.097.049-.01.015-.007.03.005.043.03.047.057.096.088.143.013.03.047.002.06.005.01.009-.008.012-.014.018l-.113.071c-.018-.02.033-.025.023-.05-.007-.025-.024-.046-.037-.069-.022-.035-.042-.073-.068-.106-.03-.039-.085-.01-.097.03-.009.019-.017.04 0 .056.03.048.058.098.09.145.012.028.044.008.059.004.01.01-.006.013-.013.018a54.84 54.84 0 01-.111.07c-.018-.018.032-.023.02-.048-.013-.035-.036-.065-.055-.097-.022-.034-.04-.072-.068-.1-.016-.014-.044.034-.044.006.019-.026.037-.054.057-.08.009-.01.014-.004.019.007l.027.042zm.62-.16c-.015.043-.032.098-.084.107-.05.01-.095-.044-.086-.092.01-.055.049-.098.08-.143.015-.01-.008-.025-.011-.036-.02-.04-.078-.039-.098 0-.01.016-.003.034.007.048.02.02.005.06-.025.05-.044-.022-.028-.087.002-.115.031-.03.074-.058.119-.049.03.01.044.04.06.066l.076.12c.008.022.036.013.036-.008.003-.005.003-.022.007-.021.003.007.012.013.008.022-.001.035-.025.096-.069.075-.01-.005-.016-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm.091-.271c.007-.044.02-.096.064-.117.037-.02.08.006.101.039.033.05.062.102.095.152.011.026.043.022.06.009.006.007.006.012-.003.015l-.12.076c-.009-.01-.003-.014.007-.02.03-.018.009-.052-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.031.05.06.1.092.149.012.03.046.015.062.007.007.007.003.01-.005.014l-.118.076c-.007-.008-.006-.014.005-.018.03-.019.008-.053-.006-.075-.029-.047-.056-.094-.087-.14-.012-.028-.04-.01-.053.002-.008-.004-.01-.009-.003-.015.018-.024.035-.05.054-.074.006-.004.012-.01.015 0zm.29-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.112.112 0 01.118-.012c.02.01.047.033.051.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.087.087 0 000 .092zm.48-.193c.018.047.02.105-.011.147a.114.114 0 01-.125.043c-.059-.014-.1-.067-.12-.121a.151.151 0 01.057-.18c.036-.025.097-.031.126.008.023.04-.048.07-.064.028-.032-.047-.098.006-.093.051a.17.17 0 00.06.123c.029.025.069.044.106.029.046-.017.064-.07.055-.115-.004-.014 0-.01.009-.013zm.04-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.112.112 0 01.118-.012c.02.01.047.033.051.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.09.09 0 000 .092zm.24-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.041-.013-.052.006-.003-.004-.012-.007-.006-.013.02-.025.038-.052.057-.077l.012-.008zm.22.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.043.125a.128.128 0 01-.147.007.22.22 0 01-.089-.13.139.139 0 01.055-.15.112.112 0 01.117-.011c.022.01.047.033.052.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016-.019.028-.016.064-.002.092zm.15-.403c.04-.027.075.047.03.062-.04.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.232-.163l.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.098-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.024.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.038 0-.08.013-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm-2.72 2.92c.024.041.064.077.114.08.046.004.095-.031.098-.08.004-.013-.006-.037 0-.046.02-.004.015.027.02.04.006.044-.005.096-.044.124a.126.126 0 01-.133.014.21.21 0 01-.1-.128.14.14 0 01.047-.153.114.114 0 01.123-.017c.022.011.047.033.052.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.26-.233c.007-.044.02-.096.064-.117.037-.02.08.006.1.039.034.05.063.102.096.152.01.026.042.022.06.009.005.007.004.012-.004.015l-.12.076c-.008-.01-.002-.014.008-.02.03-.018.009-.051-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.03.05.06.1.092.149.011.03.046.015.062.007.007.007.003.01-.005.014l-.118.076c-.007-.008-.006-.014.005-.018.03-.019.008-.053-.006-.075-.029-.047-.056-.094-.087-.14-.012-.028-.04-.01-.053.002-.008-.004-.01-.009-.003-.015.018-.024.035-.05.054-.074.006-.004.012-.01.015 0zm.43-.27c.009-.045.02-.1.068-.12a.077.077 0 01.088.021c.006-.046.02-.098.067-.119.04-.02.087.008.107.044.032.05.06.101.093.15.012.029.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.051-.01-.028-.029-.051-.043-.077-.022-.034-.04-.07-.067-.102-.037-.038-.09.01-.097.05-.01.016-.007.03.004.043l.088.143c.013.03.048.002.061.005.009.009-.01.012-.015.018a51.14 51.14 0 01-.113.071c-.017-.02.034-.024.024-.05-.006-.026-.025-.046-.037-.069-.023-.035-.042-.073-.069-.106-.03-.039-.085-.01-.096.03-.01.019-.017.04-.001.056.03.048.058.097.09.145.012.028.045.008.06.004.01.01-.007.012-.013.018l-.112.07c-.018-.018.032-.023.02-.048-.013-.035-.036-.065-.054-.097-.022-.034-.04-.072-.068-.1-.017-.014-.044.034-.045.006.02-.026.037-.053.057-.079.01-.01.015-.005.02.006zm.33-.48c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.022.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.212-.093c.02-.028.04-.057.061-.084.007-.007.012-.006.016.003l.031.052c-.002-.042.006-.092.045-.116.04-.027.093-.015.129.014.062.05.098.14.07.218a.124.124 0 01-.106.08c-.014-.003-.025-.006-.013.007.02.033.039.067.062.098.016.023.043-.006.057-.003.009.008 0 .01-.007.015l-.124.078c-.011-.009-.004-.015.007-.02.033-.021.009-.056-.007-.08l-.158-.256c-.01-.032-.044-.018-.057-.002l-.007-.004zm.119-.012c.027.044.053.09.083.133.026.034.082.028.107-.005.028-.038.012-.09-.01-.126-.024-.043-.063-.088-.116-.087-.044.004-.06.048-.064.085zm.471-.058c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 01.105.031c.031.049.06.099.091.147.008.021.036.013.036-.008.003-.005.003-.023.007-.022.003.007.012.013.008.022 0 .035-.024.096-.068.075-.01-.005-.016-.018-.023-.024zm-.011-.019l-.062-.1c-.022.033-.052.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm-.029-.491l.22.36c.012.027.045.03.065.011.005.006.008.013-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07l-.15-.245c-.008-.022-.038-.04-.053-.014 0 .01-.022 0-.01-.007.017-.025.035-.051.054-.076a.078.078 0 00.01-.007zm.46.24c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 01.105.031l.09.147c.009.021.037.013.037-.008.003-.005.003-.023.007-.022.003.007.012.013.008.022 0 .035-.024.096-.068.075-.01-.005-.016-.018-.023-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm.071-.281c.001-.044.02-.096.064-.113.052-.021.112.004.144.047.04.048.062.116.04.177a.152.152 0 01-.129.108c-.019 0-.049.013-.056-.011l-.181-.295c-.01-.024-.04-.04-.055-.012-.003.011-.021-.004-.01-.01.018-.025.036-.051.055-.075.006-.004.013-.012.016 0l.112.183zm.011.018l.096.158c.045.013.104-.006.108-.059.01-.052-.019-.102-.051-.14-.028-.034-.083-.052-.12-.021-.02.015-.027.04-.033.062zm.259-.248l.036.06c-.002-.041.003-.105.055-.11.039-.006.051.059.01.063-.018 0-.048-.007-.05.02-.002.02-.008.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077zm.41.06c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.07.01.013.022.031.01.048-.025.032-.065-.01-.057-.04.003-.05.046-.086.088-.105a.074.074 0 01.105.031c.031.049.06.099.091.146.008.022.036.014.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.052.065-.056.106-.007.046.055.09.09.05a.163.163 0 00.028-.056zm-2.569 2.339l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 01-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.039 0-.08.013-.118-.003a.09.09 0 01-.028-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.17.04c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.113.113 0 01.123-.01c.019.011.043.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.23-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012a67.32 67.32 0 00-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.057-.03-.048-.057-.096-.088-.142-.012-.025-.04-.013-.051.006-.003-.004-.013-.007-.006-.012l.055-.078zm.23.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.113.113 0 01.123-.01c.019.011.043.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.14-.393c.04-.027.075.047.03.062-.04.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.232-.163l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.046-.041-.07-.08-.062-.039 0-.08.013-.118-.003a.09.09 0 01-.028-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.19-.12l.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.02-.021-.034-.038-.018-.004.01-.018-.007-.01-.01l.08-.051c.003.006.014.013.001.015-.019.017-.012.044-.009.066l.044.273c-.005 0-.01.01-.014.005l-.233-.167c-.018-.017-.046-.009-.063-.007l-.005-.008zm.41-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.138.138 0 01.055-.149.113.113 0 01.123-.01c.019.011.043.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.24-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.057-.03-.048-.057-.096-.088-.142-.012-.025-.04-.013-.051.006-.003-.004-.013-.007-.006-.012l.055-.078zm.44.05c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 01-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.038 0-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.006.004-.014.011-.017 0zm-.012-.02l-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.272-.14c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.07.01.013.022.031.01.048-.025.032-.065-.01-.057-.04.003-.05.046-.086.088-.105a.074.074 0 01.105.031l.09.146c.009.022.037.013.037-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.069.075-.009-.005-.016-.019-.022-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm.301-.171c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 01-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.038 0-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.006.004-.014.01-.017 0zm-.012-.02l-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.082-.2c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.113.113 0 01.123-.01c.018.011.042.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.24-.283l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.057-.03-.048-.057-.096-.088-.142-.012-.025-.04-.013-.051.006-.003-.004-.013-.007-.006-.012l.055-.078zm.41.07c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.07.01.013.022.031.01.048-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 01.105.031c.031.049.06.099.091.146.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.069.075-.009-.005-.016-.019-.022-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm.091-.271c.009-.045.02-.1.068-.12.03-.014.066-.003.088.021.006-.046.02-.098.067-.119.04-.02.086.008.107.044.032.05.06.101.093.15.012.029.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.052-.011-.027-.03-.051-.044-.077-.022-.034-.04-.07-.066-.1-.037-.04-.09.008-.097.049-.01.015-.007.03.004.043.03.047.057.096.088.143.013.03.047.002.06.005.01.009-.008.012-.014.018l-.113.071c-.018-.02.033-.025.024-.05-.006-.026-.025-.046-.037-.069-.023-.035-.043-.073-.069-.106-.03-.04-.085-.01-.096.03-.01.019-.017.04-.001.056.03.048.058.097.09.144.012.029.044.008.059.004.01.01-.006.013-.013.019l-.111.07c-.018-.019.032-.024.02-.049-.013-.035-.036-.065-.055-.097-.021-.033-.039-.07-.067-.1-.017-.013-.045.035-.045.007.019-.027.037-.054.057-.08.009-.01.015-.004.02.007zm.44-.22c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.113.113 0 01.123-.01c.018.011.043.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.28-.213c.007-.044.02-.096.064-.117.037-.02.08.006.101.039.033.05.062.102.095.152.011.026.043.022.06.009.006.007.005.012-.003.015l-.12.076c-.009-.01-.003-.014.007-.02.03-.018.009-.052-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.03.05.06.1.092.149.011.03.046.015.062.007.007.007.003.01-.005.014l-.118.075c-.007-.008-.006-.013.005-.017.03-.02.008-.054-.006-.076-.03-.046-.057-.093-.087-.139-.013-.028-.041-.011-.053.002-.008-.004-.01-.009-.003-.015l.053-.074c.006-.004.013-.011.016 0zm.2-.33l.053.086.06-.038a.449.449 0 00.013.02l-.06.039.107.176c.01.025.046.037.06.01.012-.013-.002-.033.017-.039.011.038-.003.091-.044.105-.038.012-.067-.02-.082-.05l-.105-.172-.041.026c-.015-.014.011-.028.01-.044.015-.037.007-.078.006-.114zm.24.11c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.138.138 0 01.055-.149.113.113 0 01.123-.01c.018.011.043.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.09.09 0 000 .092zm-4.45 3.797c.009-.045.02-.1.068-.12a.077.077 0 01.088.021c.006-.046.02-.098.067-.119.04-.02.086.008.107.044.032.05.06.101.093.15.012.028.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.052-.01-.027-.03-.05-.044-.076-.022-.034-.04-.07-.066-.102-.037-.038-.09.01-.097.05-.01.015-.007.03.004.043l.088.143c.013.03.048.002.06.005.01.009-.008.012-.014.018a51.14 51.14 0 01-.113.071c-.017-.02.034-.024.024-.05-.007-.025-.025-.046-.037-.069-.023-.035-.042-.073-.069-.106-.03-.039-.085-.01-.096.03-.01.019-.017.04-.001.056.03.048.058.097.09.145.012.028.044.007.06.004.01.01-.007.012-.013.018l-.112.07c-.018-.018.032-.023.02-.048-.01-.031-.03-.056-.046-.084-.024-.037-.044-.077-.073-.11-.018-.024-.043.032-.05.004l.059-.08c.009-.01.015-.005.02.006zm.32-.47c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.044.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.242-.163l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 01-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.046-.041-.07-.08-.062-.038 0-.08.013-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm.54.01c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 01-.005-.179c.02-.042.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.006.004-.014.01-.017 0zm-.012-.02l-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm-.048-.47c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.044.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.232-.163l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.027.012-.046-.041-.071-.08-.063-.038 0-.08.013-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.38-.01c.018.047.02.105-.011.147a.114.114 0 01-.125.043c-.059-.014-.1-.067-.12-.121a.151.151 0 01.057-.18c.036-.025.097-.031.126.008.023.04-.048.07-.064.028-.033-.047-.098.006-.093.05a.17.17 0 00.06.124c.029.024.069.044.106.028.045-.016.064-.07.055-.115-.004-.014 0-.01.009-.012zm-.08-.36c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.021.02-.044-.002-.026-.021-.047-.033-.07-.025-.04-.048-.08-.075-.118-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.072-.003c.02-.028.04-.057.061-.084.007-.007.013-.006.016.003l.031.051c-.002-.042.006-.09.045-.115.04-.027.094-.015.129.014.062.05.098.14.07.218a.124.124 0 01-.105.079c-.015-.002-.026-.005-.014.008.02.033.039.067.062.097.016.023.044-.006.057-.003.009.008 0 .011-.007.015l-.124.08c-.01-.01-.004-.016.007-.021.033-.021.009-.057-.007-.08l-.158-.257c-.01-.03-.044-.017-.057-.002l-.007-.004zm.119-.012c.027.044.053.09.083.133.026.034.082.028.107-.005.028-.038.012-.09-.01-.126-.024-.043-.063-.089-.116-.087-.044.004-.06.048-.064.085zm.151-.398c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.072-.233l.22.36c.012.028.045.03.065.011.005.006.008.013-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07l-.15-.245c-.008-.022-.038-.04-.053-.014-.002.01-.022-.002-.011-.007l.054-.076.012-.006zm.28 0a.137.137 0 01.142-.006c.066.033.1.111.092.183-.008.077-.088.14-.165.123a.175.175 0 01-.132-.144.15.15 0 01.028-.124.138.138 0 01.035-.032zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 01-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.038 0-.08.013-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm-1.76 4.26c-.008-.047-.003-.103.036-.135.032-.03.082-.044.122-.021.046.021.054.079.042.123 0 .01-.017.035.003.026a.12.12 0 01.126.065.16.16 0 01-.033.195c-.028.024-.06.05-.098.054-.039.005-.036-.053 0-.054.042-.002.096-.008.113-.056.022-.048-.007-.104-.051-.128-.037-.02-.083-.01-.118.01-.007.007-.012.006-.014-.003.035-.03.06-.082.041-.128-.013-.047-.072-.073-.113-.043-.035.017-.04.065-.047.094l-.01.001zm.67-.1l.019.092-.227.144c-.017-.022.011-.051.01-.076.02-.084.043-.172.026-.259-.009-.048-.044-.097-.097-.099-.059-.004-.105.058-.096.114.004.011.005.021-.007.026-.023-.048-.026-.11.01-.152a.133.133 0 01.158-.037c.052.024.071.087.07.141.002.082-.02.161-.035.241-.004.013-.008.025.006.013.041-.027.084-.052.124-.08.024-.014.024-.045.033-.064l.007-.004zm.11-.04c.019-.013.048-.003.054.019.01.02-.006.047-.028.05a.037.037 0 01-.043-.03.037.037 0 01.017-.039zm.28-.65l.134-.085c.018.015-.015.02-.017.036-.026.042-.017.092-.02.139l-.001.161c.025.04.048.082.075.12.016.03.05.018.072.001.009 0 .01.015-.001.016l-.153.097c-.01-.009-.004-.014.006-.02.038-.016.026-.061.004-.086l-.054-.089c-.08-.037-.16-.076-.24-.111-.022-.017-.056.005-.072-.002-.01-.01.01-.012.014-.018l.146-.092c.018.015-.012.017-.017.031-.025.033.021.053.046.064l.147.07c0-.065.003-.129.001-.193.004-.037-.04-.05-.064-.03l-.007-.01zm.71-.04c.018.047.02.105-.011.147a.114.114 0 01-.125.043c-.059-.014-.1-.067-.12-.121a.15.15 0 01.057-.18c.037-.025.097-.031.126.008.024.04-.048.07-.063.028-.033-.047-.099.006-.094.051a.17.17 0 00.06.123c.029.024.07.044.106.028.046-.016.064-.07.055-.115-.004-.014 0-.01.01-.012zm.06-.27a.137.137 0 01.142-.006c.066.033.1.111.093.183-.008.077-.089.14-.166.123a.175.175 0 01-.132-.144.149.149 0 01.034-.131.134.134 0 01.029-.025zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.267-.134c.007-.044.02-.096.064-.117.037-.02.08.006.101.039.033.05.062.102.095.152.011.026.043.022.06.009.006.007.005.012-.003.015l-.12.076c-.009-.01-.003-.014.007-.02.03-.018.009-.051-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.031.05.06.1.092.149.011.03.046.015.062.007.007.007.003.01-.005.014l-.118.075c-.007-.008-.006-.013.005-.017.03-.019.008-.054-.006-.075-.029-.047-.056-.094-.087-.14-.012-.028-.04-.01-.053.002-.008-.004-.01-.009-.003-.015.018-.024.035-.05.054-.074.006-.004.012-.01.015 0zm.31-.26a.137.137 0 01.142-.006c.064.032.097.107.093.177-.005.077-.081.143-.158.13a.174.174 0 01-.14-.145.149.149 0 01.034-.131.133.133 0 01.029-.025zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.487-.094c.018.047.02.105-.011.147a.114.114 0 01-.125.043c-.059-.014-.1-.067-.12-.121a.15.15 0 01.057-.18c.036-.025.097-.031.126.008.023.039-.048.07-.064.028-.032-.047-.098.006-.093.051a.17.17 0 00.06.123c.029.024.069.044.106.029.045-.017.064-.07.055-.115-.004-.015 0-.01.009-.013zm.04-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.112.112 0 01.118-.012c.02.01.047.033.051.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.087.087 0 000 .092zm.23-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.007.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077zm.23.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.044.125a.128.128 0 01-.146.007.22.22 0 01-.089-.13.139.139 0 01.055-.149.112.112 0 01.117-.012c.022.01.047.033.052.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016-.019.027-.016.064-.002.092zm.14-.423c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.242-.133l.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.098-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.03.109.023.126-.027.012-.046-.041-.071-.08-.063-.038 0-.08.013-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm.2-.34l.22.36c.012.028.045.03.065.011.005.006.008.013-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07-.05-.082-.099-.164-.15-.245-.008-.022-.038-.04-.053-.014 0 .01-.022 0-.01-.007.018-.025.035-.051.054-.076a.072.072 0 00.01-.007zm.45.25c-.015.043-.032.098-.084.107-.05.01-.095-.044-.086-.092.01-.055.049-.099.08-.143.015-.01-.008-.025-.011-.036a.055.055 0 00-.097 0c-.01.016-.003.034.007.048.02.02.005.06-.026.05-.044-.022-.028-.087.002-.115.03-.029.07-.055.114-.05.033.006.048.039.065.064.025.041.05.083.076.123.008.022.036.013.036-.008.003-.005.003-.022.007-.021.003.007.012.013.008.022 0 .035-.024.096-.068.074-.01-.005-.016-.019-.023-.023zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm-4.049 3.309l.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.02-.022-.034-.038-.019-.004.012-.018-.006-.01-.008l.08-.051c.003.005.014.012.001.015-.019.017-.012.044-.009.066l.044.272c-.005.001-.01.01-.014.005l-.233-.166c-.018-.018-.046-.009-.063-.007zm.4-.14c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.113.113 0 01.123-.01c.018.011.042.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.23-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.078.126.013.03.05.028.07.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.022-.01-.04-.02-.058-.03-.047-.057-.095-.088-.141-.012-.025-.04-.013-.052.006-.003-.004-.012-.007-.006-.013l.056-.077zm.46.07c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 01-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.053.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0zm-.012-.02l-.083-.136c-.024-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.252-.16c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 01.105.031l.091.146c.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.095-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.055.09.09.05a.162.162 0 00.028-.056zm.311-.151c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 01-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.01-.01-.005-.007-.011 0-.018l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.053.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0zm-.012-.02l-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.212.07l-.008-.013c.028-.031.041-.088.008-.12-.014-.002-.013.02-.025.023-.027.022-.065-.013-.054-.043.01-.04.067-.043.091-.014.034.033.036.09.012.13-.006.013-.017.025-.024.037zm.04-.53l.121-.077c.015.013-.006.017-.013.028-.01.027.02.042.04.055l.133.085c-.011-.063-.02-.126-.033-.19 0-.027-.03-.028-.044-.018-.009-.008-.002-.012.006-.016l.073-.046c.017.015-.017.025-.012.046.01.069.023.137.034.205.009.057.02.113.027.17.005.045-.009.099-.051.12-.037.024-.079-.036-.037-.057.025-.01.066-.011.062-.05 0-.03-.008-.06-.013-.09l-.22-.143a.089.089 0 00-.069-.013l-.005-.01zm.45-.49l.22.36c.012.027.045.03.065.011.005.006.008.012-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07l-.15-.245c-.008-.022-.038-.04-.053-.014-.002.01-.022-.002-.011-.007l.054-.076.012-.006zm.44.23c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.002-.051.046-.086.088-.105a.074.074 0 01.105.031c.031.049.06.099.091.146.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.052.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm.121-.351l.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.02-.022-.034-.038-.019-.004.012-.018-.006-.01-.008l.081-.052c.002.006.014.013 0 .016-.019.016-.011.044-.009.066l.044.272c-.005.001-.01.01-.014.005l-.233-.166c-.018-.018-.045-.009-.063-.007zm.4-.14c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.044.125a.128.128 0 01-.145.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.113.113 0 01.123-.01c.018.011.043.032.046.05zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.24-.273l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.078.126.013.03.05.028.07.015.005.005.008.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.008-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.051.005-.003-.004-.013-.007-.006-.013l.055-.077zm.45.07c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.193.193 0 01-.006-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.01-.01-.005-.007-.011 0-.018l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.053.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0l-.018-.03zm-.012-.02l-.083-.136c-.024-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.262-.16c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.002-.048.04-.082.08-.101.038-.026.094-.017.113.027.031.049.06.099.091.146.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.163.163 0 00.028-.056zm.311-.151c-.007.05-.046.097-.099.102-.06.007-.116-.033-.143-.085a.19.19 0 01-.005-.179c.02-.042.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.038.002-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0zm-.012-.02l-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.242-.48a.137.137 0 01.142-.006c.066.033.1.111.092.183-.008.077-.088.14-.165.123a.175.175 0 01-.132-.144.149.149 0 01.034-.131.155.155 0 01.029-.025zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234l.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 01-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.027.012-.046-.041-.071-.08-.063-.039 0-.08.013-.118-.003a.09.09 0 01-.028-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm-4.61 3.76l.118.192c.008-.041.017-.091.058-.113.04-.023.086.004.107.04.035.049.064.103.098.153.011.025.042.013.056.007.01.009-.003.012-.01.017l-.113.072c-.015-.015.014-.018.02-.031.013-.024-.009-.046-.02-.066-.027-.043-.052-.088-.082-.129-.034-.044-.092 0-.097.044-.01.016-.005.03.006.043.029.047.057.095.087.142.013.03.046.003.06.005.01.009-.006.01-.011.016l-.114.072c-.018-.02.032-.024.02-.05-.012-.032-.033-.06-.05-.09-.047-.075-.091-.15-.139-.225-.012-.032-.043-.019-.057-.003-.012-.004-.005-.012.001-.019l.05-.07a.078.078 0 00.013-.007zm.6.15c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.03-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.023.032.01.049-.025.032-.065-.01-.057-.041.003-.05.046-.085.088-.104a.074.074 0 01.105.031l.091.146c.008.022.036.013.037-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021-.001.035-.025.096-.069.075-.01-.005-.016-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056z'/%3e%3cpath d='M502.21 304.89l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.016-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077zm.4.07c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.03-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.023.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 01.105.031c.031.049.06.099.091.146.008.022.036.014.037-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021-.001.035-.025.096-.069.075-.01-.005-.016-.019-.023-.024zm-.011-.019l-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 00.028-.056zm.131-.581l.22.36c.012.027.045.03.065.011.005.006.008.013-.002.016l-.119.075c-.018-.018.026-.021.02-.043-.004-.026-.022-.046-.035-.069-.05-.082-.1-.165-.151-.246-.008-.022-.038-.04-.053-.014 0 .01-.022 0-.01-.007.017-.025.035-.051.054-.076a.078.078 0 00.01-.007zm.13-.09c.04-.027.075.047.03.062-.04.014-.065-.041-.03-.062zm.108.123l.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.022.02-.044-.002-.026-.021-.047-.033-.07-.025-.04-.048-.08-.075-.119-.012-.025-.04-.015-.05.004-.006-.004-.015-.008-.007-.014l.055-.076.011-.007zm.182-.043c.001-.044.02-.096.064-.113.052-.021.112.004.144.047.04.048.062.116.04.177a.152.152 0 01-.129.108c-.019 0-.049.013-.056-.011l-.181-.295c-.01-.024-.04-.04-.055-.012-.003.011-.021-.004-.01-.01l.055-.075c.006-.004.013-.012.016 0zm.011.018l.096.158c.044.013.104-.007.109-.059.01-.052-.02-.102-.052-.14-.028-.034-.083-.052-.12-.021-.02.015-.027.04-.033.062zm.259-.248l.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012a67.32 67.32 0 00-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.051.005-.003-.004-.013-.007-.006-.013l.055-.077zm.22.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.043.125a.128.128 0 01-.146.007.22.22 0 01-.09-.13.139.139 0 01.055-.149.112.112 0 01.118-.012c.02.01.047.033.051.053zm-.01-.017l.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 00-.002.092zm.33-.333l.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.027.012-.046-.041-.071-.08-.063-.038 0-.08.013-.117-.003a.09.09 0 01-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm.24.14c.019-.013.048-.003.054.019a.038.038 0 01-.028.05.037.037 0 01-.043-.03.037.037 0 01.017-.039z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$1m = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3e%3clinearGradient id='a'%3e%3cstop offset='0' stop-color='%23fbd55f'/%3e%3cstop offset='1' stop-color='%23cb8e32'/%3e%3c/linearGradient%3e%3cradialGradient id='f' cx='416.38' cy='814.57' gradientTransform='matrix(1 0 0 1.0057 0 -4.636)' gradientUnits='userSpaceOnUse' r='7.422' xlink:href='%23a'/%3e%3cradialGradient id='e' cx='393.34' cy='837.95' gradientTransform='matrix(1 0 0 .99109 0 7.468)' gradientUnits='userSpaceOnUse' r='7.506' xlink:href='%23a'/%3e%3cradialGradient id='d' cx='416.58' cy='860.97' gradientTransform='matrix(1 0 0 1.0082 0 -7.063)' gradientUnits='userSpaceOnUse' r='7.422' xlink:href='%23a'/%3e%3cradialGradient id='c' cx='439.62' cy='837.58' gradientTransform='matrix(1 0 0 .98778 0 10.237)' gradientUnits='userSpaceOnUse' r='7.506' xlink:href='%23a'/%3e%3cradialGradient id='b' cx='416.51' cy='837.65' gradientTransform='matrix(1 0 0 .98848 0 9.646)' gradientUnits='userSpaceOnUse' r='11.146' xlink:href='%23a'/%3e%3cradialGradient id='g' cx='760.54' cy='474.25' gradientTransform='matrix(1 0 0 .99305 0 3.294)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='h' cx='731.81' cy='474.25' gradientTransform='matrix(1 0 0 .99305 0 1.88)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='i' cx='703.46' cy='474.25' gradientTransform='matrix(1 0 0 .99305 0 3.294)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='j' cx='771.02' cy='499.67' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='k' cx='742.68' cy='499.67' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='l' cx='714.14' cy='499.67' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='m' cx='772.18' cy='526.29' gradientTransform='matrix(1 0 0 .99305 0 3.655)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='n' cx='745.39' cy='525.29' gradientTransform='matrix(1 0 0 .99305 0 3.648)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='o' cx='716.86' cy='525.29' gradientTransform='matrix(1 0 0 .99305 0 3.648)' gradientUnits='userSpaceOnUse' r='12.039' xlink:href='%23a'/%3e%3cradialGradient id='p' cx='768.04' cy='552.78' gradientTransform='matrix(1 0 0 .98916 0 5.991)' gradientUnits='userSpaceOnUse' r='11.383' xlink:href='%23a'/%3e%3cradialGradient id='q' cx='741.28' cy='552.78' gradientTransform='matrix(1 0 0 .99234 0 4.237)' gradientUnits='userSpaceOnUse' r='11.347' xlink:href='%23a'/%3e%3cradialGradient id='r' cx='714.26' cy='552.78' gradientTransform='matrix(1 0 0 .989 0 6.08)' gradientUnits='userSpaceOnUse' r='11.385' xlink:href='%23a'/%3e%3cradialGradient id='s' cx='761.91' cy='580.39' gradientTransform='matrix(1 0 0 .99259 0 4.303)' gradientUnits='userSpaceOnUse' r='10.886' xlink:href='%23a'/%3e%3cradialGradient id='t' cx='737.53' cy='577.5' gradientTransform='matrix(1 0 0 .99205 0 4.59)' gradientUnits='userSpaceOnUse' r='10.886' xlink:href='%23a'/%3e%3cradialGradient id='u' cx='711.71' cy='576.36' gradientTransform='matrix(1 0 0 .99259 0 4.272)' gradientUnits='userSpaceOnUse' r='10.886' xlink:href='%23a'/%3e%3cradialGradient id='v' cx='751.9' cy='604.02' gradientTransform='matrix(1 0 0 .98919 0 6.531)' gradientUnits='userSpaceOnUse' r='10.462' xlink:href='%23a'/%3e%3cradialGradient id='w' cx='729.67' cy='600.54' gradientTransform='matrix(1 0 0 .99915 0 .513)' gradientUnits='userSpaceOnUse' r='9.95' xlink:href='%23a'/%3e%3cradialGradient id='x' cx='706.08' cy='597.51' gradientTransform='matrix(1 0 0 .99726 0 1.636)' gradientUnits='userSpaceOnUse' r='8.123' xlink:href='%23a'/%3e%3cradialGradient id='y' cx='741.9' cy='625.39' gradientTransform='matrix(1 0 0 .99915 0 .535)' gradientUnits='userSpaceOnUse' r='9.95' xlink:href='%23a'/%3e%3cradialGradient id='z' cx='720.45' cy='618.78' gradientTransform='matrix(1 0 0 1.0069 0 -4.273)' gradientUnits='userSpaceOnUse' r='8.345' xlink:href='%23a'/%3e%3cradialGradient id='A' cx='700.55' cy='614.7' gradientTransform='matrix(1 0 0 .99645 0 2.18)' gradientUnits='userSpaceOnUse' r='7.03' xlink:href='%23a'/%3e%3cradialGradient id='B' cx='731.65' cy='644.12' gradientTransform='matrix(1 0 0 .99834 0 1.067)' gradientUnits='userSpaceOnUse' r='9.333' xlink:href='%23a'/%3e%3cradialGradient id='C' cx='712.98' cy='635.08' gradientTransform='matrix(1 0 0 1.00597 0 -3.791)' gradientUnits='userSpaceOnUse' r='7.792' xlink:href='%23a'/%3e%3cradialGradient id='D' cx='695.15' cy='628.49' gradientTransform='matrix(1 0 0 .99767 0 1.462)' gradientUnits='userSpaceOnUse' r='6.64' xlink:href='%23a'/%3e%3cradialGradient id='E' cx='718.42' cy='660.82' gradientTransform='matrix(1 0 0 1.00252 0 -1.666)' gradientUnits='userSpaceOnUse' r='8.623' xlink:href='%23a'/%3e%3cradialGradient id='F' cx='702.21' cy='650.42' gradientTransform='matrix(1 0 0 .999 0 .647)' gradientUnits='userSpaceOnUse' r='7.301' xlink:href='%23a'/%3e%3cradialGradient id='G' cx='686.7' cy='642.53' gradientTransform='matrix(1 0 0 1.0069 0 -4.435)' gradientUnits='userSpaceOnUse' r='6.091' xlink:href='%23a'/%3e%3cradialGradient id='H' cx='707.38' cy='674.82' gradientTransform='matrix(1 0 0 .9913 0 5.871)' gradientUnits='userSpaceOnUse' r='7.953' xlink:href='%23a'/%3e%3cradialGradient id='I' cx='693.57' cy='664.01' gradientTransform='matrix(1 0 0 1.01302 0 -8.648)' gradientUnits='userSpaceOnUse' r='6.615' xlink:href='%23a'/%3e%3cradialGradient id='J' cx='680.18' cy='655.53' gradientTransform='matrix(1 0 0 1.00534 0 -3.497)' gradientUnits='userSpaceOnUse' r='5.651' xlink:href='%23a'/%3e%3cradialGradient id='K' cx='694.25' cy='686.15' gradientTransform='matrix(1 0 0 1.00986 0 -6.764)' gradientUnits='userSpaceOnUse' r='6.753' xlink:href='%23a'/%3e%3cradialGradient id='L' cx='682.92' cy='676.43' gradientTransform='matrix(1 0 0 1.00582 0 -3.938)' gradientUnits='userSpaceOnUse' r='5.721' xlink:href='%23a'/%3e%3cradialGradient id='M' cx='671.83' cy='668.65' gradientTransform='matrix(1 0 0 1.02442 0 -16.33)' gradientUnits='userSpaceOnUse' r='4.779' xlink:href='%23a'/%3e%3cradialGradient id='N' cx='682.71' cy='696.23' gradientTransform='matrix(1 0 0 1.00802 0 -5.585)' gradientUnits='userSpaceOnUse' r='6.282' xlink:href='%23a'/%3e%3cradialGradient id='O' cx='673.31' cy='686.5' gradientTransform='matrix(1 0 0 1.01694 0 -11.63)' gradientUnits='userSpaceOnUse' r='5.292' xlink:href='%23a'/%3e%3cradialGradient id='P' cx='663.89' cy='678.28' gradientTransform='matrix(1 0 0 1.00862 0 -5.844)' gradientUnits='userSpaceOnUse' r='4.489' xlink:href='%23a'/%3e%3cradialGradient id='Q' cx='671.6' cy='705.18' gradientTransform='matrix(1 0 0 1.0059 0 -4.166)' gradientUnits='userSpaceOnUse' r='6.282' xlink:href='%23a'/%3e%3cradialGradient id='R' cx='662.2' cy='695.65' gradientTransform='matrix(1 0 0 1.01055 0 -7.342)' gradientUnits='userSpaceOnUse' r='5.292' xlink:href='%23a'/%3e%3cradialGradient id='S' cx='654.58' cy='687.37' gradientTransform='matrix(1 0 0 1.01672 0 -11.49)' gradientUnits='userSpaceOnUse' r='4.49' xlink:href='%23a'/%3e%3cradialGradient id='T' cx='646.03' cy='696.48' gradientTransform='matrix(1 0 0 1.02355 0 -16.403)' gradientUnits='userSpaceOnUse' r='4.136' xlink:href='%23a'/%3e%3cradialGradient id='U' cx='653.02' cy='704.68' gradientTransform='matrix(1 0 0 1.00552 0 -3.892)' gradientUnits='userSpaceOnUse' r='4.489' xlink:href='%23a'/%3e%3cradialGradient id='V' cx='660.59' cy='713.14' gradientTransform='matrix(1 0 0 1.0171 0 -12.2)' gradientUnits='userSpaceOnUse' r='4.846' xlink:href='%23a'/%3e%3cradialGradient id='W' cx='637.01' cy='705.72' gradientTransform='matrix(1 0 0 1.01093 0 -7.714)' gradientUnits='userSpaceOnUse' r='3.872' xlink:href='%23a'/%3e%3cradialGradient id='X' cx='642.62' cy='712.94' gradientTransform='matrix(1 0 0 1.01384 0 -9.865)' gradientUnits='userSpaceOnUse' r='4.135' xlink:href='%23a'/%3e%3cradialGradient id='Y' cx='649.42' cy='720.03' gradientTransform='matrix(1 0 0 1.0073 0 -5.25)' gradientUnits='userSpaceOnUse' r='4.405' xlink:href='%23a'/%3e%3cradialGradient id='Z' cx='628.35' cy='711.82' gradientTransform='matrix(1 0 0 1.02676 0 -19.049)' gradientUnits='userSpaceOnUse' r='3.517' xlink:href='%23a'/%3e%3cradialGradient id='aa' cx='633.37' cy='718.62' gradientTransform='matrix(1 0 0 1.02113 0 -15.183)' gradientUnits='userSpaceOnUse' r='3.871' xlink:href='%23a'/%3e%3cradialGradient id='ab' cx='639.59' cy='726.09' gradientTransform='matrix(1 0 0 1.03175 0 -23.056)' gradientUnits='userSpaceOnUse' r='4.048' xlink:href='%23a'/%3e%3cradialGradient id='ac' cx='621.03' cy='717.31' gradientTransform='matrix(1 0 0 1.01622 0 -11.635)' gradientUnits='userSpaceOnUse' r='3.417' xlink:href='%23a'/%3e%3cradialGradient id='ad' cx='625.6' cy='723.58' gradientTransform='matrix(1 0 0 1.01891 0 -13.684)' gradientUnits='userSpaceOnUse' r='3.634' xlink:href='%23a'/%3e%3cradialGradient id='ae' cx='629.94' cy='730.32' gradientTransform='matrix(1 0 0 1.0334 0 -24.397)' gradientUnits='userSpaceOnUse' r='3.904' xlink:href='%23a'/%3e%3cradialGradient id='af' cx='614.05' cy='721.3' gradientTransform='matrix(1 0 0 1.00982 0 -7.086)' gradientUnits='userSpaceOnUse' r='3.053' xlink:href='%23a'/%3e%3cradialGradient id='ag' cx='617.69' cy='727.85' gradientTransform='matrix(1 0 0 1.0159 0 -11.57)' gradientUnits='userSpaceOnUse' r='3.256' xlink:href='%23a'/%3e%3cradialGradient id='ah' cx='621.24' cy='734.22' gradientTransform='matrix(1 0 0 1.00532 0 -3.906)' gradientUnits='userSpaceOnUse' r='3.473' xlink:href='%23a'/%3e%3cradialGradient id='ai' cx='606.69' cy='724.91' gradientTransform='matrix(1 0 0 1.0049 0 -3.546)' gradientUnits='userSpaceOnUse' r='2.946' xlink:href='%23a'/%3e%3cradialGradient id='aj' cx='609.28' cy='730.85' gradientTransform='matrix(1 0 0 1.01859 0 -13.586)' gradientUnits='userSpaceOnUse' r='3.122' xlink:href='%23a'/%3e%3cradialGradient id='ak' cx='612.94' cy='737.49' gradientTransform='matrix(1 0 0 1.01562 0 -11.523)' gradientUnits='userSpaceOnUse' r='3.378' xlink:href='%23a'/%3e%3cradialGradient id='al' cx='600.03' cy='728.91' gradientTransform='matrix(1 0 0 1.0265 0 -19.31)' gradientUnits='userSpaceOnUse' r='2.506' xlink:href='%23a'/%3e%3cradialGradient id='am' cx='602' cy='734.39' gradientTransform='matrix(1 0 0 .98882 0 8.212)' gradientUnits='userSpaceOnUse' r='2.724' xlink:href='%23a'/%3e%3cradialGradient id='an' cx='604.74' cy='740' gradientTransform='matrix(1 0 0 1.00265 0 -1.96)' gradientUnits='userSpaceOnUse' r='2.914' xlink:href='%23a'/%3e%3cradialGradient id='ao' cx='685.79' cy='453.08' gradientTransform='matrix(1 0 0 .99658 1.768 2.964)' gradientUnits='userSpaceOnUse' r='8.107' xlink:href='%23a'/%3e%3cg stroke-width='1.2'%3e%3cpath d='M0 0h1000v600H0z' fill='%23002b7f'/%3e%3cpath d='M0 100h1000v399.996H0z' fill='white'/%3e%3cpath d='M0 200.004h1000v200.004H0z' fill='%23ce1126'/%3e%3cellipse cx='300.001' cy='300' fill='white' rx='75' ry='87.5'/%3e%3c/g%3e%3cg transform='translate(235.939 234.475) scale(.15382)'%3e%3cg stroke='black' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M105.36 349.34l11-20.25-26-7.25-8 18zm622.24 0l-11-20.25 26-7.25 8 18z' fill='%23cea849' stroke-width='3'/%3e%3cpath d='M409.48 91.438l-40.094 1.157c-25.601 2.418-35.334 12.29-19.437 30.965-41.272 6.469-81.637 15.908-118.94 35.626-10.486-1.74-22.662 4.134-26.156 14.232-2.912 8.158 4.188 16.828 16.812 13.387-8.35 21.987-106.99 19.428-109.5 56.05 7.472-6.368 15.699-11.766 23.906-6.318l-5.656 17.11c-14.363 4.277-24.455 6.644-30.47 22.363-6.212 15.77-15.13 39.832-21.343 51.671-4.08 5.472-5.063 11.284-5.063 14.17 0 6.814 4.869 16.326 16.125 16.326 11.456 0 17.094-7.175 17.094-14.388-.666-5.02-2.644-10.912-14.75-10.228 20.321-4.871 37.886 1.953 49.687 9.477 16.306 12.038 20.387 35.38 10.875 54.58-9.323 18.654-33.013 29.543-68.344 15.764-28.736-11.292-57.644 3.484-67.156 29.151-43.293 117.15 32.408 212.17 118.22 267.58 89.304 57.703 105.21 73.418 129.09 101.62 24.07 28.155 47.37 60.398 82.312 60.398 5.437 0 10.682-1.56 15.344-4.097 21.995 0 23.424 8.208 52.937 8.727v.03c.512 0 1.004-.026 1.5-.03.492.004.962.03 1.47.03v-.03c29.544-.514 30.965-8.727 52.968-8.727 4.662 2.537 9.876 4.097 15.312 4.097 34.943 0 58.243-32.243 82.312-60.398 23.88-28.205 39.821-43.92 129.12-101.62 85.81-55.415 161.51-150.44 118.22-267.58-9.512-25.668-38.45-40.443-67.187-29.15-35.33 13.778-58.989 2.89-68.312-15.765-9.512-19.2-5.431-42.542 10.875-54.58 11.802-7.524 29.335-14.349 49.656-9.477-12.106-.684-14.053 5.209-14.719 10.228 0 7.213 5.638 14.388 17.094 14.388 11.257 0 16.094-9.512 16.094-16.327 0-2.885-.95-8.697-5.031-14.169-6.212-11.839-15.163-35.903-21.375-51.67-6.014-15.72-16.106-18.087-30.47-22.365l-5.624-17.109c8.207-5.448 16.434-.05 23.906 6.318-2.507-36.622-101.18-34.064-109.53-56.05 12.625 3.442 19.756-5.229 16.844-13.387-3.494-10.098-15.67-15.973-26.156-14.232-37.27-19.72-77.67-29.16-118.94-35.63 15.89-18.68 6.16-28.547-19.44-30.964l-40.094-1.157-7-.219-6.969.219z' fill='%23dca842' stroke-width='3.001'/%3e%3cg fill='none' stroke-width='3'%3e%3cpath d='M365.36 93.093c38.572.12 30.016 46.144-5 48.25-43.149 5.035-96.201 3.62-125 15.5m-99 61.247c33.314-9.378 69.202-1.792 91-11.75s26.49-42.896 3-47.25'/%3e%3cpath d='M349.11 123.59c7.68-1.77 15.889-2.044 19.979-5.77 4.09-3.727 5.313-10.405-4.48-11.23m-142.989 80.5c7.161-12.05 4.837-20.454-4.518-14.67M467.6 93.093c-38.572.12-30.016 46.144 5 48.25 43.149 5.035 96.201 3.62 125 15.5m99 61.247c-33.314-9.378-69.202-1.792-91-11.75s-26.49-42.896-3-47.25'/%3e%3cpath d='M483.85 123.59c-7.68-1.77-15.889-2.044-19.979-5.77-4.09-3.727-5.312-10.405 4.48-11.23m142.979 80.5c-7.161-12.05-4.837-20.454 4.518-14.67M219.23 742.45c61.736 43.665 70.667 100.43 134.54 103.15'/%3e%3cpath d='M354.55 854.5c-37.662 8.11-62.318-12.363-92.023-56.818-15.15-22.4-54.94-53.9-122.89-96.38-106.78-66.66-138.42-182.91-103.67-246.66 8.543-15.676 30.48-21.857 43.099-18.346 32.811 8.852 87.947 0 88.141-53.159.194-29.917-24.268-64.879-55.912-64.879-19.224 0-29.511 6.38-34.556 13.154'/%3e%3cpath d='M349.89 831.9c0-2.918 2.52-5.984 6.212-5.984 3.688 0 6.988 3.264 6.988 7.32 0 8.9-5.05 13.697-15.725 11.57-8.737-1.73-12.619-11.176-8.93-20.67 3.687-9.643 16.111-15.626 29.505-9.643 13.4 6.182 11.843 26.654 7.187 38.275-2.719 6.725-8.156 12.363-14.756 16.022M613.72 742.45c-61.73 43.66-70.66 100.43-134.73 103.15'/%3e%3cpath d='M478.41 854.5c37.662 8.11 62.318-12.363 92.018-56.818 14.949-22.401 54.942-53.901 122.89-96.379 106.77-66.659 138.42-182.92 103.67-246.66-8.538-15.676-30.475-21.857-43.094-18.346-32.811 8.852-87.947 0-88.141-53.159-.194-29.917 24.268-64.879 55.911-64.879 19.219 0 29.511 6.38 34.556 13.154'/%3e%3cpath d='M495.88 830.52c0-26.456-44.843-34.764-79.205-34.764-34.168 0-79.205 8.308-79.205 34.764'/%3e%3cpath d='M483.07 831.9c0-2.918-2.52-5.984-6.212-5.984-3.688 0-6.988 3.264-6.988 7.32 0 8.9 5.05 13.697 15.725 11.57 8.737-1.73 12.619-11.176 8.93-20.67-3.687-9.643-16.111-15.626-29.505-9.643-13.4 6.182-11.843 26.654-7.187 38.275 2.719 6.725 8.156 12.363 14.756 16.022'/%3e%3cpath d='M460.16 857.17c-18.056 0-17.474 19.44-43.681 19.44-26.012 0-25.431-19.44-43.487-19.44'/%3e%3c/g%3e%3c/g%3e%3cg stroke='black' stroke-width='3'%3e%3cpath d='M416.48 828.14c-12.812 0-12.812 19.035 0 19.035s13.006-19.035 0-19.035' fill='url(%23b)'/%3e%3cpath d='M439.58 831.66c-7.957 0-7.957 11.828 0 11.828 7.962 0 8.156-11.828 0-11.828' fill='url(%23c)'/%3e%3cpath d='M422.5 860.99c0-8.002-11.843-8.002-11.843 0 0 7.952 11.843 7.952 11.843 0' fill='url(%23d)'/%3e%3cpath d='M393.38 843.89c7.957 0 7.957-11.878 0-11.878-7.962 0-8.156 11.878 0 11.878' fill='url(%23e)'/%3e%3cpath d='M410.46 814.57c0 7.952 11.843 7.952 11.843 0s-11.843-7.952-11.843 0' fill='url(%23f)'/%3e%3c/g%3e%3cg id='ap' stroke='black'%3e%3cpath d='M154.052 272.66c2.176.121 4.391.67 6.438 1.531 3.615 1.523 6.784 4.129 7.906 7.75.007.023.024.04.031.063 31.912 88.55 14.845 126.29-13.5 183.59-40.958 82.506-11.105 205.42 80.375 259.16 44.974 26.295 79.656 35.262 106.22 41.906 13.281 3.322 24.558 6.07 34.094 10.156 9.2 3.94 18.697 11 24.695 19.174-9.19.76-24.19 3.281-31.554 5.445-10.704-13.603-37.624-26.11-65.484-35.588-27.86-9.478-56.925-16.224-72.688-19.344h-.031c-51.284-14.874-99.1-48.249-135.12-90.656-38.135-44.889-57.625-106.35-50.094-167.97 1.687-14.102 7.292-22.719 15.28-27.406 7.99-4.687 18.097-5.486 28.813-4.78 19.477 1.123 38.56-4.195 56-14.939 22.488-13.845 31.704-38.325 31.344-64.906-.36-26.58-10.401-55.133-26.312-76.406-5.686-7.658-7.962-13.4-7.844-17.844.119-4.444 3.002-7.378 6.531-8.406a13.699 13.699 0 012.75-.5 16.09 16.09 0 012.156-.031z' fill='%23825123' stroke-width='3'/%3e%3cpath d='M760.57 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23g)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M731.84 461.38c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23h)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M703.5 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23i)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M771.06 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' fill='url(%23j)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M742.71 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' fill='url(%23k)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M714.17 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' fill='url(%23l)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M772.22 514.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23m)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M745.43 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23n)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M716.89 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' fill='url(%23o)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M768.14 542.02c14.368 0 14.368 21.52 0 21.52-14.557 0-14.751-21.52 0-21.52' fill='url(%23p)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M741.35 542.02c14.363 0 14.363 21.52 0 21.52-14.562 0-14.562-21.52 0-21.52' fill='url(%23q)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M714.37 542.02c14.368 0 14.368 21.52 0 21.52-14.562 0-14.756-21.52 0-21.52' fill='url(%23r)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M762.43 570.11c13.782.547 12.812 21.172-.97 20.575-13.786-.596-13.01-21.371.97-20.575' fill='url(%23s)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M738.05 567.22c13.782.596 12.812 21.172-.974 20.575-13.782-.547-13.006-21.122.974-20.575' fill='url(%23t)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M712.23 566.07c13.787.596 12.817 21.172-.97 20.575-13.781-.596-13.005-21.371.97-20.575' fill='url(%23u)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M752.61 594.2c13.205.994 11.843 20.575-1.357 19.631-13.2-.795-12.037-20.575 1.357-19.631' fill='url(%23v)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M730.29 591.12c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836' fill='url(%23w)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M706.61 589.93c10.094.596 9.12 15.953-.974 15.158-10.094-.596-9.319-15.705.974-15.158' fill='url(%23x)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M742.52 615.97c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836' fill='url(%23y)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M720.97 610.9c10.487.795 9.319 16.5-.97 15.755-10.485-.795-9.512-16.5.97-15.755' fill='url(%23z)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M700.97 608.22c8.737.348 7.763 13.568-.775 12.971-8.737-.398-7.962-13.568.775-12.971' fill='url(%23A)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M733.59 635.55c11.456 2.535 7.574 19.83-3.881 17.096-11.456-2.535-7.57-19.581 3.881-17.096' fill='url(%23B)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M714.56 628c9.512 2.137 6.212 16.5-3.106 14.164-9.513-2.137-6.406-16.5 3.106-14.164' fill='url(%23C)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M696.51 622.58c7.962 1.74 5.243 13.767-2.719 11.828-7.956-1.74-5.238-13.767 2.719-11.828' fill='url(%23D)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M721.16 653.24c10.099 3.479 4.662 18.836-5.437 15.158-10.094-3.529-4.85-18.836 5.437-15.158' fill='url(%23E)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M704.47 644.1c8.543 2.932 3.881 15.755-4.468 12.624-8.538-2.883-4.075-15.705 4.468-12.624' fill='url(%23F)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M688.55 637.34c6.988 2.286 3.3 12.971-3.688 10.437-6.992-2.485-3.3-13.17 3.688-10.437' fill='url(%23G)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M710.49 668.2c8.93 4.075 2.719 17.444-6.212 13.17-8.931-3.877-2.719-17.246 6.212-13.17' fill='url(%23H)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M696.12 658.46c7.38 3.33 2.137 14.562-5.045 11.083-7.38-3.28-2.33-14.562 5.045-11.083' fill='url(%23I)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M682.34 650.91c6.212 2.932 1.744 12.027-4.274 9.294-6.212-2.883-1.938-12.226 4.274-9.294' fill='url(%23J)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M697.09 680.63c7.38 3.678 1.556 14.91-5.626 11.033-7.38-3.678-1.75-14.91 5.626-11.033' fill='url(%23K)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M685.25 671.88c6.212 3.081 1.357 12.425-4.662 9.095-6.212-3.081-1.357-12.425 4.662-9.095' fill='url(%23L)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M673.79 664.87c5.05 2.733.97 10.288-3.881 7.604-5.05-2.535-1.168-10.486 3.881-7.604' fill='url(%23M)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M685.83 691.46c6.406 4.075 0 13.816-6.212 9.542-6.407-4.075-.194-13.816 6.212-9.542' fill='url(%23N)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M675.93 682.57c5.238 3.479 0 11.431-5.243 7.952-5.243-3.479 0-11.68 5.243-7.952' fill='url(%23O)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M666.03 674.96c4.468 2.932 0 9.542-4.27 6.61-4.462-2.882 0-9.492 4.27-6.61' fill='url(%23P)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M674.73 700.43c6.406 4.274 0 13.767-6.212 9.492-6.407-4.075-.194-13.767 6.212-9.492' fill='url(%23Q)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M664.83 691.66c5.238 3.529 0 11.48-5.243 7.952-5.243-3.479 0-11.431 5.243-7.952' fill='url(%23R)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M656.71 684.11c4.463 2.932 0 9.492-4.274 6.61-4.463-2.932 0-9.741 4.274-6.61' fill='url(%23S)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M647.98 693.4c4.075 2.535 0 8.747-3.886 6.212-4.076-2.683 0-8.896 3.886-6.212' fill='url(%23T)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M655.16 701.4c4.463 2.883 0 9.492-4.27 6.56-4.467-2.882 0-9.492 4.27-6.56' fill='url(%23U)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M662.92 709.55c4.85 3.28 0 10.486-4.662 7.157-4.855-3.082 0-10.487 4.662-7.157' fill='url(%23V)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M638.85 702.94c3.688 2.535 0 7.952-3.688 5.616-3.692-2.535 0-8.15 3.688-5.616' fill='url(%23W)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M644.57 709.92c4.075 2.733 0 8.747-3.881 6.014-4.08-2.684 0-8.698 3.881-6.014' fill='url(%23X)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M651.55 716.84c4.274 2.684 0 9.294-4.27 6.411-4.273-2.932 0-9.343 4.27-6.411' fill='url(%23Y)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M630 709.28c3.3 2.137 0 7.405-3.3 5.07-3.3-2.138 0-7.356 3.3-5.07' fill='url(%23Z)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M635.21 715.78c3.688 2.535 0 8.15-3.688 5.666-3.687-2.535 0-8.15 3.688-5.666' fill='url(%23aa)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M641.53 723.19c3.881 2.535 0 8.747-3.881 5.815-3.882-2.535 0-8.747 3.881-5.815' fill='url(%23ab)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M622.74 714.97c3.106 2.336-.393 7.008-3.499 4.672-2.912-2.336.393-7.008 3.499-4.672' fill='url(%23ac)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M627.45 721.07c3.3 2.535-.388 7.554-3.688 5.02-3.3-2.485.388-7.555 3.688-5.02' fill='url(%23ad)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M631.97 727.58c3.494 2.733-.388 8.35-4.075 5.467-3.494-2.733.387-8.35 4.075-5.467' fill='url(%23ae)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M615.7 719.44c2.525 2.137-.775 6.063-3.3 3.727-2.52-2.335.78-6.013 3.3-3.727' fill='url(%23af)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M619.58 725.92c2.525 2.286-.97 6.56-3.688 3.877-2.718-2.336.97-6.61 3.688-3.877' fill='url(%23ag)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M623.18 732.05c2.912 2.733-.97 7.008-3.881 4.274-2.913-2.485.969-6.958 3.881-4.274' fill='url(%23ah)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M608.34 723.22c2.33 2.137-.97 5.616-3.3 3.479-2.33-2.336.97-5.815 3.3-3.479' fill='url(%23ai)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M611.02 729c2.525 2.535-.97 6.212-3.494 3.678-2.524-2.336.97-6.213 3.494-3.678' fill='url(%23aj)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M614.9 735.44c2.719 2.733-1.163 6.809-3.881 4.075-2.719-2.534.974-6.808 3.881-4.075' fill='url(%23ak)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M601.5 727.58c1.744 1.938-1.168 4.672-2.912 2.733-1.75-1.938.969-4.87 2.912-2.733' fill='url(%23al)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M603.61 732.94c1.943 2.137-1.163 5.02-3.3 2.883-1.744-2.137 1.168-5.02 3.3-2.883' fill='url(%23am)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M606.49 738.49c2.132 2.336-1.362 5.417-3.499 3.131-2.132-2.336 1.362-5.666 3.499-3.131' fill='url(%23an)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath d='M687.6 446.92c10.094 0 10.094 15.158 0 15.158s-10.288-15.158 0-15.158' fill='url(%23ao)' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3c/g%3e%3cuse height='500' transform='matrix(-1 0 0 1 832.957 0)' width='833.333' xlink:href='%23ap'/%3e%3cpath d='M182.15 433.08c11.262-37.473 16.893-85.632.974-148.3 70.081-45.226 119.39-86.576 233.55-86.576 113.96 0 167.73 31.41 233.55 86.576-15.725 62.671-10.094 110.63.97 148.3h-469.42' fill='%2389c5e3' stroke='black'/%3e%3cpath d='M235.5 341.84l-5.22 56.66c-.051.007-.105-.008-.156 0l-20.12-56.16 9.687 59.312c-.072.033-.147.06-.219.094l-22.47-29.65 13.5 35.25-16.5-11.5 10.031 18.812c-.09.129-.192.245-.28.375l-11.75-1.438 7.28 10.22a38.86 38.86 0 00-2.28 13.17c0 .213.06.411.063.624h77.625c.003-.213.062-.41.062-.625 0-4.637-.791-9.095-2.28-13.219l15.29-14.67-19.25 6.72c-.156-.24-.309-.483-.47-.719 2.958-3.633 31.908-39.25 30.72-39.25-1.229 0-36.6 30.34-37.844 31.406l-.188-.156 27.781-61.5-38.438 55.188c-.126-.05-.248-.108-.375-.156l11.32-58.28-20.25 56-5.25-56.5z' fill='%23fcdd09'/%3e%3cpath d='M181.82 433.08c-6.212 20.774-13.975 38.467-20.769 53.576-17.668 39.809-21.356 132.4 43.874 197.85 96.873 96.863 170.65 57.85 207.73 110.63h7.57c37.08-52.78 110.85-13.767 207.73-110.63 65.23-65.454 61.735-158.04 43.873-197.85-6.6-14.959-14.562-32.801-20.774-53.576h-469.42' fill='%230f47af' stroke='black'/%3e%3cpath d='M323.62 343.97c-1.122-5.432-13.795-4.388-12.875-13.125-8.429-1.344-6.858-16.406 8.875-15.375 1.657-2.99 20.674-9.835 18.375-.375 9.544-8.316 16.457-.702 11.125 3 3.682 3.687 5.54 12.114-5.75 11.375 4.32 7.685-5.712 7.399-12.375 5.25.164 2.911-.332 5.217-4.125 4.5-2.394 1.618-.582 3.704-.25 5.625zm174.6 5.93c.107-6.855-12.811-4.763-12.33-12.57-7.012-1.075-5.993-15.596 8.5-14.724-.808-4.194 19.513-9.577 17.596-.36 7.079-7.505 14.066-.489 9.78 2.874 3.526 3.53 7.806 9.601-4.632 10.894 5.013 4.86-5.47 7.085-11.851 5.028.157 2.788-1.693 3.746-5.326 3.06-2.292 1.55.818 4.796 1.136 6.636l-2.873-.838zm100.68 23.69c1.202-5.19-10.656-4.731-10.349-10.643-5.387-.814-4.605-11.809 6.53-11.149-.62-3.176 13.868-8.502 12.896-.772 5.439-5.683 11.432.13 8.139 2.675 2.71 2.674 5.998 7.27-3.559 8.249 3.852 3.68-4.203 5.365-9.105 3.807.12 2.11-.55 2.461-3.342 1.942-1.762 1.173 2.128 4.007 2.372 5.4l-3.582.49z' fill='white'/%3e%3cpath d='M-308.88 472.49c2.912-15.158 15.337-29.124 16.699-40.952 1.163-10.685 3.3-15.158 9.512-26.39 6.213-11.282 8.733-16.5 10.094-24.303 1.939-10.089 9.513-12.226 13.006-1.938 3.3 10.288 9.9 36.13 13.394 42.145 3.3 6.013 6.8 14.363 6.213 18.438-.582 4.075 4.468 5.616 7.38 8.548 2.913 2.733 3.3 12.226 11.843 20.377 8.538 8.15 18.051 13.965 26.012 18.04 7.182 16.153 12.037 40.605 10.87 68.536h-533.29c-.195-7.356 0-14.562.387-21.52 47.368-12.226 65.036-43.487 85.03-41.35 10.874-15.158 24.074-31.46 33.199-39.81 10.869-9.89 32.225-49.3 37.662-73.405 5.437-23.856 13.394-36.678 19.412-35.336 6.018 1.392 8.543 2.535 15.725 24.104 9.905 29.67 16.699 33.199 24.268 54.52 6.6 18.488 20.387 51.637 41.548 68.933 13.2-9.89 28.343-20.973 33.194-28.726 4.08-6.809 10.293-17.295 17.668-22.315 3.3-9.89 7.569-27.583 11.068-31.857 3.3-3.877 4.657-7.753 5.044-14.562.194-6.809 5.437-21.172 12.62-33.2 7.186-11.827 16.698-15.704 20.967 0 4.076 15.756 13.588 48.756 22.52 69.33 3.687 8.55 10.486 25.397 25.43 43.09l1.614 1.906c.303-.53.607-.926.911-2.304z' fill='%23509164' stroke='black' stroke-width='.999' transform='matrix(1.00186 0 0 1 867.911 0)'/%3e%3cg fill='%23034418'%3e%3cpath d='M497.202 528.38c-9.919-9.542-25.673-7.405-33.645-14.959-7.782-7.356-20.23-2.336-47.073-15.904-3.307-1.74-6.613-3.876-9.919-6.411-21.201-17.295-35.008-50.494-41.62-68.933-7.394-21.172-14.395-24.651-24.314-54.57-5.252-15.904-8.17-20.774-11.67-22.514 9.142 9.94 4.282 25.446 11.67 42.145 2.918 6.61-1.946 6.61-3.5 4.473-1.36-2.137-5.835-3.131-7.976-2.932 3.893 3.33 4.476 11.679 8.364 20.377 3.695 8.747-2.917 7.802 5.06 20.228 2.135 3.478 2.917 8.697-.195 10.834-3.306 1.938-5.641-6.014-10.506-3.28 1.364 3.13 7 8.746 10.7 12.026 3.694 3.33.194 5.07-2.724 3.529-3.112-1.59-7.2-3.131-9.336-4.87 0 2.534 3.112 5.417 7.389 9.293 4.476 3.728 1.558 6.411-8.753 6.411 1.558 2.336.976 8.151-3.695 8.946 6.418.398 11.283 12.226 19.255 13.021 7.782.547 8.56 6.014.976 7.356-7.588 1.342-22.954-10.884-30.537-18.836-1.947 2.733-6.03 3.876-8.948 2.336-.194 3.677.971 12.624 4.472 18.438-3.695-1.541-8.554-6.412-13.42-12.425-4.665-5.616-7.777 2.733-3.694 7.753 4.083 5.069 6.807 9.144.194 13.02-6.418 3.678-10.501 2.336-15.365-4.472-6.807 5.665-9.53 6.013-14.784 5.069 0 3.28-5.641 11.083-8.165 16.898-5.642 11.232 250.125 34.541 242.931 7.356'/%3e%3cpath d='M681.164 530.1c-67.298-5.864-104.444-31.857-125.454-56.707-14.976-17.494-21.783-34.541-25.478-43.089-8.947-20.575-18.477-53.576-22.56-69.33-1.365-5.218-3.307-8.35-5.642-9.492-3.5-1.74-1.753 4.274.777 7.355 2.723 2.932 2.529 5.666-.971 3.529-3.5-1.939-5.253 1.938-1.947 6.759 3.112 4.671 7.976 10.139 8.947 15.357.976 5.069 1.365 9.492 3.889 12.027 2.335 2.534-6.418 3.13-10.113-2.883-.194 3.877.976 9.493 3.5 8.896 2.336-.397 3.113 1.74-.194 7.604-3.306 5.616-2.917 7.555-1.747 10.09 1.747 3.876 6.224-11.48 8.947-2.734 1.36 4.075 3.695 9.144 5.83 12.425 2.142 3.13 1.948 5.07-1.164 5.07s-5.836-7.804-6.224-1.194c-.194 6.412 4.864 8.549 10.113 8.151 5.058-.199 5.835 1.74 5.058 4.473-.582 2.733 1.554 5.417 4.472 4.87 2.723-.795 7.005 1.74 9.336 8.35 2.335 6.61-1.554 9.492-7.195 4.82-5.642-4.82-13.808-9.094-14.59-12.623-.582-3.082-2.917 1.391-.388 5.665 2.335 4.274 3.695 6.213 6.807 7.952 3.112 1.54-.194 7.952-5.442 3.877-5.06-3.877-7.394-2.933-8.948 1.54-2.53 7.207-10.113 5.467-7.782 9.344 2.335 3.876 1.364 10.089-2.137 11.63-3.699 1.54-7.976-.746-7.588-7.555-.97 1.342-4.665 1.939-7.583 1.144-.388 9.542-3.112 12.822-8.948 10.288-.194 2.137-.388 5.814-3.306 8.548 6.418-.945 7.778 3.479 8.36 6.212.394 2.734 1.365 2.336 5.06 2.734 3.5.198 7.976 4.82 1.363 3.677-6.617-.944-16.924 1.342-22.953-3.081 6.224 5.616 23.924 5.815 31.314 12.97 53.88 22.167 148.797 29.92 186.326 19.632.195-4.473-.388-14.761-.776-18.041'/%3e%3cpath d='M603.028 372.77c1.554.745 3.112 2.883 4.472 6.212 3.306 10.288 9.918 36.082 13.424 42.095 3.306 6.014 6.806 14.363 6.224 18.438-.588 4.076 4.471 5.666 7.389 8.549 2.918 2.733 3.306 12.226 11.865 20.377 8.559 8.15 18.09 14.015 26.06 18.09 4.865 10.834 8.56 25.396 10.113 42.493-22.949-1.74-51.733-8.549-66.128-14.96.583-2.136.583-4.82-.194-8.895-.971-4.076-.194-7.207 4.083-11.083 4.282-3.877 2.918-10.487.587-14.164-2.335-3.48-2.14-5.616-.199-7.753 1.753-1.939 1.753-5.467-2.33-9.344-4.282-3.876-1.364-7.952.97-11.43 2.336-3.53 5.836-9.543 3.307-17.296-2.53-7.554-6.418 1.74-9.53-1.143-1.947-1.988-3.112-5.666-.971-8.747 2.136-2.932.777-8.548-1.753-12.822 5.642-1.54-3.888-18.041-5.447-25.048-1.553-7.008 1.753-10.486-1.942-13.22'/%3e%3c/g%3e%3cpath d='M358.313 435.81c0 3.678-.97 8.946-1.946 10.685 2.335 3.678 5.447 11.232 5.058 13.568 3.112-2.882 9.142-.596 10.502 7.405 1.364 8.15 2.724 15.705 1.947 20.178 2.723 2.336 8.559 6.411 9.53 10.884.97 4.274 3.889 3.678 6.806 3.28 9.142-1.342 8.365 9.692 17.896 8.15 13.419-1.937 5.059 8.748 18.477 8.35 7.778-.397 18.477 1.143 23.925 8.747 6.024-8.15 11.278-5.069 16.725-2.932 5.447 1.938 12.253 1.392 6.224-2.882-6.224-4.473-18.478-5.07-23.925-3.728-5.447 1.392-13.613.398-19.255-4.622-5.447-5.07-14.976-9.343-20.812-9.542-5.836-.199-7.195-.547-11.666-7.157-4.282-6.41-11.283-5.665-14.784-6.013-3.306-.2-5.835-4.473-1.946-8.548 5.641-6.014-2.336-6.81.582-10.487 2.918-3.678 1.365-8.549-6.418-9.145-7.777-.596-4.86-3.082-3.694-8.548 2.723-12.971-14.784-10.834-13.42-17.047m305.562 69.284c.777-7.952-5.253-11.232-6.612-17.295-1.165-6.014-10.7-6.212-13.225-4.423.971 1.74 0 4.82-1.17 6.56-1.165 1.59-1.165 2.535 1.17 3.33 2.525.596 4.666 1.143 4.86 3.28.194 1.938 1.364.199 2.335-2.336.777-2.485 7.584 3.131 8.365 8.15.583 5.07 3.306 8.549 4.083 2.535m-31.314-8.351c1.165 2.932 5.447 7.008 7.777 7.008 2.335 0 5.836 1.74 6.418 4.472.394 2.336 2.335 5.616 4.865 6.014 2.53.398 1.165 2.336-1.947 2.137-3.306-.199-8.36-2.137-8.748-4.473 1.165 4.87-.394 7.008-3.506 3.48-2.917-3.28-4.47-7.953-8.36-8.549 2.918-.547 3.306-1.342 1.942-4.274-1.165-2.883-.194-10.636 1.559-5.815' fill='%23509164'/%3e%3cpath d='M-716.69 545.89c6.382-3.131 16.23-1.938 19.904 1.342 1.93-3.678 5.025-6.411 10.828-5.417 4.644-5.07 8.511-7.604 11.22-5.07 2.708-5.02 11.799-6.212 14.894-3.08 3.288-5.07 9.863-7.406 14.309-4.673 5.803-7.604 16.052-10.288 22.241-6.41 5.417-4.076 11.606-3.28 14.314-.597 2.708 2.535 8.511-2.684 10.833 2.137 4.06-.944 11.794-1.143 13.344 3.13.965-2.335 4.446-3.726 6.382-1.937 0-8.946 6.382-15.755 15.28-13.618 4.253-6.412 11.606-9.095 15.087-6.81 3.674-3.677 11.215-1.142 14.502 3.33 7.16-.198 10.64 3.082 14.314 9.493 3.674 6.411 14.314 10.288 21.083 7.405 6.769-2.534 12.958-3.33 15.28-.198 4.06-3.678 8.511-2.734 11.215-.2 4.644 4.076 9.09-3.13 11.8-.397 4.257 4.473 8.124-4.075 15.665.398 7.353 4.473 21.855 11.232 33.075 11.232s20.117-13.767 27.272-4.076c7.155-4.82 17.988-7.156 25.53-3.08 4.45-4.076 14.7-5.418 18.76-1.542 4.06-6.212 11.798-9.94 18.373-7.802 3.674-6.362 18.374-7.356 22.821 1.59 3.679 0 9.477 3.28 9.477 7.356 3.679 0 9.482 2.335 9.482 6.61 4.06-.994 9.085 1.54 9.863 6.41 8.12-.596 14.7 2.734 18.374 9.493 2.708-2.336 1.158-8.35 7.347-9.492 6.19-.994 8.126.944 9.863 3.081 6.769-5.02 16.25-4.423 24.177 2.733 5.803-2.335 11.22-1.341 12.958 1.541 2.516-2.336 6.576-2.882 10.64-2.882.194 13.17-.97 27.533-3.871 42.294h-523.75c-2.709-14.363-3.867-28.726-3.674-41.946' fill='%23078930' stroke='black' stroke-width='.999' transform='matrix(1.00186 0 0 1 867.911 0)'/%3e%3cpath d='M416.28 245.04l-5.243 16.898H393.18l14.557 10.486-5.437 16.898 14.174-10.487 14.368 10.487-5.438-16.898 14.363-10.089h-17.663l-5.437-16.898m-67.947 5.223l-2.525 17.494-17.469 2.733 15.92 7.952-2.72 17.444 12.426-12.624 15.725 8.002-8.156-15.755 12.62-12.425-17.47 2.733-8.155-15.755M282.72 267.16l.194 17.693-16.893 5.616 17.087 5.268v17.643l10.094-14.562 16.893 5.268-10.68-14.214 10.293-14.363-16.893 5.666-10.675-14.214M220.4 294.14l3.106 17.494-15.725 8.35 17.663 2.335 2.913 17.444 7.574-15.904 17.469 2.336-12.812-12.425 7.768-15.755-15.725 8.35-12.812-12.226M484.23 250.66l2.525 17.494 17.469 2.733-15.92 7.952 2.72 17.444-12.426-12.624-15.725 8.002 8.15-15.755L458.6 263.48l17.474 2.733 8.155-15.755m66.011 16.702l-.194 17.693 16.888 5.616-17.082 5.268v17.643l-10.094-14.562-16.893 5.268 10.68-14.214-10.293-14.363 16.7 5.666 10.674-14.214m61.934 27.179l-3.106 17.494 15.725 8.35-17.668 2.335-2.908 17.444-7.574-15.904-17.474 2.336 12.817-12.425-7.768-15.755 15.725 8.35 12.812-12.226' fill='white'/%3e%3cpath d='M387.186 672.52l1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65' fill='%23865800'/%3e%3cpath d='M387.186 672.52l1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548' fill='white'/%3e%3cpath d='M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M431.056 672.72l1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4' fill='%23865800'/%3e%3cpath d='M431.056 672.72l1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548' fill='white'/%3e%3cpath d='M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M472.596 679.93l1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4' fill='%23865800'/%3e%3cpath d='M472.596 679.93l1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498' fill='white'/%3e%3cpath d='M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498.149z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234' fill='%23704d25'/%3e%3cpath d='M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234l-.58.348z' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M496.476 572.18l-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396' fill='white'/%3e%3cpath d='M496.476 572.18l-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396l-.194-.199z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404' fill='white'/%3e%3cpath d='M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404l-.198.15z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157' fill='white'/%3e%3cpath d='M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157h-.195z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M464.836 562.84l-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392' fill='white'/%3e%3cpath d='M464.836 562.84l-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392l-.194.198z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M461.726 598.18l-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473' fill='white'/%3e%3cpath d='M461.726 598.18l-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473h-.194z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M463.086 635.65l-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678' fill='white'/%3e%3cpath d='M463.086 635.65l-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335' fill='white'/%3e%3cpath d='M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335l-.194-.2z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118' fill='white'/%3e%3cpath d='M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118l.193.199z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157' fill='white'/%3e%3cpath d='M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157v.199z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913' fill='white'/%3e%3cpath d='M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913v.199zm.97-18.84c-26.4 26.589-63.868 74.002-77.461 99.796m184.821-71.616c7.181 34.938 8.93 81.904 6.019 99.199' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745' fill='%2300009e'/%3e%3cpath d='M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745-.22z' fill='%23002b7f'/%3e%3cpath d='M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745' fill='white'/%3e%3cpath d='M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745z' fill='none'/%3e%3cpath d='M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524' fill='%23ff0016'/%3e%3cpath d='M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524' fill='%23ce1126'/%3e%3cpath d='M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z' fill='white'/%3e%3cpath d='M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z' fill='none'/%3e%3cpath d='M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.524' fill='%2300009e'/%3e%3cpath d='M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.744z' fill='%23002b7f'/%3e%3cg stroke-width='1.832'%3e%3cpath d='M404.084 440.136l.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717' fill='%23865800'/%3e%3cpath d='M404.084 440.136l.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033' fill='white'/%3e%3cpath d='M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M419.651 440.207l.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628' fill='%23865800'/%3e%3cpath d='M419.651 440.207l.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033' fill='white'/%3e%3cpath d='M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M434.392 442.765l.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628' fill='%23865800'/%3e%3cpath d='M434.392 442.765l.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016' fill='white'/%3e%3cpath d='M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016.053z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825' fill='%23704d25'/%3e%3cpath d='M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825l-.206.123z' fill='%23704d25' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M442.866 404.53l-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011' fill='white'/%3e%3cpath d='M442.866 404.53l-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011l-.069-.071z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499' fill='white'/%3e%3cpath d='M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499l-.07.053z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25' fill='white'/%3e%3cpath d='M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25h-.068z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M431.638 401.216l-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204' fill='white'/%3e%3cpath d='M431.638 401.216l-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204l-.069.07z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M430.535 413.756l-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297' fill='white'/%3e%3cpath d='M430.535 413.756l-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297h-.068z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M431.017 427.053l-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015' fill='white'/%3e%3cpath d='M431.017 427.053l-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829' fill='white'/%3e%3cpath d='M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829l-.068-.07z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687' fill='white'/%3e%3cpath d='M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687l.069.07z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25' fill='white'/%3e%3cpath d='M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25v.07z' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65'/%3e%3cpath d='M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39' fill='white'/%3e%3cpath d='M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39v.07zm.344-6.686c-9.368 9.435-22.664 26.26-27.488 35.413m65.585-25.413c2.548 12.398 3.17 29.064 2.136 35.201' stroke-width='.65' fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427' fill='%2300009e'/%3e%3cpath d='M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427v-.079z' fill='%23002b7f'/%3e%3cpath d='M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684' fill='white'/%3e%3cpath d='M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684z' fill='none'/%3e%3cpath d='M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606' fill='%23ff0016'/%3e%3cpath d='M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606' fill='%23ce1126'/%3e%3cpath d='M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z' fill='white'/%3e%3cpath d='M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z' fill='none'/%3e%3cpath d='M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.606' fill='%2300009e'/%3e%3cpath d='M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.684z' fill='%23002b7f'/%3e%3c/g%3e%3cpath d='M650.12 284.78c-24.656 97.46 2.912 159.19 21.937 201.88 17.862 39.809 21.356 132.4-43.874 197.85-96.873 96.863-170.65 57.85-207.73 110.63m-7.953.19c-37.08-52.78-110.85-13.76-207.73-110.63-65.23-65.45-61.73-158.04-43.87-197.85 19.02-42.49 46.59-104.22 21.94-201.88' fill='none' stroke='black' stroke-width='3'/%3e%3cg stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3e%3cpath d='M427.55 39.787c1.357 6.308 3.106 23.321-6.212 25.758 17.082 21.075 41.737 24.086 85.03 24.086 27.18 0 49.118-.191 65.23 0 0 5.4-1.75 11.183-1.75 17.921 0 6.5 6.799 9.51 16.7 7.264 9.9-2.246 31.061-8.602 42.512 1.481 19.224 17.204 54.555 20.167 64.067 31.015-2.912-13.094-15.337-26.332-29.119-37.37 13.006-1.864 29.894-.526 35.72 3.918-14.76-15.999-41.55-16.382-55.14-24.219-13.59-7.838-26.6-14.767-36.69-17.395 0-4.444-.587-8.028-4.469-10.609-8.543-5.974-25.237-8.028-38.825-8.793 1.939-2.055 2.326-4.492 2.326-8.22V23.55c0-7.312.78-9.175-7.57-14.385-32.224-19.785-71.441-33.978-142.88-33.978-71.248 0-110.47 14.002-142.88 33.978-8.542 5.21-7.568 7.073-7.568 14.385v21.075c0 3.728.194 6.165 2.326 8.22-13.588.573-30.088 2.628-38.825 8.793-3.688 2.58-4.468 5.974-4.468 10.61-9.9 2.437-22.906 9.366-36.688 17.394-13.593 7.838-40.38 8.22-55.136 24.23 5.63-4.445 22.519-5.974 35.525-3.92-13.588 10.849-26.012 24.087-29.12 37.372 9.513-10.849 44.844-13.812 64.262-31.016 11.257-10.084 32.419-3.918 42.513-1.481 9.9 2.246 16.699-.573 16.699-7.264 0-6.738-1.75-12.521-1.75-17.921 15.92-.382 37.856 0 65.23 0 43.1 0 67.755-3.01 85.03-24.086-9.512-2.437-7.763-19.259-6.212-25.758-20.188-4.492-30.282-12.138-46.593-12.138-16.112 0-19.025 8.554-19.025 11.756v2.628c-12.812 0-30.868-3.202-35.331-11.613 24.85-10.084 61.736-19.21 112.4-19.21 50.668 0 87.555 9.127 112.4 19.21-4.463 8.411-22.52 11.613-35.331 11.613v-2.628c0-3.01-2.719-11.756-19.025-11.756s-26.405 7.455-46.593 12.138h-.775z' fill='%2389c5e3'/%3e%3cg fill='none'%3e%3cpath d='M260.98 89.965c-12.619.191-21.55.956-26.405 2.437-7.763 2.438-8.538 6.547-3.494 8.793M339.21 42.176v9.749c0 6.308 6.794 14.528 17.28 14.528 25.819 0 30.868-4.444 50.087-3.919'/%3e%3cpath d='M406.38 62.009c-17.86-3.011-32.03-12.521-47.76-12.521-15.531 0-18.831 7.073-16.112 10.466M224.48 72.809V92.02c0 5.257 3.688 12.521 17.668 9.749 12.231-2.246 20.188.526 20.188 5.782'/%3e%3cpath d='M267.96 53.215c2.912 2.963 9.319 5.591 23.493 10.657 26.012 9.51 85.805 16.009 124.64-.956M528.88 30.42c5.05 2.055 9.706 4.11 13.787 6.165 24.263 12.138 26.012 14.958 17.469 19.594m11.654 33.786c12.619.191 21.55.956 26.405 2.437 7.763 2.438 8.538 6.547 3.494 8.793M493.36 42.176v9.749c0 6.308-6.794 14.528-17.28 14.528-25.819 0-30.868-4.444-50.087-3.919'/%3e%3cpath d='M426.18 62.009c17.87-3.011 32.04-12.521 47.77-12.521 15.526 0 18.831 7.073 15.919 10.466M608.09 72.809V92.02c0 5.257-3.688 12.521-17.668 9.749-12.231-2.246-20.193.526-20.193 5.782'/%3e%3cpath d='M564.61 53.215c-2.912 2.963-9.319 5.591-23.493 10.657-26.012 9.51-85.805 16.009-124.64-.956'/%3e%3c/g%3e%3cpath d='M416.28 66.453c11.843 0 12.231-8.937 12.231-17.156 0-8.029-.388-17.013-12.231-17.013s-12.231 8.984-12.231 17.013.388 17.156 12.231 17.156z' fill='%2389c5e3'/%3e%3cpath d='M304.55 30.437c-5.169 2.052-9.936 4.105-14.113 6.157-24.843 12.123-26.628 14.939-17.883 19.568' fill='none'/%3e%3c/g%3e%3cg id='aq' fill='%23078930' stroke='black' stroke-width='3'%3e%3cpath d='M387.94 192.56c16.306-10.486 36.499-28.13 43.874-39.809 10.094-16.301 11.456-8.35 19.219-9.691-18.25 19.979-40.962 41.35-57.074 52.63l-6.019-3.13m-136.48 39.21c-40.768-23.11-56.299.994-65.812 2.137 11.257 2.734 20.769 20.774 65.812-2.137z'/%3e%3cpath d='M269.71 218.4c-38.83-26.241-56.105-3.33-65.816-2.733 11.068 3.479 19.224 22.315 65.816 2.733z'/%3e%3cpath d='M297.47 202.84c-38.248-26.987-56.105-4.473-65.816-4.075 11.068 3.876 18.637 22.514 65.816 4.075z'/%3e%3cpath d='M320.38 189.08c-35.137-31.062-55.33-10.486-64.842-11.282 10.482 5.07 16.112 24.452 64.842 11.282z'/%3e%3cpath d='M349.69 178.99c-33.582-32.851-54.744-13.22-64.256-14.562 10.288 5.417 14.95 25.396 64.256 14.562z'/%3e%3cpath d='M380.37 175.66c-27.762-37.672-51.831-21.917-61.15-24.651 9.125 7.206 10.482 27.384 61.15 24.651z'/%3e%3cpath d='M385.42 177.2c-1.362-8.498-17.28-19.383-18.637-23.458 4.075-.398 4.657-5.268 2.912-7.008-1.361-1.342-4.661-.596-6.406 1.193-1.75 2.137-3.494 7.157 2.132 11.431 5.825 4.274 13.205 12.027 15.536 17.842'/%3e%3cpath d='M214.38 234.5c11.063-3.33 25.043-1.74 34.75-2.733M232.44 218.2c11.451-2.535 25.043 0 34.943 0m-7.183-16.35c11.451-2.087 25.043.596 34.943.596M283.49 184.01c11.65-.944 24.85 3.33 34.556 4.473M313 171.98c11.644-.398 24.656 4.473 34.362 6.212m-1.942-15.162c11.649 1.193 23.686 8.548 32.811 11.48' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3cuse height='100%25' transform='matrix(-1 0 0 1 832.76 0)' width='100%25' xlink:href='%23aq'/%3e%3cg stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3e%3cg fill='white'%3e%3cpath d='M416.49 190.46c9.125 0 16.888 0 22.519-.745v-13.021c0-4.275 15.143-9.344 38.05-4.871 89.692 17.494 101.92 58.049 170.07 81.357.775.199 3.3.994 6.212 1.54 1.75-4.075 3.688-8.15 5.825-13.17 1.163-3.727 11.068-3.528 19.8.547 10.1 4.87 14.562 10.487 12.817 13.42-1.75 4.274-3.499 7.753-5.05 11.231 15.92 5.666 44.844 14.214 35.332 52.433-7.376-7.156-25.237-14.959-36.3-14.959-12.62 0-26.211-4.82-21.937-18.637-2.331-1.143-6.411-3.28-8.544-3.677-.387 1.193-.969 2.336-1.555 3.479-2.913 7.206-15.531 9.74-28.15 5.467-71.055-24.253-92.992-77.878-176.86-78.624v2.335c0 6.76-8.737 12.971-32.225 12.971-23.3 0-32.225-6.212-32.225-12.97v-2.336c-83.673.546-105.81 54.172-176.86 78.624-12.425 4.274-25.043 1.54-28.15-5.467-.393-1.143-.974-2.287-1.556-3.48-2.137.398-6.212 2.535-8.543 3.678 4.08 13.618-9.125 18.637-21.937 18.637-11.063 0-28.731 7.803-36.3 14.96-9.513-38.02 19.025-46.569 35.33-52.434-1.555-3.478-3.105-6.957-5.049-11.232-1.55-2.932 2.719-8.548 12.812-13.419 8.738-4.274 18.443-4.472 19.805-.546 2.138 4.82 3.882 8.896 5.825 13.17 2.913-.547 5.238-1.342 6.213-1.541 67.949-23.309 80.373-63.863 170.06-81.357 22.717-4.473 38.055.596 38.055 4.87v13.022c5.63.546 13.394.745 22.519.745z'/%3e%3cpath d='M393.78 189.71c-6.019-.596-9.512-1.938-9.512-4.274 0-5.815 9.512-3.877 9.512-8.747M165.27 253.58c3.494 8.35 7.962 19.035 12.037 28.13m-20.577-23.86c3.494 8.15 10.099 22.116 12.037 27.931'/%3e%3c/g%3e%3cpath d='M140.62 255.71c2.33 4.075 14.562-1.938 16.112 1.938 1.362 4.076-2.326 6.213-10.869 9.294m27.567-25.392c1.744 5.218-10.487 7.356-7.962 12.027 1.556 3.081 8.35 2.137 13.786.944' fill='none'/%3e%3cpath d='M384.06 185.24v26.987m55.14-22.517c5.825-.596 9.512-1.938 9.512-4.274 0-5.815-9.512-3.877-9.512-8.747m228.5 76.891c-3.494 8.35-7.962 19.035-12.037 28.13m20.577-23.86c-3.499 8.15-10.099 22.116-12.037 27.931' fill='white'/%3e%3cpath d='M692.36 255.71c-2.33 4.075-14.562-1.938-16.112 1.938-1.362 4.076 2.326 6.213 10.869 9.294M659.55 241.55c-1.744 5.218 10.487 7.356 7.962 12.027-1.556 3.081-8.35 2.137-13.787.944' fill='none'/%3e%3cpath d='M448.91 185.24v26.987' fill='white'/%3e%3c/g%3e%3cpath d='M203.96 281.77l-7.523-26.884 9.371-2.622c2.396-.67 4.176-.908 5.338-.713 1.162.196 2.24.797 3.233 1.805.994 1.007 1.724 2.342 2.189 4.005.588 2.102.558 3.937-.092 5.503-.649 1.566-1.857 2.774-3.623 3.624 1.146.417 2.144.946 2.995 1.584.85.639 2.108 1.859 3.773 3.66l4.145 4.496-5.3 1.483-4.865-4.947c-1.753-1.79-2.912-2.892-3.476-3.308-.565-.415-1.107-.659-1.629-.73-.52-.072-1.295.035-2.322.323l-.917.256 3.141 11.223zm.097-16.756l3.3-.924c2.018-.564 3.277-1.012 3.777-1.343.5-.331.847-.814 1.039-1.448.192-.633.163-1.396-.087-2.289-.24-.856-.603-1.495-1.09-1.92a2.718 2.718 0 00-1.695-.682c-.453-.018-1.676.251-3.669.81l-3.484.974zm24.613 9.536l-12.392-25.016 15.221-7.54 2.096 4.232-11.092 5.494 2.748 5.546 10.306-5.105 2.088 4.215-10.307 5.105 3.373 6.809 11.467-5.68 2.088 4.214zm20.14-10.63l-15.128-23.463 6.242-4.024c2.326-1.5 3.919-2.368 4.778-2.605 1.376-.373 2.816-.207 4.321.5 1.505.705 2.86 1.992 4.064 3.86 1.094 1.696 1.69 3.324 1.79 4.884.099 1.56-.182 2.881-.843 3.964-.661 1.084-2.165 2.382-4.513 3.896l-2.545 1.64 5.707 8.85zm-8.695-21.991l4.292 6.658 2.145-1.383c1.44-.928 2.354-1.66 2.74-2.197.388-.537.576-1.175.566-1.917-.01-.741-.262-1.496-.757-2.264-.502-.78-1.096-1.325-1.782-1.639-.685-.313-1.337-.399-1.955-.257-.619.142-1.74.736-3.36 1.781zm10.435-12.159l3.778-2.64 8.66 12.396c1.345 1.925 2.268 3.146 2.769 3.664.871.893 1.815 1.395 2.83 1.507 1.015.111 2.037-.193 3.068-.913.874-.61 1.45-1.304 1.73-2.08.278-.775.277-1.58-.004-2.413-.28-.834-1.217-2.39-2.81-4.67l-8.844-12.66 3.793-2.65 8.398 12.02c2.145 3.07 3.532 5.404 4.16 7.001.628 1.598.664 3.222.106 4.874-.557 1.652-1.777 3.135-3.661 4.451-1.957 1.367-3.73 2.083-5.318 2.148-1.589.065-3.075-.368-4.46-1.297s-3.274-3.106-5.666-6.53zm19.27-13.94l7.703-4.957c2.103-1.353 3.705-2.112 4.806-2.278 1.102-.165 2.259.049 3.471.643 1.212.593 2.214 1.504 3.004 2.732.728 1.131 1.135 2.315 1.22 3.55s-.13 2.33-.65 3.284c1.404-.33 2.744-.211 4.022.355 1.278.567 2.37 1.555 3.278 2.964 1.099 1.708 1.617 3.416 1.554 5.125s-.565 3.063-1.508 4.061c-.655.694-2.403 1.955-5.243 3.782l-6.55 4.215zm6.39 1.413l3.493 5.43 2.562-1.65c1.538-.989 2.47-1.627 2.8-1.914.593-.533.93-1.146 1.012-1.84.081-.695-.129-1.431-.63-2.21-.447-.695-.961-1.16-1.544-1.396-.582-.237-1.124-.27-1.625-.098-.501.172-1.777.917-3.826 2.236zm6.008 9.337l4.04 6.277 3.602-2.319c1.58-1.017 2.541-1.752 2.883-2.206.342-.454.51-1.022.5-1.703-.007-.682-.252-1.396-.733-2.144-.495-.768-1.065-1.296-1.71-1.583a2.97 2.97 0 00-1.956-.19c-.66.16-1.822.776-3.488 1.848zm20.582.56l-12.79-24.557 4.087-2.129 10.617 20.386 10.201-5.313 2.173 4.172zm17.29-9.33l-10.795-25.746 4.25-1.782 10.795 25.746zm18.42-16.67l4.784.377c.226 3.192-.232 5.712-1.376 7.558s-2.853 3.11-5.127 3.79c-2.859.855-5.505.448-7.94-1.222-2.803-1.93-4.851-5.055-6.143-9.372-1.365-4.561-1.405-8.439-.121-11.632 1.118-2.773 3.185-4.611 6.202-5.514 2.456-.735 4.763-.51 6.92.673 1.536.839 2.929 2.35 4.178 4.534l-3.996 2.587c-.713-1.364-1.601-2.307-2.666-2.83a4.377 4.377 0 00-3.293-.277c-1.617.484-2.726 1.584-3.325 3.3-.6 1.717-.414 4.2.558 7.447 1.008 3.369 2.224 5.616 3.647 6.74s2.931 1.449 4.525.972c1.167-.35 2.041-1.105 2.621-2.265.58-1.161.764-2.783.552-4.866zm30.13 3.41l-4.942.924-3.13-5.866-8.986 1.68-.687 6.58-4.83.903 3.63-29.079 4.81-.9zm-10.397-9.292l-4.993-9.606-1.147 10.753zm39.057-1.318l8.208.624c2.076.157 3.624.508 4.645 1.051 1.02.544 1.934 1.399 2.74 2.566.806 1.167 1.396 2.646 1.769 4.439.373 1.793.46 3.992.263 6.598-.179 2.348-.6 4.369-1.262 6.064-.663 1.695-1.44 3.018-2.333 3.97a7.852 7.852 0 01-3.13 2.063c-1.193.425-2.698.569-4.514.43l-8.45-.641zm4.135 4.936l-1.367 17.992 3.373.256c1.445.11 2.502.053 3.171-.17a3.8 3.8 0 001.687-1.11c.456-.519.865-1.36 1.227-2.526.361-1.165.616-2.717.763-4.656.153-2.014.135-3.612-.055-4.794-.19-1.182-.553-2.13-1.089-2.84a4.14 4.14 0 00-2.04-1.479c-.618-.208-1.828-.381-3.632-.518zm19.335 23.604l-1.723-27.188 16.542-1.049.291 4.6-12.054.764.382 6.027 11.201-.71.29 4.58-11.2.71.469 7.4 12.462-.79.29 4.58zm50.4-26.02l4.378 1.965c-.86 3.082-2.14 5.3-3.838 6.654s-3.732 1.969-6.103 1.845c-2.98-.156-5.335-1.43-7.065-3.822-1.992-2.761-2.87-6.392-2.634-10.893.25-4.754 1.516-8.42 3.799-10.995 1.986-2.235 4.55-3.27 7.695-3.106 2.56.134 4.658 1.121 6.29 2.961 1.165 1.307 1.968 3.199 2.41 5.676l-4.633 1.092c-.213-1.524-.732-2.711-1.558-3.562-.827-.85-1.83-1.307-3.008-1.368-1.687-.089-3.1.575-4.243 1.99-1.142 1.414-1.801 3.814-1.978 7.2-.184 3.511.205 6.036 1.166 7.574.962 1.537 2.274 2.35 3.935 2.437 1.217.063 2.294-.354 3.23-1.252.937-.898 1.656-2.363 2.157-4.397zm10.29-2.53c.794-3.23 1.926-5.772 3.396-7.627 1.47-1.854 3.1-3.104 4.893-3.748 1.793-.644 3.786-.696 5.98-.156 3.181.782 5.474 2.634 6.88 5.555 1.406 2.922 1.557 6.626.453 11.113-1.116 4.537-3.048 7.82-5.796 9.85-2.416 1.799-5.22 2.305-8.414 1.52-3.217-.792-5.482-2.532-6.795-5.221-1.493-3.074-1.692-6.836-.597-11.286zm4.668.952c-.767 3.12-.75 5.604.05 7.455.8 1.85 2.074 2.99 3.825 3.421 1.763.434 3.414.02 4.953-1.242s2.704-3.496 3.492-6.701c.773-3.144.781-5.606.023-7.388-.758-1.781-2.05-2.897-3.874-3.345-1.824-.45-3.496-.056-5.016 1.178s-2.67 3.442-3.453 6.622zm19.442 10.388l4.363 1.272c-.926 3.483-.092 5.774 2.502 6.875 1.286.546 2.44.639 3.46.28 1.022-.36 1.744-1.037 2.165-2.03.248-.584.33-1.136.247-1.654-.084-.518-.333-1.02-.747-1.506s-1.5-1.468-3.26-2.945c-1.578-1.318-2.652-2.477-3.22-3.477-.569-1-.88-2.128-.932-3.385s.176-2.487.687-3.69c.595-1.403 1.449-2.53 2.562-3.382 1.113-.851 2.352-1.325 3.717-1.422s2.871.205 4.519.904c2.477 1.052 4.126 2.545 4.947 4.479.82 1.934.74 4.169-.24 6.704l-4.355-1.58c.398-1.458.404-2.593.017-3.405-.386-.812-1.152-1.461-2.297-1.947-1.145-.486-2.13-.621-2.952-.405-.823.216-1.385.68-1.688 1.394-.297.701-.267 1.41.09 2.127.358.718 1.426 1.791 3.205 3.222 1.876 1.527 3.145 2.835 3.807 3.922.662 1.088 1.015 2.28 1.06 3.574s-.263 2.712-.917 4.255c-.947 2.232-2.43 3.816-4.448 4.753s-4.488.785-7.41-.455c-5.165-2.192-6.792-6.352-4.882-12.478zm21.51 20.02l11.3-20.255-5.937-3.312 2.301-4.124 15.882 8.86-2.3 4.124-5.921-3.303-11.3 20.255zm29.75 18.53l-4.205-2.756 1.805-6.4-7.645-5.01-5.053 4.27-4.109-2.694 22.758-18.462 4.093 2.683zm-1.064-13.904l3.051-10.386-8.275 6.962zm10.274 20.564l15.933-22.924 7.99 5.554c2.044 1.42 3.36 2.64 3.95 3.66.589 1.02.812 2.235.669 3.643-.144 1.407-.708 2.82-1.694 4.238-1.246 1.793-2.68 2.938-4.3 3.434-1.621.497-3.322.336-5.102-.484.407 1.149.636 2.255.686 3.317.05 1.063-.09 2.81-.419 5.24l-.825 6.06-4.519-3.141.715-6.901c.263-2.492.375-4.088.336-4.788-.04-.7-.198-1.273-.474-1.72-.277-.448-.853-.976-1.728-1.584l-.782-.544-6.652 9.57zm12.979-10.599l2.815 1.956c1.72 1.196 2.867 1.881 3.441 2.056.574.175 1.167.134 1.777-.121.611-.256 1.18-.765 1.71-1.526.507-.73.769-1.417.785-2.063a2.718 2.718 0 00-.553-1.741c-.275-.361-1.262-1.132-2.96-2.313l-2.972-2.065zm5.891 23.619l15.362-23.31 3.848 2.536-15.362 23.31zm25.3 3.49l3.024 3.726c-2.156 2.364-4.298 3.768-6.424 4.213-2.126.444-4.219.076-6.28-1.102-2.59-1.482-4.118-3.68-4.586-6.595-.535-3.362.317-6.999 2.555-10.91 2.363-4.133 5.144-6.835 8.343-8.106 2.78-1.101 5.536-.87 8.27.693 2.225 1.273 3.653 3.099 4.282 5.477.45 1.691.316 3.742-.404 6.153l-4.63-1.112c.497-1.457.568-2.75.213-3.882a4.374 4.374 0 00-2.069-2.577c-1.466-.838-3.027-.883-4.684-.134-1.656.749-3.326 2.595-5.01 5.537-1.745 3.053-2.535 5.482-2.369 7.288s.971 3.122 2.415 3.948c1.058.605 2.207.718 3.448.338 1.241-.38 2.543-1.365 3.906-2.955zm21.63 20.25l-4.709-1.762.35-6.64-8.561-3.203-3.988 5.279-4.602-1.722 18.13-23.024 4.584 1.715zm-4.102-13.327l.687-10.804-6.537 8.615zM307.368 23.483l-3.876 1.752-3.752-4.192-7.048 3.185.757 5.547-3.789 1.712-2.856-24.632 3.773-1.706zm-10.412-5.55l-6.033-6.892 1.217 9.07zm12.357 4.955L301.914.455l5.555-1.833 8.383 14.203-1.742-16.393 5.57-1.837 7.4 22.433-3.444 1.136L317.812.505l2.167 18.866-3.58 1.18-9.452-16.462 5.825 17.658zm21.567-6.83l-5.652-22.936 13.955-3.439.956 3.88-10.17 2.506 1.253 5.085 9.45-2.329.952 3.865-9.45 2.328 1.539 6.243 10.513-2.591.952 3.864zm17.554-4.207l-4.196-23.247 8.103-1.462c2.072-.374 3.59-.432 4.553-.175.963.257 1.823.85 2.58 1.777.757.928 1.265 2.11 1.525 3.548.328 1.819.156 3.361-.516 4.629-.671 1.267-1.785 2.189-3.34 2.764.931.443 1.73.968 2.396 1.573.666.606 1.628 1.734 2.887 3.385l3.133 4.117-4.582.827-3.704-4.555c-1.335-1.647-2.223-2.669-2.665-3.064-.443-.395-.88-.643-1.314-.745-.433-.102-1.094-.073-1.981.088l-.793.143 1.751 9.704zm1.416-14.108l2.854-.515c1.744-.315 2.84-.592 3.288-.831.448-.24.778-.618.99-1.137.213-.518.249-1.163.11-1.935-.134-.74-.39-1.308-.766-1.704a2.3 2.3 0 00-1.373-.71c-.38-.051-1.432.079-3.155.39l-3.013.543zm17.71 10.869l-3.202-23.403 3.864-.53 3.202 23.405zm19.11-10.906l3.909 1.099c-.336 2.686-1.13 4.702-2.383 6.047s-2.878 2.114-4.878 2.305c-2.512.241-4.642-.531-6.389-2.317-2.01-2.063-3.198-4.992-3.562-8.788-.385-4.01.218-7.235 1.808-9.675 1.383-2.118 3.4-3.305 6.052-3.559 2.16-.207 4.038.358 5.634 1.694 1.138.948 2.046 2.431 2.725 4.449l-3.742 1.492c-.368-1.25-.95-2.178-1.748-2.787a3.702 3.702 0 00-2.688-.77c-1.422.136-2.523.868-3.302 2.194-.78 1.327-1.032 3.418-.758 6.273.284 2.962.924 5.026 1.92 6.193s2.196 1.684 3.597 1.55c1.027-.099 1.876-.582 2.548-1.45.672-.87 1.091-2.185 1.256-3.95zm25.38 7.385l-4.25.17-1.905-5.294-7.728.309-1.38 5.425-4.154.166 6.593-23.905 4.137-.165zm-7.57-9.05l-3.006-8.653-2.274 8.863zm29.878.829l3.735 1.594c-.68 2.621-1.727 4.518-3.142 5.69-1.416 1.172-3.127 1.724-5.135 1.656-2.523-.085-4.535-1.125-6.037-3.121-1.728-2.305-2.528-5.363-2.4-9.174.136-4.026 1.15-7.147 3.041-9.362 1.645-1.922 3.799-2.838 6.461-2.748 2.169.073 3.958.875 5.368 2.406 1.006 1.087 1.716 2.675 2.13 4.763l-3.904.997c-.204-1.286-.662-2.282-1.374-2.989a3.702 3.702 0 00-2.567-1.11c-1.427-.048-2.613.535-3.557 1.75-.944 1.215-1.464 3.256-1.56 6.122-.101 2.974.268 5.104 1.106 6.39.838 1.286 1.96 1.952 3.366 2 1.03.035 1.936-.335 2.714-1.11.779-.774 1.364-2.025 1.755-3.753zm6.837 9.04l2.042-23.533 14.32 1.242-.346 3.981-10.434-.905-.453 5.217 9.696.841-.344 3.965-9.696-.84-.556 6.404 10.788.936-.344 3.965zm18.007 1.647l3.343-23.384 3.764.538 5.616 16.738 2.232-15.617 3.605.515-3.342 23.385-3.893-.556-5.54-16.353-2.18 15.248zm23.541 3.759l3.863-19.242-5.64-1.132.787-3.918 15.087 3.029-.787 3.918-5.624-1.13-3.863 19.243zm11.97 2.468l6.036-22.838 7.96 2.104c2.036.538 3.436 1.128 4.2 1.769.764.64 1.292 1.541 1.586 2.702.293 1.16.253 2.447-.12 3.86-.473 1.786-1.281 3.111-2.426 3.975-1.145.864-2.544 1.228-4.197 1.091.657.796 1.158 1.609 1.505 2.44.348.83.742 2.26 1.184 4.287l1.097 5.057-4.502-1.19-1.429-5.694c-.513-2.058-.893-3.36-1.128-3.904-.226-.545-.522-.956-.87-1.231-.348-.276-.966-.53-1.834-.76l-.78-.206-2.519 9.534zm7.253-12.182l2.804.74c1.714.454 2.824.666 3.331.64.508-.028.967-.231 1.379-.611.411-.38.717-.95.917-1.708.193-.727.202-1.35.027-1.868a2.3 2.3 0 00-.943-1.224c-.323-.207-1.33-.535-3.023-.982l-2.96-.783zm28.111 22.96l-4.023-1.382.143-5.625-7.315-2.512-3.252 4.557-3.932-1.35 14.806-19.892 3.916 1.345zm-3.776-11.18l.333-9.153-5.332 7.437zm5.769 12.051l9.405-21.458 3.572 1.565-7.808 17.813 8.914 3.907-1.598 3.645z'/%3e%3c/g%3e%3c/svg%3e";

var img$1l = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 291.042 198.438'%3e%3cdefs%3e%3cclipPath id='a' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M0 2834.646h4251.968V0H0z'/%3e%3c/clipPath%3e%3cclipPath id='b' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2066.45 1293.03h70.05v-186.09h-70.05z'/%3e%3c/clipPath%3e%3cclipPath id='c' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2211.74 1676.68h255.01v-253.19h-255.01z'/%3e%3c/clipPath%3e%3cclipPath id='d' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2205.52 1454.59h408.18v-390.65h-408.18z'/%3e%3c/clipPath%3e%3cclipPath id='e' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2521.52 1510.89h73.13v-91.69h-73.13z'/%3e%3c/clipPath%3e%3cclipPath id='f' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2490.57 1549.14h93.58v-82.16h-93.58z'/%3e%3c/clipPath%3e%3cclipPath id='g' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2230.33 1609.63h288.03v-217.74h-288.03z'/%3e%3c/clipPath%3e%3cclipPath id='h' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2288.18 1547.51h230.75v-167.05h-230.75z'/%3e%3c/clipPath%3e%3cclipPath id='i' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2284.54 1494.68h238.37V1330.6h-238.37z'/%3e%3c/clipPath%3e%3cclipPath id='j' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2282.77 1432.13h249.19v-133.84h-249.19z'/%3e%3c/clipPath%3e%3cclipPath id='k' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2325.63 1365.89h208.44v-104.44h-208.44z'/%3e%3c/clipPath%3e%3cclipPath id='l' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2305.72 1271.04h208.09v-49.59h-208.09z'/%3e%3c/clipPath%3e%3cclipPath id='m' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2238.25 1276.4h265.8v-111.53h-265.8z'/%3e%3c/clipPath%3e%3cclipPath id='n' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2201.75 1274.57h263.53v-153.56h-263.53z'/%3e%3c/clipPath%3e%3cclipPath id='o' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2095.46 1292.36h305.73v-193.18h-305.73z'/%3e%3c/clipPath%3e%3cclipPath id='p' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2174.94 1386.32h124.17v-119.81h-124.17z'/%3e%3c/clipPath%3e%3cclipPath id='q' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2137.84 1020.08h23.55v-28.677h-23.55z'/%3e%3c/clipPath%3e%3cclipPath id='r' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2199.61 1064.1h34.86v-35h-34.86z'/%3e%3c/clipPath%3e%3cclipPath id='s' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2115.47 1293.03h70.06v-186.09h-70.06z'/%3e%3c/clipPath%3e%3cclipPath id='t' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1785.22 1676.68h255.01v-253.19h-255.01z'/%3e%3c/clipPath%3e%3cclipPath id='u' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1638.27 1454.59h408.18v-390.65h-408.18z'/%3e%3c/clipPath%3e%3cclipPath id='v' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1657.32 1510.89h73.13v-91.69h-73.13z'/%3e%3c/clipPath%3e%3cclipPath id='w' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1667.82 1549.14h93.58v-82.16h-93.58z'/%3e%3c/clipPath%3e%3cclipPath id='x' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1733.61 1609.63h288.03v-217.74h-288.03z'/%3e%3c/clipPath%3e%3cclipPath id='y' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1733.04 1547.51h230.75v-167.05h-230.75z'/%3e%3c/clipPath%3e%3cclipPath id='z' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1729.06 1494.68h238.37V1330.6h-238.37z'/%3e%3c/clipPath%3e%3cclipPath id='A' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1720.01 1432.13h249.19v-133.84h-249.19z'/%3e%3c/clipPath%3e%3cclipPath id='B' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1717.9 1365.89h208.44v-104.44H1717.9z'/%3e%3c/clipPath%3e%3cclipPath id='C' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1738.16 1271.04h208.09v-49.59h-208.09z'/%3e%3c/clipPath%3e%3cclipPath id='D' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1747.92 1276.4h265.8v-111.53h-265.8z'/%3e%3c/clipPath%3e%3cclipPath id='E' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1786.69 1274.57h263.53v-153.56h-263.53z'/%3e%3c/clipPath%3e%3cclipPath id='F' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1850.78 1292.36h305.73v-193.18h-305.73z'/%3e%3c/clipPath%3e%3cclipPath id='G' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1952.86 1386.32h124.17v-119.81h-124.17z'/%3e%3c/clipPath%3e%3cclipPath id='H' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2090.58 1020.08h23.55v-28.677h-23.55z'/%3e%3c/clipPath%3e%3cclipPath id='I' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2017.5 1064.1h34.86v-35h-34.86z'/%3e%3c/clipPath%3e%3cclipPath id='J' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2152.04 1057.5h36.11v-63.615h-36.11z'/%3e%3c/clipPath%3e%3cclipPath id='K' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2181.67 1062.56h15.19v-66.239h-15.19z'/%3e%3c/clipPath%3e%3cclipPath id='L' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2063.75 1057.49h36.11v-63.618h-36.11z'/%3e%3c/clipPath%3e%3cclipPath id='M' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2055.04 1062.55h15.19v-66.242h-15.19z'/%3e%3c/clipPath%3e%3cclipPath id='N' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2303.35 1598.25h74.92v-73.48h-74.92z'/%3e%3c/clipPath%3e%3cclipPath id='O' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1873.7 1598.25h74.92v-73.48h-74.92z'/%3e%3c/clipPath%3e%3cclipPath id='P' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1816.62 1557.48h91.87v-67.61h-91.87z'/%3e%3c/clipPath%3e%3cclipPath id='Q' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2343.48 1557.48h91.86v-66.78h-91.86z'/%3e%3c/clipPath%3e%3cclipPath id='R' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2160.52 1020.85h58.98v-36.402h-58.98z'/%3e%3c/clipPath%3e%3cclipPath id='S' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2032.47 1020.85h58.98v-36.402h-58.98z'/%3e%3c/clipPath%3e%3cclipPath id='T' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1932.9 1644.69h46.83v-21.91h-46.83z'/%3e%3c/clipPath%3e%3cclipPath id='U' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1912.44 1606.12h43.57v-34.67h-43.57z'/%3e%3c/clipPath%3e%3cclipPath id='V' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1973.3 1568.01h416.04v-434.46H1973.3z'/%3e%3c/clipPath%3e%3cclipPath id='W' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2031.12 1552.73h344.05v-368.24h-344.05z'/%3e%3c/clipPath%3e%3cclipPath id='X' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1978.01 1600.9h19.79v-20.81h-19.79z'/%3e%3c/clipPath%3e%3cclipPath id='Y' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1964.25 1584.49h16.4v-19.48h-16.4z'/%3e%3c/clipPath%3e%3cclipPath id='Z' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1862.63 1568.01h416.04v-434.46h-416.04z'/%3e%3c/clipPath%3e%3cclipPath id='aa' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1876.8 1552.73h344.05v-368.24H1876.8z'/%3e%3c/clipPath%3e%3cclipPath id='ab' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2254.17 1600.9h19.79v-20.81h-19.79z'/%3e%3c/clipPath%3e%3cclipPath id='ac' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2271.32 1584.49h16.4v-19.48h-16.4z'/%3e%3c/clipPath%3e%3cclipPath id='ad' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2028.34 1202.53h204.21v-55.25h-204.21z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath d='M0 198.437h291.042v-66.139H0z' fill='%2300702d'/%3e%3cpath d='M0 132.298h291.042V66.14H0z' fill='%23f0e53c'/%3e%3cpath d='M0 66.14h291.042V0H0z' fill='%23d32011'/%3e%3cg clip-path='url(%23a)' transform='matrix(.07 0 0 -.07 -3.307 198.466)'%3e%3cpath d='M2493.016 985.422c1.904 2.46 1.844 6-.346 8.127l-715.049 697.004c-2.204 2.13-5.607 1.965-7.587-.375-2.01-2.354-1.844-5.982.344-8.127l715.051-696.988a5.375 5.375 0 012.594-1.41s3.09-.66 4.993 1.77' fill='%23473125'/%3e%3cpath d='M2493.016 985.422c1.904 2.46 1.844 6-.346 8.127l-715.049 697.004c-2.204 2.13-5.607 1.965-7.587-.375-2.01-2.354-1.844-5.982.344-8.127l715.051-696.988a5.375 5.375 0 012.594-1.41s3.09-.66 4.993 1.77z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2555.333 1077.518c1.8.18 3.493 1.29 4.364 3.15 1.35 2.847.269 6.296-2.37 7.736l-876.554 473.003c-2.653 1.425-5.877.286-7.212-2.549-1.334-2.834-.27-6.282 2.37-7.72l876.552-473.02a5.397 5.397 0 012.85-.6' fill='%23473125'/%3e%3cpath d='M2555.333 1077.518c1.8.18 3.493 1.29 4.364 3.15 1.35 2.847.269 6.296-2.37 7.736l-876.554 473.003c-2.653 1.425-5.877.286-7.212-2.549-1.334-2.834-.27-6.282 2.37-7.72l876.552-473.02a5.397 5.397 0 012.85-.6z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2535.014 1022.999c1.8-.091 3.614.78 4.694 2.52 1.68 2.637 1.02 6.208-1.424 7.976l-813.158 588.58c-2.46 1.785-5.804 1.08-7.453-1.544-1.664-2.624-1.019-6.193 1.425-7.977l813.16-588.595c.853-.601 1.797-.931 2.756-.96' fill='%23473125'/%3e%3cpath d='M2535.014 1022.999c1.8-.091 3.614.78 4.694 2.52 1.68 2.637 1.02 6.208-1.424 7.976l-813.158 588.58c-2.46 1.785-5.804 1.08-7.453-1.544-1.664-2.624-1.019-6.193 1.425-7.977l813.16-588.595c.853-.601 1.797-.931 2.756-.96z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2067.028 1284.38c2.999-34.816 5.127-114.107 5.623-128.473.494-14.363 27.604-49.84 29.958-27.288 2.369 22.58-15.563 150.003-15.563 150.003z' fill='%23f0e53c'/%3e%3cpath d='M2079.667 1287.468c7.542-49.69 12.64-178.492 25.7-182.092 13.076-3.568 21.068-2.608 24.891 8.518 3.838 11.125-12.55 66.126-12.55 66.126l-19.763 68.613-5.938 39.436z' fill='%2300702d'/%3e%3cg clip-path='url(%23b)' opacity='.25'%3e%3cpath d='M2136.497 1106.937c-14.53.21-18.818 0-27.965 49.032-9.131 49.031-14.155 90.206-20.977 86.427-6.823-3.81-11.757-1.71-13.75 6.807-1.98 8.516-9.162 31.19-6.928 38.775 2.219 7.587 28.579 4.38 28.579 4.38l23.393-101.782z'/%3e%3c/g%3e%3cpath d='M1758.954 985.422c-1.904 2.46-1.844 6 .346 8.127l715.049 697.004c2.203 2.13 5.606 1.965 7.586-.375 2.01-2.354 1.845-5.982-.343-8.127l-715.053-696.988a5.367 5.367 0 00-2.592-1.41s-3.09-.66-4.993 1.77' fill='%23473125'/%3e%3cpath d='M1758.954 985.422c-1.904 2.46-1.844 6 .346 8.127l715.049 697.004c2.203 2.13 5.606 1.965 7.586-.375 2.01-2.354 1.845-5.982-.343-8.127l-715.053-696.988a5.367 5.367 0 00-2.592-1.41s-3.09-.66-4.993 1.77z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2493.826 1576.912c-3.313 38.97-22.491 67.534-21.337 113.867l-94.87-92.53c11.097-15.88 30.32-48.162 34.938-87.567 45.448 36.526 81.269 66.23 81.269 66.23' fill='%23d32011'/%3e%3cpath d='M2303.353 1525.796l-106.836-104.226c12.282-10.377 20.514-28.812 29.24-44.255 3.48-6.088 46.392 24.058 96.908 62.668-.014 15.79 1.034 35.147-19.312 85.813' fill='%2300702d'/%3e%3cpath d='M2377.62 1598.249l-74.267-72.452c20.346-50.666 19.298-70.025 19.313-85.813 29.494 22.536 61.553 47.937 89.892 70.698-4.62 39.405-23.842 71.688-34.938 87.567' fill='%23f0e53c'/%3e%3cg clip-path='url(%23c)' opacity='.25'%3e%3cpath d='M2466.747 1676.684c-27.246-67.354-128.742-171.325-255.01-253.194 58.794 24.53 198.87 135.684 223.852 167.232 31.832 40.185 31.158 85.962 31.158 85.962'/%3e%3c/g%3e%3cpath d='M1696.637 1077.518c-1.8.18-3.493 1.29-4.364 3.15-1.349 2.847-.27 6.296 2.37 7.736l876.554 473.003c2.653 1.425 5.893.286 7.212-2.549 1.334-2.834.27-6.282-2.369-7.72l-876.553-473.02a5.397 5.397 0 00-2.85-.6' fill='%23473125'/%3e%3cpath d='M1696.637 1077.518c-1.8.18-3.493 1.29-4.364 3.15-1.349 2.847-.27 6.296 2.37 7.736l876.554 473.003c2.653 1.425 5.893.286 7.212-2.549 1.334-2.834.27-6.282-2.369-7.72l-876.553-473.02a5.397 5.397 0 00-2.85-.6z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2501.098 1234.299l54.534 2.729-4.018 91.945-54.536-2.73z' fill='%23f0e53c'/%3e%3cpath d='M2163.89 1181.188c45.148-48.37 131.456-130.149 245.877-115.846 61.328 7.677 96.653 30.47 125.397 59.558 28.761 29.06 16.151 32.237 34.922 45.464 18.79 13.224 23.557 49.99 23.796 50.77.226.78-1.529 13.734 7.378 28.758 8.892 15.025 10.301 37.756 7.347 45.074-2.954 7.316 5.323 29.99 5.084 36.136-.24 6.117-6.868 25.7-7.978 34.847-1.095 9.176-3.194 30.078-3.194 30.078-1.994 32.411-18.127 155.5-15.339 175.697l-78.96-41.819c3.284-58.014 8.712-177.84 15.82-195.384 7.121-17.543 20.976-37.756 12.294-51.82-21.516-34.818 9.852-39.405-20.976-47.082-21.023-5.248-351.469-54.43-351.469-54.43' fill='%23d32011'/%3e%3cg clip-path='url(%23d)' opacity='.25'%3e%3cpath d='M2613.691 1331.102c-.24 6.117-6.868 25.7-7.978 34.847-1.095 9.176-3.194 30.078-3.194 30.078-.689 11.268-3.088 33.505-5.817 58.561-9.072-15.819-18.338-36.45-17.979-44.564.541-12.377-25.985-34.448-52.525-48.034-3.597-1.86-5.652-2.968-6.507-3.569.031-.21.045-.358.075-.569 4.814.54 41.684 13.404 61.641 7.048 26.225-8.338 32.584-18.054 16.09-29.06-12.836-8.546-40.035-19.702-62.572-25.46-6.402-1.649-12.446-2.879-17.663-3.449-23.556-2.579-44.653-28.19-2.774-18.412 8.082 1.888 16.344 4.557 24.411 7.526 33.752 12.356 64.205 29.87 64.491 16.884.315-14.635-14.29-46.422-73.892-64.775-6.029-1.86-12.506-3.57-19.479-5.128-27.228-6.028-39.046-11.397-41.818-15.474-4.964-7.348 19.267-10.587 37.036-6.239 27.663 6.748 93.113 18.473 79.74-3.688-13.375-22.162-69.724-28.82-100.613-27.29-30.903 1.53-9.836-21.202 15.265-21.503 25.115-.268 37.71 5.818 37.231-9.625-.735-23.81-111.229-153.482-273.798-40.575-24.62 17.094-45.642 20.574-57.547 25.101 48.116-36.347 118.755-89.097 204.252-78.39 61.328 7.676 96.653 30.468 125.398 59.557 28.76 29.06 12.22 29.27 31.007 42.464 18.775 13.225 27.471 52.99 27.71 53.77.226.78-1.529 13.734 7.378 28.758 8.892 15.025 10.301 37.756 7.347 45.074-2.954 7.316 5.323 29.99 5.084 36.136'/%3e%3c/g%3e%3cg clip-path='url(%23e)' opacity='.25'%3e%3cpath d='M2524.73 1436.834c-13.12-33.362 16.552-13.599 42.27 11.546 10.854 10.617 19.941 18.923 27.647 25.116-1.35 12.594-2.697 25.355-3.883 37.396-25.416-20.888-56.588-50.02-66.035-74.058'/%3e%3c/g%3e%3cg clip-path='url(%23f)' opacity='.25'%3e%3cpath d='M2582.681 1545.138c-14.304-22.4-34.17-46.332-74.295-68.075-40.126-21.755.074-1.543.074-1.543l8.052 31.233c21.651 10.841 77.341 55.9 66.17 38.385'/%3e%3c/g%3e%3cpath d='M1716.954 1022.999c-1.798-.091-3.613.78-4.692 2.52-1.68 2.637-1.02 6.208 1.424 7.976l813.158 588.58c2.459 1.785 5.801 1.08 7.452-1.544 1.665-2.624 1.019-6.193-1.425-7.977l-813.158-588.595c-.854-.601-1.8-.931-2.759-.96' fill='%23473125'/%3e%3cpath d='M1716.954 1022.999c-1.798-.091-3.613.78-4.692 2.52-1.68 2.637-1.02 6.208 1.424 7.976l813.158 588.58c2.459 1.785 5.801 1.08 7.452-1.544 1.665-2.624 1.019-6.193-1.425-7.977l-813.158-588.595c-.854-.601-1.8-.931-2.759-.96z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2081.062 1312.329c-.135.21-.284.42-.42.6.12-.21.269-.39.42-.6' fill='%23d32011'/%3e%3cpath d='M2267.322 1218.82c35.161-.54 53.919 13.437 64.504 17.034 10.602 3.63 21.863 24.89 25.611 37.365 3.764 12.447 7.888 16.496 9.087 21.923 1.199 5.457.27 10.016 0 16.135-.255 6.117 4.078 21.682 4.333 32.446.24 10.738-14.184 29.21-11.41 47.743 2.773 18.57-1.17 42.92-9.117 60.943-5.113 11.562-6.523 26.467-6.853 39.512l-131.98-95.506c42.419-34.788-8.127-157.772-96.487-88.53-4.395 1.622-14.126 11.548-27.71 10.888-7.768-.39-7.947-2.908-6.688-4.978 38.565-6.567 65.45-43.483 98.093-68.704 32.657-25.221 53.47-25.73 88.617-26.27' fill='%2300702d'/%3e%3cpath d='M2536.26 1397.226c.3 9.23-1.485 33.686-3.989 42.008-2.518 8.306-8.276 8.785-7.24 34.157 1.048 25.385 1.228 37.665.208 44.518-1.02 6.853 7.377 54.04-1.8 103.476l-88.3-63.905c3.179-18.204 4.858-51.672 6.356-59.109 1.83-9.116 8.518-31.038 6.328-46.498-2.188-15.458 7.438-38.759 10.527-43.963 3.09-5.217-1.334-51.467-4.798-70.84-3.448-19.343 8.052-36.437.479-59.827-13.945-58.239-68.54-121.604-140.766-125.984-72.228-4.377-159.614 75.661-176.903 93.956-16.63 17.633-37.426 40.724-53.77 64.895-2.804 0-12.656-.57-11.051-9.056 1.875-9.867-10.257 4.858-2.354-11.606 7.886-16.493 47.337-65.946 79.575-98.094 32.223-32.147 107.06-104.899 205.003-97.132 78.599 6.236 126.087 51.58 137.843 94.374 3.568 12.985 26.014 28.158 27.423 45.104 1.41 16.943-5.907 20.421 2.684 36.975 8.593 16.523 9.807 28.07 10.047 32.717.735 15.175 7.197 31.818 7.092 67.115-.045 16.553-2.908 17.484-2.594 26.72' fill='%23d32011'/%3e%3cpath d='M2080.612 1312.989l.03-.06-.03.06m.45-.66c.494-.75 1.02-1.47 1.529-2.22.45 0 .75-.028.75-.028s-1.32.989-2.28 2.248' fill='%23f0e53c'/%3e%3cpath d='M2313.264 1151.26c72.228 4.38 126.821 67.744 140.766 125.982 7.573 23.391-3.927 40.485-.479 59.828 3.464 19.373 7.888 65.623 4.798 70.84-3.089 5.203-12.715 28.505-10.526 43.963 2.19 15.46-4.497 37.382-6.329 46.497-1.498 7.438-3.177 40.906-6.356 59.11l-91.66-66.366c.33-13.045 1.738-27.949 6.851-39.51 7.948-18.024 11.891-42.374 9.118-60.945-2.775-18.532 11.65-37.005 11.41-47.742-.255-10.765-4.588-26.33-4.333-32.447.27-6.118 1.2-10.677 0-16.134-1.199-5.428-5.323-9.476-9.087-21.923-3.748-12.475-15.009-33.736-25.61-37.366-10.586-3.598-29.344-17.572-64.505-17.032-35.148.54-55.96 1.05-88.618 26.27-32.642 25.22-59.527 62.136-98.093 68.703l.031-.059c.135-.18.284-.39.42-.6.96-1.259 2.28-2.249 2.28-2.249s-.302.03-.75.03c16.343-24.17 37.14-47.262 53.77-64.895 17.288-18.295 104.674-98.333 176.902-93.956' fill='%23f0e53c'/%3e%3cg clip-path='url(%23g)' opacity='.25'%3e%3cpath d='M2230.33 1391.89c117.092 60.33 282.044 190.585 288.027 217.74.299-23.002-102.215-154.727-288.026-217.74'/%3e%3c/g%3e%3cg clip-path='url(%23h)' opacity='.25'%3e%3cpath d='M2518.927 1547.507c-17.154-35.252-96.25-140.362-230.748-167.045 52.21 3.12 226.265 56.343 230.748 167.045'/%3e%3c/g%3e%3cg clip-path='url(%23i)' opacity='.25'%3e%3cpath d='M2521.236 1494.683c13.87-36.136-57.924-183.972-236.7-161.841 74.521 1.019 198.403 54.039 236.7 161.84'/%3e%3c/g%3e%3cg clip-path='url(%23j)' opacity='.25'%3e%3cpath d='M2528.283 1432.127c-2.969-30.844-86.231-143.218-245.518-124.326 31.668-19.133 177.039-15.084 238.021 65.945 9.401 14.725 15.443 40.359 7.497 58.38'/%3e%3c/g%3e%3cg clip-path='url(%23k)' opacity='.25'%3e%3cpath d='M2534.07 1365.888c-10.945-29.179-50.515-107.869-208.436-87.387 43.11-18.563 146.315-34.126 195.496 22.072 8.862 10.407 12.94 65.315 12.94 65.315'/%3e%3c/g%3e%3cg clip-path='url(%23l)' opacity='.25'%3e%3cpath d='M2305.722 1265.217c117.436-36.316 159.824-21.92 208.091 5.817-.795-14.604-56.678-100.283-208.09-5.817'/%3e%3c/g%3e%3cg clip-path='url(%23m)' opacity='.25'%3e%3cpath d='M2504.052 1215.286c-16.703-11.576-119.16-45.853-265.806 61.117 27.322-34.697 120.72-104.421 223.132-101.601 15.774.03 18.247-.87 16.208-9.927 8.878 9.656 7.889 16.493 11.803 25.13 3.927 8.636 14.662 25.28 14.662 25.28'/%3e%3c/g%3e%3cg clip-path='url(%23n)' opacity='.25'%3e%3cpath d='M2465.277 1151.2c-17.454-6.088-165.343-22.852-263.525 123.374 11.56-34.697 60.142-128.952 162.733-146.824 33.272-4.14 77.655-21.443 100.792 23.45'/%3e%3c/g%3e%3cg clip-path='url(%23o)' opacity='.25'%3e%3cpath d='M2095.456 1292.357c51.596-111.049 214.014-209.44 305.734-184.25-28.234-11.516-115.336-21.203-186.453 33.616-71.105 54.85-119.28 150.634-119.28 150.634'/%3e%3c/g%3e%3cg clip-path='url(%23p)' opacity='.33'%3e%3cpath d='M2176.666 1287.56c-9.491-2.97 23.376-22.884 20.213-16.135-3.165 6.746-4.934 14.334-.676 15.323 4.275.991 17.918-15.984 10.737.54-7.168 16.525 22.715-11.156 22.715-11.156s-6.777 7.347-2.428 12.176c4.334 4.8 40.125-21.8 40.125-21.8s-15.01 15.382-23.107 26.93c-8.097 11.543 35.733-4.05 35.733-4.05s-7.184.42-24.306 14.904c-17.124 14.485 24.739 8.158 24.739 8.158s-3.193 7.496-16.448 15.143c-13.24 7.647 35.147 16.494 35.147 16.494s-26.165 7.887-32.222 15.264c-6.06 7.348 36.076 11.006 23.21 10.347-32.538-1.62-71.57 18.802-70.354 16.433 13.195-25.4 8.442-82.439-43.078-98.572'/%3e%3c/g%3e%3cpath d='M2545.271 1624.894c7.092 3.6 11.396-.735 15.055-4.813 8.172 23.78 36.931 45.657 44.307 51.835-8.127-4.978-37.904-25.265-61.565-24.396 2.158-5.158 4.288-11.05-1.485-16.733z' fill='%23cacaca'/%3e%3cpath d='M2545.271 1624.894c7.092 3.6 11.396-.735 15.055-4.813 8.172 23.78 36.931 45.657 44.307 51.835-8.127-4.978-37.904-25.265-61.565-24.396 2.158-5.158 4.288-11.05-1.485-16.733z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2537.16 1633.515c3.014 2.174 7.437.795 9.866-3.074 2.445-3.867 1.964-8.787-1.05-10.946-3.014-2.174-7.437-.793-9.867 3.074-2.442 3.883-1.978 8.787 1.05 10.946' fill='%23cacaca'/%3e%3cpath d='M2537.16 1633.515c3.014 2.174 7.437.795 9.866-3.074 2.445-3.867 1.964-8.787-1.05-10.946-3.014-2.174-7.437-.793-9.867 3.074-2.442 3.883-1.978 8.787 1.05 10.946zm6.538 13.645l16.537-26.314' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2536.364 1622.764c-6.896 10.977-7.661 24.441-3.134 35.777-9.911-10.676-11.755-27.679-3.596-40.635 8.14-12.954 23.554-17.544 36.525-11.74-11.516-.21-22.896 5.608-29.795 16.598' fill='%23cacaca'/%3e%3cpath d='M2536.364 1622.764c-6.896 10.977-7.661 24.441-3.134 35.777-9.911-10.676-11.755-27.679-3.596-40.635 8.14-12.954 23.554-17.544 36.525-11.74-11.516-.21-22.896 5.608-29.795 16.598z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2531.027 1510.591l3.51.54c-2.566 18.923-1.996 86.263-1.336 96.46l-3.539.253c-.674-10.54-1.289-77.655 1.365-97.253' fill='%23f0e53c'/%3e%3cpath d='M2531.027 1510.591l3.51.54c-2.566 18.923-1.996 86.263-1.336 96.46l-3.539.253c-.674-10.54-1.289-77.655 1.365-97.253z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2527.038 1500.545c-.66 95.274 1.005 101.347 2.505 106.701.194.749.419 1.529.629 2.518l-3.464.824a29.466 29.466 0 00-.57-2.263c-1.618-5.893-3.313-11.965-2.64-107.809z' fill='%23f0e53c'/%3e%3cpath d='M2527.038 1500.545c-.66 95.274 1.005 101.347 2.505 106.701.194.749.419 1.529.629 2.518l-3.464.824a29.466 29.466 0 00-.57-2.263c-1.618-5.893-3.313-11.965-2.64-107.809z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2524.564 1625.763c1.14-4.692 3.554-10.572 8.742-14.694 5.188-4.138.404-8.036-2.984-5.293-3.373 2.758-9.042 9.011-9.146 13.735-.106 4.738 1.394 6.447 3.388 6.252' fill='%23f0e53c'/%3e%3cpath d='M2524.564 1625.763c1.14-4.692 3.554-10.572 8.742-14.694 5.188-4.138.404-8.036-2.984-5.293-3.373 2.758-9.042 9.011-9.146 13.735-.106 4.738 1.394 6.447 3.388 6.252z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2536.32 1510.861c2.25-5.638 11.666-38.82 15.325-41.475-4.799-1.662-8.097-2.067-11.096-4.347-3-2.294-3.855-3.043-7.183-2.968 0 0-6.807 39.24-3.839 47.202z' fill='%23f0e53c'/%3e%3cpath d='M2536.32 1510.861c2.25-5.638 11.666-38.82 15.325-41.475-4.799-1.662-8.097-2.067-11.096-4.347-3-2.294-3.855-3.043-7.183-2.968 0 0-6.807 39.24-3.839 47.202z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2531.7 1509.782l8.864-32.657m1.243 9.67l4.89-18.952m-7.017-3.463l-8.819 38.325' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M2527.953 1509.917c.225-1.68 2.58-2.699 5.248-2.278 2.669.403 4.648 2.114 4.424 3.792-.226 1.68-2.58 2.7-5.248 2.294-2.67-.419-4.65-2.114-4.424-3.808' fill='%23f0e53c'/%3e%3cpath d='M2527.953 1509.917c.225-1.68 2.58-2.699 5.248-2.278 2.669.403 4.648 2.114 4.424 3.792-.226 1.68-2.58 2.7-5.248 2.294-2.67-.419-4.65-2.114-4.424-3.808z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2529.213 1500.651c1.44-6.957 3.014-7.588 5.952-44.414-5.232-1.693-6.686 1.095-9.146 1.68-2.458.585-10.511-2.759-10.33 3.223.179 5.984 4.812 35.507 7.36 39.212z' fill='%23f0e53c'/%3e%3cpath d='M2529.213 1500.651c1.44-6.957 3.014-7.588 5.952-44.414-5.232-1.693-6.686 1.095-9.146 1.68-2.458.585-10.511-2.759-10.33 3.223.179 5.984 4.812 35.507 7.36 39.212z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2528.057 1487.156l-.284-23.946m3.509 5.862l.599-13.375m-6.057 42.239l-2.594-26.885m-4.53-7.721l-.044-5.759' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M2520.126 1501.041c-.016-1.71 2.159-3.105 4.858-3.134 2.7-.015 4.889 1.334 4.905 3.043.013 1.695-2.161 3.09-4.86 3.12-2.698.03-4.887-1.336-4.903-3.029' fill='%23f0e53c'/%3e%3cpath d='M2520.126 1501.041c-.016-1.71 2.159-3.105 4.858-3.134 2.7-.015 4.889 1.334 4.905 3.043.013 1.695-2.161 3.09-4.86 3.12-2.698.03-4.887-1.336-4.903-3.029z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2492.207 1696.178c6.552 4.647 11.395 1.019 15.55-2.445 4.887 24.77 30.423 50.846 36.9 58.089-7.378-6.164-34.128-30.815-57.653-33.603 2.835-4.768 5.727-10.271.765-16.78z' fill='%23cacaca'/%3e%3cpath d='M2492.207 1696.178c6.552 4.647 11.395 1.019 15.55-2.445 4.887 24.77 30.423 50.846 36.9 58.089-7.378-6.164-34.128-30.815-57.653-33.603 2.835-4.768 5.727-10.271.765-16.78z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2483.03 1703.465c2.699 2.609 7.242 1.933 10.182-1.53 2.922-3.463 3.118-8.381.434-11.005-2.699-2.612-7.257-1.92-10.197 1.528-2.923 3.464-3.118 8.396-.419 11.006' fill='%23cacaca'/%3e%3cpath d='M2483.03 1703.465c2.699 2.609 7.242 1.933 10.182-1.53 2.922-3.463 3.118-8.381.434-11.005-2.699-2.612-7.257-1.92-10.197 1.528-2.923 3.464-3.118 8.396-.419 11.006zm4.634 14.499l19.897-23.497' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2483.69 1692.698c-8.307 9.791-10.87 23.016-7.918 34.921-8.366-12.085-7.9-29.194 1.89-40.77 9.806-11.56 25.671-13.734 37.725-5.997-11.349-1.979-23.39 2.04-31.697 11.846' fill='%23cacaca'/%3e%3cpath d='M2483.69 1692.698c-8.307 9.791-10.87 23.016-7.918 34.921-8.366-12.085-7.9-29.194 1.89-40.77 9.806-11.56 25.671-13.734 37.725-5.997-11.349-1.979-23.39 2.04-31.697 11.846z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2471.74 1578.35c-1.2 95.275.435 101.348 1.904 106.716.195.764.404 1.545.599 2.535l-3.448.794c-.18-.87-.36-1.545-.555-2.264-1.604-5.908-3.254-11.996-2.055-107.824z' fill='%23f0e53c'/%3e%3cpath d='M2471.74 1578.35c-1.2 95.275.435 101.348 1.904 106.716.195.764.404 1.545.599 2.535l-3.448.794c-.18-.87-.36-1.545-.555-2.264-1.604-5.908-3.254-11.996-2.055-107.824z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2471.605 1693.853c1.753-4.468 4.933-9.911 10.63-13.195 5.683-3.298 1.47-7.902-2.248-5.698-3.705 2.22-10.166 7.528-10.902 12.19-.75 4.664.525 6.583 2.52 6.703' fill='%23f0e53c'/%3e%3cpath d='M2471.605 1693.853c1.753-4.468 4.933-9.911 10.63-13.195 5.683-3.298 1.47-7.902-2.248-5.698-3.705 2.22-10.166 7.528-10.902 12.19-.75 4.664.525 6.583 2.52 6.703z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2473.914 1578.486c1.483-6.957 3.059-7.586 6.207-44.383-5.233-1.724-6.702 1.05-9.161 1.62-2.46.57-10.496-2.819-10.347 3.148.135 5.983 4.618 35.553 7.138 39.256z' fill='%23f0e53c'/%3e%3cpath d='M2473.914 1578.486c1.483-6.957 3.059-7.586 6.207-44.383-5.233-1.724-6.702 1.05-9.161 1.62-2.46.57-10.496-2.819-10.347 3.148.135 5.983 4.618 35.553 7.138 39.256z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2472.834 1564.976l-.15-23.945m3.478 5.877l.66-13.359m-6.298 42.193l-2.43-26.915m-4.497-7.737v-5.757' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M2464.812 1578.8c0-1.693 2.174-3.087 4.873-3.087 2.698-.015 4.888 1.348 4.903 3.059 0 1.709-2.189 3.088-4.874 3.088-2.699.015-4.886-1.364-4.902-3.06' fill='%23f0e53c'/%3e%3cpath d='M2464.812 1578.8c0-1.693 2.174-3.087 4.873-3.087 2.698-.015 4.888 1.348 4.903 3.059 0 1.709-2.189 3.088-4.874 3.088-2.699.015-4.886-1.364-4.902-3.06z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2607.783 1571.62c7.467 2.593 11.216-2.28 14.35-6.824 10.93 22.462 42.058 40.245 50.11 45.358-8.65-3.823-40.589-19.882-63.95-15.804 1.529-5.397 2.924-11.544-3.48-16.39z' fill='%23cacaca'/%3e%3cpath d='M2607.783 1571.62c7.467 2.593 11.216-2.28 14.35-6.824 10.93 22.462 42.058 40.245 50.11 45.358-8.65-3.823-40.589-19.882-63.95-15.804 1.529-5.397 2.924-11.544-3.48-16.39z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2600.75 1581.276c3.255 1.738 7.483-.226 9.433-4.41 1.949-4.167.898-8.965-2.34-10.705-3.27-1.739-7.482.224-9.431 4.393-1.965 4.184-.915 8.982 2.339 10.722' fill='%23cacaca'/%3e%3cpath d='M2600.75 1581.276c3.255 1.738 7.483-.226 9.433-4.41 1.949-4.167.898-8.965-2.34-10.705-3.27-1.739-7.482.224-9.431 4.393-1.965 4.184-.915 8.982 2.339 10.722zm8.112 12.624l13.271-28.354' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2598.681 1570.704c-5.532 11.831-4.679 25.295 1.154 35.926-11.094-9.236-14.949-25.864-8.41-39.824 6.537-13.96 21.276-20.602 34.83-16.615-11.44 1.35-22.025 8.683-27.574 20.513' fill='%23cacaca'/%3e%3cpath d='M2598.681 1570.704c-5.532 11.831-4.679 25.295 1.154 35.926-11.094-9.236-14.949-25.864-8.41-39.824 6.537-13.96 21.276-20.602 34.83-16.615-11.44 1.35-22.025 8.683-27.574 20.513z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M2598.277 1451.379l3.448.81c-3.838 19.912-7.827 91.48-7.856 102.351l-3.539.03c.03-11.245 3.958-82.544 7.947-103.191' fill='%23f0e53c'/%3e%3cpath d='M2598.277 1451.379l3.448.81c-3.838 19.912-7.827 91.48-7.856 102.351l-3.539.03c.03-11.245 3.958-82.544 7.947-103.191z' fill='none' stroke='%23473125' stroke-width='1.605'/%3e%3cpath d='M2594.962 1440.449c-7.105 101.12-5.831 107.689-4.723 113.477.166.809.33 1.648.466 2.714l-3.51.645a37.66 37.66 0 00-.404-2.444c-1.23-6.358-2.505-12.926 4.634-114.663z' fill='%23f0e53c'/%3e%3cpath d='M2594.962 1440.449c-7.105 101.12-5.831 107.689-4.723 113.477.166.809.33 1.648.466 2.714l-3.51.645a37.66 37.66 0 00-.404-2.444c-1.23-6.358-2.505-12.926 4.634-114.663z' fill='none' stroke='%23473125' stroke-width='1.605'/%3e%3cpath d='M2587.345 1575.292c.557-4.813 2.266-10.96 6.929-15.759 4.648-4.812-.571-8.037-3.6-4.843-3.013 3.194-7.901 10.166-7.435 14.875.449 4.707 2.158 6.192 4.106 5.727' fill='%23f0e53c'/%3e%3cpath d='M2587.345 1575.292c.557-4.813 2.266-10.96 6.929-15.759 4.648-4.812-.571-8.037-3.6-4.843-3.013 3.194-7.901 10.166-7.435 14.875.449 4.707 2.158 6.192 4.106 5.727z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2603.614 1451.379c2.564-5.458 13.991-37.906 17.814-40.32-4.694-1.979-7.962-2.624-10.826-5.097-2.85-2.49-3.659-3.3-6.988-3.464 0 0-9.19 38.671-6.702 46.842z' fill='%23f0e53c'/%3e%3cpath d='M2603.614 1451.379c2.564-5.458 13.991-37.906 17.814-40.32-4.694-1.979-7.962-2.624-10.826-5.097-2.85-2.49-3.659-3.3-6.988-3.464 0 0-9.19 38.671-6.702 46.842z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2599.055 1449.985l10.826-31.969m.661 9.732l6.042-18.562m-6.791-3.944l-11.141 37.62' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M2595.307 1449.865c.33-1.665 2.744-2.52 5.368-1.919 2.654.6 4.528 2.442 4.184 4.093-.33 1.665-2.73 2.518-5.367 1.92-2.64-.6-4.515-2.429-4.185-4.094' fill='%23f0e53c'/%3e%3cpath d='M2595.307 1449.865c.33-1.665 2.744-2.52 5.368-1.919 2.654.6 4.528 2.442 4.184 4.093-.33 1.665-2.73 2.518-5.367 1.92-2.64-.6-4.515-2.429-4.185-4.094z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2597.123 1440.719c1.873-6.853 3.478-7.378 8.65-43.912-5.127-2.07-6.731.63-9.22 1.02-2.504.419-10.331-3.48-10.511 2.519-.18 5.96 2.639 35.754 4.962 39.622z' fill='%23f0e53c'/%3e%3cpath d='M2597.123 1440.719c1.873-6.853 3.478-7.378 8.65-43.912-5.127-2.07-6.731.63-9.22 1.02-2.504.419-10.331-3.48-10.511 2.519-.18 5.96 2.639 35.754 4.962 39.622z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2596.807 1427.163l1.17-23.916m-4.063 34.518l-.944-27.02m-4.065-8.008l.314-5.75' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M2588.036 1440.449c.089-1.695 2.339-2.924 5.038-2.774 2.699.165 4.798 1.664 4.707 3.373-.09 1.694-2.338 2.94-5.037 2.774-2.7-.15-4.8-1.664-4.708-3.373' fill='%23f0e53c'/%3e%3cpath d='M2588.036 1440.449c.089-1.695 2.339-2.924 5.038-2.774 2.699.165 4.798 1.664 4.707 3.373-.09 1.694-2.338 2.94-5.037 2.774-2.7-.15-4.8-1.664-4.708-3.373z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M2519.766 1357.852c-.03.211-.044.36-.075.57-.645-.48-.585-.63.075-.57'/%3e%3cpath d='M2085.066 1270.466c13.12-49.992 49.945-142.507 50.216-271.398.464-10.345 15.383-15.354 15.188-25.13-.209-9.807-3.238-9.957.751-17.245 2.294 7.019 9.7 9.687 9.402 16.584-.3 6.897-6.374 22.701.36 28.79 6.716 6.086 16.073 13.464 12.953 35.745-3.134 22.313-54.594 215.38-81.104 231.334-26.509 15.924-7.766 1.32-7.766 1.32' fill='%23d32011'/%3e%3cpath d='M2219.37 1017.577c1.305 6.957-6.388 25.094 1.064 26.594 7.467 1.529 19.553 7.888 15.22 20.9-4.335 13.046-32.134 74.073-60.772 110.929-28.64 36.856-58.358 67.835-58.358 67.835 16.478-44.622 68.059-197.175 73.666-221.317 2.655-11.365 29.18-4.941 29.18-4.941' fill='%2300702d'/%3e%3cg clip-path='url(%23q)' opacity='.25'%3e%3cpath d='M2159.722 1018.41c-6.327-9.327-27.395-12.895-17.709-25.34' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cg clip-path='url(%23r)' opacity='.25'%3e%3cpath d='M2203.281 1030.766c-11.081 5.667 27.38 37.814 29.208 30.618 2.055-8.486-6.673-9.476-6.088-12.025' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cpath d='M2102.368 1247.733c12.835-35.025 47.727-144.335 48.881-195.495.51-11.487 21.383-9.297 16.93-18.143-4.454-8.878-17.153-13.525-7.197-32.029 8.426 3.869 23.466 8.098 22.43-6.928-1.035-15.024 6.837-10.585 10.481-8.096 3.66 2.489 12.146 5.188 4.29 12.866-7.874 7.677-1.095 12.594 5.878 12.954 6.972.36 12.925-.51 14.904 3.63 1.964 4.106-1.859 5.667-6.179 6.026-4.317.36-27.514 14.155-22.49 22.462 5.007 8.308 12.415 10.977 8.651 23.451-3.778 12.476-43.079 111.769-65.525 145.745-22.462 34.007-31.054 33.557-31.054 33.557' fill='%23f0e53c'/%3e%3cpath d='M2184.942 1284.38c-2.999-34.816-5.113-114.107-5.623-128.473-.494-14.363-27.604-49.84-29.957-27.288-2.369 22.58 15.562 150.003 15.562 150.003z' fill='%23f0e53c'/%3e%3cpath d='M2172.302 1287.468c-7.542-49.69-12.64-178.492-25.7-182.092-13.06-3.568-21.067-2.608-24.89 8.518-3.824 11.125 12.55 66.126 12.55 66.126l19.763 68.613 5.937 39.436z' fill='%2300702d'/%3e%3cg clip-path='url(%23s)' opacity='.25'%3e%3cpath d='M2115.473 1106.937c14.53.21 18.818 0 27.965 49.032 9.131 49.031 14.155 90.206 20.992 86.427 6.808-3.81 11.741-1.71 13.734 6.807 1.98 8.516 9.163 31.19 6.944 38.775-2.235 7.587-28.595 4.38-28.595 4.38l-23.392-101.782z'/%3e%3c/g%3e%3cpath d='M1758.144 1576.912c3.313 38.97 22.491 67.534 21.336 113.867l94.87-92.53c-11.096-15.88-30.319-48.162-34.938-87.567-45.447 36.526-81.268 66.23-81.268 66.23' fill='%23d32011'/%3e%3cpath d='M1948.632 1525.796l106.819-104.226c-12.28-10.377-20.511-28.812-29.24-44.255-3.476-6.088-46.39 24.058-96.907 62.668.016 15.79-1.035 35.147 19.328 85.813' fill='%2300702d'/%3e%3cpath d='M1874.35 1598.249l74.282-72.452c-20.364-50.666-19.313-70.025-19.329-85.813-29.494 22.536-61.552 47.937-89.89 70.698 4.618 39.405 23.841 71.688 34.936 87.567' fill='%23f0e53c'/%3e%3cg clip-path='url(%23t)' opacity='.25'%3e%3cpath d='M1785.223 1676.684c27.246-67.354 128.742-171.325 255.009-253.194-58.793 24.53-198.869 135.684-223.851 167.232-31.832 40.185-31.158 85.962-31.158 85.962'/%3e%3c/g%3e%3cpath d='M1750.871 1234.299l-54.533 2.729 4.018 91.945 54.535-2.73z' fill='%23f0e53c'/%3e%3cpath d='M2088.078 1181.188c-45.147-48.37-131.455-130.149-245.876-115.846-61.327 7.677-96.653 30.47-125.398 59.558-28.76 29.06-16.149 32.237-34.92 45.464-18.79 13.224-23.558 49.99-23.797 50.77-.226.78 1.53 13.734-7.378 28.758-8.892 15.025-10.3 37.756-7.347 45.074 2.954 7.316-5.323 29.99-5.084 36.136.24 6.117 6.868 25.7 7.978 34.847 1.094 9.176 3.194 30.078 3.194 30.078 1.993 32.411 18.127 155.5 15.34 175.697l78.96-41.819c-3.285-58.014-8.712-177.84-15.82-195.384-7.123-17.543-20.977-37.756-12.296-51.82 21.518-34.818-9.85-39.405 20.977-47.082 21.023-5.248 351.467-54.43 351.467-54.43' fill='%23d32011'/%3e%3cg clip-path='url(%23u)' opacity='.25'%3e%3cpath d='M1638.279 1331.102c.24 6.117 6.868 25.7 7.978 34.847 1.093 9.176 3.194 30.078 3.194 30.078.689 11.268 3.087 33.505 5.817 58.561 9.072-15.819 18.338-36.45 17.992-44.564-.554-12.377 25.972-34.448 52.512-48.034 3.613-1.86 5.652-2.968 6.507-3.569-.031-.21-.044-.358-.075-.569-4.814.54-41.684 13.404-61.627 7.048-26.24-8.338-32.597-18.054-16.104-29.06 12.835-8.546 40.035-19.702 62.572-25.46 6.402-1.649 12.446-2.879 17.663-3.449 23.556-2.579 44.653-28.19 2.775-18.412-8.083 1.888-16.345 4.557-24.412 7.526-33.751 12.356-64.205 29.87-64.491 16.884-.315-14.635 14.29-46.422 73.892-64.775 6.029-1.86 12.506-3.57 19.479-5.128 27.229-6.028 39.059-11.397 41.818-15.474 4.964-7.348-19.268-10.587-37.035-6.239-27.666 6.748-93.116 18.473-79.741-3.688 13.375-22.162 69.725-28.82 100.613-27.29 30.903 1.53 9.836-21.202-15.265-21.503-25.115-.268-37.71 5.818-37.231-9.625.735-23.81 111.229-153.482 273.798-40.575 24.62 17.094 45.642 20.574 57.547 25.101-48.117-36.347-118.756-89.097-204.252-78.39-61.328 7.676-96.653 30.468-125.398 59.557-28.76 29.06-12.22 29.27-31.008 42.464-18.773 13.225-27.47 52.99-27.71 53.77-.225.78 1.53 13.734-7.377 28.758-8.892 15.025-10.301 37.756-7.347 45.074 2.954 7.316-5.323 29.99-5.084 36.136'/%3e%3c/g%3e%3cg clip-path='url(%23v)' opacity='.25'%3e%3cpath d='M1727.241 1436.834c13.12-33.362-16.555-13.599-42.27 11.546-10.855 10.617-19.942 18.923-27.648 25.116 1.348 12.594 2.697 25.355 3.882 37.396 25.416-20.888 56.588-50.02 66.036-74.058'/%3e%3c/g%3e%3cg clip-path='url(%23w)' opacity='.25'%3e%3cpath d='M1669.288 1545.138c14.304-22.4 34.171-46.332 74.296-68.075 40.125-21.755-.075-1.543-.075-1.543l-8.052 31.233c-21.637 10.841-77.34 55.9-66.169 38.385'/%3e%3c/g%3e%3cpath d='M2170.908 1312.329c.136.21.284.42.42.6-.12-.21-.271-.39-.42-.6' fill='%23d32011'/%3e%3cpath d='M1984.648 1218.015c-35.161-.54-53.92 13.435-64.506 17.032-10.6 3.63-21.861 24.891-25.61 37.366-3.762 12.447-7.886 16.496-9.086 21.923-1.2 5.457-.27 10.016 0 16.134.27 6.117-4.078 21.682-4.333 32.447-.241 10.737 14.184 29.21 11.41 47.743-2.773 18.57 1.17 42.92 9.117 60.943 5.113 11.562 6.523 26.466 6.853 39.511l131.98-95.506c-42.42-34.788 8.127-157.77 96.487-88.528 4.394 1.621 14.126 11.546 27.71 10.886 7.767-.389 7.947-2.908 6.688-4.977-38.565-6.568-65.435-43.484-98.093-68.704-32.66-25.22-53.47-25.73-88.617-26.27' fill='%2300702d'/%3e%3cpath d='M1715.71 1397.226c-.3 9.23 1.485 33.686 3.989 42.008 2.518 8.306 8.276 8.785 7.24 34.157-1.047 25.385-1.227 37.665-.208 44.518 1.02 6.853-7.377 54.04 1.8 103.476l88.3-63.905c-3.178-18.204-4.858-51.672-6.343-59.109-1.843-9.116-8.53-31.038-6.34-46.498 2.187-15.458-7.438-38.759-10.527-43.963-3.09-5.217 1.334-51.467 4.797-70.84 3.449-19.343-8.051-36.437-.48-59.827 13.946-58.239 68.54-121.604 140.768-125.984 72.227-4.377 159.614 75.661 176.903 93.956 16.628 17.633 37.425 40.724 53.77 64.895 2.804 0 12.655-.57 11.05-9.056-1.874-9.867 10.257 4.858 2.354-11.606-7.888-16.493-47.337-65.946-79.575-98.094-32.222-32.147-107.044-104.899-205.002-97.132-78.6 6.236-126.088 51.58-137.843 94.374-3.568 12.985-26.014 28.158-27.424 45.104-1.41 16.943 5.907 20.421-2.684 36.975-8.592 16.523-9.807 28.07-10.046 32.717-.735 15.175-7.198 31.818-7.094 67.115.047 16.553 2.91 17.484 2.595 26.72' fill='%23d32011'/%3e%3cpath d='M2171.358 1312.989l-.03-.06.03.06m-.45-.66c-.494-.75-1.02-1.47-1.529-2.22-.45 0-.75-.028-.75-.028s1.32.989 2.279 2.248' fill='%23f0e53c'/%3e%3cpath d='M1938.705 1151.26c-72.228 4.38-126.82 67.744-140.766 125.982-7.573 23.391 3.928 40.485.48 59.828-3.465 19.373-7.888 65.623-4.799 70.84 3.09 5.203 12.715 28.505 10.527 43.963-2.19 15.46 4.497 37.382 6.341 46.497 1.485 7.438 3.164 40.906 6.343 59.11l91.661-66.366c-.33-13.045-1.739-27.949-6.852-39.51-7.948-18.024-11.89-42.374-9.118-60.945 2.775-18.532-11.65-37.005-11.409-47.742.255-10.765 4.603-26.33 4.333-32.447-.27-6.118-1.199-10.677 0-16.134 1.2-5.428 5.323-9.476 9.086-21.923 3.748-12.475 15.01-33.736 25.61-37.366 10.586-3.598 29.344-17.572 64.505-17.032 35.148.54 55.96 1.05 88.617 26.27 32.66 25.22 59.528 62.136 98.094 68.703-.016-.029-.016-.029-.03-.059a9.918 9.918 0 01-.42-.6c-.959-1.259-2.28-2.249-2.28-2.249s.301.03.75.03c-16.345-24.17-37.14-47.262-53.77-64.895-17.289-18.295-104.675-98.333-176.903-93.956' fill='%23f0e53c'/%3e%3cg clip-path='url(%23x)' opacity='.25'%3e%3cpath d='M2021.64 1391.89c-117.092 60.33-282.044 190.585-288.027 217.74-.3-23.002 102.215-154.727 288.026-217.74'/%3e%3c/g%3e%3cg clip-path='url(%23y)' opacity='.25'%3e%3cpath d='M1733.043 1547.507c17.154-35.252 96.25-140.362 230.748-167.045-52.21 3.12-226.265 56.343-230.748 167.045'/%3e%3c/g%3e%3cg clip-path='url(%23z)' opacity='.25'%3e%3cpath d='M1730.734 1494.683c-13.87-36.136 57.924-183.972 236.7-161.841-74.52 1.019-198.39 54.039-236.7 161.84'/%3e%3c/g%3e%3cg clip-path='url(%23A)' opacity='.25'%3e%3cpath d='M1723.686 1432.127c2.97-30.844 86.232-143.218 245.52-124.326-31.669-19.133-177.04-15.084-238.022 65.945-9.402 14.725-15.445 40.359-7.498 58.38'/%3e%3c/g%3e%3cg clip-path='url(%23B)' opacity='.25'%3e%3cpath d='M1717.9 1365.888c10.945-29.179 50.515-107.869 208.436-87.387-43.11-18.563-146.315-34.126-195.482 22.072-8.877 10.407-12.955 65.315-12.955 65.315'/%3e%3c/g%3e%3cg clip-path='url(%23C)' opacity='.25'%3e%3cpath d='M1946.247 1265.217c-117.435-36.316-159.823-21.92-208.091 5.817.796-14.604 56.694-100.283 208.09-5.817'/%3e%3c/g%3e%3cg clip-path='url(%23D)' opacity='.25'%3e%3cpath d='M1747.917 1215.286c16.704-11.576 119.16-45.853 265.806 61.117-27.32-34.697-120.72-104.421-223.132-101.601-15.773.03-18.247-.87-16.208-9.927-8.876 9.656-7.887 16.493-11.801 25.13-3.928 8.636-14.665 25.28-14.665 25.28'/%3e%3c/g%3e%3cg clip-path='url(%23E)' opacity='.25'%3e%3cpath d='M1786.693 1151.2c17.455-6.088 165.343-22.852 263.525 123.374-11.56-34.697-60.142-128.952-162.733-146.824-33.272-4.14-77.655-21.443-100.792 23.45'/%3e%3c/g%3e%3cg clip-path='url(%23F)' opacity='.25'%3e%3cpath d='M2156.513 1292.357c-51.596-111.049-214.014-209.44-305.734-184.25 28.233-11.516 115.336-21.203 186.454 33.616 71.103 54.85 119.28 150.634 119.28 150.634'/%3e%3c/g%3e%3cg clip-path='url(%23G)' opacity='.33'%3e%3cpath d='M2075.304 1287.56c9.492-2.97-23.375-22.884-20.212-16.135 3.164 6.746 4.933 14.334.675 15.323-4.275.991-17.918-15.984-10.737.54 7.168 16.525-22.717-11.156-22.717-11.156s6.778 7.347 2.43 12.176c-4.333 4.8-40.124-21.8-40.124-21.8s15.009 15.382 23.105 26.93c8.098 11.543-35.731-4.05-35.731-4.05s7.183.42 24.306 14.904c17.123 14.485-24.74 8.158-24.74 8.158s3.193 7.496 16.449 15.143c13.239 7.647-35.148 16.494-35.148 16.494s26.165 7.887 32.222 15.264c6.06 7.348-36.076 11.006-23.195 10.347 32.523-1.62 71.568 18.802 70.339 16.433-13.195-25.4-8.443-82.439 43.078-98.572'/%3e%3c/g%3e%3cpath d='M1706.699 1624.894c-7.092 3.6-11.396-.735-15.055-4.813-8.171 23.78-36.931 45.657-44.307 51.835 8.127-4.978 37.904-25.265 61.565-24.396-2.16-5.158-4.288-11.05 1.5-16.733z' fill='%23cacaca'/%3e%3cpath d='M1706.699 1624.894c-7.092 3.6-11.396-.735-15.055-4.813-8.171 23.78-36.931 45.657-44.307 51.835 8.127-4.978 37.904-25.265 61.565-24.396-2.16-5.158-4.288-11.05 1.5-16.733z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1714.81 1633.515c-3.014 2.174-7.437.795-9.867-3.074-2.444-3.867-1.964-8.787 1.051-10.946 3.013-2.174 7.437-.793 9.88 3.074 2.43 3.883 1.965 8.787-1.064 10.946' fill='%23cacaca'/%3e%3cpath d='M1714.81 1633.515c-3.014 2.174-7.437.795-9.867-3.074-2.444-3.867-1.964-8.787 1.051-10.946 3.013-2.174 7.437-.793 9.88 3.074 2.43 3.883 1.965 8.787-1.064 10.946zm-6.538 13.645l-16.538-26.314' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1715.605 1622.764c6.897 10.977 7.662 24.441 3.134 35.777 9.911-10.676 11.755-27.679 3.597-40.635-8.14-12.954-23.554-17.544-36.525-11.74 11.515-.21 22.896 5.608 29.794 16.598' fill='%23cacaca'/%3e%3cpath d='M1715.605 1622.764c6.897 10.977 7.662 24.441 3.134 35.777 9.911-10.676 11.755-27.679 3.597-40.635-8.14-12.954-23.554-17.544-36.525-11.74 11.515-.21 22.896 5.608 29.794 16.598z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1720.943 1510.591l-3.508.54c2.564 18.923 1.994 86.263 1.334 96.46l3.539.253c.674-10.54 1.29-77.655-1.365-97.253' fill='%23f0e53c'/%3e%3cpath d='M1720.943 1510.591l-3.508.54c2.564 18.923 1.994 86.263 1.334 96.46l3.539.253c.674-10.54 1.29-77.655-1.365-97.253z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1724.931 1500.545c.66 95.274-1.005 101.347-2.504 106.701-.194.749-.42 1.529-.613 2.518l3.447.824c.18-.853.36-1.543.57-2.263 1.619-5.893 3.314-11.965 2.639-107.809z' fill='%23f0e53c'/%3e%3cpath d='M1724.931 1500.545c.66 95.274-1.005 101.347-2.504 106.701-.194.749-.42 1.529-.613 2.518l3.447.824c.18-.853.36-1.543.57-2.263 1.619-5.893 3.314-11.965 2.639-107.809z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1727.405 1625.763c-1.124-4.692-3.553-10.572-8.74-14.694-5.189-4.138-.406-8.036 2.982-5.293 3.374 2.758 9.042 9.011 9.147 13.735.106 4.738-1.394 6.447-3.389 6.252' fill='%23f0e53c'/%3e%3cpath d='M1727.405 1625.763c-1.124-4.692-3.553-10.572-8.74-14.694-5.189-4.138-.406-8.036 2.982-5.293 3.374 2.758 9.042 9.011 9.147 13.735.106 4.738-1.394 6.447-3.389 6.252z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1715.65 1510.861c-2.25-5.638-11.667-38.82-15.325-41.475 4.798-1.662 8.097-2.067 11.096-4.347 3-2.294 3.854-3.043 7.183-2.968 0 0 6.822 39.24 3.838 47.202z' fill='%23f0e53c'/%3e%3cpath d='M1715.65 1510.861c-2.25-5.638-11.667-38.82-15.325-41.475 4.798-1.662 8.097-2.067 11.096-4.347 3-2.294 3.854-3.043 7.183-2.968 0 0 6.822 39.24 3.838 47.202z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1720.268 1509.782l-8.862-32.657m-1.244 9.67l-4.889-18.952m7.017-3.463l8.818 38.325' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M1724.016 1509.917c-.224-1.68-2.579-2.699-5.248-2.278-2.669.403-4.648 2.114-4.423 3.792.225 1.68 2.58 2.7 5.248 2.294 2.67-.419 4.65-2.114 4.423-3.808' fill='%23f0e53c'/%3e%3cpath d='M1724.016 1509.917c-.224-1.68-2.579-2.699-5.248-2.278-2.669.403-4.648 2.114-4.423 3.792.225 1.68 2.58 2.7 5.248 2.294 2.67-.419 4.65-2.114 4.423-3.808z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1722.758 1500.651c-1.44-6.957-3.014-7.588-5.953-44.414 5.233-1.693 6.687 1.095 9.147 1.68 2.458.585 10.51-2.759 10.33 3.223-.18 5.984-4.812 35.507-7.362 39.212z' fill='%23f0e53c'/%3e%3cpath d='M1722.758 1500.651c-1.44-6.957-3.014-7.588-5.953-44.414 5.233-1.693 6.687 1.095 9.147 1.68 2.458.585 10.51-2.759 10.33 3.223-.18 5.984-4.812 35.507-7.362 39.212z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1723.912 1487.156l.284-23.946m-3.508 5.862l-.585-13.375m6.058 42.239l2.578-26.885m4.528-7.721l.046-5.759' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M1731.844 1501.041c.016-1.71-2.16-3.105-4.844-3.134-2.713-.015-4.903 1.334-4.918 3.043-.014 1.695 2.16 3.09 4.858 3.12 2.7.03 4.89-1.336 4.904-3.029' fill='%23f0e53c'/%3e%3cpath d='M1731.844 1501.041c.016-1.71-2.16-3.105-4.844-3.134-2.713-.015-4.903 1.334-4.918 3.043-.014 1.695 2.16 3.09 4.858 3.12 2.7.03 4.89-1.336 4.904-3.029z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1759.763 1696.178c-6.551 4.647-11.396 1.019-15.55-2.445-4.887 24.77-30.422 50.846-36.885 58.089 7.363-6.164 34.113-30.815 57.639-33.603-2.835-4.768-5.727-10.271-.765-16.78z' fill='%23cacaca'/%3e%3cpath d='M1759.763 1696.178c-6.551 4.647-11.396 1.019-15.55-2.445-4.887 24.77-30.422 50.846-36.885 58.089 7.363-6.164 34.113-30.815 57.639-33.603-2.835-4.768-5.727-10.271-.765-16.78z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1768.94 1703.465c-2.684 2.609-7.243 1.933-10.181-1.53-2.923-3.463-3.12-8.381-.42-11.005 2.684-2.612 7.242-1.92 10.18 1.528 2.925 3.464 3.12 8.396.42 11.006' fill='%23cacaca'/%3e%3cpath d='M1768.94 1703.465c-2.684 2.609-7.243 1.933-10.181-1.53-2.923-3.463-3.12-8.381-.42-11.005 2.684-2.612 7.242-1.92 10.18 1.528 2.925 3.464 3.12 8.396.42 11.006zm-4.634 14.499l-19.897-23.497' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1768.28 1692.698c8.307 9.791 10.87 23.016 7.917 34.921 8.368-12.085 7.902-29.194-1.89-40.77-9.806-11.56-25.67-13.734-37.724-5.997 11.35-1.979 23.39 2.04 31.697 11.846' fill='%23cacaca'/%3e%3cpath d='M1768.28 1692.698c8.307 9.791 10.87 23.016 7.917 34.921 8.368-12.085 7.902-29.194-1.89-40.77-9.806-11.56-25.67-13.734-37.724-5.997 11.35-1.979 23.39 2.04 31.697 11.846z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1780.23 1578.35c1.2 95.275-.435 101.348-1.904 106.716-.195.764-.404 1.545-.6 2.535l3.45.794c.179-.87.359-1.545.554-2.264 1.604-5.908 3.254-11.996 2.055-107.824z' fill='%23f0e53c'/%3e%3cpath d='M1780.23 1578.35c1.2 95.275-.435 101.348-1.904 106.716-.195.764-.404 1.545-.6 2.535l3.45.794c.179-.87.359-1.545.554-2.264 1.604-5.908 3.254-11.996 2.055-107.824z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1780.365 1693.853c-1.753-4.468-4.934-9.911-10.63-13.195-5.684-3.298-1.47-7.902 2.248-5.698 3.703 2.22 10.166 7.528 10.902 12.19.75 4.664-.525 6.583-2.52 6.703' fill='%23f0e53c'/%3e%3cpath d='M1780.365 1693.853c-1.753-4.468-4.934-9.911-10.63-13.195-5.684-3.298-1.47-7.902 2.248-5.698 3.703 2.22 10.166 7.528 10.902 12.19.75 4.664-.525 6.583-2.52 6.703z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1778.055 1578.486c-1.483-6.957-3.059-7.586-6.208-44.383 5.235-1.724 6.704 1.05 9.162 1.62 2.46.57 10.497-2.819 10.348 3.148-.135 5.983-4.619 35.553-7.138 39.256z' fill='%23f0e53c'/%3e%3cpath d='M1778.055 1578.486c-1.483-6.957-3.059-7.586-6.208-44.383 5.235-1.724 6.704 1.05 9.162 1.62 2.46.57 10.497-2.819 10.348 3.148-.135 5.983-4.619 35.553-7.138 39.256z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1779.137 1564.976l.149-23.945m-3.478 5.877l-.66-13.359m6.296 42.193l2.43-26.915m4.498-7.737v-5.757' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M1787.158 1578.8c0-1.693-2.174-3.087-4.874-3.087-2.7-.015-4.887 1.348-4.902 3.059 0 1.709 2.19 3.088 4.874 3.088 2.699.015 4.887-1.364 4.902-3.06' fill='%23f0e53c'/%3e%3cpath d='M1787.158 1578.8c0-1.693-2.174-3.087-4.874-3.087-2.7-.015-4.887 1.348-4.902 3.059 0 1.709 2.19 3.088 4.874 3.088 2.699.015 4.887-1.364 4.902-3.06z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1644.187 1571.62c-7.467 2.593-11.216-2.28-14.35-6.824-10.931 22.462-42.058 40.245-50.111 45.358 8.652-3.823 40.59-19.882 63.95-15.804-1.528-5.397-2.922-11.544 3.479-16.39z' fill='%23cacaca'/%3e%3cpath d='M1644.187 1571.62c-7.467 2.593-11.216-2.28-14.35-6.824-10.931 22.462-42.058 40.245-50.111 45.358 8.652-3.823 40.59-19.882 63.95-15.804-1.528-5.397-2.922-11.544 3.479-16.39z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1651.22 1581.276c-3.254 1.738-7.483-.226-9.433-4.41-1.948-4.167-.9-8.965 2.355-10.705 3.254-1.739 7.467.224 9.415 4.393 1.966 4.184.916 8.982-2.338 10.722' fill='%23cacaca'/%3e%3cpath d='M1651.22 1581.276c-3.254 1.738-7.483-.226-9.433-4.41-1.948-4.167-.9-8.965 2.355-10.705 3.254-1.739 7.467.224 9.415 4.393 1.966 4.184.916 8.982-2.338 10.722zm-8.112 12.624l-13.271-28.354' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1653.289 1570.704c5.532 11.831 4.679 25.295-1.155 35.926 11.11-9.236 14.949-25.864 8.41-39.824-6.536-13.96-21.275-20.602-34.83-16.615 11.44 1.35 22.026 8.683 27.575 20.513' fill='%23cacaca'/%3e%3cpath d='M1653.289 1570.704c5.532 11.831 4.679 25.295-1.155 35.926 11.11-9.236 14.949-25.864 8.41-39.824-6.536-13.96-21.275-20.602-34.83-16.615 11.44 1.35 22.026 8.683 27.575 20.513z' fill='none' stroke='black' stroke-width='2.223'/%3e%3cpath d='M1653.693 1451.379l-3.45.81c3.84 19.912 7.829 91.48 7.858 102.351l3.539.03c-.03-11.245-3.958-82.544-7.947-103.191' fill='%23f0e53c'/%3e%3cpath d='M1653.693 1451.379l-3.45.81c3.84 19.912 7.829 91.48 7.858 102.351l3.539.03c-.03-11.245-3.958-82.544-7.947-103.191z' fill='none' stroke='%23473125' stroke-width='1.605'/%3e%3cpath d='M1657.008 1440.449c7.106 101.12 5.832 107.689 4.723 113.477-.166.809-.33 1.648-.465 2.714l3.508.645c.12-.93.255-1.665.406-2.444 1.229-6.358 2.504-12.926-4.634-114.663z' fill='%23f0e53c'/%3e%3cpath d='M1657.008 1440.449c7.106 101.12 5.832 107.689 4.723 113.477-.166.809-.33 1.648-.465 2.714l3.508.645c.12-.93.255-1.665.406-2.444 1.229-6.358 2.504-12.926-4.634-114.663z' fill='none' stroke='%23473125' stroke-width='1.605'/%3e%3cpath d='M1664.623 1575.292c-.554-4.813-2.263-10.96-6.913-15.759-4.663-4.812.557-8.037 3.584-4.843 3.014 3.194 7.903 10.166 7.438 14.875-.45 4.707-2.144 6.192-4.109 5.727' fill='%23f0e53c'/%3e%3cpath d='M1664.623 1575.292c-.554-4.813-2.263-10.96-6.913-15.759-4.663-4.812.557-8.037 3.584-4.843 3.014 3.194 7.903 10.166 7.438 14.875-.45 4.707-2.144 6.192-4.109 5.727z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1648.356 1451.379c-2.564-5.458-13.991-37.906-17.814-40.32 4.694-1.979 7.962-2.624 10.826-5.097 2.848-2.49 3.659-3.3 6.988-3.464 0 0 9.19 38.671 6.702 46.842z' fill='%23f0e53c'/%3e%3cpath d='M1648.356 1451.379c-2.564-5.458-13.991-37.906-17.814-40.32 4.694-1.979 7.962-2.624 10.826-5.097 2.848-2.49 3.659-3.3 6.988-3.464 0 0 9.19 38.671 6.702 46.842z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1652.913 1449.985l-10.825-31.969m-.66 9.732l-6.043-18.562m6.792-3.944l11.141 37.62' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M1656.662 1449.865c-.33-1.665-2.744-2.52-5.368-1.919-2.655.6-4.528 2.442-4.184 4.093.33 1.665 2.73 2.518 5.369 1.92 2.638-.6 4.513-2.429 4.183-4.094' fill='%23f0e53c'/%3e%3cpath d='M1656.662 1449.865c-.33-1.665-2.744-2.52-5.368-1.919-2.655.6-4.528 2.442-4.184 4.093.33 1.665 2.73 2.518 5.369 1.92 2.638-.6 4.513-2.429 4.183-4.094z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1654.848 1440.719c-1.874-6.853-3.478-7.378-8.652-43.912 5.128-2.07 6.733.63 9.22 1.02 2.506.419 10.333-3.48 10.513 2.519.18 5.96-2.64 35.754-4.963 39.622z' fill='%23f0e53c'/%3e%3cpath d='M1654.848 1440.719c-1.874-6.853-3.478-7.378-8.652-43.912 5.128-2.07 6.733.63 9.22 1.02 2.506.419 10.333-3.48 10.513 2.519.18 5.96-2.64 35.754-4.963 39.622z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1655.162 1427.163l-1.168-23.916m4.062 34.518l.944-27.02m4.065-8.008l-.314-5.75' fill='none' stroke='%23473125' stroke-width='1.556' stroke-linecap='round'/%3e%3cpath d='M1663.934 1440.449c-.089-1.695-2.338-2.924-5.038-2.774-2.683.165-4.798 1.664-4.707 3.373.089 1.694 2.338 2.94 5.037 2.774 2.7-.15 4.799-1.664 4.708-3.373' fill='%23f0e53c'/%3e%3cpath d='M1663.934 1440.449c-.089-1.695-2.338-2.924-5.038-2.774-2.683.165-4.798 1.664-4.707 3.373.089 1.694 2.338 2.94 5.037 2.774 2.7-.15 4.799-1.664 4.708-3.373z' fill='none' stroke='%23473125' stroke-width='1.556'/%3e%3cpath d='M1732.204 1357.852c.03.211.044.36.075.57.645-.48.585-.63-.075-.57'/%3e%3cpath d='M2166.904 1270.466c-13.12-49.992-49.946-142.507-50.216-271.398-.464-10.345-15.384-15.354-15.188-25.13.208-9.807 3.237-9.957-.75-17.245-2.295 7.019-9.702 9.687-9.403 16.584.301 6.897 6.374 22.701-.359 28.79-6.717 6.086-16.074 13.464-12.956 35.745 3.136 22.313 54.595 215.38 81.105 231.334 26.51 15.924 7.767 1.32 7.767 1.32' fill='%23d32011'/%3e%3cpath d='M2032.542 1017.833c-1.304 6.957 6.446 24.838-1.007 26.338-7.466 1.529-19.552 7.888-15.22 20.9 4.334 13.046 32.135 74.074 60.773 110.929 28.64 36.856 58.358 67.835 58.358 67.835-16.478-44.622-68.06-197.175-73.666-221.316-2.655-11.366-29.238-4.686-29.238-4.686' fill='%2300702d'/%3e%3cg clip-path='url(%23H)' opacity='.25'%3e%3cpath d='M2092.247 1018.41c6.327-9.327 27.395-12.895 17.71-25.34' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cg clip-path='url(%23I)' opacity='.25'%3e%3cpath d='M2048.689 1030.766c11.08 5.667-27.38 37.814-29.208 30.618-2.055-8.486 6.672-9.476 6.088-12.025' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cpath d='M2149.601 1247.733c-12.82-35.025-47.727-144.335-48.882-195.495-.51-11.487-21.382-9.297-16.93-18.143 4.455-8.878 17.154-13.525 7.2-32.029-8.428 3.869-23.467 8.098-22.432-6.928 1.048-15.024-6.839-10.585-10.482-8.096-3.658 2.489-12.146 5.188-4.289 12.866 7.872 7.677 1.095 12.594-5.877 12.954-6.973.36-12.926-.51-14.905 3.63-1.963 4.106 1.86 5.667 6.18 6.026 4.317.36 27.513 14.155 22.49 22.462-5.009 8.308-12.416 10.977-8.653 23.451 3.78 12.476 43.08 111.769 65.526 145.745 22.461 34.007 31.054 33.557 31.054 33.557' fill='%23f0e53c'/%3e%3cg clip-path='url(%23J)' opacity='.25'%3e%3cpath d='M2164.313 1044.14c-30.989 22.858 15.107 14.98 22.171-48.588' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cg clip-path='url(%23K)' opacity='.25'%3e%3cpath d='M2190.998 1049.879c17.604 27.619-28.004.726 4.167-51.891' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cg clip-path='url(%23L)' opacity='.25'%3e%3cpath d='M2087.585 1044.127c30.989 22.859-15.107 14.98-22.171-48.588' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cg clip-path='url(%23M)' opacity='.25'%3e%3cpath d='M2060.9 1049.866c-17.603 27.619 28.003.726-4.167-51.891' fill='none' stroke='black' stroke-width='3.334' stroke-linecap='round'/%3e%3c/g%3e%3cg clip-path='url(%23N)' opacity='.25'%3e%3cpath d='M2303.763 1524.774l-.41 1.023 74.266 72.452.65-.933z'/%3e%3c/g%3e%3cg clip-path='url(%23O)' opacity='.25'%3e%3cpath d='M1948.207 1524.774l.41 1.023-74.267 72.452-.648-.933z'/%3e%3c/g%3e%3cg clip-path='url(%23P)' opacity='.25'%3e%3cpath d='M1908.493 1489.87v1.244l-91.661 66.366-.21-1.233z'/%3e%3c/g%3e%3cg clip-path='url(%23Q)' opacity='.25'%3e%3cpath d='M2343.512 1490.704l-.035 1.216 91.662 65.56.201-1.234z'/%3e%3c/g%3e%3cg clip-path='url(%23R)' opacity='.25'%3e%3cpath d='M2218.063 1016.922c-1.33-2.784-5.212-2.855-10.125-2.944-1.263-.024-2.568-.047-3.929-.119-4.905-.25-8.828-2.414-9.995-5.506-.726-1.927-.715-5.08 3.47-9.16 2.112-2.066 3.091-3.85 2.906-5.305-.26-2.054-2.818-3.522-5.074-4.818-.72-.413-1.399-.803-1.986-1.203-.877-.598-3.543-2.42-5.64-2.42-.773 0-1.383.251-1.865.77-.86.92-1.804 3.204-1.415 8.852.273 3.97-.523 6.986-2.368 8.962-1.668 1.787-4.144 2.693-7.359 2.694-5.179 0-11.113-2.378-14.164-3.779l.463-.88c3.9 1.791 9.217 3.66 13.7 3.66 5.204-.002 9.286-2.518 8.731-10.588-.576-8.355 1.602-10.69 4.277-10.69 2.135 0 4.586 1.49 6.203 2.593 3.66 2.49 12.147 5.19 4.29 12.866-7.873 7.677-1.095 12.595 5.878 12.954 6.972.361 12.925-.509 14.904 3.63 0 0 1.124 2.05.11 3.521 0 0-.106.26-.76.833 0 0 .822-1.813-.252-3.923' fill='%23292723'/%3e%3c/g%3e%3cg clip-path='url(%23S)' opacity='.25'%3e%3cpath d='M2033.907 1016.922c1.332-2.784 5.212-2.855 10.125-2.944 1.263-.024 2.569-.047 3.929-.119 4.905-.25 8.828-2.414 9.994-5.506.727-1.927.716-5.08-3.468-9.16-2.114-2.066-3.092-3.85-2.907-5.305.26-2.054 2.818-3.522 5.074-4.818.72-.413 1.4-.803 1.987-1.203.876-.598 3.542-2.42 5.639-2.42.772 0 1.382.251 1.865.77.86.92 1.804 3.204 1.415 8.852-.274 3.97.523 6.986 2.368 8.962 1.668 1.787 4.144 2.693 7.359 2.694 5.178 0 11.113-2.378 14.163-3.779l-.462-.88c-3.9 1.791-9.216 3.66-13.701 3.66-5.203-.002-9.285-2.518-8.73-10.588.576-8.355-1.602-10.69-4.277-10.69-2.135 0-4.586 1.49-6.203 2.593-3.66 2.49-12.147 5.19-4.29 12.866 7.873 7.677 1.094 12.595-5.878 12.954-6.972.361-12.925-.509-14.904 3.63 0 0-1.125 2.05-.11 3.521 0 0 .106.26.76.833 0 0-.822-1.813.252-3.923' fill='%23292723'/%3e%3c/g%3e%3cpath d='M2038.478 1170.424c-3.209-.21-6.418.089-9.477.989l1.29 4.468c10.765-3.15 23.825 2.31 29.104 12.146 5.308 9.866 1.334 21.44-10.87 31.757l2.998 3.569c19.942-16.853 15.01-31.848 11.981-37.515-4.769-8.878-14.86-14.756-25.026-15.414' fill='%23ced0d1'/%3e%3cpath d='M2038.478 1170.424c-3.209-.21-6.418.089-9.477.989l1.29 4.468c10.765-3.15 23.825 2.31 29.104 12.146 5.308 9.866 1.334 21.44-10.87 31.757l2.998 3.569c19.942-16.853 15.01-31.848 11.981-37.515-4.769-8.878-14.86-14.756-25.026-15.414z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2037.069 1202.33c2.414-5.277 5.937-11.515 13.719-11.754-5.576-1.92-12.58-5.49-17.032 2.999-4.44 8.517 3.313 8.756 3.313 8.756' fill='%23ced0d1'/%3e%3cpath d='M2037.069 1202.33c2.414-5.277 5.937-11.515 13.719-11.754-5.576-1.92-12.58-5.49-17.032 2.999-4.44 8.517 3.313 8.756 3.313 8.756z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1909.632 1054.966c17.648 26.75 34.562 52.72 40.86 63.247 6.297 10.496 25.054 32.087 40.004 40.754 14.965 8.666 15.67 21.502 18.158 30.798 2.49 9.297 8.442 48.522 23.856 61.957 15.414 13.464 9.326-.15 22.266 15.443 12.941 15.624 240.96 289.548 240.96 289.548l11.394-7.992-212.093-267.999.255-3.87s-41.985-46.273-42.39-51.73c-.42-5.458-4.229-6.477-6.297-10.496-2.07-4.019-13.57-17.993-13.676-39.735-.12-21.74-11.709-22.522-14.348-29.659-2.624-7.168-42-104.69-49.932-125.682-11.56 10.585-59.017 35.416-59.017 35.416' fill='%23473125'/%3e%3cpath d='M1909.632 1054.966c17.648 26.75 34.562 52.72 40.86 63.247 6.297 10.496 25.054 32.087 40.004 40.754 14.965 8.666 15.67 21.502 18.158 30.798 2.49 9.297 8.442 48.522 23.856 61.957 15.414 13.464 9.326-.15 22.266 15.443 12.941 15.624 240.96 289.548 240.96 289.548l11.394-7.992-212.093-267.999.255-3.87s-41.985-46.273-42.39-51.73c-.42-5.458-4.229-6.477-6.297-10.496-2.07-4.019-13.57-17.993-13.676-39.735-.12-21.74-11.709-22.522-14.348-29.659-2.624-7.168-42-104.69-49.932-125.682-11.56 10.585-59.017 35.416-59.017 35.416z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M1972.937 1030.616a1560.243 1560.243 0 01-4.289-11.065c-11.56 10.585-59.016 35.416-59.016 35.416a6148.69 6148.69 0 0110.015 15.205c33.56-20.364 53.29-39.556 53.29-39.556' fill='%23f0e53c'/%3e%3cpath d='M1972.937 1030.616a1560.243 1560.243 0 01-4.289-11.065c-11.56 10.585-59.016 35.416-59.016 35.416a6148.69 6148.69 0 0110.015 15.205c33.56-20.364 53.29-39.556 53.29-39.556z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1919.647 1070.171a6052.67 6052.67 0 00-10.015-15.205s18.187-9.536 34.802-19.281c-.796 5.966-12.806 15.534-15.28 17.692-2.475 2.159-3.988 5.519-4.199 8.697-.209 3.177-5.308 8.097-5.308 8.097' fill='%23ced0d1'/%3e%3cpath d='M1919.647 1070.171a6052.67 6052.67 0 00-10.015-15.205s18.187-9.536 34.802-19.281c-.796 5.966-12.806 15.534-15.28 17.692-2.475 2.159-3.988 5.519-4.199 8.697-.209 3.177-5.308 8.097-5.308 8.097z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M2042.286 1232.98l4.978-4.858 45.898 57.427-4.018 5.91z' fill='%23ced0d1'/%3e%3cpath d='M2042.286 1232.98l4.978-4.858 45.898 57.427-4.018 5.91z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2049.874 1261.738l-4.064 4.078 252.595 305.518 2.938-5.503z' fill='%23ced0d1'/%3e%3cpath d='M2049.874 1261.738l-4.064 4.078 252.595 305.518 2.938-5.503z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2136.242 1330.472c1.095-.959 1.274-2.549.403-3.539l-6.476-7.467c-.886-1.019-2.475-1.05-3.583-.119l-21.383 18.562c-1.095.96-1.274 2.55-.405 3.54l6.478 7.466c.869 1.02 2.473 1.05 3.568.12z' fill='%23ced0d1'/%3e%3cpath d='M2136.242 1330.472c1.095-.959 1.274-2.549.403-3.539l-6.476-7.467c-.886-1.019-2.475-1.05-3.583-.119l-21.383 18.562c-1.095.96-1.274 2.55-.405 3.54l6.478 7.466c.869 1.02 2.473 1.05 3.568.12z' fill='none' stroke='black' stroke-width='1.262'/%3e%3cpath d='M2224.557 1441.498a2.417 2.417 0 00.24-3.403l-6.477-7.468a2.406 2.406 0 00-3.404-.255l-19.507 16.914a2.404 2.404 0 00-.226 3.404l6.463 7.467c.884 1.004 2.4 1.124 3.403.255z' fill='%23ced0d1'/%3e%3cpath d='M2224.557 1441.498a2.417 2.417 0 00.24-3.403l-6.477-7.468a2.406 2.406 0 00-3.404-.255l-19.507 16.914a2.404 2.404 0 00-.226 3.404l6.463 7.467c.884 1.004 2.4 1.124 3.403.255z' fill='none' stroke='black' stroke-width='1.205'/%3e%3cpath d='M2087.165 1278.381a4.118 4.118 0 003.854 4.38 4.118 4.118 0 10.539-8.218 4.117 4.117 0 00-4.393 3.839' fill='%23ced0d1'/%3e%3cpath d='M2087.165 1278.381a4.118 4.118 0 003.854 4.38 4.118 4.118 0 10.539-8.218 4.117 4.117 0 00-4.393 3.839z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2034.55 1236.608a4.901 4.901 0 004.573 5.217c2.7.181 5.038-1.889 5.218-4.588a4.912 4.912 0 00-4.573-5.217 4.895 4.895 0 00-5.219 4.588' fill='%23ced0d1'/%3e%3cpath d='M2034.55 1236.608a4.901 4.901 0 004.573 5.217c2.7.181 5.038-1.889 5.218-4.588a4.912 4.912 0 00-4.573-5.217 4.895 4.895 0 00-5.219 4.588z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2000.153 1243.895c6.117 1.08 23.9-21.832 25.52-3.029-2.43-.18-9.895-2.039-12.116.091-5.818 5.606 5.848 4.167 5.999 6.056.329 4.17-1.154 8.187-6.448 8.548-9.012.6-2.055-6.298-4.558-9.297-.135-.15.404-.42.45-.51-4.215 1.56-6.148-.06-8.818-2.099' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2321.302 1572.054l-3.645 2.893 24.952 31.264 3.643-2.894z' fill='%23ced0d1'/%3e%3cpath d='M2321.302 1572.054l-3.645 2.893 24.952 31.264 3.643-2.894z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2017.697 1260.598c2.443-2.488 4.557-4.438 5.517-8.155 3.569 4.946 10.542 2.907 11.8-3.57.72 1.38 2.204 2.85 2.789 4.2-7.631-13.376 13.466-4.11 13.51 4.288.045 12.654-18.787 6.416-12.04-3.63-5.503 1.86-16.268 13.166-21.576 6.867' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2307.866 1565.23l10.062 12.057 5.217-4.32-11.425-15.203z' fill='%23ced0d1'/%3e%3cpath d='M2307.866 1565.23l10.062 12.057 5.217-4.32-11.425-15.203z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2295.677 1577.362c.943-4.56 3.731-9.581-.752-16.09-4.497-6.522 3.75-17.663 6.48-19.791 2.726-2.13 12.04 13.763 12.04 13.763s3.913 3.375-5.759 12.566l36.826 45.912-2.159 44.369 60.727 103.386-79.485-101.526 2.473-41.235-29.687-36.392s-1.396-1.68-.705-4.962' fill='%23ced0d1'/%3e%3cpath d='M2295.677 1577.362c.943-4.56 3.731-9.581-.752-16.09-4.497-6.522 3.75-17.663 6.48-19.791 2.726-2.13 12.04 13.763 12.04 13.763s3.913 3.375-5.759 12.566l36.826 45.912-2.159 44.369 60.727 103.386-79.485-101.526 2.473-41.235-29.687-36.392s-1.396-1.68-.705-4.962z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2316.28 1578.501l-5.595 6.583 27.56 33.813m-14.65 41.053c5.534 2.445 12.91 4.484 18.759-1.858m-16.286-39.376c3.001 1.485 8.443 5.474 18.444-4.993' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1980.66 1149.46c-3.209-.238-6.434.03-9.507.9l1.274 4.468c10.782-3.027 23.796 2.52 29 12.416 5.203 9.927 1.14 21.473-11.157 31.668l2.97 3.569c20.077-16.673 15.294-31.698 12.295-37.396-4.693-8.907-14.724-14.873-24.875-15.624' fill='%23ced0d1'/%3e%3cpath d='M1980.66 1149.46c-3.209-.238-6.434.03-9.507.9l1.274 4.468c10.782-3.027 23.796 2.52 29 12.416 5.203 9.927 1.14 21.473-11.157 31.668l2.97 3.569c20.077-16.673 15.294-31.698 12.295-37.396-4.693-8.907-14.724-14.873-24.875-15.624z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1978.966 1181.368c2.459-5.246 6.028-11.454 13.81-11.664-5.548-1.95-12.52-5.61-17.035 2.879-4.527 8.457 3.225 8.785 3.225 8.785' fill='%23ced0d1'/%3e%3cpath d='M1978.966 1181.368c2.459-5.246 6.028-11.454 13.81-11.664-5.548-1.95-12.52-5.61-17.035 2.879-4.527 8.457 3.225 8.785 3.225 8.785z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1852.818 1032.894c17.41 26.93 34.097 53.021 40.305 63.577 6.193 10.585 24.771 32.327 39.645 41.114 14.888 8.817 15.473 21.651 17.89 30.98 2.412 9.325 8.02 48.58 23.314 62.165 15.31 13.555 9.326-.09 22.147 15.624 12.805 15.714 238.456 291.603 238.456 291.603l11.468-7.888-209.785-269.829.286-3.87s-41.58-46.602-41.939-52.09c-.376-5.457-4.184-6.508-6.208-10.557-2.025-4.017-13.406-18.082-13.346-39.824.076-21.773-11.515-22.64-14.079-29.809-2.565-7.198-41.099-105.02-48.836-126.102-11.666 10.496-59.318 34.906-59.318 34.906' fill='%23473125'/%3e%3cpath d='M1852.818 1032.894c17.41 26.93 34.097 53.021 40.305 63.577 6.193 10.585 24.771 32.327 39.645 41.114 14.888 8.817 15.473 21.651 17.89 30.98 2.412 9.325 8.02 48.58 23.314 62.165 15.31 13.555 9.326-.09 22.147 15.624 12.805 15.714 238.456 291.603 238.456 291.603l11.468-7.888-209.785-269.829.286-3.87s-41.58-46.602-41.939-52.09c-.376-5.457-4.184-6.508-6.208-10.557-2.025-4.017-13.406-18.082-13.346-39.824.076-21.773-11.515-22.64-14.079-29.809-2.565-7.198-41.099-105.02-48.836-126.102-11.666 10.496-59.318 34.906-59.318 34.906z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M1916.319 1009.083a1078.493 1078.493 0 01-4.182-11.095c-11.667 10.496-59.318 34.907-59.318 34.907a3435.84 3435.84 0 019.866 15.295c33.737-20.093 53.634-39.107 53.634-39.107' fill='%23f0e53c'/%3e%3cpath d='M1916.319 1009.083a1078.493 1078.493 0 01-4.182-11.095c-11.667 10.496-59.318 34.907-59.318 34.907a3435.84 3435.84 0 019.866 15.295c33.737-20.093 53.634-39.107 53.634-39.107z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1862.685 1048.19a3349.423 3349.423 0 00-9.867-15.296s18.263-9.355 34.95-18.982c-.837 5.968-12.938 15.414-15.427 17.573-2.49 2.13-4.033 5.49-4.274 8.667-.24 3.18-5.382 8.037-5.382 8.037' fill='%23ced0d1'/%3e%3cpath d='M1862.685 1048.19a3349.423 3349.423 0 00-9.867-15.296s18.263-9.355 34.95-18.982c-.837 5.968-12.938 15.414-15.427 17.573-2.49 2.13-4.033 5.49-4.274 8.667-.24 3.18-5.382 8.037-5.382 8.037z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M1983.914 1212.047l5.022-4.829 45.403 57.85-4.063 5.847z' fill='%23ced0d1'/%3e%3cpath d='M1983.914 1212.047l5.022-4.829 45.403 57.85-4.063 5.847z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1991.261 1240.866l-4.093 4.049 249.94 307.676 2.998-5.474z' fill='%23ced0d1'/%3e%3cpath d='M1991.261 1240.866l-4.093 4.049 249.94 307.676 2.998-5.474z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2077.028 1310.35c1.11-.93 1.305-2.519.435-3.538l-6.417-7.528c-.87-1.02-2.46-1.08-3.57-.12l-21.547 18.352c-1.108.931-1.303 2.521-.434 3.54l6.418 7.526c.854 1.02 2.458 1.081 3.57.121z' fill='%23ced0d1'/%3e%3cpath d='M2077.028 1310.35c1.11-.93 1.305-2.519.435-3.538l-6.417-7.528c-.87-1.02-2.46-1.08-3.57-.12l-21.547 18.352c-1.108.931-1.303 2.521-.434 3.54l6.418 7.526c.854 1.02 2.458 1.081 3.57.121z' fill='none' stroke='black' stroke-width='1.262'/%3e%3cpath d='M2164.385 1422.125c1.02-.869 1.124-2.383.271-3.404l-6.417-7.512c-.873-1.019-2.386-1.154-3.39-.299l-19.658 16.748a2.423 2.423 0 00-.27 3.405l6.417 7.526a2.403 2.403 0 003.39.284z' fill='%23ced0d1'/%3e%3cpath d='M2164.385 1422.125c1.02-.869 1.124-2.383.271-3.404l-6.417-7.512c-.873-1.019-2.386-1.154-3.39-.299l-19.658 16.748a2.423 2.423 0 00-.27 3.405l6.417 7.526a2.403 2.403 0 003.39.284z' fill='none' stroke='black' stroke-width='1.205'/%3e%3cpath d='M2028.401 1257.84c-.164 2.28 1.545 4.26 3.81 4.408a4.122 4.122 0 004.437-3.808c.166-2.28-1.543-4.26-3.808-4.409-2.278-.179-4.259 1.53-4.439 3.808' fill='%23ced0d1'/%3e%3cpath d='M2028.401 1257.84c-.164 2.28 1.545 4.26 3.81 4.408a4.122 4.122 0 004.437-3.808c.166-2.28-1.543-4.26-3.808-4.409-2.278-.179-4.259 1.53-4.439 3.808z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1976.146 1215.586a4.91 4.91 0 004.528 5.277c2.7.18 5.053-1.829 5.264-4.528.194-2.699-1.829-5.068-4.528-5.248-2.7-.21-5.069 1.8-5.264 4.5' fill='%23ced0d1'/%3e%3cpath d='M1976.146 1215.586a4.91 4.91 0 004.528 5.277c2.7.18 5.053-1.829 5.264-4.528.194-2.699-1.829-5.068-4.528-5.248-2.7-.21-5.069 1.8-5.264 4.5z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1941.704 1222.603c6.088 1.11 24.082-21.622 25.536-2.788-2.43-.21-9.881-2.16-12.115-.03-5.864 5.547 5.802 4.227 5.937 6.087.3 4.168-1.214 8.187-6.506 8.517-9.027.51-2.011-6.328-4.499-9.357-.12-.15.419-.419.465-.48-4.229 1.5-6.134-.12-8.803-2.22' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2259.989 1553.506l-3.657 2.878 24.679 31.474 3.66-2.865z' fill='%23ced0d1'/%3e%3cpath d='M2259.989 1553.506l-3.657 2.878 24.679 31.474 3.66-2.865z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1959.083 1239.458c2.474-2.49 4.603-4.41 5.592-8.127 3.524 4.978 10.527 2.998 11.845-3.45.706 1.38 2.175 2.879 2.745 4.228-7.527-13.463 13.494-4.018 13.465 4.409-.06 12.656-18.834 6.238-12.01-3.748-5.503 1.829-16.374 13.015-21.637 6.688' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2246.614 1546.578l9.973 12.13 5.248-4.273-11.292-15.279z' fill='%23ced0d1'/%3e%3cpath d='M2246.614 1546.578l9.973 12.13 5.248-4.273-11.292-15.279z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2234.334 1558.604c.99-4.543 3.809-9.552-.614-16.104-4.44-6.553 3.913-17.619 6.657-19.717 2.744-2.115 11.905 13.853 11.905 13.853s3.884 3.405-5.863 12.507l36.437 46.242-2.534 44.338 59.813 103.926-78.586-102.217 2.819-41.218-29.374-36.648s-1.38-1.693-.66-4.962' fill='%23ced0d1'/%3e%3cpath d='M2234.334 1558.604c.99-4.543 3.809-9.552-.614-16.104-4.44-6.553 3.913-17.619 6.657-19.717 2.744-2.115 11.905 13.853 11.905 13.853s3.884 3.405-5.863 12.507l36.437 46.242-2.534 44.338 59.813 103.926-78.586-102.217 2.819-41.218-29.374-36.648s-1.38-1.693-.66-4.962z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2254.922 1559.923l-5.638 6.538 27.244 34.037m-14.979 40.934c5.503 2.49 12.85 4.59 18.773-1.709m-15.954-39.509c2.983 1.514 8.382 5.547 18.488-4.829' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2213.492 1170.424c3.209-.21 6.418.089 9.49.989l-1.303 4.468c-10.767-3.15-23.826 2.31-29.104 12.146-5.31 9.866-1.335 21.44 10.87 31.757l-2.998 3.569c-19.942-16.853-15.01-31.848-11.981-37.515 4.769-8.878 14.86-14.756 25.026-15.414' fill='%23ced0d1'/%3e%3cpath d='M2213.492 1170.424c3.209-.21 6.418.089 9.49.989l-1.303 4.468c-10.767-3.15-23.826 2.31-29.104 12.146-5.31 9.866-1.335 21.44 10.87 31.757l-2.998 3.569c-19.942-16.853-15.01-31.848-11.981-37.515 4.769-8.878 14.86-14.756 25.026-15.414z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2214.901 1202.33c-2.414-5.277-5.937-11.515-13.719-11.754 5.576-1.92 12.58-5.49 17.032 2.999 4.44 8.517-3.313 8.756-3.313 8.756' fill='%23ced0d1'/%3e%3cpath d='M2214.901 1202.33c-2.414-5.277-5.937-11.515-13.719-11.754 5.576-1.92 12.58-5.49 17.032 2.999 4.44 8.517-3.313 8.756-3.313 8.756z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2342.338 1054.966c-17.647 26.75-34.563 52.72-40.858 63.247-6.3 10.496-25.057 32.087-40.006 40.754-14.95 8.666-15.654 21.502-18.158 30.798-2.49 9.297-8.426 48.522-23.856 61.957-15.414 13.464-9.326-.15-22.267 15.443-12.94 15.624-240.96 289.548-240.96 289.548l-11.395-7.992 212.095-267.999-.255-3.87s41.985-46.273 42.39-51.73c.419-5.458 4.229-6.477 6.297-10.496 2.07-4.019 13.57-17.993 13.674-39.735.12-21.74 11.727-22.522 14.35-29.659 2.639-7.168 42-104.69 49.932-125.682 11.56 10.585 59.017 35.416 59.017 35.416' fill='%23473125'/%3e%3cpath d='M2342.338 1054.966c-17.647 26.75-34.563 52.72-40.858 63.247-6.3 10.496-25.057 32.087-40.006 40.754-14.95 8.666-15.654 21.502-18.158 30.798-2.49 9.297-8.426 48.522-23.856 61.957-15.414 13.464-9.326-.15-22.267 15.443-12.94 15.624-240.96 289.548-240.96 289.548l-11.395-7.992 212.095-267.999-.255-3.87s41.985-46.273 42.39-51.73c.419-5.458 4.229-6.477 6.297-10.496 2.07-4.019 13.57-17.993 13.674-39.735.12-21.74 11.727-22.522 14.35-29.659 2.639-7.168 42-104.69 49.932-125.682 11.56 10.585 59.017 35.416 59.017 35.416z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M2279.033 1030.616c1.812-4.647 3.298-8.457 4.288-11.065 11.561 10.585 59.017 35.416 59.017 35.416a6152.03 6152.03 0 00-10.016 15.205c-33.558-20.364-53.289-39.556-53.289-39.556' fill='%23f0e53c'/%3e%3cpath d='M2279.033 1030.616c1.812-4.647 3.298-8.457 4.288-11.065 11.561 10.585 59.017 35.416 59.017 35.416a6152.03 6152.03 0 00-10.016 15.205c-33.558-20.364-53.289-39.556-53.289-39.556z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2332.322 1070.171a6346.4 6346.4 0 0110.016-15.205s-18.189-9.536-34.802-19.281c.796 5.966 12.806 15.534 15.279 17.692 2.475 2.159 3.989 5.519 4.199 8.697.209 3.177 5.308 8.097 5.308 8.097' fill='%23ced0d1'/%3e%3cpath d='M2332.322 1070.171a6346.4 6346.4 0 0110.016-15.205s-18.189-9.536-34.802-19.281c.796 5.966 12.806 15.534 15.279 17.692 2.475 2.159 3.989 5.519 4.199 8.697.209 3.177 5.308 8.097 5.308 8.097z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M2209.683 1232.98l-4.979-4.858-45.897 57.427 4.02 5.91z' fill='%23ced0d1'/%3e%3cpath d='M2209.683 1232.98l-4.979-4.858-45.897 57.427 4.02 5.91z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2202.095 1261.738l4.065 4.078-252.58 305.518-2.954-5.503z' fill='%23ced0d1'/%3e%3cpath d='M2202.095 1261.738l4.065 4.078-252.58 305.518-2.954-5.503z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2115.728 1330.472c-1.095-.959-1.274-2.549-.39-3.539l6.463-7.467c.885-1.019 2.475-1.05 3.583-.119l21.382 18.562c1.095.96 1.275 2.55.406 3.54l-6.478 7.466c-.869 1.02-2.474 1.05-3.569.12z' fill='%23ced0d1'/%3e%3cpath d='M2115.728 1330.472c-1.095-.959-1.274-2.549-.39-3.539l6.463-7.467c.885-1.019 2.475-1.05 3.583-.119l21.382 18.562c1.095.96 1.275 2.55.406 3.54l-6.478 7.466c-.869 1.02-2.474 1.05-3.569.12z' fill='none' stroke='black' stroke-width='1.262'/%3e%3cpath d='M2027.412 1441.498a2.418 2.418 0 01-.24-3.403l6.477-7.468a2.407 2.407 0 013.405-.255l19.506 16.914a2.416 2.416 0 01.24 3.404l-6.477 7.467c-.884 1.004-2.398 1.124-3.402.255z' fill='%23ced0d1'/%3e%3cpath d='M2027.412 1441.498a2.418 2.418 0 01-.24-3.403l6.477-7.468a2.407 2.407 0 013.405-.255l19.506 16.914a2.416 2.416 0 01.24 3.404l-6.477 7.467c-.884 1.004-2.398 1.124-3.402.255z' fill='none' stroke='black' stroke-width='1.205'/%3e%3cpath d='M2164.805 1278.381a4.118 4.118 0 01-3.854 4.38 4.12 4.12 0 01-4.393-3.838 4.115 4.115 0 013.853-4.38 4.118 4.118 0 014.394 3.839' fill='%23ced0d1'/%3e%3cpath d='M2164.805 1278.381a4.118 4.118 0 01-3.854 4.38 4.12 4.12 0 01-4.393-3.838 4.115 4.115 0 013.853-4.38 4.118 4.118 0 014.394 3.839z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2217.42 1236.608a4.901 4.901 0 01-4.573 5.217c-2.7.181-5.037-1.889-5.217-4.588a4.91 4.91 0 014.572-5.217 4.887 4.887 0 015.219 4.588' fill='%23ced0d1'/%3e%3cpath d='M2217.42 1236.608a4.901 4.901 0 01-4.573 5.217c-2.7.181-5.037-1.889-5.217-4.588a4.91 4.91 0 014.572-5.217 4.887 4.887 0 015.219 4.588z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2251.817 1243.895c-6.117 1.08-23.9-21.832-25.52-3.029 2.43-.18 9.896-2.039 12.116.091 5.817 5.606-5.849 4.167-5.999 6.056-.328 4.17 1.155 8.187 6.45 8.548 9.01.6 2.052-6.298 4.556-9.297.15-.15-.404-.42-.45-.51 4.215 1.56 6.148-.06 8.818-2.099' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1930.684 1572.054l3.628 2.893-24.95 31.264-3.629-2.894z' fill='%23ced0d1'/%3e%3cpath d='M1930.684 1572.054l3.628 2.893-24.95 31.264-3.629-2.894z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2234.273 1260.598c-2.442-2.488-4.557-4.438-5.517-8.155-3.569 4.946-10.542 2.907-11.8-3.57-.72 1.38-2.205 2.85-2.789 4.2 7.631-13.376-13.465-4.11-13.51 4.288-.046 12.654 18.787 6.416 12.041-3.63 5.503 1.86 16.267 13.166 21.575 6.867' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1944.104 1565.23l-10.062 12.057-5.202-4.32 11.41-15.203z' fill='%23ced0d1'/%3e%3cpath d='M1944.104 1565.23l-10.062 12.057-5.202-4.32 11.41-15.203z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1956.293 1577.362c-.944-4.56-3.732-9.581.751-16.09 4.497-6.522-3.75-17.663-6.478-19.791-2.729-2.13-12.04 13.763-12.04 13.763s-3.915 3.375 5.757 12.566l-36.825 45.912 2.158 44.369-60.712 103.386 79.471-101.526-2.476-41.235 29.69-36.392s1.395-1.68.704-4.962' fill='%23ced0d1'/%3e%3cpath d='M1956.293 1577.362c-.944-4.56-3.732-9.581.751-16.09 4.497-6.522-3.75-17.663-6.478-19.791-2.729-2.13-12.04 13.763-12.04 13.763s-3.915 3.375 5.757 12.566l-36.825 45.912 2.158 44.369-60.712 103.386 79.471-101.526-2.476-41.235 29.69-36.392s1.395-1.68.704-4.962z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1935.691 1578.501l5.593 6.583-27.559 33.813m14.65 41.053c-5.534 2.445-12.91 4.484-18.758-1.858m16.283-39.376c-3 1.485-8.426 5.474-18.442-4.993' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2271.31 1149.46c3.208-.238 6.433.03 9.507.9l-1.26 4.468c-10.797-3.027-23.81 2.52-29.015 12.416-5.203 9.927-1.139 21.473 11.157 31.668l-2.97 3.569c-20.077-16.673-15.294-31.698-12.295-37.396 4.693-8.907 14.725-14.873 24.875-15.624' fill='%23ced0d1'/%3e%3cpath d='M2271.31 1149.46c3.208-.238 6.433.03 9.507.9l-1.26 4.468c-10.797-3.027-23.81 2.52-29.015 12.416-5.203 9.927-1.139 21.473 11.157 31.668l-2.97 3.569c-20.077-16.673-15.294-31.698-12.295-37.396 4.693-8.907 14.725-14.873 24.875-15.624z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2273.005 1181.368c-2.46-5.246-6.028-11.454-13.81-11.664 5.547-1.95 12.52-5.61 17.035 2.879 4.527 8.457-3.225 8.785-3.225 8.785' fill='%23ced0d1'/%3e%3cpath d='M2273.005 1181.368c-2.46-5.246-6.028-11.454-13.81-11.664 5.547-1.95 12.52-5.61 17.035 2.879 4.527 8.457-3.225 8.785-3.225 8.785z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2399.151 1032.894c-17.408 26.93-34.097 53.021-40.289 63.577-6.208 10.585-24.786 32.327-39.66 41.114-14.889 8.817-15.474 21.651-17.889 30.98-2.414 9.325-8.02 48.58-23.315 62.165-15.31 13.555-9.326-.09-22.148 15.624-12.804 15.714-238.455 291.603-238.455 291.603l-11.469-7.888 209.785-269.829-.285-3.87s41.58-46.602 41.94-52.09c.375-5.457 4.182-6.508 6.206-10.557 2.025-4.017 13.406-18.082 13.347-39.824-.077-21.773 11.515-22.64 14.08-29.809 2.563-7.198 41.097-105.02 48.835-126.102 11.666 10.496 59.317 34.906 59.317 34.906' fill='%23473125'/%3e%3cpath d='M2399.151 1032.894c-17.408 26.93-34.097 53.021-40.289 63.577-6.208 10.585-24.786 32.327-39.66 41.114-14.889 8.817-15.474 21.651-17.889 30.98-2.414 9.325-8.02 48.58-23.315 62.165-15.31 13.555-9.326-.09-22.148 15.624-12.804 15.714-238.455 291.603-238.455 291.603l-11.469-7.888 209.785-269.829-.285-3.87s41.58-46.602 41.94-52.09c.375-5.457 4.182-6.508 6.206-10.557 2.025-4.017 13.406-18.082 13.347-39.824-.077-21.773 11.515-22.64 14.08-29.809 2.563-7.198 41.097-105.02 48.835-126.102 11.666 10.496 59.317 34.906 59.317 34.906z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M2335.651 1009.083c1.784-4.677 3.223-8.486 4.183-11.095 11.666 10.496 59.317 34.907 59.317 34.907-3.328 5.159-6.657 10.286-9.866 15.295-33.737-20.093-53.634-39.107-53.634-39.107' fill='%23f0e53c'/%3e%3cpath d='M2335.651 1009.083c1.784-4.677 3.223-8.486 4.183-11.095 11.666 10.496 59.317 34.907 59.317 34.907-3.328 5.159-6.657 10.286-9.866 15.295-33.737-20.093-53.634-39.107-53.634-39.107z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2389.285 1048.19c3.209-5.01 6.538-10.137 9.866-15.296 0 0-18.262-9.355-34.952-18.982.84 5.968 12.94 15.414 15.43 17.573 2.489 2.13 4.033 5.49 4.273 8.667.24 3.18 5.383 8.037 5.383 8.037' fill='%23ced0d1'/%3e%3cpath d='M2389.285 1048.19c3.209-5.01 6.538-10.137 9.866-15.296 0 0-18.262-9.355-34.952-18.982.84 5.968 12.94 15.414 15.43 17.573 2.489 2.13 4.033 5.49 4.273 8.667.24 3.18 5.383 8.037 5.383 8.037z' fill='none' stroke='%23272425' stroke-width='1.549'/%3e%3cpath d='M2268.055 1212.047l-5.022-4.829-45.404 57.85 4.065 5.847z' fill='%23ced0d1'/%3e%3cpath d='M2268.055 1212.047l-5.022-4.829-45.404 57.85 4.065 5.847z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2260.709 1240.866l4.094 4.049-249.941 307.676-3-5.474z' fill='%23ced0d1'/%3e%3cpath d='M2260.709 1240.866l4.094 4.049-249.941 307.676-3-5.474z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2174.942 1310.35c-1.11-.93-1.29-2.519-.435-3.538l6.416-7.528c.872-1.02 2.46-1.08 3.57-.12l21.547 18.352c1.11.931 1.303 2.521.434 3.54l-6.418 7.526c-.853 1.02-2.458 1.081-3.568.121z' fill='%23ced0d1'/%3e%3cpath d='M2174.942 1310.35c-1.11-.93-1.29-2.519-.435-3.538l6.416-7.528c.872-1.02 2.46-1.08 3.57-.12l21.547 18.352c1.11.931 1.303 2.521.434 3.54l-6.418 7.526c-.853 1.02-2.458 1.081-3.568.121z' fill='none' stroke='black' stroke-width='1.262'/%3e%3cpath d='M2087.584 1422.125c-1.02-.869-1.124-2.383-.27-3.404l6.417-7.512c.871-1.019 2.385-1.154 3.39-.299l19.657 16.748a2.422 2.422 0 01.27 3.405l-6.418 7.526a2.401 2.401 0 01-3.388.284z' fill='%23ced0d1'/%3e%3cpath d='M2087.584 1422.125c-1.02-.869-1.124-2.383-.27-3.404l6.417-7.512c.871-1.019 2.385-1.154 3.39-.299l19.657 16.748a2.422 2.422 0 01.27 3.405l-6.418 7.526a2.401 2.401 0 01-3.388.284z' fill='none' stroke='black' stroke-width='1.205'/%3e%3cpath d='M2223.568 1257.84c.165 2.28-1.544 4.26-3.809 4.408-2.279.18-4.257-1.53-4.437-3.808-.166-2.28 1.543-4.26 3.808-4.409 2.278-.179 4.257 1.53 4.438 3.808' fill='%23ced0d1'/%3e%3cpath d='M2223.568 1257.84c.165 2.28-1.544 4.26-3.809 4.408-2.279.18-4.257-1.53-4.437-3.808-.166-2.28 1.543-4.26 3.808-4.409 2.278-.179 4.257 1.53 4.438 3.808z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2275.824 1215.586a4.912 4.912 0 01-4.528 5.277c-2.7.18-5.053-1.829-5.264-4.528-.195-2.699 1.829-5.068 4.528-5.248 2.715-.21 5.069 1.8 5.264 4.5' fill='%23ced0d1'/%3e%3cpath d='M2275.824 1215.586a4.912 4.912 0 01-4.528 5.277c-2.7.18-5.053-1.829-5.264-4.528-.195-2.699 1.829-5.068 4.528-5.248 2.715-.21 5.069 1.8 5.264 4.5z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2310.264 1222.603c-6.086 1.11-24.08-21.622-25.534-2.788 2.43-.21 9.881-2.16 12.114-.03 5.864 5.547-5.802 4.227-5.937 6.087-.299 4.168 1.214 8.187 6.522 8.517 9.012.51 1.995-6.328 4.484-9.357.135-.15-.42-.419-.465-.48 4.228 1.5 6.132-.12 8.802-2.22' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1991.981 1553.506l3.657 2.878-24.68 31.474-3.659-2.865z' fill='%23ced0d1'/%3e%3cpath d='M1991.981 1553.506l3.657 2.878-24.68 31.474-3.659-2.865z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2292.887 1239.458c-2.475-2.49-4.604-4.41-5.593-8.127-3.522 4.978-10.525 2.998-11.844-3.45-.706 1.38-2.174 2.879-2.745 4.228 7.527-13.463-13.494-4.018-13.465 4.409.06 12.656 18.847 6.238 12.01-3.748 5.519 1.829 16.374 13.015 21.637 6.688' fill='%23ced0d1' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2005.356 1546.578l-9.973 12.13-5.248-4.273 11.292-15.279z' fill='%23ced0d1'/%3e%3cpath d='M2005.356 1546.578l-9.973 12.13-5.248-4.273 11.292-15.279z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2017.637 1558.604c-.99-4.543-3.81-9.552.614-16.104 4.439-6.553-3.914-17.619-6.657-19.717-2.744-2.115-11.906 13.853-11.906 13.853s-3.883 3.405 5.862 12.507l-36.435 46.242 2.533 44.338-59.812 103.926 78.6-102.217-2.833-41.218 29.374-36.648s1.379-1.693.66-4.962' fill='%23ced0d1'/%3e%3cpath d='M2017.637 1558.604c-.99-4.543-3.81-9.552.614-16.104 4.439-6.553-3.914-17.619-6.657-19.717-2.744-2.115-11.906 13.853-11.906 13.853s-3.883 3.405 5.862 12.507l-36.435 46.242 2.533 44.338-59.812 103.926 78.6-102.217-2.833-41.218 29.374-36.648s1.379-1.693.66-4.962z' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M1997.048 1559.923l5.638 6.538-27.244 34.037m14.994 40.934c-5.518 2.49-12.865 4.59-18.789-1.709m15.955-39.509c-2.983 1.514-8.382 5.547-18.488-4.829' fill='none' stroke='black' stroke-width='1.549'/%3e%3cpath d='M2297.76 1614.533c-6.658-7.362-72.393-82.364-93.385-125.803-4.964-10.241 8.966-15.698 12.91-6.463 6.703 15.745 48.521 79.112 89.531 125.083z' fill='%23473125'/%3e%3cpath d='M2297.76 1614.533c-6.658-7.362-72.393-82.364-93.385-125.803-4.964-10.241 8.966-15.698 12.91-6.463 6.703 15.745 48.521 79.112 89.531 125.083z' fill='none' stroke='black' stroke-width='1.025'/%3e%3cpath d='M2285.555 1619.87c-1.936 3.448-4.244 15.115 2.684 25.371 6.912 10.255 14.44 13.15 22.207 11.771.478-7.797-.302-11.38 10.735-19.328 11.021-7.947 18.967-9.357 21.786-9.237 2.82.135 11.036 1.89 17.424 6.673 3.464-3.464 8.202-22.94-2.684-39.6-10.9-16.66-31.668-22.686-45.882-17.5 3.583 3.524 10.885 15.055-.78 28.776-5.353 6.192-10.378 11.02-10.378 11.02s-8.71 7.302-15.112 2.054' fill='%23ced0d1'/%3e%3cpath d='M2285.555 1619.87c-1.936 3.448-4.244 15.115 2.684 25.371 6.912 10.255 14.44 13.15 22.207 11.771.478-7.797-.302-11.38 10.735-19.328 11.021-7.947 18.967-9.357 21.786-9.237 2.82.135 11.036 1.89 17.424 6.673 3.464-3.464 8.202-22.94-2.684-39.6-10.9-16.66-31.668-22.686-45.882-17.5 3.583 3.524 10.885 15.055-.78 28.776-5.353 6.192-10.378 11.02-10.378 11.02s-8.71 7.302-15.112 2.054z' fill='none' stroke='black' stroke-width='1.025'/%3e%3cpath d='M2310.415 1657.416c-.135-5.381-4.363-11.53 11.276-22.296 15.624-10.766 27.424-10.256 38.7 0-6.912-4.363-17.423-9.492-31.533-.135-14.094 9.357-11.395 8.338-11.395 8.338-2.954 2.309-6.028 3.328-7.048 14.093' fill='%23ced0d1'/%3e%3cpath d='M2310.415 1657.416c-.135-5.381-4.363-11.53 11.276-22.296 15.624-10.766 27.424-10.256 38.7 0-6.912-4.363-17.423-9.492-31.533-.135-14.094 9.357-11.395 8.338-11.395 8.338-2.954 2.309-6.028 3.328-7.048 14.093z' fill='none' stroke='black' stroke-width='1.025'/%3e%3cpath d='M2316.743 1644.792l-21.262-27.995c-1.604-2.115.225-6.208 4.094-9.147 3.853-2.923 8.29-3.584 9.896-1.47l21.262 27.98z' fill='%23ced0d1'/%3e%3cpath d='M2316.743 1644.792l-21.262-27.995c-1.604-2.115.225-6.208 4.094-9.147 3.853-2.923 8.29-3.584 9.896-1.47l21.262 27.98z' fill='none' stroke='black' stroke-width='1.025'/%3e%3cpath d='M2330.733 1634.16c-1.604-2.114-6.043-1.44-9.897 1.485-3.868 2.94-5.698 7.032-4.093 9.146 1.604 2.115 6.043 1.44 9.896-1.485 3.868-2.938 5.697-7.032 4.094-9.146' fill='%23ced0d1'/%3e%3cpath d='M2330.733 1634.16c-1.604-2.114-6.043-1.44-9.897 1.485-3.868 2.94-5.698 7.032-4.093 9.146 1.604 2.115 6.043 1.44 9.896-1.485 3.868-2.938 5.697-7.032 4.094-9.146z' fill='none' stroke='black' stroke-width='1.025'/%3e%3cpath d='M2329.457 1638.314c-1.048-1.77-3.776-2.083-6.072-.72-2.324 1.365-3.343 3.898-2.294 5.669 1.05 1.768 4.018 2.533 6.328 1.168 2.309-1.363 3.073-4.348 2.038-6.117' fill='%23473125'/%3e%3cpath d='M2329.457 1638.314c-1.048-1.77-3.776-2.083-6.072-.72-2.324 1.365-3.343 3.898-2.294 5.669 1.05 1.768 4.018 2.533 6.328 1.168 2.309-1.363 3.073-4.348 2.038-6.117z' fill='none' stroke='black' stroke-width='1.025'/%3e%3cpath d='M1958.693 1599.268c6.252 2.25 19.388 11.2 26.72 21.232 7.333 10.032 2.954 14.185-5.218 12.475-8.17-1.708-17.094-10.944-18.503-14.018-1.41-3.06-2.999-19.69-2.999-19.69'/%3e%3cpath d='M1958.693 1599.268c6.252 2.25 19.388 11.2 26.72 21.232 7.333 10.032 2.954 14.185-5.218 12.475-8.17-1.708-17.094-10.944-18.503-14.018-1.41-3.06-2.999-19.69-2.999-19.69z' fill='none' stroke='black' stroke-width='.595'/%3e%3cpath d='M1953.82 1605.16l41.865-48.821' fill='white' stroke='%23473125' stroke-width='19.521'/%3e%3cpath d='M1929.53 1559.264c-1.53 2.323-7.333 7.376-9.252 9.911-1.92 2.533-10.106 13-9.446 25.94.644 12.94.868 17.574.764 22.971-.104 5.398-4.393 23.796 7.003 33.423 11.395 9.641 17.768 13.705 36.33 11.86 18.579-1.86 32.869-11.202 21.743-23.105 1.589-2.775 3.838-6.06 9.07-7.063-4.347-.81-16.628-5.639-18.892-12.82-2.263-7.198-3.103-22.508-3.84-26.796-.733-4.303-2.967-18.428-14.482-25.91-11.5-7.467-15.64-5.623-18.998-8.41' fill='%23d32011'/%3e%3cpath d='M1929.53 1559.264c-1.53 2.323-7.333 7.376-9.252 9.911-1.92 2.533-10.106 13-9.446 25.94.644 12.94.868 17.574.764 22.971-.104 5.398-4.393 23.796 7.003 33.423 11.395 9.641 17.768 13.705 36.33 11.86 18.579-1.86 32.869-11.202 21.743-23.105 1.589-2.775 3.838-6.06 9.07-7.063-4.347-.81-16.628-5.639-18.892-12.82-2.263-7.198-3.103-22.508-3.84-26.796-.733-4.303-2.967-18.428-14.482-25.91-11.5-7.467-15.64-5.623-18.998-8.41z' fill='none' stroke='black' stroke-width='.595'/%3e%3cg clip-path='url(%23T)' opacity='.5'%3e%3cpath d='M1976.672 1640.264c1.425 1.514 2.414 2.999 3.058 4.422-6.163-4.29-18.982-11.365-25.37-9.131-7.437 2.579-15.714 9.252-21.457 4.647 3.225-.3 17.438-1.98 4.258-17.422 4.634 4.933 21.562 18.967 31.144.42 1.244 1.739 3.028 3.283 5.007 4.618-3.987.959-8.471 2.803-7.841 5.203.764 2.894 8.187 4.768 13.9 3.509-1.155 1.184-1.994 2.504-2.7 3.734'/%3e%3c/g%3e%3cg clip-path='url(%23U)' opacity='.33'%3e%3cpath d='M1913.2 1606.12c.42-5.157 7.153-30.167 21.412-31.562 14.246-1.396 18.488 7.782 21.398 12.476-1.664-7.978-7.573-17.919-23.887-15.1-16.314 2.82-19.417 22.611-19.642 23.931-.24 1.32.72 10.255.72 10.255'/%3e%3c/g%3e%3cpath d='M2386.856 1113.564c-4.843 5.338-4.453 13.585.884 18.443 5.34 4.83 13.586 4.44 18.428-.9 4.844-5.308 4.455-13.585-.884-18.412-5.337-4.859-13.584-4.44-18.428.87' fill='%23f0e53c'/%3e%3cpath d='M2386.856 1113.564c-4.843 5.338-4.453 13.585.884 18.443 5.34 4.83 13.586 4.44 18.428-.9 4.844-5.308 4.455-13.585-.884-18.412-5.337-4.859-13.584-4.44-18.428.87z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cpath d='M2006.555 1606.646s371.05-381.853 391.862-403.266c20.798-21.381 8.818-63.725-5.668-76.891-14.483-13.165-57.788-21.021-77.086 1.74-19.297 22.76-363.837 428.695-363.837 428.695z' fill='%23f0e53c'/%3e%3cpath d='M2006.555 1606.646s371.05-381.853 391.862-403.266c20.798-21.381 8.818-63.725-5.668-76.891-14.483-13.165-57.788-21.021-77.086 1.74-19.297 22.76-363.837 428.695-363.837 428.695z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cpath d='M2334.196 1272.655a4.18 4.18 0 01-2.323-5.458c2.444-6.09-16.57-32.118-28.175-42.675-11.62-10.526-39.361-26.96-45.163-23.93-2.07 1.049-4.604.27-5.668-1.8a4.213 4.213 0 011.8-5.667c13.734-7.108 49.99 20.962 54.669 25.19 4.678 4.258 36.091 37.665 30.302 52.03a4.182 4.182 0 01-5.442 2.31' fill='%23f0e53c'/%3e%3cpath d='M2334.196 1272.655a4.18 4.18 0 01-2.323-5.458c2.444-6.09-16.57-32.118-28.175-42.675-11.62-10.526-39.361-26.96-45.163-23.93-2.07 1.049-4.604.27-5.668-1.8a4.213 4.213 0 011.8-5.667c13.734-7.108 49.99 20.962 54.669 25.19 4.678 4.258 36.091 37.665 30.302 52.03a4.182 4.182 0 01-5.442 2.31z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2344.811 1263.688a5.617 5.617 0 01-1.889-7.198c-.075-5.638-15.653-27.529-30.767-41.265-15.115-13.734-38.402-27.14-44.039-26.659a5.573 5.573 0 01-7.332-1.23c-1.95-2.398-1.574-5.907.824-7.857 13.39-10.855 57.64 27.08 58.06 27.471.434.39 42.416 40.783 32.896 55.15a5.591 5.591 0 01-7.753 1.588' fill='%23f0e53c'/%3e%3cpath d='M2344.811 1263.688a5.617 5.617 0 01-1.889-7.198c-.075-5.638-15.653-27.529-30.767-41.265-15.115-13.734-38.402-27.14-44.039-26.659a5.573 5.573 0 01-7.332-1.23c-1.95-2.398-1.574-5.907.824-7.857 13.39-10.855 57.64 27.08 58.06 27.471.434.39 42.416 40.783 32.896 55.15a5.591 5.591 0 01-7.753 1.588z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2393.243 1213.306c-2.383-1.919-2.833-5.428-.93-7.826 6.583-8.368-1.647-31.789-24.005-52.09-22.341-20.304-46.453-26.24-54.13-18.895a5.603 5.603 0 01-7.901-.179c-2.145-2.218-2.07-5.758.164-7.916 13.54-12.956 43.379-4.918 69.395 18.712 26.014 23.631 36.886 52.57 25.265 67.295-1.905 2.4-5.428 2.818-7.858.9' fill='%23f0e53c'/%3e%3cpath d='M2393.243 1213.306c-2.383-1.919-2.833-5.428-.93-7.826 6.583-8.368-1.647-31.789-24.005-52.09-22.341-20.304-46.453-26.24-54.13-18.895a5.603 5.603 0 01-7.901-.179c-2.145-2.218-2.07-5.758.164-7.916 13.54-12.956 43.379-4.918 69.395 18.712 26.014 23.631 36.886 52.57 25.265 67.295-1.905 2.4-5.428 2.818-7.858.9z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2383.392 1221.553c-1.725-1.559-1.92-4.139-.359-5.848 1.978-3.689-1.32-27.949-25.76-50.17-24.306-22.073-48.658-23.123-52.346-20.842-1.574 1.59-4.138 1.65-5.803.148-1.71-1.558-1.845-4.226-.285-5.937 6.598-7.256 37.471-3.719 64.072 20.422 26.6 24.171 33.078 54.55 26.464 61.836-1.545 1.711-4.273 1.92-5.983.391' fill='%23f0e53c'/%3e%3cpath d='M2383.392 1221.553c-1.725-1.559-1.92-4.139-.359-5.848 1.978-3.689-1.32-27.949-25.76-50.17-24.306-22.073-48.658-23.123-52.346-20.842-1.574 1.59-4.138 1.65-5.803.148-1.71-1.558-1.845-4.226-.285-5.937 6.598-7.256 37.471-3.719 64.072 20.422 26.6 24.171 33.078 54.55 26.464 61.836-1.545 1.711-4.273 1.92-5.983.391z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2321.915 1281.62l7.214-13.703-13.136 1.29 6.447-14.906-14.558.63 4.424-14.874-14.215 2.758 3.253-15.683-15.325 4.738 1.41-14.424-14.395 5.847-.778-14.574-14.216 7.856.029-13.195-12.97 8.488' fill='none' stroke='%23473125' stroke-width='2.796' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2366.48 1235.23l7.106-13.797-13.359 1.08 6.327-15.024-14.845.39 4.274-15.055-14.485 2.55 3.09-15.864-15.505 4.588 1.154-14.635-14.559 5.668-1.05-14.785-14.348 7.708-.21-13.375-13.046 8.366' fill='none' stroke='%23473125' stroke-width='2.844' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2017.98 1598.414a4.191 4.191 0 01-2.325-5.458c2.835-7.033-6.866-24.41-16.493-33.153-9.64-8.757-27.859-16.748-34.59-13.256-2.056 1.081-4.605.271-5.655-1.784a4.194 4.194 0 011.784-5.652c12.506-6.493 35.252 6.448 44.1 14.47 8.846 8.037 23.901 29.448 18.637 42.508a4.187 4.187 0 01-5.458 2.325' fill='%23f0e53c'/%3e%3cpath d='M2017.98 1598.414a4.191 4.191 0 01-2.325-5.458c2.835-7.033-6.866-24.41-16.493-33.153-9.64-8.757-27.859-16.748-34.59-13.256-2.056 1.081-4.605.271-5.655-1.784a4.194 4.194 0 011.784-5.652c12.506-6.493 35.252 6.448 44.1 14.47 8.846 8.037 23.901 29.448 18.637 42.508a4.187 4.187 0 01-5.458 2.325z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2034.354 1581.966c-2.159-.855-3.194-3.313-2.323-5.458 2.653-6.615-7.753-24.112-17.829-33.274-10.076-9.146-28.489-17.827-34.818-14.543-2.052 1.064-4.603.268-5.652-1.8-1.079-2.054-.27-4.574 1.785-5.654 12.116-6.283 34.846 7.183 44.322 15.79 9.477 8.606 25.056 29.943 19.958 42.613-.854 2.145-3.298 3.18-5.443 2.325' fill='%23f0e53c'/%3e%3cpath d='M2034.354 1581.966c-2.159-.855-3.194-3.313-2.323-5.458 2.653-6.615-7.753-24.112-17.829-33.274-10.076-9.146-28.489-17.827-34.818-14.543-2.052 1.064-4.603.268-5.652-1.8-1.079-2.054-.27-4.574 1.785-5.654 12.116-6.283 34.846 7.183 44.322 15.79 9.477 8.606 25.056 29.943 19.958 42.613-.854 2.145-3.298 3.18-5.443 2.325z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2026.303 1585.549l3.628-11.816-7.241.675 3.852-9.417-8.71.585 3.134-10.376-9.913.286 1.665-10.603-10.406 2.67-.66-9.897-10.031 4.109-.255-8.726-8.996 4.739-.031-7.274-11.41 4.754' fill='none' stroke='%23473125' stroke-width='2.844' stroke-linecap='round' stroke-linejoin='round'/%3e%3cg clip-path='url(%23V)' opacity='.33'%3e%3cpath d='M1987.932 1568.005s329.53-381.478 350.432-404.509c20.917-23.032 33.197-19.793 50.98-18.714-9.52-9.267-37.41-23.271-66.079 8.308-28.654 31.547-349.967 407.103-349.967 407.103z' fill='%23473125'/%3e%3c/g%3e%3cg clip-path='url(%23W)' opacity='.67'%3e%3cpath d='M2362.685 1185.567l-328.916 350.695c-3.704 3.944-3.493 10.137.45 13.825.031.044.075.075.106.104 3.958 3.584 10.06 3.36 13.718-.554l324.343-346.258c3.704-3.927 3.778-10.075-.165-13.793-.044-.03-5.877-7.917-9.536-4.019' fill='white'/%3e%3c/g%3e%3cpath d='M2006.42 1607.425c6.822-7.513-.044-24.86-15.325-38.746-15.294-13.885-33.21-19.058-40.05-11.545-6.822 7.527.046 24.875 15.325 38.76 15.295 13.885 33.213 19.058 40.05 11.531' fill='white'/%3e%3cpath d='M2006.42 1607.425c6.822-7.513-.044-24.86-15.325-38.746-15.294-13.885-33.21-19.058-40.05-11.545-6.822 7.527.046 24.875 15.325 38.76 15.295 13.885 33.213 19.058 40.05 11.531z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cpath d='M1998.894 1600.602c4.723-5.187-.481-17.602-11.622-27.724-11.141-10.106-23.975-14.095-28.698-8.906-4.723 5.203.494 17.603 11.62 27.71 11.14 10.121 23.99 14.108 28.7 8.92' fill='%23f0e53c'/%3e%3cpath d='M1998.894 1600.602c4.723-5.187-.481-17.602-11.622-27.724-11.141-10.106-23.975-14.095-28.698-8.906-4.723 5.203.494 17.603 11.62 27.71 11.14 10.121 23.99 14.108 28.7 8.92z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cg clip-path='url(%23X)' opacity='.33'%3e%3cpath d='M1978.006 1597.634l6.268 3.27 13.525-14.89-3.854-5.924z' fill='%23473125'/%3e%3c/g%3e%3cg clip-path='url(%23Y)' opacity='.67'%3e%3cpath d='M1973.567 1565.006s-6.462 8.606-8.621 11.666c-2.16 3.073.9 11.844 6.207 5.652 5.309-6.193 9.493-13.255 9.493-13.255z' fill='white'/%3e%3c/g%3e%3cpath d='M1865.114 1113.564c4.843 5.338 4.453 13.585-.886 18.443-5.337 4.83-13.584 4.44-18.428-.9-4.843-5.308-4.453-13.585.886-18.412 5.337-4.859 13.584-4.44 18.428.87' fill='%23f0e53c'/%3e%3cpath d='M1865.114 1113.564c4.843 5.338 4.453 13.585-.886 18.443-5.337 4.83-13.584 4.44-18.428-.9-4.843-5.308-4.453-13.585.886-18.412 5.337-4.859 13.584-4.44 18.428.87z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cpath d='M2245.415 1606.646s-371.05-381.853-391.863-403.266c-20.797-21.381-8.816-63.725 5.669-76.891 14.484-13.165 57.787-21.021 77.086 1.74 19.298 22.76 363.837 428.695 363.837 428.695z' fill='%23f0e53c'/%3e%3cpath d='M2245.415 1606.646s-371.05-381.853-391.863-403.266c-20.797-21.381-8.816-63.725 5.669-76.891 14.484-13.165 57.787-21.021 77.086 1.74 19.298 22.76 363.837 428.695 363.837 428.695z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cpath d='M1917.773 1272.655a4.181 4.181 0 002.325-5.458c-2.445-6.09 16.569-32.118 28.175-42.675 11.62-10.526 39.36-26.96 45.163-23.93 2.067 1.049 4.603.27 5.667-1.8a4.215 4.215 0 00-1.8-5.667c-13.734-7.108-49.99 20.962-54.67 25.19-4.677 4.258-36.09 37.665-30.301 52.03a4.181 4.181 0 005.44 2.31' fill='%23f0e53c'/%3e%3cpath d='M1917.773 1272.655a4.181 4.181 0 002.325-5.458c-2.445-6.09 16.569-32.118 28.175-42.675 11.62-10.526 39.36-26.96 45.163-23.93 2.067 1.049 4.603.27 5.667-1.8a4.215 4.215 0 00-1.8-5.667c-13.734-7.108-49.99 20.962-54.67 25.19-4.677 4.258-36.09 37.665-30.301 52.03a4.181 4.181 0 005.44 2.31z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M1907.157 1263.688a5.635 5.635 0 001.905-7.198c.06-5.638 15.638-27.529 30.753-41.265 15.115-13.734 38.401-27.14 44.04-26.659a5.573 5.573 0 007.331-1.23c1.95-2.398 1.574-5.907-.809-7.857-13.39-10.855-57.638 27.08-58.074 27.471-.435.39-42.419 40.783-32.897 55.15a5.589 5.589 0 007.751 1.588' fill='%23f0e53c'/%3e%3cpath d='M1907.157 1263.688a5.635 5.635 0 001.905-7.198c.06-5.638 15.638-27.529 30.753-41.265 15.115-13.734 38.401-27.14 44.04-26.659a5.573 5.573 0 007.331-1.23c1.95-2.398 1.574-5.907-.809-7.857-13.39-10.855-57.638 27.08-58.074 27.471-.435.39-42.419 40.783-32.897 55.15a5.589 5.589 0 007.751 1.588z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M1858.725 1213.306c2.385-1.919 2.834-5.428.931-7.826-6.583-8.368 1.649-31.789 24.006-52.09 22.34-20.304 46.453-26.24 54.13-18.895 2.234 2.13 5.787 2.04 7.901-.179 2.145-2.218 2.07-5.758-.164-7.916-13.541-12.956-43.379-4.918-69.395 18.712-26.015 23.631-36.87 52.57-25.265 67.295 1.905 2.4 5.427 2.818 7.856.9' fill='%23f0e53c'/%3e%3cpath d='M1858.725 1213.306c2.385-1.919 2.834-5.428.931-7.826-6.583-8.368 1.649-31.789 24.006-52.09 22.34-20.304 46.453-26.24 54.13-18.895 2.234 2.13 5.787 2.04 7.901-.179 2.145-2.218 2.07-5.758-.164-7.916-13.541-12.956-43.379-4.918-69.395 18.712-26.015 23.631-36.87 52.57-25.265 67.295 1.905 2.4 5.427 2.818 7.856.9z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M1868.576 1221.553c1.726-1.559 1.92-4.139.361-5.848-1.98-3.689 1.32-27.949 25.76-50.17 24.32-22.073 48.658-23.123 52.346-20.842 1.574 1.59 4.124 1.65 5.803.148 1.71-1.558 1.843-4.226.285-5.937-6.598-7.256-37.471-3.719-64.072 20.422-26.6 24.171-33.077 54.55-26.464 61.836 1.545 1.711 4.273 1.92 5.982.391' fill='%23f0e53c'/%3e%3cpath d='M1868.576 1221.553c1.726-1.559 1.92-4.139.361-5.848-1.98-3.689 1.32-27.949 25.76-50.17 24.32-22.073 48.658-23.123 52.346-20.842 1.574 1.59 4.124 1.65 5.803.148 1.71-1.558 1.843-4.226.285-5.937-6.598-7.256-37.471-3.719-64.072 20.422-26.6 24.171-33.077 54.55-26.464 61.836 1.545 1.711 4.273 1.92 5.982.391z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M1930.055 1281.62l-7.198-13.703 13.12 1.29-6.447-14.906 14.559.63-4.424-14.874 14.215 2.758-3.253-15.683 15.323 4.738-1.41-14.424 14.395 5.847.78-14.574 14.215 7.856-.03-13.195 12.97 8.488' fill='none' stroke='%23473125' stroke-width='2.796' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M1885.49 1235.23l-7.106-13.797 13.359 1.08-6.327-15.024 14.844.39-4.273-15.055 14.485 2.55-3.09-15.864 15.505 4.588-1.154-14.635 14.559 5.668 1.05-14.785 14.349 7.708.21-13.375 13.06 8.366' fill='none' stroke='%23473125' stroke-width='2.844' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2233.989 1598.414a4.187 4.187 0 002.323-5.458c-2.833-7.033 6.868-24.41 16.495-33.153 9.641-8.757 27.859-16.748 34.592-13.256 2.055 1.081 4.604.271 5.653-1.784 1.08-2.054.269-4.587-1.786-5.652-12.504-6.493-35.251 6.448-44.096 14.47-8.848 8.037-23.903 29.448-18.639 42.508a4.186 4.186 0 005.458 2.325' fill='%23f0e53c'/%3e%3cpath d='M2233.989 1598.414a4.187 4.187 0 002.323-5.458c-2.833-7.033 6.868-24.41 16.495-33.153 9.641-8.757 27.859-16.748 34.592-13.256 2.055 1.081 4.604.271 5.653-1.784 1.08-2.054.269-4.587-1.786-5.652-12.504-6.493-35.251 6.448-44.096 14.47-8.848 8.037-23.903 29.448-18.639 42.508a4.186 4.186 0 005.458 2.325z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2217.63 1581.966c2.145-.855 3.18-3.313 2.324-5.458-2.668-6.615 7.738-24.112 17.815-33.274 10.075-9.146 28.488-17.827 34.815-14.543 2.069 1.064 4.605.268 5.653-1.8 1.08-2.054.27-4.574-1.784-5.654-12.116-6.283-34.845 7.183-44.323 15.79-9.477 8.606-25.056 29.943-19.957 42.613.853 2.145 3.298 3.18 5.457 2.325' fill='%23f0e53c'/%3e%3cpath d='M2217.63 1581.966c2.145-.855 3.18-3.313 2.324-5.458-2.668-6.615 7.738-24.112 17.815-33.274 10.075-9.146 28.488-17.827 34.815-14.543 2.069 1.064 4.605.268 5.653-1.8 1.08-2.054.27-4.574-1.784-5.654-12.116-6.283-34.845 7.183-44.323 15.79-9.477 8.606-25.056 29.943-19.957 42.613.853 2.145 3.298 3.18 5.457 2.325z' fill='none' stroke='%23473125' stroke-width='1.398'/%3e%3cpath d='M2225.668 1585.549l-3.63-11.816 7.242.675-3.852-9.417 8.71.585-3.133-10.376 9.91.286-1.663-10.603 10.406 2.67.66-9.897 10.032 4.109.255-8.726 8.996 4.739.03-7.274 11.41 4.754' fill='none' stroke='%23473125' stroke-width='2.844' stroke-linecap='round' stroke-linejoin='round'/%3e%3cg clip-path='url(%23Z)' opacity='.33'%3e%3cpath d='M2264.038 1568.005s-329.53-381.478-350.432-404.509c-20.917-23.032-33.197-19.793-50.98-18.714 9.52-9.267 37.41-23.271 66.079 8.308 28.654 31.547 349.967 407.103 349.967 407.103z' fill='%23473125'/%3e%3c/g%3e%3cg clip-path='url(%23aa)' opacity='.67'%3e%3cpath d='M1889.284 1185.567l328.916 350.695c3.705 3.944 3.495 10.137-.45 13.825-.03.044-.074.075-.104.104-3.96 3.584-10.063 3.36-13.72-.554l-324.343-346.258c-3.704-3.927-3.777-10.075.165-13.793.045-.03 5.878-7.917 9.537-4.019' fill='white'/%3e%3c/g%3e%3cpath d='M2245.55 1607.425c-6.822-7.513.045-24.86 15.325-38.746 15.293-13.885 33.21-19.058 40.05-11.545 6.822 7.527-.046 24.875-15.325 38.76-15.294 13.885-33.213 19.058-40.05 11.531' fill='white'/%3e%3cpath d='M2245.55 1607.425c-6.822-7.513.045-24.86 15.325-38.746 15.293-13.885 33.21-19.058 40.05-11.545 6.822 7.527-.046 24.875-15.325 38.76-15.294 13.885-33.213 19.058-40.05 11.531z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cpath d='M2253.076 1600.602c-4.707-5.187.48-17.602 11.622-27.724 11.14-10.106 23.99-14.095 28.698-8.906 4.723 5.203-.478 17.603-11.62 27.71-11.14 10.121-23.975 14.108-28.7 8.92' fill='%23f0e53c'/%3e%3cpath d='M2253.076 1600.602c-4.707-5.187.48-17.602 11.622-27.724 11.14-10.106 23.99-14.095 28.698-8.906 4.723 5.203-.478 17.603-11.62 27.71-11.14 10.121-23.975 14.108-28.7 8.92z' fill='none' stroke='%23473125' stroke-width='2.097'/%3e%3cg clip-path='url(%23ab)' opacity='.33'%3e%3cpath d='M2273.964 1597.634l-6.268 3.27-13.525-14.89 3.855-5.924z' fill='%23473125'/%3e%3c/g%3e%3cg clip-path='url(%23ac)' opacity='.67'%3e%3cpath d='M2278.403 1565.006s6.463 8.606 8.621 11.666c2.16 3.073-.899 11.844-6.207 5.652-5.309-6.193-9.492-13.255-9.492-13.255z' fill='white'/%3e%3c/g%3e%3cpath d='M2267.231 1772.767s-4.483-1.095-5.232-6.267' fill='none' stroke='%23473125' stroke-width='2.068'/%3e%3cpath d='M2272.165 1772.648c0-1.184-1.215-2.144-2.73-2.144-1.514 0-2.73.96-2.73 2.144 0 1.185 1.216 2.145 2.73 2.145 1.515 0 2.73-.96 2.73-2.145' fill='%23d32011'/%3e%3cpath d='M2272.165 1772.648c0-1.184-1.215-2.144-2.73-2.144-1.514 0-2.73.96-2.73 2.144 0 1.185 1.216 2.145 2.73 2.145 1.515 0 2.73-.96 2.73-2.145z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2259.195 1770.744c-.45-1.095-1.95-1.514-3.345-.96-1.393.57-2.174 1.935-1.723 3.03.45 1.095 1.934 1.513 3.343.959 1.395-.57 2.174-1.92 1.725-3.03' fill='%23d32011'/%3e%3cpath d='M2259.195 1770.744c-.45-1.095-1.95-1.514-3.345-.96-1.393.57-2.174 1.935-1.723 3.03.45 1.095 1.934 1.513 3.343.959 1.395-.57 2.174-1.92 1.725-3.03z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2256.376 1822.384c-.45-1.095-1.935-1.529-3.344-.959-1.394.57-2.175 1.918-1.724 3.013.45 1.11 1.95 1.53 3.343.96 1.395-.57 2.175-1.919 1.725-3.014' fill='%23d32011'/%3e%3cpath d='M2256.376 1822.384c-.45-1.095-1.935-1.529-3.344-.959-1.394.57-2.175 1.918-1.724 3.013.45 1.11 1.95 1.53 3.343.96 1.395-.57 2.175-1.919 1.725-3.014z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2258.685 1822.054c.36-1.124 1.813-1.665 3.253-1.214 1.44.45 2.325 1.74 1.964 2.88-.36 1.122-1.813 1.663-3.253 1.213-1.439-.465-2.325-1.74-1.964-2.879' fill='%23d32011'/%3e%3cpath d='M2258.685 1822.054c.36-1.124 1.813-1.665 3.253-1.214 1.44.45 2.325 1.74 1.964 2.88-.36 1.122-1.813 1.663-3.253 1.213-1.439-.465-2.325-1.74-1.964-2.879z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2262.209 1725.146c-.45-1.095-1.95-1.529-3.344-.959s-2.175 1.92-1.724 3.027c.45 1.095 1.934 1.516 3.344.946 1.394-.57 2.174-1.919 1.724-3.014' fill='%23d32011'/%3e%3cpath d='M2262.209 1725.146c-.45-1.095-1.95-1.529-3.344-.959s-2.175 1.92-1.724 3.027c.45 1.095 1.934 1.516 3.344.946 1.394-.57 2.174-1.919 1.724-3.014z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2272.554 1725.206c.346-1.125-.525-2.414-1.964-2.864-1.44-.449-2.909.09-3.253 1.215-.36 1.14.524 2.414 1.964 2.88 1.44.45 2.894-.092 3.253-1.23' fill='%23d32011'/%3e%3cpath d='M2272.554 1725.206c.346-1.125-.525-2.414-1.964-2.864-1.44-.449-2.909.09-3.253 1.215-.36 1.14.524 2.414 1.964 2.88 1.44.45 2.894-.092 3.253-1.23z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2267.681 1723.766c-1.948-.224-3.493-1.784-3.673-3.732' fill='none' stroke='%23473125' stroke-width='2.068'/%3e%3cpath d='M2238.892 1655.363c.06-1.186-1.11-2.205-2.624-2.28-1.515-.075-2.774.84-2.835 2.01-.06 1.184 1.126 2.203 2.624 2.278 1.516.075 2.79-.824 2.835-2.008' fill='%23d32011'/%3e%3cpath d='M2238.892 1655.363c.06-1.186-1.11-2.205-2.624-2.28-1.515-.075-2.774.84-2.835 2.01-.06 1.184 1.126 2.203 2.624 2.278 1.516.075 2.79-.824 2.835-2.008z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2232.175 1670.34c-1.17-.103-2.25 1.036-2.385 2.536-.12 1.514.72 2.819 1.906 2.923 1.184.105 2.248-1.035 2.383-2.533.119-1.515-.718-2.82-1.904-2.925' fill='%23d32011'/%3e%3cpath d='M2232.175 1670.34c-1.17-.103-2.25 1.036-2.385 2.536-.12 1.514.72 2.819 1.906 2.923 1.184.105 2.248-1.035 2.383-2.533.119-1.515-.718-2.82-1.904-2.925z' fill='none' stroke='%23473125' stroke-width='.689'/%3e%3cpath d='M2224.482 1661.376c23.197 5.862 38.58 38.069 38.042 62.15-.825 36.152-2.52 66.186-5.188 91.81-.15 1.426-.27 2.835-.39 4.23-.406 4.559-.78 8.876-1.98 13.24l1.995.554c1.26-4.557 1.633-8.967 2.04-13.63.12-1.378.253-2.773.388-4.183 2.67-25.67 4.364-55.764 5.202-91.976.571-25.341-14.768-59.661-39.285-65.854z' fill='%2300702d'/%3e%3cpath d='M2224.482 1661.376c23.197 5.862 38.58 38.069 38.042 62.15-.825 36.152-2.52 66.186-5.188 91.81-.15 1.426-.27 2.835-.39 4.23-.406 4.559-.78 8.876-1.98 13.24l1.995.554c1.26-4.557 1.633-8.967 2.04-13.63.12-1.378.253-2.773.388-4.183 2.67-25.67 4.364-55.764 5.202-91.976.571-25.341-14.768-59.661-39.285-65.854z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2018.49 1651.314l10.106-1.604-9.596 24.65-3.269-22.58z' fill='%2300702d'/%3e%3cpath d='M2018.49 1651.314l10.106-1.604-9.596 24.65-3.269-22.58z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2002.402 1813.672c5.053 12.4 31.322 53.214 42.973 59.273-12.595 1.89-44.863-41.009-49-51.4' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2004.35 1835.67c5.384 19.972 25.087 37.154 37.458 42.283-10.361-13.12-23.617-27.874-30.214-43.319' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1997.108 1824.348c3.089 14.561 17.125 45.583 25.117 52.421-3.99-11.412-6.18-19.029-6.733-31.278' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1995.745 1814.122c3.178 17.768 13.719 32.493 31.442 37.262-14.14-10.572-27.02-32.539-28.698-50.008' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1988.786 1793.97c5.503 12.04 27.291 45.657 40.726 52.9-8.622-11.035-25.162-35.852-29.299-52.045' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1992.52 1787.583c-1.155 6.897-6.897 10.795 5.518 51.475.915-23.435.224-41.82-2.294-49.631m1.364.45c3 10.346 5.294 20.917 28.955 42.749-5.053-10.795-23.436-50.786-29.87-52.855' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1986.088 1759.782c-2.294 5.744-8.967 43.888 2.518 76.981.465-18.158 8.113-51.13 9.027-66.064' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1984.469 1738.176c-2.294 5.068-9.417 34.937-9.641 52.166 3.898-6.208 15.849-22.521 17.918-38.835 2.758 11.035-1.141 15.624 21.607 47.336-3.45-13.09-11.726-52.39-19.313-65.031' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1992.985 1728.295c-3.688 3.223-6.897 13.33-5.292 22.985 1.604 9.656 8.501 59.978 8.501 59.978 3.223-25.97 4.603-72.617 0-81.345' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1988.562 1696.597c-1.56 9.19-15.58 68.704-20.167 77.895 6.207-6.897 37.216-47.801 25.28-71.014' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2001.022 1685.786c-3.223 7.362-17.228 22.746-1.38 61.13-.464-20.451 1.38-61.13 1.38-61.13' fill='%2300702d'/%3e%3cpath d='M2001.022 1685.786c-3.223 7.362-17.228 22.746-1.38 61.13-.464-20.451 1.38-61.13 1.38-61.13z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1995.745 1679.818c-6.673 4.589-23.902 25.506-30.8 50.096 5.054-6.897 30.65-29.193 33.484-43.2' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2007.23 1664.884c-2.76 8.952-8.742 26.884-7.587 38.835 1.154 11.95 10.72 54.144 10.03 63.65 1.005-13.568 1.064-38.145 0-54.46-1.064-16.312.765-39.763 7.2-56.992l1.617-4.603-9.49 5.982z' fill='%2300702d'/%3e%3cpath d='M2007.23 1664.884c-2.76 8.952-8.742 26.884-7.587 38.835 1.154 11.95 10.72 54.144 10.03 63.65 1.005-13.568 1.064-38.145 0-54.46-1.064-16.312.765-39.763 7.2-56.992l1.617-4.603-9.49 5.982z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M1995.04 1682.577c-4.813 5.518-20.212 31.249-23.437 57.669 5.053-11.95 14.485-23.887 19.312-30.094 4.83-6.208 17.229-31.49 14.696-42.06z' fill='%2300702d'/%3e%3cpath d='M1995.04 1682.577c-4.813 5.518-20.212 31.249-23.437 57.669 5.053-11.95 14.485-23.887 19.312-30.094 4.83-6.208 17.229-31.49 14.696-42.06z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2019.855 1652.243c.24 8.967-3.209 42.044-3.674 51.927-.45 9.88.06 27.574-2.864 36.076-.12-5.968-4.379-29.614-3.899-39.511.466-9.911 2.864-40.214 6.54-45.972m-11.278 25.055c.016 6.658 4.56 25.266 4.95 32.388m-4.95-53.756c-4.813 7.813-29.389 39.286-36.286 47.788 5.518-3.21 28.954-13.09 44.923-48.476' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2037.098 1635.466c-8.037 2.533-48.25 22.52-66.634 52.165 14.933-12.64 46.647-33.784 61.581-37.683z' fill='%2300702d'/%3e%3cpath d='M2037.098 1635.466c-8.037 2.533-48.25 22.52-66.634 52.165 14.933-12.64 46.647-33.784 61.581-37.683z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2040.247 1625.584c-7.572.689-30.41 5.683-48.011 31.249 8.726-7.123 18.832-15.625 35.835-20.454' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2041.238 1631.102c-8.052 8.726-24.815 17.228-25.506 68.478 6.433-25.055 17.004-51.01 34.457-64.114z' fill='%2300702d'/%3e%3cpath d='M2041.238 1631.102c-8.052 8.726-24.815 17.228-25.506 68.478 6.433-25.055 17.004-51.01 34.457-64.114z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2043.996 1624.668c-11.037 4.59-35.987 21.533-46.483 34.083 11.547-7.437 33.619-18.458 45.554-23.286z' fill='%2300702d'/%3e%3cpath d='M2043.996 1624.668c-11.037 4.59-35.987 21.533-46.483 34.083 11.547-7.437 33.619-18.458 45.554-23.286z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2047.67 1629.258c-3.45 7.586-19.987 53.079-22.057 65.495 5.742-8.967 34.456-58.598 36.526-74.447 2.07-15.865 0-.93 0-.93z' fill='%2300702d'/%3e%3cpath d='M2047.67 1629.258c-3.45 7.586-19.987 53.079-22.057 65.495 5.742-8.967 34.456-58.598 36.526-74.447 2.07-15.865 0-.93 0-.93z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2023.543 1628.566c-5.982.931-28.144 8.054-34.98 23.213-1.336-4.364 4.646-25.972 43.018-31.473z' fill='%2300702d'/%3e%3cpath d='M2023.543 1628.566c-5.982.931-28.144 8.054-34.98 23.213-1.336-4.364 4.646-25.972 43.018-31.473z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2048.808 1615.477c-6.192-1.604-27.799-7.812-47.786 8.728 8.501-2.76 24.125-4.364 34.697-1.83z' fill='%2300702d'/%3e%3cpath d='M2048.808 1615.477c-6.192-1.604-27.799-7.812-47.786 8.728 8.501-2.76 24.125-4.364 34.697-1.83z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2060.758 1603.062c-5.741-1.14-22.97-3.449-32.161 8.501 6.896-3.209 16.088-3.898 25.97-.45z' fill='%2300702d'/%3e%3cpath d='M2060.758 1603.062c-5.741-1.14-22.97-3.449-32.161 8.501 6.896-3.209 16.088-3.898 25.97-.45z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2075.244 1595.715c-4.603-2.983-17.918-8.967-34.247-1.155 6.207-.225 15.639-.225 21.382 6.208z' fill='%2300702d'/%3e%3cpath d='M2075.244 1595.715c-4.603-2.983-17.918-8.967-34.247-1.155 6.207-.225 15.639-.225 21.382 6.208z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2097.076 1602.103c-2.07-5.01-17.244-18.338-45.958 3.269 10.106-.466 30.333-5.07 37.906-3.914m-37.217 12.64c-5.293-1.154-20.002-5.308-34.007 20.212 12.177-8.037 19.298-8.037 25.266-8.037' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2079.832 1604.682c-5.322-2.37-20.212-6.897-36.99 14.934 10.106-2.76 30.332-14.484 33.092-14.245' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2075.244 1607.89c-4.468-.674-33.857 8.982-40.44 23.212 10.796-5.294 27.335-12.641 36.076-16.553' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2097.076 1602.103c-5.292-2.715-25.746-1.634-35.732 9.432 11.83-2.954 17.349-3.644 25.61-2.49z' fill='%2300702d'/%3e%3cpath d='M2097.076 1602.103c-5.292-2.715-25.746-1.634-35.732 9.432 11.83-2.954 17.349-3.644 25.61-2.49z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2032.495 1642.362c2.684-5.354 10.347-22.056 31.338-25.64.571 4.692-9.805 12.684-15.938 15.984-6.134 3.298-10.602 5.218-15.4 9.656' fill='%2300702d'/%3e%3cpath d='M2032.495 1642.362c2.684-5.354 10.347-22.056 31.338-25.64.571 4.692-9.805 12.684-15.938 15.984-6.134 3.298-10.602 5.218-15.4 9.656z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2058.12 1624.205c5.398-8.503 18.263-23.047 32.283-16.344-2.07 2.564-7.347 4.498-12.865 5.143-5.518.63-19.417 11.2-19.417 11.2' fill='%2300702d'/%3e%3cpath d='M2058.12 1624.205c5.398-8.503 18.263-23.047 32.283-16.344-2.07 2.564-7.347 4.498-12.865 5.143-5.518.63-19.417 11.2-19.417 11.2z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2060.758 1633.17c.466 4.14-1.602 12.401-6.655 28.37-5.054 15.984-5.985 16.899-7.349 24.246-.928-6.432-1.617-34.922 3.435-45.493' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2071.33 1620.306c-.225 3.673-22.147 32.402-23.66 44.113.45-13.33-2.339-36.932 22.101-48.747' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2067.657 1622.375c-.69 10.106-2.07 19.522-5.519 28.024-3.447 8.502-6.88 13.105-7.121 25.28 4.603-11.26 26.03-54.07 33.602-63.486' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2075.933 1632.015c-.689 6.208-4.362 26.196-7.812 34.008 5.744-6.883 22.911-36.242 25.67-43.363' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2082.367 1626.962c-.227 5.744-1.036 17.005-3.165 24.817 4.32-8.277 7.302-11.486 11.201-16.314 3.914-4.829 12.642-17.814 9.882-22.461' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2056.636 1629.032c4.229-3.33 13.646-5.968 18.608-7.812 4.574-1.694 14.244-5.743 12.641-8.726-1.62-3-10.691-.96-15.174 1.14-4.484 2.098-16.075 15.398-16.075 15.398' fill='%2300702d'/%3e%3cpath d='M2056.636 1629.032c4.229-3.33 13.646-5.968 18.608-7.812 4.574-1.694 14.244-5.743 12.641-8.726-1.62-3-10.691-.96-15.174 1.14-4.484 2.098-16.075 15.398-16.075 15.398z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2097.526 1615.178c.48-2.805-10.707-5.008-15.16 0-4.454 5.007-8.097 13.165-10.017 21.667-1.933 8.5-4.228 16.089-5.833 18.847 4.125-4.378 7.693-12.19 12.686-20.226 5.01-8.038 17.635-16.225 18.324-20.288' fill='%2300702d'/%3e%3cpath d='M2097.526 1615.178c.48-2.805-10.707-5.008-15.16 0-4.454 5.007-8.097 13.165-10.017 21.667-1.933 8.5-4.228 16.089-5.833 18.847 4.125-4.378 7.693-12.19 12.686-20.226 5.01-8.038 17.635-16.225 18.324-20.288z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2261.835 1777.417c3.898 3.448 9.43 3.524 13.419 6.687-.57.12-1.305-.135-1.844.06 2.008 1.545 4.529 4.018 5.472 6.672-.224.24-1.11 0-1.35.225 1.515 1.635 2.699 3.973 3.75 5.968-.496.21-1.185-.164-1.68.06.765 2.744.975 5.968.12 8.743-2.803.059-5.292-1.036-7.047-3.194-.075.674.119 1.394.164 1.979-3.283-.571-6.072-2.834-6.866-6.103a9.962 9.962 0 00-.555 2.114c-1.89-2.37-2.7-5.503-2.595-8.546-.39.614-.57 1.303-.808 1.993-2.026-5.592 2.308-11.935-.526-16.658' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2269.405 1802.066c0-3.389-.135-6.972.106-10.255 2.294 1.678 5.233 2.19 7.602 3.704m.12 6.431c-2.985-2.039-5.639-5.067-7.139-8.382' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2264.937 1794.36c1.8-2.923 1.71-6.583 1.306-9.822 2.502 2.73 6.267 2.849 9.026 4.888m-5.757 2.385c-.646-1.17-1.8-3.929-2.28-5.144m-.989-2.129c-.676-1.378-2.551-4.198-3.615-5.217' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2257.861 1821.98c-5.489 3.553-17.71 6.852-19.733 14.02.18.225 1.05.21 1.334.48-2.82 2.052-5.233 4.917-5.218 8.53.495.27 1.005-.255 1.514.015-1.274 2.984-1.514 6.36-1.454 9.672 2.788-.884 5.503-2.519 7.407-4.694.015.705-.09 1.441-.15 2.16 1.56-1.575 3.51-2.55 5.038-4.123.061.645-.194 1.334-.15 1.98 2.175-1.455 4.14-3.66 5.368-6.074.21.39-.045 1.004.031 1.514 6.701-4.962 4.587-13.84 5.053-21.156' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2237.347 1849.629c3.33-2.789 4.56-7.722 8.007-10.046m-1.034 8.096c1.125-3.043 1.784-6.341 1.47-9.641-2.7 1.605-5.429 3.959-8.532 4.543m4.138-7.947c2.46-2.1 5.532-1.693 8.022-3.402-.195 3.238.974 6.22.451 9.534m-4.289-2.428c1.244-1.95 1.949-4.198 3.389-6.057m.57-1.215c1.29-2.144 3.763-3.253 5.802-4.588' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2256.45 1822.744c-.18 6.972-4.558 15.834.524 21.982.3-.03.81-.795 1.23-.87.106 3.719 1.185 7.573 4.364 9.776.54-.27.39-1.034.93-1.32 1.874 2.94 4.693 5.219 7.647 7.199.9-2.985 1.11-6.358.346-9.341.629.419 1.214.959 1.798 1.454-.435-2.34-.12-4.634-.584-6.928.599.345 1.064.99 1.649 1.349.03-2.803-.72-5.862-2.114-8.412.479.06.856.645 1.365.9-.345-8.892-9.448-12.476-15.61-17.363' fill='%2300702d' stroke='%231b402f' stroke-width='.736'/%3e%3cpath d='M2268.58 1853.647c-.45-4.603-4.061-8.697-4.018-13.136m6.508 5.864c-1.995-2.834-4.499-5.443-7.603-7.183-.225 3.33.211 7.168-1.154 10.226m-4.499-8.47c-.374-3.435 1.846-5.864 1.846-9.087 2.728 2.159 6.073 2.954 8.681 5.443m-4.753 2.264c-.96-2.28-2.504-4.273-3.284-6.671m-.734-1.247c-1.096-2.444-.586-5.279-.525-7.872' fill='none' stroke='%231b402f' stroke-width='.736' stroke-linecap='round'/%3e%3cpath d='M2258.55 1820.33c-2.684 7.513-9.882 10.766-13.03 17.393.615.075 1.14-.435 1.799-.299-.825 4.093-3.78 7.331-3.39 11.845.526-.15 1.11-.735 1.666-.826-.404 2.535-.3 5.43.6 7.53.45-.152.795-.812 1.29-.976-.69 3.3.915 6.327 1.934 9.221.735-2.309 2.235-4.364 3.764-5.952.164.63.015 1.378.209 1.903 1.275-2.309 2.34-4.993 3.614-7.287.435.481.164 1.035.554 1.56 1.755-2.324 2.369-5.443 2.416-8.412.419.465.749 1.185 1.123 1.68 1.035-3.015 1.035-6.224.585-9.433.539.645 1.064 1.245 1.529 1.995 1.335-7.12-4.798-12.34-4.138-19.762' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2247.874 1852.043c3.119-1.02 5.113-3.823 6.208-6.837.614 2.278 1.904 3.614 3.088 5.458m-8.787-4.65c3.525-1.558 6.193-4.752 7.378-8.276.193 2.43 1.094 4.214 1.934 6.372m-6.208-7.931c3.27-1.2 5.698-4.003 6.043-7.452-.239 3.358.586 6.793 2.234 9.52m-6.897 13.106c-.42 2.25-1.334 4.258-2.76 6.028m6.089-20.617c.479-1.05.674-2.25.585-3.45m-2.759 12.296c-.166-1.574.224-3.073 1.14-4.138' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2259.764 1778.106c-5.173 4.003-14.244 6.117-15.653 13.42.195.21 1.063.12 1.38.36-2.64 2.294-4.815 5.353-4.485 8.952.51.224.975-.346 1.5-.12-1.006 3.088-.96 6.476-.63 9.776 2.713-1.125 5.278-2.985 6.987-5.308.075.705.03 1.44.03 2.16 1.426-1.71 3.283-2.85 4.663-4.529.136.63-.075 1.35.03 1.98 2.04-1.65 3.824-3.99 4.828-6.509.24.376.06 1.005.164 1.515 6.254-5.518 3.405-14.184 3.256-21.517' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2244.59 1805.171c3.074-3.059 3.884-8.083 7.137-10.691m-.344 8.157c.855-3.12 1.244-6.478.63-9.73-2.534 1.812-5.068 4.391-8.112 5.247m3.449-8.262c2.277-2.31 5.382-2.174 7.705-4.08.091 3.256 1.5 6.119 1.261 9.477m-4.483-2.069c1.079-2.038 1.589-4.348 2.879-6.327m.448-1.261c1.11-2.249 3.48-3.553 5.398-5.053' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2262.584 1775.752c.479 7.961 4.873 13.48 6.057 20.707-.614-.09-.975-.72-1.65-.78-.345 4.168 1.59 8.097-.044 12.311-.45-.286-.855-1.005-1.365-1.245-.314 2.55-1.214 5.294-2.668 7.078-.39-.286-.541-1.006-.976-1.32-.24 3.36-2.624 5.832-4.408 8.321-.075-2.413-.93-4.798-1.965-6.76-.328.568-.404 1.317-.718 1.767-.601-2.564-.87-5.443-1.455-7.992-.555.33-.45.931-.974 1.334-1.035-2.728-.765-5.892.029-8.756-.54.33-1.05.944-1.558 1.305-.151-3.193.733-6.267 2.068-9.22-.705.464-1.38.898-2.024 1.483.705-7.198 8.112-10.917 9.552-18.233' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2262.404 1809.564c-2.715-1.844-3.854-5.098-4.064-8.291-1.23 2.008-2.834 2.938-4.499 4.377m9.731-2.023c-2.938-2.474-4.616-6.268-4.768-9.987-.87 2.265-2.233 3.735-3.628 5.578m8.157-5.893c-2.804-2.054-4.35-5.443-3.72-8.832-.704 3.285-2.457 6.343-4.797 8.518m2.969 14.499c-.226 2.28.104 4.467.976 6.567m-.107-21.501a6.988 6.988 0 01.405-3.48m-.779 12.582c.601-1.471.629-3.03.044-4.29' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2264.562 1725.355c4.14 4.093 10.002 4.168 14.244 7.932-.613.135-1.378-.164-1.978.075 2.13 1.815 4.813 4.754 5.817 7.903-.239.284-1.17 0-1.425.27 1.605 1.933 2.85 4.708 3.974 7.077-.524.24-1.275-.195-1.784.075.81 3.254 1.035 7.062.12 10.346-2.968.075-5.608-1.23-7.467-3.779-.089.795.135 1.65.18 2.34-3.493-.66-6.448-3.344-7.303-7.227a13.793 13.793 0 00-.569 2.503c-2.009-2.804-2.879-6.523-2.745-10.136-.418.734-.614 1.56-.869 2.37-2.144-6.629 2.445-14.14-.555-19.749' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2272.6 1754.58c0-4.02-.15-8.262.104-12.145 2.444 1.98 5.548 2.593 8.068 4.377m.12 7.633c-3.165-2.43-5.969-6.013-7.558-9.957' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2267.847 1745.447c1.92-3.462 1.828-7.81 1.394-11.635 2.653 3.224 6.658 3.375 9.581 5.773m-6.117 2.85c-.676-1.396-1.905-4.665-2.415-6.104m-1.049-2.519c-.72-1.634-2.699-4.978-3.823-6.208' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2262.373 1726.181c-5.487 4.738-15.1 7.241-16.598 15.908.209.24 1.14.135 1.454.435-2.79 2.715-5.084 6.327-4.738 10.587.539.268 1.035-.39 1.589-.136-1.063 3.673-1.02 7.678-.674 11.591 2.879-1.336 5.592-3.539 7.423-6.298.06.84.028 1.71.028 2.564 1.515-2.009 3.48-3.373 4.95-5.368.119.75-.091 1.59.015 2.354 2.174-1.948 4.047-4.738 5.126-7.72.255.45.047 1.182.182 1.798 6.627-6.553 3.597-16.823 3.432-25.507' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2246.299 1758.253c3.254-3.613 4.109-9.58 7.542-12.67m-.36 9.672c.9-3.705 1.32-7.678.676-11.532-2.699 2.146-5.369 5.22-8.592 6.224m3.644-9.807c2.413-2.73 5.697-2.564 8.17-4.828.092 3.854 1.59 7.257 1.336 11.23m-4.752-2.458c1.139-2.415 1.693-5.144 3.043-7.482m.494-1.5c1.17-2.668 3.689-4.213 5.729-5.997' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2264.008 1722.866c-1.83 8.998-8.636 13.465-11.036 21.473.613.044 1.08-.6 1.768-.525-.358 4.858-2.938 8.906-2.053 14.11.51-.225 1.02-.96 1.558-1.11-.118 2.983.3 6.343 1.442 8.712.433-.226.704-1.035 1.182-1.29-.33 3.914 1.605 7.287 2.94 10.556.494-2.743 1.74-5.279 3.104-7.287.224.718.164 1.605.404 2.204 1.02-2.82 1.77-6.043 2.79-8.817.494.51.284 1.17.734 1.74 1.47-2.864 1.74-6.554 1.455-10.002.464.494.885 1.305 1.304 1.844.69-3.613.345-7.347-.479-11.035.63.705 1.214 1.35 1.753 2.174.527-8.413-6.16-13.885-6.342-22.597' fill='%2300702d' stroke='%231b402f' stroke-width='.745'/%3e%3cpath d='M2256.915 1760.773c2.984-1.485 4.665-4.933 5.414-8.548.869 2.595 2.31 4.034 3.703 6.059m-9.282-4.574c3.329-2.144 5.623-6.102 6.419-10.315.464 2.789 1.559 4.798 2.638 7.212m-7.062-8.622c3.118-1.71 5.218-5.219 5.173-9.252.135 3.929 1.349 7.827 3.284 10.871m-5.382 15.894c-.167 2.653-.856 5.083-2.07 7.272m3.749-24.56c.359-1.26.419-2.684.18-4.078m-1.366 14.574c-.346-1.815-.104-3.6.69-4.918' fill='none' stroke='%231b402f' stroke-width='.745' stroke-linecap='round'/%3e%3cpath d='M2240.226 1667.163c-.749 10.256-7.932 15.58-9.49 24.815.733-.06 1.168-.84 1.978-.84.33 5.428-2.053 10.302-.21 15.955.555-.33 1.035-1.215 1.65-1.47.314 3.33 1.334 7.002 3.013 9.447.481-.315.676-1.23 1.186-1.59.224 4.393 3.013 7.843 5.066 11.277.136-3.12 1.215-6.12 2.49-8.533.376.765.435 1.755.81 2.369.75-3.268 1.14-6.957 1.89-10.195.66.51.51 1.275 1.124 1.845 1.29-3.405 1.034-7.543.15-11.322.63.48 1.23 1.32 1.814 1.86.255-4.124-.736-8.202-2.265-12.191.84.689 1.62 1.334 2.385 2.158-.69-9.401-9.342-14.5-10.886-24.14' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2237.873 1709.626c3.269-2.083 4.678-6.162 4.993-10.27 1.425 2.728 3.314 4.122 5.248 6.163m-11.516-3.705c3.553-2.864 5.622-7.616 5.893-12.4.974 3.045 2.564 5.1 4.182 7.632m-9.565-8.532c3.373-2.369 5.278-6.552 4.603-11.02.764 4.318 2.79 8.486 5.518 11.561m-3.839 18.428c.225 2.968-.21 5.773-1.289 8.397m.585-27.83c.224-1.44.075-3.029-.405-4.529m.644 16.36c-.674-1.965-.689-3.989.03-5.563' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2246.299 1667.178c11.606.869 6.463 7.347 7.273 13.84.464-.496.66-1.424 1.2-1.845.345 3.224 1.334 7.692 3.464 10.675.39-.028.689-1.123 1.064-1.183.749 2.788 2.413 5.788 3.823 8.382.525-.346.556-1.35 1.095-1.665 2.34 2.879 5.518 5.563 8.892 6.793 1.784-2.804 2.205-6.18 1.049-9.627.749.434 1.366 1.2 1.949 1.695 1.44-3.794.839-8.367-2.04-11.682.826.242 1.725.616 2.505 1.05-1.258-3.747-3.973-6.956-7.168-9.177.872.076 1.696.42 2.549.69-4.497-6.326-18.967-8.981-27.468-8.981' fill='%2300702d' stroke='%231b402f' stroke-width='.757'/%3e%3cpath d='M2274.864 1689.715c-3.464-2.595-7.062-5.489-10.571-7.737.299 3.613-.976 7.002-.885 10.57m6.538 5.039c-.271-4.589-1.755-9.612-4.229-13.676' fill='none' stroke='%231b402f' stroke-width='.757' stroke-linecap='round'/%3e%3cpath d='M2269.72 1679.248c-4.108-.39-7.811-3.283-10.886-6.177 1.26 4.633-.929 8.577-.54 12.939m5.999-4.032c-.81-1.56-2.924-4.844-3.884-6.27m-1.575-2.638c-.988-1.74-2.398-4.048-5.428-5.052' fill='none' stroke='%231b402f' stroke-width='.757' stroke-linecap='round'/%3e%3cpath d='M2239.191 1668.093c8.907 2.953 2.385 15.084 4.274 21.59.345-.433.96-.9 1.335-1.364.076 4.92-.825 10.497 1.664 14.92.285-.944.915-1.904 1.124-2.834-.239 4.064 1.23 8.472 3.464 11.8.57-.868 1.844-1.453 2.414-2.338 1.664 6.567 11.006 6.973 11.562 12.684 1.56-6.312 6.671-11.17 3.282-17.677.63.12 1.365-.015 1.995.089 2.054-7.077-.27-12.7-4.633-18.127.644-.031 1.304-.301 1.873-.376-1.138-6.327-6.64-10.106-12.04-12.595.691-.12 1.29-.524 1.965-.69-2.384-3.66-6.896-3.553-10.346-5.143-2.669-1.215-5.398-3.658-7.933.06' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2240.226 1667.643c9.567 4.018 10.571 14.528 21.832 16.073m-7.466-.69c4.978 7.737.63 14.71.689 22.761m11.83-10c-2.369-3.404-5.518-5.549-9.07-7.347m.689 7.467c5.292 5.802 1.994 14.665 6.207 21.021m-14.59-35.956c.3 4.964-2.413 9.027-1.964 13.9' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2196.954 1636.904c4.153 9.4-5.204 6.837 3.523 26.975.615-.39.63-1.29 1.349-1.68 2.85 4.649 3.029 10.06 7.302 14.185.33-.54.346-1.544.764-2.07 1.86 2.79 4.47 5.549 7.108 6.928.286-.494.016-1.41.302-1.95 2.247 3.765 6.34 5.504 9.759 7.573-1.334-2.834-1.798-5.968-1.814-8.696.69.494 1.215 1.334 1.846 1.694-.871-3.224-2.281-6.657-3.12-9.881.81.135 1.049.884 1.843 1.094-.464-3.6-2.622-7.138-5.173-10.061.78.119 1.71.585 2.476.78-1.711-3.748-4.5-6.882-7.708-9.687 1.05.226 2.039.42 3.105.795-5.024-7.992-15.055-8.426-20.948-16.223' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2215.067 1676.114c1.903-3.39 1.243-7.632-.405-11.425 2.517 1.754 4.857 2.084 7.526 2.984m-11.918 2.129c1.797-4.184 1.393-9.341-.617-13.705 2.28 2.219 4.647 3.298 7.271 4.769m-12.444-3.046c1.86-3.658 1.574-8.261-1.11-11.89 2.714 3.465 6.433 6.178 10.301 7.618m5.263 18.082c1.59 2.52 2.52 5.188 2.79 8.007m-12.536-24.845c-.495-1.38-1.364-2.698-2.503-3.808m8.261 14.14c-1.515-1.41-2.474-3.194-2.578-4.918' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2205.56 1634.236c6.896 4.602 13.3 14.92 22.416 13.374.15-.344-.33-1.393-.18-1.89 3.81 2.25 8.307 3.54 12.355 1.515.03-.75-.824-1.064-.794-1.83 4.033-.134 7.947-1.723 11.65-3.642-2.488-2.848-5.772-5.204-9.22-6.283.78-.404 1.664-.69 2.503-1.02-2.608-1.004-4.738-2.788-7.302-3.748.69-.434 1.604-.51 2.294-.93-2.804-1.798-6.313-2.923-9.672-3.044.33-.465 1.14-.525 1.695-.9-9.146-5.263-17.978 2.235-26.45 5.743' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2243.63 1640.802c-4.888-2.444-11.096-1.154-15.533-4.002m9.64-3.285c-4.003.36-8.066 1.395-11.604 3.628 3.222 2.34 7.332 4.304 9.64 7.693m-11.125-.525c-3.659-1.769-4.845-5.698-8.083-7.737 3.734-1.574 6.463-4.633 10.467-5.863m-.449 6.523c-2.85-.42-5.758-.015-8.607-.705m-1.666.001c-3.089-.36-5.653-2.715-8.23-4.424' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2195.619 1630.171c3.704 8.532 5.143 26.375 15.204 31.023.375-.195.599-1.423 1.095-1.738 2.249 4.437 5.817 8.531 11.185 9.415.539-.614-.09-1.454.45-2.099 4.079 2.535 9.01 3.72 13.96 4.5-.525-4.125-2.19-8.323-4.873-11.517 1.064.165 2.114.495 3.163.765-1.888-2.579-2.788-5.534-4.677-8.052.96.06 1.919.6 2.892.705-1.558-3.404-4.257-6.702-7.51-9.01.644-.197 1.484.298 2.278.327-5.487-10.585-19.268-9.88-30.004-12.4' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2231.17 1665.724c-3.193-5.323-10.181-8.277-12.641-13.676m11.727 3.495c-4.198-2.34-8.907-4.11-13.9-4.5 1.604 4.155 4.334 8.562 4.319 13.03m-10.632-7.781c-2.413-3.943-.944-8.126-2.774-12.025 4.753 1.094 9.522.224 14.305 1.799m-4.843 5.353c-2.535-2.22-5.669-3.794-8.022-6.268m-1.649-1.095c-2.819-2.339-3.75-6.058-5.159-9.236' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2156.633 1617.472c5.354 7.84-4.26 6.897 7.049 23.706.568-.451.463-1.26 1.123-1.71 3.432 3.764 4.332 8.607 9.101 11.667.255-.525.135-1.441.48-1.966 2.204 2.234 5.158 4.335 7.962 5.188.195-.494-.18-1.274.03-1.8 2.73 3.046 7.002 4.02 10.661 5.369-1.695-2.34-2.564-5.098-2.938-7.542.75.345 1.363 1.019 2.04 1.26-1.29-2.774-3.135-5.653-4.395-8.412.81 0 1.156.629 1.964.704-.93-3.178-3.539-6.027-6.447-8.276.778 0 1.77.27 2.55.345-2.19-3.12-5.368-5.533-8.923-7.573 1.08.03 2.085.06 3.193.24-6.026-6.432-16.013-5.353-22.88-11.486' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2179.754 1650.024c1.425-3.313.195-7.032-1.933-10.196 2.744 1.214 5.082 1.17 7.84 1.59m-11.499 3.644c1.215-4.02.135-8.592-2.43-12.207 2.565 1.65 5.038 2.265 7.842 3.209m-12.731-.915c1.366-3.553.467-7.646-2.683-10.51 3.15 2.713 7.198 4.603 11.216 5.337m7.602 15.461c1.904 2.023 3.178 4.302 3.823 6.777m-15.698-20.467c-.66-1.17-1.71-2.234-2.97-3.06m10.032 11.502c-1.693-1.05-2.863-2.52-3.194-4.05' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2152.42 1620.816c7.902-12.491 12.64-3.659 20.902-1.425-.314-.764-1.32-1.425-1.5-2.22 4.065 1.17 10.017 2.22 14.875 1.276.18-.45-.944-1.305-.81-1.755 3.794.525 9.507 2.218 13.45 1.904-.104-.75-2.414-3.389-2.474-4.138 4.843-1.215 9.927-3.464 13.407-6.613-2.31-3.358-6.12-5.428-10.917-5.818.959-.614 2.218-.944 3.164-1.335-3.69-3.433-9.536-4.961-15.205-3.373a18.86 18.86 0 012.743-2.279c-5.246-.389-10.704 1.08-15.248 3.569.598-.946 1.499-1.68 2.339-2.52-10.255 1.964-21.997 16.78-27.035 26.256' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2195.723 1598.849c-5.157 2.609-10.735 5.204-15.533 8.036 4.543 1.395 7.841 4.455 12.16 6.073m9.912-4.843c-5.67-1.92-12.566-2.684-18.909-1.89' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2180.144 1599.523c-2.908 4.394-8.563 7.107-13.854 9.132 6.311.84 9.747 5.173 15.204 6.853m-1.304-8.623c-2.325.15-7.542.916-9.807 1.305m-4.093.465c-2.67.284-6.283.734-9.281 3.613' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2159.633 1619.3c6.387 6.583 10.84 19.193 21.097 19.673.24-.33-.03-1.56.269-2.054 3.584 3.314 8.158 5.758 13.016 4.528.224-.795-.615-1.335-.405-2.144 4.408.794 9.027.015 13.495-1.17-2.01-3.674-4.993-6.972-8.473-8.936.946-.254 1.966-.36 2.954-.51-2.578-1.695-4.468-4.123-7.016-5.759.855-.315 1.859-.164 2.714-.448-2.594-2.61-6.133-4.649-9.762-5.578.48-.42 1.38-.286 2.054-.556-8.652-7.826-20.032-1.859-30.063-.074' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2199.337 1635.344c-4.708-3.764-11.74-3.853-15.878-7.96m11.245-1.26c-4.423-.57-9.086-.406-13.45 1.154 2.939 3.283 6.913 6.372 8.593 10.556m-11.922-3.179c-3.554-2.773-3.898-7.287-6.913-10.241 4.424-.81 8.127-3.465 12.761-3.84m-2.053 6.913c-2.985-1.124-6.24-1.379-9.162-2.789m-1.816-.388c-3.27-1.125-5.472-4.26-7.856-6.703' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2118.713 1598.594c11.441 8.92-2.684 12.385 7.046 26.99.54-.495 1.56-.435 2.204-.945 3.63 4.063 4.86 7.316 9.808 10.6.224-.6.06-1.588.374-2.173 2.325 2.413 5.4 4.663 8.247 5.547.164-.54-.255-1.38-.059-1.98 2.893 3.3 7.211 4.29 10.961 5.699-1.83-2.533-2.85-5.548-3.344-8.231.764.359 1.425 1.094 2.114 1.349-1.44-3.03-3.434-6.148-4.843-9.162.825-.015 1.184.674 2.024.736-1.11-3.451-3.883-6.538-6.912-8.967.793-.015 1.783.268 2.58.33-2.357-3.375-5.67-5.968-9.329-8.142 1.081.015 2.1.029 3.21.208-6.373-6.957-16.33-5.591-23.51-12.19' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2143.557 1634.236c1.261-3.675-.148-7.738-2.458-11.173 2.804 1.275 5.158 1.186 7.946 1.591m-11.335 4.243c1.005-4.453-.313-9.46-3.072-13.389 2.653 1.784 5.173 2.413 8.02 3.39m-12.806-.752c1.186-3.943.075-8.426-3.207-11.516 3.282 2.926 7.436 4.934 11.5 5.654m8.411 16.852c2.01 2.19 3.42 4.65 4.185 7.362m-16.793-22.175c-.721-1.274-1.815-2.43-3.136-3.313m10.662 12.444c-1.755-1.124-3.015-2.7-3.42-4.393' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2123.405 1601.458c7.182 1.544 15.625 8.322 22.867 3.583.03-.374-.69-1.11-.703-1.604 3.881.57 8.065.06 10.87-3.223-.18-.675-.992-.645-1.2-1.336 3.374-1.603 6.208-4.468 8.756-7.526-2.937-1.62-6.401-2.49-9.626-2.16.54-.66 1.2-1.23 1.814-1.83-2.503.06-4.827-.734-7.271-.63.45-.644 1.2-1.047 1.664-1.677-2.893-.556-6.193-.27-9.072.869.15-.541.824-.87 1.17-1.41-9.282-1.29-14.53 8.607-20.647 14.86' fill='%2300702d' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2157.489 1593.226c-4.845-.36-9.703 3.06-14.29 2.174m7.167-6.462c-3.284 1.799-6.403 4.213-8.728 7.498 3.42.884 7.454 1.108 10.408 3.268m-9.552 3.643c-3.614-.226-5.773-3.269-9.103-3.869 2.7-2.788 4.094-6.507 7.109-9.07m1.528 5.936c-2.518.69-4.843 2.114-7.467 2.564m-1.409.615c-2.715.824-5.562-.315-8.247-.885' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2117.184 1595.985c8.726 3.358 17.454-2.234 25.58 1.874-1.066.39-1.995.885-2.985 1.409 4.049.436 7.932 1.485 11.2 3.869-.733.344-1.723.539-2.443.96 3.569 1.019 7.122 2.864 9.297 5.968-.78.359-1.35-.195-2.084.239 2.294 2.474 5.158 4.768 7.482 7.228-.69.075-1.545-.361-2.37-.346 1.365 2.565 3.315 5.248 5.834 6.988-3.87.419-8.113 1.574-11.861-.45.045.736.72 1.41.735 2.07-2.88.509-6.402-.301-9.327-1.664-.09.779.39 1.739.39 2.488-5.578-.959-8.427-5.967-13.074-8.426-.406.869.013 1.724-.301 2.533-6.853-6.387-5.953-15.324-14.544-20.646-4.38-2.699-9.747-5.55-11.816-9.672-2.068-4.109-6.552-8.202-8.442-9.957v-8.456c2.759 4.303 10.166 17.228 13.27 19.807 3.104 2.595 1.095 2.504 5.459 4.184' fill='%2300702d'/%3e%3cpath d='M2117.184 1595.985c8.726 3.358 17.454-2.234 25.58 1.874-1.066.39-1.995.885-2.985 1.409 4.049.436 7.932 1.485 11.2 3.869-.733.344-1.723.539-2.443.96 3.569 1.019 7.122 2.864 9.297 5.968-.78.359-1.35-.195-2.084.239 2.294 2.474 5.158 4.768 7.482 7.228-.69.075-1.545-.361-2.37-.346 1.365 2.565 3.315 5.248 5.834 6.988-3.87.419-8.113 1.574-11.861-.45.045.736.72 1.41.735 2.07-2.88.509-6.402-.301-9.327-1.664-.09.779.39 1.739.39 2.488-5.578-.959-8.427-5.967-13.074-8.426-.406.869.013 1.724-.301 2.533-6.853-6.387-5.953-15.324-14.544-20.646-4.38-2.699-9.747-5.55-11.816-9.672-2.068-4.109-6.552-8.202-8.442-9.957v-8.456c2.759 4.303 10.166 17.228 13.27 19.807 3.104 2.595 1.095 2.504 5.459 4.184z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2151.415 1622.255c-.104-4.514-2.758-8.084-6.013-10.542 2.969-.074 5.069-1.363 7.723-2.368m-8.802 10.241c-.6-5.219-3.494-9.822-7.332-12.566 3.014.525 5.503-.089 8.411-.51m-11.831 5.714c-.269-4.77-2.788-8.936-6.821-10.527 3.973 1.425 8.412 1.425 12.31.135m13.33 13.51c2.563 1.29 4.662 3.178 6.298 5.667m-22.717-14.904c-1.079-.974-2.46-1.634-3.958-1.904m13.854 7.723c-1.964-.3-3.628-1.32-4.572-2.895' fill='none' stroke='%231b402f' stroke-width='.689' stroke-linecap='round'/%3e%3cpath d='M2105.892 1623.724c2.895-8.937 4.962-16.299 10.707-22.956 5.757-6.658 13.448-16.779 13.913-22.522.421-5.398.33-7.692.33-9.986-2.294 1.604-7.226 6.088-5.968 11.365.751 3.134-.809 5.053-2.128 7.123-1.32 2.07-9.596 14.155-19.238 19.432z' fill='%2300702d'/%3e%3cpath d='M2105.892 1623.724c2.895-8.937 4.962-16.299 10.707-22.956 5.757-6.658 13.448-16.779 13.913-22.522.421-5.398.33-7.692.33-9.986-2.294 1.604-7.226 6.088-5.968 11.365.751 3.134-.809 5.053-2.128 7.123-1.32 2.07-9.596 14.155-19.238 19.432z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2130.154 1569.864c-.227 2.76-.106 6.897-.689 8.728-.572 1.844-4.125 3.328-3.675-.69.465-4.019 1.62-4.934 4.364-8.038' fill='%23f0e53c'/%3e%3cpath d='M2111.096 1600.843c-4.034 1.77-10.376-1.186-14.02-2.145-3.66-.944-2.76-4.349-8.277.705-1.38 1.26-5.743 1.71-5.218 1.83 3.494.87 9.116 1.738 2.458 6.627-1.604 1.185-5.846 3.48-5.846 3.48s3.328-2.295 7.692 1.153c4.362 3.434 8.187-1.739 9.64 2.684 1.47 4.424 7.483-1.694 8.802-5.068 1.32-3.373 4.769-9.266 4.769-9.266' fill='%2300702d'/%3e%3cpath d='M2111.096 1600.843c-4.034 1.77-10.376-1.186-14.02-2.145-3.66-.944-2.76-4.349-8.277.705-1.38 1.26-5.743 1.71-5.218 1.83 3.494.87 9.116 1.738 2.458 6.627-1.604 1.185-5.846 3.48-5.846 3.48s3.328-2.295 7.692 1.153c4.362 3.434 8.187-1.739 9.64 2.684 1.47 4.424 7.483-1.694 8.802-5.068 1.32-3.373 4.769-9.266 4.769-9.266z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2095.636 1613.139c-3.613.974 10.857-8.922 12.011-.135.495 3.883-3 17.633-7.588 24.756-4.603 7.12-8.276 14.02-9.656 19.072.24-5.967 5.518-19.522 6.673-23.662 1.139-4.138 1.919-13.284 1.995-14.574.073-1.29-2.356-5.758-3.435-5.457' fill='%2300702d'/%3e%3cpath d='M2095.636 1613.139c-3.613.974 10.857-8.922 12.011-.135.495 3.883-3 17.633-7.588 24.756-4.603 7.12-8.276 14.02-9.656 19.072.24-5.967 5.518-19.522 6.673-23.662 1.139-4.138 1.919-13.284 1.995-14.574.073-1.29-2.356-5.758-3.435-5.457z' fill='none' stroke='%231b402f' stroke-width='.689'/%3e%3cpath d='M2218.68 1490.545l-195.197-18.233c-9.28-19.252-16.569-41.025-21.336-64.475l248.125-2.146c-6.268 32.074-17.274 61.087-31.593 84.854' fill='%23f0e53c'/%3e%3cpath d='M2125.985 1555.02c-26.66 0-51.76-13.81-72.678-37.14l134.26 11.155c-18.458 16.508-39.48 25.985-61.582 25.985' fill='%2300a0e1'/%3e%3cpath d='M2187.566 1529.035l-134.259-11.155c-11.32-12.61-21.382-28.04-29.824-45.568l195.196 18.233c-9.146 15.159-19.627 28.204-31.113 38.49m68.614-184.858c0 21.292-2.085 41.954-5.908 61.514l-248.125 2.145c-4.094-20.176-6.343-41.587-6.343-63.659z' fill='white'/%3e%3cpath d='M2038.208 1433.476c0 12.236 9.927 22.176 22.162 22.176 12.25 0 22.176-9.94 22.176-22.176 0-12.25-9.926-22.178-22.176-22.178-12.235 0-22.162 9.927-22.162 22.178' fill='%23f0e53c'/%3e%3cpath d='M2038.208 1433.476c0 12.236 9.927 22.176 22.162 22.176 12.25 0 22.176-9.94 22.176-22.176 0-12.25-9.926-22.178-22.176-22.178-12.235 0-22.162 9.927-22.162 22.178z' fill='none' stroke='white' stroke-width='5.761'/%3e%3cpath d='M1974.976 1371.239c12.505 5.607 28.338 19.222 38.34 20.332 10.002 1.109 14.995 9.506 20.002 12.288 4.993 2.804 24.157 18.638 32.492 19.583 8.339.928 6.674 2.788 15.836 7.45 9.175 4.664 14.168 4.664 24.994 10.242 10.843 5.609 17.514 13.06 20.843 12.116 3.328-.93 10.841-5.578 17.5-8.382 6.672-2.79 20.841-8.381 30.841-13.975 10.002-5.592 12.506-2.804 24.997-8.396 12.505-5.593 32.507-19.808 43.335-24.36 10.839-4.527 35.4-13.853 47.696-16.643v-95.065h-316.876z' fill='%23d9c753'/%3e%3cpath d='M1958.587 1342.13c8.382 2.938-1.365 4.23 12.054 9.865 13.406 5.67 21.802 5.67 21.802 5.67s6.704 7.137 13.406 7.737c6.702.629 15.924 3.989 19.28 6.507 0 0 2.52-3.987 11.743 4.709h10.06l8.383 4.739h22.625l20.348 1.438s3.328 5.878 9.102 5.878c5.757 0 30.917-11.217 30.917-11.217h9.22s14.247-6.387 19.284-6.387c5.023 0 14.245-1.678 14.245-1.678l21.8-9.208 10.887-.838s8.382-8.668 19.284-11.036c10.9-2.4 20.96-7.678 25.16-10.497v-37.995h-300.576z' fill='%23b2aa00'/%3e%3cpath d='M1996.606 1319.125c8.112-102.711 63.966-185.74 129.177-185.74 65.36 0 121.32 82.799 129.236 185.81z' fill='%2300702d'/%3e%3cpath d='M1987.932 1319.136l169.315.06c-11.093-15.057-98.376-59.527-163.241-42.253-64.867 17.302-6.074 42.193-6.074 42.193' fill='%23c8d700'/%3e%3cg clip-path='url(%23ad)' opacity='.28'%3e%3cpath d='M2029.961 1183.799s128.636 31.097 202.588 13.165l-36.196-44.564s-85.918 8.786-132.58-3.149c-46.662-11.965-33.812 34.548-33.812 34.548' fill='%23292723'/%3e%3c/g%3e%3cpath d='M2125.985 1133.326c-71.898 0-130.18 94.405-130.18 210.852 0 116.439 58.282 210.842 130.18 210.842 71.897 0 130.181-94.403 130.181-210.842 0-116.447-58.284-210.852-130.18-210.852m129.714 390.596c-33.856 51.536-79.918 79.92-129.715 79.92-49.782 0-95.859-28.384-129.716-79.92-31.789-48.357-49.286-112.202-49.286-179.744 0-67.565 17.497-131.411 49.286-179.783 33.857-51.52 79.934-79.89 129.716-79.89 49.797 0 95.86 28.37 129.715 79.89 31.79 48.372 49.287 112.218 49.287 179.783 0 67.542-17.497 131.387-49.287 179.744' fill='%230079c7'/%3e%3cpath d='M1982.909 1281.56l4.049-12.475h13.104l-10.6-7.707 4.049-12.475-10.602 7.707-10.601-7.707 4.049 12.475-10.602 7.707h13.107zm15.369-51.01l5.383-11.937 13.03 1.441-9.686-8.816 5.383-11.966-11.38 6.507-9.703-8.816 2.67 12.834-11.382 6.508 13.016 1.41zm22.522-43.843l7.573-10.707 12.504 3.898-7.841-10.494 7.57-10.706-12.413 4.197-7.843-10.496.166 13.105-12.402 4.228 12.52 3.87zm28.773-41.145l10.317-8.067 10.87 7.318-4.483-12.296 10.317-8.097-13.09.48-4.499-12.325-3.599 12.595-13.104.48 10.87 7.316zm39.392-27.559l12.819-2.76 6.569 11.337 1.348-13.045 12.82-2.73-11.994-5.337 1.349-13.016-8.758 9.747-11.98-5.308 6.583 11.336zm185.374 163.557l-4.05-12.475h-13.103l10.6-7.707-4.048-12.475 10.6 7.707 10.617-7.707-4.062 12.475 10.6 7.707h-13.105zm-15.369-51.01l-5.384-11.937-13.03 1.441 9.702-8.816-5.397-11.966 11.38 6.507 9.7-8.816-2.653 12.834 11.38 6.508-13.028 1.41zm-22.522-43.843L2228.89 1176l-12.519 3.898 7.843-10.494-7.558-10.706 12.4 4.197 7.857-10.496-.18 13.105 12.415 4.228-12.519 3.87zm-28.758-41.145l-10.333-8.067-10.855 7.318 4.468-12.296-10.317-8.097 13.106.48 4.484-12.325 3.613 12.595 13.09.48-10.87 7.316zm-39.406-27.559l-12.805-2.76-6.583 11.337-1.35-13.045-12.804-2.73 11.98-5.337-1.35-13.016 8.758 9.747 11.98-5.308-6.568 11.336z'/%3e%3cpath d='M1981.47 1283l4.049-12.475h13.105l-10.602-7.708 4.049-12.474-10.601 7.707-10.601-7.707 4.048 12.474-10.601 7.708h13.105zm15.37-51.011l5.381-11.935 13.031 1.439-9.687-8.816 5.383-11.965-11.38 6.506-9.7-8.816 2.667 12.836-11.38 6.507 13.03 1.41zm22.52-43.842l7.572-10.707 12.506 3.898-7.843-10.496 7.558-10.706-12.4 4.2-7.842-10.497.164 13.105-12.4 4.228 12.52 3.87zm28.775-41.144l10.315-8.067 10.872 7.316-4.484-12.294 10.315-8.1-13.09.483-4.498-12.327-3.598 12.595-13.105.48 10.871 7.318zm39.389-27.562l12.821-2.757 6.567 11.334 1.35-13.045 12.82-2.728-11.996-5.308 1.35-13.045-8.757 9.745-11.98-5.307 6.581 11.336zM2272.9 1283l-4.049-12.475h-13.105l10.6-7.708-4.049-12.474 10.603 7.707 10.616-7.707-4.064 12.474 10.6 7.708h-13.105zm-15.37-51.011l-5.383-11.935-13.029 1.439 9.7-8.816-5.398-11.965 11.381 6.506 9.702-8.816-2.668 12.836 11.393 6.507-13.029 1.41zm-22.522-43.842l-7.556-10.707-12.52 3.898 7.842-10.496-7.558-10.706 12.4 4.2 7.843-10.497-.166 13.105 12.402 4.228-12.507 3.87zm-28.759-41.144l-10.33-8.067-10.871 7.316 4.483-12.294-10.316-8.1 13.105.483 4.484-12.327 3.598 12.595 13.105.48-10.87 7.318zm-39.406-27.562l-12.804-2.757-6.584 11.334-1.348-13.045-12.805-2.728 11.98-5.308-1.35-13.045 8.758 9.745 11.98-5.307-6.567 11.336z' fill='%23f0e53c'/%3e%3cpath d='M2255.221 1319.136c.63 8.247.96 16.584.96 25.041' fill='%231b402f'/%3e%3cpath d='M2125.985 1553.22c-69.588 0-128.38-95.737-128.38-209.042 0-113.328 58.792-209.052 128.38-209.052s128.396 95.724 128.396 209.052c0 113.305-58.808 209.043-128.396 209.043m0-421.693c-71.539 0-131.98 97.373-131.98 212.65 0 115.253 60.441 212.642 131.98 212.642 71.554 0 131.995-97.39 131.995-212.642 0-115.277-60.44-212.65-131.995-212.65' fill='%23f0e53c'/%3e%3cpath d='M2125.985 1553.22c-69.588 0-128.38-95.737-128.38-209.042 0-113.328 58.792-209.052 128.38-209.052s128.396 95.724 128.396 209.052c0 113.305-58.808 209.043-128.396 209.043zm0-421.692c-71.539 0-131.98 97.373-131.98 212.65 0 115.253 60.441 212.642 131.98 212.642 71.554 0 131.995-97.39 131.995-212.642 0-115.277-60.44-212.65-131.995-212.65z' fill='none' stroke='%23473125' stroke-width='1.44'/%3e%3cpath d='M1992.58 1408.835c.028 1.572-.696 2.822-2.173 3.75a12.868 12.868 0 01-4.808 1.83c-1.566.26-3.173-.016-4.835-.808-1.65-.79-2.662-1.927-3.024-3.391a60.763 60.763 0 01-.765-3.422c-.151-.805-.265-1.411-.327-1.823l-.38-2.294 15.313-2.525.139.824c.276 1.656.485 3.06.627 4.18.14 1.12.216 2.338.232 3.679m-16.353.056c.09 1.984-.407 3.409-1.48 4.238-1.074.848-2.527 1.44-4.35 1.733-1.486.247-2.967.05-4.498-.577-1.505-.642-2.479-1.567-2.884-2.802a29.87 29.87 0 01-.946-3.507 275.384 275.384 0 00-.559-2.868l14.015-2.328c.143.886.286 1.796.428 2.682.128.906.23 2.065.274 3.429m17.605-.333l-5.7-34.022-.688.129.358 2.165.232 2.87c.09.946-.006 1.698-.288 2.302-.268.604-.857 1.043-1.756 1.319l-1.977.488-20.539 3.38-2.019.184c-.938.015-1.645-.195-2.122-.72-.46-.477-.825-1.201-1.082-2.207a51.104 51.104 0 01-.602-2.66 46.845 46.845 0 00-.429-2.217l-.688.132 5.29 32.15c.72 4.35 1.385 7.739 2.003 10.168.617 2.428 1.402 4.409 2.367 5.947.965 1.514 2.047 2.66 3.217 3.437 1.183.755 2.491 1.016 3.91.78 2.104-.365 3.457-1.585 4.053-3.72.612-2.113.897-4.202.874-6.22-.025-2.018-.275-4.467-.752-7.346l.337-.044c.572 3.377 1.072 5.898 1.513 7.562a33.558 33.558 0 001.73 4.938 10.538 10.538 0 003.183 4.09c1.42 1.103 3.06 1.489 4.937 1.179 1.823-.292 3.217-1.23 4.213-2.768.981-1.538 1.606-3.417 1.846-5.594.254-2.178.158-4.8-.246-7.817a321.177 321.177 0 00-1.175-7.885m1.675 92.026c-2.815-.067-5.02-1.634-6.606-4.662-.815-1.559-1.194-3.04-1.162-4.512.02-1.457.467-2.8 1.323-4.055.86-1.237 2.142-2.48 3.84-3.765 1.7-1.267 3.525-2.412 5.449-3.478 2.67-1.423 4.924-2.437 6.769-3.02a18.262 18.262 0 015.887-.77c2.08.043 3.916 1.59 5.506 4.638.81 1.537 1.194 3.04 1.174 4.495-.034 1.451-.478 2.815-1.338 4.052-.86 1.237-2.138 2.497-3.84 3.764-1.701 1.267-3.526 2.411-5.45 3.476-2.305 1.233-4.35 2.196-6.181 2.86-1.816.665-3.601.991-5.371.977m20.499 13.271c4.126-2.224 6.268-6.622 6.414-13.177.15-6.533-1.571-13.259-5.174-20.137-3.737-7.159-8.247-12.389-13.521-15.729-5.255-3.317-9.986-3.833-14.192-1.569-4.34 2.352-6.56 6.714-6.664 13.086-.105 6.371 1.65 13.025 5.295 19.991 3.643 6.946 8.127 12.188 13.46 15.715 5.336 3.526 10.14 4.134 14.382 1.82m48.032 27.925c2.137 1.84 3.747 4.292 4.83 7.338 1.061 3.039 1.713 6.069 1.967 9.06.237 3 .252 5.945.053 8.865l.844.736 10.251-11.906-38.87-33.101-.445.543c.275.233.668.583 1.181 1.05.511.454 1.264 1.175 2.24 2.159.996.975 1.581 1.813 1.794 2.497.213.684.094 1.429-.399 2.209l-1.207 1.627-13.62 15.847-1.426 1.429c-.723.625-1.39.905-2.002.86-.613-.031-1.343-.367-2.193-.98a41.28 41.28 0 01-2.132-1.618 37.73 37.73 0 00-1.579-1.277l-.467.519 25.883 22.259.463-.538-3.45-3.14c-1.014-.981-1.594-1.771-1.765-2.377-.15-.6.027-1.311.55-2.144l1.208-1.626 16.75-19.476zm78.853 23.455l-33.227-.261v.706c.348.005.786.005 1.348.029.56.026 1.486.084 2.792.204 1.287.106 2.214.356 2.743.744.548.39.89 1.033 1.042 1.945l.132 2.023.054 20.892-.153 2.025c-.137.938-.452 1.589-.943 1.951-.495.362-1.462.598-2.924.694l-3.807.15v.707l33.01.255-.002-.693-3.806-.162c-1.46-.107-2.442-.32-2.935-.665-.493-.345-.807-1.013-.942-2.003l-.153-2.026-.035-21.081.128-2.013c.144-.965.478-1.613 1.011-1.959.552-.329 1.538-.551 3-.647l3.67-.108zm85.187-17.369c-.365.251-.762.537-1.211.878-.445.325-1.194.83-2.203 1.474-1.013.662-1.983 1.11-2.874 1.337-.91.23-1.916.16-3.054-.17l-3.788-1.325-26.874-10.757-5.712 4.518 4.528 28.551.437 4.028c.038 1.181-.078 2.12-.353 2.831-.262.727-.848 1.49-1.75 2.317l-2.164 1.942.445.535 25.595-20.259-.444-.535-2.538 1.786a27 27 0 01-2.205 1.246c-.6.276-1.128.123-1.62-.472-.311-.422-.62-1.329-.895-2.76-.273-1.432-.61-3.457-.978-6.095-.371-2.639-.9-6.558-1.571-11.745a622.156 622.156 0 019.275 3.568c3.18 1.244 5.427 2.168 6.728 2.804 1.296.655 2.143 1.213 2.544 1.721.467.566.57 1.14.309 1.72-.263.58-.654 1.142-1.18 1.687a19.64 19.64 0 01-1.634 1.525c-.56.451-1.082.897-1.531 1.287l.436.554 14.719-11.639zm12.885-79.281l-16.011 29.11.616.335c.16-.288.389-.68.668-1.153.287-.495.775-1.279 1.499-2.359.709-1.077 1.368-1.78 1.966-2.069.58-.287 1.324-.277 2.179.034l1.842.845 18.345 10.012 1.708 1.091c.76.572 1.182 1.156 1.275 1.772.082.597-.18 1.575-.775 2.896l-1.68 3.425.616.335 15.902-28.906-.627-.352-1.948 3.276c-.778 1.241-1.431 1.981-1.97 2.266-.533.262-1.27.232-2.212-.129l-1.844-.845-18.503-10.076-1.71-1.09c-.783-.59-1.18-1.217-1.23-1.835-.026-.642.25-1.62.85-2.962l1.655-3.268zm29.043-56.371l9.46 8.069-11.783 3.9zm-3.32 12.295l-4.91 1.298c-1.141.274-2.007.354-2.613.24-.658-.13-1.067-.47-1.224-1.05-.16-.575-.21-1.29-.141-2.142.056-.852.15-1.683.269-2.456.118-.793.25-1.567.365-2.318l-.7-.126-3.788 19.59.699.127.958-4.064c.41-1.517.87-2.64 1.392-3.363.508-.703 1.082-1.221 1.707-1.51a67.6 67.6 0 012.194-.965 27.262 27.262 0 012.279-.845l27.293-8.63 1.465-7.62-21.907-19.174-2.952-2.815c-.784-.772-1.293-1.572-1.547-2.308-.267-.737-.334-1.747-.225-2.941l.384-2.868-.7-.147-6.357 32.905.699.126c.1-.558.209-1.056.313-1.488.09-.441.304-1.223.655-2.355.324-1.127.647-1.92.933-2.412.282-.448.722-.658 1.327-.545.647.11 1.478.624 2.54 1.5l4.11 3.33z'/%3e%3cpath d='M1991.996 1409.852c.027 1.574-.697 2.825-2.174 3.754a12.801 12.801 0 01-4.807 1.826c-1.566.26-3.175-.016-4.837-.806-1.648-.79-2.661-1.927-3.024-3.393a63.938 63.938 0 01-.763-3.4c-.152-.825-.265-1.433-.328-1.842l-.378-2.294 15.311-2.535.138.822c.279 1.667.488 3.072.628 4.19.141 1.12.218 2.34.234 3.678m-16.354.056c.089 1.984-.408 3.411-1.48 4.26-1.072.848-2.527 1.418-4.35 1.711-1.486.25-2.981.051-4.497-.574-1.504-.624-2.479-1.567-2.884-2.804-.42-1.26-.727-2.42-.946-3.506a332.66 332.66 0 00-.559-2.868l14.015-2.328c.142.887.284 1.794.427 2.683.128.905.231 2.063.274 3.426m17.592-.333l-5.674-34.02-.702.13.359 2.163c.078.986.155 1.928.232 2.871.076.944-.021 1.696-.288 2.3-.269.605-.859 1.044-1.757 1.32l-1.977.487-20.537 3.38-2.019.184c-.94.017-1.646-.195-2.122-.717-.461-.48-.825-1.2-1.083-2.21a49.75 49.75 0 01-.602-2.659c-.152-.824-.285-1.56-.428-2.215l-.688.132 5.29 32.148c.717 4.35 1.385 7.74 2.002 10.17.618 2.428 1.402 4.41 2.368 5.944.966 1.538 2.045 2.661 3.229 3.438 1.171.756 2.479 1.015 3.896.782 2.106-.344 3.458-1.585 4.055-3.722.61-2.114.898-4.179.873-6.22-.024-2.019-.274-4.468-.751-7.347l.337-.044c.572 3.38 1.072 5.9 1.513 7.565a32.794 32.794 0 001.728 4.935 10.385 10.385 0 003.183 4.091c1.42 1.102 3.061 1.488 4.937 1.181 1.825-.292 3.219-1.23 4.214-2.769.982-1.54 1.606-3.417 1.845-5.596.241-2.177.158-4.799-.244-7.817a264.935 264.935 0 00-1.189-7.885m1.448 90.991c-2.815-.067-5.018-1.635-6.605-4.664-.812-1.537-1.194-3.04-1.177-4.515.034-1.451.481-2.795 1.337-4.052.86-1.237 2.142-2.477 3.841-3.765 1.701-1.266 3.525-2.41 5.45-3.475 2.667-1.425 4.922-2.437 6.766-3.023a18.316 18.316 0 015.903-.767c2.067.04 3.903 1.586 5.493 4.635.81 1.537 1.193 3.041 1.173 4.495a7.286 7.286 0 01-1.339 4.052c-.86 1.237-2.137 2.497-3.838 3.765a45.553 45.553 0 01-5.45 3.477c-2.307 1.233-4.352 2.194-6.182 2.859-1.816.666-3.602.992-5.372.978m20.5 13.27c4.141-2.221 6.268-6.623 6.415-13.176.15-6.534-1.574-13.259-5.172-20.118-3.755-7.18-8.249-12.408-13.523-15.748-5.258-3.319-9.987-3.834-14.194-1.568-4.339 2.352-6.56 6.713-6.664 13.083-.104 6.371 1.651 13.028 5.297 19.991 3.643 6.946 8.126 12.191 13.46 15.717 5.336 3.526 10.139 4.134 14.382 1.819m47.983 28.049c2.138 1.84 3.749 4.293 4.81 7.333a36.197 36.197 0 011.987 9.065c.237 3.002.254 5.946.052 8.864l.863.742 10.235-11.91-38.852-33.096-.465.538c.274.232.669.582 1.18 1.05.512.454 1.265 1.175 2.243 2.159.993.973 1.58 1.814 1.794 2.496.213.684.092 1.43-.4 2.21l-1.21 1.625-13.617 15.849-1.426 1.428c-.723.624-1.391.906-2.001.876-.613-.046-1.345-.384-2.195-.995a41.012 41.012 0 01-2.132-1.62c-.568-.486-1.111-.901-1.58-1.277l-.464.522L2047.87 1570l.463-.538-3.451-3.141c-1.012-.98-1.595-1.77-1.763-2.375-.152-.601.026-1.311.549-2.144l1.209-1.626 16.749-19.477zm78.463 23.507l-33.23-.263.003.707c.326.004.784.005 1.346.03.562.025 1.488.084 2.794.204 1.287.106 2.215.354 2.74.742.552.39.89 1.035 1.024 1.943l.153 2.027.055 20.89-.134 2.027c-.157.938-.471 1.588-.965 1.949-.492.363-1.461.598-2.924.708l-3.805.138v.707l33.01.255-.004-.693-3.804-.162c-1.461-.108-2.441-.322-2.934-.667-.494-.343-.807-1.011-.965-2.005l-.131-2.023-.058-21.082.149-2.011c.144-.966.48-1.614 1.013-1.96.53-.331 1.538-.55 2.998-.646l3.669-.108zm85.36-16.679c-.365.25-.761.537-1.212.879a61.69 61.69 0 01-2.208 1.49c-1.008.645-1.978 1.091-2.869 1.318-.907.23-1.915.161-3.052-.17l-3.789-1.324-26.875-10.758-5.711 4.52 4.527 28.551.438 4.027c.019 1.183-.097 2.12-.353 2.83-.263.727-.847 1.49-1.768 2.321l-2.145 1.938.437.552 25.595-20.258-.436-.554-2.539 1.788a27.27 27.27 0 01-2.205 1.246c-.601.277-1.13.124-1.619-.473-.314-.42-.621-1.327-.895-2.759-.275-1.43-.609-3.458-.98-6.096s-.898-6.559-1.588-11.743a528.606 528.606 0 019.292 3.565c3.182 1.245 5.423 2.186 6.724 2.824 1.3.636 2.149 1.194 2.55 1.702.467.566.568 1.14.307 1.72-.261.581-.654 1.142-1.177 1.686a19.814 19.814 0 01-1.636 1.527c-.558.45-1.082.898-1.533 1.287l.437.553 14.72-11.637zm13.138-79.343l-16.013 29.112.617.333c.16-.288.388-.678.669-1.153.285-.493.775-1.277 1.498-2.357.709-1.079 1.363-1.76 1.965-2.069.583-.289 1.325-.277 2.179.034l1.843.845 18.346 10.01 1.708 1.09c.758.573 1.18 1.16 1.273 1.773.083.597-.178 1.576-.772 2.896l-1.697 3.43.632.33 15.9-28.904-.625-.354-1.948 3.276c-.78 1.241-1.437 2.003-1.971 2.266-.533.264-1.268.233-2.213-.129l-1.843-.845-18.504-10.074-1.71-1.09c-.783-.59-1.193-1.215-1.226-1.837-.03-.64.247-1.62.847-2.96l1.656-3.27zm29.329-56.196l9.46 8.071-11.771 3.9zm-3.305 12.293l-4.911 1.3c-1.14.274-2.01.354-2.613.241-.658-.13-1.067-.473-1.226-1.049-.157-.579-.208-1.293-.138-2.144.054-.852.15-1.685.267-2.456.119-.795.249-1.567.353-2.317l-.687-.127-3.79 19.591.7.126.957-4.063c.413-1.52.87-2.64 1.392-3.344.51-.723 1.084-1.24 1.708-1.533.625-.289 1.36-.61 2.194-.962a27.899 27.899 0 012.267-.844l27.305-8.63 1.464-7.6-21.905-19.195-2.967-2.813c-.768-.776-1.277-1.574-1.532-2.312-.266-.738-.34-1.703-.224-2.939l.382-2.869-.697-.146-6.36 32.903.7.126c.1-.559.21-1.054.299-1.487a50.09 50.09 0 01.656-2.353c.336-1.13.66-1.923.946-2.413.283-.45.722-.66 1.328-.546.645.11 1.477.625 2.54 1.5l4.11 3.331z' fill='%23f0e53c'/%3e%3cpath d='M2196.904 1317.706c7.107 31.757 29.836 42.062 34.886 41.623-1.215.746-1.848 1.053-3.265 1.206 0 0 2.213 1.08 4.425 2.375l-5.574-1.073 2.524 3.216c-2.754-1.09-4.915-2.806-4.915-2.806l.912 3.085-4.709-3.916.996 3.198c-5.305-3.85-8.193-8.231-8.193-8.231l.217 3.287c-3.908-4.992-16.56-30.9-17.99-40.465' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-linecap='round' stroke-miterlimit='8'/%3e%3cpath d='M2136.746 1304.693c5.436 8.296 15.252 16.386 24.27 19.873-1.017.703-2.256 1.228-4.355 1.849 8.235.726 36.584 8.02 40.862-5.299.135-.42.15-.869.196-1.259-6.404 11.575-22.613 10.465-34.113-8.277-.286.449.044 1.439-.12 1.919-2.67-2.369-5.398-5.098-7.752-7.677.27 1.233.51 3.148.51 5.383-.911-2.06-3.001-5.466-4.55-7.221.487 1.829.514 2.794.528 4.443-.93-2.838-2.87-5.549-4.038-7.282.196 1.98.349 3.306.262 5.207-1.05-2.488-2.655-4.342-4.38-6.078.48 1.515.999 3.389 1.075 4.438-1.121-1.831-2.886-3.359-4.012-4.618.225 1.079 1.163 3.255 1.343 4.184-1.71-1.482-3.527-3.194-5.301-4.184.363 1.363 1.857 4.019 3.958 5.878-1.79-.24-2.796-.482-4.383-1.279' fill='%2374b500'/%3e%3cpath d='M2136.746 1304.693c5.436 8.296 15.252 16.386 24.27 19.873-1.017.703-2.256 1.228-4.355 1.849 8.235.726 36.584 8.02 40.862-5.299.135-.42.15-.869.196-1.259-6.404 11.575-22.613 10.465-34.113-8.277-.286.449.044 1.439-.12 1.919-2.67-2.369-5.398-5.098-7.752-7.677.27 1.233.51 3.148.51 5.383-.911-2.06-3.001-5.466-4.55-7.221.487 1.829.514 2.794.528 4.443-.93-2.838-2.87-5.549-4.038-7.282.196 1.98.349 3.306.262 5.207-1.05-2.488-2.655-4.342-4.38-6.078.48 1.515.999 3.389 1.075 4.438-1.121-1.831-2.886-3.359-4.012-4.618.225 1.079 1.163 3.255 1.343 4.184-1.71-1.482-3.527-3.194-5.301-4.184.363 1.363 1.857 4.019 3.958 5.878-1.79-.24-2.796-.482-4.383-1.279z' fill='none' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2196.191 1320.267c8.548 34.638 9.97 47.651 17.521 54.69l-2.203-5.426 5.52 4.557-3.628-5.479 5.365 2.716c-2.516-2.804-5.86-5.298-7.914-8.464l4.873 2.968c-6.448-7.12-16.587-37.925-18.82-45.483' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-linecap='round' stroke-miterlimit='8'/%3e%3cpath d='M2196.13 1312.978c-.12.21-1.9 11.396-3.564 16.08-2.072 5.824-6.437 10.56-6.81 15.186 0 0 2.395-3.264 4.885-4.72 0 0-3.237 4.233-4.076 9.241 0 0 3.31-4.673 5.238-5.86 0 0-3.901 6.015-4.71 10.403l5.29-5.787c-1.587 3.255-4.17 8.712-4.17 8.712 1.45-1.676 5.125-5.072 5.125-5.072-2.105 3.64-3.724 8.214-3.724 8.214 1.229-1.64 3.547-3.827 3.547-3.827-1.69 3.33-2.395 7.147-2.395 7.147 1.078-1.95 3.443-3.735 3.443-3.735-1.211 2.015-1.95 6.307-1.95 6.307 1.328-2.863 3.303-4.729 3.303-4.729-1.631 3.415-1.394 8.41-1.394 8.41.887-2.403 1.165-3 2.808-4.872-.691 4.164 1.656 9.447 1.656 9.447-.064-2.463.615-5.105.615-5.105.194 3.224 2.762 6.851 2.762 6.851-.273-2.299-.181-4.033-.181-4.033.855 2.64 3.033 5.295 3.033 5.295.045-2.328-.933-6.607-.933-6.607 1.029.627 1.81 3.33 1.81 3.33.06-4.746-2.997-9-2.997-9 .687-.045 1.964.661 1.964.661-.44-4.836-3.61-8.62-3.61-8.62 1.12 0 2.708.964 2.708.964-.671-1.79-3.392-5.445-3.392-5.445.807.08 2.128.62 2.128.62-.36-3.74-1.604-7.523-1.604-7.523 1.074.18 1.582.736 1.582.736-.33-4.108-5.217-21.185-5.778-32.88' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-linecap='round' stroke-miterlimit='8'/%3e%3cpath d='M2203.146 1371.325c-2.518-7.281-5.545-15.547-6.524-24.936-.586-5.61.26-15.106.13-20.993' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2196.333 1319.886s2.7 14.281 17.784 17.614c0 0-1.514-1.055-2.945-2.536 0 0 4.728 2.127 9.083 2.316 0 0-1.95-1.088-3.165-2.612 0 0 5.476 2.18 9.148 1.775 0 0-2.07-1.059-3.236-2.428 0 0 5.104 1.382 9.21.653 0 0-2.426-.467-3.858-2.053 0 0 5.073.83 9.242-.25 0 0-2.178-.186-3.578-1.586 0 0 7.685.236 11.637-4.667 0 0-1.96.653-4.294-.187 0 0 4.232-1.059 6.69-4.076 0 0-1.617.346-3.33-.125 0 0 3.258-1.224 5.249-3.216 0 0-1.327.384-3.257-.052 0 0 2.365-.75 3.61-2.738 0 0-1.494.63-3.112.094 0 0 3.382-1.908 3.589-5.643 0 0-1.401 2.2-3.06 2.905 0 0 2.272-2.849 2.479-5.843 0 0-2.681 2.41-4.175 4.567 0 0 .493-2.603 1.323-4.139 0 0-2.82 1.597-4.216 5.664 0 0-.67-2.458-.358-3.61 0 0-2.116 2.24-2.832 5.29 0 0-.6-1.76-.622-3.018 0 0-2.315 1.836-2.956 5.57 0 0-.654-2.863-.34-4.575 0 0-3.488 3.368-4.234 8.464 0 0-1.401-2.83-.997-6.535 0 0-3.142 4.488-4.201 9.325 0 0-1.43-3.444-1.168-6.237 0 0-2.662 3.737-4.148 8.081 0 0-.246-3.358.065-6.75 0 0-3.086 4.333-5.078 7.466 0 0 .196-2.734 1.483-5.799 0 0-5.654 3.654-8.392 6.403-.953.957-8.298 1.285-11.981-7.13' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2200.657 1277.609c-.385 14.535-1.077 25.035-1.672 34.823-.321-1.556-.891-2.669-2.081-2.696-2.601-.061-2.58 3.019-2.581 3.031.08-12.231.561-31.263 1.077-51.275 0 .016.344 11.13 5.257 16.117' fill='%23473125'/%3e%3cpath d='M2196.988 1309.496c1.189.027 1.676.784 1.997 2.34-.178 2.929-.154 2.222-.353 4.239-.149 5.218-4.16 5.896-4.32-.591-.04-1.608-.011-.027.009-3.051.001-.014.065-2.998 2.667-2.937' fill='%23292723'/%3e%3cpath d='M2206.355 1211.836c-.677 1.174-1.647 1.976-3.05 3.345-1.366 1.332-1.174 3.91-1.346 5.415-.194 1.7-.583 29.968-1.303 57.23-5.284-4.235-5.257-16.098-5.257-16.116.55-21.248 1.1-39.928 1.134-41.266.06-2.34.218-3.823-.899-5.232-.674-.85-1.883-2.07-2.758-3.178-.767-.971-.163-1.85 2.322-2.566 2.154-.62 1.891-1.017 4.336-1.017 2.444 0 2.747.459 3.926.88.85.302 3.766.995 2.895 2.505' fill='%23cbcbc9'/%3e%3cpath d='M2199.742 1326.874c5.698 5.607 22.242 4.909 29.048 2.008 8.028-3.423 12.57-7.818 17.083-14.625' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2196.533 1220.381c.06-2.34.219-3.823-.898-5.232-.674-.85-1.883-2.07-2.758-3.177-.768-.973-.164-1.852 2.322-2.568 2.154-.62 1.891-1.016 4.335-1.016s2.747.46 3.927.88c.848.301 3.764.995 2.894 2.505-.676 1.174-1.647 1.976-3.05 3.345-1.366 1.332-1.173 3.91-1.346 5.416-.328 2.878-1.213 74.067-3.327 95.478-.149 5.219-4.16 5.896-4.32-.59-.37-15.017 2.146-92.132 2.221-95.04z' fill='none' stroke='black' stroke-width='.888'/%3e%3cpath d='M2195.934 1313.237c-3.539 17.21-1.74-7.116-5.489-13.443.05 1.362-.32 3.659-1.404 6.407.31-5.07.128-10.005-1.326-12.615.091 1.26-.45 4.35-1.69 7.338.176-2.403.663-8.263-.498-10.545-.255 1.438-1.03 4.747-1.864 6.557.407-3.751.318-7.916-.79-10.637-.28 2.663-.929 5.899-1.552 7.58.214-3.911-.667-9.7-2.287-12.668.372 2.022.855 7.444.043 10.533-.31-4.288-2.424-8.3-3.55-10.304-.107-.24 1.422 7.176 1.11 10.226-1.244-1.867-2.67-5.757-3.315-7.495-.418 3.23-.294 5.596 1.324 9.415-1.307-1.23-2.508-2.788-3.498-4.198.49 2.319 2.982 6.882 3.958 8.472-1.353-.741-3.748-3.255-4.859-4.454 1.395 3.18 4.167 6.827 6.266 9.316-1.564-.74-3.537-2.298-4.932-3.108 2.25 2.79 5.344 6.193 8 8.742-1.813-.644-2.878-.96-4.4-1.905 5.177 6.178 10.086 10 17.214 14.348 0 0 4.23 2.485 4.057-7.821' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2175.957 1295.755c4.64 9.596 8.985 15.736 17.247 24.131m-50.733-13.119c5.251 4.813 34.271 29.043 50.732 18.907' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2196.904 1317.706c-1.156 6.528-16.34 16.369-40-3.068 0 0 2.06.552 4.145.459 0 0-2.687-5.3-6.96-9.823l3.754.768c-1.929-3.112-5.602-6.248-5.602-6.248l2.88.165c-1.058-2.335-4.216-4.933-4.216-4.933 2.961.857 5.927 3.112 5.927 3.112-.434-2.7-2.326-6.491-2.326-6.491 4.066 2.278 5.271 6.923 5.271 6.923.137-3.044-.43-9.301-.43-9.301s2.82 6.242 3.72 12.874c0 0 1.095-2.892 1.498-6.666 0 0 1.682 4.61 1.788 10.92 0 0 1.564-2.928 1.891-5.058 0 0 .931 4.34 1.012 8.546 0 0 1.251-2.423 1.652-4.447 0 0 1.084 4.425.633 7.7 0 0 1.263-2.235 1.921-4.451 0 0 .905 4.302.507 7.655l2.262-3.822c-.613 2.698.067 4.972 1.171 6.72.971 1.538 1.033 4.862 1.033 4.862 2.22 1.23 17.78.958 16.651-10.284' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2156.244 1300.573c2.998 2.79 6.928 8.817 9.76 13.436 2.85 4.618 7.542 9.304 11.65 10.474' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2197.718 1312.432c-.822 15.142-8.28 26.836-17.608 35.405l.393-3.232c-4.03 5.85-11.953 9.68-11.953 9.68 3.392-2.986 5.42-7.94 5.42-7.94-3.932 4.19-10.08 7.122-10.08 7.122 1.7-1.632 4.367-5.875 4.367-5.875-4.023 3.184-8.692 4.523-8.692 4.523 2.545-1.635 5.456-5.228 5.456-5.228-4.082 2.67-9.543 3.112-9.543 3.112 2.925-1.056 6.866-4.253 6.866-4.253-4.546 1.901-10.219 1.743-10.219 1.743 2.5-.793 7.073-3.316 7.073-3.316-5.185 1.262-9.75.287-9.75.287 4.655-.786 7.51-2.382 7.51-2.382-3.899.57-7.969-.337-7.969-.337 2.867-.205 5.708-1.534 5.708-1.534-2.572.021-5.954-1.182-5.954-1.182 2.532.125 4.565-.685 4.565-.685-3.112-.207-5.332-1.762-5.332-1.762 2.262.227 3.983-.624 3.983-.624-2.24-.269-4.25-1.99-4.25-1.99 1.935.323 4.706.518 4.706.518-1.195-.668-3.65-2.988-3.65-2.988 2.15.167 4.898 1.68 4.898 1.68-1.395-3.252-3.326-4.982-3.326-4.982 2.873 1.254 6.402 4.258 6.402 4.258-.332-2.365-2.83-5.436-2.83-5.436 4.721 1.54 6.993 5.357 6.993 5.357-.316-4.106-2.904-5.804-2.904-5.804 5.878 1.194 7.685 6.397 7.685 6.397.367-3.922-1.278-6.158-1.278-6.158 4.886 2.021 6.387 6.996 6.387 6.996.499-4.318-1.531-6.124-1.531-6.124 3.601 1.376 6.142 6.561 6.142 6.561.35-4.464-1.838-6.11-1.838-6.11 6.816 1.258 8.787 5.23 8.787 5.23.046-2.344-1.433-3.972-1.433-3.972 4.97 1.628 5.07 6.422 7.356 4.804 2.52-1.783 4.427-5.396 5.67-10.218.616-2.395 2.4-11.54 2.4-11.54' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2154.275 1335.25c9.947 6.607 24.501 8.42 34.54.37' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2199.598 1323.027s4.636 19.217 25.173 17.616c0 0-3.637 2.614-6.717 3.081 0 0 6.542 1.559 10.94-2.56 0 0-.117 2.324-2.188 4.096 0 0 5.063-.89 8.238-4.227 0 0-.156 2.286-1.245 4.184 0 0 5.01-2.146 7.52-5.465 0 0-.414 1.867-1.41 3.858 0 0 4.17-2.098 7.737-6.109 0 0-.634 2.933-2.646 4.634 0 0 1.922-.455 3.393-1.367 0 0-4.076 6.534-12.903 8.983 0 0 2.157 1.991 4.813 1.991 0 0-6.556 2.945-13.733.456 0 0 1.162 2.086 4.99 4.128 0 0-5.913.498-9.507-4.294 0 0 .14 1.681 1.446 3.983 0 0-3.485-2.396-5.227-5.239 0 0 .186 1.816 1.535 3.911 0 0-2.967-2.312-4.57-5.207 0 0 .141 2.272 1.494 4.004 0 0-14.615-7.44-18.424-31.289' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2200.252 1326.627c2.427 12.49 20.597 30.889 42.899 16.444' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2210.628 1314.637c4.109-3.417 14.568-14.762 17.79-24.329 0 0 .355 4.75-1.308 9.433 0 0 3.507-3.516 4.616-12.096 0 0 .922 3.024.573 5.715 0 0 1.137-2.264 4.3-5.202l-1.782 5.52c1.66-1.609 2.645-2.739 4.829-4.402 0 0-.164 2.917-4.617 7.917l4.617-2.074s-1.438 2.961-5.164 5.711c0 0 2.308.313 4.42-.743 0 0-1.408 2.23-5.515 4.49l5.136-.208c-3.223 3.988-17.58 14.198-25.795 16.626' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-linecap='round' stroke-miterlimit='8'/%3e%3cpath d='M2197.586 1313.711c3.35 8.894 5.886-14.219 7.27-26.123l1.86 2.764s-.415-6.8 2.128-12.49l.769 8.2s1.359-1.432 1.795-2.199c0 0 .008 4.513-2.186 9.157l2.186-1.238c-.45 3.33-3.224 8.312-3.224 8.312l2.998-1.614c-1.111 3.21-12.693 33.263-14.43 15.041' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-linecap='round'/%3e%3cpath d='M2214.566 1316.555c10.57-6.764 14.433-12.809 19.193-21.196m-35.452 21.245c4.033 4.892 9.001-19.623 10.676-28.833' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2196.217 1312.767c-.056 3.354 2.107 18.163 10.407 16.896 10.212-1.56 13.329-20.26 13.54-22.432 0 0-1.236 2.042-2.834 3.452 0 0 1.76-5.688 1.3-9.294 0 0-1.183 5.421-2.691 8.044 0 0 .89-3.609.093-5.88 0 0-.673 4.72-2.468 6.886 0 0 .622-3.132-.041-4.689 0 0-.498 3.755-2.366 6.183 0 0 .477-2.345-.145-4.398 0 0-.384 2.91-2.212 6.297 0 0 .14-2.21-.391-3.663 0 0-.42 3.361-1.94 5.601 0 0-.083-2.115-.436-3.67 0 0-.355 2.823-1.9 5.348 0 0-.008-2.445-.506-3.814 0 0-.622 2.966-1.93 5.062 0 0 .099-2.075-.442-3.803 0 0-1.098 3.293-2.288 4.992-.75-1.355-2.396-5.027-2.072-7.118' fill='%2374b500' stroke='%231b402f' stroke-width='.666' stroke-miterlimit='8'/%3e%3cpath d='M2201.552 1327.138c6.64 4.52 12.114-5.477 15.035-14.706' fill='none' stroke='%231b402f' stroke-width='.553' stroke-linecap='round'/%3e%3cpath d='M2126.27 1302.313c3.478 2.52 6.237 6.566 9.911 6.657-1.229-1.739-.899-2.039-2.114-3.328-1.23-1.26-4.14-3.568-4.844-3.629-.705-.03-2.953.15-2.953.15' fill='white' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2115.279 1215.616c-1.035-3.48-6.208-15.024-7.228-16.645-1.034-1.588-.104-3.357-1.034-4.587-.945-1.23-2.818-2.07-3.3-3.57-.463-1.5 1.41-24.23.482-24.71-.945-.45-6.478.749-6.958 2.729-.464 1.979.855 1.89 0 3.388-.84 1.5-.66 2.34-.555 3.75.09 1.41 3.194 14.844 3.374 19.732.195 4.889 1.649 25.34 1.649 25.34z' fill='white'/%3e%3cpath d='M2115.279 1215.616c-1.035-3.48-6.208-15.024-7.228-16.645-1.034-1.588-.104-3.357-1.034-4.587-.945-1.23-2.818-2.07-3.3-3.57-.463-1.5 1.41-24.23.482-24.71-.945-.45-6.478.749-6.958 2.729-.464 1.979.855 1.89 0 3.388-.84 1.5-.66 2.34-.555 3.75.09 1.41 3.194 14.844 3.374 19.732.195 4.889 1.649 25.34 1.649 25.34z' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2091.797 1215.316c.286-2.249 4.32-11.815 5.73-14.365 1.408-2.519.748-4.798.943-6.177.18-1.41 1.5-1.529 1.5-2.939 0-1.41 1.59-15.235 1.32-18.023-.286-2.819.374-4.798 1.68-5.728-.376-.929-.932-2.339.748-4.229 1.695-1.889 4.201-4.057 5.805-4.057 1.59 0 1.152 1.238 1.152 1.238s1.604.57.661 2.549c-.945 1.95-3.569 3.75-3.764 4.499-.18.749.75 2.998-.18 5.068-.946 2.069-3.029 17.183-2.909 20.303.09 2.428.09 4.317-.765 6.657-.84 2.339 1.784 11.455 1.784 15.864l-6.387 3.777z' fill='white'/%3e%3cpath d='M2091.797 1215.316c.286-2.249 4.32-11.815 5.73-14.365 1.408-2.519.748-4.798.943-6.177.18-1.41 1.5-1.529 1.5-2.939 0-1.41 1.59-15.235 1.32-18.023-.286-2.819.374-4.798 1.68-5.728-.376-.929-.932-2.339.748-4.229 1.695-1.889 4.201-4.057 5.805-4.057 1.59 0 1.152 1.238 1.152 1.238s1.604.57.661 2.549c-.945 1.95-3.569 3.75-3.764 4.499-.18.749.75 2.998-.18 5.068-.946 2.069-3.029 17.183-2.909 20.303.09 2.428.09 4.317-.765 6.657-.84 2.339 1.784 11.455 1.784 15.864l-6.387 3.777z' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2071.6 1220.294c0-1.68 3.943-10.405 3.39-11.726-.57-1.32-2.446-3.21-2.355-4.408.09-1.23 5.443-14.274 5.352-21.231.091-1.68 1.784-2.071 2.624-3.3.856-1.2-1.303-1.108 0-2.61 1.321-1.53 5.173-3.388 9.492-3.206.285.479.195.837 0 1.228 0 0 .945 1.11-.465 2.16-1.41 1.02-2.819 2.519-4.513 2.999 0 0-1.125.929-.75 1.68.374.749-.135 2.638-1.514 4.317-1.394 1.709-3.613 9.417-4.003 14.486-.405 5.066 4.107 12.865 6.267 14.093l-6.267 6.268z' fill='white'/%3e%3cpath d='M2071.6 1220.294c0-1.68 3.943-10.405 3.39-11.726-.57-1.32-2.446-3.21-2.355-4.408.09-1.23 5.443-14.274 5.352-21.231.091-1.68 1.784-2.071 2.624-3.3.856-1.2-1.303-1.108 0-2.61 1.321-1.53 5.173-3.388 9.492-3.206.285.479.195.837 0 1.228 0 0 .945 1.11-.465 2.16-1.41 1.02-2.819 2.519-4.513 2.999 0 0-1.125.929-.75 1.68.374.749-.135 2.638-1.514 4.317-1.394 1.709-3.613 9.417-4.003 14.486-.405 5.066 4.107 12.865 6.267 14.093l-6.267 6.268z' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2054.507 1225.511c.286-2.669 4.14-11.695 4.319-16.673-.09-1.768-.66-3.09-.556-4.408.09-1.319 1.786-3.299 1.786-5.818 0-2.549 1.033-16.614.268-17.484.57-1.589 1.633-2.927 2.579-3.226-1.035-.93-1.17-2.022-.883-3.04.284-1.05 2.53-4.984 4.258-5.19 1.332-.158 1.503.837 1.503.837s1.466-1.017 1.286 1.323c-.195 2.37-.788 4.518-2.79 6.028-1.217.917-.148 1.86 0 2.16.166.268 1.17 2.247 0 4.226-1.154 1.951-1.53 4.02-1.724 6.088-.18 2.071-.375 8.457-.09 9.957.285 1.5 1.59 2.73 1.125 5.82-.465 3.117.749 12.263 5.068 14.632l-9.296 6.388z' fill='white'/%3e%3cpath d='M2054.507 1225.511c.286-2.669 4.14-11.695 4.319-16.673-.09-1.768-.66-3.09-.556-4.408.09-1.319 1.786-3.299 1.786-5.818 0-2.549 1.033-16.614.268-17.484.57-1.589 1.633-2.927 2.579-3.226-1.035-.93-1.17-2.022-.883-3.04.284-1.05 2.53-4.984 4.258-5.19 1.332-.158 1.503.837 1.503.837s1.466-1.017 1.286 1.323c-.195 2.37-.788 4.518-2.79 6.028-1.217.917-.148 1.86 0 2.16.166.268 1.17 2.247 0 4.226-1.154 1.951-1.53 4.02-1.724 6.088-.18 2.071-.375 8.457-.09 9.957.285 1.5 1.59 2.73 1.125 5.82-.465 3.117.749 12.263 5.068 14.632l-9.296 6.388z' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2060.954 1261.948c-6.192 10.676-18.848-1.08-14.62-9.656 1.185-2.368 3.644-1.793 6.103-1.313-1.124.03-2.22 1.213-2.49 1.882.676-.046 1.405.15 2.179.364-.762.592-1.188 1.059-1.453 2.066a5.1 5.1 0 012.029-.073c-.656 1.003-1.04 1.835-1.1 2.638.725-.222 1.3-.218 2.137 0-.248.252-.837.923-.897 2.202 1.8-.21 3.014-1.677 3.989-3.238z' fill='white'/%3e%3cpath d='M2060.954 1261.948c-6.192 10.676-18.848-1.08-14.62-9.656 1.185-2.368 3.644-1.793 6.103-1.313-1.124.03-2.22 1.213-2.49 1.882.676-.046 1.405.15 2.179.364-.762.592-1.188 1.059-1.453 2.066a5.1 5.1 0 012.029-.073c-.656 1.003-1.04 1.835-1.1 2.638.725-.222 1.3-.218 2.137 0-.248.252-.837.923-.897 2.202 1.8-.21 3.014-1.677 3.989-3.238z' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2124.32 1237.539c1.635 1.618 2.385 6.866 3.015 9.266.629 2.369.869 6.627.749 10.496 1.5 1.768 1.004 4.767 1.5 8.786 1.259 2.01 1.124 9.146.885 12.025-.255 2.879.374 4.259 1.875 5.367 1.498 1.142 6.642 3.15 8.515 2.13 1.875-.988 4.004-.24 4.004.75 2.263-.12 3.134 2.759 2.64 4.379 0 0 .929 2.309-2.894 3.899-3.69 1.529-8.008 4.498-9.508 5.637-1.514 1.11-3.134 1.68-6.642 2.008-7.002.632-9.761-3.628-11.771-5.906-2.82-3.18-4.767-10.496-5.516-13.765-.751-3.27-3.255-13.525-4.754-16.524-1.5-3-2.01-4.528-2.76-7.527-3.253 1.019-6.506.75-10.766.509-4.258-.24-11.515 4.259-18.277 5.998-6.777 1.77-17.544-2.49-19.043-7.257-1.5-4.768-5.502-6.748-5.757-9.777-.255-3-1.006-3.987-1.5-5.997-.51-2.01.99-9.776 1.245-12.266.255-2.52 2.395-3.95 3.904-5.037l.354-.241 1.248-.87s.584-2.266 2.32-3.604l.647 3.396c1.209-2.701 2.548-3.374 2.548-3.374l.529 2.814c.962-2.35 2.15-2.95 2.15-2.95l1.31 2.674s.442-1.534 1.47-3.228l1.348 1.792s-.088-1.927.604-3.22l1.854 2.073c.135-2.88 1.635-.51 2.384-2.88.75-2.368.714-2.03 1.487-3.421 0 0 1.26 1.103 2.142 2.67l.71-2.818s1.138 1.095 1.648 1.95l.655-2.52s1.156.48 1.74 1.737l.63-2.366s1.064.347 2.016 2.117l1.143-2.817 1.43 2.559s.845-2.13 2.187-4.018l1.837 3.565c.787-1.846 1.21-2.684 3.133-4.418l.664 3.162s.767-2.31 2.198-3.54l1.266 3.24c.363-1.332.807-2.47 1.66-3.568l1.33 2.958c.353-2.386 1.618-3.378 1.618-3.378l.954 3.089s.576-1.801 1.74-3.336l.638 3.28s.673-1.907 1.872-2.794l1.21 3.17s.449-1.74 1.414-2.554l1.245 3.003 1.71-2.567c.995 1.245 1.198 1.534 1.737 3.327l1.143-1.438s1.44 1.344 1.758 3.53l1.048-1.041s.887 1.85 1.332 3.957l.94-.645c.75 1.685 1.132 4.303 1.132 4.303l.838-.558c.585 2.164.84 4.155.84 4.155l1.115-.447c.366 1.49.612 3.118.527 4.583l.972-.044s.228 4.34-1.568 8.357' fill='white'/%3e%3cpath d='M2124.32 1237.539c1.635 1.618 2.385 6.866 3.015 9.266.629 2.369.869 6.627.749 10.496 1.5 1.768 1.004 4.767 1.5 8.786 1.259 2.01 1.124 9.146.885 12.025-.255 2.879.374 4.259 1.875 5.367 1.498 1.142 6.642 3.15 8.515 2.13 1.875-.988 4.004-.24 4.004.75 2.263-.12 3.134 2.759 2.64 4.379 0 0 .929 2.309-2.894 3.899-3.69 1.529-8.008 4.498-9.508 5.637-1.514 1.11-3.134 1.68-6.642 2.008-7.002.632-9.761-3.628-11.771-5.906-2.82-3.18-4.767-10.496-5.516-13.765-.751-3.27-3.255-13.525-4.754-16.524-1.5-3-2.01-4.528-2.76-7.527-3.253 1.019-6.506.75-10.766.509-4.258-.24-11.515 4.259-18.277 5.998-6.777 1.77-17.544-2.49-19.043-7.257-1.5-4.768-5.502-6.748-5.757-9.777-.255-3-1.006-3.987-1.5-5.997-.51-2.01.99-9.776 1.245-12.266.255-2.52 2.395-3.95 3.904-5.037l.354-.241 1.248-.87s.584-2.266 2.32-3.604l.647 3.396c1.209-2.701 2.548-3.374 2.548-3.374l.529 2.814c.962-2.35 2.15-2.95 2.15-2.95l1.31 2.674s.442-1.534 1.47-3.228l1.348 1.792s-.088-1.927.604-3.22l1.854 2.073c.135-2.88 1.635-.51 2.384-2.88.75-2.368.714-2.03 1.487-3.421 0 0 1.26 1.103 2.142 2.67l.71-2.818s1.138 1.095 1.648 1.95l.655-2.52s1.156.48 1.74 1.737l.63-2.366s1.064.347 2.016 2.117l1.143-2.817 1.43 2.559s.845-2.13 2.187-4.018l1.837 3.565c.787-1.846 1.21-2.684 3.133-4.418l.664 3.162s.767-2.31 2.198-3.54l1.266 3.24c.363-1.332.807-2.47 1.66-3.568l1.33 2.958c.353-2.386 1.618-3.378 1.618-3.378l.954 3.089s.576-1.801 1.74-3.336l.638 3.28s.673-1.907 1.872-2.794l1.21 3.17s.449-1.74 1.414-2.554l1.245 3.003 1.71-2.567c.995 1.245 1.198 1.534 1.737 3.327l1.143-1.438s1.44 1.344 1.758 3.53l1.048-1.041s.887 1.85 1.332 3.957l.94-.645c.75 1.685 1.132 4.303 1.132 4.303l.838-.558c.585 2.164.84 4.155.84 4.155l1.115-.447c.366 1.49.612 3.118.527 4.583l.972-.044s.228 4.34-1.568 8.357z' fill='none' stroke='black' stroke-width='.751' stroke-miterlimit='8'/%3e%3cpath d='M2120.586 1297.095c-.419 1.738-1.693 9.956 4.32 11.875.24-1.769-.63-3.328-1.32-5.338-.69-2.04-1.035-3.569-.706-4.708' fill='white' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2124.006 1307.62c-.75-.66-2.054-1.078-1.59-4.467' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2128.143 1294.127c1.188.119 1.831-.991 2.685-.93.84.03 1.75 1.248 2.321 1.327.58.08.872.082 1.382-.428' fill='none' stroke='black' stroke-width='1.127' stroke-linecap='round'/%3e%3cpath d='M2147.396 1290.467c-.51-.18-1.454 1.5-2.533.75m-5.308-3.717c.704.148 3.808.06 5.547-1.141m-41.444-27.799c.135-.99-2.624-3.629-3.748-5.639m24.41-15.382c-1.73-1.8-6.012-6.51-6.251-9.778m-28.686 30.182c-4.081-1.384-7.286-4.182-7.632-8.26m12.511 7.387c-1.805-.75-1.805-1.917-3.874-2.423m-2.503-7.213c-.496-1.32-1.347-3.229-1.826-4.577m-1.189-2.83a27.174 27.174 0 01-.99-2.879m-30.245 15.232c.614-3.72-2.247-5.997-3.446-9.084m1.498-4.139c-.419-3.18-1.813-6.07-1.064-9.711m6.208 13.58c-.9-1.11-1.365-2.4-1.38-3.869m10.511 9.386c-.794-1.798-1.217-3.676-.75-5.686m2.505 4.696c.089-3.988-3.599-6.867-4.153-10.915-.616-4.379 1.373-7.888 1.149-12.267m1.624 13.646c-.09-2.788-.24-5.788 1.14-8.127m-.134-3.15c-.195-1.617.284-3.087 1.379-4.228m2.504 2.611c.884-2.49 2.954-3.75 4.512-5.88m-2.128 9.507c-.314 2.22.48 4.319.614 6.659m1.379-7.649c.21-2.908-.344-6.057 1.515-8.517m6.013-3.267c-.616 3.598-4.543 5.758-4.259 9.535m4.124 1.62c0-2.908-.143-5.214 1.33-7.888m1.789-3.267c.735 3.018.835 5.067 0 8.127 2.608-2.399 2.205-6.969 1.89-9.356m-1.125 13.375c-.45.39-.675.929-.63 1.529m27.184 8.996c-.397-1.765-.646-3.88.12-5.758m-3.134-6.387c1.17-1.98 1.155-4.23 3.015-5.878m-1.802-1.649c1.514-1.685 2.193-2.85 2.315-4.499m2.05 1.86c-.044.929-.845 2.369-1.754 3.277m3.851-2.181c.209 1.35.158 3.252-.141 4.541m2.109-2.098c-.645 2.849-3.435 4.167-3.75 7.257m-1.378-2.49c.539-1.079-.498-2.669.042-3.929m8.223 26.641c.689-1.519 1.555-3.022 2.32-4.372m-4.018.155c.255-2.12 1.514-2.12 2.444-4.792m.22 18.598c.782-1.685 1.668-3.15 2.853-5.436m-3.073.185c.729-1.532 1.62-3.329 2.504-4.768m1.191 11.756c-1.047 1.186-1.829 2.308-2.747 3.511m3.442.374c-1.316 1.95-2.195 3.267-3.09 5m3.734-.125c-1.526 2.49-2.189 3.604-3.486 6.907m4.066-1.762c-.954 1.41-1.97 4.128-2.53 5.704m-30.298-24.858c.479.784 1.538 1.878 2.27 2.06m-9.364-8.567c.39.63.915 1.2 1.5 1.618m-35.478-17.452c-.584-1.35.586-2.55.017-3.72-.541-1.078-3.044-2.127-1.454-3.146m-1.59 7.016c-.3-1.2.39-1.83.24-2.91m67.445 65.916c-.09-.72.209-1.26.869-1.498m.255-.751c-.135-.81.164-1.41.884-1.74m.494-1.649c.422-.84.557-2.039.377-3.118m2.878-2.37c1.334-.688 2.923-1.318 4.257-1.77m-.493 2.01c.045-.51.255-.84.63-1.14m-78.407-23.51a75.85 75.85 0 00-1.215 1.889m.091-4.319c-.809.54-1.319 1.47-1.5 2.55m-.787-3.69c.208-.81.146-.937.464-1.507m.323-1.941c-.875.858-1.312 1.667-1.574 3.067m1.327 1.863c-.543.654-.726 1.207-.846 1.787m2.398.211c-.33.569-.75 1.318-1.02 1.889m2.055.27c.015.899.554 1.71 1.32 2.069m-.196-1.679c.842-.062 1.482-.232 2.55-1.104m10.51-85.325c.106-.928 2.205-2.937 1.755-4.376m17.498 7.586c1.784-.39 4.23-2.07 4.89-2.91m17.377-9.955c.84-.84 2.624-2.55 3.193-4.05m-48.655 40.007a3.07 3.07 0 012.353 1.619m37.561-10.076c.84.72 1.47 1.77 1.694 2.818m6.017 21.533c-.078-1.695.25-2.97.281-4.439m1.319 2.07a2.844 2.844 0 01.375-1.859m-4.798 4.228c.1-2.303-.96-2.613-.924-4.604m1.251-.092c-.417-.856-.394-.877-.511-1.495m-2.439 7.029c.255-1.589-.21-3.207-.106-4.707' fill='none' stroke='black' stroke-width='.751' stroke-linecap='round'/%3e%3cpath d='M2065.903 1225.482c-.195-1.859-.131-2.504.582-4.16m2.431 2.901c.48-1.26 1.844-1.39 1.833-4.61m.965 2.427c-.077-2.25 1.12-3.407 1.702-5.601m-.442 4.461c.97-1.038 1.948-3.48 1.902-4.593m-.712 7.165c.63-1.108.272-1.144 1.16-2.288m2.09-.777c1.09-1.48 1.265-2.474 2.001-5.75m.762 5.067c.895-1.355 1.265-3.688 1.79-5.519m2.515 8.393c.853-2.539.883-3.773.704-6.143m-3.509 7.527c.09-1.859.44-3.238 1.176-5.007m6.09 1.925c.414-2.094.497-4.057.198-6.38m1.272 4.724c.521-3.538-.464-5.418 1.62-7.337m.312 2.489c.913 1.94-.487 4.548-1.146 6.587m5.006-3.268c.122-1.83.026-3.526-.479-5.394m-1.019 6.384c0-1.62.089-3.15.255-4.738m6.762-.001c-.075 1.47-.15 2.788-.255 4.258m-2.249-2.278c-.104 1.648-.18 3.148-.255 4.768m4.004-5.248v3m2.759-2.76v3.748m2.009-6.507c.99 1.769 1.038 3.865 1.004 6.028m4.664 7.639c-.224-1.23-.012-3.23.542-4.25m2.051-.391c.195-1.32.375-2.699.495-4.018m3.972 11.545c.335-1.528 1.037-4.348 1.037-6.152m0 7.887c.61-1.385 1.062-3.229 1.222-4.945m-.161 6.796c.855-1.35 1.326-3.262 1.442-5.115m-.116 6.796c.496-1.183.929-2.365.874-3.89m-5.511-3.385c.315-1.202.63-4.108.63-5.128m-2.638-2.64c.104-1.259.039-2.219-.216-3.389m-55.638 12.146c0-1.589.055-3.309.657-5.082m1.096 2.593c-.029-1.14.083-2.205.563-3.014m-3.816 1.874c-.167 1.254-.794 2.52-1.004 3.63m-1.63-4.171c.249 1.38-.094 2.971-.365 4.17m-2.808-1.185c-.151.83 0 1.244-.265 2.488m-1.957-1.303c-.284.45-.575 1.61-.548 2.21m3.349-1.245c-.17 1.354-.276 2.196.107 3.294m1.373-8.758c.104.631.003 1.5-.173 2.01m-6.349 9.266c-.092 1.35 0 2.73.254 3.988m-.761.022c-.187 1.795-.08 2.617.319 3.59m.442-2.352a3.722 3.722 0 001.5 2.76m-.751 3.747c.03.78.42 1.53 1.004 2.01m1.267-14.5c.372 1.158.492 1.675.64 2.92m-2.221-5.85c.06 2.115.548 3.646.89 5.445m-1.763.199c.183 2.405.747 3.422 1.805 4.479m46.465 16.574c-1.124-.18-2.22-.72-3-1.5m4.515 1.26c-.96-.48-2.303-.63-3.074-1.26m4.318.75c-.96-.33-2.008-.688-2.999-.99m-3.516-.51c-1.334-1.081-2.6-2.1-4.252-2.518m1.755 4.126c-1.454-.299-2.954-.948-4.257-1.608m7.691 2.01c-1.016.087-1.805-.072-2.55-.24m4.125-1.77c-.676-.45-1.469-1.558-2.01-2.008m27.559-11.237c.653-1.266.931-1.93 1.748-3.144m-1.192 4.357a37.34 37.34 0 011.627-2.785m-.744 6.697c.438-.851.85-1.703 1.531-2.745m-.611 6.517c.435-.9.726-1.607 1.451-2.793m-1.451 8.48c.51-.99 1.268-2.11 1.833-2.945m-1.581 4.563c.398-.623 1.02-1.618 1.677-2.386m-.469 5.435c.359-.51.979-1.43 1.43-1.909m-1.172 7.137c.457-.706.96-1.635 1.427-2.324m-.641 7.712c.386-.783 1.025-1.986 1.683-2.856m-.727 6.776c.146-.513.448-1.145.83-1.923m-6.904-36.161v-1.38m-1.13.427v-1.776m-1.374.367v-2.24m-1.498.746c.135-.99-.12-2.894-.804-4.104m9.676 53.542c.272-.33 1.009-.99 1.398-.99m-.334.99c1.343.63 2.071-.102 2.071-.75m0 1.965c-.029-.48.257-1.184.768-1.215m0 1.054c.351-.447.786-.643 1.346-.33m-.449.612a.715.715 0 001.154-.121m-48.967-28.331c.95.685 2.482 1.4 3.65 1.795m-3.827.092c.406.302 1.354.848 1.608.938m-3.786-.377c.457.378 1.13.777 1.971 1.224m-34.145-6.262c-.3.55-.364.844-.47 1.49m-1.754-.334c-.66 1.17-.66 2.7 0 4.019m1.259 2.009c.39.81 1.442 1.713 2.131 2.132m1.966.28c1.1 0 1.785-.592 2.329-1.463m-1.672-.468c.583-.138 1.105-.513 1.843-1.024m8.684-40.542v-2.759m.749 1.501c.255-.45.4-1.605.295-2.326m.896 1.49c.173-.892.172-1.323.053-2.163m-.59-.546c0-.964-.22-1.94-.49-2.81m9.338.597c.222-.674.363-1.166.621-2.01m.427 2.24c.338-1.22.584-2.24.216-3.739m1.583 3.348c.18-1.479.223-1.85.085-3.108m1.673 2.01c-.846-.621-.846-1.053-.846-1.562m1.763 2.163c0-.091.281-.722-.326-1.151m-1.493-1.79c-.202-.718-.688-.961-.943-1.291m-.746.631c-.365-1.11-.878-1.254-1.244-2.02m-.459-.588c-.788-1.174-1.503-1.96-1.24-3.025m3.154 8.512a9.004 9.004 0 00-.079-2.017m28.612-2.178c-.199-1.562-.516-2.864-.765-4.81m1.714 4.436c-.213-1.31-.284-1.866-.464-2.945m2.402 4.283c.106-.869-.288-2.065-.5-3.184m1.702 2.299c-.229-.78-.37-.957-.64-1.407m2.273 3.374c-.294-.765-.572-1.33-.915-2.14m-3.168-1.234c-.162-1.702-.368-2.678-.83-4.377m-1.555-1.867c.083.98.747 1.637 1.012 3.274m22.699 99.449c.519.313.6.479 1.037.979m0-.989c.314.421.788 1.093 1.328 1.28m-9.003-1.66c-.765-.45-.872-1.266-.238-1.769' fill='none' stroke='%23a4a5a8' stroke-width='.564' stroke-linecap='round'/%3e%3cpath d='M2135.285 1381.218h-3.812v5.171h3.812z' fill='white'/%3e%3cpath d='M2131.585 1381.33h3.59v4.948h-3.59zm3.812-.223h-4.035v5.394h4.035z'/%3e%3cpath d='M2135.285 1386.39l.529-.732v-5.288l-.53.62z' fill='white'/%3e%3cpath d='M2135.406 1381.035l.287-.336v4.92l-.287.396zm.529-.991l-.77.9v5.82l.77-1.066z'/%3e%3cpath d='M2120.837 1378.456s.83 1.973 2.884 2.179c2.053.206 3.028-1.04 3.485-1.6l-.311-1.036-4.543-.772z' fill='white'/%3e%3cpath d='M2120.976 1378.487l1.406-1.142 4.425.752.274.913c-.461.566-1.414 1.708-3.35 1.513-1.736-.175-2.58-1.68-2.755-2.036m1.343-1.38l-.04.032-1.578 1.283.033.078c.009.019.879 2.036 2.974 2.246 2.08.21 3.079-1.02 3.56-1.61l.063-.076-.35-1.161-.067-.011z'/%3e%3cpath d='M2119.459 1378.724l5.36.062 1.678.25-.308-9.315-7.1.001z' fill='white'/%3e%3cpath d='M2119.207 1369.835l6.874-.001.3 9.07-1.545-.227-5.27-.063zm7.09-.226h-7.324l.379 9.226.106.002 5.36.062 1.795.267-.004-.134z'/%3e%3cpath d='M2118.35 1373.351v-3.772s1.833-.044 5.723-.044l-.01 4.107s-3.076.016-5.713-.29' fill='white'/%3e%3cpath d='M2118.462 1369.688c.444-.009 2.246-.04 5.5-.04l-.01 3.881c-.568 0-3.194-.019-5.49-.278zm5.723-.266h-.112c-3.848 0-5.708.044-5.726.044l-.11.003v3.982l.1.011c2.615.304 5.69.293 5.727.291h.11l.001-.112z'/%3e%3cpath d='M2124.33 1374.995c-.038-.804-.686-1.426-1.445-1.39-.76.037-1.345.719-1.306 1.523.039.804.687 1.427 1.446 1.389.76-.037 1.345-.718 1.306-1.522' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2123.5 1375.035c-.016-.318-.272-.565-.573-.551-.302.015-.533.285-.518.604.016.319.272.565.573.55.302-.014.534-.284.518-.603' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2122.957 1375.528a.42.42 0 01-.282-.11.48.48 0 01-.155-.336.483.483 0 01.113-.338.42.42 0 01.3-.15h.018c.232 0 .426.197.438.447a.47.47 0 01-.12.346.424.424 0 01-.292.141zm-.006-1.155l-.03.001a.634.634 0 00-.455.225.706.706 0 00-.167.494c.01.19.09.364.227.488a.633.633 0 00.906-.045.69.69 0 00.178-.506.675.675 0 00-.659-.657'/%3e%3cpath d='M2123.5 1375.035c-.016-.318-.272-.565-.573-.551-.302.015-.533.285-.518.604.016.319.272.565.573.55.302-.014.534-.284.518-.603' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2122.957 1375.528a.42.42 0 01-.282-.11.48.48 0 01-.155-.336.483.483 0 01.113-.338.42.42 0 01.3-.15h.018c.232 0 .426.197.438.447a.47.47 0 01-.12.346.424.424 0 01-.292.141zm-.006-1.155l-.03.001a.634.634 0 00-.455.225.706.706 0 00-.167.494c.01.19.09.364.227.488a.633.633 0 00.906-.045.69.69 0 00.178-.506.675.675 0 00-.659-.657'/%3e%3cpath d='M2124.073 1376.152h.747v-6.617h-.747z' fill='white'/%3e%3cpath d='M2124.185 1369.647h.522v6.393h-.522zm.747-.225h-.971v6.842h.971z'/%3e%3cpath d='M2124.073 1373.58c-3.734-.042-5.85-.29-5.85-.29v.29s2.116.249 5.85.29' fill='white'/%3e%3cpath d='M2118.11 1373.164v.516l.1.01c.022.003 2.164.25 5.862.292l.002-.224c-3.24-.035-5.28-.231-5.738-.28v-.064c.507.053 2.542.243 5.736.278l.002-.224c-3.683-.04-5.816-.287-5.837-.29z'/%3e%3cpath d='M2124.82 1376.152l.197-.015v-6.602h-.197z' fill='white'/%3e%3cpath d='M2125.128 1369.422h-.42v6.851l.421-.032z'/%3e%3cpath d='M2126.189 1369.721h12.426l-.228 10.206h-.954s-.498.581-1.35.705l.012.602h-.561s-1.098 1.058-2.945 1.068c-1.847.011-3.2-1.065-3.2-1.065l-.63.005-.02-.625s-.86-.098-1.388-.825l-.83-.026z' fill='white'/%3e%3cpath d='M2126.305 1369.834h12.196l-.224 9.98h-.895l-.035.04a2.26 2.26 0 01-1.28.669l-.095.014.008.586h-.491l-.033.03c-.011.012-1.091 1.029-2.868 1.038h-.027c-1.772 0-3.09-1.031-3.102-1.042l-.031-.024-.56.005-.02-.612-.095-.012c-.01-.001-.82-.103-1.312-.78l-.032-.043-.78-.025zm12.424-.225h-12.656l.339 10.267.882.027c.45.584 1.094.762 1.337.81l.02.643.699-.006c.222.165 1.495 1.066 3.21 1.066h.029c1.713-.011 2.785-.887 2.989-1.068h.63l-.01-.62a2.49 2.49 0 001.284-.688h1.014l.003-.11z'/%3e%3cpath d='M2130.503 1369.699l.15 6.243 3.513.005-.027-6.285zm2.568 9.333l-.02-1.83-1.257-.004.032 1.825s.56.733 1.245.009' fill='%23211915'/%3e%3cpath d='M2131.537 1379.604l-.282-.003-.052-2.406.287.001z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2131.372 1379.482l-.045-2.165h.045l.042 2.166zm-.291-2.407l.056 2.647.523.002-.052-2.647z'/%3e%3cpath d='M2133.664 1379.62l-.285-.001-.022-2.416h.288z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2133.498 1379.5l-.021-2.176h.05l.016 2.176zm-.263-2.417l.025 2.655.525.004-.02-2.657z'/%3e%3cpath d='M2133.666 1379.885l-2.406-.02-.005-.264 2.409.02z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2131.378 1379.746l-.001-.022 2.168.016v.025zm-.246-.265l.01.503 2.645.023-.004-.505z'/%3e%3cpath d='M2131.546 1380.025s.01.831.929.84c.915.01.908-.772.908-.824l.284.003s.069 1.074-1.188 1.129c0 0-1.191-.012-1.215-1.151z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2132.473 1381.054c-.036 0-.982-.026-1.08-.91h.046c.043.255.231.834 1.034.841.343 0 .586-.087.768-.27a.943.943 0 00.254-.553h.046a.977.977 0 01-.233.56c-.185.203-.465.314-.835.332m-1.333-1.152l.003.124c.026 1.24 1.321 1.267 1.334 1.267.445-.018.783-.158 1.012-.412.325-.363.298-.826.297-.846l-.007-.11-.52-.007.003.124c0 .032 0 .311-.192.504-.13.132-.326.2-.58.2h-.016c-.786-.009-.808-.694-.809-.723l-.002-.117z'/%3e%3cpath d='M2132.618 1381.33l-.273-.003-.007-.447.273.003z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2132.463 1381.208l-.003-.206h.033l.003.206zm-.247-.45l.01.687.514.006-.01-.687z'/%3e%3cpath d='M2134.876 1376.854l-4.744-.015.015.512 4.729.02z' fill='white'/%3e%3cpath d='M2130.243 1377.253l-.01-.312 4.542.012v.318zm-.214-.513l.02.71.097.002 4.829.019v-.716l-.1-.001z'/%3e%3cpath d='M2135.312 1376.743l-5.612-.016.007.223 5.604.018z' fill='white'/%3e%3cpath d='M2129.804 1376.85v-.022l5.408.013v.026zm-.207-.223l.013.421.096.001 5.705.018v-.424h-.099z'/%3e%3cpath d='M2135.311 1377.26l-5.596-.02.007.22 5.588.023z' fill='white'/%3e%3cpath d='M2129.82 1377.362l-.002-.022 5.394.019v.024zm-.207-.223l.012.42h.097l5.687.025.002-.423-.1-.001z'/%3e%3cpath d='M2136.39 1369.728l-1.88.02.006 2.256 1.854-.01z' fill='white'/%3e%3cpath d='M2134.619 1369.854l1.662-.017-.017 2.05-1.64.01zm1.879-.235l-2.096.021.007 2.473 2.069-.01z'/%3e%3cpath d='M2136.26 1376.811l-1.65-.004.001.608 1.646.006z' fill='white'/%3e%3cpath d='M2134.758 1377.27v-.316l1.355.003-.001.318zm-.294-.609l.002.9 1.937.007.005-.902z'/%3e%3cpath d='M2135.352 1372l-.478.003.002 4.728.466.002z' fill='white'/%3e%3cpath d='M2134.983 1372.11l.262-.002-.01 4.517-.25-.001zm.48-.219l-.698.004.004 4.944.681.002.001-.108z'/%3e%3cpath d='M2136.042 1371.996l-.48.003-.015 4.734h.467z' fill='white'/%3e%3cpath d='M2135.67 1372.107l.264-.002-.03 4.521h-.25zm.48-.22l-.696.004-.001.108-.014 4.841.682.002z'/%3e%3cpath d='M2136.413 1376.68l-1.953-.006v.264l1.95.007z' fill='white'/%3e%3cpath d='M2134.566 1376.834v-.055l1.741.006v.055zm-.21-.265v.475l2.158.006.004-.475z'/%3e%3cpath d='M2136.408 1377.29l-1.946-.007.001.263 1.943.008z' fill='white'/%3e%3cpath d='M2134.567 1377.44v-.053l1.735.008v.053zm-.21-.263v.473l2.152.01.004-.475z'/%3e%3cpath d='M2136.122 1377.989l-1.351-.007-.001-.435 1.355.005z' fill='white'/%3e%3cpath d='M2134.891 1377.862v-.195l1.112.005-.002.196zm-.242-.437l.002.677 1.591.008.003-.678z'/%3e%3cpath d='M2135.814 1378.565l-.74-.005.001-.576.742.004z' fill='white'/%3e%3cpath d='M2135.205 1378.43v-.314l.48.002-.001.315zm-.261-.577v.837l1 .006.004-.839z'/%3e%3cpath d='M2130.058 1369.79l-1.835.019.081 2.23 1.814-.01z' fill='white'/%3e%3cpath d='M2128.336 1369.915l1.617-.016.054 2.023-1.6.01zm1.828-.234l-2.053.02.005.11.085 2.337 2.029-.01z'/%3e%3cpath d='M2130.174 1376.793l-1.615-.005.022.602 1.609.007z' fill='white'/%3e%3cpath d='M2128.721 1377.244l-.012-.31 1.322.005.007.31zm-.314-.603l.032.894 1.901.008-.024-.896z'/%3e%3cpath d='M2129.123 1372.035l-.468.003.162 4.676h.455z' fill='white'/%3e%3cpath d='M2128.767 1372.145h.25l.144 4.461h-.24zm.46-.219l-.685.004.005.111.164 4.78.673.003z'/%3e%3cpath d='M2129.796 1372.03l-.47.004.146 4.682h.457z' fill='white'/%3e%3cpath d='M2129.438 1372.142l.253-.002.125 4.468h-.239zm.462-.22l-.685.004.004.112.148 4.785.672.003-.003-.112z'/%3e%3cpath d='M2130.317 1376.662l-1.91-.005.01.262 1.907.006z' fill='white'/%3e%3cpath d='M2128.517 1376.814l-.002-.053 1.7.005.001.054zm-.219-.262l.018.471 2.115.006-.013-.472z'/%3e%3cpath d='M2130.333 1377.266l-1.903-.007.009.26 1.9.008z' fill='white'/%3e%3cpath d='M2128.54 1377.414l-.002-.051 1.693.008v.05zm-.22-.261l.018.47 2.11.008-.012-.47z'/%3e%3cpath d='M2130.077 1377.958l-1.321-.007-.015-.43 1.324.004z' fill='white'/%3e%3cpath d='M2128.872 1377.83l-.007-.19 1.083.005.006.192zm-.256-.431l.024.672 1.56.008-.017-.674z'/%3e%3cpath d='M2129.796 1378.527l-.724-.005-.02-.569.727.003z' fill='white'/%3e%3cpath d='M2129.198 1378.392l-.01-.308.464.001.009.31zm-.28-.57l.027.83.984.006-.022-.833z'/%3e%3cpath d='M2131.904 1376.152h.747v-6.617h-.747z' fill='white'/%3e%3cpath d='M2132.016 1369.647h.522v6.393h-.522zm.747-.225h-.973v6.842h.973z'/%3e%3cpath d='M2132.651 1376.152l.196-.015v-6.602h-.196z' fill='white'/%3e%3cpath d='M2132.96 1369.422h-.421v6.851l.422-.032z'/%3e%3cpath d='M2145.572 1379.017s-.906 1.973-3.15 2.18c-2.244.205-3.309-1.04-3.807-1.6l.34-1.037 4.963-.772z' fill='white'/%3e%3cpath d='M2139.044 1378.665l4.844-.754 1.534 1.14c-.202.372-1.125 1.855-3.011 2.029-2.121.184-3.158-.94-3.663-1.51zm4.904-1l-5.081.79-.384 1.17.07.078c.523.59 1.615 1.819 3.88 1.609 2.284-.21 3.236-2.225 3.246-2.246l.039-.086z'/%3e%3cpath d='M2146.2 1379.343l-5.856.062-1.402.264-.555-.249v-6.453l8.211-2.627z' fill='white'/%3e%3cpath d='M2138.504 1373.053l7.97-2.55-.386 8.725-5.745.06-1.387.26-.452-.205zm8.219-2.876l-8.453 2.704v6.614l.658.296 1.437-.27 5.948-.062z'/%3e%3cpath d='M2138.387 1378.676l.575.297 7.39.047-.11-.402-7.264-.063-.591-.339z' fill='white'/%3e%3cpath d='M2138.504 1378.605v-.187l.442.254h.03l7.177.062.045.168-7.207-.046zm-.234-.59v.733l.692.342 7.543.048-.172-.636h-.09l-7.234-.064z'/%3e%3cpath d='M2146.328 1379.654l-.111-.311-7.273-.044-.557-.265v.387l.555.249z' fill='white'/%3e%3cpath d='M2138.504 1379.343v-.125l.44.197 7.19.044.028.076-7.195.017zm-.234-.495v.647l.672.291 7.553-.016-.195-.542h-.081l-7.247-.047z'/%3e%3cpath d='M2144.48 1378.61l.275-8.27' fill='white'/%3e%3cpath d='M2144.638 1370.336l-.275 8.27.234.007.275-8.269z'/%3e%3cpath d='M2144.217 1378.609l.289-8.264' fill='white'/%3e%3cpath d='M2144.388 1370.341l-.289 8.264.234.007.288-8.263z'/%3e%3cpath d='M2140.687 1378.627l.2-8.286' fill='white'/%3e%3cpath d='M2140.77 1370.338l-.2 8.286.234.006.198-8.286z'/%3e%3cpath d='M2139.296 1370.351l-.198 8.267-.711-.492v-7.679z' fill='%23040006'/%3e%3cpath d='M2138.86 1378.551l-.015.418.235.008.014-.418zm-.032.746l-.003.371.234.003.002-.372z'/%3e%3cpath d='M2139.133 1378.974h-.234v.325h.234z'/%3e%3cpath d='M2144.055 1375.33c.036-.87-.602-1.603-1.425-1.637-.822-.033-1.518.645-1.554 1.516-.036.87.602 1.603 1.425 1.638.823.033 1.52-.645 1.554-1.516' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2143.157 1375.294c.014-.345-.239-.636-.565-.648-.327-.014-.602.254-.617.6-.013.345.24.636.566.649.326.013.601-.255.616-.601' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2142.563 1375.778l-.018-.001c-.26-.011-.464-.246-.453-.526.012-.274.223-.49.476-.49l.018.001a.454.454 0 01.328.161.526.526 0 01.126.366c-.012.273-.223.489-.477.489m.005-1.25c-.378 0-.693.314-.71.713-.016.408.288.754.678.77h.027c.38 0 .694-.314.711-.712a.76.76 0 00-.184-.531.69.69 0 00-.494-.24z'/%3e%3cpath d='M2135.247 1390.17l.264-.654v-2.653l-.264.757z' fill='white'/%3e%3cpath d='M2135.358 1387.64l.042-.117v1.971l-.042.102zm.047-.813l-.27.793v2.55l.215.041.273-.695v-2.652z'/%3e%3cpath d='M2147.187 1373.445v-3.91h-14.34v4.175s11.703.04 14.34-.265' fill='white'/%3e%3cpath d='M2132.96 1369.647h14.115v3.697c-2.633.275-12.925.25-14.115.253zm14.34-.225h-14.565v4.4h.113c.118 0 11.74.037 14.353-.267l.099-.01z'/%3e%3cpath d='M2132.848 1373.567s5.953.094 14.48-.228v.29c-8.527.322-14.48.228-14.48.228' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2147.44 1373.223l-.116.004c-8.426.317-14.415.23-14.473.227l-.004.225c.062 0 5.997.088 14.368-.224v.066c-8.373.314-14.307.227-14.364.223l-.004.226c.061 0 6.054.087 14.485-.228l.108-.005z'/%3e%3cpath d='M2126.463 1377.999l-.404.355-7.058.049.475-.404 6.55-.035.418-.352z' fill='white'/%3e%3cpath d='M2119.518 1378.11l6.549-.034.276-.232.006.106-.333.293-6.708.046zm7.027-.729l-.56.472-6.55.034-.74.63 7.406-.051.476-.418z'/%3e%3cpath d='M2128.74 1380.617c-.4-.108-1.042-.348-1.39-.824l-.829-.027.009.343.635.02c.647.682 1.57.846 1.57.846z' fill='white'/%3e%3cpath d='M2126.64 1380l-.004-.118.657.02c.338.43.893.67 1.333.8v.133c-.27-.072-.908-.284-1.38-.782l-.032-.033zm-.234-.35l.015.569.695.02c.662.673 1.561.84 1.6.848l.13.022.007-.578-.084-.022c-.354-.096-.995-.325-1.328-.782l-.032-.044z'/%3e%3cpath d='M2136.084 1380.632a2.355 2.355 0 001.349-.705h.954v.344l-.78.006s-.67.642-1.523.712z' fill='white'/%3e%3cpath d='M2137.482 1380.04h.792v.12l-.71.006-.033.03c-.007.006-.592.555-1.334.669v-.137a2.483 2.483 0 001.285-.688m1.017-.225h-1.118l-.034.039a2.257 2.257 0 01-1.279.669l-.096.013v.576l.121-.01c.783-.065 1.408-.58 1.56-.713l.846-.006z'/%3e%3cpath d='M2136.444 1381.234h-.91s-1.099 1.068-2.945 1.068c-1.9 0-3.2-1.065-3.2-1.065l-.825.008v.334l.653-.01s1.388 1.075 3.382 1.076c1.94.001 3.076-1.069 3.076-1.069l.77-.01z' fill='white'/%3e%3cpath d='M2135.578 1381.347h.754v.108l-.7.01-.033.028c-.01.011-1.13 1.04-2.998 1.04h-.002c-1.93 0-3.3-1.042-3.313-1.053l-.031-.024-.578.01v-.11l.673-.007a5.55 5.55 0 003.238 1.066c1.713 0 2.786-.884 2.99-1.068m.979-.225h-1.07l-.031.033c-.011.01-1.091 1.036-2.868 1.036-1.84 0-3.115-1.03-3.127-1.04l-.032-.027-.977.008v.56l.73-.01c.224.164 1.55 1.074 3.417 1.075h.002c1.8 0 2.913-.89 3.119-1.07l.837-.01z'/%3e%3cpath d='M2119 1379.036l.364-.312 6.719-.024.38-.246.027.357-.36.195z' fill='white'/%3e%3cpath d='M2119.405 1378.836l6.71-.023.25-.162.007.096-.27.146-6.798.03zm7.156-.58l-.513.332-6.725.025-.626.536 7.462-.032.448-.242z'/%3e%3cpath d='M2121.125 1377.999l-.175-4.22' fill='white'/%3e%3cpath d='M2121.061 1373.774l-.225.009.177 4.22.224-.009z'/%3e%3cpath d='M2121.414 1377.999l-.175-4.206' fill='white'/%3e%3cpath d='M2121.35 1373.788l-.224.01.176 4.206.224-.01z'/%3e%3cpath d='M2124.62 1377.999l-.076-1.847' fill='white'/%3e%3cpath d='M2124.657 1376.147l-.225.01.076 1.846.225-.009z'/%3e%3cpath d='M2125.691 1369.721l.27 8.277.465-.458-.237-7.819z' fill='%23040006'/%3e%3cpath d='M2126.135 1377.989l-.223.02.036.404.221-.02zm.058.694l-.221.034.054.335.22-.034z'/%3e%3cpath d='M2126.17 1378.394l-.223.018.024.296.223-.016z'/%3e%3cpath d='M2132.98 1382.645h-.952v.416h.952z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2132.129 1382.745h.751v.217h-.751zm.951-.2h-1.151v.617h1.151z'/%3e%3cpath d='M2132.866 1383.429h-.724v-.368h.724z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2132.243 1383.162h.523v.167h-.523zm.724-.2h-.924v.567h.924z'/%3e%3cpath d='M2132.028 1383.797h.952v-.367h-.952z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M2132.129 1383.529h.751v.167h-.751zm.951-.2h-1.151v.567h1.151z'/%3e%3cpath d='M2131.668 1386.693v.926h.436v2.552h2.769v-2.562l.412.001v-.917z' fill='white'/%3e%3cpath d='M2131.78 1386.804h3.395v.693l-.414-.002v2.563h-2.546v-2.55h-.435zm3.617-.224h-3.84v1.15h.435v2.551h2.993v-2.56l.412.001z'/%3e%3cpath d='M2135.285 1387.61l.265-.381v-.808l-.265.272z' fill='white'/%3e%3cpath d='M2135.397 1386.738l.042-.043v.499l-.042.06zm.265-.593l-.488.502v1.32l.488-.703z'/%3e%3cpath d='M2132.103 1390.171h-.436v-2.552h.436z' fill='white'/%3e%3cpath d='M2131.78 1387.73h.212v2.328h-.212zm.435-.223h-.657v2.773h.657zm1.855 3.412s-.102.202-.074.534c.028.33.064.176.13.539.067.382.095.669.105.833.01.165.041.484.081.639 0 0 .25.178.362.285.114.108.141.188.193.274 0 0-.002.187.001.264 0 0 .068.068.087.096.018.029.02.064.026.122.007.058.06.149.032.172-.014.013-.004.024-.027.04-.022.016-.012.029-.03.027-.029-.002-.05-.11-.07-.152-.02-.044-.053-.077-.01-.178l-.046-.038s-.045.013-.099-.028c-.053-.042-.389-.29-.549-.346-.113-.04-.163-.027-.269-.02-.106.01-.189.004-.207.122-.019.117-.01.336-.08.434-.07.1-.185.169-.31.127-.128-.041-.187-.131-.153-.283.034-.152.18-.378.11-.4-.069-.024-.13-.08-.209-.111-.078-.032-.099-.073-.228-.071-.189.002-.43.117-.594.165 0 0-.056-.015-.08.003s-.034.013-.027.055c.008.042 0 .055-.053.12-.054.065-.078.11-.112.116-.022.003-.04.006-.055-.026-.017-.032-.016-.015-.022-.042-.007-.026-.01-.04-.003-.061.01-.022.04-.064.056-.125.016-.062.04-.072.097-.111.048-.034.064-.001.127-.05 0 0 .015-.158.02-.188 0 0 .15-.1.235-.14.087-.041.201-.096.402-.175 0 0 .027-.361.032-.714.005-.35.065-.524.115-.76.051-.234.111-.3.116-.524.003-.226-.102-.548-.102-.548z'/%3e%3cpath d='M2135.285 1387.61h-.412v2.561h.412z' fill='white'/%3e%3cpath d='M2134.985 1387.721h.189v2.337h-.189zm.412-.222h-.636v2.782h.636zm-4.554-.635l.63-.755v.28h3.812l.53-.731v-.412l.63.464-.708 1.154z'/%3e%3cpath d='M2134.6 1390.459s.001.775-.852.793h-.4c-.853-.018-.852-.793-.852-.793z' fill='white'/%3e%3cpath d='M2132.619 1390.57h1.858c-.034.195-.173.559-.73.57h-.4c-.555-.011-.694-.375-.728-.57m2.093-.223h-2.327v.113c0 .007.009.883.962.903h.402c.954-.02.963-.896.963-.903z'/%3e%3cpath d='M2131.395 1390.413l.264-.466v.25h3.626l.225-.68v-.104l.27.073-.32.927z' fill='white'/%3e%3cpath d='M2135.4 1389.266v.232l-.195.588h-3.435v-.564l-.486.78.054.222h4.202l.35-1.038z'/%3e%3cpath d='M2135.418 1390.413v.886h-.242v-.444h-3.538v.444h-.242v-.886z' fill='white'/%3e%3cpath d='M2131.507 1390.524h3.8v.662h-.02v-.442h-3.761v.442h-.02zm4.022-.223h-4.245v1.109h.465v-.444h3.316v.444h.464z'/%3e%3cpath d='M2135.418 1390.413l.36-.927v.396l-.36.992z' fill='white'/%3e%3cpath d='M2135.675 1389.445l-.368.968v.46l.222.089.362-1.08v-.396z'/%3e%3cpath d='M2133.89 1390.413v.442s-.14.322-.525.322c-.384 0-.524-.322-.524-.322v-.442z' fill='white'/%3e%3cpath d='M2132.953 1390.524h.824v.305a.466.466 0 01-.412.236.468.468 0 01-.412-.236zm1.047-.223h-1.27l.009.599a.686.686 0 00.626.388c.453 0 .62-.372.627-.388l.008-.045zm-.522 4.691c-.267 0-.5-.26-.5-.555 0-.285.23-.526.5-.526.284 0 .515.236.515.526 0 .295-.24.555-.515.555m0-1.177c-.322 0-.595.285-.595.622 0 .346.278.65.595.65.33 0 .61-.297.61-.65a.617.617 0 00-.61-.622'/%3e%3cpath d='M2119.09 1372.881s1.747.176 3.663.176m-3.75-.647s1.441.106 3.34.158m-3.428-.632s1.228.071 3.095.15m-3.151-.587s.957.024 2.823.104m-2.868-.533s1.114.038 2.563.08m-2.591-.466s1.514.043 2.36.065m-2.4-.433s1.414.002 2.083.022m-2.143-.388h1.838m13.319 3.13s5.13.024 12.64-.143m-12.698-.342s3.523.043 11.015-.046m-11.155-.479s7.256.136 9.732.06m-9.8-.497s6.258.1 8.28.035m-8.335-.461s5.32.074 6.923.056m-6.96-.441s4.284.043 5.13.045m-5.179-.411s2.682-.02 3.351-.016m-3.42-.395s1.402.01 1.838 0' fill='none' stroke='black' stroke-width='.198' stroke-linecap='round' stroke-miterlimit='3.864'/%3e%3cpath d='M2143.108 1204.16c.66-6.117 1.664-16.554-10.437-28.31 4.47-4.648 10.437-7.795 19.884-7.616 9.447.149 16.884-.18 25.505 7.766-3.807 3.149-14.244 12.086-9.942 28.16z' fill='%23f0e53c'/%3e%3cpath d='M2143.108 1204.16c.66-6.117 1.664-16.554-10.437-28.31 4.47-4.648 10.437-7.795 19.884-7.616 9.447.149 16.884-.18 25.505 7.766-3.807 3.149-14.244 12.086-9.942 28.16z' fill='none' stroke='%23473125' stroke-width='.276'/%3e%3cpath d='M2179.162 1204.629l1.188-3.188c.332 1.33.437 2.344.557 4.03l1.324-3.2c.667 1.463.914 4.315.914 4.315l.84-3.173c1.613 2.388 3.579 6.35 4.047 8.675l.229-3.937 1.258 4.998.4-3.053c1.43 4.316 2.185 4.511 1.282 11.14-.898 6.583-6.155 10.644-8.391 11.437-1.268.45-2 1.937-6.055 3.513-3.038 1.178-4.89.749-6.372 1.229-1.5.51-3.535 1.554-7.086 1.344-4.065-.242-3.268-.531-6.17-.773-2.488-.206-5.053.663-9.027-.391-3.697-.981-8.783-5.414-11.833-8.277-3.265-3.064-5.891-6.93-7.63-11.987l1.65.562c-1.618-3.223-1.826-6.794-1.826-6.794l1.583.864s-.343-1.712-.277-3.263l2.18 1.653s-.49-2.253-.332-3.921c0 0 1.16 1.014 2.162 2.087 0 0-.155-2.494.099-4.181l2.11 2.509s-.048-2.142.25-4.037l1.826 2.59s.068-1.944.54-4.015l1.754 2.741s.117-1.816.73-3.794l1.713 2.808c.476-2.062.498-2.509 1.728-4.686l1.952 3.581s.797-2.803 2.385-4.686l1.74 3.898s.313-2.08 1.964-4.408l1.827 4.154s.392-2.235 1.915-4.393c0 0 1.26 2.21 1.892 4.393l2.254-4.393s1.42 2.066 2.046 4.783l2.236-4.176s1.22 2.36 1.835 4.637l1.575-4.434c.546 1.354 1.285 3.237 1.542 4.706l1.057-4.146s.875 2.012 1.158 4.443l1.37-3.676s.707 2.121.77 4.072l1.225-3.345s.479 1.904.542 3.821l1.137-3.184s.496 1.82.604 3.786l1.006-3.133s.494 1.654.603 3.874' fill='%23f0e53c'/%3e%3cpath d='M2179.162 1204.629l1.188-3.188c.332 1.33.437 2.344.557 4.03l1.324-3.2c.667 1.463.914 4.315.914 4.315l.84-3.173c1.613 2.388 3.579 6.35 4.047 8.675l.229-3.937 1.258 4.998.4-3.053c1.43 4.316 2.185 4.511 1.282 11.14-.898 6.583-6.155 10.644-8.391 11.437-1.268.45-2 1.937-6.055 3.513-3.038 1.178-4.89.749-6.372 1.229-1.5.51-3.535 1.554-7.086 1.344-4.065-.242-3.268-.531-6.17-.773-2.488-.206-5.053.663-9.027-.391-3.697-.981-8.783-5.414-11.833-8.277-3.265-3.064-5.891-6.93-7.63-11.987l1.65.562c-1.618-3.223-1.826-6.794-1.826-6.794l1.583.864s-.343-1.712-.277-3.263l2.18 1.653s-.49-2.253-.332-3.921c0 0 1.16 1.014 2.162 2.087 0 0-.155-2.494.099-4.181l2.11 2.509s-.048-2.142.25-4.037l1.826 2.59s.068-1.944.54-4.015l1.754 2.741s.117-1.816.73-3.794l1.713 2.808c.476-2.062.498-2.509 1.728-4.686l1.952 3.581s.797-2.803 2.385-4.686l1.74 3.898s.313-2.08 1.964-4.408l1.827 4.154s.392-2.235 1.915-4.393c0 0 1.26 2.21 1.892 4.393l2.254-4.393s1.42 2.066 2.046 4.783l2.236-4.176s1.22 2.36 1.835 4.637l1.575-4.434c.546 1.354 1.285 3.237 1.542 4.706l1.057-4.146s.875 2.012 1.158 4.443l1.37-3.676s.707 2.121.77 4.072l1.225-3.345s.479 1.904.542 3.821l1.137-3.184s.496 1.82.604 3.786l1.006-3.133s.494 1.654.603 3.874z' fill='none' stroke='%23473125' stroke-width='.276' stroke-miterlimit='10'/%3e%3cpath d='M2133.92 1209.08c3.674 8.17 12.449 16.49 20.603 18.29m-21.946-15.877c2.083 3.343 6.977 9.28 12.608 12.4m-14.821-11.367c1.802 2.7 9.039 10.678 16.77 13.392m-17.001-10.573c6.364 6.793 14.246 13.275 24.03 12.615m-23.459-9.468c5.283 5.222 14.48 11.49 24.292 10.02m-23.899-7.227c5.405 4.38 15.827 11.452 24.352 7.576m-22.189-3.919c4.076 2.909 15.026 9.372 23.253 4.573m-19.846-.84c5.589 3.362 14.645 5.635 19.532 1.485m-15.879 1.829c3.778 2.189 11.611 2.98 15.926-1.26m-7.963 6.445c3.836-1.977 8.121-2.055 9.963-7.463m-3.25 7.917c1.653-1.652 2.903-3.903 3.158-6.393m-14.056 3.903c4.851 1.08 11.192-1.92 12.438-3.75m-5.053 6.24c2.04-1.05 5.278-3.321 6.057-5.54m4.86 6.285c-1.995-2.49-3.342-6.263-3.837-9.112m8.828 8.542c-2.938-1.498-5.233-2.519-6.947-6.319m12.144 4.911c-4.552-.652-9.328-3.685-12.342-7.523m19.836 4.945c-5.421.05-6.747-1.106-11.493-2.215m20.652-7.517c-2.412 5.956-7.624 8.626-15.586 7.774m-9.765-2.977c3.153 1.334 6.822 1.628 10.195 1.697m1.411.001c8.022-.3 13.868-8.936 14.08-16.554m-12.925 14.904c6.304-2.043 11.365-8.426 11.425-15.323m-5.54 16.123c5.54-2.813 7.34-8.006 7.834-13.98m-18.608 11.358c7.902-1.11 14.564-8.06 14.83-16.08m-15.07 17.657c7.243-.916 13.897-5.922 15.307-12.818m-23.09 12.163c2.641.48 3.537.549 6.486.729m-7.233-1.717c3.763-.42 6.214-1.265 8.95-2.474m-9.462 2.113c1.8-.51 4.248-2.054 5.673-3.224m-6.716 1.814c1.616-1.097 2.868-1.813 4.942-3.349m-2.856-2.018c-1.52 1.855-2.654 4.049-3.77 5.927m.659-5.342c-.496 1.199-1.154 2.549-1.648 3.794m-1.3-3.794c-.444 1.664-.531 3.225-.155 5.106m-5.117-10.069c.854 3.718 1.87 6.359 4.277 9.506m-9.492-10.533c1.975 4.078 5.866 9.129 9.522 11.769m-13.803-10.923c1.978 3.146 7.229 9.047 13.952 11.381m-16.221-11.2c2.682 3.718 8.968 10.069 16.356 12.086m16.555-3.659c6.64-2.82 9.775-6.657 10.855-13.734m-11.605 12.305c5.046-3.718 8.967-10.829 9.434-18.364m-12.769 18.473c6.243-4.048 10.062-10.793 10.726-18.779m-12.935 17.431c5.259-4.373 8.123-9.971 8.527-17.185m-2.983 13.824c3.096-3.988 4.403-8.152 4.724-12.95m-.661 15.579c3.005-2.853 5.152-6.866 6.304-12.645m-19.143 14.245c5.402-3.928 9.36-11.494 9.843-18.232m-9.35 14.885c3.257-4.308 4.96-8.839 5.286-15.798m-6.766 12.997c2.234-4.333 2.879-6.926 3.556-13.164m-7.123 11.276c.665-4.47 1.454-10.017 1.243-15.325m-3.988 19.794c-.139-5.013.966-11.107 1.215-16.735m-3.351 15.061c-1.162-6.56-.38-9.434-.247-14.641m-2.212 11.665c-.657-3.93-1.324-6.17-1.274-11.665m2.402 19.258c-1.79-2.795-4.61-9.277-5.555-12.105-.648-1.946-1.112-4.513-1.057-6.582m-.432 10.314c-1.812-3.78-2.414-5.098-3.173-9.235m-2.402.989c.478 2.568 2.035 6.616 3.16 8.415m-5.465-7.083c.255 1.83 1.965 5.88 3.337 7.529m-5.472-6.293c.956 2.836 1.732 4.48 3.308 6.64m18.387 5.643c.335-1.16.905-1.884 1.405-4.519m1.325 11.484c2.423-.589 3.899-1.424 5.249-2.443m-3.261 5.31c1.123.68 4.151 2.09 4.991 2.658m-8.024-3.141c.43.75.47 1 .879 1.913m-2.426-2.662c-.614 1.141-.407.93-1.172 1.949m.619-1.703c-1.722.658-3.193 1.782-6.525 1.973m6.797-2.491c-.755-.058-1.882-.388-2.585-.596m3.058-.871c-.33-1.26-.31-3.755.66-6.718m-.195 6.122c.284-.96 2.592-5.13 3.057-6.029m-1.856 6.864c.577-.835 1.552-.918 2.233-1.266m-2.399 2.527c.954.167 1.365.719 2.234 1.139m-2.486-1.831c1.076-.339 4.263.271 5.44.091m-6.546.899c-.215.901-.657 1.991-1.168 2.76m3.351 1.773c.377.82 1.3 2.819 2.699 3.937m-18.149-21.826c1.83 3.161 4.397 5.635 7.305 8.56m8.52-3.863c.45-.955 1.035-1.837 1.645-2.85m-15.514-20.038c-.338-11.813-4.495-17.506-8.52-24.681m10.527 23.605c-.409-5.552-.838-7.98-1.678-11.16m-.42-1.678c-1.656-4.287-3.463-8.187-6-12.085m-6.342 3.898c2.896 3.448 6.134 7.616 8.113 12.174m-6.15-13.509c2.657 3.8 4.637 7.203 6.826 11.86m21.181 7.902c.953-4.63 1.568-7.135 3.247-10.854m-5.971 10.39c1.274-7.648 3.164-15.084 7.872-21.203m-1.546 9.917c1.557-3.288 3.523-5.638 5.681-8.148m-16.97 20.843c.164-7.888-.715-17.533-.715-25.39m-.948 22.076c-.224-7.871-1.168-15.153-1.915-22.076m7.157 21.671c.467-4.918 1.55-15.029 5.118-20.707m-6.95 23.017c.226-6.868.37-16.156 1.49-23.655m-14.422.142c1.07 2.83 2.504 7.501 3.44 11.052m-6.08-10.301c1.808 3.63 4.458 8.956 5.609 13.5m2.241-14.719c.46 2.956 1.19 6.718 1.619 10.613m-.655 16.936c0-3.449-.593-9.595-1.182-13.345m14.89 9.366c.658-2.906 1.095-4.364 1.981-6.816m-4.8 12.025c.525-3.51 1.166-6.526 1.902-9.776m3.9-.807c.81-2.055 1.452-3.478 3.389-5.911m-7.04 5.621c1.251-4.314 1.866-5.69 3.526-9.044m.592-1.059a31.765 31.765 0 012.922-4.314m0 6.421c.884-1.195 2.564-2.666 3.7-3.862m-32.337 13.586c.974 2.677 1.214 4.761 1.55 8.484m1.355 2.928c-.016-1.2-.235-4.033-.47-5.477m9.447 2.204c.104-1.32.029-3.103 0-4.452m-1.737-1.858c-.156-3.538-.61-7.89-.806-9.419m-2.649-2.638c-.373-2.592-1.099-5.655-1.488-6.886m-1.484 4.816c-.89-2.364-1.604-4.291-2.598-6.371m17.436 27.333c.427-2.908.722-4.572 1.443-7.706m.353 9.402c.23-1.528.442-3.148.685-4.447m3.82-10.099c.743-1.874 1.6-3.076 2.63-4.41m-11.805 47.638c.375-.645.375-.645.705-1.139m-.611 1.89c.718.426 1.164 1.141 1.436 1.664m1.197-.252c1.287 1.136 2.205 1.43 3.782 2.42m-3.336-3.255c1.28.502 3.336 1.821 5.613 2.477m-8.518-3.455c.951-.147 2.362.027 3.746.25m-4.436-.76c.287-.922 2.483-4.8 3.282-6.076m-3.761 6.11c-.514-1.202-2.646-2.362-3.987-4.437m3.763 4.673c-1.213-.56-3.713-1.173-5.643-2.454m4.791 3.291c-.776.062-1.418-.288-2.181-.37m2.283 3.595c-1.446 2.108-3.604 2.776-4.239 3.058m5.881-6.315c.501 1.08.848 2.422 1.432 3.742m-1.621-1.507c.114.872.378 1.409.378 2.373m1.867-2.68c.302.456.599 1.155 1.196 1.814m-1.196-3.965c1.117.148 1.543.29 2.63.52m-.86-3.292c2.432-1.067 5.753-3.682 7.63-5.762m-9.586 6.007c.553-.75 1.834-2.189 2.448-2.729m-4.582 1.978c.362-2.458.7-4.462 1.9-6.619m-3.936 4.813c-.825-1.63-1.32-3.484-1.575-4.7m-2.367 8.966a18.75 18.75 0 01-4.137-1.037m4.764 2.903c-1.855.411-6.07-.075-7.936-.75m13.74 5.159c.13 1.229-.253 3.43-.253 4.12m3.697-5.214c.826 1.147 2.268 2.653 5.387 3.751m-1.692-3.834c3.576 2.52 8.525 2.938 10.55 3.237m-7.577-11.686c1.434-.93 2.782-1.893 4.097-3.072m-6.217 2.577c1.979-1.43 3.432-2.77 4.902-4.303m.811-2.481c1.188-1.618 2.824-5.001 3.258-7.026m.206-1.127c.36-1.618.703-4.655.72-6.244m-8.862 17.312c5.548-5.652 6.998-12.917 7.167-17.915m-7.913 15.412c2.276-3.466 4.314-8.277 4.613-13.532m-6.004 10.133c1.825-3.669 2.631-10.232 2.346-13.957m9.964 23.622c4.275-2.879 6.294-6.267 7.145-10.315m.242-1.217c.136-1.462.275-2.18.136-4.356m-1.224 1.742c.113-1.101.063-3.026-.069-3.807m-.157 19.911c2.172-1.8 4.174-6.363 4.344-8.009m-3.84 9.987c1.437-1.191 3.536-3.757 4.578-7.7m.367 3.795c.314-.75.616-2.019.782-2.83m-41.662-21.805c-.465 3.786.063 8.288 1.558 13.539m15.429-14.754c.136-2.058.479-6.04 1.848-9.761m-.955 7.995c.03-1.764.708-5.604 1.305-7.178m-2.964 7.842c.068-1.024.176-1.66.353-3.008m-1.702-5.667c.503-2.186 1.103-3.938 1.805-5.723m.931-2.666c.585-1.261 1.712-3.45 2.43-4.65' fill='none' stroke='%23473125' stroke-width='.248' stroke-linecap='round'/%3e%3cpath d='M2194.754 1315.191s.154-.721.515-1.103c.403-.426 1.064-.437 1.91-.305.72.112.805.28 1.129.663l.18-3.248-3.734.258z' fill='%23292723'/%3e%3cpath d='M2115.954 1627.398c-7.588-8.623-2.91-14.875-19.718-17.559-2.954-.479-6.673 1.02-9.461-2.458-.585-.735-.705-2.865-1.321-3.284-2.938-2.039-2.307-4.889-1.348-6.944 2.879 5.61 3.343 1.756 7.81 4.5 3.39 2.083 4.11 3.508 9.883 3.87-.3-4.155-2.894-6.329-3.6-9.434-.718-3.149.932-7.45 4.545-7.242-2.624 5.024 2.803 3.33 2.158 7.602-.81 5.294 3.794 10.782 7.123 8.907 3.479-1.964 10.42-4.768 9.52-9.37 2.88 2.907 2.536 6.506-.148 8.665-3.06 2.475-7.827 3.134-5.563 11.336 1.169 4.258 6.973 9.821 8.92 14.47z' fill='%23f0e53c'/%3e%3cpath d='M2115.954 1627.398c-7.588-8.623-2.91-14.875-19.718-17.559-2.954-.479-6.673 1.02-9.461-2.458-.585-.735-.705-2.865-1.321-3.284-2.938-2.039-2.307-4.889-1.348-6.944 2.879 5.61 3.343 1.756 7.81 4.5 3.39 2.083 4.11 3.508 9.883 3.87-.3-4.155-2.894-6.329-3.6-9.434-.718-3.149.932-7.45 4.545-7.242-2.624 5.024 2.803 3.33 2.158 7.602-.81 5.294 3.794 10.782 7.123 8.907 3.479-1.964 10.42-4.768 9.52-9.37 2.88 2.907 2.536 6.506-.148 8.665-3.06 2.475-7.827 3.134-5.563 11.336 1.169 4.258 6.973 9.821 8.92 14.47z' fill='none' stroke='%23473125' stroke-width='1.048'/%3e%3cpath d='M2133.108 1600.992c0 4.064 1.453 6.478 5.367 6.028 4.558-.525 14.32-3.779 17.65.78 2.113 2.91 1.423 8.668 1.364 12.16 2.083-.03 4.153-.09 6.252-.119-.765-3.899-2.489-11.217-.749-15.055 1.753-3.854 8.005-2.983 7.196-7.828 1.95-1.394 1.875-4.062.494-6.132-.464 2.88-2.187 2.4-3.659 3.614-.658.554-2.294.15-3.282.93-.796.63-1.02 1.724-1.56 2.084-5.504 3.764-4.843-2.879-6.028-4.844-1.41-2.354.36-5.248-3.748-4.843-.569-.915-1.41-2.099.075-3.643-8.366-1.86-.375 9.806-.78 13.854-3.524.405-5.383-7.977-10.736-5.907-.915-.765-2.025-2.429-1.485-4.273-2.488 1.873-2.608 4.708-.345 7.167-3.267 4.723 6.553 4.198 10.347 8.006.105-.029.284.046.15-.014-3.853.63-6.163-1.799-9.447-2.1-3.058-.269-3.763 2.655-7.076.135' fill='%23f0e53c'/%3e%3cpath d='M2133.108 1600.992c0 4.064 1.453 6.478 5.367 6.028 4.558-.525 14.32-3.779 17.65.78 2.113 2.91 1.423 8.668 1.364 12.16 2.083-.03 4.153-.09 6.252-.119-.765-3.899-2.489-11.217-.749-15.055 1.753-3.854 8.005-2.983 7.196-7.828 1.95-1.394 1.875-4.062.494-6.132-.464 2.88-2.187 2.4-3.659 3.614-.658.554-2.294.15-3.282.93-.796.63-1.02 1.724-1.56 2.084-5.504 3.764-4.843-2.879-6.028-4.844-1.41-2.354.36-5.248-3.748-4.843-.569-.915-1.41-2.099.075-3.643-8.366-1.86-.375 9.806-.78 13.854-3.524.405-5.383-7.977-10.736-5.907-.915-.765-2.025-2.429-1.485-4.273-2.488 1.873-2.608 4.708-.345 7.167-3.267 4.723 6.553 4.198 10.347 8.006.105-.029.284.046.15-.014-3.853.63-6.163-1.799-9.447-2.1-3.058-.269-3.763 2.655-7.076.135z' fill='none' stroke='%23473125' stroke-width='1.048'/%3e%3cpath d='M2119.237 1730.093c-5.248 4.98-10.825 8.952-18.112 18.354-7.288 9.416-33.483 29.838-61.507 39.78-28.01 9.956-75.707 33.767-56.44 5.623 1.455-1.425-.163-2.729-4.467-.375-4.288 2.354-12.745 10.481-20.002 12.564-7.258 2.1-46.333 1.831-57.16-4.153-10.84-5.966-3.598-9.295 10.812-15.144 14.395-5.848 41.894-17.887 58.132-30.453 16.225-12.58 34.563-23.572 41.896-27.499 7.332-3.93 4.557-3.675 10.795-3.93 6.224-.255 57.189-4.707 64.177-36.136-4.53-3.404-34.113-57.352-13.436-60.502 20.692-3.133 35.492-2.67 38.16-1.619l-.99-3.929s6.163 1.815 8.264-2.368c3.147 1.83 5.562 8.141 10.795 8.395 5.249.271 8.726 1.095 12.91-.733 4.184-1.83 12.566-8.907 14.41-12.566 2.353-.525 3.643.54 5.232-1.049 1.41-1.409 5.758 7.332 5.758 12.835 0 5.487 4.979 4.184 8.112.255 3.149-3.93 12.836-29.854 18.339-29.585 5.503.255 6.027 2.88 7.857 3.93 2.624-1.845 6.55.51 8.382 4.183 5.757-1.05 12.834 2.1 12.834 9.431 6.283-.525 10.21 1.83 10.21 7.333 3.93 0 10.738 2.608 10.467 8.382 3.405.523 11.53 5.487 6.029 10.465-5.503 4.978-45.824 26.72-62.062 31.683-16.238 4.978-24.097 9.702-24.352 13.885-.268 4.198 17.274 7.332 23.827 24.351 6.553 17.033-8.382 23.317.78 29.074 9.176 5.758 35.626 22.777 65.209 32.477 29.6 9.687 72.799 26.706 63.907 29.585-8.906 2.88-30.903 8.38-48.972 9.16-18.083.796-76.216 1.576-93.49-4.182-17.287-5.758-33.003-8.907-43.213-34.563-10.212-25.67-8.382-42.434-12.311-48.972z'/%3e%3cpath d='M2119.237 1730.093c-5.248 4.98-10.825 8.952-18.112 18.354-7.288 9.416-33.483 29.838-61.507 39.78-28.01 9.956-75.707 33.767-56.44 5.623 1.455-1.425-.163-2.729-4.467-.375-4.288 2.354-12.745 10.481-20.002 12.564-7.258 2.1-46.333 1.831-57.16-4.153-10.84-5.966-3.598-9.295 10.812-15.144 14.395-5.848 41.894-17.887 58.132-30.453 16.225-12.58 34.563-23.572 41.896-27.499 7.332-3.93 4.557-3.675 10.795-3.93 6.224-.255 57.189-4.707 64.177-36.136-4.53-3.404-34.113-57.352-13.436-60.502 20.692-3.133 35.492-2.67 38.16-1.619l-.99-3.929s6.163 1.815 8.264-2.368c3.147 1.83 5.562 8.141 10.795 8.395 5.249.271 8.726 1.095 12.91-.733 4.184-1.83 12.566-8.907 14.41-12.566 2.353-.525 3.643.54 5.232-1.049 1.41-1.409 5.758 7.332 5.758 12.835 0 5.487 4.979 4.184 8.112.255 3.149-3.93 12.836-29.854 18.339-29.585 5.503.255 6.027 2.88 7.857 3.93 2.624-1.845 6.55.51 8.382 4.183 5.757-1.05 12.834 2.1 12.834 9.431 6.283-.525 10.21 1.83 10.21 7.333 3.93 0 10.738 2.608 10.467 8.382 3.405.523 11.53 5.487 6.029 10.465-5.503 4.978-45.824 26.72-62.062 31.683-16.238 4.978-24.097 9.702-24.352 13.885-.268 4.198 17.274 7.332 23.827 24.351 6.553 17.033-8.382 23.317.78 29.074 9.176 5.758 35.626 22.777 65.209 32.477 29.6 9.687 72.799 26.706 63.907 29.585-8.906 2.88-30.903 8.38-48.972 9.16-18.083.796-76.216 1.576-93.49-4.182-17.287-5.758-33.003-8.907-43.213-34.563-10.212-25.67-8.382-42.434-12.311-48.972z' fill='none' stroke='%2359595b' stroke-width='1.571'/%3e%3cpath d='M2087.284 1685.05a4.216 4.216 0 00-4.004 2.94c-8.816 28.144-42.943 30.917-59.797 32.597-2.848.286-7.407.69-9.206 1.724-21.097 12.056-54.82 37.306-78.48 50.577-21.037 11.785-67.159 24.335-66.636 26.6.525 2.25 49.123-8.816 71.208-21.203 21.863-12.265 63.081-36.796 77.416-48.057 1.485-.195 3.39-.39 5.547-.599 18.654-1.844 57.46-5.698 67.955-39.136a4.19 4.19 0 00-4.003-5.443' fill='white'/%3e%3cpath d='M2087.284 1685.05a4.216 4.216 0 00-4.004 2.94c-8.816 28.144-42.943 30.917-59.797 32.597-2.848.286-7.407.69-9.206 1.724-21.097 12.056-54.82 37.306-78.48 50.577-21.037 11.785-67.159 24.335-66.636 26.6.525 2.25 49.123-8.816 71.208-21.203 21.863-12.265 63.081-36.796 77.416-48.057 1.485-.195 3.39-.39 5.547-.599 18.654-1.844 57.46-5.698 67.955-39.136a4.19 4.19 0 00-4.003-5.443z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1883.017 1805.26c-8.501 3.944-.48 6.913 14.155 1.05 6.448-2.593 20.527-8.592 32.462-16.763 14.935-10.211-39.301 12.31-46.617 15.713' fill='white'/%3e%3cpath d='M1883.017 1805.26c-8.501 3.944-.48 6.913 14.155 1.05 6.448-2.593 20.527-8.592 32.462-16.763 14.935-10.211-39.301 12.31-46.617 15.713z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2084.15 1682.262c-1.35 0-2.667.645-3.478 1.844-1.29 1.919-.794 4.528 1.125 5.818 13.644 9.222 30.093 25.566 33.992 36.99 1.544 4.515 2.758 10.437 4.049 16.705 2.413 11.8 4.257 26.945 10.392 37.8 11.138 19.703 26.854 27.62 52.059 31.728 30.753 5.009 93.879 5.714 116.312-.45 20.96-5.742 63.934-21.426 63.14-23.616-.78-2.174-43.033 9.417-65.36 15.535-21.127 5.788-83.414 5.039-112.758.255-26.15-4.26-35.402-15.19-43.618-29.734-5.487-9.701-9.672-22.012-11.966-33.198-1.334-6.537-2.594-12.715-4.32-17.737-5.247-15.34-25.144-33.048-37.23-41.22a4.202 4.202 0 00-2.338-.72' fill='white'/%3e%3cpath d='M2084.15 1682.262c-1.35 0-2.667.645-3.478 1.844-1.29 1.919-.794 4.528 1.125 5.818 13.644 9.222 30.093 25.566 33.992 36.99 1.544 4.515 2.758 10.437 4.049 16.705 2.413 11.8 4.257 26.945 10.392 37.8 11.138 19.703 26.854 27.62 52.059 31.728 30.753 5.009 93.879 5.714 116.312-.45 20.96-5.742 63.934-21.426 63.14-23.616-.78-2.174-43.033 9.417-65.36 15.535-21.127 5.788-83.414 5.039-112.758.255-26.15-4.26-35.402-15.19-43.618-29.734-5.487-9.701-9.672-22.012-11.966-33.198-1.334-6.537-2.594-12.715-4.32-17.737-5.247-15.34-25.144-33.048-37.23-41.22a4.202 4.202 0 00-2.338-.72z' fill='none' stroke='%23909294' stroke-width='2.095'/%3e%3cpath d='M1874.02 1798.859c-8.893 2.879-1.289 6.792 13.93 2.744 6.717-1.77 21.427-6.029 34.277-12.686 16.06-8.322-40.516 7.452-48.208 9.942' fill='white'/%3e%3cpath d='M1874.02 1798.859c-8.893 2.879-1.289 6.792 13.93 2.744 6.717-1.77 21.427-6.029 34.277-12.686 16.06-8.322-40.516 7.452-48.208 9.942z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1893.378 1810.299c-8.083 4.692.164 6.913 14.2-.254 6.176-3.181 19.657-10.453 30.797-19.674 13.931-11.545-38.01 15.864-44.997 19.928' fill='white'/%3e%3cpath d='M1893.378 1810.299c-8.083 4.692.164 6.913 14.2-.254 6.176-3.181 19.657-10.453 30.797-19.674 13.931-11.545-38.01 15.864-44.997 19.928z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1904.623 1811.873c-7.932 4.978.405 6.913 14.17-.734 6.073-3.39 19.282-11.125 30.108-20.722 13.511-12.027-37.44 17.168-44.278 21.456' fill='white'/%3e%3cpath d='M1904.623 1811.873c-7.932 4.978.405 6.913 14.17-.734 6.073-3.39 19.282-11.125 30.108-20.722 13.511-12.027-37.44 17.168-44.278 21.456z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1916.365 1811.977c-7.903 5.024.435 6.913 14.169-.809 6.057-3.404 19.237-11.2 30.004-20.873 13.465-12.069-37.351 17.35-44.173 21.682' fill='white'/%3e%3cpath d='M1916.365 1811.977c-7.903 5.024.435 6.913 14.169-.809 6.057-3.404 19.237-11.2 30.004-20.873 13.465-12.069-37.351 17.35-44.173 21.682z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1930.669 1812.143c-7.812 5.157.554 6.897 14.155-1.08 5.997-3.508 19.027-11.546 29.614-21.397 13.255-12.31-37.022 18.01-43.77 22.477' fill='white'/%3e%3cpath d='M1930.669 1812.143c-7.812 5.157.554 6.897 14.155-1.08 5.997-3.508 19.027-11.546 29.614-21.397 13.255-12.31-37.022 18.01-43.77 22.477z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1945.303 1812.533c-7.467 5.638.99 6.853 14.064-1.95 5.758-3.883 18.264-12.73 28.22-23.21 12.446-13.137-35.837 20.286-42.284 25.16' fill='white'/%3e%3cpath d='M1945.303 1812.533c-7.467 5.638.99 6.853 14.064-1.95 5.758-3.883 18.264-12.73 28.22-23.21 12.446-13.137-35.837 20.286-42.284 25.16z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1961.254 1812.908c-5.783 5.633 1.575 5.775 11.81-3.204 4.526-3.955 14.276-12.88 21.677-22.962 9.25-12.618-28.482 21.285-33.487 26.166' fill='white'/%3e%3cpath d='M1961.254 1812.908c-5.783 5.633 1.575 5.775 11.81-3.204 4.526-3.955 14.276-12.88 21.677-22.962 9.25-12.618-28.482 21.285-33.487 26.166z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1974.992 1810.674c-4.902 6.432 2.4 5.487 11.2-4.903 3.884-4.574 8.682-8.667 14.5-19.733 7.287-13.854-21.487 19.073-25.7 24.636' fill='white'/%3e%3cpath d='M1974.992 1810.674c-4.902 6.432 2.4 5.487 11.2-4.903 3.884-4.574 8.682-8.667 14.5-19.733 7.287-13.854-21.487 19.073-25.7 24.636z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1982.115 1810.718c-5.34 6.072 2.023 5.653 11.545-4.078 4.199-4.288 13.24-13.929 19.853-24.56 8.262-13.287-26.78 23.39-31.398 28.638' fill='white'/%3e%3cpath d='M1982.115 1810.718c-5.34 6.072 2.023 5.653 11.545-4.078 4.199-4.288 13.24-13.929 19.853-24.56 8.262-13.287-26.78 23.39-31.398 28.638z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M1990.502 1810.897c-5.8 5.822 2.483 6.202 12.76-3.07 4.517-4.087 17.783-18.354 25.136-28.685 9.203-12.921-32.893 26.73-37.896 31.755' fill='white'/%3e%3cpath d='M1990.502 1810.897c-5.8 5.822 2.483 6.202 12.76-3.07 4.517-4.087 17.783-18.354 25.136-28.685 9.203-12.921-32.893 26.73-37.896 31.755z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2015.386 1796.918c-5.406 6.004 1.948 5.657 11.582-3.953 4.243-4.252 9.353-7.931 16.092-18.47 8.4-13.201-22.996 17.219-27.674 22.423' fill='white'/%3e%3cpath d='M2015.386 1796.918c-5.406 6.004 1.948 5.657 11.582-3.953 4.243-4.252 9.353-7.931 16.092-18.47 8.4-13.201-22.996 17.219-27.674 22.423z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2025.342 1796.16c-5.181 6.209 2.152 5.599 11.42-4.372 4.089-4.395 12.894-14.266 19.217-25.062 7.919-13.478-26.155 24.07-30.637 29.435' fill='white'/%3e%3cpath d='M2025.342 1796.16c-5.181 6.209 2.152 5.599 11.42-4.372 4.089-4.395 12.894-14.266 19.217-25.062 7.919-13.478-26.155 24.07-30.637 29.435z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2036.252 1794.2c-4.602 6.645 2.657 5.372 10.978-5.39 3.672-4.758 11.537-15.381 16.871-26.708 6.665-14.144-23.872 26.34-27.849 32.099' fill='white'/%3e%3cpath d='M2036.252 1794.2c-4.602 6.645 2.657 5.372 10.978-5.39 3.672-4.758 11.537-15.381 16.871-26.708 6.665-14.144-23.872 26.34-27.849 32.099z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2050.009 1786.652c-4.199 6.913 4.183 4.949 11.875-6.281 3.389-4.949 9.401-15.775 14.049-27.38 5.833-14.529-22.296 27.695-25.924 33.661' fill='white'/%3e%3cpath d='M2050.009 1786.652c-4.199 6.913 4.183 4.949 11.875-6.281 3.389-4.949 9.401-15.775 14.049-27.38 5.833-14.529-22.296 27.695-25.924 33.661z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2064.748 1776.816c-3.194 5.878 3.75 4.559 9.67-4.962 2.61-4.2 7.138-13.435 10.497-23.422 4.199-12.49-17.408 23.302-20.167 28.384' fill='white'/%3e%3cpath d='M2064.748 1776.816c-3.194 5.878 3.75 4.559 9.67-4.962 2.61-4.2 7.138-13.435 10.497-23.422 4.199-12.49-17.408 23.302-20.167 28.384z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2075.769 1771.929c-2.79 6.162 4.258 7.137 9.52-2.79 2.31-4.377 6.165-14.095 8.758-24.755 3.24-13.331-15.88 22.222-18.278 27.545' fill='white'/%3e%3cpath d='M2075.769 1771.929c-2.79 6.162 4.258 7.137 9.52-2.79 2.31-4.377 6.165-14.095 8.758-24.755 3.24-13.331-15.88 22.222-18.278 27.545z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2087.823 1763.097c-2.277 6.281 4.396 3.943 8.833-6.343 1.95-4.543 3.613-9.612 4.183-12.655 2.4-12.956-11.034 13.57-13.015 18.998' fill='white'/%3e%3cpath d='M2087.823 1763.097c-2.277 6.281 4.396 3.943 8.833-6.343 1.95-4.543 3.613-9.612 4.183-12.655 2.4-12.956-11.034 13.57-13.015 18.998z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2098.17 1751.941c.465 9.505 9.972-12.311 10.06-15.414.092-3.329-10.21 12.16-10.06 15.414' fill='white'/%3e%3cpath d='M2098.17 1751.941c.465 9.505 9.972-12.311 10.06-15.414.092-3.329-10.21 12.16-10.06 15.414z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2104.573 1746.602c-1.71 6.883 7.497-7.436 7.587-10.54.09-3.33-6.837 7.497-7.587 10.54' fill='white'/%3e%3cpath d='M2104.573 1746.602c-1.71 6.883 7.497-7.436 7.587-10.54.09-3.33-6.837 7.497-7.587 10.54z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2281.596 1781.42c8.637.135 28.548 1.11 28.548 2.91 0 1.813-16.763 6.267-35.1 5.742-18.325-.525-27.485-9.177 6.552-8.652' fill='white'/%3e%3cpath d='M2281.596 1781.42c8.637.135 28.548 1.11 28.548 2.91 0 1.813-16.763 6.267-35.1 5.742-18.325-.525-27.485-9.177 6.552-8.652z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2259.975 1772.559c8.59.869 28.34 3.508 28.188 5.308-.15 1.799-17.229 4.827-35.447 2.759-18.218-2.085-26.63-11.456 7.26-8.067' fill='white'/%3e%3cpath d='M2259.975 1772.559c8.59.869 28.34 3.508 28.188 5.308-.15 1.799-17.229 4.827-35.447 2.759-18.218-2.085-26.63-11.456 7.26-8.067z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2278.448 1791.645c4.257 1.321 34.456 1.906 42.164 3.134 7.706 1.23.27-9.685-21.728-7.587-21.997 2.084-29.598 1.56-20.436 4.453' fill='white'/%3e%3cpath d='M2278.448 1791.645c4.257 1.321 34.456 1.906 42.164 3.134 7.706 1.23.27-9.685-21.728-7.587-21.997 2.084-29.598 1.56-20.436 4.453z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2305.317 1795.59c6.463.089 21.367.869 21.383 2.489 0 1.618-12.522 5.667-26.24 5.261-13.72-.388-20.634-8.08 4.857-7.75' fill='white'/%3e%3cpath d='M2305.317 1795.59c6.463.089 21.367.869 21.383 2.489 0 1.618-12.522 5.667-26.24 5.261-13.72-.388-20.634-8.08 4.857-7.75z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2226.867 1769.23c3.628 1.229 29.465 1.769 36.06 2.893 6.598 1.125.226-8.906-18.592-6.986-18.818 1.933-25.31 1.454-17.468 4.093' fill='white'/%3e%3cpath d='M2226.867 1769.23c3.628 1.229 29.465 1.769 36.06 2.893 6.598 1.125.226-8.906-18.592-6.986-18.818 1.933-25.31 1.454-17.468 4.093z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2212.802 1763.097c3.748 1.14 30.408 1.634 37.2 2.684 6.808 1.048.24-8.293-19.178-6.509-19.403 1.8-26.105 1.35-18.022 3.825' fill='white'/%3e%3cpath d='M2212.802 1763.097c3.748 1.14 30.408 1.634 37.2 2.684 6.808 1.048.24-8.293-19.178-6.509-19.403 1.8-26.105 1.35-18.022 3.825z' fill='none' stroke='%23909294' stroke-width='1.366'/%3e%3cpath d='M2198.738 1753.545c3.073 1.65 25.835 4.512 31.532 6.327 5.698 1.815 1.17-9.73-15.653-9.28-16.823.464-22.508-.646-15.879 2.953' fill='white'/%3e%3cpath d='M2198.738 1753.545c3.073 1.65 25.835 4.512 31.532 6.327 5.698 1.815 1.17-9.73-15.653-9.28-16.823.464-22.508-.646-15.879 2.953z' fill='none' stroke='%23909294' stroke-width='1.377'/%3e%3cpath d='M2181.629 1742.69c2.174 1.89 19.687 6.462 23.93 8.681 4.229 2.234 2.31-9.507-11.005-10.36-13.315-.856-17.633-2.37-12.925 1.68' fill='white'/%3e%3cpath d='M2181.629 1742.69c2.174 1.89 19.687 6.462 23.93 8.681 4.229 2.234 2.31-9.507-11.005-10.36-13.315-.856-17.633-2.37-12.925 1.68z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2177.91 1734.818c2.189 1.888 19.702 6.462 23.93 8.697 4.229 2.218 2.326-9.523-10.99-10.377-13.331-.84-17.648-2.369-12.94 1.68' fill='white'/%3e%3cpath d='M2177.91 1734.818c2.189 1.888 19.702 6.462 23.93 8.697 4.229 2.218 2.326-9.523-10.99-10.377-13.331-.84-17.648-2.369-12.94 1.68z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2179.724 1727.56c2.175 1.889 19.703 6.463 23.932 8.697 4.228 2.219 2.308-9.521-11.006-10.377-13.316-.84-17.633-2.37-12.926 1.68' fill='white'/%3e%3cpath d='M2179.724 1727.56c2.175 1.889 19.703 6.463 23.932 8.697 4.228 2.219 2.308-9.521-11.006-10.377-13.316-.84-17.633-2.37-12.926 1.68z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2178.645 1720.858c2.294 1.739 20.047 5.217 24.41 7.183 4.363 1.963 1.725-9.643-11.62-9.658-13.345-.014-17.754-1.275-12.79 2.475' fill='white'/%3e%3cpath d='M2178.645 1720.858c2.294 1.739 20.047 5.217 24.41 7.183 4.363 1.963 1.725-9.643-11.62-9.658-13.345-.014-17.754-1.275-12.79 2.475z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2177.774 1712.866c2.296 1.74 20.05 5.217 24.412 7.167 4.363 1.964 1.725-9.642-11.62-9.656-13.346-.015-17.754-1.274-12.792 2.489' fill='white'/%3e%3cpath d='M2177.774 1712.866c2.296 1.74 20.05 5.217 24.412 7.167 4.363 1.964 1.725-9.642-11.62-9.656-13.346-.015-17.754-1.274-12.792 2.489z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2173.083 1707.452c2.504 1.41 20.587 2.444 25.16 3.778 4.588 1.35.404-9.776-12.82-7.976-13.225 1.8-17.768 1.155-12.34 4.198' fill='white'/%3e%3cpath d='M2173.083 1707.452c2.504 1.41 20.587 2.444 25.16 3.778 4.588 1.35.404-9.776-12.82-7.976-13.225 1.8-17.768 1.155-12.34 4.198z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2167.43 1700.51c-4.709 2.534 15.64.57 19.326 1.574 3.69.99 9.956-6.793-1.784-7.077-8.906-.226-17.543 5.503-17.543 5.503' fill='white'/%3e%3cpath d='M2167.43 1700.51c-4.709 2.534 15.64.57 19.326 1.574 3.69.99 9.956-6.793-1.784-7.077-8.906-.226-17.543 5.503-17.543 5.503z' fill='none' stroke='%23909294' stroke-width='1.571'/%3e%3cpath d='M2164.626 1697.975c-3.42 3.315 13.18-2.174 16.464-1.844 3.283.33 6.927-8.382-2.94-6.612-7.481 1.351-13.524 8.456-13.524 8.456' fill='white'/%3e%3cpath d='M2164.626 1697.975c-3.42 3.315 13.18-2.174 16.464-1.844 3.283.33 6.927-8.382-2.94-6.612-7.481 1.351-13.524 8.456-13.524 8.456z' fill='none' stroke='%23909294' stroke-width='1.452'/%3e%3cpath d='M2161.026 1694.633c-.899 4.333 11.937-4.798 15.115-5.144 3.164-.345 4.618-9.565-4.273-5.833-6.748 2.834-10.842 10.977-10.842 10.977' fill='white'/%3e%3cpath d='M2161.026 1694.633c-.899 4.333 11.937-4.798 15.115-5.144 3.164-.345 4.618-9.565-4.273-5.833-6.748 2.834-10.842 10.977-10.842 10.977z' fill='none' stroke='%23909294' stroke-width='1.424'/%3e%3cpath d='M2058.21 1651.538c-5.321-8.816-2.744-18.309 5.729-21.997 10.616-4.632 14.514.555 21.516 7.527 3.794 3.765 12.326 10.542 5.518 16.51 5.953 1.02 7.752 7.647 3.389 10.555 8.352 7.227-.06 18.414-9.386 18.084-2.864 5.712-9.823 7.243-12.91.794-11.321 3.194-17.588-12.624-13.061-21.006z' fill='white'/%3e%3cpath d='M2058.21 1651.538c-5.321-8.816-2.744-18.309 5.729-21.997 10.616-4.632 14.514.555 21.516 7.527 3.794 3.765 12.326 10.542 5.518 16.51 5.953 1.02 7.752 7.647 3.389 10.555 8.352 7.227-.06 18.414-9.386 18.084-2.864 5.712-9.823 7.243-12.91.794-11.321 3.194-17.588-12.624-13.061-21.006z' fill='none' stroke='%23909294' stroke-width='1.424'/%3e%3cpath d='M2048.553 1666.728c2.596-1.05 4.95-.27 9.657 1.05 4.724 1.304 12.836-.795 12.055-9.177-.794-8.367-7.121-13.614-14.814-10.99-7.707 2.623-18.023 5.502-23.347 5.502-5.308 0-16.043-.525-19.716 7.332-3.658 7.857-2.878 5.758-4.978 6.538-2.085.794-3.404 7.602-1.305 10.481 2.1 2.88 11.516 12.91 19.898 11.815 8.382-1.08 10.48-4.229 15.458-14.169 4.964-9.957 7.092-8.382 7.092-8.382' fill='%23f4ac64'/%3e%3cpath d='M2048.553 1666.728c2.596-1.05 4.95-.27 9.657 1.05 4.724 1.304 12.836-.795 12.055-9.177-.794-8.367-7.121-13.614-14.814-10.99-7.707 2.623-18.023 5.502-23.347 5.502-5.308 0-16.043-.525-19.716 7.332-3.658 7.857-2.878 5.758-4.978 6.538-2.085.794-3.404 7.602-1.305 10.481 2.1 2.88 11.516 12.91 19.898 11.815 8.382-1.08 10.48-4.229 15.458-14.169 4.964-9.957 7.092-8.382 7.092-8.382z' fill='none' stroke='%23473125' stroke-width='1.424'/%3e%3cpath d='M1991.17 1662.53c-.78 4.453 3.404 13.404 11.786 13.36 11.292-.06 12.58-8.637 12.58-10.992 0-2.368-8.936-2.099-10.496-.524-1.559 1.558-7.572 3.657-13.87-1.844' fill='%23f0e53c'/%3e%3cpath d='M1991.17 1662.53c-.78 4.453 3.404 13.404 11.786 13.36 11.292-.06 12.58-8.637 12.58-10.992 0-2.368-8.936-2.099-10.496-.524-1.559 1.558-7.572 3.657-13.87-1.844z' fill='none' stroke='%23473125' stroke-width='1.424'/%3e%3cpath d='M1994.575 1657.49c6.627-2.787 20.737-3.853 20.183 1.905-.54 5.758-7.35 4.184-8.397 2.085-1.035-2.085-5.233-3.66-11.786-3.99' fill='%23f0e53c'/%3e%3cpath d='M1994.575 1657.49c6.627-2.787 20.737-3.853 20.183 1.905-.54 5.758-7.35 4.184-8.397 2.085-1.035-2.085-5.233-3.66-11.786-3.99z' fill='none' stroke='%23473125' stroke-width='1.424'/%3e%3cpath d='M2008.205 1675.89c2.354 4.453 9.942 12.174 16.749 11.32 6.808-.84 10.406-1.334 12.28-4.438 2.655 2.549 2.174 6.478.45 7.527-1.725 1.05-3.404 1.98-5.58 3.869-2.173 1.889-6.776.585-8.92-1.514-2.158-2.1-1.364.524-6.597-1.305-5.248-1.844-.796-2.37-6.553-3.42-5.758-1.033-10.825-4.182-6.718-9.94 4.094-5.758 4.889-2.1 4.889-2.1' fill='%23473125'/%3e%3cpath d='M2008.205 1675.89c2.354 4.453 9.942 12.174 16.749 11.32 6.808-.84 10.406-1.334 12.28-4.438 2.655 2.549 2.174 6.478.45 7.527-1.725 1.05-3.404 1.98-5.58 3.869-2.173 1.889-6.776.585-8.92-1.514-2.158-2.1-1.364.524-6.597-1.305-5.248-1.844-.796-2.37-6.553-3.42-5.758-1.033-10.825-4.182-6.718-9.94 4.094-5.758 4.889-2.1 4.889-2.1z' fill='none' stroke='%23272425' stroke-width='1.424'/%3e%3cpath d='M2013.528 1674.06c3.059-1.05 7.766 7.333 13.524 1.305' fill='none' stroke='%23272425' stroke-width='1.424' stroke-linecap='round'/%3e%3cpath d='M2016.316 1673.266a2.618 2.618 0 002.624 2.624c1.44 0 2.608-1.17 2.608-2.624a2.61 2.61 0 00-2.608-2.61 2.615 2.615 0 00-2.624 2.61' fill='%23272425'/%3e%3c/g%3e%3c/svg%3e";

var img$1k = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 12 6'%3e%3ctitle%3eFlag of Slovenia%3c/title%3e%3crect width='12' fill='%23ed1c24' height='6'/%3e%3crect width='12' fill='%23005da4' height='4'/%3e%3crect width='12' fill='white' height='2'/%3e%3cg transform='translate(2.2238 1) scale(.12937)'%3e%3csvg width='12' viewBox='-120 -190.223125 240 309.188274' height='15.459'%3e%3cpath d='m110.26-19.478l9.74-143.75a280.22 280.22 0 0 0 -240 0l9.74 143.75a155.61 155.61 0 0 0 110.26 138.45 155.61 155.61 0 0 0 110.26 -138.45' fill='%23005da4'/%3e%3cpath d='m-90 0a138.29 138.29 0 0 0 90 100.77 138.29 138.29 0 0 0 90 -100.77l-45-60-18 24-27-54-27 54-18-24-45 60' fill='white'/%3e%3cg id='wave' fill='%23005da4' transform='scale(5) translate(0 5.1962)'%3e%3cpath d='m-17.196-2.1962a6 6 0 0 0 8.1962 2.1962 6 6 0 0 1 6 0 6 6 0 0 0 6 0 6 6 0 0 1 6 0 6 6 0 0 0 8.1962 -2.1962v1.732a6 6 0 0 1 -8.1962 2.1962 6 6 0 0 0 -6 0 6 6 0 0 1 -6 0 6 6 0 0 0 -6 0 6 6 0 0 1 -8.1962 -2.1962z'/%3e%3c/g%3e%3cuse xlink:href='%23wave' transform='translate(0 17.321)'/%3e%3cg id='s' transform='translate(0%2c-120) scale(2.25)'%3e%3cpath stroke-width='.2' d='m0-5l1 3.2679 3.3301-0.7679-2.3301 2.5 2.3301 2.5-3.3301-0.7679-1 3.2679-1-3.2679-3.3301 0.7679 2.3301-2.5-2.3301-2.5 3.3301 0.7679z' fill='%23fd0'/%3e%3c/g%3e%3cuse xlink:href='%23s' transform='translate(-33.75%2c-45)'/%3e%3cuse xlink:href='%23s' transform='translate(33.75%2c-45)'/%3e%3cpath d='m-111.58-167.05l9.96 146.99a146.95 146.95 0 0 0 101.62 129.95 146.95 146.95 0 0 0 101.62 -129.95l9.96-146.99a280.22 280.22 0 0 0 8.42 3.82l-9.74 143.75a155.61 155.61 0 0 1 -110.26 138.45 155.61 155.61 0 0 1 -110.26 -138.45l-9.74-143.75a280.22 280.22 0 0 0 8.42 -3.82' fill='%23ed1c24'/%3e%3c/svg%3e%3c/g%3e%3c/svg%3e";

var img$1j = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1350 900'%3e%3cpath fill='white' d='M0 0h1350v900H0z'/%3e%3cpath fill='%230c4076' d='M0 0h1350v600H0z'/%3e%3cpath fill='%23c6363c' d='M0 0h1350v300H0z'/%3e%3cg transform='matrix(1 0 0 1.00437 0 -.33)'%3e%3cpath fill='%2321231e' d='M473.38 259.35zm1.01.03zm-93.13 5.25c-2.31-.26 3.48-.78 4.86-.75 29.24-1.82 58.48-3.65 87.74-5.02 0 2.15-3.95.67-5.64 1.28a6448 6448 0 0 0-87.42 5.1l.24-.33.22-.28zm-1 .2zm6.54 31.06l-6.53-31.05c2.25-.16 1.38 4.47 2.35 6.27l5.17 24.57c-.4.52-.44.87-.99.21zm.51.4zm94.85-4.08c.04 2.3-4.1.53-5.78 1.2-29.7.92-59.38 2.04-89.07 2.88.2-2.23 4.52-.57 6.42-1.2 29.48-.88 58.95-1.99 88.43-2.88zm-.03 0zm94.37 3.47c2.17 1.02-3.86.39-5.14.45-29.75-.88-59.49-2-89.23-2.9.26-2.2 4.35-.33 6.22-.83 29.55.93 59.1 2.03 88.65 2.87l-.32.26-.18.15zm.98.21zm6.54-31.05l-6.54 31.05c-2.11-.77.54-4.65.38-6.7l5.17-24.56c.52-.61.64-.33.99.2zm-.46-.62zm-93.66-4.84c.85-.7 3.25-.4 5.62-.28 29.36 1.44 58.7 3.27 88.04 5.12-.34 2.2-4.38.2-6.28.63-28.96-1.81-57.92-3.62-86.9-4.97l-.29-.3-.2-.2zm.48.5zm.52-.7zm-1 .03zm-7.78.33c-.26-2.1 3.14-.64 4.55-1.14 1.47.3 4.04-.8 4.73.78-1.25 1.64-1.02-2.07-.7.28-2.85-.18-5.72.03-8.58.08zm.04 0zm-8.27.16c1.01-.99-2.16.39-.12-1.29 2.8-.11 5.6.04 8.4.12.09 2.04-3.19.47-4.64.88-1.05-.12-3.4.15-3.78-.06-.19-1.12.33-1.12.14.35zm0-1.02zm-.5.5z'/%3e%3cpath fill='%2321231e' d='M595.05 245.94c.04-1.75-1.12 2.5-2.62 3.5-3.3 4.72-5.97 9.85-8.53 15-1.91-1 1.3-3.69 1.6-5.38 2.56-4.86 5.38-9.6 8.86-13.85l.69.73zm-19.26-3.89c1.12-2.16.75 3.65 1.7 4.68 1 4.16 6 4.87 9.3 3a38.01 38.01 0 0 0 7.66-4.61c1.1 2-3.51 3.1-4.96 4.43-3.69 2.33-9.93 3.71-12.32-1.08-1.14-2.1-1.52-4.5-1.71-6.86l.27.36.06.08zm.34-.96zm-2.32.51c-1.86-1.07 1.12-.83 2-.6.85.63-.33 1.29-1.08.86-.29-.1-2.06.15-.92-.26zm-.85-.55zm-25.3-5.27c-1.12-1.84 2.27 3.42 2.86 4.86 2.78 4.64 7.31 10.9 13.54 8.97 3.98-1.52 6.62-5.14 8.9-8.56 1.75 1.36-2 3.86-2.86 5.44-3.19 4.15-9.57 6.3-13.89 2.54-4.38-3.38-7.04-8.43-9.44-13.3l.46.03.42.02zm-.86-.54zm-28.4-.53c-1-1.98 2.04 3.38 2.51 4.73 2.43 4.83 7.24 10.87 13.37 8.53 5.68-2.37 9.24-7.8 12.52-12.73 1.74 1.46-2.18 4.15-2.94 5.96-3.59 4.7-9.6 10.43-15.96 7.49-5.4-2.82-8.05-8.78-10.37-14.1l.45.06.42.06zm-.8-.63zm-33.75.67c2.09-.5 2.52 3.57 4.36 4.98 3.49 5.15 10.38 8.69 16.37 5.64 5.34-2.4 9.4-6.84 13.03-11.3 1.56 1.65-2.62 3.88-3.57 5.6-4.93 5.29-12.95 10.37-20.16 6.41-4.51-2.44-7.7-6.89-10.03-11.33zm.06.25zm.95-2.34zm-1.01 0zm-.98.37c1.2-.5.16-.85 1.53-.66-.68.75.1 1.27.16-.17 1.74 1.2-1.12 1.57-1.69.83zm.38.27zm.33-1.12zm-.55-.27zm-.98 1.2c-.16-1.12.06-1.04.98-1.2.75 1.28-.24 1.05-.98 1.2zm.19 0zm-.63-.46c-2.47-.76 1.96-1.22.41.45-.36-.13-1.64-.1-.4-.45zm-.9-.47zm-.2.38zm.9.47zm-.97-.37c-2.17-.42.62 1.35-.52-.28.93-.54 1.75 1.18.35 1-1.6.4-1.1-2.14.17-.72zm-.71-.46zm-.3 2.55zm1.01 0zm-33.68-.16c-1.53-1.62 2.78 2.5 3.58 3.72 4.7 5.08 12.08 10.54 19.23 7.07 4.5-2.28 7.5-6.6 9.92-10.88 1.85 1.34-1.92 4.19-2.68 5.95-3.75 5.45-11.1 9.06-17.45 5.87-5.52-2.43-9.72-7-13.47-11.6l.46-.07.4-.06zm-.94-.39zm-28.3 1.53c-1.39-1.7 2.5 2.8 3.15 4.14 3.45 4.45 8.65 10.35 14.93 8.07 5.4-2.6 7.94-8.55 10.22-13.74 1.94 1.2-1.47 4.57-1.98 6.52-2.58 5.02-7.96 10.66-14.13 8.23-5.93-2.42-9.68-8.03-13.07-13.17l.45-.03.43-.02zm-.91-.44zm-25.7 6.54c.26-2.42 2.48 3.01 3.72 3.65 2.9 3.87 8.79 6.35 12.88 2.7 4.23-3.28 6.77-8.18 9.1-12.9 1.9 1.3-1.74 4.5-2.3 6.45-2.95 4.87-7.98 10.97-14.4 8.85-4.21-1.58-7.03-5.36-9.43-8.98l.4.22.03.01zm0-1.02zm-2.08.8c-2.21-.32.87-1 1.81-.8 1.1.98-.44 1.15-1.3 1.07-.36-.06-1.38.52-.5-.27zm-1-.08zm-17.9 3.68c-1.67-.03 3.14 1.52 4.4 2.92 3.42 2.18 9.45 4.5 11.91-.16 1.06-1.97 1.4-4.23 1.58-6.44 2.2.33.06 4.34-.24 5.98-1.44 4.64-7.2 5.12-10.88 2.98a40.12 40.12 0 0 1-7.46-4.55l.7-.73zm10.89 18.5c-.18 2.44-1.9-2.65-2.61-3.57-2.6-5-5.48-9.9-9.06-14.29 1.68-1.37 2.77 2.7 4.05 3.75 3.1 4.56 5.65 9.45 8.1 14.38l-.4-.23-.08-.05zm.04 1.01zm101.31-5.97c-.19 2.39-4.82.6-6.78 1.37-31.5 1.66-63.01 3.28-94.53 4.6.36-2.32 5.1-.6 7.21-1.33 31.38-1.35 62.74-3 94.1-4.64zm-.05 0zm101.33 4.95c-.22 2.39-4.9.13-6.83.73-31.5-1.36-63-3-94.5-4.67.56-2.27 5.12-.12 7.28-.63 31.33 1.64 62.78 3.27 94.05 4.57zm0 1.02zm0 0zm.45-.28z'/%3e%3cpath d='M583.45 264.21c3.27-6.6 6.7-13.07 11.3-18.68-11.75 8.74-17.93 7.42-18.8-3.96-.69-.25-1.63-.25-2.57-.25-8.96 13.98-17.68 12.04-26.16-5.81-11.54 18.35-21.44 18.02-29.22-1.12-13.31 16.73-24.53 16.77-33.65.36v-2.09c.51.23.16.3-1.03.13l-.2-.38-.98.2-.98-.2-.2.38c-1.19.17-1.53.1-1.03-.13v2.09c-9.12 16.41-20.33 16.37-33.64-.36-7.78 19.14-17.69 19.47-29.23 1.12-8.47 17.85-17.2 19.79-26.15 5.81-.95 0-1.89 0-2.58.25-.86 11.38-7.04 12.7-18.79 3.96 4.59 5.6 8.02 12.08 11.3 18.68 33.84-1.41 67.58-3.18 101.3-4.96 33.73 1.78 67.46 3.55 101.32 4.96z' fill='%23edb92e'/%3e%3cpath fill='%23EDB92E' d='M504.88 276.18l-22.74 11.45-22.74-11.45 22.74-11.46z'/%3e%3cpath fill='%23edb92e' d='M473.89 259.19v.18c-17.5.78-48.48 2.52-93.13 5.36l6.54 31.05c29.65-.83 64.25-2.14 94.84-3.06 30.59.92 65.2 2.23 94.85 3.06l6.53-31.05c-44.64-2.86-75.63-4.6-93.12-5.38v-.18c1.76-.34-.98-.4-8.26-.15-7.27-.25-10.01-.2-8.25.16z'/%3e%3cpath fill='%23edb92e' d='M597.33 236.74l-3.68-.62c-7.08 17.4-13.42 17.81-14.61 1.27 1.58-.57.95-3.33 2.74-2.23.94.58 2.14-1.07 1.36-1.98-2-1.48-3.79-1.25-5.54.4-.83-2.64-2.85-3.87-5.38-2.76-1.09.48-.71 2.46.38 2.35 1.77-.19 1.06 1.66 1.6 2.9-12.54 16.48-18.95 14.52-17.4-7.12-2.98-.62-6.46-1.24-9.57-2.36-11.55 23.35-19.76 24.35-26.42 3.4 1.43-1.06 1.02-3.75 3.1-2.89 1.18.49 2.16-1.6 1.12-2.49-2.44-2.06-5.08-1.36-6.84 1.29-1.42-2.85-3.95-3.88-6.62-2.15-1.16.75-.44 2.94.78 2.61 2.36-.64 1.3 2.47 3.08 3.54-5.1 19.7-30.87 21.02-26.65-8.13l-6.63.24-6.63-.24c4.22 29.15-21.55 27.83-26.65 8.13 1.78-1.07.72-4.17 3.07-3.54 1.23.33 1.95-1.86.8-2.61-2.68-1.73-5.2-.7-6.63 2.15-1.77-2.65-4.4-3.35-6.84-1.29-1.05.9-.06 2.98 1.11 2.5 2.09-.87 1.68 1.82 3.1 2.88-6.65 20.95-14.86 19.95-26.41-3.4-3.11 1.12-6.59 1.74-9.58 2.36 1.56 21.64-4.85 23.6-17.4 7.12.55-1.24-.16-3.09 1.61-2.9 1.1.11 1.47-1.87.38-2.35-2.53-1.11-4.55.12-5.38 2.76-1.75-1.65-3.53-1.88-5.54-.4-.78.91.42 2.56 1.36 1.98 1.79-1.1 1.16 1.66 2.74 2.23-1.19 16.54-7.53 16.12-14.6-1.27l-3.69.62a18.6 18.6 0 0 0 3.8 11.63c10.62 13.55 18.5 10.48 18.8-4.7 13.89 16.4 24.39 14.32 26.27-2.97 11.69 21.8 30.44 11.37 30.82-1.86 5.15 19.23 33.67 19.1 35.5-3 1.82 22.1 30.33 22.23 35.48 3 .39 13.23 19.14 23.67 30.82 1.86 1.89 17.29 12.39 19.36 26.28 2.97.29 15.18 8.18 18.25 18.79 4.7a18.6 18.6 0 0 0 3.8-11.63z'/%3e%3cpath fill='%2321231e' d='M593.72 235.62c4.42.05 4.1 2.48-.17 1-.24-.55-.74-.76.17-1zm-.55.3zm-14.31 1c1.16.8.75 3.84 1.44 6.24.45 2.4 1.82 7.19 5.1 5.32 3.95-3.12 5.78-8.08 7.77-12.55 1.99 1.06-1.31 4.29-1.7 6.15-1.9 3.11-4.05 8.36-8.46 7.76-4.07-2.5-3.89-8.18-4.49-12.41l.26-.4.08-.12zm-.34.51zm3.52-2.7c-.24 1.18-1.38.21-1.46 1.61-.08 1.42-2.4 1.82-1.4.37.75-1 1.07-3.23 2.86-1.98zm.79-1.13c1.4-2.17 1.4 2.38-.44 2.18-1.69-.01-.03-1 .42-1.6.2-.13-.11-.81.02-.58zm.6-.82zm-6.32.96c.83-.13.38-1.67 2.72-1.98 1.17-.28 4.43.43 3 1.84a3.44 3.44 0 0 0-4.9.36l-.45-.12-.37-.1zm.82.22zm-5.51-2.67c-1.1-1.94 3-1.63 3.93-.56 1.47.51 2.07 4.24.51 2.36a3.14 3.14 0 0 0-4.44-1.8zm.12 1.37c.49 2.56-2.62-.54-1.22-1.7.92-1.27 1.1.4.76 1.17.04.23.19.56.46.53zm2.06 3.72c-1.14-.33-1.04-.34-1.21-2 .08-.9-1.57-.9-.66-1.73 2.01-.12 1.69 2.45 1.87 3.73zm.06-.52zm-17.96-6.41c1.04-2.15.2 4.21.38 5.54.26 3.8-.25 8.93 3.3 11.34 4.48.55 7.56-3.98 10.38-6.8.87-1.8 5.23-5.6 2.7-1.67-3.5 3.86-7.04 9.44-12.76 9.6-4.65-1.61-4.34-7.7-4.63-11.77.2-1.36-.4-7.1.63-6.24zm.2-1zm-9.23-1.63c-1.97-1.45 2.82.35 3.89.5 1.58.68 4.56.36 5.25 1.59-.87 1.12-3.6-.53-5.17-.53-.76-.32-5.49-1.02-3.97-1.56zm-.9-.45zm-26.27 3.22c1.44.48 1.68 3.74 2.87 5.95 1.74 3.83 4.34 9.74 9.49 8.7 6.47-2.86 9.49-9.96 12.84-15.76 2.04-4.36 1.87.24.02 2.13-3.32 5.54-6.48 12.54-13.05 14.71-5.87.77-8.68-5.8-10.6-10.25-.46-1.75-1.84-3.7-1.57-5.48zm-.18.56zm3.78-3.51c-.29 1.1-1.9.73-1.97 2.4-.27 1.77-2.37 1.05-1.05-.17.53-1.28 1.24-3.13 3.02-2.23zm.59-1.63c1.53-2.09 1.8 2.68-.15 2.65-1.6.08-.14-1.02.33-1.57.13-.36.13-.83-.18-1.08zm-6.96 1.12c.6-.24.55-2.36 3.02-3 1.38-.6 4.46.09 4.3 1.46-.86.72-2.4-1.39-3.79-.55-1.59.12-2.08 2.4-3.53 2.09zm.87.06zm-6.77-2.01c-1.52-1.63 2.34-2.02 3.43-1.63 1.34.33 4.3 2.69 2.54 3.54-1.05-2.17-3.71-3.65-5.97-1.91zm.38 1.7c.9 2.26-2.41.23-1.73-1.17-.13-1.63 1.9-1.3 1.03-.06-.11.44.1 1.32.7 1.22zm3.7 4.15c-1.1.41-1.67-.25-2.2-2.08.09-1.47-1.63-.8-1.5-2.08 2.76-.77 2.23 2.96 3.7 4.16zm-.23-.56zm-26.9-7.19c.7-2.22-.03 4.13.05 5.55-.31 6.6 2.68 15.25 10.3 15.85 7.94.48 14.1-6.72 15.8-13.9 2.11.97-1.03 4.8-1.7 6.62-3.66 6.67-13.23 11.3-19.88 6.07-5.97-4.98-6.04-13.68-5.08-20.77l.31.35.2.23zm-.03-1.02zm-6.63 1.26c-.43-1.97 2.46-.7 3.64-1.15 1.07-.15 4.2-.27 2.59.93l-6.23.22zm.04 0zm-6.15-.82c-2.37-.09 1.54-.68 2.5-.33 1.2.38 4.01-.73 3.61 1.14l-6.63-.23.31-.35.2-.23zm-1 .15zm-26.41 7.62c1.33.6 1.58 3.93 3.11 6.05 3.3 6.35 12.3 11.09 18.63 6.12 5.62-4.8 5.55-13.06 4.67-19.8 2.31.09 1.02 4.89 1.44 6.9.14 6.85-3.4 15.38-11.17 15.95-8.45.58-15.1-7-16.91-14.66l.18-.43.05-.13zm-.23.56zm3.7-4.16c.17 1.35-1.61.57-1.5 2.09.07 1.23-1.98 3.35-1.74 1.34 1.12-1.2.7-4.22 3.24-3.43zm.38-1.69c1.26-2.27 2.13 2.44.18 2.65-1.58.29-.26-.99.13-1.6.1-.37.03-.83-.31-1.05zm-6.77 2c.56-.31.26-2.4 2.62-3.36 1.3-.78 4.44-.48 4.44.9-.75.82-2.55-1.07-3.82-.06-1.56.32-1.76 2.64-3.24 2.53zm.88-.05zm-6.97-1.12c-1.6-1.49 2.21-2.4 3.44-2.02 1.3.27 4.47 2.2 2.65 3.2-1.2-2.21-4.2-3.11-6.09-1.18zm.6 1.63c1.17 2.13-2.38.54-1.87-.94-.34-1.6 1.72-1.52 1.01-.2-.05.47.27 1.31.85 1.14zm3.77 3.51c-1.13.24-1.4-.16-2.13-1.85-.07-1.27-2.18-.53-1.43-1.75 2.28-.77 2.52 2.4 3.56 3.6zm-.18-.56zm-26.55-2.51c-.2-2.4 2.31 3.55 3.08 4.61 3.03 4.84 5.95 11.05 11.86 12.71 5.32 0 7.46-6.07 9.27-10.16.19-2.16 3.16-6.73 1.89-2.18-2.03 5.04-4 11.98-10 13.35-6.13-.03-9.5-6.36-12.52-10.84a110.81 110.81 0 0 1-4.2-7.75l.43.18.19.08zm-.34-.96zm-8.9 2.8c-2.45-.26 2.49-1.12 3.52-1.32 1.8-.07 4.29-1.7 5.54-1.04-.23 1.47-3.55 1.31-5.02 1.96-.8-.04-5.12 1.57-4.05.4zm-1.01.07zm-17.36 6.87c1.62-.26 2.72 2.83 4.52 4.37 2.65 2.61 5.6 6.69 9.75 6.1 3.68-2.52 3.04-7.87 3.32-11.81-.23-1.58-.3-8.21.86-4.21.03 5.39.96 11.72-2.62 16.22-3.99 2.9-8.26-1.74-10.95-4.4-1.64-1.99-3.9-3.93-4.88-6.27zm.06.52zm2.06-3.72c.06 1.11-1.3 1.28-.96 2.75-.02 1.54-1.66.42-.94-.65-.01-1.14.54-2.34 1.9-2.1zm.12-1.37c.8-2.42 2.3 1.77.52 2.24-1.54.47-.16-1.02-.18-1.75-.02-.2-.14-.4-.34-.49zm-5.51 2.67c.52-.5-.3-2.05 1.76-3.37 1-.94 4.8-1.15 3.75.7-1.95-1.12-4.29.38-4.69 2.45l-.45.12-.37.1zm.82-.22zm-5.64-.22c-1.87-1.15 1.86-2.1 2.92-1.76 1.26-.07 3.59 2.13 1.59 1.92-1.24-1.35-3.53-1.08-4.5-.16zm-.76-.67zm1.47 1.88c1.44 2.19-2.71.5-1.81-1.18.56-1.47 1.03.3 1.25 1 .14.14.36.3.56.18zm3.52 2.7c-1.02.43-1.4.35-2.17-1.34-.02-1.12-1.7-.37-1.16-1.47 2.09-1.07 2 2.07 3.33 2.81zm-.34-.52zm-14.7-.28c.13-2.42 1.95 3.46 2.76 4.55 1.76 2.89 3.35 7.2 7.1 7.79 3.7-1.84 3.45-7.02 4.08-10.6 1.43-3.12.96 2.89.46 4.23-.49 3.05-2.05 8.63-6.19 7.07-4.65-2.96-6.56-8.56-8.75-13.35l.4.23.15.08zm-.16-1.01zm-3.68.62c4.2-1.4 4.67 1 .16 1-.45-.44-.9-.47-.16-1zm-.43.49zm4.71 11.33c-1.96 1.27-2.9-3.48-3.76-5.01-.27-1.81-2.18-6.03.06-6.3a18.02 18.02 0 0 0 3.7 11.3zm18.78-4.72c-.58.1.6 3.23-.34 5.53-.42 4.37-3.71 10.06-8.86 8.35-4.4-1.4-7.55-5.07-10.37-8.53 1.93-1.14 3.27 3.4 5.27 4.26 2.7 2.84 8.33 5.52 10.99 1.2 1.98-3.1 2.29-6.9 2.42-10.49l.89-.32zm-.9.32zm27.24-3.2c-.74-.13.33 3.14-.83 5.27-.93 5.16-5.2 10.9-11.09 9.5-6.34-1.5-11.03-6.52-15.2-11.23 1.97-1.15 3.55 3.44 5.58 4.4 3.94 3.59 9.95 8.12 15.32 4.74 3.75-2.96 4.7-8.01 5.27-12.5l.95-.18zm-.95.18zm31.81-1.93c-.85-.53.5 3.54-1.16 5.52-2.98 8.15-13.67 12.4-21.1 7.44-4.2-2.47-7.2-6.51-9.5-10.73 2.13-.8 2.7 3.93 4.6 5.1 4.3 5.96 13.16 9.1 19.55 4.53a14.87 14.87 0 0 0 6.62-11.74l.99-.12zm35.5-2.91c-.9-.78.37 3.46-1.06 5.4-2.7 9.73-14.41 14.68-23.54 10.98a19.15 19.15 0 0 1-11.88-13.2c2.23-.26 1.9 4.47 3.83 5.86 6.2 9.32 21.7 10.25 28.23.83a19.81 19.81 0 0 0 3.42-9.87h1zm35.5 3.03c-.76-.72-.25 3.5-2.1 5.17-5.62 10.4-21.74 12.76-29.63 3.7-2.93-3.23-4.42-7.53-4.77-11.82 2.22.1.96 4.6 2.5 6.3 3.53 9.7 16.5 12.99 24.86 7.54a18.16 18.16 0 0 0 8.14-11l1 .1zm30.81 1.81c-.55-.32-1.23 3.58-3.2 5.2-4.32 6.41-13.33 10.45-20.5 6.22a15.88 15.88 0 0 1-8.13-13.2c2.14.17.9 4.48 2.61 6.06 3.35 7.35 13.47 10.37 20.02 5.35 3.58-2.45 6.2-6.04 8.25-9.81l.95.18zm-.95-.18zm27.23 3.2c-.5-.29-1.64 2.9-3.69 4.22-4.35 4.22-10.72 9.59-17.12 6.59-4.66-2.82-5.84-8.7-6.47-13.71 2.2-.03 1 4.31 2.23 6 1.02 4.62 5.47 9.12 10.49 7.24 5.64-1.83 9.86-6.33 13.67-10.66l.9.32zm-.89-.32zm18.78 4.72c1.6 1.56-2.43 3.74-3.44 5.3-3.06 3.27-9.2 6.32-12.56 1.8-2.39-3.3-2.76-7.53-2.9-11.48 2.24.25.6 4.66 1.79 6.54.48 3.72 4 7.8 8 5.77 3.78-1.58 6.59-4.83 9.1-7.93zm4.2-10.8c.7-2.34.53 3.82-.2 5.02-.75 2.03-1.77 5.65-3.57 6.12-.34-1.59 2.34-3.87 2.48-6.03.87-1.04.33-6.15 1.3-5.12zm0-1.03zm0 0zm0 1.02z'/%3e%3cpath fill='%23edb92e' d='M482.14 262.87c-33.98 0-67.97 1.7-101.77 5.22-7.83-.17-1.9-8.29 3.26-6.3a987.52 987.52 0 0 1 201.3.5c7.56 3.1-1.56 8.07-5.92 5.3a984.52 984.52 0 0 0-96.87-4.72z'/%3e%3cpath fill='%230c4076' d='M482.14 105.07c9.48 0 17.17 7.74 17.17 17.3 0 9.55-7.69 17.3-17.17 17.3a17.23 17.23 0 0 1-17.17-17.3c0-9.56 7.69-17.3 17.17-17.3z'/%3e%3cpath fill='%23edb92e' d='M485.26 84.9a3.12 3.12 0 0 0 3.03-3.14c0-1.7-1.35-3.09-3.03-3.13-.01-1.73-1.4-3.12-3.12-3.12-1.7 0-3.1 1.4-3.1 3.12a3.12 3.12 0 0 0-3.04 3.13c0 1.7 1.35 3.09 3.03 3.13v6.43h-5.5c0-1.72-1.39-3.12-3.1-3.12a3.13 3.13 0 0 0-3.11 3.06c-1.71 0-3.1 1.4-3.1 3.13a3.12 3.12 0 0 0 3.1 3.13 3.12 3.12 0 0 0 3.1 3.06 3.12 3.12 0 0 0 3.12-2.98h5.49v21.37h6.23V97.6h5.5a3.12 3.12 0 0 0 3.1 2.98c1.7 0 3.07-1.36 3.11-3.06 1.71 0 3.1-1.4 3.1-3.13a3.12 3.12 0 0 0-3.1-3.13 3.12 3.12 0 0 0-3.1-3.06c-1.72 0-3.1 1.4-3.12 3.12h-5.49v-6.43z'/%3e%3cpath fill='%2321231e' d='M487.78 81.76c.78-.16 1.27.07.9.9a3.64 3.64 0 0 1-3.4 2.74c-.06-.6-.16-1.17.6-1.11a2.63 2.63 0 0 0 1.9-2.53zm-3.03-3.13c.95.14.97-.12.63-.5a3.65 3.65 0 0 1 3.41 3.63c-.62.05-1.17.12-1.09-.64a2.63 2.63 0 0 0-2.46-1.98l-.5-.51zm.5.5zm-3.1-3.11c-.16-.78.06-1.28.9-.9a3.66 3.66 0 0 1 2.71 3.5c-.62.06-1.17.12-1.1-.64a2.62 2.62 0 0 0-2.52-1.96zm-3.1 3.12c.12-.95-.14-.98-.52-.63a3.65 3.65 0 0 1 3.61-3.51c.05.62.12 1.18-.65 1.1a2.63 2.63 0 0 0-1.95 2.53l-.5.5zm.49-.51zm-3.03 3.13c-.79.16-1.27-.07-.9-.9a3.64 3.64 0 0 1 3.41-2.74c.06.61.15 1.18-.6 1.11a2.63 2.63 0 0 0-1.91 2.53zm3.03 3.13c-.95-.14-.97.12-.64.5a3.65 3.65 0 0 1-3.4-3.63c.62-.04 1.17-.11 1.09.65a2.63 2.63 0 0 0 2.45 1.98l.5.5zm-.5-.5zm-.52 6.93v-6.43c.98-.25 1.17.28 1.02 1.16v5.27c-.5.58-.51.6-1.02 0zm1.02 0zm-6-.51h5.49c.25.98-.27 1.17-1.16 1.02h-4.33c-.58-.5-.59-.52 0-1.02zm0 1.02zm-3.11-3.12c-.16-.78.07-1.28.9-.9a3.66 3.66 0 0 1 2.72 3.5c-.63.06-1.18.12-1.1-.64a2.62 2.62 0 0 0-2.52-1.96zm-3.11 3.06c.14-.95-.12-.98-.5-.64a3.65 3.65 0 0 1 3.6-3.44c.05.62.13 1.18-.63 1.1a2.64 2.64 0 0 0-1.97 2.48l-.5.5zm.5-.5zm-3.09 3.12c-.8.16-1.27-.08-.9-.9a3.64 3.64 0 0 1 3.49-2.74c.04.62.12 1.18-.65 1.1a2.63 2.63 0 0 0-1.94 2.54zm3.1 3.12c-.96-.12-.97.14-.63.52a3.65 3.65 0 0 1-3.48-3.64c.63-.05 1.17-.1 1.1.66a2.62 2.62 0 0 0 2.5 1.96l.5.5zm-.5-.5zm3.1 3.06c.15.78-.07 1.28-.9.9a3.65 3.65 0 0 1-2.72-3.43c.62-.06 1.17-.15 1.11.61a2.62 2.62 0 0 0 2.5 1.92zm3.1-2.98c-.14.93.12.98.5.65a3.65 3.65 0 0 1-3.6 3.35c-.04-.61-.13-1.18.63-1.1a2.64 2.64 0 0 0 1.97-2.42l.5-.48zm-.5.48zm6 .54h-5.5c-.25-.98.28-1.18 1.16-1.02h4.34c.58.5.59.51 0 1.02zm0-1.02zm-.5 21.88V97.6c.97-.26 1.16.28 1 1.15v20.22c-.49.58-.5.6-1 0zm.5.5zm6.23 0h-6.23c-.25-.97.27-1.17 1.15-1.01h5.08c.58.5.59.52 0 1.02zm.5-.5zm0-21.37v21.37c-.97.25-1.16-.28-1-1.16V97.6c.49-.59.5-.6 1 0zm-1 0zm6 .5h-5.5c-.25-.97.27-1.17 1.16-1.01h4.33c.62.48.56.5 0 1.02zm0-1.01zm3.1 2.98c.15.77-.05 1.28-.88.91a3.66 3.66 0 0 1-2.73-3.36c.6-.07 1.16-.18 1.12.58a2.62 2.62 0 0 0 2.5 1.87zm3.1-3.06c-.13.95.13.98.51.64a3.64 3.64 0 0 1-3.6 3.44c-.05-.62-.13-1.18.63-1.1a2.63 2.63 0 0 0 1.97-2.48l.5-.5zm-.5.5zm3.1-3.12c.79-.16 1.27.08.9.9a3.64 3.64 0 0 1-3.49 2.74c-.05-.62-.12-1.18.65-1.1a2.63 2.63 0 0 0 1.94-2.54zm-3.1-3.12c.96.12.97-.14.63-.52a3.65 3.65 0 0 1 3.48 3.64c-.63.05-1.17.1-1.1-.66a2.62 2.62 0 0 0-2.5-1.96l-.5-.5zm.5.5zm-3.1-3.06c-.15-.77.06-1.28.9-.9a3.65 3.65 0 0 1 2.72 3.43c-.62.07-1.17.15-1.1-.61a2.62 2.62 0 0 0-2.52-1.92zm-3.11 3.12c.14-.96-.11-.98-.5-.63a3.65 3.65 0 0 1 3.61-3.5c.05.62.11 1.17-.65 1.1a2.63 2.63 0 0 0-1.95 2.52l-.51.5zm.5-.5zm-5.99-.52h5.49c.25.98-.27 1.17-1.16 1.02h-4.33c-.58-.5-.59-.52 0-1.02zm0 1.02zm.5-6.94v6.43c-.97.25-1.16-.28-1-1.16V84.9c.48-.6.5-.57 1 0zm-1 0zm.5 0zm-.5 0z'/%3e%3cpath fill='%2321231e' d='M499.82 122.37c-.7.1-1.26.06-1.03-.8a16.85 16.85 0 0 0-9.33-14.28 16.6 16.6 0 0 0-7.32-1.7c-.09-.71-.05-1.28.8-1a17.71 17.71 0 0 1 16.88 17.78zm-17.68 17.8c-.09-.69-.05-1.26.8-1.03a16.7 16.7 0 0 0 15.87-16.77c.7-.1 1.26-.05.99.8a17.86 17.86 0 0 1-9.76 15.13 17.6 17.6 0 0 1-7.9 1.88zm-17.67-17.8c.7-.1 1.26-.06 1.03.8a16.85 16.85 0 0 0 9.33 14.28 16.6 16.6 0 0 0 7.31 1.7c.1.71.06 1.28-.8 1a17.71 17.71 0 0 1-14.96-9.74 17.92 17.92 0 0 1-1.9-8.04zm17.67-17.8c.1.69.06 1.26-.8 1.03a16.7 16.7 0 0 0-15.86 16.77c-.7.1-1.26.05-.99-.8a17.86 17.86 0 0 1 9.77-15.13 17.6 17.6 0 0 1 7.89-1.88z'/%3e%3cpath fill='%23edb92e' d='M498.96 118.85a17.57 17.57 0 0 1 .18 5.96c-5.64-.2-11.3-.33-17-.33-5.69 0-11.34.14-16.99.33a17.47 17.47 0 0 1 .18-5.96c5.59-.2 11.19-.32 16.82-.32 5.63 0 11.23.13 16.8.32z'/%3e%3cpath fill='%2321231e' d='M499.82 122.37c-.3-.11-1.06.24-1.01-.22a16.92 16.92 0 0 0-.34-3.2c.31.06 1-.45 1.03.02.22 1.12.32 2.26.32 3.4zm-.7 2.96c-.07-.26.25-1.31-.18-.83-.4.47-.27 0-.23-.34.06-.6.1-1.2.1-1.8.28.1.98-.2 1 .17 0 .79-.06 1.58-.17 2.36l-.52.44zm.52-.44c.26.58-.9.57-.24.2l.24-.2zm-17.5.1c.12-.32-.26-1.13.3-1.01 5.57 0 11.15.13 16.72.33-.12.32.23 1.15-.33 1-5.56-.19-11.12-.3-16.68-.31zm-17.49-.1c.24-.12 1.33.01.78-.33-.66-.39.28-.22.6-.28 5.36-.18 10.74-.3 16.12-.3-.11.33.26 1.14-.3 1.02-5.56 0-11.12.13-16.68.33l-.52-.44zm.52.44c-.53.36-.71-.8-.24-.2l.24.2zm-.7-2.96c.3.1.97-.2 1.01.15 0 .75.07 1.5.17 2.23-.3-.06-.95.34-1.02-.01-.1-.79-.16-1.58-.16-2.37zm.85-4.02c.1.25-.17 1.3.25.83.43-.5.13.23.12.5-.14.9-.2 1.8-.2 2.69-.3-.11-1.09.25-1.02-.23.02-1.14.14-2.27.37-3.39l.48-.4zm-.48.4c-.06-.61.83-.43.1-.08l-.06.05-.04.03zm17.3-.73c-.1.33.27 1.14-.28 1.02-5.5 0-11 .13-16.51.32.1-.33-.3-1.13.25-1.03 5.52-.18 11.03-.3 16.55-.3zm17.32.73c-.24.14-1.32.06-.78.4.61.38-.42.14-.7.18-5.27-.17-10.55-.28-15.83-.28.1-.33-.27-1.14.29-1.02 5.51 0 11.02.13 16.54.32l.48.4zm-.48-.4c.6-.16.56.75.1.08l-.06-.05-.04-.03z'/%3e%3cpath fill='%23edb92e' d='M468.82 133.18c-3.63-2.26-4.27 1.24-4.18 4.75.35 13.23 2.87 25.83-.67 42.03-1.42 6.49-3.7 10.13-1.48 11.38 5.67 3.19 8.27 6.1 7.37 7.67 1.68 3.22 5.86 2.6 12.28 1.57 6.42 1.03 10.6 1.65 12.28-1.57-.9-1.57 1.7-4.48 7.37-7.67 2.22-1.25-.06-4.9-1.48-11.38-3.53-16.2-1.01-28.8-.67-42.03.1-3.51-.54-7-4.18-4.75-7.15 4.45-19.4 4.5-26.64 0z'/%3e%3cpath fill='%2321231e' d='M465.15 137.91c-1.13.4-1.1-.46-1-1.31.07-1.72.33-4.28 2.42-4.64.9-.08 1.76.32 2.52.78-.32 1.37-1.14.39-2.03.25-1.57-.13-1.75 1.9-1.87 3.04-.05.62-.05 1.25-.04 1.88zm-.69 42.15c-1.49.15-.72-1.14-.61-2.03 2.1-10.35 1.56-20.98.74-31.43-.2-2.89-.37-5.77-.45-8.66 1.43-.52.96.97 1.08 1.86.53 11.15 1.97 22.38.41 33.52a80.3 80.3 0 0 1-1.17 6.74zm-1.72 10.83c-.24 1.4-1.28.55-1.53-.35-.48-2.41.79-4.73 1.32-7.03.36-1.21.68-2.43.95-3.66 1.47-.15.74 1.1.56 1.98-.57 2.7-1.88 5.27-1.95 8.05.04.42.26.82.65 1.01zm7.57 7.88c-1.23.98-.69-.15-.89-.99-1.39-2.62-4.14-4.13-6.58-5.66-1.23-.4.16-1.83.85-.68 2.5 1.6 5.32 3.21 6.67 5.97.43.4-.05 2.49-.05 1.36zm-.9.47zm12.81.83c.16 1.34-.52 1.05-1.66 1.27-3.07.37-6.43 1.22-9.35-.21a4.5 4.5 0 0 1-1.8-1.89c.97-1.01 1.2.28 1.96.78 2.4 1.47 5.38.74 8.02.46.95-.12 1.89-.32 2.83-.41zm-.16 0zm11.93-.8c1.11-1.07 1.03.22.3.85-2.02 2.3-5.42 1.85-8.14 1.56-1.37-.17-2.73-.39-4.09-.6-.23-1.44 1.02-.84 1.9-.74 2.84.33 5.94 1.16 8.65-.12.66-.04 1.45-2 1.38-.96zm.87-.52zm6.69-7.86c1.05.98-.27 1.28-1 1.77-2.15 1.43-4.63 2.84-5.73 5.28.35.74-.93 1.9-1.04.73-.13-2.2 1.92-3.68 3.43-4.96a35.82 35.82 0 0 1 4.34-2.82zm-1.73-10.83c1.26-.74 1.14.67 1.4 1.52.6 2.82 2.01 5.5 1.98 8.43.02.64-.95 2.32-1.4 1.34-.57-.64.8-1.16.4-2.05-.46-3.15-1.79-6.1-2.38-9.24zm-.68-42.15c1.46-.44.9 1.03.94 1.92-.51 11.05-1.96 22.17-.44 33.2.29 2.29.69 4.56 1.17 6.82-1.3.76-1.13-.76-1.36-1.63-2.13-10.43-1.58-21.15-.76-31.7.2-2.86.37-5.74.45-8.61zm-3.4-4.3c-1-.84-.04-1.27.8-1.51 1.62-.68 3.15.76 3.34 2.32.26 1.15.3 2.34.27 3.52-1.45.43-.9-1.02-1.05-1.91-.13-1.14-.28-3.12-1.83-3.05a4.1 4.1 0 0 0-1.54.63zm-27.18 0c.35-1.48 1.34-.28 2.2.04 6.28 2.87 13.66 3.06 20.21 1.02 1.48-.48 2.9-1.11 4.23-1.93 1.07.9-.13 1.27-.9 1.67-6.57 3.13-14.35 3.38-21.25 1.25a20.93 20.93 0 0 1-4.5-2.05z'/%3e%3cg id='a'%3e%3cpath d='M363.03 212.12c-1.9-4.14-.37-9.93.25-11.23.32-.67-.61-2.12-1.02-2.7-12.9-18.27-13.12-19.9-4.23-26.75 8.03-6.18 26.16-12.19 39.14-16.23 2.7-2.06 4.42-4.87 6.87-7.18-24.93 1.8-51.94 11.92-65.57 23.76-7.2 6.25 1.56 18.89 12.28 38.1 6.63 4.79 9.74 7.01 12.28 2.23z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M362.83 200.67c1.42.16.52 1.2.38 2.07-.71 2.99-.97 6.29.28 9.17-1.16 1.09-1.29-.63-1.55-1.47-.67-3.22-.28-6.71.89-9.77zm-.98-2.17c.7-.98 1.16-.3 1.5.48.32.64.7 1.41.4 2.13-.67-.18-1.02-.45-1.05-1.12a7.78 7.78 0 0 0-.85-1.5zm-4.12-27.46c1.4 1-.63 1.53-1.24 2.28-2.2 1.75-4.73 4.22-3.98 7.33 1.16 4.64 4.24 8.48 6.8 12.43 1.11 1.62 2.24 3.22 3.37 4.83-1.05 1.37-1.52-.73-2.22-1.4-3.14-4.7-6.79-9.22-8.68-14.6-1.06-2.8.08-5.9 2.28-7.78 1.14-1.12 2.4-2.1 3.67-3.09zm39.13-16.23c1.5 1.18-.9 1.14-1.7 1.57-11.1 3.59-22.32 7.14-32.6 12.73a37.37 37.37 0 0 0-4.22 2.74c-1.36-.96.51-1.47 1.2-2.09 8.35-5.23 17.76-8.43 27.01-11.66a498.7 498.7 0 0 1 10.47-3.37l-.16.08zm.61.81zm6.61-7.07c-.28-2.03.76.33-.56.73-2 2.12-3.7 4.56-6.05 6.34-1.3-.9.35-1.4.92-2.14 1.87-1.84 3.39-4.02 5.31-5.82l.38.89zm-.07-1.02c2.15-.96.72 1.46.15.34l-.08-.18-.07-.16zm-65.2 24.65c-1.49-.95.64-1.63 1.28-2.37 10.32-7.95 22.54-13.06 34.92-16.84a137.29 137.29 0 0 1 29-5.44c.63 1.65-1.5.92-2.46 1.23a137.37 137.37 0 0 0-48.52 14.05 74.54 74.54 0 0 0-14.23 9.37zm12.24 37.3c-.69 1.77-1.22-.42-1.74-1.11-4.35-7.96-9.37-15.61-12.62-24.1-1.4-3.8-2.35-8.66.59-11.99.57-1.53 2.25-.12.8.61-2.76 3.12-1.68 7.65-.39 11.17 3.3 8.5 8.34 16.17 12.7 24.14.04.16 1.08 1.8.66 1.28zm-.6.83zm12.58 1.3c.03 1.33.67.76-.45 2.14-1.35 1.98-4.08 1.8-5.93.67-2.2-1.16-4.17-2.68-6.2-4.11.55-1.63 1.65.16 2.53.56 2.17 1.38 4.32 3.42 7.04 3.38 1.55-.14 1.96-1.88 3.01-2.64zm-.45.27zm.45.75zm.46-.72z'/%3e%3cpath d='M359.11 213.58a33.86 33.86 0 0 1-1.25-4.72c-.54-2.7-.3-5.52.6-8.15-2.98-4.21-6.32-8.78-8.73-13.33-1.72-3.24-3.04-6.86-2.03-10.56 1.08-3.94 4.5-6.63 7.58-9 3.7-2.85 8.62-5.35 13.61-7.47 11.17-4.64 20.05-6.9 26.56-7.11l-4.13 3.83c-12.11 3.92-26.4 9.09-33.28 14.38-8.9 6.85-8.68 8.47 4.23 26.76.4.57 1.33 2.02 1.02 2.68-.62 1.31-1.76 7.34.13 11.49-1.11 2.1-2.73 1-4.31 1.2z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M357.37 208.96c1.2-.7 1.12.5 1.32 1.35.25 1.05.55 2.08.9 3.1-.77.51-1.16.24-1.26-.6-.4-1.26-.72-2.58-.96-3.85zm1-.2zm-.33-7.76c1.08-1.17.92.16.56 1-.59 2.2-.69 4.52-.24 6.76-1.18.67-1.15-.51-1.22-1.39-.22-2.3.09-4.64.84-6.83l.06.46zm.83-.59zm-9.58-12.79c.88-.9 1.2.01 1.59.79 2.37 4.18 5.22 8.08 7.99 12-.76 1.02-1.2.13-1.67-.6-2.8-3.95-5.63-7.9-7.91-12.19zm-2.08-10.93c1.2-.04.9.75.72 1.58-.39 3.12.81 6.16 2.25 8.87-.86.89-1.2.03-1.52-.77-1.44-2.97-2.37-6.41-1.45-9.68zm7.76-9.28c1.04.73.16 1.2-.55 1.7-2.62 2.08-5.31 4.5-6.24 7.85-1.34.06-.8-.97-.44-1.77 1.49-3.31 4.43-5.62 7.23-7.78zm13.73-7.54c.86 1-.17 1.21-.98 1.54-4.24 1.89-8.43 3.99-12.13 6.8-1.2-.83.13-1.33.84-1.87a71.08 71.08 0 0 1 12.27-6.47zm0 0zm27.1-6.26c-1.33-1.57.38.52-1.1.17-8.9.63-17.4 3.71-25.62 7.04-.93-1.1.44-1.25 1.25-1.61 8.05-3.16 16.4-6.06 25.1-6.48l.37.88zm-.36-.88c1.59-.45 1.23.54.3.73l-.3-.73zm-4.46 3.97l4.13-3.84c1.31.75-.09 1.38-.7 2.05-1 .87-1.9 1.84-2.93 2.65l-.5-.86zm.69.75zm-33.32 14.4c-1.17-.8.06-1.3.78-1.81 7.13-4.63 15.18-7.56 23.13-10.45 2.96-1.04 5.93-2.04 8.9-3 .87 1.2-.59 1.2-1.42 1.54-9.46 3.17-19 6.39-27.72 11.3-1.26.74-2.5 1.53-3.67 2.43zm4.33 26.06c-.86 1.2-1.29-.13-1.83-.84-3.13-4.63-6.65-9.12-8.8-14.33-1.05-2.44-.88-5.45.97-7.47 1.35-1.63 3.05-2.92 4.71-4.22 1.2.83-.14 1.33-.8 1.92-2.15 1.76-4.84 3.95-4.5 7.05.56 3.8 2.95 6.98 4.93 10.16 1.72 2.61 3.52 5.17 5.32 7.73zm1.07 3.2c-.57-.21-1.04-.37-1.01-1.03a7.45 7.45 0 0 0-.88-1.58c.65-.85 1.12-.43 1.44.38.34.67.76 1.48.45 2.23zm.12 11.5c-1.12-.67-.96.26-1.38-1.3-.95-3.46-.81-7.25.34-10.64 1.22.16.72.98.51 1.8-.69 3.25-.67 6.74.54 9.85V212.62zm.02-.45zm-4.78.9c.26 1.87-.58-.07.44-.02 1.19.06 2.86.56 3.43-.9 1.14.2.81.97.1 1.5-1.11.97-2.62.34-3.9.44l-.07-1.01zm0 1.03c-.43-1.42.94-.87 0 0zm.48-.68z'/%3e%3cpath d='M468.14 132.2c.11-2.32-.04-1.92-.39 1.65-.37-.72-.86-1.05-1.45-1.03-1.05.01-1.68 1.61-1.79 5.22l.2 2.76c-33.07-.74-52.67 4.28-57.72 13.92-4.16 7.93 2.91 21.06 13.58 36.05 1.3 1.82 1.25 1.66 0 3.16-1.8 2.16-3.75 5.82-2.29 9.04-6.46 3.56-14.16 4.43-20.87 1.48-1.11-2.96-3.53-4.37-5.49-5.71-.4-.28-1.83-.98-1.98-1.44-3.52-11.35-7.06-21.85-10.1-31.62-9.54-30.68 75.24-33.5 88.3-33.48z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M467.31 134.09c1.79-.7-.88.09.1-1.72.1-.7-.02-2.45 1.08-1.93.62.77-.01 2.58-.84 1.53-.18-1.4.15-.73.96-.99-.3.93 0 2.34-.58 2.97l-.72.14zm.95-.19c.63 2.82-1.74.42-.25.05l.23-.04h.02zm-1.95-.57c-.33-.92.17-1.28.9-.8.53.3 1.51 1.23.37 1.42-.43.36-.62-.8-1.27-.62zm0 0zm-1.28 4.68c-1.6.63-.84-1.2-.87-2.08.2-1.36.44-3.43 2.13-3.62.35.91-.3 1.03-.65 1.69-.51 1.23-.56 2.85-.61 4zm-1.01.06zm.68 3.24c.38-1.77-.75.25-.55-1.33.11-.71-.65-2.2.57-1.95.65.02.24 1.25.43 1.8.05.62.2 1.07-.45 1.48zm.51-.54zm-57.77 14.2c-1.86-.47.38-2.14.87-3.04 5.18-5.62 12.95-7.71 20.18-9.27 11.92-2.32 24.12-2.59 36.23-2.37.41 1.9-2.2.64-3.31.97-13.43-.03-27.1.35-40.05 4.27-5.32 1.76-11.07 4.3-13.92 9.43zM421 190.47c-1.23 1.47-1.76-1.29-2.62-1.97-5.12-7.61-10.47-15.44-12.64-24.48-.68-3.15-.71-6.62.82-9.55 1.77.4-.19 2.02-.03 3.19-.97 6.4 2.12 12.5 4.98 18 2.82 5.15 6.1 10.03 9.49 14.81zm-.02 3.78c-1.33-.52-.22-1.07.05-1.83-.33-.8-1.36-1.51-.03-1.95.83.89 1.57 2.34.4 3.29-.15.16-.29.33-.42.5zm-2.44 9.16c-.6-1.17-1.05-.04-1.22-2.14-.27-2.84 1.13-5.54 2.88-7.68 1.44.57.02 1.39-.35 2.22-1.27 2.01-2.13 4.64-1.09 6.94l-.22.66zm.22-.66zm-21.8 1.88c1.03-1 1.51-.12 3.17.26 5.98 1.74 12.54.62 17.93-2.38 1.3 1.45-1.6 1.65-2.48 2.3-5.82 2.38-12.81 2.78-18.52-.07l-.1-.11zm.27.28zm-5.57-5.75c.48-1.62 1.63.05 2.49.48a10.14 10.14 0 0 1 3.75 4.63c-1.16.96-1.2-.6-1.79-1.27-1.11-1.66-2.83-2.75-4.45-3.84zm-2.18-1.71c.74-.55 1.14-.24 1.72.25.79.32 1.38.82.42 1.44-.73-.5-1.74-.84-2.14-1.7zm-10.1-31.62c1.54-1 1.24 1.55 1.82 2.44 3.04 9.63 6.25 19.22 9.24 28.87-1.62 1-1.28-1.79-1.9-2.71-3-9.55-6.19-19.04-9.17-28.6zm88.27-33.66c2.32.15-.97.8-1.86.56-18.49.47-37.05 2.06-55.08 6.32-8.9 2.29-18.1 5.02-25.34 10.94-3.7 3.04-6.31 7.75-5.64 12.64.1 1.03 1.21 3.66-.4 2.97a14.3 14.3 0 0 1 2.82-13.75c5.03-5.87 12.48-8.89 19.64-11.33 16.13-5.13 33.09-7.03 49.91-8.22 5.48-.34 10.97-.6 16.46-.61l-.5.48zm1.01.05zm-.5-.02zm.5.02z'/%3e%3cpath d='M404.99 190.16a6.4 6.4 0 0 1 6.37 6.41c0 3.55-2.85 6.42-6.37 6.42s-6.37-2.87-6.37-6.42a6.4 6.4 0 0 1 6.37-6.41z' fill='white'/%3e%3cpath d='M411.87 196.57h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zM405 203.5v-1.02a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.9 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.93h1.02a5.93 5.93 0 0 0 5.86 5.9v1.03a6.88 6.88 0 0 1-6.88-6.93zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.03z' fill='%2321231e'/%3e%3cpath d='M350.75 203.61a5.93 5.93 0 0 1 5.91 5.96c0 3.29-2.65 5.95-5.91 5.95a5.94 5.94 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z' fill='white'/%3e%3cpath d='M357.17 209.56h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.43 6.43 0 0 1 6.41 6.47zm-6.42 6.47V215a5.42 5.42 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-6.42 6.47zm-6.42-6.47h1.01a5.47 5.47 0 0 0 5.41 5.45v1.02a6.43 6.43 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.42 5.42 0 0 0-5.4 5.45h-1.02a6.4 6.4 0 0 1 6.42-6.47z' fill='%2321231e'/%3e%3cpath d='M345.1 192.72a5.94 5.94 0 0 1 5.91 5.96 5.94 5.94 0 0 1-5.91 5.95 5.93 5.93 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z' fill='white'/%3e%3cpath d='M351.52 198.68h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.43 6.43 0 0 1 6.41 6.47zm-6.42 6.47v-1.02a5.42 5.42 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-3.04 5.5 6.4 6.4 0 0 1-3.38.97zm-6.42-6.47h1.02a5.47 5.47 0 0 0 5.4 5.45v1.02a6.42 6.42 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.41 5.41 0 0 0-5.4 5.45h-1.02a6.42 6.42 0 0 1 6.42-6.47z' fill='%2321231e'/%3e%3cpath d='M339.79 181.71a5.93 5.93 0 0 1 5.91 5.96 5.93 5.93 0 0 1-5.91 5.95 5.94 5.94 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z' fill='white'/%3e%3cpath d='M346.21 187.66h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.42 6.42 0 0 1 6.41 6.47zm-6.42 6.47v-1.02a5.41 5.41 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-3.01 5.48 6.4 6.4 0 0 1-3.4.99zm-6.42-6.47h1.02a5.47 5.47 0 0 0 5.4 5.45v1.02a6.43 6.43 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.42 5.42 0 0 0-5.4 5.45h-1.02a6.5 6.5 0 0 1 6.42-6.47z' fill='%2321231e'/%3e%3cpath d='M444.27 202.15c3.42-.23 2.57 5.9 1.9 7.26-.88 1.78-1.7 1.84-2.81.19-.85-1.26-2.5-7.22.91-7.45z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M446.62 209.63l-.9-.45c.32-.78.44-1.63.52-2.46a6.72 6.72 0 0 0-.35-3.08c-.2-.46-.58-.88-1.1-.96a2.1 2.1 0 0 0-.48-.03l-.07-1.01c.64-.05 1.32.12 1.81.55.71.6 1.02 1.54 1.15 2.44.18 1.32.06 2.67-.24 3.97-.08.35-.19.7-.34 1.03zm-3.68.25l.84-.57c.25.35.5.74.9.94.26.1.45-.17.6-.34.17-.23.3-.48.44-.73l.9.45c-.31.61-.68 1.28-1.34 1.57-.52.23-1.12.02-1.52-.35a4.97 4.97 0 0 1-.82-.97zm1.3-8.25l.07 1.02c-.5.03-.99.26-1.23.7-.38.66-.4 1.47-.35 2.22.1 1.15.37 2.3.84 3.36l.2.38-.83.57a8.71 8.71 0 0 1-.95-2.51 8.16 8.16 0 0 1-.16-3.58c.17-.76.6-1.5 1.32-1.86.33-.18.71-.26 1.09-.3z'/%3e%3cpath d='M444.49 205.46c8.03-.55 6.04 13.85 4.46 17.05-2.07 4.2-4 4.32-6.6.45-2-2.96-5.89-16.95 2.14-17.5z' fill='white'/%3e%3cpath fill='%2321231e' d='M449.4 222.74l-.9-.45c.74-1.73 1.03-3.61 1.25-5.46.23-2.54.24-5.19-.62-7.62-.47-1.31-1.37-2.58-2.75-3.03-.6-.2-1.23-.24-1.86-.21l-.07-1.02c1.36-.1 2.78.25 3.81 1.15 1.5 1.3 2.13 3.29 2.42 5.19.43 3.03.17 6.14-.5 9.12-.2.8-.43 1.59-.78 2.33zm-7.47.5l.84-.56c.67.94 1.37 1.97 2.45 2.47.74.33 1.5-.2 1.96-.75.54-.64.94-1.37 1.32-2.11l.9.45c-.64 1.23-1.35 2.57-2.6 3.26-.94.53-2.1.2-2.88-.45a10.3 10.3 0 0 1-1.99-2.3zm2.56-17.27v-1.02l.03 1.02c-1.23.07-2.49.6-3.2 1.66-1.04 1.48-1.2 3.37-1.18 5.13.1 2.89.78 5.75 1.86 8.42.22.51.46 1.02.77 1.5l-.84.57a19.76 19.76 0 0 1-2.1-5.53c-.62-2.64-.99-5.43-.43-8.13.35-1.62 1.23-3.23 2.75-4.01.7-.39 1.5-.56 2.3-.63l.04 1.02zm0-1.02v1.02l-.04-1.02h.04z'/%3e%3cpath d='M379.74 210.81c3.26-1.05 3.9 5.1 3.56 6.6-.43 1.94-1.21 2.19-2.68.85-1.13-1.02-4.14-6.4-.88-7.45z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M383.79 217.51l-.99-.22c.13-.77.06-1.56-.04-2.33-.16-1.01-.4-2.04-.96-2.9-.3-.47-.8-.9-1.38-.86a2 2 0 0 0-.53.09l-.3-.97c.6-.2 1.29-.2 1.87.09.83.4 1.35 1.23 1.7 2.06.5 1.27.7 2.64.72 4 0 .35-.02.7-.09 1.04zm-3.51 1.13l.67-.76c.34.28.69.62 1.13.7.26.01.38-.28.47-.47.12-.26.19-.54.25-.82l.99.22c-.16.67-.36 1.4-.93 1.85-.45.34-1.07.29-1.54.03-.39-.2-.72-.47-1.04-.75zm-.7-8.32l.31.97c-.48.14-.9.5-1.03 1a4.1 4.1 0 0 0 .22 2.3c.37 1.07.9 2.1 1.6 2.99l.27.3-.67.76a8.77 8.77 0 0 1-1.53-2.24 8.18 8.18 0 0 1-.99-3.38c-.02-.8.23-1.63.84-2.15.28-.26.63-.43.98-.55z'/%3e%3cpath d='M380.74 213.97c7.67-2.46 9.14 12 8.36 15.5-1.02 4.56-2.85 5.14-6.3 2.01-2.64-2.4-9.73-15.05-2.06-17.51z' fill='white'/%3e%3cpath fill='%2321231e' d='M389.6 229.58l-.99-.22c.32-1.86.16-3.75-.07-5.6-.38-2.53-1-5.1-2.4-7.25-.79-1.2-2.04-2.25-3.53-2.3a5.16 5.16 0 0 0-1.71.25l-.3-.97a5.23 5.23 0 0 1 3.97.2c1.77.92 2.86 2.72 3.59 4.5 1.12 2.84 1.59 5.9 1.64 8.94 0 .82-.03 1.65-.2 2.45zm-7.14 2.29l.68-.76c.87.76 1.8 1.59 2.97 1.81.8.15 1.41-.54 1.72-1.2.38-.74.6-1.55.78-2.36l.99.22c-.33 1.35-.7 2.82-1.76 3.8-.78.73-1.99.7-2.9.24a10.26 10.26 0 0 1-2.48-1.75zm-1.87-18.38l.3.97a4.15 4.15 0 0 0-2.74 2.43c-.66 1.78-.32 3.73.18 5.5.8 2.7 2.11 5.26 3.78 7.53.31.42.65.83 1.03 1.2l-.68.75a19.73 19.73 0 0 1-3.34-4.86c-1.23-2.43-2.25-5.05-2.34-7.8-.05-1.66.43-3.44 1.72-4.56a5.9 5.9 0 0 1 2.09-1.16zm.15.49c-.11-.37-.2-.64-.03-.12l.03.12z'/%3e%3cpath d='M464.2 137.77c-17.23-1.57-34.85.2-52.3 7.17-14.7 5.88-13.26 23.06 4.67 46.9-1.62 3.01-2.55 6.77-2.7 11.1 1.9-.1 3.23-.05 4.9-.1-1.3-2.88.16-6.42 1.8-8.91 1.07-1.63 1.3-1.34 0-3.16-10.67-15-17.74-28.12-13.58-36.05 5.05-9.64 24.66-14.66 57.71-13.92l-.18-2.67-.32-.36z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M412.09 145.42c-1.04-1.31.96-1.3 1.79-1.78 15.99-6.06 33.39-7.97 50.37-6.37.35 1.66-1.47.72-2.44.82-16.86-1.28-34 1-49.72 7.33zm4.93 46.66c-1.2-.55-.95.17-1.95-1.42-5.67-7.88-11.01-16.38-13.12-25.97-1.2-5.52-.66-11.96 3.52-16.15a17.8 17.8 0 0 1 6.25-4.07c1.05 1.32-.99 1.31-1.75 1.95a13.8 13.8 0 0 0-7.52 11.77c-.35 7.5 2.87 14.6 6.4 21.04 2.4 4.3 5.18 8.36 8.12 12.3l.05.55zm-.05-.55zm-3.12 10.9c.37 1.81-.87.28-.42-.69a25.1 25.1 0 0 1 2.7-10.15c1.56.3.21 1.47 0 2.39a26.6 26.6 0 0 0-1.75 8.98l-.53-.52zm.06 1.02zm4.4-.4c1.66-.99.34.84-.73.32-1.23 0-2.45 0-3.67.08-.57-1.5 1.14-.96 2.06-1.09.93 0 1.86 0 2.8-.02l-.45.72zm.93-.41zm.91-8.99c1.45.4.23 1.34-.1 2.18-1.04 2.06-1.78 4.58-.8 6.8-1.2 1.1-1.33-.7-1.45-1.59-.2-2.65.95-5.21 2.35-7.39zm.01-2.58c.8-1.12 1.33.02 1.7.8.4.9-.44 1.64-.86 2.34-1.24-.36-.51-1.04-.06-1.76.01-.51-.57-.95-.78-1.38zm-13.62-36.59c1.58.29.2 1.5.13 2.48-1.25 5.38.99 10.79 3.22 15.6 3.1 6.32 7.04 12.18 11.1 17.92-1 1.33-1.47-.58-2.14-1.27-5-7.32-10.09-14.84-12.7-23.41-1.02-3.67-1.43-7.82.4-11.32zm57.66-13.65c1.96-.31-.03.92-.98.45-13-.14-26.16.19-38.83 3.36-5.86 1.62-12.12 3.82-15.98 8.79-.28.96-1.7 2.15-1.68.73 3.17-5.4 9.3-8.01 15.01-9.83 12.14-3.54 24.9-4.05 37.48-4.1 1.83 0 3.66.03 5.5.06l-.52.54zm1.01-.07zm-1.07-2.29c.73-1.05 1.02-.34.95.55-.07.55.33 1.5-.06 1.76-.99.42-.88-.43-.9-1.1 0-.37-.18-1.55-.04-1.34l.05.13zm.76-.67zm-1.06-.39c.67 1.07.67.25.83.13.55.32-.37.8-.58.88-.22-.15-.38-.54-.25-1zm0 .71zm.72.01zm-.31-.86z'/%3e%3cpath d='M380.59 142.66c3.4 0 6.14 2.77 6.14 6.19s-2.75 6.18-6.14 6.18-6.14-2.77-6.14-6.18 2.75-6.19 6.14-6.19z' fill='white'/%3e%3cpath d='M387.24 148.84h-1.01a5.7 5.7 0 0 0-5.64-5.67v-1.02a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.12-5.67 6.6 6.6 0 0 1 3.52-1.03z' fill='%2321231e'/%3e%3cpath d='M392.62 138.7c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='white'/%3e%3cpath d='M399.27 144.88h-1.01a5.7 5.7 0 0 0-5.64-5.67v-1.02a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.73 6.73 0 0 1-3.15 5.7c-1.04.65-2.27 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.18-5.71 6.62 6.62 0 0 1 3.46-.99z' fill='%2321231e'/%3e%3cpath d='M394.22 143.97c.6.82 1.22 1.64 1.84 2.46-9.7 5.36-13.72 11.01-12.77 16.7.16.97 3.1 11.38 9.7 31.55 4.5 3.13 7.86 5.93 10.07 8.4-.25.3.7 1.17.42 1.4.68 3.09-2.77 2.46-5.09 1.7-1.11-2.96-4.51-6.1-6.47-7.44-.4-.28-1.83-.98-1.98-1.44-3.52-11.35-7.07-21.85-10.1-31.62-3.06-9.82 3.56-16.78 14.38-21.71z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M396.31 146.88c-.46-1.35-.47-.23-.82-.37l-1.67-2.23c.6-.76 1.06-.54 1.44.24.36.59 1 1.11 1.18 1.74l-.13.62zm.16-.76zm-12.68 16.93c-.94.45-1.2-.06-1.12-.95-.28-4.56 2.7-8.52 6.03-11.3a43.31 43.31 0 0 1 7.12-4.81c.9.86.03 1.2-.75 1.6-4.2 2.52-8.53 5.56-10.61 10.17a9.43 9.43 0 0 0-.67 5.3zm0 0zm9.5 31.22c-.5 1.28-.95.47-1.12-.47-3.23-10.05-6.52-20.07-9.3-30.25-.19-.7 1.39-.67 1.1.25 2.88 10.33 6.2 20.53 9.5 30.73l-.19-.26zm-.58.84zm10.73 8.33c-.92-1.32-.53.43-1.17-.46-2.85-3-6.18-5.5-9.56-7.87.37-1.2 1.06-.58 1.74-.02 3.2 2.3 6.34 4.74 9 7.67v.68zm0-.68zm.54 1.63c-.9.63-.96-.46-.94.02-.24-.5-.8-1.1-.35-1.65.36.56.8.47.92.6.28.43.7 1.09.2 1.53l.17-.5zm-.98.22zm-5.07 1.76c1.28-.14.26-.95 1.42-.43 1.12.23 2.57.76 3.55-.07.38-.65-.23-1.56.9-1.44.49.17.28 1.35.04 1.84-1 1.55-3.16 1.05-4.66.68-.44-.14-.96-.17-1.25-.58zm.31.3zm-6.6-7.5c.34-1.13.98-.72 1.61-.07 2.29 1.9 4.48 4.12 5.62 6.91-.83.62-1.15.13-1.42-.67a20.37 20.37 0 0 0-5.8-6.17zm.57-.85zm-2.74-.86c.5-.07.95-.59 1.29-.03.46.33.98.58 1.45.9-.3.63-.63 1.06-1.22.45-.55-.36-1.26-.68-1.52-1.32zm-10.1-31.62c1.05-.74 1.18.29 1.4 1.14 3.17 10.08 6.54 20.09 9.66 30.17-1 .7-1.18-.16-1.38-1.02-3.15-10.12-6.53-20.17-9.69-30.29zm15.26-22.17c-1.47.64.43.73-.94 1.12-5 2.42-10.12 5.56-12.76 10.65-1.6 3.1-1.66 6.81-.6 10.1-1 .7-1.2-.17-1.32-1.04a14.11 14.11 0 0 1 2.92-12.46c3.18-3.87 7.6-6.45 12.09-8.53l.61.16zm-.61-.16z'/%3e%3cpath d='M355.95 216.87l-.37 1.98c-2.82.66-5.24.82-7.24.5 3.35-3.3 5.85-4 7.61-2.48z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M355.08 218.76l.37-1.98 1 .19-.38 1.98-.38.4-.61-.59zm1 .19c-.05.1-.01.28-.1.34-.08 0-.37.12-.23 0l.32-.34zm-8.1.03l.7.73-.27-.86c2.09.33 4.22.1 6.28-.32l.77-.17.23.99c-2.21.51-4.5.83-6.78.59a12.2 12.2 0 0 1-.66-.09l-.27-.87zm.27.87l-.99-.16.72-.7.27.86zm8.2-2.88l-1-.19.16.48a2.52 2.52 0 0 0-1.98-.63 6.23 6.23 0 0 0-2.77 1.23c-.78.55-1.5 1.19-2.18 1.85l-.7-.73a15 15 0 0 1 3.69-2.8c.97-.47 2.1-.76 3.18-.47.53.15 1.01.42 1.42.78l.17.48zm-.18-.48c.07.09.26.14.21.27-.02.16-.04.27-.1.05l-.1-.32zm-.33.38l.5.1-.5-.1zm.33-.38c.07.09.26.14.21.27-.02.16-.04.27-.1.05l-.1-.32z'/%3e%3cpath d='M355.64 212.34c1.77.4 1.93.7 2.7.83 1 .17 2.36.1 3.3-.73 3.84-2.32 3.93 1.86 2.43 4.99-1.08 2.26-.52 4.82.51 6.76 1.22 2.3.96 3.34.1 3.96l-1.68 1.1c-1.03 1.22-1.82 1.01-1.96-.6-3.84-1.59-5.1-5.29-6.25-8.55-1.68-4.76-7.77-5.9.85-7.76z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M358.43 212.66l-.17 1c-.83-.17-1.59-.6-2.43-.76-.43.03-.24-.32-.19-.6.03-.34.12-.57.48-.38.77.15 1.48.52 2.24.73l.07.01zm2.95-.66l.52.87c.1-.06-.39.32-.56.39-.94.5-2.05.58-3.08.4l.17-1c1.01.17 2.16.05 2.95-.66zm-.07.05zm3.22 5.59l-.91-.44c.56-1.26 1-2.66.78-4.05-.05-.49-.46-.99-1-.87a3.9 3.9 0 0 0-1.5.59l-.52-.87c.88-.52 2.02-1.04 3.02-.54.96.52 1.13 1.75 1.07 2.74a9.68 9.68 0 0 1-.94 3.44zm.5 6.3l-.9.49c-1.14-2.13-1.6-4.78-.6-7.05.08-.39.48.09.7.12.44.06.2.36.1.62-.7 1.92-.24 4.07.7 5.82zm-.08 4.63c-.19-.27-.37-.62-.57-.84.62-.38.6-1.2.4-1.8a8.2 8.2 0 0 0-.65-1.5l.9-.49c.54 1.08 1.14 2.32.76 3.54a2.2 2.2 0 0 1-.84 1.1zm.02-.01l-.02.01.02-.01zm-1.59 1l-.77-.65c.57-.43 1.2-.78 1.79-1.2l.55.86-1.68 1.1.11-.1zm-.77-.65zm-1.77.2l.39-.94c.19.24.36.48.36.8.05.18.07.44.25.54.33-.08.55-.37.77-.6l.77.65c-.46.56-1.19 1.2-1.96.89-.66-.31-.83-1.1-.9-1.76l.32.43zm.39-.94c.34-.07.4.7.16.23l-.16-.23zm-6.92-7.9l.95-.35c.86 2.43 1.74 5 3.68 6.8.67.61 1.45 1.1 2.29 1.45l-.39.95a9.53 9.53 0 0 1-4.76-4.55c-.74-1.37-1.26-2.84-1.77-4.3zm1.33-8.45v1.02c.19-.01-.5.12-.65.16-1.07.29-2.22.5-3.14 1.14-.42.24-.1.72.1.99 1.01 1.25 2.2 2.39 2.91 3.85.15.3.28.62.4.94l-.95.34c-.58-1.7-1.88-2.99-3.01-4.33-.48-.57-.93-1.41-.49-2.12.55-.83 1.58-1.1 2.46-1.4.78-.24 1.57-.44 2.37-.59zm-.1.01zm.1 1.01v-1.02c.24.08-.02.56.02.8l-.02.22zm0-1.02z'/%3e%3cpath d='M357.15 212.5c3.34 1.2 3.7-.67 5.96-.57-.89 5.14-1.78 7.8-7.11 5.04-2.94-1.52-6.7.7-7.42 2.36-.26.6-1.97-.65-2.6-2.02-2.6-5.76 6.7-6.42 11.17-4.81z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M363.61 212.02l-1-.18.48.6c-1.24-.1-2.23.83-3.43.94-.91.12-1.82-.1-2.68-.4l.34-.96c.99.37 2.12.56 3.12.1a5.65 5.65 0 0 1 2.7-.7l.47.6zm-.48-.6c.2.06.7-.11.54.23 0 .38-.1.4-.3.08l-.24-.3zm-7.36 6l.46-.9c1.1.54 2.29 1.12 3.55 1.04.9-.07 1.51-.87 1.82-1.65.54-1.3.76-2.7 1.01-4.07l1 .18c-.3 1.64-.55 3.35-1.35 4.84a3.05 3.05 0 0 1-2.54 1.72c-1.4.07-2.73-.54-3.95-1.15zm-6.72 2.12c-.3-.14-.62-.27-.93-.4a5.82 5.82 0 0 1 2.87-2.53 6.02 6.02 0 0 1 5.24-.09l-.46.9c-1.55-.8-3.43-.44-4.9.4-.71.42-1.44.95-1.82 1.72zm-3.52-2.02l.92-.42c.39.77 1 1.47 1.78 1.85.26 0-.36.2.04.25l.78.34c-.21.52-.89.55-1.32.3a5.15 5.15 0 0 1-2.2-2.32zm11.8-5.5l-.35.96c-2.09-.7-4.34-.86-6.53-.61-1.3.18-2.69.5-3.68 1.42-.71.62-.88 1.67-.6 2.54.07.27.18.51.28.77l-.92.42c-.49-1.07-.72-2.36-.2-3.47.64-1.3 2.02-2 3.35-2.37a15.83 15.83 0 0 1 8.64.34zm-.18.48c.07-.18.25-.7.09-.24l-.09.24z'/%3e%3cpath d='M458.84 124.49c3.38 0 6.11 2.76 6.11 6.16s-2.73 6.16-6.11 6.16c-3.38 0-6.11-2.76-6.11-6.16s2.73-6.16 6.11-6.16z' fill='white'/%3e%3cpath d='M465.46 130.64h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.62 6.62 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.61 5.61 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.03.65-2.25 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.63 6.63 0 0 1-6.62-6.67zm6.62-6.67V125a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 3.14-5.67c1.04-.65 2.26-1 3.48-1z' fill='%2321231e'/%3e%3cpath d='M446.31 124.49c3.38 0 6.11 2.76 6.11 6.16s-2.73 6.16-6.11 6.16-6.11-2.76-6.11-6.16 2.73-6.16 6.11-6.16z' fill='white'/%3e%3cpath d='M452.93 130.64h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.04.65-2.26 1-3.48 1zm-6.62-6.67h1.01a5.67 5.67 0 0 0 5.61 5.65v1.02a6.63 6.63 0 0 1-6.62-6.67zm6.62-6.67V125a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 3.14-5.67c1.04-.65 2.26-1 3.48-1z' fill='%2321231e'/%3e%3cpath d='M433.79 125.48a6.14 6.14 0 0 1 6.11 6.16c0 3.4-2.73 6.16-6.11 6.16s-6.11-2.76-6.11-6.16c0-3.4 2.73-6.16 6.11-6.16z' fill='white'/%3e%3cpath d='M440.41 131.63h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.04.65-2.26 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.62 6.62 0 0 1-6.62-6.67zm6.62-6.67v1.02a5.61 5.61 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 6.62-6.67z' fill='%2321231e'/%3e%3cpath d='M422.25 127.7a6.13 6.13 0 0 1 6.11 6.16c0 3.4-2.73 6.16-6.11 6.16a6.14 6.14 0 0 1-6.11-6.16c0-3.4 2.73-6.16 6.11-6.16z' fill='white'/%3e%3cpath d='M428.87 133.86h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.03.65-2.25 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.62 6.62 0 0 1-6.62-6.67zm6.62-6.67v1.02a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 6.62-6.67z' fill='%2321231e'/%3e%3cpath d='M346.3 159.43c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='white'/%3e%3cpath d='M352.94 165.62h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.12 5.67 6.6 6.6 0 0 1-3.53 1.03zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.67v1.02a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z' fill='%2321231e'/%3e%3cpath d='M356.82 152.75a6.16 6.16 0 0 1 6.14 6.19c0 3.41-2.75 6.18-6.14 6.18s-6.14-2.77-6.14-6.18 2.75-6.19 6.14-6.19z' fill='white'/%3e%3cpath d='M363.47 158.94h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.12 5.67 6.6 6.6 0 0 1-3.53 1.03zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.67v1.02a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.15-5.7 6.6 6.6 0 0 1 3.5-1z' fill='%2321231e'/%3e%3cpath d='M368.79 147.09c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='white'/%3e%3cpath d='M375.43 153.28h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7c-1.04.65-2.27 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.01a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z' fill='%2321231e'/%3e%3cpath d='M338.16 169.49c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z' fill='white'/%3e%3cpath d='M344.8 175.68h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.65 5.65 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.01a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7V170a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z' fill='%2321231e'/%3e%3cpath transform='matrix(1.01066 0 0 1.01824 -5.13 -6.2)' fill='%23edb92e' d='M409.61 280.14l21.77-12.6 23.15 9.85L432.76 290z'/%3e%3cpath d='M431.11 266.67l-22 12.83-.5-.88 22-12.83.45-.03.05.91zm-.5-.88l.21-.13.24.1-.46.03zm23.44 10.94l-23.4-10.03.4-.94 23.4 10.03.05.91-.45.03zm.4-.94l.93.4-.88.51-.05-.9zm-22.46 12.87l22-12.84.51.88-22 12.84-.45.03-.06-.91zm.5.88l-.21.13-.23-.1.45-.03zm-23.44-10.95l23.4 10.04-.4.94-23.4-10.04-.05-.91.45-.03zm-.4.94l-.93-.4.88-.51.06.9z' fill='%2321231e'/%3e%3cpath d='M431.13 270.65c5.64-.35 10.4 2.44 10.63 6.23.23 3.8-4.16 7.14-9.8 7.5-5.64.34-10.4-2.45-10.63-6.24-.23-3.79 4.16-7.14 9.8-7.49z' fill='%23c6363c'/%3e%3cpath fill='%2321231e' d='M442.26 276.85l-1.01.06c-.11-1.9-1.54-3.42-3.13-4.3a12.7 12.7 0 0 0-6.96-1.45l-.07-1.02c3.07-.17 6.33.48 8.78 2.43a6.07 6.07 0 0 1 2.39 4.28zm-10.27 8.03l-.06-1.02c2.8-.18 5.7-1.12 7.72-3.15.99-1 1.7-2.36 1.6-3.8l1.01-.06c.14 2.1-1.08 4.04-2.68 5.3a13.52 13.52 0 0 1-7.6 2.73zm-11.17-6.7l1.01-.07c.11 1.88 1.51 3.4 3.08 4.28 2.12 1.2 4.6 1.61 7.02 1.47l.06 1.02c-3.07.18-6.33-.48-8.78-2.43a6.07 6.07 0 0 1-2.39-4.28zm10.27-8.04l.07 1.02c-2.81.19-5.7 1.12-7.73 3.15-.99 1-1.7 2.37-1.6 3.8l-1 .06c-.15-2.11 1.1-4.07 2.71-5.33a13.54 13.54 0 0 1 7.55-2.7z'/%3e%3cpath d='M382.38 269.85l23.78 9.07-19.63 13.23c-5.09-1.7-9.12-19.12-4.15-22.3z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M405.98 279.4l-23.78-9.07c.22-.27.15-1.17.63-.85l23.5 8.97c0 .4.35 1.08-.32.95h-.03zm.36-.95c.26.18 1.3.26.61.55-.49.5-.6.21-.6-.37l-.01-.18zm-20.09 13.27l19.63-13.22c.09.33.85.8.32 1l-19.39 13.07c-.62.3-.46-.41-.55-.8l-.01-.05zm.56.85zm-4.25-23.2c0 .3-.67 1.1-.07.93.31-.01-.56.46-.63.74-1.18 1.74-1.25 3.94-1.23 5.97a27.45 27.45 0 0 0 2.89 11.2c.76 1.36 1.66 2.84 3.17 3.45-.2.27-.11 1.2-.59.86-1.77-.82-2.84-2.6-3.7-4.28a28.55 28.55 0 0 1-2.78-11.48c-.02-2.24.17-4.7 1.6-6.53.37-.38.75-.9 1.34-.86zm-.45.05c.4-.26.55.06 0 0zm.27.43zm-.27-.43c.4-.26.55.06 0 0z'/%3e%3cpath d='M382.83 274.26c5.62-.58 10.49 2.02 10.87 5.8.38 3.77-3.87 7.3-9.49 7.88-3.65.37-5.92-2.85-6.32-6.26-.4-3.42 1.09-7.02 4.94-7.42z' fill='%230c4076'/%3e%3cpath fill='%2321231e' d='M394.21 280l-1 .1c-.18-1.77-1.52-3.2-3.03-4.02a12.53 12.53 0 0 0-7.3-1.31l-.1-1.02c2.94-.29 6.06.18 8.55 1.84 1.5 1 2.7 2.57 2.88 4.41zm-9.94 8.44l-.1-1.01c2.7-.3 5.45-1.28 7.39-3.25a5.2 5.2 0 0 0 1.65-4.08l1-.1c.2 1.96-.79 3.85-2.2 5.16-2.08 1.96-4.92 2.98-7.74 3.28zm-6.88-6.7l1-.12c.25 1.99 1.14 4.04 2.88 5.16.85.55 1.9.76 2.9.65l.1 1.01c-1.72.2-3.5-.46-4.68-1.73a8.68 8.68 0 0 1-2.2-4.98zm5.4-7.99l.1 1.02a4.66 4.66 0 0 0-3.63 2.25 7.36 7.36 0 0 0-.86 4.6l-1 .11c-.26-2.22.22-4.68 1.83-6.33a5.71 5.71 0 0 1 3.55-1.65z'/%3e%3cpath d='M457.46 280.42a3.2 3.2 0 0 1 3.2 3.22c0 1.77-1.44 3.21-3.2 3.21s-3.2-1.44-3.2-3.21a3.2 3.2 0 0 1 3.2-3.22z' fill='white'/%3e%3cpath fill='%2321231e' d='M461.16 283.63h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.75 3.75 0 0 1 3.7-3.72z'/%3e%3cpath d='M408.71 283.14a3.2 3.2 0 0 1 3.2 3.22c0 1.77-1.44 3.21-3.2 3.21s-3.2-1.44-3.2-3.21a3.2 3.2 0 0 1 3.2-3.22z' fill='white'/%3e%3cpath fill='%2321231e' d='M412.41 286.36h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7H405a3.75 3.75 0 0 1 3.7-3.72z'/%3e%3cpath d='M406.99 268.29c1.76 0 3.2 1.44 3.2 3.22s-1.44 3.21-3.2 3.21-3.2-1.44-3.2-3.21 1.44-3.22 3.2-3.22z' fill='white'/%3e%3cpath fill='%2321231e' d='M410.69 271.51h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.75 3.75 0 0 1 3.7-3.72z'/%3e%3cpath d='M457.34 266.19a3.2 3.2 0 0 1 3.2 3.22 3.2 3.2 0 0 1-3.2 3.21 3.2 3.2 0 0 1-3.2-3.21 3.2 3.2 0 0 1 3.2-3.22z' fill='white'/%3e%3cpath fill='%2321231e' d='M461.04 269.41h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.02a3.7 3.7 0 0 1 3.7 3.72zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.75 3.75 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.7 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.74 3.74 0 0 1 3.7-3.72z'/%3e%3cpath d='M370.93 237.39c2.42-.74 6.2 4.64 7.1 4.54 1.18-3.07-1.24-10.43-5.54-16.25-2.92-.96-3.18-2.85-3.78-7.23-.18-1.31-2.68-.41-2.73 1.82-.05 2.39-.23 3.71.3 5.76.2.8.1 1.57-.8 2.3 4.55 1.82 5.67 4.05 5.45 9.06z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M377.56 241.75c.26.14.8.24.9.4-.24.27-.57.39-.88.18-1.07-.65-1.85-1.65-2.79-2.46-.94-.82-1.92-1.78-3.2-2.03-.4.07-.62 0-.66-.46-.25-.4-.05-.6.4-.56 1.41 0 2.58.97 3.62 1.83 1.04.87 1.92 1.93 3.01 2.74.23 0-.37.27-.4.36zm.94.37c-.04.45-.69.35-.1.08l.1-.08zm-6.16-15.96c.13-.28.18-.8.36-.93.5.4.78 1 1.16 1.51a31.9 31.9 0 0 1 4.7 10.7c.28 1.53.48 3.17-.06 4.68-.28-.15-.76-.21-.92-.42.5-1.62.15-3.34-.22-4.95a32.58 32.58 0 0 0-5.27-10.77l.25.18zm.32-.97zm-4.45-6.67c.32 0 .78-.2 1.02-.09.26 1.68.36 3.45 1.11 5a3.71 3.71 0 0 0 2.31 1.76c-.13.3-.17.79-.36.95a4.64 4.64 0 0 1-3.06-2.7c-.62-1.56-.76-3.27-1.02-4.92zm-1.71 1.76c-.32-.05-.8.06-1.01-.08.01-1.4 1.12-2.86 2.59-2.87.57 0 1.08.48 1.14 1.05-.33 0-.76.18-1.02.09-.15-.26-.56-.04-.76.07-.6.36-.94 1.05-.94 1.74zm.28 5.62c-.32.04-.75.28-1 .2-.53-1.9-.34-3.9-.3-5.84.32.05.8-.06 1.02.08-.04 1.86-.24 3.74.28 5.56zm-1.1 1.96c-.13.26-.28.82-.39.9.03-.3-.27-.73.01-.93.49-.4.7-1.08.5-1.68.31-.04.75-.28 1-.2a2.61 2.61 0 0 1-1 2.78l-.12-.87zm-.38.95c-.19-.16-1.03-.21-.62-.47.3-.3.6-.55.56.06l.06.41zm5.13 8.58h.96c-.29-.08-.87.13-.95-.14.06-2 .03-4.22-1.25-5.88-.98-1.25-2.45-1.97-3.89-2.56.16-.28.22-.77.43-.92 1.98.78 4.01 1.95 4.94 3.97.82 1.72.84 3.69.77 5.56l-1-.03zm1.01 0h-1c.2-.35.4-.63.72-.2l.28.2zm-1 0c-.27-.39.62-.68.18-.25l-.19.25z'/%3e%3cpath d='M368.78 218.51c-.42 1-.54 1.84-.64 3.37a4.77 4.77 0 0 0 1.09 3.23 10.3 10.3 0 0 0 3 2.52c.75.43 1.6 1.63 2.27 2.98a10.6 10.6 0 0 1 1.19 3.96c.1 3.58.79 6.7 2.42 7.32 1.06.4 1.49.34 2.31.15-.23-.64-.14-1.55-.72-2.45-.73-1.15-1.38-2.48-1.44-3.64-.05-.9-.48-1.51-.13-3.3.23-1.15.98-1.59.84-2.65-.25-2.06-1.87-6.02-4.24-6.02-2.35 0-3.44-.25-4.65-3.37-.41-1.06-.95-1.57-1.3-2.1z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M368.64 221.91c-.31-.06-.8.03-1-.12.07-1.18.2-2.38.67-3.48.28.16.76.24.91.45-.42 1-.52 2.08-.58 3.15zm.99 2.88c-.28.17-.58.55-.84.58a5.27 5.27 0 0 1-1.16-3.53c.31.06.8-.02 1 .13a4.32 4.32 0 0 0 1 2.82zm2.86 2.4c-.2.26-.33.73-.56.85a10.74 10.74 0 0 1-3.1-2.62c.27-.17.57-.55.83-.58a9.84 9.84 0 0 0 2.83 2.35zm2.46 3.2c-.3.1-.67.42-.93.4-.53-1-1.1-2.06-2.04-2.72.2-.26.33-.73.56-.85 1.1.76 1.8 2 2.41 3.16zm1.24 4.16c-.31-.03-.78.1-1-.03-.1-1.3-.59-2.52-1.14-3.68.3-.1.67-.43.93-.4a10.96 10.96 0 0 1 1.21 4.11zm2.1 6.86c-.15.29-.21.78-.41.93-1.3-.56-1.82-2.01-2.16-3.28a21 21 0 0 1-.54-4.48c.32.03.8-.1 1.02.03.08 1.96.2 4 1.09 5.78.23.42.53.84 1 1.02zm1.66.8c.28-.07.78-.34.92-.3-.18.27-.23.72-.64.7-.77.2-1.58.06-2.3-.24.15-.29.2-.77.4-.93a2.8 2.8 0 0 0 1.98.1l-.36.67zm.95-.34c.19.36.27.67-.25.64-.27.13.25-.56.25-.64zm-1.62-2l.85-.55c.52.75.54 1.69.77 2.55-.31.07-.72.34-.97.29-.24-.76-.2-1.61-.65-2.3zm-1.53-3.9l1.01-.05c.1 1.24.72 2.36 1.37 3.4-.29.14-.62.5-.88.5a8.57 8.57 0 0 1-1.5-3.85zm1.01-.05zm-1.12-3.36c.3.1.79.07.98.25-.21.9-.1 1.84.1 2.73.2.47-.26.4-.59.41-.37.13-.42-.08-.43-.4-.24-.98-.28-2-.06-3zm.83-2.5c.32 0 .78-.17 1.01-.07.17 1.03-.66 1.81-.85 2.76-.3-.1-.8-.07-.98-.25.1-.78.72-1.39.83-2.16v-.28zm-3.75-5.57c.04-.32-.07-.8.06-1.02 1.54.05 2.65 1.35 3.35 2.59a11.2 11.2 0 0 1 1.34 3.88c-.32 0-.77.17-1 .07a9.29 9.29 0 0 0-2.12-4.7c-.43-.44-.99-.82-1.63-.82zm-5.11-3.7l.94-.37c.45 1.1.96 2.4 2.16 2.83.65.22 1.34.21 2.01.22-.03.32.08.8-.05 1.02-1.27.02-2.7-.12-3.6-1.13a7.9 7.9 0 0 1-1.46-2.57zm-.36-2.08c-.26-.13-.81-.3-.88-.4.31.04.78-.26.95.1.49.62.96 1.27 1.23 2.01-.31.08-.7.37-.96.32-.27-.73-.79-1.32-1.23-1.95l.89-.08zm-.94-.4c.15-.2.25-.9.43-.78.06.23.72.75.23.72l-.66.06zm.47.2zm-.47-.2c.15-.2.25-.9.43-.78.06.23.72.75.23.72l-.66.06z'/%3e%3cpath d='M359.96 227.08c.64-.5 1.4-.85 2.13-1.14a5.77 5.77 0 0 1 3.81-.17c5.61 1.7 8.07 11.67 1.92 14.07-1.21.15-2.33-.95-3.42-3.36-1.28-3.18-2.64-5.4-4.1-6.74-.9-1.13-.93-2.09-.34-2.66z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M361.91 225.47l.37.95c-.7.28-1.4.6-2 1.06l-.62-.8c.67-.53 1.46-.9 2.25-1.21zm4.14-.18l-.3.97a5.28 5.28 0 0 0-3.47.16l-.37-.95a6.3 6.3 0 0 1 4.14-.18zm1.84 15.05l-.13-1c-.28.06.33-.16.42-.22a4.95 4.95 0 0 0 2.54-3.3 8.73 8.73 0 0 0-1.19-6.43 6.98 6.98 0 0 0-3.77-3.13l.29-.97a8.26 8.26 0 0 1 4.73 4.25 9.4 9.4 0 0 1 .77 7.06 5.88 5.88 0 0 1-3.31 3.61c-.12.05-.23.11-.35.13zm.12-.03zm-4.07-3.64c.3-.13.68-.24.93-.4.48 1.02 1 2.1 1.91 2.79.29.2.64.32.98.27l.13 1.01c-1.1.15-2.07-.6-2.69-1.45-.51-.68-.91-1.44-1.26-2.22zm0 .03zm-4.03-6.65l.79-.63.38.37c1.73 1.85 2.84 4.18 3.8 6.5l-.94.38c-.9-2.2-1.96-4.41-3.6-6.18-.13-.15-.3-.29-.43-.44zm.05.06zm0-3.54v1.02c.2-.08.46-.23.21.03-.28.6.13 1.26.48 1.74.07.18-.34.3-.45.46-.2.22-.37.28-.49-.03-.55-.75-.91-1.83-.4-2.7a.99.99 0 0 1 .65-.52zm-.35.14c.16-.23.53-.13.1-.03-.04 0-.07.02-.1.03zm.35.88v-1.02l.31.91-.3.11zm.31-.1z'/%3e%3cpath d='M362.79 227.74c5.4-2.1 9.36 8.23 4.32 10.19-2.7 1.05-2.96-2.33-3.49-4.21-.7-2.54-6-3.96-.83-5.98z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M367.29 238.4l-.37-.95c.8-.3 1.46-.97 1.73-1.78a5.82 5.82 0 0 0-.15-3.86 6.35 6.35 0 0 0-2.5-3.32 3.3 3.3 0 0 0-2.91-.32c-.21.13-.18-.24-.28-.36l-.2-.55c.81-.3 1.72-.4 2.57-.2a5.72 5.72 0 0 1 3.3 2.47 8.1 8.1 0 0 1 1.4 5.33 4.34 4.34 0 0 1-1.54 2.93c-.31.26-.68.45-1.05.61zm-4.16-4.55l.98-.27c.32 1.14.44 2.36 1.05 3.4.23.4.68.7 1.16.63.2-.02.4-.09.6-.16l.37.95c-.74.3-1.65.36-2.31-.15-.82-.6-1.14-1.62-1.4-2.55-.16-.61-.28-1.24-.45-1.85zm-.53-6.59l.37.95c-.65.28-1.36.53-1.83 1.08-.24.32.06.69.26.94.88.99 2.05 1.76 2.59 3.01.07.18.2.4-.09.4l-.77.21c-.3-.9-1.06-1.52-1.72-2.16-.56-.56-1.24-1.14-1.36-1.98-.09-.68.38-1.27.92-1.62.5-.35 1.07-.6 1.63-.83z'/%3e%3cpath d='M363.35 229.27c2.63-1.02 6.24 5.14 2.95 6.54-2.22.94-3.98-.3-4.7-2.16-.7-1.86-.1-3.66 1.75-4.38z' fill='%230c4076'/%3e%3cpath fill='%2321231e' d='M366.5 236.28l-.4-.94c.47-.19.84-.59.95-1.08a3.67 3.67 0 0 0-.46-2.41 4.55 4.55 0 0 0-1.93-2.02 1.46 1.46 0 0 0-1.12-.08l-.37-.95a2.42 2.42 0 0 1 1.82.07c.93.4 1.67 1.17 2.2 2.01.57.9.97 1.95.93 3.02a2.63 2.63 0 0 1-1.62 2.38zm-5.36-2.44l.94-.37a3.26 3.26 0 0 0 2.03 2.06c.66.2 1.37.08 2-.19l.39.94c-.96.42-2.1.51-3.08.08a4.39 4.39 0 0 1-2.28-2.52zm2.03-5.04l.37.95c-.75.28-1.4.89-1.61 1.68-.2.67-.1 1.4.15 2.04l-.94.37a4.05 4.05 0 0 1 .1-3.4 3.66 3.66 0 0 1 1.93-1.64zm.18.47l-.18-.47.18.47z'/%3e%3cpath d='M400.08 179.66a6.4 6.4 0 0 1 6.37 6.41 6.4 6.4 0 0 1-6.37 6.42c-3.52 0-6.37-2.87-6.37-6.42s2.85-6.41 6.37-6.41z' fill='white'/%3e%3cpath d='M406.95 186.07h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.92v-1.02a5.87 5.87 0 0 0 5.86-5.9h1.01a6.96 6.96 0 0 1-3.26 5.89 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9V193a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.9h-1.02a6.96 6.96 0 0 1 3.26-5.88 6.85 6.85 0 0 1 3.62-1.04z' fill='%2321231e'/%3e%3cpath d='M395.43 169a6.4 6.4 0 0 1 6.37 6.42 6.4 6.4 0 0 1-6.37 6.41 6.4 6.4 0 0 1-6.37-6.41 6.4 6.4 0 0 1 6.37-6.42z' fill='white'/%3e%3cpath d='M402.31 175.42h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.03a6.88 6.88 0 0 1 6.87 6.93zm-6.87 6.92v-1.01a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.89 6.85 6.85 0 0 1-3.61 1.04zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9v1.02a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.93v1.02a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.9 6.85 6.85 0 0 1 3.62-1.03z' fill='%2321231e'/%3e%3cpath d='M410.68 131.46c3.4 0 6.14 2.77 6.14 6.19s-2.75 6.18-6.14 6.18c-3.39 0-6.14-2.77-6.14-6.18s2.75-6.19 6.14-6.19z' fill='white'/%3e%3cpath d='M417.32 137.65h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.01a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.12-5.67 6.6 6.6 0 0 1 3.52-1.03z' fill='%2321231e'/%3e%3cpath d='M400.36 136.18a6.4 6.4 0 0 1 6.37 6.41 6.4 6.4 0 0 1-6.37 6.42 6.4 6.4 0 0 1-6.37-6.42 6.4 6.4 0 0 1 6.37-6.41z' fill='white'/%3e%3cpath d='M407.23 142.59h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.93v-1.02a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.9 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.93h1.02a5.93 5.93 0 0 0 5.86 5.9v1.03a6.88 6.88 0 0 1-6.88-6.93zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.04z' fill='%2321231e'/%3e%3cpath d='M392.77 145.25a6.4 6.4 0 0 1 6.37 6.42 6.4 6.4 0 0 1-6.37 6.41 6.4 6.4 0 0 1-6.37-6.41 6.4 6.4 0 0 1 6.37-6.42z' fill='white'/%3e%3cpath d='M399.64 151.66h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.03a6.88 6.88 0 0 1 6.87 6.93zm-6.87 6.92v-1.01a5.87 5.87 0 0 0 5.86-5.9h1a6.96 6.96 0 0 1-3.25 5.88 6.85 6.85 0 0 1-3.61 1.04zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9v1.02a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.93v1.02a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.9 6.85 6.85 0 0 1 3.62-1.03z' fill='%2321231e'/%3e%3cpath d='M391.54 156.66c3.52 0 6.37 2.87 6.37 6.41s-2.85 6.42-6.37 6.42-6.37-2.87-6.37-6.42 2.85-6.41 6.37-6.41z' fill='white'/%3e%3cpath d='M398.41 163.08h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.92V169a5.87 5.87 0 0 0 5.86-5.91h1.01a6.95 6.95 0 0 1-6.87 6.92zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9V170a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.04z' fill='%2321231e'/%3e%3cpath d='M474.41 198.02c-2.7-5.03-5.57-8.25-8.6-9.65 4.18-13.16 5.16-30.15 2.7-51.1-.24-3.13-1.01-4.47-2.2-4.45-1.05.02-1.68 1.61-1.79 5.22.76 11.52 1.7 21.6 1.17 30.16-.47 7.65-2.26 14-4.24 21.16-.27 1 .44 1.77 3.87 3.71 2.54 1.44 4.14 3.22 4.67 5.07.74-.3 1.2-.2 1.47-.13 2.55.74 3.62.54 2.95 0v.01z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M465.33 188.22c1.38.84.31-.67 1.29-.01 3.76 2.12 6.2 5.88 8.23 9.57-.87.9-1.2.01-1.6-.78-1.9-3.21-4.2-6.49-7.65-8.16l-.27-.62zm.27.62zm2.41-51.52c1.13-.45 1.14.35 1.16 1.26 1.57 14.52 1.95 29.38-1.2 43.72a75.51 75.51 0 0 1-1.68 6.23c-1.23-.01-.86-.85-.54-1.68 3.9-13.53 4.09-27.82 3.03-41.78-.21-2.58-.47-5.17-.77-7.75zm0 .02zm-1.7-4c-.2-.77.05-1.33.83-.85 1.6.96 1.67 3.1 1.88 4.75-1.08.41-1.13-.34-1.16-1.22-.22-.9-.36-2.58-1.55-2.69zm-1.29 4.67c-1.02.36-1.15-.23-.95-1.1.17-1.51.17-3.41 1.52-4.4.74-.6.86.3.67.82-.93.47-.9 1.8-1.1 2.7-.08.6-.12 1.52-.14 1.98zm-1 .07zm2.17 30.16c-1.23.3-1.02-.67-.93-1.55.33-9.55-.66-19.09-1.25-28.61 1.2-.46 1.1.53 1.11 1.41.6 9.57 1.6 19.16 1.07 28.75zm-4.25 21.26c-1.2.03-.9-.78-.6-1.6 1.8-6.46 3.47-13 3.84-19.72 1.2-.3 1.05.6.91 1.46-.53 6.77-2.34 13.34-4.15 19.86zm3.63 3.13c-.24 1.06-.83.86-1.52.3-1.2-.83-3-1.55-3.16-3.2-.25-.79 1.26-.46 1.03.14.76 1.34 2.4 1.95 3.65 2.76zm0 0zm4.23 5.04c.77 1.02-.16 1.12-.45.18-.78-1.94-2.51-3.31-4.28-4.33.25-1.07.88-.83 1.55-.24 1.7 1.15 3.26 2.71 3.85 4.73l-.67-.34zm.37.95zm1.43-1.1c-.19.39-.06 1.17-.66.93-.38-.06-.89.42-.92-.21-.56-.66.24-.76.76-.8.27-.02.56 0 .82.09zm3.31.5c-1.5.4-.52-.77.11-.06.42.92-.86 1.21-1.52 1.02-.74-.09-1.47-.27-2.18-.47 0-1.1.65-.98 1.46-.68.45.1 1.14.18 1.47.15-.58 1.02.29.09.66.04zm-1 0c-.64-1.45 1.17-.7.44-.22l-.45.22zm0 0c1.32-.2.8.3.02.11l-.03-.1z'/%3e%3cpath d='M458.4 214.56c1.56-.99 1.87-.72 2.37-1.37.65-.83.66-2.2.46-3.5-.82-5.3 2.33-4.56 5.88-2.22 1.77 1.17 3.56 3.88 5.08 5.3 1.53 1.41 2.79 1.54 3.17 2.1.05 2.02.06 3.78.04 4.57.02.8 0 2.55-.04 4.57-.38.56-1.64.68-3.17 2.1-1.52 1.42-3.3 4.13-5.08 5.3-3.55 2.33-6.7 3.07-5.88-2.21.2-1.31.2-2.68-.46-3.51-.5-.65-.8-.39-2.37-1.37a6.96 6.96 0 0 1-2.28-2.25c-.51-.83-.24-1.73-.24-2.63 0-.9-.27-1.8.24-2.64.5-.83 1.26-1.6 2.28-2.24z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M460.37 212.87c1.19.43.47 1.23-.4 1.44-.7.32-1.65 1.06-1.79-.22.67-.52 1.58-.65 2.19-1.22zm.35-3.12c1.66-.73 1.09 1.77.96 2.69-.04.98-.97 1.26-1.22.3.51-.9.39-2 .26-2.99zm6.66-2.71c-.62 1.8-2.14-.6-3.31-.6-1.4-.85-2.82.38-2.47 1.87.22.82.12 1.75-.9 1.33-.2-1.46-.34-3.47 1.2-4.26 1.7-.62 3.4.43 4.84 1.25l.64.4zm5.15 5.35c-.83 1.6-1.77-.63-2.5-1.23-.98-1.17-1.95-2.38-3.2-3.27.56-1.72 1.84.37 2.55.95 1.07 1.17 2 2.45 3.15 3.55zm3.33 2.46c-.45-.08-1.04.08-1.06.2-.97-.6-2.08-1.02-2.87-1.85.46-1.56 1.54.22 2.43.43.52.34 1.35.53 1.5 1.22zm-.09-.28zm.13 4.86c-1.77.46-.73-1.92-1.02-2.9-.1-.87-.2-2.19.98-1.57.04 1.49.05 2.98.04 4.47zm-1.01 0zm0 0c.62 0 1.16.01.21.01h-.21zm0 .02v-.01zm.88 4.85c-.31-.46-1.06-.39-.91-.6.02-1.41.04-2.83.03-4.25 1.79-.48.75 1.96 1 2.95-.04.63.04 1.29-.12 1.9zm.09-.28zm-3.33 2.46c-1.49-.92.64-1.7 1.41-2.18.5-.59 1.72-.61 1.7.13-.94.82-2.25 1.08-3.11 2.05zm-5.15 5.35c-1.29-1.1.9-1.69 1.37-2.62 1.04-1.15 1.96-2.41 3.1-3.48 1.47.92-.72 1.83-1.15 2.77-1.01 1.2-2.02 2.43-3.32 3.33zm-6.66-2.72c1.64-.23.57 1.55.95 2.47.15 1.32 1.71 1.25 2.61.76.91-.22 1.9-1.17 2.6-1.23 1.15.93-.73 1.33-1.35 1.8-1.17.57-2.7 1.17-3.92.42-1.3-.98-1.07-2.8-.89-4.22zm-.35-3.11c1.18-1.53 1.58 1.17 1.47 2.07.35.94-.64 1.66-1.09.8.1-.96.2-2.04-.38-2.87zm-2.24-1.26c.39-1.5 1.66-.09 2.55.18 1.04.44-.5 1.52-.9.66-.59-.2-1.13-.5-1.65-.84zm.53-.86zm-2.98-1.55c1.1-1.22 1.55.88 2.54 1.25.94.27-.28 1.73-.78.68a7.12 7.12 0 0 1-1.76-1.93zm-.3-2.9c1.71-.47.51 1.54 1.16 2.37-1.1 1.23-1.4-.64-1.22-1.51l.05-.86zm.3-2.9c1.42.37.3 1.87.7 2.9-1.52.47-1.09-1.53-.93-2.42.06-.16.13-.33.23-.48zm2.44-2.4c1.2 1-.58 1.42-1.06 2.22-.2.83-1.19.73-1.28.01a7.59 7.59 0 0 1 2.34-2.24zm.54.86z'/%3e%3cpath d='M475.52 220.24l-.13.89a17.42 17.42 0 0 0-9.56 4.35c1.8-2.66 5.63-4.65 9.69-5.24zM475.52 218.64l-.13-.89a17.43 17.43 0 0 1-9.56-4.35c1.8 2.66 5.63 4.65 9.69 5.24z' fill='%2321231e'/%3e%3cpath d='M461.16 207.28c1.14.47 2.38.97 3.44 2 1.6 1.55.56 4.12-1.5 6.62-.66.78-.97 2.17-.97 3.56 0 1.38.33 2.76.96 3.52 2.07 2.5 3.1 5.07 1.5 6.63-1.04 1.02-2.29 1.52-3.43 1.99-.1-.6-.1-1.39.06-2.4.2-1.31.2-2.68-.45-3.51-.5-.65-.81-.38-2.38-1.37a7 7 0 0 1-2.28-2.24c-.5-.84-.23-1.74-.23-2.64 0-.9-.28-1.8.23-2.63.5-.84 1.27-1.6 2.28-2.25 1.57-.98 1.87-.72 2.38-1.37.65-.83.65-2.2.45-3.5a7.44 7.44 0 0 1-.06-2.41z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M464.95 208.9l-.7.73a9.7 9.7 0 0 0-3.28-1.89l.38-.94c1.3.52 2.6 1.11 3.6 2.1zm-1.47 7.32l-.77-.66c.98-1.23 1.98-2.6 2.16-4.2a2.09 2.09 0 0 0-.62-1.73l.7-.73c.99.9 1.13 2.4.71 3.62a11.37 11.37 0 0 1-2.18 3.7zm-.84 3.23h-1.01c.01-1.35.22-2.8 1.08-3.89l.77.66c-.68.9-.82 2.13-.84 3.23zm.84 3.2l-.77.65c-.85-1.08-1.06-2.51-1.08-3.85h1c.03 1.1.18 2.3.85 3.2zm1.47 7.32l-.7-.74c.84-.77.7-2.05.3-3a11.48 11.48 0 0 0-1.84-2.93l.77-.65c1.15 1.42 2.27 3.03 2.4 4.9.05.9-.28 1.8-.93 2.42zm-4.28 1.72l1-.19c-.14-.15-.9-.33-.54-.44a9.27 9.27 0 0 0 3.12-1.83l.7.74c-1 .99-2.3 1.58-3.6 2.1l-.68-.38zm.68.37c-.31.14-.7.41-.64-.14-.17-.49.42.1.64.14zm-.63-2.95l1 .16c-.1.74-.18 1.5-.06 2.23l-1 .19a8.25 8.25 0 0 1 .06-2.58zm-.35-3.11l.8-.63c.82 1.11.74 2.6.55 3.9l-1-.16c.14-1.02.27-2.22-.35-3.11zm-2.24-1.26l.53-.86c.64.45 1.4.67 2.07 1.06.16.15.63.4.26.57-.23.08-.51.63-.72.37-.48-.38-1.12-.5-1.64-.83l-.5-.3zm0 0l-.08-.05c-.06 0 .11.05.08.05zm-2.45-2.4l.86-.54a6.53 6.53 0 0 0 2.12 2.08l-.53.86a7.52 7.52 0 0 1-2.45-2.4zm0 0c.18.3.43.71.1.18l-.1-.18zm-.3-2.9h1c.03.78-.27 1.64.16 2.36l-.86.53c-.57-.87-.34-1.93-.3-2.9zm.3-2.9l.86.53c-.42.72-.14 1.58-.16 2.36h-1c-.03-.97-.27-2.02.3-2.9zm2.45-2.42l.53.87a6.53 6.53 0 0 0-2.12 2.07l-.86-.53a7.5 7.5 0 0 1 2.45-2.4zm2.24-1.25l.8.63c-.53.73-1.51.8-2.21 1.3-.34.39-.46-.12-.65-.38-.38-.32.07-.45.34-.6.5-.35 1.14-.46 1.62-.83l.1-.12zm.35-3.12l1-.15c.19 1.3.27 2.78-.55 3.9l-.8-.63c.62-.9.49-2.1.35-3.12zm.44-1.97v-1.02c.16.29.6.5.46.86-.06.66 0 1.33.1 1.98l-1 .15a8.22 8.22 0 0 1-.05-2.57l.5.6zm0-1.02c.4-.03.77-.05.53.44.03.45-.41-.4-.53-.44zm0 0v1.02c-.4-.03 0-.58-.03-.85l.03-.17zM361 226.26l.68-.3c-1.54-2.14-1.88-4.2-1.29-6.26-1.3 1.64-.99 4.21.61 6.56z'/%3e%3cpath d='M410.74 199.91c1.33 1.69 1.17 2.09 1.89 2.57.94.63 2.22.41 3.4-.04 4.86-1.86 4.86 2 3.45 6.43-.68 2.14-2.76 4.47-3.68 6.3-.91 1.78-.71 3.12-1.12 3.57-1.76.3-3.28.51-3.97.59-.67.1-2.18.3-3.9.49-.57-.32-1.01-1.6-2.62-2.99-1.61-1.4-4.4-2.92-5.9-4.63-3.05-3.47-4.66-6.81.12-6.7 1.2.04 2.38-.18 2.92-1.04.42-.67.1-.97.51-2.93.27-1.28.74-2.3 1.35-3.04.61-.75 1.5-.58 2.33-.74.83-.15 1.59-.64 2.5-.18a8.35 8.35 0 0 1 2.72 2.34z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M412.91 202.06c-.24.18-.37.97-.7.75-.74-.6-1.01-1.58-1.64-2.29-.5-.37.25-.58.49-.86.27-.03.47.55.7.77.41.52.6 1.24 1.15 1.63zm-.56.85zm3.5-.95c.02.34.62.94.12 1.04-1.15.42-2.54.62-3.62-.09.25-.2.37-.92.7-.77.88.45 1.93.14 2.8-.18zm4.11 7.06c-.28-.2-1.14-.1-.88-.58.45-1.6.98-3.32.55-4.98-.2-.85-1.17-1.12-1.93-.95-.51.07-1 .23-1.49.4-.02-.34-.64-.96-.1-1.04 1.23-.45 2.84-.75 3.88.26 1.06 1.17.87 2.9.63 4.33-.16.87-.4 1.72-.66 2.56zm-3.7 6.38c-.25-.25-1.12-.29-.78-.71 1.11-2.03 2.75-3.77 3.52-5.98.26.2 1.09.1.89.53-.83 2.26-2.52 4.06-3.64 6.16zm-1.5 3.85c-.14-.27.05-1.23-.4-.87-.06-.02.14-.47.13-.66.16-.96.4-1.92.86-2.79.23.24 1.07.28.8.68-.51.98-.56 2.1-.88 3.12a.84.84 0 0 1-.5.52zm.3-.16zm-4.34.75c.07-.31-.13-1.01.08-1.03 1.27-.16 2.54-.36 3.8-.56-.05.32.41 1.02-.07 1.04-1.27.2-2.54.41-3.81.55zm.05 0zm.02 0l-.11-.73c.06.7.02-.76.04-.08v.6c-.03-.68.02-.01.07.2zm-.16-1.01zm-4.07 1.43c.05-.3.8-.92.22-.94.29-.05.83-.1 1.21-.15.89-.1 1.77-.2 2.64-.34-.05.32.4 1-.05 1.04-1.26.17-2.53.36-3.79.44l-.23-.05zm.3.07zm-3-3.11c.28-.15.51-.97.82-.64.92.78 1.55 1.82 2.3 2.74.07.22-.31.81-.48.9-.8-.63-1.2-1.62-1.94-2.33a8.93 8.93 0 0 0-.7-.67zm-5.95-4.68c.31-.14.66-.92.94-.47 1.68 1.72 3.85 2.83 5.67 4.38-.29.17-.52 1-.86.6-1.89-1.54-4.1-2.69-5.75-4.51zm.52-7.54c-.12.3.21 1.06-.24 1.02-.75.03-1.72 0-2.2.7-.3.9.3 1.8.73 2.58.56.91 1.25 1.75 1.95 2.57-.31.13-.67.93-.94.46-1.17-1.42-2.44-2.9-2.81-4.74a2.02 2.02 0 0 1 1.45-2.35 6.17 6.17 0 0 1 2.06-.24zm2.47-.81c.19.25 1.01.38.75.7-.75.98-2.1 1.16-3.25 1.13.11-.31-.2-1.05.24-1.02.79-.02 1.78-.09 2.26-.81zm0 0zm.45-2.76c.26.17 1.04 0 .96.39-.24.85-.1 1.77-.39 2.6-.1.57-.52.04-.8-.1-.4-.12.07-.5-.04-.8.04-.7.12-1.4.27-2.09zm1.45-3.26c.16.26.88.47.69.77-.6.79-.94 1.74-1.15 2.7-.28-.17-1.12.02-.93-.46a7.43 7.43 0 0 1 1.39-3.01zm.78.65l.34-.42-.34.42zm1.85-1.56c-.05.3.4.94.03 1.02-.64.12-1.42-.02-1.88.53-.17-.27-.98-.5-.63-.81.65-.69 1.63-.63 2.48-.74zm.19 1l-.35.06.35-.06zm2.64-1.14c-.23.23-.26 1.02-.64.83-.68-.21-1.34.2-2 .3.04-.34-.46-1.03.08-1.06.83-.26 1.74-.53 2.56-.07zm2.99 2.8c-.3.09-1.2-.25-.92.25-.11-.07-.46-.54-.7-.75a7.14 7.14 0 0 0-1.83-1.4c.23-.22.27-1.04.65-.8 1.06.6 2 1.45 2.71 2.44l.09.25zm-.11-.33zm-.9.32c.2.03 1.14-.06.88.05-.34.02-.85.55-.88-.05zm.1.32z'/%3e%3cpath d='M410.05 219.43l-.8-.03a23.54 23.54 0 0 0-6.3-9.54c2.82 1.57 5.56 5.42 7.1 9.57zM411.43 219.24l.74-.24c-.5-4 .07-7.54 1.54-10.88-1.96 2.37-2.76 6.8-2.28 11.12z' fill='%2321231e'/%3e%3cpath d='M418.3 201.97c-.18 1.42-.37 2.95-1.07 4.32-1.07 2.05-3.69 1.26-6.48-.7a4.82 4.82 0 0 0-3.48-.54c-1.24.22-2.38.79-2.88 1.61-1.6 2.64-3.51 4.12-5.31 2.61-1.2-1-2-2.29-2.75-3.47a5.03 5.03 0 0 1 2.09-.3c1.19.04 2.38-.18 2.91-1.04.43-.67.11-.97.52-2.92.27-1.29.74-2.31 1.34-3.05.62-.75 1.51-.58 2.34-.73.83-.16 1.59-.65 2.5-.19a8.35 8.35 0 0 1 2.72 2.34c1.32 1.68 1.16 2.09 1.89 2.58.94.62 2.21.4 3.4-.05a5.9 5.9 0 0 1 2.26-.47z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M417.68 206.53l-.9-.47c.67-1.28.84-2.74 1.02-4.15l1 .13c-.18 1.53-.4 3.1-1.12 4.49zm-7.22-.52l.58-.83c1.25.84 2.6 1.72 4.15 1.81.66.05 1.32-.32 1.6-.93l.89.47a2.68 2.68 0 0 1-2.7 1.47c-1.67-.15-3.17-1.06-4.52-1.99zm-3.1-.45l-.18-1a5.3 5.3 0 0 1 3.86.62l-.58.83c-.9-.6-2.07-.62-3.1-.45zm-2.54 1.37l-.86-.53c.7-1.1 2-1.62 3.22-1.85l.18 1c-.94.19-1.98.55-2.54 1.38zm-6.06 2.74l.65-.78c.58.57 1.53.63 2.2.17a7.84 7.84 0 0 0 2.35-2.66l.86.53c-.83 1.33-1.83 2.74-3.36 3.31-.93.35-1.97.08-2.7-.57zm-2.63-4.33l.4.93c.11-.16.14-.95.33-.58.73 1.15 1.49 2.31 2.55 3.2l-.65.78a14.78 14.78 0 0 1-2.86-3.6l.23-.73zm-.23.74c-.18-.28-.5-.6.03-.66.41-.26-.02.44-.02.64v.02zm2.53-1.08l-.02 1.02c-.63 0-1.29 0-1.88.25l-.4-.94c.72-.3 1.53-.34 2.3-.33zm2.48-.8c.29.17.57.37.86.54-.7 1.09-2.1 1.3-3.3 1.28-.15-.17 0-.63-.04-.92.1-.22.61-.04.88-.13.59-.07 1.26-.24 1.6-.78zm0 0zm.45-2.76l.99.21c-.22.83-.18 1.7-.33 2.53-.09.19-.17.73-.44.45-.17-.21-.8-.3-.58-.6.18-.7.1-1.46.28-2.17l.08-.42zm1.45-3.27l.78.65a6.66 6.66 0 0 0-1.24 2.83l-.99-.21a7.62 7.62 0 0 1 1.45-3.27zm0 0c.21-.27.5-.6.11-.14l-.11.14zm2.63-.91l.18 1c-.67.16-1.53-.04-2.03.56l-.78-.65c.57-.75 1.56-.82 2.42-.88.07 0 .14-.02.2-.03zm0 0c.26-.05.89-.17.29-.05l-.3.05zm2.82-.14l-.45.91c-.72-.37-1.47.12-2.19.23l-.18-1c.86-.21 1.79-.62 2.66-.21l.16.07zm-.45.91zm3.34 1.57l-.8.63a7.92 7.92 0 0 0-2.54-2.2l.45-.9a8.91 8.91 0 0 1 2.89 2.47zm1.77 2.47l-.56.85c-.8-.53-1.06-1.51-1.65-2.22-.15-.24-.55-.5-.1-.67.25-.15.55-.65.72-.19.52.63.87 1.37 1.34 2.03.07.07.17.15.25.2zm-.56.85zm3.5-.96l.36.96c-1.21.46-2.7.75-3.86 0l.56-.86c.9.56 2.03.24 2.94-.1zm2.95.08l-1-.13c.09.2.74.66.22.58-.62.03-1.23.2-1.81.43l-.36-.96c.79-.29 1.62-.53 2.47-.5.15.2.32.4.48.58zm-.48-.57c.38-.04.68 0 .5.45.02.33-.4-.4-.5-.45z'/%3e%3cpath d='M391.76 221.18c.77-.94 1.08-.73 1.22-1.32.18-.77-.27-1.97-.85-3.1-2.33-4.58.15-4.2 3.51-2.4.86.47 1.84 1.28 2.83 2.11.99.85 1.97 1.73 2.8 2.32 1.66 1.2 2.7 1.24 3.18 1.72a141.54 141.54 0 0 1 1.6 4.2c.3.72.89 2.32 1.55 4.17-.1.52-1.07.66-1.78 1.98-.7 1.3-1.26 3.66-2.12 4.8-1.27 1.66-2.42 2.65-3.32 2.49-.9-.16-1.54-1.48-1.78-4.38a5.08 5.08 0 0 0-1.48-3.03c-.58-.55-.71-.32-2.15-1.13a9.26 9.26 0 0 1-2.34-1.87c-.63-.7-.72-1.47-1.02-2.24-.29-.78-.77-1.54-.7-2.27.08-.74.35-1.45.85-2.05z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M392.49 219.74c.28.12.83.09.97.3-.16.7-.95.9-1.31 1.47-.18-.26-.81-.47-.7-.75.27-.38.7-.61 1.02-.94l.02-.08zm.98.23zm-1.8-2.98c.3-.07.75-.58.96-.36.49 1.03 1.05 2.17.84 3.34-.28-.14-.87-.06-.97-.33.05-.94-.43-1.83-.82-2.65zm4.2-3.07c-.2.23-.28.9-.58.84-1.03-.5-2.09-1.13-3.26-1.13-.5.06-.27.73-.2 1.06.17.64.45 1.24.75 1.83-.3.06-.75.58-.96.35-.48-1.04-1.1-2.2-.83-3.38.27-.89 1.35-1.02 2.13-.8 1.04.25 2.02.73 2.96 1.23zm2.92 2.16c-.25.18-.47.81-.74.7-.85-.7-1.68-1.42-2.65-1.96.2-.23.3-.85.57-.85 1.02.58 1.92 1.36 2.82 2.11zm2.77 2.3c-.24.2-.4.8-.67.77-.96-.71-1.84-1.52-2.75-2.29.25-.17.47-.81.74-.7.89.75 1.74 1.53 2.68 2.22zm3.35 1.94c-.23.18-.95.2-.87.49.06.09-.4-.24-.57-.27-.88-.34-1.73-.77-2.5-1.33.24-.2.4-.86.69-.76.86.66 1.9.97 2.85 1.47.16.1.31.23.4.4zm-.11-.17zm1.73 4.39c-.3.05-.77.34-.98.27-.5-1.38-1.03-2.75-1.57-4.1.3-.04.8-.51.98-.27.54 1.36 1.08 2.72 1.57 4.1zm0-.01zm0-.01c-.23.17-.97.2-.87.47-.04.11.69.37.17 0a62 62 0 0 1-.22-.23c-.1 0 .22.57-.07-.06.1.34.69-.15.99-.16.07.37-.27-.61.02.15-.09-.07-.75-.75-.32-.32a46.5 46.5 0 0 1 .2.2c-.46-.37-.3-.36-.07-.27l.17.22zm-.17-.22zm1.73 4.69c-.28.02-.92-.36-.98-.08 0 .29-.22-.58-.31-.76-.4-1.09-.8-2.18-1.22-3.26.31-.06.74-.4.97-.3.53 1.39 1.06 2.78 1.53 4.18l.01.22zm-.02-.28zm-1.81 2.4c-.22-.22-.9-.3-.83-.6.38-.73 1.08-1.25 1.67-1.73.28.13.9.04.97.3-.3.74-1.18.97-1.57 1.64-.09.12-.17.25-.24.39zm-2.16 4.86c-.2-.25-.82-.43-.74-.72.91-1.43 1.22-3.14 2.01-4.63.22.21.9.3.83.6-.77 1.55-1.1 3.32-2.1 4.75zm-3.81 2.68c.12-.3.02-.87.27-1 .9-.1 1.51-.9 2.1-1.52.26-.19.45-.8.73-.7.15.23.88.4.59.7-.84 1.01-1.73 2.18-3.07 2.52-.2.04-.42.04-.62 0zm-2.2-4.84c.31.03.81-.17 1.02-.02.14 1.23.21 2.57.95 3.6.31.22.5.34.32.76.03.45-.2.61-.57.33-1.06-.65-1.3-2-1.53-3.12-.09-.51-.14-1.04-.19-1.55zm-1.32-2.7c.26-.17.5-.76.77-.66a5.56 5.56 0 0 1 1.56 3.28c-.3-.04-.85.2-1.01 0a4.55 4.55 0 0 0-1.32-2.62zm-2.05-1.05c.22-.22.31-.9.6-.83.69.44 1.56.55 2.14 1.14-.26.16-.5.78-.78.66-.55-.4-1.25-.52-1.82-.9l-.14-.07zm-2.47-1.97c.27-.16.55-.66.8-.62a8.77 8.77 0 0 0 2.17 1.7c-.21.22-.31.85-.59.83a9.75 9.75 0 0 1-2.38-1.91zm-1.11-2.41c.3-.05.75-.42.97-.28.25.68.38 1.45.89 2-.27.15-.56.71-.82.6-.58-.65-.76-1.52-1.04-2.32zm-.73-2.5c.3.07.77.01 1 .15 0 .72.44 1.33.67 1.99-.3.06-.73.38-.97.3-.3-.79-.8-1.57-.7-2.44zm1 .1zm.35-1.59c.03-.22-.07-1.08.05-.9.07.3.5.65.18.92a3.28 3.28 0 0 0-.58 1.57c-.3-.09-.85.03-1-.18.1-.82.43-1.6.96-2.24l.39.83zm0-1.02c.3.04.9-.07 1.03.05-.22.16-.52.87-.7.67l-.33-.72zm0 0v1.02c-.04-.3-.64-.82-.16-.94l.16-.08zm0 1.02c-.3-.04-.91.07-1.04-.05.23-.15.52-.87.7-.67l.34.72z'/%3e%3cpath d='M406.51 226.13l.22.94a8.8 8.8 0 0 0-3.64 1.76c-1 .81-1.8 1.86-2.42 3.12.22-1.4.91-2.64 1.93-3.64a8.82 8.82 0 0 1 3.9-2.18h.01zM405.92 224.45l-.43-.93c-1.61-.14-3.17-.55-4.69-1.2a21.44 21.44 0 0 1-4.45-2.68 15.81 15.81 0 0 0 9.56 4.8h.01z' fill='%2321231e'/%3e%3cpath d='M391.36 213.8c1 .37 1.66.82 2.8 1.77a4.53 4.53 0 0 1 1.52 2.94c.17 1.2.03 2.55-.3 3.89-.2.83.05 2.25.54 3.64a10.03 10.03 0 0 0 1.95 3.5c2.45 2.45 4.16 5.04 3.48 6.65a3.31 3.31 0 0 1-1.48 1.8c-.3-.6-.99-1.14-1.22-2.16-.3-1.31-.8-2.67-1.57-3.49-.6-.63-.73-1.35-2.22-2.27-.96-.6-1.78-.35-2.44-1.15-1.27-1.56-2.93-5.38-1.3-7.12 1.6-1.72 2.17-2.69.82-5.65-.46-1-.45-1.74-.58-2.35z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M394.49 215.17l-.64.79a8.8 8.8 0 0 0-2.66-1.68l.35-.96a9.66 9.66 0 0 1 2.95 1.85zm1.7 3.27c-.33 0-.77.18-1.02.09a4.03 4.03 0 0 0-1.32-2.57l.64-.79c.98.8 1.53 2.03 1.7 3.27zm-.31 4.08l-.98-.25c.3-1.2.45-2.45.28-3.69.32 0 .77-.18 1.01-.09a11 11 0 0 1-.31 4.03zm-.98-.25zm1.5 3.6c-.31.07-.72.33-.97.29-.4-1.25-.79-2.58-.53-3.89.3.12.78.12.97.3-.16 1.12.2 2.25.53 3.3zm1.84 3.31c-.25.2-.5.61-.76.68a10.6 10.6 0 0 1-2.03-3.65c.31-.07.71-.33.97-.29a9.56 9.56 0 0 0 1.82 3.26zm3.58 7.2c-.28-.16-.75-.24-.9-.45.3-1-.28-2-.78-2.85a18.87 18.87 0 0 0-2.62-3.18c.25-.2.5-.61.76-.68 1.43 1.48 2.87 3.07 3.55 5.05.21.68.28 1.45 0 2.11zm-2.4 1.82c.25-.15.78-.32.85-.46-.17-.1-.92-.1-.5-.3.54-.33.9-.88 1.12-1.46.28.16.76.25.91.46a3.9 3.9 0 0 1-1.64 1.96l-.74-.2zm.74.2c-.3.27-.59.44-.68-.08-.18-.27.53.1.68.08zm-2-2.46c.32-.03.75-.25 1-.17.18.77.82 1.3 1.17 1.99-.3.11-.66.39-.93.4-.46-.71-1.07-1.35-1.24-2.22zm-1.44-3.25l.73-.7c.94 1.03 1.38 2.4 1.7 3.72-.32.04-.75.25-1 .18a7.3 7.3 0 0 0-1.43-3.2zm0 0zm-2.12-2.2l.53-.86a6.5 6.5 0 0 1 2.15 2.16c.36.23-.11.42-.27.63-.24.4-.45.15-.63-.14a5.26 5.26 0 0 0-1.78-1.79zm-2.56-1.25l.78-.65c.53.62 1.45.5 2.1.92.44.12-.1.5-.17.74-.1.43-.39.06-.64 0-.74-.22-1.58-.34-2.07-1.01zm-1.29-7.8l.74.7c-.79.92-.56 2.25-.26 3.31.34 1.13.86 2.21 1.6 3.14l-.8.65a9.86 9.86 0 0 1-2.08-5.32c-.04-.89.19-1.82.8-2.47zm.74-5.08c.3-.1.68-.4.94-.38.6 1.33 1.14 2.92.45 4.32-.34.7-.87 1.28-1.39 1.84l-.74-.7c.75-.78 1.61-1.74 1.43-2.91a7.53 7.53 0 0 0-.7-2.17zm-.12-3.07v1.02c.15-.1.45-.78.52-.5.1.73.19 1.46.51 2.12-.3.1-.68.4-.94.38-.36-.76-.46-1.6-.59-2.4l.5-.62zm-.5.62c-.08-.34-.28-.78.26-.62.51-.08-.18.41-.26.61zm.5.4v-1.02c.37.03-.02.6.02.86l-.02.16zm0-1.02z'/%3e%3cpath d='M434.07 226.22c-1.28 1.1-1.6.88-1.96 1.55-.45.84-.24 2.13.15 3.33 1.54 4.76-1.36 4.34-4.84 2.52-1.73-.9-3.75-3.22-5.33-4.38-1.57-1.16-2.68-1.15-3.11-1.63-.44-1.88-.8-3.52-.94-4.28-.18-.75-.53-2.43-.9-4.41.22-.59 1.3-.86 2.38-2.46 1.08-1.62 2.16-4.64 3.57-6.1 2.87-3.02 5.76-4.31 5.92 1.47.04 1.4.29 2.82 1.04 3.59.59.6.83.3 2.47 1.1a7.21 7.21 0 0 1 2.53 2c.62.8.5 1.73.63 2.64.13.9.53 1.76.18 2.64-.36.87-.95 1.7-1.79 2.42z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M432.56 228.01c-.22-.22-.97-.3-.8-.63.46-.7 1.36-.9 1.92-1.5.18.04.77.62.61.82-.48.47-1.13.74-1.64 1.17-.04.04-.06.1-.09.14zm.18 2.93c-.33 0-.95.57-1.03.08-.33-1.12-.59-2.4-.04-3.5.25.26 1.06.3.79.74-.24.89.03 1.83.28 2.68zm-5.55 3.13c.24-.24.28-1.1.7-.78 1.14.53 2.35 1.19 3.63 1.06.77-.15.7-1.11.6-1.7-.07-.47-.2-.93-.34-1.4.34 0 .98-.58 1.04-.04.33 1.15.7 2.56-.12 3.6-.9.93-2.33.57-3.4.2-.73-.26-1.43-.59-2.11-.94zm-5.4-4.42c.27-.17.43-.98.76-.7 1.75 1.35 3.17 3.11 5.1 4.22-.24.24-.29 1.1-.7.77-1.92-1.16-3.38-2.94-5.15-4.29zm.6-.82zm-3.9-1.1c.26-.17 1.17-.04.86-.46.74.44 1.63.61 2.36 1.1.25.21.94.39.48.74-.22.38-.44.69-.8.26-.8-.58-1.8-.73-2.62-1.26a.82.82 0 0 1-.28-.38zm.11.22zm-.56-4.1c.08-.27-.2-1.28.21-.85.47.25.34.86.5 1.3l.72 3.2c-.33-.03-1 .48-1.04-.02-.31-1.34-.62-2.7-.89-4.05l.5.41zm0-1.03c.49-.31.68.76.23.2l-.23-.2zm-.5.62c.3 0 .86-.35 1-.11.07-.22-.53-.73-.5-.37-.1.2.23 1.07-.2.8-.2.12-.36-.72-.3-.32zm.99-.23zm-1.86-4.47c.31.01 1.02.64.97.08.28 1.47.56 2.94.89 4.4-.31-.03-.9.4-1.02.07-.3-1.44-.63-2.9-.86-4.34l.02-.2zm-.02.27zm2.45-2.84c.2.27 1.04.42.69.79-.55.84-1.39 1.41-2.13 2.07-.26.12-.67-.24-.99-.29.38-.82 1.34-1.15 1.88-1.85.2-.23.38-.46.55-.72zm3.62-6.17c.16.3.93.57.57.89-1.43 1.76-2.12 3.97-3.35 5.85-.21-.26-1.02-.4-.71-.77 1.2-1.96 1.93-4.24 3.5-5.97zm6.8 1.82c-.33-.1-1.1.28-1.02-.25-.09-1.04-.12-2.21-.85-3.03-.7-.56-1.6.02-2.22.42-.73.5-1.37 1.11-1.98 1.75-.16-.3-.97-.6-.53-.9 1.1-1.08 2.3-2.27 3.89-2.52 1.1-.15 2.02.77 2.3 1.77.3.89.38 1.83.4 2.76zm.89 3.24c-.28.13-.58.9-.85.57-.85-1.05-1-2.47-1.05-3.78.32.1 1.08-.28 1.02.22.07 1.03.17 2.2.88 3zm0 0zm2.33 1c-.23.24-.25 1.06-.65.82-.76-.45-1.78-.41-2.4-1.1.3-.15.57-.89.88-.58.64.32 1.38.43 2.02.79l.15.07zm2.71 2.15c-.29.1-.64.77-.89.5a6.82 6.82 0 0 0-2.26-1.73c.23-.24.26-1.07.65-.8.96.5 1.84 1.18 2.5 2.03zm-.8.63c.35.44.5.63.06.07l-.04-.05-.01-.02zm1.53 2.24c-.3-.06-.96.36-1.02 0-.1-.76 0-1.6-.5-2.24.3-.11.7-.85.93-.45.54.8.48 1.78.59 2.69zm.15 2.91c-.27-.22-1.08-.18-.87-.63.13-.72-.19-1.42-.28-2.13.3.04.92-.33 1.02 0 .2.9.5 1.86.13 2.76zm-1.93 2.62c-.12-.3-.83-.64-.51-.9a5.8 5.8 0 0 0 1.5-2.1c.24.2 1.03.19.86.56a6.93 6.93 0 0 1-1.85 2.44z'/%3e%3cpath d='M417.9 222.59l-.07-.87c3.2-.88 5.7-2.72 7.72-5.43-1.14 2.9-4.2 5.28-7.65 6.3zM418.22 224.11l.3.83a16.3 16.3 0 0 1 9.18 3.14c-2.06-2.34-5.82-3.83-9.48-3.97z' fill='%2321231e'/%3e%3cpath d='M432.69 233.31c-1.09-.34-2.27-.69-3.36-1.53-1.67-1.29-1.18-3.78.24-6.35.46-.83.52-2.21.28-3.57-.24-1.36-.77-2.7-1.5-3.39-2.34-2.26-3.77-4.75-2.58-6.58.8-1.22 1.88-1.94 2.87-2.6.22.62.36 1.46.38 2.55.04 1.4.29 2.82 1.04 3.58.59.6.83.3 2.47 1.1a7.21 7.21 0 0 1 2.53 2c.62.8.49 1.74.63 2.64.13.9.53 1.76.17 2.64-.35.87-.94 1.7-1.78 2.42-1.28 1.1-1.6.89-1.96 1.55-.45.85-.24 2.13.15 3.34.3.91.43 1.64.42 2.2z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M429.01 232.18l.62-.8a9.51 9.51 0 0 0 3.2 1.44l-.3.97c-1.24-.37-2.49-.8-3.52-1.61zm.11-7l.89.5c-.7 1.32-1.41 2.81-1.19 4.36.1.52.38 1.01.8 1.33l-.61.81c-1.14-.84-1.43-2.4-1.15-3.71.2-1.17.7-2.27 1.26-3.3zm.22-3.23l1-.18c.2 1.29.28 2.7-.33 3.9l-.89-.5c.49-.99.38-2.17.22-3.22zm-1.34-3.11l.7-.74c.96.98 1.39 2.35 1.64 3.67l-1 .18a6.1 6.1 0 0 0-1.34-3.11zm0 0zm-2.66-7.24l.84.56c-.7 1.07-.2 2.4.4 3.39.58.95 1.33 1.78 2.12 2.55l-.7.74c-1.36-1.35-2.72-2.9-3.11-4.83-.16-.82-.01-1.7.45-2.4zm3.77-2.48l-.95.32c.16.13.94.17.62.36a8.53 8.53 0 0 0-2.6 2.36l-.84-.56c.74-1.16 1.88-2 3.01-2.74l.76.26zm-.76-.26c.3-.2.65-.58.68 0 .27.49-.42.02-.66 0h-.02zm1.17 2.96c-.32-.03-.78.1-1.01-.03-.03-.79-.1-1.59-.35-2.35l.96-.32c.29.87.37 1.79.4 2.7zm.89 3.24l-.72.72c-.97-1.05-1.12-2.57-1.18-3.93.32.03.78-.1 1.01.03.06 1.09.13 2.33.89 3.18zm2.33 1l-.44.92c-.68-.39-1.45-.51-2.15-.83-.2-.15-.66-.37-.26-.57.23-.11.44-.71.68-.37.57.3 1.25.38 1.83.7.11.04.23.1.34.16zm2.71 2.15l-.8.63a6.76 6.76 0 0 0-2.35-1.86l.44-.91c1.04.5 2 1.23 2.71 2.14zm-.8.63c.17.22.59.75.2.24l-.2-.24zm1.53 2.24l-1 .15c-.14-.8 0-1.7-.52-2.39l.8-.63c.66.81.6 1.9.72 2.87zm.14 2.91l-.93-.38c.3-.79-.12-1.6-.21-2.38l1-.15c.17.96.55 1.96.14 2.91zm-1.92 2.62l-.66-.78c.7-.6 1.3-1.36 1.65-2.22l.93.38a6.87 6.87 0 0 1-1.92 2.62zm-1.84 1.4l-.9-.48c.4-.78 1.33-.97 1.9-1.55.28-.34.46.3.69.45.35.25-.25.43-.4.62-.38.35-.96.48-1.27.92l-.02.04zm.18 2.94l-.96.31c-.36-1.19-.7-2.56-.11-3.73l.89.48c-.42.93-.09 2.01.18 2.94zm-.2 2.84l.29-.97c-.2.06-.7.7-.66.29a7.44 7.44 0 0 0-.39-1.85l.96-.31c.25.76.46 1.56.45 2.37l-.66.47zm.65-.47c-.04.29.14.89-.34.57-.61-.06.07-.33.27-.53l.05-.03.02-.01zm-.5-.01c-.17.51-.17.52 0 0zm.5 0c-.04.3.14.9-.34.58-.61-.06.07-.33.27-.53l.05-.03.02-.01z'/%3e%3cpath d='M410.55 216.45c4.03-.2 7.91 3.32 8.49 7.63.57 4.31-2.25 7.66-6.1 7.7-3.87.05-7.45-3.1-8.19-7.27-.74-4.16 1.77-7.86 5.8-8.06z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M419.54 224.02l-1 .13a8.48 8.48 0 0 0-6.37-7.06 6.48 6.48 0 0 0-1.6-.13c0-.34-.03-.68-.04-1.02 2.85-.13 5.57 1.46 7.22 3.72a9.5 9.5 0 0 1 1.79 4.36zm-6.6 8.28l-.01-1.02a5.59 5.59 0 0 0 4.8-2.75c.78-1.3 1-2.88.8-4.38l1.01-.13a7.48 7.48 0 0 1-2.11 6.5 6.62 6.62 0 0 1-4.49 1.78zm-8.69-7.7l1-.17c.55 3.18 3.04 6.03 6.25 6.7.47.1.95.15 1.43.15l.01 1.02c-2.97.04-5.77-1.74-7.33-4.22a9.61 9.61 0 0 1-1.36-3.47zm6.28-8.66l.05 1.02a5.52 5.52 0 0 0-4.57 2.75 6.92 6.92 0 0 0-.76 4.72l-1 .18a7.64 7.64 0 0 1 1.97-6.8 6.54 6.54 0 0 1 4.3-1.87z'/%3e%3cpath d='M410.89 218.57c2.94-.13 5.77 2.42 6.2 5.57.44 3.16-1.58 5.65-4.46 5.7-2.83.05-5.52-2.34-6.03-5.38-.54-3.1 1.35-5.76 4.29-5.89z' fill='%23edb92e'/%3e%3cpath fill='%2321231e' d='M417.59 224.07l-1 .14a6.06 6.06 0 0 0-4.7-5.07 4.87 4.87 0 0 0-.98-.07l-.05-1.01a6.56 6.56 0 0 1 5.5 2.91 7.1 7.1 0 0 1 1.23 3.1zm-4.95 6.28l-.02-1.02c1.39 0 2.75-.78 3.42-2 .55-.93.7-2.06.55-3.12l1-.14a5.7 5.7 0 0 1-1.43 4.78 5 5 0 0 1-3.52 1.5zm-6.55-5.8l1-.18a6.04 6.04 0 0 0 4.62 4.88c.3.05.6.08.91.08l.02 1.02a6.61 6.61 0 0 1-5.5-3.14 7.1 7.1 0 0 1-1.05-2.66zm4.77-6.5l.05 1.02a3.94 3.94 0 0 0-3.28 1.95c-.59 1-.74 2.22-.54 3.35l-1 .17a5.73 5.73 0 0 1 1.44-5.04c.88-.89 2.1-1.4 3.33-1.44z'/%3e%3cpath d='M411.22 220.72c1.84-.07 3.6 1.51 3.89 3.49.28 1.97-.99 3.57-2.8 3.6-1.8.04-3.5-1.46-3.81-3.4-.32-1.94.88-3.62 2.72-3.69z' fill='%230c4076'/%3e%3cpath fill='%2321231e' d='M415.6 224.13l-1 .15a3.63 3.63 0 0 0-2.8-3.01 2.89 2.89 0 0 0-.57-.05l-.04-1.01a4.33 4.33 0 0 1 3.63 1.96c.4.58.68 1.26.78 1.96zm-3.28 4.19l-.02-1.02c.86 0 1.69-.53 2.05-1.3.27-.53.33-1.14.25-1.72l1-.15a3.73 3.73 0 0 1-1.12 3.35c-.58.53-1.37.82-2.16.84zm-4.33-3.83l1-.17a3.58 3.58 0 0 0 2.81 2.94c.17.03.33.04.5.04l.02 1.02a4.34 4.34 0 0 1-3.64-2.06 4.69 4.69 0 0 1-.69-1.77zm2.72-3.77h1l-.48.5a2.3 2.3 0 0 0-1.99 1.27 2.96 2.96 0 0 0-.25 1.83l-1 .17a3.78 3.78 0 0 1 1.05-3.4 3.3 3.3 0 0 1 2.15-.88l-.48.5zm1 0v.49l-.48.01.49-.5zm0 0h-1l.48-.51.53.5zm-1 0v-.5l.48-.01-.48.5z'/%3e%3c/g%3e%3cg%3e%3cpath d='M482.14 182.98a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='white'/%3e%3cpath d='M489.47 189.85h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.34 7.34 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1.01a7.41 7.41 0 0 1-3.7 6.42c-1.1.63-2.36.96-3.63.96zm-7.33-7.38h1.02a6.38 6.38 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3e%3cpath d='M482.14 171.07a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='white'/%3e%3cpath d='M489.47 177.94h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1.01a7.41 7.41 0 0 1-3.7 6.42c-1.1.63-2.36.96-3.63.96zm-7.33-7.38h1.02a6.38 6.38 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3e%3cpath d='M482.14 159.61c3.77 0 6.82 3.08 6.82 6.87s-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='white'/%3e%3cpath d='M489.47 166.49h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.32 6.32 0 0 0 6.32-6.36h1.01a7.31 7.31 0 0 1-7.33 7.38zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3e%3cpath d='M482.14 127.08a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='white'/%3e%3cpath d='M489.47 133.95h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.33 7.33 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3e%3cpath d='M482.14 137.16a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='white'/%3e%3cpath d='M489.47 144.03h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.34 7.34 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.41 7.41 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3e%3cpath d='M482.14 148.16a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z' fill='white'/%3e%3cpath d='M489.47 155.03h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.33 7.33 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z' fill='%2321231e'/%3e%3cpath d='M486.99 195.51c.98 1.58.72 1.89 1.36 2.4.83.65 2.18.65 3.48.45 5.25-.83 4.52 2.35 2.2 5.93-1.16 1.78-3.86 3.58-5.26 5.12-1.4 1.53-1.53 2.8-2.08 3.19-2.02.05-3.75.06-4.54.04-.8.02-2.53 0-4.54-.04-.56-.38-.68-1.66-2.08-3.2-1.4-1.53-4.1-3.33-5.26-5.11-2.32-3.58-3.05-6.76 2.2-5.93 1.3.2 2.65.2 3.47-.46.65-.5.39-.81 1.37-2.39a7 7 0 0 1 2.22-2.3c.83-.51 1.72-.23 2.62-.23.9 0 1.78-.28 2.61.23a7 7 0 0 1 2.23 2.3z' fill='%23EDB92E'/%3e%3cpath fill='%2321231e' d='M488.66 197.51c-.26.16-.45.92-.75.7-.65-.61-.74-1.58-1.26-2.28-.16-.28.63-.6.8-.62.46.64.66 1.41 1.07 2.07l.14.13zm-.62.8zm3.71-.45c-.05.33.42 1.05-.1 1.05-1.21.15-2.59.18-3.61-.6.25-.18.43-.87.74-.71.89.52 2 .4 2.97.26zm2.7 6.71c-.22-.27-1.08-.4-.7-.8.71-1.2 1.54-2.47 1.53-3.91-.04-.91-1.1-1.12-1.84-1.11a9.2 9.2 0 0 0-1.53.12c.05-.34-.43-1.08.12-1.05 1.28-.15 2.85-.26 3.8.8.87 1.13.35 2.65-.18 3.82-.34.74-.76 1.45-1.2 2.13zm-5.31 5.19c-.17-.3-1-.58-.55-.9 1.62-1.66 3.66-2.92 5.01-4.85.2.26 1.02.4.72.74-1.42 1.96-3.53 3.26-5.18 5zm-2.44 3.36c-.11-.3.22-1.2-.3-.94.51-.68.78-1.6 1.33-2.28.23-.23.48-.87.77-.74.2.29.9.54.4.87-.74.8-1.05 1.88-1.68 2.77a.84.84 0 0 1-.52.32zm.27-.1zm-4.82.14c.1-.29-.2-.99.15-1.02 1.46.01 2.92 0 4.37-.04-.1.32.28 1.1-.23 1.02-1.42.04-2.9.05-4.3.04zm0-1.02zm0 0v.88c0-.29-.03-.6 0-.88zm-.02 0h.01zm-4.81.89c.08-.3.88-.85.3-.93 1.48.03 3.02.06 4.51.04-.08.3.22.98-.14 1.02-1.48 0-2.98.02-4.46-.07l-.21-.06zm.27.09zm-2.44-3.36c.31-.14.65-.95.93-.49.77.82 1.18 1.88 1.73 2.84.14.27-.38.61-.49.92-.74-.63-.9-1.68-1.5-2.43-.2-.3-.43-.58-.67-.84zm-5.3-5.19c.32-.09.77-.8.99-.35 1.42 1.88 3.46 3.14 5.06 4.85-.3.14-.63.93-.92.5-1.68-1.7-3.77-3-5.14-5zm2.69-6.7c-.15.3.08 1.14-.43.96-.94-.09-2.05-.26-2.83.39-.57.74-.13 1.75.17 2.53.34.8.78 1.54 1.24 2.26-.33.1-.8.84-1 .32-.83-1.4-1.77-2.91-1.67-4.6.06-1.17 1.2-1.92 2.29-1.97.74-.08 1.5 0 2.23.1zm3.1-.36c.1.3.86.72.42.94-1.1.68-2.46.6-3.68.42.16-.3-.07-1.1.4-.97.94.1 2.04.2 2.85-.39zm1.24-2.26c.19.24.95.35.77.68-.56.74-.63 1.8-1.4 2.38-.1-.3-.8-.66-.47-.93.4-.65.6-1.41 1.04-2.04 0-.04.05-.06.06-.1zm0 0zm2.39-2.47c.07.3.69.74.38.96a6.62 6.62 0 0 0-1.92 2.05c-.2-.26-1.04-.37-.73-.74a7.4 7.4 0 0 1 2.27-2.27zm2.88-.3c-.1.3.2 1.01-.18 1-.73 0-1.51-.23-2.17.17-.07-.31-.77-.8-.33-.98.83-.44 1.78-.21 2.68-.2zm2.88.3c-.25.2-.34 1-.7.78-.7-.29-1.46-.05-2.18-.07.09-.3-.2-.97.15-1.02.92-.05 1.9-.23 2.73.31zm0 0zm1.96 3.25c-.05-.24.12-1.35-.13-.78-.18.48-.36.63-.59.1a6.25 6.25 0 0 0-1.77-1.7c.24-.2.35-1 .7-.76.9.6 1.65 1.43 2.22 2.36l-.43.78zm.43-.78c.1.28.83.93.13.78-.68.15-.53-.19-.22-.62l.09-.16zm-.43-.24c-.08.24.17 1.06-.12.95-.6-.13.03-.62.12-.95zm-.43.78c-.1-.3-.83-.93-.13-.78.72-.16.47.24.19.67l-.04.06-.02.05z'/%3e%3cpath d='M481.35 212.77l-.88-.13a17.67 17.67 0 0 0-4.33-9.63c2.65 1.8 4.62 5.67 5.21 9.76z' fill='%2321231E'/%3e%3cpath d='M494.21 198.3c-.47 1.15-.96 2.4-1.98 3.46-1.54 1.61-4.1.57-6.57-1.51-.78-.66-2.16-.98-3.54-.97-1.37 0-2.74.33-3.5.97-2.47 2.08-5.03 3.12-6.57 1.51-1.02-1.06-1.51-2.31-1.98-3.46.6-.11 1.38-.1 2.38.06 1.3.2 2.66.2 3.49-.45.64-.51.38-.82 1.36-2.4a6.97 6.97 0 0 1 2.22-2.3c.83-.51 1.73-.23 2.62-.23.9 0 1.79-.28 2.62.23a7 7 0 0 1 2.22 2.3c.98 1.58.72 1.89 1.36 2.4.83.65 2.18.65 3.48.45 1-.16 1.8-.17 2.39-.06z' fill='%23EDB92E'/%3e%3cpath fill='%2321231e' d='M492.6 202.12l-.73-.7c.9-.93 1.4-2.13 1.88-3.3l.93.38a10.7 10.7 0 0 1-2.08 3.62zm-7.26-1.48l.65-.78c1.21.99 2.57 2 4.18 2.17.62.06 1.27-.15 1.7-.62l.73.71c-.9 1-2.39 1.14-3.6.72a11.24 11.24 0 0 1-3.66-2.2zm.64-.78l.4.33-.4-.33zm-3.85-.07v-1.02c1.34.02 2.78.23 3.85 1.09l-.64.78c-.9-.69-2.12-.83-3.21-.85zm-3.18.85l-.64-.78c1.07-.85 2.49-1.06 3.82-1.09v1.02c-1.1.02-2.29.17-3.18.85zm-7.26 1.48l.73-.7c.76.84 2.04.7 2.99.3a11.31 11.31 0 0 0 2.9-1.86l.64.78c-1.4 1.15-3 2.29-4.86 2.42a3.05 3.05 0 0 1-2.4-.94zm-1.7-4.32l.18 1c.14-.13.32-.9.44-.53a9.36 9.36 0 0 0 1.8 3.14c-.23.24-.48.47-.72.7a10.65 10.65 0 0 1-2.08-3.61l.38-.7zm-.38.7c-.13-.32-.4-.71.14-.65.49-.18-.1.42-.13.63l-.01.02zm2.93-.64l-.16 1a7.06 7.06 0 0 0-2.21-.05l-.18-1a8.11 8.11 0 0 1 2.55.05zm3.1-.35l.61.8c-1.1.83-2.58.74-3.87.56l.16-1.01c1.01.13 2.2.27 3.1-.35zm.61.8l-.15.12.15-.12zm.62-3.06l.86.54c-.46.64-.66 1.42-1.06 2.1-.16.18-.43.62-.59.2-.08-.24-.64-.51-.3-.71.36-.54.5-1.2.87-1.75l.22-.38zm2.4-2.47l.52.87a6.53 6.53 0 0 0-2.06 2.14l-.86-.54a7.5 7.5 0 0 1 2.4-2.47zm2.87-.3v1.01c-.77.02-1.63-.27-2.35.16l-.52-.87c.86-.57 1.91-.34 2.87-.3zm2.89.3l-.53.87c-.72-.43-1.58-.14-2.36-.16v-1.02c.97-.03 2.02-.26 2.89.3zm0 0zm2.39 2.47l-.86.54a6.53 6.53 0 0 0-2.06-2.14c.17-.3.35-.58.53-.87a7.52 7.52 0 0 1 2.39 2.47zm1.24 2.26l-.62.8c-.73-.54-.8-1.52-1.3-2.23-.38-.33.13-.46.38-.65.3-.36.43.03.58.3.35.52.46 1.18.84 1.68l.12.1zm-.62.8c-.39-.3-.38-.3 0 0zm3.71-.45l.16 1c-1.3.2-2.77.28-3.87-.55l.62-.8c.88.62 2.08.49 3.1.35zm2.93.64l-.93-.39c.03.2.6.8.17.66-.67-.07-1.35 0-2.01.1l-.16-1.01a8.1 8.1 0 0 1 2.56-.06l.37.7zm-.37-.7c.33.06.8.04.46.48-.11.5-.3-.3-.45-.46l-.01-.02zm-.1.5c.5.2.51.21.01 0zm.1-.5c.33.06.8.04.46.48-.11.5-.3-.3-.45-.46l-.01-.02z'/%3e%3cpath d='M482.14 211.65c4.27 0 7.73 3.49 7.73 7.79s-3.46 7.79-7.73 7.79c-4.27 0-7.73-3.49-7.73-7.79s3.46-7.79 7.73-7.79z' fill='%23EDB92E'/%3e%3cpath d='M482.94 212.77l.88-.13c.47-3.78 1.97-6.9 4.33-9.63-2.65 1.8-4.62 5.67-5.21 9.76z' fill='%2321231e'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 964.29 0)'/%3e%3cg%3e%3cpath stroke='%2321231e' stroke-width='1.01' fill='%23edb92e' d='M576.93 293.58c2 .3 3.06 1.57 3 2.86.06 1.3-1 2.56-3 2.86-.46.13-.97.22-1.53.27a1109.04 1109.04 0 0 1-186.51 0 8.72 8.72 0 0 1-1.53-.27c-2-.3-3.07-1.56-3-2.86-.07-1.3 1-2.56 3-2.86.45-.13.96-.22 1.53-.27a1109.17 1109.17 0 0 1 186.5 0 8.6 8.6 0 0 1 1.54.27z'/%3e%3cpath fill='%2321231e' d='M412.13 298.41c-.77-.03-.76-1.36 0-1.39.6.02 2.72-.21 3.92-.24 6.46-.38 12.93-.71 19.4-.98.66 2.12-2.21.98-3.43 1.36-3.7.17-7.39.35-11.08.56 4.85.26 9.7.5 14.56.7.56 2.14-2.08.8-3.25 1.07-6.7-.3-13.42-.65-20.12-1.08.07-.52-.04.05 0 0zm.04-.7zm46.62-2.63c.61 2.13-2.23.93-3.46 1.3-6.61.15-13.22.36-19.83.64-.66-2.12 2.21-.98 3.43-1.35 6.62-.26 13.24-.45 19.86-.59zm23.35-.22c.57 2.14-2.25.88-3.48 1.21-6.62.02-13.23.1-19.85.22-.61-2.12 2.24-.92 3.46-1.27 6.62-.11 13.25-.16 19.87-.16zm23.35.26c.52 2.15-2.27.83-3.5 1.14-6.62-.12-13.24-.18-19.85-.18-.58-2.14 2.25-.88 3.48-1.2 6.62.02 13.25.1 19.87.24zm23.34.74c.48 2.16-2.29.78-3.53 1.07-6.61-.26-13.23-.45-19.84-.6-.53-2.15 2.27-.83 3.5-1.13 6.63.16 13.25.38 19.87.66zm23.32 1.2c.35-.15.96.98.2 1.25-2.37.23-5.54.35-8.22.52-5.1.28-10.2.53-15.3.74-.67-2.1 2.2-.97 3.42-1.36 3.36-.15 6.72-.32 10.08-.5a1149 1149 0 0 0-13.56-.64c-.48-2.16 2.29-.78 3.53-1.06 6.62.3 13.24.65 19.85 1.06zm-.04.65zm-116.61.7c.78 0 .73 1.29-.05 1.22l.05-1.22zm93.33 1.16c-.78.07-.84-1.21-.06-1.2l.06 1.2zM482.37 265.18l-22.74 11.46-.45-.92 22.74-11.45h.45v.91zm-.45-.91l.22-.11.23.1h-.45zm22.74 12.37l-22.74-11.46.45-.91 22.74 11.45v.92h-.45zm.45-.92l.9.46-.9.46v-.92zm-23.2 11.46l22.75-11.46.45.92-22.74 11.45h-.45v-.91zm.46.91l-.23.11-.22-.11h.45zm-22.74-12.37l22.74 11.46-.45.91-22.74-11.46v-.9h.45zm-.45.91l-.9-.45.9-.46v.91z'/%3e%3cpath fill='%230c4076' d='M482.14 269.15c5.65 0 10.23 3.08 10.23 6.87 0 3.8-4.58 6.88-10.23 6.88s-10.23-3.08-10.23-6.88 4.58-6.87 10.23-6.87z'/%3e%3cpath fill='%2321231e' d='M492.88 276.02c-.4-.08-1.17.25-1.03-.4-.24-2.32-2.25-3.98-4.27-4.87-1.7-.75-3.58-1.09-5.44-1.1.1-.37-.28-1.22.4-1 3.3.09 6.8 1.17 8.99 3.77a5.75 5.75 0 0 1 1.35 3.6zm-10.74 7.38c.1-.37-.28-1.21.4-1.02 3-.1 6.2-1.04 8.2-3.4a4.71 4.71 0 0 0 1.13-2.96c.38.08 1.2-.26 1 .4-.21 2.64-2.37 4.65-4.66 5.7a14.4 14.4 0 0 1-6.07 1.28zm-10.74-7.38c.4.08 1.18-.25 1.03.4.25 2.32 2.25 3.98 4.27 4.87 1.7.75 3.58 1.1 5.44 1.1-.1.37.28 1.22-.39 1-3.3-.09-6.81-1.17-9-3.77a5.75 5.75 0 0 1-1.35-3.6zm10.74-7.38c-.1.37.28 1.21-.4 1.02-3 .1-6.2 1.04-8.2 3.4a4.71 4.71 0 0 0-1.13 2.96c-.38-.08-1.2.26-1-.4.21-2.64 2.37-4.65 4.66-5.7a14.42 14.42 0 0 1 6.07-1.28z'/%3e%3cpath fill='%23edb92e' d='M482.14 211.65c4.27 0 7.73 3.49 7.73 7.79s-3.46 7.79-7.73 7.79c-4.27 0-7.73-3.49-7.73-7.79s3.46-7.79 7.73-7.79z'/%3e%3cpath fill='%2321231e' d='M490.38 219.44h-1.01a7.3 7.3 0 0 0-4-6.5c-.99-.52-2.1-.78-3.23-.78v-1.02a8.25 8.25 0 0 1 8.24 8.3zm-8.24 8.3v-1.02a7.24 7.24 0 0 0 7.23-7.28h1.01a8.33 8.33 0 0 1-4.09 7.17 8.17 8.17 0 0 1-4.15 1.13zm-8.23-8.3h1a7.3 7.3 0 0 0 4 6.5c1 .52 2.11.78 3.23.78v1.02a8.25 8.25 0 0 1-8.23-8.3zm8.23-8.3v1.02a7.24 7.24 0 0 0-7.22 7.28h-1.01a8.34 8.34 0 0 1 3.9-7.06 8.19 8.19 0 0 1 4.33-1.24z'/%3e%3cpath fill='%23edb92e' d='M482.14 213.71a5.7 5.7 0 0 1 5.68 5.73c0 3.16-2.54 5.73-5.68 5.73s-5.68-2.57-5.68-5.73a5.7 5.7 0 0 1 5.68-5.73z'/%3e%3cpath fill='%2321231e' d='M488.33 219.44h-1.01a5.24 5.24 0 0 0-5.18-5.22v-1.02a6.2 6.2 0 0 1 6.19 6.24zm-6.19 6.24v-1.02a5.19 5.19 0 0 0 5.18-5.22h1.01a6.27 6.27 0 0 1-2.9 5.29c-.98.62-2.13.95-3.29.95zm-6.2-6.24h1.02a5.24 5.24 0 0 0 5.18 5.22v1.02a6.2 6.2 0 0 1-6.2-6.24zm6.2-6.24v1.02a5.19 5.19 0 0 0-5.18 5.22h-1.01a6.18 6.18 0 0 1 6.2-6.24z'/%3e%3cpath fill='%230c4076' d='M482.14 215.83a3.6 3.6 0 0 1 3.58 3.6c0 2-1.6 3.61-3.58 3.61a3.6 3.6 0 0 1-3.58-3.6c0-2 1.6-3.61 3.58-3.61z'/%3e%3cpath fill='%2321231e' d='M486.23 219.44h-1.01a3.1 3.1 0 0 0-3.08-3.1v-1.02a4.09 4.09 0 0 1 4.09 4.12zm-4.08 4.12v-1.02a3.08 3.08 0 0 0 3.07-3.1h1.01a4.14 4.14 0 0 1-4.08 4.12zm-4.09-4.12h1.01a3.1 3.1 0 0 0 3.08 3.1v1.02a4.09 4.09 0 0 1-4.09-4.12zm4.09-4.12v1.02a3.08 3.08 0 0 0-3.08 3.1h-1.01a4.14 4.14 0 0 1 4.09-4.12zM482.16 256.3c-43.82.22-67.8 2.12-101.63 5.29-2.02.19-3.09.9-3.5 1.21a3.4 3.4 0 0 0-1.22 3c.1.95 1.12 3.15 4.9 2.76 23.59-2.41 63.74-5.43 101.35-5.2 33.73.21 66.84 1.66 100.88 5.14 3 .3 4.78-.36 5.4-2.3.54-1.69-.43-3.15-1.9-3.86-2-.97-4.65-.95-8.4-1.28-31.18-2.76-67.33-4.9-95.88-4.76zm.12 1.09c28.75-.19 65.2 1.72 95.75 4.64 3.75.35 7.13.62 8 1.2 1.03.71 1.85 1.35 1.31 2.78-.33.9-1.04 1.8-4.28 1.46-33.25-3.55-67.8-4.95-100.9-5.13a951.23 951.23 0 0 0-101 5.13c-3.79.42-4.15-1.06-4.32-1.8-.2-.95.12-1.56 1.1-2.28.44-.32.76-.57 2.78-.77 30.67-3.07 57.72-4.94 101.56-5.23z'/%3e%3c/g%3e%3c/g%3e%3cpath d='M314.58 301.17v271.32c0 48.56 18.82 92.64 49.17 124.58s72.25 51.75 118.4 51.75c46.14 0 88.04-19.8 118.39-51.74 30.36-31.95 49.17-76.03 49.17-124.58V301.19H314.57z' fill='%23C6363C'/%3e%3cpath fill='white' d='M313.39 300c.2 94.24-.38 188.5.29 282.73 2.19 42.57 19.72 84.27 49.2 115.14 3.19-4.32-7.18-9.2-9.02-14.05-27.63-34.67-40.25-79.69-38.11-123.7V302.37h332.78c-.2 93.41.38 186.84-.29 280.25-2.85 67.34-47.2 132-111.11 155.15a158.13 158.13 0 0 1-55 9.88c1.15 5.44 12.2.64 17.23 1.43 63.88-6.28 119.6-53.78 140.58-113.74 11.26-28.96 11.56-60.35 10.95-90.95V300h-337.5z'/%3e%3cg stroke='%2321231e' stroke-width='.99' fill='white'%3e%3cpath d='M483.67 734.79c1.46-.24 3.91.07 5.77-1.4 2.47-1.94 1.49-9.78 1.27-14.74-1.14-25.36-2.18-68.04-3.47-127.97a16.7 16.7 0 0 0-5.1.07 16.68 16.68 0 0 0-5.08-.07c-1.3 59.93-2.33 102.62-3.47 127.97-.22 4.96-1.2 12.8 1.27 14.75 1.86 1.46 4.31 1.15 5.77 1.39h3.04z'/%3e%3cpath d='M499.55 734.06c-1.47-.1-3.89.42-5.87-.86-2.64-1.71-2.85-9.74-3.08-14.7-1.16-25.35-3.51-67.83-7.65-127.64 2.08-.48 3.62-.47 5.08-.38l.7-.16c9.52 59.16 13.12 101.14 19.64 126.46.9 3.5 2.84 12.25-.17 15.1-1.72 1.62-4.2 1.54-5.62 1.9l-3.03.28z'/%3e%3cpath d='M518.2 731.39c-1.48.03-3.84.77-5.93-.33-2.78-1.46-2.66-9.47-3.9-14.28-6.53-25.32-10.12-67.3-19.65-126.5 2.02-.66 3.56-.8 5.02-.84l.2-.07c15.16 57.54 19.7 98.1 31.46 123.15 1.09 3.47 4.05 12.7 1.22 15.9-1.57 1.78-4.04 1.92-5.43 2.42l-2.99.55z'/%3e%3cpath d='M536.98 726.08c-1.46.17-3.93 1.54-6.12.65-2.91-1.18-3.37-9.75-5.46-14.2-11.82-25.18-16.35-65.99-31.66-123.95a16.73 16.73 0 0 1 4.91-1.34c1.33-.6 1.08-.92 3.19-1.23 17.8 57.24 23.58 97.06 40.37 121.76 2.7 3.99 4.69 11.98 2.85 14.53-1.38 1.92-3.83 2.3-5.16 2.94l-2.92.84zM464.75 734.06c1.47-.1 3.89.42 5.87-.86 2.64-1.71 2.85-9.74 3.08-14.7 1.17-25.35 3.51-67.83 7.65-127.64a16.72 16.72 0 0 0-5.08-.38l-.7-.16c-9.52 59.16-13.12 101.14-19.64 126.46-.9 3.5-2.84 12.25.17 15.1 1.72 1.62 4.2 1.54 5.62 1.9l3.03.28z'/%3e%3cpath d='M446.09 731.39c1.47.03 3.84.77 5.93-.33 2.77-1.46 2.66-9.47 3.9-14.28 6.53-25.32 10.12-67.3 19.66-126.5-2.03-.66-3.57-.8-5.03-.84l-.2-.07c-15.16 57.54-19.7 98.1-31.46 123.15-1.08 3.47-4.05 12.7-1.21 15.9 1.56 1.78 4.03 1.92 5.42 2.42l2.99.55z'/%3e%3cpath d='M427.31 726.08c1.46.17 3.93 1.54 6.12.65 2.91-1.18 3.37-9.75 5.47-14.2 11.8-25.18 16.34-65.99 31.65-123.95a16.73 16.73 0 0 0-4.91-1.34c-1.33-.6-1.08-.92-3.19-1.23-17.8 57.24-23.58 97.06-40.36 121.76-2.71 3.99-4.7 11.98-2.86 14.53 1.38 1.92 3.83 2.3 5.16 2.94l2.92.84zM527.05 682.84c-1.34.08-3.36.9-5.46-.1-2.8-1.34-4.63-9.07-6.13-13.88-11.92-23.54-22.8-65.34-40.63-123.45 1.73-.73 3.1-.91 4.43-1.01 1.18-.52 2.45-.99 4.38-1.16 19.21 57.5 27.84 99.07 46.62 121.97 3.1 3.78 5.4 12.02 3.93 14.41-1.1 1.8-3.33 2.03-4.51 2.57l-2.63.65z'/%3e%3cpath d='M511.85 685.82c-1.34-.03-3.45.63-5.43-.54-2.63-1.55-3.56-9.4-4.5-14.3-4.8-25.05-13.66-67.1-26.24-126.12 1.8-.59 3.2-.66 4.53-.65 1.23-.42 2.55-.8 4.49-.81 14.87 58.66 18.3 102.58 32.37 125.13 2.57 4.1 4 12.4 2.26 14.66-1.3 1.7-3.56 1.75-4.79 2.2l-2.7.43z'/%3e%3cpath d='M496.38 687.58c-1.33-.13-3.5.35-5.34-.97-2.44-1.76-2.46-9.64-2.83-14.6-1.9-25.31-5.88-67.87-11.62-127.63 1.86-.44 3.26-.4 4.58-.3a13.5 13.5 0 0 1 4.57-.44c8.05 59.58 12.73 102.71 17.83 127.14 1.02 4.88 2.55 12.67.56 14.78-1.5 1.59-3.74 1.46-5.02 1.8l-2.73.22z'/%3e%3cpath d='M437.24 682.84c1.34.08 3.36.9 5.46-.1 2.8-1.34 4.63-9.07 6.13-13.88 11.92-23.54 22.8-65.34 40.63-123.45-1.73-.73-3.1-.91-4.43-1.01a13 13 0 0 0-4.38-1.16c-19.21 57.5-27.84 99.07-46.62 121.97-3.1 3.78-5.4 12.02-3.93 14.41 1.1 1.8 3.33 2.03 4.51 2.57l2.63.65z'/%3e%3cpath d='M452.44 685.82c1.34-.03 3.45.63 5.43-.54 2.63-1.55 3.56-9.4 4.5-14.3 4.8-25.05 13.66-67.1 26.24-126.12-1.8-.59-3.2-.66-4.53-.65a13.31 13.31 0 0 0-4.49-.81c-14.87 58.66-18.3 102.58-32.38 125.13-2.56 4.1-4 12.4-2.25 14.66 1.3 1.7 3.55 1.75 4.79 2.2l2.69.43z'/%3e%3cpath d='M467.92 687.58c1.33-.13 3.5.35 5.34-.97 2.44-1.76 2.46-9.64 2.84-14.6 1.9-25.31 5.87-67.87 11.61-127.63-1.86-.44-3.26-.4-4.58-.3a13.51 13.51 0 0 0-4.57-.44c-8.05 59.58-12.73 102.71-17.83 127.14-1.02 4.88-2.55 12.67-.56 14.78 1.5 1.59 3.74 1.46 5.02 1.8l2.73.22z'/%3e%3cpath d='M483.52 688.09c1.31-.24 3.53.07 5.2-1.4 2.23-1.93 1.35-9.78 1.15-14.74-1.03-25.36-1.96-68.04-3.13-127.98a13.6 13.6 0 0 0-4.6.07c-1.3-.21-2.68-.36-4.59-.07-1.16 59.94-2.1 102.62-3.12 127.98-.2 4.96-1.08 12.8 1.14 14.75 1.68 1.46 3.9 1.15 5.2 1.39h2.75z'/%3e%3cpath d='M516.54 647.97c-1.03.08-2.57.9-4.19-.1-2.14-1.34-3.54-9.07-4.69-13.88-9.12-23.54-17.45-65.34-31.12-123.45a8.18 8.18 0 0 1 3.4-1c.9-.53 1.87-1 3.35-1.17 14.72 57.5 21.33 99.07 35.7 121.97 2.38 3.78 4.15 12.02 3.02 14.41-.85 1.8-2.56 2.03-3.46 2.57l-2.01.65z'/%3e%3cpath d='M504.9 650.96c-1.03-.03-2.64.63-4.16-.54-2.01-1.55-2.72-9.4-3.44-14.3-3.68-25.05-10.47-67.1-20.1-126.12a8.1 8.1 0 0 1 3.46-.65 8.13 8.13 0 0 1 3.44-.81c11.4 58.66 14.03 102.58 24.8 125.13 1.97 4.1 3.06 12.4 1.73 14.66-1 1.7-2.72 1.75-3.67 2.2l-2.06.43z'/%3e%3cpath d='M493.05 652.72c-1.02-.14-2.68.35-4.09-.97-1.87-1.76-1.89-9.64-2.17-14.6-1.45-25.31-4.5-67.87-8.9-127.63 1.43-.44 2.5-.4 3.51-.3a8.06 8.06 0 0 1 3.5-.44c6.17 59.58 9.75 102.71 13.66 127.14.78 4.88 1.95 12.67.43 14.78-1.15 1.59-2.87 1.46-3.85 1.8l-2.09.22z'/%3e%3cpath d='M447.75 647.97c1.03.08 2.57.9 4.19-.1 2.14-1.34 3.54-9.07 4.69-13.88 9.12-23.54 17.45-65.34 31.12-123.45a8.18 8.18 0 0 0-3.4-1 8.25 8.25 0 0 0-3.35-1.17c-14.72 57.5-21.33 99.07-35.7 121.97-2.38 3.78-4.15 12.02-3.02 14.41.85 1.8 2.56 2.03 3.46 2.57l2.01.65z'/%3e%3cpath d='M459.39 650.96c1.03-.03 2.64.63 4.16-.54 2.01-1.55 2.72-9.4 3.44-14.3 3.68-25.05 10.47-67.1 20.1-126.12a8.09 8.09 0 0 0-3.46-.65 8.13 8.13 0 0 0-3.44-.81c-11.4 58.66-14.03 102.58-24.8 125.13-1.97 4.1-3.07 12.4-1.73 14.66 1 1.7 2.72 1.75 3.67 2.2l2.06.43z'/%3e%3cpath d='M471.25 652.72c1.02-.14 2.68.35 4.09-.97 1.87-1.76 1.89-9.64 2.17-14.6 1.46-25.31 4.5-67.87 8.9-127.63a8.05 8.05 0 0 0-3.51-.3 8.05 8.05 0 0 0-3.5-.44c-6.17 59.58-9.75 102.71-13.66 127.14-.78 4.88-1.95 12.67-.43 14.78 1.15 1.59 2.87 1.46 3.85 1.8l2.09.22z'/%3e%3cpath d='M483.2 653.23c1-.24 2.7.07 3.99-1.4 1.7-1.93 1.03-9.78.87-14.74-.78-25.36-1.5-68.04-2.4-127.98a8.02 8.02 0 0 0-3.51.08c-1-.22-2.06-.37-3.52-.08-.9 59.94-1.6 102.62-2.4 127.98-.15 4.96-.82 12.8.88 14.75 1.29 1.46 2.98 1.15 3.99 1.39h2.1z'/%3e%3cpath d='M474.88 559.13c-.08 4.25-.13 9.02-.16 13.91l-.05.02-10.59 2.2c-.02 4.83 11.92 55.43 18.07 55.43s18.08-50.63 18.06-55.46l-10.59-2.17-.05-.02c-.03-4.9-.08-9.66-.16-13.91-2.22 1.85-4.68 5.07-7.26 7.98-2.6-2.9-5.04-6.13-7.27-7.98z'/%3e%3c/g%3e%3cg id='c'%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M412.13 584.52c-3.2.14-7.13 1.97-18.6 11.94-5.02 10.24-10.06 20.53-17.03 29.41-2.37 1.57-4.23 2.67-6.12 3.3-1.96.64-16.43.16-16.79-.45-4.5-4.09-11.38-1.17-9.08 3.14-1.79 1.7 2.14 7.9 5.3 5.32 2.9-2.36 12.98-.13 16.34-1.35-1.27 3.03-10.38 5-16.75 5.47-5.82.25-5.44 6.06-3.04 10.52 2.73 1.74.5-.46 1.48.82 2.6 3.87 8.18 3.36 8.37-.42.2-3.92 13.79-9.01 15.83-12.02-2.5 5.95-8.24 11.5-11.1 17.31-3.06 3.09-4.93 3.7-.96 9.92 4.4-.5 4.65-1.68 7.36.89 6.01-.66 6.98-2.45 6.01-7.21-1.03-5.04 3.18-14.14 4.58-16.71 1.29-2.38 1.6-4.84 2.86-6.33 2.18-2.58 12.57-7.75 15.23-6.33 4.9 2.61 8.64 1.03 9.25-3.72-1.58-1.22-.4-7.97-3.78-8.25-2.77-.24-4.41.62-6.96 2.7-4 3.28-6.07 5.03-7.39 4.66-3.12-.86 5.67-5.18 13.66-15.68 11.08-14.55 11.84-21.95 11.33-26.93z' fill='%23EDB92E'/%3e%3cuse xlink:href='%23b' transform='matrix(-1 0 0 1 801.63 0)'/%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M345.18 634.54c-4.01-2.35-6.32-2.26-7.87-.5-.86.95-1.95.46-1.31-1.06 2.66-6.3 6.92-7.1 10.74-4.14 1.07 1 1.93 1.85 2.79 2.7-.64.94-3.83 2.27-4.35 3zM402.64 628.89c4.26-2.9 8.25-3.47 10.44-1.84 1.2.9 2.39.25 1.33-1.23-4.42-6.22-9.6-6.54-13.5-3.03-1.06 1.15-1.9 2.13-2.75 3.1 1.34 1.47 4.3 3.12 4.48 3zM369.09 664.55c.13-.26-.98-5.44-2.71-7.06-1.35 1.08-2.86 2.04-4.29 3.52-4.26 4.46-4.24 11.01 2.42 16.73 1.64 1.41 2.39-.07 1.72-1.7-1.13-2.77.25-6.32 2.86-11.5zM352.47 650.93c-3.96 1.64-5.32 3.73-5.18 6.46.08 1.5-.9 2.07-1.46.32-4.84-11.24.18-13.35 7.43-12.94.41 1.96-.62 6.09-.8 6.16h.01z' fill='%23EDB92E'/%3e%3cpath fill='%2321231e' d='M383.95 621.26l1.01.61c-.32.51-.34 1.18-.06 1.71a4.8 4.8 0 0 0 1.93 1.8l-.6 1.03a5.9 5.9 0 0 1-2.39-2.3 2.9 2.9 0 0 1 .11-2.85zm6.5.82l-.74.92c-.81-.65-1.6-1.34-2.5-1.85-.4-.2-.87-.43-1.31-.26-.43.2-.7.6-.94.98l-1.01-.6c.4-.66.93-1.31 1.69-1.54.7-.22 1.43 0 2.05.33.95.52 1.77 1.23 2.62 1.9l.15.12z'/%3e%3cpath fill='%2321231e' d='M387.33 617.58l1.01.61c-.32.51-.34 1.18-.06 1.71.41.8 1.17 1.35 1.93 1.8l-.6 1.03a5.9 5.9 0 0 1-2.39-2.3 2.9 2.9 0 0 1 .11-2.85zm6.5.82l-.74.92c-.81-.65-1.6-1.34-2.5-1.85-.4-.2-.87-.43-1.31-.26-.43.2-.7.6-.94.98l-1.01-.6c.4-.66.92-1.3 1.67-1.53.7-.23 1.46 0 2.08.33.97.53 1.8 1.25 2.67 1.94l.09.07z'/%3e%3cpath fill='%2321231e' d='M390.88 612.83l1.06.55c-.43.8-.4 1.8 0 2.61a6.08 6.08 0 0 0 2.1 2.26l-.68.98a6.8 6.8 0 0 1-2.68-3.17 4.07 4.07 0 0 1 .2-3.23zm7.14 1.1l-.82.87c-.89-.83-1.74-1.72-2.76-2.4-.38-.25-.84-.52-1.31-.4-.52.2-.81.71-1.08 1.16-.06.15-.12.28-.27.14l-.9-.47c.4-.75.89-1.52 1.68-1.89a2.3 2.3 0 0 1 1.99.14c.97.5 1.76 1.25 2.55 1.98l.92.87z'/%3e%3cpath fill='%2321231e' d='M394.82 607.72l1.07.52c-.49 1-.43 2.22.07 3.2.49 1 1.3 1.78 2.18 2.43l-.7.97a7.46 7.46 0 0 1-2.87-3.67 4.72 4.72 0 0 1 .25-3.45zm7.55 1.27l-.85.84c-.95-.95-1.86-1.95-2.95-2.74-.4-.26-.89-.57-1.39-.42-.53.22-.84.76-1.11 1.24-.08.08-.1.33-.22.31l-1.03-.5c.4-.82.91-1.68 1.76-2.1a2.3 2.3 0 0 1 2.09.14c1.03.55 1.86 1.4 2.69 2.2l1.01 1.03z'/%3e%3cpath fill='%2321231e' d='M399.15 602.61l1 .63a2.98 2.98 0 0 0-.37 2.48 7.24 7.24 0 0 0 2.23 3.13l.45.4-.76.9a9.51 9.51 0 0 1-2.94-3.75 4.19 4.19 0 0 1 .39-3.79zm7.53 1.43l-.87.8c-.88-.92-1.72-1.89-2.73-2.67-.42-.3-.93-.63-1.46-.46-.6.25-.99.82-1.35 1.34-.07.21-.19.19-.33.06l-.8-.5a4.84 4.84 0 0 1 1.94-1.95c.72-.34 1.57-.17 2.22.24 1.03.62 1.84 1.53 2.67 2.39l.7.75z'/%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M462.62 580.6l-9.49-5.38c-4 2.87-6.95 13.52-.12 22.22 8.5 10.84 11.94 18.7 14.02 27.48 6.2-7.93 8.32-16.27 4.39-24.4-5.3-10.98-8.75-17.17-8.8-19.92z' fill='white'/%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M470.37 573.01l-9.49-5.38c-4 2.87-12.33 13.18-5.51 21.88 8.5 10.84 17.33 19.05 19.41 27.82 6.2-7.93 8.83-16.27 4.9-24.4-5.3-10.98-9.26-17.17-9.31-19.92z' fill='white'/%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M449.43 569.16l-9.49-5.38c-4 2.87-6.95 13.52-.12 22.22 8.5 10.84 11.94 18.7 14.02 27.48 6.2-7.93 8.32-16.27 4.4-24.4-5.31-10.98-8.76-17.17-8.81-19.92z' fill='white'/%3e%3cpath d='M405.49 468.99c.18 8.68-1.36 66.56-1.84 74.74-.48 8.14-4.1 13.7-7.94 16.88-3.52-4.85-5.63-11.4-6.13-19.16-.26-3.96.47-58.73.78-70 6.48-17.15 11.29-17.8 15.13-2.46z' fill='white'/%3e%3cpath fill='%2321231e' d='M404.14 543.76c-1.71.36-.66-1.76-.86-2.77.8-23.27 1.45-46.54 1.72-69.82-.46-1.1.48-3.37.99-1.56-.15 21.32-.82 42.63-1.45 63.93-.12 3.4-.22 6.82-.4 10.22zm-8.84 17.14c1.2-.72-.38-.73 1.29-1.76 4.12-4.02 6.25-9.75 6.56-15.44 1.72-.36.65 1.74.7 2.74-.8 5.56-3.46 10.94-7.83 14.55l-.72-.09zm.72.1zm-6.94-19.52c1.6-.56.88 1.54 1.22 2.49.66 5.78 2.36 11.58 5.8 16.35-1.1 1.38-1.62-.98-2.29-1.71-3-5.2-4.34-11.19-4.73-17.13zm.8-70.2c1.64-.01.7 1.54.9 2.79-.37 22.16-.76 44.32-.74 66.48.16 1.88-1.66.54-1-.83.02-22.76.37-45.52.81-68.27l.04-.16zm-.03.17zm16.13-2.47c-1.6.63-1.1-1.41-1.68-2.46-.97-2.76-1.69-6.08-4.24-7.82-2.2-.75-3.66 1.74-4.73 3.25-1.89 3.03-3.23 6.36-4.52 9.69-1.8-.2.01-2.04.15-3.1 1.66-3.68 3.14-7.78 6.4-10.37 1.85-1.5 4.33-.12 5.27 1.75 1.7 2.76 2.56 5.95 3.35 9.06zm-.01-.1z'/%3e%3cpath d='M367.87 454.83l-2.46 79.58c-.77 7.06 8.42 49.08 13.45 57.36 12.43-5.31 15.06-33.82 12.72-61.59-2.34-27.77.39-51.76 2.29-56.75.16-6.28-.9-12.84-.96-19.38-7.92.47-17.12.3-25.04.78z' fill='white'/%3e%3cpath fill='%2321231e' d='M364.91 534.4l2.46-79.58c2-.2.46 2.96.86 4.28l-2.33 75.37-.99-.07zm1 .03zm12.74 56.89c.72 2.28-1.44-1.1-1.58-2.06-4.5-11.78-7.16-24.19-9.73-36.52-1.07-6.07-2.51-12.18-2.43-18.38 1.9-.1.5 2.75 1.12 4 1.78 14.12 5.06 28.04 8.94 41.72 1.22 3.88 2.34 7.85 4.3 11.44l-.62-.2zm.4.91zm12.02-62c1.94-.46.81 2.7 1.3 3.94.82 14.43.94 29.2-2.94 43.25-1.78 5.79-4.55 12.14-10.39 14.82-1.04-1.58 2.04-1.67 2.72-2.92 5.79-5.65 7.46-14.02 8.77-21.69 1.79-12.37 1.54-24.97.54-37.4zm2.3-56.81c2.04-.3-.2 2.5.07 3.68-2.58 15.62-2.63 31.57-1.79 47.34.12 1.9.26 3.8.41 5.7-1.93.46-.8-2.7-1.29-3.93-.99-16.22-.97-32.62 1.58-48.71.23-1.3.61-3.11 1.01-4.08zm.98.02zm-1.42-18.89c.03-2.28.78 1.04.54 1.94.23 5.65 1.02 11.29.88 16.95-1.75.4-.67-1.92-1-2.96-.14-5.48-.9-10.93-.94-16.42l.52.5zm-.05-1zm-24.52 1.3c-2.37-.3 1.6-.81 2.5-.66 7.34-.3 14.69-.2 22.02-.63.44 1.9-2.56.75-3.75 1.17-7.08.26-14.17.19-21.24.6l.47-.48zm-1-.03zm.5.01zm-.5-.01z'/%3e%3cpath d='M353.13 467.85l1.69 79.6c-.4 7.1 10.96 48.54 16.4 56.54 12.62-9.78 10.08-49.8 8.15-61.91-3.85-24.13-3.2-52.08-1.87-56.62-.16-6.29-.32-13.8-.72-20.34l-23.65 2.73z' fill='white'/%3e%3cpath fill='%2321231e' d='M354.32 547.47l-1.69-79.6c2-.3.62 2.96 1.09 4.27l1.6 75.35-1-.02zm1-.02zm15.6 56.16c1.16 2.08-1.5-.97-1.6-2.03-5.18-11.7-8.52-24.13-11.75-36.49-1.34-5.82-3.03-11.66-3.25-17.66 1.9-.2.65 2.72 1.33 3.95 2.52 14.03 6.52 27.76 11.12 41.24 1.42 3.78 2.73 7.65 4.87 11.1l-.72-.11zm.61.78zm7.35-62.23c1.9-.59.98 2.68 1.52 3.87 1.41 14.25 1.82 28.83-1.07 42.93-1.3 5.62-3.2 11.62-7.8 15.44-1.41-1.3 1.64-2.18 2-3.58 4.88-7.28 5.82-16.33 6.6-24.84.71-11.27.33-22.64-1.25-33.82zM377 485.48c1.95-.45.16 2.24.48 3.35-1.13 15.63-.34 31.36 1.49 46.9.26 2.1.56 4.19.89 6.28-1.9.6-1-2.65-1.57-3.83-2.1-16.23-2.93-32.68-1.84-49.02.08-1.12.35-3.11.55-3.68zm1-.03zm-1.17-19.83c-.08-2.3.85 1.06.58 1.97.3 5.95.43 11.9.59 17.86-1.76.48-.76-1.96-1.07-3-.15-5.77-.3-11.53-.65-17.29l.55.46zm-.11-.99zm-23.6 3.72c-.5-1.88 2.32-.87 3.48-1.4l20.12-2.31c.56 1.86-2.44.9-3.58 1.41l-20.01 2.3zm.07 0zm-.06-1zm-.5.52z'/%3e%3cpath d='M342.19 486.7l20.91-.53c-1.78 8.68-.35 35.65 3.25 56.21 3.39 19.28 8.11 69.27-11.96 81.28-12.44-26.38-2.97-52.02-9.24-74.92-4.9-24.35-5.86-44.68-2.96-62.04z' fill='white'/%3e%3cpath fill='%2321231e' d='M363.12 486.66l-20.91.53c-.3-2 2.93-.63 4.23-1.1l16.65-.42c.39.5.77.55.03.99zm-.03-1zm3.76 56.63c-1.89.65-1.04-2.6-1.63-3.76-2.29-15.57-3.8-31.33-3.21-47.08.11-1.8.26-3.61.61-5.39 1.9.06.16 2.63.49 3.9-.82 14.52.55 29.07 2.37 43.46.4 2.97.85 5.93 1.37 8.87zm-12.9 81.58c.67-.58 1.03-1.43 2.82-2.59 6.99-6.34 9.4-16.03 10.84-25.02 2.42-17.32 1.17-34.96-1.47-52.19-.8-2.82 1.52-1.46 1.12.68 2.6 17.53 3.82 35.49 1.12 53.08-1.62 9.1-4.39 18.92-11.87 24.98-.84.37-1.6 1.65-2.56 1.06zm.7.21zm-9.98-75.25c1.88-.83 1.22 2.5 1.87 3.61 3.48 18.27-.6 37.09 3.2 55.33a67.5 67.5 0 0 0 5.1 15.67c-1.66 1.1-1.7-2.35-2.53-3.38-5.9-14.45-5.48-30.33-5.24-45.65.06-8.57-.13-17.26-2.4-25.58zm0 .04zm-2.49-62.67c.52.9.38 1.83.01 3.85-2.6 19.54-.36 39.36 3.46 58.59-1.88.68-1.1-2.6-1.74-3.76-3.54-19.15-5.37-38.93-2.2-58.27l.47-.41zm-.47.41zm.49.09zm-.5-.09z'/%3e%3cpath d='M422.15 454.38c-.08 8.68-3.37 66.48-4.1 74.64-.73 8.13-4.5 13.56-8.45 16.62-3.38-4.96-5.28-11.57-5.55-19.34-.13-3.97 2.25-58.7 2.9-69.94 7-16.94 11.82-17.44 15.2-1.98z' fill='white'/%3e%3cpath fill='%2321231e' d='M418.54 529.07c-1.72.3-.6-1.78-.78-2.8 1.51-23.23 2.87-46.47 3.84-69.72-.42-1.13.58-3.36 1.03-1.53-.8 21.44-2.12 42.86-3.4 64.27-.22 3.26-.42 6.52-.69 9.78zm-9.35 16.85c1.22-.68-.37-.74 1.33-1.72 4.25-3.89 6.56-9.55 7.03-15.22 1.73-.3.6 1.76.63 2.76-.98 5.52-3.8 10.83-8.28 14.3l-.71-.12zm.71.11zm-6.35-19.72c1.62-.57.85 1.4 1.13 2.32.47 5.87 2 11.8 5.33 16.73-1.16 1.35-1.6-1.02-2.24-1.78-2.85-5.28-4-11.32-4.22-17.27zm2.94-70.14c1.64.04.65 1.56.81 2.82-1.05 22.06-2.1 44.13-2.75 66.21.39 1.86-1.7 1.1-.99-.44.71-22.81 1.76-45.62 2.89-68.42l.04-.17zm-.04.17zm16.2-1.95c-1.63.57-1.07-1.45-1.61-2.52-.89-2.8-1.5-6.12-4-7.95-2.17-.82-3.72 1.62-4.83 3.1-1.98 2.97-3.42 6.25-4.8 9.54-1.8-.27.07-2.04.24-3.09 1.76-3.63 3.37-7.68 6.7-10.16 1.9-1.45 4.34.02 5.22 1.91 1.6 2.81 2.38 6.03 3.08 9.17zm-.02-.11zm-.48.1zm.48-.1z'/%3e%3cpath d='M384.99 407.23c-.56 18.65-.87 59.1-.76 62.55.27 7.77 3.33 17.67 6.71 22.63 3.94-3.06 7.72-8.5 8.45-16.62.6-6.68.8-39.48.9-55.92a70.63 70.63 0 0 1-12.07-9.72s-3.1-2.76-3.23-2.92z' fill='white'/%3e%3cpath fill='%2321231e' d='M384.72 469.76c-1.49.52-.9-1.15-1.02-2.05.06-20.17.27-40.34.79-60.5 1.53-.42.82 1.27.93 2.2-.46 20.03-.71 40.07-.7 60.1v.25zm5.9 22.25c1.3 1.26-.56.7-.74-.33-3.54-6.28-5.45-13.41-6.08-20.56-.71-1.16 1.03-2.11.95-.65a50.6 50.6 0 0 0 5.76 20.33c.1.54 1.63 1.74.12 1.21zm.62.8zm7.64-17.06c1.53-.34.78 1.23.74 2.13-.88 5.75-3.73 11.32-8.38 14.92-1.28-.88.38-1.4.94-2.14 4.05-3.88 6.23-9.38 6.7-14.91zm1.14-55.46c.8-1.78.85.5.76 1.35-.16 17.33-.13 34.67-.76 52-.22.82.41 2.7-1.03 2.12-.15-1.14.13-2.69.11-3.99.54-17.3.55-34.6.7-51.9l.22.42zm.54-.84zm-12.35-9.8c-.17 1.94.32-.77 1.14.94a71.3 71.3 0 0 0 11.2 8.86c-.4 1.52-1.46.1-2.27-.32a69.35 69.35 0 0 1-10.43-8.63l.36-.85zm-.36.85c-1.9-.95 1.09-1.4.01-.03v.03zm-2.37-3.26c-1.67.34-.24-.8.29.05l2.75 2.47c-.52 1.95-.09-1.14-.68.73-1.08-.98-2.2-1.93-3.25-2.95l.89-.3zm-1-.03c-.65-2.06 1.4-.63.39-.12l-.38.12z'/%3e%3cpath d='M399.93 419.25c-.37 20.09-.15 51.74-.07 54.3.27 7.78 2.18 14.4 5.55 19.35 3.95-3.06 8.1-8.68 8.84-16.8.44-5 1.83-26.46 1.96-42.92-5.3-1.67-11.99-10.37-16.28-13.93z' fill='white'/%3e%3cpath fill='%2321231e' d='M400.36 473.54c-1.2.42-1.05-.58-1.02-1.43-.16-17.63-.19-35.25.1-52.87 1.4-.43.9.99.96 1.87-.24 17.48-.24 34.96-.04 52.43zm4.75 18.97c1.27 1.14-.43.82-.67-.2-3.47-5.6-4.84-12.23-5.07-18.74 1.33-.48.98.84 1.08 1.7.41 6.09 1.92 12.25 5.37 17.35l-.71-.11zm.6.78zm8.04-17.24c1.43-.33.85 1.03.76 1.91a24.17 24.17 0 0 1-8.8 15.33c-1.09-.75-.04-1.22.6-1.8a23.62 23.62 0 0 0 7.44-15.44zm2.31-42.4c.23-1.71.89-.15.64.77-.22 13.92-.9 27.83-1.96 41.71-1.38.32-.88-.95-.85-1.82.98-13.7 1.67-27.41 1.83-41.14l.34.48zm.3-.95zm-15.93-13.44c-1.78.28-.09-.88.47.17 4.61 4.15 8.4 9.31 13.79 12.53.57.53 2.18.41 1.44 1.48-.54.38-1.66-.56-2.34-.84-5.48-3.44-9.34-8.78-14.18-12.97l.82-.37zm-1-.02c-.62-1.72 1.61-.31.11-.05l-.1.05z'/%3e%3cpath d='M387.08 405.55l-14.24-20.52c-2.88 10.12-6.39 82.77-2.27 88.72a36.53 36.53 0 0 0 6.45 19.32c3.94-3.06 9.82-8.56 8.13-16.78-1.7-8.23.2-62.26 1.93-70.73z' fill='white'/%3e%3cpath fill='%2321231e' d='M373.25 384.74l14.24 20.53c-1.24 1.4-1.74-1.31-2.6-2l-12.46-17.96c-.31-.72.42-.38.82-.57zm-.89.15zm-1.29 88.84c-1.41.69-1.25-.68-1.7-1.95-1.39-8.26-1.12-16.68-1.15-25.02.27-18.27 1.03-36.56 2.97-54.73.3-2.4.58-4.8 1.17-7.14 1.78.02.25 1.97.4 3.04-1.9 13.6-2.48 27.34-3.1 41.04-.4 12.95-.91 25.95.13 38.89.23 1.99.41 4.04 1.28 5.87zm-.09-.26zm5.74 19.2c1.32 1.71-1.03.02-1.17-.97a36.76 36.76 0 0 1-5.47-17.93c1.64-.53.82 1.58 1.18 2.53.63 5.9 2.84 11.6 6.17 16.48l-.71-.11zm.6.79zm7.34-17.07c1.6-.82 1.08 1.6 1.28 2.56.16 6.03-4.03 11.08-8.61 14.5-1.37-.98.68-1.53 1.26-2.32 4.26-3.6 7.4-9 6.07-14.74zm2.42-70.34c.08-2.2.7.77.17 1.61-1.45 14.27-1.8 28.62-2.16 42.95-.05 8.38-.42 16.8.47 25.15-.64 1.7-1.37-.65-1.2-1.7-.75-12.66-.23-25.34.14-38 .45-10.04.7-20.12 2-30.1.03-.93.2-.26.58.1zm0-1zm0 0zm0 1z'/%3e%3cpath d='M357.88 451.24c-.65 11.24-1.1 18.85-.97 22.81.27 7.78 2.18 14.39 5.55 19.35 3.95-3.06 8.96-8.48 8.45-16.62-2-31.46 1.45-61.09 5.45-89.57-3.38-2.48-9.07-5.16-12.45-7.64-6.75 38.36-9 62.16-6.03 71.67z' fill='white'/%3e%3cpath fill='%2321231e' d='M357.41 474.03c-1.72.6-.79-1.64-1.01-2.58.14-6.76.62-13.5.98-20.24 1.82-.36.58 2 .82 3.05-.33 6.59-.87 13.18-.79 19.77zm4.75 18.97c1.33 1.73-1.06 0-1.15-1-3.12-5.43-4.37-11.73-4.6-17.93 1.67-.55.83 1.6 1.16 2.56.5 5.79 2.02 11.63 5.3 16.48l-.71-.11zm.6.79zm7.65-16.98c1.7-.6.85 1.71.96 2.68-.44 5.8-4.08 10.86-8.6 14.3-1.4-1 .71-1.55 1.26-2.37 4.1-3.68 6.84-9 6.38-14.61zm5.66-89.2c1.23-1.94.54 1.41.43 2.21-4.05 28.76-6.98 57.86-5.1 86.92-1.8.57-.79-2.07-1.17-3.12-1.55-28.94 1.57-57.87 5.64-86.49l.2.47zm.59-.81zm-12.26-7.15c-2.13-.56 1-.36 1.51.67 3.53 2.24 7.34 4.04 10.75 6.48-.67 1.7-2-.56-3.06-.83-3.3-2.03-6.82-3.74-9.98-6l.78-.32zm-.98-.17zm-5.9 71.4c1.43 1.69-1.04-.28-.62-1.5-1.59-9.29-.52-18.77.32-28.1 1.5-14 3.78-27.92 6.2-41.8 1.91-.1.26 2.28.42 3.4-2.97 17.72-6 35.5-6.71 53.48-.07 4.92-.14 9.95 1.22 14.73l-.82-.2zm.71.7zm0 0zm-.7-.7z'/%3e%3cpath d='M343.64 471.82l3.86 14.63c.27 7.78 5.07 14.2 8.45 19.16 3.94-3.06 7.52-8.1 6.51-16.18-5.78-46.47-3.71-77.2 6.03-115.07-22.03 15.04-32.25 46.78-24.85 97.46z' fill='white'/%3e%3cpath fill='%2321231e' d='M347.02 486.58l-3.86-14.63c1.83-.77 1.27 2.57 2 3.7.94 3.6 1.92 7.18 2.84 10.79l-.98.14zm.96-.25zm7.66 18.89c1.26 1.86-1.17-.34-1.42-1.26-3.61-5.2-7-11-7.22-17.49 1.83-.43.77 2.32 1.42 3.43 1.2 5.76 4.65 10.67 7.94 15.43l-.72-.11zm.61.78zm5.72-16.51c1.86-.58.9 2.39 1.14 3.53a17 17 0 0 1-6.86 12.98c-1.42-1.25 1.5-2 2-3.23 3.23-3.56 4.38-8.59 3.72-13.28zm6.8-114.72c-.54-2.06.49 1.56-.53 2.62-6 23.5-9.08 47.77-8.41 72.03.3 13.36 1.49 26.69 3.12 39.94-1.92.52-.9-2.71-1.47-3.93-3.31-27.64-4.08-55.8.6-83.34a318.5 318.5 0 0 1 5.93-27.86l.77.54zm-.56-.82zm-24.09 97.74c-1.88.88-.91-2.5-1.49-3.58-2.6-20.5-3.22-41.8 2.87-61.76 3.93-12.8 11.49-24.83 22.71-32.4 1.36 1.42-1.8 2-2.51 3.11-12.5 9.87-19.23 25.28-21.95 40.64-3.22 17.81-2.15 36.25.37 54zm-.96.26zm.48-.13zm-.48.13z'/%3e%3cpath d='M344.77 486.22l-20.22-6.72c-2.58 20.22 1.38 45.62 6.83 79.12 4.67 28.76 2.21 51.52-1.36 66.12 21.57-2.96 30.7-30.77 19.88-83.1a234.62 234.62 0 0 1-5.13-55.42z' fill='white'/%3e%3cpath fill='%2321231e' d='M324.71 479.03l20.22 6.72c-.43 2.01-3.14-.5-4.58-.48l-15.95-5.3c-.6-.66-.25-.54.31-.94zm-.65.4zm7.81 79.1c-1.96.57-1.02-2.88-1.67-4.13-3.3-21.25-7.2-42.58-6.91-64.16.08-3.61.32-7.22.77-10.8 2.02-.03.2 2.93.56 4.26-1.44 20.22 1.95 40.37 4.92 60.31.76 4.85 1.55 9.69 2.33 14.53zm-1.91 65.71c-.27 2.38-.26-2.1.36-3.03 4.3-20.54 3.9-41.86.57-62.51 1.94-.6 1.02 2.78 1.61 4 2.89 20.61 2.86 41.84-2 62.16l-.54-.62zm.13 1zm19.33-83.5c1.96-.62 1.12 2.98 1.84 4.22 3.18 17.46 5.42 35.58 1.97 53.18-1.97 9.49-6.59 19.5-15.76 23.9a25.32 25.32 0 0 1-7.38 2.2c-.54-1.95 2.82-1.01 3.97-1.92 9.15-2.75 14.81-11.59 17.18-20.39 4.2-15.36 2.87-31.57.7-47.14-.72-4.7-1.57-9.38-2.52-14.04zm-4.8-55.05c.92-2.26.57 2.35.6 3.29a234.43 234.43 0 0 0 5.17 51.56c-1.87.7-1.11-2.61-1.77-3.75a235.03 235.03 0 0 1-4.34-51.58l.17.24.17.24zm.31-.94z'/%3e%3cpath fill='%2321231e' d='M343.56 584.05c.43 0 1.63-.12.95.49-.38.31-.98 0-.95-.49zm-4.3-40.2c1.48-.85 1.32.82 1.57 1.83 2.5 12.64 4.32 25.5 3.91 38.41-1.67.48-1.07-1.16-1.13-2.21.14-12.8-1.8-25.53-4.35-38.03zm-5.41-50.21c1.63-.55 1.12 1.08 1.2 2.13.22 16.07 2.1 32.1 5.37 47.84-1.51.86-1.32-.87-1.6-1.89a251.66 251.66 0 0 1-4.97-48.08zm1.18-.01c-.44.01-1.63.18-.97-.45.37-.33.98-.04.97.45z'/%3e%3cpath d='M343.96 367.25l13.27 2.23c-.65 2.85-4.02 20.32-4.63 23.3-4.96 24.27-8.24 52.87-4.48 84.25 1.39 11.64 3.86 21.16 7.48 28.51-14.56-1.65-23.9-15.87-22.69-40.67-2.53-28.96-1.41-51.99 3.27-69.3 1.38-5.08 5.8-24.22 7.78-28.32z' fill='white'/%3e%3cpath fill='%2321231e' d='M357.15 369.98l-13.27-2.23c.08-2.02 3-.06 4.36-.28l9.07 1.53c.45.58.54.6-.16.98zm.16-.98zm-4.22 23.88c-1.88.02-.22-2.32-.32-3.48 1.32-6.68 2.58-13.36 3.98-20.02 1.86 0 .2 2.28.3 3.44-1.35 6.68-2.63 13.38-3.96 20.06zm-4.48 84.1c-1.92.5-.9-2.72-1.43-3.96-2.76-26.82-.5-53.98 4.93-80.34 2 .1.02 2.84.2 4.16-5.13 26.34-6.93 53.44-3.7 80.13zm6.93 29.07c.3-.88-1.26-.69-1.6-2.95-3.5-8.26-5.23-17.14-6.32-26 1.93-.52.92 2.71 1.53 3.92 1.26 8.34 3.19 16.69 6.9 24.31l-.5.72zm.5-.72zm-23.62-40.4c2-.57.47 2.54.9 3.68-.02 10.42 1.68 21.76 8.95 29.75a21.38 21.38 0 0 0 13.38 6.7c.05 2.02-2.88.18-4.15.17-8.95-2.5-14.83-10.9-17.1-19.55-1.9-6.72-2.3-13.86-1.98-20.76zm.99-.1zm2.3-69.4c1.95.23-.12 2.78 0 4.12-4.73 21.41-4.08 43.57-2.3 65.29-1.95.45-.81-2.79-1.33-4.03-1.54-21.77-1.91-44.1 3.63-65.37zm8.33-28.66c.3 1 .05 1.58-.64 3.37-2.62 8.42-4.5 17.04-6.74 25.56-1.92-.16.05-2.59-.04-3.83 2.2-8.3 3.84-16.79 6.9-24.83.17-.1.35-.18.52-.27zm-.53.27zm.45.22zm-.45-.22z'/%3e%3cpath d='M335.92 370.39l6.52 7.44c-1.85 1.32 1.28 7.03-.4 18.1-1.1 6.3-4.84 13.7-5.61 21.73-2.57 26.6-2.58 59.9 5.42 81.19-14.56-1.65-19.56-14.85-20.03-39.68-.4-20.52-.46-44.72 4.69-72.66 1.04-6.53 4.18-11.74 9.41-16.12z' fill='white'/%3e%3cpath fill='%2321231e' d='M342.06 378.16l-6.52-7.44c1.27-1.5 2.23 1.64 3.35 2.31 1.22 1.6 3 3.03 3.89 4.74.05.72-.23.4-.72.39zm.75-.66zm-.29 18.52c-1.96.11-.26-2.44-.59-3.63.5-4.48-.44-8.94-.57-13.4-.23-1.34 1.62-2 1.13-.46-.44 3.16.67 6.36.54 9.56a45 45 0 0 1-.5 7.93zm0-.01zm-5.6 21.7c-1.96.13-.32-2.63-.42-3.86 1.17-6.14 3.86-11.86 5.04-18 1.85-.1.3 2.16.29 3.24-1.71 6.19-4.3 12.18-4.9 18.62zm4.87 81.63c.23-.9-1.1-.66-1.3-2.86-5.26-16.46-6.12-33.93-6.07-51.1.1-9.26.63-18.53 1.51-27.76 1.95-.13.36 2.65.65 3.91-1.65 20.8-2.02 41.9 1.75 62.5a91.4 91.4 0 0 0 3.98 14.64l-.52.67zm.52-.67zm-21-39.49c1.93-.35.67 2.63 1.12 3.85.51 9.18 1.17 18.87 5.94 26.98 2.8 4.8 8.03 7.87 13.53 8.35.14 1.89-2.4.37-3.55.33-6.86-1.62-11.6-7.7-13.62-14.18-2.71-8.14-3.18-16.82-3.41-25.33zm4.7-72.75c1.97-.12.22 2.39.39 3.55-4 22.82-4.64 46.07-4.09 69.18-1.91.37-.65-2.56-1.06-3.76-.46-23.06.52-46.3 4.77-68.97zm.99.16zm9.3-16.53c-.66.8-.26 1.18-1.9 2.37a24.78 24.78 0 0 0-7.4 14.16c-1.83.12-.36-2.1-.33-3.18 1.42-5.29 4.73-9.94 8.93-13.4l.7.05zm-.7-.05z'/%3e%3cpath d='M372.29 389.97l-13.44-1.57c-2.46 12.7-4.35 21.69-4.81 26.21-.9 8.88 1.8 17.02 4.87 23.08 4.95-2.99 7.25-9.51 9.34-18.66 2.09-9.19 2.6-19.2 4.04-29.06z' fill='white'/%3e%3cpath fill='%2321231e' d='M358.91 387.91l13.44 1.57c.09.86-.26 1.18-1.09.87l-12.46-1.45c-.45-.54-.55-.61.11-.99zm-.55.4zm-3.83 26.36c-.79.07-1.2-.17-.89-.98 1.02-7.23 2.61-14.37 3.97-21.54l.75-3.84c.87-.02 1.16.34.8 1.15-1.5 7.88-3.23 15.71-4.44 23.64l-.19 1.57zm4.12 22.6c.66.67.4 1.16-.28.45-3.59-7.1-5.64-15.17-4.83-23.15.83-.1 1.2.2.91 1.02-.56 7.58 1.48 15.16 4.9 21.88l-.7-.2zm.51.85zm8.6-19.2c.78.04 1.19.3.77 1.08-1.24 5.07-2.52 10.34-5.62 14.65a13.24 13.24 0 0 1-3.75 3.47c-.58-.62-.52-1.07.28-1.38 3.6-2.68 5.29-7.06 6.6-11.2.67-2.18 1.21-4.4 1.72-6.62zm4.53-28.45c-.23-.95.28-1.18.46-.21-1.4 9.62-1.88 19.38-4.02 28.88-.78-.03-1.19-.3-.78-1.08 1.98-9.28 2.47-18.79 3.85-28.16l.49.57zm0-1c.97-.25.45 1.11 0 0zm0 0c.04.62-.07 1.49-.02.35l.02-.35zm0 1z'/%3e%3cpath d='M407.15 418.58l-11.92.12c-.41 10.97-.7 18.38-.51 22.25.38 7.57 2.27 13.99 5.5 18.8 3.63-3.03 7.05-8.36 7.6-16.28.54-7.96-.6-16.43-.67-24.89z' fill='white'/%3e%3cpath fill='%2321231e' d='M395.23 418.2l11.92-.12c.02.54.19 1.25-.61 1l-11.3.12c-.54-.5-.61-.52-.01-1zm-.5.48c-.17-.77.94-.5.05-.04l-.04.04zm.5 22.23c-.5.01-1.24.27-1.02-.5-.14-6.28.22-12.56.42-18.83l.1-2.9c.56.01 1.27-.13.98.66-.22 6.9-.62 13.78-.52 20.68l.03.9zm4.68 18.44c.36.42.98 1 .02.68-.44-.31-.66-.96-.99-1.41-3.1-5.34-4.4-11.54-4.71-17.66.55-.03 1.24-.23 1.03.58.4 6.26 1.86 12.64 5.38 17.92l-.73-.1zm.64.77c-.3.8-1.14-.39-.29-.04l.29.04zm6.78-16.7c.54.04 1.26-.08.94.7-.5 6.02-3.01 12.07-7.72 16-.35-.42-.93-.85-.17-1.17 4.38-3.91 6.58-9.76 6.95-15.52zm-.17-24.35c0-.55-.13-1.38.44-.56.14 1.09.06 2.27.13 3.4.26 7.19 1.06 14.38.59 21.58-.55-.03-1.27.1-.96-.69.44-8.08-.64-16.14-.7-24.22l.5.5zm0-1c.78-.23.54.95.05.06l-.05-.06z'/%3e%3cpath d='M419.99 424.24l-11.91.54c-.03 10.97-.07 18.4.26 22.25.65 7.55 2.76 13.9 6.16 18.59 3.51-3.15 6.75-8.6 7.02-16.53.26-7.97-1.16-16.4-1.53-24.85z' fill='white'/%3e%3cpath fill='%2321231e' d='M408.06 424.28l11.91-.54c.04.55.23 1.25-.58 1.02l-11.29.51c-.52-.39-.59-.57-.04-.99zm-.48.5c-.2-.77.92-.53.04-.05l-.04.05zm1.26 22.2c-.5.03-1.22.3-1.03-.47-.36-6.42-.21-12.86-.23-19.28v-2.45c.55-.01 1.26-.18 1 .63.02 6.83-.13 13.67.18 20.5l.08 1.07zm5.33 18.26c.38.42 1.01.96.04.68-.45-.3-.7-.95-1.05-1.4-3.28-5.22-4.78-11.36-5.3-17.45.54-.06 1.23-.28 1.04.54.61 6.24 2.3 12.56 6 17.71l-.73-.08zm.66.75c-.27.8-1.16-.35-.28-.04l.28.04zm6.2-16.92c.55 0 1.26-.13.96.66-.28 6.04-2.59 12.17-7.16 16.26-.36-.4-.96-.81-.2-1.17 4.23-4.06 6.23-9.98 6.4-15.75zm-1.04-25.33c0 .56-.12 1.38.44.54.16.2.07 1.06.14 1.51.44 7.77 1.69 15.51 1.45 23.31-.55 0-1.26.13-.98-.66.16-8.1-1.2-16.11-1.54-24.18l.5-.52zm-.5.52c-.27-.8.96-.58.07-.07l-.06.07zm.5.47c0-.32 0-1.52.01-.54-.01.16.05.42 0 .54z'/%3e%3cpath d='M395 412.42l-11.9-.84c-1.29 10.89-2.18 18.26-2.3 22.12-.24 7.58 1.13 14.14 3.96 19.18 3.86-2.71 7.7-7.75 8.89-15.6 1.18-7.89.74-16.42 1.35-24.86z' fill='white'/%3e%3cpath fill='%2321231e' d='M383.14 411.08l11.9.84c-.03.56.08 1.27-.7.95l-11.27-.8c-.48-.45-.53-.64.07-.99zm-.53.44c-.11-.8.97-.42.04-.04l-.04.04zm-1.32 22.2c-.58.02-1.22.08-.96-.68.4-6.45 1.29-12.85 2.01-19.27l.27-2.25c.64.01 1.23.06.9.83-.77 6.8-1.7 13.57-2.17 20.38l-.05.99zm3.19 18.76c.33.45.9 1.07-.05.67-.4-.36-.58-1.02-.87-1.5-2.66-5.58-3.44-11.85-3.26-17.96.61-.03 1.23-.07.98.73-.1 6.25.84 12.7 3.92 18.22l-.72-.16zm.57.81c-.37.78-1.11-.48-.28-.06l.28.06zm8.1-16.08c.64.03 1.24.1.87.86-1 5.93-3.99 11.7-8.97 15.22-.32-.44-.87-.91-.08-1.18 4.68-3.54 7.35-9.19 8.18-14.9zm1.81-24.3c.04-.55-.02-1.38.49-.5.02 1.3-.15 2.66-.17 4-.3 6.98-.12 14-1.14 20.95-.64-.04-1.23-.1-.88-.87 1.07-7.99.65-16.08 1.24-24.1l.46.53zm.08-.99c.8-.16.45 1 .04.06l-.04-.06z'/%3e%3cpath d='M383.86 399.58l-13.05-5.42c-2.22 8.82-5.23 37.87.12 50.13 4.34-2.95 8.72-8.49 10.18-17.22 1.47-8.77 1.91-18.1 2.75-27.49z' fill='white'/%3e%3cpath fill='%2321231e' d='M371 393.7l13.05 5.42c-.15.86-.57 1.06-1.29.54l-12.14-5.04c-.43-.58-.21-.68.38-.92zm-.67.34c0-1 1.18-.17 0 0zm.31 49.84c.62.62.57 1.1-.21.51-2.17-5.34-2.64-11.17-2.91-16.87-.3-9.57.36-19.16 1.84-28.6.27-1.64.57-3.27.97-4.88.8.04 1.17.34.75 1.11-1.57 7.61-2.25 15.38-2.57 23.13-.2 7.36-.12 14.83 1.6 22.03.34 1.29.75 2.56 1.27 3.78l-.74-.21zm.56.82c-.68.79-1-.69 0 0zm9.42-17.72c.84-.03 1.17.3.81 1.1-1.23 6.52-4.66 12.84-10.23 16.62-.6-.57-.6-1.03.19-1.35 5.18-3.9 8.2-10.07 9.23-16.37zm3.05-26.94c.12-.87.7-1.1.65-.1-.81 9.08-1.23 18.2-2.72 27.2-.84.05-1.17-.27-.83-1.08 1.38-8.79 1.8-17.68 2.6-26.53l.3.5zm.38-.92zm-.2.46zm.2-.46z'/%3e%3cpath id='b' d='M387.75 701.16c7.96 6.38 15.25-8.22 8.19-27.51-5.23-14.28-30.77-8.74-16.54 10.47.67.9 1.62.49 1.49-.55-.81-3.94 1.7-6.23 5.57-5.5 10.58 1.98 10.91 22.07-.6 17.5-2.09-.14-.21 3.9 1.89 5.59z' stroke='%2321231E' stroke-width='.99' fill='%23EDB92E'/%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M400.05 639.16v.13c-1.04 3.35-4.91 7.54-7.92 10.68-4.67 4.87-3.57 12.24-.34 16.16 3.53 4.28 5.1 9.1 5.8 12.84.53 2.3 1.48 7.47.8 15.5-.35 3.96-2.74 6-4.98 7.77-1.14.9.49 3.05 4.25 5.88.4.3 1.54 1.08 2.08 3.04.2.47 1.95.47 2.16 0 .54-1.96 1.67-2.73 2.09-3.04 3.76-2.83 5.38-4.98 4.24-5.88-2.24-1.77-4.63-3.81-4.97-7.77-.69-8.03.26-13.2.79-15.5.7-3.75 2.28-8.56 5.8-12.84 3.23-3.92 4.33-11.3-.33-16.16-3.01-3.14-6.88-7.33-7.92-10.68v-.13c-.06-.65-.42-.98-.78-.98-.36 0-.72.33-.77.98z' fill='%23EDB92E'/%3e%3cpath d='M395.06 685.47h11.51c1.98 0 3.6 1.6 3.6 3.54a3.58 3.58 0 0 1-3.6 3.54h-11.51c-1.98 0-3.6-1.6-3.6-3.54a3.58 3.58 0 0 1 3.6-3.54z' fill='%23EDB92E'/%3e%3cpath fill='%2321231e' d='M406.57 685.97h-11.51v-1h11.51v1zm4.1 3.04h-1a3.09 3.09 0 0 0-2.75-3.02c-.36.07-.4-.14-.35-.45.05-.2-.15-.67.21-.56a4.1 4.1 0 0 1 3.89 4.03zm-1 0h1-1zm-3.1 4.04v-1a3.1 3.1 0 0 0 3.1-2.77c-.1-.38.27-.25.52-.27.25 0 .6-.09.47.3a4.09 4.09 0 0 1-4.09 3.74zm-11.51-1h11.51v1h-11.51v-1zm-4.1-3.04h1a3.09 3.09 0 0 0 2.75 3.02c.36-.07.4.14.35.45-.05.2.15.67-.21.56a4.1 4.1 0 0 1-3.89-4.03zm1 0h-1 1zm3.1-4.04v1a3.1 3.1 0 0 0-3.1 2.77c.1.38-.27.25-.52.27-.25 0-.6.09-.47-.3a4.09 4.09 0 0 1 4.09-3.74z'/%3e%3cpath d='M417.13 579.19l.38-10.91c-4.38-2.23-15.17.06-19.73 10.13-5.68 12.56-11.06 19.25-17.87 25.14 9.88 1.85 18.25-.1 23.64-7.35 7.28-9.78 11.17-15.7 13.58-17.01z' fill='white'/%3e%3cpath fill='%2321231e' d='M418.01 568.3l-.38 10.91c-.86.17-1.2-.16-.96-1.01l.35-9.94c.48-.22.74-.73.99.04zm-.27-.46zm-19.5 10.78c-.86-.17-1.04-.6-.48-1.29 3-6.02 9.4-10.38 16.2-10.32a9 9 0 0 1 3.78.83c-.22.76-.57 1.05-1.27.55-3.67-1.01-7.61.09-10.84 1.93a18.27 18.27 0 0 0-7.4 8.3zM380 603.07c-.1.91-.23 1.16-.42.11A60.46 60.46 0 0 0 393.44 586a105.5 105.5 0 0 0 3.89-7.79c.85.18 1.04.6.5 1.3-3.7 8.07-8.38 15.82-14.87 21.94-.88.86-1.8 1.68-2.73 2.49l-.23-.87zm-.18.98c-.97-.04-1.16-.3-.28-.83.14.07.18.6.28.83zm23.33-8.14c.79.35.9.8.2 1.35a19.95 19.95 0 0 1-13.4 7.24c-3.37.42-6.8.16-10.13-.45-.02-.82.29-1.18 1.1-.82 5.73.96 12 .66 17.06-2.5a19.04 19.04 0 0 0 5.17-4.82zm13.49-16.73c.76-.14 1.32.16.44.63-2.3 1.8-3.91 4.3-5.7 6.57-2.48 3.37-4.93 6.76-7.43 10.12-.8-.35-.89-.81-.21-1.38 3.52-4.66 6.78-9.54 10.55-14.02.78-.87 1.58-1.75 2.6-2.34l-.25.42zm.99.03z'/%3e%3cpath d='M425.16 580.63l-11.79-4.97c-4.83 9.86-8.12 16.52-9.5 20.13-2.68 7.1-3.41 13.77-2.17 19.54 4.79-1.22 10.31-4.64 14.05-11.66 3.75-7.04 6.06-15.27 9.41-23.04z' fill='white'/%3e%3cpath fill='%2321231e' d='M413.56 575.2l11.79 4.97c-.18.65-.42 1.16-1.1.61l-11.07-4.66c-.3-.6-.31-.78.38-.92zm-.64.24zm-8.58 20.52c-.65-.16-1.19-.38-.65-1.06 2.6-6.18 5.68-12.14 8.6-18.17.31-.33.36-1.45.9-1.16.85.13.48.69.18 1.22-2.95 6.1-6.07 12.12-8.7 18.36l-.33.81zm-2.77 18.88c.2.63.4 1.26-.36.58-1.41-6.63-.17-13.55 2.2-19.81.6.17 1.2.33.69 1-2.14 5.91-3.24 12.4-1.92 18.6l-.6-.37zm.25.96c-.76.43-.73-.83-.04-.02l.04.02zm13.49-12.36c.61.24 1.13.51.51 1.12-2.97 5.36-7.99 9.73-14 11.24-.23-.61-.38-1.17.47-1.16 5.7-1.67 10.3-6.01 13.02-11.2zm9.65-22.36c.22-.62.45-1.25.65-.26-3.3 7.63-5.53 15.71-9.42 23.08-.6-.24-1.14-.5-.54-1.12 3.66-7.18 5.86-14.98 9.05-22.35l.26.65zm.39-.92c.85.13.09 1.1.01.04l-.01-.04z'/%3e%3cpath d='M428.55 580.62l-12.64-1.93c-2.29 10.73-3.86 18-4.3 21.84-.88 7.53.03 14.18 2.65 19.48 4.34-2.36 8.87-7.02 10.78-14.74 1.92-7.75 2.16-16.3 3.51-24.65z' fill='white'/%3e%3cpath fill='%2321231e' d='M415.98 578.2l12.64 1.93c-.03.65-.1 1.24-.88.87-3.97-.6-7.94-1.2-11.91-1.82-.42-.56-.54-.6.15-.98zm-.56.39c-.03-.8 1-.32.03-.02l-.03.02zm-3.32 22c-.6-.03-1.23-.02-.9-.77.96-6.42 2.45-12.76 3.77-19.12l.45-2.11c.65.07 1.22.18.82.93-1.38 6.66-2.94 13.29-4 20l-.14 1.07zm1.92 18.98c.35.57.68 1.12-.21.66-2.99-6.09-3.47-13.1-2.7-19.76.62.03 1.24.04.91.82-.63 6.24-.12 12.8 2.68 18.5l-.68-.22zm.47.88c-.61.6-.93-.62-.06-.02l.06.02zm10.07-15.3c.64.1 1.21.23.77.96-1.57 5.93-5.38 11.4-10.84 14.34-.36-.54-.65-1.04.16-1.24 5.13-3.02 8.54-8.35 9.9-14.06zm3.99-25.02c-.1.78.05 1.09.47.66-1.33 8.18-1.53 16.53-3.5 24.6-.64-.09-1.21-.22-.79-.96 1.8-7.85 2.03-15.95 3.33-23.89l.49-.41zm-.5.41zm.5.58c-.05-.4.06-1.53.04-.53l-.04.53z'/%3e%3cpath d='M430.43 563.41l7.54-.06c4.4 2.18 9.02 12.22 3.68 21.9-6.65 12.07-8.8 20.39-9.44 29.38-7.38-6.83-10.81-14.72-8.24-23.38 3.48-11.69 6.85-25.12 6.46-27.84z' fill='white'/%3e%3cpath fill='%2321231e' d='M437.97 563.85l-7.54.06c-.26-.96.27-1.14 1.14-1 2.2.01 4.42-.11 6.62 0l-.22.94zm0-1zm4.11 22.65c-.94-.24-.88-.78-.36-1.47 2.85-5.79 2.42-13.27-1.7-18.35a7.72 7.72 0 0 0-2.27-1.88c.2-.9.7-.97 1.33-.35 3.3 2.54 4.93 6.73 5.37 10.78a19.3 19.3 0 0 1-2.37 11.27zm-10.2 29.5c1.01-.98.24-.35-.15-.62a62 62 0 0 1 5.86-22.21c1.11-2.43 2.33-4.81 3.62-7.15.97.24.87.8.33 1.48-4.23 7.75-7.58 16.13-8.53 24.96a70.2 70.2 0 0 0-.3 3.21l-.84.33zm.83-.33c.08 1.04-.19 1.16-.83.34.26-.12.55-.22.83-.34zm-9.22-23.56c.94.05 1.04.53.68 1.3-1.32 5.07-.2 10.57 2.58 14.96a33.2 33.2 0 0 0 5.8 6.9c-.45.83-.94.72-1.45 0-4.41-4.25-8.05-9.81-8.43-16.09-.17-2.38.15-4.78.82-7.07zm6.93-28.2c-.12 1 .12.92.5.55.06 2.85-.72 5.63-1.28 8.4a319.4 319.4 0 0 1-5.2 19.54c-1-.03-1.01-.6-.62-1.38 2.2-7.66 4.38-15.33 5.82-23.17.16-1.11.38-2.24.3-3.36l.48-.57zm-.49.58zm.5-.07zm-.5.07z'/%3e%3cpath d='M433.79 558.16l-12.05-4.28c-4.27 10.11-7.17 16.95-8.33 20.64-2.28 7.23-2.63 13.94-1.06 19.63 4.71-1.5 10.68-4.58 14-11.8 3.35-7.25 4.54-16.24 7.44-24.19z' fill='white'/%3e%3cpath fill='%2321231e' d='M421.9 553.41l12.05 4.28c-.14.66-.35 1.19-1.05.68l-11.33-4.02c-.34-.57-.35-.76.33-.94zm-.62.27zm-7.4 20.99c-.65-.13-1.2-.31-.7-1.02 2.23-6.32 4.97-12.44 7.54-18.63.3-.36.28-1.47.82-1.22.87.08.53.66.26 1.21-2.6 6.26-5.36 12.45-7.64 18.82l-.28.84zm-1.68 19c.24.63.47 1.24-.33.61-1.79-6.54-.94-13.52 1.07-19.91.6.14 1.22.26.74.97-1.8 6.01-2.52 12.55-.85 18.67l-.63-.34zm.3.95c-.73.47-.78-.79-.04-.02l.04.02zm13.4-12.48c.64.21 1.16.46.58 1.1a21.82 21.82 0 0 1-11.26 10.38c-.89.38-1.8.7-2.72 1-.27-.6-.44-1.15.41-1.18 4.93-1.63 9.42-4.87 12.02-9.42.35-.6.68-1.24.98-1.88zm7.72-23.51c.19-.63.37-1.28.63-.3-2.9 7.95-3.94 16.49-7.44 24.23-.62-.2-1.16-.44-.6-1.1 3.23-7.54 4.3-15.78 7.11-23.47l.3.64zm.33-.94c.85.07.16 1.08.02.03l-.02-.03zm-.16.47zm.16-.47c.85.07.16 1.08.02.03l-.02-.03z'/%3e%3cpath d='M425.6 549.74l-2.64-16.4c-2.77-.76-6.45 5.72-10.05 9.5-.83.88-1.79 1.7-2.51 2.77a23.32 23.32 0 0 0-3.42 7.96c-3.01 13.45-7.4 20.45-12.87 27.61 10.04-.2 17.84-3.83 21.65-12.02 5.14-11.06 7.74-17.65 9.84-19.42z' fill='white'/%3e%3cpath fill='%2321231e' d='M423.44 533.25l2.64 16.4c-.94.44-1.16-.13-1.16-1l-2.46-15.24c.45-.31.57-.9.98-.16zm-.36-.4zm-9.82 10.33c-.76-.44-.78-.9-.07-1.39 2.45-2.7 4.35-5.95 7.24-8.23.76-.54 1.7-.96 2.65-.71 0 .95-.52.95-1.29 1.07-2.19 1.16-3.57 3.35-5.13 5.2-1.1 1.38-2.18 2.78-3.4 4.06zm-2.46 2.7c-.5-.28-1.08-.58-.44-1.07.65-.83 1.45-1.55 2.18-2.31.9.48.62 1-.09 1.5-.6.59-1.18 1.2-1.65 1.88zm-3.34 7.8c-.9 0-1.11-.43-.73-1.2a23.78 23.78 0 0 1 3.25-7.15c.73.3.95.7.35 1.28a22.88 22.88 0 0 0-2.87 7.06zm-13.37 27c.3 1.22-.41.87-.24 0 4.24-5.43 7.81-11.44 10.04-17.99a82.13 82.13 0 0 0 2.6-9.24c1.04-.05 1.03.56.7 1.37-1.8 7.87-4.8 15.53-9.44 22.18a99.22 99.22 0 0 1-3.25 4.48l-.4-.8zm.02 1c-1.14.35-1-.46-.35-.7l.35.7zm21.2-12.74c.96.18.94.71.4 1.4-2.48 4.9-7.17 8.47-12.41 9.98a34.1 34.1 0 0 1-9.19 1.35c-.29-.98.28-1.14 1.14-1.03 5.96-.26 12.21-2 16.45-6.41a19.2 19.2 0 0 0 3.6-5.29zm9.8-19.13c.86-.36 1.25.05.45.65-2.03 2.56-3.21 5.66-4.63 8.58-1.58 3.44-3.13 6.9-4.73 10.32-.97-.17-.92-.72-.42-1.44 2.5-5.3 4.7-10.75 7.5-15.9.57-.96 1.16-1.93 2-2.67l-.18.46zm.98-.16z'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='matrix(-1 0 0 1 964.3 0)'/%3e%3cpath stroke='%2321231E' d='M536.38 414.88c1.59-.33 3.2-.79 4.86-1.37-7.63-4.79-13.96-10.57-21.49-22.12-7.7-11.83 3.38-32.95 7.93-44.16 9.5-7.04 18.45-17.37 21.29-31 1.12-7.34-19.1-4.7-33 1.88-17 8.03-19.31 5.8-25.37 7.16-2.15 10.42 2.36 11.3 6.7 10.8-9.37 15.02-13.28 29.98-15.15 51.49-1.87-21.51-5.78-36.47-15.14-51.5 4.34.51 8.85-.37 6.7-10.79-6.07-1.36-8.38.87-25.38-7.16-13.9-6.57-34.12-9.22-33-1.89 2.85 13.63 11.8 23.97 21.3 31.01 4.54 11.2 15.63 32.33 7.92 44.16-7.52 11.55-13.85 17.34-21.48 22.12 1.65.58 3.27 1.04 4.85 1.37-1.15 1.58-11.04 4.66-12.2 3.84-7.58-5.36-14.96-17.95-21.4-25.26-18.25-20.72-27.35-36.7-24.13-49.6 4.58-13.89 20.93-29.48-.72-26.78-21.66 2.7-39.6 32.42-45.37 68.2-2.14 13.27-3.38 24.38-4.83 33.47 11.82-4.22 17.06-8.43 20.2-13.62a119.35 119.35 0 0 0-3.18 14.09c9.67-1.72 16.68-6.47 19.2-15.14a45.4 45.4 0 0 1 3.56-8.85c2.97 1.05 6.82 1 11.5-.16 1.79 4.25 15.1 19.1 22.26 30.01 8.09 12.33 20.23 21.75 24.24 22.26 2 .26 2.61-4.2 2.17-10.32 21.12.15 42.23.27 62.93-.43 20.7.7 41.82.58 62.94.43-.45 6.13.17 10.58 2.17 10.32 4-.51 16.15-9.93 24.23-22.26 7.16-10.9 20.48-25.76 22.26-30 4.68 1.14 8.54 1.2 11.5.15a45.4 45.4 0 0 1 3.57 8.85c2.51 8.67 9.53 13.42 19.2 15.14-.71-4.47-1.77-9.16-3.19-14.09 3.15 5.19 8.38 9.4 20.2 13.62-1.45-9.1-2.69-20.2-4.82-33.48-5.77-35.77-23.72-65.5-45.37-68.2-21.65-2.68-5.3 12.9-.72 26.79 3.21 12.9-5.89 28.88-24.13 49.6-6.44 7.3-13.82 19.9-21.4 25.26-1.16.82-11.05-2.26-12.2-3.84z' fill='white'/%3e%3cg id='d'%3e%3cpath d='M440.58 356.77c-2.04 1.78-8.76 1.8-17.96 2.4-14.81.52-23.4-3.96-25.3-13.45 5.56 6.63 12.2 9.9 19.73 8.04 10.16-2.52 15.98-4.32 18.3-3.87 1.56.55 3.84 3.38 5.23 6.88z' fill='%23EDB92E'/%3e%3cpath fill='%2321231e' d='M422.64 359.67c-.03-.58-.23-1.25.6-1.04 4.68-.33 9.4-.35 14.03-1.12 1.04-.22 2.13-.44 2.98-1.1.38.4.94.85.15 1.1-2.18 1.15-4.72 1.24-7.12 1.5-3.54.29-7.1.43-10.64.66zm.01 0zm-24.95-14.26c-.56.45-1.01.83-.09.31.46-.14.3.95.54 1.3 1 3.74 3.68 6.92 7.1 8.69 4.9 2.56 10.56 3.04 16 3 .44.13 1.48-.38 1.37.34.3.84-.54.6-1.1.65-5.68.07-11.59-.43-16.7-3.1a15.03 15.03 0 0 1-7.5-8.87c-.2-.62-.35-1.26-.48-1.9l.86-.42zm19.23 7.88c.22.6.37 1.18-.49 1.13-4.38.96-9.07 0-12.84-2.42a28.56 28.56 0 0 1-6.66-5.95c.45-.48.9-.86 1.25-.08 3.28 3.78 7.6 7.03 12.7 7.69 2.01.27 4.07.11 6.04-.37zm18.58-3.87c-.28.5-.1 1.19-.77.9-2.7.05-5.31.88-7.93 1.48-3.22.81-6.42 1.66-9.64 2.45-.23-.61-.38-1.18.48-1.14 4.86-1.17 9.66-2.6 14.57-3.54 1.08-.17 2.2-.36 3.29-.15zm-.07-.02zm5.47 7.75c-.4-.61-.77-.8-.83-.28-.99-2.32-2.27-4.66-4.32-6.2-.73-.17-.52-.64-.27-1.19.43 0 .96.46 1.35.76 1.93 1.7 3.23 4 4.2 6.35l-.13.56zm.13-.56zM419.53 321.15l.09 1.58c-.68.07-1.11-.84-.63-1.32a.79.79 0 0 1 .54-.26zm15.27 3.91l-.54 1.49c-3.55-1.26-7.04-2.76-10.75-3.51a15.86 15.86 0 0 0-3.9-.31l-.08-1.58c3.81-.2 7.48 1.1 11.02 2.35l4.25 1.56zm8.86 2.6l.24 1.56c-1.4.12-2.77-.36-4.1-.73-1.87-.57-3.7-1.26-5.53-1.94l.53-1.49c2.59.94 5.16 2 7.86 2.53.33.05.68.1 1 .06zm.24 1.55l-.24-1.56c.67-.13 1.19.73.76 1.25a.78.78 0 0 1-.52.31zM467.17 336.71l.2-1.17c.39.05.62.54.41.88a.6.6 0 0 1-.61.29zm-9.86-2.07l.32-1.14c3.2.9 6.46 1.5 9.73 2.04l-.2 1.17a91.54 91.54 0 0 1-9.85-2.07zm.32-1.14l-.32 1.14c-.4-.1-.57-.63-.3-.94a.6.6 0 0 1 .62-.2z'/%3e%3cpath fill='%2321231e' d='M431.54 331.89l-.77 1.38c-2.69-1.52-4.6-4.05-6.16-6.66-.77-1.3-1.47-2.64-2.19-3.97l1.38-.75c1.61 2.95 3.14 6.06 5.6 8.41.65.61 1.37 1.16 2.14 1.59zm7.6-5.16l1.4.74c-1.17 2.13-2.61 4.23-4.7 5.54a4.94 4.94 0 0 1-4.44.55c-.17-.11-.63-.17-.59-.37l.73-1.3c.96.58 2.18.5 3.14-.04 1.68-.9 2.87-2.48 3.86-4.06.21-.35.42-.71.6-1.06z'/%3e%3cpath d='M429.59 330.91l-2.19-2.2c-1.07-1.34-.45-3.14 1.85-5.4 1.69.74 3.04 1.3 4.38 1.86-.9 3.04-2.24 4.95-4.04 5.74z' fill='%2321231E'/%3e%3cpath fill='%2321231e' d='M423.26 412.95c-.15.36-.24.82-.42 1.1-.57-.19-.42-1.13.19-1.13.08 0 .15 0 .23.03zm23.87-3.53l.83.85a19.68 19.68 0 0 1-10.57 5.49c-4.88.84-9.9-.07-14.52-1.69l.4-1.12c4.67 1.64 9.79 2.54 14.7 1.49a18.48 18.48 0 0 0 9.16-5.02zm2.9-2.87l.83.84-2.9 2.88-.83-.85 2.9-2.87zm.83.84c-.26-.28-.64-.57-.82-.86.4-.4 1.16.07.96.61a.6.6 0 0 1-.14.25z'/%3e%3cpath fill='%2321231e' d='M452.17 401.28l-1.17-.16c.04-.54.83-.7 1.09-.23.07.12.1.26.08.39zm-5.5 15.93l.29 1.14-.69-.81a58.6 58.6 0 0 0 4.73-16.42l1.17.16a59.5 59.5 0 0 1-4.37 15.7c-.14.35-.3.7-.45 1.04l-.69-.81zm-.4.33l1.08.48c-.19.52-1.03.43-1.11-.11a.6.6 0 0 1 .03-.37zm15.25-9.54l.97.68c-2.54 3.66-6.34 6.28-10.42 7.97-1.66.7-3.37 1.25-5.11 1.7l-.3-1.14c4.52-1.18 8.97-3.11 12.4-6.35a18.6 18.6 0 0 0 2.46-2.86zm.97.68l-.97-.68c.28-.45 1.06-.24 1.07.3a.6.6 0 0 1-.1.38z'/%3e%3cpath fill='%2321231e' d='M461.29 400.2l-1.18.1c-.07-.5.62-.85.99-.48.1.1.17.24.19.38zm4.43 15.72l.72.94c-.28-.06-.62-.05-.87-.17-3.16-4.55-4.76-10.02-5.37-15.49l-.09-.9 1.18-.1c.49 5.31 1.9 10.65 4.82 15.17l.46.68c-.28-.05-.57-.1-.85-.13zm-.12.81l.97-.68c.32.42-.14 1.08-.65.91a.6.6 0 0 1-.32-.23zm7.67-12.6l1.14.28a22.28 22.28 0 0 1-7.87 12.38c-.22.15-.35-.37-.54-.5-.22-.23-.37-.44 0-.6a21.13 21.13 0 0 0 7.27-11.57zm1.14.28l-1.14-.29c.1-.5.87-.6 1.1-.13a.6.6 0 0 1 .04.42z'/%3e%3cpath d='M405.91 317.77c-16.62 1.8-15.83 12.67-.29 28.04 2.97 2.94 4 2.85 4.63-.2 1.1-5.35 7.02-8.5 10.12-4.44 2.11 2.77 1.64 4.36 8.68 3.38 8.89 7.46 16.12 12.7 4.5 12.26-5.12-.19-9.07 2.8-15.73 2.54 1.97 3.82 2.32 4.27 3.39 4.6 6.46 1.27 13.27-2.77 19.79-1.57 14.28 2.64-22.89-38.63-22.43-40.26 1.18-4.15-8.93-11.6-12.66-4.35z' fill='%23EDB92E'/%3e%3cpath fill='%2321231e' d='M405.97 345.46c-.64 1.24-1.28.09-1.92-.52-4.06-4.28-8.13-8.88-10.15-14.52-1.12-3.03-1-6.84 1.47-9.18 2.77-2.71 6.77-3.5 10.49-3.96.53 1.22-.65 1.08-1.53 1.2-3.4.58-7.26 1.6-9.22 4.7-1.82 3.1-.55 6.9 1 9.84 2.5 4.7 6.13 8.69 9.86 12.44zm3.8.04c1.23-.12.92.82.56 1.63a1.73 1.73 0 0 1-2.69.99c-.89-.52-1.63-1.24-2.37-1.95.56-1.05 1.1-.38 1.7.23.59.4 1.32 1.31 2.08.94.45-.5.56-1.21.71-1.84zm11-4.63c-.76 1.08-1.2 0-1.95-.47-3.6-2-7.5 1.82-8.08 5.3-1.32.13-.86-.91-.52-1.72 1.17-3.04 4.37-5.8 7.8-5 1.1.27 2.06 1 2.75 1.9zm8.6 3.3c-.83.9-.03.97-1.47 1.02-2.21.23-5.05.5-6.48-1.61-.5-.69-.92-1.43-1.44-2.1.7-.97 1.16-.23 1.58.52.65 1.25 1.78 2.37 3.3 2.31 1.47.18 2.96-.25 4.4-.18l.1.04zm-.4-.12zm4.55 13.26c-.35-1.27.77-.96 1.64-.97 1.29-.1 2.86.06 3.85-.91.2-1.26-1.04-2.2-1.76-3.1-2.66-2.67-5.66-4.96-8.52-7.4.52-1.25 1.23-.25 1.9.3 3.01 2.61 6.34 4.95 8.77 8.14.83.97 1 2.75-.38 3.32-1.7.77-3.68.64-5.5.62zm-15.26 1.8c-1.27 1.04-.72-.54.32-.25 4.56.16 8.73-1.99 13.18-2.49.61.1 2.07-.52 1.78.53.04.8-1.24.22-1.82.48-4.28.54-8.3 2.52-12.68 2.48-.75-.08-1.74.32-.78-.74zm-.89.46zm3.93 3.88c.14 1.2-.74 1.01-1.37.35-1.14-1.21-1.76-2.8-2.55-4.23.87-.85 1.19.05 1.54.83.7 1.07 1.1 2.63 2.43 3.07l-.05-.02zm-.19.98zm19.98-2.54c.15 1.25-.8.9-1.65.8-6.19-.38-12.12 2.93-18.33 1.74-.13-1.24.8-.88 1.65-.78 6.2.43 12.12-2.88 18.33-1.76zm-23-39.9c1 .04 1.28.6 1.76 1.4 7.28 9.72 15.32 18.91 21.69 29.29 1.4 2.52 3.07 5.1 3.22 8.07 0 1.35-1.22 2.3-2.52 2.25-1 .33-1.85-.69-.86-1.08.95.23 2.43.06 2.4-1.22-.27-3.04-2.07-5.67-3.55-8.25-6.25-9.99-14-18.9-21.06-28.31-.43-.67-1.07-1.31-1.08-2.15zm-12.13-3.72c.07-1.28-.86-.47.07-1.64 1.48-2.35 4.67-2.93 7.13-1.9 2.71 1.07 5.37 3.23 5.97 6.21.35.96-.4 1.76-1 .9.2-2.25-1.72-4.03-3.42-5.22-2.1-1.47-5.4-2.15-7.35-.05-.59.47-.74 1.33-1.4 1.7zm.4-.27zm-.45-.23zm.44.23z'/%3e%3cpath fill='%2321231e' d='M406.86 317.22l-1.13.4c-.17-.44.3-.94.74-.77.18.05.33.2.39.37zm7.7 10.54l-.77.9c-3.08-2.6-5.78-5.74-7.42-9.45-.24-.52-.45-1.06-.64-1.6l1.13-.39a23.66 23.66 0 0 0 6.27 9.26c.46.44.94.86 1.43 1.28zm-.77.9l.77-.9c.38.29.22.96-.25 1.04a.59.59 0 0 1-.52-.13z'/%3e%3cpath fill='%2321231E' d='M.9 0C.9.44.5.79 0 .79S-.9.44-.9 0s.4-.79.9-.79.9.35.9.79z' transform='matrix(.21422 -1.51084 1.7589 .184 404.14 325.55)'/%3e%3cpath fill='%2321231e' d='M358.42 362.56c.6-.47 1.33.54.69.96l-.69-.96zm-22.68 56.14c1.47-10.11 5.01-19.79 8.48-29.35 3.4-8.53 6.68-17.31 12.16-24.75.46-1.33 3.24-2.74 2.3-.73-4.49 4.66-6.9 10.86-9.6 16.64-4.92 11.7-9.35 23.7-11.87 36.17-.45 1.13.44 2.66-1.47 2.02zm5.55 80.36c-5.79-16.16-6.83-33.54-6.97-50.56 0-9.95.5-19.9 1.42-29.8 2.25-.32.53 2.67.84 3.99-1.59 21-1.9 42.36 2.2 63.12a89.33 89.33 0 0 0 3.62 12.84l-1.1.41zm1.11-.41c.3.7-.87 1.13-1.1.41l1.1-.41z'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 964.3 0)'/%3e%3cpath fill='%2321231e' d='M473.11 398.36c-.37.11-.52.44-.45.86a36.34 36.34 0 0 0 5.92 17.89 49 49 0 0 0 3.03 4.16c.22.19.67.2.93.1.54-.51.97-1.17 1.44-1.76a39.12 39.12 0 0 0 5.96-11.3 34.9 34.9 0 0 0 1.7-9.48c-.08-.37-.54-.6-.87-.4-.45.2-.28.87-.35 1.35a37.09 37.09 0 0 1-.84 5.48 36.31 36.31 0 0 1-4.77 11.1 51.75 51.75 0 0 1-2.67 3.7 49.32 49.32 0 0 1-2.93-4.16 37.2 37.2 0 0 1-3.35-6.81 35.87 35.87 0 0 1-1.69-6.62c-.19-1.24-.24-2.54-.38-3.77-.12-.24-.35-.38-.68-.34z'/%3e%3cg%3e%3cpath d='M549.18 422.03v108.56a72.16 72.16 0 0 1-19.67 49.81c-12.14 12.77-28.9 20.7-47.36 20.7s-35.22-7.92-47.36-20.7a72.15 72.15 0 0 1-19.67-49.8V422.02h134.06z' fill='%23C6363C'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 964.3 -90.09)'/%3e%3cpath stroke='%2321231E' stroke-width='.99' d='M549.18 488.62v27.98h-53.06v82.94a63.64 63.64 0 0 1-27.93 0V516.6h-53.07v-27.98h53.07v-66.59h27.93v66.59h53.06z' fill='white'/%3e%3cuse xlink:href='%23e' y='-90.09'/%3e%3cpath id='e' d='M459.14 567.32v-39.33c-8.56-2.3-29.4-10.62-30.49 7.61-.5 8.43 10.44 13.99 13.4 6.54 1.4-3.52-.13-6.01-2.19-6.82-2.22-.87-4.43.93-3.84 3.61-8.86-4.64 7.92-14.48 15.5-1.67 2.2 3.74-3.73 7.63-3.74 10.4 0 2.76 5.83 6.9 3.73 10.39-7.67 12.75-24.35 2.96-15.49-1.67-.59 2.68 1.62 4.48 3.84 3.6 2.06-.8 3.58-3.3 2.18-6.82-2.95-7.44-13.89-1.88-13.39 6.55 1.09 18.23 21.93 9.91 30.49 7.6z' stroke='%2321231E' stroke-width='.99' fill='white'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 964.3 0)'/%3e%3cpath fill='%2321231e' d='M414 420.86c.08 37.95-.15 75.9.12 113.85 1.2 27.86 19.67 54.5 46.21 63.77 22.43 8.32 49 2.59 66.38-13.74 16.2-14.52 24.65-36.69 23.58-58.24V420.86H414zm2.27 2.36h131.79c-.08 37.12.15 74.25-.12 111.37-1.13 26.66-18.72 52.26-44.03 61.41-21.59 8.29-47.34 3.04-64.31-12.57-16.02-14.08-24.42-35.74-23.34-56.92V423.22z'/%3e%3c/g%3e%3c/svg%3e";

var img$1i = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3crect fill='%23171796' width='1200' height='600'/%3e%3crect fill='white' width='1200' height='400'/%3e%3crect fill='red' width='1200' height='200'/%3e%3cg transform='scale(0.00296202)'%3e%3cg%3e%3cpath fill='red' d='m202577%2c153674%2c0%2c0c21658%2c0%2c39377-17720%2c39377-39377v-46791h-78755v46791c0%2c21658%2c17720%2c39377%2c39377%2c39377z'/%3e%3cpath fill='white' d='m202577%2c153043%2c0%2c0c21245%2c0%2c38626-17382%2c38626-38626v-46153h-77253v46153c0%2c21245%2c17382%2c38626%2c38627%2c38626z'/%3e%3cg fill='red'%3e%3cpath d='m180254%2c69716-14865%2c0%2c0%2c16332%2c14865%2c0z'/%3e%3cpath d='m180254%2c102379%2c14865%2c0%2c0-16331-14865%2c0z'/%3e%3cpath d='m165389%2c114326c0%2c1483%2c92%2c2946%2c263%2c4385h14602v-16332h-14865v11947z'/%3e%3cpath d='m209985%2c102379-14866%2c0%2c0%2c16332%2c14866%2c0z'/%3e%3cpath d='m209985%2c135042%2c14865%2c0%2c0-16331-14865%2c0z'/%3e%3cpath d='m224850%2c143976c3296-2488%2c6169-5509%2c8487-8933h-8487v8933z'/%3e%3cpath d='m180255%2c135042%2c14865%2c0%2c0-16331-14865%2c0z'/%3e%3cpath d='m171754%2c135042c2321%2c3429%2c5199%2c6454%2c8501%2c8944v-8944h-8501z'/%3e%3cpath d='m205141%2c151374c1645-115%2c3262-337%2c4843-661v-15671h-14865v15673c1576%2c323%2c3189%2c544%2c4829%2c658%2c1731%2c107%2c3462%2c101%2c5192%2c0z'/%3e%3cpath d='m239437%2c118711c172-1444%2c264-2912%2c264-4400v-11931h-14852v16332h14588z'/%3e%3cpath d='m209985%2c102379%2c14865%2c0%2c0-16331-14865%2c0z'/%3e%3cpath d='m209985%2c69716-14865%2c0%2c0%2c16332%2c14865%2c0z'/%3e%3cpath d='m239701%2c86048%2c0-16332-14851%2c0%2c0%2c16332z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3cpath fill='white' d='m240533%2c67027%2c9217-20893-7022-11339-11634%2c4307-8168-9337-10763%2c6168-9597-7860-9597%2c7860-10763-6168-8169%2c9336-11634-4307-7024%2c11342%2c9205%2c20897c11599-5250%2c24460-8175%2c37983-8175%2c13517%2c0%2c26372%2c2923%2c37968%2c8169z'/%3e%3cg%3e%3cpath fill='%230093dd' d='m174293%2c40024-17%2c20-11537-4272-6456%2c10424%2c2473%2c5623%2c6265%2c14222c4678-2068%2c9555-3764%2c14594-5048l-5321-20968z'/%3e%3cpath fill='white' stroke='black' stroke-width='118.162625' d='m173629%2c50332c413%2c783%2c647%2c1674%2c647%2c2617%2c0%2c3106-2533%2c5639-5639%2c5639-2737%2c0-5029-1968-5535-4561%2c974%2c1722%2c2823%2c2888%2c4935%2c2888%2c3121%2c0%2c5667-2545%2c5667-5667%2c0-312-26-618-75-917z'/%3e%3cpolygon fill='black' points='168461%2c42530%2c168442%2c42623%2c168049%2c44647%2c169602%2c46004%2c169673%2c46066%2c169583%2c46097%2c167634%2c46769%2c167235%2c48792%2c167216%2c48885%2c167145%2c48822%2c165589%2c47470%2c163638%2c48136%2c163547%2c48167%2c163566%2c48073%2c163959%2c46050%2c162407%2c44693%2c162335%2c44630%2c162425%2c44599%2c164374%2c43928%2c164773%2c41905%2c164792%2c41812%2c164863%2c41874%2c166419%2c43227%2c168370%2c42561'/%3e%3cg fill='%23f7db17'%3e%3cpath d='m166119%2c45404%2c1455%2c1269%2c1821-627z'/%3e%3cpath d='m166131%2c45340%2c3277%2c641-1450-1268z'/%3e%3cpath d='m162613%2c44651%2c3276%2c641-1455-1268z'/%3e%3cpath d='m165877%2c45357-3277-641%2c1450%2c1267z'/%3e%3cpath d='m166060%2c45234%2c2194-2517-1823%2c622z'/%3e%3cpath d='m163704%2c47937%2c2194-2517-1826%2c626z'/%3e%3cpath d='m165948%2c45463-2194%2c2517%2c1823-622z'/%3e%3cpath d='m168304%2c42760-2194%2c2517%2c1826-626z'/%3e%3cpath d='m165933%2c45242-1083-3158-373%2c1890z'/%3e%3cpath d='m167096%2c48634-1083-3158-371%2c1894z'/%3e%3cpath d='m166075%2c45454%2c1083%2c3159%2c373-1890z'/%3e%3cpath d='m164912%2c42062%2c1083%2c3159%2c371-1895z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3cpath fill='%23171796' d='m193069%2c36886-20%2c16-10673-6116-8083%2c9238%2c5321%2c20968c4938-1257%2c10031-2115%2c15242-2546l-1788-21560z'/%3e%3cg fill='red'%3e%3cpath d='m178294%2c55788c5221-1329%2c10608-2237%2c16119-2692l-452-5450c-5816%2c481-11502%2c1439-17013%2c2841l1345%2c5301z'/%3e%3cpath d='m175619%2c45250c5797-1476%2c11777-2483%2c17895-2989l-444-5350c-6418%2c530-12691%2c1588-18772%2c3135l1321%2c5204z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3cpath fill='%230093dd' d='m212105%2c36890-23%2c13-9517-7794-9497%2c7778%2c1788%2c21560c2543-210%2c5113-322%2c7709-322%2c2608%2c0%2c5190%2c113%2c7744%2c325l1795-21560z'/%3e%3cg id='lion'%3e%3cpath fill='black' d='m202545%2c46585c-18-2-44%2c10-69%2c45-186%2c250-359%2c469-545%2c720-195%2c61-242%2c180-167%2c348-261-26-291%2c193-302%2c432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172%2c74%2c267%2c434%2c535%2c868%2c802%2c1302-14%2c80%2c6%2c151%2c88%2c204%2c47%2c133%2c93%2c265%2c140%2c397-11%2c38-21%2c75-32%2c113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92%2c82-3%2c534%2c162%2c1014%2c599%2c1492-231%2c4-462%2c11-694%2c21-79%2c6-95%2c39-73%2c104%2c126%2c304%2c339%2c579%2c822%2c766-208%2c112-327%2c285-357%2c520-9%2c224-75%2c382-212%2c455-60%2c32-81%2c65-24%2c106%2c253%2c185%2c565%2c193%2c895%2c112-157%2c270-226%2c553-198%2c850%2c208%2c56%2c412%2c15%2c614-52-29%2c61-44%2c175-52%2c309-7%2c115-41%2c229-104%2c343-32%2c33-65%2c84%2c4%2c102%2c336%2c91%2c648%2c52%2c915-47%2c0%2c243%2c2%2c487%2c76%2c727%2c18%2c58%2c70%2c102%2c125%2c26%2c155-214%2c322-396%2c527-517%2c31%2c90%2c75%2c168%2c156%2c215%2c96%2c55%2c147%2c170%2c153%2c343%2c0%2c30-2%2c60%2c35%2c90%2c149%2c7%2c514-380%2c589-597%2c206%2c121%2c284%2c246%2c439%2c461%2c55%2c76%2c99%2c29%2c128-25%2c62-243%2c67-481%2c66-724%2c267%2c99%2c579%2c138%2c915%2c47%2c69-19%2c36-70%2c4-102-62-114-105-250-113-365-9-133-14-226-43-287%2c202%2c68%2c405%2c108%2c614%2c52%2c29-297-53-579-211-850%2c330%2c80%2c655%2c73%2c908-112%2c57-41%2c35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520%2c483-187%2c696-463%2c822-766%2c22-66%2c6-99-73-104-231-10-480-24-711-27%2c437-478%2c606-961%2c604-1495-1-108-38-146-92-82-74%2c87-179%2c137-348%2c146-222%2c15-435%2c24-656%2c128-11-38-21-75-32-113%2c46-132%2c106-260%2c153-393%2c82-53%2c102-123%2c88-204%2c267-434%2c513-868%2c781-1302%2c54-79-46-162-171-74-60%2c42-110%2c64-170%2c106-117%2c80-257%2c134-437%2c145-251%2c54-417%2c167-428%2c397-293-175-564-73-814%2c307-11-239-41-457-302-432%2c75-168%2c17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z'/%3e%3cg fill='%23f7db17'%3e%3cpath d='m205075%2c47978c-51-26-124%2c17-162%2c95s-33%2c170%2c19%2c196c40%2c20%2c84-6%2c119-56l22-36c2-3%2c4-6%2c5-9%2c38-78%2c49-163-2-188z'/%3e%3cpath d='m200067%2c47978c52-26%2c124%2c17%2c162%2c95s39%2c165-13%2c191-103-24-141-102-60-158-9-184z'/%3e%3cpath d='m204606%2c48883c-32%2c0-59%2c27-59%2c59s26%2c59%2c59%2c59%2c59-26%2c59-59c0-32-26-59-59-59z'/%3e%3cpath d='m200574%2c48883c-32%2c0-59%2c26-59%2c59%2c0%2c32%2c26%2c59%2c59%2c59s59-26%2c59-59-26-59-59-59z'/%3e%3cpath d='m204868%2c48579c-754-91-1506-133-2260-133s-1509%2c41-2269%2c115c-26%2c8-21%2c90%2c14%2c86%2c756-73%2c1507-113%2c2256-113%2c743%2c0%2c1485%2c40%2c2228%2c129%2c39%2c4%2c54-80%2c32-84z'/%3e%3cpath d='m200319%2c48495c768-75%2c1530-117%2c2289-116%2c754%2c0%2c1507%2c42%2c2261%2c133l111-184c-32%2c10-62%2c9-90-5-76-38-92-161-36-274%2c56-114%2c164-175%2c240-138%2c39%2c19%2c62%2c62%2c68%2c114l446-739c-204%2c130-328%2c214-581%2c252-281%2c41-409%2c139-368%2c307%2c38%2c156-57%2c133-201%2c54-314-171-541%2c71-652%2c353-73%2c186-159%2c181-168-13-4-70%2c0-131-7-200-21-223-89-286-216-224-161%2c78-175%2c25-137-58%2c28-60%2c86-128%2c66-221-9-67-66-92-151-98-182-244-467-483-649-727-182%2c244-374%2c483-556%2c727-86%2c5-142%2c30-152%2c98-20%2c93%2c52%2c157%2c80%2c217%2c38%2c82%2c23%2c135-137%2c57-127-61-186-3-207%2c220-7%2c69-10%2c139-13%2c209-9%2c194-95%2c199-168%2c13-111-282-352-524-667-353-145%2c79-203%2c102-182-54%2c23-172-107-266-388-307-253-37-377-122-581-252l419%2c682c12-25%2c29-45%2c53-57%2c76-38%2c184%2c24%2c240%2c138%2c56%2c113%2c40%2c237-36%2c274-10%2c5-21%2c8-32%2c10l100%2c163z'/%3e%3cpath d='m204708%2c49406c-7%2c3-7%2c4-24%2c11-46%2c19-80%2c66-134%2c124-57%2c60-128%2c125-211%2c188-12%2c10-25%2c19-44-6s-7-35%2c6-44c80-62%2c149-124%2c204-182%2c30-32%2c56-63%2c77-92-95-11-190-21-284-30-79%2c24-157%2c55-222%2c95-59%2c35-107%2c77-137%2c125-8%2c14-16%2c27-44%2c11-27-16-19-30-11-44%2c35-58%2c91-107%2c158-147%2c33-20%2c69-38%2c106-54-107-9-214-18-321-25-22%2c13-42%2c29-61%2c47-20%2c19-39%2c42-56%2c67-9%2c13-18%2c26-44%2c8s-18-31-8-44c19-29%2c41-54%2c64-77%2c3-3%2c6-6%2c9-9-80-5-161-10-241-14-2%2c2-5%2c5-8%2c7-21%2c18-40%2c38-55%2c59s-28%2c43-38%2c67c-6%2c15-12%2c29-41%2c18-29-12-23-26-17-41%2c12-29%2c27-55%2c45-81%2c8-11%2c18-22%2c27-33-115-5-230-9-344-12-4%2c5-9%2c8-14%2c11-25%2c15-47%2c32-66%2c51s-35%2c40-48%2c63c-8%2c14-16%2c28-43%2c12-28-16-20-29-12-43%2c16-28%2c35-54%2c59-77%2c7-7%2c14-13%2c21-19-122-2-244-4-365-4-120%2c0-240%2c1-360%2c3%2c8%2c7%2c15%2c13%2c22%2c20%2c23%2c23%2c42%2c49%2c59%2c77%2c8%2c14%2c16%2c27-12%2c43s-35%2c2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115%2c2-230%2c6-345%2c11%2c11%2c11%2c20%2c23%2c29%2c35%2c19%2c25%2c33%2c52%2c45%2c81%2c6%2c15%2c12%2c29-17%2c41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81%2c4-162%2c8-243%2c13%2c4%2c4%2c9%2c8%2c13%2c12%2c24%2c23%2c45%2c48%2c64%2c77%2c9%2c13%2c18%2c26-8%2c44s-35%2c5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110%2c7-220%2c14-330%2c23%2c43%2c18%2c85%2c38%2c122%2c61%2c67%2c40%2c124%2c89%2c158%2c147%2c8%2c14%2c16%2c27-11%2c44-27%2c16-35%2c3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90%2c7-179%2c15-268%2c24%2c22%2c33%2c51%2c68%2c86%2c106%2c55%2c58%2c124%2c120%2c204%2c182%2c13%2c9%2c25%2c19%2c6%2c44s-32%2c15-44%2c6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79%2c36%2c85%2c75%2c164%2c126%2c229%2c53%2c68%2c120%2c121%2c209%2c147%2c8%2c2%2c21%2c16%2c22%2c25%2c28%2c157%2c84%2c286%2c169%2c386%2c52%2c60%2c114%2c110%2c188%2c149-75-81-132-166-172-251-67-142-90-286-77-420%2c1-16%2c3-32%2c34-29%2c32%2c3%2c30%2c19%2c29%2c35-11%2c123%2c9%2c256%2c72%2c387%2c56%2c118%2c159%2c237%2c291%2c346%2c24%2c19%2c0%2c63-29%2c55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205%2c28%2c428%2c182%2c801%2c456%2c1137%2c61%2c75%2c165%2c182%2c255%2c216%2c92%2c35%2c95%2c100-20%2c101-34%2c1-69%2c1-105%2c1%2c84%2c31%2c164%2c66%2c233%2c105%2c127%2c73%2c217%2c162%2c224%2c273%2c1%2c16%2c2%2c32-29%2c34-32%2c2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154%2c0-312-1-459%2c3%2c39%2c28%2c80%2c57%2c131%2c84%2c82%2c44%2c188%2c86%2c343%2c122%2c89%2c21%2c166%2c52%2c233%2c91%2c71%2c42%2c130%2c93%2c177%2c150%2c10%2c12%2c20%2c25-5%2c45s-34%2c8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123%2c180%2c393%2c450%2c573%2c835%2c689%2c23%2c7%2c43%2c13%2c61%2c19%2c3%2c1%2c6%2c1%2c9%2c2%2c86%2c21%2c175%2c40%2c266%2c55%2c92%2c15%2c166%2c28%2c261%2c37%2c16%2c1%2c32%2c3%2c29%2c34-3%2c32-19%2c30-34%2c29-99-9-174-22-266-38-58-10-115-21-171-33-26%2c6-64%2c9-107%2c12-232%2c14-420%2c225-435%2c494%2c0%2c5%2c0%2c11-1%2c16%2c88-80%2c179-157%2c273-212%2c117-68%2c239-103%2c364-69%2c15%2c4%2c31%2c8%2c22%2c39-8%2c31-23%2c27-39%2c22-106-28-212%2c3-316%2c63-108%2c63-213%2c158-315%2c253-24%2c147-82%2c285-205%2c377%2c61%2c34%2c104%2c65%2c163%2c45%2c86-39%2c172-78%2c261-108%2c91-31%2c184-52%2c282-57%2c16-1%2c32-1%2c33%2c31s-14%2c32-31%2c33c-91%2c4-179%2c24-264%2c53-75%2c26-149%2c58-222%2c91%2c221%2c47%2c460-1%2c667-79%2c60-22%2c105-42%2c133-41%2c51-30%2c112-53%2c172-79%2c66-28%2c132-51%2c182-57%2c16-2%2c32-4%2c35%2c28%2c4%2c32-12%2c33-28%2c35-112%2c13-127%2c21-222%2c79%2c0%2c21-66%2c57-126%2c96-36%2c24-70%2c52-87%2c67-95%2c86-144%2c181-188%2c287-29%2c70-52%2c145-68%2c224%2c55-108%2c121-211%2c201-303%2c94-108%2c208-201%2c345-265%2c14-7%2c29-13%2c42%2c15%2c13%2c29-1%2c35-15%2c42-129%2c60-236%2c147-324%2c250-90%2c103-161%2c222-219%2c345-31%2c64-8%2c1-42%2c86%2c110-122%2c212-224%2c323-307%2c132-100%2c283-157%2c418-133%2c15%2c3%2c31%2c6%2c26%2c37s-21%2c28-37%2c26c-116-21-250%2c32-369%2c121-121%2c92-244%2c223-366%2c361%2c184%2c26%2c366-26%2c542-85%2c91-30%2c183-135%2c239-152%2c19-24%2c38-46%2c57-67%2c33-37%2c67-71%2c102-100%2c12-10%2c24-20%2c45%2c4s8%2c34-4%2c45c-33%2c28-65%2c60-96%2c94-32%2c35-62%2c73-92%2c113-6%2c8-13%2c17-24%2c16-60%2c70-151%2c162-172%2c240-57%2c210-25%2c370-122%2c576%2c71-38%2c128-81%2c175-134%2c53-60%2c94-135%2c128-230%2c37-104%2c95-195%2c167-270%2c75-77%2c165-136%2c261-172%2c15-5%2c30-11%2c41%2c19s-4%2c35-19%2c41c-87%2c32-169%2c86-238%2c157-66%2c68-119%2c151-153%2c247-37%2c102-81%2c183-141%2c250-44%2c50-95%2c91-156%2c127%2c52-3%2c78-10%2c121-7%2c79-6%2c211-66%2c279-119%2c66-51%2c116-120%2c154-206%2c6-15%2c13-29%2c42-16s23%2c27%2c16%2c42c-42%2c96-99%2c174-173%2c231-56%2c43-121%2c75-196%2c93%2c161-5%2c311-42%2c467-100%2c65-24%2c87-168%2c127-208%2c32-58%2c66-112%2c105-158%2c47-56%2c101-101%2c164-127%2c15-6%2c29-12%2c41%2c18%2c12%2c29-3%2c35-17%2c41-52%2c21-98%2c60-139%2c108-36%2c42-68%2c93-98%2c147%2c10%2c73-51%2c228-53%2c305-7%2c205-2%2c409%2c53%2c612%2c53-71%2c107-134%2c162-192%2c0-5%2c0-10%2c1-15%2c18-106%2c33-219%2c40-332%2c7-112%2c7-223-6-329-2-16-4-32%2c27-35%2c32-4%2c34%2c12%2c35%2c28%2c14%2c111%2c14%2c226%2c7%2c340-6%2c90-16%2c180-30%2c269%2c54-51%2c53-51%2c77-103%2c37-80%2c59-159%2c67-237%2c9-80%2c5-157-13-230-4-15-7-31%2c24-38s35%2c8%2c38%2c24c19%2c80%2c25%2c165%2c14%2c252-8%2c65-24%2c132-49%2c199%2c56-42%2c114-82%2c178-122-4-75-5-153-3-227%2c2-68%2c7-134%2c18-190%2c4-20%2c7-40%2c47-33s37%2c27%2c33%2c48c-9%2c50-14%2c111-16%2c177-2%2c78%2c0%2c162%2c4%2c243%2c5%2c82%2c49%2c185%2c125%2c230%2c103%2c62%2c158%2c163%2c186%2c274%2c16-145%2c17-280%2c3-400-17-143-55-267-114-368-8-14-16-27%2c12-44%2c27-16%2c35-2%2c43%2c12%2c63%2c110%2c104%2c241%2c122%2c393%2c17%2c146%2c13%2c310-13%2c488%2c102-82%2c381-258%2c352-594-7-27-16-52-28-75-7-14-14-28%2c14-42s35%2c0%2c42%2c14c17%2c33%2c30%2c69%2c39%2c110%2c5%2c24%2c8%2c49%2c11%2c76%2c13-7%2c45-43%2c51-39%2c24%2c16%2c58%2c38%2c80%2c54-21-60-35-120-42-178-10-87-5-172%2c14-252%2c4-15%2c7-31%2c38-24s27%2c23%2c24%2c38c-18%2c73-22%2c151-13%2c230%2c9%2c77%2c31%2c157%2c67%2c237%2c4%2c8%2c8%2c16%2c5%2c25%2c24%2c21%2c47%2c42%2c70%2c65-13-84-22-170-28-255-8-115-7-230%2c7-341%2c2-16%2c4-32%2c35-28s29%2c20%2c27%2c35c-13%2c106-13%2c217-6%2c329%2c7%2c113%2c22%2c225%2c40%2c332%2c1%2c2%2c1%2c5%2c1%2c7%2c54%2c59%2c95%2c120%2c152%2c196%2c55-203%2c73-407%2c66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41%2c12-29%2c27-24%2c41-18%2c62%2c26%2c117%2c71%2c164%2c127%2c38%2c45%2c72%2c98%2c103%2c154%2c57%2c7%2c78%2c179%2c143%2c212%2c154%2c57%2c298%2c94%2c453%2c100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29%2c16-42s35%2c2%2c42%2c16c38%2c86%2c88%2c156%2c154%2c206%2c85%2c66%2c289%2c124%2c400%2c127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41%2c11-29%2c26-24%2c41-19%2c96%2c36%2c186%2c94%2c261%2c172%2c72%2c74%2c130%2c166%2c167%2c270%2c34%2c95%2c75%2c169%2c128%2c230%2c47%2c54%2c105%2c98%2c177%2c135-98-207-66-367-122-577-35-129-232-277-193-320%2c45-51%2c133%2c88%2c248%2c127%2c175%2c59%2c357%2c111%2c540%2c85-122-138-244-269-366-361-119-90-237-140-352-120-16%2c3-31%2c6-37-26-5-31%2c10-34%2c26-37%2c135-24%2c269%2c32%2c401%2c132%2c111%2c84%2c201%2c175%2c311%2c298-18-47%2c0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42%2c13-28%2c28-22%2c42-15%2c137%2c65%2c251%2c157%2c345%2c265%2c81%2c93%2c147%2c198%2c203%2c307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35%2c4-32%2c19-30%2c35-28%2c50%2c6%2c115%2c28%2c182%2c56%2c33%2c14%2c66%2c43%2c98%2c60%2c53%2c4%2c139%2c47%2c208%2c74%2c206%2c78%2c446%2c126%2c666%2c79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31%2c33-31c98%2c4%2c191%2c26%2c282%2c57%2c89%2c30%2c175%2c69%2c261%2c108%2c59%2c27%2c101-7%2c163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15%2c4-31%2c8-39-22-8-31%2c7-35%2c22-39%2c125-33%2c247%2c1%2c364%2c69%2c94%2c55%2c186%2c132%2c274%2c213%2c0-6-1-11-1-17-15-270-203-480-435-494-78-5-189%2c21-186-32%2c4-59%2c97-44%2c234-86%2c385-116%2c655-296%2c836-690-54%2c41-110%2c83-186%2c124-86%2c47-198%2c91-358%2c128-82%2c19-154%2c48-216%2c84-64%2c38-117%2c84-159%2c135-10%2c12-20%2c25-45%2c5s-14-32-5-45c47-57%2c106-108%2c177-150%2c67-39%2c145-70%2c233-91%2c155-36%2c261-78%2c343-122%2c51-27%2c92-55%2c131-84-148-4-305-3-459-3-143%2c44-289%2c96-402%2c160-110%2c63-186%2c136-192%2c223-1%2c16-2%2c32-34%2c29-32-2-31-18-29-34%2c8-111%2c97-200%2c224-273%2c69-39%2c149-74%2c233-105-35%2c0-70%2c0-104-1-116-2-112-66-20-101%2c90-34%2c190-141%2c251-216%2c271-334%2c412-714%2c456-1130-33%2c72-69%2c140-115%2c198-57%2c73-128%2c131-222%2c164-31%2c160-91%2c293-180%2c397-92%2c108-216%2c185-369%2c230-29%2c8-52-35-29-55%2c132-109%2c221-226%2c278-344%2c62-131%2c83-264%2c72-387-1-16-3-32%2c29-35%2c31-3%2c33%2c13%2c34%2c29%2c12%2c134-10%2c278-78%2c420-40%2c85-97%2c170-172%2c251%2c73-39%2c136-89%2c187-149%2c85-100%2c141-229%2c170-386%2c1-8%2c14-22%2c22-25%2c89-27%2c155-79%2c209-147%2c51-65%2c90-143%2c126-228-140%2c69-304%2c64-457%2c78-213%2c19-369%2c68-554%2c152z'/%3e%3cpath d='m204649%2c49231c-680-88-1359-113-2041-114-684%2c0-1369%2c40-2058%2c112-20%2c6-15%2c33-14%2c46%2c2%2c28%2c37%2c35%2c121%2c27%2c643-60%2c1285-93%2c1932-93%2c674%2c0%2c1351%2c21%2c2038%2c102%2c33%2c9%2c77-85%2c22-81z'/%3e%3cpath fill-rule='evenodd' d='m200570%2c49160c683-71%2c1362-110%2c2038-110%2c675%2c0%2c1349%2c40%2c2025%2c127l31-127c-17%2c9-37%2c15-58%2c15-67%2c0-123-55-123-123s55-123%2c123-123c51%2c0%2c94%2c31%2c113%2c75l60-170c-724-84-1446-122-2171-122-729%2c0-1459%2c38-2193%2c107l58%2c164c22-32%2c59-54%2c101-54%2c68%2c0%2c123%2c55%2c123%2c123s-55%2c123-123%2c123c-12%2c0-25-2-36-6l33%2c94-2%2c7zm3067-416c-68%2c0-123%2c55-123%2c123s55%2c123%2c123%2c123%2c123-55%2c123-123-55-123-123-123zm0%2c64c-33%2c0-59%2c27-59%2c59s26%2c59%2c59%2c59c32%2c0%2c59-27%2c59-59s-26-59-59-59zm-1082-91c-67%2c0-123%2c55-123%2c123s55%2c123%2c123%2c123%2c123-55%2c123-123-55-123-123-123zm0%2c64c-32%2c0-59%2c26-59%2c59s26%2c59%2c59%2c59%2c59-26%2c59-59c0-32-26-59-59-59zm-1064-40c-68%2c0-123%2c55-123%2c123s55%2c123%2c123%2c123c67%2c0%2c123-55%2c123-123s-55-123-123-123zm0%2c64c-33%2c0-59%2c26-59%2c59s26%2c59%2c59%2c59c32%2c0%2c59-26%2c59-59%2c0-32-26-59-59-59z'/%3e%3c/g%3e%3cg fill='black'%3e%3cpath d='m202601%2c47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68%2c60-20%2c114-67%2c157-133%2c45-69%2c79-157%2c95-256%2c5-34%2c64-35%2c69-1%2c15%2c84%2c51%2c153%2c97%2c208%2c55%2c66%2c125%2c112%2c193%2c138%2c31%2c12%2c25%2c63-8%2c68-59%2c9-105%2c42-141%2c87-50%2c62-81%2c145-100%2c221-8%2c33-62%2c31-69-2zm33-118c20-52%2c47-103%2c81-146%2c28-34%2c60-64%2c99-84-51-30-100-70-143-120-28-34-53-73-73-116-19%2c59-45%2c112-75%2c158-31%2c47-67%2c86-108%2c116%2c50%2c19%2c95%2c47%2c134%2c82%2c34%2c31%2c63%2c68%2c85%2c110z'/%3e%3cpath d='m203433%2c52971-515%2c206c-17%2c7-35%2c14-48-21-14-34%2c4-41%2c21-48l515-206c17-7%2c35-14%2c48%2c21%2c14%2c34-4%2c41-21%2c48zm59-326-604%2c328c-16%2c9-33%2c18-51-15s-1-42%2c15-51l604-328c16-9%2c33-18%2c51%2c15s1%2c42-15%2c51zm-1826-65%2c604%2c328c16%2c9%2c33%2c18%2c15%2c51s-34%2c24-51%2c15l-604-328c-16-9-33-18-15-51s34-24%2c51-15zm51%2c322%2c515%2c206c18%2c7%2c35%2c14%2c21%2c48-14%2c35-31%2c28-49%2c21l-515-206c-17-7-34-14-21-48%2c14-35%2c31-28%2c48-21zm224%2c434c137%2c33%2c261%2c48%2c358%2c31%2c88-16%2c155-60%2c191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329%2c5-18%2c9-36%2c45-27s32%2c27%2c27%2c45c-20%2c82-33%2c194%2c1%2c284%2c23%2c60%2c69%2c110%2c152%2c133%2c91%2c25%2c198%2c38%2c307%2c38%2c107%2c0%2c214-13%2c304-40%2c82-24%2c148-69%2c192-123s65-117%2c57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94%2c7-142%2c16-25%2c5-50%2c9-77%2c13-19%2c2-37%2c5-42-32s14-40%2c32-42c23-3%2c48-8%2c73-12%2c52-10%2c105-20%2c159-18%2c60%2c2%2c121%2c18%2c168%2c51%2c42%2c29%2c72%2c72%2c80%2c131%2c11%2c80-16%2c163-73%2c233-53%2c65-131%2c119-229%2c147-83%2c24-178%2c38-274%2c42v483c3%2c5%2c3%2c11%2c2%2c16%2c37%2c82%2c102%2c125%2c188%2c141%2c97%2c18%2c221%2c2%2c358-31%2c18-5%2c36-9%2c45%2c27%2c8%2c37-9%2c41-28%2c45-146%2c35-279%2c51-388%2c32-92-17-165-58-215-132-49%2c74-124%2c115-215%2c132-109%2c20-242%2c4-388-32-18-4-37-8-28-45%2c8-36%2c27-32%2c45-27zm356%2c210%2c402-9c19%2c0%2c38-1%2c38%2c37%2c1%2c38-18%2c38-37%2c38l-402%2c9c-19%2c0-37%2c1-38-37s18-38%2c37-38z'/%3e%3cpath d='m202890%2c50464c151-125%2c293-227%2c423-297%2c133-72%2c254-111%2c359-106%2c19%2c1%2c37%2c1%2c36%2c39-1%2c37-20%2c37-39%2c36-92-4-200%2c32-322%2c97-125%2c67-263%2c166-410%2c289-14%2c12-29%2c24-53-5s-9-41%2c5-53zm-605%2c56c-141-130-298-240-445-314-139-71-268-108-363-100-19%2c2-37%2c4-40-34-4-37%2c15-39%2c34-40%2c110-10%2c252%2c31%2c404%2c107%2c152%2c77%2c315%2c191%2c461%2c325%2c14%2c13%2c28%2c25%2c2%2c53-25%2c27-39%2c15-53%2c2zm-213%2c1004c37-83%2c83-155%2c136-219%2c53-63%2c112-119%2c174-170%2c14-12%2c29-24%2c52%2c5%2c24%2c29%2c9%2c41-5%2c53-59%2c48-114%2c101-164%2c160-49%2c59-91%2c125-125%2c201-8%2c17-15%2c34-49%2c19s-27-32-19-49zm371-1734c49%2c66%2c88%2c139%2c114%2c223%2c26%2c82%2c40%2c175%2c39%2c279%2c5%2c80%2c6%2c165-7%2c249-13%2c86-42%2c170-97%2c246-43%2c60-101%2c97-165%2c113-53%2c13-109%2c10-164-7%2c29%2c100%2c51%2c208%2c6%2c308-8%2c18-33%2c27-51%2c18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1%2c2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27%2c1-53s40-12%2c53%2c1c39%2c40%2c89%2c80%2c150%2c121%2c60%2c40%2c128%2c81%2c204%2c121%2c124%2c13%2c247%2c51%2c370%2c109%2c106%2c50%2c211%2c115%2c317%2c192%2c13%2c7%2c19%2c16%2c27%2c20%2c8%2c6%2c16%2c13%2c25%2c19%2c51%2c22%2c104%2c28%2c152%2c16%2c47-11%2c90-39%2c122-84%2c48-66%2c72-139%2c84-214%2c12-77%2c11-157%2c6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30%2c7-52s41-7%2c52%2c7zm-375%2c1047c-104-77-207-141-311-190-105-49-210-83-314-98%2c2%2c48%2c8%2c93%2c18%2c135%2c13%2c52%2c35%2c99%2c71%2c138l1%2c1c30%2c37%2c73%2c72%2c130%2c107%2c60%2c36%2c134%2c71%2c225%2c106l-1-1c45%2c16%2c89%2c34%2c133%2c54%2c31%2c14%2c61%2c28%2c93%2c44%2c19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44%2c59-79%2c125-102%2c201-24%2c76-36%2c161-35%2c258v2c-5%2c77-6%2c158%2c6%2c234%2c12%2c75%2c37%2c148%2c84%2c214%2c32%2c45%2c75%2c72%2c122%2c84%2c48%2c12%2c101%2c6%2c152-16%2c8-6%2c17-13%2c25-19%2c6-4%2c13-12%2c27-20%2c105-77%2c211-143%2c317-192%2c123-58%2c246-95%2c370-109%2c75-40%2c144-80%2c204-121s111-81%2c149-121c13-13%2c26-27%2c53-1s14%2c39%2c0%2c53c-43%2c44-97%2c88-161%2c131-57%2c38-122%2c77-194%2c116-2%2c61-8%2c119-22%2c174-16%2c63-44%2c121-88%2c170l1-2c-35%2c44-85%2c85-150%2c124-63%2c38-141%2c75-237%2c112l-1%2c1c-43%2c15-85%2c32-127%2c51-43%2c19-85%2c40-128%2c62-18%2c9-43%2c0-51-18-45-100-23-208%2c6-308-55%2c18-111%2c20-164%2c7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104%2c13-196%2c39-279%2c26-84%2c65-158%2c114-223%2c11-15%2c22-30%2c52-7%2c30%2c22%2c19%2c37%2c7%2c52zm940%2c715c-105%2c15-209%2c49-314%2c98-104%2c49-207%2c113-311%2c190-4%2c13-6%2c21-8%2c29-27%2c88-56%2c184-37%2c267%2c31-15%2c62-30%2c93-44%2c44-20%2c87-38%2c133-54l-1%2c1c91-35%2c165-70%2c225-106%2c58-34%2c100-70%2c131-107%2c0%2c0%2c1-1%2c1-1%2c35-39%2c57-86%2c71-138%2c11-42%2c16-87%2c19-135z'/%3e%3cpath fill-rule='evenodd' d='m203459%2c50602c-119%2c0-216%2c97-216%2c216s97%2c217%2c216%2c217%2c216-97%2c216-217c0-119-97-216-216-216zm0%2c69c-81%2c0-147%2c66-147%2c147s66%2c147%2c147%2c147%2c147-66%2c147-147-66-147-147-147zm0%2c60c-48%2c0-87%2c39-87%2c87s39%2c87%2c87%2c87%2c87-39%2c87-87-39-87-87-87zm-1697-124c119%2c0%2c217%2c97%2c217%2c216s-97%2c217-217%2c217c-119%2c0-216-97-216-217%2c0-119%2c97-216%2c216-216zm0%2c69c81%2c0%2c147%2c66%2c147%2c147s-66%2c147-147%2c147-147-66-147-147%2c66-147%2c147-147zm0%2c60c48%2c0%2c87%2c39%2c87%2c87s-39%2c87-87%2c87-87-39-87-87%2c39-87%2c87-87z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23lion' transform='matrix(0.99928092%2c-0.03791625%2c0.03791625%2c0.99928092%2c-5965.3264%2c-1993.2203)'/%3e%3cuse xlink:href='%23lion' transform='matrix(0.99927613%2c0.03804216%2c-0.03804216%2c0.99927613%2c6277.9506%2c-17381.167)'/%3e%3c/g%3e%3cg%3e%3cpath fill='%23171796' d='m230880%2c40035-25%2c9-8100-9258-10650%2c6104-1796%2c21560c5212%2c432%2c10304%2c1293%2c15241%2c2551l5329-20965z'/%3e%3cpath fill='black' d='m214206%2c41363c370-90%2c735-109%2c1089%2c108%2c155%2c64%2c272%2c146%2c344%2c251%2c164-127%2c331-246%2c504-348%2c243-180%2c491-339%2c758-428%2c382-194%2c763-309%2c1145-344%2c404-69%2c810-73%2c1214-49%2c337%2c20%2c663%2c113%2c974%2c292%2c282%2c140%2c563%2c281%2c845%2c421%2c298%2c166%2c596%2c316%2c894%2c442%2c378%2c149%2c803%2c199%2c1256%2c216%2c222%2c8%2c440%2c8%2c654-49%2c173-46%2c281%2c64%2c90%2c181-1400%2c859-2497%2c95-3433-247%2c343%2c232%2c645%2c472%2c900%2c717%2c356%2c343%2c754%2c691%2c1458%2c1012%2c427%2c194%2c892%2c347%2c1489%2c352%2c202%2c2%2c420-6%2c656-45%2c119-19%2c170-8%2c172%2c54%2c2%2c42-9%2c126-80%2c173-361%2c242-701%2c306-1080%2c330-722%2c46-1494-191-2200-570-565-304-946-674-1396-1006-449-331-837-515-1254-603-411-88-856-78-1231%2c38%2c112%2c22%2c207%2c75%2c265%2c142%2c193%2c114%2c441%2c164%2c800%2c205%2c187%2c22%2c129%2c151-159%2c306-173%2c223-398%2c343-697%2c314-412%2c273-559%2c108-697-71-17%2c113-50%2c224-99%2c331%2c18%2c58%2c20%2c122-6%2c180%2c66%2c102%2c98%2c201%2c76%2c310%2c11%2c58%2c30%2c114%2c92%2c166%2c86%2c78%2c141%2c168%2c152%2c278%2c1%2c73%2c41%2c133%2c99%2c187%2c84%2c69%2c169%2c130%2c253%2c233%2c249%2c90%2c364%2c281%2c405%2c528%2c188%2c61%2c266%2c197%2c303%2c359%2c107%2c45%2c205%2c99%2c261%2c194%2c384%2c1%2c759%2c1%2c1110%2c38%2c329%2c35%2c597%2c240%2c837%2c506%2c162%2c25%2c326%2c33%2c494-5%2c173-76%2c356-134%2c555-151%2c329-28%2c659-45%2c973%2c30%2c213%2c51%2c379%2c164%2c515%2c318%2c196%2c223%2c498%2c193%2c756%2c83%2c350-149%2c641-144%2c999%2c13%2c153-59%2c306-87%2c459-71%2c131-142%2c270-177%2c413-181%2c233-8%2c402%2c28%2c358%2c327-12%2c81-60%2c159-121%2c187-107%2c231-311%2c299-570%2c277-28%2c159-93%2c277-197%2c353%2c119%2c367%2c5%2c514-267%2c509-57%2c106-142%2c172-287%2c151-106%2c129-231%2c195-368%2c217%2c16%2c96%2c57%2c141%2c125%2c244%2c185%2c280-93%2c393-347%2c397%2c65%2c185%2c73%2c370%2c50%2c555%2c259%2c157%2c294%2c322%2c55%2c485%2c175%2c306%2c107%2c531-221%2c695-5%2c171-22%2c343-136%2c439-78%2c66-190%2c78-116%2c202%2c133%2c220%2c104%2c498-93%2c506-42-4-80%2c2-83%2c69%2c0%2c23-20%2c46-59%2c69-236%2c127-457%2c272-660%2c439-30%2c20-60%2c34-90%2c7-148%2c322-424%2c649-729%2c978-47%2c242-184%2c406-411%2c491-16%2c75-64%2c119-135%2c138%2c127%2c141%2c175%2c277%2c52%2c411-151%2c165-350%2c326-549%2c377-423%2c108-688%2c88-858-74-150-143-91-251%2c4-296-261%2c21-314-117-307-301%2c15-92%2c46-80%2c138-77%2c142%2c4%2c270-73%2c404-117%2c52-88%2c120-164%2c204-228%2c47-296%2c234-460%2c488-557%2c205-78%2c401-276%2c591-532%2c117-202%2c235-403%2c352-605-82-107-104-214-107-321-108-60-183-134-235-218-184-13-260-96-287-211-42%2c1-88-3-138-18-90%2c58-181%2c109-294%2c104-149%2c153-303%2c278-460%2c384-55%2c152-164%2c213-297%2c232-378%2c45-604%2c516-812%2c708-84%2c62-136%2c172-173%2c304-18%2c248-61%2c442-197%2c446-122-5-141-18-145-31-53-5-106-5-159%2c7%2c102%2c112%2c118%2c253%2c24%2c377-94%2c122-229%2c160-359%2c169-269%2c18-487-6-689-88-193-79-216-194-210-306-139-66-167-132-152-197%2c19-84%2c96-127%2c193-100%2c84-40%2c168-67%2c252-83%2c244-263%2c495-489%2c771-594%2c81-98%2c174-186%2c287-259%2c32-236%2c187-422%2c377-595%2c17-85%2c45-171%2c93-256-11-51%2c3-75%2c4-123-77-143-123-315-66-458-23-69-30-159-21-228-454%2c270-594%2c178-646-41-166%2c139-321%2c204-432%2c4-161%2c48-323%2c102-484%2c38-105%2c41-211%2c78-332%2c86-49%2c97-115%2c194-204%2c291-5%2c204-76%2c408-207%2c612-76%2c218-170%2c435-294%2c653%2c2%2c70-8%2c140-45%2c211%2c35%2c251-49%2c373-187%2c435-37%2c101-92%2c203-176%2c304-4%2c33-7%2c67-11%2c100%2c55%2c148%2c64%2c295-86%2c443-121%2c76-250%2c156-378%2c219-151%2c74-291%2c39-418-7-223-80-206-158-177-234-70%2c28-150%2c31-220-3-54-34-88-69-142-104-48-87-65-166%2c52-228%2c147-65%2c247-113%2c363-232%2c40-90%2c91-158%2c163-176%2c70-164%2c156-275%2c273-305%2c86-203%2c178-427%2c287-621%2c38-59%2c66-120%2c48-187-2-55%2c2-107%2c48-138%2c26-22%2c72-42%2c14-73-53-181-20-354%2c69-487%2c118-178%2c250-608%2c125-819-23-118-46-253-31-364-43-2-75%2c4-118-26-96-59-176-3-249%2c104-53%2c134-106%2c252-159%2c252-50%2c346-220%2c615-397%2c684-41%2c159-67%2c318-45%2c477%2c18%2c173%2c0%2c291-80%2c311-88%2c22-170%2c73-221%2c214-14%2c39-30%2c86-31%2c142%2c122%2c126%2c85%2c283-32%2c399-264%2c260-592%2c222-939%2c120-251-99-312-204-287-311-356-30-285-303%2c10-385%2c317-89%2c574-292%2c785-582%2c19-344%2c98-578%2c283-615%2c18-211%2c84-401%2c173-581%2c93-163%2c150-342%2c117-560-197-123-205-250-24-380%2c60-35%2c53-71-21-107-120-12-105-127-97-235-5-56-34-85-87-86-266-39-200-148-86-266%2c48-54%2c80-134%2c30-166-41-26-69-117-78-197-163-123-93-249%2c0-370-92-78-135-192-148-325-303-13-416-167-252-391%2c69-95%2c158-186%2c266-273%2c70-113%2c137-226%2c104-339-87-221%2c191-388%2c429-560-33-58-50-115-52-173-134-129-100-249%2c48-363-33-59-49-118-55-176-333%2c66-331-133-176-453-193-111-139-308%2c211-608%2c5-69%2c18-122%2c38-159-166%2c4-303%2c53-422%2c128-133%2c87-265%2c76-398%2c21-41-66-104-122-176-173-91-80-112-170-93-266-392%2c22-467-268-232-439%2c131-104%2c227-213%2c263-332%2c106-269%2c331-452%2c550-640%2c0-77%2c17-154%2c41-232-97-65-199-112-311-121-40-100-115-208-242-269-73-44-97-85-52-184-208-186-156-299-103-406z'/%3e%3cg fill='%23f7db17'%3e%3cpath d='m221318%2c51461c-23%2c2-47%2c4-74%2c3-101%2c103-222%2c206-334%2c294-97-112-241%2c11-100%2c79-24%2c17-48%2c34-72%2c50-46%2c122-88%2c174-224%2c195-21%2c3-42%2c7-63%2c12-1-52%2c1-102%2c6-151%2c6-61%2c16-120%2c29-178%2c2-11%2c5-21-16-26s-24%2c6-26%2c17c-13%2c60-24%2c121-31%2c183-6%2c55-8%2c111-6%2c167-343%2c110-541%2c467-775%2c721-101%2c87-152%2c207-189%2c333-20%2c67-27%2c374-96%2c379-33%2c1-68%2c0-105%2c0-37-56-87-57-150-4-143-3-295-4-422%2c16-87%2c94%2c152%2c59%2c279%2c137%2c58%2c35%2c83%2c104%2c60%2c200-117%2c279-770%2c189-987%2c74-101-53-105-114-101-201%2c45%2c0%2c91-3%2c137-10%2c78-11%2c155-34%2c231-77%2c21-12%2c43-24%2c19-67s-46-31-67-19c-64%2c37-130%2c56-196%2c65-68%2c10-138%2c10-205%2c7-6%2c0-12-1-17%2c0-38-22-67-48-51-71%2c16-22%2c79%2c2%2c91%2c6%2c101-47%2c189-77%2c298-98%2c230-246%2c464-477%2c781-604%2c95-114%2c198-204%2c322-286%2c44-274%2c177-420%2c376-602%2c24-113%2c52-194%2c108-293-12-63-3-103%2c0-167-76-144-121-269-61-430-37-117-32-196-18-304%2c4-28%2c3-48-1-61%2c62-49%2c125-95%2c187-137%2c57-38%2c114-73%2c171-105-9%2c108-5%2c221%2c16%2c339%2c0%2c0-1%2c1-1%2c1-34%2c37-63%2c73-83%2c111-21%2c39-33%2c78-31%2c117%2c0%2c11%2c0%2c22%2c22%2c21%2c22%2c0%2c22-11%2c21-22-1-31%2c8-63%2c26-95%2c18-33%2c45-67%2c77-101%2c3-3%2c6-7%2c8-11%2c105-3%2c208-59%2c311-142%2c93-76%2c186-174%2c278-277-1%2c150-2%2c300-4%2c450-90%2c80-167%2c178-227%2c297-5%2c10-10%2c19%2c9%2c29%2c20%2c10%2c25%2c0%2c29-10%2c55-109%2c125-199%2c206-274h4c22%2c0%2c22-11%2c22-22v-1c14-12%2c29-24%2c44-35%2c102-79%2c218-139%2c343-187-19%2c132-28%2c261-5%2c385%2c25%2c136%2c89%2c264%2c219%2c376%2c2%2c2%2c5%2c3%2c8%2c4z'/%3e%3cpath d='m214786%2c47657c17-31%2c60-71%2c74-68%2c3-1%2c5-1%2c8-2%2c47-88%2c96-170%2c147-244%2c66-96%2c136-181%2c210-253%2c8-8%2c16-15%2c31%2c0%2c15%2c16%2c7%2c23%2c0%2c31-72%2c70-140%2c152-205%2c246-50%2c73-98%2c153-144%2c240%2c15%2c20%2c22%2c51%2c14%2c73%2c15%2c137%2c33%2c214%2c94%2c293%2c7-6%2c14-11%2c21-14%2c25-61%2c59-115%2c101-163%2c52-58%2c115-107%2c191-148%2c52-43%2c94-87%2c128-133%2c34-45%2c61-91%2c80-138%2c4-10%2c8-20%2c29-12%2c20%2c8%2c16%2c19%2c12%2c29-21%2c51-49%2c100-85%2c148-37%2c48-82%2c95-138%2c141%2c0%2c0-3%2c2-4%2c2-71%2c39-132%2c85-180%2c139-37%2c41-66%2c87-89%2c138%2c32%2c23%2c46%2c86%2c16%2c126-91%2c131-199%2c208-29%2c320-6%2c88%2c22%2c155%2c80%2c216%2c39%2c41%2c35%2c184-61%2c287-90%2c91-21%2c67%2c72%2c78%2c7%2c2%2c14%2c5%2c21%2c7v-1c34-66%2c74-125%2c118-180%2c43-54%2c90-105%2c138-153%2c67-66%2c120-138%2c158-211%2c37-71%2c59-144%2c63-214%2c1-11%2c1-22%2c24-20%2c22%2c1%2c21%2c12%2c20%2c23-5%2c76-28%2c154-68%2c232-40%2c77-96%2c152-166%2c221-47%2c47-92%2c95-134%2c149-42%2c53-80%2c110-113%2c173%2c112%2c68%2c76%2c190%2c93%2c302%2c22%2c3%2c41%2c8%2c58%2c16%2c1-2%2c2-4%2c4-6%2c22-34%2c44-69%2c66-104l104-165c6-9%2c12-19%2c30-7%2c19%2c12%2c13%2c21%2c7%2c30l-104%2c165c-22%2c35-44%2c69-66%2c104-1%2c2-2%2c4-3%2c5%2c69%2c56%2c74%2c158-11%2c236-167%2c126-120%2c165%2c36%2c265%2c20%2c147%2c21%2c265-11%2c390%2c1%2c3%2c1%2c7%2c2%2c11%2c4%2c41%2c7%2c83%2c10%2c124l10%2c125c1%2c11%2c2%2c22-20%2c24s-23-9-24-20l-10-125c-1-11-2-21-2-32-8%2c19-16%2c39-26%2c60-112%2c245-228%2c445-253%2c720-269%2c64-229%2c329-244%2c563-212%2c286-458%2c515-799%2c629-64%2c21-219%2c59-234%2c140-2%2c29%2c104%2c92%2c172%2c55%2c188-180%2c282-80%2c66%2c104-17%2c35-3%2c74%2c34%2c107%2c195%2c175%2c678%2c232%2c898%2c93%2c163-102%2c248-214%2c106-369%2c9-220%2c95-435%2c327-497%2c27-50%2c19-143%2c7-194-22-191%2c8-361%2c55-545%2c8-23%2c25-42%2c63-52%2c88-18%2c257-273%2c310-518%2c13-53%2c21-108%2c31-163%2c14-85%2c47-100%2c90-50%2c41-55%2c40-88%2c65-151%2c90-131%2c220-236%2c372-162-39-107-66-228-74-351-11-146%2c3-297%2c48-435%2c6-21%2c13-41%2c46-36%2c44-104%2c87-207%2c131-311s88-209%2c132-313c4-10%2c8-20%2c28-12s16%2c19%2c12%2c29c-44%2c104-88%2c208-132%2c313-44%2c104-87%2c207-131%2c310%2c19%2c14%2c13%2c32%2c7%2c50-40%2c125-53%2c263-43%2c398%2c10%2c146%2c46%2c287%2c100%2c402%2c5%2c11%2c11%2c22%2c9%2c33%2c72%2c42%2c71%2c52%2c68%2c148-2%2c75%2c8%2c149%2c26%2c239%2c143%2c264-6%2c706-145%2c927-67%2c107-85%2c229-57%2c352%2c86%2c83%2c30%2c169-46%2c227-6%2c20%2c0%2c43%2c1%2c63%2c8%2c86-23%2c158-68%2c229-117%2c211-207%2c436-301%2c657-170%2c47-205%2c146-273%2c305-99%2c28-109%2c57-151%2c148-114%2c115-223%2c184-369%2c250-121%2c55-4%2c108%2c81%2c166%2c77%2c57%2c178-67%2c241-161%2c69-104%2c139-73%2c94%2c8-50%2c89-86%2c217-91%2c284-26%2c72%2c248%2c127%2c295%2c129%2c167%2c8%2c377-155%2c508-238%2c109-111%2c92-208%2c44-343l1-9c-70%2c2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29%2c8-20%2c19-16%2c29-12%2c78%2c32%2c153%2c59%2c229%2c75%2c63%2c14%2c128%2c21%2c197%2c19l11-105c87-107%2c147-212%2c194-340%2c185-87%2c186-177%2c161-375%2c41-80%2c50-127%2c47-218%2c122-217%2c222-439%2c305-674%2c146-194%2c216-377%2c199-608%2c13-90%2c46-141%2c112-138%2c48-67%2c91-136%2c130-213%2c8%2c1%2c16%2c2%2c24%2c2-2-5-1-11%2c0-16%2c12-53%2c26-100%2c44-139%2c17-39%2c37-70%2c60-95%2c27-66%2c37-130%2c30-192-7-64-29-126-65-187-22-25-42-51-49-78-9-31-3-62%2c28-93%2c8-8%2c16-15%2c31%2c0%2c15%2c16%2c8%2c24%2c0%2c31-18%2c17-21%2c33-16%2c49%2c6%2c20%2c22%2c41%2c41%2c63%2c0%2c0%2c2%2c4%2c2%2c4%2c39%2c67%2c65%2c136%2c72%2c207s-3%2c144-35%2c217c0%2c1-4%2c6-4%2c7-21%2c22-39%2c50-55%2c85-16%2c37-30%2c80-41%2c130-1%2c3-1%2c6-2%2c8%2c103%2c0%2c194-32%2c293-81%2c2-2%2c4-4%2c6-6%2c50-40%2c103-101%2c147-181%2c37-67%2c67-149%2c84-243%2c2-11%2c4-21%2c26-18%2c21%2c4%2c19%2c15%2c18%2c25-18%2c100-50%2c185-89%2c257-34%2c63-74%2c114-114%2c154%2c160%2c48%2c299%2c1%2c451-46-22-214-19-377%2c4-505%2c25-139%2c72-237%2c131-311%2c7-9%2c13-17%2c31-4%2c17%2c14%2c11%2c22%2c4%2c31-55%2c69-99%2c161-122%2c292-22%2c122-26%2c278-5%2c484%2c2-1%2c5-1%2c8-2%2c64%2c109%2c98%2c188%2c229%2c103%2c48-32%2c98-64%2c138-106%2c15-16%2c10-25%2c22-38%2c125-133%2c251-257%2c376-367%2c126-111%2c252-206%2c378-283%2c9-6%2c19-12%2c30%2c7s2%2c24-7%2c30c-124%2c75-248%2c170-372%2c278-107%2c94-214%2c198-321%2c310%2c6%2c19%2c9%2c52%2c12%2c102%2c11%2c148%2c38%2c237%2c249%2c156%2c118-45%2c130-50%2c239-115%2c53-32%2c98-59%2c129-66%2c69-54%2c137-105%2c206-151%2c67-45%2c135-86%2c202-122%2c11-80%2c29-158%2c55-233%2c65-192%2c174-370%2c311-538%2c1-1%2c6-5%2c7-6%2c114-62%2c207-135%2c281-218%2c75-83%2c131-176%2c173-277%2c4-10%2c8-20%2c29-12%2c20%2c8%2c16%2c19%2c12%2c29-44%2c105-103%2c202-180%2c289-77%2c86-172%2c162-290%2c226-133%2c164-239%2c336-301%2c521-22%2c65-39%2c131-49%2c200%2c4%2c1%2c8%2c5%2c12%2c13%2c10%2c20%2c0%2c25-9%2c29-3%2c1-6%2c3-9%2c5-13%2c108-10%2c222%2c10%2c340%2c93-3%2c187-55%2c282-132%2c101-82%2c204-195%2c306-310%2c1-3%2c1-5%2c4-7%2c25-82%2c57-154%2c99-212%2c45-62%2c100-109%2c168-138%2c10-4%2c20-9%2c29%2c12%2c8%2c20-1%2c24-12%2c29-60%2c26-110%2c68-150%2c123-40%2c56-71%2c126-95%2c206-1%2c156-3%2c312-4%2c468%2c5-4%2c11-8%2c16-13%2c115-89%2c247-155%2c390-207%2c15-6%2c32%2c8%2c29%2c24-22%2c140-34%2c279-11%2c407%2c22%2c120%2c76%2c232%2c184%2c332%2c41-74%2c89-140%2c141-200%2c18-21%2c37-41%2c56-60%2c1-2%2c2-4%2c5-5%2c41-41%2c83-79%2c127-115%2c32-29%2c64-59%2c95-89%2c32-29%2c64-59%2c96-89%2c8-8%2c16-15%2c31%2c1s7%2c24-1%2c31c-32%2c30-64%2c59-96%2c89-32%2c29-64%2c59-96%2c89%2c0%2c0-1%2c1-1%2c1-41%2c33-81%2c68-118%2c106%2c1%2c41%2c3%2c81%2c5%2c122%2c1%2c22%2c1%2c44%2c2%2c66%2c92%2c25%2c147%2c26%2c241%2c24%2c31%2c185%2c47%2c214%2c208%2c218-2-66-1-130%2c6-193%2c8-72%2c23-142%2c48-208%2c4-10%2c8-20%2c28-13%2c21%2c8%2c17%2c18%2c13%2c28-24%2c62-38%2c128-46%2c197-7%2c61-8%2c124-6%2c189h13c64%2c132%2c140%2c197%2c276%2c256%2c38-60%2c66-120%2c84-180%2c20-67%2c28-134%2c24-201-1-11-1-22%2c20-23%2c22-1%2c23%2c9%2c24%2c20%2c5%2c72-4%2c144-26%2c216s-57%2c143-105%2c214c-4%2c6-8%2c12-15%2c12%2c6%2c77%2c19%2c134%2c46%2c192%2c20-43%2c41-86%2c65-126%2c33-58%2c71-110%2c117-156%2c8-8%2c15-15%2c31%2c0%2c15%2c15%2c8%2c23%2c0%2c31-43%2c42-78%2c93-110%2c147-28%2c48-53%2c100-77%2c153%2c15%2c26%2c34%2c52%2c56%2c82-256%2c439-530%2c1047-1035%2c1247-261%2c103-375%2c236-427%2c515-98%2c76-168%2c153-232%2c259-170%2c57-322%2c142-506%2c134%2c0%2c119%2c39%2c171%2c158%2c172%2c227-114%2c278-135%2c298-119%2c28%2c24-32%2c187-220%2c319-29%2c18-28%2c29-11%2c59%2c159%2c249%2c576%2c160%2c800%2c101%2c160-42%2c449-232%2c529-392%2c31-74-39-169-109-247-320%2c49-259-258%2c16-130%2c93-28%2c105-29%2c131-132%2c245-95%2c347-198%2c403-461%2c247-266%2c495-540%2c673-859%2c49-60%2c78-166%2c64-221%2c44-52%2c68-118%2c84-178%2c16-64%2c26-127%2c24-191%2c0-11-1-22%2c21-23s22%2c10%2c23%2c21c2%2c68-8%2c135-25%2c203-14%2c52-32%2c104-51%2c156%2c16%2c40%2c24%2c67%2c59%2c57%2c214-172%2c430-293%2c661-436%2c16-98%2c79-146%2c176-150%2c39%2c1%2c53-11%2c67-47%2c54-135-14-228-79-340-60-167%2c47-207%2c154-287%2c112-83%2c104-303%2c108-430h1c-4-21-8-43-13-65-9-44-22-88-38-135-4-10-7-21%2c13-28%2c21-7%2c24%2c3%2c28%2c14%2c17%2c49%2c30%2c95%2c40%2c140%2c4%2c18%2c7%2c36%2c11%2c53%2c107-55%2c219-119%2c261-238%2c37-132-35-257-99-369-27%2c13-55%2c26-84%2c38-52%2c23-108%2c47-167%2c70-10%2c4-20%2c8-28-12s2-25%2c12-28c57-23%2c112-46%2c165-70%2c44-19%2c86-39%2c125-58%2c48-32%2c97-66%2c132-111%2c77-111-130-211-202-256%2c0-3%2c1-6%2c1-9-104-95-207-191-311-286-8-7-16-15-1-31s23-9%2c31-1c96%2c88%2c192%2c176%2c288%2c264%2c16-163%2c18-319-33-481-16-52-35-103-53-154-4%2c0-8-2-12-5-88-45-150-100-190-163-41-63-61-133-67-209-1-11-1-22%2c21-24%2c22-1%2c22%2c10%2c24%2c21%2c5%2c68%2c22%2c132%2c59%2c188%2c37%2c57%2c93%2c107%2c174%2c148%2c87%2c45%2c270%2c22%2c376-29%2c147-83-45-251-90-350-32-71-40-144-54-220%2c13-2%2c26-5%2c40-7-19-24-39-45-59-62-25-22-52-38-79-48-10-4-21-7-13-28%2c7-21%2c18-17%2c28-13%2c33%2c12%2c64%2c31%2c93%2c56%2c28%2c24%2c54%2c53%2c79%2c87%2c14-2%2c29-5%2c43-8%2c145-29%2c225-110%2c313-214-48-58-101-112-158-163-59-53-119-103-180-152-8-7-17-14-3-31s22-10%2c31-3c62%2c50%2c124%2c101%2c182%2c154%2c59%2c54%2c115%2c111%2c166%2c173%2c5%2c6%2c10%2c12%2c6%2c20%2c133%2c12%2c155-15%2c222-134-17-61-45-118-80-173-37-57-82-111-133-163-8-8-15-16%2c0-31%2c16-15%2c24-7%2c31%2c0%2c52%2c54%2c100%2c111%2c138%2c170%2c38%2c58%2c67%2c118%2c85%2c183%2c62%2c1%2c129%2c4%2c182-28%2c116-69%2c18-317-12-413%2c2-1%2c3-2%2c5-4-15-10-31-20-46-29-27-17-55-34-82-52-9-6-18-12-7-30%2c12-19%2c21-13%2c30-7%2c27%2c17%2c55%2c35%2c82%2c52%2c20%2c13%2c40%2c25%2c60%2c38%2c9-7%2c18-14%2c27-21%2c85-68%2c115-158%2c141-252%2c40-144%2c48-80%2c216-105%2c181-28%2c279-48%2c386-260%2c56-28%2c85-52%2c95-121%2c18-125%2c8-189-135-200-200-16-322%2c24-457%2c156%2c18%2c27%2c36%2c55%2c54%2c82%2c6%2c9%2c12%2c18-6%2c31-18%2c12-24%2c3-30-6-17-26-34-52-51-78-182-18-328%2c11-498%2c75-17-7-34-14-51-21%2c36%2c48%2c64%2c94%2c85%2c139%2c29%2c64%2c44%2c125%2c46%2c183%2c0%2c11%2c1%2c22-21%2c23s-22-10-23-21c-2-53-15-108-42-167s-68-121-126-187l-1-1c-142-51-272-77-405-74%2c22%2c22%2c45%2c44%2c67%2c65%2c29%2c28%2c58%2c56%2c86%2c84%2c8%2c8%2c16%2c15%2c0%2c31-15%2c16-23%2c8-31%2c0-29-28-58-56-86-84-29-28-58-56-86-84-3-3-6-6-8-9-113%2c9-230%2c39-359%2c93-81%2c34-164%2c60-245%2c75%2c60%2c58%2c111%2c123%2c151%2c197%2c42%2c76%2c74%2c160%2c95%2c253%2c2%2c11%2c5%2c21-16%2c26s-24-6-26-16c-20-89-51-170-91-242s-90-136-149-192c-6-5-11-11-9-19-75%2c11-150%2c12-222%2c1l89%2c147c5%2c10%2c9%2c20-10%2c29-20%2c9-25%2c0-29-10l-82-172c-69-14-137-40-200-79%2c21%2c79%2c37%2c164%2c49%2c254%2c16%2c119%2c26%2c246%2c29%2c380%2c0%2c11%2c1%2c22-21%2c22s-22-11-22-21c-3-133-12-259-28-375-15-107-35-208-63-300-31-24-61-52-90-84-72-79-152-140-240-187%2c5%2c37%2c5%2c73%2c0%2c109-9%2c66-36%2c133-88%2c198-7%2c9-13%2c17-31%2c4-17-14-11-22-4-31%2c47-59%2c71-118%2c79-177%2c6-42%2c4-85-5-127-137-63-288-94-444-107%2c42%2c55%2c82%2c110%2c118%2c167%2c42%2c66%2c80%2c133%2c114%2c201%2c62%2c51%2c95%2c113%2c114%2c181%2c18%2c67%2c22%2c139%2c25%2c212%2c0%2c11%2c1%2c22-21%2c23s-22-10-23-21c-2-70-6-139-23-202-17-61-47-117-102-161-1-1-6-6-6-7-34-68-72-135-113-201-42-66-88-130-139-192l-2-2c-53-3-106-4-159-3%2c9%2c12%2c18%2c24%2c26%2c37%2c19%2c31%2c32%2c65%2c36%2c104%2c1%2c11%2c2%2c22-20%2c24s-23-9-24-20c-4-32-14-60-30-86-13-21-28-40-47-58-110%2c3-219%2c12-324%2c21%2c110%2c141%2c198%2c287%2c266%2c437%2c76%2c167%2c127%2c339%2c156%2c517%2c2%2c11%2c4%2c22-18%2c25-21%2c4-23-7-25-18-29-174-79-343-153-506-71-155-163-306-279-451-5%2c0-11%2c1-16%2c1-85%2c8-171%2c26-253%2c49%2c37%2c23%2c69%2c46%2c97%2c69%2c38%2c31%2c68%2c62%2c94%2c93%2c7%2c9%2c14%2c17-3%2c31s-24%2c6-31-3c-24-29-53-59-88-88-35-28-76-57-126-86-44%2c14-87%2c30-130%2c47-24%2c9-47%2c18-71%2c25%2c74%2c53%2c145%2c111%2c213%2c176%2c82%2c79%2c159%2c168%2c228%2c271%2c6%2c9%2c12%2c18-6%2c30s-24%2c3-31-6c-67-100-141-187-221-264-75-72-155-135-238-193-90%2c20-181%2c25-272%2c22%2c56%2c111%2c105%2c223%2c142%2c336%2c40%2c122%2c68%2c245%2c77%2c370%2c1%2c11%2c2%2c22-20%2c24s-23-9-24-20c-9-122-36-241-75-360-40-119-92-236-151-352-55-4-111-11-167-18%2c32%2c102%2c60%2c207%2c84%2c314%2c28%2c126%2c51%2c255%2c68%2c386%2c1%2c11%2c2%2c22-19%2c25-22%2c3-23-8-25-19-16-130-39-258-67-382-26-116-57-230-93-342-158-171-333-338-547-427%2c44%2c56%2c79%2c114%2c104%2c175%2c39%2c94%2c57%2c194%2c54%2c299%2c0%2c11-1%2c22-22%2c21-22%2c0-22-12-21-22%2c2-99-14-193-51-282-33-79-81-153-148-222-48-14-99-25-151-30-140-14-281-23-422-28%2c108%2c98%2c193%2c188%2c185%2c297-1%2c11-2%2c22-24%2c20s-21-13-20-24c7-101-93-192-210-296-84-3-169-4-253-5%2c46%2c47%2c86%2c94%2c118%2c141%2c44%2c64%2c75%2c128%2c90%2c192v3c9%2c99%2c33%2c186%2c77%2c258%2c43%2c71%2c105%2c126%2c190%2c165%2c10%2c5%2c20%2c9%2c11%2c29s-19%2c16-29%2c11c-93-42-161-104-209-182-47-77-73-169-83-274-14-58-42-117-83-176-38-55-87-111-145-167-94%2c0-187-1-281-1%2c39%2c111%2c66%2c225%2c85%2c341%2c22%2c142%2c32%2c287%2c35%2c434%2c0%2c11%2c0%2c22-22%2c22s-22-11-22-21c-2-145-12-289-34-428-19-119-47-235-88-348h-26c-61-100-118-144-206-185-1%2c10-2%2c20-5%2c29-7%2c30-19%2c60-40%2c90-6%2c9-13%2c18-31%2c6s-12-21-6-30c17-25%2c28-50%2c33-74%2c3-13%2c5-26%2c5-40-14-6-29-12-45-19-45-188-87-266-237-330-1%2c52-4%2c106-14%2c161-12%2c68-34%2c137-75%2c203-6%2c9-12%2c19-30%2c7-19-12-13-21-7-30%2c38-61%2c58-124%2c69-187%2c10-57%2c13-115%2c13-171-8-3-17-6-26-9-40-263-88-410-361-514%2c3%2c34%2c4%2c69%2c2%2c104-3%2c59-14%2c119-38%2c181-4%2c10-8%2c21-28%2c13s-16-18-13-28c22-57%2c32-113%2c35-168%2c3-52-1-104-8-155-58-66-141-129-212-199%2c2%2c97-11%2c193-38%2c290-33%2c117-87%2c235-163%2c352-6%2c9-12%2c19-30%2c7-19-12-13-21-7-30%2c73-113%2c126-227%2c158-340%2c31-108%2c42-217%2c34-326-31-34-57-71-75-110-2%2c5-4%2c10-6%2c14-11%2c24-21%2c48-32%2c72-5%2c10-9%2c20-29%2c12-20-9-16-19-12-29%2c11-24%2c21-48%2c32-72%2c8-19%2c17-39%2c25-58-2-12-4-24-5-37-9-84-54-149-115-204l-1-1c-8%2c26-18%2c53-30%2c79-19%2c41-44%2c81-76%2c122-7%2c9-13%2c17-31%2c4-17-14-10-22-4-31%2c30-38%2c53-76%2c71-113%2c15-32%2c26-64%2c34-97-28-33-48-67-64-104-10%2c24-24%2c48-42%2c72-21%2c28-48%2c55-82%2c83-8%2c7-17%2c14-31-3s-5-24%2c3-31c31-25%2c55-50%2c74-75s32-49%2c41-74c14-39%2c19-14%2c6-77%2c23-124-23-198-89-301%2c1-3%2c2-5%2c4-8-39%2c1-84%2c14-133%2c35-59%2c26-124%2c65-192%2c112-9%2c6-18%2c12-30-6-13-18-4-24%2c6-30%2c71-48%2c138-88%2c199-115%2c62-27%2c119-42%2c168-39%2c12-33%2c13-58%2c5-96-200%2c74-358%2c109-485%2c117-133%2c8-235-13-320-49-10-5-20-9-11-29%2c8-20%2c19-16%2c29-12%2c79%2c34%2c174%2c54%2c300%2c46%2c125-8%2c279-42%2c477-116-1-2-1-4-2-6%2c36-80%2c65-158%2c85-236-71%2c19-141%2c18-211%2c16h-14c-11%2c0-22-1-22-22%2c0-22%2c12-22%2c22-22h14c74%2c1%2c148%2c3%2c221-21%2c5-26%2c9-52%2c13-78%2c11-87%2c113-108%2c185-30%2c60%2c64%2c115%2c132%2c174%2c160%2c120%2c57%2c255%2c6%2c352-72-29-9-59-19-89-29-11-3-21-7-14-27%2c7-21%2c17-18%2c27-14%2c38%2c12%2c76%2c24%2c114%2c37%2c9-9%2c18-18%2c26-27%2c248%2c21%2c409-31%2c568-191-141%2c3-267-1-376-13-120-14-219-38-292-74-10-5-20-10-10-29%2c10-20%2c20-15%2c29-10%2c68%2c34%2c163%2c57%2c278%2c70%2c117%2c13%2c255%2c17%2c412%2c12h2c14-16%2c28-33%2c43-51%2c68-28%2c136-59%2c186-115-289-31-564-88-823-223-67-75-173-117-286-146-210-26-396%2c26-567%2c115-45-42-80-80-124-121-66-8-128-43-194-51-88-10-180%2c7-268-3-11-1-22-2-19-24%2c2-22%2c13-21%2c24-19%2c88%2c10%2c180-7%2c268%2c3%2c85%2c10%2c166%2c47%2c251%2c57%2c284-107%2c519-166%2c722-157%2c237-69%2c483-98%2c729-92-3-2-6-5-9-8-29-29-15-44%2c0-58%2c133-135%2c164-259%2c121-371-44-116-164-225-331-325-178%2c20-349-28-538-7-118%2c13-234%2c39-348%2c77%2c95%2c34%2c178%2c90%2c246%2c170%2c84%2c99%2c144%2c234%2c176%2c404%2c4%2c20%2c7%2c41-33%2c48-40%2c8-44-13-48-33-29-155-83-277-158-366-79-113-260-157-317-180-189%2c19-375%2c40-537%2c82-122%2c31-229%2c74-311%2c138%2c122-26%2c249-21%2c359%2c34%2c105%2c52%2c194%2c150%2c250%2c309%2c7%2c19%2c13%2c39-26%2c52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681%2c101-88%2c66-176%2c151-263%2c250-16%2c19-33%2c37-70%2c5-37-33-21-51-4-69%2c91-103%2c183-194%2c278-264%2c92-68%2c187-117%2c285-140%2c100-111%2c248-178%2c419-222%2c167-43%2c358-65%2c552-84-57-115-130-184-214-221-90-40-193-46-305-35-233%2c80-440%2c205-639%2c346%2c18%2c0%2c36%2c0%2c53%2c1%2c59%2c4%2c112-5%2c161%2c14%2c19%2c7%2c39%2c14%2c25%2c53-17%2c47-146%2c18-191%2c15-51-3-107%2c1-169%2c16-9%2c2-19%2c5-28%2c2-243%2c150-417%2c302-619%2c473l-34%2c12c-180-7-304%2c18-378%2c74-67%2c51-72%2c131-59%2c239-31%2c101-70%2c212-80%2c330-211%2c181-446%2c362-555%2c626-24%2c77-65%2c145-116%2c206%2c43%2c7%2c78%2c20%2c105%2c41%2c10%2c8%2c19%2c16%2c27%2c26%2c5-45%2c12-90%2c23-133%2c15-62%2c37-119%2c66-165%2c6-9%2c12-18%2c30-6%2c19%2c12%2c13%2c21%2c7%2c30-27%2c41-47%2c94-61%2c152-17%2c69-26%2c145-28%2c215-1%2c22-41%2c24-44%2c2-5-37-21-66-47-85-27-20-65-32-114-36-45%2c49-96%2c93-147%2c134-42%2c34-82%2c71-91%2c126-6%2c96%2c112%2c113%2c224%2c120%2c255%2c15%2c52%2c160%2c192%2c287%2c68%2c47%2c131%2c102%2c179%2c169%2c97%2c35%2c157%2c27%2c223-3%2c13-173-2-261%2c74-261h8c4-22%2c9-44%2c18-66%2c13-32%2c32-65%2c58-97%2c7-8%2c14-17%2c31-3s10%2c22%2c3%2c31c-23%2c29-40%2c58-51%2c86-9%2c24-15%2c48-18%2c72%2c13%2c26%2c10%2c77%2c9%2c168%2c145-71%2c277-89%2c425-96%2c277-324%2c395-242%2c152-6-14%2c27-27%2c51-39%2c74-42%2c81-69%2c144-78%2c254-71%2c62-419%2c348-289%2c454%2c91-13%2c148-9%2c113%2c59-43%2c91-173%2c280-130%2c384%2c16%2c38%2c72%2c34%2c127%2c21%2c4-4%2c8-7%2c12-11%2c91-74%2c187-159%2c277-258%2c89-97%2c172-208%2c239-335%2c9-18%2c18-35%2c44-29%2c27-100%2c59-199%2c95-299%2c37-103%2c79-207%2c124-311%2c7-15%2c28-18%2c38-4%2c38%2c55%2c75%2c95%2c112%2c121%2c33%2c24%2c66%2c35%2c98%2c35s65-11%2c98-33c36-25%2c72-63%2c109-115%2c6-9%2c13-18%2c31-5s12%2c21%2c5%2c31c-40%2c56-79%2c97-120%2c125s-81%2c42-123%2c41c-41%2c0-82-15-123-44-33-24-67-57-100-101-39%2c91-75%2c182-108%2c273-37%2c101-69%2c203-97%2c304%2c23%2c19%2c13%2c37%2c4%2c55-72%2c135-160%2c252-254%2c355-76%2c84-157%2c158-236%2c225%2c11%2c74%2c30%2c144%2c64%2c216%2c151-130%2c292-262%2c416-398%2c124-137%2c232-278%2c317-425%2c6-9%2c11-19%2c30-8s13%2c21%2c8%2c30c-44%2c76-94%2c150-148%2c223%2c10%2c15%2c2%2c21-6%2c28-16%2c13-25%2c65-29%2c132-6%2c91%2c0%2c204%2c10%2c285%2c1%2c11%2c3%2c22-19%2c25s-23-8-25-19c-11-85-16-201-11-293%2c1-24%2c4-46%2c7-66-33%2c39-67%2c78-102%2c117-126%2c139-270%2c273-424%2c405-1%2c1-3%2c2-4%2c3%2c4%2c8%2c9%2c16%2c14%2c24-134%2c97-243%2c131-93%2c261%2c50-36%2c100-72%2c150-108l160-115c9-6%2c18-13%2c31%2c5s4%2c24-5%2c31l-161%2c115c-52%2c37-103%2c74-155%2c111-3%2c61%2c11%2c105%2c38%2c153%2c13-2%2c24-3%2c33-3%2c112-81%2c224-163%2c336-244%2c9-7%2c18-13%2c31%2c5s4%2c24-5%2c31c-108%2c79-217%2c158-326%2c237-7%2c13-21%2c30-39%2c50-110%2c79-494%2c316-453%2c480v1c92-26%2c184-58%2c272-103%2c91-47%2c180-110%2c264-196%2c8-8%2c15-15%2c31%2c0%2c15%2c15%2c8%2c23%2c0%2c31-87%2c89-179%2c153-274%2c203v4c-1%2c15-1%2c30-2%2c45s-1%2c30-2%2c45c-1%2c11-1%2c22-23%2c21s-21-12-21-23c1-15%2c1-30%2c2-45%2c1-8%2c1-17%2c1-25-78%2c36-157%2c63-237%2c85%2c33%2c155-48%2c288-131%2c421-47%2c38-431%2c349-271%2c442%2c43%2c21%2c91%2c31%2c139%2c36z'/%3e%3cpath d='m214960%2c42248c-80-48-183-107-283-127-51-98-120-177-213-237-74-48-74-44-46-97%2c84-9%2c119-32%2c120-55%2c44%2c1%2c82%2c7%2c114%2c18%2c37%2c13%2c65%2c32%2c85%2c59%2c7%2c9%2c13%2c18%2c31%2c4%2c18-13%2c11-22%2c4-31-26-33-61-58-106-74-43-15-95-22-156-20-5%2c0-9%2c0-13%2c2-32-15-80-25-140-23-57-54-105-117-82-195%2c3%2c3%2c8%2c4%2c13%2c5%2c45%2c13%2c87%2c26%2c123%2c43%2c35%2c15%2c64%2c34%2c84%2c56%2c7%2c8%2c15%2c16%2c31%2c1s9-23%2c2-31c-25-27-58-48-98-67-29-13-61-25-95-35%2c330-67%2c625-62%2c920%2c113%2c155%2c64%2c228%2c138%2c312%2c252-28%2c24-56%2c47-84%2c71-193-5-335%2c22-424%2c90-80%2c60-96%2c168-99%2c276z'/%3e%3c/g%3e%3cg fill='black'%3e%3cpath d='m221520%2c51380c-65%2c40-118%2c68-185%2c79%2c3-2%2c6-5%2c8-8%2c43-81%2c93-152%2c149-216%2c7-8%2c15-17%2c22-25%2c1%2c27%2c2%2c53%2c3%2c80%2c1%2c30%2c2%2c61%2c3%2c91z'/%3e%3cpath d='m222347%2c53150c-44%2c66-98%2c126-159%2c181-60%2c54-128%2c105-201%2c153-9%2c6-19%2c12-31-6s-3-24%2c6-30c70-46%2c136-96%2c196-149%2c59-53%2c111-110%2c152-173%2c6-9%2c12-18%2c31-6%2c18%2c12%2c12%2c21%2c6%2c30z'/%3e%3cpath d='m222894%2c52498c-28%2c42-55%2c84-83%2c127-6%2c9-12%2c18-31%2c6-18-12-12-21-6-30%2c28-42%2c55-85%2c83-127%2c6-9%2c12-18%2c31-6%2c18%2c12%2c12%2c21%2c6%2c31z'/%3e%3cpath d='m222596%2c52456c-14%2c63-37%2c123-77%2c178s-99%2c104-184%2c143c-10%2c5-20%2c9-29-11s1-25%2c11-29c78-36%2c131-80%2c167-129%2c37-49%2c57-104%2c70-162%2c2-11%2c5-21%2c26-16s19%2c15%2c16%2c26z'/%3e%3cpath d='m223132%2c51802c-22%2c22-41%2c47-58%2c75-16%2c28-31%2c58-42%2c92-4%2c10-7%2c21-28%2c14s-18-18-14-28c12-36%2c27-69%2c46-100s40-58%2c64-83c8-8%2c15-15%2c31%2c0%2c15%2c15%2c8%2c23%2c0%2c31z'/%3e%3cpath d='m223570%2c51845c-19%2c62-37%2c125-60%2c187-23%2c64-51%2c127-87%2c190-6%2c9-11%2c19-30%2c8s-14-21-8-30c35-61%2c61-122%2c84-182%2c22-61%2c40-123%2c59-185%2c3-11%2c6-21%2c27-15s18%2c16%2c15%2c27z'/%3e%3cpath d='m223371%2c49282c136%2c200%2c166%2c406%2c171%2c613%2c15-75%2c32-151%2c53-226%2c0-1%2c3-7%2c3-7%2c57-80%2c93-160%2c111-239s18-159%2c4-238c-2-11-4-21%2c18-25%2c21-4%2c24%2c7%2c26%2c18%2c15%2c85%2c15%2c171-4%2c256-19%2c84-56%2c168-115%2c252-37%2c139-64%2c279-90%2c419l-5%2c26c-4%2c21-44%2c18-44-4%2c0-16%2c0-31%2c1-47%2c3-261%2c6-523-163-771-6-9-13-18%2c6-31%2c18-12%2c25-3%2c31%2c6z'/%3e%3cpath d='m223038%2c49711c-2%2c17-3%2c34-5%2c50-1%2c17-3%2c34-4%2c51-1%2c11-2%2c22-24%2c20s-21-13-20-24c1-17%2c3-34%2c4-50%2c1-17%2c3-34%2c5-51%2c1-11%2c2-22%2c24-20s21%2c13%2c20%2c24z'/%3e%3cpath d='m222945%2c50293c34%2c111%2c60%2c224%2c79%2c340%2c13%2c79%2c21%2c159%2c25%2c241%2c9-15%2c19-29%2c30-43%2c36-45%2c84-84%2c141-117%2c9-6%2c19-11%2c30%2c8s2%2c25-8%2c30c-53%2c31-96%2c66-128%2c107-32%2c40-53%2c85-62%2c136-4%2c22-44%2c18-44-4%2c1-120-9-237-27-351s-44-225-77-334c-3-11-7-21%2c14-27s24%2c4%2c27%2c14z'/%3e%3cpath d='m223409%2c50501c19%2c90%2c31%2c176%2c35%2c259s1%2c164-8%2c243c-1%2c11-3%2c22-25%2c19s-20-14-19-25c9-75%2c12-153%2c8-235-4-81-15-166-34-252-2-11-5-21%2c17-26%2c21-5%2c24%2c6%2c26%2c17z'/%3e%3cpath d='m223807%2c50427c15%2c82%2c23%2c162%2c19%2c239-4%2c78-19%2c152-51%2c224-27%2c82-29%2c164-15%2c246%2c14%2c84%2c46%2c168%2c84%2c253%2c5%2c10%2c9%2c20-11%2c29s-25-1-29-11c-40-87-73-175-88-263-15-90-13-179%2c17-269%2c0%2c0%2c1-2%2c1-2%2c29-66%2c44-136%2c47-209%2c4-74-4-151-19-229-2-11-4-21%2c18-25s24%2c7%2c26%2c18z'/%3e%3cpath d='m223999%2c49767c-10%2c41-20%2c83-31%2c125-10%2c41-20%2c83-31%2c125-2%2c11-5%2c21-26%2c16s-19-16-16-27c10-41%2c20-83%2c31-125%2c10-41%2c20-83%2c31-125%2c3-11%2c5-21%2c27-16%2c21%2c5%2c19%2c16%2c16%2c27z'/%3e%3cpath d='m223802%2c48671c12%2c38%2c23%2c76%2c35%2c114%2c3%2c11%2c6%2c21-15%2c27-21%2c7-24-4-27-14-12-38-23-76-35-114-4-11-7-21%2c14-27s24%2c4%2c27%2c14z'/%3e%3cpath d='m223903%2c47838c1%2c52%2c1%2c104-3%2c327-47%2c42-81%2c95-99%2c161-18%2c67-20%2c149-3%2c247%2c2%2c11%2c4%2c22-18%2c26s-24-7-26-18c-19-105-16-193%2c4-266%2c20-75%2c59-135%2c112-182l-9-139c-1-52-1-104-2-155%2c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m223076%2c47548c128%2c84%2c238%2c177%2c314%2c287%2c77%2c111%2c121%2c238%2c116%2c388-1%2c15-17%2c25-31%2c19-72-31-145-62-217-93%2c48%2c311%2c36%2c559-32%2c749-72%2c201-205%2c338-395%2c416-17%2c7-35-9-29-27%2c37-118%2c59-236%2c68-354s4-236-16-353c-2-11-4-22%2c18-25%2c22-4%2c24%2c7%2c25%2c18%2c20%2c121%2c26%2c243%2c16%2c364-8%2c106-26%2c211-56%2c318%2c155-76%2c265-198%2c327-371%2c68-191%2c78-445%2c24-767-3-17%2c15-31%2c30-24%2c74%2c32%2c149%2c64%2c223%2c96-2-126-42-234-108-329-73-105-178-194-302-275-9-6-18-12-6-31%2c12-18%2c21-12%2c30-6z'/%3e%3cpath d='m225241%2c47122c-6%2c14-12%2c29-18%2c43s-11%2c29-17%2c43c-4%2c10-8%2c20-28%2c12s-16-18-12-28c6-14%2c12-29%2c18-43s11-29%2c17-43c4-10%2c8-20%2c28-12s16%2c18%2c12%2c28z'/%3e%3cpath d='m224732%2c47111c42%2c17%2c76%2c40%2c104%2c68%2c28%2c27%2c49%2c59%2c67%2c94%2c5%2c10%2c10%2c20-9%2c29-20%2c10-25%2c0-29-9-16-31-35-59-59-83s-53-44-90-58c-10-4-20-8-12-28s18-16%2c28-12z'/%3e%3cpath d='m223976%2c47328c55%2c61%2c91%2c132%2c110%2c213%2c19%2c79%2c22%2c167%2c12%2c261-1%2c11-2%2c22-24%2c20s-21-13-19-24c9-90%2c7-173-11-247-18-73-50-138-100-193-7-8-15-16%2c2-31%2c16-15%2c24-6%2c31%2c2z'/%3e%3cpath d='m221421%2c47574c-3%2c29-6%2c58-9%2c86-3%2c29-6%2c58-8%2c86-1%2c11-2%2c22-24%2c20s-21-13-19-24c3-29%2c6-58%2c8-86%2c3-29%2c6-58%2c9-86%2c1-11%2c2-22%2c24-20s21%2c13%2c20%2c24z'/%3e%3cpath d='m221895%2c47324c12%2c41%2c24%2c82%2c37%2c123l11%2c37c3%2c11%2c6%2c21-15%2c27s-24-4-27-15l-11-37c-12-41-24-82-37-123-3-10-6-21%2c15-27s24%2c4%2c27%2c15z'/%3e%3cpath d='m222867%2c47977c5%2c18%2c8%2c36%2c9%2c53%2c1%2c18%2c1%2c35%2c0%2c53-1%2c11-2%2c22-24%2c20s-21-13-20-24c1-15%2c1-31%2c0-46-1-16-4-31-8-46-3-11-6-21%2c15-27s24%2c5%2c27%2c16z'/%3e%3cpath d='m223202%2c47237c21%2c21%2c35%2c44%2c40%2c66%2c6%2c24%2c2%2c48-10%2c71-5%2c10-11%2c20-30%2c9-19-10-14-20-9-30%2c7-14%2c9-27%2c6-41s-13-30-28-46c-8-8-15-15%2c0-31%2c15-15%2c23-8%2c31%2c0z'/%3e%3cpath d='m220882%2c47354c0%2c52%2c8%2c102%2c25%2c148%2c17%2c47%2c44%2c91%2c82%2c132%2c51%2c58%2c77%2c115%2c91%2c173%2c14%2c57%2c15%2c113%2c18%2c168%2c0%2c11%2c1%2c22-21%2c23s-22-10-23-21c-2-54-4-108-16-160-13-52-36-103-81-155-42-45-71-94-91-146-19-52-28-107-28-164%2c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m221821%2c47986c52%2c97%2c81%2c192%2c92%2c288%2c12%2c95%2c6%2c192-11%2c293-19%2c117%2c6%2c231%2c70%2c338%2c59%2c100%2c152%2c195%2c272%2c283-37-129-59-256-54-379%2c6-144%2c50-283%2c151-414%2c43-56%2c72-114%2c92-173%2c21-59%2c32-119%2c40-177%2c1-11%2c3-22%2c24-19%2c22%2c2%2c20%2c13%2c19%2c24-8%2c62-20%2c124-41%2c186s-53%2c125-99%2c185c-95%2c124-136%2c254-142%2c389-6%2c137%2c24%2c279%2c70%2c425%2c6%2c19-17%2c35-33%2c25-151-102-266-214-337-333-69-117-97-240-75-367%2c16-97%2c21-190%2c10-281s-38-180-87-272c-5-9-11-19%2c9-29%2c19-11%2c25-1%2c30%2c9z'/%3e%3cpath d='m221444%2c48563c0%2c104-29%2c208-81%2c312-41%2c82-95%2c163-159%2c244%2c33-13%2c67-26%2c100-42%2c58-27%2c116-59%2c174-103%2c40-30%2c81-65%2c121-107%2c41-42%2c82-91%2c124-149%2c6-9%2c13-18%2c31-5s11%2c22%2c5%2c31c-43%2c59-86%2c110-128%2c154-38%2c39-76%2c73-114%2c102%2c6%2c27%2c10%2c47%2c14%2c68%2c5%2c25%2c10%2c50%2c15%2c76%2c2%2c11%2c5%2c21-17%2c26-21%2c5-24-6-26-17-7-31-11-54-16-77-3-16-6-32-10-48-52%2c37-105%2c65-156%2c89-60%2c28-119%2c49-178%2c71-19%2c7-37-19-24-35%2c84-100%2c155-199%2c204-298%2c49-98%2c77-195%2c77-292%2c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m220985%2c48526v99c0%2c11%2c0%2c22-22%2c22s-22-11-22-22v-99c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m220697%2c47964c60%2c147%2c76%2c284%2c53%2c412-22%2c128-83%2c247-174%2c359%2c0%2c0-3%2c3-3%2c3-87%2c75-152%2c165-200%2c266-33%2c68-58%2c141-77%2c218%2c24-33%2c48-64%2c77-93%2c57-58%2c125-103%2c215-128%2c92-51%2c179-107%2c260-170%2c82-64%2c158-134%2c228-213%2c7-8%2c15-16%2c31-2s9%2c22%2c2%2c31c-72%2c81-150%2c153-234%2c218s-173%2c123-268%2c175c0%2c0-5%2c2-5%2c2-82%2c22-145%2c64-198%2c117s-95%2c119-136%2c187c-11%2c18-44%2c6-40-15%2c22-124%2c55-241%2c105-347s118-200%2c210-279c86-106%2c143-218%2c164-338s6-249-51-388c-4-10-8-20%2c12-29%2c20-8%2c25%2c2%2c29%2c12z'/%3e%3cpath d='m221630%2c49460c-14%2c40%2c15%2c77%2c74%2c153%2c13%2c17%2c27%2c35%2c40%2c52%2c79%2c105%2c108%2c224%2c110%2c349%2c2%2c122-21%2c249-45%2c372-4%2c21-40%2c20-43-1-20-136-78-256-163-363-86-108-201-204-333-292-9-6-18-12-6-31%2c12-18%2c21-12%2c30-6%2c136%2c91%2c254%2c190%2c343%2c302%2c68%2c85%2c119%2c177%2c149%2c278%2c15-87%2c26-174%2c25-258-2-116-29-226-101-323-15-21-28-37-39-51-69-89-102-132-81-194%2c4-10%2c7-21%2c28-14s17%2c18%2c14%2c28z'/%3e%3cpath d='m222028%2c49434c16%2c17%2c33%2c34%2c49%2c52%2c16%2c17%2c33%2c34%2c49%2c52%2c8%2c8%2c15%2c16-1%2c31s-24%2c7-31-1c-16-17-33-34-49-52-16-17-33-34-49-52-7-8-15-16%2c1-31s24-7%2c31%2c1z'/%3e%3cpath d='m222516%2c49591c-31%2c98-61%2c195-91%2c293-31%2c98-61%2c195-92%2c293-3%2c11-6%2c21-27%2c14-21-6-18-17-14-27%2c31-98%2c61-195%2c91-293%2c31-98%2c61-195%2c92-293%2c3-11%2c6-21%2c27-15%2c21%2c7%2c18%2c17%2c14%2c28z'/%3e%3cpath d='m222792%2c51228c-9%2c25-9%2c49%2c0%2c73%2c4%2c10%2c8%2c21-13%2c28-20%2c8-24-2-28-13-13-35-13-70%2c0-105%2c4-11%2c8-21%2c28-13%2c21%2c8%2c17%2c18%2c13%2c28z'/%3e%3cpath d='m222502%2c50747c-13%2c51-27%2c103-40%2c154-13%2c52-26%2c103-40%2c155-3%2c11-6%2c21-27%2c16-21-6-19-16-16-27%2c13-52%2c27-103%2c40-155%2c13-51%2c27-103%2c40-154%2c3-11%2c5-21%2c27-16%2c21%2c5%2c19%2c16%2c16%2c27z'/%3e%3cpath d='m222084%2c50745%2c38%2c38c8%2c8%2c15%2c15%2c0%2c31-16%2c15-24%2c8-31%2c0l-38-38c-8-8-15-15%2c0-31%2c16-15%2c24-8%2c31%2c0z'/%3e%3cpath d='m221593%2c50510c-10%2c29-20%2c58-31%2c87-10%2c29-20%2c58-31%2c87-4%2c10-7%2c21-28%2c13-20-7-17-18-13-28%2c10-29%2c20-58%2c31-87%2c10-29%2c20-58%2c31-87%2c4-11%2c7-21%2c28-14s17%2c18%2c14%2c28z'/%3e%3cpath d='m220890%2c51253c-27%2c29-45%2c61-58%2c94-13%2c34-20%2c69-26%2c106-2%2c11-4%2c22-25%2c18-22-4-20-14-18-25%2c7-39%2c15-77%2c29-114%2c14-38%2c35-74%2c66-108%2c7-8%2c15-16%2c31-1s9%2c23%2c1%2c31z'/%3e%3cpath d='m218878%2c53224c-10%2c22-24%2c45-43%2c67-18%2c22-40%2c43-67%2c65-8%2c7-17%2c14-31-4-14-17-5-24%2c3-31%2c25-19%2c45-39%2c61-59%2c16-19%2c28-38%2c36-56%2c5-10%2c9-20%2c29-12%2c20%2c9%2c15%2c19%2c11%2c29z'/%3e%3cpath d='m219193%2c53057c-9%2c22-24%2c41-43%2c57-18%2c15-41%2c28-68%2c39-11%2c4-21%2c8-28-13-8-21%2c3-25%2c13-28%2c22-8%2c41-19%2c55-31s24-26%2c31-41c4-10%2c9-20%2c29-11s15%2c19%2c11%2c29z'/%3e%3cpath d='m219611%2c52802c-7%2c12-15%2c24-26%2c36s-26%2c24-45%2c36c-9%2c6-19%2c12-30-7s-2-25%2c8-30c16-9%2c27-19%2c36-28%2c8-9%2c15-19%2c21-28s11-19%2c30-7c19%2c11%2c13%2c20%2c8%2c30z'/%3e%3cpath d='m220240%2c51166c-20%2c59-34%2c117-39%2c175s-2%2c116%2c10%2c173c2%2c11%2c5%2c21-16%2c26s-24-6-26-17c-14-62-17-125-11-187s20-124%2c41-185c4-11%2c7-21%2c28-14s17%2c18%2c14%2c28z'/%3e%3cpath d='m220668%2c46813c-2%2c49-15%2c97-38%2c145s-56%2c95-99%2c142c-7%2c8-15%2c16-31%2c1s-9-23-1-31c40-44%2c71-88%2c92-131%2c20-43%2c32-86%2c33-128%2c0-11%2c1-22%2c23-21s21%2c12%2c21%2c23z'/%3e%3cpath d='m220231%2c46427c38%2c66%2c61%2c133%2c74%2c200%2c13%2c66%2c16%2c133%2c12%2c199%2c0%2c11-1%2c22-23%2c21s-21-12-21-23c4-63%2c1-125-11-188-12-62-34-125-69-187-5-9-11-19%2c8-30s25-1%2c30%2c8z'/%3e%3cpath d='m219652%2c47145c-79-58-135-117-171-176-36-61-49-122-40-184%2c2-11%2c4-21%2c25-18%2c22%2c4%2c20%2c14%2c18%2c25-8%2c52%2c4%2c103%2c34%2c155%2c32%2c54%2c85%2c108%2c159%2c163%2c9%2c6%2c18%2c13%2c5%2c31s-22%2c11-31%2c5z'/%3e%3cpath d='m220293%2c48234v48%2c47c0%2c11%2c0%2c22-22%2c22s-22-11-22-22v-47-48c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m219474%2c47409c129%2c122%2c206%2c269%2c247%2c432%2c26%2c101%2c37%2c208%2c39%2c320%2c1%2c0%2c3-1%2c5-1%2c58-20%2c103-72%2c134-155%2c33-88%2c50-210%2c53-365%2c0-1%2c2-10%2c3-11%2c46-75%2c74-151%2c93-226s28-152%2c35-229c2-19%2c28-27%2c40-11%2c75%2c106%2c141%2c216%2c192%2c334s85%2c243%2c98%2c379c1%2c11%2c2%2c22-20%2c24s-23-9-24-20c-12-130-46-251-94-365-41-97-93-188-153-277-6%2c58-15%2c117-30%2c176-19%2c78-48%2c155-95%2c233-3%2c158-21%2c283-55%2c374-36%2c97-90%2c157-161%2c181-7%2c2-13%2c4-19%2c1-1%2c54-4%2c109-8%2c165-1%2c11-2%2c22-24%2c20s-21-13-20-24c15-182%2c11-355-29-511-39-155-113-295-235-411-8-7-16-15-1-31s23-8%2c31-1z'/%3e%3cpath d='m219954%2c49462c-9%2c58-18%2c115-27%2c173-9%2c57-18%2c115-27%2c172-1%2c11-3%2c22-25%2c18-21-3-20-14-18-25%2c9-58%2c18-115%2c27-172%2c9-58%2c18-115%2c27-173%2c2-11%2c3-21%2c25-18%2c21%2c4%2c20%2c14%2c18%2c25z'/%3e%3cpath d='m219032%2c49853c8%2c44%2c16%2c87%2c24%2c131%2c2%2c11%2c4%2c21-18%2c25-21%2c4-24-7-26-18-8-44-16-87-24-131-2-11-4-21%2c18-25%2c21-4%2c24%2c7%2c25%2c18z'/%3e%3cpath d='m219829%2c48795c-11%2c87-33%2c171-67%2c252-35%2c81-83%2c160-146%2c235l-1%2c1c-79%2c86-117%2c175-129%2c268s1%2c190%2c27%2c289c3%2c11%2c5%2c21-16%2c27-21%2c5-24-5-27-16-27-103-41-205-28-305%2c13-101%2c55-199%2c140-292%2c60-71%2c106-146%2c139-223%2c33-78%2c54-158%2c64-241%2c1-11%2c3-22%2c24-19%2c22%2c3%2c20%2c14%2c19%2c25z'/%3e%3cpath d='m219621%2c48485c15%2c84%2c2%2c167-33%2c251-35%2c81-91%2c163-163%2c244%2c0%2c0-2%2c2-2%2c2-75%2c63-128%2c132-170%2c203-42%2c72-73%2c147-104%2c223-4%2c10-8%2c20-29%2c12-20-8-16-18-12-28%2c31-77%2c63-154%2c107-229s100-147%2c178-213c68-77%2c121-154%2c154-231%2c32-75%2c44-151%2c30-225-2-11-4-21%2c18-26%2c21-4%2c24%2c7%2c26%2c18z'/%3e%3cpath d='m218604%2c48968c24%2c168-2%2c312-65%2c438-62%2c126-161%2c234-282%2c331-8%2c7-17%2c14-31-4-14-17-5-24%2c4-31%2c116-93%2c211-197%2c270-316s84-254%2c61-413c-1-11-3-22%2c19-25s23%2c8%2c25%2c19z'/%3e%3cpath d='m217305%2c49687c13%2c26%2c25%2c52%2c37%2c78%2c14%2c28%2c27%2c55%2c40%2c83%2c5%2c10%2c9%2c20-10%2c29-20%2c9-25%2c0-29-10-13-28-27-55-40-83-12-26-25-52-37-77-5-10-9-20%2c10-29%2c20-9%2c25%2c0%2c29%2c10z'/%3e%3cpath d='m216790%2c49697c-1%2c99%2c7%2c197%2c31%2c291%2c25%2c94%2c65%2c185%2c131%2c272%2c0%2c0%2c2%2c4%2c2%2c4%2c33%2c67%2c52%2c134%2c65%2c202%2c9%2c50%2c15%2c100%2c18%2c150%2c63-67%2c111-135%2c146-206%2c40-82%2c61-167%2c63-255%2c0-11%2c0-22%2c22-21%2c22%2c0%2c22%2c11%2c21%2c22-2%2c94-25%2c185-67%2c273-43%2c88-106%2c172-189%2c253-13%2c13-36%2c4-37-15-3-65-8-130-20-193s-30-126-60-189c-68-91-111-187-137-286s-34-200-33-303c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m216860%2c51456c4-54%2c12-107%2c25-162%2c13-54%2c29-107%2c51-161%2c4-10%2c8-20%2c28-12%2c21%2c8%2c16%2c18%2c13%2c28-21%2c52-37%2c104-49%2c155s-20%2c103-24%2c154c-1%2c11-1%2c22-24%2c20-22-1-21-12-20-23z'/%3e%3cpath d='m216800%2c51946c9-65%2c18-130%2c27-195%2c1-11%2c3-22%2c25-19s20%2c14%2c19%2c25c-9%2c65-18%2c130-27%2c195-1%2c11-3%2c22-25%2c19s-20-14-19-25z'/%3e%3cpath d='m216463%2c52767c32-32%2c63-70%2c92-112%2c30-43%2c58-90%2c86-139%2c5-10%2c11-19%2c30-9%2c19%2c11%2c14%2c20%2c8%2c30-28%2c51-58%2c99-88%2c143-31%2c44-63%2c84-98%2c118-8%2c8-16%2c15-31%2c0s-7-23%2c0-31z'/%3e%3cpath d='m215976%2c50012v81c0%2c11%2c0%2c22-22%2c22s-22-11-22-22v-81c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m215152%2c51910c-1-20-2-40-4-60l-4-61c0-11-1-22%2c21-23s23%2c9%2c23%2c21l4%2c60c1%2c20%2c2%2c40%2c4%2c60%2c0%2c11%2c1%2c22-21%2c23s-23-9-23-21z'/%3e%3cpath d='m217221%2c48534c-42%2c145-75%2c296-72%2c425%2c2%2c125%2c37%2c229%2c127%2c287%2c105%2c68%2c151%2c170%2c195%2c269%2c3%2c6%2c5%2c12%2c8%2c18%2c13-49%2c24-101%2c29-153%2c7-64%2c7-126-2-182-2-11-4-22%2c18-26%2c21-4%2c24%2c7%2c25%2c18%2c10%2c60%2c10%2c127%2c3%2c194-8%2c75-25%2c151-47%2c217-6%2c18-32%2c20-40%2c3-11-23-22-47-33-72-41-93-84-189-179-250-104-67-145-184-148-323-2-134%2c31-289%2c74-438%2c3-11%2c6-21%2c27-15s18%2c16%2c15%2c27z'/%3e%3cpath d='m217076%2c47981c14%2c113%2c10%2c217-9%2c322-19%2c104-53%2c208-98%2c321-53%2c135-77%2c278-70%2c422%2c7%2c143%2c44%2c285%2c110%2c420%2c5%2c10%2c10%2c20-10%2c29-20%2c10-25%2c0-29-10-70-140-108-289-115-437-7-150%2c18-299%2c73-440%2c44-110%2c77-212%2c95-313%2c19-100%2c23-200%2c9-308-1-11-3-22%2c19-25%2c21-3%2c23%2c8%2c25%2c19z'/%3e%3cpath d='m216115%2c49349c-30%2c66-36%2c132-25%2c198%2c12%2c67%2c41%2c135%2c82%2c203%2c6%2c9%2c11%2c19-7%2c30-19%2c11-25%2c2-30-8-43-72-75-145-87-218-13-74-6-149%2c28-223%2c5-10%2c9-20%2c29-11s15%2c19%2c11%2c29z'/%3e%3cpath d='m215696%2c49199c7%2c39%2c9%2c85%2c5%2c131-4%2c40-14%2c79-30%2c114v1c-19%2c37-23%2c74-16%2c111%2c8%2c39%2c28%2c78%2c55%2c118%2c6%2c9%2c12%2c18-6%2c31s-24%2c4-31-6c-31-44-53-89-62-134-9-47-5-93%2c20-140%2c14-30%2c22-64%2c26-99%2c4-41%2c2-83-4-119-2-11-4-22%2c18-25%2c22-4%2c24%2c7%2c25%2c18z'/%3e%3cpath d='m218146%2c45570c-13%2c115-7%2c223%2c16%2c326%2c23%2c102%2c62%2c200%2c116%2c293%2c6%2c9%2c11%2c19-8%2c30s-24%2c1-30-8c-55-96-97-198-121-305s-31-220-16-340c1-11%2c2-22%2c24-19%2c22%2c2%2c21%2c13%2c19%2c24z'/%3e%3cpath d='m217839%2c45867c57%2c101%2c106%2c210%2c143%2c329s62%2c250%2c71%2c395c1%2c11%2c1%2c22-21%2c23s-22-10-23-21c-8-141-33-268-69-384s-84-221-139-320c-5-10-11-19%2c8-30s25-1%2c30%2c8z'/%3e%3cpath d='m216317%2c45914c-147%2c209-211%2c379-223%2c526-12%2c146%2c27%2c268%2c85%2c381%2c0%2c0%2c1%2c3%2c1%2c3%2c40%2c116%2c58%2c231%2c55%2c347-2%2c115-26%2c231-67%2c346-4%2c11-7%2c21-28%2c13-21-7-17-18-13-28%2c40-111%2c62-221%2c65-332%2c2-110-14-220-52-330-61-119-102-249-89-403s79-332%2c231-548c6-9%2c13-18%2c31-6%2c18%2c13%2c12%2c22%2c5%2c31z'/%3e%3cpath d='m217736%2c45312c13%2c63%2c7%2c129-22%2c193-26%2c59-71%2c115-138%2c168-68%2c53-108%2c122-126%2c205-19%2c85-15%2c184%2c6%2c295%2c2%2c11%2c4%2c22-18%2c26-21%2c4-24-7-26-18-21-117-25-221-5-312%2c20-92%2c65-170%2c142-230%2c61-48%2c101-99%2c125-151%2c25-55%2c30-112%2c19-166-2-11-5-21%2c17-26%2c21-4%2c24%2c7%2c26%2c17z'/%3e%3cpath d='m216233%2c45441c29%2c93%2c30%2c184%2c3%2c275-26%2c90-80%2c179-162%2c266%2c0%2c0-2%2c2-2%2c2-79%2c66-127%2c150-157%2c243-31%2c95-42%2c201-48%2c311-1%2c11-1%2c22-23%2c21s-21-12-21-23c6-113%2c18-222%2c50-322s84-190%2c169-262c77-82%2c127-165%2c152-248%2c24-82%2c23-166-3-250-3-11-7-21%2c14-27s24%2c4%2c27%2c15z'/%3e%3cpath d='m217093%2c45486c-5%2c34-5%2c66%2c0%2c98%2c5%2c31%2c17%2c61%2c37%2c90%2c6%2c9%2c12%2c18-6%2c31-18%2c12-24%2c4-31-6-24-35-38-71-44-107-6-37-6-74%2c0-111%2c1-11%2c3-22%2c25-19s20%2c14%2c19%2c25z'/%3e%3cpath d='m217052%2c45260c-79%2c33-139%2c89-182%2c169-42%2c79-67%2c181-75%2c306%2c5%2c6%2c8%2c11%2c8%2c15%2c42%2c57%2c71%2c125%2c89%2c201%2c20%2c83%2c27%2c177%2c24%2c279%2c0%2c11-1%2c22-23%2c21s-21-12-21-22c3-99-4-189-23-268-16-67-41-127-76-177-163%2c152-243%2c320-248%2c503-6%2c191%2c69%2c399%2c213%2c621%2c6%2c9%2c12%2c19-6%2c31s-24%2c2-30-7c-149-230-226-446-220-646%2c6-197%2c92-377%2c269-539v-1c7-137%2c34-249%2c81-337%2c48-89%2c115-152%2c204-189%2c10-4%2c20-8%2c29%2c12%2c8%2c20-2%2c25-12%2c29z'/%3e%3cpath d='m216808%2c44944c-2%2c18-4%2c32-5%2c47-11%2c104-22%2c221-101%2c292-44%2c39-72%2c85-92%2c134-20%2c51-30%2c106-37%2c164-1%2c11-2%2c22-24%2c19-22-2-20-13-19-25%2c7-61%2c19-120%2c40-175%2c22-56%2c54-107%2c103-151%2c66-59%2c78-168%2c87-263%2c2-18%2c4-35%2c5-48%2c1-11%2c3-22%2c25-19s20%2c14%2c19%2c25z'/%3e%3cpath d='m219197%2c47493c26%2c54%2c47%2c110%2c61%2c167s21%2c116%2c18%2c177c0%2c11-1%2c22-23%2c21s-21-12-21-23c3-57-4-111-16-165-13-53-34-106-59-158-5-10-9-20%2c11-29s24%2c0%2c29%2c10z'/%3e%3cpath d='m219204%2c48277c19%2c90%2c20%2c182%2c4%2c274s-50%2c186-100%2c281c-34%2c79-67%2c158-101%2c237-5%2c10-9%2c20-29%2c12s-16-19-12-29c34-79%2c67-159%2c101-238%2c0%2c0%2c1-2%2c1-2%2c49-91%2c81-180%2c97-268%2c15-87%2c14-174-4-258-2-11-4-22%2c17-26%2c21-5%2c24%2c6%2c26%2c17z'/%3e%3cpath d='m218706%2c47547c143%2c159%2c236%2c327%2c280%2c504%2c45%2c177%2c40%2c363-14%2c557-3%2c11-6%2c21-27%2c15s-18-16-15-27c52-187%2c57-365%2c14-535s-133-332-271-486c-7-8-14-16%2c2-31s24-6%2c31%2c2z'/%3e%3cpath d='m218662%2c48427c-44%2c93-93%2c186-153%2c279s-130%2c186-213%2c279c-48%2c53-92%2c112-130%2c177-38%2c66-71%2c138-97%2c219-6%2c20-44%2c13-42-8%2c4-66-4-132-22-198s-48-133-88-199v1c-80-118-114-237-108-355%2c7-118%2c54-235%2c138-352%2c48-82%2c82-165%2c106-247s36-165%2c39-248c0-11%2c1-22%2c23-21s21%2c12%2c21%2c23c-4%2c86-16%2c172-41%2c258s-61%2c172-111%2c258c0%2c0-1%2c2-1%2c2-79%2c111-124%2c221-130%2c330-6%2c110%2c27%2c219%2c101%2c329l1%2c1c42%2c70%2c73%2c140%2c93%2c211%2c9%2c33%2c16%2c66%2c20%2c99%2c19-43%2c39-84%2c62-122%2c40-68%2c86-130%2c136-185%2c82-91%2c151-183%2c209-274%2c59-92%2c108-183%2c150-274%2c5-10%2c9-20%2c29-11s15%2c19%2c11%2c29z'/%3e%3cpath d='m217357%2c48007c-3%2c109%2c7%2c211%2c29%2c307%2c22%2c95%2c58%2c184%2c108%2c266%2c6%2c9%2c11%2c19-7%2c30-19%2c12-24%2c2-30-7-52-86-90-179-113-278-23-100-33-206-30-318%2c0-11%2c1-22%2c22-21%2c22%2c1%2c22%2c12%2c21%2c22z'/%3e%3cpath d='m216614%2c48405v64%2c64c0%2c11%2c0%2c22-22%2c22s-22-11-22-22v-64-64c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m216860%2c47726c2%2c75-8%2c148-31%2c218-24%2c70-61%2c137-115%2c200-7%2c8-14%2c17-31%2c2-17-14-9-22-2-31%2c50-59%2c85-121%2c106-186%2c22-65%2c31-133%2c29-203%2c0-11-1-22%2c21-22s22%2c11%2c22%2c21z'/%3e%3cpath d='m216191%2c49044c-120-299-149-536-119-729%2c30-195%2c120-343%2c238-464%2c79-81%2c148-161%2c193-261s66-220%2c50-382c-1-11-2-22%2c20-24s22%2c9%2c24%2c20c16%2c170-6%2c297-54%2c404-47%2c106-119%2c190-201%2c274-112%2c114-197%2c256-226%2c440-29%2c186%2c0%2c416%2c117%2c707%2c4%2c10%2c8%2c20-12%2c28s-25-2-29-12z'/%3e%3cpath d='m215805%2c48553c-18%2c48-25%2c97-19%2c145%2c5%2c48%2c23%2c97%2c53%2c146%2c6%2c9%2c12%2c19-7%2c30-19%2c12-24%2c2-30-7-33-54-53-109-59-164s1-110%2c22-165c4-10%2c8-20%2c28-13%2c21%2c8%2c16%2c18%2c13%2c28z'/%3e%3cpath d='m217703%2c47205c79%2c111%2c125%2c226%2c134%2c346s-18%2c244-86%2c373c-5%2c9-10%2c19-29%2c9-20-10-14-20-9-29%2c64-121%2c90-237%2c81-349-8-112-52-220-126-324-7-9-13-18%2c5-31s24-4%2c31%2c5z'/%3e%3cpath d='m218296%2c46741c48%2c115%2c73%2c232%2c78%2c350%2c5%2c117-12%2c236-48%2c355-6%2c20-42%2c16-43-6-4-110-27-209-68-296s-102-162-181-226c-8-7-17-14-3-31s22-10%2c31-3c85%2c68%2c149%2c148%2c193%2c241%2c27%2c57%2c47%2c119%2c59%2c185%2c13-73%2c19-146%2c16-219-4-112-28-224-74-334-4-10-8-20%2c12-29%2c20-8%2c25%2c2%2c29%2c12z'/%3e%3cpath d='m218648%2c46260c78%2c77%2c133%2c179%2c167%2c305%2c33%2c124%2c45%2c270%2c39%2c437v1c-8%2c71-11%2c140-3%2c204%2c7%2c63%2c25%2c121%2c58%2c173%2c6%2c9%2c12%2c19-6%2c31-19%2c12-25%2c2-31-7-37-58-57-123-65-192-8-68-5-140%2c3-214v1c6-163-6-305-37-424-32-118-83-213-155-285-8-8-16-15%2c0-31%2c15-16%2c23-8%2c31%2c0z'/%3e%3cpath d='m217714%2c46167c-51%2c62-82%2c135-97%2c216-15%2c82-13%2c172%2c2%2c270%2c2%2c11%2c4%2c21-18%2c25-21%2c4-23-7-25-18-16-102-18-198-2-285%2c16-88%2c51-167%2c106-236%2c7-8%2c14-17%2c31-3s10%2c22%2c3%2c31z'/%3e%3cpath d='m215883%2c47400c-8%2c182-61%2c330-146%2c452-85%2c121-201%2c217-338%2c297-9%2c6-19%2c11-30-8s-2-24%2c8-30c131-77%2c243-169%2c324-285%2c81-115%2c131-255%2c139-428%2c0-11%2c1-22%2c23-21s21%2c12%2c21%2c23z'/%3e%3cpath d='m215836%2c46770c10%2c68%2c6%2c134-9%2c200-15%2c65-41%2c130-74%2c197-5%2c10-10%2c19-29%2c10-20-10-15-20-10-29%2c32-64%2c57-126%2c71-187s18-121%2c9-184c-1-11-3-22%2c19-25s24%2c8%2c25%2c19z'/%3e%3cpath d='m217076%2c46679v62c7%2c107%2c14%2c215%2c21%2c322l2%2c29c1%2c11%2c1%2c22-20%2c24h-7c-3%2c4-8%2c6-18%2c6-22%2c0-22-11-22-22v-356c-2-29-4-58-6-87-1-11-2-22%2c20-24%2c22-1%2c23%2c9%2c24%2c20v7c5%2c4%2c5%2c11%2c5%2c18z'/%3e%3cpath d='m217375%2c46126c-88%2c107-123%2c210-125%2c311s29%2c202%2c75%2c302c104%2c167%2c138%2c333%2c127%2c500-10%2c166-65%2c331-138%2c496-5%2c10-9%2c20-29%2c11s-15-19-11-29c72-160%2c124-321%2c134-481%2c10-159-22-317-121-476%2c0%2c0-1-2-1-2-49-106-82-213-80-323%2c2-111%2c41-223%2c135-338%2c7-8%2c14-17%2c31-3s10%2c22%2c3%2c31z'/%3e%3cpath d='m215452%2c42697c145-111%2c287-174%2c436-190%2c148-15%2c301%2c17%2c467%2c95%2c55-1%2c110-1%2c165-2%2c56-1%2c113-2%2c169-2%2c11%2c0%2c22%2c0%2c22%2c22s-11%2c22-22%2c22c-57%2c1-113%2c2-169%2c2-51%2c1-101%2c1-152%2c2-1%2c1-2%2c2-3%2c3-178%2c157-330%2c243-465%2c271-139%2c29-259-2-368-80-11-8-22-16-7-38s27-15%2c38-7c98%2c68%2c204%2c96%2c326%2c71%2c118-25%2c252-98%2c409-231-144-63-276-88-403-75-138%2c14-272%2c74-409%2c179-11%2c8-22%2c16-38-5-16-22-6-30%2c5-38z'/%3e%3cpath d='m215882%2c42613c61%2c0%2c110%2c49%2c110%2c110%2c0%2c60-49%2c110-110%2c110-60%2c0-110-49-110-110s49-110%2c110-110z'/%3e%3cpath d='m216639%2c43278c79-41%2c140-85%2c191-130%2c50-45%2c90-91%2c124-137%2c6-9%2c13-18%2c31-5s11%2c22%2c5%2c31c-36%2c49-78%2c98-130%2c145-53%2c47-117%2c92-200%2c135-10%2c5-20%2c10-29-9-10-19-1-25%2c9-29z'/%3e%3cpath d='m218200%2c42632c41-11%2c81-11%2c122%2c1%2c40%2c11%2c79%2c33%2c118%2c65%2c8%2c7%2c17%2c14%2c3%2c31s-22%2c10-31%2c3c-34-28-69-47-102-56s-66-9-99-1c-11%2c3-21%2c6-27-16-6-21%2c5-24%2c15-27z'/%3e%3cpath d='m217307%2c42668c35-80%2c88-141%2c161-180%2c72-38%2c163-54%2c274-44%2c11%2c1%2c22%2c2%2c20%2c24s-13%2c21-24%2c20c-103-9-186%2c5-250%2c39-64%2c33-110%2c87-141%2c159-4%2c10-9%2c20-29%2c11s-16-19-11-29z'/%3e%3cpath d='m217409%2c42814c6-39%2c22-74%2c49-101%2c26-28%2c63-48%2c113-62%2c11-3%2c21-6%2c27%2c15s-5%2c24-15%2c27c-41%2c11-72%2c28-92%2c50-20%2c21-32%2c48-37%2c78-2%2c11-4%2c21-25%2c18s-20-14-18-25z'/%3e%3cpath d='m215923%2c43308c-24%2c38-46%2c77-62%2c119-15%2c42-23%2c87-20%2c140%2c1%2c11%2c2%2c22-20%2c23s-23-9-24-20c-4-59%2c6-111%2c22-158%2c16-46%2c40-88%2c66-128%2c6-9%2c12-19%2c30-7%2c19%2c12%2c13%2c21%2c7%2c30z'/%3e%3cpath d='m216349%2c43499v66c0%2c11%2c0%2c22-22%2c22s-22-11-22-22v-66c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m216072%2c43023c44%2c16%2c87%2c24%2c131%2c25%2c44%2c0%2c89-6%2c133-16%2c11-2%2c21-5%2c26%2c16s-6%2c24-16%2c27c-48%2c11-96%2c18-144%2c17-49-1-97-9-146-28-11-4-21-8-13-28%2c8-21%2c18-16%2c28-13z'/%3e%3cpath d='m216346%2c42224c-37-1-66%2c10-88%2c27-29%2c22-47%2c53-55%2c80-3%2c11-6%2c21-27%2c15s-18-17-15-27c11-35%2c34-74%2c71-102%2c29-22%2c68-37%2c115-36%2c11%2c0%2c22%2c1%2c22%2c22%2c0%2c22-11%2c22-22%2c22z'/%3e%3cpath d='m215903%2c42269c-33%2c14-59%2c30-79%2c46-18%2c15-30%2c32-35%2c48-4%2c11-7%2c21-28%2c14s-17-17-14-28c8-25%2c25-47%2c49-68%2c23-19%2c53-37%2c91-53%2c10-4%2c20-8%2c28%2c12%2c9%2c20-1%2c25-12%2c29z'/%3e%3cpath d='m215630%2c42277c-27%2c19-50%2c39-69%2c62s-34%2c49-45%2c77c-4%2c10-7%2c21-28%2c13-20-7-17-18-13-28%2c12-33%2c30-63%2c52-90s48-50%2c78-71c9-6%2c18-12%2c31%2c6s4%2c24-6%2c31z'/%3e%3cpath d='m215279%2c42558c-29%2c22-57%2c46-84%2c74s-52%2c58-76%2c91c-6%2c9-13%2c18-31%2c5s-11-22-5-31c25-35%2c52-67%2c80-96s58-55%2c89-78c9-7%2c18-13%2c31%2c4%2c13%2c18%2c4%2c24-5%2c31z'/%3e%3cpath d='m215314%2c42945c-21%2c23-42%2c46-63%2c68l-64%2c68c-7%2c8-15%2c16-31%2c1s-9-23-1-31l63-68c21-22%2c42-45%2c64-68%2c7-8%2c15-16%2c31-1s9%2c23%2c1%2c31z'/%3e%3cpath d='m214959%2c43048v136c0%2c11%2c0%2c22-22%2c22s-22-11-22-22v-136c0-11%2c0-22%2c22-22s22%2c11%2c22%2c22z'/%3e%3cpath d='m215414%2c43646c-7%2c74-14%2c148-21%2c223-1%2c7-1%2c14-2%2c21-1%2c11-2%2c22-24%2c20s-21-13-20-24c1-7%2c1-14%2c2-21%2c7-74%2c14-149%2c21-223%2c1-11%2c2-22%2c24-20s21%2c13%2c20%2c24z'/%3e%3cpath d='m215147%2c43448c-1%2c48-3%2c97-5%2c145%2c0%2c11-1%2c22-23%2c21s-21-12-21-22c1-49%2c3-97%2c5-146%2c0-11%2c1-22%2c23-21s21%2c12%2c21%2c23z'/%3e%3cpath d='m214899%2c41554c46%2c17%2c87%2c41%2c120%2c73%2c34%2c33%2c60%2c74%2c77%2c124%2c4%2c11%2c7%2c21-14%2c28s-24-4-28-14c-15-44-38-79-66-107-29-28-64-49-105-64-10-4-20-8-13-28%2c8-21%2c18-17%2c28-13z'/%3e%3cpath d='m217077%2c44394c42%2c95%2c65%2c190%2c66%2c284%2c2%2c95-17%2c190-57%2c285-4%2c10-8%2c20-28%2c12s-16-19-12-29c37-89%2c55-178%2c53-267-1-89-22-178-62-267-5-10-9-20%2c11-29s25%2c1%2c29%2c11z'/%3e%3cpath d='m216367%2c45215c31-107%2c76-200%2c128-285s111-162%2c170-238c68-88%2c113-184%2c137-282%2c26-106%2c27-216%2c8-320-2-11-4-21%2c18-25%2c21-4%2c24%2c7%2c25%2c18%2c20%2c110%2c19%2c225-8%2c338-25%2c104-72%2c206-145%2c299-58%2c75-116%2c151-167%2c234-50%2c82-94%2c172-123%2c274-3%2c11-6%2c21-27%2c15s-18-16-15-27z'/%3e%3cpath d='m215454%2c44974c15-40%2c37-75%2c67-106s67-57%2c111-78c10-5%2c20-9%2c29%2c10%2c9%2c20%2c0%2c25-11%2c29-40%2c19-73%2c42-99%2c69-26%2c26-45%2c57-57%2c91-4%2c10-8%2c21-28%2c13-20-7-17-18-13-28z'/%3e%3cpath d='m215277%2c44910c34-44%2c68-85%2c107-121%2c40-37%2c85-68%2c137-89%2c10-4%2c20-8%2c28%2c12%2c8%2c21-2%2c25-13%2c28-47%2c19-87%2c47-123%2c80-37%2c34-70%2c75-102%2c116-7%2c9-13%2c18-31%2c4-18-13-11-22-4-31z'/%3e%3cpath d='m216223%2c43972c38%2c17%2c74%2c25%2c109%2c26s69-4%2c102-13c11-3%2c21-6%2c27%2c15s-5%2c24-15%2c27c-37%2c11-75%2c16-115%2c15s-81-11-125-30c-10-5-20-9-11-29s19-15%2c29-11z'/%3e%3cpath d='m215752%2c43911c11-13%2c22-25%2c33-38l4-5c7-8%2c15-16%2c31-2%2c16%2c15%2c9%2c23%2c2%2c31l-4%2c5c-11%2c13-22%2c25-34%2c38-7%2c8-14%2c16-31%2c2-16-14-9-23-2-31z'/%3e%3cpath d='m225936%2c46849c21%2c23%2c39%2c47%2c55%2c73%2c15%2c26%2c27%2c53%2c37%2c82%2c4%2c11%2c7%2c21-14%2c27-21%2c7-24-4-28-14-8-26-19-50-33-73-13-23-30-45-49-65-7-8-15-16%2c1-31s24-7%2c31%2c1z'/%3e%3cpath d='m214630%2c52155c48%2c44%2c98%2c84%2c153%2c112%2c54%2c27%2c114%2c44%2c182%2c44%2c11%2c0%2c22%2c0%2c22%2c22s-11%2c22-22%2c22c-75%2c0-141-19-202-49-59-30-113-72-163-118-8-7-16-15-1-31s23-9%2c31-1z'/%3e%3c/g%3e%3cg fill='red'%3e%3cpath d='m223164%2c42025c251%2c11%2c493%2c1%2c699-33-220%2c159-501%2c266-804%2c316%2c59-46%2c97-94%2c114-143%2c16-47%2c13-94-9-140z'/%3e%3cpath d='m222565%2c41963c163%2c27%2c332%2c46%2c499%2c57%2c2%2c4%2c5%2c7%2c7%2c11%2c27%2c37%2c35%2c73%2c23%2c108-14%2c40-52%2c82-114%2c125-17%2c12-34%2c24-10%2c57-111%2c14-224%2c20-339%2c18-58-1-115-4-173-9%2c6-3%2c12-9%2c17-14%2c61-64%2c100-130%2c111-199%2c8-51%2c2-102-21-153z'/%3e%3cpath d='m218139%2c40691c282-37%2c569-46%2c861-39%2c96%2c39%2c167%2c96%2c211%2c171%2c48%2c84%2c65%2c194%2c45%2c331-3%2c20-6%2c41%2c35%2c46%2c41%2c6%2c44-15%2c46-35%2c22-156%2c2-283-55-383-28-48-64-89-108-124%2c26%2c1%2c52%2c2%2c78%2c4%2c336%2c18%2c597%2c114%2c889%2c259%2c2%2c2%2c5%2c5%2c7%2c8%2c62%2c65%2c83%2c132%2c73%2c201-11%2c73-55%2c152-125%2c233-13%2c16-27%2c31%2c5%2c58%2c31%2c27%2c45%2c11%2c58-5%2c79-93%2c131-185%2c144-275%2c7-51%2c3-99-15-147%2c246%2c122%2c496%2c239%2c739%2c367%2c5%2c3%2c10%2c5%2c15%2c8%2c0%2c5%2c2%2c11%2c4%2c16%2c20%2c69%2c12%2c128-22%2c179-37%2c53-104%2c99-201%2c135-19%2c7-38%2c14-24%2c53%2c14%2c38%2c34%2c31%2c53%2c24%2c114-43%2c194-98%2c240-166%2c39-57%2c54-120%2c45-191%2c161%2c87%2c322%2c177%2c487%2c256l1%2c1c29%2c58%2c34%2c110%2c11%2c158-24%2c51-80%2c99-169%2c143-18%2c9-37%2c18-19%2c55s37%2c28%2c55%2c19c107-53%2c175-114%2c207-182%2c22-47%2c28-95%2c18-146%2c57%2c25%2c115%2c49%2c174%2c71%2c159%2c59%2c351%2c110%2c557%2c148%2c1%2c2%2c3%2c4%2c5%2c6%2c38%2c53%2c51%2c104%2c42%2c153-9%2c51-40%2c103-90%2c155-14%2c15-28%2c29%2c1%2c58%2c5%2c5%2c9%2c8%2c13%2c11-625-64-1181-363-1763-588-69-27-139-53-208-80-215-81-432-191-648-279-7-7-18-11-28-14-15-5-29-10-44-14-9-4-19-7-28-11%2c1%2c1%2c3%2c2%2c4%2c3-197-63-396-112-598-140-224-31-452-37-686-7-13-2-25-4-38-6%2c20-123%2c4-231-57-325-43-67-108-126-198-175z'/%3e%3cpath d='m217116%2c40966c287-125%2c578-205%2c875-254%2c136%2c54%2c226%2c120%2c277%2c198%2c49%2c77%2c61%2c167%2c44%2c271-126-12-251-11-373%2c2-137%2c15-271%2c46-403%2c93-66-139-155-223-259-269-51-23-105-36-161-42z'/%3e%3cpath d='m220263%2c42558c-77-49-155-97-236-141-389-214-835-346-1282-363%2c4-3%2c7-7%2c11-10%2c159-162%2c194-315%2c140-458-42-111-139-214-273-307%2c150-8%2c289%2c1%2c445%2c23%2c220%2c31%2c505%2c105%2c765%2c210%2c64%2c140%2c82%2c263%2c54%2c367-29%2c109-111%2c200-243%2c275-18%2c10-36%2c20-16%2c56s38%2c26%2c56%2c15c153-86%2c247-194%2c282-326%2c27-102%2c19-216-26-343%2c176%2c79%2c335%2c173%2c446%2c276%2c145%2c100%2c288%2c201%2c428%2c307%2c1%2c178-51%2c279-137%2c332-91%2c55-221%2c62-369%2c47-20-2-41-4-45%2c37v2z'/%3e%3cpath d='m221119%2c43202c-260-203-514-415-787-598%2c151%2c12%2c286%2c0%2c388-61%2c99-61%2c164-167%2c175-340%2c163%2c126%2c320%2c259%2c469%2c402%2c75%2c71%2c150%2c141%2c227%2c210%2c0%2c1%2c1%2c2%2c1%2c4%2c18%2c64%2c24%2c119%2c19%2c165-5%2c45-21%2c82-47%2c111-27%2c30-66%2c52-115%2c65-73%2c21-168%2c25-285%2c12-19-2-39-4-44%2c31z'/%3e%3cpath d='m222016%2c43793c-90-46-176-94-259-143-199-118-386-253-569-394%2c112%2c9%2c206%2c3%2c282-18%2c65-18%2c117-48%2c154-89%2c38-42%2c61-94%2c68-158%2c3-28%2c3-58-1-90%2c179%2c153%2c367%2c295%2c570%2c419%2c106%2c65%2c213%2c126%2c319%2c183-1%2c7%2c0%2c14%2c1%2c22%2c13%2c82-33%2c134-117%2c167-98%2c39-244%2c55-411%2c65-19%2c1-37%2c2-39%2c34z'/%3e%3cpath d='m222974%2c44169c-304-83-598-199-867-330%2c154-11%2c290-29%2c388-68%2c111-44%2c175-112%2c171-221%2c178%2c90%2c356%2c168%2c537%2c232%2c32%2c71%2c34%2c129%2c4%2c178-36%2c60-115%2c110-213%2c153-19%2c8-38%2c17-21%2c54v1z'/%3e%3cpath d='m224970%2c43966c26-4%2c186-46%2c103%2c15-588%2c385-1334%2c384-2037%2c203%2c109-49%2c198-108%2c243-182%2c34-55%2c40-118%2c24-187%2c224%2c73%2c451%2c125%2c685%2c155%2c1%2c36-9%2c72-37%2c107-37%2c46-100%2c91-203%2c136-19%2c8-38%2c16-21%2c54%2c16%2c38%2c35%2c29%2c54%2c21%2c116-51%2c191-105%2c235-160%2c39-49%2c55-98%2c55-149%2c289%2c31%2c588%2c27%2c900-14z'/%3e%3cpath d='m220904%2c54095c-44%2c46-81%2c97-117%2c157-171%2c57-322%2c142-506%2c134%2c0%2c119%2c39%2c171%2c158%2c172%2c227-114%2c278-135%2c298-119%2c28%2c24-32%2c187-220%2c319-29%2c18-28%2c29-11%2c59%2c159%2c249%2c576%2c160%2c800%2c101%2c160-42%2c449-232%2c529-392%2c31-73-39-169-109-247-177%2c27-238-55-210-112-187-66-395-80-612-72z'/%3e%3cpath d='m214511%2c52080c-130%2c106-275%2c190-444%2c246-64%2c21-219%2c59-234%2c140-2%2c29%2c104%2c92%2c172%2c55%2c188-180%2c282-80%2c66%2c104-17%2c35-3%2c74%2c34%2c107%2c195%2c175%2c678%2c232%2c898%2c93%2c163-102%2c248-214%2c106-369%2c1-35%2c5-69%2c11-104l-269-27-165-96-175-149z'/%3e%3cpath d='m218719%2c53544c-16%2c2-33%2c4-49%2c7-87%2c94%2c152%2c59%2c279%2c137%2c58%2c35%2c83%2c104%2c60%2c200-117%2c279-770%2c189-987%2c74-101-53-105-114-101-201%2c45%2c0%2c91-3%2c137-10%2c78-11%2c155-34%2c231-77%2c21-12%2c43-25%2c19-67-24-43-46-31-67-19-64%2c36-130%2c56-196%2c65-68%2c10-138%2c10-205%2c7h-17c-38-22-67-48-51-71%2c16-22%2c79%2c2%2c91%2c6%2c101-47%2c189-77%2c298-98%2c15-15%2c29-31%2c44-46%2c199%2c17%2c389%2c47%2c515%2c93z'/%3e%3cpath d='m215700%2c53373c-40%2c24-54%2c58-83%2c121-114%2c115-223%2c184-369%2c250-121%2c55-4%2c108%2c81%2c166%2c77%2c57%2c178-67%2c241-161%2c69-104%2c139-73%2c94%2c8-50%2c89-86%2c217-91%2c284-26%2c72%2c248%2c127%2c295%2c129%2c167%2c8%2c377-155%2c508-238%2c109-111%2c92-208%2c44-343l1-9c-70%2c2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29%2c5-13%2c11-16%2c18-15l-288-66z'/%3e%3cpath d='m216869%2c42243c46-2%2c92-4%2c137%2c1%2c85%2c10%2c166%2c47%2c251%2c57%2c284-107%2c519-166%2c722-157%2c237-69%2c483-98%2c729-92-3-2-6-5-9-8-29-29-15-44%2c0-58%2c133-135%2c164-259%2c121-371-44-116-164-225-331-325-178%2c20-349-28-538-7-118%2c13-234%2c39-348%2c77%2c95%2c34%2c178%2c90%2c246%2c170%2c84%2c99%2c144%2c234%2c176%2c404%2c4%2c20%2c7%2c40-33%2c48s-44-13-48-33c-29-155-83-277-158-366-79-113-260-157-317-180-189%2c19-375%2c40-537%2c82-122%2c31-229%2c74-311%2c138%2c122-26%2c249-21%2c359%2c34%2c105%2c52%2c194%2c150%2c250%2c309%2c7%2c19%2c13%2c39-26%2c52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681%2c101-88%2c66-176%2c151-263%2c250-9%2c11-19%2c21-31%2c22%2c324%2c22%2c650%2c39%2c902%2c140zm-961-183c-7-18%2c5-31%2c16-44%2c91-103%2c183-194%2c278-264%2c92-68%2c187-117%2c285-140%2c100-111%2c248-178%2c420-222%2c167-43%2c358-65%2c551-84-57-115-130-184-214-221-90-40-194-46-305-35-233%2c80-440%2c205-639%2c346%2c18%2c0%2c36%2c0%2c53%2c1%2c59%2c4%2c112-5%2c161%2c14%2c20%2c7%2c39%2c14%2c25%2c53-17%2c47-146%2c18-191%2c15-51-3-107%2c1-169%2c16-10%2c2-19%2c5-28%2c2-209%2c129-367%2c260-536%2c403%2c128%2c45%2c228%2c98%2c293%2c160z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3cpath fill='%230093dd' d='m240096%2c66034%2c8752-19837-6456-10424-11513%2c4263-5329%2c20965c5022%2c1281%2c9882%2c2973%2c14545%2c5034z'/%3e%3cpath fill='white' d='m228935%2c47685c5767%2c1471%2c11350%2c3414%2c16705%2c5782l-3377%2c7657c-4934-2181-10076-3971-15390-5326z'/%3e%3cpath fill='red' d='m242806%2c59894%2c2256-5113c-5283-2336-10790-4252-16479-5704l-1330%2c5231c5396%2c1377%2c10620%2c3195%2c15631%2c5410l-78%2c176z'/%3e%3cpath fill='black' d='m230207%2c53061c151-95%2c312-72%2c474-46%2c131-49%2c282-66%2c446-60%2c70-38%2c151-65%2c243-82%2c49-38%2c51-79%2c7-123-41-50-64-99-67-149-260-151-356-381-455-609-148-39-217-89-233-145-72-7-143-14-214-22-337%2c37-424-72-544-161-100-33-187-88-243-193-37-47-74-93-111-140-92-117-64-272%2c75-263%2c98%2c11%2c195%2c11%2c285-28%2c105-47%2c262-46%2c381-36%2c141-8%2c230-99%2c367-227-1-55-1-109-2-164-22-59%2c6-85%2c84-77%2c183%2c6%2c292%2c92%2c366%2c214%2c213%2c37%2c381%2c139%2c494%2c318%2c283%2c1%2c474%2c108%2c497%2c213%2c17%2c77-66%2c165-194%2c259%2c1%2c19%2c2%2c39%2c2%2c58%2c76%2c66%2c126%2c132%2c152%2c197%2c159%2c61%2c311%2c143%2c453%2c263%2c405-47%2c1088%2c247%2c2011%2c836%2c599%2c107%2c1180%2c273%2c1738%2c514%2c118%2c4%2c236%2c7%2c353%2c11%2c1001-148%2c1971-34%2c2871%2c654%2c340%2c41%2c645%2c148%2c940%2c270%2c219%2c90%2c442%2c125%2c667%2c146%2c364%2c35%2c733%2c125%2c1099%2c295%2c411%2c92%2c795%2c221%2c1033%2c509%2c169%2c204%2c128%2c392-87%2c470-130%2c274-389%2c286-777%2c151-267%2c49-561-165-828-366-371-119-712-333-1049-561-175-131-352-214-524-251-135-29-256-48-337%2c0-40%2c24-35%2c38%2c0%2c67%2c94%2c79%2c160%2c197%2c181%2c339%2c19%2c125-1%2c269%2c6%2c422%2c8%2c161%2c105%2c278%2c267%2c378%2c111%2c68%2c243%2c140%2c434%2c167%2c91%2c18%2c117%2c71%2c114%2c140%2c51%2c244%2c98%2c490%2c187%2c711%2c25%2c63%2c73%2c93%2c145%2c146%2c247%2c178%2c119%2c377-106%2c420-197%2c174-367%2c291-569%2c337-161%2c54-227-12-281-91-97-2-146-41-187-104-197-145-29-397%2c442-289%2c10-55%2c50-72%2c90-71-28-122-44-258%2c9-385-42-27-78-61-139-81-170-54-331-132-458-251-241-227-618-417-981-608-300-15-523-153-758-270-106-1-212-3-318-4-93-31-169%2c1-225%2c68-94%2c114-203%2c95-332%2c80-148-17-298-6-446-8-73%2c18-145%2c41-224%2c42-167-9-330-11-441%2c82-92%2c97-184%2c90-276%2c54-69-32-119-66-148-102-116-24-191-53-216-88-195-55-250-110-241-165-259-62-136-266%2c32-273%2c198-8%2c379%2c30%2c573%2c57%2c163%2c46%2c364%2c19%2c497-101%2c86-78%2c118-145%2c223-203-335-22-582-81-764-196-490-309-882-384-1194-122-83%2c47-148%2c66-237%2c32-75-29-171-29-246-12-177%2c40-352%2c18-529-46-259%2c65-517%2c79-776%2c26-219%2c115-379%2c128-481%2c40-96-54-187-109-273-168-139-21-199-56-205-102-178-20-200-85-199-156-74-85-46-150%2c28-205%2c132-55%2c269-75%2c421%2c3%2c91%2c43%2c158%2c85%2c213%2c128%2c101-12%2c188%2c0%2c264%2c28%2c56-88%2c215-92%2c389-82%2c87-58%2c191-99%2c324-111-4-21-8-42-11-62-175-46-265-173-352-301-269-5-462-118-654-236-158%2c13-285-39-408-113-100%2c8-211%2c12-316-15-208%2c57-405%2c53-591%2c0-131%2c12-236-1-344-11-123%2c141-261%2c166-412%2c94-83-105-201-174-350-213-113-37-148-86-168-139-138-85-110-169%2c23-233%2c100-48%2c225-57%2c415%2c37%2c62%2c23%2c131%2c39%2c209%2c45z'/%3e%3cpath fill='white' d='m236801%2c55071c-13-23-41-81-142-23-313-17-663-13-926-168-274-161-556-329-859-317%2c90-85%2c202-143%2c332-178%2c174-46%2c380-49%2c608-12%2c320%2c52%2c602%2c114%2c820%2c196%2c210%2c79%2c358%2c177%2c423%2c303%2c2%2c3%2c15%2c18%2c18%2c20%2c84%2c54%2c157%2c109%2c218%2c167%2c46%2c43%2c86%2c88%2c120%2c136-99%2c9-201%2c2-301-18-110-22-216-59-312-108z'/%3e%3cpath fill='black' d='m237521%2c39962%2c18%2c94%2c394%2c2040-1567%2c1366-72%2c63%2c91%2c32%2c1964%2c679%2c399%2c2040%2c19%2c94%2c72-63%2c1570-1361%2c1967%2c674%2c91%2c31-18-94-394-2041%2c1567-1366%2c72-63-91-31-1964-680-399-2040-19-94-72%2c63-1571%2c1362-1966-675z'/%3e%3cg fill='%23f7db17'%3e%3cpath d='m236561%2c43439%2c1464-1276%2c1841%2c634z'/%3e%3cpath d='m240110%2c42750%2c1469-1277%2c1835%2c635z'/%3e%3cpath d='m243427%2c42173-1464%2c1276-1841-634z'/%3e%3cpath d='m239878%2c42863-1469%2c1276-1835-634z'/%3e%3cpath d='m237729%2c40150%2c1837%2c630%2c372%2c1911z'/%3e%3cpath d='m240101%2c42878%2c1840%2c634%2c368%2c1907z'/%3e%3cpath d='m242259%2c45462-1837-629-372-1911z'/%3e%3cpath d='m239887%2c42734-1840-633-368-1907z'/%3e%3cpath d='m241162%2c39516%2c373%2c1906-1469%2c1277z'/%3e%3cpath d='m239985%2c42934%2c371%2c1911-1467%2c1273z'/%3e%3cpath d='m238826%2c46096-373-1906%2c1469-1277z'/%3e%3cpath d='m240003%2c42678-371-1911%2c1467-1272z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$1h = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2800 1400'%3e%3crect width='2800' height='1400' id='red' style='fill:%23cc0001'/%3e%3crect width='2800' height='100' y='1300' id='white' style='fill:white'/%3e%3cuse transform='translate(0%2c-200)' id='use3035' xlink:href='%23white'/%3e%3cuse transform='translate(0%2c-400)' id='use3038' xlink:href='%23white'/%3e%3cuse transform='translate(0%2c-600)' id='use3062' xlink:href='%23white'/%3e%3cuse transform='translate(0%2c-800)' id='use3064' xlink:href='%23white'/%3e%3cuse transform='translate(0%2c-1000)' id='use3066' xlink:href='%23white'/%3e%3cuse transform='translate(0%2c-1200)' id='use3068' xlink:href='%23white'/%3e%3crect width='1400' height='800' id='blue' style='fill:%23010066'/%3e%3cpath d='M 576%2c100 C 409.85356%2c100 275%2c234.40553 275%2c400 C 275%2c565.59446 409.85356%2c699.99999 576%2c700 C 636.02725%2c700 691.95466%2c682.43566 738.92693%2c652.21675 C 711.57383%2c661.65623 682.2175%2c666.81914 651.65599%2c666.81914 C 504.3291%2c666.81915 384.75944%2c547.64674 384.75944%2c400.80929 C 384.75944%2c253.97184 504.32908%2c134.79944 651.65599%2c134.79944 C 684.21403%2c134.79944 715.40185%2c140.61419 744.2578%2c151.26671 C 696.21698%2c118.90999 638.30493%2c100 576%2c100 z' id='path4945' style='fill:%23fc0'/%3e%3cpath d='M 914.28574%2c471.42858 L 814.74817%2c418.17806 L 844.17832%2c527.16068 L 777.60261%2c435.99589 L 756.83247%2c546.9551 L 736.40474%2c435.93234 L 669.5481%2c526.89131 L 699.31432%2c418.00001 L 599.61295%2c470.94319 L 673.67755%2c385.75059 L 560.87853%2c390.19195 L 664.57212%2c345.5715 L 561.01668%2c300.63137 L 673.80146%2c305.42069 L 600.00003%2c220.00001 L 699.53759%2c273.25053 L 670.10745%2c164.26791 L 736.68316%2c255.4327 L 757.4533%2c144.47349 L 777.88103%2c255.49624 L 844.73767%2c164.53728 L 814.97145%2c273.42858 L 914.67282%2c220.4854 L 840.60822%2c305.67799 L 953.40723%2c301.23664 L 849.71365%2c345.85709 L 953.26909%2c390.79722 L 840.48431%2c386.0079 z' transform='matrix(1.2737922%2c0%2c0%2c1.2422928%2c-89.4427%2c-29.478379)' id='path4959' style='fill:%23fc0'/%3e%3c/svg%3e";

var img$1g = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 4320 2880'%3e%3crect fill='%23ed2939' width='4320' height='1440'/%3e%3crect fill='white' y='1440' width='4320' height='1440'/%3e%3cpath fill='white' d='M 1481.678%2c720 A 541.5%2c541.5 0 1 1 398.67798%2c720 A 541.5%2c541.5 0 1 1 1481.678%2c720 z'/%3e%3cpath fill='%23ed2939' d='M 1651.835%2c720 A 511.73499%2c511.73499 0 1 1 628.36499%2c720 A 511.73499%2c511.73499 0 1 1 1651.835%2c720 z'/%3e%3cpath fill='white' id='star' d='M 1007.1951%2c733.06439 L 933.63466%2c676.63425 L 860.09279%2c733.09117 L 888.40587%2c642.09687 L 814.61147%2c586.0053 L 905.6704%2c586.1981 L 933.6049%2c495.07467 L 961.56934%2c586.18798 L 1052.6282%2c585.96246 L 978.8522%2c642.0808 L 1007.1951%2c733.06439 z'/%3e%3cuse xlink:href='%23star' transform='translate(577.18853%2c0)'/%3e%3cuse xlink:href='%23star' transform='translate(288.88853%2c-214.21117)'/%3e%3cuse xlink:href='%23star' transform='translate(107.99953%2c342.74883)'/%3e%3cuse xlink:href='%23star' transform='translate(469.18853%2c342.74883)'/%3e%3c/svg%3e";

var img$1f = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 90'%3e%3ctitle%3eFlag of the Philippines%3c/title%3e%3cdesc%3eCoding according to the official 'description and specification of the FILIPINO flag' in Executive Order No. 23 from 1936%3c/desc%3e%3crect width='180' height='90' fill='%230038a8'/%3e%3crect y='45' width='180' height='45' fill='%23ce1126'/%3e%3cpath d='M 77.942286%2c45 0%2c90 0%2c0' fill='white'/%3e%3cg transform='translate(28%2c45)' fill='%23fcd116'%3e%3ccircle r='9'/%3e%3cg id='j'%3e%3cg id='i'%3e%3cg id='h'%3e%3cpath d='M -1%2c0 L -0.93848823%2c0.06151177 L 0%2c0 L -0.93848823%2c-0.06151177 z' transform='scale(19)'/%3e%3cpath id='g' d='M -0.88366349%2c0.11633651 L -0.83408932%2c0.16591068 L 0%2c0 z' transform='scale(19.238092)'/%3e%3cuse xlink:href='%23g' transform='scale(1%2c-1)'/%3e%3c/g%3e%3cuse xlink:href='%23h' transform='rotate(45)'/%3e%3c/g%3e%3cuse xlink:href='%23i' transform='rotate(90)'/%3e%3c/g%3e%3cuse xlink:href='%23j' transform='rotate(180)'/%3e%3cg transform='translate(-2.019238)'%3e%3cg id='s' transform='translate(37.961524%2c0)'%3e%3cpath id='t' d='M 5%2c0 L 1.618034%2c1.175571 1.545085%2c4.755283 -0.618034%2c1.902113 -4.045085%2c2.938926 -2%2c0 z'/%3e%3cuse xlink:href='%23t' transform='scale(1%2c-1)'/%3e%3c/g%3e%3cuse xlink:href='%23s' transform='rotate(120)'/%3e%3cuse xlink:href='%23s' transform='rotate(-120)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$1e = "data:image/svg+xml,%3csvg viewBox='0 0 900 600' xmlns='http://www.w3.org/2000/svg'%3e%3crect transform='scale(-1%2c1)' x='-900' width='900' height='600' fill='%23c1272d'/%3e%3cpath d='m450 224.31-44.467 136.87 116.4-84.559h-143.87l116.4 84.559z' fill='none' stroke='%23006233' stroke-width='14.63'/%3e%3c/svg%3e";

var img$1d = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1098 549'%3e%3ctitle%3eFlag of Belarus%3c/title%3e%3crect fill='%23C8313E' width='1098' height='549'/%3e%3crect y='366' fill='%234AA657' width='1098' height='183'/%3e%3crect fill='white' width='122' height='549'/%3e%3cg id='h'%3e%3cg id='q' fill='%23C8313E' fill-rule='evenodd' transform='scale(5.304347826%2c9)'%3e%3cpath d='M4%2c0h3v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h1v-1h1v-1h1v-1h1zM5%2c2h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM5%2c4h1v1h-1zM0%2c1h1v1h-1zM0%2c7h1v1h-1zM11%2c0h0.6v2h-.6zM11%2c7h.6v2h-.6zM2%2c9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM2%2c11h1v1h-1zM8%2c9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM8%2c11h1v1h-1zM0%2c15h1v1h-1zM11%2c14h.6v2h-.6z'/%3e%3cpath d='M0%2c18h1v-1h1v-1h1v-1h1v-1h1v-1h1v1h1v1h1v1h1v1h1v1h1v1h.6v4h-.6v1h-1v1h-1v1h-1v1h-1v1h-1v2.6h-2v-0.6h-1v-1h-1v-1h-1v-1h-1 v-3h1v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h-1v-1h-3v1h2v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1zM0%2c22h1v1h-1zM11%2c25h.6v1h-.6zM9%2c27h1v1h1v1h.6v1.6h-.6v-.6h-1v-1h-1zM7%2c30h1v.6h-1z'/%3e%3c/g%3e%3cuse xlink:href='%23q' transform='translate(122%2c0) scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23h' transform='translate(0%2c549) scale(1%2c-1)'/%3e%3c/svg%3e";

var img$1c = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3crect fill='white' width='3' height='2'/%3e%3crect fill='%23CE1126' width='3' height='1'/%3e%3c/svg%3e";

var img$1b = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect fill='%23A51931' width='900' height='600'/%3e%3crect fill='%23F4F5F8' y='100' width='900' height='400'/%3e%3crect fill='%232D2A4A' y='200' width='900' height='200'/%3e%3c/svg%3e";

var img$1a = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 8'%3e%3crect width='16' height='8' fill='%23002395'/%3e%3cpath d='m4.24%2c0h8v8z' fill='%23fecb00'/%3e%3cg id='g'%3e%3cpath d='M2.353283%2c0.5248529 2.8%2c-0.85 3.246717%2c0.524853 2.077197%2c-0.324853H3.522803z' fill='white' id='s'/%3e%3cuse xlink:href='%23s' x='1' y='1'/%3e%3cuse xlink:href='%23s' x='2' y='2'/%3e%3c/g%3e%3cuse xlink:href='%23g' x='3' y='3'/%3e%3cuse xlink:href='%23g' x='6' y='6'/%3e%3c/svg%3e";

var img$19 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3crect width='900' height='600' fill='black'/%3e%3crect width='900' height='400' fill='white'/%3e%3crect width='900' height='200' fill='%23ce1126'/%3e%3cg fill='white' stroke='%23c09300'%3e%3cpath stroke-width='1.2703' stroke-linejoin='round' d='m450.81%2c302.4%2c68.488%2c63.579-4.8759-115.47c-0.71638-17.5-15.924-13.485-26.971-7.1723-11.191%2c7.1723-23.958%2c7.1723-37.446%2c2.437-13.485%2c4.7353-26.253%2c4.7353-37.444-2.437-11.046-6.3123-26.252-10.328-26.97%2c7.1723l-4.8789%2c115.47%2c70.098-63.579z'/%3e%3cg id='w' fill='%23c09300' stroke='none'%3e%3cpath d='m393.47%2c246.49-4.7342%2c112.32-8.0347%2c7.168%2c4.8784-115.47c2.2949-1.5782%2c6.3132-4.0171%2c7.8905-4.0171z'/%3e%3cpath d='m403.09%2c254.53-4.0171%2c93.955-8.0323%2c8.2204%2c4.8772-108.49c1.5791%2c1.577%2c6.3138%2c5.4498%2c7.1721%2c6.3104z'/%3e%3cpath d='m411.84%2c261.7-3.1545%2c78.362-6.4556%2c6.3092%2c4.0177-89.405c1.5748%2c1.5782%2c4.7311%2c3.8734%2c5.5924%2c4.7334z'/%3e%3cpath d='m421.31%2c265.72-3.1563%2c66.787-6.3132%2c5.1193%2c3.1563-74.344c1.5791%2c0.71638%2c4.7348%2c2.4376%2c6.3132%2c2.4376z'/%3e%3cpath d='m430.06%2c265.72-2.2974%2c55.657-6.4544%2c6.3129%2c2.4392-61.252c1.576-0.00061%2c5.5937-0.00061%2c6.3126-0.7182z'/%3e%3c/g%3e%3cuse xlink:href='%23w' transform='matrix(-1%2c0%2c0%2c1%2c900%2c0)'/%3e%3cpath fill='%23c09300' stroke-width='1.0739' d='m453.16%2c315.06%2c9.6126%2c43.755-3.1575%2c3.1552-3.2993-2.4388-5.4518-39.018%2c2.2955%2c39.018-3.1569%2c4.0158-3.1563-4.0158%2c2.2962-39.018-5.4506%2c39.018-3.3024%2c2.4388-3.1545-3.1552%2c9.6113-43.755h6.3138z'/%3e%3cg id='b' fill='none' stroke-width='1.2705' stroke-linejoin='round'%3e%3cpath fill='white' stroke-width='1.1888' d='m428.48%2c295.84-19.08%2c67.705%2c26.255%2c4.0177%2c11.188-50.924-18.363-20.799z'/%3e%3cpath d='m422.17%2c318.94%2c2.2955%2c5.5928%2c12.405-11.848'/%3e%3cpath d='m430.76%2c304.92%2c2.5957%2c24.346%2c7.8905-10.328'/%3e%3cpath d='m438.09%2c322.95%2c4.31%2c14.875'/%3e%3cpath d='m444.09%2c332.36-8.7177%2c13.241m2.7189%2c13.216-2.7902-13.198-2.4356-13.423-5.8406%2c7.9091-2.5613-9.1191-8.1747%2c8.3847%2c4.1575%2c15.251%2c5.7375-9.4349%2c3.1557%2c9.6123%2c5.8903-9.1621'/%3e%3cpath d='m414.99%2c361.97%2c5.2997-7.4437%2c3.4528%2c11.457%2c4.7342-8.0323%2c3.1575%2c9.6136'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(-1%2c0%2c0%2c1%2c900%2c0)'/%3e%3cg stroke-width='1.2705' stroke-linejoin='round' stroke-linecap='round'%3e%3cpath stroke-width='2.3777' stroke-linejoin='round' d='m450%2c393.81c19.943%2c0%2c39.024-1.5776%2c50.213-4.734%2c4.7354-0.8588%2c4.7354-3.2976%2c4.7354-6.4553%2c4.7354-1.5776%2c2.2949-7.1704%2c5.5943-7.1704-3.2994%2c0.86244-4.0158-5.5941-8.0329-4.7316%2c0-5.5965-5.5955-6.3129-10.33-4.7377-9.4695%2c3.1576-26.255%2c3.8752-42.18%2c3.8752-15.924-0.71758-32.567-0.71758-42.179-3.8752-4.7342-1.5752-10.327-0.85881-10.327%2c4.7377-4.0183-0.86245-4.7354%2c5.5941-8.0341%2c4.7316%2c3.2988%2c0%2c0.85954%2c5.5928%2c5.5943%2c7.1704%2c0%2c3.1576%2c0%2c5.5965%2c4.8778%2c6.4553%2c11.045%2c3.1564%2c30.128%2c4.734%2c50.068%2c4.734z'/%3e%3cpath d='m422.89%2c363.54c6.4544%2c0.86123%2c13.628%2c1.5776%2c19.225%2c0.86123%2c3.1533%2c0%2c5.4494%2c5.4504-0.86257%2c6.3129-5.5931%2c0.71515-14.345%2c0-19.08-0.86245-4.0171-0.71759-12.768-2.2946-18.364-3.8752-5.5949-2.4364-1.576-7.168%2c1.5772-6.4522%2c4.879%2c1.577%2c11.192%2c3.1564%2c17.505%2c4.0158z'/%3e%3cpath d='m477.12%2c363.54c-6.4569%2c0.86123-13.628%2c1.5776-19.081%2c0.86123-3.3006%2c0-5.5961%2c5.4504%2c0.71711%2c6.3129%2c5.5955%2c0.71515%2c14.347%2c0%2c19.078-0.86245%2c4.0189-0.71759%2c12.769-2.2946%2c18.364-3.8752%2c5.5967-2.4364%2c1.5803-7.168-1.5772-6.4522-4.8778%2c1.577-11.19%2c3.1564-17.501%2c4.0158z'/%3e%3cpath d='m403.09%2c360.39c-4.8771-0.86123-7.1723%2c4.7316-5.5928%2c7.8868%2c0.71637-1.5776%2c4.0164-1.5776%2c4.7346-3.1552%2c0.8582-2.437-0.7182-2.437%2c0.8582-4.7316z'/%3e%3cpath d='m422.17%2c375.06c0-3.1528%2c3.1545-2.7651%2c3.1545-5.9215%2c0-1.577-0.85893-4.0171-2.4368-4.0171-1.5785%2c0-3.1575%2c1.5776-3.1575%2c3.1552-0.7177%2c3.157%2c2.4398%2c3.6312%2c2.4398%2c6.7834z'/%3e%3cpath d='m444.88%2c365.98c4.7305%2c0%2c4.2618%2c6.3141%2c1.9656%2c9.4699%2c0-2.2952-4.0164-3.1558-4.0164-4.7316%2c0-2.4419%2c3.6262-2.4419%2c2.0508-4.7383z'/%3e%3cpath d='m496.91%2c360.39c4.8777-0.86123%2c7.1741%2c4.7316%2c5.5953%2c7.8868-0.71819-1.5776-4.017-1.5776-4.734-3.1552-0.86124-2.437%2c0.71759-2.437-0.86124-4.7316z'/%3e%3cpath d='m477.83%2c375.06c0-3.1528-3.1532-2.7651-3.1532-5.9215%2c0-1.577%2c0.85953-4.0171%2c2.438-4.0171%2c1.5772%2c0%2c3.1563%2c1.5776%2c3.1563%2c3.1552%2c0.71771%2c3.157-2.441%2c3.6312-2.441%2c6.7834z'/%3e%3cpath d='m455.12%2c365.98c-4.7323%2c0-4.263%2c6.3141-1.9674%2c9.4699%2c0-2.2952%2c4.0158-3.1558%2c4.0158-4.7316%2c0.00061-2.4419-3.6262-2.4419-2.0484-4.7383z'/%3e%3cg stroke-width='0.8915'%3e%3cpath d='m404.67%2c361.97c1.58%2c0%2c4.0177%2c0.71758%2c4.7353%2c1.577l-4.74-1.58z'/%3e%3cpath d='m412.55%2c364.41c0.86184%2c0%2c4.0183%2c0.71639%2c5.5959%2c1.5752l-5.6-1.58z'/%3e%3cpath d='m441.25%2c367.56c-1.5776%2c0-4.734%2c0-5.5928%2c0.71516l5.59-0.72z'/%3e%3cpath d='m432.5%2c367.56c-0.8588-0.86245-4.0165-0.86245-5.5935%2c0h5.59z'/%3e%3cpath d='m495.34%2c361.97c-1.5776%2c0-3.8746%2c0.71758-4.7353%2c1.577l4.7353-1.577z'/%3e%3cpath d='m487.45%2c364.41c-0.86002%2c0-4.0171%2c0.71639-5.5953%2c1.5752l5.6-1.58z'/%3e%3cpath d='m458.75%2c367.56c1.5794%2c0%2c4.7352%2c0%2c5.5953%2c0.71516l-5.6-0.72z'/%3e%3cpath d='m467.5%2c367.56c0.86002-0.86245%2c4.0183-0.86245%2c5.5953%2c0h-5.6z'/%3e%3c/g%3e%3cg fill='%23c09300' stroke='none'%3e%3cpath d='m403.34%2c374.58c-0.53406-0.10208-0.81452-0.52459-0.68011-1.0246%2c0.16371-0.609%2c0.65161-0.95739%2c1.1126-0.79442%2c0.29312%2c0.10362%2c0.82973%2c0.64469%2c0.83184%2c0.83874%2c0.003%2c0.22275-0.28059%2c0.75257-0.40266%2c0.75379-0.0527%2c0.00053-0.1342%2c0.0465-0.18122%2c0.10201-0.10001%2c0.11816-0.41341%2c0.17549-0.68041%2c0.12446z'/%3e%3cpath d='m458.27%2c378.5c-0.19869-0.0736-0.51521-0.5185-0.51485-0.72377%2c0.002-0.38717%2c0.57418-1.0178%2c0.92881-1.0214%2c0.17516-0.001%2c0.65475%2c0.2481%2c0.83411%2c0.43462%2c0.32504%2c0.33789%2c0.25419%2c0.89278-0.15423%2c1.2079-0.20096%2c0.15505-0.80025%2c0.21125-1.0938%2c0.1026z'/%3e%3cpath d='m458.63%2c380.98c-0.42018-0.14209-0.57388-0.34776-0.60803-0.8136-0.0355-0.4854%2c0.0116-0.56097%2c0.52453-0.84064l0.36556-0.19931%2c0.34646%2c0.1545c0.47988%2c0.21397%2c0.69338%2c0.44463%2c0.71031%2c0.76742%2c0.0182%2c0.34768-0.2397%2c0.70345-0.64012%2c0.8829-0.35162%2c0.15758-0.37253%2c0.15904-0.69871%2c0.0488z'/%3e%3cpath d='m407.75%2c370.09c-0.34619-0.0109-0.82136%2c0.30729-1.0938%2c0.46875-0.64912%2c0.15215-1.4047%2c0.5511-2.0312%2c0.125-0.61719-0.19079-1.438-0.0404-1.5312%2c0.71875%2c0.15839%2c0.65179%2c1.0715%2c1.0243%2c1.625%2c0.59375%2c0.4106-0.53758%2c1.5312-0.8528%2c1.6562%2c0.0625-0.45705%2c0.69215-0.40489%2c1.6089-0.78125%2c2.3438-0.0612%2c0.45773-0.25176%2c0.8924-0.5%2c1.2812-0.4621%2c0.0464-0.95375-0.008-1.3438%2c0.28125-0.62601%2c0.0342-1.2647%2c0.34537-1.625%2c0.875-0.40338%2c0.57818-0.78869%2c1.1654-0.90625%2c1.875%2c0.10725%2c0.72494%2c0.93754%2c0.93275%2c1.5625%2c0.96875%2c0.66694%2c0.18359%2c1.3344%2c0.42433%2c2%2c0.625%2c1.0853%2c0.24303%2c2.102%2c0.63539%2c3.1875%2c0.875%2c1.5844%2c0.47758%2c3.2479%2c0.69739%2c4.8438%2c1.125%2c0.16722%2c0.0555%2c0.32405%2c0.1038%2c0.5%2c0.125%2c0.66233%2c0.13773%2c1.0079-0.58289%2c1.0625-1.125%2c0.32864-1.1596%2c0.57948-2.3391%2c0.90625-3.5%2c0.22487-0.46559%2c0.49645-1.5172-0.40625-1.2812-0.51485%2c0.30872-0.95182%2c0.7734-1.5938%2c0.8125-0.87392%2c0.0509-0.37513%2c0.94518-0.0312%2c1.3125%2c0.0759%2c0.5872-0.10989%2c1.2888-0.5%2c1.75-0.51994%2c0.32957-1.1716-0.0561-1.7188-0.1875-0.57469%2c0.01-1.7234-0.28325-1.1875-1.0625%2c0.19033-0.57691%2c0.20718-1.2083%2c0.4375-1.7812%2c0.29353-0.61455%2c0.33553-1.2851%2c0.46875-1.9375-0.36122-0.77733-0.97856%2c0.25585-1.4688%2c0.34375-0.33769%2c0.23455-1.6054%2c0.33418-0.9375%2c0.9375%2c0.57518%2c0.43696%2c0.1343%2c1.1967%2c0.0312%2c1.75-0.0369%2c0.77025-0.83781%2c0.95394-1.4688%2c0.78125-0.62768-0.0303-1.5013-0.49748-0.96875-1.1875%2c0.12115-0.57512%2c0.322-1.1402%2c0.4375-1.7188%2c0.2374-0.69777%2c0.43732-1.3628%2c0.6875-2.0625%2c0.10851-0.61996%2c0.33113-1.2079%2c0.625-1.75%2c0.0173-0.68543%2c0.47775-1.2752%2c0.46875-1.9688-0.0469-0.33876-0.19853-0.4622-0.40625-0.46875zm-3.5938%2c7.25c0.0817-0.0141%2c0.1399-0.002%2c0.21875%2c0.0312%2c0.24971%2c0.10625%2c0.25708%2c0.30938%2c0%2c0.53125-0.11238%2c0.097-0.23995%2c0.1905-0.28125%2c0.1875-0.46771-0.0402-0.6056-0.10974-0.625-0.28125-0.0172-0.15117%2c0.0307-0.19455%2c0.34375-0.34375%2c0.15556-0.0742%2c0.26207-0.11086%2c0.34375-0.125z'/%3e%3cpath d='m403.12%2c382.36c-0.49596-0.46627-0.41621-0.80642%2c0.31729-1.3532%2c0.31384-0.23393%2c0.50421-0.20747%2c0.8631%2c0.11997%2c0.55237%2c0.50393%2c0.57448%2c0.82295%2c0.0869%2c1.2548-0.24101%2c0.21344-0.34645%2c0.25721-0.62697%2c0.26001-0.29347%2c0.003-0.3766-0.0334-0.64036-0.28155z'/%3e%3cpath d='m406.17%2c383.28c-0.48488-0.11955-0.76441-0.60787-0.62254-1.0876%2c0.12852-0.43459%2c0.20285-0.47736%2c0.84026-0.48378%2c0.71478-0.007%2c0.85352%2c0.11244%2c0.86039%2c0.74185%2c0.004%2c0.35432-0.0235%2c0.43652-0.19971%2c0.60041-0.2071%2c0.19261-0.6052%2c0.29644-0.8784%2c0.22908z'/%3e%3cpath d='m495.28%2c383.36c-0.22701-0.18894-0.27272-0.27435-0.27532-0.51479-0.003-0.41064%2c0.23349-0.71172%2c0.74605-0.94382%2c0.68183-0.30882%2c0.95981-0.26636%2c1.2166%2c0.18575%2c0.34158%2c0.60129%2c0.32512%2c0.84675-0.0839%2c1.252-0.22578%2c0.22366-0.26805%2c0.2367-0.78493%2c0.2419-0.50756%2c0.003-0.56562-0.0105-0.8185-0.22102z'/%3e%3cpath d='m410.22%2c384.51c-0.36389-0.0971-0.5525-0.37016-0.55726-0.80675-0.004-0.33383%2c0.0201-0.38706%2c0.25362-0.56985%2c0.15122-0.11834%2c0.39018-0.21971%2c0.57856-0.24541%2c0.2669-0.0365%2c0.36442-0.0132%2c0.57916%2c0.13775%2c0.55052%2c0.38698%2c0.66746%2c0.76972%2c0.3487%2c1.1412-0.33953%2c0.39572-0.66141%2c0.48753-1.2028%2c0.34303z'/%3e%3cpath d='m432.14%2c385.49c-0.0807-0.10062-0.25916-0.16012-0.2775-0.287%2c0.032-0.55487%2c0.0585-1.1167%2c0.23525-1.6482%2c0.0962-0.52301%2c0.012-1.0692%2c0.19432-1.5787%2c0.18698-0.92682%2c0.18682-1.8826%2c0.40217-2.8036%2c0.01-0.47427%2c0.0549-0.949%2c0.19241-1.4054%2c0.15774-0.72168%2c0.0136-1.4762%2c0.22606-2.1894-0.0228-0.26786%2c0.28574-0.98321%2c0.55658-0.55944%2c0.39321%2c0.57645%2c0.91139%2c1.0451%2c1.4208%2c1.5153%2c0.43771%2c0.25252%2c0.0359%2c0.62445-0.26658%2c0.74975-0.41521%2c0.16364-0.51613%2c0.62086-0.48666%2c1.0222-0.0582%2c0.41455-0.22464%2c0.80685-0.24153%2c1.23-0.0878%2c0.62242-0.0706%2c1.2546-0.15153%2c1.8765-0.18211%2c0.60901-0.11244%2c1.2597-0.17323%2c1.8875%2c0.008%2c0.39859-0.18142%2c0.7606-0.15525%2c1.1604-0.0484%2c0.40592-0.0665%2c0.89432-0.40713%2c1.1724-0.32888%2c0.16605-0.80429%2c0.13737-1.0682-0.14228z'/%3e%3cpath d='m461.84%2c375.69c-0.48222%2c0.36463-0.91353%2c0.79527-1.3438%2c1.2188-0.59251%2c0.4489%2c0.48677%2c0.70998%2c0.625%2c1.0938%2c0.15716%2c0.58638%2c0.1478%2c1.2106%2c0.1875%2c1.8125%2c0.17923%2c0.55142%2c0.25835%2c1.1384%2c0.21875%2c1.7188-0.0519%2c0.6223-0.86338%2c0.49115-1.2188%2c0.84375-0.49176%2c0.20722-0.68789%2c0.69047-1.0625%2c1.0312-0.24625%2c0.48275-0.31215%2c1.0763-0.34375%2c1.625%2c0.0353%2c0.44788-0.30248%2c0.94931%2c0%2c1.3438%2c0.039%2c0.0557%2c0.0852%2c0.132%2c0.125%2c0.1875%2c0.10115%2c0.1452%2c0.3425%2c0.0292%2c0.5%2c0.0625%2c0.50368-0.0282%2c1.0285%2c0.0473%2c1.5-0.15625%2c1.21-0.20943%2c2.4311-0.22605%2c3.6562-0.28125%2c0.74925%2c0.0239%2c1.4701-0.23695%2c2.2188-0.21875%2c0.58681%2c0.12974%2c0.85075-0.50626%2c0.84375-0.96875-0.33224-0.65359-0.045-1.4285-0.3125-2.0938-0.23494-0.67246-0.14236-1.428-0.25-2.125-0.0148-0.54835-0.71068-0.75172-1.0625-0.34375-0.34144%2c0.34514-0.89289%2c0.41403-1.1562%2c0.84375-0.29659%2c0.60239%2c0.62745%2c0.60317%2c0.78125%2c1.0625%2c0.17589%2c0.4642%2c0.11825%2c0.98059%2c0.15625%2c1.4688%2c0.11422%2c0.59237-0.52919%2c0.6262-0.9375%2c0.6875-0.53675%2c0.20112-1.29%2c0.33589-1.5938-0.3125-0.1909-0.47948-0.16475-0.99286-0.21875-1.5-0.0131-0.89182-0.22755-1.7684-0.28125-2.6562-0.0514-1.0968-0.2407-2.1866-0.3125-3.2812-0.01-0.45549-0.0706-1.198-0.71875-1.0625zm-0.625%2c8.25%2c0.3125%2c0.0312%2c0.0312%2c0.375%2c0.0312%2c0.375-0.40625%2c0.125c-0.21512%2c0.0636-0.40325%2c0.0943-0.40625%2c0.0937-0.003-0.00085-0.088-0.0531-0.1875-0.125-0.21959-0.1586-0.16345-0.38503%2c0.125-0.6875%2c0.1626-0.17028%2c0.23879-0.2033%2c0.5-0.1875z'/%3e%3cpath d='m431.25%2c374.66c-0.38018%2c0.13504-0.86245%2c0.69313-1.25%2c0.6875-0.88%2c0.0623-0.75718%2c0.91919-0.125%2c1.2188%2c0.0833%2c0.25988%2c0.005%2c0.58789%2c0.0312%2c0.875%2c0.12288%2c0.7896-0.37535%2c1.4249-0.28125%2c2.2188-0.0442%2c0.87031-0.30695%2c1.7177-0.34375%2c2.5938-0.24704%2c0.90327-0.24984%2c1.8321-0.40625%2c2.75-0.10431%2c0.82323-0.69963%2c0.53271-1.2188%2c0.3125-0.004-0.35689-0.0272-0.70562-0.0312-1.0625%2c0.21637-0.81711-0.44101-1.0556-1.0938-1.1562-0.68611%2c0.0649-1.0228-0.52316-0.875-1.125%2c0.29488-0.35103%2c1.036-0.2534%2c1.5-0.3125%2c0.9813%2c0.20342%2c0.9416-1.1118%2c0.4375-1.5625-0.34472-0.63567-1.1982-0.90926-1.4375-1.5625%2c0.0956-0.86642-0.47971-1.7322-1.1875-2.1562-1.0885-0.0764-1.9104%2c0.86306-2.3125%2c1.7812-0.4525%2c0.13085-0.90391%2c0.26657-1.3438%2c0.4375-0.70889%2c0.17748-1.7197%2c1.407-0.75%2c1.875%2c0.54424%2c0.14988%2c2.2002%2c0.52782%2c1.4688%2c1.2812-0.41224%2c0.7071-1.201%2c0.71914-1.9062%2c0.53125-0.72365%2c0.00063-1.5294-0.35207-1.5-1.1875-0.14765-0.74985-0.12337-1.5579-0.46875-2.25-0.14847-0.83929-1.1008-0.64297-1.1562%2c0.125-0.73341%2c0.53403-0.6357%2c1.3978-0.125%2c2.0312%2c0.31876%2c0.72891%2c0.003%2c1.5776-0.3125%2c2.25-0.19091%2c0.87497-1.1559%2c0.90473-1.8438%2c1.1875-0.33751%2c0.13104-1.6285-0.0779-1.1562%2c0.65625%2c0.75312%2c0.26578%2c1.6525%2c0.50493%2c2.4375%2c0.3125%2c0.82295-0.10214%2c1.5375-0.66484%2c1.9375-1.375%2c0.55266-0.56003%2c1.502-0.26685%2c2.2188-0.28125%2c0.7728-0.002%2c1.5626%2c0.54243%2c2.3125%2c0.1875%2c0.21739-0.56438%2c1.2219-1.4958%2c1.5312-0.53125-0.0526%2c0.86265%2c0.70932%2c1.3257%2c1.5%2c1.2188%2c0.86375-0.0494%2c0.54445%2c0.61096%2c0.53125%2c1.125%2c0.0571%2c0.93448%2c0.65972%2c1.4247%2c1.4375%2c1.8125%2c0.26491%2c0.0715%2c0.545%2c0.0474%2c0.8125%2c0%2c0.74793-0.23513%2c1.5536-0.5689%2c1.7812-1.4062%2c0.30361-0.68071%2c0.31071-1.4507%2c0.53125-2.1562%2c0.17722-1.1299%2c0.406-2.26%2c0.4375-3.4062%2c0.27617-1.0383%2c0.19684-2.136%2c0.40625-3.1875%2c0.13231-0.7818%2c0.2308-1.5634%2c0.3125-2.3438-0.0917-0.41735-0.27189-0.48727-0.5-0.40625zm-6.7812%2c4.1562c0.15144%2c0.0185%2c0.2356%2c0.20409%2c0.25%2c0.53125%2c0.016%2c0.36409%2c0.20628%2c0.66075%2c0.4375%2c0.71875%2c0.18245%2c0.0457%2c0.16681%2c0.23882-0.0312%2c0.375-0.11507%2c0.0791-0.3209%2c0.127-0.6875%2c0.125-0.57804-0.003-0.93643-0.15276-1.25-0.46875l-0.1875-0.1875%2c0.28125-0.1875c0.14178-0.10831%2c0.39834-0.33259%2c0.5625-0.5%2c0.28494-0.29065%2c0.47356-0.42473%2c0.625-0.40625z'/%3e%3cpath d='m490.5%2c370.94c-0.56713%2c0.026-1.1373%2c0.11796-1.6562%2c0.25-1.0402-0.0647-1.5624%2c1.0271-0.5625%2c1.5625%2c0.60166%2c1.5343%2c1.5404-0.31684%2c2.5-0.1875%2c1.4375%2c0.27956%2c1.559%2c1.8323%2c1.7812%2c3%2c0.0809%2c1.1567%2c0.41439%2c2.2816%2c0.75%2c3.375%2c0.96222%2c1.0695-0.72072%2c1.7402-1.4375%2c0.90625-0.61128-0.66434-1.9204-1.4795-2.6562-0.5625-0.9036%2c0.38266-0.94069%2c1.5903-1.6875%2c1.9375-1.2091%2c0.36803-1.3613-1.1188-2-1.75-0.58724-0.82427-1.7103-0.89646-2.625-1.1875-0.42913-0.86865-0.20548-2.3456-1.0938-2.9375-0.7458%2c0.30425-2.1131%2c1.7022-0.96875%2c2.3438%2c1.1177%2c0.96067-0.48782%2c1.4011-1%2c2.0625-0.73158%2c0.81456-0.84849%2c1.936-0.96875%2c2.9688-1.2593%2c0.69566-1.5044-0.78769-1.6562-1.7188-0.0981-1.1115-1.0358-0.78521-1.6875-0.375-0.95249%2c0.38586-1.4281%2c1.2903-2.0938%2c2-0.0799%2c0.64767%2c0.0372%2c1.3567%2c0.0312%2c2.0312%2c0.21646%2c0.81142%2c1.2024%2c0.4303%2c1.8125%2c0.375%2c0.9788-0.40937%2c1.3795%2c0.62745%2c0.59375%2c1.2188-0.53181%2c0.67603-2.2198%2c0.32293-2.0625%2c1.4062%2c0.54395%2c0.0636%2c1.1105%2c0.0432%2c1.6562%2c0%2c1.0905-0.29799%2c2.2614-1.0673%2c2.375-2.2812%2c0.1436-1.0582%2c1.6676-0.86544%2c2.5-1.0938%2c1.0408-0.30002%2c2.2948-0.37704%2c2.5312%2c0.9375%2c0.70943%2c0.74499%2c2.2486%2c1.584%2c3.0312%2c0.5625%2c0.79451-0.48523%2c1.1764-1.3376%2c1.125-2.25-0.16203-0.78461%2c1.2688-0.81314%2c1.625-0.375%2c0.52141%2c0.85796%2c2.151%2c0.60478%2c2.9375%2c0.125%2c0.8361-0.61721%2c1.0176-1.705%2c2.2188-1.7188%2c1.7823-0.53352%2c3.6342-0.84122%2c5.375-1.5%2c1.4104-0.3073-0.2099-1.1977-0.5625-1.7188-1.0737-0.53098-2.0081%2c1.6419-3.2188%2c0.5625-0.93564-0.71605-0.87212-2.0766-1.2188-3.125-0.23714-1.3573-0.17721-2.9227-1.1562-4-0.67242-0.71491-1.586-0.887-2.5312-0.84375zm-6.8125%2c9.4688c0.12573-0.003%2c0.26757%2c0.0593%2c0.5%2c0.1875%2c0.43841%2c0.24193%2c0.75063%2c0.64294%2c0.75%2c0.96875-0.00043%2c0.21261-0.0545%2c0.22697-0.375%2c0.375-0.19719%2c0.091-0.4214%2c0.1885-0.5%2c0.1875-0.18098-0.002-0.62438-0.35688-0.625-0.5-0.00065-0.0594-0.0581-0.28649-0.125-0.46875-0.11761-0.32068-0.0994-0.31643%2c0.0625-0.53125%2c0.10347-0.13744%2c0.18677-0.21532%2c0.3125-0.21875zm6.5312%2c0.34375c0.37229-0.0244%2c0.59356%2c0.0918%2c0.75%2c0.375%2c0.18178%2c0.32896%2c0.0582%2c0.58095-0.40625%2c0.78125-0.20349%2c0.0878-0.407%2c0.15925-0.4375%2c0.15625-0.0306-0.003-0.19844-0.10253-0.375-0.21875-0.27012-0.17777-0.3095-0.26387-0.3125-0.46875-0.003-0.31541%2c0.34928-0.5967%2c0.78125-0.625zm-8.9375%2c0.0937c0.10904-0.017%2c0.20831%2c0.04%2c0.34375%2c0.15625%2c0.17999%2c0.15456%2c0.23685%2c0.27887%2c0.28125%2c0.59375%2c0.0314%2c0.21884%2c0.0265%2c0.50184%2c0%2c0.625-0.0486%2c0.2261-0.0532%2c0.21575-0.5625%2c0.21875-0.64029%2c0.006-0.6997-0.0639-0.6875-0.65625%2c0.008-0.37682%2c0.0118-0.4782%2c0.21875-0.6875%2c0.16044-0.16228%2c0.29721-0.23305%2c0.40625-0.25zm-5.5%2c1.4375c0.19951%2c0.0469%2c0.3879%2c0.19761%2c0.4375%2c0.4375%2c0.0656%2c0.3175%2c0.008%2c0.46223-0.25%2c0.59375-0.2221%2c0.1131-0.73401%2c0.1508-0.875%2c0.0625-0.0457-0.0286-0.1399-0.103-0.1875-0.1875-0.068-0.12114-0.0555-0.1794%2c0.0312-0.25%2c0.0605-0.0492%2c0.12539-0.11985%2c0.125-0.15625-0.0004-0.0364%2c0.0673-0.16316%2c0.15625-0.28125%2c0.14608-0.1939%2c0.36299-0.26563%2c0.5625-0.21875zm9.25%2c1.1875c0.17794-0.001%2c0.32863%2c0.0609%2c0.4375%2c0.15625%2c0.18526%2c0.16231%2c0.179%2c0.40039-0.0312%2c0.5625-0.13509%2c0.1044-0.87165%2c0.0948-1.125%2c0-0.11272-0.0421-0.15563-0.0987-0.15625-0.21875-0.002-0.14091%2c0.0375-0.22767%2c0.28125-0.34375%2c0.20425-0.0976%2c0.41581-0.15507%2c0.59375-0.15625z'/%3e%3cpath d='m467.86%2c388.29c-0.0958-0.0625-0.23767-0.11699-0.0948-0.22157%2c0.17277-0.30247%2c0.51785-0.40716%2c0.82434-0.51974%2c0.54779-0.23732%2c1.0207-0.64036%2c1.3737-1.1184%2c0.05-0.33298%2c0.42384-0.51355%2c0.42219-0.86174%2c0.003-0.47487%2c0.0311-0.9616-0.0846-1.426-0.12837-0.4257-0.45147-0.75199-0.82649-0.97395-0.25667-0.20149-0.674-0.25712-0.76877-0.61402-0.0525-0.34279%2c0.25343-0.60401%2c0.36053-0.90935%2c0.22325-0.42151%2c0.41109-0.86364%2c0.6509-1.275%2c0.25912-0.2878%2c0.65892-0.0156%2c0.79298%2c0.26239%2c0.18915%2c0.27771%2c0.35679%2c0.57593%2c0.45076%2c0.89748%2c0.30225%2c0.33175%2c0.57024%2c0.72087%2c0.679%2c1.1618%2c0.14839%2c0.31056%2c0.38316%2c0.60234%2c0.36929%2c0.96609%2c0.0003%2c0.4164%2c0.23509%2c0.78738%2c0.22034%2c1.2063%2c0.0133%2c0.56042%2c0.0131%2c1.1449-0.19184%2c1.6741-0.14001%2c0.29344-0.42058%2c0.46964-0.60639%2c0.73256-0.31897%2c0.29554-0.67037%2c0.57899-1.0797%2c0.73615-0.28928%2c0.092-0.45706%2c0.42565-0.81934%2c0.34466-0.51458%2c0.009-1.0366%2c0.079-1.5472-0.004%2c0.0323%2c0.0542-0.15633-0.0915-0.12493-0.0573z'/%3e%3cpath d='m461.01%2c388.74c-0.24268-0.24958-0.2952-0.35543-0.29788-0.60032-0.003-0.24747%2c0.0446-0.34567%2c0.2822-0.58569%2c0.43829-0.44275%2c0.65248-0.45344%2c1.4091-0.0705%2c0.72304%2c0.36598%2c0.9675%2c0.39912%2c1.0322%2c0.14002%2c0.0625-0.25022%2c0.47885-0.47916%2c0.87435-0.4808%2c0.25006-0.002%2c0.39157%2c0.0477%2c0.59183%2c0.20368%2c0.25136%2c0.19583%2c0.26349%2c0.22634%2c0.26989%2c0.67935%2c0.004%2c0.46299-0.002%2c0.48055-0.29042%2c0.73591-0.27723%2c0.24409-0.32183%2c0.25915-0.66541%2c0.22476-0.43718-0.0439-0.69954-0.24407-0.77073-0.58844-0.0516-0.25001-0.13942-0.3097-0.20523-0.1397-0.0209%2c0.0546-0.12864%2c0.12185-0.23894%2c0.1496-0.20352%2c0.0514-0.5488%2c0.26862-0.79415%2c0.50006-0.0927%2c0.0874-0.25526%2c0.12855-0.51863%2c0.13122-0.35563%2c0.003-0.40513-0.0183-0.67826-0.29915z'/%3e%3cpath d='m441.19%2c379.84c-0.66466%2c0.007-1.3805%2c0.5662-1.4688%2c1.2188%2c0.15206%2c0.75226%2c0.77698%2c1.4895%2c0.375%2c2.2812%2c0.27756%2c1.0131-0.76147%2c1.3974-1.4688%2c0.8125-0.4271-0.97134-0.64349-2.0358-1.2812-2.9062-0.80411-0.22762-1.1545%2c1.0569-1.7188%2c1.5%2c0.27975%2c0.75505%2c1.0958%2c1.4324%2c1.1875%2c2.375%2c0.1952%2c0.91482-0.36128%2c1.9306-1.1562%2c2.4062-0.68584%2c0.65472-1.6254%2c0.42074-2.4688%2c0.5625-1.0242%2c0.59857%2c0.75182%2c0.81755%2c1.2188%2c0.84375%2c1.0477%2c0.10646%2c2.1354-0.0317%2c2.9062-0.8125%2c0.76911-0.36708%2c0.70971-1.6972%2c1.625-1.8438%2c1.5884-0.0709%2c3.1626%2c0.24355%2c4.75%2c0.28125%2c0.84936%2c0.20336%2c2.1635-0.10098%2c2.75%2c0.53125%2c0.002%2c1.1075%2c0.94078%2c1.7905%2c1.8438%2c2.2188%2c0.4987%2c0.13872%2c1.0241-0.47928%2c1.5312-0.59375%2c0.96531-0.30764%2c0.67182-1.502%2c1.25-1.9688%2c1.6504-0.0893%2c3.3163-0.0704%2c4.9688-0.0937%2c0.31463%2c0.008%2c0.40734-0.43988%2c0.625-0.625-0.0363-0.63881-0.0593-1.2726-0.15625-1.9062-0.31819-0.80653%2c0.0513-1.8446-0.53125-2.5312-0.83011-0.22606-1.5362%2c0.53355-2.375%2c0.59375-0.92616%2c0.41246-1.7065%2c1.2677-1.75%2c2.3125-0.54833%2c0.89658-1.4277-0.15958-1.125-0.90625-0.0346-0.32541%2c0.0704-0.70429-0.0312-1-0.50698-0.60814-1.3947-0.4094-2.0938-0.5-1.0184%2c0.0406-2.0127-0.17955-3.0312-0.15625-0.89293-0.0674-1.822%2c0.0777-2.6875-0.15625-1.0317-0.0293-0.88959-1.0382-1.0625-1.75-0.18299-0.13571-0.40345-0.18973-0.625-0.1875zm2%2c3.6875c0.34308%2c0.007%2c0.66656%2c0.052%2c1%2c0.0937%2c0.43082%2c0.0709%2c0.8899-0.14816%2c1.3125%2c0%2c0.97651%2c0.16608%2c1.9536%2c0.12685%2c2.9375%2c0.21875%2c0.25985-0.004%2c0.44579%2c0.18471%2c0.625%2c0.34375%2c0.002%2c0.68357%2c0.00066%2c1.3789%2c0%2c2.0625-0.0299%2c0.25767%2c0.0763%2c0.5982-0.15625%2c0.78125-0.0747%2c0.0513-0.1583%2c0.1072-0.25%2c0.125-0.27065-0.07-0.55731-0.2479-0.6875-0.5-0.0414-0.35742%2c0.0179-0.70404%2c0.0312-1.0625-0.007-0.0927%2c0.0404-0.237%2c0-0.3125-0.21278-0.15067-0.45387-0.249-0.71875-0.25-0.84945-0.0291-1.682-0.0916-2.5312-0.125-0.7069-0.0446-1.4333%2c0.0604-2.125-0.125-0.26845-0.0976-0.61789-0.0641-0.78125-0.34375-0.23417-0.27227%2c0.10362-0.59695%2c0.34375-0.71875%2c0.31827-0.1447%2c0.65692-0.19411%2c1-0.1875zm11.281%2c0.25c0.15866-0.002%2c0.20935%2c0.05%2c0.28125%2c0.34375%2c0.0459%2c0.18765%2c0.0996%2c0.4172%2c0.125%2c0.5%2c0.0363%2c0.11811-0.0218%2c0.15625-0.1875%2c0.21875-0.494%2c0.18646-0.98566%2c0.16797-1.1562-0.0625-0.0774-0.10454%2c0.0129-0.43451%2c0.15625-0.5625%2c0.28946-0.25851%2c0.60992-0.43691%2c0.78125-0.4375z'/%3e%3c/g%3e%3c/g%3e%3cpath stroke-width='1.1502' d='m449.98%2c327.23c32.642-25.106%2c29.843-61.883%2c29.843-61.883-0.8613%2c0.17223-1.6795%2c0.25835-2.5408%2c0.25835-6.8471%2c0-23.178-3.9171-26.988-8.8926-4.0812%2c4.5034-20.77%2c8.8926-27.574%2c8.8926-0.86129%2c0-1.7225-0.0861-2.5407-0.25835%2c0%2c0-2.8422%2c36.776%2c29.8%2c61.883z'/%3e%3cpath stroke-width='0.9157' d='m477.22%2c268.04c-0.28097%2c0.0176-0.5633%2c0.0264-0.8477%2c0.0264-6.2055%2c0-20.619-3.1838-26.175-7.9572-5.8195%2c4.4095-20.471%2c7.9572-26.576%2c7.9572-0.28635%2c0-0.56925-0.035-0.84965-0.0865-0.0142%2c1.3908%2c0.0581%2c2.8324%2c0.14448%2c4.1436%2c0.323%2c4.9008%2c1.1826%2c9.819%2c2.4876%2c14.552%2c4.1081%2c14.895%2c12.516%2c27.553%2c24.572%2c37.155%2c12.066-9.61%2c20.484-22.28%2c24.601-37.186%2c1.3071-4.7319%2c2.1694-9.6497%2c2.4955-14.55%2c0.0853-1.2845%2c0.15716-2.6918%2c0.14745-4.0545z'/%3e%3cpath fill='%23c09300' stroke='none' d='m439.38%2c265.03c-5.8724%2c1.8448-12.229%2c3.0312-15.75%2c3.0312-0.28633%2c0-0.56336-0.0423-0.84375-0.0937-0.0142%2c1.3907%2c0.0699%2c2.8451%2c0.15625%2c4.1562%2c0.32298%2c4.9006%2c1.1638%2c9.7995%2c2.4688%2c14.531%2c2.765%2c10.025%2c7.5063%2c19.032%2c13.969%2c26.781v-48.406z'/%3e%3cpath fill='%23c09300' stroke='none' d='m460%2c264.94%2c0%2c49.25c6.794-7.9213%2c11.733-17.206%2c14.594-27.562%2c1.307-4.7317%2c2.1427-9.6313%2c2.4688-14.531%2c0.0853-1.2844%2c0.16596-2.6999%2c0.15625-4.0625-0.28095%2c0.0176-0.55937%2c0.0312-0.84375%2c0.0312-3.7302%2c0-10.42-1.1704-16.375-3.125z'/%3e%3cg stroke-width='1.2704'%3e%3cpath stroke-width='1.2179' d='m462.31%2c253.09c0.66655%2c0.0392-0.90178-3.568-0.90178-3.568%2c1.7643%2c1.8036%2c8.4297%2c2.2349%2c8.4297%2c2.2349-3.999-1.7656-7.9979-15.096-7.528-25.721%2c0.4319-10.664-1.5284-14.859-3.0971-16.428-1.9995-1.9995-8.4298-3.7639-12.664-3.9991-2.3922-0.11761-1.9995%2c1.8036-1.9995%2c1.8036-4.4308-1.137-8.8606-1.5684-10.861-0.2353-1.882%2c1.2547-2.274%2c7.5278-0.90178%2c6.43%2c3.3326-2.6661%2c6.2341-0.23524%2c8.2335%2c2.6661%2c1.7644%2c2.5485%2c1.6467%2c9.7627-0.90178%2c18.192-2.6661%2c8.8609-9.9588%2c17.722-9.9588%2c17.722%2c3.96%2c0%2c9.5276-3.5287%2c9.5276-3.5287l-1.3331%2c5.5283c4.1951-1.9996%2c7.5278-5.0969%2c7.5278-5.0969l3.9992%2c4.1951c1.333-1.7643%2c3.9991-4.1951%2c3.9991-4.1951s3.3328%2c3.5286%2c8.4297%2c3.9992z'/%3e%3cpath fill='none' d='m446.12%2c227.57s-2.2349%2c16.428-6.43%2c21.094'/%3e%3cpath fill='none' d='m449.65%2c227.14s-0.86252%2c16.623-3.7639%2c21.956'/%3e%3cpath fill='none' d='m452.78%2c227.81s0%2c18.192%2c1.0978%2c21.289'/%3e%3cpath fill='none' d='m456.74%2c228.71s0.90178%2c15.291%2c4.6657%2c20.819'/%3e%3cpath fill='%23c09300' stroke-width='0.3542' d='m442.08%2c219.61c-0.19598-1.4508-0.54888-2.5878-1.0586-3.3328-1.9996-2.9013-4.9009-5.3321-8.2335-2.6661%2c0%2c0%2c1.137-3.5287%2c3.5678-3.6463%2c1.882-0.11767%2c6.1556%2c1.4115%2c9.9196%2c7.8415%2c0%2c0-2.7837-0.62739-3.4502-0.0393-1.2546%2c1.0979-0.74495%2c1.8428-0.74495%2c1.8428z'/%3e%3cpath fill='%23c09300' stroke-width='0.3542' d='m432.44%2c209.26c0.27439-0.90178%2c0.7057-1.7251%2c1.2546-2.078%2c1.9996-1.333%2c6.43-0.90177%2c10.86%2c0.23524%2c0%2c0-0.39205-1.9212%2c1.9996-1.8036%2c4.2344%2c0.23523%2c10.665%2c1.9996%2c12.664%2c3.9992%2c0.47046%2c0.50973%2c1.0194%2c1.2547%2c1.4899%2c2.3916h-0.0784c-0.98015-1.3721-3.764-1.2937-4.4308-1.2154-1.0586%2c0.11756-1.7251%2c0.0784-3.1365%2c0.4312-0.66655%2c0.15693-1.686%2c0.3529-2.2349%2c0.78422-0.43131%2c0.3529-0.7841%2c1.6467-1.4506%2c1.6467-1.0586%2c0-0.98019-0.27449-1.2547-0.58814-0.35279-0.43131-0.54888-1.0586-0.90178-1.0194-1.0978%2c0.19608-2.8621-0.66644-5.0969-2.4308-2.2344-1.7644-3.0971-2.1956-5.9984-1.9996-2.8622%2c0.23524-3.7639%2c1.8427-3.7639%2c1.8427l0.0784-0.19598z'/%3e%3ccircle cx='448.824' cy='210.672' r='1.176' stroke='none'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$18 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2500 1800'%3e%3cpath d='M0%2c0H2500V1800H0' fill='%23003897'/%3e%3cpath d='M700%2c0h400V1800h-400M0%2c700H2500v400H0' fill='white'/%3e%3cpath d='M800%2c0h200V1800h-200M0%2c800H2500v200H0' fill='%23d72828'/%3e%3c/svg%3e";

var img$17 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect fill='white' width='900' height='600'/%3e%3crect fill='%23006233' width='450' height='600'/%3e%3cpath fill='%23d21034' d='M580%2c225a150%2c150 0 1%2c0 0%2c150 120%2c120 0 1%2c1 0-150m5%2c75-135-44 84%2c115v-142l-84%2c115z'/%3e%3c/svg%3e";

var img$16 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3crect width='12' height='2' fill='%23007a3d'/%3e%3crect width='12' height='2' y='2' fill='white'/%3e%3crect width='12' height='2' y='4' fill='%23ce1126'/%3e%3cpolygon points='0%2c0 3%2c2 3%2c4 0%2c6'/%3e%3c/svg%3e";

var img$15 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3e%3cpath d='M0 0h1100v800H0z' fill='white'/%3e%3cpath d='M0 75h1100v125H0zm0 525h1100v125H0z' fill='%230038b8'/%3e%3cpath d='M423.816 472.853h252.368L550 254.295zM550 545.705l126.184-218.558H423.816z' fill='none' stroke='%230038b8' stroke-width='27.5'/%3e%3c/svg%3e";

var img$14 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3e%3crect fill='%23ed1c24' width='750' height='500'/%3e%3crect fill='white' y='125' width='750' height='250'/%3e%3cpath fill='%2300a651' d='M 371.5894%2c125 C 366.22315%2c136.2997 356.11736%2c144.19789 346.45832%2c151.67157 C 344.86925%2c153.05938 340.91845%2c155.74726 343.78458%2c157.79271 C 346.24017%2c155.04836 352.97951%2c158.68259 349.06268%2c161.63346 C 345.55402%2c164.9176 340.72308%2c166.12 336.82746%2c168.82984 C 333.37726%2c170.7043 329.87796%2c172.66173 327.14196%2c175.53105 C 326.95559%2c180.0135 332.70358%2c177.53219 335.03612%2c179.3996 C 338.07363%2c182.64705 333.74816%2c188.12133 329.76182%2c186.86927 C 324.66471%2c187.02546 321.14438%2c191.51029 319.21689%2c195.78908 C 315.22977%2c201.95458 307.67448%2c203.78032 301.65953%2c207.28899 C 298.21778%2c209.29528 294.87854%2c211.51505 291.6746%2c213.85608 C 287.54383%2c216.68042 291.13754%2c222.27234 295.53278%2c220.89972 C 300.27728%2c220.4267 304.54592%2c216.69896 309.45786%2c217.77316 C 313.91254%2c219.33833 315.16278%2c225.16012 313.64459%2c229.22483 C 312.52055%2c232.47922 309.79569%2c234.77154 307.6125%2c237.31372 C 304.06844%2c240.90414 299.43359%2c243.23508 294.54641%2c244.34656 C 289.82305%2c245.93241 285.57789%2c248.826 282.47971%2c252.73228 C 278.88376%2c256.35224 275.30219%2c260.03085 271.1692%2c263.04934 C 269.86365%2c266.38067 273.54807%2c269.21835 276.6199%2c269.12991 C 283.09222%2c268.72234 287.57797%2c263.42506 293.09028%2c260.70292 C 297.66461%2c258.64703 303.04806%2c263.57727 301.92906%2c268.34281 C 301.57508%2c272.97905 297.23424%2c275.33164 293.37475%2c276.75816 C 282.02885%2c282.4619 272.1777%2c290.73284 263.43076%2c299.85875 C 261.62169%2c303.54889 256.64826%2c302.46257 253.97025%2c305.03499 C 252.22562%2c308.29039 256.60402%2c310.00685 259.21608%2c309.67223 C 270.44112%2c308.32214 280.91539%2c303.57761 290.83812%2c298.3575 C 294.52819%2c296.59322 297.99323%2c294.27138 301.82962%2c292.86533 C 305.43319%2c291.97509 310.45809%2c293.54159 311.10283%2c297.64287 C 311.09773%2c301.97233 306.80857%2c304.37035 303.4117%2c306.06172 C 292.93651%2c311.56524 281.44052%2c314.60765 270.24434%2c318.24607 C 266.05289%2c317.07424 262.89523%2c324.53141 267.49329%2c325.87225 C 272.3554%2c327.53952 277.52429%2c326.20279 282.49779%2c325.98426 C 297.87642%2c323.62817 311.32634%2c315.30653 325.70163%2c309.9273 C 331.67794%2c307.97923 338.73226%2c310.6978 341.68165%2c316.29776 C 344.64481%2c321.28931 344.37398%2c327.85334 341.24819%2c332.70293 C 336.30834%2c343.27146 328.79833%2c352.98464 318.7165%2c359.0613 C 312.38812%2c362.19434 305.00126%2c363.39297 299.57757%2c368.18972 C 294.56146%2c369.8432 302.09226%2c376.62136 303.18084%2c371.24168 C 306.19505%2c367.13063 311.51128%2c365.90189 316.33356%2c365.73205 C 323.58078%2c364.94312 331.27713%2c363.60631 336.9083%2c358.58922 C 341.95671%2c354.66896 346.93162%2c349.26076 353.78678%2c349.17636 C 357.57531%2c349.62563 361.32238%2c352.66984 365.17025%2c350.81231 C 368.53626%2c349.27162 373.81755%2c350.17444 374.69678%2c354.31369 C 376.30415%2c359.15581 381.29505%2c361.35894 385.25295%2c363.95016 C 386.68557%2c365.96192 391.44596%2c371.15043 392.54374%2c366.57601 C 391.65792%2c363.31338 392.92361%2c358.32091 397.20351%2c359.41116 C 400.94191%2c359.57808 404.50446%2c360.95653 408.23564%2c361.18262 C 413.20452%2c362.21183 417.34927%2c365.6135 420.17071%2c369.72085 C 422.11167%2c372.40126 426.36333%2c377.00677 429.52222%2c373.45251 C 431.48249%2c369.77666 427.74062%2c366.71103 424.69446%2c365.39845 C 420.25243%2c362.64573 416.45462%2c358.97987 412.57076%2c355.50887 C 406.84653%2c350.16275 401.90235%2c343.36292 400.99374%2c335.37635 C 399.76199%2c327.41308 400.4102%2c319.29095 401.44945%2c311.34932 C 402.75741%2c306.23638 409.29554%2c303.44506 413.86725%2c306.16167 C 420.30003%2c309.09681 426.68843%2c313.29666 434.06328%2c312.84127 C 444.72%2c313.07089 455.67072%2c311.03044 466.08536%2c314.11859 C 476.21984%2c317.31095 483.46556%2c325.86344 493.33765%2c329.56419 C 495.54761%2c330.90725 498.37484%2c329.62908 499.18462%2c327.26866 C 500.16303%2c325.1476 499.47268%2c322.43378 497.42896%2c321.22499 C 485.98778%2c309.67613 470.35146%2c304.06569 457.11353%2c295.04126 C 452.94587%2c293.98288 452.18706%2c287.27769 456.03973%2c285.34185 C 461.10528%2c281.66065 468.2721%2c283.37428 472.76607%2c287.16972 C 476.56118%2c289.39278 480.8368%2c291.05827 485.2894%2c291.06224 C 489.85029%2c289.63448 487.63912%2c283.03469 483.55544%2c282.53841 C 476.15622%2c278.36058 470.8569%2c271.50481 464.44632%2c266.0718 C 460.75559%2c262.94683 456.716%2c259.78287 451.7557%2c259.17634 C 449.04451%2c258.68263 446.27094%2c258.57459 443.52394%2c258.75896 C 440.9476%2c255.95914 444.38123%2c251.67208 447.71241%2c252.02262 C 451.1308%2c252.25288 454.52965%2c252.50697 457.94359%2c252.03127 C 461.75876%2c251.75176 465.57064%2c251.35683 469.39939%2c251.33063 C 472.48995%2c253.43534 478.66583%2c249.7996 475.87651%2c246.17083 C 472.82951%2c243.50085 468.42334%2c243.73277 464.78211%2c242.36257 C 458.38547%2c240.26395 451.87572%2c238.56782 445.28454%2c237.23756 C 440.67325%2c236.9626 441.242%2c230.89376 445.29497%2c230.22441 C 447.94739%2c229.23496 450.25279%2c231.27278 452.79892%2c231.5887 C 457.14735%2c232.52313 461.63683%2c232.51113 465.9831%2c233.45849 C 469.66816%2c231.63935 466.81948%2c226.2555 463.48593%2c225.94179 C 455.62045%2c223.12924 448.82304%2c218.05295 442.17788%2c213.11487 C 434.84116%2c207.59721 428.18494%2c201.21633 420.75826%2c195.82617 C 418.06357%2c194.15628 413.64683%2c193.67534 412.93795%2c189.97462 C 412.68795%2c186.57015 416.69529%2c185.01965 419.53592%2c185.81559 C 423.56634%2c187.00583 427.32195%2c189.07846 431.42972%2c190.09605 C 434.65252%2c190.64375 437.97545%2c191.59738 441.08179%2c191.19126 C 445.02496%2c188.71371 439.39058%2c187.13019 437.35122%2c186.27058 C 432.0938%2c183.43513 427.42242%2c179.65733 422.69107%2c176.0548 C 418.69278%2c172.64193 426.08234%2c171.13414 428.62427%2c172.44822 C 432.87417%2c174.22617 433.35847%2c168.03333 430.18167%2c166.47498 C 426.43855%2c164.88338 423.2196%2c162.24124 419.82552%2c159.93707 C 413.69304%2c155.57159 406.74727%2c152.1159 399.20847%2c151.156 C 390.75634%2c150.3067 382.86721%2c145.44628 378.38327%2c138.21818 C 375.60269%2c134.09908 373.56207%2c129.54384 371.5894%2c125 z M 343.8321%2c172.41771 C 348.18843%2c172.54695 347.51872%2c180.39793 343.22983%2c179.87413 C 339.06481%2c179.60609 339.31972%2c171.57429 343.8321%2c172.41771 z M 384.92234%2c176.64564 C 389.16127%2c175.88738 390.05889%2c183.62274 385.82379%2c183.98589 C 381.41121%2c184.77575 379.7758%2c176.15615 384.92234%2c176.64564 z M 372.88731%2c177.65384 C 377.18466%2c178.49924 376.42021%2c185.98556 372.08328%2c186.05098 C 368.91022%2c186.75752 365.49025%2c188.92314 362.28008%2c187.30008 C 359.66952%2c184.53908 363.44271%2c180.45635 366.35676%2c179.55883 C 368.59191%2c179.10829 370.64832%2c178.09344 372.88731%2c177.65384 z M 400.58563%2c177.68637 C 404.72688%2c179.19709 403.26629%2c186.50778 398.8981%2c186.41459 C 394.76724%2c186.96811 392.84357%2c180.07706 396.6956%2c178.44266 C 397.9426%2c178.00052 399.24903%2c177.62794 400.58563%2c177.68637 z M 353.8613%2c185.97958 C 356.90649%2c188.87754 355.10789%2c194.47009 351.35311%2c195.80715 C 348.64664%2c197.31266 344.95682%2c200.87381 342.00892%2c197.94369 C 340.40943%2c194.36455 344.42423%2c191.66946 346.78572%2c189.68283 C 348.89329%2c188.04409 351.21909%2c186.55653 353.8613%2c185.97958 z M 388.63905%2c202.14325 C 392.99893%2c204.2019 390.78574%2c212.05909 386.00062%2c211.57069 C 382.07061%2c210.57486 382.58371%2c203.83444 386.54227%2c203.29678 C 387.29055%2c203.01039 387.9769%2c202.58881 388.63905%2c202.14325 z M 374.80463%2c202.92376 C 378.88224%2c204.83283 375.76886%2c211.63754 371.6618%2c210.657 C 367.40345%2c210.15691 367.48196%2c202.67024 372.17815%2c203.34611 C 373.06305%2c203.30222 373.97688%2c203.27971 374.80463%2c202.92376 z M 404.62678%2c206.82647 C 409.096%2c205.43963 414.4766%2c210.04402 413.02612%2c214.71319 C 411.03543%2c218.33295 406.10946%2c218.79124 402.58121%2c217.43842 C 398.52983%2c217.23842 395.80478%2c211.1478 399.41404%2c208.56875 C 400.90756%2c207.44072 402.79022%2c206.97715 404.62678%2c206.82647 z M 338.611%2c207.99725 C 342.30631%2c205.98682 346.22984%2c212.02929 343.08717%2c214.69451 C 341.00551%2c217.75492 335.66012%2c219.00525 333.30317%2c215.60189 C 331.34505%2c212.27783 334.51104%2c206.69321 338.611%2c207.99725 z M 321.56135%2c210.85925 C 325.75319%2c211.43274 328.48457%2c215.24015 330.03376%2c218.86551 C 330.41193%2c223.28362 323.89286%2c225.70783 321.04899%2c222.49331 C 317.85114%2c220.48713 315.05191%2c216.36132 316.72839%2c212.53213 C 317.76131%2c211.0116 319.81909%2c210.38426 321.56135%2c210.85925 z M 423.56431%2c226.82777 C 428.11364%2c225.62888 431.41652%2c232.89939 427.51018%2c235.52953 C 423.93847%2c238.77373 416.99376%2c234.47573 418.85644%2c229.84687 C 419.78218%2c228.1308 421.63401%2c226.99026 423.56431%2c226.82777 z M 365.66037%2c235.121 C 369.47498%2c235.6068 368.2391%2c242.21814 364.71192%2c241.99623 C 360.92636%2c241.29454 361.79307%2c234.74813 365.66037%2c235.121 z M 346.3099%2c238.6334 C 349.42124%2c236.43197 353.434%2c241.80509 350.84595%2c244.3089 C 347.74396%2c246.49354 343.72032%2c241.20565 346.3099%2c238.6334 z M 377.07598%2c239.28385 C 380.68235%2c241.47514 382.82338%2c245.56095 383.27166%2c249.68389 C 381.54334%2c253.53578 374.86866%2c252.60724 374.11615%2c248.50531 C 372.79639%2c245.26124 374.01269%2c241.08758 377.07598%2c239.28385 z M 387.81313%2c245.65826 C 392.46055%2c244.49084 390.79279%2c254.20485 386.91238%2c250.83545 C 385.62285%2c249.30414 386.31349%2c246.78444 387.81313%2c245.65826 z M 320.38146%2c252.42293 C 323.45884%2c251.52156 327.94465%2c252.46899 328.7941%2c256.00085 C 329.15292%2c259.32013 325.5028%2c261.04696 322.8282%2c261.86956 C 318.54137%2c263.19231 314.34875%2c265.36394 309.73883%2c265.07221 C 306.28351%2c263.09729 305.04323%2c259.05585 303.81128%2c255.53103 C 307.14601%2c252.40445 312.05643%2c253.32163 316.19018%2c252.53906 C 317.58613%2c252.4675 318.98379%2c252.43346 320.38146%2c252.42293 z M 424.98018%2c267.64343 C 428.90575%2c265.71883 433.12728%2c271.9498 429.84137%2c274.86023 C 425.73054%2c279.59171 417.81599%2c280.47093 412.90065%2c276.49605 C 412.30974%2c272.3088 416.49236%2c269.26764 420.20768%2c268.66669 C 421.77056%2c268.22519 423.32385%2c267.56559 424.98018%2c267.64343 z M 447.04443%2c272.42422 C 451.50464%2c271.6566 455.01805%2c278.01951 451.83272%2c281.3126 C 448.81821%2c285.85801 441.62942%2c287.05014 437.51912%2c283.32422 C 435.91659%2c279.55585 439.16741%2c275.62934 442.62728%2c274.42031 C 444.11438%2c273.78742 445.52241%2c272.97626 447.04443%2c272.42422 z M 336.10372%2c279.1889 C 340.23431%2c278.78128 344.01843%2c282.87955 343.47633%2c286.95187 C 346.46651%2c289.89444 341.17144%2c295.37643 338.19238%2c292.32933 C 335.56714%2c289.14836 335.58095%2c284.83298 334.56407%2c281.02604 C 334.51857%2c280.18042 335.14459%2c279.08508 336.10372%2c279.1889 z M 367.81369%2c281.56305 C 372.08402%2c279.7168 377.60876%2c284.82551 375.28387%2c289.15052 C 373.6236%2c292.67309 367.14833%2c291.4924 367.3635%2c287.41217 C 367.35245%2c285.46035 367.19489%2c283.45856 367.81369%2c281.56305 z M 352.38642%2c284.32743 C 356.66836%2c283.34572 360.59695%2c288.89644 358.21743%2c292.60021 C 353.94846%2c292.97974 351.73219%2c287.9133 352.38642%2c284.32743 z'/%3e%3c/svg%3e";

var img$13 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-75 -40 120 80'%3e%3ctitle%3eFlag of Pakistan%3c/title%3e%3crect x='-75' y='-40' width='120' height='80' fill='white'/%3e%3crect x='-45' y='-40' width='90' height='80' fill='%2301411C'/%3e%3ccircle r='24' fill='white'/%3e%3ccircle r='22' cx='-7' cy='-40' fill='%2301411C' transform='rotate(-41.63354%2c 45%2c -40)'/%3e%3cpolygon points='0%2c-513674 301930%2c415571 -488533%2c-158734 488533%2c-158734 -301930%2c415571' fill='white' transform='rotate(-41.63354) translate(16) rotate(18) scale(0.00001557408)'/%3e%3c/svg%3e";

var img$12 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1400 550'%3e%3cpath fill='%238d1b3d' d='M0 0h1400v550H0z'/%3e%3cpath d='M400 550H0V0h400l100 30.556L400 61.11l100 30.556-100 30.555 100 30.556-100 30.555 100 30.556-100 30.555L500 275l-100 30.556 100 30.555-100 30.556 100 30.555-100 30.556 100 30.555-100 30.556 100 30.555z' fill='white'/%3e%3c/svg%3e";

var img$11 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z' fill='%23ce1126'/%3e%3cpath d='M0 200h900v400H0z' fill='white'/%3e%3cpath d='M0 400h900v200H0z'/%3e%3cg transform='translate(-1.009 -.584) scale(2.18978)' fill='%23007a3d'%3e%3cpath d='M246.026 120.178c-.558-.295-1.186-.768-1.395-1.054-.314-.438-.132-.456 1.163-.104 2.318.629 3.814.383 5.298-.873l1.308-1.103 1.54.784c.848.428 1.748.725 2.008.656.667-.176 2.05-1.95 2.005-2.564-.054-.759.587-.568.896.264.615 1.631-.281 3.502-1.865 3.918-.773.201-1.488.127-2.659-.281-1.438-.502-1.684-.494-2.405.058-1.618 1.239-3.869 1.355-5.894.299zm5.734-5.242c-.563-.717-1.239-3.424-1.021-4.088.192-.576.391-.691.914-.527.918.287 1.13.92.993 3.064-.107 1.747-.366 2.206-.886 1.551zm-67.516-1.946c-.185 1.311 2.325 4.568 3.458 5.158-.77.345-1.728.188-2.434.576-3.948 3.948-18.367 18.006-21 21.366 7.799.154 16.448-.106 23.761-.44-.007-5.299 5.018-5.572 8.381-7.502 1.73 2.725 6.075 2.516 6.618 6.617 0 4.91.009 12.307.009 17.646h-66.625c-1.172 5.176-5.844 9.125-12.354 7.5 2.014-2.104 5.405-2.827 6.619-5.734 1.024-6.365-2.046-10.296-4.031-13.906 3.284-1.195 3.782-1.494 7.121-3.737-2.344 7.12 6.091 6.338 12.353 6.175.211-2.417.089-5.271-1.766-5.624 2.396-.87 2.794-1.168 6.619-4.412v9.593c14.886 0 30.942-.111 46.139-.111 0-3.002.795-7.824-1.581-7.824-2.269 0-.107 6.173-1.87 6.173h-35.63c0-1.328-.034-4.104-.034-6.104 1.51-1.51 1.331-1.379 11.648-11.697 1.028-1.031 8.266-7.568 14.599-13.713zm89.06-.254c2.487 1.339 4.457 3.191 7.502 3.972-.354 1.261-1.476 1.759-1.77 3.087v26.91c3.402.75 4.118-1.178 5.737-2.205.442 4.307 3.186 8.529 3.088 11.91h-14.559c.002-14.555.002-29.114.002-43.674zm-19.412 14.412s5.296-4.471 5.296-4.643v23.484l3.814-.006c0-8.947-.118-18.022-.118-26.338 1.548-1.549 4.58-3.791 5.338-5.358v42.06c-10.746 0-30.793.012-33.443.012-.493-8.729-.577-17.771 9.6-15.826v-3.563c-.311-.609-.868.147-.998-.645 1.615-1.617 2.163-2.029 6.538-5.852 0 4.612.08 15.5.08 15.5 1.07 0 3.153.004 3.857.004.001.002.036-18.227.036-18.829zm-12.553 18.603c.716 1.075 3.154 1.056 3.04-.755-.411-1.493-3.616-.924-3.04.755z'/%3e%3ccircle cx='144.527' cy='161.369' r='2.042'/%3e%3cpath d='M207.549 112.779c2.488 1.339 4.457 3.191 7.502 3.971-.353 1.26-1.476 1.76-1.768 3.087v26.911c3.401.749 4.117-1.18 5.736-2.206.441 4.308 3.185 8.528 3.088 11.91h-14.56c.002-14.556.002-29.114.002-43.673z'/%3e%3c/g%3e%3c/svg%3e";

var img$10 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 840 420'%3e%3crect width='840' height='420' fill='%23007a3d'/%3e%3crect width='840' height='280' fill='white'/%3e%3crect width='840' height='140' fill='black'/%3e%3cpath d='M0%2c0V420L420%2c210z' fill='%23ce1126'/%3e%3cpath d='M129.787138%2c180 136.295394%2c196.485467 153.242082%2c191.295306 144.411056%2c206.662186 159.034975%2c216.675628 141.51461%2c219.352347 142.80365%2c237.029066 129.787138%2c225 116.770625%2c237.029066 118.059665%2c219.352347 100.5393%2c216.675628 115.163219%2c206.662186 106.332193%2c191.295306 123.278882%2c196.485467 129.787138%2c180z' fill='white'/%3e%3c/svg%3e";

var img$$ = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 120'%3e%3crect width='180' height='120' fill='black'/%3e%3crect width='180' height='80' fill='white'/%3e%3crect width='180' height='40' fill='%23ce1126'/%3e%3cg id='s' fill='%23007a3d'%3e%3cg id='f'%3e%3cg id='t'%3e%3cpath d='M54%2c47v13h8' transform='rotate(18%2c54%2c47)' id='o'/%3e%3cuse xlink:href='%23o' x='-108' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(72%2c54%2c60)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(-72%2c54%2c60)'/%3e%3cuse xlink:href='%23f' transform='rotate(144%2c54%2c60)'/%3e%3c/g%3e%3cuse xlink:href='%23s' x='72'/%3e%3c/svg%3e";

var img$_ = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1500 900'%3e%3cpath d='M0 0h1500v900H0' fill='white'/%3e%3cpath d='M1500 0H375l225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90h1125' fill='%23ce1126'/%3e%3c/svg%3e";

var img$Z = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3crect width='900' height='600' fill='%23de2910'/%3e%3cg id='petal'%3e%3cpath d='m 449.96406%2c299.9134 c -105.26305%2c-44.48626 -58.60174%2c-181.58185 42.06956%2c-174.6907 -20.36609%2c10.46694 -23.31775%2c29.99772 -11.68704%2c48.09021 13.02444%2c20.2558 -1.19897%2c52.84856 -18.80577%2c60.7674 -28.93485%2c13.02443 -34.72791%2c47.74999 -11.57675%2c65.83309 z' fill='white'/%3e%3cpath d='m 444.27188%2c200.91974 -5.91976%2c9.29378 -2.14454%2c-10.8142 -10.67812%2c-2.75928 9.62461%2c-5.3895 -0.67104%2c-10.99955 8.08542%2c7.48945 10.25578%2c-4.04271 -4.61053%2c10.00942 7.00143%2c8.50541 z' fill='%23de2910'/%3e%3cpath d='m 450.56002%2c298.75902 c -12.73114%2c-6.53451 -22.9963%2c-20.15491 -27.46839%2c-36.43134 -5.11498%2c-18.66969 -2.17269%2c-38.74247 8.08308%2c-55.03768 l -2.20789%2c-1.39371 c -10.64057%2c16.92871 -13.69313%2c37.74293 -8.38575%2c57.11886 4.72784%2c17.22201 15.21355%2c31.09815 28.78703%2c38.06438 z' fill='%23de2910'/%3e%3c/g%3e%3cuse xlink:href='%23petal' transform='rotate(72 450%2c300)'/%3e%3cuse xlink:href='%23petal' transform='rotate(144 450%2c300)'/%3e%3cuse xlink:href='%23petal' transform='rotate(216 450%2c300)'/%3e%3cuse xlink:href='%23petal' transform='rotate(288 450%2c300)'/%3e%3c/svg%3e";

var img$Y = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-15 -10 30 20'%3e%3crect fill='%23DA251d' x='-20' y='-15' width='40' height='30'/%3e%3cg id='g' transform='translate(0%2c-6)'%3e%3cpolyline id='g1' fill='%23FF0' points='0%2c0 0%2c6 4%2c6' transform='rotate(18)'/%3e%3cuse xlink:href='%23g1' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cg id='g2' transform='rotate(72)'%3e%3cuse xlink:href='%23g'/%3e%3cuse xlink:href='%23g' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23g2' transform='scale(-1%2c1)'/%3e%3c/svg%3e";

var img$X = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3crect width='6' height='3' fill='%23008751'/%3e%3crect x='2' width='2' height='3' fill='white'/%3e%3c/svg%3e";

var img$W = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 330'%3e%3crect width='600' height='330' fill='%230038a8'/%3e%3crect width='600' height='220' fill='white'/%3e%3crect width='600' height='110' fill='%23d52b1e'/%3e%3cg%3e%3cg fill='none' stroke='black'%3e%3ccircle stroke-width='1.07585' cx='300' cy='165' r='42.2'/%3e%3ccircle stroke-width='0.47815' cx='300' cy='165' r='34.67'/%3e%3ccircle stroke-width='0.43816' cx='300' cy='165' r='26.56'/%3e%3c/g%3e%3cg fill='black'%3e%3cpath d='m277.53%2c181.28-4.8927%2c2.9054-1.4963-2.5198c-0.27744-0.46724-0.44945-0.84813-0.51601-1.1427-0.0666-0.29453-0.0363-0.58185%2c0.0908-0.86197%2c0.12709-0.28011%2c0.34638-0.51266%2c0.65787-0.69763%2c0.27145-0.16118%2c0.53998-0.24239%2c0.80558-0.24363%2c0.26562-0.001%2c0.51973%2c0.0631%2c0.76232%2c0.19286%2c0.15451%2c0.0828%2c0.32407%2c0.22138%2c0.50868%2c0.41571-0.0469-0.21589-0.0648-0.38284-0.0536-0.50084%2c0.007-0.0794%2c0.0448-0.21092%2c0.1133-0.39456%2c0.0685-0.18363%2c0.12781-0.31439%2c0.17786-0.39227l0.98439-1.5732%2c1.0147%2c1.7088-1.0156%2c1.6955c-0.13279%2c0.2173-0.20433%2c0.38317-0.21461%2c0.49762-0.0109%2c0.15394%2c0.0246%2c0.29989%2c0.10651%2c0.43783l0.0793%2c0.1335%2c1.9858-1.1792zm-3.812%2c0.20962-0.37853-0.63744c-0.041-0.069-0.14247-0.18926-0.30456-0.36086-0.0795-0.0882-0.17921-0.13961-0.29919-0.15414-0.11997-0.0145-0.23336%2c0.01-0.34016%2c0.0734-0.15797%2c0.0938-0.2495%2c0.21587-0.2746%2c0.3662s0.0443%2c0.36344%2c0.20811%2c0.63933l0.39438%2c0.66415z'/%3e%3cpath d='m269.11%2c177.71-1.4871-4.4713%2c1.1528-0.38341%2c0.93096%2c2.7992%2c0.85817-0.28541-0.86358-2.5966%2c1.1013-0.36626%2c0.86358%2c2.5966%2c1.0644-0.35401-0.9579-2.8802%2c1.2228-0.40668%2c1.514%2c4.5524z'/%3e%3cpath d='m267.16%2c171.06-0.3323-2.9038c-0.0724-0.63243%2c0.0238-1.1233%2c0.28857-1.4727%2c0.26476-0.34935%2c0.67479-0.5558%2c1.2301-0.61935%2c0.57074-0.0653%2c1.0364%2c0.0553%2c1.3971%2c0.36169%2c0.36064%2c0.30644%2c0.58127%2c0.81187%2c0.66188%2c1.5163l0.10944%2c0.95637%2c2.0978-0.24007%2c0.2008%2c1.7546zm2.2094-2.0304-0.049-0.42806c-0.0385-0.33678-0.1241-0.56661-0.25667-0.68948-0.13256-0.12287-0.29011-0.17386-0.47265-0.15298-0.17739%2c0.0203-0.32102%2c0.0967-0.43089%2c0.22903-0.10986%2c0.13238-0.14612%2c0.36183-0.10876%2c0.68833l0.0569%2c0.49746z'/%3e%3cpath d='m266.98%2c160.38%2c0.18811-1.7443%2c3.3729%2c0.36373c0.33446%2c0.0361%2c0.64465%2c0.12223%2c0.93056%2c0.25847%2c0.28592%2c0.13625%2c0.52815%2c0.32764%2c0.72669%2c0.57418s0.32966%2c0.49688%2c0.39335%2c0.75099c0.0894%2c0.3532%2c0.10849%2c0.76778%2c0.0572%2c1.2437-0.0297%2c0.27528-0.0814%2c0.57357-0.15507%2c0.89486-0.0737%2c0.32129-0.17957%2c0.58511-0.31764%2c0.79144-0.13807%2c0.20634-0.32237%2c0.38882-0.55289%2c0.54745-0.23053%2c0.15863-0.46131%2c0.25932-0.69235%2c0.30207-0.37184%2c0.0692-0.69669%2c0.0888-0.97455%2c0.0589l-3.3729-0.36374%2c0.18811-1.7443%2c3.4539%2c0.37248c0.30873%2c0.0333%2c0.55915-0.0262%2c0.75126-0.1786%2c0.19211-0.15236%2c0.30454-0.38033%2c0.33727-0.68392%2c0.0325-0.301-0.0276-0.54628-0.18026-0.73582-0.15263-0.18954-0.38589-0.30123-0.69977-0.33508z'/%3e%3cpath d='m267.74%2c156.21%2c1.0861-3.1072c0.18101-0.51785%2c0.44822-0.87058%2c0.80162-1.0582%2c0.3534-0.18759%2c0.71941-0.21522%2c1.098-0.0829%2c0.31756%2c0.111%2c0.55534%2c0.30514%2c0.71335%2c0.5824%2c0.10535%2c0.18485%2c0.15759%2c0.41967%2c0.15673%2c0.70444%2c0.22773-0.3535%2c0.48638-0.58175%2c0.77594-0.68476%2c0.28956-0.103%2c0.60534-0.0947%2c0.94732%2c0.0248%2c0.27847%2c0.0973%2c0.50623%2c0.2496%2c0.68326%2c0.45675%2c0.17704%2c0.20718%2c0.29101%2c0.44575%2c0.34192%2c0.71573%2c0.0319%2c0.16742%2c0.0171%2c0.39799-0.0444%2c0.6917-0.0818%2c0.39082-0.14402%2c0.6473-0.18672%2c0.76943l-1.0016%2c2.8653zm2.6922-0.93805%2c0.25231-0.72183c0.0905-0.25893%2c0.1089-0.45466%2c0.0552-0.58721-0.0537-0.13253-0.16486-0.22826-0.33341-0.28718-0.15633-0.0546-0.29619-0.0466-0.41956%2c0.024s-0.22903%2c0.23176-0.31698%2c0.48335l-0.25615%2c0.73282zm2.1105%2c0.73772%2c0.29586-0.84641c0.0999-0.2858%2c0.11965-0.50504%2c0.0593-0.65773-0.0604-0.15268-0.17608-0.25891-0.34708-0.31868-0.15877-0.0555-0.30668-0.0421-0.44373%2c0.0402s-0.25637%2c0.2688-0.35798%2c0.55948l-0.29458%2c0.84275z'/%3e%3cpath d='m270.43%2c149.37%2c0.90849-1.5054%2c3.6722%2c2.2161%2c1.4179-2.3495%2c1.1997%2c0.72398-2.3264%2c3.855z'/%3e%3cpath d='m273.87%2c144.16%2c1.1282-1.3537%2c4.3712%2c3.643-1.1282%2c1.3537z'/%3e%3cpath d='m281.52%2c141.22%2c1.4723-0.65101c0.20313%2c0.39522%2c0.31475%2c0.77525%2c0.33485%2c1.1401%2c0.0201%2c0.36486-0.0469%2c0.71073-0.20101%2c1.0376-0.15411%2c0.32689-0.42448%2c0.65645-0.81111%2c0.98868-0.46907%2c0.40307-0.91088%2c0.66415-1.3254%2c0.78324-0.41455%2c0.1191-0.87733%2c0.0997-1.3884-0.0583-0.51102-0.15794-0.99673-0.50481-1.4571-1.0406-0.61387-0.71439-0.89577-1.4266-0.84571-2.1366%2c0.0501-0.71001%2c0.42249-1.3635%2c1.1172-1.9605%2c0.54365-0.46714%2c1.0654-0.72446%2c1.5654-0.77195%2c0.49996-0.0475%2c1.0211%2c0.0915%2c1.5635%2c0.41697l-0.95243%2c1.2739c-0.1542-0.0961-0.28002-0.15514-0.37744-0.1772-0.16227-0.038-0.32099-0.038-0.47616-0.00025-0.15516%2c0.0378-0.29947%2c0.11405-0.43293%2c0.22872-0.30224%2c0.25972-0.42927%2c0.5804-0.38109%2c0.96205%2c0.0335%2c0.28513%2c0.21632%2c0.62101%2c0.54856%2c1.0076%2c0.41149%2c0.47888%2c0.76617%2c0.74473%2c1.064%2c0.79755%2c0.29785%2c0.0528%2c0.57828-0.0338%2c0.84127-0.25975%2c0.25514-0.21924%2c0.38641-0.45657%2c0.39382-0.71199%2c0.007-0.25542-0.0767-0.54483-0.25221-0.86823z'/%3e%3cpath d='m287.58%2c139.04-1.7674%2c0.94226%2c0.19872%2c0.95853-1.5858%2c0.84547-0.78977-6.0274%2c1.692-0.90208%2c4.5643%2c4.0151-1.6235%2c0.86556zm-0.90425-0.91228-1.5172-1.5092%2c0.41089%2c2.099z'/%3e%3cpath d='m292.05%2c132.3%2c2.5741-0.44458c0.50743-0.0876%2c0.92922-0.0896%2c1.2654-0.006%2c0.33614%2c0.0838%2c0.62845%2c0.23678%2c0.87693%2c0.45908%2c0.24847%2c0.22232%2c0.44811%2c0.49639%2c0.59892%2c0.82222%2c0.15081%2c0.32584%2c0.25924%2c0.68%2c0.32531%2c1.0625%2c0.10349%2c0.59923%2c0.11554%2c1.0757%2c0.0362%2c1.4295-0.0794%2c0.35377-0.22095%2c0.66314-0.42465%2c0.92809-0.20371%2c0.26496-0.43815%2c0.45841-0.70331%2c0.58036-0.36233%2c0.16762-0.69776%2c0.27807-1.0063%2c0.33136l-2.5741%2c0.44458zm1.952%2c0.97061%2c0.52914%2c3.0637%2c0.42456-0.0733c0.36208-0.0625%2c0.61269-0.14717%2c0.75181-0.25392s0.23474-0.26769%2c0.28687-0.48283c0.0521-0.21514%2c0.0394-0.54711-0.0381-0.99589-0.10262-0.59413-0.26976-0.98411-0.50142-1.1699-0.23167-0.18582-0.5719-0.23998-1.0207-0.16247z'/%3e%3cpath d='m299.36%2c131.32%2c4.7078%2c0.2013-0.0519%2c1.2138-2.9472-0.12602-0.0386%2c0.90356%2c2.734%2c0.11691-0.0496%2c1.1595-2.734-0.11691-0.0479%2c1.1207%2c3.0326%2c0.12967-0.055%2c1.2875-4.7932-0.20495z'/%3e%3cpath d='m306.21%2c131.86%2c1.7079%2c0.41801-1.0197%2c4.1661%2c2.6655%2c0.6524-0.33312%2c1.361-4.3734-1.0704z'/%3e%3cpath d='m315.34%2c134.89%2c2.516%2c1.4873c0.54797%2c0.32393%2c0.88136%2c0.69687%2c1.0002%2c1.1188%2c0.1188%2c0.42194%2c0.036%2c0.87348-0.24843%2c1.3546-0.29234%2c0.49452-0.6695%2c0.7931-1.1315%2c0.89575-0.46199%2c0.10265-0.99815-0.0264-1.6085-0.38723l-0.82865-0.48985-1.0745%2c1.8177-1.5203-0.89873zm0.2858%2c2.9871%2c0.37089%2c0.21925c0.2918%2c0.1725%2c0.52669%2c0.24297%2c0.70467%2c0.21141%2c0.17798-0.0316%2c0.31371-0.12642%2c0.40721-0.28458%2c0.0909-0.1537%2c0.11665-0.3143%2c0.0774-0.4818-0.0393-0.16749-0.20035-0.33486-0.48325-0.5021l-0.43103-0.2548z'/%3e%3cpath d='m320.56%2c144.51-1.4666-1.364-0.8415%2c0.50015-1.316-1.2239%2c5.4413-2.7102%2c1.4041%2c1.3058-2.3091%2c5.6233-1.3472-1.253zm0.56794-1.1521%2c0.93263-1.9261-1.8507%2c1.0723z'/%3e%3cpath d='m321.81%2c147.14%2c4.692-3.2194%2c1.658%2c2.4164c0.30744%2c0.44807%2c0.504%2c0.81689%2c0.5897%2c1.1064%2c0.0857%2c0.28955%2c0.0743%2c0.57824-0.0342%2c0.86607-0.10849%2c0.28783-0.31209%2c0.53423-0.6108%2c0.73919-0.26032%2c0.17861-0.52295%2c0.27722-0.78791%2c0.29583-0.26497%2c0.0186-0.52274-0.0289-0.77331-0.14255-0.1596-0.0725-0.33786-0.19969-0.5348-0.38152%2c0.061%2c0.21236%2c0.0897%2c0.37777%2c0.0863%2c0.49625-0.002%2c0.0797-0.0309%2c0.2134-0.0872%2c0.40113-0.0564%2c0.18773-0.10695%2c0.32208-0.1518%2c0.40308l-0.87931%2c1.6342-1.1244-1.6387%2c0.90241-1.7584c0.11829-0.22552%2c0.17882-0.39572%2c0.18159-0.5106%2c0.00081-0.15433-0.0442-0.29763-0.13493-0.42992l-0.0878-0.12802-1.9043%2c1.3066zm3.7901-0.45867%2c0.41944%2c0.61131c0.0454%2c0.0661%2c0.15455%2c0.17952%2c0.32753%2c0.34014%2c0.0851%2c0.0828%2c0.18796%2c0.12758%2c0.30863%2c0.13423%2c0.12067%2c0.007%2c0.23221-0.0252%2c0.33464-0.0954%2c0.15148-0.10394%2c0.23483-0.23174%2c0.25004-0.38339%2c0.0152-0.15165-0.068-0.35976-0.24951-0.62434l-0.437-0.63691z'/%3e%3cpath d='m327.36%2c155.2-0.74229-1.8602-0.97457%2c0.0922-0.66605-1.6692%2c6.0777-0.12252%2c0.71065%2c1.7809-4.4924%2c4.0953-0.68188-1.7088zm1.0062-0.7985%2c1.6668-1.3421-2.1315%2c0.1777z'/%3e%3cpath d='m329.85%2c160.62%2c1.1708-0.17519%2c0.40208%2c2.6871-2.3992%2c0.359c-0.42757-0.46194-0.73428-0.88112-0.92012-1.2576-0.18585-0.37645-0.31936-0.83594-0.40054-1.3785-0.0999-0.66794-0.0675-1.2294%2c0.0973-1.6845%2c0.16477-0.45507%2c0.45504-0.8321%2c0.8708-1.1311%2c0.41575-0.299%2c0.91538-0.49216%2c1.4989-0.57947%2c0.6142-0.0919%2c1.1674-0.0452%2c1.6596%2c0.14023%2c0.49216%2c0.18539%2c0.89253%2c0.50487%2c1.2011%2c0.95844%2c0.23876%2c0.35413%2c0.40638%2c0.85365%2c0.50289%2c1.4986%2c0.093%2c0.62188%2c0.10634%2c1.0954%2c0.0399%2c1.4207-0.0665%2c0.32522-0.20284%2c0.60727-0.40911%2c0.84615-0.20629%2c0.23888-0.48347%2c0.43668-0.83156%2c0.59343l-0.55043-1.6327c0.20207-0.10089%2c0.34706-0.24229%2c0.43497-0.4242%2c0.0879-0.18192%2c0.1127-0.40083%2c0.0744-0.65675-0.0571-0.38132-0.23497-0.6654-0.53373-0.85225-0.29877-0.18686-0.73477-0.2374-1.308-0.15162-0.60908%2c0.0911-1.027%2c0.27076-1.2538%2c0.53886-0.22676%2c0.26811-0.30951%2c0.60689-0.24824%2c1.0164%2c0.0291%2c0.1945%2c0.085%2c0.37583%2c0.16774%2c0.54399%2c0.0827%2c0.16815%2c0.20894%2c0.35597%2c0.37866%2c0.56344l0.52975-0.0793z'/%3e%3cpath d='m333.57%2c168.88-0.15576%2c1.7475-3.379-0.30119c-0.33507-0.0299-0.6468-0.11026-0.93519-0.24118-0.28839-0.13093-0.53412-0.3178-0.7372-0.56061-0.20307-0.24283-0.3388-0.49069-0.40719-0.74358-0.096-0.35149-0.1227-0.76564-0.0802-1.2425%2c0.0246-0.27579%2c0.0707-0.57499%2c0.13846-0.89759%2c0.0677-0.3226%2c0.16869-0.58833%2c0.30292-0.79719%2c0.13422-0.20886%2c0.31511-0.39472%2c0.54265-0.55759%2c0.22755-0.16288%2c0.45643-0.26782%2c0.68664-0.31485%2c0.37049-0.0761%2c0.69492-0.10173%2c0.97328-0.0769l3.379%2c0.30119-0.15576%2c1.7475-3.4602-0.30842c-0.30929-0.0276-0.55857%2c0.0366-0.74782%2c0.19248-0.18926%2c0.15589-0.29744%2c0.38591-0.32455%2c0.69005-0.0269%2c0.30156%2c0.0378%2c0.54568%2c0.19387%2c0.73236%2c0.15612%2c0.18667%2c0.39141%2c0.29402%2c0.70586%2c0.32206z'/%3e%3cpath d='m327.28%2c174.9%2c0.62561-1.9026-0.80624-0.5552%2c0.56134-1.7072%2c4.7375%2c3.8091-0.59893%2c1.8215-6.0736%2c0.2543%2c0.57468-1.7478zm1.284%2c0.034%2c2.1396%2c0.0416-1.748-1.2326z'/%3e%3cpath d='m330.6%2c179.56-1.0037%2c1.6746-2.2386-0.002%2c1.0574%2c1.9732-0.9977%2c1.6647-1.6992-3.5978-2.0442-1.2252%2c0.90591-1.5115%2c2.0442%2c1.2252z'/%3e%3c/g%3e%3cg fill='%23009b3a' stroke='black' stroke-width='0.1'%3e%3cpath d='m305.58%2c145.3s16.052%2c6.9159%2c13.249%2c21.207-11.74%2c14.195-15.244%2c15.775c-3.5043%2c1.5793-5.9218%2c3.8396-7.3046%2c3.5235-1.3827-0.31613-3.2104-1.3832-3.2104-1.3832s-0.14627%2c2.3471%2c2.6684%2c2.7742%2c6.5145-3.7042%2c8.2916-4.1636c1.7771-0.45933%2c12.688-1.6436%2c15.343-16.185%2c3.0983-15.522-13.693-21.092-13.792-21.548z'/%3e%3cpath d='m313.68%2c148.34a2.2037%2c0.52177%2c75.104%2c0%2c1%2c-1.0572%2c0.0811%2c2.2037%2c0.52177%2c75.104%2c1%2c1%2c1.0572%2c-0.0811z'/%3e%3cpath d='m313.13%2c148.49a2.2707%2c0.50636%2c63.335%2c1%2c1%2c-0.95726%2c0.34968%2c2.2707%2c0.50636%2c63.335%2c0%2c1%2c0.95726%2c-0.34968z'/%3e%3cpath d='m311.52%2c149.55a2.1502%2c0.53476%2c17.053%2c0%2c1%2c-0.10032%2c1.0864%2c2.1502%2c0.53476%2c17.053%2c0%2c1%2c0.10032%2c-1.0864z'/%3e%3cpath d='m311.76%2c148.96a2.2609%2c0.50857%2c34.225%2c1%2c1%2c-0.46166%2c0.91557%2c2.2609%2c0.50857%2c34.225%2c1%2c1%2c0.46166%2c-0.91557z'/%3e%3cpath d='m312.44%2c148.68a2.299%2c0.50014%2c46.194%2c1%2c1%2c-0.6989%2c0.71633%2c2.299%2c0.50014%2c46.194%2c0%2c1%2c0.6989%2c-0.71633z'/%3e%3cpath d='m313.56%2c150.7c0.009%2c0.01-0.61928%2c0.34913-0.76157%2c0.39979-0.14231%2c0.0506-0.3352-0.18953-0.74445%2c0.0205-0.40924%2c0.21003-0.69016%2c0.59314-0.7795%2c0.81798-0.0893%2c0.22483%2c0.11595%2c0.31904%2c0.61058%2c0.0786%2c0.49463-0.24042%2c0.62481-0.62134%2c0.8633-0.77059%2c0.23847-0.14922%2c0.6385-0.36885%2c0.86618-0.44991%2c0.0986-0.21524%2c0.41874-0.67667%2c0.58423-0.94149%2c0.16549-0.2648%2c0.81483-0.70186%2c1.0512-1.2107%2c0.20634-0.42091%2c0.12886-0.77938-0.14731-0.6296-0.27617%2c0.14979-0.63323%2c0.57288-0.79951%2c0.87657-0.16629%2c0.30371-0.0235%2c0.69038-0.2082%2c0.97494-0.14547%2c0.2062-0.49727%2c0.83331-0.53495%2c0.83386z'/%3e%3cpath d='m318.53%2c152.34a3.3048%2c0.7416%2c88.415%2c1%2c1%2c-1.491%2c-0.357%2c3.3048%2c0.7416%2c88.415%2c1%2c1%2c1.491%2c0.357z'/%3e%3cpath d='m317.7%2c152.31a3.4427%2c0.71192%2c77.49%2c1%2c1%2c-1.4415%2c0.0724%2c3.4427%2c0.71192%2c77.49%2c1%2c1%2c1.4415%2c-0.0724z'/%3e%3cpath d='m315.13%2c153.11a3.2071%2c0.7642%2c34.91%2c1%2c1%2c-0.4987%2c1.511%2c3.2071%2c0.7642%2c34.91%2c1%2c1%2c0.4987%2c-1.511z'/%3e%3cpath d='m315.65%2c152.38a3.4298%2c0.71459%2c50.904%2c0%2c1%2c-0.94257%2c1.1046%2c3.4298%2c0.71459%2c50.904%2c1%2c1%2c0.94257%2c-1.1046z'/%3e%3cpath d='m316.69%2c152.28a3.5036%2c0.69953%2c61.837%2c1%2c1%2c-1.2051%2c0.71311%2c3.5036%2c0.69953%2c61.837%2c1%2c1%2c1.2051%2c-0.71311z'/%3e%3cpath d='m317.57%2c155.67c0.01%2c0.0178-0.97325%2c0.22286-1.1871%2c0.23175-0.21385%2c0.009-0.40144-0.42144-1.0378-0.30379-0.63631%2c0.11765-1.1522%2c0.54061-1.3504%2c0.82262-0.19818%2c0.28203%2c0.0549%2c0.50882%2c0.81953%2c0.38586%2c0.76463-0.12297%2c1.0711-0.61026%2c1.4508-0.71727%2c0.37968-0.107%2c1.0064-0.24252%2c1.3486-0.25671%2c0.20777-0.26415%2c0.80398-0.78171%2c1.1209-1.0869%2c0.31688-0.30518%2c1.3609-0.64054%2c1.8567-1.2634%2c0.42514-0.51046%2c0.43655-1.0585%2c0.005-0.9676-0.43208%2c0.0909-1.0667%2c0.53707-1.3975%2c0.89759-0.33087%2c0.36054-0.26112%2c0.97825-0.6112%2c1.3031-0.26974%2c0.23022-0.96462%2c0.97091-1.017%2c0.95483z'/%3e%3cpath d='m321.14%2c159a0.73839%2c3.3192%2c8.7402%2c1%2c1%2c-1.3929%2c-0.63898%2c0.73839%2c3.3192%2c8.7402%2c1%2c1%2c1.3929%2c0.63898z'/%3e%3cpath d='m320.35%2c158.8a3.4648%2c0.70737%2c87.95%2c1%2c1%2c-1.422%2c-0.20538%2c3.4648%2c0.70737%2c87.95%2c1%2c1%2c1.422%2c0.20538z'/%3e%3cpath d='m317.69%2c159.1a3.2231%2c0.76041%2c46.026%2c1%2c1%2c-0.76003%2c1.3966%2c3.2231%2c0.76041%2c46.026%2c1%2c1%2c0.76003%2c-1.3966z'/%3e%3cpath d='m318.33%2c158.48a3.4552%2c0.70935%2c61.791%2c1%2c1%2c-1.1206%2c0.90994%2c3.4552%2c0.70935%2c61.791%2c1%2c1%2c1.1206%2c-0.90994z'/%3e%3cpath d='m319.35%2c158.58a3.5309%2c0.69413%2c72.543%2c1%2c1%2c-1.3065%2c0.47282%2c3.5309%2c0.69413%2c72.543%2c1%2c1%2c1.3065%2c-0.47282z'/%3e%3cpath d='m319.61%2c162.09c0.006%2c0.0195-0.99148%2c0.0332-1.2021%2c0.00066-0.21062-0.0323-0.31635-0.49335-0.95952-0.49937-0.64317-0.006-1.2237%2c0.3126-1.4683%2c0.55307-0.24457%2c0.24047-0.0381%2c0.51308%2c0.73143%2c0.5385%2c0.76954%2c0.0255%2c1.157-0.39697%2c1.5474-0.42973%2c0.39042-0.0327%2c1.0274-0.0462%2c1.3644%2c0.005%2c0.25074-0.22097%2c0.92685-0.61761%2c1.2916-0.85817%2c0.36477-0.24055%2c1.4457-0.37122%2c2.0427-0.8912%2c0.50763-0.42249%2c0.61765-0.9616%2c0.17894-0.95479-0.43872%2c0.007-1.1395%2c0.32554-1.5279%2c0.61807-0.38843%2c0.29252-0.43169%2c0.916-0.83247%2c1.1696-0.30518%2c0.17556-1.118%2c0.77363-1.1663%2c0.74768'/%3e%3cpath d='m321.34%2c166.42a0.73814%2c3.3203%2c31.311%2c0%2c1%2c-1.0129%2c-1.1684%2c0.73814%2c3.3203%2c31.311%2c0%2c1%2c1.0129%2c1.1684'/%3e%3cpath d='m320.69%2c165.91a0.70283%2c3.4872%2c20.618%2c0%2c1%2c-1.2076%2c-0.77836%2c0.70283%2c3.4872%2c20.618%2c0%2c1%2c1.2076%2c0.77836'/%3e%3cpath d='m318.17%2c165.09a3.2755%2c0.74824%2c69.934%2c0%2c1%2c-1.2303%2c0.98083%2c3.2755%2c0.74824%2c69.934%2c0%2c1%2c1.2303%2c-0.98083'/%3e%3cpath d='m318.99%2c164.78a3.5112%2c0.69802%2c85.137%2c0%2c1%2c-1.3677%2c0.38052%2c3.5112%2c0.69802%2c85.137%2c1%2c1%2c1.3677%2c-0.38052'/%3e%3cpath d='m319.88%2c165.3a0.68491%2c3.5784%2c5.5508%2c1%2c1%2c-1.3664%2c-0.10172%2c0.68491%2c3.5784%2c5.5508%2c1%2c1%2c1.3664%2c0.10172'/%3e%3cpath d='m318.75%2c168.66c-0.002%2c0.0206-0.91045-0.37916-1.0886-0.4962-0.17812-0.11705-0.0948-0.58827-0.67475-0.85977-0.57992-0.2715-1.2292-0.21605-1.544-0.0942-0.31478%2c0.12187-0.23372%2c0.46002%2c0.45307%2c0.80175%2c0.68677%2c0.34174%2c1.2015%2c0.11022%2c1.5677%2c0.24126%2c0.36615%2c0.13105%2c0.94806%2c0.38192%2c1.2331%2c0.5692%2c0.31278-0.10125%2c1.0789-0.18952%2c1.5025-0.26178%2c0.42362-0.0722%2c1.4529%2c0.25346%2c2.1953%2c0.0181%2c0.62359-0.18191%2c0.93252-0.63634%2c0.53272-0.8114-0.39982-0.17507-1.158-0.16922-1.6232-0.0586-0.46522%2c0.11067-0.74646%2c0.67093-1.2077%2c0.74038-0.34444%2c0.0366-1.3125%2c0.25518-1.3461%2c0.21116'/%3e%3cpath d='m319.34%2c173.95a0.86442%2c3.782%2c48.457%2c1%2c1%2c-0.73094%2c-1.6561%2c0.86442%2c3.782%2c48.457%2c1%2c1%2c0.73094%2c1.6561'/%3e%3cpath d='m318.79%2c173.16a0.82109%2c3.9816%2c37.466%2c1%2c1%2c-1.0735%2c-1.296%2c0.82109%2c3.9816%2c37.466%2c1%2c1%2c1.0735%2c1.296'/%3e%3cpath d='m316.29%2c171.34a3.8093%2c0.85822%2c86.522%2c1%2c1%2c-1.6766%2c0.63757%2c3.8093%2c0.85822%2c86.522%2c1%2c1%2c1.6766%2c-0.63757'/%3e%3cpath d='m317.29%2c171.29a0.80649%2c4.0537%2c11.633%2c0%2c1%2c-1.6306%2c-0.0747%2c0.80649%2c4.0537%2c11.633%2c1%2c1%2c1.6306%2c0.0747'/%3e%3cpath d='m318.1%2c172.18a0.79539%2c4.1102%2c22.119%2c1%2c1%2c-1.4706%2c-0.60655%2c0.79539%2c4.1102%2c22.119%2c1%2c1%2c1.4706%2c0.60655'/%3e%3cpath d='m315.75%2c175.49c-0.009%2c0.022-0.87758-0.74786-1.0352-0.94149-0.15759-0.19362%2c0.089-0.68363-0.46017-1.1931-0.54912-0.50946-1.282-0.68314-1.6686-0.66249-0.38655%2c0.0207-0.40846%2c0.42323%2c0.23521%2c1.0489%2c0.64368%2c0.62564%2c1.2864%2c0.5563%2c1.6464%2c0.8334%2c0.35997%2c0.2771%2c0.91807%2c0.76453%2c1.1702%2c1.0743%2c0.37758%2c0.001%2c1.2499%2c0.18108%2c1.7399%2c0.25458%2c0.49005%2c0.0735%2c1.516%2c0.80535%2c2.4105%2c0.81412%2c0.74621%2c0.0248%2c1.2356-0.36504%2c0.85306-0.7029-0.38257-0.33788-1.219-0.60568-1.7675-0.6518-0.54847-0.0462-1.0422%2c0.47055-1.5728%2c0.38034-0.39119-0.0842-1.5286-0.19313-1.5511-0.25388'/%3e%3cpath d='m314.17%2c180.54a0.96734%2c4.1698%2c79.752%2c1%2c1%2c0.19909%2c-1.9977%2c0.96734%2c4.1698%2c79.752%2c1%2c1%2c-0.19909%2c1.9977'/%3e%3cpath d='m314.09%2c179.47a0.92321%2c4.3692%2c68.504%2c0%2c1%2c-0.32819%2c-1.8534%2c0.92321%2c4.3692%2c68.504%2c0%2c1%2c0.32819%2c1.8534'/%3e%3cpath d='m312.66%2c176.29a0.96428%2c4.1831%2c26.238%2c0%2c1%2c-1.9665%2c-0.36332%2c0.96428%2c4.1831%2c26.238%2c1%2c1%2c1.9665%2c0.36332'/%3e%3cpath d='m313.66%2c176.83a0.90974%2c4.4339%2c41.823%2c0%2c1%2c-1.533%2c-1.0142%2c0.90974%2c4.4339%2c41.823%2c0%2c1%2c1.533%2c1.0142'/%3e%3cpath d='m313.95%2c178.15a0.89742%2c4.4948%2c52.671%2c1%2c1%2c-1.0881%2c-1.4274%2c0.89742%2c4.4948%2c52.671%2c0%2c1%2c1.0881%2c1.4274'/%3e%3cpath d='m309.87%2c179.93c-0.0207%2c0.0157-0.43852-1.2188-0.48489-1.4941-0.0464-0.27531%2c0.45926-0.59874%2c0.20755-1.4008-0.25172-0.8021-0.86427-1.3912-1.2486-1.5951-0.38437-0.20393-0.6254%2c0.16627-0.34588%2c1.1336%2c0.27952%2c0.96728%2c0.9377%2c1.273%2c1.1338%2c1.7448%2c0.19607%2c0.47173%2c0.4685%2c1.2581%2c0.54266%2c1.6986%2c0.36367%2c0.2197%2c1.1074%2c0.89507%2c1.5403%2c1.2484%2c0.43283%2c0.35332%2c1.0233%2c1.6427%2c1.8819%2c2.1684%2c0.70667%2c0.45515%2c1.392%2c0.36743%2c1.2073-0.17513-0.18469-0.54259-0.84572-1.281-1.3499-1.6421-0.50418-0.36109-1.2629-0.15524-1.7257-0.54789-0.33158-0.3063-1.3698-1.0677-1.3584-1.1386'/%3e%3cpath d='m307.4%2c184.24a1.2121%2c4.2194%2c89.068%2c0%2c1%2c0.007%2c-2.4245%2c1.2121%2c4.2194%2c89.068%2c0%2c1%2c-0.007%2c2.4245'/%3e%3cpath d='m306.84%2c180.45a1.1714%2c4.3658%2c37.587%2c0%2c1%2c-1.7986%2c-1.5041%2c1.1714%2c4.3658%2c37.587%2c1%2c1%2c1.7986%2c1.5041'/%3e%3cpath d='m307.43%2c182.38a1.1973%2c4.2713%2c66.472%2c0%2c1%2c-0.8567%2c-2.2386%2c1.1973%2c4.2713%2c66.472%2c0%2c1%2c0.8567%2c2.2386'/%3e%3cpath d='m308.58%2c145.66a2.6209%2c0.53282%2c41.126%2c0%2c1%2c-0.99489%2c0.54201%2c2.6209%2c0.53282%2c41.126%2c1%2c1%2c0.99489%2c-0.54201'/%3e%3cpath d='m307.29%2c146.75a2.6543%2c0.52611%2c8.1634%2c0%2c1%2c0.202%2c1.0896%2c2.6543%2c0.52611%2c8.1634%2c1%2c1%2c-0.202%2c-1.0896'/%3e%3cpath d='m307.81%2c146.06a2.776%2c0.50303%2c26.817%2c1%2c1%2c-0.52645%2c0.86106%2c2.776%2c0.50303%2c26.817%2c0%2c1%2c0.52645%2c-0.86106'/%3e%3cpath d='m288.79%2c180.13s3.5359%2c0.75834%2c6.6097%2c1.8755c3.0739%2c1.1172%2c7.7443%2c4.9517%2c8.9996%2c5.1689%2c1.4081%2c0.0641%2c3.3608-0.41654%2c4.1019-2.4496-2.1685%2c0.57838-3.4689%2c1.457-5.539%2c0.31964-0.73141-0.27703-3.1265-2.4578-5.752-3.625s-7.9208-2.4978-7.9208-2.4978l-0.49937%2c1.2083'/%3e%3cpath d='m292.56%2c148.16c-0.0127-0.0303%2c4.0701-2.1474%2c4.0701-2.1474l-4.4882%2c1.1477-0.52144%2c0.78964%2c0.93955%2c0.21005'/%3e%3cpath d='m296.42%2c149.15c-1.5758-0.28645-3.9992-0.81633-5.5421-0.9399%2c1.0665-1.1813%2c2.536-3.1789%2c3.4417-4.4051-0.59804%2c1.1695-1.5368%2c2.7117-1.9073%2c3.8312%2c1.0862%2c0.5863%2c2.7936%2c1.0454%2c4.0078%2c1.5138'/%3e%3cpath d='m291.83%2c148.41c-0.0177-0.0279%2c3.6168-2.8004%2c3.6168-2.8004l-4.2006%2c1.8792-0.37387%2c0.86847%2c0.95766%2c0.0527'/%3e%3cpath d='m295.69%2c149.11c-1.5867-0.30167-4.0287-0.85794-5.5794-0.99119%2c1.0478-1.2168%2c2.4844-3.2756%2c3.3699-4.5394-0.57788%2c1.2063-1.4906%2c2.7965-1.8411%2c3.952%2c1.1012%2c0.60975%2c2.8232%2c1.0903%2c4.0506%2c1.5786'/%3e%3cpath d='m291.23%2c148.64c-0.01-0.0311%2c4.2591-1.7838%2c4.2591-1.7838l-4.5864%2c0.75479-0.59212%2c0.73968%2c0.91942%2c0.28937'/%3e%3cpath d='m295.21%2c149.15c-1.6049-0.13379-4.0856-0.43321-5.635-0.39973%2c0.89323-1.351%2c2.0721-3.6004%2c2.7993-4.9815-0.42971%2c1.2892-1.1454%2c3.0051-1.3563%2c4.2178%2c1.1608%2c0.49985%2c2.9206%2c0.80072%2c4.192%2c1.1634'/%3e%3cpath d='m290.79%2c148.66c-0.0233-0.0237%2c2.8854-3.5159%2c2.8854-3.5159l-3.6561%2c2.7338-0.16967%2c0.93251%2c0.9404-0.1504'/%3e%3cpath d='m295.19%2c149.38c-1.7196-0.0327-4.3869-0.18429-6.0307-0.0383%2c0.81363-1.5376%2c1.8405-4.0759%2c2.4746-5.6347-0.32708%2c1.4374-0.91528%2c3.3608-1.0174%2c4.6992%2c1.2844%2c0.46358%2c3.1854%2c0.66769%2c4.5735%2c0.97377'/%3e%3cpath d='m290.21%2c149.49c-0.0223-0.0308%2c3.5039-3.3619%2c3.5039-3.3619l-4.2398%2c2.3458-0.29039%2c1.0048%2c1.0262%2c0.0113'/%3e%3cpath d='m294.42%2c149.49c-1.848%2c0.007-4.6936-0.0933-6.4968%2c0.10867%2c1.1962-1.7142%2c2.8298-4.536%2c3.8367-6.269-0.65065%2c1.5916-1.6836%2c3.725-2.0711%2c5.2021%2c1.2892%2c0.47854%2c3.2974%2c0.65581%2c4.7312%2c0.95826'/%3e%3cpath d='m289.03%2c149.74c-0.0176-0.0333%2c4.476-3.7911%2c4.476-3.7911l-5.0591%2c2.6902-0.52142%2c1.1141%2c1.1046-0.0132'/%3e%3cpath d='m293.75%2c149.6c-1.83%2c0.26391-4.6638%2c0.56204-6.4216%2c1.0097%2c0.93966-1.8374%2c2.154-4.8155%2c2.9034-6.6449-0.41668%2c1.6421-1.1346%2c3.8655-1.3069%2c5.3593%2c1.346%2c0.28713%2c3.3611%2c0.18057%2c4.8251%2c0.27594'/%3e%3cpath d='m288.43%2c150.49c-0.0259-0.0268%2c3.4487-4.7769%2c3.4487-4.7769l-4.3038%2c3.8915-0.23064%2c1.1922%2c1.0858-0.3068'/%3e%3cpath d='m292.74%2c150.17c-1.8426%2c0.17159-4.6899%2c0.32693-6.4707%2c0.68564%2c1.0418-1.7872%2c2.4221-4.6995%2c3.2735-6.4883-0.50848%2c1.6185-1.3505%2c3.8022-1.6066%2c5.2848%2c1.3282%2c0.35426%2c3.347%2c0.34906%2c4.8038%2c0.51778'/%3e%3cpath d='m287.81%2c150.99c-0.0179-0.0338%2c4.3902-3.7991%2c4.3902-3.7991l-4.981%2c2.6844-0.50347%2c1.1213%2c1.0943-0.007'/%3e%3cpath d='m292.2%2c150.36c-1.837%2c0.38744-4.6873%2c0.87846-6.4421%2c1.442%2c0.85827-1.8764%2c1.9372-4.8962%2c2.6036-6.7515-0.33926%2c1.6475-0.95401%2c3.8889-1.0536%2c5.3732%2c1.3752%2c0.18936%2c3.4073-0.0559%2c4.8922-0.0637'/%3e%3cpath d='m287.08%2c151.19c-0.03-0.0213%2c2.8045-5.2073%2c2.8045-5.2073l-3.7959%2c4.5028-0.0628%2c1.1897%2c1.0542-0.48522'/%3e%3cpath d='m292.2%2c150.66c-1.9709%2c0.51269-5.0424%2c1.1852-6.9015%2c1.891%2c0.71391-2.1333%2c1.5308-5.5533%2c2.0364-7.6546-0.17164%2c1.855-0.57348%2c4.3854-0.5018%2c6.0476%2c1.534%2c0.1517%2c3.7366-0.21064%2c5.367-0.28402'/%3e%3cpath d='m286.53%2c152.39c-0.0298-0.0303%2c3.5334-5.2185%2c3.5334-5.2185l-4.5179%2c4.2179-0.1906%2c1.3165%2c1.1751-0.31589'/%3e%3cpath d='m291.42%2c151.25c-1.9374%2c0.61271-4.9624%2c1.4426-6.7795%2c2.2401%2c0.61082-2.1464%2c1.264-5.5698%2c1.669-7.6734-0.0842%2c1.8422-0.36592%2c4.3642-0.21696%2c6.0029%2c1.5335%2c0.0673%2c3.7084-0.40931%2c5.3275-0.56959'/%3e%3cpath d='m285.82%2c153.16c-0.0343-0.0242%2c2.6855-5.7607%2c2.6855-5.7607l-3.8184%2c4.9613%2c0.0173%2c1.3246%2c1.1156-0.52521'/%3e%3cpath d='m290.68%2c152.04c-1.9847%2c0.45234-5.0722%2c1.0322-6.9539%2c1.6786%2c0.80306-2.0896%2c1.7642-5.4488%2c2.3585-7.5126-0.25108%2c1.8295-0.76055%2c4.3205-0.76099%2c5.9662%2c1.5208%2c0.19251%2c3.7297-0.10474%2c5.3564-0.13211'/%3e%3cpath d='m285.18%2c153.71c-0.0238-0.0354%2c4.3881-4.5082%2c4.3881-4.5082l-5.173%2c3.338-0.42128%2c1.2662%2c1.2062-0.0961'/%3e%3cpath d='m289.8%2c152.82c-1.966%2c0.26388-5.0168%2c0.54834-6.8942%2c1.02%2c0.91275-2.0472%2c2.058-5.3709%2c2.7652-7.4125-0.3577%2c1.8371-1.0084%2c4.3219-1.1101%2c5.9967%2c1.4734%2c0.34649%2c3.6488%2c0.26266%2c5.239%2c0.39584'/%3e%3cpath d='m284.31%2c153.26c-0.0323-0.0271%2c2.9857-5.6409%2c2.9857-5.6409l-4.0499%2c4.7466-0.0631%2c1.3441%2c1.1273-0.44976'/%3e%3cpath d='m290.04%2c152.15c-2.1381%2c0.87557-5.4778%2c2.0958-7.4812%2c3.1751%2c0.65695-2.5384%2c1.3495-6.5596%2c1.7791-9.0308-0.077%2c2.141-0.36647%2c5.0863-0.18727%2c6.9715%2c1.6973-0.0533%2c4.0995-0.7916%2c5.8893-1.1159'/%3e%3cpath d='m283.9%2c154.97c-0.0346-0.0302%2c3.5737-6.4733%2c3.5737-6.4733l-4.7176%2c5.4774-0.13032%2c1.5296%2c1.2742-0.53369'/%3e%3cpath d='m289.22%2c152.95c-2.0951%2c0.9847-5.3742%2c2.3775-7.3258%2c3.5553%2c0.5427-2.5381%2c1.0549-6.539%2c1.3737-8.998%2c0.0186%2c2.1135-0.13932%2c5.0315%2c0.1235%2c6.8784%2c1.6918-0.14952%2c4.0566-1.014%2c5.8286-1.4358'/%3e%3cpath d='m283.17%2c155.95c-0.0392-0.0225%2c2.6078-6.9665%2c2.6078-6.9665l-3.9029%2c6.222%2c0.099%2c1.5082%2c1.1961-0.76364'/%3e%3cpath d='m288.3%2c153.53c-2.0902%2c1.0013-5.3626%2c2.4201-7.3079%2c3.6131%2c0.5268-2.5408%2c1.0138-6.543%2c1.317-9.0029%2c0.0321%2c2.1119-0.10721%2c5.0291%2c0.1676%2c6.8726%2c1.6919-0.16336%2c4.0527-1.0468%2c5.8233-1.4828'/%3e%3cpath d='m282.58%2c156.78c-0.0319-0.0338%2c4.0345-6.1433%2c4.0345-6.1433l-5.0869%2c5.0282-0.24792%2c1.5233%2c1.3003-0.40818'/%3e%3cpath d='m288.11%2c153.21c-1.8636%2c1.4877-4.8118%2c3.6746-6.4923%2c5.3092-0.003-2.5647-0.34635-6.5176-0.55367-8.9482%2c0.46762%2c2.0126%2c0.93175%2c4.8392%2c1.5844%2c6.5336%2c1.642-0.58507%2c3.7979-2.0286%2c5.4615-2.8945'/%3e%3cpath d='m282.78%2c157.07c-0.0447-0.006%2c0.46739-7.3613%2c0.46739-7.3613l-1.9438%2c7.1568%2c0.54238%2c1.3482%2c0.934-1.1436'/%3e%3cpath d='m287.58%2c153.89c-1.869%2c1.4782-4.8251%2c3.6499-6.5118%2c5.2759%2c0.008-2.5657-0.3191-6.522-0.51623-8.9546%2c0.45907%2c2.0159%2c0.91126%2c4.8461%2c1.5566%2c6.5446%2c1.6438-0.57637%2c3.8048-2.0088%2c5.4714-2.866'/%3e%3cpath d='m282.31%2c158.32c-0.0416-0.0175%2c1.8801-7.1926%2c1.8801-7.1926l-3.2533%2c6.6145%2c0.2567%2c1.4768%2c1.1165-0.89863'/%3e%3cpath d='m287.37%2c154.06c-1.7662%2c1.74-4.5782%2c4.3217-6.1396%2c6.1914-0.27684-2.6316-1.0544-6.6488-1.5284-9.1194%2c0.6982%2c2.0118%2c1.4798%2c4.8594%2c2.3351%2c6.5234%2c1.6338-0.78834%2c3.7067-2.5165%2c5.3328-3.5955'/%3e%3cpath d='m282.32%2c159.24c-0.0462-0.007%2c0.35192-7.6498%2c0.35192-7.6498l-1.8789%2c7.4327%2c0.58349%2c1.4029%2c0.94347-1.1858'/%3e%3cpath d='m286.81%2c155.33c-1.8902%2c1.5628-4.8841%2c3.862-6.5822%2c5.5756-0.0591-2.665-0.50061-6.7694-0.76796-9.2932%2c0.52674%2c2.0871%2c1.0678%2c5.0201%2c1.7784%2c6.7748%2c1.6814-0.62281%2c3.8742-2.1423%2c5.5718-3.0572'/%3e%3cpath d='m281.76%2c160.11c-0.0403-0.0248%2c2.6632-7.1952%2c2.6632-7.1952l-3.9937%2c6.3751%2c0.10446%2c1.5793%2c1.226-0.75915'/%3e%3cpath d='m286.78%2c155.36c-1.6729%2c1.7696-4.3365%2c4.3957-5.8152%2c6.2962-0.2642-2.6676-1.004-6.7388-1.4549-9.2426%2c0.66316%2c2.038%2c1.406%2c4.9231%2c2.2178%2c6.6079%2c1.5481-0.80419%2c3.5117-2.5626%2c5.0523-3.6616'/%3e%3cpath d='m281.86%2c160.48c-0.0468-0.00066-0.31503-7.607-0.31503-7.607l-1.2318%2c7.5764%2c0.70623%2c1.3169%2c0.84065-1.2864'/%3e%3cpath d='m285.96%2c155.93c-1.6186%2c1.7855-4.2014%2c4.4366-5.6223%2c6.3515-0.34233-2.6683-1.2009-6.7377-1.7249-9.2404%2c0.72226%2c2.0346%2c1.549%2c4.9167%2c2.4093%2c6.5966%2c1.5223-0.81796%2c3.4317-2.5947%2c4.9379-3.7076'/%3e%3cpath d='m281.43%2c161.24c-0.0429-0.0127%2c0.84948-7.7276%2c0.84948-7.7276l-2.2658%2c7.3094%2c0.45158%2c1.5011%2c0.96479-1.0828'/%3e%3cpath d='m285.61%2c156.23c-1.4798%2c1.9335-3.8561%2c4.822-5.1287%2c6.865-0.54421-2.6206-1.71-6.5845-2.4229-9.0227%2c0.87524%2c1.9534%2c1.919%2c4.7394%2c2.9052%2c6.3264%2c1.4572-0.96185%2c3.2278-2.915%2c4.6464-4.1687'/%3e%3cpath d='m281.4%2c161.96c-0.0443-0.002-0.49032-7.737-0.49032-7.737l-0.97414%2c7.6757%2c0.70154%2c1.3522%2c0.76292-1.2909'/%3e%3cpath d='m285.46%2c156.67c-1.3891%2c2.0246-3.6307%2c5.0578-4.806%2c7.1817-0.67929-2.6103-2.051-6.5406-2.8906-8.9584%2c0.97816%2c1.921%2c2.1678%2c4.6717%2c3.2389%2c6.218%2c1.4155-1.045%2c3.0957-3.1045%2c4.4578-4.4413'/%3e%3cpath d='m281.88%2c162.68c-0.0433-0.0142%2c0.78724-7.7718%2c0.78724-7.7718l-2.2149%2c7.3052%2c0.46702%2c1.529%2c0.96068-1.0624'/%3e%3cpath d='m285.18%2c157.39c-1.1974%2c2.206-3.1506%2c5.5334-4.1267%2c7.8084-0.90975-2.5008-2.6261-6.2176-3.6778-8.5047%2c1.1445%2c1.7739%2c2.5738%2c4.3433%2c3.7769%2c5.7318%2c1.3118-1.2357%2c2.7952-3.517%2c4.0276-5.0355'/%3e%3cpath d='m281.61%2c163.32c-0.0435%2c0.0121-2.172-7.3702-2.172-7.3702l0.73403%2c7.7686%2c0.97861%2c1.0955%2c0.45931-1.4939'/%3e%3cpath d='m285.13%2c158.25c-1.2476%2c2.1993-3.2806%2c5.5166-4.3014%2c7.7848-0.91524-2.4932-2.6498-6.1988-3.7125-8.479%2c1.1622%2c1.7686%2c2.6107%2c4.3302%2c3.836%2c5.7144%2c1.3575-1.232%2c2.8996-3.5064%2c4.1778-5.0202'/%3e%3cpath d='m281.71%2c164.71c-0.0459%2c0.00002-0.79743-7.7496-0.79743-7.7496l-0.71779%2c7.7504%2c0.77557%2c1.3281%2c0.73965-1.329'/%3e%3cpath d='m285.26%2c158.93c-1.2828%2c2.1698-3.3689%2c5.4389-4.4262%2c7.6828-0.87461-2.5145-2.5487-6.2606-3.5741-8.5656%2c1.1332%2c1.7957%2c2.5398%2c4.3912%2c3.7424%2c5.8042%2c1.3771-1.1999%2c2.9555-3.4378%2c4.2579-4.9214'/%3e%3cpath d='m281.64%2c165.33c-0.0457%2c0.005-1.438-7.6104-1.438-7.6104l-0.0703%2c7.7943%2c0.88248%2c1.2271%2c0.62581-1.411'/%3e%3cpath d='m284.71%2c160.03c-1.3837%2c2.078-3.6216%2c5.1981-4.7836%2c7.3658-0.7531-2.5716-2.2454-6.4286-3.1591-8.8014%2c1.0454%2c1.8718%2c2.3257%2c4.5611%2c3.4586%2c6.0554%2c1.4316-1.1029%2c3.1136-3.2284%2c4.4842-4.6198'/%3e%3cpath d='m280.97%2c166.18c-0.0447-0.0122%2c0.64352-7.779%2c0.64352-7.779l-2.1198%2c7.3762%2c0.51212%2c1.5034%2c0.96413-1.1006'/%3e%3cpath d='m284.79%2c160.22c-1.1829%2c2.2504-3.1184%2c5.6512-4.0726%2c7.9608-0.98749-2.4525-2.8292-6.0817-3.9579-8.315%2c1.2132%2c1.7179%2c2.7357%2c4.2162%2c4.0008%2c5.5474%2c1.321-1.2885%2c2.7961-3.6264%2c4.0297-5.1932'/%3e%3cpath d='m280.71%2c166.83c-0.0445%2c0.0139-2.3872-7.25-2.3872-7.25l0.91887%2c7.7096%2c1.0284%2c1.0491%2c0.44002-1.5087'/%3e%3cpath d='m284.47%2c160.8c-0.82599%2c2.4697-2.2198%2c6.234-2.8118%2c8.7118-1.3408-2.1938-3.6994-5.3571-5.1462-7.3047%2c1.4525%2c1.4228%2c3.3268%2c3.5446%2c4.7723%2c4.5761%2c1.1066-1.5547%2c2.207-4.1742%2c3.1857-5.9832'/%3e%3cpath d='m282.83%2c167.42c-0.0441%2c0.0157-2.5849-7.1499-2.5849-7.1499l1.1296%2c7.6676%2c1.0567%2c1.0074%2c0.39853-1.5251'/%3e%3cpath d='m284.45%2c161.56c-0.80817%2c2.4781-2.1748%2c6.2568-2.7489%2c8.7406-1.3566-2.1795-3.7381-5.3178-5.199-7.2501%2c1.4628%2c1.4074%2c3.3524%2c3.5094%2c4.8054%2c4.5256%2c1.0954-1.5662%2c2.1769-4.197%2c3.1425-6.0161'/%3e%3cpath d='m282.85%2c168.64c-0.0421%2c0.0224-3.3258-6.6866-3.3258-6.6866l1.9368%2c7.4247%2c1.1558%2c0.83503%2c0.23325-1.5732'/%3e%3cpath d='m284.2%2c162.18c-0.5167%2c2.5726-1.4378%2c6.5146-1.7217%2c9.0594-1.5966-1.9663-4.3201-4.7362-5.9916-6.4424%2c1.613%2c1.1856%2c3.7295%2c2.9986%2c5.2878%2c3.7978%2c0.90653-1.7097%2c1.6769-4.4729%2c2.4255-6.4148'/%3e%3cpath d='m283.07%2c169.69c-0.0454%2c0.009-1.7934-7.4979-1.7934-7.4979l0.29571%2c7.7844%2c0.9389%2c1.1646%2c0.55876-1.451'/%3e%3cpath d='m284.21%2c162.98c-0.27334%2c2.6303-0.82051%2c6.6781-0.86543%2c9.2492-1.7668-1.7422-4.7264-4.1325-6.5433-5.6057%2c1.7105%2c0.96289%2c3.9788%2c2.4825%2c5.5991%2c3.0682%2c0.74032-1.8239%2c1.2476-4.678%2c1.8097-6.7117'/%3e%3cpath d='m283.16%2c170.24c-0.0354%2c0.0346-4.7406-5.413-4.7406-5.413l3.5722%2c6.556%2c1.3053%2c0.44601-0.1369-1.589'/%3e%3cpath d='m284.31%2c163.9c-0.2837%2c2.6285-0.84683%2c6.6728-0.90187%2c9.2435-1.76-1.7521-4.7104-4.1591-6.5216-5.6425%2c1.7068%2c0.97255%2c3.9692%2c2.505%2c5.5873%2c3.0998%2c0.74754-1.8195%2c1.266-4.6705%2c1.8362-6.7008'/%3e%3cpath d='m283.69%2c171.49c-0.041%2c0.0242-3.6411-6.525-3.6411-6.525l2.2874%2c7.3243%2c1.195%2c0.78156%2c0.15873-1.5808'/%3e%3cpath d='m284.52%2c164.98c-0.17301%2c2.6443-0.56557%2c6.7207-0.5128%2c9.2934-1.8299-1.6444-4.8751-3.8712-6.7449-5.244%2c1.7442%2c0.8685%2c4.0662%2c2.2628%2c5.7059%2c2.7592%2c0.66981-1.8639%2c1.0678-4.7448%2c1.5518-6.8086'/%3e%3cpath d='m284.15%2c172.69c-0.0369%2c0.0323-4.4987-5.7041-4.4987-5.7041l3.2806%2c6.7699%2c1.2848%2c0.52845-0.0667-1.5943'/%3e%3cpath d='m284.57%2c166.2c-0.15709%2c2.646-0.52509%2c6.7261-0.45686%2c9.2986-1.8395-1.6286-4.8978-3.829-6.7755-5.1857%2c1.7491%2c0.8534%2c4.0793%2c2.2276%2c5.7218%2c2.7098%2c0.65851-1.8699%2c1.0392-4.7545%2c1.5106-6.8227'/%3e%3cpath d='m284.56%2c173.66c-0.0427%2c0.0197-3.1543-6.877-3.1543-6.877l1.7456%2c7.5287%2c1.1347%2c0.90411%2c0.274-1.5558'/%3e%3cpath d='m284.69%2c166.99c0.0903%2c2.655%2c0.10463%2c6.7657%2c0.41156%2c9.317-1.9764-1.3734-5.215-3.1518-7.2041-4.2492%2c1.8146%2c0.6139%2c4.2541%2c1.668%2c5.9284%2c1.9268%2c0.4794-1.9499%2c0.58873-4.8724%2c0.86412-6.9945'/%3e%3cpath d='m285.11%2c173.39c-0.0266%2c0.0435-5.7616-3.9448-5.7616-3.9448l4.8844%2c5.3824%2c1.3575%2c0.0701-0.4804-1.5077'/%3e%3cpath d='m284.87%2c167.27c0.22922%2c2.6428%2c0.45861%2c6.7394%2c0.89939%2c9.2707-2.0509-1.2942-5.3868-2.9444-7.4359-3.9631%2c1.8492%2c0.54333%2c4.347%2c1.5018%2c6.0371%2c1.6964%2c0.37805-1.9616%2c0.3347-4.8786%2c0.49945-7.0041'/%3e%3cpath d='m285.73%2c174.86c-0.0353%2c0.0336-4.8006-5.5183-4.8006-5.5183l3.636%2c6.6258%2c1.314%2c0.47899-0.14944-1.5865'/%3e%3cpath d='m285.29%2c168.28c0.34006%2c2.6317%2c0.74172%2c6.7188%2c1.2879%2c9.2262-2.0982-1.1719-5.4919-2.6228-7.5767-3.5191%2c1.8655%2c0.43245%2c4.3949%2c1.2414%2c6.0871%2c1.3344%2c0.29381-1.9864%2c0.12737-4.9038%2c0.20173-7.0415'/%3e%3cpath d='m286.69%2c175.79c-0.0271%2c0.0431-5.7175-4.0403-5.7175-4.0403l4.8227%2c5.4618%2c1.3574%2c0.0933-0.4626-1.5148'/%3e%3cpath d='m285.47%2c169.4c0.51244%2c2.6008%2c1.1827%2c6.6519%2c1.8915%2c9.1088-2.1618-0.97386-5.6288-2.1041-7.7589-2.8035%2c1.8815%2c0.25605%2c4.4475%2c0.82589%2c6.1344%2c0.75872%2c0.15996-2.0152-0.19901-4.9183-0.26704-7.0641'/%3e%3cpath d='m287.32%2c176.59c-0.0357%2c0.0328-4.729-5.6059-4.729-5.6059l3.5489%2c6.6901%2c1.3083%2c0.50387-0.12812-1.588'/%3e%3cpath d='m285.78%2c170.12c0.75054%2c2.5293%2c1.7931%2c6.4861%2c2.7243%2c8.8454-2.2284-0.68355-5.7618-1.3487-7.9333-1.7623%2c1.8841%2c0.004%2c4.4741%2c0.22995%2c6.1355-0.0628-0.0309-2.0343-0.65805-4.8861-0.92656-7.0203'/%3e%3cpath d='m287.57%2c176.6c-0.01%2c0.0517-6.6064-1.4152-6.6064-1.4152l6.2826%2c3.1233%2c1.2691-0.47761-0.94521-1.2305'/%3e%3cpath d='m286.21%2c170.91c0.74065%2c2.533%2c1.7677%2c6.4948%2c2.6898%2c8.8588-2.2262-0.696-5.7576-1.381-7.9279-1.8067%2c1.8844%2c0.0147%2c4.4742%2c0.25521%2c6.137-0.0281-0.0228-2.034-0.63878-4.8887-0.89888-7.024'/%3e%3cpath d='m288.65%2c177.3c-0.0197%2c0.0468-6.3209-3.0528-6.3209-3.0528l5.6692%2c4.5959%2c1.3583-0.12728-0.70667-1.4158'/%3e%3cpath d='m285.88%2c171.35c1.2554%2c2.3082%2c3.0909%2c5.9481%2c4.4875%2c8.0501-2.3158-0.17673-5.9011-0.0474-8.1055%2c0.0273%2c1.8392-0.41187%2c4.4133-0.76254%2c5.9739-1.4156-0.45081-1.9829-1.6525-4.6337-2.3559-6.6618'/%3e%3cpath d='m289.65%2c177.99c-0.0123%2c0.0508-6.5681-1.814-6.5681-1.814l6.1642%2c3.4904%2c1.2962-0.39585-0.89236-1.2805'/%3e%3cpath d='m286.56%2c172.33c1.2689%2c2.2992%2c3.1258%2c5.9263%2c4.5345%2c8.0181-2.3151-0.15736-5.8968%2c0.002-8.099%2c0.0956%2c1.8352-0.42766%2c4.4051-0.80025%2c5.9604-1.4669-0.4629-1.9805-1.6803-4.6231-2.3958-6.6467'/%3e%3cpath d='m290.48%2c178.53c-0.0234%2c0.0441-6.1205-3.6614-6.1205-3.6614l5.3476%2c5.1176%2c1.3751%2c0.0136-0.60219-1.4699'/%3e%3cpath d='m287.07%2c172.91c1.4696%2c2.146%2c3.6456%2c5.55%2c5.2323%2c7.4692-2.2891%2c0.14354-5.7916%2c0.77074-7.9455%2c1.1516%2c1.761-0.66908%2c4.2489-1.3786%2c5.7118-2.2514-0.64696-1.9306-2.0993-4.4284-2.9986-6.3694'/%3e%3cpath d='m290.93%2c179.07c-0.002%2c0.0538-6.6066-0.15568-6.6066-0.15568l6.5361%2c1.9315%2c1.1622-0.72207-1.0918-1.0538'/%3e%3cpath d='m294.76%2c147.06c0.00065-0.0206%2c4.7533-0.79299%2c4.7533-0.79299l-4.7291%2c0.11031-0.82503%2c0.42379%2c0.80086%2c0.25889'/%3e%3cpath d='m297.37%2c148.07c-1.3791-0.41674-3.4631-1.1148-4.8787-1.4225%2c1.5043-0.59791%2c3.7307-1.6585%2c5.1008-2.309-1.0541%2c0.65981-2.5868%2c1.5076-3.4038%2c2.1691%2c0.78925%2c0.5361%2c2.2218%2c1.0828%2c3.1818%2c1.5624'/%3e%3cpath d='m294.55%2c147.22c-0.005-0.0199%2c4.5986-1.2633%2c4.5986-1.2633l-4.7642%2c0.6073-0.7185%2c0.49317%2c0.88409%2c0.16283'/%3e%3cpath d='m297.59%2c148.41c-1.6114-0.15181-4.0828-0.46088-5.6728-0.47676%2c1.198-1.0608%2c2.8775-2.8356%2c3.9121-3.9252-0.71132%2c1.024-1.805%2c2.3829-2.2765%2c3.3514%2c1.0804%2c0.43367%2c2.8148%2c0.724%2c4.0372%2c1.0505'/%3e%3cpath d='m292.84%2c147.55c0.004-0.0209%2c4.7795-0.53969%2c4.7795-0.53969l-4.657-0.14908-0.87096%2c0.38293%2c0.74852%2c0.30584'/%3e%3cpath d='m296.38%2c148.59c-1.4653-0.28018-3.6918-0.76832-5.174-0.94216%2c1.4082-0.69122%2c3.4606-1.8807%2c4.7239-2.6105-0.94322%2c0.71246-2.3349%2c1.6427-3.0389%2c2.3371%2c0.89228%2c0.44221%2c2.4349%2c0.84107%2c3.489%2c1.2156'/%3e%3cpath d='m292.43%2c147.5c-0.0121-0.018%2c4.207-1.8106%2c4.207-1.8106l-4.6079%2c1.2163-0.55216%2c0.56093%2c0.95306%2c0.0333'/%3e%3cpath d='m296.24%2c149.12c-1.2194-0.5036-3.0876-1.3567-4.294-1.7117%2c0.93412-0.86906%2c2.2505-2.3921%2c3.0614-3.3263-0.56395%2c0.93353-1.4259%2c2.1406-1.8066%2c3.0664%2c0.80976%2c0.68926%2c2.1192%2c1.3658%2c3.0392%2c1.9717'/%3e%3cpath d='m292.67%2c147.81c-0.009-0.0282%2c3.2732-1.4184%2c3.2732-1.4184l-3.5645%2c0.48835-0.43827%2c0.63528%2c0.72961%2c0.29475'/%3e%3cpath d='m289.93%2c178.46c0.003%2c0.0524-6.7834%2c0.0512-6.7834%2c0.0512l6.8687%2c1.6793%2c1.1269-0.73842-1.2122-0.99207'/%3e%3cpath d='m291.15%2c178.9c-0.008%2c0.0497-6.8895-1.6024-6.8895-1.6024l6.6159%2c3.2432%2c1.2964-0.41713-1.0228-1.2237'/%3e%3cpath d='m292.28%2c179.36c-0.00001%2c0.052-6.8397-0.34479-6.8397-0.34479l6.8394%2c2.0617%2c1.1727-0.66479-1.1723-1.0521'/%3e%3cpath d='m287.94%2c174.53c1.7794%2c1.9611%2c4.4452%2c5.086%2c6.3123%2c6.8152-2.2976%2c0.34709-5.7574%2c1.2758-7.8858%2c1.8423%2c1.6915-0.81215%2c4.1133-1.7294%2c5.4752-2.7134-0.91749-1.8253-2.7273-4.1313-3.9017-5.944'/%3e%3cpath d='m293.22%2c179.71c-0.0125%2c0.0479-6.8369-2.2373-6.8369-2.2373l6.4245%2c3.8199%2c1.3459-0.28376-0.9335-1.2989'/%3e%3cpath d='m288.57%2c174.98c1.9393%2c1.7687%2c4.8642%2c4.6079%2c6.8646%2c6.1309-2.2015%2c0.63398-5.474%2c2.0002-7.4877%2c2.8357%2c1.5623-1.0308%2c3.8248-2.2579%2c5.0481-3.4224-1.0855-1.737-3.0907-3.8515-4.425-5.5442'/%3e%3cpath d='m293.78%2c180.13c0.0106%2c0.0527-6.4875%2c1.2757-6.4875%2c1.2757l6.8362%2c0.46588%2c0.96514-0.95299-1.3138-0.78855'/%3e%3cpath d='m292.43%2c179.72c0.007%2c0.0521-6.7667%2c0.51919-6.7667%2c0.51919l6.9817%2c1.1997%2c1.0693-0.81376-1.2844-0.90516'/%3e%3cpath d='m293.68%2c180.08c-0.005%2c0.0501-6.9968-1.1217-6.9968-1.1217l6.8468%2c2.776%2c1.2626-0.50524-1.1127-1.1491z'/%3e%3cpath d='m294.84%2c180.46c0.004%2c0.0518-6.8526%2c0.12836-6.8526%2c0.12836l6.9812%2c1.5829%2c1.1205-0.74354-1.2491-0.96772z'/%3e%3cpath d='m290.14%2c175.94c1.9233%2c1.8319%2c4.8186%2c4.7625%2c6.812%2c6.3572-2.2671%2c0.5045-5.6507%2c1.669-7.7325%2c2.3804%2c1.6273-0.92621%2c3.9756-2.0076%2c5.261-3.0824-1.0528-1.756-3.0324-3.9295-4.3406-5.6552z'/%3e%3cpath d='m295.81%2c180.74c-0.009%2c0.0487-6.9919-1.7581-6.9919-1.7581l6.6991%2c3.364%2c1.3221-0.37572-1.0293-1.2302z'/%3e%3cpath d='m290.81%2c176.34c2.0685%2c1.6291%2c5.201%2c4.2571%2c7.3119%2c5.637-2.1497%2c0.78383-5.3134%2c2.3714-7.2605%2c3.3431%2c1.4819-1.1352%2c3.648-2.5144%2c4.7815-3.7595-1.2138-1.6564-3.374-3.6256-4.8329-5.2206z'/%3e%3cpath d='m296.4%2c181.12c0.0145%2c0.0519-6.3794%2c1.7192-6.3794%2c1.7192l6.8581-0.007%2c0.89174-1.0165-1.3705-0.6953z'/%3e%3c/g%3e%3cpath d='m305.21%2c171.52-5.2112-3.6015-5.2113%2c3.6015%2c1.9542-5.7624-4.5599-3.6016%2c5.8626%2c0%2c1.9542-5.7624%2c1.9542%2c5.7624%2c5.8626%2c0-4.5598%2c3.6016%2c1.9542%2c5.7624z' fill='%23fedf00' stroke='black' stroke-width='0.298846'/%3e%3c/g%3e%3c/svg%3e";

var img$V = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3crect width='12' height='2' fill='%2300732f' id='green'/%3e%3crect width='12' height='2' y='2' fill='white'/%3e%3crect width='12' height='2' y='4'/%3e%3crect width='3' height='6' fill='red' id='red'/%3e%3c/svg%3e";

var img$U = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 750 500'%3e%3crect width='750' fill='%23006c35' height='500'/%3e%3cpath fill-rule='evenodd' d='m323.28 118.09c-0.3878-0.0115-0.96797 0.20495-1.7812 0.6875-1.8284 1.2256-5.4516 5.0006-5.5625 9.3438-0.11087 2.4503-0.57338 2.4407 1.0312 4 1.1591 1.6712 2.3168 1.5069 4.6562 0.28125 1.3436-0.98979 1.7974-1.6212 2.25-3.2812 0.55738-2.7839-2.9295 1.3172-3.375-1.7812-0.77915-2.8766 1.4468-4.0598 3.5625-6.8438 0.0485-1.3111 0.0719-2.381-0.78125-2.4062zm34.062 0.1875c-0.65345 0.088-1.4528 0.92515-2.5625 2.9375-0.79526 2.1076-4.2255 5.2972-1.75 11.875 2.0249 4.1708 2.8567 10.949 1.9375 18.5-1.403 2.1459-1.723 2.8854-3.5625 5.0312-2.5843 2.7789-5.3833 2.0684-7.5312 1.0312-2.0068-1.3526-3.5838-2.0469-4.5-6.3438 0.16531-6.8489 0.56436-18.059-0.6875-20.438-1.8455-3.684-4.8873-2.3628-6.1875-1.25-6.2472 5.712-9.3329 15.357-11.219 23.031-1.7326 5.593-3.5788 3.9755-4.875 1.7188-3.1558-2.9573-3.3775-26.083-7.1875-22.281-6.1021 17.44 3.5018 36.545 10.156 34.688 4.8008 1.9876 7.847-7.1505 9.8125-17.156 1.3446-2.8081 2.3721-3.1309 3.0625-1.6875-0.17741 13.306 0.95406 16.274 4.375 20.312 7.6311 5.8874 13.943 0.7459 14.438 0.25 0.49491-0.4949 5.9375-5.9375 5.9375-5.9375 1.3224-1.391 3.0698-1.4756 4.9375-0.25 1.8153 1.65 1.5822 4.4922 5.4688 6.4688 3.2708 1.3083 10.255 0.31819 11.875-2.5 2.1802-3.7364 2.7088-5.0203 3.7188-6.4375 1.5562-2.0713 4.2188-1.1542 4.2188-0.5-0.24796 1.1551-1.8124 2.2946-0.75 4.375 1.8506 1.3879 2.2804 0.49593 3.375 0.1875 3.8715-1.8506 6.7812-10.25 6.7812-10.25 0.17134-3.1327-1.611-2.8951-2.75-2.25-1.4857 0.90815-1.5768 1.2168-3.0625 2.125-1.8929 0.28122-5.5597 1.5299-7.375-1.2812-1.8536-3.3796-1.8641-8.0912-3.2812-11.5 0-0.24795-2.4765-5.3599-0.1875-5.6875 1.1551 0.21469 3.6392 0.85659 4.0312-1.2188 1.2116-2.0229-2.6142-7.7615-5.2188-10.656-2.2608-2.4815-5.3824-2.784-8.4062-0.25-2.1177 1.9483-1.8035 4.1242-2.2188 6.1875-0.53925 2.3697-0.43618 5.3048 1.9688 8.4375 2.1136 4.1678 5.9535 9.5151 4.6875 17.062 0 0-2.2313 3.5917-6.1562 3.125-1.6359-0.35681-4.3016-1.0648-5.7188-11.531-1.0724-7.9224 0.26872-19.022-3.0938-24.219-0.75911-1.9611-1.4109-3.8654-2.5-3.7188zm-10.78 0.84c-1.0171 0.0888-2.1438 1.2735-3.0625 3.5625-0.78821 1.7407-1.751 10.844-1.5938 10.844-0.62896 2.7093 2.8308 3.8574 4.4062 0.375 2.3616-6.3843 2.373-9.1042 2.5312-11.812-0.3679-2.0627-1.2641-3.0576-2.2812-2.9688zm39.812 0.71875c-1.0447 0.0947-1.8768 0.70635-2.1875 2.25-0.41629 3.6296-0.20355 5.6032 0.40625 8.625 0.46769 2.0149 3.4004 5.3884 4.8438 7.3438 6.896 9.2694 13.531 18.583 19.938 28.219 1.0072 7.155 1.7452 14.154 2.2188 21.125 1.0382 15.284 1.3537 34.31 0.40625 50.406 2.8636 0.1129 7.4518-4.6239 9.0625-11.562 1.0472-9.5976-0.37299-29.18-0.46875-34.844-0.0675-2.3514-0.21224-5.157-0.375-8.0938 7.4527 12.179 14.683 25.082 21.781 39.25 2.5874-1.2297 2.0139-15.798 0.5-17.844-5.6807-12.227-13.529-24.296-16.031-28.938-0.90311-1.6763-3.9793-6.3547-7.625-11.75-0.67122-7.6985-1.4006-14.219-1.875-16.188-1.1722-8.1381 3.3447 0.91775 2.7188-3.8125-1.4656-8.127-5.9513-13.65-11.25-21.094-1.7085-2.4211-1.6747-2.9149-4.3125 0.59375-1.5766 3.5768-1.5553 6.5526-1.0938 9.3438-0.69381-1.0083-1.5514-2.2039-2.7812-3.6875-4.576-3.9259-4.8583-4.1405-8.6562-7.3438-1.1976-0.84982-3.4776-2.1579-5.2188-2zm118 1.2188c-0.50876-0.0791-1.0631 0.17099-1.6875 1.0938-1.1934 1.0462-2.4768 2.9408-2.4375 5.375 0.29027 4.2888 1.0535 8.68 1.3438 12.969 0.10229 0.57392 0.2102 1.1448 0.3125 1.7188-0.46081-0.58803-0.86314-1.0469-1.0938-1.2812-8.3598-8.7822 3.841-1.4353-1.5938-8.2188-4.5962-5.0467-5.941-6.6526-9.875-9.6875-1.9726-1.275-3.1644-3.7112-3.8125 0.4375-0.25802 3.6447-0.52618 7.8653-0.28125 10.938-0.0141 1.7074 1.7542 4.9216 3.2812 6.8125 5.5768 6.8517 11.273 14.142 17 21.75 1.2052 15.516 1.5266 29.739 2.75 45.281-0.17335 6.6473-2.218 15.476-4.1562 16.312 0 0-2.9599 1.7004-4.9375-0.1875-1.4383-0.57755-7.1875-9.5938-7.1875-9.5938-2.9432-2.6982-4.9055-1.9272-7 0-5.7755 5.5769-8.3876 16.023-12.312 23.219-1.012 1.6056-3.8623 2.9724-7.0312-0.125-8.0484-10.996-3.3419-26.648-4.3438-22.625-7.1685 8.0786-3.9938 21.465-2.375 24.344 2.3636 4.7282 4.2758 7.7553 8.875 10.094 4.189 3.0833 7.4508 1.159 9.25-1 4.2152-4.3684 4.2714-15.54 6.25-17.75 1.3879-4.06 4.8662-3.3617 6.5625-1.5625 1.644 2.3636 3.585 3.9014 6 5.1875 3.9319 3.4683 8.6246 4.0984 13.25 0.9375 3.1609-1.773 5.2119-4.0772 7.0625-8.625 1.9856-5.3106 1.0038-33.142 0.5625-48.625 2.9696 4.1831 5.9006 8.4568 8.8125 12.781 1.2782 13.591 1.8582 26.976 1.4375 39.812-0.30139 2.5521 8.9062-7.6196 8.8438-12.438-0.0415-4.2158 0.008-8.0366 0-11.594 4.466 7.1306 8.789 14.38 12.875 21.719 2.532-1.3416 1.6641-15.678 0.0625-17.656-4.2781-7.1786-9.7567-14.936-14-20.938-0.83864-7.5749-1.9805-16.512-2.5-19.25-0.8094-4.2696-1.6201-10.683-2.8438-15.75-0.33567-1.9786-1.3488-8.2985-1.0312-8.9062 0.49893-1.4141 2.3842 0.0452 3.3125-1.5938 1.3899-1.5149-4.8179-17.598-7.9688-22.188-1.1329-2.0572-3.1818-1.3453-5.7188 2-2.3526 2.2013-1.4918 7.2234-0.59375 12 2.3327 12.174 4.4149 24.572 6.0625 36.938-3.0501-4.5343-6.7725-10.021-10.438-15.312-0.0985-0.51026-0.46875-2.3803-0.46875-2.4062-0.00002-0.21873-0.50509-9.959-0.9375-12.281-0.0756-0.94243-0.30028-1.2137 0.6875-1.0938 1.0473 0.88094 1.1896 0.92846 1.8438 1.2188 1.0573 0.19352 1.9818-1.594 1.3438-3.25-3.2708-6.0325-6.5418-12.092-9.8125-18.125-0.3936-0.38756-0.83499-0.79588-1.3438-0.875zm-304.53 0.3125c-1.8123-0.0518-3.8118 1.0716-3.0312 3.25-0.45458 1.1873 3.5475 5.2009 4.25 7.4062 0.62996 1.5704-0.62483 6.6271 0.6875 7.0938 1.2065 0.52312 2.868-3.5005 3.5-7.2188 0.34975-2.037 0.0851-9.0082-4.6562-10.438-0.24291-0.0549-0.4911-0.0863-0.75-0.0937zm346.91 0.04c-0.41312 0.041-0.91624 0.70862-1.6875 2.3438-1.8546 3.0379-2.4928 8.4774-1.75 13.281 4.4652 30.203 7.7834 59.449 8.4688 86.219-0.38402 2.541-0.49612 3.8926-1.6875 7.0938-2.6358 3.3786-5.5427 7.6142-8.2812 9.6562-2.7376 2.0411-8.5638 3.9871-10.469 5.5-6.0436 3.4935-6.074 7.5111-1.1875 7.6562 8.4213-0.97769 18.386-1.6686 25.25-12.031 1.8365-2.9038 3.999-10.776 4.0938-15.594 0.64204-28.247-0.36143-55.866-4.5938-76.281-0.27113-1.9887-1.1492-6.5596-0.8125-7.1562 0.54529-1.398 3.3005 0.13992 4.2812-1.4688 1.4394-1.4696-7.1254-12.436-10.125-17.125-0.59928-1.1776-0.96885-2.1465-1.5-2.0938zm-88.312 0.46875c-0.34774 0.06-0.86114 0.58925-1.8125 1.8438-2.3525 7.6916-3.1793 13.973-2.2812 18.75 6.0426 31.534 12.234 60.263 11.25 90.281 2.8656 0.0191 6.1786-6.5553 7.5938-13.062 0.7751-8.9636-0.51716-14.419-0.75-19.688-0.23181-5.2685-5.9639-48.014-7.125-52-1.401-7.5374 5.5735-0.99148 4.8125-5.375-2.411-5.5265-8.4287-13.574-10.312-18.375-0.70808-1.2858-0.79543-2.475-1.375-2.375zm-215.03 0.59375c-0.7426 0.12864-1.4592 0.74056-1.7188 1.75-0.16329 0.66121 0.28622 1.7611-0.3125 2.0938-0.3437 0.34673-1.6482 0.11368-1.5938-1.7188 0-0.58359-0.42846-1.1926-0.6875-1.5625-0.26005-0.17034-0.43554-0.21875-0.90625-0.21875-0.57352 0.0232-0.56052 0.17445-0.875 0.65625-0.14 0.49-0.32 0.97-0.32 1.53-0.0716 0.65214-0.33273 0.873-0.8125 0.96875-0.53623 0-0.40932 0.0584-0.84375-0.21875-0.25803-0.28222-0.5625-0.3932-0.5625-0.875 0-0.49892-0.13107-1.2954-0.28125-1.625-0.22778-0.30036-0.58775-0.45667-1-0.5625-2.2467 0.008-2.4103 2.5898-2.2812 3.5625-0.16832 0.18344-0.25163 4.7592 2.8125 6.0312 4.1134 1.9614 11.827 1.1322 11.5-5.5 0.00001-0.58662-0.12904-2.5565-0.1875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm55.188 0.0625c-1.4216 0.0725-2.6766 0.47991-3.75 1.0312-2.7265 2.6106-3.3657 6.7957-1.2188 9.4062 2.0895 0.98677 4.1742 3.0899 2.7812 4.25-5.9087 6.3111-21.287 16.857-22.062 18.781-0.006 0.0157-0.0279 0.0481-0.0312 0.0625-0.002 0.0138 0.00015 0.05 0 0.0625 0.00047 0.006-0.001 0.0256 0 0.0312 0.005 0.0159 0.0214 0.0496 0.0312 0.0625 0.004 0.004 0.0268 0.0276 0.0312 0.0312 0.005 0.003 0.0257-0.003 0.0312 0 0.006 0.003 0.0245 0.029 0.0312 0.0312 0.007 0.002 0.0233-0.002 0.0312 0 0.002 0.002 0.0286 0.029 0.0312 0.0312 0.78147 0.52416 10.404 0.51176 11.469 0.0312 0.008-0.004 0.0248-0.0271 0.0312-0.0312 0.003-0.002 0.0286 0.002 0.0312 0 0.002-0.002-0.002-0.0291 0-0.0312 3.307-1.2186 19-19.156 19-19.156-0.81342-0.69647-1.5626-1.2098-2.375-1.9062-0.87086-0.75393-0.78317-1.4951 0-2.25 3.8866-2.2618 2.655-7.2382 0.625-9.5-1.6828-0.75445-3.2659-1.01-4.6875-0.9375zm144.25 0.0625c-0.41312 0.041-0.91624 0.67737-1.6875 2.3125-1.8546 3.0379-3.1149 8.3282-2.9688 13.281 4.0176 27.814 5.2493 52.154 7.875 79.969 0.21369 2.6902-0.18067 6.598-1.9688 8.1562-6.6141 6.9064-16.151 15.424-26.531 19.344-1.1168 1.2539 2.7768 6.5988 7.8125 6.5938 8.4213-0.9777 15.823-5.7042 22.688-18.156 1.8355-2.9039 5.0615-9.1196 5.1562-13.938 0.64205-28.247-1.4239-50.209-5.6562-70.625-0.27114-1.9886-0.0867-4.3408 0.25-4.9375 0.54529-0.65112 2.3943 0.0149 3.375-1.5938 1.4393-1.4696-3.8441-13.655-6.8438-18.344-0.59928-1.1776-0.96885-2.1152-1.5-2.0625zm-223.47 0.85c-1.1623 0.1359-2.2557 1.0822-2.7812 2.3438-0.19454 4.4611-0.2207 8.9199 0.28125 13.031 2.029 7.2108 2.6715 13.553 3.6562 20.938 0.27314 9.8909-5.7117 4.2786-5.4375-0.625 1.3819-6.3692 1.0089-16.396-0.21875-18.938-0.97367-2.541-2.1011-3.1683-4.4688-2.75-1.8798-0.1149-6.7361 5.1765-8.0938 13.938 0.00001-0.00001-1.1311 4.4965-1.625 8.5-0.66423 4.5246-3.6616 7.7288-5.75-0.625-1.8052-6.0718-2.9147-21.032-5.9375-17.531-0.86582 11.681-1.8939 32.235 8.0312 34.344 12.005 1.1541 5.3735-20.294 9.7188-24.188 0.82147-1.9242 2.3438-1.9584 2.4688 0.46875v18.219c-0.10986 5.9226 3.7877 7.6826 6.8125 8.9062 3.1478-0.24292 5.235-0.15687 6.4688 2.9062 0.49188 10.502 1.0081 21.03 1.5 31.531 0 0 7.2773 2.0912 7.625-17.719 0.34876-11.632-2.3163-21.393-0.75-23.656 0.0554-2.2235 2.9055-2.3335 4.875-1.25 3.1377 2.2134 4.5298 4.9374 9.4062 3.8438 7.4204-2.0441 11.89-5.6459 12-11.344-0.43342-5.4146-1.0598-10.835-3.4062-16.25 0.32759-0.98475-1.4203-3.5465-1.0938-4.5312 1.3335 2.0884 3.3509 1.9151 3.8125 0-1.263-4.1618-3.2292-8.1494-6.4062-9.875-2.6257-2.3132-6.4679-1.824-7.875 3-0.65214 5.5588 2.0146 12.147 6.0625 17.531 0.85977 2.1036 2.0624 5.6022 1.5312 8.75-2.154 1.2287-4.2896 0.7175-6.0938-1.1875 0.00001-0.00001-5.9062-4.4215-5.9062-5.4062 1.5673-10.035 0.33759-11.184-0.53125-13.969-0.60677-3.8443-2.4286-5.0618-3.9062-7.6875-1.4776-1.5663-3.482-1.5663-4.4375 0-2.6106 4.5256-1.3858 14.242 0.5 18.594 1.3627 4.0025 3.4525 6.5 2.4688 6.5-0.81038 2.2618-2.5002 1.7356-3.7188-0.875-1.7397-5.3955-2.0938-13.437-2.0938-17.062-0.52212-4.4944-1.1042-14.095-4.0625-16.531-0.78934-1.0751-1.721-1.4494-2.625-1.3438zm42.156 0.0625c-0.59574 0.0753-1.2543 0.41445-2.0312 0.59375-2.5521 0.8124-4.9414 3.0187-4.1875 7.3125 3.0168 18.332 4.9832 32.323 8 50.656 0.46368 2.1469-1.336 4.9768-3.6562 4.6875-3.9451-2.669-4.9242-8.0746-11.656-7.8438-4.8734 0.0585-10.431 5.3615-11.125 10.469-0.81239 4.059-1.1017 8.4601 0 12 3.425 4.1184 7.5277 3.6793 11.125 2.75 2.9583-1.2176 5.3923-4.133 6.4375-3.4375 0.003 0.003 0.0286-0.004 0.0312 0 0.003 0.004-0.003 0.027 0 0.0312 0.64509 1.1276-0.0608 10.663-13.938 18.031-8.5281 3.8292-15.316 4.7441-18.969-2.2188-2.2628-4.3513 0.16462-20.924-5.4062-17.094-16.475 42.467 38.598 48.395 44.75 1.75 0.39844-1.3159 1.6121-2.6362 2.4688-2.3125 0.3759 0.16008 0.71998 0.67052 0.84375 1.625-1.2771 42.235-42.606 45.13-49.625 31.844-1.7397-3.1317-2.2631-10.103-2.4375-14.281-0.31817-2.5275-0.95237-3.9854-1.6875-4.5625-1.6745-1.2582-3.9247 2.023-4.4062 7.7188-0.69647 4.5831-0.5 5.8413-0.5 10.25 2.2044 33.359 55.388 19.026 64.031-8.5312 4.2787-14.246-0.0871-24.993 1.3438-26.312 0.0124-0.0104 0.0493-0.0222 0.0625-0.0312 0.0136-0.008 0.048-0.0242 0.0625-0.0312 0.0149-0.006 0.0467-0.0262 0.0625-0.0312 0.0487-0.013 0.13046-0.0305 0.1875-0.0312 5.2796 5.6868 12.688 0.72253 14.312-1.25 0.69648-0.98677 2.4387-1.6198 3.6562-0.34375 4.1184 2.9603 11.337 1.5649 12.844-3.6562 0.87085-5.1052 1.6069-10.361 1.7812-15.812-2.6827 0.83292-4.8475 1.4566-5.7188 2.375-0.20749 0.22659-0.36097 0.47794-0.40625 0.75-0.23283 1.5089-0.45467 3.0224-0.6875 4.5312-0.0249 0.12473-0.065 0.23996-0.125 0.34375-0.11434 0.18521-0.30336 0.35601-0.5 0.46875-0.94842 0.51783-2.6022 0.22171-2.6875-1.1562-1.276-5.8017-6.5276-6.5563-9.7188 2.4375-2.1469 1.7397-6.0616 2.0793-6.4688-0.53125 0.52213-6.0335-1.9089-6.8434-6.7812-4-1.5664-11.951-3.1202-23.361-4.6875-35.312 2.031-0.0585 3.8934 1.414 5.75-0.90625-2.0092-6.2487-6.2607-18.963-8.6562-20.156-0.0188-0.009-0.0439-0.024-0.0625-0.0312-0.10876-0.1305-0.23745-0.25071-0.34375-0.34375-0.0442-0.0375-0.1123-0.0933-0.15625-0.125-0.0439-0.0305-0.11251-0.0687-0.15625-0.0937-0.0962-0.0528-0.21644-0.0958-0.3125-0.125-0.2184-0.0619-0.43059-0.091-0.65625-0.0625zm164.34 0.0937c-2.1076-0.0625-4.4397 1.2657-3.5312 3.9062-0.52916 1.4403 4.5283 6.326 5.3438 9 1.4676 4.1084-1.1208 8.0273 0.40625 8.5938 1.4051 0.63399 3.36-4.2415 4.0938-8.75 0.84767-3.6447-1.7525-11.114-5.4375-12.656-0.28247-0.0665-0.57391-0.0848-0.875-0.0937zm-128.03 4.5c0.95979-0.0978 2.1195 0.78407 2.6875 2.0312 0.60588 1.3303 0.30199 2.6014-0.6875 2.8438-0.98948 0.24236-2.2691-0.63842-2.875-1.9688-0.60586-1.3303-0.30199-2.6326 0.6875-2.875 0.0618-0.0152 0.12351-0.0247 0.1875-0.0312zm237.5 6.1562c-1.9215-0.0673-4.0156 1.3916-3.1875 4.25-0.4818 1.5593 4.1009 6.8552 4.8438 9.75 0.66826 2.0602-1.017 8.6997 0.375 9.3125 1.2811 0.6864 3.0818-4.5873 3.75-9.4688 0.37092-2.672-1.6093-12.049-4.9688-13.719-0.25753-0.0719-0.538-0.11538-0.8125-0.125zm-131.31 3.25c0.17575 0.78356 0.3514 1.5724 0.46875 2.375 0.39382 1.7317 0.73331 3.4518 1.0938 5.1562-1.5169-2.0887-2.7725-3.7763-3.3125-4.375-3.4323-4.079 0.0773-2.6786 1.75-3.1562zm30.25 14.875c-0.7426 0.12864-1.4592 0.7718-1.7188 1.7812-0.16329 0.6612 0.31746 1.7299-0.28125 2.0625-0.3437 0.34673-1.6794 0.14492-1.625-1.6875-0.00001-0.5836-0.42846-1.2238-0.6875-1.5938-0.26003-0.17035-0.43554-0.21875-0.90625-0.21875-0.57353 0.0232-0.56053 0.17446-0.875 0.65625-0.13304 0.49087-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.87299-0.78125 0.96875-0.53622 0-0.44058 0.0584-0.875-0.21875-0.25804-0.28221-0.5625-0.39321-0.5625-0.875 0.00001-0.49893-0.13107-1.2954-0.28125-1.625-0.2278-0.30037-0.58776-0.42541-1-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16834 0.18344-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 11.858 1.101 11.531-5.5312 0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm-138.12 1.375c-0.5072-0.0517-1.1721 0.13451-1.9375 0.59375-3.6376 1.9675-5.0461 7.8039-2.7812 11.219 2.1157 3.0077 5.4607 1.9062 5.9062 1.9062 3.564 0.4455 5.6875-6.6875 5.6875-6.6875-0.00001 0 0.10732-2.0056-4.125 1.7812-1.781 0.33363-2.0232-0.3096-2.4688-1.3125-0.37093-1.8556-0.29122-3.7371 0.5625-5.5938 0.39436-1.1131 0.002-1.8201-0.84375-1.9062zm195.25 0.90625c-2.0194-0.0982-4.1688 1.2095-4.7188 3.9688 0.008 1.6278 0.73488 2.5224 0.59375 4-0.21065 0.84465-1.0809 1.4001-3.1562 0.40625 0.32455-0.29835-1.3438-2.6562-1.3438-2.6562-1.6188-0.98576-3.7804 0.0535-5.1875 0.96875-0.7741 1.4071-1.3467 3.8189-0.46875 6.2812 2.3233 4.2928 10.293 11.618 14.094 11.688 0.0706-3.8705 0.4466-9.0175 0.65625-12.219 0.0897-1.2085 0.37315-2.5404 1.5312-2.8438 1.1571-0.30238 3.1653 1.1642 3.1875-0.0937-0.21066-2.4624-0.70279-6.096-2.0938-7.8125-0.71249-1.0557-1.8821-1.6286-3.0938-1.6875zm-161.62 13.469c-0.0537 0.0197-0.10688 0.0656-0.15625 0.0937-0.0242 0.0147-0.0693 0.0449-0.0937 0.0625-0.40219 0.30193-0.87679 0.99874-1.9375 1.75-1.7891 2.035-2.1098 3.4521-2 7.5312 0.10179 0.43147 3.3965 9.5919 6.1875 16.031 1.8818 6.6927 3.6228 14.356 2.3438 21.594-4.4057 9.5684-13.263 18.15-21.812 22.812-4.3557 1.395-8.1174 0.91994-9.125-0.0312-0.008-0.008-0.024-0.0236-0.0312-0.0312-2.5014-1.6818-2.5588-4.6756-2.4062-5.1875-0.00005-0.003 0.00017-0.0277 0-0.0312 0.006-0.006 0.0255-0.0258 0.0312-0.0312 7.2138-5.0246 15.454-9.0914 21.906-22.656 1.905-5.1838 2.4866-8.2964 0.59375-16.312-0.73791-2.9868-1.6494-5.4446-3.6875-7.5625 0.005-0.006 0.0259-0.0257 0.0312-0.0312 1.228-0.58751 4.4141 1.7597 4.9062 0.28125-0.75393-3.8271-3.3461-8.965-6.2812-11.594-2.5702-2.3344-5.3662-2.6046-7.7188-0.46875-2.6499 1.4746-3.2135 6.7707-1.9375 11.406 1.4172 3.4895 5.2433 4.1017 7.9688 11.125-0.00005 0.007-0.00024 0.0289 0 0.0312 0.0568 0.44036 0.93536 5.2424-0.4375 7.1875-1.1141 3.4742-15.424 14.759-16.438 15.438-0.0112 0.0112-0.0829 0.0519-0.0937 0.0625-0.006 0.006-0.0259 0.026-0.0312 0.0312-0.003 0.002-0.0246 0.0245-0.0312 0.0312-0.003 0.003-0.0284 0.028-0.0312 0.0312-0.003 0-0.0278 0.00017-0.0312 0-0.002-0.00007-0.0241-0.00011-0.0312 0-0.006-0.005-0.0257-0.0254-0.0312-0.0312 0.00024-0.003-0.00007-0.0284 0-0.0312-0.006-0.0108-0.0256-0.0512-0.0312-0.0625-0.0431-0.28175 0.0326-0.99908 0-2.1562-0.094-2.1144 0.78114-6.8979 0.71875-7.7188 0.00003-0.003-0.00009-0.0281 0-0.0312-0.006-0.006-0.0254-0.0257-0.0312-0.0312 0.00004-0.003-0.00016-0.0278 0-0.0312-0.007 0.00014-0.0302 0.00009-0.0312 0-4.7302 3.0541-6.2924 12.416-7.1562 15.188-11.975 8.2741-25.574 14.43-33.406 22.812-4.0791 6.3702 28.104-7.3147 31.844-8.9688 0.0321 0.0241 0.0641 0.063 0.0937 0.0937 0.71089 0.78237 0.77161 3.5103 2.9062 5.9688 3.3453 4.5317 10.456 7.3224 17.375 5.5938 11.603-4.194 18.288-12.102 25.094-20.875 0.97266-1.4151 2.4972-2.5301 3.9062-1.4375 4.6768 10.47 18.161 17.92 35.594 18.688 4.0338-4.9056 2.1046-7.3177 0.46875-8.3438-0.50391-0.33487-8.6698-3.5184-9.9375-6.6875-0.79829-2.9492 1.1426-5.5648 5.0312-7.5312 11.193-1.3537 22.196-2.8573 32.844-6.2812 0.10784-3.5772 2.2149-8.9267 3.625-11.25 0.97909-1.612 1.6086-1.7716 1.8438-2 0.008-0.008 0.0246-0.023 0.0312-0.0312 0.003-0.004 0.0284-0.0269 0.0312-0.0312 0.006-0.005 0.0256-0.0257 0.0312-0.0312 0.00002-0.0107 0.00042-0.0514 0-0.0625 0.006-0.0708-0.00049-0.19272-0.0312-0.3125l-1.8125-1.0625-35.719-0.15625c-0.44124-0.16987-0.76931-0.34037-0.96875-0.5-0.0152-0.0127-0.0489-0.0499-0.0625-0.0625-0.006-0.006-0.0253-0.025-0.0312-0.0312-0.006-0.006-0.0261-0.0251-0.0312-0.0312-0.005-0.0109-0.0263-0.0516-0.0312-0.0625-0.003-0.003-0.0277-0.0279-0.0312-0.0312 0.00006-0.003-0.00029-0.0279 0-0.0312-0.003-0.003-0.0276-0.0279-0.0312-0.0312 0.00002-0.003-0.00018-0.0279 0-0.0312 0.00001-0.003-0.00013-0.0279 0-0.0312 0-0.003-0.00008-0.0279 0-0.0312-0.00033-0.005 0.00012-0.0265 0-0.0312 0.00013-0.002 0.00009-0.0246 0-0.0312-0.00005-0.003 0.0001-0.0279 0-0.0312-0.00006-0.003 0.00014-0.0279 0-0.0312-0.00007-0.003 0.00019-0.0279 0-0.0312 0.006-0.006 0.0254-0.0256 0.0312-0.0312 0.008-0.0165 0.0204-0.0462 0.0312-0.0625 0.17439-0.23501 0.59702-0.45652 1.125-0.65625 8.5292-1.1621 23.682-3.646 24.688-18.219-0.15724-7.5908-3.2482-12.561-12.562-13.938-6.8439 0.52918-11.725 7.1491-10.938 14.438-0.32757 1.9624 0.66406 5.8136-1.3438 6.25-13.128 1.1994-27.457 9.4251-27.938 15.312-0.003-0.00052-0.0285 0.00014-0.0312 0-0.005 0.006-0.0258 0.0256-0.0312 0.0312-0.0101 0.005-0.046 0.0231-0.0625 0.0312-0.0109-0.00015-0.0515 0.0004-0.0625 0-0.0211 0.007-0.0722 0.0257-0.0937 0.0312-0.006 0.00054-0.0232-0.00011-0.0312 0-0.0178-0.00028-0.0507 0-0.0625 0-0.006-0.00019-0.0232-0.0002-0.0312 0-0.0132 0.00033-0.0516 0.00053-0.0625 0-0.0339-0.007-0.0956-0.0238-0.125-0.0312-0.85384-0.23714-1.9538-1.6462-1.7812-3.625-0.49994-10.177-3.8122-21.693-9-30.562-1.8513-1.8508-2.6579-2.6008-3.1875-2.6875-0.0171-0.002-0.0459 0.0008-0.0625 0-0.0218-0.00009-0.0656 0.00025-0.0937 0-0.005 0.00014-0.0264-0.0004-0.0312 0-0.003-0.00009-0.0283 0.00025-0.0312 0-0.004 0.001-0.0274-0.001-0.0312 0zm34.188 5.375c-0.7426 0.12864-1.4592 0.74055-1.7188 1.75-0.16327 0.66121 0.31746 1.7611-0.28125 2.0938-0.34371 0.34673-1.6794 0.14493-1.625-1.6875 0-0.58359-0.42846-1.2238-0.6875-1.5938-0.26004-0.17034-0.40429-0.21875-0.875-0.21875-0.57352 0.0232-0.59178 0.17445-0.90625 0.65625-0.13306 0.49085-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.873-0.78125 0.96875-0.53623 0-0.40933 0.0584-0.84375-0.21875-0.25803-0.28222-0.59375-0.3932-0.59375-0.875-0.00001-0.49893-0.0998-1.2954-0.25-1.625-0.22779-0.30036-0.61901-0.42542-1.0312-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16833 0.18345-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 13.916 0.80665 11.531-5.5312-0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.4198-0.9777-1.1949-1.3474-1.9375-1.2188zm137.97 5.6562c-0.1034-0.0186-0.22236-0.0114-0.34375 0.0312 0 0-19.059 13.559-19.531 14.031-1.8899 1.6802-0.94442 7.5886 0 6.9062 1.3658 0.52513 20.554-12.478 20.188-14 0.83627 0.0491 1.2385-6.6892-0.3125-6.9688zm-119.96 2.01c0.77787-0.0825 1.7982 0.18143 2.7812 0.75 1.4228 0.82293 2.2998 2.0657 2.1875 2.9688-0.004 0.0245 0.005 0.0698 0 0.0937-0.006 0.0238-0.0554 0.0705-0.0625 0.0937-0.008 0.023-0.0221 0.0713-0.0312 0.0937-0.006 0.0148-0.0241 0.048-0.0312 0.0625-0.007 0.0144-0.0231 0.0484-0.0312 0.0625-0.0466 0.0763-0.12358 0.15638-0.1875 0.21875-0.68395 0.63877-2.2626 0.54784-3.75-0.3125-1.4098-0.81544-2.281-2.068-2.1875-2.9688 0.003-0.0246 0.0267-0.0696 0.0312-0.0937 0.0236-0.11178 0.0679-0.21374 0.125-0.3125 0.0204-0.0353 0.0384-0.0926 0.0625-0.125 0.005-0.006 0.0261-0.025 0.0312-0.0312 0.042-0.049 0.10547-0.11459 0.15625-0.15625 0.22671-0.17829 0.54802-0.30575 0.90625-0.34375zm-166.91 3.4375c-9.8758 0.18043-24.338 12.945-24.719 20.031 10.421-5.0044 20.657-9.8212 31.25-15-1.7095-2.5521-0.10363-4.8518-6.5312-5.0312zm32 4.4375c0.96809 0.0109 1.9891 0.48893 2.5312 1.8438 0.48784 1.2428 0.0231 2.5424-0.5625 3.1875-0.003 0.005 0.003 0.0263 0 0.0312-0.009 0.0144-0.0215 0.049-0.0312 0.0625-0.4145 0.53404-1.8697 0.3125-2.9062 0.3125-1.2539-0.0554-1.8721-0.26122-2.625-1.2812-0.35982-1.1339 0.73594-2.2481 1.2188-3.0938 0.005-0.008 0.0263-0.0234 0.0312-0.0312 0.0524-0.0788 0.13801-0.17326 0.21875-0.25 0.375-0.34347 1.0235-0.66453 1.7188-0.75 0.13519-0.0166 0.26795-0.0328 0.40625-0.0312zm251.16 3.93c-1.756 0.21654-3.4252 1.877-2.6562 4.5312-0.4818 1.5593 2.3822 7.0115 3.125 9.9062 0.66827 2.0602-0.86071 7.8872 0.53125 8.5 1.2811 0.68641 4.6502-3.4593 4.5312-8.6562 0.37092-2.672-0.95304-12.517-4.3125-14.188-0.38629-0.10791-0.81353-0.14372-1.2188-0.0937zm-213.31 9.625c-1.552 0.10848-2.9369 0.93803-2.3125 3.125-0.0937 1.5865 4.3851 3.5156 4.6562 7.1875 0.64004 1.5139-0.9575 6.362 0.375 6.8125 1.2236 0.50396 2.9215-3.3513 3.5625-6.9375 0.35479-1.9645-1.5367-8.8358-4.75-10.062-0.49313-0.10609-1.0139-0.16116-1.5312-0.125zm63.844 8.7188c0.11777-0.008 0.22161 0.00072 0.34375 0 0.0205-0.00013 0.0419-0.00009 0.0625 0 3.9793 1.0815 9.8454 1.1936 14.938 1.7188 4.1477 0.26307 6.1971 3.5103 2.3125 4.875-3.8322 1.3124-7.5141 2.3374-7.5312 7.875 0.50376 2.7431 0.39705 4.1826-0.0312 4.8438-0.0335 0.0496-0.0878 0.11552-0.125 0.15625-0.005 0.006-0.0258 0.0258-0.0312 0.0312-0.006 0.005-0.0256 0.0261-0.0312 0.0312-0.006 0.005-0.0255 0.0265-0.0312 0.0312l-0.0312 0.0312c-0.011 0.005-0.0514 0.0259-0.0625 0.0312-0.0557 0.0346-0.12681 0.0715-0.1875 0.0937-0.0536 0.0182-0.1305 0.0217-0.1875 0.0312-0.91095 0.1336-2.234-0.73511-3.2188-1.25-2.3626-1.6964-8.9931-5.8056-9.9375-14.625-0.13438-1.9902 1.3554-3.7064 3.75-3.875zm-155.94 6.7812c-0.24858 0.008-0.74605 0.75061-1.4062 1.5938-5.8753 9.3597-6.3978 23.331-3.1562 27.5 1.7226 1.9695 4.5628 2.8356 6.6562 2.2188 3.6911-1.6006 5.3134-9.077 4.4375-11.812-1.2317-1.9282-2.2078-2.2337-3.4375-0.59375-2.5974 5.2735-3.6784 1.666-3.9062-1.2812-0.39814-5.589 0.14322-10.736 0.75-14.812 0.32304-2.089 0.31108-2.8203 0.0625-2.8125zm200.16 12.29c-0.43689-0.0234-0.90278 0.0449-1.375 0.28125-0.0927 0-4.2058 2.7815-5.5312 4.7188-0.80837 0.61485-0.71671 1.1493-0.46875 2.2188 0.62996 1.4484 1.7401 0.99386 3 0.3125 1.6722-0.2278 2.4808 0.8672 2.3438 2.875-0.77208 2.5037 0.34374 3.4365 0.34375 3.5938 0 0.15724 1.6101 1.5392 3.5 0.4375 3.9894-1.523 6.4755-3.0042 12.062-4.2188 1.4666-0.0292 1.3818-3.9536-0.9375-4.0938-3.0258 0.1522-5.8179 0.30676-8.8438 2.6875-1.8617 0.43039-2.1805-0.70275-2.5938-1.7188-0.47272-2.5208 1.0645-4.2976 0.75-6.1875 0.0839 0.0831-0.93932-0.83604-2.25-0.90625zm128.16 4.7812c-0.74222 0.0232-1.5238 0.12602-2.6562 0.21875-1.2246 0.26006-1.6522 0.79656-1.875 2.2812 0.0877 2.2517 1.4649 2.1402 2.875 3.0312 0.81645 1.0392 1.3476 1.98-0.0625 3.6875-1.3365 1.2246-2.2885 1.9004-3.625 3.125-0.631 1.0765-1.024 2.7299 0.90625 3.25 3.564 1.0019 11.812-4.3569 11.812-4.4688 1.3365-1.0019 0.89313-2.9062 0.78125-2.9062-0.77912-0.89102-2.5374-0.35586-3.7188-0.5-0.56244 0-2.4092-0.27339-1.5312-1.9062 0.73278-1.016 1.0031-1.6232 1.5-2.875 0.55638-1.2246 0.0673-2.0505-1.9375-2.7188-1.021-0.18546-1.7265-0.24193-2.4688-0.21875zm-53.54 108.4c-0.008 0.004-0.0234 0.0258-0.0312 0.0312-5.9277 1.521-5.7433 7.6749-1.9375 10.375-62.594 0-158.65-1.0625-179.25-1.0625-11.525 0-47.987-1.375-48.688-1.375 7.8196 11.437 19.147 13.766 33.969 14 27.802 0 156.62-0.34375 193.28-0.34375-2.6062 4.6275 0.23645 12.074 2.2812 13.438 0.0434 0.0279 0.11369 0.0715 0.15625 0.0937 0.0763 0.038 0.17693 0.0749 0.25 0.0937 0.0242 0.006 0.07-0.003 0.0937 0 2.4271 0.5725 3.4951-1.1846 4.3125-2.4688 3.9372 0.34703 26.097 0.66757 28.125-0.0312 0.007-0.003 0.0245-0.0284 0.0312-0.0312 1.3718 2.0189 2.7332 3.9264 5.3438 3.5938 4.569-0.97972 8.1674-1.477 8.2812-10.75 0 0-0.46704-15.802-10.844-14.812-2.4553 0.37092-9.3438 1.0625-9.3438 1.0625-7.9718-0.94847-13.819-1.0454-22.781-1.375 0.82723-1.0502 2.2878-5.3034 0.5-6.8438-0.46622-0.38767-1.1617-0.60352-2.125-0.53125-0.007 0.0005-0.0244-0.00008-0.0312 0-0.0136-0.00068-0.0492 0.002-0.0625 0-0.007-0.002-0.0248-0.0293-0.0312-0.0312-0.0257-0.009-0.0692-0.0161-0.0937-0.0312-0.0486-0.033-0.11173-0.10294-0.15625-0.15625-0.011-0.0139-0.0517-0.0475-0.0625-0.0625-0.45322-0.65987-0.70068-2.2777-1-2.6875-0.004-0.004-0.0277-0.0271-0.0312-0.0312-0.004-0.003-0.0276-0.0282-0.0312-0.0312-0.0109-0.007-0.0514-0.0277-0.0625-0.0312-0.004-0.00036-0.0275-0.00006-0.0312 0-0.004 0.00091-0.0274-0.001-0.0312 0zm4.25 22.594c0.0109-0.005 0.0202 0.005 0.0312 0 9.1319 0.44551 17.712 0.0857 26.844 0.53125 1.4473 1.2303 0.72345 4.0484-0.21875 4.5625-0.0422 0.0211-0.11339 0.051-0.15625 0.0625-0.0344 0.008-0.0905-0.001-0.125 0-0.0345-0.0007-0.0905 0.008-0.125 0-2.9694-0.0746-4.6869-0.14417-7.6562-0.21875-0.005-0.14772-0.0215-0.30707-0.0625-0.4375-0.70371-2.0856-5.8008-1.9461-7-0.3125-0.0166 0.0235-0.0475 0.0696-0.0625 0.0937-0.0192 0.0325-0.0463 0.0915-0.0625 0.125-0.0193 0.0422-0.0482 0.11238-0.0625 0.15625-0.0187 0.0619-0.0229 0.15372-0.0312 0.21875-0.008 0.0748-0.0379 0.17113-0.0312 0.25-4.0086 0.4818-7.6164-0.13309-11.625-0.28125-1.1761-1.4641-1.0388-4.1134 0.34375-4.75z' fill='white'/%3e%3c/svg%3e";

var img$T = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3crect width='1200' height='600' fill='%233f9c35'/%3e%3crect width='1200' height='400' fill='%23ed2939'/%3e%3crect width='1200' height='200' fill='%2300b9e4'/%3e%3ccircle cx='580' cy='300' r='90' fill='white'/%3e%3ccircle cx='600' cy='300' r='75' fill='%23ed2939'/%3e%3cpath d='M680%2c250 689.567%2c276.903 715.355%2c264.645 703.097%2c290.433 730%2c300 703.097%2c309.567 715.355%2c335.355 689.567%2c323.097 680%2c350 670.433%2c323.097 644.645%2c335.355 656.903%2c309.567 630%2c300 656.903%2c290.433 644.645%2c264.645 670.433%2c276.903 680%2c250z' fill='white'/%3e%3c/svg%3e";

var img$S = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28'%3e%3crect width='56' height='28' fill='%23d20000'/%3e%3cg fill='%23ffe600'%3e%3cpath d='M 0%2c0 8.4%2c0 28%2c13.5 47.6%2c0 56%2c0 0%2c28 8.4%2c28 28%2c14.5 47.6%2c28 56%2c28 z M 56%2c11.2 56%2c16.8 0%2c11.2 0%2c11.2 0%2c16.8 z M 25.2%2c0 28%2c12 30.8%2c0 z M 25.2%2c28 28%2c16 30.8%2c28 z'/%3e%3ccircle cx='28' cy='14' r='4.5' stroke='%23d20000'/%3e%3c/g%3e%3c/svg%3e";

var img$R = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 640 320'%3e%3cpath fill='%23d3ae3b' d='M0 0h640v320H0z'/%3e%3cpath fill='%23c40308' d='M16 16h608v288H16z'/%3e%3cpath fill='%23B96B29' d='M389.64 157.4c1.87-.53 8.39-2.43 12.98-6.16 4.6-3.72 5.49-6.7 5.86-8.32.37-1.61.53-2.88-.66-1.96-1.19.93-4.75 3.73-7.18 5.08a26.85 26.85 0 0 1-5.99 2.35c-1.32.37-2.37.6-1.1.1 1.26-.5 5.4-1.95 8.6-5.15 3.19-3.2 5.71-7.99 5.76-10.93.06-2.94-.15-2.73-1.1-2-.94.74-4.3 4.9-6.2 6.47a60.01 60.01 0 0 1-6.46 4.57c-1.52.9-3.67 1.89-.68-.16 3-2.05 8.67-6.88 10.98-13.13 2.31-6.25 1.89-9.93 1.84-10.56-.06-.63-.58-1.9-1.1-.73-.53 1.15-4.32 8.72-7.36 11.97-3.05 3.26-2.31 2.63-3 3.15-.68.53-1.83 1.47-.36-.37 1.47-1.83 4.52-6.09 6.1-10.29 1.57-4.2 1.99-8.4 2.04-10.82.05-2.42-1-5.78-1.47-6.78s-.95-1.73-1.1-.58c-.16 1.16-2.58 8.62-3.9 12.24a47.14 47.14 0 0 1-4.46 8.51c-.52.8-1.89 2.42-.42-.31s4.31-10.77 4.68-18.39c.37-7.61-.68-11.81-1.74-13.92-1.05-2.1-1.96-2.84-1.96-2.84s.18 5.2-1.37 12.67-3.82 11.41-3.82 11.41-.95 1.08-.3-.71a31.8 31.8 0 0 0 1.77-8.36c.44-4.72.5-10.1-.88-14.66-1.5-4.98-4.1-7.52-4.1-7.52-.73 7.14-.59 16.34-3.2 23.8-.5-.44-1.14-1.25-1.4.4a42.09 42.09 0 0 1-4.66 12.9c-3.22 5.87-4.53 6.64-4.53 6.64s-.6-1.43-1.02-2.2c-.41-.78-.65-1.2-1.19-.13-.54 1.08-2.33 5.2-6.27 9.74-3.93 4.55-6.14 6.76-6.02 10.16.12 3.41 1.9 5.14 4.3 6.7 2.38 1.55 2.8 2.39 2.44 4.24-.36 1.85-2.5 2.51-4.35 2.57-1.86.06-4.18-.12-5.02.36-.83.48-.9 1.67-1.73 2.5-.83.84-1.2 1.32-1.97 1.44l-.67.09c-.17-8.99 3.31-13 3.31-13l-9.73-11.42-1.5.7a2.72 2.72 0 0 0-.29-.44 7.46 7.46 0 0 1-1.72-5.18c.48.05 1.46.4 2.34.22.88-.17.22-1.06-.05-1.9-.26-.84-.53-3.76-.35-4.86l.26-1.55s1.42 1.55 2.3 1.55c.88 0 .8-.89.92-1.86.2-1.47.9-3.32 2.03-4.34 0 0 1.55 1.07 3.31 1.07a8.7 8.7 0 0 0 6.04-2.3c1.9-1.82 1.85-2.26 1.85-2.26s3.53 1.24 6.22 1.37c2.7.14 5.56-.3 6.93-3.14 1.36-2.83-.4-5.44-.7-5.88-.32-.44-1.2-.8-1.2 0s.05 2.92-1.59 3.98c-1.63 1.06-2.9 1.02-4.45.53a13.68 13.68 0 0 0-8.73-.23c.12-.11 2.13-2.18 4.1-2.78 2.03-.62 3.22.22 3.88 1.02s1.23 2.08 1.76.22a6.9 6.9 0 0 0-.66-5.35 5.05 5.05 0 0 0-4.76-2.04c-1.98.23-2.69.53-2.69.53s-1.01-2.87-3.57-3.4c-3.12-.65-6.56.52-9.26 2.03 0 0-2.12.5-4.28-.13a13.96 13.96 0 0 1-3.64-1.81l.73-2.35 1.27-.43c.64-.25.5-.46.59-1 .08-.54-1.22-1.48-1.22-1.48s-.18-1.61 1.94-2.72c2.13-1.11 1.9-.93 1.9-.93s1.25.24 1.76-.13c.5-.37.5-.6.5-.6s.94-.31 1.3-.88c.34-.57.4-1.39.15-2.05-.25-.66-.57-.8-.22-1.1.34-.32.66-1.08.69-1.61l.03-.67s.72-.25.7-1.35c-.04-1.1-.64-1.55-.99-1.65-.34-.09-.56-.09-.56-.09s-.06-.66-.63-1.54c-.57-.89-.94-1.27-.94-1.27s.4-.31.19-1.04a1.94 1.94 0 0 0-1.23-1.32c-.5-.16-1.04 0-1.04 0s-1.67-1.01-2.45-1.42l-.98-.5s-.03-.7-.31-1.08-.95-.54-1.3-.54-.71.2-.71.2-2.84-.73-4-.92c-1.16-.2-1.23-.29-1.23-.29s-2.51-1.2-3.49-1.38c-.97-.2-1.25-.29-1.25-.29s1.01-1.23 1.08-2.65a3.95 3.95 0 0 0-1.89-3.36c-.57-.33-.87-.39-1.06-.5l-.02-.98 1.9.19.15-3.04-1.84.23.28-1.83-3.86-.05.29 1.83-1.86-.12.16 3 1.95-.26-.19 1.14s-.71.12-1.32.56c-1 .6-1.86 1.77-1.8 3.2.07 1.41.92 2.67.92 2.67s-.25.07-1.23.25c-.97.2-3.49 1.4-3.49 1.4s-.06.09-1.23.28c-1.16.19-4 .91-4 .91s-.37-.19-.72-.19c-.34 0-1 .16-1.28.54-.29.38-.32 1.07-.32 1.07l-.97.5c-.8.42-2.46 1.43-2.46 1.43s-.53-.16-1.04 0c-.5.16-1 .6-1.22 1.32s.19 1.04.19 1.04-.38.38-.95 1.26c-.56.89-.63 1.55-.63 1.55s-.22 0-.56.1c-.35.09-.95.53-.98 1.64-.03 1.1.7 1.35.7 1.35l.03.66c.03.54.34 1.3.69 1.61.34.32.03.44-.22 1.1-.25.67-.2 1.49.15 2.06.35.56 1.3.87 1.3.87s0 .23.5.6 1.76.14 1.76.14-.23-.18 1.9.93c2.12 1.1 1.93 2.72 1.93 2.72s-1.3.94-1.21 1.48c.08.54-.06.75.59 1 .65.24 1.26.43 1.26.43l.73 2.35c-.8.54-2.22 1.4-3.63 1.81-2.16.62-4.28.13-4.28.13-2.7-1.5-6.14-2.68-9.26-2.03-2.56.53-3.58 3.4-3.58 3.4s-.7-.3-2.68-.53a5.06 5.06 0 0 0-4.77 2.04 6.9 6.9 0 0 0-.66 5.35c.53 1.86 1.1.57 1.76-.22.67-.8 1.86-1.64 3.89-1.02 1.97.6 3.98 2.66 4.1 2.78a13.68 13.68 0 0 0-8.73.23 4.67 4.67 0 0 1-4.46-.53c-1.63-1.06-1.59-3.19-1.59-3.98s-.88-.44-1.19 0-2.07 3.05-.7 5.88c1.36 2.83 4.23 3.27 6.92 3.14 2.7-.13 6.22-1.37 6.22-1.37s-.04.44 1.85 2.26c1.9 1.8 4.28 2.3 6.04 2.3s3.31-1.07 3.31-1.07c1.14 1.02 1.83 2.87 2.03 4.34.13.97.04 1.86.93 1.86.88 0 2.29-1.55 2.29-1.55s.09.44.26 1.55c.18 1.1-.08 4.02-.35 4.86-.26.84-.93 1.73-.04 1.9.88.18 1.85-.17 2.33-.22 0 2.12-.42 3.52-1.72 5.18l-.27.4c-.48-.2-.96-.43-1.44-.67l-9.73 11.44s3.5 4.02 3.3 13.06v-.07c-.17-.01-.4-.04-.7-.09-.78-.12-1.14-.6-1.97-1.43-.84-.84-.9-2.03-1.73-2.51s-3.17-.3-5.02-.36c-1.85-.06-4-.72-4.35-2.57-.36-1.85.06-2.69 2.44-4.24 2.4-1.56 4.18-3.29 4.3-6.7.12-3.4-2.09-5.61-6.03-10.16-3.94-4.54-5.73-8.66-6.26-9.74s-.78-.65-1.2.12c-.41.78-1.01 2.21-1.01 2.21s-1.31-.77-4.54-6.63a42 42 0 0 1-4.65-12.91c-.26-1.65-.9-.84-1.4-.4-2.62-7.46-2.47-16.66-3.2-23.8 0 0-2.6 2.54-4.1 7.52-1.38 4.57-1.33 9.94-.89 14.66.42 4.5 1.33 7.15 1.77 8.36.66 1.79-.3.71-.3.71s-2.26-3.94-3.81-11.41c-1.56-7.47-1.38-12.67-1.38-12.67s-.9.74-1.96 2.84c-1.05 2.1-2.1 6.3-1.73 13.92.37 7.62 3.2 15.66 4.68 18.39 1.47 2.73.1 1.1-.43.31a47.3 47.3 0 0 1-4.46-8.5c-1.31-3.63-3.73-11.09-3.89-12.25-.16-1.15-.63-.42-1.1.58-.47 1-1.52 4.36-1.47 6.78a34.3 34.3 0 0 0 2.05 10.82c1.57 4.2 4.62 8.46 6.09 10.3 1.47 1.83.31.89-.37.36s.05.1-3-3.15-6.82-10.82-7.35-11.97c-.52-1.16-1.05.1-1.1.73-.05.63-.47 4.3 1.84 10.56 2.31 6.25 7.98 11.08 10.98 13.13 3 2.05.84 1.05-.69.16-1.52-.9-4.57-3-6.46-4.57-1.89-1.58-5.25-5.73-6.2-6.46-.94-.74-1.15-.95-1.1 2s2.58 7.72 5.77 10.92c3.2 3.2 7.33 4.65 8.6 5.15 1.27.5.21.27-1.1-.1a26.8 26.8 0 0 1-6-2.35c-2.42-1.35-5.98-4.15-7.17-5.08-1.19-.92-1.03.35-.66 1.96.37 1.61 1.26 4.6 5.85 8.32 4.6 3.73 11.11 5.63 12.99 6.16 1.87.53.55.53.55.53s-.74-.1-4.54-.95-9.55-3.86-11.1-4.84c-1.56-.98-1.8-1.35-1.59.71.21 2.06 2.4 6.48 5.91 8.54s9.84 3.12 11.48 3.2c1.63.08 1.21.31.47.37-.74.05-2.56.05-5.54-.3-2.44-.28-6.07-1.46-7.3-1.88-.14-.53-.27-1.04-.33-1.35-.14-.79-.55-.67-.8-.5-.27.18-.42.32-1.28.76-.88.44-.9-.09-.93-.35-.03-.26-.2-1.4-.24-1.98-.03-.58-.35-.61-.75-.44l-3.08 1.32c-.72.32-.06.9.32 1.6.38.7.96 1.71.96 1.71l-2.41.65c-.58.14-.4.55-.26.96.14.4 1.04 2.44 1.28 3.02s.75.24.75.24l1.83-1.08.64 2.44c-.03.04-.85.2-1.77.85-.93.65-.7 1.48.41 1.8 1.11.33 2.4.89 3.84 3.48 1.43 2.6 1.8 7.28 2.68 14.65.88 7.36 5.59 11.12 6.24 11.58s.27.84.27.84-.64.93-.37 2.36a3.55 3.55 0 0 0 2.17 2.5c.65.24.47.89.47.89s-.33 1.57 0 4.45c.32 2.87 2.68 6.11 3.32 6.67.65.55.7.83.6 1.07-.09.23-.5.04-1.29.64a8.15 8.15 0 0 0-2.22 2.46c-.55 1.02-.37 1.62-.18 3.01.18 1.4 2.22 2.65 2.22 2.65s-.37.09-.47 1.1c-.09 1.03.65 2.19 1.58 2.93.92.74 2.68 1.1 2.68 1.1l.23 1.5c.09.6 1.24 1.2 1.98 1.61.74.42 2.17.19 2.78-.09.6-.28 1.01.05 1.38.65.37.6.23 2.92.23 3.85 0 .92-.55 1.9-.23 2.36.32.46 1.2.14 2.08-.37.88-.51 1.11-.14 1.9.37a6 6 0 0 0 2.35.93c.33-.05.19-.88.19-1.58s.12-2.27.45-2.5c.15-.1 1.5-.21 2.55-.65.49-.2 1.11-.42 1.16-.88.04-.46-.65-.46-2.18-1.25-1.52-.79-1.8-1.25-2.77-1.9-.97-.65-.5-.88-.5-1.16 0-.28.46-.6.64-.97s.1-1.2.1-1.2.78-.8 1.15-1.21c.37-.42.83-1.07 1.34-1.49s1.3-2.4 1.8-3.06c.5-.64 1.66-1.34 2.36-2.22.69-.88 2.54-2.32 3.6-3.01 1.06-.7 3.93-2.04 3.93-2.04s-.05 1.71.7 2.55c.73.83 1.7-.65 4.98-2.97 3.28-2.32 5.78-3.15 5.78-3.15s.69 1.06 1.57 2.18c.87 1.1 1.66-.05 5.68-5.61a72.84 72.84 0 0 1 8.97-9.9l.9.4c-.09.22-.17.46-.25.72-.37 1.16-.97 1.9-1.75 3.5-.79 1.62-1.98 1.98-3.36 4.15-1.39 2.16-1.57 3.64-1.7 5.85-.15 2.2 1.1 2.67 1.1 2.67s-2.03 1.98-2.63 3.45c-.6 1.47-.92 4.47-.92 4.47s-.32.13-1.06 1.65c-.74 1.53-2.07 1.75-4 3.69-1.94 1.93-4.1 2.76-5.12 3.36-1 .6-.73 1.2-.46 1.98.28.78 1.66 1.56 3.27 2.16 1.62.6 2.17.37 3.27.32 1.1-.04.23.83-.23 1.3-.46.45-1.06 2.06-.96 3.86.09 1.8 1.42 1.38 3.08 1.1 1.66-.27 3.6-1.1 3.6-1.1l-.19.5c-.18.51-.28.88-.28 2.31 0 1.43.23 2.12.65 2.49.41.36 1.24-.42 1.84-.6.6-.19 1.61-.78 3.09-1.1 1.47-.33 2.02-.97 2.02-.97s-.37.46-.46 1.47c-.1 1.01-.05 2.53.19 3.4.22.88.87 1.94 1.88 2.86 1.02.92 1.25.5 1.98-.64.74-1.15 2.26-2.63 2.26-2.63s.09.37 1.1 3.64c1.02 3.27 4.33 5.99 4.33 5.99s3.32-2.72 4.33-6c1.01-3.26 1.1-3.63 1.1-3.63s1.52 1.48 2.26 2.63c.74 1.15.97 1.56 1.98.64a6.29 6.29 0 0 0 1.89-2.85c.23-.88.27-2.4.18-3.41-.09-1.01-.46-1.47-.46-1.47s.55.64 2.03.96c1.47.33 2.48.92 3.08 1.1.6.2 1.43.97 1.84.6.42-.36.65-1.05.65-2.48s-.1-1.8-.28-2.3l-.18-.51s1.93.83 3.6 1.1 2.98.7 3.08-1.1c.09-1.8-.51-3.4-.97-3.87-.46-.46-1.34-1.33-.23-1.29 1.1.05 1.66.28 3.27-.32 1.6-.6 3-1.38 3.27-2.16.27-.78.55-1.38-.46-1.98-1.02-.6-3.18-1.43-5.11-3.36-1.94-1.94-3.27-2.16-4.01-3.69-.74-1.52-1.06-1.65-1.06-1.65s-.32-3-.92-4.47c-.6-1.47-2.62-3.45-2.62-3.45s1.24-.46 1.1-2.67c-.14-2.21-.32-3.69-1.7-5.85-1.38-2.17-2.58-2.53-3.37-4.15-.78-1.6-1.38-2.34-1.74-3.5a21.1 21.1 0 0 0-.24-.7l1.19-.51a72.7 72.7 0 0 1 8.99 9.9c4.02 5.57 4.8 6.73 5.68 5.62.88-1.11 1.57-2.18 1.57-2.18s2.5.83 5.78 3.15c3.28 2.32 4.25 3.8 4.99 2.97.39-.44.47-1.17.52-1.73a69.7 69.7 0 0 1 7.84 2.78c2.85 1.2 3.16 1.83 5.42 3.61s5.48 1.62 8.53.69c3.04-.93 11.16-3.6 14.42-5.02 3.25-1.4 5.58-2.64 5.92-3.3.34-.65.72-2.47.72-3.12 0-.65-.72-1.62-.96-1.79-.24-.17-.13-.69-.07-1.1a3.45 3.45 0 0 0-.65-2.2c-.5-.55-.44-.75-.37-2.33.14-3.36-2.25-7.58-5.64-8.93 0 0-.09-.39-.36-.62-.28-.22-.73-.43-.73-.43s.06-1.93.04-2.34c-.02-.41.16-.37.4-.25.22.11.58.57 1.13.7.55.15.9-.25 1.01-.86.11-.62.57-1.86.78-2.48.2-.62-.05-.71-.3-.78-.25-.07-1.07-.16-1.46-.25-.4-.1-.4-.12-.3-.32.1-.21.23-.53.73-1.31s.05-.8-.44-.96c-.48-.17-2.65-.83-3.24-.92-.6-.1-.73.4-.73.66s.02 1.36.04 1.77-.36.3-.6.18a8.45 8.45 0 0 1-1.16-.76c-.41-.32-.7-.02-.87.44-.16.46-.66 2.34-.82 2.9-.16.54-.12.98.11 1.07.23.1 1.3 0 1.95 0 .64 0 .27.37.27.37s-.69 1.12-.91 1.56c-.23.43-.62.5-1.15.5h-1.4s-3.52.13-6.1 2.05c-2.6 1.92-3.32 3.52-3.72 4.44-.4.93-.86.73-1.26 1.06-.4.34-1.52 1.53-1.52 2.26 0 .73.26 1.13-.87 1.86-1.12.73-2.05 3.9-.53 5.57 1.53 1.65 2.13 3.3 2.6 4.1.45.8 0 1.13-.4 1.13s-1.24-.67-1.93-1.2c-.7-.5-4.2-3.24-5.7-4.37-1.5-1.12-.4-1-.4-1s.38.04 1.26-.33 1.02-.83.14-1.1a11.14 11.14 0 0 1-3.05-1.72c-.46-.47-.7-.98.19-1.44.87-.46 2.81-1.71 1.29-2.13-1.53-.42-3.33-.74-4.8-1.16-1.49-.42-1.63-.83-1.63-.83l.98-1.4s.78-1.1-.14-1.25-3.14-.41-5.18-1.3c-4.06-1.75-6.6-4.74-7.55-8.38l.07-.09c.76 1.5 2.53 4.3 5.19 4.4 3.64.12 4.06-1.02 3.22-2.22s-1.79-2.27-2.03-2.62c-.24-.36-.3-.84.66.06s2.77 3.94 8.26 3.58c5.5-.36 5.46-1.43 5.46-1.73 0-1.06-1.11-1.22-1.77-1.88-.35-.35-.56-.85.55-.43s3.83.93 7.52.13c1.46-.3 5.33-2 5.7-3.96 0 0-2.45-.13-4.17-.87-1.71-.74-2.74-1.35-.92-.98 1.82.37 5.36 1.11 8.47.06 1.82-.62 4.17-2.1 4.17-4.79 0 0-3.38-.71-4.62-1.16-1.24-.45-1.64-.8-1.64-.8s4.83 1.54 9.21-.68c4.38-2.22 4.57-5.26 4.57-5.97s-.1-.93-.1-.93-4 .98-6.97.95c-2.99-.02-3.9-.29-3.9-.29s8.33-.23 12.52-2.8c4.2-2.56 4.44-7.6 4.44-7.6s-4.75 1.68-7.73 2.03c-2.98.34-4.8.34-5.54.29-.74-.06-1.16-.3.47-.37 1.64-.08 7.97-1.14 11.48-3.2 3.5-2.06 5.7-6.48 5.91-8.53.21-2.07-.03-1.7-1.58-.72-1.56.98-7.31 4-11.11 4.84-3.8.84-4.54.95-4.54.95s-1.46-.07.42-.6zm-150.1 9.58l-1.68.96s-.67-1.37-.85-1.77c-.17-.41-.08-.59.15-.59.23 0 .93-.2 1.48-.26.08 0 .15-.02.21-.03.19.52.43 1.09.75 1.66l-.06.04zm51.18 29.97c-1.02 1.9-3.79 3.9-5.82 4.78s-4.25 1.15-5.18 1.3c-.92.13-.14 1.24-.14 1.24l.97 1.4s-.13.41-1.61.83-3.28.74-4.8 1.16c-1.53.41.4 1.67 1.28 2.13.88.46.65.97.19 1.44-.46.46-2.17 1.43-3.05 1.71s-.74.75.14 1.12c.88.36 3.28.83 3.28.83s-.05.1-1.52 1.2a12.1 12.1 0 0 1-5.78 1.95c-1.71.1-4.41.2-7.84.05-3.43-.16-3.82-.24-3.82-.24s-.12-1.14-.36-2.84c-.23-1.69-1.26-4.1-2.05-5.2-.78-1.1-2.44-3.3-2.44-3.3s.04-.48.16-1.03.04-1.14-.36-2.18c-.4-1.05-2.4-2.57-2.4-2.57s-.09-1.12-.09-2.16-.72-5.13-1.36-7.05c-.64-1.92-3.76-6.97-5.2-9.37-1.45-2.4-2.3-5.96-2.74-8.73-.43-2.76-.26-3.67-.11-4.4.06-.31.2-.6.32-.86a8.6 8.6 0 0 0 2.32 2.08c4.2 2.56 12.54 2.8 12.54 2.8s-.93.27-3.9.3c-2.99.02-6.97-.96-6.97-.96s-.11.21-.11.93.19 3.75 4.56 5.97c4.38 2.22 9.21.69 9.21.69s-.4.34-1.63.79c-1.24.45-4.62 1.16-4.62 1.16 0 2.7 2.35 4.17 4.17 4.78 3.11 1.06 6.65.32 8.47-.05 1.82-.37.8.24-.93.98-1.7.74-4.16.87-4.16.87.37 1.96 4.24 3.65 5.7 3.96 3.69.8 6.4.3 7.52-.13s.9.08.55.42c-.66.67-1.78.83-1.78 1.89 0 .3-.03 1.37 5.46 1.73s7.31-2.69 8.27-3.59c.95-.9.9-.42.65-.06-.23.36-1.19 1.44-2.02 2.63-.84 1.2-.42 2.33 3.22 2.21 2.68-.08 4.45-2.93 5.2-4.42l.05.07.15.2c-.34.88-.93 2.32-1.58 3.54zM335 78.19c-.5-.94-.76-1.39-.76-1.39s2.07.97 3.3 2.36c1.23 1.4 1.2 2.13 1.39 2.81.18.69 0 1.94-.19 3.13-.18 1.18-.18 1.89.06 2.3.23.43.44.64.44.64s-.92.23-1.78.57c-.86.35-1.99.66-2.62.14-.63-.53-.78-.9-.39-1.24.4-.34 1.86-.76 2.04-3.28.18-2.52-.99-5.1-1.49-6.04zm-11.28 6.86c.47-1.2.67-2.34.3-4.8-.3-2.06-.7-3.82-.8-6.04 0 0 1.53.33 3.72 2.34 2.2 2 2.7 4.07 2.7 5.07s-.53 2.23-.61 3.2c-.09.98.27 1.85.27 1.85s-.8.33-1.52.83c-.73.5-1.23.8-2.34.75-1.1-.05-1.78-.55-2.42-.89s-1.05-.39-1.05-.39 1.27-.72 1.74-1.92zm-10.7-8.5c2.2-2 3.72-2.34 3.72-2.34-.1 2.22-.5 3.98-.8 6.05-.36 2.45-.17 3.59.3 4.79.48 1.2 1.75 1.92 1.75 1.92s-.41.06-1.05.39c-.64.33-1.3.84-2.42.9-1.11.05-1.61-.26-2.33-.76-.73-.5-1.53-.83-1.53-.83s.36-.87.27-1.84c-.08-.98-.6-2.2-.6-3.2 0-1.01.5-3.07 2.7-5.08zm-7.91 12.2c-.63.52-1.75.2-2.62-.13-.86-.35-1.78-.58-1.78-.58s.21-.21.45-.63c.23-.42.23-1.13.05-2.31-.18-1.19-.37-2.44-.18-3.13.18-.68.15-1.42 1.38-2.8 1.23-1.4 3.3-2.37 3.3-2.37s-.26.45-.76 1.39c-.5.95-1.67 3.52-1.49 6.04.18 2.52 1.65 2.94 2.04 3.28.4.34.23.71-.4 1.24zm29.24 21.07c-2.16 1.2-3.4.93-3.3 1.82.08.88 2.02 1.55 2.02 1.55s-1.98 2.12-3.53 3.1c-1.54.97-3.35 1.59-3.35 1.59s-.62.08-.27 1.06c.36.97.97 1.63 1.46 1.9.48.26.75.35.75.35s-2.69 2.88-3.88 3.8c-1.2.94-1.85 1.25-2.82 1.64-.97.4-.49 2-.27 2.7.22.7 1.06 1.68 1.55 1.82.48.13.66.48.04 1.46-.46.72-2 2.65-2.74 3.72l-.04.02c-.73-1.06-2.29-3.01-2.75-3.74-.62-.98-.44-1.33.04-1.46s1.32-1.11 1.54-1.82c.22-.7.71-2.3-.26-2.7-.97-.4-1.63-.7-2.82-1.63-1.2-.93-3.88-3.8-3.88-3.8s.26-.1.75-.36a3.6 3.6 0 0 0 1.45-1.9c.35-.98-.26-1.06-.26-1.06s-1.81-.62-3.36-1.6c-1.54-.97-3.52-3.1-3.52-3.1s1.94-.66 2.03-1.54c.08-.89-1.15-.62-3.31-1.82s-2.87-2.7-2.87-2.7 2.51-.83 3.75-3.36c.44-.89.54-1.7.5-2.39l.1.04c4 1.3 8.7 1.83 12.9 1.83 4.18 0 8.87-.53 12.87-1.83l.1-.04c-.05.69.06 1.5.5 2.4 1.23 2.52 3.74 3.36 3.74 3.36s-.7 1.5-2.86 2.7z'/%3e%3cpath fill='%23D4AF3A' d='M347.47 158.5c0-6.79 3.12-11.08 3.12-11.08l-8.5-9.73c-8.08 3.13-15.5 3.32-22.09-.04-6.6 3.36-14 3.17-22.1.04l-8.5 9.73s3.13 4.3 3.13 11.08c0 6.79-1.31 11.82-2.08 15.1-.76 3.29-1.42 9.41.33 13.8 1.75 4.37 3.61 8.2 11.16 11.37s11.5 4.82 14.12 7c2.63 2.2 3.94 3.95 3.94 3.95s1.31-1.76 3.94-3.94c2.63-2.2 6.57-3.83 14.12-7 7.55-3.18 9.4-7.01 11.16-11.39 1.75-4.38 1.1-10.5.33-13.79-.76-3.28-2.07-8.3-2.07-15.1z'/%3e%3cpath fill='%23B96B29' d='M344.8 161.3c-1.06-6.48 2.67-12.19 2.67-12.19l-7.27-8.5c-5.6 3.15-13.4 2.72-20.17-.4-6.78 3.12-14.58 3.55-20.18.4l-7.27 8.5s3.74 5.7 2.67 12.19c-1.07 6.48-3.36 16.74-2.79 20.92.58 4.18 3.53 9.02 6.57 11.57s7.54 4.67 10.74 5.82a30.98 30.98 0 0 1 7.8 4.51c1.47 1.15 2.46 2.14 2.46 2.14s.98-.99 2.46-2.14 4.6-3.36 7.79-4.5c3.2-1.16 7.71-3.3 10.75-5.83 3.03-2.55 5.98-7.39 6.56-11.57.57-4.2-1.73-14.45-2.8-20.93z'/%3e%3cpath fill='%231D5E91' d='M344.1 162.07c-1.05-7 2.1-12.63 2.1-12.63l-6.56-7.31c-5.55 2.85-12.29 2.11-19.63-.44-7.35 2.55-14.09 3.29-19.64.44l-6.56 7.3s3.16 5.64 2.1 12.64-2.66 14.92-2.35 19.57c.02.32.06.64.1.97h5.98s.35-.4 1.01-.69c.67-.28.86-.47.86-.47s.12-1.21.85-1.46c.73-.26 1.05-.26 1.33-.26s.5-.06.86-.41c.35-.35 1.3-1.2 1.7-2.42s.67-1.68.67-2.47c0-.8.29-2.07.29-2.07s-.16-.38-.76-.15c-.6.22-.7-.39-.76-.99-.07-.6-.03-1.84.31-2.41s.48-.77.48-.77l-.25-.95s-3.8.76-4.47-2.19c-.66-2.95-.79-4.38-.88-4.7-.1-.32-.2-.48-.7-.44-.5.03-1.59-.32-2.35-1.85-.76-1.52-.82-2.15-.6-2.76.22-.6.64-.38.76-.19.13.2 1.14 1.65 1.55 1.24.42-.41.2-.41-.38-1.56s-.38-1.52-.31-2.1c.06-.56-.2-1.33-.2-1.64 0-.32.36-.58.7-.42.35.16.67.42.83.6.16.2.22.48.54.3s.12-1.25.12-1.6c0-.34.41-.6.92-.31.5.28.76.82.76 1.2 0 .39.03.73.22.73s.41-.57.45-.95c.03-.38.25-.95.6-.47.35.47.47 1.17.35 1.9-.13.73.12.35-.13 1.62s-.38 1.84-.35 2.8c.03.95.06 1.49.54 2.66.47 1.18.85 2.54 1.74 2.57l1.14.04s.98-1.9 1.74-2.35c.76-.45 1.84-.51 2.6-.6.76-.1 1.07-.33 1.07-.52s-.25-.25-1.17-.38c-.91-.12-1.67-.35-1.7-1.05-.04-.7.15-1.3-.45-1.33-.6-.03-2.09-.51-2.63-1.5-.53-.98-.4-1.2-.34-1.74s.76-1.62 1.2-.6.73 1.14 1.1 1.36c.39.23.9.29.64-.41-.25-.7-.41-1.14-.35-1.65.07-.5.41-.73.83-.83.4-.1 1.64-.47 2.28-.6.63-.13.66-.19.66-.19s.06-.44.89-.7a5.96 5.96 0 0 1 1.96-.28c.6 0 1.04.1 1.84-.29.79-.38 1.42-.44 1.93-.41.5.03.88.22 1.26.47.38.26.26.6.26.96 0 .35.06.54.6.54s1.01 0 1.52.19c.5.19 1.2.47.76 1.01-.44.54-.47 1.15-.76 1.12-.28-.04-.25.28-.38.47-.13.2-.22.35.1.54.31.2.34.38.79.8.44.4 1.1.85.44 1.52-.66.67-1.84 1.2-1.84 1.2s-.66.32.1.77c.76.44 1.1 1.37 1.4 1.52.28.16.56.42.75.51.2.1.16.73.16.73s-.41.29-.98.51c-.57.22-1.17.48-1.71.48s-.82 0-.6.5c.22.51.6 1.05.7 1.34.09.28.22.8.22.8s.88.18 1.67.18c.8 0 1.14.03 2.88-.16 1.75-.18 2.25-.25 3.93-.06 1.68.2 1.93.13 2.38.29.44.16.88.38.88.38s2.38-.03 3.68-.32c1.3-.28 1.61-1.11 1.42-1.55-.19-.45-.16-1.12-2.44-1.43-2.28-.32-3.2-.2-5-.55-1.8-.34-4.62-1.27-5.13-3.52-.5-2.25 1.33-3.2 2.25-3.65.92-.45 2.91-1.14 3.83-1.52.92-.39 2.6-.77 4.37-.51 1.77.25 2.79.73 3.48.31.7-.4 1.27-.1 1.14.54-.12.64-.82 1.94-2.82 2.54-1.99.6-4.4.67-5.7.32-1.3-.35-2.27-.86-3.06-.57-.8.29-1.68 1.27-.83 2.44.86 1.18 5.23 1.53 6.4 1.66 1.17.12 5.5-.2 6.74 1.96 1.24 2.17.25 4.58-1.2 5.12-1.46.54-2.7.89-3.8 1.05l-1.1.15s.5 1.15.5 1.63c0 .47-.07 1.36.47 1.7.54.36 1.3.61 2.22.52.92-.1 2.03.54 2.09 1.36.06.83.32 1.97.41 3.62.1 1.65 0 3.02 0 3.02s-.06.64-.28 1.24c-.23.6-1.37 2.94-1.37 2.94h6.38c.05-.33.08-.65.1-.97.26-4.71-1.35-12.63-2.4-19.63z'/%3e%3cpath fill='%236D8C3E' d='M294.42 185.72a18.27 18.27 0 0 0 7.75 9.55c5.45 3.28 7.8 2.85 12.94 6.2 5.14 3.34 4.83 3.9 4.9 3.9s-.25-.57 4.89-3.9c5.14-3.35 7.5-2.92 12.94-6.2a18.25 18.25 0 0 0 7.75-9.55h-51.16z'/%3e%3cpath fill='%23D4AF3A' d='M298.88 158.13c.58.61 1.02.8 1.91.71.9-.1 1.1.56 1.26 1.26.16.71.16 2.38.8 3.92.65 1.54 2.8 1.63 2.8 1.63a9.6 9.6 0 0 1 .65-2.56c.06-.14.34-.83-.43-.83s-.74-.31-1.2-1.05a14.44 14.44 0 0 1-1.57-3.97c-.21-1.27.19-3.14.4-3.82.22-.68.25-1.14 0-1.26-.25-.13-.74 0-.74 0s.19.58-.03.67c-.22.1-.4-.3-.55-.74-.16-.43-.34-.37-.65-.34-.3.04-.3.31-.1.62.22.3.1.86.1.86s-.68-.49-.95-.61c-.28-.13-.93.12-1 .49-.05.37.26 1.32.84 1.82.59.49.59 1.5.4 1.97-.18.46-1.05.4-1.23.18a.53.53 0 0 0-.8 0c-.25.28-.5.44.09 1.05zM298.54 156.5s-.34-.28-.46-.43l-.37-.5s-.06.16-.06.53.4.77.4.77l.49-.37zM299.83 152.22c.28-.12.5-.19.28-.5-.22-.3-.4-.64-.62-.7-.22-.06-.4-.03-.4-.03s.25.55.3.9c.07.33.17.45.44.33zM301.44 150.92c-.03.28.03.4.28.28.24-.13.34-.47.21-.71-.12-.25-.4-.43-.4-.43l-.18-.13c-.02 0 .1.71.08.98zM303.74 151.29c.03-.3-.1-.65-.1-.65s0 .37-.15.59c-.15.22-.12.15.03.34.15.19.18.03.21-.28zM307.36 166.95c.45 1.05 1.6-.6 2.65-1.93 1.04-1.32 1.01-.3.87.77a5.1 5.1 0 0 0 .7 2.98c.42.73.77.31.94-.21.17-.52.31-1.6.66-2.13s.7-.07.73.38.6 1.47 1.12 2.06c.52.6.77-.2.94-.94s.38-1.85.52-2.31c.14-.45.63-.07.63-.07l1.05 1.01c.7.67.76-.38.83-.9.07-.53-.1-1.68.1-1.86.22-.17.8.25 1.72.7.9.46.87-.42.76-.9-.1-.5-.62-1.62-1.36-2.24-.73-.63-.83-1.37-.59-1.68.25-.32 1.12-.04 1.67-.1.56-.08.84-.15 1.26-.22.42-.07.42-.49.42-.49s-.32-.52-.9-1.05c-.6-.52-.95-.94-1.68-1.12-.73-.17-1.74 0-1.74 0l-.1-.2c-.11-.21-.32-.21-.46 0-.14.2-.49.48-.77.73-.28.24-.45.38-.63.28-.17-.1.14-.35.14-.35s.39-.28.74-.98c.34-.7.45-1.37.17-1.68-.28-.32-1.05 0-1.46 0-.42 0-.67.07-.7-.14-.04-.21.42-.1.94-.18.52-.07.84-.7 1.01-1.22s.31-.46.63-.14c.31.31.6.24.66.03.07-.2.35-.73.7-1.26.35-.52.56-1.25.17-1.74-.38-.5-1.32-.42-1.7-.1-.39.3-.63.62-.74 1.4-.1.76-.31.34-.31.1s-.32-.64-.18-.95c.14-.31 0-.66 0-.66s-.07-.67-.8-.8-1.57.03-2.3.2-.6.8-.6.8-.55.04-1.14.11c-.6.07-1.3.32-1.85.46-.56.14-.77.2-.77.48 0 .29.1.74.1.74s.46 0 .7.14c.25.14.1.38-.17.49-.28.1-.39.14-.39.49s.14.42.42.42.87 0 1.57.31c.7.32.87.95.8 1.3-.07.35-1.04.8-1.53.8s-.63.1-.63.42c0 .32.6.28.6.28s.59.04 1.74.17c1.15.15 1.32.39 1.85.84.52.46.14.56-.1.7-.25.14-.64.46-1.02.6-.38.14-.63.42-.98.49s-1.22.03-2.82.66c-1.6.63-2.16 2.73-2.16 2.73s.2-.07.94-.45c.73-.39 1.64-.8 2.47-1.33.84-.53.84.24.42.98-.42.73.39.59.63.38.24-.21.56-.42 1.36-.84s.52.25.52.25-.24.49-.31 1.64c-.07 1.16 1.15.07 1.7-.66s.81 0 .4.84c-.43.84-1.23 1.5-1.68 1.5-.46 0-.8-.49-.84-.77s.14-1.12-.14-1.33c-.28-.2-1.08.04-1.67.39-.6.35-.74.07-.87-.25-.14-.31.2-.42.07-.63-.14-.2-.46 0-.7.1-.25.11-.8.43-1.88.99-1.09.55-1.02.87-1.02 1.67s.2 1 .65 2.04z'/%3e%3cpath fill='%23D4AF3A' d='M317.82 149.44c.23-.14.64-.3.64-.3s.51-.13.99-.2c.47-.06.39-.33.28-.55-.1-.23-.28-.31-.9-.31s-1.01.31-1.36.45c-.35.15-.76.25-.76.25l.3.43c.23.35.58.4.8.24zM320.34 151.94c.25 0 .52-.14.52-.14s.45-.23.86-.38c.41-.14.58-.2.82-.7.25-.49-.27-.49-.99-.67-.72-.2-1.07.06-1.15.32-.08.27-.06.58-.35 1.1-.29.5.04.47.3.47zM320.11 152.57c-.7 0-1.48 1.05-1.77 1.24s-.12.37-.12.37.2.43.28.84c.09.41.1 1.11.1 1.11s.11.04.52.04c.41 0 .66-.2 1.05-.5s.7-.38 1.26-.49c.55-.1.82-.2 1.44-.53s-.33-.9-.99-1.44a2.46 2.46 0 0 0-1.77-.62zM310.8 154.99c.55-.06.8-.34.8-.65s-.28-.64-.99-.58c-1.73.15-3.41-.47-3.72-2.19 0 0-.59 1.08.5 2.28 1.08 1.2 2.86 1.2 3.42 1.14zM304.89 182.31c.09.15.2.25.3.3h2.66c.46-.12.46-.54.48-.83.03-.34.3-1.31.66-3.08.37-1.77 1-3.03 1.26-3.74s-.26-.95-.45-1.4c-.18-.44-.47-1.23-.55-1.63-.08-.4-.7-.34-1.05-.32s-.4.58-.45 1.11c-.05.53-.29 2.08-.55 3.42-.26 1.35-1.78 3.14-2.2 3.54-.43.4-.77.55-1.06.55s-.91 0-1.23.18c-.31.19-.63.69-.66 1.08-.02.4.6.61.6.61s.5-.29.7-.53c.17-.23.6-.29 1.01-.36.42-.08.48.07.32.28-.16.2-.11.25.21.81zM300.82 182.17c-.2.07-.35.27-.44.44h1.74a.93.93 0 0 0-.17-.44c-.21-.26-.77-.13-1.13 0z'/%3e%3cpath fill='%23D4AF3A' d='M303.18 182.12c-.21.12-.47.3-.6.49h1.87c.07-.18.09-.4-.14-.6-.42-.34-.84-.05-1.13.1zM319.4 181.35c-.2 0-.39.18-.68.39-.3.2-.38.52-.43.77l.01.1h.8a.14.14 0 0 0 .05-.1c0-.23.1-.44.43-.73.35-.3.03-.43-.17-.43zM320.96 182.21c0-.25-.1-.47-.27-.45s-.48.34-.72.52c-.14.1-.24.23-.32.33h1.17c.07-.14.14-.29.14-.4z'/%3e%3cpath fill='%23D4AF3A' d='M328.18 173.58c.56-.4.47-.52.5-.95.02-.43.02-.57-.2-.72-.23-.16-1.07-.53-1.86-.53s-2.28.19-2.84.57c-.57.39-.84 1.77-.84 2.49s.11.84.32.84.54-.52.54-.52.74.97 1.2 1.65c.45.68.24.95.04 1.47-.2.52-.95 1.9-1.53 2.2-.6.3-1.04.02-1.74-.1-.7-.1-1.09.1-1.5.5s-.01.73.23.73c.25 0 .6-.02.86.32.19.23.06.77-.03 1.08h3.46c.59-.26 1-1.07 1.15-1.52.18-.5.93-1.15 1.3-1.49.35-.34.4-.56.4-1.31s-.2-1.18-.48-1.7a3.1 3.1 0 0 1-.38-1.7c.06-.46.8-.93 1.37-1.34z'/%3e%3cpath fill='%23D4AF3A' d='M322.49 164.95c.35.56.17.67-.32.78-.5.1-1.04.19-1.81.13-.78-.07-.76.04-.78.43a3.4 3.4 0 0 1-.54 1.8c-.45.61-1.01.38-1.36.14s-.54-.18-.67.26-.36.73-.73 1.38c-.37.64-.6.67-.86.6s-.5-.45-.76-.47-.67-.54-1.05-1.17c-.4-.62-.59.07-.84.6-.26.54-.52.93-1.02.87-.5-.07-1.05-1-1.33-1.56s-.46-1.1-.89-1.07c-.43.02-1.14.92-1.62 1.16-.47.24-.6.15-.81-.15-.22-.3-.5.1-.78.82-.28.71.02 1.31.4 1.5.4.2 1.17-.36 1.7-.7.5-.35.75-.26 1.29-.26.53 0 .5.88.73 2.18.24 1.29.99 1.46.99 1.46s.26.22.84-.77c.58-1 .65-1.97 1.2-1.97.57 0 .61.13 1.17.91.56.78 1.04 1.36 1.36.78.32-.59.6-1.45.97-1.75.37-.3.71-.39.33.17-.4.56-.57 1.17.23.93s3.84-1.47 5.07-1.7c0 0 1.44-.24 3.1-.33 1.66-.08 2.07-.2 2.72-.2.65 0 .67-.06.71-.49.05-.43-.3-.34-1.5-.34-1.21 0-2.06.15-2.9.28-.84.13-1.22.1-1.08-.1.16-.23.4-.38 1.36-.53a39.7 39.7 0 0 1 4-.28c1.03-.02.7.3.62 1-.09.68.08 1.7.15 2.35.06.64.08.84.65 1.74s2.5 1.47 3.06 1.77c.56.3.47 0 .45-.54-.02-.54.43-.52.93-.24.5.29 1.31.52 1.9.67.58.15.66.26.66.56s.07.97.13 1.6c.07.63.05.82-.21 1.2s-1.36 1.52-1.36 1.52-.5 0-1.55.26c-1.06.26-1.39.75-1.5 1.18s.2.56.25.74c.02.1 0 .32 0 .51h.24c.09-.15.22-.35.38-.56.37-.47 1.3-.58 1.9-.3.4.18.4.6.36.86h2.41a86.8 86.8 0 0 0 1.3-2.59c.26-.58.41-.94.43-1.74s.11-3.88-.04-4.06c-.15-.17.04-.69 0-1.55-.04-.86 0-1.5-1.6-1.66-1.6-.15-2.09-.82-2.63-1.36-.54-.54-.4-1.79-.84-3.3-.43-1.5-1.48-1.74-3.36-2.11-1.88-.37-3.26-.4-4.66-.28s-3.14.32-4.12.24c-.95-.12-.8.16-.45.72z'/%3e%3cpath fill='%23D4AF3A' d='M331.55 182.27c-.16.1-.27.23-.35.34h1.63c.01-.14-.01-.3-.16-.47-.24-.3-.72-.13-1.12.13zM334.47 182.16c-.27.13-.44.3-.54.45h1.65v-.19c-.06-.26-.56-.54-1.1-.26zM293.75 183.19c.1.51.21 1.03.36 1.55h51.79c.14-.52.27-1.04.36-1.55h-52.51zM328.65 158.45c1.64 1.09 6.83 1.15 9.27 1.64 2.44.48 2.27 2.35 1.52 3.32-.75.98-4.18 1.1-4.8 1.18.34.23.84.95.84.95l1.4-.12c1.04-.08 2.85-.34 4.08-1.38 1.24-1.03 1.15-2.7.06-3.81-1.1-1.12-2.9-1.23-4.74-1.44-1.83-.2-3.27-.34-5.33-.68-2.07-.35-3.07-1.18-3.07-2.39 0-1.2 1.12-1.83 1.92-2.06.8-.23 2.1-.57 3.24-.15 1.15.43 2.5.5 4.77.2 2.26-.28 2.78-1.86 2.78-1.86s-.29.14-1.44.17c-1.14.03-1.98-.49-4.07-.52-2.1-.02-2.84.72-3.82 1.07-.97.34-3.58.6-4.36 2.3-.77 1.7.12 2.5 1.76 3.58z'/%3e%3cellipse rx='.98' ry='.96' cy='150.64' cx='315.04' fill='%23B96B29'/%3e%3cpath fill='%23B96B29' d='M336.02 152.28c-1.3-.11-2.99.23-2.99.23s.32.26.75.23 1.2-.06 2.47.17c1.26.23 2.18-.37 2.18-.37s-1.12-.14-2.41-.26z'/%3e%3cpath fill='%231D5E91' d='M323.74 176.38c-.32-.5-.4-.45-.77-.14-.36.32-.72-.77-.77-1.44-.04-.68.27-2.76.27-2.76s-1.76.36-2.71.68c-.95.31-1.86.4-2.63.59s-1.17.36-1.58.27c-.4-.1-1.27-.14-1.94-.14s-.64.14-1.32.81c-.67.68-.85 1.04-1.4 2.31a13.45 13.45 0 0 0-.9 3.98c-.12 1-.32 1.7-.44 2.06h8.11l.33-.83c.22-.46.66-.76.98-.9s.6-.16.74-.52c.15-.36.56-.66.98-.85s1.17-.08 1.85.1c.68.2.91-.27 1.1-.52.2-.26.28-.62.64-1.09.36-.46.1-.89.1-.89s-.34-.22-.66-.72zM336.75 176.6c-.1-.47-.06-.53-.34-.6-.28-.06-.74-.14-1.15-.31-.4-.17-.36.91-.36.91s-.95.1-2.04-.02c-1.08-.13-2.35-1.1-2.8-1.43-.44-.31-.93-1.04-.93-1.04s-.34.32-.68.51-.54.88-.6 1.56c-.06.68.79 1.5.85 2.18.06.68-.74 2.04-1.15 2.6-.27.37-.63 1.18-.83 1.65h3.92a2 2 0 0 1 .42-.66c.4-.4 1.08-.48 1.08-.48s0-.17.15-.53c.15-.37.55-.8 1.53-1.17.98-.39 2.14-.45 2.14-.45s.47-.38.81-.91c.34-.53.1-1.33-.02-1.8z'/%3e%3cg%3e%3cpath fill='%23D4AF3A' d='M304.15 219.77c.73.24 2.1-.3 2.77-1.12.68-.82.93-2.1 1.41-2.82l.84-1.27s-.1 1.2-.75 2.81a10.31 10.31 0 0 0-.57 4.54c.29 1.8 1.45 2.1 2.14 1.85.51-.19 1.3-.98 2.01-2.18.23-.38.4-.9.61-1.32.46-.88.88-2.31 1.08-2.27.45.09.16 1.1 0 1.78-.35 1.36-1.03 3.36-1.08 4.57s.1 3.4 1.32 3.5c1.21.1 1.84-.97 2.52-3.45.69-2.48.83-3.26 1.12-3.26.3 0 .3 1.7.3 2.43 0 .25 0 .94.1 1.64.2 1.33.58 2.92.97 3.28.58.53 1.07.43 1.07.43s.48.1 1.07-.43c.58-.54 1.06-4.19 1.06-4.92s0-2.43.3-2.43c.29 0 .43.78 1.11 3.26.69 2.48 1.32 3.55 2.53 3.45 1.22-.1 1.37-2.28 1.32-3.5s-.73-3.21-1.07-4.57c-.34-1.36.14-1.27 1.07.49.29.54.59 1.21.88 1.68.65 1.03 1.28 1.65 1.74 1.82.68.24 1.85-.05 2.14-1.85.3-1.8-1.07-6.96-1.07-6.96l.59.88c.48.73.73 2 1.4 2.82.69.83 2.05 1.36 2.78 1.12s.83-1.6.3-4.04c-.54-2.43-2.73-3.8-4.29-5.74-1.43-1.79-2.53-4.93-2.7-5.43a17.96 17.96 0 0 0-5.23 3.7c-3.22 3.35-3.92 4.2-3.92 4.2s-.7-.85-3.91-4.2a18.03 18.03 0 0 0-5.27-3.71c-.18.41-1.52 3.42-2.96 5.23-.72.9-1.71 1.57-2.42 2.44-.82 1-1.31 2.2-1.6 3.5-.52 2.43-.42 3.79.3 4.04z'/%3e%3cpath fill='%23D4AF3A' d='M304.06 228.01c.94-.83 1.43-1.29 1.43-1.29s.68-.57.51.52c-.17 1.08-.54 3.31-.31 4.28.23.97.34 1.8 1.54 1.08 1.2-.71 1.48-1.14 2.05-1.74.57-.6 1.17-.85 1.03.09-.14.94-.57 2.37-.37 4.28.2 1.91 1.14 2.2 2.37.57a21.5 21.5 0 0 0 2.34-3.91c.37-.8 1.11-1.48 1.11 0 0 3.2.73 7.83 4.25 9.07 3.52-1.24 4.25-5.88 4.25-9.07 0-1.48.74-.8 1.11 0 .38.8 1.12 2.28 2.34 3.9 1.23 1.63 2.17 1.35 2.37-.56.2-1.91-.23-3.34-.37-4.28s.46-.69 1.03-.09c.57.6.85 1.03 2.05 1.74 1.2.72 1.32-.11 1.54-1.08.23-.97-.14-3.2-.3-4.28-.18-1.09.5-.52.5-.52s.49.46 1.43 1.29a4 4 0 0 0 2.24.88s.6-3.35-.8-5.35-1.9-2.66-1.9-2.66-.8-.04-1.4-.27c-.6-.24-1.2-.67-1.2-.67v1.85s1.72 1.63 2.12 2.11c.4.48 1.2 1.31.03.51s-2.14-1.6-2.14-1.6-.23 1.69-.72 2.12c-.48.42-1.17.48-1.45.37l-.29-.12-.08.66s1.05 1.97 1.2 2.77c.14.8-.09.71-.57-.32-.49-1.02-1.43-2.34-1.86-3.05s-1.05-1.2-1-.28c.06.9-.31 2.56-.63 3.16-.3.6-.5.8-.5.8s.65 2.31.73 2.74c.09.43.03.91-.34.37s-1.43-2.82-1.43-2.82-1.4-.06-1.8-.46c-.4-.4-1.02-1.94-1.02-1.94s-.57 1.97-1.05 2.6c-.47.63-1.57 1.26-1.57 1.26s-.08 3.41-.16 4.02c-.08.6-.1.86-.36.86-.25 0-.28-.26-.36-.86-.08-.6-.16-4.02-.16-4.02s-1.1-.63-1.57-1.26c-.48-.63-1.05-2.6-1.05-2.6s-.63 1.54-1.03 1.94c-.4.4-1.8.46-1.8.46s-1.05 2.28-1.42 2.82c-.37.54-.43.06-.34-.37s.74-2.74.74-2.74-.2-.2-.51-.8a8.2 8.2 0 0 1-.63-3.16c.06-.92-.57-.43-1 .28s-1.37 2.03-1.85 3.05c-.49 1.03-.72 1.12-.57.32s1.2-2.77 1.2-2.77l-.1-.66-.28.12c-.28.11-.97.05-1.45-.37-.49-.43-.72-2.12-.72-2.12s-.97.8-2.14 1.6c-1.17.8-.37-.03.03-.51s2.11-2.11 2.11-2.11v-1.85s-.58.43-1.19.67c-.6.23-1.4.27-1.4.27s-.5.65-1.9 2.66c-1.4 2-.8 5.35-.8 5.35s1.3-.04 2.25-.86zM321.23 250.32c-.9-1.05-1.2-1.58-1.2-1.58s-.3.52-1.2 1.58c-.9 1.05-3.01 2.7-3.01 2.7s.18 2.8 1.2 4.3c.86 1.27 1.67 2.43 3 3.3a10.97 10.97 0 0 0 3.02-3.3c1.01-1.5 1.2-4.3 1.2-4.3s-2.11-1.65-3.01-2.7z'/%3e%3cpath fill='%23B96B29' d='M319.57 253.73c.08.65.03 2.28.42 2.28s.34-1.63.42-2.28c.08-.65.11-2.2.11-2.2h-1.06s.04 1.55.12 2.2z'/%3e%3cpath fill='%23D4AF3A' d='M319.98 100.87c-3.77.06-8.18-.46-10.62-1.36l-2.59.57c4.01 1.5 7.36 2.1 13.21 2.15 5.85-.06 9.2-.64 13.2-2.15l-2.59-.57c-2.43.9-6.85 1.42-10.62 1.36zM333.68 97.73c-.3-.25-2.01-1.47-2.46-1.7-.45-.22-.1-.82-.02-1.07.07-.25 2-.8 3.08-1.07 1.06-.27.9-.5.9-.5s-.63-.72-4.5-1.14c-3.88-.43-10.69-.33-10.69-.33s-6.8-.1-10.68.33c-3.87.42-4.5 1.14-4.5 1.14s-.17.23.9.5 3 .82 3.08 1.07c.07.25.42.85-.02 1.07a27.9 27.9 0 0 0-2.46 1.7c-.3.25-.33.64.15.67.47.02.48.02 1.8-.25 4-.8 7.75-1.01 11.74-1.07 3.98.06 7.73.28 11.72 1.07 1.33.27 1.34.27 1.81.25.47-.03.45-.42.15-.67z'/%3e%3cpath fill='%23D4AF3A' d='M329.27 99.37c-2.66-.31-4.35-.66-9.27-.61-4.92.04-6.6.3-9.27.61 1.68.68 4.38 1.01 9.27 1.01s7.6-.34 9.27-1zM319.18 62.89l2.03-.16-.19-1.78 2.18.3.09-1.75-2.29.21.4-1.89-2.52-.02.44 1.91-2.22-.2v1.74l2.2-.25zM323.61 65.76h-2.73v-2.33a4.02 4.02 0 0 0-1.51-.01v2.34h-2.82a3.05 3.05 0 0 0-.12 1.33h7.3a2.9 2.9 0 0 0-.14-1.33z'/%3e%3cpath fill='%231D5E91' d='M320.08 70.03c1.62 0 3-.95 3.48-2.27h-6.97a3.67 3.67 0 0 0 3.5 2.27zM321.58 63.65v1.6h1.8a3.5 3.5 0 0 0-1.8-1.6zM318.57 63.65c-.8.32-1.43.89-1.8 1.6h1.8v-1.6z'/%3e%3cpath fill='%23B96B29' d='M322.17 93.31c-.69-.32-2.19-.96-2.19-.96l-2.2 1.09c-.77.39-.67.27-.91.84s.02.76.36.91c.34.15 2.79 1.4 2.79 1.4l3.01-1.4c.6-.27.48-.55.32-.98-.16-.42-.5-.57-1.17-.9z'/%3e%3cpath fill='%23D4AF3A' d='M317.64 94.03l2.4 1.22 2.37-1.22-2.43-1.14zM319.98 84.65s-.2.84-.47 1.2c-.27.36-.48.69-.4 1.12.08.44.58.73.87.73.3 0 .8-.29.87-.73.08-.43-.13-.76-.4-1.12-.26-.35-.47-1.2-.47-1.2z'/%3e%3ccircle cy='88.56' cx='320' r='.45' fill='%23D4AF3A'/%3e%3cpath fill='%23D4AF3A' d='M318.39 86.24s.78-.87 1.07-1.42c.29-.54.52-1.03.52-1.03s.24.49.52 1.03c.3.55 1.07 1.42 1.07 1.42s1.1-.58 1.73-2.68c.64-2.11-.14-4.33-.43-6.73s-.52-6.52-.52-6.52c-.83.48-1.62.68-2.37.7a4.89 4.89 0 0 1-2.37-.7s-.23 4.13-.52 6.52c-.29 2.4-1.07 4.62-.43 6.73.64 2.1 1.73 2.68 1.73 2.68z'/%3e%3cellipse rx='1.89' ry='1.83' cy='81.51' cx='319.98' fill='%23B96B29'/%3e%3cellipse rx='1.82' ry='1.76' cy='77.22' cx='319.98' fill='%23B96B29'/%3e%3cellipse rx='1.74' ry='1.68' cy='73.12' cx='319.98' fill='%23B96B29'/%3e%3cellipse rx='1' ry='.97' cy='81.18' cx='319.98' fill='%23D4AF3A'/%3e%3cellipse rx='.97' ry='.93' cy='76.91' cx='319.98' fill='%23D4AF3A'/%3e%3cellipse rx='.85' ry='.82' cy='72.82' cx='319.98' fill='%23D4AF3A'/%3e%3cpath fill='%23b96b29' d='M319.93 224.04c.12.02.14-.28.16-.83.03-.56.1-1.9.23-2.7.14-.78-.2-.73-.41-.69-.21.05-.33.65-.33 1s.1 2.34.1 2.76.13.44.25.46z'/%3e%3c/g%3e%3cg id='a'%3e%3cpath fill='%23d4af3a' d='M300.28 239.41c.84-.53 1.57-1.13 3.48-2.4 1.9-1.26 2.6-2.66 2.6-2.66h-.67c-.36 0-.67-.51-.7-1.02-.03-.5 0-1.55.14-2.76.14-1.2-.2-2.19-.2-2.19s-.8.76-2.04 1.4c-1.24.65-1.74.34-1.74.34l-.31-1.23s-.53 1.12-1.29 2.44c-.76 1.33-2.8 2.79-4.26 3.89s-3.06 2.25-4.27 2.67c-1.2.42-.5.99-.5.99s1.2 1.2 4.32 1.77 4.6-.7 5.44-1.24z'/%3e%3cpath fill='%23d4af3a' d='M311.17 238.2c-1.11-.12-1.78-.54-2-1.75-.13-.78.06-3.8.06-3.8s-.36.32-.78.82c-.42.5-1.38.62-1.38.62s-.14.42-.56 1.1c-.42.67-.95 1.5-2.02 2.16-1.06.68-2.3 1.47-3.11 2.14-.81.68-1.77 1.47-2.83 2.06a4.66 4.66 0 0 0-2.39 3.12c-.36 1.58-.08 2.08 1.15 2 1.24-.09 1.38.03 3.37-.48 1.99-.5 4.82-2.73 6.9-4.05 2.08-1.32 3.59-3.94 3.59-3.94z'/%3e%3cpath fill='%23d4af3a' d='M316.69 240.02s-.84-1.07-1.15-2.28l-.9-3.6s-.28.76-.95 2.2c-.67 1.43-1.82 1.77-1.82 1.77s-.06.62-1.01 1.83a14.03 14.03 0 0 1-3.8 3.18c-1.42.84-3.27 2-4.28 3.43-1.01 1.43-1.1 2.92-.62 3.57.48.65 1.15-.09 2.1-.56s3.68-.9 7.44-2.93c3.76-2.02 4.99-6.61 4.99-6.61z'/%3e%3cpath fill='%23d4af3a' d='M318.32 248.44c1.04-1.55 1.2-5.32 1.2-5.32s-.36-.25-.86-.67c-.5-.42-1.49-1.91-1.49-1.91s-.62 1.29-1.29 2.5a9.4 9.4 0 0 1-2.41 2.92c-1.4 1.3-3.31 2.57-4.13 3.94-.8 1.38-.36 4.14.17 5.07.54.93 1.3.61 2.08-.14.78-.76 1.04-.96 2.41-2.14s3.28-2.7 4.32-4.25z'/%3e%3cpath fill='%23b96b29' d='M305.98 216.89c.55-1.13 1.18-2.5 1.68-3.19.5-.7.86-1.49.86-1.49s-1.34 1.22-1.87 2.09c-.53.86-.86 1.7-1.1 2.64-.24.93-.12 1.08.43-.05zM311.31 217.85c.22-.74.34-1.24.34-1.24s.21-.72.1-.77c-.13-.05-.68.45-1.06 1.67-.39 1.23-.96 3-.84 3.07.12.08 1.24-1.99 1.46-2.73zM315.51 221.23l.24-.55s.43-1.4.43-1.68c0-.29-.14-.62-.5.1s-.38 1.41-.46 1.72c-.07.32-.48 1.4-.36 1.5.12.09.41-.56.65-1.09zM302.47 234.03l-.56-.34s-.34.45-.82.96c-.47.5-1 .7-1.37 1.18-.36.48-.93 1.07-1.8 1.52s-1.2.6-1.03.73c.17.14.76-.2.76-.2s.25-.02 1.29-.64 1.29-.96 1.96-1.55 1.57-1.66 1.57-1.66zM307.02 239.41c.4-.42.81-.7.59-.93-.23-.22-.5-.2-.87.11s-1.4 1.3-1.88 1.72c-.48.42-.87.67-1.35 1.04-.47.37-1.51.93-2.02 1.2-.5.3-.02.32-.02.32s.39-.2.81-.34c.42-.14 1.63-.67 1.63-.67s.47-.23 1.12-.68c.64-.45 1.6-1.35 1.99-1.77zM312.26 243.04c.34-.67-.03-.48-.59-.25-.56.22-1.82 1.6-2.55 2.1s-1.35.71-1.96 1.02c-.62.31-.62.48-.6.62.03.14.29.14.54.03.25-.12 1.12-.62 1.12-.62s.37-.11.7-.14c.34-.03.82-.4 1.57-1.04.76-.65 1.43-1.04 1.77-1.72zM314.7 247.85c-.93.56-2.52 1.83-2.94 2.67-.43.85-.7 1.44-.57 1.58.14.14.6-.14.79-.48.2-.34.62-.85.62-.85s1.6-1.57 2.18-1.94 1.55-1.4 1.77-2.02c.22-.62.06-.96.06-.96s-.99 1.44-1.91 2z'/%3e%3cpath fill='%23c52126' d='M289.99 113.28c-.85-.5-3.13-1.47-5.56-1.68-2.42-.2-4.3.16-6.31.7a6.98 6.98 0 0 1-3.77.14 5.23 5.23 0 0 1-3.54-3.95s-1.6 2.06.03 4.29a4.8 4.8 0 0 0 2.86 1.95c3.4.68 6.73-1.4 9.56-1.57 2.72-.18 4.86 1.55 4.86 1.55s.64.53 1.55 0c.9-.53 1.17-.93.32-1.43z'/%3e%3cpath fill='%23d4af3a' d='M280.2 211.66l-.8-.1c-.47-.07-1.47-.4-1.77-.54-.3-.13-.77-.17-1.07.17-.3.34-2.75 1.78-2.75 1.78h4.05c1.4 0 2.34-1.31 2.34-1.31z'/%3e%3cpath fill='%23d4af3a' d='M291.59 210.97v-.4l-.54-1.16s-.63.39-1.24 1.02c-.79.82-1.64 1.97-2.02 2.46-.67.86-1.61 1.68-.8.3.8-1.38 1.07-1.98 1.72-2.9.64-.91 1.13-1.32 1.05-1.37-.08-.06-.6-.14-2.3-.35-1.69-.22-2.74-.87-3.52-1.33-.78-.46-2.18-1.21-2.18-1.21s-2.88 1.21-3.96 1.48-1.73.43-.68.95c1.06.51 1.94.67 2.46 1 .5.32 2.1.83 3.07.83.97 0 2.6.03 1.96.7-.64.68-1.37 1.98-2.07 3.95-.7 1.97-.73 3.73-.73 4.6s.1 1.72.1 1.72 1.2-1.32 4.37-3.32a56.1 56.1 0 0 1 4.96-2.94c.59-.27.89-.27.78-1.03-.1-.76-.43-2.62-.43-3z'/%3e%3cpath fill='%23d4af3a' d='M303.73 201.31l-.59-.27a.7.7 0 0 0-.15.05c-.37.2-2.3 1.5-3.1 2.76-.77 1.27-1.56 1.38-.7 0a11.94 11.94 0 0 1 2.84-3.32 35.56 35.56 0 0 1-4.9-2.8 7.49 7.49 0 0 1-1.07 1.65c-.67.7-2.17 1.3-2.17 1.3s1.2-1.22 1.6-2.16c.27-.6.44-1.23.53-1.62a21.1 21.1 0 0 1-3.21-3.06c-.2.8-.84 2.77-2.76 4.9-2.5 2.8-7.5 4.22-7.5 4.22s-1.74.19-.33.56 2.43 1 5.19.52c2.76-.48 2.94-.6 3.32-.7.37-.12 1.38-.04 0 .48s-4.6 1-5.82.9c-1.23-.12-2.91-.38-1.16.55s2.5 1.3 3.58 1.3 1.53.35 2.58.35c1.04 0 1.34-.2 2.08-.34.75-.15 1.23.11 1.23.4 0 .3-1 1.13-.96 3.18.03 2.05.18 3.4.37 3.99.19.6.63 1.56.93 2.13.3.55.41 1.11.7-.08.3-1.2.98-2.9 1.24-4.06.26-1.16.4-1.2.52-1.8.11-.6.75-1.04.45.04s-.64 2.46-.86 3.43c-.22.97-.74 2.76.15 1.35.9-1.42 4.25-5.19 4.8-5.86s1.02-1.3 1.43-1.86c.4-.56 1.56-1.3 2.12-2.13.5-.74 1.99-2.18 2.63-2.7-.95-.4-1.95-.83-3.01-1.3zM257.37 115.23c.09 2.06 2.36 5.99 3.66 8.09 1.3 2.1 1.65 2.94 1.43 3.08-.23.13-.76-.94-1.48-1.88-.71-.93-2.1-3.12-3.25-4.78s-2.86-5.58-3.08-5.94c-.22-.36-.31-.58-.9-.13-.57.44-1.69 4.78-.35 7.73 1.34 2.94 3.35 5.09 4.2 6.12.84 1.02 1.96 2.63 1.78 2.77-.18.13-.5-.27-1.52-1.34s-2.72-2.9-3.84-4.25a31.7 31.7 0 0 1-2.56-4.09c-.16-.3-.37-.21-.53-.06-.37.37-.95 1.23-.7 3.57.36 3.26 2.05 5.14 3.57 6.8 1.52 1.64 3.03 3.03 2.81 3.25s-1.78-1.16-2.85-2.19a95.4 95.4 0 0 1-4.29-4.29c-.58-.7-1.42-.35-1.38 2.46s3.17 5.68 4.46 7.24c1.3 1.56 2.9 2.5 2.77 2.81-.14.32-1.43-.49-2.28-1.07-.84-.58-4.01-2.64-4.64-3.08-.62-.45-.93.4-.13 3.08s3.12 4.82 4.5 5.8c1.39.99 3.62 2.2 3.48 2.51-.13.31-1.07-.09-2.36-.72-1.3-.62-2.85-1.2-3.97-1.51-1.12-.32-1.11.49-1.11.49s-.23 2.27 1.42 4.1 3.53 2.55 5.31 2.86c1.78.32 2.05.4 2 .68-.04.26-.22.3-.62.3s-2.05.19-3.57.19-2.31.35-2.31 1.02-.05 1.57 2.23 3.09c2.27 1.52 4.81 1.74 5.88 1.96 1.07.23 1.12.32.9.63-.23.31-.72.27-2.41.45-1.7.17-2.72.84-2.95 1.29-.22.45.14 1.79 1.52 2.73 1.38.93 3.17 1.25 5.84 1.07 2.68-.18 3.35-.23 3.44.22.09.45-.8.58-2.14.8-1.34.23-2.37.23-3.13.86-.75.62-.17 1.92 1.12 2.85s4.5.94 5.84.85 3.4-.58 3.53-.22-.98.9-2.37 1.38c-1.38.5-1.78.8-2.05 1.39-.27.58-.04 1.12 1.6 1.74 1.66.63 4.07.63 5.32.05s1.91-.8 2.14-.58c.22.22 0 .44-.27.76-.27.3-1.34 1.16-2.72 1.52s-1.52.35-2 1.47c-.5 1.12.75 2.01 3.25 2.1 2.5.09 5.84-.9 6.91-1.52 1.07-.63 1.47-.76 1.65-.54.18.23.14.36-.4.76s-2.23 1.61-3.08 1.84c-.84.22-.93.84-.93 1.43 0 .58-.23 1.74 2 2.27 2.23.54 4.86.14 7.27-1.56a5.5 5.5 0 0 0 1.48-1.39c-.19-2.28-.09-3.85.19-5.3a8.81 8.81 0 0 1-2.3-.55c-1.33-.53-1.86-1.78-2.18-2.45-.31-.67-.76-.67-1.3-.5-.53.18-1.06.4-1.82.36s-2.36-.44-3.52-1.83c-1.16-1.39-.94-2.72-.99-3.4-.04-.67-1.11-.17-1.65-.17-.53 0-2.1-.23-3.52-1.21-1.43-.98-1.43-2.32-1.56-2.86-.14-.54-.72-.9-1.16-1.07-.45-.18-1.16-.36-2.14-1.16-.98-.8-1.34-2.37-1.39-2.9-.04-.54-.62-.59-2.63-1.61s-1.83-3.18-1.74-4.02c.1-.85 1.03-1.57 1.03-1.88 0-.32-.67-.4-1.34-.8s-2.36-1.08-2.4-3.58c-.05-2.5 1.6-2.77 1.6-2.77s-.31-.13-.98-.54c-.67-.4-2.5-1.65-2.5-3.12 0-1.48.67-2.15 1.16-2.5.49-.36 1.83-.72 1.83-.72s-.85-.54-1.2-1.7c-.36-1.16-.5-2.59.35-3.62.85-1.02 2.27-1.02 3.03-1.02s1.43.4 1.7.18c.27-.23.31-.4.04-.99a4.38 4.38 0 0 1-.09-2.5c.23-.49.27-1.47 2.19-2.1 1.92-.62 3.92.67 4.55 1.03s.36-.5.36-1.12c0-.62-1.3-2.19-2.77-4.42s-2.14-3.4-3.8-6.8-2.71-7.76-2.94-8.88c-.22-1.12-.67-.58-.67-.58s-.44.18-1.47 2.77a16.66 16.66 0 0 0-1.11 7.01z'/%3e%3cpath fill='%23d4af3a' d='M291.02 160.92a5.02 5.02 0 0 1-3.8-2.36c-1.14-1.67-2.87-2.07-5.85-2.01-3 .05-4.37-1.38-5.12-3.46-.74-2.07.12-4.43 3.16-5.92s4.43-3.17 4.54-5.76c.12-2.59-3.04-5.81-6.2-9.43s-5.63-8.75-5.63-8.75-.92 1.2-.92 2.41.46 2.48 0 2.82c-.46.35-.63-.51-2.47-1.32-1.84-.8-3.34-.92-4.48.4s0 3.63 1.03 4.72c1.03 1.1 1.9 1.9 1.6 2.3s-1.83-.63-2.35-.97-1.72-1.67-3.5-1.5-2.42.69-2.59 2.19c-.17 1.5 1.61 2.82 2.76 3.4 1.15.57 1.6 1.09 1.32 1.31-.29.24-.57 0-1.1-.17a5.35 5.35 0 0 0-2.86 0c-.92.35-2.42 1.61-1.04 3.17 1.38 1.55 4.25 2.13 4.83 2.24.57.12.86-.06.92.4.05.47-1.21.47-2.76.52s-2.01 1.56-1.78 2.7 2.81 2.42 4.25 2.65c1.44.23 1.95 0 2.07.4.11.4-.17.58-.98.81-.8.23-2.35.4-2.64 1.67-.29 1.27-.35 1.84.86 2.94 1.2 1.09 3.16.92 3.73.8.58-.11 1.27-.75 1.84-.17.58.57-.51 1.04-1.5 1.73-.97.69-.91 2.01.76 2.93 1.66.92 3.33.58 4.02.35s1.6-1.33 2.07-.64c.46.7-1.44.93-2.24 1.9-.8.98-.52 2.6 1.09 3.57 1.6.98 4.25.29 4.7-.11.47-.4 1.04-.58 1.39-.23.34.34-.17 1.26-.52 2.07-.34.8-.98 3.16 1.44 4.08 2.41.92 4.6-1.15 5-1.55.4-.4.8-.46 1.15-.29.34.17.17.52-.12.92-.29.4-.92 2.13.8 3.34 1.18.82 2.47.76 3.16.64.36-1.34.83-2.78 1.3-4.8H290c-.23 0-.27.34-.27.48s.07.25-.14.25c-.2 0-.23.12-.53.33-.3.2-.58.46-.74.34-.16-.11.62-.53.83-.78.2-.25.62-.65.65-.92.02-.28.16-.44.57-.78.13-.11.23-.24.31-.36.28-1.34.55-2.92.8-4.82.16-1.29.26-2.5.3-3.64l-.76-.04zM241.91 125.05c2.57 5.2 6.2 8.12 6.2 8.12s-.48-1.3-.7-2.18c-.2-.89-.04-1.9-.04-1.9s-.91-1.16-2.6-3.75-2.56-6.42-2.56-6.42 1.56 3.83 2.78 5.86c1.21 2.03 2.61 3.69 2.61 3.69s.5-1.8.84-1.9c.35-.08.61.2.91.6.3.39.57.35.57.35s-.42-.85-1.06-1.88c-.29-.47-.71-.97-1-1.45-.97-1.5-3.03-4.38-4.09-7.25-1.06-2.88-3.37-10.09-3.77-12.2-.4-2.12-.8-.96-1.21.6-.4 1.56-.96 3.78-.6 7.1s1.15 7.42 3.72 12.61zM245.23 139.07c.96.7 2.37 1.66 2.37 1.66s-.23-.52-.37-1.14-.2-1.91-.2-1.91l-1.9-1.68a27.83 27.83 0 0 1-3.73-3.98c-1.95-2.42-.38-.97 1.2.76s4.63 4.25 4.63 4.25l.02-.56c.02-.53.18-.9.47-1.27.28-.36.13-.41-1.58-1.72-1.71-1.32-6.15-6.3-7.96-9.28-1.81-2.98-3.77-7.01-3.77-7.01s-.96 5.95 2.66 12.5c3.63 6.56 7.2 8.67 8.16 9.38zM264.25 176.6c1.99-.77 1.44-2.73 1.44-2.76s-1.22.38-2.34.8c-1.12.42-3.87 1.22-4.96 1.25-1.09.03-1.09-.12-1.12-.29-.03-.16.83 0 2.4-.28 1.57-.3 4.32-1.74 4.8-2.06.48-.32.42-.38-.28-.45a3.02 3.02 0 0 1-1.57-.6c-.26-.23-1 .1-2.79.5-1.8.42-5.51 1.07-8.36 1.07s-5.51-.48-5.96-.58c-.45-.1-.93.16.45 2.47 1.38 2.31 6.21 3.56 9.58 3.53 3.36-.04 6.72-1.83 8.71-2.6zM255.31 171.83c3.47.03 4.76-1 4.76-1s0-.18-.47-.89c-.47-.7-.38-1.9-.38-1.9s-.82.14-2.26.35c-1.44.2-3.12.4-4.97.08s-1.06-.53.4-.35c1.48.18 4.3-.36 5.21-.68.91-.32.53-.62-.08-.82-.62-.2-2.3-1.27-2.3-1.27s-4.2.53-8.11.09c-3.91-.44-6.39-1.44-7.18-1.56s-.76.2-.76.2-.21.36 1.14 2.48c1.35 2.12 4 3.5 6.24 4.15 2.23.65 5.29 1.1 8.76 1.12zM254.42 163.7s-.15-.2-.35-.91c-.2-.71.38-1.24.38-1.24s-.8-.23-3.38-.56c-2.6-.32-2.74-.53-4.33-.88-1.58-.36-2.64-.83-2.61-1s.53.08 1.47.44c.94.35 4.9.76 6.58 1 1.68.23 2.62.41 2.91.23.3-.17 1.33-.44 1.33-.44s-.7-.2-1.59-.35a5.6 5.6 0 0 1-2.15-.86c-.47-.32-.61-.41-2.73-.64-2.12-.24-3.82-.92-7.62-2.3-3.79-1.39-6.64-3.03-7.4-3.65-.77-.62-.71-.18-.5.62.2.8.17 1.8 2.08 4.03 1.91 2.24 2.85 3.21 7.67 4.98 4.83 1.77 10.24 1.53 10.24 1.53zM240.16 151.95c4.26 3 9.26 4.1 10.32 4.24.24-.28-.26-1.28-.03-1.89.28-.72.74-.73 1.77-.79 1.02-.06.35-.27.11-.27s-.29-.02-2-.47c-1.7-.44-3.44-.7-5.79-1.59-2.35-.88-3.06-1.53-3-1.7.06-.18 1.09.56 3.27 1.38 2.17.82 4.7 1.15 6.08 1.44 1.39.3.18-.3-.47-.68-.64-.38-1.56-1.8-1.56-1.8s-1.53-.26-4.02-1.02a32.52 32.52 0 0 1-6.68-2.8c-.72-.4-1.41-.93-2.16-1.47-1.43-1.02-2.87-2.07-3.43-2.48-.85-.62-.58-.12-.5.27s.68 2.15 2.03 4.1c1.35 1.94 1.8 2.52 6.06 5.53zM239.46 143.5c4.2 3.33 7.82 4.36 8.44 4.62.62.27.56-.09.44-.44-.12-.35-.2-1.5-.2-1.5l-3.18-1.83c-1.68-.97-3.53-2.3-4.77-3.15-1.23-.85-.5-.8-.11-.47.38.32 2.08 1.33 3.79 2.39 1.7 1.06 4.3 2.59 4.3 2.59s.05-.56.4-.91 1.24-.27 1.24-.27-.44-.44-.7-.85c-.27-.42-1.65-.86-3.21-1.6-1.56-.73-4.36-2.79-6.41-4.53a83.89 83.89 0 0 1-6.33-6.45c-.26-.35-.44-.3-.47.15-.03.44-.17.73.27 2.74.44 2 2.3 6.18 6.5 9.51zM254.34 112.03c.48.99 1 1.74 1.38 2.38.56.98.88 1.6.88 1.6s.12-.34.03-.92-.18-1.4-.02-2.36c.08-.52.19-1.04.16-1.5-.03-.52-.2-.97-.28-1.27-.13-.56-.74-3.02-1.03-4.75-.3-1.73-.6-4.2-.59-6.39.03-2.18.34-1.08.34-.02s.11 2.68.45 5.17c.34 2.5 1.4 6.3 1.4 6.3s.06-.58.38-1.41.83-1.78 1.23-2.82c.4-1.03.26-1.2.26-1.2s-1.47-7.07-1.86-10.41a427.64 427.64 0 0 1-1.01-12.12c-2.16 2.18-3.77 7.9-4.05 13.3-.22 4.08.44 7.85.63 9.38.38 3.03.9 5.4 1.7 7.04zM249.55 123.18c.07-1.6.43-2.81 1.47-3.17 0 0-.92-1.6-1.71-3.88-.55-1.56-1-3.57-1.23-5.1-.56-3.8-1.01-7.7.11-1.3 1.13 6.38 2.49 8.64 2.49 8.64l1.63 2.66c-.24-1.17-.28-1.99-.21-3.26s.22-3 .6-4.37c0 0-1.97-3.96-3.2-8.7s-1.96-9.08-1.98-11.65l-.17-3.45s-2.03 1.53-2.71 9.27c-.68 7.75 1.35 15.15 2.37 17.98 1.02 2.82 2.54 6.33 2.54 6.33zM271.71 182.24s-.32-.22-1.28-.83-.67-2.44-.67-2.44-.26.19-.97.67c-.7.48-1.5 1.03-2.46 1.41s-1.44.65-2.05.84c-.61.19-.45-.07.06-.36.51-.28.68-.44 1.96-.96 1.28-.51 3.84-2.76 3.84-2.76s-.6-.06-1.67-.1-2.4-.57-2.4-.57-1.05.96-5.32 2.79c-4.26 1.83-7.88 2.3-7.88 2.3s.45 2.2 2.5 2.93c1.7.74 4.04 1.19 8.62.1 4.58-1.1 7.72-3.02 7.72-3.02zM277.32 186.61c.35-1.8-.67-3.05-.67-3.05s-.23.13-.87.7c-.64.58-1.57 1.68-3.36 2.57s-2.44.84-.7-.1 4.26-3.56 4.26-3.56l-.68-.25c-.67-.26-1.82.19-6.63 3.08-4.8 2.88-7.62 2.98-7.62 2.98s2.14 2.6 7.97 2.4c5.83-.18 7.95-2.97 8.3-4.77zM288.34 184.52s-.64.9-1.5 1.48-3.18.93-3.18.93-.1.25-.54.83c-.45.58-1.44 1.96-2.47 2.7-1.02.73-2.62 1.21-2.72 1.02s.93-.58 1.92-1.19c1-.6 1.9-1.73 2.56-2.5.68-.77-.28-.64-.28-.64s-1.22.03-2.34-.06c-1.12-.1-.9 0-1.22.54s-.77 1.03-1.6 2c-1.02 1.17-1.98 2.23-2.95 3.39-.64.77-.16 1-.16 1s.29.48 2.88.77c1.6.17 3.34-.03 5.17-1.08 1.13-.66 2.3-1.7 3.49-3 3.1-3.4 2.94-6.19 2.94-6.19zM289.72 191.54c-.64.83-1 1.19-1 1.19s.45-1.38.84-2.02c.2-.35.43-.67.6-.9-.44-.96-.79-2-1.05-3.12-.28.93-1.17 3.64-2.27 5.4-1.35 2.14-2.53 2.92-1.77 3.5.77.57 2.28.7 3.98-.14 1.64-.8 2.11-2.2 2.34-3.34-.28-.45-.55-.91-.8-1.4-.22.13-.52.38-.87.83z'/%3e%3cellipse rx='1.19' ry='1.09' cy='105.75' cx='289.34' fill='%23d4af3a'/%3e%3cpath fill='%23d4af3a' d='M286.83 103.69c1.09-.03 1.67-.54 2.87-.42 1.42.13 3.34.96 5.67 2.2a9.7 9.7 0 0 0 6.55.57c.65-.19 1.3-.54 1.91-.9 2.84-1.6 2.15-4.76 2.15-4.76a11.12 11.12 0 0 1-7.09 2.15s.19.14.6.55c.41.42 1.16.9.91 1.1-.24.21-1.28-.78-2.14-1.42a12.92 12.92 0 0 0-4.35-2.15c-2.2-.65-4.66-.7-6.3.22-1.66.92-1.8 2.07-1.56 2.53.12.26.43.34.78.33zM317.64 126.8c-.5-.14-1.37-.28-2.51-1.33a47.76 47.76 0 0 1-4.21-4.63c-.32-.55-.19-1.06.6-1.38.77-.32 1.32-1.33 1.32-1.33s-1.7-.64-2.83-1.47c-1.15-.82-3.8-3.2-4.17-3.8s-.18-.7.37-.87c.55-.19.69-.56.69-.56s-1.24-.77-2.38-1.7c-1.14-.9-2.7-2.42-2.7-2.42-1.71.69-4.4.4-5.85.14-2.56-.46-4.44-1.52-4.44-1.52s-.09.41-.4 1.2c-.33.77-1.52 1.23-2.7.45-1.2-.78-.92-2.47-.92-2.47s-.96-.6-2.93-1.33-3.56-.83-5.16-.1c-1.6.74-2.38 2.94-2.38 4.6 0 1.64.87.95 1.05.72.18-.23.55-1.42 2.56-1.74 2.01-.32 3.84.64 6.13 2.52 2.28 1.88 2.79 2.02 3.93 3.21 1.14 1.2.23 1.84-1.74 2.48s-4.48-.64-4.57-.6c-.38.2.85 1.94 2.54 2.6 1.7.66 3.87.24 5.55-.44 1.15-.46 1.36.02 1.7.37 1.85 1.95 2.33 3.78 2.65 6a2.7 2.7 0 0 0 1.73-2.01c.07-.37.19-1.2.83-.6.64.6 1.14 3.9 1.14 5.41s-.46 3.54-.46 3.54l.46-.05c.28-.05.82-.37 1.55-.78.74-.41.78.05.78.87s.28 2.39 1.37 5.18 2.7 3.72 2.7 3.72.32-.55.64-1.65c.32-1.1.55-3.26.55-5.14s-.5-5.92-.5-5.92 2.29 2.8 4.66 3.5c2.38.68 4.76.27 5.76-.88s.1-1.65-.41-1.79z'/%3e%3cpath fill='%23d4af3a' d='M302 134.04s-.72 1.6-1.12 2.17-.56.65-.56.65.72.62 1.77.94c1.05.33 1.99.53 1.99.53s-1.18-1.62-1.6-2.76c-.41-1.14-.48-1.53-.48-1.53zM316.28 133.1c-.35-.9-.57-1.4-.57-1.4-1.46.3-4.23-.4-5.43-1.12 0 0 1.1 2.23 2.2 3 1.09.77 1.24.81 1.24.81s-1.1.18-2.56-1.27c-1.47-1.44-2.13-3.1-2.13-3.1s.33 3.85-.26 6.2-.72 2.68-.72 2.68 3.1.55 6.57-.42c3.45-.96 3.72-1.27 3.72-1.27s.41-.1-.13-.83a18.68 18.68 0 0 1-1.93-3.28z'/%3e%3cpath fill='%23b96b29' d='M310 124.64c-1.06-1.22-1.17-1.52-1.17-1.52s-.37.38-.05.9a11.1 11.1 0 0 0 2.87 2.45 7.4 7.4 0 0 0 2.07.77l-.05-.2s-2.6-1.18-3.67-2.4zM305.78 132.67s-.27-4.84-.27-5.56-.45-.53-.45-.53l-.53.24 1.04 7.08c.11.76.49.7.68.66-.38-.2-.45-1.67-.47-1.89zM299.25 111.72c-.4-.4-1.28-.69-.43.26.86.96 1.98 2.14 2.3 3.13.34.99.53 2.2-.03 1.94-.56-.26-.95-.26-1.54-.75a9.86 9.86 0 0 0-2.18-1.45c-.46-.13-1.28 0-.62.72.66.73 1.38 1.42 2.63 2.34 1.25.92 1.98 1.31 2.64 1.78.65.46 1.31.85 1.31.85s-.6-3.95-1.68-5.7-2-2.72-2.4-3.12zM277.91 177.87c-.8.6-1.85.86-1.85.86s-.5-.03-.5.16.58 0 1.19-.1c.6-.12 1.44-.73 1.74-.95.3-.22.75-.5.6-.88-.13-.4-.38.3-1.18.91zM284.8 181.56c-.17.2-1.5 1.19-1.5 1.19s-.4.28-.85.44c-.44.17-.55.42-.55.42s.08.1.55-.03c.47-.14 1.85-1.1 2.3-1.5.44-.38.63-.5.47-.66-.17-.16-.25-.05-.42.14zM256.87 131.93c.25.3.55.71.69.58.14-.14-.03-.28-.36-.66-.33-.39-.52-.58-.52-.58s-.47-.75-.75-1.02c-.27-.28-.68-.42-.16.22.52.63.85 1.16 1.1 1.46zM254.75 136.58c.3.28.58.52.9.88s.59.74.78.55c.19-.2-.5-.6-.8-.99-.3-.39-.55-.63-.94-.94s-.85-.55-.85-.55.6.78.91 1.05zM255.54 144.09c.53.55 1.3.72 1.41.5.11-.22-.06-.4-.5-.62-.43-.22-1.15-.69-1.5-.94a7.61 7.61 0 0 1-.97-.77c-.25-.25-.54-.47-.63-.38-.1.08.73.96.97 1.1.25.14.7.56 1.22 1.11zM257.06 150.1c0-.22.05-.33-.39-.36-.44-.03-1.05-.1-1.05-.1s-.86-.34-.91-.18c-.06.17.72.5 1.05.56.33.05.75.16.94.27.2.11.36.03.36-.19zM257.72 156.63c-.94 0-1.74-.22-1.8-.08s.45.36.92.52c.47.17 1.35.22 1.96.25s.72-.1.7-.41c-.04-.3-.84-.28-1.78-.28zM265.08 163.78c-.14-.14-.47-.03-1 .08-.52.11-1.38.28-1.88.25s-1.57-.05-1.57-.05l-.61.14c0 .14.8.1 1.96.25 1.16.13 1.94-.11 2.5-.2.54-.08.74-.33.6-.47zM268.12 168.87c-.58.22-1 .28-1.44.28-.44 0-1.5.19-1.5.19s-.49.06-.4.25c.08.2.24 0 .68-.06.45-.05.78 0 1.55-.02.78-.03 1.22-.23 1.69-.3.47-.1 1-.34.75-.65-.25-.3-.75.09-1.33.31zM274.04 172.72c-.33.33-1.6 1.2-1.6 1.2s-.25.19-.75.43-.47.37-.39.5.39-.2.67-.3 1.18-.72 1.65-1.1c.47-.4 1.08-.7.97-.98-.1-.28-.22-.08-.55.25zM264.19 122.87s.11.25 1.13 1.53c1.02 1.28.48.07.22-.25-.26-.33-1.75-2.45-2.26-3.03-.51-.59-.59-.3-.33.07.26.37 1.24 1.68 1.24 1.68zM262.04 129.43c.15-.15-.18-.3-.77-1.02l-1.75-2.23s-.33-.69-.43-.62c-.11.08.4 1.17.87 1.65.48.47 1.1 1.38 1.42 1.78s.51.59.66.44zM264.87 141.73c0-.36-1.16-.3-1.68-.41l-1.46-.3s-1.1-.2-1.12-.06c-.03.13.22.27.82.38.6.11 1.51.39 2.2.5s1.24.25 1.24-.11zM262.04 135.09c.77.62 1.28.91 1.68 1.13.4.22.73.55.95.3.22-.26-.19-.45-.84-.74-.66-.29-.99-.54-.99-.54l-.7-.37c-.32-.18-.87-.4-.1.22zM268.64 130.71c-.47-.4-.88-.62-.88-.62s-.58-.55-.69-.37c-.1.19.66.73 1.02 1.06.37.33 1.02 1.28 1.35 1.1.33-.19-.33-.77-.8-1.17zM264.33 147.85l-1.05.28c-.41.1-.44.3.3.3s1.06-.2 1.8-.33c.75-.14 1-.22.89-.47-.11-.25-.5-.17-.8-.08l-1.14.3zM265.49 154.06c-.06.14.53 0 .91-.14.39-.14 1.2-.55 1.66-.69.47-.14.47-.22.47-.5 0-.27-.5-.05-1.1.14-.61.2-1.39.8-1.39.8s-.5.25-.55.39zM273.48 157.82c.55-.33.67-.58.47-.75-.2-.16-.36-.14-.8.22-.44.36-1.3.97-1.3.97s-.44.17-.77.34-.75.44-.64.6c.1.17.8 0 1.16-.3.36-.3 1.33-.75 1.88-1.08zM277.25 162.81c.22-.2.88-.41 1.19-.64.3-.22.5-.88.25-.97s-.39.28-.91.67c-.53.39-2.33 1.58-2.33 1.58l-.47.19c-.5.2-.27.33.14.28.42-.06.7-.06 1.19-.44.5-.4.72-.48.94-.67zM282.83 167.54c.47-.2 1.16-.8 1.5-1.1.33-.31.74-.7.5-.9-.26-.19-.53.06-.92.42s-1.41 1.44-1.41 1.44-.14.03-.7.47c-.55.44.04.36.23.17.2-.2.33-.3.8-.5z'/%3e%3cpath fill='%23d4af3a' d='M305.58 96.59l2.25-1.6-2.65-.68-1.7 1.36z'/%3e%3cellipse rx='2.15' ry='2.07' cy='94.72' cx='312.78' fill='%23b96b29'/%3e%3cellipse cx='312.78' rx='1.29' cy='94.28' ry='1.24' fill='%23d4af3a'/%3e%3cpath fill='%23d4af3a' d='M308.3 87.6c.55.21 1.27.12 1.27.12s.22-.95-.3-1.41c-.53-.47-1-.8-1.32-1.1l-.38-.42s0 .82-.04 1.34c-.04.51.22 1.27.77 1.48z'/%3e%3cellipse cx='309.44' rx='.39' cy='88.65' ry='.37' fill='%23d4af3a'/%3e%3cpath fill='%23d4af3a' d='M306.51 88.25c-.17.23-.53.6-.53.6s.44.02.8.27c.36.26.82.48 1.24.43.43-.05.6-.45.52-.74-.1-.28-.3-.57-.99-.83-.7-.26-.87.04-1.04.27z'/%3e%3cpath fill='%23d4af3a' d='M308.01 90.76c-1.35.12-3.13-1.37-3.13-1.37-.17 1.2-.9 1.81-2.04 2.04l.1.05s1.06.54 2.3.73c.57.09 1.07 0 1.67-.13a7.06 7.06 0 0 0 2-.63c.81-.5.57-1.8.57-1.8s-.12.98-1.47 1.1zM302.76 89.4c-.55-.2-1.38-.6-1.73-.62-.34-.02-.85-.1-.76.54.09.64.74.95 1.38.97.64.02.97-.23 1.35-.42.38-.19.31-.26-.24-.47zM298.54 87.11c-.6-.43-1.14-.55-1.14-.55s-.4 1.04-.17 1.68c.22.65.69.82 1.26.8.57-.02 1.42-.31 1.17-.75a3.38 3.38 0 0 0-1.12-1.18z'/%3e%3cellipse cx='299.09' rx='.47' cy='90.04' ry='.34' fill='%23d4af3a'/%3e%3cpath fill='%23d4af3a' d='M300.38 84.86c-.37-1.77-.31-3.7 1.37-6.16 1.68-2.46 4.6-3.45 4.6-3.45s.1-.2 1.03-1.19c.94-1 2.84-2.24 2.84-2.24s-2.2.55-3.46.95v.06c0 .85-.67 1.54-1.5 1.54-.33 0-.62-.1-.87-.27-.68.13-2.94 1.49-3.52 1.97.14.23.23.51.23.81 0 .85-.68 1.54-1.51 1.54-.25 0-.49-.06-.7-.17l-.19.33c-.47.87-.82 1.7-1.08 2.48.38.26.64.76.64 1.33 0 .85-.57 1.53-1.28 1.54-.05.5-.04.85-.02 1 .06.5.25.8 1.12 1.06.87.24 2.05 1.77 2.05 1.77.09 0 .7-1.12.25-2.9z'/%3e%3cpath fill='%23d4af3a' d='M305.74 73.5c.32-.25.37-.65.12-.87-.25-.23-.71-.2-1.03.06-.31.26-.37.65-.12.88.25.22.71.2 1.03-.06zM300.1 77.32c.36-.33.42-.82.14-1.1-.29-.3-.8-.26-1.17.07-.35.32-.41.82-.13 1.1.28.29.8.25 1.16-.07z'/%3e%3cellipse cx='296.74' rx='.87' cy='82.11' ry='.86' fill='%23d4af3a'/%3e%3cpath fill='%23d4af3a' d='M315.54 70.02c-.45.1-1.29.37-2.54 1.02h.02c.87 0 1.55.56 1.55 1.28s-.8 1.5-1.66 1.5-1.46-.75-1.46-1.47c0-.17.04-.34.11-.49l-1.19.77c-2.77 1.87-3.42 2.77-4.8 5.33-1.36 2.55-1.86 5.35-1.27 7 .6 1.65 2.77 2 2.8 2s-.25-.26-.28-.57c-.03-.31.07-.47.16-1.09.1-.62.03-1.37.03-1.37s.5-.06.78.28c.28.35.68.75.96 1.1.28.33 1.03.99 1.03.99s.44-.63.44-1.37c0-.75-.5-1.56-.6-2.87s.6-3.64 1.87-5.35a15.05 15.05 0 0 1 4.39-3.61c.72-.34.84-.87.87-1.18.03-.32.1-.53.16-1.31s-.65-.75-1.37-.6z'/%3e%3cpath fill='%23d4af3a' d='M312.79 72.97c.49 0 .94-.44.94-.84 0-.4-.39-.72-.88-.72s-.88.33-.88.73.33.83.82.83zM316.91 89.25c.67.27 1.42.12 1.78-.12.35-.24.47-.84.05-1.19a1.34 1.34 0 0 0-1.43-.12c-.39.22-1.26.84-1.26.84s.2.32.86.59z'/%3e%3cpath fill='%23d4af3a' d='M319.05 90c-.24.37-.42.6-1.16.63s-1.55-.02-2.03-.5c-.49-.49-.82-1.17-.82-1.17l-.84-.01s-.28 1.16-.65 1.48c-.37.33-1.66.38-2.22-.04s-1.08-.94-1.18-.88 0 .49.58.99.98.8 1.92.8h5.32s1.08.07 1.39-.58c.3-.64.32-1.05.17-1.2-.14-.17-.24.1-.48.48z'/%3e%3cpath fill='%23d4af3a' d='M310.96 89.1c.8.44 1.24.17 1.53-.19.3-.35.34-.51.34-.51s-.75-.28-1.12-.5c-.36-.2-.61-.41-.98-.37-.36.05-.42.1-.42.1s-.15 1.02.65 1.47z'/%3e%3cellipse cx='307.11' rx='1.77' cy='81.24' ry='1.76' fill='%23b96b29'/%3e%3cpath fill='%23b96b29' d='M310.19 75.14c-.71-.47-1.75-.28-2.33.43-.58.72-.47 1.68.24 2.16.71.48 1.76.29 2.34-.43.57-.7.46-1.68-.25-2.16z'/%3e%3cellipse cx='307.04' rx='1.03' cy='81.01' ry='.98' fill='%23d4af3a'/%3e%3cpath fill='%23d4af3a' d='M309.45 75.34c-.46-.13-1.02.1-1.26.5s.01.83.62.96c1.12.22 1.66-1.18.64-1.46z'/%3e%3c/g%3e%3cg%3e%3cpath fill='%23D4AF3A' d='M282.34 212.67s-2.74 1.31-3.61 1.54c-.87.24-1.07.24-1.07.24s-1.87 1.7-3.25 2.51c-1.44.85-3.09 1.47-4.74 1.65-2.14.23-8.03.16-10.67.06s-4.28.54-5.42 1.82c-1.13 1.27-1.4 3.11.04 4.52s3.04.7 3.57-.16c.54-.88.27-1.98.04-2.49-.24-.5.47-.67 1.2-.7.74-.03 1.98.07 3.11.23 1.14.17 3.15.84 4.02 1.31.87.47.36.54-.24.44s-1.27-.34-2.34-.74a9.28 9.28 0 0 0-2.64-.64c-.67-.03-.44.34-.3.57.13.24.5.8.6 1.08.1.27-.2 1.27-.2 1.27l.33.64s.4-.64.54-.97c.13-.34-.04-.98.1-1.28s.7-.3 1.14.2c.43.5.93 1.11 1.17 2.38.23 1.28-.2 2.18-.2 2.18s.53.44.63.74c.1.3-.13 1.51-.13 1.51s.36.24.7-.47c.33-.7.73-1.94.83-2.38.1-.44.4-1.24.94-.64s.9 1.34 1 1.71c.1.37.1.67.1.67s1.2-1.17 1.6-1.84 1.25-1.68 2.38-2.62c1.14-.94 3.11-2.81 4.08-3.45.97-.64 3.45-1.98 4.22-2.45s.9-.5 1.03-1.81c.14-1.31.77-2.48 1.07-3.39.3-.9.36-1.24.36-1.24zM238.49 163.52c-.02-.22-.47-1-.58-1.4-.11-.4-.51-.16-.51-.16s-.87.49-1.52.67-.73-.07-.8-.4c-.07-.34-.22-1.4-.34-2.13-.1-.74-.26-.7-.53-.58-.27.11-1.07.4-1.63.65-.55.24-.38.51-.2.82.18.32.83 1.64 1.12 2.1.29.48.02.68-.32.83-.33.16-.82.23-1.49.45s-.62.38-.56.6c.07.23.52 1.15.76 1.57.25.42.47.13.47.13s.71-.64 1.31-.94c.6-.28.65-.2.8.25.16.45.85 2.8.99 3.24.13.45.35.4.67.27.3-.13.73-.2 1.09-.31.35-.11.49-.83.49-.83s-1.32-2.37-1.67-2.97c-.36-.6 0-.74.26-.78.27-.05 1.05-.16 1.72-.32.66-.17.48-.55.46-.78zM253.35 227.9c-.1-.57 0-1.14-.43-1.58a5.4 5.4 0 0 1-1.17-2c-.2-.71.16-1.05.1-1.45-.07-.4-.6-.4-1.14.03-.54.44-1.24.84-1.24 2.11 0 1.28.47 2.79 2.24 3.32 1.77.54 1.74.14 1.64-.43zM255.15 227.29s-.37-.23-.54.1-.13.5.34 1.24.77.9 1.3 1.24c.54.34.17-.33.1-.53-.06-.2 0-.47-.13-.64-.13-.17-.2-.37-.2-.9 0-.54-.87-.5-.87-.5z'/%3e%3cpath fill='%23D4AF3A' d='M257.32 233.33c.33-.5.64-.64 1.44-1s2.27-.58 2.77-.61c.5-.03 1.64-1 1.47-2.01-.16-1.01-.9-1.41-1.54-1.55s-1.2-.13-1.4.17c-.2.3-.57.7-1.27.94s-.8.47-1.24.6c-.43.14-.1.4-.47.7-.36.31-.86 0-1.43-.16-.57-.17-.6-.27-1.24-.3l-2.3-.14s-.07-.03-.44-.03-.4.07-.57.47c-.17.4.03 1.41.44 1.91.4.5 1.7.74 2.57 1 .87.28 1.3.38 2.04.51.76.13.86 0 1.2-.5zM265.45 234.13c.7-.47.3-1.27.13-1.78-.16-.5-1.13-.6-1.63-.6s-.77 0-1.04.23c-.27.24-.64.57-1.37.8-.74.24-1.3.51-2.31.91-1 .4-1.3 1.08-1.74 1.35-.43.26-1.27 0-1.27 0s-.6-.17-.8 0c-.2.16 0 .5.4.93.4.44 1.17.4 2.04.68.87.26 1.04.06 1.37-.17.33-.24.6-.74 1.2-1.1.6-.38 1.91-.44 2.55-.51a6.15 6.15 0 0 0 2.49-.74zM265.45 231.08c.3.27.64.64.9.2.27-.43.7-1.34.4-1.88-.3-.53-.66-1-.66-1s-.5 1.54-.74 1.94c-.22.41-.19.47.11.74zM262.74 226.45c0-.87-.6-1.95-.6-1.95s-.2.8-.57 1.51c-.37.7-.74 1.08-.74 1.08s.87.23 1.2.23.72.01.72-.86zM257.73 228.3c.94-.2 1.44-.57 1.84-.9s.64-1.25.37-1.71c-.27-.48-.94-.98-1.2-.98h-.5s-.28.87-.64 1.31c-.37.44-.8.74-.77 1.3.03.57-.04 1.17.9.97zM259.63 224.04a1.6 1.6 0 0 0-.43-1.2l-.5-.5s-.07.66-.14 1.03-.1.44-.1.44.27.27.5.37c.23.09.63.3.66-.14zM248.07 200.25l.63-3.95c-.47-3.95-2.53-7.7-4.16-10.28a49.03 49.03 0 0 1-4.06-8.8 24.93 24.93 0 0 1-1.23-6.66c0-1.55.66-2.35.66-2.35s.29-.42.02-.69c-.26-.26-.68-.02-1.1.4s-.86 1.2-1.04 1.75c-.17.56-.17.75-.17.75s-.84-.2-2.19-.08c-1.34.1-1.98.22-2.03.5-.04.3.18.51 1.15.93.97.42 1.59.6 2.07 1.18.49.57 1.73 3.46 2.1 4.86.39 1.4 1.2 5.18 1.53 8.15s1.33 6.57 2.73 9.57c.46.99 2.97 5.67 5.09 4.73zM250.52 207.21c-.92.51-.88 4.25-.47 6.19.4 1.94 2.3 4.35 2.88 5 .57.64.7.64 1.01.47.31-.17.44-.17.44-.17s.82-.27 1.43-.74c.6-.48.37-1.67.27-2.73-.1-1.05-.92-3.16-2.4-5.6-1.49-2.46-2.24-2.94-3.15-2.43zM251.53 204.18c0-1.22-1.06-2.14-2.27-2.14a2.1 2.1 0 0 0-1.4.43c-1.23 1.1-.49 3.89 1.3 3.89.64 0 1.4-.11 1.86-.56.42-.39.51-1.04.51-1.62zM269.21 239.32c-.49-.09-.77-.28-1.5-.77-.7-.49-1.86-1.5-2.06-1.98-.2-.5-.2-.52-.89-.29-.69.23-1.66.2-2.4.23-.75.03.08.86.6 1.64.51.77.34 3.38.34 3.38s0 .23-.12.6c-.11.38-.03.64.17.72.2.09.32-.08.84-.69.51-.6 1.46-2.18 1.46-2.18l.95.23c.8.2 2.1.09 2.75-.11.68-.2.36-.7-.13-.78z'/%3e%3cpath fill='%23D4AF3A' d='M266.14 241.34c-.34-.06-.49-.09-.66.14-.17.23-.32.66-.4.9-.09.22-.06.42.14.6.2.17.5.37.5.37s.28.31.57.46c.28.14.34-.29.34-.6 0-.32.17-.9.17-1.27s-.3-.55-.65-.6z'/%3e%3cpath fill='%231D5E91' d='M396.62 216.11c-.84-.2-1.2-.52-1.2-.52s-.35-.04-.64.48c-.27.52-1.35 1.2-1.35 1.2s-1.51.4-1.72 1.43c-.2 1.04.52 1.4 1.24 1.28.72-.12 2.48-.48 3.23-1.4.76-.91.88-1.43 1.04-1.8.14-.34.23-.46-.61-.66zM398.97 207.85c-.55-2.3-2.03-5.16-4.9-6.58 0 0-1.08 3.79-1.4 4.98-.32 1.2-.32 1.16.6 1.4.91.24 3.86.88 4.46 1.04s1.6.67 1.24-.85zM385.29 205.7c.68.12.6-.16.84-1.08l1.43-5.46s-3.03-.12-5.66 1.16c-2.63 1.27-3.79 3.62-3.79 3.62s.68.28 2.48.68c1.8.4 4.03.95 4.7 1.07zM378.27 211.96c-1.07-.2-1.48-.32-1.48-.32s.68 2.6 1.8 4.03c1.12 1.44 2.35 2.15 4.67 2.2 2.3.03 4.06-1.24 4.34-2.24.28-1 .76-1.75.76-1.75s-4.19-.56-5.9-.96c-1.74-.4-3.13-.76-4.21-.96z'/%3e%3cpath fill='%23D4AF3A' d='M377.55 210.32c1.04.24 9.57 1.87 10.29 2.03.72.16 1.32.32 1.52.12.2-.2.32-.32 1.07-.6.76-.27.72-1.03.72-1.03s.2-.72.28-1.44c.08-.72.48-.96 1.32-.08.83.88 1 2.15 1.15 3.4.16 1.23 2.12 1.55 2.87 1.67.76.12 1.12-.12 1.56-.84.44-.72.68-2.15.8-3.07.12-.92.04-.84-.92-1.08-.96-.24-5.38-1.23-6.18-1.44-.8-.2-.64-.71-.52-1.27s1.87-6.18 1.87-6.18c-1.25-.78-3-1.24-5.1-1.48 0 0-1.28 5.74-1.52 6.62-.24.88-.8.88-1.71.72-.92-.16-7.54-1.71-7.54-1.71l-.52 1.23c-.52 1.24-.76 2.71-.76 3.47s.27.74 1.3.97z'/%3e%3cpath fill='%23D4AF3A' d='M400.2 215.51c-.88-.57-1.53-.73-1.99.34-.45 1.07-.5 2.64-1.64 3.75-1.14 1.11-2.75 2.26-4.35 2.14-1.6-.11-2.52-.5-2.14-2.33.38-1.83 2.83-2.4 3.4-3.36s.42-2.07-.42-2.8c-.84-.72-2.06-.88-2.4-.65a5.29 5.29 0 0 0-1.84 2.45c-.5 1.38-.8 2.49-1.87 3.37a8.1 8.1 0 0 1-5.96 1.26c-2.13-.5-2.9-1.15-3.7-3.25-.8-2.1-1.76-5.58-2.18-5.97-.42-.38-.95-.69-1.87-.04-.91.65-.99 1.61-1.1 2.38-.12.76 0 1.64.91 2.75.92 1.1 1.87 2.22 2.22 3.36.34 1.15 1.37 2.91-.08 2.99-1.45.07-2.1.11-3.2-.96-1.11-1.07-5.43-4.02-6.61-4.97-1.19-.96-1.68-1.26-1.68-1.26-2-.04-4-.86-6-2.22 0 0 1.15 2.94 1.38 4.05.23 1.11.19 1.72.19 1.72s4.35 2.22 6.07 3.06c1.72.84 5.2 2.83 6.87 3.86 1.68 1.04 3.1 2.64 6.07 2.03 2.98-.61 9.01-2.45 10.96-3.02 1.95-.57 7.33-1.91 9.32-3.29s2.17-1.3 2.52-2.68c.34-1.35 0-2.1-.88-2.69zM388.71 194.92c.33-.04.46-.09 1.48-.22 1.02-.14.64.84.46 1.21-.17.38-.48 1.13-.9 1.84-.42.7.13.82.42.93.28.11.7.15 1.52.38.82.22.66-.38.69-.69.02-.31.06-1.93.15-2.5.09-.57.62-.42.82-.3l1.12.6c.42.23.62-.01.7-.26s.3-.68.47-1.32c.18-.64-.22-.51-.62-.51s-.97 0-1.63-.02c-.66-.02-.24-.67-.24-.67L394 192c.37-.6.24-.68-.14-.8l-1.87-.46c-.33-.09-.49-.04-.49.18s-.04 1.37-.04 1.81c0 .44-.04.7-.62.73-.57.02-.93-.31-1.39-.82-.46-.5-.66-.3-.7-.1-.05.19-.43 1.65-.52 2.05-.1.39.11.37.44.32zM391.91 209.41s-.04 1.16-.16 1.55c-.12.4-.4 1 .08 1.16.48.16.92.36 1.2.28.28-.08.15-.64 0-1.11a4.27 4.27 0 0 0-.76-1.48l-.35-.4zM398.93 214.03c.16.36.48.44.72.52.24.08.56.08.56-.36s.08-1-.28-1.48c-.36-.48-.55-.82-.76-.12-.2.72-.4 1.1-.24 1.44zM374.48 209.37c.2.04.96.28.96.28s0-1.12.16-1.88c.15-.75.47-1.27.2-1.27s-.44.24-.64.56c-.2.31-.76.4-.96 1.31-.2.91.08.95.28 1z'/%3e%3ccircle cy='207.45' cx='379.27' r='1.56' fill='%23B96B29'/%3e%3ccircle cy='208.53' cx='383.65' r='1.59' fill='%23B96B29'/%3e%3ccircle cy='211.24' cx='396.42' r='1.6' fill='%23B96B29'/%3e%3ccircle cy='209.57' cx='388.04' r='1.6' fill='%23B96B29'/%3e%3ccircle cy='205.74' cx='389.2' r='1.6' fill='%23B96B29'/%3e%3ccircle cy='201.91' cx='390.32' r='1.6' fill='%23B96B29'/%3e%3ccircle cy='207.3' cx='379.38' r='.78' fill='%23D4AF3A'/%3e%3ccircle cy='208.37' cx='383.77' r='.8' fill='%23D4AF3A'/%3e%3ccircle cy='211.08' cx='396.54' r='.8' fill='%23D4AF3A'/%3e%3ccircle cy='209.41' cx='388.16' r='.8' fill='%23D4AF3A'/%3e%3ccircle cy='205.58' cx='389.32' r='.8' fill='%23D4AF3A'/%3e%3ccircle cy='201.75' cx='390.44' r='.8' fill='%23D4AF3A'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 639.97 0)' height='320' width='640'/%3e%3c/svg%3e";

var img$Q = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-60 -40 240 160'%3e%3crect x='-60' y='-40' width='100%25' height='100%25' fill='%23fe0000'/%3e%3crect x='-60' y='-40' width='50%25' height='50%25' fill='%23000095'/%3e%3cpath id='four_rays' d='M 8%2c0 L 0%2c30 L -8%2c0 L 0%2c-30 M 0%2c8 L 30%2c0 L 0%2c-8 L -30%2c0' fill='white'/%3e%3cuse xlink:href='%23four_rays' transform='rotate(30)'/%3e%3cuse xlink:href='%23four_rays' transform='rotate(60)'/%3e%3ccircle r='17' fill='%23000095'/%3e%3ccircle r='15' fill='white'/%3e%3c/svg%3e";

var img$P = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 600'%3e%3crect width='1000' height='300' y='300' fill='%2300a1de'/%3e%3crect width='1000' height='300' fill='%23ed2939'/%3e%3crect width='1000' height='200' y='200' fill='white'/%3e%3c/svg%3e";

var img$O = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1800 900'%3e%3crect width='1800' height='900' fill='%23cc092f'/%3e%3crect width='1200' height='900' fill='%23ffd200'/%3e%3crect width='600' height='900' fill='%230046ae'/%3e%3cg%3e%3cg%3e%3cpath fill='black' d='m847.69 183.24c-3.223 0-6.038 0.822-7.68 2.1 2.609 0.76 4.506 3.166 4.506 6.092v7.423h-7.422c-2.907 0-5.315-1.87-6.093-4.454-1.278 1.642-2.099 4.457-2.099 7.679 0 3.223 0.821 6.039 2.099 7.679 0.761-2.61 3.166-4.506 6.093-4.506h7.422v35.681c0 2.805-1.754 5.132-4.198 5.989 3.541 0.482 6.588 5.234 7.423 7.833 0.837-2.593 3.884-7.351 7.424-7.833-2.47-0.842-4.251-3.166-4.251-5.989v-35.683h7.424c2.908 0 5.315 1.87 6.093 4.456 1.277-1.642 2.098-4.459 2.098-7.68 0-3.223-0.82-6.038-2.098-7.679-0.761 2.609-3.167 4.504-6.093 4.504h-7.424v-7.422c0-2.908 1.869-5.315 4.455-6.093-1.64-1.276-4.457-2.098-7.679-2.098z'/%3e%3cpath fill='%23f5d402' d='m847.69 184.78c-1.678 0-3.156 0.314-4.402 0.716 1.664 1.447 2.765 3.544 2.765 5.939v7.423c0 0.106-0.031 0.207-0.052 0.308v1.177h-1.178c-0.1 0.021-0.202 0.051-0.307 0.052h-7.424c-2.367 0-4.439-1.083-5.886-2.713-0.416 1.259-0.768 2.697-0.768 4.403 0 1.678 0.314 3.156 0.716 4.402 1.447-1.664 3.543-2.763 5.938-2.763h8.959c-0.01 0.154-0.052 0.303-0.052 0.459v0.768c0.021 0.1 0.051 0.201 0.052 0.307v35.681c0 2.317-1.195 4.139-2.765 5.58 1.123 0.693 2.09 1.565 2.918 2.561 0.737 0.885 1.03 1.751 1.536 2.661 0.507-0.908 0.799-1.776 1.536-2.661 0.815-0.978 1.768-1.82 2.867-2.509-1.584-1.437-2.765-3.305-2.765-5.631v-37.168h1.229c0.1-0.02 0.201-0.05 0.307-0.05h7.423c2.366 0 4.438 1.083 5.886 2.712 0.415-1.258 0.769-2.695 0.769-4.402 0-1.677-0.315-3.156-0.717-4.402-1.447 1.664-3.543 2.763-5.938 2.763h-7.423c-0.105 0-0.207-0.031-0.307-0.052h-1.178v-1.177c-0.021-0.099-0.051-0.201-0.052-0.308v-7.422c0-2.367 1.084-4.438 2.713-5.887-1.259-0.414-2.696-0.768-4.402-0.768'/%3e%3cpath fill='black' d='m940.609%2c313.987c-4.535-3.221-8.258-6.862-10.904-11.11-6.372-10.223-9.061-22.773-9.061-35.527%2c0-5.391%2c6.04-11.46%2c6.04-15.82%2c0-6.59-0.614-10.544-0.614-10.544%2c2.143%2c0.292%2c5.887%2c4.095%2c5.887%2c4.095s-0.129-10.938-3.585-12.849c0%2c0%2c1.398-1.438%2c6.451-1.587-1.42-3.596-8.446-7.986-8.446-7.986%2c0.351-0.629%2c1-1.173%2c1.842-1.638%2c1.765-0.976%2c4.245-1.62%2c6.142-1.997-2.022-0.419-4.352-1.061-6.91-1.895-5.842-1.903-12.719-4.697-19.146-7.78-11.732-5.628-20.669-5.99-25.596-5.9895-3.575%2c0.0005-8.84%2c0.0985-11.927%2c2.1515-2.825%2c1.875-2.595%2c4.314-3.584%2c5.17-2.33%2c2.016-6.321%2c1.945-8.243%2c1.945-12.44%2c0-12.901%2c13.311-12.901%2c13.311s3.181-4.813%2c8.805-4.813c9.351%2c0%2c16.433%2c5.094%2c16.433%2c7.013%2c0%2c0.777-0.964%2c0.921-1.023%2c0.921-6.108%2c0-15.326-3.516-20.223-3.686v2.406c10.931%2c3.803%2c22.013%2c9.187%2c22.013%2c32.917%2c0%2c14.943-1.789%2c30.19-9.265%2c42.183-2.648%2c4.247-6.418%2c7.881-10.955%2c11.11l44.385%2c7.9995z'/%3e%3cg id='eagle_half'%3e%3cpath fill='black' d='m896.222%2c303.988-44.383%2c10.0005c-2.019-0.61-11.513-3.56-18.174-7.269-11.726-6.532-17.806-13.031-31.74-13.669v-10.598c0-5.662%2c2.049-10.763%2c2.049-16.177-5.874-1.575-22.178-21.51-37.218-30.358-22.13%2c14.334-39.265%2c37.865-39.265%2c48.686%2c0%2c0%2c0.665%2c232.51%2c0%2c313.51%2c0%2c4.668-2.815%2c11.263-2.815%2c11.263%2c8.079-3.418%2c22.888-23.68%2c26.006-31.382v3.687c12.201-5.564%2c21.135-20.184%2c25.136-27.747%2c0.071%2c1.093%2c0.257%2c3.838%2c0.257%2c3.838%2c10.9-9.555%2c24.776-66.038%2c24.776-66.038l23.124%2c22.7255s-8.363%2c16.9755-11.621%2c20.0155c0%2c0%2c2.184%2c0.277%2c4.658%2c0.256-1.522%2c2.188-13.147%2c18.925-16.791%2c25.238-3.41%2c5.906-5.816%2c3.277-11.058%2c3.277-4.347%2c0-14.2%2c6.925-15.818%2c9.727-1.701%2c2.945-2.968%2c6.523-2.968%2c9.471%2c0%2c3.24%2c3.43%2c7.679%2c3.43%2c7.679%2c0.369-1.551%2c1.023-2.099%2c1.023-2.099s9.013%2c11.228%2c10.341%2c12.695c1.034%2c1.143%2c5.645%2c1.886%2c7.27%2c0.411%2c4.066-3.697%2c8.002-6.282%2c11.621-11.621%2c1.863-2.751%2c2.005-5.904%2c4.146-8.858%2c7.162-9.88%2c21.415-28.799%2c24.675-33.121%2c0.218%2c1.203%2c0.405%2c2.205%2c0.612%2c3.43%2c3.694-7.457%2c21.451-21.706%2c21.451-21.706l18.578%2c8.55s-34.687%2c79.735-65.476%2c91.995c0%2c0%2c13.395%2c5.691%2c29.845%2c14.232%2c2.4%2c1.246%2c4.871%2c2.584%2c7.372%2c3.943%2c2.071-2.494%2c4.251-5.265%2c6.399-8.141%2c9.836-13.16%2c19.455-28.412%2c19.455-28.412%2c0.67%2c3.961-4.524%2c16.194-13.31%2c31.281-1.728%2c2.964-3.53%2c6.064-5.529%2c9.213%2c2.229%2c1.273%2c4.441%2c2.559%2c6.655%2c3.892%2c16.295%2c9.805%2c31.598%2c21.077%2c37.267%2c31.432l4%2c-10.009 -4%2c-10.009v-349.957l2%2c-5z'/%3e%3cg fill='%23b07f55'%3e%3cpath d='m896.202%2c667.221c-5.749-6.236-17.769-13.855-31.278-20.886%2c16.334-29.316%2c24.428-75.655%2c20.63-84.88%2c0%2c0-6.705%2c24.033-14.898%2c37.729-7.586%2c12.684-16.925%2c26.95-25.954%2c37.526-7.428-3.169-14.631-5.828-20.785-7.68%2c27.058-20.843%2c54.726-89.742%2c54.726-89.742l-28.612-13.26s-10.704%2c12.479-14.18%2c14.796c0%2c0-1.485-6.206-2.355-8.396%2c0%2c0-4.101%2c3.102-6.346%2c3.176%2c0%2c0-0.671-4.212-1.178-6.964-2.825%2c1.883-7.525%2c1.485-7.525%2c1.485%2c4.127-1.954%2c9.01-13.925%2c9.01-13.925l-27.322-36.343s-9.597%2c46.116-20.528%2c55.596v-198.58l8.652%2c8.036%2c13.105-12.235v-9.317l-11.621%2c10.852v-28.105c1.751-2.649%2c2.912-4.626%2c3.788-6.194%2c1.881%2c3.279%2c7.96%2c13.329%2c15.101%2c19.505%2c1.175-4.778%2c8.908-9.318%2c8.908-9.318s2.771%2c7.508%2c7.012%2c9.368c1.492-2.628%2c10.394-8.446%2c10.394-8.446s-7.616%2c1.157-10.7%2c4.045c-2.649-0.593-3.328-11.058-3.328-11.058s-11.207%2c5.459-13.156%2c9.368c-2.137-0.578-5.464-8.988-6.759-12.44%2c1.955-0.213%2c4.716-0.46%2c8.345-0.46%2c3.196%2c0%2c7.285%2c1.514%2c11.569%2c3.532%2c4.707%2c2.216%2c9.631%2c5.022%2c14.028%2c7.014%2c5.632%2c2.55%2c14.153%2c3.068%2c16.637%2c3.174-2.845%2c2-5.973%2c3.826-9.367%2c5.529%2c0%2c0%2c13.411-0.124%2c22.832-4.813%2c3.361-2.162%2c6.849-4.316%2c9.829-6.86-1.293%2c3.593-3.306%2c7.839-6.452%2c11.467%2c13.836-1.171%2c20.726-9.072%2c22.679-11.723%2c0.918%2c2.375%2c2.553%2c6.187%2c5.119%2c9.47h5v340z'/%3e%3cpath d='m794.247%2c267.298%2c0.255%2c6.348%2c0%2c18.687c-5.019-1.727-11.326-9.973-14.384-14.334v-2.56c0-2.408%2c1.417-4.167%2c2.457-5.119l-3.02-1.074c-1.152%2c1.313-2.406%2c3.263-2.406%2c5.784v1.485l-9.009%2c9.676-8.856-13.413v-3.276c0-2.208%2c1.698-4.67%2c3.123-6.348l-2.97-1.075c-1.499%2c1.942-3.072%2c4.559-3.072%2c7.013v2.661c-2.083%2c2.156-10.187%2c10.496-10.187%2c10.496s-4.066-8.737-5.17-11.109c6.205-8.595%2c16.266-18.219%2c25.7488-25.1245%2c0%2c0%2c20.5642%2c18.8805%2c27.4902%2c21.2825z'/%3e%3cpath d='m742.127%2c285.421%2c0%2c15.411-7.167%2c6.654%2c0-22.883c0-2.191%2c0.918-4.831%2c2.4565-7.731z'/%3e%3cpath d='m764.447%2c291.359%2c0%2c9.522-8.241%2c7.731%2c0-29.794z'/%3e%3cpath d='m753.286%2c308.561-8.243-7.679%2c0-11.159%2c8.243-8.652z'/%3e%3cpath d='m790.913%2c296.991c-1.914%2c2.705-6.927%2c9.321-12.337%2c12.236v-26.1605c1.241%2c2.0645%2c6.934%2c11.2745%2c12.337%2c13.9245z'/%3e%3cpath d='m775.656%2c284.397%2c0%2c24.163-8.243-7.679%2c0-8.549z'/%3e%3cpath d='m742.126%2c310.147%2c0%2c24.113-7.167-6.707%2c0-10.7z'/%3e%3cpath d='m753.28%2c317.878%2c0%2c8.651-8.244%2c7.678%2c0-24.0085z'/%3e%3cpath d='m764.438%2c310.2%2c0%2c24.01-8.241-7.731%2c0-8.549z'/%3e%3cpath d='m775.651%2c317.93%2c0%2c8.549-8.243%2c7.73%2c0-24.0095z'/%3e%3cpath d='m786.81%2c334.26-8.244-7.731%2c0-8.036c2.843-1.735%2c5.702-4.924%2c8.2435-8.2935z'/%3e%3cpath d='m765.925%2c344.908%2c8.703-8.089%2c0%2c198.63s0.607%2c9.856%2c1.024%2c16.279c-3.87%2c3.912-18.429%2c18.634-18.429%2c18.634v-233.596z'/%3e%3cpath d='m752.253%2c562.94c0%2c6.385-11.659%2c21.273-17.303%2c24.675v-250.74l8.6%2c8.036%2c8.703-8.0895z'/%3e%3c/g%3e%3cg fill='%23d10429'%3e%3cpath d='m824.535%2c541.388%2c6.348-4.352s0.423%2c2.1%2c0.972%2c4.967c-2.718%2c3.716-18.331%2c25.024-26.057%2c35.425-1.921%2c2.584-3.534%2c9.163-3.534%2c9.163s-2.814-1.331-2.814-3.736c0-2.362%2c0.308-5.171%2c0.308-5.171s-2.101%2c2.406-5.735%2c2.406c0-2.903%2c5.614-6.052%2c5.836-10.186-4.281%2c3.174-7.999%2c1.545-12.951%2c3.072-5.393%2c1.661-6.895%2c3.927-8.549%2c3.84-0.974-0.053-1.856-1.733-1.484-2.765%2c0.644-1.787%2c7.314-6.733%2c11.977-7.627%2c1.117-0.214%2c9.903%2c1.912%2c11.673-0.819%2c7.292-11.252%2c19.13-29.518%2c20.272-31.278%2c0.752-0.18%2c1.444-0.371%2c1.9955-0.719%2c0%2c0-0.0675%2c5.751%2c1.7425%2c7.78z'/%3e%3cpath d='m783.72%2c576.452c0.353%2c0.408%2c0.322%2c1.006-0.053%2c1.33l-2.866%2c2.508c-0.375%2c0.324-0.977%2c0.255-1.33-0.154-0.354-0.408-0.324-1.006%2c0.052-1.331l2.866-2.508c0.187-0.163%2c0.428-0.233%2c0.6655-0.204%2c0.2375%2c0.027%2c0.4875%2c0.154%2c0.6655%2c0.359z'/%3e%3cpath d='m788.071%2c579.472c0.857%2c0.988%2c0.802%2c2.388-0.103%2c3.175l-6.962%2c6.091c-0.906%2c0.788-2.367%2c0.63-3.226-0.357-0.857-0.988-0.803-2.439%2c0.103-3.225l6.962-6.041c0.339-0.296%2c0.802-0.477%2c1.229-0.5125%2c0.712-0.0585%2c1.46%2c0.2535%2c1.997%2c0.8695z'/%3e%3cpath d='m792.061%2c584.182c0.857%2c0.988%2c0.803%2c2.387-0.103%2c3.174l-7.012%2c6.092c-0.906%2c0.787-2.316%2c0.63-3.175-0.358-0.858-0.987-0.803-2.438%2c0.104-3.224l6.961-6.041c0.339-0.295%2c0.75-0.476%2c1.178-0.5125%2c0.711-0.0585%2c1.51%2c0.2515%2c2.047%2c0.8695z'/%3e%3cpath d='m794.464%2c587.919c0.713-0.058%2c1.461%2c0.201%2c1.997%2c0.819%2c0.858%2c0.988%2c0.803%2c2.439-0.102%2c3.225l-6.963%2c6.042c-0.906%2c0.787-2.316%2c0.629-3.174-0.359s-0.854-2.388%2c0.051-3.175l7.014-6.091c0.338-0.296%2c0.749-0.427%2c1.177-0.461z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23eagle_half' transform='matrix(-1%2c0%2c0%2c1%2c1792.404%2c0)'/%3e%3cpath fill='%23b07f55' d='m885.934%2c206.637c11.458%2c0%2c19.517%2c5.224%2c30.359%2c10.033%2c2.841%2c1.26%2c5.45%2c2.281%2c7.779%2c3.071-1.459%2c1.293-2.594%2c2.592-2.918%2c3.687%2c0%2c0%2c4.859%2c0.9%2c7.064%2c4.967%2c0%2c0-4.62%2c0.524-5.375%2c3.224%2c2.588%2c0.195%2c5.159%2c3.457%2c5.171%2c6.605l-6.553-2.049s1.587%2c7.358%2c1.587%2c15.358c0%2c4.086-5.886%2c8.894-5.886%2c15.819%2c0%2c21.734%2c5.475%2c30.088%2c9.369%2c36.807%2c1.523%2c2.629%2c2.761%2c5.654%2c5.324%2c7.935-11.218-5.973-19.556-13.439-19.556-20.374v-26.262h-2.918v26.262c0%2c5.029%2c1.228%2c7.372%2c1.228%2c7.372%2c1.761%2c5.564%2c5.321%2c14.152%2c7.526%2c17.61-10.321-5.578-15.564-12.563-15.564-15.153v-36.092h-2.918v36.603l0.563%2c2.508c-1.251%2c1.88-2.877%2c4.106-3.993%2c4.863-1.113-0.756-2.69-2.986-3.943-4.863l0.564-2.508v-36.603h-2.918v36.092c0%2c2.589-5.243%2c9.575-15.563%2c15.153%2c2.205-3.459%2c5.764-12.046%2c7.524-17.61%2c0%2c0%2c1.229-2.342%2c1.229-7.372v-26.262h-2.918v26.262c0%2c6.927-8.307%2c14.405-19.505%2c20.374%2c2.537-2.283%2c3.757-5.321%2c5.272-7.935%2c4.258-7.348%2c9.522-16.683%2c9.522-43.258%2c0-9.974-1.475-16.755-4.044-21.501-0.781-1.566-1.833-5.734%2c4.146-5.734%2c3.097%2c0%2c10.188%2c5.478%2c10.188%2c5.478s-0.292-4.371-3.891-6.86c-0.597-0.413-1.586-1.712-1.586-2.919%2c0-0.904%2c1.551-3.135%2c2.763-3.686%2c0.833-0.378-12.183-2.646-12.183-8.549%2c0-1.229%2c0.773-2.048%2c3.479-2.048%2c3.545%2c0%2c9.312%2c4.249%2c14.438%2c4.249%2c3.789%2c0%2c5.283-0.922%2c9.163-0.922%2c4.742%2c0%2c14.635%2c8.979%2c18.019%2c8.651-3.783-2.375-9.894-11.365-19.145-11.365-3.211%2c0-6.117%2c0.717-9.114%2c0.717-3.841%2c0-7.623-3.533-11.774-3.533-2.782%2c0-5.889%2c0.155-6.349-0.564-0.805-1.255-0.08-1.983%2c0.666-3.02%2c1.409-1.957%2c5.366-2.525%2c9.267-2.661%2c1.17-0.041%2c2.338-0.061%2c3.4325-0.0505%2c1.0905%2c0.0115%2c2.0995%2c0.0535%2c2.9715%2c0.0535z'/%3e%3cpath fill='%23cc092f' d='m848.73 220.69s2.419-4.581 8.534-4.581c2.556 0 10.992-0.177 10.992-0.177 1.124 2.921 6.249 7.802 6.249 12.878 0 0-5.202-9.377-19.723-9.377-3.649 0-6.054 1.256-6.054 1.256z'/%3e%3cpath fill='%23d10429' d='m872.34 230.6s-3.093 3.258-3.765 4.997c-3.061-1.16-8.399-6.661-8.399-6.661s4.525 2.642 12.163 1.664z'/%3e%3cpath fill='black' d='m867.44 221.97s-3.568-1.144-3.568-2.342c0-1.526 1.733-1.526 2.769-0.337 0.713 0.819 0.798 2.68 0.798 2.68z'/%3e%3cellipse fill='black' cx='882.798' cy='222.06' rx='5.112' ry='4.043'/%3e%3ccircle fill='%23f5d402' cx='882.8' cy='222.06' r='3.56'/%3e%3ccircle fill='black' cx='882.799' cy='222.06' r='1.511'/%3e%3c/g%3e%3cg%3e%3cg fill='black'%3e%3crect width='20.503' height='20.503' x='1052.3' y='157.29' transform='matrix(0.7902%2c0.4311%2c-0.1917%2c0.8793%2c0%2c0)'/%3e%3cpath d='m725.9 418.73-5.836 2.663 65.936 144.42h7.014zm77.762 170.32-4.76 4.915 2.969 6.553 5.784-2.662z'/%3e%3cpath d='m746.39 532.6s5.554 11.472 9.775 13.045c-2.183-0.595-9.271 2.006-9.271 2.006s12.499 11.165 23.1 11.898c8.99 0.619 13.355-3.868 13.355-3.868l-1.801-9.524s-5.5-6.642-14.302-9.707c-8.894-3.098-20.857-3.848-20.857-3.848z'/%3e%3cpath d='m788.26 512.05s-7.669 6.565-9.768 14.169c-2.1 7.605 1.368 16.247 1.368 16.247l6.444 12.021s8.931-4.753 12.73-11.86c3.799-7.108 2.406-16.698 2.406-16.698s-7.075 2.634-7.975 3.8c1.493-7.884-5.206-17.679-5.206-17.679z'/%3e%3cpath d='m763.61 508.98s-8.722 2.948-17.192 2.438c-8.068-0.487-14.777-7.262-14.777-7.262s6.688-4.526 9.989-3.923c-3.631-1.327-8.896-10.423-8.896-10.423s7.482-2.261 14.116 0.24c6.634 2.503 12.419 9.77 12.419 9.77l4.342 9.16z'/%3e%3cpath d='m766.61 466.38s4.362 9.032 3.328 12.171c1.353-2.09 6.474-5.345 6.474-5.345s3.096 14.624 0.135 23.656c-2.96 9.031-11.974 12.47-11.974 12.47l-9.943-19.337s-1.48-7.164 1.62-12.837c3.101-5.673 10.36-10.779 10.36-10.779z'/%3e%3cpath d='m709.86 442.47s9.427-0.99 18.051 2.583c7.21 2.993 9.42 8.433 9.42 8.433l3.551 9.52s-10.261 3.848-18.368 0.906c-8.108-2.945-14.065-12.68-14.065-12.68s5.666-2.149 7.823-1.343c-3.142-1.39-6.41-7.419-6.41-7.419v0.001z'/%3e%3cpath d='m739.51 424.8s4.137 5.313 4.261 11.424c1.103-3.249 6.268-6.84 6.268-6.84s5.312 12.855 4.146 21.982c-1.166 9.128-8.809 14.527-8.809 14.527l-9.531-18.092s-3.106-7.415-2.191-13.167c0.916-5.75 5.856-9.836 5.856-9.836z'/%3e%3cpath d='m706.86 390.2s-1.709 9.854 1.199 15.53c2.598 5.065 4.252 6.176 4.252 6.176-4.954-3.269-12.444-3.551-12.444-3.551s2.666 10.721 9.037 15.612 16.195 3.748 16.195 3.748 6.46-8.6 6.01-17.865c-0.449-9.265-7.808-19.197-7.808-19.197s-2.902 6.02-3.158 10.514c-1.878-4.633-13.285-10.966-13.285-10.966z'/%3e%3cpath d='m783.86 555.27 0.265 3.537c5.875 0.055 6.75-0.53 8.256 1.322 1.003 1.234 3.389 2.311 5.787 1.215 2.4-1.095 3.475-3.977 2.38-6.376s-3.326-2.92-5.475-2.496c-1.319 0.26-2.187 1.313-3.306 1.891-2.128 1.102-7.909 0.908-7.909 0.908z'/%3e%3cpath d='m783.35 552.57 2.859 2.095c-3.067 5.014-4.024 5.446-3.251 7.705 0.515 1.504 0.166 4.097-2.035 5.553-2.2 1.455-5.214 0.841-6.669-1.358-1.454-2.2-0.715-4.366 0.783-5.965 0.92-0.982 2.27-1.16 3.353-1.803 2.062-1.223 4.959-6.228 4.959-6.228z'/%3e%3cpath d='m763.45 510.57 0.264 3.537c5.876 0.054 6.75-0.53 8.256 1.321 1.002 1.233 3.389 2.311 5.787 1.215 2.401-1.095 3.476-3.976 2.379-6.375-1.095-2.4-3.325-2.92-5.474-2.496-1.32 0.261-2.187 1.313-3.305 1.891-2.129 1.101-7.909 0.908-7.909 0.908z'/%3e%3cpath d='m764.64 511.82 2.5 2.517c-3.809 4.474-4.824 4.753-4.411 7.104 0.276 1.567-0.473 4.075-2.874 5.17-2.399 1.095-5.279 0.021-6.376-2.379-1.095-2.399-0.028-4.425 1.701-5.771 1.061-0.825 2.425-0.793 3.593-1.258 2.227-0.887 5.867-5.382 5.867-5.382z'/%3e%3cpath d='m743.67 468.72 0.265 3.537c5.876 0.054 6.75-0.53 8.257 1.323 1.003 1.231 3.388 2.309 5.788 1.213 2.398-1.095 3.474-3.975 2.379-6.377-1.097-2.399-3.326-2.919-5.476-2.495-1.32 0.261-2.187 1.313-3.306 1.891-2.128 1.102-7.908 0.907-7.908 0.907z'/%3e%3cpath d='m745.3 467.98 2.499 2.516c-3.809 4.475-4.822 4.754-4.411 7.105 0.276 1.566-0.473 4.074-2.873 5.169-2.399 1.094-5.28 0.02-6.376-2.379-1.094-2.4-0.027-4.426 1.701-5.771 1.061-0.827 2.424-0.793 3.594-1.26 2.227-0.887 5.866-5.38 5.866-5.38z'/%3e%3cpath d='m722.6 424.54 0.264 3.536c5.876 0.055 6.751-0.53 8.256 1.321 1.004 1.234 3.39 2.311 5.788 1.217 2.4-1.097 3.475-3.977 2.38-6.377s-3.326-2.921-5.476-2.496c-1.318 0.261-2.186 1.314-3.305 1.891-2.128 1.101-7.909 0.908-7.909 0.908z'/%3e%3cpath d='m724.23 423.8 2.498 2.517c-3.808 4.475-4.823 4.753-4.41 7.105 0.276 1.566-0.474 4.074-2.873 5.169-2.4 1.095-5.28 0.021-6.375-2.379-1.096-2.399-0.028-4.427 1.699-5.771 1.062-0.825 2.425-0.793 3.594-1.26 2.226-0.886 5.866-5.38 5.866-5.38z'/%3e%3c/g%3e%3cg fill='%23f5d402'%3e%3crect width='12.717' height='12.718' x='1056.2' y='161.19' transform='matrix(0.7902%2c0.4311%2c-0.1917%2c0.8793%2c0%2c0)'/%3e%3cpath d='m759.72 500.09c-2.106 0.874-5.23-8.295-7.524-13.318-2.353-5.155-7.131-13.1-5.774-13.72 1.489-0.68 3.451 3.492 5.859 8.767 2.408 5.273 9.412 17.449 7.439 18.269z'/%3e%3cpath d='m738.09 451.8c-2.105 0.877-4.41-5.127-6.703-10.151-2.353-5.154-4.645-8.795-3.288-9.415 1.49-0.68 3.69 3.837 5.616 8.055 1.866 4.088 6.348 10.69 4.374 11.512z'/%3e%3cpath d='m788.13 561.29c-1.653 0.442-8.869-14.662-14.703-27.442-5.833-12.779-10.177-23.119-8.82-23.736 1.49-0.681 6.213 11.391 12.049 24.172 5.835 12.781 12.713 26.673 11.475 27.006z'/%3e%3c/g%3e%3cg fill='%23097754'%3e%3cpath d='m709.76 396.19s-0.255 7.201 2.127 11.285c2.383 4.086 7.704 5.715 7.704 5.715s0.254-7.199-2.128-11.283c-2.383-4.086-7.703-5.717-7.703-5.717z'/%3e%3cpath d='m704.78 412.48s6.255 0.368 9.868 3.136c3.61 2.768 5.009 8.535 5.009 8.535s-4.146 0.421-7.756-2.347c-3.611-2.769-7.121-9.324-7.121-9.324z'/%3e%3cpath d='m724.41 397.94s-2.08 4.77-1.84 9.912c0.239 5.143 3.24 10.937 3.24 10.937s2.713-6.174 2.474-11.318c-0.238-5.143-3.147-8.075-3.874-9.531z'/%3e%3cpath d='m713.88 444.3s3.071 4.288 7.799 6.626c4.728 2.337 11.773 2.424 11.773 2.424s-3.516-4.562-8.245-6.9c-4.728-2.337-11.327-2.152-11.327-2.152z'/%3e%3cpath d='m715.4 454.26s2.257 4.421 6.384 6.316c4.129 1.896 12.574 1.74 12.574 1.74s-3.24-4.131-7.368-6.027c-4.128-1.897-11.591-2.029-11.591-2.029z'/%3e%3cpath d='m739.17 430.68s-2.495 4.123-2.251 8.666c0.245 4.545 3.227 9.511 3.227 9.511s2.097-5.693 1.852-10.237c-0.244-4.545-2.829-7.94-2.829-7.94z'/%3e%3cpath d='m748.36 436.51s-4.269 5.73-4.882 11.621c-0.613 5.89 2.428 11.942 2.428 11.942s5.157-5.178 5.77-11.068c0.613-5.892-3.316-12.493-3.316-12.493z'/%3e%3cpath d='m736.59 490.91s0.513 2.118 2.297 4.367c1.783 2.251 4.836 4.632 4.836 4.632s2.949-0.948 6.615-0.155c3.665 0.795 8.54 4.06 8.54 4.06s-5.247-7.831-10.695-10.876c-5.448-3.043-11.591-2.029-11.591-2.029z'/%3e%3cpath d='m736.05 504.37s6.793-2.902 12.387-2.153c5.595 0.749 10.639 5.171 10.639 5.171s-7.561 2.616-13.155 1.868c-5.596-0.749-9.872-4.886-9.872-4.886z'/%3e%3cpath d='m764.76 472.79s-6.007 6.364-6.511 11.887c-0.503 5.522 4.871 10.669 4.871 10.669s-0.264-3.542 0.661-5.874c0.926-2.332 2.893-4.822 2.893-4.822s0.838-2.843 0.514-5.123c-0.453-3.186-2.428-6.737-2.428-6.737z'/%3e%3cpath d='m773.38 480.16s-5.662 5.729-7.158 11.864c-1.497 6.135 1.17 12.676 1.17 12.676s5.149-4.062 6.646-10.196c1.497-6.135-0.659-14.344-0.659-14.344z'/%3e%3cpath d='m787.56 517.14s2.565 5.355 3.215 9.833c0.652 4.477 0.048 6.027 0.048 6.027s-2.652 2.607-3.841 4.14c-1.528 1.97-1.752 5.576-1.752 5.576s-5.325-7.916-4.504-13.703c0.82-5.786 6.834-11.874 6.834-11.874z'/%3e%3cpath d='m798.78 529.53s-6.818 4.503-9.523 9.123c-2.708 4.617-1.304 9.349-1.304 9.349s4.858-0.428 7.566-5.046c2.706-4.618 3.26-13.427 3.26-13.427z'/%3e%3cpath d='m753.98 548.55s9.826-0.268 15.832 1.209c6.006 1.475 8.192 4.695 8.192 4.695s-6.753 3.162-12.759 1.686c-6.006-1.475-11.266-7.591-11.266-7.591z'/%3e%3cpath d='m752.32 536.89s4.433 6.873 10.164 9.367c7.898 3.435 17.043 1.77 17.043 1.77s-4.968-6.089-11.804-8.777c-6.838-2.687-15.403-2.359-15.403-2.359z'/%3e%3c/g%3e%3cpath fill='black' d='m1088.74%2c401.944%2c1.281%2c2.712s-2.08%2c0.714-3.022%2c2.559c-0.94%2c1.847%2c0.615%2c4.455%2c0.615%2c4.455s-10.804-0.943-12.491%2c0.154c-1.528%2c0.99%2c0.647%2c8.474-0.359%2c14.795-1.402%2c8.81-4.875%2c8.07-5.017%2c9.777-0.138%2c1.659%2c1.331%2c4.249%2c1.331%2c4.249s-2.026%2c0.638-2.458%2c1.485c-0.695%2c1.362%2c0.484%2c3.875-0.358%2c5.528-4.7%2c9.223-11.64%2c22.836-16.228%2c31.843-0.641%2c1.257-2.363%2c1.737-3.226%2c3.43-0.796%2c1.562-0.153%2c3.839-0.153%2c3.839s-3.041%2c0.182-4.096%2c2.253c-1.121%2c2.2-0.461%2c5.17-0.461%2c5.17s-1.923%2c0.246-2.868%2c2.099c-1.009%2c1.981%2c0.7%2c3.02%2c0.259%2c3.891-6.169%2c12.102-13.434%2c26.368-17.867%2c35.068-1.631%2c3.199-7.338%2c3.84-10.65%2c10.341-3.214%2c6.306%2c1.382%2c10.955%2c1.382%2c10.955s-4.772%2c0.432-6.04%2c2.919c-1.292%2c2.535-0.27%2c6.384%2c3.174%2c8.139%2c3.444%2c1.754%2c7.207%2c0.334%2c8.5-2.201%2c1.267-2.487-1.281-6.604-1.281-6.604s6.463%2c0.931%2c9.675-5.376c3.313-6.501%2c0.52-11.441%2c2.15-14.641%2c4.434-8.7%2c11.7-22.965%2c17.867-35.068%2c0.445-0.871%2c2.267-0.117%2c3.276-2.098%2c0.944-1.853%2c0-3.532%2c0-3.532s2.822-1.23%2c3.943-3.431c1.056-2.071-0.563-4.658-0.563-4.658s2.223-0.792%2c3.02-2.354c0.862-1.693%2c0.228-3.35%2c0.869-4.609%2c4.59-9.006%2c11.531-22.62%2c16.229-31.841%2c0.843-1.655%2c3.555-2.221%2c4.249-3.585%2c0.432-0.846-0.255-2.866-0.255-2.866s2.988-0.296%2c4.248-1.383c1.298-1.118-1.337-3.516%2c4.967-9.829%2c4.522-4.528%2c11.817-7.192%2c11.722-9.01-0.105-2.01-7.218-10.187-7.218-10.187s3.001-0.253%2c3.942-2.098c0.941-1.846%2c0.308-3.994%2c0.308-3.994l2.968-0.512%2c0.0005-14.078zm-98.136%2c196.074c-0.448%2c0.877-0.53%2c2.076%2c0%2c3.121%2c0%2c0-3.583-1.12-4.812-0.512-1.158%2c0.573%2c0%2c17.458%2c0%2c17.458s14.295-9.018%2c14.077-10.29c-0.23-1.352-3.225-3.635-3.225-3.635%2c1.158-0.186%2c2.061-0.912%2c2.509-1.791%2c0.47-0.925%2c0.533-3.568-2.714-5.223-1.216-0.62-2.299-0.804-3.1745-0.716-1.4555%2c0.147-2.3655%2c1.01-2.6605%2c1.588z'/%3e%3cg fill='%23f5d402'%3e%3cpath d='m1091.34%2c402.51%2c6.757%2c3.431-0.101-8.1405z'/%3e%3cpath d='m1088.73%2c407.425c-0.868%2c1.704-0.025%2c3.886%2c1.894%2c4.863%2c1.92%2c0.977%2c4.148%2c0.373%2c5.018-1.33%2c0.868-1.704%2c0.023-3.885-1.895-4.863-0.72-0.367-1.476-0.511-2.2015-0.4615-1.2075%2c0.0825-2.2725%2c0.7265-2.8155%2c1.7915z'/%3e%3cpath d='m1077.11%2c413.62c-0.711%2c0.46%2c0.256%2c6.545%2c0.051%2c11.722-0.194%2c4.882-1.756%2c6.257-2.611%2c7.935-0.789%2c1.549-3.634%2c3.379-3.634%2c3.379l2.354%2c2.355s1.532-2.386%2c3.942-7.118c2.843-5.579%2c2.751-15.688%2c3.585-16.227%2c0.725-0.469%2c6.655-1.946%2c6.655-1.946-0.001%2c0-5.442-0.294-8.447-0.2545-1.003%2c0.0125-1.73%2c0.0475-1.895%2c0.1545z'/%3e%3cpath d='m1077.73%2c441.725s0.787-2.188%2c3.533-7.577c3.311-6.499%2c10.379-11.213%2c10.544-12.389%2c0.172-1.212-2.4565-6.9105-2.4565-6.9105s-6.2355%2c1.1955-7.1175%2c2.0485c-0.852%2c0.823-0.476%2c9.267-3.788%2c15.767-2.744%2c5.388-4.094%2c7.372-4.094%2c7.372z'/%3e%3cpath d='m1093.65%2c422.22c0.052%2c0.989-8.163%2c6.861-11.007%2c12.439-2.41%2c4.731-3.43%2c7.373-3.43%2c7.373l3.277%2c0.512s-0.226-3.367%2c0.563-4.915c0.854-1.677%2c1.079-3.731%2c4.915-6.757%2c4.068-3.209%2c9.567-6.014%2c9.522-6.861-0.041-0.782-6.1435-8.344-6.1435-8.344s2.2565%2c5.692%2c2.3035%2c6.553z'/%3e%3cpath d='m1069.59%2c458.72c4.936-9.688%2c6.444-10.348%2c7.065-11.569%2c0.669-1.312%2c0.509-3.078-1.689-4.199-0.824-0.419-1.531-0.526-2.1495-0.459-1.0335%2c0.111-1.7845%2c0.767-2.2015%2c1.586-0.622%2c1.222-0.285%2c2.855-5.223%2c12.544l-11.212%2c21.961s-1.175%2c2.156%2c1.024%2c3.276c2.199%2c1.119%2c3.174-1.127%2c3.174-1.127z'/%3e%3cpath d='m1049.78%2c483.908c-0.611%2c1.201%2c0.436%2c2.964%2c2.355%2c3.943%2c1.919%2c0.976%2c3.996%2c0.791%2c4.607-0.41%2c0.611-1.2-0.486-2.964-2.406-3.943-0.959-0.489-1.935-0.687-2.7645-0.613-0.8295%2c0.072-1.4855%2c0.424-1.7915%2c1.023z'/%3e%3cpath d='m1045.63%2c490.153c-0.792%2c1.553%2c0.443%2c3.783%2c2.765%2c4.968%2c2.322%2c1.183%2c4.84%2c0.886%2c5.631-0.667%2c0.792-1.554-0.444-3.782-2.765-4.967-0.871-0.442-1.733-0.677-2.5595-0.716-1.3745-0.065-2.5765%2c0.411-3.0715%2c1.382z'/%3e%3cpath d='m1043.02%2c497.117c-0.611%2c1.199%2c0.437%2c2.963%2c2.355%2c3.941%2c1.919%2c0.978%2c3.995%2c0.791%2c4.608-0.409%2c0.611-1.2-0.437-2.964-2.355-3.942-0.96-0.49-1.986-0.688-2.8155-0.615-0.8285%2c0.073-1.4855%2c0.424-1.7925%2c1.025z'/%3e%3cpath d='m1041.33%2c503.772s-12.448%2c24.5-16.84%2c33.121c-1.404%2c2.754-7.312%2c4.47-9.625%2c9.011-2.33%2c4.568-0.686%2c8.844%2c2.354%2c10.392%2c3.039%2c1.549%2c7.502%2c0.423%2c9.83-4.146%2c2.313-4.54%2c0.235-10.353%2c1.637-13.106%2c4.393-8.624%2c16.843-33.122%2c16.843-33.122s1.226-2.156-0.973-3.276c-0.55-0.28-1.028-0.308-1.433-0.2555-1.212%2c0.1555-1.793%2c1.3815-1.793%2c1.3815z'/%3e%3cpath d='m1009.84%2c560.646c-0.933%2c1.83%2c0.134%2c4.269%2c2.405%2c5.426%2c2.272%2c1.158%2c4.904%2c0.601%2c5.837-1.228%2c0.933-1.83-0.186-4.27-2.457-5.427-0.852-0.435-1.721-0.637-2.56-0.6135-1.399%2c0.0395-2.643%2c0.6995-3.225%2c1.8425z'/%3e%3cpath d='m993.257%2c598.069c-0.71%2c0.024-1.298%2c0.249-1.535%2c0.717-0.477%2c0.935%2c0.508%2c2.413%2c2.201%2c3.276%2c1.693%2c0.862%2c3.464%2c0.782%2c3.942-0.154%2c0.477-0.937-0.51-2.414-2.201-3.276-0.847-0.432-1.695-0.588-2.407-0.564z'/%3e%3cpath d='m987.421%2c602.675v12.082l9.83-7.065s-1.333-2.354-4.25-3.84c-2.917-1.485-5.58-1.178-5.58-1.178z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3cpath fill='%23f5d402' d='m993.643%2c333.597c0-6.626%2c8.703-13.157%2c8.703-13.157h-212.246s8.703%2c6.53%2c8.703%2c13.157v157.986c0%2c4.162%2c1.286%2c6.872%2c3.328%2c9.521%2c2.041%2c2.853%2c6.39%2c6.795%2c10.903%2c9.727%2c13.94%2c9.053%2c37.246%2c18.599%2c54.88%2c26.621%2c14.694%2c6.684%2c20.671%2c9.381%2c28.309%2c18.839%2c7.639-9.458%2c13.667-12.154%2c28.361-18.839%2c17.631-8.021%2c40.938-17.568%2c54.879-26.621%2c4.515-2.932%2c8.864-6.873%2c10.904-9.727%2c2.042-2.649%2c3.276-5.359%2c3.276-9.521z'/%3e%3cpath fill='%23d10429' d='m803.82%2c422.981%2c0-89.385c0-5.059-2.5605-8.139-2.5605-8.139h189.928s-2.56%2c3.081-2.56%2c8.139l0.054%2c89.385-92.4305%2c28z'/%3e%3cpath fill='%230b45bb' d='m988.681%2c422.981-57.234-1.075-70.393%2c0-57.234%2c1.075%2c0%2c68.601c0%2c3.448%2c3.578%2c11.525%2c24.215%2c21.807%2c34.111%2c16.998%2c60.33%2c24.934%2c68.189%2c34.607%2c7.858-9.673%2c34.077-17.61%2c68.189-34.607%2c20.636-10.282%2c24.214-18.359%2c24.214-21.807z'/%3e%3cg fill='black'%3e%3cpath d='m930.063%2c419.401s33.019-8.326%2c33.019-43.617c0-27.563-33.103-41.237-34.044-47.814-3.235%2c11.381%2c11.058%2c27.1%2c11.058%2c45.715%2c0%2c24.086-17.764%2c25.239-17.764%2c25.239-4.157%2c0-5.841%2c2.968-7.475%2c2.968-3.497-0.365-5.143-4.813-8.601-4.813-3.247%2c0-5.74%2c5.017-10.033%2c5.017-4.292%2c0-6.735-5.017-9.983-5.017-3.456%2c0-5.103%2c4.448-8.6%2c4.813-1.634%2c0-3.319-2.968-7.476-2.968%2c0%2c0-17.763-1.153-17.763-25.239%2c0-18.615%2c14.295-34.336%2c11.058-45.715-0.938%2c6.577-34.041%2c20.25-34.041%2c47.814%2c0%2c35.291%2c33.019%2c43.617%2c33.019%2c43.617l-9.42%2c17.149s13.645%2c0.683%2c20.887%2c6.861c8.733%2c7.448%2c7.883%2c23.229%2c7.883%2c34.709%2c0%2c9.045-1.143%2c18.59-5.784%2c22.524-6.232%2c5.284-10.445%2c5.675-10.445%2c11.878%2c0%2c5.174%2c3.977%2c6.211%2c10.445%2c9.625%2c8.287%2c4.373%2c7.901%2c10.238%2c20.22%2c10.238%2c12.321%2c0%2c11.985-5.864%2c20.273-10.238%2c6.468-3.414%2c10.444-4.451%2c10.444-9.625%2c0-6.203-4.214-6.594-10.444-11.878-4.641-3.936-5.784-13.48-5.784-22.524%2c0-11.48-0.849-27.261%2c7.883-34.709%2c7.243-6.177%2c20.886-6.861%2c20.887-6.861z'/%3e%3cpath d='m896.22%2c330.42-5.735%2c16.281-15.614-7.424%2c7.423%2c15.615-16.279%2c5.784%2c16.279%2c5.785-7.423%2c15.563%2c15.614-7.423%2c5.735%2c16.279%2c5.785-16.279%2c15.614%2c7.423-7.422-15.563%2c16.279-5.785-16.279-5.784%2c7.422-15.615-15.614%2c7.424-5.785-16.281z'/%3e%3cpath d='m861.05%2c421.91s-20.387-4.984-28.002-15.051c-13.313%2c11.976-29.232%2c16.126-29.232%2c16.126s16.607%2c7.498%2c29.232%2c17.048c5.817-8.336%2c28.002-18.123%2c28.002-18.123z'/%3e%3cpath d='m931.44%2c421.91s22.186%2c9.786%2c28.004%2c18.123c12.623-9.55%2c29.229-17.048%2c29.229-17.048s-15.917-4.151-29.229-16.126c-7.615%2c10.066-28.004%2c15.051-28.004%2c15.051z'/%3e%3cpath d='m869.4%2c443.61-7.935%2c7.934%2c7.935%2c7.935%2c7.935-7.935-7.935-7.934z'/%3e%3cpath d='m923.1%2c443.61-7.934%2c7.934%2c7.934%2c7.935%2c7.935-7.935-7.935-7.934z'/%3e%3cpath d='m867.403%2c489.94c0%2c10.025-0.972%2c15.307-0.972%2c15.307s11.186-3.293%2c13.414-14.641c1.044-5.32%2c2.207-24.918-3.175-28.259l-14.5895-2.867c1.5755%2c3.899%2c5.3225%2c15.977%2c5.3225%2c30.46z'/%3e%3cpath d='m915.829%2c462.348c-5.381%2c3.34-4.218%2c22.938-3.174%2c28.259%2c2.227%2c11.348%2c13.413%2c14.641%2c13.413%2c14.641s-0.972-5.282-0.972-15.307c0-14.483%2c3.747-26.562%2c5.3245-30.4605z'/%3e%3cpath d='m833.005%2c462.915c-5.031%2c1.262-8.071%2c6.385-6.808%2c11.416%2c0.193%2c0.77%2c0.511%2c1.481%2c0.87%2c2.15-0.733-0.244-1.498-0.406-2.304-0.461-0.323-0.022-0.655-0.011-0.972%2c0-4.761%2c0.16-8.73%2c3.903-9.061%2c8.755-0.354%2c5.174%2c3.579%2c9.629%2c8.755%2c9.983%2c0.772%2c0.052%2c1.523%2c0.024%2c2.251-0.103-0.445%2c0.611-0.83%2c1.263-1.125%2c1.996-1.937%2c4.813%2c0.409%2c10.351%2c5.222%2c12.288%2c4.812%2c1.935%2c10.298-0.461%2c12.234-5.273%2c0.296-0.735%2c0.461-1.452%2c0.564-2.202%2c0.443%2c0.615%2c0.976%2c1.179%2c1.586%2c1.689%2c3.979%2c3.328%2c9.931%2c2.801%2c13.259-1.177%2c3.329-3.978%2c2.801-9.881-1.178-13.208-0.602-0.504-1.27-0.9-1.945-1.228%2c0.723-0.232%2c1.426-0.552%2c2.098-0.972%2c4.395-2.755%2c5.725-8.609%2c2.969-13.004-1.894-3.021-5.222-4.574-8.549-4.351-1.513%2c0.101-3.029%2c0.572-4.403%2c1.434-0.671%2c0.421-1.267%2c0.888-1.791%2c1.433%2c0.001-0.756-0.064-1.534-0.256-2.303-1.104-4.403-5.151-7.305-9.5215-7.117-0.6245%2c0.027-1.2655%2c0.098-1.8945%2c0.255z'/%3e%3cpath d='m932.825%2c490.25c1.017%2c9.587%2c8.808%2c17.619%2c18.429%2c19.914-1.643-2.687-2.735-5.682-3.072-8.856-1.205-11.37%2c7.588-20.581%2c19.607-20.581%2c1.894%2c0%2c3.729%2c0.234%2c5.528%2c0.667-4.237-6.947-12.215-11.775-20.887-11.7745-12.018%2c0.0005-20.813%2c9.2625-19.605%2c20.6305z'/%3e%3c/g%3e%3cg fill='%23ffd200'%3e%3cpath d='m847.592%2c373.684c0%2c18.128%2c9.667%2c28.821%2c22.576%2c28.821%2c2.462%2c0%2c5.155%2c3.328%2c7.475%2c3.328%2c3.782%2c0%2c6.298-4.198%2c8.601-4.198%2c2.927%2c0%2c4.9%2c4.607%2c9.982%2c4.607%2c5.083%2c0%2c7.107-4.607%2c10.034-4.607%2c2.302%2c0%2c4.818%2c4.198%2c8.6%2c4.198%2c2.321%2c0%2c5.012-3.328%2c7.475-3.328%2c12.909%2c0%2c22.577-10.693%2c22.577-28.821%2c0-14.784-12.416-32.81-11.058-35.734%2c0%2c0%2c24.214%2c17.369%2c24.214%2c37.832%2c0%2c32.963-33.429%2c41.109-33.429%2c41.109l7.525%2c16.944s-10.362%2c1.554-16.689%2c6.656c-8.439%2c6.805-8.55%2c25.191-8.55%2c37.626%2c0%2c14.648%2c0.545%2c20.855%2c5.837%2c24.829%2c5.58%2c4.193%2c9.777%2c5.096%2c9.777%2c9.369%2c0%2c3.723-4.345%2c5.246-9.983%2c7.73-6.413%2c2.827-7.052%2c7.731-16.33%2c7.731-9.279%2c0-9.867-4.904-16.28-7.731-5.637-2.484-9.983-4.006-9.983-7.73%2c0-4.273%2c4.197-5.176%2c9.777-9.369%2c5.292-3.974%2c5.836-10.181%2c5.836-24.829%2c0-12.435-0.11-30.821-8.549-37.626-6.328-5.104-16.689-6.656-16.689-6.656l7.524-16.944s-33.428-8.145-33.428-41.109c0-20.463%2c24.215-37.832%2c24.215-37.832%2c1.358%2c2.924-11.057%2c20.95-11.057%2c35.734zm35.988%2c136.126c-6.567%2c0-10.75%2c1.386-10.75%2c3.379%2c0%2c1.994%2c4.184%2c3.328%2c10.75%2c3.328%2c1.75%2c0%2c3.737-1.019%2c3.737-3.328s-1.988-3.379-3.737-3.379zm25.34%2c0c-1.75%2c0-3.737%2c1.071-3.737%2c3.379-0.001%2c2.309%2c1.987%2c3.328%2c3.737%2c3.328%2c6.568%2c0%2c10.75-1.333%2c10.75-3.328%2c0-1.994-4.183-3.379-10.75-3.379z'/%3e%3cpath d='m896.28%2c341.38%2c3.686%2c10.394%2c9.931-4.761-4.71%2c9.982%2c10.342%2c3.687-10.342%2c3.686%2c4.71%2c9.931-9.931-4.71-3.737%2c10.341-3.686-10.341-9.931%2c4.71%2c4.71-9.931-10.341-3.686%2c10.341-3.687-4.71-9.982%2c9.931%2c4.761%2c3.737-10.394z'/%3e%3cpath d='m850.147%2c422.528c-0.002%2c0-17.099%2c12.696-17.099%2c12.696l-0.206%2c0.255-0.358-0.307-18.941-11.877s12.087-4.167%2c19.1975-11.4155c6.7285%2c7.7035%2c17.4065%2c10.6485%2c17.4065%2c10.6485z'/%3e%3cpath d='m978.948%2c423.295s-12.609%2c6.28-18.943%2c11.877l-0.357%2c0.307-0.204-0.255c-5.986-6.871-17.098-12.696-17.098-12.696s10.676-2.945%2c17.4045-10.648c7.1115%2c7.248%2c19.1975%2c11.415%2c19.1975%2c11.415z'/%3e%3cpath d='m869.4%2c447.4%2c4.147%2c4.145-4.147%2c4.199-4.198-4.199%2c4.198-4.145z'/%3e%3cpath d='m923.1%2c447.4%2c4.199%2c4.145-4.199%2c4.199-4.146-4.199%2c4.146-4.145z'/%3e%3cpath d='m875.033%2c465.519c2.897%2c3.998%2c2.405%2c10.462%2c2.405%2c19.455%2c0%2c9.067-6.808%2c12.541-6.808%2c12.541%2c0-21.794-2.247-27.034-3.43-33.6345z'/%3e%3cpath d='m925.3%2c463.88c-1.185%2c6.602-3.429%2c11.841-3.429%2c33.634%2c0%2c0-6.809-3.474-6.809-12.541%2c0-8.993-0.492-15.455%2c2.406-19.454l7.832-1.639z'/%3e%3cpath id='leaf' d='m842.832%2c472.128c0.204%2c0.816%2c0.226%2c1.618%2c0.153%2c2.407-0.06%2c0.654-0.234%2c1.248-0.46%2c1.842-1.133-0.414-2.359-0.615-3.635-0.615-3.159%2c0-5.987%2c1.39-7.935%2c3.585-0.511-0.452-0.955-0.952-1.33-1.536-0.42-0.649-0.775-1.359-0.973-2.15-0.982-3.913%2c1.411-7.876%2c5.324-8.857%2c0.488-0.124%2c1-0.185%2c1.4845-0.2045%2c3.3925-0.1455%2c6.5115%2c2.1055%2c7.3715%2c5.5285z'/%3e%3cuse xlink:href='%23leaf' transform='rotate(72%2c838.89%2c486.468)'/%3e%3cuse xlink:href='%23leaf' transform='rotate(144%2c838.89%2c486.468)'/%3e%3cuse xlink:href='%23leaf' transform='rotate(216%2c838.89%2c486.468)'/%3e%3cuse xlink:href='%23leaf' transform='rotate(288%2c838.89%2c486.468)'/%3e%3ccircle cx='838.890' cy='486.468' r='7.065'/%3e%3cpath d='m962.925%2c476.942c-11.729%2c2.268-20.17%2c12.628-18.942%2c24.727-3.738-3.096-6.473-7.266-6.962-11.877-0.951-8.979%2c5.571-15.922%2c15.4095-15.922%2c3.7615%2c0%2c7.3755%2c1.152%2c10.4945%2c3.072z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$N = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 660 440'%3e%3crect fill='%2300785E' width='660' height='440'/%3e%3cpolygon fill='%23FBD116' points='330 82.958 315.792 126.693 352.995 99.666 307.005 99.666 344.208 126.693 '/%3e%3cg id='h'%3e%3cpath fill='white' d='M330 303.99h-93.937c-1.184-1.2-2.35-2.423-3.488-3.667H330c0.751 0.269 1.267 0.958 1.306 1.736C331.348 302.903 330.818 303.694 330 303.99zM330 275.265c0.545-1.114 1.607-3.694 1.125-6.921 -0.218-1.463-0.692-2.644-1.125-3.492 -5.271 4.988-15.175 12.981-29.785 17.401 -6.821 2.064-14.055 3.173-21.548 3.173h-57.872c1.706 2.507 3.494 4.954 5.364 7.333h55.945C300.346 292.76 317.058 286.179 330 275.265zM229.539 252.628c-2.785 1.072-5.772 1.741-8.887 1.926 13.629 15.415 33.545 25.144 55.723 25.144 21.066 0 40.091-8.775 53.625-22.867 2.297-15.839 3.968-33.969 4.167-53.998 0.232-23.321-1.581-44.2-4.167-62.032 -6.045 5.419-17.371 17.128-22.71 35.079 -1.998 6.72-3.072 13.837-3.072 21.203 0 15.291 4.623 29.506 12.547 41.329 -9.731-12.57-15.526-28.338-15.526-45.454 0-11.369 2.558-22.144 7.126-31.783 -3.154-3.334-5.551-7.392-6.904-11.902 -6.121 10.804-9.618 23.284-9.618 36.581 0 16.539 5.409 31.819 14.552 44.172 -15.923-16.693-38.377-27.099-63.25-27.099 -1.336 0-2.667 0.034-3.989 0.093 2.503 2.333 4.604 5.089 6.188 8.157 24.742 0.038 47.078 10.377 62.964 26.949 -15.171-12.672-34.698-20.303-55.995-20.303 -11.902 0-23.25 2.382-33.594 6.696 10.629 28.085 37.78 48.075 69.574 48.075 2.059 0 4.1-0.093 6.116-0.258 -4.29 0.771-8.709 1.174-13.22 1.174C261.128 273.51 242.92 265.554 229.539 252.628zM330 334.01h-48.684c15.067 5.988 31.492 9.281 48.684 9.281 0.414-0.788 1.125-2.395 1.146-4.542C331.168 336.492 330.417 334.804 330 334.01zM330 311.552h-85.83c2.322 1.99 4.711 3.902 7.169 5.729H330c0.197-0.201 1.167-1.236 1.167-2.865S330.197 311.753 330 311.552zM330 323.01h-70.304c4.257 2.686 8.675 5.139 13.242 7.333H330c0.33-0.523 1.112-1.917 1.063-3.844C331.018 324.78 330.335 323.54 330 323.01z'/%3e%3cpolygon fill='%23FBD116' points='237.639 150.67 224.197 179.509 252.019 164.076 220.444 160.202 243.712 181.901'/%3e%3cpolygon fill='%23FBD116' points='260.663 112.27 269.966 142.699 280.328 112.607 254.26 130.861 286.079 131.413'/%3e%3c/g%3e%3cuse xlink:href='%23h' transform='matrix(-1%2c0%2c0%2c1%2c660%2c0)'/%3e%3c/svg%3e";

var img$M = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-120 -80 240 160'%3e%3cdefs%3e%3cpath id='spearshape' d='M -1%2c55.4256258422040733928782829281879157421699 h 2 V -38 C 3%2c-40 3%2c-43 3%2c-46 C 3%2c-48 3%2c-56 0%2c-64.6632301492380856250246634162192350325315 C -3%2c-56 -3%2c-48 -3%2c-46 C -3%2c-43 -3%2c-40 -1%2c-38 z' stroke-miterlimit='10' transform='rotate(30)'/%3e%3c/defs%3e%3crect x='-120' y='-80' width='240' height='160' fill='white'/%3e%3crect x='-120' y='-80' width='240' height='48'/%3e%3crect x='-120' y='32' width='240' height='48' fill='%23060'/%3e%3cg id='spear'%3e%3cuse xlink:href='%23spearshape' stroke='black'/%3e%3cuse xlink:href='%23spearshape' fill='white'/%3e%3c/g%3e%3cuse xlink:href='%23spear' transform='scale(-1%2c1)'/%3e%3cpath fill='%23b00' d='M -120%2c-24 V 24 H -19 c 3%2c8 13%2c24 19%2c24 s 16%2c-16 19%2c-24 H 120 V -24 H 19 c -3%2c-8 -13%2c-24 -19%2c-24 s -16%2c16 -19%2c24 z'/%3e%3cpath id='deco_r' d='M 19%2c24 c 3%2c-8 5%2c-16 5%2c-24 s -2%2c-16 -5%2c-24 c -3%2c8 -5%2c16 -5%2c24 s 2%2c16 5%2c24'/%3e%3cuse xlink:href='%23deco_r' transform='scale(-1%2c1)'/%3e%3cg fill='white'%3e%3cellipse rx='4' ry='6'/%3e%3cpath id='deco_br' d='M 1%2c5.85 c 0%2c0 4%2c8 4%2c21 s -4%2c21 -4%2c21 z'/%3e%3cuse xlink:href='%23deco_br' transform='scale(-1)'/%3e%3cuse xlink:href='%23deco_br' transform='scale(-1%2c1)'/%3e%3cuse xlink:href='%23deco_br' transform='scale(1%2c-1)'/%3e%3c/g%3e%3c/svg%3e";

var img$L = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 252 126'%3e%3crect fill='%23319208' width='252' height='126'/%3e%3crect y='18' fill='%23FFD200' width='252' height='90'/%3e%3crect y='36' fill='%23DE2010' width='252' height='54'/%3e%3crect y='54' width='252' height='18'/%3e%3cpath d='M4.583%2c0l84%2c63l-84%2c63H0V0H4.583z'/%3e%3cpath fill='white' d='M0%2c0l84%2c63L0%2c126'/%3e%3cpolygon fill='%23DE2010' points='46.161%2c66.045 64.434%2c53.111 43.405%2c50.056 34%2c31 24.595%2c50.056 3.566%2c53.111 21.839%2c66.045 17.836%2c85.248 34%2c76 50.164%2c85.248 '/%3e%3cpath fill='%23FFC618' d='M28.635%2c55.109c1.976%2c4.305%2c2.47%2c4.588%2c7.411%2c6.282c4.94%2c1.694%2c18.898%2c3.3%2c20.274%2c3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917%2c1.429-4.623%2c3.97c-0.388%2c0.106-2.47%2c1.376-2.4%2c2.682c0.6-0.071%2c4.376-1.129%2c5.682%2c3.141c1.306%2c4.27%2c1.376%2c11.257%2c0.035%2c14.716c-1.341%2c3.459-3.423%2c6.07-3.423%2c9.105c0%2c0.423%2c0.282%2c1.27%2c0.988%2c1.27c0.247%2c1.341%2c2.223%2c10.904%2c2.223%2c10.904h28.161l4.473-17.292'/%3e%3cg fill='none' stroke='black' stroke-width='0.2117'%3e%3cpath d='M28.635%2c55.109c1.976%2c4.305%2c2.47%2c4.588%2c7.411%2c6.282c4.94%2c1.694%2c18.898%2c3.3%2c20.274%2c3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917%2c1.429-4.623%2c3.97c-0.388%2c0.106-2.47%2c1.376-2.4%2c2.682c0.6-0.071%2c4.376-1.129%2c5.682%2c3.141c1.306%2c4.27%2c1.376%2c11.257%2c0.035%2c14.716c-1.341%2c3.459-3.423%2c6.07-3.423%2c9.105c0%2c0.423%2c0.282%2c1.27%2c0.988%2c1.27c0.247%2c1.341%2c2.223%2c10.904%2c2.223%2c10.904h28.161l4.473-17.292'/%3e%3cpath d='M19.39%2c70.99c0%2c0%2c5.999-0.353%2c7.623-0.353c1.623%2c0%2c16.734%2c0.019%2c25.165%2c1.968'/%3e%3cpath d='M21.508%2c70.871c0%2c0-0.601-0.728-0.213-2.175 c0.388-1.447%2c4.623-5.188%2c4.623-10.481'/%3e%3cpath d='M25.142%2c70.637c0%2c0-0.494-2.364%2c4.905-4.376 c1.518-0.459%2c5.858-2.894%2c5.999-4.87'/%3e%3cpath d='M29.473%2c66.485c0%2c0%2c13.243%2c0.058%2c23.724%2c2.175'/%3e%3cpath d='M32.793%2c64.905c0%2c0%2c4.551%2c0.156%2c5.292-0.056c0.741-0.212%2c2.053-0.762%2c2.575-2.313'/%3e%3cpath d='M35.49%2c64.959c0%2c0%2c2.434-1.265%2c2.911-2.911'/%3e%3cpath d='M28.141%2c81.894c0%2c0-1.041-7.216-1.253-11.257l2.717%2c2.594l2.875-2.514l2.472%2c2.638l2.858-2.425l2.471%2c2.778l2.83-2.407l2.252%2c2.618l2.822-2.041l3.355%2c3.189'/%3e%3cpath d='M50.951%2c77.345c-10.081-1.444-23.57-1.35-23.57-1.35'/%3e%3cpath d='M22.694%2c51.052c0%2c0%2c8.2-3.918%2c9.647-4.465'/%3e%3c/g%3e%3cg transform='matrix(0.211738%2c0%2c0%2c0.211738%2c16%2c36)' fill='none' stroke='black'%3e%3cpolyline points='52.487%2c177.086 65.505%2c188.938 77.267%2c177.176 89.163%2c189.442 102.009%2c178.084 113.836%2c190.514 127.175%2c179.501 138.072%2c192.229 151.342%2c182.084 165.289%2c194.403'/%3e%3ccircle cx='89.425' cy='154.584' r='5.167'/%3e%3ccircle cx='111.237' cy='156.047' r='5.167'/%3e%3ccircle cx='30.05' cy='16.5' r='4'/%3e%3c/g%3e%3c/svg%3e";

var img$K = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 36 24'%3e%3crect width='36' height='24' fill='white'/%3e%3cg fill='%23005293'%3e%3cg id='star' transform='translate(9%2c6)'%3e%3cg id='c'%3e%3cpath id='t' d='M 0%2c-3 v 3 h 1.5 z' transform='rotate(18 0%2c-3)'/%3e%3cuse xlink:href='%23t' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3cuse xlink:href='%23c' transform='rotate(216)'/%3e%3cuse xlink:href='%23c' transform='rotate(288)'/%3e%3c/g%3e%3crect y='12' width='18' height='12'/%3e%3c/g%3e%3cg fill='%23d21034'%3e%3crect x='18' width='18' height='12'/%3e%3cuse xlink:href='%23star' x='18' y='12'/%3e%3c/g%3e%3c/svg%3e";

var img$J = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 625 400'%3e%3crect width='625' height='400' fill='%23032ea1'/%3e%3crect width='625' height='200' y='100' fill='%23e00025'/%3e%3cg fill='white' stroke='black' stroke-width='0.96' transform='translate(117.14286%2c-434.9336)'%3e%3cg stroke-linejoin='bevel'%3e%3cpath d='m139.02%2c623.46%2c113.8%2c0%2c0%2c43.788-113.8%2c0z'/%3e%3crect width='3.5864' height='16.495' x='246.95' y='647.64'/%3e%3crect width='113.8' height='5.0903' x='139.02' y='639.49'/%3e%3crect width='113.8' height='4.489' x='139.02' y='632.59'/%3e%3crect stroke-width='0.94545' width='113.8' height='4.354' x='139.02' y='625.7'/%3e%3crect width='3.5864' height='16.495' x='168.98' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='217.97' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='139.92' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='146.95' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='154.45' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='161.95' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='224.77' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='232.27' y='647.64'/%3e%3crect width='3.5864' height='16.495' x='239.77' y='647.64'/%3e%3cpath stroke-linejoin='miter' d='m94.509%2c669.55c1.7604-0.89672%2c3.7684-2.9836%2c4.425-5.319h193.07c0.65665%2c2.3354%2c2.6647%2c4.4222%2c4.425%2c5.319z'/%3e%3c/g%3e%3cg%3e%3cg%3e%3cpath d='m193%2c556.8s-0.14437-4.1125%2c2.2507-4.1572c2.3951%2c0.0447%2c2.2507%2c4.1572%2c2.2507%2c4.1572z'/%3e%3cpath d='m180.51%2c611.34%2c0-5.5357c-0.0789-2.768-2.7591-2.9681-2.838-4.9862%2c0%2c0-0.34606-3.0266%2c0.45159-4.4082%2c1.0845%2c4.0474%2c3.0561%2c3.3039%2c3.0561%2c1.6397%2c0-1.4526-1.117-2.8031-3.408-6.3302-0.73206-1.127-0.27901-4.6597%2c0.74692-5.9224%2c0.39808%2c3.0709%2c0.85311%2c4.5398%2c2.1717%2c4.5398%2c0.80428%2c0%2c1.4612-0.52417%2c1.4612-2.0621%2c0-1.9565-1.325-2.9445-1.9762-4.725-0.76004-2.0777-0.23675-4.1957%2c1.0259-5.3795%2c0.54129%2c3.0293%2c0.38028%2c4.2372%2c1.7255%2c4.2372%2c2.7133-0.8584%2c0.00063-4.7866-0.57911-5.7773-0.667-1.1553%2c0.89682-3.4598%2c0.89682-3.4598%2c0.86209%2c2.6898%2c1.1394%2c2.909%2c2.0699%2c2.6597%2c1.1738-0.31452%2c1.0224-2.056-0.40996-3.4633-0.90449-0.88866-0.80857-2.2116%2c0.16248-3.274%2c0.97489%2c1.9056%2c2.2229%2c1.7898%2c2.343%2c0.65821l-0.78373-4.3931h17.255l-0.85683%2c4.2488c-0.24526%2c1.2162%2c1.396%2c1.4801%2c2.4162-0.51392%2c0.97105%2c1.0624%2c1.067%2c2.3854%2c0.16248%2c3.274-1.4323%2c1.4073-1.5837%2c3.1488-0.40996%2c3.4633%2c0.93041%2c0.2493%2c1.2078%2c0.0302%2c2.0699-2.6597%2c0%2c0%2c1.403%2c1.5708%2c0.89682%2c3.4598-0.57974%2c0.99071-3.2924%2c4.9189-0.57911%2c5.7773%2c1.3453%2c0%2c1.1842-1.2079%2c1.7255-4.2372%2c1.2627%2c1.1838%2c1.786%2c3.3017%2c1.0259%2c5.3795-0.65127%2c1.7804-1.9762%2c2.7685-1.9762%2c4.725%2c0%2c1.538%2c0.65688%2c2.0621%2c1.4612%2c2.0621%2c1.3186%2c0%2c1.7736-1.4689%2c2.1717-4.5398%2c1.0259%2c1.2627%2c1.479%2c4.7953%2c0.74692%2c5.9224-2.291%2c3.527-3.408%2c4.8776-3.408%2c6.3302%2c0%2c1.6641%2c1.9716%2c2.4076%2c3.0561-1.6397%2c0.79765%2c1.3816%2c0.4516%2c4.4082%2c0.4516%2c4.4082-0.0789%2c2.018-2.7591%2c2.2182-2.838%2c4.9862v5.5357z'/%3e%3cpath d='m187.73%2c565.32-0.39721-3.125%2c15.838%2c0-0.39721%2c3.125z'/%3e%3cpath d='m188.79%2c562.13-0.34117-2.5686%2c13.604%2c0-0.34117%2c2.5686z'/%3e%3cpath d='m190.95%2c559.47-0.22717-2.5686%2c9.0585%2c0-0.22718%2c2.5686z'/%3e%3cpath d='m223.97%2c669.55c-2.0266-0.78125-4.9773-2.9188-4.9773-5.0695v-24.297l2.6385-3.3588-52.776%2c0.00008%2c2.5293%2c3.3588v24.297c0%2c2.1508-2.0264%2c4.2883-4.0529%2c5.0695z'/%3e%3crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='178.24' y='647.64'/%3e%3crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='208.56' y='647.64'/%3e%3cpath d='m167.91%2c609.17%2c0%2c14.648%2c0%2c7.0117%2c0%2c5.9961%2c54.023%2c0%2c0-5.957%2c0.0783-21.699c-2.2097%2c0.8681-2.5976%2c2.8711-2.5976%2c2.8711v11.777h-48.75v-11.777s-0.5442-2.003-2.7539-2.8711z'/%3e%3cpath d='m214.6%2c669.55c-1.7655-0.78125-5.6118-2.9188-5.6118-5.0695v-27.192c0.37751-1.518%2c2.436-2.414%2c3.761-3.3588h-35.823c1.7049%2c0.90271%2c3.6054%2c1.6522%2c4.2846%2c3.3588v27.192c0%2c2.1508-3.041%2c4.2883-4.8065%2c5.0695z'/%3e%3cpath d='m219.41%2c634.22-0.00027-19.587-4.9104-0.00008%2c0-1.9085-38.839%2c0%2c0%2c1.9085-4.9109-0.00018%2c0.00017%2c19.587z'/%3e%3cpath d='m206.86%2c669.55c-1.7299-0.78125-4.2489-2.9186-4.2489-5.0694v-23.215l1.4205-2.1088h-17.691l1.4205%2c2.109v23.215c0%2c2.1508-2.5189%2c4.2883-4.2488%2c5.0695z'/%3e%3cpath stroke-width='0.981' d='m190.71%2c639.16%2c8.9655-0.00005%2c0%2c30.377-8.9655%2c0z'/%3e%3cpath stroke-linejoin='bevel' d='m204.38%2c632.48c0.0215-2.0012%2c5.8375-2.091%2c8.8318-3.7949h-35.952c2.9943%2c1.7039%2c8.6755%2c1.8441%2c8.6755%2c3.7949l1.2166%2c3.8818%2c14.883%2c0.59776z'/%3e%3cpath d='m211.41%2c611.34c0-4.8986%2c0.20532-6.7857%2c1.7103-6.7857l0.00001%2c15.58c-3.6912%2c1.3393-6.3254%2c6.0491-6.3254%2c6.0491l-23.211-0.00027s-2.6342-4.7096-6.3254-6.0488v-15.58c1.856%2c0%2c1.8682%2c1.9717%2c1.8682%2c6.7857z'/%3e%3cpath d='m213.12%2c609.33c0-5.6184%2c4.8512-6.2503%2c4.8512-6.2503v5c-1.8465-0.0789-2.7368%2c1.578-2.7368%2c4.0444%2c0%2c2.4663%2c1.4868%2c2.5056%2c1.4868%2c2.5056v14.19h-3.6012z'/%3e%3cpath d='m177.28%2c609.33c0-5.6184-4.8512-6.2503-4.8512-6.2503v5c1.8465-0.0789%2c2.7368%2c1.578%2c2.7368%2c4.0444%2c0%2c2.4663-1.4868%2c2.5056-1.4868%2c2.5056v14.19h3.6012z'/%3e%3c/g%3e%3cg fill='none' stroke-width='0.8'%3e%3cpath d='m186.84%2c570.62h17.128'/%3e%3cpath d='m184.81%2c575.97h20.921'/%3e%3cpath d='m182.78%2c582.46h24.904'/%3e%3cpath d='m180.66%2c590.39h29.536'/%3e%3cpath d='m179.98%2c599.43h30.426'/%3e%3cpath stroke-width='0.96' d='m170.75%2c628.92h48.661'/%3e%3crect stroke-width='0.96' width='18.036' height='6.6291' x='186.19' y='628.93'/%3e%3c/g%3e%3cg%3e%3cpath d='m183.93%2c614.24c2.9903%2c3.59%2c2.7128%2c9.6801%2c2.6786%2c13.27h17.343c-0.0342-3.59-0.31172-9.68%2c2.6786-13.27z'/%3e%3cpath d='m193.68%2c573.11-2.3764-1.2239%2c0-3.4974c0.97149%2c0.29214%2c2.062%2c0.41142%2c2.1686%2c1.9595%2c0.33824-2.2099%2c0.94822-2.1018%2c1.9064-2.963%2c0.95814%2c0.86127%2c1.5681%2c0.75315%2c1.9064%2c2.963%2c0.10661-1.5481%2c1.1971-1.6674%2c2.1686-1.9595v3.4974l-2.3764%2c1.2239z'/%3e%3cpath d='m193.52%2c578.85-3.9464-2.7128%2c0-3.2231c1.3836%2c0.32035%2c2.9366%2c0.45115%2c3.0885%2c2.1488%2c0.48172-2.4232%2c1.3504-3.6754%2c2.715-4.6198%2c1.3646%2c0.94444%2c2.2332%2c2.1966%2c2.715%2c4.6198%2c0.15183-1.6976%2c1.7049-1.8284%2c3.0885-2.1488v3.2231l-3.9464%2c2.7128z'/%3e%3cpath d='m193.24%2c587.8-4.5378-3.9854%2c0-4.7351c1.5909%2c0.47062%2c3.3767%2c0.66279%2c3.5513%2c3.1567%2c0.55391-3.56%2c1.5528-5.3995%2c3.1218-6.787%2c1.569%2c1.3875%2c2.5679%2c3.227%2c3.1218%2c6.787%2c0.17458-2.4939%2c1.9604-2.6861%2c3.5513-3.1567v4.7351l-4.5378%2c3.9854z'/%3e%3cpath d='m201.61%2c593.09-4.1037%2c5.6759-4.6463%2c0-4.1037-5.6759z'/%3e%3cpath d='m186.39%2c602.62c2.0526%2c1.1219%2c2.8106%2c3.3568%2c3.0299%2c7.5527h11.55c0.21927-4.1959%2c0.97728-6.4308%2c3.0298-7.5527z'/%3e%3cpath stroke-linejoin='bevel' d='m204.17%2c593.09%2c0-5.7018c-1.9498%2c0.53675-3.2129%2c1.6912-3.7755%2c3.2577%2c0-1.8927-2.4906-6.2573-5.2071-8.4294-2.7242%2c2.4314-5.2575%2c6.3801-5.2066%2c8.4294-0.46332-1.4918-1.8258-2.7209-3.7755-3.2577v5.702z'/%3e%3cpath stroke-linejoin='bevel' d='m205.04%2c602.62-0.00021-5.7022c-2.1373%2c0.53675-3.522%2c1.6912-4.1387%2c3.2577%2c0-1.8927-2.7299-6.2573-5.7077-8.4294-2.9863%2c2.4314-5.7635%2c6.3801-5.7077%2c8.4294-0.50788-1.4918-2.0014-2.7209-4.1387-3.2577v5.702z'/%3e%3cpath stroke-linejoin='bevel' d='m207.44%2c614.32%2c0-6.5765c-2.6591%2c0.68624-4.3124%2c2.653-5.1491%2c3.7996%2c0-3.5614-4.0212-8.9902-7.1011-10.768-3.1599%2c1.8244-7.1011%2c7.435-7.1011%2c10.768-0.85883-1.1395-2.49-3.1134-5.1491-3.7996v6.5765z'/%3e%3cpath stroke-linejoin='bevel' d='m206%2c628.92%2c0-6.7617c-2.3465%2c0.9193-3.0479%2c3.1802-3.7862%2c4.7163%2c0.28981-6.8584-3.8614-14.23-7.0239-16.1-3.1624%2c1.8699-7.3926%2c9.3996-7.0239%2c16.1-0.75787-1.5265-1.4397-3.797-3.7862-4.7163v6.7618z'/%3e%3cpath d='m204.36%2c639.16%2c0-6.7618c-2.4581%2c0.58449-2.61%2c1.491-3.3916%2c3.0055%2c0.28981-4.0963-2.6114-8.7695-5.7739-10.639-3.1624%2c1.8699-6.0637%2c6.5431-5.7739%2c10.639-0.78168-1.5145-0.87771-2.421-3.3916-3.0055v6.7618z'/%3e%3c/g%3e%3c/g%3e%3cg id='tower'%3e%3cg%3e%3cpath d='m98.935%2c664.23%2c0-20.44c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-17.993l3.7418%2c2.0232%2c4.2712%2c18.811v22.965z'/%3e%3cpath d='m98.935%2c664.31%2c0-20.519c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-19.243c2.5118%2c0%2c3.7418%2c3.2732%2c3.7418%2c3.2732l4.2712%2c18.811v22.886z'/%3e%3cpath d='m96.275%2c669.55c1.7299-0.78125%2c4.2487-2.9188%2c4.2487-5.0695v-25.547l-1.1852-2.1088h43.522l-1.6983%2c2.1088v25.547c0%2c2.1508%2c1.7297%2c4.2883%2c3.4596%2c5.0695z'/%3e%3cpath d='m135.84%2c669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-24.297l3.619-3.359-29.588%2c0.00008%2c3.6191%2c3.3589v24.297c0%2c2.1508-2.5189%2c4.2883-4.2488%2c5.0695z'/%3e%3cpath d='m131.69%2c669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-21.965l2.369-3.359h-18.798l2.3688%2c3.359v21.965c0%2c2.1508-2.5189%2c4.2883-4.2488%2c5.0695z'/%3e%3cpath d='m115.92%2c639.16%2c8.9819-0.00004-0.00002%2c30.393-8.9818%2c0z'/%3e%3crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='103.7' y='647.64'/%3e%3crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='134.45' y='647.64'/%3e%3cpath stroke-linejoin='bevel' d='m100.64%2c619.82h4.3202v16.909h-4.3202z'/%3e%3cpath stroke-linejoin='bevel' d='m100.64%2c616.64h4.2946v3.1387h-4.2946z'/%3e%3cpath stroke-width='1.0337' stroke-linejoin='bevel' d='m136.17%2c623.46h6.1594v13.054h-6.1594z'/%3e%3cpath d='m104.89%2c636.6%2c0-28.941c1.2321%2c0%2c1.4222%2c4.2418%2c4.249%2c4.2418%2c1.4716%2c0%2c1.3152-1.757%2c0.4889-3.1882-0.73168-1.2673-1.6372-3.0176-0.40702-6.2783%2c0.84298%2c2.4949%2c3.1119%2c3.2866%2c2.6927%2c1.722-0.72042-2.6886-2.7945-3.1298-1.2383-7.3021%2c0.54049%2c3.4806%2c2.7732%2c3.3273%2c2.2309%2c1.3034-0.61083-2.2796-1.8732-3.2139-0.3157-6.4275%2c0.87209%2c3.6492%2c2.0519%2c3.4352%2c2.0519%2c1.1711%2c0-3.347-0.1285-6.9568%2c4.2027-8.296%2c0%2c0%2c0.25002-3.0682%2c1.8123-3.0682s1.8123%2c3.0682%2c1.8123%2c3.0682c4.3312%2c1.3393%2c4.2027%2c4.949%2c4.2027%2c8.296%2c0%2c2.264%2c1.1798%2c2.4781%2c2.0519-1.1711%2c1.5574%2c3.2136%2c0.29513%2c4.1479-0.3157%2c6.4275-0.54227%2c2.0238%2c1.6904%2c2.1772%2c2.2309-1.3034%2c1.5562%2c4.1722-0.5179%2c4.6134-1.2383%2c7.3021-0.41923%2c1.5646%2c1.8497%2c0.77297%2c2.6927-1.722%2c1.2302%2c3.2606%2c0.32466%2c5.011-0.40702%2c6.2783-0.82627%2c1.4311-0.98274%2c3.1882%2c0.4889%2c3.1882%2c2.8268%2c0%2c3.0168-4.2418%2c4.249-4.2418v28.941z'/%3e%3cpath d='m98.124%2c614.74%2c0.000081%2c22.079%2c2.5111%2c0-0.00019-22.135c-0.90498-0.45686-1.7546-0.5274-2.511%2c0.0558z'/%3e%3cpath d='m98.203%2c629.03c3.1124%2c1.5914%2c6.1949%2c3.4325%2c6.9754%2c7.7931h-6.9754z'/%3e%3cpath d='m141.37%2c622.42%2c0.00006%2c14.407%2c2.0354%2c0%2c0-14.443c-0.63587-0.2981-1.5039-0.34413-2.0354%2c0.0364z'/%3e%3cpath d='m143.41%2c628.92c-3.1124%2c1.5914-6.1949%2c3.4325-6.9754%2c7.7931h6.9754z'/%3e%3c/g%3e%3cg%3e%3cpath d='m122.83%2c595.27%2c1.8142-1.5247%2c0-1.9528c-0.6637%2c0.0645-1.0258%2c0.29275-1.516%2c0.93531-0.41694-1.2944-1.3337-2.3051-2.5624-2.9327-1.2287%2c0.6276-2.1454%2c1.5924-2.5624%2c2.8867-0.49022-0.64256-0.8523-0.8249-1.516-0.88935v1.9528l1.8142%2c1.5247z'/%3e%3cpath d='m123.8%2c600.16%2c0.8432-1.8253%2c0-2.5384c-0.6637%2c0.0654-1.0258%2c0.29688-1.516%2c0.94855-0.41694-1.3127-1.3337-2.3377-2.5624-2.9742-1.2287%2c0.63649-2.1454%2c1.6149-2.5624%2c2.9276-0.49022-0.65166-0.8523-0.83658-1.516-0.90194v2.5384l0.8432%2c1.8253z'/%3e%3cpath d='m123.93%2c606.79%2c2.6948-3.2865%2c0-3.2432c-0.98588%2c0.11068-1.5237%2c0.50272-2.2519%2c1.6061-0.61934-2.2227-1.9811-2.7084-3.8062-3.7861-1.8251%2c1.0777-3.1869%2c1.4845-3.8062%2c3.7072-0.72818-1.1034-1.266-1.4165-2.2519-1.5272v3.2432l2.6949%2c3.2865z'/%3e%3cpath d='m124.72%2c613.3s3.1405-2.7397%2c3.3269-4.2436v-3.4672c-1.2171%2c0.14291-2.3682%2c0.45834-3.2672%2c1.8831-0.76458-2.8701-1.9586-3.6704-4.2117-5.0621-2.2532%2c1.3916-3.4471%2c2.192-4.2117%2c5.0621-0.89895-1.4248-2.0501-1.7402-3.2672-1.8831v3.4672c0.3965%2c1.5039%2c3.3269%2c4.2436%2c3.3269%2c4.2436z'/%3e%3cpath d='m126.06%2c625.32s4.3013-4.7614%2c4.3999-6.6164v-5.4059c-1.6097%2c0.22281-3.1321%2c1.3298-4.321%2c3.5513-1.0112-4.4748-2.5903-7.5949-5.5702-9.7647-2.9799%2c2.1698-4.559%2c5.2898-5.5702%2c9.7647-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.30884%2c1.8551%2c4.3999%2c6.6164%2c4.3999%2c6.6164z'/%3e%3cpath d='m126.06%2c632.43s3.6763-3.7418%2c4.3999-5.3664v-5.4059c-1.6097%2c0.22281-3.1321%2c1.3299-4.321%2c3.5513-1.0112-4.4748-2.5903-7.0369-5.5702-9.2067-2.9799%2c2.1698-4.559%2c4.7318-5.5702%2c9.2067-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.93384%2c1.6247%2c4.3999%2c5.3664%2c4.3999%2c5.3664z'/%3e%3cpath d='m127.54%2c636.56c-1.0733-4.6678-1.9959-8.1303-7.163-11.641-5.167%2c3.5104-6.0894%2c6.9728-7.1627%2c11.641z'/%3e%3cpath d='m130.2%2c639.16%2c0-6.7618c-2.3465%2c0.91931-4.467%2c2.2802-5.2487%2c3.7947-0.87376-3.754-2.5569-5.4078-4.6536-7.6786-2.0967%2c2.2708-3.5008%2c3.9245-4.3746%2c7.6786-0.78168-1.5145-2.9024-2.8754-5.2489-3.7946l0.00022%2c6.7618z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23tower' transform='matrix(-1%2c0%2c0%2c1%2c390.73979%2c0)'/%3e%3cg%3e%3cpath d='m72.694%2c694.25%2c245.33%2c0%2c0.00018%2c12.531-245.33%2c0.00001z'/%3e%3cpath d='m66.228%2c706.76%2c258.26%2c0%2c0.00018%2c12.512-258.26%2c0.00002z'/%3e%3cpath d='m85.576%2c675.51%2c219.56%2c0%2c0.00015%2c8.1093-219.56%2c0.00001z'/%3e%3cpath d='m79.157%2c683.56%2c232.4%2c0%2c0.00017%2c10.622-232.4%2c0.00001z'/%3e%3cpath d='m89.412%2c669.28%2c211.89%2c0%2c0.00015%2c6.174-211.89%2c0z'/%3e%3cpath d='m112.41%2c669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3e%3cpath d='m115.95%2c669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3e%3cpath d='m187.08%2c669.31h16.006v49.935h-16.005z' stroke-width='1.0446'/%3e%3cpath d='m190.73%2c669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3e%3cpath d='m262.19%2c669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3e%3cpath d='m265.73%2c669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath d='m98.935%2c664.23h193.07'/%3e%3cpath d='m115.79%2c712.97h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438'/%3e%3cpath d='m190.77%2c712.98h8.6071m-8.6071%2c-6.2533h8.6071m-8.6071%2c-6.2533h8.6071m-8.6071%2c-6.2533h8.6071m-8.6071%2c-6.2533h8.6071m-8.6071%2c-6.2533h8.6071m-8.6071%2c-6.2533h8.6071'/%3e%3cpath d='m265.57%2c712.97h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438m-9.2438%2c-6.25h9.2438'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$I = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 90 60'%3e%3crect width='30' height='60' fill='%23007a5e'/%3e%3crect x='30' width='30' height='60' fill='%23ce1126'/%3e%3crect x='60' width='30' height='60' fill='%23fcd116'/%3e%3cg transform='translate(45%2c30)' fill='%23fcd116'%3e%3cg id='c'%3e%3cpath id='t' d='M 0%2c-8 v 8 h 4 z' transform='rotate(18 0%2c-8)'/%3e%3cuse xlink:href='%23t' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3cuse xlink:href='%23c' transform='rotate(216)'/%3e%3cuse xlink:href='%23c' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";

var img$H = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3crect fill='%23009E60' width='450' height='300'/%3e%3crect fill='white' width='300' height='300'/%3e%3crect fill='%23F77F00' width='150' height='300'/%3e%3c/svg%3e";

var img$G = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3crect width='1200' height='600' fill='%23ffb700'/%3e%3cpath d='M50%2c300 215%2c50H380V550H215z' fill='%23ff5b00'/%3e%3crect width='165' height='500' x='50' y='50' fill='%23005641'/%3e%3crect width='725' height='500' x='430' y='50' fill='%238d2029'/%3e%3cpath id='leaf' d='m1086.1%2c466.06s6.7982%2c13.841%2c14.309%2c19.48c11.128%2c8.3556%2c33.945%2c7.752%2c43.629%2c17.5%2c11.604%2c11.495-0.9004%2c26.682-0.7959%2c28l0.6363%2c8.0206s-7.8245%2c0.0943-11.119%2c0.60793c-4.9538%2c0.7724-6.886%2c4.8032-16.109%2c4.2045-23.189-1.5052-22.254-22.397-23.566-40.25-1.1646-6.7983-3.8594-15.662-5.3908-22.458-1.313-5.8277-1.5933-15.105-1.5933-15.105z' fill='%23ffb700' stroke='black' stroke-width='2.12575722'/%3e%3cuse xlink:href='%23leaf' transform='matrix(-1%2c0%2c0%2c1%2c1585%2c0)'/%3e%3cuse xlink:href='%23leaf' transform='matrix(1%2c0%2c0%2c-1%2c0%2c600)'/%3e%3cuse xlink:href='%23leaf' transform='matrix(-1%2c0%2c0%2c-1%2c1585%2c600)'/%3e%3cuse xlink:href='%23lion' stroke='black' stroke-width='5.5598'/%3e%3cg id='lion' fill='%23ffb700'%3e%3cpath d='m681.54%2c479.56%2c4.3593-2.517%2c1.8649%2c2.5215c2.4846%2c3.3595%2c9.3595%2c3.3215%2c13.921-0.0773l3.4882-2.5985%2c2.9208%2c2.5985c3.8402%2c3.4168%2c11.012%2c3.4213%2c15.591%2c0.0122%2c3.206-2.3882%2c3.653-2.4362%2c5.7728-0.61944%2c1.2637%2c1.0831%2c4.9702%2c2.3162%2c8.2366%2c2.7402%2c5.8828%2c0.76367%2c5.9719%2c0.72173%2c9.4138-4.442%2c2.8826-4.3245%2c3.3335-6.0748%2c2.6456-10.269-0.45593-2.7807-0.9471-7.2562-1.0915-9.9454-0.26119-4.8694-0.23309-4.8997%2c6.8598-7.3695%2c3.9171-1.364%2c8.4514-3.1933%2c10.076-4.0653%2c2.8328-1.5202%2c10.643-10.699%2c10.643-12.508%2c0-0.47938-3.0511-1.2137-6.7801-1.632-14.833-1.6637-17.345-9.6288-7.7022-24.423%2c15.725-24.128%2c25.215-47.625%2c25.278-62.593%2c0.0285-6.6906%2c0.40945-8.937%2c1.2692-7.482%2c3.5135%2c5.9459-2.7808%2c30.877-12.316%2c48.78l-3.8392%2c7.2089%2c3.6635-0.84337c2.0149-0.46382%2c13.861-5.4619%2c26.325-11.107%2c34.115-15.451%2c45.833-18.479%2c67.911-17.549%2c18.497%2c0.77911%2c26.374%2c4.3927%2c39.434%2c18.09%2c6.9185%2c7.2565%2c13.583%2c12.449%2c25.775%2c20.08%2c25.975%2c16.259%2c27.058%2c17.667%2c28.293%2c36.788%2c1.2515%2c19.373%2c0.62869%2c20.424-14.024%2c23.661-12.524%2c2.7669-20.375%2c8.6054-22.481%2c16.717-1.1245%2c4.3318%2c1.242%2c4.4565%2c7.5561%2c0.39845l4.6275-2.9741%2c2.0576%2c2.9741c2.7051%2c3.91%2c8.455%2c3.9256%2c13.23%2c0.0356l3.6067-2.9381%2c3.6869%2c2.9381c5.7286%2c4.565%2c13.347%2c3.458%2c15.497-2.252%2c0.41335-1.0975%2c1.5164-0.74587%2c3.75%2c1.1953%2c4.1852%2c3.6374%2c14.914%2c5.1976%2c16.072%2c2.3376%2c0.44221-1.0912-0.3978-3.7862-1.8666-5.9887-6.2419-9.3596-8.1945-13.823-8.2758-18.918-0.11266-7.0863%2c2.0014-10.505%2c10.061-16.268%2c9.7908-7.0008%2c12.816-16.033%2c5.3706-16.033-4.5972%2c0-9.2317-4.0634-12.187-10.686-6.0079-13.461-4.8304-28.552%2c4.1866-53.657%2c9.1588-25.5%2c10.175-30.202%2c10.211-47.256%2c0.03-13.789-0.3175-16.174-3.4548-23.734-1.9182-4.6223-5.8102-11.505-8.6489-15.294l-5.1614-6.8903%2c6.6267-5.49c20.234-16.763%2c16.095-44.198-8.263-54.769-7.4516-3.2338-9.3134-3.5194-22.372-3.4316-7.8342%2c0.0527-19.78%2c1.0836-26.546%2c2.2911-6.8986%2c1.2311-18.575%2c2.2205-26.585%2c2.2526-12.725%2c0.0512-14.885-0.26249-19.789-2.8727-5.1132-2.7217-5.9899-4.0139-6.991-10.305-0.20575-1.2931-1.1099-2.5831-2.0089-2.8666-1.7392-0.54841-9.771%2c6.4223-10.958%2c9.51-0.58543%2c1.5235-1.0633%2c1.4182-2.7808-0.61319-1.1407-1.349-2.7333-4.4487-3.5393-6.8883-2.0267-6.1353%2c0.46204-10.735%2c7.6738-14.181l5.5952-2.6741-3.2993-2.0474c-6.8083-4.2248-18.385-1.3347-22.572%2c5.635-1.1843%2c1.9715-2.4761%2c3.5881-2.8706%2c3.5924-0.39444%2c0.003-2.6455-1.8765-5.0025-4.1795-8.7904-8.5893-5.7666-21.297%2c5.9908-25.177%2c6.2696-2.0689%2c11.818-0.49068%2c12.972%2c3.69%2c1.7624%2c6.3826%2c7.2409-2.0071%2c6.2584-9.584-0.6533-5.0374-0.55514-5.212%2c2.9305-5.212%2c4.8473%2c0%2c15.165%2c6.3619%2c18.356%2c11.319%2c3.7064%2c5.7573%2c3.4367%2c14.823-0.64203%2c21.58l-3.2027%2c5.3055%2c4.1894-0.83896c6.1434-1.2302%2c12.112-5.0453%2c15.131-9.6721%2c3.192-4.8914%2c3.5352-14.416%2c0.70469-19.555-2.7429-4.981-2.4284-5.7717%2c1.6267-4.0885%2c6.8969%2c2.8628%2c10.584%2c6.0201%2c13.35%2c11.431%2c2.4908%2c4.8729%2c2.6298%2c6.0838%2c1.2814%2c11.156-0.83198%2c3.1291-2.6831%2c7.246-4.1137%2c9.1486-2.2274%2c2.9626-2.3034%2c3.4593-0.52871%2c3.4593%2c3.3052%2c0%2c10.206-3.1281%2c12.658-5.7373%2c1.2383-1.3182%2c3.0437-4.564%2c4.012-7.2129l1.7607-4.8162%2c2.023%2c3.6712c2.8609%2c5.1912%2c8.4225%2c9.8627%2c15.204%2c12.77%2c7.293%2c3.1265%2c10.33%2c3.3027%2c6.5164%2c0.37792-2.5718-1.9723-7.3109-15.878-5.8747-17.238%2c0.84508-0.80031%2c10.747%2c6.8186%2c22.053%2c16.968%2c10.695%2c9.6009%2c17.415%2c12.746%2c27.238%2c12.746%2c12.548%2c0.00008%2c19.854-10.923%2c14.214-21.251-3.288-6.0216-10.613-6.8581-14.896-1.7011-1.9696%2c2.3714-2.5103%2c4.2577-1.9334%2c6.745%2c0.7066%2c3.047%2c0.4309%2c3.453-2.3451%2c3.453-3.6473%2c0-10.837-4.6664-23.606-15.321-19.471-16.248-43.13-30.02-60.214-35.05-10.963-3.2285-34.383-4.4883-45.528-2.4492-12.062%2c2.207-26.329%2c9.1099-34.101%2c16.499-13.772%2c13.094-13.991%2c30.518-0.58141%2c46.385l3.8411%2c4.5452-2.6005%2c4.0394c-3.7831%2c5.8765-3.4591%2c13.785%2c0.80339%2c19.61%2c1.8774%2c2.5656%2c3.7712%2c4.6637%2c4.2085%2c4.6623%2c0.43728-0.001%2c0.91679-1.6508%2c1.0654-3.6654%2c0.37644-5.0966%2c2.5638-8.5113%2c6.3183-9.8632%2c3.3816-1.2176%2c5.5676-0.64252%2c21.051%2c5.5376%2c16.289%2c6.5015%2c43.077%2c6.9484%2c71.561%2c1.1938%2c13.964-2.8211%2c30.43-2.6552%2c37.674%2c0.37962%2c13.279%2c5.5631%2c16.357%2c20.036%2c6.5955%2c31.022-4.2256%2c4.7559-8.3008%2c6.6927-21.983%2c10.448-10.412%2c2.8575-12.878%2c3.0472-36.543%2c2.8109-20.218-0.20184-27.484%2c0.18642-35.737%2c1.9096-8.9598%2c1.8707-14.471%2c2.0594-40.79%2c1.3961l-30.431-0.76685%2c3.3746%2c2.7943c1.856%2c1.5368%2c4.4782%2c3.4277%2c5.8271%2c4.202%2c2.2952%2c1.3174%2c2.2187%2c1.4944-1.1927%2c2.7593-2.0049%2c0.7434-6.4548%2c1.3516-9.8886%2c1.3516h-6.2432l-0.84015%2c5.3057c-0.46215%2c2.9182-0.42705%2c6.3252%2c0.0776%2c7.5711%2c0.74459%2c1.8377%2c0.46708%2c2.1016-1.4696%2c1.3977-1.313-0.47719-4.97-1.4158-8.1265-2.0857-3.1565-0.66995-7.4054-2.0342-9.442-3.0316-3.4248-1.6773-3.8054-1.6322-5.0669%2c0.60016-1.1264%2c1.9935-11.702%2c9.8644-13.254%2c9.8644-0.25046%2c0-0.57378-1.5176-0.71843-3.3725-0.14464-1.8549-1.6703-6.6837-3.3904-10.731-1.7202-4.047-3.5162-8.4619-3.9913-9.8109-0.71672-2.035-1.0412-2.1394-1.9056-0.61319-0.573%2c1.0118-1.4096%2c3.7711-1.8591%2c6.1318-0.44947%2c2.3607-2.043%2c6.1958-3.5412%2c8.5224l-2.724%2c4.2301-1.7374-3.617c-1.8651-3.8828-4.9615-7.9092-6.0825-7.9092-0.37837%2c0-1.0228%2c1.2417-1.432%2c2.7593-0.85453%2c3.1692-8.197%2c11.957-9.9903%2c11.957-0.66041%2c0-1.2007-2.4834-1.2007-5.5186s-0.5827-5.5186-1.2949-5.5186-1.2949%2c0.78545-1.2949%2c1.7454c0%2c2.3335-6.2706%2c9.2918-8.3736%2c9.2918-0.91771%2c0-2.394%2c0.82779-3.2807%2c1.8395-2.3118%2c2.638-4.2029%2c2.2678-3.231-0.63242%2c0.45568-1.3596%2c0.15939-4.5328-0.65846-7.0516-0.81788-2.5188-1.6875-5.1996-1.9325-5.9573-0.30871-0.95429-2.5558-0.70116-7.3116%2c0.82362-7.6852%2c2.4639-10.261%2c2.028-6.3087-1.0676%2c1.4449-1.1316%2c3.6425-5.0514%2c4.8838-8.7107%2c1.2412-3.6592%2c3.0726-6.9061%2c4.0698-7.2151%2c1.3963-0.43282%2c1.322%2c0.10204-0.32373%2c2.3272-1.1753%2c1.5891-2.1404%2c3.7321-2.1448%2c4.7624%2c0%2c1.0303-0.88884%2c3.473-1.9656%2c5.4282-1.0766%2c1.9552-1.7534%2c3.7483-1.5039%2c3.9845%2c0.24941%2c0.23626%2c3.1735-0.87452%2c6.4978-2.4684l6.0442-2.8979%2c0.0246%2c2.5925c0.0142%2c1.4259%2c0.74212%2c5.1875%2c1.6186%2c8.3592l1.5937%2c5.7666%2c4.1143-1.891c4.2049-1.9326%2c8.1874-8.8222%2c8.1874-14.164%2c0-2.6406%2c1.5126-2.2353%2c2.132%2c0.57128%2c0.18181%2c0.8236%2c1.1312%2c3.9147%2c2.1099%2c6.8692l1.7795%2c5.3717%2c2.817-3.3916c1.5494-1.8654%2c3.4917-5.5244%2c4.3163-8.131%2c1.4315-4.5251%2c3.6793-6.4706%2c3.6793-3.1845%2c0%2c2.368%2c6.4622%2c10.861%2c7.7088%2c10.131%2c0.60253-0.35262%2c1.8023-3.5401%2c2.6661-7.0833%2c1.7967-7.3686%2c4.6952-12.38%2c6.537-11.302%2c0.69252%2c0.40535%2c0.96225%2c1.192%2c0.59929%2c1.7482-0.36297%2c0.55613%2c1.1254%2c5.3468%2c3.3075%2c10.646%2c2.1821%2c5.2991%2c4.3732%2c10.634%2c4.8693%2c11.856%2c0.797%2c1.9632%2c1.5174%2c1.678%2c6.1947-2.4527%2c2.911-2.5708%2c5.5531-5.4487%2c5.8713-6.3953%2c0.48094-1.431%2c1.1303-1.3786%2c3.8524%2c0.31056%2c3.8067%2c2.3622%2c16.605%2c6.1683%2c17.593%2c5.2321%2c0.37021-0.35059%2c0.74975-3.7118%2c0.8435-7.4694l0.17042-6.8319%2c3.6804%2c0.76323c2.0242%2c0.41978%2c6.2805%2c0.39398%2c9.4584-0.0575l5.7779-0.82057-5.1492-3.5327c-2.8322-1.943-5.6958-4.4574-6.3636-5.5875-0.71142-1.204-3.232-2.2263-6.0873-2.469-7.7147-0.65558-21.388-8.3244-21.388-11.996%2c0-0.68925%2c1.8938%2c0.48271%2c4.2085%2c2.6043%2c5.1349%2c4.7067%2c12.269%2c7.6609%2c18.499%2c7.6609h4.6621l-2.884-3.8358c-1.6567-2.2034-3.1425-6.3832-3.4914-9.8218-0.55604-5.481-1.1346-6.3525-6.8578-10.331-3.4376-2.3899-7.6957-5.972-9.4622-7.9603l-3.2119-3.615-1.6387%2c4.2921c-0.90139%2c2.3607-2.003%2c4.2921-2.4479%2c4.2921-0.44494%2c0-2.1777-1.3797-3.8503-3.0659-1.6728-1.6862-3.3768-3.0596-3.7867-3.0518-0.4101%2c0.007-1.8919%2c2.2791-3.2929%2c5.0474l-2.5474%2c5.0333-1.9684-2.9012c-1.0827-1.5957-3.64-4.4189-5.6829-6.2738s-3.1174-3.3725-2.3877-3.3725c0.72956%2c0%2c3.251%2c1.9323%2c5.6033%2c4.294l4.2765%2c4.294%2c1.7405-3.146c1.0328-1.8669%2c1.4199-4.7346%2c0.95201-7.0533-0.68203-3.3797-0.5862-3.5761%2c0.70963-1.4546%2c0.82408%2c1.349%2c3.3259%2c3.9353%2c5.5597%2c5.7473l4.0616%2c3.2946%2c2.8028-5.1341c2.7895-5.1094%2c2.8091-5.1194%2c4.0782-2.0682%2c1.6972%2c4.0805%2c13.98%2c14.149%2c24.437%2c20.032%2c1.6118%2c0.9067%2c0.9322-2.2112-2.0444-9.3809-0.78834-1.8988-1.4333-5.3219-1.4333-7.607%2c0-3.39-0.97793-4.8988-5.3136-8.1981-6.2592-4.7632-8.2835-8.1504-9.463-15.835-0.47783-3.1128-1.5732-6.5749-2.4343-7.6935-1.2773-1.6596-1.4884-0.73081-1.1466%2c5.0465%2c0.23036%2c3.8942-0.27608%2c8.7359-1.1256%2c10.759l-1.5443%2c3.6791-1.1938-3.0659c-0.65653-1.6862-3.5605-4.6187-6.4535-6.5166-2.8929-1.8979-4.9233-3.7694-4.5119-4.1589%2c0.41126-0.38953%2c3.3874%2c1.3402%2c6.6134%2c3.8437%2c4.9147%2c3.814%2c5.9973%2c4.227%2c6.678%2c2.5471%2c0.79975-1.9739-0.001-10.562-1.5461-16.563-0.77113-2.9968-0.70366-2.9807%2c2.9932%2c0.71559%2c2.7266%2c2.7261%2c4.2342%2c5.9776%2c5.4023%2c11.65%2c1.4838%2c7.2068%2c2.2324%2c8.4066%2c8.8962%2c14.258%2c4.0018%2c3.5138%2c7.4844%2c6.1913%2c7.7391%2c5.9502%2c0.25458-0.24116%2c0.75961-9.3307%2c1.1222-20.199%2c0.69536-20.841-0.0906-25.8-5.1098-32.239l-2.5788-3.3085%2c4.054-4.3729c5.2886-5.7045%2c7.7168-10.277%2c8.7701-16.515l0.85683-5.0748-4.5751%2c4.3329c-3.7462%2c3.5479-5.5352%2c4.3329-9.8743%2c4.3329-4.2965%2c0-5.9749-0.72001-8.8702-3.8052-3.4739-3.7017-9.6295-7.2634-15.549-8.9969-2.1867-0.64031-2.9136-0.3614-2.9136%2c1.1179%2c0%2c1.0841-1.2079%2c4.2133-2.6842%2c6.9538l-2.6841%2c4.9828-5.6238-5.5587c-3.4497-3.4096-7.5436-6.0635-10.589-6.8644-7.7808-2.0462-8.2022-1.843-8.2022%2c3.954%2c0%2c8.7932-3.7543%2c10.431-10.511%2c4.5868-5.1508-4.4554-9.4235-5.4241-19.191-4.3505l-7.5435%2c0.82916%2c1.3573%2c3.4054c1.1337%2c2.8446%2c0.8782%2c4.0425-1.5508%2c7.2732-3.9398%2c5.2399-9.0624%2c7.5098-16.948%2c7.5098-3.6319%2c0-8.1768%2c0.75156-10.1%2c1.6701-1.9232%2c0.91856-6.7016%2c1.9768-10.619%2c2.3517-3.9171%2c0.37491-8.0922%2c1.044-9.2778%2c1.4869-1.8554%2c0.69306-2.059%2c0.12189-1.4614-4.098%2c0.91472-6.4581-3.5965-11.222-10.627-11.222-9.1217%2c0-13.329%2c8.1592-9.7568%2c18.922%2c0.68749%2c2.0714%2c1.5871%2c5.3381%2c1.999%2c7.2593%2c0.42746%2c1.9932%2c4.5362%2c7.2825%2c9.5688%2c12.318%2c4.8509%2c4.8537%2c9.4354%2c9.9041%2c10.188%2c11.223%2c0.75262%2c1.3191%2c3.2407%2c3.4359%2c5.529%2c4.704l4.1608%2c2.3058-0.5488-4.4519c-0.60318-4.8928%2c0.46295-5.6604%2c3.0662-2.2077%2c0.93053%2c1.2343%2c3.2945%2c3.2293%2c5.2531%2c4.4333%2c3.0853%2c1.8967%2c3.561%2c1.9353%2c3.561%2c0.28842%2c0-1.0454%2c0.62895-3.4543%2c1.3976-5.3531l1.3977-3.4523%2c2.4251%2c4.6972c1.3338%2c2.5835%2c5.6714%2c8.455%2c9.639%2c13.048%2c7.6986%2c8.9118%2c12.389%2c18.871%2c9.9683%2c21.163-0.98194%2c0.92988-3.6363%2c0.85791-9.1376-0.24774-4.2646-0.85709-9.5394-1.3101-11.722-1.0068-4.4571%2c0.61953-4.8082%2c0.0441-2.067-3.3881%2c2.8931-3.6226%2c2.4329-4.2201-3.2508-4.2201-6.5757%2c0-22.901-3.1522-29.168-5.6319-6.0934-2.4112-7.4993-1.8108-9.2928%2c3.9686-0.80725%2c2.601-2.2853%2c7.3142-3.2844%2c10.474l-1.8166%2c5.7444%2c6.5927-0.6349c3.626-0.3492%2c8.2897-1.1431%2c10.364-1.7642%2c2.0741-0.62112%2c3.9591-0.95122%2c4.1889-0.73356%2c0.22985%2c0.21769-0.6946%2c2.4623-2.0543%2c4.988l-2.4721%2c4.5922%2c4.1103-0.8379c2.2608-0.46085%2c5.662-1.5885%2c7.5584-2.5059%2c3.2998-1.5963%2c3.5648-1.4804%2c6.1676%2c2.6973%2c3.2006%2c5.1376%2c5.7611%2c4.9265%2c6.3292-0.52181%2c0.58738-5.6325%2c2.4401-4.7994%2c5.9255%2c2.6645%2c3.3515%2c7.1772%2c6.8385%2c9.7112%2c7.5085%2c5.4565%2c0.22232-1.4126%2c2.0278-3.7122%2c4.012-5.1101%2c4.0136-2.8276%2c7.0382-1.9792%2c8.7723%2c2.4603%2c1.795%2c4.5955-2.2084%2c9.3323-13.853%2c16.391-23.327%2c14.14-36.886%2c33.479-40.757%2c58.128-3.4915%2c22.233%2c7.4134%2c45.207%2c29.29%2c61.708%2c10.469%2c7.8966%2c27.1%2c16.231%2c26.043%2c13.051-4.4882-13.505-4.3404-39.274%2c0.2503-43.621%2c0.68891-0.65244%2c0.45194%2c2.0364-0.52663%2c5.9752-3.645%2c14.672-2.0615%2c26.363%2c7.282%2c53.763%2c8.4506%2c24.782%2c7.2809%2c35.373-4.6794%2c42.374-3.8414%2c2.2484-6.3146%2c2.6189-16.643%2c2.4936-11.207-0.13613-12.428%2c0.0895-16.026%2c2.9564-3.4881%2c2.7798-8.0108%2c11.906-8.0108%2c16.165%2c0%2c2.3072%2c2.562%2c2.0018%2c7.5966-0.90506z'/%3e%3cpath d='m863.45%2c479.06%2c4.7011-3.0213%2c3.1903%2c3.0213c4.1796%2c3.9583%2c9.0759%2c3.8698%2c13.094-0.23669%2c1.7536-1.792%2c3.3283-3.0336%2c3.4993-2.7593%2c0.17093%2c0.27434%2c0.95293%2c1.6025%2c1.7376%2c2.9515%2c0.99334%2c1.7076%2c3.0357%2c2.5662%2c6.7222%2c2.8263%2c4.4417%2c0.31334%2c5.6344-0.1165%2c7.3993-2.6674l2.1038-3.041%2c4.6277%2c2.9741c12.669%2c8.1426%2c19.42-0.40017%2c13.758-17.411-2.879-8.6495-1.296-13.512%2c7.983-24.521%2c3.9128-4.6423%2c7.1176-9.5973%2c7.1215-11.011%2c0-2.2539-0.72386-2.5559-5.9314-2.4527-4.9834%2c0.0994-6.4413-0.43585-9.0644-3.3233-4.2665-4.6965-4.013-10.075%2c0.75623-16.044l3.81-4.7681-6.7596-4.5873c-3.7178-2.5231-10.422-8.4924-14.899-13.265-10.054-10.719-19.939-15.802-32.975-16.955l-8.7404-0.77298%2c0.0129%2c6.6158c0.0168%2c8.5168%2c4.0137%2c16.71%2c14.924%2c30.588%2c12.405%2c15.779%2c13.271%2c18.222%2c13.774%2c38.846l0.42473%2c17.442-3.5896%2c3.4057c-3.2436%2c3.0773-4.7062%2c3.47-15.173%2c4.0736-9.9645%2c0.57467-12.058%2c1.0888-14.982%2c3.6791-3.8836%2c3.4404-5.0449%2c5.3118-6.244%2c10.063-0.69887%2c2.7688-0.41568%2c3.3725%2c1.5825%2c3.3725%2c1.3386%2c0%2c4.5493-1.3597%2c7.1349-3.0214z'/%3e%3cpath d='m596.82%2c433.98c1.1086-1.4991%2c2.0158-3.9198%2c2.0158-5.3794%2c0-2.2052%2c0.98543-2.7937%2c5.8314-3.4819l5.8314-0.82816-3.889-3.0993c-4.6204-3.6819-5.0478-6.5584-0.97546-6.5647%2c4.056%2c0%2c10.925-4.2118%2c11.969-7.3279%2c0.48536-1.4483%2c0.18013-3.3834-0.69044-4.3769-2.2738-2.5946-6.5486-2.2034-7.3427%2c0.67204-0.85348%2c3.091-2.2824%2c3.0992-5.5219%2c0.0306-4.8732-4.6153-4.9826-14.169-0.22595-19.732%2c2.2418-2.6218%2c2.2218-2.7938-0.6362-5.5005-3.0745-2.9118-5.2702-8.6748-3.826-10.043%2c0.45957-0.43524%2c2.8886-0.0884%2c5.3979%2c0.77114%2c3.5656%2c1.2211%2c4.9732%2c1.2396%2c6.4421%2c0.0846%2c4.4496-3.4973-0.37114-7.9944-7.5068-7.0025-2.8718%2c0.3992-4.0582%2c0-4.4706-1.4897-0.31195-1.1298-2.8238-2.605-5.6539-3.3204-5.0569-1.2784-5.0926-1.2628-5.0926%2c2.2213%2c0%2c3.8179-2.1794%2c4.5382-6.3206%2c2.0889-3.365-1.9903-6.6286-0.44518-6.6286%2c3.1383%2c0%2c3.3434%2c3.3623%2c4.9923%2c9.3882%2c4.604%2c4.6219-0.29789%2c4.7939%2c3.1391%2c0.40427%2c8.0796l-3.1567%2c3.5529%2c2.5008%2c3.5928c3.7037%2c5.321%2c3.3919%2c14.158-0.65433%2c18.547l-3.1721%2c3.4409-2.081-2.7593c-2.8919-3.8346-6.8476-3.5776-7.9323%2c0.51543-0.71028%2c2.6802-0.12315%2c3.905%2c3.2331%2c6.745%2c2.2555%2c1.9086%2c5.5485%2c3.4702%2c7.3178%2c3.4702%2c4.3784%2c0%2c4.2072%2c3.4433-0.34417%2c6.9217l-3.561%2c2.7216%2c5.5034%2c0.85366c3.0269%2c0.46958%2c5.5034%2c1.3529%2c5.5034%2c1.9628%2c0%2c2.339%2c3.8141%2c9.6148%2c5.0401%2c9.6148%2c0.70818%2c0%2c2.1948-1.2265%2c3.3034-2.7256z'/%3e%3cpath d='m668.48%2c402.92c5.0001-1.9709%2c15.821-11.134%2c15.821-13.398%2c0-0.71202-2.9869-3.997-6.6374-7.3001-7.6824-6.9509-16.039-18.657-18.204-25.501-1.1289-3.5687-6.5843-9.6779-21.951-24.581l-20.448-19.832-5.8934%2c1.4927c-3.2414%2c0.82104-7.1962%2c1.5127-8.7885%2c1.537-2.7441%2c0.0417-2.6943%2c0.19928%2c0.95383%2c3.0226l3.8489%2c2.9786%2c5.3959-2.9948c5.2303-2.9029%2c5.4165-2.9208%2c6.0615-0.58461%2c0.37773%2c1.3676-0.43704%2c3.7378-1.8831%2c5.479-1.4019%2c1.6877-2.2004%2c3.6023-1.7748%2c4.2546%2c0.42564%2c0.65216-0.92107%2c2.016-2.9927%2c3.0306-3.8397%2c1.8805-6.5048%2c8.0707-3.4747%2c8.0707%2c2.7261%2c0%2c8.7373-7.4169%2c8.0447-9.9256-0.35481-1.2846-0.18323-2.6059%2c0.38121-2.9363%2c2.3412-1.3703%2c2.1949%2c4.4528-0.18374%2c7.3168-1.4019%2c1.6877-2.2004%2c3.6023-1.7748%2c4.2546%2c0.42564%2c0.65218-0.92107%2c2.016-2.9927%2c3.0306-3.8148%2c1.8683-6.5067%2c8.0707-3.5029%2c8.0707%2c2.944%2c0%2c8.8566-7.0875%2c8.1244-9.7388-0.38303-1.3874-0.23476-2.7927%2c0.32968-3.1231%2c1.5768-0.92296%2c2.4275%2c3.6741%2c1.0964%2c5.9264-0.71298%2c1.2066-0.70651%2c2.8536%2c0.0168%2c4.1598%2c1.3096%2c2.3663-0.0182%2c6.9107-2.4316%2c8.3233-1.0345%2c0.60546-0.33394%2c1.7936%2c2.1753%2c3.6885%2c3.631%2c2.7423%2c3.7014%2c3.0302%2c3.7014%2c15.13%2c0%2c10.112%2c0.40827%2c12.722%2c2.2661%2c14.482%2c2.0848%2c1.9754%2c2.2661%2c1.9825%2c2.2661%2c0.0884%2c0-2.069%2c3.6318-4.5981%2c6.6028-4.5981%2c0.8764%2c0%2c6.3518%2c4.6402%2c12.167%2c10.312%2c5.8509%2c5.7058%2c11.973%2c10.561%2c13.707%2c10.87%2c1.7232%2c0.30733%2c3.5888%2c0.63391%2c4.1458%2c0.72575%2c0.55695%2c0.092%2c3.1792-0.68688%2c5.8271-1.7306z'/%3e%3cpath d='m605.96%2c354c0-3.2598-6.7241-6.7394-14.767-7.6415-6.4933-0.72835-6.5996-0.68714-6.5996%2c2.5565%2c0%2c2.685%2c1.0211%2c3.7413%2c5.5034%2c5.6928%2c7.2024%2c3.1357%2c15.863%2c2.804%2c15.863-0.60778z'/%3e%3cpath d='m613.33%2c353.7c3.2799-2.976%2c4.8339-6.5156%2c2.8606-6.5156-2.2695%2c0-8.293%2c5.4052-8.293%2c7.4417%2c0%2c3.1786%2c1.1188%2c2.9878%2c5.4324-0.92616z'/%3e%3cpath d='m606.34%2c344.06c0.27788-1.8392-0.8597-3.0666-4.2697-4.6066-7.3558-3.3221-16.15-4.8607-18.268-3.196-3.901%2c3.0662-1.3018%2c7.1829%2c5.0028%2c7.9235%2c2.5382%2c0.29812%2c5.98%2c1.0722%2c7.6482%2c1.7202%2c4.8456%2c1.882%2c9.4537%2c1.0239%2c9.8867-1.8411z'/%3e%3cpath d='m606.34%2c334.21c0.39598-2.6237-1.2816-3.5626-14.978-8.3834-10.225-3.5989-14.752-1.9018-11.484%2c4.3058%2c1.1384%2c2.1624%2c3.049%2c3.1503%2c7.3339%2c3.7919%2c3.187%2c0.4773%2c7.5427%2c1.4104%2c9.6793%2c2.0738%2c5.7081%2c1.772%2c9.0058%2c1.148%2c9.4489-1.788z'/%3e%3cpath d='m613.2%2c324.98c2.0666-2.0947%2c3.7572-4.567%2c3.7572-5.4936%2c0-3.0061-8.1614%2c2.3121-9.2017%2c5.9959-1.2478%2c4.4187%2c0.77501%2c4.2322%2c5.4449-0.50233z'/%3e%3cpath d='m606.34%2c324.36c0.45051-2.9886-4.5198-5.6876-14.294-7.7622-7.1711-1.522-10.334-0.6588-9.7971%2c2.6736%2c0.29315%2c1.8191%2c2.6814%2c3.1481%2c9.4566%2c5.2626%2c10.843%2c3.3836%2c14.104%2c3.3449%2c14.634-0.17403z'/%3e%3cpath d='m615.9%2c310.45c12.525-5.5755%2c13.608-19.635%2c1.7976-23.326-4.9037-1.5327-8.0341-0.70686-9.9112%2c2.6147-1.4372%2c2.5434-0.476%2c7.1676%2c1.4899%2c7.1676%2c0.66417%2c0%2c1.2076%2c0.85596%2c1.2076%2c1.9021%2c0%2c4.8819-19.123%2c7.0939-26.965%2c3.119-2.7551-1.3964-3.9546-5.0211-1.6616-5.0211%2c1.7134%2c0%2c2.8981-3.6935%2c2.0226-6.3059-1.1928-3.5592-4.7799-4.7922-9.9831-3.4317-11.74%2c3.0699-11.41%2c16.865%2c0.54277%2c22.719%2c9.8013%2c4.8001%2c31.287%2c5.0919%2c41.46%2c0.56291z'/%3e%3cpath d='m608.11%2c299.64c0.72529-0.68694%2c0.41011-1.7425-0.80582-2.6982-2.6627-2.0928-2.5207-5.2056%2c0.4-8.7689%2c2.1933-2.6759%2c2.4673-6.6804%2c3.2223-47.074%2c1.3008-69.611%2c6.4773-121.97%2c13.3-134.53%2c2.7163-5.0009%2c2.3354-5.0208-4.6839-0.24499-9.0418%2c6.1522-15.926%2c14.163-22.026%2c25.631-11.516%2c21.651-15.518%2c50.78-15.518%2c112.96%2c0%2c35.305%2c0.24051%2c39.924%2c2.2515%2c43.243%2c1.9103%2c3.1523%2c2.0118%2c4.3165%2c0.66998%2c7.6833-0.86981%2c2.1824-1.2645%2c4.2682-0.87709%2c4.6351%2c2.5711%2c2.435%2c21.302%2c1.789%2c24.067-0.82993z'/%3e%3cpath d='m713.34%2c233.26c0.39236-0.6012-0.47458-3.6364-1.9264-6.745-2.2635-4.8468-3.1753-5.6519-6.4-5.6519-10.102%2c0-26.341-4.5144-43.083-11.976-9.6677-4.3091-13.007-5.2994-14.166-4.2013-2.958%2c2.8014%2c1.9582%2c9.4508%2c9.5715%2c12.946%2c6.754%2c3.1007%2c25.635%2c6.9107%2c34.248%2c6.9107%2c4.9966%2c0%2c5.1147%2c0.22548%2c2.2713%2c4.3354l-2.0914%2c3.0228%2c5.6524%2c0.14508c3.1087%2c0.0799%2c7.4004%2c0.56638%2c9.5371%2c1.0813%2c5.5493%2c1.3373%2c5.6012%2c1.3384%2c6.3876%2c0.13328z'/%3e%3cpath fill='black' d='m772.35%2c264.63c0-1.7992-5.2837-6.6752-10.638-9.817-4.2046-2.4674-4.8992-2.5424-4.9086-0.52996-0.0143%2c3.0552-2.7311%2c10.731-3.798%2c10.731-0.60162%2c0-1.4912-1.4999-1.9771-3.3332-0.48587-1.8332-2.5241-5.4462-4.5295-8.0287l-3.6462-4.6956-2.8391%2c4.3506c-2.6467%2c4.0557-7.2315%2c8.0278-9.2662%2c8.0278-0.48599%2c0-0.58103-2.1359-0.21134-4.7465%2c0.40169-2.8364%2c0.092-5.0863-0.77073-5.591-0.79353-0.4645-1.4428-0.30245-1.4428%2c0.3601%2c0%2c1.5283-6.367%2c8.751-7.7142%2c8.751-0.55513%2c0-1.3322-2.0695-1.727-4.5989-0.39469-2.5294-1.0656-6.5304-1.4908-8.8911-0.42526-2.3608%2c0.48144-0.75983%2c2.015%2c3.5576l2.7884%2c7.8498%2c3.0577-4.7839c1.6817-2.6312%2c3.0607-5.5063%2c3.0643-6.3893%2c0-0.88294%2c0.57248-1.2741%2c1.2641-0.86936%2c0.69149%2c0.40477%2c1.654%2c3.5676%2c2.1387%2c7.0284l0.88145%2c6.2925%2c3.3646-3.689c1.8506-2.0289%2c4.019-4.7452%2c4.8188-6.0363%2c1.427-2.3036%2c1.5078-2.3017%2c4.3463%2c0.10554%2c1.5907%2c1.349%2c4.0363%2c4.5757%2c5.4345%2c7.1704%2c1.3984%2c2.5947%2c2.7296%2c4.5262%2c2.9584%2c4.2923%2c0.22868-0.23399%2c0.74108-2.9088%2c1.1388-5.9441%2c0.39754-3.0352%2c0.75248-5.6312%2c0.7886-5.7688%2c0.19786-0.7521%2c10.135%2c5.7072%2c13.812%2c8.9778%2c2.3631%2c2.1022%2c4.6074%2c3.5278%2c4.9873%2c3.1681%2c0.37993-0.35979%2c0.69071-3.4612%2c0.69071-6.8921%2c0-5.3167-0.56355-6.7417-3.8155-9.6485-3.7391-3.3422-3.8437-3.3606-5.2252-0.91579-1.7931%2c3.173-3.9084%2c3.2188-3.9084%2c0.0846%2c0-2.2875-7.0659-11.08-8.9041-11.08-0.47653%2c0-1.9646%2c1.9315-3.3071%2c4.2923-1.3424%2c2.3607-2.786%2c4.29-3.208%2c4.2874-1.8125-0.0111-11.774-11.117-11.769-13.122%2c0-1.5945%2c0.67129-1.1868%2c2.4176%2c1.4761%2c1.3269%2c2.0235%2c3.9777%2c5.0443%2c5.8904%2c6.7129%2c3.8731%2c3.3787%2c5.2811%2c2.5571%2c6.7757-3.9536%2c0.42577-1.8549%2c1.1658-3.3725%2c1.6444-3.3725%2c1.6558%2c0%2c10.327%2c9.2097%2c11.547%2c12.264l1.2244%2c3.0659%2c0.92741-3.3725c1.134-4.124%2c2.3852-4.2774%2c4.1958-0.51425%2c0.75626%2c1.572%2c4.4918%2c4.8404%2c8.3011%2c7.263l6.926%2c4.4047%2c1.39-4.4303c0.76451-2.4366%2c1.7773-3.8368%2c2.2506-3.1116%2c0.70585%2c1.0815-1.0945%2c8.4227-2.4528%2c10.002-0.20356%2c0.23674-2.4479-1.0705-4.9875-2.9049l-4.6172-3.3353-0.0182%2c5.9708c-0.0129%2c3.2839-0.36905%2c7.2125-0.79856%2c8.7301-0.83976%2c2.9674-3.0686%2c3.8021-3.0686%2c1.1492z'/%3e%3cpath fill='black' d='m737.82%2c217.03c-8.2314-6.8725-9.481-8.4451-9.2987-11.702l0.19399-3.4668%2c0.537%2c3.3485c0.31363%2c1.9552%2c2.5058%2c4.8853%2c5.2686%2c7.0422l4.7318%2c3.6937%2c2.9076-3.3631c1.5993-1.8497%2c2.9287-4.0529%2c2.9544-4.896%2c0.0673-2.1985%2c0.46176-2.0139%2c6.0347%2c2.8216%2c4.9515%2c4.2963%2c5.0287%2c4.3168%2c5.7651%2c1.533%2c0.41049-1.5519%2c0.26481-4.4736-0.32372-6.4926-1.6179-5.5499-1.3009-6.3875%2c1.1507-3.0403%2c1.2214%2c1.6677%2c3.1854%2c4.0253%2c4.3644%2c5.239%2c2.0523%2c2.1129%2c2.1775%2c2.0868%2c2.9412-0.6132%2c0.43872-1.551%2c0.80557-4.3898%2c0.81528-6.3085l0.0182-3.4885%2c4.4645%2c5.0607c4.1702%2c4.7272%2c4.5544%2c4.9018%2c5.8272%2c2.6494%2c0.7495-1.3262%2c1.3716-4.5171%2c1.3824-7.0908%2c0.0142-3.3248%2c0.36439-4.1637%2c1.21-2.8977%2c1.4121%2c2.114%2c0.43172%2c7.87-2.1758%2c12.775l-1.8712%2c3.5199-2.4571-3.8264c-3.1417-4.8928-4.1876-4.8142-6.2036%2c0.46582-1.9052%2c4.9898-3.1441%2c5.3696-5.0005%2c1.533-1.2013-2.4829-1.43-2.1787-2.2827%2c3.0374l-0.94776%2c5.7967-5.6785-4.4068-5.6786-4.4068-2.5528%2c2.9023c-1.4041%2c1.5963-2.5722%2c3.5922-2.5959%2c4.4353-0.0517%2c1.8274-1.4176%2c1.8844-3.4995%2c0.14622z'/%3e%3cpath fill='black' d='m811.04%2c191.43c-2.9962-2.6993-5.0602-5.2746-4.5867-5.723%2c0.47342-0.44838%2c1.0065-0.57681%2c1.1846-0.28542%2c0.17806%2c0.29139%2c2.6271%2c2.8668%2c5.4424%2c5.723%2c6.4822%2c6.5765%2c5.1496%2c6.7629-2.0403%2c0.28543z'/%3e%3cpath fill='black' d='m713.51%2c181.35c-2.7255-3.6852-2.5373-6.1267%2c0.7803-10.121%2c2.3974-2.8864%2c3.4925-3.2781%2c7.6788-2.7463%2c2.6854%2c0.34111%2c8.4638%2c2.7138%2c12.841%2c5.2725%2c5.0555%2c2.9552%2c10.285%2c4.9349%2c14.335%2c5.427%2c3.5069%2c0.42609%2c6.3763%2c0.58673%2c6.3763%2c0.35699%2c0-0.22973-1.4568-2.6032-3.2373-5.2744-4.2283-6.3433-4.0835-7.0241%2c0.68552-3.2237%2c4.8954%2c3.9012%2c10.751%2c5.0421%2c23.836%2c4.6444l6.393-0.19431-3.7088-3.6663c-5.1869-5.1273-3.5906-5.587%2c2.1375-0.61554%2c5.3722%2c4.6626%2c5.0358%2c4.991-6.2715%2c6.1196-4.8048%2c0.47958-9.9719%2c0.1317-14.267-0.96048-6.4256-1.6342-6.675-1.6093-5.4578%2c0.54471%2c0.70158%2c1.2414%2c1.8378%2c2.2571%2c2.5248%2c2.2571%2c0.68721%2c0%2c1.2495%2c0.62908%2c1.2495%2c1.3979%2c0%2c2.3644-13.879%2c0.28524-20.511-3.0727-15.151-7.6712-17.058-8.3355-20.664-7.1991-2.0067%2c0.63235-4.0153%2c2.4833-4.7074%2c4.3381-2.3091%2c6.1873%2c6.4658%2c10.997%2c10.085%2c5.5273%2c1.049-1.5853%2c0.804-2.6696-1.0397-4.5988-2.5248-2.6423-2.288-3.0188%2c1.1205-1.7801%2c2.4199%2c0.87945%2c2.7455%2c6.6892%2c0.49439%2c8.8212-2.5757%2c2.4393-8.4536%2c1.7488-10.674-1.254z'/%3e%3cpath fill='black' d='m773.19%2c166.07c-1.8946-1.7944-0.40932-2.2338%2c8.0847-2.3922%2c10.508-0.19593%2c16.89-1.947%2c24.42-6.7006%2c6.0333-3.8088%2c7.669-3.0593%2c1.9424%2c0.88996-5.2242%2c3.6027-13.372%2c6.3723-21.239%2c7.2191-3.8093%2c0.41006-8.1505%2c0.9781-9.6473%2c1.2623-1.4967%2c0.28421-3.0991%2c0.15887-3.561-0.27852z'/%3e%3c/g%3e%3c/svg%3e";

var img$F = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3crect width='450' height='300' fill='%23006b3f'/%3e%3crect width='450' height='200' fill='%23fcd116'/%3e%3crect width='450' height='100' fill='%23ce1126'/%3e%3cpath d='M225%2c100 257.492%2c200 172.427%2c138.197H277.573L192.508%2c200z' fill='black'/%3e%3c/svg%3e";

var img$E = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-60 -40 120 80'%3e%3cg fill='%23E70013'%3e%3crect x='-60' y='-40' width='120' height='80'/%3e%3ccircle fill='white' r='20'/%3e%3ccircle r='15'/%3e%3ccircle fill='white' cx='4' r='12'/%3e%3cpath transform='translate(4)scale(9)rotate(-90)' d='M0%2c-1 L0.58779%2c0.80902 L-0.95106%2c-0.30902 L0.95106%2c-0.30902 L-0.58779%2c0.80902z'/%3e%3c/g%3e%3c/svg%3e";

var img$D = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 980 700'%3e%3cpath d='M980 0H0v700h980z' fill='red'/%3e%3cpath d='M516.51 528.944c-6.15-5.332-13.605-16.13-13.5-26.538.55-7.761 5.873-12.27 9.312-2.796 4.862 10.457 15.29 27.749 29.66 17.605 6.278-4.608 6.18-11.392-2.428-10.614-10.63-.728-17.16-6.577-21.917-21.636-.865-8.282 2.58-8.075 7.387-2.747 6.18 7.09 18.478 17.806 32.046 12.063 7.54-3.16 9.668-9.68-1.723-11.285-10.784.157-19.587-6.834-28.35-17.498-4.805-5.9 2.282-11.856 6.537-6.834 3.795 3.26 9.11 9.266 13.665 10.094 5.267 1.034 11.796.52 19.03-3.31 7.798-6.527 5.266-11.236-4.2-12.32-7.338.364-11.335 3.153-20.8-3.16-17.014-11.5-30.54-26.865-32.653-45.347-1.388-12.156 5.148-15.837 10.582-14.438 14.78 3.802 24.449 31.422 34.675 46.595 3.348 4.373 6.424 4.444 8.6 3.096 4.102-3.517 7.378-6.408 11.48-10.34 0 0 30.085 5.406 46.468 10.746l-18.242 6.483c-6.907-3.814-15.243.298-15.243 6.915-6.536 4.52-6.01 9.819-3.19 14.933.86-3.561 1.594-8.186 6.757-8.801 7.369 3.048 15.955-1.302 15.955-7.057l21.519-8.458 21.74 12.308c0 8.32 7.883 10.956 16.085 8.71 3.865 2.4 6.35 6.564 7.659 11.017 2.42-6.422 1.915-10.956-1.875-14.107 2.175-8.303-9.46-16.287-18.467-10.97l-15.64-8.98 26.77-.75c3.107 5.5 14.337 5.803 17.613 0 2.8-.767 5.166-1.255 10.625 2.803-1.72-6.566-5.068-9.373-10.09-9.373-3.816-6.761-17.626-6.73-19.62.882l-27.881.775 16.543-11.778c6.175 3.646 14.84-.407 16.575-7.03 2.462-2.927 5.498-4.302 11.474-2.316-3.08-5.455-7.42-7.083-15.258-3.38-7.15-5.418-16.574 1.153-15.144 6.608l-22.01 14.975c-15.976-4.767-44.91-12.19-44.91-12.19 3.445-3.624 6.94-6.991 10.379-10.665 1.242-2.152-.656-4.658-3.293-5.18-25.816-5.328-40.597-15.735-49.553-42.186-3.746-11.078 4.353-14.388 7.136-7.612 3.85 9.424 8.098 19.724 19.69 27.7 3.998 2.796 15.899.513 8.86-6.164-7.29-6.006-10.428-8.588-14.02-23.19 0-7.398 7.54-10.715 11.746-3.624 4.5 14.545 4.96 20.808 13.107 30.18 6.173 7.092 14.223 11.857 18.22 11.75 7.192-.1 14.432-7.87 4.813-13.511-14.125-5.642-19.287-13.353-21.366-20.708-2.274-12.833.21-19.046 7.952-12.733 10.98 12.476 31.94 35.717 42.92 46.538 12.305 9.424 26.423 9.73 37.66.157 6.432-7.404 4.15-15.372-5.921-13.667-22.726 1.918-39.935-9.367-58.817-39.862-3.697-6.884-4.71-16.771 3.445-9.416 9.41 12.733 23.13 23.554 35.89 28.212 12.806 4.602 23.38 2.06 27.481-1.968 4.943-4.942 3.643-17.392-4.91-14.39-7.038 2.484-16.957 3.104-27.28-.883-10.331-4.038-21.06-12.733-32.45-27.485-3.9-8.332-2.63-15.373 5.265-11.08 18.68 15.845 42.775 28.678 55.072 20.967 9.062-5.643 9.215-20.138-2.274-19.204-23.137 3.153-31.891-1.968-54.115-21.585-5.058-3.781-4.708-13.361 3.34-7.248 18.68 12.063 44.19 16.77 54.214 10.458 9.013-5.643 7.694-22.885-7.491-16.778-12.151 7.404-25.565 7.197-52.442-12.006-6.78-5.642-1.723-12.997 3.844-9.837 21.617 12.32 53.104 17.598 61.3-7.454 3.188-9.574-2.58-15.166-11.035-8.54-18.576 17.185-39.635 8.746-51.423.1-3.376-1.99-9.57-12.062 1.31-10.193 28.147 6.42 55.986.828 61.05-19.103 2.937-6.47-2.84-17.912-13.113-8.332-13.512 13.354-27.84 13.817-45.857 13.717-9.166-1.918-9.263-12.012-1.57-13.51 14.223.306 28.244-5.907 39.482-12.22 10.986-6.313 20.096-15.166 22.984-27.435 1.77-10.972-8.81-22.62-15.186-10.972-9.417 17.028-30.273 33.078-53.46 35.975-1.207-2.02-4.248-7.198-7.994-5.743-6.808 2.64-14.92 6.172-23.272 10.139-18.004 8.549-25.507 12.669-23.345 27.44 2.257 15.413-9.626 25.153-19.44 22.463-8.56-2.304-13.282-10.036-11.748-23.447 1.229-10.686 11.957-23.612 24.046-30.39 7.826-4.38 19.642-6.776 33.865-9.936 8.656-1.705 13.065-5.072 13.568-8.596 0 0-5.917 4.33-15.388 3.68-4.478-.32-7.478-2.29-8.608-4.3 3.293-.67 9.264.107 14.628.107 7.135-.057 23.702-1.655 28.097-11.7 1.367-6.626-2.987-7.817-7.038-3.573-4.353 4.587-6.146 8.71-14.88 10.25-5.314.935-10.63 2.02-17.466.365 3.85-4.573 9.968-9.252 15.186-8.39 1.716.286 3.997 1.87 5.824 4.716 1.116-7.248-.865-15.43-20.25-12.013.308-5.485-11.238-7.868-18.17-7.761-3.948.1-11.998 2.433-17.816 5.222-9.214 2.853-18.324 4.922-29.06 5.7 6.23 5.328 7.395 5.642 13.616 10.143-9.41 3.517-16.7 10.765-19.991 15.53 0 0 10.986-.307 13.77.934-11.496 3.36-16.659 5.379-22.733 11.592 2.127.364 5.314.984 6.682 1.505 1.423.514 1.053 1.448-.098 2.326-2.476 1.89-12.708 13.774-15.694 16.62-2.986-2.846-13.218-14.73-15.694-16.62-1.151-.878-1.521-1.812-.098-2.326 1.367-.52 4.555-1.141 6.682-1.505-6.075-6.213-11.237-8.232-22.733-11.592 2.784-1.241 13.77-.934 13.77-.934-3.293-4.765-10.582-12.013-19.992-15.53 6.222-4.501 7.387-4.815 13.616-10.144-10.735-.777-19.845-2.846-29.06-5.7-5.817-2.788-13.867-5.121-17.815-5.221-6.933-.107-18.478 2.276-18.17 7.76-19.385-3.416-21.366 4.766-20.25 12.014 1.827-2.846 4.108-4.43 5.824-4.715 5.218-.863 11.335 3.816 15.186 8.389-6.836 1.655-12.152.57-17.467-.364-8.733-1.54-10.526-5.664-14.88-10.25-4.051-4.245-8.404-3.054-7.037 3.573 4.395 10.044 20.96 11.642 28.097 11.699 5.364 0 11.335-.778 14.628-.107-1.13 2.012-4.13 3.98-8.608 4.3-9.472.65-15.388-3.68-15.388-3.68.503 3.524 4.91 6.89 13.568 8.596 14.223 3.16 26.039 5.557 33.865 9.937 12.089 6.777 22.817 19.703 24.045 30.389 1.534 13.41-3.188 21.143-11.747 23.447-9.814 2.69-21.697-7.05-19.44-22.463 2.162-14.771-5.341-18.891-23.345-27.44-8.352-3.967-16.464-7.5-23.272-10.14-3.746-1.454-6.787 3.725-7.994 5.744-23.187-2.897-44.043-18.947-53.46-35.975-6.376-11.648-16.957 0-15.186 10.972 2.888 12.27 11.998 21.122 22.984 27.435 11.238 6.313 25.259 12.526 39.482 12.22 7.693 1.498 7.596 11.592-1.57 13.51-18.018.1-32.345-.363-45.857-13.717-10.274-9.58-16.05 1.862-13.113 8.332 5.064 19.93 32.903 25.523 61.049 19.103 10.88-1.87 4.687 8.204 1.31 10.194-11.787 8.645-32.846 17.084-51.422-.1-8.454-6.627-14.224-1.035-11.035 8.539 8.196 25.052 39.683 19.774 61.3 7.454 5.567-3.16 10.624 4.195 3.844 9.837-26.877 19.203-40.29 19.41-52.442 12.006-15.185-6.107-16.504 11.135-7.491 16.778 10.023 6.313 35.533 1.605 54.213-10.458 8.05-6.113 8.398 3.467 3.34 7.248-22.223 19.617-30.977 24.738-54.114 21.585-11.49-.934-11.336 13.56-2.274 19.204 12.297 7.71 36.39-5.122 55.07-20.966 7.897-4.294 9.166 2.747 5.267 11.079-11.39 14.752-22.12 23.447-32.45 27.485-10.323 3.987-20.242 3.367-27.28.884-8.553-3.003-9.853 9.447-4.911 14.389 4.103 4.028 14.676 6.57 27.483 1.968 12.758-4.658 26.479-15.48 35.889-28.212 8.154-7.355 7.142 2.532 3.445 9.416-18.882 30.495-36.09 41.78-58.817 39.862-10.072-1.705-12.353 6.263-5.922 13.667 11.238 9.573 25.356 9.267 37.66-.157 10.98-10.821 31.94-34.062 42.92-46.538 7.743-6.313 10.227-.1 7.953 12.733-2.08 7.355-7.24 15.066-21.366 20.708-9.62 5.643-2.38 13.41 4.813 13.51 3.997.108 12.047-4.657 18.22-11.748 8.147-9.373 8.608-15.636 13.107-30.181 4.206-7.091 11.746-3.774 11.746 3.623-3.592 14.603-6.731 17.185-14.02 23.19-7.04 6.678 4.862 8.96 8.859 6.165 11.593-7.976 15.84-18.276 19.69-27.7 2.784-6.776 10.883-3.466 7.137 7.612-8.956 26.45-23.737 36.858-49.553 42.187-2.637.52-4.535 3.027-3.294 5.179 3.44 3.674 6.935 7.04 10.38 10.665 0 0-28.935 7.423-44.911 12.19l-22.01-14.975c1.43-5.455-7.993-12.026-15.144-6.61-7.839-3.701-12.178-2.073-15.258 3.382 5.976-1.986 9.012-.611 11.474 2.315 1.735 6.624 10.4 10.677 16.575 7.03l16.543 11.78-27.88-.776c-1.995-7.611-15.805-7.643-19.622-.882-5.02 0-8.37 2.807-10.09 9.373 5.46-4.058 7.827-3.57 10.626-2.803 3.276 5.803 14.506 5.5 17.612 0l26.771.75-15.64 8.98c-9.007-5.317-20.642 2.667-18.467 10.97-3.79 3.15-4.296 7.685-1.875 14.107 1.308-4.453 3.794-8.617 7.66-11.018 8.2 2.247 16.084-.388 16.084-8.71l21.74-12.307 21.52 8.458c0 5.755 8.585 10.105 15.954 7.057 5.163.615 5.897 5.24 6.757 8.8 2.82-5.113 3.346-10.412-3.19-14.932 0-6.617-8.336-10.73-15.243-6.915l-18.242-6.483c16.383-5.34 46.469-10.745 46.469-10.745 4.101 3.93 7.377 6.822 11.48 10.34 2.176 1.347 5.252 1.276 8.6-3.097 10.226-15.173 19.894-42.793 34.675-46.595 5.434-1.4 11.97 2.282 10.582 14.438-2.114 18.482-15.64 33.848-32.652 45.347-9.466 6.313-13.463 3.524-20.801 3.16-9.466 1.084-11.998 5.793-4.2 12.32 7.234 3.83 13.763 4.344 19.03 3.31 4.555-.828 9.87-6.834 13.665-10.094 4.255-5.022 11.342.934 6.536 6.834-8.762 10.664-17.565 17.655-28.35 17.498-11.39 1.605-9.262 8.125-1.722 11.285 13.568 5.743 25.865-4.972 32.046-12.063 4.806-5.328 8.252-5.535 7.387 2.747-4.758 15.059-11.287 20.908-21.917 21.636-8.608-.778-8.706 6.006-2.428 10.614 14.37 10.144 24.798-7.148 29.66-17.605 3.439-9.473 8.76-4.965 9.312 2.796.105 10.408-7.35 21.206-13.5 26.538C457.344 534.278 490 568.18 490 568.18s32.657-33.904 26.509-39.237zm43.763-383.94c-5.083 0-8.223 1.78-8.223 3.94 0 2.194 3.14 3.982 8.223 3.982 5.053 0 8.262-1.95 8.262-4.147 0-2.16-3.21-3.776-8.262-3.776zm-140.544 0c5.083 0 8.223 1.78 8.223 3.94 0 2.194-3.14 3.982-8.223 3.982-5.053 0-8.262-1.95-8.262-4.147 0-2.16 3.21-3.776 8.262-3.776z' fill-rule='evenodd'/%3e%3c/svg%3e";

var img$C = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 840 600'%3e%3cpath fill='%23244aa5' d='M0 0h840v600H0z'/%3e%3cpath d='M424.541 190.135c3.515 4.101 5.868 8.2 5.868 13.185-2.951 1.459-7.028 2.054-9.381 4.69 14.651-2.055 17.57 14.934 33.978 8.487.596 2.353 2.95 4.407 5.867 3.519l1.757-4.68c6.432-1.756 4.675 8.785 11.731 6.73 3.517 2.934 1.164 7.907 3.517 11.437 0 4.094 1.758 7.608 3.513 11.122 1.759-2.04 2.92-4.974 7.028-4.095 2.919 3.217 5.272 6.15 5.865 9.664-1.19 6.745-2.947 12.596 4.08 16.11v2.054c4.707 2.055 15.249-2.054 15.249 6.15-.598 2.934 2.917.298 4.109 2.055 2.919-1.177 7.028-.58 10.541-.58 2.919 6.15-3.513 10.541-5.27 16.11 2.917 2.919 1.757 8.204 1.161 11.702l-1.758.879c4.675.878 10.54-.565 14.652 2.07l7.624 2.918c3.513-2.038 7.593-2.352 12.298-2.038 3.514 2.636-1.191 7.027 1.758 9.067 4.11 0 7.624.597 8.189 4.111l.595 1.16c2.919-5.271 11.138-1.758 14.653-5.552 5.866 0 7.026 6.432 9.944 9.946 1.193 9.097-9.944 13.209-6.431 22.275-2.353 4.391-7.028 7.907-10.541 12.016 1.16.596.564 2.04.564 2.918-3.514 2.071-.564 8.22-5.271 8.787-.565 3.826-7.593 2.352-5.27 6.46 4.704 6.15-2.323 9.947-2.323 15.531-2.95 3.231-8.816-2.95-8.816 3.231-3.514.878-7.027-3.23-9.35.284-1.19 4.11 2.323 5.553 1.758 9.663 5.836-.597 7.593 5.27 9.946 8.785l5.867 5.866c-5.867 4.675-13.491-.597-20.52 2.039-1.757-.878 0-3.2-1.757-4.078-1.758-2.072-5.27-2.072-8.189-2.638.565 2.638-4.705 3.515-2.352 6.715 0 .878 1.16 3.514-1.162 3.514-4.706 1.475-4.11-4.078-8.22-2.04-5.27 2.04-1.16 9.947-8.784 9.068 1.16 7.06-11.703 11.735-2.919 17.884 1.16 1.162.565 3.514.565 5.27-5.272 4.707-14.623 2.95-20.488 1.192-4.706-1.191-1.757-7.058-3.513-10.258-1.758-2.95-7.028-4.989-7.028-9.099-3.517-1.445-6.463-2.35-8.816-5.271-8.188 7.906-18.163 15.53-29.869 15.812-5.27 2.636-8.219 13.21-16.408 8.815-3.216 5.273-12.895 0-13.476 7.595-3.812 1.474-2.055 6.462-4.392 8.784-.879 5.866 0 10.854 4.973 14.37 2.054 4.391-4.393 4.391-1.758 8.503.597 1.444 0 3.513-.878 4.109-1.757.878-2.337 1.758-1.757 3.514-1.459 0-2.053.878-3.216 2.039-1.475 2.918-6.15 4.392-9.38 6.432-3.217.878-5.57-1.444-7.61-3.514-.596 3.231-3.23 4.989-6.446 4.989-4.691 0-3.812-4.11-7.327-5.867 1.46-5.271-3.23-7.593-1.757-12.3 3.811-2.917 10.244-4.987 8.487-11.136-4.094-4.958-2.635-12.3-6.73-18.166-2.635-2.322-7.027-5.835-5.569-11.42 3.812-4.392 0-9.663-2.054-14.338-.878-3.827-3.216-7.34-3.216-11.734-6.447-3.796-6.746-13.773-15.828-14.651-6.447 0-7.608-8.19-14.056-7.625-.595-1.16-2.054-2.038-3.23-3.2-4.675 3.2-10.542-.878-16.394.565-3.812-6.432 3.216-15.217-7.043-19.045v-4.078c1.177.564 1.757-.598 2.055-1.193.58-4.392-7.327-4.957-4.094-9.946-1.758-1.474-3.812-2.07-2.636-4.988-4.407-9.068-17.585-8.189-20.518-17.287 2.352-2.038 2.352-4.11 3.232-5.866-2.056-3.515-2.636-7.311-2.056-11.107 2.056-.597 3.216-3.231 4.393-5.303-2.636-1.756-5.853-4.391-8.786-3.513-5.27-.878-9.083-4.957-13.773-7.31-1.176-1.162-.58-3.231-.58-4.675 6.447-2.072-.878-11.154 7.028-9.977 2.056-2.635 6.447-3.514 9.665-5.569 3.23-.58 5.866.596 9.082 1.475 2.635 3.499 7.326 2.04 9.96 4.972 2.636-.595 5.868-2.055 9.084-.595 0-4.974 2.338-7.907 5.866-11.422.58-2.04 3.797-3.513 6.432-4.675 4.99 1.162 10.84 1.162 14.37-2.353 2.338 1.474 4.393-1.458 7.028-1.458 3.215-.596 5.851.282 8.204 1.757.283-5.868 10.541-.88 12.597-7.907 2.338-4.691-6.447-6.447-5.867-10.557-1.46-4.691 2.055-7.028 3.811-10.244 2.055-.88 4.393-2.055 7.028-1.475 6.746-2.338 1.474-16.11 12.315-11.122 0 1.46-.596 3.216.282 3.514 3.812 0 4.397-4.396 7.044-5.866 1.16-4.094-1.474-9.082 2.04-12.3 1.757-.297 3.23-.877 4.392-2.352 0-3.216-1.757-4.972-4.393-7.028-.878 1.464-3.216.298-4.686.88 0-3.515-2.044-5.852-2.64-9.084-1.757-.878-2.635-2.337-2.04-4.393 2.636-2.635 0-9.082 6.15-7.62 2.338-2.043 6.447-.584 8.785-4.099 6.15-3.513 14.353-3.513 19.044-9.96 2.055.297 4.393-1.757 6.447 0 .582 3.81 6.151 2.336 6.151 5.858' fill='%23d0a650'/%3e%3cpath d='M469.9 110.7l-8.1-24.9-8 24.9h-26.2l21.2 15.4-8.1 24.9 21.1-15.4L483 151l-8.1-24.9 21.2-15.4zm82.4 14.5l-8.1-24.8-8 24.8H510l21.2 15.4-8.1 24.9 21.1-15.4 21.2 15.4-8.1-24.9 21.2-15.4zm78.6 28.6l-8-24.8-8.1 24.8h-26.2l21.2 15.4-8.1 24.9 21.2-15.4 21.1 15.4-8.1-24.9 21.2-15.4zm-244.7-43.1l-8-24.9-8.1 24.9h-26.2l21.2 15.4L357 151l21.2-15.4 21.1 15.4-8.1-24.9 21.2-15.4zm-82.4 14.5l-8-24.8-8.1 24.8h-26.2l21.2 15.4-8.1 24.9 21.2-15.4 21.1 15.4-8.1-24.9 21.2-15.4zm-78.6 28.6l-8.1-24.8-8 24.8h-26.2l21.2 15.4-8.1 24.9 21.1-15.4 21.2 15.4-8.1-24.9 21.2-15.4z' fill='white'/%3e%3c/svg%3e";

var img$B = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 12'%3e%3crect width='20' height='12' fill='%23006a4e'/%3e%3ccircle cx='9' cy='6' r='4' fill='%23f42a41'/%3e%3c/svg%3e";

var img$A = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 48'%3e%3cpath d='M0%2c48V0H72z' fill='%231eb53a'/%3e%3cpath d='M0%2c48H72V0z' fill='%2300a3dd'/%3e%3cpath d='M0%2c48 72%2c0' stroke='%23fcd116' stroke-width='19'/%3e%3cpath d='M0%2c48 72%2c0' stroke='black' stroke-width='13'/%3e%3c/svg%3e";

var img$z = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1080 720'%3e%3crect width='1080' height='720' fill='%2320603D'/%3e%3crect width='1080' height='540' fill='%23FAD201'/%3e%3crect width='1080' height='360' fill='%2300A1DE'/%3e%3cg transform='translate(886.5%2c188.1)'%3e%3cg id='h'%3e%3cpath id='q' fill='%23E5BE01' d='M 116.10000%2c0.00000 L 35.69202%2c4.69894 112.14399%2c30.04889 33.25966%2c13.77660 100.54555%2c58.05000 28.56072%2c21.91541 82.09510%2c82.09510 21.91541%2c28.56072 58.05000%2c100.54555 13.77660%2c33.25966 30.04889%2c112.14399 4.69894%2c35.69202 0.00000%2c116.10000 -1%2c-1 z'/%3e%3cuse xlink:href='%23q' transform='scale(1%2c-1)'/%3e%3c/g%3e%3cuse xlink:href='%23h' transform='scale(-1%2c1)'/%3e%3ccircle r='34.3' fill='%23E5BE01' stroke='%2300A1DE' stroke-width='3.4'/%3e%3c/g%3e%3c/svg%3e";

var img$y = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect width='900' height='600' fill='black'/%3e%3crect width='900' height='206.25' fill='white'/%3e%3crect width='900' height='187.5' fill='%23007168'/%3e%3crect y='393.5' width='900' height='206.5' fill='white'/%3e%3crect y='412.5' width='900' height='187.5' fill='%23fce100'/%3e%3cpath d='M 0%2c0 V 600 L 393.75%2c300 z' fill='%23d21034'/%3e%3cpath d='M 189.54603%2c214.56867 L 128.78569%2c171.99623 L 69.930531%2c217.0706 L 91.643351%2c146.12847 L 30.587837%2c104.08263 L 104.76744%2c102.81043 L 125.88822%2c31.750306 L 150.02091%2c101.90617 L 224.12978%2c100.03443 L 164.86501%2c144.66535 z' transform='matrix(1.221793%2c2.542786e-2%2c-2.542786e-2%2c1.221793%2c-21.7604%2c145.5065)' fill='%23fce100'/%3e%3cpath d='M 77.1122%2c167.913 L 118.946%2c167.913 C 122.312%2c171.689 129.822%2c173.229 136.975%2c167.868 C 150.087%2c160.688 175.454%2c167.913 175.454%2c167.913 L 180.449%2c162.606 L 168.273%2c122.645 L 163.902%2c117.962 C 163.902%2c117.962 154.537%2c112.343 136.741%2c114.216 C 118.946%2c116.089 112.702%2c113.592 112.702%2c113.592 C 112.702%2c113.592 97.0927%2c115.465 92.7219%2c117.65 C 92.2414%2c118.039 87.7268%2c122.645 87.7268%2c122.645 z' transform='matrix(1.259719%2c0%2c0%2c1.259719%2c-29.41569%2c140.9042)' fill='white' fill-rule='evenodd' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M 85.5415%2c157.611 C 85.5415%2c157.611 125.502%2c152.616 137.054%2c167.913 C 130.53%2c172.377 124.786%2c172.745 118.634%2c168.226 C 119.614%2c166.593 132.995%2c152.616 167.024%2c157.299' transform='matrix(1.259719%2c0%2c0%2c1.259719%2c-29.41569%2c140.9042)' fill='none' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M 128.312%2c117.65 L 128%2c161.67 M 163.902%2c118.274 L 171.395%2c153.24 M 93.1339%2c117.725 L 88.9756%2c135.757' transform='matrix(1.259719%2c0%2c0%2c1.259719%2c-29.41569%2c140.9042)' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M 49.9417%2c172.706 L 59.7799%2c184.241 C 60.9352%2c184.93 61.9614%2c184.886 62.9876%2c184.241 L 77.5681%2c166.745 L 83.6919%2c159.163 C 84.6401%2c158.04 84.9428%2c156.787 84.8583%2c155.664 L 96.5657%2c145.261 C 97.5234%2c145.327 98.0938%2c145.435 99.0515%2c145.5 C 97.92%2c145.207 97.0898%2c144.656 97.9807%2c143.416 L 100.605%2c141.375 L 102.646%2c143.999 C 102.646%2c143.999 99.7304%2c147.79 99.4388%2c147.79 C 99.1472%2c147.79 96.2311%2c147.79 96.2311%2c147.79 L 90.1073%2c153.331 L 92.7843%2c155.697 L 96.8143%2c166.745 L 101.772%2c163.245 L 98.5639%2c151.873 L 105.563%2c144.291 L 102.938%2c140.208 L 104.688%2c137.875 C 104.688%2c137.875 128.91%2c153.125 138.242%2c149.043 C 138.494%2c149.134 138.806%2c138.167 138.806%2c138.167 C 138.806%2c138.167 113.728%2c135.543 113.144%2c130.585 C 112.561%2c125.628 118.685%2c125.045 118.685%2c125.045 L 116.06%2c121.254 L 116.644%2c119.212 L 121.018%2c124.753 L 130.933%2c116.296 L 189.254%2c182.783 C 192.438%2c181.492 193.118%2c180.713 193.337%2c177.534 C 193.255%2c177.454 136.182%2c111.922 136.182%2c111.922 L 140.556%2c107.257 C 141.418%2c106.285 141.721%2c105.872 141.722%2c104.34 L 148.429%2c98.5082 C 150.446%2c99.2011 151.732%2c100.41 152.803%2c102.007 L 171.242%2c86.3801 C 171.728%2c86.8661 173.204%2c87.3521 174.206%2c86.8055 L 204.691%2c57.5442 L 171.466%2c81.0116 L 170.3%2c80.1368 C 170.3%2c79.1647 171.505%2c78.9243 170.3%2c77.2207 C 169.009%2c75.6716 167.092%2c78.6788 166.801%2c78.6788 C 166.509%2c78.6788 161.992%2c77.0824 161.002%2c75.06 L 160.677%2c80.4284 L 152.22%2c88.3019 L 145.805%2c88.0103 L 136.473%2c97.0501 L 135.307%2c100.549 L 136.765%2c103.466 C 136.765%2c103.466 131.807%2c107.84 131.807%2c107.548 C 131.807%2c107.257 130.805%2c106.259 130.762%2c106.13 L 135.015%2c102.299 L 135.598%2c99.6747 L 134.179%2c97.4589 C 133.749%2c97.7714 128.308%2c103.466 128.016%2c102.882 C 127.53%2c102.338 112.27%2c85.0942 112.27%2c85.0942 L 113.144%2c81.8865 L 103.23%2c71.0969 C 99.6155%2c69.849 93.8982%2c69.6389 92.7318%2c77.5123 C 91.8235%2c79.3616 84.2751%2c77.8039 84.2751%2c77.8039 L 80.1926%2c78.6788 L 57.1554%2c111.339 L 69.9862%2c126.794 L 96.2311%2c93.5508 L 97.0102%2c84.1332 L 102.517%2c90.2905 C 104.353%2c90.5264 106.102%2c90.5471 107.766%2c89.7073 L 123.315%2c107.063 L 120.726%2c109.589 C 121.601%2c110.561 122.203%2c111.182 123.078%2c112.154 C 123.953%2c111.571 124.788%2c110.871 125.663%2c110.287 C 125.955%2c110.677 126.441%2c111.416 126.733%2c111.805 C 125.43%2c112.514 124.516%2c113.458 123.213%2c114.167 C 121.128%2c112.808 119.115%2c111.116 119.268%2c108.423 L 110.52%2c115.713 L 110.228%2c117.171 L 84.2751%2c138.75 L 81.9422%2c139.042 L 81.359%2c145.749 L 98.2723%2c131.752 L 98.2723%2c129.71 L 100.022%2c131.168 L 113.144%2c120.671 C 113.144%2c120.671 114.019%2c121.837 113.728%2c121.837 C 113.436%2c121.837 102.063%2c132.335 102.063%2c132.335 L 101.772%2c133.501 L 99.7304%2c135.251 L 98.5639%2c134.376 L 82.817%2c148.373 L 80.4842%2c148.373 L 71.7359%2c157.122 C 69.4795%2c157.318 67.5243%2c157.557 65.6121%2c158.871 z' transform='matrix(1.259719%2c0%2c0%2c1.259719%2c-29.41569%2c140.9042)' fill='black' fill-rule='evenodd' stroke='black' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$x = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300'%3e%3crect fill='%233a75c4' width='400' height='300'/%3e%3crect fill='%23fcd116' width='400' height='200'/%3e%3crect fill='%23009e60' width='400' height='100'/%3e%3c/svg%3e";

var img$w = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 720 360'%3e%3crect fill='%23da121a' height='360' width='720'/%3e%3crect fill='%23fcdd09' height='240' width='720'/%3e%3crect fill='%23078930' height='120' width='720'/%3e%3cg transform='translate(360%2c180)'%3e%3ccircle fill='%230f47af' r='120'/%3e%3cg id='t'%3e%3cpath fill='%23fcdd09' d='M0%2c-96 -4.205849%2c-83.055728 13.141645%2c-29.665631H-9.987258L-12.586616%2c-21.665631H61.576052L72.587108%2c-29.665631H21.553343z'/%3e%3cpath stroke='%23fcdd09' stroke-width='4' d='M0%2c44V96' transform='rotate(216)'/%3e%3c/g%3e%3cuse xlink:href='%23t' transform='rotate(72)'/%3e%3cuse xlink:href='%23t' transform='rotate(144)'/%3e%3cuse xlink:href='%23t' transform='rotate(216)'/%3e%3cuse xlink:href='%23t' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";

var img$v = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2100 1400'%3e%3crect width='2100' height='1400' fill='%23198a00'/%3e%3crect x='1850' y='500' width='250' height='900' fill='%23ef7d00'/%3e%3crect x='1600' y='500' width='250' height='900' fill='black'/%3e%3crect x='1350' y='500' width='250' height='900' fill='%23de2010'/%3e%3cg fill='%23ef7d00' stroke='black' stroke-width='2.25' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M 1916.4245%2c168.3344 C 1916.4245%2c168.3344 2002.4265%2c134.6285 2010.7593%2c127.6785 C 2014.5489%2c131.8483 1976.2829%2c174.2418 1902.0276%2c189.87871 C 1969.4633%2c175.2842 2027.0511%2c129.4158 2038.7957%2c130.8058 C 2042.2056%2c131.5008 2041.4461%2c175.6316 1886.8731%2c213.85517 C 1993.7101%2c188.14097 2055.8431%2c140.8829 2055.0855%2c146.0952 C 2055.8431%2c147.1376 2044.4782%2c183.27622 1950.9008%2c211.42263 C 1977.0424%2c205.86205 2047.8881%2c166.2494 2047.1305%2c173.8943 C 2049.4031%2c177.0216 1978.5575%2c260.41781 1850.5039%2c233.31502 C 1952.7956%2c257.63859 2019.0941%2c198.91314 2028.5661%2c199.95564 C 2030.4609%2c200.30309 2009.6221%2c251.38355 1880.8128%2c254.51107 C 1942.568%2c248.60433 1924.7593%2c254.16286 1924.7593%2c254.16286 C 1924.7593%2c254.16286 1888.3881%2c280.22426 1844.4417%2c262.50402 C 1878.918%2c271.19178 1882.7056%2c271.53828 1883.4633%2c274.31751 C 1881.1906%2c277.79154 1852.7764%2c283.00526 1825.4995%2c269.45208 C 1847.4718%2c277.79154 1867.1733%2c279.18294 1867.5512%2c282.31046 C 1867.1733%2c283.35177 1853.1561%2c290.64992 1840.654%2c285.43798 C 1828.1518%2c280.22426 1712.9782%2c215.24513 1712.9782%2c215.24513 L 1909.227%2c165.902 z'/%3e%3cpath d='M 1685.7126%2c344.10525 C 1668.4556%2c344.10525 1667.9794%2c358.19028 1667.9794%2c358.19028 C 1667.9794%2c358.19028 1666.5551%2c359.20736 1667.5052%2c366.03421 C 1670.3541%2c361.38542 1671.7804%2c359.93337 1671.7804%2c359.93337 C 1673.6808%2c360.22451 1681.5962%2c362.40249 1694.104%2c353.39936 C 1682.7032%2c364.28942 1689.5134%2c368.35602 1689.5134%2c368.35602 C 1689.5134%2c368.35602 1686.8216%2c376.92419 1695.5285%2c378.66728 C 1692.8383%2c375.18109 1694.4214%2c372.13156 1694.4214%2c372.13156 C 1694.4214%2c372.13156 1706.6118%2c370.97066 1705.8204%2c357.32052 C 1706.2964%2c369.66245 1713.5789%2c372.71197 1713.5789%2c372.71197 C 1713.5789%2c372.71197 1713.5789%2c379.53704 1721.4943%2c380.11924 C 1717.2212%2c376.63305 1718.1694%2c371.26002 1718.1694%2c371.26002 C 1718.1694%2c371.26002 1728.4613%2c364.43494 1719.7526%2c352.81725 C 1724.9778%2c350.05699 1729.2529%2c342.36216 1729.2529%2c342.36216 C 1729.2529%2c342.36216 1722.1291%2c339.60198 1718.8042%2c337.28017 C 1717.2192%2c334.22886 1718.6456%2c317.52919 1718.6456%2c317.52919 L 1714.3704%2c295.89129 L 1702.1781%2c329.58356 C 1702.6522%2c324.79085 1702.9697%2c344.10525 1685.7126%2c344.10525 z'/%3e%3cpath d='M 1770.9438%2c295.51356 C 1771.3216%2c295.86186 1783.8256%2c308.72015 1795.9482%2c308.02364 C 1800.4933%2c304.54953 1786.4761%2c296.90496 1786.4761%2c295.16705 C 1791.401%2c299.33759 1812.238%2c315.66829 1825.4995%2c309.76147 C 1830.8022%2c302.81171 1816.0275%2c303.85472 1799.7358%2c285.08968 C 1811.1007%2c292.03953 1839.5168%2c307.32884 1852.7764%2c301.42209 C 1858.4607%2c295.86186 1823.225%2c278.48634 1811.4804%2c264.93494 L 1781.1734%2c250.68874 L 1739.8773%2c281.61565 z'/%3e%3cpath d='M 1724.3449%2c189.87853 C 1724.3449%2c189.87853 1738.3622%2c182.23388 1794.433%2c186.05621 C 1800.4952%2c186.75101 1832.6971%2c175.9792 1842.9266%2c172.8518 C 1859.2164%2c170.0719 1911.1199%2c159.6472 1925.1389%2c149.9175 C 1934.9888%2c148.8752 1922.4847%2c166.597 1909.9846%2c170.7667 C 1896.7229%2c176.32663 1848.6091%2c191.61602 1831.5597%2c189.53109 C 1852.0189%2c189.87871 1840.654%2c205.16792 1806.5555%2c197.87072 C 1822.8472%2c206.21035 1816.785%2c207.6003 1816.785%2c207.6003 C 1816.785%2c207.6003 1787.993%2c208.99025 1780.4158%2c203.083 C 1799.7377%2c209.68531 1791.7807%2c212.11761 1791.7807%2c212.11761 C 1791.7807%2c212.11761 1772.0811%2c213.855 1762.9868%2c210.03267 C 1777.0041%2c213.855 1769.8065%2c216.28754 1769.8065%2c216.28754 C 1769.8065%2c216.28754 1758.4416%2c218.02494 1748.9696%2c214.89759 C 1739.4994%2c211.77024 1725.1025%2c189.87853 1724.3449%2c189.87853 z'/%3e%3cpath d='M 1746.8274%2c302.71636 L 1748.8865%2c336.69798 C 1748.8865%2c336.69798 1747.7776%2c338.44108 1746.8274%2c339.45816 C 1745.8771%2c340.47353 1720.5441%2c335.82644 1724.0276%2c353.54318 C 1724.0276%2c360.80493 1724.1863%2c362.69184 1729.5703%2c366.75845 C 1728.144%2c361.96582 1728.6201%2c358.62694 1728.6201%2c358.62694 C 1728.6201%2c358.62694 1735.7439%2c362.54802 1742.711%2c351.80187 C 1737.9617%2c362.40249 1741.2846%2c366.17804 1742.3936%2c366.46909 C 1743.5025%2c368.35772 1740.495%2c376.92419 1749.9935%2c376.77866 C 1746.3532%2c373.58352 1748.0949%2c368.93642 1748.0949%2c368.93642 C 1748.0949%2c368.93642 1758.0695%2c367.48617 1754.5859%2c350.93033 C 1758.2281%2c347.58966 1759.6525%2c350.78479 1759.6525%2c350.78479 C 1759.6525%2c350.78479 1760.7596%2c360.65939 1769.4684%2c358.62694 C 1773.428%2c360.65939 1768.8356%2c366.03242 1768.8356%2c366.03242 C 1768.8356%2c366.03242 1775.1678%2c366.17804 1777.0683%2c361.23981 C 1778.9688%2c356.30336 1781.1847%2c347.44413 1770.7341%2c343.81411 C 1769.4684%2c340.32971 1774.8524%2c340.03856 1774.8524%2c340.03856 C 1774.8524%2c340.03856 1781.502%2c342.07101 1783.4006%2c345.12063 C 1785.3011%2c348.17015 1784.6682%2c337.13456 1776.4354%2c335.97196 C 1766.3022%2c335.68091 1765.6694%2c333.79399 1765.6694%2c333.35902 C 1765.6694%2c332.92244 1763.9276%2c308.67167 1763.1361%2c301.70098 z'/%3e%3cpath d='M 1782.0688%2c331.67486 C 1782.1934%2c330.11719 1764.7834%2c308.61621 1769.2001%2c305.83699 C 1773.6149%2c306.67035 1780.8559%2c316.44969 1786.7216%2c313.27539 C 1784.9439%2c309.46353 1779.7036%2c311.61029 1773.7529%2c301.85179 C 1767.8041%2c290.81969 1766.9351%2c274.25865 1746.0981%2c256.19352 C 1759.5883%2c275.31034 1790.1901%2c286.5157 1791.4861%2c280.9416 C 1792.782%2c275.3675 1764.5397%2c254.28933 1765.9868%2c249.20906 C 1771.6031%2c259.64161 1799.9606%2c282.88746 1820.8542%2c280.96244 C 1822.2862%2c276.48689 1803.7445%2c267.45433 1798.9726%2c259.01961 C 1785.626%2c250.79616 1749.9084%2c222.55764 1749.1925%2c216.00857 C 1736.1954%2c198.622 1728.0817%2c193.36226 1724.3034%2c191.35975 C 1722.8431%2c189.78217 1722.4767%2c188.27399 1722.1914%2c187.31517 C 1714.123%2c169.8692 1724.8097%2c164.2041 1731.0646%2c163.3664 C 1736.2124%2c162.8417 1737.7067%2c163.5485 1741.4113%2c161.9032 C 1737.0247%2c160.3293 1732.6401%2c158.8574 1728.2554%2c157.2835 C 1733.9738%2c161.1307 1748.5805%2c157.7436 1745.4143%2c168.8249 C 1751.8184%2c166.5901 1765.4446%2c151.7209 1729.9707%2c148.3652 C 1718.4264%2c136.218 1670.9623%2c129.237 1659.0818%2c182.2531 C 1660.0301%2c182.99639 1660.5269%2c183.60716 1663.5458%2c185.67499 C 1648.5575%2c179.01161 1608.1248%2c173.8732 1593.554%2c171.7138 C 1554.1905%2c161.297 1513.3099%2c136.1939 1509.3802%2c139.2811 C 1504.1242%2c141.4208 1533.1636%2c166.2005 1531.6542%2c166.749 C 1506.4747%2c153.2833 1483.4723%2c143.7431 1462.0688%2c135.0617 C 1447.0114%2c129.8992 1431.9299%2c117.8797 1430.2669%2c120.1662 C 1424.7253%2c130.6954 1454.4075%2c157.1623 1459.9287%2c160.2757 C 1465.4516%2c163.2539 1508.8759%2c181.72909 1508.2356%2c181.95975 C 1442.8304%2c154.731 1431.8645%2c149.7947 1428.5824%2c146.6553 C 1422.8177%2c145.4644 1408.775%2c128.074 1404.8615%2c129.1923 C 1402.719%2c131.1229 1407.0161%2c158.6011 1438.2263%2c170.9357 C 1443.3134%2c174.3363 1505.1266%2c194.67481 1504.5213%2c196.26941 C 1504.3701%2c196.66789 1433.7231%2c169.5256 1430.9789%2c168.5552 C 1417.358%2c163.6563 1400.6447%2c146.4846 1397.5201%2c148.4156 C 1394.5379%2c150.1678 1405.2248%2c168.754 1418.9884%2c174.5834 C 1426.2027%2c177.50343 1453.8752%2c190.0745 1478.8069%2c198.07552 C 1480.3981%2c198.60329 1433.9924%2c181.93483 1411.6811%2c173.3834 C 1401.5649%2c168.2337 1396.801%2c161.8148 1395.2601%2c163.1959 C 1392.9808%2c164.5768 1398.9425%2c192.03295 1470.6403%2c207.52545 C 1472.5293%2c208.26287 1495.8781%2c202.45215 1494.7241%2c203.22283 C 1494.4354%2c203.41556 1471.5384%2c207.98755 1469.309%2c207.83131 C 1467.3249%2c207.55335 1454.781%2c209.19336 1454.5541%2c209.78959 C 1453.7962%2c211.64683 1459.0989%2c221.47779 1496.1182%2c219.42766 C 1500.8508%2c219.16671 1526.5335%2c210.84928 1524.3758%2c212.63847 C 1523.2969%2c213.53358 1489.403%2c223.63519 1486.8217%2c223.83447 C 1484.5797%2c224.12502 1472.6728%2c225.26704 1472.2326%2c226.42862 C 1471.695%2c228.01284 1481.0459%2c235.00963 1500.9262%2c236.13064 C 1518.5282%2c236.98833 1551.9751%2c226.26591 1551.3042%2c226.96106 C 1550.6331%2c227.65612 1519.0604%2c237.5792 1518.2342%2c238.18393 C 1517.0918%2c238.77651 1505.5304%2c239.35172 1505.1246%2c240.16612 C 1504.1825%2c242.19168 1521.802%2c257.30424 1573.911%2c241.1763 C 1568.6762%2c247.66176 1543.4181%2c252.09749 1543.4544%2c253.26528 C 1543.3373%2c254.11259 1549.0191%2c259.14779 1557.8497%2c260.94983 C 1562.2647%2c261.85081 1568.3098%2c261.66709 1573.8316%2c260.86664 C 1583.7496%2c259.04555 1594.202%2c255.44675 1607.4824%2c244.18943 C 1609.0694%2c247.7224 1574.3077%2c263.85722 1575.9399%2c265.39586 C 1583.4775%2c271.80689 1608.5159%2c264.56939 1610.1556%2c263.72905 C 1611.7972%2c262.88693 1658.3714%2c238.79904 1658.2108%2c236.01114 C 1658.9344%2c239.58392 1598.1654%2c269.86969 1598.8209%2c271.11208 C 1602.7219%2c276.82124 1623.4814%2c270.81226 1624.4731%2c270.28731 C 1625.4631%2c269.76397 1650.9661%2c257.1275 1651.665%2c256.75496 C 1652.3622%2c256.38243 1621.6924%2c273.21904 1624.4241%2c275.78162 C 1623.1036%2c286.71498 1672.3226%2c268.23581 1676.1801%2c265.93476 C 1678.1089%2c264.78423 1652.5359%2c276.24772 1652.4679%2c281.69356 C 1660.7027%2c294.46357 1687.0709%2c290.41253 1691.1381%2c287.60379 C 1693.1727%2c286.19862 1688.7446%2c297.09029 1690.1709%2c296.10094 C 1690.6678%2c295.89648 1695.9063%2c290.21495 1697.9201%2c286.10327 C 1697.2777%2c289.67094 1694.3874%2c295.29174 1692.7004%2c301.74087 C 1691.0116%2c308.18993 1690.5279%2c315.46723 1688.2101%2c323.19855 C 1687.6791%2c326.59459 1704.4583%2c316.5589 1702.0213%2c292.56797 C 1703.4571%2c305.04684 1696.7224%2c328.38106 1698.4848%2c329.59393 C 1702.01%2c332.01968 1711.7559%2c317.97275 1712.7401%2c308.47409 C 1715.6343%2c313.2719 1721.7078%2c323.28692 1726.9331%2c325.59137 C 1726.3645%2c318.33312 1727.0332%2c318.66586 1724.6813%2c311.53229 C 1726.0376%2c302.06144 1726.2266%2c288.9536 1726.5552%2c274.15293 C 1740.7539%2c299.1002 1746.4174%2c309.63499 1742.4503%2c328.73974 C 1746.6724%2c330.35457 1753.4165%2c315.40489 1752.8725%2c307.70996 C 1758.2943%2c329.09143 1781.6966%2c332.29695 1782.0688%2c331.67486 z'/%3e%3cpath d='M 1545.5749%2c173.2876 C 1545.5749%2c173.2876 1535.9106%2c179.9848 1523.8842%2c179.591 C 1526.8908%2c190.62165 1551.8029%2c182.15172 1551.8029%2c182.15172 C 1551.8029%2c182.15172 1539.7764%2c194.36428 1531.1861%2c196.33396 C 1536.3403%2c200.27349 1558.0311%2c198.89477 1561.6827%2c196.925 C 1565.3326%2c194.95515 1571.7762%2c187.27308 1571.7762%2c187.27308 C 1571.7762%2c187.27308 1549.4406%2c210.91026 1546.2193%2c210.71344 C 1545.7897%2c213.47107 1569.6284%2c212.48614 1574.5684%2c208.34971 C 1579.5066%2c204.21311 1591.9634%2c198.10691 1591.9634%2c198.10691 C 1591.9634%2c198.10691 1559.3195%2c218.98639 1557.8157%2c218.98639 C 1570.0573%2c221.94117 1594.5402%2c215.44075 1610.2179%2c206.57684 C 1587.0233%2c220.75926 1584.8773%2c223.31981 1573.0646%2c228.04728 C 1583.5889%2c230.2142 1588.9559%2c236.71462 1624.6073%2c222.53196 C 1645.0097%2c213.66823 1656.6051%2c197.51588 1656.6051%2c197.51588 C 1643.9348%2c213.07718 1623.9613%2c226.27561 1601.8435%2c239.27551 C 1600.5532%2c241.63891 1625.4649%2c251.28999 1657.2493%2c220.95624'/%3e%3cpath d='M 1718.2413%2c239.07802 C 1718.2413%2c239.07802 1720.3891%2c248.33581 1728.9789%2c255.42769 C 1737.5707%2c262.51788 1738.2149%2c269.41228 1738.2149%2c269.41228'/%3e%3cpath d='M 1713.9473%2c178.80314 C 1713.9473%2c178.80314 1716.9529%2c187.07601 1725.758%2c192.39452 C 1734.7786%2c197.71286 1748.3103%2c214.45591 1749.3833%2c217.41051 C 1750.4223%2c220.98661 1755.6098%2c246.76077 1755.1811%2c249.51746'/%3e%3cpath d='M 1659.1838%2c191.60649 C 1659.8279%2c194.75808 1646.5116%2c210.71344 1664.7661%2c229.42617 C 1648.2288%2c247.94073 1648.2307%2c250.30583 1648.2307%2c250.30583 C 1648.2307%2c250.30583 1657.4646%2c255.03262 1674.0019%2c242.0322 C 1701.2751%2c272.76153 1692.1866%2c286.82411 1692.1866%2c286.82411'/%3e%3cpath d='M 1690.0141%2c265.13074 C 1690.0141%2c265.13074 1687.5016%2c261.82996 1691.9807%2c249.5036 C 1696.0139%2c253.96009 1700.4987%2c254.91133 1702.4653%2c256.71508 C 1704.4299%2c258.51881 1725.0232%2c261.25304 1726.3323%2c273.87565'/%3e%3cpath d='M 1714.2231%2c149.4322 C 1714.2231%2c148.5049 1710.0765%2c140.3439 1694.6066%2c150.5451 C 1702.8979%2c151.0086 1711.0872%2c155.3674 1714.2231%2c149.4322 z'/%3e%3cpath d='M 1861.8688%2c186.75118 C 1862.6263%2c187.09854 1908.0897%2c196.13332 1923.2443%2c191.61602 C 1903.9224%2c215.24513 1865.2786%2c199.26067 1865.2786%2c199.26067 C 1884.2207%2c204.47295 1884.9802%2c204.12559 1891.0404%2c208.99025 C 1892.9352%2c213.50756 1856.1863%2c211.42263 1844.0619%2c205.16792 C 1877.7808%2c214.89759 1878.5384%2c214.20262 1879.6755%2c218.02494 C 1881.1926%2c223.23722 1824.3623%2c216.63491 1819.4373%2c209.68531 C 1834.5918%2c220.45741 1842.9266%2c222.54242 1851.2614%2c227.40708 C 1841.0319%2c231.57703 1822.0896%2c235.74603 1787.2336%2c213.16019 C 1833.0748%2c251.38355 1874.371%2c248.95092 1880.8128%2c255.90068 C 1864.9008%2c277.44503 1803.1456%2c243.04417 1774.7314%2c225.66951 C 1746.3173%2c208.29527 1836.8644%2c267.71596 1845.2011%2c266.67286 C 1841.0319%2c272.5796 1811.1026%2c267.36766 1809.2077%2c264.58844'/%3e%3cpath d='M 1873.6134%2c226.71211 C 1868.3106%2c227.40708 1852.3986%2c227.40708 1850.126%2c227.05955'/%3e%3cpath d='M 1532.2598%2c166.9845 C 1532.2598%2c166.9845 1566.8363%2c183.72743 1581.4391%2c182.54561 C 1577.574%2c185.89418 1571.7744%2c187.27308 1571.7744%2c187.27308 C 1575.4261%2c188.65197 1585.5196%2c193.57642 1600.7685%2c190.42467 C 1597.1169%2c193.77324 1592.3922%2c197.51604 1592.3922%2c197.51604 C 1592.3922%2c197.51604 1605.4932%2c202.04636 1620.3114%2c194.95515 C 1615.8021%2c200.07642 1613.2234%2c203.81922 1613.2234%2c203.81922 L 1623.5324%2c204.41009'/%3e%3c/g%3e%3c/svg%3e";

var img$u = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z'/%3e%3cpath fill='%23cc092f' d='M0 0h900v300H0z'/%3e%3cpath d='M390.858 205.797h36.644l11.112-34.537 11.41 34.537h36.64l-29.433 21.926 11.409 35.135-30.026-21.324-29.731 21.324 11.41-35.135z' fill='%23ffcb00' fill-rule='evenodd'/%3e%3cpath d='M524.801 394.706l-28.827-22.53c29.127-23.724 48.052-60.064 48.052-100.605 0-61.866-44.144-113.824-102.411-126.137l4.504-21.025c8.11 1.803 17.624 5.217 25.432 7.916l7.51-12.608c8.1 3.9 17.118 7.803 24.621 12.608l-5.703 13.518c7.51 4.808 16.575 12.251 21.616 18.112l11.277-8.809c6.008 6.604 13.218 13.507 18.323 20.721l-10.211 10.512c6.594 9.68 9.143 14.135 14.004 25.287l14.327-3.36c2.706 8.408 6.814 18.702 8.32 27.408l-13.566 5.332c1.62 6.766 3.718 18.584 3.583 28.525-.011.598-.056 1.276-.056 1.878l14.167 2.021c-.6 8.712-.897 18.625-2.704 27.333h-14.714c-2.1 9.005-4.81 20.02-8.11 28.425l12.308 7.213c-3.901 7.805-7.8 17.117-12.908 24.626l-13.514-5.703c-5.11 7.505-10.81 14.71-17.118 21.321l8.706 11.41c-2.398 2.1-4.502 4.205-6.908 6.61m-63.362-2.704l21.772 13.12c-2.03 1.857-8.112 5.006-9.724 5.644l3.56 13.666c-8.407 2.708-17.42 6.608-26.724 8.412l-5.405-13.513c-8.71 1.8-17.416 3-26.427 3l-1.807 14.114c-8.406-.598-18.617 0-27.928-2.102v-14.11c-8.411-1.506-16.519-3.606-24.324-6.312l-6.91 12.322c-7.207-3.01-16.816-6.615-24.628-11.416l5.108-13.514c-6.31-3.307-12.015-7.509-17.42-11.72l13.515-17.118c22.226 17.722 50.153 28.228 80.787 28.228 16.221 0 32.132-2.697 46.555-8.7' fill='%23ffcb00' fill-rule='evenodd'/%3e%3cpath d='M552.192 426.811L408.462 317.43l-1.31 1.866 143.36 109.573-8.509 10.647-139.753-89.64c-37.839-23.726-36.337-42.344-28.528-62.466l6.608-16.217c3.605 21.023 25.223 36.944 47.748 54.658l126.914 97.497zm36.084 32.6a2.23 2.23 0 01-2.23-2.238 2.23 2.23 0 012.23-2.232c1.237 0 2.24 1 2.24 2.232a2.238 2.238 0 01-2.24 2.239m-8.59-6.308a2.24 2.24 0 01-2.237-2.235 2.236 2.236 0 112.237 2.235m-8.79-7.006c-1.232 0-2.236-1-2.236-2.231a2.236 2.236 0 014.47 0c0 1.231-1 2.231-2.234 2.231m29.554 12.4l-43.065-33.365-12.514 16.127 37.41 26.235c3.005 2.1 3.3 11.718 14.407 13.222 4.513.596 7.508-2.71 7.508-2.71 4.84-5.892 3.521-14.003-3.746-19.51' fill='%23ffcb00' fill-rule='evenodd'/%3e%3c/svg%3e";

var img$t = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 18 12'%3e%3crect width='18' height='6' fill='%23FECB00'/%3e%3crect width='18' height='6' y='6' fill='%23EA2839'/%3e%3crect width='18' height='4' y='4' fill='%2334B233'/%3e%3cg transform='translate(9%2c6.422)scale(4.422)'%3e%3cpolygon id='pt' points='-0.3249196962329062%2c0 0%2c-1 0.3249196962329062%2c0' fill='white'/%3e%3cuse xlink:href='%23pt' transform='rotate(-144)'/%3e%3cuse xlink:href='%23pt' transform='rotate(-72)'/%3e%3cuse xlink:href='%23pt' transform='rotate(72)'/%3e%3cuse xlink:href='%23pt' transform='rotate(144)'/%3e%3c/g%3e%3c/svg%3e";

var img$s = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='white' d='M0 0h900v600H0z'/%3e%3cpath id='a' d='M463.1 506.741a1.01 1.01 0 01-.347-.245l-.125-.117a21.523 21.523 0 01-1.582-1.643c-1.332-1.513-3.119-3.728-4.69-5.685-3.115-3.883-5.689-7.228-6.174-7.858l-.793-1.032-7.767-2.395-5.671-2.644 3.03-3.406 10.408 4.456 7.767 1.594 14.363 10.564-.011.009c-.029.024-2.089 1.738-4.136 3.6-.913.83-2.064 1.9-2.877 2.783-.335.359-.646.74-.93 1.14a9.004 9.004 0 00-.465.88m-53.34-16.02a39.63 39.63 0 01-19.895-5.567h-.007v-.008a10.24 10.24 0 012.878-3.1c1.941-1.425 5.442-3.128 11.1-3.15h.117c6.7 0 14.9 2.278 24.373 6.771a36.022 36.022 0 01-18.566 5.054l.01.01-.01-.01zm-29.37-6.51a4.241 4.241 0 01-3.17-1.333A6.439 6.439 0 01375.8 480a14.656 14.656 0 01-.351-4.217 4.336 4.336 0 011.562-.354h.112c2.511 0 4.49 2.178 5.338 4.337a4.35 4.35 0 01.274 3.067 2.417 2.417 0 01-2.34 1.37l-.005.009zm51.68-5.99c-17.359-2.479-24.717-8.755-27.833-13.583a15.705 15.705 0 01-2.634-9.96v-.014h.013c.872-.2 1.764-.299 2.658-.293 4.618 0 16.43 2.323 27.8 23.842l.007.014-.02-.01.009.004zm-35.58-3.44c-7.416 0-13.062-1.28-16.782-3.8a10.304 10.304 0 01-3.686-4.125 6.75 6.75 0 01-.594-2.023 22.704 22.704 0 017.765-1.65c.383-.018.769-.029 1.174-.03 5.732 0 14.448 1.87 23.646 10.78l.009.009h-.011a90.034 90.034 0 01-11.53.84l.009-.001zm-35.91-1.38c-7.82 0-18.563-2.388-25.263-9.087l-.007-.008h.02a78.487 78.487 0 0115.523-2.062c.488-.012.98-.018 1.475-.019 7.332 0 12.944 1.422 16.682 4.225a4.942 4.942 0 012.178 2.783 2.28 2.28 0 01-1.056 2.15c-1.683 1.271-4.692 1.949-8.945 2.017l-.6.02-.007-.019zm-25.34-13a3.206 3.206 0 01-2.479-1.167 5.87 5.87 0 01-1.108-2.522 14.298 14.298 0 01-.291-3.674v-.018c.382-.176.797-.27 1.217-.275a3.784 3.784 0 012.589 1.158 6.956 6.956 0 011.688 2.645 4.03 4.03 0 01.18 2.635 1.915 1.915 0 01-1.8 1.21l.004.008zm58.53-1.32a4.241 4.241 0 01-3.17-1.333 6.45 6.45 0 01-1.422-2.878 14.656 14.656 0 01-.351-4.217 4.336 4.336 0 011.562-.354h.112c2.511 0 4.49 2.178 5.338 4.337a4.35 4.35 0 01.274 3.067 2.413 2.413 0 01-2.34 1.37l-.003.008zm-28.51-1.18c-15.737-.554-23.9-5.027-27.984-8.683a18.3 18.3 0 01-4.24-5.447 11.649 11.649 0 01-.908-2.438l.021-.009a13.461 13.461 0 013.885-.579h.368c5.307 0 16.111 2.229 28.852 17.153v.01l.006-.007zm17.09-1.59c-12.661-1.928-19.834-7.363-23.622-11.585a24.177 24.177 0 01-5.213-8.738 18.622 18.622 0 013.9-.469c.169 0 .345-.007.524-.007s.365 0 .553.007c6.368.139 17.934 3.023 23.855 20.785h.01l-.007.007zm-65-6.08a49.336 49.336 0 01-11.96-1.432c-6.629-1.658-9.473-4.189-10.691-6.021a6.318 6.318 0 01-1.031-2.534 4.282 4.282 0 01-.031-1.073l.031-.011a45.238 45.238 0 0110.464-1.328c.239 0 .48-.006.725-.006a43.806 43.806 0 018.564.83 27.146 27.146 0 0116.053 10.14v.009h-.013a49.635 49.635 0 01-12.12 1.42l.009.006zm29.39-10.68a4.244 4.244 0 01-3.172-1.3 6.49 6.49 0 01-1.42-2.908 14.4 14.4 0 01-.351-4.185 4.336 4.336 0 011.562-.354h.112c2.506 0 4.488 2.179 5.339 4.338a4.25 4.25 0 01.243 3.034 2.356 2.356 0 01-2.31 1.38l-.003-.005zm-22.1-3.03a48.225 48.225 0 01-11.967-5.225c-5.544-3.413-12.326-9.45-13.153-18.83h.014a7.14 7.14 0 011.278-.154c.1 0 .217-.006.334-.006 1.656 0 5.046.466 9.147 3.584 5.22 3.98 10.04 10.92 14.35 20.65l-.003-.019zm14.43-.53a39.027 39.027 0 01-9.469-6.084 60.759 60.759 0 01-16.716-23.33 7.698 7.698 0 013.655-.718c2.411.068 6.083 1.07 10.154 5.463 4.676 5.047 8.85 13.34 12.4 24.651l.01.032-.03-.01-.004-.004zm-37.39-1.09c-4.821 0-6.471-2.615-6.957-3.74a7.783 7.783 0 01-.554-3.707v-.02a10.615 10.615 0 012.4-.314h.165a9.918 9.918 0 018.084 3.841c.255.379 1.037 1.694.39 2.721-.52.81-1.7 1.22-3.53 1.22l.002-.001zM291 421.431a63.914 63.914 0 01-11.141-.952c-4.294-.781-6.728-4.432-8.013-7.356a25.55 25.55 0 01-1.8-6.254h.012c13.282.39 19.555 4.271 22.478 7.457a11.713 11.713 0 013.206 6.922h-.009c-.02 0-1.89.18-4.74.18l.007.003zm13.83-13.82a53.867 53.867 0 01-3.033-4.228c-1.573-2.445-3.028-5-3.028-7.084 0-2.016-.474-6.266-.757-8.619-.358-2.985-.72-5.54-.75-5.757h.013c.337.123 8.308 3.114 8.308 10.591s-.738 15.014-.745 15.089v.011h-.01l.002-.003zm-10.33-.71c-.084 0-.167-.008-.25-.021-2.356-.393-6.5-2.194-11.073-4.818-5.082-2.914-9.209-6.036-11.62-8.791-2.2-2.512-3.5-6.457-3.88-11.726a43.595 43.595 0 01.087-7.163 4.135 4.135 0 011.315-.2c1.764.029 3.647.823 6.189 2.574a49.763 49.763 0 016.49 5.514 99.384 99.384 0 017.2 7.971l.032.04c.265.475 2.537 4.571 4.307 8.558a27.554 27.554 0 012.024 5.746c.174.581.174 1.2 0 1.781a.902.902 0 01-.385.448c-.139.06-.289.091-.44.09l.004-.003z' fill='%234e5b31'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 900 0)'/%3e%3cpath d='M727.132 103.967l-2.355.938-.923.368-2.854-.157-2.673 1.283-4.74 3.239-.209.15-1.767.461-1.641-.708-.932.424-.321 1.92-.887 1.379-1.092.767-3.783.387-3.19 1.645-4.15-1.111-1.928.755-4.1 3.692-2.095.992-.732-.042-2.778-.143-1.173.384-1.752 1.693-3.315.258-1.033.715-1.618 3.26-1.753 1.808-1 .212-1.087-.4-.817.144-.37 2.086-.793.874-2.219.764-1.773 1.477-1.556.8-2.084-.052h-.479l-2.076 1.146-3.9.342-1.624 1.549-.358.331-.758.458-1.24.74-.3.184-1.5-.267-1.75.693-.708-1.089-1.211.727-1.6.069-2-.889-1.522-.678-1.113.161-.387 1.94-.039.206-1.17 1.557-2.184 1.323-.3.387-2.485 3.208-4.722 4.966-3.993 2.028-4.139 1.259-2.9 2.38-7.6 3.767-11.995 5.973-2.453.786-3.52.562-6.278 2.312-5.539 1.671-.308.094-1.1.332-7.81 2.363-3.635-.384-2.153.782-5.605-.622-3.9.077-2.467.513-4.637 2.224-7.827 3.762-2.586 2.366-4.027 2.1-4.715 1.493.011-1.981-.028-.084-1.636.517-1.181.373-3.825.59h-2.128l-1.321-.384-.2.069-7.818 2.569-8.719.842-4.363 1.4-3.26-.052-2.038.606-4 .489-1.428-.381-.322-.088-11.75.51-5.372-.607-2.564.583-4.3-1.446-6.269-.727-1.465-.439-3.3-.978-1.491.859-1.116.119-2.667-.967-.96-.024-2.2.8-1.267-.325-1.177-.938-2.761-.411-1.682-1.414-9.4 1.246-2.551-.75-8.554-2.492-1.361.069-1.7 1.271-2.548.929-2.212.575-3.012.1-3.5-.918-3.606-1.748-1.333-.317-2.974.3-.91.082-5.466-2.932-7.042-4.4-4.778-2.3-1.794-.291-.241.853.89 2.8.3 2.774-.091 2.563-.049 1.587.446 1.425 1.725 1.912.719 1.92.526 5.284-.006 5.362-.839 8.551-.283 1.3-1 4.43-.914 4.069-3.546 10.833-.974 1.343-2.391 1.631-5.419 3.688-3.99 2.3-1.263.523-3.239.245-2.018-.1-2.513-1.361-2.467-.635-3.232-2.324-3.6-.744-3.941-2.278-1.026-1.233-2.146-.2-2.976-.893v-.005l-1.093-.327-.755-.22-3.8-.1-3.54-1.634-1.864-.45-2.547-.129-2.666 1.239-1.351.629-1.707-.678-1.235.077-1.4 2.115-.172.323-.964.51-1.2-.017-.939-.025-1.016.444-1.368.593-1.208.527-.59.255-.01-.01-.363.073-.645.112-.8.153-1.41-.824-.75-.442-1.257-.256-.677.489-.133 2.3-.618 1.378-1.961 1.734-1.993 1.755-1.389 2.047-3.676 8.39-2.3 3.385-.715.789-2.418 2.66-2.136 1.657-4.922 3.815-4.659 1.741-4.013.82-1.951.008-3.7-.492-3.323-1.02-3.65-2.282-4-3.217-5.794-5.724-.82-.493-.171-.114-1.825-1.167-1.354.035-.53.874-.29 1.263-.245 1.12-.664 6.367.049.369.349 2.622 4.4 6.15 1.358 3.267.223.373.908 1.525.691 1.163.069.118 1.5 4.488-1.057 2.534.534 1.7-1.336 1.037-.245 1.465 3.951 4.953.862 2.185-.963 3.029-1.536 1.671-.429.457.216 1.28 1.818 1.635 3.089 2.75 1.647 4.086 1.253 1.1 1.456-.31.81.618 1.228-.021 1.208 1.208.782.379 1.236.616.977 1.272.216 3.911 1.822 4.86.028 2.635.01.374 1.134 1.948.356 1.538-.6 4.069 1.445 1.306 1.567-.32 1.012.16 1.626 1.354 1.969 3 1.926-.282 1.222.589 5.9 5.334 1.339.676.074.042.963.483 1.2 1.208 1.856-1.232.206-.021 2.018-.178.886.6 1.7 1.149 2.234-.029 4.844 1.485 2.119.543 4.261 2.648 1.811 1.12 1.072.871 1.424 1.161 2.845 1.224 2.44.584 1.322.314 1 .384.025-.062h.014l-.024.063 5.284 2.023 2.862.668 2.648.975 1.927.7 1.414.023 2-1.682 1.937-.112 1.609.4 1.57-.263 2.485-1.531.485-.719 1.762-.839 5.944-.738 1.737.564 4.46-1.94 2.988.831 2.645-.938 5.779 1.284 1.536 1.081 1.717 1.965.21.009 1.912.037-.8 1.331 2.523 2.647 2.279 3.445.154.455 1.657 4.864 1.232 1.723.862 2.405.042 1.568-1.34 1.022-.22.583-.076.216.272.655.506-.276.963-.533 1.172-.182 2.066.22 1.364.143 2.154-1.069 1.427-.71 2.293.987 2.52-.028 1.058.471 3 1.358 1.529.144.565-.371.36-.856-.185-1L397 377.23l-2.531-2.938-1.036-1.51-.789-2.186-.244-2.796-.174-1.885.314-2.477.68-.884.5-1.968h.009l.129-.515 1.406-1.866 3.724-2.393 4-3.582 3.162-2.085 3.26-1.412.087-.4.363.146 8.292-2.819.137-.016 3.692-.643 24.92 1.755.924-.279v-.006l.83-2.33.447-.432.3-.282 2.74-1.206 1.281-.183 3.556.878 1.456.359 2.332-1.307 1.654.028 3.417-1.866 2.111.053.8-.321 4.112-2.955 3.961-1.135 1.03-.548.363-.2 4.06-2.144 2.579-1.981 2.226-1.183 2.438-.629 6.38-.449 1.283-2.138 2.744-.366 1.657-1.87 1.9-.771 1.359-1.958 1.139-1.641 1.591-.921 5.1-.32 6.045.749.8-.485 1.366-4.875 1.43-.915 3.851-5.612.013-2.045v-1.708l.633-2.432-.43-4.391.51-4.446 2.394-5.65 2.109-2.279 3.4-2.3 1.729-.753 2.449-.412v.001l.36-.061.624-.107 8.433-.116c.117-.087 3.067-.042 3.067-.042l2.812-.038 7.116 1.264.506.088 2.4.779 2.774 2.157 2.938 2.869.551.535 1.9.8.575.251 1.571-.251 2.237-1.165 1.688-1.427 2.3-1.257.056-.08 1.295-1.948.039-.04.028.007v-.011h-.022l.511-.775 4.447-1.733 5.23-.3.588-.318.327-.175 1.382-1.623 1.295-.01 3.135 1.134 2.2-.438 1.75.7 1.36-.161 2.565-.3 2.754 1.937 1.605.2 5.658 3.31.294.048.152.028.324.054.671-.2 1-.289.132-.039.126.175.643.907.882.126 1.044-1.393-.415-.632-.157-.23-2.021-.411-1.815-3.1 1.728-1.861-2.711-3.326-.45-.551-.153-.234-.937-1.423-4.746-7.235-6.182-4.935-2.165-1.732-.014-.01-.758-.6-3.3-3.358-2.358-3.13-.309-.674-.487-1.062-1.413-3.078-2.462-1.9-2.006-2.191-.1-.129-4.14-5.626-.68-.943-.978-.565-2.066-.014-.2-.2-.116-.121.07-.074.991-.985 1.105-.278.476-1.089-2.108-6.1-.014-.213-.157-1.95 1.718-8.855.22-1.079 2.928-5.958 1.814-1.486 1.98-3.892 1.7-2.488 1.625-1.582.284-.168 2.934-1.776 2.465-.347 2.348-.331 4.1 1.264 3.9-.076.761-.081 1.77-.2 2.911-.917 1.374-.848.713-1.093 1.487-4.987.478-1.587.917-1.724 5.306-6.108 4.011-3.71 9.019-6.613 4.415-2.639 2.254-1.347 20.126-8.946 5.23-5.3 2.725-2.758 4.821-3.235 5.641-2.311 4.854-3.842 1.06-1.334 1.336-4.3 1.113-.269 1-2.174.286-.618 3.961-2.792.448-.223 15.388-7.71 2.236.307 1.2-1.793 4.477-.751.824-.14 1.1-.551.939-1.6v-.316l.129-4.273.956-1.155.521-2.816.491-.65.513-.676 1.268-.891-.22-.531.032.031z' fill='%23d57800'/%3e%3c/svg%3e";

var img$r = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3crect width='900' height='600' fill='%23cf142b'/%3e%3crect width='450' height='600' fill='white'/%3e%3cg%3e%3cpath fill='%23e60d2e' d='m22.222%2c82.828%2c0%2c45.457%2c45.455%2c0c0%2c7.5741%2c7.5762%2c15.151%2c15.152%2c15.151v45.454h45.452v-45.454c7.5762%2c0%2c15.152-7.5766%2c15.152-15.151h45.455v-45.457h-45.455c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-45.452v45.454c-7.5762%2c0-15.152%2c7.5766-15.152%2c15.151h-45.455z'/%3e%3cpath fill='%2396877d' d='m25.254%2c85.857%2c0%2c39.397%2c45.452%2c0c0%2c7.5738%2c7.5762%2c15.15%2c15.152%2c15.15v45.454h39.392v-45.454c7.5762%2c0%2c15.152-7.5766%2c15.152-15.15h45.452v-39.397h-45.452c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-39.392v45.454c-7.5762%2c0-15.152%2c7.5766-15.152%2c15.151h-45.452z'/%3e%3cpath fill='%23ccc' d='m26.77%2c87.373%2c0%2c36.364%2c45.452%2c0c0%2c7.5741%2c7.5762%2c15.153%2c15.152%2c15.153v45.454h36.362v-45.454c7.5762%2c0%2c15.152-7.5791%2c15.152-15.153h45.452v-36.364h-45.452c0-7.5738-7.5762-15.15-15.152-15.15v-45.454h-36.362v45.454c-7.5762%2c0-15.152%2c7.5766-15.152%2c15.15h-45.452z'/%3e%3cg id='vi' fill='%23d0d0d0'%3e%3cpath fill='%2396877d' d='m84.536%2c71.681c2.6626%2c2.6628%2c1.9431%2c7.6994-1.6071%2c11.25-3.5502%2c3.5503-8.5867%2c4.2698-11.249%2c1.6072-2.6626-2.6626-1.9431-7.6994%2c1.6071-11.25%2c3.5502-3.5501%2c8.5867-4.2698%2c11.249-1.6072z'/%3e%3cpath d='m71.143%2c79.715%2c1.0712-1.0722%2c4.2856%2c2.1422-2.143-4.2853%2c1.0714-1.0722%2c4.2855%2c8.5711-8.5708-4.2856z'/%3e%3cpath d='m77.572%2c73.287%2c1.0714-1.0714%2c6.4282%2c6.4283-1.0714%2c1.0714z'/%3e%3c/g%3e%3cuse xlink:href='%23vi' transform='rotate(90%2c105.555%2c105.557)'/%3e%3cuse xlink:href='%23vi' transform='rotate(180%2c105.555%2c105.557)'/%3e%3cuse xlink:href='%23vi' transform='rotate(270%2c105.555%2c105.557)'/%3e%3cg fill='none' stroke='%2396877d' stroke-width='0.514'%3e%3ccircle cx='105.555' cy='105.557' r='31.822'/%3e%3ccircle cx='105.555' cy='105.557' r='24.245'/%3e%3c/g%3e%3cg fill='black'%3e%3ccircle cx='93.434' cy='131.31' r='1.515'/%3e%3ccircle cx='117.675' cy='131.31' r='1.515'/%3e%3cpath d='m104.55%2c131.31%2c0%2c1.5798-2.0203%2c0c-2.0203%2c0-2.0203%2c1.5798%2c0%2c1.5798h2.0203v1.5798c0.007%2c1.637%2c1.7632%2c1.8358%2c1.8917%2c0.13718l0.12826-1.7078h2.0203c2.02%2c0%2c2.02-1.5798%2c0-1.5798h-2.0203v-1.5798c0-1.5798-2.02-1.5798-2.02%2c0z'/%3e%3cpath d='m75.954%2c113.4%2c2.0836-0.49669-0.23018-0.96558c-0.05274-0.22154-0.14029-0.37212-0.26261-0.45176-0.12227-0.0796-0.33208-0.10192-0.62945-0.0669l-0.03456-0.14462%2c1.7943-0.42772%2c0.03456%2c0.14462c-0.20528%2c0.0516-0.35004%2c0.11445-0.43437%2c0.18823-0.08431%2c0.0738-0.13986%2c0.16141-0.16664%2c0.26283-0.02678%2c0.10141-0.01904%2c0.24072%2c0.02319%2c0.41794l0.23018%2c0.96558%2c1.6653-0.39698c0.26844-0.064%2c0.44162-0.12317%2c0.51955-0.17754%2c0.05893-0.0416%2c0.10192-0.10968%2c0.12895-0.20426%2c0.03521-0.12958%2c0.0379-0.25691%2c0.0081-0.38202l-0.04572-0.19152%2c0.14462-0.0346%2c0.54235%2c2.2752-0.14462%2c0.0346-0.04465-0.18767c-0.05228-0.21889-0.15392-0.36268-0.30524-0.43127-0.0983-0.0427-0.30644-0.0261-0.62439%2c0.0497l-3.4245%2c0.81632c-0.26844%2c0.064-0.44161%2c0.12317-0.51955%2c0.17753-0.05893%2c0.0416-0.10222%2c0.10838-0.1299%2c0.20035-0.03582%2c0.12697-0.03853%2c0.25431-0.0081%2c0.38201l0.04465%2c0.18768-0.14462%2c0.0346-0.94026-3.9444%2c1.1528-0.32851%2c0.03261%2c0.13683c-0.23143%2c0.12678-0.39442%2c0.24896-0.48896%2c0.3665-0.09453%2c0.11756-0.15218%2c0.24837-0.17294%2c0.39239-0.02075%2c0.14403%2c0.0018%2c0.35418%2c0.06766%2c0.63043l0.27863%2c1.1689zm-1.3422-9.402c0.03979-0.70618%2c0.34243-1.303%2c0.90792-1.7904%2c0.56549-0.48738%2c1.2495-0.70846%2c2.052-0.66326%2c0.82656%2c0.0466%2c1.498%2c0.34604%2c2.0143%2c0.89839%2c0.5163%2c0.55236%2c0.75358%2c1.199%2c0.71183%2c1.94-0.0422%2c0.74898-0.34381%2c1.3633-0.90484%2c1.8428-0.56102%2c0.47958-1.2642%2c0.69556-2.1095%2c0.64794-0.864-0.0487-1.5523-0.38264-2.0648-1.0019-0.44467-0.53759-0.64696-1.1622-0.6069-1.8737zm0.28861%2c0.0927c-0.02742%2c0.48684%2c0.13113%2c0.88756%2c0.47566%2c1.2021%2c0.42874%2c0.39179%2c1.0765%2c0.6121%2c1.9431%2c0.66093%2c0.88808%2c0.05%2c1.5822-0.10137%2c2.0824-0.45424%2c0.38022-0.27106%2c0.58382-0.64601%2c0.6108-1.1248%2c0.02878-0.51091-0.14672-0.94411-0.52652-1.2996-0.3798-0.35548-0.99903-0.55741-1.8577-0.6058-0.93088-0.0524-1.6353%2c0.0917-2.1134%2c0.43237-0.38036%2c0.27376-0.58517%2c0.67009-0.61441%2c1.189zm7.894-9.9511-0.5176%2c1.3596-3.0375%2c0.8174c-0.04359%2c0.12962-0.08066%2c0.23448-0.11117%2c0.3146-0.0124%2c0.03256-0.02636%2c0.06738-0.04191%2c0.10444-0.01555%2c0.03709-0.03221%2c0.07518-0.04997%2c0.11428l1.4798%2c0.56335c0.3205%2c0.12201%2c0.5329%2c0.16274%2c0.63721%2c0.12218%2c0.14641-0.05317%2c0.25581-0.17496%2c0.32826-0.36525l0.07577-0.19905%2c0.13896%2c0.0529-0.83073%2c2.1821-0.13896-0.0529%2c0.07293-0.19155c0.08198-0.21532%2c0.07048-0.39601-0.03445-0.54204-0.05761-0.08213-0.23164-0.17848-0.52208-0.28906l-3.2901-1.2525c-0.32049-0.12201-0.5329-0.16274-0.63721-0.12218-0.14736%2c0.05566-0.25771%2c0.17998-0.33112%2c0.37276l-0.07293%2c0.19155-0.13896-0.0529%2c0.70634-1.8554c0.2059-0.54083%2c0.39713-0.92456%2c0.57371-1.1512%2c0.17658-0.22662%2c0.40474-0.38916%2c0.68447-0.48765s0.56608-0.09195%2c0.85903%2c0.01957c0.31299%2c0.11916%2c0.54581%2c0.32462%2c0.69848%2c0.61637%2c0.15267%2c0.29177%2c0.19508%2c0.66984%2c0.12722%2c1.1342l1.8614-0.49542c0.42703-0.11264%2c0.72853-0.23431%2c0.90446-0.36521%2c0.17594-0.13082%2c0.33184-0.32948%2c0.46769-0.59598l0.13896%2c0.0529zm-3.9947%2c2.6203c0.01811-0.04758%2c0.03447-0.08865%2c0.04906-0.12322%2c0.01461-0.03458%2c0.02618-0.06313%2c0.03477-0.08567%2c0.18493-0.48575%2c0.21917-0.89198%2c0.10274-1.2187-0.1164-0.32671-0.3374-0.55201-0.66291-0.67593-0.31799-0.12105-0.6144-0.11994-0.88925%2c0.0033-0.27484%2c0.12328-0.47469%2c0.34893-0.59956%2c0.67693-0.05529%2c0.14523-0.10632%2c0.35084-0.15312%2c0.61683l2.1183%2c0.80642zm11.596-18.053%2c1.0531%2c1.3672-0.11806%2c0.07646c-0.35222-0.2826-0.68176-0.4538-0.98862-0.51362-0.4425-0.08686-0.87738%2c0.0081-1.3046%2c0.28477-0.58242%2c0.37723-0.87613%2c0.89464-0.88114%2c1.5522-0.0021%2c0.55362%2c0.17083%2c1.0991%2c0.51894%2c1.6366%2c0.28254%2c0.43626%2c0.62467%2c0.77966%2c1.0264%2c1.0302%2c0.40168%2c0.25056%2c0.79339%2c0.37113%2c1.1751%2c0.3617%2c0.38172-0.0094%2c0.71651-0.10735%2c1.0043-0.29378%2c0.16864-0.10923%2c0.31785-0.23619%2c0.44759-0.38087%2c0.12973-0.14467%2c0.24074-0.30595%2c0.33302-0.48382l-0.85639-1.3223c-0.14856-0.22936-0.26321-0.36818-0.34394-0.41644-0.08075-0.04825-0.16966-0.06726-0.26677-0.05704-0.09711%2c0.01023-0.23785%2c0.07513-0.42227%2c0.19448l-0.08302-0.12817%2c1.7709-1.147%2c0.08302%2c0.12817-0.08432%2c0.05462c-0.1754%2c0.1136-0.25784%2c0.25-0.24732%2c0.40916%2c0.0089%2c0.11233%2c0.09274%2c0.29106%2c0.2515%2c0.53617l0.90664%2c1.3998c-0.16831%2c0.30692-0.35727%2c0.57454-0.56689%2c0.80287-0.20962%2c0.22834-0.46847%2c0.44227-0.77654%2c0.6418-0.88375%2c0.57238-1.7385%2c0.7238-2.5643%2c0.45423-0.61932-0.20217-1.1089-0.58098-1.4686-1.1364-0.26069-0.40252-0.41379-0.8508-0.45924-1.3449-0.05463-0.58706%2c0.04172-1.1283%2c0.28906-1.6236%2c0.20835-0.41264%2c0.54077-0.7668%2c0.99726-1.0625%2c0.1664-0.10776%2c0.32637-0.19222%2c0.4799-0.25335%2c0.15351-0.0612%2c0.38497-0.12637%2c0.69427-0.1959%2c0.15647-0.03441%2c0.25611-0.0654%2c0.29888-0.09297%2c0.04269-0.02776%2c0.06653-0.071%2c0.07138-0.13003%2c0.0049-0.059-0.02647-0.14805-0.09404-0.26709l0.1248-0.08083zm8.8735%2c0.61442-2.039%2c0.5422-0.1363%2c0.92615c-0.03364%2c0.22797-0.03703%2c0.39242-0.01019%2c0.4934%2c0.02126%2c0.08029%2c0.07829%2c0.14067%2c0.17086%2c0.1812s0.26812%2c0.03612%2c0.52668-0.01322l0.03817%2c0.14372-1.6584%2c0.44098-0.03817-0.14372c0.20976-0.09736%2c0.33873-0.18572%2c0.38694-0.26507%2c0.099-0.1594%2c0.17816-0.45074%2c0.23748-0.87404l0.70002-4.827%2c0.13591-0.0362%2c2.9981%2c3.8935c0.24122%2c0.31289%2c0.43597%2c0.50576%2c0.58426%2c0.5786%2c0.14827%2c0.07285%2c0.33159%2c0.08718%2c0.54994%2c0.04297l0.0382%2c0.14372-2.0778%2c0.55252-0.03817-0.14372c0.20698-0.06609%2c0.33943-0.13878%2c0.39738-0.21796%2c0.058-0.07918%2c0.0756-0.16149%2c0.0529-0.24693-0.0303-0.11391-0.12993-0.2801-0.2989-0.49854l-0.51986-0.67266zm-0.18516-0.25849-1.4592-1.8908-0.35063%2c2.3721%2c1.8099-0.48127zm9.6209-0.02828%2c0.13143%2c0.03327-0.52332%2c1.4597-4.2165-0.16404%2c0.006-0.14858%2c0.20481%2c0.008c0.23023%2c0.009%2c0.39779-0.0596%2c0.50268-0.20567%2c0.0596-0.08349%2c0.0954-0.28049%2c0.10745-0.59105l0.1367-3.5138c0.0132-0.34-0.016-0.55428-0.0876-0.64287-0.0998-0.12186-0.25281-0.18679-0.45895-0.19481l-0.20481-0.008%2c0.006-0.14858%2c2.4657%2c0.09592-0.006%2c0.14858c-0.28903-0.01392-0.49287%2c0.005-0.61151%2c0.05664-0.11865%2c0.05169-0.20105%2c0.11954-0.24721%2c0.20354-0.0462%2c0.08402-0.0756%2c0.28798-0.0882%2c0.61191l-0.1331%2c3.4214c-0.009%2c0.2222%2c0.007%2c0.37563%2c0.0465%2c0.46029%2c0.0299%2c0.05749%2c0.0778%2c0.10089%2c0.14374%2c0.13026%2c0.0659%2c0.02938%2c0.27418%2c0.05088%2c0.62489%2c0.06453l0.39756%2c0.01547c0.41764%2c0.01626%2c0.71198-0.0031%2c0.88304-0.05815%2c0.17109-0.05493%2c0.32924-0.15811%2c0.47454-0.30932%2c0.1453-0.15119%2c0.29412-0.39275%2c0.44646-0.72466zm7.2573%2c1.942%2c0.11707%2c0.06835-0.90692%2c1.2578-4.0064-1.3248%2c0.0467-0.14118%2c0.1946%2c0.06436c0.21875%2c0.07234%2c0.39874%2c0.05284%2c0.53997-0.05847%2c0.0803-0.06374%2c0.16929-0.24314%2c0.26686-0.53821l1.104-3.3386c0.10682-0.32305%2c0.13808-0.53705%2c0.0938-0.642-0.0622-0.14473-0.19123-0.24947-0.38709-0.31424l-0.1946-0.06436%2c0.0467-0.14118%2c2.3428%2c0.7747-0.0467%2c0.14118c-0.27388-0.09339-0.47498-0.13166-0.60329-0.11484-0.12831%2c0.01684-0.22625%2c0.05931-0.2939%2c0.12715-0.0676%2c0.06794-0.15231%2c0.25582-0.25409%2c0.56359l-1.075%2c3.2509c-0.0698%2c0.21112-0.0974%2c0.36285-0.0828%2c0.45516%2c0.0128%2c0.06352%2c0.0469%2c0.11852%2c0.10206%2c0.16497%2c0.0552%2c0.04647%2c0.24939%2c0.12479%2c0.58261%2c0.23499l0.37774%2c0.12491c0.39682%2c0.13122%2c0.68503%2c0.19407%2c0.86463%2c0.18856%2c0.17959-0.0055%2c0.36014-0.06081%2c0.54163-0.16584%2c0.18148-0.10507%2c0.39135-0.29599%2c0.62961-0.57275zm5.8487%2c3.0973-1.7221-1.2189-0.79864%2c0.48837c-0.19664%2c0.12013-0.32513%2c0.22285-0.38549%2c0.30813-0.048%2c0.06779-0.0579%2c0.15021-0.0298%2c0.24726%2c0.0282%2c0.09704%2c0.14395%2c0.22907%2c0.34742%2c0.39607l-0.0859%2c0.12138-1.4007-0.99138%2c0.0859-0.12137c0.2091%2c0.09875%2c0.35956%2c0.14125%2c0.45138%2c0.12746%2c0.18582-0.02604%2c0.46028-0.15182%2c0.82341-0.37729l4.1557-2.5533%2c0.11481%2c0.08126-1.0706%2c4.796c-0.0858%2c0.38563-0.10928%2c0.65872-0.0703%2c0.81927%2c0.039%2c0.16053%2c0.14539%2c0.31051%2c0.31915%2c0.44992l-0.0859%2c0.12138-1.7549-1.2421%2c0.0859-0.12138c0.18331%2c0.11663%2c0.32394%2c0.17185%2c0.42187%2c0.16566%2c0.0979-0.0062%2c0.17241-0.04539%2c0.22351-0.11752%2c0.0681-0.09623%2c0.13193-0.27916%2c0.19151-0.54882l0.18376-0.83003zm0.08-0.30775%2c0.51785-2.3316-2.0464%2c1.2496%2c1.5286%2c1.0819zm6.4627%2c1.191%2c0.88066%2c1.1881-1.2996%2c5.1103%2c2.5247-1.8714c0.26904-0.19942%2c0.41459-0.35399%2c0.43665-0.46372%2c0.0314-0.14663-0.0168-0.30606-0.14439-0.47825l-0.11246-0.15174%2c0.11946-0.08854%2c1.1295%2c1.5239-0.11946%2c0.08854-0.11487-0.15497c-0.13721-0.18511-0.29049-0.27492-0.45985-0.26945-0.10398%2c0.0037-0.27868%2c0.0964-0.52401%2c0.27837l-3.6903%2c2.7353-0.0862-0.11622%2c1.3862-5.4996-2.6959%2c1.9982c-0.26905%2c0.19942-0.41539%2c0.35292-0.43904%2c0.4605-0.0298%2c0.14879%2c0.0183%2c0.30822%2c0.14439%2c0.47825l0.11487%2c0.15497-0.11946%2c0.08854-1.1295-1.5239%2c0.11946-0.08854%2c0.11247%2c0.15174c0.13879%2c0.18726%2c0.29287%2c0.27815%2c0.46223%2c0.27267%2c0.10397-0.0037%2c0.27868-0.0964%2c0.52402-0.27835l3.0445-2.2567c0.0544-0.23707%2c0.0809-0.40598%2c0.0796-0.50673-0.001-0.10075-0.0286-0.22977-0.0818-0.38707-0.0269-0.07677-0.0874-0.17867-0.18154-0.30565l0.11946-0.08854zm6.871%2c12.662-1.1847%2c0.48309-0.0508-0.144c0.20233-0.10285%2c0.34047-0.19436%2c0.41442-0.27451%2c0.11879-0.13013%2c0.1899-0.27253%2c0.21334-0.42717%2c0.0234-0.15465-0.002-0.33806-0.0774-0.55022l-0.2561-0.72361-3.925%2c1.3887c-0.31574%2c0.11164-0.50066%2c0.2155-0.55483%2c0.3114-0.0721%2c0.13351-0.0729%2c0.30003-0.002%2c0.49957l0.0629%2c0.17808-0.14018%2c0.04957-0.77076-2.1785%2c0.14019-0.04957%2c0.0644%2c0.18184c0.0769%2c0.2172%2c0.19703%2c0.34805%2c0.36054%2c0.39251%2c0.10048%2c0.02697%2c0.2947-0.01047%2c0.58263-0.11236l3.925-1.3887-0.2184-0.61758c-0.0849-0.23993-0.16291-0.40418-0.23401-0.4927-0.0944-0.11436-0.22643-0.19414-0.39587-0.23933-0.16946-0.0452-0.3735-0.03554-0.61212%2c0.029l-0.0508-0.144%2c1.2262-0.36564%2c1.4839%2c4.194zm-4.3136%2c9.6659-0.0755-1.4528%2c2.4487-1.9744c-0.0125-0.13618-0.0209-0.24707-0.0254-0.33268-0.002-0.0348-0.003-0.0722-0.004-0.11247-0.00067-0.0402-0.00091-0.0818-0.00045-0.12474l-1.5813%2c0.0822c-0.34247%2c0.0178-0.55323%2c0.0663-0.63228%2c0.14555-0.11245%2c0.10779-0.16337%2c0.26336-0.1528%2c0.46671l0.0111%2c0.21271-0.14849%2c0.008-0.12122-2.3318%2c0.14849-0.008%2c0.0106%2c0.20469c0.012%2c0.2301%2c0.0954%2c0.39075%2c0.25042%2c0.48195%2c0.0859%2c0.0519%2c0.28397%2c0.0697%2c0.59434%2c0.0536l3.5157-0.18276c0.34247-0.0178%2c0.55323-0.0663%2c0.63229-0.14554%2c0.11228-0.11047%2c0.16309-0.26871%2c0.15238-0.47473l-0.0106-0.20467%2c0.14849-0.008%2c0.10307%2c1.9826c0.03%2c0.57792%2c0.01%2c1.0062-0.06%2c1.2848-0.07%2c0.27863-0.21311%2c0.51947-0.42924%2c0.72253-0.21615%2c0.20305-0.48074%2c0.31272-0.79378%2c0.32899-0.33444%2c0.0174-0.63041-0.0765-0.8879-0.28181-0.25749-0.20526-0.44896-0.53401-0.57442-0.98625l-1.5028%2c1.2049c-0.34518%2c0.27549-0.57183%2c0.50861-0.67995%2c0.69934s-0.17053%2c0.43543-0.1872%2c0.73409l-0.14849%2c0.008zm2.5964-4.0103c0.003%2c0.0508%2c0.004%2c0.095%2c0.005%2c0.13254%2c0.00064%2c0.0375%2c0.002%2c0.0683%2c0.003%2c0.0924%2c0.027%2c0.51906%2c0.1597%2c0.90452%2c0.39806%2c1.1564%2c0.23845%2c0.25186%2c0.53158%2c0.36875%2c0.87941%2c0.35067%2c0.33979-0.0177%2c0.61052-0.13838%2c0.81217-0.36215%2c0.20164-0.22378%2c0.29336-0.5109%2c0.27514-0.8614-0.008-0.15519-0.0444-0.3639-0.10902-0.62613l-2.2635%2c0.11767zm1.4941%2c11.21-0.48239%2c1.8386-0.14382-0.0377%2c0.0265-0.10106c0.0177-0.0674%2c0.0137-0.17368-0.0119-0.31889s-0.0803-0.28555-0.16376-0.42104c-0.0836-0.1355-0.23063-0.31396-0.4412-0.53539l-1.6684-1.7964-1.3216-0.34676c-0.32394-0.085-0.53559-0.10174-0.63496-0.0503-0.13468%2c0.0699-0.2299%2c0.21113-0.28565%2c0.42363l-0.0449%2c0.17104-0.14382-0.0377%2c0.58744-2.239%2c0.14382%2c0.0377-0.049%2c0.1866c-0.0585%2c0.22285-0.0326%2c0.39862%2c0.0777%2c0.52727%2c0.068%2c0.0788%2c0.24967%2c0.15691%2c0.54509%2c0.23442l1.2478%2c0.32737%2c2.5873-0.86676c0.30401-0.10305%2c0.49641-0.17651%2c0.57717-0.22043%2c0.0807-0.044%2c0.19165-0.14983%2c0.33267-0.31782%2c0.0395-0.045%2c0.0722-0.11677%2c0.098-0.21525l0.14383%2c0.0378-0.59152%2c2.2546-0.14382-0.0377%2c0.0306-0.11662c0.0319-0.12181%2c0.0328-0.24136%2c0.003-0.35868-0.0302-0.11731-0.10225-0.19095-0.21628-0.22086-0.0933-0.0245-0.28248%2c0.0104-0.56755%2c0.10454l-1.9874%2c0.65431%2c1.3536%2c1.4603c0.20279%2c0.21939%2c0.3638%2c0.34473%2c0.48301%2c0.37601%2c0.0726%2c0.019%2c0.14227%2c0.0172%2c0.20915-0.005%2c0.0669-0.0226%2c0.12568-0.0647%2c0.17643-0.12614%2c0.0508-0.0615%2c0.0945-0.16218%2c0.1312-0.30212l0.14382%2c0.0377z'/%3e%3c/g%3e%3cg fill='%2396877d' stroke='black' stroke-width='0.203'%3e%3cpath d='m122.85%2c110.19c0.53163-0.13451%2c1.4092-0.0256%2c1.4092-0.0256s0.0769%2c0.3651-0.15373%2c0.4868c0.25621%2c0.14732%2c1.1786%2c0.10248%2c1.1786%2c0.10248s-0.3587%2c0.27543-0.53804%2c0.38431c0.33307%2c0.032%2c0.743%2c0.46118%2c0.743%2c0.46118s-0.76862%2c0.1281-1.1017-0.0512c0.20497%2c0.40993%2c0.17935%2c0.76863%2c0.17935%2c0.76863s-1.2426-0.30745-1.691-1.1273'/%3e%3cpath d='m120.77%2c109.49c-0.30104%2c0.74301-2.5108-0.64052-2.5108-0.64052s0.9736%2c1.5437%2c2.434%2c1.7166'/%3e%3cpath d='m93.181%2c123.66%2c25.877%2c0%2c1.9984-1.5885-3.3307-1.7935-5.1242-1.7422-2.0497-1.1273-3.7919%2c0.20497-3.177%2c1.691-4.3556%2c0.51242-1.0248%2c1.1786-3.2282%2c0.25621-5.0729-0.10248%2c8.4549%2c1.3323-6.9689-0.3587%2c1.7935%2c1.5373z'/%3e%3cpath d='m107.12%2c116.23c-3.241-1.7422-4.189%2c2.5493-5.5854%2c3.5869%2c1.8831%2c0.32026%2c3.3051-1.4476%2c4.9192-2.3059%2c1.224%2c3.333%2c3.1514%2c1.1273%2c3.1514%2c1.1273s2.0112%2c3.1898%2c4.6886%2c1.7422c0.73019%2c0.55085%2c1.5372%2c0.0512%2c1.5372%2c0.0512s0.9736%2c0.17935%2c1.1786-0.25621c0.51241%2c0.17935%2c1.0761-0.46117%2c1.0761-0.46117s1.1145%2c0.0128%2c1.3323-0.56366c1.6526%2c0.29464%2c3.8431-3.382%2c3.8431-3.382l0.66615-1.281%2c0.97359-0.20497s0.0641-0.64052-0.46118-0.6149c-0.0128-0.38432-0.34588-0.58929-0.81986-0.51242%2c0.0897-0.23059-0.25621-0.40994-0.25621-0.40994-0.92236%2c0.23059-0.9736%2c2.5621-0.9736%2c2.5621s-1.6141%2c1.2298-2.2034%2c1.5372c-0.0256-1.3323-2.2546-3.1386-1.7935-3.9969%2c0.46117-0.8583%2c1.9088%2c1.3195%2c3.177%2c0.92235%2c1.2682-0.39712%2c1.8914-2.0468%2c1.9472-3.3307-0.35869-0.87111-1.2298-2.3059-1.2298-2.3059l-0.81987-0.0512-0.71739-1.7422s-1.5116%2c0.98641-1.486%2c1.8447c0.0256%2c0.8583%2c1.5885%2c1.5885%2c1.5885%2c1.5885s-0.90121%2c0.56325-1.7422%2c0.30745c-0.0769%2c0.87111%2c1.0248%2c0.70457%2c1.4348%2c0.71738%2c0.20497%2c0.62771%2c0.81987%2c0.9736%2c0.81987%2c0.9736s0.38432%2c0.96078-0.6149%2c0.87111c-0.99922-0.0897-2.1781-2.3919-3.5869-1.3323-1.4988%2c1.1273%2c0.66614%2c3.177%2c0.66614%2c3.177s-1.3195%2c0.69176-2.1009%2c2.4596c-3.1898-2.6902-5.0601-1.4348-8.6086-0.71739z'/%3e%3cpath d='m102.46%2c111.67c1.3323%2c1.2554%2c0.40316%2c3.3422%2c0.92235%2c3.7407%2c0.55085%2c0.42274%2c1.3323-0.20497%2c1.3323-0.20497%2c1.3963%2c0.37151%2c3.8944-0.40993%2c3.8944-0.40993%2c1.0994%2c0.61473%2c0.66541-0.29241%2c1.3323-0.25621%2c0.58928%2c1.5116%2c2.5621%2c1.2298%2c2.5621%2c1.2298s-1.8063-1.8447-2.9208-2.3571c-0.8583%2c0.51242-3.3564%2c0.58928-3.7919%2c0.51242-0.48533-0.0857-0.17935-0.67896-0.40994-1.0248%2c0.91849-0.89406%2c0.19216-3.1129-0.30745-3.9456-2.036-1.3563-4.4684%2c0.96777-2.6133%2c2.7158z'/%3e%3cpath d='m93.599%2c107.92c-1.6758%2c0.45291-4.5835-2.165-5.9423-1.1595s-0.72467%2c3.4784%2c0.18117%2c4.7104c0.885%2c1.2036-1.2953%2c1.6396-1.8841%2c2.3552-0.55353%2c0.67276%2c0.18117%2c1.4493%2c0.18117%2c1.4493l0.61597%2c0.39857-0.1087%2c0.90583%2c0.3261%2c1.087s0.29892%2c0.26269%2c0.39857-0.0725c0.28081%2c0.28081%2c0.02966%2c1.0928%2c0.72467%2c1.1957-0.24887-0.52003%2c0.18117-1.9566%2c0.18117-1.9566s1.2138%2c0.0906%2c1.5218-0.4348c0.30798-0.52539-0.28987-1.6667-0.28987-1.6667h0.36233c-0.40763-0.28081-0.5435-1.1232-0.5435-1.1232s1.6849-0.53444%2c1.6667-1.8117c-0.01812-1.2772-2.7356-2.636-1.7392-3.2972%2c1.1051-0.73373%2c3.0255%2c1.9023%2c4.6741%2c0.68844%2c1.6315-1.2012%2c0.57974-0.0362%2c0.57974-0.0362s0.74569-1.6783-0.90584-1.2319z'/%3e%3cpath d='m102.25%2c89.971c-2.2418-0.93516-6.8216-0.99281-9.3773-2.2546-1.1209%2c0.07046-1.6205%2c0.95438-1.6654%2c1.3067-1.1722-0.05765-1.9664%2c1.7871-1.7935%2c2.1522-2.1329-0.86471-3.1258%2c2.5108-2.434%2c3.2026-1.8191%2c0.07686-1.5949%2c2.402-1.7678%2c3.0489-0.58288%2c1.4156%2c0.1298%2c1.8919%2c1.281%2c1.3835%2c0.17294%2c0.6149-0.06911%2c0.95934-0.58928%2c1.0761%2c3.1575%2c3.6133%2c4.9421-2.2236%2c7.7119-2.2034%2c3.4583-1.0124%2c4.8167-2.7158%2c4.8167-2.7158l1.3579%2c0.17934s2.4596-5.1754%2c2.4596-5.1754z'/%3e%3ccircle cx='105.145' cy='87.384' r='3.305'/%3e%3cpath d='m99.33%2c113.41c-2.0497-0.37151-5.4444-2.498-5.7903-5.2779%2c1.9088-7.4941%2c11.755-3.5807%2c12.604-9.2173-0.21639-3.7187%2c0.44951-7.3999%2c2.5119-10.511%2c0.96079-1.217%2c2.2034-1.5373%2c2.2034-1.5373s0.22257%2c0.79372-0.10248%2c1.3323c1.6269-0.17935%2c3.856%2c0.7302%2c5.3804%2c0.81987%2c0.44837%2c0.90954%2c0.40994%2c1.2426%2c0.30745%2c1.7935-0.10248%2c0.55085-0.71738%2c0.40993-0.71738%2c0.40993-0.39767%2c0.37723-0.87565%2c0.76105-1.9472%2c0.56366-0.80706%2c0.6149-2.5108%2c0.76863-2.5108%2c0.76863s3.5613%2c3.7535%2c2.972%2c4.9192c0.74301%2c0.34588%2c1.8447%2c1.9984%2c1.8447%2c1.9984s2.434-1.281%2c3.2282-2.4596c1.4092%2c0%2c3.715%2c1.4732%2c4.868%2c1.6397%2c1.4092%2c1.1401%2c2.8183%2c2.3059%2c2.8183%2c2.3059s-1.6782%2c1.1017-2.4084-0.3587c-0.88392%2c0.0769-2.7927-2.0369-5.4316-1.3835-0.0769%2c2.3443-2.6646%2c3.9969-2.6646%2c3.9969s2.4153-0.33802%2c3.7406%2c0.46117c1.3707%2c1.153%2c3.382%2c2.7158%2c3.382%2c2.7158l1.7935%2c3.0745s-1.6397%2c0.28183-2.2546-1.8447c-0.61491%2c1.7166-0.64052-1.0633-3.0745-2.3571-0.74301%2c0.0897-1.1145%2c0.14092-1.7422-0.35869-1.755%2c0.47399-3.8303%2c1.4988-6.3028%2c1.2298-1.755%2c0.55085-3.0361%2c2.0112-4.8167%2c2.8183-1.7807%2c0.80706-2.3059%2c0.40993-2.3059%2c0.40993l-1.4348%2c0.0512c-0.20699%2c0.86376-0.0897%2c2.1778-0.87111%2c2.4084%2c0.49961%2c0.53804-0.35869%2c2.8311-1.2298%2c3.2282%2c0.40993%2c1.4732%2c1.6108%2c1.9242%2c2.8695%2c2.6646%2c0%2c0%2c1.1145-0.51241%2c1.8447%2c0.15373%2c0.73019%2c0.66614%2c1.486%2c2.5621%2c1.486%2c2.5621s-1.5197%2c0.10268-1.9984-0.10248c-0.47871-0.20516-0.52523-0.70458-1.0761-0.56366-3.4716-3.0873-5.3024-1.8593-5.6366-2.5621-0.34252-0.72035%2c0.81987-2.6005%2c0.46118-3.7919z'/%3e%3cpath d='m90.99%2c99.655c0.18117-0.22646%2c1.4493%2c0.25363%2c1.4493%2c0.25363l2.3189%2c1.4493%2c4.7104%2c3.0436%2c1.6667%2c2.4276-3.0074-0.9783-4.1668-3.5871-2.2465-1.4493s-0.90584-0.93301-0.72467-1.1595z'/%3e%3cpath d='m118.85%2c107.37c-1.6269-0.40994-5.6366%2c4.458-5.6366%2c4.458l3.0233%2c3.2795s0.0897-5.5854%2c2.6133-7.7375z'/%3e%3cpath d='m99.023%2c93.789c-0.88723%2c1.1368-0.96662%2c3.4287%2c0.18756%2c4.3531%2c0.10881%2c1.3911%2c1.2915%2c4.1971%2c2.2208%2c4.4605%2c1.0153%2c0.28784%2c5.0729%2c1.2298%2c6.6614%2c0.97359-0.30381%2c2.5745%2c1.7164%2c4.641%2c3.5869%2c5.9953-0.0136%2c0.23103-0.0168%2c0.51306%2c0.19928%2c0.79864%2c0.20936%2c0.27664%2c1.1923%2c0.32734%2c1.2355%2c0.17495%2c0.43591%2c0.6126%2c2.5473%2c0.88157%2c2.7003%2c0.60869%2c0.14884-0.26552-3.1056-2.5307-3.8276-3.222-0.6133-1.1442-1.7749-3.6938-2.0497-5.7391-1.5973-1.9003-4.3395-1.8623-4.3395-1.8623l0.0864-3.7231%2c0.15373-4.2018-1.486-0.76863s0.29956-0.13652%2c0.46117-0.30745c0.36089%2c0.15517%2c1.0391-0.56988%2c1.1273-0.77484%2c0.34187%2c0.12113%2c0.65138%2c0.11952%2c0.71117-0.06314%2c0.0528-0.16132%2c0.11399-0.87942%2c0.23863-1.2505%2c1.1211-0.98705-0.16365-3.08-1.8778-3.1144-1.6961-0.03441-2.0765%2c2.0232-2.044%2c2.1796%2c0.15932%2c0.64556%2c0.12499%2c0.97102%2c0%2c1.1273-0.12777%2c0.15976-0.71739%2c0.51242-0.71739%2c0.51242s-0.94797-0.44837-2.1009%2c0-2.4468%2c1.0505-2.5108%2c1.7935c-0.52523%2c0.07686-1.3835%2c0.75582-1.5373%2c1.3323-0.46118-0.08967-1.0633%2c0.29464-2.0497%2c1.8959-1.7678%2c0.78144-1.8703%2c4.5605-1.8703%2c4.5605s-0.47719%2c0.69496-0.49961%2c1.0633c-0.02242%2c0.3683%2c0.16654%2c0.70458%2c0.39712%2c0.64053%2c0.02562%2c0.24339%2c0.34588%2c0.46117%2c0.4868%2c0.38431%2c0.05124%2c0.2434%2c0.40298%2c0.37952%2c0.6149%2c0.34588%2c0.01922%2c0.16654%2c0.70137%2c0.12491%2c0.75582-0.0256%2c0.06008-0.16611-0.0675-0.99692%2c0.0128-1.0633%2c0.07366-0.0609%2c0.64052%2c0.37151%2c0.79425%2c0.25621%2c0.15373-0.11529-0.02936-0.48449-0.11529-0.62771-0.07686-0.12811-0.56366-0.26902-0.67895-0.87111s0.30745-1.4348%2c0.30745-1.4348%2c1.9216-1.5116%2c2.1393-2.8055c1.4476%2c0.14092%2c2.213-1.1241%2c2.6261-1.6013z'/%3e%3cpath d='m95.679%2c88.37c0.43876-1.0729%2c2.0241-0.97359%2c2.0241-0.97359s0.56686-1.4924%2c2.703-0.60209c0.80386-0.62131%2c2.9208%2c0.26902%2c2.9208%2c0.26902s0.7927-1.0562%2c1.8319-0.93516c1.9248%2c0.22418%2c2.245%2c1.9888%2c2.1265%2c2.2931-1.0537%2c0.26582-2.879-0.85629-4.2659-0.53804-0.81026%2c0.45797-2.1233%2c0.94157-2.6133%2c1.6013-1.2842%2c0.13451-2.655-1.1818-4.7271-1.1145z'/%3e%3cpath d='m99.689%2c90.151c0.4804-0.29464%2c1.6588-0.81262%2c2.4596-0.17935%2c0.83908%2c0.90314%2c2.1265%2c1.7422%2c2.1265%2c1.7422l1.4604%2c0.6149%2c0.66614%2c0.40994-0.43556%2c6.6871c-1.3518-1.3831-2.6186-1.6253-3.5869-3.2539-0.51883-0.69817-0.1217-2.3763-1.0248-3.4844-0.90314-1.1081-1.8639-1.8575-1.6654-2.5365z'/%3e%3cpath d='m103.2%2c92.082s0.76544-0.14493%2c0.97831%2c0.03623c0.26722%2c0.09058%2c0.52538%2c0.16758%2c0.59785%2c0.39857%2c0.28987%2c0.08605%2c0.48915%2c0.23552%2c0.48915%2c0.45292%2c0.27175%2c0.07247%2c0.38045%2c0.56162%2c0.38045%2c0.56162l-0.25363%2c0.38045s-0.28987-0.27175-0.3261-0.56162c-0.1834-0.09031-0.5888-0.1857-0.68844-0.45292-0.31704-0.0317-0.52085-0.19476-0.57973-0.47104-0.2944%2c0.06794-0.59786-0.34422-0.59786-0.34422z'/%3e%3cpath d='m109.68%2c87.717c-0.43556-0.4868-1.2042-0.1281-1.2042-0.1281l-2.0497%2c3.5357-0.89673%2c0.74301-0.0769%2c2.7671%2c0.743%2c2.5877-0.25621%2c1.9984s1.0322-0.96837%2c1.153-1.5116c0.11529-0.51882-0.38432-2.2034-0.38432-2.2034s-0.6149-1.0505%2c0.12811-2.9976c0.743-1.9472%2c2.434-3.5613%2c2.8439-4.7911z'/%3e%3cpath d='m114.74%2c90.868s-3.2003%2c4.5733-8.4398%2c6.2003c-1.4476%2c0.34588-0.92236-3.382-0.92236-3.382l-0.35869%2c0.10248s-0.80706%2c3.651%2c1.1273%2c3.6894c5.2651-1.0376%2c9.2156-6.5806%2c9.2156-6.5806l-0.63-0.028z'/%3e%3cpath d='m116.91%2c117.16s-0.4868%2c0.3587-1.1273%2c0c-0.33307-0.76862-1.2298-0.81987-1.2298-0.81987s-0.57758-1.6593-1.486-1.1786c-0.14091-0.8583-1.1273-0.40993-1.1273-0.40993s-0.0256-1.2426-1.1786-1.0761c0.38431-1.422-1.5885-1.3323-1.5885-1.3323s-0.064-1.6013-2.972-1.281c6.2643-2.8055%2c11.222%2c4.4068%2c11.222%2c4.4068'/%3e%3cpath d='m119.88%2c117.77s1.4476%2c1.6269%2c2.2034%2c1.6397c0.75582%2c0.0128%2c0.81987-1.5885%2c0.81987-1.5885s0.2434%2c0.69176%2c0.6149%2c0.51242c-0.0384%2c0.48679%2c0.46118%2c0.6149%2c0.46118%2c0.6149s-1.3067%2c3.0361-5.0217%2c0.15372'/%3e%3cpath d='m108.55%2c118.39-0.51242%2c2.1009s-0.65333%2c0.58928-0.46118%2c0.71739c0.19216%2c0.1281%2c1.2298-0.20497%2c1.2298-0.20497s1.6141-0.19215%2c2.1009-0.66614c0.33308%2c0.75582%2c1.0761%2c0.81987%2c1.0761%2c0.81987s0.0512-0.32026-0.0512-0.51242c0.35869%2c0.0641%2c0.66615-0.0512%2c0.66615-0.0512s0.20496-0.58929-0.25621-0.81987c0.0512-0.43556%2c0.26901-0.81987-0.51242-0.76863-0.57647%2c0.6149-1.9984%2c1.3195-2.3571%2c1.0761-0.35869-0.2434%2c1.4092-1.0248%2c0.92236-2.0497'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$q = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3crect width='900' height='600'/%3e%3crect y='100' width='900' height='100' fill='%23fcdc04'/%3e%3crect y='200' width='900' height='100' fill='%23d90000'/%3e%3crect y='400' width='900' height='100' fill='%23fcdc04'/%3e%3crect y='500' width='900' height='100' fill='%23d90000'/%3e%3ccircle cx='450' cy='300' r='93.5' fill='white'/%3e%3cg stroke='black'%3e%3cpath d='M 433.52031%2c228.39062 L 427.45593%2c217.22033 C 429.79607%2c214.8802 433.73312%2c213.07128 440.0095%2c213.07128 C 440.0095%2c213.49691 439.37106%2c225.30563 439.37106%2c225.30563 z' fill='%23d90000'/%3e%3cpath d='M 439.37106%2c225.41204 L 440.22231%2c213.07128 C 440.22231%2c213.07128 452.77588%2c212.32724 459.5843%2c220.51813 C 459.6907%2c220.41173 452.88229%2c230.09231 452.88229%2c230.09231 z' fill='%23fcdc04'/%3e%3cpath d='M 453.0951%2c229.98591 L 459.26508%2c220.41173 C 463.41413%2c224.7736 465.11583%2c227.85858 465.75427%2c232.53967 C 465.86068%2c232.64608 455.96728%2c234.98622 455.96728%2c234.87981 C 455.96728%2c234.7734 453.20151%2c230.09231 453.0951%2c229.98591 z' fill='%23d90000'/%3e%3cpath d='M 436.60529%2c388.07318 C 436.60529%2c388.07318 448.2012%2c374.77476 470.75458%2c377.64774 C 467.35037%2c372.1154 456.3929%2c372.75384 456.3929%2c372.75384 C 456.3929%2c372.75384 452.9887%2c346.90266 455.64806%2c345.62578 C 458.30741%2c344.3489 469.5841%2c345.73219 469.5841%2c345.73219 C 471.07299%2c345.73219 473.62675%2c341.68954 471.60583%2c339.13659 C 469.5841%2c336.58282 463.62694%2c326.79583 466.07349%2c324.88051 C 468.52085%2c322.966 481.81845%2c325.94457 481.81845%2c325.94457 L 444.26496%2c277.85924 C 444.26496%2c277.85924 440.43513%2c259.77414 448.09479%2c251.0504 C 457.35057%2c243.39073 456.3929%2c235.09262 456.07368%2c235.19903 C 454.7968%2c226.79451 442.03123%2c220.73014 433.4139%2c228.49702 C 428.30718%2c234.667 431.71139%2c239.34808 431.71139%2c239.34808 C 431.71139%2c239.34808 418.30738%2c242.9651 417.77534%2c245.30524 C 417.24331%2c247.64619 432.88186%2c244.88043 432.88186%2c244.88043 L 431.39217%2c255.62508 C 431.39217%2c255.62508 400.96631%2c283.28436 424.26453%2c307.22103 C 424.47735%2c307.11462 425.00938%2c306.15696 425.00938%2c306.15696 C 425.00938%2c306.15696 433.20108%2c316.26399 441.8176%2c318.49772 C 449.9029%2c326.79583 449.15886%2c325.51895 449.15886%2c325.51895 C 449.15886%2c325.51895 450.75415%2c338.60455 449.26527%2c341.1575 C 447.24354%2c340.51906 426.60548%2c339.77503 423.51969%2c340.94469 C 420.75392%2c341.79595 410.11567%2c341.26391 412.77503%2c358.60498 C 414.79595%2c353.92389 416.60487%2c349.77483 416.60487%2c349.77483 C 416.60487%2c349.77483 416.28565%2c356.05121 418.83941%2c358.28576 C 418.41378%2c351.68935 421.28595%2c347.22188 421.28595%2c347.22188 C 421.28595%2c347.22188 421.81799%2c354.45592 423.41328%2c355.51918 C 425.00938%2c356.58325 425.00938%2c343.81686 433.83953%2c344.88093 C 442.66886%2c345.945 449.05246%2c345.62578 449.05246%2c345.62578 C 449.05246%2c345.62578 452.03104%2c370.6257 451.07337%2c372.96665 C 444.68977%2c371.47696 429.47766%2c373.60509 428.52%2c377.43493 C 437.45573%2c376.90289 441.6056%2c377.96615 441.6056%2c377.96615 C 441.6056%2c377.96615 434.37156%2c384.34975 436.60529%2c388.07318 z'/%3e%3cpath d='M 440.19145%2c251.66041 C 440.19145%2c251.66041 418.05232%2c276.06251 427.60376%2c294.73569 C 428.11224%2c292.13157 427.89049%2c290.49566 428.20971%2c290.60207 C 427.67768%2c290.28285 430.95517%2c292.8488 430.7058%2c292.34925 C 430.77566%2c290.99927 429.70753%2c288.10598 429.70753%2c288.10598 C 430.7058%2c288.35534 431.70489%2c288.60552 432.70317%2c288.85488 C 432.12077%2c287.77295 431.53756%2c286.69182 430.95517%2c285.60988 C 432.37014%2c285.7764 433.78429%2c285.9421 435.19926%2c286.10861 C 435.19926%2c286.10861 433.70144%2c282.1147 434.20098%2c282.1147 C 434.69972%2c282.1147 437.69535%2c282.36407 437.69535%2c282.36407 C 431.39948%2c271.06545 437.33877%2c261.68215 440.19145%2c251.66041 z' fill='%239ca69c' stroke='%239ca69c'/%3e%3cpath d='M 447.88198%2c230.73075 C 447.88198%2c230.73075 449.05246%2c239.13527 444.47777%2c241.58182 C 443.73293%2c242.11385 440.86075%2c243.07151 441.28638%2c244.77402 C 441.81841%2c247.11416 443.09448%2c246.68853 444.9034%2c246.2629 C 449.69008%2c245.41165 455.22243%2c235.19903 447.88198%2c230.73075 z' fill='%239ca69c' stroke='%239ca69c'/%3e%3ccircle cx='438' cy='238' r='1.8' fill='white' stroke='none'/%3e%3cpath d='M 432.56264%2c244.98602 C 431.39217%2c245.94368 425.2222%2c252.32728 431.28576%2c254.66742 C 437.56295%2c252.96491 435.86044%2c251.79525 437.24373%2c250.41196 C 437.27947%2c247.53979 434.12301%2c246.79494 432.56264%2c244.98602 z' fill='%23d90000'/%3e%3cpath d='M 445.96666%2c305.30652 C 445.64744%2c306.68981 444.26496%2c311.79571 446.17947%2c315.73195 C 451.499%2c313.49822 453.94555%2c314.13585 455.75446%2c315.30633 C 451.39341%2c311.79571 449.6909%2c310.30602 445.96666%2c305.30652 z' fill='%239ca69c' stroke='%239ca69c'/%3e%3cpath d='M 455.11602%2c329.45519 L 455.43524%2c341.37032 C 455.43524%2c341.37032 459.5843%2c342.11517 461.49881%2c341.37032 C 463.41413%2c340.62547 461.3924%2c333.07221 455.11602%2c329.45519 z' fill='white' stroke='white'/%3e%3cpath d='M 485.22266%2c330.94488 C 485.22266%2c330.94488 477.56299%2c312.43415 457.98819%2c307.75307 C 438.4134%2c303.07198 440.96635%2c282.22111 442.56245%2c280.94423 C 443.41371%2c279.13531 444.05215%2c276.36954 449.69008%2c279.02971 C 455.32883%2c281.68907 481.28642%2c294.77387 485.00985%2c295.41231 C 488.73327%2c296.05075 485.54188%2c331.37051 485.22266%2c330.94488 z' fill='%239ca69c'/%3e%3cpath d='M 466.60552%2c307.64666 C 466.2863%2c307.85947 492.77592%2c323.2844 484.79703%2c336.58282 C 492.35111%2c331.58251 489.90375%2c322.85959 489.90375%2c322.85959 C 489.90375%2c322.85959 496.07372%2c338.92377 481.07361%2c346.79626 C 482.66971%2c348.17954 483.73378%2c347.85951 483.73378%2c347.85951 L 481.18001%2c350.41328 C 481.18001%2c350.41328 480.00954%2c352.32779 490.11656%2c347.43388 C 487.34999%2c349.66843 487.13798%2c351.26372 487.13798%2c351.26372 C 487.13798%2c351.26372 487.88202%2c353.39185 494.47843%2c347.6467 C 489.1589%2c353.39185 487.98843%2c356.37043 487.98843%2c356.26403 C 502.3501%2c354.98715 533.62722%2c308.2851 478.09503%2c294.45465 C 481.07442%2c297.54044 480.64798%2c297.11482 480.64798%2c297.11482 z' fill='%23d90000'/%3e%3cpath d='M 467.776%2c303.07198 C 471.39302%2c305.62493 472.66909%2c306.47618 473.09472%2c307.75307 C 469.79692%2c307.00903 466.81834%2c307.22103 466.81834%2c307.22103 C 466.81834%2c307.22103 459.6907%2c300.41262 458.41382%2c299.88058 C 457.45616%2c299.88058 451.92463%2c296.36997 451.92463%2c296.36997 C 449.15886%2c294.98668 446.60591%2c285.4125 456.81853%2c288.17827 C 467.34956%2c293.17776 468.83926%2c293.6042 468.83926%2c293.6042 C 473.02405%2c294.91601 477.20803%2c296.22864 481.39283%2c297.54044 C 483.80444%2c300.23554 486.21525%2c302.93064 488.62687%2c305.62574 C 488.62687%2c305.62574 475.75489%2c299.24214 474.15879%2c299.13574 C 477.6694%2c302.00791 479.69113%2c305.94415 479.69113%2c305.94415 C 475.61274%2c304.77367 472.0672%2c303.71042 467.776%2c303.07198 z' fill='white'/%3e%3cpath d='M 417.66893%2c245.94368 C 417.66893%2c245.94368 430.00969%2c242.9651 431.49858%2c243.39073' stroke='white'/%3e%3c/g%3e%3c/svg%3e";

var img$p = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3crect width='450' height='300'/%3e%3crect fill='white' width='450' height='200'/%3e%3crect fill='%23CE1126' width='450' height='100'/%3e%3c/svg%3e";

var img$o = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 24'%3e%3crect width='36' height='24' fill='%2375aadb'/%3e%3crect y='9' width='36' height='6' fill='white'/%3e%3crect y='10' width='36' height='4'/%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3crect fill='%23007A3D' width='6' height='3'/%3e%3crect fill='white' width='6' height='2'/%3e%3crect width='6' height='1'/%3e%3cpath fill='%23CE1126' d='M0%2c0l2%2c1.5L0%2c3Z'/%3e%3c/svg%3e";

var img$m = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 960 480'%3e%3crect width='960' height='480' fill='%23239e46'/%3e%3crect width='960' height='360' fill='black'/%3e%3crect width='960' height='120' fill='%23e70013'/%3e%3ccircle cx='480' cy='240' r='60' fill='white'/%3e%3ccircle cx='492.132034' cy='240' r='52.132034' fill='black'/%3e%3cpath d='M509.175411%2c240 589.875233%2c213.779039 540%2c282.426407V197.573593L589.875233%2c266.220961z' fill='white'/%3e%3c/svg%3e";

var img$l = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 400'%3e%3crect fill='%23ce1126' width='600' height='400'/%3e%3crect fill='%23002868' y='100' width='600' height='200'/%3e%3ccircle fill='white' cx='300' cy='200' r='80'/%3e%3c/svg%3e";

var img$k = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 90 60'%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath d='M0 0h90v60H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath fill='%23003580' d='M0 60V0h90z'/%3e%3cpath fill='%23009543' d='M90 0v60H0z'/%3e%3cg fill='none' clip-path='url(%23a)'%3e%3cpath stroke='white' stroke-width='20' d='M0 60L90 0'/%3e%3cpath stroke='%23d21034' stroke-width='15' d='M0 60L90 0'/%3e%3c/g%3e%3cg fill='%23ffce00' transform='translate(18 16.341)'%3e%3cpath d='M0-10l1.55 4.2L5-8.66l-.76 4.42L8.66-5 5.8-1.55 10 0 5.8 1.55 8.66 5l-4.42-.76L5 8.66 1.55 5.8 0 10l-1.55-4.2L-5 8.66l.76-4.42-4.42.76 2.86-3.45L-10 0l4.2-1.55L-8.66-5l4.42.76L-5-8.66l3.45 2.86z'/%3e%3ccircle r='5.5' stroke='%23003580'/%3e%3c/g%3e%3c/svg%3e";

var img$j = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1440 720'%3e%3crect width='1440' height='720' fill='%23f7e017'/%3e%3cpath d='M0%2c50V370L1440%2c520V350z' fill='white'/%3e%3cpath d='M0%2c220V370L1440%2c670V520z' fill='black'/%3e%3cg fill='%23cf1126'%3e%3cpath d='M695.74%2c569.72c-19.36-2.57-37.11-8.73-49.44-17.17-2.39-1.64-4.64-2.98-4.99-2.98-0.36%2c0-0.65%2c1.82-0.65%2c4.07%2c0%2c6.37-2.56%2c9.58-9%2c11.25-6.16%2c1.6-15.56-1.63-23.18-7.95-7.89-6.55-17-11.55-24.71-13.55-6.35-1.66-14.78-1.39-20.87%2c0.65-2.83%2c0.95-6.05%2c2.29-7.17%2c2.98-1.11%2c0.69-2.36%2c1.25-2.76%2c1.25-1.08%2c0-0.93-6.85%2c0.2-9.04%2c1.49-2.87%2c5.16-5.7%2c9.44-7.26%2c2.16-0.79%2c3.93-1.8%2c3.93-2.25s-0.73-2.1-1.62-3.65c-2.9-5.08-1.71-10%2c3.35-13.87%2c5.18-3.96%2c13.95-4.64%2c21.7-1.69%2c1.95%2c0.74%2c3.77%2c1.35%2c4.04%2c1.35%2c1.02%2c0%2c0.4-1.43-2.41-5.52-3.24-4.74-3.88-7.08-3.48-12.72%2c0.52-7.14%2c6.34-12.98%2c13.47-13.5%2c5.82-0.42%2c9.44%2c1.54%2c18.03%2c9.72%2c25.65%2c24.46%2c53.54%2c37.94%2c86.07%2c41.59%2c8.21%2c0.92%2c24.73%2c0.43%2c34.42-1.03%2c29.27-4.41%2c58.76-19.13%2c81.79-40.82%2c6.38-6.01%2c9.45-7.6%2c14.68-7.62%2c4.55-0.02%2c7.74%2c1.45%2c11%2c5.05%2c2.97%2c3.3%2c3.98%2c6.43%2c3.66%2c11.44-0.21%2c3.21-0.73%2c4.79-2.64%2c7.9-2.82%2c4.59-2.34%2c5.01%2c3.24%2c2.85%2c7.54-2.94%2c16.83-1.58%2c21.84%2c3.18%2c4.41%2c4.19%2c4.83%2c8.38%2c1.4%2c14.06-1.25%2c2.08-2.27%2c4.03-2.27%2c4.34%2c0%2c0.57%2c0.95%2c0.84%2c5.53%2c1.58%2c5.99%2c0.96%2c9.42%2c5.41%2c9.42%2c12.21%2c0%2c2.04-0.25%2c3.7-0.56%2c3.7-0.3%2c0-2.57-0.83-5.04-1.85-6.98-2.88-10.95-3.62-19.11-3.57-6.21%2c0.04-8.35%2c0.33-12.68%2c1.74-6.63%2c2.17-13.72%2c6.35-19.5%2c11.5-6.37%2c5.68-10.38%2c7.47-16.58%2c7.42-5.76-0.06-9.7-1.73-11.78-5.02-1.11-1.76-1.27-2.83-1-6.81%2c0.18-2.59%2c0.14-4.71-0.07-4.71-0.22%2c0-2.46%2c1.42-4.99%2c3.17-6.64%2c4.56-10.87%2c6.82-18.47%2c9.83-23.18%2c9.17-56.63%2c13.14-82.24%2c9.75z'/%3e%3cpath d='m706.34%2c525.17c-38.58-3.7033-75.494-23.798-97.939-55.657-24.37-33.235-32.05-77.117-24.611-117.24%2c3.9535-18.267%2c11.929-36.546%2c25.544-49.554-10.85%2c23.003-14.516%2c49.369-8.7299%2c74.29%2c8.989%2c49.753%2c51.036%2c91.87%2c101.34%2c99.156%2c19.9%2c5.761%2c40.487-0.32356%2c59.496-6.4934%2c41.935-14.779%2c73.879-54.583%2c77.777-99.079%2c3.3363-24.078-0.36023-49.114-11.207-70.916%2c6.1825%2c3.2692%2c13.987%2c16.087%2c18.589%2c24.707%2c16.003%2c31.003%2c16.734%2c68.155%2c7.3126%2c101.24-12.78%2c42.097-44.965%2c78.978-87.511%2c92.382-19.308%2c6.3081-39.842%2c8.2315-60.058%2c7.1679z'/%3e%3cg id='hand'%3e%3cpath d='m512.02%2c469.9c-2.5284-0.39577-5.3161%2c2.092-4.3628%2c4.6971%2c1.823%2c2.633%2c4.9641%2c3.9201%2c7.798%2c5.1795%2c6.7915%2c2.7224%2c14.179%2c3.7823%2c21.471%2c3.6055-2.5133-0.006%2c0.86258%2c0.026%2c1.8015-0.00068%2c5.774%2c0.0171%2c11.516-1.0234%2c16.944-2.98%2c3.018-1.0614%2c6.8641-2.0244%2c8.1009-5.3629%2c1.2069-2.1744-0.98008-4.3462-3.1859-3.9108-3.0714%2c0.67078-5.9433%2c2.064-8.9896%2c2.8576-6.5725%2c1.8534-13.494%2c2.5704-20.303%2c2.0116-4.9792-0.60782-9.8039-2.2005-14.41-4.1433-1.5972-0.70457-3.0962-1.7322-4.8648-1.9536z'/%3e%3cpath d='m514.83%2c459.52c-2.5558-0.38057-4.7577%2c2.5607-3.6917%2c4.9076%2c1.965%2c2.8484%2c5.2671%2c4.3651%2c8.356%2c5.6992%2c5.3706%2c2.1486%2c11.204%2c3.0471%2c16.975%2c2.8752-2.1917-0.006%2c0.75258%2c0.026%2c1.5651-0.00068%2c4.9069%2c0.006%2c9.7882-0.96448%2c14.325-2.8311%2c2.7732-1.0787%2c6.1693-2.1246%2c7.3241-5.177%2c0.89621-1.6768%2c0.21293-4.1165-1.8997-4.2476-1.9288-0.0953-3.5928%2c1.1322-5.3782%2c1.6831-6.4849%2c2.6815-13.622%2c3.8183-20.614%2c3.2146-4.3567-0.56071-8.519-2.1681-12.47-4.0312-1.4847-0.71699-2.8205-1.8356-4.4909-2.092z'/%3e%3cpath d='m518.28%2c449.57c-2.1908-0.26295-3.6978%2c2.2088-3.3288%2c4.1816%2c0.32687%2c1.7334%2c1.8824%2c2.8984%2c3.1689%2c3.9607%2c5.3292%2c3.8973%2c12.083%2c5.5573%2c18.626%2c5.3398-2.5415-0.009%2c3.4093%2c0.0418%2c1.5947-0.007%2c4.1442-0.0169%2c8.2378-1.0309%2c11.966-2.825%2c2.4889-1.0824%2c5.4115-2.3356%2c6.2502-5.1771%2c0.40122-1.3236%2c0.65233-3.227-0.84101-3.97-1.5638-0.87412-3.1169%2c0.47031-4.5388%2c1.0156-4.7891%2c2.4374-10.125%2c3.7932-15.507%2c3.7682-4.6507%2c0.15705-9.0334-1.799-13.068-3.9072-1.464-0.74578-2.6708-2.0422-4.3214-2.3798z'/%3e%3cpath d='m481.53%2c302.7c-3.2575%2c3.2606-0.7701%2c9.2712-0.94626%2c13.543%2c1.6879%2c13.158%2c3.785%2c26.484%2c8.697%2c38.87%2c6.015%2c12.102%2c18.791%2c18.573%2c26.533%2c29.268%2c2.7675%2c5.155%2c1.7849%2c11.355%2c2.3681%2c16.994%2c0.45808%2c15.366%2c0.31593%2c30.743%2c0.047%2c46.111%2c6.9387%2c3.4817%2c14.474%2c6.9863%2c22.456%2c5.6471%2c4.7306-1.13%2c13.512-1.8326%2c14.496-6.5436-0.38235-26.5-0.6304-53.01-0.98289-79.506-2.6903-8.1185-10.951-12.32-17.129-17.514-5.0992-5.0259-9.844-10.435-14.188-16.099-2.6218-4.4175-12.868-6.0092-9.1612%2c1.6764%2c2.1735%2c6.6538%2c7.7204%2c11.61%2c9.1091%2c18.602%2c0.30342%2c3.8316%2c4.8776%2c10.879%2c0.97314%2c13.114-2.4837-4.2216-6.0823-7.815-10.682-9.9574-4.4324-3.3044-11.759-4.68-13.359-10.517-1.1745-8.2799-5.4152-15.782-10.887-21.986%2c1.4102-7.4368%2c0.005-16.737-6.4234-21.49l-0.92101-0.21254-0.00013-0.00002z'/%3e%3cpath d='m491.44%2c304.19c-2.9629%2c0.47847-2.8621%2c4.2538-1.491%2c6.239%2c1.4583%2c4.2881%2c1.8554%2c8.9449%2c1.0659%2c13.409%2c5.2675%2c6.1665%2c9.3467%2c13.543%2c10.576%2c21.64%2c0.0299%2c3.0437%2c3.2327%2c4.0512%2c5.309%2c5.5551%2c4.8712%2c3.1016%2c10.348%2c5.3512%2c14.686%2c9.2326%2c0.91286%2c0.97602%2c1.6017%2c2.0271%2c0.9566%2c0.035-0.67695-2.5463-1.0251-5.3576-3.0207-7.2849-2.7345-2.939-6.15-5.5628-10.133-6.4593-0.33199-4.114-2.2913-7.8931-4.1017-11.532-2.0066-3.4792-4.1026-7.2065-7.5407-9.4626%2c0.13834-6.098%2c0.0385-12.495-2.5857-18.122-0.7696-1.4455-1.9032-3.163-3.7197-3.2499z'/%3e%3cpath d='m499.73%2c306.62c-2.0642%2c0.61274-1.6695%2c3.1587-1.0158%2c4.7165%2c0.98881%2c4.3156%2c1.1436%2c8.7732%2c1.063%2c13.184%2c3.7911%2c3.0003%2c6.1624%2c7.3501%2c8.3216%2c11.586%2c1.3534%2c2.8304%2c2.6366%2c5.7518%2c3.1556%2c8.8651%2c3.0757%2c1.0188%2c5.7672%2c2.946%2c8.171%2c5.0773-0.95256-2.8824-3.0766-5.1129-4.5042-7.7441-1.5516-2.7372-3.0336-5.5913-3.6904-8.6923-2.9581-3.1576-4.5872-7.6305-3.9408-11.952%2c0.13267-4.7762-1.4093-9.7114-4.6059-13.311-0.8049-0.79276-1.7658-1.6692-2.954-1.7296z'/%3e%3cpath d='m509.16%2c307.97c-1.1224%2c0.1984-1.8054%2c1.2662-2.4064%2c2.1373-0.23225%2c0.87316%2c0.83776%2c1.8114%2c1.0081%2c2.7596%2c1.3127%2c3.2919%2c1.8084%2c6.903%2c1.4162%2c10.426-0.0864%2c2.5018%2c0.80881%2c4.9458%2c2.0839%2c7.0649%2c0.36793-1.5628%2c1.8164-2.6864%2c3.3865-2.8406%2c0.57114-0.10043%2c1.4107%2c0.18835%2c1.0779-0.68251-0.39881-4.7853-1.128-9.5978-2.8007-14.119-0.64833-1.615-1.3844-3.3147-2.7835-4.4203-0.28367-0.20186-0.62304-0.3745-0.98205-0.32512z'/%3e%3c/g%3e%3cuse xlink:href='%23hand' transform='matrix(-1%2c0%2c0%2c1%2c1440%2c0)'/%3e%3cpath d='m715.67%2c475.98c-13.493-1.2846-25.667-11.12-29.829-24%2c0.22423-2.2187%2c2.9867%2c1.2413%2c4.2917%2c1.4741%2c2.4503%2c1.3606%2c5.0998%2c2.4802%2c7.9211%2c2.6539%2c3.5571%2c1.529%2c5.7565%2c5.0346%2c9.1516%2c6.8629%2c1.5764%2c1.2278%2c7.1544%2c3.641%2c6.1182-0.26421-1.307-2.04-2.2057-4.6242-1.0806-6.9613%2c1.8918-4.1503%2c4.8018-7.7638%2c7.7306-11.226%2c2.1527-0.71996%2c3.5939%2c3.5262%2c5.1338%2c4.9568%2c2.1308%2c3.2786%2c4.7004%2c7.2793%2c3.447%2c11.352-1.2198%2c1.5087-2.0216%2c6.0472%2c1.2409%2c4.5219%2c4.0213-1.7692%2c7.3158-4.7418%2c10.651-7.5175%2c2.9183-2.0384%2c6.6539-2.1824%2c9.7125-3.9699%2c1.4177-0.35921%2c4.3706-3.1946%2c4.9861-1.6225-1.6759%2c4.4876-4.4822%2c8.5068-7.4822%2c12.211-4.8588%2c5.5503-11.432%2c9.7247-18.786%2c10.902-4.3459%2c0.79562-8.806%2c0.96352-13.207%2c0.62747z'/%3e%3cpath d='m731.53%2c460.22c0.29719-2.7079-0.31965-5.4735-1.703-7.9349-2.123-4.3258-5.1213-8.1663-8.0456-11.961-2.7573-1.615-4.2871%2c3.6582-6.1205%2c5.1714-2.8566%2c4.2769-6.4434%2c8.6562-6.617%2c14.036-1.6071%2c2.5012-4.6044-2.0411-5.8962-3.5357-2.4673-3.4911-4.3356-7.6206-4.0297-11.987-0.29227-7.0356%2c1.0571-14.041%2c3.6204-20.581%2c1.9348-5.5826%2c5.0755-11.006%2c4.7564-17.105%2c0.22416-4.5905-0.70745-9.6582-4.4262-12.745-3.538-2.7758%2c2.2916-3.3674%2c4.1432-1.928%2c3.1686%2c0.21257%2c4.8825%2c5.4481%2c7.7771%2c4.152%2c1.1532-2.7346%2c1.3824-5.9968%2c3.7595-8.1295%2c2.3338-3.1959%2c4.773%2c1.3562%2c5.5715%2c3.488%2c1.6467%2c1.8723-0.0931%2c6.5066%2c2.5817%2c6.6282%2c3.2062-2.2473%2c5.4923-6.0227%2c9.5918-6.8447%2c1.6623-0.94835%2c4.5034-0.12664%2c2.3114%2c1.7848-3.0339%2c2.8443-5.6262%2c6.4002-6.1786%2c10.631-0.92788%2c5.3074%2c0.39912%2c10.69%2c2.7124%2c15.47%2c4.4468%2c9.3901%2c7.8854%2c19.996%2c5.6361%2c30.444-1.0432%2c4.644-4.1982%2c8.6454-8.0313%2c11.341-0.4847%2c0.29274-1.2499%2c0.27192-1.4134-0.39473z'/%3e%3cpath d='m726.73%2c389.63c-1.4562-2.6239-3.2238-5.2103-5.673-6.9945-2.3812-0.005-3.8508%2c2.9985-5.468%2c4.5721-1.134%2c2.11-2.5118%2c5.6386-5.3053%2c2.8796-4.4442-2.5928-5.2306-8.2748-5.202-12.958-0.27951-7.5908%2c2.777-14.674%2c5.4923-21.587%2c1.7275-4.3277%2c1.3019-9.1991%2c0.24806-13.634-1.3266-5.0918-5.4137-8.6231-8.5601-12.595%2c0.214-1.5365%2c4.235-0.69686%2c5.7483-0.40478%2c3.3588%2c0.85136%2c5.3664%2c3.8249%2c7.8703%2c5.9259%2c1.7818-0.53937%2c1.0545-4.1395%2c1.8839-5.833%2c0.0613-2.3821%2c3.233-5.5228%2c4.5407-2.1121%2c1.9588%2c2.1674-0.0626%2c6.4643%2c2.4686%2c7.8144%2c2.4113-0.89283%2c3.6009-3.5283%2c5.8666-4.72%2c2.2295-1.5204%2c5.3776-1.69%2c7.7781-0.49647%2c0.84484%2c2.2126-2.6402%2c4.0548-3.6496%2c5.9771-4.052%2c5.0056-5.4756%2c11.91-3.7401%2c18.112%2c1.3759%2c4.8649%2c3.8133%2c9.4058%2c4.6546%2c14.434%2c1.0126%2c5.6525%2c0.97903%2c11.589-0.48403%2c17.159-0.87455%2c3.3816-3.8021%2c5.6402-6.8258%2c7.0448-0.74602-0.69428-1.1395-1.7142-1.6436-2.583z'/%3e%3cpath d='M711.61%2c326.89c-3.36-2.46-4.47-4.81-4.47-9.46%2c0-2.38%2c0.44-3.67%2c2.01-5.83%2c2.31-3.2%2c1.89-4.21-1.38-3.27-5.26%2c1.51-7.77%2c0.13-7.95-4.35-0.08-2.19%2c0.38-3.12%2c3.33-6.66%2c2.36-2.84%2c3.22-4.33%2c2.75-4.8-0.46-0.46-3.25%2c1.96-8.98%2c7.79-4.57%2c4.65-9.71%2c9.4-11.42%2c10.56-9.84%2c6.64-19.24%2c7.67-23.53%2c2.56-2.2-2.61-2.08-4.08%2c0.46-5.66%2c1.17-0.72%2c3.14-2.38%2c4.39-3.69%2c2.95-3.07%2c11.74-9.41%2c16.1-11.61%2c3.54-1.79%2c4.38-3%2c2.08-3-2.98%2c0-12.54%2c6.22-19.79%2c12.88-2.13%2c1.97-5.2%2c4.16-6.81%2c4.87-3.62%2c1.6-10.73%2c2.19-13.89%2c1.15-2.23-0.74-6.3-4.58-6.3-5.95%2c0-0.36%2c0.93-1.16%2c2.06-1.77%2c1.13-0.6%2c3.16-2.07%2c4.5-3.24%2c5.8-5.09%2c16.79-10.33%2c25.51-12.16%2c2.77-0.58%2c1.75-1.98-1.34-1.84-5.99%2c0.26-17.88%2c5.83-24.98%2c11.69-8.32%2c6.86-20.87%2c6.21-24.91-1.29-0.7-1.29-1.11-2.5-0.91-2.69%2c0.19-0.19%2c2.66-0.93%2c5.49-1.65%2c3.06-0.77%2c9.12-3.28%2c14.91-6.17%2c9.11-4.54%2c11.81-5.51%2c18.08-6.52%2c2.82-0.45%2c2.97-1.83%2c0.23-2.15-3.53-0.42-8.94%2c1.35-18.5%2c6.05-12.28%2c6.04-15.72%2c7.08-22.19%2c6.7-5.9-0.36-9.23-1.87-14.02-6.4-3.13-2.97-7.57-10.51-6.7-11.38%2c0.21-0.21%2c1.65%2c0%2c3.2%2c0.45%2c1.72%2c0.51%2c6.65%2c0.85%2c12.59%2c0.86%2c8.31%2c0.02%2c10.52-0.2%2c14.95-1.48%2c7.41-2.14%2c17.26-7.15%2c24-12.18%2c12.89-9.64%2c23.4-13.51%2c36.8-13.57%2c12.37-0.05%2c20.24%2c2.81%2c27.21%2c9.88%2c2.36%2c2.39%2c4.37%2c3.94%2c4.7%2c3.61%2c0.31-0.31%2c0.65-4.49%2c0.75-9.29%2c0%2c0%2c3.64-0.35%2c4.41%2c0.67%2c0%2c7.79%2c0.09%2c8.4%2c1.22%2c8.4%2c0.74%2c0%2c1.53-0.76%2c2.02-1.94%2c1.06-2.55%2c4.98-6.04%2c9.17-8.16%2c9.05-4.59%2c24.71-4.73%2c37.29-0.34%2c5.3%2c1.86%2c11.18%2c5.18%2c16.78%2c9.5%2c5.62%2c4.32%2c17.11%2c10.1%2c23.9%2c12.03%2c6.87%2c1.95%2c18.98%2c2.44%2c25.19%2c1.03%2c2.56-0.58%2c4.96-1.06%2c5.34-1.06%2c2.29%2c0-1.61%2c7.63-6.19%2c12.1-8.37%2c8.18-19.26%2c8.14-34.58-0.12-9.55-5.14-20.97-7.95-20.97-5.15%2c0%2c0.58%2c0.6%2c0.97%2c1.49%2c0.97%2c3.32%2c0%2c9.73%2c2.23%2c18.67%2c6.47%2c9.67%2c4.6%2c15.1%2c6.54%2c18.32%2c6.54%2c2.34%2c0%2c2.41%2c1.45%2c0.23%2c4.65-2.31%2c3.41-6.23%2c5.1-11.77%2c5.09-5.29-0.02-8.23-1.18-12.96-5.11-7.91-6.58-27.62-13.92-26.86-10%2c0.15%2c0.78%2c1.1%2c1.26%2c3.13%2c1.57%2c6.86%2c1.05%2c14.91%2c4.89%2c23.15%2c11.06%2c2.54%2c1.91%2c5.18%2c3.79%2c5.85%2c4.19%2c1.13%2c0.66%2c1.15%2c0.86%2c0.26%2c2.53-1.48%2c2.76-5.21%2c4.9-9.25%2c5.32-5.23%2c0.54-9.78-1.02-14.49-4.96-9.94-8.32-19.31-14.34-22.31-14.34-2.45%2c0-1.35%2c1.35%2c2.97%2c3.64%2c5.68%2c3.01%2c11.52%2c7.08%2c15.82%2c11.03%2c2.03%2c1.88%2c4.32%2c3.74%2c5.08%2c4.15%2c1.8%2c0.96%2c1.73%2c2.37-0.25%2c4.96-2.02%2c2.64-5.36%2c3.8-9.69%2c3.34-8.64-0.91-15.38-5.08-25.97-16.07-4.14-4.29-7.83-7.8-8.21-7.8-1.41%2c0-0.58%2c1.91%2c2.15%2c4.97%2c3.38%2c3.78%2c4.03%2c5.91%2c2.75%2c8.98-1.13%2c2.72-3.01%2c3.35-6.87%2c2.31-3.95-1.07-4.57-0.1-1.98%2c3.12%2c3.86%2c4.81%2c3.29%2c10.7-1.44%2c14.75-1.47%2c1.25-3.01%2c2.28-3.43%2c2.28-0.41%2c0-1.45-1.07-2.32-2.38-3.04-4.62-5.71-4.59-8.67%2c0.08-1.03%2c1.63-1.9%2c2.95-1.93%2c2.94-0.04-0.01-1.43-1.01-3.08-2.23z'/%3e%3cpath d='M726.67%2c233.03%2c721.54%2c237.09%2c716.94%2c233.62%2c716.94%2c261.36%2c726.67%2c261.48z'/%3e%3cpath d='M694.89%2c204.25c-1.02%2c13.11-4.35%2c22.26-8.98%2c32.35l11.1-10.29%2c7.72%2c9.17%2c8.36-9.33%2c8.53%2c7.88%2c8.2-8.2%2c8.52%2c9.97%2c7.4-8.2%2c12.54%2c9c-4.55-10.09-10.71-18.64-9.94-32.84-12.15%2c9.03-41.02%2c10.66-53.45%2c0.49z'/%3e%3cpath d='M716.95%2c197.56c-4.46%2c0.08-9.16%2c0.14-13.39%2c0.97-2.93%2c0.58-5.59%2c1.53-7.81%2c3.1%2c0.36%2c8.53%2c41%2c12.09%2c51.9%2c0.16-2.29-1.67-5.09-2.66-8.17-3.26-4.07-0.79-8.57-0.87-12.84-0.94%2c0%2c2.34%2c0.02%2c4.69%2c0.02%2c7.04l-9.71-0.03v-7.04z'/%3e%3cpath d='M724.9%2c153.97%2c718.59%2c154.02%2c718.59%2c203.4%2c725.03%2c203.43z'/%3e%3cpath d='M724.89%2c155.24%2c722.48%2c178.88%2c746.8%2c190.76%2c734.49%2c174.3%2c751.3%2c168.85z'/%3e%3cpath d='M722.18%2c149.08c-3.69%2c0-6.42%2c1.38-6.42%2c3.02s2.73%2c3.03%2c6.42%2c3.03%2c6.4-1.39%2c6.4-3.03-2.71-3.02-6.4-3.02z'/%3e%3c/g%3e%3cg fill='%23f7e017'%3e%3cpath d='M711.05%2c563.82c3.99-1.32%2c6.26-3.74%2c7.89-8.4%2c0.81-2.32%2c1.36-4.73%2c1.22-5.36-0.34-1.49-2.06-1.41-3.96%2c0.17-1.3%2c1.09-1.46%2c1.64-1.09%2c3.86%2c0.95%2c5.6-1.04%2c6.99-11.64%2c8.13-1.05%2c0.11-4.09-0.07-6.77-0.4-5.04-0.63-6.84-0.13-5.01%2c1.39%2c0.55%2c0.46%2c1.95%2c1.08%2c3.11%2c1.37%2c2.83%2c0.73%2c13.22%2c0.24%2c16.25-0.76z'/%3e%3cpath d='M733.02%2c562.89c0.6-0.55%2c2.66-1.5%2c4.58-2.12%2c2.56-0.82%2c3.88-1.7%2c4.96-3.31%2c3.11-4.63%2c2.53-8.62-2.04-14-2.48-2.92-3.58-2.84-5.56%2c0.4-1.71%2c2.8-1.67%2c2.98%2c0.79%2c3.62%2c1.29%2c0.33%2c2.53%2c1.28%2c3.21%2c2.45%2c2.68%2c4.64%2c1.89%2c7.51-2.08%2c7.54-3.6%2c0.03-4.59%2c0.54-5.56%2c2.87-0.51%2c1.21-0.92%2c2.5-0.92%2c2.87%2c0%2c0.98%2c1.36%2c0.81%2c2.62-0.32z'/%3e%3cpath d='M725.81%2c557.65c0.68-1.84%2c0.92-5.15%2c0.84-11.9-0.05-5.14-0.25-9.5-0.45-9.7-0.6-0.6-3.56%2c1.31-3.95%2c2.54-0.2%2c0.64%2c0.13%2c2.12%2c0.73%2c3.28%2c0.92%2c1.79%2c1.04%2c3.46%2c0.76%2c10.47-0.36%2c8.86%2c0.22%2c10.35%2c2.07%2c5.31z'/%3e%3cpath d='M708.89%2c553.43c0.36-1.65%2c0.82-5.03%2c1.03-7.5s0.72-5.59%2c1.12-6.94c1.02-3.46-0.01-4.37-2.74-2.43l-2.03%2c1.45%2c0.42%2c4.97c0.39%2c4.48-0.32%2c12.83-1.35%2c16.07-0.28%2c0.86%2c0.12%2c0.64%2c1.25-0.68%2c0.91-1.06%2c1.95-3.29%2c2.3-4.94z'/%3e%3cpath d='m693.88%2c555.84c3.6514-3.0546%2c3.2318-8.2704%2c4.04-12.52-0.0835-2.8248%2c1.8038-6.2116%2c0.58588-8.6828-3.4119%2c0.62408-5.5147%2c3.8554-3.7684%2c7.0746%2c0.14546%2c3.7382%2c0.0129%2c7.8076-1.9089%2c11.113-1.5698%2c2.1618-6.5419%2c1.6234-6.3131-1.4406%2c1.2477-4.6065-4.2718-2.3648-6.4264-1.1571-1.6657%2c1.1597-5.1825%2c1.2451-3.9601-1.6569-0.80663-3.8664-5.7798-1.4479-8.4816-1.4651-2.552-0.0466-0.21096-5.1708-3.8736-4.271-6.8058-0.53675-14.319%2c0.0602-20.21-4.0515-3.4486-1.6577-2.937-5.8052-1.1415-8.4888%2c2.1442-3.6651%2c2.7555-8.249%2c6.1588-11.093%2c3.369-3.231-3.1775-1.8666-4.6517-0.77788-3.2819%2c1.7962-0.23302%2c6.4226-2.9192%2c8.9886-1.5695%2c2.6611-3.6362%2c6.3361-7.2698%2c5.8296-5.2398-0.9908-8.2605-5.8651-12.017-9.1317-3.218-0.64222-1.4087%2c5.2218%2c0.25284%2c6.4543%2c3.2878%2c2.4618%2c7.1291%2c4.2558%2c11.092%2c5.3187%2c3.9439-0.63072%2c4.0717%2c4.5336%2c7.4444%2c5.3437%2c6.1873%2c2.883%2c13.083%2c3.7467%2c19.833%2c4.0986%2c2.6511%2c0.22107%2c1.16%2c4.9425%2c4.6458%2c4.0096%2c1.948%2c0.50493%2c6.3478-0.72487%2c6.5682%2c1.5381-2.9527%2c3.5059%2c2.8341%2c3.4276%2c4.9757%2c2.7999%2c2.742-0.41905%2c6.2461-1.4668%2c6.9708%2c2.2924%2c2.289%2c2.413%2c6.4921%2c2.057%2c9.2796%2c0.67619%2c0.39162-0.22691%2c0.75972-0.49483%2c1.0937-0.80043z'/%3e%3cpath d='M634.12%2c525.57c1.11-1.41%2c2.77-4.26%2c3.69-6.34%2c0.91-2.09%2c2.28-4.46%2c3.03-5.27%2c1.76-1.9%2c0.78-3.07-2.06-2.44-1.5%2c0.33-2.11%2c0.88-2.36%2c2.18-0.85%2c4.24-2.39%2c8.58-3.76%2c10.6-2.48%2c3.66-2.54%2c3.81-1.52%2c3.81%2c0.53%2c0%2c1.87-1.14%2c2.98-2.54z'/%3e%3cpath d='M596.66%2c502.09c-2.8%2c0-2.92%2c1.77-0.19%2c2.72%2c1.32%2c0.46%2c2.44%2c1.57%2c3.34%2c3.38%2c2.66%2c5.29%2c4.22%2c6.23%2c11.28%2c6.84l4.53%2c0.41%2c0.22%2c2.75c0.11%2c1.52%2c0.47%2c2.78%2c0.82%2c2.78s2.1-0.76%2c3.87-1.66c3.32-1.68%2c6.47-5.6%2c6.47-8.03%2c0-1.59-2.65-3.31-5.06-3.31-1.07%2c0-3.11%2c0.86-4.72%2c2.03-5.04%2c3.65-10.43%2c2.91-13.38-1.84-2.42-3.92-4.95-6.07-7.18-6.07zm24.46%2c9.75c1.34%2c0%2c1.67%2c0.99%2c0.94%2c2.88-0.5%2c1.3-2.13%2c1.34-2.62%2c0.06-0.58-1.51%2c0.23-2.94%2c1.68-2.94z'/%3e%3cpath d='M810.84%2c505.69c-1.83%2c0.07-2.37%2c0.47-3.53%2c2.19-1.9%2c2.82-2.09%2c8.93-0.34%2c11.09%2c1.09%2c1.34%2c1.25%2c1.37%2c3.56%2c0.41%2c3.22-1.35%2c3.76-1.3%2c3.75%2c0.43-0.02%2c4.42-6.36%2c12.94-13%2c17.47-1.79%2c1.22-3.39%2c2.58-3.56%2c3.03-0.48%2c1.26%2c1.98%2c0.98%2c5-0.56%2c4.12-2.1%2c9.53-7.62%2c11.75-11.97%2c1.76-3.47%2c2.01-4.65%2c2.22-10.72%2c0.19-5.59%2c0.04-7.23-0.91-9.09-1.06-2.09-1.4-2.28-4.06-2.28-0.32%2c0-0.61-0.01-0.88%2c0zm0.22%2c3.9c1.38%2c0%2c1.62%2c0.31%2c1.78%2c2.29%2c0.14%2c1.64-0.15%2c2.64-1.06%2c3.46-1.24%2c1.12-1.34%2c1.11-2.44-0.56-1.54-2.36-0.59-5.19%2c1.72-5.19z'/%3e%3cpath d='M780.7%2c552.27c5.85-2.88%2c9.3-6.12%2c11.52-10.81%2c1.05-2.23%2c1.91-4.33%2c1.91-4.69%2c0-0.81-2.88-2.15-4.61-2.15-1.72%2c0-2.07-1.19-1.33-4.48%2c0.72-3.21-0.15-7.23-1.56-7.23-0.51%2c0-1.41%2c0.75-2.01%2c1.66-0.92%2c1.41-0.97%2c2.01-0.29%2c4.06%2c1%2c3.04%2c0.21%2c5.31-2.51%2c7.25-1.29%2c0.92-2%2c1.98-2%2c3.01%2c0%2c0.87%2c0.11%2c1.58%2c0.24%2c1.58%2c0.14%2c0%2c1.56-0.74%2c3.16-1.63l2.92-1.63%2c1.72%2c1.35c0.94%2c0.74%2c1.72%2c1.95%2c1.72%2c2.69%2c0%2c3.56-10.15%2c9.54-17.12%2c10.1-3.71%2c0.3-4.34%2c0.17-5.63-1.11-1.05-1.05-1.35-1.93-1.09-3.17%2c0.2-0.95%2c0.56-2.68%2c0.8-3.84%2c0.64-3.1-0.69-2.68-2.99%2c0.94-1.89%2c2.99-2.45%2c6.18-1.39%2c7.86%2c0.87%2c1.37%2c6.65%2c2.68%2c10.74%2c2.43%2c2.57-0.15%2c5.11-0.87%2c7.8-2.19z'/%3e%3cpath d='M819.74%2c530.49c3.68-3.67%2c5.24-8.14%2c5.26-15.05l0.01-5.19%2c3.04-1.44c3.95-1.88%2c7.69-5.62%2c7.69-7.7%2c0-2.14-0.95-2.03-2.67%2c0.3-1.25%2c1.69-2.92%2c2.71-9.03%2c5.52-1.54%2c0.71-1.64%2c1.09-1.99%2c7.55-0.41%2c7.45-1.42%2c10.24-5.58%2c15.33-2.55%2c3.1-2.64%2c3.51-0.87%2c3.51%2c0.73%2c0%2c2.59-1.27%2c4.14-2.83z'/%3e%3cpath d='M779.66%2c526.33c0.35-1.07-1.68-1.83-2.56-0.96-0.37%2c0.37-0.47%2c1.01-0.22%2c1.42%2c0.58%2c0.93%2c2.42%2c0.62%2c2.78-0.46z'/%3e%3cpath d='M834.93%2c512.02c0.36-1.07-1.68-1.83-2.55-0.96-0.38%2c0.38-0.48%2c1.02-0.23%2c1.43%2c0.58%2c0.93%2c2.42%2c0.62%2c2.78-0.47z'/%3e%3cpath d='m768.41%2c473.28c-1.4296%2c0.68071-2.1713%2c2.2244-3.165%2c3.4028-0.71516%2c0.48622-0.14203%2c0.9405%2c0.26976%2c1.3988%2c2.5225%2c2.7171%2c3.5898%2c6.3866%2c4.7883%2c9.8088%2c1.177%2c4.0402%2c2.659%2c8.3784%2c1.4283%2c12.588-0.48423%2c1.6123-1.7525%2c3.2813-3.6466%2c2.746-3.0304-0.18916-6.0122-0.99351-9.0512-0.96152-2.705%2c0.14095-4.7956%2c2.6024-7.5614%2c2.3341-1.767%2c0.11638-1.6925-3.618-3.3341-2.6194-0.8128%2c1.9472-0.41254%2c4.1196-0.50932%2c6.1787%2c0.30628%2c0.29508%2c1.165%2c0.0377%2c1.6799%2c0.1242h5.4451c0.38492%2c1.8802%2c0.33677%2c4.0358%2c1.6875%2c5.5312%2c1.8899%2c0.67214%2c4.0159%2c0.0917%2c5.8116-0.64309%2c1.9256-0.89569%2c2.1834-3.2112%2c2.7274-5.0153%2c0.57858-1.9384%2c3.117-1.4302%2c4.6149-2.1913%2c3.6648-1.0697%2c6.0666-4.8789%2c5.852-8.6268-0.23686-5.722-2.4198-11.105-4.0759-16.521-0.83346-2.386-1.4104-4.875-2.377-7.2045-0.11331-0.20034-0.34573-0.36894-0.58432-0.32903zm-9.07%2c32.72c2.0364-0.13276%2c2.9212%2c2.3697%2c2.4899%2c4.0293-0.76215%2c2.2555-3.5349%2c0.80928-4.0958-0.81602-1.0301-1.4517-0.39353-3.4044%2c1.6058-3.2133z'/%3e%3cpath d='M683.94%2c487.22c-0.91-0.02-1.93%2c0.32-2.94%2c1.03-5.31%2c3.72-6.67%2c8.12-3.06%2c9.84%2c2.65%2c1.27%2c1.98%2c2.76-2.19%2c4.85-5.97%2c2.98-11.24%2c2.61-21.25-1.53-2.46-1.02-3.1-0.63-2.53%2c1.62%2c0.55%2c2.21%2c2.57%2c3.42%2c7.59%2c4.56%2c5.4%2c1.24%2c11.93%2c0.84%2c16.13-0.97%2c2.05-0.88%2c4.48-2.73%2c6.53-4.96l3.25-3.57%2c3.78%2c0.47c4.66%2c0.57%2c4.75%2c0.62%2c4.75%2c2.85%2c0%2c1.77%2c0.1%2c1.81%2c4.38%2c2.21%2c2.41%2c0.23%2c5.58%2c0.44%2c7.06%2c0.44%2c1.89%2c0.01%2c2.96%2c0.34%2c3.59%2c1.22%2c0.84%2c1.17%2c1.34%2c1.23%2c8.38%2c0.6%2c6.58-0.6%2c7.87-0.55%2c10.84%2c0.46%2c2.11%2c0.72%2c4.43%2c1.01%2c6.19%2c0.82%2c5.04-0.57%2c11.99-4.69%2c13-7.72%2c0.12-0.37%2c1.95-1.02%2c4.06-1.44%2c5.09-1.02%2c5.31-2.13%2c0.56-2.72-2.06-0.26-5.15-1.01-6.87-1.69-1.73-0.68-4.09-1.25-5.25-1.25-2.56%2c0-4.97%2c1.6-4.97%2c3.25%2c0%2c1.08%2c0.38%2c1.19%2c3.41%2c0.88%2c2.85-0.29%2c3.68-0.13%2c5.18%2c1.06%2c0.99%2c0.78%2c1.65%2c1.7%2c1.44%2c2.03-0.67%2c1.09-6.62%2c3.8-9.25%2c4.22-1.76%2c0.28-3.18%2c0.09-4.56-0.62-2.31-1.2-5.71-1.38-6.35-0.35-0.27%2c0.45-1%2c0.16-2-0.78l-1.56-1.47-3.53%2c1.47c-3.59%2c1.49-4.91%2c1.43-4.91-0.28%2c0-0.78-1.05-0.87-6.34-0.53-5.83%2c0.38-6.44%2c0.28-7.53-0.94-1.01-1.12-1.03-1.51-0.31-2.66%2c0.66-1.06%2c0.66-1.52%2c0.03-2.15s-1.45-0.62-3.75%2c0c-5.8%2c1.55-7.44%2c0.68-7.44-3.85%2c0-2.72-1.56-4.37-3.56-4.4zm-1.44%2c4.16c0.31%2c0%2c0.57%2c0.19%2c0.97%2c0.59%2c0.51%2c0.51%2c0.78%2c1.4%2c0.56%2c1.97-0.52%2c1.35-2.98%2c1.3-3.5-0.06-0.25-0.66%2c0.07-1.4%2c0.81-1.94%2c0.52-0.38%2c0.85-0.57%2c1.16-0.56z'/%3e%3cpath d='M672.1%2c495.6c3.53-2.24%2c3.45-2.07%2c3.96-8.29%2c0.35-4.39%2c0.29-4.72-0.9-4.72-1.73%2c0-2.63%2c1.9-2.63%2c5.52%2c0%2c2.32-0.36%2c3.36-1.6%2c4.59-2.94%2c2.94-10.24%2c1.6-11.16-2.05-0.31-1.25%2c0.09-2.38%2c1.62-4.55%2c3.19-4.53%2c2.47-5.64-1.44-2.2-2.69%2c2.35-3.17%2c2.42-2.66%2c0.39%2c0.47-1.87-0.51-2.61-2.7-2.06-1.12%2c0.28-1.73%2c0.98-2%2c2.34-0.26%2c1.33-0.87%2c2.07-1.93%2c2.33-1.77%2c0.45-4.79-1.23-4.79-2.66%2c0-1.06%2c4.52-6.58%2c10.32-12.6%2c2.19-2.28%2c3.98-4.4%2c3.98-4.72s-1.17-0.58-2.6-0.58c-2.09%2c0-2.6%2c0.23-2.6%2c1.2%2c0%2c0.66-2.92%2c4.49-6.5%2c8.52-7.46%2c8.4-8.08%2c10.15-4.39%2c12.39%2c2.97%2c1.82%2c6.78%2c1.68%2c9.77-0.35l2.42-1.65v2.99c0%2c3.82%2c0.76%2c5.19%2c3.76%2c6.78%2c3.77%2c1.99%2c8.33%2c1.75%2c12.07-0.62z'/%3e%3cpath d='m828.66%2c443.69c-2.7668%2c1.6519-0.60168%2c5.1236-0.18254%2c7.4288-1.1299%2c3.146-5.1718%2c3.9934-8.1183%2c4.5774-4.1736%2c0.69135-7.1308%2c4.1827-8.7186%2c7.8921-0.86037%2c2.4089-2.9366%2c6.1445-5.1993%2c2.4767-1.9667-1.9933-5.5819-3.5732-7.9078-1.2462-1.7668%2c1.6824-2.2148%2c4.1568-2.8735%2c6.4025-1.0427-1.7262-1.5104-4.2966-3.7201-4.8424-3.5276%2c0.49628-2.2527%2c4.9439-0.594%2c6.7779%2c1.5076%2c2.1378%2c2.9558%2c4.9578%2c1.4779%2c7.4969-1.303%2c3.0516-5.8095%2c5.11-8.4565%2c2.4995-2.4722-1.305-0.81896-5.9649-3.254-6.221-1.204%2c0.86977-1.3032%2c5.7458-3.2303%2c3.1024-1.3906-2.2586-0.65318-5.3523-2.3547-7.3843-2.0106%2c0.24966-3.6272%2c3.7115-2.9583%2c5.5709%2c2.6825%2c3.6176%2c3.7849%2c8.1558%2c4.8314%2c12.467%2c0.65196%2c1.7264-0.0951%2c5.2267%2c1.5199%2c5.9106%2c1.1196-2.7787%2c0.0791-5.9306%2c0.96044-8.7358%2c2.6182-0.32901%2c5.5303%2c0.86591%2c8.2761%2c0.23077%2c3.9286-0.50981%2c6.9646-3.825%2c8.3424-7.3555%2c0.41644-2.6542-0.079-5.3476-0.15274-8.0168%2c3.1034%2c0.48084%2c6.3281%2c0.47101%2c9.3135%2c1.4788%2c1.4804%2c2.2709-0.46974%2c5.4485-0.87913%2c7.9295-1.5586%2c5.0524-5.5163%2c8.7194-9.366%2c12.097-1.6101%2c0.95299-1.8264%2c3.4782%2c0.55162%2c2.118%2c5.1735-2.2122%2c9.0295-6.8975%2c11.248-11.969%2c1.619-3.9019%2c0.31744-8.2474%2c1.3744-12.238%2c1.5617-2.9959%2c5.3215-2.3646%2c8.1035-2.3553%2c2.879-0.10959%2c5.3363-3.464%2c4.3747-6.2619-0.91607-3.2468%2c2.519-4.8109%2c4.8661-5.9714%2c3.1119-1.5702%2c5.4981-4.7591%2c5.2571-8.3583-0.12787-1.8402-0.0371-5.3318-2.5312-5.5zm-11.031%2c18.75c3.3336%2c0.88568-0.60342%2c7.2524-2.375%2c3.2188-0.54528-1.539%2c0.75001-3.2741%2c2.375-3.2188zm-15.47%2c4.56c4.3385-0.25338%2c2.7806%2c6.0812-0.88479%2c3.2048-1.9006-0.95441-1.2718-3.3229%2c0.88479-3.2048z'/%3e%3cpath d='M645.1%2c491.48c0.12-0.63-0.2-1.08-0.77-1.08-1.21%2c0-1.94%2c1.06-1.37%2c1.98%2c0.59%2c0.95%2c1.89%2c0.41%2c2.14-0.9z'/%3e%3cpath d='M695.94%2c485.8c0-0.93-0.35-1.28-1.13-1.13-1.7%2c0.32-1.89%2c2.48-0.22%2c2.48%2c0.93%2c0%2c1.35-0.42%2c1.35-1.35z'/%3e%3cpath d='m633.03%2c455.28c-2.029-0.41667-3.3053%2c1.3004-4%2c2.9375-1.5174%2c2.5503-3.3705%2c5.1587-6.0931%2c6.5091-1.9578%2c0.54422-4.0937-0.20046-5.7819-1.2102-2.0147-1.0029-1.5567-3.4259-2.4202-5.1005-1.457-1.1443-4.0407%2c0.4921-3.9834%2c2.2714-0.16115%2c2.3862%2c2.0713%2c3.7641%2c3.9242%2c4.6869%2c1.5747%2c0.96445%2c3.8577%2c1.5009%2c4.4871%2c3.4529-0.0437%2c1.6587%2c0.6235%2c3.5571%2c2.6435%2c2.9166%2c2.2597-0.0372%2c2.8449%2c2.7155%2c1.9326%2c4.3671-0.92932%2c1.8613-1.5564%2c4.0416-1.1119%2c6.1154%2c1.08%2c0.90934%2c2.1827-1.5301%2c2.9652-2.2268%2c0.53138-0.70851%2c1.0628-1.417%2c1.5941-2.1255%2c3.9984%2c0.21679%2c7.9929%2c0.72673%2c12.001%2c0.5846%2c2.8505-0.0516%2c5.2778-1.8114%2c7.0906-3.875%2c2.5633-2.6802%2c4.6693-5.8294%2c7.597-8.142%2c2.0839-0.50859%2c0.96439-4.4336-1.2124-3.3001-1.9608%2c0.7355-2.578%2c2.9513-3.9368%2c4.3632-2.3146%2c2.8028-4.6762%2c5.6471-7.5941%2c7.8434-2.1245%2c0.8812-4.5705%2c0.49663-6.7532-0.00022-0.91062-0.79618%2c1.8087-1.445%2c2.188-2.33%2c1.252-1.2507%2c2.7385-2.438%2c3.4639-4.0814-0.69398-1.5148-2.8167-1.6373-4.3126-1.6678-3.6856%2c0.44249-6.5007%2c3.5363-10.223%2c3.8277-2.8253%2c0.099-1.355-2.9607-0.0813-4.0046%2c2.4916-2.9589%2c5.1844-5.7458%2c7.7858-8.6074%2c0.73816-0.88845%2c3.4086-1.732%2c1.7006-2.98-0.59723-0.21503-1.2431-0.21478-1.8694-0.22424zm1.8125%2c14.969c1.8586%2c1.0454-1.1858%2c2.7567-2.4681%2c2.5229-1.6823%2c0.50416-1.7125-1.2116-0.2183-1.5533%2c0.8401-0.43711%2c1.7274-0.89316%2c2.6864-0.96961zm-5.7188%2c3.9062c1.0579-0.0202%2c3.2748%2c0.99623%2c1.1931%2c1.6469-1.4494%2c1.1234-3.0867-1.1434-1.1931-1.6469z'/%3e%3cpath d='M674.15%2c476.74c0-1.41-2.53-1.21-2.81%2c0.22-0.18%2c0.92%2c0.11%2c1.14%2c1.29%2c0.97%2c0.84-0.12%2c1.52-0.65%2c1.52-1.19z'/%3e%3cpath d='M786.2%2c466.82c0.26-1.35-1.62-2.25-2.61-1.26s-0.08%2c2.87%2c1.26%2c2.61c0.62-0.12%2c1.23-0.73%2c1.35-1.35z'/%3e%3cpath d='M611.82%2c453.09c1.76-1.51%2c1.78-1.61%2c1.02-4.93-1.08-4.65-1.01-5.15%2c0.76-5.59%2c2.24-0.57%2c7.93%2c2.48%2c9.19%2c4.92%2c0.98%2c1.89%2c0.95%2c2.02-0.71%2c3.56-1.79%2c1.65-1.78%2c3.58%2c0.01%2c3.58%2c1.48%2c0%2c5.57-3.87%2c5.57-5.26%2c0-1.93-4.54-6.49-8.13-8.16-2.22-1.04-4.44-1.52-7.01-1.53-4.6%2c0-5.22%2c0.99-3.98%2c6.34%2c1.46%2c6.27-0.52%2c7.12-5.57%2c2.39-3.75-3.51-5.23-7.16-5.21-12.91%2c0.01-6.17%2c2.37-9.22%2c7.69-9.94%2c3.53-0.47%2c3.44-1.3-0.19-1.84-5.3-0.8-9.78%2c2.74-11.48%2c9.06-1.89%2c7.01%2c2.44%2c15.55%2c10.1%2c19.95%2c4.01%2c2.3%2c5.61%2c2.37%2c7.94%2c0.36z'/%3e%3cpath d='M820.66%2c445.4c0.43-0.43%2c0.78-1.4%2c0.78-2.15s0.73-2.36%2c1.62-3.57c0.9-1.21%2c1.63-2.45%2c1.63-2.75%2c0-1.23-2.03-1.19-3.63%2c0.08-1.64%2c1.28-2.87%2c1.31-2.87%2c0.06%2c0-0.31%2c0.78-0.95%2c1.74-1.42%2c2.38-1.16%2c2.58-2.31%2c0.57-3.23-2.58-1.17-5.17%2c0.97-5.44%2c4.5-0.17%2c2.36%2c0.02%2c2.77%2c1.84%2c3.84%2c1.66%2c0.98%2c1.97%2c1.5%2c1.69%2c2.9-0.48%2c2.43%2c0.53%2c3.28%2c2.07%2c1.74z'/%3e%3cpath d='M840.29%2c443.18c1.44-1.29%2c2.61-2.76%2c2.61-3.25s1.24-1.79%2c2.76-2.88c4.31-3.1%2c5.26-6.23%2c3.33-11.04-0.75-1.89-3.11-4.5-8.24-9.12-3.94-3.56-7.57-6.47-8.04-6.47-1.4%2c0-1.15%2c5.15%2c0.27%2c5.6%2c2.56%2c0.82%2c4.11%2c1.87%2c8.14%2c5.5%2c4.68%2c4.23%2c6.84%2c8.18%2c5.66%2c10.38-1.13%2c2.13-2.63%2c1.47-6.76-2.96-2.17-2.33-4.32-4.23-4.76-4.23-0.48%2c0.01-0.82%2c0.85-0.82%2c2.03%2c0%2c1.48%2c0.79%2c2.89%2c2.93%2c5.27%2c3.49%2c3.88%2c3.83%2c6.21%2c1.21%2c8.27-0.94%2c0.74-1.91%2c1.35-2.15%2c1.35-0.23%2c0-1-1.16-1.7-2.57-1.46-2.96-10.39-12.39-11.73-12.39-0.61%2c0-0.91%2c0.76-0.91%2c2.26%2c0%2c1.81%2c0.36%2c2.45%2c1.8%2c3.19%2c1.77%2c0.92%2c6.15%2c5.33%2c10.55%2c10.65%2c1.26%2c1.52%2c2.5%2c2.75%2c2.77%2c2.76%2c0.26%2c0%2c1.65-1.06%2c3.08-2.35z'/%3e%3cpath d='M849.05%2c418.11c-0.58-1.87-12.56-14.2-13.79-14.2-0.64%2c0-0.84%2c0.76-0.69%2c2.72%2c0.17%2c2.38%2c0.43%2c2.79%2c2.07%2c3.22%2c1.02%2c0.27%2c4.18%2c2.75%2c7.01%2c5.5%2c2.82%2c2.75%2c5.3%2c4.84%2c5.5%2c4.63%2c0.2-0.2%2c0.16-1.04-0.1-1.87z'/%3e%3cpath d='m777.5%2c556.89a1.7806%2c1.6322%2c0%2c1%2c1%2c-3.5612%2c0%2c1.7806%2c1.6322%2c0%2c1%2c1%2c3.5612%2c0z'/%3e%3cpath d='m783.79%2c554.79a1.7806%2c1.6322%2c0%2c1%2c1%2c-3.5612%2c0%2c1.7806%2c1.6322%2c0%2c1%2c1%2c3.5612%2c0z'/%3e%3c/g%3e%3c/svg%3e";

var img$i = "data:image/svg+xml,%3csvg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1005 567'%3e%3cpath d='M0 0h1005v567H0z' fill='white' fill-rule='evenodd'/%3e%3cpath d='M0 378h1005v189H0zM0 0h1005v189H0z' fill='%230047ab' fill-rule='evenodd'/%3e%3cpath d='M463.041 354.917l-.035.035.8 5.406a2.833 2.833 0 00-3.418 1.5c-1 2.032-.148 3.565 1.813 4.57l2.617 1.29 4.812-9.417-1.917-1.012-1.884 3.837h-.069l-.419-5.058-2.3-1.15zm.453 7.22a2.492 2.492 0 011.29.28l.28.139-1.36 2.581-.279-.14c-.873-.5-1.444-1.027-.942-2.092a1.356 1.356 0 011.011-.768zm-8.872-2.3l1.286-1.875-2.9-1.943 1-1.434 2.811 1.875 1.592-2.376-2.965-1.943 1-1.5 4.773 3.18-5.928 8.852-4.71-3.18 1-1.44 2.964 1.874m-1.91-12.444v.035l-2.617 2.965-.766-.628c-1.723-1.524-3.41-1.449-4.849.21-1.592 1.874-1.007 3.48.8 4.987l2.163 1.883 6.871-8.056zM447 350.974a1.782 1.782 0 011.464.594l.314.279-1.883 2.163-.35-.176c-.763-.652-1.168-1.328-.383-2.266a1.6 1.6 0 01.838-.594zm-7.4-.921l-1.438-1.59 4.425-3.99c.937-.871 2.245-2.244 1-3.556-1.222-1.373-2.682-.195-3.684.637l-4.34 3.99-1.438-1.6 4.71-4.27c1.874-1.724 4.12-2.159 6.082 0 2.026 2.16 1.286 4.336-.633 6.083l-4.622 4.27m-4.146-20.019a2.467 2.467 0 00-.454.035 3.267 3.267 0 00-1.29.523 2.437 2.437 0 00-1.047 3.035 2.36 2.36 0 00-2.267.454c-1.722 1.155-1.643 2.606-.488 4.325l1.5 2.163 8.685-6-1.884-2.72a3.585 3.585 0 00-2.755-1.815zm.14 2.268c.642-.053 1.109.445 1.534 1.081l.28.35v.068l-2.269 1.5-.174-.28c-.48-.808-1.071-1.76-.069-2.475a1.468 1.468 0 01.7-.244zm-3.105 3.069a1.389 1.389 0 011.046.732l.105.21-2.023 1.43-.174-.175c-.436-.652-.571-1.314.28-1.883a1.282 1.282 0 01.766-.313zm-.148-9.818l-1.438-2.684 1.5-.848 2.535 4.558-9.352 5.056-1.068-1.87 7.826-4.208m-1.591-7.545l.785 2.026-9.7 4.275-.85-2.026 9.79-4.275m-10.988-7.322a3.4 3.4 0 00-.349 2.68 3.512 3.512 0 004.556 1.874 3.264 3.264 0 00.5-6.15l2.31-.714a5.348 5.348 0 011.438 2.154 5.6 5.6 0 01-10.659 3.427 5.814 5.814 0 01-.2-2.534l2.377-.721m5.087-14.222l-9.94 6 .314 1.674 11.44 2.3-.419-2.232-2.3-.523h-.07l-.7-3.767 2.093-1.221zm-3.14 4.395l.42 2.511-3.977-.487zm-2.964-24.206a5.038 5.038 0 00-4.639 4.848L414 284.53l10.463.871.28-3.034a5.124 5.124 0 00-4.813-5.72 6.129 6.129 0 00-1.117 0zm.176 2.372a4.816 4.816 0 01.731 0c1.9.152 3.091 1.18 2.895 3.557v.35l-6.348-.524.07-.349c.133-1.907 1.026-2.9 2.65-3.034zm-1.513-8.272l2.245.414.72-3.335 1.721.348-.633 3.336 2.814.632.719-3.466 1.743.283-1.155 5.647-10.345-2.159 1.068-5.58 1.81.348-.72 3.467m4.077-13.933l2.18.854 1.221-3.188 1.656.638-1.22 3.18 2.681 1 1.286-3.247 1.656.63-2.091 5.274-9.941-3.834 2.18-5.273 1.657.563-1.286 3.337m10.115-5.385l1.371-2.681 1.656.787-2.376 4.62-9.482-4.837 1-1.875 7.827 3.99m2.964-16.614a1.854 1.854 0 00-1.656.787 1.38 1.38 0 00.065 1.808c1.439 1 3.466-2.964 6.365-.781a3.455 3.455 0 01.72 5.055 4.022 4.022 0 01-3.685 1.5l-.195-1.936a2.144 2.144 0 002.376-.637 1.388 1.388 0 00-.349-2.026c-.85-.63-1.722 0-2.53.5-1.22.787-2.462 1.223-3.77.2a3.074 3.074 0 01-.633-4.425 4.542 4.542 0 012.747-1.719l.566 1.651m4.713-9.361l-1.15 1.22 4.847 10.676 1.57-1.64-1.012-2.162.035-.07 2.685-2.721 2.163.907 1.57-1.64zm1.64 3.068h.07v.036l3.313 1.5-1.64 1.744zm11.262-2.468l2.377-1.876 1.068 1.352-4.056 3.27-6.67-8.26 1.723-1.374 5.494 6.888m6.735-6.825l.065-.062-1.809-7.327 2.027-1.217L461.336 222l-1.067.63-9.418-6.953 1.962-1.223 6.082 4.622m7.773-12.54l-1.5.732.559 11.65 2.022-.942-.069-2.372h.035L471.2 214l1.64 1.64 2.162-.838zm.419 3.487l2.581 2.652-2.162.94zm10.882-7.115a6.53 6.53 0 00-1.15.243l-2.9.769 2.964 10.219 2.93-.837a5.193 5.193 0 003.663-6.592 5.053 5.053 0 00-5.512-3.8zm.523 2.162a2.708 2.708 0 012.582 2.338c.588 1.83.01 3.38-2.3 4.01l-.28.105-1.814-6.14.35-.138a4.763 4.763 0 011.464-.175zm12.767-5.3c-.2 0-.39.01-.594.035A5.6 5.6 0 00492.2 210.9a5.6 5.6 0 00-.942-11.127zm-.244 2.372a3.164 3.164 0 013.348 2.755c.13 1.434-.886 3.378-2.477 3.663-1.666.215-3.169-1.428-3.383-2.86a3.13 3.13 0 012.511-3.558zm9.138-2.86l-.14 10.673h2.163v-4.291h.07l2.616 4.29 2.581.069v-.034l-3.035-4.569a2.771 2.771 0 002.268-2.9c.065-2.249-1.448-3.182-3.628-3.244zm2.092 1.883h.28c1.025 0 1.814.243 1.814 1.465 0 1.155-.78 1.43-1.85 1.43h-.209l-.035.035zm20.415 2.391l-.567 2.25 3.333.781-.413 1.808-3.334-.847-.633 2.745 3.4.937-.419 1.724-5.49-1.44 2.528-10.29 5.58 1.373-.435 1.814-3.466-.855m7.98 0l1.435.57 2.617 9.069h.068l2.678-6.586 1.964.787L535.5 217.4l-1.44-.569-2.679-9.07-2.661 6.737-2.026-.781 4.058-10.14m14.186 16.893l2.533 1.595-.937 1.5-4.426-2.68 5.642-9.068 1.814 1.156-4.627 7.456m12.873-2l-10.22 5.825 1.71 1.36 2.093-1.15.034.034 2.965 2.442-.732 2.232 1.813 1.43 3.627-11.092zm-1.64 3.14l-1.22 3.453-1.779-1.43zm17.616 13.5l-11.372 2.965 1.291 1.814 2.372-.593h.035l2.232 3.138-1.29 2.024 1.29 1.813 6.384-9.8zm-2.372 2.616l-2.093 3.035-1.36-1.884zm7.555 14.642l-7.172.715-.284-.63 4.839-5.146v-.061l-6.3 2.092-1-1.941 10.57-3.25.72 1.374-4.99 5.58 7.39-.786.72 1.373-9.07 6.368-.937-1.943 5.492-3.683m5.19 6.976l-2.183.787 1.072 3.18-1.725.569-1.065-3.186-2.684.855 1.133 3.4-1.72.565-1.808-5.428 10.007-3.4 1.87 5.424-1.72.57-1.155-3.4m4 6.844l-10.36 2.163.42 2.162 4.115-.942h.07l-3.628 3.558.488 2.511.07.035 3.768-3.907a2.759 2.759 0 003.313 1.5c2.243-.435 2.84-2.1 2.337-4.255zm-1.36 2.582v.173c.224 1.025.21 1.9-1.012 2.093-1.178.218-1.619-.432-1.813-1.5v-.21zm-7.084 11.15l-.194-2.092 10.507-1.221.28 2.092-10.57 1.222m8.236 10.311a3.1 3.1 0 001.072-2.464 3.626 3.626 0 10-6.083 2.53l-2.461.065a6.616 6.616 0 01-.637-2.529 5.436 5.436 0 015.43-5.494 5.5 5.5 0 015.71 5.363 4.828 4.828 0 01-.564 2.463l-2.467.066m-7.838 1.976l-.208 2.233 2.057 1.15-.487 3.837-2.3.489-.278 2.337 11.3-2.826.21-1.639zm3.559 4.36l3.348 1.5v.1l-3.628.766zm-3.193 26.1a3.129 3.129 0 001.936-1.808 3.443 3.443 0 00-2.16-4.426 3.527 3.527 0 00-4.553 1.658 3.828 3.828 0 00.195 2.746l-2.31-.848a6.433 6.433 0 01.285-2.6 5.371 5.371 0 017.1-2.963 5.485 5.485 0 013.338 7.1 6.1 6.1 0 01-1.5 2.094l-2.317-.939m-1.764 5.71l-2.026-1.067-1.656 2.964-1.507-.782 1.573-3.03-2.528-1.373-1.724 3.182-1.507-.849 2.684-5.061 9.353 5.061-2.684 4.99-1.59-.849 1.657-3.12m-2.07 7.763l-.855 1.223-9.414.278-.067.068 5.8 4.208-1.283 1.724-8.7-6.368.854-1.222 9.414-.346h.069l-5.867-4.275 1.284-1.724 8.768 6.457m-18.947 6.016l1.506-1.59 6.363 6.143 1.507-1.657 1.283 1.223-4.554 4.776-1.288-1.212 1.5-1.591-6.368-6.083m-3.1 3.131l-1.675 1.29 2.76 3.353v.07l-4.85-1.605-1.953 1.64.035.07 5.2 1.43a2.762 2.762 0 00.209 3.7c1.373 1.719 3.19 1.408 4.847.035l2.163-1.848-6.731-8.128zm2.058 5.929l1.883 2.268-.21.1c-.808.7-1.52 1.007-2.3.07-.72-.87-.36-1.582.488-2.3zm-8.615-.42l-1.954 1.187.42 2.372h-.036l-3.244 2.023-1.884-1.43-1.953 1.22 9.383 7.011 1.36-.837-2.092-11.544zm-1.257 5.582l.943 3.487h-.07l-2.895-2.267zm-10.45 3.173l-2.813 1.222-.721-1.59 4.71-2.249 4.56 9.637-1.964.848-3.773-7.89m50.076-101.154l2.125 2.785h1.687l-1.466-2.785zm-154.113 88.7l3.477-.429 1.18 1.2-3.016.9z' fill='%23fc0'/%3e%3cpath d='M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.6 2.443-3.03.566-.413 10.572-5.274 17.047-6.3 6.366-1 16.4-4.839 18.488-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64a83.241 83.241 0 00-2.093-18.922c-1.155-4.993-9.7-19.64-14.933-26.12 0 0 11.752 18.205 13.778 25.247a77.632 77.632 0 012.46 20.884c-.128 4.12-3.487 19.142-8.476 30.17-3.968 8.85-7.456 9.855-13.629 14.782a90.148 90.148 0 01-13.187 8.417 91.74 91.74 0 01-17.33 5.642c-2.681.5-16.023 4.425-17.767 5.28a44.751 44.751 0 00-7.456 6.144' fill='%23090'/%3e%3cpath d='M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.6 2.443-3.03.566-.413 10.572-5.274 17.047-6.3 6.366-1 16.4-4.839 18.488-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64a83.241 83.241 0 00-2.093-18.922c-1.155-4.993-9.7-19.64-14.933-26.12 0 0 11.752 18.205 13.778 25.247a77.632 77.632 0 012.46 20.884c-.128 4.12-3.487 19.142-8.476 30.17-3.968 8.85-7.456 9.855-13.629 14.782a90.148 90.148 0 01-13.187 8.417 91.74 91.74 0 01-17.33 5.642c-2.681.5-16.023 4.425-17.767 5.28a44.751 44.751 0 00-7.456 6.144z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M551.326 325.81c-.284-1.373-.413-2.371-.937-2.746-.347-.5-1.875-2.243-2.16-3.4a8.417 8.417 0 010-2.684 25.18 25.18 0 00-.413-2.59 10.612 10.612 0 011.29-2.969 11.891 11.891 0 002.31-3.03 3.831 3.831 0 00.279 1.725 5.6 5.6 0 01.636 2.962 17.848 17.848 0 000 3.9 6.871 6.871 0 01.435 3.4c-.195 1.065-1.44 5.425-1.44 5.425' fill='%23090'/%3e%3cpath d='M551.326 325.81c-.284-1.373-.413-2.371-.937-2.746-.347-.5-1.875-2.243-2.16-3.4a8.417 8.417 0 010-2.684 25.18 25.18 0 00-.413-2.59 10.612 10.612 0 011.29-2.969 11.891 11.891 0 002.31-3.03 3.831 3.831 0 00.279 1.725 5.6 5.6 0 01.636 2.962 17.848 17.848 0 000 3.9 6.871 6.871 0 01.435 3.4c-.195 1.065-1.44 5.425-1.44 5.425' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M551.7 324.377s3.4-4.276 3.4-6.084a6.569 6.569 0 01.563-3.186 4.529 4.529 0 00.5-5.426 7.141 7.141 0 01-1.374-2.31c-.563-1.59-1.718-1.59-1.874-3.184a34.009 34.009 0 00-.564 3.468 8.627 8.627 0 00.28 3.026c.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.589 0 .419.564 6.016-.636 7.83' fill='%23090'/%3e%3cpath d='M551.7 324.377s3.4-4.276 3.4-6.084a6.569 6.569 0 01.563-3.186 4.529 4.529 0 00.5-5.426 7.141 7.141 0 01-1.374-2.31c-.563-1.59-1.718-1.59-1.874-3.184a34.009 34.009 0 00-.564 3.468 8.627 8.627 0 00.28 3.026c.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.589 0 .419.564 6.016-.636 7.83z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M514.092 347.285s2.812-.284 3.9-.5a20.218 20.218 0 003.466-.847 11.148 11.148 0 003.9-2.685c2.679-2.9 2.371-4.426 2.9-4.554 1-.128-1.5-.413-2.679-.2a7.48 7.48 0 00-3.838 1.942 39.092 39.092 0 01-3.335 2.59 6.824 6.824 0 00-1.657 1.44 7.667 7.667 0 01-2.681 2.812' fill='%23090'/%3e%3cpath d='M514.092 347.285s2.812-.284 3.9-.5a20.218 20.218 0 003.466-.847 11.148 11.148 0 003.9-2.685c2.679-2.9 2.371-4.426 2.9-4.554 1-.128-1.5-.413-2.679-.2a7.48 7.48 0 00-3.838 1.942 39.092 39.092 0 01-3.335 2.59 6.824 6.824 0 00-1.657 1.44 7.667 7.667 0 01-2.681 2.812z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M510.255 349.333s7.107-3.18 7.76-3.772a17 17 0 002.685-2.461c.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.5-4.71 2.31a8.641 8.641 0 00-2.747 2.813c-.567 1.217-1.22 3.465-1.874 4.553a18.542 18.542 0 01-3.9 4.773' fill='%23090'/%3e%3cpath d='M510.255 349.333s7.107-3.18 7.76-3.772a17 17 0 002.685-2.461c.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.5-4.71 2.31a8.641 8.641 0 00-2.747 2.813c-.567 1.217-1.22 3.465-1.874 4.553a18.542 18.542 0 01-3.9 4.773z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M506.419 350.21s5.776-1.508 8.48-5.146c1.875-2.467 1.94-1.724 2.747-2.528a27.944 27.944 0 003.77-4.342c-.13.195 1.593-5.8 1.593-6.452-.067-.413-2.246.285-4.056 1-1.5.652-2.376 1.875-3.683 2.679-1.592 1-1.723 3.555-2.464 4.71a6.307 6.307 0 00-1.155 3.466c0 1.284-.72 1.724-1.156 2.812-.5 1.284-2.028 1.066-4.055 3.773' fill='%23090'/%3e%3cpath d='M506.419 350.21s5.776-1.508 8.48-5.146c1.875-2.467 1.94-1.724 2.747-2.528a27.944 27.944 0 003.77-4.342c-.13.195 1.593-5.8 1.593-6.452-.067-.413-2.246.285-4.056 1-1.5.652-2.376 1.875-3.683 2.679-1.592 1-1.723 3.555-2.464 4.71a6.307 6.307 0 00-1.155 3.466c0 1.284-.72 1.724-1.156 2.812-.5 1.284-2.028 1.066-4.055 3.773z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1-.57 2.03-.848a5.765 5.765 0 013.682-.419c.849.2 4.488 1 5.426.57.853-.413-1.306 2.46-2.395 3.12a8.063 8.063 0 01-4.208.713c-1.506-.127-3.554 0-4.273 0a6.866 6.866 0 01-2.245-.127 6.392 6.392 0 00-3.772-.57' fill='%23090'/%3e%3cpath d='M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1-.57 2.03-.848a5.765 5.765 0 013.682-.419c.849.2 4.488 1 5.426.57.853-.413-1.306 2.46-2.395 3.12a8.063 8.063 0 01-4.208.713c-1.506-.127-3.554 0-4.273 0a6.866 6.866 0 01-2.245-.127 6.392 6.392 0 00-3.772-.57z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M512.37 348.312s5.58-1.44 6.518-1.44a34.052 34.052 0 014.624.413c1.066.133 4.4-.2 5.424.284a18.493 18.493 0 006.586.782c1.155-.195-2.311 3.186-3.773 3.555-4.492 1.29-3.114 1.072-6.016.351-1.808-.419-4.338-.569-5.21-.72-.872-.133-.72-.63-1.875-1.155a17.727 17.727 0 00-6.3-2.093' fill='%23090'/%3e%3cpath d='M512.37 348.312s5.58-1.44 6.518-1.44a34.052 34.052 0 014.624.413c1.066.133 4.4-.2 5.424.284a18.493 18.493 0 006.586.782c1.155-.195-2.311 3.186-3.773 3.555-4.492 1.29-3.114 1.072-6.016.351-1.808-.419-4.338-.569-5.21-.72-.872-.133-.72-.63-1.875-1.155a17.727 17.727 0 00-6.3-2.093z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M507.792 350.645s5.581-2.31 9.919-1.155a26.341 26.341 0 004.12.937c1.352.194 2.529-.5 4.84.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.849-10.791.063-1.876-.715-2.966-1.218-3.9-1.5-.937-.352-1.439-1.223-2-1.591-.567-.5-.938-1.591-4.273-2.528' fill='%23090'/%3e%3cpath d='M507.792 350.645s5.581-2.31 9.919-1.155a26.341 26.341 0 004.12.937c1.352.194 2.529-.5 4.84.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.849-10.791.063-1.876-.715-2.966-1.218-3.9-1.5-.937-.352-1.439-1.223-2-1.591-.567-.5-.938-1.591-4.273-2.528z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M537.614 337.781s3.249-3.556 3.834-3.99c.637-.5 2.16-1.59 2.97-2.31a5.99 5.99 0 013.331-2.378c.937-.195 3.12-.631 3.69-1.373.63-.782-.069 2.813-.788 3.773a7.52 7.52 0 01-3.466 2.528c-1.372.5-3.185 1.507-3.839 1.808a5.4 5.4 0 01-2.026.787 7.268 7.268 0 00-3.683 1.155' fill='%23090'/%3e%3cpath d='M537.614 337.781s3.249-3.556 3.834-3.99c.637-.5 2.16-1.59 2.97-2.31a5.99 5.99 0 013.331-2.378c.937-.195 3.12-.631 3.69-1.373.63-.782-.069 2.813-.788 3.773a7.52 7.52 0 01-3.466 2.528c-1.372.5-3.185 1.507-3.839 1.808a5.4 5.4 0 01-2.026.787 7.268 7.268 0 00-3.683 1.155z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M534.584 339.242s5.492-3.838 6.3-4.207c.848-.413 2.4-.937 3.4-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.621-3.549 3.115-1.066 2.154-4.051 2.747-1.725.345-4.12 1.372-4.928 1.59-.938.285-1-.285-2.243-.195a19.973 19.973 0 00-6.586.787' fill='%23090'/%3e%3cpath d='M534.584 339.242s5.492-3.838 6.3-4.207c.848-.413 2.4-.937 3.4-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.621-3.549 3.115-1.066 2.154-4.051 2.747-1.725.345-4.12 1.372-4.928 1.59-.938.285-1-.285-2.243-.195a19.973 19.973 0 00-6.586.787z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M533.256 340.265a18.849 18.849 0 016.669-2.155 27.17 27.17 0 004.057-1 12.306 12.306 0 014.119-.5c1.222-.128 6.083 1.44 7.238.787 1-.57-1.223 1.434-2.528 1.937-1.942.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25' fill='%23090'/%3e%3cpath d='M533.256 340.265a18.849 18.849 0 016.669-2.155 27.17 27.17 0 004.057-1 12.306 12.306 0 014.119-.5c1.222-.128 6.083 1.44 7.238.787 1-.57-1.223 1.434-2.528 1.937-1.942.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M532.82 339.176s-1.071-5.363-.133-6.585a6.2 6.2 0 001.155-2.813 11.074 11.074 0 011.59-4.208c.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989a6.32 6.32 0 000 2.317 11.919 11.919 0 01-1.284 4.7c-.63.853-.284 3.553-.938 4.056-.569.63-4.056 2.964-4.776 2.528' fill='%23090'/%3e%3cpath d='M532.82 339.176s-1.071-5.363-.133-6.585a6.2 6.2 0 001.155-2.813 11.074 11.074 0 011.59-4.208c.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989a6.32 6.32 0 000 2.317 11.919 11.919 0 01-1.284 4.7c-.63.853-.284 3.553-.938 4.056-.569.63-4.056 2.964-4.776 2.528z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M533.256 340.265a15.3 15.3 0 012.9-2.094c1.071-.412 5.144-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492a15.376 15.376 0 00.57-2.746 18.318 18.318 0 00-.848-3.465c-.42-1.072-1.507-3.556-2.534-3.99 0 0-.848 2.745-1.156 3.772a9.421 9.421 0 01-1 2.813 19.859 19.859 0 00-2.094 4.426 41.535 41.535 0 01-1 5.078c-.068.72-2.813 3.772-4.052 4.336' fill='%23090'/%3e%3cpath d='M533.256 340.265a15.3 15.3 0 012.9-2.094c1.071-.412 5.144-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492a15.376 15.376 0 00.57-2.746 18.318 18.318 0 00-.848-3.465c-.42-1.072-1.507-3.556-2.534-3.99 0 0-.848 2.745-1.156 3.772a9.421 9.421 0 01-1 2.813 19.859 19.859 0 00-2.094 4.426 41.535 41.535 0 01-1 5.078c-.068.72-2.813 3.772-4.052 4.336z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.6-2.812a13.1 13.1 0 002.528-4.335c.435-1.5 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847a8.529 8.529 0 01-3.331 1.6c-.57.278-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705' fill='%23090'/%3e%3cpath d='M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.6-2.812a13.1 13.1 0 002.528-4.335c.435-1.5 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847a8.529 8.529 0 01-3.331 1.6c-.57.278-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.9 5.273-4.772.134-1 2.093-2.466 2.534-3.119 1-1.74 1.59-5.709 3.03-6.736 0 0-3.99 1-4.994 1.155-1.875.284-3.466.57-4.276 2.25-.63 1.59-1.283 2.9-1.875 3.029-.563.129-1.434 2.155-1.718 4.27-.285 2.026-2.6 6.452-2.6 6.452' fill='%23090'/%3e%3cpath d='M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.9 5.273-4.772.134-1 2.093-2.466 2.534-3.119 1-1.72 1.59-5.709 3.03-6.736 0 0-3.99 1-4.994 1.155-1.875.284-3.466.57-4.276 2.25-.63 1.59-1.283 2.9-1.875 3.029-.563.129-1.434 2.155-1.74 4.27-.285 2.026-2.6 6.452-2.6 6.452z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M558.52 305.8c-.63 1.006-.57-5.86-.938-6.514a10.334 10.334 0 00-1.59-2.812c-.57-.567-.57-2.594-.848-3.184a15.492 15.492 0 01.279-5.58 14.381 14.381 0 011.814 1.591c.563.72 1.59 1 1.875 1.875.278.85.87.85 1.283 1.81a5.593 5.593 0 01.57 3.466 8.585 8.585 0 00-.135 2.681 22.989 22.989 0 01-2.31 6.667' fill='%23090'/%3e%3cpath d='M558.52 305.8c-.63 1.006-.57-5.86-.938-6.514a10.334 10.334 0 00-1.59-2.812c-.57-.567-.57-2.594-.848-3.184a15.492 15.492 0 01.279-5.58 14.381 14.381 0 011.814 1.591c.563.72 1.59 1 1.875 1.875.278.85.87.85 1.283 1.81a5.593 5.593 0 01.57 3.466 8.585 8.585 0 00-.135 2.681 22.989 22.989 0 01-2.31 6.667' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1-.5-1.591a10.725 10.725 0 01-1-2.092c-.28-1.592-1.155-3.337-.413-5.058a8.785 8.785 0 012.026.85 4.711 4.711 0 011.942 2.593 4.1 4.1 0 00.72 2.246c.413.72 1 2.9.284 4.207a8.235 8.235 0 00-.853 2.683' fill='%23090'/%3e%3cpath d='M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1-.5-1.591a10.725 10.725 0 01-1-2.092c-.28-1.592-1.155-3.337-.413-5.058a8.785 8.785 0 012.026.85 4.711 4.711 0 011.942 2.593 4.1 4.1 0 00.72 2.246c.413.72 1 2.9.284 4.207a8.235 8.235 0 00-.853 2.683z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145a5.115 5.115 0 010 1.81c-.067.632-.345 2.746 0 3.465.5.72 1.943 2.028 1.943 2.682a3.83 3.83 0 001.718 2.31 10.3 10.3 0 001.29.415' fill='%23090'/%3e%3cpath d='M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145a5.115 5.115 0 010 1.81c-.067.632-.345 2.746 0 3.465.5.72 1.943 2.028 1.943 2.682a3.83 3.83 0 001.718 2.31 10.3 10.3 0 001.29.415z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M562.577 286.268s0-3.03-.786-3.9a17.826 17.826 0 01-1.791-1.876c-.435-.567-.877-2.094-1.875-2.682a9.29 9.29 0 01-2.968-2.594s-.413 3.619.569 5.58c1 1.875 1 2.9 2.243 3.336a5.484 5.484 0 011.747 1 3.121 3.121 0 001.724.718 2.4 2.4 0 011.155.415' fill='%23090'/%3e%3cpath d='M562.577 286.268s0-3.03-.786-3.9a17.826 17.826 0 01-1.791-1.876c-.435-.567-.877-2.094-1.875-2.682a9.29 9.29 0 01-2.968-2.594s-.413 3.619.569 5.58c1 1.875 1 2.9 2.243 3.336a5.484 5.484 0 011.747 1 3.121 3.121 0 001.724.718 2.4 2.4 0 011.155.415z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M559.24 306.3c-.128.854-.72-1.875 2.31-1.875a9.774 9.774 0 006.585-2.243 22.447 22.447 0 002.093-2.245 8.408 8.408 0 001.72-3.03c.133-.851 1-4.12.853-4.71a6.7 6.7 0 00-2.31.85c-.72.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.725 2.027-.413.414-1.718.414-2.31 1.285a15 15 0 00-1.808 3.685c-.067.85-1.155 1.722-1.875 2.158-.72.414-.57 2.157-.72 2.967' fill='%23090'/%3e%3cpath d='M559.24 306.3c-.128.854-.72-1.875 2.31-1.875a9.774 9.774 0 006.585-2.243 22.447 22.447 0 002.093-2.245 8.408 8.408 0 001.72-3.03c.133-.851 1-4.12.853-4.71a6.7 6.7 0 00-2.31.85c-.72.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.747 2.027-.413.414-1.718.414-2.31 1.285a15.222 15.222 0 00-1.809 3.685c-.066.85-1.154 1.722-1.874 2.158-.72.414-.57 2.157-.72 2.967z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.681 3.834-3.771a8.074 8.074 0 011.59-3.837 3.422 3.422 0 001.508-3.248c-.2-1.723-.2-4.622-.2-4.622s-.57 1.723-1.44 2.158c-.847.414-2.46 1-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159a8.972 8.972 0 00-1.284 2.462c-.284 1.22-1.875 4.273-1.59 7.235' fill='%23090'/%3e%3cpath d='M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.681 3.834-3.771a8.074 8.074 0 011.59-3.837 3.422 3.422 0 001.508-3.248c-.2-1.723-.2-4.622-.2-4.622s-.57 1.723-1.44 2.158c-.847.414-2.46 1-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159a8.972 8.972 0 00-1.284 2.462c-.284 1.22-1.875 4.273-1.59 7.235z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M562.577 288.884c.061.785-1.155-1.5 1.59-2.377a9.414 9.414 0 005.425-3.836c.636-1.155.938-2.026 1.222-2.528a7.928 7.928 0 00.72-3.249c-.067-.85-.194-4.054-.5-4.556a6.576 6.576 0 00-1.875 1.439c-.5.785-1.658 1.155-2.243 1.722a11.051 11.051 0 00-1 2.376c-.279.5-1.44.85-1.719 1.81a11.986 11.986 0 00-.569 3.836 4.068 4.068 0 01-1.155 2.53c-.5.566.133 2.092.133 2.812' fill='%23090'/%3e%3cpath d='M562.577 288.884c.061.785-1.155-1.5 1.59-2.377a9.414 9.414 0 005.425-3.836c.636-1.155.938-2.026 1.222-2.528a7.928 7.928 0 00.72-3.249c-.067-.85-.194-4.054-.5-4.556a6.576 6.576 0 00-1.875 1.439c-.5.785-1.658 1.155-2.243 1.722a11.051 11.051 0 00-1 2.376c-.279.5-1.44.85-1.719 1.81a11.986 11.986 0 00-.569 3.836 4.068 4.068 0 01-1.155 2.53c-.5.566.133 2.092.133 2.812z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M562.577 287.729s1.155-2.813 2.093-3.118c.938-.282 2.461-2.68 2.528-3.77.062-1.222.285-3.4.72-3.9a4.952 4.952 0 00.563-3.9c-.63-1.591-1.59-3.685-1.59-3.685a18.852 18.852 0 00-1.283 2.159c-.788 1.5-1.507 1.592-1.657 2.158-.069.633-1.072 1-1.374 2.224-.419 1.656.061 1.59-.066 2.245a9.334 9.334 0 00-.5 2.593c.067 1.157-.564 4.34.569 6.956' fill='%23090'/%3e%3cpath d='M562.577 287.729s1.155-2.813 2.093-3.118c.938-.282 2.461-2.68 2.528-3.77.062-1.222.285-3.4.72-3.9a4.952 4.952 0 00.563-3.9c-.63-1.591-1.59-3.685-1.59-3.685a18.852 18.852 0 00-1.283 2.159c-.788 1.5-1.507 1.592-1.657 2.158-.069.633-1.072 1-1.374 2.224-.419 1.656.061 1.59-.066 2.245a9.334 9.334 0 00-.5 2.593c.067 1.157-.564 4.34.569 6.956z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-1-.284-2.656-2.6-3.332-3.183-.72-.633-1.071-1.5-1.941-2.028-.849-.5-1.507-2.31-1.724-4.119 0 0 2.466.565 3.185.721a7.627 7.627 0 012.814 1.718c.563.72 1.155 1.942 1.718 2.225s1.29 2.028 1.29 3.248v2.595' fill='%23090'/%3e%3cpath d='M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-1-.284-2.656-2.6-3.332-3.183-.72-.633-1.071-1.5-1.941-2.028-.849-.5-1.507-2.31-1.748-4.119 0 0 2.468.565 3.188.721a7.628 7.628 0 012.812 1.718c.564.72 1.156 1.942 1.719 2.225s1.29 2.028 1.29 3.248v2.595z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M560.4 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.145-.854-1.283-4.124-3.772-4.994-3.9a12.025 12.025 0 00-.413 3.03c.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556' fill='%23090'/%3e%3cpath d='M560.4 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.145-.854-1.283-4.124-3.772-4.994-3.9a12.025 12.025 0 00-.413 3.03c.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M561.137 270.028c.346.632.129-2.225 1-2.9a3.434 3.434 0 001-2.965 22.923 22.923 0 00-.345-2.81c-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.807-1.59 3.616-.413 1 .284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.4' fill='%23090'/%3e%3cpath d='M561.137 270.028c.346.632.129-2.225 1-2.9a3.434 3.434 0 001-2.965 22.923 22.923 0 00-.345-2.81c-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.807-1.59 3.616-.413 1 .284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.4z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.833-.714a11.452 11.452 0 00-2.16-1.595 4.378 4.378 0 01-1.72-2.244c-.2-.564-1.221-1.72-1.657-1.72a11.032 11.032 0 013.4.348c1.723.345 4.208 1.283 4.776 2.46.63 1.156 2.68 3.907 2.68 3.907' fill='%23090'/%3e%3cpath d='M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.833-.714a11.452 11.452 0 00-2.16-1.595 4.532 4.532 0 01-1.741-2.244c-.2-.564-1.223-1.72-1.658-1.72a11.023 11.023 0 013.4.348c1.724.345 4.208 1.283 4.777 2.46.63 1.156 2.679 3.907 2.679 3.907z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M552.917 254.572c-.346 1-2.813-1-3.4-1.724-.568-.72-1.438-1.875-1.438-1.875a14.624 14.624 0 01-1.725-2.372c-.848-1.6-.631-4.493-.28-4.275a21.134 21.134 0 002.462 1.374 2.41 2.41 0 011.59 1.132 7.364 7.364 0 001.072 2.243 4.418 4.418 0 011.742 5.5' fill='%23090'/%3e%3cpath d='M552.917 254.572c-.346 1-2.813-1-3.4-1.724-.568-.72-1.438-1.875-1.438-1.875a14.624 14.624 0 01-1.725-2.372c-.848-1.6-.631-4.493-.28-4.275a21.134 21.134 0 002.462 1.374 2.41 2.41 0 011.59 1.132 7.364 7.364 0 001.072 2.243 4.418 4.418 0 011.742 5.5z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M553.787 254.572a24.071 24.071 0 01-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.155-2.812.285-.849.854-3.332.854-3.332s1.066.937 1.808 1.719a4.639 4.639 0 011.155 2.182 19.31 19.31 0 001.156 2.243 7.509 7.509 0 01-.135 3.03 6.7 6.7 0 000 1.724' fill='%23090'/%3e%3cpath d='M553.787 254.572a24.071 24.071 0 01-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.155-2.812.285-.849.854-3.332.854-3.332s1.066.937 1.808 1.719a4.639 4.639 0 011.155 2.182 19.31 19.31 0 001.156 2.243 7.509 7.509 0 01-.135 3.03 6.7 6.7 0 000 1.724' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M530.878 337.278a.851.851 0 11.85-.848.808.808 0 01-.85.848' fill='%23e60000'/%3e%3cpath d='M530.878 337.278a.851.851 0 11.85-.848.808.808 0 01-.85.848' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M535.867 343.45a.814.814 0 01-.847-.853.864.864 0 01.847-.848.916.916 0 01.877.847.859.859 0 01-.877.855' fill='%23e60000'/%3e%3cpath d='M535.867 343.45a.814.814 0 01-.847-.853.864.864 0 01.847-.848.916.916 0 01.877.847.859.859 0 01-.877.855' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M547.492 324.091a.93.93 0 01-.937-.853.875.875 0 01.937-.849.866.866 0 01.849.848.913.913 0 01-.848.854' fill='%23e60000'/%3e%3cpath d='M547.492 324.091a.93.93 0 01-.937-.853.875.875 0 01.937-.849.866.866 0 01.849.848.913.913 0 01-.848.854' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M554.664 327.708a.973.973 0 01-1-1 .959.959 0 011-.936.946.946 0 01.938.937.961.961 0 01-.937 1' fill='%23e60000'/%3e%3cpath d='M554.664 327.708a.973.973 0 01-1-1 .959.959 0 011-.936.946.946 0 01.938.937.961.961 0 01-.937 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M555.97 305.932a1 1 0 01-1-.938 1.079 1.079 0 011-1 1.018 1.018 0 01.938 1 .943.943 0 01-.938.937' fill='%23e60000'/%3e%3cpath d='M555.97 305.932a1 1 0 01-1-.938 1.079 1.079 0 011-1 1.018 1.018 0 01.938 1 .943.943 0 01-.938.937' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M561.986 307.762a.924.924 0 01-.938-1 .908.908 0 01.938-.938.947.947 0 01.937.938.958.958 0 01-.937 1' fill='%23e60000'/%3e%3cpath d='M561.986 307.762a.924.924 0 01-.938-1 .908.908 0 01.938-.938.947.947 0 01.937.938.958.958 0 01-.937 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M558.934 288.382a1.026 1.026 0 01-1-1 .958.958 0 011-.937.944.944 0 01.938.937 1 1 0 01-.938 1' fill='%23e60000'/%3e%3cpath d='M558.934 288.382a1.026 1.026 0 01-1-1 .958.958 0 011-.937.944.944 0 01.938.937 1 1 0 01-.938 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M564.319 270.529a.886.886 0 01-.938-.85.96.96 0 01.938-1 .973.973 0 011 1 .907.907 0 01-1 .85' fill='%23e60000'/%3e%3cpath d='M564.319 270.529a.886.886 0 01-.938-.85.96.96 0 01.938-1 .973.973 0 011 1 .907.907 0 01-1 .85' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M557.431 272.337a.959.959 0 01-.937-1 .944.944 0 01.937-.938.959.959 0 011 .938.972.972 0 01-1 1' fill='%23e60000'/%3e%3cpath d='M557.431 272.337a.959.959 0 01-.937-1 .944.944 0 01.937-.938.959.959 0 011 .938.972.972 0 01-1 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M550.673 257.468a.94.94 0 110-1.875.938.938 0 010 1.875' fill='%23e60000'/%3e%3cpath d='M550.673 257.468a.94.94 0 110-1.875.938.938 0 010 1.875' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M555.82 253.417a.922.922 0 01-.939-1 .9.9 0 01.938-.939.972.972 0 010 1.943' fill='%23e60000'/%3e%3cpath d='M555.82 253.417a.922.922 0 01-.939-1 .9.9 0 01.938-.939.972.972 0 010 1.943' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M545.528 243.41a.971.971 0 010-1.941.971.971 0 110 1.941' fill='%23e60000'/%3e%3cpath d='M545.528 243.41a.971.971 0 010-1.941.971.971 0 110 1.941' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M566.5 288.449a.886.886 0 01-.937-.85.938.938 0 111.875 0 .872.872 0 01-.937.85' fill='%23e60000'/%3e%3cpath d='M566.5 288.449a.886.886 0 01-.937-.85.938.938 0 111.875 0 .872.872 0 01-.937.85' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M530.008 340.918a18.057 18.057 0 00.564-3.768s-.285 0-.721-.57m1.312 5.56a22.186 22.186 0 013.684.35 2.3 2.3 0 00.284.782m13.076-15.128s.134-3.685-.564-3.986a2.96 2.96 0 01-1.155-.876m4.554 3.705a7.915 7.915 0 012.595 0 1.06 1.06 0 00.569.721m.736-22.279l.721.352c.786.346 2.249 3.834 2.249 3.834a12.793 12.793 0 013.331-1.875h1M567 288.1a1.116 1.116 0 01-1.156.282s-2.968 1.877-3.03 2.6c0 0-3.12-3.03-3.689-2.748 0 0-.28.415-.847-.13m5.514-18.072a2.925 2.925 0 01-.938.72 7.561 7.561 0 00-1.284 3.335s-2.461-2.158-3.181-2.027a2.279 2.279 0 01-1.44 0m-.4-18.945s-.564.72-1 .133c0 0-1.746 2.155-.72 3.835 0 0-2.466-.564-3.18-.129a.749.749 0 01-1.223.413m-4.111-14.767s.435 1-1.29.636' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M521.373 347.068s9.634-.068 10.571-1.284m-16.173 2.528s6.3 1.72 9.633 1.284a17.691 17.691 0 015.714.284 28.328 28.328 0 004.426-1.507m-26.225 2.272s4.838.847 5.863 1.155c1 .279 6.017 2.153 7.455 2.153 1.154 0 4.056-.06 4.842 0a17.292 17.292 0 006.145-.412m-5.95-14.515a30.9 30.9 0 00-4.274 2.9c-.564.786-3.836 3.4-4.425 3.4m8.7-10.882s-6.3 5.43-7.392 6.15c-1 .78-7.172 6.736-7.89 7.695m10.135-16.156s-4.991 3.99-5.58 5.582a15.563 15.563 0 01-2.027 3.465s-2.093 4.124-2.812 4.71a30.77 30.77 0 01-3.9 3.248m42.836-20.71s-5.3 4.425-6.736 5.273m8.918-2.438a63.615 63.615 0 01-7.607 4.553 41.549 41.549 0 01-9.42 2.31m-2.07 2.054s5.864-.284 6.887 0c1 .28 5.58-.72 6.735-1s5.865-1.155 6.457-1.289m-11.078-17.5a15.718 15.718 0 01-.2 4.554c-.413 1.289-2.462 5.056-2.31 6.016.128.853-1.156 4.838-2.311 5.58m-1.29-15.586s1.072 3.186.57 4.274a15.629 15.629 0 00-1.156 4.119 12.126 12.126 0 01-1 3.622c-.28.72.133 3.248-.565 3.9a21.8 21.8 0 00-1.59 2.094m35.18-25.465s-4.62 1.725-5.272 2.9c-.57 1.156-1.374 1.5-1.875 2.093m-10.136-9.42s-1.155 4.71-.853 5.865a24.717 24.717 0 01.284 4.426c0 .854 1.29 4.425 1.072 4.994m1.395-19.208s.413 2.745.564 3.906a25.931 25.931 0 00.285 3.834c.284.72.72 4.62 0 6.451M566 309.069s-3.84 3.247-4.71 4.123c-.848.848-4.771 5.056-4.99 6.144-.067 1-2.9 4.209-3.771 5m19.922-31.676s-3.772 3.771-4.119 4.621a8.029 8.029 0 01-2.594 2.813m-11.207-5.82s1.44 2.157 1.44 2.9a7.191 7.191 0 001.223 3.4c.346.5 1.59 2.594 1.44 3.9m-2.947-16.37s.569 2.027.854 3.467a25.253 25.253 0 001.373 3.836c.278.85 1.434 5.145 1 7.761m10.119-15.216a6.283 6.283 0 01-1.44 3.03c-1.005 1-2.6 2.529-2.746 3.335-.135.937-1.44 5.275-2.964 6.8a5.387 5.387 0 00-1.6 2.964m10.267-31.085s-.5 2.462-.72 3.181c-.278.72-1.522 3.99-2.678 4.993m-9.219-7.52a22.285 22.285 0 01.848 2.964 10.751 10.751 0 001.155 2.31c.129.414.72 1.94.72 1.94m-5.408-5.187a22.3 22.3 0 001.943 3.989 6.847 6.847 0 001.875 3.117c.87.567 3.465 2.463 3.332 3.249m4.32-16s.128 3.183-.414 4.338c-.569 1.22-1.289 2.966-1.6 3.836a22.966 22.966 0 00-.412 3.337 9.2 9.2 0 01-1.155 3.683m-11.53-25.2s2.092 2.377 3.03 3.4c1 .936 4.705 4.991 4.84 5.71m-4.382-11.29s2.093 4.486 2.528 5.206c.413.787.848 1.942.848 1.942m1.92-7.305s-.129 3.555 0 4.425a9.806 9.806 0 010 2.75 31.383 31.383 0 00.569 4.425m-17.552-20.73s4.622 2.812 5.364 3.55m-2.662-7.194l3.247 4.627.721 1.372m-.28-6.435a22.9 22.9 0 011.218 3.466 30.368 30.368 0 002.16 5.43' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M472.454 337.278a.851.851 0 000-1.7.866.866 0 00-.85.853.85.85 0 00.85.848' fill='%23e60000'/%3e%3cpath d='M472.454 337.278a.851.851 0 000-1.7.866.866 0 00-.85.853.85.85 0 00.85.848' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M467.463 343.45a.888.888 0 00.937-.853.931.931 0 00-.937-.848.912.912 0 00-.85.847.853.853 0 00.85.855' fill='%23e60000'/%3e%3cpath d='M467.463 343.45a.888.888 0 00.937-.853.931.931 0 00-.937-.848.912.912 0 00-.85.847.853.853 0 00.85.855' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M455.908 324.091a.9.9 0 00.85-.853.852.852 0 00-.85-.849.887.887 0 00-.937.848.931.931 0 00.937.854' fill='%23e60000'/%3e%3cpath d='M455.908 324.091a.9.9 0 00.85-.853.852.852 0 00-.85-.849.887.887 0 00-.937.848.931.931 0 00.937.854' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M448.737 327.708a.969.969 0 10-1-1 .985.985 0 001 1' fill='%23e60000'/%3e%3cpath d='M448.737 327.708a.969.969 0 10-1-1 .985.985 0 001 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M447.428 305.932a.944.944 0 00.937-.938 1 1 0 00-.937-1 1.029 1.029 0 00-1 1 .961.961 0 001 .937' fill='%23e60000'/%3e%3cpath d='M447.428 305.932a.944.944 0 00.937-.938 1 1 0 00-.937-1 1.029 1.029 0 00-1 1 .961.961 0 001 .937' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M441.347 307.762a.972.972 0 100-1.942.947.947 0 00-.938.938.959.959 0 00.938 1' fill='%23e60000'/%3e%3cpath d='M441.347 307.762a.972.972 0 100-1.942.947.947 0 00-.938.938.959.959 0 00.938 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M444.464 288.382a1.019 1.019 0 00.937-1 .944.944 0 00-.937-.937.96.96 0 00-1 .937 1.013 1.013 0 001 1' fill='%23e60000'/%3e%3cpath d='M444.464 288.382a1.019 1.019 0 00.937-1 .944.944 0 00-.937-.937.96.96 0 00-1 .937 1.013 1.013 0 001 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M439.014 270.529a.948.948 0 001-.85 1.031 1.031 0 00-1-1 .962.962 0 00-.938 1 .874.874 0 00.938.85' fill='%23e60000'/%3e%3cpath d='M439.014 270.529a.948.948 0 001-.85 1.031 1.031 0 00-1-1 .962.962 0 00-.938 1 .874.874 0 00.938.85' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M445.9 272.337a.973.973 0 001-1 .961.961 0 00-1-.938.945.945 0 00-.937.938.96.96 0 00.938 1' fill='%23e60000'/%3e%3cpath d='M445.9 272.337a.973.973 0 001-1 .961.961 0 00-1-.938.945.945 0 00-.937.938.96.96 0 00.938 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M452.66 257.468a.94.94 0 100-1.875.948.948 0 00-.939.938.96.96 0 00.939.937' fill='%23e60000'/%3e%3cpath d='M452.66 257.468a.94.94 0 100-1.875.948.948 0 00-.939.938.96.96 0 00.939.937' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M447.494 253.417a.973.973 0 001-1 .971.971 0 10-1 1' fill='%23e60000'/%3e%3cpath d='M447.494 253.417a.973.973 0 001-1 .971.971 0 10-1 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M457.805 243.41a.971.971 0 10-.937-.938.9.9 0 00.937.938' fill='%23e60000'/%3e%3cpath d='M457.805 243.41a.971.971 0 10-.937-.938.9.9 0 00.937.938' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M436.833 288.449a.886.886 0 00.937-.85.937.937 0 10-1.874 0 .873.873 0 00.937.85' fill='%23e60000'/%3e%3cpath d='M436.833 288.449a.886.886 0 00.937-.85.937.937 0 10-1.874 0 .873.873 0 00.937.85' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M473.326 340.918a18.227 18.227 0 01-.567-3.768s.284 0 .72-.57m-1.308 5.56a22.783 22.783 0 00-3.684.35 2.3 2.3 0 01-.283.782m-13.08-15.128s-.131-3.685.566-3.986a2.967 2.967 0 001.156-.876m-4.469 3.705a8.435 8.435 0 00-2.68 0 1.07 1.07 0 01-.569.721m-.763-22.279l-.718.352c-.72.346-2.18 3.834-2.18 3.834a13.5 13.5 0 00-3.4-1.875h-1m-4.735-19.64a1.113 1.113 0 001.156.282s2.9 1.877 3.117 2.6c0 0 3.03-3.03 3.618-2.748 0 0 .35.415.938-.13m-5.56-18.072a2.484 2.484 0 00.786.72 7.3 7.3 0 011.374 3.335s2.44-2.158 3.182-2.027a2.513 2.513 0 001.5 0m.327-18.945s.568.72 1 .133c0 0 1.744 2.155.719 3.835 0 0 2.465-.564 3.27-.129a.706.706 0 001.156.413M457 242.6s-.414 1 1.374.636' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M518.975 359.842s-3.771-.285-4.337-.285-1.963-2.6-2.53-3.03c-.566-.413-10.508-5.274-17.047-6.3-6.453-1-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.378-3.77-12.035-3.77-18.64a82.491 82.491 0 012.026-18.922c1.156-4.993 9.7-19.64 15-26.12 0 0-11.815 18.205-13.842 25.247a77.734 77.734 0 00-2.464 20.884c.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.69 14.782a93.228 93.228 0 0013.124 8.417 91.7 91.7 0 0017.331 5.642c2.594.5 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144' fill='%23090'/%3e%3cpath d='M518.975 359.842s-3.771-.285-4.337-.285-1.963-2.6-2.53-3.03c-.566-.413-10.508-5.274-17.047-6.3-6.453-1-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.378-3.77-12.035-3.77-18.64a82.491 82.491 0 012.026-18.922c1.156-4.993 9.7-19.64 15-26.12 0 0-11.815 18.205-13.842 25.247a77.734 77.734 0 00-2.464 20.884c.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.69 14.782a93.228 93.228 0 0013.124 8.417 91.7 91.7 0 0017.331 5.642c2.594.5 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M452.071 325.81c.284-1.373.349-2.371.85-2.746a11.72 11.72 0 002.16-3.4 8.359 8.359 0 000-2.684 25.18 25.18 0 01.413-2.59 10.7 10.7 0 00-1.286-2.969 13.814 13.814 0 01-2.376-3.03 2.558 2.558 0 01-.283 1.725 6.312 6.312 0 00-.568 2.962 17.91 17.91 0 010 3.9 6.625 6.625 0 00-.414 3.4q.744 2.715 1.5 5.425' fill='%23090'/%3e%3cpath d='M452.071 325.81c.284-1.373.349-2.371.85-2.746a11.72 11.72 0 002.16-3.4 8.359 8.359 0 000-2.684 25.18 25.18 0 01.413-2.59 10.7 10.7 0 00-1.286-2.969 13.814 13.814 0 01-2.376-3.03 2.558 2.558 0 01-.283 1.725 6.312 6.312 0 00-.568 2.962 17.91 17.91 0 010 3.9 6.625 6.625 0 00-.414 3.4q.744 2.715 1.5 5.425' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M451.57 324.377s-3.335-4.276-3.335-6.084a6.481 6.481 0 00-.567-3.186 4.563 4.563 0 01-.435-5.426 8.145 8.145 0 001.285-2.31c.567-1.59 1.744-1.59 1.962-3.184 0 0 .35 1.873.5 3.468a12.278 12.278 0 01-.195 3.026c-.2.937.348 1.941.348 3.254 0 1.283-.13 1.808-.13 2.589 0 .419-.5 6.016.566 7.83' fill='%23090'/%3e%3cpath d='M451.57 324.377s-3.335-4.276-3.335-6.084a6.481 6.481 0 00-.567-3.186 4.563 4.563 0 01-.435-5.426 8.145 8.145 0 001.285-2.31c.567-1.59 1.744-1.59 1.962-3.184 0 0 .35 1.873.5 3.468a12.278 12.278 0 01-.195 3.026c-.2.937.348 1.941.348 3.254 0 1.283-.13 1.808-.13 2.589 0 .419-.5 6.016.566 7.83z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M489.219 347.285s-2.813-.284-3.9-.5a18.278 18.278 0 01-3.4-.847 10.91 10.91 0 01-3.99-2.685c-2.66-2.9-2.377-4.426-2.9-4.554-.936-.128 1.5-.413 2.66-.2a7.731 7.731 0 013.838 1.942 30.616 30.616 0 003.4 2.59 5.672 5.672 0 011.592 1.44 7.09 7.09 0 002.68 2.812' fill='%23090'/%3e%3cpath d='M489.219 347.285s-2.813-.284-3.9-.5a18.278 18.278 0 01-3.4-.847 10.91 10.91 0 01-3.99-2.685c-2.66-2.9-2.377-4.426-2.9-4.554-.936-.128 1.5-.413 2.66-.2a7.731 7.731 0 013.838 1.942 30.616 30.616 0 003.4 2.59 5.672 5.672 0 011.592 1.44 7.09 7.09 0 002.68 2.812z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M493.143 349.333s-7.107-3.18-7.827-3.772a20.766 20.766 0 01-2.747-2.462c-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.566-1.072 4.709.284 4.709.284 4.272 1.719 2.4.5 4.709 2.31a9 9 0 012.812 2.813 42.184 42.184 0 001.81 4.553 19.454 19.454 0 003.988 4.773' fill='%23090'/%3e%3cpath d='M493.143 349.333s-7.107-3.18-7.827-3.772a20.766 20.766 0 01-2.747-2.462c-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.566-1.072 4.709.284 4.709.284 4.272 1.719 2.4.5 4.709 2.31a9 9 0 012.812 2.813 42.184 42.184 0 001.81 4.553 19.454 19.454 0 003.988 4.773z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M496.979 350.21s-5.864-1.508-8.545-5.146c-1.876-2.467-1.876-1.724-2.681-2.528a22.3 22.3 0 01-3.772-4.342c.065.195-1.723-5.8-1.591-6.452 0-.413 2.158.285 3.99 1 1.5.652 2.376 1.875 3.683 2.679 1.569 1 1.788 3.555 2.53 4.71a6.006 6.006 0 011.067 3.466c0 1.284.72 1.724 1.155 2.812.5 1.284 2.093 1.066 4.121 3.773' fill='%23090'/%3e%3cpath d='M496.979 350.21s-5.864-1.508-8.545-5.146c-1.876-2.467-1.876-1.724-2.681-2.528a22.3 22.3 0 01-3.772-4.342c.065.195-1.744-5.8-1.591-6.452 0-.413 2.158.285 3.99 1 1.5.652 2.376 1.875 3.683 2.679 1.569 1 1.788 3.555 2.53 4.71a6.006 6.006 0 011.067 3.466c0 1.284.72 1.724 1.155 2.812.5 1.284 2.093 1.066 4.121 3.773z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M487.562 348.312s-4.993-2.25-5.646-2.4c-.785-.128-1.068-.57-2.093-.848a5.745 5.745 0 00-3.684-.419c-.85.2-4.491 1-5.363.57-.938-.413 1.286 2.46 2.31 3.12a8.2 8.2 0 004.273.713c1.44-.127 3.466 0 4.208 0a6.783 6.783 0 002.223-.127 6.433 6.433 0 013.772-.57' fill='%23090'/%3e%3cpath d='M487.562 348.312s-4.993-2.25-5.646-2.4c-.785-.128-1.068-.57-2.093-.848a5.745 5.745 0 00-3.684-.419c-.85.2-4.491 1-5.363.57-.938-.413 1.286 2.46 2.31 3.12a8.2 8.2 0 004.273.713c1.44-.127 3.466 0 4.208 0a6.783 6.783 0 002.223-.127 6.433 6.433 0 013.772-.57z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M490.963 348.312s-5.581-1.44-6.519-1.44a37.6 37.6 0 00-4.709.413c-1 .133-4.338-.2-5.362.284a18.479 18.479 0 01-6.584.782c-1.155-.195 2.377 3.186 3.771 3.555 4.491 1.29 3.118 1.072 6.083.351 1.744-.419 4.273-.569 5.144-.72.938-.133.72-.63 1.94-1.155a16.821 16.821 0 016.236-2.093' fill='%23090'/%3e%3cpath d='M490.963 348.312s-5.581-1.44-6.519-1.44a37.6 37.6 0 00-4.709.413c-1 .133-4.338-.2-5.362.284a18.479 18.479 0 01-6.584.782c-1.155-.195 2.377 3.186 3.771 3.555 4.491 1.29 3.118 1.072 6.083.351 1.744-.419 4.273-.569 5.144-.72.938-.133.72-.63 1.94-1.155a16.821 16.821 0 016.236-2.093z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M495.54 350.645s-5.58-2.31-9.918-1.155a24.8 24.8 0 01-4.12.937c-1.374.194-2.53-.5-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.9 3.249 5.275 3.03 4.491-.636 8.7.849 10.726.063 1.875-.715 2.965-1.218 3.9-1.5.938-.352 1.44-1.223 2.027-1.591.567-.5.938-1.591 4.273-2.528' fill='%23090'/%3e%3cpath d='M495.54 350.645s-5.58-2.31-9.918-1.155a24.8 24.8 0 01-4.12.937c-1.374.194-2.53-.5-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.9 3.249 5.275 3.03 4.491-.636 8.7.849 10.726.063 1.875-.715 2.965-1.218 3.9-1.5.938-.352 1.44-1.223 2.027-1.591.567-.5.938-1.591 4.273-2.528' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M465.718 337.781s-3.182-3.556-3.836-3.99c-.567-.5-2.093-1.59-2.9-2.31-.72-.57-1.374-1.876-3.466-2.378-.872-.195-3.03-.631-3.618-1.373-.568-.782.13 2.813.784 3.773a7.422 7.422 0 003.466 2.528c1.374.5 3.183 1.507 3.837 1.808a5.919 5.919 0 002.026.787 7.273 7.273 0 013.686 1.155' fill='%23090'/%3e%3cpath d='M465.718 337.781s-3.182-3.556-3.836-3.99c-.567-.5-2.093-1.59-2.9-2.31-.72-.57-1.374-1.876-3.466-2.378-.872-.195-3.03-.631-3.618-1.373-.568-.782.13 2.813.784 3.773a7.422 7.422 0 003.466 2.528c1.374.5 3.183 1.507 3.837 1.808a5.919 5.919 0 002.026.787 7.273 7.273 0 013.686 1.155z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M468.749 339.242s-5.428-3.838-6.3-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1-.782-.131 2.595.937 3.621 3.467 3.115 1.068 2.154 3.99 2.747 1.722.345 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195a19.62 19.62 0 016.517.787' fill='%23090'/%3e%3cpath d='M468.749 339.242s-5.428-3.838-6.3-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1-.782-.131 2.595.937 3.621 3.467 3.115 1.068 2.154 3.99 2.747 1.722.345 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195a19.62 19.62 0 016.517.787z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M470.056 340.265a18.861 18.861 0 00-6.67-2.155 29.631 29.631 0 01-4.055-1 12.328 12.328 0 00-4.121-.5c-1.22-.128-6.082 1.44-7.17.787-1.07-.57 1.153 1.434 2.527 1.937 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25' fill='%23090'/%3e%3cpath d='M470.056 340.265a18.861 18.861 0 00-6.67-2.155 29.631 29.631 0 01-4.055-1 12.328 12.328 0 00-4.121-.5c-1.22-.128-6.082 1.44-7.17.787-1.07-.57 1.153 1.434 2.527 1.937 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M470.514 339.176s1.156-5.363.2-6.585a4.9 4.9 0 01-1.222-2.813 10.021 10.021 0 00-1.59-4.208c-.568-.714-1.723-4.119-1.44-4.989 0 0-3.117 3.03-2.9 4.989a12.173 12.173 0 010 2.317c-.2.847.72 3.833 1.286 4.7.567.853.284 3.553.872 4.056.567.63 4.055 2.964 4.774 2.528' fill='%23090'/%3e%3cpath d='M470.514 339.176s1.156-5.363.2-6.585a4.9 4.9 0 01-1.222-2.813 10.021 10.021 0 00-1.59-4.208c-.568-.714-1.744-4.119-1.44-4.989 0 0-3.117 3.03-2.9 4.989a12.173 12.173 0 010 2.317c-.2.847.72 3.833 1.286 4.7.567.853.284 3.553.872 4.056.567.63 4.055 2.964 4.774 2.528z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M470.056 340.265a13.207 13.207 0 00-2.9-2.094c-1-.412-5.145-1.59-5.428-2.594-.284-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746a11.88 11.88 0 01.85-3.465c.415-1.072 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772a9.524 9.524 0 001 2.813c.414.563 1.961 3.332 2.027 4.426.2 1 .938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336' fill='%23090'/%3e%3cpath d='M470.056 340.265a13.207 13.207 0 00-2.9-2.094c-1-.412-5.145-1.59-5.428-2.594-.284-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746a11.88 11.88 0 01.85-3.465c.415-1.072 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772a9.524 9.524 0 001 2.813c.414.563 1.961 3.332 2.027 4.426.2 1 .938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M452.071 325.81c.066.787-2.244-.714-3.4-.714s-4.709.413-5.582-.42a32.834 32.834 0 00-2.68-2.812 16.268 16.268 0 01-2.463-4.335c-.415-1.5-3.467-4.12-3.9-4.426 0 0 4.186-.848 6.89.847a8.535 8.535 0 003.334 1.6c.633.278 5.145 4.118 5.43 5.58.282 1.434 2.157 3.984 2.374 4.705' fill='%23090'/%3e%3cpath d='M452.071 325.81c.066.787-2.244-.714-3.4-.714s-4.709.413-5.582-.42a32.834 32.834 0 00-2.68-2.812 16.268 16.268 0 01-2.463-4.335c-.415-1.5-3.467-4.12-3.9-4.426 0 0 4.186-.848 6.89.847a8.535 8.535 0 003.334 1.6c.633.278 5.145 4.118 5.43 5.58.282 1.434 2.157 3.984 2.374 4.705z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.9-5.276-4.772-.13-1-2.158-2.466-2.463-3.119-1.068-1.74-1.657-5.709-3.117-6.736 0 0 3.99 1 4.992 1.155 1.874.284 3.466.57 4.207 2.25.784 1.59 1.374 2.9 1.962 3.029.567.129 1.439 2.155 1.722 4.27.284 2.026 2.66 6.452 2.66 6.452' fill='%23090'/%3e%3cpath d='M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.9-5.276-4.772-.13-1-2.158-2.466-2.463-3.119-1.068-1.72-1.657-5.709-3.117-6.736 0 0 3.99 1 4.992 1.155 1.874.284 3.466.57 4.207 2.25.784 1.59 1.374 2.9 1.962 3.029.567.129 1.439 2.155 1.722 4.27.284 2.026 2.66 6.452 2.66 6.452z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M444.9 305.8c.566 1.006.566-5.86.785-6.514a10.423 10.423 0 011.656-2.812c.568-.567.568-2.594.85-3.184a15.5 15.5 0 00-.282-5.58 10.477 10.477 0 00-1.723 1.591c-.633.72-1.592 1-1.94 1.875-.284.85-.85.85-1.286 1.81a5.7 5.7 0 00-.567 3.466 8.671 8.671 0 01.13 2.681 21.431 21.431 0 002.377 6.667' fill='%23090'/%3e%3cpath d='M444.9 305.8c.566 1.006.566-5.86.785-6.514a10.423 10.423 0 011.656-2.812c.568-.567.568-2.594.85-3.184a15.5 15.5 0 00-.282-5.58 10.477 10.477 0 00-1.723 1.591c-.633.72-1.592 1-1.94 1.875-.284.85-.85.85-1.286 1.81a5.7 5.7 0 00-.567 3.466 8.671 8.671 0 01.13 2.681 21.431 21.431 0 002.377 6.667' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M444.965 306.456s-.283-1.941.5-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1 .436-1.591a10.759 10.759 0 001-2.092c.283-1.592 1.156-3.337.415-5.058a10.189 10.189 0 00-2.028.85 4.072 4.072 0 00-1.874 2.593 4.051 4.051 0 01-.786 2.246c-.414.72-1 2.9-.283 4.207a6.635 6.635 0 01.85 2.683' fill='%23090'/%3e%3cpath d='M444.965 306.456s-.283-1.941.5-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1 .436-1.591a10.759 10.759 0 001-2.092c.283-1.592 1.156-3.337.415-5.058a10.189 10.189 0 00-2.028.85 4.072 4.072 0 00-1.874 2.593 4.051 4.051 0 01-.786 2.246c-.414.72-1 2.9-.283 4.207a6.635 6.635 0 01.85 2.683z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M440.692 283.958s-.283-4.274.938-5.581c1.155-1.286 1.439-3.771 4.055-5.145a7.578 7.578 0 000 1.81c.195.632.5 2.746 0 3.465-.414.72-1.876 2.028-1.876 2.682a3.842 3.842 0 01-1.722 2.31 9.135 9.135 0 01-1.374.415' fill='%23090'/%3e%3cpath d='M440.692 283.958s-.283-4.274.938-5.581c1.155-1.286 1.439-3.771 4.055-5.145a7.578 7.578 0 000 1.81c.195.632.5 2.746 0 3.465-.414.72-1.876 2.028-1.876 2.682a3.842 3.842 0 01-1.722 2.31 9.135 9.135 0 01-1.374.415z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M440.692 286.268s0-3.03.938-3.9c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682a10.052 10.052 0 002.964-2.594s.415 3.619-.566 5.58c-1.069 1.875-1.069 2.9-2.181 3.336a5.039 5.039 0 00-1.81 1 3.118 3.118 0 01-1.721.718 2.789 2.789 0 00-1.221.415' fill='%23090'/%3e%3cpath d='M440.692 286.268s0-3.03.938-3.9c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682a10.052 10.052 0 002.964-2.594s.415 3.619-.566 5.58c-1.069 1.875-1.069 2.9-2.181 3.336a5.039 5.039 0 00-1.81 1 3.119 3.119 0 01-1.743.718 2.777 2.777 0 00-1.22.415z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M444.093 306.3c.13.854.785-1.875-2.31-1.875a9.885 9.885 0 01-6.606-2.243 17.33 17.33 0 01-2.006-2.245 7.42 7.42 0 01-1.81-3.03c-.13-.851-1-4.12-.849-4.71a6.277 6.277 0 012.31.85c.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.312 1.285a13.138 13.138 0 011.809 3.685 3.859 3.859 0 001.874 2.158c.72.414.567 2.157.72 2.967' fill='%23090'/%3e%3cpath d='M444.093 306.3c.13.854.785-1.875-2.31-1.875a9.885 9.885 0 01-6.606-2.243 17.33 17.33 0 01-2.006-2.245 7.42 7.42 0 01-1.81-3.03c-.13-.851-1-4.12-.849-4.71a6.277 6.277 0 012.31.85c.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.312 1.285a13.138 13.138 0 011.809 3.685 3.859 3.859 0 001.874 2.158c.72.414.567 2.157.72 2.967z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M443.81 305.145s-2.027-2.527-3.118-2.527c-1 0-3.619-2.681-3.771-3.771a8.006 8.006 0 00-1.592-3.837 3.708 3.708 0 01-1.5-3.248c.218-1.723.218-4.622.218-4.622s.566 1.723 1.44 2.158c.849.414 2.463 1 2.746 1.592.283.567 1.438.567 1.961 2.376a5.761 5.761 0 00.72 2.159 8.94 8.94 0 011.286 2.462c.284 1.22 1.874 4.273 1.592 7.235' fill='%23090'/%3e%3cpath d='M443.81 305.145s-2.027-2.527-3.118-2.527c-1 0-3.619-2.681-3.771-3.771a8.006 8.006 0 00-1.592-3.837 3.708 3.708 0 01-1.5-3.248c.218-1.723.218-4.622.218-4.622s.566 1.723 1.44 2.158c.849.414 2.463 1 2.746 1.592.283.567 1.438.567 1.961 2.376a5.761 5.761 0 00.72 2.159 8.94 8.94 0 011.286 2.462c.284 1.22 1.874 4.273 1.592 7.235z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M440.758 288.884c-.066.785 1.155-1.5-1.593-2.377a9.434 9.434 0 01-5.427-3.836c-.567-1.155-.938-2.026-1.221-2.528a8.025 8.025 0 01-.72-3.249c.066-.85.2-4.054.5-4.556a6.562 6.562 0 011.874 1.439c.5.785 1.656 1.155 2.245 1.722a11.1 11.1 0 011 2.376c.282.5 1.439.85 1.721 1.81a10.374 10.374 0 01.567 3.836 4.089 4.089 0 001.155 2.53c.5.566-.065 2.092-.13 2.812' fill='%23090'/%3e%3cpath d='M440.758 288.884c-.066.785 1.155-1.5-1.593-2.377a9.434 9.434 0 01-5.427-3.836c-.567-1.155-.938-2.026-1.221-2.528a8.025 8.025 0 01-.72-3.249c.066-.85.2-4.054.5-4.556a6.562 6.562 0 011.874 1.439c.5.785 1.656 1.155 2.245 1.722a11.1 11.1 0 011 2.376c.282.5 1.439.85 1.721 1.81a10.374 10.374 0 01.567 3.836 4.089 4.089 0 001.155 2.53c.5.566-.065 2.092-.13 2.812z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M440.823 287.729s-1.221-2.813-2.18-3.118c-.85-.282-2.377-2.68-2.442-3.77-.13-1.222-.349-3.4-.719-3.9a4.681 4.681 0 01-.633-3.9c.633-1.591 1.658-3.685 1.658-3.685s.784 1.374 1.286 2.159c.72 1.5 1.5 1.592 1.59 2.158.131.633 1 1 1.374 2.224.437 1.656-.065 1.59.066 2.245a9.536 9.536 0 01.5 2.593c-.065 1.157.567 4.34-.5 6.956' fill='%23090'/%3e%3cpath d='M440.823 287.729s-1.221-2.813-2.18-3.118c-.85-.282-2.377-2.68-2.442-3.77-.13-1.222-.349-3.4-.719-3.9a4.681 4.681 0 01-.633-3.9c.633-1.591 1.658-3.685 1.658-3.685s.784 1.374 1.286 2.159c.72 1.5 1.5 1.592 1.59 2.158.131.633 1 1 1.374 2.224.437 1.656-.065 1.59.066 2.245a9.536 9.536 0 01.5 2.593c-.065 1.157.567 4.34-.5 6.956z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M443.069 270.028c.13-.415 1-.851 2.092-1.221 1-.284 2.595-2.6 3.335-3.183.655-.633 1-1.5 1.963-2.028.85-.5 1.373-2.31 1.656-4.119 0 0-2.464.565-3.183.721a6.9 6.9 0 00-2.747 1.718c-.631.72-1.22 1.942-1.809 2.225-.567.284-1.286 2.028-1.286 3.248v2.595' fill='%23090'/%3e%3cpath d='M443.069 270.028c.13-.415 1-.851 2.092-1.221 1-.284 2.595-2.6 3.335-3.183.655-.633 1-1.5 1.963-2.028.85-.5 1.373-2.31 1.656-4.119 0 0-2.464.565-3.183.721a6.9 6.9 0 00-2.747 1.718c-.631.72-1.22 1.942-1.809 2.225-.567.284-1.286 2.028-1.286 3.248v2.595z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.145.85-1.283 4.12-3.772 4.992-3.9a13.109 13.109 0 01.436 3.03c-.13.72-.937 3.683-1.591 3.988-.633.283-2.377 3.772-4.426 4.556' fill='%23090'/%3e%3cpath d='M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.145.85-1.283 4.12-3.772 4.992-3.9a13.109 13.109 0 01.436 3.03c-.13.72-.937 3.683-1.591 3.988-.633.283-2.377 3.772-4.426 4.556' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M442.2 270.028c-.349.632-.13-2.225-1-2.9a3.707 3.707 0 01-1-2.965 9.552 9.552 0 01.415-2.81c.066-.72 2.311-3.773 2.158-4.621 0 0 1.286 2.807 1.59 3.616.5 1-.282 2.093-.13 2.963.13.852.85 2.465.35 3.337-.5.785-1.81 2.377-2.4 3.4' fill='%23090'/%3e%3cpath d='M442.2 270.028c-.349.632-.13-2.225-1-2.9a3.707 3.707 0 01-1-2.965 9.552 9.552 0 01.415-2.81c.066-.72 2.311-3.773 2.158-4.621 0 0 1.286 2.807 1.59 3.616.5 1-.282 2.093-.13 2.963.13.852.85 2.465.35 3.337-.5.785-1.81 2.377-2.4 3.4z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M449.979 254.857s.131-.442 1.5-.442c1.286 0 3.183-.061 3.772-.714a11.374 11.374 0 012.157-1.595 5.57 5.57 0 001.81-2.244c.131-.564 1.155-1.72 1.591-1.72a11.131 11.131 0 00-3.4.348c-1.723.345-4.208 1.283-4.775 2.46a38.561 38.561 0 01-2.68 3.907' fill='%23090'/%3e%3cpath d='M449.979 254.857s.131-.442 1.5-.442c1.286 0 3.183-.061 3.772-.714a11.374 11.374 0 012.157-1.595 5.57 5.57 0 001.81-2.244c.131-.564 1.155-1.72 1.591-1.72a11.131 11.131 0 00-3.4.348c-1.723.345-4.208 1.283-4.775 2.46a38.561 38.561 0 01-2.68 3.907z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M450.48 254.572c.284 1 2.747-1 3.336-1.724.567-.72 1.439-1.875 1.439-1.875a20.088 20.088 0 001.722-2.372c.937-1.6.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374a2.409 2.409 0 00-1.592 1.132 7.288 7.288 0 01-1.068 2.243c-.348.441-3.03 1.875-1.657 5.5' fill='%23090'/%3e%3cpath d='M450.48 254.572c.284 1 2.747-1 3.336-1.724.567-.72 1.439-1.875 1.439-1.875a20.088 20.088 0 001.722-2.372c.937-1.6.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374a2.409 2.409 0 00-1.592 1.132 7.288 7.288 0 01-1.068 2.243c-.348.441-3.03 1.875-1.657 5.5' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M449.543 254.572s2.026-1.44 2.812-2.16c.85-.847.414-2.026.85-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.849-.849-3.332-.849-3.332a19.352 19.352 0 00-1.722 1.719 4.085 4.085 0 00-1.222 2.182 19.313 19.313 0 01-1.155 2.243 7.594 7.594 0 00.131 3.03 6.6 6.6 0 010 1.724' fill='%23090'/%3e%3cpath d='M449.543 254.572s2.026-1.44 2.812-2.16c.85-.847.414-2.026.85-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.849-.849-3.332-.849-3.332a21.681 21.681 0 00-1.744 1.719 4.077 4.077 0 00-1.221 2.182 19.467 19.467 0 01-1.156 2.243 7.63 7.63 0 00.13 3.03 6.551 6.551 0 010 1.724z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M481.96 347.068s-9.636-.068-10.508-1.284m16.11 2.528s-6.3 1.72-9.635 1.284a17.682 17.682 0 00-5.712.284 31.069 31.069 0 01-4.426-1.507m26.226 2.272s-4.84.847-5.865 1.155c-1 .279-5.93 2.153-7.455 2.153-1.155 0-4.055-.06-4.84 0a17.3 17.3 0 01-6.147-.412m5.951-14.515a30.606 30.606 0 014.272 2.9c.568.786 3.837 3.4 4.426 3.4m-8.7-10.882s6.3 5.43 7.325 6.15c1.068.78 7.238 6.736 7.979 7.695M480.8 332.133s4.992 3.99 5.581 5.582a15.8 15.8 0 002.006 3.465s2.092 4.124 2.811 4.71a28.377 28.377 0 003.99 3.248m-42.815-20.71s5.21 4.425 6.67 5.273m-8.937-2.438a65.571 65.571 0 007.608 4.553 41.48 41.48 0 009.418 2.31m2.048 2.054s-5.864-.284-6.888 0c-1 .28-5.581-.72-6.736-1s-5.865-1.155-6.453-1.289m11.162-17.5a17.586 17.586 0 00.13 4.554c.414 1.289 2.441 5.056 2.311 6.016-.13.853 1.155 4.838 2.377 5.58m1.2-15.586s-1 3.186-.567 4.274a13.366 13.366 0 011.134 4.119 12.1 12.1 0 001 3.622c.283.72-.131 3.248.565 3.9.721.788 1.659 2.094 1.659 2.094m-35.207-25.465s4.708 1.725 5.3 2.9c.5 1.156 1.439 1.5 1.875 2.093m10.092-9.42s1.222 4.71.939 5.865a24.8 24.8 0 00-.283 4.426c0 .854-1.287 4.425-1.222 4.994m-1.308-19.208s-.435 2.745-.566 3.906a26.5 26.5 0 01-.284 3.834c-.283.72-.72 4.62 0 6.451m-12.077-10.267s3.836 3.247 4.71 4.123c.849.848 4.839 5.056 4.99 6.144.131 1 2.9 4.209 3.773 5m-19.926-31.676s3.837 3.771 4.12 4.621a7.523 7.523 0 002.682 2.813m11.118-5.82s-1.439 2.157-1.439 2.9a7.821 7.821 0 01-1.155 3.4 7.541 7.541 0 00-1.5 3.9m2.942-16.37s-.566 2.027-.85 3.467-1.069 2.964-1.286 3.836c-.283.85-1.5 5.145-1.068 7.761M434.3 287.947a7.005 7.005 0 001.44 3.03c1 1 2.593 2.529 2.746 3.335.13.937 1.5 5.275 2.965 6.8a5.377 5.377 0 011.592 2.964m-10.268-31.085a29.019 29.019 0 00.719 3.181c.283.72 1.5 3.99 2.682 4.993m9.286-7.52a15.394 15.394 0 00-.85 2.964 14.452 14.452 0 01-1.22 2.31c-.131.414-.72 1.94-.72 1.94m5.406-5.187c-.13.937-1.809 3.552-1.874 3.989-.2.5-1 2.529-1.94 3.117-.85.567-3.467 2.463-3.335 3.249m-4.318-16s-.13 3.183.414 4.338a27.422 27.422 0 011.592 3.836 12.479 12.479 0 01.414 3.337c.2 1.068.567 2.964 1.222 3.683m11.532-25.2s-2.16 2.377-3.118 3.4c-.938.936-4.709 4.991-4.84 5.71m4.4-11.29s-2.027 4.486-2.529 5.206a14.752 14.752 0 00-.784 1.942m-1.985-7.305s.132 3.555 0 4.425a9.656 9.656 0 000 2.75 28.417 28.417 0 01-.567 4.425m17.615-20.73a61.769 61.769 0 00-5.428 3.55m2.594-7.194l-3.183 4.627-.72 1.372m.284-6.435a18.428 18.428 0 00-1.155 3.466 29.505 29.505 0 01-2.245 5.43' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.273 348.027s.633-1.808 2.159-.195c0 0 1.744 4.118.414 4.27-1.286.133-2.594.418-2.747-.28a21.206 21.206 0 01.131-3.772' fill='%23004bb3'/%3e%3cpath d='M503.148 347.375s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.591 1.35.13 7.824-.414 8.477-.567.57-1.44 2.377-4.84 1.942l-.414-1.59a8.439 8.439 0 002.9-.787c1.22-.564 1.59-1.066 1.5-1.72-.131-.853-.065-4.123-1-4.424-.85-.286-2.246-.721-2.246-.721s-1.285 4.928-1.59 6.3l-.283-.418m-2.072 4.364s-6.082 3.466-2.964 8.763a2.649 2.649 0 01-2.093-1.284S495 361.37 496 362.526c0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.119 5.864-4.119l.2 1.44' fill='%23004bb3'/%3e%3cpath d='M501.121 351.8s-6.082 3.465-2.964 8.762a2.649 2.649 0 01-2.093-1.284S495 361.37 496 362.526c0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.119 5.864-4.119l.2 1.44' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M501.121 348.9a8.206 8.206 0 00-6.43-.781s-1.744-5.431-1.069-7.178a1.159 1.159 0 01.85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.2-1.44' fill='%23004bb3'/%3e%3cpath d='M501.121 348.9a8.206 8.206 0 00-6.43-.781s-1.744-5.431-1.069-7.178a1.159 1.159 0 01.85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.2-1.44z' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M501.121 348.9s-5.275-8.851-6.67-8.851c0 0-1.5-.2 1.874-.564 1.22-.134 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927a1.91 1.91 0 00-1.155 1.808' fill='%23004bb3'/%3e%3cpath d='M501.121 348.9s-5.275-8.851-6.67-8.851c0 0-1.5-.2 1.874-.564 1.22-.134 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927a1.91 1.91 0 00-1.155 1.808z' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M501.121 348.9a36.814 36.814 0 01-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1 2.46a29.393 29.393 0 001.222 5.581 8.412 8.412 0 016.43.788' fill='%23003'/%3e%3cpath d='M501.121 348.9a36.814 36.814 0 01-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1 2.46a29.393 29.393 0 001.222 5.581 8.412 8.412 0 016.43.788z' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M504.3 351.8a4.235 4.235 0 011.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1-1.942 0 0 1.723 2.093 2.31 2.093a9.738 9.738 0 01-1-2.813c0-.848-.85-4.27-1.722-5.055a11.931 11.931 0 00-5.145-3.685v1' fill='%23004bb3'/%3e%3cpath d='M504.3 351.8a4.235 4.235 0 011.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1-1.942 0 0 1.723 2.093 2.31 2.093a9.738 9.738 0 01-1-2.813c0-.848-.85-4.27-1.722-5.055a11.931 11.931 0 00-5.145-3.685v.983z' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M505.045 341.487l-1.59 6.3.413 1.373a1.332 1.332 0 00.85-.847c.283-.788 1.156-6.151 1.657-6.39l-1.375-.414' fill='%23003'/%3e%3cpath d='M505.045 341.487l-1.59 6.3.413 1.373a1.332 1.332 0 00.85-.847c.283-.788 1.156-6.151 1.657-6.39l-1.375-.414z' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M501.056 351.08s-2.9.848-3.99 3.114c0 0-.348-1.434 3.837-3.465l.131.35m3.356 0s2.029.782 2.53 1.936a27.232 27.232 0 00-2.529-1.434v-.5m-3.335-1.68s-4.491.72-5.516.5a23.591 23.591 0 005.582-.068l-.066-.413m7.26-2.767s.5 2.243.85 2.16c.348-.2 1.067-3.773 1.154-5.5.066-1.59-.719-2.026-1.35-1.875-.633 0-1 1.507-.938 2.16a27.323 27.323 0 00.283 3.03' fill='%2300004b'/%3e%3cpath d='M503.454 347.81s1.81 4.052.414 4.269c-1.373.2.567.133-.349-2.59-.348-1.071-.938-2.376-1.221-2.376 0 0 1 .412 1.156.719' fill='%2300004b'/%3e%3cpath d='M501.273 348.027s.633-1.808 2.159-.195c0 0 1.744 4.118.414 4.27-1.286.133-2.594.418-2.747-.28a21.206 21.206 0 01.131-3.772zm1.875-.652s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.591 1.35.13 7.824-.414 8.477-.567.57-1.44 2.377-4.84 1.942l-.414-1.59a8.439 8.439 0 002.9-.787c1.22-.564 1.59-1.066 1.5-1.72-.131-.853-.065-4.123-1-4.424-.85-.286-2.246-.721-2.246-.721s-1.285 4.928-1.59 6.3l-.283-.418z' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M496.63 240.576c-.349-.938-.414-7.238-.349-8.2.066-1.658 3.03-10.007 3.62-10.945.632-.937.413-1.154.72-1.718l.784-1.156a9.574 9.574 0 011.22 3.99 58.628 58.628 0 01-1 5.8 27.2 27.2 0 01-1.723 4.7c-.566 1.222-.5 2.31-.13 2.444l-3.117 5.056' fill='%23004bb3'/%3e%3cpath d='M501.624 232.227l.5.5c1.286-1.44 1.374-4.342 1.374-4.342l-.851-5.86a58.677 58.677 0 01-1 5.8 27.424 27.424 0 01-1.721 4.706c-.85 2.092-.2 2.315-.132 2.444l1.876-3.248' fill='white'/%3e%3cpath d='M502.146 232.729c1.286-1.44 1.373-4.342 1.373-4.342s.938 4.777.414 5.8c-.5 1-.5.715-.414 1.218l-1.373-2.68' fill='%23004bb3'/%3e%3cpath d='M503.52 235.408c-.066-.5-.066-.195.413-1.217.5-1-.414-5.8-.414-5.8l-.85-5.86a9.176 9.176 0 00-1.22-3.99l-.786 1.155c-.282.564-.065.782-.719 1.719-.567.938-3.553 9.27-3.619 10.945-.065.937 0 7.238.349 8.2' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M501.624 219.3s-.066-.937-.132-1.289c-.066-.129.5.848.937.72a5.743 5.743 0 012.028 1.724c-.35.5-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.441a3.8 3.8 0 01-.348-1.072' fill='%23fc0'/%3e%3cpath d='M501.624 219.3s-.066-.937-.132-1.289c-.066-.129.5.848.937.72a5.743 5.743 0 012.028 1.724c-.35.5-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.441a3.8 3.8 0 01-.348-1.072z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.71 218.515c.066.067.283.346.35.435.194.067.348 0 .631.129a9.432 9.432 0 011.505 1.44m-1.92-1.352a5.259 5.259 0 011.81 1.725v-.134' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M500.75 218.643a10.393 10.393 0 001.134-.63c.131-.068-.632.786-.349 1.133a4.688 4.688 0 01-.937 2.528c-.567-.195-1.22-.195-1.722-1.155-.2-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787' fill='%23fc0'/%3e%3cpath d='M500.75 218.643a10.393 10.393 0 001.134-.63c.131-.068-.632.786-.349 1.133a4.688 4.688 0 01-.937 2.528c-.567-.195-1.22-.195-1.722-1.155-.2-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.558 218.365a1.083 1.083 0 00-.284.5c0 .2.13.351.065.636a8.733 8.733 0 01-.785 1.936m.567-2.266a4.6 4.6 0 01-1 2.244h.131' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M502.06 218.013c.565-.631 1.655-1.284 2.157-.848a2.922 2.922 0 01.567.5c.282.28.2.413.065.781-.349.721-1.352.352-2.027 0-.13-.066-.5-.412-.72-.284-.282.067-.2.067-.282.067.064.135.194.067.282.135a14.754 14.754 0 011.722.78c.5.2 1.44-.412 1.374-.937 0-.5-.85-1.5-1.286-1.5a3.472 3.472 0 00-2.377 1.371c.2-.133.349.129.5-.066' fill='%23fc0'/%3e%3cpath d='M502.06 218.013c.565-.631 1.655-1.284 2.157-.848a2.922 2.922 0 01.567.5c.282.28.2.413.065.781-.349.721-1.352.352-2.027 0-.13-.066-.5-.412-.72-.284-.282.067-.2.067-.282.067.064.135.194.067.282.135a14.754 14.754 0 011.722.78c.5.2 1.44-.412 1.374-.937 0-.5-.85-1.5-1.286-1.5a3.472 3.472 0 00-2.377 1.371c.2-.133.349.129.5-.066z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.558 218.013c-.567-.631-1.657-1.284-2.16-.848a2.37 2.37 0 00-.565.5.674.674 0 00-.066.781c.348.721 1.373.352 2.027 0 .131-.066.5-.412.72-.284.348.067.2.067.348.067-.13.135-.283.067-.414.135-.5.127-.938.5-1.657.78a1.284 1.284 0 01-1.438-.937c.065-.563.938-1.5 1.373-1.5a3.305 3.305 0 012.377 1.371c-.131-.133-.35.129-.5-.066' fill='%23fc0'/%3e%3cpath d='M501.558 218.013c-.567-.631-1.657-1.284-2.16-.848a2.37 2.37 0 00-.565.5.674.674 0 00-.066.781c.348.721 1.373.352 2.027 0 .131-.066.5-.412.72-.284.348.067.2.067.348.067-.13.135-.283.067-.414.135-.5.127-.938.5-1.657.78a1.284 1.284 0 01-1.438-.937c.065-.563.938-1.5 1.373-1.5a3.305 3.305 0 012.377 1.371c-.131-.133-.35.129-.5-.066z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.776 217.645c-.284-.135-.568.127-.655.278-.065.2.065.57.284.57.348.128.85.066.938-.285.065-.346-.284-.413-.567-.563' fill='%23fc0'/%3e%3cpath d='M501.776 217.645c-.284-.135-.568.127-.655.278-.065.2.065.57.284.57.348.128.85.066.938-.285.065-.346-.284-.413-.567-.563' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.71 211.757a10.735 10.735 0 001.5 3.9 11.235 11.235 0 00-1.591 2.027 5.6 5.6 0 00-1.5-2.094 13.269 13.269 0 001.591-3.833' fill='%23fc0'/%3e%3cpath d='M501.71 211.757a10.735 10.735 0 001.5 3.9 11.235 11.235 0 00-1.591 2.027 5.6 5.6 0 00-1.5-2.094 13.269 13.269 0 001.591-3.833m-.087 2.4a10.247 10.247 0 00.632 1.656 4.063 4.063 0 00-.632.632 2.167 2.167 0 00-.567-.788 3.46 3.46 0 00.567-1.5' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M528.613 277.2c1.434-3.554 2.963-10.944 2.9-12.623-.284-6.89-.2-8.984-.847-16.087l-7.112 8.2a26.264 26.264 0 01-1 10.267l6.085 10.224' fill='white'/%3e%3cpath d='M522.53 266.975a27.289 27.289 0 001-4.991 28.241 28.241 0 000-5.274l-4.428 4.838 3.4 5.427m18.228 6.671c.129-1.591.195-3.335.195-4.12 0-4.992.564-7.76 0-13.056-.35-4.125-1.44-9.638-1.221-14.064.066-1.283-.129-2.528-.129-3.773l-8.918 9.857c.63 7.1.564 9.2.848 16.087.067 1.657-1.44 9.07-2.9 12.622l1.875 3.183 10.224-6.736' fill='%23004bb3'/%3e%3cpath d='M518.452 260.9l20.82-23.066.346.5-20.512 23.194-.632-.63' fill='%23fc0'/%3e%3cpath d='M518.452 260.9l20.82-23.066.346.5-20.512 23.194-.632-.63z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M539.076 244.259s-1.657 14.565-7.327 14' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M531.749 258.188c2.813.135 4.621-3.465 5.715-6.8a41.3 41.3 0 001.59-7.177' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M531.749 258.188c2.813-.128 4.621-3.773 5.648-6.887a42.121 42.121 0 001.657-7.11' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M531.749 258.127c2.813-.2 4.621-3.99 5.648-6.96a47.856 47.856 0 001.657-7.013' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M531.749 258.06c2.813-.413 4.621-4.209 5.582-6.954a49.089 49.089 0 001.745-7.02' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M531.666 257.971c2.806-.564 4.7-4.487 5.58-6.953a50.784 50.784 0 001.808-7.018' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M531.666 257.971c2.806-.781 4.7-4.771 5.58-7.02a47.72 47.72 0 001.808-6.951' fill='none' stroke='%23002289' stroke-width='.232'/%3e%3cpath d='M531.666 257.91c2.806-.938 4.7-5 5.424-7.11a52.781 52.781 0 001.964-6.888' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M531.666 257.91c2.806-1.223 4.7-5.28 5.424-7.178a62.406 62.406 0 001.964-6.886' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M531.6 257.754c2.9-1.284 4.771-5.426 5.424-7.105a58.951 58.951 0 002.03-6.892' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M531.6 257.754c2.9-1.5 4.771-5.8 5.424-7.172 1-2.595 1.942-6.518 2.03-6.8' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M531.6 257.686c2.812-1.652 4.771-6.016 5.274-7.17a47.658 47.658 0 002.16-6.8' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M531.531 257.686c2.9-1.875 4.84-6.295 5.363-7.322a66.792 66.792 0 002.16-6.735' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M538.988 243.606a39.676 39.676 0 01-2.16 6.67c-.436.785-2.372 5.211-5.274 7.237' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M538.86 240.927s-4.711 11.6-7.7 10.285' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M531.163 251.235c1.217.569 3.18-1.719 4.772-4.487q1.574-2.839 2.9-5.8' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M531.163 251.169c1.066.5 3.115-1.653 4.705-4.488q1.621-2.828 2.969-5.8' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M531.163 251.169c.848.44 3.03-1.653 4.62-4.555 1.81-3.248 3.031-5.708 3.031-5.708' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M531.1 251.169c.787.283 3.03-1.653 4.71-4.622q1.567-2.826 3.03-5.708' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M531.1 251.084c.631.285 2.963-1.59 4.621-4.62 1.942-3.556 3.03-5.715 3.03-5.715' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M531.1 251.084c.413.195 2.9-1.59 4.621-4.777l3.03-5.642' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M531.1 251.084c.284.128 2.813-1.59 4.554-4.838 2.093-3.84 3.03-5.582 3.03-5.582' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M531.1 251.084a12.226 12.226 0 004.493-4.838c2.154-4.057 3.114-5.648 3.114-5.648' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M538.7 240.576s-.938 1.373-3.181 5.49a12.5 12.5 0 01-4.493 4.93m-7.494 8l-3.993 2.16m3.708 1.612l-3.686-.636' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M523.617 259.215l-4.053 1.943' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M523.534 259.366l-4.057 1.875' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M523.534 259.583l-4.057 1.658' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M523.534 259.718l-4.123 1.59' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M523.534 259.868l-4.123 1.44' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M523.534 260.086l-4.123 1.223' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M523.534 260.237l-4.21 1.154' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M523.534 260.46l-4.275.931' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M523.534 260.589l-4.275.847' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M523.31 262.615l-3.833-.565' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M523.31 262.4l-3.833-.413' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M523.31 262.178l-3.9-.284' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M523.31 262.05l-3.9-.134' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M523.31 261.833h-3.986' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M523.4 261.615l-4.12.128' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M523.4 261.391l-4.12.286' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M523.467 261.241l-4.273.351' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M523.467 261.023l-4.273.57' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M523.467 260.806l-4.339.72' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M540.734 273.646a28.761 28.761 0 00.129-3.117c0-4.993.63-8.764.066-14.06-.35-4.124-1.44-9.637-1.221-14.063.066-1.283-.129-2.528-.129-3.773l-20.45 22.915' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M540.734 261.894a17.139 17.139 0 01-.938 4.34c-.937 1.875-3.772 4.621-7.02 6.671' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M532.687 272.926a28.555 28.555 0 005.363-4.49 12.982 12.982 0 001.59-2.245 15.238 15.238 0 001-4.336' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M532.6 272.926a28.323 28.323 0 005.274-4.621 13.218 13.218 0 001.657-2.158 16.79 16.79 0 001.066-4.337' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M532.536 272.926a30.018 30.018 0 005.207-4.621A15.024 15.024 0 00539.4 266a16.553 16.553 0 001.221-4.34' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M532.47 272.861a34.728 34.728 0 005.144-4.621 9.572 9.572 0 001.658-2.311 17.2 17.2 0 001.374-4.336' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M532.38 272.861a33.2 33.2 0 005.145-4.709 16.83 16.83 0 001.6-2.31 17.134 17.134 0 001.524-4.339' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M532.319 272.861a31.313 31.313 0 005.078-4.84 12.606 12.606 0 001.657-2.244 26.293 26.293 0 001.59-4.34' fill='none' stroke='%23002289' stroke-width='.232'/%3e%3cpath d='M532.251 272.861a31.683 31.683 0 005-4.926 16.491 16.491 0 001.652-2.246 26.4 26.4 0 001.747-4.337' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M532.162 272.861a32.291 32.291 0 005-4.991 14.374 14.374 0 001.59-2.246 28.094 28.094 0 001.875-4.338' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M532.1 272.861a45.035 45.035 0 004.923-5.058 13.626 13.626 0 001.6-2.31 32.516 32.516 0 001.937-4.335' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M532.034 272.861a41.421 41.421 0 004.839-5.144 16.6 16.6 0 001.59-2.311 38.844 38.844 0 002.093-4.338' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M531.944 272.861c1.943-1.5 3.84-4.12 4.845-5.21a15.366 15.366 0 001.5-2.31 42.487 42.487 0 002.245-4.34' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M531.883 272.774a34.958 34.958 0 004.772-5.21 21.406 21.406 0 001.568-2.311c1.155-1.942 2.31-4.335 2.31-4.335' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M540.577 260.806a60.427 60.427 0 01-4.051 6.67c-.937 1-2.751 3.772-4.71 5.277' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M540.516 273.646c-2.968 2.028-3.772 2.528-10 6.518l-1.876-2.965s.72-1.656 1-2.528' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M540.45 273.646c-2.814 1.94-3.84 2.528-9.923 6.365l-.061-.065-1.725-2.812s.134-.349.285-.784a7.225 7.225 0 00.63-1.657' fill='none' stroke='%2300004f' stroke-width='.232'/%3e%3cpath d='M540.45 273.646c-2.746 1.876-4.058 2.681-9.923 6.3l-.061-.13c0-.066-1.591-2.813-1.591-2.813a3.4 3.4 0 01.28-.719c.2-.5.35-1.156.5-1.591' fill='none' stroke='%23000053' stroke-width='.232'/%3e%3cpath d='M540.45 273.646c-2.685 1.723-4.119 2.681-9.923 6.147l-.061-.13c0-.066-1.507-2.747-1.507-2.747s.067-.283.2-.72c.2-.5.418-1.068.57-1.5' fill='none' stroke='%23000056' stroke-width='.232'/%3e%3cpath d='M540.45 273.581c-2.6 1.722-4.342 2.811-9.923 6.082l-.061-.066c0-.13-1.374-2.812-1.374-2.812a2.578 2.578 0 01.129-.632 9.834 9.834 0 00.5-1.439' fill='none' stroke='%23000058' stroke-width='.232'/%3e%3cpath d='M540.45 273.581c-2.528 1.656-4.493 2.9-9.923 6.016l-.061-.13c0-.2-1.29-2.812-1.29-2.812a1.879 1.879 0 01.134-.567 5.585 5.585 0 00.413-1.374' fill='none' stroke='%2300005c' stroke-width='.232'/%3e%3cpath d='M540.45 273.581c-2.377 1.59-4.622 2.964-9.923 5.864l-.061-.131c0-.2-1.156-2.747-1.156-2.747a.945.945 0 01.062-.566 9.072 9.072 0 00.35-1.286' fill='none' stroke='%23000060' stroke-width='.232'/%3e%3cpath d='M540.45 273.581c-2.31 1.5-4.839 2.964-9.923 5.712l-.061-.132c0-.2-1.072-2.747-1.072-2.747s-.061-.13.067-.5a4.927 4.927 0 00.285-1.221' fill='none' stroke='%23000062' stroke-width='.232'/%3e%3cpath d='M540.36 273.581c-2.16 1.439-4.928 3.03-9.85 5.646l-.067-.131c0-.283-1-2.747-.937-2.747 0 0-.134-.13 0-.5a3.55 3.55 0 00.2-1.155' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M540.36 273.516a82.979 82.979 0 01-9.85 5.58c-.067 0-.067-.13-.067-.13 0-.283-.854-2.748-.854-2.748s-.128-.065 0-.414a2.761 2.761 0 00.134-1.068' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M540.36 273.516a78.009 78.009 0 01-9.85 5.427c-.067 0-.067-.065-.134-.13a16.441 16.441 0 00-.72-2.682h.067a.317.317 0 01-.067-.414 2.415 2.415 0 00.067-1' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M540.36 273.516a76.082 76.082 0 01-9.85 5.362c-.067-.066-.067-.131-.134-.195 0-.285-.563-2.595-.563-2.595s-.2-.131-.068-.436a1.512 1.512 0 000-.938' fill='none' stroke='%2300096f' stroke-width='.232'/%3e%3cpath d='M540.36 273.516a78.353 78.353 0 01-9.85 5.21l-.134-.132c0-.414-.5-2.68-.5-2.68s-.194-.066-.128-.35a1.286 1.286 0 00.067-.85' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M540.36 273.516a68.1 68.1 0 01-9.917 5.078l-.067-.13c0-.436-.413-2.595-.346-2.681 0 0-.284-.066-.133-.284.066-.349 0-.349-.068-.785' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M540.36 273.516a65.649 65.649 0 01-9.917 4.991.644.644 0 00-.067-.195c0-.415-.346-2.6-.284-2.6 0 0-.279-.065-.195-.283.133-.284 0-.284-.068-.72' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M540.293 273.428a47.69 47.69 0 01-9.85 4.927l-.067-.2c0-.414-.195-2.53-.129-2.595 0 0-.35 0-.284-.195.067-.284-.066-.284-.133-.634' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M540.293 273.428a45.953 45.953 0 01-9.85 4.773l-.067-.13c0-.5-.129-2.594-.067-2.681 0 0-.346.065-.279-.13.129-.284-.067-.2-.2-.567' fill='none' stroke='%23001c82' stroke-width='.232'/%3e%3cpath d='M540.293 273.363a44.1 44.1 0 01-9.85 4.773.662.662 0 00-.067-.2c0-.566 0-2.529.067-2.594 0 0-.413.065-.351-.13.067-.283-.129-.13-.195-.5' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M540.293 273.363c-1.217.85-6.518 3.836-9.85 4.621a.641.641 0 00-.067-.2 23.465 23.465 0 01.135-2.594s-.5.13-.352-.066c.067-.195-.195-.065-.285-.414' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M540.232 273.363c-1.094.785-6.586 3.9-9.789 4.49a.642.642 0 01-.067-.195 21.363 21.363 0 01.2-2.53h.068s-.5.066-.413-.065c.061-.195-.2 0-.352-.349' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M540.232 273.363c-1 .719-6.736 3.989-9.789 4.425a.235.235 0 01-.067-.2 13.726 13.726 0 01.352-2.53s-.5.066-.5-.065c.128-.195-.2.066-.352-.282' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M540.232 273.363c-.937.632-6.893 4.054-9.789 4.272-.067-.065-.067-.13-.134-.195a20.572 20.572 0 01.5-2.53s-.565.131-.436 0c.067-.2-.346.131-.5-.2' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M540.232 273.363c-.877.5-7.021 4.054-9.789 4.207a1.709 1.709 0 00-.134-.282 9.8 9.8 0 01.658-2.53s-.569.131-.569.066c.068-.2-.284.195-.5-.131' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M540.232 273.3c-.787.5-7.238 4.207-9.789 4.12a.484.484 0 01-.134-.284 8.12 8.12 0 01.72-2.463s-.564.13-.564 0c.062-.065-.351.349-.568 0' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M540.232 273.3c-.636.5-7.394 4.272-9.789 3.989-.067-.066-.134-.13-.134-.2a6.5 6.5 0 01.854-2.529s-.72.195-.636.13c.067-.13-.346.35-.63 0' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M540.232 273.3c-.57.348-7.545 4.337-9.789 3.836-.067 0-.134-.13-.134-.195a6.939 6.939 0 01.938-2.465v-.065s-.72.283-.63.2c.066-.132-.413.414-.721.065' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M540.165 273.3c-.413.282-7.674 4.337-9.7 3.77a2.143 2.143 0 01-.194-.282 6.361 6.361 0 011.154-2.465s-.72.285-.72.2c0-.13-.5.5-.72.13' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M540.165 273.3c-.351.195-7.824 4.425-9.7 3.619a2.313 2.313 0 01-.194-.284c0-.785 1.154-2.312 1.216-2.464 0 0-.782.35-.72.2 0 0-.5.633-.782.284' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M540.165 273.3c-.285.13-7.98 4.49-9.789 3.552a.445.445 0 00-.129-.282 6.163 6.163 0 011.284-2.465s-.78.285-.72.285c0-.067-.564.567-.847.282' fill='none' stroke='%230042a8' stroke-width='.232'/%3e%3cpath d='M540.165 273.21c-.195.13-8.2 4.621-9.789 3.466 0-.065-.129-.13-.129-.283a4.79 4.79 0 011.435-2.377l-.78.284s-.632.633-.939.349' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M540.165 273.21c-.068.065-8.327 4.709-9.789 3.335 0-.065-.129-.13-.129-.282 0-.938 1.435-2.312 1.5-2.377l-.782.283s-.658.786-1 .5' fill='none' stroke='%230049af' stroke-width='.232'/%3e%3cpath d='M540.165 273.146s-9.482 5.361-9.917 2.963c0-.937 1.59-2.31 1.59-2.31l-.853.283s-.653.85-1 .567' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026a4.942 4.942 0 00-.786.061c-.346.134-.413.285-.5.636-.128.781.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285a.444.444 0 01-.285-.135c-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.42a3.169 3.169 0 011.155 2.468c-.067-.194-.35-.067-.35-.284' fill='%23fc0'/%3e%3cpath d='M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026a4.942 4.942 0 00-.786.061c-.346.134-.413.285-.5.636-.128.781.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285a.444.444 0 01-.285-.135c-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.42a3.169 3.169 0 011.155 2.468c-.067-.194-.35-.067-.35-.284z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M539.579 238.092c.847-.284 2.092-.134 2.31.413 0 .067.2.563.128.787.068.346-.066.5-.346.715-.72.35-1.378-.5-1.657-1.156a1.518 1.518 0 00-.418-.714c-.346-.068-.2 0-.346-.068.067.13.2.2.284.285.346.5.5.938.938 1.653.2.5 1.35.5 1.657.067a2.575 2.575 0 00-.2-2.026 3.015 3.015 0 00-2.747-.195c.195-.068.195.284.436.195' fill='%23fc0'/%3e%3cpath d='M539.579 238.092c.847-.284 2.092-.134 2.31.413a2 2 0 01.128.787c.068.346-.066.5-.346.715-.72.35-1.378-.5-1.657-1.156a1.518 1.518 0 00-.418-.714c-.346-.068-.2 0-.346-.068.067.13.2.2.284.285.346.5.5.938.938 1.653.2.5 1.35.5 1.657.067a2.575 2.575 0 00-.2-2.026 3.015 3.015 0 00-2.747-.195c.195-.068.195.284.436.195z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M539.64 237.673c.285 0 .351.42.285.637 0 .194-.346.345-.57.284-.345-.133-.63-.419-.5-.786.061-.352.5-.195.781-.135' fill='%23fc0'/%3e%3cpath d='M539.64 237.673c.285 0 .351.42.285.637 0 .194-.346.345-.57.284-.345-.133-.63-.419-.5-.786.061-.352.5-.195.781-.135' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M543.72 233.532a15.016 15.016 0 01-4.057 2.032 5.785 5.785 0 010 2.244 5.529 5.529 0 012.528-.5 9.226 9.226 0 011.507-3.773' fill='%23fc0'/%3e%3cpath d='M543.72 233.532a15.016 15.016 0 01-4.057 2.032 5.785 5.785 0 010 2.244 5.529 5.529 0 012.528-.5 9.226 9.226 0 011.507-3.773z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M542.13 235.19a6.738 6.738 0 01-1.658.787 1.829 1.829 0 010 .848 2.8 2.8 0 011-.128 4 4 0 01.636-1.507z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M539.947 239.549s-.569-.63-.787-.937c-.128-.129.285.937-.128 1.221a5.351 5.351 0 000 2.595 2.4 2.4 0 002.093-.345c.284-.285-.134-.855-.352-1.29-.128-.195-.346-.937-.781-1.222' fill='%23fc0'/%3e%3cpath d='M539.947 239.549s-.569-.63-.787-.937c-.128-.129.285.937-.128 1.221a5.351 5.351 0 000 2.595 2.4 2.4 0 002.093-.345c.284-.285-.134-.855-.352-1.29-.128-.195-.346-.937-.781-1.222z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M539.356 239.113c0 .068.067.42.067.5-.068.195-.285.284-.285.569a8.175 8.175 0 00.068 2.154m.217-2.416a6.081 6.081 0 00.134 2.46h-.134m.156-.937a3.658 3.658 0 01.129.938c.066-.062.194.067.284.067' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.624 326.9c-.066 0-.2-.134-.285-.195-.414-.2-1.067-.2-1.286-.42-1-1.154-.283-3.33.066-4.7a58.156 58.156 0 001.5-7.238h.065c.567 2.378.633 4.705 1.439 7.238.5 1.373 1.155 3.55.13 4.705-.195.2-.85.2-1.22.419-.13.061-.283.195-.414.195' fill='white'/%3e%3cpath d='M501.624 314.213c.565 2.377.719 4.839 1.5 7.394.414 1.218 1.069 3.249.283 4.42l-.012-.156a2.87 2.87 0 001.067-.2c.13-.067.21.03.3-.105a3.206 3.206 0 01.436-.5c.283-.133.566-.066.85-.2.066-.062.066-.13.13-.13a1.827 1.827 0 001.287-2.286 2.838 2.838 0 00-.284-.788 5.8 5.8 0 00-.5-1.065 8.08 8.08 0 00-.567-1.156 1.181 1.181 0 00-.283-.5 2.906 2.906 0 00-.284-.5c-.066-.195-.283-.285-.414-.5-.132-.128-.219-.128-.284-.284-.065 0-.283-.061-.2-.129a.7.7 0 01-.282-.128c-.284-.72-.655-1.072-.938-1.814a2.224 2.224 0 01-.2-1.155h-1.59' fill='%23004bb3'/%3e%3cpath d='M502.43 314.28a35.041 35.041 0 001.5 5c.567 1 2.813 2.808 1.286 5.709' fill='none' stroke='%23003' stroke-width='.232'/%3e%3cpath d='M502.276 314.28a28.091 28.091 0 001.592 5c.567 1.066 2.878 2.812 1.351 5.709' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M502.211 314.28a37.861 37.861 0 001.479 5.1c.567 1 2.812 2.963 1.22 5.865' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M502.06 314.28a36.435 36.435 0 001.59 5.146c.567 1 2.837 2.7 1.31 5.69' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M501.994 314.28s.936 4.209 1.59 5.212c.5 1 2.682 3.115 1.068 6.079' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M501.928 314.28a36.187 36.187 0 001.5 5.275c.567 1 2.682 3.185 1.068 6.15' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M502.5 314.28a30.09 30.09 0 001.591 4.928c.566 1.066 2.813 2.9 1.286 5.71' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M502.647 314.37a31.333 31.333 0 001.5 4.838c.566 1 2.9 2.9 1.373 5.71' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M502.713 314.37a27.5 27.5 0 001.59 4.838c.568 1 2.813 2.813 1.374 5.71' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M502.8 314.37a29.831 29.831 0 001.591 4.772c.567 1.071 2.9 2.9 1.374 5.714' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M502.93 314.37a25.7 25.7 0 001.592 4.772c.567 1 2.9 2.9 1.373 5.714' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M501.624 314.213c-.5 2.377-.633 4.839-1.5 7.394-.35 1.218-1 3.249-.2 4.42l-.066-.06h.066a3.169 3.169 0 01-1.069-.195c-.066-.069-.2-.069-.282-.2a1.8 1.8 0 00-.5-.5c-.2-.133-.5-.066-.719-.2-.065-.062-.13-.13-.2-.13a2.587 2.587 0 01-1.221-1.065 3.84 3.84 0 01-.066-1.221c.066-.286.2-.5.284-.788a5.751 5.751 0 01.5-1.065 7.874 7.874 0 01.567-1.156 190.615 190.615 0 01.566-1c.066-.195.283-.285.415-.5.13-.128.194-.128.348-.284 0 0 .2-.061.2-.129a.142.142 0 00.132-.128 11.373 11.373 0 001-1.814 2.224 2.224 0 00.2-1.155h1.5' fill='%23004bb3'/%3e%3cpath d='M500.9 314.28a34.94 34.94 0 01-1.5 5c-.566 1-2.813 2.808-1.374 5.709' fill='none' stroke='%23003' stroke-width='.232'/%3e%3cpath d='M501.056 314.28a34.94 34.94 0 01-1.5 5c-.633 1.066-2.835 2.963-1.286 5.86' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M501.121 314.28a39 39 0 01-1.5 5.146c-.567 1-2.812 2.963-1.22 5.864' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M501.273 314.28a34.292 34.292 0 01-1.525 5.146c-.633 1-2.812 3.03-1.221 6.016' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M501.34 314.28a35.98 35.98 0 01-1.5 5.212c-.567 1-2.747 3.115-1.155 6.079' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M501.405 314.28s-.85 4.275-1.5 5.275c-.566 1-2.68 3.185-1.067 6.15' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M500.838 314.28a38.373 38.373 0 01-1.5 4.928c-.567 1.066-2.9 2.9-1.374 5.71' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M500.75 314.37a34.783 34.783 0 01-1.59 4.838c-.568 1-2.9 2.9-1.374 5.71' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M500.6 314.37a27.385 27.385 0 01-1.592 4.838c-.5 1-2.811 2.813-1.286 5.71' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M500.533 314.37a21.653 21.653 0 01-1.656 4.772c-.5 1.071-2.813 2.9-1.287 5.714' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M500.4 314.37a25.7 25.7 0 01-1.592 4.772c-.567 1-2.812 2.9-1.286 5.714' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M498.157 317.768c-.132.2-.349.285-.415.5a1.378 1.378 0 00-.283.5 1.3 1.3 0 00-.283.5 10.655 10.655 0 00-.567 1.155 11.17 11.17 0 00-.5 1.066c-.065.285-.2.5-.282.787a3.809 3.809 0 00.064 1.217 2.478 2.478 0 001.221 1.071c.066 0 .131.062.195.13.2.133.5.065.721.194a1.855 1.855 0 01.5.5c.066.133.2.133.283.194a3.006 3.006 0 001.07.2h-.066l.065.061v-.06a.421.421 0 00.132.279c.195.194.849.194 1.285.419.066.06.2.194.283.194.132 0 .284-.133.416-.194.349-.2 1-.2 1.22-.42a.337.337 0 00.13-.279v0a2.756 2.756 0 001.07-.2c.13-.061.195-.061.282-.194a3.579 3.579 0 01.437-.5c.282-.129.566-.061.85-.195.064-.068.13-.129.13-.129a1.836 1.836 0 001.287-2.288 2.831 2.831 0 00-.284-.787 5.661 5.661 0 00-.5-1.066 7.792 7.792 0 00-.569-1.155 1.131 1.131 0 00-.282-.5 2.78 2.78 0 00-.284-.5c-.066-.195-.283-.285-.415-.5' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M543.942 272.661l-8.03 5.32a18.435 18.435 0 01-.2 4.821 23.061 23.061 0 01-1.222 4.274h-.04l6.678 11.145a32.89 32.89 0 003-10.667c.004-6.412.217-8.32-.186-14.893z' fill='white'/%3e%3cpath d='M534.5 287.075a23.218 23.218 0 001.222-4.274 18.423 18.423 0 00.2-4.84l-4.927 3.184 3.47 5.93' fill='%23004bb3'/%3e%3cpath d='M530.51 280.4l23.277-15.216.419.567-23.2 15.434-.5-.785' fill='%23fc0'/%3e%3cpath d='M530.51 280.4l23.277-15.216.419.567-23.2 15.434-.5-.785' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M548.49 310.508a4.938 4.938 0 001.81-2.154c.5-1.657.418-1.6.853-3.471.2-1.066.2-2.244.413-3.334.285-1.068 1.809-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.9-1.155-9.2-.72-13.276a30.281 30.281 0 00-.061-3.467l-10.007 6.52c.413 6.67.195 8.545.195 15 0 1.592-1.372 7.891-3.03 10.726l7.322 12.25' fill='%23004bb3'/%3e%3cpath d='M541.231 298.236l7.328 12.25a4.884 4.884 0 001.74-2.155 17.1 17.1 0 00.854-3.465 29.155 29.155 0 00.5-3.338c.28-1.068 1.808-4.622 1.875-6.017m.039-.021c-.062 1.373-1.59 4.84-1.875 5.93a22.612 22.612 0 01-.5 3.334 18.637 18.637 0 01-.854 3.466 5 5 0 01-1.741 2.093l-7.327-12.1' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M553.57 295.49c-.062 1.373-1.59 4.773-1.875 5.864a22.54 22.54 0 01-.5 3.333 20.423 20.423 0 01-.854 3.466 5.576 5.576 0 01-1.741 2.092s-7.238-11.965-7.327-12.03m12.294-2.725c-.062 1.373-1.5 4.773-1.875 5.864a22.9 22.9 0 01-.5 3.25 19.832 19.832 0 01-.854 3.4 4.884 4.884 0 01-1.741 2.025c-.067.067-7.238-11.748-7.327-11.813' fill='none' stroke='%2300004f' stroke-width='.232'/%3e%3cpath d='M553.57 295.49c-.062 1.286-1.5 4.708-1.875 5.8a19.47 19.47 0 01-.5 3.182 18.442 18.442 0 01-.854 3.4 5.667 5.667 0 01-1.741 2.093c-.067 0-7.171-11.665-7.327-11.752m12.294-2.725c-.062 1.286-1.5 4.621-1.808 5.711-.195 1-.285 2.158-.564 3.185a16.616 16.616 0 01-.854 3.332 5.576 5.576 0 01-1.741 2.092c-.067 0-7.171-11.53-7.327-11.6' fill='none' stroke='%23000051' stroke-width='.232'/%3e%3cpath d='M553.57 295.49c-.062 1.286-1.5 4.556-1.808 5.646-.195 1-.285 2.158-.564 3.183a19.144 19.144 0 01-.854 3.337 5.437 5.437 0 01-1.741 2.026c-.134.067-7.171-11.38-7.327-11.446m12.294-2.747c-.062 1.286-1.5 4.557-1.808 5.582-.195 1.068-.285 2.158-.564 3.182a22.669 22.669 0 01-.854 3.247 4.9 4.9 0 01-1.741 2.027c-.195.066-7.11-11.225-7.327-11.312' fill='none' stroke='%23000053' stroke-width='.232'/%3e%3cpath d='M553.57 295.49c-.062 1.286-1.5 4.49-1.808 5.58-.195 1-.285 2.093-.564 3.118a17.988 17.988 0 01-.937 3.244 5.4 5.4 0 01-1.658 1.944c-.195.066-7.11-11.1-7.327-11.161m12.294-2.725c-.062 1.22-1.5 4.425-1.808 5.428-.195 1.068-.285 2.158-.564 3.182a22.842 22.842 0 01-.937 3.182 4.923 4.923 0 01-1.658 1.943c-.195.06-7.11-10.945-7.327-11.01m12.294-2.725c-.062 1.22-1.5 4.425-1.808 5.428-.195 1-.285 2.026-.564 3.03a18.787 18.787 0 01-.937 3.184 4.479 4.479 0 01-1.658 1.936c-.285.068-7.11-10.788-7.327-10.876' fill='none' stroke='%23000056' stroke-width='.232'/%3e%3cpath d='M553.57 295.49c-.062 1.22-1.434 4.338-1.808 5.363-.195 1-.285 2.092-.564 3.03a14.722 14.722 0 01-1 3.115 4.27 4.27 0 01-1.591 1.942c-.285.066-7.02-10.66-7.327-10.725m12.294-2.725c-.062 1.22-1.434 4.273-1.808 5.275-.195 1-.346 2.092-.564 2.964a14.3 14.3 0 01-1 3.186 4.148 4.148 0 01-1.658 1.874c-.194.129-6.887-10.443-7.238-10.574' fill='none' stroke='%23000058' stroke-width='.232'/%3e%3cpath d='M553.57 295.49c-.062 1.22-1.434 4.273-1.808 5.275-.195.938-.346 1.94-.564 2.9a14.685 14.685 0 01-1 3.115 5.447 5.447 0 01-1.658 1.942c-.284.067-6.887-10.355-7.238-10.507m12.21-2.725c0 1.155-1.373 4.207-1.724 5.21-.195.937-.346 1.962-.57 2.9a19.473 19.473 0 01-1 3.12 5.405 5.405 0 01-1.657 1.87c-.286.067-6.888-10.221-7.238-10.353' fill='none' stroke='%2300005c' stroke-width='.232'/%3e%3cpath d='M553.508 295.49c0 1.155-1.373 4.12-1.724 5.144-.195.938-.346 1.94-.57 2.9a16.115 16.115 0 01-1 3.03 4.71 4.71 0 01-1.657 1.873c-.352.068-6.8-10.07-7.238-10.222m12.187-2.725c0 1.068-1.373 4.054-1.724 5.057-.195 1-.346 1.94-.57 2.9a18.362 18.362 0 01-1 2.965 4.7 4.7 0 01-1.657 1.874c-.352.129-6.8-9.918-7.238-10.071' fill='none' stroke='%2300005e' stroke-width='.232'/%3e%3cpath d='M553.508 295.425c0 1.155-1.373 4.12-1.724 5.143-.195.852-.346 1.875-.631 2.813a22.023 22.023 0 01-.937 2.9 5.352 5.352 0 01-1.657 1.875c-.352.133-6.8-9.785-7.238-9.917m12.187-2.811c0 1.155-1.373 4.054-1.724 4.991a27.164 27.164 0 01-.631 2.813 26.858 26.858 0 01-.937 2.965 5.19 5.19 0 01-1.657 1.803c-.413.129-6.8-9.634-7.238-9.787m12.187-2.79c0 1.155-1.288 3.989-1.724 4.991a25.909 25.909 0 01-.631 2.747 17.93 17.93 0 01-1 2.964 4.545 4.545 0 01-1.591 1.724c-.413.129-6.737-9.483-7.238-9.636' fill='none' stroke='%23000060' stroke-width='.232'/%3e%3cpath d='M553.508 295.425c0 1.155-1.288 3.9-1.657 4.926-.285.937-.413 1.874-.72 2.747a15.445 15.445 0 01-1 2.9 4.542 4.542 0 01-1.59 1.719c-.5.134-6.737-9.35-7.239-9.482m12.21-2.811c0 1.067-1.288 3.9-1.657 4.838-.285.938-.413 1.876-.72 2.747a15.726 15.726 0 01-1 2.81 5.58 5.58 0 01-1.59 1.814c-.5.061-6.737-9.266-7.239-9.42' fill='none' stroke='%23000062' stroke-width='.232'/%3e%3cpath d='M553.508 295.425c0 1.067-1.288 3.836-1.657 4.838-.285.85-.413 1.81-.72 2.682a13.433 13.433 0 01-1 2.747 3.983 3.983 0 01-1.59 1.725c-.5.194-6.67-8.984-7.239-9.2m12.21-2.79c0 1.067-1.288 3.836-1.657 4.773-.285.85-.413 1.809-.72 2.682a17.027 17.027 0 01-1 2.745 4.184 4.184 0 01-1.59 1.657c-.57.195-6.586-8.85-7.239-9.067' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M553.508 295.425c0 1.067-1.288 3.77-1.657 4.708-.285.85-.413 1.809-.72 2.594a22.19 22.19 0 01-1 2.747 4.508 4.508 0 01-1.59 1.72c-.57.133-6.586-8.761-7.239-8.98m12.21-2.79c0 1.068-1.288 3.684-1.657 4.622-.285.872-.413 1.809-.72 2.616a28.971 28.971 0 01-1 2.745 5.481 5.481 0 01-1.59 1.658c-.632.128-6.586-8.632-7.239-8.85' fill='none' stroke='%23000268' stroke-width='.232'/%3e%3cpath d='M553.508 295.425c0 1-1.222 3.618-1.657 4.621-.285.784-.413 1.656-.72 2.528a16.408 16.408 0 01-1.072 2.683 4.859 4.859 0 01-1.5 1.657c-.631.195-6.586-8.481-7.238-8.7m12.187-2.79c0 1-1.222 3.619-1.657 4.491-.285.85-.413 1.722-.72 2.594a15.352 15.352 0 01-1.072 2.591 4.232 4.232 0 01-1.59 1.658c-.564.2-6.452-8.325-7.172-8.543m12.211-2.79c0 1-1.222 3.552-1.657 4.49-.285.85-.413 1.657-.72 2.463a12.91 12.91 0 01-1.072 2.594 4.838 4.838 0 01-1.59 1.657c-.63.129-6.452-8.11-7.172-8.414' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M553.508 295.425c0 .937-1.222 3.465-1.657 4.424-.285.785-.413 1.723-.72 2.464a15.352 15.352 0 01-1.072 2.591 5.408 5.408 0 01-1.59 1.592c-.63.2-6.452-7.976-7.172-8.26m12.211-2.811a15.414 15.414 0 01-1.657 4.338c-.285.784-.413 1.656-.72 2.462a12.921 12.921 0 01-1.072 2.53 4.1 4.1 0 01-1.59 1.59c-.63.195-6.384-7.825-7.172-8.109' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a15.414 15.414 0 01-1.657 4.338c-.285.784-.413 1.591-.72 2.376-.413 1.22-.57 1.285-1.072 2.526a4.29 4.29 0 01-1.59 1.507c-.72.194-6.384-7.674-7.172-7.979m12.211-2.768a15.039 15.039 0 01-1.657 4.272c-.285.72-.413 1.591-.72 2.376a24.486 24.486 0 01-1.072 2.464 7.8 7.8 0 01-1.59 1.59c-.781.134-6.3-7.608-7.172-7.891' fill='none' stroke='%2300096f' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a13.979 13.979 0 01-1.657 4.207c-.285.784-.413 1.59-.72 2.31-.5 1.221-.57 1.286-1.072 2.46a4.863 4.863 0 01-1.59 1.508c-.781.284-6.3-7.39-7.172-7.674m12.211-2.811a14.447 14.447 0 01-1.657 4.12 18.829 18.829 0 01-.787 2.31A15.639 15.639 0 01550 304.32a4.164 4.164 0 01-1.507 1.439c-.782.28-6.3-7.24-7.172-7.544' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a14.077 14.077 0 01-1.657 4.054 18.829 18.829 0 01-.787 2.31 12.735 12.735 0 01-1.065 2.4 5.075 5.075 0 01-1.591 1.5c-.787.195-6.15-7.172-7.11-7.456m12.21-2.811a13.731 13.731 0 01-1.657 3.989 18.829 18.829 0 01-.787 2.31A16.482 16.482 0 01550 304.1a5.648 5.648 0 01-1.591 1.441c-.787.195-6.15-7.021-7.11-7.325m12.21-2.791a13.731 13.731 0 01-1.657 3.989c-.285.719-.413 1.5-.787 2.244a9.145 9.145 0 01-1.155 2.312 4.813 4.813 0 01-1.5 1.437c-.787.285-6.15-6.887-7.11-7.17' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a11.351 11.351 0 01-1.657 3.9c-.285.72-.413 1.5-.787 2.246a14.394 14.394 0 01-1.155 2.245 4.158 4.158 0 01-1.5 1.44c-.855.195-6.083-6.671-7.11-7.021m12.21-2.811a11.628 11.628 0 01-1.657 3.836 16.643 16.643 0 01-.787 2.159 11.872 11.872 0 01-1.155 2.31 3.962 3.962 0 01-1.5 1.37c-.855.284-6.083-6.514-7.11-6.885' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a12.23 12.23 0 01-1.657 3.836c-.285.632-.413 1.373-.787 2.093a11.971 11.971 0 01-1.155 2.245 3.978 3.978 0 01-1.5 1.373c-.855.285-6.083-6.365-7.11-6.736m12.21-2.811a10.254 10.254 0 01-1.657 3.683 16.643 16.643 0 01-.787 2.159 10.706 10.706 0 01-1.155 2.158 3.972 3.972 0 01-1.5 1.374c-.938.284-6.021-6.235-7.11-6.584' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a10.966 10.966 0 01-1.657 3.683 21.962 21.962 0 01-.787 2.093 20.141 20.141 0 01-1.155 2.158 4.2 4.2 0 01-1.5 1.284c-.938.285-6.021-6.079-7.11-6.45m12.21-2.768a10.693 10.693 0 01-1.657 3.618c-.285.72-.5 1.373-.787 2.093a21.792 21.792 0 01-1.155 2.093 5.7 5.7 0 01-1.5 1.374c-1 .28-5.933-6.017-7.11-6.367' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a10.413 10.413 0 01-1.657 3.552c-.285.634-.5 1.374-.787 2.094a21.78 21.78 0 01-1.155 2.092 6.54 6.54 0 01-1.5 1.284c-1 .285-5.933-5.861-7.11-6.232m12.21-2.79a9.889 9.889 0 01-1.657 3.465c-.285.72-.5 1.373-.787 2.028a10.478 10.478 0 01-1.222 2.092 3.988 3.988 0 01-1.434 1.221c-1 .35-5.933-5.645-7.11-6.016m12.21-2.79a10.141 10.141 0 01-1.657 3.465c-.285.633-.5 1.286-.787 1.94a10.577 10.577 0 01-1.222 2.027 4.681 4.681 0 01-1.434 1.287c-1.072.28-5.866-5.58-7.11-5.93' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a9.384 9.384 0 01-1.657 3.4c-.285.566-.5 1.285-.787 1.94a9.4 9.4 0 01-1.222 1.94 4.678 4.678 0 01-1.434 1.286c-1.072.351-5.866-5.428-7.11-5.8m12.21-2.767a9.146 9.146 0 01-1.657 3.334c-.285.633-.5 1.286-.787 1.875a10.577 10.577 0 01-1.222 2.027 5.729 5.729 0 01-1.434 1.221c-1.072.284-5.866-5.21-7.11-5.646' fill='none' stroke='%23001c82' stroke-width='.232'/%3e%3cpath d='M553.508 295.425a9.675 9.675 0 01-1.657 3.334c-.285.567-.5 1.222-.787 1.81-.5 1-.72 1.068-1.222 2.026a5.446 5.446 0 01-1.434 1.157c-1.156.348-5.782-5.058-7.11-5.5m12.21-2.832a8.32 8.32 0 01-1.6 3.182c-.347.632-.564 1.286-.849 1.874-.5.939-.72 1.07-1.222 1.941a5.458 5.458 0 01-1.434 1.155c-1.223.35-5.782-4.926-7.11-5.362' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a8.45 8.45 0 01-1.6 3.27c-.28.566-.564 1.22-.849 1.81-.5.937-.72 1-1.222 1.873a4.819 4.819 0 01-1.5 1.157c-1.157.349-5.649-4.775-7.022-5.211m12.188-2.9a8.022 8.022 0 01-1.6 3.184 19.133 19.133 0 01-.938 1.81 9.438 9.438 0 01-1.217 1.809 3.655 3.655 0 01-1.44 1.155c-1.155.349-5.647-4.622-7.02-5.058' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a7.416 7.416 0 01-1.6 3.117 19.012 19.012 0 01-.938 1.81 9.445 9.445 0 01-1.217 1.81 4.371 4.371 0 01-1.44 1.068c-1.221.414-5.647-4.426-7.02-4.927m12.21-2.878a7.533 7.533 0 01-1.6 3.03 11.252 11.252 0 01-.938 1.722 9.445 9.445 0 01-1.217 1.81 4.615 4.615 0 01-1.44 1.155c-1.221.349-5.58-4.338-7.02-4.84m12.21-2.877a7.533 7.533 0 01-1.6 3.03 14.873 14.873 0 01-.938 1.657 8.809 8.809 0 01-1.217 1.81 5.488 5.488 0 01-1.44 1.067c-1.221.349-5.58-4.207-7.02-4.709' fill='none' stroke='%23002289' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a8.092 8.092 0 01-1.6 2.965c-.28.5-.564 1.068-.938 1.656a12.247 12.247 0 01-1.283 1.723 2.808 2.808 0 01-1.374 1c-1.289.414-5.58-3.99-7.02-4.49m12.21-2.857a6.468 6.468 0 01-1.6 2.9 16.767 16.767 0 01-.938 1.656 8.974 8.974 0 01-1.283 1.658 3.4 3.4 0 01-1.374 1.068c-1.289.414-5.514-3.9-7.02-4.426' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a7.207 7.207 0 01-1.6 2.9c-.28.5-.564 1-.938 1.592a6.923 6.923 0 01-1.283 1.592 4.121 4.121 0 01-1.374 1.067c-1.289.414-5.514-3.77-7.02-4.272m12.21-2.878a6.312 6.312 0 01-1.6 2.747 14.684 14.684 0 01-.938 1.656 12.941 12.941 0 01-1.283 1.592 6.127 6.127 0 01-1.374 1c-1.372.348-5.514-3.619-7.02-4.12' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a6.825 6.825 0 01-1.6 2.747 8.343 8.343 0 01-1 1.5c-.35.785-.72.938-1.221 1.657a4.389 4.389 0 01-1.374.938c-1.372.414-5.514-3.466-7.02-3.99m12.21-2.855a6.261 6.261 0 01-1.6 2.68 8.32 8.32 0 01-1 1.5c-.35.72-.72.85-1.221 1.592a5.885 5.885 0 01-1.374.938c-1.44.414-5.43-3.336-7.02-3.837' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5.944 5.944 0 01-1.6 2.594 8.314 8.314 0 01-1 1.5c-.35.72-.72.85-1.221 1.5a5.791 5.791 0 01-1.374.937c-1.44.414-5.363-3.182-7.02-3.77m12.21-2.77a5.925 5.925 0 01-1.6 2.53 6.226 6.226 0 01-1 1.439 5.912 5.912 0 01-1.221 1.5 4.632 4.632 0 01-1.374 1c-1.44.348-5.363-3.117-7.02-3.685m12.21-2.79a6.344 6.344 0 01-1.6 2.463 6.231 6.231 0 01-1 1.44c-.35.718-.72.849-1.288 1.5a3.679 3.679 0 01-1.284.849c-1.507.5-5.363-2.811-7.021-3.466' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5.644 5.644 0 01-1.6 2.463 8.414 8.414 0 01-1 1.373 8.6 8.6 0 01-1.288 1.439 8.021 8.021 0 01-1.284.938c-1.507.414-5.363-2.747-7.021-3.4m12.188-2.813a5.523 5.523 0 01-1.6 2.4 7.491 7.491 0 01-1 1.352 12.328 12.328 0 01-1.288 1.44 8.61 8.61 0 01-1.374.85c-1.44.414-5.206-2.594-6.954-3.25' fill='none' stroke='%23002f96' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a4.922 4.922 0 01-1.6 2.31 7.573 7.573 0 01-1 1.374c-.413.566-.787.784-1.288 1.374a5.529 5.529 0 01-1.374.85c-1.5.413-5.206-2.463-6.954-3.118m12.211-2.79a5.137 5.137 0 01-1.6 2.245 5.434 5.434 0 01-1 1.286 8.547 8.547 0 01-1.288 1.374 5.529 5.529 0 01-1.374.85c-1.59.5-5.206-2.31-6.954-2.965' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5.676 5.676 0 01-1.6 2.245 7.758 7.758 0 01-1 1.221 10.228 10.228 0 01-1.288 1.286 4.439 4.439 0 01-1.374.85c-1.59.415-5.145-2.157-6.954-2.812m12.211-2.79a5.409 5.409 0 01-1.6 2.158 12.478 12.478 0 01-1 1.221 10.162 10.162 0 01-1.278 1.284 6.743 6.743 0 01-1.374.785c-1.59.5-5.078-2.028-6.954-2.681' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a4.909 4.909 0 01-1.6 2.092 10.786 10.786 0 01-2.373 2.442 3.632 3.632 0 01-1.288.785c-1.658.5-5.08-1.874-6.955-2.53m12.211-2.79a4.819 4.819 0 01-1.6 2.028 5.663 5.663 0 01-1 1.222 9.844 9.844 0 01-1.373 1.22 4.729 4.729 0 01-1.288.72c-1.658.5-5.08-1.723-6.955-2.378m12.211-2.811a4.119 4.119 0 01-1.6 1.94 6.856 6.856 0 01-1 1.221c-.5.5-.787.632-1.373 1.155a4.728 4.728 0 01-1.288.72c-1.658.5-5.08-1.591-6.955-2.246' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5 5 0 01-1.6 1.94 10.857 10.857 0 01-1 1.068 17.129 17.129 0 01-1.373 1.156 6 6 0 01-1.372.785c-1.658.5-4.928-1.44-6.892-2.16m12.232-2.79a5.111 5.111 0 01-1.6 1.876 10.857 10.857 0 01-1 1.068 7.639 7.639 0 01-1.373 1.069 2.636 2.636 0 01-1.372.718c-1.658.567-4.928-1.22-6.892-1.94' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a4.325 4.325 0 01-1.6 1.81 10.857 10.857 0 01-1 1.068 16.026 16.026 0 01-1.373 1.068 7.731 7.731 0 01-1.372.72c-1.658.5-4.928-1.156-6.892-1.876m12.232-2.79a3.814 3.814 0 01-1.6 1.722 6.864 6.864 0 01-1.067 1.068c-.413.436-.786.633-1.283 1.069a11.459 11.459 0 01-1.378.632c-1.72.5-4.839-1-6.888-1.722' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a4.3 4.3 0 01-1.6 1.722 12.242 12.242 0 01-1.067 1c-.413.413-.786.566-1.283 1a11.459 11.459 0 01-1.378.632c-1.72.566-4.839-.85-6.888-1.591m12.211-2.77a4.3 4.3 0 01-1.6 1.657c-.28.284-.631.633-1.067 1a11.54 11.54 0 01-1.372.939 3.925 3.925 0 01-1.29.63c-1.807.5-4.838-.718-6.887-1.438' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5.3 5.3 0 01-1.508 1.592c-.345.282-.72.632-1.155.937a4.934 4.934 0 01-1.372.937 3.91 3.91 0 01-1.29.632c-1.807.567-4.77-.567-6.887-1.286m12.211-2.812a4.485 4.485 0 01-1.507 1.5 8.127 8.127 0 01-1.155.937c-.413.349-.847.567-1.372.938a8.714 8.714 0 01-1.29.567c-1.807.566-4.77-.415-6.887-1.156m12.211-2.79a4.809 4.809 0 01-1.507 1.443c-.345.282-.72.567-1.155.937a6.293 6.293 0 01-1.44.85c-.346.2-.781.414-1.221.633-1.87.5-4.7-.35-6.888-1.07' fill='none' stroke='%230042a8' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5.728 5.728 0 01-1.508 1.439c-.345.2-.72.5-1.155.785a7.333 7.333 0 01-1.44.937 7.7 7.7 0 01-1.221.5c-1.87.566-4.7-.132-6.954-.85m12.277-2.813a4.886 4.886 0 01-1.507 1.376 6.293 6.293 0 01-1.155.784 9.026 9.026 0 01-1.44.85 4.277 4.277 0 01-1.221.5c-1.87.632-4.7 0-6.954-.72' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a6.155 6.155 0 01-1.508 1.286c-.345.2-.72.567-1.155.785a5.666 5.666 0 01-1.44.784c-.346.2-.781.35-1.221.567-1.937.567-4.622.13-6.954-.632m12.277-2.79a5.257 5.257 0 01-1.507 1.22 12.838 12.838 0 01-1.155.786c-.413.282-.937.5-1.44.784-.346.131-.781.349-1.221.5a12.454 12.454 0 01-6.954-.5' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M553.508 295.337a5.257 5.257 0 01-1.507 1.22c-.345.2-.72.415-1.155.72a8.875 8.875 0 01-1.44.72 7.791 7.791 0 01-1.221.5 12.543 12.543 0 01-6.954-.349m12.277-2.812a18.1 18.1 0 01-1.508 1.156 13.435 13.435 0 00-1.155.72c-.413.195-.937.414-1.44.632a7.791 7.791 0 01-1.221.5 11.889 11.889 0 01-6.954-.2' fill='none' stroke='%230049af' stroke-width='.232'/%3e%3cpath d='M553.508 295.337A11.274 11.274 0 01552 296.4c-.345.2-.72.415-1.155.633a8.955 8.955 0 01-1.44.719c-.434.13-.781.282-1.221.414a12.2 12.2 0 01-6.954-.065m12.277-2.77s-6.239 4.927-12.316 2.813' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M553.787 275.892s-1.216 7.913-1.718 9.07c-.351 1-2.9 5.491-6.737 6.516' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M553.787 275.892s-1.283 7.825-1.808 8.915c-.413 1-2.745 5.364-6.669 6.671' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M553.726 275.825s-1.29 7.762-1.813 8.982c-.5 1-2.59 5.08-6.58 6.671' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M553.726 275.825s-1.373 7.762-1.875 8.917a14.188 14.188 0 01-6.519 6.671' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M553.726 275.825s-1.506 7.674-2.031 8.765a14.624 14.624 0 01-6.385 6.8' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M553.726 275.825s-1.59 7.609-2.093 8.765a16.056 16.056 0 01-6.3 6.8' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M553.66 275.825s-1.591 7.543-2.094 8.7a16.477 16.477 0 01-6.234 6.8' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M553.66 275.825s-1.747 7.457-2.244 8.634c-.5 1.068-1.814 3.9-6.15 6.889' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M553.66 275.825s-1.809 7.391-2.311 8.547c-.5 1.067-1.724 3.683-6.083 6.954' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M553.66 275.76s-1.876 7.456-2.462 8.547c-.5 1.067-1.506 3.4-5.933 7.02' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M553.66 275.76s-1.943 7.326-2.528 8.48c-.5 1.069-1.374 3.184-5.866 7.02' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M553.57 275.76s-1.958 7.326-2.528 8.415c-.564 1.069-1.223 2.965-5.8 7.02' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M553.57 275.674s-2.026 7.324-2.68 8.393c-.568 1.068-1.07 2.747-5.646 7.106' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M553.291 271.03s-1.005 11.162-8.985 14.214' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M553.224 271.03a23.494 23.494 0 01-2.026 7.02 13.486 13.486 0 01-6.892 7.171' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M553.224 271.03a27.881 27.881 0 01-2.092 7.02c-1.156 2.376-3.25 5.581-6.8 7.171' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M553.224 271.03a28.01 28.01 0 01-2.16 6.888c-1.155 2.312-3.248 5.582-6.736 7.238' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M553.224 271.03a31.509 31.509 0 01-2.31 6.888c-1 2.093-3.12 5.494-6.586 7.173' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M553.224 271.03a31.937 31.937 0 01-2.377 6.8c-.938 1.876-3.03 5.43-6.519 7.238' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M553.134 271.03a30.443 30.443 0 01-2.377 6.736 17.281 17.281 0 01-6.451 7.326' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M553.134 270.964a31.082 31.082 0 01-2.46 6.737c-.787 1.5-2.9 5.276-6.368 7.325' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M553.134 270.964a38.848 38.848 0 01-2.528 6.671c-.787 1.44-2.812 5.277-6.3 7.39' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M553.134 270.964a32.032 32.032 0 01-2.679 6.671c-.636 1.156-2.66 5.145-6.15 7.39' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M553.134 270.964a42.188 42.188 0 01-2.745 6.605c-.57 1-2.6 5.06-6.083 7.391' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M553.073 270.964a35.012 35.012 0 01-2.751 6.519c-.5.785-2.528 4.992-6.016 7.455' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M553.073 270.964a33.861 33.861 0 01-2.9 6.453c-.413.633-2.377 4.993-5.864 7.543' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M553.224 267.913s-2.31 8.981-8.762 11.161' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M553.224 267.913a21.757 21.757 0 01-3.03 6.235 12.256 12.256 0 01-5.715 4.926' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M553.224 267.913a23.269 23.269 0 01-3.12 6.147c-1.44 2.093-3.465 4.273-5.642 4.993' fill='none' stroke='%2300096f' stroke-width='.232'/%3e%3cpath d='M553.134 267.848A24.628 24.628 0 01550.1 274c-1.5 2.158-3.684 4.338-5.731 5.058' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M553.134 267.782a26.179 26.179 0 01-3.113 6.234c-1.6 2.093-3.773 4.426-5.648 5.058' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M553.134 267.782a25.588 25.588 0 01-3.247 6.083c-1.591 2.223-3.835 4.556-5.514 5.144' fill='none' stroke='%23001c82' stroke-width='.232'/%3e%3cpath d='M553.134 267.782a23.348 23.348 0 01-3.334 6.018c-1.657 2.31-3.99 4.708-5.43 5.21' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M553.134 267.7a26.119 26.119 0 01-3.331 6.017c-1.724 2.31-4.124 4.84-5.43 5.275' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M553.134 267.7a25.9 25.9 0 01-3.465 5.929c-1.72 2.377-4.208 4.927-5.3 5.276' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M553.134 267.7a29.511 29.511 0 01-3.554 5.865c-1.808 2.376-4.336 5.055-5.207 5.361' fill='none' stroke='%23002f96' stroke-width='.232'/%3e%3cpath d='M553.134 267.63a32.289 32.289 0 01-3.616 5.864c-1.875 2.375-4.425 5.21-5.145 5.427' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M553.073 267.63a32.112 32.112 0 01-3.556 5.864c-1.941 2.375-4.559 5.21-5.211 5.427' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M553.073 267.63a32.831 32.831 0 01-3.69 5.71c-1.873 2.53-4.62 5.43-5.077 5.582' fill='none' stroke='%230042a8' stroke-width='.232'/%3e%3cpath d='M553.073 267.564a30.862 30.862 0 01-3.772 5.711 50.451 50.451 0 01-5 5.646' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M553.073 267.476a31.911 31.911 0 01-3.84 5.712c-2.025 2.6-4.927 5.647-4.927 5.647m-8.439 1.35l-4.425.786m3.99 2.55l-3.99-1.656' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M535.935 280.251l-4.426.72' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M535.867 280.47l-4.425.5' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M535.867 280.622l-4.425.349' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M535.867 280.753l-4.487.282' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M535.867 280.971l-4.487.065' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M535.867 281.124l-4.553-.066' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M535.867 281.276l-4.62-.2' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M535.807 281.406l-4.56-.282' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M535.807 281.56l-4.621-.415' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M535.522 283.3l-4.058-1.5' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M535.522 283.15l-4.12-1.438' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M535.522 283.02l-4.12-1.374' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M535.589 282.8l-4.275-1.22' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M535.589 282.65l-4.342-1.156' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M535.589 282.5l-4.342-1.07' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M535.65 282.28l-4.487-.851' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M535.717 282.061l-4.554-.785' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M535.717 281.93l-4.621-.654' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M535.717 281.777l-4.71-.565' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M548.49 310.508a4.938 4.938 0 001.81-2.154c.5-1.657.418-1.6.853-3.471.2-1.066.2-2.244.413-3.334.285-1.068 1.809-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.9-1.155-9.2-.72-13.276a30.281 30.281 0 00-.061-3.467l-22.977 15.217' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M554.161 264.883c.2-.85-.066-2.03-.72-2.157a2.156 2.156 0 00-.786-.068c-.347 0-.413.13-.565.436-.35.785.565 1.287 1.285 1.5.133.066.569.13.63.349.134.349.068.2.134.349-.134-.065-.134-.2-.285-.284-.5-.282-1-.348-1.74-.72-.5-.194-.57-1.372-.2-1.657a2.3 2.3 0 012.03 0 3.561 3.561 0 01.5 2.682c0-.195-.285-.13-.285-.414' fill='%23fc0'/%3e%3cpath d='M554.161 264.883c.2-.85-.066-2.03-.72-2.157a2.156 2.156 0 00-.786-.068c-.347 0-.413.13-.565.436-.35.785.565 1.287 1.285 1.5.133.066.569.13.63.349.134.349.068.2.134.349-.134-.065-.134-.2-.285-.284-.5-.282-1-.348-1.74-.72-.5-.194-.57-1.372-.2-1.657a2.3 2.3 0 012.03 0 3.561 3.561 0 01.5 2.682c0-.195-.285-.13-.285-.414z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M554.53 265.318c.938 0 2.026.349 2.093.938a3.64 3.64 0 010 .85c-.068.349-.129.5-.5.567-.847.2-1.217-.784-1.373-1.5a1.511 1.511 0 00-.195-.72c-.346-.13-.285-.066-.346-.13a.835.835 0 01.195.283c.2.5.285 1.068.5 1.81.13.567 1.218.784 1.591.436a2.194 2.194 0 00.285-1.94 3.319 3.319 0 00-2.6-.939c.194.066.128.414.345.35' fill='%23fc0'/%3e%3cpath d='M554.53 265.318c.938 0 2.026.349 2.093.938a3.64 3.64 0 010 .85c-.068.349-.129.5-.5.567-.847.2-1.217-.784-1.373-1.5a1.511 1.511 0 00-.195-.72c-.346-.13-.285-.066-.346-.13a.835.835 0 01.195.283c.2.5.285 1.068.5 1.81.13.567 1.218.784 1.591.436a2.194 2.194 0 00.285-1.94 3.319 3.319 0 00-2.6-.939c.194.066.128.414.345.35' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M554.725 264.948a.551.551 0 01.134.632c-.134.2-.5.283-.63.13a.59.59 0 01-.351-.85c.195-.282.568-.065.847.067' fill='%23fc0'/%3e%3cpath d='M554.725 264.948a.551.551 0 01.134.632c-.134.2-.5.283-.63.13a.59.59 0 01-.351-.85c.195-.282.568-.065.847.067z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M559.586 261.833a13.626 13.626 0 01-4.425 1 6.749 6.749 0 01-.5 2.226 6.57 6.57 0 012.6.065 9.614 9.614 0 012.31-3.334' fill='%23fc0'/%3e%3cpath d='M559.586 261.833a13.626 13.626 0 01-4.425 1 6.749 6.749 0 01-.5 2.226 6.57 6.57 0 012.6.065 9.614 9.614 0 012.31-3.334z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M557.65 263.05a5.141 5.141 0 01-1.747.418 2.969 2.969 0 01-.2.848 2.909 2.909 0 011 .065 2.961 2.961 0 01.938-1.354z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068a4.964 4.964 0 00-.63 2.593 2.16 2.16 0 002.092.066c.346-.2.128-.784-.067-1.286a2.287 2.287 0 00-.413-1.374' fill='%23fc0'/%3e%3cpath d='M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068a4.964 4.964 0 00-.63 2.593 2.16 2.16 0 002.092.066c.346-.2.128-.784-.067-1.286a2.287 2.287 0 00-.413-1.374z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M554.1 266.19a4.308 4.308 0 01-.068.567c0-.2-.2.2-.279.284a5.548 5.548 0 00-.569 2.31m.7-2.092a6.863 6.863 0 00-.346 2.245l-.067-.065m.48-1.308a4.035 4.035 0 00-.195 1.373l.279.13' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M531.944 314.213c-1.875 1.658-5.274 2.528-5.86 2.97a10.84 10.84 0 01-6.084 2.31c-2.31.195-3.335-.419-5.646-.72-2.66-.285.283.128-2.223-.42a29.641 29.641 0 00-3.03-.93c-1.286-.352-2.6-.637-3.4-1.725a2.054 2.054 0 01-.634-1.44h-1.72c-.131.5.348 1.44.5 1.808a4.222 4.222 0 01.415.659c.282.5.2.345.719.78a5.714 5.714 0 00.785.632 2.418 2.418 0 001 .636 22.489 22.489 0 014.12 1.155c1.57.413.719.346 1.94.63a21.431 21.431 0 002.31.631c1.069.195 1.222.352 2.312.57a27.571 27.571 0 008.328.285 14.057 14.057 0 004.927-1.29c1.72-1.222 5.581-1.719 7.238-2.9a9.7 9.7 0 001.5-.854c1.59-1.373 2.963-1.72 4.71-2.813h-12.25' fill='%23004bb3'/%3e%3cpath d='M518.54 314.213c-1.222.636-1.81 1.658-5.21 2.746-1.287 0-2.748.57-3.99.5 1.526.352 1.526.57 2.747.854 2.528.563-.415.129 2.223.413 2.31.285 3.335.938 5.646.72a10.655 10.655 0 006.084-2.31c.563-.413 3.99-1.29 5.865-2.97H518.5' fill='white'/%3e%3cpath d='M518.54 314.213h-13.56a2.13 2.13 0 00.633 1.44c.784 1.072 2.091 1.374 3.4 1.724 1.373.28 2.812-.419 4.272-.419 3.554-1.064 3.99-2.242 5.211-2.745' fill='%23004bb3'/%3e%3cpath d='M531.666 314.213s2.371.135 2.528.135c.127 0 9.7-.135 9.7-.135' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M531.666 314.28s2.31.129 2.59.2c.2.068 9.637-.127 9.637-.127' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M531.666 314.37s2.31.195 2.59.279c.418 0 9.509-.279 9.509-.279' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M531.666 314.37s2.176.279 2.679.346c.5.133 9.352-.285 9.352-.285' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M531.6 314.43s2.16.286 2.745.42c.631.128 9.264-.42 9.264-.42' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M531.6 314.43s2.092.42 2.812.57c.781.129 9.2-.5 9.2-.5' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M531.531 314.43s2.093.5 2.964.721c.854.195 8.985-.564 8.985-.564' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M531.531 314.5s2.027.569 2.964.786c1 .128 8.918-.72 8.918-.72' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M531.531 314.587s1.943.63 3.03.848c1.156.2 8.852-.786 8.852-.786' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M531.531 314.587a28.846 28.846 0 003.12 1c1.155.2 8.634-.848 8.634-.848' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M531.531 314.649a16.306 16.306 0 003.181 1c1.29.285 8.483-.937 8.483-.937' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M544 314.213h-12.334' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M543.128 314.805s-6.954 1.284-8.416 1a16.527 16.527 0 01-3.248-1.155' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M529.94 319.643s-4.491.631-4.642.631c-.067 0-2.528-.194-2.66-.194l-2.18-.5' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M530.136 319.577s-4.554.72-4.838.636c-.2-.068-2.445-.2-2.594-.2-.13 0-2.029-.413-2.029-.413' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M530.443 319.447a44.022 44.022 0 01-5.145.632c-.285 0-2.377-.129-2.528-.129-.2 0-1.876-.434-1.876-.434' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M530.66 319.292a45.409 45.409 0 01-5.43.72c-.345 0-2.16-.128-2.46-.128-.2-.068-1.658-.352-1.658-.352' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M530.946 319.23a48.6 48.6 0 01-5.715.721c-.413-.068-2.093-.134-2.377-.2-.28 0-1.5-.194-1.5-.194' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M531.163 319.074s-4.994 1-6.016.787c-.5-.067-1.875-.128-2.31-.194a10.29 10.29 0 01-1.289-.2' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M531.443 319.013s-5.14 1-6.3.781c-.57-.061-1.814-.195-2.249-.195q-.607-.084-1.22-.128' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M531.666 318.923s-5.213 1.066-6.52.787a14 14 0 00-2.248-.194 7.5 7.5 0 00-1-.069' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M529.634 319.794l-4.336.57-2.66-.134-2.311-.564' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M531.944 318.8s-5.362 1.155-6.887.848a17.608 17.608 0 00-2.964-.284m-11.4.09s-2.748-1-4.21-1.508a4.693 4.693 0 01-2.9-3.616m7.417 4.247s-1.656-.636-3.03-1.155c-3.77-1.44-3.335-3.185-3.335-3.185' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M511.28 318.706s-2.245-.787-3.335-1.223a7.127 7.127 0 01-1.722-.78 4.09 4.09 0 01-1.286-1.222 2.932 2.932 0 01-.415-1.223' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M511.5 318.923s-2.747-1-3.553-1.372a11.133 11.133 0 01-1.722-.72 14 14 0 01-1.374-1.156 9.457 9.457 0 01-.414-1.44' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M511.781 319.074s-3.335-1.155-3.836-1.373q-.858-.368-1.722-.72c-.2-.128-1.286-1.066-1.44-1.217a11.676 11.676 0 01-.435-1.506' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M512 319.292s-3.837-1.373-4.054-1.5c-.2-.069-1.592-.57-1.657-.632a15.145 15.145 0 01-1.5-1.222c-.066-.134-.567-1.59-.567-1.59' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M511 319.447s-3.334-1.221-4.49-1.656a5.1 5.1 0 01-2.027-1.507 5.616 5.616 0 01-.785-1.936' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M511.346 319.447s-4.056-1.438-4.927-1.807a5.436 5.436 0 01-1.875-1.44 7.108 7.108 0 01-.785-1.875' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M511.65 319.516s-4.708-1.814-5.21-1.943a7.673 7.673 0 01-1.809-1.373 7.313 7.313 0 01-.719-1.875' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M511.934 319.516s-5.276-2.033-5.582-2.094a12.1 12.1 0 01-1.721-1.289c-.13-.195-.633-1.808-.633-1.808' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M512.218 319.516l-5.93-2.25-1.592-1.222-.566-1.719' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M505.328 314.213s2.53.135 2.682.135c.13 0 10.071-.135 10.071-.135' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M505.328 314.28s2.464.129 2.682.2c.283.068 10-.127 10-.127' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M505.263 314.37s2.441.195 2.813.279c.348 0 9.853-.279 9.853-.279' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M505.263 314.37s2.377.279 2.9.346c.5.133 9.7-.285 9.7-.285' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M505.263 314.43s2.223.286 2.9.42c.633.128 9.635-.42 9.635-.42' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M505.263 314.43s2.158.42 2.965.57c.72.129 9.5-.5 9.5-.5' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M505.177 314.43s2.157.5 3.03.721c.936.195 9.416-.564 9.416-.564' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M505.177 314.5s2.092.569 3.117.786c1 .128 9.264-.72 9.264-.72' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M505.177 314.587s2 .63 3.117.848c1.155.2 9.2-.786 9.2-.786' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M505.177 314.587a32.2 32.2 0 003.182 1c1.286.2 9.07-.848 9.07-.848' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M505.177 314.649a15.46 15.46 0 003.247 1c1.374.285 8.917-.937 8.917-.937' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M518.169 314.213h-12.754' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M517.23 314.805s-7.171 1.284-8.7 1a17.741 17.741 0 01-3.4-1.155' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M503.214 314.213c-.131.5.348 1.44.5 1.814a4.215 4.215 0 01.415.653c.283.5.195.346.72.781a5.943 5.943 0 00.783.636 2.481 2.481 0 001 .631 22.871 22.871 0 014.12 1.156c1.569.413.72.346 1.94.63a20.545 20.545 0 002.31.63c1.07.2 1.221.352 2.311.57a27.56 27.56 0 008.326.285 13.908 13.908 0 004.927-1.29c1.724-1.216 5.582-1.718 7.238-2.9a9.013 9.013 0 001.508-.854c1.59-1.373 2.962-1.719 4.7-2.807' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M474.721 277.2c-1.438-3.554-2.964-10.944-2.9-12.623.349-6.89.2-8.984.85-16.087l7.172 8.2a23.291 23.291 0 000 5.274 26.769 26.769 0 00.939 4.993l-6.082 10.221' fill='white'/%3e%3cpath d='M480.8 266.975a28.277 28.277 0 01-.938-4.991 23.413 23.413 0 010-5.274l4.339 4.838-3.4 5.427m-18.2 6.671c-.065-1.591-.2-3.335-.2-4.12 0-4.992-.567-7.76 0-13.056.414-4.125 1.439-9.638 1.22-14.064a36.124 36.124 0 01.2-3.773l8.85 9.857c-.63 7.1-.5 9.2-.849 16.087-.065 1.657 1.44 9.07 2.9 12.622l-1.875 3.183-10.224-6.736' fill='%23004bb3'/%3e%3cpath d='M484.858 260.9l-20.817-23.07-.415.5 20.6 23.194.632-.63' fill='%23fc0'/%3e%3cpath d='M484.858 260.9l-20.817-23.07-.415.5 20.6 23.194.632-.63' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M464.258 244.259s1.656 14.565 7.325 14' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M471.583 258.188c-2.813.135-4.71-3.465-5.712-6.8a53.357 53.357 0 01-1.592-7.177' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M471.583 258.188c-2.813-.128-4.71-3.773-5.647-6.887a42.121 42.121 0 01-1.657-7.11' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M471.67 258.127c-2.9-.2-4.774-3.99-5.712-6.96a59.13 59.13 0 01-1.656-7.013' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M471.67 258.06c-2.9-.413-4.774-4.209-5.647-6.954a67.931 67.931 0 01-1.744-7.02' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M471.67 257.971c-2.9-.564-4.774-4.487-5.582-6.953a70.184 70.184 0 01-1.809-7.018' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M471.67 257.971c-2.812-.781-4.774-4.771-5.515-7.02a46.1 46.1 0 01-1.788-6.951' fill='none' stroke='%23002289' stroke-width='.232'/%3e%3cpath d='M471.736 257.91c-2.9-.938-4.84-5-5.582-7.11a50.891 50.891 0 01-1.787-6.888' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M471.736 257.91c-2.9-1.223-4.84-5.28-5.43-7.178a36.75 36.75 0 01-1.939-6.886' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M471.736 257.754c-2.813-1.284-4.84-5.426-5.43-7.105a41.4 41.4 0 01-1.939-6.892' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M471.736 257.754c-2.813-1.5-4.84-5.8-5.364-7.172a42.026 42.026 0 01-2-6.8' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M471.736 257.686c-2.813-1.652-4.84-6.016-5.277-7.17a44.031 44.031 0 01-2.092-6.8' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M471.8 257.686c-2.9-1.875-4.926-6.295-5.362-7.322a49.254 49.254 0 01-2.092-6.735' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M464.346 243.606a39.674 39.674 0 002.157 6.67c.35.785 2.377 5.211 5.275 7.237' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M464.476 240.927s4.708 11.6 7.76 10.285' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M472.236 251.235c-1.286.569-3.248-1.719-4.84-4.487q-1.571-2.839-2.9-5.8' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M472.236 251.169c-1.155.5-3.182-1.653-4.773-4.488q-1.6-2.835-2.965-5.8' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M472.236 251.169c-1 .44-3.117-1.653-4.773-4.555-1.81-3.248-2.9-5.708-2.9-5.708' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M472.236 251.169c-.784.283-3.03-1.653-4.621-4.622-1.962-3.4-3.03-5.708-3.03-5.708' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M472.236 251.084c-.632.285-2.964-1.59-4.621-4.62-1.962-3.556-3.03-5.715-3.03-5.715' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M472.236 251.084c-.5.195-2.9-1.59-4.556-4.777-2.027-3.617-3.117-5.642-3.117-5.642' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M472.236 251.084c-.282.128-2.812-1.59-4.556-4.838-2.027-3.84-3.03-5.582-3.03-5.582' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M472.236 251.084a12.192 12.192 0 01-4.49-4.838c-2.093-4.057-3.118-5.648-3.118-5.648' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M464.628 240.576a47.8 47.8 0 013.117 5.49 13.028 13.028 0 004.491 4.93m7.63 8l3.9 2.16m-3.684 1.612l3.684-.636' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M479.715 259.215l4.053 1.943' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M479.715 259.366l4.119 1.875' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M479.715 259.583l4.119 1.658' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M479.78 259.718l4.12 1.59' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M479.78 259.868l4.12 1.44' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M479.78 260.086l4.207 1.223' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M479.78 260.237l4.207 1.154' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M479.78 260.46l4.272.931' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M479.78 260.589l4.272.847' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M480.085 262.615l3.683-.565' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M480.085 262.4l3.771-.413' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M480 262.178l3.9-.284' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M480 262.05l3.9-.134' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M479.931 261.833h4.056' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M479.931 261.615l4.056.128' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M479.931 261.391l4.12.286' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M479.931 261.241l4.209.351' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M479.931 261.023l4.274.57' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M479.866 260.806l4.339.72' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M462.6 273.646c-.064-1.155-.13-2.377-.13-3.117.066-4.993-.633-8.764-.065-14.06.414-4.124 1.439-9.637 1.22-14.063a36.124 36.124 0 01.2-3.773l20.384 22.915' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M462.6 261.894a13.9 13.9 0 00.938 4.34c.938 1.875 3.772 4.621 7.02 6.671' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M470.645 272.926a27.9 27.9 0 01-5.276-4.49 18.456 18.456 0 01-1.722-2.245 17.978 17.978 0 01-.937-4.336' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M470.733 272.926a28.179 28.179 0 01-5.276-4.621 10.667 10.667 0 01-1.592-2.158 15.28 15.28 0 01-1.134-4.337' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M470.8 272.926a27.907 27.907 0 01-5.21-4.621 22.114 22.114 0 01-1.656-2.31 16.553 16.553 0 01-1.221-4.34' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M470.863 272.861a31.353 31.353 0 01-5.21-4.621 16.624 16.624 0 01-1.59-2.311 19.942 19.942 0 01-1.353-4.336' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M470.95 272.861a33.516 33.516 0 01-5.144-4.709 16.715 16.715 0 01-1.592-2.31 19.369 19.369 0 01-1.439-4.339' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M471.016 272.861a30.149 30.149 0 01-5.058-4.84 12.208 12.208 0 01-1.591-2.244 19.643 19.643 0 01-1.592-4.34' fill='none' stroke='%23002289' stroke-width='.232'/%3e%3cpath d='M471.08 272.861a35.725 35.725 0 01-4.99-4.926 16.618 16.618 0 01-1.658-2.246 22.971 22.971 0 01-1.656-4.337' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M471.169 272.861a35.784 35.784 0 01-4.993-4.991 20.963 20.963 0 01-1.592-2.246 25.281 25.281 0 01-1.809-4.338' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M471.234 272.861a45.024 45.024 0 01-4.927-5.058 13.574 13.574 0 01-1.591-2.31 24.962 24.962 0 01-1.94-4.335' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M471.3 272.861a41.287 41.287 0 01-4.84-5.144 16.953 16.953 0 01-1.592-2.311 39.447 39.447 0 01-2.093-4.338' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M471.386 272.861c-1.962-1.5-3.77-4.12-4.774-5.21a14.617 14.617 0 01-1.657-2.31c-1.068-1.873-2.158-4.34-2.158-4.34' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M471.452 272.774c-1.94-1.5-3.772-4.12-4.774-5.21a15.13 15.13 0 01-1.5-2.311c-1.221-1.942-2.377-4.335-2.377-4.335' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M462.754 260.806a60.413 60.413 0 004.054 6.67c.937 1 2.813 3.772 4.71 5.277' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M462.82 273.646c3.029 2.028 3.77 2.528 10 6.518l1.88-2.964s-.72-1.656-1-2.528' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M462.884 273.646c2.9 1.94 3.837 2.528 9.94 6.365l.066-.065 1.657-2.812a3.29 3.29 0 00-.283-.784q-.312-.819-.567-1.657' fill='none' stroke='%2300004f' stroke-width='.232'/%3e%3cpath d='M462.884 273.646c2.747 1.876 3.99 2.681 9.94 6.3l.066-.13c0-.066 1.592-2.813 1.592-2.813s-.066-.282-.2-.719c-.2-.5-.414-1.156-.567-1.591' fill='none' stroke='%23000053' stroke-width='.232'/%3e%3cpath d='M462.884 273.646c2.681 1.723 4.208 2.681 9.94 6.147l.066-.13c0-.066 1.439-2.747 1.439-2.747a1.962 1.962 0 00-.195-.72c-.132-.5-.35-1.068-.415-1.5' fill='none' stroke='%23000056' stroke-width='.232'/%3e%3cpath d='M462.884 273.581c2.616 1.722 4.338 2.811 9.94 6.082l.066-.066c0-.13 1.373-2.812 1.373-2.812a2.561 2.561 0 00-.13-.632 6.929 6.929 0 01-.414-1.439' fill='none' stroke='%23000058' stroke-width='.232'/%3e%3cpath d='M462.884 273.581c2.53 1.656 4.491 2.9 9.94 6.016l.066-.13c0-.2 1.287-2.812 1.287-2.812a1.9 1.9 0 00-.132-.567 5.377 5.377 0 01-.348-1.374' fill='none' stroke='%2300005c' stroke-width='.232'/%3e%3cpath d='M462.884 273.581c2.464 1.59 4.71 2.964 9.94 5.864l.132-.131c0-.2 1.068-2.747 1.068-2.747a.945.945 0 00-.065-.566 4.55 4.55 0 01-.284-1.286' fill='none' stroke='%23000060' stroke-width='.232'/%3e%3cpath d='M462.884 273.581c2.4 1.5 4.84 2.964 9.94 5.712l.132-.132c0-.2 1-2.747 1-2.747s.065-.13-.066-.5a11.292 11.292 0 01-.283-1.221' fill='none' stroke='%23000062' stroke-width='.232'/%3e%3cpath d='M462.884 273.581c2.246 1.439 4.993 3.03 9.94 5.646l.132-.131c0-.283.937-2.747.85-2.747 0 0 .131-.13 0-.5a6.88 6.88 0 01-.2-1.155' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M462.972 273.516a90.978 90.978 0 009.853 5.58l.131-.13c0-.283.785-2.748.785-2.748s.13-.065 0-.414a2.821 2.821 0 01-.131-1.068' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M462.972 273.516a72.127 72.127 0 009.853 5.427c.065 0 .131-.13.131-.13 0-.35.72-2.682.72-2.682a.446.446 0 00.065-.414 1.693 1.693 0 01-.131-1' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M462.972 273.516a76.1 76.1 0 009.853 5.362c.065-.066.131-.131.131-.195 0-.285.567-2.595.567-2.595a.407.407 0 00.13-.436 2.145 2.145 0 01-.13-.938' fill='none' stroke='%2300096f' stroke-width='.232'/%3e%3cpath d='M463.037 273.516a74.825 74.825 0 009.788 5.21l.131-.132c0-.414.5-2.68.5-2.68s.195-.066.13-.35a1.82 1.82 0 01-.065-.85' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M463.037 273.516a69.139 69.139 0 009.788 5.078l.131-.13c0-.436.414-2.595.349-2.681 0 0 .349-.066.2-.284-.13-.349 0-.349 0-.785' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M463.037 273.516a64.264 64.264 0 009.853 4.991l.066-.195c0-.415.349-2.6.283-2.6 0 0 .284-.065.2-.283-.13-.284 0-.284.066-.72' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M463.037 273.428a47.808 47.808 0 009.853 4.927c.066 0 .066-.2.066-.2 0-.414.2-2.53.2-2.595 0 0 .283 0 .2-.195-.13-.284.066-.284.131-.634' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M463.037 273.428a46.134 46.134 0 009.853 4.773c.066 0 .066-.13.066-.13 0-.5.13-2.594.065-2.681 0 0 .414.065.283-.13-.064-.284.131-.2.2-.567' fill='none' stroke='%23001c82' stroke-width='.232'/%3e%3cpath d='M463.037 273.363a45.7 45.7 0 009.853 4.773c.066-.064.066-.2.131-.2 0-.566-.065-2.529-.065-2.594 0 0 .349.065.283-.13-.065-.283.131-.13.284-.5' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M463.037 273.363c1.286.85 6.518 3.836 9.853 4.621.066-.065.066-.13.131-.2a21.567 21.567 0 00-.2-2.594s.415.13.415-.066c-.132-.195.065-.065.282-.414' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M463.037 273.363c1.22.785 6.649 3.9 9.853 4.49.066 0 .131-.13.131-.195a15.021 15.021 0 00-.282-2.53s.5.066.413-.065c-.13-.195.13 0 .349-.349' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M463.1 273.363c1 .719 6.735 3.989 9.787 4.425.066-.065.131-.13.131-.2a24.235 24.235 0 00-.35-2.53s.5.066.351-.065c0-.195.283.066.413-.282' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M463.1 273.363c.937.632 6.888 4.054 9.787 4.272.066-.065.131-.13.131-.195a11.133 11.133 0 00-.5-2.53s.5.131.5 0c-.065-.2.283.131.414-.2' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M463.1 273.363c.85.5 7.106 4.054 9.853 4.207 0-.13.065-.2.065-.282a11.628 11.628 0 00-.567-2.53s.567.131.5.066c-.066-.2.283.195.5-.131' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M463.1 273.3c.784.5 7.238 4.207 9.853 4.12 0-.066.065-.2.065-.284a7.429 7.429 0 00-.72-2.463s.634.13.567 0c-.065-.065.35.349.567 0' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M463.1 273.3c.718.5 7.39 4.272 9.853 3.989 0-.066.065-.13.065-.2a8.225 8.225 0 00-.785-2.529s.567.195.567.13c-.065-.13.414.35.633 0' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M463.1 273.3c.632.348 7.608 4.337 9.853 3.836a.655.655 0 00.065-.195 7.635 7.635 0 00-.85-2.465v-.065s.633.283.567.2c0-.132.414.414.72.065' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M463.1 273.3c.5.282 7.76 4.337 9.853 3.77a.422.422 0 00.065-.282 7.132 7.132 0 00-1-2.465s.72.285.633.2c0-.13.5.5.784.13' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M463.168 273.3c.349.195 7.826 4.425 9.788 3.619.065-.067.065-.2.13-.284a8.378 8.378 0 00-1.155-2.464s.72.35.72.2c-.066 0 .5.633.784.284' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M463.168 273.3c.282.13 7.978 4.49 9.788 3.552a1.773 1.773 0 01.13-.282 6.175 6.175 0 00-1.286-2.47s.784.285.719.285c0-.067.567.567.938.282' fill='none' stroke='%230042a8' stroke-width='.232'/%3e%3cpath d='M463.168 273.21c.2.13 8.109 4.621 9.788 3.466.065-.065.065-.13.13-.283 0-.85-1.285-2.311-1.373-2.377l.785.284c-.065-.065.567.633.85.349' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M463.168 273.21c.13.065 8.327 4.709 9.788 3.335a.35.35 0 00.13-.282c0-.938-1.373-2.312-1.5-2.377l.85.283s.566.786.937.5' fill='none' stroke='%230049af' stroke-width='.232'/%3e%3cpath d='M463.255 273.146s9.417 5.361 9.853 2.963c0-.937-1.59-2.31-1.59-2.31l.85.283s.631.85 1 .567' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M464.258 237.808c0-.938.5-2.026 1.155-2.026a4.925 4.925 0 01.785.061c.35.134.414.285.5.636.132.781-.85 1.066-1.59 1.156-.2 0-.72-.068-.786.128-.2.285-.065.195-.2.285a.429.429 0 00.283-.135c.633-.127 1.155-.127 1.94-.278.5-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.962-.42a3.15 3.15 0 00-1.155 2.468c.065-.194.349-.067.414-.284' fill='%23fc0'/%3e%3cpath d='M464.258 237.808c0-.938.5-2.026 1.155-2.026a4.925 4.925 0 01.785.061c.35.134.414.285.5.636.132.781-.85 1.066-1.59 1.156-.2 0-.72-.068-.786.128-.2.285-.065.195-.2.285a.429.429 0 00.283-.135c.633-.127 1.155-.127 1.94-.278.5-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.962-.42a3.15 3.15 0 00-1.155 2.468c.065-.194.349-.067.414-.284z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M463.756 238.092c-.85-.284-2.006-.134-2.223.413a5.648 5.648 0 00-.2.787.68.68 0 00.437.715c.632.35 1.286-.5 1.57-1.156a1.483 1.483 0 01.413-.714c.349-.068.284 0 .349-.068-.065.13-.2.2-.283.285-.284.5-.5.938-.938 1.653a1.154 1.154 0 01-1.656.067 2.252 2.252 0 01.283-2.026 2.822 2.822 0 012.66-.195c-.131-.068-.2.284-.415.195' fill='%23fc0'/%3e%3cpath d='M463.756 238.092c-.85-.284-2.006-.134-2.223.413a3.882 3.882 0 00-.2.787.68.68 0 00.437.715c.632.35 1.286-.5 1.57-1.156a1.483 1.483 0 01.413-.714c.349-.068.284 0 .349-.068-.065.13-.2.2-.283.285-.284.5-.5.938-.938 1.653a1.154 1.154 0 01-1.656.067 2.252 2.252 0 01.283-2.026 2.822 2.822 0 012.66-.195c-.131-.068-.2.284-.415.195z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M463.69 237.673c-.282 0-.348.42-.282.637 0 .194.348.345.566.284a.748.748 0 00.567-.786c-.13-.352-.567-.195-.85-.135' fill='%23fc0'/%3e%3cpath d='M463.69 237.673c-.282 0-.348.42-.282.637 0 .194.348.345.566.284a.748.748 0 00.567-.786c-.13-.352-.567-.195-.85-.135' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M459.68 233.532a15.319 15.319 0 003.99 2.032 5.785 5.785 0 000 2.244 5.536 5.536 0 00-2.53-.5 9.844 9.844 0 00-1.438-3.773' fill='%23fc0'/%3e%3cpath d='M459.68 233.532a15.319 15.319 0 003.99 2.032 5.785 5.785 0 000 2.244 5.536 5.536 0 00-2.53-.5 9.844 9.844 0 00-1.438-3.773z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M461.294 235.19a5.7 5.7 0 001.59.787 1.8 1.8 0 000 .848 2.815 2.815 0 00-1-.128 3.466 3.466 0 00-.566-1.507z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M463.386 239.549a11.331 11.331 0 00.85-.937c.065-.129-.35.937.065 1.221a5.388 5.388 0 010 2.595 2.232 2.232 0 01-2.026-.345c-.284-.285.065-.855.282-1.29a5.224 5.224 0 01.785-1.222' fill='%23fc0'/%3e%3cpath d='M463.386 239.549a11.331 11.331 0 00.85-.937c.065-.129-.35.937.065 1.221a5.388 5.388 0 010 2.595 2.232 2.232 0 01-2.026-.345c-.284-.285.065-.855.282-1.29a5.224 5.224 0 01.785-1.222z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M463.974 239.113c0 .068-.065.42-.065.5.065.195.283.284.349.569a13.243 13.243 0 01-.13 2.154m-.219-2.416a7.672 7.672 0 01-.065 2.46h.065m-.153-.937a2.006 2.006 0 00-.13.938c-.066-.062-.2.067-.283.067' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.624 326.9c.13 0 .282-.134.413-.195.349-.2 1-.2 1.22-.42 1-1.154.35-3.33-.13-4.7-.784-2.533-.85-4.844-1.439-7.238h-.065a55.114 55.114 0 01-1.5 7.238c-.35 1.373-1.069 3.55-.066 4.705.2.2.85.2 1.286.419.066.061.2.195.284.195' fill='white'/%3e%3cpath d='M501.624 314.213c-.5 2.377-.633 4.839-1.5 7.394-.35 1.218-1 3.249-.2 4.42l-.066-.06h.066a3.169 3.169 0 01-1.069-.195c-.066-.069-.2-.069-.282-.2a1.8 1.8 0 00-.5-.5c-.2-.133-.5-.066-.719-.2-.065-.062-.13-.13-.2-.13a2.587 2.587 0 01-1.221-1.065 3.84 3.84 0 01-.066-1.221c.066-.286.2-.5.284-.788a5.751 5.751 0 01.5-1.065 7.874 7.874 0 01.567-1.156 190.615 190.615 0 01.566-1c.066-.195.283-.285.415-.5.13-.128-.16 0-.006-.16a2.781 2.781 0 00.358-.463c.065 0 .313-.1.313-.157.414-.72.73-.833 1.012-1.575a2.214 2.214 0 00.2-1.155h1.5' fill='%23004bb3'/%3e%3cpath d='M500.9 314.28a34.94 34.94 0 01-1.5 5c-.566 1-2.813 2.808-1.374 5.709' fill='none' stroke='%23003' stroke-width='.232'/%3e%3cpath d='M501.056 314.28a34.94 34.94 0 01-1.5 5c-.633 1.066-2.835 2.963-1.286 5.86' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M501.121 314.28a39 39 0 01-1.5 5.146c-.567 1-2.812 2.963-1.22 5.864' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M501.273 314.28a34.292 34.292 0 01-1.525 5.146c-.633 1-2.812 3.03-1.221 6.016' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M501.34 314.28a35.98 35.98 0 01-1.5 5.212c-.567 1-2.747 3.115-1.155 6.079' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M501.405 314.28s-.85 4.275-1.5 5.275c-.566 1-2.68 3.185-1.067 6.15' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M500.838 314.28a38.373 38.373 0 01-1.5 4.928c-.567 1.066-2.9 2.9-1.374 5.71' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M500.75 314.37a34.783 34.783 0 01-1.59 4.838c-.568 1-2.9 2.9-1.374 5.71' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M500.6 314.37a27.385 27.385 0 01-1.592 4.838c-.5 1-2.811 2.813-1.286 5.71' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M500.533 314.37a21.653 21.653 0 01-1.656 4.772c-.5 1.071-2.813 2.9-1.287 5.714' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M500.4 314.37a25.7 25.7 0 01-1.592 4.772c-.567 1-2.812 2.9-1.286 5.714' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M501.624 314.213c.565 2.377.719 4.839 1.5 7.394.414 1.218 1.069 3.249.283 4.42l.01-.148a2.841 2.841 0 001.059-.216c.13-.069.195-.046.283-.18a2.5 2.5 0 01.436-.409c.283-.134.567-.068.85-.2.066-.062.066-.13.13-.13a1.827 1.827 0 001.287-2.286 2.835 2.835 0 00-.283-.788 5.877 5.877 0 00-.5-1.065 8.08 8.08 0 00-.567-1.156 1.16 1.16 0 00-.283-.5 2.78 2.78 0 00-.284-.5c-.066-.195-.283-.285-.414-.5-.18-.32-.3-.281-.37-.438-.065 0-.092.063 0 0-.066 0-.168-.146-.256-.207a7.183 7.183 0 01-1.07-1.706 2.217 2.217 0 01-.2-1.156h-1.59' fill='%23004bb3'/%3e%3cpath d='M502.43 314.28a35.041 35.041 0 001.5 5c.567 1 2.813 2.808 1.286 5.709' fill='none' stroke='%23003' stroke-width='.232'/%3e%3cpath d='M502.276 314.28a28.091 28.091 0 001.592 5c.567 1.066 3.066 2.594 1.54 5.49' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M502.211 314.28a39 39 0 001.5 5.146c.567 1 2.885 2.8 1.293 5.7' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M502.06 314.28a36.435 36.435 0 001.59 5.146c.563 1 2.815 2.753 1.358 5.7-.007.013-.034.013-.04.027s.227-.251.04-.027' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M501.994 314.28s.936 4.209 1.59 5.212c.5 1 2.682 3.115 1.068 6.079' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M501.928 314.28a36.187 36.187 0 001.5 5.275c.567 1 2.682 3.185 1.068 6.15' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M502.5 314.28a30.09 30.09 0 001.591 4.928c.566 1.066 2.813 2.9 1.286 5.71' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M502.647 314.37a31.333 31.333 0 001.5 4.838c.566 1 2.9 2.9 1.373 5.71' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M502.713 314.37a27.5 27.5 0 001.59 4.838c.568 1 2.813 2.813 1.374 5.71' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M502.8 314.37a29.831 29.831 0 001.591 4.772c.567 1.071 2.9 2.9 1.374 5.714' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M502.93 314.37a25.7 25.7 0 001.592 4.772c.567 1 2.9 2.9 1.373 5.714' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M504.85 317.461a7.077 7.077 0 01.642 1 4.6 4.6 0 01.283.5 1.291 1.291 0 01.284.5 10.474 10.474 0 01.567 1.155 10.931 10.931 0 01.5 1.066 5.762 5.762 0 01.282.787 2.541 2.541 0 01-.064 1.217 2.48 2.48 0 01-1.22 1.071s-.067.062-.132.129c-.283.133-.566.066-.85.195a3.884 3.884 0 00-.436.5c-.065.134-.13.134-.283.195a2.678 2.678 0 01-1.068.2v0a.417.417 0 01-.132.28c-.2.194-.85.194-1.22.418-.13.062-.283.195-.414.195-.066 0-.2-.133-.283-.195-.415-.2-1.069-.2-1.287-.419a.338.338 0 01-.13-.28v0a3.013 3.013 0 01-1.069-.2c-.065-.062-.2-.062-.282-.2a1.888 1.888 0 00-.5-.5c-.2-.129-.5-.062-.721-.195-.064-.068-.13-.129-.195-.129a2.573 2.573 0 01-1.222-1.051 3.78 3.78 0 01-.066-1.218c.066-.283.2-.5.283-.786a5.737 5.737 0 01.5-1.066 7.873 7.873 0 01.567-1.155 1.142 1.142 0 01.283-.5 1.16 1.16 0 01.284-.5 10.327 10.327 0 01.645-.874' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M459.37 272.661c-.341 6.572-.192 8.481-.192 14.894a31.329 31.329 0 003.006 10.68l6.678-11.159h-.027a23.483 23.483 0 01-1.22-4.273 18.507 18.507 0 01-.2-4.812z' fill='white'/%3e%3cpath d='M468.836 287.075a23.365 23.365 0 01-1.221-4.274 18.582 18.582 0 01-.2-4.84l4.927 3.184-3.466 5.93' fill='%23004bb3'/%3e%3cpath d='M472.825 280.4l-23.283-15.216-.414.567 23.217 15.434.5-.785' fill='%23fc0'/%3e%3cpath d='M472.825 280.4l-23.283-15.216-.414.567 23.217 15.434.5-.785z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M454.84 310.508a5.157 5.157 0 01-1.723-2.154 17.677 17.677 0 01-.936-3.471c-.2-1.066-.2-2.244-.5-3.334-.132-1.068-1.723-4.621-1.81-6.016-.131-4.622-1.657-7.76-1.286-12.753.282-3.9 1.155-9.2.72-13.276a30.771 30.771 0 01.065-3.467l10 6.52c-.347 6.67-.194 8.545-.194 15a31.226 31.226 0 003.03 10.726l-7.324 12.25' fill='%23004bb3'/%3e%3cpath d='M462.078 298.236l-7.326 12.25a5.488 5.488 0 01-1.808-2.155c-.5-1.657-.414-1.657-.85-3.465-.2-1.071-.2-2.248-.414-3.338-.283-1.068-1.81-4.622-1.876-6.017m-.043-.021c.066 1.373 1.591 4.84 1.875 5.93.2 1.067.2 2.244.414 3.334a23.237 23.237 0 00.937 3.466 4.974 4.974 0 001.744 2.093l7.325-12.1' fill='none' stroke='%2300004b' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.373 1.591 4.773 1.81 5.864.282 1.068.282 2.245.566 3.333a29.441 29.441 0 00.85 3.466 5.536 5.536 0 001.744 2.092s7.238-11.965 7.325-12.03m-12.295-2.725c.066 1.373 1.591 4.773 1.81 5.864.282 1 .282 2.158.566 3.25a28.667 28.667 0 00.85 3.4 4.855 4.855 0 001.744 2.025c.066.067 7.238-11.748 7.325-11.813' fill='none' stroke='%2300004f' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.286 1.591 4.708 1.81 5.8.282 1.068.282 2.159.566 3.182a25.82 25.82 0 00.85 3.4 5.626 5.626 0 001.744 2.093c.131 0 7.238-11.665 7.325-11.752m-12.295-2.725c.066 1.286 1.591 4.621 1.81 5.711.282 1 .282 2.158.566 3.185a15.4 15.4 0 00.938 3.332 5.116 5.116 0 001.722 2.092c.065 0 7.106-11.53 7.238-11.6' fill='none' stroke='%23000051' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.286 1.5 4.556 1.81 5.646.282 1 .282 2.158.566 3.183a17.733 17.733 0 00.938 3.337 4.986 4.986 0 001.722 2.026c.065.067 7.106-11.38 7.238-11.446m-12.275-2.747c.067 1.286 1.5 4.557 1.81 5.582.283 1.068.283 2.158.567 3.182a20.532 20.532 0 00.938 3.247 4.532 4.532 0 001.722 2.027c.13.066 7.019-11.225 7.238-11.312' fill='none' stroke='%23000053' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.286 1.5 4.49 1.81 5.58.282 1 .282 2.093.566 3.118a25.181 25.181 0 00.938 3.244 5.509 5.509 0 001.722 1.944c.13.066 7.019-11.1 7.238-11.161m-12.275-2.725c.067 1.22 1.5 4.425 1.81 5.428.283 1.068.283 2.158.567 3.182a21.934 21.934 0 00.938 3.182 5.023 5.023 0 001.722 1.943c.13.06 7.019-10.945 7.238-11.01m-12.275-2.725c.067 1.22 1.5 4.425 1.81 5.428.283 1 .283 2.026.567 3.03a18.168 18.168 0 00.938 3.184 4.568 4.568 0 001.722 1.936c.2.068 6.953-10.788 7.238-10.876' fill='none' stroke='%23000056' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.22 1.5 4.338 1.81 5.363.282 1 .282 2.092.566 3.03a28.323 28.323 0 00.938 3.115 4.58 4.58 0 001.722 1.942c.2.066 6.953-10.66 7.238-10.725m-12.275-2.725c.067 1.22 1.5 4.273 1.81 5.275.283 1 .283 2.092.567 2.964a18.2 18.2 0 001 3.186 4.682 4.682 0 001.656 1.874c.284.129 6.955-10.443 7.238-10.574' fill='none' stroke='%23000058' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.22 1.5 4.273 1.81 5.275.282.938.282 1.94.566 2.9a19.051 19.051 0 001 3.115 5.423 5.423 0 001.656 1.942c.284.067 6.89-10.355 7.238-10.507m-12.273-2.725c.066 1.155 1.438 4.207 1.81 5.21.282.937.282 1.962.566 2.9a19.39 19.39 0 001 3.12 5.373 5.373 0 001.656 1.87c.284.067 6.89-10.221 7.238-10.353' fill='none' stroke='%2300005c' stroke-width='.232'/%3e%3cpath d='M449.761 295.49c.066 1.155 1.438 4.12 1.81 5.144.282.938.348 1.94.566 2.9a16.05 16.05 0 001 3.03 4.686 4.686 0 001.656 1.873c.35.068 6.89-10.07 7.238-10.222m-12.273-2.725c.066 1.068 1.438 4.054 1.81 5.057.282 1 .348 1.94.566 2.9a18.287 18.287 0 001 2.965 4.676 4.676 0 001.656 1.874c.35.129 6.89-9.918 7.238-10.071' fill='none' stroke='%2300005e' stroke-width='.232'/%3e%3cpath d='M449.761 295.425c.066 1.155 1.438 4.12 1.81 5.143.282.852.348 1.875.566 2.813a15.671 15.671 0 001 2.9 5.32 5.32 0 001.656 1.875c.35.133 6.8-9.785 7.238-9.917m-12.273-2.811a21.3 21.3 0 001.81 4.991c.282.938.348 1.94.566 2.813.5 1.5.5 1.5 1 2.965A4.622 4.622 0 00454.8 308c.415.129 6.737-9.634 7.238-9.787m-12.273-2.79a22.413 22.413 0 001.81 4.991 26.158 26.158 0 00.632 2.747 23.54 23.54 0 001 2.964 4.535 4.535 0 001.59 1.724c.5.129 6.737-9.483 7.239-9.636' fill='none' stroke='%23000060' stroke-width='.232'/%3e%3cpath d='M449.761 295.425c.066 1.155 1.352 3.9 1.81 4.926a26.216 26.216 0 00.632 2.747 19.5 19.5 0 001 2.9 5.327 5.327 0 001.59 1.719c.5.134 6.737-9.35 7.239-9.482m-12.275-2.811a21.726 21.726 0 001.81 4.838 26.551 26.551 0 00.633 2.747 20.244 20.244 0 001 2.81 6.005 6.005 0 001.656 1.814c.414.061 6.671-9.266 7.172-9.42' fill='none' stroke='%23000062' stroke-width='.232'/%3e%3cpath d='M449.761 295.425a22.88 22.88 0 001.81 4.838c.195.85.348 1.81.632 2.682a16.74 16.74 0 001 2.747 4.681 4.681 0 001.656 1.725c.5.194 6.6-8.984 7.172-9.2m-12.273-2.79a21.127 21.127 0 001.81 4.773c.195.85.348 1.809.632 2.682a15.744 15.744 0 001.067 2.745 4.182 4.182 0 001.592 1.657c.5.195 6.6-8.85 7.172-9.067' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M449.761 295.425a20.652 20.652 0 001.81 4.708 23.344 23.344 0 00.632 2.594 12.569 12.569 0 001.067 2.747 4.505 4.505 0 001.592 1.72c.5.133 6.6-8.761 7.172-8.98m-12.273-2.79a19.992 19.992 0 001.81 4.622 23.738 23.738 0 00.632 2.616 20.884 20.884 0 001.067 2.745 4.831 4.831 0 001.592 1.658c.567.128 6.517-8.632 7.172-8.85' fill='none' stroke='%23000268' stroke-width='.232'/%3e%3cpath d='M449.761 295.425a19.336 19.336 0 001.81 4.621c.195.784.348 1.656.632 2.528a18.974 18.974 0 001.067 2.683 4.353 4.353 0 001.592 1.657c.567.195 6.453-8.481 7.172-8.7m-12.273-2.79a16.583 16.583 0 001.81 4.491 14.859 14.859 0 00.718 2.594 10.409 10.409 0 001 2.591 4.251 4.251 0 001.592 1.658c.566.2 6.451-8.325 7.171-8.543m-12.295-2.79a17.489 17.489 0 001.81 4.49 12.2 12.2 0 00.718 2.463 13.1 13.1 0 001 2.594 4.317 4.317 0 001.592 1.657c.63.129 6.451-8.11 7.171-8.414' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M449.761 295.425a18.388 18.388 0 001.81 4.424 12.21 12.21 0 00.718 2.464 15.508 15.508 0 001 2.591 5.438 5.438 0 001.592 1.592c.63.2 6.451-7.976 7.171-8.26m-12.295-2.811a17.505 17.505 0 001.81 4.338 13.571 13.571 0 00.718 2.462 13.082 13.082 0 001 2.53 4.117 4.117 0 001.592 1.59c.718.195 6.386-7.825 7.171-8.109' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M449.761 295.425a17.505 17.505 0 001.81 4.338 19.575 19.575 0 00.718 2.376 13.11 13.11 0 001.069 2.526 3.815 3.815 0 001.5 1.507c.72.194 6.388-7.674 7.172-7.979m-12.273-2.768a20.683 20.683 0 001.722 4.272c.283.72.5 1.591.785 2.376a11.084 11.084 0 001.068 2.464 5.516 5.516 0 001.5 1.59c.72.134 6.387-7.608 7.172-7.891' fill='none' stroke='%2300096f' stroke-width='.232'/%3e%3cpath d='M449.827 295.425a13.976 13.976 0 001.656 4.207c.283.784.5 1.59.785 2.31a10.957 10.957 0 001.068 2.46 4.293 4.293 0 001.5 1.508c.785.284 6.3-7.39 7.172-7.674m-12.186-2.811a14.447 14.447 0 001.657 4.12c.283.785.5 1.591.785 2.31a15.292 15.292 0 001.068 2.465 4.126 4.126 0 001.5 1.439c.785.28 6.3-7.24 7.172-7.544' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M449.827 295.425a14.074 14.074 0 001.656 4.054c.283.784.5 1.592.785 2.31a12.493 12.493 0 001.068 2.4 4.974 4.974 0 001.5 1.5c.785.195 6.3-7.172 7.172-7.456m-12.186-2.811a13.731 13.731 0 001.657 3.989c.283.784.5 1.592.785 2.31.414 1.156.567 1.221 1.068 2.376a6.638 6.638 0 001.5 1.441c.85.195 6.234-7.021 7.172-7.325m-12.186-2.791a13.731 13.731 0 001.657 3.989c.283.719.5 1.5.785 2.244a20.21 20.21 0 001.068 2.312 5.586 5.586 0 001.591 1.437c.85.285 6.147-6.887 7.107-7.17' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M449.827 295.425c0 .85 1.154 3.03 1.656 3.9.283.72.5 1.5.785 2.246a14.748 14.748 0 001.155 2.245 4.134 4.134 0 001.5 1.44c.85.195 6.082-6.671 7.107-7.021m-12.207-2.811a13.705 13.705 0 001.656 3.836c.283.72.5 1.5.785 2.159a12.1 12.1 0 001.155 2.31 4.482 4.482 0 001.5 1.37c.85.284 6.082-6.514 7.107-6.885' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M449.827 295.425c0 .784 1.154 2.9 1.656 3.836.283.632.5 1.373.785 2.093a12.214 12.214 0 001.155 2.245 4.5 4.5 0 001.5 1.373c.938.285 6.082-6.365 7.107-6.736m-12.207-2.811a10.2 10.2 0 001.656 3.683c.283.72.5 1.5.785 2.159a10.91 10.91 0 001.155 2.158 4.5 4.5 0 001.5 1.374c.938.284 6.017-6.235 7.107-6.584' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M449.827 295.425a10.9 10.9 0 001.656 3.683c.283.633.5 1.439.785 2.093a13 13 0 001.155 2.158 4.207 4.207 0 001.5 1.284c.938.285 6.017-6.079 7.107-6.45m-12.207-2.768a10.632 10.632 0 001.656 3.618c.283.72.5 1.373.785 2.093.5 1 .632 1.068 1.155 2.093a5.707 5.707 0 001.5 1.374c1 .28 6.017-6.017 7.107-6.367' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M449.827 295.425a10.353 10.353 0 001.656 3.552c.283.634.5 1.374.785 2.094.5 1 .632 1.068 1.155 2.092a6.556 6.556 0 001.5 1.284c1 .285 5.93-5.861 7.107-6.232m-12.207-2.79a8.821 8.821 0 001.656 3.465 18.756 18.756 0 00.85 2.028 17.2 17.2 0 001.068 2.092 4.23 4.23 0 001.5 1.221c1 .35 5.93-5.645 7.106-6.016m-12.186-2.79a10.122 10.122 0 001.657 3.465c.283.633.5 1.286.85 1.94a10.414 10.414 0 001.156 2.027 5.648 5.648 0 001.438 1.287c1.069.28 5.865-5.58 7.107-5.93' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M449.827 295.425a9.364 9.364 0 001.656 3.4c.283.566.5 1.285.85 1.94a9.241 9.241 0 001.156 1.94 5.643 5.643 0 001.438 1.286c1.069.351 5.865-5.428 7.107-5.8m-12.207-2.767a9.126 9.126 0 001.656 3.334 18.061 18.061 0 00.85 1.875 10.414 10.414 0 001.156 2.027 5.78 5.78 0 001.438 1.221c1.156.284 5.865-5.21 7.107-5.646' fill='none' stroke='%23001c82' stroke-width='.232'/%3e%3cpath d='M449.827 295.425a9.653 9.653 0 001.656 3.334c.283.567.5 1.222.85 1.81a8.215 8.215 0 001.22 2.026 4.362 4.362 0 001.374 1.157c1.156.348 5.8-5.058 7.107-5.5m-12.207-2.832a8.621 8.621 0 001.656 3.182 18.045 18.045 0 00.85 1.874 9.58 9.58 0 001.22 1.941 4.369 4.369 0 001.374 1.155c1.156.35 5.8-4.926 7.107-5.362' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a8.737 8.737 0 001.656 3.27c.283.566.5 1.22.85 1.81a9.165 9.165 0 001.22 1.873 4.362 4.362 0 001.374 1.157c1.221.349 5.8-4.775 7.107-5.211m-12.207-2.9a8.3 8.3 0 001.656 3.184c.283.566.5 1.22.85 1.81a9.457 9.457 0 001.22 1.809 3.662 3.662 0 001.44 1.155c1.155.349 5.646-4.622 7.02-5.058' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a6.942 6.942 0 001.656 3.117c.283.567.5 1.22.85 1.81a16.674 16.674 0 001.22 1.81 5.192 5.192 0 001.44 1.068c1.155.414 5.646-4.426 7.02-4.927m-12.187-2.878a7.038 7.038 0 001.657 3.03 13.921 13.921 0 00.85 1.722 16.674 16.674 0 001.22 1.81 5.531 5.531 0 001.44 1.155c1.22.349 5.646-4.338 7.02-4.84m-12.187-2.877a7.038 7.038 0 001.657 3.03c.283.5.5 1.155.85 1.657a14.774 14.774 0 001.22 1.81 6.873 6.873 0 001.44 1.067c1.286.349 5.646-4.207 7.02-4.709' fill='none' stroke='%23002289' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a7.511 7.511 0 001.656 2.965c.283.5.5 1.068.85 1.656a21 21 0 001.22 1.723 3.943 3.943 0 001.44 1c1.286.414 5.582-3.99 7.02-4.49m-12.187-2.857a6.923 6.923 0 001.657 2.9c.283.567.5 1.069.85 1.656a9.169 9.169 0 001.286 1.658 4.117 4.117 0 001.374 1.068c1.286.414 5.494-3.9 7.02-4.426' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a7.794 7.794 0 001.656 2.9c.283.5.5 1 .85 1.592a7.042 7.042 0 001.286 1.592 4.1 4.1 0 001.374 1.067c1.373.414 5.494-3.77 7.02-4.272m-12.187-2.878a6.8 6.8 0 001.657 2.747c.283.5.5 1.155.85 1.656.5.72.72.85 1.286 1.592a6.181 6.181 0 001.374 1c1.373.348 5.494-3.619 7.02-4.12' fill='none' stroke='%2300288f' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a6.38 6.38 0 001.656 2.747 17.16 17.16 0 00.85 1.5c.5.785.784.938 1.286 1.657a4.025 4.025 0 001.439.938c1.286.414 5.363-3.466 6.954-3.99m-12.186-2.855a5.875 5.875 0 001.657 2.68 17.045 17.045 0 00.85 1.5c.5.72.784.85 1.286 1.592a5.158 5.158 0 001.439.938c1.373.414 5.363-3.336 6.954-3.837' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.945 5.945 0 001.59 2.594c.35.5.633 1 1 1.5a11.474 11.474 0 001.22 1.5 5.1 5.1 0 001.44.937c1.373.414 5.361-3.182 6.953-3.77m-12.207-2.77a5.925 5.925 0 001.59 2.53c.35.5.633 1 1 1.439a7.681 7.681 0 001.22 1.5 4.932 4.932 0 001.44 1c1.373.348 5.361-3.117 6.953-3.685m-12.207-2.79a5.642 5.642 0 001.59 2.463c.35.5.633 1 1 1.44a8.328 8.328 0 001.286 1.5 3.26 3.26 0 001.35.849c1.44.5 5.3-2.811 6.955-3.466' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.642 5.642 0 001.59 2.463c.35.415.633.938 1 1.373a8.678 8.678 0 001.286 1.439 4.683 4.683 0 001.35.938c1.44.414 5.212-2.747 6.955-3.4m-12.186-2.813a5.524 5.524 0 001.591 2.4c.35.415.633.938 1 1.352a12.484 12.484 0 001.286 1.44 9.628 9.628 0 001.35.85c1.5.414 5.212-2.594 6.955-3.25' fill='none' stroke='%23002f96' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a4.919 4.919 0 001.59 2.31c.35.437.633.939 1 1.374.414.566.784.784 1.286 1.374a5.879 5.879 0 001.35.85c1.5.413 5.212-2.463 6.955-3.118m-12.186-2.79a5.137 5.137 0 001.591 2.245 15.526 15.526 0 001 1.286 6.3 6.3 0 001.373 1.374 4.124 4.124 0 001.286.85c1.591.5 5.145-2.31 6.954-2.965' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.671 5.671 0 001.59 2.245c.35.414.633.786 1 1.221a7.084 7.084 0 001.373 1.286 3.467 3.467 0 001.286.85c1.591.415 5.145-2.157 6.954-2.812m-12.207-2.79a5.4 5.4 0 001.59 2.158c.35.35.633.785 1 1.221a7.054 7.054 0 001.381 1.284 4.829 4.829 0 001.286.785c1.591.5 5.145-2.028 6.954-2.681' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a4.9 4.9 0 001.59 2.092c.35.35.633.873 1 1.222a9.315 9.315 0 001.373 1.22 3.589 3.589 0 001.286.785c1.656.5 5.145-1.874 6.954-2.53m-12.207-2.79a4.317 4.317 0 001.59 2.028c.35.414.633.85 1 1.222a15.69 15.69 0 001.373 1.22 4.684 4.684 0 001.286.72c1.656.5 5.058-1.723 6.954-2.378m-12.207-2.811a4.125 4.125 0 001.59 1.94 12.259 12.259 0 001 1.221c.414.5.85.632 1.373 1.155a4.651 4.651 0 001.286.72c1.744.5 5.058-1.591 6.954-2.246' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.006 5.006 0 001.59 1.94 10.939 10.939 0 001 1.068 8.917 8.917 0 001.373 1.156 7.546 7.546 0 001.286.785c1.744.5 5.058-1.44 6.954-2.16m-12.207-2.79a5.121 5.121 0 001.59 1.876 11.054 11.054 0 001 1.068 7.5 7.5 0 001.373 1.069 2.711 2.711 0 001.286.718c1.744.567 4.992-1.22 6.954-1.94' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.131 5.131 0 001.59 1.81 11.292 11.292 0 001 1.068 10.19 10.19 0 001.439 1.068 5.534 5.534 0 001.286.72c1.722.5 4.926-1.156 6.888-1.876m-12.207-2.79a4.755 4.755 0 001.5 1.722l1.068 1.068c.5.436.85.633 1.44 1.069a5.476 5.476 0 001.285.632c1.723.5 4.84-1 6.89-1.722' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.6 5.6 0 001.5 1.722 14.273 14.273 0 011.068 1c.5.413.938.566 1.44 1a5.476 5.476 0 001.285.632c1.723.566 4.84-.85 6.89-1.591m-12.187-2.77a5.64 5.64 0 001.5 1.657c.35.284.72.633 1.156 1 .414.35.85.567 1.374.939a3.934 3.934 0 001.286.63c1.809.5 4.84-.718 6.888-1.438' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.583 5.583 0 001.5 1.592c.35.282.72.632 1.156.937a6.092 6.092 0 001.374.937 4.679 4.679 0 001.286.632c1.809.567 4.773-.567 6.888-1.286m-12.207-2.812a4.691 4.691 0 001.5 1.5 8.369 8.369 0 001.156.937c.414.349.85.567 1.374.938a13.663 13.663 0 001.286.567c1.809.566 4.773-.415 6.888-1.156m-12.207-2.79a5.057 5.057 0 001.5 1.439c.35.282.72.567 1.156.937a7.648 7.648 0 001.374.85c.414.2.85.414 1.286.633 1.875.5 4.773-.35 6.888-1.07' fill='none' stroke='%230042a8' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a6.091 6.091 0 001.5 1.439c.35.2.72.5 1.156.785a7.476 7.476 0 001.439.937 7.964 7.964 0 001.22.5c1.941.566 4.71-.132 6.889-.85m-12.207-2.813a11.879 11.879 0 002.659 2.158 6.357 6.357 0 001.439.85 4.355 4.355 0 001.22.5c1.941.632 4.71 0 6.889-.72' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a9.156 9.156 0 001.5 1.286c.35.2.72.567 1.156.785a5.694 5.694 0 001.439.784c.349.2.85.35 1.22.567 1.941.567 4.622.13 6.889-.632m-12.207-2.79a7.334 7.334 0 001.5 1.22 13.46 13.46 0 001.156.786c.414.282.937.5 1.439.784.414.131.85.349 1.22.5a12.183 12.183 0 006.889-.5' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a5.256 5.256 0 001.5 1.22 13.08 13.08 0 011.156.72 8.946 8.946 0 001.439.72c.414.195.85.348 1.22.5a12.284 12.284 0 006.889-.349m-12.207-2.812a18.167 18.167 0 001.5 1.155c.35.2.72.414 1.221.72.35.195.85.414 1.352.632.415.195.85.348 1.22.5a11.665 11.665 0 006.89-.2' fill='none' stroke='%230049af' stroke-width='.232'/%3e%3cpath d='M449.827 295.337a11.288 11.288 0 001.5 1.068 12.55 12.55 0 001.221.633 6.163 6.163 0 001.352.719c.415.13.85.282 1.22.414a11.978 11.978 0 006.89-.065m-12.187-2.77s6.3 4.927 12.252 2.813' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M449.543 275.892s1.22 7.913 1.722 9.07c.348 1 2.9 5.491 6.67 6.516' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M449.543 275.892s1.286 7.825 1.81 8.915c.413 1 2.746 5.364 6.67 6.671' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M449.608 275.825s1.374 7.762 1.875 8.982a13.21 13.21 0 006.517 6.671' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M449.608 275.825s1.438 7.762 1.94 8.917a13.506 13.506 0 006.452 6.671' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M449.608 275.825s1.5 7.674 2.027 8.765a14.687 14.687 0 006.366 6.8' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M449.608 275.825s1.591 7.609 2.158 8.765a15.148 15.148 0 006.235 6.8' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M449.608 275.825s1.657 7.543 2.246 8.7a16 16 0 006.147 6.8' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M449.674 275.825s1.656 7.457 2.245 8.634a17.11 17.11 0 006.081 6.889' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M449.674 275.825s1.809 7.391 2.31 8.547c.567 1.067 1.744 3.683 6.083 6.954' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M449.761 275.76s1.81 7.456 2.376 8.547c.5 1.067 1.5 3.4 5.93 7.02' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M449.761 275.76s1.875 7.326 2.442 8.48c.566 1.069 1.373 3.184 5.864 7.02' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M449.761 275.76s2.027 7.326 2.528 8.415c.567 1.069 1.286 2.965 5.865 7.02' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M449.761 275.674s2.093 7.324 2.594 8.393c.567 1.068 1.156 2.747 5.776 7.106' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M450.045 271.03s1 11.162 8.98 14.214' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M450.045 271.03a32.315 32.315 0 002.092 7.02 13.478 13.478 0 006.888 7.171' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M450.11 271.03a27.714 27.714 0 002.093 7.02 14.707 14.707 0 006.8 7.171' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M450.11 271.03a28.157 28.157 0 002.158 6.888c1.155 2.312 3.183 5.582 6.736 7.238' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M450.11 271.03a27.905 27.905 0 002.31 6.888c1 2.093 3.03 5.494 6.584 7.173' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M450.11 271.03a31.6 31.6 0 002.376 6.8c.937 1.876 3.03 5.43 6.517 7.238' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M450.2 271.03a29.806 29.806 0 002.4 6.736 17.306 17.306 0 006.452 7.326' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M450.2 270.964a35.374 35.374 0 002.464 6.737c.784 1.5 2.9 5.276 6.365 7.325' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M450.2 270.964a30.745 30.745 0 002.616 6.671c.72 1.44 2.747 5.277 6.235 7.39' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M450.262 270.964a28.306 28.306 0 002.594 6.671c.634 1.156 2.66 5.145 6.147 7.39' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M450.262 270.964a35.8 35.8 0 002.66 6.605c.633 1 2.594 5.06 6.082 7.391' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M450.262 270.964a32.025 32.025 0 002.813 6.519c.5.785 2.462 4.992 5.93 7.455' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M450.262 270.964a30.066 30.066 0 002.9 6.453c.414.633 2.375 4.993 5.864 7.543' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M450.11 267.913s2.31 8.981 8.85 11.161' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M450.11 267.913a24.726 24.726 0 003.03 6.235 12.044 12.044 0 005.8 4.926' fill='none' stroke='%2300056b' stroke-width='.232'/%3e%3cpath d='M450.11 267.913a24.568 24.568 0 003.03 6.147c1.5 2.093 3.554 4.273 5.8 4.993' fill='none' stroke='%2300096f' stroke-width='.232'/%3e%3cpath d='M450.11 267.848a24.906 24.906 0 003.183 6.152c1.5 2.158 3.618 4.338 5.646 5.058' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M450.2 267.782a25.035 25.035 0 003.182 6.234c1.506 2.093 3.772 4.426 5.581 5.058' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M450.2 267.782a25.8 25.8 0 003.248 6.083c1.591 2.223 3.837 4.556 5.494 5.144' fill='none' stroke='%23001c82' stroke-width='.232'/%3e%3cpath d='M450.2 267.782a27.84 27.84 0 003.248 6.017c1.722 2.31 4.055 4.708 5.494 5.21' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M450.2 267.7a25.115 25.115 0 003.4 6.017c1.723 2.31 4.055 4.84 5.363 5.275' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M450.262 267.7a24.248 24.248 0 003.4 5.929c1.745 2.377 4.208 4.927 5.277 5.276' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M450.262 267.7a26.509 26.509 0 003.466 5.865c1.788 2.376 4.273 5.055 5.211 5.361' fill='none' stroke='%23002f96' stroke-width='.232'/%3e%3cpath d='M450.262 267.63a25.1 25.1 0 003.554 5.864c1.809 2.375 4.425 5.21 5.143 5.427' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M450.262 267.63a30.293 30.293 0 003.62 5.864 36.75 36.75 0 005.057 5.427' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M450.262 267.63a32.839 32.839 0 003.684 5.71 49.01 49.01 0 004.993 5.582' fill='none' stroke='%230042a8' stroke-width='.232'/%3e%3cpath d='M450.262 267.564a30.756 30.756 0 003.771 5.711 50.2 50.2 0 004.993 5.646' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M450.262 267.476a37.055 37.055 0 003.837 5.712c2.027 2.6 4.927 5.647 4.927 5.647m8.436 1.35l4.426.786m-3.99 2.55l3.99-1.656' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M467.4 280.251l4.425.72' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M467.4 280.47l4.49.5' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M467.463 280.622l4.49.349' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M467.463 280.753l4.49.282' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M467.463 280.971l4.556.065' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M467.463 281.124l4.556-.066' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M467.463 281.276l4.621-.2' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M467.463 281.406l4.708-.282' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M467.528 281.56l4.622-.415' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M467.9 283.3l4.055-1.5' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M467.81 283.15l4.121-1.438' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M467.81 283.02l4.209-1.374' fill='none' stroke='%2300359c' stroke-width='.232'/%3e%3cpath d='M467.745 282.8l4.274-1.22' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M467.745 282.65l4.34-1.156' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M467.745 282.5l4.426-1.07' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M467.68 282.28l4.491-.851' fill='none' stroke='%2300167c' stroke-width='.232'/%3e%3cpath d='M467.68 282.061l4.556-.785' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M467.68 281.93l4.556-.654' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M467.616 281.777l4.708-.565' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M454.84 310.508a5.157 5.157 0 01-1.723-2.154 17.677 17.677 0 01-.936-3.471c-.2-1.066-.2-2.244-.5-3.334-.132-1.068-1.744-4.621-1.81-6.016-.131-4.622-1.657-7.76-1.286-12.753.282-3.9 1.155-9.2.72-13.276a30.771 30.771 0 01.065-3.467l22.976 15.217' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M449.172 264.883c-.13-.85.065-2.03.72-2.157a2.362 2.362 0 01.784-.068c.349 0 .415.13.633.436.283.785-.633 1.287-1.286 1.5-.2.066-.633.13-.72.349-.13.349-.066.2-.13.349.13-.065.13-.2.283-.284.5-.282 1-.348 1.722-.72.567-.194.633-1.372.283-1.657a2.292 2.292 0 00-2.027 0 3.214 3.214 0 00-.567 2.682c0-.195.349-.13.283-.414' fill='%23fc0'/%3e%3cpath d='M449.172 264.883c-.13-.85.065-2.03.72-2.157a2.152 2.152 0 01.784-.068c.349 0 .415.13.633.436.283.785-.633 1.287-1.286 1.5-.2.066-.633.13-.72.349-.13.349-.066.2-.13.349.13-.065.13-.2.283-.284.5-.282 1-.348 1.722-.72.567-.194.633-1.372.283-1.657a2.292 2.292 0 00-2.027 0 3.214 3.214 0 00-.567 2.682c0-.195.349-.13.283-.414z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M448.8 265.318c-.85 0-2.028.349-2.094.938a3.7 3.7 0 000 .85c.066.349.2.5.5.567.85.2 1.22-.784 1.374-1.5 0-.13 0-.567.195-.72.35-.13.284-.066.35-.13a.786.786 0 00-.2.283c-.195.5-.195 1.068-.5 1.81-.13.567-1.22.784-1.591.436a2 2 0 01-.283-1.94 3.394 3.394 0 012.594-.939c-.13.066-.13.414-.35.35' fill='%23fc0'/%3e%3cpath d='M448.8 265.318c-.85 0-2.028.349-2.094.938a3.7 3.7 0 000 .85c.066.349.2.5.5.567.85.2 1.22-.784 1.374-1.5 0-.13 0-.567.195-.72.35-.13.284-.066.35-.13a.786.786 0 00-.2.283c-.195.5-.195 1.068-.5 1.81-.13.567-1.22.784-1.591.436a2 2 0 01-.283-1.94 3.394 3.394 0 012.594-.939c-.13.066-.13.414-.35.35' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M448.584 264.948a.465.465 0 00-.066.632.384.384 0 00.567.13.592.592 0 00.35-.85c-.2-.282-.5-.065-.851.067' fill='%23fc0'/%3e%3cpath d='M448.584 264.948a.465.465 0 00-.066.632.384.384 0 00.567.13.592.592 0 00.35-.85c-.2-.282-.5-.065-.851.067z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M443.723 261.833a14.4 14.4 0 004.424 1 5.372 5.372 0 00.5 2.226 6.527 6.527 0 00-2.594.065 9.683 9.683 0 00-2.311-3.334' fill='%23fc0'/%3e%3cpath d='M443.723 261.833a14.4 14.4 0 004.424 1 5.372 5.372 0 00.5 2.226 6.538 6.538 0 00-2.594.065 9.683 9.683 0 00-2.311-3.334z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M445.685 263.05a5.737 5.737 0 001.809.418 1.722 1.722 0 00.2.848 2.9 2.9 0 00-1 .065 3.354 3.354 0 00-1-1.354z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M448.8 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068a5.161 5.161 0 01.719 2.593 2.354 2.354 0 01-2.18.066c-.348-.2-.066-.784 0-1.286a5.307 5.307 0 01.5-1.374' fill='%23fc0'/%3e%3cpath d='M448.8 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068a5.161 5.161 0 01.719 2.593 2.354 2.354 0 01-2.18.066c-.348-.2-.066-.784 0-1.286a5.307 5.307 0 01.5-1.374z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M449.237 266.19a4.369 4.369 0 00.067.567c0-.2.194.2.282.284a5.6 5.6 0 01.567 2.31m-.7-2.092a6.857 6.857 0 01.348 2.245l.13-.065m-.478-1.308c.13.632.065 1 .13 1.373l-.282.13' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M471.452 314.213c1.81 1.658 5.21 2.528 5.8 2.97a10.871 10.871 0 006.147 2.31c2.247.195 3.249-.419 5.582-.72 2.681-.285-.35.128 2.246-.42a25.884 25.884 0 013.117-.93c1.286-.352 2.594-.637 3.4-1.725a2.8 2.8 0 00.567-1.44h1.743c.2.5-.282 1.44-.5 1.808-.066.135-.283.436-.414.659a2.166 2.166 0 01-.633.78c-.131.068-.72.57-.871.632a2.267 2.267 0 01-1.07.636 25.757 25.757 0 00-4.054 1.155c-1.591.413-.72.346-1.875.63-.632.13-1.787.57-2.376.631-1.067.195-1.22.352-2.31.57a27.572 27.572 0 01-8.328.285 14.051 14.051 0 01-4.927-1.29c-1.744-1.222-5.515-1.719-7.238-2.9a16.251 16.251 0 01-1.5-.854c-1.57-1.373-2.965-1.72-4.622-2.813h12.252' fill='%23004bb3'/%3e%3cpath d='M484.793 314.213c1.22.636 1.81 1.658 5.21 2.746 1.286 0 2.747.57 3.99.5-1.5.352-1.5.57-2.747.854-2.594.563.414.129-2.245.413-2.311.285-3.336.938-5.581.72a10.547 10.547 0 01-6.147-2.31c-.567-.413-3.99-1.29-5.8-2.97h13.342' fill='white'/%3e%3cpath d='M484.793 314.213h13.56a2.941 2.941 0 01-.567 1.44c-.785 1.072-2.093 1.374-3.4 1.724-1.44.28-2.9-.419-4.34-.419-3.553-1.064-3.988-2.242-5.209-2.745' fill='%23004bb3'/%3e%3cpath d='M471.67 314.213s-2.377.135-2.53.135c-.13 0-9.7-.135-9.7-.135' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M471.67 314.28s-2.377.129-2.53.2c-.282.068-9.634-.127-9.634-.127' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M471.736 314.37s-2.312.195-2.66.279c-.35 0-9.5-.279-9.5-.279' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M471.736 314.37s-2.224.279-2.748.346c-.5.133-9.352-.285-9.352-.285' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M471.736 314.43s-2.16.286-2.748.42c-.633.128-9.265-.42-9.265-.42' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M471.736 314.43s-2.094.42-2.813.57c-.72.129-9.134-.5-9.134-.5' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M471.736 314.43s-2.029.5-2.9.721c-.851.195-8.981-.564-8.981-.564' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M471.8 314.5s-2.027.569-3.03.786c-.937.128-8.85-.72-8.85-.72' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M471.8 314.587s-1.94.63-3.03.848c-1.068.2-8.763-.786-8.763-.786' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M471.8 314.587a28.816 28.816 0 01-3.116 1c-1.221.2-8.634-.848-8.634-.848' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M471.8 314.649a16.8 16.8 0 01-3.116 1c-1.374.285-8.546-.937-8.546-.937' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M459.33 314.213h12.34' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M460.2 314.805s6.956 1.284 8.416 1a14.794 14.794 0 003.248-1.155' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M473.48 319.643s4.425.631 4.555.631c.066 0 2.595-.194 2.682-.194l2.18-.5' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M473.2 319.577s4.556.72 4.926.636c.13-.068 2.464-.2 2.53-.2.13 0 2.026-.413 2.026-.413' fill='none' stroke='%23001178' stroke-width='.232'/%3e%3cpath d='M472.978 319.447a41.727 41.727 0 005.144.632c.2 0 2.312-.129 2.53-.129.13 0 1.809-.434 1.809-.434' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M472.672 319.292a45.361 45.361 0 005.429.72c.348 0 2.245-.128 2.463-.128.2-.068 1.656-.352 1.656-.352' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M472.454 319.23a46.678 46.678 0 005.647.721c.414-.068 2.092-.134 2.463-.2.283 0 1.438-.194 1.438-.194' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M472.171 319.074s4.992 1 6.016.787c.5-.067 1.94-.128 2.312-.194a11.961 11.961 0 001.351-.2' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M471.953 319.013s5.08 1 6.234.781c.634-.061 1.876-.195 2.224-.195.414-.068 1.221-.128 1.221-.128' fill='none' stroke='%230039a0' stroke-width='.232'/%3e%3cpath d='M471.67 318.923s5.21 1.066 6.517.787a14.413 14.413 0 012.224-.194 7.546 7.546 0 011-.069' fill='none' stroke='%230045ab' stroke-width='.232'/%3e%3cpath d='M473.7 319.794l4.338.57 2.682-.134 2.31-.564' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M471.452 318.8s5.362 1.155 6.8.848a17.631 17.631 0 012.966-.284m11.4.09s2.812-1 4.207-1.508a4.7 4.7 0 002.9-3.616m-7.39 4.252s1.655-.636 3.116-1.155c3.685-1.44 3.248-3.185 3.248-3.185' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M492.118 318.706s2.158-.787 3.335-1.223a16.064 16.064 0 001.723-.78 5.436 5.436 0 001.286-1.222 2.928 2.928 0 00.282-1.223' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M491.833 318.923s2.748-1 3.62-1.372c.35-.129 1.374-.57 1.656-.72a13.886 13.886 0 001.374-1.156 4.488 4.488 0 00.415-1.44' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M491.616 319.074s3.27-1.155 3.837-1.373c.284-.128 1.44-.63 1.591-.72a8.026 8.026 0 001.5-1.217 11.121 11.121 0 00.414-1.506' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M491.333 319.292s3.837-1.373 4.12-1.5c.066-.069 1.505-.57 1.591-.632a15.048 15.048 0 001.5-1.222 12.191 12.191 0 00.566-1.59' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M492.336 319.447s3.4-1.221 4.491-1.656a4.684 4.684 0 002.027-1.507 5.616 5.616 0 00.785-1.936' fill='none' stroke='%23003ca2' stroke-width='.232'/%3e%3cpath d='M491.987 319.447s4.055-1.438 4.927-1.807a5.422 5.422 0 001.874-1.44 6.909 6.909 0 00.72-1.875' fill='none' stroke='%23002d93' stroke-width='.232'/%3e%3cpath d='M491.681 319.516s4.71-1.814 5.277-1.943a11.839 11.839 0 001.809-1.373 9.3 9.3 0 00.633-1.875' fill='none' stroke='%23001e85' stroke-width='.232'/%3e%3cpath d='M491.4 319.516s5.276-2.033 5.582-2.094a17.531 17.531 0 001.721-1.289c.132-.195.655-1.808.655-1.808' fill='none' stroke='%23000f75' stroke-width='.232'/%3e%3cpath d='M491.115 319.516l5.93-2.25 1.591-1.222.567-1.719' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M498 314.213s-2.53.135-2.594.135c-.131 0-10.137-.135-10.137-.135' fill='none' stroke='%2300066d' stroke-width='.232'/%3e%3cpath d='M498 314.28s-2.464.129-2.682.2c-.283.068-10-.127-10-.127' fill='none' stroke='%23000b73' stroke-width='.232'/%3e%3cpath d='M498.069 314.37s-2.377.195-2.812.279c-.35 0-9.853-.279-9.853-.279' fill='none' stroke='%23001379' stroke-width='.232'/%3e%3cpath d='M498.069 314.37s-2.31.279-2.812.346c-.5.133-9.788-.285-9.788-.285' fill='none' stroke='%2300187e' stroke-width='.232'/%3e%3cpath d='M498.069 314.43s-2.245.286-2.9.42c-.632.128-9.634-.42-9.634-.42' fill='none' stroke='%23002086' stroke-width='.232'/%3e%3cpath d='M498.069 314.43s-2.158.42-2.9.57c-.784.129-9.57-.5-9.57-.5' fill='none' stroke='%2300258b' stroke-width='.232'/%3e%3cpath d='M498.069 314.43s-2.092.5-2.964.721c-.85.195-9.418-.564-9.418-.564' fill='none' stroke='%23002b91' stroke-width='.232'/%3e%3cpath d='M498.157 314.5s-2.093.569-3.118.786c-1 .128-9.265-.72-9.265-.72' fill='none' stroke='%23039' stroke-width='.232'/%3e%3cpath d='M498.157 314.587a32.112 32.112 0 01-3.184.848c-1.068.2-9.134-.786-9.134-.786' fill='none' stroke='%2300389e' stroke-width='.232'/%3e%3cpath d='M498.222 314.587s-2.027.72-3.249 1c-1.286.2-8.98-.848-8.98-.848' fill='none' stroke='%23003ea6' stroke-width='.232'/%3e%3cpath d='M498.222 314.649a18.954 18.954 0 01-3.336 1c-1.373.285-8.85-.937-8.85-.937' fill='none' stroke='%230046ad' stroke-width='.232'/%3e%3cpath d='M485.163 314.213H498' fill='none' stroke='%23006' stroke-width='.232'/%3e%3cpath d='M486.036 314.805s7.325 1.284 8.85 1a18.246 18.246 0 003.336-1.155' fill='none' stroke='%23004bb3' stroke-width='.232'/%3e%3cpath d='M500.1 314.213c.2.5-.282 1.44-.5 1.814-.066.129-.284.436-.415.653a2.107 2.107 0 01-.632.781c-.131.068-.72.57-.873.636a2.292 2.292 0 01-1.067.631 26.258 26.258 0 00-4.055 1.156c-1.591.413-.72.346-1.875.63-.633.134-1.788.569-2.377.63-1.068.2-1.22.352-2.31.57a27.57 27.57 0 01-8.328.285 13.908 13.908 0 01-4.926-1.29c-1.744-1.216-5.516-1.718-7.238-2.9a14.677 14.677 0 01-1.5-.854c-1.57-1.373-2.966-1.719-4.623-2.807' fill='none' stroke='black' stroke-width='.232'/%3e%3cpath d='M550.673 314.213l-49.028-81.964-48.963 81.964H550.7' fill='%23fc0'/%3e%3cpath d='M550.673 314.213l-49.028-81.964-48.963 81.964h97.991z' fill='none' stroke='black' stroke-width='.58'/%3e%3cpath d='M545.964 311.534l-44.319-73.99-44.166 73.99h88.507' fill='white'/%3e%3cpath d='M545.964 311.534l-44.319-73.99-44.166 73.99h88.485z' fill='none' stroke='white' stroke-width='.173'/%3e%3cpath d='M493.95 250.516a10.875 10.875 0 017.608-2.68h.195c2.813 0 5.712.72 7.609 2.68' fill='none' stroke='%2300a8ff' stroke-width='.232'/%3e%3cpath d='M493.95 250.582c2.026-1.942 4.62-2.595 7.608-2.679h.195c2.9 0 5.865.714 7.674 2.68' fill='none' stroke='%23009eff' stroke-width='.232'/%3e%3cpath d='M493.862 250.65a10.694 10.694 0 017.7-2.685h.195c2.965 0 5.93.72 7.761 2.746' fill='none' stroke='%230096ff' stroke-width='.232'/%3e%3cpath d='M493.8 250.8c2.028-2.027 4.775-2.746 7.762-2.746h.282c2.965 0 5.93.72 7.827 2.813' fill='none' stroke='%23008bff' stroke-width='.232'/%3e%3cpath d='M493.731 250.867c2.027-2.032 4.84-2.747 7.892-2.813h.2c3.03.066 6.016.781 7.914 2.964' fill='none' stroke='%230082ff' stroke-width='.232'/%3e%3cpath d='M493.644 250.934c2.027-2.1 4.84-2.814 7.979-2.814h.2c3.117.062 6.082.849 7.978 3.031' fill='none' stroke='%230079ff' stroke-width='.232'/%3e%3cpath d='M493.644 251.084c1.961-2.093 4.84-2.9 7.979-2.9h.2c3.247.068 6.148.854 8.11 3.12' fill='none' stroke='%23006fff' stroke-width='.232'/%3e%3cpath d='M493.077 251.955c2.311-2.461 5.21-3.181 8.633-3.181h.195c3.772.061 6.956 1.283 8.852 3.9' fill='none' stroke='%231609ff' stroke-width='.232'/%3e%3cpath d='M493.143 251.826c2.245-2.31 5.144-3.03 8.545-3.12h.2c3.684.068 6.8 1.29 8.7 3.84' fill='none' stroke='%231316ff' stroke-width='.232'/%3e%3cpath d='M493.207 251.737c2.246-2.377 5.059-3.12 8.393-3.12h.2c3.618.067 6.8 1.223 8.7 3.773' fill='none' stroke='%231120ff' stroke-width='.232'/%3e%3cpath d='M493.207 251.67c2.246-2.31 5.059-3.03 8.393-3.114h.2c3.553.061 6.67 1.155 8.633 3.683' fill='none' stroke='%230f2dff' stroke-width='.232'/%3e%3cpath d='M493.36 251.52c2.093-2.244 4.927-2.964 8.263-2.964h.13c3.554 0 6.671 1 8.633 3.55' fill='none' stroke='%230938ff' stroke-width='.232'/%3e%3cpath d='M493.36 251.452c2.093-2.243 4.993-2.962 8.2-2.962h.195c3.466 0 6.584.937 8.48 3.4' fill='none' stroke='%230645ff' stroke-width='.232'/%3e%3cpath d='M493.426 251.39c2.027-2.248 4.927-2.968 8.11-2.968h.2c3.4 0 6.43.854 8.415 3.338' fill='none' stroke='%23054fff' stroke-width='.232'/%3e%3cpath d='M493.513 251.235c1.94-2.16 4.84-2.9 8.045-2.9h.13c3.4 0 6.453.78 8.393 3.247' fill='none' stroke='%23025cff' stroke-width='.232'/%3e%3cpath d='M496.762 245.655a7.9 7.9 0 014.838-1.284 8.348 8.348 0 014.84 1.217' fill='none' stroke='%23ff0500' stroke-width='.232'/%3e%3cpath d='M496.762 245.721a7.92 7.92 0 014.838-1.289 8.366 8.366 0 014.84 1.222' fill='none' stroke='%23ff0b00' stroke-width='.232'/%3e%3cpath d='M496.7 245.788a8.278 8.278 0 014.928-1.29 9 9 0 014.992 1.223' fill='none' stroke='%23f10' stroke-width='.232'/%3e%3cpath d='M496.7 245.938a8.208 8.208 0 014.928-1.372 9.394 9.394 0 014.992 1.222' fill='none' stroke='%23ff1800' stroke-width='.232'/%3e%3cpath d='M496.63 246.005a8.448 8.448 0 014.993-1.373 9.117 9.117 0 015.058 1.285' fill='none' stroke='%23ff1e00' stroke-width='.232'/%3e%3cpath d='M496.544 246.067a8.821 8.821 0 015.056-1.374 9.122 9.122 0 015.058 1.29' fill='none' stroke='%23ff2500' stroke-width='.232'/%3e%3cpath d='M496.544 246.224a7.963 7.963 0 015.056-1.44 9.471 9.471 0 015.146 1.283' fill='none' stroke='%23ff2d00' stroke-width='.232'/%3e%3cpath d='M496.478 246.285a8.476 8.476 0 015.145-1.435 8.8 8.8 0 015.21 1.374' fill='none' stroke='%23f30' stroke-width='.232'/%3e%3cpath d='M496.478 246.374a8.363 8.363 0 015.145-1.44 9.184 9.184 0 015.276 1.373' fill='none' stroke='%23ff3900' stroke-width='.232'/%3e%3cpath d='M496.412 246.44a8.662 8.662 0 015.212-1.44 9.522 9.522 0 015.275 1.374' fill='none' stroke='%23ff3e00' stroke-width='.232'/%3e%3cpath d='M496.324 246.525a8.761 8.761 0 015.276-1.434 10.243 10.243 0 015.364 1.372' fill='none' stroke='%23ff4500' stroke-width='.232'/%3e%3cpath d='M495.235 248.467a11.8 11.8 0 0112.97 0' fill='none' stroke='%23fff500' stroke-width='.232'/%3e%3cpath d='M495.322 248.339a10.765 10.765 0 016.366-1.876 10.516 10.516 0 016.453 1.937' fill='none' stroke='%23ffeb00' stroke-width='.232'/%3e%3cpath d='M495.388 248.249a11.631 11.631 0 0112.665 0' fill='none' stroke='%23ffe000' stroke-width='.232'/%3e%3cpath d='M495.453 248.12a11.74 11.74 0 0112.535 0' fill='none' stroke='%23ffd600' stroke-width='.232'/%3e%3cpath d='M495.453 248.054a11.655 11.655 0 0112.47 0' fill='none' stroke='%23ffcf00' stroke-width='.232'/%3e%3cpath d='M495.54 247.9a10.689 10.689 0 016.17-1.814 9.995 9.995 0 016.147 1.876' fill='none' stroke='%23ffc500' stroke-width='.232'/%3e%3cpath d='M495.605 247.837a10.265 10.265 0 016.083-1.81 10.163 10.163 0 016.082 1.809' fill='none' stroke='%23ffb900' stroke-width='.232'/%3e%3cpath d='M495.672 247.68a11.381 11.381 0 0112.032 0' fill='none' stroke='%23ffaf00' stroke-width='.232'/%3e%3cpath d='M495.76 247.619a9.8 9.8 0 015.95-1.725 10.215 10.215 0 015.93 1.725' fill='none' stroke='%23ffa600' stroke-width='.232'/%3e%3cpath d='M495.824 247.462a9.78 9.78 0 015.864-1.651 10.34 10.34 0 015.864 1.65' fill='none' stroke='%23ff9c00' stroke-width='.232'/%3e%3cpath d='M495.824 247.4a10.157 10.157 0 015.864-1.657 10.339 10.339 0 015.777 1.591' fill='none' stroke='%23ff9100' stroke-width='.232'/%3e%3cpath d='M495.954 247.245a9.51 9.51 0 015.734-1.657 9.663 9.663 0 015.712 1.657' fill='none' stroke='%23ff8600' stroke-width='.232'/%3e%3cpath d='M495.954 247.183a9.7 9.7 0 015.734-1.657 10.325 10.325 0 015.712 1.59' fill='none' stroke='%23ff7c00' stroke-width='.232'/%3e%3cpath d='M496.042 247.027a10.7 10.7 0 0111.227 0' fill='none' stroke='%23ff7500' stroke-width='.232'/%3e%3cpath d='M496.107 246.966a9.189 9.189 0 015.582-1.6 9.517 9.517 0 015.492 1.53' fill='none' stroke='%23ff6b00' stroke-width='.232'/%3e%3cpath d='M496.172 246.81a9.365 9.365 0 015.516-1.5 9.5 9.5 0 015.493 1.5' fill='none' stroke='%23ff6000' stroke-width='.232'/%3e%3cpath d='M496.26 246.748a8.526 8.526 0 015.428-1.507 10.107 10.107 0 015.428 1.44' fill='none' stroke='%23ff5600' stroke-width='.232'/%3e%3cpath d='M495.018 248.617a11.774 11.774 0 016.67-1.936 10.51 10.51 0 016.583 2.026' fill='none' stroke='%23ebff00' stroke-width='.232'/%3e%3cpath d='M494.952 248.774a11.112 11.112 0 016.736-2.026 11.336 11.336 0 016.736 2.087' fill='none' stroke='%23d6ff00' stroke-width='.232'/%3e%3cpath d='M494.886 248.9a10.977 10.977 0 016.8-2.093 11.207 11.207 0 016.736 2.093' fill='none' stroke='%23c2ff00' stroke-width='.232'/%3e%3cpath d='M494.821 249.059a10.813 10.813 0 016.89-2.16 11.145 11.145 0 016.8 2.16' fill='none' stroke='%23adff00' stroke-width='.232'/%3e%3cpath d='M494.734 249.12a11.094 11.094 0 016.889-2.154 11.278 11.278 0 016.953 2.153' fill='none' stroke='%239f0' stroke-width='.232'/%3e%3cpath d='M494.668 249.276a10.474 10.474 0 016.956-2.249 10.991 10.991 0 017.019 2.249' fill='none' stroke='%2385ff00' stroke-width='.232'/%3e%3cpath d='M494.668 249.427a10.111 10.111 0 016.956-2.311 11.384 11.384 0 017.1 2.221' fill='none' stroke='%236fff00' stroke-width='.232'/%3e%3cpath d='M494.516 249.555a10.2 10.2 0 017.107-2.439 11.2 11.2 0 017.106 2.377' fill='none' stroke='%235cff00' stroke-width='.232'/%3e%3cpath d='M494.451 249.644a10.3 10.3 0 017.172-2.377 11.374 11.374 0 017.172 2.31' fill='none' stroke='%2346ff00' stroke-width='.232'/%3e%3cpath d='M494.08 250.3a10.908 10.908 0 017.608-2.528c2.747 0 5.712.72 7.543 2.528' fill='none' stroke='%2305b9e2' stroke-width='.232'/%3e%3cpath d='M494.167 250.3a10.551 10.551 0 017.543-2.68 11.3 11.3 0 017.542 2.529' fill='none' stroke='%2309c5c6' stroke-width='.232'/%3e%3cpath d='M494.167 250.147a10.92 10.92 0 017.543-2.528c2.748 0 5.646.72 7.456 2.438' fill='none' stroke='%2311ccab' stroke-width='.232'/%3e%3cpath d='M494.233 250.058a10.482 10.482 0 017.455-2.529 11.166 11.166 0 017.39 2.467' fill='none' stroke='%2316d38f' stroke-width='.232'/%3e%3cpath d='M494.233 250.058a10.289 10.289 0 017.39-2.6c2.747 0 5.646.787 7.39 2.467' fill='none' stroke='%231cde6f' stroke-width='.232'/%3e%3cpath d='M494.3 250a10.06 10.06 0 017.326-2.533 11.471 11.471 0 017.389 2.377' fill='none' stroke='%2320e653' stroke-width='.232'/%3e%3cpath d='M494.386 249.93a10 10 0 017.238-2.53 11.281 11.281 0 017.323 2.373' fill='none' stroke='%2328ed38' stroke-width='.232'/%3e%3cpath d='M494.386 249.862a10.094 10.094 0 017.238-2.528c2.593 0 5.58.786 7.323 2.4' fill='none' stroke='%232df81c' stroke-width='.232'/%3e%3cpath d='M506.419 245.5a8.148 8.148 0 00-4.774-1.223 7.724 7.724 0 00-4.774 1.289' fill='none' stroke='red' stroke-width='.232'/%3e%3cpath d='M510.844 252.893c-1.874-2.746-5.21-4.058-9.07-4.058-3.552 0-6.364.72-8.762 3.186' fill='none' stroke='%231800ff' stroke-width='.232'/%3e%3cpath d='M509.319 250.3c-1.876-1.808-4.775-2.528-7.609-2.528a11.224 11.224 0 00-7.695 2.594' fill='none' stroke='%2300b3ff' stroke-width='.232'/%3e%3cpath d='M510.038 251.452c-2.028-2.377-5.058-3.18-8.415-3.18-3.118 0-6.083.72-8.11 2.9' fill='none' stroke='%2306f' stroke-width='.232'/%3e%3cpath d='M508.316 248.617a10.8 10.8 0 00-6.585-2.026 11.285 11.285 0 00-6.582 1.942' fill='none' stroke='%23ff0' stroke-width='.232'/%3e%3cpath d='M507.007 246.525a10.055 10.055 0 00-5.363-1.434 8.291 8.291 0 00-5.276 1.59' fill='none' stroke='%23ff4b00' stroke-width='.232'/%3e%3cpath d='M508.881 249.644a11.65 11.65 0 00-7.237-2.377 9.981 9.981 0 00-7.172 2.528' fill='none' stroke='%233f0' stroke-width='.232'/%3e%3cpath d='M470.514 289.539l-13.058 21.974h88.507l-13.188-21.974h-62.239' fill='%230088e8'/%3e%3cpath d='M470.514 289.539l-13.058 21.974h88.507l-13.188-21.974h-62.261z' fill='none' stroke='%2300ccb3' stroke-width='.347'/%3e%3cpath d='M504.02 302.378a7.146 7.146 0 003.9.065c1.875-.414 3.684-1.5 5.93-1.285 1.59.13 3.77 1.5 6.452 1.5 2.592 0 3.486-.937 5.8-1.374a8.622 8.622 0 014.124.2c1.96.349 2.963 1.5 6.3 1.22' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M469.926 305.58a7.949 7.949 0 016.082-1.155c2.594.569 3.684 1.222 6.517 1.222 2.029-.067 3.839-1.437 5.952-1.437 3.467 0 3.62.718 6.737 1.286a8.59 8.59 0 005.624-1.071c1-.5 3.466-.412 4.709-.28a10.208 10.208 0 013.553 1.155 7.147 7.147 0 003.9.127c1.875-.563 3.619-1.808 5.93-1.5 1.591.13 3.77 1.721 6.388 1.721 2.68 0 3.555-1.065 5.776-1.59a8.937 8.937 0 014.208.2c1.958.412 2.963 1.724 6.3 1.44' fill='none' stroke='white' stroke-width='.637'/%3e%3cpath d='M464.912 303.12a8.622 8.622 0 016.082-1c2.594.5 3.77 1.068 6.517 1.068 2.094-.065 3.838-1.286 5.93-1.286 3.554 0 3.62.632 6.737 1.155a8.61 8.61 0 002.594 0 12.38 12.38 0 003.117-.937c.85-.414 3.4-.349 4.621-.283a10.192 10.192 0 013.554 1.067 10.576 10.576 0 003.9.066c1.874-.5 3.684-1.591 5.93-1.352 1.59.13 3.835 1.592 6.452 1.5 2.593 0 3.554-.938 5.775-1.374a8.618 8.618 0 014.123.2c1.937.414 3.031 1.5 6.363 1.221' fill='none' stroke='white' stroke-width='.463'/%3e%3cpath d='M460.355 310.29a7.381 7.381 0 016.083-1.222c2.594.57 3.77 1.378 6.517 1.29 2.094 0 3.9-1.591 5.93-1.591 3.554 0 3.619.781 6.737 1.5a8.783 8.783 0 002.66 0 14.505 14.505 0 003.03-1.216c.937-.5 3.4-.419 4.62-.284a7.61 7.61 0 013.554 1.284 7.447 7.447 0 003.99.066c1.874-.63 3.619-1.942 5.864-1.657 1.59.128 3.836 1.875 6.453 1.875 2.594 0 3.553-1.155 5.8-1.724 1.592-.413 2.378-.129 4.12.2 2.026.5 3.03 1.937 6.367 1.653' fill='none' stroke='white' stroke-width='.837'/%3e%3cpath d='M461.51 306.15a9.247 9.247 0 016.148-1c2.595.5 3.772 1.071 6.519 1.071a8.369 8.369 0 002.66-.569' fill='none' stroke='white' stroke-width='.463'/%3e%3cpath d='M474.94 301.876a9.349 9.349 0 013.4-.718c3.554 0 1.286 0 4.426.567.785.13 3.03.13 3.684-.415m30.934 10.007a13.356 13.356 0 003.117-1c.937-.436 3.335-.346 4.623-.195a12.449 12.449 0 013.55 1 8.123 8.123 0 003.907.063c1.875-.5 3.682-1.591 5.926-1.374 1.591.195 3.84 1.59 6.451 1.59' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M522.814 301.506c2.59 0 3.55-.937 5.8-1.373a8.6 8.6 0 014.119.2c2.026.348 3.03 1.5 6.367 1.22' fill='none' stroke='white' stroke-width='.463'/%3e%3cpath d='M460.487 310.575a8.745 8.745 0 016.082-1c2.594.5 3.77 1.072 6.583 1.072 2.027-.067 3.837-1.29 5.952-1.29 3.465 0 3.618.631 6.67 1.156a8.419 8.419 0 002.594 0 10.1 10.1 0 003.118-.938 12.478 12.478 0 014.621-.194 8.869 8.869 0 013.554 1' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M466.067 307.305a9.143 9.143 0 016.083-1c2.593.5 3.77 1.155 6.517 1.072 2.094-.067 3.838-1.29 5.93-1.223 3.553 0 3.684.57 6.736 1.156a8.81 8.81 0 002.594 0 12.409 12.409 0 003.117-1 14.1 14.1 0 014.623-.195 12.691 12.691 0 013.552 1 8.11 8.11 0 003.9.068c1.874-.419 3.684-1.507 5.93-1.38 1.722.2 3.989 1.6 6.451 1.6 2.595 0 3.554-.938 5.8-1.373a8.166 8.166 0 014.208.195c1.875.346 2.963 1.5 6.234 1.217' fill='none' stroke='black' stroke-width='.837'/%3e%3cpath d='M492.706 252.48a19.3 19.3 0 018.917-2.16 20.064 20.064 0 019.2 2.594l9.418 15.653a18.639 18.639 0 11-37.278.065l9.7-16.175z' fill='none' stroke='%23fff3f3' stroke-width='.232'/%3e%3cpath d='M501.624 250.516a20.028 20.028 0 019.133 2.594l9.2 15.436a18.345 18.345 0 11-36.69.064l9.57-15.957a19.825 19.825 0 018.763-2.16z' fill='none' stroke='%23fff3ef' stroke-width='.232'/%3e%3cpath d='M501.624 250.732a19.342 19.342 0 018.98 2.595s9.134 15.152 9.134 15.219a18.138 18.138 0 11-36.275.065c0-.065 9.352-15.652 9.418-15.74a19.529 19.529 0 018.7-2.16z' fill='none' stroke='%23ffefef' stroke-width='.232'/%3e%3cpath d='M501.624 250.934a19.714 19.714 0 018.849 2.528c.065.061 8.982 14.93 8.982 15.084a17.833 17.833 0 11-35.665.065c0-.132 9.135-15.456 9.2-15.523a19.455 19.455 0 018.611-2.154z' fill='none' stroke='%23ffefed' stroke-width='.232'/%3e%3cpath d='M501.624 251.235a19.494 19.494 0 018.7 2.466c.132.129 8.917 14.713 8.917 14.931a17.615 17.615 0 11-35.229 0c0-.131 8.982-15.215 9.135-15.3a18.785 18.785 0 018.48-2.093m0 .217a19.533 19.533 0 018.632 2.468c.131.06 8.763 14.494 8.763 14.712a17.4 17.4 0 11-34.792 0c0-.2 8.917-14.93 9.07-15.087a18.8 18.8 0 018.327-2.093' fill='none' stroke='%23ffedeb' stroke-width='.232'/%3e%3cpath d='M501.624 251.737a18.533 18.533 0 018.479 2.377c.2.129 8.633 14.213 8.633 14.5a17.113 17.113 0 11-34.226 0c0-.2 8.611-14.714 8.85-14.87a18.041 18.041 0 018.263-2.027z' fill='none' stroke='%23ffebe8' stroke-width='.232'/%3e%3cpath d='M501.624 251.955a18.484 18.484 0 018.414 2.377c.195.128 8.48 13.908 8.48 14.279a16.9 16.9 0 11-33.79 0c0-.284 8.48-14.5 8.763-14.652a17.757 17.757 0 018.11-2.027z' fill='none' stroke='%23ffebe6' stroke-width='.232'/%3e%3cpath d='M501.624 252.172a18.23 18.23 0 018.26 2.378c.284.128 8.329 13.69 8.329 14.06a16.612 16.612 0 11-33.224 0c0-.348 8.328-14.277 8.612-14.428a17.425 17.425 0 017.978-2.032z' fill='none' stroke='%23ffe8e6' stroke-width='.232'/%3e%3cpath d='M501.624 252.48a17.263 17.263 0 018.109 2.31c.282.128 8.26 13.406 8.26 13.842a16.393 16.393 0 11-32.786 0c0-.348 8.2-13.993 8.48-14.217a17.386 17.386 0 017.891-1.935z' fill='none' stroke='%23ffe8e2' stroke-width='.232'/%3e%3cpath d='M501.624 252.675a17.233 17.233 0 018.043 2.31c.283.195 8.044 13.19 8.044 13.626a16.1 16.1 0 11-32.2 0c0-.415 7.978-13.777 8.328-13.994a17.624 17.624 0 017.76-1.942z' fill='none' stroke='%23ffe6e0' stroke-width='.232'/%3e%3cpath d='M501.624 252.981a17.484 17.484 0 017.912 2.222c.349.194 7.978 12.906 7.978 13.408a15.881 15.881 0 11-31.761.087c0-.5 7.825-13.624 8.2-13.841a17.113 17.113 0 017.674-1.876' fill='none' stroke='%23ffe6de' stroke-width='.232'/%3e%3cpath d='M501.624 253.2a16.541 16.541 0 017.76 2.243 153.017 153.017 0 017.825 13.19 15.619 15.619 0 11-31.238.086c0-.567 7.673-13.343 8.109-13.623a16.808 16.808 0 017.543-1.874z' fill='none' stroke='%23ffe2de' stroke-width='.232'/%3e%3cpath d='M501.624 253.417a15.949 15.949 0 017.607 2.243c.5.195 7.761 12.405 7.761 12.972a15.37 15.37 0 01-30.739.156v-.088c0-.566 7.457-13.12 7.979-13.4a15.754 15.754 0 017.39-1.875' fill='none' stroke='%23ffe2dc' stroke-width='.232'/%3e%3cpath d='M501.624 253.7a16.217 16.217 0 017.542 2.155c.5.285 7.608 12.1 7.608 12.755a15.151 15.151 0 11-30.3.066c0-.634 7.39-12.905 7.913-13.19a16.11 16.11 0 017.238-1.808zm0 .219a16.06 16.06 0 017.389 2.092c.5.346 7.543 11.967 7.543 12.62a15 15 0 01-14.933 14.934 14.845 14.845 0 01-14.868-14.865c0-.72 7.172-12.686 7.7-12.97a16.339 16.339 0 017.172-1.808' fill='none' stroke='%23ffe0d9' stroke-width='.232'/%3e%3cpath d='M501.624 254.2a17 17 0 017.323 2.031c.5.347 7.326 11.749 7.326 12.4a14.65 14.65 0 11-29.3.065c0-.718 7.02-12.468 7.543-12.751a15.78 15.78 0 017.107-1.725z' fill='none' stroke='%23ffded6' stroke-width='.232'/%3e%3cpath d='M501.624 254.415a16.1 16.1 0 017.17 2.033c.5.345 7.239 11.443 7.239 12.184a14.577 14.577 0 01-14.433 14.5 14.4 14.4 0 01-14.343-14.432c0-.785 6.8-12.183 7.39-12.557a16.016 16.016 0 016.953-1.725z' fill='none' stroke='%23ffded3' stroke-width='.232'/%3e%3cpath d='M501.624 254.723a15.6 15.6 0 017.019 1.942c.566.346 7.106 11.226 7.106 11.967a14.137 14.137 0 11-28.274.066c0-.785 6.67-11.966 7.325-12.318a15.116 15.116 0 016.8-1.657z' fill='none' stroke='%23ffdcd3' stroke-width='.232'/%3e%3cpath d='M501.624 254.94a14.631 14.631 0 016.887 1.943c.633.346 7.02 10.943 7.02 11.75a13.919 13.919 0 11-27.838.086c0-.85 6.517-11.747 7.237-12.1a14.811 14.811 0 016.67-1.656z' fill='none' stroke='%23ffdcd1' stroke-width='.232'/%3e%3cpath d='M501.624 255.158a14.521 14.521 0 016.8 1.942c.633.413 6.8 10.66 6.8 11.532a13.625 13.625 0 11-27.249.087c0-.937 6.387-11.446 7.02-11.88a14.693 14.693 0 016.583-1.659zm0 .285a14.022 14.022 0 016.67 1.874c.719.413 6.735 10.443 6.735 11.315a13.407 13.407 0 11-26.814.087c0-.937 6.235-11.228 6.955-11.664a13.77 13.77 0 016.453-1.59z' fill='none' stroke='%23ffd9cf' stroke-width='.232'/%3e%3cpath d='M501.624 255.66a13.437 13.437 0 016.517 1.876c.784.413 6.583 10.16 6.583 11.1a13.156 13.156 0 11-26.312.087c0-1 6.082-11.01 6.8-11.446a13.811 13.811 0 016.365-1.59z' fill='none' stroke='%23ffd6cc' stroke-width='.232'/%3e%3cpath d='M501.624 255.945a13.614 13.614 0 016.386 1.808c.785.413 6.517 9.942 6.517 10.88a12.905 12.905 0 11-25.81.065c0-1 5.8-10.727 6.671-11.23a13.659 13.659 0 016.235-1.523' fill='none' stroke='%23ffd6c9' stroke-width='.232'/%3e%3cpath d='M501.624 256.163a13.19 13.19 0 016.3 1.808c.785.5 6.366 9.636 6.366 10.661a12.688 12.688 0 11-25.376.066c0-1.068 5.734-10.51 6.519-11.011a13.557 13.557 0 016.147-1.524z' fill='none' stroke='%23ffd3c9' stroke-width='.232'/%3e%3cpath d='M501.624 256.38a12.556 12.556 0 016.147 1.808c.85.5 6.234 9.42 6.234 10.444a12.4 12.4 0 11-24.809.065c0-1.067 5.495-10.29 6.367-10.787a13 13 0 016.016-1.507z' fill='none' stroke='%23ffd3c6' stroke-width='.232'/%3e%3cpath d='M501.624 256.687a13.483 13.483 0 016.08 1.658c.85.5 6.083 9.2 6.083 10.287a12.187 12.187 0 11-24.373.066c0-1.068 5.363-10.007 6.3-10.57a13.187 13.187 0 015.864-1.44z' fill='none' stroke='%23ffd1c5' stroke-width='.232'/%3e%3cpath d='M501.624 256.9a12.737 12.737 0 015.95 1.657c.937.564 5.93 8.914 5.93 10.136a11.925 11.925 0 11-23.85 0c0-1.156 5.211-9.857 6.17-10.353a13.033 13.033 0 015.776-1.44z' fill='none' stroke='%23ffd1c2' stroke-width='.232'/%3e%3cpath d='M501.624 257.189a13.112 13.112 0 015.8 1.59c1 .565 5.864 8.7 5.864 9.919a11.663 11.663 0 01-23.325.029v-.027c0-1.221 4.992-9.572 6.017-10.136a12.5 12.5 0 015.646-1.373' fill='none' stroke='%23ffcfc2' stroke-width='.232'/%3e%3cpath d='M501.624 257.407a11.2 11.2 0 015.645 1.59c1 .564 5.733 8.48 5.733 9.723a11.413 11.413 0 11-22.825 0c0-1.22 4.841-9.353 5.865-9.917a12.387 12.387 0 015.582-1.373z' fill='none' stroke='%23ffcfbe' stroke-width='.232'/%3e%3cpath d='M501.624 257.686a12.071 12.071 0 015.58 1.507c1 .57 5.58 8.2 5.58 9.483a11.161 11.161 0 01-22.322 0c0-1.287 4.708-9.138 5.71-9.724a12.342 12.342 0 015.428-1.284zm0 .224a11.455 11.455 0 015.427 1.5c1.067.654 5.428 7.98 5.428 9.266a10.911 10.911 0 11-21.821 0c0-1.286 4.556-8.852 5.645-9.483a11.011 11.011 0 015.276-1.283z' fill='none' stroke='%23ffccbc' stroke-width='.232'/%3e%3cpath d='M501.624 258.127a11.472 11.472 0 015.362 1.5c1 .631 5.275 7.7 5.275 9.07a10.66 10.66 0 11-21.32 0c0-1.374 4.338-8.634 5.494-9.265a11.068 11.068 0 015.144-1.29z' fill='none' stroke='%23ffc9b9' stroke-width='.232'/%3e%3cpath d='M501.624 258.345a10.89 10.89 0 015.209 1.5c1.068.632 5.144 7.392 5.144 8.853a10.409 10.409 0 01-20.817.081v-.079c0-1.44 4.207-8.417 5.361-9.07a10.785 10.785 0 015.058-1.283z' fill='none' stroke='%23ffc9b8' stroke-width='.232'/%3e%3cpath d='M501.624 258.624a9.984 9.984 0 015.056 1.44c1.155.636 5.08 7.173 5.08 8.634a10.181 10.181 0 11-20.362 0c0-1.44 4.055-8.11 5.276-8.852a10.492 10.492 0 014.926-1.222z' fill='none' stroke='%23ffc6b8' stroke-width='.232'/%3e%3cpath d='M501.624 258.841a10.655 10.655 0 014.991 1.44c1.155.72 4.927 6.891 4.927 8.417a9.931 9.931 0 01-19.861 0c0-1.5 3.838-7.892 5.08-8.634a10.891 10.891 0 014.84-1.223z' fill='none' stroke='%23ffc6b5' stroke-width='.232'/%3e%3cpath d='M501.624 259.065a9.85 9.85 0 014.838 1.434c1.221.72 4.774 6.673 4.774 8.2a9.668 9.668 0 11-19.336 0c0-1.5 3.77-7.675 4.992-8.417a10.125 10.125 0 014.708-1.216zm0 .3a8.933 8.933 0 014.708 1.374c1.307.719 4.708 6.366 4.708 7.979a9.49 9.49 0 01-9.417 9.418 9.351 9.351 0 01-9.418-9.418c0-1.59 3.553-7.389 4.84-8.2a9.218 9.218 0 014.555-1.155z' fill='none' stroke='%23ffc5b3' stroke-width='.232'/%3e%3cpath d='M501.624 259.583a9.85 9.85 0 014.555 1.29c1.286.781 4.556 6.233 4.556 7.825a9.167 9.167 0 11-18.334 0c0-1.591 3.4-7.171 4.71-7.98a9.408 9.408 0 014.49-1.156z' fill='none' stroke='%23ffc2af' stroke-width='.232'/%3e%3cpath d='M501.624 259.868a9.534 9.534 0 014.49 1.222c1.286.782 4.424 5.93 4.424 7.608a8.916 8.916 0 11-17.832 0c0-1.657 3.183-6.955 4.556-7.764a9.539 9.539 0 014.338-1.065z' fill='none' stroke='%23ffc2ad' stroke-width='.232'/%3e%3cpath d='M501.624 260.086a8.939 8.939 0 014.337 1.223c1.373.786 4.272 5.645 4.272 7.389a8.666 8.666 0 11-17.331.036v-.034c0-1.723 3.03-6.737 4.426-7.54a9.471 9.471 0 014.272-1.072z' fill='none' stroke='%23ffbead' stroke-width='.232'/%3e%3cpath d='M501.624 260.37a8.453 8.453 0 014.271 1.156c1.353.87 4.121 5.428 4.121 7.172a8.448 8.448 0 11-16.9 0c0-1.723 2.9-6.452 4.34-7.323a8.806 8.806 0 014.119-1z' fill='none' stroke='%23ffbeab' stroke-width='.232'/%3e%3cpath d='M501.624 260.589a9 9 0 014.118 1.154c1.44.849 3.99 5.21 3.99 6.955a8.142 8.142 0 11-16.284 0c0-1.81 2.66-6.235 4.12-7.1a9.386 9.386 0 014.055-1' fill='none' stroke='%23ffbca8' stroke-width='.232'/%3e%3cpath d='M501.624 260.806a8.352 8.352 0 013.988 1.155c1.439.848 3.9 4.928 3.9 6.737a7.946 7.946 0 11-15.892.046v-.044c0-1.81 2.529-6.017 4.054-6.888a8.825 8.825 0 013.9-1z' fill='none' stroke='%23ffbca6' stroke-width='.232'/%3e%3cpath d='M501.624 261.113a7.627 7.627 0 013.835 1.065c1.5.849 3.838 4.71 3.838 6.52a7.674 7.674 0 01-15.348.087v-.085c0-1.875 2.311-5.8 3.9-6.67a8.414 8.414 0 013.77-.938z' fill='none' stroke='%23ffb9a6' stroke-width='.232'/%3e%3cpath d='M501.624 261.33a7.887 7.887 0 013.77 1.067c1.5.937 3.619 4.426 3.619 6.3a7.423 7.423 0 11-14.846.008v-.005c0-1.941 2.158-5.493 3.837-6.452a7.347 7.347 0 013.619-.937z' fill='none' stroke='%23ffb9a2' stroke-width='.232'/%3e%3cpath d='M501.624 261.615a7.019 7.019 0 013.618 1c1.5.938 3.553 4.12 3.553 6.084a7.172 7.172 0 11-14.344 0c0-1.941 2.026-5.275 3.618-6.235a7.235 7.235 0 013.554-.848m0 .218a7.085 7.085 0 013.466 1 8.46 8.46 0 013.4 5.867 6.921 6.921 0 11-13.842 0 8.2 8.2 0 013.554-5.928 6.1 6.1 0 013.4-.937z' fill='none' stroke='%23ffb8a0' stroke-width='.232'/%3e%3cpath d='M501.624 262.05a6.215 6.215 0 013.4 1 7.717 7.717 0 013.247 5.648 6.7 6.7 0 11-13.406 0 7.949 7.949 0 013.4-5.8 7.347 7.347 0 013.335-.847z' fill='none' stroke='%23ffb59e' stroke-width='.232'/%3e%3cpath d='M501.624 262.33a5.668 5.668 0 013.247.937 7.08 7.08 0 013.117 5.43 6.42 6.42 0 11-12.839 0 7.185 7.185 0 013.247-5.582 6.488 6.488 0 013.183-.787z' fill='none' stroke='%23ffb59c' stroke-width='.232'/%3e%3cpath d='M501.624 262.553a6.589 6.589 0 013.116.847 6.441 6.441 0 013.03 5.276 6.191 6.191 0 11-12.382.087 6.56 6.56 0 013.183-5.43 5.9 5.9 0 013.03-.78z' fill='none' stroke='%23ffb39c' stroke-width='.232'/%3e%3cpath d='M501.624 274.671a5.838 5.838 0 005.862-5.814v-.05a5.9 5.9 0 10-5.863 5.864' fill='none' stroke='%23ffb399' stroke-width='.232'/%3e%3cpath d='M501.624 274.736a5.93 5.93 0 10-5.931-5.93 5.982 5.982 0 005.931 5.93' fill='none' stroke='white' stroke-width='.173'/%3e%3cpath d='M501.624 274.736a5.93 5.93 0 10-5.931-5.93 5.982 5.982 0 005.931 5.93' fill='white'/%3e%3cpath d='M502.93 262.92l.633-3.118m-1.287 3.03l.35-3.181m-1 3.18v-3.248m-.567 3.248l-.283-3.18m-.37 3.27l-.655-3.12m.065 3.338l-1-3.12m.438 3.337l-1.286-2.963m.762 3.18l-1.656-2.745m1.09 3.1l-1.876-2.593m1.44 3.03l-2.246-2.465m1.722 2.9l-2.377-2.159m2.028 2.682l-2.594-1.94m2.224 2.378l-2.812-1.593m2.506 2.159l-2.964-1.286m2.747 1.874l-3.03-1m2.833 1.57l-3.117-.632m3.03 1.286l-3.183-.35m3.183 1h-3.248m3.248.589l-3.183.348m3.27.305l-3.117.633m3.313-.044l-3.117 1m3.335-.436l-2.964 1.286m3.27-.7l-3.466 2.094m3.75-1.592l-6.955 4.991m7.39-4.49l-7.543 6.584m7.914-6.147l-6.155 6.89m6.649-6.517l-4.621 6.3m5.144-5.865l-4.84 8.482m5.407-8.263l-2.68 6.147m3.269-5.864L497 283m3.314-8.327l-1.155 5.71m1.81-5.645l-.85 8.763m2.092-8.763l.349 3.183m.305-3.248l1.875 8.262m-1.286-8.415l1.591 4.84m-1.025-5.06l3.772 8.11m-3.182-8.394l4.054 6.89m-3.553-7.26l5.8 7.608m-5.3-7.956l5.08 5.864m-4.645-6.3l7.544 6.8m-7.172-7.325l4.12 2.966m-3.75-3.467l2.812 1.592m-2.529-2.18l2.966 1.286m-2.748-1.852l3.03 1m-2.811-1.59l3.117.633m-3.052-1.287l3.183.349m-3.1-1h3.182m-3.27-.566l3.183-.283m-3.248-.305l3.117-.72m-3.336.065l3.118-1m-3.27.415l2.9-1.286m-3.184.719l2.813-1.592m-3.183 1.091l2.594-1.873m-2.943 1.35l2.377-2.16m-2.806 1.718l2.093-2.377m-2.615 1.94l1.874-2.532m-2.377 2.25l1.592-2.813m-2.18 2.528l1.286-2.963m-1.853 2.746l1-3.03m-2.9-4.884v-2.46m-2.747 2.744l-.5-2.377m-2.2 3.248l-1-2.243m-1.438 3.706l-1.5-2.032m-.61 3.907l-1.875-1.658m.218 3.99l-2.18-1.289m1 3.816l-2.377-.785m1.723 3.554l-2.442-.2m2.442 3.03l-2.442.284m3.095 2.528l-2.462.72m27.052 1.9l2.18 1.22m-1-3.836l2.31.785m-1.743-3.531l2.441.282m-2.441-3.117l2.441-.195m-3.008-2.552l2.376-.785m-3.553-1.83l2.18-1.22m-3.837-1.027l1.875-1.742m-3.9-.15l1.373-2.032m-3.837.592l1-2.31m-3.772 1.35l.5-2.378' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M505.111 271.553a4.261 4.261 0 00-1.373-.414 17.848 17.848 0 00-3.62.13 1.842 1.842 0 00-.85.567 3.134 3.134 0 001.744.72 7.3 7.3 0 002.594-.2 5.4 5.4 0 001.5-.784' fill='%23e60000'/%3e%3cpath d='M505.111 271.553a4.261 4.261 0 00-1.373-.414 17.848 17.848 0 00-3.62.13 1.842 1.842 0 00-.85.567 3.134 3.134 0 001.744.72 7.3 7.3 0 002.594-.2 5.4 5.4 0 001.5-.784z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M499.377 270.681A8.94 8.94 0 01500.6 267a10.316 10.316 0 00-.567 1.068s-.632.35-1-.13c-.413-.349-.195-.5.066-1.157.282-.414.2-.849.567-1.154.282-.283.567-.349 1.373-.349a1.932 1.932 0 011.94 1c.567.784.938 1.5 1.222 1.94a5.1 5.1 0 01.632 2.311l.2 1a4.254 4.254 0 00-1.374-.415 17.76 17.76 0 00-3.618.13 1.847 1.847 0 00-.85.568s-.348-.784.131-1.155' fill='%23e60000'/%3e%3cpath d='M499.377 270.681A8.94 8.94 0 01500.6 267a10.316 10.316 0 00-.567 1.068s-.632.35-1-.13c-.413-.349-.195-.5.066-1.157.282-.414.2-.849.567-1.154.282-.283.567-.349 1.373-.349a1.932 1.932 0 011.94 1c.567.784.938 1.5 1.222 1.94a5.1 5.1 0 01.632 2.311l.2 1a4.254 4.254 0 00-1.374-.415 17.76 17.76 0 00-3.618.13 1.847 1.847 0 00-.85.568s-.348-.784.131-1.155z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M499.377 270.681a6.612 6.612 0 012.747-.348c2.528.065 2.594.195 2.748.414' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M501.558 279.968v-8.7s.282-.282.937 0v8.632s.2 6.671-.5 6.585c-.851 0-.415-1.5-.415-6.52' fill='%23fc0'/%3e%3cpath d='M501.558 279.968v-8.7s.282-.282.937 0v8.632s.2 6.671-.5 6.585c-.851 0-.415-1.5-.415-6.52z' fill='none' stroke='black' stroke-width='.173'/%3e%3cpath d='M545.964 311.534l-44.319-73.99-44.166 73.99h88.485z' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M467.245 295.054c.414.065 1.439-.72 1.722-.938.414-.2.632-.85.937-1.221a18.328 18.328 0 011.81-1.155 12.071 12.071 0 004.337-3.837 21.353 21.353 0 016.955-6.3 3.863 3.863 0 013.182.066 3.6 3.6 0 011 .718 13.867 13.867 0 004.708 2.16c1.875.566 2.31 1.808 3.77 3.116a9.808 9.808 0 002.465 1.592c.066.066.283.349.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.9 3.77.217.2.284.634.5.786a12.547 12.547 0 003.032 2.462 35.814 35.814 0 013.335 2.028c-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.659-.066l3.183-5.428' fill='%23090'/%3e%3cpath d='M467.245 295.054c.414.065 1.439-.72 1.722-.938.414-.2.632-.85.937-1.221a18.328 18.328 0 011.81-1.155 12.071 12.071 0 004.337-3.837 21.353 21.353 0 016.955-6.3 3.863 3.863 0 013.182.066 3.6 3.6 0 011 .718 13.867 13.867 0 004.708 2.16c1.875.566 2.31 1.808 3.77 3.116a9.808 9.808 0 002.465 1.592c.066.066.283.349.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.9 3.77.217.2.284.634.5.786a12.547 12.547 0 003.032 2.462 35.814 35.814 0 013.335 2.028c-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.659-.066l3.183-5.428z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M481.96 282.28c.566-.066.282-.2.784.13m-1.788.523c.567-.065.785-.414 1.222.065m-1.744.305a1.224 1.224 0 011.22.2m-1.788.524a2.18 2.18 0 011.287.065m-2.006.436c.567-.195.85.2 1.5.066m-2.245.675c.414 0 .5-.13.85 0 .436.066.349 0 .785.066m-2.42.654a4.451 4.451 0 01.938 0 1.877 1.877 0 00.85 0m-2.224.653a3.278 3.278 0 011.656.132m-2.833 1.4a2.056 2.056 0 011.656.065m-13.406 12.056c2.31-.35 5.08.065 7.39-.283m4.73-12.557c.567-.2.414-.131 1-.066.632.065.85.13 1 .065m-2.943 1.374a2.536 2.536 0 011.875 0m-.35.588a9.674 9.674 0 00-1.94 0m1.418.72a4.22 4.22 0 00-2.093-.131m-.872.633a7.887 7.887 0 012.464.064m-3.184.59a5.872 5.872 0 012.682.065m-3.553.435c.937-.065 1.809-.065 2.747-.065.13 0 .414-.13.567.065m-.262.524a26.7 26.7 0 01-4.208.13m3.4.59a13.183 13.183 0 01-1.788.13c-.065 0-.2-.13-.348-.13a7.386 7.386 0 00-2.093.195m-.349.524a1.176 1.176 0 01.938-.066 16.015 16.015 0 012.528.2 2.132 2.132 0 00.72.13m-4.687.11a9.04 9.04 0 011.875.065 14.934 14.934 0 002.376.348h-.065m-4.775.022a8.858 8.858 0 011.962.283c.85.13 1.81-.065 2.594.13m-5.34.023c.85.349 1.808.065 2.746.2.85.13 1.656.13 2.53.283m-5.865.24a28.553 28.553 0 014.054.2 3.343 3.343 0 001.5.13m-6.059.262a35.292 35.292 0 013.988.35 8.566 8.566 0 001.875.195h-.13m-6.257.458a.764.764 0 01.35-.13c1.067 0 2.092.13 3.182.065a6.85 6.85 0 012.593.13h-.065m-6.562.589c2.094-.2 4.273.065 6.366 0m-6.736.654c2.245.195 4.49 0 6.671.195m-7.02.459c1 .2 1.94-.065 2.9.13a7.525 7.525 0 002.092.13 8.539 8.539 0 011.81-.064m9.09-9.265h.2m-.414.283c.065 0 .2-.13.2 0m-.5.37h.5m-.633.285h.567m-1 .37c.35 0 .633.066 1 .066h-.065m-1.22.435c.348-.13.783 0 1.155-.13h-.066m-1.613.719h1.526m-1.81.371a6.884 6.884 0 011.657.065m-2.027.5a10.346 10.346 0 012 .065m-2.377.523c.415-.065.786.2 1.222.283a1.879 1.879 0 00.85-.065m-2.2.218a7.07 7.07 0 001.96.283m-2.331.218a5.567 5.567 0 011.591.283 2.619 2.619 0 00.72 0m-3.03.524a3.637 3.637 0 012.245.13 3.1 3.1 0 00.784 0h-.065m-3.03.37a3.708 3.708 0 012.376.132h.414m-3.313.523c1.068.2 2.18-.13 3.183.132m-3.466.3c.85.349 1.809 0 2.68.283a1.549 1.549 0 00.939-.065m-4.186.437a2.232 2.232 0 011.155-.131 21.7 21.7 0 002.813.282m-4.491.5c.195 0 .414.13.632.065a38.281 38.281 0 013.836-.065m-4.752.5c1 .349 2.027 0 3.183.282a1.968 1.968 0 001.373 0m-4.927.46c1.5.064 3.03-.066 4.84.13m4.023-9.142c.13 0 .283.13.414.13m-.632.37a.85.85 0 01.567-.065m-.7.5a1.625 1.625 0 01.786.065m-1 .524a5.214 5.214 0 011 .065m-1.309.5c.414-.131.85.065 1.286-.066m-1.35.5a8.508 8.508 0 001.307.065v-.065m-1.526.653a3.466 3.466 0 011.155.066.48.48 0 00.414-.065m-1.634.588c.567-.2 1.067.13 1.656 0m-1.875.72a16.791 16.791 0 001.81 0m-2.028.588c.2-.065.5-.282.785-.13a6.814 6.814 0 001.221.13m-2.159.654c.72-.283 1.44.131 2.159-.2m-2.224.85a2.565 2.565 0 011 0 2.849 2.849 0 001.286 0m-2.506.633a16.937 16.937 0 012.594-.066l-.065.065m-3.052.59c1.067-.066 2.245-.2 3.335-.2m-3.183.85a23.007 23.007 0 013.684-.13m-3.9.785a12.313 12.313 0 002.682-.066 9.007 9.007 0 001.44-.282h.718m-4.84.719c1.81-.132 3.772.13 5.647-.283m-13.777.064h1.5m5.69.219c.2.065.413-.067.5.065m6.606-.218c1.5-.13 3.03.283 4.557 0m-5.341-.5a5.571 5.571 0 012.811.13c.066 0 .066.131.131.2a10.148 10.148 0 002.442-.065m-10.77-.349h-1m-5.1-.218c-.631.065-1.286.065-2.026.13m14.8-14.343h.284m-.13.436a.835.835 0 00.348-.066m-.282.72a.228.228 0 01.064-.131h.414m-.326.567c.195-.13.414-.066.719-.066m.065.436a2.354 2.354 0 00-.632.131m.282.589a1.086 1.086 0 01.633-.13m.305.5h-.937m.283.5a1.515 1.515 0 00.938-.13m.24.7a2.507 2.507 0 00-1 .13m.2.61a1.845 1.845 0 001.156-.2m.088.414a9.5 9.5 0 01-1.069.284m.195.589c.415-.2 1 0 1.44-.13m.153.565a6.864 6.864 0 00-1.156 0 .684.684 0 01-.348.132m.26.959a1.537 1.537 0 01.938-.284c0-.2.2 0 .348-.13.066-.066.2 0 .35 0m.261.633a7.322 7.322 0 00-1.656.13m.13.72c.633-.2 1.286-.2 1.962-.35m-1.9 1.156a10.883 10.883 0 002.158-.415m.523.48a8.556 8.556 0 00-2.377.349m.131.74a.681.681 0 00.35.132 4.379 4.379 0 012.245-.5m.24.59a6.081 6.081 0 01-2.463.282c-.066 0-.132.066-.284.131m.283.545c.938-.13 1.81-.2 2.747-.349m.588.632c-.719.066-1.439-.065-2.158.066-.348.066-.654.2-1 .283m.11.589c.13 0 .283.065.349-.066a6.2 6.2 0 013.03-.348m.327.567a8.667 8.667 0 00-2.594.065 2.151 2.151 0 01-.939.282m.263.655c.5-.065.937-.283 1.373-.349a21.268 21.268 0 012.9-.065m0 .5a3.566 3.566 0 00-1.657 0 10.656 10.656 0 01-2.464.414m.5.457c.655-.065 1.286-.282 1.94-.414a6.983 6.983 0 011.657-.066m-3.6.85a20.4 20.4 0 003.03-.282c.35-.131.72.064 1.07 0m.042-.392c1.744.13 3.4-.2 5.08.13m-4.73.393c.195.065.348-.132.5-.132 1.374 0 2.748.065 4.208.132m-.5-3.554h.2m-.108.436c.13.066.349-.2.5 0m-.37.5h.851m-.633.72c.284-.349.72 0 1-.2m-.784.85c.349-.282.937.066 1.286-.282m-1.2.784c.566-.13 1.154.066 1.656-.282m-1.439.805c.85-.348 1.809.2 2.594-.414m-2.529.85c1.069-.349 2.18 0 3.248-.065m.676 0q2.79-.1 5.581 0m-6.387-.675c1.656.13 4.12 0 6.169.13' fill='none' stroke='%2300b300' stroke-width='.173'/%3e%3cpath d='M511.434 300.22c-.939-.567-1.877-1.22-2.9-1.722a11.523 11.523 0 01-3.03-2.465c-.2-.13-.285-.565-.5-.784-1.286-1.286-2.528-2.528-3.9-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.37 9.37 0 01-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.313v-.065c.5-.282 1-.632 1.5-.937a3.309 3.309 0 012.68.13 2.509 2.509 0 01.851.5 11.631 11.631 0 003.9 1.875c1.592.414 1.941 1.438 3.183 2.53a6.893 6.893 0 001.94 1.285 4.486 4.486 0 01.283.414 14.793 14.793 0 012.094 1.438q1.656 1.525 3.247 3.118c.131.131.2.5.35.654a11.014 11.014 0 002.593 2.027c.937.5 1.81 1.156 2.747 1.657-2.528.131-4.992.131-7.542.131h-.066' fill='%23fc0'/%3e%3cpath d='M511.434 300.22c-.939-.567-1.877-1.22-2.9-1.722a11.523 11.523 0 01-3.03-2.465c-.2-.13-.285-.565-.5-.784-1.286-1.286-2.528-2.528-3.9-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.017 9.017 0 01-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.313v-.065c.5-.282 1-.632 1.5-.937a3.309 3.309 0 012.68.13 2.509 2.509 0 01.851.5 11.631 11.631 0 003.9 1.875c1.592.414 1.941 1.438 3.183 2.53a6.893 6.893 0 001.94 1.285 4.486 4.486 0 01.283.414 14.793 14.793 0 012.094 1.438q1.656 1.525 3.247 3.118c.131.131.2.5.35.654a11.014 11.014 0 002.593 2.027c.937.5 1.81 1.156 2.747 1.657-2.528.131-4.992.131-7.542.131h-.066z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M495.322 287.075c.131 0 1.222-.2 1.352-.2m-1 .48a3.524 3.524 0 001.44-.195m-.851.719l1-.2h.413m-.98.48c.131-.065 1.5 0 1.743-.065m.349.349a5.306 5.306 0 00-1.5.194m.937.612a3.238 3.238 0 011.22-.283m.654.5c-.348 0-1.067.066-1.439.066m.72.587a4.566 4.566 0 001.221-.282m.741.566c-.414 0-.937.065-1.439.065m.633.524a10.52 10.52 0 001.5-.065m.545.282a10.014 10.014 0 01-1.286.284m.632.59c.348-.2 1-.066 1.5-.2m.523.48a7.463 7.463 0 00-1.286.066 1.344 1.344 0 01-.349.065m3.161 1.025a7.9 7.9 0 00-1.81.13m.567.676a9.139 9.139 0 011.962-.35m-.5 2.094a4.592 4.592 0 00.938-.065 8.04 8.04 0 012.092-.283m.523.414c-1.22.195-1.656.195-2.594.348-.13 0-.414.066-.5.066m.545.457c.937-.195 2.245-.13 3.183-.283m1.024.5c-.72.13-1.657 0-2.377.13-.282.065-.936.13-1.285.2m.915.61c.066 0 .284 0 .35-.065.719-.5 1.94-.35 3.029-.35m.763.48c-1.067 0-1.5 0-2.31.066a5.134 5.134 0 01-1.069.195m.83.61c1-.194 2.811-.348 1.721-.282 1-.066 1.156-.066 2.311-.066m.3.349a5.694 5.694 0 00-1.874.065 3.977 3.977 0 01-1.723.284m.567.306a5.1 5.1 0 001.44-.2 7.915 7.915 0 011.787-.065m-2.856.566a8.635 8.635 0 012.245-.065 4.649 4.649 0 00.937-.065m-19.663-13.3a1.166 1.166 0 01.85-.13c-.065-.2.2 0 .349-.131 0-.067.2 0 .349 0m-2.049-.241a1.455 1.455 0 01.937-.065c-.131-.2.283 0 .283-.13.066-.066.283 0 .5 0m6.693 7.3a.841.841 0 01.72-.131c-.13-.2.414 0 .5-.13 0-.066.5 0 .653 0m-.064 1.918a9.645 9.645 0 002.092-.414m1.025.72a12.626 12.626 0 00-2.594.348m-9.648-10.14c-.784-.066-.85.194-1.439.194' fill='none' stroke='%2300b300' stroke-width='.173'/%3e%3cpath d='M501.405 286.487a5.1 5.1 0 011.068.348c1.591.414 1.94 1.438 3.183 2.528a6.791 6.791 0 001.94 1.286 4.815 4.815 0 01.283.415 14.56 14.56 0 012.092 1.44q1.658 1.524 3.25 3.116c.13.131.2.5.348.654a11.029 11.029 0 002.594 2.028 17.206 17.206 0 012.31 1.438c2.094 0 4.121-.065 6.3-.13-.87-.5-1.59-1.068-2.527-1.5a9.343 9.343 0 01-2.312-1.875c-.13-.065-.2-.415-.349-.567q-1.449-1.44-2.964-2.812c-.567-.5-1.22-.85-1.875-1.374-.066 0-.195-.283-.283-.283a10.627 10.627 0 01-1.81-1.22c-1.067-1-1.439-1.875-2.9-2.312a13.141 13.141 0 01-3.554-1.656 2.516 2.516 0 00-.719-.5 2.974 2.974 0 00-2.463-.13 12.408 12.408 0 00-1.656 1.155' fill='%23fc0'/%3e%3cpath d='M501.405 286.487a5.1 5.1 0 011.068.348c1.591.414 1.94 1.438 3.183 2.528a6.791 6.791 0 001.94 1.286 4.815 4.815 0 01.283.415 14.56 14.56 0 012.092 1.44q1.658 1.524 3.25 3.116c.13.131.2.5.348.654a11.029 11.029 0 002.594 2.028 17.206 17.206 0 012.31 1.438c2.094 0 4.121-.065 6.3-.13-.87-.5-1.59-1.068-2.527-1.5a9.343 9.343 0 01-2.312-1.875c-.13-.065-.2-.415-.349-.567q-1.449-1.44-2.964-2.812c-.567-.5-1.22-.85-1.875-1.374-.066 0-.195-.283-.283-.283a10.627 10.627 0 01-1.81-1.22c-1.067-1-1.439-1.875-2.9-2.312a13.141 13.141 0 01-3.554-1.656 2.516 2.516 0 00-.719-.5 2.974 2.974 0 00-2.463-.13 12.408 12.408 0 00-1.656 1.155z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M503.89 287.51c.065 0 .938-.13 1.068-.13m-.785.5c.5-.13.938 0 1.22-.2m-.783.633l.849-.131a.915.915 0 01.415-.066m-.829.546a9.581 9.581 0 011.5-.132m.3.35a11.5 11.5 0 00-1.439.195m.567.545a3.3 3.3 0 011.5-.2m.611.392c-.349 0-1.286.066-1.59.066m.5.458a5.6 5.6 0 001.592-.2m.567.545a10.025 10.025 0 00-1.352.064m.414.458a5.981 5.981 0 001.591-.13m.523.262a10.636 10.636 0 01-1.35.349m.7.457c.349-.195 1-.065 1.439-.195m.435.479a5.547 5.547 0 00-1.068.065c-.13 0-.2.13-.348.065m2.876.96a6.587 6.587 0 00-1.656.13m.5.61a10 10 0 011.874-.282m-.37 1.94c.13.065.567-.131.632-.131 1-.065 1.068-.283 2.027-.283m.48.413a11.1 11.1 0 01-2.4.284 1.55 1.55 0 00-.5.13m.479.393c.85-.13 2.093-.13 2.965-.2m.959.414c-.654.065-1.439 0-2.158.13-.282.067-.937.067-1.22.132m.849.61a.706.706 0 00.349-.065 5.637 5.637 0 012.812-.349m.611.414a18.625 18.625 0 00-2.094.13c-.414.066-1 .2-1.067.2m.632.458c.937-.131 2.812-.283 1.81-.2.937-.065 1.154-.065 2.18-.065m.217.414a3.535 3.535 0 00-1.657 0 7.636 7.636 0 01-1.874.284m.48.283a12.094 12.094 0 001.591-.2 6.786 6.786 0 011.656-.065m-2.594.567a9.617 9.617 0 012.028-.131c.349 0 .5-.066.85-.066m-18.051-12.3c.2-.065.131-.131.5-.131.283-.065.5.066.567-.065a1.337 1.337 0 01.349-.066m-2.071-.021c.282-.13.349-.284.719-.2.349-.065.5 0 .567-.13h.415m6.365 6.714c.195-.131.065-.2.5-.131-.13-.13.35 0 .415-.065a1.747 1.747 0 01.654-.066m-.044 1.788a12.226 12.226 0 001.876-.349m.937.633a9.224 9.224 0 00-2.159.283m-9.068-9.287a2.679 2.679 0 00-1.723.567' fill='none' stroke='%2300b300' stroke-width='.173'/%3e%3cpath d='M511.716 288.884a6.422 6.422 0 001 1.069 10.2 10.2 0 001.808 1.22c.067 0 .2.283.284.283.633.5 1.286.851 1.875 1.373 1 .939 1.94 1.81 2.965 2.813.131.131.2.5.348.567a9.4 9.4 0 002.312 1.875c.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065a14.952 14.952 0 00-2.026-1.222 9.092 9.092 0 01-1.876-1.5c-.133-.065-.133-.283-.284-.5-.781-.786-1.591-1.5-2.377-2.246a10.852 10.852 0 00-1.5-1.069c-.067-.065-.195-.195-.195-.282a5.763 5.763 0 01-1.506-.938c-.85-.785-1.068-1.591-2.246-1.874a8.571 8.571 0 01-2.9-1.374 2.859 2.859 0 00-.633-.414 2.7 2.7 0 00-1.94-.065 11.447 11.447 0 00-2.026 1.439' fill='%23fc0'/%3e%3cpath d='M511.716 288.884a6.422 6.422 0 001 1.069 10.2 10.2 0 001.808 1.22c.067 0 .2.283.284.283.633.5 1.286.851 1.875 1.373 1 .939 1.94 1.81 2.965 2.813.131.131.2.5.348.567a9.4 9.4 0 002.312 1.875c.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065a14.952 14.952 0 00-2.026-1.222 9.092 9.092 0 01-1.876-1.5c-.133-.065-.133-.283-.284-.5-.781-.786-1.591-1.5-2.377-2.246a10.852 10.852 0 00-1.5-1.069c-.067-.065-.195-.195-.195-.282a5.763 5.763 0 01-1.506-.938c-.85-.785-1.068-1.591-2.246-1.874a8.571 8.571 0 01-2.9-1.374 2.859 2.859 0 00-.633-.414 2.7 2.7 0 00-1.94-.065 11.447 11.447 0 00-2.026 1.439z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M512.588 289.756c.065 0 1.069-.13 1.069-.13m-.786.348a5.155 5.155 0 001.156-.13m-.72.5l.785-.13c.065-.065.2 0 .349 0m-.85.414a4.846 4.846 0 011.374-.13m.239.282a2.858 2.858 0 00-1.068.131m.545.37a4.5 4.5 0 011-.13m.458.283c-.2 0-1 .066-1.221.066m.414.37a3.664 3.664 0 001.22-.195m.459.48h-1.07m.263.37a8.38 8.38 0 001.307-.066m.37.2a2.991 2.991 0 01-1.067.195m.348.393c.284-.131 1 0 1.286-.066m.437.285a3.948 3.948 0 00-.937.065h-.283m2.245.806a10.615 10.615 0 00-1.44.131m.5.37a9.225 9.225 0 011.5-.2m-.5 1.44a2.669 2.669 0 00.72 0c.719-.066.85-.283 1.5-.2m.393.327c-.785.065-1.156.13-1.81.13-.065 0-.348.066-.5.066m.35.327c.632-.13 1.809-.065 2.46-.13m.681.348c-.5.065-1.158 0-1.66.065-.349.066-1 .132-1 .132m.48.458c.13 0 .72-.132.72-.132.85-.065 1.156-.13 1.96-.2m.5.327a11.483 11.483 0 00-1.657.13 7.422 7.422 0 00-1.067.2m.61.393c.568-.132 2.159-.284 1.506-.284a13.2 13.2 0 001.59-.065m.263.349a4.217 4.217 0 00-1.29 0 5.666 5.666 0 01-1.524.195m.413.24a7.035 7.035 0 001.223-.13 4.374 4.374 0 011.284-.066m-2.071.48a4.753 4.753 0 011.724-.13 2.621 2.621 0 00.631-.066m-14.037-9.374c.2-.066.282-.2.566-.131.195-.065.348 0 .348-.065.066-.066.2-.066.35-.066m-1.626-.038c.2-.066.282-.2.566-.2H513c0-.065.2-.065.283-.065m4.73 5.123a1.218 1.218 0 01.568-.067c-.13-.065.282 0 .349-.065h.414m.065 1.374a4.981 4.981 0 001.44-.284m.74.5a7.71 7.71 0 00-1.809.195m-6.91-7.084c-.5-.066-.633.13-1 .348' fill='none' stroke='%2300b300' stroke-width='.173'/%3e%3cpath d='M530.878 298.76a8.662 8.662 0 00-1.506-.938 9.286 9.286 0 01-1.876-1.5c-.128-.065-.128-.284-.278-.5-.787-.785-1.59-1.5-2.377-2.245a10.827 10.827 0 00-1.508-1.068c-.061-.065-.195-.2-.195-.283a5.787 5.787 0 01-1.5-.938c-.719-.72-1-1.285-1.81-1.722h.066a6.891 6.891 0 011.22-.785 2.177 2.177 0 011.725.065c.062.067.28.2.5.35a6.193 6.193 0 002.467 1.154c.938.284 1.155.938 1.937 1.592a4.744 4.744 0 001.222.85c.067 0 .134.2.2.2a7.73 7.73 0 011.29.938c.72.633 1.373 1.285 2.026 1.94.133.13.133.349.284.414a8.586 8.586 0 001.59 1.22c.631.35 1.155.722 1.724 1.07-1.724.065-3.465.065-5.212.065v.065' fill='%23fc0'/%3e%3cpath d='M530.878 298.76a8.662 8.662 0 00-1.506-.938 9.286 9.286 0 01-1.876-1.5c-.128-.065-.128-.284-.278-.5-.787-.785-1.59-1.5-2.377-2.245a10.827 10.827 0 00-1.508-1.068c-.061-.065-.195-.2-.195-.283a5.787 5.787 0 01-1.5-.938c-.719-.72-1-1.285-1.81-1.722h.066a6.891 6.891 0 011.22-.785 2.177 2.177 0 011.725.065c.062.067.28.2.5.35a6.193 6.193 0 002.467 1.154c.938.284 1.155.938 1.937 1.592a4.744 4.744 0 001.222.85c.067 0 .134.2.2.2a7.73 7.73 0 011.29.938c.72.633 1.373 1.285 2.026 1.94.133.13.133.349.284.414a8.586 8.586 0 001.59 1.22c.631.35 1.155.722 1.724 1.07-1.724.065-3.465.065-5.212.065v.065z' fill='none' stroke='black' stroke-width='.347'/%3e%3cpath d='M520.5 290.126c.066 0 .937-.13 1-.13m-.72.414c.284-.066.85-.066 1-.2m-.719.413l.85-.13h.283m-.7.566a5.853 5.853 0 011.157-.2m.305.195a3.818 3.818 0 00-1.22.2m.478.306a2.608 2.608 0 011.072-.132m.48.284a4.2 4.2 0 00-1.224.13m.414.241a3.353 3.353 0 001.155-.2m.435.415a11.175 11.175 0 00-1.222.13m.5.306a3.654 3.654 0 001.221-.132m.308.2a6.984 6.984 0 01-1.155.2m.563.391c.134-.13.854-.065 1.155-.13m.374.262a3.242 3.242 0 00-.854.065c-.062.065-.279.065-.346.065m2.137.676a7.729 7.729 0 00-1.289.131m.352.37a9.1 9.1 0 011.5-.2m-.48 1.374c.068 0 .57-.065.636-.065a5.826 5.826 0 011.435-.132m.307.262c-.72.13-1.066.13-1.658.2h-.413m.263.393c.563-.066 1.657-.13 2.243-.2m.743.326a12.293 12.293 0 00-1.591.066 5.8 5.8 0 00-.938.131m.48.392c.061 0 .63-.13.63-.13.721-.066 1.006-.131 1.81-.2m.479.327a9.994 9.994 0 00-1.5.065c-.353.066-.855.283-1.006.283m.547.284a7.545 7.545 0 011.435-.2 9.6 9.6 0 011.44-.065m.239.26a2.581 2.581 0 00-1.222 0 4.875 4.875 0 01-1.373.2m.352.174a3.4 3.4 0 001.155-.13 7.42 7.42 0 011.222 0m-2.032.435a11.794 11.794 0 011.658-.13h.57m-12.951-8.743a1 1 0 01.5-.13h.436a.7.7 0 01.282-.066m-1.525 0c.2-.13.2-.2.5-.13.195-.066.348 0 .414-.066a.7.7 0 01.283-.066m4.316 4.753a1.135 1.135 0 01.5-.065c-.067-.131.285 0 .346-.066h.441m-.134 1.221a9.861 9.861 0 001.44-.2m.742.415a8.36 8.36 0 00-1.875.13m-6.17-6.518c-.5-.065-.633.13-.938.349' fill='none' stroke='%2300b300' stroke-width='.173'/%3e%3cpath d='M514.5 299.651a2.1 2.1 0 00-1.161-.287l-.906-.031.893-.062c.974-.069 1.025-.11.628-.507-.235-.234-.5-.244-2.2-.071a10.429 10.429 0 01-2.244.07c-.375-.15.737-.356 2.026-.376.487-.008.808-.09.808-.207 0-.2-2.291-.1-3.234.134-.34.086-.386.063-.222-.111a3.638 3.638 0 011.49-.3c1.375-.088 1.76-.362.562-.4-.4-.013-.552-.057-.341-.1.737-.142.386-.4-.425-.316-2.319.245-3.015.272-2.767.1a2.482 2.482 0 011.022-.178c.9 0 1.531-.152 1.531-.356 0-.08-.21-.113-.467-.073s-1 .112-1.66.16c-1.374.1-1.03-.132.468-.316 1.342-.166 1.269-.477-.085-.366l-1.064.086.809-.182c.445-.1.808-.25.808-.334 0-.189.03-.19-1.66.084-1.183.192-1.4.192-1.4 0 0-.165.244-.232.838-.232.887 0 1.42-.131 1.3-.321a3.526 3.526 0 00-1.233-.008c-1.264.116-1.858-.078-.792-.257.708-.12 1.208-.36 1.06-.509a1.283 1.283 0 00-.674.076c-.753.216-1.523.214-1.523 0 0-.093.25-.171.554-.172.536 0 1.137-.244.974-.393a3.611 3.611 0 00-1.017.057 2.32 2.32 0 01-1.1-.022c-.1-.088.166-.15.64-.15 1.188 0 .968-.315-.265-.38l-1.064-.056.723-.144c1.057-.212.905-.49-.192-.351-.6.074-.954.049-1.031-.074s.093-.187.49-.187c.964 0 .7-.337-.288-.37-.735-.023-.78-.04-.255-.095.35-.036.638-.149.638-.25 0-.12-.292-.15-.846-.083-.923.11-1.335-.119-.513-.283.52-.1.714-.451.253-.451-.14 0-.256-.085-.256-.19 0-.127-.245-.152-.75-.077-.462.07-.794.044-.862-.066s.092-.178.411-.178c.752 0 .643-.336-.118-.36-.35-.01-.5-.055-.338-.1.546-.143.142-.352-.6-.309-.4.024-.516.01-.258-.032.722-.114.553-.39-.255-.419-.509-.017-.585-.045-.256-.1.257-.04.468-.153.468-.253 0-.117-.263-.146-.727-.082a1.99 1.99 0 01-.979-.06c-.182-.116-.076-.16.387-.161.35 0 .638-.047.638-.1 0-.3-.58-.587-1.222-.608-.4-.012-.563-.056-.352-.1.471-.09.508-.39.047-.39-.243 0-.3-.078-.226-.285s.041-.258-.175-.175c-.158.06-.284.027-.284-.073s-.27-.157-.682-.118c-.374.036-.68 0-.68-.069s.172-.132.383-.133a1.4 1.4 0 00.623-.156c.2-.127.195-.2-.049-.44-.227-.227-.454-.265-1.049-.176-.494.074-.76.051-.76-.067 0-.1.268-.18.6-.18.8 0 .762-.3-.043-.38l-.638-.06.808-.384c1.163-.552 2.127-.337 3.75.84a15.515 15.515 0 002.57 1.214 6.969 6.969 0 013.225 2 23.333 23.333 0 002.083 1.789 29.261 29.261 0 014.944 4.03 23.445 23.445 0 011.617 1.765 12.975 12.975 0 003.191 2.528 11.732 11.732 0 011.387.89 9.012 9.012 0 01-1.605.072c-1.2 0-1.669-.065-1.86-.256z' fill='%23090'/%3e%3cpath d='M521.309 299.14a1.808 1.808 0 01-.373-.621c-.112-.354-.177-.36-2.265-.27-1.2.054-1.962.035-1.726-.042a6.563 6.563 0 011.4-.156c.614-.01.98-.09.98-.212 0-.14-.448-.17-1.575-.1-.887.053-1.39.034-1.15-.043a5.632 5.632 0 011.235-.154c.444-.01.808-.093.808-.187s-.115-.17-.255-.17-.255-.077-.255-.17-.517-.184-1.15-.2c-.7-.017-.9-.054-.51-.095.35-.036.638-.137.638-.224a3.73 3.73 0 00-1.574-.074c-1.776.1-1.825-.006-.085-.174 1.182-.115 1.578-.41.6-.444-.3-.011-.419-.055-.255-.1.493-.128.337-.428-.17-.328-1.29.253-2.052.3-2.16.12-.078-.125.161-.185.735-.185a1.725 1.725 0 00.965-.183c.077-.124-.246-.17-1.013-.142-1.29.047-1.626-.09-.618-.25.378-.06.687-.185.687-.279 0-.2-.227-.206-1.065-.011-.352.081-.677.087-.722.015s.261-.185.682-.248.764-.187.764-.277c0-.143-1.066-.076-1.654.1a.281.281 0 01-.308-.1c-.057-.092.162-.163.5-.163.97 0 .7-.338-.288-.357-.869-.017-.878-.023-.341-.195.825-.265.67-.467-.275-.355-.529.063-.87.03-.945-.093s.082-.191.487-.191c.7 0 .834-.334.138-.354-.257-.008-.372-.052-.255-.1.488-.2.156-.35-.58-.266-.569.064-.757.034-.67-.106a.581.581 0 01.45-.2c.183 0 .332-.077.332-.17s-.116-.171-.256-.171-.256-.073-.256-.162-.363-.137-.808-.107-.6.023-.341-.018c.723-.115.554-.391-.254-.417-.4-.013-.552-.056-.341-.1.426-.08.528-.39.127-.39-.14 0-.255-.076-.255-.17s-.248-.18-.553-.19-.42-.054-.255-.1c.629-.165.259-.383-.51-.3-.679.073-.741.057-.39-.1a2.828 2.828 0 00.488-.252c.124-.124-.45-.6-.725-.6-.147 0-.268-.078-.268-.17s-.114-.171-.255-.171-.236-.1-.213-.213-.088-.19-.253-.163c-.188.031-.263-.033-.207-.18.066-.17-.077-.218-.556-.188-.367.023-.46 0-.218-.048.667-.138.82-.4.246-.42-.286-.01-.374-.053-.2-.1.364-.1.4-.394.043-.394-.14 0-.255-.077-.255-.17s-.288-.173-.639-.176c-.6 0-.617-.021-.307-.255a2.323 2.323 0 012.323.17 32.609 32.609 0 004.058 1.974 5.889 5.889 0 012.213 1.5 16.621 16.621 0 001.8 1.532c1.993 1.307 3.452 2.593 6.939 6.113a11.279 11.279 0 002.125 1.586 8.681 8.681 0 011.235.76 4.192 4.192 0 01-1.094.073c-.748 0-1.176-.082-1.351-.257zm4.829-.608c0-.348-.49-.668-1.02-.668-.312 0-.49-.07-.428-.17s-.019-.171-.17-.171-.229-.076-.17-.17-.058-.17-.255-.17-.314-.077-.256-.17-.087-.17-.34-.17-.4-.074-.341-.17-.16-.18-.543-.194-.5-.052-.265-.1c.427-.082.527-.39.127-.39-.14 0-.255-.076-.255-.17s-.115-.17-.255-.17-.256-.076-.256-.17-.234-.17-.52-.17c-.307 0-.478-.071-.415-.172.119-.192-.3-.68-.585-.68a.177.177 0 01-.182-.17c0-.094-.158-.17-.35-.17s-.3-.077-.246-.17-.216-.181-.713-.2c-.62-.02-.685-.044-.265-.095.545-.069.792-.388.3-.388-.14 0-.255-.062-.255-.137s-.288-.112-.638-.082c-.556.045-.587.029-.243-.12s.368-.2.14-.427a.848.848 0 00-.438-.255.179.179 0 01-.183-.17.183.183 0 00-.192-.171.982.982 0 01-.494-.346 2.2 2.2 0 00-1.041-.493c-.408-.08-.607-.154-.443-.163.408-.026.376-.37-.042-.48-.188-.05-.341-.166-.341-.259s-.27-.137-.6-.1a1.272 1.272 0 01-1.15-.4l-.548-.471.457-.007c.579-.009.774-.3.388-.585-.268-.2-.238-.252.334-.6a2.608 2.608 0 012.957.288 10.343 10.343 0 002.038 1 4.835 4.835 0 012.167 1.342 24.389 24.389 0 002.553 2.077 29.988 29.988 0 013.522 3.09 17.6 17.6 0 002.469 2.223c1.283.678 1.265.691-.926.693-1.371 0-2.085-.059-2.085-.18zm6.819-.562c-.2-.367-.314-.4-1.263-.361-.576.023-.8.01-.493-.032s.553-.113.553-.161c0-.223-.541-.589-1.012-.682-.286-.058-.52-.172-.52-.253s-.11-.15-.243-.15-.293-.152-.353-.34a.5.5 0 00-.436-.34c-.182 0-.33-.076-.33-.17s-.25-.171-.553-.173c-.392 0-.483-.047-.313-.155.2-.129.2-.193-.03-.423a.9.9 0 00-.453-.27.178.178 0 01-.183-.171c0-.094-.115-.17-.255-.17s-.256-.077-.256-.17a.2.2 0 00-.217-.17.784.784 0 01-.463-.342.825.825 0 00-.559-.34c-.186 0-.266-.076-.195-.189.167-.272-.277-.493-.777-.385-.325.07-.367.05-.177-.083.211-.147.188-.228-.154-.524a1.534 1.534 0 00-.555-.351 1.612 1.612 0 01-.578-.425 1.558 1.558 0 00-.6-.425 2.567 2.567 0 01-1.007-.941 1.023 1.023 0 00-.274-.38c-.254-.254-.245-.286.1-.413a2.241 2.241 0 011.962.545 9.984 9.984 0 001.778.86 4.9 4.9 0 011.899 1.192 13.987 13.987 0 001.8 1.45 26.112 26.112 0 012.825 2.439 23.56 23.56 0 002.724 2.341l.9.559h-1.036c-.917 0-1.06-.041-1.251-.4z' fill='%23090'/%3e%3cpath d='M492.488 272.643l.132.349-1.657.633.2.631-.2.065c-.131-.348-.284-.5-.72-.414l-.13-.282 2.376-1m-1.81-.72a.464.464 0 01-.283-.413c-.066-.414.066-.938.567-1 .283-.13.937-.13 1.155.721a.8.8 0 01-.5.937l-.13-.349c.348-.065.414-.283.348-.567a.581.581 0 00-.72-.414.557.557 0 00-.414.72c0 .13.132.283.35.348l.065.284-1.438.13-.284-1.286.283-.065.284 1.068.72-.066m-.72-4.752a.563.563 0 00-.567.557v.01c0 .2 0 .633.414.633.2 0 .283-.13.349-.284l.2-.72a.594.594 0 01.72-.5c.632 0 .785.566.719 1.067a.964.964 0 01-.283.72.682.682 0 01-.72.195l.065-.283c.414 0 .567-.348.633-.718a.583.583 0 00-.35-.72c-.282 0-.348.065-.5.5l-.2.567a.624.624 0 01-.632.5.823.823 0 01-.719-1c.066-.85.566-.938.85-.938v.35m2.616-2.4l-.567 1.875-2.529-.85.567-1.81.35.131-.5 1.439.72.2.5-1.374.284.132-.5 1.373.85.283.5-1.5.283.065m.415-.545l-.2.284-2.246-1.354.632-1a.687.687 0 011-.284.7.7 0 01.282 1.066l-.413.72.938.567m-1.025-3.335l1.5-1.5.2.195-.632.63 1.656 1.59-.194.286-1.658-1.658-.633.631-.195-.2m3.88.023l-.283.195-1.5-2.16.2-.128 1.59 2.093M498 259.5l-1.722.938-1.22-2.4 1.744-.848.131.278-1.373.721.348.72 1.286-.631.13.284-1.285.63.414.788 1.373-.72.13.195m2.443-.524l-.283-1.5c0-.067-.066-.35-.13-.636l-.2 2.311-.348.133-1.221-2.03a5.6 5.6 0 01.13.568l.35 1.591h-.35l-.566-2.528.5-.067 1.22 2.031.284-2.377.5-.134.5 2.6-.348.067m.894-2.7h1.069c.5.061.784.346.719.72a.6.6 0 01-.349.564c.13.067.5.194.414.63a.7.7 0 01-.85.72l-1.156-.062.132-2.6m2.572 2.919l-.283-.066.631-2.59 1.221.413c.415.067.785.346.633.848-.131.413-.35.413-.5.5.065.067.194.194.065.568l-.065.413c0 .195 0 .195.065.285v.061l-.414-.127c-.065-.135.065-.5.13-.632a.473.473 0 00-.348-.568l-.85-.195-.283 1.087m3.77 1.658l-1.722-1 1.286-2.244 1.744.937-.2.285-1.286-.787-.415.72 1.222.72-.132.285-1.275-.722-.348.72 1.286.782-.066.284m2.877-.847l.633.78a1.078 1.078 0 01-.2 1.658c-.5.413-1.221.72-1.81.067l-.632-.848 2.027-1.658m.415 5.448l-.872-1.72 2.311-1.222.85 1.722-.283.13-.633-1.372-.784.346.719 1.288-.283.131-.633-1.286-.784.347.72 1.442-.285.13m.393 2.31v-.349l1.809-.2-.13-.567.282-.065c.132.414.132.567.568.567l.065.283-2.594.35m1.46 2.157a.627.627 0 01-.654.414c-.414 0-.784-.282-.784-.937a1.27 1.27 0 01.195-.567.814.814 0 01.655-.283.823.823 0 01.633.5c.064-.2.195-.282.5-.282.283 0 .633.13.633.784 0 .567-.349.784-.72.719-.349 0-.414-.195-.5-.349m.174.938a.822.822 0 01.719 1.068.838.838 0 01-.938.633c-.414-.131-.567-.415-.719-.938l-.065-.284c-.066-.348-.2-.5-.35-.5l-.347 1.352-.285-.066.415-1.723a.993.993 0 01.871.85l.132.35c.065.283.13.5.5.567.132.065.415 0 .5-.35.132-.5-.282-.566-.414-.653v-.351m-2.55 2.6l.13-.284 1.656.785.2-.567.284.066c-.2.414-.2.567.13.85l-.13.195-2.311-1.068' fill='%23e60000'/%3e%3cpath d='M491.681 263.268l.284-.5c.2-.286.2-.5-.065-.637-.2-.195-.414-.062-.567.134l-.349.563.72.42m9.92-5.844h.631c.283 0 .414-.067.5-.35 0-.286-.132-.347-.5-.347l-.567-.068-.065.787' fill='%23ffd1c5'/%3e%3cpath d='M501.624 258.562h.631c.349 0 .567-.134.567-.35 0-.347-.284-.414-.567-.414l-.632-.068v.855' fill='%23ffe6d9'/%3e%3cpath d='M504.39 257.754l.721.195c.195 0 .5.067.566-.28a.388.388 0 00-.282-.5l-.785-.194-.2.78m4.752 3.99l.348.413c.283.352.72.352 1.221-.061.414-.351.5-.786.2-1.072l-.414-.5-1.374 1.222m3.227 7.129c-.2 0-.5.065-.5.414 0 .2 0 .5.414.5.283 0 .435-.13.435-.414.067-.35-.13-.5-.348-.5m1.155.937a.317.317 0 00.283-.349c.067-.348-.13-.414-.283-.414a.383.383 0 100 .763' fill='%23ffd1c5'/%3e%3cpath d='M501.624 335.538c1.5 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3a8.106 8.106 0 013.248-.413 8.4 8.4 0 00-5.713-2.685c-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.2-16.459 4.2h-.13c-8.851 0-14.28-3.182-16.83-4.2-2.442-1.071-1.373-1.071-4.274-1.071a8.15 8.15 0 00-5.711 2.685 8.732 8.732 0 013.27.413c1.286.563 6.89 4.71 13.626 6.3 6.735 1.658 8.415 1.658 9.787 1.658' fill='white'/%3e%3cpath d='M501.624 335.538c1.5 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3a8.106 8.106 0 013.248-.413 8.4 8.4 0 00-5.713-2.685c-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.2-16.459 4.2h-.13c-8.851 0-14.28-3.182-16.83-4.2-2.442-1.071-1.373-1.071-4.274-1.071a8.15 8.15 0 00-5.711 2.685 8.732 8.732 0 013.27.413c1.286.563 6.89 4.71 13.626 6.3 6.735 1.658 8.415 1.658 9.787 1.658z' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M475.66 329.74c.718-.352-.132-1.6-.132-1.6l2.682-.563a8.233 8.233 0 00-3.27-.413c-.5.413-.414.937-.5 1.283a1.719 1.719 0 00.195 1.29c.284.194 1 0 1 0' fill='white'/%3e%3cpath d='M475.66 329.74c.718-.352-.132-1.6-.132-1.6l2.682-.563a8.233 8.233 0 00-3.27-.413c-.5.413-.414.937-.5 1.283a1.719 1.719 0 00.195 1.29c.284.194 1 0 1 0z' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M478.187 327.557l-2.68.563s.85 1.223.13 1.6l4.71-.854a25.078 25.078 0 00-2.16-1.283' fill='white'/%3e%3cpath d='M478.187 327.557l-2.68.563s.85 1.223.13 1.6l4.71-.854a25.078 25.078 0 00-2.16-1.283z' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M527.675 329.74c-.72-.352.128-1.6.128-1.6l-2.679-.563a8.115 8.115 0 013.25-.413c.5.413.412.937.5 1.283a1.733 1.733 0 01-.2 1.29c-.28.194-1 0-1 0' fill='white'/%3e%3cpath d='M527.675 329.74c-.72-.352.128-1.6.128-1.6l-2.679-.563a8.115 8.115 0 013.25-.413c.5.413.412.937.5 1.283a1.733 1.733 0 01-.2 1.29c-.28.194-1 0-1 0' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M525.147 327.557l2.679.563s-.848 1.223-.129 1.6l-4.71-.854s.721-.5 2.16-1.283' fill='white'/%3e%3cpath d='M525.147 327.557l2.679.563s-.848 1.223-.129 1.6l-4.71-.854s.721-.5 2.16-1.283z' fill='none' stroke='black' stroke-width='.406'/%3e%3cpath d='M482.984 325.75l.567.194a1.6 1.6 0 11-1.243 2.941l-.567-.195 1.22-2.963m1.7 4.23l-.35-.134 1.287-2.9.349.061-1.286 2.97m3.989 0a1.552 1.552 0 01-2.094.847 1.573 1.573 0 01-.784-2.091 1.606 1.606 0 012.093-.938 1.648 1.648 0 01.785 2.16m2.092-.263c-.065-.2-.13-.351-.348-.413-.2-.067-.5 0-.567.195a.493.493 0 00.131.565l.2.195c.349.284.567.569.349 1.071a.952.952 0 01-1.22.63 1.06 1.06 0 01-.568-1.222l.349.067a.626.626 0 00.349.787.554.554 0 00.72-.351c.13-.346-.067-.564-.284-.782l-.131-.134a.833.833 0 01-.283-.937.794.794 0 011.068-.5.834.834 0 01.567.721l-.35.066m2.355.174l-.5 1.808c-.13.5-.13 1 .414 1.16.567.195.85-.2 1-.72l.5-1.813.35.066-.567 1.943a1.058 1.058 0 01-1.374.847 1 1 0 01-.719-1.438l.5-1.937.349.061m2.354.547l1.722 2.9.414-2.317.35.067-.568 3.248-1.809-2.9-.414 2.31-.349-.066.633-3.248m3.138 3.9l-.348-.06.348-3.12h.35l-.35 3.181m3.86-1.373a1.555 1.555 0 01-1.593 1.59 1.539 1.539 0 01-1.525-1.718 1.49 1.49 0 011.59-1.507 1.547 1.547 0 011.506 1.657m.37-1.763l2.464 2.243-.219-2.31h.414l.2 3.248-2.441-2.244.2 2.31h-.414l-.2-3.247m5.232 2.333l.85-.134.13.351-1.286.2-.653-3.12.414-.06.5 2.746m1.788.022l-.349.061-.72-3.03.35-.129.719 3.12m-.153-3.23l.349-.13c.567-.128 1.068-.128 1.286.57a.754.754 0 01-.131.63.7.7 0 01.785.565.966.966 0 01-.785 1.154l-.653.2-.851-3.029m2.115-.614l1.59-.563.066.345-1.155.413.283.854 1.156-.42.066.353-1.07.346.35 1.16 1.134-.418.13.352-1.5.5-1.069-2.97m5.015 1.575l-.436.129-1.286-.849-.131.061.414 1.223-.283.133-1.226-2.966.414-.127a1.768 1.768 0 01.786-.2.972.972 0 01.632.563.838.838 0 01-.349 1.071l1.439.938m1.264-.547l-.348.195-1.156-2.6-.633.284-.13-.284 1.591-.72.2.284-.72.286 1.22 2.528m1.07-1.374l.065.849-.349.2-.2-3.622 2.747 2.244-.284.2-.72-.57-1.22.63m.959-3.18l.5-.285a1.575 1.575 0 012.312.5 1.6 1.6 0 01-.72 2.244l-.5.284-1.592-2.746'/%3e%3cpath d='M482.33 328.427h.131a1.047 1.047 0 001.59-.5c.35-.782-.064-1.218-.783-1.5l-.066-.067-.872 2.093m5.864 1.29a1.152 1.152 0 00-.567-1.508 1.07 1.07 0 00-1.374.63 1.122 1.122 0 00.5 1.508 1.085 1.085 0 001.439-.653m13.647 3.136a1.083 1.083 0 00-1-1.222 1.193 1.193 0 00-1.156 1.156 1.234 1.234 0 001.091 1.221 1.12 1.12 0 001.068-1.155m8.5-1.44l.066-.061c.283-.067.567-.134.436-.57-.13-.412-.349-.412-.72-.284h-.065l.283.937m8.546-4.012l.065 1.29.85-.5-.937-.787m2.856.57h.065a1.18 1.18 0 00.633-1.658 1.154 1.154 0 00-1.722-.285l-.13.067 1.154 1.876m-11.03 4.794l.282-.062c.284-.134.568-.285.416-.637-.067-.412-.5-.346-.786-.279h-.131l.2 1m3.945-2.79h.065c.35-.129.72-.346.5-.781-.13-.351-.567-.285-.85-.2l-.066.061.35.937' fill='white'/%3e%3c/svg%3e";

var img$h = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3e%3cdefs%3e%3clinearGradient id='cap1' gradientUnits='userSpaceOnUse' x1='498.738' y1='289.055' x2='500.626' y2='283.42'%3e%3cstop stop-color='%23510000' offset='0'/%3e%3cstop stop-color='%238a0000' offset='0.3'/%3e%3cstop stop-color='%23a00' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='cap2' gradientUnits='userSpaceOnUse' x1='501.444' y1='291.373' x2='502.927' y2='287.449'%3e%3cstop stop-color='%23ff2a2a' offset='0'/%3e%3cstop stop-color='red' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='mountain' gradientUnits='userSpaceOnUse' x1='484.764' y1='311.709' x2='484.764' y2='317.647'%3e%3cstop stop-color='%23F5F549' offset='0'/%3e%3cstop stop-color='%2397C924' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='seafgrad'%3e%3cstop stop-color='%23025' offset='0'/%3e%3cstop stop-color='%2304a' offset='0.5'/%3e%3cstop stop-color='%23025' offset='1'/%3e%3c/linearGradient%3e%3clinearGradient id='seabgrad' xlink:href='%23seafgrad' gradientUnits='userSpaceOnUse' x1='444.509' y1='317.486' x2='634.411' y2='317.486'/%3e%3cclipPath id='shield'%3e%3cpath fill='black' d='m500%2c226.375 -63.7015%2c110.332h127.401z'/%3e%3c/clipPath%3e%3c/defs%3e%3crect width='1000' height='600' fill='%230067C6'/%3e%3crect width='1000' height='200' y='200' fill='white'/%3e%3cg id='text' fill='%23c8a400'%3e%3cpath d='m410%2c299.329c3.32634%2c0.22223%2c6.65268%2c0.44445%2c9.97902%2c0.66668%2c0.0329-0.48587%2c0.064-0.97205%2c0.0981-1.45773-1.30824-0.0873-2.61644-0.17511-3.92471-0.26198%2c0.0986-1.60327%2c0.23297-3.20473%2c0.3036-4.80942%2c1.38833-1.00412%2c2.77759-2.00697%2c4.16149-3.01719%2c0.0412-0.61599%2c0.0823-1.23197%2c0.12346-1.84796-1.46281%2c1.06196-2.92562%2c2.12393-4.38843%2c3.18589-0.14757-1.03794-0.72165-2.10727-1.76463-2.46788-0.91323-0.33059-2.03168-0.3884-2.82311%2c0.26424-1.00326%2c0.738-1.18359%2c2.05857-1.31388%2c3.20783-0.17463%2c2.17695-0.29658%2c4.35998-0.45091%2c6.53752zm1.51943-1.36222c0.12006-1.63759%2c0.19451-3.27916%2c0.35147-4.91355%2c0.12284-0.80837%2c0.27116-1.7421%2c0.97877-2.25692%2c0.63951-0.42451%2c1.58455-0.10865%2c1.84624%2c0.61403%2c0.52201%2c1.24667%2c0.29033%2c2.62159%2c0.22338%2c3.93021-0.0632%2c0.94689-0.12655%2c1.89378-0.18977%2c2.84068-1.06985-0.0707-2.14151-0.14232-3.21009-0.21445z'/%3e%3cpath d='m411.299%2c284.006c3.24602%2c0.75791%2c6.49205%2c1.51582%2c9.73807%2c2.27373%2c0.73769-3.1594%2c1.47537-6.31879%2c2.21306-9.47819-0.4612-0.10769-0.92241-0.21537-1.38361-0.32306-0.62753%2c2.68761-1.25507%2c5.37521-1.8826%2c8.06282-0.98811-0.2308-1.97626-0.4614-2.96437-0.69221%2c0.56551-2.42194%2c1.13101-4.84387%2c1.69651-7.26581-0.45886-0.10714-0.91773-0.21428-1.37659-0.32142-0.5655%2c2.42194-1.13099%2c4.84388-1.69649%2c7.26582-0.87427-0.20424-1.7486-0.40821-2.62286-0.61249%2c0.60401-2.58683%2c1.208-5.17367%2c1.812-7.7605-0.46355-0.10824-0.92711-0.21647-1.39066-0.32471-0.71415%2c3.05867-1.42831%2c6.11735-2.14246%2c9.17602z'/%3e%3cpath d='m414.807%2c270.929c3.14837%2c1.09493%2c6.29675%2c2.18986%2c9.44512%2c3.28479%2c0.15992-0.45982%2c0.31983-0.91964%2c0.47975-1.37946-1.2384-0.4307-2.47682-0.86135-3.71521-1.29209%2c0.48491-1.42877%2c1.01619-2.8425%2c1.46212-4.28396%2c0.31982-1.1769%2c0.56684-2.55272-0.12567-3.64707-0.56233-0.80874-1.56218-1.32766-2.54938-1.29642-1.08858%2c0.0466-1.97544%2c0.84759-2.45833%2c1.77548-0.71429%2c1.34208-1.11369%2c2.81798-1.63458%2c4.23987-0.30127%2c0.86629-0.60255%2c1.73257-0.90382%2c2.59886zm1.82516-0.91156c0.50573-1.41719%2c0.96234-2.85276%2c1.50949-4.25451%2c0.34032-0.74874%2c0.75526-1.63711%2c1.61685-1.87541%2c0.70884-0.16219%2c1.45167%2c0.38249%2c1.5132%2c1.10855%2c0.17309%2c1.3358-0.4107%2c2.59669-0.82087%2c3.83664-0.25986%2c0.74722-0.51973%2c1.49444-0.77958%2c2.24166-1.01301-0.35237-2.02604-0.70467-3.03909-1.05693z'/%3e%3cpath d='m420.024%2c258.833c1.78079%2c1.03286%2c3.54652%2c2.09256%2c5.33751%2c3.10726%2c1.01015%2c0.54316%2c2.29139%2c0.85386%2c3.34732%2c0.24536%2c1.44062-0.79757%2c2.34305-2.27069%2c3.05103-3.70714%2c0.55788-1.21033%2c0.96223-2.71397%2c0.25161-3.95061-0.76525-1.23498-2.15613-1.80264-3.34366-2.54015-1.15241-0.67405-2.30482-1.34811-3.45723-2.02216-0.2446%2c0.4182-0.4892%2c0.83639-0.7338%2c1.25459%2c1.69411%2c0.99759%2c3.40038%2c1.97522%2c5.08648%2c2.98594%2c0.80638%2c0.49107%2c1.47446%2c1.38051%2c1.33556%2c2.36857-0.15909%2c1.178-0.83235%2c2.21182-1.50327%2c3.1639-0.5532%2c0.77126-1.48261%2c1.39382-2.46901%2c1.18523-1.02907-0.19727-1.86511-0.87054-2.7694-1.35707-1.13311-0.66277-2.26623-1.32553-3.39934-1.9883-0.24459%2c0.41819-0.48923%2c0.83643-0.7338%2c1.25458z'/%3e%3cpath d='m427.227%2c247.062c2.64728%2c2.02559%2c5.29456%2c4.05117%2c7.94184%2c6.07676%2c1.2324-1.60897%2c2.45998-3.22252%2c3.70139-4.82374%2c0.71204-1.0218%2c1.36783-2.35063%2c0.88541-3.60415-0.43852-0.99742-1.46605-1.76954-2.56718-1.82076-0.49731-0.0682-1.14581%2c0.30822-1.41493%2c0.47419%2c0.28305-1.06581-0.58942-2.0679-1.57186-2.35041-1.18182-0.42013-2.38052%2c0.33763-3.16221%2c1.17835-0.9204%2c1.00107-1.68892%2c2.12852-2.53072%2c3.19463-0.42725%2c0.55838-0.85449%2c1.11675-1.28174%2c1.67513zm2.01433-0.29772c0.92943-1.19063%2c1.80918-2.42176%2c2.78303-3.57628%2c0.45282-0.50395%2c1.17935-1.07479%2c1.88161-0.70532%2c0.64009%2c0.27772%2c0.79787%2c1.08511%2c0.49233%2c1.66627-0.48521%2c1.03983-1.28618%2c1.88276-1.95401%2c2.80542-0.36367%2c0.47529-0.72737%2c0.95057-1.09102%2c1.42588-0.70398-0.53866-1.40796-1.07732-2.11194-1.61597zm3.23588%2c2.47597c0.96434-1.2336%2c1.87255-2.51286%2c2.89009-3.70336%2c0.51954-0.54354%2c1.17239-1.22856%2c1.99705-1.07233%2c0.70444%2c0.16212%2c1.21664%2c0.92689%2c0.97341%2c1.63628-0.39626%2c1.30911-1.37599%2c2.31142-2.16426%2c3.39599-0.4137%2c0.54068-0.82742%2c1.08134-1.2411%2c1.62203-0.81839-0.62621-1.6368-1.2524-2.45519-1.87861z'/%3e%3cpath d='m436.231%2c236.455%2c6.8675%2c7.26894%2c5.88255-5.55767-0.97575-1.03279-4.70554%2c4.44565-0.12052%2c0.11387-0.0869-0.092-5.80486-6.14418z'/%3e%3cpath d='m445.035%2c228.752%2c6.09535%2c7.92761%2c1.18915-0.91429-6.09535-7.92762z'/%3e%3cpath d='m453.991%2c222.67c-0.98774%2c0.61544-1.78425%2c1.33504-2.39782%2c2.17554-0.6112%2c0.83726-0.94122%2c1.71049-0.98884%2c2.62241-0.0476%2c0.91165%2c0.19536%2c1.79452%2c0.73286%2c2.6572%2c0.49251%2c0.79046%2c1.15266%2c1.40385%2c1.97619%2c1.84418%2c0.82023%2c0.43856%2c1.70565%2c0.60098%2c2.67598%2c0.49235%2c0.96511-0.10804%2c2.05508-0.53501%2c3.26884-1.29126%2c1.16547-0.72616%2c1.99135-1.56229%2c2.50028-2.52478%2c0.48822-0.92337%2c0.62578-1.90365%2c0.41645-2.94732l-1.38296%2c0.5422c0.36225%2c1.99857-0.92658%2c2.9588-2.36991%2c3.87479-2.2587%2c1.37399-4.45973%2c1.27451-5.80828-0.78982-1.39827-2.32778%2c0.12974-4.25089%2c2.05166-5.49964%2c1.36386-0.85119%2c2.70794-1.43321%2c3.98724-0.61857l1.08262-0.9642c-0.74564-0.51452-1.59209-0.75257-2.55559-0.6994-1.01162%2c0.0558-2.06822%2c0.42819-3.18872%2c1.12632z'/%3e%3cpath d='m465.808%2c216.773-1.047%2c11.2056%2c1.55741-0.62791%2c0.31478-3.47417%2c0.006-0.003%2c5.05831-2.03938%2c2.63645%2c2.28431%2c1.5574-0.62791-8.52648-7.34584-1.5574%2c0.62791zm1.36835%2c1.14857%2c3.32461%2c2.87791-3.72338%2c1.50118%2c0.39877-4.37909z'/%3e%3cpath d='m487.726%2c210.591c0.20805%2c3.32683%2c0.41609%2c6.65367%2c0.62414%2c9.9805%2c1.80444-0.12174%2c3.6118-0.20647%2c5.41405-0.35597%2c1.4176-0.16233%2c2.93884-0.53067%2c3.9077-1.65878%2c1.2513-1.3881%2c1.42875-3.46194%2c0.88129-5.18861-0.4596-1.52076-1.82744-2.6711-3.37555-2.9629-1.52435-0.29289-3.07841-0.0617-4.61381%2c0.008-0.94594%2c0.0591-1.89188%2c0.11841-2.83782%2c0.1774zm1.5393%2c1.32733c1.43646-0.0757%2c2.87074-0.21585%2c4.30969-0.22392%2c0.81646-0.0241%2c1.62864%2c0.21461%2c2.28786%2c0.70072%2c1.00072%2c0.68405%2c1.58799%2c1.91553%2c1.45667%2c3.12503-0.0712%2c1.38985-1.09329%2c2.66855-2.44413%2c3.02043-0.77283%2c0.19999-1.57593%2c0.25601-2.36712%2c0.34365-0.93214%2c0.0583-1.86428%2c0.11665-2.79643%2c0.17483-0.14939-2.38021-0.29825-4.76046-0.44654-7.14074z'/%3e%3cpath d='m501.664%2c210c-0.19023%2c3.3279-0.38046%2c6.6558-0.57069%2c9.9837%2c3.23909%2c0.18516%2c6.47818%2c0.37031%2c9.71727%2c0.55547%2c0.027-0.47284%2c0.0541-0.94567%2c0.0811-1.41851-2.75541-0.1572-5.51074-0.31562-8.26619-0.47205%2c0.0573-1.01308%2c0.11603-2.02606%2c0.17328-3.03914%2c2.48308%2c0.14086%2c4.96605%2c0.28372%2c7.44909%2c0.42535%2c0.0269-0.47043%2c0.0538-0.94086%2c0.0807-1.41129-2.48304-0.14163-4.966-0.28449-7.44908-0.42535%2c0.0507-0.89637%2c0.10241-1.79268%2c0.15347-2.68903%2c2.65213%2c0.15053%2c5.30416%2c0.30305%2c7.95625%2c0.45434%2c0.0272-0.47524%2c0.0543-0.95049%2c0.0815-1.42573-3.13557-0.17925-6.27113-0.35851-9.4067-0.53776z'/%3e%3cpath d='m527.774%2c214.166-3.61612%2c9.3233%2c1.28604%2c0.4988%2c2.86698-7.3919%2c0.14904-0.38427%2c0.15998%2c0.42657%2c3.44815%2c9.91881%2c1.68397%2c0.65315%2c3.61613-9.3233-1.28934-0.50007-2.86569%2c7.38853-0.1464%2c0.37752-0.158-0.42191-3.45405-9.91335z'/%3e%3cpath d='m541.208%2c219.937-4.54582%2c8.90705-1.33607-0.68187%2c4.54582-8.90705z'/%3e%3cpath d='m548.751%2c224.356c-0.97142-0.64089-1.95772-1.06453-2.97756-1.27147-1.01591-0.20614-1.9472-0.14174-2.79583%2c0.19546-0.84836%2c0.3371-1.54936%2c0.92626-2.1091%2c1.77467-0.51289%2c0.77738-0.79492%2c1.63325-0.85151%2c2.56539-0.0563%2c0.92841%2c0.16547%2c1.80086%2c0.66904%2c2.63737%2c0.50084%2c0.83202%2c1.34364%2c1.64445%2c2.53733%2c2.432%2c1.14619%2c0.75621%2c2.25064%2c1.15792%2c3.33769%2c1.21888%2c1.04287%2c0.0584%2c1.99114-0.22553%2c2.85229-0.85122l-1.06975-1.03062c-1.66517%2c1.16306-3.07555%2c0.39239-4.5102-0.53714-2.19107-1.47947-3.01898-3.52128-1.70555-5.60813%2c1.53212-2.24195%2c3.91737-1.65565%2c5.8541-0.43%2c1.3426%2c0.88435%2c2.43232%2c1.86302%2c2.22572%2c3.36554l1.32796%2c0.58161c0.15651-0.89231%2c0.0197-1.76089-0.43062-2.61434-0.47283-0.89607-1.25205-1.70096-2.35401-2.428z'/%3e%3cpath d='m558.272%2c231.538-10.4535%2c4.16977%2c1.26814%2c1.10073%2c3.2365-1.30154%2c0.005%2c0.005%2c4.1188%2c3.57507-0.83343%2c3.38738%2c1.26814%2c1.10073%2c2.65816-10.936-1.26815-1.10073zm-0.39961%2c1.74123-1.0486%2c4.27035-3.03182-2.63158%2c4.08042-1.63877z'/%3e%3cpath d='m565.825%2c238.486c-2.572%2c2.12101-5.14401%2c4.24201-7.71601%2c6.36302%2c0.30955%2c0.37576%2c0.6199%2c0.75094%2c0.92896%2c1.12706%2c1.01157-0.83421%2c2.02316-1.66839%2c3.03473-2.50261%2c1.02878%2c1.23361%2c2.02924%2c2.49136%2c3.07954%2c3.70663-0.32075%2c1.6831-0.6431%2c3.36591-0.95647%2c5.05041%2c0.39278%2c0.4763%2c0.78555%2c0.95259%2c1.17833%2c1.42889%2c0.33526-1.77628%2c0.67051-3.55257%2c1.00577-5.32885%2c0.86447%2c0.70788%2c2.1276%2c1.06331%2c3.16016%2c0.50203%2c0.88803-0.42012%2c1.67042-1.22768%2c1.7162-2.25661%2c0.10773-1.37866-0.87542-2.49623-1.66235-3.51871-1.25571-1.5241-2.5136-3.04745-3.76886-4.57126zm-0.17038%2c2.03353c1.08022%2c1.33434%2c2.21438%2c2.62669%2c3.24602%2c3.99893%2c0.47574%2c0.70741%2c1.06859%2c1.70139%2c0.52294%2c2.52797-0.44979%2c0.70689-1.43474%2c0.64494-2.03913%2c0.18646-1.2247-0.82376-2.0334-2.08693-2.9893-3.18371-0.40756-0.49424-0.81514-0.98846-1.2227-1.4827%2c0.82739-0.68229%2c1.6549-1.36466%2c2.48217-2.04695z'/%3e%3cpath d='m577.523%2c254.401-11.2426%2c0.51528%2c0.83758%2c1.45542%2c3.48429-0.16949%2c0.003%2c0.006%2c2.72039%2c4.72706-1.89709%2c2.92745%2c0.83758%2c1.45542%2c6.09396-9.46182-0.83758-1.45542zm-0.94796%2c1.51425-2.38965%2c3.69121-2.00246-3.47954%2c4.39211-0.21167z'/%3e%3cpath d='m583.939%2c267.638c-0.62517-1.69658-1.61122-3.43366-3.27989-4.28241-1.85658-0.93284-4.32804-0.47908-5.6446%2c1.15572-1.14698%2c1.35925-1.20561%2c3.28116-0.89925%2c4.9518%2c0.36199%2c1.91793%2c1.24128%2c3.74411%2c2.56297%2c5.18542-0.24899%2c0.0895-0.49798%2c0.17897-0.74697%2c0.26846%2c0.15949%2c0.44375%2c0.31898%2c0.88751%2c0.47847%2c1.33126%2c1.56145-0.56118%2c3.12289-1.12237%2c4.68434-1.68356-0.60724-1.6861-1.21448-3.37219-1.82172-5.05829-0.36076%2c0.12966-0.72152%2c0.25931-1.08228%2c0.38897%2c0.44666%2c1.24274%2c0.89326%2c2.4855%2c1.33997%2c3.72822-0.52894%2c0.19019-1.05794%2c0.38024-1.5869%2c0.57038-1.39993-1.20263-2.18095-2.98027-2.58642-4.74823-0.30073-1.32658-0.3127-2.91664%2c0.69375-3.96056%2c1.15449-1.20086%2c3.20117-1.57383%2c4.58696-0.54964%2c1.36679%2c1.00022%2c2.13826%2c2.6215%2c2.52811%2c4.233%2c0.26694%2c1.05995%2c0.22329%2c2.32-0.58098%2c3.14709-0.22477%2c0.16883%2c0.13155%2c0.40385%2c0.19251%2c0.60544%2c0.12747%2c0.21048%2c0.25493%2c0.42097%2c0.3824%2c0.63145%2c0.84766-0.66844%2c1.36007-1.71422%2c1.34362-2.79667%2c0.0283-1.06426-0.20642-2.12058-0.56409-3.11785z'/%3e%3cpath d='m586.811%2c275.447-5.59255%2c1.08792c-1.03793%2c0.20191-1.81583%2c0.53072-2.3346%2c0.96809-0.51784%2c0.43655-0.84913%2c1.05225-1.00889%2c1.87102-0.15808%2c0.81019-0.13548%2c1.80286%2c0.0969%2c3.01081%2c0.002%2c0.009%2c0.004%2c0.0182%2c0.005%2c0.0277%2c0.23733%2c1.207%2c0.58855%2c2.13574%2c1.03883%2c2.82758%2c0.45504%2c0.69917%2c0.99299%2c1.14578%2c1.63672%2c1.35637%2c0.64489%2c0.21099%2c1.48934%2c0.2242%2c2.52725%2c0.0223l5.59255-1.08792-0.27754-1.42669-5.45747%2c1.06164c-2.44995%2c0.47659-3.27516-0.81293-3.69596-3.01869-0.002-0.009-0.003-0.0183-0.005-0.0277-0.43677-2.20264-0.15514-3.70748%2c2.2948-4.18408l5.45748-1.06164-0.27752-1.4267z'/%3e%3cpath d='m589.879%2c292.467-10.3479-4.42525%2c0.12129%2c1.67483%2c3.21126%2c1.36264%2c0.00051%2c0.007%2c0.39395%2c5.43971-2.98142%2c1.8111%2c0.1213%2c1.67484%2c9.60233-5.87006-0.1213-1.67483zm-1.51216%2c0.95131-3.75709%2c2.28466-0.28998-4.00412%2c4.04707%2c1.71946z'/%3e%3crect width='1.5' height='6.3' x='-322.944' y='414.199' transform='scale(-1%2c1) rotate(14.748924)'/%3e%3crect width='1.5' height='6.3' x='644.14' y='159.606' transform='rotate(14.748924)'/%3e%3cpath d='m433.217%2c343.989-11.1807%2c1.28621%2c0.93557%2c1.39445%2c3.46441-0.40839%2c0.004%2c0.006%2c3.03863%2c4.52906-1.69156%2c3.05083%2c0.93557%2c1.39445%2c5.42972-9.85801-0.93556-1.39445zm-0.84172%2c1.57578-2.13049%2c3.84662-2.23671-3.33381%2c4.3672-0.51281z'/%3e%3cpath d='m437.497%2c350.098-7.12714%2c6.66478%2c0.95177%2c1.0178%2c6.00626-5.61661-3.15096%2c8.66999%2c1.09151%2c1.16724%2c8.61117-2.61405-5.89802%2c5.51541%2c0.95176%2c1.0178%2c7.12714-6.66478-1.44571-1.54602-8.75099%2c2.61438%2c3.27652-8.46862z'/%3e%3cpath d='m447.878%2c360.689c-2.00517%2c2.66278-4.01035%2c5.32555-6.01552%2c7.98833%2c2.59171%2c1.95166%2c5.18343%2c3.90333%2c7.77514%2c5.85499%2c0.2849-0.37833%2c0.5698-0.75667%2c0.8547-1.135-2.2047-1.6602-4.40935-3.32047-6.61409-4.98063%2c0.61036-0.8106%2c1.2208-1.62113%2c1.83116-2.43173%2c1.98679%2c1.49606%2c3.97352%2c2.9922%2c5.96029%2c4.48829%2c0.28345-0.37641%2c0.5669-0.75281%2c0.85035-1.12922-1.98677-1.49609-3.9735-2.99224-5.96029-4.4883%2c0.54002-0.71722%2c1.08018-1.43435%2c1.62017-2.1516%2c2.12207%2c1.59791%2c4.24406%2c3.19593%2c6.3661%2c4.79388%2c0.28635-0.38026%2c0.5727-0.76052%2c0.85905-1.14078-2.50902-1.88941-5.01804-3.77882-7.52706-5.66823z'/%3e%3cpath d='m457.662%2c367.85c-1.56999%2c2.94092-3.13997%2c5.88185-4.70996%2c8.82277%2c0.42937%2c0.22948%2c0.85923%2c0.45816%2c1.2883%2c0.68814%2c0.61751-1.15665%2c1.23489-2.31336%2c1.85248-3.46997%2c1.42112%2c0.74871%2c2.82545%2c1.53016%2c4.25943%2c2.25383%2c0.34467%2c1.67837%2c0.68772%2c3.35708%2c1.03974%2c5.03393%2c0.54461%2c0.29074%2c1.08923%2c0.58147%2c1.63384%2c0.87221-0.36674-1.77005-0.73349-3.5401-1.10023-5.31015%2c1.06896%2c0.32516%2c2.37225%2c0.17258%2c3.11309-0.73977%2c0.62944-0.70484%2c1.05797-1.69332%2c0.75635-2.63927-0.35132-1.30341-1.63425-1.98592-2.71701-2.61729-1.80294-0.96908-3.61175-1.92868-5.41603-2.89443zm0.61719%2c1.94509c1.50709%2c0.8222%2c3.04815%2c1.58484%2c4.52472%2c2.46067%2c0.68458%2c0.46205%2c1.55319%2c1.0947%2c1.46717%2c2.02654-0.0761%2c0.81768-0.95762%2c1.2541-1.70343%2c1.08062-1.45923-0.24188-2.68995-1.11223-3.9896-1.76124-0.60467-0.32278-1.20931-0.64561-1.814-0.96836%2c0.50503-0.94608%2c1.01013-1.89215%2c1.51514-2.83823z'/%3e%3cpath d='m468.957%2c373.756-3.77856%2c9.25864%2c1.38879%2c0.5668%2c3.77856-9.25864z'/%3e%3cpath d='m477.975%2c376.871c-1.1045-0.36671-2.16696-0.51975-3.20557-0.45482-1.03459%2c0.0647-1.91722%2c0.36866-2.6492%2c0.91462-0.73176%2c0.5458-1.25576%2c1.29675-1.57605%2c2.26139-0.29347%2c0.88389-0.34361%2c1.78363-0.15626%2c2.6985%2c0.18663%2c0.9112%2c0.62734%2c1.69614%2c1.33082%2c2.37323%2c0.69968%2c0.67346%2c1.72451%2c1.23922%2c3.08173%2c1.68985%2c1.30322%2c0.43271%2c2.4741%2c0.5339%2c3.5397%2c0.31054%2c1.02228-0.21431%2c1.8643-0.73475%2c2.53348-1.56255l-1.30064-0.71755c-1.30612%2c1.5555-2.86822%2c1.17743-4.495%2c0.65224-2.50004-0.85988-3.82967-2.61674-3.10307-4.97303%2c0.89751-2.56285%2c3.35319-2.61592%2c5.54172-1.93512%2c1.52616%2c0.50545%2c2.8326%2c1.16765%2c3.02317%2c2.67228l1.43343%2c0.2169c-0.0805-0.90234-0.43816-1.70562-1.09461-2.41289-0.68925-0.74259-1.65072-1.31757-2.90365-1.73359z'/%3e%3cpath d='m488.029%2c379.122-6.54019%2c9.15906%2c1.66192%2c0.24047%2c2.01921-2.8446%2c0.007%2c0.001%2c5.39774%2c0.78104%2c1.13004%2c3.30029%2c1.66192%2c0.24048-3.6757-10.6373-1.66191-0.24047zm0.60512%2c1.6809%2c1.42636%2c4.15944-3.97323-0.57492%2c2.54687-3.58452z'/%3e%3cpath d='m511.47%2c379.193c-1.14266%2c0.22076-2.14408%2c0.60727-3.01802%2c1.1722-0.87056%2c0.56274-1.4915%2c1.25979-1.86263%2c2.09414-0.37102%2c0.83409-0.46045%2c1.74541-0.26766%2c2.74338%2c0.17666%2c0.91443%2c0.57327%2c1.7236%2c1.1844%2c2.42972%2c0.6087%2c0.70328%2c1.37718%2c1.1721%2c2.32202%2c1.41827%2c0.93976%2c0.24486%2c2.11036%2c0.23669%2c3.51447-0.0346%2c1.34825-0.26047%2c2.41884-0.74526%2c3.23879-1.46156%2c0.7866-0.6872%2c1.26619-1.55314%2c1.44461-2.60254l-1.4854%2c0.0108c-0.37773%2c1.99571-1.925%2c2.43052-3.60068%2c2.76868-2.601%2c0.47368-4.62033-0.40766-5.13988-2.81808-0.47161-2.67419%2c1.64391-3.9223%2c3.88562-4.3997%2c1.57827-0.30613%2c3.04163-0.36804%2c3.94421%2c0.85082l1.35617-0.51239c-0.51183-0.74748-1.21684-1.27295-2.13544-1.56846-0.96449-0.31025-2.08436-0.34112-3.38058-0.0907z'/%3e%3cpath d='m518.148%2c378.01c0.94813%2c3.19565%2c1.89626%2c6.39129%2c2.84439%2c9.58694%2c3.11037-0.92283%2c6.22073-1.84565%2c9.3311-2.76848-0.13471-0.45405-0.26943-0.90809-0.40414-1.36214-2.64589%2c0.78505-5.29182%2c1.57-7.93769%2c2.35511-0.28864-0.97278-0.57724-1.94559-0.86588-2.91837%2c2.38433-0.70751%2c4.7687-1.41486%2c7.15305-2.12231-0.13403-0.45173-0.26805-0.90347-0.40208-1.3552-2.38435%2c0.70745-4.76872%2c1.4148-7.15305%2c2.12231-0.25541-0.86072-0.51069-1.72147-0.76615-2.58217%2c2.54667-0.75567%2c5.09338-1.51119%2c7.64007-2.2668-0.1354-0.45636-0.27079-0.91271-0.40619-1.36907-3.01114%2c0.89339-6.02229%2c1.78679-9.03343%2c2.68018z'/%3e%3cpath d='m528.966%2c374.61c1.39945%2c3.02534%2c2.79891%2c6.05067%2c4.19836%2c9.07601%2c0.41731-0.19304%2c0.83461-0.38607%2c1.25192-0.57911-1.16723-2.5233-2.33445-5.04661-3.50169-7.5699%2c3.2371%2c1.46816%2c6.45494%2c2.97935%2c9.68455%2c4.46424%2c0.21532%2c0.18677%2c0.43059%2c0.0619%2c0.64586-0.0532%2c0.41968-0.19414%2c0.83935-0.38827%2c1.25903-0.5824-1.39945-3.02534-2.79891-6.05067-4.19836-9.07601-0.41837%2c0.19353-0.83673%2c0.38706-1.2551%2c0.58059%2c1.16571%2c2.52002%2c2.33141%2c5.04004%2c3.49712%2c7.56005-3.32359-1.50694-6.62903-3.05445-9.94557-4.57714-0.54537%2c0.25228-1.09075%2c0.50455-1.63612%2c0.75683z'/%3e%3cpath d='m539.947%2c369.452%2c0.7834%2c1.1903%2c3.57155-2.3506%2c0.13556-0.0892%2c0.0676%2c0.10271%2c4.64663%2c7.0602%2c1.2141-0.79904-4.64663-7.06021-0.0676-0.10271%2c0.13849-0.0912%2c3.58924-2.36224-0.7834-1.1903z'/%3e%3cpath d='m550.009%2c362.562c2.25912%2c2.45158%2c4.51825%2c4.90315%2c6.77737%2c7.35473%2c0.35826-0.32963%2c0.71559-0.66044%2c1.07443-0.98933-0.88853-0.9642-1.77701-1.92843-2.66556-2.89261%2c1.17531-1.0949%2c2.3759-2.16325%2c3.53179-3.27856%2c1.69818%2c0.22782%2c3.39617%2c0.45717%2c5.09534%2c0.67753%2c0.45399-0.41836%2c0.90799-0.83671%2c1.36198-1.25507-1.79202-0.23715-3.58403-0.4743-5.37605-0.71145%2c0.65931-0.90206%2c0.94479-2.18281%2c0.32762-3.18296-0.46831-0.86361-1.31769-1.60043-2.34759-1.58963-1.38249-0.0318-2.44436%2c1.01126-3.42205%2c1.85319-1.45278%2c1.3374-2.90492%2c2.6777-4.35728%2c4.01416zm2.0398%2c0.0584c1.27303-1.15184%2c2.50096-2.35547%2c3.81453-3.46086%2c0.6802-0.51389%2c1.64011-1.16046%2c2.49542-0.66105%2c0.73053%2c0.41027%2c0.7228%2c1.39714%2c0.29822%2c2.02581-0.75622%2c1.26942-1.97455%2c2.14713-3.01826%2c3.16305-0.46989%2c0.433-0.93977%2c0.866-1.40966%2c1.299-0.72675-0.78859-1.45368-1.57749-2.18025-2.36595z'/%3e%3cpath d='m561.643%2c350.918%2c4.47337%2c10.3272%2c1.06321-1.29975-1.39553-3.1971%2c0.004-0.005%2c3.45322-4.22148%2c3.41028%2c0.73412%2c1.06321-1.29976-11.009-2.33754-1.06322%2c1.29975zm1.75217%2c0.34857%2c4.29916%2c0.9234-2.54189%2c3.1074-1.75727-4.0308z'/%3e%3cpath d='m565.998%2c345.253%2c8.39039%2c5.44074%2c4.40302-6.79009-1.19211-0.77303-3.52205%2c5.43147-0.0902%2c0.13913-0.10617-0.0688-7.09208-4.59886z'/%3e%3c/g%3e%3cg clip-path='url(%23shield)'%3e%3cg id='rays'%3e%3cpath fill='white' d='m500.001%2c226.408 -31.4786%2c54.5355 -15.42%2c26.7015h93.7971l-14.7145%2c-25.4844 -32.1841%2c-55.7526z'/%3e%3cg id='rays5'%3e%3cg id='ray'%3e%3cpath fill='%2317c0eb' stroke='%2317c0eb' stroke-width='0.12869333' opacity='0.62040818' d='m500.001%2c226.408-2.35655%2c4.08164%2c2.35655%2c54.9769%2c2.35656-54.9769z'/%3e%3cpath fill='white' d='m500.001%2c277.475c-0.044%2c0 -0.0891%2c0.002 -0.1335%2c0.003l0.1335%2c3.11123 0.13351-3.11123c-0.0443%2c-0.00097 -0.0892%2c-0.003 -0.13351%2c-0.003z'/%3e%3c/g%3e%3cuse xlink:href='%23ray' transform='rotate(72%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23ray' transform='rotate(144%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23ray' transform='rotate(216%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23ray' transform='rotate(288%2c500.001%2c285.46654)'/%3e%3c/g%3e%3cuse xlink:href='%23rays5' transform='rotate(8%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(16%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(24%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(32%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(40%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(48%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(56%2c500.001%2c285.46654)'/%3e%3cuse xlink:href='%23rays5' transform='rotate(64%2c500.001%2c285.46654)'/%3e%3c/g%3e%3cg id='rainbow'%3e%3cpath fill='red' d='m500%2c265.844c-11.0666%2c0-21.1953%2c4.05143-28.9688%2c10.75l-14.656%2c25.406c-0.50136%2c2.67038-0.75%2c5.43402-0.75%2c8.25h5.03125c0-21.7264%2c17.6173-39.3438%2c39.3438-39.3438%2c21.7264%2c0%2c39.3438%2c17.6173%2c39.3438%2c39.3438h5.03125c0-2.81337-0.24954-5.58193-0.75-8.25l-14.6562-25.4062c-7.77293-6.69663-17.904-10.75-28.9688-10.75z'/%3e%3cpath fill='%23f60' d='m500%2c266.656c-11.764%2c0-22.4393%2c4.67488-30.2812%2c12.25l-12.031%2c20.844c-0.83351%2c3.36611-1.28125%2c6.87625-1.28125%2c10.5h4.25c0-21.7264%2c17.6173-39.3438%2c39.3438-39.3438%2c21.7264%2c0%2c39.3438%2c17.6173%2c39.3438%2c39.3438h4.25c0-3.62494-0.44735-7.16414-1.28125-10.5312l-12.0312-20.8125c-7.841-7.57455-18.5177-12.25-30.2812-12.25z'/%3e%3cpath fill='%23ff0' d='m500%2c267.469c-12.7024%2c0-24.1008%2c5.52218-31.9375%2c14.3125l-8.71875%2c15.0938c-1.38396%2c4.20847-2.125%2c8.70346-2.125%2c13.375h3.4375c0-21.7264%2c17.6173-39.3438%2c39.3438-39.3438%2c21.7264%2c0%2c39.3438%2c17.6173%2c39.3438%2c39.3438h3.4375c0-4.67311-0.74037-9.16532-2.125-13.375l-8.719-15.095c-7.836-8.788-19.237-14.312-31.938-14.312z'/%3e%3cpath fill='lime' d='m500%2c268.25c-14.5495%2c0-27.3723%2c7.41414-34.9062%2c18.6562l-2.8125%2c4.875c-2.735%2c5.574-4.282%2c11.842-4.282%2c18.469h2.65625c0-21.7264%2c17.6173-39.3438%2c39.3438-39.3438%2c21.7264%2c0%2c39.3438%2c17.6173%2c39.3438%2c39.3438h2.6562c0-6.61555-1.55577-12.8712-4.28125-18.4375l-2.844-4.937c-7.536-11.227-20.337-18.625-34.875-18.625z'/%3e%3cpath fill='%230cf' d='m500%2c269.062c-22.7472%2c0-41.1875%2c18.4403-41.1875%2c41.1875h1.84375c0-21.7264%2c17.6173-39.3438%2c39.3438-39.3438%2c21.7264%2c0%2c39.3438%2c17.6173%2c39.3438%2c39.3438h1.84375c0-22.7472-18.4403-41.1875-41.1875-41.1875z'/%3e%3cpath fill='blue' d='m500%2c269.844c-22.3058%2c0-40.375%2c18.1004-40.375%2c40.4062h1.34375c0-21.5594%2c17.4718-39.0312%2c39.0312-39.0312s39.0312%2c17.4718%2c39.0312%2c39.0312h1.375c0-22.3058-18.1004-40.4062-40.4062-40.4062z'/%3e%3cpath fill='purple' d='m500.001%2c270.657c-21.8638%2c0-39.5887%2c17.7249-39.5887%2c39.5887%2c0%2c0.24501%2c0.003%2c0.48981%2c0.007%2c0.73377h0.8008c-0.005-0.24405-0.007-0.48864-0.007-0.73377%2c0-21.4222%2c17.3658-38.7879%2c38.7879-38.7879%2c21.4222%2c0%2c38.7879%2c17.3658%2c38.7879%2c38.7879%2c0%2c0.24513-0.002%2c0.48972-0.007%2c0.73377h0.79727c0.004-0.24396%2c0.007-0.48876%2c0.007-0.73377%2c0-21.8638-17.7214-39.5887-39.5852-39.5887z'/%3e%3c/g%3e%3cg id='cap'%3e%3cpath fill='%23510000' d='m500.395%2c288.134c-0.64444-0.12422-1.22556-0.48362-1.77526-0.60947-0.75553%2c0.72433-0.83505%2c1.45617-0.73118%2c2.07933%2c0.26291%2c0.13958%2c0.31133%2c0.353%2c0.87825%2c0.86011s0.49599%2c0.7732%2c0.46178%2c1.96543c-0.0144%2c0.50237%2c0.0702%2c1.58063%2c0.57906%2c1.682%2c0.54856%2c0.1093%2c0.93237-0.34645%2c1.08988-1.16049%2c0.15297-0.79058%2c0.4179-1.2158%2c0.69822-1.70182%2c0.30651-1.85224-0.19317-2.50796-1.20075-3.11509z'/%3e%3cpath fill='red' d='m497.168%2c283.524c-0.5954%2c0.015-1.52849%2c1.01222-1.94312%2c0.4754-0.2385-0.30879-0.2787-0.90191-0.037-1.40011%2c0.55866-1.15143%2c1.12448-1.71603%2c2.16738-2.33046%2c2.37772-1.40083%2c3.8889-0.95056%2c5.07395%2c1.06271%2c1.0982%2c1.77292%2c2.15196%2c3.72986%2c2.24612%2c5.37194%2c0.0291%2c0.50093%2c0.28239%2c1.40776-0.15623%2c1.85983-1.34779%2c1.38922-4.59607-1.43513-6.49718-0.9882-0.63913%2c0.15025-1.37729%2c0.6166-1.98048%2c0.21781-0.46922-0.31025-0.0771-0.99697%2c0.27265-1.29413%2c0.61215-0.52003%2c1.50103-2.36524%2c1.38013-3.16441-0.0677-0.44682-0.08%2c0.17838-0.52586%2c0.18962z'/%3e%3cpath fill='url(%23cap1)' d='m496.927%2c282.548c-1.08326%2c0.4452-0.96582%2c1.07615-1.50945%2c1.59022%2c0.15386%2c0.0578%2c0.7653%2c0.31056%2c1.36345-0.30126%2c0.25817-0.21386%2c0.54788-0.29339%2c0.67713-0.36245-0.30513%2c0.22158-0.52326%2c0.55469-0.68366%2c0.68484-0.40495%2c0.32861-1.03464%2c1.08239-1.34095%2c1.84608-0.30631%2c0.76368-0.43013%2c1.67294-0.37506%2c1.78203%2c0.0551%2c0.1091%2c0.42587%2c0.77878%2c1.5653%2c1.23156%2c2.03098%2c0.80708%2c2.41713%2c2.43864%2c4.47768%2c2.43864%2c1.61336%2c0%2c1.35441-1.05575%2c2.64581-0.83159%2c1.1192%2c0.19425%2c1.71404-0.69654%2c0.63574-1.23178-1.371-0.46864-4.09192-0.19196-5.37247%2c0.0332-0.41337-4.08361-0.0551-2.64985-0.15181-4.40521-0.0968-1.75536-0.62285-1.86055%2c0.0724-3.28125-0.57778%2c0.87239-1.27677%2c0.73447-2.004%2c0.807z'/%3e%3cpath fill='%23ff2a2a' d='m500.938%2c279.795c-0.0401%2c0.22319-0.0767%2c0.51644-0.0555%2c0.6%2c0.087%2c0.33854%2c0.17464%2c0.69288%2c0.27745%2c0.99375%2c0.11493%2c0.33621%2c0.16173%2c0.57942%2c0.24047%2c0.92812%2c0.0812%2c0.35981%2c0.40101%2c0.50003%2c0.69364%2c0.72188%2c0.36987%2c0.28044%2c0.0839%2c1.03755%2c0.31445%2c1.06875%2c0.18399%2c0.025%2c0.48828-1.07134%2c0.49017-1.24688%2c0-0.23637-0.001-0.42692-0.037-0.64687-0.1351-0.29493-0.27167-0.58548-0.42543-0.87188-0.002-0.004-0.007-0.006-0.009-0.009-0.0604-0.11211-0.12197-0.22206-0.19422-0.32812-0.21674-0.3182-0.48469-0.61247-0.78613-0.8625-0.0186-0.0154-0.0367-0.0318-0.0555-0.0469-0.0843-0.0645-0.17013-0.13028-0.25896-0.1875-0.0629-0.0405-0.12933-0.0758-0.19422-0.1125z'/%3e%3cpath fill='url(%23cap2)' d='m501.249%2c287.398c-0.71834-0.18768-1.42584-0.54264-2.03712-0.72519-1.20046-0.3585-2.47993-1.13407-3.3655-0.81346-0.31696%2c0.14032-0.28927%2c0.45588-0.39018%2c0.90946-0.0419%2c0.53363-0.59621%2c1.31951-0.13634%2c1.06243%2c0.68545-0.38318%2c2.49069%2c0.73271%2c3.09544%2c1.10617%2c0.28651%2c0.17693%2c0.89218%2c0.52377%2c1.08153%2c1.02169%2c0.18934%2c0.49792%2c0.092%2c1.75593%2c0.0412%2c2.29553-0.0533%2c0.56606%2c0.11902%2c1.83505%2c0.68594%2c1.98695%2c0.61122%2c0.16378%2c1.07804-0.32245%2c1.31579-1.2298%2c0.23091-0.8812%2c0.40519-1.38725%2c0.75742-1.91526s0.75591-0.75584%2c1.31984-0.86236c0.56393-0.10651%2c1.38228%2c0.46186%2c1.38228-0.20334%2c0-0.43694-0.38382-0.85479-0.22071-1.45374%2c0.12846-0.47174-0.40137-0.37766-0.84179-0.57224-1.03591-0.31872-1.96945-0.41916-2.6878-0.60684z'/%3e%3cpath fill='%23910000' d='m498.363%2c288.902c-0.32675-0.17761-2.3152-1.4778-3.04281-1.07105-0.22993%2c0.12854-0.31747-0.0162-0.32062-0.25731-0.004-0.24106%2c0.10913-0.59399%2c0.18399-0.86612%2c0.0749-0.27214%2c0.19591-0.79179%2c0.5164-1.06192%2c0.68731-0.5793%2c2.2686%2c0.57503%2c3.1082%2c0.88679-0.0717%2c0.4352-0.47012%2c2.35517-0.44516%2c2.36961z'/%3e%3cpath fill='%23ff3a3a' d='m501.763%2c291.361c0.91566-1.60289%2c1.50762-1.39687%2c2.61336-1.37357%2c0.36843%2c0.008%2c0.47628-0.32925%2c0.39238-0.66749-0.278%2c0.62397-1.66206-0.069-2.41497%2c0.26261-1.57249%2c0.69255-1.28027%2c3.76979-2.02634%2c4.07028%2c0.77552%2c0.65117%2c1.1236-1.74573%2c1.43557-2.29183z'/%3e%3c/g%3e%3cg id='seab' fill='url(%23seabgrad)'%3e%3cpath fill='white' d='m453.103%2c307.645-9.95545%2c17.2366%2c113.708%2c0-9.95545-17.2366-93.7972%2c0z'/%3e%3cg id='wavesb3'%3e%3cpath id='waveb1' d='m449.705%2c321.364c-1.65776%2c0-3.19731%2c0.16736-4.70961%2c0.35278l-0.48684%2c0.84666c2.43344-0.21658%2c4.69724-0.64924%2c7.14027-0.70908%2c3.29349%2c0.0801%2c6.2835%2c0.82902%2c9.78611%2c0.82902%2c1.51792%2c0.0147%2c3.02697-0.0297%2c4.5262%2c0%2c3.49923%2c0%2c6.48854-0.74896%2c9.78259-0.82902%2c3.29576%2c0.0801%2c6.30397%2c0.82902%2c9.80375%2c0.82902%2c1.51769%2c0.005%2c3.17747-0.0238%2c4.52973%2c0%2c3.49922%2c0%2c6.47429-0.74896%2c9.76495-0.82902%2c3.29293%2c0.0801%2c6.26925%2c0.82902%2c9.76848%2c0.82902%2c1.53042%2c0.0148%2c3.03299-0.0299%2c4.54381%2c0%2c3.49923%2c0%2c6.49037-0.74896%2c9.78612-0.82902%2c3.29632%2c0.0795%2c6.28114%2c0.82902%2c9.78258%2c0.82902%2c1.51624%2c0.0145%2c3.03114-0.0297%2c4.52976%2c0%2c3.49867%2c0%2c6.47485-0.74896%2c9.76495-0.82902%2c2.55081%2c0.062%2c4.92094%2c0.51761%2c7.48601%2c0.72319l-0.51507-0.89252c-1.40293-0.16829-2.8346-0.32103-4.36741-0.32103-1.52925-0.0208-3.03636%2c0.0308-4.54734%2c0-3.4992%2c0-6.47369%2c0.74842-9.76495%2c0.82902-3.29632-0.0801-6.28347-0.82902-9.78612-0.82902-1.51274-0.0209-3.0301%2c0.0312-4.52617%2c0-3.49921%2c0-6.49263%2c0.74897-9.7861%2c0.82902-3.29407-0.0801-6.28337-0.82902-9.7826-0.82902-1.52189-0.0207-3.04194%2c0.0308-4.54734%2c0-3.49922%2c0-6.4754%2c0.74897-9.76495%2c0.82902-3.29404-0.0801-6.26924-0.82902-9.76847-0.82902-1.52279-0.0213-3.02634%2c0.0313-4.52618%2c0-3.5026%2c0-6.48979%2c0.74897-9.78611%2c0.82902-3.29405-0.0806-6.28335-0.82902-9.78259-0.82902-1.52022-0.0209-3.04332%2c0.0313-4.54733%2c0z'/%3e%3cuse xlink:href='%23waveb1' y='-1.1132812'/%3e%3cuse xlink:href='%23waveb1' y='-2.2304687'/%3e%3c/g%3e%3cuse xlink:href='%23wavesb3' y='-3.34375'/%3e%3cuse xlink:href='%23wavesb3' y='-6.6914063'/%3e%3cpath d='m453.23%2c307.458 -0.12347%2c0.21519h93.7901l-0.12348%2c-0.21519h-93.5432zm-0.21872%2c0.37746 -0.127%2c0.21873h94.2346l-0.127%2c-0.21873h-93.9806zm-0.20109%2c0.34572 -0.20461%2c0.35631h94.792l-0.2046%2c-0.35631h-94.3828zm-0.3175%2c0.55033 -0.25047%2c0.43392h95.5187l-0.25048%2c-0.43392h-95.0178zm-0.39864%2c0.69144 -0.25047%2c0.43392h96.316l-0.25047%2c-0.43392h-95.815zm-0.39864%2c0.69144 -0.24695%2c0.43039h97.1062l-0.24693%2c-0.43039h-96.6123zm-0.39864%2c0.69144 -0.25048%2c0.43039h97.9106l-0.25048%2c-0.43039h-97.4096zm-0.43039%2c0.74436 -0.30339%2c0.52916h98.8772l-0.30339%2c-0.52916h-98.2704z'/%3e%3cpath d='m457.357%2c312.287c3.45019%2c0.6621 3.7818%2c0 3.7818%2c0zm81.5028%2c0s0.3316%2c0.6621 3.7818%2c0z'/%3e%3c/g%3e%3cg id='mountains' fill='%23ccd11e'%3e%3cg id='mountain1'%3e%3cpath fill='url(%23mountain)' d='m530.631%2c297.043c-1.70879%2c0-2.23164%2c0.86208-2.23164%2c0.86208-2.73683%2c10.5758-11.8078%2c21.3327-22.6008%2c21.3327h-8.08019v10.7684c0%2c0.003%2c0.0112%2c0%2c0.017%2c0h61.4976l-6.18652-10.9539c-9.70777-1.44879-17.6397-11.3728-20.1666-21.1472-0.0003%2c0-0.54017-0.86208-2.24897-0.86208z'/%3e%3cpath fill='%2397c924' d='m530.631%2c297.465c-0.78411%2c0-1.26009%2c0.18069-1.53836%2c0.35499-0.26383%2c0.16497-0.31454%2c0.2757-0.32096%2c0.28758%2c0%2c0.007-0.0151%2c0.01-0.0176%2c0.0168-1.39971%2c5.32242-4.35191%2c10.6683-8.33374%2c14.7065-4.01201%2c4.06971-9.06971%2c6.82929-14.605%2c6.82929h-7.67481v9.92268h60.8557l-5.68004-10.0578c-4.68763-0.61173-8.97309-3.16302-12.4584-6.69417-3.98569-4.03827-6.93211-9.38349-8.33374-14.7065%2c0%2c0-0.0164-0.0165-0.017-0.0168-0.007-0.012-0.0696-0.10431-0.33797-0.27057-0.28308-0.17556-0.75393-0.372-1.53804-0.372z'/%3e%3cpath fill='%23ede71f' d='m530.63%2c297.465c0.14713%2c0%2c0.27966%2c0.0211%2c0.4057%2c0.0341%2c0.0238%2c3.01731%2c0%2c8.10909%2c0%2c10.8013-0.0287%2c2.34006-0.83034%2c4.2225-2.01175%2c6.44085-0.54742%2c1.5541-0.98612%2c0.96232-2.34929%2c2.85666-1.83161%2c0.65398-3.18666%2c0.90876-5.13836%2c1.21655-2.51753%2c0.39758-8.12164%2c0.75027-10.8869%2c0.13523%2c3.64106-1.06725%2c6.96079-3.26938%2c9.77096-6.11954%2c0.74649-0.7573%2c1.45945-1.5595%2c2.12967-2.40011%2c1.11812-1.40047%2c2.12751-2.91291%2c3.00924-4.47944%2c0.35269-0.6264%2c0.68645-1.24901%2c0.99749-1.89326%2c0.46683-0.9661%2c0.88335-1.95059%2c1.25119-2.94104%2c0.12279-0.3305%2c0.24396-0.66588%2c0.35485-0.99747%2c0.22233-0.66372%2c0.41706-1.32961%2c0.59179-1.99495%2c0.002-0.006%2c0.0151-0.0103%2c0.0168-0.0168%2c0.006-0.0119%2c0.0579-0.12225%2c0.32077-0.28724%2c0.13578-0.0849%2c0.3316-0.17039%2c0.57502-0.23692%2c0.005-0.001%2c0.0124%2c0.001%2c0.0168%2c0%2c0.25153-0.0665%2c0.55446-0.11793%2c0.9461-0.11793z'/%3e%3cpath fill='%23c6cb24' d='m529.938%2c298.902c-0.41166%2c6.03407-2.27735%2c13.1917-6.64434%2c17.8107-1.60658%2c1.33664-3.65998%2c2.54995-5.64577%2c2.2546%2c6.77038-5.51045%2c10.8853-13.9468%2c12.2901-20.0653z'/%3e%3cpath fill='%239ecb34' d='m524.494%2c309.281c-1.00181%2c2.72142-4.78784%2c6.74649-8.84%2c10.0451-1.15058%2c0.0352-1.75967%2c0.10115-2.80422%2c0.0379%2c2.46776-0.22502%2c8.22171-5.08258%2c11.6442-10.0829z'/%3e%3c/g%3e%3cuse xlink:href='%23mountain1' x='-15.340665'/%3e%3cg id='mountain3' fill='%23c6cb24'%3e%3cpath fill='url(%23mountain)' d='m502.218%2c297.911c2.73458%2c10.5755%2c11.7902%2c21.3327%2c22.5831%2c21.3327h8.08853v10.7681c0%2c0.003-0.0144%2c0-0.017%2c0h-65.7947c-0.006%2c0-0.0167%2c0.003-0.0167%2c0v-10.7681h8.07151c10.7926%2c0%2c19.863-10.7575%2c22.6001-21.3327%2c0%2c0%2c0.53408-0.86562%2c2.24287-0.86562s2.24287%2c0.86562%2c2.24287%2c0.86562z'/%3e%3cpath fill='%2397c924' d='m499.975%2c297.465c0.78378%2c0%2c1.25463%2c0.19644%2c1.53836%2c0.372%2c0.26865%2c0.16626%2c0.33123%2c0.25869%2c0.33829%2c0.27057%2c0%2c0%2c0.017%2c0.0168%2c0.017%2c0.0168%2c1.40164%2c5.32275%2c4.34806%2c10.6683%2c8.33375%2c14.7065%2c4.0165%2c4.06971%2c9.08671%2c6.82929%2c14.6226%2c6.82929h7.64046v9.92238h-64.9804v-9.92238h7.67448c5.53561%2c0%2c10.593-2.75991%2c14.6053-6.82929%2c3.98184-4.03827%2c6.93371-9.38379%2c8.33374-14.7065%2c0.003-0.007%2c0.0151-0.01%2c0.017-0.0168%2c0.006-0.012%2c0.0575-0.12228%2c0.32096-0.28758%2c0.2786-0.1743%2c0.75458-0.35499%2c1.53837-0.35499z'/%3e%3cpath fill='%23ede71f' d='m499.263%2c297.53c-0.0864%2c0.0162-0.16714%2c0.0347-0.24243%2c0.0546-0.004%2c0.001-0.0128-0.001-0.0176%2c0-0.24288%2c0.0665-0.43572%2c0.15144-0.5715%2c0.23636-0.26398%2c0.16499-0.31454%2c0.27385-0.32103%2c0.28575-0.002%2c0.006-0.016%2c0.0111-0.0176%2c0.0176-0.17526%2c0.66535-0.37034%2c1.333-0.59266%2c1.99672-0.11089%2c0.33159-0.23352%2c0.66433-0.35631%2c0.99484-0.36838%2c0.99044-0.782%2c1.97606-1.24883%2c2.94216-0.31158%2c0.64425-0.64567%2c1.26802-0.99836%2c1.89442-0.88173%2c1.56653-1.89108%2c3.07628-3.0092%2c4.47675-0.67076%2c0.84061-1.38428%2c1.64511-2.13077%2c2.40242-2.80963%2c2.85016-6.12791%2c5.04991-9.76842%2c6.11716%2c2.76473%2c0.61504%2c4.03154-0.056%2c6.54853-0.45356%2c1.95224-0.30779%2c4.21092-0.5631%2c6.04308-1.21708%2c1.3637-1.89434%2c0.89896-1.29988%2c1.44639-2.85397%2c1.18086-2.21836%2c2.90542-4.22182%2c3.33375-6.68161%2c1.61858-3.02147%2c1.90301-8.6137%2c1.90304-10.2126z'/%3e%3cpath d='m499.275%2c298.902c-0.41166%2c6.03407-2.27681%2c13.1917-6.6438%2c17.8107-1.60658%2c1.33664-3.65998%2c2.54995-5.64577%2c2.2546%2c6.77038-5.51045%2c10.8848-13.9468%2c12.2896-20.0653z'/%3e%3cpath fill='%239ecb34' d='m493.832%2c309.281c-1.00204%2c2.72139-4.78809%2c6.74682-8.84021%2c10.0453-1.15033%2c0.035-1.75951%2c0.10077-2.80424%2c0.0375%2c2.46787-0.2253%2c8.22237-5.08266%2c11.6444-10.0828z'/%3e%3cpath fill='%23ede71f' d='m500.951%2c297.584c0.004%2c0.001%2c0.0128-0.001%2c0.0176%2c0%2c0.24288%2c0.0665%2c0.43572%2c0.15144%2c0.5715%2c0.23636%2c0.26398%2c0.16499%2c0.31454%2c0.27385%2c0.32103%2c0.28575%2c0.002%2c0.006%2c0.016%2c0.0111%2c0.0176%2c0.0176%2c0.17526%2c0.66535%2c0.37034%2c1.333%2c0.59266%2c1.99672%2c0.11089%2c0.33159%2c0.23352%2c0.66433%2c0.35631%2c0.99484%2c0.36838%2c0.99044%2c0.782%2c1.97606%2c1.24883%2c2.94216%2c0.31158%2c0.64425%2c0.64567%2c1.26802%2c0.99836%2c1.89442%2c0.88173%2c1.56653%2c1.89108%2c3.07628%2c3.0092%2c4.47675%2c0.67076%2c0.84061%2c1.38428%2c1.64511%2c2.13077%2c2.40242%2c2.80963%2c2.85016%2c6.12791%2c5.44502%2c9.76842%2c6.51227-7.24491%2c0.0274-10.3888-0.63-13.022-4.01661-2.63318-3.38661-3.60599-4.86816-4.1405-6.93644-0.53451-2.06829-2.02539-6.57045-1.86986-10.8063z'/%3e%3cpath d='m501.476%2c298.902c0.41166%2c6.03407%2c2.2209%2c12.0063%2c6.58735%2c16.6253%2c1.60659%2c1.33664%2c3.65999%2c2.54994%2c5.64577%2c2.2546-7.33482-5.00192-10.8288-12.7615-12.2331-18.8799z'/%3e%3c/g%3e%3cg id='mountain4'%3e%3cpath fill='url(%23mountain)' d='m484.749%2c297.043c-1.70911%2c0-2.24833%2c0.86208-2.24833%2c0.86208-2.52242%2c9.74649-11.825%2c22.3182-21.4962%2c23.8113l-4.78983%2c8.28981h49.0144v-11.3486c-8.82472-2.37071-15.8893-11.6292-18.2484-20.7525-0.00034%2c0-0.52284-0.86208-2.23164-0.86208z'/%3e%3cpath fill='%2397c924' d='m484.749%2c297.465c-0.7841%2c0-1.25495%2c0.19644-1.53836%2c0.372-0.26864%2c0.16626-0.33123%2c0.25869-0.33797%2c0.27057-0.00033%2c0-0.017%2c0.0168-0.017%2c0.0168-1.40164%2c5.32275-4.67746%2c10.7045-8.07974%2c14.9888-3.40228%2c4.28421-9.71968%2c8.61825-14.0417%2c9.07638l-4.28272%2c7.39371h48.0605v-10.6937c-3.55405-1.09062-6.79917-3.26637-9.5523-6.05864-3.98183-4.03827-6.93371-9.38379-8.33374-14.7065-0.002-0.007-0.0154-0.01-0.017-0.0168-0.006-0.012-0.0578-0.12228-0.32128-0.28758-0.27891-0.1743-0.7549-0.35499-1.53868-0.35499z'/%3e%3cpath fill='%2393bc30' d='m483.445%2c298.903c-0.61721%2c9.04327-5.65334%2c20.4536-11.3402%2c22.4194-1.85433%2c0.64154-5.09834%2c0.86441-6.22727%2c1.00883%2c9.94892-4.73151%2c15.8284-15.8536%2c17.5675-23.4282z'/%3e%3cpath fill='%23ede71f' d='m484.746%2c297.465c-0.14713%2c0-0.27966%2c0.0211-0.4057%2c0.0341-0.0233%2c3.01731%2c0%2c8.10909%2c0%2c10.8013%2c0.0292%2c2.34006%2c0.83088%2c4.2225%2c2.01175%2c6.44085%2c0.0687%2c0.1942%2c0.13577%2c0.35377%2c0.20285%2c0.49009%2c0.41003%2c1.08564%2c0.7135%2c1.46267%2c2.28222%2c2.6538%2c4.9869%2c3.78651%2c11.1698%2c4.35287%2c14.8082%2c4.04021-1.13975-0.89849-2.35794-1.71529-3.4317-2.46772%2c1.71152-0.0552%2c3.3511-0.24883%2c4.51358-0.5074-3.64051-1.06725-6.96079-3.26938-9.77042-6.11954-0.48955-0.49658-0.94501-1.02182-1.40319-1.55518-0.20826-0.29156-0.50091-0.69725-0.59178-0.81139-1.11812-1.40047-2.26275-2.94699-3.14448-4.51352-0.35269-0.6264-0.6859-1.24901-0.99748-1.89326-0.46683-0.9661-0.88282-1.95059-1.25119-2.94104-0.1228-0.3305-0.24397-0.66588-0.35486-0.99747-0.22232-0.66372-0.41652-1.32961-0.59178-1.99495-0.002-0.006-0.0152-0.0103-0.0168-0.0168-0.006-0.0119-0.0573-0.12225-0.32132-0.28724-0.13578-0.0849-0.3316-0.17039-0.57502-0.23692-0.005-0.001-0.0124%2c0.001-0.0168%2c0-0.25153-0.0665-0.55446-0.11793-0.9461-0.11793z'/%3e%3cpath d='m485.446%2c298.902c0.41166%2c6.03407%2c2.27735%2c13.1917%2c6.6438%2c17.8107%2c1.60658%2c1.33664%2c3.65998%2c2.54995%2c5.64577%2c2.2546-6.77038-5.50991-10.8853-13.9468-12.2896-20.0653z'/%3e%3cpath fill='%239ecb34' d='m489.613%2c307.247c2.36901%2c5.83689%2c8.37001%2c11.2893%2c14.5434%2c14.9536%2c1.15032%2c0.035%2c1.49118%2c0.003%2c2.53623-0.06-4.41834-2.3709-11.5382-5.75379-17.0796-14.8936z'/%3e%3c/g%3e%3cuse xlink:href='%23mountain4' x='-15.429624' fill='%23c6cb24'/%3e%3c/g%3e%3cg id='seaf'%3e%3cpath fill='white' d='m556.5%2c324.692c-0.57438%2c0.20274-4.4212-0.18918-6.43291-0.0441l-1.27942%2c0.33561c-1.12352-0.008-2.2382%2c0.0249-3.33025%2c0-3.60215%2c0-6.64947%2c0.94833-10.0754%2c0.94896-3.43268%2c0-6.47005-0.94896-10.0754-0.94896-1.11911-0.008-2.23365%2c0.025-3.33025%2c0-3.6015%2c0-6.64626%2c0.94896-10.0754%2c0.94896-3.42915%2c0-6.47326-0.94896-10.0754-0.94896-1.13086-0.007-2.24155%2c0.0238-3.34789%2c0-3.60182%2c0-6.63215%2c0.94896-10.0578%2c0.94896-3.42883%2c0-6.45594-0.94896-10.0578-0.94896-0.26736%2c0-0.51646%2c0.009-0.77612%2c0.0177-0.17781-0.004-0.37669-0.0177-0.55739-0.0177-0.11972%2c0-0.22152-0.003-0.33867%2c0-0.11714-0.003-0.23659%2c0-0.35631%2c0-0.18069%2c0-0.3443%2c0.0138-0.52212%2c0.0177-0.25964-0.008-0.51195-0.0177-0.77963-0.0177-3.60535%2c0-6.64241%2c0.94929-10.0754%2c0.94896-3.42914%2c0-6.47358-0.94896-10.0754-0.94896-0.2619%2c0-0.52159%2c0.01-0.77611%2c0.0177-0.1807-0.004-0.33885-0.0177-0.52212-0.0177-0.12421%2c0-0.25198-0.003-0.37394%2c0-0.11715-0.003-0.23659%2c0-0.35631%2c0-0.1807%2c0-0.36162%2c0.0138-0.53975%2c0.0177-0.25902-0.008-0.50844-0.0177-0.77612-0.0177-2.87883%2c0-6.21806%2c0.60744-8.93592%2c0.8502l-6.27243%2c10.8584%2c62.9712-0.007%2c64.3753%2c0.007z'/%3e%3cpath fill='url(%23seafgrad)' d='m547.993%2c323.111c-0.19914%2c0-0.3979%2c0-0.5962%2c0.007-3.24025%2c0.0945-5.56407%2c1.1148-11.2007%2c1.1148-5.63662%2c0-6.21814-1.01862-12.5836-0.87843-5.9467%2c0.13098-8.44224%2c1.2612-11.6699%2c1.21707-3.22765-0.0441-8.47272-0.69756-12.5095-0.27513-4.03677%2c0.4224-8.8283%2c1.28394-11.9733%2c1.29114-3.90833-0.0174-7.81956-0.73101-11.9062-0.32454-4.08669%2c0.40647-5.99703%2c1.49994-11.0631%2c1.48518-4.35525-0.0126-9.08294-0.69768-12.7459-0.69498-3.43476%2c0.003-7.26655%2c0.95724-10.0859%2c1.44288l-0.84314%2c1.46403c2.24704-0.26058%2c8.55148-1.21821%2c10.802-1.27707%2c2.34423-0.0613%2c10.717%2c0.48306%2c15.3352%2c0.32457%2c4.61831-0.15849%2c5.15872-1.17123%2c10.6186-1.17123%2c3.80095%2c0%2c6.66602%2c0.39864%2c10.5657%2c0.39864%2c2.43414%2c0%2c4.64322-1.24179%2c8.34319-1.24179%2c0.93595-0.0267%2c1.86447-0.0608%2c2.794-0.0914%2c3.11857-0.51522%2c8.38344%2c0.0449%2c12.0474%2c0.23274%2c3.31532%2c0.17289%2c5.45733-0.61554%2c8.9147-0.73023%2c1.49575-0.0682%2c2.99739-0.0659%2c4.47322-0.1483%2c3.46061-0.11481%2c6.42225%2c0.64053%2c9.68022%2c0.62442%2c3.24998-0.20046%2c6.40346-0.9225%2c9.86013-1.03716%2c1.51123-0.0717%2c2.99793-0.0723%2c4.49087-0.1482%2c2.28616-0.0758%2c5.83581%2c0.0784%2c8.27264%2c0.50094l-0.83962-1.4499c-2.37954-0.0756-5.31192-0.63528-8.18091-0.63501z'/%3e%3cg id='wavesf3'%3e%3cpath id='wavef1' fill='url(%23seafgrad)' d='m450.312%2c334.748c-3.4571%2c0-6.40225%2c0.85314-9.65206%2c0.94542-1.21068-0.0338-2.36647-0.18372-3.53485-0.34572l-0.49037%2c0.8502c0.48641%2c0.0323%2c0.97518%2c0.0635%2c1.48873%2c0.0635%2c1.50121%2c0.0181%2c2.99033-0.0362%2c4.47333%2c0%2c3.4571%2c0%2c6.38201-0.85251%2c9.63442-0.94545%2c3.25403%2c0.0923%2c6.20548%2c0.94545%2c9.66617%2c0.94545%2c1.5011%2c0.0185%2c2.99216-0.0362%2c4.47329%2c0%2c3.45743%2c0%2c6.41213-0.85317%2c9.66616-0.94545%2c3.25601%2c0.0923%2c6.23024%2c0.94545%2c9.68735%2c0.94545%2c1.49515%2c0.018%2c2.99325-0.0361%2c4.46979%2c0%2c3.45745%2c0%2c6.40128-0.85317%2c9.65206-0.94545%2c3.25339%2c0.0923%2c6.19143%2c0.94545%2c9.64853%2c0.94545%2c1.51281%2c0.0184%2c2.99932-0.0362%2c4.49089%2c0%2c3.45713%2c0%2c6.41051-0.85317%2c9.66617-0.94545%2c3.25762%2c0.0917%2c6.21%2c0.94545%2c9.66971%2c0.94545%2c1.49537%2c0.018%2c2.99209-0.0361%2c4.46978%2c0%2c3.45709%2c0%2c6.40095-0.85317%2c9.65206-0.94545%2c3.25303%2c0.0923%2c6.20903%2c0.94545%2c9.66616%2c0.94545%2c1.49931%2c0.0181%2c2.99554-0.0361%2c4.47325%2c0%2c0.60565%2c0%2c1.19636-0.0342%2c1.77801-0.0776l-0.46213-0.79728c-1.06409%2c0.14412-2.13376%2c0.27615-3.235%2c0.3069-3.25439-0.0923-6.19497-0.94542-9.65207-0.94542-1.51059-0.0196-2.99775%2c0.0292-4.49089%2c0-3.4571%2c0-6.39678%2c0.85314-9.64853%2c0.94542-3.25694-0.0916-6.2058-0.94542-9.66617-0.94542-1.49604-0.0198-2.99286%2c0.0297-4.47325%2c0-3.45713%2c0-6.41243%2c0.85314-9.66617%2c0.94542-3.25435-0.0923-6.20904-0.94542-9.66617-0.94542-1.50326-0.0196-3.00351%2c0.0292-4.4909%2c0-3.45712%2c0-6.39874%2c0.85314-9.64852%2c0.94542-3.25406-0.0923-6.19497-0.94542-9.65206-0.94542-1.5058-0.02-2.98967%2c0.0296-4.47325%2c0-3.46037%2c0-6.40921%2c0.8538-9.66618%2c0.94542-3.25436-0.0923-6.20873-0.94542-9.66617-0.94542-1.50222-0.0201-3.00578%2c0.0298-4.49089%2c0z'/%3e%3cuse xlink:href='%23wavef1' y='-1.2894435'/%3e%3cuse xlink:href='%23wavef1' y='-2.5745998'/%3e%3c/g%3e%3cuse xlink:href='%23wavesf3' y='-3.8671875'/%3e%3cuse xlink:href='%23wavesf3' y='-7.7286534'/%3e%3c/g%3e%3cpath fill='%2397c924' d='m443.846%2c324.705-2.42711%2c4.191c2.83897-0.47073%2c7.10222-1.70307%2c10.6345-1.70568%2c3.66291-0.003%2c8.08192%2c0.90279%2c12.4372%2c0.91545%2c5.06609%2c0.0147%2c6.97643-1.07871%2c11.0631-1.48521%2c4.08668-0.40644%2c7.99791%2c0.52761%2c11.9062%2c0.54507%2c3.14498-0.007%2c7.93651-1.08924%2c11.9733-1.51167%2c4.03678-0.42243%2c7.73721%2c0.29346%2c12.603%2c0.3687%2c4.86583%2c0.0753%2c5.62964-1.17963%2c11.5763-1.31061%2c6.36544-0.14022%2c6.94696%2c0.8784%2c12.5836%2c0.8784%2c4.24149%2c0.22824%2c7.88284-0.8541%2c11.6664-1.12182%2c3.78351-0.26772%2c5.53834%2c0.043%2c8.3044%2c0.10938l-1.83798-3.25263c-0.0306%2c0-0.0608%2c0.003-0.0917%2c0.004l-101.246%2c2.2256z'/%3e%3cpath fill='white' d='m550.067%2c324.648s2.71009%2c0.1485%2c3.84748%2c0.27558c1.13739%2c0.12711%2c2.95452%2c0.25356%2c2.95452%2c0.25356l-0.36909-0.48504c-0.57438%2c0.20274-4.4212-0.18918-6.43291-0.0441z'/%3e%3c/g%3e%3cpath fill='%23c8a400' d='m500%2c224.874 -32.1418%2c55.6856 -32.8579%2c56.8991 64.2977%2c-0.007 65.7018%2c0.007 -32.153%2c-55.683 -32.847%2c-56.902zm0%2c3.00212 31.5491%2c54.652 30.8506%2c53.4278 -63.1018%2c-0.004 -61.7012%2c0.004 31.5597%2c-54.6448z'/%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3crect width='450' height='300' fill='%23009543'/%3e%3crect width='450' height='210' fill='white'/%3e%3crect width='450' height='90' fill='%2300209f'/%3e%3cg fill='white'%3e%3cpath fill='black' stroke='black' d='m224.76%2c95.569c-1.7098%2c0.03684-3.3781%2c1.9308-3.3781%2c1.9308l0.14732%2c20.233-6.3878%2c6.692h5.1711l-0.0437%2c11.603-30.591%2c41.193-4.5222-1.563-7.9041%2c16.861s19.55%2c12.242%2c47.925%2c11.907c31.144-0.37035%2c48.064-12.471%2c48.064-12.471l-8.1677-16.644-3.9996%2c1.7393-30.983-40.979-0.0437-11.949h5.1711l-7.0378-6.6088%2c0.0416-20.159s-1.7514-1.8203-3.4613-1.7835z'/%3e%3cpath fill='none' stroke='black' stroke-width='5' d='m235.43%2c144.01-21.153%2c0s-7.6776-16.176-6.4331-27.485c1.2672-11.515%2c7.8483-16.963%2c16.598-17.059%2c10.345-0.11526%2c15.767%2c5.0691%2c17.405%2c16.598%2c1.6231%2c11.424-6.4172%2c27.947-6.4172%2c27.947z'/%3e%3cpath d='m187.79%2c182.57c-0.3458%2c0.46106-2.8816%2c5.5326-2.8816%2c5.5326l4.38-0.92211-1.4984-4.6105z'/%3e%3cpath d='m190.32%2c189.14-4.6105%2c1.4984%2c5.5327%2c2.19-0.92212-3.6884z'/%3e%3cpath d='m192.4%2c182.68%2c2.3053%2c6.8006%2c5.6479-1.6137-1.4984-3.2274-6.4548-1.9595z'/%3e%3cpath d='m195.97%2c191.91%2c0.80685%2c2.7663%2c7.4921%2c1.8442-2.9968-6.3395-5.3021%2c1.729z'/%3e%3cpath d='m204.27%2c186.14%2c2.6511%2c6.3395%2c5.6479-2.19-1.8442-2.7663-6.4548-1.3832z'/%3e%3cpath d='m207.96%2c194.79%2c0.92211%2c2.4205%2c8.76%2c1.2679-3.6884-5.7632-5.9937%2c2.0747z'/%3e%3cpath d='m216.37%2c187.99%2c3.2274%2c5.6479%2c8.1837-2.9969-0.9221-2.19-10.489-0.46106z'/%3e%3cpath d='m221.1%2c195.71%2c1.729%2c2.9969%2c10.143-0.3458-3.8037-5.6479-8.0684%2c2.9968z'/%3e%3cpath d='m231.82%2c188.22%2c2.7663%2c4.7258%2c6.4548-3.1121-1.729-2.5358-7.4921%2c0.92212z'/%3e%3cpath d='m242.42%2c191.79-6.4548%2c3.2274%2c1.729%2c2.7663%2c8.6448-1.3832-3.919-4.6106z'/%3e%3cpath d='m244.5%2c186.83%2c3.3426%2c4.1495%2c5.4174-4.2648-1.8442-1.9595-6.9158%2c2.0748z'/%3e%3cpath d='m254.41%2c189.02-5.1869%2c3.919%2c1.3832%2c2.4205%2c7.1464-1.8442-3.3426-4.4953z'/%3e%3cpath d='m261.56%2c180.84%2c1.2679%2c1.8442-3.5732%2c5.3021-3.6884-4.7258%2c5.9937-2.4205z'/%3e%3cpath d='m263.98%2c185.45%2c2.19%2c4.38-4.38%2c1.4984-0.34579-2.0748%2c2.5358-3.8037z'/%3e%3c/g%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3crect fill='%230072C6' width='450' height='300'/%3e%3crect fill='white' width='450' height='200'/%3e%3crect fill='%231EB53A' width='450' height='100'/%3e%3c/svg%3e";

var img$e = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%233e5eb9' d='M0 0h900v600H0z'/%3e%3cpath fill='%23ffd900' d='M0 112.5h900v375H0z'/%3e%3cpath fill='%23b10c0c' d='M0 150h900v300H0z'/%3e%3cg transform='scale(1.5)' fill='%23ffd900' stroke='black' stroke-width='1.008'%3e%3cg id='a'%3e%3cpath d='M492.85 154.28l-24.285 8.571 24.285 8.571 24.285-8.571z' fill='white'/%3e%3crect width='357.13' height='5.714' x='122.85' y='160' rx='3.106' ry='2.857'/%3e%3cpath d='M471.44 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857m-2.861 5.714c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857m-2.861 5.714c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3e%3c/g%3e%3cuse xlink:href='%23a' x='-23.27' y='17.15' width='100%25' height='100%25'/%3e%3crect width='485.7' height='8.571' x='59.812' y='195.72' rx='4.224' ry='4.286' stroke-width='1.08'/%3e%3c/g%3e%3cpath d='M664.275 300c-42.856 42.853-100.002 128.566-214.29 128.566-100.002 0-171.42-85.712-214.29-128.566 42.857-42.861 114.282-128.574 214.29-128.574 114.282 0 171.42 85.713 214.29 128.574z' fill='white' stroke='black' stroke-width='1.512'/%3e%3cpath d='M435.03 216.15c11.402 12.823 1.881 17.994 13.95 18.835 12.727.935 5.512 13.551 16.218 13.99 7.485.327-.747 30.226 6.457 40.093 7.34 10.286 13.487 3.014 13.616 10.444.127 7.686-19.976 6.911-20.328 30.585-.59 13.644-16.965 14.517-17.747 23.297-.972 8.257 32.261 12.892 31.817 20.284-.456 7.37-35.883 6.216-37.425 14.621-.79 7.55 48.669 13.737 52.647 35.57-7.38 2.413-28.379 4.685-44.249 4.697-99.985.072-171.42-85.72-214.275-128.574 42.857-42.86 114.282-128.574 214.29-128.574 0 0-29.683 27.123-14.956 44.723z'/%3e%3cg transform='scale(1.5)' stroke='white'%3e%3cg id='d' stroke-width='6.927'%3e%3cg id='c'%3e%3cpath id='b' d='M213.933 192.377V169.52m13.85 0v22.857m13.86-22.857v22.857'/%3e%3cuse xlink:href='%23b' y='38.1' width='100%25' height='100%25'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='41.56' width='100%25' height='100%25'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23d' x='104.76' width='100%25' height='100%25' transform='scale(1.5)' stroke='black'/%3e%3cg fill='%23a70000'%3e%3cpath d='M767.025 294.9c-6.492 11.244 4.982-3.74 32.978 15.084 5.188 3.497 9.721 12.734 9.721 19.139-1.317-.881-2.295-2.841-3.745-4.115-2.031 2.035 1.939 11.366 2.52 15.775-4.377-2.449-3.956-3.609-5.41-6.619.29 3.639-.751 13.66.99 17.52-3.45-.986-3.22-3.762-5.021-4.32 1.225 4.368-1.068 9.122-.46 14.033-2.015-1.995-4.163-3.558-5.1-4.364-.157 2.338-3.877 8.484-3.961 10.695-1.71-1.033-2.175-2.644-2.46-3.729-2.126 2.671-9.681 12.537-10.165 15.546-5.822-5.142-20.735-17.663-22.676-24.309-1.716 3.772-4.2 5.046-9.11 7.8-1.939-10.533-9.194-22.372-5.314-31.401-2.75 1.63-5.013 3.261-7.761 5.267 2.604-15.255 15.88-33.143 34.979-42.002z' fill='%233d5da7' stroke='black' stroke-width='1.282'/%3e%3cpath d='M742.815 350.58c2.695-5.388 5.178-7.096 6.92-10.566 3.076-6.098 3.515-10.949 6.196-10.238 2.68.711 2.677 3.209-.795 9.204-3.473 5.996-5.124 7.277-12.321 11.6zm18.225 12.84c-.347-4.103.843-5.816.627-8.457-.37-4.649-2.271-7.839.201-8.066 2.472-.226 3.627 1.36 3.634 6.044.008 4.685-.717 5.915-4.46 10.48zm13.83 8.04c-1.08-5.727-.271-8.267-.963-11.957-1.203-6.492-3.583-10.765-1.293-11.359 2.29-.594 3.674 1.506 4.54 8.09.868 6.583.41 8.392-2.284 15.226zm14.385-40.125c-3.378-2.564-5.349-2.736-7.527-4.383-3.837-2.89-5.778-5.985-7.013-4.449-1.234 1.536-.358 3.216 3.663 5.883 4.02 2.667 5.382 2.877 10.878 2.949zm-2.385 19.005c-1.78-3.697-3.654-4.635-4.806-7.014-2.035-4.18-2.038-7.797-4.246-6.87-2.208.927-2.385 2.82-.024 6.867 2.36 4.046 3.597 4.779 9.076 7.017z'/%3e%3cpath d='M121.174 305.73c-.363-3.274.338-3.666-1.677-6.135 2.933 1.227 3.044 4.488 6.61 2.174 1.309-.678 1.88-.7.289-4.337 3.718.173 15.894 4.348 17.844 4.444 5.12.236 14.466-5.378 20.953 1.525 6.227 6.294 4.148 12.826 4.148 21.543-2.502-1.199-1.296-1.79-3.951-4.907 1.99 7.619-.106 21.356-.106 29.436-1.022-1.948-.872-1.103-1.871-3.12-2.655 7.375-5.837 8.893-5.837 17.61-.958-3.418-.033-2.696-1.099-4.494-2.58 5.6-19.89 10.385-13.22 16.029-6.02-3.53-8.66-3.159-11.39-6.334-1.177.759-2.111 2.196-3.205 4.165-10.585-4.87-6.8-15.375-15.093-22.392-1.435 2.942-.781 2.516-2.332 7.304-1.679-6.651-2.138-10.877-4.026-15.767-1.629 2.71-1.484 1.671-4.442 5.768-1.224-8.102-3.216-10.014-2.428-15.375-3.144 2.218-1.086 1.32-4.229 4.05 2.978-20.76 15.837-36.101 25.065-31.188z' fill='%233d5da7' stroke='black' stroke-width='1.6'/%3e%3cpath d='M108.151 339.615c2.728-6.684 5.186-8.783 6.949-13.086 3.112-7.563 3.619-13.61 6.233-12.687 2.615.922 2.573 4.037-.925 11.467-3.498 7.433-5.135 9.008-12.257 14.304zm10.326 16.725c1.094-5.992 2.819-8.175 3.528-12.034 1.259-6.786.557-11.84 2.987-11.573 2.43.266 2.979 2.828 1.362 9.578-1.617 6.751-2.733 8.349-7.878 14.029zm12.351 11.625c.308-5.81 1.67-8.077 1.874-11.82.369-6.582-.898-11.293 1.419-11.32 2.317-.027 3.143 2.34 2.433 8.929-.71 6.59-1.567 8.234-5.726 14.211zm26.522-37.995c-5.071-5.052-8.137-5.996-11.409-9.245-5.763-5.706-8.547-11.064-10.599-9.165-2.052 1.9-.817 4.746 5.25 10.176 6.068 5.43 8.178 6.222 16.758 8.234zm-3.09 19.53c-3.303-5.073-5.727-6.387-7.86-9.651-3.76-5.736-5.054-10.665-7.185-9.444-2.133 1.221-1.656 3.796 2.42 9.357 4.075 5.559 5.714 6.582 12.625 9.74z'/%3e%3cpath d='M380.7 194.25c-5.937 11.482 10.395-3.819 35.997 15.404 4.745 3.571 11.546 17.68 11.546 24.22-5.451-1.16-15.104-6.54-15.104-6.54s11.328 11.346 11.328 24.426c-4.002-2.502-6.004-2.127-7.335-5.199 0 4.234 3.56 6.933 3.56 13.473a52.938 52.938 0 00-7.78-5.19c3.776 6.54-6.88 19.227-1.547 23.462-9.327-1.349-18.87-7.308-22.646-13.848-2.001 1.348-2.218 3.466-2.296 5.723.294.245-14.198-10.756-12.866-14.982-1.944 2.727-2.217 4.226-2.661 7.3-5.323-5.25-10.203-10.5-11.979-17.288-2.365 3.073-2.514 3.073-4.88 6.147-1.774-10.757-1.774-10.373 1.775-19.592-2.514 1.665-4.584 3.33-7.098 5.38 2.38-15.578 14.523-33.845 31.988-42.892z' fill='%233d5da7' stroke='black' stroke-width='1.239'/%3e%3cpath d='M366.06 250.35c.95-7.912 3.018-10.893 3.636-15.988 1.103-8.961-.206-15.512 2.97-15.345 3.176.165 4.09 3.47 2.52 12.414-1.569 8.941-2.893 11.113-9.126 18.92zm16.575 14.49c-.643-6.675.59-9.517.18-13.818-.705-7.566-3.042-12.691-.274-13.162 2.767-.471 4.167 2.067 4.465 9.706.299 7.64-.441 9.675-4.372 17.274zm25.875 11.82c-2.814-5.777-5.232-7.499-7.048-11.217-3.209-6.534-3.88-11.87-6.354-10.904-2.475.968-2.339 3.728 1.236 10.124 3.574 6.396 5.19 7.701 12.166 11.997zm8.955-51.735c-7.167-3.773-10.848-3.82-15.466-6.245-8.133-4.25-12.867-9.052-14.547-6.409-1.682 2.643.562 5.271 8.947 9.135s10.96 4.047 21.067 3.519zm2.625 21.615c-5.218-4.341-8.304-4.98-11.67-7.773-5.93-4.9-8.88-9.714-10.861-7.762-1.98 1.951-.657 4.528 5.566 9.145 6.224 4.617 8.352 5.19 16.965 6.39z'/%3e%3c/g%3e%3c/svg%3e";

var img$d = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 209 110'%3e%3crect fill='%23bf0a30' width='209' height='110'/%3e%3cpath d='M0%2c15H209 M0%2c35H209 M0%2c55H209 M0%2c75H209 M0%2c95H209' stroke='white' stroke-width='10'/%3e%3crect fill='%23002868' width='50' height='50'/%3e%3cg transform='translate(25%2c25) scale(15)'%3e%3cg id='B'%3e%3cpolygon id='A' fill='white' points='0%2c0 0%2c1 .5%2c1' transform='translate(0%2c-1) rotate(18)'/%3e%3cuse xlink:href='%23A' transform='scale(-1%2c1)'/%3e%3c/g%3e%3cuse xlink:href='%23B' transform='rotate(72)'/%3e%3cuse xlink:href='%23B' transform='rotate(-72)'/%3e%3cuse xlink:href='%23B' transform='rotate(144)'/%3e%3cuse xlink:href='%23B' transform='rotate(-144)'/%3e%3c/g%3e%3c/svg%3e";

var img$c = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 450'%3e%3cpath d='M0%2c450H900V0H0z' fill='%23d62828'/%3e%3cpath d='M0%2c450V0H600z' fill='%23fcd856'/%3e%3cpath d='M0%2c450V0H300z' fill='%23003f87'/%3e%3cpath d='M0%2c450H900V150z' fill='white'/%3e%3cpath d='M0%2c450H900V300z' fill='%23007a3d'/%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-225 -114 450 300'%3e%3ctitle%3eFlag of Malawi%3c/title%3e%3crect x='-225' y='-114' width='450' height='300'/%3e%3cg fill='%23CE1126'%3e%3ccircle r='64.5'/%3e%3crect x='-225' y='-14' width='450' height='100'/%3e%3cg id='r16'%3e%3cg id='r8'%3e%3cg id='r4'%3e%3cg id='r2'%3e%3cpath id='r' d='M0-102c-2.2%2c0-3%2c3.3-3%2c6.5 0%2c8 1%2c12 3%2c23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5'/%3e%3cuse transform='rotate(5)' xlink:href='%23r'/%3e%3c/g%3e%3cuse transform='rotate(10)' xlink:href='%23r2'/%3e%3c/g%3e%3cuse transform='rotate(20)' xlink:href='%23r4'/%3e%3c/g%3e%3cuse transform='rotate(40)' xlink:href='%23r8'/%3e%3c/g%3e%3cuse transform='rotate(-80)' xlink:href='%23r16'/%3e%3c/g%3e%3crect x='-225' y='-21.5' width='450' height='7.5'/%3e%3crect x='-225' y='86' width='450' height='100' fill='%23339E35'/%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 4'%3e%3crect fill='%2300A551' width='6' height='4'/%3e%3crect fill='%23FFD500' width='6' height='3'/%3e%3crect fill='%231A206D' width='6' height='2'/%3e%3crect fill='%23EA2839' width='6' height='1'/%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3e%3ctitle%3eFlag of The Gambia%3c/title%3e%3cpath d='m0%2c0h27v18H0' fill='%233A7728'/%3e%3cpath d='m0%2c0h27v11H0' fill='%230C1C8C'/%3e%3cpath d='m0%2c0h27v6H0' fill='%23CE1126'/%3e%3cpath d='m0%2c6.5h27m0%2c5H0' stroke='white'/%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 72 36'%3e%3crect width='72' height='36' style='fill:%230073cf'/%3e%3crect width='72' height='12' y='12' style='fill:white'/%3e%3cg id='star' transform='translate(36%2c18) scale(2)' fill='%230073cf'%3e%3cg id='cone'%3e%3cpolygon id='triangle' points='0%2c0 0%2c1 .5%2c1' transform='translate(0%2c-1) rotate(18)'/%3e%3cuse xlink:href='%23triangle' transform='scale(-1%2c1)' id='use12'/%3e%3c/g%3e%3cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3e%3cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3e%3cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3e%3cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3e%3c/g%3e%3cuse xlink:href='%23star' transform='translate(10%2c-3.2)'/%3e%3cuse xlink:href='%23star' transform='translate(10%2c2.8)'/%3e%3cuse xlink:href='%23star' transform='translate(-10%2c-3.2)'/%3e%3cuse xlink:href='%23star' transform='translate(-10%2c2.8)'/%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 30 20'%3e%3cdefs%3e%3cpath id='s' d='M0%2c-1 0.587785%2c0.809017 -0.951057%2c-0.309017H0.951057L-0.587785%2c0.809017z' fill='%23ffde00'/%3e%3c/defs%3e%3crect width='30' height='20' fill='%23de2910'/%3e%3cuse xlink:href='%23s' transform='translate(5%2c5) scale(3)'/%3e%3cuse xlink:href='%23s' transform='translate(10%2c2) rotate(23.036243)'/%3e%3cuse xlink:href='%23s' transform='translate(12%2c4) rotate(45.869898)'/%3e%3cuse xlink:href='%23s' transform='translate(12%2c7) rotate(69.945396)'/%3e%3cuse xlink:href='%23s' transform='translate(10%2c9) rotate(20.659808)'/%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 225 150'%3e%3crect width='225' height='150' fill='%23f93'/%3e%3crect width='225' height='50' y='50' fill='white'/%3e%3crect width='225' height='50' y='100' fill='%23128807'/%3e%3cg transform='translate(112.5%2c75)'%3e%3ccircle r='20' fill='%23008'/%3e%3ccircle r='17.5' fill='white'/%3e%3ccircle r='3.5' fill='%23008'/%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='b'%3e%3cg id='a'%3e%3ccircle r='0.875' fill='%23008' transform='rotate(7.5) translate(17.5)'/%3e%3cpath fill='%23008' d='M 0%2c17.5 0.6%2c7 C 0.6%2c7 0%2c2 0%2c2 0%2c2 -0.6%2c7 -0.6%2c7 L 0%2c17.5 z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(15)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(30)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(60)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(120)'/%3e%3cuse xlink:href='%23d' transform='rotate(-120)'/%3e%3c/g%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg viewBox='0 0 600 300' xmlns='http://www.w3.org/2000/svg'%3e%3cg transform='translate(0 -752.36)'%3e%3crect y='752.36' width='200' height='300' fill='%23169b62'/%3e%3crect x='200' y='752.36' width='200' height='300' fill='white'/%3e%3crect x='400' y='752.36' width='200' height='300' fill='%23ff883e'/%3e%3c/g%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3ctitle%3eFlag of Oman%3c/title%3e%3crect width='1200' fill='%23db161b' height='600'/%3e%3crect height='200' width='900' x='300' fill='white'/%3e%3crect height='200' width='900' y='400' x='300' fill='green'/%3e%3cg id='a' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'%3e%3crect rx='3.2154' ry='3.0152' height='21.217' width='38.669' y='102.64' x='65.854' stroke-width='0.28333pt'/%3e%3crect rx='3.0505' ry='2.764' height='19.449' width='36.686' y='103.52' x='66.846' stroke-width='0.26422pt'/%3e%3cpath d='M83.904%2c108.83l1.853%2c0.06%2c0.084%2c0.84%2c1.516%2c0.77%2c1.18-0.96%2c1.431%2c0.77-1.347%2c0.84%2c0.337%2c1.16%2c1.684-0.06v1.55l-1.347-0.07-0.674%2c0.97%2c1.516%2c1.1-1.179%2c0.9-1.264-0.97-1.853%2c0.39%2c0.084%2c1.42-2.021%2c0.13-0.253-1.36-1.684-0.71-0.927%2c0.97-1.432-0.71%2c0.843-1.1-1.011-0.71h-1.432l-0.084-2%2c1.432%2c0.13%2c1.01-1.16-1.179-0.9%2c1.516-1.04%2c1.095%2c0.84%2c1.853-0.25%2c0.253-0.84z' stroke-width='0.16681166pt'/%3e%3cellipse cx='68.944' cy='426.78' rx='11.049' ry='9.9439' transform='matrix(0.1841806%2c0%2c0%2c0.1752043%2c71.76647%2c38.246478)' stroke-width='1pt'/%3e%3cpath d='M71.803%2c104.41l-2.974%2c2.65'/%3e%3cpath d='M73.786%2c104.41l-2.974%2c2.65'/%3e%3cpath d='M75.769%2c104.41l-2.974%2c2.65'/%3e%3cpath d='M77.752%2c104.41l-2.974%2c2.65'/%3e%3cpath d='M79.735%2c104.41l-2.974%2c2.65'/%3e%3cpath d='M81.718%2c104.41l-2.974%2c2.65'/%3e%3cpath d='M83.702%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M85.685%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M87.668%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M89.651%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M91.634%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M93.617%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M85.685%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M95.6%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M97.583%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M99.566%2c104.41l-2.975%2c2.65'/%3e%3cpath d='M101.55%2c104.41l-2.976%2c2.65'/%3e%3cpath d='M98.574%2c104.41l2.976%2c2.65'/%3e%3cpath d='M96.591%2c104.41l2.975%2c2.65'/%3e%3cpath d='M94.608%2c104.41l2.975%2c2.65'/%3e%3cpath d='M92.625%2c104.41l2.975%2c2.65'/%3e%3cpath d='M90.642%2c104.41l2.975%2c2.65'/%3e%3cpath d='M88.659%2c104.41l2.975%2c2.65'/%3e%3cpath d='M86.676%2c104.41l2.975%2c2.65'/%3e%3cpath d='M84.693%2c104.41l2.975%2c2.65'/%3e%3cpath d='M82.71%2c104.41l2.975%2c2.65'/%3e%3cpath d='M80.727%2c104.41l2.975%2c2.65'/%3e%3cpath d='M78.744%2c104.41l2.975%2c2.65'/%3e%3cpath d='M76.761%2c104.41l2.974%2c2.65'/%3e%3cpath d='M84.693%2c104.41l2.975%2c2.65'/%3e%3cpath d='M74.778%2c104.41l2.974%2c2.65'/%3e%3cpath d='M72.795%2c104.41l2.974%2c2.65'/%3e%3cpath d='M70.812%2c104.41l2.974%2c2.65'/%3e%3cpath d='M68.829%2c104.41l2.974%2c2.65'/%3e%3cpath d='M71.803%2c119.43l-2.974%2c2.66'/%3e%3cpath d='M73.786%2c119.43l-2.974%2c2.66'/%3e%3cpath d='M75.769%2c119.43l-2.974%2c2.66'/%3e%3cpath d='M77.752%2c119.43l-2.974%2c2.66'/%3e%3cpath d='M79.735%2c119.43l-2.974%2c2.66'/%3e%3cpath d='M81.718%2c119.43l-2.974%2c2.66'/%3e%3cpath d='M83.702%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M85.685%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M87.668%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M89.651%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M91.634%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M93.617%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M85.685%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M95.6%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M97.583%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M99.566%2c119.43l-2.975%2c2.66'/%3e%3cpath d='M101.55%2c119.43l-2.976%2c2.66'/%3e%3cpath d='M98.574%2c119.43l2.976%2c2.66'/%3e%3cpath d='M96.591%2c119.43l2.975%2c2.66'/%3e%3cpath d='M94.608%2c119.43l2.975%2c2.66'/%3e%3cpath d='M92.625%2c119.43l2.975%2c2.66'/%3e%3cpath d='M90.642%2c119.43l2.975%2c2.66'/%3e%3cpath d='M88.659%2c119.43l2.975%2c2.66'/%3e%3cpath d='M86.676%2c119.43l2.975%2c2.66'/%3e%3cpath d='M84.693%2c119.43l2.975%2c2.66'/%3e%3cpath d='M82.71%2c119.43l2.975%2c2.66'/%3e%3cpath d='M80.727%2c119.43l2.975%2c2.66'/%3e%3cpath d='M78.744%2c119.43l2.975%2c2.66'/%3e%3cpath d='M76.761%2c119.43l2.974%2c2.66'/%3e%3cpath d='M84.693%2c119.43l2.975%2c2.66'/%3e%3cpath d='M74.778%2c119.43l2.974%2c2.66'/%3e%3cpath d='M72.795%2c119.43l2.974%2c2.66'/%3e%3cpath d='M70.812%2c119.43l2.974%2c2.66'/%3e%3cpath d='M68.829%2c119.43l2.974%2c2.66'/%3e%3c/g%3e%3cuse xlink:href='%23a' x='-300' transform='scale(-1%2c1)'/%3e%3cg id='b'%3e%3cpath d='M126.51%2c147.12c-48.114%2c47.05-68.638%2c53-59.006%2c56.79s40.616-20.49%2c72.856-52.75c32.24-32.25%2c51.98-60.956%2c42.35-64.747-9.63-3.792-5.03%2c10.662-56.2%2c60.707z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.42368097pt' fill='white'/%3e%3cpath d='M86.008%2c181.31l16.852%2c4.42c-15.861%2c15.03-33.708%2c21.22-38.665%2c18.57-4.958-2.65%2c8.923-8.84%2c21.813-22.99z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='white'/%3e%3cpath d='M86.008%2c183.08l13.881%2c3.54c-15.453%2c14.45-30.737%2c18.56-34.692%2c16.8-3.977-1.77%2c8.255-6.74%2c20.811-20.34z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028045' fill='white'/%3e%3cpath d='M137.79%2c145.06c-0.04%2c0.23-0.15%2c1.24-0.25%2c1.64%2c0%2c0.56-0.06%2c0.98-0.12%2c1.42-0.16%2c0.38-0.13%2c0.73-0.62%2c0.87-0.33%2c0.46-0.54%2c0.58-0.98%2c0.77-0.3%2c0.23-0.76%2c0.46-1.24%2c0.65-0.49%2c0.19-0.94%2c0.21-1.47%2c0.11-0.44-0.27-0.75-0.54-1.11-0.76-0.09-0.35-0.16-0.86-0.25-1.2%2c0.13%2c0.35%2c0.23%2c0.91%2c0.25%2c1.41-0.05%2c0.55-0.25%2c0.79-0.49%2c1.2' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3e%3cpath d='M133.23%2c152.37c-0.04-0.03-0.08-0.07-0.12-0.11%2c0.29%2c0.26%2c0.17%2c0.14-0.5-0.21-0.47-0.22-0.98-0.34-1.6-0.44h-1.72c-0.67%2c0-1.12%2c0.09-1.6%2c0.22-0.35%2c0.31-0.87%2c0.48-1.23%2c0.76-0.38%2c0.23-0.54%2c0.5-0.74%2c0.87-0.34%2c0.3-0.56%2c0.76-0.87%2c0.99-0.13%2c0.5-0.42%2c0.48-0.61%2c0.87%2c0.58%2c0.04%2c1.05%2c0.11%2c1.35%2c0.43%2c0.52%2c0.24-0.43-0.23-0.61-0.43-0.41-0.11-0.51-0.22-1.11-0.22-0.56-0.16-0.9%2c0.13-1.48%2c0.22-0.33%2c0.17-0.43%2c0.22-0.86%2c0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3e%3cpath d='M126.58%2c157.83c-0.25%2c0.01-1.4%2c0.2-1.85%2c0-0.5-0.12-0.8-0.36-1.11-0.77-0.15-0.29%2c0%2c0.53%2c0%2c0.88-0.05%2c0.64-0.27%2c0.65-0.61%2c1.09-0.36%2c0.2-0.74%2c0.49-1.11%2c0.65-0.31%2c0.24-0.69%2c0.4-1.11%2c0.55-0.37%2c0.15-0.81%2c0.31-1.11%2c0.54-0.41%2c0.26-0.37%2c0.58-0.61%2c0.98%2c0.04%2c0.54%2c0.14%2c0.84%2c0.49%2c1.1%2c0.14%2c0.36%2c0.47%2c0.73%2c0.74%2c0.98%2c0.3%2c0.5%2c0.64%2c0.73-0.13%2c0.87-0.42%2c0.16-0.65%2c0.03-1.1%2c0' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3e%3cpath d='M118.82%2c165.46c-0.3-0.06-1.38-0.38-1.85-0.54h-1.72c-0.67%2c0.04-0.8%2c0.22-1.36%2c0.43-0.36%2c0.33-0.61%2c0.56-1.11%2c0.77-0.26%2c0.3-0.78%2c0.81-0.98%2c1.2-0.15%2c0.37-0.25%2c0.87-0.25%2c1.42%2c0.01%2c0.63%2c0.2%2c0.74%2c0.25%2c1.31%2c0.14%2c0.46%2c0.36%2c0.89%2c0.74%2c1.3%2c0.05%2c0.14%2c0.09%2c0.18%2c0.24%2c0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3e%3cpath d='M112.95%2c173c-0.05%2c0-0.17%2c0.28-0.35%2c0.52-0.39%2c0.4-0.44%2c0.43-1.05%2c0.43-0.54-0.02-0.49-0.21-0.87-0.35-0.18-0.27-0.41-0.49-0.61-0.86-0.14-0.22-0.27-0.57-0.44-0.77-0.16-0.26-0.36-0.45-0.53-0.69-0.16-0.07-0.22-0.14-0.43-0.17%2c0.5%2c0.08%2c0.54%2c0.25%2c0.87%2c0.51%2c0.15%2c0.25%2c0.31%2c0.5%2c0.44%2c0.78%2c0.05%2c0.37%2c0.17%2c0.66%2c0.17%2c1.12%2c0%2c0.47%2c0%2c0.81-0.17%2c1.2-0.21%2c0.22-0.36%2c0.44-0.61%2c0.61-0.21%2c0.19-0.46%2c0.45-0.62%2c0.68-0.27%2c0.17-0.47%2c0.31-0.78%2c0.52-0.27%2c0.15-0.55%2c0.31-0.96%2c0.35-0.52-0.04-0.67-0.18-1.05-0.35-0.33-0.24-0.59-0.39-0.88-0.6-0.23-0.16-0.46-0.47-0.61-0.69-0.47-0.12-0.77-0.07-1.05%2c0.17-0.24%2c0.16-0.45%2c0.37-0.61%2c0.6-0.15%2c0.07-0.38%2c0.28-0.53%2c0.35' stroke='%23db161b' stroke-width='0.33028191' fill='none'/%3e%3cpath d='M103.32%2c176.56c0.14%2c0.06%2c0.64%2c0.41%2c0.87%2c0.54%2c0.14%2c0.45%2c0.36%2c0.7%2c0.43%2c1.18%2c0.12%2c0.47%2c0.11%2c0.98%2c0.11%2c1.51-0.12%2c0.55-0.35%2c0.95-0.54%2c1.39-0.35%2c0.24-0.52%2c0.4-0.98%2c0.65-0.43%2c0.06-0.86%2c0.11-1.41%2c0.11-0.34%2c0.11-0.98%2c0.16-1.31%2c0-0.48-0.07-0.843-0.26-1.194-0.43-0.402-0.23-0.649-0.44-1.088-0.65-0.213-0.31-0.544-0.59-0.869-0.97-0.271-0.36-0.47-0.56-0.653-0.96%2c0.161%2c0.46%2c0.405%2c0.86%2c0.544%2c1.29%2c0.247%2c0.45%2c0.391%2c0.62%2c0.435%2c1.18%2c0.151%2c0.45%2c0.109%2c0.99%2c0.109%2c1.5-0.048%2c0.35-0.073%2c1.01-0.218%2c1.29v0.33' stroke='%23db161b' stroke-width='0.33028162' fill='none'/%3e%3cpath d='M87.242%2c186.23v0.16c0-0.42-0.011-0.21%2c0.175%2c0.62%2c0.33%2c0.37%2c1.104%2c0.47%2c1.749%2c0.31%2c0.566-0.41%2c0.548-0.73%2c1.574-0.93%2c0.991%2c0.06%2c1.369%2c0.32%2c1.924%2c0.62%2c0.658%2c0.29%2c0.962%2c0.44%2c1.399%2c1.09%2c0.217%2c0.53%2c0.338%2c0.89-0.35%2c1.09-0.547%2c0.35-1.197%2c0.54-1.924%2c0.63-0.808%2c0-1.39-0.09-1.749%2c0.31-0.555%2c0.51-0.524%2c0.82-0.524%2c1.71-0.187%2c0.28-0.224%2c1.1-0.35%2c1.41-0.486%2c0.2-0.771%2c0.31-1.574%2c0.31-0.189-0.48-0.398-1.35-0.525-1.87-0.137-0.56-0.179-1.34-0.525-1.72-0.326-0.42-0.743-0.8-1.224-1.09-0.214-0.27-0.622-0.49-1.049-0.62%2c0.686%2c0.31%2c0.784%2c0.65%2c0.874%2c1.4-0.603%2c0.27-0.764%2c0.46-1.749%2c0.47-0.968-0.07-1.202-0.29-1.574-0.78-0.067%2c0.78-0.348%2c1.04-0.524%2c1.72-0.36%2c0.47-0.513%2c0.95-0.875%2c1.55%2c0.154%2c0.76%2c0.486%2c0.79%2c0.525%2c1.72%2c0.227%2c0.61%2c0.202%2c1.19%2c0.699%2c1.56%2c0.222%2c0.24%2c0.388%2c0.29%2c0.875%2c0.31-1.013%2c0-1.603-0.1-2.274-0.47-0.519-0.28-0.911-0.64-1.399-0.93-0.619-0.4-1.384-0.77-2.099-0.94-0.808%2c0-1.39-0.08-1.749%2c0.31-0.495%2c0.32-0.828%2c0.86-1.049%2c1.56-0.162%2c0.81-0.224%2c1.35%2c0.175%2c1.87%2c0.296%2c0.61%2c0.363%2c0.84%2c0%2c1.56-0.407%2c0.51-1.012%2c0.57-1.924%2c0.78-0.666-0.03-1.306-0.16-1.749-0.31' stroke='%23db161b' stroke-width='0.33028123' fill='none'/%3e%3cpath d='M181.41%2c104.66c21.35-36.858%2c35.52-68.222%2c31.62-70.014-3.89-1.791-24.37%2c26.665-45.72%2c63.518l14.1%2c6.496z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33520904pt' fill='white'/%3e%3cpath d='M180%2c104.01c20.59-35.557%2c34.78-65.574%2c31.67-67.007s-22.35%2c26.258-42.95%2c61.81' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.29448283pt' fill='white'/%3e%3cpath d='M176.46%2c85.461c-2.51%2c4.157-5.16%2c8.908-7.74%2c13.352l11.28%2c5.197c2.57-4.448%2c5.38-9.13%2c7.73-13.356l-11.27-5.193z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='white'/%3e%3cpath d='M177.41%2c86.895c-2.5%2c4.157-4.25%2c7.338-6.82%2c11.782l8.45%2c3.893c2.58-4.442%2c4.48-7.554%2c6.83-11.78l-8.46-3.895z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='white'/%3e%3crect transform='matrix(-0.9083207%2c-0.4182743%2c-0.5012544%2c0.8653%2c0%2c0)' height='9.9849' width='6.2072' stroke='%23db161b' y='6.5585' x='-205.69' stroke-width='0.33495pt' fill='white'/%3e%3cpath d='M183.55%2c91.712l-10.64%2c6.043' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='white'/%3e%3cpath d='M178.54%2c100.35l-0.63-11.235' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='white'/%3e%3cpath d='M209.03%2c47.727l-5.64-2.597' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='white'/%3e%3cellipse rx='3.5433' ry='3.5433' stroke='%23db161b' transform='matrix(-0.4490005%2c0.1132067%2c0.1013394%2c0.3938715%2c444.34717%2c-55.797864)' cy='92.126' cx='545.67' stroke-width='1pt' fill='%23db161b'/%3e%3c/g%3e%3cuse xlink:href='%23b' x='-300' transform='scale(-1%2c1)'/%3e%3cpath d='M135.26%2c84.958c0%2c30.942%2c0.18%2c42.602-2.1%2c44.202-2.16%2c1.71-62.348%2c0-62.348%2c8.84s49.578%2c17.68%2c64.448%2c17.68c19.83%2c0%2c29.75-8.84%2c29.75-26.52v-44.202h-29.75z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.30510197pt' fill='white'/%3e%3cpath d='M135.26%2c93.798v4.42c9.92%2c1.474%2c19.83%2c1.474%2c29.75%2c0v-4.42c-9.92%2c1.474-19.83%2c1.474-29.75%2c0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='white'/%3e%3cpath d='M135.26%2c84.958v4.42c9.92%2c1.473%2c19.83%2c1.473%2c29.75%2c0v-4.42c-9.92%2c1.473-19.83%2c1.473-29.75%2c0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='white'/%3e%3cpath d='M135.26%2c89.378v4.42c9.92%2c1.474%2c19.83%2c1.474%2c29.75%2c0v-4.42c-9.92%2c1.473-19.83%2c1.473-29.75%2c0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='white'/%3e%3cpath d='M135.26%2c98.218v4.422c9.92%2c1.47%2c19.83%2c1.47%2c29.75%2c0v-4.422c-9.92%2c1.474-19.83%2c1.474-29.75%2c0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.402506%2c84.325604)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.40259%2c83.530922)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883436e-2%2c97.40259%2c83.372046)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883436e-2%2c97.40259%2c83.372046)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.40259%2c83.530922)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.402534%2c84.325604)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='white'/%3e%3cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'%3e%3cpath d='M135.26%2c107.06l29.75%2c23.87'/%3e%3cpath d='M138.23%2c107.06l26.78%2c21.21'/%3e%3cpath d='M142.2%2c107.94l22.81%2c17.68'/%3e%3cpath d='M145.18%2c107.94l19.83%2c15.03'/%3e%3cpath d='M148.15%2c107.94l16.86%2c12.38'/%3e%3cpath d='M151.12%2c107.94l13.89%2c9.73'/%3e%3cpath d='M154.1%2c107.94l10.91%2c7.07'/%3e%3cpath d='M157.07%2c107.94l7.94%2c5.31'/%3e%3cpath d='M160.05%2c107.94l4.96%2c3.54'/%3e%3cpath d='M163.02%2c107.94l1.99%2c1.77'/%3e%3cpath d='M135.26%2c109.71l29.75%2c23.87'/%3e%3cpath d='M165.01%2c107.06l-32.72%2c26.52'/%3e%3cpath d='M162.03%2c107.06l-28.75%2c22.98'/%3e%3cpath d='M158.07%2c107.94l-22.81%2c17.68'/%3e%3cpath d='M155.09%2c107.94l-19.83%2c15.03'/%3e%3cpath d='M152.12%2c107.94l-16.86%2c12.38'/%3e%3cpath d='M149.14%2c107.94l-13.88%2c9.73'/%3e%3cpath d='M146.17%2c107.94l-10.91%2c7.07'/%3e%3cpath d='M143.19%2c107.94l-7.93%2c5.31'/%3e%3cpath d='M140.22%2c107.94l-4.96%2c3.54'/%3e%3cpath d='M137.24%2c107.94l-1.98%2c1.77'/%3e%3cpath d='M165.01%2c109.71l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c112.36l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c115.01l-32.72%2c26.53'/%3e%3cpath d='M165.01%2c117.67l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c120.32l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c122.97l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c125.62l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c128.28l-32.72%2c26.52'/%3e%3cpath d='M165.01%2c130.93l-30.74%2c24.75'/%3e%3cpath d='M165.01%2c133.58l-27.77%2c22.1'/%3e%3cpath d='M164.01%2c137.12l-21.81%2c17.68'/%3e%3cpath d='M163.02%2c140.65l-17.84%2c14.15'/%3e%3cpath d='M161.04%2c145.07l-8.92%2c7.07'/%3e%3cpath d='M135.26%2c112.36l28.75%2c22.99'/%3e%3cpath d='M135.26%2c115.01l28.75%2c22.99'/%3e%3cpath d='M135.26%2c117.67l27.76%2c22.1'/%3e%3cpath d='M135.26%2c120.32l27.76%2c22.1'/%3e%3cpath d='M135.26%2c122.97l26.77%2c21.22'/%3e%3cpath d='M134.27%2c124.74l26.77%2c21.22'/%3e%3cpath d='M134.27%2c127.39l24.79%2c19.45'/%3e%3cpath d='M133.28%2c129.16l24.79%2c19.45'/%3e%3cpath d='M132.29%2c130.93l23.79%2c18.56'/%3e%3cpath d='M132.29%2c133.58l22.8%2c17.68'/%3e%3cpath d='M132.29%2c136.23l19.83%2c15.91'/%3e%3c/g%3e%3cpath d='M135.26%2c102.64v4.42c9.92%2c1.47%2c19.83%2c1.47%2c29.75%2c0v-4.42c-9.92%2c1.47-19.83%2c1.47-29.75%2c0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='white'/%3e%3cpath d='M132.29%2c138.88l17.84%2c14.15' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M132.29%2c141.54l15.86%2c12.37' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M132.29%2c144.19l13.88%2c10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M132.29%2c146.84l9.91%2c7.96' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M132.29%2c149.49l7.93%2c6.19' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M132.29%2c152.14l4.95%2c3.54' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.402506%2c97.586004)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.40259%2c96.791347)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883436e-2%2c97.40259%2c96.632446)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883436e-2%2c97.40259%2c96.632446)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.40259%2c96.791347)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='white'/%3e%3cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333%2c0%2c0%2c3.5883686e-2%2c97.402534%2c97.586004)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='white'/%3e%3cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'%3e%3cpath d='M92.625%2c148.61l35.695-18.57'/%3e%3cpath d='M90.642%2c147.72l33.708-17.68'/%3e%3cpath d='M89.651%2c145.96l30.739-15.92'/%3e%3cpath d='M88.659%2c144.19l26.771-14.15'/%3e%3cpath d='M86.676%2c142.42l24.784-12.38'/%3e%3cpath d='M87.668%2c139.77l16.852-8.84'/%3e%3cpath d='M86.676%2c138l12.89-7.07'/%3e%3cpath d='M86.676%2c135.35l8.924-4.42'/%3e%3cpath d='M95.6%2c149.49l33.71-17.68'/%3e%3cpath d='M98.574%2c150.38l31.726-16.8'/%3e%3cpath d='M101.55%2c151.26l29.74-15.91'/%3e%3cpath d='M104.52%2c152.14l24.79-13.26'/%3e%3cpath d='M108.49%2c152.14l21.81-11.49'/%3e%3cpath d='M111.46%2c153.03l18.84-9.73'/%3e%3cpath d='M114.44%2c153.91l14.87-7.95'/%3e%3cpath d='M118.4%2c153.91l11.9-6.19'/%3e%3cpath d='M122.37%2c154.8l7.93-4.42'/%3e%3cpath d='M126.34%2c154.8l4.95-2.66'/%3e%3c/g%3e%3cpath d='M133.28%2c129.16h-4.96c-1.65%2c8.84-1.65%2c17.68%2c0%2c26.52h4.96c-1.66-8.84-1.66-17.68%2c0-26.52z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='white'/%3e%3cpath d='M74.778%2c141.54l11.898-8.84' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M74.778%2c135.35l11.898%2c10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='white'/%3e%3cpath d='M92.625%2c130.93l-5.949%2c0.88c-1.322%2c5.6-1.322%2c10.31%2c0%2c15.91l5.949%2c1.77c-1.322-5.6-1.322-12.96%2c0-18.56z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.18807621pt' fill='white'/%3e%3cpath d='M164.97%2c86.726v-4.457c-4.45%2c0.037-7.43-2.615-7.43-5.305l-14.85%2c0.037c0%2c2.653-2.97%2c5.305-7.43%2c5.305v4.42h29.71z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.32342911pt' fill='white'/%3e%3crect height='5.3041' width='12.734' stroke='%23db161b' y='71.697' x='143.75' stroke-width='0.27335pt' fill='white'/%3e%3crect height='5.3042' width='10.612' stroke='%23db161b' y='66.393' x='144.81' stroke-width='0.27335pt' fill='white'/%3e%3crect height='5.3042' width='10.612' stroke='%23db161b' y='61.089' x='144.81' stroke-width='0.27335pt' fill='white'/%3e%3crect height='7.0722' width='8.4893' stroke='%23db161b' y='54.017' x='145.87' stroke-width='0.27335pt' fill='white'/%3e%3crect height='6.1882' width='9.2211' stroke='%23db161b' y='47.829' x='145.51' stroke-width='0.28488pt' fill='white'/%3e%3cellipse rx='42.52' ry='33.661' stroke='%23db161b' transform='matrix(0.2891558%2c0%2c0%2c0.249492%2c81.982856%2c1.8592021)' cy='161.22' cx='237.4' stroke-width='1pt' fill='white'/%3e%3cpath d='M156.78%2c41.64c0%2c2.319%2c3.07%2c6.189%2c3.07%2c6.189-2.23%2c1.52-5.83%2c2.652-9.22%2c2.652s-7.62-0.631-9.22-2.652c0%2c0%2c3.07-3.87%2c3.07-6.189%2c0-2.318-3.07-5.304-3.07-5.304%2c2.22-1.52%2c5.83-2.652%2c9.22-2.652s6.99%2c1.132%2c9.22%2c2.652c0%2c0-3.07%2c2.986-3.07%2c5.304z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='white'/%3e%3cpath d='M154.73%2c41.64c0%2c2.319%2c3.07%2c7.073%2c3.07%2c7.073-2.22%2c1.52-3.78%2c1.768-7.17%2c1.768s-5.57%2c0.253-7.17-1.768c0%2c0%2c3.07-4.754%2c3.07-7.073%2c0-2.318-3.07-6.188-3.07-6.188%2c2.22-1.52%2c3.78-1.768%2c7.17-1.768s4.95%2c0.248%2c7.17%2c1.768c0%2c0-3.07%2c3.87-3.07%2c6.188z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558%2c0%2c0%2c0.249492%2c81.982856%2c0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558%2c0%2c0%2c0.249492%2c106.57247%2c0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558%2c0%2c0%2c0.249492%2c94.277639%2c0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558%2c0%2c0%2c0.249492%2c94.277639%2c-7.8650879)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823%2c0%2c0%2c0.249492%2c83.263631%2c42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823%2c0%2c0%2c0.249492%2c100.24214%2c42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3cpath d='M142.69%2c77.001h14.85l-7.42%2c7.957-7.43-7.957z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.27334673pt' fill='white'/%3e%3cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.3993101%2c0%2c0%2c0.3326564%2c72.298311%2c27.790617)' cy='166.54' cx='194.88' stroke-width='1pt' fill='white'/%3e%3crect rx='1.2377' ry='0.93811' height='5.3042' width='22.805' stroke='%23db161b' y='109.72' x='133.77' stroke-width='0.33028' fill='white'/%3e%3cpath d='M163.52%2c105.3c-2.75%2c0-4.96%2c2.06-4.96%2c4.62v4.02c0%2c2.56%2c2.21%2c4.62%2c4.96%2c4.62s4.96-2.06%2c4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0%2c1.77c-1.65%2c0-2.98%2c1.65-2.98%2c3.7v2.33c0%2c2.05%2c1.33%2c3.69%2c2.98%2c3.69s2.97-1.64%2c2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='white'/%3e%3cpath d='M137.74%2c106.19c-1.65%2c0-2.97%2c1.64-2.97%2c3.69v4.1c0%2c2.05%2c1.32%2c3.7%2c2.97%2c3.7s2.97-1.65%2c2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75%2c0-4.96%2c2.06-4.96%2c4.62v5.79c0%2c2.56%2c2.21%2c4.62%2c4.96%2c4.62s4.96-2.06%2c4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='white'/%3e%3cpath d='M129.81%2c107.95c-1.65%2c0-2.98%2c1.65-2.98%2c3.7v0.96c0%2c2.05%2c1.33%2c3.7%2c2.98%2c3.7s2.97-1.65%2c2.97-3.7v-0.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75%2c0-4.96%2c2.06-4.96%2c4.62v2.65c0%2c2.56%2c2.21%2c4.62%2c4.96%2c4.62%2c2.74%2c0%2c4.96-2.06%2c4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='white'/%3e%3cpath d='M117.91%2c105.51c-2.97%2c0-5.35%2c1.84-5.35%2c4.13v4.58c0%2c2.29%2c2.38%2c4.13%2c5.35%2c4.13s5.35-1.84%2c5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94%2c0-8.92%2c2.31-8.92%2c5.17v6.47c0%2c2.86%2c3.98%2c5.16%2c8.92%2c5.16s8.92-2.3%2c8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='white'/%3e%3cpath d='M182.36%2c106.39c-2.97%2c0-5.36%2c1.85-5.36%2c4.14v4.58c0%2c2.29%2c2.39%2c4.13%2c5.36%2c4.13%2c2.96%2c0%2c5.35-1.84%2c5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95%2c0-8.93%2c2.3-8.93%2c5.16v6.47c0%2c2.86%2c3.98%2c5.16%2c8.93%2c5.16%2c4.94%2c0%2c8.92-2.3%2c8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='white'/%3e%3crect rx='0.64577' ry='0.93811' height='5.3042' width='11.898' stroke='%23db161b' y='109.72' x='165.5' stroke-width='0.33028' fill='white'/%3e%3crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='154.6' stroke-width='0.33028' fill='white'/%3e%3crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='121.88' stroke-width='0.33028' fill='white'/%3e%3crect rx='0.7534' ry='1.5635' height='8.8403' width='13.881' stroke='%23db161b' y='107.95' x='100.06' stroke-width='0.33028' fill='white'/%3e%3crect rx='0.69959' ry='1.5635' height='8.8403' width='12.89' stroke='%23db161b' y='108.84' x='186.32' stroke-width='0.33028' fill='white'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg viewBox='0 0 630 360' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect width='630' height='360' fill='%23da0000'/%3e%3crect width='630' height='240' fill='white'/%3e%3crect width='630' height='120' fill='%23239f40'/%3e%3cg transform='translate(8.4%2c100.4)'%3e%3cg id='d'%3e%3cg id='a' fill='none' stroke='white' stroke-width='2'%3e%3cpath id='c' transform='scale(1.4)' d='M0%2c1H26M1%2c10V5H9V9H17V5H12M4%2c9H6M26%2c9H21V5H29M29%2c0V9H37V0M33%2c0V9'/%3e%3cpath id='b' transform='scale(2.8)' d='m0 7h9m1 0h9'/%3e%3cuse y='120' xlink:href='%23b'/%3e%3cuse y='145.2' xlink:href='%23c'/%3e%3c/g%3e%3cg id='e'%3e%3cuse x='56' xlink:href='%23a'/%3e%3cuse x='112' xlink:href='%23a'/%3e%3cuse x='168' xlink:href='%23a'/%3e%3c/g%3e%3c/g%3e%3cuse x='168' xlink:href='%23e'/%3e%3cuse x='392' xlink:href='%23d'/%3e%3c/g%3e%3cg transform='matrix(45%2c0%2c0%2c45%2c315%2c180)' fill='%23da0000'%3e%3cg id='f'%3e%3cpath d='m-0.54815 0.83638a0.91205 0.91205 0 0 0 0.87669-1.5588 1 1 0 0 1-0.87669 1.5588'/%3e%3cpath d='m0.61834 0.66141a0.76393 0.76393 0 0 0-0.1967-1.4025 1 1 0 0 1 0.1967 1.4025'/%3e%3cpath d='m0 1-0.05-1 0.05-0.78728a0.31 0.31 0 0 0 0.11803 0.099087v0.58778l-0.040225 0.99331z'/%3e%3cpath d='M-0.02%2c-0.85 0%2c-0.831217A0.14431%2c0.14431 0 0%2c0 0.252075%2c-0.967708A0.136408%2c0.136408 0 0%2c1 0%2c-0.924634'/%3e%3c/g%3e%3cuse transform='scale(-1%2c1)' xlink:href='%23f'/%3e%3c/g%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3crect width='12' height='6'/%3e%3crect fill='white' width='12' height='4'/%3e%3crect fill='%23D21034' width='12' height='2'/%3e%3cpolygon fill='%23007229' points='0%2c0 4%2c3 0%2c6'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-36 -24 72 48'%3e%3cpath fill='white' d='M-36-24h72v48h-72z'/%3e%3cg transform='rotate(-56.31)'%3e%3cg id='b'%3e%3cpath id='a' d='M-6-25H6m-12 3H6m-12 3H6' stroke='black' stroke-width='2'/%3e%3cuse xlink:href='%23a' y='44'/%3e%3c/g%3e%3cpath stroke='white' d='M0 17v10'/%3e%3ccircle fill='%23cd2e3a' r='12'/%3e%3cpath fill='%230047a0' d='M0-12A6 6 0 000 0a6 6 0 010 12 12 12 0 010-24z'/%3e%3c/g%3e%3cg transform='rotate(-123.69)'%3e%3cuse xlink:href='%23b'/%3e%3cpath stroke='white' d='M0-23.5v3M0 17v3.5m0 3v3'/%3e%3c/g%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 600'%3e%3crect width='800' height='600' x='0' y='0' style='fill:%23007fff'/%3e%3cpath d='m 36%2c120 84%2c0 26%2c-84 26%2c84 84%2c0 -68%2c52 26%2c84 -68%2c-52 -68%2c52 26%2c-84 -68%2c-52 z M 750%2c0 0%2c450 0%2c600 0%2c600 50%2c600 800%2c150 800%2c0 750%2c0' style='fill:%23f7d618'/%3e%3cpath d='M 800%2c0 0%2c480 0%2c600 0%2c600 0%2c600 800%2c120 800%2c0' style='fill:%23ce1021'/%3e%3c/svg%3e";

var flagsSVGsObj = {
    ae: img$V,
    al: img$D,
    ao: img$u,
    ar: img$1z,
    at: img$1F,
    au: img$1L,
    az: img$T,
    ba: img$1a,
    bd: img$B,
    be: img$1U,
    bg: img$1P,
    bh: img$_,
    bn: img$j,
    bo: img$1l,
    br: img$1G,
    bw: img$o,
    by: img$1d,
    ca: img$1E,
    cd: img,
    ch: img$1V,
    ci: img$H,
    cl: img$1y,
    cm: img$I,
    cn: img$7,
    co: img$1v,
    cr: img$1m,
    cy: img$s,
    cz: img$1A,
    de: img$21,
    dk: img$20,
    do: img$1n,
    dz: img$17,
    ec: img$1x,
    ee: img$1R,
    eg: img$19,
    es: img$1Z,
    et: img$w,
    fi: img$1$,
    fr: img$1M,
    ga: img$x,
    gb: img$23,
    gh: img$F,
    gm: img$9,
    gr: img$1W,
    gt: img$1u,
    hk: img$Z,
    hn: img$8,
    hr: img$1i,
    hu: img$1X,
    id: img$1c,
    ie: img$5,
    il: img$15,
    in: img$6,
    iq: img$11,
    ir: img$3,
    is: img$18,
    it: img$1Y,
    jo: img$10,
    jp: img$1J,
    ke: img$M,
    kh: img$J,
    kr: img$1,
    kw: img$16,
    kz: img$1B,
    la: img$l,
    lb: img$14,
    lk: img$G,
    lr: img$d,
    ls: img$g,
    lt: img$1Q,
    lu: img$P,
    lv: img$1O,
    ly: img$m,
    ma: img$1e,
    md: img$O,
    me: img$R,
    mk: img$S,
    mm: img$t,
    mo: img$N,
    mt: img$r,
    mu: img$a,
    mw: img$b,
    mx: img$1C,
    my: img$1h,
    mz: img$y,
    na: img$k,
    ng: img$X,
    ni: img$h,
    nl: img$1T,
    no: img$1_,
    nz: img$1o,
    om: img$4,
    pa: img$K,
    pe: img$1w,
    ph: img$1f,
    pk: img$13,
    pl: img$1S,
    pr: img$1t,
    ps: img$n,
    pt: img$1I,
    py: img$W,
    qa: img$12,
    ro: img$1H,
    rs: img$1j,
    ru: img$1N,
    rw: img$z,
    sa: img$U,
    sc: img$c,
    sd: img$2,
    se: img$22,
    sg: img$1g,
    si: img$1k,
    sk: img$1q,
    sl: img$f,
    sv: img$i,
    sy: img$$,
    sz: img$e,
    th: img$1b,
    tn: img$E,
    tr: img$1D,
    tw: img$Q,
    tz: img$A,
    ua: img$1K,
    ug: img$q,
    us: img$24,
    uy: img$1r,
    ve: img$1s,
    vn: img$Y,
    xk: img$C,
    ye: img$p,
    za: img$1p,
    zm: img$v,
    zw: img$L
};

var countryToSvgIcon = function (countryCode) {
    if (countryCode) {
        var formattedCountryCode = countryCode.toLowerCase();
        return (jsx$1("img", { src: flagsSVGsObj[formattedCountryCode], alt: countryCode, height: 20, width: 20 }));
    }
    return undefined;
};

var SelectMenuItem = function (props) {
    var option = props.option, classes = props.classes, textSize = props.textSize, dataCy = props.dataCy;
    return (jsx$1(MuiMenuItem, __assign$3({ "data-testid": "select-menu-item-".concat(option.id), value: option.value, disableGutters: true, className: classes.menuItem, "data-cy": dataCy }, { children: jsxs(Grid$2, __assign$3({ container: true, direction: "row", className: classes.menuItemGrid }, { children: [option.countryCode && (jsx$1(Grid$2, __assign$3({ item: true, xs: "auto", className: classes.menuItemIcon }, { children: jsx$1("div", __assign$3({ style: { paddingTop: '1px' } }, { children: countryToSvgIcon(option.countryCode) })) }))), jsx$1("p", __assign$3({ style: { fontSize: textSize, color: theme.palette.text.secondary } }, { children: option.name }))] })) }), option.id));
};

var SelectVariant;
(function (SelectVariant) {
    SelectVariant[SelectVariant["Outlined"] = 0] = "Outlined";
    SelectVariant[SelectVariant["Filled"] = 1] = "Filled";
    SelectVariant[SelectVariant["Underlined"] = 2] = "Underlined";
})(SelectVariant || (SelectVariant = {}));
var SelectIconColor;
(function (SelectIconColor) {
    SelectIconColor[SelectIconColor["Primary"] = 0] = "Primary";
    SelectIconColor[SelectIconColor["Secondary"] = 1] = "Secondary";
})(SelectIconColor || (SelectIconColor = {}));
var getPaperCssClassFromInputVariant = function (variant, classes) {
    switch (variant) {
        case SelectVariant.Filled:
        case SelectVariant.Outlined:
            return classes.dropdownStyle;
        case SelectVariant.Underlined:
            return classes.underlineStyle;
        default:
            return '';
    }
};
var getVariantTextFromInputVariant = function (variant) {
    switch (variant) {
        case SelectVariant.Outlined:
        case SelectVariant.Filled:
            return 'outlined';
        case SelectVariant.Underlined:
        default:
            return 'standard';
    }
};
var getSelectCssClassFromInputVariant = function (variant, classes) {
    switch (variant) {
        case SelectVariant.Filled:
            return classes.selectFilled;
        case SelectVariant.Outlined:
        case SelectVariant.Underlined:
            return classes.select;
        default:
            return '';
    }
};
var getStylesFromProps = function (minWidth, width) {
    if (width) {
        return {
            width: width
        };
    }
    return {
        minWidth: minWidth
    };
};
var getInputFromVariant = function (variant, classes, disableUnderline) {
    switch (variant) {
        case SelectVariant.Filled:
        case SelectVariant.Outlined:
            return (jsx$1(OutlinedInput$1, { classes: {
                    notchedOutline: classes.notchedOutline
                } }));
        case SelectVariant.Underlined:
            return jsx$1(Input$8, { color: "secondary", disableUnderline: disableUnderline });
        default:
            return jsx$1(OutlinedInput$1, {});
    }
};
var Select = function (props) {
    var _a = props.autoWidth, autoWidth = _a === void 0 ? false : _a, _b = props.noWhiteSpaceAfterSelection, noWhiteSpaceAfterSelection = _b === void 0 ? false : _b, _c = props.ariaLabel, ariaLabel = _c === void 0 ? 'Select' : _c, defaultOptionValue = props.defaultOptionValue, optionValue = props.optionValue, _d = props.disableUnderline, disableUnderline = _d === void 0 ? true : _d, _e = props.fullWidth, fullWidth = _e === void 0 ? false : _e, width = props.width, _f = props.minWidth, minWidth = _f === void 0 ? 200 : _f, _g = props.maxMenuHeight, maxMenuHeight = _g === void 0 ? 356 : _g, placeholder = props.placeholder, onChange = props.onChange, options = props.options, suggestedOptions = props.suggestedOptions, _h = props.variant, variant = _h === void 0 ? SelectVariant.Outlined : _h, _j = props.iconColor, iconColor = _j === void 0 ? SelectIconColor.Secondary : _j, _k = props.textSize, textSize = _k === void 0 ? TextSize.ms : _k, _l = props.selectedTextWeight, selectedTextWeight = _l === void 0 ? TextWeight.Regular : _l, _m = props.selectedTextHighlight, selectedTextHighlight = _m === void 0 ? TextHighlight.Background : _m, selectedTextFontSize = props.selectedTextFontSize, readOnly = props.readOnly;
    var _o = useStyles$5(), classes = _o.classes, classNames = _o.cx;
    var _p = useState(defaultOptionValue === undefined && !!placeholder), showPlaceholder = _p[0], setShowPlaceholder = _p[1];
    var textClasses = useTextStyles().classes;
    var stringVariant = getVariantTextFromInputVariant(variant);
    var paperCssClass = getPaperCssClassFromInputVariant(variant, classes);
    var selectCssClass = getSelectCssClassFromInputVariant(variant, classes);
    var stylesFromProps = getStylesFromProps(minWidth, width);
    var input = getInputFromVariant(variant, classes, disableUnderline);
    var iconColorMap = new Map([
        [SelectIconColor.Primary, classes.arrowIconPrimary],
        [SelectIconColor.Secondary, classes.arrowIconSecondary]
    ]);
    var arrowIconClass = iconColorMap.get(iconColor);
    var keyboardArrowAction = function (props) { return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx$1(KeyboardArrowDown, __assign$3({}, props, { classes: { root: arrowIconClass } }))); };
    return (jsxs(MuiSelect, __assign$3({ autoWidth: autoWidth, defaultValue: defaultOptionValue && defaultOptionValue, displayEmpty: true, readOnly: readOnly, renderValue: showPlaceholder
            ? function () {
                var _a;
                return (jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.highlightBackground, textClasses[(_a = classNameBySize.get(textSize)) !== null && _a !== void 0 ? _a : 'sizeMs']) }, { children: placeholder })));
            }
            : function (value) {
                var _a;
                var _b, _c, _d, _e, _f;
                return (jsxs(Grid$2, __assign$3({ container: true, direction: "row", className: classNames((_a = {},
                        _a[classes.menuItemGrid] = !noWhiteSpaceAfterSelection,
                        _a[classes.menuItemGridNoWhiteSpace] = noWhiteSpaceAfterSelection,
                        _a)), alignItems: "center" }, { children: [jsx$1(Grid$2, __assign$3({ item: true, className: classes.countryFlag }, { children: countryToSvgIcon((_b = options === null || options === void 0 ? void 0 : options.find(function (option) { return option.value === value; })) === null || _b === void 0 ? void 0 : _b.countryCode) })), jsx$1("p", __assign$3({ className: classNames(textClasses.default, textClasses.noWrap, textClasses[(_c = classNameByHighlight.get(selectedTextHighlight)) !== null && _c !== void 0 ? _c : 'highlightBackground'], textClasses[(_d = classNameBySize.get(selectedTextFontSize || textSize)) !== null && _d !== void 0 ? _d : 'sizeMs'], textClasses[(_e = classNameByWeight.get(selectedTextWeight)) !== null && _e !== void 0 ? _e : 'weightRegular']) }, { children: (_f = options === null || options === void 0 ? void 0 : options.find(function (option) { return option.value === value; })) === null || _f === void 0 ? void 0 : _f.name }))] })));
            }, value: optionValue, fullWidth: fullWidth, 
        /* eslint-disable react/jsx-props-no-spreading */
        IconComponent: keyboardArrowAction, className: selectCssClass, input: input, inputProps: {
            'data-testid': 'select-control',
            className: classes.outlinedInput,
            classes: { select: classes.selectBackground },
            'aria-label': ariaLabel
        }, MenuProps: {
            classes: {
                paper: paperCssClass
            },
            style: {
                maxHeight: "".concat(maxMenuHeight, "px")
            },
            elevation: 0,
            // getContentAnchorEl: null,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            variant: 'menu'
        }, onChange: function (event) {
            onChange && onChange(event);
        }, onFocus: function () {
            setShowPlaceholder(false);
        }, variant: stringVariant, style: stylesFromProps }, { children: [suggestedOptions &&
                suggestedOptions.map(function (option) {
                    return SelectMenuItem({ option: option, classes: classes, textSize: textSize });
                }), jsx$1(Divider$2, {}), options &&
                options.map(function (option) {
                    return SelectMenuItem({ option: option, classes: classes, textSize: textSize });
                })] })));
};

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var SnackbarContext = /*#__PURE__*/React__default.createContext();

var allClasses = {
  mui: {
    root: {},
    anchorOriginTopCenter: {},
    anchorOriginBottomCenter: {},
    anchorOriginTopRight: {},
    anchorOriginBottomRight: {},
    anchorOriginTopLeft: {},
    anchorOriginBottomLeft: {}
  },
  container: {
    containerRoot: {},
    containerAnchorOriginTopCenter: {},
    containerAnchorOriginBottomCenter: {},
    containerAnchorOriginTopRight: {},
    containerAnchorOriginBottomRight: {},
    containerAnchorOriginTopLeft: {},
    containerAnchorOriginBottomLeft: {}
  }
};
var MESSAGES = {
  NO_PERSIST_ALL: 'WARNING - notistack: Reached maxSnack while all enqueued snackbars have \'persist\' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented.'
};
var SNACKBAR_INDENTS = {
  view: {
    "default": 20,
    dense: 4
  },
  snackbar: {
    "default": 6,
    dense: 2
  }
};
var DEFAULTS = {
  maxSnack: 3,
  dense: false,
  hideIconVariant: false,
  variant: 'default',
  autoHideDuration: 5000,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  TransitionComponent: Slide$1,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
};
var capitalise = function capitalise(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
var originKeyExtractor = function originKeyExtractor(anchor) {
  return "" + capitalise(anchor.vertical) + capitalise(anchor.horizontal);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */

var omitContainerKeys = function omitContainerKeys(classes) {
  return (// @ts-ignore
    Object.keys(classes).filter(function (key) {
      return !allClasses.container[key];
    }).reduce(function (obj, key) {
      var _extends2;

      return _extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {})
  );
};
var REASONS = {
  TIMEOUT: 'timeout',
  CLICKAWAY: 'clickaway',
  MAXSNACK: 'maxsnack',
  INSTRUCTED: 'instructed'
};
/** Tranforms classes name */

var transformer = {
  toContainerAnchorOrigin: function toContainerAnchorOrigin(origin) {
    return "containerAnchorOrigin" + origin;
  },
  toAnchorOrigin: function toAnchorOrigin(_ref) {
    var vertical = _ref.vertical,
        horizontal = _ref.horizontal;
    return "anchorOrigin" + capitalise(vertical) + capitalise(horizontal);
  },
  toVariant: function toVariant(variant) {
    return "variant" + capitalise(variant);
  }
};
var isDefined = function isDefined(value) {
  return !!value || value === 0;
};

var numberOrNull = function numberOrNull(numberish) {
  return typeof numberish === 'number' || numberish === null;
}; // @ts-ignore


var merge = function merge(options, props, defaults) {
  return function (name) {
    if (name === 'autoHideDuration') {
      if (numberOrNull(options.autoHideDuration)) return options.autoHideDuration;
      if (numberOrNull(props.autoHideDuration)) return props.autoHideDuration;
      return DEFAULTS.autoHideDuration;
    }

    return options[name] || props[name] || defaults[name];
  };
};
function objectMerge(options, props, defaults) {
  if (options === void 0) {
    options = {};
  }

  if (props === void 0) {
    props = {};
  }

  if (defaults === void 0) {
    defaults = {};
  }

  return _extends({}, defaults, {}, props, {}, options);
}

var componentName = 'SnackbarContent';
var classes = {
  root: componentName + "-root"
};
var Root = /*#__PURE__*/styled$1('div')(function (_ref) {
  var _ref2, _ref3;

  var theme = _ref.theme;
  return _ref3 = {}, _ref3["&." + classes.root] = (_ref2 = {
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1
  }, _ref2[theme.breakpoints.up('sm')] = {
    flexGrow: 'initial',
    minWidth: 288
  }, _ref2), _ref3;
});
var SnackbarContent = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
      props = _objectWithoutPropertiesLoose(_ref4, ["className"]);

  return React__default.createElement(Root, Object.assign({
    ref: ref,
    className: clsx(classes.root, className)
  }, props));
});

var DIRECTION = {
  right: 'left',
  left: 'right',
  bottom: 'up',
  top: 'down'
};
var getTransitionDirection = function getTransitionDirection(anchorOrigin) {
  if (anchorOrigin.horizontal !== 'center') {
    return DIRECTION[anchorOrigin.horizontal];
  }

  return DIRECTION[anchorOrigin.vertical];
};

var CheckIcon = function CheckIcon(props) {
  return React__default.createElement(SvgIcon$1, Object.assign({}, props), React__default.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
  }));
};

var WarningIcon = function WarningIcon(props) {
  return React__default.createElement(SvgIcon$1, Object.assign({}, props), React__default.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
};

var ErrorIcon = function ErrorIcon(props) {
  return React__default.createElement(SvgIcon$1, Object.assign({}, props), React__default.createElement("path", {
    d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
  }));
};

var InfoIcon = function InfoIcon(props) {
  return React__default.createElement(SvgIcon$1, Object.assign({}, props), React__default.createElement("path", {
    d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
  }));
};

var iconStyles = {
  fontSize: 20,
  marginInlineEnd: 8
};
var defaultIconVariants = {
  "default": undefined,
  success: /*#__PURE__*/React__default.createElement(CheckIcon, {
    style: iconStyles
  }),
  warning: /*#__PURE__*/React__default.createElement(WarningIcon, {
    style: iconStyles
  }),
  error: /*#__PURE__*/React__default.createElement(ErrorIcon, {
    style: iconStyles
  }),
  info: /*#__PURE__*/React__default.createElement(InfoIcon, {
    style: iconStyles
  })
};

/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/createChainedFunction.js
 */
function createChainedFunction(funcs, extraArg) {
  return funcs.reduce(function (acc, func) {
    if (func == null) return acc;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof func !== 'function') {
        // eslint-disable-next-line no-console
        console.error('Invalid Argument Type. must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var argums = [].concat(args);

      if (extraArg && argums.indexOf(extraArg) === -1) {
        argums.push(extraArg);
      }

      acc.apply(this, argums);
      func.apply(this, argums);
    };
  }, function () {});
}

/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/useEventCallback.js
 */
var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
function useEventCallback(fn) {
  var ref = useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return useCallback$1(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

var Snackbar = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      autoHideDuration = props.autoHideDuration,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      onClose = props.onClose,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      other = _objectWithoutPropertiesLoose(props, ["children", "autoHideDuration", "ClickAwayListenerProps", "disableWindowBlurListener", "onClose", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration"]);

  var timerAutoHide = useRef();
  var handleClose = useEventCallback(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = useEventCallback(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, REASONS.TIMEOUT);
    }, autoHideDurationParam);
  });
  useEffect(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  };
  /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */


  var handleResume = useCallback$1(function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, REASONS.CLICKAWAY);
    }
  };

  useEffect(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]);
  return createElement(ClickAwayListener, _extends({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), createElement("div", _extends({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), children));
});

var componentName$1 = 'SnackbarItem';
var classes$1 = {
  contentRoot: componentName$1 + "-contentRoot",
  lessPadding: componentName$1 + "-lessPadding",
  variantSuccess: componentName$1 + "-variantSuccess",
  variantError: componentName$1 + "-variantError",
  variantInfo: componentName$1 + "-variantInfo",
  variantWarning: componentName$1 + "-variantWarning",
  message: componentName$1 + "-message",
  action: componentName$1 + "-action",
  wrappedRoot: componentName$1 + "-wrappedRoot"
};
var StyledSnackbar = /*#__PURE__*/styled$1(Snackbar)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  var mode = theme.palette.mode || theme.palette.type;
  var backgroundColor = emphasize(theme.palette.background["default"], mode === 'light' ? 0.8 : 0.98);
  return _ref2 = {}, _ref2["&." + classes$1.wrappedRoot] = {
    position: 'relative',
    transform: 'translateX(0)',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, _ref2["." + classes$1.contentRoot] = _extends({}, theme.typography.body2, {
    backgroundColor: backgroundColor,
    color: theme.palette.getContrastText(backgroundColor),
    alignItems: 'center',
    padding: '6px 16px',
    borderRadius: '4px',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
  }), _ref2["." + classes$1.lessPadding] = {
    paddingLeft: 8 * 2.5
  }, _ref2["." + classes$1.variantSuccess] = {
    backgroundColor: '#43a047',
    color: '#fff'
  }, _ref2["." + classes$1.variantError] = {
    backgroundColor: '#d32f2f',
    color: '#fff'
  }, _ref2["." + classes$1.variantInfo] = {
    backgroundColor: '#2196f3',
    color: '#fff'
  }, _ref2["." + classes$1.variantWarning] = {
    backgroundColor: '#ff9800',
    color: '#fff'
  }, _ref2["." + classes$1.message] = {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0'
  }, _ref2["." + classes$1.action] = {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
  }, _ref2;
});

var SnackbarItem = function SnackbarItem(_ref3) {
  var propClasses = _ref3.classes,
      props = _objectWithoutPropertiesLoose(_ref3, ["classes"]);

  var timeout = useRef();

  var _useState = useState(true),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  useEffect(function () {
    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);
  var handleClose = createChainedFunction([props.snack.onClose, props.onClose], props.snack.key);

  var handleEntered = function handleEntered() {
    if (props.snack.requestClose) {
      handleClose(null, REASONS.INSTRCUTED);
    }
  };

  var handleExitedScreen = function handleExitedScreen() {
    timeout.current = setTimeout(function () {
      setCollapsed(!collapsed);
    }, 125);
  };

  var style = props.style,
      otherAriaAttributes = props.ariaAttributes,
      otherClassName = props.className,
      hideIconVariant = props.hideIconVariant,
      iconVariant = props.iconVariant,
      snack = props.snack,
      otherAction = props.action,
      otherContent = props.content,
      otherTranComponent = props.TransitionComponent,
      otherTranProps = props.TransitionProps,
      otherTranDuration = props.transitionDuration,
      other = _objectWithoutPropertiesLoose(props, ["style", "dense", "ariaAttributes", "className", "hideIconVariant", "iconVariant", "snack", "action", "content", "TransitionComponent", "TransitionProps", "transitionDuration", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"]);

  var key = snack.key,
      open = snack.open,
      singleClassName = snack.className,
      variant = snack.variant,
      singleContent = snack.content,
      singleAction = snack.action,
      singleAriaAttributes = snack.ariaAttributes,
      anchorOrigin = snack.anchorOrigin,
      snackMessage = snack.message,
      singleTranComponent = snack.TransitionComponent,
      singleTranProps = snack.TransitionProps,
      singleTranDuration = snack.transitionDuration,
      singleSnackProps = _objectWithoutPropertiesLoose(snack, ["persist", "key", "open", "entered", "requestClose", "className", "variant", "content", "action", "ariaAttributes", "anchorOrigin", "message", "TransitionComponent", "TransitionProps", "transitionDuration", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"]);

  var icon = _extends({}, defaultIconVariants, {}, iconVariant)[variant];

  var ariaAttributes = _extends({
    'aria-describedby': 'notistack-snackbar'
  }, objectMerge(singleAriaAttributes, otherAriaAttributes));

  var TransitionComponent = singleTranComponent || otherTranComponent || DEFAULTS.TransitionComponent;
  var transitionDuration = objectMerge(singleTranDuration, otherTranDuration, DEFAULTS.transitionDuration);

  var transitionProps = _extends({
    direction: getTransitionDirection(anchorOrigin)
  }, objectMerge(singleTranProps, otherTranProps));

  var action = singleAction || otherAction;

  if (typeof action === 'function') {
    action = action(key);
  }

  var content = singleContent || otherContent;

  if (typeof content === 'function') {
    content = content(key, snack.message);
  } // eslint-disable-next-line operator-linebreak


  var callbacks = ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].reduce(function (acc, cbName) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[cbName] = createChainedFunction([props.snack[cbName], props[cbName]], props.snack.key), _extends2));
  }, {});
  return React__default.createElement(Collapse$1, {
    unmountOnExit: true,
    timeout: 175,
    "in": collapsed,
    onExited: callbacks.onExited
  }, React__default.createElement(StyledSnackbar, Object.assign({}, other, singleSnackProps, {
    open: open,
    className: clsx(propClasses.root, classes$1.wrappedRoot, propClasses[transformer.toAnchorOrigin(anchorOrigin)]),
    onClose: handleClose
  }), React__default.createElement(TransitionComponent, Object.assign({
    appear: true,
    "in": open,
    timeout: transitionDuration
  }, transitionProps, {
    onExit: callbacks.onExit,
    onExiting: callbacks.onExiting,
    onExited: handleExitedScreen,
    onEnter: callbacks.onEnter,
    onEntering: callbacks.onEntering,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: createChainedFunction([callbacks.onEntered, handleEntered])
  }), content || React__default.createElement(SnackbarContent, Object.assign({}, ariaAttributes, {
    role: "alert",
    style: style,
    className: clsx(classes$1.contentRoot, classes$1[transformer.toVariant(variant)], propClasses[transformer.toVariant(variant)], otherClassName, singleClassName, !hideIconVariant && icon && classes$1.lessPadding)
  }), React__default.createElement("div", {
    id: ariaAttributes['aria-describedby'],
    className: classes$1.message
  }, !hideIconVariant ? icon : null, snackMessage), action && React__default.createElement("div", {
    className: classes$1.action
  }, action)))));
};

var collapse = {
  // Material-UI 4.12.x and above uses MuiCollapse-root; earlier versions use
  // Mui-Collapse-container.  https://github.com/mui-org/material-ui/pull/24084
  container: '& > .MuiCollapse-container, & > .MuiCollapse-root',
  wrapper: '& > .MuiCollapse-container > .MuiCollapse-wrapper, & > .MuiCollapse-root > .MuiCollapse-wrapper'
};
var xsWidthMargin = 16;
var componentName$2 = 'SnackbarContainer';
var classes$2 = {
  root: componentName$2 + "-root",
  rootDense: componentName$2 + "-rootDense",
  top: componentName$2 + "-top",
  bottom: componentName$2 + "-bottom",
  left: componentName$2 + "-left",
  right: componentName$2 + "-right",
  center: componentName$2 + "-center"
};
var Root$1 = /*#__PURE__*/styled$1('div')(function (_ref) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;

  var theme = _ref.theme;
  return _ref7 = {}, _ref7["&." + classes$2.root] = (_ref2 = {
    boxSizing: 'border-box',
    display: 'flex',
    maxHeight: '100%',
    position: 'fixed',
    zIndex: theme.zIndex.snackbar,
    height: 'auto',
    width: 'auto',
    transition: 'top 300ms ease 0ms, right 300ms ease 0ms, bottom 300ms ease 0ms, left 300ms ease 0ms, margin 300ms ease 0ms, max-width 300ms ease 0ms',
    // container itself is invisible and should not block clicks, clicks should be passed to its children
    pointerEvents: 'none'
  }, _ref2[collapse.container] = {
    pointerEvents: 'all'
  }, _ref2[collapse.wrapper] = {
    padding: SNACKBAR_INDENTS.snackbar["default"] + "px 0px",
    transition: 'padding 300ms ease 0ms'
  }, _ref2.maxWidth = "calc(100% - " + SNACKBAR_INDENTS.view["default"] * 2 + "px)", _ref2[theme.breakpoints.down('sm')] = {
    width: '100%',
    maxWidth: "calc(100% - " + xsWidthMargin * 2 + "px)"
  }, _ref2), _ref7["&." + classes$2.rootDense] = (_ref3 = {}, _ref3[collapse.wrapper] = {
    padding: SNACKBAR_INDENTS.snackbar.dense + "px 0px"
  }, _ref3), _ref7["&." + classes$2.top] = {
    top: SNACKBAR_INDENTS.view["default"] - SNACKBAR_INDENTS.snackbar["default"],
    flexDirection: 'column'
  }, _ref7["&." + classes$2.bottom] = {
    bottom: SNACKBAR_INDENTS.view["default"] - SNACKBAR_INDENTS.snackbar["default"],
    flexDirection: 'column-reverse'
  }, _ref7["&." + classes$2.left] = (_ref4 = {
    left: SNACKBAR_INDENTS.view["default"]
  }, _ref4[theme.breakpoints.up('sm')] = {
    alignItems: 'flex-start'
  }, _ref4[theme.breakpoints.down('sm')] = {
    left: xsWidthMargin + "px"
  }, _ref4), _ref7["&." + classes$2.right] = (_ref5 = {
    right: SNACKBAR_INDENTS.view["default"]
  }, _ref5[theme.breakpoints.up('sm')] = {
    alignItems: 'flex-end'
  }, _ref5[theme.breakpoints.down('sm')] = {
    right: xsWidthMargin + "px"
  }, _ref5), _ref7["&." + classes$2.center] = (_ref6 = {
    left: '50%',
    transform: 'translateX(-50%)'
  }, _ref6[theme.breakpoints.up('sm')] = {
    alignItems: 'center'
  }, _ref6), _ref7;
});

var SnackbarContainer = function SnackbarContainer(props) {
  var className = props.className,
      anchorOrigin = props.anchorOrigin,
      dense = props.dense,
      other = _objectWithoutPropertiesLoose(props, ["className", "anchorOrigin", "dense"]);

  var combinedClassname = clsx(classes$2[anchorOrigin.vertical], classes$2[anchorOrigin.horizontal], classes$2.root, // root should come after others to override maxWidth
  className, dense && classes$2.rootDense);
  return React__default.createElement(Root$1, Object.assign({
    className: combinedClassname
  }, other));
};

var SnackbarContainer$1 = /*#__PURE__*/React__default.memo(SnackbarContainer);

/* eslint-disable */
var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = (function (message) {
  if (!__DEV__) return;

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    throw new Error(message);
  } catch (x) {}
});

var SnackbarProvider$1 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SnackbarProvider, _Component);

  function SnackbarProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */

    _this.enqueueSnackbar = function (message, opts) {
      if (opts === void 0) {
        opts = {};
      }

      var _opts = opts,
          key = _opts.key,
          preventDuplicate = _opts.preventDuplicate,
          options = _objectWithoutPropertiesLoose(_opts, ["key", "preventDuplicate"]);

      var hasSpecifiedKey = isDefined(key);
      var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
      var merger = merge(options, _this.props, DEFAULTS);

      var snack = _extends({
        key: id
      }, options, {
        message: message,
        open: true,
        entered: false,
        requestClose: false,
        variant: merger('variant'),
        anchorOrigin: merger('anchorOrigin'),
        autoHideDuration: merger('autoHideDuration')
      });

      if (options.persist) {
        snack.autoHideDuration = undefined;
      }

      _this.setState(function (state) {
        if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
          var compareFunction = function compareFunction(item) {
            return hasSpecifiedKey ? item.key === key : item.message === message;
          };

          var inQueue = state.queue.findIndex(compareFunction) > -1;
          var inView = state.snacks.findIndex(compareFunction) > -1;

          if (inQueue || inView) {
            return state;
          }
        }

        return _this.handleDisplaySnack(_extends({}, state, {
          queue: [].concat(state.queue, [snack])
        }));
      });

      return id;
    };
    /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */


    _this.handleDisplaySnack = function (state) {
      var snacks = state.snacks;

      if (snacks.length >= _this.maxSnack) {
        return _this.handleDismissOldest(state);
      }

      return _this.processQueue(state);
    };
    /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */


    _this.processQueue = function (state) {
      var queue = state.queue,
          snacks = state.snacks;

      if (queue.length > 0) {
        return _extends({}, state, {
          snacks: [].concat(snacks, [queue[0]]),
          queue: queue.slice(1, queue.length)
        });
      }

      return state;
    };
    /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */


    _this.handleDismissOldest = function (state) {
      if (state.snacks.some(function (item) {
        return !item.open || item.requestClose;
      })) {
        return state;
      }

      var popped = false;
      var ignore = false;
      var persistentCount = state.snacks.reduce(function (acc, current) {
        return acc + (current.open && current.persist ? 1 : 0);
      }, 0);

      if (persistentCount === _this.maxSnack) {
        process.env.NODE_ENV !== "production" ? warning(MESSAGES.NO_PERSIST_ALL) : void 0;
        ignore = true;
      }

      var snacks = state.snacks.map(function (item) {
        if (!popped && (!item.persist || ignore)) {
          popped = true;

          if (!item.entered) {
            return _extends({}, item, {
              requestClose: true
            });
          }

          if (item.onClose) item.onClose(null, REASONS.MAXSNACK, item.key);
          if (_this.props.onClose) _this.props.onClose(null, REASONS.MAXSNACK, item.key);
          return _extends({}, item, {
            open: false
          });
        }

        return _extends({}, item);
      });
      return _extends({}, state, {
        snacks: snacks
      });
    };
    /**
     * Set the entered state of the snackbar with the given key.
     */


    _this.handleEnteredSnack = function (node, isAppearing, key) {
      if (!isDefined(key)) {
        throw new Error('handleEnteredSnack Cannot be called with undefined key');
      }

      _this.setState(function (_ref) {
        var snacks = _ref.snacks;
        return {
          snacks: snacks.map(function (item) {
            return item.key === key ? _extends({}, item, {
              entered: true
            }) : _extends({}, item);
          })
        };
      });
    };
    /**
     * Hide a snackbar after its timeout.
     */


    _this.handleCloseSnack = function (event, reason, key) {
      // should not use createChainedFunction for onClose.
      // because this.closeSnackbar called this function
      if (_this.props.onClose) {
        _this.props.onClose(event, reason, key);
      }

      if (reason === REASONS.CLICKAWAY) return;
      var shouldCloseAll = key === undefined;

      _this.setState(function (_ref2) {
        var snacks = _ref2.snacks,
            queue = _ref2.queue;
        return {
          snacks: snacks.map(function (item) {
            if (!shouldCloseAll && item.key !== key) {
              return _extends({}, item);
            }

            return item.entered ? _extends({}, item, {
              open: false
            }) : _extends({}, item, {
              requestClose: true
            });
          }),
          queue: queue.filter(function (item) {
            return item.key !== key;
          })
        };
      });
    };
    /**
     * Close snackbar with the given key
     */


    _this.closeSnackbar = function (key) {
      // call individual snackbar onClose callback passed through options parameter
      var toBeClosed = _this.state.snacks.find(function (item) {
        return item.key === key;
      });

      if (isDefined(key) && toBeClosed && toBeClosed.onClose) {
        toBeClosed.onClose(null, REASONS.INSTRUCTED, key);
      }

      _this.handleCloseSnack(null, REASONS.INSTRUCTED, key);
    };
    /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */
    // @ts-ignore


    _this.handleExitedSnack = function (event, key1, key2) {
      var key = key1 || key2;

      if (!isDefined(key)) {
        throw new Error('handleExitedSnack Cannot be called with undefined key');
      }

      _this.setState(function (state) {
        var newState = _this.processQueue(_extends({}, state, {
          snacks: state.snacks.filter(function (item) {
            return item.key !== key;
          })
        }));

        if (newState.queue.length === 0) {
          return newState;
        }

        return _this.handleDismissOldest(newState);
      });
    };

    _this.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: _this.enqueueSnackbar.bind(_assertThisInitialized(_this)),
        closeSnackbar: _this.closeSnackbar.bind(_assertThisInitialized(_this))
      }
    };
    return _this;
  }

  var _proto = SnackbarProvider.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var contextValue = this.state.contextValue;

    var _this$props = this.props,
        iconVariant = _this$props.iconVariant,
        _this$props$dense = _this$props.dense,
        dense = _this$props$dense === void 0 ? DEFAULTS.dense : _this$props$dense,
        _this$props$hideIconV = _this$props.hideIconVariant,
        hideIconVariant = _this$props$hideIconV === void 0 ? DEFAULTS.hideIconVariant : _this$props$hideIconV,
        domRoot = _this$props.domRoot,
        children = _this$props.children,
        _this$props$classes = _this$props.classes,
        classes = _this$props$classes === void 0 ? {} : _this$props$classes,
        props = _objectWithoutPropertiesLoose(_this$props, ["maxSnack", "preventDuplicate", "variant", "anchorOrigin", "iconVariant", "dense", "hideIconVariant", "domRoot", "children", "classes"]);

    var categ = this.state.snacks.reduce(function (acc, current) {
      var _extends2;

      var category = originKeyExtractor(current.anchorOrigin);
      var existingOfCategory = acc[category] || [];
      return _extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [current]), _extends2));
    }, {});
    var snackbars = Object.keys(categ).map(function (origin) {
      var snacks = categ[origin];
      return React__default.createElement(SnackbarContainer$1, {
        key: origin,
        dense: dense,
        anchorOrigin: snacks[0].anchorOrigin,
        className: clsx(classes.containerRoot, classes[transformer.toContainerAnchorOrigin(origin)])
      }, snacks.map(function (snack) {
        return React__default.createElement(SnackbarItem, Object.assign({}, props, {
          key: snack.key,
          snack: snack,
          dense: dense,
          iconVariant: iconVariant,
          hideIconVariant: hideIconVariant,
          classes: omitContainerKeys(classes),
          onClose: _this2.handleCloseSnack,
          onExited: createChainedFunction([_this2.handleExitedSnack, _this2.props.onExited]),
          onEntered: createChainedFunction([_this2.handleEnteredSnack, _this2.props.onEntered])
        }));
      }));
    });
    return React__default.createElement(SnackbarContext.Provider, {
      value: contextValue
    }, children, domRoot ? createPortal(snackbars, domRoot) : snackbars);
  };

  _createClass(SnackbarProvider, [{
    key: "maxSnack",
    get: function get() {
      return this.props.maxSnack || DEFAULTS.maxSnack;
    }
  }]);

  return SnackbarProvider;
}(Component);

var useSnackbar$1 = (function () {
  return useContext(SnackbarContext);
});

var useStyles$4 = makeStyles()(function (theme) { return ({
    icon: {
        padding: theme.spacing(0.5, 1, 0, 0)
    }
}); });

var SnackbarVariant;
(function (SnackbarVariant) {
    SnackbarVariant["Error"] = "error";
    SnackbarVariant["Info"] = "info";
    SnackbarVariant["Success"] = "success";
    SnackbarVariant["Warning"] = "warning";
    SnackbarVariant["Default"] = "default";
})(SnackbarVariant || (SnackbarVariant = {}));
var useSnackbar = useSnackbar$1;
var SnackbarProvider = function (props) {
    var children = props.children, _a = props.preventDuplicate, preventDuplicate = _a === void 0 ? true : _a, _b = props.dense, dense = _b === void 0 ? false : _b, maxSnack = props.maxSnack;
    var classes = useStyles$4().classes;
    return (jsx$1(SnackbarProvider$1, __assign$3({ maxSnack: maxSnack, preventDuplicate: preventDuplicate, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        }, iconVariant: {
            error: (jsx$1("div", __assign$3({ className: classes.icon }, { children: jsx$1(Icon, { name: IconName.InfoOutlinedIcon, size: IconSize$1.Medium, iconColor: IconColor$1.White }) })))
        }, dense: dense }, { children: children })));
};

var useStyles$3 = makeStyles()(function (theme) { return ({
    outlinedChipStyle: {
        borderRadius: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        borderColor: theme.palette.grey[200],
        fontSize: theme.spacing(2)
    }
}); });

var Chip = function (props) {
    var label = props.label, style = props.style, className = props.className, onDelete = props.onDelete;
    var _a = useStyles$3(), classes = _a.classes, classNames = _a.cx;
    return (jsx$1(MuiChip, { variant: "outlined", style: style, label: label, className: classNames(classes.outlinedChipStyle, className), onDelete: onDelete }));
};

var muiCache = createCache({
    key: 'mui-cache',
    prepend: true
});
var ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.direction, direction = _b === void 0 ? 'ltr' : _b;
    theme.direction = direction;
    return (jsx$1("div", __assign$3({ dir: direction }, { children: jsx$1(CacheProvider, __assign$3({ value: muiCache }, { children: jsx$1(ThemeProvider$1, __assign$3({ theme: theme }, { children: children })) })) })));
};

var useStyles$2 = makeStyles()({
    root: {
        '&.MuiChip-root': {
            marginLeft: theme.spacing(2),
            backgroundColor: additionalPalette.liveBlue.main,
            borderRadius: theme.spacing(0.25),
            color: additionalPalette.lightBlue.main,
            borderColor: additionalPalette.transparent
        }
    }
});

var ETABadge = function (props) {
    var percentage = props.percentage, style = props.style, className = props.className;
    var _a = useStyles$2(), classes = _a.classes, classNames = _a.cx;
    var parsePercentage = parseFloat(percentage.toString()) * 100;
    var label = '';
    if (parsePercentage >= 90 && parsePercentage < 95) {
        label = 'ETA < 8 hours';
    }
    else if (parsePercentage >= 95 && parsePercentage < 97) {
        label = 'ETA < 5 hours';
    }
    else if (parsePercentage >= 97 && parsePercentage < 100) {
        label = 'ETA < 3 hours';
    }
    return label ? (jsx$1(MuiChip, { className: classNames(classes.root, className), style: style, label: label })) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    jsx$1(Fragment$1, {}));
};

var ExclusiveButton = function (_a) {
    var onExclusiveIconClick = _a.onExclusiveIconClick;
    var _b = useState(null), exclusiveAnchorEl = _b[0], setExclusiveAnchorEl = _b[1];
    var handleOpenExclusiveMenu = function (event) {
        setExclusiveAnchorEl(event.currentTarget);
        return false;
    };
    var handleCloseExclusiveMenu = function () {
        setExclusiveAnchorEl(null);
        return false;
    };
    var handleDisableExclusive = function () {
        setExclusiveAnchorEl(null);
        onExclusiveIconClick === null || onExclusiveIconClick === void 0 ? void 0 : onExclusiveIconClick();
    };
    return (jsx$1(Tooltip$1, __assign$3({ title: "Exclusive response", tipPlacement: TipPlacement.Top }, { children: jsxs(Fragment$1, { children: [jsx$1(IconButton, { smallHoverShadowSize: true, iconSize: IconSize$1.Large, iconName: IconName.Filter1Outlined, iconColor: IconColor$1.Green, onClick: handleOpenExclusiveMenu }), jsx$1(MuiMenu, __assign$3({ elevation: 1, anchorEl: exclusiveAnchorEl, open: Boolean(exclusiveAnchorEl), onClose: handleCloseExclusiveMenu, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    } }, { children: jsx$1(MuiMenuItem, __assign$3({ onClick: handleDisableExclusive }, { children: jsx$1(Text$1, __assign$3({ size: TextSize.ms, highlight: TextHighlight.Background }, { children: "Make non-exclusive" })) })) }))] }) })));
};

var useStyles$1 = makeStyles()(function (theme) { return ({
    routing: {
        width: 30,
        color: theme.palette.success.main
    },
    routingEntryNumber: {
        marginBottom: "-".concat(theme.spacing(1.75))
    },
    iconButton: {
        padding: theme.spacing(0.5)
    }
}); });

var RoutingButton = function (props) {
    var routingBadgeDisplayString = props.routingBadgeDisplayString, isRoutingDisabled = props.isRoutingDisabled, ariaLabel = props.ariaLabel, onRoutingMenuClick = props.onRoutingMenuClick;
    var classes = useStyles$1().classes;
    var routingIconColor = routingBadgeDisplayString
        ? IconColor$1.Enabled
        : IconColor$1.Background;
    var iconColor = isRoutingDisabled ? IconColor$1.Disabled : routingIconColor;
    return (jsxs(Grid$2, __assign$3({ container: true, className: classes.routing, justifyContent: "center", alignItems: "flex-start" }, { children: [routingBadgeDisplayString && (jsx$1(Text$1, __assign$3({ size: TextSize.s, highlight: TextHighlight.Inherit, weight: TextWeight.SemiBold, className: classes.routingEntryNumber }, { children: routingBadgeDisplayString }))), jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " routing"), iconName: IconName.TimelineOutlined, iconColor: iconColor, onClick: onRoutingMenuClick, iconSize: IconSize$1.Large, className: classes.iconButton, disabled: isRoutingDisabled })] })));
};

var useStyles = makeStyles()(function (theme) { return ({
    iconButton: {
        padding: theme.spacing(0.5)
    }
}); });

var TextEntryButton = function (props) {
    var ariaLabel = props.ariaLabel, onDisableTextEntry = props.onDisableTextEntry;
    var classes = useStyles().classes;
    var _a = React__default.useState(null), textEntryAnchorEl = _a[0], setTextEntryAnchorEl = _a[1];
    var handleOpenTextEntryMenu = function (event) {
        setTextEntryAnchorEl(event.currentTarget);
        return false;
    };
    var handleCloseTextEntryMenu = function () {
        setTextEntryAnchorEl(null);
        return false;
    };
    var handleDisableTextEntry = function () {
        setTextEntryAnchorEl(null);
        onDisableTextEntry === null || onDisableTextEntry === void 0 ? void 0 : onDisableTextEntry();
    };
    return (jsx$1(Tooltip$1, __assign$3({ title: "Text entry", tipPlacement: TipPlacement.Top }, { children: jsxs(Fragment$1, { children: [jsx$1(IconButton, { ariaLabel: "".concat(ariaLabel, " text entry"), iconName: IconName.TextFields, onClick: handleOpenTextEntryMenu, iconSize: IconSize$1.Large, className: classes.iconButton, iconColor: IconColor$1.Enabled }), jsx$1(MuiMenu, __assign$3({ elevation: 1, anchorEl: textEntryAnchorEl, open: Boolean(textEntryAnchorEl), onClose: handleCloseTextEntryMenu, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    } }, { children: jsx$1(MuiMenuItem, __assign$3({ onClick: handleDisableTextEntry }, { children: jsx$1(Text$1, __assign$3({ size: TextSize.ms, highlight: TextHighlight.Background }, { children: "Disable text entry" })) })) }))] }) })));
};

var featureTogglesProd = {
	
};

var featureTogglesDev = {
	
};

var _a;
var Environment;
(function (Environment) {
    Environment["development"] = "development";
    Environment["production"] = "production";
})(Environment || (Environment = {}));
var featureTogglesByEnv = (_a = {},
    _a[Environment.production] = featureTogglesProd,
    _a[Environment.development] = featureTogglesDev,
    _a);
var FeatureToggles = /** @class */ (function () {
    function FeatureToggles(env) {
        this.featureToggles = featureTogglesByEnv[env] || {};
    }
    FeatureToggles.prototype.getConfig = function () {
        return this.featureToggles;
    };
    FeatureToggles.prototype.isOn = function (featureName) {
        return this.featureToggles[featureName];
    };
    return FeatureToggles;
}());

export { Accordion, AccordionVariant, AlignInputText, AudienceType, Badge, BadgeAudience, BadgeColor, BarChart, BottomNav, Box, BreadcrumbLink, BreadcrumbLinkVariant, Breadcrumbs, Button$1 as Button, ButtonSize, ButtonType, ButtonVariant, Checkbox, CheckboxGroup, Chip, CircularProgress, CreatePassword, DateInput, Dialog, DialogMaxWidth, DialogVariant, Divider, Drawer, DynamicError, ETABadge, EditorInput, EmptyState, Environment, ErrorPage, ExclusiveButton, FabButton, Fade, FeatureToggles, Filter$2 as Filter, FilterButton, FilterButtonVariant, ForgotPassowrd as ForgotPassword, ForgotPasswordSucessful as ForgotPasswordSuccessful, FreeText, Grid, GroupedChart, Header, HiddenLayout, Highlight, Icon, IconButton, IconColor$1 as IconColor, IconName, IconSize$1 as IconSize, Increment, InfoIcon$1 as InfoIcon, IconColor as InfoIconColor, InfoPanel, InfoPanelIconVariant, InfoPanelItem, InfoPanelVariant, Input$6 as Input, InputFontSize, InputType, InputVariant, InputWeight, IntervalInput, KebabMenu, KebabMenuIconPosition, KebabMenuItem, LayoutVisibility, LinkButton, List, ListItemAudienceResponseOption$1 as ListItemAudienceResponseOption, ListItemProject, ListItemProjectLoading, ListItemQuestionnaireResponseOption$1 as ListItemQuestionnaireResponseOption, ListItemQuota, ListItemResponseOption, ListItemSidebar, LoadingBar, LoadingBarColor, Login, Matrix, MeanChart, Media, ImageUploader as MediaUploader, Menu, MenuItem, MenuVariant, MuiMenu, MuiMenuItem, MultiEmaiInput, MultipleChoice, Paper, PaperGroupItem, PasswordInput, PercentageInput, Progress, QuestionsDialogDialog as QuestionsDialog, Radio, Ranked, RoutingButton, RoutingMenu, ScrollElement, ScrollLink, ScrollTo, ScrollToBottom, SearchBarInput, SearchBarVariant, Select, SelectIconColor, SelectMenuItem, SelectVariant, Signup, SignupSuccessful, SingleChoice, Skeleton, Slider, SnackbarProvider, SnackbarVariant, Spinner, SpinnerButton, SpinnerColor, SpinnerDialog, SpinnerSize, StackedBarChart, Status, StatusBadge, Subheader, Switch, Text$1 as Text, TextAlign, TextDisplay, TextEntryButton, TextEntryState, TextHighlight, TextInstructions, TextSize, TextWeight, ThemeProvider, TipPlacement, Tooltip$1 as Tooltip, TooltipPlacement, Variant, WordCloudChart, additionalPalette, makeStyles, text as textStyleUtils, theme, useSnackbar };
//# sourceMappingURL=index.es.js.map
